(function(){"use strict";try{if(typeof document<"u"){var i=document.createElement("style");i.appendChild(document.createTextNode('.IncodeCaptureSelfieContainer .OT_publisher{display:block}@font-face{font-family:swiper-icons;src:url(data:application/font-woff;charset=utf-8;base64,\\ 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);font-weight:400;font-style:normal}:root{--swiper-theme-color:#007aff}.swiper,swiper-container{margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1;display:block}.swiper-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;transition-timing-function:var(--swiper-wrapper-transition-timing-function,initial);box-sizing:content-box}.swiper-android .swiper-slide,.swiper-wrapper{transform:translateZ(0)}.swiper-horizontal{touch-action:pan-y}.swiper-vertical{touch-action:pan-x}.swiper-slide,swiper-slide{flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform;display:block}.swiper-slide-invisible-blank{visibility:hidden}.swiper-autoheight,.swiper-autoheight .swiper-slide{height:auto}.swiper-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-backface-hidden .swiper-slide{transform:translateZ(0);-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-3d.swiper-css-mode .swiper-wrapper{perspective:1200px}.swiper-3d .swiper-wrapper{transform-style:preserve-3d}.swiper-3d{perspective:1200px}.swiper-3d .swiper-cube-shadow,.swiper-3d .swiper-slide,.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-bottom,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top{transform-style:preserve-3d}.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-bottom,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}.swiper-3d .swiper-slide-shadow{background:#00000026}.swiper-3d .swiper-slide-shadow-left{background-image:linear-gradient(to left,#00000080,#0000)}.swiper-3d .swiper-slide-shadow-right{background-image:linear-gradient(to right,#00000080,#0000)}.swiper-3d .swiper-slide-shadow-top{background-image:linear-gradient(to top,#00000080,#0000)}.swiper-3d .swiper-slide-shadow-bottom{background-image:linear-gradient(to bottom,#00000080,#0000)}.swiper-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-css-mode>.swiper-wrapper>.swiper-slide{scroll-snap-align:start start}.swiper-horizontal.swiper-css-mode>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-vertical.swiper-css-mode>.swiper-wrapper{scroll-snap-type:y mandatory}.swiper-css-mode.swiper-free-mode>.swiper-wrapper{scroll-snap-type:none}.swiper-css-mode.swiper-free-mode>.swiper-wrapper>.swiper-slide{scroll-snap-align:none}.swiper-centered>.swiper-wrapper:before{content:"";flex-shrink:0;order:9999}.swiper-centered>.swiper-wrapper>.swiper-slide{scroll-snap-align:center center;scroll-snap-stop:always}.swiper-centered.swiper-horizontal>.swiper-wrapper>.swiper-slide:first-child{margin-inline-start:var(--swiper-centered-offset-before)}.swiper-centered.swiper-horizontal>.swiper-wrapper:before{height:100%;min-height:1px;width:var(--swiper-centered-offset-after)}.swiper-centered.swiper-vertical>.swiper-wrapper>.swiper-slide:first-child{margin-block-start:var(--swiper-centered-offset-before)}.swiper-centered.swiper-vertical>.swiper-wrapper:before{width:100%;min-width:1px;height:var(--swiper-centered-offset-after)}.swiper-lazy-preloader{width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;transform-origin:50%;box-sizing:border-box;border:4px solid var(--swiper-preloader-color,var(--swiper-theme-color));border-radius:50%;border-top-color:transparent}.swiper-watch-progress .swiper-slide-visible .swiper-lazy-preloader,.swiper:not(.swiper-watch-progress) .swiper-lazy-preloader,swiper-container:not(.swiper-watch-progress) .swiper-lazy-preloader{animation:swiper-preloader-spin 1s infinite linear}.swiper-lazy-preloader-white{--swiper-preloader-color:#fff}.swiper-lazy-preloader-black{--swiper-preloader-color:#000}@keyframes swiper-preloader-spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translateZ(0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-pagination-disabled>.swiper-pagination,.swiper-pagination.swiper-pagination-disabled{display:none!important}.swiper-horizontal>.swiper-pagination-bullets,.swiper-pagination-bullets.swiper-pagination-horizontal,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:var(--swiper-pagination-bottom,8px);top:var(--swiper-pagination-top,auto);left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active,.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{width:var(--swiper-pagination-bullet-width,var(--swiper-pagination-bullet-size,8px));height:var(--swiper-pagination-bullet-height,var(--swiper-pagination-bullet-size,8px));display:inline-block;border-radius:var(--swiper-pagination-bullet-border-radius,50%);background:var(--swiper-pagination-bullet-inactive-color,#000);opacity:var(--swiper-pagination-bullet-inactive-opacity, .2)}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;-moz-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none!important}.swiper-pagination-bullet-active{opacity:var(--swiper-pagination-bullet-opacity, 1);background:var(--swiper-pagination-color,var(--swiper-theme-color))}.swiper-pagination-vertical.swiper-pagination-bullets,.swiper-vertical>.swiper-pagination-bullets{right:var(--swiper-pagination-right,8px);left:var(--swiper-pagination-left,auto);top:50%;transform:translate3d(0,-50%,0)}.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:var(--swiper-pagination-bullet-vertical-gap,6px) 0;display:block}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 var(--swiper-pagination-bullet-horizontal-gap,4px)}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translate(-50%);white-space:nowrap}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.swiper-horizontal.swiper-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,:host(.swiper-horizontal.swiper-rtl) .swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.swiper-pagination-fraction{color:var(--swiper-pagination-fraction-color,inherit)}.swiper-pagination-progressbar{background:var(--swiper-pagination-progressbar-bg-color,rgba(0,0,0,.25));position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color,var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-horizontal>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-horizontal,.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite,.swiper-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:var(--swiper-pagination-progressbar-size,4px);left:0;top:0}.swiper-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-vertical,.swiper-vertical>.swiper-pagination-progressbar{width:var(--swiper-pagination-progressbar-size,4px);height:100%;left:0;top:0}.swiper-pagination-lock{display:none}.document-selector{height:100%}')),document.head.appendChild(i)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
var i6 = Object.defineProperty;
var UA = (me) => {
  throw TypeError(me);
};
var a6 = (me, ue, Qe) => ue in me ? i6(me, ue, { enumerable: !0, configurable: !0, writable: !0, value: Qe }) : me[ue] = Qe;
var $n = (me, ue, Qe) => a6(me, typeof ue != "symbol" ? ue + "" : ue, Qe), Ih = (me, ue, Qe) => ue.has(me) || UA("Cannot " + Qe);
var xt = (me, ue, Qe) => (Ih(me, ue, "read from private field"), Qe ? Qe.call(me) : ue.get(me)), tn = (me, ue, Qe) => ue.has(me) ? UA("Cannot add the same private member more than once") : ue instanceof WeakSet ? ue.add(me) : ue.set(me, Qe), Zt = (me, ue, Qe, Ue) => (Ih(me, ue, "write to private field"), Ue ? Ue.call(me, Qe) : ue.set(me, Qe), Qe), en = (me, ue, Qe) => (Ih(me, ue, "access private method"), Qe);
var Xi = (me, ue, Qe, Ue) => ({
  set _(He) {
    Zt(me, ue, He, Qe);
  },
  get _() {
    return xt(me, ue, Ue);
  }
});
import * as React from "react";
import React__default, { useRef, useEffect, useState, useMemo, useCallback, useLayoutEffect, createContext, useContext, createElement as createElement$2, isValidElement, cloneElement, forwardRef, Children, useReducer, useImperativeHandle, Fragment, Component } from "react";
import * as ReactDOM from "react-dom";
import ReactDOM__default, { createPortal } from "react-dom";
function _mergeNamespaces(me, ue) {
  for (var Qe = 0; Qe < ue.length; Qe++) {
    const Ue = ue[Qe];
    if (typeof Ue != "string" && !Array.isArray(Ue)) {
      for (const He in Ue)
        if (He !== "default" && !(He in me)) {
          const Ge = Object.getOwnPropertyDescriptor(Ue, He);
          Ge && Object.defineProperty(me, He, Ge.get ? Ge : {
            enumerable: !0,
            get: () => Ue[He]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(me, Symbol.toStringTag, { value: "Module" }));
}
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(me) {
  return me && me.__esModule && Object.prototype.hasOwnProperty.call(me, "default") ? me.default : me;
}
function getAugmentedNamespace(me) {
  if (me.__esModule) return me;
  var ue = me.default;
  if (typeof ue == "function") {
    var Qe = function Ue() {
      return this instanceof Ue ? Reflect.construct(ue, arguments, this.constructor) : ue.apply(this, arguments);
    };
    Qe.prototype = ue.prototype;
  } else Qe = {};
  return Object.defineProperty(Qe, "__esModule", { value: !0 }), Object.keys(me).forEach(function(Ue) {
    var He = Object.getOwnPropertyDescriptor(me, Ue);
    Object.defineProperty(Qe, Ue, He.get ? He : {
      enumerable: !0,
      get: function() {
        return me[Ue];
      }
    });
  }), Qe;
}
var dayjs_min = { exports: {} };
(function(me, ue) {
  (function(Qe, Ue) {
    me.exports = Ue();
  })(commonjsGlobal, function() {
    var Qe = 1e3, Ue = 6e4, He = 36e5, Ge = "millisecond", Xe = "second", Ke = "minute", $e = "hour", Je = "day", Ze = "week", nt = "month", tt = "quarter", et = "year", rt = "date", it = "Invalid Date", ot = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, at = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, st = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(ht) {
      var It = ["th", "st", "nd", "rd"], vt = ht % 100;
      return "[" + ht + (It[(vt - 20) % 10] || It[vt] || It[0]) + "]";
    } }, ut = function(ht, It, vt) {
      var Et = String(ht);
      return !Et || Et.length >= It ? ht : "" + Array(It + 1 - Et.length).join(vt) + ht;
    }, lt = { s: ut, z: function(ht) {
      var It = -ht.utcOffset(), vt = Math.abs(It), Et = Math.floor(vt / 60), bt = vt % 60;
      return (It <= 0 ? "+" : "-") + ut(Et, 2, "0") + ":" + ut(bt, 2, "0");
    }, m: function ht(It, vt) {
      if (It.date() < vt.date()) return -ht(vt, It);
      var Et = 12 * (vt.year() - It.year()) + (vt.month() - It.month()), bt = It.clone().add(Et, nt), Rt = vt - bt < 0, St = It.clone().add(Et + (Rt ? -1 : 1), nt);
      return +(-(Et + (vt - bt) / (Rt ? bt - St : St - bt)) || 0);
    }, a: function(ht) {
      return ht < 0 ? Math.ceil(ht) || 0 : Math.floor(ht);
    }, p: function(ht) {
      return { M: nt, y: et, w: Ze, d: Je, D: rt, h: $e, m: Ke, s: Xe, ms: Ge, Q: tt }[ht] || String(ht || "").toLowerCase().replace(/s$/, "");
    }, u: function(ht) {
      return ht === void 0;
    } }, dt = "en", At = {};
    At[dt] = st;
    var pt = "$isDayjsObject", gt = function(ht) {
      return ht instanceof yt || !(!ht || !ht[pt]);
    }, wt = function ht(It, vt, Et) {
      var bt;
      if (!It) return dt;
      if (typeof It == "string") {
        var Rt = It.toLowerCase();
        At[Rt] && (bt = Rt), vt && (At[Rt] = vt, bt = Rt);
        var St = It.split("-");
        if (!bt && St.length > 1) return ht(St[0]);
      } else {
        var kt = It.name;
        At[kt] = It, bt = kt;
      }
      return !Et && bt && (dt = bt), bt || !Et && dt;
    }, Bt = function(ht, It) {
      if (gt(ht)) return ht.clone();
      var vt = typeof It == "object" ? It : {};
      return vt.date = ht, vt.args = arguments, new yt(vt);
    }, Tt = lt;
    Tt.l = wt, Tt.i = gt, Tt.w = function(ht, It) {
      return Bt(ht, { locale: It.$L, utc: It.$u, x: It.$x, $offset: It.$offset });
    };
    var yt = function() {
      function ht(vt) {
        this.$L = wt(vt.locale, null, !0), this.parse(vt), this.$x = this.$x || vt.x || {}, this[pt] = !0;
      }
      var It = ht.prototype;
      return It.parse = function(vt) {
        this.$d = function(Et) {
          var bt = Et.date, Rt = Et.utc;
          if (bt === null) return /* @__PURE__ */ new Date(NaN);
          if (Tt.u(bt)) return /* @__PURE__ */ new Date();
          if (bt instanceof Date) return new Date(bt);
          if (typeof bt == "string" && !/Z$/i.test(bt)) {
            var St = bt.match(ot);
            if (St) {
              var kt = St[2] - 1 || 0, jt = (St[7] || "0").substring(0, 3);
              return Rt ? new Date(Date.UTC(St[1], kt, St[3] || 1, St[4] || 0, St[5] || 0, St[6] || 0, jt)) : new Date(St[1], kt, St[3] || 1, St[4] || 0, St[5] || 0, St[6] || 0, jt);
            }
          }
          return new Date(bt);
        }(vt), this.init();
      }, It.init = function() {
        var vt = this.$d;
        this.$y = vt.getFullYear(), this.$M = vt.getMonth(), this.$D = vt.getDate(), this.$W = vt.getDay(), this.$H = vt.getHours(), this.$m = vt.getMinutes(), this.$s = vt.getSeconds(), this.$ms = vt.getMilliseconds();
      }, It.$utils = function() {
        return Tt;
      }, It.isValid = function() {
        return this.$d.toString() !== it;
      }, It.isSame = function(vt, Et) {
        var bt = Bt(vt);
        return this.startOf(Et) <= bt && bt <= this.endOf(Et);
      }, It.isAfter = function(vt, Et) {
        return Bt(vt) < this.startOf(Et);
      }, It.isBefore = function(vt, Et) {
        return this.endOf(Et) < Bt(vt);
      }, It.$g = function(vt, Et, bt) {
        return Tt.u(vt) ? this[Et] : this.set(bt, vt);
      }, It.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, It.valueOf = function() {
        return this.$d.getTime();
      }, It.startOf = function(vt, Et) {
        var bt = this, Rt = !!Tt.u(Et) || Et, St = Tt.p(vt), kt = function(Ut, Lt) {
          var Ot = Tt.w(bt.$u ? Date.UTC(bt.$y, Lt, Ut) : new Date(bt.$y, Lt, Ut), bt);
          return Rt ? Ot : Ot.endOf(Je);
        }, jt = function(Ut, Lt) {
          return Tt.w(bt.toDate()[Ut].apply(bt.toDate("s"), (Rt ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Lt)), bt);
        }, Pt = this.$W, Qt = this.$M, qt = this.$D, _t = "set" + (this.$u ? "UTC" : "");
        switch (St) {
          case et:
            return Rt ? kt(1, 0) : kt(31, 11);
          case nt:
            return Rt ? kt(1, Qt) : kt(0, Qt + 1);
          case Ze:
            var Yt = this.$locale().weekStart || 0, Xt = (Pt < Yt ? Pt + 7 : Pt) - Yt;
            return kt(Rt ? qt - Xt : qt + (6 - Xt), Qt);
          case Je:
          case rt:
            return jt(_t + "Hours", 0);
          case $e:
            return jt(_t + "Minutes", 1);
          case Ke:
            return jt(_t + "Seconds", 2);
          case Xe:
            return jt(_t + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, It.endOf = function(vt) {
        return this.startOf(vt, !1);
      }, It.$set = function(vt, Et) {
        var bt, Rt = Tt.p(vt), St = "set" + (this.$u ? "UTC" : ""), kt = (bt = {}, bt[Je] = St + "Date", bt[rt] = St + "Date", bt[nt] = St + "Month", bt[et] = St + "FullYear", bt[$e] = St + "Hours", bt[Ke] = St + "Minutes", bt[Xe] = St + "Seconds", bt[Ge] = St + "Milliseconds", bt)[Rt], jt = Rt === Je ? this.$D + (Et - this.$W) : Et;
        if (Rt === nt || Rt === et) {
          var Pt = this.clone().set(rt, 1);
          Pt.$d[kt](jt), Pt.init(), this.$d = Pt.set(rt, Math.min(this.$D, Pt.daysInMonth())).$d;
        } else kt && this.$d[kt](jt);
        return this.init(), this;
      }, It.set = function(vt, Et) {
        return this.clone().$set(vt, Et);
      }, It.get = function(vt) {
        return this[Tt.p(vt)]();
      }, It.add = function(vt, Et) {
        var bt, Rt = this;
        vt = Number(vt);
        var St = Tt.p(Et), kt = function(Qt) {
          var qt = Bt(Rt);
          return Tt.w(qt.date(qt.date() + Math.round(Qt * vt)), Rt);
        };
        if (St === nt) return this.set(nt, this.$M + vt);
        if (St === et) return this.set(et, this.$y + vt);
        if (St === Je) return kt(1);
        if (St === Ze) return kt(7);
        var jt = (bt = {}, bt[Ke] = Ue, bt[$e] = He, bt[Xe] = Qe, bt)[St] || 1, Pt = this.$d.getTime() + vt * jt;
        return Tt.w(Pt, this);
      }, It.subtract = function(vt, Et) {
        return this.add(-1 * vt, Et);
      }, It.format = function(vt) {
        var Et = this, bt = this.$locale();
        if (!this.isValid()) return bt.invalidDate || it;
        var Rt = vt || "YYYY-MM-DDTHH:mm:ssZ", St = Tt.z(this), kt = this.$H, jt = this.$m, Pt = this.$M, Qt = bt.weekdays, qt = bt.months, _t = bt.meridiem, Yt = function(Lt, Ot, ft, Dt) {
          return Lt && (Lt[Ot] || Lt(Et, Rt)) || ft[Ot].slice(0, Dt);
        }, Xt = function(Lt) {
          return Tt.s(kt % 12 || 12, Lt, "0");
        }, Ut = _t || function(Lt, Ot, ft) {
          var Dt = Lt < 12 ? "AM" : "PM";
          return ft ? Dt.toLowerCase() : Dt;
        };
        return Rt.replace(at, function(Lt, Ot) {
          return Ot || function(ft) {
            switch (ft) {
              case "YY":
                return String(Et.$y).slice(-2);
              case "YYYY":
                return Tt.s(Et.$y, 4, "0");
              case "M":
                return Pt + 1;
              case "MM":
                return Tt.s(Pt + 1, 2, "0");
              case "MMM":
                return Yt(bt.monthsShort, Pt, qt, 3);
              case "MMMM":
                return Yt(qt, Pt);
              case "D":
                return Et.$D;
              case "DD":
                return Tt.s(Et.$D, 2, "0");
              case "d":
                return String(Et.$W);
              case "dd":
                return Yt(bt.weekdaysMin, Et.$W, Qt, 2);
              case "ddd":
                return Yt(bt.weekdaysShort, Et.$W, Qt, 3);
              case "dddd":
                return Qt[Et.$W];
              case "H":
                return String(kt);
              case "HH":
                return Tt.s(kt, 2, "0");
              case "h":
                return Xt(1);
              case "hh":
                return Xt(2);
              case "a":
                return Ut(kt, jt, !0);
              case "A":
                return Ut(kt, jt, !1);
              case "m":
                return String(jt);
              case "mm":
                return Tt.s(jt, 2, "0");
              case "s":
                return String(Et.$s);
              case "ss":
                return Tt.s(Et.$s, 2, "0");
              case "SSS":
                return Tt.s(Et.$ms, 3, "0");
              case "Z":
                return St;
            }
            return null;
          }(Lt) || St.replace(":", "");
        });
      }, It.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, It.diff = function(vt, Et, bt) {
        var Rt, St = this, kt = Tt.p(Et), jt = Bt(vt), Pt = (jt.utcOffset() - this.utcOffset()) * Ue, Qt = this - jt, qt = function() {
          return Tt.m(St, jt);
        };
        switch (kt) {
          case et:
            Rt = qt() / 12;
            break;
          case nt:
            Rt = qt();
            break;
          case tt:
            Rt = qt() / 3;
            break;
          case Ze:
            Rt = (Qt - Pt) / 6048e5;
            break;
          case Je:
            Rt = (Qt - Pt) / 864e5;
            break;
          case $e:
            Rt = Qt / He;
            break;
          case Ke:
            Rt = Qt / Ue;
            break;
          case Xe:
            Rt = Qt / Qe;
            break;
          default:
            Rt = Qt;
        }
        return bt ? Rt : Tt.a(Rt);
      }, It.daysInMonth = function() {
        return this.endOf(nt).$D;
      }, It.$locale = function() {
        return At[this.$L];
      }, It.locale = function(vt, Et) {
        if (!vt) return this.$L;
        var bt = this.clone(), Rt = wt(vt, Et, !0);
        return Rt && (bt.$L = Rt), bt;
      }, It.clone = function() {
        return Tt.w(this.$d, this);
      }, It.toDate = function() {
        return new Date(this.valueOf());
      }, It.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, It.toISOString = function() {
        return this.$d.toISOString();
      }, It.toString = function() {
        return this.$d.toUTCString();
      }, ht;
    }(), Ct = yt.prototype;
    return Bt.prototype = Ct, [["$ms", Ge], ["$s", Xe], ["$m", Ke], ["$H", $e], ["$W", Je], ["$M", nt], ["$y", et], ["$D", rt]].forEach(function(ht) {
      Ct[ht[1]] = function(It) {
        return this.$g(It, ht[0], ht[1]);
      };
    }), Bt.extend = function(ht, It) {
      return ht.$i || (ht(It, yt, Bt), ht.$i = !0), Bt;
    }, Bt.locale = wt, Bt.isDayjs = gt, Bt.unix = function(ht) {
      return Bt(1e3 * ht);
    }, Bt.en = At[dt], Bt.Ls = At, Bt.p = {}, Bt;
  });
})(dayjs_min);
var dayjs_minExports = dayjs_min.exports;
const dayjs = /* @__PURE__ */ getDefaultExportFromCjs(dayjs_minExports);
var utc$1 = { exports: {} };
(function(me, ue) {
  (function(Qe, Ue) {
    me.exports = Ue();
  })(commonjsGlobal, function() {
    var Qe = "minute", Ue = /[+-]\d\d(?::?\d\d)?/g, He = /([+-]|\d\d)/g;
    return function(Ge, Xe, Ke) {
      var $e = Xe.prototype;
      Ke.utc = function(it) {
        var ot = { date: it, utc: !0, args: arguments };
        return new Xe(ot);
      }, $e.utc = function(it) {
        var ot = Ke(this.toDate(), { locale: this.$L, utc: !0 });
        return it ? ot.add(this.utcOffset(), Qe) : ot;
      }, $e.local = function() {
        return Ke(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var Je = $e.parse;
      $e.parse = function(it) {
        it.utc && (this.$u = !0), this.$utils().u(it.$offset) || (this.$offset = it.$offset), Je.call(this, it);
      };
      var Ze = $e.init;
      $e.init = function() {
        if (this.$u) {
          var it = this.$d;
          this.$y = it.getUTCFullYear(), this.$M = it.getUTCMonth(), this.$D = it.getUTCDate(), this.$W = it.getUTCDay(), this.$H = it.getUTCHours(), this.$m = it.getUTCMinutes(), this.$s = it.getUTCSeconds(), this.$ms = it.getUTCMilliseconds();
        } else Ze.call(this);
      };
      var nt = $e.utcOffset;
      $e.utcOffset = function(it, ot) {
        var at = this.$utils().u;
        if (at(it)) return this.$u ? 0 : at(this.$offset) ? nt.call(this) : this.$offset;
        if (typeof it == "string" && (it = function(dt) {
          dt === void 0 && (dt = "");
          var At = dt.match(Ue);
          if (!At) return null;
          var pt = ("" + At[0]).match(He) || ["-", 0, 0], gt = pt[0], wt = 60 * +pt[1] + +pt[2];
          return wt === 0 ? 0 : gt === "+" ? wt : -wt;
        }(it), it === null)) return this;
        var st = Math.abs(it) <= 16 ? 60 * it : it, ut = this;
        if (ot) return ut.$offset = st, ut.$u = it === 0, ut;
        if (it !== 0) {
          var lt = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (ut = this.local().add(st + lt, Qe)).$offset = st, ut.$x.$localOffset = lt;
        } else ut = this.utc();
        return ut;
      };
      var tt = $e.format;
      $e.format = function(it) {
        var ot = it || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return tt.call(this, ot);
      }, $e.valueOf = function() {
        var it = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * it;
      }, $e.isUTC = function() {
        return !!this.$u;
      }, $e.toISOString = function() {
        return this.toDate().toISOString();
      }, $e.toString = function() {
        return this.toDate().toUTCString();
      };
      var et = $e.toDate;
      $e.toDate = function(it) {
        return it === "s" && this.$offset ? Ke(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : et.call(this);
      };
      var rt = $e.diff;
      $e.diff = function(it, ot, at) {
        if (it && this.$u === it.$u) return rt.call(this, it, ot, at);
        var st = this.local(), ut = Ke(it).local();
        return rt.call(st, ut, ot, at);
      };
    };
  });
})(utc$1);
var utcExports = utc$1.exports;
const utc = /* @__PURE__ */ getDefaultExportFromCjs(utcExports);
dayjs.extend(utc);
function isSafari() {
  return window.navigator.vendor && window.navigator.vendor.indexOf("Apple") > -1 && window.navigator.userAgent && window.navigator.userAgent.indexOf("CriOS") === -1 && window.navigator.userAgent.indexOf("FxiOS") === -1;
}
const sleep = (me) => new Promise((ue) => setTimeout(ue, me)), throttle$1 = (me, ue) => {
  let Qe;
  return (...Ue) => {
    Qe || (me.apply(void 0, Ue), Qe = !0, setTimeout(() => Qe = !1, ue));
  };
}, getLogObject = (me, ue) => ({
  type: me,
  payload: ue
}), toImage$1 = (me) => me ? `data:image/png;base64,${me}` : "", resizeImg = function(me, ue) {
  const Qe = document.createElement("canvas");
  Qe.width = me.width <= ue ? me.width : ue, Qe.height = me.width <= ue ? me.height : me.height / (me.width / ue);
  const Ue = Qe.getContext("2d");
  return Ue == null || Ue.drawImage(me, 0, 0, Qe.width, Qe.height), Qe.toDataURL();
}, rotateImg = (me) => {
  const ue = document.createElement("canvas");
  ue.width = me.width, ue.height = me.height;
  const Qe = ue.getContext("2d");
  Qe == null || Qe.drawImage(me, 0, 0);
  const Ue = ue.width;
  return ue.width = ue.height, ue.height = Ue, Qe == null || Qe.clearRect(0, 0, ue.width, ue.height), Qe == null || Qe.save(), Qe == null || Qe.translate(ue.width / 2, ue.height / 2), Qe == null || Qe.rotate(-90 * Math.PI / 180), Qe == null || Qe.drawImage(me, -me.width / 2, -me.height / 2), Qe == null || Qe.restore(), ue;
}, getBase64 = (me) => new Promise((ue, Qe) => {
  const Ue = new FileReader();
  Ue.onload = function(He) {
    var Xe;
    const Ge = (Xe = He == null ? void 0 : He.target) == null ? void 0 : Xe.result;
    ue(Ge);
  }, Ue.readAsDataURL(me), Ue.onerror = (He) => Qe(He);
}), getScaledBase64 = (me, ue = 1280, Qe = !1) => new Promise((Ue, He) => {
  const Ge = new Image();
  Ge.onload = function() {
    const Xe = Qe && Ge.width > Ge.height ? rotateImg(Ge) : Ge, Ke = resizeImg(Xe, ue);
    URL.revokeObjectURL(Ge.src), Ue(Ke);
  }, Ge.onerror = (Xe) => He(Xe), Ge.src = URL.createObjectURL(me);
}), getScaledImageFromFile = async (me, ue = 1280, Qe = !1) => ({ imageBase64: me.type === "application/pdf" ? await getBase64(me) : await getScaledBase64(me, ue, Qe), fullImage: me });
function emptyFunc(...me) {
}
const reload = () => {
  window.location.reload();
}, INCODE_DOMAINS = {
  SAAS: "saas-api.incodesmile.com",
  STAGE: "incode-stageus-api.stage.incodetest.com",
  DEMO: "demo-api.incodesmile.com",
  STAGEK8S: "user-service-k8s.stage.incodetest.com"
}, allowedDomains = [
  INCODE_DOMAINS.SAAS,
  INCODE_DOMAINS.STAGE,
  INCODE_DOMAINS.DEMO,
  INCODE_DOMAINS.STAGEK8S
], isValidUrl = (me) => {
  try {
    return new URL(me), !0;
  } catch {
    return !1;
  }
}, allowedDomain = (me) => {
  const ue = new URL(me).hostname;
  return {
    isAllowed: allowedDomains.includes(ue),
    domain: ue
  };
}, isSaasEnv = (me) => {
  const { isAllowed: ue, domain: Qe } = allowedDomain(me);
  return isValidUrl(me) && ue && Qe === INCODE_DOMAINS.SAAS;
}, isStageEnv = (me) => {
  const { isAllowed: ue, domain: Qe } = allowedDomain(me);
  return isValidUrl(me) && ue && Qe === INCODE_DOMAINS.STAGE;
}, isDemoEnv = (me) => {
  const { isAllowed: ue, domain: Qe } = allowedDomain(me);
  return isValidUrl(me) && ue && Qe === INCODE_DOMAINS.DEMO;
}, isStageK8sEnv = (me) => {
  const { isAllowed: ue, domain: Qe } = allowedDomain(me);
  return isValidUrl(me) && ue && Qe === INCODE_DOMAINS.STAGEK8S;
}, camelToStartCase = (me) => {
  const ue = me.replace(/([A-Z])/g, " $1");
  return ue.charAt(0).toUpperCase() + ue.slice(1);
}, formatInputDate = (me) => {
  let ue = new Date(me), Qe = "" + (ue.getMonth() + 1), Ue = "" + ue.getDate(), He = ue.getFullYear();
  return Qe.length < 2 && (Qe = "0" + Qe), Ue.length < 2 && (Ue = "0" + Ue), [He, Qe, Ue].join("-");
}, getKioskMaskPosition = () => {
  var Ze;
  const me = (Ze = document.querySelector("video")) == null ? void 0 : Ze.getBoundingClientRect(), ue = me.width, Qe = me.height, Ue = 5.4 / 8.6, He = 0.96, Xe = +ue * 0.6, Ke = +Qe * He, $e = Ke * Ue, Je = $e > Xe ? Xe : $e;
  return {
    width: Je,
    height: Ke,
    left: (+ue - Je) / 2,
    top: (Qe - Ke) / 2
  };
}, getMaskPosition = (me = !1) => {
  const ue = window.innerWidth, Qe = window.innerHeight, Ue = 8.6 / 5.4, He = localStorage.getItem("isIPhone14OrHigher") === "true" ? me ? 0.8 : 0.6 : 0.86, Xe = Qe * 0.9, Ke = ue * He, $e = Ke * Ue, Je = $e > Xe ? Xe : $e;
  return {
    width: Ke,
    height: Je,
    left: (ue - Ke) / 2,
    top: (Qe - Je) / 2
  };
}, getLanguageCodeWithCountry = (me) => me != null && me.startsWith("en") ? "en-US" : me != null && me.startsWith("es") ? "es-ES" : "en-US", b64toBlob = (me, ue = "", Qe = 512) => {
  const Ue = atob(me), He = [];
  for (let Xe = 0; Xe < Ue.length; Xe += Qe) {
    const Ke = Ue.slice(Xe, Xe + Qe), $e = new Array(Ke.length);
    for (let Ze = 0; Ze < Ke.length; Ze++)
      $e[Ze] = Ke.charCodeAt(Ze);
    const Je = new Uint8Array($e);
    He.push(Je);
  }
  return new Blob(He, { type: ue });
}, getScreenRecordingEventCode = (me) => ({
  frontId: "frontIdScanScreenRecordVideoUploaded",
  backId: "backIdScanScreenRecordVideoUploaded",
  selfie: "selfieScanScreenRecordVideoUploaded"
})[me] || "", maskDate = (me) => {
  const ue = me.replace(/\D/g, "").slice(0, 10);
  return ue.length >= 5 ? `${ue.slice(0, 2)}/${ue.slice(2, 4)}/${ue.slice(4).substring(0, 4)}` : ue.length >= 3 ? `${ue.slice(0, 2)}/${ue.slice(2)}` : ue.substring(0, 9);
};
/**
 * React Router v6.21.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
const DataRouterContext = /* @__PURE__ */ React.createContext(null);
process.env.NODE_ENV !== "production" && (DataRouterContext.displayName = "DataRouter");
const DataRouterStateContext = /* @__PURE__ */ React.createContext(null);
process.env.NODE_ENV !== "production" && (DataRouterStateContext.displayName = "DataRouterState");
const AwaitContext = /* @__PURE__ */ React.createContext(null);
process.env.NODE_ENV !== "production" && (AwaitContext.displayName = "Await");
const NavigationContext = /* @__PURE__ */ React.createContext(null);
process.env.NODE_ENV !== "production" && (NavigationContext.displayName = "Navigation");
const LocationContext = /* @__PURE__ */ React.createContext(null);
process.env.NODE_ENV !== "production" && (LocationContext.displayName = "Location");
const RouteContext = /* @__PURE__ */ React.createContext({
  outlet: null,
  matches: [],
  isDataRoute: !1
});
process.env.NODE_ENV !== "production" && (RouteContext.displayName = "Route");
const RouteErrorContext = /* @__PURE__ */ React.createContext(null);
process.env.NODE_ENV !== "production" && (RouteErrorContext.displayName = "RouteError");
function useParams() {
  let {
    matches: me
  } = React.useContext(RouteContext), ue = me[me.length - 1];
  return ue ? ue.params : {};
}
new Promise(() => {
});
var uaParser = { exports: {} };
(function(me, ue) {
  (function(Qe, Ue) {
    var He = "1.0.37", Ge = "", Xe = "?", Ke = "function", $e = "undefined", Je = "object", Ze = "string", nt = "major", tt = "model", et = "name", rt = "type", it = "vendor", ot = "version", at = "architecture", st = "console", ut = "mobile", lt = "tablet", dt = "smarttv", At = "wearable", pt = "embedded", gt = 500, wt = "Amazon", Bt = "Apple", Tt = "ASUS", yt = "BlackBerry", Ct = "Browser", ht = "Chrome", It = "Edge", vt = "Firefox", Et = "Google", bt = "Huawei", Rt = "LG", St = "Microsoft", kt = "Motorola", jt = "Opera", Pt = "Samsung", Qt = "Sharp", qt = "Sony", _t = "Xiaomi", Yt = "Zebra", Xt = "Facebook", Ut = "Chromium OS", Lt = "Mac OS", Ot = function(Jt, an) {
      var cn = {};
      for (var dn in Jt)
        an[dn] && an[dn].length % 2 === 0 ? cn[dn] = an[dn].concat(Jt[dn]) : cn[dn] = Jt[dn];
      return cn;
    }, ft = function(Jt) {
      for (var an = {}, cn = 0; cn < Jt.length; cn++)
        an[Jt[cn].toUpperCase()] = Jt[cn];
      return an;
    }, Dt = function(Jt, an) {
      return typeof Jt === Ze ? Mt(an).indexOf(Mt(Jt)) !== -1 : !1;
    }, Mt = function(Jt) {
      return Jt.toLowerCase();
    }, Ft = function(Jt) {
      return typeof Jt === Ze ? Jt.replace(/[^\d\.]/g, Ge).split(".")[0] : Ue;
    }, Gt = function(Jt, an) {
      if (typeof Jt === Ze)
        return Jt = Jt.replace(/^\s\s*/, Ge), typeof an === $e ? Jt : Jt.substring(0, gt);
    }, zt = function(Jt, an) {
      for (var cn = 0, dn, yn, Nn, Rn, rn, ln; cn < an.length && !rn; ) {
        var pn = an[cn], Sn = an[cn + 1];
        for (dn = yn = 0; dn < pn.length && !rn && pn[dn]; )
          if (rn = pn[dn++].exec(Jt), rn)
            for (Nn = 0; Nn < Sn.length; Nn++)
              ln = rn[++yn], Rn = Sn[Nn], typeof Rn === Je && Rn.length > 0 ? Rn.length === 2 ? typeof Rn[1] == Ke ? this[Rn[0]] = Rn[1].call(this, ln) : this[Rn[0]] = Rn[1] : Rn.length === 3 ? typeof Rn[1] === Ke && !(Rn[1].exec && Rn[1].test) ? this[Rn[0]] = ln ? Rn[1].call(this, ln, Rn[2]) : Ue : this[Rn[0]] = ln ? ln.replace(Rn[1], Rn[2]) : Ue : Rn.length === 4 && (this[Rn[0]] = ln ? Rn[3].call(this, ln.replace(Rn[1], Rn[2])) : Ue) : this[Rn] = ln || Ue;
        cn += 2;
      }
    }, $t = function(Jt, an) {
      for (var cn in an)
        if (typeof an[cn] === Je && an[cn].length > 0) {
          for (var dn = 0; dn < an[cn].length; dn++)
            if (Dt(an[cn][dn], Jt))
              return cn === Xe ? Ue : cn;
        } else if (Dt(an[cn], Jt))
          return cn === Xe ? Ue : cn;
      return Jt;
    }, Ht = {
      "1.0": "/8",
      "1.2": "/1",
      "1.3": "/3",
      "2.0": "/412",
      "2.0.2": "/416",
      "2.0.3": "/417",
      "2.0.4": "/419",
      "?": "/"
    }, hn = {
      ME: "4.90",
      "NT 3.11": "NT3.51",
      "NT 4.0": "NT4.0",
      2e3: "NT 5.0",
      XP: ["NT 5.1", "NT 5.2"],
      Vista: "NT 6.0",
      7: "NT 6.1",
      8: "NT 6.2",
      "8.1": "NT 6.3",
      10: ["NT 6.4", "NT 10.0"],
      RT: "ARM"
    }, un = {
      browser: [
        [
          /\b(?:crmo|crios)\/([\w\.]+)/i
          // Chrome for Android/iOS
        ],
        [ot, [et, "Chrome"]],
        [
          /edg(?:e|ios|a)?\/([\w\.]+)/i
          // Microsoft Edge
        ],
        [ot, [et, "Edge"]],
        [
          // Presto based
          /(opera mini)\/([-\w\.]+)/i,
          // Opera Mini
          /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
          // Opera Mobi/Tablet
          /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
          // Opera
        ],
        [et, ot],
        [
          /opios[\/ ]+([\w\.]+)/i
          // Opera mini on iphone >= 8.0
        ],
        [ot, [et, jt + " Mini"]],
        [
          /\bopr\/([\w\.]+)/i
          // Opera Webkit
        ],
        [ot, [et, jt]],
        [
          // Mixed
          /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
          // Baidu
        ],
        [ot, [et, "Baidu"]],
        [
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
          // Lunascape/Maxthon/Netfront/Jasmine/Blazer
          // Trident based
          /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
          // Avant/IEMobile/SlimBrowser
          /(?:ms|\()(ie) ([\w\.]+)/i,
          // Internet Explorer
          // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
          /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
          // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
          /(heytap|ovi)browser\/([\d\.]+)/i,
          // Heytap/Ovi
          /(weibo)__([\d\.]+)/i
          // Weibo
        ],
        [et, ot],
        [
          /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
          // UCBrowser
        ],
        [ot, [et, "UC" + Ct]],
        [
          /microm.+\bqbcore\/([\w\.]+)/i,
          // WeChat Desktop for Windows Built-in Browser
          /\bqbcore\/([\w\.]+).+microm/i,
          /micromessenger\/([\w\.]+)/i
          // WeChat
        ],
        [ot, [et, "WeChat"]],
        [
          /konqueror\/([\w\.]+)/i
          // Konqueror
        ],
        [ot, [et, "Konqueror"]],
        [
          /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
          // IE11
        ],
        [ot, [et, "IE"]],
        [
          /ya(?:search)?browser\/([\w\.]+)/i
          // Yandex
        ],
        [ot, [et, "Yandex"]],
        [
          /slbrowser\/([\w\.]+)/i
          // Smart Lenovo Browser
        ],
        [ot, [et, "Smart Lenovo " + Ct]],
        [
          /(avast|avg)\/([\w\.]+)/i
          // Avast/AVG Secure Browser
        ],
        [[et, /(.+)/, "$1 Secure " + Ct], ot],
        [
          /\bfocus\/([\w\.]+)/i
          // Firefox Focus
        ],
        [ot, [et, vt + " Focus"]],
        [
          /\bopt\/([\w\.]+)/i
          // Opera Touch
        ],
        [ot, [et, jt + " Touch"]],
        [
          /coc_coc\w+\/([\w\.]+)/i
          // Coc Coc Browser
        ],
        [ot, [et, "Coc Coc"]],
        [
          /dolfin\/([\w\.]+)/i
          // Dolphin
        ],
        [ot, [et, "Dolphin"]],
        [
          /coast\/([\w\.]+)/i
          // Opera Coast
        ],
        [ot, [et, jt + " Coast"]],
        [
          /miuibrowser\/([\w\.]+)/i
          // MIUI Browser
        ],
        [ot, [et, "MIUI " + Ct]],
        [
          /fxios\/([-\w\.]+)/i
          // Firefox for iOS
        ],
        [ot, [et, vt]],
        [
          /\bqihu|(qi?ho?o?|360)browser/i
          // 360
        ],
        [[et, "360 " + Ct]],
        [
          /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
        ],
        [[et, /(.+)/, "$1 " + Ct], ot],
        [
          // Oculus/Sailfish/HuaweiBrowser/VivoBrowser
          /samsungbrowser\/([\w\.]+)/i
          // Samsung Internet
        ],
        [ot, [et, Pt + " Internet"]],
        [
          /(comodo_dragon)\/([\w\.]+)/i
          // Comodo Dragon
        ],
        [[et, /_/g, " "], ot],
        [
          /metasr[\/ ]?([\d\.]+)/i
          // Sogou Explorer
        ],
        [ot, [et, "Sogou Explorer"]],
        [
          /(sogou)mo\w+\/([\d\.]+)/i
          // Sogou Mobile
        ],
        [[et, "Sogou Mobile"], ot],
        [
          /(electron)\/([\w\.]+) safari/i,
          // Electron-based App
          /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
          // Tesla
          /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i
          // QQBrowser/2345 Browser
        ],
        [et, ot],
        [
          /(lbbrowser)/i,
          // LieBao Browser
          /\[(linkedin)app\]/i
          // LinkedIn App for iOS & Android
        ],
        [et],
        [
          // WebView
          /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
          // Facebook App for iOS & Android
        ],
        [[et, Xt], ot],
        [
          /(Klarna)\/([\w\.]+)/i,
          // Klarna Shopping Browser for iOS & Android
          /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
          // Kakao App
          /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
          // Naver InApp
          /safari (line)\/([\w\.]+)/i,
          // Line App for iOS
          /\b(line)\/([\w\.]+)\/iab/i,
          // Line App for Android
          /(alipay)client\/([\w\.]+)/i,
          // Alipay
          /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
          // Chromium/Instagram/Snapchat
        ],
        [et, ot],
        [
          /\bgsa\/([\w\.]+) .*safari\//i
          // Google Search Appliance on iOS
        ],
        [ot, [et, "GSA"]],
        [
          /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
          // TikTok
        ],
        [ot, [et, "TikTok"]],
        [
          /headlesschrome(?:\/([\w\.]+)| )/i
          // Chrome Headless
        ],
        [ot, [et, ht + " Headless"]],
        [
          / wv\).+(chrome)\/([\w\.]+)/i
          // Chrome WebView
        ],
        [[et, ht + " WebView"], ot],
        [
          /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
          // Android Browser
        ],
        [ot, [et, "Android " + Ct]],
        [
          /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
          // Chrome/OmniWeb/Arora/Tizen/Nokia
        ],
        [et, ot],
        [
          /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
          // Mobile Safari
        ],
        [ot, [et, "Mobile Safari"]],
        [
          /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
          // Safari & Safari Mobile
        ],
        [ot, et],
        [
          /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
          // Safari < 3.0
        ],
        [et, [ot, $t, Ht]],
        [
          /(webkit|khtml)\/([\w\.]+)/i
        ],
        [et, ot],
        [
          // Gecko based
          /(navigator|netscape\d?)\/([-\w\.]+)/i
          // Netscape
        ],
        [[et, "Netscape"], ot],
        [
          /mobile vr; rv:([\w\.]+)\).+firefox/i
          // Firefox Reality
        ],
        [ot, [et, vt + " Reality"]],
        [
          /ekiohf.+(flow)\/([\w\.]+)/i,
          // Flow
          /(swiftfox)/i,
          // Swiftfox
          /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
          // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
          /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
          // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
          /(firefox)\/([\w\.]+)/i,
          // Other Firefox-based
          /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
          // Mozilla
          // Other
          /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
          // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
          /(links) \(([\w\.]+)/i,
          // Links
          /panasonic;(viera)/i
          // Panasonic Viera
        ],
        [et, ot],
        [
          /(cobalt)\/([\w\.]+)/i
          // Cobalt
        ],
        [et, [ot, /master.|lts./, ""]]
      ],
      cpu: [
        [
          /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
          // AMD64 (x64)
        ],
        [[at, "amd64"]],
        [
          /(ia32(?=;))/i
          // IA32 (quicktime)
        ],
        [[at, Mt]],
        [
          /((?:i[346]|x)86)[;\)]/i
          // IA32 (x86)
        ],
        [[at, "ia32"]],
        [
          /\b(aarch64|arm(v?8e?l?|_?64))\b/i
          // ARM64
        ],
        [[at, "arm64"]],
        [
          /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
          // ARMHF
        ],
        [[at, "armhf"]],
        [
          // PocketPC mistakenly identified as PowerPC
          /windows (ce|mobile); ppc;/i
        ],
        [[at, "arm"]],
        [
          /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
          // PowerPC
        ],
        [[at, /ower/, Ge, Mt]],
        [
          /(sun4\w)[;\)]/i
          // SPARC
        ],
        [[at, "sparc"]],
        [
          /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
          // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
        ],
        [[at, Mt]]
      ],
      device: [
        [
          //////////////////////////
          // MOBILES & TABLETS
          /////////////////////////
          // Samsung
          /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
        ],
        [tt, [it, Pt], [rt, lt]],
        [
          /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
          /samsung[- ]([-\w]+)/i,
          /sec-(sgh\w+)/i
        ],
        [tt, [it, Pt], [rt, ut]],
        [
          // Apple
          /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
          // iPod/iPhone
        ],
        [tt, [it, Bt], [rt, ut]],
        [
          /\((ipad);[-\w\),; ]+apple/i,
          // iPad
          /applecoremedia\/[\w\.]+ \((ipad)/i,
          /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
        ],
        [tt, [it, Bt], [rt, lt]],
        [
          /(macintosh);/i
        ],
        [tt, [it, Bt]],
        [
          // Sharp
          /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
        ],
        [tt, [it, Qt], [rt, ut]],
        [
          // Huawei
          /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
        ],
        [tt, [it, bt], [rt, lt]],
        [
          /(?:huawei|honor)([-\w ]+)[;\)]/i,
          /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
        ],
        [tt, [it, bt], [rt, ut]],
        [
          // Xiaomi
          /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
          // Xiaomi POCO
          /\b; (\w+) build\/hm\1/i,
          // Xiaomi Hongmi 'numeric' models
          /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
          // Xiaomi Hongmi
          /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
          // Xiaomi Redmi
          /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
          // Xiaomi Redmi 'numeric' models
          /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
          // Xiaomi Mi
        ],
        [[tt, /_/g, " "], [it, _t], [rt, ut]],
        [
          /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
          // Redmi Pad
          /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
          // Mi Pad tablets
        ],
        [[tt, /_/g, " "], [it, _t], [rt, lt]],
        [
          // OPPO
          /; (\w+) bui.+ oppo/i,
          /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
        ],
        [tt, [it, "OPPO"], [rt, ut]],
        [
          // Vivo
          /vivo (\w+)(?: bui|\))/i,
          /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
        ],
        [tt, [it, "Vivo"], [rt, ut]],
        [
          // Realme
          /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
        ],
        [tt, [it, "Realme"], [rt, ut]],
        [
          // Motorola
          /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
          /\bmot(?:orola)?[- ](\w*)/i,
          /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
        ],
        [tt, [it, kt], [rt, ut]],
        [
          /\b(mz60\d|xoom[2 ]{0,2}) build\//i
        ],
        [tt, [it, kt], [rt, lt]],
        [
          // LG
          /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
        ],
        [tt, [it, Rt], [rt, lt]],
        [
          /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
          /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
          /\blg-?([\d\w]+) bui/i
        ],
        [tt, [it, Rt], [rt, ut]],
        [
          // Lenovo
          /(ideatab[-\w ]+)/i,
          /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
        ],
        [tt, [it, "Lenovo"], [rt, lt]],
        [
          // Nokia
          /(?:maemo|nokia).*(n900|lumia \d+)/i,
          /nokia[-_ ]?([-\w\.]*)/i
        ],
        [[tt, /_/g, " "], [it, "Nokia"], [rt, ut]],
        [
          // Google
          /(pixel c)\b/i
          // Google Pixel C
        ],
        [tt, [it, Et], [rt, lt]],
        [
          /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
          // Google Pixel
        ],
        [tt, [it, Et], [rt, ut]],
        [
          // Sony
          /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
        ],
        [tt, [it, qt], [rt, ut]],
        [
          /sony tablet [ps]/i,
          /\b(?:sony)?sgp\w+(?: bui|\))/i
        ],
        [[tt, "Xperia Tablet"], [it, qt], [rt, lt]],
        [
          // OnePlus
          / (kb2005|in20[12]5|be20[12][59])\b/i,
          /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
        ],
        [tt, [it, "OnePlus"], [rt, ut]],
        [
          // Amazon
          /(alexa)webm/i,
          /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
          // Kindle Fire without Silk / Echo Show
          /(kf[a-z]+)( bui|\)).+silk\//i
          // Kindle Fire HD
        ],
        [tt, [it, wt], [rt, lt]],
        [
          /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
          // Fire Phone
        ],
        [[tt, /(.+)/g, "Fire Phone $1"], [it, wt], [rt, ut]],
        [
          // BlackBerry
          /(playbook);[-\w\),; ]+(rim)/i
          // BlackBerry PlayBook
        ],
        [tt, it, [rt, lt]],
        [
          /\b((?:bb[a-f]|st[hv])100-\d)/i,
          /\(bb10; (\w+)/i
          // BlackBerry 10
        ],
        [tt, [it, yt], [rt, ut]],
        [
          // Asus
          /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
        ],
        [tt, [it, Tt], [rt, lt]],
        [
          / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
        ],
        [tt, [it, Tt], [rt, ut]],
        [
          // HTC
          /(nexus 9)/i
          // HTC Nexus 9
        ],
        [tt, [it, "HTC"], [rt, lt]],
        [
          /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
          // HTC
          // ZTE
          /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
          /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
          // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
        ],
        [it, [tt, /_/g, " "], [rt, ut]],
        [
          // Acer
          /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
        ],
        [tt, [it, "Acer"], [rt, lt]],
        [
          // Meizu
          /droid.+; (m[1-5] note) bui/i,
          /\bmz-([-\w]{2,})/i
        ],
        [tt, [it, "Meizu"], [rt, ut]],
        [
          // Ulefone
          /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
        ],
        [tt, [it, "Ulefone"], [rt, ut]],
        [
          // MIXED
          /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
          // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
          /(hp) ([\w ]+\w)/i,
          // HP iPAQ
          /(asus)-?(\w+)/i,
          // Asus
          /(microsoft); (lumia[\w ]+)/i,
          // Microsoft Lumia
          /(lenovo)[-_ ]?([-\w]+)/i,
          // Lenovo
          /(jolla)/i,
          // Jolla
          /(oppo) ?([\w ]+) bui/i
          // OPPO
        ],
        [it, tt, [rt, ut]],
        [
          /(kobo)\s(ereader|touch)/i,
          // Kobo
          /(archos) (gamepad2?)/i,
          // Archos
          /(hp).+(touchpad(?!.+tablet)|tablet)/i,
          // HP TouchPad
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(nook)[\w ]+build\/(\w+)/i,
          // Nook
          /(dell) (strea[kpr\d ]*[\dko])/i,
          // Dell Streak
          /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
          // Le Pan Tablets
          /(trinity)[- ]*(t\d{3}) bui/i,
          // Trinity Tablets
          /(gigaset)[- ]+(q\w{1,9}) bui/i,
          // Gigaset Tablets
          /(vodafone) ([\w ]+)(?:\)| bui)/i
          // Vodafone
        ],
        [it, tt, [rt, lt]],
        [
          /(surface duo)/i
          // Surface Duo
        ],
        [tt, [it, St], [rt, lt]],
        [
          /droid [\d\.]+; (fp\du?)(?: b|\))/i
          // Fairphone
        ],
        [tt, [it, "Fairphone"], [rt, ut]],
        [
          /(u304aa)/i
          // AT&T
        ],
        [tt, [it, "AT&T"], [rt, ut]],
        [
          /\bsie-(\w*)/i
          // Siemens
        ],
        [tt, [it, "Siemens"], [rt, ut]],
        [
          /\b(rct\w+) b/i
          // RCA Tablets
        ],
        [tt, [it, "RCA"], [rt, lt]],
        [
          /\b(venue[\d ]{2,7}) b/i
          // Dell Venue Tablets
        ],
        [tt, [it, "Dell"], [rt, lt]],
        [
          /\b(q(?:mv|ta)\w+) b/i
          // Verizon Tablet
        ],
        [tt, [it, "Verizon"], [rt, lt]],
        [
          /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
          // Barnes & Noble Tablet
        ],
        [tt, [it, "Barnes & Noble"], [rt, lt]],
        [
          /\b(tm\d{3}\w+) b/i
        ],
        [tt, [it, "NuVision"], [rt, lt]],
        [
          /\b(k88) b/i
          // ZTE K Series Tablet
        ],
        [tt, [it, "ZTE"], [rt, lt]],
        [
          /\b(nx\d{3}j) b/i
          // ZTE Nubia
        ],
        [tt, [it, "ZTE"], [rt, ut]],
        [
          /\b(gen\d{3}) b.+49h/i
          // Swiss GEN Mobile
        ],
        [tt, [it, "Swiss"], [rt, ut]],
        [
          /\b(zur\d{3}) b/i
          // Swiss ZUR Tablet
        ],
        [tt, [it, "Swiss"], [rt, lt]],
        [
          /\b((zeki)?tb.*\b) b/i
          // Zeki Tablets
        ],
        [tt, [it, "Zeki"], [rt, lt]],
        [
          /\b([yr]\d{2}) b/i,
          /\b(dragon[- ]+touch |dt)(\w{5}) b/i
          // Dragon Touch Tablet
        ],
        [[it, "Dragon Touch"], tt, [rt, lt]],
        [
          /\b(ns-?\w{0,9}) b/i
          // Insignia Tablets
        ],
        [tt, [it, "Insignia"], [rt, lt]],
        [
          /\b((nxa|next)-?\w{0,9}) b/i
          // NextBook Tablets
        ],
        [tt, [it, "NextBook"], [rt, lt]],
        [
          /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
          // Voice Xtreme Phones
        ],
        [[it, "Voice"], tt, [rt, ut]],
        [
          /\b(lvtel\-)?(v1[12]) b/i
          // LvTel Phones
        ],
        [[it, "LvTel"], tt, [rt, ut]],
        [
          /\b(ph-1) /i
          // Essential PH-1
        ],
        [tt, [it, "Essential"], [rt, ut]],
        [
          /\b(v(100md|700na|7011|917g).*\b) b/i
          // Envizen Tablets
        ],
        [tt, [it, "Envizen"], [rt, lt]],
        [
          /\b(trio[-\w\. ]+) b/i
          // MachSpeed Tablets
        ],
        [tt, [it, "MachSpeed"], [rt, lt]],
        [
          /\btu_(1491) b/i
          // Rotor Tablets
        ],
        [tt, [it, "Rotor"], [rt, lt]],
        [
          /(shield[\w ]+) b/i
          // Nvidia Shield Tablets
        ],
        [tt, [it, "Nvidia"], [rt, lt]],
        [
          /(sprint) (\w+)/i
          // Sprint Phones
        ],
        [it, tt, [rt, ut]],
        [
          /(kin\.[onetw]{3})/i
          // Microsoft Kin
        ],
        [[tt, /\./g, " "], [it, St], [rt, ut]],
        [
          /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
          // Zebra
        ],
        [tt, [it, Yt], [rt, lt]],
        [
          /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
        ],
        [tt, [it, Yt], [rt, ut]],
        [
          ///////////////////
          // SMARTTVS
          ///////////////////
          /smart-tv.+(samsung)/i
          // Samsung
        ],
        [it, [rt, dt]],
        [
          /hbbtv.+maple;(\d+)/i
        ],
        [[tt, /^/, "SmartTV"], [it, Pt], [rt, dt]],
        [
          /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
          // LG SmartTV
        ],
        [[it, Rt], [rt, dt]],
        [
          /(apple) ?tv/i
          // Apple TV
        ],
        [it, [tt, Bt + " TV"], [rt, dt]],
        [
          /crkey/i
          // Google Chromecast
        ],
        [[tt, ht + "cast"], [it, Et], [rt, dt]],
        [
          /droid.+aft(\w+)( bui|\))/i
          // Fire TV
        ],
        [tt, [it, wt], [rt, dt]],
        [
          /\(dtv[\);].+(aquos)/i,
          /(aquos-tv[\w ]+)\)/i
          // Sharp
        ],
        [tt, [it, Qt], [rt, dt]],
        [
          /(bravia[\w ]+)( bui|\))/i
          // Sony
        ],
        [tt, [it, qt], [rt, dt]],
        [
          /(mitv-\w{5}) bui/i
          // Xiaomi
        ],
        [tt, [it, _t], [rt, dt]],
        [
          /Hbbtv.*(technisat) (.*);/i
          // TechniSAT
        ],
        [it, tt, [rt, dt]],
        [
          /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
          // Roku
          /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
          // HbbTV devices
        ],
        [[it, Gt], [tt, Gt], [rt, dt]],
        [
          /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
          // SmartTV from Unidentified Vendors
        ],
        [[rt, dt]],
        [
          ///////////////////
          // CONSOLES
          ///////////////////
          /(ouya)/i,
          // Ouya
          /(nintendo) ([wids3utch]+)/i
          // Nintendo
        ],
        [it, tt, [rt, st]],
        [
          /droid.+; (shield) bui/i
          // Nvidia
        ],
        [tt, [it, "Nvidia"], [rt, st]],
        [
          /(playstation [345portablevi]+)/i
          // Playstation
        ],
        [tt, [it, qt], [rt, st]],
        [
          /\b(xbox(?: one)?(?!; xbox))[\); ]/i
          // Microsoft Xbox
        ],
        [tt, [it, St], [rt, st]],
        [
          ///////////////////
          // WEARABLES
          ///////////////////
          /((pebble))app/i
          // Pebble
        ],
        [it, tt, [rt, At]],
        [
          /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
          // Apple Watch
        ],
        [tt, [it, Bt], [rt, At]],
        [
          /droid.+; (glass) \d/i
          // Google Glass
        ],
        [tt, [it, Et], [rt, At]],
        [
          /droid.+; (wt63?0{2,3})\)/i
        ],
        [tt, [it, Yt], [rt, At]],
        [
          /(quest( 2| pro)?)/i
          // Oculus Quest
        ],
        [tt, [it, Xt], [rt, At]],
        [
          ///////////////////
          // EMBEDDED
          ///////////////////
          /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
          // Tesla
        ],
        [it, [rt, pt]],
        [
          /(aeobc)\b/i
          // Echo Dot
        ],
        [tt, [it, wt], [rt, pt]],
        [
          ////////////////////
          // MIXED (GENERIC)
          ///////////////////
          /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
          // Android Phones from Unidentified Vendors
        ],
        [tt, [rt, ut]],
        [
          /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
          // Android Tablets from Unidentified Vendors
        ],
        [tt, [rt, lt]],
        [
          /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
          // Unidentifiable Tablet
        ],
        [[rt, lt]],
        [
          /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
          // Unidentifiable Mobile
        ],
        [[rt, ut]],
        [
          /(android[-\w\. ]{0,9});.+buil/i
          // Generic Android Device
        ],
        [tt, [it, "Generic"]]
      ],
      engine: [
        [
          /windows.+ edge\/([\w\.]+)/i
          // EdgeHTML
        ],
        [ot, [et, It + "HTML"]],
        [
          /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
          // Blink
        ],
        [ot, [et, "Blink"]],
        [
          /(presto)\/([\w\.]+)/i,
          // Presto
          /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
          // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
          /ekioh(flow)\/([\w\.]+)/i,
          // Flow
          /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
          // KHTML/Tasman/Links
          /(icab)[\/ ]([23]\.[\d\.]+)/i,
          // iCab
          /\b(libweb)/i
        ],
        [et, ot],
        [
          /rv\:([\w\.]{1,9})\b.+(gecko)/i
          // Gecko
        ],
        [ot, et]
      ],
      os: [
        [
          // Windows
          /microsoft (windows) (vista|xp)/i
          // Windows (iTunes)
        ],
        [et, ot],
        [
          /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
          // Windows Phone
        ],
        [et, [ot, $t, hn]],
        [
          /windows nt 6\.2; (arm)/i,
          // Windows RT
          /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
          /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
        ],
        [[ot, $t, hn], [et, "Windows"]],
        [
          // iOS/macOS
          /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
          // iOS
          /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
          /cfnetwork\/.+darwin/i
        ],
        [[ot, /_/g, "."], [et, "iOS"]],
        [
          /(mac os x) ?([\w\. ]*)/i,
          /(macintosh|mac_powerpc\b)(?!.+haiku)/i
          // Mac OS
        ],
        [[et, Lt], [ot, /_/g, "."]],
        [
          // Mobile OSes
          /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
          // Android-x86/HarmonyOS
        ],
        [ot, et],
        [
          // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
          /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
          /(blackberry)\w*\/([\w\.]*)/i,
          // Blackberry
          /(tizen|kaios)[\/ ]([\w\.]+)/i,
          // Tizen/KaiOS
          /\((series40);/i
          // Series 40
        ],
        [et, ot],
        [
          /\(bb(10);/i
          // BlackBerry 10
        ],
        [ot, [et, yt]],
        [
          /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
          // Symbian
        ],
        [ot, [et, "Symbian"]],
        [
          /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
          // Firefox OS
        ],
        [ot, [et, vt + " OS"]],
        [
          /web0s;.+rt(tv)/i,
          /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
          // WebOS
        ],
        [ot, [et, "webOS"]],
        [
          /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
          // watchOS
        ],
        [ot, [et, "watchOS"]],
        [
          // Google Chromecast
          /crkey\/([\d\.]+)/i
          // Google Chromecast
        ],
        [ot, [et, ht + "cast"]],
        [
          /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
          // Chromium OS
        ],
        [[et, Ut], ot],
        [
          // Smart TVs
          /panasonic;(viera)/i,
          // Panasonic Viera
          /(netrange)mmh/i,
          // Netrange
          /(nettv)\/(\d+\.[\w\.]+)/i,
          // NetTV
          // Console
          /(nintendo|playstation) ([wids345portablevuch]+)/i,
          // Nintendo/Playstation
          /(xbox); +xbox ([^\);]+)/i,
          // Microsoft Xbox (360, One, X, S, Series X, Series S)
          // Other
          /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
          // Joli/Palm
          /(mint)[\/\(\) ]?(\w*)/i,
          // Mint
          /(mageia|vectorlinux)[; ]/i,
          // Mageia/VectorLinux
          /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
          // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
          /(hurd|linux) ?([\w\.]*)/i,
          // Hurd/Linux
          /(gnu) ?([\w\.]*)/i,
          // GNU
          /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
          // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
          /(haiku) (\w+)/i
          // Haiku
        ],
        [et, ot],
        [
          /(sunos) ?([\w\.\d]*)/i
          // Solaris
        ],
        [[et, "Solaris"], ot],
        [
          /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
          // Solaris
          /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
          // AIX
          /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
          // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
          /(unix) ?([\w\.]*)/i
          // UNIX
        ],
        [et, ot]
      ]
    }, An = function(Jt, an) {
      if (typeof Jt === Je && (an = Jt, Jt = Ue), !(this instanceof An))
        return new An(Jt, an).getResult();
      var cn = typeof Qe !== $e && Qe.navigator ? Qe.navigator : Ue, dn = Jt || (cn && cn.userAgent ? cn.userAgent : Ge), yn = cn && cn.userAgentData ? cn.userAgentData : Ue, Nn = an ? Ot(un, an) : un, Rn = cn && cn.userAgent == dn;
      return this.getBrowser = function() {
        var rn = {};
        return rn[et] = Ue, rn[ot] = Ue, zt.call(rn, dn, Nn.browser), rn[nt] = Ft(rn[ot]), Rn && cn && cn.brave && typeof cn.brave.isBrave == Ke && (rn[et] = "Brave"), rn;
      }, this.getCPU = function() {
        var rn = {};
        return rn[at] = Ue, zt.call(rn, dn, Nn.cpu), rn;
      }, this.getDevice = function() {
        var rn = {};
        return rn[it] = Ue, rn[tt] = Ue, rn[rt] = Ue, zt.call(rn, dn, Nn.device), Rn && !rn[rt] && yn && yn.mobile && (rn[rt] = ut), Rn && rn[tt] == "Macintosh" && cn && typeof cn.standalone !== $e && cn.maxTouchPoints && cn.maxTouchPoints > 2 && (rn[tt] = "iPad", rn[rt] = lt), rn;
      }, this.getEngine = function() {
        var rn = {};
        return rn[et] = Ue, rn[ot] = Ue, zt.call(rn, dn, Nn.engine), rn;
      }, this.getOS = function() {
        var rn = {};
        return rn[et] = Ue, rn[ot] = Ue, zt.call(rn, dn, Nn.os), Rn && !rn[et] && yn && yn.platform != "Unknown" && (rn[et] = yn.platform.replace(/chrome os/i, Ut).replace(/macos/i, Lt)), rn;
      }, this.getResult = function() {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      }, this.getUA = function() {
        return dn;
      }, this.setUA = function(rn) {
        return dn = typeof rn === Ze && rn.length > gt ? Gt(rn, gt) : rn, this;
      }, this.setUA(dn), this;
    };
    An.VERSION = He, An.BROWSER = ft([et, ot, nt]), An.CPU = ft([at]), An.DEVICE = ft([tt, it, rt, st, ut, dt, lt, At, pt]), An.ENGINE = An.OS = ft([et, ot]), me.exports && (ue = me.exports = An), ue.UAParser = An;
    var mn = typeof Qe !== $e && (Qe.jQuery || Qe.Zepto);
    if (mn && !mn.ua) {
      var En = new An();
      mn.ua = En.getResult(), mn.ua.get = function() {
        return En.getUA();
      }, mn.ua.set = function(Jt) {
        En.setUA(Jt);
        var an = En.getResult();
        for (var cn in an)
          mn.ua[cn] = an[cn];
      };
    }
  })(typeof window == "object" ? window : commonjsGlobal);
})(uaParser, uaParser.exports);
var uaParserExports = uaParser.exports;
const UAParser = /* @__PURE__ */ getDefaultExportFromCjs(uaParserExports);
let uxType = null;
const setUxType = (me) => {
  if (me === "desktop" || me === "mobile" || me === null)
    uxType = me;
  else
    throw new Error(
      "Invalid value for uxType. Accepted values are 'desktop', 'mobile', or null."
    );
}, getUxType = () => uxType, parser$1 = new UAParser(), uaResult = parser$1.getResult(), isTouchDevice = () => navigator.maxTouchPoints > 0 || "ontouchstart" in document.documentElement, isTabletWithoutAndroid = () => !uaResult.device.type && uaResult.os.name === "Linux" && uaResult.browser.name === "Chrome" && isTouchDevice(), mobile = {
  Android: () => uaResult.os.name === "Android",
  iOS: () => ["iOS", "iPadOS"].includes(uaResult.os.name || ""),
  isIpad: () => uaResult.device.model === "iPad",
  isFBInAppBrowser: () => /\[FB/.test(uaResult.ua),
  isInstagramAppBrowser: () => /Instagram/.test(uaResult.ua),
  any: () => uxType ? uxType === "mobile" : !!(uaResult.device.type === "mobile" || uaResult.device.type === "tablet" || isTabletWithoutAndroid()),
  isDesktop: () => uxType ? uxType === "desktop" : !mobile.any(),
  isAppleDevice: () => ["iOS", "Mac OS", "iPadOS"].includes(uaResult.os.name || ""),
  isBrowserSupported: () => {
    const { browser: me, os: ue } = uaResult;
    return ue.name === "iOS" || ue.name === "iPadOS" ? ["Mobile Safari", "Chrome"].includes(me.name || "") : ue.name === "Mac OS" ? ["Safari", "Chrome"].includes(me.name || "") : me.name === "Chrome";
  }
}, browserName = uaResult.browser.name, desktop = {
  isEdge: () => browserName === "Edge",
  isChrome: () => ["Chrome", "Chrome WebView", "Chrome Headless"].includes(browserName),
  isFirefox: () => ["Firefox", "Firefox Focus", "Firefox Reality"].includes(browserName),
  isOpera: () => ["Opera", "Opera Mini", "Opera Touch"].includes(browserName),
  isSafari: () => ["Safari", "Mobile Safari"].includes(browserName)
}, getHasLiedBrowser = () => {
  let me = navigator.userAgent.toLowerCase(), ue = navigator.productSub, Qe;
  if (me.indexOf("edge/") >= 0 || me.indexOf("iemobile/") >= 0)
    return !1;
  if (me.indexOf("opera mini") >= 0)
    return !1;
  if (me.indexOf("firefox/") >= 0 ? Qe = "Firefox" : me.indexOf("opera/") >= 0 || me.indexOf(" opr/") >= 0 ? Qe = "Opera" : me.indexOf("chrome/") >= 0 ? Qe = "Chrome" : me.indexOf("safari/") >= 0 ? me.indexOf("android 1.") >= 0 || me.indexOf("android 2.") >= 0 || me.indexOf("android 3.") >= 0 || me.indexOf("android 4.") >= 0 ? Qe = "AOSP" : Qe = "Safari" : me.indexOf("trident/") >= 0 ? Qe = "Internet Explorer" : Qe = "Other", (Qe === "Chrome" || Qe === "Safari" || Qe === "Opera") && ue !== "20030107")
    return !0;
  let Ue = eval.toString().length;
  if (Ue === 37 && Qe !== "Safari" && Qe !== "Firefox" && Qe !== "Other")
    return !0;
  if (Ue === 39 && Qe !== "Internet Explorer" && Qe !== "Other")
    return !0;
  if (Ue === 33 && Qe !== "Chrome" && Qe !== "AOSP" && Qe !== "Opera" && Qe !== "Other")
    return !0;
  let He;
  try {
    throw "a";
  } catch (Ge) {
    try {
      Ge.toSource(), He = !0;
    } catch {
      He = !1;
    }
  }
  return He && Qe !== "Firefox" && Qe !== "Other";
}, getUAParserResults = () => uaResult, isBrowserSimulation = () => getUAParserResults().browser.name ? isTouchDevice() && navigator.maxTouchPoints !== 1 ? !1 : isTouchDevice() && // https://stackoverflow.com/a/51774045/14238203
(getHasLiedBrowser() || window.navigator.userAgent.indexOf("Mobile") !== -1) || mobile.iOS() && typeof window.ontouchstart > "u" : !0, isMobile = mobile.any() && !isBrowserSimulation(), isWebRtcSupported = () => !!(window.navigator.mediaDevices && window.navigator.mediaDevices.getUserMedia), isSurfaceTablet = () => {
  const me = navigator.userAgent.indexOf("Windows") > -1, ue = navigator.maxTouchPoints, Qe = "ontouchstart" in window || ue > 0 || (matchMedia == null ? void 0 : matchMedia("(any-pointer: coarse)").matches);
  return me && Qe;
}, deviceClass = {
  MOBILE: "MOBILE",
  DESKTOP: "DESKTOP"
}, getDeviceClass = () => isMobile ? deviceClass.MOBILE : deviceClass.DESKTOP, useEventListener = (me, ue, Qe = window) => {
  const Ue = useRef(() => {
  });
  useEffect(() => {
    Ue.current = ue;
  }, [ue]), useEffect(() => {
    if (!(Qe && Qe.addEventListener)) return;
    const Ge = (Xe) => {
      var Ke;
      return (Ke = Ue == null ? void 0 : Ue.current) == null ? void 0 : Ke.call(Ue, Xe);
    };
    return Qe.addEventListener(me, Ge), () => {
      Qe.removeEventListener(me, Ge);
    };
  }, [me, Qe]);
}, globalState = {}, createGlobalState = (me, ue, Qe) => (globalState[me] || (globalState[me] = { callbacks: [], value: Qe }), globalState[me].callbacks.push(ue), {
  deregister() {
    const Ue = globalState[me].callbacks, He = Ue.indexOf(ue);
    He > -1 && Ue.splice(He, 1);
  },
  emit(Ue) {
    globalState[me].value !== Ue && (globalState[me].value = Ue, globalState[me].callbacks.forEach(
      //@ts-ignore
      (He) => {
        ue !== He && He(Ue);
      }
    ));
  }
}), usePersistedState = (me, ue, {
  get: Qe,
  set: Ue
}) => {
  const He = useRef(null), [Ge, Xe] = useState(() => Qe(ue, me));
  return useEventListener(
    "storage",
    //@ts-ignore
    ({ key: Ke, newValue: $e }) => {
      if (Ke === ue) {
        const Je = JSON.parse($e);
        Ge !== Je && Xe(Je);
      }
    }
  ), useEffect(() => (He.current = createGlobalState(ue, Xe, me), () => {
    var Ke, $e;
    ($e = (Ke = He == null ? void 0 : He.current) == null ? void 0 : Ke.deregister) == null || $e.call(Ke);
  }), []), useEffect(() => {
    var Ke, $e;
    Ue(ue, Ge), ($e = (Ke = He == null ? void 0 : He.current) == null ? void 0 : Ke.emit) == null || $e.call(Ke, Ge);
  }, [ue, Ue, Ge]), [Ge, Xe];
}, createStorage = (me) => ({
  get(ue, Qe) {
    const Ue = me.getItem(ue);
    return Ue === null ? typeof Qe == "function" ? Qe() : Qe : JSON.parse(Ue);
  },
  set(ue, Qe) {
    me.setItem(ue, JSON.stringify(Qe));
  }
}), createPersistedState = (me, ue) => {
  if (!ue && typeof window < "u")
    try {
      ue = localStorage;
    } catch {
      ue = null;
    }
  if (ue) {
    const Qe = createStorage(ue);
    return (Ue) => (
      //@ts-ignore
      usePersistedState(Ue, me, Qe)
    );
  }
  return useState;
}, useSessionState = createPersistedState("sessionData");
function usePermissions() {
  const [me, ue] = useState(!1), [Qe, Ue] = useState(!1);
  return useEffect(() => {
    var He;
    if (!navigator.permissions) {
      Ue(!0);
      return;
    }
    (He = navigator.permissions) == null || He.query({ name: "camera" }).then(function(Ge) {
      Ge.state === "granted" && (ue(!0), Ue(!1)), Ge.state === "prompt" && Ue(!0);
    }).catch(() => {
      ue(!1), Ue(!1);
    });
  }, []), [me, ue, Qe];
}
function useInterval(me, ue) {
  const Qe = useRef(me), Ue = useRef(null);
  return Qe.current = me, useEffect(() => {
    function He() {
      Qe.current();
    }
    if (ue !== null)
      return Ue.current = setInterval(He, ue), () => clearInterval(Ue.current);
  }, [ue]), Ue.current;
}
const resize = async () => {
  await sleep(100);
  const me = window.innerWidth * 0.01, ue = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vw", `${me}px`), document.documentElement.style.setProperty("--vh", `${ue}px`);
}, useResize = (me) => {
  const { isRotated: ue } = useOrientation();
  useEventListener(
    "resize",
    () => {
      mobile.any() && !me || resize();
    },
    window
  ), useLayoutEffect(() => {
    mobile.any() && ue && !me || resize();
  }, [ue, me]);
}, isPortrait = () => {
  var me;
  return ((me = screen.orientation) == null ? void 0 : me.type.includes("portrait")) || Math.abs(window.orientation) === 0;
};
function useOrientation() {
  const me = getUxType(), ue = me === "mobile" ? !1 : !isPortrait(), [Qe, Ue] = useState(ue), He = mobile.isDesktop();
  return useEffect(() => {
    if (me === "mobile") return;
    function Ge() {
      Ue(!isPortrait()), document.activeElement instanceof HTMLElement && document.activeElement.blur(), window.focus();
    }
    return screen.orientation ? screen.orientation.addEventListener("change", Ge) : window.addEventListener("orientationchange", Ge), () => {
      screen.orientation ? screen.orientation.removeEventListener(
        "change",
        Ge
      ) : window.removeEventListener(
        "orientationchange",
        Ge
      );
    };
  }, [me]), useEventListener(
    "resize",
    () => {
      isMobile && Ue(!isPortrait());
    },
    window
  ), {
    isRotated: He ? !1 : Qe
  };
}
const handleUnmountRoot = (me, ue, Qe) => (...Ue) => {
  setTimeout(() => {
    if (me(...Ue), "createRoot" in ReactDOM)
      ue.unmount();
    else if (typeof ReactDOM.unmountComponentAtNode == "function")
      ReactDOM.unmountComponentAtNode(Qe);
    else
      throw new Error("Unsupported React version");
  }, 0);
}, createRoot$1 = (me) => {
  if ("createRoot" in ReactDOM)
    return ReactDOM.createRoot(me);
  if (typeof ReactDOM.render == "function")
    return ReactDOM.render;
  throw new Error("Unsupported React version");
}, customRender = (me, ue, Qe) => {
  if ("createRoot" in ReactDOM)
    Qe.render(me);
  else if (typeof Qe == "function")
    Qe(me, ue);
  else
    throw new Error("Unsupported React version");
};
function useQuery() {
  return useMemo(
    () => new URLSearchParams(window.location.search),
    []
  );
}
function useSteps(me = 0) {
  const [ue, Qe] = useState(me), Ue = useCallback(() => {
    Qe((He) => He + 1);
  }, []);
  return {
    currentStep: ue,
    setStep: Qe,
    nextStep: Ue
  };
}
function useOffline(me = emptyFunc) {
  useEventListener("offline", () => {
    navigator.onLine || me();
  });
}
function useToggle(me = !1) {
  const [ue, Qe] = useState(me);
  return { state: ue, actions: {
    on: () => {
      Qe(!0);
    },
    off: () => {
      Qe(!1);
    },
    toggle: () => {
      Qe((He) => !He);
    },
    reset: () => {
      Qe(me);
    }
  } };
}
function useClickOutside(me, ue) {
  const Qe = useRef();
  useEffect(() => {
    Qe.current = ue;
    const Ue = (He) => {
      var Ge;
      !(me != null && me.current) || (Ge = me == null ? void 0 : me.current) != null && Ge.contains(He.target) || ue();
    };
    return document.addEventListener("mousedown", Ue, !0), document.addEventListener("touchstart", Ue, !0), () => {
      document.removeEventListener("mousedown", Ue), document.removeEventListener("touchstart", Ue);
    };
  }, [ue, me]);
}
const useAutoFocus = (me, ue = !1) => {
  useEffect(() => (me.current && me.current.focus(), () => {
    ue && me.current && me.current.blur();
  }), [me, ue]);
};
let _deviceId = null;
function useDeviceId() {
  const [me, ue] = useState(_deviceId);
  return [me, (Ue) => {
    _deviceId = Ue, ue(Ue);
  }];
}
const backCameraKeywords = [
  "rear",
  "back",
  "rück",
  "arrière",
  "trasera",
  "trás",
  "traseira",
  "posteriore",
  "后面",
  "後面",
  "背面",
  "后置",
  // alternative
  "後置",
  // alternative
  "背置",
  // alternative
  "задней",
  "الخلفية",
  "후",
  "arka",
  "achterzijde",
  "หลัง",
  "baksidan",
  "bagside",
  "sau",
  "bak",
  "tylny",
  "takakamera",
  "belakang",
  "אחורית",
  "πίσω",
  "spate",
  "hátsó",
  "zadní",
  "darrere",
  "zadná",
  "задня",
  "stražnja",
  "belakang",
  "बैक"
], cameraObjects = /* @__PURE__ */ new Map();
let getCamerasPromise;
function isBackCameraLabel(me) {
  const ue = me.toLowerCase();
  return backCameraKeywords.some((Qe) => ue.includes(Qe));
}
function createCamera(me, ue, Qe) {
  var Ze, nt;
  if (cameraObjects.has(me.deviceId))
    return cameraObjects.get(me.deviceId);
  const Ue = me.label, He = me.getCapabilities(), Ge = (Ze = He == null ? void 0 : He.width) == null ? void 0 : Ze.max, Xe = (nt = He == null ? void 0 : He.height) == null ? void 0 : nt.max, Ke = He == null ? void 0 : He.aspectRatio;
  let $e;
  Qe.every((tt) => tt.label === "") ? $e = Qe.length === 1 || ue + 1 <= Qe.length / 2 ? "front" : "back" : $e = isBackCameraLabel(Ue) ? "back" : "front";
  const Je = {
    deviceId: me.deviceId,
    label: Ue,
    cameraType: $e,
    width: Ge,
    height: Xe,
    aspectRatio: Ke
  };
  return cameraObjects.set(me.deviceId, Je), Je;
}
function extractCamerasFromDevices(me) {
  const ue = me.filter((Qe) => Qe.kind === "videoinput").map(createCamera);
  if (ue.length > 1 && !ue.some((Qe) => Qe.cameraType === "back")) {
    let Qe = ue.length - 1;
    const Ue = ue.map((He) => {
      const Ge = He.label.match(/\b([0-9]+)MP?\b/i);
      return Ge != null ? parseInt(Ge[1], 10) : NaN;
    });
    Ue.some((He) => isNaN(He)) || (Qe = Ue.lastIndexOf(
      Math.max(...Ue)
    )), ue[Qe].cameraType = "back";
  }
  return ue;
}
function adjustCamerasFromCameraStream(me, ue) {
  const Qe = me.getSettings(), Ue = ue.find((He) => He.deviceId === Qe.deviceId || He.label !== "" && He.label === me.label);
  if (Ue !== void 0) {
    if ((Qe != null && Qe.facingMode === "environment" || isBackCameraLabel(me.label)) && ue.length > 1)
      return ue.forEach((Ge) => {
        Ge.deviceId === Ue.deviceId ? Ge.cameraType = "back" : isBackCameraLabel(Ge.label) || (Ge.cameraType = "front");
      }), ue.filter((Ge) => Ge.cameraType === "back").sort((Ge, Xe) => Ge.label.localeCompare(Xe.label))[0];
    if (ue.length === 1)
      return Ue;
  }
}
function getCameras() {
  return getCamerasPromise != null || (getCamerasPromise = new Promise(async (me) => {
    const ue = await navigator.mediaDevices.enumerateDevices(), Qe = extractCamerasFromDevices(ue);
    return me(Qe);
  })), getCamerasPromise;
}
function getUserMediaVideoParams(me) {
  const ue = {
    resizeMode: "none",
    facingMode: "environment"
  };
  switch (me) {
    case 0:
      return {
        ...ue,
        height: {
          ideal: 720
        },
        aspectRatio: { ideal: 19.5 / 9 }
      };
    case 1:
      return {
        ...ue,
        width: { min: 3200, ideal: 3840, max: 4096 },
        height: { min: 1800, ideal: 2160, max: 2400 }
      };
    case 2:
      return {
        ...ue,
        width: { min: 1400, ideal: 1920, max: 2160 },
        height: { min: 900, ideal: 1080, max: 1440 }
      };
    case 3:
      return {
        ...ue,
        width: { min: 640, ideal: 640, max: 800 },
        height: { min: 480, ideal: 480, max: 600 }
      };
    case 4:
      return {
        ...ue,
        width: { min: 640, ideal: 800, max: 960 },
        height: { min: 480, ideal: 480, max: 480 }
      };
    default:
      return {};
  }
}
const selfieConstraints = {
  video: {
    facingMode: "user",
    height: { ideal: 480 },
    width: { ideal: 640 }
  }
}, killStream = (me, ue = !1) => {
  if (ue) {
    me.getVideoTracks().forEach((Qe) => Qe.stop());
    return;
  }
  me.getTracks().forEach((Qe) => Qe.stop());
}, selfieChecks = ({ confidence: me, isBright: ue, hasLenses: Qe, hasFaceMask: Ue, hasClosedEyes: He, hasHeadCover: Ge }) => {
  const Xe = me === 0, Ke = ue, $e = !Qe, Je = !Ue, Ze = !He, nt = !Ge;
  return {
    livenessPassed: Xe,
    brightnessPassed: Ke,
    lensesPassed: $e,
    maskPassed: Je,
    closedEyesPassed: Ze,
    headCoverPassed: nt,
    hasErrors: !Xe || !Ke || !$e || !Je || !Ze || !nt
  };
}, logSelfieChecks = (me, ue, Qe, Ue, He) => {
  const Ge = [
    {
      passed: ue.headCoverPassed,
      log: "headCoverDected",
      notification: "notifications.removeHeadwear",
      message: "Lenses detected"
    },
    {
      passed: ue.lensesPassed,
      log: "lensesDetected",
      notification: "notifications.lenses",
      message: "Lenses detected"
    },
    {
      passed: ue.brightnessPassed,
      log: "badBrightness",
      notification: "notifications.brightness",
      message: "Bad brightness"
    },
    {
      passed: ue.maskPassed,
      log: "badMask",
      notification: "notifications.mask",
      message: "Mask detected"
    },
    {
      passed: ue.livenessPassed,
      log: "spoofAttempt",
      notification: "notifications.spoof",
      message: "Spoof attempt detected"
    },
    {
      passed: ue.closedEyesPassed,
      log: "closedEyes",
      notification: "notifications.closedEyes",
      message: "Closed eyes detected"
    }
  ];
  for (const { passed: Xe, log: Ke, message: $e, notification: Je } of Ge)
    if (!Xe) {
      Qe(
        getLogObject(Ke, {
          response: me,
          message: $e
        })
      ), Ue(He(Je));
      break;
    }
}, getIdealContraintsDefault = (me = 720) => ({
  audio: !1,
  video: {
    resizeMode: "none",
    facingMode: "environment",
    height: {
      ideal: me
    },
    aspectRatio: { ideal: 19.5 / 9 }
  }
}), getStream = async (me, ue = 0) => {
  if (me === "user")
    return navigator.mediaDevices.getUserMedia(selfieConstraints);
  if (mobile.iOS()) {
    const Ue = await navigator.mediaDevices.getUserMedia(
      getIOSConstraints()
    );
    return await Ue.getVideoTracks()[0].applyConstraints({
      //@ts-ignore
      advanced: [{ focusDistance: 1 }]
    }), Ue;
  }
  try {
    const Ue = await getCameras(), He = await navigator.mediaDevices.getUserMedia({
      video: getUserMediaVideoParams(ue)
    }), Ge = He.getVideoTracks()[0], Xe = adjustCamerasFromCameraStream(
      Ge,
      Ue
    );
    killStream(He);
    let Ke = 1280, $e = 720;
    if (ue > 1) {
      const { width: nt, height: tt } = getUserMediaVideoParams(
        ue
      );
      Ke = nt.ideal, $e = tt.ideal;
    }
    const Je = {
      video: {
        deviceId: {
          exact: Xe.deviceId
        },
        width: {
          ideal: Ke
        },
        height: {
          ideal: $e
        }
      }
    };
    return await navigator.mediaDevices.getUserMedia(Je);
  } catch (Ue) {
    if (ue === 5)
      throw Ue;
    return getStream(me, ue + 1);
  }
}, getIOSConstraints = () => getIdealContraintsDefault(
  localStorage.getItem("isHighPerformance") === "true" ? 1080 : 720
);
async function chooseNonUltraFrontCameraMultilingual() {
  const me = [
    "front",
    "frontal",
    "vorderseite",
    "avant",
    "前面",
    "正面",
    "앞"
  ], ue = ["ultra", "ウルトラ", "울트라"];
  try {
    const Ue = (await navigator.mediaDevices.enumerateDevices()).find((He) => {
      const Ge = He.label.toLowerCase();
      return He.kind === "videoinput" && me.some((Xe) => Ge.includes(Xe.toLowerCase())) && !ue.some((Xe) => Ge.includes(Xe.toLowerCase()));
    });
    return Ue ? Ue.deviceId : null;
  } catch {
    return null;
  }
}
async function getNonUltraWideFrontCameraStream() {
  const me = await navigator.mediaDevices.getUserMedia({
    video: {
      facingMode: "user"
    },
    audio: !1
  });
  killStream(me);
  const ue = await chooseNonUltraFrontCameraMultilingual();
  return navigator.mediaDevices.getUserMedia({
    video: {
      deviceId: ue
    }
  });
}
const zoomCameraToTheMax = async (me) => {
  const ue = me.getVideoTracks()[0], Qe = ue.getCapabilities();
  return Qe.zoom ? await zoomCamera(ue, Qe.zoom.max) : !1;
}, zoomCamera = async (me, ue) => {
  if (!me) return !1;
  const Qe = me.getSettings(), Ue = me.getCapabilities();
  return "zoom" in Qe || Ue.zoom ? (await me.applyConstraints({
    advanced: [
      {
        zoom: Ue.zoom.min && ue < Ue.zoom.min || Ue.zoom.max && ue > Ue.zoom.max || ue
      }
    ]
  }), !0) : !1;
};
async function base64ToImageData(me) {
  const Qe = await (await fetch(`data:image/jpeg;base64,${me}`)).blob(), Ue = new Image(), He = new Promise((Ke, $e) => {
    Ue.onload = Ke, Ue.onerror = $e;
  });
  Ue.src = URL.createObjectURL(Qe), await He;
  const Ge = document.createElement("canvas");
  Ge.width = Ue.width, Ge.height = Ue.height;
  const Xe = Ge.getContext("2d");
  return Xe.drawImage(Ue, 0, 0), Xe.getImageData(0, 0, Ue.width, Ue.height);
}
function getChosenCameraInfo(me, ue = null, Qe = null) {
  const Ue = me.getCapabilities(), He = me.getSettings(), { focusMode: Ge = !1 } = navigator.mediaDevices.getSupportedConstraints();
  return {
    label: me.label,
    deviceId: He.deviceId,
    fallbackOption: ue,
    videoSource: Qe,
    resolution: `${He.width}x${He.height}`,
    autofocus: Ge,
    facingMode: He.facingMode,
    currentFrameRate: He.frameRate,
    zoom: Ue.zoom ? {
      current: He.zoom,
      min: Ue.zoom.min,
      max: Ue.zoom.max,
      step: Ue.zoom.step
    } : void 0,
    focusDistance: Ue.focusDistance ? {
      current: He.focusDistance,
      min: Ue.focusDistance.min,
      max: Ue.focusDistance.max,
      step: Ue.focusDistance.step
    } : void 0
  };
}
async function getDeviceCapabilities() {
  const me = {};
  try {
    (await navigator.mediaDevices.enumerateDevices()).filter((Ue) => Ue.kind === "videoinput").forEach((Ue, He) => {
      const Ge = Ue.getCapabilities();
      me[`camera${He + 1}`] = {
        label: Ue.label,
        width: {
          min: Ge.width.min,
          max: Ge.width.max
        },
        height: {
          min: Ge.height.min,
          max: Ge.height.max
        },
        frameRate: {
          min: Ge.frameRate.min,
          max: Ge.frameRate.max
        },
        facingMode: Ge.facingMode,
        focusMode: Ge.focusMode || void 0,
        focusDistance: Ge.focusDistance ? {
          min: Ge.focusDistance.min,
          max: Ge.focusDistance.max
        } : void 0
      };
    });
  } catch (ue) {
    console.log("Unable to get device capabilities: ", ue);
  }
  return me;
}
const regex$1 = {
  CURP_PATTERN: /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HMX](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/,
  EMAIL_PATTERN: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  E164_PHONE_NUMBER: /^\+?[1-9]\d{7,14}$/,
  SSN_PATTERN: /^\d{3}-?\d{2}-?\d{4}$/
};
let api;
function setApi(me) {
  api = me;
}
const deviceStatsQueue = [];
let isReady = !1;
function addDeviceStats(me, ue) {
  if (!isReady) {
    deviceStatsQueue.push(ue);
    return;
  }
  return api.post("/omni/device/stats", ue, {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }).catch(() => {
  });
}
function emptyDeviceStatsQueue(me) {
  isReady = !0, deviceStatsQueue.forEach((ue) => {
    addDeviceStats(me, ue);
  });
}
const eventsQueue = [];
function addEvent(me) {
  const { token: ue, code: Qe, module: Ue, screen: He, clientTimestamp: Ge, payload: Xe = {} } = me;
  if (!ue) {
    eventsQueue.push(me);
    return;
  }
  return api.post(
    "/omni/interview-events",
    [
      {
        code: Qe,
        module: Ue,
        screen: He,
        clientTimestamp: Ge ?? (/* @__PURE__ */ new Date()).getTime(),
        payload: Xe
      }
    ],
    {
      headers: {
        "X-Incode-Hardware-Id": ue
      }
    }
  ).catch(() => {
  });
}
function emptyQueue(me) {
  eventsQueue.forEach((ue) => {
    addEvent({ ...ue, token: me });
  });
}
const state = {
  token: null
};
let options = {
  darkMode: !1,
  hostingApp: "Web SDK",
  unsafeMode: !1,
  redirectFromUnsupportedBrowsers: !1,
  recorderProvider: "openVidu"
};
const setOptions = (me) => (options = {
  ...options,
  ...me
}, options);
var PipelineProfileName = /* @__PURE__ */ ((me) => (me[me.IdCapture_2_01 = 0] = "IdCapture_2_01", me[me.IdVideoSelfie_2_01 = 1] = "IdVideoSelfie_2_01", me[me.SelfieWithAggregationMetrics = 2] = "SelfieWithAggregationMetrics", me[me.SelfieWithQualityMetrics = 3] = "SelfieWithQualityMetrics", me))(PipelineProfileName || {});
class PipelineProfile {
  constructor(ue, Qe, Ue, He, Ge, Xe = null, Ke = "") {
    this.pipelineType = ue, this.name = Qe, this.detectionType = Ue, this.modelNames = He, this.parameters = Ge, this.paramsConfigurator = Xe, this.description = Ke;
  }
  reconfigureParams(ue = null) {
    if (this.paramsConfigurator == null)
      throw new Error("PipelineProfile does not have a paramsConfigurator");
    this.paramsConfigurator(
      this.parameters,
      this.pipelineType,
      ue
    );
  }
}
var DetectionType = /* @__PURE__ */ ((me) => (me[me.IDCapture = 0] = "IDCapture", me[me.Selfie = 1] = "Selfie", me[me.IdVideoSelfie = 2] = "IdVideoSelfie", me))(DetectionType || {}), WasmPipelineType = /* @__PURE__ */ ((me) => (me[me.IdCapturePipeline = 0] = "IdCapturePipeline", me[me.IdVideoSelfiePipeline = 1] = "IdVideoSelfiePipeline", me[me.SelfieWithAggregationMetrics = 2] = "SelfieWithAggregationMetrics", me[me.SelfieWithQualityMetrics = 3] = "SelfieWithQualityMetrics", me[me.IdFaceDetectionPipeline = 4] = "IdFaceDetectionPipeline", me))(WasmPipelineType || {});
function IdCaptureParamsConfigurator(me, ue, Qe) {
  Object.assign(me, {
    areaDown: Qe ? 55e3 : 25e3,
    areaUp: Qe ? 75e3 : 55e3,
    areaIOSPassportUp: 3e4,
    areaIOSPassportDown: 2e4,
    widthIOSUp: ue == WasmPipelineType.IdCapturePipeline ? 125 : 180,
    widthIOSDown: ue == WasmPipelineType.IdCapturePipeline ? 85 : 150,
    widthDown: Qe ? 185 : 135,
    widthUp: Qe ? 255 : 205
  });
}
const SelfieFaceDetectionPipelineParams = {
  frameMinX: 0,
  frameMinY: 0,
  frameMaxX: 1,
  frameMaxY: 1,
  brightnessThreshold: 50,
  blurrinessThreshold: 50,
  tiltRotationAngleThreshold: 15,
  minMagicCropSize: 200,
  headwearThreshold: 0.95,
  lensesThreshold: 0.95,
  closedEyesThreshold: 0.9,
  maskThreshold: 0.5,
  minFaceQualityScore: 0.59
}, pipelineProfiles = [
  new PipelineProfile(
    WasmPipelineType.IdCapturePipeline,
    PipelineProfileName.IdCapture_2_01,
    DetectionType.IDCapture,
    ["id_capture_2_01_fp16.ortmodelv2"],
    {
      glareThreshold: 0.3,
      classificationThreshold: 0.98,
      sharpnessThreshold: 0.2,
      sharpnessChangeThreshold: 0.2
    },
    IdCaptureParamsConfigurator,
    "Id Capture Profile with model https://www.notion.so/ID-cropping-web-2-01-d011d878c6f4406394609cbfbf03c259?pvs=4"
  ),
  new PipelineProfile(
    WasmPipelineType.IdVideoSelfiePipeline,
    PipelineProfileName.IdVideoSelfie_2_01,
    DetectionType.IdVideoSelfie,
    ["id_capture_2_01_fp16.ortmodelv2"],
    {
      glareThreshold: 0.3,
      classificationThreshold: 0.9,
      sharpnessThreshold: 0.2,
      sharpnessChangeThreshold: 0.2
    },
    IdCaptureParamsConfigurator,
    "Id Videoselfie profile with model https://www.notion.so/ID-cropping-web-2-01-d011d878c6f4406394609cbfbf03c259?pvs=4"
  ),
  new PipelineProfile(
    WasmPipelineType.SelfieWithAggregationMetrics,
    PipelineProfileName.SelfieWithAggregationMetrics,
    DetectionType.Selfie,
    [
      "selfie_bf_angles_192x192_opset9_fp16.ortmodelv2",
      "bf_attrib_31b8f9d92fb345c2b4bbdd222792562c_0_fp16.ortmodelv2",
      "mls_regressor_4773007c657b4f05a460321456740d0f_fp16.ortmodelv2"
    ],
    SelfieFaceDetectionPipelineParams,
    null,
    "Selfie face detection profile with aggregation metrics"
  ),
  new PipelineProfile(
    WasmPipelineType.SelfieWithQualityMetrics,
    PipelineProfileName.SelfieWithQualityMetrics,
    DetectionType.Selfie,
    [
      "selfie_bf_angles_192x192_opset9_fp16.ortmodelv2",
      "bf_attrib_31b8f9d92fb345c2b4bbdd222792562c_0_fp16.ortmodelv2",
      "mls_regressor_4773007c657b4f05a460321456740d0f_fp16.ortmodelv2"
    ],
    SelfieFaceDetectionPipelineParams,
    null,
    "Selfie face detection profile with quality metrics"
  )
];
function getProfile(me) {
  const ue = pipelineProfiles.find(
    (Qe) => Qe.name === me
  );
  if (!ue)
    throw new Error(`Profile not found for type: ${me}`);
  return ue;
}
const probabilityThreshold = 0.6, wasmVersion = "v1.8.8", pipelineBundles = /* @__PURE__ */ new Map([
  ["selfieAggregationMetrics", [
    PipelineProfileName.IdCapture_2_01,
    PipelineProfileName.IdVideoSelfie_2_01,
    PipelineProfileName.SelfieWithAggregationMetrics
  ]],
  ["selfieQualityMetrics", [
    PipelineProfileName.IdCapture_2_01,
    PipelineProfileName.IdVideoSelfie_2_01,
    PipelineProfileName.SelfieWithQualityMetrics
  ]]
]);
function switchBundle() {
  return Math.random() < probabilityThreshold ? "selfieAggregationMetrics" : "selfieQualityMetrics";
}
function getInitializationParams(me) {
  const Qe = me ? switchBundle() : "selfieAggregationMetrics", Ue = "https://d3vv997wtl2myz.cloudfront.net/webcamera/onnx-backend-wasm", He = `${Ue}/${wasmVersion}/webLib.wasm`, Ge = `${Ue}/${wasmVersion}/webLibSimd.wasm`, Xe = `${Ue}/${wasmVersion}/webLib.js`, Ke = `${Ue}/${wasmVersion}/versions.json`;
  let $e = /* @__PURE__ */ new Map(), Je = /* @__PURE__ */ new Map();
  for (const Ze of pipelineBundles.get(Qe)) {
    const nt = getProfile(Ze);
    if (!nt)
      throw new Error(`Profile not found: ${Ze}`);
    const tt = nt.modelNames;
    let et = [];
    for (const rt of tt)
      et.push(`${Ue}/${wasmVersion}/models/${rt}`);
    $e.set(nt.pipelineType, et), Je.set(nt.detectionType, nt);
  }
  return {
    wasmModulePath: He,
    wasmSimdModulePath: Ge,
    glueCodePath: Xe,
    versionsFilePath: Ke,
    pipelineModels: $e,
    enableSIMD: !0,
    bundle: Qe,
    profiles: Je,
    wasmVersion
  };
}
window.wasmArrayBuffer = null;
class MlWasmJSApi {
  constructor() {
    this.versionsFile = null, this.modelsBuffers = null, this.inputImageBuffer = null, this.wasmModule = null, this.wasmApiHelpers = null, this.idCaptureWasmApi = null, this.faceDetectionWasmApi = null, this.imageWidth_ = null, this.imageHeight_ = null, this.pipelines_ = null, this.isInitialized_ = !1, this.Module = null, this.loadModule = async (ue) => {
      this.Module = (await import(
        /* webpackIgnore: true */
        ue
      )).Module;
    };
  }
  /**
   * Initiallization method, use it when the application starts
   * TODO: this method can return the list of promises to be awaited together with other initialization code
   * @param {string} webLibPath - The path to the webassembly binary
   * @param {string} webLibPathSimd - The path to the SIMD version webassembly binary
   * @param {boolean} useSimd - Indicates whether SIMD optimizations should be used
   * @param {string} versionsFile - The path to the file containing versioning information
   * @param {Map.<WasmPipelineType, Array<string>>} pipelines - pipelines for initialization and corresponding models paths
   * @returns {Promise<boolean>} A promise that resolves to a boolean indicating whether SIMD is enabled once the initialization is complete.
   * @throws {Error} Throws an error if the initialization fails.
   */
  async initialize(ue, Qe, Ue, He, Ge, Xe) {
    await this.freeResources(), this.pipelines_ = Xe, this.versionsFile = Ge, await this.loadModule(Ue);
    const Ke = await this.loadWasm(He, ue, Qe);
    return this.wasmApiHelpers = new this.wasmModule.MlWasmApiHelpers(), this.idCaptureWasmApi = new this.wasmModule.IdCaptureWasmApi(), this.faceDetectionWasmApi = new this.wasmModule.FaceDetectionWasmApi(), this.isInitialized_ = !0, Ke;
  }
  static getInstance() {
    return MlWasmJSApi.instance || (MlWasmJSApi.instance = new MlWasmJSApi()), MlWasmJSApi.instance;
  }
  /**
   * Returns initialization status
   * @returns
   */
  isInitialized() {
    return this.wasmApiHelpers != null && this.idCaptureWasmApi != null && this.faceDetectionWasmApi != null && this.isInitialized_;
  }
  /**
   * Allocate shared memory for image buffers (RGBA format)
   * Use it every time when the frame dimentions changes
   * @param {number} imageWidth - image width
   * @param {number} imageHeight - image height
   */
  async allocateImageBuffers(ue, Qe) {
    this.checkWasmInitialization(
      "Unable to allocate image buffers, cpp API hasn't been initialized"
    ), !(ue && Qe && ue == this.imageWidth_ && Qe == this.imageHeight_ && this.inputImageBuffer && ue * Qe * 4 === this.inputImageBuffer.length) && (this.imageWidth_ = ue, this.imageHeight_ = Qe, this.inputImageBuffer = this.wasmApiHelpers.allocateInputImageBuffer(
      ue,
      Qe,
      4
    ));
  }
  async handleDetectionCallAndUpdateState(ue) {
    this.checkWasmInitialization(
      "Unable to update pipeline state, cpp API hasn't been initialized"
    ), this.wasmApiHelpers.handleDetectionCallAndUpdateState(
      this.toWasmEnum(ue)
    );
  }
  async encryptImage(ue) {
    return this.checkWasmInitialization(
      "Unable to encrypt the image, cpp API hasn't been initialized"
    ), this.wasmApiHelpers.encryptImage(ue);
  }
  isVirtualCamera(ue) {
    if (this.checkWasmInitialization(
      "Unable to check if the camera is virtual, cpp API hasn't been initialized"
    ), ue)
      return this.wasmApiHelpers.isVirtualCamera(ue);
  }
  estimatePerformance() {
    return this.checkWasmInitialization(
      "Unable to estimate performance, cpp API hasn't been initialized"
    ), this.wasmApiHelpers.estimatePerformance();
  }
  async analyzeFrame(ue) {
    return this.checkWasmInitialization(
      "Unable to analyze the frame, cpp API hasn't been initialized"
    ), await this.allocateImageBuffers(ue.width, ue.height), this.inputImageBuffer.set(ue.data), this.wasmApiHelpers.analyzeFrame();
  }
  /**
   * Free allocated memory
   */
  async freeResources() {
    this.versionsFile = null, this.modelsBuffers = null, this.inputImageBuffer = null, this.imageWidth_ = null, this.imageHeight_ = null, this.pipelines_ = null, window.wasmArrayBuffer = null, this.wasmApiHelpers && typeof this.wasmApiHelpers.delete == "function" && (this.wasmApiHelpers.delete(), this.wasmApiHelpers = null), this.idCaptureWasmApi && typeof this.idCaptureWasmApi.delete == "function" && (this.idCaptureWasmApi.delete(), this.idCaptureWasmApi = null), this.faceDetectionWasmApi && typeof this.faceDetectionWasmApi.delete == "function" && (this.faceDetectionWasmApi.delete(), this.faceDetectionWasmApi = null), this.wasmModule = null, this.isInitialized_ = !1;
  }
  /**
   * Clear pipeline state
   */
  resetPipeline(ue) {
    this.checkWasmInitialization(
      "Unable to reset pipeline, cpp API hasn't been initialized"
    ), this.wasmApiHelpers.resetPipeline(this.toWasmEnum(ue));
  }
  /**
   * Clear all pipelines states
   */
  resetAllPipelines() {
    this.checkWasmInitialization(
      "Unable to reset pipelines, cpp API hasn't been initialized"
    );
    for (const [ue, Qe] of this.pipelines_)
      this.resetPipeline(ue);
  }
  /**
   * Process one frame using one of the pipelines
   * @param {ImageData} image - input image
   * @param {WasmPipelineType} type - pipeline type
   * @returns
   */
  async process(ue, Qe) {
    if (this.checkWasmInitialization(
      "Unable to process the image, cpp API hasn't been initialized"
    ), this.inputImageBuffer === null)
      throw new Error(
        "Unable to process the image, buffers haven't been allocated!"
      );
    switch (this.inputImageBuffer.set(ue.data), Qe) {
      case WasmPipelineType.IdCapturePipeline:
        return this.idCaptureWasmApi.runIdCapturePipeline();
      case WasmPipelineType.IdFaceDetectionPipeline:
        return this.faceDetectionWasmApi.runIdFaceDetectionPipeline();
      case WasmPipelineType.IdVideoSelfiePipeline:
        return this.idCaptureWasmApi.runIdVideoSelfiePipeline();
      case WasmPipelineType.SelfieWithAggregationMetrics:
      case WasmPipelineType.SelfieWithQualityMetrics:
        return this.faceDetectionWasmApi.runSelfieFaceDetectionPipeline(this.toWasmEnum(Qe));
      default:
        throw new Error("Unknown pipeline type");
    }
  }
  async runIdCapture(ue) {
    if (this.checkWasmInitialization(
      "Unable to run Id Capture, cpp API hasn't been initialized"
    ), this.inputImageBuffer === null)
      throw new Error(
        "Unable to process the image, buffers haven't been allocated!"
      );
    return this.inputImageBuffer.set(ue.data), this.idCaptureWasmApi.runIdCapture();
  }
  async runSelfieCapture(ue) {
    if (this.checkWasmInitialization(
      "Unable to run Selfie Capture, cpp API hasn't been initialized"
    ), this.inputImageBuffer === null)
      throw new Error(
        "Unable to process the image, buffers haven't been allocated!"
      );
    return this.inputImageBuffer.set(ue.data), this.faceDetectionWasmApi.runSelfieCapture();
  }
  async setFacePositionConstraints(ue, Qe, Ue, He, Ge) {
    this.checkWasmInitialization(
      "Unable to set face position constraints, cpp API hasn't been initialized"
    ), this.faceDetectionWasmApi.setFacePositionConstraints(
      this.toWasmEnum(ue),
      Qe,
      Ue,
      He,
      Ge
    );
  }
  async setFaceDetectionThresholds(ue, Qe, Ue, He, Ge, Xe, Ke) {
    this.checkWasmInitialization(
      "Unable to set face detection thresholds, cpp API hasn't been initialized"
    ), this.faceDetectionWasmApi.setFaceDetectionThresholds(
      this.toWasmEnum(ue),
      Qe,
      Ue,
      He,
      Ge,
      Xe,
      Ke
    );
  }
  async setFaceAttributesThresholds(ue, Qe, Ue, He, Ge) {
    this.checkWasmInitialization(
      "Unable to set face attributes thresholds, cpp API hasn't been initialized"
    ), this.faceDetectionWasmApi.setFaceAttributesThresholds(
      this.toWasmEnum(ue),
      Qe,
      Ue,
      He,
      Ge
    );
  }
  async setFaceAttributesEnabled(ue, Qe, Ue, He, Ge) {
    this.checkWasmInitialization(
      "Unable to set face attributes enabled flags, cpp API hasn't been initialized"
    ), this.faceDetectionWasmApi.setFaceAttributesEnabled(
      this.toWasmEnum(ue),
      Qe,
      Ue,
      He,
      Ge
    );
  }
  async setFaceDetectionMode(ue, Qe) {
    this.checkWasmInitialization(
      "Unable to set face detection mode, cpp API hasn't been initialized"
    ), this.faceDetectionWasmApi.setFaceDetectionMode(
      this.toWasmEnum(ue),
      Qe
    );
  }
  async setFaceDetectionCallbacks(ue, Qe, Ue, He, Ge, Xe, Ke, $e, Je, Ze, nt, tt, et, rt, it, ot, at) {
    this.checkWasmInitialization(
      "Unable to set face detection callbacks, cpp API hasn't been initialized"
    ), this.faceDetectionWasmApi.setFaceDetectionCallbacks(
      this.toWasmEnum(ue),
      Qe,
      Ue,
      He,
      Ge,
      Xe,
      Ke,
      $e,
      Je,
      Ze,
      nt,
      tt,
      et,
      rt,
      it,
      ot,
      at
    );
  }
  async setIdCaptureThresholds(ue, Qe, Ue, He, Ge, Xe) {
    this.checkWasmInitialization(
      "Unable to set thresholds, cpp API hasn't been initialized"
    ), this.idCaptureWasmApi.setIdCaptureThresholds(
      this.toWasmEnum(ue),
      Qe,
      Ue,
      He,
      Ge,
      Xe
    );
  }
  async setIdCaptureCallbacks(ue, Qe, Ue, He, Ge, Xe, Ke, $e, Je, Ze, nt) {
    this.checkWasmInitialization(
      "Unable to set callbacks, cpp API hasn't been initialized"
    ), this.idCaptureWasmApi.setIdCaptureCallbacks(
      this.toWasmEnum(ue),
      Qe,
      Ue,
      He,
      Ge,
      Xe,
      Ke,
      $e,
      Je,
      Ze,
      nt
    );
  }
  async setIdCaptureGeometryParams(ue, Qe, Ue, He, Ge, Xe, Ke, $e, Je, Ze, nt, tt, et) {
    this.checkWasmInitialization(
      "Unable to set geometry params, cpp API hasn't been initialized"
    ), this.idCaptureWasmApi.setIdCaptureGeometryParams(
      this.toWasmEnum(ue),
      Qe,
      Ue,
      He,
      Ge,
      Xe,
      Ke,
      $e,
      Je,
      Ze,
      nt,
      tt,
      et
    );
  }
  async setIdCaptureConfigParams(ue, Qe, Ue, He, Ge, Xe) {
    this.checkWasmInitialization(
      "Unable to set config params, cpp API hasn't been initialized"
    ), this.idCaptureWasmApi.setIdCaptureConfigParams(
      this.toWasmEnum(ue),
      Qe,
      Ue,
      He,
      Ge,
      Xe
    );
  }
  async getVersions() {
    const Qe = await (await fetch(this.versionsFile)).text();
    return JSON.parse(Qe);
  }
  async loadWasm(ue, Qe, Ue) {
    const He = ue ? Ue : Qe;
    try {
      window.wasmArrayBuffer = await fetch(He).then((Ge) => Ge.arrayBuffer()).then((Ge) => new Uint8Array(Ge)), this.wasmModule = await this.Module();
    } catch (Ge) {
      if (console.log(Ge, ue, "useSmd"), ue)
        return await this.loadWasm(!1, Qe, Ue);
      throw Ge;
    }
    return ue;
  }
  async loadModels() {
    var He;
    this.checkWasmInitialization(
      "Unable load the models, cpp API hasn't been initialized"
    );
    let ue = new this.wasmModule.PipelineTypeToIntMap(), Qe = /* @__PURE__ */ new Map(), Ue = /* @__PURE__ */ new Map();
    for (let [Ge, Xe] of this.pipelines_) {
      let Ke = this.toWasmEnum(Ge), $e = [], Je = new this.wasmModule.VectorInt();
      for (let Ze of Xe) {
        if (!Ue.has(Ze)) {
          let tt = await fetch(Ze).then((et) => et.arrayBuffer()).then((et) => new Uint8Array(et));
          Ue.set(Ze, tt);
        }
        let nt = Ue.get(Ze);
        Je.push_back(nt.byteLength), $e.push(nt);
      }
      ue.set(Ke, Je), Qe.set(Ke, $e);
    }
    this.modelsBuffers = this.wasmApiHelpers.allocateModelsBuffers(ue);
    for (let [Ge, Xe] of Qe) {
      let Ke = (He = this.modelsBuffers) == null ? void 0 : He.get(Ge);
      for (let $e = 0; $e < Ke.size(); $e++) {
        let Je = Ke == null ? void 0 : Ke.get($e);
        if (Je)
          Je.set(Xe[$e]);
        else
          throw new Error("Unable to get model buffer from shared memory!");
      }
    }
  }
  async initializePipelines() {
    this.checkWasmInitialization(
      "Unable to initialize pipelines, cpp API hasn't been initialized"
    ), this.modelsBuffers || await this.loadModels(), this.wasmApiHelpers.initializePipelines();
  }
  async setProductionMode(ue) {
    this.checkWasmInitialization(
      "Unable to set production mode, cpp API hasn't been initialized"
    ), this.wasmApiHelpers.setProductionMode(ue);
  }
  getPipelineState() {
    return this.checkWasmInitialization(
      "Unable to get pipeline state, cpp API hasn't been initialized"
    ), this.wasmApiHelpers.getPipelineState();
  }
  getCurrentPipeline() {
    return this.checkWasmInitialization(
      "Unable to get current pipeline, cpp API hasn't been initialized"
    ), this.fromWasmEnum(this.wasmApiHelpers.getCurrentPipeline());
  }
  toWasmEnum(ue) {
    switch (ue) {
      case WasmPipelineType.IdCapturePipeline:
        return this.wasmModule.PipelineType.IdCapturePipeline;
      case WasmPipelineType.IdFaceDetectionPipeline:
        return this.wasmModule.PipelineType.IdFaceDetectionPipeline;
      case WasmPipelineType.IdVideoSelfiePipeline:
        return this.wasmModule.PipelineType.IdVideoSelfiePipeline;
      case WasmPipelineType.SelfieWithAggregationMetrics:
        return this.wasmModule.PipelineType.SelfieWithAggregationMetrics;
      case WasmPipelineType.SelfieWithQualityMetrics:
        return this.wasmModule.PipelineType.SelfieWithQualityMetrics;
      default:
        throw new Error("Unknown pipeline type");
    }
  }
  fromWasmEnum(ue) {
    switch (ue) {
      case this.wasmModule.PipelineType.IdCapturePipeline:
        return WasmPipelineType.IdCapturePipeline;
      case this.wasmModule.PipelineType.IdFaceDetectionPipeline:
        return WasmPipelineType.IdFaceDetectionPipeline;
      case this.wasmModule.PipelineType.IdVideoSelfiePipeline:
        return WasmPipelineType.IdVideoSelfiePipeline;
      case this.wasmModule.PipelineType.SelfieWithAggregationMetrics:
        return WasmPipelineType.SelfieWithAggregationMetrics;
      case this.wasmModule.PipelineType.SelfieWithQualityMetrics:
        return WasmPipelineType.SelfieWithQualityMetrics;
      default:
        throw new Error("Unknown pipeline type");
    }
  }
  checkWasmInitialization(ue) {
    if (!this.isInitialized())
      throw new Error(ue);
  }
}
const MlWasmJSApi$1 = MlWasmJSApi.getInstance();
class MotionStatusCheck {
  constructor(ue, Qe, Ue, He, Ge, Xe, Ke, $e, Je, Ze, nt, tt) {
    this.isRunning_ = !1, this.acl_ = null, this.gyro_ = null, this.permission_ = !0, this.minNumberOfFrames_ = 3, this.maxFrequency_ = 60, this.emptyParams = {
      meanX: 0,
      meanY: 0,
      meanZ: 0,
      m2X: 0,
      m2Y: 0,
      m2Z: 0,
      cumulativeAbsErrorX: 0,
      cumulativeAbsErrorY: 0,
      cumulativeAbsErrorZ: 0,
      ptsNum: 0
    }, this.paramsAcc_ = { ...this.emptyParams }, this.paramsGyro_ = { ...this.emptyParams }, this.paramsAccGrOld_ = { ...this.emptyParams }, this.paramsAccOld_ = { ...this.emptyParams }, this.paramsGyroscopeOld_ = { ...this.emptyParams }, this.paramsOrientationOld_ = { ...this.emptyParams }, this.waitForClick = () => new Promise((et) => {
      document.addEventListener(
        "click",
        async () => {
          const rt = await this.requestMotionPermission();
          et(rt);
        },
        { once: !0 }
      );
    }), this.deviceMotionListener = (et) => {
      if (et.accelerationIncludingGravity) {
        const rt = {
          x: et.accelerationIncludingGravity.x,
          y: et.accelerationIncludingGravity.y,
          z: et.accelerationIncludingGravity.z
        };
        this.checkFields(rt) && (this.paramsAccGrOld_.ptsNum += 1, this.updateParams(this.paramsAccGrOld_, rt));
      }
      if (et.acceleration) {
        const rt = {
          x: et.acceleration.x,
          y: et.acceleration.y,
          z: et.acceleration.z
        };
        this.checkFields(rt) && (this.paramsAccOld_.ptsNum += 1, this.updateParams(this.paramsAccOld_, rt));
      }
      if (et.rotationRate) {
        const rt = {
          x: et.rotationRate.alpha,
          y: et.rotationRate.beta,
          z: et.rotationRate.gamma
        };
        this.checkFields(rt) && (this.paramsGyroscopeOld_.ptsNum += 1, this.updateParams(this.paramsGyroscopeOld_, rt));
      }
    }, this.deviceOrientationListener = (et) => {
      const rt = {
        x: et.alpha,
        y: et.beta,
        z: et.gamma
      };
      this.checkFields(rt) && (this.paramsOrientationOld_.ptsNum += 1, this.updateParams(this.paramsOrientationOld_, rt));
    }, this.accThreshold_ = ue, this.gyroThreshold_ = Qe, this.accGrOldThreshold_ = Ue, this.accOldThreshold_ = He, this.gyroscopeOldThreshold_ = Ge, this.orientationOldThreshold_ = Xe, this.maeAccThreshold_ = Ke, this.maeGyroThreshold_ = $e, this.maeAccGrOldThreshold_ = Je, this.maeAccOldThreshold_ = Ze, this.maeGyroscopeOldThreshold_ = nt, this.maeOrientationOldThreshold_ = tt;
  }
  async requestMotionPermission() {
    DeviceMotionEvent && typeof DeviceMotionEvent.requestPermission == "function" && DeviceMotionEvent.requestPermission().then((ue) => {
      ue !== "granted" && (this.permission_ = !1);
    }).catch(console.error);
  }
  initializeAccelerometer() {
    if ("Accelerometer" in window)
      try {
        this.acl_ = new window.Accelerometer({ frequency: this.maxFrequency_ }), this.acl_.addEventListener("reading", () => this.updateAcc());
      } catch {
      }
  }
  initializeGyroscope() {
    if ("Gyroscope" in window)
      try {
        this.gyro_ = new window.Gyroscope({ frequency: this.maxFrequency_ }), this.gyro_.addEventListener("reading", () => this.updateGyro());
      } catch {
      }
  }
  async start() {
    this.run();
  }
  run() {
    if (!(this.isRunning_ || !this.permission_)) {
      try {
        this.initializeAccelerometer(), this.acl_.start();
      } catch {
      }
      try {
        this.initializeGyroscope(), this.gyro_.start();
      } catch {
      }
      window.addEventListener("devicemotion", this.deviceMotionListener), window.addEventListener(
        "deviceorientation",
        this.deviceOrientationListener
      ), this.isRunning_ = !0;
    }
  }
  stop() {
    this.isRunning_ = !1, this.acl_ && this.acl_.stop(), this.gyro_ && this.gyro_.stop(), window.removeEventListener("devicemotion", this.deviceMotionListener), window.removeEventListener(
      "deviceorientation",
      this.deviceOrientationListener
    ), this.paramsAcc_ = { ...this.emptyParams }, this.paramsGyro_ = { ...this.emptyParams }, this.paramsAccGrOld_ = { ...this.emptyParams }, this.paramsAccOld_ = { ...this.emptyParams }, this.paramsGyroscopeOld_ = { ...this.emptyParams }, this.paramsOrientationOld_ = { ...this.emptyParams };
  }
  updateAcc() {
    if (!(!this.isRunning_ || !this.acl_) && (this.paramsAcc_.ptsNum += 1, this.acl_)) {
      const ue = { x: this.acl_.x, y: this.acl_.y, z: this.acl_.z };
      this.checkFields(ue) && this.updateParams(this.paramsAcc_, ue);
    }
  }
  updateGyro() {
    if (!(!this.isRunning_ || !this.gyro_) && (this.paramsGyro_.ptsNum += 1, this.gyro_)) {
      const ue = {
        x: this.gyro_.x,
        y: this.gyro_.y,
        z: this.gyro_.z
      };
      this.checkFields(ue) && this.updateParams(this.paramsGyro_, ue);
    }
  }
  check() {
    if (!this.permission_)
      return "UNCLEAR";
    const ue = this.checkStability();
    return ue === null ? "UNCLEAR" : ue ? "FAIL" : "PASS";
  }
  checkStability() {
    if (!this.isRunning_)
      return null;
    const Qe = [
      this.gyro_ ? this.isBelowStdThreshold(this.paramsGyro_, this.gyroThreshold_) : null,
      this.acl_ ? this.isBelowStdThreshold(this.paramsAcc_, this.accThreshold_) : null,
      this.isBelowStdThreshold(this.paramsAccGrOld_, this.accGrOldThreshold_),
      this.isBelowStdThreshold(this.paramsAccOld_, this.accOldThreshold_),
      this.isBelowStdThreshold(
        this.paramsGyroscopeOld_,
        this.gyroscopeOldThreshold_
      ),
      this.isBelowStdThreshold(
        this.paramsOrientationOld_,
        this.orientationOldThreshold_
      )
    ].filter((Ke) => Ke !== null), Ue = Qe.length > 0 ? Qe.every((Ke) => Ke) : null, Ge = [
      this.gyro_ ? this.isBelowMaeThreshold(this.paramsGyro_, this.maeGyroThreshold_) : null,
      this.acl_ ? this.isBelowMaeThreshold(this.paramsAcc_, this.maeAccThreshold_) : null,
      this.isBelowMaeThreshold(
        this.paramsAccGrOld_,
        this.maeAccGrOldThreshold_
      ),
      this.isBelowMaeThreshold(this.paramsAccOld_, this.maeAccOldThreshold_),
      this.isBelowMaeThreshold(
        this.paramsGyroscopeOld_,
        this.maeGyroscopeOldThreshold_
      ),
      this.isBelowMaeThreshold(
        this.paramsOrientationOld_,
        this.maeOrientationOldThreshold_
      )
    ].filter((Ke) => Ke !== null), Xe = Ge.length > 0 ? Ge.every((Ke) => Ke) : null;
    return Ue === null ? Xe === null ? null : Xe : Xe !== null ? Ue && Xe : Ue;
  }
  updateParams(ue, Qe) {
    const Ue = Qe.x - ue.meanX, He = Qe.y - ue.meanY, Ge = Qe.z - ue.meanZ;
    ue.meanX += Ue / ue.ptsNum, ue.meanY += He / ue.ptsNum, ue.meanZ += Ge / ue.ptsNum, ue.m2X += Ue * (Qe.x - ue.meanX), ue.m2Y += He * (Qe.y - ue.meanY), ue.m2Z += Ge * (Qe.z - ue.meanZ), ue.cumulativeAbsErrorX += Math.abs(Qe.x - ue.meanX), ue.cumulativeAbsErrorY += Math.abs(Qe.y - ue.meanY), ue.cumulativeAbsErrorZ += Math.abs(Qe.z - ue.meanZ);
  }
  calculateStd(ue) {
    const Qe = {
      x: ue.m2X / ue.ptsNum,
      y: ue.m2Y / ue.ptsNum,
      z: ue.m2Z / ue.ptsNum
    };
    return {
      x: Math.sqrt(Qe.x),
      y: Math.sqrt(Qe.y),
      z: Math.sqrt(Qe.z)
    };
  }
  calculateMae(ue) {
    return {
      x: ue.cumulativeAbsErrorX / ue.ptsNum,
      y: ue.cumulativeAbsErrorY / ue.ptsNum,
      z: ue.cumulativeAbsErrorZ / ue.ptsNum
    };
  }
  checkFields(ue) {
    return ue.x !== null && ue.y !== null && ue.z !== null;
  }
  isBelowStdThreshold(ue, Qe) {
    if (ue.ptsNum < this.minNumberOfFrames_)
      return null;
    const Ue = this.calculateStd(ue);
    return Ue.x < Qe && Ue.y < Qe && Ue.z < Qe;
  }
  isBelowMaeThreshold(ue, Qe) {
    if (ue.ptsNum < this.minNumberOfFrames_)
      return null;
    const Ue = this.calculateMae(ue);
    return Ue.x < Qe && Ue.y < Qe && Ue.z < Qe;
  }
}
class OnboardingAnalytics {
  constructor() {
    this.motionStatusCheck = null, this.estimatedPerformance = null, this.analysisStatus = "", this.motionStatus = "", this.pipelineLogs = "", this.pipelinesBundle = null, this.simdIsEnabled = null, this.wasmVersion = null, this.isVirtualCameraDetectedByLabel = !1, this.motionStatusCheck = new MotionStatusCheck(
      0.3,
      0.3,
      0.3,
      0.3,
      10,
      10,
      0.3,
      0.3,
      0.3,
      0.3,
      10,
      10
    );
  }
  static getInstance() {
    return OnboardingAnalytics.instance || (OnboardingAnalytics.instance = new OnboardingAnalytics()), OnboardingAnalytics.instance;
  }
  setPipelinesBundle(ue) {
    this.pipelinesBundle = ue;
  }
  setSimdIsEnabled(ue) {
    this.simdIsEnabled = ue;
  }
  setWasmVersion(ue) {
    this.wasmVersion = ue;
  }
  getPipelineLogs() {
    return this.pipelineLogs;
  }
  getMotionStatus() {
    return this.motionStatus;
  }
  getAnalysisStatus() {
    return this.analysisStatus;
  }
  async analyzeFrame(ue) {
    const Qe = await base64ToImageData(ue);
    await MlWasmJSApi$1.analyzeFrame(Qe), this.updatePipelineStats();
  }
  /**
   * Asynchronously checks if the provided video track or any device in the system is a virtual camera.
   *
   * @param {MediaStreamTrack | null} videoTrack - The video track to inspect for a virtual camera label. If null,
   * the method checks all device capabilities instead. Defaults to null.
   * @returns {Promise<CameraLabelInspectionResult | null>} A promise that resolves to a `CameraLabelInspectionResult`
   * indicating whether a virtual camera is detected and if there was a prior detection. The promise may resolve to
   * null if the ML Wasm API is not initialized or if an exception occurs.
   */
  async checkForVirtualCameraByLabel(ue = null) {
    try {
      if (!MlWasmJSApi$1.isInitialized())
        return null;
      if (!ue) {
        const Ue = await getDeviceCapabilities();
        for (const He of Object.keys(Ue)) {
          const Ge = Ue[He];
          if (MlWasmJSApi$1.isVirtualCamera(Ge == null ? void 0 : Ge.label)) {
            const Xe = {
              isDetected: !0,
              hasPriorDetection: this.isVirtualCameraDetectedByLabel
            };
            return this.isVirtualCameraDetectedByLabel = !0, Xe;
          }
        }
      }
      const Qe = getChosenCameraInfo(ue);
      if (MlWasmJSApi$1.isVirtualCamera(Qe == null ? void 0 : Qe.label)) {
        const Ue = {
          isDetected: !0,
          hasPriorDetection: this.isVirtualCameraDetectedByLabel
        };
        return this.isVirtualCameraDetectedByLabel = !0, Ue;
      }
      return {
        isDetected: !1,
        hasPriorDetection: this.isVirtualCameraDetectedByLabel
      };
    } catch (Qe) {
      console.log(`Exception: ${Qe}`);
    }
    return null;
  }
  async startOnboardingCheck() {
    this.motionStatusCheck.start();
  }
  estimatePerformance() {
    if (this.estimatedPerformance)
      return this.estimatedPerformance;
    this.estimatedPerformance = MlWasmJSApi$1.estimatePerformance();
  }
  updatePipelineStats() {
    if (MlWasmJSApi$1.isInitialized())
      try {
        const ue = MlWasmJSApi$1.getPipelineState();
        if (ue !== "") {
          const Qe = JSON.parse(ue);
          this.analysisStatus = Qe.statsAnalysisStatus, Qe.pipelinesBundle = this.pipelinesBundle ? this.pipelinesBundle : "unknown", Qe.estimatedPerformance = this.estimatedPerformance, Qe.simdIsEnabled = this.simdIsEnabled, Qe.wasmVersion = this.wasmVersion, this.pipelineLogs = JSON.stringify(Qe), this.motionStatus === "" && (this.motionStatus = this.motionStatusCheck.check());
        }
      } catch (ue) {
        console.error(`Exception: ${ue}`);
      }
  }
}
const OnboardingAnalytics$1 = OnboardingAnalytics.getInstance();
var define_import_meta_env_default = { BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1, PACKAGE_VERSION: "1.75.1" };
class DetectionSetup {
  constructor() {
    this.setupDetectPromise = null, this.isSetupDetect = !1, this.pipelinesBundle = null, this.profiles = null;
  }
  static getInstance() {
    return DetectionSetup.instance || (DetectionSetup.instance = new DetectionSetup()), DetectionSetup.instance;
  }
  setIsIPhone14OrHigher() {
    if (!mobile.iOS())
      return;
    if (new URLSearchParams(window.location.search).get("smallFrame") === "true") {
      localStorage.setItem("isIPhone14OrHigher", "true");
      return;
    }
    localStorage.setItem(
      "isIPhone14OrHigher",
      String(
        window.outerHeight === 852 && window.outerWidth === 393 || window.outerHeight === 932 && window.outerWidth === 430 || window.innerHeight === 631 && window.innerWidth === 375
      )
    );
  }
  async setupDetect() {
    return this.setupDetectPromise ? this.setupDetectPromise : (this.setupDetectPromise = this._runSetupDetect(), this.setupDetectPromise);
  }
  getPipelinesBundle() {
    return this.pipelinesBundle;
  }
  getProfile(ue) {
    var Qe;
    return ((Qe = this.profiles) == null ? void 0 : Qe.get(ue)) ?? null;
  }
  async warmup() {
    for (; !MlWasmJSApi$1.isInitialized(); )
      await new Promise((ue) => setTimeout(ue, 100));
  }
  async _runSetupDetect() {
    var Ge, Xe, Ke;
    if (this.isSetupDetect)
      return;
    addEvent({
      token: (Ge = state.token) == null ? void 0 : Ge.token,
      code: "modelLoadStart"
    }), this.setIsIPhone14OrHigher();
    const ue = getInitializationParams(
      options.hostingApp === "Incode ID"
    );
    this.pipelinesBundle = ue.bundle, this.profiles = ue.profiles, OnboardingAnalytics$1.setPipelinesBundle(this.pipelinesBundle), OnboardingAnalytics$1.startOnboardingCheck();
    const Qe = await MlWasmJSApi$1.initialize(
      ue.wasmModulePath,
      ue.wasmSimdModulePath,
      ue.glueCodePath,
      ue.enableSIMD,
      ue.versionsFilePath,
      ue.pipelineModels
    );
    for (; !MlWasmJSApi$1.isInitialized(); )
      await new Promise(($e) => setTimeout($e, 100));
    OnboardingAnalytics$1.estimatePerformance(), OnboardingAnalytics$1.setWasmVersion(ue.wasmVersion), OnboardingAnalytics$1.setSimdIsEnabled(Qe);
    const Ue = await OnboardingAnalytics$1.checkForVirtualCameraByLabel();
    Ue != null && Ue.isDetected && !Ue.hasPriorDetection && addDeviceStats((Xe = state.token) == null ? void 0 : Xe.token, {
      cameraLabelInspectionStatus: "FAIL"
    }), await MlWasmJSApi$1.initializePipelines();
    const He = define_import_meta_env_default.VITE_WASM_PRODUCTION_MODE === "true";
    try {
      await MlWasmJSApi$1.setProductionMode(He);
    } catch ($e) {
      console.error(`Exception: ${$e}`);
    }
    this.isSetupDetect = !0, addEvent({
      token: (Ke = state.token) == null ? void 0 : Ke.token,
      code: "modelLoadEnd",
      payload: {
        loadSuccessful: !0
      }
    });
  }
}
const detectionSetup = DetectionSetup.getInstance();
function _typeof$a(me) {
  "@babel/helpers - typeof";
  return _typeof$a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ue) {
    return typeof ue;
  } : function(ue) {
    return ue && typeof Symbol == "function" && ue.constructor === Symbol && ue !== Symbol.prototype ? "symbol" : typeof ue;
  }, _typeof$a(me);
}
function _classCallCheck$m(me, ue) {
  if (!(me instanceof ue))
    throw new TypeError("Cannot call a class as a function");
}
function toPrimitive(me, ue) {
  if (_typeof$a(me) != "object" || !me) return me;
  var Qe = me[Symbol.toPrimitive];
  if (Qe !== void 0) {
    var Ue = Qe.call(me, ue || "default");
    if (_typeof$a(Ue) != "object") return Ue;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (ue === "string" ? String : Number)(me);
}
function toPropertyKey(me) {
  var ue = toPrimitive(me, "string");
  return _typeof$a(ue) == "symbol" ? ue : String(ue);
}
function _defineProperties$9(me, ue) {
  for (var Qe = 0; Qe < ue.length; Qe++) {
    var Ue = ue[Qe];
    Ue.enumerable = Ue.enumerable || !1, Ue.configurable = !0, "value" in Ue && (Ue.writable = !0), Object.defineProperty(me, toPropertyKey(Ue.key), Ue);
  }
}
function _createClass$l(me, ue, Qe) {
  return ue && _defineProperties$9(me.prototype, ue), Qe && _defineProperties$9(me, Qe), Object.defineProperty(me, "prototype", {
    writable: !1
  }), me;
}
function _assertThisInitialized$1(me) {
  if (me === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return me;
}
function _setPrototypeOf$1(me, ue) {
  return _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Ue, He) {
    return Ue.__proto__ = He, Ue;
  }, _setPrototypeOf$1(me, ue);
}
function _inherits$c(me, ue) {
  if (typeof ue != "function" && ue !== null)
    throw new TypeError("Super expression must either be null or a function");
  me.prototype = Object.create(ue && ue.prototype, {
    constructor: {
      value: me,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(me, "prototype", {
    writable: !1
  }), ue && _setPrototypeOf$1(me, ue);
}
function _possibleConstructorReturn$c(me, ue) {
  if (ue && (_typeof$a(ue) === "object" || typeof ue == "function"))
    return ue;
  if (ue !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$1(me);
}
function _getPrototypeOf$1(me) {
  return _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(Qe) {
    return Qe.__proto__ || Object.getPrototypeOf(Qe);
  }, _getPrototypeOf$1(me);
}
function _defineProperty$6(me, ue, Qe) {
  return ue = toPropertyKey(ue), ue in me ? Object.defineProperty(me, ue, {
    value: Qe,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : me[ue] = Qe, me;
}
function _arrayWithHoles$3(me) {
  if (Array.isArray(me)) return me;
}
function _iterableToArray(me) {
  if (typeof Symbol < "u" && me[Symbol.iterator] != null || me["@@iterator"] != null) return Array.from(me);
}
function _arrayLikeToArray$b(me, ue) {
  (ue == null || ue > me.length) && (ue = me.length);
  for (var Qe = 0, Ue = new Array(ue); Qe < ue; Qe++) Ue[Qe] = me[Qe];
  return Ue;
}
function _unsupportedIterableToArray$b(me, ue) {
  if (me) {
    if (typeof me == "string") return _arrayLikeToArray$b(me, ue);
    var Qe = Object.prototype.toString.call(me).slice(8, -1);
    if (Qe === "Object" && me.constructor && (Qe = me.constructor.name), Qe === "Map" || Qe === "Set") return Array.from(me);
    if (Qe === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Qe)) return _arrayLikeToArray$b(me, ue);
  }
}
function _nonIterableRest$3() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _toArray(me) {
  return _arrayWithHoles$3(me) || _iterableToArray(me) || _unsupportedIterableToArray$b(me) || _nonIterableRest$3();
}
function ownKeys$8(me, ue) {
  var Qe = Object.keys(me);
  if (Object.getOwnPropertySymbols) {
    var Ue = Object.getOwnPropertySymbols(me);
    ue && (Ue = Ue.filter(function(He) {
      return Object.getOwnPropertyDescriptor(me, He).enumerable;
    })), Qe.push.apply(Qe, Ue);
  }
  return Qe;
}
function _objectSpread$8(me) {
  for (var ue = 1; ue < arguments.length; ue++) {
    var Qe = arguments[ue] != null ? arguments[ue] : {};
    ue % 2 ? ownKeys$8(Object(Qe), !0).forEach(function(Ue) {
      _defineProperty$6(me, Ue, Qe[Ue]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(me, Object.getOwnPropertyDescriptors(Qe)) : ownKeys$8(Object(Qe)).forEach(function(Ue) {
      Object.defineProperty(me, Ue, Object.getOwnPropertyDescriptor(Qe, Ue));
    });
  }
  return me;
}
var consoleLogger = {
  type: "logger",
  log: function(ue) {
    this.output("log", ue);
  },
  warn: function(ue) {
    this.output("warn", ue);
  },
  error: function(ue) {
    this.output("error", ue);
  },
  output: function(ue, Qe) {
    console && console[ue] && console[ue].apply(console, Qe);
  }
}, Logger = function() {
  function me(ue) {
    var Qe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    _classCallCheck$m(this, me), this.init(ue, Qe);
  }
  return _createClass$l(me, [{
    key: "init",
    value: function(Qe) {
      var Ue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.prefix = Ue.prefix || "i18next:", this.logger = Qe || consoleLogger, this.options = Ue, this.debug = Ue.debug;
    }
  }, {
    key: "setDebug",
    value: function(Qe) {
      this.debug = Qe;
    }
  }, {
    key: "log",
    value: function() {
      for (var Qe = arguments.length, Ue = new Array(Qe), He = 0; He < Qe; He++)
        Ue[He] = arguments[He];
      return this.forward(Ue, "log", "", !0);
    }
  }, {
    key: "warn",
    value: function() {
      for (var Qe = arguments.length, Ue = new Array(Qe), He = 0; He < Qe; He++)
        Ue[He] = arguments[He];
      return this.forward(Ue, "warn", "", !0);
    }
  }, {
    key: "error",
    value: function() {
      for (var Qe = arguments.length, Ue = new Array(Qe), He = 0; He < Qe; He++)
        Ue[He] = arguments[He];
      return this.forward(Ue, "error", "");
    }
  }, {
    key: "deprecate",
    value: function() {
      for (var Qe = arguments.length, Ue = new Array(Qe), He = 0; He < Qe; He++)
        Ue[He] = arguments[He];
      return this.forward(Ue, "warn", "WARNING DEPRECATED: ", !0);
    }
  }, {
    key: "forward",
    value: function(Qe, Ue, He, Ge) {
      return Ge && !this.debug ? null : (typeof Qe[0] == "string" && (Qe[0] = "".concat(He).concat(this.prefix, " ").concat(Qe[0])), this.logger[Ue](Qe));
    }
  }, {
    key: "create",
    value: function(Qe) {
      return new me(this.logger, _objectSpread$8(_objectSpread$8({}, {
        prefix: "".concat(this.prefix, ":").concat(Qe, ":")
      }), this.options));
    }
  }, {
    key: "clone",
    value: function(Qe) {
      return Qe = Qe || this.options, Qe.prefix = Qe.prefix || this.prefix, new me(this.logger, Qe);
    }
  }]), me;
}(), baseLogger = new Logger(), EventEmitter$6 = function() {
  function me() {
    _classCallCheck$m(this, me), this.observers = {};
  }
  return _createClass$l(me, [{
    key: "on",
    value: function(Qe, Ue) {
      var He = this;
      return Qe.split(" ").forEach(function(Ge) {
        He.observers[Ge] = He.observers[Ge] || [], He.observers[Ge].push(Ue);
      }), this;
    }
  }, {
    key: "off",
    value: function(Qe, Ue) {
      if (this.observers[Qe]) {
        if (!Ue) {
          delete this.observers[Qe];
          return;
        }
        this.observers[Qe] = this.observers[Qe].filter(function(He) {
          return He !== Ue;
        });
      }
    }
  }, {
    key: "emit",
    value: function(Qe) {
      for (var Ue = arguments.length, He = new Array(Ue > 1 ? Ue - 1 : 0), Ge = 1; Ge < Ue; Ge++)
        He[Ge - 1] = arguments[Ge];
      if (this.observers[Qe]) {
        var Xe = [].concat(this.observers[Qe]);
        Xe.forEach(function($e) {
          $e.apply(void 0, He);
        });
      }
      if (this.observers["*"]) {
        var Ke = [].concat(this.observers["*"]);
        Ke.forEach(function($e) {
          $e.apply($e, [Qe].concat(He));
        });
      }
    }
  }]), me;
}();
function defer() {
  var me, ue, Qe = new Promise(function(Ue, He) {
    me = Ue, ue = He;
  });
  return Qe.resolve = me, Qe.reject = ue, Qe;
}
function makeString(me) {
  return me == null ? "" : "" + me;
}
function copy(me, ue, Qe) {
  me.forEach(function(Ue) {
    ue[Ue] && (Qe[Ue] = ue[Ue]);
  });
}
function getLastOfPath(me, ue, Qe) {
  function Ue(Ke) {
    return Ke && Ke.indexOf("###") > -1 ? Ke.replace(/###/g, ".") : Ke;
  }
  function He() {
    return !me || typeof me == "string";
  }
  for (var Ge = typeof ue != "string" ? [].concat(ue) : ue.split("."); Ge.length > 1; ) {
    if (He()) return {};
    var Xe = Ue(Ge.shift());
    !me[Xe] && Qe && (me[Xe] = new Qe()), Object.prototype.hasOwnProperty.call(me, Xe) ? me = me[Xe] : me = {};
  }
  return He() ? {} : {
    obj: me,
    k: Ue(Ge.shift())
  };
}
function setPath(me, ue, Qe) {
  var Ue = getLastOfPath(me, ue, Object), He = Ue.obj, Ge = Ue.k;
  He[Ge] = Qe;
}
function pushPath(me, ue, Qe, Ue) {
  var He = getLastOfPath(me, ue, Object), Ge = He.obj, Xe = He.k;
  Ge[Xe] = Ge[Xe] || [], Ge[Xe].push(Qe);
}
function getPath$1(me, ue) {
  var Qe = getLastOfPath(me, ue), Ue = Qe.obj, He = Qe.k;
  if (Ue)
    return Ue[He];
}
function getPathWithDefaults(me, ue, Qe) {
  var Ue = getPath$1(me, Qe);
  return Ue !== void 0 ? Ue : getPath$1(ue, Qe);
}
function deepExtend(me, ue, Qe) {
  for (var Ue in ue)
    Ue !== "__proto__" && Ue !== "constructor" && (Ue in me ? typeof me[Ue] == "string" || me[Ue] instanceof String || typeof ue[Ue] == "string" || ue[Ue] instanceof String ? Qe && (me[Ue] = ue[Ue]) : deepExtend(me[Ue], ue[Ue], Qe) : me[Ue] = ue[Ue]);
  return me;
}
function regexEscape(me) {
  return me.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var _entityMap = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
function escape$1(me) {
  return typeof me == "string" ? me.replace(/[&<>"'\/]/g, function(ue) {
    return _entityMap[ue];
  }) : me;
}
var isIE10 = typeof window < "u" && window.navigator && typeof window.navigator.userAgentData > "u" && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1, chars = [" ", ",", "?", "!", ";"];
function looksLikeObjectPath(me, ue, Qe) {
  ue = ue || "", Qe = Qe || "";
  var Ue = chars.filter(function(Ke) {
    return ue.indexOf(Ke) < 0 && Qe.indexOf(Ke) < 0;
  });
  if (Ue.length === 0) return !0;
  var He = new RegExp("(".concat(Ue.map(function(Ke) {
    return Ke === "?" ? "\\?" : Ke;
  }).join("|"), ")")), Ge = !He.test(me);
  if (!Ge) {
    var Xe = me.indexOf(Qe);
    Xe > 0 && !He.test(me.substring(0, Xe)) && (Ge = !0);
  }
  return Ge;
}
function ownKeys$1$1(me, ue) {
  var Qe = Object.keys(me);
  if (Object.getOwnPropertySymbols) {
    var Ue = Object.getOwnPropertySymbols(me);
    ue && (Ue = Ue.filter(function(He) {
      return Object.getOwnPropertyDescriptor(me, He).enumerable;
    })), Qe.push.apply(Qe, Ue);
  }
  return Qe;
}
function _objectSpread$1$1(me) {
  for (var ue = 1; ue < arguments.length; ue++) {
    var Qe = arguments[ue] != null ? arguments[ue] : {};
    ue % 2 ? ownKeys$1$1(Object(Qe), !0).forEach(function(Ue) {
      _defineProperty$6(me, Ue, Qe[Ue]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(me, Object.getOwnPropertyDescriptors(Qe)) : ownKeys$1$1(Object(Qe)).forEach(function(Ue) {
      Object.defineProperty(me, Ue, Object.getOwnPropertyDescriptor(Qe, Ue));
    });
  }
  return me;
}
function _createSuper$1(me) {
  var ue = _isNativeReflectConstruct$1();
  return function() {
    var Ue = _getPrototypeOf$1(me), He;
    if (ue) {
      var Ge = _getPrototypeOf$1(this).constructor;
      He = Reflect.construct(Ue, arguments, Ge);
    } else
      He = Ue.apply(this, arguments);
    return _possibleConstructorReturn$c(this, He);
  };
}
function _isNativeReflectConstruct$1() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function deepFind(me, ue) {
  var Qe = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (me) {
    if (me[ue]) return me[ue];
    for (var Ue = ue.split(Qe), He = me, Ge = 0; Ge < Ue.length; ++Ge) {
      if (!He || typeof He[Ue[Ge]] == "string" && Ge + 1 < Ue.length)
        return;
      if (He[Ue[Ge]] === void 0) {
        for (var Xe = 2, Ke = Ue.slice(Ge, Ge + Xe).join(Qe), $e = He[Ke]; $e === void 0 && Ue.length > Ge + Xe; )
          Xe++, Ke = Ue.slice(Ge, Ge + Xe).join(Qe), $e = He[Ke];
        if ($e === void 0) return;
        if ($e === null) return null;
        if (ue.endsWith(Ke)) {
          if (typeof $e == "string") return $e;
          if (Ke && typeof $e[Ke] == "string") return $e[Ke];
        }
        var Je = Ue.slice(Ge + Xe).join(Qe);
        return Je ? deepFind($e, Je, Qe) : void 0;
      }
      He = He[Ue[Ge]];
    }
    return He;
  }
}
var ResourceStore = function(me) {
  _inherits$c(Qe, me);
  var ue = _createSuper$1(Qe);
  function Qe(Ue) {
    var He, Ge = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    return _classCallCheck$m(this, Qe), He = ue.call(this), isIE10 && EventEmitter$6.call(_assertThisInitialized$1(He)), He.data = Ue || {}, He.options = Ge, He.options.keySeparator === void 0 && (He.options.keySeparator = "."), He.options.ignoreJSONStructure === void 0 && (He.options.ignoreJSONStructure = !0), He;
  }
  return _createClass$l(Qe, [{
    key: "addNamespaces",
    value: function(He) {
      this.options.ns.indexOf(He) < 0 && this.options.ns.push(He);
    }
  }, {
    key: "removeNamespaces",
    value: function(He) {
      var Ge = this.options.ns.indexOf(He);
      Ge > -1 && this.options.ns.splice(Ge, 1);
    }
  }, {
    key: "getResource",
    value: function(He, Ge, Xe) {
      var Ke = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, $e = Ke.keySeparator !== void 0 ? Ke.keySeparator : this.options.keySeparator, Je = Ke.ignoreJSONStructure !== void 0 ? Ke.ignoreJSONStructure : this.options.ignoreJSONStructure, Ze = [He, Ge];
      Xe && typeof Xe != "string" && (Ze = Ze.concat(Xe)), Xe && typeof Xe == "string" && (Ze = Ze.concat($e ? Xe.split($e) : Xe)), He.indexOf(".") > -1 && (Ze = He.split("."));
      var nt = getPath$1(this.data, Ze);
      return nt || !Je || typeof Xe != "string" ? nt : deepFind(this.data && this.data[He] && this.data[He][Ge], Xe, $e);
    }
  }, {
    key: "addResource",
    value: function(He, Ge, Xe, Ke) {
      var $e = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
        silent: !1
      }, Je = this.options.keySeparator;
      Je === void 0 && (Je = ".");
      var Ze = [He, Ge];
      Xe && (Ze = Ze.concat(Je ? Xe.split(Je) : Xe)), He.indexOf(".") > -1 && (Ze = He.split("."), Ke = Ge, Ge = Ze[1]), this.addNamespaces(Ge), setPath(this.data, Ze, Ke), $e.silent || this.emit("added", He, Ge, Xe, Ke);
    }
  }, {
    key: "addResources",
    value: function(He, Ge, Xe) {
      var Ke = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
        silent: !1
      };
      for (var $e in Xe)
        (typeof Xe[$e] == "string" || Object.prototype.toString.apply(Xe[$e]) === "[object Array]") && this.addResource(He, Ge, $e, Xe[$e], {
          silent: !0
        });
      Ke.silent || this.emit("added", He, Ge, Xe);
    }
  }, {
    key: "addResourceBundle",
    value: function(He, Ge, Xe, Ke, $e) {
      var Je = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
        silent: !1
      }, Ze = [He, Ge];
      He.indexOf(".") > -1 && (Ze = He.split("."), Ke = Xe, Xe = Ge, Ge = Ze[1]), this.addNamespaces(Ge);
      var nt = getPath$1(this.data, Ze) || {};
      Ke ? deepExtend(nt, Xe, $e) : nt = _objectSpread$1$1(_objectSpread$1$1({}, nt), Xe), setPath(this.data, Ze, nt), Je.silent || this.emit("added", He, Ge, Xe);
    }
  }, {
    key: "removeResourceBundle",
    value: function(He, Ge) {
      this.hasResourceBundle(He, Ge) && delete this.data[He][Ge], this.removeNamespaces(Ge), this.emit("removed", He, Ge);
    }
  }, {
    key: "hasResourceBundle",
    value: function(He, Ge) {
      return this.getResource(He, Ge) !== void 0;
    }
  }, {
    key: "getResourceBundle",
    value: function(He, Ge) {
      return Ge || (Ge = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? _objectSpread$1$1(_objectSpread$1$1({}, {}), this.getResource(He, Ge)) : this.getResource(He, Ge);
    }
  }, {
    key: "getDataByLanguage",
    value: function(He) {
      return this.data[He];
    }
  }, {
    key: "hasLanguageSomeTranslations",
    value: function(He) {
      var Ge = this.getDataByLanguage(He), Xe = Ge && Object.keys(Ge) || [];
      return !!Xe.find(function(Ke) {
        return Ge[Ke] && Object.keys(Ge[Ke]).length > 0;
      });
    }
  }, {
    key: "toJSON",
    value: function() {
      return this.data;
    }
  }]), Qe;
}(EventEmitter$6), postProcessor = {
  processors: {},
  addPostProcessor: function(ue) {
    this.processors[ue.name] = ue;
  },
  handle: function(ue, Qe, Ue, He, Ge) {
    var Xe = this;
    return ue.forEach(function(Ke) {
      Xe.processors[Ke] && (Qe = Xe.processors[Ke].process(Qe, Ue, He, Ge));
    }), Qe;
  }
};
function ownKeys$2$1(me, ue) {
  var Qe = Object.keys(me);
  if (Object.getOwnPropertySymbols) {
    var Ue = Object.getOwnPropertySymbols(me);
    ue && (Ue = Ue.filter(function(He) {
      return Object.getOwnPropertyDescriptor(me, He).enumerable;
    })), Qe.push.apply(Qe, Ue);
  }
  return Qe;
}
function _objectSpread$2$1(me) {
  for (var ue = 1; ue < arguments.length; ue++) {
    var Qe = arguments[ue] != null ? arguments[ue] : {};
    ue % 2 ? ownKeys$2$1(Object(Qe), !0).forEach(function(Ue) {
      _defineProperty$6(me, Ue, Qe[Ue]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(me, Object.getOwnPropertyDescriptors(Qe)) : ownKeys$2$1(Object(Qe)).forEach(function(Ue) {
      Object.defineProperty(me, Ue, Object.getOwnPropertyDescriptor(Qe, Ue));
    });
  }
  return me;
}
function _createSuper$1$1(me) {
  var ue = _isNativeReflectConstruct$1$1();
  return function() {
    var Ue = _getPrototypeOf$1(me), He;
    if (ue) {
      var Ge = _getPrototypeOf$1(this).constructor;
      He = Reflect.construct(Ue, arguments, Ge);
    } else
      He = Ue.apply(this, arguments);
    return _possibleConstructorReturn$c(this, He);
  };
}
function _isNativeReflectConstruct$1$1() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var checkedLoadedFor = {}, Translator = function(me) {
  _inherits$c(Qe, me);
  var ue = _createSuper$1$1(Qe);
  function Qe(Ue) {
    var He, Ge = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return _classCallCheck$m(this, Qe), He = ue.call(this), isIE10 && EventEmitter$6.call(_assertThisInitialized$1(He)), copy(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], Ue, _assertThisInitialized$1(He)), He.options = Ge, He.options.keySeparator === void 0 && (He.options.keySeparator = "."), He.logger = baseLogger.create("translator"), He;
  }
  return _createClass$l(Qe, [{
    key: "changeLanguage",
    value: function(He) {
      He && (this.language = He);
    }
  }, {
    key: "exists",
    value: function(He) {
      var Ge = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        interpolation: {}
      };
      if (He == null)
        return !1;
      var Xe = this.resolve(He, Ge);
      return Xe && Xe.res !== void 0;
    }
  }, {
    key: "extractFromKey",
    value: function(He, Ge) {
      var Xe = Ge.nsSeparator !== void 0 ? Ge.nsSeparator : this.options.nsSeparator;
      Xe === void 0 && (Xe = ":");
      var Ke = Ge.keySeparator !== void 0 ? Ge.keySeparator : this.options.keySeparator, $e = Ge.ns || this.options.defaultNS || [], Je = Xe && He.indexOf(Xe) > -1, Ze = !this.options.userDefinedKeySeparator && !Ge.keySeparator && !this.options.userDefinedNsSeparator && !Ge.nsSeparator && !looksLikeObjectPath(He, Xe, Ke);
      if (Je && !Ze) {
        var nt = He.match(this.interpolator.nestingRegexp);
        if (nt && nt.length > 0)
          return {
            key: He,
            namespaces: $e
          };
        var tt = He.split(Xe);
        (Xe !== Ke || Xe === Ke && this.options.ns.indexOf(tt[0]) > -1) && ($e = tt.shift()), He = tt.join(Ke);
      }
      return typeof $e == "string" && ($e = [$e]), {
        key: He,
        namespaces: $e
      };
    }
  }, {
    key: "translate",
    value: function(He, Ge, Xe) {
      var Ke = this;
      if (_typeof$a(Ge) !== "object" && this.options.overloadTranslationOptionHandler && (Ge = this.options.overloadTranslationOptionHandler(arguments)), Ge || (Ge = {}), He == null) return "";
      Array.isArray(He) || (He = [String(He)]);
      var $e = Ge.returnDetails !== void 0 ? Ge.returnDetails : this.options.returnDetails, Je = Ge.keySeparator !== void 0 ? Ge.keySeparator : this.options.keySeparator, Ze = this.extractFromKey(He[He.length - 1], Ge), nt = Ze.key, tt = Ze.namespaces, et = tt[tt.length - 1], rt = Ge.lng || this.language, it = Ge.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
      if (rt && rt.toLowerCase() === "cimode") {
        if (it) {
          var ot = Ge.nsSeparator || this.options.nsSeparator;
          return $e ? (at.res = "".concat(et).concat(ot).concat(nt), at) : "".concat(et).concat(ot).concat(nt);
        }
        return $e ? (at.res = nt, at) : nt;
      }
      var at = this.resolve(He, Ge), st = at && at.res, ut = at && at.usedKey || nt, lt = at && at.exactUsedKey || nt, dt = Object.prototype.toString.apply(st), At = ["[object Number]", "[object Function]", "[object RegExp]"], pt = Ge.joinArrays !== void 0 ? Ge.joinArrays : this.options.joinArrays, gt = !this.i18nFormat || this.i18nFormat.handleAsObject, wt = typeof st != "string" && typeof st != "boolean" && typeof st != "number";
      if (gt && st && wt && At.indexOf(dt) < 0 && !(typeof pt == "string" && dt === "[object Array]")) {
        if (!Ge.returnObjects && !this.options.returnObjects) {
          this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
          var Bt = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(ut, st, _objectSpread$2$1(_objectSpread$2$1({}, Ge), {}, {
            ns: tt
          })) : "key '".concat(nt, " (").concat(this.language, ")' returned an object instead of string.");
          return $e ? (at.res = Bt, at) : Bt;
        }
        if (Je) {
          var Tt = dt === "[object Array]", yt = Tt ? [] : {}, Ct = Tt ? lt : ut;
          for (var ht in st)
            if (Object.prototype.hasOwnProperty.call(st, ht)) {
              var It = "".concat(Ct).concat(Je).concat(ht);
              yt[ht] = this.translate(It, _objectSpread$2$1(_objectSpread$2$1({}, Ge), {
                joinArrays: !1,
                ns: tt
              })), yt[ht] === It && (yt[ht] = st[ht]);
            }
          st = yt;
        }
      } else if (gt && typeof pt == "string" && dt === "[object Array]")
        st = st.join(pt), st && (st = this.extendTranslation(st, He, Ge, Xe));
      else {
        var vt = !1, Et = !1, bt = Ge.count !== void 0 && typeof Ge.count != "string", Rt = Qe.hasDefaultValue(Ge), St = bt ? this.pluralResolver.getSuffix(rt, Ge.count, Ge) : "", kt = Ge["defaultValue".concat(St)] || Ge.defaultValue;
        !this.isValidLookup(st) && Rt && (vt = !0, st = kt), this.isValidLookup(st) || (Et = !0, st = nt);
        var jt = Ge.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey, Pt = jt && Et ? void 0 : st, Qt = Rt && kt !== st && this.options.updateMissing;
        if (Et || vt || Qt) {
          if (this.logger.log(Qt ? "updateKey" : "missingKey", rt, et, nt, Qt ? kt : st), Je) {
            var qt = this.resolve(nt, _objectSpread$2$1(_objectSpread$2$1({}, Ge), {}, {
              keySeparator: !1
            }));
            qt && qt.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
          }
          var _t = [], Yt = this.languageUtils.getFallbackCodes(this.options.fallbackLng, Ge.lng || this.language);
          if (this.options.saveMissingTo === "fallback" && Yt && Yt[0])
            for (var Xt = 0; Xt < Yt.length; Xt++)
              _t.push(Yt[Xt]);
          else this.options.saveMissingTo === "all" ? _t = this.languageUtils.toResolveHierarchy(Ge.lng || this.language) : _t.push(Ge.lng || this.language);
          var Ut = function(Ot, ft, Dt) {
            var Mt = Rt && Dt !== st ? Dt : Pt;
            Ke.options.missingKeyHandler ? Ke.options.missingKeyHandler(Ot, et, ft, Mt, Qt, Ge) : Ke.backendConnector && Ke.backendConnector.saveMissing && Ke.backendConnector.saveMissing(Ot, et, ft, Mt, Qt, Ge), Ke.emit("missingKey", Ot, et, ft, st);
          };
          this.options.saveMissing && (this.options.saveMissingPlurals && bt ? _t.forEach(function(Lt) {
            Ke.pluralResolver.getSuffixes(Lt, Ge).forEach(function(Ot) {
              Ut([Lt], nt + Ot, Ge["defaultValue".concat(Ot)] || kt);
            });
          }) : Ut(_t, nt, kt));
        }
        st = this.extendTranslation(st, He, Ge, at, Xe), Et && st === nt && this.options.appendNamespaceToMissingKey && (st = "".concat(et, ":").concat(nt)), (Et || vt) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? st = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(et, ":").concat(nt) : nt, vt ? st : void 0) : st = this.options.parseMissingKeyHandler(st));
      }
      return $e ? (at.res = st, at) : st;
    }
  }, {
    key: "extendTranslation",
    value: function(He, Ge, Xe, Ke, $e) {
      var Je = this;
      if (this.i18nFormat && this.i18nFormat.parse)
        He = this.i18nFormat.parse(He, _objectSpread$2$1(_objectSpread$2$1({}, this.options.interpolation.defaultVariables), Xe), Ke.usedLng, Ke.usedNS, Ke.usedKey, {
          resolved: Ke
        });
      else if (!Xe.skipInterpolation) {
        Xe.interpolation && this.interpolator.init(_objectSpread$2$1(_objectSpread$2$1({}, Xe), {
          interpolation: _objectSpread$2$1(_objectSpread$2$1({}, this.options.interpolation), Xe.interpolation)
        }));
        var Ze = typeof He == "string" && (Xe && Xe.interpolation && Xe.interpolation.skipOnVariables !== void 0 ? Xe.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables), nt;
        if (Ze) {
          var tt = He.match(this.interpolator.nestingRegexp);
          nt = tt && tt.length;
        }
        var et = Xe.replace && typeof Xe.replace != "string" ? Xe.replace : Xe;
        if (this.options.interpolation.defaultVariables && (et = _objectSpread$2$1(_objectSpread$2$1({}, this.options.interpolation.defaultVariables), et)), He = this.interpolator.interpolate(He, et, Xe.lng || this.language, Xe), Ze) {
          var rt = He.match(this.interpolator.nestingRegexp), it = rt && rt.length;
          nt < it && (Xe.nest = !1);
        }
        Xe.nest !== !1 && (He = this.interpolator.nest(He, function() {
          for (var st = arguments.length, ut = new Array(st), lt = 0; lt < st; lt++)
            ut[lt] = arguments[lt];
          return $e && $e[0] === ut[0] && !Xe.context ? (Je.logger.warn("It seems you are nesting recursively key: ".concat(ut[0], " in key: ").concat(Ge[0])), null) : Je.translate.apply(Je, ut.concat([Ge]));
        }, Xe)), Xe.interpolation && this.interpolator.reset();
      }
      var ot = Xe.postProcess || this.options.postProcess, at = typeof ot == "string" ? [ot] : ot;
      return He != null && at && at.length && Xe.applyPostProcessor !== !1 && (He = postProcessor.handle(at, He, Ge, this.options && this.options.postProcessPassResolved ? _objectSpread$2$1({
        i18nResolved: Ke
      }, Xe) : Xe, this)), He;
    }
  }, {
    key: "resolve",
    value: function(He) {
      var Ge = this, Xe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Ke, $e, Je, Ze, nt;
      return typeof He == "string" && (He = [He]), He.forEach(function(tt) {
        if (!Ge.isValidLookup(Ke)) {
          var et = Ge.extractFromKey(tt, Xe), rt = et.key;
          $e = rt;
          var it = et.namespaces;
          Ge.options.fallbackNS && (it = it.concat(Ge.options.fallbackNS));
          var ot = Xe.count !== void 0 && typeof Xe.count != "string", at = ot && !Xe.ordinal && Xe.count === 0 && Ge.pluralResolver.shouldUseIntlApi(), st = Xe.context !== void 0 && (typeof Xe.context == "string" || typeof Xe.context == "number") && Xe.context !== "", ut = Xe.lngs ? Xe.lngs : Ge.languageUtils.toResolveHierarchy(Xe.lng || Ge.language, Xe.fallbackLng);
          it.forEach(function(lt) {
            Ge.isValidLookup(Ke) || (nt = lt, !checkedLoadedFor["".concat(ut[0], "-").concat(lt)] && Ge.utils && Ge.utils.hasLoadedNamespace && !Ge.utils.hasLoadedNamespace(nt) && (checkedLoadedFor["".concat(ut[0], "-").concat(lt)] = !0, Ge.logger.warn('key "'.concat($e, '" for languages "').concat(ut.join(", "), `" won't get resolved as namespace "`).concat(nt, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), ut.forEach(function(dt) {
              if (!Ge.isValidLookup(Ke)) {
                Ze = dt;
                var At = [rt];
                if (Ge.i18nFormat && Ge.i18nFormat.addLookupKeys)
                  Ge.i18nFormat.addLookupKeys(At, rt, dt, lt, Xe);
                else {
                  var pt;
                  ot && (pt = Ge.pluralResolver.getSuffix(dt, Xe.count, Xe));
                  var gt = "".concat(Ge.options.pluralSeparator, "zero");
                  if (ot && (At.push(rt + pt), at && At.push(rt + gt)), st) {
                    var wt = "".concat(rt).concat(Ge.options.contextSeparator).concat(Xe.context);
                    At.push(wt), ot && (At.push(wt + pt), at && At.push(wt + gt));
                  }
                }
                for (var Bt; Bt = At.pop(); )
                  Ge.isValidLookup(Ke) || (Je = Bt, Ke = Ge.getResource(dt, lt, Bt, Xe));
              }
            }));
          });
        }
      }), {
        res: Ke,
        usedKey: $e,
        exactUsedKey: Je,
        usedLng: Ze,
        usedNS: nt
      };
    }
  }, {
    key: "isValidLookup",
    value: function(He) {
      return He !== void 0 && !(!this.options.returnNull && He === null) && !(!this.options.returnEmptyString && He === "");
    }
  }, {
    key: "getResource",
    value: function(He, Ge, Xe) {
      var Ke = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(He, Ge, Xe, Ke) : this.resourceStore.getResource(He, Ge, Xe, Ke);
    }
  }], [{
    key: "hasDefaultValue",
    value: function(He) {
      var Ge = "defaultValue";
      for (var Xe in He)
        if (Object.prototype.hasOwnProperty.call(He, Xe) && Ge === Xe.substring(0, Ge.length) && He[Xe] !== void 0)
          return !0;
      return !1;
    }
  }]), Qe;
}(EventEmitter$6);
function capitalize(me) {
  return me.charAt(0).toUpperCase() + me.slice(1);
}
var LanguageUtil = function() {
  function me(ue) {
    _classCallCheck$m(this, me), this.options = ue, this.supportedLngs = this.options.supportedLngs || !1, this.logger = baseLogger.create("languageUtils");
  }
  return _createClass$l(me, [{
    key: "getScriptPartFromCode",
    value: function(Qe) {
      if (!Qe || Qe.indexOf("-") < 0) return null;
      var Ue = Qe.split("-");
      return Ue.length === 2 || (Ue.pop(), Ue[Ue.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(Ue.join("-"));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function(Qe) {
      if (!Qe || Qe.indexOf("-") < 0) return Qe;
      var Ue = Qe.split("-");
      return this.formatLanguageCode(Ue[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function(Qe) {
      if (typeof Qe == "string" && Qe.indexOf("-") > -1) {
        var Ue = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"], He = Qe.split("-");
        return this.options.lowerCaseLng ? He = He.map(function(Ge) {
          return Ge.toLowerCase();
        }) : He.length === 2 ? (He[0] = He[0].toLowerCase(), He[1] = He[1].toUpperCase(), Ue.indexOf(He[1].toLowerCase()) > -1 && (He[1] = capitalize(He[1].toLowerCase()))) : He.length === 3 && (He[0] = He[0].toLowerCase(), He[1].length === 2 && (He[1] = He[1].toUpperCase()), He[0] !== "sgn" && He[2].length === 2 && (He[2] = He[2].toUpperCase()), Ue.indexOf(He[1].toLowerCase()) > -1 && (He[1] = capitalize(He[1].toLowerCase())), Ue.indexOf(He[2].toLowerCase()) > -1 && (He[2] = capitalize(He[2].toLowerCase()))), He.join("-");
      }
      return this.options.cleanCode || this.options.lowerCaseLng ? Qe.toLowerCase() : Qe;
    }
  }, {
    key: "isSupportedCode",
    value: function(Qe) {
      return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (Qe = this.getLanguagePartFromCode(Qe)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(Qe) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function(Qe) {
      var Ue = this;
      if (!Qe) return null;
      var He;
      return Qe.forEach(function(Ge) {
        if (!He) {
          var Xe = Ue.formatLanguageCode(Ge);
          (!Ue.options.supportedLngs || Ue.isSupportedCode(Xe)) && (He = Xe);
        }
      }), !He && this.options.supportedLngs && Qe.forEach(function(Ge) {
        if (!He) {
          var Xe = Ue.getLanguagePartFromCode(Ge);
          if (Ue.isSupportedCode(Xe)) return He = Xe;
          He = Ue.options.supportedLngs.find(function(Ke) {
            if (Ke.indexOf(Xe) === 0) return Ke;
          });
        }
      }), He || (He = this.getFallbackCodes(this.options.fallbackLng)[0]), He;
    }
  }, {
    key: "getFallbackCodes",
    value: function(Qe, Ue) {
      if (!Qe) return [];
      if (typeof Qe == "function" && (Qe = Qe(Ue)), typeof Qe == "string" && (Qe = [Qe]), Object.prototype.toString.apply(Qe) === "[object Array]") return Qe;
      if (!Ue) return Qe.default || [];
      var He = Qe[Ue];
      return He || (He = Qe[this.getScriptPartFromCode(Ue)]), He || (He = Qe[this.formatLanguageCode(Ue)]), He || (He = Qe[this.getLanguagePartFromCode(Ue)]), He || (He = Qe.default), He || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function(Qe, Ue) {
      var He = this, Ge = this.getFallbackCodes(Ue || this.options.fallbackLng || [], Qe), Xe = [], Ke = function(Je) {
        Je && (He.isSupportedCode(Je) ? Xe.push(Je) : He.logger.warn("rejecting language code not found in supportedLngs: ".concat(Je)));
      };
      return typeof Qe == "string" && Qe.indexOf("-") > -1 ? (this.options.load !== "languageOnly" && Ke(this.formatLanguageCode(Qe)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && Ke(this.getScriptPartFromCode(Qe)), this.options.load !== "currentOnly" && Ke(this.getLanguagePartFromCode(Qe))) : typeof Qe == "string" && Ke(this.formatLanguageCode(Qe)), Ge.forEach(function($e) {
        Xe.indexOf($e) < 0 && Ke(He.formatLanguageCode($e));
      }), Xe;
    }
  }]), me;
}(), sets = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], _rulesPluralsTypes = {
  1: function(ue) {
    return +(ue > 1);
  },
  2: function(ue) {
    return +(ue != 1);
  },
  3: function(ue) {
    return 0;
  },
  4: function(ue) {
    return ue % 10 == 1 && ue % 100 != 11 ? 0 : ue % 10 >= 2 && ue % 10 <= 4 && (ue % 100 < 10 || ue % 100 >= 20) ? 1 : 2;
  },
  5: function(ue) {
    return ue == 0 ? 0 : ue == 1 ? 1 : ue == 2 ? 2 : ue % 100 >= 3 && ue % 100 <= 10 ? 3 : ue % 100 >= 11 ? 4 : 5;
  },
  6: function(ue) {
    return ue == 1 ? 0 : ue >= 2 && ue <= 4 ? 1 : 2;
  },
  7: function(ue) {
    return ue == 1 ? 0 : ue % 10 >= 2 && ue % 10 <= 4 && (ue % 100 < 10 || ue % 100 >= 20) ? 1 : 2;
  },
  8: function(ue) {
    return ue == 1 ? 0 : ue == 2 ? 1 : ue != 8 && ue != 11 ? 2 : 3;
  },
  9: function(ue) {
    return +(ue >= 2);
  },
  10: function(ue) {
    return ue == 1 ? 0 : ue == 2 ? 1 : ue < 7 ? 2 : ue < 11 ? 3 : 4;
  },
  11: function(ue) {
    return ue == 1 || ue == 11 ? 0 : ue == 2 || ue == 12 ? 1 : ue > 2 && ue < 20 ? 2 : 3;
  },
  12: function(ue) {
    return +(ue % 10 != 1 || ue % 100 == 11);
  },
  13: function(ue) {
    return +(ue !== 0);
  },
  14: function(ue) {
    return ue == 1 ? 0 : ue == 2 ? 1 : ue == 3 ? 2 : 3;
  },
  15: function(ue) {
    return ue % 10 == 1 && ue % 100 != 11 ? 0 : ue % 10 >= 2 && (ue % 100 < 10 || ue % 100 >= 20) ? 1 : 2;
  },
  16: function(ue) {
    return ue % 10 == 1 && ue % 100 != 11 ? 0 : ue !== 0 ? 1 : 2;
  },
  17: function(ue) {
    return ue == 1 || ue % 10 == 1 && ue % 100 != 11 ? 0 : 1;
  },
  18: function(ue) {
    return ue == 0 ? 0 : ue == 1 ? 1 : 2;
  },
  19: function(ue) {
    return ue == 1 ? 0 : ue == 0 || ue % 100 > 1 && ue % 100 < 11 ? 1 : ue % 100 > 10 && ue % 100 < 20 ? 2 : 3;
  },
  20: function(ue) {
    return ue == 1 ? 0 : ue == 0 || ue % 100 > 0 && ue % 100 < 20 ? 1 : 2;
  },
  21: function(ue) {
    return ue % 100 == 1 ? 1 : ue % 100 == 2 ? 2 : ue % 100 == 3 || ue % 100 == 4 ? 3 : 0;
  },
  22: function(ue) {
    return ue == 1 ? 0 : ue == 2 ? 1 : (ue < 0 || ue > 10) && ue % 10 == 0 ? 2 : 3;
  }
}, deprecatedJsonVersions = ["v1", "v2", "v3"], suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function createRules() {
  var me = {};
  return sets.forEach(function(ue) {
    ue.lngs.forEach(function(Qe) {
      me[Qe] = {
        numbers: ue.nr,
        plurals: _rulesPluralsTypes[ue.fc]
      };
    });
  }), me;
}
var PluralResolver = function() {
  function me(ue) {
    var Qe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    _classCallCheck$m(this, me), this.languageUtils = ue, this.options = Qe, this.logger = baseLogger.create("pluralResolver"), (!this.options.compatibilityJSON || this.options.compatibilityJSON === "v4") && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = createRules();
  }
  return _createClass$l(me, [{
    key: "addRule",
    value: function(Qe, Ue) {
      this.rules[Qe] = Ue;
    }
  }, {
    key: "getRule",
    value: function(Qe) {
      var Ue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (this.shouldUseIntlApi())
        try {
          return new Intl.PluralRules(Qe, {
            type: Ue.ordinal ? "ordinal" : "cardinal"
          });
        } catch {
          return;
        }
      return this.rules[Qe] || this.rules[this.languageUtils.getLanguagePartFromCode(Qe)];
    }
  }, {
    key: "needsPlural",
    value: function(Qe) {
      var Ue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, He = this.getRule(Qe, Ue);
      return this.shouldUseIntlApi() ? He && He.resolvedOptions().pluralCategories.length > 1 : He && He.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function(Qe, Ue) {
      var He = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return this.getSuffixes(Qe, He).map(function(Ge) {
        return "".concat(Ue).concat(Ge);
      });
    }
  }, {
    key: "getSuffixes",
    value: function(Qe) {
      var Ue = this, He = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Ge = this.getRule(Qe, He);
      return Ge ? this.shouldUseIntlApi() ? Ge.resolvedOptions().pluralCategories.sort(function(Xe, Ke) {
        return suffixesOrder[Xe] - suffixesOrder[Ke];
      }).map(function(Xe) {
        return "".concat(Ue.options.prepend).concat(Xe);
      }) : Ge.numbers.map(function(Xe) {
        return Ue.getSuffix(Qe, Xe, He);
      }) : [];
    }
  }, {
    key: "getSuffix",
    value: function(Qe, Ue) {
      var He = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, Ge = this.getRule(Qe, He);
      return Ge ? this.shouldUseIntlApi() ? "".concat(this.options.prepend).concat(Ge.select(Ue)) : this.getSuffixRetroCompatible(Ge, Ue) : (this.logger.warn("no plural rule found for: ".concat(Qe)), "");
    }
  }, {
    key: "getSuffixRetroCompatible",
    value: function(Qe, Ue) {
      var He = this, Ge = Qe.noAbs ? Qe.plurals(Ue) : Qe.plurals(Math.abs(Ue)), Xe = Qe.numbers[Ge];
      this.options.simplifyPluralSuffix && Qe.numbers.length === 2 && Qe.numbers[0] === 1 && (Xe === 2 ? Xe = "plural" : Xe === 1 && (Xe = ""));
      var Ke = function() {
        return He.options.prepend && Xe.toString() ? He.options.prepend + Xe.toString() : Xe.toString();
      };
      return this.options.compatibilityJSON === "v1" ? Xe === 1 ? "" : typeof Xe == "number" ? "_plural_".concat(Xe.toString()) : Ke() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && Qe.numbers.length === 2 && Qe.numbers[0] === 1 ? Ke() : this.options.prepend && Ge.toString() ? this.options.prepend + Ge.toString() : Ge.toString();
    }
  }, {
    key: "shouldUseIntlApi",
    value: function() {
      return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
    }
  }]), me;
}();
function ownKeys$3$1(me, ue) {
  var Qe = Object.keys(me);
  if (Object.getOwnPropertySymbols) {
    var Ue = Object.getOwnPropertySymbols(me);
    ue && (Ue = Ue.filter(function(He) {
      return Object.getOwnPropertyDescriptor(me, He).enumerable;
    })), Qe.push.apply(Qe, Ue);
  }
  return Qe;
}
function _objectSpread$3$1(me) {
  for (var ue = 1; ue < arguments.length; ue++) {
    var Qe = arguments[ue] != null ? arguments[ue] : {};
    ue % 2 ? ownKeys$3$1(Object(Qe), !0).forEach(function(Ue) {
      _defineProperty$6(me, Ue, Qe[Ue]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(me, Object.getOwnPropertyDescriptors(Qe)) : ownKeys$3$1(Object(Qe)).forEach(function(Ue) {
      Object.defineProperty(me, Ue, Object.getOwnPropertyDescriptor(Qe, Ue));
    });
  }
  return me;
}
var Interpolator = function() {
  function me() {
    var ue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck$m(this, me), this.logger = baseLogger.create("interpolator"), this.options = ue, this.format = ue.interpolation && ue.interpolation.format || function(Qe) {
      return Qe;
    }, this.init(ue);
  }
  return _createClass$l(me, [{
    key: "init",
    value: function() {
      var Qe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      Qe.interpolation || (Qe.interpolation = {
        escapeValue: !0
      });
      var Ue = Qe.interpolation;
      this.escape = Ue.escape !== void 0 ? Ue.escape : escape$1, this.escapeValue = Ue.escapeValue !== void 0 ? Ue.escapeValue : !0, this.useRawValueToEscape = Ue.useRawValueToEscape !== void 0 ? Ue.useRawValueToEscape : !1, this.prefix = Ue.prefix ? regexEscape(Ue.prefix) : Ue.prefixEscaped || "{{", this.suffix = Ue.suffix ? regexEscape(Ue.suffix) : Ue.suffixEscaped || "}}", this.formatSeparator = Ue.formatSeparator ? Ue.formatSeparator : Ue.formatSeparator || ",", this.unescapePrefix = Ue.unescapeSuffix ? "" : Ue.unescapePrefix || "-", this.unescapeSuffix = this.unescapePrefix ? "" : Ue.unescapeSuffix || "", this.nestingPrefix = Ue.nestingPrefix ? regexEscape(Ue.nestingPrefix) : Ue.nestingPrefixEscaped || regexEscape("$t("), this.nestingSuffix = Ue.nestingSuffix ? regexEscape(Ue.nestingSuffix) : Ue.nestingSuffixEscaped || regexEscape(")"), this.nestingOptionsSeparator = Ue.nestingOptionsSeparator ? Ue.nestingOptionsSeparator : Ue.nestingOptionsSeparator || ",", this.maxReplaces = Ue.maxReplaces ? Ue.maxReplaces : 1e3, this.alwaysFormat = Ue.alwaysFormat !== void 0 ? Ue.alwaysFormat : !1, this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function() {
      this.options && this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function() {
      var Qe = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(Qe, "g");
      var Ue = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(Ue, "g");
      var He = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(He, "g");
    }
  }, {
    key: "interpolate",
    value: function(Qe, Ue, He, Ge) {
      var Xe = this, Ke, $e, Je, Ze = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
      function nt(ot) {
        return ot.replace(/\$/g, "$$$$");
      }
      var tt = function(at) {
        if (at.indexOf(Xe.formatSeparator) < 0) {
          var st = getPathWithDefaults(Ue, Ze, at);
          return Xe.alwaysFormat ? Xe.format(st, void 0, He, _objectSpread$3$1(_objectSpread$3$1(_objectSpread$3$1({}, Ge), Ue), {}, {
            interpolationkey: at
          })) : st;
        }
        var ut = at.split(Xe.formatSeparator), lt = ut.shift().trim(), dt = ut.join(Xe.formatSeparator).trim();
        return Xe.format(getPathWithDefaults(Ue, Ze, lt), dt, He, _objectSpread$3$1(_objectSpread$3$1(_objectSpread$3$1({}, Ge), Ue), {}, {
          interpolationkey: lt
        }));
      };
      this.resetRegExp();
      var et = Ge && Ge.missingInterpolationHandler || this.options.missingInterpolationHandler, rt = Ge && Ge.interpolation && Ge.interpolation.skipOnVariables !== void 0 ? Ge.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables, it = [{
        regex: this.regexpUnescape,
        safeValue: function(at) {
          return nt(at);
        }
      }, {
        regex: this.regexp,
        safeValue: function(at) {
          return Xe.escapeValue ? nt(Xe.escape(at)) : nt(at);
        }
      }];
      return it.forEach(function(ot) {
        for (Je = 0; Ke = ot.regex.exec(Qe); ) {
          var at = Ke[1].trim();
          if ($e = tt(at), $e === void 0)
            if (typeof et == "function") {
              var st = et(Qe, Ke, Ge);
              $e = typeof st == "string" ? st : "";
            } else if (Ge && Ge.hasOwnProperty(at))
              $e = "";
            else if (rt) {
              $e = Ke[0];
              continue;
            } else
              Xe.logger.warn("missed to pass in variable ".concat(at, " for interpolating ").concat(Qe)), $e = "";
          else typeof $e != "string" && !Xe.useRawValueToEscape && ($e = makeString($e));
          var ut = ot.safeValue($e);
          if (Qe = Qe.replace(Ke[0], ut), rt ? (ot.regex.lastIndex += $e.length, ot.regex.lastIndex -= Ke[0].length) : ot.regex.lastIndex = 0, Je++, Je >= Xe.maxReplaces)
            break;
        }
      }), Qe;
    }
  }, {
    key: "nest",
    value: function(Qe, Ue) {
      var He = this, Ge = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, Xe, Ke, $e = _objectSpread$3$1({}, Ge);
      $e.applyPostProcessor = !1, delete $e.defaultValue;
      function Je(et, rt) {
        var it = this.nestingOptionsSeparator;
        if (et.indexOf(it) < 0) return et;
        var ot = et.split(new RegExp("".concat(it, "[ ]*{"))), at = "{".concat(ot[1]);
        et = ot[0], at = this.interpolate(at, $e);
        var st = at.match(/'/g), ut = at.match(/"/g);
        (st && st.length % 2 === 0 && !ut || ut.length % 2 !== 0) && (at = at.replace(/'/g, '"'));
        try {
          $e = JSON.parse(at), rt && ($e = _objectSpread$3$1(_objectSpread$3$1({}, rt), $e));
        } catch (lt) {
          return this.logger.warn("failed parsing options string in nesting for key ".concat(et), lt), "".concat(et).concat(it).concat(at);
        }
        return delete $e.defaultValue, et;
      }
      for (; Xe = this.nestingRegexp.exec(Qe); ) {
        var Ze = [], nt = !1;
        if (Xe[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(Xe[1])) {
          var tt = Xe[1].split(this.formatSeparator).map(function(et) {
            return et.trim();
          });
          Xe[1] = tt.shift(), Ze = tt, nt = !0;
        }
        if (Ke = Ue(Je.call(this, Xe[1].trim(), $e), $e), Ke && Xe[0] === Qe && typeof Ke != "string") return Ke;
        typeof Ke != "string" && (Ke = makeString(Ke)), Ke || (this.logger.warn("missed to resolve ".concat(Xe[1], " for nesting ").concat(Qe)), Ke = ""), nt && (Ke = Ze.reduce(function(et, rt) {
          return He.format(et, rt, Ge.lng, _objectSpread$3$1(_objectSpread$3$1({}, Ge), {}, {
            interpolationkey: Xe[1].trim()
          }));
        }, Ke.trim())), Qe = Qe.replace(Xe[0], Ke), this.regexp.lastIndex = 0;
      }
      return Qe;
    }
  }]), me;
}();
function ownKeys$4$1(me, ue) {
  var Qe = Object.keys(me);
  if (Object.getOwnPropertySymbols) {
    var Ue = Object.getOwnPropertySymbols(me);
    ue && (Ue = Ue.filter(function(He) {
      return Object.getOwnPropertyDescriptor(me, He).enumerable;
    })), Qe.push.apply(Qe, Ue);
  }
  return Qe;
}
function _objectSpread$4$1(me) {
  for (var ue = 1; ue < arguments.length; ue++) {
    var Qe = arguments[ue] != null ? arguments[ue] : {};
    ue % 2 ? ownKeys$4$1(Object(Qe), !0).forEach(function(Ue) {
      _defineProperty$6(me, Ue, Qe[Ue]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(me, Object.getOwnPropertyDescriptors(Qe)) : ownKeys$4$1(Object(Qe)).forEach(function(Ue) {
      Object.defineProperty(me, Ue, Object.getOwnPropertyDescriptor(Qe, Ue));
    });
  }
  return me;
}
function parseFormatStr(me) {
  var ue = me.toLowerCase().trim(), Qe = {};
  if (me.indexOf("(") > -1) {
    var Ue = me.split("(");
    ue = Ue[0].toLowerCase().trim();
    var He = Ue[1].substring(0, Ue[1].length - 1);
    if (ue === "currency" && He.indexOf(":") < 0)
      Qe.currency || (Qe.currency = He.trim());
    else if (ue === "relativetime" && He.indexOf(":") < 0)
      Qe.range || (Qe.range = He.trim());
    else {
      var Ge = He.split(";");
      Ge.forEach(function(Xe) {
        if (Xe) {
          var Ke = Xe.split(":"), $e = _toArray(Ke), Je = $e[0], Ze = $e.slice(1), nt = Ze.join(":").trim().replace(/^'+|'+$/g, "");
          Qe[Je.trim()] || (Qe[Je.trim()] = nt), nt === "false" && (Qe[Je.trim()] = !1), nt === "true" && (Qe[Je.trim()] = !0), isNaN(nt) || (Qe[Je.trim()] = parseInt(nt, 10));
        }
      });
    }
  }
  return {
    formatName: ue,
    formatOptions: Qe
  };
}
function createCachedFormatter(me) {
  var ue = {};
  return function(Ue, He, Ge) {
    var Xe = He + JSON.stringify(Ge), Ke = ue[Xe];
    return Ke || (Ke = me(He, Ge), ue[Xe] = Ke), Ke(Ue);
  };
}
var Formatter$1 = function() {
  function me() {
    var ue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck$m(this, me), this.logger = baseLogger.create("formatter"), this.options = ue, this.formats = {
      number: createCachedFormatter(function(Qe, Ue) {
        var He = new Intl.NumberFormat(Qe, Ue);
        return function(Ge) {
          return He.format(Ge);
        };
      }),
      currency: createCachedFormatter(function(Qe, Ue) {
        var He = new Intl.NumberFormat(Qe, _objectSpread$4$1(_objectSpread$4$1({}, Ue), {}, {
          style: "currency"
        }));
        return function(Ge) {
          return He.format(Ge);
        };
      }),
      datetime: createCachedFormatter(function(Qe, Ue) {
        var He = new Intl.DateTimeFormat(Qe, _objectSpread$4$1({}, Ue));
        return function(Ge) {
          return He.format(Ge);
        };
      }),
      relativetime: createCachedFormatter(function(Qe, Ue) {
        var He = new Intl.RelativeTimeFormat(Qe, _objectSpread$4$1({}, Ue));
        return function(Ge) {
          return He.format(Ge, Ue.range || "day");
        };
      }),
      list: createCachedFormatter(function(Qe, Ue) {
        var He = new Intl.ListFormat(Qe, _objectSpread$4$1({}, Ue));
        return function(Ge) {
          return He.format(Ge);
        };
      })
    }, this.init(ue);
  }
  return _createClass$l(me, [{
    key: "init",
    value: function(Qe) {
      var Ue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        interpolation: {}
      }, He = Ue.interpolation;
      this.formatSeparator = He.formatSeparator ? He.formatSeparator : He.formatSeparator || ",";
    }
  }, {
    key: "add",
    value: function(Qe, Ue) {
      this.formats[Qe.toLowerCase().trim()] = Ue;
    }
  }, {
    key: "addCached",
    value: function(Qe, Ue) {
      this.formats[Qe.toLowerCase().trim()] = createCachedFormatter(Ue);
    }
  }, {
    key: "format",
    value: function(Qe, Ue, He, Ge) {
      var Xe = this, Ke = Ue.split(this.formatSeparator), $e = Ke.reduce(function(Je, Ze) {
        var nt = parseFormatStr(Ze), tt = nt.formatName, et = nt.formatOptions;
        if (Xe.formats[tt]) {
          var rt = Je;
          try {
            var it = Ge && Ge.formatParams && Ge.formatParams[Ge.interpolationkey] || {}, ot = it.locale || it.lng || Ge.locale || Ge.lng || He;
            rt = Xe.formats[tt](Je, ot, _objectSpread$4$1(_objectSpread$4$1(_objectSpread$4$1({}, et), Ge), it));
          } catch (at) {
            Xe.logger.warn(at);
          }
          return rt;
        } else
          Xe.logger.warn("there was no format function for ".concat(tt));
        return Je;
      }, Qe);
      return $e;
    }
  }]), me;
}();
function ownKeys$5$1(me, ue) {
  var Qe = Object.keys(me);
  if (Object.getOwnPropertySymbols) {
    var Ue = Object.getOwnPropertySymbols(me);
    ue && (Ue = Ue.filter(function(He) {
      return Object.getOwnPropertyDescriptor(me, He).enumerable;
    })), Qe.push.apply(Qe, Ue);
  }
  return Qe;
}
function _objectSpread$5$1(me) {
  for (var ue = 1; ue < arguments.length; ue++) {
    var Qe = arguments[ue] != null ? arguments[ue] : {};
    ue % 2 ? ownKeys$5$1(Object(Qe), !0).forEach(function(Ue) {
      _defineProperty$6(me, Ue, Qe[Ue]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(me, Object.getOwnPropertyDescriptors(Qe)) : ownKeys$5$1(Object(Qe)).forEach(function(Ue) {
      Object.defineProperty(me, Ue, Object.getOwnPropertyDescriptor(Qe, Ue));
    });
  }
  return me;
}
function _createSuper$2(me) {
  var ue = _isNativeReflectConstruct$2();
  return function() {
    var Ue = _getPrototypeOf$1(me), He;
    if (ue) {
      var Ge = _getPrototypeOf$1(this).constructor;
      He = Reflect.construct(Ue, arguments, Ge);
    } else
      He = Ue.apply(this, arguments);
    return _possibleConstructorReturn$c(this, He);
  };
}
function _isNativeReflectConstruct$2() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function removePending(me, ue) {
  me.pending[ue] !== void 0 && (delete me.pending[ue], me.pendingCount--);
}
var Connector = function(me) {
  _inherits$c(Qe, me);
  var ue = _createSuper$2(Qe);
  function Qe(Ue, He, Ge) {
    var Xe, Ke = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return _classCallCheck$m(this, Qe), Xe = ue.call(this), isIE10 && EventEmitter$6.call(_assertThisInitialized$1(Xe)), Xe.backend = Ue, Xe.store = He, Xe.services = Ge, Xe.languageUtils = Ge.languageUtils, Xe.options = Ke, Xe.logger = baseLogger.create("backendConnector"), Xe.waitingReads = [], Xe.maxParallelReads = Ke.maxParallelReads || 10, Xe.readingCalls = 0, Xe.maxRetries = Ke.maxRetries >= 0 ? Ke.maxRetries : 5, Xe.retryTimeout = Ke.retryTimeout >= 1 ? Ke.retryTimeout : 350, Xe.state = {}, Xe.queue = [], Xe.backend && Xe.backend.init && Xe.backend.init(Ge, Ke.backend, Ke), Xe;
  }
  return _createClass$l(Qe, [{
    key: "queueLoad",
    value: function(He, Ge, Xe, Ke) {
      var $e = this, Je = {}, Ze = {}, nt = {}, tt = {};
      return He.forEach(function(et) {
        var rt = !0;
        Ge.forEach(function(it) {
          var ot = "".concat(et, "|").concat(it);
          !Xe.reload && $e.store.hasResourceBundle(et, it) ? $e.state[ot] = 2 : $e.state[ot] < 0 || ($e.state[ot] === 1 ? Ze[ot] === void 0 && (Ze[ot] = !0) : ($e.state[ot] = 1, rt = !1, Ze[ot] === void 0 && (Ze[ot] = !0), Je[ot] === void 0 && (Je[ot] = !0), tt[it] === void 0 && (tt[it] = !0)));
        }), rt || (nt[et] = !0);
      }), (Object.keys(Je).length || Object.keys(Ze).length) && this.queue.push({
        pending: Ze,
        pendingCount: Object.keys(Ze).length,
        loaded: {},
        errors: [],
        callback: Ke
      }), {
        toLoad: Object.keys(Je),
        pending: Object.keys(Ze),
        toLoadLanguages: Object.keys(nt),
        toLoadNamespaces: Object.keys(tt)
      };
    }
  }, {
    key: "loaded",
    value: function(He, Ge, Xe) {
      var Ke = He.split("|"), $e = Ke[0], Je = Ke[1];
      Ge && this.emit("failedLoading", $e, Je, Ge), Xe && this.store.addResourceBundle($e, Je, Xe), this.state[He] = Ge ? -1 : 2;
      var Ze = {};
      this.queue.forEach(function(nt) {
        pushPath(nt.loaded, [$e], Je), removePending(nt, He), Ge && nt.errors.push(Ge), nt.pendingCount === 0 && !nt.done && (Object.keys(nt.loaded).forEach(function(tt) {
          Ze[tt] || (Ze[tt] = {});
          var et = nt.loaded[tt];
          et.length && et.forEach(function(rt) {
            Ze[tt][rt] === void 0 && (Ze[tt][rt] = !0);
          });
        }), nt.done = !0, nt.errors.length ? nt.callback(nt.errors) : nt.callback());
      }), this.emit("loaded", Ze), this.queue = this.queue.filter(function(nt) {
        return !nt.done;
      });
    }
  }, {
    key: "read",
    value: function(He, Ge, Xe) {
      var Ke = this, $e = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, Je = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, Ze = arguments.length > 5 ? arguments[5] : void 0;
      if (!He.length) return Ze(null, {});
      if (this.readingCalls >= this.maxParallelReads) {
        this.waitingReads.push({
          lng: He,
          ns: Ge,
          fcName: Xe,
          tried: $e,
          wait: Je,
          callback: Ze
        });
        return;
      }
      return this.readingCalls++, this.backend[Xe](He, Ge, function(nt, tt) {
        if (Ke.readingCalls--, Ke.waitingReads.length > 0) {
          var et = Ke.waitingReads.shift();
          Ke.read(et.lng, et.ns, et.fcName, et.tried, et.wait, et.callback);
        }
        if (nt && tt && $e < Ke.maxRetries) {
          setTimeout(function() {
            Ke.read.call(Ke, He, Ge, Xe, $e + 1, Je * 2, Ze);
          }, Je);
          return;
        }
        Ze(nt, tt);
      });
    }
  }, {
    key: "prepareLoading",
    value: function(He, Ge) {
      var Xe = this, Ke = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, $e = arguments.length > 3 ? arguments[3] : void 0;
      if (!this.backend)
        return this.logger.warn("No backend was added via i18next.use. Will not load resources."), $e && $e();
      typeof He == "string" && (He = this.languageUtils.toResolveHierarchy(He)), typeof Ge == "string" && (Ge = [Ge]);
      var Je = this.queueLoad(He, Ge, Ke, $e);
      if (!Je.toLoad.length)
        return Je.pending.length || $e(), null;
      Je.toLoad.forEach(function(Ze) {
        Xe.loadOne(Ze);
      });
    }
  }, {
    key: "load",
    value: function(He, Ge, Xe) {
      this.prepareLoading(He, Ge, {}, Xe);
    }
  }, {
    key: "reload",
    value: function(He, Ge, Xe) {
      this.prepareLoading(He, Ge, {
        reload: !0
      }, Xe);
    }
  }, {
    key: "loadOne",
    value: function(He) {
      var Ge = this, Xe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", Ke = He.split("|"), $e = Ke[0], Je = Ke[1];
      this.read($e, Je, "read", void 0, void 0, function(Ze, nt) {
        Ze && Ge.logger.warn("".concat(Xe, "loading namespace ").concat(Je, " for language ").concat($e, " failed"), Ze), !Ze && nt && Ge.logger.log("".concat(Xe, "loaded namespace ").concat(Je, " for language ").concat($e), nt), Ge.loaded(He, Ze, nt);
      });
    }
  }, {
    key: "saveMissing",
    value: function(He, Ge, Xe, Ke, $e) {
      var Je = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(Ge)) {
        this.logger.warn('did not save key "'.concat(Xe, '" as the namespace "').concat(Ge, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
        return;
      }
      Xe == null || Xe === "" || (this.backend && this.backend.create && this.backend.create(He, Ge, Xe, Ke, null, _objectSpread$5$1(_objectSpread$5$1({}, Je), {}, {
        isUpdate: $e
      })), !(!He || !He[0]) && this.store.addResource(He[0], Ge, Xe, Ke));
    }
  }]), Qe;
}(EventEmitter$6);
function get$1() {
  return {
    debug: !1,
    initImmediate: !0,
    ns: ["translation"],
    defaultNS: ["translation"],
    fallbackLng: ["dev"],
    fallbackNS: !1,
    supportedLngs: !1,
    nonExplicitSupportedLngs: !1,
    load: "all",
    preload: !1,
    simplifyPluralSuffix: !0,
    keySeparator: ".",
    nsSeparator: ":",
    pluralSeparator: "_",
    contextSeparator: "_",
    partialBundledLanguages: !1,
    saveMissing: !1,
    updateMissing: !1,
    saveMissingTo: "fallback",
    saveMissingPlurals: !0,
    missingKeyHandler: !1,
    missingInterpolationHandler: !1,
    postProcess: !1,
    postProcessPassResolved: !1,
    returnNull: !0,
    returnEmptyString: !0,
    returnObjects: !1,
    joinArrays: !1,
    returnedObjectHandler: !1,
    parseMissingKeyHandler: !1,
    appendNamespaceToMissingKey: !1,
    appendNamespaceToCIMode: !1,
    overloadTranslationOptionHandler: function(ue) {
      var Qe = {};
      if (_typeof$a(ue[1]) === "object" && (Qe = ue[1]), typeof ue[1] == "string" && (Qe.defaultValue = ue[1]), typeof ue[2] == "string" && (Qe.tDescription = ue[2]), _typeof$a(ue[2]) === "object" || _typeof$a(ue[3]) === "object") {
        var Ue = ue[3] || ue[2];
        Object.keys(Ue).forEach(function(He) {
          Qe[He] = Ue[He];
        });
      }
      return Qe;
    },
    interpolation: {
      escapeValue: !0,
      format: function(ue, Qe, Ue, He) {
        return ue;
      },
      prefix: "{{",
      suffix: "}}",
      formatSeparator: ",",
      unescapePrefix: "-",
      nestingPrefix: "$t(",
      nestingSuffix: ")",
      nestingOptionsSeparator: ",",
      maxReplaces: 1e3,
      skipOnVariables: !0
    }
  };
}
function transformOptions(me) {
  return typeof me.ns == "string" && (me.ns = [me.ns]), typeof me.fallbackLng == "string" && (me.fallbackLng = [me.fallbackLng]), typeof me.fallbackNS == "string" && (me.fallbackNS = [me.fallbackNS]), me.supportedLngs && me.supportedLngs.indexOf("cimode") < 0 && (me.supportedLngs = me.supportedLngs.concat(["cimode"])), me;
}
function ownKeys$6$1(me, ue) {
  var Qe = Object.keys(me);
  if (Object.getOwnPropertySymbols) {
    var Ue = Object.getOwnPropertySymbols(me);
    ue && (Ue = Ue.filter(function(He) {
      return Object.getOwnPropertyDescriptor(me, He).enumerable;
    })), Qe.push.apply(Qe, Ue);
  }
  return Qe;
}
function _objectSpread$6$1(me) {
  for (var ue = 1; ue < arguments.length; ue++) {
    var Qe = arguments[ue] != null ? arguments[ue] : {};
    ue % 2 ? ownKeys$6$1(Object(Qe), !0).forEach(function(Ue) {
      _defineProperty$6(me, Ue, Qe[Ue]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(me, Object.getOwnPropertyDescriptors(Qe)) : ownKeys$6$1(Object(Qe)).forEach(function(Ue) {
      Object.defineProperty(me, Ue, Object.getOwnPropertyDescriptor(Qe, Ue));
    });
  }
  return me;
}
function _createSuper$3(me) {
  var ue = _isNativeReflectConstruct$3();
  return function() {
    var Ue = _getPrototypeOf$1(me), He;
    if (ue) {
      var Ge = _getPrototypeOf$1(this).constructor;
      He = Reflect.construct(Ue, arguments, Ge);
    } else
      He = Ue.apply(this, arguments);
    return _possibleConstructorReturn$c(this, He);
  };
}
function _isNativeReflectConstruct$3() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function noop$1() {
}
function bindMemberFunctions(me) {
  var ue = Object.getOwnPropertyNames(Object.getPrototypeOf(me));
  ue.forEach(function(Qe) {
    typeof me[Qe] == "function" && (me[Qe] = me[Qe].bind(me));
  });
}
var I18n = function(me) {
  _inherits$c(Qe, me);
  var ue = _createSuper$3(Qe);
  function Qe() {
    var Ue, He = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Ge = arguments.length > 1 ? arguments[1] : void 0;
    if (_classCallCheck$m(this, Qe), Ue = ue.call(this), isIE10 && EventEmitter$6.call(_assertThisInitialized$1(Ue)), Ue.options = transformOptions(He), Ue.services = {}, Ue.logger = baseLogger, Ue.modules = {
      external: []
    }, bindMemberFunctions(_assertThisInitialized$1(Ue)), Ge && !Ue.isInitialized && !He.isClone) {
      if (!Ue.options.initImmediate)
        return Ue.init(He, Ge), _possibleConstructorReturn$c(Ue, _assertThisInitialized$1(Ue));
      setTimeout(function() {
        Ue.init(He, Ge);
      }, 0);
    }
    return Ue;
  }
  return _createClass$l(Qe, [{
    key: "init",
    value: function() {
      var He = this, Ge = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Xe = arguments.length > 1 ? arguments[1] : void 0;
      typeof Ge == "function" && (Xe = Ge, Ge = {}), !Ge.defaultNS && Ge.defaultNS !== !1 && Ge.ns && (typeof Ge.ns == "string" ? Ge.defaultNS = Ge.ns : Ge.ns.indexOf("translation") < 0 && (Ge.defaultNS = Ge.ns[0]));
      var Ke = get$1();
      this.options = _objectSpread$6$1(_objectSpread$6$1(_objectSpread$6$1({}, Ke), this.options), transformOptions(Ge)), this.options.compatibilityAPI !== "v1" && (this.options.interpolation = _objectSpread$6$1(_objectSpread$6$1({}, Ke.interpolation), this.options.interpolation)), Ge.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = Ge.keySeparator), Ge.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = Ge.nsSeparator);
      function $e(at) {
        return at ? typeof at == "function" ? new at() : at : null;
      }
      if (!this.options.isClone) {
        this.modules.logger ? baseLogger.init($e(this.modules.logger), this.options) : baseLogger.init(null, this.options);
        var Je;
        this.modules.formatter ? Je = this.modules.formatter : typeof Intl < "u" && (Je = Formatter$1);
        var Ze = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var nt = this.services;
        nt.logger = baseLogger, nt.resourceStore = this.store, nt.languageUtils = Ze, nt.pluralResolver = new PluralResolver(Ze, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        }), Je && (!this.options.interpolation.format || this.options.interpolation.format === Ke.interpolation.format) && (nt.formatter = $e(Je), nt.formatter.init(nt, this.options), this.options.interpolation.format = nt.formatter.format.bind(nt.formatter)), nt.interpolator = new Interpolator(this.options), nt.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        }, nt.backendConnector = new Connector($e(this.modules.backend), nt.resourceStore, nt, this.options), nt.backendConnector.on("*", function(at) {
          for (var st = arguments.length, ut = new Array(st > 1 ? st - 1 : 0), lt = 1; lt < st; lt++)
            ut[lt - 1] = arguments[lt];
          He.emit.apply(He, [at].concat(ut));
        }), this.modules.languageDetector && (nt.languageDetector = $e(this.modules.languageDetector), nt.languageDetector.init(nt, this.options.detection, this.options)), this.modules.i18nFormat && (nt.i18nFormat = $e(this.modules.i18nFormat), nt.i18nFormat.init && nt.i18nFormat.init(this)), this.translator = new Translator(this.services, this.options), this.translator.on("*", function(at) {
          for (var st = arguments.length, ut = new Array(st > 1 ? st - 1 : 0), lt = 1; lt < st; lt++)
            ut[lt - 1] = arguments[lt];
          He.emit.apply(He, [at].concat(ut));
        }), this.modules.external.forEach(function(at) {
          at.init && at.init(He);
        });
      }
      if (this.format = this.options.interpolation.format, Xe || (Xe = noop$1), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var tt = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        tt.length > 0 && tt[0] !== "dev" && (this.options.lng = tt[0]);
      }
      !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined");
      var et = ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"];
      et.forEach(function(at) {
        He[at] = function() {
          var st;
          return (st = He.store)[at].apply(st, arguments);
        };
      });
      var rt = ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"];
      rt.forEach(function(at) {
        He[at] = function() {
          var st;
          return (st = He.store)[at].apply(st, arguments), He;
        };
      });
      var it = defer(), ot = function() {
        var st = function(lt, dt) {
          He.isInitialized && !He.initializedStoreOnce && He.logger.warn("init: i18next is already initialized. You should call init just once!"), He.isInitialized = !0, He.options.isClone || He.logger.log("initialized", He.options), He.emit("initialized", He.options), it.resolve(dt), Xe(lt, dt);
        };
        if (He.languages && He.options.compatibilityAPI !== "v1" && !He.isInitialized) return st(null, He.t.bind(He));
        He.changeLanguage(He.options.lng, st);
      };
      return this.options.resources || !this.options.initImmediate ? ot() : setTimeout(ot, 0), it;
    }
  }, {
    key: "loadResources",
    value: function(He) {
      var Ge = this, Xe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop$1, Ke = Xe, $e = typeof He == "string" ? He : this.language;
      if (typeof He == "function" && (Ke = He), !this.options.resources || this.options.partialBundledLanguages) {
        if ($e && $e.toLowerCase() === "cimode") return Ke();
        var Je = [], Ze = function(et) {
          if (et) {
            var rt = Ge.services.languageUtils.toResolveHierarchy(et);
            rt.forEach(function(it) {
              Je.indexOf(it) < 0 && Je.push(it);
            });
          }
        };
        if ($e)
          Ze($e);
        else {
          var nt = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          nt.forEach(function(tt) {
            return Ze(tt);
          });
        }
        this.options.preload && this.options.preload.forEach(function(tt) {
          return Ze(tt);
        }), this.services.backendConnector.load(Je, this.options.ns, function(tt) {
          !tt && !Ge.resolvedLanguage && Ge.language && Ge.setResolvedLanguage(Ge.language), Ke(tt);
        });
      } else
        Ke(null);
    }
  }, {
    key: "reloadResources",
    value: function(He, Ge, Xe) {
      var Ke = defer();
      return He || (He = this.languages), Ge || (Ge = this.options.ns), Xe || (Xe = noop$1), this.services.backendConnector.reload(He, Ge, function($e) {
        Ke.resolve(), Xe($e);
      }), Ke;
    }
  }, {
    key: "use",
    value: function(He) {
      if (!He) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
      if (!He.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
      return He.type === "backend" && (this.modules.backend = He), (He.type === "logger" || He.log && He.warn && He.error) && (this.modules.logger = He), He.type === "languageDetector" && (this.modules.languageDetector = He), He.type === "i18nFormat" && (this.modules.i18nFormat = He), He.type === "postProcessor" && postProcessor.addPostProcessor(He), He.type === "formatter" && (this.modules.formatter = He), He.type === "3rdParty" && this.modules.external.push(He), this;
    }
  }, {
    key: "setResolvedLanguage",
    value: function(He) {
      if (!(!He || !this.languages) && !(["cimode", "dev"].indexOf(He) > -1))
        for (var Ge = 0; Ge < this.languages.length; Ge++) {
          var Xe = this.languages[Ge];
          if (!(["cimode", "dev"].indexOf(Xe) > -1) && this.store.hasLanguageSomeTranslations(Xe)) {
            this.resolvedLanguage = Xe;
            break;
          }
        }
    }
  }, {
    key: "changeLanguage",
    value: function(He, Ge) {
      var Xe = this;
      this.isLanguageChangingTo = He;
      var Ke = defer();
      this.emit("languageChanging", He);
      var $e = function(tt) {
        Xe.language = tt, Xe.languages = Xe.services.languageUtils.toResolveHierarchy(tt), Xe.resolvedLanguage = void 0, Xe.setResolvedLanguage(tt);
      }, Je = function(tt, et) {
        et ? ($e(et), Xe.translator.changeLanguage(et), Xe.isLanguageChangingTo = void 0, Xe.emit("languageChanged", et), Xe.logger.log("languageChanged", et)) : Xe.isLanguageChangingTo = void 0, Ke.resolve(function() {
          return Xe.t.apply(Xe, arguments);
        }), Ge && Ge(tt, function() {
          return Xe.t.apply(Xe, arguments);
        });
      }, Ze = function(tt) {
        !He && !tt && Xe.services.languageDetector && (tt = []);
        var et = typeof tt == "string" ? tt : Xe.services.languageUtils.getBestMatchFromCodes(tt);
        et && (Xe.language || $e(et), Xe.translator.language || Xe.translator.changeLanguage(et), Xe.services.languageDetector && Xe.services.languageDetector.cacheUserLanguage(et)), Xe.loadResources(et, function(rt) {
          Je(rt, et);
        });
      };
      return !He && this.services.languageDetector && !this.services.languageDetector.async ? Ze(this.services.languageDetector.detect()) : !He && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect(Ze) : Ze(He), Ke;
    }
  }, {
    key: "getFixedT",
    value: function(He, Ge, Xe) {
      var Ke = this, $e = function Je(Ze, nt) {
        var tt;
        if (_typeof$a(nt) !== "object") {
          for (var et = arguments.length, rt = new Array(et > 2 ? et - 2 : 0), it = 2; it < et; it++)
            rt[it - 2] = arguments[it];
          tt = Ke.options.overloadTranslationOptionHandler([Ze, nt].concat(rt));
        } else
          tt = _objectSpread$6$1({}, nt);
        tt.lng = tt.lng || Je.lng, tt.lngs = tt.lngs || Je.lngs, tt.ns = tt.ns || Je.ns, tt.keyPrefix = tt.keyPrefix || Xe || Je.keyPrefix;
        var ot = Ke.options.keySeparator || ".", at = tt.keyPrefix ? "".concat(tt.keyPrefix).concat(ot).concat(Ze) : Ze;
        return Ke.t(at, tt);
      };
      return typeof He == "string" ? $e.lng = He : $e.lngs = He, $e.ns = Ge, $e.keyPrefix = Xe, $e;
    }
  }, {
    key: "t",
    value: function() {
      var He;
      return this.translator && (He = this.translator).translate.apply(He, arguments);
    }
  }, {
    key: "exists",
    value: function() {
      var He;
      return this.translator && (He = this.translator).exists.apply(He, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function(He) {
      this.options.defaultNS = He;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function(He) {
      var Ge = this, Xe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (!this.isInitialized)
        return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
      if (!this.languages || !this.languages.length)
        return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
      var Ke = this.resolvedLanguage || this.languages[0], $e = this.options ? this.options.fallbackLng : !1, Je = this.languages[this.languages.length - 1];
      if (Ke.toLowerCase() === "cimode") return !0;
      var Ze = function(et, rt) {
        var it = Ge.services.backendConnector.state["".concat(et, "|").concat(rt)];
        return it === -1 || it === 2;
      };
      if (Xe.precheck) {
        var nt = Xe.precheck(this, Ze);
        if (nt !== void 0) return nt;
      }
      return !!(this.hasResourceBundle(Ke, He) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || Ze(Ke, He) && (!$e || Ze(Je, He)));
    }
  }, {
    key: "loadNamespaces",
    value: function(He, Ge) {
      var Xe = this, Ke = defer();
      return this.options.ns ? (typeof He == "string" && (He = [He]), He.forEach(function($e) {
        Xe.options.ns.indexOf($e) < 0 && Xe.options.ns.push($e);
      }), this.loadResources(function($e) {
        Ke.resolve(), Ge && Ge($e);
      }), Ke) : (Ge && Ge(), Promise.resolve());
    }
  }, {
    key: "loadLanguages",
    value: function(He, Ge) {
      var Xe = defer();
      typeof He == "string" && (He = [He]);
      var Ke = this.options.preload || [], $e = He.filter(function(Je) {
        return Ke.indexOf(Je) < 0;
      });
      return $e.length ? (this.options.preload = Ke.concat($e), this.loadResources(function(Je) {
        Xe.resolve(), Ge && Ge(Je);
      }), Xe) : (Ge && Ge(), Promise.resolve());
    }
  }, {
    key: "dir",
    value: function(He) {
      if (He || (He = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !He) return "rtl";
      var Ge = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"];
      return Ge.indexOf(this.services.languageUtils.getLanguagePartFromCode(He)) > -1 || He.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
    }
  }, {
    key: "cloneInstance",
    value: function() {
      var He = this, Ge = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Xe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop$1, Ke = _objectSpread$6$1(_objectSpread$6$1(_objectSpread$6$1({}, this.options), Ge), {
        isClone: !0
      }), $e = new Qe(Ke);
      (Ge.debug !== void 0 || Ge.prefix !== void 0) && ($e.logger = $e.logger.clone(Ge));
      var Je = ["store", "services", "language"];
      return Je.forEach(function(Ze) {
        $e[Ze] = He[Ze];
      }), $e.services = _objectSpread$6$1({}, this.services), $e.services.utils = {
        hasLoadedNamespace: $e.hasLoadedNamespace.bind($e)
      }, $e.translator = new Translator($e.services, $e.options), $e.translator.on("*", function(Ze) {
        for (var nt = arguments.length, tt = new Array(nt > 1 ? nt - 1 : 0), et = 1; et < nt; et++)
          tt[et - 1] = arguments[et];
        $e.emit.apply($e, [Ze].concat(tt));
      }), $e.init(Ke, Xe), $e.translator.options = $e.options, $e.translator.backendConnector.services.utils = {
        hasLoadedNamespace: $e.hasLoadedNamespace.bind($e)
      }, $e;
    }
  }, {
    key: "toJSON",
    value: function() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }]), Qe;
}(EventEmitter$6);
_defineProperty$6(I18n, "createInstance", function() {
  var me = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ue = arguments.length > 1 ? arguments[1] : void 0;
  return new I18n(me, ue);
});
var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;
instance.createInstance;
instance.init;
instance.loadResources;
instance.reloadResources;
instance.use;
instance.changeLanguage;
instance.getFixedT;
instance.t;
instance.exists;
instance.setDefaultNamespace;
instance.hasLoadedNamespace;
instance.loadNamespaces;
instance.loadLanguages;
function _typeof$9(me) {
  "@babel/helpers - typeof";
  return _typeof$9 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ue) {
    return typeof ue;
  } : function(ue) {
    return ue && typeof Symbol == "function" && ue.constructor === Symbol && ue !== Symbol.prototype ? "symbol" : typeof ue;
  }, _typeof$9(me);
}
var arr$1 = [], each$1 = arr$1.forEach, slice$1 = arr$1.slice;
function defaults$6(me) {
  return each$1.call(slice$1.call(arguments, 1), function(ue) {
    if (ue)
      for (var Qe in ue)
        me[Qe] === void 0 && (me[Qe] = ue[Qe]);
  }), me;
}
function hasXMLHttpRequest() {
  return typeof XMLHttpRequest == "function" || (typeof XMLHttpRequest > "u" ? "undefined" : _typeof$9(XMLHttpRequest)) === "object";
}
function isPromise(me) {
  return !!me && typeof me.then == "function";
}
function makePromise(me) {
  return isPromise(me) ? me : Promise.resolve(me);
}
function commonjsRequire(me) {
  throw new Error('Could not dynamically require "' + me + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var getFetch$1 = { exports: {} }, browserPonyfill = { exports: {} }, hasRequiredBrowserPonyfill;
function requireBrowserPonyfill() {
  return hasRequiredBrowserPonyfill || (hasRequiredBrowserPonyfill = 1, function(me, ue) {
    var Qe = typeof self < "u" ? self : commonjsGlobal, Ue = function() {
      function Ge() {
        this.fetch = !1, this.DOMException = Qe.DOMException;
      }
      return Ge.prototype = Qe, new Ge();
    }();
    (function(Ge) {
      (function(Xe) {
        var Ke = {
          searchParams: "URLSearchParams" in Ge,
          iterable: "Symbol" in Ge && "iterator" in Symbol,
          blob: "FileReader" in Ge && "Blob" in Ge && function() {
            try {
              return new Blob(), !0;
            } catch {
              return !1;
            }
          }(),
          formData: "FormData" in Ge,
          arrayBuffer: "ArrayBuffer" in Ge
        };
        function $e(ht) {
          return ht && DataView.prototype.isPrototypeOf(ht);
        }
        if (Ke.arrayBuffer)
          var Je = [
            "[object Int8Array]",
            "[object Uint8Array]",
            "[object Uint8ClampedArray]",
            "[object Int16Array]",
            "[object Uint16Array]",
            "[object Int32Array]",
            "[object Uint32Array]",
            "[object Float32Array]",
            "[object Float64Array]"
          ], Ze = ArrayBuffer.isView || function(ht) {
            return ht && Je.indexOf(Object.prototype.toString.call(ht)) > -1;
          };
        function nt(ht) {
          if (typeof ht != "string" && (ht = String(ht)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(ht))
            throw new TypeError("Invalid character in header field name");
          return ht.toLowerCase();
        }
        function tt(ht) {
          return typeof ht != "string" && (ht = String(ht)), ht;
        }
        function et(ht) {
          var It = {
            next: function() {
              var vt = ht.shift();
              return { done: vt === void 0, value: vt };
            }
          };
          return Ke.iterable && (It[Symbol.iterator] = function() {
            return It;
          }), It;
        }
        function rt(ht) {
          this.map = {}, ht instanceof rt ? ht.forEach(function(It, vt) {
            this.append(vt, It);
          }, this) : Array.isArray(ht) ? ht.forEach(function(It) {
            this.append(It[0], It[1]);
          }, this) : ht && Object.getOwnPropertyNames(ht).forEach(function(It) {
            this.append(It, ht[It]);
          }, this);
        }
        rt.prototype.append = function(ht, It) {
          ht = nt(ht), It = tt(It);
          var vt = this.map[ht];
          this.map[ht] = vt ? vt + ", " + It : It;
        }, rt.prototype.delete = function(ht) {
          delete this.map[nt(ht)];
        }, rt.prototype.get = function(ht) {
          return ht = nt(ht), this.has(ht) ? this.map[ht] : null;
        }, rt.prototype.has = function(ht) {
          return this.map.hasOwnProperty(nt(ht));
        }, rt.prototype.set = function(ht, It) {
          this.map[nt(ht)] = tt(It);
        }, rt.prototype.forEach = function(ht, It) {
          for (var vt in this.map)
            this.map.hasOwnProperty(vt) && ht.call(It, this.map[vt], vt, this);
        }, rt.prototype.keys = function() {
          var ht = [];
          return this.forEach(function(It, vt) {
            ht.push(vt);
          }), et(ht);
        }, rt.prototype.values = function() {
          var ht = [];
          return this.forEach(function(It) {
            ht.push(It);
          }), et(ht);
        }, rt.prototype.entries = function() {
          var ht = [];
          return this.forEach(function(It, vt) {
            ht.push([vt, It]);
          }), et(ht);
        }, Ke.iterable && (rt.prototype[Symbol.iterator] = rt.prototype.entries);
        function it(ht) {
          if (ht.bodyUsed)
            return Promise.reject(new TypeError("Already read"));
          ht.bodyUsed = !0;
        }
        function ot(ht) {
          return new Promise(function(It, vt) {
            ht.onload = function() {
              It(ht.result);
            }, ht.onerror = function() {
              vt(ht.error);
            };
          });
        }
        function at(ht) {
          var It = new FileReader(), vt = ot(It);
          return It.readAsArrayBuffer(ht), vt;
        }
        function st(ht) {
          var It = new FileReader(), vt = ot(It);
          return It.readAsText(ht), vt;
        }
        function ut(ht) {
          for (var It = new Uint8Array(ht), vt = new Array(It.length), Et = 0; Et < It.length; Et++)
            vt[Et] = String.fromCharCode(It[Et]);
          return vt.join("");
        }
        function lt(ht) {
          if (ht.slice)
            return ht.slice(0);
          var It = new Uint8Array(ht.byteLength);
          return It.set(new Uint8Array(ht)), It.buffer;
        }
        function dt() {
          return this.bodyUsed = !1, this._initBody = function(ht) {
            this._bodyInit = ht, ht ? typeof ht == "string" ? this._bodyText = ht : Ke.blob && Blob.prototype.isPrototypeOf(ht) ? this._bodyBlob = ht : Ke.formData && FormData.prototype.isPrototypeOf(ht) ? this._bodyFormData = ht : Ke.searchParams && URLSearchParams.prototype.isPrototypeOf(ht) ? this._bodyText = ht.toString() : Ke.arrayBuffer && Ke.blob && $e(ht) ? (this._bodyArrayBuffer = lt(ht.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : Ke.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(ht) || Ze(ht)) ? this._bodyArrayBuffer = lt(ht) : this._bodyText = ht = Object.prototype.toString.call(ht) : this._bodyText = "", this.headers.get("content-type") || (typeof ht == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : Ke.searchParams && URLSearchParams.prototype.isPrototypeOf(ht) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
          }, Ke.blob && (this.blob = function() {
            var ht = it(this);
            if (ht)
              return ht;
            if (this._bodyBlob)
              return Promise.resolve(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as blob");
            return Promise.resolve(new Blob([this._bodyText]));
          }, this.arrayBuffer = function() {
            return this._bodyArrayBuffer ? it(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(at);
          }), this.text = function() {
            var ht = it(this);
            if (ht)
              return ht;
            if (this._bodyBlob)
              return st(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(ut(this._bodyArrayBuffer));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as text");
            return Promise.resolve(this._bodyText);
          }, Ke.formData && (this.formData = function() {
            return this.text().then(wt);
          }), this.json = function() {
            return this.text().then(JSON.parse);
          }, this;
        }
        var At = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
        function pt(ht) {
          var It = ht.toUpperCase();
          return At.indexOf(It) > -1 ? It : ht;
        }
        function gt(ht, It) {
          It = It || {};
          var vt = It.body;
          if (ht instanceof gt) {
            if (ht.bodyUsed)
              throw new TypeError("Already read");
            this.url = ht.url, this.credentials = ht.credentials, It.headers || (this.headers = new rt(ht.headers)), this.method = ht.method, this.mode = ht.mode, this.signal = ht.signal, !vt && ht._bodyInit != null && (vt = ht._bodyInit, ht.bodyUsed = !0);
          } else
            this.url = String(ht);
          if (this.credentials = It.credentials || this.credentials || "same-origin", (It.headers || !this.headers) && (this.headers = new rt(It.headers)), this.method = pt(It.method || this.method || "GET"), this.mode = It.mode || this.mode || null, this.signal = It.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && vt)
            throw new TypeError("Body not allowed for GET or HEAD requests");
          this._initBody(vt);
        }
        gt.prototype.clone = function() {
          return new gt(this, { body: this._bodyInit });
        };
        function wt(ht) {
          var It = new FormData();
          return ht.trim().split("&").forEach(function(vt) {
            if (vt) {
              var Et = vt.split("="), bt = Et.shift().replace(/\+/g, " "), Rt = Et.join("=").replace(/\+/g, " ");
              It.append(decodeURIComponent(bt), decodeURIComponent(Rt));
            }
          }), It;
        }
        function Bt(ht) {
          var It = new rt(), vt = ht.replace(/\r?\n[\t ]+/g, " ");
          return vt.split(/\r?\n/).forEach(function(Et) {
            var bt = Et.split(":"), Rt = bt.shift().trim();
            if (Rt) {
              var St = bt.join(":").trim();
              It.append(Rt, St);
            }
          }), It;
        }
        dt.call(gt.prototype);
        function Tt(ht, It) {
          It || (It = {}), this.type = "default", this.status = It.status === void 0 ? 200 : It.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in It ? It.statusText : "OK", this.headers = new rt(It.headers), this.url = It.url || "", this._initBody(ht);
        }
        dt.call(Tt.prototype), Tt.prototype.clone = function() {
          return new Tt(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new rt(this.headers),
            url: this.url
          });
        }, Tt.error = function() {
          var ht = new Tt(null, { status: 0, statusText: "" });
          return ht.type = "error", ht;
        };
        var yt = [301, 302, 303, 307, 308];
        Tt.redirect = function(ht, It) {
          if (yt.indexOf(It) === -1)
            throw new RangeError("Invalid status code");
          return new Tt(null, { status: It, headers: { location: ht } });
        }, Xe.DOMException = Ge.DOMException;
        try {
          new Xe.DOMException();
        } catch {
          Xe.DOMException = function(It, vt) {
            this.message = It, this.name = vt;
            var Et = Error(It);
            this.stack = Et.stack;
          }, Xe.DOMException.prototype = Object.create(Error.prototype), Xe.DOMException.prototype.constructor = Xe.DOMException;
        }
        function Ct(ht, It) {
          return new Promise(function(vt, Et) {
            var bt = new gt(ht, It);
            if (bt.signal && bt.signal.aborted)
              return Et(new Xe.DOMException("Aborted", "AbortError"));
            var Rt = new XMLHttpRequest();
            function St() {
              Rt.abort();
            }
            Rt.onload = function() {
              var kt = {
                status: Rt.status,
                statusText: Rt.statusText,
                headers: Bt(Rt.getAllResponseHeaders() || "")
              };
              kt.url = "responseURL" in Rt ? Rt.responseURL : kt.headers.get("X-Request-URL");
              var jt = "response" in Rt ? Rt.response : Rt.responseText;
              vt(new Tt(jt, kt));
            }, Rt.onerror = function() {
              Et(new TypeError("Network request failed"));
            }, Rt.ontimeout = function() {
              Et(new TypeError("Network request failed"));
            }, Rt.onabort = function() {
              Et(new Xe.DOMException("Aborted", "AbortError"));
            }, Rt.open(bt.method, bt.url, !0), bt.credentials === "include" ? Rt.withCredentials = !0 : bt.credentials === "omit" && (Rt.withCredentials = !1), "responseType" in Rt && Ke.blob && (Rt.responseType = "blob"), bt.headers.forEach(function(kt, jt) {
              Rt.setRequestHeader(jt, kt);
            }), bt.signal && (bt.signal.addEventListener("abort", St), Rt.onreadystatechange = function() {
              Rt.readyState === 4 && bt.signal.removeEventListener("abort", St);
            }), Rt.send(typeof bt._bodyInit > "u" ? null : bt._bodyInit);
          });
        }
        return Ct.polyfill = !0, Ge.fetch || (Ge.fetch = Ct, Ge.Headers = rt, Ge.Request = gt, Ge.Response = Tt), Xe.Headers = rt, Xe.Request = gt, Xe.Response = Tt, Xe.fetch = Ct, Object.defineProperty(Xe, "__esModule", { value: !0 }), Xe;
      })({});
    })(Ue), Ue.fetch.ponyfill = !0, delete Ue.fetch.polyfill;
    var He = Ue;
    ue = He.fetch, ue.default = He.fetch, ue.fetch = He.fetch, ue.Headers = He.Headers, ue.Request = He.Request, ue.Response = He.Response, me.exports = ue;
  }(browserPonyfill, browserPonyfill.exports)), browserPonyfill.exports;
}
(function(me, ue) {
  var Qe;
  if (typeof fetch == "function" && (typeof commonjsGlobal < "u" && commonjsGlobal.fetch ? Qe = commonjsGlobal.fetch : typeof window < "u" && window.fetch ? Qe = window.fetch : Qe = fetch), typeof commonjsRequire < "u" && (typeof window > "u" || typeof window.document > "u")) {
    var Ue = Qe || requireBrowserPonyfill();
    Ue.default && (Ue = Ue.default), ue.default = Ue, me.exports = ue.default;
  }
})(getFetch$1, getFetch$1.exports);
var getFetchExports = getFetch$1.exports;
const getFetch = /* @__PURE__ */ getDefaultExportFromCjs(getFetchExports), fetchNode = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  default: getFetch
}, [getFetchExports]);
function _typeof$8(me) {
  "@babel/helpers - typeof";
  return _typeof$8 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ue) {
    return typeof ue;
  } : function(ue) {
    return ue && typeof Symbol == "function" && ue.constructor === Symbol && ue !== Symbol.prototype ? "symbol" : typeof ue;
  }, _typeof$8(me);
}
var fetchApi;
typeof fetch == "function" && (typeof global < "u" && global.fetch ? fetchApi = global.fetch : typeof window < "u" && window.fetch ? fetchApi = window.fetch : fetchApi = fetch);
var XmlHttpRequestApi;
hasXMLHttpRequest() && (typeof global < "u" && global.XMLHttpRequest ? XmlHttpRequestApi = global.XMLHttpRequest : typeof window < "u" && window.XMLHttpRequest && (XmlHttpRequestApi = window.XMLHttpRequest));
var ActiveXObjectApi;
typeof ActiveXObject == "function" && (typeof global < "u" && global.ActiveXObject ? ActiveXObjectApi = global.ActiveXObject : typeof window < "u" && window.ActiveXObject && (ActiveXObjectApi = window.ActiveXObject));
!fetchApi && fetchNode && !XmlHttpRequestApi && !ActiveXObjectApi && (fetchApi = getFetch || fetchNode);
typeof fetchApi != "function" && (fetchApi = void 0);
var addQueryString = function(ue, Qe) {
  if (Qe && _typeof$8(Qe) === "object") {
    var Ue = "";
    for (var He in Qe)
      Ue += "&" + encodeURIComponent(He) + "=" + encodeURIComponent(Qe[He]);
    if (!Ue) return ue;
    ue = ue + (ue.indexOf("?") !== -1 ? "&" : "?") + Ue.slice(1);
  }
  return ue;
}, fetchIt = function(ue, Qe, Ue) {
  fetchApi(ue, Qe).then(function(He) {
    if (!He.ok) return Ue(He.statusText || "Error", {
      status: He.status
    });
    He.text().then(function(Ge) {
      Ue(null, {
        status: He.status,
        data: Ge
      });
    }).catch(Ue);
  }).catch(Ue);
}, omitFetchOptions = !1, requestWithFetch = function(ue, Qe, Ue, He) {
  ue.queryStringParams && (Qe = addQueryString(Qe, ue.queryStringParams));
  var Ge = defaults$6({}, typeof ue.customHeaders == "function" ? ue.customHeaders() : ue.customHeaders);
  Ue && (Ge["Content-Type"] = "application/json");
  var Xe = typeof ue.requestOptions == "function" ? ue.requestOptions(Ue) : ue.requestOptions, Ke = defaults$6({
    method: Ue ? "POST" : "GET",
    body: Ue ? ue.stringify(Ue) : void 0,
    headers: Ge
  }, omitFetchOptions ? {} : Xe);
  try {
    fetchIt(Qe, Ke, He);
  } catch ($e) {
    if (!Xe || Object.keys(Xe).length === 0 || !$e.message || $e.message.indexOf("not implemented") < 0)
      return He($e);
    try {
      Object.keys(Xe).forEach(function(Je) {
        delete Ke[Je];
      }), fetchIt(Qe, Ke, He), omitFetchOptions = !0;
    } catch (Je) {
      He(Je);
    }
  }
}, requestWithXmlHttpRequest = function(ue, Qe, Ue, He) {
  Ue && _typeof$8(Ue) === "object" && (Ue = addQueryString("", Ue).slice(1)), ue.queryStringParams && (Qe = addQueryString(Qe, ue.queryStringParams));
  try {
    var Ge;
    XmlHttpRequestApi ? Ge = new XmlHttpRequestApi() : Ge = new ActiveXObjectApi("MSXML2.XMLHTTP.3.0"), Ge.open(Ue ? "POST" : "GET", Qe, 1), ue.crossDomain || Ge.setRequestHeader("X-Requested-With", "XMLHttpRequest"), Ge.withCredentials = !!ue.withCredentials, Ue && Ge.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), Ge.overrideMimeType && Ge.overrideMimeType("application/json");
    var Xe = ue.customHeaders;
    if (Xe = typeof Xe == "function" ? Xe() : Xe, Xe)
      for (var Ke in Xe)
        Ge.setRequestHeader(Ke, Xe[Ke]);
    Ge.onreadystatechange = function() {
      Ge.readyState > 3 && He(Ge.status >= 400 ? Ge.statusText : null, {
        status: Ge.status,
        data: Ge.responseText
      });
    }, Ge.send(Ue);
  } catch ($e) {
    console && console.log($e);
  }
}, request = function(ue, Qe, Ue, He) {
  if (typeof Ue == "function" && (He = Ue, Ue = void 0), He = He || function() {
  }, fetchApi)
    return requestWithFetch(ue, Qe, Ue, He);
  if (hasXMLHttpRequest() || typeof ActiveXObject == "function")
    return requestWithXmlHttpRequest(ue, Qe, Ue, He);
  He(new Error("No fetch and no xhr implementation found!"));
};
function _classCallCheck$l(me, ue) {
  if (!(me instanceof ue))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$8(me, ue) {
  for (var Qe = 0; Qe < ue.length; Qe++) {
    var Ue = ue[Qe];
    Ue.enumerable = Ue.enumerable || !1, Ue.configurable = !0, "value" in Ue && (Ue.writable = !0), Object.defineProperty(me, Ue.key, Ue);
  }
}
function _createClass$k(me, ue, Qe) {
  return ue && _defineProperties$8(me.prototype, ue), Object.defineProperty(me, "prototype", { writable: !1 }), me;
}
function _defineProperty$5(me, ue, Qe) {
  return ue in me ? Object.defineProperty(me, ue, { value: Qe, enumerable: !0, configurable: !0, writable: !0 }) : me[ue] = Qe, me;
}
var getDefaults$2 = function() {
  return {
    loadPath: "/locales/{{lng}}/{{ns}}.json",
    addPath: "/locales/add/{{lng}}/{{ns}}",
    allowMultiLoading: !1,
    parse: function(Qe) {
      return JSON.parse(Qe);
    },
    stringify: JSON.stringify,
    parsePayload: function(Qe, Ue, He) {
      return _defineProperty$5({}, Ue, He || "");
    },
    request,
    reloadInterval: typeof window < "u" ? !1 : 60 * 60 * 1e3,
    customHeaders: {},
    queryStringParams: {},
    crossDomain: !1,
    withCredentials: !1,
    overrideMimeType: !1,
    requestOptions: {
      mode: "cors",
      credentials: "same-origin",
      cache: "default"
    }
  };
}, Backend = function() {
  function me(ue) {
    var Qe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Ue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    _classCallCheck$l(this, me), this.services = ue, this.options = Qe, this.allOptions = Ue, this.type = "backend", this.init(ue, Qe, Ue);
  }
  return _createClass$k(me, [{
    key: "init",
    value: function(Qe) {
      var Ue = this, He = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Ge = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      this.services = Qe, this.options = defaults$6(He, this.options || {}, getDefaults$2()), this.allOptions = Ge, this.services && this.options.reloadInterval && setInterval(function() {
        return Ue.reload();
      }, this.options.reloadInterval);
    }
  }, {
    key: "readMulti",
    value: function(Qe, Ue, He) {
      this._readAny(Qe, Qe, Ue, Ue, He);
    }
  }, {
    key: "read",
    value: function(Qe, Ue, He) {
      this._readAny([Qe], Qe, [Ue], Ue, He);
    }
  }, {
    key: "_readAny",
    value: function(Qe, Ue, He, Ge, Xe) {
      var Ke = this, $e = this.options.loadPath;
      typeof this.options.loadPath == "function" && ($e = this.options.loadPath(Qe, He)), $e = makePromise($e), $e.then(function(Je) {
        if (!Je) return Xe(null, {});
        var Ze = Ke.services.interpolator.interpolate(Je, {
          lng: Qe.join("+"),
          ns: He.join("+")
        });
        Ke.loadUrl(Ze, Xe, Ue, Ge);
      });
    }
  }, {
    key: "loadUrl",
    value: function(Qe, Ue, He, Ge) {
      var Xe = this;
      this.options.request(this.options, Qe, void 0, function(Ke, $e) {
        if ($e && ($e.status >= 500 && $e.status < 600 || !$e.status)) return Ue("failed loading " + Qe + "; status code: " + $e.status, !0);
        if ($e && $e.status >= 400 && $e.status < 500) return Ue("failed loading " + Qe + "; status code: " + $e.status, !1);
        if (!$e && Ke && Ke.message && Ke.message.indexOf("Failed to fetch") > -1) return Ue("failed loading " + Qe + ": " + Ke.message, !0);
        if (Ke) return Ue(Ke, !1);
        var Je, Ze;
        try {
          typeof $e.data == "string" ? Je = Xe.options.parse($e.data, He, Ge) : Je = $e.data;
        } catch {
          Ze = "failed parsing " + Qe + " to json";
        }
        if (Ze) return Ue(Ze, !1);
        Ue(null, Je);
      });
    }
  }, {
    key: "create",
    value: function(Qe, Ue, He, Ge, Xe) {
      var Ke = this;
      if (this.options.addPath) {
        typeof Qe == "string" && (Qe = [Qe]);
        var $e = this.options.parsePayload(Ue, He, Ge), Je = 0, Ze = [], nt = [];
        Qe.forEach(function(tt) {
          var et = Ke.options.addPath;
          typeof Ke.options.addPath == "function" && (et = Ke.options.addPath(tt, Ue));
          var rt = Ke.services.interpolator.interpolate(et, {
            lng: tt,
            ns: Ue
          });
          Ke.options.request(Ke.options, rt, $e, function(it, ot) {
            Je += 1, Ze.push(it), nt.push(ot), Je === Qe.length && Xe && Xe(Ze, nt);
          });
        });
      }
    }
  }, {
    key: "reload",
    value: function() {
      var Qe = this, Ue = this.services, He = Ue.backendConnector, Ge = Ue.languageUtils, Xe = Ue.logger, Ke = He.language;
      if (!(Ke && Ke.toLowerCase() === "cimode")) {
        var $e = [], Je = function(nt) {
          var tt = Ge.toResolveHierarchy(nt);
          tt.forEach(function(et) {
            $e.indexOf(et) < 0 && $e.push(et);
          });
        };
        Je(Ke), this.allOptions.preload && this.allOptions.preload.forEach(function(Ze) {
          return Je(Ze);
        }), $e.forEach(function(Ze) {
          Qe.allOptions.ns.forEach(function(nt) {
            He.read(Ze, nt, "read", null, null, function(tt, et) {
              tt && Xe.warn("loading namespace ".concat(nt, " for language ").concat(Ze, " failed"), tt), !tt && et && Xe.log("loaded namespace ".concat(nt, " for language ").concat(Ze), et), He.loaded("".concat(Ze, "|").concat(nt), tt, et);
            });
          });
        });
      }
    }
  }]), me;
}();
Backend.type = "backend";
var arr = [], each = arr.forEach, slice = arr.slice;
function defaults$5(me) {
  return each.call(slice.call(arguments, 1), function(ue) {
    if (ue)
      for (var Qe in ue)
        me[Qe] === void 0 && (me[Qe] = ue[Qe]);
  }), me;
}
var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/, serializeCookie = function(ue, Qe, Ue) {
  var He = Ue || {};
  He.path = He.path || "/";
  var Ge = encodeURIComponent(Qe), Xe = "".concat(ue, "=").concat(Ge);
  if (He.maxAge > 0) {
    var Ke = He.maxAge - 0;
    if (Number.isNaN(Ke)) throw new Error("maxAge should be a Number");
    Xe += "; Max-Age=".concat(Math.floor(Ke));
  }
  if (He.domain) {
    if (!fieldContentRegExp.test(He.domain))
      throw new TypeError("option domain is invalid");
    Xe += "; Domain=".concat(He.domain);
  }
  if (He.path) {
    if (!fieldContentRegExp.test(He.path))
      throw new TypeError("option path is invalid");
    Xe += "; Path=".concat(He.path);
  }
  if (He.expires) {
    if (typeof He.expires.toUTCString != "function")
      throw new TypeError("option expires is invalid");
    Xe += "; Expires=".concat(He.expires.toUTCString());
  }
  if (He.httpOnly && (Xe += "; HttpOnly"), He.secure && (Xe += "; Secure"), He.sameSite) {
    var $e = typeof He.sameSite == "string" ? He.sameSite.toLowerCase() : He.sameSite;
    switch ($e) {
      case !0:
        Xe += "; SameSite=Strict";
        break;
      case "lax":
        Xe += "; SameSite=Lax";
        break;
      case "strict":
        Xe += "; SameSite=Strict";
        break;
      case "none":
        Xe += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  }
  return Xe;
}, cookie = {
  create: function(ue, Qe, Ue, He) {
    var Ge = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      path: "/",
      sameSite: "strict"
    };
    Ue && (Ge.expires = /* @__PURE__ */ new Date(), Ge.expires.setTime(Ge.expires.getTime() + Ue * 60 * 1e3)), He && (Ge.domain = He), document.cookie = serializeCookie(ue, encodeURIComponent(Qe), Ge);
  },
  read: function(ue) {
    for (var Qe = "".concat(ue, "="), Ue = document.cookie.split(";"), He = 0; He < Ue.length; He++) {
      for (var Ge = Ue[He]; Ge.charAt(0) === " "; )
        Ge = Ge.substring(1, Ge.length);
      if (Ge.indexOf(Qe) === 0) return Ge.substring(Qe.length, Ge.length);
    }
    return null;
  },
  remove: function(ue) {
    this.create(ue, "", -1);
  }
}, cookie$1 = {
  name: "cookie",
  lookup: function(ue) {
    var Qe;
    if (ue.lookupCookie && typeof document < "u") {
      var Ue = cookie.read(ue.lookupCookie);
      Ue && (Qe = Ue);
    }
    return Qe;
  },
  cacheUserLanguage: function(ue, Qe) {
    Qe.lookupCookie && typeof document < "u" && cookie.create(Qe.lookupCookie, ue, Qe.cookieMinutes, Qe.cookieDomain, Qe.cookieOptions);
  }
}, querystring = {
  name: "querystring",
  lookup: function(ue) {
    var Qe;
    if (typeof window < "u") {
      var Ue = window.location.search;
      !window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1 && (Ue = window.location.hash.substring(window.location.hash.indexOf("?")));
      for (var He = Ue.substring(1), Ge = He.split("&"), Xe = 0; Xe < Ge.length; Xe++) {
        var Ke = Ge[Xe].indexOf("=");
        if (Ke > 0) {
          var $e = Ge[Xe].substring(0, Ke);
          $e === ue.lookupQuerystring && (Qe = Ge[Xe].substring(Ke + 1));
        }
      }
    }
    return Qe;
  }
}, hasLocalStorageSupport = null, localStorageAvailable = function() {
  if (hasLocalStorageSupport !== null) return hasLocalStorageSupport;
  try {
    hasLocalStorageSupport = window !== "undefined" && window.localStorage !== null;
    var ue = "i18next.translate.boo";
    window.localStorage.setItem(ue, "foo"), window.localStorage.removeItem(ue);
  } catch {
    hasLocalStorageSupport = !1;
  }
  return hasLocalStorageSupport;
}, localStorage$1 = {
  name: "localStorage",
  lookup: function(ue) {
    var Qe;
    if (ue.lookupLocalStorage && localStorageAvailable()) {
      var Ue = window.localStorage.getItem(ue.lookupLocalStorage);
      Ue && (Qe = Ue);
    }
    return Qe;
  },
  cacheUserLanguage: function(ue, Qe) {
    Qe.lookupLocalStorage && localStorageAvailable() && window.localStorage.setItem(Qe.lookupLocalStorage, ue);
  }
}, hasSessionStorageSupport = null, sessionStorageAvailable = function() {
  if (hasSessionStorageSupport !== null) return hasSessionStorageSupport;
  try {
    hasSessionStorageSupport = window !== "undefined" && window.sessionStorage !== null;
    var ue = "i18next.translate.boo";
    window.sessionStorage.setItem(ue, "foo"), window.sessionStorage.removeItem(ue);
  } catch {
    hasSessionStorageSupport = !1;
  }
  return hasSessionStorageSupport;
}, sessionStorage$1 = {
  name: "sessionStorage",
  lookup: function(ue) {
    var Qe;
    if (ue.lookupSessionStorage && sessionStorageAvailable()) {
      var Ue = window.sessionStorage.getItem(ue.lookupSessionStorage);
      Ue && (Qe = Ue);
    }
    return Qe;
  },
  cacheUserLanguage: function(ue, Qe) {
    Qe.lookupSessionStorage && sessionStorageAvailable() && window.sessionStorage.setItem(Qe.lookupSessionStorage, ue);
  }
}, navigator$1 = {
  name: "navigator",
  lookup: function(ue) {
    var Qe = [];
    if (typeof navigator < "u") {
      if (navigator.languages)
        for (var Ue = 0; Ue < navigator.languages.length; Ue++)
          Qe.push(navigator.languages[Ue]);
      navigator.userLanguage && Qe.push(navigator.userLanguage), navigator.language && Qe.push(navigator.language);
    }
    return Qe.length > 0 ? Qe : void 0;
  }
}, htmlTag = {
  name: "htmlTag",
  lookup: function(ue) {
    var Qe, Ue = ue.htmlTag || (typeof document < "u" ? document.documentElement : null);
    return Ue && typeof Ue.getAttribute == "function" && (Qe = Ue.getAttribute("lang")), Qe;
  }
}, path$1 = {
  name: "path",
  lookup: function(ue) {
    var Qe;
    if (typeof window < "u") {
      var Ue = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
      if (Ue instanceof Array)
        if (typeof ue.lookupFromPathIndex == "number") {
          if (typeof Ue[ue.lookupFromPathIndex] != "string")
            return;
          Qe = Ue[ue.lookupFromPathIndex].replace("/", "");
        } else
          Qe = Ue[0].replace("/", "");
    }
    return Qe;
  }
}, subdomain = {
  name: "subdomain",
  lookup: function(ue) {
    var Qe = typeof ue.lookupFromSubdomainIndex == "number" ? ue.lookupFromSubdomainIndex + 1 : 1, Ue = typeof window < "u" && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
    if (Ue)
      return Ue[Qe];
  }
};
function getDefaults$1() {
  return {
    order: ["querystring", "cookie", "localStorage", "sessionStorage", "navigator", "htmlTag"],
    lookupQuerystring: "lng",
    lookupCookie: "i18next",
    lookupLocalStorage: "i18nextLng",
    lookupSessionStorage: "i18nextLng",
    // cache user language
    caches: ["localStorage"],
    excludeCacheFor: ["cimode"]
    // cookieMinutes: 10,
    // cookieDomain: 'myDomain'
  };
}
var Browser = /* @__PURE__ */ function() {
  function me(ue) {
    var Qe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    _classCallCheck$m(this, me), this.type = "languageDetector", this.detectors = {}, this.init(ue, Qe);
  }
  return _createClass$l(me, [{
    key: "init",
    value: function(Qe) {
      var Ue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, He = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      this.services = Qe, this.options = defaults$5(Ue, this.options || {}, getDefaults$1()), this.options.lookupFromUrlIndex && (this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex), this.i18nOptions = He, this.addDetector(cookie$1), this.addDetector(querystring), this.addDetector(localStorage$1), this.addDetector(sessionStorage$1), this.addDetector(navigator$1), this.addDetector(htmlTag), this.addDetector(path$1), this.addDetector(subdomain);
    }
  }, {
    key: "addDetector",
    value: function(Qe) {
      this.detectors[Qe.name] = Qe;
    }
  }, {
    key: "detect",
    value: function(Qe) {
      var Ue = this;
      Qe || (Qe = this.options.order);
      var He = [];
      return Qe.forEach(function(Ge) {
        if (Ue.detectors[Ge]) {
          var Xe = Ue.detectors[Ge].lookup(Ue.options);
          Xe && typeof Xe == "string" && (Xe = [Xe]), Xe && (He = He.concat(Xe));
        }
      }), this.services.languageUtils.getBestMatchFromCodes ? He : He.length > 0 ? He[0] : null;
    }
  }, {
    key: "cacheUserLanguage",
    value: function(Qe, Ue) {
      var He = this;
      Ue || (Ue = this.options.caches), Ue && (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(Qe) > -1 || Ue.forEach(function(Ge) {
        He.detectors[Ge] && He.detectors[Ge].cacheUserLanguage(Qe, He.options);
      }));
    }
  }]), me;
}();
Browser.type = "languageDetector";
function _objectWithoutPropertiesLoose(me, ue) {
  if (me == null) return {};
  var Qe = {}, Ue = Object.keys(me), He, Ge;
  for (Ge = 0; Ge < Ue.length; Ge++)
    He = Ue[Ge], !(ue.indexOf(He) >= 0) && (Qe[He] = me[He]);
  return Qe;
}
function _objectWithoutProperties$4(me, ue) {
  if (me == null) return {};
  var Qe = _objectWithoutPropertiesLoose(me, ue), Ue, He;
  if (Object.getOwnPropertySymbols) {
    var Ge = Object.getOwnPropertySymbols(me);
    for (He = 0; He < Ge.length; He++)
      Ue = Ge[He], !(ue.indexOf(Ue) >= 0) && Object.prototype.propertyIsEnumerable.call(me, Ue) && (Qe[Ue] = me[Ue]);
  }
  return Qe;
}
var voidElements = {
  area: !0,
  base: !0,
  br: !0,
  col: !0,
  embed: !0,
  hr: !0,
  img: !0,
  input: !0,
  link: !0,
  meta: !0,
  param: !0,
  source: !0,
  track: !0,
  wbr: !0
};
const e = /* @__PURE__ */ getDefaultExportFromCjs(voidElements);
var t$1 = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function n(me) {
  var ue = { type: "tag", name: "", voidElement: !1, attrs: {}, children: [] }, Qe = me.match(/<\/?([^\s]+?)[/\s>]/);
  if (Qe && (ue.name = Qe[1], (e[Qe[1]] || me.charAt(me.length - 2) === "/") && (ue.voidElement = !0), ue.name.startsWith("!--"))) {
    var Ue = me.indexOf("-->");
    return { type: "comment", comment: Ue !== -1 ? me.slice(4, Ue) : "" };
  }
  for (var He = new RegExp(t$1), Ge = null; (Ge = He.exec(me)) !== null; ) if (Ge[0].trim()) if (Ge[1]) {
    var Xe = Ge[1].trim(), Ke = [Xe, ""];
    Xe.indexOf("=") > -1 && (Ke = Xe.split("=")), ue.attrs[Ke[0]] = Ke[1], He.lastIndex--;
  } else Ge[2] && (ue.attrs[Ge[2]] = Ge[3].trim().substring(1, Ge[3].length - 1));
  return ue;
}
var r$2 = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, i$4 = /^\s*$/, s$2 = /* @__PURE__ */ Object.create(null);
function a$2(me, ue) {
  switch (ue.type) {
    case "text":
      return me + ue.content;
    case "tag":
      return me += "<" + ue.name + (ue.attrs ? function(Qe) {
        var Ue = [];
        for (var He in Qe) Ue.push(He + '="' + Qe[He] + '"');
        return Ue.length ? " " + Ue.join(" ") : "";
      }(ue.attrs) : "") + (ue.voidElement ? "/>" : ">"), ue.voidElement ? me : me + ue.children.reduce(a$2, "") + "</" + ue.name + ">";
    case "comment":
      return me + "<!--" + ue.comment + "-->";
  }
}
var c$2 = { parse: function(me, ue) {
  ue || (ue = {}), ue.components || (ue.components = s$2);
  var Qe, Ue = [], He = [], Ge = -1, Xe = !1;
  if (me.indexOf("<") !== 0) {
    var Ke = me.indexOf("<");
    Ue.push({ type: "text", content: Ke === -1 ? me : me.substring(0, Ke) });
  }
  return me.replace(r$2, function($e, Je) {
    if (Xe) {
      if ($e !== "</" + Qe.name + ">") return;
      Xe = !1;
    }
    var Ze, nt = $e.charAt(1) !== "/", tt = $e.startsWith("<!--"), et = Je + $e.length, rt = me.charAt(et);
    if (tt) {
      var it = n($e);
      return Ge < 0 ? (Ue.push(it), Ue) : ((Ze = He[Ge]).children.push(it), Ue);
    }
    if (nt && (Ge++, (Qe = n($e)).type === "tag" && ue.components[Qe.name] && (Qe.type = "component", Xe = !0), Qe.voidElement || Xe || !rt || rt === "<" || Qe.children.push({ type: "text", content: me.slice(et, me.indexOf("<", et)) }), Ge === 0 && Ue.push(Qe), (Ze = He[Ge - 1]) && Ze.children.push(Qe), He[Ge] = Qe), (!nt || Qe.voidElement) && (Ge > -1 && (Qe.voidElement || Qe.name === $e.slice(2, -1)) && (Ge--, Qe = Ge === -1 ? Ue : He[Ge]), !Xe && rt !== "<" && rt)) {
      Ze = Ge === -1 ? Ue : He[Ge].children;
      var ot = me.indexOf("<", et), at = me.slice(et, ot === -1 ? void 0 : ot);
      i$4.test(at) && (at = " "), (ot > -1 && Ge + Ze.length >= 0 || at !== " ") && Ze.push({ type: "text", content: at });
    }
  }), Ue;
}, stringify: function(me) {
  return me.reduce(function(ue, Qe) {
    return ue + a$2("", Qe);
  }, "");
} }, matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, htmlEntities = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, unescapeHtmlEntity = function(ue) {
  return htmlEntities[ue];
}, unescape$1 = function(ue) {
  return ue.replace(matchHtmlEntity, unescapeHtmlEntity);
};
function ownKeys$7(me, ue) {
  var Qe = Object.keys(me);
  if (Object.getOwnPropertySymbols) {
    var Ue = Object.getOwnPropertySymbols(me);
    ue && (Ue = Ue.filter(function(He) {
      return Object.getOwnPropertyDescriptor(me, He).enumerable;
    })), Qe.push.apply(Qe, Ue);
  }
  return Qe;
}
function _objectSpread$7(me) {
  for (var ue = 1; ue < arguments.length; ue++) {
    var Qe = arguments[ue] != null ? arguments[ue] : {};
    ue % 2 ? ownKeys$7(Object(Qe), !0).forEach(function(Ue) {
      _defineProperty$6(me, Ue, Qe[Ue]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(me, Object.getOwnPropertyDescriptors(Qe)) : ownKeys$7(Object(Qe)).forEach(function(Ue) {
      Object.defineProperty(me, Ue, Object.getOwnPropertyDescriptor(Qe, Ue));
    });
  }
  return me;
}
var defaultOptions$1 = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: unescape$1
}, i18nInstance$1, I18nContext = createContext();
function setDefaults() {
  var me = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  defaultOptions$1 = _objectSpread$7(_objectSpread$7({}, defaultOptions$1), me);
}
function getDefaults() {
  return defaultOptions$1;
}
var ReportNamespaces = function() {
  function me() {
    _classCallCheck$m(this, me), this.usedNamespaces = {};
  }
  return _createClass$l(me, [{
    key: "addUsedNamespaces",
    value: function(Qe) {
      var Ue = this;
      Qe.forEach(function(He) {
        Ue.usedNamespaces[He] || (Ue.usedNamespaces[He] = !0);
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function() {
      return Object.keys(this.usedNamespaces);
    }
  }]), me;
}();
function setI18n(me) {
  i18nInstance$1 = me;
}
function getI18n() {
  return i18nInstance$1;
}
var initReactI18next = {
  type: "3rdParty",
  init: function(ue) {
    setDefaults(ue.options.react), setI18n(ue);
  }
};
function warn$1() {
  if (console && console.warn) {
    for (var me, ue = arguments.length, Qe = new Array(ue), Ue = 0; Ue < ue; Ue++)
      Qe[Ue] = arguments[Ue];
    typeof Qe[0] == "string" && (Qe[0] = "react-i18next:: ".concat(Qe[0])), (me = console).warn.apply(me, Qe);
  }
}
var alreadyWarned = {};
function warnOnce$1() {
  for (var me = arguments.length, ue = new Array(me), Qe = 0; Qe < me; Qe++)
    ue[Qe] = arguments[Qe];
  typeof ue[0] == "string" && alreadyWarned[ue[0]] || (typeof ue[0] == "string" && (alreadyWarned[ue[0]] = /* @__PURE__ */ new Date()), warn$1.apply(void 0, ue));
}
function loadNamespaces(me, ue, Qe) {
  me.loadNamespaces(ue, function() {
    if (me.isInitialized)
      Qe();
    else {
      var Ue = function He() {
        setTimeout(function() {
          me.off("initialized", He);
        }, 0), Qe();
      };
      me.on("initialized", Ue);
    }
  });
}
function oldI18nextHasLoadedNamespace(me, ue) {
  var Qe = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, Ue = ue.languages[0], He = ue.options ? ue.options.fallbackLng : !1, Ge = ue.languages[ue.languages.length - 1];
  if (Ue.toLowerCase() === "cimode") return !0;
  var Xe = function($e, Je) {
    var Ze = ue.services.backendConnector.state["".concat($e, "|").concat(Je)];
    return Ze === -1 || Ze === 2;
  };
  return Qe.bindI18n && Qe.bindI18n.indexOf("languageChanging") > -1 && ue.services.backendConnector.backend && ue.isLanguageChangingTo && !Xe(ue.isLanguageChangingTo, me) ? !1 : !!(ue.hasResourceBundle(Ue, me) || !ue.services.backendConnector.backend || ue.options.resources && !ue.options.partialBundledLanguages || Xe(Ue, me) && (!He || Xe(Ge, me)));
}
function hasLoadedNamespace(me, ue) {
  var Qe = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (!ue.languages || !ue.languages.length)
    return warnOnce$1("i18n.languages were undefined or empty", ue.languages), !0;
  var Ue = ue.options.ignoreJSONStructure !== void 0;
  return Ue ? ue.hasLoadedNamespace(me, {
    precheck: function(Ge, Xe) {
      if (Qe.bindI18n && Qe.bindI18n.indexOf("languageChanging") > -1 && Ge.services.backendConnector.backend && Ge.isLanguageChangingTo && !Xe(Ge.isLanguageChangingTo, me)) return !1;
    }
  }) : oldI18nextHasLoadedNamespace(me, ue, Qe);
}
var _excluded = ["format"], _excluded2 = ["children", "count", "parent", "i18nKey", "context", "tOptions", "values", "defaults", "components", "ns", "i18n", "t", "shouldUnescape"];
function ownKeys$6(me, ue) {
  var Qe = Object.keys(me);
  if (Object.getOwnPropertySymbols) {
    var Ue = Object.getOwnPropertySymbols(me);
    ue && (Ue = Ue.filter(function(He) {
      return Object.getOwnPropertyDescriptor(me, He).enumerable;
    })), Qe.push.apply(Qe, Ue);
  }
  return Qe;
}
function _objectSpread$6(me) {
  for (var ue = 1; ue < arguments.length; ue++) {
    var Qe = arguments[ue] != null ? arguments[ue] : {};
    ue % 2 ? ownKeys$6(Object(Qe), !0).forEach(function(Ue) {
      _defineProperty$6(me, Ue, Qe[Ue]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(me, Object.getOwnPropertyDescriptors(Qe)) : ownKeys$6(Object(Qe)).forEach(function(Ue) {
      Object.defineProperty(me, Ue, Object.getOwnPropertyDescriptor(Qe, Ue));
    });
  }
  return me;
}
function hasChildren(me, ue) {
  if (!me) return !1;
  var Qe = me.props ? me.props.children : me.children;
  return ue ? Qe.length > 0 : !!Qe;
}
function getChildren$1(me) {
  return me ? me.props ? me.props.children : me.children : [];
}
function hasValidReactChildren(me) {
  return Object.prototype.toString.call(me) !== "[object Array]" ? !1 : me.every(function(ue) {
    return isValidElement(ue);
  });
}
function getAsArray(me) {
  return Array.isArray(me) ? me : [me];
}
function mergeProps(me, ue) {
  var Qe = _objectSpread$6({}, ue);
  return Qe.props = Object.assign(me.props, ue.props), Qe;
}
function nodesToString(me, ue) {
  if (!me) return "";
  var Qe = "", Ue = getAsArray(me), He = ue.transSupportBasicHtmlNodes && ue.transKeepBasicHtmlNodesFor ? ue.transKeepBasicHtmlNodesFor : [];
  return Ue.forEach(function(Ge, Xe) {
    if (typeof Ge == "string")
      Qe += "".concat(Ge);
    else if (isValidElement(Ge)) {
      var Ke = Object.keys(Ge.props).length, $e = He.indexOf(Ge.type) > -1, Je = Ge.props.children;
      if (!Je && $e && Ke === 0)
        Qe += "<".concat(Ge.type, "/>");
      else if (!Je && (!$e || Ke !== 0))
        Qe += "<".concat(Xe, "></").concat(Xe, ">");
      else if (Ge.props.i18nIsDynamicList)
        Qe += "<".concat(Xe, "></").concat(Xe, ">");
      else if ($e && Ke === 1 && typeof Je == "string")
        Qe += "<".concat(Ge.type, ">").concat(Je, "</").concat(Ge.type, ">");
      else {
        var Ze = nodesToString(Je, ue);
        Qe += "<".concat(Xe, ">").concat(Ze, "</").concat(Xe, ">");
      }
    } else if (Ge === null)
      warn$1("Trans: the passed in value is invalid - seems you passed in a null child.");
    else if (_typeof$a(Ge) === "object") {
      var nt = Ge.format, tt = _objectWithoutProperties$4(Ge, _excluded), et = Object.keys(tt);
      if (et.length === 1) {
        var rt = nt ? "".concat(et[0], ", ").concat(nt) : et[0];
        Qe += "{{".concat(rt, "}}");
      } else
        warn$1("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", Ge);
    } else
      warn$1("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", Ge);
  }), Qe;
}
function renderNodes(me, ue, Qe, Ue, He, Ge) {
  if (ue === "") return [];
  var Xe = Ue.transKeepBasicHtmlNodesFor || [], Ke = ue && new RegExp(Xe.join("|")).test(ue);
  if (!me && !Ke) return [ue];
  var $e = {};
  function Je(ot) {
    var at = getAsArray(ot);
    at.forEach(function(st) {
      typeof st != "string" && (hasChildren(st) ? Je(getChildren$1(st)) : _typeof$a(st) === "object" && !isValidElement(st) && Object.assign($e, st));
    });
  }
  Je(me);
  var Ze = c$2.parse("<0>".concat(ue, "</0>")), nt = _objectSpread$6(_objectSpread$6({}, $e), He);
  function tt(ot, at, st) {
    var ut = getChildren$1(ot), lt = rt(ut, at.children, st);
    return hasValidReactChildren(ut) && lt.length === 0 ? ut : lt;
  }
  function et(ot, at, st, ut, lt) {
    ot.dummy && (ot.children = at), st.push(cloneElement(ot, _objectSpread$6(_objectSpread$6({}, ot.props), {}, {
      key: ut
    }), lt ? void 0 : at));
  }
  function rt(ot, at, st) {
    var ut = getAsArray(ot), lt = getAsArray(at);
    return lt.reduce(function(dt, At, pt) {
      var gt = At.children && At.children[0] && At.children[0].content && Qe.services.interpolator.interpolate(At.children[0].content, nt, Qe.language);
      if (At.type === "tag") {
        var wt = ut[parseInt(At.name, 10)];
        !wt && st.length === 1 && st[0][At.name] && (wt = st[0][At.name]), wt || (wt = {});
        var Bt = Object.keys(At.attrs).length !== 0 ? mergeProps({
          props: At.attrs
        }, wt) : wt, Tt = isValidElement(Bt), yt = Tt && hasChildren(At, !0) && !At.voidElement, Ct = Ke && _typeof$a(Bt) === "object" && Bt.dummy && !Tt, ht = _typeof$a(me) === "object" && me !== null && Object.hasOwnProperty.call(me, At.name);
        if (typeof Bt == "string") {
          var It = Qe.services.interpolator.interpolate(Bt, nt, Qe.language);
          dt.push(It);
        } else if (hasChildren(Bt) || yt) {
          var vt = tt(Bt, At, st);
          et(Bt, vt, dt, pt);
        } else if (Ct) {
          var Et = rt(ut, At.children, st);
          dt.push(cloneElement(Bt, _objectSpread$6(_objectSpread$6({}, Bt.props), {}, {
            key: pt
          }), Et));
        } else if (Number.isNaN(parseFloat(At.name)))
          if (ht) {
            var bt = tt(Bt, At, st);
            et(Bt, bt, dt, pt, At.voidElement);
          } else if (Ue.transSupportBasicHtmlNodes && Xe.indexOf(At.name) > -1)
            if (At.voidElement)
              dt.push(createElement$2(At.name, {
                key: "".concat(At.name, "-").concat(pt)
              }));
            else {
              var Rt = rt(ut, At.children, st);
              dt.push(createElement$2(At.name, {
                key: "".concat(At.name, "-").concat(pt)
              }, Rt));
            }
          else if (At.voidElement)
            dt.push("<".concat(At.name, " />"));
          else {
            var St = rt(ut, At.children, st);
            dt.push("<".concat(At.name, ">").concat(St, "</").concat(At.name, ">"));
          }
        else if (_typeof$a(Bt) === "object" && !Tt) {
          var kt = At.children[0] ? gt : null;
          kt && dt.push(kt);
        } else At.children.length === 1 && gt ? dt.push(cloneElement(Bt, _objectSpread$6(_objectSpread$6({}, Bt.props), {}, {
          key: pt
        }), gt)) : dt.push(cloneElement(Bt, _objectSpread$6(_objectSpread$6({}, Bt.props), {}, {
          key: pt
        })));
      } else if (At.type === "text") {
        var jt = Ue.transWrapTextNodes, Pt = Ge ? Ue.unescape(Qe.services.interpolator.interpolate(At.content, nt, Qe.language)) : Qe.services.interpolator.interpolate(At.content, nt, Qe.language);
        jt ? dt.push(createElement$2(jt, {
          key: "".concat(At.name, "-").concat(pt)
        }, Pt)) : dt.push(Pt);
      }
      return dt;
    }, []);
  }
  var it = rt([{
    dummy: !0,
    children: me || []
  }], Ze, getAsArray(me || []));
  return getChildren$1(it[0]);
}
function Trans(me) {
  var ue = me.children, Qe = me.count, Ue = me.parent, He = me.i18nKey, Ge = me.context, Xe = me.tOptions, Ke = Xe === void 0 ? {} : Xe, $e = me.values, Je = me.defaults, Ze = me.components, nt = me.ns, tt = me.i18n, et = me.t, rt = me.shouldUnescape, it = _objectWithoutProperties$4(me, _excluded2), ot = useContext(I18nContext) || {}, at = ot.i18n, st = ot.defaultNS, ut = tt || at || getI18n();
  if (!ut)
    return warnOnce$1("You will need to pass in an i18next instance by using i18nextReactModule"), ue;
  var lt = et || ut.t.bind(ut) || function(It) {
    return It;
  };
  Ge && (Ke.context = Ge);
  var dt = _objectSpread$6(_objectSpread$6({}, getDefaults()), ut.options && ut.options.react), At = nt || lt.ns || st || ut.options && ut.options.defaultNS;
  At = typeof At == "string" ? [At] : At || ["translation"];
  var pt = Je || nodesToString(ue, dt) || dt.transEmptyNodeValue || He, gt = dt.hashTransKey, wt = He || (gt ? gt(pt) : pt), Bt = $e ? Ke.interpolation : {
    interpolation: _objectSpread$6(_objectSpread$6({}, Ke.interpolation), {}, {
      prefix: "#$?",
      suffix: "?$#"
    })
  }, Tt = _objectSpread$6(_objectSpread$6(_objectSpread$6(_objectSpread$6({}, Ke), {}, {
    count: Qe
  }, $e), Bt), {}, {
    defaultValue: pt,
    ns: At
  }), yt = wt ? lt(wt, Tt) : pt, Ct = renderNodes(Ze || ue, yt, ut, dt, Tt, rt), ht = Ue !== void 0 ? Ue : dt.defaultTransParent;
  return ht ? createElement$2(ht, it, Ct) : Ct;
}
function _iterableToArrayLimit$3(me, ue) {
  var Qe = me == null ? null : typeof Symbol < "u" && me[Symbol.iterator] || me["@@iterator"];
  if (Qe != null) {
    var Ue, He, Ge, Xe, Ke = [], $e = !0, Je = !1;
    try {
      if (Ge = (Qe = Qe.call(me)).next, ue !== 0) for (; !($e = (Ue = Ge.call(Qe)).done) && (Ke.push(Ue.value), Ke.length !== ue); $e = !0) ;
    } catch (Ze) {
      Je = !0, He = Ze;
    } finally {
      try {
        if (!$e && Qe.return != null && (Xe = Qe.return(), Object(Xe) !== Xe)) return;
      } finally {
        if (Je) throw He;
      }
    }
    return Ke;
  }
}
function _slicedToArray$3(me, ue) {
  return _arrayWithHoles$3(me) || _iterableToArrayLimit$3(me, ue) || _unsupportedIterableToArray$b(me, ue) || _nonIterableRest$3();
}
function ownKeys$5(me, ue) {
  var Qe = Object.keys(me);
  if (Object.getOwnPropertySymbols) {
    var Ue = Object.getOwnPropertySymbols(me);
    ue && (Ue = Ue.filter(function(He) {
      return Object.getOwnPropertyDescriptor(me, He).enumerable;
    })), Qe.push.apply(Qe, Ue);
  }
  return Qe;
}
function _objectSpread$5(me) {
  for (var ue = 1; ue < arguments.length; ue++) {
    var Qe = arguments[ue] != null ? arguments[ue] : {};
    ue % 2 ? ownKeys$5(Object(Qe), !0).forEach(function(Ue) {
      _defineProperty$6(me, Ue, Qe[Ue]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(me, Object.getOwnPropertyDescriptors(Qe)) : ownKeys$5(Object(Qe)).forEach(function(Ue) {
      Object.defineProperty(me, Ue, Object.getOwnPropertyDescriptor(Qe, Ue));
    });
  }
  return me;
}
var usePrevious = function(ue, Qe) {
  var Ue = useRef();
  return useEffect(function() {
    Ue.current = ue;
  }, [ue, Qe]), Ue.current;
};
function useTranslation(me) {
  var ue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Qe = ue.i18n, Ue = useContext(I18nContext) || {}, He = Ue.i18n, Ge = Ue.defaultNS, Xe = Qe || He || getI18n();
  if (Xe && !Xe.reportNamespaces && (Xe.reportNamespaces = new ReportNamespaces()), !Xe) {
    warnOnce$1("You will need to pass in an i18next instance by using initReactI18next");
    var Ke = function(wt) {
      return Array.isArray(wt) ? wt[wt.length - 1] : wt;
    }, $e = [Ke, {}, !1];
    return $e.t = Ke, $e.i18n = {}, $e.ready = !1, $e;
  }
  Xe.options.react && Xe.options.react.wait !== void 0 && warnOnce$1("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  var Je = _objectSpread$5(_objectSpread$5(_objectSpread$5({}, getDefaults()), Xe.options.react), ue), Ze = Je.useSuspense, nt = Je.keyPrefix, tt = Ge || Xe.options && Xe.options.defaultNS;
  tt = typeof tt == "string" ? [tt] : tt || ["translation"], Xe.reportNamespaces.addUsedNamespaces && Xe.reportNamespaces.addUsedNamespaces(tt);
  var et = (Xe.isInitialized || Xe.initializedStoreOnce) && tt.every(function(gt) {
    return hasLoadedNamespace(gt, Xe, Je);
  });
  function rt() {
    return Xe.getFixedT(null, Je.nsMode === "fallback" ? tt : tt[0], nt);
  }
  var it = useState(rt), ot = _slicedToArray$3(it, 2), at = ot[0], st = ot[1], ut = tt.join(), lt = usePrevious(ut), dt = useRef(!0);
  useEffect(function() {
    var gt = Je.bindI18n, wt = Je.bindI18nStore;
    dt.current = !0, !et && !Ze && loadNamespaces(Xe, tt, function() {
      dt.current && st(rt);
    }), et && lt && lt !== ut && dt.current && st(rt);
    function Bt() {
      dt.current && st(rt);
    }
    return gt && Xe && Xe.on(gt, Bt), wt && Xe && Xe.store.on(wt, Bt), function() {
      dt.current = !1, gt && Xe && gt.split(" ").forEach(function(Tt) {
        return Xe.off(Tt, Bt);
      }), wt && Xe && wt.split(" ").forEach(function(Tt) {
        return Xe.store.off(Tt, Bt);
      });
    };
  }, [Xe, ut]);
  var At = useRef(!0);
  useEffect(function() {
    dt.current && !At.current && st(rt), At.current = !1;
  }, [Xe, nt]);
  var pt = [at, Xe, et];
  if (pt.t = at, pt.i18n = Xe, pt.ready = et, et || !et && !Ze) return pt;
  throw new Promise(function(gt) {
    loadNamespaces(Xe, tt, function() {
      gt();
    });
  });
}
function I18nextProvider(me) {
  var ue = me.i18n, Qe = me.defaultNS, Ue = me.children, He = useMemo(function() {
    return {
      i18n: ue,
      defaultNS: Qe
    };
  }, [ue, Qe]);
  return createElement$2(I18nContext.Provider, {
    value: He
  }, Ue);
}
const supportedLngs = [
  "en",
  "en-DG",
  "es",
  "es-ES",
  "sr",
  "sr-Latn",
  "fr",
  "pt-BR",
  "pt",
  "bn",
  "zh",
  "hi",
  "id",
  "ms",
  "tr",
  "vi",
  "ht",
  "it",
  "de",
  "nl",
  "tl-PH",
  "pl",
  "hu",
  "ro"
], languageDetector = new Browser();
languageDetector.addDetector({
  name: "navigatorOnlyLanguage",
  lookup() {
    if (typeof navigator > "u")
      return "en";
    const me = navigator.language;
    return supportedLngs.includes(me) ? me : me.split("-")[0];
  }
});
const apiKey = "cg41dUINoxdp8BaHDQLJhA", loadPath = `https://api.i18nexus.com/project_resources/translations/{{lng}}/{{ns}}.json?api_key=${apiKey}`, i18nInstance = instance.createInstance();
i18nInstance.use(initReactI18next).use(Backend).use(languageDetector).init({
  fallbackLng: "en",
  supportedLngs,
  ns: ["default"],
  detection: {
    order: [
      "querystring",
      "cookie",
      "localStorage",
      "sessionStorage",
      "navigatorOnlyLanguage",
      "htmlTag",
      "path",
      "subdomain"
    ],
    lookupQuerystring: "lang"
  },
  defaultNS: "default",
  parseMissingKeyHandler: (me) => {
    const ue = me.split("."), Qe = ue[ue.length - 1];
    return camelToStartCase(Qe);
  },
  partialBundledLanguages: !0,
  keySeparator: ".",
  interpolation: {
    escapeValue: !1
    // react already safes from xss
  },
  backend: {
    loadPath
  },
  react: {
    useSuspense: !1
  },
  initImmediate: !1
});
const addCustomFields = ({ token: me, fields: ue }) => api.post(
  "/omni/add/custom-fields",
  { customFields: { ...ue } },
  {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }
).then((Qe) => Qe.data).catch((Qe) => Promise.reject(Qe.response.data));
async function addContract({ token: me, image: ue }) {
  const { url: Qe, contractId: Ue } = await getContractURL({ token: me });
  return await fetch(Qe, {
    method: "PUT",
    body: ue,
    headers: {
      "x-ms-blob-type": "BlockBlob"
    }
  }), { url: Qe, contractId: Ue };
}
function getContractURL({ token: me }) {
  return api.post(
    "/omni/generateContractUploadUrl",
    null,
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).then((ue) => ue.data);
}
async function addDocument({
  token: me,
  type: ue,
  image: Qe,
  onProgress: Ue = emptyFunc
}) {
  if (ue === "contract") {
    const { url: He, contractId: Ge } = await addContract({
      token: me,
      image: b64toBlob(Qe)
    });
    return {
      success: !0,
      sessionStatus: "Alive",
      additionalInformation: {
        contractId: Ge,
        url: He
      }
    };
  }
  return api.post(
    `/omni/add/document/v2?type=${ue}`,
    { base64Image: Qe },
    {
      headers: {
        "X-Incode-Hardware-Id": me
      },
      onUploadProgress: ({ loaded: He, total: Ge }) => Ue(He / Ge * 100)
    }
  ).then((He) => He.data).catch((He) => Promise.reject(He.response.data));
}
function addName({ token: me, name: ue }) {
  return api.post(
    "/omni/add/name",
    { name: ue },
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).catch((Qe) => Promise.reject(Qe.response.data));
}
const addQrUrl = "/omni/qr";
function addQr({ token: me }) {
  return api.get(addQrUrl, {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }).then((ue) => ue.data);
}
function approve({ token: me }) {
  return api.post("/omni/process/approve", null, {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }).then((ue) => {
    const { uuid: Qe, ...Ue } = ue.data;
    return { ...Ue, customerId: Qe };
  }).catch((ue) => {
    var Qe;
    return Promise.reject((Qe = ue.response) == null ? void 0 : Qe.data);
  });
}
var jsxRuntime = { exports: {} }, reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var me = React__default, ue = Symbol.for("react.element"), Qe = Symbol.for("react.fragment"), Ue = Object.prototype.hasOwnProperty, He = me.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, Ge = { key: !0, ref: !0, __self: !0, __source: !0 };
  function Xe(Ke, $e, Je) {
    var Ze, nt = {}, tt = null, et = null;
    Je !== void 0 && (tt = "" + Je), $e.key !== void 0 && (tt = "" + $e.key), $e.ref !== void 0 && (et = $e.ref);
    for (Ze in $e) Ue.call($e, Ze) && !Ge.hasOwnProperty(Ze) && (nt[Ze] = $e[Ze]);
    if (Ke && Ke.defaultProps) for (Ze in $e = Ke.defaultProps, $e) nt[Ze] === void 0 && (nt[Ze] = $e[Ze]);
    return { $$typeof: ue, type: Ke, key: tt, ref: et, props: nt, _owner: He.current };
  }
  return reactJsxRuntime_production_min.Fragment = Qe, reactJsxRuntime_production_min.jsx = Xe, reactJsxRuntime_production_min.jsxs = Xe, reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  return hasRequiredReactJsxRuntime_development || (hasRequiredReactJsxRuntime_development = 1, process.env.NODE_ENV !== "production" && function() {
    var me = React__default, ue = Symbol.for("react.element"), Qe = Symbol.for("react.portal"), Ue = Symbol.for("react.fragment"), He = Symbol.for("react.strict_mode"), Ge = Symbol.for("react.profiler"), Xe = Symbol.for("react.provider"), Ke = Symbol.for("react.context"), $e = Symbol.for("react.forward_ref"), Je = Symbol.for("react.suspense"), Ze = Symbol.for("react.suspense_list"), nt = Symbol.for("react.memo"), tt = Symbol.for("react.lazy"), et = Symbol.for("react.offscreen"), rt = Symbol.iterator, it = "@@iterator";
    function ot(on) {
      if (on === null || typeof on != "object")
        return null;
      var bn = rt && on[rt] || on[it];
      return typeof bn == "function" ? bn : null;
    }
    var at = me.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function st(on) {
      {
        for (var bn = arguments.length, vn = new Array(bn > 1 ? bn - 1 : 0), Ln = 1; Ln < bn; Ln++)
          vn[Ln - 1] = arguments[Ln];
        ut("error", on, vn);
      }
    }
    function ut(on, bn, vn) {
      {
        var Ln = at.ReactDebugCurrentFrame, Jn = Ln.getStackAddendum();
        Jn !== "" && (bn += "%s", vn = vn.concat([Jn]));
        var nr = vn.map(function(ir) {
          return String(ir);
        });
        nr.unshift("Warning: " + bn), Function.prototype.apply.call(console[on], console, nr);
      }
    }
    var lt = !1, dt = !1, At = !1, pt = !1, gt = !1, wt;
    wt = Symbol.for("react.module.reference");
    function Bt(on) {
      return !!(typeof on == "string" || typeof on == "function" || on === Ue || on === Ge || gt || on === He || on === Je || on === Ze || pt || on === et || lt || dt || At || typeof on == "object" && on !== null && (on.$$typeof === tt || on.$$typeof === nt || on.$$typeof === Xe || on.$$typeof === Ke || on.$$typeof === $e || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      on.$$typeof === wt || on.getModuleId !== void 0));
    }
    function Tt(on, bn, vn) {
      var Ln = on.displayName;
      if (Ln)
        return Ln;
      var Jn = bn.displayName || bn.name || "";
      return Jn !== "" ? vn + "(" + Jn + ")" : vn;
    }
    function yt(on) {
      return on.displayName || "Context";
    }
    function Ct(on) {
      if (on == null)
        return null;
      if (typeof on.tag == "number" && st("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof on == "function")
        return on.displayName || on.name || null;
      if (typeof on == "string")
        return on;
      switch (on) {
        case Ue:
          return "Fragment";
        case Qe:
          return "Portal";
        case Ge:
          return "Profiler";
        case He:
          return "StrictMode";
        case Je:
          return "Suspense";
        case Ze:
          return "SuspenseList";
      }
      if (typeof on == "object")
        switch (on.$$typeof) {
          case Ke:
            var bn = on;
            return yt(bn) + ".Consumer";
          case Xe:
            var vn = on;
            return yt(vn._context) + ".Provider";
          case $e:
            return Tt(on, on.render, "ForwardRef");
          case nt:
            var Ln = on.displayName || null;
            return Ln !== null ? Ln : Ct(on.type) || "Memo";
          case tt: {
            var Jn = on, nr = Jn._payload, ir = Jn._init;
            try {
              return Ct(ir(nr));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ht = Object.assign, It = 0, vt, Et, bt, Rt, St, kt, jt;
    function Pt() {
    }
    Pt.__reactDisabledLog = !0;
    function Qt() {
      {
        if (It === 0) {
          vt = console.log, Et = console.info, bt = console.warn, Rt = console.error, St = console.group, kt = console.groupCollapsed, jt = console.groupEnd;
          var on = {
            configurable: !0,
            enumerable: !0,
            value: Pt,
            writable: !0
          };
          Object.defineProperties(console, {
            info: on,
            log: on,
            warn: on,
            error: on,
            group: on,
            groupCollapsed: on,
            groupEnd: on
          });
        }
        It++;
      }
    }
    function qt() {
      {
        if (It--, It === 0) {
          var on = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ht({}, on, {
              value: vt
            }),
            info: ht({}, on, {
              value: Et
            }),
            warn: ht({}, on, {
              value: bt
            }),
            error: ht({}, on, {
              value: Rt
            }),
            group: ht({}, on, {
              value: St
            }),
            groupCollapsed: ht({}, on, {
              value: kt
            }),
            groupEnd: ht({}, on, {
              value: jt
            })
          });
        }
        It < 0 && st("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var _t = at.ReactCurrentDispatcher, Yt;
    function Xt(on, bn, vn) {
      {
        if (Yt === void 0)
          try {
            throw Error();
          } catch (Jn) {
            var Ln = Jn.stack.trim().match(/\n( *(at )?)/);
            Yt = Ln && Ln[1] || "";
          }
        return `
` + Yt + on;
      }
    }
    var Ut = !1, Lt;
    {
      var Ot = typeof WeakMap == "function" ? WeakMap : Map;
      Lt = new Ot();
    }
    function ft(on, bn) {
      if (!on || Ut)
        return "";
      {
        var vn = Lt.get(on);
        if (vn !== void 0)
          return vn;
      }
      var Ln;
      Ut = !0;
      var Jn = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var nr;
      nr = _t.current, _t.current = null, Qt();
      try {
        if (bn) {
          var ir = function() {
            throw Error();
          };
          if (Object.defineProperty(ir.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ir, []);
            } catch (Kn) {
              Ln = Kn;
            }
            Reflect.construct(on, [], ir);
          } else {
            try {
              ir.call();
            } catch (Kn) {
              Ln = Kn;
            }
            on.call(ir.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Kn) {
            Ln = Kn;
          }
          on();
        }
      } catch (Kn) {
        if (Kn && Ln && typeof Kn.stack == "string") {
          for (var Zn = Kn.stack.split(`
`), Wr = Ln.stack.split(`
`), Or = Zn.length - 1, pr = Wr.length - 1; Or >= 1 && pr >= 0 && Zn[Or] !== Wr[pr]; )
            pr--;
          for (; Or >= 1 && pr >= 0; Or--, pr--)
            if (Zn[Or] !== Wr[pr]) {
              if (Or !== 1 || pr !== 1)
                do
                  if (Or--, pr--, pr < 0 || Zn[Or] !== Wr[pr]) {
                    var yr = `
` + Zn[Or].replace(" at new ", " at ");
                    return on.displayName && yr.includes("<anonymous>") && (yr = yr.replace("<anonymous>", on.displayName)), typeof on == "function" && Lt.set(on, yr), yr;
                  }
                while (Or >= 1 && pr >= 0);
              break;
            }
        }
      } finally {
        Ut = !1, _t.current = nr, qt(), Error.prepareStackTrace = Jn;
      }
      var to = on ? on.displayName || on.name : "", vi = to ? Xt(to) : "";
      return typeof on == "function" && Lt.set(on, vi), vi;
    }
    function Dt(on, bn, vn) {
      return ft(on, !1);
    }
    function Mt(on) {
      var bn = on.prototype;
      return !!(bn && bn.isReactComponent);
    }
    function Ft(on, bn, vn) {
      if (on == null)
        return "";
      if (typeof on == "function")
        return ft(on, Mt(on));
      if (typeof on == "string")
        return Xt(on);
      switch (on) {
        case Je:
          return Xt("Suspense");
        case Ze:
          return Xt("SuspenseList");
      }
      if (typeof on == "object")
        switch (on.$$typeof) {
          case $e:
            return Dt(on.render);
          case nt:
            return Ft(on.type, bn, vn);
          case tt: {
            var Ln = on, Jn = Ln._payload, nr = Ln._init;
            try {
              return Ft(nr(Jn), bn, vn);
            } catch {
            }
          }
        }
      return "";
    }
    var Gt = Object.prototype.hasOwnProperty, zt = {}, $t = at.ReactDebugCurrentFrame;
    function Ht(on) {
      if (on) {
        var bn = on._owner, vn = Ft(on.type, on._source, bn ? bn.type : null);
        $t.setExtraStackFrame(vn);
      } else
        $t.setExtraStackFrame(null);
    }
    function hn(on, bn, vn, Ln, Jn) {
      {
        var nr = Function.call.bind(Gt);
        for (var ir in on)
          if (nr(on, ir)) {
            var Zn = void 0;
            try {
              if (typeof on[ir] != "function") {
                var Wr = Error((Ln || "React class") + ": " + vn + " type `" + ir + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof on[ir] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Wr.name = "Invariant Violation", Wr;
              }
              Zn = on[ir](bn, ir, Ln, vn, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Or) {
              Zn = Or;
            }
            Zn && !(Zn instanceof Error) && (Ht(Jn), st("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ln || "React class", vn, ir, typeof Zn), Ht(null)), Zn instanceof Error && !(Zn.message in zt) && (zt[Zn.message] = !0, Ht(Jn), st("Failed %s type: %s", vn, Zn.message), Ht(null));
          }
      }
    }
    var un = Array.isArray;
    function An(on) {
      return un(on);
    }
    function mn(on) {
      {
        var bn = typeof Symbol == "function" && Symbol.toStringTag, vn = bn && on[Symbol.toStringTag] || on.constructor.name || "Object";
        return vn;
      }
    }
    function En(on) {
      try {
        return Jt(on), !1;
      } catch {
        return !0;
      }
    }
    function Jt(on) {
      return "" + on;
    }
    function an(on) {
      if (En(on))
        return st("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", mn(on)), Jt(on);
    }
    var cn = at.ReactCurrentOwner, dn = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, yn, Nn, Rn;
    Rn = {};
    function rn(on) {
      if (Gt.call(on, "ref")) {
        var bn = Object.getOwnPropertyDescriptor(on, "ref").get;
        if (bn && bn.isReactWarning)
          return !1;
      }
      return on.ref !== void 0;
    }
    function ln(on) {
      if (Gt.call(on, "key")) {
        var bn = Object.getOwnPropertyDescriptor(on, "key").get;
        if (bn && bn.isReactWarning)
          return !1;
      }
      return on.key !== void 0;
    }
    function pn(on, bn) {
      if (typeof on.ref == "string" && cn.current && bn && cn.current.stateNode !== bn) {
        var vn = Ct(cn.current.type);
        Rn[vn] || (st('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', Ct(cn.current.type), on.ref), Rn[vn] = !0);
      }
    }
    function Sn(on, bn) {
      {
        var vn = function() {
          yn || (yn = !0, st("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", bn));
        };
        vn.isReactWarning = !0, Object.defineProperty(on, "key", {
          get: vn,
          configurable: !0
        });
      }
    }
    function In(on, bn) {
      {
        var vn = function() {
          Nn || (Nn = !0, st("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", bn));
        };
        vn.isReactWarning = !0, Object.defineProperty(on, "ref", {
          get: vn,
          configurable: !0
        });
      }
    }
    var Bn = function(on, bn, vn, Ln, Jn, nr, ir) {
      var Zn = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: ue,
        // Built-in properties that belong on the element
        type: on,
        key: bn,
        ref: vn,
        props: ir,
        // Record the component responsible for creating this element.
        _owner: nr
      };
      return Zn._store = {}, Object.defineProperty(Zn._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Zn, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ln
      }), Object.defineProperty(Zn, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Jn
      }), Object.freeze && (Object.freeze(Zn.props), Object.freeze(Zn)), Zn;
    };
    function Pn(on, bn, vn, Ln, Jn) {
      {
        var nr, ir = {}, Zn = null, Wr = null;
        vn !== void 0 && (an(vn), Zn = "" + vn), ln(bn) && (an(bn.key), Zn = "" + bn.key), rn(bn) && (Wr = bn.ref, pn(bn, Jn));
        for (nr in bn)
          Gt.call(bn, nr) && !dn.hasOwnProperty(nr) && (ir[nr] = bn[nr]);
        if (on && on.defaultProps) {
          var Or = on.defaultProps;
          for (nr in Or)
            ir[nr] === void 0 && (ir[nr] = Or[nr]);
        }
        if (Zn || Wr) {
          var pr = typeof on == "function" ? on.displayName || on.name || "Unknown" : on;
          Zn && Sn(ir, pr), Wr && In(ir, pr);
        }
        return Bn(on, Zn, Wr, Jn, Ln, cn.current, ir);
      }
    }
    var Yn = at.ReactCurrentOwner, or = at.ReactDebugCurrentFrame;
    function mr(on) {
      if (on) {
        var bn = on._owner, vn = Ft(on.type, on._source, bn ? bn.type : null);
        or.setExtraStackFrame(vn);
      } else
        or.setExtraStackFrame(null);
    }
    var lr;
    lr = !1;
    function Mr(on) {
      return typeof on == "object" && on !== null && on.$$typeof === ue;
    }
    function ai() {
      {
        if (Yn.current) {
          var on = Ct(Yn.current.type);
          if (on)
            return `

Check the render method of \`` + on + "`.";
        }
        return "";
      }
    }
    function Un(on) {
      return "";
    }
    var qn = {};
    function hr(on) {
      {
        var bn = ai();
        if (!bn) {
          var vn = typeof on == "string" ? on : on.displayName || on.name;
          vn && (bn = `

Check the top-level render call using <` + vn + ">.");
        }
        return bn;
      }
    }
    function Vr(on, bn) {
      {
        if (!on._store || on._store.validated || on.key != null)
          return;
        on._store.validated = !0;
        var vn = hr(bn);
        if (qn[vn])
          return;
        qn[vn] = !0;
        var Ln = "";
        on && on._owner && on._owner !== Yn.current && (Ln = " It was passed a child from " + Ct(on._owner.type) + "."), mr(on), st('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', vn, Ln), mr(null);
      }
    }
    function Pr(on, bn) {
      {
        if (typeof on != "object")
          return;
        if (An(on))
          for (var vn = 0; vn < on.length; vn++) {
            var Ln = on[vn];
            Mr(Ln) && Vr(Ln, bn);
          }
        else if (Mr(on))
          on._store && (on._store.validated = !0);
        else if (on) {
          var Jn = ot(on);
          if (typeof Jn == "function" && Jn !== on.entries)
            for (var nr = Jn.call(on), ir; !(ir = nr.next()).done; )
              Mr(ir.value) && Vr(ir.value, bn);
        }
      }
    }
    function Er(on) {
      {
        var bn = on.type;
        if (bn == null || typeof bn == "string")
          return;
        var vn;
        if (typeof bn == "function")
          vn = bn.propTypes;
        else if (typeof bn == "object" && (bn.$$typeof === $e || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        bn.$$typeof === nt))
          vn = bn.propTypes;
        else
          return;
        if (vn) {
          var Ln = Ct(bn);
          hn(vn, on.props, "prop", Ln, on);
        } else if (bn.PropTypes !== void 0 && !lr) {
          lr = !0;
          var Jn = Ct(bn);
          st("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Jn || "Unknown");
        }
        typeof bn.getDefaultProps == "function" && !bn.getDefaultProps.isReactClassApproved && st("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function xr(on) {
      {
        for (var bn = Object.keys(on.props), vn = 0; vn < bn.length; vn++) {
          var Ln = bn[vn];
          if (Ln !== "children" && Ln !== "key") {
            mr(on), st("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ln), mr(null);
            break;
          }
        }
        on.ref !== null && (mr(on), st("Invalid attribute `ref` supplied to `React.Fragment`."), mr(null));
      }
    }
    function kr(on, bn, vn, Ln, Jn, nr) {
      {
        var ir = Bt(on);
        if (!ir) {
          var Zn = "";
          (on === void 0 || typeof on == "object" && on !== null && Object.keys(on).length === 0) && (Zn += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Wr = Un();
          Wr ? Zn += Wr : Zn += ai();
          var Or;
          on === null ? Or = "null" : An(on) ? Or = "array" : on !== void 0 && on.$$typeof === ue ? (Or = "<" + (Ct(on.type) || "Unknown") + " />", Zn = " Did you accidentally export a JSX literal instead of a component?") : Or = typeof on, st("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Or, Zn);
        }
        var pr = Pn(on, bn, vn, Jn, nr);
        if (pr == null)
          return pr;
        if (ir) {
          var yr = bn.children;
          if (yr !== void 0)
            if (Ln)
              if (An(yr)) {
                for (var to = 0; to < yr.length; to++)
                  Pr(yr[to], on);
                Object.freeze && Object.freeze(yr);
              } else
                st("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Pr(yr, on);
        }
        return on === Ue ? xr(pr) : Er(pr), pr;
      }
    }
    function Rr(on, bn, vn) {
      return kr(on, bn, vn, !0);
    }
    function sr(on, bn, vn) {
      return kr(on, bn, vn, !1);
    }
    var br = sr, Gr = Rr;
    reactJsxRuntime_development.Fragment = Ue, reactJsxRuntime_development.jsx = br, reactJsxRuntime_development.jsxs = Gr;
  }()), reactJsxRuntime_development;
}
process.env.NODE_ENV === "production" ? jsxRuntime.exports = requireReactJsxRuntime_production_min() : jsxRuntime.exports = requireReactJsxRuntime_development();
var jsxRuntimeExports = jsxRuntime.exports, classnames = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(me) {
  (function() {
    var ue = {}.hasOwnProperty;
    function Qe() {
      for (var Ue = [], He = 0; He < arguments.length; He++) {
        var Ge = arguments[He];
        if (Ge) {
          var Xe = typeof Ge;
          if (Xe === "string" || Xe === "number")
            Ue.push(Ge);
          else if (Array.isArray(Ge)) {
            if (Ge.length) {
              var Ke = Qe.apply(null, Ge);
              Ke && Ue.push(Ke);
            }
          } else if (Xe === "object") {
            if (Ge.toString !== Object.prototype.toString && !Ge.toString.toString().includes("[native code]")) {
              Ue.push(Ge.toString());
              continue;
            }
            for (var $e in Ge)
              ue.call(Ge, $e) && Ge[$e] && Ue.push($e);
          }
        }
      }
      return Ue.join(" ");
    }
    me.exports ? (Qe.default = Qe, me.exports = Qe) : window.classNames = Qe;
  })();
})(classnames);
var classnamesExports = classnames.exports;
const classNames = /* @__PURE__ */ getDefaultExportFromCjs(classnamesExports);
var extendStatics = function(me, ue) {
  return extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Qe, Ue) {
    Qe.__proto__ = Ue;
  } || function(Qe, Ue) {
    for (var He in Ue) Object.prototype.hasOwnProperty.call(Ue, He) && (Qe[He] = Ue[He]);
  }, extendStatics(me, ue);
};
function __extends$1q(me, ue) {
  if (typeof ue != "function" && ue !== null)
    throw new TypeError("Class extends value " + String(ue) + " is not a constructor or null");
  extendStatics(me, ue);
  function Qe() {
    this.constructor = me;
  }
  me.prototype = ue === null ? Object.create(ue) : (Qe.prototype = ue.prototype, new Qe());
}
var __assign$2 = function() {
  return __assign$2 = Object.assign || function(ue) {
    for (var Qe, Ue = 1, He = arguments.length; Ue < He; Ue++) {
      Qe = arguments[Ue];
      for (var Ge in Qe) Object.prototype.hasOwnProperty.call(Qe, Ge) && (ue[Ge] = Qe[Ge]);
    }
    return ue;
  }, __assign$2.apply(this, arguments);
};
function __rest$3(me, ue) {
  var Qe = {};
  for (var Ue in me) Object.prototype.hasOwnProperty.call(me, Ue) && ue.indexOf(Ue) < 0 && (Qe[Ue] = me[Ue]);
  if (me != null && typeof Object.getOwnPropertySymbols == "function")
    for (var He = 0, Ue = Object.getOwnPropertySymbols(me); He < Ue.length; He++)
      ue.indexOf(Ue[He]) < 0 && Object.prototype.propertyIsEnumerable.call(me, Ue[He]) && (Qe[Ue[He]] = me[Ue[He]]);
  return Qe;
}
function __read$1(me, ue) {
  var Qe = typeof Symbol == "function" && me[Symbol.iterator];
  if (!Qe) return me;
  var Ue = Qe.call(me), He, Ge = [], Xe;
  try {
    for (; (ue === void 0 || ue-- > 0) && !(He = Ue.next()).done; ) Ge.push(He.value);
  } catch (Ke) {
    Xe = { error: Ke };
  } finally {
    try {
      He && !He.done && (Qe = Ue.return) && Qe.call(Ue);
    } finally {
      if (Xe) throw Xe.error;
    }
  }
  return Ge;
}
function __spreadArray$1(me, ue, Qe) {
  if (Qe || arguments.length === 2) for (var Ue = 0, He = ue.length, Ge; Ue < He; Ue++)
    (Ge || !(Ue in ue)) && (Ge || (Ge = Array.prototype.slice.call(ue, 0, Ue)), Ge[Ue] = ue[Ue]);
  return me.concat(Ge || Array.prototype.slice.call(ue));
}
typeof SuppressedError == "function" && SuppressedError;
var defaultEnvironment = "production", env$1 = typeof process > "u" || process.env === void 0 ? defaultEnvironment : process.env.NODE_ENV || defaultEnvironment, createDefinition = function(me) {
  return {
    isEnabled: function(ue) {
      return me.some(function(Qe) {
        return !!ue[Qe];
      });
    }
  };
}, featureDefinitions = {
  measureLayout: createDefinition(["layout", "layoutId", "drag"]),
  animation: createDefinition([
    "animate",
    "exit",
    "variants",
    "whileHover",
    "whileTap",
    "whileFocus",
    "whileDrag",
    "whileInView"
  ]),
  exit: createDefinition(["exit"]),
  drag: createDefinition(["drag", "dragControls"]),
  focus: createDefinition(["whileFocus"]),
  hover: createDefinition(["whileHover", "onHoverStart", "onHoverEnd"]),
  tap: createDefinition(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
  pan: createDefinition([
    "onPan",
    "onPanStart",
    "onPanSessionStart",
    "onPanEnd"
  ]),
  inView: createDefinition([
    "whileInView",
    "onViewportEnter",
    "onViewportLeave"
  ])
};
function loadFeatures(me) {
  for (var ue in me)
    me[ue] !== null && (ue === "projectionNodeConstructor" ? featureDefinitions.projectionNodeConstructor = me[ue] : featureDefinitions[ue].Component = me[ue]);
}
var warning$3 = function() {
}, invariant$1 = function() {
};
process.env.NODE_ENV !== "production" && (warning$3 = function(me, ue) {
  !me && typeof console < "u" && console.warn(ue);
}, invariant$1 = function(me, ue) {
  if (!me)
    throw new Error(ue);
});
var LazyContext = createContext({ strict: !1 }), featureNames = Object.keys(featureDefinitions), numFeatures = featureNames.length;
function useFeatures(me, ue, Qe) {
  var Ue = [], He = useContext(LazyContext);
  if (!ue)
    return null;
  env$1 !== "production" && Qe && He.strict && invariant$1(!1, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");
  for (var Ge = 0; Ge < numFeatures; Ge++) {
    var Xe = featureNames[Ge], Ke = featureDefinitions[Xe], $e = Ke.isEnabled, Je = Ke.Component;
    $e(me) && Je && Ue.push(React.createElement(Je, __assign$2({ key: Xe }, me, { visualElement: ue })));
  }
  return Ue;
}
var MotionConfigContext = createContext({
  transformPagePoint: function(me) {
    return me;
  },
  isStatic: !1,
  reducedMotion: "never"
}), MotionContext = createContext({});
function useVisualElementContext() {
  return useContext(MotionContext).visualElement;
}
var PresenceContext = createContext(null), isBrowser$1 = typeof document < "u", useIsomorphicLayoutEffect$1 = isBrowser$1 ? useLayoutEffect : useEffect, prefersReducedMotion = { current: null }, hasDetected = !1;
function initPrefersReducedMotion() {
  if (hasDetected = !0, !!isBrowser$1)
    if (window.matchMedia) {
      var me = window.matchMedia("(prefers-reduced-motion)"), ue = function() {
        return prefersReducedMotion.current = me.matches;
      };
      me.addListener(ue), ue();
    } else
      prefersReducedMotion.current = !1;
}
function useReducedMotion() {
  !hasDetected && initPrefersReducedMotion();
  var me = __read$1(useState(prefersReducedMotion.current), 1), ue = me[0];
  return ue;
}
function useReducedMotionConfig() {
  var me = useReducedMotion(), ue = useContext(MotionConfigContext).reducedMotion;
  return ue === "never" ? !1 : ue === "always" ? !0 : me;
}
function useVisualElement(me, ue, Qe, Ue) {
  var He = useContext(LazyContext), Ge = useVisualElementContext(), Xe = useContext(PresenceContext), Ke = useReducedMotionConfig(), $e = useRef(void 0);
  Ue || (Ue = He.renderer), !$e.current && Ue && ($e.current = Ue(me, {
    visualState: ue,
    parent: Ge,
    props: Qe,
    presenceId: Xe == null ? void 0 : Xe.id,
    blockInitialAnimation: (Xe == null ? void 0 : Xe.initial) === !1,
    shouldReduceMotion: Ke
  }));
  var Je = $e.current;
  return useIsomorphicLayoutEffect$1(function() {
    Je == null || Je.syncRender();
  }), useEffect(function() {
    var Ze;
    (Ze = Je == null ? void 0 : Je.animationState) === null || Ze === void 0 || Ze.animateChanges();
  }), useIsomorphicLayoutEffect$1(function() {
    return function() {
      return Je == null ? void 0 : Je.notifyUnmount();
    };
  }, []), Je;
}
function isRefObject(me) {
  return typeof me == "object" && Object.prototype.hasOwnProperty.call(me, "current");
}
function useMotionRef(me, ue, Qe) {
  return useCallback(
    function(Ue) {
      var He;
      Ue && ((He = me.mount) === null || He === void 0 || He.call(me, Ue)), ue && (Ue ? ue.mount(Ue) : ue.unmount()), Qe && (typeof Qe == "function" ? Qe(Ue) : isRefObject(Qe) && (Qe.current = Ue));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [ue]
  );
}
function isVariantLabels(me) {
  return Array.isArray(me);
}
function isVariantLabel(me) {
  return typeof me == "string" || isVariantLabels(me);
}
function getCurrent(me) {
  var ue = {};
  return me.forEachValue(function(Qe, Ue) {
    return ue[Ue] = Qe.get();
  }), ue;
}
function getVelocity$1(me) {
  var ue = {};
  return me.forEachValue(function(Qe, Ue) {
    return ue[Ue] = Qe.getVelocity();
  }), ue;
}
function resolveVariantFromProps(me, ue, Qe, Ue, He) {
  var Ge;
  return Ue === void 0 && (Ue = {}), He === void 0 && (He = {}), typeof ue == "function" && (ue = ue(Qe ?? me.custom, Ue, He)), typeof ue == "string" && (ue = (Ge = me.variants) === null || Ge === void 0 ? void 0 : Ge[ue]), typeof ue == "function" && (ue = ue(Qe ?? me.custom, Ue, He)), ue;
}
function resolveVariant(me, ue, Qe) {
  var Ue = me.getProps();
  return resolveVariantFromProps(Ue, ue, Qe ?? Ue.custom, getCurrent(me), getVelocity$1(me));
}
function checkIfControllingVariants(me) {
  var ue;
  return typeof ((ue = me.animate) === null || ue === void 0 ? void 0 : ue.start) == "function" || isVariantLabel(me.initial) || isVariantLabel(me.animate) || isVariantLabel(me.whileHover) || isVariantLabel(me.whileDrag) || isVariantLabel(me.whileTap) || isVariantLabel(me.whileFocus) || isVariantLabel(me.exit);
}
function checkIfVariantNode(me) {
  return !!(checkIfControllingVariants(me) || me.variants);
}
function getCurrentTreeVariants(me, ue) {
  if (checkIfControllingVariants(me)) {
    var Qe = me.initial, Ue = me.animate;
    return {
      initial: Qe === !1 || isVariantLabel(Qe) ? Qe : void 0,
      animate: isVariantLabel(Ue) ? Ue : void 0
    };
  }
  return me.inherit !== !1 ? ue : {};
}
function useCreateMotionContext(me) {
  var ue = getCurrentTreeVariants(me, useContext(MotionContext)), Qe = ue.initial, Ue = ue.animate;
  return useMemo(function() {
    return { initial: Qe, animate: Ue };
  }, [variantLabelsAsDependency(Qe), variantLabelsAsDependency(Ue)]);
}
function variantLabelsAsDependency(me) {
  return Array.isArray(me) ? me.join(" ") : me;
}
function useConstant(me) {
  var ue = useRef(null);
  return ue.current === null && (ue.current = me()), ue.current;
}
var globalProjectionState = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
}, id$1 = 1;
function useProjectionId() {
  return useConstant(function() {
    if (globalProjectionState.hasEverUpdated)
      return id$1++;
  });
}
var LayoutGroupContext = createContext({}), SwitchLayoutGroupContext = createContext({});
function useProjection(me, ue, Qe, Ue) {
  var He, Ge = ue.layoutId, Xe = ue.layout, Ke = ue.drag, $e = ue.dragConstraints, Je = ue.layoutScroll, Ze = useContext(SwitchLayoutGroupContext);
  !Ue || !Qe || Qe != null && Qe.projection || (Qe.projection = new Ue(me, Qe.getLatestValues(), (He = Qe.parent) === null || He === void 0 ? void 0 : He.projection), Qe.projection.setOptions({
    layoutId: Ge,
    layout: Xe,
    alwaysMeasureLayout: !!Ke || $e && isRefObject($e),
    visualElement: Qe,
    scheduleRender: function() {
      return Qe.scheduleRender();
    },
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof Xe == "string" ? Xe : "both",
    initialPromotionConfig: Ze,
    layoutScroll: Je
  }));
}
var VisualElementHandler = (
  /** @class */
  function(me) {
    __extends$1q(ue, me);
    function ue() {
      return me !== null && me.apply(this, arguments) || this;
    }
    return ue.prototype.getSnapshotBeforeUpdate = function() {
      return this.updateProps(), null;
    }, ue.prototype.componentDidUpdate = function() {
    }, ue.prototype.updateProps = function() {
      var Qe = this.props, Ue = Qe.visualElement, He = Qe.props;
      Ue && Ue.setProps(He);
    }, ue.prototype.render = function() {
      return this.props.children;
    }, ue;
  }(React__default.Component)
);
function createMotionComponent(me) {
  var ue = me.preloadedFeatures, Qe = me.createVisualElement, Ue = me.projectionNodeConstructor, He = me.useRender, Ge = me.useVisualState, Xe = me.Component;
  ue && loadFeatures(ue);
  function Ke($e, Je) {
    var Ze = useLayoutId($e);
    $e = __assign$2(__assign$2({}, $e), { layoutId: Ze });
    var nt = useContext(MotionConfigContext), tt = null, et = useCreateMotionContext($e), rt = nt.isStatic ? void 0 : useProjectionId(), it = Ge($e, nt.isStatic);
    return !nt.isStatic && isBrowser$1 && (et.visualElement = useVisualElement(Xe, it, __assign$2(__assign$2({}, nt), $e), Qe), useProjection(rt, $e, et.visualElement, Ue || featureDefinitions.projectionNodeConstructor), tt = useFeatures($e, et.visualElement, ue)), React.createElement(
      VisualElementHandler,
      { visualElement: et.visualElement, props: __assign$2(__assign$2({}, nt), $e) },
      tt,
      React.createElement(MotionContext.Provider, { value: et }, He(Xe, $e, rt, useMotionRef(it, et.visualElement, Je), it, nt.isStatic, et.visualElement))
    );
  }
  return forwardRef(Ke);
}
function useLayoutId(me) {
  var ue, Qe = me.layoutId, Ue = (ue = useContext(LayoutGroupContext)) === null || ue === void 0 ? void 0 : ue.id;
  return Ue && Qe !== void 0 ? Ue + "-" + Qe : Qe;
}
function createMotionProxy(me) {
  function ue(Ue, He) {
    return He === void 0 && (He = {}), createMotionComponent(me(Ue, He));
  }
  if (typeof Proxy > "u")
    return ue;
  var Qe = /* @__PURE__ */ new Map();
  return new Proxy(ue, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: function(Ue, He) {
      return Qe.has(He) || Qe.set(He, ue(He)), Qe.get(He);
    }
  });
}
var lowercaseSVGElements = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "svg",
  "switch",
  "symbol",
  "text",
  "tspan",
  "use",
  "view"
];
function isSVGComponent(me) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof me != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    me.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(lowercaseSVGElements.indexOf(me) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(me))
    )
  );
}
var scaleCorrectors = {};
function addScaleCorrector(me) {
  Object.assign(scaleCorrectors, me);
}
var transformAxes = ["", "X", "Y", "Z"], order$1 = ["translate", "scale", "rotate", "skew"], transformProps = ["transformPerspective", "x", "y", "z"];
order$1.forEach(function(me) {
  return transformAxes.forEach(function(ue) {
    return transformProps.push(me + ue);
  });
});
function sortTransformProps(me, ue) {
  return transformProps.indexOf(me) - transformProps.indexOf(ue);
}
var transformPropSet = new Set(transformProps);
function isTransformProp(me) {
  return transformPropSet.has(me);
}
var transformOriginProps = /* @__PURE__ */ new Set(["originX", "originY", "originZ"]);
function isTransformOriginProp(me) {
  return transformOriginProps.has(me);
}
function isForcedMotionValue(me, ue) {
  var Qe = ue.layout, Ue = ue.layoutId;
  return isTransformProp(me) || isTransformOriginProp(me) || (Qe || Ue !== void 0) && (!!scaleCorrectors[me] || me === "opacity");
}
var isMotionValue = function(me) {
  return !!(me !== null && typeof me == "object" && me.getVelocity);
}, translateAlias = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};
function buildTransform(me, ue, Qe, Ue) {
  var He = me.transform, Ge = me.transformKeys, Xe = ue.enableHardwareAcceleration, Ke = Xe === void 0 ? !0 : Xe, $e = ue.allowTransformNone, Je = $e === void 0 ? !0 : $e, Ze = "";
  Ge.sort(sortTransformProps);
  for (var nt = !1, tt = Ge.length, et = 0; et < tt; et++) {
    var rt = Ge[et];
    Ze += "".concat(translateAlias[rt] || rt, "(").concat(He[rt], ") "), rt === "z" && (nt = !0);
  }
  return !nt && Ke ? Ze += "translateZ(0)" : Ze = Ze.trim(), Ue ? Ze = Ue(He, Qe ? "" : Ze) : Je && Qe && (Ze = "none"), Ze;
}
function buildTransformOrigin(me) {
  var ue = me.originX, Qe = ue === void 0 ? "50%" : ue, Ue = me.originY, He = Ue === void 0 ? "50%" : Ue, Ge = me.originZ, Xe = Ge === void 0 ? 0 : Ge;
  return "".concat(Qe, " ").concat(He, " ").concat(Xe);
}
function isCSSVariable$1(me) {
  return me.startsWith("--");
}
var getValueAsType = function(me, ue) {
  return ue && typeof me == "number" ? ue.transform(me) : me;
};
const clamp$1 = (me, ue) => (Qe) => Math.max(Math.min(Qe, ue), me), sanitize = (me) => me % 1 ? Number(me.toFixed(5)) : me, floatRegex = /(-)?([\d]*\.?[\d])+/g, colorRegex = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi, singleColorRegex = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function isString$3(me) {
  return typeof me == "string";
}
const number$1 = {
  test: (me) => typeof me == "number",
  parse: parseFloat,
  transform: (me) => me
}, alpha = Object.assign(Object.assign({}, number$1), { transform: clamp$1(0, 1) }), scale = Object.assign(Object.assign({}, number$1), { default: 1 }), createUnitType = (me) => ({
  test: (ue) => isString$3(ue) && ue.endsWith(me) && ue.split(" ").length === 1,
  parse: parseFloat,
  transform: (ue) => `${ue}${me}`
}), degrees = createUnitType("deg"), percent = createUnitType("%"), px = createUnitType("px"), vh = createUnitType("vh"), vw = createUnitType("vw"), progressPercentage = Object.assign(Object.assign({}, percent), { parse: (me) => percent.parse(me) / 100, transform: (me) => percent.transform(me * 100) }), isColorString = (me, ue) => (Qe) => !!(isString$3(Qe) && singleColorRegex.test(Qe) && Qe.startsWith(me) || ue && Object.prototype.hasOwnProperty.call(Qe, ue)), splitColor = (me, ue, Qe) => (Ue) => {
  if (!isString$3(Ue))
    return Ue;
  const [He, Ge, Xe, Ke] = Ue.match(floatRegex);
  return {
    [me]: parseFloat(He),
    [ue]: parseFloat(Ge),
    [Qe]: parseFloat(Xe),
    alpha: Ke !== void 0 ? parseFloat(Ke) : 1
  };
}, hsla = {
  test: isColorString("hsl", "hue"),
  parse: splitColor("hue", "saturation", "lightness"),
  transform: ({ hue: me, saturation: ue, lightness: Qe, alpha: Ue = 1 }) => "hsla(" + Math.round(me) + ", " + percent.transform(sanitize(ue)) + ", " + percent.transform(sanitize(Qe)) + ", " + sanitize(alpha.transform(Ue)) + ")"
}, clampRgbUnit = clamp$1(0, 255), rgbUnit = Object.assign(Object.assign({}, number$1), { transform: (me) => Math.round(clampRgbUnit(me)) }), rgba = {
  test: isColorString("rgb", "red"),
  parse: splitColor("red", "green", "blue"),
  transform: ({ red: me, green: ue, blue: Qe, alpha: Ue = 1 }) => "rgba(" + rgbUnit.transform(me) + ", " + rgbUnit.transform(ue) + ", " + rgbUnit.transform(Qe) + ", " + sanitize(alpha.transform(Ue)) + ")"
};
function parseHex(me) {
  let ue = "", Qe = "", Ue = "", He = "";
  return me.length > 5 ? (ue = me.substr(1, 2), Qe = me.substr(3, 2), Ue = me.substr(5, 2), He = me.substr(7, 2)) : (ue = me.substr(1, 1), Qe = me.substr(2, 1), Ue = me.substr(3, 1), He = me.substr(4, 1), ue += ue, Qe += Qe, Ue += Ue, He += He), {
    red: parseInt(ue, 16),
    green: parseInt(Qe, 16),
    blue: parseInt(Ue, 16),
    alpha: He ? parseInt(He, 16) / 255 : 1
  };
}
const hex = {
  test: isColorString("#"),
  parse: parseHex,
  transform: rgba.transform
}, color$1 = {
  test: (me) => rgba.test(me) || hex.test(me) || hsla.test(me),
  parse: (me) => rgba.test(me) ? rgba.parse(me) : hsla.test(me) ? hsla.parse(me) : hex.parse(me),
  transform: (me) => isString$3(me) ? me : me.hasOwnProperty("red") ? rgba.transform(me) : hsla.transform(me)
}, colorToken = "${c}", numberToken = "${n}";
function test(me) {
  var ue, Qe, Ue, He;
  return isNaN(me) && isString$3(me) && ((Qe = (ue = me.match(floatRegex)) === null || ue === void 0 ? void 0 : ue.length) !== null && Qe !== void 0 ? Qe : 0) + ((He = (Ue = me.match(colorRegex)) === null || Ue === void 0 ? void 0 : Ue.length) !== null && He !== void 0 ? He : 0) > 0;
}
function analyse$1(me) {
  typeof me == "number" && (me = `${me}`);
  const ue = [];
  let Qe = 0;
  const Ue = me.match(colorRegex);
  Ue && (Qe = Ue.length, me = me.replace(colorRegex, colorToken), ue.push(...Ue.map(color$1.parse)));
  const He = me.match(floatRegex);
  return He && (me = me.replace(floatRegex, numberToken), ue.push(...He.map(number$1.parse))), { values: ue, numColors: Qe, tokenised: me };
}
function parse$6(me) {
  return analyse$1(me).values;
}
function createTransformer(me) {
  const { values: ue, numColors: Qe, tokenised: Ue } = analyse$1(me), He = ue.length;
  return (Ge) => {
    let Xe = Ue;
    for (let Ke = 0; Ke < He; Ke++)
      Xe = Xe.replace(Ke < Qe ? colorToken : numberToken, Ke < Qe ? color$1.transform(Ge[Ke]) : sanitize(Ge[Ke]));
    return Xe;
  };
}
const convertNumbersToZero = (me) => typeof me == "number" ? 0 : me;
function getAnimatableNone$1(me) {
  const ue = parse$6(me);
  return createTransformer(me)(ue.map(convertNumbersToZero));
}
const complex = { test, parse: parse$6, createTransformer, getAnimatableNone: getAnimatableNone$1 }, maxDefaults = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function applyDefaultFilter(me) {
  let [ue, Qe] = me.slice(0, -1).split("(");
  if (ue === "drop-shadow")
    return me;
  const [Ue] = Qe.match(floatRegex) || [];
  if (!Ue)
    return me;
  const He = Qe.replace(Ue, "");
  let Ge = maxDefaults.has(ue) ? 1 : 0;
  return Ue !== Qe && (Ge *= 100), ue + "(" + Ge + He + ")";
}
const functionRegex = /([a-z-]*)\(.*?\)/g, filter = Object.assign(Object.assign({}, complex), { getAnimatableNone: (me) => {
  const ue = me.match(functionRegex);
  return ue ? ue.map(applyDefaultFilter).join(" ") : me;
} });
var int = __assign$2(__assign$2({}, number$1), { transform: Math.round }), numberValueTypes = {
  // Border props
  borderWidth: px,
  borderTopWidth: px,
  borderRightWidth: px,
  borderBottomWidth: px,
  borderLeftWidth: px,
  borderRadius: px,
  radius: px,
  borderTopLeftRadius: px,
  borderTopRightRadius: px,
  borderBottomRightRadius: px,
  borderBottomLeftRadius: px,
  // Positioning props
  width: px,
  maxWidth: px,
  height: px,
  maxHeight: px,
  size: px,
  top: px,
  right: px,
  bottom: px,
  left: px,
  // Spacing props
  padding: px,
  paddingTop: px,
  paddingRight: px,
  paddingBottom: px,
  paddingLeft: px,
  margin: px,
  marginTop: px,
  marginRight: px,
  marginBottom: px,
  marginLeft: px,
  // Transform props
  rotate: degrees,
  rotateX: degrees,
  rotateY: degrees,
  rotateZ: degrees,
  scale,
  scaleX: scale,
  scaleY: scale,
  scaleZ: scale,
  skew: degrees,
  skewX: degrees,
  skewY: degrees,
  distance: px,
  translateX: px,
  translateY: px,
  translateZ: px,
  x: px,
  y: px,
  z: px,
  perspective: px,
  transformPerspective: px,
  opacity: alpha,
  originX: progressPercentage,
  originY: progressPercentage,
  originZ: px,
  // Misc
  zIndex: int,
  // SVG
  fillOpacity: alpha,
  strokeOpacity: alpha,
  numOctaves: int
};
function buildHTMLStyles(me, ue, Qe, Ue) {
  var He, Ge = me.style, Xe = me.vars, Ke = me.transform, $e = me.transformKeys, Je = me.transformOrigin;
  $e.length = 0;
  var Ze = !1, nt = !1, tt = !0;
  for (var et in ue) {
    var rt = ue[et];
    if (isCSSVariable$1(et)) {
      Xe[et] = rt;
      continue;
    }
    var it = numberValueTypes[et], ot = getValueAsType(rt, it);
    if (isTransformProp(et)) {
      if (Ze = !0, Ke[et] = ot, $e.push(et), !tt)
        continue;
      rt !== ((He = it.default) !== null && He !== void 0 ? He : 0) && (tt = !1);
    } else isTransformOriginProp(et) ? (Je[et] = ot, nt = !0) : Ge[et] = ot;
  }
  Ze ? Ge.transform = buildTransform(me, Qe, tt, Ue) : Ue ? Ge.transform = Ue({}, "") : !ue.transform && Ge.transform && (Ge.transform = "none"), nt && (Ge.transformOrigin = buildTransformOrigin(Je));
}
var createHtmlRenderState = function() {
  return {
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {}
  };
};
function copyRawValuesOnly(me, ue, Qe) {
  for (var Ue in ue)
    !isMotionValue(ue[Ue]) && !isForcedMotionValue(Ue, Qe) && (me[Ue] = ue[Ue]);
}
function useInitialMotionValues(me, ue, Qe) {
  var Ue = me.transformTemplate;
  return useMemo(function() {
    var He = createHtmlRenderState();
    buildHTMLStyles(He, ue, { enableHardwareAcceleration: !Qe }, Ue);
    var Ge = He.vars, Xe = He.style;
    return __assign$2(__assign$2({}, Ge), Xe);
  }, [ue]);
}
function useStyle(me, ue, Qe) {
  var Ue = me.style || {}, He = {};
  return copyRawValuesOnly(He, Ue, me), Object.assign(He, useInitialMotionValues(me, ue, Qe)), me.transformValues && (He = me.transformValues(He)), He;
}
function useHTMLProps(me, ue, Qe) {
  var Ue = {}, He = useStyle(me, ue, Qe);
  return me.drag && me.dragListener !== !1 && (Ue.draggable = !1, He.userSelect = He.WebkitUserSelect = He.WebkitTouchCallout = "none", He.touchAction = me.drag === !0 ? "none" : "pan-".concat(me.drag === "x" ? "y" : "x")), Ue.style = He, Ue;
}
var validMotionProps = /* @__PURE__ */ new Set([
  "initial",
  "animate",
  "exit",
  "style",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "layout",
  "layoutId",
  "layoutDependency",
  "onLayoutAnimationStart",
  "onLayoutAnimationComplete",
  "onLayoutMeasure",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "drag",
  "dragControls",
  "dragListener",
  "dragConstraints",
  "dragDirectionLock",
  "dragSnapToOrigin",
  "_dragX",
  "_dragY",
  "dragElastic",
  "dragMomentum",
  "dragPropagation",
  "dragTransition",
  "whileDrag",
  "onPan",
  "onPanStart",
  "onPanEnd",
  "onPanSessionStart",
  "onTap",
  "onTapStart",
  "onTapCancel",
  "onHoverStart",
  "onHoverEnd",
  "whileFocus",
  "whileTap",
  "whileHover",
  "whileInView",
  "onViewportEnter",
  "onViewportLeave",
  "viewport",
  "layoutScroll"
]);
function isValidMotionProp(me) {
  return validMotionProps.has(me);
}
var shouldForward = function(me) {
  return !isValidMotionProp(me);
};
function loadExternalIsValidProp(me) {
  me && (shouldForward = function(ue) {
    return ue.startsWith("on") ? !isValidMotionProp(ue) : me(ue);
  });
}
try {
  loadExternalIsValidProp(require("@emotion/is-prop-valid").default);
} catch {
}
function filterProps(me, ue, Qe) {
  var Ue = {};
  for (var He in me)
    (shouldForward(He) || Qe === !0 && isValidMotionProp(He) || !ue && !isValidMotionProp(He) || // If trying to use native HTML drag events, forward drag listeners
    me.draggable && He.startsWith("onDrag")) && (Ue[He] = me[He]);
  return Ue;
}
function calcOrigin$1(me, ue, Qe) {
  return typeof me == "string" ? me : px.transform(ue + Qe * me);
}
function calcSVGTransformOrigin(me, ue, Qe) {
  var Ue = calcOrigin$1(ue, me.x, me.width), He = calcOrigin$1(Qe, me.y, me.height);
  return "".concat(Ue, " ").concat(He);
}
var camelKeys = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function buildSVGPath(me, ue, Qe, Ue, He) {
  Qe === void 0 && (Qe = 1), Ue === void 0 && (Ue = 0), me.pathLength = 1;
  var Ge = camelKeys;
  me[Ge.offset] = px.transform(-Ue);
  var Xe = px.transform(ue), Ke = px.transform(Qe);
  me[Ge.array] = "".concat(Xe, " ").concat(Ke);
}
function buildSVGAttrs(me, ue, Qe, Ue) {
  var He = ue.attrX, Ge = ue.attrY, Xe = ue.originX, Ke = ue.originY, $e = ue.pathLength, Je = ue.pathSpacing, Ze = Je === void 0 ? 1 : Je, nt = ue.pathOffset, tt = nt === void 0 ? 0 : nt, et = __rest$3(ue, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);
  buildHTMLStyles(me, et, Qe, Ue), me.attrs = me.style, me.style = {};
  var rt = me.attrs, it = me.style, ot = me.dimensions;
  rt.transform && (ot && (it.transform = rt.transform), delete rt.transform), ot && (Xe !== void 0 || Ke !== void 0 || it.transform) && (it.transformOrigin = calcSVGTransformOrigin(ot, Xe !== void 0 ? Xe : 0.5, Ke !== void 0 ? Ke : 0.5)), He !== void 0 && (rt.x = He), Ge !== void 0 && (rt.y = Ge), $e !== void 0 && buildSVGPath(rt, $e, Ze, tt);
}
var createSvgRenderState = function() {
  return __assign$2(__assign$2({}, createHtmlRenderState()), { attrs: {} });
};
function useSVGProps(me, ue) {
  var Qe = useMemo(function() {
    var He = createSvgRenderState();
    return buildSVGAttrs(He, ue, { enableHardwareAcceleration: !1 }, me.transformTemplate), __assign$2(__assign$2({}, He.attrs), { style: __assign$2({}, He.style) });
  }, [ue]);
  if (me.style) {
    var Ue = {};
    copyRawValuesOnly(Ue, me.style, me), Qe.style = __assign$2(__assign$2({}, Ue), Qe.style);
  }
  return Qe;
}
function createUseRender(me) {
  me === void 0 && (me = !1);
  var ue = function(Qe, Ue, He, Ge, Xe, Ke) {
    var $e = Xe.latestValues, Je = isSVGComponent(Qe) ? useSVGProps : useHTMLProps, Ze = Je(Ue, $e, Ke), nt = filterProps(Ue, typeof Qe == "string", me), tt = __assign$2(__assign$2(__assign$2({}, nt), Ze), { ref: Ge });
    return He && (tt["data-projection-id"] = He), createElement$2(Qe, tt);
  };
  return ue;
}
var CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g, REPLACE_TEMPLATE = "$1-$2", camelToDash = function(me) {
  return me.replace(CAMEL_CASE_PATTERN, REPLACE_TEMPLATE).toLowerCase();
};
function renderHTML(me, ue, Qe, Ue) {
  var He = ue.style, Ge = ue.vars;
  Object.assign(me.style, He, Ue && Ue.getProjectionStyles(Qe));
  for (var Xe in Ge)
    me.style.setProperty(Xe, Ge[Xe]);
}
var camelCaseAttributes = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength"
]);
function renderSVG(me, ue, Qe, Ue) {
  renderHTML(me, ue, void 0, Ue);
  for (var He in ue.attrs)
    me.setAttribute(camelCaseAttributes.has(He) ? He : camelToDash(He), ue.attrs[He]);
}
function scrapeMotionValuesFromProps$1(me) {
  var ue = me.style, Qe = {};
  for (var Ue in ue)
    (isMotionValue(ue[Ue]) || isForcedMotionValue(Ue, me)) && (Qe[Ue] = ue[Ue]);
  return Qe;
}
function scrapeMotionValuesFromProps(me) {
  var ue = scrapeMotionValuesFromProps$1(me);
  for (var Qe in me)
    if (isMotionValue(me[Qe])) {
      var Ue = Qe === "x" || Qe === "y" ? "attr" + Qe.toUpperCase() : Qe;
      ue[Ue] = me[Qe];
    }
  return ue;
}
function isAnimationControls(me) {
  return typeof me == "object" && typeof me.start == "function";
}
var isKeyframesTarget = function(me) {
  return Array.isArray(me);
}, isCustomValue = function(me) {
  return !!(me && typeof me == "object" && me.mix && me.toValue);
}, resolveFinalValueInKeyframes = function(me) {
  return isKeyframesTarget(me) ? me[me.length - 1] || 0 : me;
};
function resolveMotionValue(me) {
  var ue = isMotionValue(me) ? me.get() : me;
  return isCustomValue(ue) ? ue.toValue() : ue;
}
function makeState(me, ue, Qe, Ue) {
  var He = me.scrapeMotionValuesFromProps, Ge = me.createRenderState, Xe = me.onMount, Ke = {
    latestValues: makeLatestValues(ue, Qe, Ue, He),
    renderState: Ge()
  };
  return Xe && (Ke.mount = function($e) {
    return Xe(ue, $e, Ke);
  }), Ke;
}
var makeUseVisualState = function(me) {
  return function(ue, Qe) {
    var Ue = useContext(MotionContext), He = useContext(PresenceContext);
    return Qe ? makeState(me, ue, Ue, He) : useConstant(function() {
      return makeState(me, ue, Ue, He);
    });
  };
};
function makeLatestValues(me, ue, Qe, Ue) {
  var He = {}, Ge = (Qe == null ? void 0 : Qe.initial) === !1, Xe = Ue(me);
  for (var Ke in Xe)
    He[Ke] = resolveMotionValue(Xe[Ke]);
  var $e = me.initial, Je = me.animate, Ze = checkIfControllingVariants(me), nt = checkIfVariantNode(me);
  ue && nt && !Ze && me.inherit !== !1 && ($e ?? ($e = ue.initial), Je ?? (Je = ue.animate));
  var tt = Ge || $e === !1, et = tt ? Je : $e;
  if (et && typeof et != "boolean" && !isAnimationControls(et)) {
    var rt = Array.isArray(et) ? et : [et];
    rt.forEach(function(it) {
      var ot = resolveVariantFromProps(me, it);
      if (ot) {
        var at = ot.transitionEnd;
        ot.transition;
        var st = __rest$3(ot, ["transitionEnd", "transition"]);
        for (var ut in st) {
          var lt = st[ut];
          if (Array.isArray(lt)) {
            var dt = tt ? lt.length - 1 : 0;
            lt = lt[dt];
          }
          lt !== null && (He[ut] = lt);
        }
        for (var ut in at)
          He[ut] = at[ut];
      }
    });
  }
  return He;
}
var svgMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps,
    createRenderState: createSvgRenderState,
    onMount: function(me, ue, Qe) {
      var Ue = Qe.renderState, He = Qe.latestValues;
      try {
        Ue.dimensions = typeof ue.getBBox == "function" ? ue.getBBox() : ue.getBoundingClientRect();
      } catch {
        Ue.dimensions = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }
      buildSVGAttrs(Ue, He, { enableHardwareAcceleration: !1 }, me.transformTemplate), renderSVG(ue, Ue);
    }
  })
}, htmlMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
    createRenderState: createHtmlRenderState
  })
};
function createDomMotionConfig(me, ue, Qe, Ue, He) {
  var Ge = ue.forwardMotionProps, Xe = Ge === void 0 ? !1 : Ge, Ke = isSVGComponent(me) ? svgMotionConfig : htmlMotionConfig;
  return __assign$2(__assign$2({}, Ke), { preloadedFeatures: Qe, useRender: createUseRender(Xe), createVisualElement: Ue, projectionNodeConstructor: He, Component: me });
}
var AnimationType;
(function(me) {
  me.Animate = "animate", me.Hover = "whileHover", me.Tap = "whileTap", me.Drag = "whileDrag", me.Focus = "whileFocus", me.InView = "whileInView", me.Exit = "exit";
})(AnimationType || (AnimationType = {}));
function addDomEvent(me, ue, Qe, Ue) {
  return Ue === void 0 && (Ue = { passive: !0 }), me.addEventListener(ue, Qe, Ue), function() {
    return me.removeEventListener(ue, Qe);
  };
}
function useDomEvent(me, ue, Qe, Ue) {
  useEffect(function() {
    var He = me.current;
    if (Qe && He)
      return addDomEvent(He, ue, Qe, Ue);
  }, [me, ue, Qe, Ue]);
}
function useFocusGesture(me) {
  var ue = me.whileFocus, Qe = me.visualElement, Ue = function() {
    var Ge;
    (Ge = Qe.animationState) === null || Ge === void 0 || Ge.setActive(AnimationType.Focus, !0);
  }, He = function() {
    var Ge;
    (Ge = Qe.animationState) === null || Ge === void 0 || Ge.setActive(AnimationType.Focus, !1);
  };
  useDomEvent(Qe, "focus", ue ? Ue : void 0), useDomEvent(Qe, "blur", ue ? He : void 0);
}
function isMouseEvent(me) {
  return typeof PointerEvent < "u" && me instanceof PointerEvent ? me.pointerType === "mouse" : me instanceof MouseEvent;
}
function isTouchEvent(me) {
  var ue = !!me.touches;
  return ue;
}
function filterPrimaryPointer(me) {
  return function(ue) {
    var Qe = ue instanceof MouseEvent, Ue = !Qe || Qe && ue.button === 0;
    Ue && me(ue);
  };
}
var defaultPagePoint = { pageX: 0, pageY: 0 };
function pointFromTouch(me, ue) {
  ue === void 0 && (ue = "page");
  var Qe = me.touches[0] || me.changedTouches[0], Ue = Qe || defaultPagePoint;
  return {
    x: Ue[ue + "X"],
    y: Ue[ue + "Y"]
  };
}
function pointFromMouse(me, ue) {
  return ue === void 0 && (ue = "page"), {
    x: me[ue + "X"],
    y: me[ue + "Y"]
  };
}
function extractEventInfo(me, ue) {
  return ue === void 0 && (ue = "page"), {
    point: isTouchEvent(me) ? pointFromTouch(me, ue) : pointFromMouse(me, ue)
  };
}
var wrapHandler = function(me, ue) {
  ue === void 0 && (ue = !1);
  var Qe = function(Ue) {
    return me(Ue, extractEventInfo(Ue));
  };
  return ue ? filterPrimaryPointer(Qe) : Qe;
}, supportsPointerEvents = function() {
  return isBrowser$1 && window.onpointerdown === null;
}, supportsTouchEvents = function() {
  return isBrowser$1 && window.ontouchstart === null;
}, supportsMouseEvents = function() {
  return isBrowser$1 && window.onmousedown === null;
}, mouseEventNames = {
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointercancel: "mousecancel",
  pointerover: "mouseover",
  pointerout: "mouseout",
  pointerenter: "mouseenter",
  pointerleave: "mouseleave"
}, touchEventNames = {
  pointerdown: "touchstart",
  pointermove: "touchmove",
  pointerup: "touchend",
  pointercancel: "touchcancel"
};
function getPointerEventName(me) {
  return supportsPointerEvents() ? me : supportsTouchEvents() ? touchEventNames[me] : supportsMouseEvents() ? mouseEventNames[me] : me;
}
function addPointerEvent(me, ue, Qe, Ue) {
  return addDomEvent(me, getPointerEventName(ue), wrapHandler(Qe, ue === "pointerdown"), Ue);
}
function usePointerEvent(me, ue, Qe, Ue) {
  return useDomEvent(me, getPointerEventName(ue), Qe && wrapHandler(Qe, ue === "pointerdown"), Ue);
}
function createLock(me) {
  var ue = null;
  return function() {
    var Qe = function() {
      ue = null;
    };
    return ue === null ? (ue = me, Qe) : !1;
  };
}
var globalHorizontalLock = createLock("dragHorizontal"), globalVerticalLock = createLock("dragVertical");
function getGlobalLock(me) {
  var ue = !1;
  if (me === "y")
    ue = globalVerticalLock();
  else if (me === "x")
    ue = globalHorizontalLock();
  else {
    var Qe = globalHorizontalLock(), Ue = globalVerticalLock();
    Qe && Ue ? ue = function() {
      Qe(), Ue();
    } : (Qe && Qe(), Ue && Ue());
  }
  return ue;
}
function isDragActive() {
  var me = getGlobalLock(!0);
  return me ? (me(), !1) : !0;
}
function createHoverEvent(me, ue, Qe) {
  return function(Ue, He) {
    var Ge;
    !isMouseEvent(Ue) || isDragActive() || ((Ge = me.animationState) === null || Ge === void 0 || Ge.setActive(AnimationType.Hover, ue), Qe == null || Qe(Ue, He));
  };
}
function useHoverGesture(me) {
  var ue = me.onHoverStart, Qe = me.onHoverEnd, Ue = me.whileHover, He = me.visualElement;
  usePointerEvent(He, "pointerenter", ue || Ue ? createHoverEvent(He, !0, ue) : void 0, { passive: !ue }), usePointerEvent(He, "pointerleave", Qe || Ue ? createHoverEvent(He, !1, Qe) : void 0, { passive: !Qe });
}
var isNodeOrChild = function(me, ue) {
  return ue ? me === ue ? !0 : isNodeOrChild(me, ue.parentElement) : !1;
};
function useUnmountEffect(me) {
  return useEffect(function() {
    return function() {
      return me();
    };
  }, []);
}
const clamp = (me, ue, Qe) => Math.min(Math.max(Qe, me), ue), safeMin = 1e-3, minDuration = 0.01, maxDuration = 10, minDamping = 0.05, maxDamping = 1;
function findSpring({ duration: me = 800, bounce: ue = 0.25, velocity: Qe = 0, mass: Ue = 1 }) {
  let He, Ge;
  warning$3(me <= maxDuration * 1e3, "Spring duration must be 10 seconds or less");
  let Xe = 1 - ue;
  Xe = clamp(minDamping, maxDamping, Xe), me = clamp(minDuration, maxDuration, me / 1e3), Xe < 1 ? (He = (Je) => {
    const Ze = Je * Xe, nt = Ze * me, tt = Ze - Qe, et = calcAngularFreq(Je, Xe), rt = Math.exp(-nt);
    return safeMin - tt / et * rt;
  }, Ge = (Je) => {
    const nt = Je * Xe * me, tt = nt * Qe + Qe, et = Math.pow(Xe, 2) * Math.pow(Je, 2) * me, rt = Math.exp(-nt), it = calcAngularFreq(Math.pow(Je, 2), Xe);
    return (-He(Je) + safeMin > 0 ? -1 : 1) * ((tt - et) * rt) / it;
  }) : (He = (Je) => {
    const Ze = Math.exp(-Je * me), nt = (Je - Qe) * me + 1;
    return -safeMin + Ze * nt;
  }, Ge = (Je) => {
    const Ze = Math.exp(-Je * me), nt = (Qe - Je) * (me * me);
    return Ze * nt;
  });
  const Ke = 5 / me, $e = approximateRoot(He, Ge, Ke);
  if (me = me * 1e3, isNaN($e))
    return {
      stiffness: 100,
      damping: 10,
      duration: me
    };
  {
    const Je = Math.pow($e, 2) * Ue;
    return {
      stiffness: Je,
      damping: Xe * 2 * Math.sqrt(Ue * Je),
      duration: me
    };
  }
}
const rootIterations = 12;
function approximateRoot(me, ue, Qe) {
  let Ue = Qe;
  for (let He = 1; He < rootIterations; He++)
    Ue = Ue - me(Ue) / ue(Ue);
  return Ue;
}
function calcAngularFreq(me, ue) {
  return me * Math.sqrt(1 - ue * ue);
}
const durationKeys = ["duration", "bounce"], physicsKeys = ["stiffness", "damping", "mass"];
function isSpringType(me, ue) {
  return ue.some((Qe) => me[Qe] !== void 0);
}
function getSpringOptions(me) {
  let ue = Object.assign({ velocity: 0, stiffness: 100, damping: 10, mass: 1, isResolvedFromDuration: !1 }, me);
  if (!isSpringType(me, physicsKeys) && isSpringType(me, durationKeys)) {
    const Qe = findSpring(me);
    ue = Object.assign(Object.assign(Object.assign({}, ue), Qe), { velocity: 0, mass: 1 }), ue.isResolvedFromDuration = !0;
  }
  return ue;
}
function spring(me) {
  var { from: ue = 0, to: Qe = 1, restSpeed: Ue = 2, restDelta: He } = me, Ge = __rest$3(me, ["from", "to", "restSpeed", "restDelta"]);
  const Xe = { done: !1, value: ue };
  let { stiffness: Ke, damping: $e, mass: Je, velocity: Ze, duration: nt, isResolvedFromDuration: tt } = getSpringOptions(Ge), et = zero, rt = zero;
  function it() {
    const ot = Ze ? -(Ze / 1e3) : 0, at = Qe - ue, st = $e / (2 * Math.sqrt(Ke * Je)), ut = Math.sqrt(Ke / Je) / 1e3;
    if (He === void 0 && (He = Math.min(Math.abs(Qe - ue) / 100, 0.4)), st < 1) {
      const lt = calcAngularFreq(ut, st);
      et = (dt) => {
        const At = Math.exp(-st * ut * dt);
        return Qe - At * ((ot + st * ut * at) / lt * Math.sin(lt * dt) + at * Math.cos(lt * dt));
      }, rt = (dt) => {
        const At = Math.exp(-st * ut * dt);
        return st * ut * At * (Math.sin(lt * dt) * (ot + st * ut * at) / lt + at * Math.cos(lt * dt)) - At * (Math.cos(lt * dt) * (ot + st * ut * at) - lt * at * Math.sin(lt * dt));
      };
    } else if (st === 1)
      et = (lt) => Qe - Math.exp(-ut * lt) * (at + (ot + ut * at) * lt);
    else {
      const lt = ut * Math.sqrt(st * st - 1);
      et = (dt) => {
        const At = Math.exp(-st * ut * dt), pt = Math.min(lt * dt, 300);
        return Qe - At * ((ot + st * ut * at) * Math.sinh(pt) + lt * at * Math.cosh(pt)) / lt;
      };
    }
  }
  return it(), {
    next: (ot) => {
      const at = et(ot);
      if (tt)
        Xe.done = ot >= nt;
      else {
        const st = rt(ot) * 1e3, ut = Math.abs(st) <= Ue, lt = Math.abs(Qe - at) <= He;
        Xe.done = ut && lt;
      }
      return Xe.value = Xe.done ? Qe : at, Xe;
    },
    flipTarget: () => {
      Ze = -Ze, [ue, Qe] = [Qe, ue], it();
    }
  };
}
spring.needsInterpolation = (me, ue) => typeof me == "string" || typeof ue == "string";
const zero = (me) => 0, progress = (me, ue, Qe) => {
  const Ue = ue - me;
  return Ue === 0 ? 1 : (Qe - me) / Ue;
}, mix = (me, ue, Qe) => -Qe * me + Qe * ue + me;
function hueToRgb(me, ue, Qe) {
  return Qe < 0 && (Qe += 1), Qe > 1 && (Qe -= 1), Qe < 1 / 6 ? me + (ue - me) * 6 * Qe : Qe < 1 / 2 ? ue : Qe < 2 / 3 ? me + (ue - me) * (2 / 3 - Qe) * 6 : me;
}
function hslaToRgba({ hue: me, saturation: ue, lightness: Qe, alpha: Ue }) {
  me /= 360, ue /= 100, Qe /= 100;
  let He = 0, Ge = 0, Xe = 0;
  if (!ue)
    He = Ge = Xe = Qe;
  else {
    const Ke = Qe < 0.5 ? Qe * (1 + ue) : Qe + ue - Qe * ue, $e = 2 * Qe - Ke;
    He = hueToRgb($e, Ke, me + 1 / 3), Ge = hueToRgb($e, Ke, me), Xe = hueToRgb($e, Ke, me - 1 / 3);
  }
  return {
    red: Math.round(He * 255),
    green: Math.round(Ge * 255),
    blue: Math.round(Xe * 255),
    alpha: Ue
  };
}
const mixLinearColor = (me, ue, Qe) => {
  const Ue = me * me, He = ue * ue;
  return Math.sqrt(Math.max(0, Qe * (He - Ue) + Ue));
}, colorTypes = [hex, rgba, hsla], getColorType = (me) => colorTypes.find((ue) => ue.test(me)), notAnimatable = (me) => `'${me}' is not an animatable color. Use the equivalent color code instead.`, mixColor = (me, ue) => {
  let Qe = getColorType(me), Ue = getColorType(ue);
  invariant$1(!!Qe, notAnimatable(me)), invariant$1(!!Ue, notAnimatable(ue));
  let He = Qe.parse(me), Ge = Ue.parse(ue);
  Qe === hsla && (He = hslaToRgba(He), Qe = rgba), Ue === hsla && (Ge = hslaToRgba(Ge), Ue = rgba);
  const Xe = Object.assign({}, He);
  return (Ke) => {
    for (const $e in Xe)
      $e !== "alpha" && (Xe[$e] = mixLinearColor(He[$e], Ge[$e], Ke));
    return Xe.alpha = mix(He.alpha, Ge.alpha, Ke), Qe.transform(Xe);
  };
}, isNum = (me) => typeof me == "number", combineFunctions = (me, ue) => (Qe) => ue(me(Qe)), pipe = (...me) => me.reduce(combineFunctions);
function getMixer(me, ue) {
  return isNum(me) ? (Qe) => mix(me, ue, Qe) : color$1.test(me) ? mixColor(me, ue) : mixComplex(me, ue);
}
const mixArray = (me, ue) => {
  const Qe = [...me], Ue = Qe.length, He = me.map((Ge, Xe) => getMixer(Ge, ue[Xe]));
  return (Ge) => {
    for (let Xe = 0; Xe < Ue; Xe++)
      Qe[Xe] = He[Xe](Ge);
    return Qe;
  };
}, mixObject = (me, ue) => {
  const Qe = Object.assign(Object.assign({}, me), ue), Ue = {};
  for (const He in Qe)
    me[He] !== void 0 && ue[He] !== void 0 && (Ue[He] = getMixer(me[He], ue[He]));
  return (He) => {
    for (const Ge in Ue)
      Qe[Ge] = Ue[Ge](He);
    return Qe;
  };
};
function analyse(me) {
  const ue = complex.parse(me), Qe = ue.length;
  let Ue = 0, He = 0, Ge = 0;
  for (let Xe = 0; Xe < Qe; Xe++)
    Ue || typeof ue[Xe] == "number" ? Ue++ : ue[Xe].hue !== void 0 ? Ge++ : He++;
  return { parsed: ue, numNumbers: Ue, numRGB: He, numHSL: Ge };
}
const mixComplex = (me, ue) => {
  const Qe = complex.createTransformer(ue), Ue = analyse(me), He = analyse(ue);
  return Ue.numHSL === He.numHSL && Ue.numRGB === He.numRGB && Ue.numNumbers >= He.numNumbers ? pipe(mixArray(Ue.parsed, He.parsed), Qe) : (warning$3(!0, `Complex values '${me}' and '${ue}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), (Xe) => `${Xe > 0 ? ue : me}`);
}, mixNumber = (me, ue) => (Qe) => mix(me, ue, Qe);
function detectMixerFactory(me) {
  if (typeof me == "number")
    return mixNumber;
  if (typeof me == "string")
    return color$1.test(me) ? mixColor : mixComplex;
  if (Array.isArray(me))
    return mixArray;
  if (typeof me == "object")
    return mixObject;
}
function createMixers(me, ue, Qe) {
  const Ue = [], He = Qe || detectMixerFactory(me[0]), Ge = me.length - 1;
  for (let Xe = 0; Xe < Ge; Xe++) {
    let Ke = He(me[Xe], me[Xe + 1]);
    if (ue) {
      const $e = Array.isArray(ue) ? ue[Xe] : ue;
      Ke = pipe($e, Ke);
    }
    Ue.push(Ke);
  }
  return Ue;
}
function fastInterpolate([me, ue], [Qe]) {
  return (Ue) => Qe(progress(me, ue, Ue));
}
function slowInterpolate(me, ue) {
  const Qe = me.length, Ue = Qe - 1;
  return (He) => {
    let Ge = 0, Xe = !1;
    if (He <= me[0] ? Xe = !0 : He >= me[Ue] && (Ge = Ue - 1, Xe = !0), !Xe) {
      let $e = 1;
      for (; $e < Qe && !(me[$e] > He || $e === Ue); $e++)
        ;
      Ge = $e - 1;
    }
    const Ke = progress(me[Ge], me[Ge + 1], He);
    return ue[Ge](Ke);
  };
}
function interpolate(me, ue, { clamp: Qe = !0, ease: Ue, mixer: He } = {}) {
  const Ge = me.length;
  invariant$1(Ge === ue.length, "Both input and output ranges must be the same length"), invariant$1(!Ue || !Array.isArray(Ue) || Ue.length === Ge - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values."), me[0] > me[Ge - 1] && (me = [].concat(me), ue = [].concat(ue), me.reverse(), ue.reverse());
  const Xe = createMixers(ue, Ue, He), Ke = Ge === 2 ? fastInterpolate(me, Xe) : slowInterpolate(me, Xe);
  return Qe ? ($e) => Ke(clamp(me[0], me[Ge - 1], $e)) : Ke;
}
const reverseEasing = (me) => (ue) => 1 - me(1 - ue), mirrorEasing = (me) => (ue) => ue <= 0.5 ? me(2 * ue) / 2 : (2 - me(2 * (1 - ue))) / 2, createExpoIn = (me) => (ue) => Math.pow(ue, me), createBackIn = (me) => (ue) => ue * ue * ((me + 1) * ue - me), createAnticipate = (me) => {
  const ue = createBackIn(me);
  return (Qe) => (Qe *= 2) < 1 ? 0.5 * ue(Qe) : 0.5 * (2 - Math.pow(2, -10 * (Qe - 1)));
}, DEFAULT_OVERSHOOT_STRENGTH = 1.525, BOUNCE_FIRST_THRESHOLD = 4 / 11, BOUNCE_SECOND_THRESHOLD = 8 / 11, BOUNCE_THIRD_THRESHOLD = 9 / 10, linear = (me) => me, easeIn = createExpoIn(2), easeOut = reverseEasing(easeIn), easeInOut = mirrorEasing(easeIn), circIn = (me) => 1 - Math.sin(Math.acos(me)), circOut = reverseEasing(circIn), circInOut = mirrorEasing(circOut), backIn = createBackIn(DEFAULT_OVERSHOOT_STRENGTH), backOut = reverseEasing(backIn), backInOut = mirrorEasing(backIn), anticipate = createAnticipate(DEFAULT_OVERSHOOT_STRENGTH), ca = 4356 / 361, cb = 35442 / 1805, cc = 16061 / 1805, bounceOut = (me) => {
  if (me === 1 || me === 0)
    return me;
  const ue = me * me;
  return me < BOUNCE_FIRST_THRESHOLD ? 7.5625 * ue : me < BOUNCE_SECOND_THRESHOLD ? 9.075 * ue - 9.9 * me + 3.4 : me < BOUNCE_THIRD_THRESHOLD ? ca * ue - cb * me + cc : 10.8 * me * me - 20.52 * me + 10.72;
}, bounceIn = reverseEasing(bounceOut), bounceInOut = (me) => me < 0.5 ? 0.5 * (1 - bounceOut(1 - me * 2)) : 0.5 * bounceOut(me * 2 - 1) + 0.5;
function defaultEasing(me, ue) {
  return me.map(() => ue || easeInOut).splice(0, me.length - 1);
}
function defaultOffset(me) {
  const ue = me.length;
  return me.map((Qe, Ue) => Ue !== 0 ? Ue / (ue - 1) : 0);
}
function convertOffsetToTimes(me, ue) {
  return me.map((Qe) => Qe * ue);
}
function keyframes$1({ from: me = 0, to: ue = 1, ease: Qe, offset: Ue, duration: He = 300 }) {
  const Ge = { done: !1, value: me }, Xe = Array.isArray(ue) ? ue : [me, ue], Ke = convertOffsetToTimes(Ue && Ue.length === Xe.length ? Ue : defaultOffset(Xe), He);
  function $e() {
    return interpolate(Ke, Xe, {
      ease: Array.isArray(Qe) ? Qe : defaultEasing(Xe, Qe)
    });
  }
  let Je = $e();
  return {
    next: (Ze) => (Ge.value = Je(Ze), Ge.done = Ze >= He, Ge),
    flipTarget: () => {
      Xe.reverse(), Je = $e();
    }
  };
}
function decay({ velocity: me = 0, from: ue = 0, power: Qe = 0.8, timeConstant: Ue = 350, restDelta: He = 0.5, modifyTarget: Ge }) {
  const Xe = { done: !1, value: ue };
  let Ke = Qe * me;
  const $e = ue + Ke, Je = Ge === void 0 ? $e : Ge($e);
  return Je !== $e && (Ke = Je - ue), {
    next: (Ze) => {
      const nt = -Ke * Math.exp(-Ze / Ue);
      return Xe.done = !(nt > He || nt < -He), Xe.value = Xe.done ? Je : Je + nt, Xe;
    },
    flipTarget: () => {
    }
  };
}
const types$2 = { keyframes: keyframes$1, spring, decay };
function detectAnimationFromOptions(me) {
  if (Array.isArray(me.to))
    return keyframes$1;
  if (types$2[me.type])
    return types$2[me.type];
  const ue = new Set(Object.keys(me));
  return ue.has("ease") || ue.has("duration") && !ue.has("dampingRatio") ? keyframes$1 : ue.has("dampingRatio") || ue.has("stiffness") || ue.has("mass") || ue.has("damping") || ue.has("restSpeed") || ue.has("restDelta") ? spring : keyframes$1;
}
const defaultTimestep = 1 / 60 * 1e3, getCurrentTime = typeof performance < "u" ? () => performance.now() : () => Date.now(), onNextFrame = typeof window < "u" ? (me) => window.requestAnimationFrame(me) : (me) => setTimeout(() => me(getCurrentTime()), defaultTimestep);
function createRenderStep(me) {
  let ue = [], Qe = [], Ue = 0, He = !1, Ge = !1;
  const Xe = /* @__PURE__ */ new WeakSet(), Ke = {
    schedule: ($e, Je = !1, Ze = !1) => {
      const nt = Ze && He, tt = nt ? ue : Qe;
      return Je && Xe.add($e), tt.indexOf($e) === -1 && (tt.push($e), nt && He && (Ue = ue.length)), $e;
    },
    cancel: ($e) => {
      const Je = Qe.indexOf($e);
      Je !== -1 && Qe.splice(Je, 1), Xe.delete($e);
    },
    process: ($e) => {
      if (He) {
        Ge = !0;
        return;
      }
      if (He = !0, [ue, Qe] = [Qe, ue], Qe.length = 0, Ue = ue.length, Ue)
        for (let Je = 0; Je < Ue; Je++) {
          const Ze = ue[Je];
          Ze($e), Xe.has(Ze) && (Ke.schedule(Ze), me());
        }
      He = !1, Ge && (Ge = !1, Ke.process($e));
    }
  };
  return Ke;
}
const maxElapsed = 40;
let useDefaultElapsed = !0, runNextFrame = !1, isProcessing = !1;
const frame = {
  delta: 0,
  timestamp: 0
}, stepsOrder = [
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], steps$2 = stepsOrder.reduce((me, ue) => (me[ue] = createRenderStep(() => runNextFrame = !0), me), {}), sync = stepsOrder.reduce((me, ue) => {
  const Qe = steps$2[ue];
  return me[ue] = (Ue, He = !1, Ge = !1) => (runNextFrame || startLoop(), Qe.schedule(Ue, He, Ge)), me;
}, {}), cancelSync = stepsOrder.reduce((me, ue) => (me[ue] = steps$2[ue].cancel, me), {}), flushSync = stepsOrder.reduce((me, ue) => (me[ue] = () => steps$2[ue].process(frame), me), {}), processStep = (me) => steps$2[me].process(frame), processFrame = (me) => {
  runNextFrame = !1, frame.delta = useDefaultElapsed ? defaultTimestep : Math.max(Math.min(me - frame.timestamp, maxElapsed), 1), frame.timestamp = me, isProcessing = !0, stepsOrder.forEach(processStep), isProcessing = !1, runNextFrame && (useDefaultElapsed = !1, onNextFrame(processFrame));
}, startLoop = () => {
  runNextFrame = !0, useDefaultElapsed = !0, isProcessing || onNextFrame(processFrame);
}, getFrameData = () => frame;
function loopElapsed(me, ue, Qe = 0) {
  return me - ue - Qe;
}
function reverseElapsed(me, ue, Qe = 0, Ue = !0) {
  return Ue ? loopElapsed(ue + -me, ue, Qe) : ue - (me - ue) + Qe;
}
function hasRepeatDelayElapsed(me, ue, Qe, Ue) {
  return Ue ? me >= ue + Qe : me <= -Qe;
}
const framesync = (me) => {
  const ue = ({ delta: Qe }) => me(Qe);
  return {
    start: () => sync.update(ue, !0),
    stop: () => cancelSync.update(ue)
  };
};
function animate$1(me) {
  var ue, Qe, { from: Ue, autoplay: He = !0, driver: Ge = framesync, elapsed: Xe = 0, repeat: Ke = 0, repeatType: $e = "loop", repeatDelay: Je = 0, onPlay: Ze, onStop: nt, onComplete: tt, onRepeat: et, onUpdate: rt } = me, it = __rest$3(me, ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate"]);
  let { to: ot } = it, at, st = 0, ut = it.duration, lt, dt = !1, At = !0, pt;
  const gt = detectAnimationFromOptions(it);
  !((Qe = (ue = gt).needsInterpolation) === null || Qe === void 0) && Qe.call(ue, Ue, ot) && (pt = interpolate([0, 100], [Ue, ot], {
    clamp: !1
  }), Ue = 0, ot = 100);
  const wt = gt(Object.assign(Object.assign({}, it), { from: Ue, to: ot }));
  function Bt() {
    st++, $e === "reverse" ? (At = st % 2 === 0, Xe = reverseElapsed(Xe, ut, Je, At)) : (Xe = loopElapsed(Xe, ut, Je), $e === "mirror" && wt.flipTarget()), dt = !1, et && et();
  }
  function Tt() {
    at.stop(), tt && tt();
  }
  function yt(ht) {
    if (At || (ht = -ht), Xe += ht, !dt) {
      const It = wt.next(Math.max(0, Xe));
      lt = It.value, pt && (lt = pt(lt)), dt = At ? It.done : Xe <= 0;
    }
    rt == null || rt(lt), dt && (st === 0 && (ut ?? (ut = Xe)), st < Ke ? hasRepeatDelayElapsed(Xe, ut, Je, At) && Bt() : Tt());
  }
  function Ct() {
    Ze == null || Ze(), at = Ge(yt), at.start();
  }
  return He && Ct(), {
    stop: () => {
      nt == null || nt(), at.stop();
    }
  };
}
function velocityPerSecond(me, ue) {
  return ue ? me * (1e3 / ue) : 0;
}
function inertia({ from: me = 0, velocity: ue = 0, min: Qe, max: Ue, power: He = 0.8, timeConstant: Ge = 750, bounceStiffness: Xe = 500, bounceDamping: Ke = 10, restDelta: $e = 1, modifyTarget: Je, driver: Ze, onUpdate: nt, onComplete: tt, onStop: et }) {
  let rt;
  function it(ut) {
    return Qe !== void 0 && ut < Qe || Ue !== void 0 && ut > Ue;
  }
  function ot(ut) {
    return Qe === void 0 ? Ue : Ue === void 0 || Math.abs(Qe - ut) < Math.abs(Ue - ut) ? Qe : Ue;
  }
  function at(ut) {
    rt == null || rt.stop(), rt = animate$1(Object.assign(Object.assign({}, ut), {
      driver: Ze,
      onUpdate: (lt) => {
        var dt;
        nt == null || nt(lt), (dt = ut.onUpdate) === null || dt === void 0 || dt.call(ut, lt);
      },
      onComplete: tt,
      onStop: et
    }));
  }
  function st(ut) {
    at(Object.assign({ type: "spring", stiffness: Xe, damping: Ke, restDelta: $e }, ut));
  }
  if (it(me))
    st({ from: me, velocity: ue, to: ot(me) });
  else {
    let ut = He * ue + me;
    typeof Je < "u" && (ut = Je(ut));
    const lt = ot(ut), dt = lt === Qe ? -1 : 1;
    let At, pt;
    const gt = (wt) => {
      At = pt, pt = wt, ue = velocityPerSecond(wt - At, getFrameData().delta), (dt === 1 && wt > lt || dt === -1 && wt < lt) && st({ from: wt, to: lt, velocity: ue });
    };
    at({
      type: "decay",
      from: me,
      velocity: ue,
      timeConstant: Ge,
      power: He,
      restDelta: $e,
      modifyTarget: Je,
      onUpdate: it(ut) ? gt : void 0
    });
  }
  return {
    stop: () => rt == null ? void 0 : rt.stop()
  };
}
const isPoint = (me) => me.hasOwnProperty("x") && me.hasOwnProperty("y"), isPoint3D = (me) => isPoint(me) && me.hasOwnProperty("z"), distance1D = (me, ue) => Math.abs(me - ue);
function distance(me, ue) {
  if (isNum(me) && isNum(ue))
    return distance1D(me, ue);
  if (isPoint(me) && isPoint(ue)) {
    const Qe = distance1D(me.x, ue.x), Ue = distance1D(me.y, ue.y), He = isPoint3D(me) && isPoint3D(ue) ? distance1D(me.z, ue.z) : 0;
    return Math.sqrt(Math.pow(Qe, 2) + Math.pow(Ue, 2) + Math.pow(He, 2));
  }
}
const a$1 = (me, ue) => 1 - 3 * ue + 3 * me, b$2 = (me, ue) => 3 * ue - 6 * me, c$1 = (me) => 3 * me, calcBezier = (me, ue, Qe) => ((a$1(ue, Qe) * me + b$2(ue, Qe)) * me + c$1(ue)) * me, getSlope = (me, ue, Qe) => 3 * a$1(ue, Qe) * me * me + 2 * b$2(ue, Qe) * me + c$1(ue), subdivisionPrecision = 1e-7, subdivisionMaxIterations = 10;
function binarySubdivide(me, ue, Qe, Ue, He) {
  let Ge, Xe, Ke = 0;
  do
    Xe = ue + (Qe - ue) / 2, Ge = calcBezier(Xe, Ue, He) - me, Ge > 0 ? Qe = Xe : ue = Xe;
  while (Math.abs(Ge) > subdivisionPrecision && ++Ke < subdivisionMaxIterations);
  return Xe;
}
const newtonIterations = 8, newtonMinSlope = 1e-3;
function newtonRaphsonIterate(me, ue, Qe, Ue) {
  for (let He = 0; He < newtonIterations; ++He) {
    const Ge = getSlope(ue, Qe, Ue);
    if (Ge === 0)
      return ue;
    const Xe = calcBezier(ue, Qe, Ue) - me;
    ue -= Xe / Ge;
  }
  return ue;
}
const kSplineTableSize = 11, kSampleStepSize = 1 / (kSplineTableSize - 1);
function cubicBezier(me, ue, Qe, Ue) {
  if (me === ue && Qe === Ue)
    return linear;
  const He = new Float32Array(kSplineTableSize);
  for (let Xe = 0; Xe < kSplineTableSize; ++Xe)
    He[Xe] = calcBezier(Xe * kSampleStepSize, me, Qe);
  function Ge(Xe) {
    let Ke = 0, $e = 1;
    const Je = kSplineTableSize - 1;
    for (; $e !== Je && He[$e] <= Xe; ++$e)
      Ke += kSampleStepSize;
    --$e;
    const Ze = (Xe - He[$e]) / (He[$e + 1] - He[$e]), nt = Ke + Ze * kSampleStepSize, tt = getSlope(nt, me, Qe);
    return tt >= newtonMinSlope ? newtonRaphsonIterate(Xe, nt, me, Qe) : tt === 0 ? nt : binarySubdivide(Xe, Ke, Ke + kSampleStepSize, me, Qe);
  }
  return (Xe) => Xe === 0 || Xe === 1 ? Xe : calcBezier(Ge(Xe), ue, Ue);
}
function useTapGesture(me) {
  var ue = me.onTap, Qe = me.onTapStart, Ue = me.onTapCancel, He = me.whileTap, Ge = me.visualElement, Xe = ue || Qe || Ue || He, Ke = useRef(!1), $e = useRef(null), Je = {
    passive: !(Qe || ue || Ue || rt)
  };
  function Ze() {
    var it;
    (it = $e.current) === null || it === void 0 || it.call($e), $e.current = null;
  }
  function nt() {
    var it;
    return Ze(), Ke.current = !1, (it = Ge.animationState) === null || it === void 0 || it.setActive(AnimationType.Tap, !1), !isDragActive();
  }
  function tt(it, ot) {
    nt() && (isNodeOrChild(Ge.getInstance(), it.target) ? ue == null || ue(it, ot) : Ue == null || Ue(it, ot));
  }
  function et(it, ot) {
    nt() && (Ue == null || Ue(it, ot));
  }
  function rt(it, ot) {
    var at;
    Ze(), !Ke.current && (Ke.current = !0, $e.current = pipe(addPointerEvent(window, "pointerup", tt, Je), addPointerEvent(window, "pointercancel", et, Je)), (at = Ge.animationState) === null || at === void 0 || at.setActive(AnimationType.Tap, !0), Qe == null || Qe(it, ot));
  }
  usePointerEvent(Ge, "pointerdown", Xe ? rt : void 0, Je), useUnmountEffect(Ze);
}
var warned = /* @__PURE__ */ new Set();
function warnOnce(me, ue, Qe) {
  me || warned.has(ue) || (console.warn(ue), warned.add(ue));
}
var observerCallbacks = /* @__PURE__ */ new WeakMap(), observers = /* @__PURE__ */ new WeakMap(), fireObserverCallback = function(me) {
  var ue;
  (ue = observerCallbacks.get(me.target)) === null || ue === void 0 || ue(me);
}, fireAllObserverCallbacks = function(me) {
  me.forEach(fireObserverCallback);
};
function initIntersectionObserver(me) {
  var ue = me.root, Qe = __rest$3(me, ["root"]), Ue = ue || document;
  observers.has(Ue) || observers.set(Ue, {});
  var He = observers.get(Ue), Ge = JSON.stringify(Qe);
  return He[Ge] || (He[Ge] = new IntersectionObserver(fireAllObserverCallbacks, __assign$2({ root: ue }, Qe))), He[Ge];
}
function observeIntersection(me, ue, Qe) {
  var Ue = initIntersectionObserver(ue);
  return observerCallbacks.set(me, Qe), Ue.observe(me), function() {
    observerCallbacks.delete(me), Ue.unobserve(me);
  };
}
function useViewport(me) {
  var ue = me.visualElement, Qe = me.whileInView, Ue = me.onViewportEnter, He = me.onViewportLeave, Ge = me.viewport, Xe = Ge === void 0 ? {} : Ge, Ke = useRef({
    hasEnteredView: !1,
    isInView: !1
  }), $e = !!(Qe || Ue || He);
  Xe.once && Ke.current.hasEnteredView && ($e = !1);
  var Je = typeof IntersectionObserver > "u" ? useMissingIntersectionObserver : useIntersectionObserver;
  Je($e, Ke.current, ue, Xe);
}
var thresholdNames = {
  some: 0,
  all: 1
};
function useIntersectionObserver(me, ue, Qe, Ue) {
  var He = Ue.root, Ge = Ue.margin, Xe = Ue.amount, Ke = Xe === void 0 ? "some" : Xe, $e = Ue.once;
  useEffect(function() {
    if (me) {
      var Je = {
        root: He == null ? void 0 : He.current,
        rootMargin: Ge,
        threshold: typeof Ke == "number" ? Ke : thresholdNames[Ke]
      }, Ze = function(nt) {
        var tt, et = nt.isIntersecting;
        if (ue.isInView !== et && (ue.isInView = et, !($e && !et && ue.hasEnteredView))) {
          et && (ue.hasEnteredView = !0), (tt = Qe.animationState) === null || tt === void 0 || tt.setActive(AnimationType.InView, et);
          var rt = Qe.getProps(), it = et ? rt.onViewportEnter : rt.onViewportLeave;
          it == null || it(nt);
        }
      };
      return observeIntersection(Qe.getInstance(), Je, Ze);
    }
  }, [me, He, Ge, Ke]);
}
function useMissingIntersectionObserver(me, ue, Qe, Ue) {
  var He = Ue.fallback, Ge = He === void 0 ? !0 : He;
  useEffect(function() {
    !me || !Ge || (env$1 !== "production" && warnOnce(!1, "IntersectionObserver not available on this device. whileInView animations will trigger on mount."), requestAnimationFrame(function() {
      var Xe;
      ue.hasEnteredView = !0;
      var Ke = Qe.getProps().onViewportEnter;
      Ke == null || Ke(null), (Xe = Qe.animationState) === null || Xe === void 0 || Xe.setActive(AnimationType.InView, !0);
    }));
  }, [me]);
}
var makeRenderlessComponent = function(me) {
  return function(ue) {
    return me(ue), null;
  };
}, gestureAnimations = {
  inView: makeRenderlessComponent(useViewport),
  tap: makeRenderlessComponent(useTapGesture),
  focus: makeRenderlessComponent(useFocusGesture),
  hover: makeRenderlessComponent(useHoverGesture)
}, counter = 0, incrementId = function() {
  return counter++;
}, useId = function() {
  return useConstant(incrementId);
};
function usePresence() {
  var me = useContext(PresenceContext);
  if (me === null)
    return [!0, null];
  var ue = me.isPresent, Qe = me.onExitComplete, Ue = me.register, He = useId();
  useEffect(function() {
    return Ue(He);
  }, []);
  var Ge = function() {
    return Qe == null ? void 0 : Qe(He);
  };
  return !ue && Qe ? [!1, Ge] : [!0];
}
function shallowCompare(me, ue) {
  if (!Array.isArray(ue))
    return !1;
  var Qe = ue.length;
  if (Qe !== me.length)
    return !1;
  for (var Ue = 0; Ue < Qe; Ue++)
    if (ue[Ue] !== me[Ue])
      return !1;
  return !0;
}
var secondsToMilliseconds = function(me) {
  return me * 1e3;
}, easingLookup = {
  linear,
  easeIn,
  easeInOut,
  easeOut,
  circIn,
  circInOut,
  circOut,
  backIn,
  backInOut,
  backOut,
  anticipate,
  bounceIn,
  bounceInOut,
  bounceOut
}, easingDefinitionToFunction = function(me) {
  if (Array.isArray(me)) {
    invariant$1(me.length === 4, "Cubic bezier arrays must contain four numerical values.");
    var ue = __read$1(me, 4), Qe = ue[0], Ue = ue[1], He = ue[2], Ge = ue[3];
    return cubicBezier(Qe, Ue, He, Ge);
  } else if (typeof me == "string")
    return invariant$1(easingLookup[me] !== void 0, "Invalid easing type '".concat(me, "'")), easingLookup[me];
  return me;
}, isEasingArray = function(me) {
  return Array.isArray(me) && typeof me[0] != "number";
}, isAnimatable = function(me, ue) {
  return me === "zIndex" ? !1 : !!(typeof ue == "number" || Array.isArray(ue) || typeof ue == "string" && // It's animatable if we have a string
  complex.test(ue) && // And it contains numbers and/or colors
  !ue.startsWith("url("));
}, underDampedSpring = function() {
  return {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
  };
}, criticallyDampedSpring = function(me) {
  return {
    type: "spring",
    stiffness: 550,
    damping: me === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10
  };
}, linearTween = function() {
  return {
    type: "keyframes",
    ease: "linear",
    duration: 0.3
  };
}, keyframes = function(me) {
  return {
    type: "keyframes",
    duration: 0.8,
    values: me
  };
}, defaultTransitions = {
  x: underDampedSpring,
  y: underDampedSpring,
  z: underDampedSpring,
  rotate: underDampedSpring,
  rotateX: underDampedSpring,
  rotateY: underDampedSpring,
  rotateZ: underDampedSpring,
  scaleX: criticallyDampedSpring,
  scaleY: criticallyDampedSpring,
  scale: criticallyDampedSpring,
  opacity: linearTween,
  backgroundColor: linearTween,
  color: linearTween,
  default: criticallyDampedSpring
}, getDefaultTransition = function(me, ue) {
  var Qe;
  return isKeyframesTarget(ue) ? Qe = keyframes : Qe = defaultTransitions[me] || defaultTransitions.default, __assign$2({ to: ue }, Qe(ue));
}, defaultValueTypes = __assign$2(__assign$2({}, numberValueTypes), {
  // Color props
  color: color$1,
  backgroundColor: color$1,
  outlineColor: color$1,
  fill: color$1,
  stroke: color$1,
  // Border props
  borderColor: color$1,
  borderTopColor: color$1,
  borderRightColor: color$1,
  borderBottomColor: color$1,
  borderLeftColor: color$1,
  filter,
  WebkitFilter: filter
}), getDefaultValueType = function(me) {
  return defaultValueTypes[me];
};
function getAnimatableNone(me, ue) {
  var Qe, Ue = getDefaultValueType(me);
  return Ue !== filter && (Ue = complex), (Qe = Ue.getAnimatableNone) === null || Qe === void 0 ? void 0 : Qe.call(Ue, ue);
}
function isTransitionDefined(me) {
  me.when, me.delay, me.delayChildren, me.staggerChildren, me.staggerDirection, me.repeat, me.repeatType, me.repeatDelay, me.from;
  var ue = __rest$3(me, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from"]);
  return !!Object.keys(ue).length;
}
var legacyRepeatWarning = !1;
function convertTransitionToAnimationOptions(me) {
  var ue = me.ease, Qe = me.times, Ue = me.yoyo, He = me.flip, Ge = me.loop, Xe = __rest$3(me, ["ease", "times", "yoyo", "flip", "loop"]), Ke = __assign$2({}, Xe);
  return Qe && (Ke.offset = Qe), Xe.duration && (Ke.duration = secondsToMilliseconds(Xe.duration)), Xe.repeatDelay && (Ke.repeatDelay = secondsToMilliseconds(Xe.repeatDelay)), ue && (Ke.ease = isEasingArray(ue) ? ue.map(easingDefinitionToFunction) : easingDefinitionToFunction(ue)), Xe.type === "tween" && (Ke.type = "keyframes"), (Ue || Ge || He) && (warning$3(!legacyRepeatWarning, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options."), legacyRepeatWarning = !0, Ue ? Ke.repeatType = "reverse" : Ge ? Ke.repeatType = "loop" : He && (Ke.repeatType = "mirror"), Ke.repeat = Ge || Ue || He || Xe.repeat), Xe.type !== "spring" && (Ke.type = "keyframes"), Ke;
}
function getDelayFromTransition(me, ue) {
  var Qe, Ue, He = getValueTransition(me, ue) || {};
  return (Ue = (Qe = He.delay) !== null && Qe !== void 0 ? Qe : me.delay) !== null && Ue !== void 0 ? Ue : 0;
}
function hydrateKeyframes(me) {
  return Array.isArray(me.to) && me.to[0] === null && (me.to = __spreadArray$1([], __read$1(me.to), !1), me.to[0] = me.from), me;
}
function getPopmotionAnimationOptions(me, ue, Qe) {
  var Ue;
  return Array.isArray(ue.to) && ((Ue = me.duration) !== null && Ue !== void 0 || (me.duration = 0.8)), hydrateKeyframes(ue), isTransitionDefined(me) || (me = __assign$2(__assign$2({}, me), getDefaultTransition(Qe, ue.to))), __assign$2(__assign$2({}, ue), convertTransitionToAnimationOptions(me));
}
function getAnimation(me, ue, Qe, Ue, He) {
  var Ge, Xe = getValueTransition(Ue, me), Ke = (Ge = Xe.from) !== null && Ge !== void 0 ? Ge : ue.get(), $e = isAnimatable(me, Qe);
  Ke === "none" && $e && typeof Qe == "string" ? Ke = getAnimatableNone(me, Qe) : isZero(Ke) && typeof Qe == "string" ? Ke = getZeroUnit(Qe) : !Array.isArray(Qe) && isZero(Qe) && typeof Ke == "string" && (Qe = getZeroUnit(Ke));
  var Je = isAnimatable(me, Ke);
  warning$3(Je === $e, "You are trying to animate ".concat(me, ' from "').concat(Ke, '" to "').concat(Qe, '". ').concat(Ke, " is not an animatable value - to enable this animation set ").concat(Ke, " to a value animatable to ").concat(Qe, " via the `style` property."));
  function Ze() {
    var tt = {
      from: Ke,
      to: Qe,
      velocity: ue.getVelocity(),
      onComplete: He,
      onUpdate: function(et) {
        return ue.set(et);
      }
    };
    return Xe.type === "inertia" || Xe.type === "decay" ? inertia(__assign$2(__assign$2({}, tt), Xe)) : animate$1(__assign$2(__assign$2({}, getPopmotionAnimationOptions(Xe, tt, me)), { onUpdate: function(et) {
      var rt;
      tt.onUpdate(et), (rt = Xe.onUpdate) === null || rt === void 0 || rt.call(Xe, et);
    }, onComplete: function() {
      var et;
      tt.onComplete(), (et = Xe.onComplete) === null || et === void 0 || et.call(Xe);
    } }));
  }
  function nt() {
    var tt, et, rt = resolveFinalValueInKeyframes(Qe);
    return ue.set(rt), He(), (tt = Xe == null ? void 0 : Xe.onUpdate) === null || tt === void 0 || tt.call(Xe, rt), (et = Xe == null ? void 0 : Xe.onComplete) === null || et === void 0 || et.call(Xe), { stop: function() {
    } };
  }
  return !Je || !$e || Xe.type === !1 ? nt : Ze;
}
function isZero(me) {
  return me === 0 || typeof me == "string" && parseFloat(me) === 0 && me.indexOf(" ") === -1;
}
function getZeroUnit(me) {
  return typeof me == "number" ? 0 : getAnimatableNone("", me);
}
function getValueTransition(me, ue) {
  return me[ue] || me.default || me;
}
function startAnimation(me, ue, Qe, Ue) {
  return Ue === void 0 && (Ue = {}), ue.start(function(He) {
    var Ge, Xe, Ke = getAnimation(me, ue, Qe, Ue, He), $e = getDelayFromTransition(Ue, me), Je = function() {
      return Xe = Ke();
    };
    return $e ? Ge = window.setTimeout(Je, secondsToMilliseconds($e)) : Je(), function() {
      clearTimeout(Ge), Xe == null || Xe.stop();
    };
  });
}
var isNumericalString = function(me) {
  return /^\-?\d*\.?\d+$/.test(me);
}, isZeroValueString = function(me) {
  return /^0[^.\s]+$/.test(me);
};
function addUniqueItem(me, ue) {
  me.indexOf(ue) === -1 && me.push(ue);
}
function removeItem(me, ue) {
  var Qe = me.indexOf(ue);
  Qe > -1 && me.splice(Qe, 1);
}
var SubscriptionManager = (
  /** @class */
  function() {
    function me() {
      this.subscriptions = [];
    }
    return me.prototype.add = function(ue) {
      var Qe = this;
      return addUniqueItem(this.subscriptions, ue), function() {
        return removeItem(Qe.subscriptions, ue);
      };
    }, me.prototype.notify = function(ue, Qe, Ue) {
      var He = this.subscriptions.length;
      if (He)
        if (He === 1)
          this.subscriptions[0](ue, Qe, Ue);
        else
          for (var Ge = 0; Ge < He; Ge++) {
            var Xe = this.subscriptions[Ge];
            Xe && Xe(ue, Qe, Ue);
          }
    }, me.prototype.getSize = function() {
      return this.subscriptions.length;
    }, me.prototype.clear = function() {
      this.subscriptions.length = 0;
    }, me;
  }()
), isFloat = function(me) {
  return !isNaN(parseFloat(me));
}, MotionValue = (
  /** @class */
  function() {
    function me(ue) {
      var Qe = this;
      this.version = "6.5.1", this.timeDelta = 0, this.lastUpdated = 0, this.updateSubscribers = new SubscriptionManager(), this.velocityUpdateSubscribers = new SubscriptionManager(), this.renderSubscribers = new SubscriptionManager(), this.canTrackVelocity = !1, this.updateAndNotify = function(Ue, He) {
        He === void 0 && (He = !0), Qe.prev = Qe.current, Qe.current = Ue;
        var Ge = getFrameData(), Xe = Ge.delta, Ke = Ge.timestamp;
        Qe.lastUpdated !== Ke && (Qe.timeDelta = Xe, Qe.lastUpdated = Ke, sync.postRender(Qe.scheduleVelocityCheck)), Qe.prev !== Qe.current && Qe.updateSubscribers.notify(Qe.current), Qe.velocityUpdateSubscribers.getSize() && Qe.velocityUpdateSubscribers.notify(Qe.getVelocity()), He && Qe.renderSubscribers.notify(Qe.current);
      }, this.scheduleVelocityCheck = function() {
        return sync.postRender(Qe.velocityCheck);
      }, this.velocityCheck = function(Ue) {
        var He = Ue.timestamp;
        He !== Qe.lastUpdated && (Qe.prev = Qe.current, Qe.velocityUpdateSubscribers.notify(Qe.getVelocity()));
      }, this.hasAnimated = !1, this.prev = this.current = ue, this.canTrackVelocity = isFloat(this.current);
    }
    return me.prototype.onChange = function(ue) {
      return this.updateSubscribers.add(ue);
    }, me.prototype.clearListeners = function() {
      this.updateSubscribers.clear();
    }, me.prototype.onRenderRequest = function(ue) {
      return ue(this.get()), this.renderSubscribers.add(ue);
    }, me.prototype.attach = function(ue) {
      this.passiveEffect = ue;
    }, me.prototype.set = function(ue, Qe) {
      Qe === void 0 && (Qe = !0), !Qe || !this.passiveEffect ? this.updateAndNotify(ue, Qe) : this.passiveEffect(ue, this.updateAndNotify);
    }, me.prototype.get = function() {
      return this.current;
    }, me.prototype.getPrevious = function() {
      return this.prev;
    }, me.prototype.getVelocity = function() {
      return this.canTrackVelocity ? (
        // These casts could be avoided if parseFloat would be typed better
        velocityPerSecond(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
      ) : 0;
    }, me.prototype.start = function(ue) {
      var Qe = this;
      return this.stop(), new Promise(function(Ue) {
        Qe.hasAnimated = !0, Qe.stopAnimation = ue(Ue);
      }).then(function() {
        return Qe.clearAnimation();
      });
    }, me.prototype.stop = function() {
      this.stopAnimation && this.stopAnimation(), this.clearAnimation();
    }, me.prototype.isAnimating = function() {
      return !!this.stopAnimation;
    }, me.prototype.clearAnimation = function() {
      this.stopAnimation = null;
    }, me.prototype.destroy = function() {
      this.updateSubscribers.clear(), this.renderSubscribers.clear(), this.stop();
    }, me;
  }()
);
function motionValue(me) {
  return new MotionValue(me);
}
var testValueType = function(me) {
  return function(ue) {
    return ue.test(me);
  };
}, auto = {
  test: function(me) {
    return me === "auto";
  },
  parse: function(me) {
    return me;
  }
}, dimensionValueTypes = [number$1, px, percent, degrees, vw, vh, auto], findDimensionValueType = function(me) {
  return dimensionValueTypes.find(testValueType(me));
}, valueTypes = __spreadArray$1(__spreadArray$1([], __read$1(dimensionValueTypes), !1), [color$1, complex], !1), findValueType = function(me) {
  return valueTypes.find(testValueType(me));
};
function setMotionValue(me, ue, Qe) {
  me.hasValue(ue) ? me.getValue(ue).set(Qe) : me.addValue(ue, motionValue(Qe));
}
function setTarget(me, ue) {
  var Qe = resolveVariant(me, ue), Ue = Qe ? me.makeTargetAnimatable(Qe, !1) : {}, He = Ue.transitionEnd, Ge = He === void 0 ? {} : He;
  Ue.transition;
  var Xe = __rest$3(Ue, ["transitionEnd", "transition"]);
  Xe = __assign$2(__assign$2({}, Xe), Ge);
  for (var Ke in Xe) {
    var $e = resolveFinalValueInKeyframes(Xe[Ke]);
    setMotionValue(me, Ke, $e);
  }
}
function checkTargetForNewValues(me, ue, Qe) {
  var Ue, He, Ge, Xe, Ke = Object.keys(ue).filter(function(et) {
    return !me.hasValue(et);
  }), $e = Ke.length;
  if ($e)
    for (var Je = 0; Je < $e; Je++) {
      var Ze = Ke[Je], nt = ue[Ze], tt = null;
      Array.isArray(nt) && (tt = nt[0]), tt === null && (tt = (He = (Ue = Qe[Ze]) !== null && Ue !== void 0 ? Ue : me.readValue(Ze)) !== null && He !== void 0 ? He : ue[Ze]), tt != null && (typeof tt == "string" && (isNumericalString(tt) || isZeroValueString(tt)) ? tt = parseFloat(tt) : !findValueType(tt) && complex.test(nt) && (tt = getAnimatableNone(Ze, nt)), me.addValue(Ze, motionValue(tt)), (Ge = (Xe = Qe)[Ze]) !== null && Ge !== void 0 || (Xe[Ze] = tt), me.setBaseTarget(Ze, tt));
    }
}
function getOriginFromTransition(me, ue) {
  if (ue) {
    var Qe = ue[me] || ue.default || ue;
    return Qe.from;
  }
}
function getOrigin(me, ue, Qe) {
  var Ue, He, Ge = {};
  for (var Xe in me)
    Ge[Xe] = (Ue = getOriginFromTransition(Xe, ue)) !== null && Ue !== void 0 ? Ue : (He = Qe.getValue(Xe)) === null || He === void 0 ? void 0 : He.get();
  return Ge;
}
function animateVisualElement(me, ue, Qe) {
  Qe === void 0 && (Qe = {}), me.notifyAnimationStart(ue);
  var Ue;
  if (Array.isArray(ue)) {
    var He = ue.map(function(Xe) {
      return animateVariant(me, Xe, Qe);
    });
    Ue = Promise.all(He);
  } else if (typeof ue == "string")
    Ue = animateVariant(me, ue, Qe);
  else {
    var Ge = typeof ue == "function" ? resolveVariant(me, ue, Qe.custom) : ue;
    Ue = animateTarget(me, Ge, Qe);
  }
  return Ue.then(function() {
    return me.notifyAnimationComplete(ue);
  });
}
function animateVariant(me, ue, Qe) {
  var Ue;
  Qe === void 0 && (Qe = {});
  var He = resolveVariant(me, ue, Qe.custom), Ge = (He || {}).transition, Xe = Ge === void 0 ? me.getDefaultTransition() || {} : Ge;
  Qe.transitionOverride && (Xe = Qe.transitionOverride);
  var Ke = He ? function() {
    return animateTarget(me, He, Qe);
  } : function() {
    return Promise.resolve();
  }, $e = !((Ue = me.variantChildren) === null || Ue === void 0) && Ue.size ? function(et) {
    et === void 0 && (et = 0);
    var rt = Xe.delayChildren, it = rt === void 0 ? 0 : rt, ot = Xe.staggerChildren, at = Xe.staggerDirection;
    return animateChildren(me, ue, it + et, ot, at, Qe);
  } : function() {
    return Promise.resolve();
  }, Je = Xe.when;
  if (Je) {
    var Ze = __read$1(Je === "beforeChildren" ? [Ke, $e] : [$e, Ke], 2), nt = Ze[0], tt = Ze[1];
    return nt().then(tt);
  } else
    return Promise.all([Ke(), $e(Qe.delay)]);
}
function animateTarget(me, ue, Qe) {
  var Ue, He = Qe === void 0 ? {} : Qe, Ge = He.delay, Xe = Ge === void 0 ? 0 : Ge, Ke = He.transitionOverride, $e = He.type, Je = me.makeTargetAnimatable(ue), Ze = Je.transition, nt = Ze === void 0 ? me.getDefaultTransition() : Ze, tt = Je.transitionEnd, et = __rest$3(Je, ["transition", "transitionEnd"]);
  Ke && (nt = Ke);
  var rt = [], it = $e && ((Ue = me.animationState) === null || Ue === void 0 ? void 0 : Ue.getState()[$e]);
  for (var ot in et) {
    var at = me.getValue(ot), st = et[ot];
    if (!(!at || st === void 0 || it && shouldBlockAnimation(it, ot))) {
      var ut = __assign$2({ delay: Xe }, nt);
      me.shouldReduceMotion && isTransformProp(ot) && (ut = __assign$2(__assign$2({}, ut), { type: !1, delay: 0 }));
      var lt = startAnimation(ot, at, st, ut);
      rt.push(lt);
    }
  }
  return Promise.all(rt).then(function() {
    tt && setTarget(me, tt);
  });
}
function animateChildren(me, ue, Qe, Ue, He, Ge) {
  Qe === void 0 && (Qe = 0), Ue === void 0 && (Ue = 0), He === void 0 && (He = 1);
  var Xe = [], Ke = (me.variantChildren.size - 1) * Ue, $e = He === 1 ? function(Je) {
    return Je === void 0 && (Je = 0), Je * Ue;
  } : function(Je) {
    return Je === void 0 && (Je = 0), Ke - Je * Ue;
  };
  return Array.from(me.variantChildren).sort(sortByTreeOrder).forEach(function(Je, Ze) {
    Xe.push(animateVariant(Je, ue, __assign$2(__assign$2({}, Ge), { delay: Qe + $e(Ze) })).then(function() {
      return Je.notifyAnimationComplete(ue);
    }));
  }), Promise.all(Xe);
}
function sortByTreeOrder(me, ue) {
  return me.sortNodePosition(ue);
}
function shouldBlockAnimation(me, ue) {
  var Qe = me.protectedKeys, Ue = me.needsAnimating, He = Qe.hasOwnProperty(ue) && Ue[ue] !== !0;
  return Ue[ue] = !1, He;
}
var variantPriorityOrder = [
  AnimationType.Animate,
  AnimationType.InView,
  AnimationType.Focus,
  AnimationType.Hover,
  AnimationType.Tap,
  AnimationType.Drag,
  AnimationType.Exit
], reversePriorityOrder = __spreadArray$1([], __read$1(variantPriorityOrder), !1).reverse(), numAnimationTypes = variantPriorityOrder.length;
function animateList(me) {
  return function(ue) {
    return Promise.all(ue.map(function(Qe) {
      var Ue = Qe.animation, He = Qe.options;
      return animateVisualElement(me, Ue, He);
    }));
  };
}
function createAnimationState(me) {
  var ue = animateList(me), Qe = createState$1(), Ue = {}, He = !0, Ge = function(Ze, nt) {
    var tt = resolveVariant(me, nt);
    if (tt) {
      tt.transition;
      var et = tt.transitionEnd, rt = __rest$3(tt, ["transition", "transitionEnd"]);
      Ze = __assign$2(__assign$2(__assign$2({}, Ze), rt), et);
    }
    return Ze;
  };
  function Xe(Ze) {
    return Ue[Ze] !== void 0;
  }
  function Ke(Ze) {
    ue = Ze(me);
  }
  function $e(Ze, nt) {
    for (var tt, et = me.getProps(), rt = me.getVariantContext(!0) || {}, it = [], ot = /* @__PURE__ */ new Set(), at = {}, st = 1 / 0, ut = function(pt) {
      var gt = reversePriorityOrder[pt], wt = Qe[gt], Bt = (tt = et[gt]) !== null && tt !== void 0 ? tt : rt[gt], Tt = isVariantLabel(Bt), yt = gt === nt ? wt.isActive : null;
      yt === !1 && (st = pt);
      var Ct = Bt === rt[gt] && Bt !== et[gt] && Tt;
      if (Ct && He && me.manuallyAnimateOnMount && (Ct = !1), wt.protectedKeys = __assign$2({}, at), // If it isn't active and hasn't *just* been set as inactive
      !wt.isActive && yt === null || // If we didn't and don't have any defined prop for this animation type
      !Bt && !wt.prevProp || // Or if the prop doesn't define an animation
      isAnimationControls(Bt) || typeof Bt == "boolean")
        return "continue";
      var ht = checkVariantsDidChange(wt.prevProp, Bt), It = ht || // If we're making this variant active, we want to always make it active
      gt === nt && wt.isActive && !Ct && Tt || // If we removed a higher-priority variant (i is in reverse order)
      pt > st && Tt, vt = Array.isArray(Bt) ? Bt : [Bt], Et = vt.reduce(Ge, {});
      yt === !1 && (Et = {});
      var bt = wt.prevResolvedValues, Rt = bt === void 0 ? {} : bt, St = __assign$2(__assign$2({}, Rt), Et), kt = function(qt) {
        It = !0, ot.delete(qt), wt.needsAnimating[qt] = !0;
      };
      for (var jt in St) {
        var Pt = Et[jt], Qt = Rt[jt];
        at.hasOwnProperty(jt) || (Pt !== Qt ? isKeyframesTarget(Pt) && isKeyframesTarget(Qt) ? !shallowCompare(Pt, Qt) || ht ? kt(jt) : wt.protectedKeys[jt] = !0 : Pt !== void 0 ? kt(jt) : ot.add(jt) : Pt !== void 0 && ot.has(jt) ? kt(jt) : wt.protectedKeys[jt] = !0);
      }
      wt.prevProp = Bt, wt.prevResolvedValues = Et, wt.isActive && (at = __assign$2(__assign$2({}, at), Et)), He && me.blockInitialAnimation && (It = !1), It && !Ct && it.push.apply(it, __spreadArray$1([], __read$1(vt.map(function(qt) {
        return {
          animation: qt,
          options: __assign$2({ type: gt }, Ze)
        };
      })), !1));
    }, lt = 0; lt < numAnimationTypes; lt++)
      ut(lt);
    if (Ue = __assign$2({}, at), ot.size) {
      var dt = {};
      ot.forEach(function(pt) {
        var gt = me.getBaseTarget(pt);
        gt !== void 0 && (dt[pt] = gt);
      }), it.push({ animation: dt });
    }
    var At = !!it.length;
    return He && et.initial === !1 && !me.manuallyAnimateOnMount && (At = !1), He = !1, At ? ue(it) : Promise.resolve();
  }
  function Je(Ze, nt, tt) {
    var et;
    if (Qe[Ze].isActive === nt)
      return Promise.resolve();
    (et = me.variantChildren) === null || et === void 0 || et.forEach(function(ot) {
      var at;
      return (at = ot.animationState) === null || at === void 0 ? void 0 : at.setActive(Ze, nt);
    }), Qe[Ze].isActive = nt;
    var rt = $e(tt, Ze);
    for (var it in Qe)
      Qe[it].protectedKeys = {};
    return rt;
  }
  return {
    isAnimated: Xe,
    animateChanges: $e,
    setActive: Je,
    setAnimateFunction: Ke,
    getState: function() {
      return Qe;
    }
  };
}
function checkVariantsDidChange(me, ue) {
  return typeof ue == "string" ? ue !== me : isVariantLabels(ue) ? !shallowCompare(ue, me) : !1;
}
function createTypeState(me) {
  return me === void 0 && (me = !1), {
    isActive: me,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function createState$1() {
  var me;
  return me = {}, me[AnimationType.Animate] = createTypeState(!0), me[AnimationType.InView] = createTypeState(), me[AnimationType.Hover] = createTypeState(), me[AnimationType.Tap] = createTypeState(), me[AnimationType.Drag] = createTypeState(), me[AnimationType.Focus] = createTypeState(), me[AnimationType.Exit] = createTypeState(), me;
}
var animations = {
  animation: makeRenderlessComponent(function(me) {
    var ue = me.visualElement, Qe = me.animate;
    ue.animationState || (ue.animationState = createAnimationState(ue)), isAnimationControls(Qe) && useEffect(function() {
      return Qe.subscribe(ue);
    }, [Qe]);
  }),
  exit: makeRenderlessComponent(function(me) {
    var ue = me.custom, Qe = me.visualElement, Ue = __read$1(usePresence(), 2), He = Ue[0], Ge = Ue[1], Xe = useContext(PresenceContext);
    useEffect(function() {
      var Ke, $e;
      Qe.isPresent = He;
      var Je = (Ke = Qe.animationState) === null || Ke === void 0 ? void 0 : Ke.setActive(AnimationType.Exit, !He, { custom: ($e = Xe == null ? void 0 : Xe.custom) !== null && $e !== void 0 ? $e : ue });
      !He && (Je == null || Je.then(Ge));
    }, [He]);
  })
}, PanSession = (
  /** @class */
  function() {
    function me(ue, Qe, Ue) {
      var He = this, Ge = Ue === void 0 ? {} : Ue, Xe = Ge.transformPagePoint;
      if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.updatePoint = function() {
        if (He.lastMoveEvent && He.lastMoveEventInfo) {
          var tt = getPanInfo(He.lastMoveEventInfo, He.history), et = He.startEvent !== null, rt = distance(tt.offset, { x: 0, y: 0 }) >= 3;
          if (!(!et && !rt)) {
            var it = tt.point, ot = getFrameData().timestamp;
            He.history.push(__assign$2(__assign$2({}, it), { timestamp: ot }));
            var at = He.handlers, st = at.onStart, ut = at.onMove;
            et || (st && st(He.lastMoveEvent, tt), He.startEvent = He.lastMoveEvent), ut && ut(He.lastMoveEvent, tt);
          }
        }
      }, this.handlePointerMove = function(tt, et) {
        if (He.lastMoveEvent = tt, He.lastMoveEventInfo = transformPoint(et, He.transformPagePoint), isMouseEvent(tt) && tt.buttons === 0) {
          He.handlePointerUp(tt, et);
          return;
        }
        sync.update(He.updatePoint, !0);
      }, this.handlePointerUp = function(tt, et) {
        He.end();
        var rt = He.handlers, it = rt.onEnd, ot = rt.onSessionEnd, at = getPanInfo(transformPoint(et, He.transformPagePoint), He.history);
        He.startEvent && it && it(tt, at), ot && ot(tt, at);
      }, !(isTouchEvent(ue) && ue.touches.length > 1)) {
        this.handlers = Qe, this.transformPagePoint = Xe;
        var Ke = extractEventInfo(ue), $e = transformPoint(Ke, this.transformPagePoint), Je = $e.point, Ze = getFrameData().timestamp;
        this.history = [__assign$2(__assign$2({}, Je), { timestamp: Ze })];
        var nt = Qe.onSessionStart;
        nt && nt(ue, getPanInfo($e, this.history)), this.removeListeners = pipe(addPointerEvent(window, "pointermove", this.handlePointerMove), addPointerEvent(window, "pointerup", this.handlePointerUp), addPointerEvent(window, "pointercancel", this.handlePointerUp));
      }
    }
    return me.prototype.updateHandlers = function(ue) {
      this.handlers = ue;
    }, me.prototype.end = function() {
      this.removeListeners && this.removeListeners(), cancelSync.update(this.updatePoint);
    }, me;
  }()
);
function transformPoint(me, ue) {
  return ue ? { point: ue(me.point) } : me;
}
function subtractPoint(me, ue) {
  return { x: me.x - ue.x, y: me.y - ue.y };
}
function getPanInfo(me, ue) {
  var Qe = me.point;
  return {
    point: Qe,
    delta: subtractPoint(Qe, lastDevicePoint(ue)),
    offset: subtractPoint(Qe, startDevicePoint(ue)),
    velocity: getVelocity(ue, 0.1)
  };
}
function startDevicePoint(me) {
  return me[0];
}
function lastDevicePoint(me) {
  return me[me.length - 1];
}
function getVelocity(me, ue) {
  if (me.length < 2)
    return { x: 0, y: 0 };
  for (var Qe = me.length - 1, Ue = null, He = lastDevicePoint(me); Qe >= 0 && (Ue = me[Qe], !(He.timestamp - Ue.timestamp > secondsToMilliseconds(ue))); )
    Qe--;
  if (!Ue)
    return { x: 0, y: 0 };
  var Ge = (He.timestamp - Ue.timestamp) / 1e3;
  if (Ge === 0)
    return { x: 0, y: 0 };
  var Xe = {
    x: (He.x - Ue.x) / Ge,
    y: (He.y - Ue.y) / Ge
  };
  return Xe.x === 1 / 0 && (Xe.x = 0), Xe.y === 1 / 0 && (Xe.y = 0), Xe;
}
function calcLength(me) {
  return me.max - me.min;
}
function isNear(me, ue, Qe) {
  return ue === void 0 && (ue = 0), Qe === void 0 && (Qe = 0.01), distance(me, ue) < Qe;
}
function calcAxisDelta(me, ue, Qe, Ue) {
  Ue === void 0 && (Ue = 0.5), me.origin = Ue, me.originPoint = mix(ue.min, ue.max, me.origin), me.scale = calcLength(Qe) / calcLength(ue), (isNear(me.scale, 1, 1e-4) || isNaN(me.scale)) && (me.scale = 1), me.translate = mix(Qe.min, Qe.max, me.origin) - me.originPoint, (isNear(me.translate) || isNaN(me.translate)) && (me.translate = 0);
}
function calcBoxDelta(me, ue, Qe, Ue) {
  calcAxisDelta(me.x, ue.x, Qe.x, Ue == null ? void 0 : Ue.originX), calcAxisDelta(me.y, ue.y, Qe.y, Ue == null ? void 0 : Ue.originY);
}
function calcRelativeAxis(me, ue, Qe) {
  me.min = Qe.min + ue.min, me.max = me.min + calcLength(ue);
}
function calcRelativeBox(me, ue, Qe) {
  calcRelativeAxis(me.x, ue.x, Qe.x), calcRelativeAxis(me.y, ue.y, Qe.y);
}
function calcRelativeAxisPosition(me, ue, Qe) {
  me.min = ue.min - Qe.min, me.max = me.min + calcLength(ue);
}
function calcRelativePosition(me, ue, Qe) {
  calcRelativeAxisPosition(me.x, ue.x, Qe.x), calcRelativeAxisPosition(me.y, ue.y, Qe.y);
}
function applyConstraints(me, ue, Qe) {
  var Ue = ue.min, He = ue.max;
  return Ue !== void 0 && me < Ue ? me = Qe ? mix(Ue, me, Qe.min) : Math.max(me, Ue) : He !== void 0 && me > He && (me = Qe ? mix(He, me, Qe.max) : Math.min(me, He)), me;
}
function calcRelativeAxisConstraints(me, ue, Qe) {
  return {
    min: ue !== void 0 ? me.min + ue : void 0,
    max: Qe !== void 0 ? me.max + Qe - (me.max - me.min) : void 0
  };
}
function calcRelativeConstraints(me, ue) {
  var Qe = ue.top, Ue = ue.left, He = ue.bottom, Ge = ue.right;
  return {
    x: calcRelativeAxisConstraints(me.x, Ue, Ge),
    y: calcRelativeAxisConstraints(me.y, Qe, He)
  };
}
function calcViewportAxisConstraints(me, ue) {
  var Qe, Ue = ue.min - me.min, He = ue.max - me.max;
  return ue.max - ue.min < me.max - me.min && (Qe = __read$1([He, Ue], 2), Ue = Qe[0], He = Qe[1]), { min: Ue, max: He };
}
function calcViewportConstraints(me, ue) {
  return {
    x: calcViewportAxisConstraints(me.x, ue.x),
    y: calcViewportAxisConstraints(me.y, ue.y)
  };
}
function calcOrigin(me, ue) {
  var Qe = 0.5, Ue = calcLength(me), He = calcLength(ue);
  return He > Ue ? Qe = progress(ue.min, ue.max - Ue, me.min) : Ue > He && (Qe = progress(me.min, me.max - He, ue.min)), clamp(0, 1, Qe);
}
function rebaseAxisConstraints(me, ue) {
  var Qe = {};
  return ue.min !== void 0 && (Qe.min = ue.min - me.min), ue.max !== void 0 && (Qe.max = ue.max - me.min), Qe;
}
var defaultElastic = 0.35;
function resolveDragElastic(me) {
  return me === void 0 && (me = defaultElastic), me === !1 ? me = 0 : me === !0 && (me = defaultElastic), {
    x: resolveAxisElastic(me, "left", "right"),
    y: resolveAxisElastic(me, "top", "bottom")
  };
}
function resolveAxisElastic(me, ue, Qe) {
  return {
    min: resolvePointElastic(me, ue),
    max: resolvePointElastic(me, Qe)
  };
}
function resolvePointElastic(me, ue) {
  var Qe;
  return typeof me == "number" ? me : (Qe = me[ue]) !== null && Qe !== void 0 ? Qe : 0;
}
var createAxisDelta = function() {
  return {
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0
  };
}, createDelta = function() {
  return {
    x: createAxisDelta(),
    y: createAxisDelta()
  };
}, createAxis = function() {
  return { min: 0, max: 0 };
}, createBox = function() {
  return {
    x: createAxis(),
    y: createAxis()
  };
};
function eachAxis(me) {
  return [me("x"), me("y")];
}
function convertBoundingBoxToBox(me) {
  var ue = me.top, Qe = me.left, Ue = me.right, He = me.bottom;
  return {
    x: { min: Qe, max: Ue },
    y: { min: ue, max: He }
  };
}
function convertBoxToBoundingBox(me) {
  var ue = me.x, Qe = me.y;
  return { top: Qe.min, right: ue.max, bottom: Qe.max, left: ue.min };
}
function transformBoxPoints(me, ue) {
  if (!ue)
    return me;
  var Qe = ue({ x: me.left, y: me.top }), Ue = ue({ x: me.right, y: me.bottom });
  return {
    top: Qe.y,
    left: Qe.x,
    bottom: Ue.y,
    right: Ue.x
  };
}
function isIdentityScale(me) {
  return me === void 0 || me === 1;
}
function hasScale(me) {
  var ue = me.scale, Qe = me.scaleX, Ue = me.scaleY;
  return !isIdentityScale(ue) || !isIdentityScale(Qe) || !isIdentityScale(Ue);
}
function hasTransform(me) {
  return hasScale(me) || hasTranslate(me.x) || hasTranslate(me.y) || me.z || me.rotate || me.rotateX || me.rotateY;
}
function hasTranslate(me) {
  return me && me !== "0%";
}
function scalePoint(me, ue, Qe) {
  var Ue = me - Qe, He = ue * Ue;
  return Qe + He;
}
function applyPointDelta(me, ue, Qe, Ue, He) {
  return He !== void 0 && (me = scalePoint(me, He, Ue)), scalePoint(me, Qe, Ue) + ue;
}
function applyAxisDelta(me, ue, Qe, Ue, He) {
  ue === void 0 && (ue = 0), Qe === void 0 && (Qe = 1), me.min = applyPointDelta(me.min, ue, Qe, Ue, He), me.max = applyPointDelta(me.max, ue, Qe, Ue, He);
}
function applyBoxDelta(me, ue) {
  var Qe = ue.x, Ue = ue.y;
  applyAxisDelta(me.x, Qe.translate, Qe.scale, Qe.originPoint), applyAxisDelta(me.y, Ue.translate, Ue.scale, Ue.originPoint);
}
function applyTreeDeltas(me, ue, Qe, Ue) {
  var He, Ge;
  Ue === void 0 && (Ue = !1);
  var Xe = Qe.length;
  if (Xe) {
    ue.x = ue.y = 1;
    for (var Ke, $e, Je = 0; Je < Xe; Je++)
      Ke = Qe[Je], $e = Ke.projectionDelta, ((Ge = (He = Ke.instance) === null || He === void 0 ? void 0 : He.style) === null || Ge === void 0 ? void 0 : Ge.display) !== "contents" && (Ue && Ke.options.layoutScroll && Ke.scroll && Ke !== Ke.root && transformBox(me, { x: -Ke.scroll.x, y: -Ke.scroll.y }), $e && (ue.x *= $e.x.scale, ue.y *= $e.y.scale, applyBoxDelta(me, $e)), Ue && hasTransform(Ke.latestValues) && transformBox(me, Ke.latestValues));
  }
}
function translateAxis(me, ue) {
  me.min = me.min + ue, me.max = me.max + ue;
}
function transformAxis(me, ue, Qe) {
  var Ue = __read$1(Qe, 3), He = Ue[0], Ge = Ue[1], Xe = Ue[2], Ke = ue[Xe] !== void 0 ? ue[Xe] : 0.5, $e = mix(me.min, me.max, Ke);
  applyAxisDelta(me, ue[He], ue[Ge], $e, ue.scale);
}
var xKeys$1 = ["x", "scaleX", "originX"], yKeys$1 = ["y", "scaleY", "originY"];
function transformBox(me, ue) {
  transformAxis(me.x, ue, xKeys$1), transformAxis(me.y, ue, yKeys$1);
}
function measureViewportBox(me, ue) {
  return convertBoundingBoxToBox(transformBoxPoints(me.getBoundingClientRect(), ue));
}
function measurePageBox(me, ue, Qe) {
  var Ue = measureViewportBox(me, Qe), He = ue.scroll;
  return He && (translateAxis(Ue.x, He.x), translateAxis(Ue.y, He.y)), Ue;
}
var elementDragControls = /* @__PURE__ */ new WeakMap(), VisualElementDragControls = (
  /** @class */
  function() {
    function me(ue) {
      this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = createBox(), this.visualElement = ue;
    }
    return me.prototype.start = function(ue, Qe) {
      var Ue = this, He = Qe === void 0 ? {} : Qe, Ge = He.snapToCursor, Xe = Ge === void 0 ? !1 : Ge;
      if (this.visualElement.isPresent !== !1) {
        var Ke = function(nt) {
          Ue.stopAnimation(), Xe && Ue.snapToCursor(extractEventInfo(nt, "page").point);
        }, $e = function(nt, tt) {
          var et, rt = Ue.getProps(), it = rt.drag, ot = rt.dragPropagation, at = rt.onDragStart;
          it && !ot && (Ue.openGlobalLock && Ue.openGlobalLock(), Ue.openGlobalLock = getGlobalLock(it), !Ue.openGlobalLock) || (Ue.isDragging = !0, Ue.currentDirection = null, Ue.resolveConstraints(), Ue.visualElement.projection && (Ue.visualElement.projection.isAnimationBlocked = !0, Ue.visualElement.projection.target = void 0), eachAxis(function(st) {
            var ut, lt, dt = Ue.getAxisMotionValue(st).get() || 0;
            if (percent.test(dt)) {
              var At = (lt = (ut = Ue.visualElement.projection) === null || ut === void 0 ? void 0 : ut.layout) === null || lt === void 0 ? void 0 : lt.actual[st];
              if (At) {
                var pt = calcLength(At);
                dt = pt * (parseFloat(dt) / 100);
              }
            }
            Ue.originPoint[st] = dt;
          }), at == null || at(nt, tt), (et = Ue.visualElement.animationState) === null || et === void 0 || et.setActive(AnimationType.Drag, !0));
        }, Je = function(nt, tt) {
          var et = Ue.getProps(), rt = et.dragPropagation, it = et.dragDirectionLock, ot = et.onDirectionLock, at = et.onDrag;
          if (!(!rt && !Ue.openGlobalLock)) {
            var st = tt.offset;
            if (it && Ue.currentDirection === null) {
              Ue.currentDirection = getCurrentDirection(st), Ue.currentDirection !== null && (ot == null || ot(Ue.currentDirection));
              return;
            }
            Ue.updateAxis("x", tt.point, st), Ue.updateAxis("y", tt.point, st), Ue.visualElement.syncRender(), at == null || at(nt, tt);
          }
        }, Ze = function(nt, tt) {
          return Ue.stop(nt, tt);
        };
        this.panSession = new PanSession(ue, {
          onSessionStart: Ke,
          onStart: $e,
          onMove: Je,
          onSessionEnd: Ze
        }, { transformPagePoint: this.visualElement.getTransformPagePoint() });
      }
    }, me.prototype.stop = function(ue, Qe) {
      var Ue = this.isDragging;
      if (this.cancel(), !!Ue) {
        var He = Qe.velocity;
        this.startAnimation(He);
        var Ge = this.getProps().onDragEnd;
        Ge == null || Ge(ue, Qe);
      }
    }, me.prototype.cancel = function() {
      var ue, Qe;
      this.isDragging = !1, this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !1), (ue = this.panSession) === null || ue === void 0 || ue.end(), this.panSession = void 0;
      var Ue = this.getProps().dragPropagation;
      !Ue && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), (Qe = this.visualElement.animationState) === null || Qe === void 0 || Qe.setActive(AnimationType.Drag, !1);
    }, me.prototype.updateAxis = function(ue, Qe, Ue) {
      var He = this.getProps().drag;
      if (!(!Ue || !shouldDrag(ue, He, this.currentDirection))) {
        var Ge = this.getAxisMotionValue(ue), Xe = this.originPoint[ue] + Ue[ue];
        this.constraints && this.constraints[ue] && (Xe = applyConstraints(Xe, this.constraints[ue], this.elastic[ue])), Ge.set(Xe);
      }
    }, me.prototype.resolveConstraints = function() {
      var ue = this, Qe = this.getProps(), Ue = Qe.dragConstraints, He = Qe.dragElastic, Ge = (this.visualElement.projection || {}).layout, Xe = this.constraints;
      Ue && isRefObject(Ue) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : Ue && Ge ? this.constraints = calcRelativeConstraints(Ge.actual, Ue) : this.constraints = !1, this.elastic = resolveDragElastic(He), Xe !== this.constraints && Ge && this.constraints && !this.hasMutatedConstraints && eachAxis(function(Ke) {
        ue.getAxisMotionValue(Ke) && (ue.constraints[Ke] = rebaseAxisConstraints(Ge.actual[Ke], ue.constraints[Ke]));
      });
    }, me.prototype.resolveRefConstraints = function() {
      var ue = this.getProps(), Qe = ue.dragConstraints, Ue = ue.onMeasureDragConstraints;
      if (!Qe || !isRefObject(Qe))
        return !1;
      var He = Qe.current;
      invariant$1(He !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
      var Ge = this.visualElement.projection;
      if (!Ge || !Ge.layout)
        return !1;
      var Xe = measurePageBox(He, Ge.root, this.visualElement.getTransformPagePoint()), Ke = calcViewportConstraints(Ge.layout.actual, Xe);
      if (Ue) {
        var $e = Ue(convertBoxToBoundingBox(Ke));
        this.hasMutatedConstraints = !!$e, $e && (Ke = convertBoundingBoxToBox($e));
      }
      return Ke;
    }, me.prototype.startAnimation = function(ue) {
      var Qe = this, Ue = this.getProps(), He = Ue.drag, Ge = Ue.dragMomentum, Xe = Ue.dragElastic, Ke = Ue.dragTransition, $e = Ue.dragSnapToOrigin, Je = Ue.onDragTransitionEnd, Ze = this.constraints || {}, nt = eachAxis(function(tt) {
        var et;
        if (shouldDrag(tt, He, Qe.currentDirection)) {
          var rt = (et = Ze == null ? void 0 : Ze[tt]) !== null && et !== void 0 ? et : {};
          $e && (rt = { min: 0, max: 0 });
          var it = Xe ? 200 : 1e6, ot = Xe ? 40 : 1e7, at = __assign$2(__assign$2({ type: "inertia", velocity: Ge ? ue[tt] : 0, bounceStiffness: it, bounceDamping: ot, timeConstant: 750, restDelta: 1, restSpeed: 10 }, Ke), rt);
          return Qe.startAxisValueAnimation(tt, at);
        }
      });
      return Promise.all(nt).then(Je);
    }, me.prototype.startAxisValueAnimation = function(ue, Qe) {
      var Ue = this.getAxisMotionValue(ue);
      return startAnimation(ue, Ue, 0, Qe);
    }, me.prototype.stopAnimation = function() {
      var ue = this;
      eachAxis(function(Qe) {
        return ue.getAxisMotionValue(Qe).stop();
      });
    }, me.prototype.getAxisMotionValue = function(ue) {
      var Qe, Ue, He = "_drag" + ue.toUpperCase(), Ge = this.visualElement.getProps()[He];
      return Ge || this.visualElement.getValue(ue, (Ue = (Qe = this.visualElement.getProps().initial) === null || Qe === void 0 ? void 0 : Qe[ue]) !== null && Ue !== void 0 ? Ue : 0);
    }, me.prototype.snapToCursor = function(ue) {
      var Qe = this;
      eachAxis(function(Ue) {
        var He = Qe.getProps().drag;
        if (shouldDrag(Ue, He, Qe.currentDirection)) {
          var Ge = Qe.visualElement.projection, Xe = Qe.getAxisMotionValue(Ue);
          if (Ge && Ge.layout) {
            var Ke = Ge.layout.actual[Ue], $e = Ke.min, Je = Ke.max;
            Xe.set(ue[Ue] - mix($e, Je, 0.5));
          }
        }
      });
    }, me.prototype.scalePositionWithinConstraints = function() {
      var ue = this, Qe, Ue = this.getProps(), He = Ue.drag, Ge = Ue.dragConstraints, Xe = this.visualElement.projection;
      if (!(!isRefObject(Ge) || !Xe || !this.constraints)) {
        this.stopAnimation();
        var Ke = { x: 0, y: 0 };
        eachAxis(function(Je) {
          var Ze = ue.getAxisMotionValue(Je);
          if (Ze) {
            var nt = Ze.get();
            Ke[Je] = calcOrigin({ min: nt, max: nt }, ue.constraints[Je]);
          }
        });
        var $e = this.visualElement.getProps().transformTemplate;
        this.visualElement.getInstance().style.transform = $e ? $e({}, "") : "none", (Qe = Xe.root) === null || Qe === void 0 || Qe.updateScroll(), Xe.updateLayout(), this.resolveConstraints(), eachAxis(function(Je) {
          if (shouldDrag(Je, He, null)) {
            var Ze = ue.getAxisMotionValue(Je), nt = ue.constraints[Je], tt = nt.min, et = nt.max;
            Ze.set(mix(tt, et, Ke[Je]));
          }
        });
      }
    }, me.prototype.addListeners = function() {
      var ue = this, Qe;
      elementDragControls.set(this.visualElement, this);
      var Ue = this.visualElement.getInstance(), He = addPointerEvent(Ue, "pointerdown", function(Je) {
        var Ze = ue.getProps(), nt = Ze.drag, tt = Ze.dragListener, et = tt === void 0 ? !0 : tt;
        nt && et && ue.start(Je);
      }), Ge = function() {
        var Je = ue.getProps().dragConstraints;
        isRefObject(Je) && (ue.constraints = ue.resolveRefConstraints());
      }, Xe = this.visualElement.projection, Ke = Xe.addEventListener("measure", Ge);
      Xe && !Xe.layout && ((Qe = Xe.root) === null || Qe === void 0 || Qe.updateScroll(), Xe.updateLayout()), Ge();
      var $e = addDomEvent(window, "resize", function() {
        return ue.scalePositionWithinConstraints();
      });
      return Xe.addEventListener("didUpdate", function(Je) {
        var Ze = Je.delta, nt = Je.hasLayoutChanged;
        ue.isDragging && nt && (eachAxis(function(tt) {
          var et = ue.getAxisMotionValue(tt);
          et && (ue.originPoint[tt] += Ze[tt].translate, et.set(et.get() + Ze[tt].translate));
        }), ue.visualElement.syncRender());
      }), function() {
        $e(), He(), Ke();
      };
    }, me.prototype.getProps = function() {
      var ue = this.visualElement.getProps(), Qe = ue.drag, Ue = Qe === void 0 ? !1 : Qe, He = ue.dragDirectionLock, Ge = He === void 0 ? !1 : He, Xe = ue.dragPropagation, Ke = Xe === void 0 ? !1 : Xe, $e = ue.dragConstraints, Je = $e === void 0 ? !1 : $e, Ze = ue.dragElastic, nt = Ze === void 0 ? defaultElastic : Ze, tt = ue.dragMomentum, et = tt === void 0 ? !0 : tt;
      return __assign$2(__assign$2({}, ue), { drag: Ue, dragDirectionLock: Ge, dragPropagation: Ke, dragConstraints: Je, dragElastic: nt, dragMomentum: et });
    }, me;
  }()
);
function shouldDrag(me, ue, Qe) {
  return (ue === !0 || ue === me) && (Qe === null || Qe === me);
}
function getCurrentDirection(me, ue) {
  ue === void 0 && (ue = 10);
  var Qe = null;
  return Math.abs(me.y) > ue ? Qe = "y" : Math.abs(me.x) > ue && (Qe = "x"), Qe;
}
function useDrag(me) {
  var ue = me.dragControls, Qe = me.visualElement, Ue = useConstant(function() {
    return new VisualElementDragControls(Qe);
  });
  useEffect(function() {
    return ue && ue.subscribe(Ue);
  }, [Ue, ue]), useEffect(function() {
    return Ue.addListeners();
  }, [Ue]);
}
function usePanGesture(me) {
  var ue = me.onPan, Qe = me.onPanStart, Ue = me.onPanEnd, He = me.onPanSessionStart, Ge = me.visualElement, Xe = ue || Qe || Ue || He, Ke = useRef(null), $e = useContext(MotionConfigContext).transformPagePoint, Je = {
    onSessionStart: He,
    onStart: Qe,
    onMove: ue,
    onEnd: function(nt, tt) {
      Ke.current = null, Ue && Ue(nt, tt);
    }
  };
  useEffect(function() {
    Ke.current !== null && Ke.current.updateHandlers(Je);
  });
  function Ze(nt) {
    Ke.current = new PanSession(nt, Je, {
      transformPagePoint: $e
    });
  }
  usePointerEvent(Ge, "pointerdown", Xe && Ze), useUnmountEffect(function() {
    return Ke.current && Ke.current.end();
  });
}
var drag = {
  pan: makeRenderlessComponent(usePanGesture),
  drag: makeRenderlessComponent(useDrag)
}, names = [
  "LayoutMeasure",
  "BeforeLayoutMeasure",
  "LayoutUpdate",
  "ViewportBoxUpdate",
  "Update",
  "Render",
  "AnimationComplete",
  "LayoutAnimationComplete",
  "AnimationStart",
  "LayoutAnimationStart",
  "SetAxisTarget",
  "Unmount"
];
function createLifecycles() {
  var me = names.map(function() {
    return new SubscriptionManager();
  }), ue = {}, Qe = {
    clearAllListeners: function() {
      return me.forEach(function(Ue) {
        return Ue.clear();
      });
    },
    updatePropListeners: function(Ue) {
      names.forEach(function(He) {
        var Ge, Xe = "on" + He, Ke = Ue[Xe];
        (Ge = ue[He]) === null || Ge === void 0 || Ge.call(ue), Ke && (ue[He] = Qe[Xe](Ke));
      });
    }
  };
  return me.forEach(function(Ue, He) {
    Qe["on" + names[He]] = function(Ge) {
      return Ue.add(Ge);
    }, Qe["notify" + names[He]] = function() {
      for (var Ge = [], Xe = 0; Xe < arguments.length; Xe++)
        Ge[Xe] = arguments[Xe];
      return Ue.notify.apply(Ue, __spreadArray$1([], __read$1(Ge), !1));
    };
  }), Qe;
}
function updateMotionValuesFromProps(me, ue, Qe) {
  var Ue;
  for (var He in ue) {
    var Ge = ue[He], Xe = Qe[He];
    if (isMotionValue(Ge))
      me.addValue(He, Ge), process.env.NODE_ENV === "development" && warnOnce(Ge.version === "6.5.1", "Attempting to mix Framer Motion versions ".concat(Ge.version, " with 6.5.1 may not work as expected."));
    else if (isMotionValue(Xe))
      me.addValue(He, motionValue(Ge));
    else if (Xe !== Ge)
      if (me.hasValue(He)) {
        var Ke = me.getValue(He);
        !Ke.hasAnimated && Ke.set(Ge);
      } else
        me.addValue(He, motionValue((Ue = me.getStaticValue(He)) !== null && Ue !== void 0 ? Ue : Ge));
  }
  for (var He in Qe)
    ue[He] === void 0 && me.removeValue(He);
  return ue;
}
var visualElement = function(me) {
  var ue = me.treeType, Qe = ue === void 0 ? "" : ue, Ue = me.build, He = me.getBaseTarget, Ge = me.makeTargetAnimatable, Xe = me.measureViewportBox, Ke = me.render, $e = me.readValueFromInstance, Je = me.removeValueFromRenderState, Ze = me.sortNodePosition, nt = me.scrapeMotionValuesFromProps;
  return function(tt, et) {
    var rt = tt.parent, it = tt.props, ot = tt.presenceId, at = tt.blockInitialAnimation, st = tt.visualState, ut = tt.shouldReduceMotion;
    et === void 0 && (et = {});
    var lt = !1, dt = st.latestValues, At = st.renderState, pt, gt = createLifecycles(), wt = /* @__PURE__ */ new Map(), Bt = /* @__PURE__ */ new Map(), Tt = {}, yt = __assign$2({}, dt), Ct;
    function ht() {
      !pt || !lt || (It(), Ke(pt, At, it.style, Pt.projection));
    }
    function It() {
      Ue(Pt, At, dt, et, it);
    }
    function vt() {
      gt.notifyUpdate(dt);
    }
    function Et(Qt, qt) {
      var _t = qt.onChange(function(Xt) {
        dt[Qt] = Xt, it.onUpdate && sync.update(vt, !1, !0);
      }), Yt = qt.onRenderRequest(Pt.scheduleRender);
      Bt.set(Qt, function() {
        _t(), Yt();
      });
    }
    var bt = nt(it);
    for (var Rt in bt) {
      var St = bt[Rt];
      dt[Rt] !== void 0 && isMotionValue(St) && St.set(dt[Rt], !1);
    }
    var kt = checkIfControllingVariants(it), jt = checkIfVariantNode(it), Pt = __assign$2(__assign$2({
      treeType: Qe,
      /**
       * This is a mirror of the internal instance prop, which keeps
       * VisualElement type-compatible with React's RefObject.
       */
      current: null,
      /**
       * The depth of this visual element within the visual element tree.
       */
      depth: rt ? rt.depth + 1 : 0,
      parent: rt,
      children: /* @__PURE__ */ new Set(),
      /**
       *
       */
      presenceId: ot,
      shouldReduceMotion: ut,
      /**
       * If this component is part of the variant tree, it should track
       * any children that are also part of the tree. This is essentially
       * a shadow tree to simplify logic around how to stagger over children.
       */
      variantChildren: jt ? /* @__PURE__ */ new Set() : void 0,
      /**
       * Whether this instance is visible. This can be changed imperatively
       * by the projection tree, is analogous to CSS's visibility in that
       * hidden elements should take up layout, and needs enacting by the configured
       * render function.
       */
      isVisible: void 0,
      /**
       * Normally, if a component is controlled by a parent's variants, it can
       * rely on that ancestor to trigger animations further down the tree.
       * However, if a component is created after its parent is mounted, the parent
       * won't trigger that mount animation so the child needs to.
       *
       * TODO: This might be better replaced with a method isParentMounted
       */
      manuallyAnimateOnMount: !!(rt != null && rt.isMounted()),
      /**
       * This can be set by AnimatePresence to force components that mount
       * at the same time as it to mount as if they have initial={false} set.
       */
      blockInitialAnimation: at,
      /**
       * Determine whether this component has mounted yet. This is mostly used
       * by variant children to determine whether they need to trigger their
       * own animations on mount.
       */
      isMounted: function() {
        return !!pt;
      },
      mount: function(Qt) {
        lt = !0, pt = Pt.current = Qt, Pt.projection && Pt.projection.mount(Qt), jt && rt && !kt && (Ct = rt == null ? void 0 : rt.addVariantChild(Pt)), wt.forEach(function(qt, _t) {
          return Et(_t, qt);
        }), rt == null || rt.children.add(Pt), Pt.setProps(it);
      },
      /**
       *
       */
      unmount: function() {
        var Qt;
        (Qt = Pt.projection) === null || Qt === void 0 || Qt.unmount(), cancelSync.update(vt), cancelSync.render(ht), Bt.forEach(function(qt) {
          return qt();
        }), Ct == null || Ct(), rt == null || rt.children.delete(Pt), gt.clearAllListeners(), pt = void 0, lt = !1;
      },
      /**
       * Add a child visual element to our set of children.
       */
      addVariantChild: function(Qt) {
        var qt, _t = Pt.getClosestVariantNode();
        if (_t)
          return (qt = _t.variantChildren) === null || qt === void 0 || qt.add(Qt), function() {
            return _t.variantChildren.delete(Qt);
          };
      },
      sortNodePosition: function(Qt) {
        return !Ze || Qe !== Qt.treeType ? 0 : Ze(Pt.getInstance(), Qt.getInstance());
      },
      /**
       * Returns the closest variant node in the tree starting from
       * this visual element.
       */
      getClosestVariantNode: function() {
        return jt ? Pt : rt == null ? void 0 : rt.getClosestVariantNode();
      },
      /**
       * Expose the latest layoutId prop.
       */
      getLayoutId: function() {
        return it.layoutId;
      },
      /**
       * Returns the current instance.
       */
      getInstance: function() {
        return pt;
      },
      /**
       * Get/set the latest static values.
       */
      getStaticValue: function(Qt) {
        return dt[Qt];
      },
      setStaticValue: function(Qt, qt) {
        return dt[Qt] = qt;
      },
      /**
       * Returns the latest motion value state. Currently only used to take
       * a snapshot of the visual element - perhaps this can return the whole
       * visual state
       */
      getLatestValues: function() {
        return dt;
      },
      /**
       * Set the visiblity of the visual element. If it's changed, schedule
       * a render to reflect these changes.
       */
      setVisibility: function(Qt) {
        Pt.isVisible !== Qt && (Pt.isVisible = Qt, Pt.scheduleRender());
      },
      /**
       * Make a target animatable by Popmotion. For instance, if we're
       * trying to animate width from 100px to 100vw we need to measure 100vw
       * in pixels to determine what we really need to animate to. This is also
       * pluggable to support Framer's custom value types like Color,
       * and CSS variables.
       */
      makeTargetAnimatable: function(Qt, qt) {
        return qt === void 0 && (qt = !0), Ge(Pt, Qt, it, qt);
      },
      /**
       * Measure the current viewport box with or without transforms.
       * Only measures axis-aligned boxes, rotate and skew must be manually
       * removed with a re-render to work.
       */
      measureViewportBox: function() {
        return Xe(pt, it);
      },
      // Motion values ========================
      /**
       * Add a motion value and bind it to this visual element.
       */
      addValue: function(Qt, qt) {
        Pt.hasValue(Qt) && Pt.removeValue(Qt), wt.set(Qt, qt), dt[Qt] = qt.get(), Et(Qt, qt);
      },
      /**
       * Remove a motion value and unbind any active subscriptions.
       */
      removeValue: function(Qt) {
        var qt;
        wt.delete(Qt), (qt = Bt.get(Qt)) === null || qt === void 0 || qt(), Bt.delete(Qt), delete dt[Qt], Je(Qt, At);
      },
      /**
       * Check whether we have a motion value for this key
       */
      hasValue: function(Qt) {
        return wt.has(Qt);
      },
      /**
       * Get a motion value for this key. If called with a default
       * value, we'll create one if none exists.
       */
      getValue: function(Qt, qt) {
        var _t = wt.get(Qt);
        return _t === void 0 && qt !== void 0 && (_t = motionValue(qt), Pt.addValue(Qt, _t)), _t;
      },
      /**
       * Iterate over our motion values.
       */
      forEachValue: function(Qt) {
        return wt.forEach(Qt);
      },
      /**
       * If we're trying to animate to a previously unencountered value,
       * we need to check for it in our state and as a last resort read it
       * directly from the instance (which might have performance implications).
       */
      readValue: function(Qt) {
        var qt;
        return (qt = dt[Qt]) !== null && qt !== void 0 ? qt : $e(pt, Qt, et);
      },
      /**
       * Set the base target to later animate back to. This is currently
       * only hydrated on creation and when we first read a value.
       */
      setBaseTarget: function(Qt, qt) {
        yt[Qt] = qt;
      },
      /**
       * Find the base target for a value thats been removed from all animation
       * props.
       */
      getBaseTarget: function(Qt) {
        if (He) {
          var qt = He(it, Qt);
          if (qt !== void 0 && !isMotionValue(qt))
            return qt;
        }
        return yt[Qt];
      }
    }, gt), {
      /**
       * Build the renderer state based on the latest visual state.
       */
      build: function() {
        return It(), At;
      },
      /**
       * Schedule a render on the next animation frame.
       */
      scheduleRender: function() {
        sync.render(ht, !1, !0);
      },
      /**
       * Synchronously fire render. It's prefered that we batch renders but
       * in many circumstances, like layout measurement, we need to run this
       * synchronously. However in those instances other measures should be taken
       * to batch reads/writes.
       */
      syncRender: ht,
      /**
       * Update the provided props. Ensure any newly-added motion values are
       * added to our map, old ones removed, and listeners updated.
       */
      setProps: function(Qt) {
        (Qt.transformTemplate || it.transformTemplate) && Pt.scheduleRender(), it = Qt, gt.updatePropListeners(Qt), Tt = updateMotionValuesFromProps(Pt, nt(it), Tt);
      },
      getProps: function() {
        return it;
      },
      // Variants ==============================
      /**
       * Returns the variant definition with a given name.
       */
      getVariant: function(Qt) {
        var qt;
        return (qt = it.variants) === null || qt === void 0 ? void 0 : qt[Qt];
      },
      /**
       * Returns the defined default transition on this component.
       */
      getDefaultTransition: function() {
        return it.transition;
      },
      getTransformPagePoint: function() {
        return it.transformPagePoint;
      },
      /**
       * Used by child variant nodes to get the closest ancestor variant props.
       */
      getVariantContext: function(Qt) {
        if (Qt === void 0 && (Qt = !1), Qt)
          return rt == null ? void 0 : rt.getVariantContext();
        if (!kt) {
          var qt = (rt == null ? void 0 : rt.getVariantContext()) || {};
          return it.initial !== void 0 && (qt.initial = it.initial), qt;
        }
        for (var _t = {}, Yt = 0; Yt < numVariantProps; Yt++) {
          var Xt = variantProps[Yt], Ut = it[Xt];
          (isVariantLabel(Ut) || Ut === !1) && (_t[Xt] = Ut);
        }
        return _t;
      }
    });
    return Pt;
  };
}, variantProps = __spreadArray$1(["initial"], __read$1(variantPriorityOrder), !1), numVariantProps = variantProps.length;
function isCSSVariable(me) {
  return typeof me == "string" && me.startsWith("var(--");
}
var cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function parseCSSVariable(me) {
  var ue = cssVariableRegex.exec(me);
  if (!ue)
    return [,];
  var Qe = __read$1(ue, 3), Ue = Qe[1], He = Qe[2];
  return [Ue, He];
}
var maxDepth = 4;
function getVariableValue(me, ue, Qe) {
  Qe === void 0 && (Qe = 1), invariant$1(Qe <= maxDepth, 'Max CSS variable fallback depth detected in property "'.concat(me, '". This may indicate a circular fallback dependency.'));
  var Ue = __read$1(parseCSSVariable(me), 2), He = Ue[0], Ge = Ue[1];
  if (He) {
    var Xe = window.getComputedStyle(ue).getPropertyValue(He);
    return Xe ? Xe.trim() : isCSSVariable(Ge) ? getVariableValue(Ge, ue, Qe + 1) : Ge;
  }
}
function resolveCSSVariables(me, ue, Qe) {
  var Ue, He = __rest$3(ue, []), Ge = me.getInstance();
  if (!(Ge instanceof Element))
    return { target: He, transitionEnd: Qe };
  Qe && (Qe = __assign$2({}, Qe)), me.forEachValue(function(Je) {
    var Ze = Je.get();
    if (isCSSVariable(Ze)) {
      var nt = getVariableValue(Ze, Ge);
      nt && Je.set(nt);
    }
  });
  for (var Xe in He) {
    var Ke = He[Xe];
    if (isCSSVariable(Ke)) {
      var $e = getVariableValue(Ke, Ge);
      $e && (He[Xe] = $e, Qe && ((Ue = Qe[Xe]) !== null && Ue !== void 0 || (Qe[Xe] = Ke)));
    }
  }
  return { target: He, transitionEnd: Qe };
}
var positionalKeys = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y"
]), isPositionalKey = function(me) {
  return positionalKeys.has(me);
}, hasPositionalKey = function(me) {
  return Object.keys(me).some(isPositionalKey);
}, setAndResetVelocity = function(me, ue) {
  me.set(ue, !1), me.set(ue);
}, isNumOrPxType = function(me) {
  return me === number$1 || me === px;
}, BoundingBoxDimension;
(function(me) {
  me.width = "width", me.height = "height", me.left = "left", me.right = "right", me.top = "top", me.bottom = "bottom";
})(BoundingBoxDimension || (BoundingBoxDimension = {}));
var getPosFromMatrix = function(me, ue) {
  return parseFloat(me.split(", ")[ue]);
}, getTranslateFromMatrix = function(me, ue) {
  return function(Qe, Ue) {
    var He = Ue.transform;
    if (He === "none" || !He)
      return 0;
    var Ge = He.match(/^matrix3d\((.+)\)$/);
    if (Ge)
      return getPosFromMatrix(Ge[1], ue);
    var Xe = He.match(/^matrix\((.+)\)$/);
    return Xe ? getPosFromMatrix(Xe[1], me) : 0;
  };
}, transformKeys = /* @__PURE__ */ new Set(["x", "y", "z"]), nonTranslationalTransformKeys = transformProps.filter(function(me) {
  return !transformKeys.has(me);
});
function removeNonTranslationalTransform(me) {
  var ue = [];
  return nonTranslationalTransformKeys.forEach(function(Qe) {
    var Ue = me.getValue(Qe);
    Ue !== void 0 && (ue.push([Qe, Ue.get()]), Ue.set(Qe.startsWith("scale") ? 1 : 0));
  }), ue.length && me.syncRender(), ue;
}
var positionalValues = {
  // Dimensions
  width: function(me, ue) {
    var Qe = me.x, Ue = ue.paddingLeft, He = Ue === void 0 ? "0" : Ue, Ge = ue.paddingRight, Xe = Ge === void 0 ? "0" : Ge;
    return Qe.max - Qe.min - parseFloat(He) - parseFloat(Xe);
  },
  height: function(me, ue) {
    var Qe = me.y, Ue = ue.paddingTop, He = Ue === void 0 ? "0" : Ue, Ge = ue.paddingBottom, Xe = Ge === void 0 ? "0" : Ge;
    return Qe.max - Qe.min - parseFloat(He) - parseFloat(Xe);
  },
  top: function(me, ue) {
    var Qe = ue.top;
    return parseFloat(Qe);
  },
  left: function(me, ue) {
    var Qe = ue.left;
    return parseFloat(Qe);
  },
  bottom: function(me, ue) {
    var Qe = me.y, Ue = ue.top;
    return parseFloat(Ue) + (Qe.max - Qe.min);
  },
  right: function(me, ue) {
    var Qe = me.x, Ue = ue.left;
    return parseFloat(Ue) + (Qe.max - Qe.min);
  },
  // Transform
  x: getTranslateFromMatrix(4, 13),
  y: getTranslateFromMatrix(5, 14)
}, convertChangedValueTypes = function(me, ue, Qe) {
  var Ue = ue.measureViewportBox(), He = ue.getInstance(), Ge = getComputedStyle(He), Xe = Ge.display, Ke = {};
  Xe === "none" && ue.setStaticValue("display", me.display || "block"), Qe.forEach(function(Je) {
    Ke[Je] = positionalValues[Je](Ue, Ge);
  }), ue.syncRender();
  var $e = ue.measureViewportBox();
  return Qe.forEach(function(Je) {
    var Ze = ue.getValue(Je);
    setAndResetVelocity(Ze, Ke[Je]), me[Je] = positionalValues[Je]($e, Ge);
  }), me;
}, checkAndConvertChangedValueTypes = function(me, ue, Qe, Ue) {
  Qe === void 0 && (Qe = {}), Ue === void 0 && (Ue = {}), ue = __assign$2({}, ue), Ue = __assign$2({}, Ue);
  var He = Object.keys(ue).filter(isPositionalKey), Ge = [], Xe = !1, Ke = [];
  if (He.forEach(function(Ze) {
    var nt = me.getValue(Ze);
    if (me.hasValue(Ze)) {
      var tt = Qe[Ze], et = findDimensionValueType(tt), rt = ue[Ze], it;
      if (isKeyframesTarget(rt)) {
        var ot = rt.length, at = rt[0] === null ? 1 : 0;
        tt = rt[at], et = findDimensionValueType(tt);
        for (var st = at; st < ot; st++)
          it ? invariant$1(findDimensionValueType(rt[st]) === it, "All keyframes must be of the same type") : (it = findDimensionValueType(rt[st]), invariant$1(it === et || isNumOrPxType(et) && isNumOrPxType(it), "Keyframes must be of the same dimension as the current value"));
      } else
        it = findDimensionValueType(rt);
      if (et !== it)
        if (isNumOrPxType(et) && isNumOrPxType(it)) {
          var ut = nt.get();
          typeof ut == "string" && nt.set(parseFloat(ut)), typeof rt == "string" ? ue[Ze] = parseFloat(rt) : Array.isArray(rt) && it === px && (ue[Ze] = rt.map(parseFloat));
        } else et != null && et.transform && (it != null && it.transform) && (tt === 0 || rt === 0) ? tt === 0 ? nt.set(it.transform(tt)) : ue[Ze] = et.transform(rt) : (Xe || (Ge = removeNonTranslationalTransform(me), Xe = !0), Ke.push(Ze), Ue[Ze] = Ue[Ze] !== void 0 ? Ue[Ze] : ue[Ze], setAndResetVelocity(nt, rt));
    }
  }), Ke.length) {
    var $e = Ke.indexOf("height") >= 0 ? window.pageYOffset : null, Je = convertChangedValueTypes(ue, me, Ke);
    return Ge.length && Ge.forEach(function(Ze) {
      var nt = __read$1(Ze, 2), tt = nt[0], et = nt[1];
      me.getValue(tt).set(et);
    }), me.syncRender(), $e !== null && window.scrollTo({ top: $e }), { target: Je, transitionEnd: Ue };
  } else
    return { target: ue, transitionEnd: Ue };
};
function unitConversion(me, ue, Qe, Ue) {
  return hasPositionalKey(ue) ? checkAndConvertChangedValueTypes(me, ue, Qe, Ue) : { target: ue, transitionEnd: Ue };
}
var parseDomVariant = function(me, ue, Qe, Ue) {
  var He = resolveCSSVariables(me, ue, Ue);
  return ue = He.target, Ue = He.transitionEnd, unitConversion(me, ue, Qe, Ue);
};
function getComputedStyle$2(me) {
  return window.getComputedStyle(me);
}
var htmlConfig = {
  treeType: "dom",
  readValueFromInstance: function(me, ue) {
    if (isTransformProp(ue)) {
      var Qe = getDefaultValueType(ue);
      return Qe && Qe.default || 0;
    } else {
      var Ue = getComputedStyle$2(me);
      return (isCSSVariable$1(ue) ? Ue.getPropertyValue(ue) : Ue[ue]) || 0;
    }
  },
  sortNodePosition: function(me, ue) {
    return me.compareDocumentPosition(ue) & 2 ? 1 : -1;
  },
  getBaseTarget: function(me, ue) {
    var Qe;
    return (Qe = me.style) === null || Qe === void 0 ? void 0 : Qe[ue];
  },
  measureViewportBox: function(me, ue) {
    var Qe = ue.transformPagePoint;
    return measureViewportBox(me, Qe);
  },
  /**
   * Reset the transform on the current Element. This is called as part
   * of a batched process across the entire layout tree. To remove this write
   * cycle it'd be interesting to see if it's possible to "undo" all the current
   * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
   * works
   */
  resetTransform: function(me, ue, Qe) {
    var Ue = Qe.transformTemplate;
    ue.style.transform = Ue ? Ue({}, "") : "none", me.scheduleRender();
  },
  restoreTransform: function(me, ue) {
    me.style.transform = ue.style.transform;
  },
  removeValueFromRenderState: function(me, ue) {
    var Qe = ue.vars, Ue = ue.style;
    delete Qe[me], delete Ue[me];
  },
  /**
   * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
   * can be animated by Motion.
   */
  makeTargetAnimatable: function(me, ue, Qe, Ue) {
    var He = Qe.transformValues;
    Ue === void 0 && (Ue = !0);
    var Ge = ue.transition, Xe = ue.transitionEnd, Ke = __rest$3(ue, ["transition", "transitionEnd"]), $e = getOrigin(Ke, Ge || {}, me);
    if (He && (Xe && (Xe = He(Xe)), Ke && (Ke = He(Ke)), $e && ($e = He($e))), Ue) {
      checkTargetForNewValues(me, Ke, $e);
      var Je = parseDomVariant(me, Ke, $e, Xe);
      Xe = Je.transitionEnd, Ke = Je.target;
    }
    return __assign$2({ transition: Ge, transitionEnd: Xe }, Ke);
  },
  scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
  build: function(me, ue, Qe, Ue, He) {
    me.isVisible !== void 0 && (ue.style.visibility = me.isVisible ? "visible" : "hidden"), buildHTMLStyles(ue, Qe, Ue, He.transformTemplate);
  },
  render: renderHTML
}, htmlVisualElement = visualElement(htmlConfig), svgVisualElement = visualElement(__assign$2(__assign$2({}, htmlConfig), { getBaseTarget: function(me, ue) {
  return me[ue];
}, readValueFromInstance: function(me, ue) {
  var Qe;
  return isTransformProp(ue) ? ((Qe = getDefaultValueType(ue)) === null || Qe === void 0 ? void 0 : Qe.default) || 0 : (ue = camelCaseAttributes.has(ue) ? ue : camelToDash(ue), me.getAttribute(ue));
}, scrapeMotionValuesFromProps, build: function(me, ue, Qe, Ue, He) {
  buildSVGAttrs(ue, Qe, Ue, He.transformTemplate);
}, render: renderSVG })), createDomVisualElement = function(me, ue) {
  return isSVGComponent(me) ? svgVisualElement(ue, { enableHardwareAcceleration: !1 }) : htmlVisualElement(ue, { enableHardwareAcceleration: !0 });
};
function pixelsToPercent(me, ue) {
  return ue.max === ue.min ? 0 : me / (ue.max - ue.min) * 100;
}
var correctBorderRadius = {
  correct: function(me, ue) {
    if (!ue.target)
      return me;
    if (typeof me == "string")
      if (px.test(me))
        me = parseFloat(me);
      else
        return me;
    var Qe = pixelsToPercent(me, ue.target.x), Ue = pixelsToPercent(me, ue.target.y);
    return "".concat(Qe, "% ").concat(Ue, "%");
  }
}, varToken = "_$css", correctBoxShadow = {
  correct: function(me, ue) {
    var Qe = ue.treeScale, Ue = ue.projectionDelta, He = me, Ge = me.includes("var("), Xe = [];
    Ge && (me = me.replace(cssVariableRegex, function(it) {
      return Xe.push(it), varToken;
    }));
    var Ke = complex.parse(me);
    if (Ke.length > 5)
      return He;
    var $e = complex.createTransformer(me), Je = typeof Ke[0] != "number" ? 1 : 0, Ze = Ue.x.scale * Qe.x, nt = Ue.y.scale * Qe.y;
    Ke[0 + Je] /= Ze, Ke[1 + Je] /= nt;
    var tt = mix(Ze, nt, 0.5);
    typeof Ke[2 + Je] == "number" && (Ke[2 + Je] /= tt), typeof Ke[3 + Je] == "number" && (Ke[3 + Je] /= tt);
    var et = $e(Ke);
    if (Ge) {
      var rt = 0;
      et = et.replace(varToken, function() {
        var it = Xe[rt];
        return rt++, it;
      });
    }
    return et;
  }
}, MeasureLayoutWithContext = (
  /** @class */
  function(me) {
    __extends$1q(ue, me);
    function ue() {
      return me !== null && me.apply(this, arguments) || this;
    }
    return ue.prototype.componentDidMount = function() {
      var Qe = this, Ue = this.props, He = Ue.visualElement, Ge = Ue.layoutGroup, Xe = Ue.switchLayoutGroup, Ke = Ue.layoutId, $e = He.projection;
      addScaleCorrector(defaultScaleCorrectors), $e && (Ge != null && Ge.group && Ge.group.add($e), Xe != null && Xe.register && Ke && Xe.register($e), $e.root.didUpdate(), $e.addEventListener("animationComplete", function() {
        Qe.safeToRemove();
      }), $e.setOptions(__assign$2(__assign$2({}, $e.options), { onExitComplete: function() {
        return Qe.safeToRemove();
      } }))), globalProjectionState.hasEverUpdated = !0;
    }, ue.prototype.getSnapshotBeforeUpdate = function(Qe) {
      var Ue = this, He = this.props, Ge = He.layoutDependency, Xe = He.visualElement, Ke = He.drag, $e = He.isPresent, Je = Xe.projection;
      return Je && (Je.isPresent = $e, Ke || Qe.layoutDependency !== Ge || Ge === void 0 ? Je.willUpdate() : this.safeToRemove(), Qe.isPresent !== $e && ($e ? Je.promote() : Je.relegate() || sync.postRender(function() {
        var Ze;
        !((Ze = Je.getStack()) === null || Ze === void 0) && Ze.members.length || Ue.safeToRemove();
      }))), null;
    }, ue.prototype.componentDidUpdate = function() {
      var Qe = this.props.visualElement.projection;
      Qe && (Qe.root.didUpdate(), !Qe.currentAnimation && Qe.isLead() && this.safeToRemove());
    }, ue.prototype.componentWillUnmount = function() {
      var Qe = this.props, Ue = Qe.visualElement, He = Qe.layoutGroup, Ge = Qe.switchLayoutGroup, Xe = Ue.projection;
      Xe && (Xe.scheduleCheckAfterUnmount(), He != null && He.group && He.group.remove(Xe), Ge != null && Ge.deregister && Ge.deregister(Xe));
    }, ue.prototype.safeToRemove = function() {
      var Qe = this.props.safeToRemove;
      Qe == null || Qe();
    }, ue.prototype.render = function() {
      return null;
    }, ue;
  }(React__default.Component)
);
function MeasureLayout(me) {
  var ue = __read$1(usePresence(), 2), Qe = ue[0], Ue = ue[1], He = useContext(LayoutGroupContext);
  return React__default.createElement(MeasureLayoutWithContext, __assign$2({}, me, { layoutGroup: He, switchLayoutGroup: useContext(SwitchLayoutGroupContext), isPresent: Qe, safeToRemove: Ue }));
}
var defaultScaleCorrectors = {
  borderRadius: __assign$2(__assign$2({}, correctBorderRadius), { applyTo: [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ] }),
  borderTopLeftRadius: correctBorderRadius,
  borderTopRightRadius: correctBorderRadius,
  borderBottomLeftRadius: correctBorderRadius,
  borderBottomRightRadius: correctBorderRadius,
  boxShadow: correctBoxShadow
}, layoutFeatures = {
  measureLayout: MeasureLayout
};
function animate(me, ue, Qe) {
  Qe === void 0 && (Qe = {});
  var Ue = isMotionValue(me) ? me : motionValue(me);
  return startAnimation("", Ue, ue, Qe), {
    stop: function() {
      return Ue.stop();
    },
    isAnimating: function() {
      return Ue.isAnimating();
    }
  };
}
var borders = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], numBorders = borders.length, asNumber = function(me) {
  return typeof me == "string" ? parseFloat(me) : me;
}, isPx = function(me) {
  return typeof me == "number" || px.test(me);
};
function mixValues(me, ue, Qe, Ue, He, Ge) {
  var Xe, Ke, $e, Je;
  He ? (me.opacity = mix(
    0,
    // (follow?.opacity as number) ?? 0,
    // TODO Reinstate this if only child
    (Xe = Qe.opacity) !== null && Xe !== void 0 ? Xe : 1,
    easeCrossfadeIn(Ue)
  ), me.opacityExit = mix((Ke = ue.opacity) !== null && Ke !== void 0 ? Ke : 1, 0, easeCrossfadeOut(Ue))) : Ge && (me.opacity = mix(($e = ue.opacity) !== null && $e !== void 0 ? $e : 1, (Je = Qe.opacity) !== null && Je !== void 0 ? Je : 1, Ue));
  for (var Ze = 0; Ze < numBorders; Ze++) {
    var nt = "border".concat(borders[Ze], "Radius"), tt = getRadius(ue, nt), et = getRadius(Qe, nt);
    if (!(tt === void 0 && et === void 0)) {
      tt || (tt = 0), et || (et = 0);
      var rt = tt === 0 || et === 0 || isPx(tt) === isPx(et);
      rt ? (me[nt] = Math.max(mix(asNumber(tt), asNumber(et), Ue), 0), (percent.test(et) || percent.test(tt)) && (me[nt] += "%")) : me[nt] = et;
    }
  }
  (ue.rotate || Qe.rotate) && (me.rotate = mix(ue.rotate || 0, Qe.rotate || 0, Ue));
}
function getRadius(me, ue) {
  var Qe;
  return (Qe = me[ue]) !== null && Qe !== void 0 ? Qe : me.borderRadius;
}
var easeCrossfadeIn = compress(0, 0.5, circOut), easeCrossfadeOut = compress(0.5, 0.95, linear);
function compress(me, ue, Qe) {
  return function(Ue) {
    return Ue < me ? 0 : Ue > ue ? 1 : Qe(progress(me, ue, Ue));
  };
}
function copyAxisInto(me, ue) {
  me.min = ue.min, me.max = ue.max;
}
function copyBoxInto(me, ue) {
  copyAxisInto(me.x, ue.x), copyAxisInto(me.y, ue.y);
}
function removePointDelta(me, ue, Qe, Ue, He) {
  return me -= ue, me = scalePoint(me, 1 / Qe, Ue), He !== void 0 && (me = scalePoint(me, 1 / He, Ue)), me;
}
function removeAxisDelta(me, ue, Qe, Ue, He, Ge, Xe) {
  if (ue === void 0 && (ue = 0), Qe === void 0 && (Qe = 1), Ue === void 0 && (Ue = 0.5), Ge === void 0 && (Ge = me), Xe === void 0 && (Xe = me), percent.test(ue)) {
    ue = parseFloat(ue);
    var Ke = mix(Xe.min, Xe.max, ue / 100);
    ue = Ke - Xe.min;
  }
  if (typeof ue == "number") {
    var $e = mix(Ge.min, Ge.max, Ue);
    me === Ge && ($e -= ue), me.min = removePointDelta(me.min, ue, Qe, $e, He), me.max = removePointDelta(me.max, ue, Qe, $e, He);
  }
}
function removeAxisTransforms(me, ue, Qe, Ue, He) {
  var Ge = __read$1(Qe, 3), Xe = Ge[0], Ke = Ge[1], $e = Ge[2];
  removeAxisDelta(me, ue[Xe], ue[Ke], ue[$e], ue.scale, Ue, He);
}
var xKeys = ["x", "scaleX", "originX"], yKeys = ["y", "scaleY", "originY"];
function removeBoxTransforms(me, ue, Qe, Ue) {
  removeAxisTransforms(me.x, ue, xKeys, Qe == null ? void 0 : Qe.x, Ue == null ? void 0 : Ue.x), removeAxisTransforms(me.y, ue, yKeys, Qe == null ? void 0 : Qe.y, Ue == null ? void 0 : Ue.y);
}
function isAxisDeltaZero(me) {
  return me.translate === 0 && me.scale === 1;
}
function isDeltaZero(me) {
  return isAxisDeltaZero(me.x) && isAxisDeltaZero(me.y);
}
function boxEquals(me, ue) {
  return me.x.min === ue.x.min && me.x.max === ue.x.max && me.y.min === ue.y.min && me.y.max === ue.y.max;
}
var NodeStack = (
  /** @class */
  function() {
    function me() {
      this.members = [];
    }
    return me.prototype.add = function(ue) {
      addUniqueItem(this.members, ue), ue.scheduleRender();
    }, me.prototype.remove = function(ue) {
      if (removeItem(this.members, ue), ue === this.prevLead && (this.prevLead = void 0), ue === this.lead) {
        var Qe = this.members[this.members.length - 1];
        Qe && this.promote(Qe);
      }
    }, me.prototype.relegate = function(ue) {
      var Qe = this.members.findIndex(function(Xe) {
        return ue === Xe;
      });
      if (Qe === 0)
        return !1;
      for (var Ue, He = Qe; He >= 0; He--) {
        var Ge = this.members[He];
        if (Ge.isPresent !== !1) {
          Ue = Ge;
          break;
        }
      }
      return Ue ? (this.promote(Ue), !0) : !1;
    }, me.prototype.promote = function(ue, Qe) {
      var Ue, He = this.lead;
      if (ue !== He && (this.prevLead = He, this.lead = ue, ue.show(), He)) {
        He.instance && He.scheduleRender(), ue.scheduleRender(), ue.resumeFrom = He, Qe && (ue.resumeFrom.preserveOpacity = !0), He.snapshot && (ue.snapshot = He.snapshot, ue.snapshot.latestValues = He.animationValues || He.latestValues, ue.snapshot.isShared = !0), !((Ue = ue.root) === null || Ue === void 0) && Ue.isUpdating && (ue.isLayoutDirty = !0);
        var Ge = ue.options.crossfade;
        Ge === !1 && He.hide();
      }
    }, me.prototype.exitAnimationComplete = function() {
      this.members.forEach(function(ue) {
        var Qe, Ue, He, Ge, Xe;
        (Ue = (Qe = ue.options).onExitComplete) === null || Ue === void 0 || Ue.call(Qe), (Xe = (He = ue.resumingFrom) === null || He === void 0 ? void 0 : (Ge = He.options).onExitComplete) === null || Xe === void 0 || Xe.call(Ge);
      });
    }, me.prototype.scheduleRender = function() {
      this.members.forEach(function(ue) {
        ue.instance && ue.scheduleRender(!1);
      });
    }, me.prototype.removeLeadSnapshot = function() {
      this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
    }, me;
  }()
), identityProjection = "translate3d(0px, 0px, 0) scale(1, 1) scale(1, 1)";
function buildProjectionTransform(me, ue, Qe) {
  var Ue = me.x.translate / ue.x, He = me.y.translate / ue.y, Ge = "translate3d(".concat(Ue, "px, ").concat(He, "px, 0) ");
  if (Ge += "scale(".concat(1 / ue.x, ", ").concat(1 / ue.y, ") "), Qe) {
    var Xe = Qe.rotate, Ke = Qe.rotateX, $e = Qe.rotateY;
    Xe && (Ge += "rotate(".concat(Xe, "deg) ")), Ke && (Ge += "rotateX(".concat(Ke, "deg) ")), $e && (Ge += "rotateY(".concat($e, "deg) "));
  }
  var Je = me.x.scale * ue.x, Ze = me.y.scale * ue.y;
  return Ge += "scale(".concat(Je, ", ").concat(Ze, ")"), Ge === identityProjection ? "none" : Ge;
}
var compareByDepth = function(me, ue) {
  return me.depth - ue.depth;
}, FlatTree = (
  /** @class */
  function() {
    function me() {
      this.children = [], this.isDirty = !1;
    }
    return me.prototype.add = function(ue) {
      addUniqueItem(this.children, ue), this.isDirty = !0;
    }, me.prototype.remove = function(ue) {
      removeItem(this.children, ue), this.isDirty = !0;
    }, me.prototype.forEach = function(ue) {
      this.isDirty && this.children.sort(compareByDepth), this.isDirty = !1, this.children.forEach(ue);
    }, me;
  }()
), animationTarget = 1e3;
function createProjectionNode(me) {
  var ue = me.attachResizeListener, Qe = me.defaultParent, Ue = me.measureScroll, He = me.checkIsScrollRoot, Ge = me.resetTransform;
  return (
    /** @class */
    function() {
      function Xe(Ke, $e, Je) {
        var Ze = this;
        $e === void 0 && ($e = {}), Je === void 0 && (Je = Qe == null ? void 0 : Qe()), this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.potentialNodes = /* @__PURE__ */ new Map(), this.checkUpdateFailed = function() {
          Ze.isUpdating && (Ze.isUpdating = !1, Ze.clearAllSnapshots());
        }, this.updateProjection = function() {
          Ze.nodes.forEach(resolveTargetDelta), Ze.nodes.forEach(calcProjection);
        }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.id = Ke, this.latestValues = $e, this.root = Je ? Je.root || Je : this, this.path = Je ? __spreadArray$1(__spreadArray$1([], __read$1(Je.path), !1), [Je], !1) : [], this.parent = Je, this.depth = Je ? Je.depth + 1 : 0, Ke && this.root.registerPotentialNode(Ke, this);
        for (var nt = 0; nt < this.path.length; nt++)
          this.path[nt].shouldResetTransform = !0;
        this.root === this && (this.nodes = new FlatTree());
      }
      return Xe.prototype.addEventListener = function(Ke, $e) {
        return this.eventHandlers.has(Ke) || this.eventHandlers.set(Ke, new SubscriptionManager()), this.eventHandlers.get(Ke).add($e);
      }, Xe.prototype.notifyListeners = function(Ke) {
        for (var $e = [], Je = 1; Je < arguments.length; Je++)
          $e[Je - 1] = arguments[Je];
        var Ze = this.eventHandlers.get(Ke);
        Ze == null || Ze.notify.apply(Ze, __spreadArray$1([], __read$1($e), !1));
      }, Xe.prototype.hasListeners = function(Ke) {
        return this.eventHandlers.has(Ke);
      }, Xe.prototype.registerPotentialNode = function(Ke, $e) {
        this.potentialNodes.set(Ke, $e);
      }, Xe.prototype.mount = function(Ke, $e) {
        var Je = this, Ze;
        if ($e === void 0 && ($e = !1), !this.instance) {
          this.isSVG = Ke instanceof SVGElement && Ke.tagName !== "svg", this.instance = Ke;
          var nt = this.options, tt = nt.layoutId, et = nt.layout, rt = nt.visualElement;
          if (rt && !rt.getInstance() && rt.mount(Ke), this.root.nodes.add(this), (Ze = this.parent) === null || Ze === void 0 || Ze.children.add(this), this.id && this.root.potentialNodes.delete(this.id), $e && (et || tt) && (this.isLayoutDirty = !0), ue) {
            var it, ot = function() {
              return Je.root.updateBlockedByResize = !1;
            };
            ue(Ke, function() {
              Je.root.updateBlockedByResize = !0, clearTimeout(it), it = window.setTimeout(ot, 250), globalProjectionState.hasAnimatedSinceResize && (globalProjectionState.hasAnimatedSinceResize = !1, Je.nodes.forEach(finishAnimation));
            });
          }
          tt && this.root.registerSharedNode(tt, this), this.options.animate !== !1 && rt && (tt || et) && this.addEventListener("didUpdate", function(at) {
            var st, ut, lt, dt, At, pt = at.delta, gt = at.hasLayoutChanged, wt = at.hasRelativeTargetChanged, Bt = at.layout;
            if (Je.isTreeAnimationBlocked()) {
              Je.target = void 0, Je.relativeTarget = void 0;
              return;
            }
            var Tt = (ut = (st = Je.options.transition) !== null && st !== void 0 ? st : rt.getDefaultTransition()) !== null && ut !== void 0 ? ut : defaultLayoutTransition, yt = rt.getProps(), Ct = yt.onLayoutAnimationStart, ht = yt.onLayoutAnimationComplete, It = !Je.targetLayout || !boxEquals(Je.targetLayout, Bt) || wt, vt = !gt && wt;
            if (!((lt = Je.resumeFrom) === null || lt === void 0) && lt.instance || vt || gt && (It || !Je.currentAnimation)) {
              Je.resumeFrom && (Je.resumingFrom = Je.resumeFrom, Je.resumingFrom.resumingFrom = void 0), Je.setAnimationOrigin(pt, vt);
              var Et = __assign$2(__assign$2({}, getValueTransition(Tt, "layout")), { onPlay: Ct, onComplete: ht });
              rt.shouldReduceMotion && (Et.delay = 0, Et.type = !1), Je.startAnimation(Et);
            } else
              !gt && Je.animationProgress === 0 && Je.finishAnimation(), Je.isLead() && ((At = (dt = Je.options).onExitComplete) === null || At === void 0 || At.call(dt));
            Je.targetLayout = Bt;
          });
        }
      }, Xe.prototype.unmount = function() {
        var Ke, $e;
        this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this), (Ke = this.getStack()) === null || Ke === void 0 || Ke.remove(this), ($e = this.parent) === null || $e === void 0 || $e.children.delete(this), this.instance = void 0, cancelSync.preRender(this.updateProjection);
      }, Xe.prototype.blockUpdate = function() {
        this.updateManuallyBlocked = !0;
      }, Xe.prototype.unblockUpdate = function() {
        this.updateManuallyBlocked = !1;
      }, Xe.prototype.isUpdateBlocked = function() {
        return this.updateManuallyBlocked || this.updateBlockedByResize;
      }, Xe.prototype.isTreeAnimationBlocked = function() {
        var Ke;
        return this.isAnimationBlocked || ((Ke = this.parent) === null || Ke === void 0 ? void 0 : Ke.isTreeAnimationBlocked()) || !1;
      }, Xe.prototype.startUpdate = function() {
        var Ke;
        this.isUpdateBlocked() || (this.isUpdating = !0, (Ke = this.nodes) === null || Ke === void 0 || Ke.forEach(resetRotation));
      }, Xe.prototype.willUpdate = function(Ke) {
        var $e, Je, Ze;
        if (Ke === void 0 && (Ke = !0), this.root.isUpdateBlocked()) {
          (Je = ($e = this.options).onExitComplete) === null || Je === void 0 || Je.call($e);
          return;
        }
        if (!this.root.isUpdating && this.root.startUpdate(), !this.isLayoutDirty) {
          this.isLayoutDirty = !0;
          for (var nt = 0; nt < this.path.length; nt++) {
            var tt = this.path[nt];
            tt.shouldResetTransform = !0, tt.updateScroll();
          }
          var et = this.options, rt = et.layoutId, it = et.layout;
          if (!(rt === void 0 && !it)) {
            var ot = (Ze = this.options.visualElement) === null || Ze === void 0 ? void 0 : Ze.getProps().transformTemplate;
            this.prevTransformTemplateValue = ot == null ? void 0 : ot(this.latestValues, ""), this.updateSnapshot(), Ke && this.notifyListeners("willUpdate");
          }
        }
      }, Xe.prototype.didUpdate = function() {
        var Ke = this.isUpdateBlocked();
        if (Ke) {
          this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(clearMeasurements);
          return;
        }
        this.isUpdating && (this.isUpdating = !1, this.potentialNodes.size && (this.potentialNodes.forEach(mountNodeEarly), this.potentialNodes.clear()), this.nodes.forEach(resetTransformStyle), this.nodes.forEach(updateLayout), this.nodes.forEach(notifyLayoutUpdate), this.clearAllSnapshots(), flushSync.update(), flushSync.preRender(), flushSync.render());
      }, Xe.prototype.clearAllSnapshots = function() {
        this.nodes.forEach(clearSnapshot), this.sharedNodes.forEach(removeLeadSnapshots);
      }, Xe.prototype.scheduleUpdateProjection = function() {
        sync.preRender(this.updateProjection, !1, !0);
      }, Xe.prototype.scheduleCheckAfterUnmount = function() {
        var Ke = this;
        sync.postRender(function() {
          Ke.isLayoutDirty ? Ke.root.didUpdate() : Ke.root.checkUpdateFailed();
        });
      }, Xe.prototype.updateSnapshot = function() {
        if (!(this.snapshot || !this.instance)) {
          var Ke = this.measure(), $e = this.removeTransform(this.removeElementScroll(Ke));
          roundBox($e), this.snapshot = {
            measured: Ke,
            layout: $e,
            latestValues: {}
          };
        }
      }, Xe.prototype.updateLayout = function() {
        var Ke;
        if (this.instance && (this.updateScroll(), !(!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))) {
          if (this.resumeFrom && !this.resumeFrom.instance)
            for (var $e = 0; $e < this.path.length; $e++) {
              var Je = this.path[$e];
              Je.updateScroll();
            }
          var Ze = this.measure();
          roundBox(Ze);
          var nt = this.layout;
          this.layout = {
            measured: Ze,
            actual: this.removeElementScroll(Ze)
          }, this.layoutCorrected = createBox(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.actual), (Ke = this.options.visualElement) === null || Ke === void 0 || Ke.notifyLayoutMeasure(this.layout.actual, nt == null ? void 0 : nt.actual);
        }
      }, Xe.prototype.updateScroll = function() {
        this.options.layoutScroll && this.instance && (this.isScrollRoot = He(this.instance), this.scroll = Ue(this.instance));
      }, Xe.prototype.resetTransform = function() {
        var Ke;
        if (Ge) {
          var $e = this.isLayoutDirty || this.shouldResetTransform, Je = this.projectionDelta && !isDeltaZero(this.projectionDelta), Ze = (Ke = this.options.visualElement) === null || Ke === void 0 ? void 0 : Ke.getProps().transformTemplate, nt = Ze == null ? void 0 : Ze(this.latestValues, ""), tt = nt !== this.prevTransformTemplateValue;
          $e && (Je || hasTransform(this.latestValues) || tt) && (Ge(this.instance, nt), this.shouldResetTransform = !1, this.scheduleRender());
        }
      }, Xe.prototype.measure = function() {
        var Ke = this.options.visualElement;
        if (!Ke)
          return createBox();
        var $e = Ke.measureViewportBox(), Je = this.root.scroll;
        return Je && (translateAxis($e.x, Je.x), translateAxis($e.y, Je.y)), $e;
      }, Xe.prototype.removeElementScroll = function(Ke) {
        var $e = createBox();
        copyBoxInto($e, Ke);
        for (var Je = 0; Je < this.path.length; Je++) {
          var Ze = this.path[Je], nt = Ze.scroll, tt = Ze.options, et = Ze.isScrollRoot;
          if (Ze !== this.root && nt && tt.layoutScroll) {
            if (et) {
              copyBoxInto($e, Ke);
              var rt = this.root.scroll;
              rt && (translateAxis($e.x, -rt.x), translateAxis($e.y, -rt.y));
            }
            translateAxis($e.x, nt.x), translateAxis($e.y, nt.y);
          }
        }
        return $e;
      }, Xe.prototype.applyTransform = function(Ke, $e) {
        $e === void 0 && ($e = !1);
        var Je = createBox();
        copyBoxInto(Je, Ke);
        for (var Ze = 0; Ze < this.path.length; Ze++) {
          var nt = this.path[Ze];
          !$e && nt.options.layoutScroll && nt.scroll && nt !== nt.root && transformBox(Je, {
            x: -nt.scroll.x,
            y: -nt.scroll.y
          }), hasTransform(nt.latestValues) && transformBox(Je, nt.latestValues);
        }
        return hasTransform(this.latestValues) && transformBox(Je, this.latestValues), Je;
      }, Xe.prototype.removeTransform = function(Ke) {
        var $e, Je = createBox();
        copyBoxInto(Je, Ke);
        for (var Ze = 0; Ze < this.path.length; Ze++) {
          var nt = this.path[Ze];
          if (nt.instance && hasTransform(nt.latestValues)) {
            hasScale(nt.latestValues) && nt.updateSnapshot();
            var tt = createBox(), et = nt.measure();
            copyBoxInto(tt, et), removeBoxTransforms(Je, nt.latestValues, ($e = nt.snapshot) === null || $e === void 0 ? void 0 : $e.layout, tt);
          }
        }
        return hasTransform(this.latestValues) && removeBoxTransforms(Je, this.latestValues), Je;
      }, Xe.prototype.setTargetDelta = function(Ke) {
        this.targetDelta = Ke, this.root.scheduleUpdateProjection();
      }, Xe.prototype.setOptions = function(Ke) {
        var $e;
        this.options = __assign$2(__assign$2(__assign$2({}, this.options), Ke), { crossfade: ($e = Ke.crossfade) !== null && $e !== void 0 ? $e : !0 });
      }, Xe.prototype.clearMeasurements = function() {
        this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
      }, Xe.prototype.resolveTargetDelta = function() {
        var Ke, $e = this.options, Je = $e.layout, Ze = $e.layoutId;
        !this.layout || !(Je || Ze) || (!this.targetDelta && !this.relativeTarget && (this.relativeParent = this.getClosestProjectingParent(), this.relativeParent && this.relativeParent.layout && (this.relativeTarget = createBox(), this.relativeTargetOrigin = createBox(), calcRelativePosition(this.relativeTargetOrigin, this.layout.actual, this.relativeParent.layout.actual), copyBoxInto(this.relativeTarget, this.relativeTargetOrigin))), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = createBox(), this.targetWithTransforms = createBox()), this.relativeTarget && this.relativeTargetOrigin && (!((Ke = this.relativeParent) === null || Ke === void 0) && Ke.target) ? calcRelativeBox(this.target, this.relativeTarget, this.relativeParent.target) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.actual) : copyBoxInto(this.target, this.layout.actual), applyBoxDelta(this.target, this.targetDelta)) : copyBoxInto(this.target, this.layout.actual), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, this.relativeParent = this.getClosestProjectingParent(), this.relativeParent && !!this.relativeParent.resumingFrom == !!this.resumingFrom && !this.relativeParent.options.layoutScroll && this.relativeParent.target && (this.relativeTarget = createBox(), this.relativeTargetOrigin = createBox(), calcRelativePosition(this.relativeTargetOrigin, this.target, this.relativeParent.target), copyBoxInto(this.relativeTarget, this.relativeTargetOrigin)))));
      }, Xe.prototype.getClosestProjectingParent = function() {
        if (!(!this.parent || hasTransform(this.parent.latestValues)))
          return (this.parent.relativeTarget || this.parent.targetDelta) && this.parent.layout ? this.parent : this.parent.getClosestProjectingParent();
      }, Xe.prototype.calcProjection = function() {
        var Ke, $e = this.options, Je = $e.layout, Ze = $e.layoutId;
        if (this.isTreeAnimating = !!(!((Ke = this.parent) === null || Ke === void 0) && Ke.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !(!this.layout || !(Je || Ze))) {
          var nt = this.getLead();
          copyBoxInto(this.layoutCorrected, this.layout.actual), applyTreeDeltas(this.layoutCorrected, this.treeScale, this.path, !!this.resumingFrom || this !== nt);
          var tt = nt.target;
          if (tt) {
            this.projectionDelta || (this.projectionDelta = createDelta(), this.projectionDeltaWithTransform = createDelta());
            var et = this.treeScale.x, rt = this.treeScale.y, it = this.projectionTransform;
            calcBoxDelta(this.projectionDelta, this.layoutCorrected, tt, this.latestValues), this.projectionTransform = buildProjectionTransform(this.projectionDelta, this.treeScale), (this.projectionTransform !== it || this.treeScale.x !== et || this.treeScale.y !== rt) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", tt));
          }
        }
      }, Xe.prototype.hide = function() {
        this.isVisible = !1;
      }, Xe.prototype.show = function() {
        this.isVisible = !0;
      }, Xe.prototype.scheduleRender = function(Ke) {
        var $e, Je, Ze;
        Ke === void 0 && (Ke = !0), (Je = ($e = this.options).scheduleRender) === null || Je === void 0 || Je.call($e), Ke && ((Ze = this.getStack()) === null || Ze === void 0 || Ze.scheduleRender()), this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
      }, Xe.prototype.setAnimationOrigin = function(Ke, $e) {
        var Je = this, Ze;
        $e === void 0 && ($e = !1);
        var nt = this.snapshot, tt = (nt == null ? void 0 : nt.latestValues) || {}, et = __assign$2({}, this.latestValues), rt = createDelta();
        this.relativeTarget = this.relativeTargetOrigin = void 0, this.attemptToResolveRelativeTarget = !$e;
        var it = createBox(), ot = nt == null ? void 0 : nt.isShared, at = (((Ze = this.getStack()) === null || Ze === void 0 ? void 0 : Ze.members.length) || 0) <= 1, st = !!(ot && !at && this.options.crossfade === !0 && !this.path.some(hasOpacityCrossfade));
        this.animationProgress = 0, this.mixTargetDelta = function(ut) {
          var lt, dt = ut / 1e3;
          mixAxisDelta(rt.x, Ke.x, dt), mixAxisDelta(rt.y, Ke.y, dt), Je.setTargetDelta(rt), Je.relativeTarget && Je.relativeTargetOrigin && Je.layout && (!((lt = Je.relativeParent) === null || lt === void 0) && lt.layout) && (calcRelativePosition(it, Je.layout.actual, Je.relativeParent.layout.actual), mixBox(Je.relativeTarget, Je.relativeTargetOrigin, it, dt)), ot && (Je.animationValues = et, mixValues(et, tt, Je.latestValues, dt, st, at)), Je.root.scheduleUpdateProjection(), Je.scheduleRender(), Je.animationProgress = dt;
        }, this.mixTargetDelta(0);
      }, Xe.prototype.startAnimation = function(Ke) {
        var $e = this, Je, Ze;
        this.notifyListeners("animationStart"), (Je = this.currentAnimation) === null || Je === void 0 || Je.stop(), this.resumingFrom && ((Ze = this.resumingFrom.currentAnimation) === null || Ze === void 0 || Ze.stop()), this.pendingAnimation && (cancelSync.update(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = sync.update(function() {
          globalProjectionState.hasAnimatedSinceResize = !0, $e.currentAnimation = animate(0, animationTarget, __assign$2(__assign$2({}, Ke), { onUpdate: function(nt) {
            var tt;
            $e.mixTargetDelta(nt), (tt = Ke.onUpdate) === null || tt === void 0 || tt.call(Ke, nt);
          }, onComplete: function() {
            var nt;
            (nt = Ke.onComplete) === null || nt === void 0 || nt.call(Ke), $e.completeAnimation();
          } })), $e.resumingFrom && ($e.resumingFrom.currentAnimation = $e.currentAnimation), $e.pendingAnimation = void 0;
        });
      }, Xe.prototype.completeAnimation = function() {
        var Ke;
        this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0), (Ke = this.getStack()) === null || Ke === void 0 || Ke.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
      }, Xe.prototype.finishAnimation = function() {
        var Ke;
        this.currentAnimation && ((Ke = this.mixTargetDelta) === null || Ke === void 0 || Ke.call(this, animationTarget), this.currentAnimation.stop()), this.completeAnimation();
      }, Xe.prototype.applyTransformsToTarget = function() {
        var Ke = this.getLead(), $e = Ke.targetWithTransforms, Je = Ke.target, Ze = Ke.layout, nt = Ke.latestValues;
        !$e || !Je || !Ze || (copyBoxInto($e, Je), transformBox($e, nt), calcBoxDelta(this.projectionDeltaWithTransform, this.layoutCorrected, $e, nt));
      }, Xe.prototype.registerSharedNode = function(Ke, $e) {
        var Je, Ze, nt;
        this.sharedNodes.has(Ke) || this.sharedNodes.set(Ke, new NodeStack());
        var tt = this.sharedNodes.get(Ke);
        tt.add($e), $e.promote({
          transition: (Je = $e.options.initialPromotionConfig) === null || Je === void 0 ? void 0 : Je.transition,
          preserveFollowOpacity: (nt = (Ze = $e.options.initialPromotionConfig) === null || Ze === void 0 ? void 0 : Ze.shouldPreserveFollowOpacity) === null || nt === void 0 ? void 0 : nt.call(Ze, $e)
        });
      }, Xe.prototype.isLead = function() {
        var Ke = this.getStack();
        return Ke ? Ke.lead === this : !0;
      }, Xe.prototype.getLead = function() {
        var Ke, $e = this.options.layoutId;
        return $e ? ((Ke = this.getStack()) === null || Ke === void 0 ? void 0 : Ke.lead) || this : this;
      }, Xe.prototype.getPrevLead = function() {
        var Ke, $e = this.options.layoutId;
        return $e ? (Ke = this.getStack()) === null || Ke === void 0 ? void 0 : Ke.prevLead : void 0;
      }, Xe.prototype.getStack = function() {
        var Ke = this.options.layoutId;
        if (Ke)
          return this.root.sharedNodes.get(Ke);
      }, Xe.prototype.promote = function(Ke) {
        var $e = Ke === void 0 ? {} : Ke, Je = $e.needsReset, Ze = $e.transition, nt = $e.preserveFollowOpacity, tt = this.getStack();
        tt && tt.promote(this, nt), Je && (this.projectionDelta = void 0, this.needsReset = !0), Ze && this.setOptions({ transition: Ze });
      }, Xe.prototype.relegate = function() {
        var Ke = this.getStack();
        return Ke ? Ke.relegate(this) : !1;
      }, Xe.prototype.resetRotation = function() {
        var Ke = this.options.visualElement;
        if (Ke) {
          for (var $e = !1, Je = {}, Ze = 0; Ze < transformAxes.length; Ze++) {
            var nt = transformAxes[Ze], tt = "rotate" + nt;
            Ke.getStaticValue(tt) && ($e = !0, Je[tt] = Ke.getStaticValue(tt), Ke.setStaticValue(tt, 0));
          }
          if ($e) {
            Ke == null || Ke.syncRender();
            for (var tt in Je)
              Ke.setStaticValue(tt, Je[tt]);
            Ke.scheduleRender();
          }
        }
      }, Xe.prototype.getProjectionStyles = function(Ke) {
        var $e, Je, Ze, nt, tt, et;
        Ke === void 0 && (Ke = {});
        var rt = {};
        if (!this.instance || this.isSVG)
          return rt;
        if (this.isVisible)
          rt.visibility = "";
        else
          return { visibility: "hidden" };
        var it = ($e = this.options.visualElement) === null || $e === void 0 ? void 0 : $e.getProps().transformTemplate;
        if (this.needsReset)
          return this.needsReset = !1, rt.opacity = "", rt.pointerEvents = resolveMotionValue(Ke.pointerEvents) || "", rt.transform = it ? it(this.latestValues, "") : "none", rt;
        var ot = this.getLead();
        if (!this.projectionDelta || !this.layout || !ot.target) {
          var at = {};
          return this.options.layoutId && (at.opacity = (Je = this.latestValues.opacity) !== null && Je !== void 0 ? Je : 1, at.pointerEvents = resolveMotionValue(Ke.pointerEvents) || ""), this.hasProjected && !hasTransform(this.latestValues) && (at.transform = it ? it({}, "") : "none", this.hasProjected = !1), at;
        }
        var st = ot.animationValues || ot.latestValues;
        this.applyTransformsToTarget(), rt.transform = buildProjectionTransform(this.projectionDeltaWithTransform, this.treeScale, st), it && (rt.transform = it(st, rt.transform));
        var ut = this.projectionDelta, lt = ut.x, dt = ut.y;
        rt.transformOrigin = "".concat(lt.origin * 100, "% ").concat(dt.origin * 100, "% 0"), ot.animationValues ? rt.opacity = ot === this ? (nt = (Ze = st.opacity) !== null && Ze !== void 0 ? Ze : this.latestValues.opacity) !== null && nt !== void 0 ? nt : 1 : this.preserveOpacity ? this.latestValues.opacity : st.opacityExit : rt.opacity = ot === this ? (tt = st.opacity) !== null && tt !== void 0 ? tt : "" : (et = st.opacityExit) !== null && et !== void 0 ? et : 0;
        for (var At in scaleCorrectors)
          if (st[At] !== void 0) {
            var pt = scaleCorrectors[At], gt = pt.correct, wt = pt.applyTo, Bt = gt(st[At], ot);
            if (wt)
              for (var Tt = wt.length, yt = 0; yt < Tt; yt++)
                rt[wt[yt]] = Bt;
            else
              rt[At] = Bt;
          }
        return this.options.layoutId && (rt.pointerEvents = ot === this ? resolveMotionValue(Ke.pointerEvents) || "" : "none"), rt;
      }, Xe.prototype.clearSnapshot = function() {
        this.resumeFrom = this.snapshot = void 0;
      }, Xe.prototype.resetTree = function() {
        this.root.nodes.forEach(function(Ke) {
          var $e;
          return ($e = Ke.currentAnimation) === null || $e === void 0 ? void 0 : $e.stop();
        }), this.root.nodes.forEach(clearMeasurements), this.root.sharedNodes.clear();
      }, Xe;
    }()
  );
}
function updateLayout(me) {
  me.updateLayout();
}
function notifyLayoutUpdate(me) {
  var ue, Qe, Ue, He, Ge = (Qe = (ue = me.resumeFrom) === null || ue === void 0 ? void 0 : ue.snapshot) !== null && Qe !== void 0 ? Qe : me.snapshot;
  if (me.isLead() && me.layout && Ge && me.hasListeners("didUpdate")) {
    var Xe = me.layout, Ke = Xe.actual, $e = Xe.measured;
    me.options.animationType === "size" ? eachAxis(function(st) {
      var ut = Ge.isShared ? Ge.measured[st] : Ge.layout[st], lt = calcLength(ut);
      ut.min = Ke[st].min, ut.max = ut.min + lt;
    }) : me.options.animationType === "position" && eachAxis(function(st) {
      var ut = Ge.isShared ? Ge.measured[st] : Ge.layout[st], lt = calcLength(Ke[st]);
      ut.max = ut.min + lt;
    });
    var Je = createDelta();
    calcBoxDelta(Je, Ke, Ge.layout);
    var Ze = createDelta();
    Ge.isShared ? calcBoxDelta(Ze, me.applyTransform($e, !0), Ge.measured) : calcBoxDelta(Ze, Ke, Ge.layout);
    var nt = !isDeltaZero(Je), tt = !1;
    if (!me.resumeFrom && (me.relativeParent = me.getClosestProjectingParent(), me.relativeParent && !me.relativeParent.resumeFrom)) {
      var et = me.relativeParent, rt = et.snapshot, it = et.layout;
      if (rt && it) {
        var ot = createBox();
        calcRelativePosition(ot, Ge.layout, rt.layout);
        var at = createBox();
        calcRelativePosition(at, Ke, it.actual), boxEquals(ot, at) || (tt = !0);
      }
    }
    me.notifyListeners("didUpdate", {
      layout: Ke,
      snapshot: Ge,
      delta: Ze,
      layoutDelta: Je,
      hasLayoutChanged: nt,
      hasRelativeTargetChanged: tt
    });
  } else me.isLead() && ((He = (Ue = me.options).onExitComplete) === null || He === void 0 || He.call(Ue));
  me.options.transition = void 0;
}
function clearSnapshot(me) {
  me.clearSnapshot();
}
function clearMeasurements(me) {
  me.clearMeasurements();
}
function resetTransformStyle(me) {
  var ue = me.options.visualElement;
  ue != null && ue.getProps().onBeforeLayoutMeasure && ue.notifyBeforeLayoutMeasure(), me.resetTransform();
}
function finishAnimation(me) {
  me.finishAnimation(), me.targetDelta = me.relativeTarget = me.target = void 0;
}
function resolveTargetDelta(me) {
  me.resolveTargetDelta();
}
function calcProjection(me) {
  me.calcProjection();
}
function resetRotation(me) {
  me.resetRotation();
}
function removeLeadSnapshots(me) {
  me.removeLeadSnapshot();
}
function mixAxisDelta(me, ue, Qe) {
  me.translate = mix(ue.translate, 0, Qe), me.scale = mix(ue.scale, 1, Qe), me.origin = ue.origin, me.originPoint = ue.originPoint;
}
function mixAxis(me, ue, Qe, Ue) {
  me.min = mix(ue.min, Qe.min, Ue), me.max = mix(ue.max, Qe.max, Ue);
}
function mixBox(me, ue, Qe, Ue) {
  mixAxis(me.x, ue.x, Qe.x, Ue), mixAxis(me.y, ue.y, Qe.y, Ue);
}
function hasOpacityCrossfade(me) {
  return me.animationValues && me.animationValues.opacityExit !== void 0;
}
var defaultLayoutTransition = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
function mountNodeEarly(me, ue) {
  for (var Qe = me.root, Ue = me.path.length - 1; Ue >= 0; Ue--)
    if (me.path[Ue].instance) {
      Qe = me.path[Ue];
      break;
    }
  var He = Qe && Qe !== me.root ? Qe.instance : document, Ge = He.querySelector('[data-projection-id="'.concat(ue, '"]'));
  Ge && me.mount(Ge, !0);
}
function roundAxis(me) {
  me.min = Math.round(me.min), me.max = Math.round(me.max);
}
function roundBox(me) {
  roundAxis(me.x), roundAxis(me.y);
}
var DocumentProjectionNode = createProjectionNode({
  attachResizeListener: function(me, ue) {
    return addDomEvent(me, "resize", ue);
  },
  measureScroll: function() {
    return {
      x: document.documentElement.scrollLeft || document.body.scrollLeft,
      y: document.documentElement.scrollTop || document.body.scrollTop
    };
  },
  checkIsScrollRoot: function() {
    return !0;
  }
}), rootProjectionNode = {
  current: void 0
}, HTMLProjectionNode = createProjectionNode({
  measureScroll: function(me) {
    return {
      x: me.scrollLeft,
      y: me.scrollTop
    };
  },
  defaultParent: function() {
    if (!rootProjectionNode.current) {
      var me = new DocumentProjectionNode(0, {});
      me.mount(window), me.setOptions({ layoutScroll: !0 }), rootProjectionNode.current = me;
    }
    return rootProjectionNode.current;
  },
  resetTransform: function(me, ue) {
    me.style.transform = ue ?? "none";
  },
  checkIsScrollRoot: function(me) {
    return window.getComputedStyle(me).position === "fixed";
  }
}), featureBundle = __assign$2(__assign$2(__assign$2(__assign$2({}, animations), gestureAnimations), drag), layoutFeatures), motion = /* @__PURE__ */ createMotionProxy(function(me, ue) {
  return createDomMotionConfig(me, ue, featureBundle, createDomVisualElement, HTMLProjectionNode);
}), reactIs$1 = { exports: {} }, reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var me = typeof Symbol == "function" && Symbol.for, ue = me ? Symbol.for("react.element") : 60103, Qe = me ? Symbol.for("react.portal") : 60106, Ue = me ? Symbol.for("react.fragment") : 60107, He = me ? Symbol.for("react.strict_mode") : 60108, Ge = me ? Symbol.for("react.profiler") : 60114, Xe = me ? Symbol.for("react.provider") : 60109, Ke = me ? Symbol.for("react.context") : 60110, $e = me ? Symbol.for("react.async_mode") : 60111, Je = me ? Symbol.for("react.concurrent_mode") : 60111, Ze = me ? Symbol.for("react.forward_ref") : 60112, nt = me ? Symbol.for("react.suspense") : 60113, tt = me ? Symbol.for("react.suspense_list") : 60120, et = me ? Symbol.for("react.memo") : 60115, rt = me ? Symbol.for("react.lazy") : 60116, it = me ? Symbol.for("react.block") : 60121, ot = me ? Symbol.for("react.fundamental") : 60117, at = me ? Symbol.for("react.responder") : 60118, st = me ? Symbol.for("react.scope") : 60119;
  function ut(dt) {
    if (typeof dt == "object" && dt !== null) {
      var At = dt.$$typeof;
      switch (At) {
        case ue:
          switch (dt = dt.type, dt) {
            case $e:
            case Je:
            case Ue:
            case Ge:
            case He:
            case nt:
              return dt;
            default:
              switch (dt = dt && dt.$$typeof, dt) {
                case Ke:
                case Ze:
                case rt:
                case et:
                case Xe:
                  return dt;
                default:
                  return At;
              }
          }
        case Qe:
          return At;
      }
    }
  }
  function lt(dt) {
    return ut(dt) === Je;
  }
  return reactIs_production_min.AsyncMode = $e, reactIs_production_min.ConcurrentMode = Je, reactIs_production_min.ContextConsumer = Ke, reactIs_production_min.ContextProvider = Xe, reactIs_production_min.Element = ue, reactIs_production_min.ForwardRef = Ze, reactIs_production_min.Fragment = Ue, reactIs_production_min.Lazy = rt, reactIs_production_min.Memo = et, reactIs_production_min.Portal = Qe, reactIs_production_min.Profiler = Ge, reactIs_production_min.StrictMode = He, reactIs_production_min.Suspense = nt, reactIs_production_min.isAsyncMode = function(dt) {
    return lt(dt) || ut(dt) === $e;
  }, reactIs_production_min.isConcurrentMode = lt, reactIs_production_min.isContextConsumer = function(dt) {
    return ut(dt) === Ke;
  }, reactIs_production_min.isContextProvider = function(dt) {
    return ut(dt) === Xe;
  }, reactIs_production_min.isElement = function(dt) {
    return typeof dt == "object" && dt !== null && dt.$$typeof === ue;
  }, reactIs_production_min.isForwardRef = function(dt) {
    return ut(dt) === Ze;
  }, reactIs_production_min.isFragment = function(dt) {
    return ut(dt) === Ue;
  }, reactIs_production_min.isLazy = function(dt) {
    return ut(dt) === rt;
  }, reactIs_production_min.isMemo = function(dt) {
    return ut(dt) === et;
  }, reactIs_production_min.isPortal = function(dt) {
    return ut(dt) === Qe;
  }, reactIs_production_min.isProfiler = function(dt) {
    return ut(dt) === Ge;
  }, reactIs_production_min.isStrictMode = function(dt) {
    return ut(dt) === He;
  }, reactIs_production_min.isSuspense = function(dt) {
    return ut(dt) === nt;
  }, reactIs_production_min.isValidElementType = function(dt) {
    return typeof dt == "string" || typeof dt == "function" || dt === Ue || dt === Je || dt === Ge || dt === He || dt === nt || dt === tt || typeof dt == "object" && dt !== null && (dt.$$typeof === rt || dt.$$typeof === et || dt.$$typeof === Xe || dt.$$typeof === Ke || dt.$$typeof === Ze || dt.$$typeof === ot || dt.$$typeof === at || dt.$$typeof === st || dt.$$typeof === it);
  }, reactIs_production_min.typeOf = ut, reactIs_production_min;
}
var reactIs_development = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  return hasRequiredReactIs_development || (hasRequiredReactIs_development = 1, process.env.NODE_ENV !== "production" && function() {
    var me = typeof Symbol == "function" && Symbol.for, ue = me ? Symbol.for("react.element") : 60103, Qe = me ? Symbol.for("react.portal") : 60106, Ue = me ? Symbol.for("react.fragment") : 60107, He = me ? Symbol.for("react.strict_mode") : 60108, Ge = me ? Symbol.for("react.profiler") : 60114, Xe = me ? Symbol.for("react.provider") : 60109, Ke = me ? Symbol.for("react.context") : 60110, $e = me ? Symbol.for("react.async_mode") : 60111, Je = me ? Symbol.for("react.concurrent_mode") : 60111, Ze = me ? Symbol.for("react.forward_ref") : 60112, nt = me ? Symbol.for("react.suspense") : 60113, tt = me ? Symbol.for("react.suspense_list") : 60120, et = me ? Symbol.for("react.memo") : 60115, rt = me ? Symbol.for("react.lazy") : 60116, it = me ? Symbol.for("react.block") : 60121, ot = me ? Symbol.for("react.fundamental") : 60117, at = me ? Symbol.for("react.responder") : 60118, st = me ? Symbol.for("react.scope") : 60119;
    function ut(ft) {
      return typeof ft == "string" || typeof ft == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      ft === Ue || ft === Je || ft === Ge || ft === He || ft === nt || ft === tt || typeof ft == "object" && ft !== null && (ft.$$typeof === rt || ft.$$typeof === et || ft.$$typeof === Xe || ft.$$typeof === Ke || ft.$$typeof === Ze || ft.$$typeof === ot || ft.$$typeof === at || ft.$$typeof === st || ft.$$typeof === it);
    }
    function lt(ft) {
      if (typeof ft == "object" && ft !== null) {
        var Dt = ft.$$typeof;
        switch (Dt) {
          case ue:
            var Mt = ft.type;
            switch (Mt) {
              case $e:
              case Je:
              case Ue:
              case Ge:
              case He:
              case nt:
                return Mt;
              default:
                var Ft = Mt && Mt.$$typeof;
                switch (Ft) {
                  case Ke:
                  case Ze:
                  case rt:
                  case et:
                  case Xe:
                    return Ft;
                  default:
                    return Dt;
                }
            }
          case Qe:
            return Dt;
        }
      }
    }
    var dt = $e, At = Je, pt = Ke, gt = Xe, wt = ue, Bt = Ze, Tt = Ue, yt = rt, Ct = et, ht = Qe, It = Ge, vt = He, Et = nt, bt = !1;
    function Rt(ft) {
      return bt || (bt = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), St(ft) || lt(ft) === $e;
    }
    function St(ft) {
      return lt(ft) === Je;
    }
    function kt(ft) {
      return lt(ft) === Ke;
    }
    function jt(ft) {
      return lt(ft) === Xe;
    }
    function Pt(ft) {
      return typeof ft == "object" && ft !== null && ft.$$typeof === ue;
    }
    function Qt(ft) {
      return lt(ft) === Ze;
    }
    function qt(ft) {
      return lt(ft) === Ue;
    }
    function _t(ft) {
      return lt(ft) === rt;
    }
    function Yt(ft) {
      return lt(ft) === et;
    }
    function Xt(ft) {
      return lt(ft) === Qe;
    }
    function Ut(ft) {
      return lt(ft) === Ge;
    }
    function Lt(ft) {
      return lt(ft) === He;
    }
    function Ot(ft) {
      return lt(ft) === nt;
    }
    reactIs_development.AsyncMode = dt, reactIs_development.ConcurrentMode = At, reactIs_development.ContextConsumer = pt, reactIs_development.ContextProvider = gt, reactIs_development.Element = wt, reactIs_development.ForwardRef = Bt, reactIs_development.Fragment = Tt, reactIs_development.Lazy = yt, reactIs_development.Memo = Ct, reactIs_development.Portal = ht, reactIs_development.Profiler = It, reactIs_development.StrictMode = vt, reactIs_development.Suspense = Et, reactIs_development.isAsyncMode = Rt, reactIs_development.isConcurrentMode = St, reactIs_development.isContextConsumer = kt, reactIs_development.isContextProvider = jt, reactIs_development.isElement = Pt, reactIs_development.isForwardRef = Qt, reactIs_development.isFragment = qt, reactIs_development.isLazy = _t, reactIs_development.isMemo = Yt, reactIs_development.isPortal = Xt, reactIs_development.isProfiler = Ut, reactIs_development.isStrictMode = Lt, reactIs_development.isSuspense = Ot, reactIs_development.isValidElementType = ut, reactIs_development.typeOf = lt;
  }()), reactIs_development;
}
process.env.NODE_ENV === "production" ? reactIs$1.exports = requireReactIs_production_min() : reactIs$1.exports = requireReactIs_development();
var reactIsExports = reactIs$1.exports;
function stylis_min(me) {
  function ue(jt, Pt, Qt, qt, _t) {
    for (var Yt = 0, Xt = 0, Ut = 0, Lt = 0, Ot, ft, Dt = 0, Mt = 0, Ft, Gt = Ft = Ot = 0, zt = 0, $t = 0, Ht = 0, hn = 0, un = Qt.length, An = un - 1, mn, En = "", Jt = "", an = "", cn = "", dn; zt < un; ) {
      if (ft = Qt.charCodeAt(zt), zt === An && Xt + Lt + Ut + Yt !== 0 && (Xt !== 0 && (ft = Xt === 47 ? 10 : 47), Lt = Ut = Yt = 0, un++, An++), Xt + Lt + Ut + Yt === 0) {
        if (zt === An && (0 < $t && (En = En.replace(tt, "")), 0 < En.trim().length)) {
          switch (ft) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              En += Qt.charAt(zt);
          }
          ft = 59;
        }
        switch (ft) {
          case 123:
            for (En = En.trim(), Ot = En.charCodeAt(0), Ft = 1, hn = ++zt; zt < un; ) {
              switch (ft = Qt.charCodeAt(zt)) {
                case 123:
                  Ft++;
                  break;
                case 125:
                  Ft--;
                  break;
                case 47:
                  switch (ft = Qt.charCodeAt(zt + 1)) {
                    case 42:
                    case 47:
                      e: {
                        for (Gt = zt + 1; Gt < An; ++Gt)
                          switch (Qt.charCodeAt(Gt)) {
                            case 47:
                              if (ft === 42 && Qt.charCodeAt(Gt - 1) === 42 && zt + 2 !== Gt) {
                                zt = Gt + 1;
                                break e;
                              }
                              break;
                            case 10:
                              if (ft === 47) {
                                zt = Gt + 1;
                                break e;
                              }
                          }
                        zt = Gt;
                      }
                  }
                  break;
                case 91:
                  ft++;
                case 40:
                  ft++;
                case 34:
                case 39:
                  for (; zt++ < An && Qt.charCodeAt(zt) !== ft; )
                    ;
              }
              if (Ft === 0) break;
              zt++;
            }
            switch (Ft = Qt.substring(hn, zt), Ot === 0 && (Ot = (En = En.replace(nt, "").trim()).charCodeAt(0)), Ot) {
              case 64:
                switch (0 < $t && (En = En.replace(tt, "")), ft = En.charCodeAt(1), ft) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    $t = Pt;
                    break;
                  default:
                    $t = vt;
                }
                if (Ft = ue(Pt, $t, Ft, ft, _t + 1), hn = Ft.length, 0 < bt && ($t = Qe(vt, En, Ht), dn = Ke(3, Ft, $t, Pt, Ct, yt, hn, ft, _t, qt), En = $t.join(""), dn !== void 0 && (hn = (Ft = dn.trim()).length) === 0 && (ft = 0, Ft = "")), 0 < hn) switch (ft) {
                  case 115:
                    En = En.replace(At, Xe);
                  case 100:
                  case 109:
                  case 45:
                    Ft = En + "{" + Ft + "}";
                    break;
                  case 107:
                    En = En.replace(st, "$1 $2"), Ft = En + "{" + Ft + "}", Ft = It === 1 || It === 2 && Ge("@" + Ft, 3) ? "@-webkit-" + Ft + "@" + Ft : "@" + Ft;
                    break;
                  default:
                    Ft = En + Ft, qt === 112 && (Ft = (Jt += Ft, ""));
                }
                else Ft = "";
                break;
              default:
                Ft = ue(Pt, Qe(Pt, En, Ht), Ft, qt, _t + 1);
            }
            an += Ft, Ft = Ht = $t = Gt = Ot = 0, En = "", ft = Qt.charCodeAt(++zt);
            break;
          case 125:
          case 59:
            if (En = (0 < $t ? En.replace(tt, "") : En).trim(), 1 < (hn = En.length)) switch (Gt === 0 && (Ot = En.charCodeAt(0), Ot === 45 || 96 < Ot && 123 > Ot) && (hn = (En = En.replace(" ", ":")).length), 0 < bt && (dn = Ke(1, En, Pt, jt, Ct, yt, Jt.length, qt, _t, qt)) !== void 0 && (hn = (En = dn.trim()).length) === 0 && (En = "\0\0"), Ot = En.charCodeAt(0), ft = En.charCodeAt(1), Ot) {
              case 0:
                break;
              case 64:
                if (ft === 105 || ft === 99) {
                  cn += En + Qt.charAt(zt);
                  break;
                }
              default:
                En.charCodeAt(hn - 1) !== 58 && (Jt += He(En, Ot, ft, En.charCodeAt(2)));
            }
            Ht = $t = Gt = Ot = 0, En = "", ft = Qt.charCodeAt(++zt);
        }
      }
      switch (ft) {
        case 13:
        case 10:
          Xt === 47 ? Xt = 0 : 1 + Ot === 0 && qt !== 107 && 0 < En.length && ($t = 1, En += "\0"), 0 < bt * St && Ke(0, En, Pt, jt, Ct, yt, Jt.length, qt, _t, qt), yt = 1, Ct++;
          break;
        case 59:
        case 125:
          if (Xt + Lt + Ut + Yt === 0) {
            yt++;
            break;
          }
        default:
          switch (yt++, mn = Qt.charAt(zt), ft) {
            case 9:
            case 32:
              if (Lt + Yt + Xt === 0) switch (Dt) {
                case 44:
                case 58:
                case 9:
                case 32:
                  mn = "";
                  break;
                default:
                  ft !== 32 && (mn = " ");
              }
              break;
            case 0:
              mn = "\\0";
              break;
            case 12:
              mn = "\\f";
              break;
            case 11:
              mn = "\\v";
              break;
            case 38:
              Lt + Xt + Yt === 0 && ($t = Ht = 1, mn = "\f" + mn);
              break;
            case 108:
              if (Lt + Xt + Yt + ht === 0 && 0 < Gt) switch (zt - Gt) {
                case 2:
                  Dt === 112 && Qt.charCodeAt(zt - 3) === 58 && (ht = Dt);
                case 8:
                  Mt === 111 && (ht = Mt);
              }
              break;
            case 58:
              Lt + Xt + Yt === 0 && (Gt = zt);
              break;
            case 44:
              Xt + Ut + Lt + Yt === 0 && ($t = 1, mn += "\r");
              break;
            case 34:
            case 39:
              Xt === 0 && (Lt = Lt === ft ? 0 : Lt === 0 ? ft : Lt);
              break;
            case 91:
              Lt + Xt + Ut === 0 && Yt++;
              break;
            case 93:
              Lt + Xt + Ut === 0 && Yt--;
              break;
            case 41:
              Lt + Xt + Yt === 0 && Ut--;
              break;
            case 40:
              if (Lt + Xt + Yt === 0) {
                if (Ot === 0) switch (2 * Dt + 3 * Mt) {
                  case 533:
                    break;
                  default:
                    Ot = 1;
                }
                Ut++;
              }
              break;
            case 64:
              Xt + Ut + Lt + Yt + Gt + Ft === 0 && (Ft = 1);
              break;
            case 42:
            case 47:
              if (!(0 < Lt + Yt + Ut)) switch (Xt) {
                case 0:
                  switch (2 * ft + 3 * Qt.charCodeAt(zt + 1)) {
                    case 235:
                      Xt = 47;
                      break;
                    case 220:
                      hn = zt, Xt = 42;
                  }
                  break;
                case 42:
                  ft === 47 && Dt === 42 && hn + 2 !== zt && (Qt.charCodeAt(hn + 2) === 33 && (Jt += Qt.substring(hn, zt + 1)), mn = "", Xt = 0);
              }
          }
          Xt === 0 && (En += mn);
      }
      Mt = Dt, Dt = ft, zt++;
    }
    if (hn = Jt.length, 0 < hn) {
      if ($t = Pt, 0 < bt && (dn = Ke(2, Jt, $t, jt, Ct, yt, hn, qt, _t, qt), dn !== void 0 && (Jt = dn).length === 0)) return cn + Jt + an;
      if (Jt = $t.join(",") + "{" + Jt + "}", It * ht !== 0) {
        switch (It !== 2 || Ge(Jt, 2) || (ht = 0), ht) {
          case 111:
            Jt = Jt.replace(lt, ":-moz-$1") + Jt;
            break;
          case 112:
            Jt = Jt.replace(ut, "::-webkit-input-$1") + Jt.replace(ut, "::-moz-$1") + Jt.replace(ut, ":-ms-input-$1") + Jt;
        }
        ht = 0;
      }
    }
    return cn + Jt + an;
  }
  function Qe(jt, Pt, Qt) {
    var qt = Pt.trim().split(ot);
    Pt = qt;
    var _t = qt.length, Yt = jt.length;
    switch (Yt) {
      case 0:
      case 1:
        var Xt = 0;
        for (jt = Yt === 0 ? "" : jt[0] + " "; Xt < _t; ++Xt)
          Pt[Xt] = Ue(jt, Pt[Xt], Qt).trim();
        break;
      default:
        var Ut = Xt = 0;
        for (Pt = []; Xt < _t; ++Xt)
          for (var Lt = 0; Lt < Yt; ++Lt)
            Pt[Ut++] = Ue(jt[Lt] + " ", qt[Xt], Qt).trim();
    }
    return Pt;
  }
  function Ue(jt, Pt, Qt) {
    var qt = Pt.charCodeAt(0);
    switch (33 > qt && (qt = (Pt = Pt.trim()).charCodeAt(0)), qt) {
      case 38:
        return Pt.replace(at, "$1" + jt.trim());
      case 58:
        return jt.trim() + Pt.replace(at, "$1" + jt.trim());
      default:
        if (0 < 1 * Qt && 0 < Pt.indexOf("\f")) return Pt.replace(at, (jt.charCodeAt(0) === 58 ? "" : "$1") + jt.trim());
    }
    return jt + Pt;
  }
  function He(jt, Pt, Qt, qt) {
    var _t = jt + ";", Yt = 2 * Pt + 3 * Qt + 4 * qt;
    if (Yt === 944) {
      jt = _t.indexOf(":", 9) + 1;
      var Xt = _t.substring(jt, _t.length - 1).trim();
      return Xt = _t.substring(0, jt).trim() + Xt + ";", It === 1 || It === 2 && Ge(Xt, 1) ? "-webkit-" + Xt + Xt : Xt;
    }
    if (It === 0 || It === 2 && !Ge(_t, 1)) return _t;
    switch (Yt) {
      case 1015:
        return _t.charCodeAt(10) === 97 ? "-webkit-" + _t + _t : _t;
      case 951:
        return _t.charCodeAt(3) === 116 ? "-webkit-" + _t + _t : _t;
      case 963:
        return _t.charCodeAt(5) === 110 ? "-webkit-" + _t + _t : _t;
      case 1009:
        if (_t.charCodeAt(4) !== 100) break;
      case 969:
      case 942:
        return "-webkit-" + _t + _t;
      case 978:
        return "-webkit-" + _t + "-moz-" + _t + _t;
      case 1019:
      case 983:
        return "-webkit-" + _t + "-moz-" + _t + "-ms-" + _t + _t;
      case 883:
        if (_t.charCodeAt(8) === 45) return "-webkit-" + _t + _t;
        if (0 < _t.indexOf("image-set(", 11)) return _t.replace(Tt, "$1-webkit-$2") + _t;
        break;
      case 932:
        if (_t.charCodeAt(4) === 45) switch (_t.charCodeAt(5)) {
          case 103:
            return "-webkit-box-" + _t.replace("-grow", "") + "-webkit-" + _t + "-ms-" + _t.replace("grow", "positive") + _t;
          case 115:
            return "-webkit-" + _t + "-ms-" + _t.replace("shrink", "negative") + _t;
          case 98:
            return "-webkit-" + _t + "-ms-" + _t.replace("basis", "preferred-size") + _t;
        }
        return "-webkit-" + _t + "-ms-" + _t + _t;
      case 964:
        return "-webkit-" + _t + "-ms-flex-" + _t + _t;
      case 1023:
        if (_t.charCodeAt(8) !== 99) break;
        return Xt = _t.substring(_t.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify"), "-webkit-box-pack" + Xt + "-webkit-" + _t + "-ms-flex-pack" + Xt + _t;
      case 1005:
        return rt.test(_t) ? _t.replace(et, ":-webkit-") + _t.replace(et, ":-moz-") + _t : _t;
      case 1e3:
        switch (Xt = _t.substring(13).trim(), Pt = Xt.indexOf("-") + 1, Xt.charCodeAt(0) + Xt.charCodeAt(Pt)) {
          case 226:
            Xt = _t.replace(dt, "tb");
            break;
          case 232:
            Xt = _t.replace(dt, "tb-rl");
            break;
          case 220:
            Xt = _t.replace(dt, "lr");
            break;
          default:
            return _t;
        }
        return "-webkit-" + _t + "-ms-" + Xt + _t;
      case 1017:
        if (_t.indexOf("sticky", 9) === -1) break;
      case 975:
        switch (Pt = (_t = jt).length - 10, Xt = (_t.charCodeAt(Pt) === 33 ? _t.substring(0, Pt) : _t).substring(jt.indexOf(":", 7) + 1).trim(), Yt = Xt.charCodeAt(0) + (Xt.charCodeAt(7) | 0)) {
          case 203:
            if (111 > Xt.charCodeAt(8)) break;
          case 115:
            _t = _t.replace(Xt, "-webkit-" + Xt) + ";" + _t;
            break;
          case 207:
          case 102:
            _t = _t.replace(Xt, "-webkit-" + (102 < Yt ? "inline-" : "") + "box") + ";" + _t.replace(Xt, "-webkit-" + Xt) + ";" + _t.replace(Xt, "-ms-" + Xt + "box") + ";" + _t;
        }
        return _t + ";";
      case 938:
        if (_t.charCodeAt(5) === 45) switch (_t.charCodeAt(6)) {
          case 105:
            return Xt = _t.replace("-items", ""), "-webkit-" + _t + "-webkit-box-" + Xt + "-ms-flex-" + Xt + _t;
          case 115:
            return "-webkit-" + _t + "-ms-flex-item-" + _t.replace(gt, "") + _t;
          default:
            return "-webkit-" + _t + "-ms-flex-line-pack" + _t.replace("align-content", "").replace(gt, "") + _t;
        }
        break;
      case 973:
      case 989:
        if (_t.charCodeAt(3) !== 45 || _t.charCodeAt(4) === 122) break;
      case 931:
      case 953:
        if (Bt.test(jt) === !0) return (Xt = jt.substring(jt.indexOf(":") + 1)).charCodeAt(0) === 115 ? He(jt.replace("stretch", "fill-available"), Pt, Qt, qt).replace(":fill-available", ":stretch") : _t.replace(Xt, "-webkit-" + Xt) + _t.replace(Xt, "-moz-" + Xt.replace("fill-", "")) + _t;
        break;
      case 962:
        if (_t = "-webkit-" + _t + (_t.charCodeAt(5) === 102 ? "-ms-" + _t : "") + _t, Qt + qt === 211 && _t.charCodeAt(13) === 105 && 0 < _t.indexOf("transform", 10)) return _t.substring(0, _t.indexOf(";", 27) + 1).replace(it, "$1-webkit-$2") + _t;
    }
    return _t;
  }
  function Ge(jt, Pt) {
    var Qt = jt.indexOf(Pt === 1 ? ":" : "{"), qt = jt.substring(0, Pt !== 3 ? Qt : 10);
    return Qt = jt.substring(Qt + 1, jt.length - 1), Rt(Pt !== 2 ? qt : qt.replace(wt, "$1"), Qt, Pt);
  }
  function Xe(jt, Pt) {
    var Qt = He(Pt, Pt.charCodeAt(0), Pt.charCodeAt(1), Pt.charCodeAt(2));
    return Qt !== Pt + ";" ? Qt.replace(pt, " or ($1)").substring(4) : "(" + Pt + ")";
  }
  function Ke(jt, Pt, Qt, qt, _t, Yt, Xt, Ut, Lt, Ot) {
    for (var ft = 0, Dt = Pt, Mt; ft < bt; ++ft)
      switch (Mt = Et[ft].call(Ze, jt, Dt, Qt, qt, _t, Yt, Xt, Ut, Lt, Ot)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;
        default:
          Dt = Mt;
      }
    if (Dt !== Pt) return Dt;
  }
  function $e(jt) {
    switch (jt) {
      case void 0:
      case null:
        bt = Et.length = 0;
        break;
      default:
        if (typeof jt == "function") Et[bt++] = jt;
        else if (typeof jt == "object") for (var Pt = 0, Qt = jt.length; Pt < Qt; ++Pt)
          $e(jt[Pt]);
        else St = !!jt | 0;
    }
    return $e;
  }
  function Je(jt) {
    return jt = jt.prefix, jt !== void 0 && (Rt = null, jt ? typeof jt != "function" ? It = 1 : (It = 2, Rt = jt) : It = 0), Je;
  }
  function Ze(jt, Pt) {
    var Qt = jt;
    if (33 > Qt.charCodeAt(0) && (Qt = Qt.trim()), kt = Qt, Qt = [kt], 0 < bt) {
      var qt = Ke(-1, Pt, Qt, Qt, Ct, yt, 0, 0, 0, 0);
      qt !== void 0 && typeof qt == "string" && (Pt = qt);
    }
    var _t = ue(vt, Qt, Pt, 0, 0);
    return 0 < bt && (qt = Ke(-2, _t, Qt, Qt, Ct, yt, _t.length, 0, 0, 0), qt !== void 0 && (_t = qt)), kt = "", ht = 0, yt = Ct = 1, _t;
  }
  var nt = /^\0+/g, tt = /[\0\r\f]/g, et = /: */g, rt = /zoo|gra/, it = /([,: ])(transform)/g, ot = /,\r+?/g, at = /([\t\r\n ])*\f?&/g, st = /@(k\w+)\s*(\S*)\s*/, ut = /::(place)/g, lt = /:(read-only)/g, dt = /[svh]\w+-[tblr]{2}/, At = /\(\s*(.*)\s*\)/g, pt = /([\s\S]*?);/g, gt = /-self|flex-/g, wt = /[^]*?(:[rp][el]a[\w-]+)[^]*/, Bt = /stretch|:\s*\w+\-(?:conte|avail)/, Tt = /([^-])(image-set\()/, yt = 1, Ct = 1, ht = 0, It = 1, vt = [], Et = [], bt = 0, Rt = null, St = 0, kt = "";
  return Ze.use = $e, Ze.set = Je, me !== void 0 && Je(me), Ze;
}
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function memoize(me) {
  var ue = /* @__PURE__ */ Object.create(null);
  return function(Qe) {
    return ue[Qe] === void 0 && (ue[Qe] = me(Qe)), ue[Qe];
  };
}
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, isPropValid = /* @__PURE__ */ memoize(
  function(me) {
    return reactPropsRegex.test(me) || me.charCodeAt(0) === 111 && me.charCodeAt(1) === 110 && me.charCodeAt(2) < 91;
  }
  /* Z+1 */
), reactIs = reactIsExports, REACT_STATICS = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, KNOWN_STATICS = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, FORWARD_REF_STATICS = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, MEMO_STATICS = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(me) {
  return reactIs.isMemo(me) ? MEMO_STATICS : TYPE_STATICS[me.$$typeof] || REACT_STATICS;
}
var defineProperty$1 = Object.defineProperty, getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, getPrototypeOf = Object.getPrototypeOf, objectPrototype = Object.prototype;
function hoistNonReactStatics(me, ue, Qe) {
  if (typeof ue != "string") {
    if (objectPrototype) {
      var Ue = getPrototypeOf(ue);
      Ue && Ue !== objectPrototype && hoistNonReactStatics(me, Ue, Qe);
    }
    var He = getOwnPropertyNames(ue);
    getOwnPropertySymbols && (He = He.concat(getOwnPropertySymbols(ue)));
    for (var Ge = getStatics(me), Xe = getStatics(ue), Ke = 0; Ke < He.length; ++Ke) {
      var $e = He[Ke];
      if (!KNOWN_STATICS[$e] && !(Qe && Qe[$e]) && !(Xe && Xe[$e]) && !(Ge && Ge[$e])) {
        var Je = getOwnPropertyDescriptor(ue, $e);
        try {
          defineProperty$1(me, $e, Je);
        } catch {
        }
      }
    }
  }
  return me;
}
var hoistNonReactStatics_cjs = hoistNonReactStatics;
const m$2 = /* @__PURE__ */ getDefaultExportFromCjs(hoistNonReactStatics_cjs);
function y$1() {
  return (y$1 = Object.assign || function(me) {
    for (var ue = 1; ue < arguments.length; ue++) {
      var Qe = arguments[ue];
      for (var Ue in Qe) Object.prototype.hasOwnProperty.call(Qe, Ue) && (me[Ue] = Qe[Ue]);
    }
    return me;
  }).apply(this, arguments);
}
var v$1 = function(me, ue) {
  for (var Qe = [me[0]], Ue = 0, He = ue.length; Ue < He; Ue += 1) Qe.push(ue[Ue], me[Ue + 1]);
  return Qe;
}, g$1 = function(me) {
  return me !== null && typeof me == "object" && (me.toString ? me.toString() : Object.prototype.toString.call(me)) === "[object Object]" && !reactIsExports.typeOf(me);
}, S$1 = Object.freeze([]), w$1 = Object.freeze({});
function E$1(me) {
  return typeof me == "function";
}
function b$1(me) {
  return process.env.NODE_ENV !== "production" && typeof me == "string" && me || me.displayName || me.name || "Component";
}
function _$2(me) {
  return me && typeof me.styledComponentId == "string";
}
var N$1 = typeof process < "u" && process.env !== void 0 && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", C$1 = typeof window < "u" && "HTMLElement" in window, I$1 = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && (process.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? process.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && process.env.REACT_APP_SC_DISABLE_SPEEDY : process.env.SC_DISABLE_SPEEDY !== void 0 && process.env.SC_DISABLE_SPEEDY !== "" ? process.env.SC_DISABLE_SPEEDY !== "false" && process.env.SC_DISABLE_SPEEDY : process.env.NODE_ENV !== "production")), O$1 = process.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
` } : {};
function R$2() {
  for (var me = arguments.length <= 0 ? void 0 : arguments[0], ue = [], Qe = 1, Ue = arguments.length; Qe < Ue; Qe += 1) ue.push(Qe < 0 || arguments.length <= Qe ? void 0 : arguments[Qe]);
  return ue.forEach(function(He) {
    me = me.replace(/%[a-z]/, He);
  }), me;
}
function D$1(me) {
  for (var ue = arguments.length, Qe = new Array(ue > 1 ? ue - 1 : 0), Ue = 1; Ue < ue; Ue++) Qe[Ue - 1] = arguments[Ue];
  throw process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://git.io/JUIaE#" + me + " for more information." + (Qe.length > 0 ? " Args: " + Qe.join(", ") : "")) : new Error(R$2.apply(void 0, [O$1[me]].concat(Qe)).trim());
}
var j = function() {
  function me(Qe) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = Qe;
  }
  var ue = me.prototype;
  return ue.indexOfGroup = function(Qe) {
    for (var Ue = 0, He = 0; He < Qe; He++) Ue += this.groupSizes[He];
    return Ue;
  }, ue.insertRules = function(Qe, Ue) {
    if (Qe >= this.groupSizes.length) {
      for (var He = this.groupSizes, Ge = He.length, Xe = Ge; Qe >= Xe; ) (Xe <<= 1) < 0 && D$1(16, "" + Qe);
      this.groupSizes = new Uint32Array(Xe), this.groupSizes.set(He), this.length = Xe;
      for (var Ke = Ge; Ke < Xe; Ke++) this.groupSizes[Ke] = 0;
    }
    for (var $e = this.indexOfGroup(Qe + 1), Je = 0, Ze = Ue.length; Je < Ze; Je++) this.tag.insertRule($e, Ue[Je]) && (this.groupSizes[Qe]++, $e++);
  }, ue.clearGroup = function(Qe) {
    if (Qe < this.length) {
      var Ue = this.groupSizes[Qe], He = this.indexOfGroup(Qe), Ge = He + Ue;
      this.groupSizes[Qe] = 0;
      for (var Xe = He; Xe < Ge; Xe++) this.tag.deleteRule(He);
    }
  }, ue.getGroup = function(Qe) {
    var Ue = "";
    if (Qe >= this.length || this.groupSizes[Qe] === 0) return Ue;
    for (var He = this.groupSizes[Qe], Ge = this.indexOfGroup(Qe), Xe = Ge + He, Ke = Ge; Ke < Xe; Ke++) Ue += this.tag.getRule(Ke) + `/*!sc*/
`;
    return Ue;
  }, me;
}(), T$1 = /* @__PURE__ */ new Map(), x = /* @__PURE__ */ new Map(), k$1 = 1, V$1 = function(me) {
  if (T$1.has(me)) return T$1.get(me);
  for (; x.has(k$1); ) k$1++;
  var ue = k$1++;
  return process.env.NODE_ENV !== "production" && ((0 | ue) < 0 || ue > 1 << 30) && D$1(16, "" + ue), T$1.set(me, ue), x.set(ue, me), ue;
}, B$1 = function(me) {
  return x.get(me);
}, z = function(me, ue) {
  ue >= k$1 && (k$1 = ue + 1), T$1.set(me, ue), x.set(ue, me);
}, M$1 = "style[" + N$1 + '][data-styled-version="5.3.11"]', G = new RegExp("^" + N$1 + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), L$1 = function(me, ue, Qe) {
  for (var Ue, He = Qe.split(","), Ge = 0, Xe = He.length; Ge < Xe; Ge++) (Ue = He[Ge]) && me.registerName(ue, Ue);
}, F$1 = function(me, ue) {
  for (var Qe = (ue.textContent || "").split(`/*!sc*/
`), Ue = [], He = 0, Ge = Qe.length; He < Ge; He++) {
    var Xe = Qe[He].trim();
    if (Xe) {
      var Ke = Xe.match(G);
      if (Ke) {
        var $e = 0 | parseInt(Ke[1], 10), Je = Ke[2];
        $e !== 0 && (z(Je, $e), L$1(me, Je, Ke[3]), me.getTag().insertRules($e, Ue)), Ue.length = 0;
      } else Ue.push(Xe);
    }
  }
}, Y = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}, q = function(me) {
  var ue = document.head, Qe = me || ue, Ue = document.createElement("style"), He = function(Ke) {
    for (var $e = Ke.childNodes, Je = $e.length; Je >= 0; Je--) {
      var Ze = $e[Je];
      if (Ze && Ze.nodeType === 1 && Ze.hasAttribute(N$1)) return Ze;
    }
  }(Qe), Ge = He !== void 0 ? He.nextSibling : null;
  Ue.setAttribute(N$1, "active"), Ue.setAttribute("data-styled-version", "5.3.11");
  var Xe = Y();
  return Xe && Ue.setAttribute("nonce", Xe), Qe.insertBefore(Ue, Ge), Ue;
}, H = function() {
  function me(Qe) {
    var Ue = this.element = q(Qe);
    Ue.appendChild(document.createTextNode("")), this.sheet = function(He) {
      if (He.sheet) return He.sheet;
      for (var Ge = document.styleSheets, Xe = 0, Ke = Ge.length; Xe < Ke; Xe++) {
        var $e = Ge[Xe];
        if ($e.ownerNode === He) return $e;
      }
      D$1(17);
    }(Ue), this.length = 0;
  }
  var ue = me.prototype;
  return ue.insertRule = function(Qe, Ue) {
    try {
      return this.sheet.insertRule(Ue, Qe), this.length++, !0;
    } catch {
      return !1;
    }
  }, ue.deleteRule = function(Qe) {
    this.sheet.deleteRule(Qe), this.length--;
  }, ue.getRule = function(Qe) {
    var Ue = this.sheet.cssRules[Qe];
    return Ue !== void 0 && typeof Ue.cssText == "string" ? Ue.cssText : "";
  }, me;
}(), $$1 = function() {
  function me(Qe) {
    var Ue = this.element = q(Qe);
    this.nodes = Ue.childNodes, this.length = 0;
  }
  var ue = me.prototype;
  return ue.insertRule = function(Qe, Ue) {
    if (Qe <= this.length && Qe >= 0) {
      var He = document.createTextNode(Ue), Ge = this.nodes[Qe];
      return this.element.insertBefore(He, Ge || null), this.length++, !0;
    }
    return !1;
  }, ue.deleteRule = function(Qe) {
    this.element.removeChild(this.nodes[Qe]), this.length--;
  }, ue.getRule = function(Qe) {
    return Qe < this.length ? this.nodes[Qe].textContent : "";
  }, me;
}(), W = function() {
  function me(Qe) {
    this.rules = [], this.length = 0;
  }
  var ue = me.prototype;
  return ue.insertRule = function(Qe, Ue) {
    return Qe <= this.length && (this.rules.splice(Qe, 0, Ue), this.length++, !0);
  }, ue.deleteRule = function(Qe) {
    this.rules.splice(Qe, 1), this.length--;
  }, ue.getRule = function(Qe) {
    return Qe < this.length ? this.rules[Qe] : "";
  }, me;
}(), U$1 = C$1, J = { isServer: !C$1, useCSSOMInjection: !I$1 }, X = function() {
  function me(Qe, Ue, He) {
    Qe === void 0 && (Qe = w$1), Ue === void 0 && (Ue = {}), this.options = y$1({}, J, {}, Qe), this.gs = Ue, this.names = new Map(He), this.server = !!Qe.isServer, !this.server && C$1 && U$1 && (U$1 = !1, function(Ge) {
      for (var Xe = document.querySelectorAll(M$1), Ke = 0, $e = Xe.length; Ke < $e; Ke++) {
        var Je = Xe[Ke];
        Je && Je.getAttribute(N$1) !== "active" && (F$1(Ge, Je), Je.parentNode && Je.parentNode.removeChild(Je));
      }
    }(this));
  }
  me.registerId = function(Qe) {
    return V$1(Qe);
  };
  var ue = me.prototype;
  return ue.reconstructWithOptions = function(Qe, Ue) {
    return Ue === void 0 && (Ue = !0), new me(y$1({}, this.options, {}, Qe), this.gs, Ue && this.names || void 0);
  }, ue.allocateGSInstance = function(Qe) {
    return this.gs[Qe] = (this.gs[Qe] || 0) + 1;
  }, ue.getTag = function() {
    return this.tag || (this.tag = (He = (Ue = this.options).isServer, Ge = Ue.useCSSOMInjection, Xe = Ue.target, Qe = He ? new W(Xe) : Ge ? new H(Xe) : new $$1(Xe), new j(Qe)));
    var Qe, Ue, He, Ge, Xe;
  }, ue.hasNameForId = function(Qe, Ue) {
    return this.names.has(Qe) && this.names.get(Qe).has(Ue);
  }, ue.registerName = function(Qe, Ue) {
    if (V$1(Qe), this.names.has(Qe)) this.names.get(Qe).add(Ue);
    else {
      var He = /* @__PURE__ */ new Set();
      He.add(Ue), this.names.set(Qe, He);
    }
  }, ue.insertRules = function(Qe, Ue, He) {
    this.registerName(Qe, Ue), this.getTag().insertRules(V$1(Qe), He);
  }, ue.clearNames = function(Qe) {
    this.names.has(Qe) && this.names.get(Qe).clear();
  }, ue.clearRules = function(Qe) {
    this.getTag().clearGroup(V$1(Qe)), this.clearNames(Qe);
  }, ue.clearTag = function() {
    this.tag = void 0;
  }, ue.toString = function() {
    return function(Qe) {
      for (var Ue = Qe.getTag(), He = Ue.length, Ge = "", Xe = 0; Xe < He; Xe++) {
        var Ke = B$1(Xe);
        if (Ke !== void 0) {
          var $e = Qe.names.get(Ke), Je = Ue.getGroup(Xe);
          if ($e && Je && $e.size) {
            var Ze = N$1 + ".g" + Xe + '[id="' + Ke + '"]', nt = "";
            $e !== void 0 && $e.forEach(function(tt) {
              tt.length > 0 && (nt += tt + ",");
            }), Ge += "" + Je + Ze + '{content:"' + nt + `"}/*!sc*/
`;
          }
        }
      }
      return Ge;
    }(this);
  }, me;
}(), Z = /(a)(d)/gi, K$1 = function(me) {
  return String.fromCharCode(me + (me > 25 ? 39 : 97));
};
function Q(me) {
  var ue, Qe = "";
  for (ue = Math.abs(me); ue > 52; ue = ue / 52 | 0) Qe = K$1(ue % 52) + Qe;
  return (K$1(ue % 52) + Qe).replace(Z, "$1-$2");
}
var ee = function(me, ue) {
  for (var Qe = ue.length; Qe; ) me = 33 * me ^ ue.charCodeAt(--Qe);
  return me;
}, te = function(me) {
  return ee(5381, me);
};
function ne(me) {
  for (var ue = 0; ue < me.length; ue += 1) {
    var Qe = me[ue];
    if (E$1(Qe) && !_$2(Qe)) return !1;
  }
  return !0;
}
var re$3 = te("5.3.11"), oe = function() {
  function me(ue, Qe, Ue) {
    this.rules = ue, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && (Ue === void 0 || Ue.isStatic) && ne(ue), this.componentId = Qe, this.baseHash = ee(re$3, Qe), this.baseStyle = Ue, X.registerId(Qe);
  }
  return me.prototype.generateAndInjectStyles = function(ue, Qe, Ue) {
    var He = this.componentId, Ge = [];
    if (this.baseStyle && Ge.push(this.baseStyle.generateAndInjectStyles(ue, Qe, Ue)), this.isStatic && !Ue.hash) if (this.staticRulesId && Qe.hasNameForId(He, this.staticRulesId)) Ge.push(this.staticRulesId);
    else {
      var Xe = _e(this.rules, ue, Qe, Ue).join(""), Ke = Q(ee(this.baseHash, Xe) >>> 0);
      if (!Qe.hasNameForId(He, Ke)) {
        var $e = Ue(Xe, "." + Ke, void 0, He);
        Qe.insertRules(He, Ke, $e);
      }
      Ge.push(Ke), this.staticRulesId = Ke;
    }
    else {
      for (var Je = this.rules.length, Ze = ee(this.baseHash, Ue.hash), nt = "", tt = 0; tt < Je; tt++) {
        var et = this.rules[tt];
        if (typeof et == "string") nt += et, process.env.NODE_ENV !== "production" && (Ze = ee(Ze, et + tt));
        else if (et) {
          var rt = _e(et, ue, Qe, Ue), it = Array.isArray(rt) ? rt.join("") : rt;
          Ze = ee(Ze, it + tt), nt += it;
        }
      }
      if (nt) {
        var ot = Q(Ze >>> 0);
        if (!Qe.hasNameForId(He, ot)) {
          var at = Ue(nt, "." + ot, void 0, He);
          Qe.insertRules(He, ot, at);
        }
        Ge.push(ot);
      }
    }
    return Ge.join(" ");
  }, me;
}(), se = /^\s*\/\/.*$/gm, ie = [":", "[", ".", "#"];
function ae(me) {
  var ue, Qe, Ue, He, Ge = w$1, Xe = Ge.options, Ke = Xe === void 0 ? w$1 : Xe, $e = Ge.plugins, Je = $e === void 0 ? S$1 : $e, Ze = new stylis_min(Ke), nt = [], tt = /* @__PURE__ */ function(it) {
    function ot(at) {
      if (at) try {
        it(at + "}");
      } catch {
      }
    }
    return function(at, st, ut, lt, dt, At, pt, gt, wt, Bt) {
      switch (at) {
        case 1:
          if (wt === 0 && st.charCodeAt(0) === 64) return it(st + ";"), "";
          break;
        case 2:
          if (gt === 0) return st + "/*|*/";
          break;
        case 3:
          switch (gt) {
            case 102:
            case 112:
              return it(ut[0] + st), "";
            default:
              return st + (Bt === 0 ? "/*|*/" : "");
          }
        case -2:
          st.split("/*|*/}").forEach(ot);
      }
    };
  }(function(it) {
    nt.push(it);
  }), et = function(it, ot, at) {
    return ot === 0 && ie.indexOf(at[Qe.length]) !== -1 || at.match(He) ? it : "." + ue;
  };
  function rt(it, ot, at, st) {
    st === void 0 && (st = "&");
    var ut = it.replace(se, ""), lt = ot && at ? at + " " + ot + " { " + ut + " }" : ut;
    return ue = st, Qe = ot, Ue = new RegExp("\\" + Qe + "\\b", "g"), He = new RegExp("(\\" + Qe + "\\b){2,}"), Ze(at || !ot ? "" : ot, lt);
  }
  return Ze.use([].concat(Je, [function(it, ot, at) {
    it === 2 && at.length && at[0].lastIndexOf(Qe) > 0 && (at[0] = at[0].replace(Ue, et));
  }, tt, function(it) {
    if (it === -2) {
      var ot = nt;
      return nt = [], ot;
    }
  }])), rt.hash = Je.length ? Je.reduce(function(it, ot) {
    return ot.name || D$1(15), ee(it, ot.name);
  }, 5381).toString() : "", rt;
}
var ce = React__default.createContext();
ce.Consumer;
var le = React__default.createContext(), de = (le.Consumer, new X()), he = ae();
function pe() {
  return useContext(ce) || de;
}
function fe() {
  return useContext(le) || he;
}
var ye = function() {
  function me(ue, Qe) {
    var Ue = this;
    this.inject = function(He, Ge) {
      Ge === void 0 && (Ge = he);
      var Xe = Ue.name + Ge.hash;
      He.hasNameForId(Ue.id, Xe) || He.insertRules(Ue.id, Xe, Ge(Ue.rules, Xe, "@keyframes"));
    }, this.toString = function() {
      return D$1(12, String(Ue.name));
    }, this.name = ue, this.id = "sc-keyframes-" + ue, this.rules = Qe;
  }
  return me.prototype.getName = function(ue) {
    return ue === void 0 && (ue = he), this.name + ue.hash;
  }, me;
}(), ve = /([A-Z])/, ge = /([A-Z])/g, Se = /^ms-/, we = function(me) {
  return "-" + me.toLowerCase();
};
function Ee(me) {
  return ve.test(me) ? me.replace(ge, we).replace(Se, "-ms-") : me;
}
var be = function(me) {
  return me == null || me === !1 || me === "";
};
function _e(me, ue, Qe, Ue) {
  if (Array.isArray(me)) {
    for (var He, Ge = [], Xe = 0, Ke = me.length; Xe < Ke; Xe += 1) (He = _e(me[Xe], ue, Qe, Ue)) !== "" && (Array.isArray(He) ? Ge.push.apply(Ge, He) : Ge.push(He));
    return Ge;
  }
  if (be(me)) return "";
  if (_$2(me)) return "." + me.styledComponentId;
  if (E$1(me)) {
    if (typeof (Je = me) != "function" || Je.prototype && Je.prototype.isReactComponent || !ue) return me;
    var $e = me(ue);
    return process.env.NODE_ENV !== "production" && reactIsExports.isElement($e) && console.warn(b$1(me) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."), _e($e, ue, Qe, Ue);
  }
  var Je;
  return me instanceof ye ? Qe ? (me.inject(Qe, Ue), me.getName(Ue)) : me : g$1(me) ? function Ze(nt, tt) {
    var et, rt, it = [];
    for (var ot in nt) nt.hasOwnProperty(ot) && !be(nt[ot]) && (Array.isArray(nt[ot]) && nt[ot].isCss || E$1(nt[ot]) ? it.push(Ee(ot) + ":", nt[ot], ";") : g$1(nt[ot]) ? it.push.apply(it, Ze(nt[ot], ot)) : it.push(Ee(ot) + ": " + (et = ot, (rt = nt[ot]) == null || typeof rt == "boolean" || rt === "" ? "" : typeof rt != "number" || rt === 0 || et in unitlessKeys || et.startsWith("--") ? String(rt).trim() : rt + "px") + ";"));
    return tt ? [tt + " {"].concat(it, ["}"]) : it;
  }(me) : me.toString();
}
var Ne = function(me) {
  return Array.isArray(me) && (me.isCss = !0), me;
};
function Ae(me) {
  for (var ue = arguments.length, Qe = new Array(ue > 1 ? ue - 1 : 0), Ue = 1; Ue < ue; Ue++) Qe[Ue - 1] = arguments[Ue];
  return E$1(me) || g$1(me) ? Ne(_e(v$1(S$1, [me].concat(Qe)))) : Qe.length === 0 && me.length === 1 && typeof me[0] == "string" ? me : Ne(_e(v$1(me, Qe)));
}
var Ce = /invalid hook call/i, Ie = /* @__PURE__ */ new Set(), Pe = function(me, ue) {
  if (process.env.NODE_ENV !== "production") {
    var Qe = "The component " + me + (ue ? ' with the id of "' + ue + '"' : "") + ` has been created dynamically.
You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`, Ue = console.error;
    try {
      var He = !0;
      console.error = function(Ge) {
        if (Ce.test(Ge)) He = !1, Ie.delete(Qe);
        else {
          for (var Xe = arguments.length, Ke = new Array(Xe > 1 ? Xe - 1 : 0), $e = 1; $e < Xe; $e++) Ke[$e - 1] = arguments[$e];
          Ue.apply(void 0, [Ge].concat(Ke));
        }
      }, useRef(), He && !Ie.has(Qe) && (console.warn(Qe), Ie.add(Qe));
    } catch (Ge) {
      Ce.test(Ge.message) && Ie.delete(Qe);
    } finally {
      console.error = Ue;
    }
  }
}, Oe = function(me, ue, Qe) {
  return Qe === void 0 && (Qe = w$1), me.theme !== Qe.theme && me.theme || ue || Qe.theme;
}, Re = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, De = /(^-|-$)/g;
function je(me) {
  return me.replace(Re, "-").replace(De, "");
}
var Te = function(me) {
  return Q(te(me) >>> 0);
};
function xe(me) {
  return typeof me == "string" && (process.env.NODE_ENV === "production" || me.charAt(0) === me.charAt(0).toLowerCase());
}
var ke = function(me) {
  return typeof me == "function" || typeof me == "object" && me !== null && !Array.isArray(me);
}, Ve = function(me) {
  return me !== "__proto__" && me !== "constructor" && me !== "prototype";
};
function Be(me, ue, Qe) {
  var Ue = me[Qe];
  ke(ue) && ke(Ue) ? ze(Ue, ue) : me[Qe] = ue;
}
function ze(me) {
  for (var ue = arguments.length, Qe = new Array(ue > 1 ? ue - 1 : 0), Ue = 1; Ue < ue; Ue++) Qe[Ue - 1] = arguments[Ue];
  for (var He = 0, Ge = Qe; He < Ge.length; He++) {
    var Xe = Ge[He];
    if (ke(Xe)) for (var Ke in Xe) Ve(Ke) && Be(me, Xe[Ke], Ke);
  }
  return me;
}
var Me = React__default.createContext();
Me.Consumer;
function Le(me) {
  var ue = useContext(Me), Qe = useMemo(function() {
    return function(Ue, He) {
      if (!Ue) return D$1(14);
      if (E$1(Ue)) {
        var Ge = Ue(He);
        return process.env.NODE_ENV === "production" || Ge !== null && !Array.isArray(Ge) && typeof Ge == "object" ? Ge : D$1(7);
      }
      return Array.isArray(Ue) || typeof Ue != "object" ? D$1(8) : He ? y$1({}, He, {}, Ue) : Ue;
    }(me.theme, ue);
  }, [me.theme, ue]);
  return me.children ? React__default.createElement(Me.Provider, { value: Qe }, me.children) : null;
}
var Fe = {};
function Ye(me, ue, Qe) {
  var Ue = _$2(me), He = !xe(me), Ge = ue.attrs, Xe = Ge === void 0 ? S$1 : Ge, Ke = ue.componentId, $e = Ke === void 0 ? function(st, ut) {
    var lt = typeof st != "string" ? "sc" : je(st);
    Fe[lt] = (Fe[lt] || 0) + 1;
    var dt = lt + "-" + Te("5.3.11" + lt + Fe[lt]);
    return ut ? ut + "-" + dt : dt;
  }(ue.displayName, ue.parentComponentId) : Ke, Je = ue.displayName, Ze = Je === void 0 ? function(st) {
    return xe(st) ? "styled." + st : "Styled(" + b$1(st) + ")";
  }(me) : Je, nt = ue.displayName && ue.componentId ? je(ue.displayName) + "-" + ue.componentId : ue.componentId || $e, tt = Ue && me.attrs ? Array.prototype.concat(me.attrs, Xe).filter(Boolean) : Xe, et = ue.shouldForwardProp;
  Ue && me.shouldForwardProp && (et = ue.shouldForwardProp ? function(st, ut, lt) {
    return me.shouldForwardProp(st, ut, lt) && ue.shouldForwardProp(st, ut, lt);
  } : me.shouldForwardProp);
  var rt, it = new oe(Qe, nt, Ue ? me.componentStyle : void 0), ot = it.isStatic && Xe.length === 0, at = function(st, ut) {
    return function(lt, dt, At, pt) {
      var gt = lt.attrs, wt = lt.componentStyle, Bt = lt.defaultProps, Tt = lt.foldedComponentIds, yt = lt.shouldForwardProp, Ct = lt.styledComponentId, ht = lt.target, It = function(qt, _t, Yt) {
        qt === void 0 && (qt = w$1);
        var Xt = y$1({}, _t, { theme: qt }), Ut = {};
        return Yt.forEach(function(Lt) {
          var Ot, ft, Dt, Mt = Lt;
          for (Ot in E$1(Mt) && (Mt = Mt(Xt)), Mt) Xt[Ot] = Ut[Ot] = Ot === "className" ? (ft = Ut[Ot], Dt = Mt[Ot], ft && Dt ? ft + " " + Dt : ft || Dt) : Mt[Ot];
        }), [Xt, Ut];
      }(Oe(dt, useContext(Me), Bt) || w$1, dt, gt), vt = It[0], Et = It[1], bt = function(qt, _t, Yt, Xt) {
        var Ut = pe(), Lt = fe(), Ot = _t ? qt.generateAndInjectStyles(w$1, Ut, Lt) : qt.generateAndInjectStyles(Yt, Ut, Lt);
        return process.env.NODE_ENV !== "production" && !_t && Xt && Xt(Ot), Ot;
      }(wt, pt, vt, process.env.NODE_ENV !== "production" ? lt.warnTooManyClasses : void 0), Rt = At, St = Et.$as || dt.$as || Et.as || dt.as || ht, kt = xe(St), jt = Et !== dt ? y$1({}, dt, {}, Et) : dt, Pt = {};
      for (var Qt in jt) Qt[0] !== "$" && Qt !== "as" && (Qt === "forwardedAs" ? Pt.as = jt[Qt] : (yt ? yt(Qt, isPropValid, St) : !kt || isPropValid(Qt)) && (Pt[Qt] = jt[Qt]));
      return dt.style && Et.style !== dt.style && (Pt.style = y$1({}, dt.style, {}, Et.style)), Pt.className = Array.prototype.concat(Tt, Ct, bt !== Ct ? bt : null, dt.className, Et.className).filter(Boolean).join(" "), Pt.ref = Rt, createElement$2(St, Pt);
    }(rt, st, ut, ot);
  };
  return at.displayName = Ze, (rt = React__default.forwardRef(at)).attrs = tt, rt.componentStyle = it, rt.displayName = Ze, rt.shouldForwardProp = et, rt.foldedComponentIds = Ue ? Array.prototype.concat(me.foldedComponentIds, me.styledComponentId) : S$1, rt.styledComponentId = nt, rt.target = Ue ? me.target : me, rt.withComponent = function(st) {
    var ut = ue.componentId, lt = function(At, pt) {
      if (At == null) return {};
      var gt, wt, Bt = {}, Tt = Object.keys(At);
      for (wt = 0; wt < Tt.length; wt++) gt = Tt[wt], pt.indexOf(gt) >= 0 || (Bt[gt] = At[gt]);
      return Bt;
    }(ue, ["componentId"]), dt = ut && ut + "-" + (xe(st) ? st : je(b$1(st)));
    return Ye(st, y$1({}, lt, { attrs: tt, componentId: dt }), Qe);
  }, Object.defineProperty(rt, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(st) {
    this._foldedDefaultProps = Ue ? ze({}, me.defaultProps, st) : st;
  } }), process.env.NODE_ENV !== "production" && (Pe(Ze, nt), rt.warnTooManyClasses = /* @__PURE__ */ function(st, ut) {
    var lt = {}, dt = !1;
    return function(At) {
      if (!dt && (lt[At] = !0, Object.keys(lt).length >= 200)) {
        var pt = ut ? ' with the id of "' + ut + '"' : "";
        console.warn("Over 200 classes were generated for component " + st + pt + `.
Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), dt = !0, lt = {};
      }
    };
  }(Ze, nt)), Object.defineProperty(rt, "toString", { value: function() {
    return "." + rt.styledComponentId;
  } }), He && m$2(rt, me, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0, withComponent: !0 }), rt;
}
var qe = function(me) {
  return function ue(Qe, Ue, He) {
    if (He === void 0 && (He = w$1), !reactIsExports.isValidElementType(Ue)) return D$1(1, String(Ue));
    var Ge = function() {
      return Qe(Ue, He, Ae.apply(void 0, arguments));
    };
    return Ge.withConfig = function(Xe) {
      return ue(Qe, Ue, y$1({}, He, {}, Xe));
    }, Ge.attrs = function(Xe) {
      return ue(Qe, Ue, y$1({}, He, { attrs: Array.prototype.concat(He.attrs, Xe).filter(Boolean) }));
    }, Ge;
  }(Ye, me);
};
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function(me) {
  qe[me] = qe(me);
});
function We(me) {
  process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");
  for (var ue = arguments.length, Qe = new Array(ue > 1 ? ue - 1 : 0), Ue = 1; Ue < ue; Ue++) Qe[Ue - 1] = arguments[Ue];
  var He = Ae.apply(void 0, [me].concat(Qe)).join(""), Ge = Te(He);
  return new ye(Ge, He);
}
process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`), process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window < "u" && (window["__styled-components-init__"] = window["__styled-components-init__"] || 0, window["__styled-components-init__"] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`), window["__styled-components-init__"] += 1);
const RetryButtonsContainer = qe.div`
  display: flex;
  justify-content: center;
  margin-top: 50px;
  ${(me) => me.isDesktop && `position: absolute;
    bottom: 100px;
    z-index: 100;
    `}
`, CaptureButtonContainer$2 = qe(motion.div)`
  position: fixed;
  bottom: 18px;
  left: calc(50% - 44px);
  z-index: 9999;

  &.kiosk {
    position: absolute;
  }

  p {
    margin: 0;
    text-transform: uppercase;
    margin-bottom: 10px;
    font-size: 13px;
    color: #343a4f;
    font-weight: bold;
  }

  button {
    background-color: transparent;
    border: none;
  }
`, Hidder = qe(motion.div)`
  background: #f5f5f6;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`, WebcamContainer$1 = qe.div`
  height: 301px;
  width: 301px;
  display: flex;
  justify-content: center;
  align-items: center;

  &.kiosk {
    position: relative;
  }
`, spinner$2 = We`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`, Container$h = qe.div`
  height: 100%;
  max-width: 300px;
  text-align: center;
  margin: auto;
  padding-top: 100px;
  position: relative;

  &.kiosk {
    padding-top: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  @media only screen and (max-height: 600px) {
    padding-top: 30px;
  }
`, BordersContainer = qe.div`
  position: absolute;
  left: -17px;
  top: 84px;
  right: 0;
  width: 335px;
  margin: auto;

  &.kiosk {
    top: -16px;
  }

  @media only screen and (max-height: 600px) {
    top: 14px;
  }
`, CameraOvalOuter = qe(motion.div)`
  width: 300px;
  height: 300px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: rotateZ(0.01deg);
  border: 0px solid #21273b;
`, CameraOvalInner = qe.div`
  border-radius: 50%;
  overflow: hidden;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  transform: translate3d(0, 0, 0) rotateZ(0.01deg);
  border: 11px solid #fff;

  &.isUploading {
    border: none;
    background-color: rgba(113, 113, 113, 0.07);
  }
`, CameraOvalInnerText = qe.p`
  display: flex;
  align-items: center;
  font-size: 23px;
  font-weight: bold;
  color: #21273b;

  &.isError {
    color: #ff5c6f;
  }
`, FaceFrame$1 = qe.img`
  height: 85%;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
  z-index: 10;
`, LoadingBordersContainer = qe(motion.svg)`
  height: 100%;
  width: 100%;

  animation: ${spinner$2} 1s linear infinite;

  &.success {
    animation: none;
  }
`, NotificationInline = qe(motion.p)`
  font-size: 100px;
  font-size: 23px;
  font-weight: bold;
  margin-top: 30px;
  margin: 30px auto 0 auto;
  height: 60px;

  &.hasManualCapture {
    @media only screen and (max-height: 530px) {
      display: none;
    }
  }
`, loadingColors = {
  capturing: "rgba(33, 39, 59, 0.36)",
  uploading: "#3CB0F7",
  success: "#09eda8"
};
function LoadingBorders({ mode: me, className: ue }) {
  const Qe = loadingColors[me];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    LoadingBordersContainer,
    {
      width: 272,
      height: 272,
      viewBox: "0 0 272 272",
      className: classNames(ue, { success: me === "success" }),
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      transition: { duration: 0.3 },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { id: "wydb6yed4a", cx: 142, cy: 142, r: 125 }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "mask",
            {
              id: "kb40xhfrmb",
              width: 272,
              height: 272,
              x: -11,
              y: -11,
              maskContentUnits: "userSpaceOnUse",
              maskUnits: "objectBoundingBox",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fill: "#fff", d: "M6 6H278V278H6z" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("use", { xlinkHref: "#wydb6yed4a" })
              ]
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("g", { fill: "none", fillRule: "evenodd", strokeDasharray: "2.94 4.2", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          motion.g,
          {
            strokeWidth: 22,
            initial: { stroke: "rgba(33, 39, 59, 0.36)" },
            animate: {
              stroke: Qe
            },
            transition: { duration: 0.5 },
            children: /* @__PURE__ */ jsxRuntimeExports.jsx("g", { transform: "translate(-52 -225) translate(46 219)", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              "use",
              {
                mask: "url(#kb40xhfrmb)",
                transform: "rotate(-90 142 142)",
                xlinkHref: "#wydb6yed4a"
              }
            ) })
          }
        ) })
      ]
    }
  );
}
const PreviewImage = qe.img`
  width: 100%;
  position: absolute;
  z-index: 1;
  transform: rotateY(180deg) rotateZ(0.01deg);
`, LoginContainer = qe.div`
  display: flex;
  height: 100vh;
  width: 100%;
  video {
    width: 100% !important;
    margin-left: 0 !important;
  }
`, Notification$1 = qe.p`
  border-radius: 20px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 15px 20px 15px 20px;
  position: absolute;
  top: 20px;
  left: 50%;
  right: 0;
  max-width: calc(100% - 50px); // 40px are for the padding
  width: fit-content;
  box-sizing: content-box;
  transform: translateX(-50%);
  z-index: 9999999999999;

  &.center {
    font-size: 18px;

    .icon {
      text-align: center;
    }

    .notification-text {
      line-height: 1.5;
      margin: 0;
    }
  }

  &.inline {
    display: flex;
  }

  color: ${(me) => me.isLoading ? "white" : me.isError ? "#ff5c6f" : "white"};

  &.desktop {
    top: 100px;
    padding: 0;
    background-color: transparent;
    color: #20263d;
    font-size: 24px;
    line-height: 22px;
  }
`, FaceMask$1 = qe.div`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
  position: absolute;
  top: ${(me) => me.desktop ? "50%" : "45%"};
  width: 35vw;
  height: 35vw;
  transform: translate(-50%, -50%);
  left: 50%;
  border: solid 6.9px;
  border-color: ${(me) => me.isCapturing ? "#0cd5a2" : me.isLoading ? "#00b2fd" : me.error ? "#ff5c6f" : "#fff"};
  border-radius: 50%;
  box-shadow: ${(me) => me.desktop ? "0 0 0 99999px #ffffff" : me.isUploading ? "0 0 0 99999px #F2F2F2" : "0 0 0 99999px rgba(0, 0, 0, 0.6)"};
  max-height: ${(me) => me.desktop ? "400px" : "none"};
  max-width: ${(me) => me.desktop ? "400px" : "none"};
`, WebcamDesktopContainer = qe.div`
  height: 100%;
  width: 100%;
  position: relative;
`;
var eventemitter3 = { exports: {} };
(function(me) {
  var ue = Object.prototype.hasOwnProperty, Qe = "~";
  function Ue() {
  }
  Object.create && (Ue.prototype = /* @__PURE__ */ Object.create(null), new Ue().__proto__ || (Qe = !1));
  function He($e, Je, Ze) {
    this.fn = $e, this.context = Je, this.once = Ze || !1;
  }
  function Ge($e, Je, Ze, nt, tt) {
    if (typeof Ze != "function")
      throw new TypeError("The listener must be a function");
    var et = new He(Ze, nt || $e, tt), rt = Qe ? Qe + Je : Je;
    return $e._events[rt] ? $e._events[rt].fn ? $e._events[rt] = [$e._events[rt], et] : $e._events[rt].push(et) : ($e._events[rt] = et, $e._eventsCount++), $e;
  }
  function Xe($e, Je) {
    --$e._eventsCount === 0 ? $e._events = new Ue() : delete $e._events[Je];
  }
  function Ke() {
    this._events = new Ue(), this._eventsCount = 0;
  }
  Ke.prototype.eventNames = function() {
    var Je = [], Ze, nt;
    if (this._eventsCount === 0) return Je;
    for (nt in Ze = this._events)
      ue.call(Ze, nt) && Je.push(Qe ? nt.slice(1) : nt);
    return Object.getOwnPropertySymbols ? Je.concat(Object.getOwnPropertySymbols(Ze)) : Je;
  }, Ke.prototype.listeners = function(Je) {
    var Ze = Qe ? Qe + Je : Je, nt = this._events[Ze];
    if (!nt) return [];
    if (nt.fn) return [nt.fn];
    for (var tt = 0, et = nt.length, rt = new Array(et); tt < et; tt++)
      rt[tt] = nt[tt].fn;
    return rt;
  }, Ke.prototype.listenerCount = function(Je) {
    var Ze = Qe ? Qe + Je : Je, nt = this._events[Ze];
    return nt ? nt.fn ? 1 : nt.length : 0;
  }, Ke.prototype.emit = function(Je, Ze, nt, tt, et, rt) {
    var it = Qe ? Qe + Je : Je;
    if (!this._events[it]) return !1;
    var ot = this._events[it], at = arguments.length, st, ut;
    if (ot.fn) {
      switch (ot.once && this.removeListener(Je, ot.fn, void 0, !0), at) {
        case 1:
          return ot.fn.call(ot.context), !0;
        case 2:
          return ot.fn.call(ot.context, Ze), !0;
        case 3:
          return ot.fn.call(ot.context, Ze, nt), !0;
        case 4:
          return ot.fn.call(ot.context, Ze, nt, tt), !0;
        case 5:
          return ot.fn.call(ot.context, Ze, nt, tt, et), !0;
        case 6:
          return ot.fn.call(ot.context, Ze, nt, tt, et, rt), !0;
      }
      for (ut = 1, st = new Array(at - 1); ut < at; ut++)
        st[ut - 1] = arguments[ut];
      ot.fn.apply(ot.context, st);
    } else {
      var lt = ot.length, dt;
      for (ut = 0; ut < lt; ut++)
        switch (ot[ut].once && this.removeListener(Je, ot[ut].fn, void 0, !0), at) {
          case 1:
            ot[ut].fn.call(ot[ut].context);
            break;
          case 2:
            ot[ut].fn.call(ot[ut].context, Ze);
            break;
          case 3:
            ot[ut].fn.call(ot[ut].context, Ze, nt);
            break;
          case 4:
            ot[ut].fn.call(ot[ut].context, Ze, nt, tt);
            break;
          default:
            if (!st) for (dt = 1, st = new Array(at - 1); dt < at; dt++)
              st[dt - 1] = arguments[dt];
            ot[ut].fn.apply(ot[ut].context, st);
        }
    }
    return !0;
  }, Ke.prototype.on = function(Je, Ze, nt) {
    return Ge(this, Je, Ze, nt, !1);
  }, Ke.prototype.once = function(Je, Ze, nt) {
    return Ge(this, Je, Ze, nt, !0);
  }, Ke.prototype.removeListener = function(Je, Ze, nt, tt) {
    var et = Qe ? Qe + Je : Je;
    if (!this._events[et]) return this;
    if (!Ze)
      return Xe(this, et), this;
    var rt = this._events[et];
    if (rt.fn)
      rt.fn === Ze && (!tt || rt.once) && (!nt || rt.context === nt) && Xe(this, et);
    else {
      for (var it = 0, ot = [], at = rt.length; it < at; it++)
        (rt[it].fn !== Ze || tt && !rt[it].once || nt && rt[it].context !== nt) && ot.push(rt[it]);
      ot.length ? this._events[et] = ot.length === 1 ? ot[0] : ot : Xe(this, et);
    }
    return this;
  }, Ke.prototype.removeAllListeners = function(Je) {
    var Ze;
    return Je ? (Ze = Qe ? Qe + Je : Je, this._events[Ze] && Xe(this, Ze)) : (this._events = new Ue(), this._eventsCount = 0), this;
  }, Ke.prototype.off = Ke.prototype.removeListener, Ke.prototype.addListener = Ke.prototype.on, Ke.prefixed = Qe, Ke.EventEmitter = Ke, me.exports = Ke;
})(eventemitter3);
var eventemitter3Exports = eventemitter3.exports;
const EventEmitter$5 = /* @__PURE__ */ getDefaultExportFromCjs(eventemitter3Exports), theme$1 = {
  main: "#007AFF",
  active: "#22253d",
  buttonBorderRadius: "31px",
  buttonColor: "#fff",
  modal: {},
  mainButton: {},
  secondaryButton: {},
  minWidth: "215px",
  fontSize: "1.188rem"
}, buttonStyles = Ae`
  text-transform: uppercase;
  padding: 18px 25px;
  background-color: ${(me) => me.theme.main ?? theme$1.main};
  min-width: ${(me) => me.theme.minWidth ?? theme$1.minWidth};
  border-radius: ${(me) => me.theme.buttonBorderRadius ?? theme$1.buttonBorderRadius};
  color: ${(me) => me.theme.buttonColor ?? theme$1.buttonColor};
  font-size: ${(me) => me.theme.fontSize ?? theme$1.fontSize};
  font-weight: bold;
  border: none;
  box-shadow: 0px 3px 10px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14);
  ${(me) => me.theme.mainButton}

  &.hover {
    background-color: ${(me) => me.theme.main};
  }

  &:active {
    background-color: ${(me) => me.theme.active || theme$1.active};
  }

  &.button-hidden {
    display: none;
  }

  &:disabled {
    color: #646464;
    box-shadow: none;
    background-color: #e9e9eb;
  }
`, Button$a = qe.button`
  ${buttonStyles}
`;
Button$a.defaultProps = {
  theme: theme$1
};
const Steps = ({ children: me, currentStep: ue }) => /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: Children.toArray(me).filter((Qe) => Qe !== null).map(
  (Qe, Ue) => ue === Ue && cloneElement(Qe)
) }), secondaryButtonStyles = Ae`
  font-size: 18px;
  font-weight: bold;
  line-height: 1.11;
  color: rgba(32, 38, 61, 0.54);
  background: transparent;
  border: none;
`, SecondaryButton = qe.button`
  ${secondaryButtonStyles}
`, CheckboxInput = qe.input`
  appearance: none;
  display: block;
  height: 25px;
  width: 25px;
  min-width: 25px;
  background-color: ${(me) => me.variant === "circle" ? "#eee" : "unset"};
  border-radius: ${(me) => me.variant === "circle" ? "50%" : "6px"};
  margin-right: 10px;
  position: relative;
  border: ${(me) => me.variant === "circle" ? "none" : "solid 2px #20263D"};

  &:after {
    content: '';
    position: absolute;
    display: none;
  }

  &:checked {
    background-color: #0cd5a2;
    border: unset;

    &:after {
      position: absolute;
      left: 10px;
      top: 7px;
      width: 5px;
      height: 10px;
      border: solid white;
      border-width: 0 3px 3px 0;
      transform: rotate(45deg);
      display: block;
    }
  }

  &:disabled {
    opacity: 0.5;
  }
`, CheckboxLabel$4 = qe.label`
  display: flex;

  span {
    font-size: 14px;
  }
`, Checkbox = ({
  id: me,
  text: ue,
  variant: Qe = "circle",
  handleChange: Ue,
  defaultChecked: He,
  disabled: Ge = !1
}) => {
  const [Xe, Ke] = useState(He), $e = (Je) => {
    Ke((Ze) => !Ze), Ue(Je);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(CheckboxLabel$4, { htmlFor: me, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CheckboxInput,
      {
        id: me,
        type: "checkbox",
        checked: Xe,
        onChange: $e,
        variant: Qe,
        disabled: Ge
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: ue })
  ] });
}, Input$8 = qe.input`
  justify-content: space-between;
  width: 100%;
  max-width: 41px;
  height: 49px;
  margin: 5px;
  text-align: center;
  font-size: 34px;
  border-radius: 6px;
  background-color: #e9e9eb;
  border: none;
  padding: 0;
  line-height: 1;
  text-transform: uppercase;

  &:not(:placeholder-shown) {
    border: solid 3px #20263d;
  }
`, InputBox = (me) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  Input$8,
  {
    maxLength: me.maxLength || 1,
    ref: me.inputRef,
    placeholder: " ",
    autoComplete: "off",
    className: "IncodeOTPInput",
    ...me
  }
), Wrapper$5 = qe.div`
  margin: auto;
  margin-top: 50px;
  padding: 10px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`, ContainerInput = qe.div`
  display: flex;
`, IndividualCharacterInputBoxes = ({ isNumeric: me = !1, ...ue }) => {
  const { t: Qe } = useTranslation(), [Ue, He] = useState(
    Array(ue.amount).fill("")
  ), Ge = useRef({});
  useEffect(() => {
    He((rt) => (rt.forEach(
      (it, ot) => rt[ot] = ue.value[ot] || ""
    ), [...rt]));
  }, [ue.value]), useEffect(() => {
    ue.autoFocus && Ge.current.input0.select();
  }, [ue.autoFocus]), useEffect(() => {
    ue.password ? ue.onChange(Ue.join("")) : ue.onChange(Ue.join("").toUpperCase());
  }, [Ue, ue]);
  const Xe = () => {
    const rt = Ue.length;
    return Ue.map((it, ot) => {
      const at = Qe("otp.input", {
        number: ot + 1,
        charLength: rt
      });
      return ue.password ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        InputBox,
        {
          "aria-labelledby": "otp-group-label",
          "aria-label": at,
          id: `OTPInput-${ot}`,
          type: "password",
          onKeyDown: Je,
          onFocus: Ze,
          onChange: $e,
          name: `otp-input-${ot}`,
          inputRef: (st) => {
            st && (Ge.current[st.name] = st);
          },
          value: Ue[ot]
        },
        ot
      ) : me ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        InputBox,
        {
          "aria-labelledby": "otp-group-label",
          "aria-label": at,
          id: `OTPInput-${ot}`,
          type: "number",
          max: 1,
          inputMode: "numeric",
          pattern: "[0-9]{1}",
          onKeyDown: Je,
          onFocus: Ze,
          onChange: $e,
          name: "input" + ot,
          inputRef: (st) => {
            st && (Ge.current[st.name] = st);
          },
          value: Ue[ot]
        },
        ot
      ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
        InputBox,
        {
          "aria-labelledby": "otp-group-label",
          "aria-label": at,
          id: `OTPInput-${ot}`,
          type: "text",
          onKeyDown: Je,
          onFocus: Ze,
          onChange: $e,
          onPaste: Ke,
          name: "input" + ot,
          inputRef: (st) => {
            st && (Ge.current[st.name] = st);
          },
          value: Ue[ot],
          maxLength: ue.maxLength
        },
        ot
      );
    });
  }, Ke = (rt) => {
    const it = rt.clipboardData.getData("text");
    it.length > ue.amount && it.slice(0, ue.amount);
    const ot = it.split("");
    He((at) => (setTimeout(() => {
      at.forEach(
        (st, ut) => at[ut] = ot[ut] || ""
      );
    }), [...at])), Ge.current[`input${ot.length - 1}`].select();
  }, $e = ({ target: rt }) => {
    rt.value.length === ue.amount ? (He((it) => (rt.value.split("").forEach((ot, at) => it[at] = ot || ""), [...it])), Ge.current[`input${rt.value.length - 1}`].focus()) : (tt(rt), et());
  }, Je = (rt) => {
    const it = rt.key, ot = rt.target;
    it === "Backspace" ? (ot.value === "" && ot.previousElementSibling !== null ? (ot.previousElementSibling.value = "", nt(ot)) : ot.value = "", et()) : it === "ArrowLeft" ? nt(ot) : it === "ArrowRight" && tt(ot);
  }, Ze = ({ target: rt }) => {
    const it = rt;
    setTimeout(function() {
      it.select();
    }, 0);
  }, nt = (rt) => {
    rt.previousElementSibling !== null && rt.previousElementSibling.focus();
  }, tt = (rt) => {
    rt.nextElementSibling !== null && rt.nextElementSibling.focus();
  }, et = () => {
    He((rt) => rt.map(
      (it, ot) => Ge.current["input" + ot].value[0]
    ));
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Wrapper$5, { className: "character-inputs-container", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ContainerInput, { children: Xe() }) });
}, ProgressStateContext = createContext(null);
ProgressStateContext.displayName = "ProgressStateContext";
const ProgressDispatcherContext = createContext(null);
ProgressDispatcherContext.displayName = "ProgressDispatcherContext";
createContext(null);
const rotateImage = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='90'%20height='90'%20viewBox='0%200%2090%2090'%3e%3cg%20fill='%2320263D'%3e%3cpath%20d='M84.12%2027.54l-2.58-2.58L65.036%208.456l-2.58-2.58c-3.127-3.127-8.58-2.764-12.157.81L6.69%2050.306c-3.574%203.574-3.938%209.027-.81%2012.158l21.66%2021.66c3.128%203.127%208.58%202.764%2012.157-.81l43.617-43.616c3.574-3.578%203.937-9.03.806-12.158zm-5.524%208.617l-42.439%2042.44c-1.3%201.3-3.28%201.432-4.42.296l-20.63-20.63c-1.14-1.14-1.008-3.12.297-4.42l42.438-42.44c1.302-1.3%203.282-1.432%204.422-.296l1.031%201.032c1.14%201.14%201.009%203.12-.296%204.421-1.302%201.301-1.433%203.281-.297%204.421L69.02%2031.297c1.14%201.14%203.12%201.01%204.421-.296%201.301-1.301%203.281-1.432%204.421-.296l1.031%201.031c1.137%201.14%201.005%203.12-.296%204.421zM51.885%2090a3.135%203.135%200%2001-2.22-5.351l8.925-8.925a3.138%203.138%200%20014.646.233l3.308%204.046c10.114-5.374%2017.081-15.994%2017.178-28.14a3.136%203.136%200%20013.136-3.113h.026a3.14%203.14%200%20013.112%203.161C89.835%2072.746%2072.746%2089.835%2051.911%2090h-.026zM38.115%200a3.135%203.135%200%20012.22%205.351l-8.925%208.925a3.125%203.125%200%2001-2.378.915%203.138%203.138%200%2001-2.272-1.147l-3.308-4.046C13.34%2015.37%206.373%2025.99%206.274%2038.138a3.14%203.14%200%2001-3.139%203.112h-.026a3.139%203.139%200%2001-3.11-3.161C.166%2017.254%2017.255.165%2038.09%200h.026z'/%3e%3c/g%3e%3c/svg%3e", LandscapeNotSupportedContainer = qe.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: white;
  text-align: center;
  z-index: 99999999999999999;
  box-sizing: border-box;
  padding: 50px;
  font-weight: bolder;
  height: 100%;
  width: 100%;

  @media only screen and (max-height: 480px) {
    width: 100vw;
    height: 100vh;
  }
`, Paragraph$5 = qe.p`
  display: block;
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 0;
  margin-inline-end: 0;
  font-size: 22px;
`, RotateIcon = qe.img`
  height: 90px;
  margin-bottom: 25px;
`;
function LandscapeNotSupported() {
  const { t: me } = useTranslation(), ue = document.getElementsByTagName("body")[0];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: createPortal(
    /* @__PURE__ */ jsxRuntimeExports.jsxs(LandscapeNotSupportedContainer, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(RotateIcon, { src: rotateImage }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph$5, { children: me("common.landscape") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph$5, { children: mobile.isIpad() ? me("common.rotateIpad") : me("common.rotate") })
    ] }),
    ue
  ) });
}
const StyledInput = qe.input`
  background: #edf2f6;
  border-radius: 6px;
  padding: 25px 0;
  text-align: center;
  width: 320px;
`, spinH2 = {
  margin: "0 0 20px 0"
}, Container$g = qe.div`
  width: 100%;
  height: 100%;
`;
function HangOn() {
  const { t: me } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Container$g, { className: "IncodeContainer", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "IncodeSpinnerHeading IncodeH2", style: spinH2, children: me("loadingCircle.hangOn") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "IncodeParagraph", children: me("loadingCircle.validating") })
  ] });
}
const StyledSpinner = ({
  className: me,
  color: ue = "#1C1F28"
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "svg",
  {
    className: me,
    xmlns: "http://www.w3.org/2000/svg",
    width: "286",
    height: "286",
    viewBox: "0 0 286 286",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { id: "a", cx: "150", cy: "150", r: "131" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("mask", { id: "b", width: "286", height: "286", x: "-12", y: "-12", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fill: "#fff", d: "M7 7h286v286H7z" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("use", { xlinkHref: "#a" })
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "use",
        {
          fill: "none",
          fillRule: "evenodd",
          stroke: ue,
          strokeDasharray: "3,5",
          strokeWidth: "24",
          mask: "url(#b)",
          transform: "translate(-7 -7)",
          xlinkHref: "#a"
        }
      )
    ]
  }
), SpinnerContainer$4 = qe.div`
  height: 100%;
  top: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0px;
  right: 0px;
  z-index: 100;
  bottom: 0px;
  background-color: #fff;

  @keyframes spinner {
    to {
      transform: rotate(360deg);
    }
  }

  .spinner-inner {
    width: 250px;
    height: 250px;
    position: absolute;
    border-radius: 50%;
    background-color: rgba(#000, 0.1);
    text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    margin: 0 auto;
  }

  .spinner-animation {
    position: absolute;
    animation: spinner 0.6s linear infinite;
  }

  h2 {
    font-size: 36px;
  }

  p {
    font-size: 20px;
    margin: 0 10px;
  }
`, Spinner$6 = ({ children: me = /* @__PURE__ */ jsxRuntimeExports.jsx(HangOn, {}) }) => {
  const ue = new URLSearchParams(window.location.search), Ue = ue.get("darkMode") || ue.get("darkTheme") ? "#FFF" : "#1C1F28";
  return /* @__PURE__ */ jsxRuntimeExports.jsx("section", { className: "wrapper user-data-wrapper yourInfo", children: /* @__PURE__ */ jsxRuntimeExports.jsx(SpinnerContainer$4, { className: "IncodeContainer", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "spinner-inner", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinner, { className: "spinner-animation", color: Ue }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: "IncodeSpinnerAnimationText",
        role: "region",
        "aria-live": "assertive",
        children: me
      }
    )
  ] }) }) });
}, PhoneContainer = qe.div`
  position: relative;
  margin-top: 10px;
  font-size: 20px;
  display: flex;
  height: 90%;
  min-height: 90%;
  flex-direction: column;
  justify-content: space-between;
`;
qe.section`
  position: relative;
`;
const PhoneSelectorWrapper = qe.section``, PhoneLabel = qe.label`
  display: flex;
  flex-direction: column;
`;
qe.label`
  font-size: 16px;
  color: #636670;
  font-weight: 700;
  margin-bottom: 4px;
  display: inline-block;
`;
const Phone$2 = qe.input`
  width: 100%;
  font-size: 18px;
  padding: 12px 8px 12px 8px;
  caret-color: #bcbcbc;
  border-radius: 8px;
`, CountryListContainer = qe.section`
  position: absolute;
  z-index: 2;
  width: 100%;
  margin-top: 8px;
  border: 2px solid #636670;
  background: #fff;
  border-radius: 8px;
  padding: 16px 21.5px;
  max-height: 320px;
  display: flex;
  flex-direction: column;
`, CountryItemsContainer = qe.ul`
  font-size: 15px;
  cursor: pointer;
  overflow: auto;
`, CountryItem = qe.li`
  padding: 13.5px 8px;
  color: ${(me) => me.isDisabled ? "#bcbcbc" : "#20263d"};
  > :first-child {
    margin-right: 5px;
  }
`, SearchInputContainer = qe.div`
  display: flex;
  position: relative;
  border-bottom: 1px solid #e9e9eb;
`, SearchInput = qe.input`
  color: #bcbcbc;
  font-size: 15px;
  width: 100%;
  margin: 0 8px 0;
  padding: 13.5px 0;
`, PhoneInputWrapper = qe.div`
  display: flex;
  position: relative;
  border: 2px solid #979797;
  border-radius: 8px;
`, SelectorDivider = qe.div`
  width: 1px;
  border: 1px solid #bcbcbc;
  height: 100%;
`, CountryButtonSelector = qe.button`
  display: flex;
  padding: 8px;
  width: 119px;
  align-items: center;
  color: #bcbcbc;

  font-size: 18px;
  > span {
    margin-right: 5px;
  }

  > :last-child {
    margin-left: 8px;
  }
`;
qe.section`
  height: 48px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  color: ${(me) => me.hasValue ? "#20263d" : "#bcbcbc"};
  font-size: 20px;
  font-weight: 500;
  width: 100%;
  border: 2px solid #979797;
  border-radius: 8px;

  > span {
    margin-right: 5px;
  }
`;
const FormContainer = qe.section`
  display: flex;
  width: 100%;
`;
qe.span`
  color: #ff5c6f;
`;
const StyledButton$6 = qe(Button$a)`
  margin-top: 15px;
  text-transform: uppercase;
`;
qe.div`
  display: flex;
  flex-grow: 1;
  align-items: flex-end;
`;
const EmailLink$1 = qe.div`
  color: #3585f1;
  font-size: 14px;
  font-weight: 700;
  margin-top: 16px;
`, searchIcon = "data:image/svg+xml,%3csvg%20width='24'%20height='25'%20viewBox='0%200%2024%2025'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M10.875%2019.25C15.2242%2019.25%2018.75%2015.7242%2018.75%2011.375C18.75%207.02576%2015.2242%203.5%2010.875%203.5C6.52576%203.5%203%207.02576%203%2011.375C3%2015.7242%206.52576%2019.25%2010.875%2019.25Z'%20stroke='%23979797'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M16.4431%2016.9434L20.9994%2021.4997'%20stroke='%23979797'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", SearchBar = ({ onHandleSearch: me, placeholder: ue }) => {
  const Qe = ({
    target: { value: Ue }
  }) => {
    me(Ue);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(SearchInputContainer, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      SearchInput,
      {
        onChange: Qe,
        type: "text",
        placeholder: ue
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: searchIcon, alt: "search icon" })
  ] });
}, CountryList = forwardRef(
  ({ list: me, onHandleChange: ue, searchPlaceholder: Qe, closeList: Ue, selectedCountry: He }, Ge) => {
    const [Xe, Ke] = useState(""), $e = useMemo(() => Xe ? me.filter(
      (Ze) => Ze.name.toLocaleLowerCase().includes(Xe.toLocaleLowerCase())
    ) : me, [me, Xe]);
    useClickOutside(Ge, () => {
      Ue();
    });
    const Je = (Ze) => {
      Ke(Ze);
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(CountryListContainer, { ref: Ge, id: "country-list", role: "listbox", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        SearchBar,
        {
          placeholder: Qe,
          onHandleSearch: Je
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(CountryItemsContainer, { children: $e.map((Ze) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
        CountryItem,
        {
          onClick: () => {
            ue(Ze.id);
          },
          role: "option",
          "aria-selected": He === Ze.id,
          tabIndex: 0,
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: Ze.emoji }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
              Ze.code,
              " ",
              Ze.name
            ] })
          ]
        },
        Ze.id
      )) })
    ] });
  }
), countries = {
  MX: {
    emoji: "🇲🇽",
    name: "México",
    alpha3: "mex"
  },
  US: {
    emoji: "🇺🇸",
    name: "USA",
    alpha3: "usa"
  },
  RS: {
    emoji: "🇷🇸",
    name: "Serbia",
    alpha3: "srb"
  },
  AC: {
    emoji: "🇦🇨",
    name: "Ascension Island",
    alpha3: null
  },
  AD: {
    emoji: "🇦🇩",
    name: "Andorra",
    alpha3: "and"
  },
  AE: {
    emoji: "🇦🇪",
    name: "United Arab Emirates",
    alpha3: "are"
  },
  AF: {
    emoji: "🇦🇫",
    name: "Afghanistan",
    alpha3: "afg"
  },
  AG: {
    emoji: "🇦🇬",
    name: "Antigua and Barbuda",
    alpha3: "atg"
  },
  AI: {
    emoji: "🇦🇮",
    name: "Anguilla",
    alpha3: "aia"
  },
  AL: {
    emoji: "🇦🇱",
    name: "Albania",
    alpha3: "alb"
  },
  AM: {
    emoji: "🇦🇲",
    name: "Armenia",
    alpha3: "arm"
  },
  AO: {
    emoji: "🇦🇴",
    name: "Angola",
    alpha3: "ago"
  },
  AR: {
    emoji: "🇦🇷",
    name: "Argentina",
    alpha3: "arg"
  },
  AS: {
    emoji: "🇦🇸",
    name: "American Samoa",
    alpha3: "asm"
  },
  AT: {
    emoji: "🇦🇹",
    name: "Austria",
    alpha3: "aut"
  },
  AU: {
    emoji: "🇦🇺",
    name: "Australia",
    alpha3: "aus"
  },
  AW: {
    emoji: "🇦🇼",
    name: "Aruba",
    alpha3: "abw"
  },
  AX: {
    emoji: "🇦🇽",
    name: "Åland Islands",
    alpha3: "ala"
  },
  AZ: {
    emoji: "🇦🇿",
    name: "Azerbaijan",
    alpha3: "aze"
  },
  BA: {
    emoji: "🇧🇦",
    name: "Bosnia and Herzegovina",
    alpha3: "bih"
  },
  BB: {
    emoji: "🇧🇧",
    name: "Barbados",
    alpha3: "brb"
  },
  BD: {
    emoji: "🇧🇩",
    name: "Bangladesh",
    alpha3: "bgd"
  },
  BE: {
    emoji: "🇧🇪",
    name: "Belgium",
    alpha3: "bel"
  },
  BF: {
    emoji: "🇧🇫",
    name: "Burkina Faso",
    alpha3: "bfa"
  },
  BG: {
    emoji: "🇧🇬",
    name: "Bulgaria",
    alpha3: "bgr"
  },
  BH: {
    emoji: "🇧🇭",
    name: "Bahrain",
    alpha3: "bhr"
  },
  BI: {
    emoji: "🇧🇮",
    name: "Burundi",
    alpha3: "bdi"
  },
  BJ: {
    emoji: "🇧🇯",
    name: "Benin",
    alpha3: "ben"
  },
  BL: {
    emoji: "🇧🇱",
    name: "Saint Barthélemy",
    alpha3: "blm"
  },
  BM: {
    emoji: "🇧🇲",
    name: "Bermuda",
    alpha3: "bmu"
  },
  BN: {
    emoji: "🇧🇳",
    name: "Brunei Darussalam",
    alpha3: "brn"
  },
  BO: {
    emoji: "🇧🇴",
    name: "Bolivia",
    alpha3: "bol"
  },
  BR: {
    emoji: "🇧🇷",
    name: "Brazil",
    alpha3: "bra"
  },
  BS: {
    emoji: "🇧🇸",
    name: "Bahamas",
    alpha3: "bhs"
  },
  BT: {
    emoji: "🇧🇹",
    name: "Bhutan",
    alpha3: "btn"
  },
  BW: {
    emoji: "🇧🇼",
    name: "Botswana",
    alpha3: "bwa"
  },
  BY: {
    emoji: "🇧🇾",
    name: "Belarus",
    alpha3: "blr"
  },
  BZ: {
    emoji: "🇧🇿",
    name: "Belize",
    alpha3: "blz"
  },
  CA: {
    emoji: "🇨🇦",
    name: "Canada",
    alpha3: "can"
  },
  CC: {
    emoji: "🇨🇨",
    name: "Cocos (Keeling) Islands",
    alpha3: "cck"
  },
  CD: {
    emoji: "🇨🇩",
    name: "Congo (Democratic Republic)",
    alpha3: "cod"
  },
  CF: {
    emoji: "🇨🇫",
    name: "Central African Republic",
    alpha3: "caf"
  },
  CG: {
    emoji: "🇨🇬",
    name: "Congo",
    alpha3: "cog"
  },
  CH: {
    emoji: "🇨🇭",
    name: "Switzerland",
    alpha3: "che"
  },
  CI: {
    emoji: "🇨🇮",
    name: "Ivory Coast",
    alpha3: "civ"
  },
  CK: {
    emoji: "🇨🇰",
    name: "Cook Islands",
    alpha3: "cok"
  },
  CL: {
    emoji: "🇨🇱",
    name: "Chile",
    alpha3: "chl"
  },
  CM: {
    emoji: "🇨🇲",
    name: "Cameroon",
    alpha3: "cmr"
  },
  CN: {
    emoji: "🇨🇳",
    name: "China",
    alpha3: "chn"
  },
  CO: {
    emoji: "🇨🇴",
    name: "Colombia",
    alpha3: "col"
  },
  CR: {
    emoji: "🇨🇷",
    name: "Costa Rica",
    alpha3: "cri"
  },
  CU: {
    emoji: "🇨🇺",
    name: "Cuba",
    alpha3: "cub"
  },
  CV: {
    emoji: "🇨🇻",
    name: "Cape Verde",
    alpha3: "cpv"
  },
  CW: {
    emoji: "🇨🇼",
    name: "Curaçao",
    alpha3: "cuw"
  },
  CX: {
    emoji: "🇨🇽",
    name: "Christmas Island",
    alpha3: "cxr"
  },
  CY: {
    emoji: "🇨🇾",
    name: "Cyprus",
    alpha3: "cyp"
  },
  CZ: {
    emoji: "🇨🇿",
    name: "Czechia (The Czech Republic)",
    alpha3: "cze"
  },
  DE: {
    emoji: "🇩🇪",
    name: "Germany",
    alpha3: "deu"
  },
  DJ: {
    emoji: "🇩🇯",
    name: "Djibouti",
    alpha3: "dji"
  },
  DK: {
    emoji: "🇩🇰",
    name: "Denmark",
    alpha3: "dnk"
  },
  DM: {
    emoji: "🇩🇲",
    name: "Dominica",
    alpha3: "dma"
  },
  DO: {
    emoji: "🇩🇴",
    name: "Dominican Republic",
    alpha3: "dom"
  },
  DZ: {
    emoji: "🇩🇿",
    name: "Algeria",
    alpha3: "dza"
  },
  EC: {
    emoji: "🇪🇨",
    name: "Ecuador",
    alpha3: "ecu"
  },
  EE: {
    emoji: "🇪🇪",
    name: "Estonia",
    alpha3: "est"
  },
  EG: {
    emoji: "🇪🇬",
    name: "Egypt",
    alpha3: "egy"
  },
  EH: {
    emoji: "🇪🇭",
    name: "Western Sahara",
    alpha3: "esh"
  },
  ER: {
    emoji: "🇪🇷",
    name: "Eritrea",
    alpha3: "eri"
  },
  ES: {
    emoji: "🇪🇸",
    name: "Spain",
    alpha3: "esp"
  },
  ET: {
    emoji: "🇪🇹",
    name: "Ethiopia",
    alpha3: "eth"
  },
  FI: {
    emoji: "🇫🇮",
    name: "Finland",
    alpha3: "fin"
  },
  FJ: {
    emoji: "🇫🇯",
    name: "Fiji",
    alpha3: "fji"
  },
  FK: {
    emoji: "🇫🇰",
    name: "Falkland Islands",
    alpha3: "flk"
  },
  FM: {
    emoji: "🇫🇲",
    name: "Micronesia",
    alpha3: "fsm"
  },
  FO: {
    emoji: "🇫🇴",
    name: "Faroe Islands",
    alpha3: "fro"
  },
  FR: {
    emoji: "🇫🇷",
    name: "France",
    alpha3: "fra"
  },
  GA: {
    emoji: "🇬🇦",
    name: "Gabon",
    alpha3: "gab"
  },
  GB: {
    emoji: "🇬🇧",
    name: "United Kingdom",
    alpha3: "gbr"
  },
  GD: {
    emoji: "🇬🇩",
    name: "Grenada",
    alpha3: "grd"
  },
  GE: {
    emoji: "🇬🇪",
    name: "Georgia",
    alpha3: "geo"
  },
  GF: {
    emoji: "🇬🇫",
    name: "French Guiana",
    alpha3: "guf"
  },
  GG: {
    emoji: "🇬🇬",
    name: "Guernsey",
    alpha3: "ggy"
  },
  GH: {
    emoji: "🇬🇭",
    name: "Ghana",
    alpha3: "gha"
  },
  GI: {
    emoji: "🇬🇮",
    name: "Gibraltar",
    alpha3: "gib"
  },
  GL: {
    emoji: "🇬🇱",
    name: "Greenland",
    alpha3: "grl"
  },
  GM: {
    emoji: "🇬🇲",
    name: "Gambia",
    alpha3: "gmb"
  },
  GN: {
    emoji: "🇬🇳",
    name: "Guinea",
    alpha3: "gin"
  },
  GP: {
    emoji: "🇬🇵",
    name: "Guadeloupe",
    alpha3: "glp"
  },
  GQ: {
    emoji: "🇬🇶",
    name: "Equatorial Guinea",
    alpha3: "gnq"
  },
  GR: {
    emoji: "🇬🇷",
    name: "Greece",
    alpha3: "grc"
  },
  GT: {
    emoji: "🇬🇹",
    name: "Guatemala",
    alpha3: "gtm"
  },
  GU: {
    emoji: "🇬🇺",
    name: "Guam",
    alpha3: "gum"
  },
  GW: {
    emoji: "🇬🇼",
    name: "Guinea-Bissau",
    alpha3: "gnb"
  },
  GY: {
    emoji: "🇬🇾",
    name: "Guyana",
    alpha3: "guy"
  },
  HK: {
    emoji: "🇭🇰",
    name: "Hong Kong",
    alpha3: "hkg"
  },
  HN: {
    emoji: "🇭🇳",
    name: "Honduras",
    alpha3: "hnd"
  },
  HR: {
    emoji: "🇭🇷",
    name: "Croatia",
    alpha3: "hrv"
  },
  HT: {
    emoji: "🇭🇹",
    name: "Haiti",
    alpha3: "hti"
  },
  HU: {
    emoji: "🇭🇺",
    name: "Hungary",
    alpha3: "hun"
  },
  ID: {
    emoji: "🇮🇩",
    name: "Indonesia",
    alpha3: "idn"
  },
  IE: {
    emoji: "🇮🇪",
    name: "Ireland",
    alpha3: "irl"
  },
  IL: {
    emoji: "🇮🇱",
    name: "Israel",
    alpha3: "isr"
  },
  IM: {
    emoji: "🇮🇲",
    name: "Isle of Man",
    alpha3: "imn"
  },
  IN: {
    emoji: "🇮🇳",
    name: "India",
    alpha3: "ind"
  },
  IO: {
    emoji: "🇮🇴",
    name: "British Indian Ocean Territory",
    alpha3: "iot"
  },
  IQ: {
    emoji: "🇮🇶",
    name: "Iraq",
    alpha3: "irq"
  },
  IR: {
    emoji: "🇮🇷",
    name: "Iran",
    alpha3: "irn"
  },
  IS: {
    emoji: "🇮🇸",
    name: "Iceland",
    alpha3: "isl"
  },
  IT: {
    emoji: "🇮🇹",
    name: "Italy",
    alpha3: "ita"
  },
  JE: {
    emoji: "🇯🇪",
    name: "Jersey",
    alpha3: "jey"
  },
  JM: {
    emoji: "🇯🇲",
    name: "Jamaica",
    alpha3: "jam"
  },
  JO: {
    emoji: "🇯🇴",
    name: "Jordan",
    alpha3: "jor"
  },
  JP: {
    emoji: "🇯🇵",
    name: "Japan",
    alpha3: "jpn"
  },
  KE: {
    emoji: "🇰🇪",
    name: "Kenya",
    alpha3: "ken"
  },
  KG: {
    emoji: "🇰🇬",
    name: "Kyrgyzstan",
    alpha3: "kgz"
  },
  KH: {
    emoji: "🇰🇭",
    name: "Cambodia",
    alpha3: "khm"
  },
  KI: {
    emoji: "🇰🇮",
    name: "Kiribati",
    alpha3: "kir"
  },
  KM: {
    emoji: "🇰🇲",
    name: "Comoros",
    alpha3: "com"
  },
  KN: {
    emoji: "🇰🇳",
    name: "Saint Kitts and Nevis",
    alpha3: "kna"
  },
  KR: {
    emoji: "🇰🇷",
    name: "Korea (the Republic of)",
    alpha3: "kor"
  },
  KW: {
    emoji: "🇰🇼",
    name: "Kuwait",
    alpha3: "kwt"
  },
  KY: {
    emoji: "🇰🇾",
    name: "Cayman Islands",
    alpha3: "cym"
  },
  KZ: {
    emoji: "🇰🇿",
    name: "Kazakhstan",
    alpha3: "kaz"
  },
  LB: {
    emoji: "🇱🇧",
    name: "Lebanon",
    alpha3: "lbn"
  },
  LC: {
    emoji: "🇱🇨",
    name: "Saint Lucia",
    alpha3: "lca"
  },
  LI: {
    emoji: "🇱🇮",
    name: "Liechtenstein",
    alpha3: "lie"
  },
  LK: {
    emoji: "🇱🇰",
    name: "Sri Lanka",
    alpha3: "lka"
  },
  LR: {
    emoji: "🇱🇷",
    name: "Liberia",
    alpha3: "lbr"
  },
  LS: {
    emoji: "🇱🇸",
    name: "Lesotho",
    alpha3: "lso"
  },
  LT: {
    emoji: "🇱🇹",
    name: "Lithuania",
    alpha3: "ltu"
  },
  LU: {
    emoji: "🇱🇺",
    name: "Luxembourg",
    alpha3: "lux"
  },
  LV: {
    emoji: "🇱🇻",
    name: "Latvia",
    alpha3: "lva"
  },
  LY: {
    emoji: "🇱🇾",
    name: "Libya",
    alpha3: "lby"
  },
  MA: {
    emoji: "🇲🇦",
    name: "Morocco",
    alpha3: "mar"
  },
  MC: {
    emoji: "🇲🇨",
    name: "Monaco",
    alpha3: "mco"
  },
  MD: {
    emoji: "🇲🇩",
    name: "Moldova",
    alpha3: "mda"
  },
  ME: {
    emoji: "🇲🇪",
    name: "Montenegro",
    alpha3: "mne"
  },
  MF: {
    emoji: "🇲🇫",
    name: "Saint Martin",
    alpha3: "maf"
  },
  MG: {
    emoji: "🇲🇬",
    name: "Madagascar",
    alpha3: "mdg"
  },
  MH: {
    emoji: "🇲🇭",
    name: "Marshall Islands",
    alpha3: "mhl"
  },
  MK: {
    emoji: "🇲🇰",
    name: "Macedonia",
    alpha3: "mkd"
  },
  ML: {
    emoji: "🇲🇱",
    name: "Mali",
    alpha3: "mli"
  },
  MM: {
    emoji: "🇲🇲",
    name: "Myanmar",
    alpha3: "mmr"
  },
  MN: {
    emoji: "🇲🇳",
    name: "Mongolia",
    alpha3: "mng"
  },
  MO: {
    emoji: "🇲🇴",
    name: "Macao",
    alpha3: "mac"
  },
  MP: {
    emoji: "🇲🇵",
    name: "Northern Mariana Islands",
    alpha3: "mnp"
  },
  MQ: {
    emoji: "🇲🇶",
    name: "Martinique",
    alpha3: "mtq"
  },
  MR: {
    emoji: "🇲🇷",
    name: "Mauritania",
    alpha3: "mrt"
  },
  MS: {
    emoji: "🇲🇸",
    name: "Montserrat",
    alpha3: "msr"
  },
  MT: {
    emoji: "🇲🇹",
    name: "Malta",
    alpha3: "mlt"
  },
  MU: {
    emoji: "🇲🇺",
    name: "Mauritius",
    alpha3: "mus"
  },
  MV: {
    emoji: "🇲🇻",
    name: "Maldives",
    alpha3: "mdv"
  },
  MW: {
    emoji: "🇲🇼",
    name: "Malawi",
    alpha3: "mwi"
  },
  MY: {
    emoji: "🇲🇾",
    name: "Malaysia",
    alpha3: "mys"
  },
  MZ: {
    emoji: "🇲🇿",
    name: "Mozambique",
    alpha3: "moz"
  },
  NA: {
    emoji: "🇳🇦",
    name: "Namibia",
    alpha3: "nam"
  },
  NC: {
    emoji: "🇳🇨",
    name: "New Caledonia",
    alpha3: "ncl"
  },
  NE: {
    emoji: "🇳🇪",
    name: "Niger",
    alpha3: "ner"
  },
  NF: {
    emoji: "🇳🇫",
    name: "Norfolk Island",
    alpha3: "nfk"
  },
  NG: {
    emoji: "🇳🇬",
    name: "Nigeria",
    alpha3: "nga"
  },
  NI: {
    emoji: "🇳🇮",
    name: "Nicaragua",
    alpha3: "nic"
  },
  NL: {
    emoji: "🇳🇱",
    name: "Netherlands",
    alpha3: "nld"
  },
  NO: {
    emoji: "🇳🇴",
    name: "Norway",
    alpha3: "nor"
  },
  NP: {
    emoji: "🇳🇵",
    name: "Nepal",
    alpha3: "npl"
  },
  NR: {
    emoji: "🇳🇷",
    name: "Nauru",
    alpha3: "nru"
  },
  NU: {
    emoji: "🇳🇺",
    name: "Niue",
    alpha3: "niu"
  },
  NZ: {
    emoji: "🇳🇿",
    name: "New Zealand",
    alpha3: "nzl"
  },
  OM: {
    emoji: "🇴🇲",
    name: "Oman",
    alpha3: "omn"
  },
  PA: {
    emoji: "🇵🇦",
    name: "Panama",
    alpha3: "pan"
  },
  PE: {
    emoji: "🇵🇪",
    name: "Peru",
    alpha3: "per"
  },
  PF: {
    emoji: "🇵🇫",
    name: "French Polynesia",
    alpha3: "pyf"
  },
  PG: {
    emoji: "🇵🇬",
    name: "Papua New Guinea",
    alpha3: "png"
  },
  PH: {
    emoji: "🇵🇭",
    name: "Philippines",
    alpha3: "phl"
  },
  PK: {
    emoji: "🇵🇰",
    name: "Pakistan",
    alpha3: "pak"
  },
  PL: {
    emoji: "🇵🇱",
    name: "Poland",
    alpha3: "pol"
  },
  PM: {
    emoji: "🇵🇲",
    name: "Saint Pierre and Miquelon",
    alpha3: "spm"
  },
  PR: {
    emoji: "🇵🇷",
    name: "Puerto Rico",
    alpha3: "pri"
  },
  PS: {
    emoji: "🇵🇸",
    name: "Palestine",
    alpha3: "pse"
  },
  PT: {
    emoji: "🇵🇹",
    name: "Portugal",
    alpha3: "prt"
  },
  PW: {
    emoji: "🇵🇼",
    name: "Palau",
    alpha3: "plw"
  },
  PY: {
    emoji: "🇵🇾",
    name: "Paraguay",
    alpha3: "pry"
  },
  QA: {
    emoji: "🇶🇦",
    name: "Qatar",
    alpha3: "qat"
  },
  RE: {
    emoji: "🇷🇪",
    name: "Réunion",
    alpha3: "reu"
  },
  RO: {
    emoji: "🇷🇴",
    name: "Romania",
    alpha3: "rou"
  },
  RU: {
    emoji: "🇷🇺",
    name: "Russia",
    alpha3: "rus"
  },
  RW: {
    emoji: "🇷🇼",
    name: "Rwanda",
    alpha3: "rwa"
  },
  SA: {
    emoji: "🇸🇦",
    name: "Saudi Arabia",
    alpha3: "sau"
  },
  SB: {
    emoji: "🇸🇧",
    name: "Solomon Islands",
    alpha3: "slb"
  },
  SC: {
    emoji: "🇸🇨",
    name: "Seychelles",
    alpha3: "syc"
  },
  SD: {
    emoji: "🇸🇩",
    name: "Sudan",
    alpha3: "sdn"
  },
  SE: {
    emoji: "🇸🇪",
    name: "Sweden",
    alpha3: "swe"
  },
  SG: {
    emoji: "🇸🇬",
    name: "Singapore",
    alpha3: "sgp"
  },
  SH: {
    emoji: "🇸🇭",
    name: "Saint Helena",
    alpha3: "shn"
  },
  SI: {
    emoji: "🇸🇮",
    name: "Slovenia",
    alpha3: "svn"
  },
  SJ: {
    emoji: "🇸🇯",
    name: "Svalbard and Jan Mayen",
    alpha3: "sjm"
  },
  SK: {
    emoji: "🇸🇰",
    name: "Slovakia",
    alpha3: "svk"
  },
  SL: {
    emoji: "🇸🇱",
    name: "Sierra Leone",
    alpha3: "sle"
  },
  SM: {
    emoji: "🇸🇲",
    name: "San Marino",
    alpha3: "smr"
  },
  SN: {
    emoji: "🇸🇳",
    name: "Senegal",
    alpha3: "sen"
  },
  SO: {
    emoji: "🇸🇴",
    name: "Somalia",
    alpha3: "som"
  },
  SS: {
    emoji: "🇸🇩",
    name: "South Sudan",
    alpha3: "ssd"
  },
  ST: {
    emoji: "🇸🇹",
    name: "Sao Tome and Principe",
    alpha3: "stp"
  },
  SV: {
    emoji: "🇸🇻",
    name: "El Salvador",
    alpha3: "slv"
  },
  SX: {
    emoji: "🇸🇽",
    name: "Sint Maarten",
    alpha3: "sxm"
  },
  SY: {
    emoji: "🇸🇾",
    name: "Syrian",
    alpha3: "syr"
  },
  SZ: {
    emoji: "🇸🇿",
    name: "Swaziland",
    alpha3: "swz"
  },
  TA: {
    emoji: "🇹🇦",
    name: "Tristan da Cunha",
    alpha3: null
  },
  TC: {
    emoji: "🇹🇨",
    name: "Turks and Caicos Islands",
    alpha3: "tca"
  },
  TD: {
    emoji: "🇹🇩",
    name: "Chad",
    alpha3: "tcd"
  },
  TG: {
    emoji: "🇹🇬",
    name: "Togo",
    alpha3: "tgo"
  },
  TH: {
    emoji: "🇹🇭",
    name: "Thailand",
    alpha3: "tha"
  },
  TJ: {
    emoji: "🇹🇯",
    name: "Tajikistan",
    alpha3: "tjk"
  },
  TK: {
    emoji: "🇹🇰",
    name: "Tokelau",
    alpha3: "tkl"
  },
  TL: {
    emoji: "🇹🇱",
    name: "Timor-Leste",
    alpha3: "tls"
  },
  TM: {
    emoji: "🇹🇲",
    name: "Turkmenistan",
    alpha3: "tkm"
  },
  TN: {
    emoji: "🇹🇳",
    name: "Tunisia",
    alpha3: "tun"
  },
  TO: {
    emoji: "🇹🇴",
    name: "Tonga",
    alpha3: "ton"
  },
  TR: {
    emoji: "🇹🇷",
    name: "Turkey",
    alpha3: "tur"
  },
  TT: {
    emoji: "🇹🇹",
    name: "Trinidad and Tobago",
    alpha3: "tto"
  },
  TV: {
    emoji: "🇹🇻",
    name: "Tuvalu",
    alpha3: "tuv"
  },
  TW: {
    emoji: "🇹🇼",
    name: "Taiwan",
    alpha3: "twn"
  },
  TZ: {
    emoji: "🇹🇿",
    name: "Tanzania",
    alpha3: "tza"
  },
  UA: {
    emoji: "🇺🇦",
    name: "Ukraine",
    alpha3: "ukr"
  },
  UG: {
    emoji: "🇺🇬",
    name: "Uganda",
    alpha3: "uga"
  },
  UY: {
    emoji: "🇺🇾",
    name: "Uruguay",
    alpha3: "ury"
  },
  UZ: {
    emoji: "🇺🇿",
    name: "Uzbekistan",
    alpha3: "uzb"
  },
  VA: {
    emoji: "🇻🇦",
    name: "Holy See",
    alpha3: "vat"
  },
  VC: {
    emoji: "🇻🇨",
    name: "Saint Vincent and the Grenadines",
    alpha3: "vct"
  },
  VE: {
    emoji: "🇻🇪",
    name: "Venezuela",
    alpha3: "ven"
  },
  VG: {
    emoji: "🇻🇬",
    name: "Virgin Islands (British)",
    alpha3: "vgb"
  },
  VI: {
    emoji: "🇻🇮",
    name: "Virgin Islands",
    alpha3: "vir"
  },
  VN: {
    emoji: "🇻🇳",
    name: "Vietnam",
    alpha3: "vnm"
  },
  VU: {
    emoji: "🇻🇺",
    name: "Vanuatu",
    alpha3: "vut"
  },
  WF: {
    emoji: "🇼🇫",
    name: "Wallis and Futuna",
    alpha3: "wlf"
  },
  WS: {
    emoji: "🇼🇸",
    name: "Samoa",
    alpha3: "wsm"
  },
  YE: {
    emoji: "🇾🇪",
    name: "Yemen",
    alpha3: "yem"
  },
  YT: {
    emoji: "🇾🇹",
    name: "Mayotte",
    alpha3: "myt"
  },
  ZA: {
    emoji: "🇿🇦",
    name: "South Africa",
    alpha3: "zaf"
  },
  ZM: {
    emoji: "🇿🇲",
    name: "Zambia",
    alpha3: "zmb"
  },
  ZW: {
    emoji: "🇿🇼",
    name: "Zimbabwe",
    alpha3: "zwe"
  }
}, metadata = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|22"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "[24-689]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]]], BL: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "(?:[2-467]\\d\\d|8001)\\d{5}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "[189]\\d{8}|[1-68]\\d{6}", [7, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "10(?:10|9[56])|2[0-57-9](?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}", [10, 11], [["(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[12]00|[368]|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-79])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "[56]94\\d{6}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[4-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(8-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", 1]], "8", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|9)|8(?:0[89]|92)", "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-2]|5[01]|8[0-3]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "596\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "1(?:(?:[27]2|44|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}", [10, 11], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], 0, 1], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], 0, 1], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], 0, 1]], "01", 0, "0(?:[12]|4[45])|1", 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[047]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}", [7, 8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|80\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-6])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[2378]\\d|62|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "(?:[1-6]|[7-9]\\d\\d)\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "800\\d{4}|(?:[249]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-8]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|77|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[69]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "[1-6]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:5056(?:[0-35-9]\\d|4[468])|73020\\d)\\d{4}|(?:4722|505[2-57-9]|983[289])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[0149]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "810", "(?:20|33|[5-79]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|5[0-4]|6\\d|[78]0)\\d{4}"], ["639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, 0, 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function withMetadataArgument(me, ue) {
  var Qe = Array.prototype.slice.call(ue);
  return Qe.push(metadata), me.apply(this, Qe);
}
function _typeof$7(me) {
  "@babel/helpers - typeof";
  return _typeof$7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ue) {
    return typeof ue;
  } : function(ue) {
    return ue && typeof Symbol == "function" && ue.constructor === Symbol && ue !== Symbol.prototype ? "symbol" : typeof ue;
  }, _typeof$7(me);
}
function _createClass$j(me, ue, Qe) {
  return Object.defineProperty(me, "prototype", { writable: !1 }), me;
}
function _classCallCheck$k(me, ue) {
  if (!(me instanceof ue))
    throw new TypeError("Cannot call a class as a function");
}
function _inherits$b(me, ue) {
  if (typeof ue != "function" && ue !== null)
    throw new TypeError("Super expression must either be null or a function");
  me.prototype = Object.create(ue && ue.prototype, { constructor: { value: me, writable: !0, configurable: !0 } }), Object.defineProperty(me, "prototype", { writable: !1 }), ue && _setPrototypeOf(me, ue);
}
function _createSuper(me) {
  var ue = _isNativeReflectConstruct();
  return function() {
    var Ue = _getPrototypeOf(me), He;
    if (ue) {
      var Ge = _getPrototypeOf(this).constructor;
      He = Reflect.construct(Ue, arguments, Ge);
    } else
      He = Ue.apply(this, arguments);
    return _possibleConstructorReturn$b(this, He);
  };
}
function _possibleConstructorReturn$b(me, ue) {
  if (ue && (_typeof$7(ue) === "object" || typeof ue == "function"))
    return ue;
  if (ue !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(me);
}
function _assertThisInitialized(me) {
  if (me === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return me;
}
function _wrapNativeSuper(me) {
  var ue = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return _wrapNativeSuper = function(Ue) {
    if (Ue === null || !_isNativeFunction(Ue)) return Ue;
    if (typeof Ue != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof ue < "u") {
      if (ue.has(Ue)) return ue.get(Ue);
      ue.set(Ue, He);
    }
    function He() {
      return _construct(Ue, arguments, _getPrototypeOf(this).constructor);
    }
    return He.prototype = Object.create(Ue.prototype, { constructor: { value: He, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(He, Ue);
  }, _wrapNativeSuper(me);
}
function _construct(me, ue, Qe) {
  return _isNativeReflectConstruct() ? _construct = Reflect.construct : _construct = function(He, Ge, Xe) {
    var Ke = [null];
    Ke.push.apply(Ke, Ge);
    var $e = Function.bind.apply(He, Ke), Je = new $e();
    return Xe && _setPrototypeOf(Je, Xe.prototype), Je;
  }, _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _isNativeFunction(me) {
  return Function.toString.call(me).indexOf("[native code]") !== -1;
}
function _setPrototypeOf(me, ue) {
  return _setPrototypeOf = Object.setPrototypeOf || function(Ue, He) {
    return Ue.__proto__ = He, Ue;
  }, _setPrototypeOf(me, ue);
}
function _getPrototypeOf(me) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function(Qe) {
    return Qe.__proto__ || Object.getPrototypeOf(Qe);
  }, _getPrototypeOf(me);
}
var ParseError = /* @__PURE__ */ function(me) {
  _inherits$b(Qe, me);
  var ue = _createSuper(Qe);
  function Qe(Ue) {
    var He;
    return _classCallCheck$k(this, Qe), He = ue.call(this, Ue), Object.setPrototypeOf(_assertThisInitialized(He), Qe.prototype), He.name = He.constructor.name, He;
  }
  return _createClass$j(Qe);
}(/* @__PURE__ */ _wrapNativeSuper(Error)), MIN_LENGTH_FOR_NSN = 2, MAX_LENGTH_FOR_NSN = 17, MAX_LENGTH_COUNTRY_CODE = 3, VALID_DIGITS = "0-9０-９٠-٩۰-۹", DASHES = "-‐-―−ー－", SLASHES = "／/", DOTS = "．.", WHITESPACE = "  ­​⁠　", BRACKETS = "()（）［］\\[\\]", TILDES = "~⁓∼～", VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES), PLUS_CHARS = "+＋";
function compare(me, ue) {
  me = me.split("-"), ue = ue.split("-");
  for (var Qe = me[0].split("."), Ue = ue[0].split("."), He = 0; He < 3; He++) {
    var Ge = Number(Qe[He]), Xe = Number(Ue[He]);
    if (Ge > Xe) return 1;
    if (Xe > Ge) return -1;
    if (!isNaN(Ge) && isNaN(Xe)) return 1;
    if (isNaN(Ge) && !isNaN(Xe)) return -1;
  }
  return me[1] && ue[1] ? me[1] > ue[1] ? 1 : me[1] < ue[1] ? -1 : 0 : !me[1] && ue[1] ? 1 : me[1] && !ue[1] ? -1 : 0;
}
var objectConstructor = {}.constructor;
function isObject$7(me) {
  return me != null && me.constructor === objectConstructor;
}
function _typeof$6(me) {
  "@babel/helpers - typeof";
  return _typeof$6 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ue) {
    return typeof ue;
  } : function(ue) {
    return ue && typeof Symbol == "function" && ue.constructor === Symbol && ue !== Symbol.prototype ? "symbol" : typeof ue;
  }, _typeof$6(me);
}
function _classCallCheck$j(me, ue) {
  if (!(me instanceof ue))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$7(me, ue) {
  for (var Qe = 0; Qe < ue.length; Qe++) {
    var Ue = ue[Qe];
    Ue.enumerable = Ue.enumerable || !1, Ue.configurable = !0, "value" in Ue && (Ue.writable = !0), Object.defineProperty(me, Ue.key, Ue);
  }
}
function _createClass$i(me, ue, Qe) {
  return ue && _defineProperties$7(me.prototype, ue), Object.defineProperty(me, "prototype", { writable: !1 }), me;
}
var V3 = "1.2.0", V4 = "1.7.35", DEFAULT_EXT_PREFIX = " ext. ", CALLING_CODE_REG_EXP = /^\d+$/, Metadata$1 = /* @__PURE__ */ function() {
  function me(ue) {
    _classCallCheck$j(this, me), validateMetadata(ue), this.metadata = ue, setVersion.call(this, ue);
  }
  return _createClass$i(me, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(Qe) {
        return Qe !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(Qe) {
      return this.metadata.countries[Qe];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(Qe) {
      return this.getCountryMetadata(Qe) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(Qe) {
      if (this.getCountryCodesForCallingCode(Qe))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[Qe])
          return !0;
      } else {
        var Ue = this.countryCallingCodes()[Qe];
        if (Ue && Ue.length === 1 && Ue[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(Qe) {
      return this.nonGeographic() ? !!this.nonGeographic()[Qe] : !this.getCountryCodesForCallingCode(Qe);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(Qe) {
      return this.selectNumberingPlan(Qe);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(Qe, Ue) {
      if (Qe && CALLING_CODE_REG_EXP.test(Qe) && (Ue = Qe, Qe = null), Qe && Qe !== "001") {
        if (!this.hasCountry(Qe))
          throw new Error("Unknown country: ".concat(Qe));
        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(Qe), this);
      } else if (Ue) {
        if (!this.hasCallingCode(Ue))
          throw new Error("Unknown calling code: ".concat(Ue));
        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(Ue), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(Qe) {
      var Ue = this.countryCallingCodes()[Qe];
      if (Ue)
        return Ue.length === 1 && Ue[0].length === 3 ? void 0 : Ue;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(Qe) {
      var Ue = this.getCountryCodesForCallingCode(Qe);
      if (Ue)
        return Ue[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(Qe) {
      var Ue = this.getCountryCodeForCallingCode(Qe);
      if (Ue)
        return this.getCountryMetadata(Ue);
      if (this.nonGeographic()) {
        var He = this.nonGeographic()[Qe];
        if (He)
          return He;
      } else {
        var Ge = this.countryCallingCodes()[Qe];
        if (Ge && Ge.length === 1 && Ge[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(Qe) {
      return this.numberingPlan.type(Qe);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(Qe) {
      return this.selectNumberingPlan(Qe);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), me;
}(), NumberingPlan = /* @__PURE__ */ function() {
  function me(ue, Qe) {
    _classCallCheck$j(this, me), this.globalMetadataObject = Qe, this.metadata = ue, setVersion.call(this, Qe.metadata);
  }
  return _createClass$i(me, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(Qe) {
      return Qe[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var Qe = this, Ue = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return Ue.map(function(He) {
        return new Format(He, Qe);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(Qe) {
      return Qe[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(Qe) {
      if (this.hasTypes() && getType(this.types(), Qe))
        return new Type(getType(this.types(), Qe), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? DEFAULT_EXT_PREFIX : this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]), me;
}(), Format = /* @__PURE__ */ function() {
  function me(ue, Qe) {
    _classCallCheck$j(this, me), this._format = ue, this.metadata = Qe;
  }
  return _createClass$i(me, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), me;
}(), FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/, Type = /* @__PURE__ */ function() {
  function me(ue, Qe) {
    _classCallCheck$j(this, me), this.type = ue, this.metadata = Qe;
  }
  return _createClass$i(me, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), me;
}();
function getType(me, ue) {
  switch (ue) {
    case "FIXED_LINE":
      return me[0];
    case "MOBILE":
      return me[1];
    case "TOLL_FREE":
      return me[2];
    case "PREMIUM_RATE":
      return me[3];
    case "PERSONAL_NUMBER":
      return me[4];
    case "VOICEMAIL":
      return me[5];
    case "UAN":
      return me[6];
    case "PAGER":
      return me[7];
    case "VOIP":
      return me[8];
    case "SHARED_COST":
      return me[9];
  }
}
function validateMetadata(me) {
  if (!me)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!isObject$7(me) || !isObject$7(me.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(isObject$7(me) ? "an object of shape: { " + Object.keys(me).join(", ") + " }" : "a " + typeOf$1(me) + ": " + me, "."));
}
var typeOf$1 = function(ue) {
  return _typeof$6(ue);
};
function getCountryCallingCode$1(me, ue) {
  if (ue = new Metadata$1(ue), ue.hasCountry(me))
    return ue.country(me).countryCallingCode();
  throw new Error("Unknown country: ".concat(me));
}
function isSupportedCountry(me, ue) {
  return ue.countries.hasOwnProperty(me);
}
function setVersion(me) {
  var ue = me.version;
  typeof ue == "number" ? (this.v1 = ue === 1, this.v2 = ue === 2, this.v3 = ue === 3, this.v4 = ue === 4) : ue ? compare(ue, V3) === -1 ? this.v2 = !0 : compare(ue, V4) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
var RFC3966_EXTN_PREFIX = ";ext=", getExtensionDigitsPattern = function(ue) {
  return "([".concat(VALID_DIGITS, "]{1,").concat(ue, "})");
};
function createExtensionPattern(me) {
  var ue = "20", Qe = "15", Ue = "9", He = "6", Ge = "[  \\t,]*", Xe = "[:\\.．]?[  \\t,-]*", Ke = "#?", $e = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", Je = "(?:[xｘ#＃~～]|int|ｉｎｔ)", Ze = "[- ]+", nt = "[  \\t]*", tt = "(?:,{2}|;)", et = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(ue), rt = Ge + $e + Xe + getExtensionDigitsPattern(ue) + Ke, it = Ge + Je + Xe + getExtensionDigitsPattern(Ue) + Ke, ot = Ze + getExtensionDigitsPattern(He) + "#", at = nt + tt + Xe + getExtensionDigitsPattern(Qe) + Ke, st = nt + "(?:,)+" + Xe + getExtensionDigitsPattern(Ue) + Ke;
  return et + "|" + rt + "|" + it + "|" + ot + "|" + at + "|" + st;
}
var MIN_LENGTH_PHONE_NUMBER_PATTERN = "[" + VALID_DIGITS + "]{" + MIN_LENGTH_FOR_NSN + "}", VALID_PHONE_NUMBER = "[" + PLUS_CHARS + "]{0,1}(?:[" + VALID_PUNCTUATION + "]*[" + VALID_DIGITS + "]){3,}[" + VALID_PUNCTUATION + VALID_DIGITS + "]*", VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + PLUS_CHARS + "]{0,1}(?:[" + VALID_PUNCTUATION + "]*[" + VALID_DIGITS + "]){1,2}$", "i"), VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + // Phone number extensions
"(?:" + createExtensionPattern() + ")?", VALID_PHONE_NUMBER_PATTERN = new RegExp(
  // Either a short two-digit-only phone number
  "^" + MIN_LENGTH_PHONE_NUMBER_PATTERN + "$|^" + VALID_PHONE_NUMBER_WITH_EXTENSION + "$",
  "i"
);
function isViablePhoneNumber(me) {
  return me.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(me);
}
function isViablePhoneNumberStart(me) {
  return VALID_PHONE_NUMBER_START_REG_EXP.test(me);
}
var EXTN_PATTERN = new RegExp("(?:" + createExtensionPattern() + ")$", "i");
function extractExtension(me) {
  var ue = me.search(EXTN_PATTERN);
  if (ue < 0)
    return {};
  for (var Qe = me.slice(0, ue), Ue = me.match(EXTN_PATTERN), He = 1; He < Ue.length; ) {
    if (Ue[He])
      return {
        number: Qe,
        ext: Ue[He]
      };
    He++;
  }
}
function _createForOfIteratorHelperLoose$7(me, ue) {
  var Qe = typeof Symbol < "u" && me[Symbol.iterator] || me["@@iterator"];
  if (Qe) return (Qe = Qe.call(me)).next.bind(Qe);
  if (Array.isArray(me) || (Qe = _unsupportedIterableToArray$a(me)) || ue) {
    Qe && (me = Qe);
    var Ue = 0;
    return function() {
      return Ue >= me.length ? { done: !0 } : { done: !1, value: me[Ue++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$a(me, ue) {
  if (me) {
    if (typeof me == "string") return _arrayLikeToArray$a(me, ue);
    var Qe = Object.prototype.toString.call(me).slice(8, -1);
    if (Qe === "Object" && me.constructor && (Qe = me.constructor.name), Qe === "Map" || Qe === "Set") return Array.from(me);
    if (Qe === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Qe)) return _arrayLikeToArray$a(me, ue);
  }
}
function _arrayLikeToArray$a(me, ue) {
  (ue == null || ue > me.length) && (ue = me.length);
  for (var Qe = 0, Ue = new Array(ue); Qe < ue; Qe++)
    Ue[Qe] = me[Qe];
  return Ue;
}
var DIGITS = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function parseDigit(me) {
  return DIGITS[me];
}
function parseDigits(me) {
  for (var ue = "", Qe = _createForOfIteratorHelperLoose$7(me.split("")), Ue; !(Ue = Qe()).done; ) {
    var He = Ue.value, Ge = parseDigit(He);
    Ge && (ue += Ge);
  }
  return ue;
}
function _createForOfIteratorHelperLoose$6(me, ue) {
  var Qe = typeof Symbol < "u" && me[Symbol.iterator] || me["@@iterator"];
  if (Qe) return (Qe = Qe.call(me)).next.bind(Qe);
  if (Array.isArray(me) || (Qe = _unsupportedIterableToArray$9(me)) || ue) {
    Qe && (me = Qe);
    var Ue = 0;
    return function() {
      return Ue >= me.length ? { done: !0 } : { done: !1, value: me[Ue++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$9(me, ue) {
  if (me) {
    if (typeof me == "string") return _arrayLikeToArray$9(me, ue);
    var Qe = Object.prototype.toString.call(me).slice(8, -1);
    if (Qe === "Object" && me.constructor && (Qe = me.constructor.name), Qe === "Map" || Qe === "Set") return Array.from(me);
    if (Qe === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Qe)) return _arrayLikeToArray$9(me, ue);
  }
}
function _arrayLikeToArray$9(me, ue) {
  (ue == null || ue > me.length) && (ue = me.length);
  for (var Qe = 0, Ue = new Array(ue); Qe < ue; Qe++)
    Ue[Qe] = me[Qe];
  return Ue;
}
function parseIncompletePhoneNumber(me) {
  for (var ue = "", Qe = _createForOfIteratorHelperLoose$6(me.split("")), Ue; !(Ue = Qe()).done; ) {
    var He = Ue.value;
    ue += parsePhoneNumberCharacter(He, ue) || "";
  }
  return ue;
}
function parsePhoneNumberCharacter(me, ue) {
  return me === "+" ? ue ? void 0 : "+" : parseDigit(me);
}
function checkNumberLength(me, ue) {
  return checkNumberLengthForType(me, void 0, ue);
}
function checkNumberLengthForType(me, ue, Qe) {
  var Ue = Qe.type(ue), He = Ue && Ue.possibleLengths() || Qe.possibleLengths();
  if (!He)
    return "IS_POSSIBLE";
  var Ge = me.length, Xe = He[0];
  return Xe === Ge ? "IS_POSSIBLE" : Xe > Ge ? "TOO_SHORT" : He[He.length - 1] < Ge ? "TOO_LONG" : He.indexOf(Ge, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function isPossiblePhoneNumber(me, ue, Qe) {
  if (ue === void 0 && (ue = {}), Qe = new Metadata$1(Qe), ue.v2) {
    if (!me.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    Qe.selectNumberingPlan(me.countryCallingCode);
  } else {
    if (!me.phone)
      return !1;
    if (me.country) {
      if (!Qe.hasCountry(me.country))
        throw new Error("Unknown country: ".concat(me.country));
      Qe.country(me.country);
    } else {
      if (!me.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      Qe.selectNumberingPlan(me.countryCallingCode);
    }
  }
  if (Qe.possibleLengths())
    return isPossibleNumber(me.phone || me.nationalNumber, Qe);
  if (me.countryCallingCode && Qe.isNonGeographicCallingCode(me.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function isPossibleNumber(me, ue) {
  switch (checkNumberLength(me, ue)) {
    case "IS_POSSIBLE":
      return !0;
    default:
      return !1;
  }
}
function matchesEntirely(me, ue) {
  return me = me || "", new RegExp("^(?:" + ue + ")$").test(me);
}
function _createForOfIteratorHelperLoose$5(me, ue) {
  var Qe = typeof Symbol < "u" && me[Symbol.iterator] || me["@@iterator"];
  if (Qe) return (Qe = Qe.call(me)).next.bind(Qe);
  if (Array.isArray(me) || (Qe = _unsupportedIterableToArray$8(me)) || ue) {
    Qe && (me = Qe);
    var Ue = 0;
    return function() {
      return Ue >= me.length ? { done: !0 } : { done: !1, value: me[Ue++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$8(me, ue) {
  if (me) {
    if (typeof me == "string") return _arrayLikeToArray$8(me, ue);
    var Qe = Object.prototype.toString.call(me).slice(8, -1);
    if (Qe === "Object" && me.constructor && (Qe = me.constructor.name), Qe === "Map" || Qe === "Set") return Array.from(me);
    if (Qe === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Qe)) return _arrayLikeToArray$8(me, ue);
  }
}
function _arrayLikeToArray$8(me, ue) {
  (ue == null || ue > me.length) && (ue = me.length);
  for (var Qe = 0, Ue = new Array(ue); Qe < ue; Qe++)
    Ue[Qe] = me[Qe];
  return Ue;
}
var NON_FIXED_LINE_PHONE_TYPES = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function getNumberType(me, ue, Qe) {
  if (ue = ue || {}, !(!me.country && !me.countryCallingCode)) {
    Qe = new Metadata$1(Qe), Qe.selectNumberingPlan(me.country, me.countryCallingCode);
    var Ue = ue.v2 ? me.nationalNumber : me.phone;
    if (matchesEntirely(Ue, Qe.nationalNumberPattern())) {
      if (isNumberTypeEqualTo(Ue, "FIXED_LINE", Qe))
        return Qe.type("MOBILE") && Qe.type("MOBILE").pattern() === "" || !Qe.type("MOBILE") || isNumberTypeEqualTo(Ue, "MOBILE", Qe) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var He = _createForOfIteratorHelperLoose$5(NON_FIXED_LINE_PHONE_TYPES), Ge; !(Ge = He()).done; ) {
        var Xe = Ge.value;
        if (isNumberTypeEqualTo(Ue, Xe, Qe))
          return Xe;
      }
    }
  }
}
function isNumberTypeEqualTo(me, ue, Qe) {
  return ue = Qe.type(ue), !ue || !ue.pattern() || ue.possibleLengths() && ue.possibleLengths().indexOf(me.length) < 0 ? !1 : matchesEntirely(me, ue.pattern());
}
function isValidNumber(me, ue, Qe) {
  if (ue = ue || {}, Qe = new Metadata$1(Qe), Qe.selectNumberingPlan(me.country, me.countryCallingCode), Qe.hasTypes())
    return getNumberType(me, ue, Qe.metadata) !== void 0;
  var Ue = ue.v2 ? me.nationalNumber : me.phone;
  return matchesEntirely(Ue, Qe.nationalNumberPattern());
}
function getPossibleCountriesForNumber(me, ue, Qe) {
  var Ue = new Metadata$1(Qe), He = Ue.getCountryCodesForCallingCode(me);
  return He ? He.filter(function(Ge) {
    return couldNationalNumberBelongToCountry(ue, Ge, Qe);
  }) : [];
}
function couldNationalNumberBelongToCountry(me, ue, Qe) {
  var Ue = new Metadata$1(Qe);
  return Ue.selectNumberingPlan(ue), Ue.numberingPlan.possibleLengths().indexOf(me.length) >= 0;
}
function applyInternationalSeparatorStyle(me) {
  return me.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), "g"), " ").trim();
}
var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(me, ue, Qe) {
  var Ue = Qe.useInternationalFormat, He = Qe.withNationalPrefix;
  Qe.carrierCode, Qe.metadata;
  var Ge = me.replace(new RegExp(ue.pattern()), Ue ? ue.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    He && ue.nationalPrefixFormattingRule() ? ue.format().replace(FIRST_GROUP_PATTERN, ue.nationalPrefixFormattingRule()) : ue.format()
  ));
  return Ue ? applyInternationalSeparatorStyle(Ge) : Ge;
}
var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function getIddPrefix(me, ue, Qe) {
  var Ue = new Metadata$1(Qe);
  if (Ue.selectNumberingPlan(me, ue), Ue.defaultIDDPrefix())
    return Ue.defaultIDDPrefix();
  if (SINGLE_IDD_PREFIX_REG_EXP.test(Ue.IDDPrefix()))
    return Ue.IDDPrefix();
}
function formatRFC3966(me) {
  var ue = me.number, Qe = me.ext;
  if (!ue)
    return "";
  if (ue[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(ue).concat(Qe ? ";ext=" + Qe : "");
}
function _createForOfIteratorHelperLoose$4(me, ue) {
  var Qe = typeof Symbol < "u" && me[Symbol.iterator] || me["@@iterator"];
  if (Qe) return (Qe = Qe.call(me)).next.bind(Qe);
  if (Array.isArray(me) || (Qe = _unsupportedIterableToArray$7(me)) || ue) {
    Qe && (me = Qe);
    var Ue = 0;
    return function() {
      return Ue >= me.length ? { done: !0 } : { done: !1, value: me[Ue++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$7(me, ue) {
  if (me) {
    if (typeof me == "string") return _arrayLikeToArray$7(me, ue);
    var Qe = Object.prototype.toString.call(me).slice(8, -1);
    if (Qe === "Object" && me.constructor && (Qe = me.constructor.name), Qe === "Map" || Qe === "Set") return Array.from(me);
    if (Qe === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Qe)) return _arrayLikeToArray$7(me, ue);
  }
}
function _arrayLikeToArray$7(me, ue) {
  (ue == null || ue > me.length) && (ue = me.length);
  for (var Qe = 0, Ue = new Array(ue); Qe < ue; Qe++)
    Ue[Qe] = me[Qe];
  return Ue;
}
function ownKeys$4(me, ue) {
  var Qe = Object.keys(me);
  if (Object.getOwnPropertySymbols) {
    var Ue = Object.getOwnPropertySymbols(me);
    ue && (Ue = Ue.filter(function(He) {
      return Object.getOwnPropertyDescriptor(me, He).enumerable;
    })), Qe.push.apply(Qe, Ue);
  }
  return Qe;
}
function _objectSpread$4(me) {
  for (var ue = 1; ue < arguments.length; ue++) {
    var Qe = arguments[ue] != null ? arguments[ue] : {};
    ue % 2 ? ownKeys$4(Object(Qe), !0).forEach(function(Ue) {
      _defineProperty$4(me, Ue, Qe[Ue]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(me, Object.getOwnPropertyDescriptors(Qe)) : ownKeys$4(Object(Qe)).forEach(function(Ue) {
      Object.defineProperty(me, Ue, Object.getOwnPropertyDescriptor(Qe, Ue));
    });
  }
  return me;
}
function _defineProperty$4(me, ue, Qe) {
  return ue in me ? Object.defineProperty(me, ue, { value: Qe, enumerable: !0, configurable: !0, writable: !0 }) : me[ue] = Qe, me;
}
var DEFAULT_OPTIONS = {
  formatExtension: function(ue, Qe, Ue) {
    return "".concat(ue).concat(Ue.ext()).concat(Qe);
  }
};
function formatNumber(me, ue, Qe, Ue) {
  if (Qe ? Qe = _objectSpread$4(_objectSpread$4({}, DEFAULT_OPTIONS), Qe) : Qe = DEFAULT_OPTIONS, Ue = new Metadata$1(Ue), me.country && me.country !== "001") {
    if (!Ue.hasCountry(me.country))
      throw new Error("Unknown country: ".concat(me.country));
    Ue.country(me.country);
  } else if (me.countryCallingCode)
    Ue.selectNumberingPlan(me.countryCallingCode);
  else return me.phone || "";
  var He = Ue.countryCallingCode(), Ge = Qe.v2 ? me.nationalNumber : me.phone, Xe;
  switch (ue) {
    case "NATIONAL":
      return Ge ? (Xe = formatNationalNumber$1(Ge, me.carrierCode, "NATIONAL", Ue, Qe), addExtension(Xe, me.ext, Ue, Qe.formatExtension)) : "";
    case "INTERNATIONAL":
      return Ge ? (Xe = formatNationalNumber$1(Ge, null, "INTERNATIONAL", Ue, Qe), Xe = "+".concat(He, " ").concat(Xe), addExtension(Xe, me.ext, Ue, Qe.formatExtension)) : "+".concat(He);
    case "E.164":
      return "+".concat(He).concat(Ge);
    case "RFC3966":
      return formatRFC3966({
        number: "+".concat(He).concat(Ge),
        ext: me.ext
      });
    case "IDD":
      if (!Qe.fromCountry)
        return;
      var Ke = formatIDD(Ge, me.carrierCode, He, Qe.fromCountry, Ue);
      return addExtension(Ke, me.ext, Ue, Qe.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(ue, '"'));
  }
}
function formatNationalNumber$1(me, ue, Qe, Ue, He) {
  var Ge = chooseFormatForNumber(Ue.formats(), me);
  return Ge ? formatNationalNumberUsingFormat(me, Ge, {
    useInternationalFormat: Qe === "INTERNATIONAL",
    withNationalPrefix: !(Ge.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && He && He.nationalPrefix === !1),
    carrierCode: ue,
    metadata: Ue
  }) : me;
}
function chooseFormatForNumber(me, ue) {
  for (var Qe = _createForOfIteratorHelperLoose$4(me), Ue; !(Ue = Qe()).done; ) {
    var He = Ue.value;
    if (He.leadingDigitsPatterns().length > 0) {
      var Ge = He.leadingDigitsPatterns()[He.leadingDigitsPatterns().length - 1];
      if (ue.search(Ge) !== 0)
        continue;
    }
    if (matchesEntirely(ue, He.pattern()))
      return He;
  }
}
function addExtension(me, ue, Qe, Ue) {
  return ue ? Ue(me, ue, Qe) : me;
}
function formatIDD(me, ue, Qe, Ue, He) {
  var Ge = getCountryCallingCode$1(Ue, He.metadata);
  if (Ge === Qe) {
    var Xe = formatNationalNumber$1(me, ue, "NATIONAL", He);
    return Qe === "1" ? Qe + " " + Xe : Xe;
  }
  var Ke = getIddPrefix(Ue, void 0, He.metadata);
  if (Ke)
    return "".concat(Ke, " ").concat(Qe, " ").concat(formatNationalNumber$1(me, null, "INTERNATIONAL", He));
}
function ownKeys$3(me, ue) {
  var Qe = Object.keys(me);
  if (Object.getOwnPropertySymbols) {
    var Ue = Object.getOwnPropertySymbols(me);
    ue && (Ue = Ue.filter(function(He) {
      return Object.getOwnPropertyDescriptor(me, He).enumerable;
    })), Qe.push.apply(Qe, Ue);
  }
  return Qe;
}
function _objectSpread$3(me) {
  for (var ue = 1; ue < arguments.length; ue++) {
    var Qe = arguments[ue] != null ? arguments[ue] : {};
    ue % 2 ? ownKeys$3(Object(Qe), !0).forEach(function(Ue) {
      _defineProperty$3(me, Ue, Qe[Ue]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(me, Object.getOwnPropertyDescriptors(Qe)) : ownKeys$3(Object(Qe)).forEach(function(Ue) {
      Object.defineProperty(me, Ue, Object.getOwnPropertyDescriptor(Qe, Ue));
    });
  }
  return me;
}
function _defineProperty$3(me, ue, Qe) {
  return ue in me ? Object.defineProperty(me, ue, { value: Qe, enumerable: !0, configurable: !0, writable: !0 }) : me[ue] = Qe, me;
}
function _classCallCheck$i(me, ue) {
  if (!(me instanceof ue))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$6(me, ue) {
  for (var Qe = 0; Qe < ue.length; Qe++) {
    var Ue = ue[Qe];
    Ue.enumerable = Ue.enumerable || !1, Ue.configurable = !0, "value" in Ue && (Ue.writable = !0), Object.defineProperty(me, Ue.key, Ue);
  }
}
function _createClass$h(me, ue, Qe) {
  return ue && _defineProperties$6(me.prototype, ue), Object.defineProperty(me, "prototype", { writable: !1 }), me;
}
var PhoneNumber = /* @__PURE__ */ function() {
  function me(ue, Qe, Ue) {
    if (_classCallCheck$i(this, me), !ue)
      throw new TypeError("`country` or `countryCallingCode` not passed");
    if (!Qe)
      throw new TypeError("`nationalNumber` not passed");
    if (!Ue)
      throw new TypeError("`metadata` not passed");
    var He = getCountryAndCountryCallingCode(ue, Ue), Ge = He.country, Xe = He.countryCallingCode;
    this.country = Ge, this.countryCallingCode = Xe, this.nationalNumber = Qe, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return Ue;
    };
  }
  return _createClass$h(me, [{
    key: "setExt",
    value: function(Qe) {
      this.ext = Qe;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : getPossibleCountriesForNumber(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return isPossiblePhoneNumber(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return isValidNumber(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var Qe = new Metadata$1(this.getMetadata());
      return Qe.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(Qe) {
      return this.number === Qe.number && this.ext === Qe.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return getNumberType(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(Qe, Ue) {
      return formatNumber(this, Qe, Ue ? _objectSpread$3(_objectSpread$3({}, Ue), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(Qe) {
      return this.format("NATIONAL", Qe);
    }
  }, {
    key: "formatInternational",
    value: function(Qe) {
      return this.format("INTERNATIONAL", Qe);
    }
  }, {
    key: "getURI",
    value: function(Qe) {
      return this.format("RFC3966", Qe);
    }
  }]), me;
}(), isCountryCode = function(ue) {
  return /^[A-Z]{2}$/.test(ue);
};
function getCountryAndCountryCallingCode(me, ue) {
  var Qe, Ue, He = new Metadata$1(ue);
  return isCountryCode(me) ? (Qe = me, He.selectNumberingPlan(Qe), Ue = He.countryCallingCode()) : Ue = me, {
    country: Qe,
    countryCallingCode: Ue
  };
}
var CAPTURING_DIGIT_PATTERN = new RegExp("([" + VALID_DIGITS + "])");
function stripIddPrefix(me, ue, Qe, Ue) {
  if (ue) {
    var He = new Metadata$1(Ue);
    He.selectNumberingPlan(ue, Qe);
    var Ge = new RegExp(He.IDDPrefix());
    if (me.search(Ge) === 0) {
      me = me.slice(me.match(Ge)[0].length);
      var Xe = me.match(CAPTURING_DIGIT_PATTERN);
      if (!(Xe && Xe[1] != null && Xe[1].length > 0 && Xe[1] === "0"))
        return me;
    }
  }
}
function extractNationalNumberFromPossiblyIncompleteNumber(me, ue) {
  if (me && ue.numberingPlan.nationalPrefixForParsing()) {
    var Qe = new RegExp("^(?:" + ue.numberingPlan.nationalPrefixForParsing() + ")"), Ue = Qe.exec(me);
    if (Ue) {
      var He, Ge, Xe = Ue.length - 1, Ke = Xe > 0 && Ue[Xe];
      if (ue.nationalPrefixTransformRule() && Ke)
        He = me.replace(Qe, ue.nationalPrefixTransformRule()), Xe > 1 && (Ge = Ue[1]);
      else {
        var $e = Ue[0];
        He = me.slice($e.length), Ke && (Ge = Ue[1]);
      }
      var Je;
      if (Ke) {
        var Ze = me.indexOf(Ue[1]), nt = me.slice(0, Ze);
        nt === ue.numberingPlan.nationalPrefix() && (Je = ue.numberingPlan.nationalPrefix());
      } else
        Je = Ue[0];
      return {
        nationalNumber: He,
        nationalPrefix: Je,
        carrierCode: Ge
      };
    }
  }
  return {
    nationalNumber: me
  };
}
function extractNationalNumber(me, ue) {
  var Qe = extractNationalNumberFromPossiblyIncompleteNumber(me, ue), Ue = Qe.carrierCode, He = Qe.nationalNumber;
  if (He !== me) {
    if (!shouldHaveExtractedNationalPrefix(me, He, ue))
      return {
        nationalNumber: me
      };
    if (ue.possibleLengths() && !isPossibleIncompleteNationalNumber(He, ue))
      return {
        nationalNumber: me
      };
  }
  return {
    nationalNumber: He,
    carrierCode: Ue
  };
}
function shouldHaveExtractedNationalPrefix(me, ue, Qe) {
  return !(matchesEntirely(me, Qe.nationalNumberPattern()) && !matchesEntirely(ue, Qe.nationalNumberPattern()));
}
function isPossibleIncompleteNationalNumber(me, ue) {
  switch (checkNumberLength(me, ue)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(me, ue, Qe, Ue) {
  var He = ue ? getCountryCallingCode$1(ue, Ue) : Qe;
  if (me.indexOf(He) === 0) {
    Ue = new Metadata$1(Ue), Ue.selectNumberingPlan(ue, Qe);
    var Ge = me.slice(He.length), Xe = extractNationalNumber(Ge, Ue), Ke = Xe.nationalNumber, $e = extractNationalNumber(me, Ue), Je = $e.nationalNumber;
    if (!matchesEntirely(Je, Ue.nationalNumberPattern()) && matchesEntirely(Ke, Ue.nationalNumberPattern()) || checkNumberLength(Je, Ue) === "TOO_LONG")
      return {
        countryCallingCode: He,
        number: Ge
      };
  }
  return {
    number: me
  };
}
function extractCountryCallingCode(me, ue, Qe, Ue) {
  if (!me)
    return {};
  var He;
  if (me[0] !== "+") {
    var Ge = stripIddPrefix(me, ue, Qe, Ue);
    if (Ge && Ge !== me)
      He = !0, me = "+" + Ge;
    else {
      if (ue || Qe) {
        var Xe = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(me, ue, Qe, Ue), Ke = Xe.countryCallingCode, $e = Xe.number;
        if (Ke)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: Ke,
            number: $e
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: me
      };
    }
  }
  if (me[1] === "0")
    return {};
  Ue = new Metadata$1(Ue);
  for (var Je = 2; Je - 1 <= MAX_LENGTH_COUNTRY_CODE && Je <= me.length; ) {
    var Ze = me.slice(1, Je);
    if (Ue.hasCallingCode(Ze))
      return Ue.selectNumberingPlan(Ze), {
        countryCallingCodeSource: He ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: Ze,
        number: me.slice(Je)
      };
    Je++;
  }
  return {};
}
function _createForOfIteratorHelperLoose$3(me, ue) {
  var Qe = typeof Symbol < "u" && me[Symbol.iterator] || me["@@iterator"];
  if (Qe) return (Qe = Qe.call(me)).next.bind(Qe);
  if (Array.isArray(me) || (Qe = _unsupportedIterableToArray$6(me)) || ue) {
    Qe && (me = Qe);
    var Ue = 0;
    return function() {
      return Ue >= me.length ? { done: !0 } : { done: !1, value: me[Ue++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$6(me, ue) {
  if (me) {
    if (typeof me == "string") return _arrayLikeToArray$6(me, ue);
    var Qe = Object.prototype.toString.call(me).slice(8, -1);
    if (Qe === "Object" && me.constructor && (Qe = me.constructor.name), Qe === "Map" || Qe === "Set") return Array.from(me);
    if (Qe === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Qe)) return _arrayLikeToArray$6(me, ue);
  }
}
function _arrayLikeToArray$6(me, ue) {
  (ue == null || ue > me.length) && (ue = me.length);
  for (var Qe = 0, Ue = new Array(ue); Qe < ue; Qe++)
    Ue[Qe] = me[Qe];
  return Ue;
}
function getCountryByNationalNumber(me, ue) {
  var Qe = ue.countries, Ue = ue.defaultCountry, He = ue.metadata;
  He = new Metadata$1(He);
  for (var Ge = [], Xe = _createForOfIteratorHelperLoose$3(Qe), Ke; !(Ke = Xe()).done; ) {
    var $e = Ke.value;
    if (He.country($e), He.leadingDigits()) {
      if (me && me.search(He.leadingDigits()) === 0)
        return $e;
    } else if (getNumberType({
      phone: me,
      country: $e
    }, void 0, He.metadata))
      if (Ue) {
        if ($e === Ue)
          return $e;
        Ge.push($e);
      } else
        return $e;
  }
  if (Ge.length > 0)
    return Ge[0];
}
function getCountryByCallingCode(me, ue) {
  var Qe = ue.nationalNumber, Ue = ue.defaultCountry, He = ue.metadata, Ge = He.getCountryCodesForCallingCode(me);
  if (Ge)
    return Ge.length === 1 ? Ge[0] : getCountryByNationalNumber(Qe, {
      countries: Ge,
      defaultCountry: Ue,
      metadata: He.metadata
    });
}
var PLUS_SIGN = "+", RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?", RFC3966_PHONE_DIGIT_ = "([" + VALID_DIGITS + "]|" + RFC3966_VISUAL_SEPARATOR_ + ")", RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + PLUS_SIGN + RFC3966_PHONE_DIGIT_ + "*[" + VALID_DIGITS + "]" + RFC3966_PHONE_DIGIT_ + "*$", RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp(RFC3966_GLOBAL_NUMBER_DIGITS_, "g"), ALPHANUM_ = VALID_DIGITS, RFC3966_DOMAINLABEL_ = "[" + ALPHANUM_ + "]+((\\-)*[" + ALPHANUM_ + "])*", VALID_ALPHA_ = "a-zA-Z", RFC3966_TOPLABEL_ = "[" + VALID_ALPHA_ + "]+((\\-)*[" + ALPHANUM_ + "])*", RFC3966_DOMAINNAME_ = "^(" + RFC3966_DOMAINLABEL_ + "\\.)*" + RFC3966_TOPLABEL_ + "\\.?$", RFC3966_DOMAINNAME_PATTERN_ = new RegExp(RFC3966_DOMAINNAME_, "g"), RFC3966_PREFIX_ = "tel:", RFC3966_PHONE_CONTEXT_ = ";phone-context=", RFC3966_ISDN_SUBADDRESS_ = ";isub=";
function extractPhoneContext(me) {
  var ue = me.indexOf(RFC3966_PHONE_CONTEXT_);
  if (ue < 0)
    return null;
  var Qe = ue + RFC3966_PHONE_CONTEXT_.length;
  if (Qe >= me.length)
    return "";
  var Ue = me.indexOf(";", Qe);
  return Ue >= 0 ? me.substring(Qe, Ue) : me.substring(Qe);
}
function isPhoneContextValid(me) {
  return me === null ? !0 : me.length === 0 ? !1 : RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(me) || RFC3966_DOMAINNAME_PATTERN_.test(me);
}
function extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(me, ue) {
  var Qe = ue.extractFormattedPhoneNumber, Ue = extractPhoneContext(me);
  if (!isPhoneContextValid(Ue))
    throw new ParseError("NOT_A_NUMBER");
  var He;
  if (Ue === null)
    He = Qe(me) || "";
  else {
    He = "", Ue.charAt(0) === PLUS_SIGN && (He += Ue);
    var Ge = me.indexOf(RFC3966_PREFIX_), Xe;
    Ge >= 0 ? Xe = Ge + RFC3966_PREFIX_.length : Xe = 0;
    var Ke = me.indexOf(RFC3966_PHONE_CONTEXT_);
    He += me.substring(Xe, Ke);
  }
  var $e = He.indexOf(RFC3966_ISDN_SUBADDRESS_);
  if ($e > 0 && (He = He.substring(0, $e)), He !== "")
    return He;
}
var MAX_INPUT_STRING_LENGTH = 250, PHONE_NUMBER_START_PATTERN = new RegExp("[" + PLUS_CHARS + VALID_DIGITS + "]"), AFTER_PHONE_NUMBER_END_PATTERN = new RegExp("[^" + VALID_DIGITS + "#]+$");
function parse$5(me, ue, Qe) {
  if (ue = ue || {}, Qe = new Metadata$1(Qe), ue.defaultCountry && !Qe.hasCountry(ue.defaultCountry))
    throw ue.v2 ? new ParseError("INVALID_COUNTRY") : new Error("Unknown country: ".concat(ue.defaultCountry));
  var Ue = parseInput(me, ue.v2, ue.extract), He = Ue.number, Ge = Ue.ext, Xe = Ue.error;
  if (!He) {
    if (ue.v2)
      throw Xe === "TOO_SHORT" ? new ParseError("TOO_SHORT") : new ParseError("NOT_A_NUMBER");
    return {};
  }
  var Ke = parsePhoneNumber$3(He, ue.defaultCountry, ue.defaultCallingCode, Qe), $e = Ke.country, Je = Ke.nationalNumber, Ze = Ke.countryCallingCode, nt = Ke.countryCallingCodeSource, tt = Ke.carrierCode;
  if (!Qe.hasSelectedNumberingPlan()) {
    if (ue.v2)
      throw new ParseError("INVALID_COUNTRY");
    return {};
  }
  if (!Je || Je.length < MIN_LENGTH_FOR_NSN) {
    if (ue.v2)
      throw new ParseError("TOO_SHORT");
    return {};
  }
  if (Je.length > MAX_LENGTH_FOR_NSN) {
    if (ue.v2)
      throw new ParseError("TOO_LONG");
    return {};
  }
  if (ue.v2) {
    var et = new PhoneNumber(Ze, Je, Qe.metadata);
    return $e && (et.country = $e), tt && (et.carrierCode = tt), Ge && (et.ext = Ge), et.__countryCallingCodeSource = nt, et;
  }
  var rt = (ue.extended ? Qe.hasSelectedNumberingPlan() : $e) ? matchesEntirely(Je, Qe.nationalNumberPattern()) : !1;
  return ue.extended ? {
    country: $e,
    countryCallingCode: Ze,
    carrierCode: tt,
    valid: rt,
    possible: rt ? !0 : !!(ue.extended === !0 && Qe.possibleLengths() && isPossibleNumber(Je, Qe)),
    phone: Je,
    ext: Ge
  } : rt ? result($e, Je, Ge) : {};
}
function _extractFormattedPhoneNumber(me, ue, Qe) {
  if (me) {
    if (me.length > MAX_INPUT_STRING_LENGTH) {
      if (Qe)
        throw new ParseError("TOO_LONG");
      return;
    }
    if (ue === !1)
      return me;
    var Ue = me.search(PHONE_NUMBER_START_PATTERN);
    if (!(Ue < 0))
      return me.slice(Ue).replace(AFTER_PHONE_NUMBER_END_PATTERN, "");
  }
}
function parseInput(me, ue, Qe) {
  var Ue = extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(me, {
    extractFormattedPhoneNumber: function(Xe) {
      return _extractFormattedPhoneNumber(Xe, Qe, ue);
    }
  });
  if (!Ue)
    return {};
  if (!isViablePhoneNumber(Ue))
    return isViablePhoneNumberStart(Ue) ? {
      error: "TOO_SHORT"
    } : {};
  var He = extractExtension(Ue);
  return He.ext ? He : {
    number: Ue
  };
}
function result(me, ue, Qe) {
  var Ue = {
    country: me,
    phone: ue
  };
  return Qe && (Ue.ext = Qe), Ue;
}
function parsePhoneNumber$3(me, ue, Qe, Ue) {
  var He = extractCountryCallingCode(parseIncompletePhoneNumber(me), ue, Qe, Ue.metadata), Ge = He.countryCallingCodeSource, Xe = He.countryCallingCode, Ke = He.number, $e;
  if (Xe)
    Ue.selectNumberingPlan(Xe);
  else if (Ke && (ue || Qe))
    Ue.selectNumberingPlan(ue, Qe), ue && ($e = ue), Xe = Qe || getCountryCallingCode$1(ue, Ue.metadata);
  else return {};
  if (!Ke)
    return {
      countryCallingCodeSource: Ge,
      countryCallingCode: Xe
    };
  var Je = extractNationalNumber(parseIncompletePhoneNumber(Ke), Ue), Ze = Je.nationalNumber, nt = Je.carrierCode, tt = getCountryByCallingCode(Xe, {
    nationalNumber: Ze,
    defaultCountry: ue,
    metadata: Ue
  });
  return tt && ($e = tt, tt === "001" || Ue.country($e)), {
    country: $e,
    countryCallingCode: Xe,
    countryCallingCodeSource: Ge,
    nationalNumber: Ze,
    carrierCode: nt
  };
}
function ownKeys$2(me, ue) {
  var Qe = Object.keys(me);
  if (Object.getOwnPropertySymbols) {
    var Ue = Object.getOwnPropertySymbols(me);
    ue && (Ue = Ue.filter(function(He) {
      return Object.getOwnPropertyDescriptor(me, He).enumerable;
    })), Qe.push.apply(Qe, Ue);
  }
  return Qe;
}
function _objectSpread$2(me) {
  for (var ue = 1; ue < arguments.length; ue++) {
    var Qe = arguments[ue] != null ? arguments[ue] : {};
    ue % 2 ? ownKeys$2(Object(Qe), !0).forEach(function(Ue) {
      _defineProperty$2(me, Ue, Qe[Ue]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(me, Object.getOwnPropertyDescriptors(Qe)) : ownKeys$2(Object(Qe)).forEach(function(Ue) {
      Object.defineProperty(me, Ue, Object.getOwnPropertyDescriptor(Qe, Ue));
    });
  }
  return me;
}
function _defineProperty$2(me, ue, Qe) {
  return ue in me ? Object.defineProperty(me, ue, { value: Qe, enumerable: !0, configurable: !0, writable: !0 }) : me[ue] = Qe, me;
}
function parsePhoneNumberWithError(me, ue, Qe) {
  return parse$5(me, _objectSpread$2(_objectSpread$2({}, ue), {}, {
    v2: !0
  }), Qe);
}
function ownKeys$1(me, ue) {
  var Qe = Object.keys(me);
  if (Object.getOwnPropertySymbols) {
    var Ue = Object.getOwnPropertySymbols(me);
    ue && (Ue = Ue.filter(function(He) {
      return Object.getOwnPropertyDescriptor(me, He).enumerable;
    })), Qe.push.apply(Qe, Ue);
  }
  return Qe;
}
function _objectSpread$1(me) {
  for (var ue = 1; ue < arguments.length; ue++) {
    var Qe = arguments[ue] != null ? arguments[ue] : {};
    ue % 2 ? ownKeys$1(Object(Qe), !0).forEach(function(Ue) {
      _defineProperty$1(me, Ue, Qe[Ue]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(me, Object.getOwnPropertyDescriptors(Qe)) : ownKeys$1(Object(Qe)).forEach(function(Ue) {
      Object.defineProperty(me, Ue, Object.getOwnPropertyDescriptor(Qe, Ue));
    });
  }
  return me;
}
function _defineProperty$1(me, ue, Qe) {
  return ue in me ? Object.defineProperty(me, ue, { value: Qe, enumerable: !0, configurable: !0, writable: !0 }) : me[ue] = Qe, me;
}
function _slicedToArray$2(me, ue) {
  return _arrayWithHoles$2(me) || _iterableToArrayLimit$2(me, ue) || _unsupportedIterableToArray$5(me, ue) || _nonIterableRest$2();
}
function _nonIterableRest$2() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$5(me, ue) {
  if (me) {
    if (typeof me == "string") return _arrayLikeToArray$5(me, ue);
    var Qe = Object.prototype.toString.call(me).slice(8, -1);
    if (Qe === "Object" && me.constructor && (Qe = me.constructor.name), Qe === "Map" || Qe === "Set") return Array.from(me);
    if (Qe === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Qe)) return _arrayLikeToArray$5(me, ue);
  }
}
function _arrayLikeToArray$5(me, ue) {
  (ue == null || ue > me.length) && (ue = me.length);
  for (var Qe = 0, Ue = new Array(ue); Qe < ue; Qe++)
    Ue[Qe] = me[Qe];
  return Ue;
}
function _iterableToArrayLimit$2(me, ue) {
  var Qe = me == null ? null : typeof Symbol < "u" && me[Symbol.iterator] || me["@@iterator"];
  if (Qe != null) {
    var Ue = [], He = !0, Ge = !1, Xe, Ke;
    try {
      for (Qe = Qe.call(me); !(He = (Xe = Qe.next()).done) && (Ue.push(Xe.value), !(ue && Ue.length === ue)); He = !0)
        ;
    } catch ($e) {
      Ge = !0, Ke = $e;
    } finally {
      try {
        !He && Qe.return != null && Qe.return();
      } finally {
        if (Ge) throw Ke;
      }
    }
    return Ue;
  }
}
function _arrayWithHoles$2(me) {
  if (Array.isArray(me)) return me;
}
function normalizeArguments(me) {
  var ue = Array.prototype.slice.call(me), Qe = _slicedToArray$2(ue, 4), Ue = Qe[0], He = Qe[1], Ge = Qe[2], Xe = Qe[3], Ke, $e, Je;
  if (typeof Ue == "string")
    Ke = Ue;
  else throw new TypeError("A text for parsing must be a string.");
  if (!He || typeof He == "string")
    Xe ? ($e = Ge, Je = Xe) : ($e = void 0, Je = Ge), He && ($e = _objectSpread$1({
      defaultCountry: He
    }, $e));
  else if (isObject$7(He))
    Ge ? ($e = He, Je = Ge) : Je = He;
  else throw new Error("Invalid second argument: ".concat(He));
  return {
    text: Ke,
    options: $e,
    metadata: Je
  };
}
function ownKeys(me, ue) {
  var Qe = Object.keys(me);
  if (Object.getOwnPropertySymbols) {
    var Ue = Object.getOwnPropertySymbols(me);
    ue && (Ue = Ue.filter(function(He) {
      return Object.getOwnPropertyDescriptor(me, He).enumerable;
    })), Qe.push.apply(Qe, Ue);
  }
  return Qe;
}
function _objectSpread(me) {
  for (var ue = 1; ue < arguments.length; ue++) {
    var Qe = arguments[ue] != null ? arguments[ue] : {};
    ue % 2 ? ownKeys(Object(Qe), !0).forEach(function(Ue) {
      _defineProperty(me, Ue, Qe[Ue]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(me, Object.getOwnPropertyDescriptors(Qe)) : ownKeys(Object(Qe)).forEach(function(Ue) {
      Object.defineProperty(me, Ue, Object.getOwnPropertyDescriptor(Qe, Ue));
    });
  }
  return me;
}
function _defineProperty(me, ue, Qe) {
  return ue in me ? Object.defineProperty(me, ue, { value: Qe, enumerable: !0, configurable: !0, writable: !0 }) : me[ue] = Qe, me;
}
function parsePhoneNumber$2(me, ue, Qe) {
  ue && ue.defaultCountry && !isSupportedCountry(ue.defaultCountry, Qe) && (ue = _objectSpread(_objectSpread({}, ue), {}, {
    defaultCountry: void 0
  }));
  try {
    return parsePhoneNumberWithError(me, ue, Qe);
  } catch (Ue) {
    if (!(Ue instanceof ParseError)) throw Ue;
  }
}
function parsePhoneNumber$1() {
  var me = normalizeArguments(arguments), ue = me.text, Qe = me.options, Ue = me.metadata;
  return parsePhoneNumber$2(ue, Qe, Ue);
}
function _classCallCheck$h(me, ue) {
  if (!(me instanceof ue))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$5(me, ue) {
  for (var Qe = 0; Qe < ue.length; Qe++) {
    var Ue = ue[Qe];
    Ue.enumerable = Ue.enumerable || !1, Ue.configurable = !0, "value" in Ue && (Ue.writable = !0), Object.defineProperty(me, Ue.key, Ue);
  }
}
function _createClass$g(me, ue, Qe) {
  return ue && _defineProperties$5(me.prototype, ue), Object.defineProperty(me, "prototype", { writable: !1 }), me;
}
var AsYouTypeState = /* @__PURE__ */ function() {
  function me(ue) {
    var Qe = ue.onCountryChange, Ue = ue.onCallingCodeChange;
    _classCallCheck$h(this, me), this.onCountryChange = Qe, this.onCallingCodeChange = Ue;
  }
  return _createClass$g(me, [{
    key: "reset",
    value: function(Qe) {
      var Ue = Qe.country, He = Qe.callingCode;
      this.international = !1, this.missingPlus = !1, this.IDDPrefix = void 0, this.callingCode = void 0, this.digits = "", this.resetNationalSignificantNumber(), this.initCountryAndCallingCode(Ue, He);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function() {
      this.nationalSignificantNumber = this.getNationalDigits(), this.nationalSignificantNumberMatchesInput = !0, this.nationalPrefix = void 0, this.carrierCode = void 0, this.complexPrefixBeforeNationalSignificantNumber = void 0;
    }
  }, {
    key: "update",
    value: function(Qe) {
      for (var Ue = 0, He = Object.keys(Qe); Ue < He.length; Ue++) {
        var Ge = He[Ue];
        this[Ge] = Qe[Ge];
      }
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function(Qe, Ue) {
      this.setCountry(Qe), this.setCallingCode(Ue);
    }
  }, {
    key: "setCountry",
    value: function(Qe) {
      this.country = Qe, this.onCountryChange(Qe);
    }
  }, {
    key: "setCallingCode",
    value: function(Qe) {
      this.callingCode = Qe, this.onCallingCodeChange(Qe, this.country);
    }
  }, {
    key: "startInternationalNumber",
    value: function(Qe, Ue) {
      this.international = !0, this.initCountryAndCallingCode(Qe, Ue);
    }
  }, {
    key: "appendDigits",
    value: function(Qe) {
      this.digits += Qe;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function(Qe) {
      this.nationalSignificantNumber += Qe;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */
  }, {
    key: "getNationalDigits",
    value: function() {
      return this.international ? this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0)) : this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function() {
      return this.international && this.IDDPrefix ? this.digits.slice(this.IDDPrefix.length) : this.digits;
    }
  }]), me;
}();
function _createForOfIteratorHelperLoose$2(me, ue) {
  var Qe = typeof Symbol < "u" && me[Symbol.iterator] || me["@@iterator"];
  if (Qe) return (Qe = Qe.call(me)).next.bind(Qe);
  if (Array.isArray(me) || (Qe = _unsupportedIterableToArray$4(me)) || ue) {
    Qe && (me = Qe);
    var Ue = 0;
    return function() {
      return Ue >= me.length ? { done: !0 } : { done: !1, value: me[Ue++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$4(me, ue) {
  if (me) {
    if (typeof me == "string") return _arrayLikeToArray$4(me, ue);
    var Qe = Object.prototype.toString.call(me).slice(8, -1);
    if (Qe === "Object" && me.constructor && (Qe = me.constructor.name), Qe === "Map" || Qe === "Set") return Array.from(me);
    if (Qe === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Qe)) return _arrayLikeToArray$4(me, ue);
  }
}
function _arrayLikeToArray$4(me, ue) {
  (ue == null || ue > me.length) && (ue = me.length);
  for (var Qe = 0, Ue = new Array(ue); Qe < ue; Qe++)
    Ue[Qe] = me[Qe];
  return Ue;
}
var DIGIT_PLACEHOLDER = "x", DIGIT_PLACEHOLDER_MATCHER = new RegExp(DIGIT_PLACEHOLDER);
function repeat(me, ue) {
  if (ue < 1)
    return "";
  for (var Qe = ""; ue > 1; )
    ue & 1 && (Qe += me), ue >>= 1, me += me;
  return Qe + me;
}
function cutAndStripNonPairedParens(me, ue) {
  return me[ue] === ")" && ue++, stripNonPairedParens(me.slice(0, ue));
}
function stripNonPairedParens(me) {
  for (var ue = [], Qe = 0; Qe < me.length; )
    me[Qe] === "(" ? ue.push(Qe) : me[Qe] === ")" && ue.pop(), Qe++;
  var Ue = 0, He = "";
  ue.push(me.length);
  for (var Ge = 0, Xe = ue; Ge < Xe.length; Ge++) {
    var Ke = Xe[Ge];
    He += me.slice(Ue, Ke), Ue = Ke + 1;
  }
  return He;
}
function populateTemplateWithDigits(me, ue, Qe) {
  for (var Ue = _createForOfIteratorHelperLoose$2(Qe.split("")), He; !(He = Ue()).done; ) {
    var Ge = He.value;
    if (me.slice(ue + 1).search(DIGIT_PLACEHOLDER_MATCHER) < 0)
      return;
    ue = me.search(DIGIT_PLACEHOLDER_MATCHER), me = me.replace(DIGIT_PLACEHOLDER_MATCHER, Ge);
  }
  return [me, ue];
}
function formatCompleteNumber(me, ue, Qe) {
  var Ue = Qe.metadata, He = Qe.shouldTryNationalPrefixFormattingRule, Ge = Qe.getSeparatorAfterNationalPrefix, Xe = new RegExp("^(?:".concat(ue.pattern(), ")$"));
  if (Xe.test(me.nationalSignificantNumber))
    return formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(me, ue, {
      metadata: Ue,
      shouldTryNationalPrefixFormattingRule: He,
      getSeparatorAfterNationalPrefix: Ge
    });
}
function canFormatCompleteNumber(me, ue) {
  return checkNumberLength(me, ue) === "IS_POSSIBLE";
}
function formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(me, ue, Qe) {
  var Ue = Qe.metadata, He = Qe.shouldTryNationalPrefixFormattingRule, Ge = Qe.getSeparatorAfterNationalPrefix;
  if (me.nationalSignificantNumber, me.international, me.nationalPrefix, me.carrierCode, He(ue)) {
    var Xe = formatNationalNumber(me, ue, {
      useNationalPrefixFormattingRule: !0,
      getSeparatorAfterNationalPrefix: Ge,
      metadata: Ue
    });
    if (Xe)
      return Xe;
  }
  return formatNationalNumber(me, ue, {
    useNationalPrefixFormattingRule: !1,
    getSeparatorAfterNationalPrefix: Ge,
    metadata: Ue
  });
}
function formatNationalNumber(me, ue, Qe) {
  var Ue = Qe.metadata, He = Qe.useNationalPrefixFormattingRule, Ge = Qe.getSeparatorAfterNationalPrefix, Xe = formatNationalNumberUsingFormat(me.nationalSignificantNumber, ue, {
    carrierCode: me.carrierCode,
    useInternationalFormat: me.international,
    withNationalPrefix: He,
    metadata: Ue
  });
  if (He || (me.nationalPrefix ? Xe = me.nationalPrefix + Ge(ue) + Xe : me.complexPrefixBeforeNationalSignificantNumber && (Xe = me.complexPrefixBeforeNationalSignificantNumber + " " + Xe)), isValidFormattedNationalNumber(Xe, me))
    return Xe;
}
function isValidFormattedNationalNumber(me, ue) {
  return parseDigits(me) === ue.getNationalDigits();
}
function _classCallCheck$g(me, ue) {
  if (!(me instanceof ue))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$4(me, ue) {
  for (var Qe = 0; Qe < ue.length; Qe++) {
    var Ue = ue[Qe];
    Ue.enumerable = Ue.enumerable || !1, Ue.configurable = !0, "value" in Ue && (Ue.writable = !0), Object.defineProperty(me, Ue.key, Ue);
  }
}
function _createClass$f(me, ue, Qe) {
  return ue && _defineProperties$4(me.prototype, ue), Object.defineProperty(me, "prototype", { writable: !1 }), me;
}
var PatternParser = /* @__PURE__ */ function() {
  function me() {
    _classCallCheck$g(this, me);
  }
  return _createClass$f(me, [{
    key: "parse",
    value: function(Qe) {
      if (this.context = [{
        or: !0,
        instructions: []
      }], this.parsePattern(Qe), this.context.length !== 1)
        throw new Error("Non-finalized contexts left when pattern parse ended");
      var Ue = this.context[0], He = Ue.branches, Ge = Ue.instructions;
      if (He)
        return {
          op: "|",
          args: He.concat([expandSingleElementArray(Ge)])
        };
      if (Ge.length === 0)
        throw new Error("Pattern is required");
      return Ge.length === 1 ? Ge[0] : Ge;
    }
  }, {
    key: "startContext",
    value: function(Qe) {
      this.context.push(Qe);
    }
  }, {
    key: "endContext",
    value: function() {
      this.context.pop();
    }
  }, {
    key: "getContext",
    value: function() {
      return this.context[this.context.length - 1];
    }
  }, {
    key: "parsePattern",
    value: function(Qe) {
      if (!Qe)
        throw new Error("Pattern is required");
      var Ue = Qe.match(OPERATOR);
      if (!Ue) {
        if (ILLEGAL_CHARACTER_REGEXP.test(Qe))
          throw new Error("Illegal characters found in a pattern: ".concat(Qe));
        this.getContext().instructions = this.getContext().instructions.concat(Qe.split(""));
        return;
      }
      var He = Ue[1], Ge = Qe.slice(0, Ue.index), Xe = Qe.slice(Ue.index + He.length);
      switch (He) {
        case "(?:":
          Ge && this.parsePattern(Ge), this.startContext({
            or: !0,
            instructions: [],
            branches: []
          });
          break;
        case ")":
          if (!this.getContext().or)
            throw new Error('")" operator must be preceded by "(?:" operator');
          if (Ge && this.parsePattern(Ge), this.getContext().instructions.length === 0)
            throw new Error('No instructions found after "|" operator in an "or" group');
          var Ke = this.getContext(), $e = Ke.branches;
          $e.push(expandSingleElementArray(this.getContext().instructions)), this.endContext(), this.getContext().instructions.push({
            op: "|",
            args: $e
          });
          break;
        case "|":
          if (!this.getContext().or)
            throw new Error('"|" operator can only be used inside "or" groups');
          if (Ge && this.parsePattern(Ge), !this.getContext().branches)
            if (this.context.length === 1)
              this.getContext().branches = [];
            else
              throw new Error('"branches" not found in an "or" group context');
          this.getContext().branches.push(expandSingleElementArray(this.getContext().instructions)), this.getContext().instructions = [];
          break;
        case "[":
          Ge && this.parsePattern(Ge), this.startContext({
            oneOfSet: !0
          });
          break;
        case "]":
          if (!this.getContext().oneOfSet)
            throw new Error('"]" operator must be preceded by "[" operator');
          this.endContext(), this.getContext().instructions.push({
            op: "[]",
            args: parseOneOfSet(Ge)
          });
          break;
        default:
          throw new Error("Unknown operator: ".concat(He));
      }
      Xe && this.parsePattern(Xe);
    }
  }]), me;
}();
function parseOneOfSet(me) {
  for (var ue = [], Qe = 0; Qe < me.length; ) {
    if (me[Qe] === "-") {
      if (Qe === 0 || Qe === me.length - 1)
        throw new Error("Couldn't parse a one-of set pattern: ".concat(me));
      for (var Ue = me[Qe - 1].charCodeAt(0) + 1, He = me[Qe + 1].charCodeAt(0) - 1, Ge = Ue; Ge <= He; )
        ue.push(String.fromCharCode(Ge)), Ge++;
    } else
      ue.push(me[Qe]);
    Qe++;
  }
  return ue;
}
var ILLEGAL_CHARACTER_REGEXP = /[\(\)\[\]\?\:\|]/, OPERATOR = new RegExp(
  // any of:
  "(\\||\\(\\?\\:|\\)|\\[|\\])"
);
function expandSingleElementArray(me) {
  return me.length === 1 ? me[0] : me;
}
function _createForOfIteratorHelperLoose$1(me, ue) {
  var Qe = typeof Symbol < "u" && me[Symbol.iterator] || me["@@iterator"];
  if (Qe) return (Qe = Qe.call(me)).next.bind(Qe);
  if (Array.isArray(me) || (Qe = _unsupportedIterableToArray$3(me)) || ue) {
    Qe && (me = Qe);
    var Ue = 0;
    return function() {
      return Ue >= me.length ? { done: !0 } : { done: !1, value: me[Ue++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$3(me, ue) {
  if (me) {
    if (typeof me == "string") return _arrayLikeToArray$3(me, ue);
    var Qe = Object.prototype.toString.call(me).slice(8, -1);
    if (Qe === "Object" && me.constructor && (Qe = me.constructor.name), Qe === "Map" || Qe === "Set") return Array.from(me);
    if (Qe === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Qe)) return _arrayLikeToArray$3(me, ue);
  }
}
function _arrayLikeToArray$3(me, ue) {
  (ue == null || ue > me.length) && (ue = me.length);
  for (var Qe = 0, Ue = new Array(ue); Qe < ue; Qe++)
    Ue[Qe] = me[Qe];
  return Ue;
}
function _classCallCheck$f(me, ue) {
  if (!(me instanceof ue))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$3(me, ue) {
  for (var Qe = 0; Qe < ue.length; Qe++) {
    var Ue = ue[Qe];
    Ue.enumerable = Ue.enumerable || !1, Ue.configurable = !0, "value" in Ue && (Ue.writable = !0), Object.defineProperty(me, Ue.key, Ue);
  }
}
function _createClass$e(me, ue, Qe) {
  return ue && _defineProperties$3(me.prototype, ue), Object.defineProperty(me, "prototype", { writable: !1 }), me;
}
var PatternMatcher = /* @__PURE__ */ function() {
  function me(ue) {
    _classCallCheck$f(this, me), this.matchTree = new PatternParser().parse(ue);
  }
  return _createClass$e(me, [{
    key: "match",
    value: function(Qe) {
      var Ue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, He = Ue.allowOverflow;
      if (!Qe)
        throw new Error("String is required");
      var Ge = _match(Qe.split(""), this.matchTree, !0);
      if (Ge && Ge.match && delete Ge.matchedChars, !(Ge && Ge.overflow && !He))
        return Ge;
    }
  }]), me;
}();
function _match(me, ue, Qe) {
  if (typeof ue == "string") {
    var Ue = me.join("");
    return ue.indexOf(Ue) === 0 ? me.length === ue.length ? {
      match: !0,
      matchedChars: me
    } : {
      partialMatch: !0
      // matchedChars: characters
    } : Ue.indexOf(ue) === 0 ? Qe && me.length > ue.length ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: me.slice(0, ue.length)
    } : void 0;
  }
  if (Array.isArray(ue)) {
    for (var He = me.slice(), Ge = 0; Ge < ue.length; ) {
      var Xe = ue[Ge], Ke = _match(He, Xe, Qe && Ge === ue.length - 1);
      if (Ke) {
        if (Ke.overflow)
          return Ke;
        if (Ke.match) {
          if (He = He.slice(Ke.matchedChars.length), He.length === 0)
            return Ge === ue.length - 1 ? {
              match: !0,
              matchedChars: me
            } : {
              partialMatch: !0
              // matchedChars: characters
            };
        } else {
          if (Ke.partialMatch)
            return {
              partialMatch: !0
              // matchedChars: characters
            };
          throw new Error(`Unsupported match result:
`.concat(JSON.stringify(Ke, null, 2)));
        }
      } else return;
      Ge++;
    }
    return Qe ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: me.slice(0, me.length - He.length)
    };
  }
  switch (ue.op) {
    case "|":
      for (var $e, Je = _createForOfIteratorHelperLoose$1(ue.args), Ze; !(Ze = Je()).done; ) {
        var nt = Ze.value, tt = _match(me, nt, Qe);
        if (tt) {
          if (tt.overflow)
            return tt;
          if (tt.match)
            return {
              match: !0,
              matchedChars: tt.matchedChars
            };
          if (tt.partialMatch)
            $e = !0;
          else
            throw new Error(`Unsupported match result:
`.concat(JSON.stringify(tt, null, 2)));
        }
      }
      return $e ? {
        partialMatch: !0
        // matchedChars: ...
      } : void 0;
    case "[]":
      for (var et = _createForOfIteratorHelperLoose$1(ue.args), rt; !(rt = et()).done; ) {
        var it = rt.value;
        if (me[0] === it)
          return me.length === 1 ? {
            match: !0,
            matchedChars: me
          } : Qe ? {
            overflow: !0
          } : {
            match: !0,
            matchedChars: [it]
          };
      }
      return;
    default:
      throw new Error("Unsupported instruction tree: ".concat(ue));
  }
}
function _createForOfIteratorHelperLoose(me, ue) {
  var Qe = typeof Symbol < "u" && me[Symbol.iterator] || me["@@iterator"];
  if (Qe) return (Qe = Qe.call(me)).next.bind(Qe);
  if (Array.isArray(me) || (Qe = _unsupportedIterableToArray$2(me)) || ue) {
    Qe && (me = Qe);
    var Ue = 0;
    return function() {
      return Ue >= me.length ? { done: !0 } : { done: !1, value: me[Ue++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$2(me, ue) {
  if (me) {
    if (typeof me == "string") return _arrayLikeToArray$2(me, ue);
    var Qe = Object.prototype.toString.call(me).slice(8, -1);
    if (Qe === "Object" && me.constructor && (Qe = me.constructor.name), Qe === "Map" || Qe === "Set") return Array.from(me);
    if (Qe === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Qe)) return _arrayLikeToArray$2(me, ue);
  }
}
function _arrayLikeToArray$2(me, ue) {
  (ue == null || ue > me.length) && (ue = me.length);
  for (var Qe = 0, Ue = new Array(ue); Qe < ue; Qe++)
    Ue[Qe] = me[Qe];
  return Ue;
}
function _classCallCheck$e(me, ue) {
  if (!(me instanceof ue))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$2(me, ue) {
  for (var Qe = 0; Qe < ue.length; Qe++) {
    var Ue = ue[Qe];
    Ue.enumerable = Ue.enumerable || !1, Ue.configurable = !0, "value" in Ue && (Ue.writable = !0), Object.defineProperty(me, Ue.key, Ue);
  }
}
function _createClass$d(me, ue, Qe) {
  return ue && _defineProperties$2(me.prototype, ue), Object.defineProperty(me, "prototype", { writable: !1 }), me;
}
var DUMMY_DIGIT = "9", LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15, LONGEST_DUMMY_PHONE_NUMBER = repeat(DUMMY_DIGIT, LONGEST_NATIONAL_PHONE_NUMBER_LENGTH), NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/, CREATE_CHARACTER_CLASS_PATTERN = function() {
  return /\[([^\[\]])*\]/g;
}, CREATE_STANDALONE_DIGIT_PATTERN = function() {
  return /\d(?=[^,}][^,}])/g;
}, NON_ALTERING_FORMAT_REG_EXP = new RegExp("[" + VALID_PUNCTUATION + "]*\\$1[" + VALID_PUNCTUATION + "]*(\\$\\d[" + VALID_PUNCTUATION + "]*)*$"), MIN_LEADING_DIGITS_LENGTH = 3, AsYouTypeFormatter = /* @__PURE__ */ function() {
  function me(ue) {
    ue.state;
    var Qe = ue.metadata;
    _classCallCheck$e(this, me), this.metadata = Qe, this.resetFormat();
  }
  return _createClass$d(me, [{
    key: "resetFormat",
    value: function() {
      this.chosenFormat = void 0, this.template = void 0, this.nationalNumberTemplate = void 0, this.populatedNationalNumberTemplate = void 0, this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function(Qe, Ue) {
      this.resetFormat(), Qe ? (this.isNANP = Qe.callingCode() === "1", this.matchingFormats = Qe.formats(), Ue.nationalSignificantNumber && this.narrowDownMatchingFormats(Ue)) : (this.isNANP = void 0, this.matchingFormats = []);
    }
    /**
     * Formats an updated phone number.
     * @param  {string} nextDigits — Additional phone number digits.
     * @param  {object} state — `AsYouType` state.
     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
     */
  }, {
    key: "format",
    value: function(Qe, Ue) {
      var He = this;
      if (canFormatCompleteNumber(Ue.nationalSignificantNumber, this.metadata))
        for (var Ge = _createForOfIteratorHelperLoose(this.matchingFormats), Xe; !(Xe = Ge()).done; ) {
          var Ke = Xe.value, $e = formatCompleteNumber(Ue, Ke, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function(Ze) {
              return He.shouldTryNationalPrefixFormattingRule(Ze, {
                international: Ue.international,
                nationalPrefix: Ue.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: function(Ze) {
              return He.getSeparatorAfterNationalPrefix(Ze);
            }
          });
          if ($e)
            return this.resetFormat(), this.chosenFormat = Ke, this.setNationalNumberTemplate($e.replace(/\d/g, DIGIT_PLACEHOLDER), Ue), this.populatedNationalNumberTemplate = $e, this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(DIGIT_PLACEHOLDER), $e;
        }
      return this.formatNationalNumberWithNextDigits(Qe, Ue);
    }
    // Formats the next phone number digits.
  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function(Qe, Ue) {
      var He = this.chosenFormat, Ge = this.chooseFormat(Ue);
      if (Ge)
        return Ge === He ? this.formatNextNationalNumberDigits(Qe) : this.formatNextNationalNumberDigits(Ue.getNationalDigits());
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function(Qe) {
      var Ue = this, He = Qe.nationalSignificantNumber, Ge = Qe.nationalPrefix, Xe = Qe.international, Ke = He, $e = Ke.length - MIN_LEADING_DIGITS_LENGTH;
      $e < 0 && ($e = 0), this.matchingFormats = this.matchingFormats.filter(function(Je) {
        return Ue.formatSuits(Je, Xe, Ge) && Ue.formatMatches(Je, Ke, $e);
      }), this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1 && this.resetFormat();
    }
  }, {
    key: "formatSuits",
    value: function(Qe, Ue, He) {
      return !(He && !Qe.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !Qe.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !Ue && !He && Qe.nationalPrefixIsMandatoryWhenFormattingInNationalFormat());
    }
  }, {
    key: "formatMatches",
    value: function(Qe, Ue, He) {
      var Ge = Qe.leadingDigitsPatterns().length;
      if (Ge === 0)
        return !0;
      He = Math.min(He, Ge - 1);
      var Xe = Qe.leadingDigitsPatterns()[He];
      if (Ue.length < MIN_LEADING_DIGITS_LENGTH)
        try {
          return new PatternMatcher(Xe).match(Ue, {
            allowOverflow: !0
          }) !== void 0;
        } catch (Ke) {
          return console.error(Ke), !0;
        }
      return new RegExp("^(".concat(Xe, ")")).test(Ue);
    }
  }, {
    key: "getFormatFormat",
    value: function(Qe, Ue) {
      return Ue ? Qe.internationalFormat() : Qe.format();
    }
  }, {
    key: "chooseFormat",
    value: function(Qe) {
      for (var Ue = this, He = function() {
        var Je = Xe.value;
        return Ue.chosenFormat === Je ? "break" : NON_ALTERING_FORMAT_REG_EXP.test(Ue.getFormatFormat(Je, Qe.international)) ? Ue.createTemplateForFormat(Je, Qe) ? (Ue.chosenFormat = Je, "break") : (Ue.matchingFormats = Ue.matchingFormats.filter(function(Ze) {
          return Ze !== Je;
        }), "continue") : "continue";
      }, Ge = _createForOfIteratorHelperLoose(this.matchingFormats.slice()), Xe; !(Xe = Ge()).done; ) {
        var Ke = He();
        if (Ke === "break") break;
      }
      return this.chosenFormat || this.resetFormat(), this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function(Qe, Ue) {
      if (!(Qe.pattern().indexOf("|") >= 0)) {
        var He = this.getTemplateForFormat(Qe, Ue);
        if (He)
          return this.setNationalNumberTemplate(He, Ue), !0;
      }
    }
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: function(Qe) {
      return this.isNANP || Qe && Qe.nationalPrefixFormattingRule() && NATIONAL_PREFIX_SEPARATORS_PATTERN.test(Qe.nationalPrefixFormattingRule()) ? " " : "";
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function(Qe, Ue) {
      var He = Qe.IDDPrefix, Ge = Qe.missingPlus;
      return He ? Ue && Ue.spacing === !1 ? He : He + " " : Ge ? "" : "+";
    }
  }, {
    key: "getTemplate",
    value: function(Qe) {
      if (this.template) {
        for (var Ue = -1, He = 0, Ge = Qe.international ? this.getInternationalPrefixBeforeCountryCallingCode(Qe, {
          spacing: !1
        }) : ""; He < Ge.length + Qe.getDigitsWithoutInternationalPrefix().length; )
          Ue = this.template.indexOf(DIGIT_PLACEHOLDER, Ue + 1), He++;
        return cutAndStripNonPairedParens(this.template, Ue + 1);
      }
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function(Qe, Ue) {
      this.nationalNumberTemplate = Qe, this.populatedNationalNumberTemplate = Qe, this.populatedNationalNumberTemplatePosition = -1, Ue.international ? this.template = this.getInternationalPrefixBeforeCountryCallingCode(Ue).replace(/[\d\+]/g, DIGIT_PLACEHOLDER) + repeat(DIGIT_PLACEHOLDER, Ue.callingCode.length) + " " + Qe : this.template = Qe;
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */
  }, {
    key: "getTemplateForFormat",
    value: function(Qe, Ue) {
      var He = Ue.nationalSignificantNumber, Ge = Ue.international, Xe = Ue.nationalPrefix, Ke = Ue.complexPrefixBeforeNationalSignificantNumber, $e = Qe.pattern();
      $e = $e.replace(CREATE_CHARACTER_CLASS_PATTERN(), "\\d").replace(CREATE_STANDALONE_DIGIT_PATTERN(), "\\d");
      var Je = LONGEST_DUMMY_PHONE_NUMBER.match($e)[0];
      if (!(He.length > Je.length)) {
        var Ze = new RegExp("^" + $e + "$"), nt = He.replace(/\d/g, DUMMY_DIGIT);
        Ze.test(nt) && (Je = nt);
        var tt = this.getFormatFormat(Qe, Ge), et;
        if (this.shouldTryNationalPrefixFormattingRule(Qe, {
          international: Ge,
          nationalPrefix: Xe
        })) {
          var rt = tt.replace(FIRST_GROUP_PATTERN, Qe.nationalPrefixFormattingRule());
          if (parseDigits(Qe.nationalPrefixFormattingRule()) === (Xe || "") + parseDigits("$1") && (tt = rt, et = !0, Xe))
            for (var it = Xe.length; it > 0; )
              tt = tt.replace(/\d/, DIGIT_PLACEHOLDER), it--;
        }
        var ot = Je.replace(new RegExp($e), tt).replace(new RegExp(DUMMY_DIGIT, "g"), DIGIT_PLACEHOLDER);
        return et || (Ke ? ot = repeat(DIGIT_PLACEHOLDER, Ke.length) + " " + ot : Xe && (ot = repeat(DIGIT_PLACEHOLDER, Xe.length) + this.getSeparatorAfterNationalPrefix(Qe) + ot)), Ge && (ot = applyInternationalSeparatorStyle(ot)), ot;
      }
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function(Qe) {
      var Ue = populateTemplateWithDigits(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, Qe);
      if (!Ue) {
        this.resetFormat();
        return;
      }
      return this.populatedNationalNumberTemplate = Ue[0], this.populatedNationalNumberTemplatePosition = Ue[1], cutAndStripNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1);
    }
  }, {
    key: "shouldTryNationalPrefixFormattingRule",
    value: function(Qe, Ue) {
      var He = Ue.international, Ge = Ue.nationalPrefix;
      if (Qe.nationalPrefixFormattingRule()) {
        var Xe = Qe.usesNationalPrefix();
        if (Xe && Ge || !Xe && !He)
          return !0;
      }
    }
  }]), me;
}();
function _slicedToArray$1(me, ue) {
  return _arrayWithHoles$1(me) || _iterableToArrayLimit$1(me, ue) || _unsupportedIterableToArray$1(me, ue) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$1(me, ue) {
  if (me) {
    if (typeof me == "string") return _arrayLikeToArray$1(me, ue);
    var Qe = Object.prototype.toString.call(me).slice(8, -1);
    if (Qe === "Object" && me.constructor && (Qe = me.constructor.name), Qe === "Map" || Qe === "Set") return Array.from(me);
    if (Qe === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Qe)) return _arrayLikeToArray$1(me, ue);
  }
}
function _arrayLikeToArray$1(me, ue) {
  (ue == null || ue > me.length) && (ue = me.length);
  for (var Qe = 0, Ue = new Array(ue); Qe < ue; Qe++)
    Ue[Qe] = me[Qe];
  return Ue;
}
function _iterableToArrayLimit$1(me, ue) {
  var Qe = me == null ? null : typeof Symbol < "u" && me[Symbol.iterator] || me["@@iterator"];
  if (Qe != null) {
    var Ue = [], He = !0, Ge = !1, Xe, Ke;
    try {
      for (Qe = Qe.call(me); !(He = (Xe = Qe.next()).done) && (Ue.push(Xe.value), !(ue && Ue.length === ue)); He = !0)
        ;
    } catch ($e) {
      Ge = !0, Ke = $e;
    } finally {
      try {
        !He && Qe.return != null && Qe.return();
      } finally {
        if (Ge) throw Ke;
      }
    }
    return Ue;
  }
}
function _arrayWithHoles$1(me) {
  if (Array.isArray(me)) return me;
}
function _classCallCheck$d(me, ue) {
  if (!(me instanceof ue))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1(me, ue) {
  for (var Qe = 0; Qe < ue.length; Qe++) {
    var Ue = ue[Qe];
    Ue.enumerable = Ue.enumerable || !1, Ue.configurable = !0, "value" in Ue && (Ue.writable = !0), Object.defineProperty(me, Ue.key, Ue);
  }
}
function _createClass$c(me, ue, Qe) {
  return ue && _defineProperties$1(me.prototype, ue), Object.defineProperty(me, "prototype", { writable: !1 }), me;
}
var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART = "[" + VALID_PUNCTUATION + VALID_DIGITS + "]+", VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN = new RegExp("^" + VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART + "$", "i"), VALID_FORMATTED_PHONE_NUMBER_PART = "(?:[" + PLUS_CHARS + "][" + VALID_PUNCTUATION + VALID_DIGITS + "]*|[" + VALID_PUNCTUATION + VALID_DIGITS + "]+)", AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp("[^" + VALID_PUNCTUATION + VALID_DIGITS + "]+.*$"), COMPLEX_NATIONAL_PREFIX = /[^\d\[\]]/, AsYouTypeParser = /* @__PURE__ */ function() {
  function me(ue) {
    var Qe = ue.defaultCountry, Ue = ue.defaultCallingCode, He = ue.metadata, Ge = ue.onNationalSignificantNumberChange;
    _classCallCheck$d(this, me), this.defaultCountry = Qe, this.defaultCallingCode = Ue, this.metadata = He, this.onNationalSignificantNumberChange = Ge;
  }
  return _createClass$c(me, [{
    key: "input",
    value: function(Qe, Ue) {
      var He = extractFormattedDigitsAndPlus(Qe), Ge = _slicedToArray$1(He, 2), Xe = Ge[0], Ke = Ge[1], $e = parseDigits(Xe), Je;
      return Ke && (Ue.digits || (Ue.startInternationalNumber(), $e || (Je = !0))), $e && this.inputDigits($e, Ue), {
        digits: $e,
        justLeadingPlus: Je
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */
  }, {
    key: "inputDigits",
    value: function(Qe, Ue) {
      var He = Ue.digits, Ge = He.length < 3 && He.length + Qe.length >= 3;
      if (Ue.appendDigits(Qe), Ge && this.extractIddPrefix(Ue), this.isWaitingForCountryCallingCode(Ue)) {
        if (!this.extractCountryCallingCode(Ue))
          return;
      } else
        Ue.appendNationalSignificantNumberDigits(Qe);
      Ue.international || this.hasExtractedNationalSignificantNumber || this.extractNationalSignificantNumber(Ue.getNationalDigits(), function(Xe) {
        return Ue.update(Xe);
      });
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function(Qe) {
      var Ue = Qe.international, He = Qe.callingCode;
      return Ue && !He;
    }
    // Extracts a country calling code from a number
    // being entered in internatonal format.
  }, {
    key: "extractCountryCallingCode",
    value: function(Qe) {
      var Ue = extractCountryCallingCode("+" + Qe.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), He = Ue.countryCallingCode, Ge = Ue.number;
      if (He)
        return Qe.setCallingCode(He), Qe.update({
          nationalSignificantNumber: Ge
        }), !0;
    }
  }, {
    key: "reset",
    value: function(Qe) {
      if (Qe) {
        this.hasSelectedNumberingPlan = !0;
        var Ue = Qe._nationalPrefixForParsing();
        this.couldPossiblyExtractAnotherNationalSignificantNumber = Ue && COMPLEX_NATIONAL_PREFIX.test(Ue);
      } else
        this.hasSelectedNumberingPlan = void 0, this.couldPossiblyExtractAnotherNationalSignificantNumber = void 0;
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */
  }, {
    key: "extractNationalSignificantNumber",
    value: function(Qe, Ue) {
      if (this.hasSelectedNumberingPlan) {
        var He = extractNationalNumberFromPossiblyIncompleteNumber(Qe, this.metadata), Ge = He.nationalPrefix, Xe = He.nationalNumber, Ke = He.carrierCode;
        if (Xe !== Qe)
          return this.onExtractedNationalNumber(Ge, Ke, Xe, Qe, Ue), !0;
      }
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */
  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function(Qe, Ue, He) {
      if (!this.hasExtractedNationalSignificantNumber)
        return this.extractNationalSignificantNumber(Qe, He);
      if (this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        var Ge = extractNationalNumberFromPossiblyIncompleteNumber(Qe, this.metadata), Xe = Ge.nationalPrefix, Ke = Ge.nationalNumber, $e = Ge.carrierCode;
        if (Ke !== Ue)
          return this.onExtractedNationalNumber(Xe, $e, Ke, Qe, He), !0;
      }
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function(Qe, Ue, He, Ge, Xe) {
      var Ke, $e, Je = Ge.lastIndexOf(He);
      if (Je >= 0 && Je === Ge.length - He.length) {
        $e = !0;
        var Ze = Ge.slice(0, Je);
        Ze !== Qe && (Ke = Ze);
      }
      Xe({
        nationalPrefix: Qe,
        carrierCode: Ue,
        nationalSignificantNumber: He,
        nationalSignificantNumberMatchesInput: $e,
        complexPrefixBeforeNationalSignificantNumber: Ke
      }), this.hasExtractedNationalSignificantNumber = !0, this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function(Qe) {
      if (this.extractAnotherNationalSignificantNumber(Qe.getNationalDigits(), Qe.nationalSignificantNumber, function(Ue) {
        return Qe.update(Ue);
      }))
        return !0;
      if (this.extractIddPrefix(Qe))
        return this.extractCallingCodeAndNationalSignificantNumber(Qe), !0;
      if (this.fixMissingPlus(Qe))
        return this.extractCallingCodeAndNationalSignificantNumber(Qe), !0;
    }
  }, {
    key: "extractIddPrefix",
    value: function(Qe) {
      var Ue = Qe.international, He = Qe.IDDPrefix, Ge = Qe.digits;
      if (Qe.nationalSignificantNumber, !(Ue || He)) {
        var Xe = stripIddPrefix(Ge, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
        if (Xe !== void 0 && Xe !== Ge)
          return Qe.update({
            IDDPrefix: Ge.slice(0, Ge.length - Xe.length)
          }), this.startInternationalNumber(Qe, {
            country: void 0,
            callingCode: void 0
          }), !0;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function(Qe) {
      if (!Qe.international) {
        var Ue = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(Qe.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), He = Ue.countryCallingCode;
        if (Ue.number, He)
          return Qe.update({
            missingPlus: !0
          }), this.startInternationalNumber(Qe, {
            country: Qe.country,
            callingCode: He
          }), !0;
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function(Qe, Ue) {
      var He = Ue.country, Ge = Ue.callingCode;
      Qe.startInternationalNumber(He, Ge), Qe.nationalSignificantNumber && (Qe.resetNationalSignificantNumber(), this.onNationalSignificantNumberChange(), this.hasExtractedNationalSignificantNumber = void 0);
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function(Qe) {
      this.extractCountryCallingCode(Qe) && this.extractNationalSignificantNumber(Qe.getNationalDigits(), function(Ue) {
        return Qe.update(Ue);
      });
    }
  }]), me;
}();
function extractFormattedPhoneNumber(me) {
  var ue = me.search(VALID_FORMATTED_PHONE_NUMBER_PART);
  if (!(ue < 0)) {
    me = me.slice(ue);
    var Qe;
    return me[0] === "+" && (Qe = !0, me = me.slice(1)), me = me.replace(AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, ""), Qe && (me = "+" + me), me;
  }
}
function _extractFormattedDigitsAndPlus(me) {
  var ue = extractFormattedPhoneNumber(me) || "";
  return ue[0] === "+" ? [ue.slice(1), !0] : [ue];
}
function extractFormattedDigitsAndPlus(me) {
  var ue = _extractFormattedDigitsAndPlus(me), Qe = _slicedToArray$1(ue, 2), Ue = Qe[0], He = Qe[1];
  return VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN.test(Ue) || (Ue = ""), [Ue, He];
}
function _slicedToArray(me, ue) {
  return _arrayWithHoles(me) || _iterableToArrayLimit(me, ue) || _unsupportedIterableToArray(me, ue) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray(me, ue) {
  if (me) {
    if (typeof me == "string") return _arrayLikeToArray(me, ue);
    var Qe = Object.prototype.toString.call(me).slice(8, -1);
    if (Qe === "Object" && me.constructor && (Qe = me.constructor.name), Qe === "Map" || Qe === "Set") return Array.from(me);
    if (Qe === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Qe)) return _arrayLikeToArray(me, ue);
  }
}
function _arrayLikeToArray(me, ue) {
  (ue == null || ue > me.length) && (ue = me.length);
  for (var Qe = 0, Ue = new Array(ue); Qe < ue; Qe++)
    Ue[Qe] = me[Qe];
  return Ue;
}
function _iterableToArrayLimit(me, ue) {
  var Qe = me == null ? null : typeof Symbol < "u" && me[Symbol.iterator] || me["@@iterator"];
  if (Qe != null) {
    var Ue = [], He = !0, Ge = !1, Xe, Ke;
    try {
      for (Qe = Qe.call(me); !(He = (Xe = Qe.next()).done) && (Ue.push(Xe.value), !(ue && Ue.length === ue)); He = !0)
        ;
    } catch ($e) {
      Ge = !0, Ke = $e;
    } finally {
      try {
        !He && Qe.return != null && Qe.return();
      } finally {
        if (Ge) throw Ke;
      }
    }
    return Ue;
  }
}
function _arrayWithHoles(me) {
  if (Array.isArray(me)) return me;
}
function _classCallCheck$c(me, ue) {
  if (!(me instanceof ue))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(me, ue) {
  for (var Qe = 0; Qe < ue.length; Qe++) {
    var Ue = ue[Qe];
    Ue.enumerable = Ue.enumerable || !1, Ue.configurable = !0, "value" in Ue && (Ue.writable = !0), Object.defineProperty(me, Ue.key, Ue);
  }
}
function _createClass$b(me, ue, Qe) {
  return ue && _defineProperties(me.prototype, ue), Object.defineProperty(me, "prototype", { writable: !1 }), me;
}
var AsYouType$1 = /* @__PURE__ */ function() {
  function me(ue, Qe) {
    _classCallCheck$c(this, me), this.metadata = new Metadata$1(Qe);
    var Ue = this.getCountryAndCallingCode(ue), He = _slicedToArray(Ue, 2), Ge = He[0], Xe = He[1];
    this.defaultCountry = Ge, this.defaultCallingCode = Xe, this.reset();
  }
  return _createClass$b(me, [{
    key: "getCountryAndCallingCode",
    value: function(Qe) {
      var Ue, He;
      return Qe && (isObject$7(Qe) ? (Ue = Qe.defaultCountry, He = Qe.defaultCallingCode) : Ue = Qe), Ue && !this.metadata.hasCountry(Ue) && (Ue = void 0), [Ue, He];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */
  }, {
    key: "input",
    value: function(Qe) {
      var Ue = this.parser.input(Qe, this.state), He = Ue.digits, Ge = Ue.justLeadingPlus;
      if (Ge)
        this.formattedOutput = "+";
      else if (He) {
        this.determineTheCountryIfNeeded(), this.state.nationalSignificantNumber && this.formatter.narrowDownMatchingFormats(this.state);
        var Xe;
        if (this.metadata.hasSelectedNumberingPlan() && (Xe = this.formatter.format(He, this.state)), Xe === void 0 && this.parser.reExtractNationalSignificantNumber(this.state)) {
          this.determineTheCountryIfNeeded();
          var Ke = this.state.getNationalDigits();
          Ke && (Xe = this.formatter.format(Ke, this.state));
        }
        this.formattedOutput = Xe ? this.getFullNumber(Xe) : this.getNonFormattedNumber();
      }
      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function() {
      var Qe = this;
      return this.state = new AsYouTypeState({
        onCountryChange: function(He) {
          Qe.country = He;
        },
        onCallingCodeChange: function(He, Ge) {
          Qe.metadata.selectNumberingPlan(Ge, He), Qe.formatter.reset(Qe.metadata.numberingPlan, Qe.state), Qe.parser.reset(Qe.metadata.numberingPlan);
        }
      }), this.formatter = new AsYouTypeFormatter({
        state: this.state,
        metadata: this.metadata
      }), this.parser = new AsYouTypeParser({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function() {
          Qe.determineTheCountryIfNeeded(), Qe.formatter.reset(Qe.metadata.numberingPlan, Qe.state);
        }
      }), this.state.reset({
        country: this.defaultCountry,
        callingCode: this.defaultCallingCode
      }), this.formattedOutput = "", this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */
  }, {
    key: "isInternational",
    value: function() {
      return this.state.international;
    }
    /**
     * Returns the "calling code" part of the phone number when it's being input
     * in an international format.
     * If no valid calling code has been entered so far, returns `undefined`.
     * @return {string} [callingCode]
     */
  }, {
    key: "getCallingCode",
    value: function() {
      if (this.isInternational())
        return this.state.callingCode;
    }
    // A legacy alias.
  }, {
    key: "getCountryCallingCode",
    value: function() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */
  }, {
    key: "getCountry",
    value: function() {
      var Qe = this.state.digits;
      if (Qe)
        return this._getCountry();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * @return {string} [country]
     */
  }, {
    key: "_getCountry",
    value: function() {
      var Qe = this.state.country;
      return Qe;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function() {
      (!this.state.country || this.isCountryCallingCodeAmbiguous()) && this.determineTheCountry();
    }
    // Prepends `+CountryCode ` in case of an international phone number
  }, {
    key: "getFullNumber",
    value: function(Qe) {
      var Ue = this;
      if (this.isInternational()) {
        var He = function(Ke) {
          return Ue.formatter.getInternationalPrefixBeforeCountryCallingCode(Ue.state, {
            spacing: !!Ke
          }) + Ke;
        }, Ge = this.state.callingCode;
        return He(Ge ? Qe ? "".concat(Ge, " ").concat(Qe) : Ge : "".concat(this.state.getDigitsWithoutInternationalPrefix()));
      }
      return Qe;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function() {
      var Qe = this.state, Ue = Qe.nationalSignificantNumber, He = Qe.complexPrefixBeforeNationalSignificantNumber, Ge = Qe.nationalPrefix, Xe = Ue, Ke = He || Ge;
      return Ke && (Xe = Ke + Xe), Xe;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function() {
      var Qe = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(Qe ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function() {
      var Qe = this.getNonFormattedNumber();
      if (Qe)
        return Qe.replace(/[\+\d]/g, DIGIT_PLACEHOLDER);
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function() {
      var Qe = this.state.callingCode, Ue = this.metadata.getCountryCodesForCallingCode(Qe);
      return Ue && Ue.length > 1;
    }
    // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.
  }, {
    key: "determineTheCountry",
    value: function() {
      this.state.setCountry(getCountryByCallingCode(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
        nationalNumber: this.state.nationalSignificantNumber,
        defaultCountry: this.defaultCountry,
        metadata: this.metadata
      }));
    }
    /**
     * Returns a E.164 phone number value for the user's input.
     *
     * For example, for country `"US"` and input `"(222) 333-4444"`
     * it will return `"+12223334444"`.
     *
     * For international phone number input, it will also auto-correct
     * some minor errors such as using a national prefix when writing
     * an international phone number. For example, if the user inputs
     * `"+44 0 7400 000000"` then it will return an auto-corrected
     * `"+447400000000"` phone number value.
     *
     * Will return `undefined` if no digits have been input,
     * or when inputting a phone number in national format and no
     * default country or default "country calling code" have been set.
     *
     * @return {string} [value]
     */
  }, {
    key: "getNumberValue",
    value: function() {
      var Qe = this.state, Ue = Qe.digits, He = Qe.callingCode, Ge = Qe.country, Xe = Qe.nationalSignificantNumber;
      if (Ue) {
        if (this.isInternational())
          return He ? "+" + He + Xe : "+" + Ue;
        if (Ge || He) {
          var Ke = Ge ? this.metadata.countryCallingCode() : He;
          return "+" + Ke + Xe;
        }
      }
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */
  }, {
    key: "getNumber",
    value: function() {
      var Qe = this.state, Ue = Qe.nationalSignificantNumber, He = Qe.carrierCode, Ge = Qe.callingCode, Xe = this._getCountry();
      if (Ue && !(!Xe && !Ge)) {
        if (Xe && Xe === this.defaultCountry) {
          var Ke = new Metadata$1(this.metadata.metadata);
          Ke.selectNumberingPlan(Xe);
          var $e = Ke.numberingPlan.callingCode(), Je = this.metadata.getCountryCodesForCallingCode($e);
          if (Je.length > 1) {
            var Ze = getCountryByNationalNumber(Ue, {
              countries: Je,
              defaultCountry: this.defaultCountry,
              metadata: this.metadata.metadata
            });
            Ze && (Xe = Ze);
          }
        }
        var nt = new PhoneNumber(Xe || Ge, Ue, this.metadata.metadata);
        return He && (nt.carrierCode = He), nt;
      }
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */
  }, {
    key: "isPossible",
    value: function() {
      var Qe = this.getNumber();
      return Qe ? Qe.isPossible() : !1;
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */
  }, {
    key: "isValid",
    value: function() {
      var Qe = this.getNumber();
      return Qe ? Qe.isValid() : !1;
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */
  }, {
    key: "getNationalNumber",
    value: function() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */
  }, {
    key: "getChars",
    value: function() {
      return (this.state.international ? "+" : "") + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */
  }, {
    key: "getTemplate",
    value: function() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || "";
    }
  }]), me;
}();
function parsePhoneNumber() {
  return withMetadataArgument(parsePhoneNumber$1, arguments);
}
function AsYouType(me) {
  return AsYouType$1.call(this, me, metadata);
}
AsYouType.prototype = Object.create(AsYouType$1.prototype, {});
AsYouType.prototype.constructor = AsYouType;
function getCountryCallingCode() {
  return withMetadataArgument(getCountryCallingCode$1, arguments);
}
const initialState = {
  phoneNumber: "",
  nextButtonDisabled: !0
}, PhoneAction = {
  SET_PHONE_NUMBER: "SET_PHONE_NUMBER",
  SET_NEXT_BUTTON_STATUS: "SET_NEXT_BUTTON_STATUS"
}, phoneReducer = (me, ue) => {
  switch (ue.type) {
    case PhoneAction.SET_PHONE_NUMBER:
      return { ...me, phoneNumber: ue.payload };
    case PhoneAction.SET_NEXT_BUTTON_STATUS:
      return { ...me, nextButtonDisabled: ue.payload };
    default:
      return me;
  }
}, PhoneStateContext = createContext(null), PhoneDispatcherContext = createContext(null), PhoneContextProvider = ({
  children: me
}) => {
  const [ue, Qe] = useReducer(phoneReducer, initialState);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PhoneDispatcherContext.Provider, { value: Qe, children: /* @__PURE__ */ jsxRuntimeExports.jsx(PhoneStateContext.Provider, { value: ue, children: me }) });
}, usePhoneState = () => {
  const me = useContext(PhoneStateContext);
  if (!me)
    throw new Error(
      "Phone State Context must be used within PhoneStateContext"
    );
  return me;
}, usePhoneDispatcher = () => {
  const me = useContext(PhoneDispatcherContext);
  if (!me)
    throw new Error(
      "Phone State Dispatcher must be used within PhoneDispatcherContext"
    );
  return me;
}, asYouType$2 = new AsYouType(), PhoneInput = ({ country: me, onChange: ue, maxLength: Qe }) => {
  const [Ue, He] = useState(""), Ge = usePhoneDispatcher();
  useEffect(() => {
    Ge({ type: PhoneAction.SET_PHONE_NUMBER, payload: "" }), He(""), ue == null || ue("", !1);
  }, [me]);
  const Xe = ({
    target: { value: Ke }
  }) => {
    if (me) {
      const $e = Qe ? Ke.replace(/\s/g, "").slice(0, Qe) : Ke, Je = `${me.code}${$e}`, Ze = parsePhoneNumber(Je), tt = asYouType$2.input(Je).replace(me.code, "");
      He(tt), asYouType$2.reset();
      const et = (Ze == null ? void 0 : Ze.isValid()) ?? !1;
      et ? (Ge({ type: PhoneAction.SET_PHONE_NUMBER, payload: Je }), Ge({ type: PhoneAction.SET_NEXT_BUTTON_STATUS, payload: !1 })) : Ge({ type: PhoneAction.SET_NEXT_BUTTON_STATUS, payload: !0 }), ue == null || ue(Je, !!et);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Phone$2,
    {
      className: "phone-input",
      value: Ue,
      onChange: Xe,
      type: "tel",
      id: "phone-input-selector"
    }
  ) });
}, NextButton = ({
  handleNext: me,
  buttonTitle: ue,
  disableButton: Qe = !1
}) => {
  const { nextButtonDisabled: Ue, phoneNumber: He } = usePhoneState(), Ge = () => {
    me(He);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    StyledButton$6,
    {
      onClick: Ge,
      disabled: Ue || Qe,
      children: ue
    }
  );
}, arrowDown = "data:image/svg+xml,%3csvg%20width='10'%20height='10'%20viewBox='0%200%2010%2010'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M4.0575%208.85899C4.00917%208.8119%203.8025%208.63411%203.6325%208.4685C2.56333%207.49756%200.813333%204.96468%200.279167%203.63898C0.193333%203.43765%200.0116667%202.92864%200%202.65668C0%202.39609%200.06%202.14767%200.181667%201.91062C0.351667%201.61511%200.619167%201.37806%200.935%201.24817C1.15417%201.16455%201.81%201.03466%201.82167%201.03466C2.53917%200.904772%203.705%200.833332%204.99333%200.833332C6.22083%200.833332%207.33917%200.904772%208.0675%201.01112C8.07917%201.0233%208.89417%201.15319%209.17333%201.29526C9.68333%201.55585%2010%202.06486%2010%202.60959V2.65668C9.9875%203.01145%209.67083%203.75751%209.65917%203.75751C9.12417%205.01177%207.46%207.4862%206.35417%208.48068C6.35417%208.48068%206.07%208.76076%205.8925%208.88253C5.6375%209.07249%205.32167%209.16667%205.00583%209.16667C4.65333%209.16667%204.325%209.06032%204.0575%208.85899Z'%20fill='%232B2B2B'/%3e%3c/svg%3e", useCountryItems = () => {
  const { t: me } = useTranslation(), [ue] = useState(() => {
    const Ue = /* @__PURE__ */ new Map();
    return Object.keys(countries).forEach((He) => {
      const Ge = `+${getCountryCallingCode(He)}`;
      Ue.set(
        He,
        // @ts-ignore
        {
          ...countries[He],
          name: me(`countries.${He}`),
          id: He,
          code: Ge
        }
      );
    }), Ue;
  });
  return {
    countryItems: ue,
    getCountryByISOCode: (Ue) => ue.get(Ue)
  };
}, Phone$1 = ({
  countryISOCode: me,
  translations: ue,
  handleNext: Qe,
  shouldDisableNextButton: Ue = !1,
  optinEnabled: He = !1,
  optInOnChange: Ge = emptyFunc,
  isInstantVerify: Xe = !1,
  displayContinueButton: Ke = !0,
  onChange: $e,
  onStepChange: Je,
  disableCountrySelector: Ze = !1,
  maxLength: nt = null
}) => {
  const { countryItems: tt, getCountryByISOCode: et } = useCountryItems(), [rt, it] = useState([]), [ot, at] = useState(), st = useRef(null), ut = useRef(null), {
    state: lt,
    actions: { toggle: dt, off: At }
  } = useToggle(!1);
  useEffect(() => {
    it(Array.from(tt.values()));
    const gt = tt.get(me) ?? tt.get("MX");
    at(gt);
  }, [me]), useLayoutEffect(() => {
    var gt;
    ut.current && st.current && (ut.current.style.left = "0", ut.current.style.top = `${(gt = st.current) == null ? void 0 : gt.offsetHeight}px`);
  }, [lt]);
  const pt = (gt) => {
    const wt = et(gt);
    At(), wt && at(wt);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PhoneContextProvider, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(PhoneContainer, { className: "phone-container", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(PhoneSelectorWrapper, { className: "phone-container", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        PhoneLabel,
        {
          ref: st,
          htmlFor: "phone-input-selector",
          id: "phone-label",
          children: /* @__PURE__ */ jsxRuntimeExports.jsxs(PhoneInputWrapper, { className: "phone-input-wrapper", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs(
              CountryButtonSelector,
              {
                onClick: Ze ? void 0 : dt,
                role: "combobox",
                type: "button",
                "aria-expanded": lt,
                "aria-owns": "country-list",
                "aria-haspopup": "listbox",
                "aria-labelledby": "phone-label",
                "aria-autocomplete": "list",
                className: "country-button-selector",
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: ot == null ? void 0 : ot.emoji }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: ot == null ? void 0 : ot.code }),
                  Ze ? null : /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: arrowDown, alt: "arrow down" }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(SelectorDivider, { className: "selector-divider" })
                ]
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              PhoneInput,
              {
                country: ot,
                onChange: $e,
                "aria-autocomplete": "list",
                "aria-controls": "country-list",
                maxLength: nt
              }
            )
          ] })
        }
      ),
      Xe ? /* @__PURE__ */ jsxRuntimeExports.jsx(EmailLink$1, { onClick: Je, children: ue.instantVerifyEmailLink }) : null
    ] }),
    lt ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      CountryList,
      {
        closeList: At,
        searchPlaceholder: ue.searchForCountry,
        ref: ut,
        onHandleChange: pt,
        list: rt,
        selectedCountry: ot == null ? void 0 : ot.id
      }
    ) : null,
    He ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      Checkbox,
      {
        id: "optInEnabledCheckbox",
        handleChange: Ge,
        text: ue.finishGptOptInLabel,
        defaultChecked: He
      }
    ) : null,
    Ke ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      NextButton,
      {
        disableButton: !!Ue,
        handleNext: Qe,
        buttonTitle: ue.nextButtonTitle
      }
    ) : null
  ] }) });
}, SpinnerContainer$3 = qe.div`
  position: relative;
  height: 40px;

  @keyframes spinner {
    to {
      transform: rotate(360deg);
    }
  }

  @keyframes reverse-spinner {
    to {
      transform: rotate(-360deg);
    }
  }

  .loader-img {
    position: absolute;
    max-width: unset;
  }

  .outter {
    left: calc(50% - 21px);
    animation: spinner 0.6s linear infinite;
  }

  .inner {
    top: 6px;
    left: calc(50% - 15px);
    animation: reverse-spinner 0.6s linear infinite;
  }
`, Spinner$5 = ({
  outerColor: me = "#00B2FD",
  innerColor: ue = "#21273B"
}) => {
  const Qe = ({ className: He }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    "svg",
    {
      className: He,
      width: "40px",
      height: "40px",
      viewBox: "0 0 40 40",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "g",
        {
          transform: "translate(2.000000, 2.000000)",
          stroke: me,
          strokeWidth: "3",
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M18,36 C27.941,36 36,27.941 36,18 C36,8.059 27.941,0 18,0 C8.059,0 0,8.059 0,18",
              id: "Path"
            }
          )
        }
      ) })
    }
  ), Ue = ({ className: He }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    "svg",
    {
      className: He,
      width: "28px",
      height: "28px",
      viewBox: "0 0 28 28",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "g",
        {
          transform: "translate(2.000000, 2.000000)",
          stroke: ue,
          strokeWidth: "3",
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "path",
            {
              d: "M12,24 C18.6273333,24 24,18.6273333 24,12 C24,5.37266667 18.6273333,0 12,0 C5.37266667,0 0,5.37266667 0,12",
              id: "Path",
              transform: "translate(12.000000, 12.000000) rotate(180.000000) translate(-12.000000, -12.000000) "
            }
          )
        }
      ) })
    }
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(SpinnerContainer$3, { className: "IncodeBandwidthSpinner", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Qe, { className: "loader-img outter", alt: "loading..." }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Ue, { className: "loader-img inner", alt: "loading..." })
  ] });
}, useUrlTheme = () => {
  const [me, ue] = useState({
    main: "#3db0f7",
    buttonBorderRadius: "31px",
    buttonColor: "#fff",
    modal: {},
    mainButton: {},
    secondaryButton: {},
    primary: "#3db0f7",
    secondary: "#21273B"
  });
  return useEffect(() => {
    const Qe = () => {
      const Ge = new URLSearchParams(window.location.search).get("theme");
      if (Ge) {
        const Xe = decodeURIComponent(Ge), Ke = JSON.parse(Xe), $e = Object.assign({}, me);
        Ke != null && Ke.primary && ($e.main = Ke == null ? void 0 : Ke.primary, $e.primary = Ke == null ? void 0 : Ke.primary, $e.secondary = Ke == null ? void 0 : Ke.secondary, $e.isUrlTheme = !0, ue($e));
      }
    };
    Qe();
    const Ue = () => Qe();
    return window.addEventListener("popstate", Ue), () => window.removeEventListener("popstate", Ue);
  }, []), me;
}, SpinnerContainer$2 = qe.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  text-align: center;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
`, Loader$2 = () => {
  const me = useUrlTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SpinnerContainer$2, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Spinner$5,
    {
      outerColor: me == null ? void 0 : me.primary,
      innerColor: me == null ? void 0 : me.secondary
    }
  ) });
}, Container$f = qe.div`
  width: 100%;
  height: 100%;
`, RootContainer = ({
  cssSelector: me,
  children: ue
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(Container$f, { className: classNames("IncodeRootContainer", me), children: ue }), srOnlyHeadingStyles = Ae`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
`, SrOnlyHeading = qe.h1`
  ${srOnlyHeadingStyles}
`, HiddenTitle = qe.h1`
  border: 0;
  clip: rect(0 0 0 0);
  height: 0;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 0;
  text-indent: -9999px;
  line-height: 0;
`;
qe.div`
  position: relative;
  height: 100%;
`;
qe.button`
  box-sizing: border-box;
  color: #333;
  cursor: pointer;
  padding: 8px 52px 8px 10px;
  transition: all 0.2s ease;
  background-color: transparent;
  width: 100%;
  padding-bottom: 15px;
  padding-top: 15px;
  position: relative;
  overflow: hidden;
  text-align: left;
  border: 1px solid #ccc;
  border-bottom: ${(me) => me.isDropdownOpen ? "none" : "1px solid #ccc"};
  border-radius: ${(me) => me.isDropdownOpen ? "4px 4px 0 0;" : "4px"};

  &::after {
    content: '';
    position: absolute;
    right: 10px;
    top: 60%;
    transform: translateY(-50%);
    border: 5px solid transparent;
    border-top-color: #999;
    border-bottom: 0;
    margin-top: -2.5px;
  }
`;
qe.ul`
  width: 100%;
  visibility: ${(me) => me.isDropdownOpen ? "visible" : "hidden"};
  opacity: ${(me) => me.isDropdownOpen ? 1 : 0};
  transition: opacity 0.3s ease, visibility 0.3s ease;
  position: absolute;
  z-index: 10;
  border: 1px solid #ccc;
  top: 100%;
  border-top: ${(me) => me.isDropdownOpen ? "none" : "1px solid #ccc"};
  border-radius: 0 0 4px 4px;
  max-height: 150px;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
`;
const StyledDropdownOption = qe.li`
  padding: 10px;
  background-color: ${(me) => me.isSelected ? "#DDD" : "transparent"};
  cursor: pointer;

  &:hover {
    background-color: #eee;
  }

  &:focus {
    color: green;
  }
`;
React__default.forwardRef(({ id: me, isSelected: ue, children: Qe, onClick: Ue, tabIndex: He }, Ge) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  StyledDropdownOption,
  {
    id: me,
    ref: Ge,
    isSelected: ue,
    onClick: Ue,
    role: "option",
    tabIndex: He,
    children: Qe
  }
));
const AutocompleteContainer = qe.div`
  display: flex;
  position: relative;
`, InputContainer$4 = qe.div`
  position: relative;
  width: 100%;
  margin: 8px 0;
  background-color: rgba(33, 30, 59, 0.07);
  border-radius: 7px;
  padding: 5px;
  height: 60px;
  min-height: 60px;

  &.error-input {
    border: solid 0.9px #ff5c6f;
    background-color: rgba(255, 92, 111, 0.1);
  }

  @media only screen and (max-height: 480px) {
    margin: 5px 0 0 0;
    height: 50px;
    min-height: 50px;
  }
`, Label$2 = qe.label`
  opacity: 0.7;
  font-size: 12px;
  line-height: 1.5;
  color: #21273b;
  display: inline-block;
  font-weight: bold;
  margin-left: 5px;
`, Input$7 = qe.input`
  background-color: transparent;
  width: 100%;
  border: none;
  display: flex;
  line-height: 1.5;
  appearance: none;
  font-size: 16px;
  color: #21273b;
  font-weight: bold;
  &:disabled {
    background-color: rgba(33, 39, 59, 0.1);
    border: none;
    color: #21273b;
    opacity: 1;
  }
`, MAX_LIST_HEIGHT = 200, AutocompleteList = qe.ul`
  position: absolute;
  border-top-right-radius: ${({ position: me }) => me === "top" ? "0" : "13px"};
  border-top-left-radius: ${({ position: me }) => me === "top" ? "0" : "13px"};
  border-bottom-right-radius: ${({ position: me }) => me === "top" ? "13px" : "0"};
  border-bottom-left-radius: ${({ position: me }) => me === "top" ? "13px" : "0"};
  background-color: #fff;
  border: 0.8px solid #20263d;
  width: 100%;
  z-index: 100;
  max-height: ${MAX_LIST_HEIGHT}px;
  overflow-y: auto;
  overscroll-behavior: contain;
  top: ${({ top: me }) => me}px;
`, ListItem = qe.li`
  cursor: pointer;
  list-style-type: none;
  padding: 5px 10px;
  border-bottom: 1px solid #f3f3f3;
  font-size: 12px;
  display: flex;
  align-items: center;

  &:hover {
    background-color: #f3f3f3;
  }

  &:last-child {
    border-bottom: unset;
  }
`, ErrorMessage$6 = qe.p`
  height: auto;
  margin: 0;
  width: 100%;
`, IconWrapper = qe.span`
  display: inline-block;
  margin-right: 10px;
`;
forwardRef(
  ({ id: me, label: ue, error: Qe, options: Ue, value: He, onOptionSelect: Ge, icon: Xe, ...Ke }, $e) => {
    const [Je, Ze] = useState(!1), [nt, tt] = useState(null), et = useRef(null), rt = useRef(null), it = useRef(null), ot = useRef(() => {
      var pt, gt, wt;
      const lt = window.innerHeight, dt = ((gt = (pt = rt.current) == null ? void 0 : pt.getBoundingClientRect()) == null ? void 0 : gt.bottom) ?? 0;
      let At = ((wt = rt.current) == null ? void 0 : wt.offsetHeight) ?? 0;
      lt < dt + MAX_LIST_HEIGHT && (At = -(MAX_LIST_HEIGHT - 10)), tt(At);
    });
    useEffect(() => {
      var dt;
      if (!it.current)
        return;
      const lt = () => {
        ot.current(), Ze(!0);
      };
      return (dt = it.current) == null || dt.addEventListener("focus", lt), () => {
        var At;
        (At = it.current) == null || At.removeEventListener("focus", lt);
      };
    }, []), useEffect(() => {
      const lt = (At) => {
        var pt;
        At.target === et.current || (pt = et.current) != null && pt.contains(At.target) || ot.current();
      }, dt = (At) => {
        var pt;
        At.target === it.current || At.target === et.current || (pt = et.current) != null && pt.contains(At.target) || Ze(!1);
      };
      return window.addEventListener("click", dt), window.addEventListener("wheel", lt), () => {
        window.removeEventListener("click", dt), window.removeEventListener("wheel", lt);
      };
    }, []);
    const at = (lt) => {
      it.current = lt, typeof $e == "function" ? $e(lt) : $e && ($e.current = lt);
    }, st = (lt) => {
      Ze(!1), tt(null), Ge(lt);
    }, ut = Ue.length > 0 && Je && He;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorMessage$6, { children: Qe }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(AutocompleteContainer, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          InputContainer$4,
          {
            ref: rt,
            className: Qe ? "error-input" : void 0,
            children: [
              ue ? /* @__PURE__ */ jsxRuntimeExports.jsx(Label$2, { htmlFor: me, children: ue }) : null,
              /* @__PURE__ */ jsxRuntimeExports.jsx(Input$7, { ref: at, id: me, ...Ke })
            ]
          }
        ),
        ut ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          AutocompleteList,
          {
            ref: et,
            top: nt ?? 0,
            position: (nt ?? 0) > 0 ? "top" : "bottom",
            children: Ue.map((lt) => /* @__PURE__ */ jsxRuntimeExports.jsxs(ListItem, { onClick: () => st(lt), children: [
              Xe ? /* @__PURE__ */ jsxRuntimeExports.jsx(IconWrapper, { children: Xe }) : null,
              lt.label
            ] }, lt.id))
          }
        ) : null
      ] })
    ] });
  }
);
const ConsentWrapper$1 = qe.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 25px;
  overflow: scroll;
  max-width: 720px;
  margin: 0 auto;
  height: 100%;
  overflow: auto;

  @media only screen and (max-height: 480px) {
    padding: 20px;
  }
  &.IncodeCustomConsent,
  &.IncodeDefaultConsent {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin: 0 0 10px;
    }
    ul {
      list-style: disc;
      padding-left: 25px;
    }
    ol {
      list-style: decimal;
      padding-left: 25px;
    }
    p {
      margin: 0 0 15px;
    }
  }
`, ConsentTitle = qe.h1`
  margin-bottom: 20px;
  font-weight: 700;
  font-size: 2rem;

  @media only screen and (max-height: 480px) {
    margin: 0 0 15px 0;
  }
`, ConsentParagraph = qe.p`
  font-size: 14px;
  margin-top: 10px;
  width: 100%;

  &:last-of-type {
    margin-bottom: 0;
  }

  @media only screen and (max-height: 480px) {
    font-size: 12px;
    margin: 0 0 10px 0;
    &:last-of-type {
      margin: 0;
    }
  }
`, CustomCheckBox$5 = qe.span`
  position: absolute;
  top: ${(me) => me.top}px;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
  border-radius: 5px;
  cursor: pointer;

  &:after {
    content: '';
    position: absolute;
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
    display: none;
  }
`, CheckBox$5 = qe.input.attrs({ type: "checkbox" })`
  position: absolute;
  opacity: 0;
  z-index: 1;
  cursor: pointer;
  width: 25px;
  height: 25px;
  margin: 0;

  &:checked + ${CustomCheckBox$5} {
    background-color: #2196f3;

    &:after {
      display: block;
    }
  }
`, CheckboxLabel$3 = qe.label`
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 35px;
  margin: 30px 0;
  font-size: 14px;
  user-select: none;
  cursor: pointer;
  p {
    margin: 0;
  }
`;
function AcceptCheck$2({
  consentChecked: me,
  setConsentChecked: ue,
  text: Qe = "I confirm that I have read and accept.",
  top: Ue = -5,
  id: He = "checkbox-consent"
}) {
  function Ge() {
    ue(!me);
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(CheckboxLabel$3, { htmlFor: `confirmation${He}`, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CheckBox$5,
      {
        id: `confirmation${He}`,
        onChange: Ge,
        checked: me
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(CustomCheckBox$5, { top: Ue }),
    Qe
  ] });
}
const BrowserNotSupportedIcon = "data:image/svg+xml,%3csvg%20width='68'%20height='69'%20viewBox='0%200%2068%2069'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20id='Vector'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M5.54609%205.98233C8.91319%202.37074%2013.7069%200.351715%2019.3625%200.351715H48.1185C53.789%200.351715%2058.585%202.36949%2061.9504%205.98348C65.2962%209.57648%2067.0328%2014.5346%2067.0328%2020.0945V37.2372C67.0328%2038.6769%2065.8656%2039.8441%2064.4259%2039.8441C62.9862%2039.8441%2061.819%2038.6769%2061.819%2037.2372V27.6981H5.66545V47.1869C5.66545%2051.6711%207.05538%2055.2818%209.34966%2057.7469C11.6243%2060.1908%2014.9812%2061.7191%2019.3625%2061.7191H25.3316C26.7712%2061.7191%2027.9384%2062.8863%2027.9384%2064.326C27.9384%2065.7657%2026.7712%2066.9329%2025.3316%2066.9329H19.3625C13.693%2066.9329%208.89787%2064.9138%205.53327%2061.2992C2.18831%2057.7052%200.45166%2052.7465%200.45166%2047.1869V20.0945C0.45166%2014.5312%202.1979%209.57366%205.54609%205.98233ZM5.66545%2022.4841H61.819V20.0945C61.819%2015.6104%2060.4293%2012.0005%2058.1349%209.53658C55.86%207.09364%2052.5023%205.56551%2048.1185%205.56551H19.3625C14.9977%205.56551%2011.6394%207.09238%209.35963%209.53769C7.06098%2012.0033%205.66545%2015.6137%205.66545%2020.0945V22.4841ZM11.6634%2015.061C11.6634%2013.6213%2012.8306%2012.4541%2014.2703%2012.4541H14.4631C15.9028%2012.4541%2017.07%2013.6213%2017.07%2015.061C17.07%2016.5008%2015.9028%2017.6679%2014.4631%2017.6679H14.2703C12.8306%2017.6679%2011.6634%2016.5008%2011.6634%2015.061ZM20.1379%2015.061C20.1379%2013.6213%2021.3051%2012.4541%2022.7448%2012.4541H22.9376C24.3773%2012.4541%2025.5445%2013.6213%2025.5445%2015.061C25.5445%2016.5008%2024.3773%2017.6679%2022.9376%2017.6679H22.7448C21.3051%2017.6679%2020.1379%2016.5008%2020.1379%2015.061ZM28.6123%2015.061C28.6123%2013.6213%2029.7795%2012.4541%2031.2192%2012.4541H31.4121C32.8518%2012.4541%2034.019%2013.6213%2034.019%2015.061C34.019%2016.5008%2032.8518%2017.6679%2031.4121%2017.6679H31.2192C29.7795%2017.6679%2028.6123%2016.5008%2028.6123%2015.061ZM43.1981%2049.8317C44.2165%2048.8139%2045.8669%2048.8139%2046.8849%2049.8324L51.9639%2054.9127L57.0431%2049.8324C58.0609%2048.8139%2059.7116%2048.8139%2060.7296%2049.8317C61.7481%2050.8497%2061.7481%2052.5004%2060.7303%2053.5185L55.6504%2058.5999L60.7303%2063.6809C61.7481%2064.6993%2061.7481%2066.3496%2060.7296%2067.3677C59.7116%2068.3858%2058.0609%2068.3855%2057.0431%2067.3674L51.9639%2062.2871L46.8849%2067.3674C45.8669%2068.3855%2044.2165%2068.3858%2043.1981%2067.3677C42.18%2066.3496%2042.1797%2064.6993%2043.1977%2063.6809L48.2777%2058.5999L43.1977%2053.5185C42.1797%2052.5004%2042.18%2050.8497%2043.1981%2049.8317Z'%20fill='%2320263D'%20/%3e%3c/svg%3e", ContinueButton = qe.button`
  margin-top: 38px;
  font-size: 12px;
  text-transform: uppercase;
  text-decoration-line: underline;
  background: none;
  border: none;
  cursor: pointer;
`, BrowserNotSupportedBottomContainer = qe.div`
  padding: 0 50px;
  width: 100%;
`, BrowserNotSupportedContainer = qe.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: white;
  text-align: center;
  z-index: 9999999;
  box-sizing: border-box;
  padding: 20px;
  height: 100%;
  width: 100%;
`, Image$a = qe.img`
  height: 66px;
  margin-bottom: 25px;
  margin: 0 auto;
  margin-bottom: 50px;
`, Text$7 = qe.p`
  font-size: 18px;
`, Blue$1 = qe.span`
  color: #007aff;
`, LinkText = qe.p`
  font-size: 18px;
  margin-top: 20px;
  color: #636670;
  max-width: 100%;
  overflow: hidden;
  opacity: 0.7;
  white-space: nowrap;
`;
function copyLink() {
  const me = window.location.href;
  navigator.clipboard.writeText(me);
}
const isAppleDevice = mobile.isAppleDevice();
function BrowserNotSupported({
  onContinue: me,
  token: ue
}) {
  const { t: Qe } = useTranslation();
  useEffect(() => {
    ue && addEvent({
      token: ue,
      code: "pageWasRenderedToUser",
      screen: "Unsupported Browser"
    });
  }, [ue]);
  const Ue = () => {
    copyLink(), ue && addEvent({
      token: ue,
      code: "userClickedCopyLink",
      screen: "Unsupported Browser"
    });
  }, He = () => {
    ue && addEvent({
      token: ue,
      code: "userClickedContinueAnyway",
      screen: "Unsupported Browser"
    }), me();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(BrowserNotSupportedContainer, { className: "IncodeBrowserNotSupporterContainer", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "BrowserNotSupportedTopContainer", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Image$a,
        {
          src: BrowserNotSupportedIcon,
          alt: "browser not supported",
          className: "IncodeBrowserNotSupporterImage"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "IncodeBrowserNotSupporterTitle", children: Qe("unsupportedBrowser.title") }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$7, { className: "IncodeBrowserNotSupporterTextFirst", children: [
        Qe("unsupportedBrowser.betterExperience"),
        " ",
        isAppleDevice && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Blue$1, { children: "Safari" }),
          ` ${Qe("unsupportedBrowser.or")} `
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Blue$1, { children: "Chrome" })
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(BrowserNotSupportedBottomContainer, { className: "BrowserNotSupportedBottomContainer", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(LinkText, { className: "IncodeBrowserNotSupporterLinkText", children: window.location.href }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button$a,
        {
          onClick: Ue,
          type: "button",
          className: "IncodeBrowserNotSupporterCopyLinkButton",
          children: Qe("unsupportedBrowser.copyLink")
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        ContinueButton,
        {
          type: "button",
          onClick: He,
          className: "IncodeBrowserNotSupporterContinueButton",
          children: Qe("unsupportedBrowser.continueAnyways")
        }
      )
    ] })
  ] });
}
var lib$2 = { exports: {} }, Modal$2 = {}, propTypes$2 = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign, hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var me = Object.getOwnPropertySymbols, ue = Object.prototype.hasOwnProperty, Qe = Object.prototype.propertyIsEnumerable;
  function Ue(Ge) {
    if (Ge == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(Ge);
  }
  function He() {
    try {
      if (!Object.assign)
        return !1;
      var Ge = new String("abc");
      if (Ge[5] = "de", Object.getOwnPropertyNames(Ge)[0] === "5")
        return !1;
      for (var Xe = {}, Ke = 0; Ke < 10; Ke++)
        Xe["_" + String.fromCharCode(Ke)] = Ke;
      var $e = Object.getOwnPropertyNames(Xe).map(function(Ze) {
        return Xe[Ze];
      });
      if ($e.join("") !== "0123456789")
        return !1;
      var Je = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(Ze) {
        Je[Ze] = Ze;
      }), Object.keys(Object.assign({}, Je)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return objectAssign = He() ? Object.assign : function(Ge, Xe) {
    for (var Ke, $e = Ue(Ge), Je, Ze = 1; Ze < arguments.length; Ze++) {
      Ke = Object(arguments[Ze]);
      for (var nt in Ke)
        ue.call(Ke, nt) && ($e[nt] = Ke[nt]);
      if (me) {
        Je = me(Ke);
        for (var tt = 0; tt < Je.length; tt++)
          Qe.call(Ke, Je[tt]) && ($e[Je[tt]] = Ke[Je[tt]]);
      }
    }
    return $e;
  }, objectAssign;
}
var ReactPropTypesSecret_1, hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var me = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ReactPropTypesSecret_1 = me, ReactPropTypesSecret_1;
}
var has$1, hasRequiredHas;
function requireHas() {
  return hasRequiredHas || (hasRequiredHas = 1, has$1 = Function.call.bind(Object.prototype.hasOwnProperty)), has$1;
}
var checkPropTypes_1, hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var me = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var ue = requireReactPropTypesSecret(), Qe = {}, Ue = requireHas();
    me = function(Ge) {
      var Xe = "Warning: " + Ge;
      typeof console < "u" && console.error(Xe);
      try {
        throw new Error(Xe);
      } catch {
      }
    };
  }
  function He(Ge, Xe, Ke, $e, Je) {
    if (process.env.NODE_ENV !== "production") {
      for (var Ze in Ge)
        if (Ue(Ge, Ze)) {
          var nt;
          try {
            if (typeof Ge[Ze] != "function") {
              var tt = Error(
                ($e || "React class") + ": " + Ke + " type `" + Ze + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Ge[Ze] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw tt.name = "Invariant Violation", tt;
            }
            nt = Ge[Ze](Xe, Ze, $e, Ke, null, ue);
          } catch (rt) {
            nt = rt;
          }
          if (nt && !(nt instanceof Error) && me(
            ($e || "React class") + ": type specification of " + Ke + " `" + Ze + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof nt + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), nt instanceof Error && !(nt.message in Qe)) {
            Qe[nt.message] = !0;
            var et = Je ? Je() : "";
            me(
              "Failed " + Ke + " type: " + nt.message + (et ?? "")
            );
          }
        }
    }
  }
  return He.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (Qe = {});
  }, checkPropTypes_1 = He, checkPropTypes_1;
}
var factoryWithTypeCheckers, hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var me = reactIsExports, ue = requireObjectAssign(), Qe = requireReactPropTypesSecret(), Ue = requireHas(), He = requireCheckPropTypes(), Ge = function() {
  };
  process.env.NODE_ENV !== "production" && (Ge = function(Ke) {
    var $e = "Warning: " + Ke;
    typeof console < "u" && console.error($e);
    try {
      throw new Error($e);
    } catch {
    }
  });
  function Xe() {
    return null;
  }
  return factoryWithTypeCheckers = function(Ke, $e) {
    var Je = typeof Symbol == "function" && Symbol.iterator, Ze = "@@iterator";
    function nt(St) {
      var kt = St && (Je && St[Je] || St[Ze]);
      if (typeof kt == "function")
        return kt;
    }
    var tt = "<<anonymous>>", et = {
      array: at("array"),
      bigint: at("bigint"),
      bool: at("boolean"),
      func: at("function"),
      number: at("number"),
      object: at("object"),
      string: at("string"),
      symbol: at("symbol"),
      any: st(),
      arrayOf: ut,
      element: lt(),
      elementType: dt(),
      instanceOf: At,
      node: Bt(),
      objectOf: gt,
      oneOf: pt,
      oneOfType: wt,
      shape: yt,
      exact: Ct
    };
    function rt(St, kt) {
      return St === kt ? St !== 0 || 1 / St === 1 / kt : St !== St && kt !== kt;
    }
    function it(St, kt) {
      this.message = St, this.data = kt && typeof kt == "object" ? kt : {}, this.stack = "";
    }
    it.prototype = Error.prototype;
    function ot(St) {
      if (process.env.NODE_ENV !== "production")
        var kt = {}, jt = 0;
      function Pt(qt, _t, Yt, Xt, Ut, Lt, Ot) {
        if (Xt = Xt || tt, Lt = Lt || Yt, Ot !== Qe) {
          if ($e) {
            var ft = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw ft.name = "Invariant Violation", ft;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Dt = Xt + ":" + Yt;
            !kt[Dt] && // Avoid spamming the console because they are often not actionable except for lib authors
            jt < 3 && (Ge(
              "You are manually calling a React.PropTypes validation function for the `" + Lt + "` prop on `" + Xt + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), kt[Dt] = !0, jt++);
          }
        }
        return _t[Yt] == null ? qt ? _t[Yt] === null ? new it("The " + Ut + " `" + Lt + "` is marked as required " + ("in `" + Xt + "`, but its value is `null`.")) : new it("The " + Ut + " `" + Lt + "` is marked as required in " + ("`" + Xt + "`, but its value is `undefined`.")) : null : St(_t, Yt, Xt, Ut, Lt);
      }
      var Qt = Pt.bind(null, !1);
      return Qt.isRequired = Pt.bind(null, !0), Qt;
    }
    function at(St) {
      function kt(jt, Pt, Qt, qt, _t, Yt) {
        var Xt = jt[Pt], Ut = vt(Xt);
        if (Ut !== St) {
          var Lt = Et(Xt);
          return new it(
            "Invalid " + qt + " `" + _t + "` of type " + ("`" + Lt + "` supplied to `" + Qt + "`, expected ") + ("`" + St + "`."),
            { expectedType: St }
          );
        }
        return null;
      }
      return ot(kt);
    }
    function st() {
      return ot(Xe);
    }
    function ut(St) {
      function kt(jt, Pt, Qt, qt, _t) {
        if (typeof St != "function")
          return new it("Property `" + _t + "` of component `" + Qt + "` has invalid PropType notation inside arrayOf.");
        var Yt = jt[Pt];
        if (!Array.isArray(Yt)) {
          var Xt = vt(Yt);
          return new it("Invalid " + qt + " `" + _t + "` of type " + ("`" + Xt + "` supplied to `" + Qt + "`, expected an array."));
        }
        for (var Ut = 0; Ut < Yt.length; Ut++) {
          var Lt = St(Yt, Ut, Qt, qt, _t + "[" + Ut + "]", Qe);
          if (Lt instanceof Error)
            return Lt;
        }
        return null;
      }
      return ot(kt);
    }
    function lt() {
      function St(kt, jt, Pt, Qt, qt) {
        var _t = kt[jt];
        if (!Ke(_t)) {
          var Yt = vt(_t);
          return new it("Invalid " + Qt + " `" + qt + "` of type " + ("`" + Yt + "` supplied to `" + Pt + "`, expected a single ReactElement."));
        }
        return null;
      }
      return ot(St);
    }
    function dt() {
      function St(kt, jt, Pt, Qt, qt) {
        var _t = kt[jt];
        if (!me.isValidElementType(_t)) {
          var Yt = vt(_t);
          return new it("Invalid " + Qt + " `" + qt + "` of type " + ("`" + Yt + "` supplied to `" + Pt + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return ot(St);
    }
    function At(St) {
      function kt(jt, Pt, Qt, qt, _t) {
        if (!(jt[Pt] instanceof St)) {
          var Yt = St.name || tt, Xt = Rt(jt[Pt]);
          return new it("Invalid " + qt + " `" + _t + "` of type " + ("`" + Xt + "` supplied to `" + Qt + "`, expected ") + ("instance of `" + Yt + "`."));
        }
        return null;
      }
      return ot(kt);
    }
    function pt(St) {
      if (!Array.isArray(St))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? Ge(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : Ge("Invalid argument supplied to oneOf, expected an array.")), Xe;
      function kt(jt, Pt, Qt, qt, _t) {
        for (var Yt = jt[Pt], Xt = 0; Xt < St.length; Xt++)
          if (rt(Yt, St[Xt]))
            return null;
        var Ut = JSON.stringify(St, function(Ot, ft) {
          var Dt = Et(ft);
          return Dt === "symbol" ? String(ft) : ft;
        });
        return new it("Invalid " + qt + " `" + _t + "` of value `" + String(Yt) + "` " + ("supplied to `" + Qt + "`, expected one of " + Ut + "."));
      }
      return ot(kt);
    }
    function gt(St) {
      function kt(jt, Pt, Qt, qt, _t) {
        if (typeof St != "function")
          return new it("Property `" + _t + "` of component `" + Qt + "` has invalid PropType notation inside objectOf.");
        var Yt = jt[Pt], Xt = vt(Yt);
        if (Xt !== "object")
          return new it("Invalid " + qt + " `" + _t + "` of type " + ("`" + Xt + "` supplied to `" + Qt + "`, expected an object."));
        for (var Ut in Yt)
          if (Ue(Yt, Ut)) {
            var Lt = St(Yt, Ut, Qt, qt, _t + "." + Ut, Qe);
            if (Lt instanceof Error)
              return Lt;
          }
        return null;
      }
      return ot(kt);
    }
    function wt(St) {
      if (!Array.isArray(St))
        return process.env.NODE_ENV !== "production" && Ge("Invalid argument supplied to oneOfType, expected an instance of array."), Xe;
      for (var kt = 0; kt < St.length; kt++) {
        var jt = St[kt];
        if (typeof jt != "function")
          return Ge(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + bt(jt) + " at index " + kt + "."
          ), Xe;
      }
      function Pt(Qt, qt, _t, Yt, Xt) {
        for (var Ut = [], Lt = 0; Lt < St.length; Lt++) {
          var Ot = St[Lt], ft = Ot(Qt, qt, _t, Yt, Xt, Qe);
          if (ft == null)
            return null;
          ft.data && Ue(ft.data, "expectedType") && Ut.push(ft.data.expectedType);
        }
        var Dt = Ut.length > 0 ? ", expected one of type [" + Ut.join(", ") + "]" : "";
        return new it("Invalid " + Yt + " `" + Xt + "` supplied to " + ("`" + _t + "`" + Dt + "."));
      }
      return ot(Pt);
    }
    function Bt() {
      function St(kt, jt, Pt, Qt, qt) {
        return ht(kt[jt]) ? null : new it("Invalid " + Qt + " `" + qt + "` supplied to " + ("`" + Pt + "`, expected a ReactNode."));
      }
      return ot(St);
    }
    function Tt(St, kt, jt, Pt, Qt) {
      return new it(
        (St || "React class") + ": " + kt + " type `" + jt + "." + Pt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Qt + "`."
      );
    }
    function yt(St) {
      function kt(jt, Pt, Qt, qt, _t) {
        var Yt = jt[Pt], Xt = vt(Yt);
        if (Xt !== "object")
          return new it("Invalid " + qt + " `" + _t + "` of type `" + Xt + "` " + ("supplied to `" + Qt + "`, expected `object`."));
        for (var Ut in St) {
          var Lt = St[Ut];
          if (typeof Lt != "function")
            return Tt(Qt, qt, _t, Ut, Et(Lt));
          var Ot = Lt(Yt, Ut, Qt, qt, _t + "." + Ut, Qe);
          if (Ot)
            return Ot;
        }
        return null;
      }
      return ot(kt);
    }
    function Ct(St) {
      function kt(jt, Pt, Qt, qt, _t) {
        var Yt = jt[Pt], Xt = vt(Yt);
        if (Xt !== "object")
          return new it("Invalid " + qt + " `" + _t + "` of type `" + Xt + "` " + ("supplied to `" + Qt + "`, expected `object`."));
        var Ut = ue({}, jt[Pt], St);
        for (var Lt in Ut) {
          var Ot = St[Lt];
          if (Ue(St, Lt) && typeof Ot != "function")
            return Tt(Qt, qt, _t, Lt, Et(Ot));
          if (!Ot)
            return new it(
              "Invalid " + qt + " `" + _t + "` key `" + Lt + "` supplied to `" + Qt + "`.\nBad object: " + JSON.stringify(jt[Pt], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(St), null, "  ")
            );
          var ft = Ot(Yt, Lt, Qt, qt, _t + "." + Lt, Qe);
          if (ft)
            return ft;
        }
        return null;
      }
      return ot(kt);
    }
    function ht(St) {
      switch (typeof St) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !St;
        case "object":
          if (Array.isArray(St))
            return St.every(ht);
          if (St === null || Ke(St))
            return !0;
          var kt = nt(St);
          if (kt) {
            var jt = kt.call(St), Pt;
            if (kt !== St.entries) {
              for (; !(Pt = jt.next()).done; )
                if (!ht(Pt.value))
                  return !1;
            } else
              for (; !(Pt = jt.next()).done; ) {
                var Qt = Pt.value;
                if (Qt && !ht(Qt[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function It(St, kt) {
      return St === "symbol" ? !0 : kt ? kt["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && kt instanceof Symbol : !1;
    }
    function vt(St) {
      var kt = typeof St;
      return Array.isArray(St) ? "array" : St instanceof RegExp ? "object" : It(kt, St) ? "symbol" : kt;
    }
    function Et(St) {
      if (typeof St > "u" || St === null)
        return "" + St;
      var kt = vt(St);
      if (kt === "object") {
        if (St instanceof Date)
          return "date";
        if (St instanceof RegExp)
          return "regexp";
      }
      return kt;
    }
    function bt(St) {
      var kt = Et(St);
      switch (kt) {
        case "array":
        case "object":
          return "an " + kt;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + kt;
        default:
          return kt;
      }
    }
    function Rt(St) {
      return !St.constructor || !St.constructor.name ? tt : St.constructor.name;
    }
    return et.checkPropTypes = He, et.resetWarningCache = He.resetWarningCache, et.PropTypes = et, et;
  }, factoryWithTypeCheckers;
}
var factoryWithThrowingShims, hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var me = requireReactPropTypesSecret();
  function ue() {
  }
  function Qe() {
  }
  return Qe.resetWarningCache = ue, factoryWithThrowingShims = function() {
    function Ue(Xe, Ke, $e, Je, Ze, nt) {
      if (nt !== me) {
        var tt = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw tt.name = "Invariant Violation", tt;
      }
    }
    Ue.isRequired = Ue;
    function He() {
      return Ue;
    }
    var Ge = {
      array: Ue,
      bigint: Ue,
      bool: Ue,
      func: Ue,
      number: Ue,
      object: Ue,
      string: Ue,
      symbol: Ue,
      any: Ue,
      arrayOf: He,
      element: Ue,
      elementType: Ue,
      instanceOf: He,
      node: Ue,
      objectOf: He,
      oneOf: He,
      oneOfType: He,
      shape: He,
      exact: He,
      checkPropTypes: Qe,
      resetWarningCache: ue
    };
    return Ge.PropTypes = Ge, Ge;
  }, factoryWithThrowingShims;
}
if (process.env.NODE_ENV !== "production") {
  var ReactIs = reactIsExports, throwOnDirectAccess = !0;
  propTypes$2.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else
  propTypes$2.exports = requireFactoryWithThrowingShims()();
var propTypesExports = propTypes$2.exports;
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
var ModalPortal = { exports: {} }, focusManager = {}, tabbable = { exports: {} };
(function(me, ue) {
  Object.defineProperty(ue, "__esModule", {
    value: !0
  }), ue.default = Ze;
  /*!
   * Adapted from jQuery UI core
   *
   * http://jqueryui.com
   *
   * Copyright 2014 jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   *
   * http://api.jqueryui.com/category/ui-core/
   */
  var Qe = "none", Ue = "contents", He = /input|select|textarea|button|object|iframe/;
  function Ge(nt, tt) {
    return tt.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
    nt.scrollWidth <= 0 && nt.scrollHeight <= 0;
  }
  function Xe(nt) {
    var tt = nt.offsetWidth <= 0 && nt.offsetHeight <= 0;
    if (tt && !nt.innerHTML) return !0;
    try {
      var et = window.getComputedStyle(nt), rt = et.getPropertyValue("display");
      return tt ? rt !== Ue && Ge(nt, et) : rt === Qe;
    } catch {
      return console.warn("Failed to inspect element style"), !1;
    }
  }
  function Ke(nt) {
    for (var tt = nt, et = nt.getRootNode && nt.getRootNode(); tt && tt !== document.body; ) {
      if (et && tt === et && (tt = et.host.parentNode), Xe(tt)) return !1;
      tt = tt.parentNode;
    }
    return !0;
  }
  function $e(nt, tt) {
    var et = nt.nodeName.toLowerCase(), rt = He.test(et) && !nt.disabled || et === "a" && nt.href || tt;
    return rt && Ke(nt);
  }
  function Je(nt) {
    var tt = nt.getAttribute("tabindex");
    tt === null && (tt = void 0);
    var et = isNaN(tt);
    return (et || tt >= 0) && $e(nt, !et);
  }
  function Ze(nt) {
    var tt = [].slice.call(nt.querySelectorAll("*"), 0).reduce(function(et, rt) {
      return et.concat(rt.shadowRoot ? Ze(rt.shadowRoot) : [rt]);
    }, []);
    return tt.filter(Je);
  }
  me.exports = ue.default;
})(tabbable, tabbable.exports);
var tabbableExports = tabbable.exports;
Object.defineProperty(focusManager, "__esModule", {
  value: !0
});
focusManager.resetState = resetState$4;
focusManager.log = log$4;
focusManager.handleBlur = handleBlur;
focusManager.handleFocus = handleFocus;
focusManager.markForFocusLater = markForFocusLater;
focusManager.returnFocus = returnFocus;
focusManager.popWithoutFocus = popWithoutFocus;
focusManager.setupScopedFocus = setupScopedFocus;
focusManager.teardownScopedFocus = teardownScopedFocus;
var _tabbable = tabbableExports, _tabbable2 = _interopRequireDefault$t(_tabbable);
function _interopRequireDefault$t(me) {
  return me && me.__esModule ? me : { default: me };
}
var focusLaterElements = [], modalElement = null, needToFocus = !1;
function resetState$4() {
  focusLaterElements = [];
}
function log$4() {
  process.env.NODE_ENV !== "production" && (console.log("focusManager ----------"), focusLaterElements.forEach(function(me) {
    var ue = me || {};
    console.log(ue.nodeName, ue.className, ue.id);
  }), console.log("end focusManager ----------"));
}
function handleBlur() {
  needToFocus = !0;
}
function handleFocus() {
  if (needToFocus) {
    if (needToFocus = !1, !modalElement)
      return;
    setTimeout(function() {
      if (!modalElement.contains(document.activeElement)) {
        var me = (0, _tabbable2.default)(modalElement)[0] || modalElement;
        me.focus();
      }
    }, 0);
  }
}
function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}
function returnFocus() {
  var me = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, ue = null;
  try {
    focusLaterElements.length !== 0 && (ue = focusLaterElements.pop(), ue.focus({ preventScroll: me }));
    return;
  } catch {
    console.warn(["You tried to return focus to", ue, "but it is not in the DOM anymore"].join(" "));
  }
}
function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}
function setupScopedFocus(me) {
  modalElement = me, window.addEventListener ? (window.addEventListener("blur", handleBlur, !1), document.addEventListener("focus", handleFocus, !0)) : (window.attachEvent("onBlur", handleBlur), document.attachEvent("onFocus", handleFocus));
}
function teardownScopedFocus() {
  modalElement = null, window.addEventListener ? (window.removeEventListener("blur", handleBlur), document.removeEventListener("focus", handleFocus)) : (window.detachEvent("onBlur", handleBlur), document.detachEvent("onFocus", handleFocus));
}
var scopeTab = { exports: {} };
(function(me, ue) {
  Object.defineProperty(ue, "__esModule", {
    value: !0
  }), ue.default = Xe;
  var Qe = tabbableExports, Ue = He(Qe);
  function He(Ke) {
    return Ke && Ke.__esModule ? Ke : { default: Ke };
  }
  function Ge() {
    var Ke = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
    return Ke.activeElement.shadowRoot ? Ge(Ke.activeElement.shadowRoot) : Ke.activeElement;
  }
  function Xe(Ke, $e) {
    var Je = (0, Ue.default)(Ke);
    if (!Je.length) {
      $e.preventDefault();
      return;
    }
    var Ze = void 0, nt = $e.shiftKey, tt = Je[0], et = Je[Je.length - 1], rt = Ge();
    if (Ke === rt) {
      if (!nt) return;
      Ze = et;
    }
    if (et === rt && !nt && (Ze = tt), tt === rt && nt && (Ze = et), Ze) {
      $e.preventDefault(), Ze.focus();
      return;
    }
    var it = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent), ot = it != null && it[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    if (ot) {
      var at = Je.indexOf(rt);
      if (at > -1 && (at += nt ? -1 : 1), Ze = Je[at], typeof Ze > "u") {
        $e.preventDefault(), Ze = nt ? et : tt, Ze.focus();
        return;
      }
      $e.preventDefault(), Ze.focus();
    }
  }
  me.exports = ue.default;
})(scopeTab, scopeTab.exports);
var scopeTabExports = scopeTab.exports, ariaAppHider$1 = {}, __DEV__ = process.env.NODE_ENV !== "production", warning$1 = function() {
};
if (__DEV__) {
  var printWarning = function(ue, Qe) {
    var Ue = arguments.length;
    Qe = new Array(Ue > 1 ? Ue - 1 : 0);
    for (var He = 1; He < Ue; He++)
      Qe[He - 1] = arguments[He];
    var Ge = 0, Xe = "Warning: " + ue.replace(/%s/g, function() {
      return Qe[Ge++];
    });
    typeof console < "u" && console.error(Xe);
    try {
      throw new Error(Xe);
    } catch {
    }
  };
  warning$1 = function(me, ue, Qe) {
    var Ue = arguments.length;
    Qe = new Array(Ue > 2 ? Ue - 2 : 0);
    for (var He = 2; He < Ue; He++)
      Qe[He - 2] = arguments[He];
    if (ue === void 0)
      throw new Error(
        "`warning(condition, format, ...args)` requires a warning message argument"
      );
    me || printWarning.apply(null, [ue].concat(Qe));
  };
}
var warning_1 = warning$1;
const warning$2 = /* @__PURE__ */ getDefaultExportFromCjs(warning_1);
var safeHTMLElement = {}, exenv = { exports: {} };
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
(function(me) {
  (function() {
    var ue = !!(typeof window < "u" && window.document && window.document.createElement), Qe = {
      canUseDOM: ue,
      canUseWorkers: typeof Worker < "u",
      canUseEventListeners: ue && !!(window.addEventListener || window.attachEvent),
      canUseViewport: ue && !!window.screen
    };
    me.exports ? me.exports = Qe : window.ExecutionEnvironment = Qe;
  })();
})(exenv);
var exenvExports = exenv.exports;
Object.defineProperty(safeHTMLElement, "__esModule", {
  value: !0
});
safeHTMLElement.canUseDOM = safeHTMLElement.SafeNodeList = safeHTMLElement.SafeHTMLCollection = void 0;
var _exenv = exenvExports, _exenv2 = _interopRequireDefault$s(_exenv);
function _interopRequireDefault$s(me) {
  return me && me.__esModule ? me : { default: me };
}
var EE = _exenv2.default, SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};
safeHTMLElement.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};
safeHTMLElement.SafeNodeList = EE.canUseDOM ? window.NodeList : {};
safeHTMLElement.canUseDOM = EE.canUseDOM;
safeHTMLElement.default = SafeHTMLElement;
Object.defineProperty(ariaAppHider$1, "__esModule", {
  value: !0
});
ariaAppHider$1.resetState = resetState$3;
ariaAppHider$1.log = log$3;
ariaAppHider$1.assertNodeList = assertNodeList;
ariaAppHider$1.setElement = setElement;
ariaAppHider$1.validateElement = validateElement;
ariaAppHider$1.hide = hide;
ariaAppHider$1.show = show;
ariaAppHider$1.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
var _warning = warning_1, _warning2 = _interopRequireDefault$r(_warning), _safeHTMLElement$1 = safeHTMLElement;
function _interopRequireDefault$r(me) {
  return me && me.__esModule ? me : { default: me };
}
var globalElement = null;
function resetState$3() {
  globalElement && (globalElement.removeAttribute ? globalElement.removeAttribute("aria-hidden") : globalElement.length != null ? globalElement.forEach(function(me) {
    return me.removeAttribute("aria-hidden");
  }) : document.querySelectorAll(globalElement).forEach(function(me) {
    return me.removeAttribute("aria-hidden");
  })), globalElement = null;
}
function log$3() {
  if (process.env.NODE_ENV !== "production") {
    var me = globalElement || {};
    console.log("ariaAppHider ----------"), console.log(me.nodeName, me.className, me.id), console.log("end ariaAppHider ----------");
  }
}
function assertNodeList(me, ue) {
  if (!me || !me.length)
    throw new Error("react-modal: No elements were found for selector " + ue + ".");
}
function setElement(me) {
  var ue = me;
  if (typeof ue == "string" && _safeHTMLElement$1.canUseDOM) {
    var Qe = document.querySelectorAll(ue);
    assertNodeList(Qe, ue), ue = Qe;
  }
  return globalElement = ue || globalElement, globalElement;
}
function validateElement(me) {
  var ue = me || globalElement;
  return ue ? Array.isArray(ue) || ue instanceof HTMLCollection || ue instanceof NodeList ? ue : [ue] : ((0, _warning2.default)(!1, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" ")), []);
}
function hide(me) {
  var ue = !0, Qe = !1, Ue = void 0;
  try {
    for (var He = validateElement(me)[Symbol.iterator](), Ge; !(ue = (Ge = He.next()).done); ue = !0) {
      var Xe = Ge.value;
      Xe.setAttribute("aria-hidden", "true");
    }
  } catch (Ke) {
    Qe = !0, Ue = Ke;
  } finally {
    try {
      !ue && He.return && He.return();
    } finally {
      if (Qe)
        throw Ue;
    }
  }
}
function show(me) {
  var ue = !0, Qe = !1, Ue = void 0;
  try {
    for (var He = validateElement(me)[Symbol.iterator](), Ge; !(ue = (Ge = He.next()).done); ue = !0) {
      var Xe = Ge.value;
      Xe.removeAttribute("aria-hidden");
    }
  } catch (Ke) {
    Qe = !0, Ue = Ke;
  } finally {
    try {
      !ue && He.return && He.return();
    } finally {
      if (Qe)
        throw Ue;
    }
  }
}
function documentNotReadyOrSSRTesting() {
  globalElement = null;
}
var classList = {};
Object.defineProperty(classList, "__esModule", {
  value: !0
});
classList.resetState = resetState$2;
classList.log = log$2;
var htmlClassList = {}, docBodyClassList = {};
function removeClass$2(me, ue) {
  me.classList.remove(ue);
}
function resetState$2() {
  var me = document.getElementsByTagName("html")[0];
  for (var ue in htmlClassList)
    removeClass$2(me, htmlClassList[ue]);
  var Qe = document.body;
  for (var Ue in docBodyClassList)
    removeClass$2(Qe, docBodyClassList[Ue]);
  htmlClassList = {}, docBodyClassList = {};
}
function log$2() {
  if (process.env.NODE_ENV !== "production") {
    var me = document.getElementsByTagName("html")[0].className, ue = `Show tracked classes:

`;
    ue += "<html /> (" + me + `):
  `;
    for (var Qe in htmlClassList)
      ue += "  " + Qe + " " + htmlClassList[Qe] + `
  `;
    me = document.body.className, ue += `

doc.body (` + me + `):
  `;
    for (var Ue in docBodyClassList)
      ue += "  " + Ue + " " + docBodyClassList[Ue] + `
  `;
    ue += `
`, console.log(ue);
  }
}
var incrementReference = function(ue, Qe) {
  return ue[Qe] || (ue[Qe] = 0), ue[Qe] += 1, Qe;
}, decrementReference = function(ue, Qe) {
  return ue[Qe] && (ue[Qe] -= 1), Qe;
}, trackClass = function(ue, Qe, Ue) {
  Ue.forEach(function(He) {
    incrementReference(Qe, He), ue.add(He);
  });
}, untrackClass = function(ue, Qe, Ue) {
  Ue.forEach(function(He) {
    decrementReference(Qe, He), Qe[He] === 0 && ue.remove(He);
  });
};
classList.add = function(ue, Qe) {
  return trackClass(ue.classList, ue.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, Qe.split(" "));
};
classList.remove = function(ue, Qe) {
  return untrackClass(ue.classList, ue.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, Qe.split(" "));
};
var portalOpenInstances$1 = {};
Object.defineProperty(portalOpenInstances$1, "__esModule", {
  value: !0
});
portalOpenInstances$1.log = log$1;
portalOpenInstances$1.resetState = resetState$1;
function _classCallCheck$b(me, ue) {
  if (!(me instanceof ue))
    throw new TypeError("Cannot call a class as a function");
}
var PortalOpenInstances = function me() {
  var ue = this;
  _classCallCheck$b(this, me), this.register = function(Qe) {
    if (ue.openInstances.indexOf(Qe) !== -1) {
      process.env.NODE_ENV !== "production" && console.warn("React-Modal: Cannot register modal instance that's already open");
      return;
    }
    ue.openInstances.push(Qe), ue.emit("register");
  }, this.deregister = function(Qe) {
    var Ue = ue.openInstances.indexOf(Qe);
    if (Ue === -1) {
      process.env.NODE_ENV !== "production" && console.warn("React-Modal: Unable to deregister " + Qe + " as it was never registered");
      return;
    }
    ue.openInstances.splice(Ue, 1), ue.emit("deregister");
  }, this.subscribe = function(Qe) {
    ue.subscribers.push(Qe);
  }, this.emit = function(Qe) {
    ue.subscribers.forEach(function(Ue) {
      return Ue(
        Qe,
        // shallow copy to avoid accidental mutation
        ue.openInstances.slice()
      );
    });
  }, this.openInstances = [], this.subscribers = [];
}, portalOpenInstances = new PortalOpenInstances();
function log$1() {
  console.log("portalOpenInstances ----------"), console.log(portalOpenInstances.openInstances.length), portalOpenInstances.openInstances.forEach(function(me) {
    return console.log(me);
  }), console.log("end portalOpenInstances ----------");
}
function resetState$1() {
  portalOpenInstances = new PortalOpenInstances();
}
portalOpenInstances$1.default = portalOpenInstances;
var bodyTrap$1 = {};
Object.defineProperty(bodyTrap$1, "__esModule", {
  value: !0
});
bodyTrap$1.resetState = resetState;
bodyTrap$1.log = log;
var _portalOpenInstances = portalOpenInstances$1, _portalOpenInstances2 = _interopRequireDefault$q(_portalOpenInstances);
function _interopRequireDefault$q(me) {
  return me && me.__esModule ? me : { default: me };
}
var before$2 = void 0, after = void 0, instances = [];
function resetState() {
  for (var me = [before$2, after], ue = 0; ue < me.length; ue++) {
    var Qe = me[ue];
    Qe && Qe.parentNode && Qe.parentNode.removeChild(Qe);
  }
  before$2 = after = null, instances = [];
}
function log() {
  console.log("bodyTrap ----------"), console.log(instances.length);
  for (var me = [before$2, after], ue = 0; ue < me.length; ue++) {
    var Qe = me[ue], Ue = Qe || {};
    console.log(Ue.nodeName, Ue.className, Ue.id);
  }
  console.log("edn bodyTrap ----------");
}
function focusContent() {
  if (instances.length === 0) {
    process.env.NODE_ENV !== "production" && console.warn("React-Modal: Open instances > 0 expected");
    return;
  }
  instances[instances.length - 1].focusContent();
}
function bodyTrap(me, ue) {
  !before$2 && !after && (before$2 = document.createElement("div"), before$2.setAttribute("data-react-modal-body-trap", ""), before$2.style.position = "absolute", before$2.style.opacity = "0", before$2.setAttribute("tabindex", "0"), before$2.addEventListener("focus", focusContent), after = before$2.cloneNode(), after.addEventListener("focus", focusContent)), instances = ue, instances.length > 0 ? (document.body.firstChild !== before$2 && document.body.insertBefore(before$2, document.body.firstChild), document.body.lastChild !== after && document.body.appendChild(after)) : (before$2.parentElement && before$2.parentElement.removeChild(before$2), after.parentElement && after.parentElement.removeChild(after));
}
_portalOpenInstances2.default.subscribe(bodyTrap);
(function(me, ue) {
  Object.defineProperty(ue, "__esModule", {
    value: !0
  });
  var Qe = Object.assign || function(ht) {
    for (var It = 1; It < arguments.length; It++) {
      var vt = arguments[It];
      for (var Et in vt)
        Object.prototype.hasOwnProperty.call(vt, Et) && (ht[Et] = vt[Et]);
    }
    return ht;
  }, Ue = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ht) {
    return typeof ht;
  } : function(ht) {
    return ht && typeof Symbol == "function" && ht.constructor === Symbol && ht !== Symbol.prototype ? "symbol" : typeof ht;
  }, He = /* @__PURE__ */ function() {
    function ht(It, vt) {
      for (var Et = 0; Et < vt.length; Et++) {
        var bt = vt[Et];
        bt.enumerable = bt.enumerable || !1, bt.configurable = !0, "value" in bt && (bt.writable = !0), Object.defineProperty(It, bt.key, bt);
      }
    }
    return function(It, vt, Et) {
      return vt && ht(It.prototype, vt), Et && ht(It, Et), It;
    };
  }(), Ge = React__default, Xe = propTypesExports, Ke = dt(Xe), $e = focusManager, Je = lt($e), Ze = scopeTabExports, nt = dt(Ze), tt = ariaAppHider$1, et = lt(tt), rt = classList, it = lt(rt), ot = safeHTMLElement, at = dt(ot), st = portalOpenInstances$1, ut = dt(st);
  function lt(ht) {
    if (ht && ht.__esModule)
      return ht;
    var It = {};
    if (ht != null)
      for (var vt in ht)
        Object.prototype.hasOwnProperty.call(ht, vt) && (It[vt] = ht[vt]);
    return It.default = ht, It;
  }
  function dt(ht) {
    return ht && ht.__esModule ? ht : { default: ht };
  }
  function At(ht, It) {
    if (!(ht instanceof It))
      throw new TypeError("Cannot call a class as a function");
  }
  function pt(ht, It) {
    if (!ht)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return It && (typeof It == "object" || typeof It == "function") ? It : ht;
  }
  function gt(ht, It) {
    if (typeof It != "function" && It !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof It);
    ht.prototype = Object.create(It && It.prototype, { constructor: { value: ht, enumerable: !1, writable: !0, configurable: !0 } }), It && (Object.setPrototypeOf ? Object.setPrototypeOf(ht, It) : ht.__proto__ = It);
  }
  var wt = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
  }, Bt = function(It) {
    return It.code === "Tab" || It.keyCode === 9;
  }, Tt = function(It) {
    return It.code === "Escape" || It.keyCode === 27;
  }, yt = 0, Ct = function(ht) {
    gt(It, ht);
    function It(vt) {
      At(this, It);
      var Et = pt(this, (It.__proto__ || Object.getPrototypeOf(It)).call(this, vt));
      return Et.setOverlayRef = function(bt) {
        Et.overlay = bt, Et.props.overlayRef && Et.props.overlayRef(bt);
      }, Et.setContentRef = function(bt) {
        Et.content = bt, Et.props.contentRef && Et.props.contentRef(bt);
      }, Et.afterClose = function() {
        var bt = Et.props, Rt = bt.appElement, St = bt.ariaHideApp, kt = bt.htmlOpenClassName, jt = bt.bodyOpenClassName, Pt = bt.parentSelector, Qt = Pt && Pt().ownerDocument || document;
        jt && it.remove(Qt.body, jt), kt && it.remove(Qt.getElementsByTagName("html")[0], kt), St && yt > 0 && (yt -= 1, yt === 0 && et.show(Rt)), Et.props.shouldFocusAfterRender && (Et.props.shouldReturnFocusAfterClose ? (Je.returnFocus(Et.props.preventScroll), Je.teardownScopedFocus()) : Je.popWithoutFocus()), Et.props.onAfterClose && Et.props.onAfterClose(), ut.default.deregister(Et);
      }, Et.open = function() {
        Et.beforeOpen(), Et.state.afterOpen && Et.state.beforeClose ? (clearTimeout(Et.closeTimer), Et.setState({ beforeClose: !1 })) : (Et.props.shouldFocusAfterRender && (Je.setupScopedFocus(Et.node), Je.markForFocusLater()), Et.setState({ isOpen: !0 }, function() {
          Et.openAnimationFrame = requestAnimationFrame(function() {
            Et.setState({ afterOpen: !0 }), Et.props.isOpen && Et.props.onAfterOpen && Et.props.onAfterOpen({
              overlayEl: Et.overlay,
              contentEl: Et.content
            });
          });
        }));
      }, Et.close = function() {
        Et.props.closeTimeoutMS > 0 ? Et.closeWithTimeout() : Et.closeWithoutTimeout();
      }, Et.focusContent = function() {
        return Et.content && !Et.contentHasFocus() && Et.content.focus({ preventScroll: !0 });
      }, Et.closeWithTimeout = function() {
        var bt = Date.now() + Et.props.closeTimeoutMS;
        Et.setState({ beforeClose: !0, closesAt: bt }, function() {
          Et.closeTimer = setTimeout(Et.closeWithoutTimeout, Et.state.closesAt - Date.now());
        });
      }, Et.closeWithoutTimeout = function() {
        Et.setState({
          beforeClose: !1,
          isOpen: !1,
          afterOpen: !1,
          closesAt: null
        }, Et.afterClose);
      }, Et.handleKeyDown = function(bt) {
        Bt(bt) && (0, nt.default)(Et.content, bt), Et.props.shouldCloseOnEsc && Tt(bt) && (bt.stopPropagation(), Et.requestClose(bt));
      }, Et.handleOverlayOnClick = function(bt) {
        Et.shouldClose === null && (Et.shouldClose = !0), Et.shouldClose && Et.props.shouldCloseOnOverlayClick && (Et.ownerHandlesClose() ? Et.requestClose(bt) : Et.focusContent()), Et.shouldClose = null;
      }, Et.handleContentOnMouseUp = function() {
        Et.shouldClose = !1;
      }, Et.handleOverlayOnMouseDown = function(bt) {
        !Et.props.shouldCloseOnOverlayClick && bt.target == Et.overlay && bt.preventDefault();
      }, Et.handleContentOnClick = function() {
        Et.shouldClose = !1;
      }, Et.handleContentOnMouseDown = function() {
        Et.shouldClose = !1;
      }, Et.requestClose = function(bt) {
        return Et.ownerHandlesClose() && Et.props.onRequestClose(bt);
      }, Et.ownerHandlesClose = function() {
        return Et.props.onRequestClose;
      }, Et.shouldBeClosed = function() {
        return !Et.state.isOpen && !Et.state.beforeClose;
      }, Et.contentHasFocus = function() {
        return document.activeElement === Et.content || Et.content.contains(document.activeElement);
      }, Et.buildClassName = function(bt, Rt) {
        var St = (typeof Rt > "u" ? "undefined" : Ue(Rt)) === "object" ? Rt : {
          base: wt[bt],
          afterOpen: wt[bt] + "--after-open",
          beforeClose: wt[bt] + "--before-close"
        }, kt = St.base;
        return Et.state.afterOpen && (kt = kt + " " + St.afterOpen), Et.state.beforeClose && (kt = kt + " " + St.beforeClose), typeof Rt == "string" && Rt ? kt + " " + Rt : kt;
      }, Et.attributesFromObject = function(bt, Rt) {
        return Object.keys(Rt).reduce(function(St, kt) {
          return St[bt + "-" + kt] = Rt[kt], St;
        }, {});
      }, Et.state = {
        afterOpen: !1,
        beforeClose: !1
      }, Et.shouldClose = null, Et.moveFromContentToOverlay = null, Et;
    }
    return He(It, [{
      key: "componentDidMount",
      value: function() {
        this.props.isOpen && this.open();
      }
    }, {
      key: "componentDidUpdate",
      value: function(Et, bt) {
        process.env.NODE_ENV !== "production" && (Et.bodyOpenClassName !== this.props.bodyOpenClassName && console.warn('React-Modal: "bodyOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.'), Et.htmlOpenClassName !== this.props.htmlOpenClassName && console.warn('React-Modal: "htmlOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.')), this.props.isOpen && !Et.isOpen ? this.open() : !this.props.isOpen && Et.isOpen && this.close(), this.props.shouldFocusAfterRender && this.state.isOpen && !bt.isOpen && this.focusContent();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.state.isOpen && this.afterClose(), clearTimeout(this.closeTimer), cancelAnimationFrame(this.openAnimationFrame);
      }
    }, {
      key: "beforeOpen",
      value: function() {
        var Et = this.props, bt = Et.appElement, Rt = Et.ariaHideApp, St = Et.htmlOpenClassName, kt = Et.bodyOpenClassName, jt = Et.parentSelector, Pt = jt && jt().ownerDocument || document;
        kt && it.add(Pt.body, kt), St && it.add(Pt.getElementsByTagName("html")[0], St), Rt && (yt += 1, et.hide(bt)), ut.default.register(this);
      }
      // Don't steal focus from inner elements
    }, {
      key: "render",
      value: function() {
        var Et = this.props, bt = Et.id, Rt = Et.className, St = Et.overlayClassName, kt = Et.defaultStyles, jt = Et.children, Pt = Rt ? {} : kt.content, Qt = St ? {} : kt.overlay;
        if (this.shouldBeClosed())
          return null;
        var qt = {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", St),
          style: Qe({}, Qt, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        }, _t = Qe({
          id: bt,
          ref: this.setContentRef,
          style: Qe({}, Pt, this.props.style.content),
          className: this.buildClassName("content", Rt),
          tabIndex: "-1",
          onKeyDown: this.handleKeyDown,
          onMouseDown: this.handleContentOnMouseDown,
          onMouseUp: this.handleContentOnMouseUp,
          onClick: this.handleContentOnClick,
          role: this.props.role,
          "aria-label": this.props.contentLabel
        }, this.attributesFromObject("aria", Qe({ modal: !0 }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
          "data-testid": this.props.testId
        }), Yt = this.props.contentElement(_t, jt);
        return this.props.overlayElement(qt, Yt);
      }
    }]), It;
  }(Ge.Component);
  Ct.defaultProps = {
    style: {
      overlay: {},
      content: {}
    },
    defaultStyles: {}
  }, Ct.propTypes = {
    isOpen: Ke.default.bool.isRequired,
    defaultStyles: Ke.default.shape({
      content: Ke.default.object,
      overlay: Ke.default.object
    }),
    style: Ke.default.shape({
      content: Ke.default.object,
      overlay: Ke.default.object
    }),
    className: Ke.default.oneOfType([Ke.default.string, Ke.default.object]),
    overlayClassName: Ke.default.oneOfType([Ke.default.string, Ke.default.object]),
    parentSelector: Ke.default.func,
    bodyOpenClassName: Ke.default.string,
    htmlOpenClassName: Ke.default.string,
    ariaHideApp: Ke.default.bool,
    appElement: Ke.default.oneOfType([Ke.default.instanceOf(at.default), Ke.default.instanceOf(ot.SafeHTMLCollection), Ke.default.instanceOf(ot.SafeNodeList), Ke.default.arrayOf(Ke.default.instanceOf(at.default))]),
    onAfterOpen: Ke.default.func,
    onAfterClose: Ke.default.func,
    onRequestClose: Ke.default.func,
    closeTimeoutMS: Ke.default.number,
    shouldFocusAfterRender: Ke.default.bool,
    shouldCloseOnOverlayClick: Ke.default.bool,
    shouldReturnFocusAfterClose: Ke.default.bool,
    preventScroll: Ke.default.bool,
    role: Ke.default.string,
    contentLabel: Ke.default.string,
    aria: Ke.default.object,
    data: Ke.default.object,
    children: Ke.default.node,
    shouldCloseOnEsc: Ke.default.bool,
    overlayRef: Ke.default.func,
    contentRef: Ke.default.func,
    id: Ke.default.string,
    overlayElement: Ke.default.func,
    contentElement: Ke.default.func,
    testId: Ke.default.string
  }, ue.default = Ct, me.exports = ue.default;
})(ModalPortal, ModalPortal.exports);
var ModalPortalExports = ModalPortal.exports;
function componentWillMount() {
  var me = this.constructor.getDerivedStateFromProps(this.props, this.state);
  me != null && this.setState(me);
}
function componentWillReceiveProps(me) {
  function ue(Qe) {
    var Ue = this.constructor.getDerivedStateFromProps(me, Qe);
    return Ue ?? null;
  }
  this.setState(ue.bind(this));
}
function componentWillUpdate(me, ue) {
  try {
    var Qe = this.props, Ue = this.state;
    this.props = me, this.state = ue, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      Qe,
      Ue
    );
  } finally {
    this.props = Qe, this.state = Ue;
  }
}
componentWillMount.__suppressDeprecationWarning = !0;
componentWillReceiveProps.__suppressDeprecationWarning = !0;
componentWillUpdate.__suppressDeprecationWarning = !0;
function polyfill(me) {
  var ue = me.prototype;
  if (!ue || !ue.isReactComponent)
    throw new Error("Can only polyfill class components");
  if (typeof me.getDerivedStateFromProps != "function" && typeof ue.getSnapshotBeforeUpdate != "function")
    return me;
  var Qe = null, Ue = null, He = null;
  if (typeof ue.componentWillMount == "function" ? Qe = "componentWillMount" : typeof ue.UNSAFE_componentWillMount == "function" && (Qe = "UNSAFE_componentWillMount"), typeof ue.componentWillReceiveProps == "function" ? Ue = "componentWillReceiveProps" : typeof ue.UNSAFE_componentWillReceiveProps == "function" && (Ue = "UNSAFE_componentWillReceiveProps"), typeof ue.componentWillUpdate == "function" ? He = "componentWillUpdate" : typeof ue.UNSAFE_componentWillUpdate == "function" && (He = "UNSAFE_componentWillUpdate"), Qe !== null || Ue !== null || He !== null) {
    var Ge = me.displayName || me.name, Xe = typeof me.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error(
      `Unsafe legacy lifecycles will not be called for components using new component APIs.

` + Ge + " uses " + Xe + " but also contains the following legacy lifecycles:" + (Qe !== null ? `
  ` + Qe : "") + (Ue !== null ? `
  ` + Ue : "") + (He !== null ? `
  ` + He : "") + `

The above lifecycles should be removed. Learn more about this warning here:
https://fb.me/react-async-component-lifecycle-hooks`
    );
  }
  if (typeof me.getDerivedStateFromProps == "function" && (ue.componentWillMount = componentWillMount, ue.componentWillReceiveProps = componentWillReceiveProps), typeof ue.getSnapshotBeforeUpdate == "function") {
    if (typeof ue.componentDidUpdate != "function")
      throw new Error(
        "Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype"
      );
    ue.componentWillUpdate = componentWillUpdate;
    var Ke = ue.componentDidUpdate;
    ue.componentDidUpdate = function(Je, Ze, nt) {
      var tt = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : nt;
      Ke.call(this, Je, Ze, tt);
    };
  }
  return me;
}
const reactLifecyclesCompat_es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  polyfill
}, Symbol.toStringTag, { value: "Module" })), require$$6 = /* @__PURE__ */ getAugmentedNamespace(reactLifecyclesCompat_es);
Object.defineProperty(Modal$2, "__esModule", {
  value: !0
});
Modal$2.bodyOpenClassName = Modal$2.portalClassName = void 0;
var _extends$5 = Object.assign || function(me) {
  for (var ue = 1; ue < arguments.length; ue++) {
    var Qe = arguments[ue];
    for (var Ue in Qe)
      Object.prototype.hasOwnProperty.call(Qe, Ue) && (me[Ue] = Qe[Ue]);
  }
  return me;
}, _createClass$a = /* @__PURE__ */ function() {
  function me(ue, Qe) {
    for (var Ue = 0; Ue < Qe.length; Ue++) {
      var He = Qe[Ue];
      He.enumerable = He.enumerable || !1, He.configurable = !0, "value" in He && (He.writable = !0), Object.defineProperty(ue, He.key, He);
    }
  }
  return function(ue, Qe, Ue) {
    return Qe && me(ue.prototype, Qe), Ue && me(ue, Ue), ue;
  };
}(), _react$e = React__default, _react2$e = _interopRequireDefault$p(_react$e), _reactDom = ReactDOM__default, _reactDom2 = _interopRequireDefault$p(_reactDom), _propTypes$e = propTypesExports, _propTypes2$e = _interopRequireDefault$p(_propTypes$e), _ModalPortal = ModalPortalExports, _ModalPortal2 = _interopRequireDefault$p(_ModalPortal), _ariaAppHider = ariaAppHider$1, ariaAppHider = _interopRequireWildcard(_ariaAppHider), _safeHTMLElement = safeHTMLElement, _safeHTMLElement2 = _interopRequireDefault$p(_safeHTMLElement), _reactLifecyclesCompat = require$$6;
function _interopRequireWildcard(me) {
  if (me && me.__esModule)
    return me;
  var ue = {};
  if (me != null)
    for (var Qe in me)
      Object.prototype.hasOwnProperty.call(me, Qe) && (ue[Qe] = me[Qe]);
  return ue.default = me, ue;
}
function _interopRequireDefault$p(me) {
  return me && me.__esModule ? me : { default: me };
}
function _classCallCheck$a(me, ue) {
  if (!(me instanceof ue))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$a(me, ue) {
  if (!me)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return ue && (typeof ue == "object" || typeof ue == "function") ? ue : me;
}
function _inherits$a(me, ue) {
  if (typeof ue != "function" && ue !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof ue);
  me.prototype = Object.create(ue && ue.prototype, { constructor: { value: me, enumerable: !1, writable: !0, configurable: !0 } }), ue && (Object.setPrototypeOf ? Object.setPrototypeOf(me, ue) : me.__proto__ = ue);
}
var portalClassName = Modal$2.portalClassName = "ReactModalPortal", bodyOpenClassName = Modal$2.bodyOpenClassName = "ReactModal__Body--open", isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== void 0, createHTMLElement = function(ue) {
  return document.createElement(ue);
}, getCreatePortal = function() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};
function getParentElement(me) {
  return me();
}
var Modal$1 = function(me) {
  _inherits$a(ue, me);
  function ue() {
    var Qe, Ue, He, Ge;
    _classCallCheck$a(this, ue);
    for (var Xe = arguments.length, Ke = Array(Xe), $e = 0; $e < Xe; $e++)
      Ke[$e] = arguments[$e];
    return Ge = (Ue = (He = _possibleConstructorReturn$a(this, (Qe = ue.__proto__ || Object.getPrototypeOf(ue)).call.apply(Qe, [this].concat(Ke))), He), He.removePortal = function() {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(He.node);
      var Je = getParentElement(He.props.parentSelector);
      Je && Je.contains(He.node) ? Je.removeChild(He.node) : console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
    }, He.portalRef = function(Je) {
      He.portal = Je;
    }, He.renderPortal = function(Je) {
      var Ze = getCreatePortal(), nt = Ze(He, _react2$e.default.createElement(_ModalPortal2.default, _extends$5({ defaultStyles: ue.defaultStyles }, Je)), He.node);
      He.portalRef(nt);
    }, Ue), _possibleConstructorReturn$a(He, Ge);
  }
  return _createClass$a(ue, [{
    key: "componentDidMount",
    value: function() {
      if (_safeHTMLElement.canUseDOM) {
        isReact16 || (this.node = createHTMLElement("div")), this.node.className = this.props.portalClassName;
        var Ue = getParentElement(this.props.parentSelector);
        Ue.appendChild(this.node), !isReact16 && this.renderPortal(this.props);
      }
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function(Ue) {
      var He = getParentElement(Ue.parentSelector), Ge = getParentElement(this.props.parentSelector);
      return { prevParent: He, nextParent: Ge };
    }
  }, {
    key: "componentDidUpdate",
    value: function(Ue, He, Ge) {
      if (_safeHTMLElement.canUseDOM) {
        var Xe = this.props, Ke = Xe.isOpen, $e = Xe.portalClassName;
        Ue.portalClassName !== $e && (this.node.className = $e);
        var Je = Ge.prevParent, Ze = Ge.nextParent;
        Ze !== Je && (Je.removeChild(this.node), Ze.appendChild(this.node)), !(!Ue.isOpen && !Ke) && !isReact16 && this.renderPortal(this.props);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      if (!(!_safeHTMLElement.canUseDOM || !this.node || !this.portal)) {
        var Ue = this.portal.state, He = Date.now(), Ge = Ue.isOpen && this.props.closeTimeoutMS && (Ue.closesAt || He + this.props.closeTimeoutMS);
        Ge ? (Ue.beforeClose || this.portal.closeWithTimeout(), setTimeout(this.removePortal, Ge - He)) : this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function() {
      if (!_safeHTMLElement.canUseDOM || !isReact16)
        return null;
      !this.node && isReact16 && (this.node = createHTMLElement("div"));
      var Ue = getCreatePortal();
      return Ue(_react2$e.default.createElement(_ModalPortal2.default, _extends$5({
        ref: this.portalRef,
        defaultStyles: ue.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function(Ue) {
      ariaAppHider.setElement(Ue);
    }
    /* eslint-disable react/no-unused-prop-types */
    /* eslint-enable react/no-unused-prop-types */
  }]), ue;
}(_react$e.Component);
Modal$1.propTypes = {
  isOpen: _propTypes2$e.default.bool.isRequired,
  style: _propTypes2$e.default.shape({
    content: _propTypes2$e.default.object,
    overlay: _propTypes2$e.default.object
  }),
  portalClassName: _propTypes2$e.default.string,
  bodyOpenClassName: _propTypes2$e.default.string,
  htmlOpenClassName: _propTypes2$e.default.string,
  className: _propTypes2$e.default.oneOfType([_propTypes2$e.default.string, _propTypes2$e.default.shape({
    base: _propTypes2$e.default.string.isRequired,
    afterOpen: _propTypes2$e.default.string.isRequired,
    beforeClose: _propTypes2$e.default.string.isRequired
  })]),
  overlayClassName: _propTypes2$e.default.oneOfType([_propTypes2$e.default.string, _propTypes2$e.default.shape({
    base: _propTypes2$e.default.string.isRequired,
    afterOpen: _propTypes2$e.default.string.isRequired,
    beforeClose: _propTypes2$e.default.string.isRequired
  })]),
  appElement: _propTypes2$e.default.oneOfType([_propTypes2$e.default.instanceOf(_safeHTMLElement2.default), _propTypes2$e.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2$e.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2$e.default.arrayOf(_propTypes2$e.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2$e.default.func,
  onRequestClose: _propTypes2$e.default.func,
  closeTimeoutMS: _propTypes2$e.default.number,
  ariaHideApp: _propTypes2$e.default.bool,
  shouldFocusAfterRender: _propTypes2$e.default.bool,
  shouldCloseOnOverlayClick: _propTypes2$e.default.bool,
  shouldReturnFocusAfterClose: _propTypes2$e.default.bool,
  preventScroll: _propTypes2$e.default.bool,
  parentSelector: _propTypes2$e.default.func,
  aria: _propTypes2$e.default.object,
  data: _propTypes2$e.default.object,
  role: _propTypes2$e.default.string,
  contentLabel: _propTypes2$e.default.string,
  shouldCloseOnEsc: _propTypes2$e.default.bool,
  overlayRef: _propTypes2$e.default.func,
  contentRef: _propTypes2$e.default.func,
  id: _propTypes2$e.default.string,
  overlayElement: _propTypes2$e.default.func,
  contentElement: _propTypes2$e.default.func
};
Modal$1.defaultProps = {
  isOpen: !1,
  portalClassName,
  bodyOpenClassName,
  role: "dialog",
  ariaHideApp: !0,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: !0,
  shouldCloseOnEsc: !0,
  shouldCloseOnOverlayClick: !0,
  shouldReturnFocusAfterClose: !0,
  preventScroll: !1,
  parentSelector: function() {
    return document.body;
  },
  overlayElement: function(ue, Qe) {
    return _react2$e.default.createElement(
      "div",
      ue,
      Qe
    );
  },
  contentElement: function(ue, Qe) {
    return _react2$e.default.createElement(
      "div",
      ue,
      Qe
    );
  }
};
Modal$1.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};
(0, _reactLifecyclesCompat.polyfill)(Modal$1);
process.env.NODE_ENV !== "production" && (Modal$1.setCreateHTMLElement = function(me) {
  return createHTMLElement = me;
});
Modal$2.default = Modal$1;
(function(me, ue) {
  Object.defineProperty(ue, "__esModule", {
    value: !0
  });
  var Qe = Modal$2, Ue = He(Qe);
  function He(Ge) {
    return Ge && Ge.__esModule ? Ge : { default: Ge };
  }
  ue.default = Ue.default, me.exports = ue.default;
})(lib$2, lib$2.exports);
var libExports = lib$2.exports;
const Modal = /* @__PURE__ */ getDefaultExportFromCjs(libExports), Container$e = qe.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  align-items: center;
  ${({ fullScreen: me }) => me && {
  width: "100vw",
  height: "100vh",
  zIndex: 1,
  background: "#000000",
  position: "absolute",
  justifyContent: "center"
}}
`, Spinner$4 = qe.div`
  border: 2px solid #fff;
  border-radius: 50%;
  border-top: 2px solid transparent;
  width: 38px;
  height: 38px;
  margin-bottom: 15px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`, Message$6 = qe.div`
  font-size: 2.25rem;
  font-weight: bold;
  color: #fff;
  margin: 15px;
`, customStyles$7 = {
  overlay: {
    zIndex: 5
  },
  content: {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    padding: 0,
    borderRadius: 0,
    border: "none",
    inset: 0,
    backgroundColor: "transparent",
    transform: "translateY(0)"
  }
};
function Loader$1({ message: me, ...ue }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Modal,
    {
      "aria-label": me,
      isOpen: !0,
      style: customStyles$7,
      appElement: document.body,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Container$e, { ...ue, role: "region", "aria-live": "assertive", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$4, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Message$6, { className: "IncodeCameraLoading", children: [
          me,
          "..."
        ] })
      ] })
    }
  );
}
const permissionsImg = "data:image/png;base64,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", Container$d = qe.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  grid-gap: 33px;
  overflow: auto;
`, Title$g = qe.h2`
  font-size: 1.56rem;
  margin: 0;
  color: #000;
  text-align: center;
  @media only screen and (max-height: 640px) {
    font-size: 1.25rem;
  }
`, Content$5 = qe.div`
  display: flex;
  flex-direction: column;
  color: #000;
  padding: 2rem;
  overflow: auto;
`, List$2 = qe.div`
  counter-reset: countLi;
  display: grid;
  grid-template-rows: auto;
  grid-gap: 33px;
  @media only screen and (max-height: 640px) {
    grid-gap: 20px;
  }
  strong {
    color: #00b2fd;
  }
  span {
    counter-increment: countLi;
    position: relative;
    max-width: ${({ desktop: me }) => me ? "100%" : "300px"};

    padding-left: 70px;
    line-height: 1.42;
    &.arrow-up {
      display: flex;
      align-items: center;
      gap: 10px;
      img:last-of-type {
        width: 50px;
        height: 50px;
        position: absolute;
        right: 0;
        top: -80%;
      }
    }
    &.with-image {
      img {
        display: inline-block;
        height: 25px;
        width: 25px;
        margin-left: 10px;
      }
    }
    &.arrow-down {
      display: flex;
      gap: 10px;
      align-items: center;
      img {
        padding-top: 32px;
      }
    }
    &.safari_,
    &.settings_ {
      img {
        margin-left: 10px;
        width: 30px;
        height: 30px;
      }
    }
    &::before {
      content: counter(countLi);
      position: absolute;
      width: 40px;
      height: 40px;
      background: #000;
      left: 8px;
      border-radius: 50%;
      color: #fff;
      text-align: center;
      top: 50%;
      transform: translateY(-50%);
      line-height: 2.4;
    }
  }
`;
qe.div`
  position: relative;
  margin-top: 10px;

  img.menu-options {
    width: 100%;
  }
`;
qe.img`
  position: absolute;
  right: 65px;
  top: -40px;
`;
qe.div`
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;

  p {
    font-size: 16px;
  }

  .separator {
    height: 1px;
    background: #d9d9d9;
    flex: 1;
    margin: 0 10px;
  }
`;
const SpanIcon = qe.span`
  display: flex;
  align-items: center;
  img {
    width: 32px;
    height: 32px;
  }
`, arrowUp = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20width='67'%20height='78'%20viewBox='0%200%2067%2078'%3e%3cdefs%3e%3cpath%20id='inwcmzvw7a'%20d='M0%200L59%200%2059%2072%200%2072z'/%3e%3c/defs%3e%3cg%20fill='none'%20fill-rule='evenodd'%3e%3cg%3e%3cg%20transform='translate(-280%20-173)%20rotate(-5%202187.031%20-3128.335)'%3e%3cmask%20id='8r31d2xxib'%20fill='%23fff'%3e%3cuse%20xlink:href='%23inwcmzvw7a'/%3e%3c/mask%3e%3cpath%20fill='%2300B2FD'%20d='M11.4%2064.893c-2.663%201.749-9.293%205.22-11.133%205.83-.296.1-.353.427-.136.774.95%201.527%207.64-.573%2013.519-4.249%2010.551-6.593%2022.989-18.98%2029.792-29.675%203.016-4.742%208.327-15.386%2010.298-20.648l1.33-3.552.466%206.506c.375%205.236.619%206.606%201.24%206.993.567.351.985.311%201.548-.15.688-.569.753-1.902.62-12.449-.121-9.464-.286-12.018-.839-12.844C56.64-.77%2055.248-.464%2052.877%202.57%2040.5%2018.438%2040.241%2018.81%2040.693%2019.983c.586%201.51%202.292.736%205.523-2.495%201.77-1.77%203.285-3.155%203.366-3.074.215.212-2.67%207.202-5.112%2012.386-7.34%2015.594-18.648%2028.616-33.07%2038.093'%20mask='url(%238r31d2xxib)'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e", infoIcon = "data:image/svg+xml,%3csvg%20width='24'%20height='25'%20viewBox='0%200%2024%2025'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M22.5%2012.5C22.5%2018.299%2017.799%2023%2012%2023C6.20101%2023%201.5%2018.299%201.5%2012.5C1.5%206.70101%206.20101%202%2012%202C17.799%202%2022.5%206.70101%2022.5%2012.5Z'%20stroke='%23979797'%20stroke-width='2'/%3e%3crect%20x='11'%20y='11'%20width='2'%20height='7'%20fill='%23979797'/%3e%3crect%20x='11'%20y='7'%20width='2'%20height='2'%20fill='%23979797'/%3e%3c/svg%3e", StyledContainer = qe(Container$d)`
  width: 100%;

  div,
  label {
    width: 100%;
  }
`, StyledTitle = qe(Title$g)`
  text-align: left;

  &:last-of-type {
    margin-top: 30px;
  }
`, Arrow = qe.img`
  position: absolute;
  right: 0;
  top: 10%;
  height: 100px;
  width: 100px;
`;
function StepsToAllowCameraAndroid({ children: me }) {
  const { t: ue } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledContainer, { className: "IncodeAndroidInstructionsContainer", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Arrow, { src: arrowUp, alt: "arrow up" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTitle, { children: ue("enableCameraSteps.title") }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Content$5, { className: "IncodeAndroidInstructionsContent", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(List$2, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "arrow-up", children: /* @__PURE__ */ jsxRuntimeExports.jsx("label", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Trans, { i18nKey: "enableCameraSteps.one", children: [
          "Tap the icon in ",
          /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: "Top right corner" })
        ] }) }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "with-image", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("label", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Trans, { i18nKey: "enableCameraSteps.two", children: [
            "Tap ",
            /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: "Settings" }),
            " or"
          ] }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: infoIcon, alt: "information-icon" })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Trans, { i18nKey: "enableCameraSteps.three", children: [
          "Tap on ",
          /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: "Site settings" }),
          " or",
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: "Permissions" })
        ] }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Trans, { i18nKey: "enableCameraSteps.four", children: [
          "Tap ",
          /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: "Camera" }),
          " and allow it"
        ] }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Trans, { i18nKey: "enableCameraSteps.five", children: [
          "Tap ",
          /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: "Retry" })
        ] }) })
      ] }),
      me,
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTitle, { children: ue("enableCameraSteps.notWorking") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Trans, { i18nKey: "enableCameraSteps.six", shouldUnescape: !0 }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Trans, { i18nKey: "enableCameraSteps.seven", children: [
        "If that didn't work, try these steps for",
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "a",
          {
            href: "https://support.google.com/googleplay/answer/9431959",
            target: "_blank",
            rel: "noopener noreferrer",
            children: "changing app permissions."
          }
        ),
        "Then tap Retry."
      ] }) })
    ] })
  ] });
}
const safari = "data:image/svg+xml,%3csvg%20width='294'%20height='294'%20viewBox='0%200%20294%20294'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20filter='url(%23filter0_d)'%3e%3crect%20x='22'%20y='15'%20width='250'%20height='250'%20rx='55.6641'%20fill='white'/%3e%3ccircle%20cx='147'%20cy='140'%20r='109.375'%20fill='url(%23paint0_linear)'/%3e%3crect%20x='145.535'%20y='38.4375'%20width='2.92969'%20height='18.5547'%20fill='white'/%3e%3crect%20x='145.535'%20y='223.008'%20width='2.92969'%20height='18.5547'%20fill='white'/%3e%3crect%20x='127.921'%20y='40.2344'%20width='2.92969'%20height='18.5547'%20transform='rotate(-10%20127.921%2040.2344)'%20fill='white'/%3e%3crect%20x='159.972'%20y='222'%20width='2.92969'%20height='18.5547'%20transform='rotate(-10%20159.972%20222)'%20fill='white'/%3e%3crect%20x='110.888'%20y='45.0664'%20width='2.92969'%20height='18.5547'%20transform='rotate(-20%20110.888%2045.0664)'%20fill='white'/%3e%3crect%20x='174.015'%20y='218.504'%20width='2.92969'%20height='18.5547'%20transform='rotate(-20%20174.015%20218.504)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='18.5547'%20transform='matrix(0.939693%200.34202%200.34202%20-0.939693%20110.888%20234.934)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='18.5547'%20transform='matrix(0.939693%200.34202%200.34202%20-0.939693%20174.015%2061.4961)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='18.5547'%20transform='matrix(0.984808%200.173648%200.173648%20-0.984808%20127.921%20239.766)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='18.5547'%20transform='matrix(0.984808%200.173648%200.173648%20-0.984808%20159.972%2058)'%20fill='white'/%3e%3crect%20x='94.9502'%20y='52.7773'%20width='2.92969'%20height='18.5547'%20transform='rotate(-30%2094.9502%2052.7773)'%20fill='white'/%3e%3crect%20x='187.235'%20y='212.621'%20width='2.92969'%20height='18.5547'%20transform='rotate(-30%20187.235%20212.621)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='18.5547'%20transform='matrix(0.866025%200.5%200.5%20-0.866025%2094.9502%20227.223)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='18.5547'%20transform='matrix(0.866025%200.5%200.5%20-0.866025%20187.235%2067.3789)'%20fill='white'/%3e%3crect%20x='80.5947'%20y='63.1406'%20width='2.92969'%20height='18.5547'%20transform='rotate(-40%2080.5947%2063.1406)'%20fill='white'/%3e%3crect%20x='199.234'%20y='204.531'%20width='2.92969'%20height='18.5547'%20transform='rotate(-40%20199.234%20204.531)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='18.5547'%20transform='matrix(0.766044%200.642788%200.642788%20-0.766044%2080.5947%20216.859)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='18.5547'%20transform='matrix(0.766044%200.642788%200.642788%20-0.766044%20199.234%2075.4688)'%20fill='white'/%3e%3crect%20x='68.2568'%20y='75.8398'%20width='2.92969'%20height='18.5547'%20transform='rotate(-50%2068.2568%2075.8398)'%20fill='white'/%3e%3crect%20x='209.646'%20y='194.477'%20width='2.92969'%20height='18.5547'%20transform='rotate(-50%20209.646%20194.477)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='18.5547'%20transform='matrix(0.642788%200.766044%200.766044%20-0.642788%2068.2568%20204.16)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='18.5547'%20transform='matrix(0.642788%200.766044%200.766044%20-0.642788%20209.646%2085.5234)'%20fill='white'/%3e%3crect%20x='58.3125'%20y='90.4883'%20width='2.92969'%20height='18.5547'%20transform='rotate(-60%2058.3125%2090.4883)'%20fill='white'/%3e%3crect%20x='218.154'%20y='182.773'%20width='2.92969'%20height='18.5547'%20transform='rotate(-60%20218.154%20182.773)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='18.5547'%20transform='matrix(0.5%200.866025%200.866025%20-0.5%2058.3125%20189.512)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='18.5547'%20transform='matrix(0.5%200.866025%200.866025%20-0.5%20218.154%2097.2266)'%20fill='white'/%3e%3crect%20x='51.0615'%20y='106.641'%20width='2.92969'%20height='18.5547'%20transform='rotate(-70%2051.0615%20106.641)'%20fill='white'/%3e%3crect%20x='224.501'%20y='169.766'%20width='2.92969'%20height='18.5547'%20transform='rotate(-70%20224.501%20169.766)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='18.5547'%20transform='matrix(0.34202%200.939693%200.939693%20-0.34202%2051.0615%20173.359)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='18.5547'%20transform='matrix(0.34202%200.939693%200.939693%20-0.34202%20224.501%20110.234)'%20fill='white'/%3e%3crect%20x='46.7266'%20y='123.809'%20width='2.92969'%20height='18.5547'%20transform='rotate(-80%2046.7266%20123.809)'%20fill='white'/%3e%3crect%20x='228.493'%20y='155.859'%20width='2.92969'%20height='18.5547'%20transform='rotate(-80%20228.493%20155.859)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='18.5547'%20transform='matrix(0.173648%200.984808%200.984808%20-0.173648%2046.7266%20156.191)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='18.5547'%20transform='matrix(0.173648%200.984808%200.984808%20-0.173648%20228.493%20124.141)'%20fill='white'/%3e%3crect%20x='45.4375'%20y='141.465'%20width='2.92969'%20height='18.5547'%20transform='rotate(-90%2045.4375%20141.465)'%20fill='white'/%3e%3crect%20x='230.008'%20y='141.465'%20width='2.92969'%20height='18.5547'%20transform='rotate(-90%20230.008%20141.465)'%20fill='white'/%3e%3crect%20x='136.688'%20y='38.9531'%20width='2.92969'%20height='11.7187'%20transform='rotate(-5%20136.688%2038.9531)'%20fill='white'/%3e%3crect%20x='153.371'%20y='229.629'%20width='2.92969'%20height='11.7187'%20transform='rotate(-5%20153.371%20229.629)'%20fill='white'/%3e%3crect%20x='154.393'%20y='38.6992'%20width='2.92969'%20height='11.7187'%20transform='rotate(5%20154.393%2038.6992)'%20fill='white'/%3e%3crect%20x='137.71'%20y='229.375'%20width='2.92969'%20height='11.7187'%20transform='rotate(5%20137.71%20229.375)'%20fill='white'/%3e%3crect%20x='119.298'%20y='42.2773'%20width='2.92969'%20height='11.7188'%20transform='rotate(-15%20119.298%2042.2773)'%20fill='white'/%3e%3crect%20x='168.838'%20y='227.16'%20width='2.92969'%20height='11.7188'%20transform='rotate(-15%20168.838%20227.16)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='11.7187'%20transform='matrix(0.965926%200.258819%200.258819%20-0.965926%20119.298%20237.723)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='11.7187'%20transform='matrix(0.965926%200.258819%200.258819%20-0.965926%20168.838%2052.8398)'%20fill='white'/%3e%3crect%20x='102.751'%20y='48.5742'%20width='2.92969'%20height='11.7187'%20transform='rotate(-25%20102.751%2048.5742)'%20fill='white'/%3e%3crect%20x='183.643'%20y='222.047'%20width='2.92969'%20height='11.7187'%20transform='rotate(-25%20183.643%20222.047)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='11.7187'%20transform='matrix(0.906308%200.422618%200.422618%20-0.906308%20102.751%20231.426)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='11.7187'%20transform='matrix(0.906308%200.422618%200.422618%20-0.906308%20183.643%2057.9531)'%20fill='white'/%3e%3crect%20x='87.5459'%20y='57.6445'%20width='2.92969'%20height='11.7187'%20transform='rotate(-35%2087.5459%2057.6445)'%20fill='white'/%3e%3crect%20x='197.332'%20y='214.438'%20width='2.92969'%20height='11.7187'%20transform='rotate(-35%20197.332%20214.438)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='11.7187'%20transform='matrix(0.819152%200.573576%200.573576%20-0.819152%2087.5459%20222.355)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='11.7187'%20transform='matrix(0.819152%200.573576%200.573576%20-0.819152%20197.332%2065.5625)'%20fill='white'/%3e%3crect%20x='74.1484'%20y='69.2227'%20width='2.92969'%20height='11.7187'%20transform='rotate(-45%2074.1484%2069.2227)'%20fill='white'/%3e%3crect%20x='209.493'%20y='204.566'%20width='2.92969'%20height='11.7187'%20transform='rotate(-45%20209.493%20204.566)'%20fill='white'/%3e%3crect%20x='62.9648'%20y='82.9453'%20width='2.92969'%20height='11.7187'%20transform='rotate(-55%2062.9648%2082.9453)'%20fill='white'/%3e%3crect%20x='219.755'%20y='192.73'%20width='2.92969'%20height='11.7187'%20transform='rotate(-55%20219.755%20192.73)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='11.7187'%20transform='matrix(0.573576%200.819152%200.819152%20-0.573576%2062.9648%20197.055)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='11.7187'%20transform='matrix(0.573576%200.819152%200.819152%20-0.573576%20219.755%2087.2695)'%20fill='white'/%3e%3crect%20x='54.334'%20y='98.4023'%20width='2.92969'%20height='11.7187'%20transform='rotate(-65%2054.334%2098.4023)'%20fill='white'/%3e%3crect%20x='227.808'%20y='179.293'%20width='2.92969'%20height='11.7187'%20transform='rotate(-65%20227.808%20179.293)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='11.7187'%20transform='matrix(0.422618%200.906308%200.906308%20-0.422618%2054.334%20181.598)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='11.7187'%20transform='matrix(0.422618%200.906308%200.906308%20-0.422618%20227.808%20100.707)'%20fill='white'/%3e%3crect%20x='48.5195'%20y='115.129'%20width='2.92969'%20height='11.7188'%20transform='rotate(-75%2048.5195%20115.129)'%20fill='white'/%3e%3crect%20x='233.403'%20y='164.668'%20width='2.92969'%20height='11.7188'%20transform='rotate(-75%20233.403%20164.668)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='11.7187'%20transform='matrix(0.258819%200.965926%200.965926%20-0.258819%2048.5186%20164.871)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='11.7187'%20transform='matrix(0.258819%200.965926%200.965926%20-0.258819%20233.403%20115.332)'%20fill='white'/%3e%3crect%20x='45.6963'%20y='132.609'%20width='2.92969'%20height='11.7187'%20transform='rotate(-85%2045.6963%20132.609)'%20fill='white'/%3e%3crect%20x='236.374'%20y='149.293'%20width='2.92969'%20height='11.7187'%20transform='rotate(-85%20236.374%20149.293)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='11.7187'%20transform='matrix(0.0871557%200.996195%200.996195%20-0.0871557%2045.6963%20147.391)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='11.7187'%20transform='matrix(0.0871557%200.996195%200.996195%20-0.0871557%20236.374%20130.707)'%20fill='white'/%3e%3crect%20x='45.9521'%20y='150.309'%20width='2.92969'%20height='11.7187'%20transform='rotate(-95%2045.9521%20150.309)'%20fill='white'/%3e%3crect%20x='236.63'%20y='133.625'%20width='2.92969'%20height='11.7187'%20transform='rotate(-95%20236.63%20133.625)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='11.7187'%20transform='matrix(-0.0871557%200.996195%200.996195%200.0871557%2045.9521%20129.691)'%20fill='white'/%3e%3crect%20width='2.92969'%20height='11.7187'%20transform='matrix(-0.0871557%200.996195%200.996195%200.0871557%20236.63%20146.375)'%20fill='white'/%3e%3cg%20filter='url(%23filter1_d)'%3e%3cpath%20d='M218.815%2068.1827L153.905%20146.904L140.095%20133.093L218.815%2068.1827Z'%20fill='%23FE3C30'/%3e%3cpath%20d='M75.1846%20211.815L153.906%20146.905L140.095%20133.095L75.1846%20211.815Z'%20fill='white'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cfilter%20id='filter0_d'%20x='0.57143'%20y='0.714287'%20width='292.857'%20height='292.857'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'%20result='hardAlpha'/%3e%3cfeOffset%20dy='7.14286'/%3e%3cfeGaussianBlur%20stdDeviation='10.7143'/%3e%3cfeComposite%20in2='hardAlpha'%20operator='out'/%3e%3cfeColorMatrix%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200.25%200'/%3e%3cfeBlend%20mode='normal'%20in2='BackgroundImageFix'%20result='effect1_dropShadow'/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='effect1_dropShadow'%20result='shape'/%3e%3c/filter%3e%3cfilter%20id='filter1_d'%20x='71.2783'%20y='68.1836'%20width='151.444'%20height='151.444'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'%20result='hardAlpha'/%3e%3cfeOffset%20dy='3.90625'/%3e%3cfeGaussianBlur%20stdDeviation='1.95312'/%3e%3cfeColorMatrix%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200.25%200'/%3e%3cfeBlend%20mode='normal'%20in2='BackgroundImageFix'%20result='effect1_dropShadow'/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='effect1_dropShadow'%20result='shape'/%3e%3c/filter%3e%3clinearGradient%20id='paint0_linear'%20x1='147'%20y1='30.9615'%20x2='147'%20y2='249.038'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%231BC9FA'/%3e%3cstop%20offset='0.760051'%20stop-color='%231F70F0'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e", settings = "data:image/svg+xml,%3csvg%20width='294'%20height='294'%20viewBox='0%200%20294%20294'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20filter='url(%23filter0_d)'%3e%3crect%20x='22'%20y='15'%20width='250'%20height='250'%20rx='55.6641'%20fill='url(%23paint0_linear)'/%3e%3ccircle%20cx='147'%20cy='140'%20r='109.375'%20fill='%232E2E2F'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M146.414%2075.0576C146.534%2074.4079%20147.465%2074.4079%20147.584%2075.0576L149.297%2084.3927C149.929%2084.4183%20150.558%2084.4544%20151.185%2084.5008L153.971%2075.4288C154.165%2074.7974%20155.09%2074.9056%20155.133%2075.5648L155.748%2085.0276C156.373%2085.1261%20156.996%2085.2349%20157.614%2085.3539L161.434%2076.6734C161.7%2076.0688%20162.606%2076.2839%20162.572%2076.9435L162.082%2086.4071C162.693%2086.5779%20163.299%2086.7588%20163.9%2086.9496L168.701%2078.7745C169.035%2078.2049%20169.91%2078.5239%20169.8%2079.1751L168.213%2088.5171C168.799%2088.7578%20169.379%2089.0082%20169.955%2089.268L175.674%2081.7037C176.073%2081.1768%20176.905%2081.5953%20176.719%2082.2293L174.056%2091.3281C174.608%2091.6348%20175.155%2091.9506%20175.696%2092.2753L182.26%2085.4213C182.717%2084.9442%20183.495%2085.4566%20183.237%2086.0648L179.531%2094.7984C180.043%2095.1663%20180.549%2095.5427%20181.048%2095.9273L188.369%2089.877C188.878%2089.4562%20189.591%2090.0555%20189.264%2090.6296L184.566%2098.8774C185.032%2099.3015%20185.49%2099.7332%20185.941%20100.173L193.918%2095.0105C194.472%2094.6516%20195.111%2095.3297%20194.72%2095.8619L189.095%20103.509C189.508%20103.983%20189.914%20104.465%20190.311%20104.954L198.832%20100.752C199.425%20100.46%20199.98%20101.208%20199.53%20101.691L193.057%20108.63C193.413%20109.15%20193.761%20109.676%20194.099%20110.208L203.045%20107.025C203.668%20106.803%20204.133%20107.61%20203.629%20108.038L196.399%20114.176C196.692%20114.734%20196.977%20115.298%20197.251%20115.867L206.501%20113.743C207.145%20113.595%20207.513%20114.451%20206.963%20114.817L199.072%20120.073C199.298%20120.662%20199.514%20121.255%20199.721%20121.853L209.151%20120.816C209.808%20120.744%20210.075%20121.637%20209.486%20121.937L201.036%20126.243C201.191%20126.853%20201.336%20127.468%20201.471%20128.086L210.962%20128.148C211.623%20128.153%20211.784%20129.07%20211.165%20129.3L202.264%20132.601C202.347%20133.223%20202.419%20133.849%20202.481%20134.478L211.907%20135.641C212.563%20135.722%20212.617%20136.652%20211.975%20136.809L202.745%20139.057C202.75%20139.371%20202.752%20139.686%20202.752%20140.002C202.752%20140.317%20202.75%20140.631%20202.745%20140.944L211.975%20143.192C212.617%20143.349%20212.563%20144.279%20211.907%20144.36L202.482%20145.523C202.42%20146.152%20202.347%20146.778%20202.264%20147.4L211.165%20150.701C211.784%20150.93%20211.623%20151.848%20210.962%20151.852L201.472%20151.915C201.337%20152.533%20201.192%20153.148%20201.036%20153.758L209.486%20158.064C210.075%20158.364%20209.808%20159.257%20209.151%20159.185L199.722%20158.148C199.516%20158.746%20199.299%20159.339%20199.073%20159.928L206.963%20165.184C207.513%20165.55%20207.145%20166.406%20206.501%20166.258L197.253%20164.134C196.978%20164.704%20196.694%20165.268%20196.4%20165.826L203.629%20171.963C204.133%20172.39%20203.668%20173.198%20203.045%20172.976L194.101%20169.793C193.763%20170.326%20193.415%20170.852%20193.059%20171.372L199.53%20178.31C199.98%20178.793%20199.425%20179.541%20198.832%20179.248L190.313%20175.048C189.916%20175.537%20189.51%20176.019%20189.096%20176.494L194.72%20184.139C195.111%20184.671%20194.472%20185.349%20193.918%20184.99L185.943%20179.83C185.492%20180.269%20185.033%20180.701%20184.568%20181.126L189.264%20189.371C189.591%20189.945%20188.878%20190.545%20188.369%20190.124L181.05%20184.075C180.551%20184.46%20180.045%20184.837%20179.532%20185.205L183.237%20193.936C183.495%20194.544%20182.717%20195.057%20182.26%20194.579L175.698%20187.728C175.157%20188.053%20174.61%20188.369%20174.057%20188.676L176.719%20197.771C176.905%20198.405%20176.073%20198.824%20175.674%20198.297L169.957%20190.736C169.381%20190.996%20168.8%20191.246%20168.214%20191.487L169.8%20200.826C169.91%20201.477%20169.035%20201.796%20168.701%20201.226L163.902%20193.054C163.3%20193.245%20162.693%20193.426%20162.082%20193.597L162.572%20203.057C162.606%20203.717%20161.7%20203.932%20161.434%20203.327L157.616%20194.65C156.997%20194.769%20156.374%20194.878%20155.748%20194.977L155.133%20204.436C155.09%20205.095%20154.165%20205.203%20153.971%20204.572L151.186%20195.504C150.559%20195.55%20149.929%20195.586%20149.296%20195.612L147.584%20204.943C147.465%20205.593%20146.534%20205.593%20146.414%20204.943L144.702%20195.612C144.07%20195.586%20143.44%20195.55%20142.812%20195.504L140.027%20204.572C139.833%20205.203%20138.908%20205.095%20138.866%20204.436L138.251%20194.977C137.625%20194.879%20137.002%20194.77%20136.382%20194.651L132.565%20203.327C132.299%20203.932%20131.393%20203.717%20131.427%20203.057L131.916%20193.598C131.305%20193.427%20130.698%20193.246%20130.096%20193.055L125.298%20201.226C124.963%20201.796%20124.088%20201.477%20124.199%20200.826L125.785%20191.488C125.198%20191.247%20124.617%20190.996%20124.041%20190.736L118.324%20198.297C117.926%20198.824%20117.094%20198.405%20117.279%20197.771L119.941%20188.677C119.388%20188.37%20118.841%20188.054%20118.299%20187.729L111.738%20194.579C111.281%20195.057%20110.504%20194.544%20110.762%20193.936L114.466%20185.207C113.953%20184.838%20113.447%20184.461%20112.947%20184.076L105.63%20190.124C105.121%20190.545%20104.407%20189.945%20104.734%20189.371L109.43%20181.127C108.964%20180.703%20108.505%20180.27%20108.054%20179.831L100.081%20184.99C99.5261%20185.349%2098.8874%20184.671%2099.2789%20184.139L104.901%20176.496C104.487%20176.02%20104.081%20175.538%20103.683%20175.049L95.1665%20179.248C94.5738%20179.541%2094.0181%20178.793%2094.4688%20178.31L100.938%20171.373C100.582%20170.853%20100.234%20170.327%2099.8953%20169.794L90.9531%20172.976C90.3306%20173.198%2089.8653%20172.39%2090.3691%20171.963L97.5964%20165.827C97.3027%20165.269%2097.0183%20164.704%2096.7433%20164.135L87.4978%20166.258C86.8537%20166.406%2086.4851%20165.55%2087.0351%20165.184L94.9238%20159.93C94.6974%20159.34%2094.4808%20158.746%2094.2741%20158.148L84.847%20159.185C84.1901%20159.257%2083.9232%20158.364%2084.512%20158.064L92.9599%20153.759C92.8044%20153.148%2092.6589%20152.534%2092.5238%20151.915L83.0367%20151.852C82.3758%20151.848%2082.2142%20150.93%2082.8339%20150.701L91.732%20147.401C91.6491%20146.778%2091.5766%20146.152%2091.5145%20145.522L82.0911%20144.36C81.4352%20144.279%2081.3811%20143.349%2082.0232%20143.192L91.2515%20140.945C91.2463%20140.631%2091.2437%20140.317%2091.2437%20140.002C91.2437%20139.686%2091.2463%20139.371%2091.2516%20139.056L82.0232%20136.809C81.3811%20136.652%2081.4352%20135.722%2082.0911%20135.641L91.5149%20134.478C91.577%20133.849%2091.6496%20133.223%2091.7325%20132.6L82.8339%20129.3C82.2142%20129.07%2082.3758%20128.153%2083.0366%20128.148L92.5246%20128.086C92.6598%20127.467%2092.8052%20126.853%2092.9608%20126.242L84.512%20121.937C83.9232%20121.637%2084.1901%20120.744%2084.847%20120.816L94.2754%20121.853C94.482%20121.255%2094.6986%20120.661%2094.925%20120.072L87.0351%20114.817C86.4851%20114.451%2086.8537%20113.595%2087.4978%20113.743L96.745%20115.866C97.0199%20115.297%2097.3042%20114.733%2097.5978%20114.175L90.3691%20108.038C89.8653%20107.61%2090.3306%20106.803%2090.9531%20107.025L99.8973%20110.208C100.236%20109.675%20100.584%20109.149%20100.94%20108.629L94.4688%20101.691C94.0181%20101.208%2094.5738%20100.46%2095.1665%20100.752L103.686%20104.953C104.083%20104.464%20104.489%20103.982%20104.902%20103.507L99.2789%2095.8619C98.8874%2095.3297%2099.5261%2094.6516%20100.081%2095.0105L108.056%20100.172C108.507%2099.7322%20108.966%2099.3002%20109.432%2098.876L104.734%2090.6296C104.407%2090.0555%20105.121%2089.4562%20105.63%2089.877L112.95%2095.9264C113.449%2095.5416%20113.955%2095.1651%20114.467%2094.7971L110.762%2086.0648C110.504%2085.4566%20111.281%2084.9442%20111.738%2085.4213L118.302%2092.2744C118.843%2091.9496%20119.39%2091.6337%20119.942%2091.327L117.279%2082.2293C117.094%2081.5953%20117.926%2081.1768%20118.324%2081.7037L124.043%2089.2673C124.619%2089.0074%20125.199%2088.7569%20125.785%2088.5162L124.199%2079.1751C124.088%2078.5239%20124.963%2078.2049%20125.298%2078.7745L130.098%2086.949C130.7%2086.7582%20131.306%2086.5772%20131.916%2086.4064L131.427%2076.9435C131.393%2076.2839%20132.299%2076.0688%20132.565%2076.6734L136.384%2085.3535C137.003%2085.2345%20137.625%2085.1257%20138.251%2085.0273L138.866%2075.5648C138.908%2074.9056%20139.833%2074.7974%20140.027%2075.4288L142.813%2084.5006C143.44%2084.4542%20144.07%2084.4181%20144.702%2084.3926L146.414%2075.0576ZM146.999%20186.876C172.888%20186.876%20193.874%20165.889%20193.874%20140.001C193.874%20114.112%20172.888%2093.1258%20146.999%2093.1258C121.111%2093.1258%20100.124%20114.112%20100.124%20140.001C100.124%20165.889%20121.111%20186.876%20146.999%20186.876Z'%20fill='url(%23paint1_linear)'/%3e%3cg%20filter='url(%23filter1_d)'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M147.71%2039.7919C147.589%2038.9756%20146.411%2038.9756%20146.29%2039.7919L143.939%2055.584C142.699%2055.6282%20141.465%2055.6991%20140.239%2055.7962L136.072%2040.3871C135.856%2039.5904%20134.687%2039.727%20134.661%2040.5519L134.16%2056.4992C132.932%2056.6864%20131.714%2056.8999%20130.505%2057.1393L124.581%2042.3293C124.274%2041.563%20123.129%2041.8345%20123.199%2042.6569L124.551%2058.5449C123.355%2058.874%20122.168%2059.2288%20120.993%2059.6087L113.393%2045.5925C113%2044.8669%20111.894%2045.2696%20112.059%2046.0782L115.246%2061.7008C114.097%2062.1673%20112.961%2062.6584%20111.837%2063.1733L102.66%2050.1323C102.185%2049.4574%20101.133%2049.9857%20101.391%2050.7697L106.373%2065.9229C105.288%2066.5194%20104.217%2067.1391%20103.161%2067.7812L92.5268%2055.8875C91.9767%2055.2723%2090.9932%2055.9192%2091.3402%2056.668L98.0515%2071.1487C97.0443%2071.866%2096.0535%2072.6049%2095.0798%2073.3646L83.13%2062.7802C82.5122%2062.233%2081.6104%2062.9897%2082.042%2063.6931L90.3923%2077.302C89.4757%2078.1301%2088.5773%2078.978%2087.6978%2079.845L74.5969%2070.7172C73.9198%2070.2454%2073.1119%2071.1017%2073.6223%2071.7503L83.4957%2084.2974C82.681%2085.2254%2081.8863%2086.1715%2081.1123%2087.1349L67.043%2079.5912C66.3157%2079.2012%2065.6127%2080.1454%2066.1949%2080.7304L77.4534%2092.0417C76.7512%2093.058%2076.0707%2094.0904%2075.4126%2095.1384L60.5703%2089.2821C59.8026%2088.9792%2059.214%2089.9987%2059.8602%2090.5121L72.3485%20100.434C71.7688%20101.525%2071.2124%20102.631%2070.6798%20103.75L55.2665%2099.6589C54.4688%2099.4472%2054.0025%20100.528%2054.704%20100.963L68.2547%20109.365C67.8064%20110.516%2067.3826%20111.68%2066.984%20112.855L51.2032%20110.581C50.3863%20110.464%2050.0487%20111.591%2050.7959%20111.942L65.2323%20118.715C64.9222%20119.909%2064.6376%20121.114%2064.3791%20122.328L48.4354%20121.902C47.6104%20121.879%2047.4059%20123.039%2048.1888%20123.3L63.3237%20128.355C63.1555%20129.574%2063.0134%20130.803%2062.8978%20132.038L47.0005%20133.467C46.1785%20133.54%2046.11%20134.716%2046.9179%20134.884L62.5472%20138.15C62.534%20138.766%2062.5273%20139.383%2062.5273%20140.002C62.5273%20140.621%2062.534%20141.239%2062.5472%20141.855L46.9179%20145.12C46.11%20145.289%2046.1785%20146.464%2047.0005%20146.538L62.8978%20147.966C63.0134%20149.202%2063.1555%20150.43%2063.3237%20151.65L48.1888%20156.704C47.4059%20156.966%2047.6104%20158.125%2048.4354%20158.103L64.3791%20157.676C64.6376%20158.891%2064.9222%20160.095%2065.2323%20161.29L50.7959%20168.063C50.0487%20168.413%2050.3863%20169.541%2051.2032%20169.423L66.984%20167.149C67.3826%20168.325%2067.8064%20169.488%2068.2547%20170.639L54.704%20179.041C54.0025%20179.476%2054.4688%20180.557%2055.2665%20180.346L70.6798%20176.254C71.2124%20177.373%2071.7688%20178.479%2072.3485%20179.57L59.8602%20189.492C59.214%20190.006%2059.8026%20191.025%2060.5703%20190.722L75.4126%20184.866C76.0707%20185.914%2076.7512%20186.946%2077.4534%20187.963L66.1949%20199.274C65.6127%20199.859%2066.3157%20200.803%2067.043%20200.413L81.1123%20192.87C81.8863%20193.833%2082.681%20194.779%2083.4957%20195.707L73.6223%20208.254C73.1119%20208.903%2073.9198%20209.759%2074.5969%20209.287L87.6978%20200.159C88.5773%20201.026%2089.4757%20201.874%2090.3923%20202.702L82.042%20216.311C81.6104%20217.015%2082.5122%20217.771%2083.13%20217.224L95.0798%20206.64C96.0535%20207.4%2097.0443%20208.138%2098.0515%20208.856L91.3402%20223.336C90.9932%20224.085%2091.9767%20224.732%2092.5268%20224.117L103.161%20212.223C104.217%20212.865%20105.288%20213.485%20106.373%20214.082L101.391%20229.235C101.133%20230.019%20102.185%20230.547%20102.66%20229.872L111.837%20216.831C112.961%20217.346%20114.097%20217.837%20115.246%20218.304L112.059%20233.926C111.894%20234.735%20113%20235.137%20113.393%20234.412L120.993%20220.396C122.168%20220.776%20123.355%20221.13%20124.551%20221.46L123.199%20237.348C123.129%20238.17%20124.274%20238.441%20124.581%20237.675L130.505%20222.865C131.714%20223.105%20132.932%20223.318%20134.16%20223.505L134.661%20239.453C134.687%20240.277%20135.856%20240.414%20136.072%20239.617L140.239%20224.208C141.465%20224.305%20142.699%20224.376%20143.939%20224.42L146.29%20240.213C146.411%20241.029%20147.589%20241.029%20147.71%20240.213L150.061%20224.42C151.301%20224.376%20152.535%20224.305%20153.761%20224.208L157.928%20239.617C158.144%20240.414%20159.313%20240.277%20159.339%20239.452L159.84%20223.505C161.068%20223.318%20162.286%20223.105%20163.495%20222.865L169.419%20237.675C169.726%20238.441%20170.871%20238.17%20170.801%20237.348L169.448%20221.46C170.645%20221.13%20171.832%20220.776%20173.007%20220.396L180.607%20234.412C181%20235.138%20182.106%20234.735%20181.941%20233.926L178.753%20218.304C179.903%20217.837%20181.039%20217.346%20182.163%20216.831L191.34%20229.872C191.815%20230.547%20192.867%20230.019%20192.609%20229.235L187.627%20214.082C188.712%20213.485%20189.783%20212.865%20190.839%20212.223L201.473%20224.117C202.023%20224.732%20203.007%20224.085%20202.66%20223.336L195.948%20208.856C196.956%20208.138%20197.946%20207.4%20198.92%20206.64L210.87%20217.224C211.488%20217.771%20212.39%20217.015%20211.958%20216.311L203.608%20202.702C204.524%20201.874%20205.423%20201.026%20206.302%20200.159L219.403%20209.287C220.08%20209.759%20220.888%20208.903%20220.378%20208.254L210.504%20195.707C211.319%20194.779%20212.114%20193.833%20212.888%20192.87L226.957%20200.413C227.684%20200.803%20228.387%20199.859%20227.805%20199.274L216.546%20187.963C217.249%20186.946%20217.929%20185.914%20218.587%20184.866L233.43%20190.722C234.197%20191.025%20234.786%20190.006%20234.14%20189.492L221.651%20179.57C222.231%20178.479%20222.788%20177.373%20223.32%20176.254L238.733%20180.346C239.531%20180.557%20239.997%20179.476%20239.296%20179.041L225.745%20170.639C226.194%20169.488%20226.617%20168.325%20227.016%20167.149L242.797%20169.423C243.614%20169.541%20243.951%20168.413%20243.204%20168.063L228.768%20161.29C229.078%20160.095%20229.362%20158.891%20229.621%20157.676L245.565%20158.103C246.39%20158.125%20246.594%20156.966%20245.811%20156.704L230.676%20151.65C230.844%20150.43%20230.987%20149.202%20231.102%20147.966L246.999%20146.538C247.821%20146.464%20247.89%20145.289%20247.082%20145.12L231.453%20141.855C231.466%20141.239%20231.473%20140.621%20231.473%20140.002C231.473%20139.383%20231.466%20138.766%20231.453%20138.15L247.082%20134.884C247.89%20134.716%20247.821%20133.54%20246.999%20133.467L231.102%20132.038C230.987%20130.802%20230.844%20129.574%20230.676%20128.355L245.811%20123.3C246.594%20123.039%20246.39%20121.879%20245.565%20121.902L229.621%20122.328C229.362%20121.114%20229.078%20119.909%20228.768%20118.715L243.204%20111.942C243.951%20111.591%20243.614%20110.464%20242.797%20110.581L227.016%20112.855C226.617%20111.68%20226.194%20110.516%20225.745%20109.365L239.296%20100.963C239.997%20100.528%20239.531%2099.4472%20238.733%2099.6589L223.32%20103.75C222.788%20102.631%20222.231%20101.525%20221.651%20100.434L234.14%2090.5121C234.786%2089.9987%20234.197%2088.9792%20233.43%2089.2821L218.587%2095.1384C217.929%2094.0904%20217.249%2093.058%20216.547%2092.0417L227.805%2080.7304C228.387%2080.1454%20227.684%2079.2012%20226.957%2079.5912L212.888%2087.1349C212.114%2086.1715%20211.319%2085.2254%20210.504%2084.2974L220.378%2071.7503C220.888%2071.1017%20220.08%2070.2454%20219.403%2070.7172L206.302%2079.845C205.423%2078.978%20204.524%2078.1301%20203.608%2077.302L211.958%2063.6931C212.39%2062.9897%20211.488%2062.233%20210.87%2062.7802L198.92%2073.3646C197.946%2072.6049%20196.956%2071.866%20195.948%2071.1487L202.66%2056.668C203.007%2055.9192%20202.023%2055.2723%20201.473%2055.8875L190.839%2067.7812C189.783%2067.1391%20188.712%2066.5194%20187.627%2065.9229L192.609%2050.7697C192.867%2049.9857%20191.815%2049.4574%20191.34%2050.1323L182.163%2063.1733C181.039%2062.6584%20179.903%2062.1673%20178.753%2061.7008L181.941%2046.0782C182.106%2045.2696%20181%2044.8669%20180.607%2045.5925L173.007%2059.6087C171.832%2059.2288%20170.645%2058.874%20169.448%2058.5449L170.801%2042.6569C170.871%2041.8345%20169.726%2041.5631%20169.419%2042.3293L163.495%2057.1393C162.286%2056.8999%20161.068%2056.6864%20159.84%2056.4992L159.339%2040.5519C159.313%2039.727%20158.144%2039.5904%20157.928%2040.3871L153.761%2055.7962C152.535%2055.6991%20151.301%2055.6282%20150.061%2055.584L147.71%2039.7919ZM94.4659%2086.4796C100.347%2080.7485%20109.693%2083.0017%20113.856%2090.0796L138.298%20131.633C140.953%20136.147%20140.953%20141.745%20138.298%20146.258L113.07%20189.149C108.866%20196.296%2099.3935%20198.504%2093.554%20192.618C80.0996%20179.056%2071.8045%20160.485%2071.8045%20140C71.8045%20119.057%2080.4754%20100.114%2094.4659%2086.4796ZM158.617%20143.431C153.505%20143.431%20148.776%20146.136%20146.185%20150.542L120.828%20193.652C116.617%20200.811%20119.309%20210.179%20127.313%20212.4C133.878%20214.221%20140.803%20215.196%20147.958%20215.196C183.61%20215.196%20213.54%20191.005%20221.831%20158.34C223.854%20150.37%20217.163%20143.431%20208.94%20143.431H158.617ZM208.382%20134.46C216.766%20134.46%20223.503%20127.254%20221.162%20119.204C212.025%2087.7902%20182.71%2064.8051%20147.958%2064.8051C141.254%2064.8051%20134.752%2065.6606%20128.558%2067.267C120.44%2069.3725%20117.645%2078.8275%20121.897%2086.0564L146.185%20127.349C148.776%20131.755%20153.505%20134.46%20158.617%20134.46L208.382%20134.46ZM147.046%20144.031C149.338%20144.031%20151.196%20142.172%20151.196%20139.88C151.196%20137.588%20149.338%20135.73%20147.046%20135.73C144.754%20135.73%20142.896%20137.588%20142.896%20139.88C142.896%20142.172%20144.754%20144.031%20147.046%20144.031Z'%20fill='url(%23paint2_linear)'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cfilter%20id='filter0_d'%20x='0.571428'%20y='0.714285'%20width='292.857'%20height='292.857'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'%20result='hardAlpha'/%3e%3cfeOffset%20dy='7.14286'/%3e%3cfeGaussianBlur%20stdDeviation='10.7143'/%3e%3cfeComposite%20in2='hardAlpha'%20operator='out'/%3e%3cfeColorMatrix%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200.25%200'/%3e%3cfeBlend%20mode='normal'%20in2='BackgroundImageFix'%20result='effect1_dropShadow'/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='effect1_dropShadow'%20result='shape'/%3e%3c/filter%3e%3cfilter%20id='filter1_d'%20x='42.7569'%20y='39.1797'%20width='208.486'%20height='208.825'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'%20result='hardAlpha'/%3e%3cfeOffset%20dy='3.58974'/%3e%3cfeGaussianBlur%20stdDeviation='1.79487'/%3e%3cfeColorMatrix%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200.45%200'/%3e%3cfeBlend%20mode='normal'%20in2='BackgroundImageFix'%20result='effect1_dropShadow'/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='effect1_dropShadow'%20result='shape'/%3e%3c/filter%3e%3clinearGradient%20id='paint0_linear'%20x1='147'%20y1='15'%20x2='147'%20y2='265'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23EAEAEA'/%3e%3cstop%20offset='1'%20stop-color='%238F8F93'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear'%20x1='146.999'%20y1='77.5004'%20x2='146.999'%20y2='202.5'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23B4B4B8'/%3e%3cstop%20offset='1'%20stop-color='%23B4B4B8'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint2_linear'%20x1='147.082'%20y1='40.6587'%20x2='148.205'%20y2='240.947'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.193294'%20stop-color='%23D4D4D8'/%3e%3cstop%20offset='0.830878'%20stop-color='%239D9DA1'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e";
function StepsToAllowCameraIOS({ children: me }) {
  const { t: ue } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Container$d, { className: "IncodeiOSInstructionsContainer", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Title$g, { children: ue("enableCameraSteps.title") }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Content$5, { className: "IncodeiOSInstructionsContent", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(List$2, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "settings_", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("label", { children: ue("enableCameraStepsiOS.one") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: settings, alt: "Three dots" })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "safari_", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("label", { children: ue("enableCameraStepsiOS.two") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: safari, alt: "arrow down" })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
          ue("enableCameraStepsiOS.threeFirst"),
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: ue("enableCameraStepsiOS.threeSecond") })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
          ue("enableCameraStepsiOS.fourFirst"),
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: ue("enableCameraStepsiOS.fourSecond") })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
          ue("enableCameraStepsiOS.fiveFirst"),
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: ue("enableCameraStepsiOS.fiveSecond") })
        ] })
      ] }),
      me
    ] })
  ] });
}
const lock = "data:image/svg+xml,%3csvg%20width='32'%20height='33'%20viewBox='0%200%2032%2033'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M10.4883%2027.9062H21.4688C23.25%2027.9062%2024.1758%2026.957%2024.1758%2025.0352V16.7266C24.1758%2015.0391%2023.4492%2014.1016%2022.043%2013.9141V11.125C22.043%206.80078%2019.1836%204.5625%2015.9844%204.5625C12.7852%204.5625%209.92578%206.80078%209.92578%2011.125V13.9141C8.51953%2014.1016%207.78125%2015.0391%207.78125%2016.7266V25.0352C7.78125%2026.957%208.70703%2027.9062%2010.4883%2027.9062ZM12.1172%2010.9141C12.1172%208.16016%2013.8867%206.66016%2015.9844%206.66016C18.0703%206.66016%2019.8516%208.16016%2019.8516%2010.9141V13.8672H12.1172V10.9141Z'%20fill='%239C9C9C'/%3e%3c/svg%3e", ChromeInstructions = () => {
  const { t: me } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(SpanIcon, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("label", { children: me("desktop.chrome.cameraInstructions.one.clickOn") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: lock, "aria-hidden": !0, alt: "lock" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { children: [
      me("desktop.chrome.cameraInstructions.two.clickOn"),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: me("desktop.chrome.cameraInstructions.two.siteSettings") }),
      " ",
      me("desktop.chrome.cameraInstructions.two.menu")
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
      me("desktop.chrome.cameraInstructions.three.inThe"),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("strong", { children: [
        " ",
        me("desktop.chrome.cameraInstructions.three.permissions"),
        " "
      ] }),
      " ",
      me("desktop.chrome.cameraInstructions.three.section"),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: me("desktop.chrome.cameraInstructions.three.camera") }),
      " ",
      me("desktop.chrome.cameraInstructions.three.select"),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: me("desktop.generic.cameraInstructions.allow") })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("strong", { children: [
        me("desktop.generic.cameraInstructions.refresh"),
        " "
      ] }),
      me("desktop.generic.cameraInstructions.thisPage")
    ] })
  ] });
}, EdgeInstructions = () => {
  const { t: me } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { children: [
      me("desktop.edge.cameraInstructions.one.clickOn"),
      "(",
      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: me("desktop.edge.cameraInstructions.one.settings") }),
      ")",
      " ",
      me("desktop.edge.cameraInstructions.one.located")
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { children: [
      me("desktop.edge.cameraInstructions.two.clickOn"),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: me("desktop.edge.cameraInstructions.two.settings") }),
      " ",
      me("desktop.edge.cameraInstructions.two.menu")
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { children: [
      me("desktop.edge.cameraInstructions.three.scroll"),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: me("desktop.edge.cameraInstructions.three.site") }),
      " ",
      me("desktop.edge.cameraInstructions.three.under"),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: me("desktop.edge.cameraInstructions.three.privacy") }),
      " ",
      me("desktop.edge.cameraInstructions.three.section")
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { children: [
      me("desktop.edge.cameraInstructions.four.clickOn"),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsxs("strong", { children: [
        me("desktop.edge.cameraInstructions.four.camera"),
        " "
      ] }),
      me("desktop.edge.cameraInstructions.four.view")
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { children: [
      me("desktop.edge.cameraInstructions.five.toggle"),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsxs("strong", { children: [
        me("desktop.edge.cameraInstructions.five.on"),
        " "
      ] }),
      me("desktop.edge.cameraInstructions.five.allowCamera")
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: me("desktop.generic.cameraInstructions.refresh") }),
      " ",
      me("desktop.generic.cameraInstructions.thisPage")
    ] })
  ] });
}, MozillaInstructions = () => {
  const { t: me } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(SpanIcon, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("label", { children: me("desktop.mozilla.cameraInstructions.one.clickOn") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: lock, "aria-hidden": !0, alt: "lock" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { children: [
      me("desktop.mozilla.cameraInstructions.two.arrowNext"),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsxs("strong", { children: [
        me("desktop.mozilla.cameraInstructions.two.connectionSecure"),
        " "
      ] }),
      " ",
      me("desktop.mozilla.cameraInstructions.two.security")
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
      me("desktop.mozilla.cameraInstructions.three.select"),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: me("desktop.mozilla.cameraInstructions.three.moreInfo") })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
      me("desktop.mozilla.cameraInstructions.four.securityTab"),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: me("desktop.mozilla.cameraInstructions.four.permissions") })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
      me("desktop.mozilla.cameraInstructions.five.locate"),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: me("desktop.mozilla.cameraInstructions.five.useCamera") }),
      me("desktop.mozilla.cameraInstructions.five.option"),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: me("desktop.generic.cameraInstructions.allow") })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
      me("desktop.mozilla.cameraInstructions.six.if"),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: me("desktop.mozilla.cameraInstructions.six.block") }),
      ",",
      me("desktop.mozilla.cameraInstructions.six.clickOn"),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: me("desktop.mozilla.cameraInstructions.six.block") }),
      " ",
      me("desktop.mozilla.cameraInstructions.six.optionSelect"),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: me("desktop.generic.cameraInstructions.allow") })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("strong", { children: [
        me("desktop.generic.cameraInstructions.refresh"),
        " "
      ] }),
      me("desktop.generic.cameraInstructions.thisPage")
    ] })
  ] });
}, OperaInstructions = () => {
  const { t: me } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(SpanIcon, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("label", { children: me("desktop.opera.cameraInstructions.one.clickOn") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: lock, "aria-hidden": !0, alt: "lock" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { children: [
      me("desktop.opera.cameraInstructions.two.clickOn"),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: me("desktop.opera.cameraInstructions.two.siteSettings") }),
      " ",
      me("desktop.opera.cameraInstructions.two.dropDown")
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { children: [
      me("desktop.opera.cameraInstructions.three.scrollDown"),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: me("desktop.opera.cameraInstructions.three.permissions") }),
      " ",
      me("desktop.opera.cameraInstructions.three.section"),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: me("desktop.opera.cameraInstructions.three.Camera") })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { children: [
      me("desktop.opera.cameraInstructions.four.in"),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: me("desktop.opera.cameraInstructions.four.camera") }),
      " ",
      me("desktop.opera.cameraInstructions.four.section"),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: me("desktop.generic.cameraInstructions.allow") })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("strong", { children: [
        " ",
        me("desktop.generic.cameraInstructions.refresh"),
        " "
      ] }),
      me("desktop.generic.cameraInstructions.thisPage")
    ] })
  ] });
}, SafariInstructions = () => {
  const { t: me } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "settings_", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { children: [
      me("desktop.safari.cameraInstructions.one.clickOn"),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: "Safari" }),
      " ",
      me("desktop.safari.cameraInstructions.one.topMenu"),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: me("desktop.safari.cameraInstructions.one.preferences") })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { children: [
      me("desktop.safari.cameraInstructions.two.clickOn"),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsxs("strong", { children: [
        me("desktop.safari.cameraInstructions.two.websites"),
        " "
      ] }),
      "tab"
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
      me("desktop.safari.cameraInstructions.three.scroll"),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsxs("strong", { children: [
        me("desktop.safari.cameraInstructions.three.camera"),
        " "
      ] }),
      " ",
      me("desktop.safari.cameraInstructions.three.leftMenu")
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: me("desktop.safari.cameraInstructions.four.rightSide") }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
      me("desktop.safari.cameraInstructions.five.select"),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: me("desktop.generic.cameraInstructions.allow") }),
      " ",
      me("desktop.safari.cameraInstructions.five.dropDown")
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("strong", { children: [
        me("desktop.generic.cameraInstructions.refresh"),
        " "
      ] }),
      me("desktop.generic.cameraInstructions.thisPage")
    ] })
  ] });
}, cameraOff = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M25.74%2026.3199C25.8302%2026.4167%2025.9002%2026.5304%2025.9461%2026.6544C25.9919%2026.7784%2026.0127%2026.9103%2026.0072%2027.0425C26.0017%2027.1746%2025.97%2027.3043%2025.9139%2027.4241C25.8578%2027.5438%2025.7785%2027.6513%2025.6806%2027.7402C25.5827%2027.8292%2025.4681%2027.8978%2025.3434%2027.9421C25.2187%2027.9865%2025.0865%2028.0057%2024.9543%2027.9986C24.8222%2027.9915%2024.6928%2027.9582%2024.5736%2027.9008C24.4544%2027.8433%2024.3478%2027.7628%2024.26%2027.6639L21.83%2024.9934H3C2.46957%2024.9934%201.96086%2024.7828%201.58579%2024.408C1.21071%2024.0332%201%2023.5249%201%2022.9948V9.00517C1%208.47513%201.21071%207.9668%201.58579%207.592C1.96086%207.21721%202.46957%207.00665%203%207.00665H5.46625L4.26%205.68013C4.16983%205.58334%204.09979%205.46964%204.05392%205.3456C4.00806%205.22157%203.98728%205.08967%203.99281%204.95755C3.99833%204.82543%204.03004%204.69572%204.0861%204.57594C4.14216%204.45616%204.22146%204.34869%204.31939%204.25975C4.41732%204.17082%204.53194%204.1022%204.65661%204.05785C4.78128%204.01351%204.91352%203.99434%205.04566%204.00144C5.1778%204.00855%205.30721%204.04179%205.4264%204.09924C5.54559%204.15669%205.65218%204.23721%205.74%204.33612L25.74%2026.3199ZM30.4713%209.13008C30.3118%209.04467%2030.1321%209.00409%2029.9514%209.01267C29.7707%209.02125%2029.5956%209.07866%2029.445%209.17879L25.445%2011.8443C25.3082%2011.9355%2025.196%2012.0591%2025.1184%2012.2039C25.0408%2012.3488%2025.0001%2012.5106%2025%2012.675V19.3375C25.0001%2019.5019%2025.0408%2019.6637%2025.1184%2019.8085C25.196%2019.9534%2025.3082%2020.077%2025.445%2020.1682L29.445%2022.8337C29.6101%2022.9408%2029.8032%2022.9969%2030%2022.9948C30.2652%2022.9948%2030.5196%2022.8895%2030.7071%2022.7022C30.8946%2022.5148%2031%2022.2606%2031%2021.9956V10.0044C30.9987%209.82464%2030.949%209.64852%2030.8559%209.49463C30.7628%209.34075%2030.63%209.21481%2030.4713%209.13008ZM21.26%2018.4307C21.3963%2018.5806%2021.575%2018.6856%2021.7724%2018.7317C21.9698%2018.7778%2022.1765%2018.7629%2022.3652%2018.6889C22.5539%2018.6149%2022.7157%2018.4854%2022.829%2018.3175C22.9424%2018.1496%2023.002%2017.9512%2023%2017.7487V9.00517C23%208.47513%2022.7893%207.9668%2022.4142%207.592C22.0391%207.21721%2021.5304%207.00665%2021%207.00665H13.1325C12.9388%207.00667%2012.7493%207.0629%2012.5869%207.16852C12.4246%207.27413%2012.2965%207.42459%2012.2181%207.60159C12.1397%207.7786%2012.1145%207.97455%2012.1455%208.16562C12.1764%208.35669%2012.2622%208.53466%2012.3925%208.67791L21.26%2018.4307Z'%20fill='%23979797'/%3e%3c/svg%3e", DesktopTitle = qe.h1`
  font-size: 3rem;
  margin: 0;
  color: #20263d;
  text-align: center;
  @media only screen and (max-height: 640px) {
    font-size: 2.5rem;
  }
`, ContainerButtons$1 = qe.section`
  padding: 10px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
`, ChromeRecommendation = qe.section`
  width: 100%;
  border-top: 1px solid #bcbcbc;
  padding-top: 24px;
  h2 {
    color: #20263d;
    font-size: 2.1rem;
  }
  p {
    color: #20263d;
    font-weight: 500;
    display: flex;
    align-items: center;

    strong {
      color: rgb(0, 178, 253);
      margin: 0 5px;
    }
    img {
      width: 32px;
      height: 32px;
      display: inline-block;
      margin: 0px 10px;
    }
  }
`, DesktopPermissionSteps = () => {
  const { t: me } = useTranslation(), ue = () => {
    window.location.reload();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Container$d, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(DesktopTitle, { children: me("desktop.generic.cameraInstructions.allowCamera") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Content$5, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(List$2, { desktop: !0, children: [
      desktop.isChrome() ? /* @__PURE__ */ jsxRuntimeExports.jsx(ChromeInstructions, {}) : null,
      desktop.isSafari() ? /* @__PURE__ */ jsxRuntimeExports.jsx(SafariInstructions, {}) : null,
      desktop.isFirefox() ? /* @__PURE__ */ jsxRuntimeExports.jsx(MozillaInstructions, {}) : null,
      desktop.isEdge() ? /* @__PURE__ */ jsxRuntimeExports.jsx(EdgeInstructions, {}) : null,
      desktop.isOpera() ? /* @__PURE__ */ jsxRuntimeExports.jsx(OperaInstructions, {}) : null
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ContainerButtons$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button$a, { onClick: ue, children: me("desktop.generic.cameraInstructions.reload") }) }),
    desktop.isChrome() ? /* @__PURE__ */ jsxRuntimeExports.jsxs(ChromeRecommendation, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: me("desktop.chrome.cameraInstructions.try") }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
        me("desktop.chrome.cameraInstructions.findIcon"),
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: cameraOff, "aria-hidden": !0, alt: "camera off" }),
        " ",
        me("desktop.chrome.cameraInstructions.inThe"),
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsxs("strong", { children: [
          " ",
          me("desktop.generic.cameraInstructions.allow"),
          " "
        ] }),
        me("desktop.chrome.cameraInstructions.menu")
      ] })
    ] }) : null
  ] });
}, Container$c = qe.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  align-items: center;
  width: 100vw;
  min-height: 100vh;
  z-index: 1;
  background: #fff;
  position: absolute;
  justify-content: center;
  gap: 40px;
`;
Container$c.displayName = "ModalPermissionContainer";
const Image$9 = qe.img`
  margin: 0 auto;
  display: block;
  flex: 1;
  @media only screen and (max-height: 600px) {
    flex-grow: 1;
    width: 40vw;
  }
`, Title$f = qe.h1`
  margin-bottom: 0;
  text-align: center;
`, Message$5 = qe.p`
  text-align: center;
  font-weight: bold;
  color: #000;
  margin: 0 15px;
  strong {
    color: #00b2fd;
  }
  @media only screen and (max-height: 640px) {
    font-size: 18px;
  }
`;
Message$5.displayName = "MessagePermission";
const ContainerImages = qe.div`
  display: flex;
  gap: 10px;
  width: 75%;
  max-width: 75%;
  align-items: center;
  justify-content: center;
  @media only screen and (max-height: 640px) {
    height: 90px;
    width: 50%;
  }
`, ContainerButtons = qe.div`
  margin-top: 33px;
  @media only screen and (max-height: 640px) {
    margin-top: 20px;
  }
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
ContainerButtons.displayName = "ContainerButtonsPermission";
const customStyles$6 = {
  overlay: {
    zIndex: 9999999999
  },
  content: {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    padding: 0,
    borderRadius: 0,
    border: "none",
    inset: 0,
    backgroundColor: "transparent",
    transform: "translateY(0)"
  }
}, isAndroidDevice$1 = !!mobile.Android(), isIOSDevice$1 = !!mobile.iOS(), isDesktop$1 = mobile.isDesktop();
function AllowCameraUse({ handleAllowCamera: me }) {
  const { t: ue } = useTranslation(), [Qe, Ue] = useState(!1), [He, Ge] = useState(!1), [Xe, Ke] = useState(!1);
  useEffect(() => () => {
    Ue(!1), Ke(!1);
  }, []);
  const $e = () => {
    isAndroidDevice$1 ? Ue(!0) : isIOSDevice$1 ? Ge(!0) : isDesktop$1 && Ke(!0);
  }, Je = () => He ? /* @__PURE__ */ jsxRuntimeExports.jsx(StepsToAllowCameraIOS, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ContainerButtons, { className: "IncodePermissionsReloadButtonContainer", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Button$a,
    {
      className: "IncodeAllowPermissionsButton",
      onClick: me,
      children: ue("cameraPermission.reload")
    }
  ) }) }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Title$f, { children: ue("cameraPermission.title") }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Message$5, { children: [
      ue("cameraPermission.instructions"),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: ue("cameraPermission.instructionsStrong") }),
      "."
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ContainerImages, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Image$9, { src: permissionsImg, "aria-hidden": "true" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ContainerButtons, { className: "IncodeAllowPermissionsButtonContainer IncodeiOSPermissionsContainer", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button$a,
      {
        className: "IncodeAllowPermissionsButton IncodeiOSButton",
        onClick: $e,
        children: ue("cameraPermission.allowButtonTitle")
      }
    ) })
  ] });
  return Xe ? /* @__PURE__ */ jsxRuntimeExports.jsx(Modal, { isOpen: !0, style: customStyles$6, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Container$c, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(DesktopPermissionSteps, {}) }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Modal, { isOpen: !0, style: customStyles$6, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Container$c, { className: "IncodeAllowPermissionsContainer", children: Qe ? /* @__PURE__ */ jsxRuntimeExports.jsx(StepsToAllowCameraAndroid, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ContainerButtons, { className: "IncodeAllowPermissionsButtonContainer IncodeAndroidPermissionsContainer", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Button$a,
    {
      className: "IncodeAllowPermissionsButton IncodeAndroidPermissionsButton",
      onClick: me,
      children: ue("cameraPermission.retry")
    }
  ) }) }) : Je() }) });
}
class IncodeCanvas {
  /**
   * Create a new canvas element.
   * @param {HTMLCanvasElement} canvas_ - The canvas element to clone.
   */
  constructor(ue) {
    this.base64Image = null, this.blobData = null, this.canvas = document.createElement("canvas"), this.canvas.width = ue.width, this.canvas.height = ue.height;
    const Qe = this.canvas.getContext("2d");
    Qe && Qe.drawImage(ue, 0, 0);
  }
  /**
   * Check if the current canvas is valid.
   * @return {boolean} True if the canvas is valid, false otherwise.
   */
  checkCanvas() {
    return this.canvas && this.canvas.width > 1 && this.canvas.height > 1;
  }
  /**
   * Release the data, stored by IncodeCanvas.
   */
  release() {
    if (!this.checkCanvas())
      return;
    this.canvas.width = 1, this.canvas.height = 1;
    const ue = this.canvas.getContext("2d");
    ue == null || ue.clearRect(0, 0, 1, 1), this.base64Image = null, this.blobData = null;
  }
  /**
   * Get the width of the canvas.
   * @return {number | null} The width of the canvas or null if current canvas is incorrect.
   */
  width() {
    return this.checkCanvas() ? this.canvas.width : null;
  }
  /**
   * Get the height of the canvas.
   * @return {number | null} The height of the canvas or null if current canvas is incorrect.
   */
  height() {
    return this.checkCanvas() ? this.canvas.height : null;
  }
  /**
   * Set the width of the canvas.
   * @param {number} width - The new width of the canvas.
   */
  setWidth(ue) {
    this.checkCanvas() && (this.canvas.width = ue);
  }
  /**
   * Set the height of the canvas.
   * @param {number} height - The new height of the canvas.
   */
  setHeight(ue) {
    this.checkCanvas() && (this.canvas.height = ue);
  }
  /**
   * Clone the current canvas.
   * This method doesn't clone blob data and hense it is synchronous.
   * @return {IncodeCanvas | null} A new IncodeCanvas object with the same canvas as the current one or null if current canvas is not valid.
   */
  clone() {
    if (!this.checkCanvas())
      return null;
    const ue = new IncodeCanvas(this.canvas);
    return ue.setBase64Image(this.base64Image), ue;
  }
  /**
   * Deep clone the current IncodeCanvas.
   * This method clones the canvas element and also the base64Image and blobData properties.
   * It is asynchronous because it uses the setBlobData method which is asynchronous.
   * @return {Promise<IncodeCanvas | null>} A Promise that resolves to a new IncodeCanvas object with the same properties as the current one,
   * or null if current canvas is not valid.
   */
  async deepClone() {
    const ue = this.clone();
    return ue ? (await ue.setBlobData(this.blobData), ue) : null;
  }
  /**
   * Returns the drawing context on the canvas.
   *
   * @param {string} contextId - The context identifier.
   * @param {CanvasRenderingContext2DSettings} [contextAttributes] - The context attributes.
   *
   * @returns {CanvasRenderingContext2D | null} - The drawing context on the canvas, or null if the context identifier is not supported
   * or current canvas is not valid.
   */
  getContext(ue, Qe) {
    if (!this.checkCanvas())
      return null;
    const Ue = this.canvas.getContext(ue, Qe);
    return Ue instanceof CanvasRenderingContext2D ? Ue : null;
  }
  /**
   * Retrieves the image data from the canvas and returns it.
   *
   * @returns {ImageData | null} - The image data from the canvas if the canvas and context are available and the operation was successful, null otherwise.
   */
  getImageData() {
    return this.checkCanvas() ? this.canvas.getContext("2d", { willReadFrequently: !0 }).getImageData(0, 0, this.canvas.width, this.canvas.height) : null;
  }
  /**
   * Updates the base64 representation of the current canvas image.
   * @param {number} jpegQuality - The quality level of the JPEG image. Defaults to 1.0.
   */
  updateBase64Image(ue = 1) {
    this.checkCanvas() && (this.base64Image = this.canvas.toDataURL("image/jpeg", ue));
  }
  /**
   * Converts the current canvas element to a base64 string.
   *
   * @param {number} jpegQuality - The quality level of the JPEG image. Defaults to 1.0.
   * @param {boolean} includeDataURLPrefix - If true, returns the complete base64 string. If false, returns the base64 string without the data URL prefix.
   *
   * @returns {string | null} - The base64 string if the operation was successful, null otherwise.
   */
  getBase64Image(ue = 1, Qe = !1) {
    return this.checkCanvas() ? (this.base64Image === null && this.updateBase64Image(ue), Qe ? this.base64Image : this.base64Image.split(",")[1]) : null;
  }
  /**
   * Sets the base64 representation of the current canvas image.
   * @param {string} base64Image - The base64 string of the image.
   */
  setBase64Image(ue) {
    this.base64Image = ue;
  }
  /**
   * Updates the Blob representation of the current canvas image.
   * @param {number} jpegQuality - The quality level of the JPEG image. Defaults to 1.0.
   */
  updateBlob(ue = 1, Qe = !1) {
    this.checkCanvas() && (this.base64Image === null && this.updateBase64Image(ue), this.blobData = IncodeCanvas.base64ToBlob(
      this.getBase64Image(ue, Qe)
    ));
  }
  /**
   * Converts a base64 string to a Blob and creates a URL for it.
   *
   * @param {string} base64 - The base64 string.
   *
   * @returns {Object} - An object containing the Blob object and its URL, or null if an error occurred.
   */
  static base64ToBlob(ue) {
    try {
      const Qe = atob(ue), Ue = [];
      for (let Xe = 0; Xe < Qe.length; Xe++)
        Ue.push(Qe.charCodeAt(Xe));
      const He = new Blob([new Uint8Array(Ue)]), Ge = URL.createObjectURL(He);
      return { blob: He, url: Ge };
    } catch (Qe) {
      console.error("Failed to convert base64 string to Blob:", Qe);
    }
    return null;
  }
  /**
   * Retrieves the Blob data and its URL from the current canvas.
   *
   * If the Blob data is not already available, it creates a Blob object from the current canvas and creates a URL for it.
   *
   * @param {number} jpegQuality=1.0 - The quality level of the JPEG image.
   * @param {boolean} includeDataURLPrefix=false - Whether to include the data URL prefix in the Blob data.
   *
   * @returns {Object | null} - An object containing the Blob object and its URL, or null if an error occurred.
   */
  getBlobData(ue = 1, Qe = !1) {
    return this.checkCanvas() ? (this.blobData === null && this.updateBlob(ue, Qe), this.blobData) : null;
  }
  /**
   * Sets the Blob data of the current canvas image.
   * @param {Object} blobData - An object containing the Blob object and its URL.
   */
  async setBlobData(ue) {
    const Qe = await ue.blob.arrayBuffer();
    this.blobData = {
      blob: new Blob([Qe], { type: ue.blob.type }),
      url: ue.url
    };
  }
  /**
   * Returns a resized canvas according to video element size.
   * @param {number} vieoElementWidth - The width of the video element.
   * @param {number} videoElementHeight - The height of the video element.
   * @returns {IncodeCanvas | null} - The resized canvas or null if there's no context.
   */
  getResizedCanvas(ue, Qe) {
    if (!this.checkCanvas())
      return null;
    const Ue = Math.abs(ue - window.innerWidth), He = new IncodeCanvas(document.createElement("canvas")), Ge = this.height() / Qe, Xe = window.innerWidth, Ke = window.innerHeight;
    He.setWidth(Xe), He.setHeight(Ke);
    const $e = He.getContext("2d");
    return $e ? ($e.drawImage(
      this.canvas,
      Ge * Ue / 2,
      0,
      Ge * Xe,
      Ge * Ke,
      0,
      0,
      Xe,
      Ke
    ), He) : (console.error("Failed to get 2d context in getProperSizeImage method."), null);
  }
}
const AndroidNotificationStyled = qe.div`
  background: white;
  width: 80%;
  padding: 1rem;
  .content {
    display: flex;
    flex-direction: column;
    padding-bottom: 1rem;
    h4 {
      font-size: 1.1rem;
    }
    p {
      text-align: center;
      font-size: 0.75rem;
    }
  }
  .container-buttons {
    width: 100%;
    display: flex;
    button {
      font-size: 0.875rem;
      line-height: 1.25rem;
      height: 2.5rem;
      color: #009688;
    }
  }
`, AndroidNotification = ({ buttons: me }) => {
  const { t: ue } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(AndroidNotificationStyled, { className: "IncodeAndroidNotification", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "content", children: /* @__PURE__ */ jsxRuntimeExports.jsx("h4", { children: ue("fakePermissionsNotification.android.title") }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "container-buttons", children: me })
  ] });
}, IOSNotificationStyled = qe.div`
  background: white;
  width: 80%;
  z-index: 100;
  border-radius: 0.5rem;
  .content {
    display: flex;
    flex-direction: column;
    padding-top: 1rem;
    padding-left: 1rem;
    padding-right: 1rem;
    h4 {
      text-align: center;
    }
    p {
      text-align: center;
      font-size: 0.75rem;
    }
  }
  .container-buttons {
    width: 100%;
    display: flex;
    button {
      font-size: 0.875rem;
      line-height: 1.25rem;
      height: 2.5rem;
      color: #3db0f7;
    }
  }
`, IOSNotification = ({ buttons: me }) => {
  const { t: ue } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(IOSNotificationStyled, { className: "IncodeIOSNotification", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "content", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h4", { children: ue("fakePermissionsNotification.ios.title") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: ue("fakePermissionsNotification.ios.content") })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "container-buttons", children: me })
  ] });
}, ContainerMessage = qe.div`
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  * + * {
    margin-bottom: 0.2rem;
  }
  button {
    margin-bottom: 1.5rem;
  }
  button:last-child {
    font-size: 0.8rem;
    margin-top: 1rem;
    border: none;
    background: transparent;
  }
  .content {
    display: flex;
    flex-direction: column;
    text-align: center;
    font-size: 1.25rem;
    line-height: 1.75rem;
    strong {
      color: #3db0f7;
    }
  }
  .container-img {
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
    img {
      width: 80%;
    }
  }
`, Message$4 = ({ buttons: me }) => {
  const { t: ue } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ContainerMessage, { className: "IncodeFakePermissionsRequestMessageContainer", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "content", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: ue("cameraPermission.messageLineOne") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: ue("cameraPermission.messageLineTwo") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: ue("cameraPermission.messageLineThree") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: ue("cameraPermission.messageLineFour") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: ue("cameraPermission.messageLineFive") })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "container-img", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: permissionsImg, alt: "Permissions" }) }),
    me
  ] });
}, ButtonDontAllowIOS = qe.button`
  border-color: rgb(232 233 236 / 1);
  border-right-width: 1px;
  border-top-width: 1px;
  border-bottom-left-radius: 0.5rem;
  flex: 1 1;
`, ButtonOkIOS = qe.button`
  border-color: rgb(232 233 236 / 1);
  flex: 1 1;
  border-top-width: 1px;
  border-bottom-right-radius: 0.5rem;
`, ButtonDontAllowAndroid = qe.button``, ButtonOKAndroid = qe.button`
  flex: 1 1;
`, customStyles$5 = {
  overlay: {
    zIndex: 9999999999,
    background: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "fixed",
    top: 0,
    left: 0
  },
  content: {
    top: 0,
    left: 0,
    display: "flex",
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    background: "rgba(0,0,0,0.6)",
    padding: 0,
    border: 0,
    borderRadius: 0
  }
}, isAndroidDevice = !!mobile.Android(), isIOSDevice = !!mobile.iOS(), FakePermissionsRequest = ({
  handleCameraPermission: me,
  handleDenyPermission: ue,
  handleQuitOnboarding: Qe,
  token: Ue,
  type: He
}) => {
  const { t: Ge } = useTranslation(), [Xe, Ke] = useState(!1);
  useEffect(() => {
    addEvent({
      token: Ue,
      code: "cameraFeedbackDisplayed",
      payload: {
        feedback: "Allow the permission to complete the process"
      },
      module: "ID Capture",
      screen: `${He} Camera Capture`
    });
  }, []);
  const $e = () => {
    Ke(!0), ue();
  };
  return useEffect(() => {
    mobile.isIpad() && me();
  }, [me]), Xe ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    Modal,
    {
      className: "IncodeFakePermissionsRequestModal",
      isOpen: !0,
      style: customStyles$5,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Message$4,
        {
          buttons: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(Button$a, { onClick: me, children: Ge("fakePermissionsNotification.allowPermission") }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("button", { onClick: Qe, type: "button", children: Ge("fakePermissionsNotification.quitOnboarding") })
          ] })
        }
      )
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { contentLabel: "Request permissions modal", isOpen: !0, style: customStyles$5, children: [
    isIOSDevice ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      IOSNotification,
      {
        buttons: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonDontAllowIOS, { onClick: $e, children: Ge("fakePermissionsNotification.ios.dontAllow") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonOkIOS, { onClick: me, children: Ge("fakePermissionsNotification.ios.ok") })
        ] })
      }
    ) : null,
    isAndroidDevice ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      AndroidNotification,
      {
        buttons: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonDontAllowAndroid, { onClick: $e, children: Ge("fakePermissionsNotification.android.deny") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonOKAndroid, { onClick: me, children: Ge("fakePermissionsNotification.android.allow") })
        ] })
      }
    ) : null
  ] });
}, Video$1 = qe.video`
  width: calc(100% + 20px);
  margin-left: -10px;
  max-width: unset;

  @media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape) {
    width: auto;
    height: 100%;

    &.kiosk {
      margin-left: 0;
      width: 100%;
      object-fit: cover;
    }
  }

  &.selfie {
    height: auto;
    width: 100%;
    transform: rotateY(180deg);
    object-fit: cover;
    margin-left: 0;

    &.desktop {
      height: 100%;
      object-fit: none;
    }

    &.kiosk {
      height: 100%;
    }

    &.assistedOnboarding {
      transform: none;
    }

    &.horizontal {
      width: auto;
      height: 100%;
    }
  }

  &.full-height {
    height: 100%;
  }

  &.desktop {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transform: rotateY(180deg);
    overflow: hidden;
    margin: auto;
  }
`, isAndroid = !!mobile.Android(), isDesktop = mobile.isDesktop(), parser = new UAParser(), { browser: browser$1 } = parser.getResult(), onFrameEmitter = new EventEmitter$5(), Webcam = forwardRef(
  ({
    className: me,
    onPlay: ue,
    videoSource: Qe,
    isSelfie: Ue = !1,
    type: He,
    permissionMessage: Ge,
    onLog: Xe = emptyFunc,
    stream: Ke,
    onError: $e = emptyFunc,
    token: Je,
    interviewId: Ze,
    onStreamReady: nt = emptyFunc,
    showCustomCameraPermissionScreen: tt,
    assistedOnboarding: et,
    deviceId: rt,
    onRestartOnboarding: it = reload,
    showDoublePermissionsRequest: ot = !1,
    publishAudio: at = !1,
    fullHeight: st = !1,
    isRecordingEnabled: ut = !1,
    isKiosk: lt = !1
  }, dt) => {
    const [At, pt] = useState(!1), [gt, wt] = useState(Ke), [Bt, Tt] = useState(!0), [yt, Ct] = useState(!0), ht = useRef(!1), It = useRef(null), vt = useRef(), Et = useRef(0), bt = useRef(0), Rt = useRef(0), { t: St } = useTranslation(), [kt, jt] = usePermissions(), Pt = useRef(), Qt = useRef(!1);
    Pt.current = kt;
    const [qt, _t] = useState(!ot);
    Ge = Ge || St("permissionMessage"), useEffect(() => {
      Pt.current && !isDesktop && !lt && _t(Pt.current);
    }, [kt]), useEffect(() => {
      const un = sessionStorage.getItem("cameraPermissionsGranted") === "true";
      !isDesktop && un && !lt && _t(!0);
    }, [kt]), useEffect(() => {
      const un = It.current;
      return () => {
        un.pause(), un.srcObject = null;
      };
    }, []), useEffect(() => () => {
      gt == null || gt.getTracks().forEach((un) => un.stop());
    }, [gt]);
    const Yt = () => {
      if (!ht.current)
        return;
      if (!It.current) {
        ht.current = !1;
        return;
      }
      if (It.current.paused) {
        ht.current = !1;
        return;
      }
      const un = It.current.currentTime;
      un !== Et.current && (onFrameEmitter.emit("newFrame"), Et.current = un, !ut && yt && Ct(!1)), requestAnimationFrame(Yt);
    }, Xt = useCallback(() => {
      var un, An, mn;
      if (!document.hidden)
        return (An = (un = It.current) == null ? void 0 : un.srcObject) == null || An.clone(), (mn = It.current) == null ? void 0 : mn.play();
    }, []);
    useEventListener("visibilitychange", Xt, document);
    const Ut = async (un) => {
      const An = un.getVideoTracks()[0], mn = await getDeviceCapabilities(), En = getChosenCameraInfo(
        An,
        Rt.current,
        Qe
      ), { width: Jt, height: an } = An.getSettings(), { focusMode: cn = !1 } = navigator.mediaDevices.getSupportedConstraints();
      addEvent({
        code: "cameraType",
        payload: {
          type: "webRTC",
          resolution: `${Jt}x${an}`,
          autofocus: cn,
          label: An.label
        },
        token: Je
      }), addEvent({
        code: "cameraDebugInfo",
        payload: {
          type: "webRTC",
          availableCameras: mn,
          chosenCamera: En
        },
        token: Je
      }), Ue && addEvent({
        code: "cameraSelfie",
        token: Je
      });
    }, Lt = (un) => {
      Ct(!1), un.constructor.name === "DOMException" ? (addEvent({
        code: "permissionDenied",
        payload: {
          message: "User denied to use camera."
        },
        token: Je
      }), Xe(
        getLogObject("permissionDenied", {
          message: "User denied to use camera."
        })
      ), un.type = "permissionDenied", tt ? pt(!0) : $e(un)) : un.constructor.name === "OverconstrainedError" ? (Xe(
        getLogObject("OSVersionNotSupported", {
          message: "OS version is not supported."
        })
      ), Tt(!1)) : (Xe(
        getLogObject("browserNotSupported", {
          message: "Browser is not supported."
        })
      ), Tt(!1));
    }, Ot = async (un) => {
      jt(!0);
      const An = () => {
        It.current.srcObject = un, nt(un), wt(un);
      }, mn = un.getVideoTracks()[0], En = await OnboardingAnalytics$1.checkForVirtualCameraByLabel(
        mn
      );
      En != null && En.isDetected && (En.hasPriorDetection || await addDeviceStats(Je, {
        cameraLabelInspectionStatus: "FAIL"
      }), $e(new Error("Virtual camera is detected"))), mobile.iOS() ? mn.applyConstraints({
        //@ts-ignore
        advanced: [{ focusDistance: 1 }]
      }).finally(() => {
        An();
      }) : An();
    };
    useEffect(() => ((async () => {
      function An(Jt) {
        const an = {
          resizeMode: "none",
          facingMode: "environment"
        };
        switch (Jt) {
          case 0:
            return {
              ...an,
              height: {
                ideal: localStorage.getItem("isIPhone14OrHigher") === "true" ? 1080 : 720
              }
            };
          case 1:
            return {
              ...an,
              width: { min: 3200, ideal: 3840, max: 4096 },
              height: { min: 1800, ideal: 2160, max: 2400 }
            };
          case 2:
            return {
              ...an,
              width: { min: 1400, ideal: 1920, max: 2160 },
              height: { min: 900, ideal: 1080, max: 1440 }
            };
          case 3:
            return {
              ...an,
              width: { min: 640, ideal: 640, max: 800 },
              height: { min: 480, ideal: 480, max: 600 }
            };
          case 4:
            return {
              ...an,
              width: { min: 640, ideal: 800, max: 960 },
              height: { min: 480, ideal: 480, max: 480 }
            };
          default:
            return {};
        }
      }
      const mn = async (Jt) => {
        const an = {
          video: Qe === "environment" ? An(Jt.current) : localStorage.getItem("isIPhone14OrHigher") === "true" ? {
            height: { ideal: 1080 }
          } : {
            facingMode: Qe,
            height: { ideal: 480 },
            width: { ideal: 640 }
          },
          audio: at
        }, cn = isSafari() || at, dn = {
          audio: cn,
          video: {
            facingMode: "user",
            deviceId: rt ? { exact: rt } : void 0
          }
        };
        if (mobile.isIpad() && Qe === "user")
          try {
            const yn = await getNonUltraWideFrontCameraStream();
            Ot(yn), await Ut(yn);
          } catch (yn) {
            $e({ ...yn, type: "permissionDenied" });
          }
        else isAndroid && Qe === "environment" ? navigator.mediaDevices.getUserMedia(an).then(async (yn) => {
          const Nn = yn.getVideoTracks()[0], Rn = await getCameras(), rn = adjustCamerasFromCameraStream(
            Nn,
            Rn
          );
          yn.getTracks().forEach((In) => In.stop());
          let ln = 1280, pn = 720;
          if (Jt.current > 1) {
            const { width: In, height: Bn } = An(
              Jt.current
            );
            ln = In == null ? void 0 : In.ideal, pn = Bn == null ? void 0 : Bn.ideal;
          }
          const Sn = {
            video: {
              deviceId: {
                exact: rn.deviceId
              },
              width: {
                ideal: ln
              },
              height: {
                ideal: pn
              }
            },
            audio: cn
          };
          navigator.mediaDevices.getUserMedia(Sn).then(async (In) => {
            await Ut(In), Ot(In);
          });
        }).catch((yn) => {
          Jt.current = Jt.current + 1, Jt.current > 4 ? Lt(yn) : mn(Jt);
        }) : navigator.mediaDevices.getUserMedia(mobile.any() ? an : dn).then(async (yn) => {
          await Ut(yn), Ot(yn);
        }).catch((yn) => {
          Lt(yn);
        });
      };
      if (mobile.iOS() && Qt.current)
        return;
      if (qt === !0 || isDesktop || lt || ot === !1) {
        if (Qt.current = !0, Ke) {
          Ot(Ke);
          return;
        }
        Ct(!0), mn(Rt), addEvent({
          token: Je,
          code: "cameraFeedbackDisplayed",
          payload: {
            feedback: "Loading..."
          },
          module: "ID Capture",
          screen: `${He} Camera Capture`
        });
      }
      const En = document.createElement("canvas");
      vt.current = En;
    })(), () => {
      qt && (Qt.current = !1, Ke == null || Ke.getTracks().forEach((An) => An.stop()));
    }), [qt, Qe, Ke]), useImperativeHandle(dt, () => ({
      getCanvas: Dt,
      video: It.current,
      stream: gt,
      setIsLoadingCamera: Ct
    }));
    const ft = ({
      width: un = 0,
      height: An = 0,
      useOriginalDimensions: mn = !0
    }) => {
      if (!It.current || !It.current.videoHeight || !It.current.videoWidth || !vt.current || !ht.current)
        return !1;
      const En = It.current.currentTime;
      if (bt.current === En)
        return !1;
      if (bt.current = En, mn)
        vt.current.width = It.current.videoWidth, vt.current.height = It.current.videoHeight;
      else {
        if (un === 0 || An === 0)
          return !1;
        vt.current.width = un, vt.current.height = An;
      }
      const Jt = vt.current.getContext("2d");
      return Jt.clearRect(0, 0, vt.current.width, vt.current.height), Jt.drawImage(It.current, 0, 0), !0;
    }, Dt = ({
      width: un = 0,
      height: An = 0,
      useOriginalDimensions: mn = !0
    } = {}) => ft({
      width: un,
      height: An,
      useOriginalDimensions: mn
    }) ? new IncodeCanvas(vt.current) : null, Mt = () => It.current ? It.current.videoWidth > It.current.videoHeight : !1, Ft = () => {
      _t(!0), sessionStorage.setItem("cameraPermissionsGranted", String(!0)), addEvent({
        token: Je,
        code: "permissionsAllowedCustom"
      }), addEvent({
        token: Je,
        code: "cameraPermissionSubmitted",
        payload: {
          requestor: "browser",
          requestorDetails: browser$1.name,
          permission: "allowed"
        },
        module: "ID capture",
        screen: `${He} Camera Capture`
      });
    }, Gt = () => {
      addEvent({
        token: Je,
        code: "permissionsQuitFlow"
      }), setTimeout(() => {
        window.location.reload();
      }, 0);
    }, zt = () => {
      addEvent({
        token: Je,
        code: "permissionsDeniedCustom"
      }), addEvent({
        token: Je,
        code: "cameraPermissionSubmitted",
        payload: {
          requestor: "browser",
          requestorDetails: browser$1.name,
          permission: "denied"
        },
        module: "ID capture",
        screen: `${He} Camera Capture`
      });
    }, $t = sessionStorage.getItem("cameraPermissionsGranted") === "true", Ht = ot && (typeof kt < "u" && !kt && !qt || typeof qt < "u" && !qt) && !isDesktop && !lt && !$t, hn = () => {
      ht.current || (ue && typeof ue == "function" && ue(), ht.current = !0, requestAnimationFrame(Yt));
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment, { children: [
      At && /* @__PURE__ */ jsxRuntimeExports.jsx(AllowCameraUse, { handleAllowCamera: it }),
      Ht && /* @__PURE__ */ jsxRuntimeExports.jsx(
        FakePermissionsRequest,
        {
          handleDenyPermission: zt,
          handleCameraPermission: Ft,
          handleQuitOnboarding: Gt,
          type: He,
          token: Je,
          interviewId: Ze
        }
      ),
      !Bt && /* @__PURE__ */ jsxRuntimeExports.jsx(BrowserNotSupported, {}),
      yt && !Ht && /* @__PURE__ */ jsxRuntimeExports.jsx(Loader$1, { message: St("webcam.loading"), fullScreen: !0 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Video$1,
        {
          "aria-hidden": "true",
          autoPlay: !0,
          className: classNames(me, {
            selfie: Ue,
            horizontal: Mt(),
            desktop: !mobile.any(),
            assistedOnboarding: et,
            "full-height": st
          }),
          playsInline: !0,
          onPlay: hn,
          ref: It,
          muted: !0
        }
      )
    ] });
  }
), captureButton = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='65'%20height='65'%20viewBox='0%200%2065%2065'%3e%3cg%20fill='none'%20fill-rule='evenodd'%3e%3cg%3e%3cg%3e%3cg%20transform='translate(-155%20-646)%20translate(155%20646)'%3e%3ccircle%20cx='32.319'%20cy='32.319'%20r='32.319'%20fill='%2320263D'/%3e%3ccircle%20cx='32.319'%20cy='32.319'%20r='25.137'%20fill='%23FFF'%20fill-opacity='.093'%20stroke='%23FFF'%20stroke-width='2.052'/%3e%3c/g%3e%3cg%20fill='%23FFF'%20fill-rule='nonzero'%3e%3cpath%20d='M17.193%2012.24c0%202.294-1.88%204.16-4.193%204.16-2.312%200-4.192-1.866-4.192-4.16%200-2.293%201.88-4.16%204.192-4.16%202.312%200%204.193%201.867%204.193%204.16zM26%206.334v11.814C26%2019.723%2024.713%2021%2023.125%2021H2.875C1.287%2021%200%2019.723%200%2018.148V6.334C0%204.76%201.287%203.482%202.875%203.482h3.536v-.987C6.411%201.117%207.537%200%208.927%200h8.146c1.39%200%202.516%201.117%202.516%202.495v.986h3.536C24.713%203.482%2026%204.76%2026%206.334zm-6.65%205.906c0-3.473-2.849-6.298-6.35-6.298-3.5%200-6.349%202.825-6.349%206.298S9.5%2018.54%2013%2018.54c3.501%200%206.35-2.826%206.35-6.299z'%20transform='translate(-155%20-646)%20translate(155%20646)%20translate(19%2021)'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e", faceFrame$1 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='336'%20height='518'%20viewBox='0%200%20336%20518'%3e%3cpath%20fill='none'%20fill-rule='evenodd'%20stroke='%23FFF'%20stroke-dasharray='7.139999675750732,19.03999967575073'%20stroke-width='9.044'%20d='M168%20513.392c76.83%200%20162.893-113.92%20162.893-254.447S280.236%204.498%20168%204.498%205.107%20118.418%205.107%20258.945%2091.17%20513.392%20168%20513.392z'/%3e%3c/svg%3e";
class FaceDetection {
  constructor() {
    this.pipelineProfile = null, this.bestCanvas = null, this.bestLandmarks = null, this.bestTopLeft = null, this.bestSize = null, this.currCanvas = null;
  }
  formatLandmarks(ue, Qe, Ue) {
    const [
      He,
      Ge,
      Xe,
      Ke,
      $e,
      Je,
      Ze,
      nt,
      tt,
      et
    ] = ue;
    return {
      rightEyeX: He,
      rightEyeY: Ge,
      leftEyeX: Xe,
      leftEyeY: Ke,
      noseTipX: $e,
      noseTipY: Je,
      rightMouthX: Ze,
      rightMouthY: nt,
      mouthX: tt,
      mouthY: et,
      x: Qe[0],
      y: Qe[1],
      width: Ue[0],
      height: Ue[1]
    };
  }
  async initialize(ue) {
    const {
      onNoFace: Qe,
      onCapturing: Ue,
      onCapture: He,
      onTooManyFaces: Ge,
      onTooClose: Xe,
      onCenterFace: Ke,
      onFarAway: $e,
      onFaceAngle: Je,
      onDark: Ze,
      onBlur: nt,
      onHeadWear: tt,
      onLenses: et,
      onEyesClosed: rt,
      onFaceMask: it,
      onSwitchToManualCapture: ot,
      isLensesCheckEnabled: at,
      isMaskCheckEnabled: st,
      isClosedEyesCheckEnabled: ut,
      isHeadWearCheckEnabled: lt,
      isVideoSelfie: dt,
      pipelineProfile: At,
      autocaptureTimeout: pt
    } = ue;
    this.pipelineProfile = At;
    const gt = this.pipelineProfile.pipelineType;
    await MlWasmJSApi$1.setFacePositionConstraints(
      gt,
      At.parameters.frameMinX,
      At.parameters.frameMinY,
      At.parameters.frameMaxX,
      At.parameters.frameMaxY
    ), await MlWasmJSApi$1.setFaceDetectionThresholds(
      gt,
      At.parameters.brightnessThreshold,
      At.parameters.blurrinessThreshold,
      At.parameters.tiltRotationAngleThreshold,
      At.parameters.minMagicCropSize,
      pt,
      At.parameters.minFaceQualityScore
    ), await MlWasmJSApi$1.setFaceAttributesEnabled(
      gt,
      at,
      st,
      ut,
      lt
    ), await MlWasmJSApi$1.setFaceAttributesThresholds(
      gt,
      At.parameters.headwearThreshold,
      At.parameters.lensesThreshold,
      At.parameters.closedEyesThreshold,
      At.parameters.maskThreshold
    ), await MlWasmJSApi$1.setFaceDetectionMode(gt, dt);
    const wt = () => {
      this.bestCanvas.updateBase64Image(), this.bestCanvas.updateBlob(), He(
        this.bestCanvas,
        this.formatLandmarks(
          this.bestLandmarks,
          this.bestTopLeft,
          this.bestSize
        )
      );
    }, Bt = (Tt) => {
      this.bestCanvas = this.currCanvas.clone();
      const yt = Tt.rect;
      this.bestTopLeft = [yt.x, yt.y];
      const Ct = [yt.x + yt.width, yt.y + yt.height], ht = this.bestTopLeft, It = Ct;
      this.bestSize = [It[0] - ht[0], It[1] - ht[1]], this.bestLandmarks = [
        Tt.rightEye.x,
        Tt.rightEye.y,
        Tt.leftEye.x,
        Tt.leftEye.y,
        Tt.noseTip.x,
        Tt.noseTip.y,
        Tt.rightMouthCorner.x,
        Tt.rightMouthCorner.y,
        Tt.leftMouthCorner.x,
        Tt.leftMouthCorner.y
      ];
    };
    await MlWasmJSApi$1.setFaceDetectionCallbacks(
      gt,
      $e,
      Xe,
      Ge,
      Qe,
      wt,
      Ue,
      Ke,
      Ze,
      nt,
      Je,
      Bt,
      et,
      it,
      rt,
      tt,
      ot
    );
  }
  async detect(ue) {
    try {
      this.currCanvas = ue, await MlWasmJSApi$1.allocateImageBuffers(ue.width(), ue.height()), await MlWasmJSApi$1.process(
        ue.getImageData(),
        this.pipelineProfile.pipelineType
      ), this.currCanvas.release();
    } catch (Qe) {
      console.error(`Exception: ${Qe}`);
    }
  }
}
const sources = {
  front: "FRONT_ID",
  back: "BACK_ID",
  selfie: "SELFIE"
}, logFrame = async ({
  source: me,
  base64Image: ue,
  token: Qe
}) => api.post(
  "/omni/log/frame/v2",
  {
    base64Image: ue
  },
  {
    params: {
      source: me
    },
    headers: {
      "X-Incode-Hardware-Id": Qe
    }
  }
).then((Ue) => Ue.data).catch(emptyFunc);
function useSelfie({
  timeout: me = 4e4,
  onLog: ue = emptyFunc,
  handleCapture: Qe,
  numberOfTries: Ue = 3,
  handleNoAttempsLeft: He = emptyFunc,
  webcam: Ge,
  token: Xe,
  isDetecting: Ke,
  onSwitchManualCapture: $e = emptyFunc,
  onManualCaptureSelfie: Je = emptyFunc
}) {
  const Ze = useRef(0), nt = useRef(!1), tt = useRef(!1), [et, rt] = useState(""), [it, ot] = useState("idle"), [at, st] = useState(!1), ut = useRef(void 0), [lt, dt] = useState(!1), At = useRef(), pt = useRef($e), gt = useRef(null), wt = useRef(!1), { t: Bt } = useTranslation(), Tt = async (mn, En) => {
    tt.current || (Ke.current = !1, await sleep(300), tt.current = !0, ot("uploading"), Qe(mn, En), await sleep(2e3), Ct(En).catch(console.log));
  }, yt = 500;
  async function Ct(mn) {
    var rn;
    if (mobile.isDesktop())
      return;
    Ge.current.video.play();
    const Jt = document.querySelector("video").srcObject, an = Jt == null ? void 0 : Jt.getVideoTracks()[0];
    ut.current = (rn = an == null ? void 0 : an.getSettings()) == null ? void 0 : rn.zoom;
    const cn = await zoomCameraToTheMax(Jt);
    if (mobile.iOS() && !cn) {
      await ht(an);
      return;
    }
    await sleep(yt);
    const dn = Ge.current.getCanvas();
    if (!dn) {
      await ht(an);
      return;
    }
    const yn = dn.getImageData(), Nn = dn.getBase64Image();
    logFrame({
      token: Xe,
      base64Image: Nn,
      source: sources.selfie
    }), await MlWasmJSApi$1.allocateImageBuffers(yn.width, yn.height);
    const Rn = await MlWasmJSApi$1.runSelfieCapture(yn);
    if (Rn.faces.size() > 0) {
      const ln = Rn.faces.get(0), { rightEye: pn, leftEye: Sn } = ln;
      if (!(pn != null && pn.x) || !(pn != null && pn.y) || !(Sn != null && Sn.x) || !(Sn != null && Sn.y)) {
        await ht(an);
        return;
      }
      let In = 1e4;
      if (mn && (In = Math.sqrt(
        (mn.rightEyeX - mn.leftEyeX) ** 2 + (mn.rightEyeY - mn.leftEyeY) ** 2
      ), In === 0)) {
        await ht(an);
        return;
      }
      Math.sqrt(
        (pn.x - Sn.x) ** 2 + (pn.y - Sn.y) ** 2
      ) / In < 1.4 && await addDeviceStats(Xe, { virtualCameraDetected: !0 });
    }
    await ht(an);
  }
  const ht = async (mn) => {
    ut.current && (await zoomCamera(mn, ut.current), await sleep(yt), ut.current = mn.getSettings().zoom);
  }, It = () => {
    var En;
    const mn = getLogObject("timeout", {
      message: "No face found"
    });
    (En = pt.current) == null || En.call(pt), ue(mn), dt(!0);
  }, vt = () => {
    nt.current || (ue(
      getLogObject("tooFar", {
        message: Bt("notifications.moveCloser")
      })
    ), rt(Bt("notifications.moveCloser")));
  }, Et = () => {
    nt.current || (ue(
      getLogObject("tooManyFaces", {
        message: Bt("notifications.tooManyFaces")
      })
    ), rt(Bt("notifications.tooManyFaces")));
  }, bt = () => {
    nt.current || (ue(
      getLogObject("centerFace", {
        message: Bt("notifications.centerFace")
      })
    ), rt(Bt("notifications.centerFace")));
  }, Rt = () => {
    tt.current || nt.current || (ot("capturing"), ue(
      getLogObject("dontMove", {
        message: Bt("notifications.dontMove")
      })
    ), rt(Bt("notifications.getReady")), nt.current = !0);
  }, St = () => {
    nt.current || tt.current || rt(Bt("notifications.moveAway"));
  }, kt = () => {
    nt.current || tt.current || rt(Bt("notifications.onDark"));
  }, jt = () => {
    nt.current || tt.current || rt(Bt("notifications.onBlur"));
  }, Pt = () => {
    nt.current || tt.current || rt(Bt("notifications.onFaceAngle"));
  }, Qt = () => {
    nt.current || tt.current || rt(Bt("notifications.removeHeadwear"));
  }, qt = () => {
    nt.current || tt.current || rt(Bt("notifications.removeLenses"));
  }, _t = () => {
    nt.current || tt.current || rt(Bt("notifications.openEyes"));
  }, Yt = () => {
    nt.current || tt.current || rt(Bt("notifications.removeMask"));
  }, Xt = async () => {
    gt.current = new FaceDetection(), await gt.current.initialize({
      onNoFace: emptyFunc,
      onCaptureFace: emptyFunc,
      onTooManyFaces: Et,
      onTooClose: St,
      onCenterFace: bt,
      onFarAway: vt,
      onCapturing: Rt,
      onBlur: jt,
      onDark: kt,
      onFaceAngle: Pt,
      onHeadWear: Qt,
      onLenses: qt,
      onEyesClosed: _t,
      onFaceMask: Yt,
      onSwitchToManualCapture: It,
      onCapture: Tt,
      isLensesCheckEnabled: !1,
      isMaskCheckEnabled: !1,
      isClosedEyesCheckEnabled: !0,
      isHeadWearCheckEnabled: !1,
      isVideoSelfie: !1,
      pipelineProfile: detectionSetup.getProfile(DetectionType.Selfie),
      autocaptureTimeout: me
    });
  };
  useEffect(() => {
    pt.current = $e;
  }, [$e]), useEffect(() => {
    dt(!1), Dt();
  }, []);
  const Ut = async ({ response: mn, livenessPassed: En, imageBase64: Jt }) => {
    if (Ze.current = Ze.current + 1, Ue !== -1 && Ze.current >= Ue)
      return He({
        response: mn,
        livenessPassed: En,
        imageBase64: Jt
      });
    rt(""), ot("idle"), nt.current = !1, tt.current = !1;
  }, Lt = (mn) => {
    const En = mn.errorMessage || mn.message || mn.reason, { status: Jt } = mn;
    if (Jt === 3004) {
      rt(Bt("notifications.unableToCrop")), ue(
        getLogObject("unableToCrop", {
          message: `${Bt("notifications.unableToCrop")}`
        })
      );
      return;
    }
    switch (En) {
      case "Face not found.":
        rt(Bt("notifications.faceNotFound")), ue(
          getLogObject("faceNotDetected", {
            message: `${Bt("notifications.faceNotFound")}`
          })
        );
        break;
      case "No faces found on the image":
        rt(Bt("notifications.face")), ue(
          getLogObject("faceNotDetected", {
            message: `${Bt("notifications.face")}`
          })
        );
        break;
      case "BadRequestException: More than one face detected.":
        rt(Bt("notifications.multiple")), ue(
          getLogObject("multipleFacesDetected", {
            message: `${Bt("notifications.multiple")}`
          })
        );
        break;
      case "Cropping area goes off the image.":
        rt(Bt("notifications.crop")), ue(
          getLogObject("cropTooSmall", {
            message: `${Bt("notifications.crop")}`
          })
        );
        break;
      case "Image in portrait orientation is expected.":
        rt(Bt("notifications.portrait")), ue(
          getLogObject("imageNotPortrait", {
            message: `${Bt("notifications.portrait")}`
          })
        );
        break;
      default:
        ue(
          getLogObject("InternalServerError", {
            message: `${Bt("notifications.error")}`
          })
        ), rt(Bt("notifications.error"));
        break;
    }
  }, Ot = useCallback(async () => {
    if (!(!Ke.current || wt.current)) {
      wt.current = !0, gt.current || await Xt();
      try {
        await MlWasmJSApi$1.handleDetectionCallAndUpdateState(
          detectionSetup.getProfile(DetectionType.Selfie).pipelineType
        );
        const mn = Ge.current.getCanvas();
        await gt.current.detect(mn);
      } catch (mn) {
        console.error(mn);
      } finally {
        wt.current = !1;
      }
    }
  }, [Xt]);
  useEffect(() => (onFrameEmitter.on("newFrame", Ot), () => {
    onFrameEmitter.off("newFrame", Ot);
  }), [Ot]);
  const ft = useCallback(() => {
    Ke.current || (Ke.current = !0, Ge.current.video.play());
  }, [ue, Xt]), Dt = useCallback(async () => {
    st(!0), await sleep(4e3), ft();
  }, [ft]);
  function Mt() {
    Je();
    const mn = Ge.current.getCanvas();
    mn.updateBase64Image(), mn.updateBlob(), Tt(mn, null);
  }
  const Ft = it === "capturing", Gt = it === "uploading", zt = it === "success", $t = it === "error", Ht = Ft || Gt, hn = Gt || zt || $t;
  return {
    notificationMessage: et,
    mode: it,
    capturing: nt,
    cameraReady: at,
    showManualCapture: lt,
    handleFaceAutoCapture: Tt,
    setMode: ot,
    resetLoading: Ut,
    setNotificationMessage: rt,
    handleError: Lt,
    autoDetectFace: ft,
    startAutoDetect: Dt,
    handleManualCapture: Mt,
    isCapturing: Ft,
    isUploading: Gt,
    isSuccess: zt,
    isError: $t,
    isLoading: Ht,
    hideCamera: hn,
    showBorders: at && (it === "idle" || $t),
    shouldShowManualCapture: lt && !hn,
    selfieTimeoutRef: At
  };
}
async function sendMfa({ verificationCode: me, transactionId: ue }) {
  return api.post("/omni/oneToN/mfa", { verificationCode: me, transactionId: ue }).then((Qe) => Qe.data).catch((Qe) => {
    var Ue;
    return Promise.reject((Ue = Qe == null ? void 0 : Qe.response) == null ? void 0 : Ue.data);
  });
}
const ErrorContainer$1 = qe.div`
  text-align: center;
  margin-top: 10px;
`, ErrorSpan = qe.span`
  font-size: 16px;
  color: #ff5c6f;
`, ErrorMessage$5 = ({ error: me }) => {
  const { t: ue } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorContainer$1, { children: me && /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorSpan, { children: ue(`secondFactor.${me}`) }) });
}, SecondFactorContainer = qe.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 100px;
`, DivWithMargin = qe.div`
  margin-bottom: 90px;
`, SecondFactor = ({ transactionId: me, onSuccess: ue }) => {
  const [Qe, Ue] = useState(""), [He, Ge] = useState(""), [Xe, Ke] = useState(!1), { t: $e } = useTranslation();
  async function Je() {
    try {
      Ke(!0);
      const Ze = await sendMfa({
        transactionId: me,
        verificationCode: Qe
      });
      ue(Ze);
    } catch {
      Ke(!1), Ge("incorrect");
    }
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(SecondFactorContainer, { className: "IncodeSecondFactorContainer", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(DivWithMargin, { className: "IncodeSecondFactorDivWithMargin", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: $e("secondFactor.title") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: $e("secondFactor.instruction") })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(DivWithMargin, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        StyledInput,
        {
          className: "IncodeSecondFactorInput",
          type: "tel",
          autoComplete: "off",
          value: Qe,
          onChange: (Ze) => {
            Ue(Ze.target.value), Ge("");
          }
        }
      ),
      He && /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorMessage$5, { error: He })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button$a,
      {
        disabled: Xe,
        onClick: Je,
        className: "IncodeSecondFactorButton",
        children: $e("common.continue")
      }
    )
  ] });
};
async function identify({
  base64Image: me,
  faceCoordinates: ue,
  authReference: Qe
}) {
  return api.post("/omni/oneToN/identify?returnIPDeviceLocation=true", {
    authReference: Qe,
    selfie: {
      base64Image: await MlWasmJSApi$1.encryptImage(me),
      faceCoordinates: ue,
      clientInfo: { deviceClass: getDeviceClass() }
    }
  }).then((Ue) => Ue.data).catch((Ue) => {
    var He;
    return Promise.reject((He = Ue == null ? void 0 : Ue.response) == null ? void 0 : He.data);
  });
}
async function identifyInstantVerify({
  token: me,
  base64Image: ue,
  faceCoordinates: Qe
}) {
  return api.post(
    "/omni/instant/verify/face",
    {
      base64Image: await MlWasmJSApi$1.encryptImage(ue),
      faceCoordinates: Qe,
      clientInfo: { deviceClass: getDeviceClass() }
    },
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).then((Ue) => Ue.data).catch((Ue) => {
    var He;
    return Promise.reject((He = Ue == null ? void 0 : Ue.response) == null ? void 0 : He.data);
  });
}
async function oneToOneIdentify({
  base64Image: me,
  phone: ue,
  email: Qe,
  authReference: Ue,
  uuid: He,
  nationalNumber: Ge
}) {
  return api.post("omni/1to1/identify?returnIPDeviceLocation=true", {
    phone: ue,
    email: Qe,
    authReference: Ue,
    uuid: He,
    nationalNumber: Ge,
    selfie: {
      base64Image: await MlWasmJSApi$1.encryptImage(me),
      clientInfo: { deviceClass: getDeviceClass() }
    }
  }).then((Xe) => Xe.data).catch((Xe) => {
    var Ke;
    return Promise.reject((Ke = Xe == null ? void 0 : Xe.response) == null ? void 0 : Ke.data);
  });
}
const getCircleText$1 = (me, ue) => ({
  uploading: me("notifications.uploading"),
  success: me("notifications.done"),
  error: ue
});
function Login({
  onError: me,
  onSuccess: ue,
  onCapture: Qe,
  timeout: Ue = 4e4,
  stopAtError: He = !1,
  stopAtAccessDenied: Ge = !1,
  isOneToOne: Xe = !1,
  oneToOneProps: Ke,
  accessDeniedNotificationText: $e,
  token: Je,
  isInstantVerify: Ze = !1,
  showCustomCameraPermissionScreen: nt = !1,
  isKiosk: tt = !1
}) {
  const [et, rt] = useState("selfie"), [it, ot] = useState(""), [at, st] = useState(""), ut = useRef(null), lt = useRef(!1), dt = async (Ut) => {
    var Lt;
    if (He) {
      me(Ut);
      return;
    }
    qt(Ut || yt("notifications.serverError")), _t("error"), await sleep(3e3), Yt({
      response: (Lt = Ut == null ? void 0 : Ut.response) == null ? void 0 : Lt.data,
      livenessPassed: null,
      imageBase64: at
    }), vt();
  }, At = async (Ut) => {
    const Lt = Ut.spoofAttempt === !1, Ot = !!Ut.customerId && !Ut.error, ft = Ut.secondFactor, Dt = Ut.hasLenses, Mt = Ut.hasFaceMask;
    if (ft) {
      rt("secondFactor"), ot(Ut.transactionId), st(at);
      return;
    }
    if (!Lt || !Ot || Mt || Dt) {
      if (He) {
        const Gt = {
          status: Ut == null ? void 0 : Ut.error.status,
          message: Ut == null ? void 0 : Ut.error.error
        };
        me(Gt ?? "error");
        return;
      }
      if (_t("error"), Xt((() => {
        switch (!0) {
          case Mt:
            return yt("notifications.faceMask");
          case Dt:
            return yt("notifications.lenses");
          case !Lt:
            return yt("notifications.spoof");
          case !Ot:
            return $e ?? yt("selfie.accessDenied");
          default:
            return "";
        }
      })()), await sleep(3e3), Lt && !Ot && Ge) {
        const Gt = new Error("AccessDenied");
        me(Gt);
        return;
      }
      Yt({
        response: Ut,
        livenessPassed: Lt,
        imageBase64: at
      }), vt();
      return;
    }
    Tt(Ut, at);
  }, pt = async (Ut, Lt) => {
    await identifyInstantVerify({
      token: Je,
      base64Image: Ut,
      faceCoordinates: Lt
    }).then(At).catch(dt);
  }, gt = async (Ut, Lt) => {
    await identify({
      base64Image: Ut,
      faceCoordinates: Lt,
      authReference: Ke == null ? void 0 : Ke.authReference
    }).then(At).catch(dt);
  }, wt = async (Ut, Lt) => {
    await oneToOneIdentify({
      base64Image: Ut,
      faceCoordinates: Lt,
      phone: Ke == null ? void 0 : Ke.phone,
      email: Ke == null ? void 0 : Ke.email,
      authReference: Ke == null ? void 0 : Ke.authReference,
      uuid: Ke == null ? void 0 : Ke.identityId,
      nationalNumber: Ke == null ? void 0 : Ke.nationalNumber
    }).then(At).catch(dt);
  }, Bt = throttle$1(
    async (Ut, Lt) => {
      MlWasmJSApi$1.resetAllPipelines();
      const Ot = Ut.getBase64Image();
      Qe && typeof Qe == "function" ? Qe(await MlWasmJSApi$1.encryptImage(Ot), Lt) : Ze ? pt(Ot, Lt) : Xe ? wt(Ot, Lt) : gt(Ot, Lt);
    },
    300
  );
  async function Tt(Ut, Lt) {
    ue({
      ...Ut,
      token: Ut.token,
      base64Image: Lt || at
    });
  }
  const { t: yt } = useTranslation(), {
    showManualCapture: Ct,
    mode: ht,
    notificationMessage: It,
    startAutoDetect: vt,
    cameraReady: Et,
    handleManualCapture: bt,
    isSuccess: Rt,
    isError: St,
    isLoading: kt,
    hideCamera: jt,
    showBorders: Pt,
    shouldShowManualCapture: Qt,
    handleError: qt,
    setMode: _t,
    resetLoading: Yt,
    setNotificationMessage: Xt
  } = useSelfie({
    timeout: Ue,
    isDetecting: lt,
    handleCapture: Bt,
    numberOfTries: -1,
    webcam: ut,
    token: ""
  });
  return et === "secondFactor" ? /* @__PURE__ */ jsxRuntimeExports.jsx(SecondFactor, { transactionId: it, onSuccess: Tt }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Container$h,
    {
      className: classNames("IncodeLoginContainer", {
        kiosk: tt
      }),
      children: [
        Qt && /* @__PURE__ */ jsxRuntimeExports.jsxs(
          CaptureButtonContainer$2,
          {
            className: classNames("IncodeLoginCaptureButtonContainer", {
              kiosk: tt
            }),
            initial: {
              scale: 0
            },
            animate: {
              scale: 1
            },
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: yt("common.takePhoto") }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("button", { onClick: bt, type: "button", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: captureButton, alt: "capture button" }) })
            ]
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          WebcamContainer$1,
          {
            className: classNames("IncodeLoginWebcamContainer", {
              kiosk: tt
            }),
            children: [
              (kt || Rt) && /* @__PURE__ */ jsxRuntimeExports.jsx(
                BordersContainer,
                {
                  className: classNames("IncodeLoginBordersContainer", {
                    kiosk: tt
                  }),
                  children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingBorders, { className: "IncodeLoginLoadingBorders", mode: ht })
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Hidder,
                {
                  className: "IncodeLoginHidder",
                  initial: { width: 50, height: 50 },
                  animate: {
                    width: Et ? 300 : 50,
                    height: Et ? 300 : 50
                  },
                  children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    CameraOvalOuter,
                    {
                      className: classNames("IncodeLoginCameraOvalOuter", {
                        "no-borders": kt || Rt,
                        "has-error": St
                      }),
                      initial: {
                        borderWidth: "0px"
                      },
                      transition: {
                        delay: 0,
                        ease: "linear"
                      },
                      animate: {
                        borderWidth: Pt ? "6px" : "0px",
                        borderColor: St ? "#ff5c6f" : "#21273b"
                      },
                      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
                        CameraOvalInner,
                        {
                          className: classNames("IncodeLoginCameraOvalInner", {
                            isUploading: jt
                          }),
                          children: [
                            /* @__PURE__ */ jsxRuntimeExports.jsx(
                              FaceFrame$1,
                              {
                                src: faceFrame$1,
                                alt: "face frame",
                                className: classNames("IncodeLoginFaceFrame", { hidden: jt })
                              }
                            ),
                            /* @__PURE__ */ jsxRuntimeExports.jsx(
                              Webcam,
                              {
                                ref: ut,
                                videoSource: "user",
                                onPlay: () => {
                                },
                                isSelfie: !0,
                                type: "login",
                                className: classNames("video__selfie IncodeLoginWebcam", {
                                  hidden: jt,
                                  kiosk: tt
                                }),
                                onError: me,
                                showCustomCameraPermissionScreen: nt,
                                isKiosk: tt
                              }
                            ),
                            jt && /* @__PURE__ */ jsxRuntimeExports.jsx(
                              CameraOvalInnerText,
                              {
                                "aria-live": "assertive",
                                "aria-atomic": "true",
                                className: classNames("IncodeLoginCameraOvalInnerText", { isError: St }),
                                children: getCircleText$1(yt, It)[ht]
                              }
                            )
                          ]
                        }
                      )
                    }
                  )
                }
              )
            ]
          }
        ),
        !jt && /* @__PURE__ */ jsxRuntimeExports.jsx(
          NotificationInline,
          {
            "aria-live": "assertive",
            initial: {
              scale: 0
            },
            animate: {
              scale: Et ? 1 : 0
            },
            className: classNames("IncodeLoginNotificationInline", {
              hasManualCapture: Ct
            }),
            children: It || /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
              yt("notifications.selfie.one"),
              " ",
              /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
              yt("notifications.selfie.two")
            ] })
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("canvas", { id: "canvasFrame", hidden: !0 })
      ]
    }
  );
}
var dist$1 = {}, OTSession$4 = {}, createSession$6 = {};
Object.defineProperty(createSession$6, "__esModule", {
  value: !0
});
createSession$6.default = createSession$5;
function createSession$5() {
  var me = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ue = me.apiKey, Qe = me.sessionId, Ue = me.token, He = me.onStreamsUpdated, Ge = me.onConnect, Xe = me.onError, Ke = me.options;
  if (!ue)
    throw new Error("Missing apiKey");
  if (!Qe)
    throw new Error("Missing sessionId");
  if (!Ue)
    throw new Error("Missing token");
  var $e = [], Je = function(rt) {
    var it = $e.findIndex(function(ot) {
      return ot.id === rt.stream.id;
    });
    it < 0 && ($e.push(rt.stream), He($e));
  }, Ze = function(rt) {
    var it = $e.findIndex(function(ot) {
      return ot.id === rt.stream.id;
    });
    it >= 0 && ($e.splice(it, 1), He($e));
  }, nt = {
    streamCreated: Je,
    streamDestroyed: Ze
  }, tt = OT.initSession(ue, Qe, Ke);
  return tt.on(nt), tt.connect(Ue, function(et) {
    tt && (et && typeof Xe == "function" ? Xe(et) : !et && typeof Ge == "function" && Ge());
  }), {
    session: tt,
    streams: $e,
    disconnect: function() {
      tt && (tt.off(nt), tt.disconnect()), $e = null, Je = null, Ze = null, nt = null, tt = null, this.session = null, this.streams = null;
    }
  };
}
Object.defineProperty(OTSession$4, "__esModule", {
  value: !0
});
var _typeof$5 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(me) {
  return typeof me;
} : function(me) {
  return me && typeof Symbol == "function" && me.constructor === Symbol && me !== Symbol.prototype ? "symbol" : typeof me;
}, _createClass$9 = /* @__PURE__ */ function() {
  function me(ue, Qe) {
    for (var Ue = 0; Ue < Qe.length; Ue++) {
      var He = Qe[Ue];
      He.enumerable = He.enumerable || !1, He.configurable = !0, "value" in He && (He.writable = !0), Object.defineProperty(ue, He.key, He);
    }
  }
  return function(ue, Qe, Ue) {
    return Qe && me(ue.prototype, Qe), Ue && me(ue, Ue), ue;
  };
}(), _react$d = React__default, _react2$d = _interopRequireDefault$o(_react$d), _propTypes$d = propTypesExports, _propTypes2$d = _interopRequireDefault$o(_propTypes$d), _createSession2$3 = createSession$6, _createSession3$1 = _interopRequireDefault$o(_createSession2$3);
function _interopRequireDefault$o(me) {
  return me && me.__esModule ? me : { default: me };
}
function _classCallCheck$9(me, ue) {
  if (!(me instanceof ue))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$9(me, ue) {
  if (!me)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return ue && (typeof ue == "object" || typeof ue == "function") ? ue : me;
}
function _inherits$9(me, ue) {
  if (typeof ue != "function" && ue !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof ue);
  me.prototype = Object.create(ue && ue.prototype, { constructor: { value: me, enumerable: !1, writable: !0, configurable: !0 } }), ue && (Object.setPrototypeOf ? Object.setPrototypeOf(me, ue) : me.__proto__ = ue);
}
var OTSession$3 = function(me) {
  _inherits$9(ue, me);
  function ue(Qe) {
    _classCallCheck$9(this, ue);
    var Ue = _possibleConstructorReturn$9(this, (ue.__proto__ || Object.getPrototypeOf(ue)).call(this, Qe));
    return Ue.state = {
      streams: []
    }, Ue;
  }
  return _createClass$9(ue, [{
    key: "getChildContext",
    value: function() {
      return { session: this.sessionHelper.session, streams: this.state.streams };
    }
  }, {
    key: "componentWillMount",
    value: function() {
      this.createSession();
    }
  }, {
    key: "componentDidUpdate",
    value: function(Ue) {
      (Ue.apiKey !== this.props.apiKey || Ue.sessionId !== this.props.sessionId || Ue.token !== this.props.token) && this.createSession();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.destroySession();
    }
  }, {
    key: "createSession",
    value: function() {
      var Ue = this;
      this.destroySession(), this.sessionHelper = (0, _createSession3$1.default)({
        apiKey: this.props.apiKey,
        sessionId: this.props.sessionId,
        token: this.props.token,
        onStreamsUpdated: function(Xe) {
          Ue.setState({ streams: Xe });
        },
        onConnect: this.props.onConnect,
        onError: this.props.onError,
        options: this.props.options
      }), this.props.eventHandlers && _typeof$5(this.props.eventHandlers) === "object" && this.sessionHelper.session.on(this.props.eventHandlers);
      var He = this.sessionHelper.streams;
      this.setState({ streams: He });
    }
  }, {
    key: "destroySession",
    value: function() {
      this.sessionHelper && (this.props.eventHandlers && _typeof$5(this.props.eventHandlers) === "object" && this.sessionHelper.session.off(this.props.eventHandlers), this.sessionHelper.disconnect());
    }
  }, {
    key: "render",
    value: function() {
      var Ue = this.props.children, He = typeof Ue == "function";
      return _react2$d.default.createElement(
        _react$d.Fragment,
        null,
        He ? Ue(this.sessionHelper) : this.props.children
      );
    }
  }]), ue;
}(_react$d.Component);
OTSession$4.default = OTSession$3;
OTSession$3.propTypes = {
  children: _propTypes2$d.default.oneOfType([_propTypes2$d.default.element, _propTypes2$d.default.arrayOf(_propTypes2$d.default.element), _propTypes2$d.default.func]).isRequired,
  apiKey: _propTypes2$d.default.string.isRequired,
  sessionId: _propTypes2$d.default.string.isRequired,
  token: _propTypes2$d.default.string.isRequired,
  eventHandlers: _propTypes2$d.default.objectOf(_propTypes2$d.default.func),
  onConnect: _propTypes2$d.default.func,
  onError: _propTypes2$d.default.func,
  options: _propTypes2$d.default.object
};
OTSession$3.defaultProps = {
  eventHandlers: null,
  onConnect: null,
  onError: null,
  options: {}
};
OTSession$3.childContextTypes = {
  streams: _propTypes2$d.default.arrayOf(_propTypes2$d.default.object),
  session: _propTypes2$d.default.shape({
    subscribe: _propTypes2$d.default.func,
    unsubscribe: _propTypes2$d.default.func
  })
};
var OTPublisher$4 = {}, reWhitespace = /\s/;
function trimmedEndIndex$1(me) {
  for (var ue = me.length; ue-- && reWhitespace.test(me.charAt(ue)); )
    ;
  return ue;
}
var _trimmedEndIndex = trimmedEndIndex$1, trimmedEndIndex = _trimmedEndIndex, reTrimStart = /^\s+/;
function baseTrim$1(me) {
  return me && me.slice(0, trimmedEndIndex(me) + 1).replace(reTrimStart, "");
}
var _baseTrim = baseTrim$1;
function isObject$6(me) {
  var ue = typeof me;
  return me != null && (ue == "object" || ue == "function");
}
var isObject_1 = isObject$6, freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, _freeGlobal = freeGlobal$1, freeGlobal = _freeGlobal, freeSelf = typeof self == "object" && self && self.Object === Object && self, root$5 = freeGlobal || freeSelf || Function("return this")(), _root = root$5, root$4 = _root, Symbol$3 = root$4.Symbol, _Symbol = Symbol$3, Symbol$2 = _Symbol, objectProto$1 = Object.prototype, hasOwnProperty$1 = objectProto$1.hasOwnProperty, nativeObjectToString$1 = objectProto$1.toString, symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : void 0;
function getRawTag$1(me) {
  var ue = hasOwnProperty$1.call(me, symToStringTag$1), Qe = me[symToStringTag$1];
  try {
    me[symToStringTag$1] = void 0;
    var Ue = !0;
  } catch {
  }
  var He = nativeObjectToString$1.call(me);
  return Ue && (ue ? me[symToStringTag$1] = Qe : delete me[symToStringTag$1]), He;
}
var _getRawTag = getRawTag$1, objectProto = Object.prototype, nativeObjectToString = objectProto.toString;
function objectToString$1(me) {
  return nativeObjectToString.call(me);
}
var _objectToString = objectToString$1, Symbol$1 = _Symbol, getRawTag = _getRawTag, objectToString = _objectToString, nullTag = "[object Null]", undefinedTag = "[object Undefined]", symToStringTag = Symbol$1 ? Symbol$1.toStringTag : void 0;
function baseGetTag$1(me) {
  return me == null ? me === void 0 ? undefinedTag : nullTag : symToStringTag && symToStringTag in Object(me) ? getRawTag(me) : objectToString(me);
}
var _baseGetTag = baseGetTag$1;
function isObjectLike$1(me) {
  return me != null && typeof me == "object";
}
var isObjectLike_1 = isObjectLike$1, baseGetTag = _baseGetTag, isObjectLike = isObjectLike_1, symbolTag = "[object Symbol]";
function isSymbol$1(me) {
  return typeof me == "symbol" || isObjectLike(me) && baseGetTag(me) == symbolTag;
}
var isSymbol_1 = isSymbol$1, baseTrim = _baseTrim, isObject$5 = isObject_1, isSymbol = isSymbol_1, NAN = NaN, reIsBadHex = /^[-+]0x[0-9a-f]+$/i, reIsBinary = /^0b[01]+$/i, reIsOctal = /^0o[0-7]+$/i, freeParseInt = parseInt;
function toNumber$1(me) {
  if (typeof me == "number")
    return me;
  if (isSymbol(me))
    return NAN;
  if (isObject$5(me)) {
    var ue = typeof me.valueOf == "function" ? me.valueOf() : me;
    me = isObject$5(ue) ? ue + "" : ue;
  }
  if (typeof me != "string")
    return me === 0 ? me : +me;
  me = baseTrim(me);
  var Qe = reIsBinary.test(me);
  return Qe || reIsOctal.test(me) ? freeParseInt(me.slice(2), Qe ? 2 : 8) : reIsBadHex.test(me) ? NAN : +me;
}
var toNumber_1 = toNumber$1, toNumber = toNumber_1, INFINITY = 1 / 0, MAX_INTEGER = 17976931348623157e292;
function toFinite$1(me) {
  if (!me)
    return me === 0 ? me : 0;
  if (me = toNumber(me), me === INFINITY || me === -INFINITY) {
    var ue = me < 0 ? -1 : 1;
    return ue * MAX_INTEGER;
  }
  return me === me ? me : 0;
}
var toFinite_1 = toFinite$1, toFinite = toFinite_1;
function toInteger$1(me) {
  var ue = toFinite(me), Qe = ue % 1;
  return ue === ue ? Qe ? ue - Qe : ue : 0;
}
var toInteger_1 = toInteger$1, toInteger = toInteger_1, FUNC_ERROR_TEXT = "Expected a function";
function before$1(me, ue) {
  var Qe;
  if (typeof ue != "function")
    throw new TypeError(FUNC_ERROR_TEXT);
  return me = toInteger(me), function() {
    return --me > 0 && (Qe = ue.apply(this, arguments)), me <= 1 && (ue = void 0), Qe;
  };
}
var before_1 = before$1, before = before_1;
function once$1(me) {
  return before(2, me);
}
var once_1 = once$1;
const once$2 = /* @__PURE__ */ getDefaultExportFromCjs(once_1);
var lodash_min = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
lodash_min.exports;
(function(me, ue) {
  (function() {
    function Qe(gn, xn, Wt) {
      switch (Wt.length) {
        case 0:
          return gn.call(xn);
        case 1:
          return gn.call(xn, Wt[0]);
        case 2:
          return gn.call(xn, Wt[0], Wt[1]);
        case 3:
          return gn.call(xn, Wt[0], Wt[1], Wt[2]);
      }
      return gn.apply(xn, Wt);
    }
    function Ue(gn, xn, Wt, Mn) {
      for (var Wn = -1, Qn = gn == null ? 0 : gn.length; ++Wn < Qn; ) {
        var _i = gn[Wn];
        xn(Mn, _i, Wt(_i), gn);
      }
      return Mn;
    }
    function He(gn, xn) {
      for (var Wt = -1, Mn = gn == null ? 0 : gn.length; ++Wt < Mn && xn(gn[Wt], Wt, gn) !== !1; ) ;
      return gn;
    }
    function Ge(gn, xn) {
      for (var Wt = gn == null ? 0 : gn.length; Wt-- && xn(gn[Wt], Wt, gn) !== !1; ) ;
      return gn;
    }
    function Xe(gn, xn) {
      for (var Wt = -1, Mn = gn == null ? 0 : gn.length; ++Wt < Mn; ) if (!xn(gn[Wt], Wt, gn)) return !1;
      return !0;
    }
    function Ke(gn, xn) {
      for (var Wt = -1, Mn = gn == null ? 0 : gn.length, Wn = 0, Qn = []; ++Wt < Mn; ) {
        var _i = gn[Wt];
        xn(_i, Wt, gn) && (Qn[Wn++] = _i);
      }
      return Qn;
    }
    function $e(gn, xn) {
      return !!(gn != null && gn.length) && ut(gn, xn, 0) > -1;
    }
    function Je(gn, xn, Wt) {
      for (var Mn = -1, Wn = gn == null ? 0 : gn.length; ++Mn < Wn; ) if (Wt(xn, gn[Mn])) return !0;
      return !1;
    }
    function Ze(gn, xn) {
      for (var Wt = -1, Mn = gn == null ? 0 : gn.length, Wn = Array(Mn); ++Wt < Mn; ) Wn[Wt] = xn(gn[Wt], Wt, gn);
      return Wn;
    }
    function nt(gn, xn) {
      for (var Wt = -1, Mn = xn.length, Wn = gn.length; ++Wt < Mn; ) gn[Wn + Wt] = xn[Wt];
      return gn;
    }
    function tt(gn, xn, Wt, Mn) {
      var Wn = -1, Qn = gn == null ? 0 : gn.length;
      for (Mn && Qn && (Wt = gn[++Wn]); ++Wn < Qn; ) Wt = xn(Wt, gn[Wn], Wn, gn);
      return Wt;
    }
    function et(gn, xn, Wt, Mn) {
      var Wn = gn == null ? 0 : gn.length;
      for (Mn && Wn && (Wt = gn[--Wn]); Wn--; ) Wt = xn(Wt, gn[Wn], Wn, gn);
      return Wt;
    }
    function rt(gn, xn) {
      for (var Wt = -1, Mn = gn == null ? 0 : gn.length; ++Wt < Mn; ) if (xn(gn[Wt], Wt, gn)) return !0;
      return !1;
    }
    function it(gn) {
      return gn.split("");
    }
    function ot(gn) {
      return gn.match(ro) || [];
    }
    function at(gn, xn, Wt) {
      var Mn;
      return Wt(gn, function(Wn, Qn, _i) {
        if (xn(Wn, Qn, _i)) return Mn = Qn, !1;
      }), Mn;
    }
    function st(gn, xn, Wt, Mn) {
      for (var Wn = gn.length, Qn = Wt + (Mn ? 1 : -1); Mn ? Qn-- : ++Qn < Wn; ) if (xn(gn[Qn], Qn, gn)) return Qn;
      return -1;
    }
    function ut(gn, xn, Wt) {
      return xn === xn ? Ot(gn, xn, Wt) : st(gn, dt, Wt);
    }
    function lt(gn, xn, Wt, Mn) {
      for (var Wn = Wt - 1, Qn = gn.length; ++Wn < Qn; ) if (Mn(gn[Wn], xn)) return Wn;
      return -1;
    }
    function dt(gn) {
      return gn !== gn;
    }
    function At(gn, xn) {
      var Wt = gn == null ? 0 : gn.length;
      return Wt ? Tt(gn, xn) / Wt : Rr;
    }
    function pt(gn) {
      return function(xn) {
        return xn == null ? Ht : xn[gn];
      };
    }
    function gt(gn) {
      return function(xn) {
        return gn == null ? Ht : gn[xn];
      };
    }
    function wt(gn, xn, Wt, Mn, Wn) {
      return Wn(gn, function(Qn, _i, Sf) {
        Wt = Mn ? (Mn = !1, Qn) : xn(Wt, Qn, _i, Sf);
      }), Wt;
    }
    function Bt(gn, xn) {
      var Wt = gn.length;
      for (gn.sort(xn); Wt--; ) gn[Wt] = gn[Wt].value;
      return gn;
    }
    function Tt(gn, xn) {
      for (var Wt, Mn = -1, Wn = gn.length; ++Mn < Wn; ) {
        var Qn = xn(gn[Mn]);
        Qn !== Ht && (Wt = Wt === Ht ? Qn : Wt + Qn);
      }
      return Wt;
    }
    function yt(gn, xn) {
      for (var Wt = -1, Mn = Array(gn); ++Wt < gn; ) Mn[Wt] = xn(Wt);
      return Mn;
    }
    function Ct(gn, xn) {
      return Ze(xn, function(Wt) {
        return [Wt, gn[Wt]];
      });
    }
    function ht(gn) {
      return gn && gn.slice(0, Ft(gn) + 1).replace($r, "");
    }
    function It(gn) {
      return function(xn) {
        return gn(xn);
      };
    }
    function vt(gn, xn) {
      return Ze(xn, function(Wt) {
        return gn[Wt];
      });
    }
    function Et(gn, xn) {
      return gn.has(xn);
    }
    function bt(gn, xn) {
      for (var Wt = -1, Mn = gn.length; ++Wt < Mn && ut(xn, gn[Wt], 0) > -1; ) ;
      return Wt;
    }
    function Rt(gn, xn) {
      for (var Wt = gn.length; Wt-- && ut(xn, gn[Wt], 0) > -1; ) ;
      return Wt;
    }
    function St(gn, xn) {
      for (var Wt = gn.length, Mn = 0; Wt--; ) gn[Wt] === xn && ++Mn;
      return Mn;
    }
    function kt(gn) {
      return "\\" + Qm[gn];
    }
    function jt(gn, xn) {
      return gn == null ? Ht : gn[xn];
    }
    function Pt(gn) {
      return Nm.test(gn);
    }
    function Qt(gn) {
      return Dm.test(gn);
    }
    function qt(gn) {
      for (var xn, Wt = []; !(xn = gn.next()).done; ) Wt.push(xn.value);
      return Wt;
    }
    function _t(gn) {
      var xn = -1, Wt = Array(gn.size);
      return gn.forEach(function(Mn, Wn) {
        Wt[++xn] = [Wn, Mn];
      }), Wt;
    }
    function Yt(gn, xn) {
      return function(Wt) {
        return gn(xn(Wt));
      };
    }
    function Xt(gn, xn) {
      for (var Wt = -1, Mn = gn.length, Wn = 0, Qn = []; ++Wt < Mn; ) {
        var _i = gn[Wt];
        _i !== xn && _i !== cn || (gn[Wt] = cn, Qn[Wn++] = Wt);
      }
      return Qn;
    }
    function Ut(gn) {
      var xn = -1, Wt = Array(gn.size);
      return gn.forEach(function(Mn) {
        Wt[++xn] = Mn;
      }), Wt;
    }
    function Lt(gn) {
      var xn = -1, Wt = Array(gn.size);
      return gn.forEach(function(Mn) {
        Wt[++xn] = [Mn, Mn];
      }), Wt;
    }
    function Ot(gn, xn, Wt) {
      for (var Mn = Wt - 1, Wn = gn.length; ++Mn < Wn; ) if (gn[Mn] === xn) return Mn;
      return -1;
    }
    function ft(gn, xn, Wt) {
      for (var Mn = Wt + 1; Mn--; ) if (gn[Mn] === xn) return Mn;
      return Mn;
    }
    function Dt(gn) {
      return Pt(gn) ? Gt(gn) : Um(gn);
    }
    function Mt(gn) {
      return Pt(gn) ? zt(gn) : it(gn);
    }
    function Ft(gn) {
      for (var xn = gn.length; xn-- && yi.test(gn.charAt(xn)); ) ;
      return xn;
    }
    function Gt(gn) {
      for (var xn = If.lastIndex = 0; If.test(gn); ) ++xn;
      return xn;
    }
    function zt(gn) {
      return gn.match(If) || [];
    }
    function $t(gn) {
      return gn.match(Om) || [];
    }
    var Ht, hn = "4.17.21", un = 200, An = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", mn = "Expected a function", En = "Invalid `variable` option passed into `_.template`", Jt = "__lodash_hash_undefined__", an = 500, cn = "__lodash_placeholder__", dn = 1, yn = 2, Nn = 4, Rn = 1, rn = 2, ln = 1, pn = 2, Sn = 4, In = 8, Bn = 16, Pn = 32, Yn = 64, or = 128, mr = 256, lr = 512, Mr = 30, ai = "...", Un = 800, qn = 16, hr = 1, Vr = 2, Pr = 3, Er = 1 / 0, xr = 9007199254740991, kr = 17976931348623157e292, Rr = NaN, sr = 4294967295, br = sr - 1, Gr = sr >>> 1, on = [["ary", or], ["bind", ln], ["bindKey", pn], ["curry", In], ["curryRight", Bn], ["flip", lr], ["partial", Pn], ["partialRight", Yn], ["rearg", mr]], bn = "[object Arguments]", vn = "[object Array]", Ln = "[object AsyncFunction]", Jn = "[object Boolean]", nr = "[object Date]", ir = "[object DOMException]", Zn = "[object Error]", Wr = "[object Function]", Or = "[object GeneratorFunction]", pr = "[object Map]", yr = "[object Number]", to = "[object Null]", vi = "[object Object]", Kn = "[object Promise]", Td = "[object Proxy]", Ts = "[object RegExp]", Wi = "[object Set]", no = "[object String]", zc = "[object Symbol]", cf = "[object Undefined]", Bs = "[object WeakMap]", uf = "[object WeakSet]", Rs = "[object ArrayBuffer]", Na = "[object DataView]", Xc = "[object Float32Array]", dl = "[object Float64Array]", Os = "[object Int8Array]", fl = "[object Int16Array]", hl = "[object Int32Array]", Kc = "[object Uint8Array]", Ns = "[object Uint8ClampedArray]", qo = "[object Uint16Array]", pl = "[object Uint32Array]", lf = /\b__p \+= '';/g, df = /\b(__p \+=) '' \+/g, ff = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Bd = /&(?:amp|lt|gt|quot|#39);/g, Rd = /[&<>"']/g, Ds = RegExp(Bd.source), hf = RegExp(Rd.source), Od = /<%-([\s\S]+?)%>/g, Al = /<%([\s\S]+?)%>/g, Ps = /<%=([\s\S]+?)%>/g, gl = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, ks = /^\w*$/, pf = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Vn = /[\\^$.*+?()[\]{}|]/g, Cr = RegExp(Vn.source), $r = /^\s+/, yi = /\s/, zo = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, oi = /\{\n\/\* \[wrapped with (.+)\] \*/, Xo = /,? & /, ro = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, ml = /[()=,{}\[\]\/\s]/, io = /\\(\\)?/g, Nd = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Yc = /\w*$/, Af = /^[-+]0x[0-9a-f]+$/i, gf = /^0b[01]+$/i, mf = /^\[object .+?Constructor\]$/, Dd = /^0o[0-7]+$/i, $c = /^(?:0|[1-9]\d*)$/, Jc = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Pd = /($^)/, dm = /['\n\r\u2028\u2029\\]/g, kd = "\\ud800-\\udfff", fm = "\\u0300-\\u036f", hm = "\\ufe20-\\ufe2f", pm = "\\u20d0-\\u20ff", b1 = fm + hm + pm, S1 = "\\u2700-\\u27bf", w1 = "a-z\\xdf-\\xf6\\xf8-\\xff", Am = "\\xac\\xb1\\xd7\\xf7", gm = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", mm = "\\u2000-\\u206f", Em = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", T1 = "A-Z\\xc0-\\xd6\\xd8-\\xde", B1 = "\\ufe0e\\ufe0f", R1 = Am + gm + mm + Em, Ef = "['’]", Cm = "[" + kd + "]", O1 = "[" + R1 + "]", _d = "[" + b1 + "]", N1 = "\\d+", vm = "[" + S1 + "]", D1 = "[" + w1 + "]", P1 = "[^" + kd + R1 + N1 + S1 + w1 + T1 + "]", Cf = "\\ud83c[\\udffb-\\udfff]", ym = "(?:" + _d + "|" + Cf + ")", k1 = "[^" + kd + "]", vf = "(?:\\ud83c[\\udde6-\\uddff]){2}", yf = "[\\ud800-\\udbff][\\udc00-\\udfff]", Zc = "[" + T1 + "]", _1 = "\\u200d", L1 = "(?:" + D1 + "|" + P1 + ")", Im = "(?:" + Zc + "|" + P1 + ")", M1 = "(?:" + Ef + "(?:d|ll|m|re|s|t|ve))?", Q1 = "(?:" + Ef + "(?:D|LL|M|RE|S|T|VE))?", F1 = ym + "?", j1 = "[" + B1 + "]?", xm = "(?:" + _1 + "(?:" + [k1, vf, yf].join("|") + ")" + j1 + F1 + ")*", bm = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Sm = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", V1 = j1 + F1 + xm, wm = "(?:" + [vm, vf, yf].join("|") + ")" + V1, Tm = "(?:" + [k1 + _d + "?", _d, vf, yf, Cm].join("|") + ")", Bm = RegExp(Ef, "g"), Rm = RegExp(_d, "g"), If = RegExp(Cf + "(?=" + Cf + ")|" + Tm + V1, "g"), Om = RegExp([Zc + "?" + D1 + "+" + M1 + "(?=" + [O1, Zc, "$"].join("|") + ")", Im + "+" + Q1 + "(?=" + [O1, Zc + L1, "$"].join("|") + ")", Zc + "?" + L1 + "+" + M1, Zc + "+" + Q1, Sm, bm, N1, wm].join("|"), "g"), Nm = RegExp("[" + _1 + kd + b1 + B1 + "]"), Dm = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Pm = ["Array", "Buffer", "DataView", "Date", "Error", "Float32Array", "Float64Array", "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object", "Promise", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_", "clearTimeout", "isFinite", "parseInt", "setTimeout"], km = -1, Fr = {};
    Fr[Xc] = Fr[dl] = Fr[Os] = Fr[fl] = Fr[hl] = Fr[Kc] = Fr[Ns] = Fr[qo] = Fr[pl] = !0, Fr[bn] = Fr[vn] = Fr[Rs] = Fr[Jn] = Fr[Na] = Fr[nr] = Fr[Zn] = Fr[Wr] = Fr[pr] = Fr[yr] = Fr[vi] = Fr[Ts] = Fr[Wi] = Fr[no] = Fr[Bs] = !1;
    var _r = {};
    _r[bn] = _r[vn] = _r[Rs] = _r[Na] = _r[Jn] = _r[nr] = _r[Xc] = _r[dl] = _r[Os] = _r[fl] = _r[hl] = _r[pr] = _r[yr] = _r[vi] = _r[Ts] = _r[Wi] = _r[no] = _r[zc] = _r[Kc] = _r[Ns] = _r[qo] = _r[pl] = !0, _r[Zn] = _r[Wr] = _r[Bs] = !1;
    var _m = {
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, Lm = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }, Mm = { "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"', "&#39;": "'" }, Qm = { "\\": "\\", "'": "'", "\n": "n", "\r": "r", "\u2028": "u2028", "\u2029": "u2029" }, Fm = parseFloat, jm = parseInt, U1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, Vm = typeof self == "object" && self && self.Object === Object && self, li = U1 || Vm || Function("return this")(), xf = ue && !ue.nodeType && ue, _s = xf && !0 && me && !me.nodeType && me, G1 = _s && _s.exports === xf, bf = G1 && U1.process, ra = function() {
      try {
        var gn = _s && _s.require && _s.require("util").types;
        return gn || bf && bf.binding && bf.binding("util");
      } catch {
      }
    }(), W1 = ra && ra.isArrayBuffer, q1 = ra && ra.isDate, z1 = ra && ra.isMap, X1 = ra && ra.isRegExp, K1 = ra && ra.isSet, Y1 = ra && ra.isTypedArray, Um = pt("length"), Hm = gt(_m), Gm = gt(Lm), Wm = gt(Mm), qm = function gn(xn) {
      function Wt(ct) {
        if (qr(ct) && !er(ct) && !(ct instanceof Qn)) {
          if (ct instanceof Wn) return ct;
          if (Sr.call(ct, "__wrapped__")) return Wp(ct);
        }
        return new Wn(ct);
      }
      function Mn() {
      }
      function Wn(ct, mt) {
        this.__wrapped__ = ct, this.__actions__ = [], this.__chain__ = !!mt, this.__index__ = 0, this.__values__ = Ht;
      }
      function Qn(ct) {
        this.__wrapped__ = ct, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = sr, this.__views__ = [];
      }
      function _i() {
        var ct = new Qn(this.__wrapped__);
        return ct.__actions__ = Li(this.__actions__), ct.__dir__ = this.__dir__, ct.__filtered__ = this.__filtered__, ct.__iteratees__ = Li(this.__iteratees__), ct.__takeCount__ = this.__takeCount__, ct.__views__ = Li(this.__views__), ct;
      }
      function Sf() {
        if (this.__filtered__) {
          var ct = new Qn(this);
          ct.__dir__ = -1, ct.__filtered__ = !0;
        } else ct = this.clone(), ct.__dir__ *= -1;
        return ct;
      }
      function zm() {
        var ct = this.__wrapped__.value(), mt = this.__dir__, Nt = er(ct), Vt = mt < 0, Kt = Nt ? ct.length : 0, nn = iE(0, Kt, this.__views__), sn = nn.start, fn = nn.end, Cn = fn - sn, Tn = Vt ? fn : sn - 1, wn = this.__iteratees__, On = wn.length, _n = 0, jn = Ii(Cn, this.__takeCount__);
        if (!Nt || !Vt && Kt == Cn && jn == Cn) return Ep(ct, this.__actions__);
        var Hn = [];
        e: for (; Cn-- && _n < jn; ) {
          Tn += mt;
          for (var tr = -1, Gn = ct[Tn]; ++tr < On; ) {
            var cr = wn[tr], ur = cr.iteratee, bi = cr.type, ji = ur(Gn);
            if (bi == Vr) Gn = ji;
            else if (!ji) {
              if (bi == hr) continue e;
              break e;
            }
          }
          Hn[_n++] = Gn;
        }
        return Hn;
      }
      function Ls(ct) {
        var mt = -1, Nt = ct == null ? 0 : ct.length;
        for (this.clear(); ++mt < Nt; ) {
          var Vt = ct[mt];
          this.set(Vt[0], Vt[1]);
        }
      }
      function Xm() {
        this.__data__ = Rl ? Rl(null) : {}, this.size = 0;
      }
      function Km(ct) {
        var mt = this.has(ct) && delete this.__data__[ct];
        return this.size -= mt ? 1 : 0, mt;
      }
      function Ym(ct) {
        var mt = this.__data__;
        if (Rl) {
          var Nt = mt[ct];
          return Nt === Jt ? Ht : Nt;
        }
        return Sr.call(mt, ct) ? mt[ct] : Ht;
      }
      function $m(ct) {
        var mt = this.__data__;
        return Rl ? mt[ct] !== Ht : Sr.call(mt, ct);
      }
      function Jm(ct, mt) {
        var Nt = this.__data__;
        return this.size += this.has(ct) ? 0 : 1, Nt[ct] = Rl && mt === Ht ? Jt : mt, this;
      }
      function ao(ct) {
        var mt = -1, Nt = ct == null ? 0 : ct.length;
        for (this.clear(); ++mt < Nt; ) {
          var Vt = ct[mt];
          this.set(Vt[0], Vt[1]);
        }
      }
      function Zm() {
        this.__data__ = [], this.size = 0;
      }
      function e3(ct) {
        var mt = this.__data__, Nt = Ld(mt, ct);
        return !(Nt < 0) && (Nt == mt.length - 1 ? mt.pop() : l2.call(mt, Nt, 1), --this.size, !0);
      }
      function t3(ct) {
        var mt = this.__data__, Nt = Ld(mt, ct);
        return Nt < 0 ? Ht : mt[Nt][1];
      }
      function n3(ct) {
        return Ld(this.__data__, ct) > -1;
      }
      function r3(ct, mt) {
        var Nt = this.__data__, Vt = Ld(Nt, ct);
        return Vt < 0 ? (++this.size, Nt.push([ct, mt])) : Nt[Vt][1] = mt, this;
      }
      function oo(ct) {
        var mt = -1, Nt = ct == null ? 0 : ct.length;
        for (this.clear(); ++mt < Nt; ) {
          var Vt = ct[mt];
          this.set(Vt[0], Vt[1]);
        }
      }
      function i3() {
        this.size = 0, this.__data__ = { hash: new Ls(), map: new (Tl || ao)(), string: new Ls() };
      }
      function a3(ct) {
        var mt = Xd(this, ct).delete(ct);
        return this.size -= mt ? 1 : 0, mt;
      }
      function o3(ct) {
        return Xd(this, ct).get(ct);
      }
      function s3(ct) {
        return Xd(this, ct).has(ct);
      }
      function c3(ct, mt) {
        var Nt = Xd(this, ct), Vt = Nt.size;
        return Nt.set(ct, mt), this.size += Nt.size == Vt ? 0 : 1, this;
      }
      function Ms(ct) {
        var mt = -1, Nt = ct == null ? 0 : ct.length;
        for (this.__data__ = new oo(); ++mt < Nt; ) this.add(ct[mt]);
      }
      function u3(ct) {
        return this.__data__.set(ct, Jt), this;
      }
      function l3(ct) {
        return this.__data__.has(ct);
      }
      function ma(ct) {
        this.size = (this.__data__ = new ao(ct)).size;
      }
      function d3() {
        this.__data__ = new ao(), this.size = 0;
      }
      function f3(ct) {
        var mt = this.__data__, Nt = mt.delete(ct);
        return this.size = mt.size, Nt;
      }
      function h3(ct) {
        return this.__data__.get(ct);
      }
      function p3(ct) {
        return this.__data__.has(ct);
      }
      function A3(ct, mt) {
        var Nt = this.__data__;
        if (Nt instanceof ao) {
          var Vt = Nt.__data__;
          if (!Tl || Vt.length < un - 1) return Vt.push([ct, mt]), this.size = ++Nt.size, this;
          Nt = this.__data__ = new oo(Vt);
        }
        return Nt.set(ct, mt), this.size = Nt.size, this;
      }
      function $1(ct, mt) {
        var Nt = er(ct), Vt = !Nt && Hs(ct), Kt = !Nt && !Vt && es(ct), nn = !Nt && !Vt && !Kt && lu(ct), sn = Nt || Vt || Kt || nn, fn = sn ? yt(ct.length, A4) : [], Cn = fn.length;
        for (var Tn in ct) !mt && !Sr.call(ct, Tn) || sn && (Tn == "length" || Kt && (Tn == "offset" || Tn == "parent") || nn && (Tn == "buffer" || Tn == "byteLength" || Tn == "byteOffset") || lo(Tn, Cn)) || fn.push(Tn);
        return fn;
      }
      function J1(ct) {
        var mt = ct.length;
        return mt ? ct[_f(0, mt - 1)] : Ht;
      }
      function g3(ct, mt) {
        return Kd(Li(ct), Qs(mt, 0, ct.length));
      }
      function m3(ct) {
        return Kd(Li(ct));
      }
      function wf(ct, mt, Nt) {
        (Nt === Ht || Ea(ct[mt], Nt)) && (Nt !== Ht || mt in ct) || so(ct, mt, Nt);
      }
      function El(ct, mt, Nt) {
        var Vt = ct[mt];
        Sr.call(ct, mt) && Ea(Vt, Nt) && (Nt !== Ht || mt in ct) || so(ct, mt, Nt);
      }
      function Ld(ct, mt) {
        for (var Nt = ct.length; Nt--; ) if (Ea(ct[Nt][0], mt)) return Nt;
        return -1;
      }
      function E3(ct, mt, Nt, Vt) {
        return Zo(ct, function(Kt, nn, sn) {
          mt(Vt, Kt, Nt(Kt), sn);
        }), Vt;
      }
      function Z1(ct, mt) {
        return ct && Pa(mt, si(mt), ct);
      }
      function C3(ct, mt) {
        return ct && Pa(mt, Qi(mt), ct);
      }
      function so(ct, mt, Nt) {
        mt == "__proto__" && d2 ? d2(ct, mt, { configurable: !0, enumerable: !0, value: Nt, writable: !0 }) : ct[mt] = Nt;
      }
      function Tf(ct, mt) {
        for (var Nt = -1, Vt = mt.length, Kt = Zr(Vt), nn = ct == null; ++Nt < Vt; ) Kt[Nt] = nn ? Ht : eh(ct, mt[Nt]);
        return Kt;
      }
      function Qs(ct, mt, Nt) {
        return ct === ct && (Nt !== Ht && (ct = ct <= Nt ? ct : Nt), mt !== Ht && (ct = ct >= mt ? ct : mt)), ct;
      }
      function ia(ct, mt, Nt, Vt, Kt, nn) {
        var sn, fn = mt & dn, Cn = mt & yn, Tn = mt & Nn;
        if (Nt && (sn = Kt ? Nt(ct, Vt, Kt, nn) : Nt(ct)), sn !== Ht) return sn;
        if (!Ur(ct)) return ct;
        var wn = er(ct);
        if (wn) {
          if (sn = oE(ct), !fn) return Li(ct, sn);
        } else {
          var On = xi(ct), _n = On == Wr || On == Or;
          if (es(ct)) return vp(ct, fn);
          if (On == vi || On == bn || _n && !Kt) {
            if (sn = Cn || _n ? {} : Qp(ct), !fn) return Cn ? Y3(ct, C3(sn, ct)) : K3(ct, Z1(sn, ct));
          } else {
            if (!_r[On]) return Kt ? ct : {};
            sn = sE(ct, On, fn);
          }
        }
        nn || (nn = new ma());
        var jn = nn.get(ct);
        if (jn) return jn;
        nn.set(ct, sn), _A(ct) ? ct.forEach(function(Gn) {
          sn.add(ia(Gn, mt, Nt, Gn, ct, nn));
        }) : kA(ct) && ct.forEach(function(Gn, cr) {
          sn.set(cr, ia(Gn, mt, Nt, cr, ct, nn));
        });
        var Hn = Tn ? Cn ? qf : Wf : Cn ? Qi : si, tr = wn ? Ht : Hn(ct);
        return He(tr || ct, function(Gn, cr) {
          tr && (cr = Gn, Gn = ct[cr]), El(sn, cr, ia(Gn, mt, Nt, cr, ct, nn));
        }), sn;
      }
      function y3(ct) {
        var mt = si(ct);
        return function(Nt) {
          return ep(Nt, ct, mt);
        };
      }
      function ep(ct, mt, Nt) {
        var Vt = Nt.length;
        if (ct == null) return !Vt;
        for (ct = jr(ct); Vt--; ) {
          var Kt = Nt[Vt], nn = mt[Kt], sn = ct[Kt];
          if (sn === Ht && !(Kt in ct) || !nn(sn)) return !1;
        }
        return !0;
      }
      function tp(ct, mt, Nt) {
        if (typeof ct != "function") throw new ua(mn);
        return Nl(function() {
          ct.apply(Ht, Nt);
        }, mt);
      }
      function Cl(ct, mt, Nt, Vt) {
        var Kt = -1, nn = $e, sn = !0, fn = ct.length, Cn = [], Tn = mt.length;
        if (!fn) return Cn;
        Nt && (mt = Ze(mt, It(Nt))), Vt ? (nn = Je, sn = !1) : mt.length >= un && (nn = Et, sn = !1, mt = new Ms(mt));
        e: for (; ++Kt < fn; ) {
          var wn = ct[Kt], On = Nt == null ? wn : Nt(wn);
          if (wn = Vt || wn !== 0 ? wn : 0, sn && On === On) {
            for (var _n = Tn; _n--; ) if (mt[_n] === On) continue e;
            Cn.push(wn);
          } else nn(mt, On, Vt) || Cn.push(wn);
        }
        return Cn;
      }
      function I3(ct, mt) {
        var Nt = !0;
        return Zo(ct, function(Vt, Kt, nn) {
          return Nt = !!mt(Vt, Kt, nn);
        }), Nt;
      }
      function Md(ct, mt, Nt) {
        for (var Vt = -1, Kt = ct.length; ++Vt < Kt; ) {
          var nn = ct[Vt], sn = mt(nn);
          if (sn != null && (fn === Ht ? sn === sn && !zi(sn) : Nt(sn, fn))) var fn = sn, Cn = nn;
        }
        return Cn;
      }
      function x3(ct, mt, Nt, Vt) {
        var Kt = ct.length;
        for (Nt = rr(Nt), Nt < 0 && (Nt = -Nt > Kt ? 0 : Kt + Nt), Vt = Vt === Ht || Vt > Kt ? Kt : rr(Vt), Vt < 0 && (Vt += Kt), Vt = Nt > Vt ? 0 : uA(Vt); Nt < Vt; ) ct[Nt++] = mt;
        return ct;
      }
      function np(ct, mt) {
        var Nt = [];
        return Zo(ct, function(Vt, Kt, nn) {
          mt(Vt, Kt, nn) && Nt.push(Vt);
        }), Nt;
      }
      function di(ct, mt, Nt, Vt, Kt) {
        var nn = -1, sn = ct.length;
        for (Nt || (Nt = uE), Kt || (Kt = []); ++nn < sn; ) {
          var fn = ct[nn];
          mt > 0 && Nt(fn) ? mt > 1 ? di(fn, mt - 1, Nt, Vt, Kt) : nt(Kt, fn) : Vt || (Kt[Kt.length] = fn);
        }
        return Kt;
      }
      function Da(ct, mt) {
        return ct && hh(ct, mt, si);
      }
      function Bf(ct, mt) {
        return ct && wA(ct, mt, si);
      }
      function Qd(ct, mt) {
        return Ke(mt, function(Nt) {
          return fo(ct[Nt]);
        });
      }
      function Fs(ct, mt) {
        mt = Yo(mt, ct);
        for (var Nt = 0, Vt = mt.length; ct != null && Nt < Vt; ) ct = ct[ka(mt[Nt++])];
        return Nt && Nt == Vt ? ct : Ht;
      }
      function rp(ct, mt, Nt) {
        var Vt = mt(ct);
        return er(ct) ? Vt : nt(Vt, Nt(ct));
      }
      function Ti(ct) {
        return ct == null ? ct === Ht ? cf : to : Us && Us in jr(ct) ? rE(ct) : AE(ct);
      }
      function Rf(ct, mt) {
        return ct > mt;
      }
      function b3(ct, mt) {
        return ct != null && Sr.call(ct, mt);
      }
      function S3(ct, mt) {
        return ct != null && mt in jr(ct);
      }
      function w3(ct, mt, Nt) {
        return ct >= Ii(mt, Nt) && ct < ei(mt, Nt);
      }
      function Of(ct, mt, Nt) {
        for (var Vt = Nt ? Je : $e, Kt = ct[0].length, nn = ct.length, sn = nn, fn = Zr(nn), Cn = 1 / 0, Tn = []; sn--; ) {
          var wn = ct[sn];
          sn && mt && (wn = Ze(wn, It(mt))), Cn = Ii(wn.length, Cn), fn[sn] = !Nt && (mt || Kt >= 120 && wn.length >= 120) ? new Ms(sn && wn) : Ht;
        }
        wn = ct[0];
        var On = -1, _n = fn[0];
        e: for (; ++On < Kt && Tn.length < Cn; ) {
          var jn = wn[On], Hn = mt ? mt(jn) : jn;
          if (jn = Nt || jn !== 0 ? jn : 0, !(_n ? Et(_n, Hn) : Vt(Tn, Hn, Nt))) {
            for (sn = nn; --sn; ) {
              var tr = fn[sn];
              if (!(tr ? Et(tr, Hn) : Vt(ct[sn], Hn, Nt))) continue e;
            }
            _n && _n.push(Hn), Tn.push(jn);
          }
        }
        return Tn;
      }
      function T3(ct, mt, Nt, Vt) {
        return Da(ct, function(Kt, nn, sn) {
          mt(Vt, Nt(Kt), nn, sn);
        }), Vt;
      }
      function vl(ct, mt, Nt) {
        mt = Yo(mt, ct), ct = Up(ct, mt);
        var Vt = ct == null ? ct : ct[ka(oa(mt))];
        return Vt == null ? Ht : Qe(Vt, ct, Nt);
      }
      function ip(ct) {
        return qr(ct) && Ti(ct) == bn;
      }
      function B3(ct) {
        return qr(ct) && Ti(ct) == Rs;
      }
      function R3(ct) {
        return qr(ct) && Ti(ct) == nr;
      }
      function yl(ct, mt, Nt, Vt, Kt) {
        return ct === mt || (ct == null || mt == null || !qr(ct) && !qr(mt) ? ct !== ct && mt !== mt : O3(ct, mt, Nt, Vt, yl, Kt));
      }
      function O3(ct, mt, Nt, Vt, Kt, nn) {
        var sn = er(ct), fn = er(mt), Cn = sn ? vn : xi(ct), Tn = fn ? vn : xi(mt);
        Cn = Cn == bn ? vi : Cn, Tn = Tn == bn ? vi : Tn;
        var wn = Cn == vi, On = Tn == vi, _n = Cn == Tn;
        if (_n && es(ct)) {
          if (!es(mt)) return !1;
          sn = !0, wn = !1;
        }
        if (_n && !wn) return nn || (nn = new ma()), sn || lu(ct) ? Lp(ct, mt, Nt, Vt, Kt, nn) : tE(ct, mt, Cn, Nt, Vt, Kt, nn);
        if (!(Nt & Rn)) {
          var jn = wn && Sr.call(ct, "__wrapped__"), Hn = On && Sr.call(mt, "__wrapped__");
          if (jn || Hn) {
            var tr = jn ? ct.value() : ct, Gn = Hn ? mt.value() : mt;
            return nn || (nn = new ma()), Kt(tr, Gn, Nt, Vt, nn);
          }
        }
        return !!_n && (nn || (nn = new ma()), nE(ct, mt, Nt, Vt, Kt, nn));
      }
      function N3(ct) {
        return qr(ct) && xi(ct) == pr;
      }
      function Nf(ct, mt, Nt, Vt) {
        var Kt = Nt.length, nn = Kt, sn = !Vt;
        if (ct == null) return !nn;
        for (ct = jr(ct); Kt--; ) {
          var fn = Nt[Kt];
          if (sn && fn[2] ? fn[1] !== ct[fn[0]] : !(fn[0] in ct)) return !1;
        }
        for (; ++Kt < nn; ) {
          fn = Nt[Kt];
          var Cn = fn[0], Tn = ct[Cn], wn = fn[1];
          if (sn && fn[2]) {
            if (Tn === Ht && !(Cn in ct)) return !1;
          } else {
            var On = new ma();
            if (Vt) var _n = Vt(Tn, wn, Cn, ct, mt, On);
            if (!(_n === Ht ? yl(wn, Tn, Rn | rn, Vt, On) : _n)) return !1;
          }
        }
        return !0;
      }
      function ap(ct) {
        return !(!Ur(ct) || dE(ct)) && (fo(ct) ? y4 : mf).test(Vs(ct));
      }
      function D3(ct) {
        return qr(ct) && Ti(ct) == Ts;
      }
      function P3(ct) {
        return qr(ct) && xi(ct) == Wi;
      }
      function k3(ct) {
        return qr(ct) && e2(ct.length) && !!Fr[Ti(ct)];
      }
      function op(ct) {
        return typeof ct == "function" ? ct : ct == null ? Fi : typeof ct == "object" ? er(ct) ? up(ct[0], ct[1]) : cp(ct) : AA(ct);
      }
      function Df(ct) {
        if (!bl(ct)) return T4(ct);
        var mt = [];
        for (var Nt in jr(ct)) Sr.call(ct, Nt) && Nt != "constructor" && mt.push(Nt);
        return mt;
      }
      function _3(ct) {
        if (!Ur(ct)) return pE(ct);
        var mt = bl(ct), Nt = [];
        for (var Vt in ct) (Vt != "constructor" || !mt && Sr.call(ct, Vt)) && Nt.push(Vt);
        return Nt;
      }
      function Pf(ct, mt) {
        return ct < mt;
      }
      function sp(ct, mt) {
        var Nt = -1, Vt = Mi(ct) ? Zr(ct.length) : [];
        return Zo(ct, function(Kt, nn, sn) {
          Vt[++Nt] = mt(Kt, nn, sn);
        }), Vt;
      }
      function cp(ct) {
        var mt = zf(ct);
        return mt.length == 1 && mt[0][2] ? jp(mt[0][0], mt[0][1]) : function(Nt) {
          return Nt === ct || Nf(Nt, ct, mt);
        };
      }
      function up(ct, mt) {
        return Xf(ct) && Fp(mt) ? jp(ka(ct), mt) : function(Nt) {
          var Vt = eh(Nt, ct);
          return Vt === Ht && Vt === mt ? th(Nt, ct) : yl(mt, Vt, Rn | rn);
        };
      }
      function Fd(ct, mt, Nt, Vt, Kt) {
        ct !== mt && hh(mt, function(nn, sn) {
          if (Kt || (Kt = new ma()), Ur(nn)) L3(ct, mt, sn, Nt, Fd, Vt, Kt);
          else {
            var fn = Vt ? Vt(Yf(ct, sn), nn, sn + "", ct, mt, Kt) : Ht;
            fn === Ht && (fn = nn), wf(ct, sn, fn);
          }
        }, Qi);
      }
      function L3(ct, mt, Nt, Vt, Kt, nn, sn) {
        var fn = Yf(ct, Nt), Cn = Yf(mt, Nt), Tn = sn.get(Cn);
        if (Tn) return wf(ct, Nt, Tn), Ht;
        var wn = nn ? nn(fn, Cn, Nt + "", ct, mt, sn) : Ht, On = wn === Ht;
        if (On) {
          var _n = er(Cn), jn = !_n && es(Cn), Hn = !_n && !jn && lu(Cn);
          wn = Cn, _n || jn || Hn ? er(fn) ? wn = fn : Kr(fn) ? wn = Li(fn) : jn ? (On = !1, wn = vp(Cn, !0)) : Hn ? (On = !1, wn = yp(Cn, !0)) : wn = [] : Sl(Cn) || Hs(Cn) ? (wn = fn, Hs(fn) ? wn = lA(fn) : Ur(fn) && !fo(fn) || (wn = Qp(Cn))) : On = !1;
        }
        On && (sn.set(Cn, wn), Kt(wn, Cn, Vt, nn, sn), sn.delete(Cn)), wf(ct, Nt, wn);
      }
      function lp(ct, mt) {
        var Nt = ct.length;
        if (Nt) return mt += mt < 0 ? Nt : 0, lo(mt, Nt) ? ct[mt] : Ht;
      }
      function dp(ct, mt, Nt) {
        mt = mt.length ? Ze(mt, function(Kt) {
          return er(Kt) ? function(nn) {
            return Fs(nn, Kt.length === 1 ? Kt[0] : Kt);
          } : Kt;
        }) : [Fi];
        var Vt = -1;
        return mt = Ze(mt, It(zn())), Bt(sp(ct, function(Kt, nn, sn) {
          return { criteria: Ze(mt, function(fn) {
            return fn(Kt);
          }), index: ++Vt, value: Kt };
        }), function(Kt, nn) {
          return X3(Kt, nn, Nt);
        });
      }
      function M3(ct, mt) {
        return hp(ct, mt, function(Nt, Vt) {
          return th(ct, Vt);
        });
      }
      function hp(ct, mt, Nt) {
        for (var Vt = -1, Kt = mt.length, nn = {}; ++Vt < Kt; ) {
          var sn = mt[Vt], fn = Fs(ct, sn);
          Nt(fn, sn) && Il(nn, Yo(sn, ct), fn);
        }
        return nn;
      }
      function Q3(ct) {
        return function(mt) {
          return Fs(mt, ct);
        };
      }
      function kf(ct, mt, Nt, Vt) {
        var Kt = Vt ? lt : ut, nn = -1, sn = mt.length, fn = ct;
        for (ct === mt && (mt = Li(mt)), Nt && (fn = Ze(ct, It(Nt))); ++nn < sn; ) for (var Cn = 0, Tn = mt[nn], wn = Nt ? Nt(Tn) : Tn; (Cn = Kt(fn, wn, Cn, Vt)) > -1; ) fn !== ct && l2.call(fn, Cn, 1), l2.call(ct, Cn, 1);
        return ct;
      }
      function pp(ct, mt) {
        for (var Nt = ct ? mt.length : 0, Vt = Nt - 1; Nt--; ) {
          var Kt = mt[Nt];
          if (Nt == Vt || Kt !== nn) {
            var nn = Kt;
            lo(Kt) ? l2.call(ct, Kt, 1) : Qf(ct, Kt);
          }
        }
        return ct;
      }
      function _f(ct, mt) {
        return ct + h2(xA() * (mt - ct + 1));
      }
      function F3(ct, mt, Nt, Vt) {
        for (var Kt = -1, nn = ei(f2((mt - ct) / (Nt || 1)), 0), sn = Zr(nn); nn--; ) sn[Vt ? nn : ++Kt] = ct, ct += Nt;
        return sn;
      }
      function Lf(ct, mt) {
        var Nt = "";
        if (!ct || mt < 1 || mt > xr) return Nt;
        do
          mt % 2 && (Nt += ct), mt = h2(mt / 2), mt && (ct += ct);
        while (mt);
        return Nt;
      }
      function ar(ct, mt) {
        return gh(Vp(ct, mt, Fi), ct + "");
      }
      function j3(ct) {
        return J1(iu(ct));
      }
      function U3(ct, mt) {
        var Nt = iu(ct);
        return Kd(Nt, Qs(mt, 0, Nt.length));
      }
      function Il(ct, mt, Nt, Vt) {
        if (!Ur(ct)) return ct;
        mt = Yo(mt, ct);
        for (var Kt = -1, nn = mt.length, sn = nn - 1, fn = ct; fn != null && ++Kt < nn; ) {
          var Cn = ka(mt[Kt]), Tn = Nt;
          if (Cn === "__proto__" || Cn === "constructor" || Cn === "prototype") return ct;
          if (Kt != sn) {
            var wn = fn[Cn];
            Tn = Vt ? Vt(wn, Cn, fn) : Ht, Tn === Ht && (Tn = Ur(wn) ? wn : lo(mt[Kt + 1]) ? [] : {});
          }
          El(fn, Cn, Tn), fn = fn[Cn];
        }
        return ct;
      }
      function H3(ct) {
        return Kd(iu(ct));
      }
      function aa(ct, mt, Nt) {
        var Vt = -1, Kt = ct.length;
        mt < 0 && (mt = -mt > Kt ? 0 : Kt + mt), Nt = Nt > Kt ? Kt : Nt, Nt < 0 && (Nt += Kt), Kt = mt > Nt ? 0 : Nt - mt >>> 0, mt >>>= 0;
        for (var nn = Zr(Kt); ++Vt < Kt; ) nn[Vt] = ct[Vt + mt];
        return nn;
      }
      function G3(ct, mt) {
        var Nt;
        return Zo(ct, function(Vt, Kt, nn) {
          return Nt = mt(Vt, Kt, nn), !Nt;
        }), !!Nt;
      }
      function jd(ct, mt, Nt) {
        var Vt = 0, Kt = ct == null ? Vt : ct.length;
        if (typeof mt == "number" && mt === mt && Kt <= Gr) {
          for (; Vt < Kt; ) {
            var nn = Vt + Kt >>> 1, sn = ct[nn];
            sn !== null && !zi(sn) && (Nt ? sn <= mt : sn < mt) ? Vt = nn + 1 : Kt = nn;
          }
          return Kt;
        }
        return Mf(ct, mt, Fi, Nt);
      }
      function Mf(ct, mt, Nt, Vt) {
        var Kt = 0, nn = ct == null ? 0 : ct.length;
        if (nn === 0) return 0;
        mt = Nt(mt);
        for (var sn = mt !== mt, fn = mt === null, Cn = zi(mt), Tn = mt === Ht; Kt < nn; ) {
          var wn = h2((Kt + nn) / 2), On = Nt(ct[wn]), _n = On !== Ht, jn = On === null, Hn = On === On, tr = zi(On);
          if (sn) var Gn = Vt || Hn;
          else Gn = Tn ? Hn && (Vt || _n) : fn ? Hn && _n && (Vt || !jn) : Cn ? Hn && _n && !jn && (Vt || !tr) : !jn && !tr && (Vt ? On <= mt : On < mt);
          Gn ? Kt = wn + 1 : nn = wn;
        }
        return Ii(nn, br);
      }
      function Ap(ct, mt) {
        for (var Nt = -1, Vt = ct.length, Kt = 0, nn = []; ++Nt < Vt; ) {
          var sn = ct[Nt], fn = mt ? mt(sn) : sn;
          if (!Nt || !Ea(fn, Cn)) {
            var Cn = fn;
            nn[Kt++] = sn === 0 ? 0 : sn;
          }
        }
        return nn;
      }
      function gp(ct) {
        return typeof ct == "number" ? ct : zi(ct) ? Rr : +ct;
      }
      function qi(ct) {
        if (typeof ct == "string") return ct;
        if (er(ct)) return Ze(ct, qi) + "";
        if (zi(ct)) return bA ? bA.call(ct) : "";
        var mt = ct + "";
        return mt == "0" && 1 / ct == -Er ? "-0" : mt;
      }
      function Ko(ct, mt, Nt) {
        var Vt = -1, Kt = $e, nn = ct.length, sn = !0, fn = [], Cn = fn;
        if (Nt) sn = !1, Kt = Je;
        else if (nn >= un) {
          var Tn = mt ? null : Q4(ct);
          if (Tn) return Ut(Tn);
          sn = !1, Kt = Et, Cn = new Ms();
        } else Cn = mt ? [] : fn;
        e: for (; ++Vt < nn; ) {
          var wn = ct[Vt], On = mt ? mt(wn) : wn;
          if (wn = Nt || wn !== 0 ? wn : 0, sn && On === On) {
            for (var _n = Cn.length; _n--; ) if (Cn[_n] === On) continue e;
            mt && Cn.push(On), fn.push(wn);
          } else Kt(Cn, On, Nt) || (Cn !== fn && Cn.push(On), fn.push(wn));
        }
        return fn;
      }
      function Qf(ct, mt) {
        return mt = Yo(mt, ct), ct = Up(ct, mt), ct == null || delete ct[ka(oa(mt))];
      }
      function mp(ct, mt, Nt, Vt) {
        return Il(ct, mt, Nt(Fs(ct, mt)), Vt);
      }
      function Vd(ct, mt, Nt, Vt) {
        for (var Kt = ct.length, nn = Vt ? Kt : -1; (Vt ? nn-- : ++nn < Kt) && mt(ct[nn], nn, ct); ) ;
        return Nt ? aa(ct, Vt ? 0 : nn, Vt ? nn + 1 : Kt) : aa(ct, Vt ? nn + 1 : 0, Vt ? Kt : nn);
      }
      function Ep(ct, mt) {
        var Nt = ct;
        return Nt instanceof Qn && (Nt = Nt.value()), tt(mt, function(Vt, Kt) {
          return Kt.func.apply(Kt.thisArg, nt([Vt], Kt.args));
        }, Nt);
      }
      function Ff(ct, mt, Nt) {
        var Vt = ct.length;
        if (Vt < 2) return Vt ? Ko(ct[0]) : [];
        for (var Kt = -1, nn = Zr(Vt); ++Kt < Vt; ) for (var sn = ct[Kt], fn = -1; ++fn < Vt; ) fn != Kt && (nn[Kt] = Cl(nn[Kt] || sn, ct[fn], mt, Nt));
        return Ko(di(nn, 1), mt, Nt);
      }
      function Cp(ct, mt, Nt) {
        for (var Vt = -1, Kt = ct.length, nn = mt.length, sn = {}; ++Vt < Kt; )
          Nt(sn, ct[Vt], Vt < nn ? mt[Vt] : Ht);
        return sn;
      }
      function jf(ct) {
        return Kr(ct) ? ct : [];
      }
      function Vf(ct) {
        return typeof ct == "function" ? ct : Fi;
      }
      function Yo(ct, mt) {
        return er(ct) ? ct : Xf(ct, mt) ? [ct] : NA(Ir(ct));
      }
      function $o(ct, mt, Nt) {
        var Vt = ct.length;
        return Nt = Nt === Ht ? Vt : Nt, !mt && Nt >= Vt ? ct : aa(ct, mt, Nt);
      }
      function vp(ct, mt) {
        if (mt) return ct.slice();
        var Nt = ct.length, Vt = EA ? EA(Nt) : new ct.constructor(Nt);
        return ct.copy(Vt), Vt;
      }
      function Uf(ct) {
        var mt = new ct.constructor(ct.byteLength);
        return new c2(mt).set(new c2(ct)), mt;
      }
      function W3(ct, mt) {
        return new ct.constructor(mt ? Uf(ct.buffer) : ct.buffer, ct.byteOffset, ct.byteLength);
      }
      function q3(ct) {
        var mt = new ct.constructor(ct.source, Yc.exec(ct));
        return mt.lastIndex = ct.lastIndex, mt;
      }
      function z3(ct) {
        return Ol ? jr(Ol.call(ct)) : {};
      }
      function yp(ct, mt) {
        return new ct.constructor(mt ? Uf(ct.buffer) : ct.buffer, ct.byteOffset, ct.length);
      }
      function Ip(ct, mt) {
        if (ct !== mt) {
          var Nt = ct !== Ht, Vt = ct === null, Kt = ct === ct, nn = zi(ct), sn = mt !== Ht, fn = mt === null, Cn = mt === mt, Tn = zi(mt);
          if (!fn && !Tn && !nn && ct > mt || nn && sn && Cn && !fn && !Tn || Vt && sn && Cn || !Nt && Cn || !Kt) return 1;
          if (!Vt && !nn && !Tn && ct < mt || Tn && Nt && Kt && !Vt && !nn || fn && Nt && Kt || !sn && Kt || !Cn) return -1;
        }
        return 0;
      }
      function X3(ct, mt, Nt) {
        for (var Vt = -1, Kt = ct.criteria, nn = mt.criteria, sn = Kt.length, fn = Nt.length; ++Vt < sn; ) {
          var Cn = Ip(Kt[Vt], nn[Vt]);
          if (Cn)
            return Vt >= fn ? Cn : Cn * (Nt[Vt] == "desc" ? -1 : 1);
        }
        return ct.index - mt.index;
      }
      function xp(ct, mt, Nt, Vt) {
        for (var Kt = -1, nn = ct.length, sn = Nt.length, fn = -1, Cn = mt.length, Tn = ei(nn - sn, 0), wn = Zr(Cn + Tn), On = !Vt; ++fn < Cn; ) wn[fn] = mt[fn];
        for (; ++Kt < sn; ) (On || Kt < nn) && (wn[Nt[Kt]] = ct[Kt]);
        for (; Tn--; ) wn[fn++] = ct[Kt++];
        return wn;
      }
      function bp(ct, mt, Nt, Vt) {
        for (var Kt = -1, nn = ct.length, sn = -1, fn = Nt.length, Cn = -1, Tn = mt.length, wn = ei(nn - fn, 0), On = Zr(wn + Tn), _n = !Vt; ++Kt < wn; ) On[Kt] = ct[Kt];
        for (var jn = Kt; ++Cn < Tn; ) On[jn + Cn] = mt[Cn];
        for (; ++sn < fn; ) (_n || Kt < nn) && (On[jn + Nt[sn]] = ct[Kt++]);
        return On;
      }
      function Li(ct, mt) {
        var Nt = -1, Vt = ct.length;
        for (mt || (mt = Zr(Vt)); ++Nt < Vt; ) mt[Nt] = ct[Nt];
        return mt;
      }
      function Pa(ct, mt, Nt, Vt) {
        var Kt = !Nt;
        Nt || (Nt = {});
        for (var nn = -1, sn = mt.length; ++nn < sn; ) {
          var fn = mt[nn], Cn = Vt ? Vt(Nt[fn], ct[fn], fn, Nt, ct) : Ht;
          Cn === Ht && (Cn = ct[fn]), Kt ? so(Nt, fn, Cn) : El(Nt, fn, Cn);
        }
        return Nt;
      }
      function K3(ct, mt) {
        return Pa(ct, Ah(ct), mt);
      }
      function Y3(ct, mt) {
        return Pa(ct, RA(ct), mt);
      }
      function Ud(ct, mt) {
        return function(Nt, Vt) {
          var Kt = er(Nt) ? Ue : E3, nn = mt ? mt() : {};
          return Kt(Nt, ct, zn(Vt, 2), nn);
        };
      }
      function tu(ct) {
        return ar(function(mt, Nt) {
          var Vt = -1, Kt = Nt.length, nn = Kt > 1 ? Nt[Kt - 1] : Ht, sn = Kt > 2 ? Nt[2] : Ht;
          for (nn = ct.length > 3 && typeof nn == "function" ? (Kt--, nn) : Ht, sn && Bi(Nt[0], Nt[1], sn) && (nn = Kt < 3 ? Ht : nn, Kt = 1), mt = jr(mt); ++Vt < Kt; ) {
            var fn = Nt[Vt];
            fn && ct(mt, fn, Vt, nn);
          }
          return mt;
        });
      }
      function Sp(ct, mt) {
        return function(Nt, Vt) {
          if (Nt == null) return Nt;
          if (!Mi(Nt)) return ct(Nt, Vt);
          for (var Kt = Nt.length, nn = mt ? Kt : -1, sn = jr(Nt); (mt ? nn-- : ++nn < Kt) && Vt(sn[nn], nn, sn) !== !1; ) ;
          return Nt;
        };
      }
      function wp(ct) {
        return function(mt, Nt, Vt) {
          for (var Kt = -1, nn = jr(mt), sn = Vt(mt), fn = sn.length; fn--; ) {
            var Cn = sn[ct ? fn : ++Kt];
            if (Nt(nn[Cn], Cn, nn) === !1) break;
          }
          return mt;
        };
      }
      function $3(ct, mt, Nt) {
        function Vt() {
          return (this && this !== li && this instanceof Vt ? nn : ct).apply(Kt ? Nt : this, arguments);
        }
        var Kt = mt & ln, nn = xl(ct);
        return Vt;
      }
      function Tp(ct) {
        return function(mt) {
          mt = Ir(mt);
          var Nt = Pt(mt) ? Mt(mt) : Ht, Vt = Nt ? Nt[0] : mt.charAt(0), Kt = Nt ? $o(Nt, 1).join("") : mt.slice(1);
          return Vt[ct]() + Kt;
        };
      }
      function nu(ct) {
        return function(mt) {
          return tt(pA(hA(mt).replace(Bm, "")), ct, "");
        };
      }
      function xl(ct) {
        return function() {
          var mt = arguments;
          switch (mt.length) {
            case 0:
              return new ct();
            case 1:
              return new ct(mt[0]);
            case 2:
              return new ct(mt[0], mt[1]);
            case 3:
              return new ct(mt[0], mt[1], mt[2]);
            case 4:
              return new ct(mt[0], mt[1], mt[2], mt[3]);
            case 5:
              return new ct(mt[0], mt[1], mt[2], mt[3], mt[4]);
            case 6:
              return new ct(mt[0], mt[1], mt[2], mt[3], mt[4], mt[5]);
            case 7:
              return new ct(mt[0], mt[1], mt[2], mt[3], mt[4], mt[5], mt[6]);
          }
          var Nt = uu(ct.prototype), Vt = ct.apply(Nt, mt);
          return Ur(Vt) ? Vt : Nt;
        };
      }
      function J3(ct, mt, Nt) {
        function Vt() {
          for (var nn = arguments.length, sn = Zr(nn), fn = nn, Cn = ru(Vt); fn--; ) sn[fn] = arguments[fn];
          var Tn = nn < 3 && sn[0] !== Cn && sn[nn - 1] !== Cn ? [] : Xt(sn, Cn);
          return nn -= Tn.length, nn < Nt ? Dp(ct, mt, Hd, Vt.placeholder, Ht, sn, Tn, Ht, Ht, Nt - nn) : Qe(this && this !== li && this instanceof Vt ? Kt : ct, this, sn);
        }
        var Kt = xl(ct);
        return Vt;
      }
      function Bp(ct) {
        return function(mt, Nt, Vt) {
          var Kt = jr(mt);
          if (!Mi(mt)) {
            var nn = zn(Nt, 3);
            mt = si(mt), Nt = function(fn) {
              return nn(Kt[fn], fn, Kt);
            };
          }
          var sn = ct(mt, Nt, Vt);
          return sn > -1 ? Kt[nn ? mt[sn] : sn] : Ht;
        };
      }
      function Rp(ct) {
        return uo(function(mt) {
          var Nt = mt.length, Vt = Nt, Kt = Wn.prototype.thru;
          for (ct && mt.reverse(); Vt--; ) {
            var nn = mt[Vt];
            if (typeof nn != "function") throw new ua(mn);
            if (Kt && !sn && zd(nn) == "wrapper") var sn = new Wn([], !0);
          }
          for (Vt = sn ? Vt : Nt; ++Vt < Nt; ) {
            nn = mt[Vt];
            var fn = zd(nn), Cn = fn == "wrapper" ? ph(nn) : Ht;
            sn = Cn && Kf(Cn[0]) && Cn[1] == (or | In | Pn | mr) && !Cn[4].length && Cn[9] == 1 ? sn[zd(Cn[0])].apply(sn, Cn[3]) : nn.length == 1 && Kf(nn) ? sn[fn]() : sn.thru(nn);
          }
          return function() {
            var Tn = arguments, wn = Tn[0];
            if (sn && Tn.length == 1 && er(wn)) return sn.plant(wn).value();
            for (var On = 0, _n = Nt ? mt[On].apply(this, Tn) : wn; ++On < Nt; ) _n = mt[On].call(this, _n);
            return _n;
          };
        });
      }
      function Hd(ct, mt, Nt, Vt, Kt, nn, sn, fn, Cn, Tn) {
        function wn() {
          for (var cr = arguments.length, ur = Zr(cr), bi = cr; bi--; ) ur[bi] = arguments[bi];
          if (Hn) var ji = ru(wn), ts = St(ur, ji);
          if (Vt && (ur = xp(ur, Vt, Kt, Hn)), nn && (ur = bp(ur, nn, sn, Hn)), cr -= ts, Hn && cr < Tn)
            return Dp(ct, mt, Hd, wn.placeholder, Nt, ur, Xt(ur, ji), fn, Cn, Tn - cr);
          var zr = _n ? Nt : this, la = jn ? zr[ct] : ct;
          return cr = ur.length, fn ? ur = gE(ur, fn) : tr && cr > 1 && ur.reverse(), On && Cn < cr && (ur.length = Cn), this && this !== li && this instanceof wn && (la = Gn || xl(la)), la.apply(zr, ur);
        }
        var On = mt & or, _n = mt & ln, jn = mt & pn, Hn = mt & (In | Bn), tr = mt & lr, Gn = jn ? Ht : xl(ct);
        return wn;
      }
      function Op(ct, mt) {
        return function(Nt, Vt) {
          return T3(Nt, ct, mt(Vt), {});
        };
      }
      function Gd(ct, mt) {
        return function(Nt, Vt) {
          var Kt;
          if (Nt === Ht && Vt === Ht) return mt;
          if (Nt !== Ht && (Kt = Nt), Vt !== Ht) {
            if (Kt === Ht) return Vt;
            typeof Nt == "string" || typeof Vt == "string" ? (Nt = qi(Nt), Vt = qi(Vt)) : (Nt = gp(Nt), Vt = gp(Vt)), Kt = ct(Nt, Vt);
          }
          return Kt;
        };
      }
      function Hf(ct) {
        return uo(function(mt) {
          return mt = Ze(mt, It(zn())), ar(function(Nt) {
            var Vt = this;
            return ct(mt, function(Kt) {
              return Qe(Kt, Vt, Nt);
            });
          });
        });
      }
      function Wd(ct, mt) {
        mt = mt === Ht ? " " : qi(mt);
        var Nt = mt.length;
        if (Nt < 2) return Nt ? Lf(mt, ct) : mt;
        var Vt = Lf(mt, f2(ct / Dt(mt)));
        return Pt(mt) ? $o(Mt(Vt), 0, ct).join("") : Vt.slice(0, ct);
      }
      function Z3(ct, mt, Nt, Vt) {
        function Kt() {
          for (var fn = -1, Cn = arguments.length, Tn = -1, wn = Vt.length, On = Zr(wn + Cn), _n = this && this !== li && this instanceof Kt ? sn : ct; ++Tn < wn; ) On[Tn] = Vt[Tn];
          for (; Cn--; ) On[Tn++] = arguments[++fn];
          return Qe(_n, nn ? Nt : this, On);
        }
        var nn = mt & ln, sn = xl(ct);
        return Kt;
      }
      function Np(ct) {
        return function(mt, Nt, Vt) {
          return Vt && typeof Vt != "number" && Bi(mt, Nt, Vt) && (Nt = Vt = Ht), mt = ho(mt), Nt === Ht ? (Nt = mt, mt = 0) : Nt = ho(Nt), Vt = Vt === Ht ? mt < Nt ? 1 : -1 : ho(Vt), F3(mt, Nt, Vt, ct);
        };
      }
      function qd(ct) {
        return function(mt, Nt) {
          return typeof mt == "string" && typeof Nt == "string" || (mt = sa(mt), Nt = sa(Nt)), ct(mt, Nt);
        };
      }
      function Dp(ct, mt, Nt, Vt, Kt, nn, sn, fn, Cn, Tn) {
        var wn = mt & In, On = wn ? sn : Ht, _n = wn ? Ht : sn, jn = wn ? nn : Ht, Hn = wn ? Ht : nn;
        mt |= wn ? Pn : Yn, mt &= ~(wn ? Yn : Pn), mt & Sn || (mt &= ~(ln | pn));
        var tr = [ct, mt, Kt, jn, On, Hn, _n, fn, Cn, Tn], Gn = Nt.apply(Ht, tr);
        return Kf(ct) && OA(Gn, tr), Gn.placeholder = Vt, Hp(Gn, ct, mt);
      }
      function Gf(ct) {
        var mt = au[ct];
        return function(Nt, Vt) {
          if (Nt = sa(Nt), Vt = Vt == null ? 0 : Ii(rr(Vt), 292), Vt && IA(Nt)) {
            var Kt = (Ir(Nt) + "e").split("e");
            return Kt = (Ir(mt(Kt[0] + "e" + (+Kt[1] + Vt))) + "e").split("e"), +(Kt[0] + "e" + (+Kt[1] - Vt));
          }
          return mt(Nt);
        };
      }
      function Pp(ct) {
        return function(mt) {
          var Nt = xi(mt);
          return Nt == pr ? _t(mt) : Nt == Wi ? Lt(mt) : Ct(mt, ct(mt));
        };
      }
      function co(ct, mt, Nt, Vt, Kt, nn, sn, fn) {
        var Cn = mt & pn;
        if (!Cn && typeof ct != "function") throw new ua(mn);
        var Tn = Vt ? Vt.length : 0;
        if (Tn || (mt &= ~(Pn | Yn), Vt = Kt = Ht), sn = sn === Ht ? sn : ei(rr(sn), 0), fn = fn === Ht ? fn : rr(fn), Tn -= Kt ? Kt.length : 0, mt & Yn) {
          var wn = Vt, On = Kt;
          Vt = Kt = Ht;
        }
        var _n = Cn ? Ht : ph(ct), jn = [ct, mt, Nt, Vt, Kt, wn, On, nn, sn, fn];
        if (_n && hE(jn, _n), ct = jn[0], mt = jn[1], Nt = jn[2], Vt = jn[3], Kt = jn[4], fn = jn[9] = jn[9] === Ht ? Cn ? 0 : ct.length : ei(jn[9] - Tn, 0), !fn && mt & (In | Bn) && (mt &= ~(In | Bn)), mt && mt != ln) Hn = mt == In || mt == Bn ? J3(ct, mt, fn) : mt != Pn && mt != (ln | Pn) || Kt.length ? Hd.apply(Ht, jn) : Z3(ct, mt, Nt, Vt);
        else var Hn = $3(ct, mt, Nt);
        return Hp((_n ? TA : OA)(Hn, jn), ct, mt);
      }
      function kp(ct, mt, Nt, Vt) {
        return ct === Ht || Ea(ct, ou[Nt]) && !Sr.call(Vt, Nt) ? mt : ct;
      }
      function _p(ct, mt, Nt, Vt, Kt, nn) {
        return Ur(ct) && Ur(mt) && (nn.set(mt, ct), Fd(ct, mt, Ht, _p, nn), nn.delete(mt)), ct;
      }
      function eE(ct) {
        return Sl(ct) ? Ht : ct;
      }
      function Lp(ct, mt, Nt, Vt, Kt, nn) {
        var sn = Nt & Rn, fn = ct.length, Cn = mt.length;
        if (fn != Cn && !(sn && Cn > fn)) return !1;
        var Tn = nn.get(ct), wn = nn.get(mt);
        if (Tn && wn) return Tn == mt && wn == ct;
        var On = -1, _n = !0, jn = Nt & rn ? new Ms() : Ht;
        for (nn.set(ct, mt), nn.set(mt, ct); ++On < fn; ) {
          var Hn = ct[On], tr = mt[On];
          if (Vt) var Gn = sn ? Vt(tr, Hn, On, mt, ct, nn) : Vt(Hn, tr, On, ct, mt, nn);
          if (Gn !== Ht) {
            if (Gn) continue;
            _n = !1;
            break;
          }
          if (jn) {
            if (!rt(mt, function(cr, ur) {
              if (!Et(jn, ur) && (Hn === cr || Kt(Hn, cr, Nt, Vt, nn))) return jn.push(ur);
            })) {
              _n = !1;
              break;
            }
          } else if (Hn !== tr && !Kt(Hn, tr, Nt, Vt, nn)) {
            _n = !1;
            break;
          }
        }
        return nn.delete(ct), nn.delete(mt), _n;
      }
      function tE(ct, mt, Nt, Vt, Kt, nn, sn) {
        switch (Nt) {
          case Na:
            if (ct.byteLength != mt.byteLength || ct.byteOffset != mt.byteOffset) return !1;
            ct = ct.buffer, mt = mt.buffer;
          case Rs:
            return !(ct.byteLength != mt.byteLength || !nn(new c2(ct), new c2(mt)));
          case Jn:
          case nr:
          case yr:
            return Ea(+ct, +mt);
          case Zn:
            return ct.name == mt.name && ct.message == mt.message;
          case Ts:
          case no:
            return ct == mt + "";
          case pr:
            var fn = _t;
          case Wi:
            var Cn = Vt & Rn;
            if (fn || (fn = Ut), ct.size != mt.size && !Cn) return !1;
            var Tn = sn.get(ct);
            if (Tn) return Tn == mt;
            Vt |= rn, sn.set(ct, mt);
            var wn = Lp(fn(ct), fn(mt), Vt, Kt, nn, sn);
            return sn.delete(ct), wn;
          case zc:
            if (Ol) return Ol.call(ct) == Ol.call(mt);
        }
        return !1;
      }
      function nE(ct, mt, Nt, Vt, Kt, nn) {
        var sn = Nt & Rn, fn = Wf(ct), Cn = fn.length;
        if (Cn != Wf(mt).length && !sn) return !1;
        for (var Tn = Cn; Tn--; ) {
          var wn = fn[Tn];
          if (!(sn ? wn in mt : Sr.call(mt, wn))) return !1;
        }
        var On = nn.get(ct), _n = nn.get(mt);
        if (On && _n) return On == mt && _n == ct;
        var jn = !0;
        nn.set(ct, mt), nn.set(mt, ct);
        for (var Hn = sn; ++Tn < Cn; ) {
          wn = fn[Tn];
          var tr = ct[wn], Gn = mt[wn];
          if (Vt) var cr = sn ? Vt(Gn, tr, wn, mt, ct, nn) : Vt(tr, Gn, wn, ct, mt, nn);
          if (!(cr === Ht ? tr === Gn || Kt(tr, Gn, Nt, Vt, nn) : cr)) {
            jn = !1;
            break;
          }
          Hn || (Hn = wn == "constructor");
        }
        if (jn && !Hn) {
          var ur = ct.constructor, bi = mt.constructor;
          ur != bi && "constructor" in ct && "constructor" in mt && !(typeof ur == "function" && ur instanceof ur && typeof bi == "function" && bi instanceof bi) && (jn = !1);
        }
        return nn.delete(ct), nn.delete(mt), jn;
      }
      function uo(ct) {
        return gh(Vp(ct, Ht, Xp), ct + "");
      }
      function Wf(ct) {
        return rp(ct, si, Ah);
      }
      function qf(ct) {
        return rp(ct, Qi, RA);
      }
      function zd(ct) {
        for (var mt = ct.name + "", Nt = cu[mt], Vt = Sr.call(cu, mt) ? Nt.length : 0; Vt--; ) {
          var Kt = Nt[Vt], nn = Kt.func;
          if (nn == null || nn == ct) return Kt.name;
        }
        return mt;
      }
      function ru(ct) {
        return (Sr.call(Wt, "placeholder") ? Wt : ct).placeholder;
      }
      function zn() {
        var ct = Wt.iteratee || rh;
        return ct = ct === rh ? op : ct, arguments.length ? ct(arguments[0], arguments[1]) : ct;
      }
      function Xd(ct, mt) {
        var Nt = ct.__data__;
        return lE(mt) ? Nt[typeof mt == "string" ? "string" : "hash"] : Nt.map;
      }
      function zf(ct) {
        for (var mt = si(ct), Nt = mt.length; Nt--; ) {
          var Vt = mt[Nt], Kt = ct[Vt];
          mt[Nt] = [Vt, Kt, Fp(Kt)];
        }
        return mt;
      }
      function js(ct, mt) {
        var Nt = jt(ct, mt);
        return ap(Nt) ? Nt : Ht;
      }
      function rE(ct) {
        var mt = Sr.call(ct, Us), Nt = ct[Us];
        try {
          ct[Us] = Ht;
          var Vt = !0;
        } catch {
        }
        var Kt = o2.call(ct);
        return Vt && (mt ? ct[Us] = Nt : delete ct[Us]), Kt;
      }
      function iE(ct, mt, Nt) {
        for (var Vt = -1, Kt = Nt.length; ++Vt < Kt; ) {
          var nn = Nt[Vt], sn = nn.size;
          switch (nn.type) {
            case "drop":
              ct += sn;
              break;
            case "dropRight":
              mt -= sn;
              break;
            case "take":
              mt = Ii(mt, ct + sn);
              break;
            case "takeRight":
              ct = ei(ct, mt - sn);
          }
        }
        return { start: ct, end: mt };
      }
      function aE(ct) {
        var mt = ct.match(oi);
        return mt ? mt[1].split(Xo) : [];
      }
      function Mp(ct, mt, Nt) {
        mt = Yo(mt, ct);
        for (var Vt = -1, Kt = mt.length, nn = !1; ++Vt < Kt; ) {
          var sn = ka(mt[Vt]);
          if (!(nn = ct != null && Nt(ct, sn))) break;
          ct = ct[sn];
        }
        return nn || ++Vt != Kt ? nn : (Kt = ct == null ? 0 : ct.length, !!Kt && e2(Kt) && lo(sn, Kt) && (er(ct) || Hs(ct)));
      }
      function oE(ct) {
        var mt = ct.length, Nt = new ct.constructor(mt);
        return mt && typeof ct[0] == "string" && Sr.call(ct, "index") && (Nt.index = ct.index, Nt.input = ct.input), Nt;
      }
      function Qp(ct) {
        return typeof ct.constructor != "function" || bl(ct) ? {} : uu(u2(ct));
      }
      function sE(ct, mt, Nt) {
        var Vt = ct.constructor;
        switch (mt) {
          case Rs:
            return Uf(ct);
          case Jn:
          case nr:
            return new Vt(+ct);
          case Na:
            return W3(ct, Nt);
          case Xc:
          case dl:
          case Os:
          case fl:
          case hl:
          case Kc:
          case Ns:
          case qo:
          case pl:
            return yp(ct, Nt);
          case pr:
            return new Vt();
          case yr:
          case no:
            return new Vt(ct);
          case Ts:
            return q3(ct);
          case Wi:
            return new Vt();
          case zc:
            return z3(ct);
        }
      }
      function cE(ct, mt) {
        var Nt = mt.length;
        if (!Nt) return ct;
        var Vt = Nt - 1;
        return mt[Vt] = (Nt > 1 ? "& " : "") + mt[Vt], mt = mt.join(Nt > 2 ? ", " : " "), ct.replace(zo, `{
/* [wrapped with ` + mt + `] */
`);
      }
      function uE(ct) {
        return er(ct) || Hs(ct) || !!(yA && ct && ct[yA]);
      }
      function lo(ct, mt) {
        var Nt = typeof ct;
        return mt = mt ?? xr, !!mt && (Nt == "number" || Nt != "symbol" && $c.test(ct)) && ct > -1 && ct % 1 == 0 && ct < mt;
      }
      function Bi(ct, mt, Nt) {
        if (!Ur(Nt)) return !1;
        var Vt = typeof mt;
        return !!(Vt == "number" ? Mi(Nt) && lo(mt, Nt.length) : Vt == "string" && mt in Nt) && Ea(Nt[mt], ct);
      }
      function Xf(ct, mt) {
        if (er(ct)) return !1;
        var Nt = typeof ct;
        return !(Nt != "number" && Nt != "symbol" && Nt != "boolean" && ct != null && !zi(ct)) || ks.test(ct) || !gl.test(ct) || mt != null && ct in jr(mt);
      }
      function lE(ct) {
        var mt = typeof ct;
        return mt == "string" || mt == "number" || mt == "symbol" || mt == "boolean" ? ct !== "__proto__" : ct === null;
      }
      function Kf(ct) {
        var mt = zd(ct), Nt = Wt[mt];
        if (typeof Nt != "function" || !(mt in Qn.prototype)) return !1;
        if (ct === Nt) return !0;
        var Vt = ph(Nt);
        return !!Vt && ct === Vt[0];
      }
      function dE(ct) {
        return !!mA && mA in ct;
      }
      function bl(ct) {
        var mt = ct && ct.constructor;
        return ct === (typeof mt == "function" && mt.prototype || ou);
      }
      function Fp(ct) {
        return ct === ct && !Ur(ct);
      }
      function jp(ct, mt) {
        return function(Nt) {
          return Nt != null && Nt[ct] === mt && (mt !== Ht || ct in jr(Nt));
        };
      }
      function fE(ct) {
        var mt = Jd(ct, function(Vt) {
          return Nt.size === an && Nt.clear(), Vt;
        }), Nt = mt.cache;
        return mt;
      }
      function hE(ct, mt) {
        var Nt = ct[1], Vt = mt[1], Kt = Nt | Vt, nn = Kt < (ln | pn | or), sn = Vt == or && Nt == In || Vt == or && Nt == mr && ct[7].length <= mt[8] || Vt == (or | mr) && mt[7].length <= mt[8] && Nt == In;
        if (!nn && !sn) return ct;
        Vt & ln && (ct[2] = mt[2], Kt |= Nt & ln ? 0 : Sn);
        var fn = mt[3];
        if (fn) {
          var Cn = ct[3];
          ct[3] = Cn ? xp(Cn, fn, mt[4]) : fn, ct[4] = Cn ? Xt(ct[3], cn) : mt[4];
        }
        return fn = mt[5], fn && (Cn = ct[5], ct[5] = Cn ? bp(Cn, fn, mt[6]) : fn, ct[6] = Cn ? Xt(ct[5], cn) : mt[6]), fn = mt[7], fn && (ct[7] = fn), Vt & or && (ct[8] = ct[8] == null ? mt[8] : Ii(ct[8], mt[8])), ct[9] == null && (ct[9] = mt[9]), ct[0] = mt[0], ct[1] = Kt, ct;
      }
      function pE(ct) {
        var mt = [];
        if (ct != null) for (var Nt in jr(ct)) mt.push(Nt);
        return mt;
      }
      function AE(ct) {
        return o2.call(ct);
      }
      function Vp(ct, mt, Nt) {
        return mt = ei(mt === Ht ? ct.length - 1 : mt, 0), function() {
          for (var Vt = arguments, Kt = -1, nn = ei(Vt.length - mt, 0), sn = Zr(nn); ++Kt < nn; ) sn[Kt] = Vt[mt + Kt];
          Kt = -1;
          for (var fn = Zr(mt + 1); ++Kt < mt; ) fn[Kt] = Vt[Kt];
          return fn[mt] = Nt(sn), Qe(ct, this, fn);
        };
      }
      function Up(ct, mt) {
        return mt.length < 2 ? ct : Fs(ct, aa(mt, 0, -1));
      }
      function gE(ct, mt) {
        for (var Nt = ct.length, Vt = Ii(mt.length, Nt), Kt = Li(ct); Vt--; ) {
          var nn = mt[Vt];
          ct[Vt] = lo(nn, Nt) ? Kt[nn] : Ht;
        }
        return ct;
      }
      function Yf(ct, mt) {
        if ((mt !== "constructor" || typeof ct[mt] != "function") && mt != "__proto__") return ct[mt];
      }
      function Hp(ct, mt, Nt) {
        var Vt = mt + "";
        return gh(ct, cE(Vt, mE(aE(Vt), Nt)));
      }
      function Gp(ct) {
        var mt = 0, Nt = 0;
        return function() {
          var Vt = B4(), Kt = qn - (Vt - Nt);
          if (Nt = Vt, Kt > 0) {
            if (++mt >= Un) return arguments[0];
          } else mt = 0;
          return ct.apply(Ht, arguments);
        };
      }
      function Kd(ct, mt) {
        var Nt = -1, Vt = ct.length, Kt = Vt - 1;
        for (mt = mt === Ht ? Vt : mt; ++Nt < mt; ) {
          var nn = _f(Nt, Kt), sn = ct[nn];
          ct[nn] = ct[Nt], ct[Nt] = sn;
        }
        return ct.length = mt, ct;
      }
      function ka(ct) {
        if (typeof ct == "string" || zi(ct)) return ct;
        var mt = ct + "";
        return mt == "0" && 1 / ct == -Er ? "-0" : mt;
      }
      function Vs(ct) {
        if (ct != null) {
          try {
            return a2.call(ct);
          } catch {
          }
          try {
            return ct + "";
          } catch {
          }
        }
        return "";
      }
      function mE(ct, mt) {
        return He(on, function(Nt) {
          var Vt = "_." + Nt[0];
          mt & Nt[1] && !$e(ct, Vt) && ct.push(Vt);
        }), ct.sort();
      }
      function Wp(ct) {
        if (ct instanceof Qn) return ct.clone();
        var mt = new Wn(ct.__wrapped__, ct.__chain__);
        return mt.__actions__ = Li(ct.__actions__), mt.__index__ = ct.__index__, mt.__values__ = ct.__values__, mt;
      }
      function CE(ct, mt, Nt) {
        mt = (Nt ? Bi(ct, mt, Nt) : mt === Ht) ? 1 : ei(rr(mt), 0);
        var Vt = ct == null ? 0 : ct.length;
        if (!Vt || mt < 1) return [];
        for (var Kt = 0, nn = 0, sn = Zr(f2(Vt / mt)); Kt < Vt; ) sn[nn++] = aa(ct, Kt, Kt += mt);
        return sn;
      }
      function vE(ct) {
        for (var mt = -1, Nt = ct == null ? 0 : ct.length, Vt = 0, Kt = []; ++mt < Nt; ) {
          var nn = ct[mt];
          nn && (Kt[Vt++] = nn);
        }
        return Kt;
      }
      function yE() {
        var ct = arguments.length;
        if (!ct) return [];
        for (var mt = Zr(ct - 1), Nt = arguments[0], Vt = ct; Vt--; ) mt[Vt - 1] = arguments[Vt];
        return nt(er(Nt) ? Li(Nt) : [Nt], di(mt, 1));
      }
      function IE(ct, mt, Nt) {
        var Vt = ct == null ? 0 : ct.length;
        return Vt ? (mt = Nt || mt === Ht ? 1 : rr(mt), aa(ct, mt < 0 ? 0 : mt, Vt)) : [];
      }
      function xE(ct, mt, Nt) {
        var Vt = ct == null ? 0 : ct.length;
        return Vt ? (mt = Nt || mt === Ht ? 1 : rr(mt), mt = Vt - mt, aa(ct, 0, mt < 0 ? 0 : mt)) : [];
      }
      function bE(ct, mt) {
        return ct && ct.length ? Vd(ct, zn(mt, 3), !0, !0) : [];
      }
      function SE(ct, mt) {
        return ct && ct.length ? Vd(ct, zn(mt, 3), !0) : [];
      }
      function wE(ct, mt, Nt, Vt) {
        var Kt = ct == null ? 0 : ct.length;
        return Kt ? (Nt && typeof Nt != "number" && Bi(ct, mt, Nt) && (Nt = 0, Vt = Kt), x3(ct, mt, Nt, Vt)) : [];
      }
      function qp(ct, mt, Nt) {
        var Vt = ct == null ? 0 : ct.length;
        if (!Vt) return -1;
        var Kt = Nt == null ? 0 : rr(Nt);
        return Kt < 0 && (Kt = ei(Vt + Kt, 0)), st(ct, zn(mt, 3), Kt);
      }
      function zp(ct, mt, Nt) {
        var Vt = ct == null ? 0 : ct.length;
        if (!Vt) return -1;
        var Kt = Vt - 1;
        return Nt !== Ht && (Kt = rr(Nt), Kt = Nt < 0 ? ei(Vt + Kt, 0) : Ii(Kt, Vt - 1)), st(ct, zn(mt, 3), Kt, !0);
      }
      function Xp(ct) {
        return ct != null && ct.length ? di(ct, 1) : [];
      }
      function TE(ct) {
        return ct != null && ct.length ? di(ct, Er) : [];
      }
      function BE(ct, mt) {
        return ct != null && ct.length ? (mt = mt === Ht ? 1 : rr(mt), di(ct, mt)) : [];
      }
      function RE(ct) {
        for (var mt = -1, Nt = ct == null ? 0 : ct.length, Vt = {}; ++mt < Nt; ) {
          var Kt = ct[mt];
          Vt[Kt[0]] = Kt[1];
        }
        return Vt;
      }
      function Kp(ct) {
        return ct && ct.length ? ct[0] : Ht;
      }
      function OE(ct, mt, Nt) {
        var Vt = ct == null ? 0 : ct.length;
        if (!Vt) return -1;
        var Kt = Nt == null ? 0 : rr(Nt);
        return Kt < 0 && (Kt = ei(Vt + Kt, 0)), ut(ct, mt, Kt);
      }
      function NE(ct) {
        return ct != null && ct.length ? aa(ct, 0, -1) : [];
      }
      function DE(ct, mt) {
        return ct == null ? "" : w4.call(ct, mt);
      }
      function oa(ct) {
        var mt = ct == null ? 0 : ct.length;
        return mt ? ct[mt - 1] : Ht;
      }
      function PE(ct, mt, Nt) {
        var Vt = ct == null ? 0 : ct.length;
        if (!Vt) return -1;
        var Kt = Vt;
        return Nt !== Ht && (Kt = rr(Nt), Kt = Kt < 0 ? ei(Vt + Kt, 0) : Ii(Kt, Vt - 1)), mt === mt ? ft(ct, mt, Kt) : st(ct, dt, Kt, !0);
      }
      function kE(ct, mt) {
        return ct && ct.length ? lp(ct, rr(mt)) : Ht;
      }
      function Yp(ct, mt) {
        return ct && ct.length && mt && mt.length ? kf(ct, mt) : ct;
      }
      function _E(ct, mt, Nt) {
        return ct && ct.length && mt && mt.length ? kf(ct, mt, zn(Nt, 2)) : ct;
      }
      function LE(ct, mt, Nt) {
        return ct && ct.length && mt && mt.length ? kf(ct, mt, Ht, Nt) : ct;
      }
      function ME(ct, mt) {
        var Nt = [];
        if (!ct || !ct.length) return Nt;
        var Vt = -1, Kt = [], nn = ct.length;
        for (mt = zn(mt, 3); ++Vt < nn; ) {
          var sn = ct[Vt];
          mt(sn, Vt, ct) && (Nt.push(sn), Kt.push(Vt));
        }
        return pp(ct, Kt), Nt;
      }
      function $f(ct) {
        return ct == null ? ct : O4.call(ct);
      }
      function QE(ct, mt, Nt) {
        var Vt = ct == null ? 0 : ct.length;
        return Vt ? (Nt && typeof Nt != "number" && Bi(ct, mt, Nt) ? (mt = 0, Nt = Vt) : (mt = mt == null ? 0 : rr(mt), Nt = Nt === Ht ? Vt : rr(Nt)), aa(ct, mt, Nt)) : [];
      }
      function FE(ct, mt) {
        return jd(ct, mt);
      }
      function jE(ct, mt, Nt) {
        return Mf(ct, mt, zn(Nt, 2));
      }
      function VE(ct, mt) {
        var Nt = ct == null ? 0 : ct.length;
        if (Nt) {
          var Vt = jd(ct, mt);
          if (Vt < Nt && Ea(ct[Vt], mt)) return Vt;
        }
        return -1;
      }
      function UE(ct, mt) {
        return jd(ct, mt, !0);
      }
      function HE(ct, mt, Nt) {
        return Mf(ct, mt, zn(Nt, 2), !0);
      }
      function GE(ct, mt) {
        if (ct != null && ct.length) {
          var Nt = jd(ct, mt, !0) - 1;
          if (Ea(ct[Nt], mt)) return Nt;
        }
        return -1;
      }
      function WE(ct) {
        return ct && ct.length ? Ap(ct) : [];
      }
      function qE(ct, mt) {
        return ct && ct.length ? Ap(ct, zn(mt, 2)) : [];
      }
      function zE(ct) {
        var mt = ct == null ? 0 : ct.length;
        return mt ? aa(ct, 1, mt) : [];
      }
      function XE(ct, mt, Nt) {
        return ct && ct.length ? (mt = Nt || mt === Ht ? 1 : rr(mt), aa(ct, 0, mt < 0 ? 0 : mt)) : [];
      }
      function KE(ct, mt, Nt) {
        var Vt = ct == null ? 0 : ct.length;
        return Vt ? (mt = Nt || mt === Ht ? 1 : rr(mt), mt = Vt - mt, aa(ct, mt < 0 ? 0 : mt, Vt)) : [];
      }
      function YE(ct, mt) {
        return ct && ct.length ? Vd(ct, zn(mt, 3), !1, !0) : [];
      }
      function $E(ct, mt) {
        return ct && ct.length ? Vd(ct, zn(mt, 3)) : [];
      }
      function JE(ct) {
        return ct && ct.length ? Ko(ct) : [];
      }
      function ZE(ct, mt) {
        return ct && ct.length ? Ko(ct, zn(mt, 2)) : [];
      }
      function eC(ct, mt) {
        return mt = typeof mt == "function" ? mt : Ht, ct && ct.length ? Ko(ct, Ht, mt) : [];
      }
      function Jf(ct) {
        if (!ct || !ct.length) return [];
        var mt = 0;
        return ct = Ke(ct, function(Nt) {
          if (Kr(Nt)) return mt = ei(Nt.length, mt), !0;
        }), yt(mt, function(Nt) {
          return Ze(ct, pt(Nt));
        });
      }
      function $p(ct, mt) {
        if (!ct || !ct.length) return [];
        var Nt = Jf(ct);
        return mt == null ? Nt : Ze(Nt, function(Vt) {
          return Qe(mt, Ht, Vt);
        });
      }
      function tC(ct, mt) {
        return Cp(ct || [], mt || [], El);
      }
      function nC(ct, mt) {
        return Cp(ct || [], mt || [], Il);
      }
      function Jp(ct) {
        var mt = Wt(ct);
        return mt.__chain__ = !0, mt;
      }
      function rC(ct, mt) {
        return mt(ct), ct;
      }
      function Yd(ct, mt) {
        return mt(ct);
      }
      function iC() {
        return Jp(this);
      }
      function aC() {
        return new Wn(this.value(), this.__chain__);
      }
      function oC() {
        this.__values__ === Ht && (this.__values__ = cA(this.value()));
        var ct = this.__index__ >= this.__values__.length;
        return { done: ct, value: ct ? Ht : this.__values__[this.__index__++] };
      }
      function sC() {
        return this;
      }
      function cC(ct) {
        for (var mt, Nt = this; Nt instanceof Mn; ) {
          var Vt = Wp(Nt);
          Vt.__index__ = 0, Vt.__values__ = Ht, mt ? Kt.__wrapped__ = Vt : mt = Vt;
          var Kt = Vt;
          Nt = Nt.__wrapped__;
        }
        return Kt.__wrapped__ = ct, mt;
      }
      function uC() {
        var ct = this.__wrapped__;
        if (ct instanceof Qn) {
          var mt = ct;
          return this.__actions__.length && (mt = new Qn(this)), mt = mt.reverse(), mt.__actions__.push({ func: Yd, args: [$f], thisArg: Ht }), new Wn(mt, this.__chain__);
        }
        return this.thru($f);
      }
      function lC() {
        return Ep(this.__wrapped__, this.__actions__);
      }
      function dC(ct, mt, Nt) {
        var Vt = er(ct) ? Xe : I3;
        return Nt && Bi(ct, mt, Nt) && (mt = Ht), Vt(ct, zn(mt, 3));
      }
      function fC(ct, mt) {
        return (er(ct) ? Ke : np)(ct, zn(mt, 3));
      }
      function hC(ct, mt) {
        return di($d(ct, mt), 1);
      }
      function pC(ct, mt) {
        return di($d(ct, mt), Er);
      }
      function AC(ct, mt, Nt) {
        return Nt = Nt === Ht ? 1 : rr(Nt), di($d(ct, mt), Nt);
      }
      function Zp(ct, mt) {
        return (er(ct) ? He : Zo)(ct, zn(mt, 3));
      }
      function eA(ct, mt) {
        return (er(ct) ? Ge : SA)(ct, zn(mt, 3));
      }
      function gC(ct, mt, Nt, Vt) {
        ct = Mi(ct) ? ct : iu(ct), Nt = Nt && !Vt ? rr(Nt) : 0;
        var Kt = ct.length;
        return Nt < 0 && (Nt = ei(Kt + Nt, 0)), t2(ct) ? Nt <= Kt && ct.indexOf(mt, Nt) > -1 : !!Kt && ut(ct, mt, Nt) > -1;
      }
      function $d(ct, mt) {
        return (er(ct) ? Ze : sp)(ct, zn(mt, 3));
      }
      function mC(ct, mt, Nt, Vt) {
        return ct == null ? [] : (er(mt) || (mt = mt == null ? [] : [mt]), Nt = Vt ? Ht : Nt, er(Nt) || (Nt = Nt == null ? [] : [Nt]), dp(ct, mt, Nt));
      }
      function EC(ct, mt, Nt) {
        var Vt = er(ct) ? tt : wt, Kt = arguments.length < 3;
        return Vt(ct, zn(mt, 4), Nt, Kt, Zo);
      }
      function CC(ct, mt, Nt) {
        var Vt = er(ct) ? et : wt, Kt = arguments.length < 3;
        return Vt(ct, zn(mt, 4), Nt, Kt, SA);
      }
      function vC(ct, mt) {
        return (er(ct) ? Ke : np)(ct, Zd(zn(mt, 3)));
      }
      function yC(ct) {
        return (er(ct) ? J1 : j3)(ct);
      }
      function IC(ct, mt, Nt) {
        return mt = (Nt ? Bi(ct, mt, Nt) : mt === Ht) ? 1 : rr(mt), (er(ct) ? g3 : U3)(ct, mt);
      }
      function xC(ct) {
        return (er(ct) ? m3 : H3)(ct);
      }
      function bC(ct) {
        if (ct == null) return 0;
        if (Mi(ct)) return t2(ct) ? Dt(ct) : ct.length;
        var mt = xi(ct);
        return mt == pr || mt == Wi ? ct.size : Df(ct).length;
      }
      function SC(ct, mt, Nt) {
        var Vt = er(ct) ? rt : G3;
        return Nt && Bi(ct, mt, Nt) && (mt = Ht), Vt(ct, zn(mt, 3));
      }
      function wC(ct, mt) {
        if (typeof mt != "function") throw new ua(mn);
        return ct = rr(ct), function() {
          if (--ct < 1) return mt.apply(this, arguments);
        };
      }
      function tA(ct, mt, Nt) {
        return mt = Nt ? Ht : mt, mt = ct && mt == null ? ct.length : mt, co(ct, or, Ht, Ht, Ht, Ht, mt);
      }
      function nA(ct, mt) {
        var Nt;
        if (typeof mt != "function") throw new ua(mn);
        return ct = rr(ct), function() {
          return --ct > 0 && (Nt = mt.apply(this, arguments)), ct <= 1 && (mt = Ht), Nt;
        };
      }
      function rA(ct, mt, Nt) {
        mt = Nt ? Ht : mt;
        var Vt = co(ct, In, Ht, Ht, Ht, Ht, Ht, mt);
        return Vt.placeholder = rA.placeholder, Vt;
      }
      function iA(ct, mt, Nt) {
        mt = Nt ? Ht : mt;
        var Vt = co(ct, Bn, Ht, Ht, Ht, Ht, Ht, mt);
        return Vt.placeholder = iA.placeholder, Vt;
      }
      function aA(ct, mt, Nt) {
        function Vt(zr) {
          var la = _n, Dl = jn;
          return _n = jn = Ht, ur = zr, tr = ct.apply(Dl, la);
        }
        function Kt(zr) {
          return ur = zr, Gn = Nl(fn, mt), bi ? Vt(zr) : tr;
        }
        function nn(zr) {
          var la = zr - cr, Dl = zr - ur, VA = mt - la;
          return ji ? Ii(VA, Hn - Dl) : VA;
        }
        function sn(zr) {
          var la = zr - cr, Dl = zr - ur;
          return cr === Ht || la >= mt || la < 0 || ji && Dl >= Hn;
        }
        function fn() {
          var zr = g2();
          return sn(zr) ? Cn(zr) : (Gn = Nl(fn, nn(zr)), Ht);
        }
        function Cn(zr) {
          return Gn = Ht, ts && _n ? Vt(zr) : (_n = jn = Ht, tr);
        }
        function Tn() {
          Gn !== Ht && BA(Gn), ur = 0, _n = cr = jn = Gn = Ht;
        }
        function wn() {
          return Gn === Ht ? tr : Cn(g2());
        }
        function On() {
          var zr = g2(), la = sn(zr);
          if (_n = arguments, jn = this, cr = zr, la) {
            if (Gn === Ht) return Kt(cr);
            if (ji) return BA(Gn), Gn = Nl(fn, mt), Vt(cr);
          }
          return Gn === Ht && (Gn = Nl(fn, mt)), tr;
        }
        var _n, jn, Hn, tr, Gn, cr, ur = 0, bi = !1, ji = !1, ts = !0;
        if (typeof ct != "function") throw new ua(mn);
        return mt = sa(mt) || 0, Ur(Nt) && (bi = !!Nt.leading, ji = "maxWait" in Nt, Hn = ji ? ei(sa(Nt.maxWait) || 0, mt) : Hn, ts = "trailing" in Nt ? !!Nt.trailing : ts), On.cancel = Tn, On.flush = wn, On;
      }
      function TC(ct) {
        return co(ct, lr);
      }
      function Jd(ct, mt) {
        if (typeof ct != "function" || mt != null && typeof mt != "function") throw new ua(mn);
        var Nt = function() {
          var Vt = arguments, Kt = mt ? mt.apply(this, Vt) : Vt[0], nn = Nt.cache;
          if (nn.has(Kt)) return nn.get(Kt);
          var sn = ct.apply(this, Vt);
          return Nt.cache = nn.set(Kt, sn) || nn, sn;
        };
        return Nt.cache = new (Jd.Cache || oo)(), Nt;
      }
      function Zd(ct) {
        if (typeof ct != "function") throw new ua(mn);
        return function() {
          var mt = arguments;
          switch (mt.length) {
            case 0:
              return !ct.call(this);
            case 1:
              return !ct.call(this, mt[0]);
            case 2:
              return !ct.call(this, mt[0], mt[1]);
            case 3:
              return !ct.call(this, mt[0], mt[1], mt[2]);
          }
          return !ct.apply(this, mt);
        };
      }
      function BC(ct) {
        return nA(2, ct);
      }
      function RC(ct, mt) {
        if (typeof ct != "function") throw new ua(mn);
        return mt = mt === Ht ? mt : rr(mt), ar(ct, mt);
      }
      function OC(ct, mt) {
        if (typeof ct != "function") throw new ua(mn);
        return mt = mt == null ? 0 : ei(rr(mt), 0), ar(function(Nt) {
          var Vt = Nt[mt], Kt = $o(Nt, 0, mt);
          return Vt && nt(Kt, Vt), Qe(ct, this, Kt);
        });
      }
      function NC(ct, mt, Nt) {
        var Vt = !0, Kt = !0;
        if (typeof ct != "function") throw new ua(mn);
        return Ur(Nt) && (Vt = "leading" in Nt ? !!Nt.leading : Vt, Kt = "trailing" in Nt ? !!Nt.trailing : Kt), aA(ct, mt, { leading: Vt, maxWait: mt, trailing: Kt });
      }
      function DC(ct) {
        return tA(ct, 1);
      }
      function PC(ct, mt) {
        return Eh(Vf(mt), ct);
      }
      function kC() {
        if (!arguments.length) return [];
        var ct = arguments[0];
        return er(ct) ? ct : [ct];
      }
      function _C(ct) {
        return ia(ct, Nn);
      }
      function LC(ct, mt) {
        return mt = typeof mt == "function" ? mt : Ht, ia(ct, Nn, mt);
      }
      function MC(ct) {
        return ia(ct, dn | Nn);
      }
      function QC(ct, mt) {
        return mt = typeof mt == "function" ? mt : Ht, ia(ct, dn | Nn, mt);
      }
      function FC(ct, mt) {
        return mt == null || ep(ct, mt, si(mt));
      }
      function Ea(ct, mt) {
        return ct === mt || ct !== ct && mt !== mt;
      }
      function Mi(ct) {
        return ct != null && e2(ct.length) && !fo(ct);
      }
      function Kr(ct) {
        return qr(ct) && Mi(ct);
      }
      function jC(ct) {
        return ct === !0 || ct === !1 || qr(ct) && Ti(ct) == Jn;
      }
      function VC(ct) {
        return qr(ct) && ct.nodeType === 1 && !Sl(ct);
      }
      function UC(ct) {
        if (ct == null) return !0;
        if (Mi(ct) && (er(ct) || typeof ct == "string" || typeof ct.splice == "function" || es(ct) || lu(ct) || Hs(ct))) return !ct.length;
        var mt = xi(ct);
        if (mt == pr || mt == Wi) return !ct.size;
        if (bl(ct)) return !Df(ct).length;
        for (var Nt in ct) if (Sr.call(ct, Nt)) return !1;
        return !0;
      }
      function HC(ct, mt) {
        return yl(ct, mt);
      }
      function GC(ct, mt, Nt) {
        Nt = typeof Nt == "function" ? Nt : Ht;
        var Vt = Nt ? Nt(ct, mt) : Ht;
        return Vt === Ht ? yl(ct, mt, Ht, Nt) : !!Vt;
      }
      function Zf(ct) {
        if (!qr(ct)) return !1;
        var mt = Ti(ct);
        return mt == Zn || mt == ir || typeof ct.message == "string" && typeof ct.name == "string" && !Sl(ct);
      }
      function WC(ct) {
        return typeof ct == "number" && IA(ct);
      }
      function fo(ct) {
        if (!Ur(ct)) return !1;
        var mt = Ti(ct);
        return mt == Wr || mt == Or || mt == Ln || mt == Td;
      }
      function oA(ct) {
        return typeof ct == "number" && ct == rr(ct);
      }
      function e2(ct) {
        return typeof ct == "number" && ct > -1 && ct % 1 == 0 && ct <= xr;
      }
      function Ur(ct) {
        var mt = typeof ct;
        return ct != null && (mt == "object" || mt == "function");
      }
      function qr(ct) {
        return ct != null && typeof ct == "object";
      }
      function qC(ct, mt) {
        return ct === mt || Nf(ct, mt, zf(mt));
      }
      function zC(ct, mt, Nt) {
        return Nt = typeof Nt == "function" ? Nt : Ht, Nf(ct, mt, zf(mt), Nt);
      }
      function XC(ct) {
        return sA(ct) && ct != +ct;
      }
      function KC(ct) {
        if (F4(ct)) throw new ch(An);
        return ap(ct);
      }
      function YC(ct) {
        return ct === null;
      }
      function $C(ct) {
        return ct == null;
      }
      function sA(ct) {
        return typeof ct == "number" || qr(ct) && Ti(ct) == yr;
      }
      function Sl(ct) {
        if (!qr(ct) || Ti(ct) != vi) return !1;
        var mt = u2(ct);
        if (mt === null) return !0;
        var Nt = Sr.call(mt, "constructor") && mt.constructor;
        return typeof Nt == "function" && Nt instanceof Nt && a2.call(Nt) == E4;
      }
      function JC(ct) {
        return oA(ct) && ct >= -xr && ct <= xr;
      }
      function t2(ct) {
        return typeof ct == "string" || !er(ct) && qr(ct) && Ti(ct) == no;
      }
      function zi(ct) {
        return typeof ct == "symbol" || qr(ct) && Ti(ct) == zc;
      }
      function ZC(ct) {
        return ct === Ht;
      }
      function ev(ct) {
        return qr(ct) && xi(ct) == Bs;
      }
      function tv(ct) {
        return qr(ct) && Ti(ct) == uf;
      }
      function cA(ct) {
        if (!ct) return [];
        if (Mi(ct)) return t2(ct) ? Mt(ct) : Li(ct);
        if (wl && ct[wl]) return qt(ct[wl]());
        var mt = xi(ct);
        return (mt == pr ? _t : mt == Wi ? Ut : iu)(ct);
      }
      function ho(ct) {
        return ct ? (ct = sa(ct), ct === Er || ct === -Er ? (ct < 0 ? -1 : 1) * kr : ct === ct ? ct : 0) : ct === 0 ? ct : 0;
      }
      function rr(ct) {
        var mt = ho(ct), Nt = mt % 1;
        return mt === mt ? Nt ? mt - Nt : mt : 0;
      }
      function uA(ct) {
        return ct ? Qs(rr(ct), 0, sr) : 0;
      }
      function sa(ct) {
        if (typeof ct == "number") return ct;
        if (zi(ct)) return Rr;
        if (Ur(ct)) {
          var mt = typeof ct.valueOf == "function" ? ct.valueOf() : ct;
          ct = Ur(mt) ? mt + "" : mt;
        }
        if (typeof ct != "string") return ct === 0 ? ct : +ct;
        ct = ht(ct);
        var Nt = gf.test(ct);
        return Nt || Dd.test(ct) ? jm(ct.slice(2), Nt ? 2 : 8) : Af.test(ct) ? Rr : +ct;
      }
      function lA(ct) {
        return Pa(ct, Qi(ct));
      }
      function nv(ct) {
        return ct ? Qs(rr(ct), -xr, xr) : ct === 0 ? ct : 0;
      }
      function Ir(ct) {
        return ct == null ? "" : qi(ct);
      }
      function rv(ct, mt) {
        var Nt = uu(ct);
        return mt == null ? Nt : Z1(Nt, mt);
      }
      function iv(ct, mt) {
        return at(ct, zn(mt, 3), Da);
      }
      function av(ct, mt) {
        return at(ct, zn(mt, 3), Bf);
      }
      function ov(ct, mt) {
        return ct == null ? ct : hh(ct, zn(mt, 3), Qi);
      }
      function sv(ct, mt) {
        return ct == null ? ct : wA(ct, zn(mt, 3), Qi);
      }
      function cv(ct, mt) {
        return ct && Da(ct, zn(mt, 3));
      }
      function uv(ct, mt) {
        return ct && Bf(ct, zn(mt, 3));
      }
      function lv(ct) {
        return ct == null ? [] : Qd(ct, si(ct));
      }
      function dv(ct) {
        return ct == null ? [] : Qd(ct, Qi(ct));
      }
      function eh(ct, mt, Nt) {
        var Vt = ct == null ? Ht : Fs(ct, mt);
        return Vt === Ht ? Nt : Vt;
      }
      function fv(ct, mt) {
        return ct != null && Mp(ct, mt, b3);
      }
      function th(ct, mt) {
        return ct != null && Mp(ct, mt, S3);
      }
      function si(ct) {
        return Mi(ct) ? $1(ct) : Df(ct);
      }
      function Qi(ct) {
        return Mi(ct) ? $1(ct, !0) : _3(ct);
      }
      function hv(ct, mt) {
        var Nt = {};
        return mt = zn(mt, 3), Da(ct, function(Vt, Kt, nn) {
          so(Nt, mt(Vt, Kt, nn), Vt);
        }), Nt;
      }
      function pv(ct, mt) {
        var Nt = {};
        return mt = zn(mt, 3), Da(ct, function(Vt, Kt, nn) {
          so(Nt, Kt, mt(Vt, Kt, nn));
        }), Nt;
      }
      function Av(ct, mt) {
        return dA(ct, Zd(zn(mt)));
      }
      function dA(ct, mt) {
        if (ct == null) return {};
        var Nt = Ze(qf(ct), function(Vt) {
          return [Vt];
        });
        return mt = zn(mt), hp(ct, Nt, function(Vt, Kt) {
          return mt(Vt, Kt[0]);
        });
      }
      function gv(ct, mt, Nt) {
        mt = Yo(mt, ct);
        var Vt = -1, Kt = mt.length;
        for (Kt || (Kt = 1, ct = Ht); ++Vt < Kt; ) {
          var nn = ct == null ? Ht : ct[ka(mt[Vt])];
          nn === Ht && (Vt = Kt, nn = Nt), ct = fo(nn) ? nn.call(ct) : nn;
        }
        return ct;
      }
      function mv(ct, mt, Nt) {
        return ct == null ? ct : Il(ct, mt, Nt);
      }
      function Ev(ct, mt, Nt, Vt) {
        return Vt = typeof Vt == "function" ? Vt : Ht, ct == null ? ct : Il(ct, mt, Nt, Vt);
      }
      function Cv(ct, mt, Nt) {
        var Vt = er(ct), Kt = Vt || es(ct) || lu(ct);
        if (mt = zn(mt, 4), Nt == null) {
          var nn = ct && ct.constructor;
          Nt = Kt ? Vt ? new nn() : [] : Ur(ct) && fo(nn) ? uu(u2(ct)) : {};
        }
        return (Kt ? He : Da)(ct, function(sn, fn, Cn) {
          return mt(Nt, sn, fn, Cn);
        }), Nt;
      }
      function vv(ct, mt) {
        return ct == null || Qf(ct, mt);
      }
      function yv(ct, mt, Nt) {
        return ct == null ? ct : mp(ct, mt, Vf(Nt));
      }
      function Iv(ct, mt, Nt, Vt) {
        return Vt = typeof Vt == "function" ? Vt : Ht, ct == null ? ct : mp(ct, mt, Vf(Nt), Vt);
      }
      function iu(ct) {
        return ct == null ? [] : vt(ct, si(ct));
      }
      function xv(ct) {
        return ct == null ? [] : vt(ct, Qi(ct));
      }
      function bv(ct, mt, Nt) {
        return Nt === Ht && (Nt = mt, mt = Ht), Nt !== Ht && (Nt = sa(Nt), Nt = Nt === Nt ? Nt : 0), mt !== Ht && (mt = sa(mt), mt = mt === mt ? mt : 0), Qs(sa(ct), mt, Nt);
      }
      function Sv(ct, mt, Nt) {
        return mt = ho(mt), Nt === Ht ? (Nt = mt, mt = 0) : Nt = ho(Nt), ct = sa(ct), w3(ct, mt, Nt);
      }
      function wv(ct, mt, Nt) {
        if (Nt && typeof Nt != "boolean" && Bi(ct, mt, Nt) && (mt = Nt = Ht), Nt === Ht && (typeof mt == "boolean" ? (Nt = mt, mt = Ht) : typeof ct == "boolean" && (Nt = ct, ct = Ht)), ct === Ht && mt === Ht ? (ct = 0, mt = 1) : (ct = ho(ct), mt === Ht ? (mt = ct, ct = 0) : mt = ho(mt)), ct > mt) {
          var Vt = ct;
          ct = mt, mt = Vt;
        }
        if (Nt || ct % 1 || mt % 1) {
          var Kt = xA();
          return Ii(ct + Kt * (mt - ct + Fm("1e-" + ((Kt + "").length - 1))), mt);
        }
        return _f(ct, mt);
      }
      function fA(ct) {
        return yh(Ir(ct).toLowerCase());
      }
      function hA(ct) {
        return ct = Ir(ct), ct && ct.replace(Jc, Hm).replace(Rm, "");
      }
      function Tv(ct, mt, Nt) {
        ct = Ir(ct), mt = qi(mt);
        var Vt = ct.length;
        Nt = Nt === Ht ? Vt : Qs(rr(Nt), 0, Vt);
        var Kt = Nt;
        return Nt -= mt.length, Nt >= 0 && ct.slice(Nt, Kt) == mt;
      }
      function Bv(ct) {
        return ct = Ir(ct), ct && hf.test(ct) ? ct.replace(Rd, Gm) : ct;
      }
      function Rv(ct) {
        return ct = Ir(ct), ct && Cr.test(ct) ? ct.replace(Vn, "\\$&") : ct;
      }
      function Ov(ct, mt, Nt) {
        ct = Ir(ct), mt = rr(mt);
        var Vt = mt ? Dt(ct) : 0;
        if (!mt || Vt >= mt) return ct;
        var Kt = (mt - Vt) / 2;
        return Wd(h2(Kt), Nt) + ct + Wd(f2(Kt), Nt);
      }
      function Nv(ct, mt, Nt) {
        ct = Ir(ct), mt = rr(mt);
        var Vt = mt ? Dt(ct) : 0;
        return mt && Vt < mt ? ct + Wd(mt - Vt, Nt) : ct;
      }
      function Dv(ct, mt, Nt) {
        ct = Ir(ct), mt = rr(mt);
        var Vt = mt ? Dt(ct) : 0;
        return mt && Vt < mt ? Wd(mt - Vt, Nt) + ct : ct;
      }
      function Pv(ct, mt, Nt) {
        return Nt || mt == null ? mt = 0 : mt && (mt = +mt), R4(Ir(ct).replace($r, ""), mt || 0);
      }
      function kv(ct, mt, Nt) {
        return mt = (Nt ? Bi(ct, mt, Nt) : mt === Ht) ? 1 : rr(mt), Lf(Ir(ct), mt);
      }
      function Lv() {
        var ct = arguments, mt = Ir(ct[0]);
        return ct.length < 3 ? mt : mt.replace(ct[1], ct[2]);
      }
      function Mv(ct, mt, Nt) {
        return Nt && typeof Nt != "number" && Bi(ct, mt, Nt) && (mt = Nt = Ht), (Nt = Nt === Ht ? sr : Nt >>> 0) ? (ct = Ir(ct), ct && (typeof mt == "string" || mt != null && !Ch(mt)) && (mt = qi(mt), !mt && Pt(ct)) ? $o(Mt(ct), 0, Nt) : ct.split(mt, Nt)) : [];
      }
      function Qv(ct, mt, Nt) {
        return ct = Ir(ct), Nt = Nt == null ? 0 : Qs(rr(Nt), 0, ct.length), mt = qi(mt), ct.slice(Nt, Nt + mt.length) == mt;
      }
      function Fv(ct, mt, Nt) {
        var Vt = Wt.templateSettings;
        Nt && Bi(ct, mt, Nt) && (mt = Ht), ct = Ir(ct), mt = m2({}, mt, Vt, kp);
        var Kt, nn, sn = m2({}, mt.imports, Vt.imports, kp), fn = si(sn), Cn = vt(sn, fn), Tn = 0, wn = mt.interpolate || Pd, On = "__p += '", _n = uh((mt.escape || Pd).source + "|" + wn.source + "|" + (wn === Ps ? Nd : Pd).source + "|" + (mt.evaluate || Pd).source + "|$", "g"), jn = "//# sourceURL=" + (Sr.call(mt, "sourceURL") ? (mt.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++km + "]") + `
`;
        ct.replace(_n, function(Gn, cr, ur, bi, ji, ts) {
          return ur || (ur = bi), On += ct.slice(Tn, ts).replace(dm, kt), cr && (Kt = !0, On += `' +
__e(` + cr + `) +
'`), ji && (nn = !0, On += `';
` + ji + `;
__p += '`), ur && (On += `' +
((__t = (` + ur + `)) == null ? '' : __t) +
'`), Tn = ts + Gn.length, Gn;
        }), On += `';
`;
        var Hn = Sr.call(mt, "variable") && mt.variable;
        if (Hn) {
          if (ml.test(Hn)) throw new ch(En);
        } else On = `with (obj) {
` + On + `
}
`;
        On = (nn ? On.replace(lf, "") : On).replace(df, "$1").replace(ff, "$1;"), On = "function(" + (Hn || "obj") + `) {
` + (Hn ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (Kt ? ", __e = _.escape" : "") + (nn ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + On + `return __p
}`;
        var tr = jA(function() {
          return gA(fn, jn + "return " + On).apply(Ht, Cn);
        });
        if (tr.source = On, Zf(tr)) throw tr;
        return tr;
      }
      function jv(ct) {
        return Ir(ct).toLowerCase();
      }
      function Vv(ct) {
        return Ir(ct).toUpperCase();
      }
      function Uv(ct, mt, Nt) {
        if (ct = Ir(ct), ct && (Nt || mt === Ht)) return ht(ct);
        if (!ct || !(mt = qi(mt))) return ct;
        var Vt = Mt(ct), Kt = Mt(mt);
        return $o(Vt, bt(Vt, Kt), Rt(Vt, Kt) + 1).join("");
      }
      function Hv(ct, mt, Nt) {
        if (ct = Ir(ct), ct && (Nt || mt === Ht)) return ct.slice(0, Ft(ct) + 1);
        if (!ct || !(mt = qi(mt))) return ct;
        var Vt = Mt(ct);
        return $o(Vt, 0, Rt(Vt, Mt(mt)) + 1).join("");
      }
      function Gv(ct, mt, Nt) {
        if (ct = Ir(ct), ct && (Nt || mt === Ht)) return ct.replace($r, "");
        if (!ct || !(mt = qi(mt))) return ct;
        var Vt = Mt(ct);
        return $o(Vt, bt(Vt, Mt(mt))).join("");
      }
      function Wv(ct, mt) {
        var Nt = Mr, Vt = ai;
        if (Ur(mt)) {
          var Kt = "separator" in mt ? mt.separator : Kt;
          Nt = "length" in mt ? rr(mt.length) : Nt, Vt = "omission" in mt ? qi(mt.omission) : Vt;
        }
        ct = Ir(ct);
        var nn = ct.length;
        if (Pt(ct)) {
          var sn = Mt(ct);
          nn = sn.length;
        }
        if (Nt >= nn) return ct;
        var fn = Nt - Dt(Vt);
        if (fn < 1) return Vt;
        var Cn = sn ? $o(sn, 0, fn).join("") : ct.slice(0, fn);
        if (Kt === Ht) return Cn + Vt;
        if (sn && (fn += Cn.length - fn), Ch(Kt)) {
          if (ct.slice(fn).search(Kt)) {
            var Tn, wn = Cn;
            for (Kt.global || (Kt = uh(Kt.source, Ir(Yc.exec(Kt)) + "g")), Kt.lastIndex = 0; Tn = Kt.exec(wn); ) var On = Tn.index;
            Cn = Cn.slice(0, On === Ht ? fn : On);
          }
        } else if (ct.indexOf(qi(Kt), fn) != fn) {
          var _n = Cn.lastIndexOf(Kt);
          _n > -1 && (Cn = Cn.slice(0, _n));
        }
        return Cn + Vt;
      }
      function qv(ct) {
        return ct = Ir(ct), ct && Ds.test(ct) ? ct.replace(Bd, Wm) : ct;
      }
      function pA(ct, mt, Nt) {
        return ct = Ir(ct), mt = Nt ? Ht : mt, mt === Ht ? Qt(ct) ? $t(ct) : ot(ct) : ct.match(mt) || [];
      }
      function zv(ct) {
        var mt = ct == null ? 0 : ct.length, Nt = zn();
        return ct = mt ? Ze(ct, function(Vt) {
          if (typeof Vt[1] != "function") throw new ua(mn);
          return [Nt(Vt[0]), Vt[1]];
        }) : [], ar(function(Vt) {
          for (var Kt = -1; ++Kt < mt; ) {
            var nn = ct[Kt];
            if (Qe(nn[0], this, Vt)) return Qe(nn[1], this, Vt);
          }
        });
      }
      function Xv(ct) {
        return y3(ia(ct, dn));
      }
      function nh(ct) {
        return function() {
          return ct;
        };
      }
      function Kv(ct, mt) {
        return ct == null || ct !== ct ? mt : ct;
      }
      function Fi(ct) {
        return ct;
      }
      function rh(ct) {
        return op(typeof ct == "function" ? ct : ia(ct, dn));
      }
      function Yv(ct) {
        return cp(ia(ct, dn));
      }
      function $v(ct, mt) {
        return up(ct, ia(mt, dn));
      }
      function ih(ct, mt, Nt) {
        var Vt = si(mt), Kt = Qd(mt, Vt);
        Nt != null || Ur(mt) && (Kt.length || !Vt.length) || (Nt = mt, mt = ct, ct = this, Kt = Qd(mt, si(mt)));
        var nn = !(Ur(Nt) && "chain" in Nt && !Nt.chain), sn = fo(ct);
        return He(Kt, function(fn) {
          var Cn = mt[fn];
          ct[fn] = Cn, sn && (ct.prototype[fn] = function() {
            var Tn = this.__chain__;
            if (nn || Tn) {
              var wn = ct(this.__wrapped__);
              return (wn.__actions__ = Li(this.__actions__)).push({ func: Cn, args: arguments, thisArg: ct }), wn.__chain__ = Tn, wn;
            }
            return Cn.apply(ct, nt([this.value()], arguments));
          });
        }), ct;
      }
      function Jv() {
        return li._ === this && (li._ = C4), this;
      }
      function ah() {
      }
      function Zv(ct) {
        return ct = rr(ct), ar(function(mt) {
          return lp(mt, ct);
        });
      }
      function AA(ct) {
        return Xf(ct) ? pt(ka(ct)) : Q3(ct);
      }
      function e4(ct) {
        return function(mt) {
          return ct == null ? Ht : Fs(ct, mt);
        };
      }
      function oh() {
        return [];
      }
      function sh() {
        return !1;
      }
      function t4() {
        return {};
      }
      function n4() {
        return "";
      }
      function r4() {
        return !0;
      }
      function i4(ct, mt) {
        if (ct = rr(ct), ct < 1 || ct > xr) return [];
        var Nt = sr, Vt = Ii(ct, sr);
        mt = zn(mt), ct -= sr;
        for (var Kt = yt(Vt, mt); ++Nt < ct; ) mt(Nt);
        return Kt;
      }
      function a4(ct) {
        return er(ct) ? Ze(ct, ka) : zi(ct) ? [ct] : Li(NA(Ir(ct)));
      }
      function o4(ct) {
        var mt = ++m4;
        return Ir(ct) + mt;
      }
      function s4(ct) {
        return ct && ct.length ? Md(ct, Fi, Rf) : Ht;
      }
      function c4(ct, mt) {
        return ct && ct.length ? Md(ct, zn(mt, 2), Rf) : Ht;
      }
      function u4(ct) {
        return At(ct, Fi);
      }
      function l4(ct, mt) {
        return At(ct, zn(mt, 2));
      }
      function d4(ct) {
        return ct && ct.length ? Md(ct, Fi, Pf) : Ht;
      }
      function f4(ct, mt) {
        return ct && ct.length ? Md(ct, zn(mt, 2), Pf) : Ht;
      }
      function h4(ct) {
        return ct && ct.length ? Tt(ct, Fi) : 0;
      }
      function p4(ct, mt) {
        return ct && ct.length ? Tt(ct, zn(mt, 2)) : 0;
      }
      xn = xn == null ? li : eu.defaults(li.Object(), xn, eu.pick(li, Pm));
      var Zr = xn.Array, n2 = xn.Date, ch = xn.Error, gA = xn.Function, au = xn.Math, jr = xn.Object, uh = xn.RegExp, A4 = xn.String, ua = xn.TypeError, r2 = Zr.prototype, g4 = gA.prototype, ou = jr.prototype, i2 = xn["__core-js_shared__"], a2 = g4.toString, Sr = ou.hasOwnProperty, m4 = 0, mA = function() {
        var ct = /[^.]+$/.exec(i2 && i2.keys && i2.keys.IE_PROTO || "");
        return ct ? "Symbol(src)_1." + ct : "";
      }(), o2 = ou.toString, E4 = a2.call(jr), C4 = li._, y4 = uh("^" + a2.call(Sr).replace(Vn, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), s2 = G1 ? xn.Buffer : Ht, Jo = xn.Symbol, c2 = xn.Uint8Array, EA = s2 ? s2.allocUnsafe : Ht, u2 = Yt(jr.getPrototypeOf, jr), CA = jr.create, vA = ou.propertyIsEnumerable, l2 = r2.splice, yA = Jo ? Jo.isConcatSpreadable : Ht, wl = Jo ? Jo.iterator : Ht, Us = Jo ? Jo.toStringTag : Ht, d2 = function() {
        try {
          var ct = js(jr, "defineProperty");
          return ct({}, "", {}), ct;
        } catch {
        }
      }(), I4 = xn.clearTimeout !== li.clearTimeout && xn.clearTimeout, x4 = n2 && n2.now !== li.Date.now && n2.now, b4 = xn.setTimeout !== li.setTimeout && xn.setTimeout, f2 = au.ceil, h2 = au.floor, lh = jr.getOwnPropertySymbols, S4 = s2 ? s2.isBuffer : Ht, IA = xn.isFinite, w4 = r2.join, T4 = Yt(jr.keys, jr), ei = au.max, Ii = au.min, B4 = n2.now, R4 = xn.parseInt, xA = au.random, O4 = r2.reverse, dh = js(xn, "DataView"), Tl = js(xn, "Map"), fh = js(xn, "Promise"), su = js(xn, "Set"), Bl = js(xn, "WeakMap"), Rl = js(jr, "create"), p2 = Bl && new Bl(), cu = {}, N4 = Vs(dh), D4 = Vs(Tl), P4 = Vs(fh), k4 = Vs(su), _4 = Vs(Bl), A2 = Jo ? Jo.prototype : Ht, Ol = A2 ? A2.valueOf : Ht, bA = A2 ? A2.toString : Ht, uu = /* @__PURE__ */ function() {
        function ct() {
        }
        return function(mt) {
          if (!Ur(mt)) return {};
          if (CA) return CA(mt);
          ct.prototype = mt;
          var Nt = new ct();
          return ct.prototype = Ht, Nt;
        };
      }();
      Wt.templateSettings = { escape: Od, evaluate: Al, interpolate: Ps, variable: "", imports: { _: Wt } }, Wt.prototype = Mn.prototype, Wt.prototype.constructor = Wt, Wn.prototype = uu(Mn.prototype), Wn.prototype.constructor = Wn, Qn.prototype = uu(Mn.prototype), Qn.prototype.constructor = Qn, Ls.prototype.clear = Xm, Ls.prototype.delete = Km, Ls.prototype.get = Ym, Ls.prototype.has = $m, Ls.prototype.set = Jm, ao.prototype.clear = Zm, ao.prototype.delete = e3, ao.prototype.get = t3, ao.prototype.has = n3, ao.prototype.set = r3, oo.prototype.clear = i3, oo.prototype.delete = a3, oo.prototype.get = o3, oo.prototype.has = s3, oo.prototype.set = c3, Ms.prototype.add = Ms.prototype.push = u3, Ms.prototype.has = l3, ma.prototype.clear = d3, ma.prototype.delete = f3, ma.prototype.get = h3, ma.prototype.has = p3, ma.prototype.set = A3;
      var Zo = Sp(Da), SA = Sp(Bf, !0), hh = wp(), wA = wp(!0), TA = p2 ? function(ct, mt) {
        return p2.set(ct, mt), ct;
      } : Fi, L4 = d2 ? function(ct, mt) {
        return d2(ct, "toString", {
          configurable: !0,
          enumerable: !1,
          value: nh(mt),
          writable: !0
        });
      } : Fi, M4 = ar, BA = I4 || function(ct) {
        return li.clearTimeout(ct);
      }, Q4 = su && 1 / Ut(new su([, -0]))[1] == Er ? function(ct) {
        return new su(ct);
      } : ah, ph = p2 ? function(ct) {
        return p2.get(ct);
      } : ah, Ah = lh ? function(ct) {
        return ct == null ? [] : (ct = jr(ct), Ke(lh(ct), function(mt) {
          return vA.call(ct, mt);
        }));
      } : oh, RA = lh ? function(ct) {
        for (var mt = []; ct; ) nt(mt, Ah(ct)), ct = u2(ct);
        return mt;
      } : oh, xi = Ti;
      (dh && xi(new dh(new ArrayBuffer(1))) != Na || Tl && xi(new Tl()) != pr || fh && xi(fh.resolve()) != Kn || su && xi(new su()) != Wi || Bl && xi(new Bl()) != Bs) && (xi = function(ct) {
        var mt = Ti(ct), Nt = mt == vi ? ct.constructor : Ht, Vt = Nt ? Vs(Nt) : "";
        if (Vt) switch (Vt) {
          case N4:
            return Na;
          case D4:
            return pr;
          case P4:
            return Kn;
          case k4:
            return Wi;
          case _4:
            return Bs;
        }
        return mt;
      });
      var F4 = i2 ? fo : sh, OA = Gp(TA), Nl = b4 || function(ct, mt) {
        return li.setTimeout(ct, mt);
      }, gh = Gp(L4), NA = fE(function(ct) {
        var mt = [];
        return ct.charCodeAt(0) === 46 && mt.push(""), ct.replace(pf, function(Nt, Vt, Kt, nn) {
          mt.push(Kt ? nn.replace(io, "$1") : Vt || Nt);
        }), mt;
      }), j4 = ar(function(ct, mt) {
        return Kr(ct) ? Cl(ct, di(mt, 1, Kr, !0)) : [];
      }), U4 = ar(function(ct, mt) {
        var Nt = oa(mt);
        return Kr(Nt) && (Nt = Ht), Kr(ct) ? Cl(ct, di(mt, 1, Kr, !0), zn(Nt, 2)) : [];
      }), H4 = ar(function(ct, mt) {
        var Nt = oa(mt);
        return Kr(Nt) && (Nt = Ht), Kr(ct) ? Cl(ct, di(mt, 1, Kr, !0), Ht, Nt) : [];
      }), G4 = ar(function(ct) {
        var mt = Ze(ct, jf);
        return mt.length && mt[0] === ct[0] ? Of(mt) : [];
      }), W4 = ar(function(ct) {
        var mt = oa(ct), Nt = Ze(ct, jf);
        return mt === oa(Nt) ? mt = Ht : Nt.pop(), Nt.length && Nt[0] === ct[0] ? Of(Nt, zn(mt, 2)) : [];
      }), q4 = ar(function(ct) {
        var mt = oa(ct), Nt = Ze(ct, jf);
        return mt = typeof mt == "function" ? mt : Ht, mt && Nt.pop(), Nt.length && Nt[0] === ct[0] ? Of(Nt, Ht, mt) : [];
      }), z4 = ar(Yp), X4 = uo(function(ct, mt) {
        var Nt = ct == null ? 0 : ct.length, Vt = Tf(ct, mt);
        return pp(ct, Ze(mt, function(Kt) {
          return lo(Kt, Nt) ? +Kt : Kt;
        }).sort(Ip)), Vt;
      }), K4 = ar(function(ct) {
        return Ko(di(ct, 1, Kr, !0));
      }), Y4 = ar(function(ct) {
        var mt = oa(ct);
        return Kr(mt) && (mt = Ht), Ko(di(ct, 1, Kr, !0), zn(mt, 2));
      }), $4 = ar(function(ct) {
        var mt = oa(ct);
        return mt = typeof mt == "function" ? mt : Ht, Ko(di(ct, 1, Kr, !0), Ht, mt);
      }), J4 = ar(function(ct, mt) {
        return Kr(ct) ? Cl(ct, mt) : [];
      }), Z4 = ar(function(ct) {
        return Ff(Ke(ct, Kr));
      }), ey = ar(function(ct) {
        var mt = oa(ct);
        return Kr(mt) && (mt = Ht), Ff(Ke(ct, Kr), zn(mt, 2));
      }), ty = ar(function(ct) {
        var mt = oa(ct);
        return mt = typeof mt == "function" ? mt : Ht, Ff(Ke(ct, Kr), Ht, mt);
      }), ny = ar(Jf), ry = ar(function(ct) {
        var mt = ct.length, Nt = mt > 1 ? ct[mt - 1] : Ht;
        return Nt = typeof Nt == "function" ? (ct.pop(), Nt) : Ht, $p(ct, Nt);
      }), iy = uo(function(ct) {
        var mt = ct.length, Nt = mt ? ct[0] : 0, Vt = this.__wrapped__, Kt = function(nn) {
          return Tf(nn, ct);
        };
        return !(mt > 1 || this.__actions__.length) && Vt instanceof Qn && lo(Nt) ? (Vt = Vt.slice(Nt, +Nt + (mt ? 1 : 0)), Vt.__actions__.push({ func: Yd, args: [Kt], thisArg: Ht }), new Wn(Vt, this.__chain__).thru(function(nn) {
          return mt && !nn.length && nn.push(Ht), nn;
        })) : this.thru(Kt);
      }), ay = Ud(function(ct, mt, Nt) {
        Sr.call(ct, Nt) ? ++ct[Nt] : so(ct, Nt, 1);
      }), oy = Bp(qp), sy = Bp(zp), cy = Ud(function(ct, mt, Nt) {
        Sr.call(ct, Nt) ? ct[Nt].push(mt) : so(ct, Nt, [mt]);
      }), uy = ar(function(ct, mt, Nt) {
        var Vt = -1, Kt = typeof mt == "function", nn = Mi(ct) ? Zr(ct.length) : [];
        return Zo(ct, function(sn) {
          nn[++Vt] = Kt ? Qe(mt, sn, Nt) : vl(sn, mt, Nt);
        }), nn;
      }), ly = Ud(function(ct, mt, Nt) {
        so(ct, Nt, mt);
      }), dy = Ud(function(ct, mt, Nt) {
        ct[Nt ? 0 : 1].push(mt);
      }, function() {
        return [[], []];
      }), fy = ar(function(ct, mt) {
        if (ct == null) return [];
        var Nt = mt.length;
        return Nt > 1 && Bi(ct, mt[0], mt[1]) ? mt = [] : Nt > 2 && Bi(mt[0], mt[1], mt[2]) && (mt = [mt[0]]), dp(ct, di(mt, 1), []);
      }), g2 = x4 || function() {
        return li.Date.now();
      }, mh = ar(function(ct, mt, Nt) {
        var Vt = ln;
        if (Nt.length) {
          var Kt = Xt(Nt, ru(mh));
          Vt |= Pn;
        }
        return co(ct, Vt, mt, Nt, Kt);
      }), DA = ar(function(ct, mt, Nt) {
        var Vt = ln | pn;
        if (Nt.length) {
          var Kt = Xt(Nt, ru(DA));
          Vt |= Pn;
        }
        return co(mt, Vt, ct, Nt, Kt);
      }), hy = ar(function(ct, mt) {
        return tp(ct, 1, mt);
      }), py = ar(function(ct, mt, Nt) {
        return tp(ct, sa(mt) || 0, Nt);
      });
      Jd.Cache = oo;
      var Ay = M4(function(ct, mt) {
        mt = mt.length == 1 && er(mt[0]) ? Ze(mt[0], It(zn())) : Ze(di(mt, 1), It(zn()));
        var Nt = mt.length;
        return ar(function(Vt) {
          for (var Kt = -1, nn = Ii(Vt.length, Nt); ++Kt < nn; ) Vt[Kt] = mt[Kt].call(this, Vt[Kt]);
          return Qe(ct, this, Vt);
        });
      }), Eh = ar(function(ct, mt) {
        return co(ct, Pn, Ht, mt, Xt(mt, ru(Eh)));
      }), PA = ar(function(ct, mt) {
        return co(ct, Yn, Ht, mt, Xt(mt, ru(PA)));
      }), gy = uo(function(ct, mt) {
        return co(ct, mr, Ht, Ht, Ht, mt);
      }), my = qd(Rf), Ey = qd(function(ct, mt) {
        return ct >= mt;
      }), Hs = ip(/* @__PURE__ */ function() {
        return arguments;
      }()) ? ip : function(ct) {
        return qr(ct) && Sr.call(ct, "callee") && !vA.call(ct, "callee");
      }, er = Zr.isArray, Cy = W1 ? It(W1) : B3, es = S4 || sh, vy = q1 ? It(q1) : R3, kA = z1 ? It(z1) : N3, Ch = X1 ? It(X1) : D3, _A = K1 ? It(K1) : P3, lu = Y1 ? It(Y1) : k3, yy = qd(Pf), Iy = qd(function(ct, mt) {
        return ct <= mt;
      }), xy = tu(function(ct, mt) {
        if (bl(mt) || Mi(mt)) return Pa(mt, si(mt), ct), Ht;
        for (var Nt in mt) Sr.call(mt, Nt) && El(ct, Nt, mt[Nt]);
      }), LA = tu(function(ct, mt) {
        Pa(mt, Qi(mt), ct);
      }), m2 = tu(function(ct, mt, Nt, Vt) {
        Pa(mt, Qi(mt), ct, Vt);
      }), by = tu(function(ct, mt, Nt, Vt) {
        Pa(mt, si(mt), ct, Vt);
      }), Sy = uo(Tf), wy = ar(function(ct, mt) {
        ct = jr(ct);
        var Nt = -1, Vt = mt.length, Kt = Vt > 2 ? mt[2] : Ht;
        for (Kt && Bi(mt[0], mt[1], Kt) && (Vt = 1); ++Nt < Vt; ) for (var nn = mt[Nt], sn = Qi(nn), fn = -1, Cn = sn.length; ++fn < Cn; ) {
          var Tn = sn[fn], wn = ct[Tn];
          (wn === Ht || Ea(wn, ou[Tn]) && !Sr.call(ct, Tn)) && (ct[Tn] = nn[Tn]);
        }
        return ct;
      }), Ty = ar(function(ct) {
        return ct.push(Ht, _p), Qe(MA, Ht, ct);
      }), By = Op(function(ct, mt, Nt) {
        mt != null && typeof mt.toString != "function" && (mt = o2.call(mt)), ct[mt] = Nt;
      }, nh(Fi)), Ry = Op(function(ct, mt, Nt) {
        mt != null && typeof mt.toString != "function" && (mt = o2.call(mt)), Sr.call(ct, mt) ? ct[mt].push(Nt) : ct[mt] = [Nt];
      }, zn), Oy = ar(vl), Ny = tu(function(ct, mt, Nt) {
        Fd(ct, mt, Nt);
      }), MA = tu(function(ct, mt, Nt, Vt) {
        Fd(ct, mt, Nt, Vt);
      }), Dy = uo(function(ct, mt) {
        var Nt = {};
        if (ct == null) return Nt;
        var Vt = !1;
        mt = Ze(mt, function(nn) {
          return nn = Yo(nn, ct), Vt || (Vt = nn.length > 1), nn;
        }), Pa(ct, qf(ct), Nt), Vt && (Nt = ia(Nt, dn | yn | Nn, eE));
        for (var Kt = mt.length; Kt--; ) Qf(Nt, mt[Kt]);
        return Nt;
      }), Py = uo(function(ct, mt) {
        return ct == null ? {} : M3(ct, mt);
      }), QA = Pp(si), FA = Pp(Qi), ky = nu(function(ct, mt, Nt) {
        return mt = mt.toLowerCase(), ct + (Nt ? fA(mt) : mt);
      }), _y = nu(function(ct, mt, Nt) {
        return ct + (Nt ? "-" : "") + mt.toLowerCase();
      }), Ly = nu(function(ct, mt, Nt) {
        return ct + (Nt ? " " : "") + mt.toLowerCase();
      }), My = Tp("toLowerCase"), Qy = nu(function(ct, mt, Nt) {
        return ct + (Nt ? "_" : "") + mt.toLowerCase();
      }), Fy = nu(function(ct, mt, Nt) {
        return ct + (Nt ? " " : "") + yh(mt);
      }), jy = nu(function(ct, mt, Nt) {
        return ct + (Nt ? " " : "") + mt.toUpperCase();
      }), yh = Tp("toUpperCase"), jA = ar(function(ct, mt) {
        try {
          return Qe(ct, Ht, mt);
        } catch (Nt) {
          return Zf(Nt) ? Nt : new ch(Nt);
        }
      }), Vy = uo(function(ct, mt) {
        return He(mt, function(Nt) {
          Nt = ka(Nt), so(ct, Nt, mh(ct[Nt], ct));
        }), ct;
      }), Uy = Rp(), Hy = Rp(!0), Gy = ar(function(ct, mt) {
        return function(Nt) {
          return vl(Nt, ct, mt);
        };
      }), Wy = ar(function(ct, mt) {
        return function(Nt) {
          return vl(ct, Nt, mt);
        };
      }), qy = Hf(Ze), zy = Hf(Xe), Xy = Hf(rt), Ky = Np(), Yy = Np(!0), $y = Gd(function(ct, mt) {
        return ct + mt;
      }, 0), Jy = Gf("ceil"), Zy = Gd(function(ct, mt) {
        return ct / mt;
      }, 1), e6 = Gf("floor"), t6 = Gd(function(ct, mt) {
        return ct * mt;
      }, 1), n6 = Gf("round"), r6 = Gd(function(ct, mt) {
        return ct - mt;
      }, 0);
      return Wt.after = wC, Wt.ary = tA, Wt.assign = xy, Wt.assignIn = LA, Wt.assignInWith = m2, Wt.assignWith = by, Wt.at = Sy, Wt.before = nA, Wt.bind = mh, Wt.bindAll = Vy, Wt.bindKey = DA, Wt.castArray = kC, Wt.chain = Jp, Wt.chunk = CE, Wt.compact = vE, Wt.concat = yE, Wt.cond = zv, Wt.conforms = Xv, Wt.constant = nh, Wt.countBy = ay, Wt.create = rv, Wt.curry = rA, Wt.curryRight = iA, Wt.debounce = aA, Wt.defaults = wy, Wt.defaultsDeep = Ty, Wt.defer = hy, Wt.delay = py, Wt.difference = j4, Wt.differenceBy = U4, Wt.differenceWith = H4, Wt.drop = IE, Wt.dropRight = xE, Wt.dropRightWhile = bE, Wt.dropWhile = SE, Wt.fill = wE, Wt.filter = fC, Wt.flatMap = hC, Wt.flatMapDeep = pC, Wt.flatMapDepth = AC, Wt.flatten = Xp, Wt.flattenDeep = TE, Wt.flattenDepth = BE, Wt.flip = TC, Wt.flow = Uy, Wt.flowRight = Hy, Wt.fromPairs = RE, Wt.functions = lv, Wt.functionsIn = dv, Wt.groupBy = cy, Wt.initial = NE, Wt.intersection = G4, Wt.intersectionBy = W4, Wt.intersectionWith = q4, Wt.invert = By, Wt.invertBy = Ry, Wt.invokeMap = uy, Wt.iteratee = rh, Wt.keyBy = ly, Wt.keys = si, Wt.keysIn = Qi, Wt.map = $d, Wt.mapKeys = hv, Wt.mapValues = pv, Wt.matches = Yv, Wt.matchesProperty = $v, Wt.memoize = Jd, Wt.merge = Ny, Wt.mergeWith = MA, Wt.method = Gy, Wt.methodOf = Wy, Wt.mixin = ih, Wt.negate = Zd, Wt.nthArg = Zv, Wt.omit = Dy, Wt.omitBy = Av, Wt.once = BC, Wt.orderBy = mC, Wt.over = qy, Wt.overArgs = Ay, Wt.overEvery = zy, Wt.overSome = Xy, Wt.partial = Eh, Wt.partialRight = PA, Wt.partition = dy, Wt.pick = Py, Wt.pickBy = dA, Wt.property = AA, Wt.propertyOf = e4, Wt.pull = z4, Wt.pullAll = Yp, Wt.pullAllBy = _E, Wt.pullAllWith = LE, Wt.pullAt = X4, Wt.range = Ky, Wt.rangeRight = Yy, Wt.rearg = gy, Wt.reject = vC, Wt.remove = ME, Wt.rest = RC, Wt.reverse = $f, Wt.sampleSize = IC, Wt.set = mv, Wt.setWith = Ev, Wt.shuffle = xC, Wt.slice = QE, Wt.sortBy = fy, Wt.sortedUniq = WE, Wt.sortedUniqBy = qE, Wt.split = Mv, Wt.spread = OC, Wt.tail = zE, Wt.take = XE, Wt.takeRight = KE, Wt.takeRightWhile = YE, Wt.takeWhile = $E, Wt.tap = rC, Wt.throttle = NC, Wt.thru = Yd, Wt.toArray = cA, Wt.toPairs = QA, Wt.toPairsIn = FA, Wt.toPath = a4, Wt.toPlainObject = lA, Wt.transform = Cv, Wt.unary = DC, Wt.union = K4, Wt.unionBy = Y4, Wt.unionWith = $4, Wt.uniq = JE, Wt.uniqBy = ZE, Wt.uniqWith = eC, Wt.unset = vv, Wt.unzip = Jf, Wt.unzipWith = $p, Wt.update = yv, Wt.updateWith = Iv, Wt.values = iu, Wt.valuesIn = xv, Wt.without = J4, Wt.words = pA, Wt.wrap = PC, Wt.xor = Z4, Wt.xorBy = ey, Wt.xorWith = ty, Wt.zip = ny, Wt.zipObject = tC, Wt.zipObjectDeep = nC, Wt.zipWith = ry, Wt.entries = QA, Wt.entriesIn = FA, Wt.extend = LA, Wt.extendWith = m2, ih(Wt, Wt), Wt.add = $y, Wt.attempt = jA, Wt.camelCase = ky, Wt.capitalize = fA, Wt.ceil = Jy, Wt.clamp = bv, Wt.clone = _C, Wt.cloneDeep = MC, Wt.cloneDeepWith = QC, Wt.cloneWith = LC, Wt.conformsTo = FC, Wt.deburr = hA, Wt.defaultTo = Kv, Wt.divide = Zy, Wt.endsWith = Tv, Wt.eq = Ea, Wt.escape = Bv, Wt.escapeRegExp = Rv, Wt.every = dC, Wt.find = oy, Wt.findIndex = qp, Wt.findKey = iv, Wt.findLast = sy, Wt.findLastIndex = zp, Wt.findLastKey = av, Wt.floor = e6, Wt.forEach = Zp, Wt.forEachRight = eA, Wt.forIn = ov, Wt.forInRight = sv, Wt.forOwn = cv, Wt.forOwnRight = uv, Wt.get = eh, Wt.gt = my, Wt.gte = Ey, Wt.has = fv, Wt.hasIn = th, Wt.head = Kp, Wt.identity = Fi, Wt.includes = gC, Wt.indexOf = OE, Wt.inRange = Sv, Wt.invoke = Oy, Wt.isArguments = Hs, Wt.isArray = er, Wt.isArrayBuffer = Cy, Wt.isArrayLike = Mi, Wt.isArrayLikeObject = Kr, Wt.isBoolean = jC, Wt.isBuffer = es, Wt.isDate = vy, Wt.isElement = VC, Wt.isEmpty = UC, Wt.isEqual = HC, Wt.isEqualWith = GC, Wt.isError = Zf, Wt.isFinite = WC, Wt.isFunction = fo, Wt.isInteger = oA, Wt.isLength = e2, Wt.isMap = kA, Wt.isMatch = qC, Wt.isMatchWith = zC, Wt.isNaN = XC, Wt.isNative = KC, Wt.isNil = $C, Wt.isNull = YC, Wt.isNumber = sA, Wt.isObject = Ur, Wt.isObjectLike = qr, Wt.isPlainObject = Sl, Wt.isRegExp = Ch, Wt.isSafeInteger = JC, Wt.isSet = _A, Wt.isString = t2, Wt.isSymbol = zi, Wt.isTypedArray = lu, Wt.isUndefined = ZC, Wt.isWeakMap = ev, Wt.isWeakSet = tv, Wt.join = DE, Wt.kebabCase = _y, Wt.last = oa, Wt.lastIndexOf = PE, Wt.lowerCase = Ly, Wt.lowerFirst = My, Wt.lt = yy, Wt.lte = Iy, Wt.max = s4, Wt.maxBy = c4, Wt.mean = u4, Wt.meanBy = l4, Wt.min = d4, Wt.minBy = f4, Wt.stubArray = oh, Wt.stubFalse = sh, Wt.stubObject = t4, Wt.stubString = n4, Wt.stubTrue = r4, Wt.multiply = t6, Wt.nth = kE, Wt.noConflict = Jv, Wt.noop = ah, Wt.now = g2, Wt.pad = Ov, Wt.padEnd = Nv, Wt.padStart = Dv, Wt.parseInt = Pv, Wt.random = wv, Wt.reduce = EC, Wt.reduceRight = CC, Wt.repeat = kv, Wt.replace = Lv, Wt.result = gv, Wt.round = n6, Wt.runInContext = gn, Wt.sample = yC, Wt.size = bC, Wt.snakeCase = Qy, Wt.some = SC, Wt.sortedIndex = FE, Wt.sortedIndexBy = jE, Wt.sortedIndexOf = VE, Wt.sortedLastIndex = UE, Wt.sortedLastIndexBy = HE, Wt.sortedLastIndexOf = GE, Wt.startCase = Fy, Wt.startsWith = Qv, Wt.subtract = r6, Wt.sum = h4, Wt.sumBy = p4, Wt.template = Fv, Wt.times = i4, Wt.toFinite = ho, Wt.toInteger = rr, Wt.toLength = uA, Wt.toLower = jv, Wt.toNumber = sa, Wt.toSafeInteger = nv, Wt.toString = Ir, Wt.toUpper = Vv, Wt.trim = Uv, Wt.trimEnd = Hv, Wt.trimStart = Gv, Wt.truncate = Wv, Wt.unescape = qv, Wt.uniqueId = o4, Wt.upperCase = jy, Wt.upperFirst = yh, Wt.each = Zp, Wt.eachRight = eA, Wt.first = Kp, ih(Wt, function() {
        var ct = {};
        return Da(Wt, function(mt, Nt) {
          Sr.call(Wt.prototype, Nt) || (ct[Nt] = mt);
        }), ct;
      }(), { chain: !1 }), Wt.VERSION = hn, He(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(ct) {
        Wt[ct].placeholder = Wt;
      }), He(["drop", "take"], function(ct, mt) {
        Qn.prototype[ct] = function(Nt) {
          Nt = Nt === Ht ? 1 : ei(rr(Nt), 0);
          var Vt = this.__filtered__ && !mt ? new Qn(this) : this.clone();
          return Vt.__filtered__ ? Vt.__takeCount__ = Ii(Nt, Vt.__takeCount__) : Vt.__views__.push({ size: Ii(Nt, sr), type: ct + (Vt.__dir__ < 0 ? "Right" : "") }), Vt;
        }, Qn.prototype[ct + "Right"] = function(Nt) {
          return this.reverse()[ct](Nt).reverse();
        };
      }), He(["filter", "map", "takeWhile"], function(ct, mt) {
        var Nt = mt + 1, Vt = Nt == hr || Nt == Pr;
        Qn.prototype[ct] = function(Kt) {
          var nn = this.clone();
          return nn.__iteratees__.push({ iteratee: zn(Kt, 3), type: Nt }), nn.__filtered__ = nn.__filtered__ || Vt, nn;
        };
      }), He(["head", "last"], function(ct, mt) {
        var Nt = "take" + (mt ? "Right" : "");
        Qn.prototype[ct] = function() {
          return this[Nt](1).value()[0];
        };
      }), He(["initial", "tail"], function(ct, mt) {
        var Nt = "drop" + (mt ? "" : "Right");
        Qn.prototype[ct] = function() {
          return this.__filtered__ ? new Qn(this) : this[Nt](1);
        };
      }), Qn.prototype.compact = function() {
        return this.filter(Fi);
      }, Qn.prototype.find = function(ct) {
        return this.filter(ct).head();
      }, Qn.prototype.findLast = function(ct) {
        return this.reverse().find(ct);
      }, Qn.prototype.invokeMap = ar(function(ct, mt) {
        return typeof ct == "function" ? new Qn(this) : this.map(function(Nt) {
          return vl(Nt, ct, mt);
        });
      }), Qn.prototype.reject = function(ct) {
        return this.filter(Zd(zn(ct)));
      }, Qn.prototype.slice = function(ct, mt) {
        ct = rr(ct);
        var Nt = this;
        return Nt.__filtered__ && (ct > 0 || mt < 0) ? new Qn(Nt) : (ct < 0 ? Nt = Nt.takeRight(-ct) : ct && (Nt = Nt.drop(ct)), mt !== Ht && (mt = rr(mt), Nt = mt < 0 ? Nt.dropRight(-mt) : Nt.take(mt - ct)), Nt);
      }, Qn.prototype.takeRightWhile = function(ct) {
        return this.reverse().takeWhile(ct).reverse();
      }, Qn.prototype.toArray = function() {
        return this.take(sr);
      }, Da(Qn.prototype, function(ct, mt) {
        var Nt = /^(?:filter|find|map|reject)|While$/.test(mt), Vt = /^(?:head|last)$/.test(mt), Kt = Wt[Vt ? "take" + (mt == "last" ? "Right" : "") : mt], nn = Vt || /^find/.test(mt);
        Kt && (Wt.prototype[mt] = function() {
          var sn = this.__wrapped__, fn = Vt ? [1] : arguments, Cn = sn instanceof Qn, Tn = fn[0], wn = Cn || er(sn), On = function(cr) {
            var ur = Kt.apply(Wt, nt([cr], fn));
            return Vt && _n ? ur[0] : ur;
          };
          wn && Nt && typeof Tn == "function" && Tn.length != 1 && (Cn = wn = !1);
          var _n = this.__chain__, jn = !!this.__actions__.length, Hn = nn && !_n, tr = Cn && !jn;
          if (!nn && wn) {
            sn = tr ? sn : new Qn(this);
            var Gn = ct.apply(sn, fn);
            return Gn.__actions__.push({ func: Yd, args: [On], thisArg: Ht }), new Wn(Gn, _n);
          }
          return Hn && tr ? ct.apply(this, fn) : (Gn = this.thru(On), Hn ? Vt ? Gn.value()[0] : Gn.value() : Gn);
        });
      }), He(["pop", "push", "shift", "sort", "splice", "unshift"], function(ct) {
        var mt = r2[ct], Nt = /^(?:push|sort|unshift)$/.test(ct) ? "tap" : "thru", Vt = /^(?:pop|shift)$/.test(ct);
        Wt.prototype[ct] = function() {
          var Kt = arguments;
          if (Vt && !this.__chain__) {
            var nn = this.value();
            return mt.apply(er(nn) ? nn : [], Kt);
          }
          return this[Nt](function(sn) {
            return mt.apply(er(sn) ? sn : [], Kt);
          });
        };
      }), Da(Qn.prototype, function(ct, mt) {
        var Nt = Wt[mt];
        if (Nt) {
          var Vt = Nt.name + "";
          Sr.call(cu, Vt) || (cu[Vt] = []), cu[Vt].push({ name: mt, func: Nt });
        }
      }), cu[Hd(Ht, pn).name] = [{ name: "wrapper", func: Ht }], Qn.prototype.clone = _i, Qn.prototype.reverse = Sf, Qn.prototype.value = zm, Wt.prototype.at = iy, Wt.prototype.chain = iC, Wt.prototype.commit = aC, Wt.prototype.next = oC, Wt.prototype.plant = cC, Wt.prototype.reverse = uC, Wt.prototype.toJSON = Wt.prototype.valueOf = Wt.prototype.value = lC, Wt.prototype.first = Wt.prototype.head, wl && (Wt.prototype[wl] = sC), Wt;
    }, eu = qm();
    _s ? ((_s.exports = eu)._ = eu, xf._ = eu) : li._ = eu;
  }).call(commonjsGlobal);
})(lodash_min, lodash_min.exports);
var lodash_minExports = lodash_min.exports, _mapping = {};
(function(me) {
  me.aliasToReal = {
    // Lodash aliases.
    each: "forEach",
    eachRight: "forEachRight",
    entries: "toPairs",
    entriesIn: "toPairsIn",
    extend: "assignIn",
    extendAll: "assignInAll",
    extendAllWith: "assignInAllWith",
    extendWith: "assignInWith",
    first: "head",
    // Methods that are curried variants of others.
    conforms: "conformsTo",
    matches: "isMatch",
    property: "get",
    // Ramda aliases.
    __: "placeholder",
    F: "stubFalse",
    T: "stubTrue",
    all: "every",
    allPass: "overEvery",
    always: "constant",
    any: "some",
    anyPass: "overSome",
    apply: "spread",
    assoc: "set",
    assocPath: "set",
    complement: "negate",
    compose: "flowRight",
    contains: "includes",
    dissoc: "unset",
    dissocPath: "unset",
    dropLast: "dropRight",
    dropLastWhile: "dropRightWhile",
    equals: "isEqual",
    identical: "eq",
    indexBy: "keyBy",
    init: "initial",
    invertObj: "invert",
    juxt: "over",
    omitAll: "omit",
    nAry: "ary",
    path: "get",
    pathEq: "matchesProperty",
    pathOr: "getOr",
    paths: "at",
    pickAll: "pick",
    pipe: "flow",
    pluck: "map",
    prop: "get",
    propEq: "matchesProperty",
    propOr: "getOr",
    props: "at",
    symmetricDifference: "xor",
    symmetricDifferenceBy: "xorBy",
    symmetricDifferenceWith: "xorWith",
    takeLast: "takeRight",
    takeLastWhile: "takeRightWhile",
    unapply: "rest",
    unnest: "flatten",
    useWith: "overArgs",
    where: "conformsTo",
    whereEq: "isMatch",
    zipObj: "zipObject"
  }, me.aryMethod = {
    1: [
      "assignAll",
      "assignInAll",
      "attempt",
      "castArray",
      "ceil",
      "create",
      "curry",
      "curryRight",
      "defaultsAll",
      "defaultsDeepAll",
      "floor",
      "flow",
      "flowRight",
      "fromPairs",
      "invert",
      "iteratee",
      "memoize",
      "method",
      "mergeAll",
      "methodOf",
      "mixin",
      "nthArg",
      "over",
      "overEvery",
      "overSome",
      "rest",
      "reverse",
      "round",
      "runInContext",
      "spread",
      "template",
      "trim",
      "trimEnd",
      "trimStart",
      "uniqueId",
      "words",
      "zipAll"
    ],
    2: [
      "add",
      "after",
      "ary",
      "assign",
      "assignAllWith",
      "assignIn",
      "assignInAllWith",
      "at",
      "before",
      "bind",
      "bindAll",
      "bindKey",
      "chunk",
      "cloneDeepWith",
      "cloneWith",
      "concat",
      "conformsTo",
      "countBy",
      "curryN",
      "curryRightN",
      "debounce",
      "defaults",
      "defaultsDeep",
      "defaultTo",
      "delay",
      "difference",
      "divide",
      "drop",
      "dropRight",
      "dropRightWhile",
      "dropWhile",
      "endsWith",
      "eq",
      "every",
      "filter",
      "find",
      "findIndex",
      "findKey",
      "findLast",
      "findLastIndex",
      "findLastKey",
      "flatMap",
      "flatMapDeep",
      "flattenDepth",
      "forEach",
      "forEachRight",
      "forIn",
      "forInRight",
      "forOwn",
      "forOwnRight",
      "get",
      "groupBy",
      "gt",
      "gte",
      "has",
      "hasIn",
      "includes",
      "indexOf",
      "intersection",
      "invertBy",
      "invoke",
      "invokeMap",
      "isEqual",
      "isMatch",
      "join",
      "keyBy",
      "lastIndexOf",
      "lt",
      "lte",
      "map",
      "mapKeys",
      "mapValues",
      "matchesProperty",
      "maxBy",
      "meanBy",
      "merge",
      "mergeAllWith",
      "minBy",
      "multiply",
      "nth",
      "omit",
      "omitBy",
      "overArgs",
      "pad",
      "padEnd",
      "padStart",
      "parseInt",
      "partial",
      "partialRight",
      "partition",
      "pick",
      "pickBy",
      "propertyOf",
      "pull",
      "pullAll",
      "pullAt",
      "random",
      "range",
      "rangeRight",
      "rearg",
      "reject",
      "remove",
      "repeat",
      "restFrom",
      "result",
      "sampleSize",
      "some",
      "sortBy",
      "sortedIndex",
      "sortedIndexOf",
      "sortedLastIndex",
      "sortedLastIndexOf",
      "sortedUniqBy",
      "split",
      "spreadFrom",
      "startsWith",
      "subtract",
      "sumBy",
      "take",
      "takeRight",
      "takeRightWhile",
      "takeWhile",
      "tap",
      "throttle",
      "thru",
      "times",
      "trimChars",
      "trimCharsEnd",
      "trimCharsStart",
      "truncate",
      "union",
      "uniqBy",
      "uniqWith",
      "unset",
      "unzipWith",
      "without",
      "wrap",
      "xor",
      "zip",
      "zipObject",
      "zipObjectDeep"
    ],
    3: [
      "assignInWith",
      "assignWith",
      "clamp",
      "differenceBy",
      "differenceWith",
      "findFrom",
      "findIndexFrom",
      "findLastFrom",
      "findLastIndexFrom",
      "getOr",
      "includesFrom",
      "indexOfFrom",
      "inRange",
      "intersectionBy",
      "intersectionWith",
      "invokeArgs",
      "invokeArgsMap",
      "isEqualWith",
      "isMatchWith",
      "flatMapDepth",
      "lastIndexOfFrom",
      "mergeWith",
      "orderBy",
      "padChars",
      "padCharsEnd",
      "padCharsStart",
      "pullAllBy",
      "pullAllWith",
      "rangeStep",
      "rangeStepRight",
      "reduce",
      "reduceRight",
      "replace",
      "set",
      "slice",
      "sortedIndexBy",
      "sortedLastIndexBy",
      "transform",
      "unionBy",
      "unionWith",
      "update",
      "xorBy",
      "xorWith",
      "zipWith"
    ],
    4: [
      "fill",
      "setWith",
      "updateWith"
    ]
  }, me.aryRearg = {
    2: [1, 0],
    3: [2, 0, 1],
    4: [3, 2, 0, 1]
  }, me.iterateeAry = {
    dropRightWhile: 1,
    dropWhile: 1,
    every: 1,
    filter: 1,
    find: 1,
    findFrom: 1,
    findIndex: 1,
    findIndexFrom: 1,
    findKey: 1,
    findLast: 1,
    findLastFrom: 1,
    findLastIndex: 1,
    findLastIndexFrom: 1,
    findLastKey: 1,
    flatMap: 1,
    flatMapDeep: 1,
    flatMapDepth: 1,
    forEach: 1,
    forEachRight: 1,
    forIn: 1,
    forInRight: 1,
    forOwn: 1,
    forOwnRight: 1,
    map: 1,
    mapKeys: 1,
    mapValues: 1,
    partition: 1,
    reduce: 2,
    reduceRight: 2,
    reject: 1,
    remove: 1,
    some: 1,
    takeRightWhile: 1,
    takeWhile: 1,
    times: 1,
    transform: 2
  }, me.iterateeRearg = {
    mapKeys: [1],
    reduceRight: [1, 0]
  }, me.methodRearg = {
    assignInAllWith: [1, 0],
    assignInWith: [1, 2, 0],
    assignAllWith: [1, 0],
    assignWith: [1, 2, 0],
    differenceBy: [1, 2, 0],
    differenceWith: [1, 2, 0],
    getOr: [2, 1, 0],
    intersectionBy: [1, 2, 0],
    intersectionWith: [1, 2, 0],
    isEqualWith: [1, 2, 0],
    isMatchWith: [2, 1, 0],
    mergeAllWith: [1, 0],
    mergeWith: [1, 2, 0],
    padChars: [2, 1, 0],
    padCharsEnd: [2, 1, 0],
    padCharsStart: [2, 1, 0],
    pullAllBy: [2, 1, 0],
    pullAllWith: [2, 1, 0],
    rangeStep: [1, 2, 0],
    rangeStepRight: [1, 2, 0],
    setWith: [3, 1, 2, 0],
    sortedIndexBy: [2, 1, 0],
    sortedLastIndexBy: [2, 1, 0],
    unionBy: [1, 2, 0],
    unionWith: [1, 2, 0],
    updateWith: [3, 1, 2, 0],
    xorBy: [1, 2, 0],
    xorWith: [1, 2, 0],
    zipWith: [1, 2, 0]
  }, me.methodSpread = {
    assignAll: { start: 0 },
    assignAllWith: { start: 0 },
    assignInAll: { start: 0 },
    assignInAllWith: { start: 0 },
    defaultsAll: { start: 0 },
    defaultsDeepAll: { start: 0 },
    invokeArgs: { start: 2 },
    invokeArgsMap: { start: 2 },
    mergeAll: { start: 0 },
    mergeAllWith: { start: 0 },
    partial: { start: 1 },
    partialRight: { start: 1 },
    without: { start: 1 },
    zipAll: { start: 0 }
  }, me.mutate = {
    array: {
      fill: !0,
      pull: !0,
      pullAll: !0,
      pullAllBy: !0,
      pullAllWith: !0,
      pullAt: !0,
      remove: !0,
      reverse: !0
    },
    object: {
      assign: !0,
      assignAll: !0,
      assignAllWith: !0,
      assignIn: !0,
      assignInAll: !0,
      assignInAllWith: !0,
      assignInWith: !0,
      assignWith: !0,
      defaults: !0,
      defaultsAll: !0,
      defaultsDeep: !0,
      defaultsDeepAll: !0,
      merge: !0,
      mergeAll: !0,
      mergeAllWith: !0,
      mergeWith: !0
    },
    set: {
      set: !0,
      setWith: !0,
      unset: !0,
      update: !0,
      updateWith: !0
    }
  }, me.realToAlias = function() {
    var ue = Object.prototype.hasOwnProperty, Qe = me.aliasToReal, Ue = {};
    for (var He in Qe) {
      var Ge = Qe[He];
      ue.call(Ue, Ge) ? Ue[Ge].push(He) : Ue[Ge] = [He];
    }
    return Ue;
  }(), me.remap = {
    assignAll: "assign",
    assignAllWith: "assignWith",
    assignInAll: "assignIn",
    assignInAllWith: "assignInWith",
    curryN: "curry",
    curryRightN: "curryRight",
    defaultsAll: "defaults",
    defaultsDeepAll: "defaultsDeep",
    findFrom: "find",
    findIndexFrom: "findIndex",
    findLastFrom: "findLast",
    findLastIndexFrom: "findLastIndex",
    getOr: "get",
    includesFrom: "includes",
    indexOfFrom: "indexOf",
    invokeArgs: "invoke",
    invokeArgsMap: "invokeMap",
    lastIndexOfFrom: "lastIndexOf",
    mergeAll: "merge",
    mergeAllWith: "mergeWith",
    padChars: "pad",
    padCharsEnd: "padEnd",
    padCharsStart: "padStart",
    propertyOf: "get",
    rangeStep: "range",
    rangeStepRight: "rangeRight",
    restFrom: "rest",
    spreadFrom: "spread",
    trimChars: "trim",
    trimCharsEnd: "trimEnd",
    trimCharsStart: "trimStart",
    zipAll: "zip"
  }, me.skipFixed = {
    castArray: !0,
    flow: !0,
    flowRight: !0,
    iteratee: !0,
    mixin: !0,
    rearg: !0,
    runInContext: !0
  }, me.skipRearg = {
    add: !0,
    assign: !0,
    assignIn: !0,
    bind: !0,
    bindKey: !0,
    concat: !0,
    difference: !0,
    divide: !0,
    eq: !0,
    gt: !0,
    gte: !0,
    isEqual: !0,
    lt: !0,
    lte: !0,
    matchesProperty: !0,
    merge: !0,
    multiply: !0,
    overArgs: !0,
    partial: !0,
    partialRight: !0,
    propertyOf: !0,
    random: !0,
    range: !0,
    rangeRight: !0,
    subtract: !0,
    zip: !0,
    zipObject: !0,
    zipObjectDeep: !0
  };
})(_mapping);
var placeholder = {}, mapping = _mapping, fallbackHolder = placeholder, push$1 = Array.prototype.push;
function baseArity(me, ue) {
  return ue == 2 ? function(Qe, Ue) {
    return me.apply(void 0, arguments);
  } : function(Qe) {
    return me.apply(void 0, arguments);
  };
}
function baseAry(me, ue) {
  return ue == 2 ? function(Qe, Ue) {
    return me(Qe, Ue);
  } : function(Qe) {
    return me(Qe);
  };
}
function cloneArray(me) {
  for (var ue = me ? me.length : 0, Qe = Array(ue); ue--; )
    Qe[ue] = me[ue];
  return Qe;
}
function createCloner(me) {
  return function(ue) {
    return me({}, ue);
  };
}
function flatSpread(me, ue) {
  return function() {
    for (var Qe = arguments.length, Ue = Qe - 1, He = Array(Qe); Qe--; )
      He[Qe] = arguments[Qe];
    var Ge = He[ue], Xe = He.slice(0, ue);
    return Ge && push$1.apply(Xe, Ge), ue != Ue && push$1.apply(Xe, He.slice(ue + 1)), me.apply(this, Xe);
  };
}
function wrapImmutable(me, ue) {
  return function() {
    var Qe = arguments.length;
    if (Qe) {
      for (var Ue = Array(Qe); Qe--; )
        Ue[Qe] = arguments[Qe];
      var He = Ue[0] = ue.apply(void 0, Ue);
      return me.apply(void 0, Ue), He;
    }
  };
}
function baseConvert(me, ue, Qe, Ue) {
  var He = typeof ue == "function", Ge = ue === Object(ue);
  if (Ge && (Ue = Qe, Qe = ue, ue = void 0), Qe == null)
    throw new TypeError();
  Ue || (Ue = {});
  var Xe = {
    cap: "cap" in Ue ? Ue.cap : !0,
    curry: "curry" in Ue ? Ue.curry : !0,
    fixed: "fixed" in Ue ? Ue.fixed : !0,
    immutable: "immutable" in Ue ? Ue.immutable : !0,
    rearg: "rearg" in Ue ? Ue.rearg : !0
  }, Ke = He ? Qe : fallbackHolder, $e = "curry" in Ue && Ue.curry, Je = "fixed" in Ue && Ue.fixed, Ze = "rearg" in Ue && Ue.rearg, nt = He ? Qe.runInContext() : void 0, tt = He ? Qe : {
    ary: me.ary,
    assign: me.assign,
    clone: me.clone,
    curry: me.curry,
    forEach: me.forEach,
    isArray: me.isArray,
    isError: me.isError,
    isFunction: me.isFunction,
    isWeakMap: me.isWeakMap,
    iteratee: me.iteratee,
    keys: me.keys,
    rearg: me.rearg,
    toInteger: me.toInteger,
    toPath: me.toPath
  }, et = tt.ary, rt = tt.assign, it = tt.clone, ot = tt.curry, at = tt.forEach, st = tt.isArray, ut = tt.isError, lt = tt.isFunction, dt = tt.isWeakMap, At = tt.keys, pt = tt.rearg, gt = tt.toInteger, wt = tt.toPath, Bt = At(mapping.aryMethod), Tt = {
    castArray: function(qt) {
      return function() {
        var _t = arguments[0];
        return st(_t) ? qt(cloneArray(_t)) : qt.apply(void 0, arguments);
      };
    },
    iteratee: function(qt) {
      return function() {
        var _t = arguments[0], Yt = arguments[1], Xt = qt(_t, Yt), Ut = Xt.length;
        return Xe.cap && typeof Yt == "number" ? (Yt = Yt > 2 ? Yt - 2 : 1, Ut && Ut <= Yt ? Xt : baseAry(Xt, Yt)) : Xt;
      };
    },
    mixin: function(qt) {
      return function(_t) {
        var Yt = this;
        if (!lt(Yt))
          return qt(Yt, Object(_t));
        var Xt = [];
        return at(At(_t), function(Ut) {
          lt(_t[Ut]) && Xt.push([Ut, Yt.prototype[Ut]]);
        }), qt(Yt, Object(_t)), at(Xt, function(Ut) {
          var Lt = Ut[1];
          lt(Lt) ? Yt.prototype[Ut[0]] = Lt : delete Yt.prototype[Ut[0]];
        }), Yt;
      };
    },
    nthArg: function(qt) {
      return function(_t) {
        var Yt = _t < 0 ? 1 : gt(_t) + 1;
        return ot(qt(_t), Yt);
      };
    },
    rearg: function(qt) {
      return function(_t, Yt) {
        var Xt = Yt ? Yt.length : 0;
        return ot(qt(_t, Yt), Xt);
      };
    },
    runInContext: function(qt) {
      return function(_t) {
        return baseConvert(me, qt(_t), Ue);
      };
    }
  };
  function yt(qt, _t) {
    if (Xe.cap) {
      var Yt = mapping.iterateeRearg[qt];
      if (Yt)
        return St(_t, Yt);
      var Xt = !He && mapping.iterateeAry[qt];
      if (Xt)
        return Rt(_t, Xt);
    }
    return _t;
  }
  function Ct(qt, _t, Yt) {
    return $e || Xe.curry && Yt > 1 ? ot(_t, Yt) : _t;
  }
  function ht(qt, _t, Yt) {
    if (Xe.fixed && (Je || !mapping.skipFixed[qt])) {
      var Xt = mapping.methodSpread[qt], Ut = Xt && Xt.start;
      return Ut === void 0 ? et(_t, Yt) : flatSpread(_t, Ut);
    }
    return _t;
  }
  function It(qt, _t, Yt) {
    return Xe.rearg && Yt > 1 && (Ze || !mapping.skipRearg[qt]) ? pt(_t, mapping.methodRearg[qt] || mapping.aryRearg[Yt]) : _t;
  }
  function vt(qt, _t) {
    _t = wt(_t);
    for (var Yt = -1, Xt = _t.length, Ut = Xt - 1, Lt = it(Object(qt)), Ot = Lt; Ot != null && ++Yt < Xt; ) {
      var ft = _t[Yt], Dt = Ot[ft];
      Dt != null && !(lt(Dt) || ut(Dt) || dt(Dt)) && (Ot[ft] = it(Yt == Ut ? Dt : Object(Dt))), Ot = Ot[ft];
    }
    return Lt;
  }
  function Et(qt) {
    return Pt.runInContext.convert(qt)(void 0);
  }
  function bt(qt, _t) {
    var Yt = mapping.aliasToReal[qt] || qt, Xt = mapping.remap[Yt] || Yt, Ut = Ue;
    return function(Lt) {
      var Ot = He ? nt : tt, ft = He ? nt[Xt] : _t, Dt = rt(rt({}, Ut), Lt);
      return baseConvert(Ot, Yt, ft, Dt);
    };
  }
  function Rt(qt, _t) {
    return kt(qt, function(Yt) {
      return typeof Yt == "function" ? baseAry(Yt, _t) : Yt;
    });
  }
  function St(qt, _t) {
    return kt(qt, function(Yt) {
      var Xt = _t.length;
      return baseArity(pt(baseAry(Yt, Xt), _t), Xt);
    });
  }
  function kt(qt, _t) {
    return function() {
      var Yt = arguments.length;
      if (!Yt)
        return qt();
      for (var Xt = Array(Yt); Yt--; )
        Xt[Yt] = arguments[Yt];
      var Ut = Xe.rearg ? 0 : Yt - 1;
      return Xt[Ut] = _t(Xt[Ut]), qt.apply(void 0, Xt);
    };
  }
  function jt(qt, _t, Yt) {
    var Xt, Ut = mapping.aliasToReal[qt] || qt, Lt = _t, Ot = Tt[Ut];
    return Ot ? Lt = Ot(_t) : Xe.immutable && (mapping.mutate.array[Ut] ? Lt = wrapImmutable(_t, cloneArray) : mapping.mutate.object[Ut] ? Lt = wrapImmutable(_t, createCloner(_t)) : mapping.mutate.set[Ut] && (Lt = wrapImmutable(_t, vt))), at(Bt, function(ft) {
      return at(mapping.aryMethod[ft], function(Dt) {
        if (Ut == Dt) {
          var Mt = mapping.methodSpread[Ut], Ft = Mt && Mt.afterRearg;
          return Xt = Ft ? ht(Ut, It(Ut, Lt, ft), ft) : It(Ut, ht(Ut, Lt, ft), ft), Xt = yt(Ut, Xt), Xt = Ct(Ut, Xt, ft), !1;
        }
      }), !Xt;
    }), Xt || (Xt = Lt), Xt == _t && (Xt = $e ? ot(Xt, 1) : function() {
      return _t.apply(this, arguments);
    }), Xt.convert = bt(Ut, _t), Xt.placeholder = _t.placeholder = Yt, Xt;
  }
  if (!Ge)
    return jt(ue, Qe, Ke);
  var Pt = Qe, Qt = [];
  return at(Bt, function(qt) {
    at(mapping.aryMethod[qt], function(_t) {
      var Yt = Pt[mapping.remap[_t] || _t];
      Yt && Qt.push([_t, jt(_t, Yt, Pt)]);
    });
  }), at(At(Pt), function(qt) {
    var _t = Pt[qt];
    if (typeof _t == "function") {
      for (var Yt = Qt.length; Yt--; )
        if (Qt[Yt][0] == qt)
          return;
      _t.convert = bt(qt, _t), Qt.push([qt, _t]);
    }
  }), at(Qt, function(qt) {
    Pt[qt[0]] = qt[1];
  }), Pt.convert = Et, Pt.placeholder = Pt, at(At(Pt), function(qt) {
    at(mapping.realToAlias[qt] || [], function(_t) {
      Pt[_t] = Pt[qt];
    });
  }), Pt;
}
var _baseConvert = baseConvert, _$1 = lodash_minExports.runInContext(), fp = _baseConvert(_$1, _$1), rngBrowser = { exports: {} }, getRandomValues$1 = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if (getRandomValues$1) {
  var rnds8$1 = new Uint8Array(16);
  rngBrowser.exports = function() {
    return getRandomValues$1(rnds8$1), rnds8$1;
  };
} else {
  var rnds = new Array(16);
  rngBrowser.exports = function() {
    for (var ue = 0, Qe; ue < 16; ue++)
      ue & 3 || (Qe = Math.random() * 4294967296), rnds[ue] = Qe >>> ((ue & 3) << 3) & 255;
    return rnds;
  };
}
var rngBrowserExports = rngBrowser.exports, byteToHex$1 = [];
for (var i$3 = 0; i$3 < 256; ++i$3)
  byteToHex$1[i$3] = (i$3 + 256).toString(16).substr(1);
function bytesToUuid$2(me, ue) {
  var Qe = ue || 0, Ue = byteToHex$1;
  return [
    Ue[me[Qe++]],
    Ue[me[Qe++]],
    Ue[me[Qe++]],
    Ue[me[Qe++]],
    "-",
    Ue[me[Qe++]],
    Ue[me[Qe++]],
    "-",
    Ue[me[Qe++]],
    Ue[me[Qe++]],
    "-",
    Ue[me[Qe++]],
    Ue[me[Qe++]],
    "-",
    Ue[me[Qe++]],
    Ue[me[Qe++]],
    Ue[me[Qe++]],
    Ue[me[Qe++]],
    Ue[me[Qe++]],
    Ue[me[Qe++]]
  ].join("");
}
var bytesToUuid_1 = bytesToUuid$2, rng$3 = rngBrowserExports, bytesToUuid$1 = bytesToUuid_1, _nodeId$1, _clockseq$1, _lastMSecs$1 = 0, _lastNSecs$1 = 0;
function v1$3(me, ue, Qe) {
  var Ue = ue && Qe || 0, He = ue || [];
  me = me || {};
  var Ge = me.node || _nodeId$1, Xe = me.clockseq !== void 0 ? me.clockseq : _clockseq$1;
  if (Ge == null || Xe == null) {
    var Ke = rng$3();
    Ge == null && (Ge = _nodeId$1 = [
      Ke[0] | 1,
      Ke[1],
      Ke[2],
      Ke[3],
      Ke[4],
      Ke[5]
    ]), Xe == null && (Xe = _clockseq$1 = (Ke[6] << 8 | Ke[7]) & 16383);
  }
  var $e = me.msecs !== void 0 ? me.msecs : (/* @__PURE__ */ new Date()).getTime(), Je = me.nsecs !== void 0 ? me.nsecs : _lastNSecs$1 + 1, Ze = $e - _lastMSecs$1 + (Je - _lastNSecs$1) / 1e4;
  if (Ze < 0 && me.clockseq === void 0 && (Xe = Xe + 1 & 16383), (Ze < 0 || $e > _lastMSecs$1) && me.nsecs === void 0 && (Je = 0), Je >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  _lastMSecs$1 = $e, _lastNSecs$1 = Je, _clockseq$1 = Xe, $e += 122192928e5;
  var nt = (($e & 268435455) * 1e4 + Je) % 4294967296;
  He[Ue++] = nt >>> 24 & 255, He[Ue++] = nt >>> 16 & 255, He[Ue++] = nt >>> 8 & 255, He[Ue++] = nt & 255;
  var tt = $e / 4294967296 * 1e4 & 268435455;
  He[Ue++] = tt >>> 8 & 255, He[Ue++] = tt & 255, He[Ue++] = tt >>> 24 & 15 | 16, He[Ue++] = tt >>> 16 & 255, He[Ue++] = Xe >>> 8 | 128, He[Ue++] = Xe & 255;
  for (var et = 0; et < 6; ++et)
    He[Ue + et] = Ge[et];
  return ue || bytesToUuid$1(He);
}
var v1_1 = v1$3, rng$2 = rngBrowserExports, bytesToUuid = bytesToUuid_1;
function v4$3(me, ue, Qe) {
  var Ue = ue && Qe || 0;
  typeof me == "string" && (ue = me === "binary" ? new Array(16) : null, me = null), me = me || {};
  var He = me.random || (me.rng || rng$2)();
  if (He[6] = He[6] & 15 | 64, He[8] = He[8] & 63 | 128, ue)
    for (var Ge = 0; Ge < 16; ++Ge)
      ue[Ue + Ge] = He[Ge];
  return ue || bytesToUuid(He);
}
var v4_1 = v4$3, v1$2 = v1_1, v4$2 = v4_1, uuid = v4$2;
uuid.v1 = v1$2;
uuid.v4 = v4$2;
var uuid_1$2 = uuid;
const uuid$1 = /* @__PURE__ */ getDefaultExportFromCjs(uuid_1$2);
Object.defineProperty(OTPublisher$4, "__esModule", {
  value: !0
});
var _typeof$4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(me) {
  return typeof me;
} : function(me) {
  return me && typeof Symbol == "function" && me.constructor === Symbol && me !== Symbol.prototype ? "symbol" : typeof me;
}, _createClass$8 = /* @__PURE__ */ function() {
  function me(ue, Qe) {
    for (var Ue = 0; Ue < Qe.length; Ue++) {
      var He = Qe[Ue];
      He.enumerable = He.enumerable || !1, He.configurable = !0, "value" in He && (He.writable = !0), Object.defineProperty(ue, He.key, He);
    }
  }
  return function(ue, Qe, Ue) {
    return Qe && me(ue.prototype, Qe), Ue && me(ue, Ue), ue;
  };
}(), _react$c = React__default, _react2$c = _interopRequireDefault$n(_react$c), _propTypes$c = propTypesExports, _propTypes2$c = _interopRequireDefault$n(_propTypes$c), _once$1 = once_1, _once2$1 = _interopRequireDefault$n(_once$1), _fp$1 = fp, _uuid$3 = uuid_1$2, _uuid2$3 = _interopRequireDefault$n(_uuid$3);
function _interopRequireDefault$n(me) {
  return me && me.__esModule ? me : { default: me };
}
function _classCallCheck$8(me, ue) {
  if (!(me instanceof ue))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$8(me, ue) {
  if (!me)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return ue && (typeof ue == "object" || typeof ue == "function") ? ue : me;
}
function _inherits$8(me, ue) {
  if (typeof ue != "function" && ue !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof ue);
  me.prototype = Object.create(ue && ue.prototype, { constructor: { value: me, enumerable: !1, writable: !0, configurable: !0 } }), ue && (Object.setPrototypeOf ? Object.setPrototypeOf(me, ue) : me.__proto__ = ue);
}
var OTPublisher$3 = function(me) {
  _inherits$8(ue, me);
  function ue(Qe, Ue) {
    _classCallCheck$8(this, ue);
    var He = _possibleConstructorReturn$8(this, (ue.__proto__ || Object.getPrototypeOf(ue)).call(this, Qe));
    return He.sessionConnectedHandler = function() {
      He.publishToSession(He.state.publisher);
    }, He.streamCreatedHandler = function(Ge) {
      He.setState({ lastStreamId: Ge.stream.id });
    }, He.state = {
      publisher: null,
      lastStreamId: "",
      session: Qe.session || Ue.session || null
    }, He;
  }
  return _createClass$8(ue, [{
    key: "componentDidMount",
    value: function() {
      this.createPublisher();
    }
  }, {
    key: "componentDidUpdate",
    value: function(Ue, He) {
      var Ge = this, Xe = function(Ze, nt) {
        return Ze === void 0 ? nt : Ze;
      }, Ke = function(Ze, nt) {
        var tt = Xe(Ue.properties[Ze], nt), et = Xe(Ge.props.properties[Ze], nt);
        return tt !== et;
      }, $e = function(Ze, nt) {
        if (Ke(Ze, nt)) {
          var tt = Xe(Ge.props.properties[Ze], nt);
          Ge.state.publisher[Ze](tt);
        }
      };
      if (Ke("videoSource", void 0)) {
        this.destroyPublisher(), this.createPublisher();
        return;
      }
      $e("publishAudio", !0), $e("publishVideo", !0), this.state.session !== He.session && (this.destroyPublisher(He.session), this.createPublisher());
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.state.session && this.state.session.off("sessionConnected", this.sessionConnectedHandler), this.destroyPublisher();
    }
  }, {
    key: "getPublisher",
    value: function() {
      return this.state.publisher;
    }
  }, {
    key: "destroyPublisher",
    value: function() {
      var Ue = this, He = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.state.session;
      delete this.publisherId, this.state.publisher && (this.state.publisher.off("streamCreated", this.streamCreatedHandler), this.props.eventHandlers && _typeof$4(this.props.eventHandlers) === "object" && this.state.publisher.once("destroyed", function() {
        Ue.state.publisher.off(Ue.props.eventHandlers);
      }), He && He.unpublish(this.state.publisher), this.state.publisher.destroy());
    }
  }, {
    key: "publishToSession",
    value: function(Ue) {
      var He = this, Ge = this.publisherId;
      this.state.session.publish(Ue, function(Xe) {
        Ge === He.publisherId && (Xe ? He.errorHandler(Xe) : typeof He.props.onPublish == "function" && He.props.onPublish());
      });
    }
  }, {
    key: "createPublisher",
    value: function() {
      var Ue = this;
      if (!this.state.session) {
        this.setState({ publisher: null, lastStreamId: "" });
        return;
      }
      var He = this.props.properties || {}, Ge = void 0;
      He.insertDefaultUI !== !1 && (Ge = document.createElement("div"), Ge.setAttribute("class", "OTPublisherContainer"), this.node.appendChild(Ge)), this.publisherId = (0, _uuid2$3.default)();
      var Xe = this.publisherId;
      this.errorHandler = (0, _once2$1.default)(function(Je) {
        Xe === Ue.publisherId && typeof Ue.props.onError == "function" && Ue.props.onError(Je);
      });
      var Ke = OT.initPublisher(Ge, He, function(Je) {
        Xe === Ue.publisherId && (Je ? Ue.errorHandler(Je) : typeof Ue.props.onInit == "function" && Ue.props.onInit());
      });
      if (Ke.on("streamCreated", this.streamCreatedHandler), this.props.eventHandlers && _typeof$4(this.props.eventHandlers) === "object") {
        var $e = (0, _fp$1.omitBy)(_fp$1.isNil)(this.props.eventHandlers);
        Ke.on($e);
      }
      this.state.session.connection ? this.publishToSession(Ke) : this.state.session.once("sessionConnected", this.sessionConnectedHandler), this.setState({ publisher: Ke, lastStreamId: "" });
    }
  }, {
    key: "render",
    value: function() {
      var Ue = this, He = this.props, Ge = He.className, Xe = He.style;
      return _react2$c.default.createElement("div", { className: Ge, style: Xe, ref: function($e) {
        Ue.node = $e;
      } });
    }
  }]), ue;
}(_react$c.Component);
OTPublisher$4.default = OTPublisher$3;
OTPublisher$3.propTypes = {
  session: _propTypes2$c.default.shape({
    connection: _propTypes2$c.default.shape({
      connectionId: _propTypes2$c.default.string
    }),
    once: _propTypes2$c.default.func,
    off: _propTypes2$c.default.func,
    publish: _propTypes2$c.default.func,
    unpublish: _propTypes2$c.default.func
  }),
  className: _propTypes2$c.default.string,
  style: _propTypes2$c.default.object,
  // eslint-disable-line react/forbid-prop-types
  properties: _propTypes2$c.default.object,
  // eslint-disable-line react/forbid-prop-types
  eventHandlers: _propTypes2$c.default.objectOf(_propTypes2$c.default.func),
  onInit: _propTypes2$c.default.func,
  onPublish: _propTypes2$c.default.func,
  onError: _propTypes2$c.default.func
};
OTPublisher$3.defaultProps = {
  session: null,
  className: "",
  style: {},
  properties: {},
  eventHandlers: null,
  onInit: null,
  onPublish: null,
  onError: null
};
OTPublisher$3.contextTypes = {
  session: _propTypes2$c.default.shape({
    connection: _propTypes2$c.default.shape({
      connectionId: _propTypes2$c.default.string
    }),
    once: _propTypes2$c.default.func,
    off: _propTypes2$c.default.func,
    publish: _propTypes2$c.default.func,
    unpublish: _propTypes2$c.default.func
  })
};
var OTStreams$4 = {}, OTSubscriberContext$4 = {};
Object.defineProperty(OTSubscriberContext$4, "__esModule", {
  value: !0
});
var _createClass$7 = /* @__PURE__ */ function() {
  function me(ue, Qe) {
    for (var Ue = 0; Ue < Qe.length; Ue++) {
      var He = Qe[Ue];
      He.enumerable = He.enumerable || !1, He.configurable = !0, "value" in He && (He.writable = !0), Object.defineProperty(ue, He.key, He);
    }
  }
  return function(ue, Qe, Ue) {
    return Qe && me(ue.prototype, Qe), Ue && me(ue, Ue), ue;
  };
}(), _react$b = React__default, _react2$b = _interopRequireDefault$m(_react$b), _propTypes$b = propTypesExports, _propTypes2$b = _interopRequireDefault$m(_propTypes$b);
function _interopRequireDefault$m(me) {
  return me && me.__esModule ? me : { default: me };
}
function _classCallCheck$7(me, ue) {
  if (!(me instanceof ue))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$7(me, ue) {
  if (!me)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return ue && (typeof ue == "object" || typeof ue == "function") ? ue : me;
}
function _inherits$7(me, ue) {
  if (typeof ue != "function" && ue !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof ue);
  me.prototype = Object.create(ue && ue.prototype, { constructor: { value: me, enumerable: !1, writable: !0, configurable: !0 } }), ue && (Object.setPrototypeOf ? Object.setPrototypeOf(me, ue) : me.__proto__ = ue);
}
var OTSubscriberContext$3 = function(me) {
  _inherits$7(ue, me);
  function ue() {
    return _classCallCheck$7(this, ue), _possibleConstructorReturn$7(this, (ue.__proto__ || Object.getPrototypeOf(ue)).apply(this, arguments));
  }
  return _createClass$7(ue, [{
    key: "getChildContext",
    value: function() {
      return { stream: this.props.stream };
    }
  }, {
    key: "render",
    value: function() {
      return _react2$b.default.createElement(
        _react$b.Fragment,
        null,
        this.props.children
      );
    }
  }]), ue;
}(_react$b.Component);
OTSubscriberContext$4.default = OTSubscriberContext$3;
OTSubscriberContext$3.propTypes = {
  children: _propTypes2$b.default.element.isRequired,
  stream: _propTypes2$b.default.shape({
    streamId: _propTypes2$b.default.string
  }).isRequired
};
OTSubscriberContext$3.childContextTypes = {
  stream: _propTypes2$b.default.shape({
    streamId: _propTypes2$b.default.string
  })
};
Object.defineProperty(OTStreams$4, "__esModule", {
  value: !0
});
OTStreams$4.default = OTStreams$3;
var _react$a = React__default, _react2$a = _interopRequireDefault$l(_react$a), _propTypes$a = propTypesExports, _propTypes2$a = _interopRequireDefault$l(_propTypes$a), _OTSubscriberContext$1 = OTSubscriberContext$4, _OTSubscriberContext2$1 = _interopRequireDefault$l(_OTSubscriberContext$1);
function _interopRequireDefault$l(me) {
  return me && me.__esModule ? me : { default: me };
}
function OTStreams$3(me, ue) {
  var Qe = me.session || ue.session || null, Ue = me.streams || ue.streams || null;
  if (!Qe)
    return null;
  var He = _react$a.Children.only(me.children);
  console.log(me.loading, "uwu");
  var Ge = Array.isArray(Ue) && Ue.length > 0 ? Ue.map(function(Xe) {
    return _react2$a.default.createElement(
      _OTSubscriberContext2$1.default,
      { stream: Xe, key: Xe.id },
      (0, _react$a.cloneElement)(He)
    );
  }) : me.loading;
  return _react2$a.default.createElement(
    _react$a.Fragment,
    null,
    Ge
  );
}
OTStreams$3.propTypes = {
  children: _propTypes2$a.default.element.isRequired,
  session: _propTypes2$a.default.shape({
    publish: _propTypes2$a.default.func,
    subscribe: _propTypes2$a.default.func
  }),
  streams: _propTypes2$a.default.arrayOf(_propTypes2$a.default.object)
};
OTStreams$3.defaultProps = {
  session: null,
  streams: null,
  loading: null
};
OTStreams$3.contextTypes = {
  session: _propTypes2$a.default.shape({
    publish: _propTypes2$a.default.func,
    subscribe: _propTypes2$a.default.func
  }),
  streams: _propTypes2$a.default.arrayOf(_propTypes2$a.default.object),
  loading: _propTypes2$a.default.element
};
var OTSubscriber$4 = {};
Object.defineProperty(OTSubscriber$4, "__esModule", {
  value: !0
});
var _typeof$3 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(me) {
  return typeof me;
} : function(me) {
  return me && typeof Symbol == "function" && me.constructor === Symbol && me !== Symbol.prototype ? "symbol" : typeof me;
}, _createClass$6 = /* @__PURE__ */ function() {
  function me(ue, Qe) {
    for (var Ue = 0; Ue < Qe.length; Ue++) {
      var He = Qe[Ue];
      He.enumerable = He.enumerable || !1, He.configurable = !0, "value" in He && (He.writable = !0), Object.defineProperty(ue, He.key, He);
    }
  }
  return function(ue, Qe, Ue) {
    return Qe && me(ue.prototype, Qe), Ue && me(ue, Ue), ue;
  };
}(), _react$9 = React__default, _react2$9 = _interopRequireDefault$k(_react$9), _propTypes$9 = propTypesExports, _propTypes2$9 = _interopRequireDefault$k(_propTypes$9), _uuid$2 = uuid_1$2, _uuid2$2 = _interopRequireDefault$k(_uuid$2);
function _interopRequireDefault$k(me) {
  return me && me.__esModule ? me : { default: me };
}
function _classCallCheck$6(me, ue) {
  if (!(me instanceof ue))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$6(me, ue) {
  if (!me)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return ue && (typeof ue == "object" || typeof ue == "function") ? ue : me;
}
function _inherits$6(me, ue) {
  if (typeof ue != "function" && ue !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof ue);
  me.prototype = Object.create(ue && ue.prototype, { constructor: { value: me, enumerable: !1, writable: !0, configurable: !0 } }), ue && (Object.setPrototypeOf ? Object.setPrototypeOf(me, ue) : me.__proto__ = ue);
}
var OTSubscriber$3 = function(me) {
  _inherits$6(ue, me);
  function ue(Qe, Ue) {
    _classCallCheck$6(this, ue);
    var He = _possibleConstructorReturn$6(this, (ue.__proto__ || Object.getPrototypeOf(ue)).call(this, Qe));
    return He.state = {
      subscriber: null,
      stream: Qe.stream || Ue.stream || null,
      session: Qe.session || Ue.session || null,
      currentRetryAttempt: 0
    }, He.maxRetryAttempts = Qe.maxRetryAttempts || 5, He.retryAttemptTimeout = Qe.retryAttemptTimeout || 1e3, He;
  }
  return _createClass$6(ue, [{
    key: "componentDidMount",
    value: function() {
      this.createSubscriber();
    }
  }, {
    key: "componentDidUpdate",
    value: function(Ue, He) {
      var Ge = this, Xe = function(Je, Ze, nt) {
        return Je === void 0 ? nt : Ze(Je);
      }, Ke = function(Je) {
        var Ze = Xe(Ue.properties[Je], Boolean, !0), nt = Xe(Ge.props.properties[Je], Boolean, !0);
        Ze !== nt && Ge.state.subscriber[Je](nt);
      };
      Ke("subscribeToAudio"), Ke("subscribeToVideo"), (He.session !== this.state.session || He.stream !== this.state.stream) && (this.destroySubscriber(He.session), this.createSubscriber());
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.destroySubscriber();
    }
  }, {
    key: "getSubscriber",
    value: function() {
      return this.state.subscriber;
    }
  }, {
    key: "createSubscriber",
    value: function() {
      var Ue = this;
      if (!this.state.session || !this.state.stream) {
        this.setState({ subscriber: null });
        return;
      }
      var He = this.props.properties || {}, Ge = void 0;
      He.insertDefaultUI !== !1 && (Ge = document.createElement("div"), Ge.setAttribute("class", "OTSubscriberContainer"), this.node.appendChild(Ge)), this.subscriberId = (0, _uuid2$2.default)();
      var Xe = this.subscriberId, Ke = this.state.session.subscribe(this.state.stream, Ge, this.props.properties, function($e) {
        Xe === Ue.subscriberId && ($e && Ue.props.retry && Ue.state.currentRetryAttempt < Ue.maxRetryAttempts - 1 && Ue.handleRetrySubscriber(), $e && typeof Ue.props.onError == "function" ? Ue.props.onError($e) : !$e && typeof Ue.props.onSubscribe == "function" && Ue.props.onSubscribe());
      });
      this.props.eventHandlers && _typeof$3(this.props.eventHandlers) === "object" && Ke.on(this.props.eventHandlers), this.setState({ subscriber: Ke });
    }
  }, {
    key: "handleRetrySubscriber",
    value: function() {
      var Ue = this;
      setTimeout(function() {
        Ue.setState(function(He) {
          return {
            currentRetryAttempt: He.currentRetryAttempt + 1,
            subscriber: null
          };
        }), Ue.createSubscriber();
      }, this.retryAttemptTimeout);
    }
  }, {
    key: "destroySubscriber",
    value: function() {
      var Ue = this, He = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props.session;
      delete this.subscriberId, this.state.subscriber && (this.props.eventHandlers && _typeof$3(this.props.eventHandlers) === "object" && this.state.subscriber.once("destroyed", function() {
        Ue.state.subscriber.off(Ue.props.eventHandlers);
      }), He && He.unsubscribe(this.state.subscriber));
    }
  }, {
    key: "render",
    value: function() {
      var Ue = this, He = this.props, Ge = He.className, Xe = He.style;
      return _react2$9.default.createElement("div", { className: Ge, style: Xe, ref: function($e) {
        Ue.node = $e;
      } });
    }
  }]), ue;
}(_react$9.Component);
OTSubscriber$4.default = OTSubscriber$3;
OTSubscriber$3.propTypes = {
  stream: _propTypes2$9.default.shape({
    streamId: _propTypes2$9.default.string
  }),
  session: _propTypes2$9.default.shape({
    subscribe: _propTypes2$9.default.func,
    unsubscribe: _propTypes2$9.default.func
  }),
  className: _propTypes2$9.default.string,
  style: _propTypes2$9.default.object,
  // eslint-disable-line react/forbid-prop-types
  properties: _propTypes2$9.default.object,
  // eslint-disable-line react/forbid-prop-types
  retry: _propTypes2$9.default.bool,
  maxRetryAttempts: _propTypes2$9.default.number,
  retryAttemptTimeout: _propTypes2$9.default.number,
  eventHandlers: _propTypes2$9.default.objectOf(_propTypes2$9.default.func),
  onSubscribe: _propTypes2$9.default.func,
  onError: _propTypes2$9.default.func
};
OTSubscriber$3.defaultProps = {
  stream: null,
  session: null,
  className: "",
  style: {},
  properties: {},
  retry: !1,
  maxRetryAttempts: 5,
  retryAttemptTimeout: 1e3,
  eventHandlers: null,
  onSubscribe: null,
  onError: null
};
OTSubscriber$3.contextTypes = {
  stream: _propTypes2$9.default.shape({
    streamId: _propTypes2$9.default.string
  }),
  session: _propTypes2$9.default.shape({
    subscribe: _propTypes2$9.default.func,
    unsubscribe: _propTypes2$9.default.func
  })
};
var preloadScript$6 = {}, getDisplayName$1 = {};
Object.defineProperty(getDisplayName$1, "__esModule", {
  value: !0
});
var _default$f = getDisplayName$1.default = getDisplayName;
function getDisplayName(me) {
  return me.displayName || me.name || (typeof me == "string" && me.length > 0 ? me : "Unknown");
}
var script = { exports: {} };
/*!
  * $script.js JS loader & dependency manager
  * https://github.com/ded/script.js
  * (c) Dustin Diaz 2014 | License MIT
  */
(function(me) {
  (function(ue, Qe) {
    me.exports ? me.exports = Qe() : this[ue] = Qe();
  })("$script", function() {
    var ue = document, Qe = ue.getElementsByTagName("head")[0], Ue = !1, He = "push", Ge = "readyState", Xe = "onreadystatechange", Ke = {}, $e = {}, Je = {}, Ze, nt;
    function tt(ot, at) {
      for (var st = 0, ut = ot.length; st < ut; ++st) if (!at(ot[st])) return Ue;
      return 1;
    }
    function et(ot, at) {
      tt(ot, function(st) {
        return at(st), 1;
      });
    }
    function rt(ot, at, st) {
      ot = ot[He] ? ot : [ot];
      var ut = at && at.call, lt = ut ? at : st, dt = ut ? ot.join("") : at, At = ot.length;
      function pt(wt) {
        return wt.call ? wt() : Ke[wt];
      }
      function gt() {
        if (!--At) {
          Ke[dt] = 1, lt && lt();
          for (var wt in $e)
            tt(wt.split("|"), pt) && !et($e[wt], pt) && ($e[wt] = []);
        }
      }
      return setTimeout(function() {
        et(ot, function wt(Bt, Tt) {
          if (Bt === null) return gt();
          if (!Tt && !/^https?:\/\//.test(Bt) && Ze && (Bt = Bt.indexOf(".js") === -1 ? Ze + Bt + ".js" : Ze + Bt), Je[Bt])
            return Je[Bt] == 2 ? gt() : setTimeout(function() {
              wt(Bt, !0);
            }, 0);
          Je[Bt] = 1, it(Bt, gt);
        });
      }, 0), rt;
    }
    function it(ot, at) {
      var st = ue.createElement("script"), ut;
      st.onload = st.onerror = st[Xe] = function() {
        st[Ge] && !/^c|loade/.test(st[Ge]) || ut || (st.onload = st[Xe] = null, ut = 1, Je[ot] = 2, at());
      }, st.async = 1, st.src = nt ? ot + (ot.indexOf("?") === -1 ? "?" : "&") + nt : ot, Qe.insertBefore(st, Qe.lastChild);
    }
    return rt.get = it, rt.order = function(ot, at, st) {
      (function ut(lt) {
        lt = ot.shift(), ot.length ? rt(lt, ut) : rt(lt, at, st);
      })();
    }, rt.path = function(ot) {
      Ze = ot;
    }, rt.urlArgs = function(ot) {
      nt = ot;
    }, rt.ready = function(ot, at, st) {
      ot = ot[He] ? ot : [ot];
      var ut = [];
      return !et(ot, function(lt) {
        Ke[lt] || ut[He](lt);
      }) && tt(ot, function(lt) {
        return Ke[lt];
      }) ? at() : function(lt) {
        $e[lt] = $e[lt] || [], $e[lt][He](at), st && st(ut);
      }(ot.join("|")), rt;
    }, rt.done = function(ot) {
      rt([null], ot);
    }, rt;
  });
})(script);
var scriptExports = script.exports;
const scriptjs = /* @__PURE__ */ getDefaultExportFromCjs(scriptExports);
Object.defineProperty(preloadScript$6, "__esModule", {
  value: !0
});
var _createClass$5 = /* @__PURE__ */ function() {
  function me(ue, Qe) {
    for (var Ue = 0; Ue < Qe.length; Ue++) {
      var He = Qe[Ue];
      He.enumerable = He.enumerable || !1, He.configurable = !0, "value" in He && (He.writable = !0), Object.defineProperty(ue, He.key, He);
    }
  }
  return function(ue, Qe, Ue) {
    return Qe && me(ue.prototype, Qe), Ue && me(ue, Ue), ue;
  };
}();
preloadScript$6.default = preloadScript$5;
var _react$8 = React__default, _react2$8 = _interopRequireDefault$j(_react$8), _propTypes$8 = propTypesExports, _propTypes2$8 = _interopRequireDefault$j(_propTypes$8), _reactDisplayName$1 = getDisplayName$1, _reactDisplayName2$1 = _interopRequireDefault$j(_reactDisplayName$1), _scriptjs$1 = scriptExports, _scriptjs2$1 = _interopRequireDefault$j(_scriptjs$1);
function _interopRequireDefault$j(me) {
  return me && me.__esModule ? me : { default: me };
}
function _objectWithoutProperties$3(me, ue) {
  var Qe = {};
  for (var Ue in me)
    ue.indexOf(Ue) >= 0 || Object.prototype.hasOwnProperty.call(me, Ue) && (Qe[Ue] = me[Ue]);
  return Qe;
}
function _classCallCheck$5(me, ue) {
  if (!(me instanceof ue))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$5(me, ue) {
  if (!me)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return ue && (typeof ue == "object" || typeof ue == "function") ? ue : me;
}
function _inherits$5(me, ue) {
  if (typeof ue != "function" && ue !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof ue);
  me.prototype = Object.create(ue && ue.prototype, { constructor: { value: me, enumerable: !1, writable: !0, configurable: !0 } }), ue && (Object.setPrototypeOf ? Object.setPrototypeOf(me, ue) : me.__proto__ = ue);
}
var DEFAULT_SCRIPT_URL$2 = "https://static.opentok.com/v2/js/opentok.min.js";
function preloadScript$5(me) {
  var ue = function(Qe) {
    _inherits$5(Ue, Qe);
    function Ue(He) {
      _classCallCheck$5(this, Ue);
      var Ge = _possibleConstructorReturn$5(this, (Ue.__proto__ || Object.getPrototypeOf(Ue)).call(this, He));
      return Ge.onScriptLoad = function() {
        Ge.isPresent && Ge.setState({ scriptLoaded: !0 });
      }, Ge.state = {
        scriptLoaded: typeof OT < "u"
      }, Ge.isPresent = !1, Ge;
    }
    return _createClass$5(Ue, [{
      key: "componentDidMount",
      value: function() {
        if (this.isPresent = !0, !(this.scriptLoading || this.state.scriptLoaded)) {
          this.scriptLoading = !0;
          var Ge = this.props.opentokClientUrl;
          (0, _scriptjs2$1.default)(Ge, this.onScriptLoad);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.isPresent = !1;
      }
    }, {
      key: "render",
      value: function() {
        var Ge = this.props;
        Ge.opentokClientUrl;
        var Xe = Ge.loadingDelegate, Ke = _objectWithoutProperties$3(Ge, ["opentokClientUrl", "loadingDelegate"]);
        return this.state.scriptLoaded ? _react2$8.default.createElement(me, Ke) : Xe;
      }
    }]), Ue;
  }(_react$8.Component);
  return ue.displayName = "preloadScript(" + (0, _reactDisplayName2$1.default)(me) + ")", ue.propTypes = {
    opentokClientUrl: _propTypes2$8.default.string,
    loadingDelegate: _propTypes2$8.default.node
  }, ue.defaultProps = {
    opentokClientUrl: DEFAULT_SCRIPT_URL$2,
    loadingDelegate: _react2$8.default.createElement("div", null)
  }, ue;
}
Object.defineProperty(dist$1, "__esModule", {
  value: !0
});
var preloadScript$4 = dist$1.preloadScript = dist$1.createSession = dist$1.OTSubscriber = dist$1.OTStreams = dist$1.OTPublisher = dist$1.OTSession = void 0, _OTSession$1 = OTSession$4, _OTSession2$1 = _interopRequireDefault$i(_OTSession$1), _OTPublisher$1 = OTPublisher$4, _OTPublisher2$1 = _interopRequireDefault$i(_OTPublisher$1), _OTStreams$1 = OTStreams$4, _OTStreams2$1 = _interopRequireDefault$i(_OTStreams$1), _OTSubscriber$1 = OTSubscriber$4, _OTSubscriber2$1 = _interopRequireDefault$i(_OTSubscriber$1), _createSession$1 = createSession$6, _createSession2$2 = _interopRequireDefault$i(_createSession$1), _preloadScript$1 = preloadScript$6, _preloadScript2$1 = _interopRequireDefault$i(_preloadScript$1);
function _interopRequireDefault$i(me) {
  return me && me.__esModule ? me : { default: me };
}
dist$1.default = {
  OTSession: _OTSession2$1.default,
  OTPublisher: _OTPublisher2$1.default,
  OTStreams: _OTStreams2$1.default,
  OTSubscriber: _OTSubscriber2$1.default,
  createSession: _createSession2$2.default,
  preloadScript: _preloadScript2$1.default
};
dist$1.OTSession = _OTSession2$1.default;
dist$1.OTPublisher = _OTPublisher2$1.default;
dist$1.OTStreams = _OTStreams2$1.default;
dist$1.OTSubscriber = _OTSubscriber2$1.default;
dist$1.createSession = _createSession2$2.default;
preloadScript$4 = dist$1.preloadScript = _preloadScript2$1.default;
const getFeatureConfig = async ({ token: me }) => (await api.get("/omni/feature-config", {
  headers: {
    "X-Incode-Hardware-Id": me
  }
})).data, frontType = "front", backType = "back", selfieType = "selfie", frontIdUrl = "/omni/add/front-id", secondFrontIdUrl = "/omni/add/front-second-id", backIdUrl = "/omni/add/back-id", secondBackIdUrl = "/omni/add/back-second-id", frontIdBase64Url = "/omni/add/front-id/v2", backIdBase64Url = "/omni/add/back-id/v2", getSelfieUrl = (me) => `/omni/add/face?imageType=${me}`, getRealQualityValue = (me) => (1 - me) * 100;
function uploadFrontId({
  token: me,
  image: ue,
  onProgress: Qe = emptyFunc,
  sendBase64: Ue,
  onlyFront: He,
  isRetry: Ge = !1,
  isSecondId: Xe = !1,
  glare: Ke,
  sharpness: $e,
  captureType: Je = null,
  shouldAddGlare: Ze = !1
}) {
  const nt = Ue ? frontIdBase64Url : Xe ? secondFrontIdUrl : frontIdUrl, tt = He ? `${nt}?onlyFront=${He}` : nt, et = Ue ? { base64Image: ue } : ue, rt = Ue ? "application/json" : "image/jpeg";
  return api.post(tt, et, {
    headers: {
      "X-Incode-Hardware-Id": me,
      "Content-Type": rt
    },
    onUploadProgress: ({ loaded: it, total: ot }) => Qe(it / ot * 100),
    params: {
      ...Ge ? { retry: !0 } : void 0,
      ...Ze && Ke ? { glare: getRealQualityValue(Ke) } : void 0,
      ...$e ? { sharpness: getRealQualityValue($e) } : void 0,
      captureType: Je
    }
  }).then((it) => it.data);
}
function uploadBackId({
  token: me,
  image: ue,
  onProgress: Qe = emptyFunc,
  sendBase64: Ue,
  isRetry: He = !1,
  isSecondId: Ge = !1,
  glare: Xe,
  sharpness: Ke,
  shouldSkipGlareBack: $e = !1,
  captureType: Je = null,
  shouldAddGlare: Ze = !1
}) {
  const nt = Ue ? backIdBase64Url : Ge ? secondBackIdUrl : backIdUrl, tt = Ue ? { base64Image: ue } : ue, et = Ue ? "application/json" : "image/jpeg";
  return api.post(nt, tt, {
    headers: {
      "X-Incode-Hardware-Id": me,
      "Content-Type": et
    },
    onUploadProgress: ({ loaded: rt, total: it }) => Qe(rt / it * 100),
    params: {
      ...He ? { retry: !0 } : void 0,
      ...$e ? { glare: 0 } : Ze && Xe ? { glare: getRealQualityValue(Xe) } : void 0,
      ...Ke ? { sharpness: getRealQualityValue(Ke) } : void 0,
      captureType: Je
    }
  }).then((rt) => rt.data);
}
function uploadSelfie({
  token: me,
  image: ue,
  onProgress: Qe = emptyFunc,
  encrypted: Ue,
  imageType: He = "selfie",
  faceCoordinates: Ge = null
}) {
  return api.post(
    getSelfieUrl(He),
    {
      base64Image: ue,
      encrypted: Ue,
      faceCoordinates: Ge,
      clientInfo: { deviceClass: getDeviceClass() }
    },
    {
      headers: {
        "X-Incode-Hardware-Id": me
      },
      onUploadProgress: ({ loaded: Xe, total: Ke }) => Qe(Xe / Ke * 100)
    }
  ).then((Xe) => Xe.data);
}
async function capture({ type: me, ...ue }) {
  var He;
  const Ue = ((He = (await getFeatureConfig({ token: ue.token })).features) == null ? void 0 : He.some(
    (Ge) => Ge.feature === "USE_CLIENT_GLARE" && Ge.enabled
  )) || !1;
  if (me === frontType)
    return uploadFrontId({ ...ue, shouldAddGlare: Ue });
  if (me === backType)
    return uploadBackId({ ...ue, shouldAddGlare: Ue });
  if (me === selfieType)
    return uploadSelfie({ ...ue });
  throw new Error(
    `type not supported, please use one of this: [${frontType}, ${backType}, ${selfieType}]`
  );
}
const eventModuleNames = {
  selfie: "SELFIE",
  mlConsent: "ML_CONSENT",
  combinedConsent: "COMBINED_CONSENT",
  curpValidation: "CURP_VALIDATION",
  faceMatch: "FACE_MATCH",
  generateQR: "QR",
  videoSelfie: "VIDEO_ONBOARDING",
  passport: "ID",
  front: "ID",
  back: "ID",
  document: "DOCUMENT_CAPTURE",
  creditCard: "CREDIT_CARD_FRONT",
  creditCardBack: "CREDIT_CARD_BACK",
  conference: "CONFERENCE",
  otp: "OTP",
  signature: "SIGNATURE",
  ekyc: "EXTERNAL_VERIFICATION",
  globalWatchList: "GLOBAL_WATCHLIST",
  customWatchList: "CUSTOM_WATCHLIST",
  email: "EMAIL",
  phone: "PHONE",
  instantVerifyEmail: "INSTANT_VERIFY_EMAIL",
  instantVerifyConsent: "INSTANT_VERIFY_CONSENT",
  forms: "FORMS"
}, eventScreenNames = {
  faceMatch: "FACE_MATCH",
  faceCaptureTutorial: "SELFIE_CAPTURE_TUTORIAL",
  faceCaptureCamera: "SELFIE_CAMERA_CAPTURE",
  faceCaptureError: "SELFIE_ATTEMPT_FAILED",
  faceCaptureSuccess: "SELFIE_UPLOAD_SUCCEEDED",
  faceCaptureUpload: "SELFIE_UPLOAD_PROGRESS",
  mlConsent: "MACHINE_LEARNING_CONSENT",
  combinedConsent: "COMBINED_CONSENT",
  curpEnter: "ENTER_CURP",
  curpValidate: "VALIDATE_CURP",
  curpGenerate: "GENERATE_CURP",
  curpValidation: "CURP_VALIDATION_PROGRESS",
  curpValidationFailed: "CURP_VALIDATION_FAILED",
  curpValidationSuccess: "CURP_VALIDATION_SUCCEEDED",
  qrTutorial: "QR_TUTORIAL",
  qrScan: "QR_SCAN",
  smsOtp: "OTP",
  simpleOTP: "OTP",
  signatureInput: "SIGNATURE_INPUT",
  frontTutorial: "FRONT_ID_CAPTURE_TUTORIAL",
  frontCameraCapture: "FRONT_ID_CAMERA_CAPTURE",
  frontHelp: "FRONT_ID_HELP",
  frontReviewPhoto: "FRONT_ID_REVIEW_PHOTO",
  frontUploadProgress: "FRONT_ID_UPLOAD_PROGRESS",
  frontAttemptFailed: "FRONT_ID_ATTEMPT_FAILED",
  frontUploadSuccess: "FRONT_ID_UPLOAD_SUCCEEDED",
  backTutorial: "BACK_ID_CAPTURE_TUTORIAL",
  backCameraCapture: "BACK_ID_CAMERA_CAPTURE",
  backReviewPhoto: "BACK_ID_REVIEW_PHOTO",
  backUploadProgress: "BACK_ID_UPLOAD_PROGRESS",
  backAttemptFailed: "BACK_ID_ATTEMPT_FAILED",
  backUploadSuccess: "BACK_ID_UPLOAD_SUCCEEDED",
  backHelp: "BACK_ID_HELP",
  passportTutorial: "TUTORIAL_PASSPORT",
  documentTutorial: "DOCUMENT_CAPTURE_TUTORIAL",
  documentCameraCapture: "DOCUMENT_CAMERA_CAPTURE",
  documentHelp: "DOCUMENT_HELP",
  documentReviewPhoto: "DOCUMENT_REVIEW_PHOTO",
  documentUploadProgress: "DOCUMENT_UPLOAD_IN_PROGRESS",
  documentAttemptFailed: "DOCUMENT_ATTEMPT_FAILED",
  documentUploadSuccess: "DOCUMENT_UPLOAD_SUCCEEDED",
  conferenceWait: "CONFERENCE_WAIT",
  conferenceVideoChat: "CONFERENCE_VIDEO_CHAT",
  conferenceMessageChat: "CONFERENCE_MESSAGE_CHAT",
  videoSelfieTutorial: "VIDEO_SELFIE_TUTORIAL",
  videoSelfie: "VIDEO_SELFIE",
  videoSelfieFaceCapture: "VIDEO_SELFIE_FACE_CAPTURE",
  videoSelfieFaceUploadProgress: "VIDEO_SELFIE_FACE_UPLOAD_PROGRESS",
  videoSelfieFaceAttemptFailed: "VIDEO_SELFIE_FACE_ATTEMPT_FAILED",
  videoSelfieFaceUploadSucceeded: "VIDEO_SELFIE_FACE_UPLOAD_SUCCEEDED",
  videoSelfieFrontIdCapture: "VIDEO_SELFIE_FRONT_ID_CAPTURE",
  videoSelfieFrontIdUploadProgress: "VIDEO_SELFIE_FRONT_ID_UPLOAD_PROGRESS",
  videoSelfieFrontIdAttemptFailed: "VIDEO_SELFIE_FRONT_ID_ATTEMPT_FAILED",
  videoSelfieFrontIdUploadSucceeded: "VIDEO_SELFIE_FRONT_ID_UPLOAD_SUCCEEDED",
  videoSelfieBackIdCapture: "VIDEO_SELFIE_BACK_ID_CAPTURE",
  videoSelfieBackIdUploadProgress: "VIDEO_SELFIE_BACK_ID_UPLOAD_PROGRESS",
  videoSelfieBackIdAttemptFailed: "VIDEO_SELFIE_BACK_ID_ATTEMPT_FAILED",
  videoSelfieBackIdUploadSucceeded: "VIDEO_SELFIE_BACK_ID_UPLOAD_SUCCEEDED",
  videoSelfieDocumentCapture: "VIDEO_SELFIE_DOCUMENT_CAPTURE",
  videoSelfieVoiceQuestion: "VIDEO_SELFIE_VOICE_QUESTION",
  videoSelfieVoiceFinalQuestion: "VIDEO_SELFIE_VOICE_FINAL_QUESTION",
  videoSelfieVideoUpload: "VIDEO SELFIE VIDEO UPLOAD",
  ekycInput: "EKYC_INPUT",
  ekycProgress: "EKYC_PROGRESS",
  ekycSucceeded: "EKYC_SUCCEEDED",
  ekycFailed: "EKYC_FAILED",
  globalWatchListInput: "GLOBAL_WATCHLIST_INPUT",
  globalWatchListProgress: "GLOBAL_WATCHLIST_PROGRESS",
  globalWatchListSuccess: "GLOBAL_WATCHLIST_SUCCEEDED",
  globalWatchListFailed: "GLOBAL_WATCHLIST_FAILED",
  customWatchListInput: "CUSTOM_WATCHLIST_INPUT",
  customWatchListProgress: "CUSTOM_WATCHLIST_PROGRESS",
  customWatchListSuccess: "CUSTOM_WATCHLIST_SUCCEEDED",
  customWatchListFailed: "CUSTOM_WATCHLIST_FAILED",
  emailInput: "EMAIL_INPUT",
  phoneInput: "PHONE_INPUT",
  instantVerify: "INSTANT_VERIFY",
  forms: "FORMS"
}, videoSelfieEvents = {
  imageTooBlurry: "imageTooBlurry",
  fillFrame: "fillFrame",
  checkCameraOrLighting: "checkCameraOrLighting",
  frontIdCaptureStarted: "frontIdCaptureStarted",
  lookAtCamera: "lookAtCamera",
  moveCloser: "moveCloser",
  lookingForFrontId: "lookingForFrontId",
  lookingForBackId: "lookingForBackId",
  cameraSwitchToBack: "cameraSwitchToBack",
  cameraSwitchToFront: "cameraSwitchToFront",
  audioStreamOpened: "audioStreamOpened",
  audioStreamClosed: "audioStreamClosed",
  videoSelfieVideoUploadInProgress: "videoSelfieVideoUploadInProgress",
  videoSelfieTosNotAccepted: "videoSelfieTosNotAccepted",
  videoSelfieTosAccepted: "videoSelfieTosAccepted"
}, tutorialScreenNamesMapper = {
  passport: eventScreenNames.passportTutorial,
  front: eventScreenNames.frontTutorial,
  back: eventScreenNames.backTutorial,
  selfie: eventScreenNames.faceCaptureTutorial
}, cameraScreenNamesMapper = {
  front: "front",
  back: "back",
  passport: "front",
  creditCard: "front",
  creditCardBack: "back",
  document: "document"
};
function screenEvent({
  module: me,
  payload: ue,
  token: Qe,
  screen: Ue,
  code: He
}) {
  try {
    addEvent({
      token: Qe,
      module: me,
      code: He,
      screen: Ue,
      clientTimestamp: (/* @__PURE__ */ new Date()).getTime(),
      payload: {
        ...ue ?? {}
      }
    });
  } catch (Ge) {
    console.error(Ge);
  }
}
function useScreenEvents({
  module: me,
  screen: ue,
  payload: Qe = {},
  token: Ue
}) {
  useEffect(() => (screenEvent({
    module: me,
    payload: Qe,
    code: "screenOpened",
    token: Ue,
    screen: ue
  }), () => {
    screenEvent({
      module: me,
      payload: Qe,
      code: "screenClosed",
      token: Ue,
      screen: ue
    });
  }), []);
}
function useModuleEvents({
  module: me,
  payload: ue = {},
  token: Qe,
  screen: Ue
}) {
  useLayoutEffect(() => (screenEvent({
    module: me,
    screen: Ue,
    payload: ue,
    code: "moduleOpened",
    token: Qe
  }), () => {
    setTimeout(() => {
      screenEvent({
        module: me,
        payload: ue,
        screen: Ue,
        code: "moduleClosed",
        token: Qe
      });
    }, 0);
  }), []);
}
const addScreenEvent = ({
  module: me,
  token: ue,
  screen: Qe,
  payload: Ue,
  shouldOpen: He
}) => {
  screenEvent({
    module: me,
    payload: Ue,
    token: ue,
    screen: Qe,
    code: He ? "screenOpened" : "screenClosed"
  });
};
function processFace({ token: me, imageType: ue = "selfie" }) {
  return api.post(
    `/omni/process/face?imageType=${ue}`,
    {},
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).then((Qe) => Qe.data).catch((Qe) => Promise.reject(Qe.response.data));
}
function processFaceSecondId({ token: me, imageType: ue = "selfie" }) {
  return api.post(
    `/omni/process/face-vs-second-id?imageType=${ue}`,
    {},
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).then((Qe) => Qe.data).catch((Qe) => Promise.reject(Qe.response.data));
}
const updateSessionUrl = "/omni/update";
function updateSession({ token: me, key: ue, value: Qe, onProgress: Ue = emptyFunc }) {
  return api.put(
    updateSessionUrl,
    { [ue]: Qe },
    {
      headers: {
        "X-Incode-Hardware-Id": me
      },
      onUploadProgress: ({ loaded: He, total: Ge }) => Ue(He / Ge * 100)
    }
  );
}
function createSession$4({
  apiKey: me,
  sessionId: ue,
  token: Qe,
  onStreamsUpdated: Ue,
  onConnect: He,
  onError: Ge,
  options: Xe
} = {}) {
  if (!me)
    throw new Error("Missing apiKey");
  if (!ue)
    throw new Error("Missing sessionId");
  if (!Qe)
    throw new Error("Missing token");
  let Ke = [], $e = (tt) => {
    Ke.findIndex((rt) => rt.id === tt.stream.id) < 0 && (Ke.push(tt.stream), Ue(Ke));
  }, Je = (tt) => {
    const et = Ke.findIndex((rt) => rt.id === tt.stream.id);
    et >= 0 && (Ke.splice(et, 1), Ue(Ke));
  }, Ze = {
    streamCreated: $e,
    streamDestroyed: Je
  }, nt = OT.initSession(me, ue, Xe);
  return nt.on(Ze), nt.connect(Qe, (tt) => {
    nt && (tt && typeof Ge == "function" ? Ge(tt) : !tt && typeof He == "function" && He());
  }), {
    session: nt,
    streams: Ke,
    disconnect() {
      nt && (nt.off(Ze), nt.disconnect()), Ke = null, $e = null, Je = null, Ze = null, nt = null, this.session = null, this.streams = null;
    }
  };
}
let OTSession$2 = class extends Component {
  constructor(ue) {
    super(ue), this.state = {
      streams: []
    };
  }
  getChildContext() {
    return { session: this.sessionHelper.session, streams: this.state.streams };
  }
  componentWillMount() {
    this.createSession();
  }
  componentDidUpdate(ue) {
    (ue.apiKey !== this.props.apiKey || ue.sessionId !== this.props.sessionId || ue.token !== this.props.token) && this.createSession();
  }
  componentWillUnmount() {
    this.destroySession();
  }
  createSession() {
    this.destroySession(), this.sessionHelper = createSession$4({
      apiKey: this.props.apiKey,
      sessionId: this.props.sessionId,
      token: this.props.token,
      onStreamsUpdated: (Qe) => {
        this.setState({ streams: Qe });
      },
      onConnect: this.props.onConnect,
      onError: this.props.onError,
      options: this.props.options
    }), this.props.eventHandlers && typeof this.props.eventHandlers == "object" && this.sessionHelper.session.on(this.props.eventHandlers);
    const { streams: ue } = this.sessionHelper;
    this.setState({ streams: ue });
  }
  destroySession() {
    this.sessionHelper && (this.props.eventHandlers && typeof this.props.eventHandlers == "object" && this.sessionHelper.session.off(this.props.eventHandlers), this.sessionHelper.disconnect());
  }
  render() {
    const ue = typeof this.props.children == "function";
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: ue ? this.props.children(this.sessionHelper) : this.props.children });
  }
};
OTSession$2.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.func
  ]).isRequired,
  apiKey: PropTypes.string.isRequired,
  sessionId: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  eventHandlers: PropTypes.objectOf(PropTypes.func),
  onConnect: PropTypes.func,
  onError: PropTypes.func,
  options: PropTypes.object
};
OTSession$2.defaultProps = {
  eventHandlers: null,
  onConnect: null,
  onError: null,
  options: {}
};
OTSession$2.childContextTypes = {
  streams: PropTypes.arrayOf(PropTypes.object),
  session: PropTypes.shape({
    subscribe: PropTypes.func,
    unsubscribe: PropTypes.func
  })
};
let OTPublisher$2 = class extends Component {
  constructor(Qe, Ue) {
    super(Qe);
    $n(this, "sessionConnectedHandler", () => {
      this.publishToSession(this.state.publisher);
    });
    $n(this, "streamCreatedHandler", (Qe) => {
      this.setState({ lastStreamId: Qe.stream.id });
    });
    this.state = {
      publisher: null,
      lastStreamId: "",
      session: Qe.session || Ue.session || null
    };
  }
  componentDidMount() {
    this.createPublisher();
  }
  componentDidUpdate(Qe, Ue) {
    const He = (Ke, $e) => Ke === void 0 ? $e : Ke, Ge = (Ke, $e) => {
      const Je = He(Qe.properties[Ke], $e), Ze = He(this.props.properties[Ke], $e);
      return Je !== Ze;
    }, Xe = (Ke, $e) => {
      if (Ge(Ke, $e)) {
        const Je = He(this.props.properties[Ke], $e);
        this.state.publisher[Ke](Je);
      }
    };
    if (Ge("videoSource", void 0)) {
      this.destroyPublisher(), this.createPublisher();
      return;
    }
    Xe("publishAudio", !0), Xe("publishVideo", !0), this.state.session !== Ue.session && (this.destroyPublisher(Ue.session), this.createPublisher());
  }
  componentWillUnmount() {
    this.state.session && this.state.session.off("sessionConnected", this.sessionConnectedHandler), this.destroyPublisher();
  }
  getPublisher() {
    return this.state.publisher;
  }
  destroyPublisher(Qe = this.state.session) {
    delete this.publisherId, this.state.publisher && (this.state.publisher.off("streamCreated", this.streamCreatedHandler), this.props.eventHandlers && typeof this.props.eventHandlers == "object" && this.state.publisher.once("destroyed", () => {
      this.state.publisher.off(this.props.eventHandlers);
    }), Qe && Qe.unpublish(this.state.publisher), this.state.publisher.destroy());
  }
  publishToSession(Qe) {
    const { publisherId: Ue } = this;
    this.state.session.publish(Qe, (He) => {
      Ue === this.publisherId && (He ? this.errorHandler(He) : typeof this.props.onPublish == "function" && this.props.onPublish());
    });
  }
  createPublisher() {
    if (!this.state.session) {
      this.setState({ publisher: null, lastStreamId: "" });
      return;
    }
    const Qe = this.props.properties || {};
    let Ue;
    Qe.insertDefaultUI !== !1 && (Ue = document.createElement("div"), Ue.setAttribute("class", "OTPublisherContainer"), this.node.appendChild(Ue)), this.publisherId = uuid$1();
    const { publisherId: He } = this;
    this.errorHandler = once$2((Xe) => {
      He === this.publisherId && typeof this.props.onError == "function" && this.props.onError(Xe);
    });
    const Ge = OT.initPublisher(Ue, Qe, (Xe) => {
      He === this.publisherId && (Xe ? this.errorHandler(Xe) : typeof this.props.onInit == "function" && this.props.onInit());
    });
    if (Ge.on("streamCreated", this.streamCreatedHandler), Ge.setStyle({
      buttonDisplayMode: "off"
    }), this.props.eventHandlers && typeof this.props.eventHandlers == "object") {
      const Xe = fp.omitBy(fp.isNil)(this.props.eventHandlers);
      Ge.on(Xe);
    }
    this.state.session.connection ? this.publishToSession(Ge) : this.state.session.once("sessionConnected", this.sessionConnectedHandler), this.setState({ publisher: Ge, lastStreamId: "" });
  }
  render() {
    const { className: Qe, style: Ue } = this.props;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: Qe,
        style: Ue,
        ref: (He) => {
          this.node = He;
        }
      }
    );
  }
};
OTPublisher$2.propTypes = {
  session: PropTypes.shape({
    connection: PropTypes.shape({
      connectionId: PropTypes.string
    }),
    once: PropTypes.func,
    off: PropTypes.func,
    publish: PropTypes.func,
    unpublish: PropTypes.func
  }),
  className: PropTypes.string,
  style: PropTypes.object,
  properties: PropTypes.object,
  eventHandlers: PropTypes.objectOf(PropTypes.func),
  onInit: PropTypes.func,
  onPublish: PropTypes.func,
  onError: PropTypes.func
};
OTPublisher$2.defaultProps = {
  session: null,
  className: "",
  style: {},
  properties: {},
  eventHandlers: null,
  onInit: null,
  onPublish: null,
  onError: null
};
OTPublisher$2.contextTypes = {
  session: PropTypes.shape({
    connection: PropTypes.shape({
      connectionId: PropTypes.string
    }),
    once: PropTypes.func,
    off: PropTypes.func,
    publish: PropTypes.func,
    unpublish: PropTypes.func
  })
};
let OTSubscriberContext$2 = class extends Component {
  getChildContext() {
    return { stream: this.props.stream };
  }
  render() {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: this.props.children });
  }
};
OTSubscriberContext$2.propTypes = {
  children: PropTypes.element.isRequired,
  stream: PropTypes.shape({
    streamId: PropTypes.string
  }).isRequired
};
OTSubscriberContext$2.childContextTypes = {
  stream: PropTypes.shape({
    streamId: PropTypes.string
  })
};
function OTStreams$2(me, ue) {
  const Qe = me.session || ue.session || null, Ue = me.streams || ue.streams || null;
  if (!Qe)
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {});
  const He = Children.only(me.children);
  return Array.isArray(Ue) ? Ue.map(
    (Xe) => He && /* @__PURE__ */ jsxRuntimeExports.jsx(OTSubscriberContext$2, { stream: Xe, children: cloneElement(He) }, Xe.id)
  ) : null;
}
OTStreams$2.propTypes = {
  children: PropTypes.element.isRequired,
  session: PropTypes.shape({
    publish: PropTypes.func,
    subscribe: PropTypes.func
  }),
  streams: PropTypes.arrayOf(PropTypes.object)
};
OTStreams$2.defaultProps = {
  session: null,
  streams: null
};
OTStreams$2.contextTypes = {
  session: PropTypes.shape({
    publish: PropTypes.func,
    subscribe: PropTypes.func
  }),
  streams: PropTypes.arrayOf(PropTypes.object)
};
let OTSubscriber$2 = class extends Component {
  constructor(ue, Qe) {
    super(ue), this.state = {
      subscriber: null,
      stream: ue.stream || Qe.stream || null,
      session: ue.session || Qe.session || null,
      currentRetryAttempt: 0
    }, this.maxRetryAttempts = ue.maxRetryAttempts || 5, this.retryAttemptTimeout = ue.retryAttemptTimeout || 1e3;
  }
  componentDidMount() {
    this.createSubscriber();
  }
  componentDidUpdate(ue, Qe) {
    const Ue = (Ge, Xe, Ke) => Ge === void 0 ? Ke : Xe(Ge), He = (Ge) => {
      const Xe = Ue(ue.properties[Ge], Boolean, !0), Ke = Ue(this.props.properties[Ge], Boolean, !0);
      Xe !== Ke && this.state.subscriber[Ge](Ke);
    };
    He("subscribeToAudio"), He("subscribeToVideo"), (Qe.session !== this.state.session || Qe.stream !== this.state.stream) && (this.destroySubscriber(Qe.session), this.createSubscriber());
  }
  componentWillUnmount() {
    this.destroySubscriber();
  }
  getSubscriber() {
    return this.state.subscriber;
  }
  createSubscriber() {
    if (!this.state.session || !this.state.stream) {
      this.setState({ subscriber: null });
      return;
    }
    const ue = this.props.properties || {};
    let Qe;
    ue.insertDefaultUI !== !1 && (Qe = document.createElement("div"), Qe.setAttribute("class", "OTSubscriberContainer"), this.node.appendChild(Qe)), this.subscriberId = uuid$1();
    const { subscriberId: Ue } = this, He = this.state.session.subscribe(
      this.state.stream,
      Qe,
      this.props.properties,
      (Ge) => {
        Ue === this.subscriberId && (Ge && this.props.retry && this.state.currentRetryAttempt < this.maxRetryAttempts - 1 && this.handleRetrySubscriber(), Ge && typeof this.props.onError == "function" ? this.props.onError(Ge) : !Ge && typeof this.props.onSubscribe == "function" && this.props.onSubscribe());
      }
    );
    this.props.eventHandlers && typeof this.props.eventHandlers == "object" && He.on(this.props.eventHandlers), this.setState({ subscriber: He });
  }
  handleRetrySubscriber() {
    setTimeout(() => {
      this.setState((ue) => ({
        currentRetryAttempt: ue.currentRetryAttempt + 1,
        subscriber: null
      })), this.createSubscriber();
    }, this.retryAttemptTimeout);
  }
  destroySubscriber(ue = this.props.session) {
    delete this.subscriberId, this.state.subscriber && (this.props.eventHandlers && typeof this.props.eventHandlers == "object" && this.state.subscriber.once("destroyed", () => {
      this.state.subscriber.off(this.props.eventHandlers);
    }), ue && ue.unsubscribe(this.state.subscriber));
  }
  render() {
    const { className: ue, style: Qe } = this.props;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: ue,
        style: Qe,
        ref: (Ue) => {
          this.node = Ue;
        }
      }
    );
  }
};
OTSubscriber$2.propTypes = {
  stream: PropTypes.shape({
    streamId: PropTypes.string
  }),
  session: PropTypes.shape({
    subscribe: PropTypes.func,
    unsubscribe: PropTypes.func
  }),
  className: PropTypes.string,
  style: PropTypes.object,
  properties: PropTypes.object,
  retry: PropTypes.bool,
  maxRetryAttempts: PropTypes.number,
  retryAttemptTimeout: PropTypes.number,
  eventHandlers: PropTypes.objectOf(PropTypes.func),
  onSubscribe: PropTypes.func,
  onError: PropTypes.func
};
OTSubscriber$2.defaultProps = {
  stream: null,
  session: null,
  className: "",
  style: {},
  properties: {},
  retry: !1,
  maxRetryAttempts: 5,
  retryAttemptTimeout: 1e3,
  eventHandlers: null,
  onSubscribe: null,
  onError: null
};
OTSubscriber$2.contextTypes = {
  stream: PropTypes.shape({
    streamId: PropTypes.string
  }),
  session: PropTypes.shape({
    subscribe: PropTypes.func,
    unsubscribe: PropTypes.func
  })
};
const DEFAULT_SCRIPT_URL$1 = "https://static.opentok.com/v2/js/opentok.min.js";
function preloadScript$3(me) {
  class ue extends Component {
    constructor(He) {
      super(He);
      $n(this, "onScriptLoad", () => {
        this.isPresent && this.setState({ scriptLoaded: !0 });
      });
      this.state = {
        scriptLoaded: typeof OT < "u"
      }, this.isPresent = !1;
    }
    componentDidMount() {
      if (this.isPresent = !0, this.scriptLoading || this.state.scriptLoaded)
        return;
      this.scriptLoading = !0;
      const He = this.props.opentokClientUrl;
      scriptjs(He, this.onScriptLoad);
    }
    componentWillUnmount() {
      this.isPresent = !1;
    }
    render() {
      const { opentokClientUrl: He, loadingDelegate: Ge, ...Xe } = this.props;
      return this.state.scriptLoaded ? /* @__PURE__ */ jsxRuntimeExports.jsx(me, { ...Xe }) : Ge;
    }
  }
  return ue.displayName = `preloadScript(${_default$f(me)})`, ue.propTypes = {
    opentokClientUrl: PropTypes.string,
    loadingDelegate: PropTypes.node
  }, ue.defaultProps = {
    opentokClientUrl: DEFAULT_SCRIPT_URL$1,
    loadingDelegate: /* @__PURE__ */ jsxRuntimeExports.jsx("div", {})
  }, ue;
}
var lib$1 = {}, jsnlog = {};
(function(me) {
  var ue = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
    var Ue = function(He, Ge) {
      return Ue = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Xe, Ke) {
        Xe.__proto__ = Ke;
      } || function(Xe, Ke) {
        for (var $e in Ke) Object.prototype.hasOwnProperty.call(Ke, $e) && (Xe[$e] = Ke[$e]);
      }, Ue(He, Ge);
    };
    return function(He, Ge) {
      Ue(He, Ge);
      function Xe() {
        this.constructor = He;
      }
      He.prototype = Ge === null ? Object.create(Ge) : (Xe.prototype = Ge.prototype, new Xe());
    };
  }();
  function Qe(Ue) {
    if (!Ue)
      return Qe.__;
    Array.prototype.reduce || (Array.prototype.reduce = function(Xe, Ke) {
      for (var $e = Ke, Je = 0; Je < this.length; Je++)
        $e = Xe($e, this[Je], Je, this);
      return $e;
    });
    var He = "", Ge = ("." + Ue).split(".").reduce(function(Xe, Ke, $e, Je) {
      He ? He += "." + Ke : He = Ke;
      var Ze = Xe["__" + He];
      return Ze === void 0 && (Qe.Logger.prototype = Xe, Ze = new Qe.Logger(He), Xe["__" + He] = Ze), Ze;
    }, Qe.__);
    return Ge;
  }
  (function(Ue) {
    Ue.requestId = "", Ue.entryId = 0, Ue._createXMLHttpRequest = function() {
      return new XMLHttpRequest();
    }, Ue._getTime = function() {
      return (/* @__PURE__ */ new Date()).getTime();
    }, Ue._console = console, Ue._appenderNames = [];
    function He(vt, Et, bt) {
      if (Et[vt] !== void 0) {
        if (Et[vt] === null) {
          delete bt[vt];
          return;
        }
        bt[vt] = Et[vt];
      }
    }
    function Ge(vt) {
      if (Ue.enabled != null && !Ue.enabled)
        return !1;
      try {
        if (vt.userAgentRegex && !new RegExp(vt.userAgentRegex).test(navigator.userAgent))
          return !1;
      } catch {
      }
      try {
        if (vt.ipRegex && Ue.clientIP && !new RegExp(vt.ipRegex).test(Ue.clientIP))
          return !1;
      } catch {
      }
      return !0;
    }
    function Xe(vt, Et) {
      try {
        if (vt.disallow && new RegExp(vt.disallow).test(Et))
          return !1;
      } catch {
      }
      return !0;
    }
    function Ke(vt) {
      return typeof vt == "function" ? vt instanceof RegExp ? vt.toString() : vt() : vt;
    }
    var $e = (
      /** @class */
      /* @__PURE__ */ function() {
        function vt(Et, bt, Rt) {
          this.msg = Et, this.meta = bt, this.finalString = Rt;
        }
        return vt;
      }()
    );
    function Je(vt) {
      var Et = Ke(vt), bt;
      switch (typeof Et) {
        case "string":
          return new $e(Et, null, Et);
        case "number":
          return bt = Et.toString(), new $e(bt, null, bt);
        case "boolean":
          return bt = Et.toString(), new $e(bt, null, bt);
        case "undefined":
          return new $e("undefined", null, "undefined");
        case "object":
          return Et instanceof RegExp || Et instanceof String || Et instanceof Number || Et instanceof Boolean ? (bt = Et.toString(), new $e(bt, null, bt)) : (typeof Ue.serialize == "function" ? bt = Ue.serialize.call(this, Et) : bt = JSON.stringify(Et), new $e("", Et, bt));
        default:
          return new $e("unknown", null, "unknown");
      }
    }
    function Ze(vt) {
      return He("enabled", vt, this), He("maxMessages", vt, this), He("defaultAjaxUrl", vt, this), He("clientIP", vt, this), He("requestId", vt, this), He("defaultBeforeSend", vt, this), He("serialize", vt, this), this;
    }
    Ue.setOptions = Ze;
    function nt() {
      return -2147483648;
    }
    Ue.getAllLevel = nt;
    function tt() {
      return 1e3;
    }
    Ue.getTraceLevel = tt;
    function et() {
      return 2e3;
    }
    Ue.getDebugLevel = et;
    function rt() {
      return 3e3;
    }
    Ue.getInfoLevel = rt;
    function it() {
      return 4e3;
    }
    Ue.getWarnLevel = it;
    function ot() {
      return 5e3;
    }
    Ue.getErrorLevel = ot;
    function at() {
      return 6e3;
    }
    Ue.getFatalLevel = at;
    function st() {
      return 2147483647;
    }
    Ue.getOffLevel = st;
    function ut(vt) {
      return vt <= 1e3 ? "trace" : vt <= 2e3 ? "debug" : vt <= 3e3 ? "info" : vt <= 4e3 ? "warn" : vt <= 5e3 ? "error" : "fatal";
    }
    var lt = (
      /** @class */
      /* @__PURE__ */ function() {
        function vt(Et, bt) {
          this.inner = bt, this.name = "JL.Exception", this.message = Je(Et).finalString;
        }
        return vt;
      }()
    );
    Ue.Exception = lt, lt.prototype = new Error();
    var dt = (
      /** @class */
      /* @__PURE__ */ function() {
        function vt(Et, bt, Rt, St, kt) {
          this.l = Et, this.m = bt, this.n = Rt, this.t = St, this.u = kt;
        }
        return vt;
      }()
    );
    Ue.LogItem = dt;
    function At(vt, Et, bt) {
      return Ue.entryId++, new dt(vt, Et, bt, Ue._getTime(), Ue.entryId);
    }
    function pt(vt) {
      vt.id && (clearTimeout(vt.id), vt.id = null);
    }
    function gt(vt, Et, bt) {
      var Rt = this;
      vt.id || (vt.id = setTimeout(function() {
        bt.call(Rt);
      }, Et));
    }
    var wt = (
      /** @class */
      function() {
        function vt(Et, bt) {
          this.appenderName = Et, this.sendLogItems = bt, this.level = Ue.getTraceLevel(), this.sendWithBufferLevel = 2147483647, this.storeInBufferLevel = -2147483648, this.bufferSize = 0, this.batchSize = 1, this.maxBatchSize = 20, this.batchTimeout = 2147483647, this.sendTimeout = 5e3, this.buffer = [], this.batchBuffer = [], this.batchTimeoutTimer = { id: null }, this.sendTimeoutTimer = { id: null }, this.nbrLogItemsSkipped = 0, this.nbrLogItemsBeingSent = 0;
          var Rt = "Trying to create an appender without a name or with an empty name";
          if (Et == null)
            throw Rt;
          if (Ue._appenderNames.indexOf(Et) != -1)
            throw Et ? "Multiple appenders use the same name " + Et : Rt;
          Ue._appenderNames.push(Et);
        }
        return vt.prototype.addLogItemsToBuffer = function(Et) {
          if (this.batchBuffer.length >= this.maxBatchSize) {
            this.nbrLogItemsSkipped += Et.length;
            return;
          }
          if (Ue.maxMessages != null) {
            if (Ue.maxMessages < 1)
              return;
            Ue.maxMessages -= Et.length;
          }
          this.batchBuffer = this.batchBuffer.concat(Et);
          var bt = this;
          gt(this.batchTimeoutTimer, this.batchTimeout, function() {
            bt.sendBatch.call(bt);
          });
        }, vt.prototype.batchBufferHasOverdueMessages = function() {
          for (var Et = 0; Et < this.batchBuffer.length; Et++) {
            var bt = Ue._getTime() - this.batchBuffer[Et].t;
            if (bt > this.batchTimeout)
              return !0;
          }
          return !1;
        }, vt.prototype.batchBufferHasStrandedMessage = function() {
          return Ue.maxMessages != null && Ue.maxMessages < 1 && this.batchBuffer.length > 0;
        }, vt.prototype.sendBatchIfComplete = function() {
          (this.batchBuffer.length >= this.batchSize || this.batchBufferHasOverdueMessages() || this.batchBufferHasStrandedMessage()) && this.sendBatch();
        }, vt.prototype.onSendingEnded = function() {
          pt(this.sendTimeoutTimer), this.nbrLogItemsBeingSent = 0, this.sendBatchIfComplete();
        }, vt.prototype.setOptions = function(Et) {
          if (He("level", Et, this), He("ipRegex", Et, this), He("userAgentRegex", Et, this), He("disallow", Et, this), He("sendWithBufferLevel", Et, this), He("storeInBufferLevel", Et, this), He("bufferSize", Et, this), He("batchSize", Et, this), He("maxBatchSize", Et, this), He("batchTimeout", Et, this), He("sendTimeout", Et, this), this.bufferSize < this.buffer.length && (this.buffer.length = this.bufferSize), this.maxBatchSize < this.batchSize)
            throw new Ue.Exception({
              message: "maxBatchSize cannot be smaller than batchSize",
              maxBatchSize: this.maxBatchSize,
              batchSize: this.batchSize
            });
          return this;
        }, vt.prototype.log = function(Et, bt, Rt, St, kt, jt, Pt) {
          var Qt;
          if (Ge(this) && Xe(this, jt) && !(kt < this.storeInBufferLevel)) {
            if (Qt = At(kt, jt, Pt), kt < this.level) {
              this.bufferSize > 0 && (this.buffer.push(Qt), this.buffer.length > this.bufferSize && this.buffer.shift());
              return;
            }
            this.addLogItemsToBuffer([Qt]), kt >= this.sendWithBufferLevel && this.buffer.length && (this.addLogItemsToBuffer(this.buffer), this.buffer.length = 0), this.sendBatchIfComplete();
          }
        }, vt.prototype.sendBatch = function() {
          if (!(this.nbrLogItemsBeingSent > 0) && (pt(this.batchTimeoutTimer), this.batchBuffer.length != 0)) {
            this.nbrLogItemsBeingSent = this.batchBuffer.length;
            var Et = this;
            gt(this.sendTimeoutTimer, this.sendTimeout, function() {
              Et.onSendingEnded.call(Et);
            }), this.sendLogItems(this.batchBuffer, function() {
              Et.batchBuffer.splice(0, Et.nbrLogItemsBeingSent), Et.nbrLogItemsSkipped > 0 && (Et.batchBuffer.push(At(it(), "Lost " + Et.nbrLogItemsSkipped + " messages. Either connection with the server was down or logging was disabled via the enabled option. Reduce lost messages by increasing the ajaxAppender option maxBatchSize.", Et.appenderName)), Et.nbrLogItemsSkipped = 0), Et.onSendingEnded.call(Et);
            });
          }
        }, vt;
      }()
    );
    Ue.Appender = wt;
    var Bt = (
      /** @class */
      function(vt) {
        ue(Et, vt);
        function Et(bt) {
          return vt.call(this, bt, Et.prototype.sendLogItemsAjax) || this;
        }
        return Et.prototype.setOptions = function(bt) {
          return He("url", bt, this), He("beforeSend", bt, this), vt.prototype.setOptions.call(this, bt), this;
        }, Et.prototype.sendLogItemsAjax = function(bt, Rt) {
          try {
            if (!Ge(this))
              return;
            this.xhr && this.xhr.readyState != 0 && this.xhr.readyState != 4 && this.xhr.abort(), this.xhr = Ue._createXMLHttpRequest();
            var St = "/jsnlog.logger";
            Ue.defaultAjaxUrl != null && (St = Ue.defaultAjaxUrl), this.url && (St = this.url), this.xhr.open("POST", St), this.xhr.setRequestHeader("Content-Type", "application/json"), this.xhr.setRequestHeader("JSNLog-RequestId", Ue.requestId);
            var kt = this;
            this.xhr.onreadystatechange = function() {
              kt.xhr.readyState == 4 && kt.xhr.status >= 200 && kt.xhr.status < 300 && Rt();
            };
            var jt = {
              r: Ue.requestId,
              lg: bt
            };
            typeof this.beforeSend == "function" ? this.beforeSend.call(this, this.xhr, jt) : typeof Ue.defaultBeforeSend == "function" && Ue.defaultBeforeSend.call(this, this.xhr, jt);
            var Pt = JSON.stringify(jt);
            this.xhr.send(Pt);
          } catch {
          }
        }, Et;
      }(wt)
    );
    Ue.AjaxAppender = Bt;
    var Tt = (
      /** @class */
      function(vt) {
        ue(Et, vt);
        function Et(bt) {
          return vt.call(this, bt, Et.prototype.sendLogItemsConsole) || this;
        }
        return Et.prototype.clog = function(bt) {
          Ue._console.log(bt);
        }, Et.prototype.cerror = function(bt) {
          Ue._console.error ? Ue._console.error(bt) : this.clog(bt);
        }, Et.prototype.cwarn = function(bt) {
          Ue._console.warn ? Ue._console.warn(bt) : this.clog(bt);
        }, Et.prototype.cinfo = function(bt) {
          Ue._console.info ? Ue._console.info(bt) : this.clog(bt);
        }, Et.prototype.cdebug = function(bt) {
          Ue._console.debug ? Ue._console.debug(bt) : this.cinfo(bt);
        }, Et.prototype.sendLogItemsConsole = function(bt, Rt) {
          try {
            if (!Ge(this) || !Ue._console)
              return;
            var St;
            for (St = 0; St < bt.length; ++St) {
              var kt = bt[St], jt = kt.n + ": " + kt.m;
              typeof window > "u" && (jt = new Date(kt.t) + " | " + jt), kt.l <= Ue.getDebugLevel() ? this.cdebug(jt) : kt.l <= Ue.getInfoLevel() ? this.cinfo(jt) : kt.l <= Ue.getWarnLevel() ? this.cwarn(jt) : this.cerror(jt);
            }
          } catch {
          }
          Rt();
        }, Et;
      }(wt)
    );
    Ue.ConsoleAppender = Tt;
    var yt = (
      /** @class */
      function() {
        function vt(Et) {
          this.loggerName = Et, this.seenRegexes = [];
        }
        return vt.prototype.setOptions = function(Et) {
          return He("level", Et, this), He("userAgentRegex", Et, this), He("disallow", Et, this), He("ipRegex", Et, this), He("appenders", Et, this), He("onceOnly", Et, this), this.seenRegexes = [], this;
        }, vt.prototype.buildExceptionObject = function(Et) {
          var bt = {};
          return Et.stack ? bt.stack = Et.stack : bt.e = Et, Et.message && (bt.message = Et.message), Et.name && (bt.name = Et.name), Et.data && (bt.data = Et.data), Et.inner && (bt.inner = this.buildExceptionObject(Et.inner)), bt;
        }, vt.prototype.log = function(Et, bt, Rt) {
          var St = 0, kt, jt;
          if (!this.appenders)
            return this;
          if (Et >= this.level && Ge(this) && (Rt ? (jt = this.buildExceptionObject(Rt), jt.logData = Ke(bt)) : jt = bt, kt = Je(jt), Xe(this, kt.finalString))) {
            if (this.onceOnly)
              for (St = this.onceOnly.length - 1; St >= 0; ) {
                if (new RegExp(this.onceOnly[St]).test(kt.finalString)) {
                  if (this.seenRegexes[St])
                    return this;
                  this.seenRegexes[St] = !0;
                }
                St--;
              }
            for (kt.meta = kt.meta || {}, St = this.appenders.length - 1; St >= 0; )
              this.appenders[St].log(ut(Et), kt.msg, kt.meta, function() {
              }, Et, kt.finalString, this.loggerName), St--;
          }
          return this;
        }, vt.prototype.trace = function(Et) {
          return this.log(tt(), Et);
        }, vt.prototype.debug = function(Et) {
          return this.log(et(), Et);
        }, vt.prototype.info = function(Et) {
          return this.log(rt(), Et);
        }, vt.prototype.warn = function(Et) {
          return this.log(it(), Et);
        }, vt.prototype.error = function(Et) {
          return this.log(ot(), Et);
        }, vt.prototype.fatal = function(Et) {
          return this.log(at(), Et);
        }, vt.prototype.fatalException = function(Et, bt) {
          return this.log(at(), Et, bt);
        }, vt;
      }()
    );
    Ue.Logger = yt;
    function Ct(vt) {
      return new Bt(vt);
    }
    Ue.createAjaxAppender = Ct;
    function ht(vt) {
      return new Tt(vt);
    }
    Ue.createConsoleAppender = ht;
    var It;
    typeof window < "u" ? It = new Bt("") : It = new Tt(""), Ue.__ = new Ue.Logger(""), Ue.__.setOptions({
      level: Ue.getDebugLevel(),
      appenders: [It]
    });
  })(Qe || (Qe = {})), me.__esModule = !0, me.JL = Qe, typeof __jsnlog_configure == "function" && __jsnlog_configure(Qe), typeof window < "u" && !window.onerror && (window.onerror = function(Ue, He, Ge, Xe, Ke) {
    return Qe("onerrorLogger").fatalException({
      msg: "Uncaught Exception",
      errorMsg: Ue ? Ue.message || Ue : "",
      url: He,
      "line number": Ge,
      column: Xe
    }, Ke), !1;
  }), typeof window < "u" && !window.onunhandledrejection && (window.onunhandledrejection = function(Ue) {
    Qe("onerrorLogger").fatalException({
      msg: "unhandledrejection",
      errorMsg: Ue.reason ? Ue.reason.message : Ue.message || null
    }, Ue.reason);
  });
})(jsnlog);
var OpenVidu$1 = {}, LocalRecorder$1 = {}, LocalRecorderState = {};
(function(me) {
  Object.defineProperty(me, "__esModule", { value: !0 }), me.LocalRecorderState = void 0, function(ue) {
    ue.READY = "READY", ue.RECORDING = "RECORDING", ue.PAUSED = "PAUSED", ue.FINISHED = "FINISHED";
  }(me.LocalRecorderState || (me.LocalRecorderState = {}));
})(LocalRecorderState);
var OpenViduLogger$1 = {}, ConsoleLogger$1 = {};
Object.defineProperty(ConsoleLogger$1, "__esModule", { value: !0 });
ConsoleLogger$1.ConsoleLogger = void 0;
var ConsoleLogger = (
  /** @class */
  /* @__PURE__ */ function() {
    function me(ue) {
      this.logger = ue, this.log = ue.log, this.info = ue.info, this.debug = ue.debug, this.warn = ue.warn, this.error = ue.error;
    }
    return me;
  }()
);
ConsoleLogger$1.ConsoleLogger = ConsoleLogger;
var OpenViduLoggerConfiguration = {};
(function(me) {
  Object.defineProperty(me, "__esModule", { value: !0 }), me.OpenViduLoggerConfiguration = void 0, function(ue) {
    ue.disabled = "disabled", ue.debug = "debug", ue.debug_app = "debug_app";
  }(me.OpenViduLoggerConfiguration || (me.OpenViduLoggerConfiguration = {}));
})(OpenViduLoggerConfiguration);
Object.defineProperty(OpenViduLogger$1, "__esModule", { value: !0 });
OpenViduLogger$1.OpenViduLogger = void 0;
var jsnlog_1 = jsnlog, ConsoleLogger_1 = ConsoleLogger$1, OpenViduLoggerConfiguration_1$1 = OpenViduLoggerConfiguration, OpenViduLogger = (
  /** @class */
  function() {
    function me() {
      this.JSNLOG_URL = "/openvidu/elk/openvidu-browser-logs", this.MAX_JSNLOG_BATCH_LOG_MESSAGES = 100, this.MAX_MSECONDS_BATCH_MESSAGES = 5e3, this.MAX_LENGTH_STRING_JSON = 1e3, this.defaultConsoleLogger = new ConsoleLogger_1.ConsoleLogger(globalThis.console), this.isProdMode = !1, this.isJSNLogSetup = !1;
    }
    return me.configureJSNLog = function(ue, Qe) {
      var Ue = this;
      try {
        if (globalThis.LOG_JSNLOG_RESULTS || // If instance is created and it is OpenVidu Pro
        this.instance && ue.isAtLeastPro && // If logs are enabled
        this.instance.isOpenViduBrowserLogsDebugActive(ue) && // Only reconfigure it if session or finalUserId has changed
        this.instance.canConfigureJSNLog(ue, this.instance)) {
          ue.sendBrowserLogs === OpenViduLoggerConfiguration_1$1.OpenViduLoggerConfiguration.debug_app && this.instance.replaceWindowConsole(), this.instance.isJSNLogSetup = !1, this.instance.info("Configuring JSNLogs.");
          var He = ue.finalUserId, Ge = ue.session.sessionId, Xe = function($e) {
            var Je = $e.onreadystatechange;
            $e.onreadystatechange = function() {
              Ue.isInvalidResponse($e) && (Object.defineProperty($e, "readyState", { value: 4 }), Object.defineProperty($e, "status", { value: 200 }), Ue.instance.disableLogger()), Je();
            }, $e.setRequestHeader("Authorization", "Basic " + btoa("".concat(He, "%/%").concat(Ge) + ":" + Qe)), $e.setRequestHeader("X-Requested-With", "XMLHttpRequest"), $e.setRequestHeader("OV-Final-User-Id", He), $e.setRequestHeader("OV-Session-Id", Ge), $e.setRequestHeader("OV-Token", Qe);
          };
          this.instance.currentAppender = jsnlog_1.JL.createAjaxAppender("appender-".concat(He, "-").concat(Ge)), this.instance.currentAppender.setOptions({
            beforeSend: Xe,
            maxBatchSize: 1e3,
            batchSize: this.instance.MAX_JSNLOG_BATCH_LOG_MESSAGES,
            batchTimeout: this.instance.MAX_MSECONDS_BATCH_MESSAGES
          });
          var Ke = function($e) {
            var Je = function() {
              var nt = /* @__PURE__ */ new WeakSet();
              return function(tt, et) {
                if (typeof et == "object" && et != null) {
                  if (nt.has(et) || globalThis.HTMLElement && et instanceof HTMLElement)
                    return;
                  nt.add(et);
                }
                return et;
              };
            }, Ze = JSON.stringify($e, Je());
            return Ze.length > Ue.instance.MAX_LENGTH_STRING_JSON && (Ze = "".concat(Ze.substring(0, Ue.instance.MAX_LENGTH_STRING_JSON), "...")), globalThis.LOG_JSNLOG_RESULTS && console.log(Ze), Ze;
          };
          jsnlog_1.JL.setOptions({
            defaultAjaxUrl: ue.httpUri + this.instance.JSNLOG_URL,
            serialize: Ke,
            enabled: !0
          }), (0, jsnlog_1.JL)().setOptions({
            appenders: [this.instance.currentAppender]
          }), this.instance.isJSNLogSetup = !0, this.instance.loggingSessionId = Ge, this.instance.info("JSNLog configured.");
        }
      } catch ($e) {
        console.error("Error configuring JSNLog: "), console.error($e), this.instance.disableLogger();
      }
    }, me.getInstance = function() {
      return me.instance || (me.instance = new me()), me.instance;
    }, me.isInvalidResponse = function(ue) {
      return ue.status == 401 || ue.status == 403 || ue.status == 404 || ue.status == 0;
    }, me.prototype.canConfigureJSNLog = function(ue, Qe) {
      return ue.session.sessionId != Qe.loggingSessionId;
    }, me.prototype.isOpenViduBrowserLogsDebugActive = function(ue) {
      return ue.sendBrowserLogs === OpenViduLoggerConfiguration_1$1.OpenViduLoggerConfiguration.debug || ue.sendBrowserLogs === OpenViduLoggerConfiguration_1$1.OpenViduLoggerConfiguration.debug_app;
    }, me.prototype.getConsoleWithJSNLog = function() {
      return /* @__PURE__ */ function(ue) {
        return {
          log: function() {
            ue.defaultConsoleLogger.log.apply(ue.defaultConsoleLogger.logger, arguments), ue.isJSNLogSetup && (0, jsnlog_1.JL)().info(arguments);
          },
          info: function() {
            ue.defaultConsoleLogger.info.apply(ue.defaultConsoleLogger.logger, arguments), ue.isJSNLogSetup && (0, jsnlog_1.JL)().info(arguments);
          },
          debug: function() {
            ue.defaultConsoleLogger.debug.apply(ue.defaultConsoleLogger.logger, arguments);
          },
          warn: function() {
            ue.defaultConsoleLogger.warn.apply(ue.defaultConsoleLogger.logger, arguments), ue.isJSNLogSetup && (0, jsnlog_1.JL)().warn(arguments);
          },
          error: function() {
            ue.defaultConsoleLogger.error.apply(ue.defaultConsoleLogger.logger, arguments), ue.isJSNLogSetup && (0, jsnlog_1.JL)().error(arguments);
          }
        };
      }(this);
    }, me.prototype.replaceWindowConsole = function() {
      globalThis.console = this.defaultConsoleLogger.logger, globalThis.console.log = this.getConsoleWithJSNLog().log, globalThis.console.info = this.getConsoleWithJSNLog().info, globalThis.console.debug = this.getConsoleWithJSNLog().debug, globalThis.console.warn = this.getConsoleWithJSNLog().warn, globalThis.console.error = this.getConsoleWithJSNLog().error;
    }, me.prototype.disableLogger = function() {
      jsnlog_1.JL.setOptions({ enabled: !1 }), this.isJSNLogSetup = !1, this.loggingSessionId = void 0, this.currentAppender = void 0, globalThis.console = this.defaultConsoleLogger.logger, globalThis.console.log = this.defaultConsoleLogger.log, globalThis.console.info = this.defaultConsoleLogger.info, globalThis.console.debug = this.defaultConsoleLogger.debug, globalThis.console.warn = this.defaultConsoleLogger.warn, globalThis.console.error = this.defaultConsoleLogger.error;
    }, me.prototype.log = function() {
      this.isProdMode || this.defaultConsoleLogger.log.apply(this.defaultConsoleLogger.logger, arguments), this.isJSNLogSetup && (0, jsnlog_1.JL)().info(arguments);
    }, me.prototype.debug = function() {
      this.isProdMode || this.defaultConsoleLogger.debug.apply(this.defaultConsoleLogger.logger, arguments);
    }, me.prototype.info = function() {
      this.isProdMode || this.defaultConsoleLogger.info.apply(this.defaultConsoleLogger.logger, arguments), this.isJSNLogSetup && (0, jsnlog_1.JL)().info(arguments);
    }, me.prototype.warn = function() {
      this.defaultConsoleLogger.warn.apply(this.defaultConsoleLogger.logger, arguments), this.isJSNLogSetup && (0, jsnlog_1.JL)().warn(arguments);
    }, me.prototype.error = function() {
      this.defaultConsoleLogger.error.apply(this.defaultConsoleLogger.logger, arguments), this.isJSNLogSetup && (0, jsnlog_1.JL)().error(arguments);
    }, me.prototype.flush = function() {
      this.isJSNLogSetup && this.currentAppender != null && this.currentAppender.sendBatch();
    }, me.prototype.enableProdMode = function() {
      this.isProdMode = !0;
    }, me;
  }()
);
OpenViduLogger$1.OpenViduLogger = OpenViduLogger;
var Platform = {}, platform$6 = { exports: {} };
/*!
 * Platform.js v1.3.6
 * Copyright 2014-2020 Benjamin Tan
 * Copyright 2011-2013 John-David Dalton
 * Available under MIT license
 */
platform$6.exports;
(function(me, ue) {
  (function() {
    var Qe = {
      function: !0,
      object: !0
    }, Ue = Qe[typeof window] && window || this, He = ue, Ge = me && !me.nodeType && me, Xe = He && Ge && typeof commonjsGlobal == "object" && commonjsGlobal;
    Xe && (Xe.global === Xe || Xe.window === Xe || Xe.self === Xe) && (Ue = Xe);
    var Ke = Math.pow(2, 53) - 1, $e = /\bOpera/, Je = Object.prototype, Ze = Je.hasOwnProperty, nt = Je.toString;
    function tt(gt) {
      return gt = String(gt), gt.charAt(0).toUpperCase() + gt.slice(1);
    }
    function et(gt, wt, Bt) {
      var Tt = {
        "10.0": "10",
        "6.4": "10 Technical Preview",
        "6.3": "8.1",
        "6.2": "8",
        "6.1": "Server 2008 R2 / 7",
        "6.0": "Server 2008 / Vista",
        "5.2": "Server 2003 / XP 64-bit",
        "5.1": "XP",
        "5.01": "2000 SP1",
        "5.0": "2000",
        "4.0": "NT",
        "4.90": "ME"
      };
      return wt && Bt && /^Win/i.test(gt) && !/^Windows Phone /i.test(gt) && (Tt = Tt[/[\d.]+$/.exec(gt)]) && (gt = "Windows " + Tt), gt = String(gt), wt && Bt && (gt = gt.replace(RegExp(wt, "i"), Bt)), gt = it(
        gt.replace(/ ce$/i, " CE").replace(/\bhpw/i, "web").replace(/\bMacintosh\b/, "Mac OS").replace(/_PowerPC\b/i, " OS").replace(/\b(OS X) [^ \d]+/i, "$1").replace(/\bMac (OS X)\b/, "$1").replace(/\/(\d)/, " $1").replace(/_/g, ".").replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, "").replace(/\bx86\.64\b/gi, "x86_64").replace(/\b(Windows Phone) OS\b/, "$1").replace(/\b(Chrome OS \w+) [\d.]+\b/, "$1").split(" on ")[0]
      ), gt;
    }
    function rt(gt, wt) {
      var Bt = -1, Tt = gt ? gt.length : 0;
      if (typeof Tt == "number" && Tt > -1 && Tt <= Ke)
        for (; ++Bt < Tt; )
          wt(gt[Bt], Bt, gt);
      else
        ot(gt, wt);
    }
    function it(gt) {
      return gt = dt(gt), /^(?:webOS|i(?:OS|P))/.test(gt) ? gt : tt(gt);
    }
    function ot(gt, wt) {
      for (var Bt in gt)
        Ze.call(gt, Bt) && wt(gt[Bt], Bt, gt);
    }
    function at(gt) {
      return gt == null ? tt(gt) : nt.call(gt).slice(8, -1);
    }
    function st(gt, wt) {
      var Bt = gt != null ? typeof gt[wt] : "number";
      return !/^(?:boolean|number|string|undefined)$/.test(Bt) && (Bt == "object" ? !!gt[wt] : !0);
    }
    function ut(gt) {
      return String(gt).replace(/([ -])(?!$)/g, "$1?");
    }
    function lt(gt, wt) {
      var Bt = null;
      return rt(gt, function(Tt, yt) {
        Bt = wt(Bt, Tt, yt, gt);
      }), Bt;
    }
    function dt(gt) {
      return String(gt).replace(/^ +| +$/g, "");
    }
    function At(gt) {
      var wt = Ue, Bt = gt && typeof gt == "object" && at(gt) != "String";
      Bt && (wt = gt, gt = null);
      var Tt = wt.navigator || {}, yt = Tt.userAgent || "";
      gt || (gt = yt);
      var Ct = Bt ? !!Tt.likeChrome : /\bChrome\b/.test(gt) && !/internal|\n/i.test(nt.toString()), ht = "Object", It = Bt ? ht : "ScriptBridgingProxyObject", vt = Bt ? ht : "Environment", Et = Bt && wt.java ? "JavaPackage" : at(wt.java), bt = Bt ? ht : "RuntimeObject", Rt = /\bJava/.test(Et) && wt.java, St = Rt && at(wt.environment) == vt, kt = Rt ? "a" : "α", jt = Rt ? "b" : "β", Pt = wt.document || {}, Qt = wt.operamini || wt.opera, qt = $e.test(qt = Bt && Qt ? Qt["[[Class]]"] : at(Qt)) ? qt : Qt = null, _t, Yt = gt, Xt = [], Ut = null, Lt = gt == yt, Ot = Lt && Qt && typeof Qt.version == "function" && Qt.version(), ft, Dt = $t([
        { label: "EdgeHTML", pattern: "Edge" },
        "Trident",
        { label: "WebKit", pattern: "AppleWebKit" },
        "iCab",
        "Presto",
        "NetFront",
        "Tasman",
        "KHTML",
        "Gecko"
      ]), Mt = hn([
        "Adobe AIR",
        "Arora",
        "Avant Browser",
        "Breach",
        "Camino",
        "Electron",
        "Epiphany",
        "Fennec",
        "Flock",
        "Galeon",
        "GreenBrowser",
        "iCab",
        "Iceweasel",
        "K-Meleon",
        "Konqueror",
        "Lunascape",
        "Maxthon",
        { label: "Microsoft Edge", pattern: "(?:Edge|Edg|EdgA|EdgiOS)" },
        "Midori",
        "Nook Browser",
        "PaleMoon",
        "PhantomJS",
        "Raven",
        "Rekonq",
        "RockMelt",
        { label: "Samsung Internet", pattern: "SamsungBrowser" },
        "SeaMonkey",
        { label: "Silk", pattern: "(?:Cloud9|Silk-Accelerated)" },
        "Sleipnir",
        "SlimBrowser",
        { label: "SRWare Iron", pattern: "Iron" },
        "Sunrise",
        "Swiftfox",
        "Vivaldi",
        "Waterfox",
        "WebPositive",
        { label: "Yandex Browser", pattern: "YaBrowser" },
        { label: "UC Browser", pattern: "UCBrowser" },
        "Opera Mini",
        { label: "Opera Mini", pattern: "OPiOS" },
        "Opera",
        { label: "Opera", pattern: "OPR" },
        "Chromium",
        "Chrome",
        { label: "Chrome", pattern: "(?:HeadlessChrome)" },
        { label: "Chrome Mobile", pattern: "(?:CriOS|CrMo)" },
        { label: "Firefox", pattern: "(?:Firefox|Minefield)" },
        { label: "Firefox for iOS", pattern: "FxiOS" },
        { label: "IE", pattern: "IEMobile" },
        { label: "IE", pattern: "MSIE" },
        "Safari"
      ]), Ft = An([
        { label: "BlackBerry", pattern: "BB10" },
        "BlackBerry",
        { label: "Galaxy S", pattern: "GT-I9000" },
        { label: "Galaxy S2", pattern: "GT-I9100" },
        { label: "Galaxy S3", pattern: "GT-I9300" },
        { label: "Galaxy S4", pattern: "GT-I9500" },
        { label: "Galaxy S5", pattern: "SM-G900" },
        { label: "Galaxy S6", pattern: "SM-G920" },
        { label: "Galaxy S6 Edge", pattern: "SM-G925" },
        { label: "Galaxy S7", pattern: "SM-G930" },
        { label: "Galaxy S7 Edge", pattern: "SM-G935" },
        "Google TV",
        "Lumia",
        "iPad",
        "iPod",
        "iPhone",
        "Kindle",
        { label: "Kindle Fire", pattern: "(?:Cloud9|Silk-Accelerated)" },
        "Nexus",
        "Nook",
        "PlayBook",
        "PlayStation Vita",
        "PlayStation",
        "TouchPad",
        "Transformer",
        { label: "Wii U", pattern: "WiiU" },
        "Wii",
        "Xbox One",
        { label: "Xbox 360", pattern: "Xbox" },
        "Xoom"
      ]), Gt = Ht({
        Apple: { iPad: 1, iPhone: 1, iPod: 1 },
        Alcatel: {},
        Archos: {},
        Amazon: { Kindle: 1, "Kindle Fire": 1 },
        Asus: { Transformer: 1 },
        "Barnes & Noble": { Nook: 1 },
        BlackBerry: { PlayBook: 1 },
        Google: { "Google TV": 1, Nexus: 1 },
        HP: { TouchPad: 1 },
        HTC: {},
        Huawei: {},
        Lenovo: {},
        LG: {},
        Microsoft: { Xbox: 1, "Xbox One": 1 },
        Motorola: { Xoom: 1 },
        Nintendo: { "Wii U": 1, Wii: 1 },
        Nokia: { Lumia: 1 },
        Oppo: {},
        Samsung: { "Galaxy S": 1, "Galaxy S2": 1, "Galaxy S3": 1, "Galaxy S4": 1 },
        Sony: { PlayStation: 1, "PlayStation Vita": 1 },
        Xiaomi: { Mi: 1, Redmi: 1 }
      }), zt = un([
        "Windows Phone",
        "KaiOS",
        "Android",
        "CentOS",
        { label: "Chrome OS", pattern: "CrOS" },
        "Debian",
        { label: "DragonFly BSD", pattern: "DragonFly" },
        "Fedora",
        "FreeBSD",
        "Gentoo",
        "Haiku",
        "Kubuntu",
        "Linux Mint",
        "OpenBSD",
        "Red Hat",
        "SuSE",
        "Ubuntu",
        "Xubuntu",
        "Cygwin",
        "Symbian OS",
        "hpwOS",
        "webOS ",
        "webOS",
        "Tablet OS",
        "Tizen",
        "Linux",
        "Mac OS X",
        "Macintosh",
        "Mac",
        "Windows 98;",
        "Windows "
      ]);
      function $t(an) {
        return lt(an, function(cn, dn) {
          return cn || RegExp("\\b" + (dn.pattern || ut(dn)) + "\\b", "i").exec(gt) && (dn.label || dn);
        });
      }
      function Ht(an) {
        return lt(an, function(cn, dn, yn) {
          return cn || (dn[Ft] || dn[/^[a-z]+(?: +[a-z]+\b)*/i.exec(Ft)] || RegExp("\\b" + ut(yn) + "(?:\\b|\\w*\\d)", "i").exec(gt)) && yn;
        });
      }
      function hn(an) {
        return lt(an, function(cn, dn) {
          return cn || RegExp("\\b" + (dn.pattern || ut(dn)) + "\\b", "i").exec(gt) && (dn.label || dn);
        });
      }
      function un(an) {
        return lt(an, function(cn, dn) {
          var yn = dn.pattern || ut(dn);
          return !cn && (cn = RegExp("\\b" + yn + "(?:/[\\d.]+|[ \\w.]*)", "i").exec(gt)) && (cn = et(cn, yn, dn.label || dn)), cn;
        });
      }
      function An(an) {
        return lt(an, function(cn, dn) {
          var yn = dn.pattern || ut(dn);
          return !cn && (cn = RegExp("\\b" + yn + " *\\d+[.\\w_]*", "i").exec(gt) || RegExp("\\b" + yn + " *\\w+-[\\w]*", "i").exec(gt) || RegExp("\\b" + yn + "(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)", "i").exec(gt)) && ((cn = String(dn.label && !RegExp(yn, "i").test(dn.label) ? dn.label : cn).split("/"))[1] && !/[\d.]+/.test(cn[0]) && (cn[0] += " " + cn[1]), dn = dn.label || dn, cn = it(cn[0].replace(RegExp(yn, "i"), dn).replace(RegExp("; *(?:" + dn + "[_-])?", "i"), " ").replace(RegExp("(" + dn + ")[-_.]?(\\w)", "i"), "$1 $2"))), cn;
        });
      }
      function mn(an) {
        return lt(an, function(cn, dn) {
          return cn || (RegExp(dn + "(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)", "i").exec(gt) || 0)[1] || null;
        });
      }
      function En() {
        return this.description || "";
      }
      if (Dt && (Dt = [Dt]), /\bAndroid\b/.test(zt) && !Ft && (_t = /\bAndroid[^;]*;(.*?)(?:Build|\) AppleWebKit)\b/i.exec(gt)) && (Ft = dt(_t[1]).replace(/^[a-z]{2}-[a-z]{2};\s*/i, "") || null), Gt && !Ft ? Ft = An([Gt]) : Gt && Ft && (Ft = Ft.replace(RegExp("^(" + ut(Gt) + ")[-_.\\s]", "i"), Gt + " ").replace(RegExp("^(" + ut(Gt) + ")[-_.]?(\\w)", "i"), Gt + " $2")), (_t = /\bGoogle TV\b/.exec(Ft)) && (Ft = _t[0]), /\bSimulator\b/i.test(gt) && (Ft = (Ft ? Ft + " " : "") + "Simulator"), Mt == "Opera Mini" && /\bOPiOS\b/.test(gt) && Xt.push("running in Turbo/Uncompressed mode"), Mt == "IE" && /\blike iPhone OS\b/.test(gt) ? (_t = At(gt.replace(/like iPhone OS/, "")), Gt = _t.manufacturer, Ft = _t.product) : /^iP/.test(Ft) ? (Mt || (Mt = "Safari"), zt = "iOS" + ((_t = / OS ([\d_]+)/i.exec(gt)) ? " " + _t[1].replace(/_/g, ".") : "")) : Mt == "Konqueror" && /^Linux\b/i.test(zt) ? zt = "Kubuntu" : Gt && Gt != "Google" && (/Chrome/.test(Mt) && !/\bMobile Safari\b/i.test(gt) || /\bVita\b/.test(Ft)) || /\bAndroid\b/.test(zt) && /^Chrome/.test(Mt) && /\bVersion\//i.test(gt) ? (Mt = "Android Browser", zt = /\bAndroid\b/.test(zt) ? zt : "Android") : Mt == "Silk" ? (/\bMobi/i.test(gt) || (zt = "Android", Xt.unshift("desktop mode")), /Accelerated *= *true/i.test(gt) && Xt.unshift("accelerated")) : Mt == "UC Browser" && /\bUCWEB\b/.test(gt) ? Xt.push("speed mode") : Mt == "PaleMoon" && (_t = /\bFirefox\/([\d.]+)\b/.exec(gt)) ? Xt.push("identifying as Firefox " + _t[1]) : Mt == "Firefox" && (_t = /\b(Mobile|Tablet|TV)\b/i.exec(gt)) ? (zt || (zt = "Firefox OS"), Ft || (Ft = _t[1])) : !Mt || (_t = !/\bMinefield\b/i.test(gt) && /\b(?:Firefox|Safari)\b/.exec(Mt)) ? (Mt && !Ft && /[\/,]|^[^(]+?\)/.test(gt.slice(gt.indexOf(_t + "/") + 8)) && (Mt = null), (_t = Ft || Gt || zt) && (Ft || Gt || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(zt)) && (Mt = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(zt) ? zt : _t) + " Browser")) : Mt == "Electron" && (_t = (/\bChrome\/([\d.]+)\b/.exec(gt) || 0)[1]) && Xt.push("Chromium " + _t), Ot || (Ot = mn([
        "(?:Cloud9|CriOS|CrMo|Edge|Edg|EdgA|EdgiOS|FxiOS|HeadlessChrome|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$)|UCBrowser|YaBrowser)",
        "Version",
        ut(Mt),
        "(?:Firefox|Minefield|NetFront)"
      ])), (_t = Dt == "iCab" && parseFloat(Ot) > 3 && "WebKit" || /\bOpera\b/.test(Mt) && (/\bOPR\b/.test(gt) ? "Blink" : "Presto") || /\b(?:Midori|Nook|Safari)\b/i.test(gt) && !/^(?:Trident|EdgeHTML)$/.test(Dt) && "WebKit" || !Dt && /\bMSIE\b/i.test(gt) && (zt == "Mac OS" ? "Tasman" : "Trident") || Dt == "WebKit" && /\bPlayStation\b(?! Vita\b)/i.test(Mt) && "NetFront") && (Dt = [_t]), Mt == "IE" && (_t = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(gt) || 0)[1]) ? (Mt += " Mobile", zt = "Windows Phone " + (/\+$/.test(_t) ? _t : _t + ".x"), Xt.unshift("desktop mode")) : /\bWPDesktop\b/i.test(gt) ? (Mt = "IE Mobile", zt = "Windows Phone 8.x", Xt.unshift("desktop mode"), Ot || (Ot = (/\brv:([\d.]+)/.exec(gt) || 0)[1])) : Mt != "IE" && Dt == "Trident" && (_t = /\brv:([\d.]+)/.exec(gt)) && (Mt && Xt.push("identifying as " + Mt + (Ot ? " " + Ot : "")), Mt = "IE", Ot = _t[1]), Lt) {
        if (st(wt, "global"))
          if (Rt && (_t = Rt.lang.System, Yt = _t.getProperty("os.arch"), zt = zt || _t.getProperty("os.name") + " " + _t.getProperty("os.version")), St) {
            try {
              Ot = wt.require("ringo/engine").version.join("."), Mt = "RingoJS";
            } catch {
              (_t = wt.system) && _t.global.system == wt.system && (Mt = "Narwhal", zt || (zt = _t[0].os || null));
            }
            Mt || (Mt = "Rhino");
          } else typeof wt.process == "object" && !wt.process.browser && (_t = wt.process) && (typeof _t.versions == "object" && (typeof _t.versions.electron == "string" ? (Xt.push("Node " + _t.versions.node), Mt = "Electron", Ot = _t.versions.electron) : typeof _t.versions.nw == "string" && (Xt.push("Chromium " + Ot, "Node " + _t.versions.node), Mt = "NW.js", Ot = _t.versions.nw)), Mt || (Mt = "Node.js", Yt = _t.arch, zt = _t.platform, Ot = /[\d.]+/.exec(_t.version), Ot = Ot ? Ot[0] : null));
        else at(_t = wt.runtime) == It ? (Mt = "Adobe AIR", zt = _t.flash.system.Capabilities.os) : at(_t = wt.phantom) == bt ? (Mt = "PhantomJS", Ot = (_t = _t.version || null) && _t.major + "." + _t.minor + "." + _t.patch) : typeof Pt.documentMode == "number" && (_t = /\bTrident\/(\d+)/i.exec(gt)) ? (Ot = [Ot, Pt.documentMode], (_t = +_t[1] + 4) != Ot[1] && (Xt.push("IE " + Ot[1] + " mode"), Dt && (Dt[1] = ""), Ot[1] = _t), Ot = Mt == "IE" ? String(Ot[1].toFixed(1)) : Ot[0]) : typeof Pt.documentMode == "number" && /^(?:Chrome|Firefox)\b/.test(Mt) && (Xt.push("masking as " + Mt + " " + Ot), Mt = "IE", Ot = "11.0", Dt = ["Trident"], zt = "Windows");
        zt = zt && it(zt);
      }
      if (Ot && (_t = /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(Ot) || /(?:alpha|beta)(?: ?\d)?/i.exec(gt + ";" + (Lt && Tt.appMinorVersion)) || /\bMinefield\b/i.test(gt) && "a") && (Ut = /b/i.test(_t) ? "beta" : "alpha", Ot = Ot.replace(RegExp(_t + "\\+?$"), "") + (Ut == "beta" ? jt : kt) + (/\d+\+?/.exec(_t) || "")), Mt == "Fennec" || Mt == "Firefox" && /\b(?:Android|Firefox OS|KaiOS)\b/.test(zt))
        Mt = "Firefox Mobile";
      else if (Mt == "Maxthon" && Ot)
        Ot = Ot.replace(/\.[\d.]+/, ".x");
      else if (/\bXbox\b/i.test(Ft))
        Ft == "Xbox 360" && (zt = null), Ft == "Xbox 360" && /\bIEMobile\b/.test(gt) && Xt.unshift("mobile mode");
      else if ((/^(?:Chrome|IE|Opera)$/.test(Mt) || Mt && !Ft && !/Browser|Mobi/.test(Mt)) && (zt == "Windows CE" || /Mobi/i.test(gt)))
        Mt += " Mobile";
      else if (Mt == "IE" && Lt)
        try {
          wt.external === null && Xt.unshift("platform preview");
        } catch {
          Xt.unshift("embedded");
        }
      else (/\bBlackBerry\b/.test(Ft) || /\bBB10\b/.test(gt)) && (_t = (RegExp(Ft.replace(/ +/g, " *") + "/([.\\d]+)", "i").exec(gt) || 0)[1] || Ot) ? (_t = [_t, /BB10/.test(gt)], zt = (_t[1] ? (Ft = null, Gt = "BlackBerry") : "Device Software") + " " + _t[0], Ot = null) : this != ot && Ft != "Wii" && (Lt && Qt || /Opera/.test(Mt) && /\b(?:MSIE|Firefox)\b/i.test(gt) || Mt == "Firefox" && /\bOS X (?:\d+\.){2,}/.test(zt) || Mt == "IE" && (zt && !/^Win/.test(zt) && Ot > 5.5 || /\bWindows XP\b/.test(zt) && Ot > 8 || Ot == 8 && !/\bTrident\b/.test(gt))) && !$e.test(_t = At.call(ot, gt.replace($e, "") + ";")) && _t.name && (_t = "ing as " + _t.name + ((_t = _t.version) ? " " + _t : ""), $e.test(Mt) ? (/\bIE\b/.test(_t) && zt == "Mac OS" && (zt = null), _t = "identify" + _t) : (_t = "mask" + _t, qt ? Mt = it(qt.replace(/([a-z])([A-Z])/g, "$1 $2")) : Mt = "Opera", /\bIE\b/.test(_t) && (zt = null), Lt || (Ot = null)), Dt = ["Presto"], Xt.push(_t));
      (_t = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(gt) || 0)[1]) && (_t = [parseFloat(_t.replace(/\.(\d)$/, ".0$1")), _t], Mt == "Safari" && _t[1].slice(-1) == "+" ? (Mt = "WebKit Nightly", Ut = "alpha", Ot = _t[1].slice(0, -1)) : (Ot == _t[1] || Ot == (_t[2] = (/\bSafari\/([\d.]+\+?)/i.exec(gt) || 0)[1])) && (Ot = null), _t[1] = (/\b(?:Headless)?Chrome\/([\d.]+)/i.exec(gt) || 0)[1], _t[0] == 537.36 && _t[2] == 537.36 && parseFloat(_t[1]) >= 28 && Dt == "WebKit" && (Dt = ["Blink"]), !Lt || !Ct && !_t[1] ? (Dt && (Dt[1] = "like Safari"), _t = (_t = _t[0], _t < 400 ? 1 : _t < 500 ? 2 : _t < 526 ? 3 : _t < 533 ? 4 : _t < 534 ? "4+" : _t < 535 ? 5 : _t < 537 ? 6 : _t < 538 ? 7 : _t < 601 ? 8 : _t < 602 ? 9 : _t < 604 ? 10 : _t < 606 ? 11 : _t < 608 ? 12 : "12")) : (Dt && (Dt[1] = "like Chrome"), _t = _t[1] || (_t = _t[0], _t < 530 ? 1 : _t < 532 ? 2 : _t < 532.05 ? 3 : _t < 533 ? 4 : _t < 534.03 ? 5 : _t < 534.07 ? 6 : _t < 534.1 ? 7 : _t < 534.13 ? 8 : _t < 534.16 ? 9 : _t < 534.24 ? 10 : _t < 534.3 ? 11 : _t < 535.01 ? 12 : _t < 535.02 ? "13+" : _t < 535.07 ? 15 : _t < 535.11 ? 16 : _t < 535.19 ? 17 : _t < 536.05 ? 18 : _t < 536.1 ? 19 : _t < 537.01 ? 20 : _t < 537.11 ? "21+" : _t < 537.13 ? 23 : _t < 537.18 ? 24 : _t < 537.24 ? 25 : _t < 537.36 ? 26 : Dt != "Blink" ? "27" : "28")), Dt && (Dt[1] += " " + (_t += typeof _t == "number" ? ".x" : /[.+]/.test(_t) ? "" : "+")), Mt == "Safari" && (!Ot || parseInt(Ot) > 45) ? Ot = _t : Mt == "Chrome" && /\bHeadlessChrome/i.test(gt) && Xt.unshift("headless")), Mt == "Opera" && (_t = /\bzbov|zvav$/.exec(zt)) ? (Mt += " ", Xt.unshift("desktop mode"), _t == "zvav" ? (Mt += "Mini", Ot = null) : Mt += "Mobile", zt = zt.replace(RegExp(" *" + _t + "$"), "")) : Mt == "Safari" && /\bChrome\b/.exec(Dt && Dt[1]) ? (Xt.unshift("desktop mode"), Mt = "Chrome Mobile", Ot = null, /\bOS X\b/.test(zt) ? (Gt = "Apple", zt = "iOS 4.3+") : zt = null) : /\bSRWare Iron\b/.test(Mt) && !Ot && (Ot = mn("Chrome")), Ot && Ot.indexOf(_t = /[\d.]+$/.exec(zt)) == 0 && gt.indexOf("/" + _t + "-") > -1 && (zt = dt(zt.replace(_t, ""))), zt && zt.indexOf(Mt) != -1 && !RegExp(Mt + " OS").test(zt) && (zt = zt.replace(RegExp(" *" + ut(Mt) + " *"), "")), Dt && !/\b(?:Avant|Nook)\b/.test(Mt) && (/Browser|Lunascape|Maxthon/.test(Mt) || Mt != "Safari" && /^iOS/.test(zt) && /\bSafari\b/.test(Dt[1]) || /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Samsung Internet|Sleipnir|SRWare Iron|Vivaldi|Web)/.test(Mt) && Dt[1]) && (_t = Dt[Dt.length - 1]) && Xt.push(_t), Xt.length && (Xt = ["(" + Xt.join("; ") + ")"]), Gt && Ft && Ft.indexOf(Gt) < 0 && Xt.push("on " + Gt), Ft && Xt.push((/^on /.test(Xt[Xt.length - 1]) ? "" : "on ") + Ft), zt && (_t = / ([\d.+]+)$/.exec(zt), ft = _t && zt.charAt(zt.length - _t[0].length - 1) == "/", zt = {
        architecture: 32,
        family: _t && !ft ? zt.replace(_t[0], "") : zt,
        version: _t ? _t[1] : null,
        toString: function() {
          var an = this.version;
          return this.family + (an && !ft ? " " + an : "") + (this.architecture == 64 ? " 64-bit" : "");
        }
      }), (_t = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(Yt)) && !/\bi686\b/i.test(Yt) ? (zt && (zt.architecture = 64, zt.family = zt.family.replace(RegExp(" *" + _t), "")), Mt && (/\bWOW64\b/i.test(gt) || Lt && /\w(?:86|32)$/.test(Tt.cpuClass || Tt.platform) && !/\bWin64; x64\b/i.test(gt)) && Xt.unshift("32-bit")) : zt && /^OS X/.test(zt.family) && Mt == "Chrome" && parseFloat(Ot) >= 39 && (zt.architecture = 64), gt || (gt = null);
      var Jt = {};
      return Jt.description = gt, Jt.layout = Dt && Dt[0], Jt.manufacturer = Gt, Jt.name = Mt, Jt.prerelease = Ut, Jt.product = Ft, Jt.ua = gt, Jt.version = Mt && Ot, Jt.os = zt || {
        /**
         * The CPU architecture the OS is built for.
         *
         * @memberOf platform.os
         * @type number|null
         */
        architecture: null,
        /**
         * The family of the OS.
         *
         * Common values include:
         * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
         * "Windows XP", "OS X", "Linux", "Ubuntu", "Debian", "Fedora", "Red Hat",
         * "SuSE", "Android", "iOS" and "Windows Phone"
         *
         * @memberOf platform.os
         * @type string|null
         */
        family: null,
        /**
         * The version of the OS.
         *
         * @memberOf platform.os
         * @type string|null
         */
        version: null,
        /**
         * Returns the OS string.
         *
         * @memberOf platform.os
         * @returns {string} The OS string.
         */
        toString: function() {
          return "null";
        }
      }, Jt.parse = At, Jt.toString = En, Jt.version && Xt.unshift(Ot), Jt.name && Xt.unshift(Mt), zt && Mt && !(zt == String(zt).split(" ")[0] && (zt == Mt.split(" ")[0] || Ft)) && Xt.push(Ft ? "(" + zt + ")" : "on " + zt), Xt.length && (Jt.description = Xt.join(" ")), Jt;
    }
    var pt = At();
    He && Ge ? ot(pt, function(gt, wt) {
      He[wt] = gt;
    }) : Ue.platform = pt;
  }).call(commonjsGlobal);
})(platform$6, platform$6.exports);
var platformExports = platform$6.exports;
Object.defineProperty(Platform, "__esModule", { value: !0 });
Platform.PlatformUtils = void 0;
var platform$5 = platformExports, PlatformUtils = (
  /** @class */
  function() {
    function me() {
    }
    return me.getInstance = function() {
      return this.instance || (this.instance = new me()), me.instance;
    }, me.prototype.isChromeBrowser = function() {
      return platform$5.name === "Chrome";
    }, me.prototype.isSafariBrowser = function() {
      return platform$5.name === "Safari";
    }, me.prototype.isChromeMobileBrowser = function() {
      return platform$5.name === "Chrome Mobile";
    }, me.prototype.isFirefoxBrowser = function() {
      return platform$5.name === "Firefox";
    }, me.prototype.isFirefoxMobileBrowser = function() {
      return platform$5.name === "Firefox Mobile" || platform$5.name === "Firefox for iOS";
    }, me.prototype.isOperaBrowser = function() {
      return platform$5.name === "Opera";
    }, me.prototype.isOperaMobileBrowser = function() {
      return platform$5.name === "Opera Mobile";
    }, me.prototype.isEdgeBrowser = function() {
      var ue = platform$5 != null && platform$5.version ? parseFloat(platform$5.version) : -1;
      return platform$5.name === "Microsoft Edge" && ue >= 80;
    }, me.prototype.isEdgeMobileBrowser = function() {
      var ue, Qe, Ue = platform$5 != null && platform$5.version ? parseFloat(platform$5.version) : -1;
      return platform$5.name === "Microsoft Edge" && (((ue = platform$5.os) === null || ue === void 0 ? void 0 : ue.family) === "Android" || ((Qe = platform$5.os) === null || Qe === void 0 ? void 0 : Qe.family) === "iOS") && Ue > 45;
    }, me.prototype.isAndroidBrowser = function() {
      return platform$5.name === "Android Browser";
    }, me.prototype.isElectron = function() {
      return platform$5.name === "Electron";
    }, me.prototype.isNodeJs = function() {
      return platform$5.name === "Node.js";
    }, me.prototype.isSamsungBrowser = function() {
      return platform$5.name === "Samsung Internet Mobile" || platform$5.name === "Samsung Internet";
    }, me.prototype.isMotorolaEdgeDevice = function() {
      var ue;
      return ((ue = platform$5.product) === null || ue === void 0 ? void 0 : ue.toLowerCase().includes("motorola edge")) || !1;
    }, me.prototype.isIPhoneOrIPad = function() {
      var ue = platform$5.ua ? platform$5.ua : navigator.userAgent, Qe = "ontouchend" in document, Ue = /\b(\w*Macintosh\w*)\b/.test(ue) && Qe, He = /\b(\w*iPhone\w*)\b/.test(ue) && /\b(\w*Mobile\w*)\b/.test(ue) && Qe;
      return Ue || He;
    }, me.prototype.isIOSWithSafari = function() {
      var ue = platform$5.ua ? platform$5.ua : navigator.userAgent;
      return this.isIPhoneOrIPad() && /\b(\w*Apple\w*)\b/.test(navigator.vendor) && /\b(\w*Safari\w*)\b/.test(ue) && !/\b(\w*CriOS\w*)\b/.test(ue) && !/\b(\w*FxiOS\w*)\b/.test(ue);
    }, me.prototype.isIonicIos = function() {
      return this.isIPhoneOrIPad() && platform$5.ua.indexOf("Safari") === -1;
    }, me.prototype.isIonicAndroid = function() {
      return platform$5.os.family === "Android" && platform$5.name == "Android Browser";
    }, me.prototype.isMobileDevice = function() {
      return platform$5.os.family === "iOS" || platform$5.os.family === "Android";
    }, me.prototype.isReactNative = function() {
      return !1;
    }, me.prototype.isChromium = function() {
      return this.isChromeBrowser() || this.isChromeMobileBrowser() || this.isOperaBrowser() || this.isOperaMobileBrowser() || this.isEdgeBrowser() || this.isEdgeMobileBrowser() || this.isSamsungBrowser() || this.isIonicAndroid() || this.isIonicIos() || this.isElectron() || // TODO: remove when possible
      this.isMotorolaEdgeDevice();
    }, me.prototype.canScreenShare = function() {
      var ue = platform$5 != null && platform$5.version ? parseFloat(platform$5.version) : -1;
      return this.isMobileDevice() ? !1 : this.isChromeBrowser() || this.isFirefoxBrowser() || this.isOperaBrowser() || this.isElectron() || this.isEdgeBrowser() || this.isSafariBrowser() && ue >= 13;
    }, me.prototype.getName = function() {
      return platform$5.name || "";
    }, me.prototype.getVersion = function() {
      return platform$5.version || "";
    }, me.prototype.getFamily = function() {
      return platform$5.os.family || "";
    }, me.prototype.getDescription = function() {
      return platform$5.description || "";
    }, me;
  }()
);
Platform.PlatformUtils = PlatformUtils;
function Mime$2() {
  this._types = /* @__PURE__ */ Object.create(null), this._extensions = /* @__PURE__ */ Object.create(null);
  for (let me = 0; me < arguments.length; me++)
    this.define(arguments[me]);
  this.define = this.define.bind(this), this.getType = this.getType.bind(this), this.getExtension = this.getExtension.bind(this);
}
Mime$2.prototype.define = function(me, ue) {
  for (let Qe in me) {
    let Ue = me[Qe].map(function(He) {
      return He.toLowerCase();
    });
    Qe = Qe.toLowerCase();
    for (let He = 0; He < Ue.length; He++) {
      const Ge = Ue[He];
      if (Ge[0] !== "*") {
        if (!ue && Ge in this._types)
          throw new Error(
            'Attempt to change mapping for "' + Ge + '" extension from "' + this._types[Ge] + '" to "' + Qe + '". Pass `force=true` to allow this, otherwise remove "' + Ge + '" from the list of extensions for "' + Qe + '".'
          );
        this._types[Ge] = Qe;
      }
    }
    if (ue || !this._extensions[Qe]) {
      const He = Ue[0];
      this._extensions[Qe] = He[0] !== "*" ? He : He.substr(1);
    }
  }
};
Mime$2.prototype.getType = function(me) {
  me = String(me);
  let ue = me.replace(/^.*[/\\]/, "").toLowerCase(), Qe = ue.replace(/^.*\./, "").toLowerCase(), Ue = ue.length < me.length;
  return (Qe.length < ue.length - 1 || !Ue) && this._types[Qe] || null;
};
Mime$2.prototype.getExtension = function(me) {
  return me = /^\s*([^;\s]*)/.test(me) && RegExp.$1, me && this._extensions[me.toLowerCase()] || null;
};
var Mime_1 = Mime$2, standard = { "application/andrew-inset": ["ez"], "application/applixware": ["aw"], "application/atom+xml": ["atom"], "application/atomcat+xml": ["atomcat"], "application/atomdeleted+xml": ["atomdeleted"], "application/atomsvc+xml": ["atomsvc"], "application/atsc-dwd+xml": ["dwd"], "application/atsc-held+xml": ["held"], "application/atsc-rsat+xml": ["rsat"], "application/bdoc": ["bdoc"], "application/calendar+xml": ["xcs"], "application/ccxml+xml": ["ccxml"], "application/cdfx+xml": ["cdfx"], "application/cdmi-capability": ["cdmia"], "application/cdmi-container": ["cdmic"], "application/cdmi-domain": ["cdmid"], "application/cdmi-object": ["cdmio"], "application/cdmi-queue": ["cdmiq"], "application/cu-seeme": ["cu"], "application/dash+xml": ["mpd"], "application/davmount+xml": ["davmount"], "application/docbook+xml": ["dbk"], "application/dssc+der": ["dssc"], "application/dssc+xml": ["xdssc"], "application/ecmascript": ["es", "ecma"], "application/emma+xml": ["emma"], "application/emotionml+xml": ["emotionml"], "application/epub+zip": ["epub"], "application/exi": ["exi"], "application/express": ["exp"], "application/fdt+xml": ["fdt"], "application/font-tdpfr": ["pfr"], "application/geo+json": ["geojson"], "application/gml+xml": ["gml"], "application/gpx+xml": ["gpx"], "application/gxf": ["gxf"], "application/gzip": ["gz"], "application/hjson": ["hjson"], "application/hyperstudio": ["stk"], "application/inkml+xml": ["ink", "inkml"], "application/ipfix": ["ipfix"], "application/its+xml": ["its"], "application/java-archive": ["jar", "war", "ear"], "application/java-serialized-object": ["ser"], "application/java-vm": ["class"], "application/javascript": ["js", "mjs"], "application/json": ["json", "map"], "application/json5": ["json5"], "application/jsonml+json": ["jsonml"], "application/ld+json": ["jsonld"], "application/lgr+xml": ["lgr"], "application/lost+xml": ["lostxml"], "application/mac-binhex40": ["hqx"], "application/mac-compactpro": ["cpt"], "application/mads+xml": ["mads"], "application/manifest+json": ["webmanifest"], "application/marc": ["mrc"], "application/marcxml+xml": ["mrcx"], "application/mathematica": ["ma", "nb", "mb"], "application/mathml+xml": ["mathml"], "application/mbox": ["mbox"], "application/mediaservercontrol+xml": ["mscml"], "application/metalink+xml": ["metalink"], "application/metalink4+xml": ["meta4"], "application/mets+xml": ["mets"], "application/mmt-aei+xml": ["maei"], "application/mmt-usd+xml": ["musd"], "application/mods+xml": ["mods"], "application/mp21": ["m21", "mp21"], "application/mp4": ["mp4s", "m4p"], "application/msword": ["doc", "dot"], "application/mxf": ["mxf"], "application/n-quads": ["nq"], "application/n-triples": ["nt"], "application/node": ["cjs"], "application/octet-stream": ["bin", "dms", "lrf", "mar", "so", "dist", "distz", "pkg", "bpk", "dump", "elc", "deploy", "exe", "dll", "deb", "dmg", "iso", "img", "msi", "msp", "msm", "buffer"], "application/oda": ["oda"], "application/oebps-package+xml": ["opf"], "application/ogg": ["ogx"], "application/omdoc+xml": ["omdoc"], "application/onenote": ["onetoc", "onetoc2", "onetmp", "onepkg"], "application/oxps": ["oxps"], "application/p2p-overlay+xml": ["relo"], "application/patch-ops-error+xml": ["xer"], "application/pdf": ["pdf"], "application/pgp-encrypted": ["pgp"], "application/pgp-signature": ["asc", "sig"], "application/pics-rules": ["prf"], "application/pkcs10": ["p10"], "application/pkcs7-mime": ["p7m", "p7c"], "application/pkcs7-signature": ["p7s"], "application/pkcs8": ["p8"], "application/pkix-attr-cert": ["ac"], "application/pkix-cert": ["cer"], "application/pkix-crl": ["crl"], "application/pkix-pkipath": ["pkipath"], "application/pkixcmp": ["pki"], "application/pls+xml": ["pls"], "application/postscript": ["ai", "eps", "ps"], "application/provenance+xml": ["provx"], "application/pskc+xml": ["pskcxml"], "application/raml+yaml": ["raml"], "application/rdf+xml": ["rdf", "owl"], "application/reginfo+xml": ["rif"], "application/relax-ng-compact-syntax": ["rnc"], "application/resource-lists+xml": ["rl"], "application/resource-lists-diff+xml": ["rld"], "application/rls-services+xml": ["rs"], "application/route-apd+xml": ["rapd"], "application/route-s-tsid+xml": ["sls"], "application/route-usd+xml": ["rusd"], "application/rpki-ghostbusters": ["gbr"], "application/rpki-manifest": ["mft"], "application/rpki-roa": ["roa"], "application/rsd+xml": ["rsd"], "application/rss+xml": ["rss"], "application/rtf": ["rtf"], "application/sbml+xml": ["sbml"], "application/scvp-cv-request": ["scq"], "application/scvp-cv-response": ["scs"], "application/scvp-vp-request": ["spq"], "application/scvp-vp-response": ["spp"], "application/sdp": ["sdp"], "application/senml+xml": ["senmlx"], "application/sensml+xml": ["sensmlx"], "application/set-payment-initiation": ["setpay"], "application/set-registration-initiation": ["setreg"], "application/shf+xml": ["shf"], "application/sieve": ["siv", "sieve"], "application/smil+xml": ["smi", "smil"], "application/sparql-query": ["rq"], "application/sparql-results+xml": ["srx"], "application/srgs": ["gram"], "application/srgs+xml": ["grxml"], "application/sru+xml": ["sru"], "application/ssdl+xml": ["ssdl"], "application/ssml+xml": ["ssml"], "application/swid+xml": ["swidtag"], "application/tei+xml": ["tei", "teicorpus"], "application/thraud+xml": ["tfi"], "application/timestamped-data": ["tsd"], "application/toml": ["toml"], "application/trig": ["trig"], "application/ttml+xml": ["ttml"], "application/ubjson": ["ubj"], "application/urc-ressheet+xml": ["rsheet"], "application/urc-targetdesc+xml": ["td"], "application/voicexml+xml": ["vxml"], "application/wasm": ["wasm"], "application/widget": ["wgt"], "application/winhlp": ["hlp"], "application/wsdl+xml": ["wsdl"], "application/wspolicy+xml": ["wspolicy"], "application/xaml+xml": ["xaml"], "application/xcap-att+xml": ["xav"], "application/xcap-caps+xml": ["xca"], "application/xcap-diff+xml": ["xdf"], "application/xcap-el+xml": ["xel"], "application/xcap-ns+xml": ["xns"], "application/xenc+xml": ["xenc"], "application/xhtml+xml": ["xhtml", "xht"], "application/xliff+xml": ["xlf"], "application/xml": ["xml", "xsl", "xsd", "rng"], "application/xml-dtd": ["dtd"], "application/xop+xml": ["xop"], "application/xproc+xml": ["xpl"], "application/xslt+xml": ["*xsl", "xslt"], "application/xspf+xml": ["xspf"], "application/xv+xml": ["mxml", "xhvml", "xvml", "xvm"], "application/yang": ["yang"], "application/yin+xml": ["yin"], "application/zip": ["zip"], "audio/3gpp": ["*3gpp"], "audio/adpcm": ["adp"], "audio/amr": ["amr"], "audio/basic": ["au", "snd"], "audio/midi": ["mid", "midi", "kar", "rmi"], "audio/mobile-xmf": ["mxmf"], "audio/mp3": ["*mp3"], "audio/mp4": ["m4a", "mp4a"], "audio/mpeg": ["mpga", "mp2", "mp2a", "mp3", "m2a", "m3a"], "audio/ogg": ["oga", "ogg", "spx", "opus"], "audio/s3m": ["s3m"], "audio/silk": ["sil"], "audio/wav": ["wav"], "audio/wave": ["*wav"], "audio/webm": ["weba"], "audio/xm": ["xm"], "font/collection": ["ttc"], "font/otf": ["otf"], "font/ttf": ["ttf"], "font/woff": ["woff"], "font/woff2": ["woff2"], "image/aces": ["exr"], "image/apng": ["apng"], "image/avif": ["avif"], "image/bmp": ["bmp"], "image/cgm": ["cgm"], "image/dicom-rle": ["drle"], "image/emf": ["emf"], "image/fits": ["fits"], "image/g3fax": ["g3"], "image/gif": ["gif"], "image/heic": ["heic"], "image/heic-sequence": ["heics"], "image/heif": ["heif"], "image/heif-sequence": ["heifs"], "image/hej2k": ["hej2"], "image/hsj2": ["hsj2"], "image/ief": ["ief"], "image/jls": ["jls"], "image/jp2": ["jp2", "jpg2"], "image/jpeg": ["jpeg", "jpg", "jpe"], "image/jph": ["jph"], "image/jphc": ["jhc"], "image/jpm": ["jpm"], "image/jpx": ["jpx", "jpf"], "image/jxr": ["jxr"], "image/jxra": ["jxra"], "image/jxrs": ["jxrs"], "image/jxs": ["jxs"], "image/jxsc": ["jxsc"], "image/jxsi": ["jxsi"], "image/jxss": ["jxss"], "image/ktx": ["ktx"], "image/ktx2": ["ktx2"], "image/png": ["png"], "image/sgi": ["sgi"], "image/svg+xml": ["svg", "svgz"], "image/t38": ["t38"], "image/tiff": ["tif", "tiff"], "image/tiff-fx": ["tfx"], "image/webp": ["webp"], "image/wmf": ["wmf"], "message/disposition-notification": ["disposition-notification"], "message/global": ["u8msg"], "message/global-delivery-status": ["u8dsn"], "message/global-disposition-notification": ["u8mdn"], "message/global-headers": ["u8hdr"], "message/rfc822": ["eml", "mime"], "model/3mf": ["3mf"], "model/gltf+json": ["gltf"], "model/gltf-binary": ["glb"], "model/iges": ["igs", "iges"], "model/mesh": ["msh", "mesh", "silo"], "model/mtl": ["mtl"], "model/obj": ["obj"], "model/step+xml": ["stpx"], "model/step+zip": ["stpz"], "model/step-xml+zip": ["stpxz"], "model/stl": ["stl"], "model/vrml": ["wrl", "vrml"], "model/x3d+binary": ["*x3db", "x3dbz"], "model/x3d+fastinfoset": ["x3db"], "model/x3d+vrml": ["*x3dv", "x3dvz"], "model/x3d+xml": ["x3d", "x3dz"], "model/x3d-vrml": ["x3dv"], "text/cache-manifest": ["appcache", "manifest"], "text/calendar": ["ics", "ifb"], "text/coffeescript": ["coffee", "litcoffee"], "text/css": ["css"], "text/csv": ["csv"], "text/html": ["html", "htm", "shtml"], "text/jade": ["jade"], "text/jsx": ["jsx"], "text/less": ["less"], "text/markdown": ["markdown", "md"], "text/mathml": ["mml"], "text/mdx": ["mdx"], "text/n3": ["n3"], "text/plain": ["txt", "text", "conf", "def", "list", "log", "in", "ini"], "text/richtext": ["rtx"], "text/rtf": ["*rtf"], "text/sgml": ["sgml", "sgm"], "text/shex": ["shex"], "text/slim": ["slim", "slm"], "text/spdx": ["spdx"], "text/stylus": ["stylus", "styl"], "text/tab-separated-values": ["tsv"], "text/troff": ["t", "tr", "roff", "man", "me", "ms"], "text/turtle": ["ttl"], "text/uri-list": ["uri", "uris", "urls"], "text/vcard": ["vcard"], "text/vtt": ["vtt"], "text/xml": ["*xml"], "text/yaml": ["yaml", "yml"], "video/3gpp": ["3gp", "3gpp"], "video/3gpp2": ["3g2"], "video/h261": ["h261"], "video/h263": ["h263"], "video/h264": ["h264"], "video/iso.segment": ["m4s"], "video/jpeg": ["jpgv"], "video/jpm": ["*jpm", "jpgm"], "video/mj2": ["mj2", "mjp2"], "video/mp2t": ["ts"], "video/mp4": ["mp4", "mp4v", "mpg4"], "video/mpeg": ["mpeg", "mpg", "mpe", "m1v", "m2v"], "video/ogg": ["ogv"], "video/quicktime": ["qt", "mov"], "video/webm": ["webm"] };
let Mime$1 = Mime_1;
var lite = new Mime$1(standard);
Object.defineProperty(LocalRecorder$1, "__esModule", { value: !0 });
LocalRecorder$1.LocalRecorder = void 0;
var LocalRecorderState_1 = LocalRecorderState, OpenViduLogger_1$a = OpenViduLogger$1, Platform_1$5 = Platform, Mime = lite, logger$a = OpenViduLogger_1$a.OpenViduLogger.getInstance(), platform$4, LocalRecorder = (
  /** @class */
  function() {
    function me(ue) {
      this.stream = ue, this.chunks = [], platform$4 = Platform_1$5.PlatformUtils.getInstance(), this.connectionId = this.stream.connection ? this.stream.connection.connectionId : "default-connection", this.id = this.stream.streamId + "_" + this.connectionId + "_localrecord", this.state = LocalRecorderState_1.LocalRecorderState.READY;
    }
    return me.prototype.record = function(ue) {
      var Qe = this;
      return new Promise(function(Ue, He) {
        try {
          if (typeof ue == "string" || ue instanceof String)
            return He(`When calling LocalRecorder.record(options) parameter 'options' cannot be a string. Must be an object like { mimeType: "`.concat(ue, '" }'));
          if (typeof MediaRecorder > "u")
            throw logger$a.error("MediaRecorder not supported on your device. See compatibility in https://caniuse.com/#search=MediaRecorder"), Error("MediaRecorder not supported on your device. See compatibility in https://caniuse.com/#search=MediaRecorder");
          if (Qe.state !== LocalRecorderState_1.LocalRecorderState.READY)
            throw Error("'LocalRecord.record()' needs 'LocalRecord.state' to be 'READY' (current value: '" + Qe.state + "'). Call 'LocalRecorder.clean()' or init a new LocalRecorder before");
          logger$a.log("Starting local recording of stream '" + Qe.stream.streamId + "' of connection '" + Qe.connectionId + "'"), ue ? ue.mimeType || (ue.mimeType = "video/webm") : ue = { mimeType: "video/webm" }, Qe.mediaRecorder = new MediaRecorder(Qe.stream.getMediaStream(), ue), Qe.mediaRecorder.start();
        } catch (Ge) {
          return He(Ge);
        }
        return Qe.mediaRecorder.ondataavailable = function(Ge) {
          Ge.data.size > 0 && Qe.chunks.push(Ge.data);
        }, Qe.mediaRecorder.onerror = function(Ge) {
          logger$a.error("MediaRecorder error: ", Ge);
        }, Qe.mediaRecorder.onstart = function() {
          logger$a.log("MediaRecorder started (state=" + Qe.mediaRecorder.state + ")");
        }, Qe.mediaRecorder.onstop = function() {
          Qe.onStopDefault();
        }, Qe.mediaRecorder.onpause = function() {
          logger$a.log("MediaRecorder paused (state=" + Qe.mediaRecorder.state + ")");
        }, Qe.mediaRecorder.onresume = function() {
          logger$a.log("MediaRecorder resumed (state=" + Qe.mediaRecorder.state + ")");
        }, Qe.state = LocalRecorderState_1.LocalRecorderState.RECORDING, Ue();
      });
    }, me.prototype.stop = function() {
      var ue = this;
      return new Promise(function(Qe, Ue) {
        try {
          if (ue.state === LocalRecorderState_1.LocalRecorderState.READY || ue.state === LocalRecorderState_1.LocalRecorderState.FINISHED)
            throw Error("'LocalRecord.stop()' needs 'LocalRecord.state' to be 'RECORDING' or 'PAUSED' (current value: '" + ue.state + "'). Call 'LocalRecorder.start()' before");
          ue.mediaRecorder.onstop = function() {
            return ue.onStopDefault(), Qe();
          }, ue.mediaRecorder.stop();
        } catch (He) {
          return Ue(He);
        }
      });
    }, me.prototype.pause = function() {
      var ue = this;
      return new Promise(function(Qe, Ue) {
        try {
          return ue.state !== LocalRecorderState_1.LocalRecorderState.RECORDING ? Ue(Error("'LocalRecord.pause()' needs 'LocalRecord.state' to be 'RECORDING' (current value: '" + ue.state + "'). Call 'LocalRecorder.start()' or 'LocalRecorder.resume()' before")) : (ue.mediaRecorder.pause(), ue.state = LocalRecorderState_1.LocalRecorderState.PAUSED, Qe());
        } catch (He) {
          return Ue(He);
        }
      });
    }, me.prototype.resume = function() {
      var ue = this;
      return new Promise(function(Qe, Ue) {
        try {
          if (ue.state !== LocalRecorderState_1.LocalRecorderState.PAUSED)
            throw Error("'LocalRecord.resume()' needs 'LocalRecord.state' to be 'PAUSED' (current value: '" + ue.state + "'). Call 'LocalRecorder.pause()' before");
          return ue.mediaRecorder.resume(), ue.state = LocalRecorderState_1.LocalRecorderState.RECORDING, Qe();
        } catch (He) {
          return Ue(He);
        }
      });
    }, me.prototype.preview = function(ue) {
      if (this.state !== LocalRecorderState_1.LocalRecorderState.FINISHED)
        throw Error("'LocalRecord.preview()' needs 'LocalRecord.state' to be 'FINISHED' (current value: '" + this.state + "'). Call 'LocalRecorder.stop()' before");
      if (this.videoPreview = document.createElement("video"), this.videoPreview.id = this.id, this.videoPreview.autoplay = !0, platform$4.isSafariBrowser() && (this.videoPreview.playsInline = !0), typeof ue == "string") {
        var Qe = document.getElementById(ue);
        Qe && (this.videoPreview = Qe.appendChild(this.videoPreview));
      } else
        this.videoPreview = ue.appendChild(this.videoPreview);
      return this.videoPreview.src = this.videoPreviewSrc, this.videoPreview;
    }, me.prototype.clean = function() {
      var ue = this, Qe = function() {
        delete ue.blob, ue.chunks = [], ue.state = LocalRecorderState_1.LocalRecorderState.READY;
      };
      this.state === LocalRecorderState_1.LocalRecorderState.RECORDING || this.state === LocalRecorderState_1.LocalRecorderState.PAUSED ? this.stop().then(function() {
        return Qe();
      }).catch(function() {
        return Qe();
      }) : Qe();
    }, me.prototype.download = function() {
      if (this.state !== LocalRecorderState_1.LocalRecorderState.FINISHED)
        throw Error("'LocalRecord.download()' needs 'LocalRecord.state' to be 'FINISHED' (current value: '" + this.state + "'). Call 'LocalRecorder.stop()' before");
      var ue = document.createElement("a");
      ue.style.display = "none", document.body.appendChild(ue);
      var Qe = globalThis.URL.createObjectURL(this.blob);
      ue.href = Qe, ue.download = this.id + "." + Mime.getExtension(this.blob.type), ue.click(), globalThis.URL.revokeObjectURL(Qe), document.body.removeChild(ue);
    }, me.prototype.getBlob = function() {
      if (this.state !== LocalRecorderState_1.LocalRecorderState.FINISHED)
        throw Error("Call 'LocalRecord.stop()' before getting Blob file");
      return this.blob;
    }, me.prototype.uploadAsBinary = function(ue, Qe) {
      var Ue = this;
      return new Promise(function(He, Ge) {
        if (Ue.state !== LocalRecorderState_1.LocalRecorderState.FINISHED)
          return Ge(Error("'LocalRecord.uploadAsBinary()' needs 'LocalRecord.state' to be 'FINISHED' (current value: '" + Ue.state + "'). Call 'LocalRecorder.stop()' before"));
        var Xe = new XMLHttpRequest();
        if (Xe.open("POST", ue, !0), typeof Qe == "object")
          for (var Ke = 0, $e = Object.keys(Qe); Ke < $e.length; Ke++) {
            var Je = $e[Ke];
            Xe.setRequestHeader(Je, Qe[Je]);
          }
        Xe.onreadystatechange = function() {
          if (Xe.readyState === 4)
            return Xe.status.toString().charAt(0) === "2" ? He(Xe.responseText) : Ge(Xe.status);
        }, Xe.send(Ue.blob);
      });
    }, me.prototype.uploadAsMultipartfile = function(ue, Qe) {
      var Ue = this;
      return new Promise(function(He, Ge) {
        if (Ue.state !== LocalRecorderState_1.LocalRecorderState.FINISHED)
          return Ge(Error("'LocalRecord.uploadAsMultipartfile()' needs 'LocalRecord.state' to be 'FINISHED' (current value: '" + Ue.state + "'). Call 'LocalRecorder.stop()' before"));
        var Xe = new XMLHttpRequest();
        if (Xe.open("POST", ue, !0), typeof Qe == "object")
          for (var Ke = 0, $e = Object.keys(Qe); Ke < $e.length; Ke++) {
            var Je = $e[Ke];
            Xe.setRequestHeader(Je, Qe[Je]);
          }
        var Ze = new FormData();
        Ze.append("file", Ue.blob, Ue.id + "." + Mime.getExtension(Ue.blob.type)), Xe.onreadystatechange = function() {
          if (Xe.readyState === 4)
            return Xe.status.toString().charAt(0) === "2" ? He(Xe.responseText) : Ge(Xe.status);
        }, Xe.send(Ze);
      });
    }, me.prototype.onStopDefault = function() {
      logger$a.log("MediaRecorder stopped  (state=" + this.mediaRecorder.state + ")"), this.blob = new Blob(this.chunks, { type: this.mediaRecorder.mimeType }), this.chunks = [], this.videoPreviewSrc = globalThis.URL.createObjectURL(this.blob), this.state = LocalRecorderState_1.LocalRecorderState.FINISHED;
    }, me;
  }()
);
LocalRecorder$1.LocalRecorder = LocalRecorder;
var Publisher = {}, Session = {}, Connection$1 = {}, Stream$2 = {}, Filter$1 = {}, StreamPropertyChangedEvent$1 = {}, Event$2 = {};
Object.defineProperty(Event$2, "__esModule", { value: !0 });
Event$2.Event = void 0;
var Event$1 = (
  /** @class */
  function() {
    function me(ue, Qe, Ue) {
      this.hasBeenPrevented = !1, this.cancelable = ue, this.target = Qe, this.type = Ue;
    }
    return me.prototype.isDefaultPrevented = function() {
      return this.hasBeenPrevented;
    }, me.prototype.preventDefault = function() {
      this.callDefaultBehavior = function() {
      }, this.hasBeenPrevented = !0;
    }, me;
  }()
);
Event$2.Event = Event$1;
var __extends$1p = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) Object.prototype.hasOwnProperty.call(He, Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    if (typeof Qe != "function" && Qe !== null)
      throw new TypeError("Class extends value " + String(Qe) + " is not a constructor or null");
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}();
Object.defineProperty(StreamPropertyChangedEvent$1, "__esModule", { value: !0 });
StreamPropertyChangedEvent$1.StreamPropertyChangedEvent = void 0;
var Event_1$b = Event$2, StreamPropertyChangedEvent = (
  /** @class */
  function(me) {
    __extends$1p(ue, me);
    function ue(Qe, Ue, He, Ge, Xe, Ke) {
      var $e = me.call(this, !1, Qe, "streamPropertyChanged") || this;
      return $e.stream = Ue, $e.changedProperty = He, $e.newValue = Ge, $e.oldValue = Xe, $e.reason = Ke, $e;
    }
    return ue.prototype.callDefaultBehavior = function() {
    }, ue;
  }(Event_1$b.Event)
);
StreamPropertyChangedEvent$1.StreamPropertyChangedEvent = StreamPropertyChangedEvent;
var OpenViduError = {};
(function(me) {
  Object.defineProperty(me, "__esModule", { value: !0 }), me.OpenViduError = me.OpenViduErrorName = void 0, function(Qe) {
    Qe.BROWSER_NOT_SUPPORTED = "BROWSER_NOT_SUPPORTED", Qe.DEVICE_ACCESS_DENIED = "DEVICE_ACCESS_DENIED", Qe.DEVICE_ALREADY_IN_USE = "DEVICE_ALREADY_IN_USE", Qe.SCREEN_CAPTURE_DENIED = "SCREEN_CAPTURE_DENIED", Qe.SCREEN_SHARING_NOT_SUPPORTED = "SCREEN_SHARING_NOT_SUPPORTED", Qe.SCREEN_EXTENSION_NOT_INSTALLED = "SCREEN_EXTENSION_NOT_INSTALLED", Qe.SCREEN_EXTENSION_DISABLED = "SCREEN_EXTENSION_DISABLED", Qe.INPUT_VIDEO_DEVICE_NOT_FOUND = "INPUT_VIDEO_DEVICE_NOT_FOUND", Qe.INPUT_AUDIO_DEVICE_NOT_FOUND = "INPUT_AUDIO_DEVICE_NOT_FOUND", Qe.INPUT_AUDIO_DEVICE_GENERIC_ERROR = "INPUT_AUDIO_DEVICE_GENERIC_ERROR", Qe.NO_INPUT_SOURCE_SET = "NO_INPUT_SOURCE_SET", Qe.PUBLISHER_PROPERTIES_ERROR = "PUBLISHER_PROPERTIES_ERROR", Qe.OPENVIDU_PERMISSION_DENIED = "OPENVIDU_PERMISSION_DENIED", Qe.OPENVIDU_NOT_CONNECTED = "OPENVIDU_NOT_CONNECTED", Qe.VIRTUAL_BACKGROUND_ERROR = "VIRTUAL_BACKGROUND_ERROR", Qe.GENERIC_ERROR = "GENERIC_ERROR";
  }(me.OpenViduErrorName || (me.OpenViduErrorName = {}));
  var ue = (
    /** @class */
    /* @__PURE__ */ function() {
      function Qe(Ue, He) {
        this.name = Ue, this.message = He;
      }
      return Qe;
    }()
  );
  me.OpenViduError = ue;
})(OpenViduError);
Object.defineProperty(Filter$1, "__esModule", { value: !0 });
Filter$1.Filter = void 0;
var StreamPropertyChangedEvent_1$2 = StreamPropertyChangedEvent$1, OpenViduError_1$2 = OpenViduError, OpenViduLogger_1$9 = OpenViduLogger$1, logger$9 = OpenViduLogger_1$9.OpenViduLogger.getInstance(), Filter = (
  /** @class */
  function() {
    function me(ue, Qe) {
      this.handlers = /* @__PURE__ */ new Map(), this.type = ue, this.options = Qe;
    }
    return me.prototype.execMethod = function(ue, Qe) {
      var Ue = this;
      return new Promise(function(He, Ge) {
        var Xe;
        logger$9.info("Executing filter method to stream " + Ue.stream.streamId);
        var Ke, $e = function(nt) {
          logger$9.info("Filter method successfully executed on Stream " + Ue.stream.streamId);
          var tt = Object.assign({}, Ue.stream.filter);
          return Ue.stream.filter.lastExecMethod = { method: ue, params: Ke }, nt && (Ue.stream.session.emitEvent("streamPropertyChanged", [
            new StreamPropertyChangedEvent_1$2.StreamPropertyChangedEvent(Ue.stream.session, Ue.stream, "filter", Ue.stream.filter, tt, "execFilterMethod")
          ]), Ue.stream.streamManager.emitEvent("streamPropertyChanged", [
            new StreamPropertyChangedEvent_1$2.StreamPropertyChangedEvent(Ue.stream.streamManager, Ue.stream, "filter", Ue.stream.filter, tt, "execFilterMethod")
          ])), He();
        };
        if (Ue.type.startsWith("VB:")) {
          if (typeof Qe == "string")
            try {
              Qe = JSON.parse(Qe);
            } catch (nt) {
              return Ge(new OpenViduError_1$2.OpenViduError(OpenViduError_1$2.OpenViduErrorName.VIRTUAL_BACKGROUND_ERROR, "Wrong params syntax: " + nt));
            }
          if (Ke = Qe, ue === "update")
            if (!((Xe = Ue.stream.virtualBackgroundSinkElements) === null || Xe === void 0) && Xe.VB)
              Ue.stream.virtualBackgroundSinkElements.VB.updateValues(Qe).then(function() {
                return $e(!1);
              }).catch(function(nt) {
                return nt.name === OpenViduError_1$2.OpenViduErrorName.VIRTUAL_BACKGROUND_ERROR ? Ge(new OpenViduError_1$2.OpenViduError(nt.name, nt.message)) : Ge(new OpenViduError_1$2.OpenViduError(OpenViduError_1$2.OpenViduErrorName.VIRTUAL_BACKGROUND_ERROR, "Error updating values on Virtual Background filter: " + nt));
              });
            else
              return Ge(new OpenViduError_1$2.OpenViduError(OpenViduError_1$2.OpenViduErrorName.VIRTUAL_BACKGROUND_ERROR, "There is no Virtual Background filter applied"));
          else
            return Ge(new OpenViduError_1$2.OpenViduError(OpenViduError_1$2.OpenViduErrorName.VIRTUAL_BACKGROUND_ERROR, 'Unknown Virtual Background method "'.concat(ue, '"')));
        } else {
          var Je = void 0;
          if (typeof Qe != "string")
            try {
              Je = JSON.stringify(Qe);
            } catch {
              var Ze = "'params' property must be a JSON formatted object";
              return logger$9.error(Ze), Ge(Ze);
            }
          else
            Je = Qe;
          Ke = Je, Ue.stream.session.openvidu.sendRequest("execFilterMethod", { streamId: Ue.stream.streamId, method: ue, params: Je }, function(nt, tt) {
            return nt ? (logger$9.error("Error executing filter method for Stream " + Ue.stream.streamId, nt), nt.code === 401 ? Ge(new OpenViduError_1$2.OpenViduError(OpenViduError_1$2.OpenViduErrorName.OPENVIDU_PERMISSION_DENIED, "You don't have permissions to execute a filter method")) : Ge(nt)) : $e(!0);
          });
        }
      });
    }, me.prototype.addEventListener = function(ue, Qe) {
      var Ue = this;
      return new Promise(function(He, Ge) {
        logger$9.info("Adding filter event listener to event " + ue + " to stream " + Ue.stream.streamId), Ue.stream.session.openvidu.sendRequest("addFilterEventListener", { streamId: Ue.stream.streamId, eventType: ue }, function(Xe, Ke) {
          return Xe ? (logger$9.error("Error adding filter event listener to event " + ue + "for Stream " + Ue.stream.streamId, Xe), Xe.code === 401 ? Ge(new OpenViduError_1$2.OpenViduError(OpenViduError_1$2.OpenViduErrorName.OPENVIDU_PERMISSION_DENIED, "You don't have permissions to add a filter event listener")) : Ge(Xe)) : (Ue.handlers.set(ue, Qe), logger$9.info("Filter event listener to event " + ue + " successfully applied on Stream " + Ue.stream.streamId), He());
        });
      });
    }, me.prototype.removeEventListener = function(ue) {
      var Qe = this;
      return new Promise(function(Ue, He) {
        logger$9.info("Removing filter event listener to event " + ue + " to stream " + Qe.stream.streamId), Qe.stream.session.openvidu.sendRequest("removeFilterEventListener", { streamId: Qe.stream.streamId, eventType: ue }, function(Ge, Xe) {
          return Ge ? (logger$9.error("Error removing filter event listener to event " + ue + "for Stream " + Qe.stream.streamId, Ge), Ge.code === 401 ? He(new OpenViduError_1$2.OpenViduError(OpenViduError_1$2.OpenViduErrorName.OPENVIDU_PERMISSION_DENIED, "You don't have permissions to add a filter event listener")) : He(Ge)) : (Qe.handlers.delete(ue), logger$9.info("Filter event listener to event " + ue + " successfully removed on Stream " + Qe.stream.streamId), Ue());
        });
      });
    }, me;
  }()
);
Filter$1.Filter = Filter;
var Subscriber$1 = {}, StreamManager$1 = {}, EventDispatcher$1 = {}, EventEmitter$4 = { exports: {} };
/*!
 * EventEmitter v5.2.9 - git.io/ee
 * Unlicense - http://unlicense.org/
 * Oliver Caldwell - https://oli.me.uk/
 * @preserve
 */
(function(me) {
  (function(ue) {
    function Qe() {
    }
    var Ue = Qe.prototype, He = ue.EventEmitter;
    function Ge($e, Je) {
      for (var Ze = $e.length; Ze--; )
        if ($e[Ze].listener === Je)
          return Ze;
      return -1;
    }
    function Xe($e) {
      return function() {
        return this[$e].apply(this, arguments);
      };
    }
    Ue.getListeners = function(Je) {
      var Ze = this._getEvents(), nt, tt;
      if (Je instanceof RegExp) {
        nt = {};
        for (tt in Ze)
          Ze.hasOwnProperty(tt) && Je.test(tt) && (nt[tt] = Ze[tt]);
      } else
        nt = Ze[Je] || (Ze[Je] = []);
      return nt;
    }, Ue.flattenListeners = function(Je) {
      var Ze = [], nt;
      for (nt = 0; nt < Je.length; nt += 1)
        Ze.push(Je[nt].listener);
      return Ze;
    }, Ue.getListenersAsObject = function(Je) {
      var Ze = this.getListeners(Je), nt;
      return Ze instanceof Array && (nt = {}, nt[Je] = Ze), nt || Ze;
    };
    function Ke($e) {
      return typeof $e == "function" || $e instanceof RegExp ? !0 : $e && typeof $e == "object" ? Ke($e.listener) : !1;
    }
    Ue.addListener = function(Je, Ze) {
      if (!Ke(Ze))
        throw new TypeError("listener must be a function");
      var nt = this.getListenersAsObject(Je), tt = typeof Ze == "object", et;
      for (et in nt)
        nt.hasOwnProperty(et) && Ge(nt[et], Ze) === -1 && nt[et].push(tt ? Ze : {
          listener: Ze,
          once: !1
        });
      return this;
    }, Ue.on = Xe("addListener"), Ue.addOnceListener = function(Je, Ze) {
      return this.addListener(Je, {
        listener: Ze,
        once: !0
      });
    }, Ue.once = Xe("addOnceListener"), Ue.defineEvent = function(Je) {
      return this.getListeners(Je), this;
    }, Ue.defineEvents = function(Je) {
      for (var Ze = 0; Ze < Je.length; Ze += 1)
        this.defineEvent(Je[Ze]);
      return this;
    }, Ue.removeListener = function(Je, Ze) {
      var nt = this.getListenersAsObject(Je), tt, et;
      for (et in nt)
        nt.hasOwnProperty(et) && (tt = Ge(nt[et], Ze), tt !== -1 && nt[et].splice(tt, 1));
      return this;
    }, Ue.off = Xe("removeListener"), Ue.addListeners = function(Je, Ze) {
      return this.manipulateListeners(!1, Je, Ze);
    }, Ue.removeListeners = function(Je, Ze) {
      return this.manipulateListeners(!0, Je, Ze);
    }, Ue.manipulateListeners = function(Je, Ze, nt) {
      var tt, et, rt = Je ? this.removeListener : this.addListener, it = Je ? this.removeListeners : this.addListeners;
      if (typeof Ze == "object" && !(Ze instanceof RegExp))
        for (tt in Ze)
          Ze.hasOwnProperty(tt) && (et = Ze[tt]) && (typeof et == "function" ? rt.call(this, tt, et) : it.call(this, tt, et));
      else
        for (tt = nt.length; tt--; )
          rt.call(this, Ze, nt[tt]);
      return this;
    }, Ue.removeEvent = function(Je) {
      var Ze = typeof Je, nt = this._getEvents(), tt;
      if (Ze === "string")
        delete nt[Je];
      else if (Je instanceof RegExp)
        for (tt in nt)
          nt.hasOwnProperty(tt) && Je.test(tt) && delete nt[tt];
      else
        delete this._events;
      return this;
    }, Ue.removeAllListeners = Xe("removeEvent"), Ue.emitEvent = function(Je, Ze) {
      var nt = this.getListenersAsObject(Je), tt, et, rt, it, ot;
      for (it in nt)
        if (nt.hasOwnProperty(it))
          for (tt = nt[it].slice(0), rt = 0; rt < tt.length; rt++)
            et = tt[rt], et.once === !0 && this.removeListener(Je, et.listener), ot = et.listener.apply(this, Ze || []), ot === this._getOnceReturnValue() && this.removeListener(Je, et.listener);
      return this;
    }, Ue.trigger = Xe("emitEvent"), Ue.emit = function(Je) {
      var Ze = Array.prototype.slice.call(arguments, 1);
      return this.emitEvent(Je, Ze);
    }, Ue.setOnceReturnValue = function(Je) {
      return this._onceReturnValue = Je, this;
    }, Ue._getOnceReturnValue = function() {
      return this.hasOwnProperty("_onceReturnValue") ? this._onceReturnValue : !0;
    }, Ue._getEvents = function() {
      return this._events || (this._events = {});
    }, Qe.noConflict = function() {
      return ue.EventEmitter = He, Qe;
    }, me.exports ? me.exports = Qe : ue.EventEmitter = Qe;
  })(typeof window < "u" ? window : commonjsGlobal || {});
})(EventEmitter$4);
var EventEmitterExports = EventEmitter$4.exports;
Object.defineProperty(EventDispatcher$1, "__esModule", { value: !0 });
EventDispatcher$1.EventDispatcher = void 0;
var OpenViduLogger_1$8 = OpenViduLogger$1, EventEmitter$3 = EventEmitterExports, logger$8 = OpenViduLogger_1$8.OpenViduLogger.getInstance(), EventDispatcher = (
  /** @class */
  function() {
    function me() {
      this.userHandlerArrowHandler = /* @__PURE__ */ new WeakMap(), this.ee = new EventEmitter$3();
    }
    return me.prototype.onAux = function(ue, Qe, Ue) {
      var He = function(Ge) {
        Ge ? logger$8.debug(Qe, Ge) : logger$8.debug(Qe), Ue(Ge);
      };
      return this.userHandlerArrowHandler.set(Ue, He), this.ee.on(ue, He), this;
    }, me.prototype.onceAux = function(ue, Qe, Ue) {
      var He = this, Ge = function(Xe) {
        Xe ? logger$8.debug(Qe, Xe) : logger$8.debug(Qe), Ue(Xe), He.userHandlerArrowHandler.delete(Ue);
      };
      return this.userHandlerArrowHandler.set(Ue, Ge), this.ee.once(ue, Ge), this;
    }, me.prototype.offAux = function(ue, Qe) {
      if (!Qe)
        this.ee.removeAllListeners(ue);
      else {
        var Ue = this.userHandlerArrowHandler.get(Qe);
        Ue && this.ee.off(ue, Ue), this.userHandlerArrowHandler.delete(Qe);
      }
      return this;
    }, me;
  }()
);
EventDispatcher$1.EventDispatcher = EventDispatcher;
var StreamManagerEvent$1 = {}, __extends$1o = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) Object.prototype.hasOwnProperty.call(He, Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    if (typeof Qe != "function" && Qe !== null)
      throw new TypeError("Class extends value " + String(Qe) + " is not a constructor or null");
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}();
Object.defineProperty(StreamManagerEvent$1, "__esModule", { value: !0 });
StreamManagerEvent$1.StreamManagerEvent = void 0;
var Event_1$a = Event$2, StreamManagerEvent = (
  /** @class */
  function(me) {
    __extends$1o(ue, me);
    function ue(Qe, Ue, He) {
      var Ge = me.call(this, !1, Qe, Ue) || this;
      return Ge.value = He, Ge;
    }
    return ue.prototype.callDefaultBehavior = function() {
    }, ue;
  }(Event_1$a.Event)
);
StreamManagerEvent$1.StreamManagerEvent = StreamManagerEvent;
var VideoElementEvent$1 = {}, __extends$1n = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) Object.prototype.hasOwnProperty.call(He, Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    if (typeof Qe != "function" && Qe !== null)
      throw new TypeError("Class extends value " + String(Qe) + " is not a constructor or null");
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}();
Object.defineProperty(VideoElementEvent$1, "__esModule", { value: !0 });
VideoElementEvent$1.VideoElementEvent = void 0;
var Event_1$9 = Event$2, VideoElementEvent = (
  /** @class */
  function(me) {
    __extends$1n(ue, me);
    function ue(Qe, Ue, He) {
      var Ge = me.call(this, !1, Ue, He) || this;
      return Ge.element = Qe, Ge;
    }
    return ue.prototype.callDefaultBehavior = function() {
    }, ue;
  }(Event_1$9.Event)
);
VideoElementEvent$1.VideoElementEvent = VideoElementEvent;
var ExceptionEvent = {};
(function(me) {
  var ue = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
    var He = function(Ge, Xe) {
      return He = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ke, $e) {
        Ke.__proto__ = $e;
      } || function(Ke, $e) {
        for (var Je in $e) Object.prototype.hasOwnProperty.call($e, Je) && (Ke[Je] = $e[Je]);
      }, He(Ge, Xe);
    };
    return function(Ge, Xe) {
      if (typeof Xe != "function" && Xe !== null)
        throw new TypeError("Class extends value " + String(Xe) + " is not a constructor or null");
      He(Ge, Xe);
      function Ke() {
        this.constructor = Ge;
      }
      Ge.prototype = Xe === null ? Object.create(Xe) : (Ke.prototype = Xe.prototype, new Ke());
    };
  }();
  Object.defineProperty(me, "__esModule", { value: !0 }), me.ExceptionEvent = me.ExceptionEventName = void 0;
  var Qe = Event$2;
  (function(He) {
    He.ICE_CANDIDATE_ERROR = "ICE_CANDIDATE_ERROR", He.ICE_CONNECTION_FAILED = "ICE_CONNECTION_FAILED", He.ICE_CONNECTION_DISCONNECTED = "ICE_CONNECTION_DISCONNECTED", He.NO_STREAM_PLAYING_EVENT = "NO_STREAM_PLAYING_EVENT", He.SPEECH_TO_TEXT_DISCONNECTED = "SPEECH_TO_TEXT_DISCONNECTED";
  })(me.ExceptionEventName || (me.ExceptionEventName = {}));
  var Ue = (
    /** @class */
    function(He) {
      ue(Ge, He);
      function Ge(Xe, Ke, $e, Je, Ze) {
        var nt = He.call(this, !1, Xe, "exception") || this;
        return nt.name = Ke, nt.origin = $e, nt.message = Je, nt.data = Ze, nt;
      }
      return Ge.prototype.callDefaultBehavior = function() {
      }, Ge;
    }(Qe.Event)
  );
  me.ExceptionEvent = Ue;
})(ExceptionEvent);
var VideoInsertMode = {};
(function(me) {
  Object.defineProperty(me, "__esModule", { value: !0 }), me.VideoInsertMode = void 0, function(ue) {
    ue.AFTER = "AFTER", ue.APPEND = "APPEND", ue.BEFORE = "BEFORE", ue.PREPEND = "PREPEND", ue.REPLACE = "REPLACE";
  }(me.VideoInsertMode || (me.VideoInsertMode = {}));
})(VideoInsertMode);
var __extends$1m = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) Object.prototype.hasOwnProperty.call(He, Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    if (typeof Qe != "function" && Qe !== null)
      throw new TypeError("Class extends value " + String(Qe) + " is not a constructor or null");
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}();
Object.defineProperty(StreamManager$1, "__esModule", { value: !0 });
StreamManager$1.StreamManager = void 0;
var EventDispatcher_1 = EventDispatcher$1, StreamManagerEvent_1$1 = StreamManagerEvent$1, VideoElementEvent_1 = VideoElementEvent$1, ExceptionEvent_1$3 = ExceptionEvent, VideoInsertMode_1$1 = VideoInsertMode, OpenViduLogger_1$7 = OpenViduLogger$1, Platform_1$4 = Platform, logger$7 = OpenViduLogger_1$7.OpenViduLogger.getInstance(), platform$3, StreamManager = (
  /** @class */
  function(me) {
    __extends$1m(ue, me);
    function ue(Qe, Ue) {
      var He = me.call(this) || this;
      if (He.videos = [], He.lazyLaunchVideoElementCreatedEvent = !1, platform$3 = Platform_1$4.PlatformUtils.getInstance(), He.stream = Qe, He.stream.streamManager = He, He.remote = !He.stream.isLocal(), Ue) {
        var Ge = void 0;
        typeof Ue == "string" ? Ge = document.getElementById(Ue) : Ue instanceof HTMLElement && (Ge = Ue), Ge && (He.firstVideoElement = {
          targetElement: Ge,
          video: document.createElement("video"),
          id: "",
          canplayListenerAdded: !1
        }, (platform$3.isSafariBrowser() || platform$3.isIPhoneOrIPad() && (platform$3.isChromeMobileBrowser() || platform$3.isEdgeMobileBrowser() || platform$3.isOperaMobileBrowser() || platform$3.isFirefoxMobileBrowser())) && (He.firstVideoElement.video.playsInline = !0), He.targetElement = Ge, He.element = Ge);
      }
      return He.canPlayListener = function() {
        He.deactivateStreamPlayingEventExceptionTimeout(), He.ee.emitEvent("streamPlaying", [new StreamManagerEvent_1$1.StreamManagerEvent(He, "streamPlaying", void 0)]);
      }, He;
    }
    return ue.prototype.on = function(Qe, Ue) {
      return me.prototype.onAux.call(this, Qe, "Event '" + Qe + "' triggered by '" + (this.remote ? "Subscriber" : "Publisher") + "'", Ue), Qe === "videoElementCreated" && this.stream && this.lazyLaunchVideoElementCreatedEvent && (this.ee.emitEvent("videoElementCreated", [new VideoElementEvent_1.VideoElementEvent(this.videos[0].video, this, "videoElementCreated")]), this.lazyLaunchVideoElementCreatedEvent = !1), Qe === "streamPlaying" && this.videos[0] && this.videos[0].video && this.videos[0].video.currentTime > 0 && this.videos[0].video.paused === !1 && this.videos[0].video.ended === !1 && this.videos[0].video.readyState === 4 && this.ee.emitEvent("streamPlaying", [new StreamManagerEvent_1$1.StreamManagerEvent(this, "streamPlaying", void 0)]), this.stream.hasAudio && (Qe === "publisherStartSpeaking" && this.stream.enableHarkSpeakingEvent(), Qe === "publisherStopSpeaking" && this.stream.enableHarkStoppedSpeakingEvent(), Qe === "streamAudioVolumeChange" && this.stream.enableHarkVolumeChangeEvent(!1)), this;
    }, ue.prototype.once = function(Qe, Ue) {
      return me.prototype.onceAux.call(this, Qe, "Event '" + Qe + "' triggered once by '" + (this.remote ? "Subscriber" : "Publisher") + "'", Ue), Qe === "videoElementCreated" && this.stream && this.lazyLaunchVideoElementCreatedEvent && this.ee.emitEvent("videoElementCreated", [new VideoElementEvent_1.VideoElementEvent(this.videos[0].video, this, "videoElementCreated")]), Qe === "streamPlaying" && this.videos[0] && this.videos[0].video && this.videos[0].video.currentTime > 0 && this.videos[0].video.paused === !1 && this.videos[0].video.ended === !1 && this.videos[0].video.readyState === 4 && this.ee.emitEvent("streamPlaying", [new StreamManagerEvent_1$1.StreamManagerEvent(this, "streamPlaying", void 0)]), this.stream.hasAudio && (Qe === "publisherStartSpeaking" && this.stream.enableOnceHarkSpeakingEvent(), Qe === "publisherStopSpeaking" && this.stream.enableOnceHarkStoppedSpeakingEvent(), Qe === "streamAudioVolumeChange" && this.stream.enableOnceHarkVolumeChangeEvent(!1)), this;
    }, ue.prototype.off = function(Qe, Ue) {
      if (me.prototype.offAux.call(this, Qe, Ue), Qe === "publisherStartSpeaking") {
        var He = this.ee.getListeners(Qe).length + this.stream.session.ee.getListeners(Qe).length;
        He === 0 && this.stream.disableHarkSpeakingEvent(!1);
      }
      if (Qe === "publisherStopSpeaking") {
        var Ge = this.ee.getListeners(Qe).length + this.stream.session.ee.getListeners(Qe).length;
        Ge === 0 && this.stream.disableHarkStoppedSpeakingEvent(!1);
      }
      if (Qe === "streamAudioVolumeChange") {
        var Xe = this.ee.getListeners(Qe).length;
        Xe === 0 && this.stream.disableHarkVolumeChangeEvent(!1);
      }
      return this;
    }, ue.prototype.addVideoElement = function(Qe) {
      this.initializeVideoProperties(Qe), !this.remote && this.stream.displayMyRemote() && Qe.srcObject !== this.stream.getMediaStream() && (Qe.srcObject = this.stream.getMediaStream());
      for (var Ue = 0, He = this.videos; Ue < He.length; Ue++) {
        var Ge = He[Ue];
        if (Ge.video === Qe)
          return 0;
      }
      for (var Xe = 1, Ke = 0, $e = this.stream.session.streamManagers; Ke < $e.length; Ke++) {
        var Je = $e[Ke];
        if (Je.disassociateVideo(Qe)) {
          Xe = -1;
          break;
        }
      }
      return this.stream.session.streamManagers.forEach(function(Ze) {
        Ze.disassociateVideo(Qe);
      }), this.pushNewStreamManagerVideo({
        video: Qe,
        id: Qe.id,
        canplayListenerAdded: !1
      }), logger$7.info("New video element associated to ", this), Xe;
    }, ue.prototype.createVideoElement = function(Qe, Ue) {
      var He;
      if (typeof Qe == "string") {
        if (He = document.getElementById(Qe), !He)
          throw new Error("The provided 'targetElement' couldn't be resolved to any HTML element: " + Qe);
      } else if (Qe instanceof HTMLElement)
        He = Qe;
      else
        throw new Error("The provided 'targetElement' couldn't be resolved to any HTML element: " + Qe);
      var Ge = this.createVideo();
      this.initializeVideoProperties(Ge);
      var Xe = Ue || VideoInsertMode_1$1.VideoInsertMode.APPEND;
      switch (Xe) {
        case VideoInsertMode_1$1.VideoInsertMode.AFTER:
          He.parentNode.insertBefore(Ge, He.nextSibling);
          break;
        case VideoInsertMode_1$1.VideoInsertMode.APPEND:
          He.appendChild(Ge);
          break;
        case VideoInsertMode_1$1.VideoInsertMode.BEFORE:
          He.parentNode.insertBefore(Ge, He);
          break;
        case VideoInsertMode_1$1.VideoInsertMode.PREPEND:
          He.insertBefore(Ge, He.childNodes[0]);
          break;
        case VideoInsertMode_1$1.VideoInsertMode.REPLACE:
          He.parentNode.replaceChild(Ge, He);
          break;
        default:
          Xe = VideoInsertMode_1$1.VideoInsertMode.APPEND, He.appendChild(Ge);
          break;
      }
      var Ke = {
        targetElement: He,
        video: Ge,
        insertMode: Xe,
        id: Ge.id,
        canplayListenerAdded: !1
      };
      return this.pushNewStreamManagerVideo(Ke), this.ee.emitEvent("videoElementCreated", [new VideoElementEvent_1.VideoElementEvent(Ke.video, this, "videoElementCreated")]), this.lazyLaunchVideoElementCreatedEvent = !!this.firstVideoElement, Ge;
    }, ue.prototype.updatePublisherSpeakingEventsOptions = function(Qe) {
      var Ue = this.stream.harkOptions ? this.stream.harkOptions : this.stream.session.openvidu.advancedConfiguration.publisherSpeakingEventsOptions || {}, He = typeof Qe.interval == "number" ? Qe.interval : typeof Ue.interval == "number" ? Ue.interval : 100, Ge = typeof Qe.threshold == "number" ? Qe.threshold : typeof Ue.threshold == "number" ? Ue.threshold : -50;
      this.stream.harkOptions = {
        interval: He,
        threshold: Ge
      }, this.stream.speechEvent && (this.stream.speechEvent.setInterval(He), this.stream.speechEvent.setThreshold(Ge));
    }, ue.prototype.initializeVideoProperties = function(Qe) {
      !this.remote && this.stream.displayMyRemote() || Qe.srcObject !== this.stream.getMediaStream() && (Qe.srcObject = this.stream.getMediaStream()), Qe.autoplay = !0, Qe.controls = !1, (platform$3.isSafariBrowser() || platform$3.isIPhoneOrIPad() && (platform$3.isChromeMobileBrowser() || platform$3.isEdgeMobileBrowser() || platform$3.isOperaMobileBrowser() || platform$3.isFirefoxMobileBrowser())) && (Qe.playsInline = !0), Qe.id || (Qe.id = (this.remote ? "remote-" : "local-") + "video-" + this.stream.streamId, !this.id && this.targetElement && (this.id = Qe.id)), this.remote && this.isMirroredVideo(Qe) ? this.removeMirrorVideo(Qe) : !this.remote && !this.stream.displayMyRemote() && (Qe.muted = !0, this.isMirroredVideo(Qe) && !this.stream.outboundStreamOpts.publisherProperties.mirror ? this.removeMirrorVideo(Qe) : this.stream.outboundStreamOpts.publisherProperties.mirror && !this.stream.isSendScreen() && this.mirrorVideo(Qe));
    }, ue.prototype.removeAllVideos = function() {
      for (var Qe = this, Ue = this.stream.session.streamManagers.length - 1; Ue >= 0; --Ue)
        this.stream.session.streamManagers[Ue] === this && this.stream.session.streamManagers.splice(Ue, 1);
      this.videos.forEach(function(He) {
        He.video && He.video.removeEventListener && He.video.removeEventListener("canplay", Qe.canPlayListener), He.canplayListenerAdded = !1, He.targetElement && (He.video.parentNode.removeChild(He.video), Qe.ee.emitEvent("videoElementDestroyed", [
          new VideoElementEvent_1.VideoElementEvent(He.video, Qe, "videoElementDestroyed")
        ])), Qe.removeSrcObject(He), Qe.videos.filter(function(Ge) {
          return !Ge.targetElement;
        });
      });
    }, ue.prototype.disassociateVideo = function(Qe) {
      for (var Ue = !1, He = 0; He < this.videos.length; He++)
        if (this.videos[He].video === Qe) {
          this.videos[He].video.removeEventListener("canplay", this.canPlayListener), this.videos.splice(He, 1), Ue = !0, logger$7.info("Video element disassociated from ", this);
          break;
        }
      return Ue;
    }, ue.prototype.addPlayEventToFirstVideo = function() {
      this.videos[0] && this.videos[0].video && !this.videos[0].canplayListenerAdded && (this.activateStreamPlayingEventExceptionTimeout(), this.videos[0].video.addEventListener("canplay", this.canPlayListener), this.videos[0].canplayListenerAdded = !0);
    }, ue.prototype.updateMediaStream = function(Qe) {
      this.videos.forEach(function(Ue) {
        if (Ue.video.srcObject = Qe, platform$3.isIonicIos()) {
          var He = Ue.video.parentElement, Ge = Ue.video;
          He.replaceChild(Ge, Ue.video), Ue.video = Ge;
        }
      });
    }, ue.prototype.emitEvent = function(Qe, Ue) {
      this.ee.emitEvent(Qe, Ue);
    }, ue.prototype.createVideo = function() {
      return document.createElement("video");
    }, ue.prototype.removeSrcObject = function(Qe) {
      Qe.video.srcObject = null, this.deactivateStreamPlayingEventExceptionTimeout();
    }, ue.prototype.pushNewStreamManagerVideo = function(Qe) {
      this.videos.push(Qe), this.addPlayEventToFirstVideo(), this.stream.session.streamManagers.indexOf(this) === -1 && this.stream.session.streamManagers.push(this);
    }, ue.prototype.mirrorVideo = function(Qe) {
      platform$3.isIonicIos() || (Qe.style.transform = "rotateY(180deg)", Qe.style.webkitTransform = "rotateY(180deg)");
    }, ue.prototype.removeMirrorVideo = function(Qe) {
      Qe.style.transform = "unset", Qe.style.webkitTransform = "unset";
    }, ue.prototype.isMirroredVideo = function(Qe) {
      return Qe.style.transform === "rotateY(180deg)" || Qe.style.webkitTransform === "rotateY(180deg)";
    }, ue.prototype.activateStreamPlayingEventExceptionTimeout = function() {
      var Qe = this;
      if (this.remote && this.streamPlayingEventExceptionTimeout == null) {
        var Ue = this.stream.session.openvidu.advancedConfiguration.noStreamPlayingEventExceptionTimeout || 4e3;
        this.streamPlayingEventExceptionTimeout = setTimeout(function() {
          var He = "StreamManager of Stream " + Qe.stream.streamId + " (" + (Qe.remote ? "Subscriber" : "Publisher") + ') did not trigger "streamPlaying" event in ' + Ue + " ms";
          logger$7.warn(He), Qe.stream.session.emitEvent("exception", [
            new ExceptionEvent_1$3.ExceptionEvent(Qe.stream.session, ExceptionEvent_1$3.ExceptionEventName.NO_STREAM_PLAYING_EVENT, Qe, He)
          ]), delete Qe.streamPlayingEventExceptionTimeout;
        }, Ue);
      }
    }, ue.prototype.deactivateStreamPlayingEventExceptionTimeout = function() {
      clearTimeout(this.streamPlayingEventExceptionTimeout), delete this.streamPlayingEventExceptionTimeout;
    }, ue;
  }(EventDispatcher_1.EventDispatcher)
);
StreamManager$1.StreamManager = StreamManager;
var __extends$1l = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) Object.prototype.hasOwnProperty.call(He, Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    if (typeof Qe != "function" && Qe !== null)
      throw new TypeError("Class extends value " + String(Qe) + " is not a constructor or null");
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}();
Object.defineProperty(Subscriber$1, "__esModule", { value: !0 });
Subscriber$1.Subscriber = void 0;
var StreamManager_1 = StreamManager$1, OpenViduLogger_1$6 = OpenViduLogger$1, logger$6 = OpenViduLogger_1$6.OpenViduLogger.getInstance(), Subscriber = (
  /** @class */
  function(me) {
    __extends$1l(ue, me);
    function ue(Qe, Ue, He) {
      var Ge = me.call(this, Qe, Ue) || this;
      return Ge.element = Ge.targetElement, Ge.stream = Qe, Ge.properties = He, Ge;
    }
    return ue.prototype.subscribeToAudio = function(Qe) {
      return this.stream.getMediaStream().getAudioTracks().forEach(function(Ue) {
        Ue.enabled = Qe;
      }), this.stream.audioActive = Qe, logger$6.info("'Subscriber' has " + (Qe ? "subscribed to" : "unsubscribed from") + " its audio stream"), this;
    }, ue.prototype.subscribeToVideo = function(Qe) {
      return this.stream.getMediaStream().getVideoTracks().forEach(function(Ue) {
        Ue.enabled = Qe;
      }), this.stream.videoActive = Qe, logger$6.info("'Subscriber' has " + (Qe ? "subscribed to" : "unsubscribed from") + " its video stream"), this;
    }, ue.prototype.replaceTrackInMediaStream = function(Qe, Ue) {
      var He = this.stream.getMediaStream(), Ge;
      Qe.kind === "video" ? (Ge = He.getVideoTracks()[0], Ue && (this.stream.lastVideoTrackConstraints = Qe.getConstraints())) : Ge = He.getAudioTracks()[0], He.removeTrack(Ge), Ge.stop(), He.addTrack(Qe);
    }, ue;
  }(StreamManager_1.StreamManager)
);
Subscriber$1.Subscriber = Subscriber;
var WebRtcPeer$1 = {}, protocols = [
  "stun:",
  "turn:"
], normalice$1 = function(me) {
  var ue = (me || {}).url || me, Qe, Ue, He = {};
  return typeof ue != "string" && !(ue instanceof String) || (ue = ue.trim(), Qe = protocols[protocols.indexOf(ue.slice(0, 5))], !Qe) ? me : (ue = ue.slice(5), Ue = ue.split("@"), He.username = me.username, He.credential = me.credential, Ue.length > 1 && (ue = Ue[1], Ue = Ue[0].split(":"), He.username = Ue[0], He.credential = (me || {}).credential || Ue[1] || ""), He.url = Qe + ue, He.urls = [He.url], He);
};
const require$$1 = [
  "stun.l.google.com:19302",
  "stun1.l.google.com:19302",
  "stun2.l.google.com:19302",
  "stun3.l.google.com:19302",
  "stun4.l.google.com:19302",
  "stun.ekiga.net",
  "stun.ideasip.com",
  "stun.schlund.de",
  "stun.stunprotocol.org:3478",
  "stun.voiparound.com",
  "stun.voipbuster.com",
  "stun.voipstunt.com",
  "stun.voxgratia.org"
], require$$2 = [];
var normalice = normalice$1, freeice$1 = function(me) {
  var ue = {
    stun: (me || {}).stun || require$$1,
    turn: (me || {}).turn || require$$2
  }, Qe = (me || {}).stunCount || 2, Ue = (me || {}).turnCount || 0, He;
  function Ge(Xe, Ke) {
    for (var $e = [], Je = [].concat(ue[Xe]), Ze; Je.length && $e.length < Ke; )
      Ze = Math.random() * Je.length | 0, $e = $e.concat(Je.splice(Ze, 1));
    return $e.map(function(nt) {
      return typeof nt != "string" && !(nt instanceof String) ? nt : normalice(Xe + ":" + nt);
    });
  }
  return He = [].concat(Ge("stun", Qe)), Ue && (He = He.concat(Ge("turn", Ue))), He;
}, freeice_1 = freeice$1, commonjsBrowser = {}, v1$1 = {}, rng$1 = {};
Object.defineProperty(rng$1, "__esModule", {
  value: !0
});
rng$1.default = rng;
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues && (getRandomValues = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !getRandomValues))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return getRandomValues(rnds8);
}
var stringify$3 = {}, validate$1 = {}, regex = {};
Object.defineProperty(regex, "__esModule", {
  value: !0
});
regex.default = void 0;
var _default$e = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
regex.default = _default$e;
Object.defineProperty(validate$1, "__esModule", {
  value: !0
});
validate$1.default = void 0;
var _regex = _interopRequireDefault$h(regex);
function _interopRequireDefault$h(me) {
  return me && me.__esModule ? me : { default: me };
}
function validate(me) {
  return typeof me == "string" && _regex.default.test(me);
}
var _default$d = validate;
validate$1.default = _default$d;
Object.defineProperty(stringify$3, "__esModule", {
  value: !0
});
stringify$3.default = void 0;
stringify$3.unsafeStringify = unsafeStringify;
var _validate$2 = _interopRequireDefault$g(validate$1);
function _interopRequireDefault$g(me) {
  return me && me.__esModule ? me : { default: me };
}
const byteToHex = [];
for (let me = 0; me < 256; ++me)
  byteToHex.push((me + 256).toString(16).slice(1));
function unsafeStringify(me, ue = 0) {
  return (byteToHex[me[ue + 0]] + byteToHex[me[ue + 1]] + byteToHex[me[ue + 2]] + byteToHex[me[ue + 3]] + "-" + byteToHex[me[ue + 4]] + byteToHex[me[ue + 5]] + "-" + byteToHex[me[ue + 6]] + byteToHex[me[ue + 7]] + "-" + byteToHex[me[ue + 8]] + byteToHex[me[ue + 9]] + "-" + byteToHex[me[ue + 10]] + byteToHex[me[ue + 11]] + byteToHex[me[ue + 12]] + byteToHex[me[ue + 13]] + byteToHex[me[ue + 14]] + byteToHex[me[ue + 15]]).toLowerCase();
}
function stringify$2(me, ue = 0) {
  const Qe = unsafeStringify(me, ue);
  if (!(0, _validate$2.default)(Qe))
    throw TypeError("Stringified UUID is invalid");
  return Qe;
}
var _default$c = stringify$2;
stringify$3.default = _default$c;
Object.defineProperty(v1$1, "__esModule", {
  value: !0
});
v1$1.default = void 0;
var _rng$1 = _interopRequireDefault$f(rng$1), _stringify$2 = stringify$3;
function _interopRequireDefault$f(me) {
  return me && me.__esModule ? me : { default: me };
}
let _nodeId, _clockseq, _lastMSecs = 0, _lastNSecs = 0;
function v1(me, ue, Qe) {
  let Ue = ue && Qe || 0;
  const He = ue || new Array(16);
  me = me || {};
  let Ge = me.node || _nodeId, Xe = me.clockseq !== void 0 ? me.clockseq : _clockseq;
  if (Ge == null || Xe == null) {
    const tt = me.random || (me.rng || _rng$1.default)();
    Ge == null && (Ge = _nodeId = [tt[0] | 1, tt[1], tt[2], tt[3], tt[4], tt[5]]), Xe == null && (Xe = _clockseq = (tt[6] << 8 | tt[7]) & 16383);
  }
  let Ke = me.msecs !== void 0 ? me.msecs : Date.now(), $e = me.nsecs !== void 0 ? me.nsecs : _lastNSecs + 1;
  const Je = Ke - _lastMSecs + ($e - _lastNSecs) / 1e4;
  if (Je < 0 && me.clockseq === void 0 && (Xe = Xe + 1 & 16383), (Je < 0 || Ke > _lastMSecs) && me.nsecs === void 0 && ($e = 0), $e >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  _lastMSecs = Ke, _lastNSecs = $e, _clockseq = Xe, Ke += 122192928e5;
  const Ze = ((Ke & 268435455) * 1e4 + $e) % 4294967296;
  He[Ue++] = Ze >>> 24 & 255, He[Ue++] = Ze >>> 16 & 255, He[Ue++] = Ze >>> 8 & 255, He[Ue++] = Ze & 255;
  const nt = Ke / 4294967296 * 1e4 & 268435455;
  He[Ue++] = nt >>> 8 & 255, He[Ue++] = nt & 255, He[Ue++] = nt >>> 24 & 15 | 16, He[Ue++] = nt >>> 16 & 255, He[Ue++] = Xe >>> 8 | 128, He[Ue++] = Xe & 255;
  for (let tt = 0; tt < 6; ++tt)
    He[Ue + tt] = Ge[tt];
  return ue || (0, _stringify$2.unsafeStringify)(He);
}
var _default$b = v1;
v1$1.default = _default$b;
var v3$1 = {}, v35$1 = {}, parse$4 = {};
Object.defineProperty(parse$4, "__esModule", {
  value: !0
});
parse$4.default = void 0;
var _validate$1 = _interopRequireDefault$e(validate$1);
function _interopRequireDefault$e(me) {
  return me && me.__esModule ? me : { default: me };
}
function parse$3(me) {
  if (!(0, _validate$1.default)(me))
    throw TypeError("Invalid UUID");
  let ue;
  const Qe = new Uint8Array(16);
  return Qe[0] = (ue = parseInt(me.slice(0, 8), 16)) >>> 24, Qe[1] = ue >>> 16 & 255, Qe[2] = ue >>> 8 & 255, Qe[3] = ue & 255, Qe[4] = (ue = parseInt(me.slice(9, 13), 16)) >>> 8, Qe[5] = ue & 255, Qe[6] = (ue = parseInt(me.slice(14, 18), 16)) >>> 8, Qe[7] = ue & 255, Qe[8] = (ue = parseInt(me.slice(19, 23), 16)) >>> 8, Qe[9] = ue & 255, Qe[10] = (ue = parseInt(me.slice(24, 36), 16)) / 1099511627776 & 255, Qe[11] = ue / 4294967296 & 255, Qe[12] = ue >>> 24 & 255, Qe[13] = ue >>> 16 & 255, Qe[14] = ue >>> 8 & 255, Qe[15] = ue & 255, Qe;
}
var _default$a = parse$3;
parse$4.default = _default$a;
Object.defineProperty(v35$1, "__esModule", {
  value: !0
});
v35$1.URL = v35$1.DNS = void 0;
v35$1.default = v35;
var _stringify$1 = stringify$3, _parse = _interopRequireDefault$d(parse$4);
function _interopRequireDefault$d(me) {
  return me && me.__esModule ? me : { default: me };
}
function stringToBytes$1(me) {
  me = unescape(encodeURIComponent(me));
  const ue = [];
  for (let Qe = 0; Qe < me.length; ++Qe)
    ue.push(me.charCodeAt(Qe));
  return ue;
}
const DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
v35$1.DNS = DNS;
const URL$1 = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
v35$1.URL = URL$1;
function v35(me, ue, Qe) {
  function Ue(He, Ge, Xe, Ke) {
    var $e;
    if (typeof He == "string" && (He = stringToBytes$1(He)), typeof Ge == "string" && (Ge = (0, _parse.default)(Ge)), (($e = Ge) === null || $e === void 0 ? void 0 : $e.length) !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    let Je = new Uint8Array(16 + He.length);
    if (Je.set(Ge), Je.set(He, Ge.length), Je = Qe(Je), Je[6] = Je[6] & 15 | ue, Je[8] = Je[8] & 63 | 128, Xe) {
      Ke = Ke || 0;
      for (let Ze = 0; Ze < 16; ++Ze)
        Xe[Ke + Ze] = Je[Ze];
      return Xe;
    }
    return (0, _stringify$1.unsafeStringify)(Je);
  }
  try {
    Ue.name = me;
  } catch {
  }
  return Ue.DNS = DNS, Ue.URL = URL$1, Ue;
}
var md5$1 = {};
Object.defineProperty(md5$1, "__esModule", {
  value: !0
});
md5$1.default = void 0;
function md5(me) {
  if (typeof me == "string") {
    const ue = unescape(encodeURIComponent(me));
    me = new Uint8Array(ue.length);
    for (let Qe = 0; Qe < ue.length; ++Qe)
      me[Qe] = ue.charCodeAt(Qe);
  }
  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(me), me.length * 8));
}
function md5ToHexEncodedArray(me) {
  const ue = [], Qe = me.length * 32, Ue = "0123456789abcdef";
  for (let He = 0; He < Qe; He += 8) {
    const Ge = me[He >> 5] >>> He % 32 & 255, Xe = parseInt(Ue.charAt(Ge >>> 4 & 15) + Ue.charAt(Ge & 15), 16);
    ue.push(Xe);
  }
  return ue;
}
function getOutputLength(me) {
  return (me + 64 >>> 9 << 4) + 14 + 1;
}
function wordsToMd5(me, ue) {
  me[ue >> 5] |= 128 << ue % 32, me[getOutputLength(ue) - 1] = ue;
  let Qe = 1732584193, Ue = -271733879, He = -1732584194, Ge = 271733878;
  for (let Xe = 0; Xe < me.length; Xe += 16) {
    const Ke = Qe, $e = Ue, Je = He, Ze = Ge;
    Qe = md5ff(Qe, Ue, He, Ge, me[Xe], 7, -680876936), Ge = md5ff(Ge, Qe, Ue, He, me[Xe + 1], 12, -389564586), He = md5ff(He, Ge, Qe, Ue, me[Xe + 2], 17, 606105819), Ue = md5ff(Ue, He, Ge, Qe, me[Xe + 3], 22, -1044525330), Qe = md5ff(Qe, Ue, He, Ge, me[Xe + 4], 7, -176418897), Ge = md5ff(Ge, Qe, Ue, He, me[Xe + 5], 12, 1200080426), He = md5ff(He, Ge, Qe, Ue, me[Xe + 6], 17, -1473231341), Ue = md5ff(Ue, He, Ge, Qe, me[Xe + 7], 22, -45705983), Qe = md5ff(Qe, Ue, He, Ge, me[Xe + 8], 7, 1770035416), Ge = md5ff(Ge, Qe, Ue, He, me[Xe + 9], 12, -1958414417), He = md5ff(He, Ge, Qe, Ue, me[Xe + 10], 17, -42063), Ue = md5ff(Ue, He, Ge, Qe, me[Xe + 11], 22, -1990404162), Qe = md5ff(Qe, Ue, He, Ge, me[Xe + 12], 7, 1804603682), Ge = md5ff(Ge, Qe, Ue, He, me[Xe + 13], 12, -40341101), He = md5ff(He, Ge, Qe, Ue, me[Xe + 14], 17, -1502002290), Ue = md5ff(Ue, He, Ge, Qe, me[Xe + 15], 22, 1236535329), Qe = md5gg(Qe, Ue, He, Ge, me[Xe + 1], 5, -165796510), Ge = md5gg(Ge, Qe, Ue, He, me[Xe + 6], 9, -1069501632), He = md5gg(He, Ge, Qe, Ue, me[Xe + 11], 14, 643717713), Ue = md5gg(Ue, He, Ge, Qe, me[Xe], 20, -373897302), Qe = md5gg(Qe, Ue, He, Ge, me[Xe + 5], 5, -701558691), Ge = md5gg(Ge, Qe, Ue, He, me[Xe + 10], 9, 38016083), He = md5gg(He, Ge, Qe, Ue, me[Xe + 15], 14, -660478335), Ue = md5gg(Ue, He, Ge, Qe, me[Xe + 4], 20, -405537848), Qe = md5gg(Qe, Ue, He, Ge, me[Xe + 9], 5, 568446438), Ge = md5gg(Ge, Qe, Ue, He, me[Xe + 14], 9, -1019803690), He = md5gg(He, Ge, Qe, Ue, me[Xe + 3], 14, -187363961), Ue = md5gg(Ue, He, Ge, Qe, me[Xe + 8], 20, 1163531501), Qe = md5gg(Qe, Ue, He, Ge, me[Xe + 13], 5, -1444681467), Ge = md5gg(Ge, Qe, Ue, He, me[Xe + 2], 9, -51403784), He = md5gg(He, Ge, Qe, Ue, me[Xe + 7], 14, 1735328473), Ue = md5gg(Ue, He, Ge, Qe, me[Xe + 12], 20, -1926607734), Qe = md5hh(Qe, Ue, He, Ge, me[Xe + 5], 4, -378558), Ge = md5hh(Ge, Qe, Ue, He, me[Xe + 8], 11, -2022574463), He = md5hh(He, Ge, Qe, Ue, me[Xe + 11], 16, 1839030562), Ue = md5hh(Ue, He, Ge, Qe, me[Xe + 14], 23, -35309556), Qe = md5hh(Qe, Ue, He, Ge, me[Xe + 1], 4, -1530992060), Ge = md5hh(Ge, Qe, Ue, He, me[Xe + 4], 11, 1272893353), He = md5hh(He, Ge, Qe, Ue, me[Xe + 7], 16, -155497632), Ue = md5hh(Ue, He, Ge, Qe, me[Xe + 10], 23, -1094730640), Qe = md5hh(Qe, Ue, He, Ge, me[Xe + 13], 4, 681279174), Ge = md5hh(Ge, Qe, Ue, He, me[Xe], 11, -358537222), He = md5hh(He, Ge, Qe, Ue, me[Xe + 3], 16, -722521979), Ue = md5hh(Ue, He, Ge, Qe, me[Xe + 6], 23, 76029189), Qe = md5hh(Qe, Ue, He, Ge, me[Xe + 9], 4, -640364487), Ge = md5hh(Ge, Qe, Ue, He, me[Xe + 12], 11, -421815835), He = md5hh(He, Ge, Qe, Ue, me[Xe + 15], 16, 530742520), Ue = md5hh(Ue, He, Ge, Qe, me[Xe + 2], 23, -995338651), Qe = md5ii(Qe, Ue, He, Ge, me[Xe], 6, -198630844), Ge = md5ii(Ge, Qe, Ue, He, me[Xe + 7], 10, 1126891415), He = md5ii(He, Ge, Qe, Ue, me[Xe + 14], 15, -1416354905), Ue = md5ii(Ue, He, Ge, Qe, me[Xe + 5], 21, -57434055), Qe = md5ii(Qe, Ue, He, Ge, me[Xe + 12], 6, 1700485571), Ge = md5ii(Ge, Qe, Ue, He, me[Xe + 3], 10, -1894986606), He = md5ii(He, Ge, Qe, Ue, me[Xe + 10], 15, -1051523), Ue = md5ii(Ue, He, Ge, Qe, me[Xe + 1], 21, -2054922799), Qe = md5ii(Qe, Ue, He, Ge, me[Xe + 8], 6, 1873313359), Ge = md5ii(Ge, Qe, Ue, He, me[Xe + 15], 10, -30611744), He = md5ii(He, Ge, Qe, Ue, me[Xe + 6], 15, -1560198380), Ue = md5ii(Ue, He, Ge, Qe, me[Xe + 13], 21, 1309151649), Qe = md5ii(Qe, Ue, He, Ge, me[Xe + 4], 6, -145523070), Ge = md5ii(Ge, Qe, Ue, He, me[Xe + 11], 10, -1120210379), He = md5ii(He, Ge, Qe, Ue, me[Xe + 2], 15, 718787259), Ue = md5ii(Ue, He, Ge, Qe, me[Xe + 9], 21, -343485551), Qe = safeAdd(Qe, Ke), Ue = safeAdd(Ue, $e), He = safeAdd(He, Je), Ge = safeAdd(Ge, Ze);
  }
  return [Qe, Ue, He, Ge];
}
function bytesToWords(me) {
  if (me.length === 0)
    return [];
  const ue = me.length * 8, Qe = new Uint32Array(getOutputLength(ue));
  for (let Ue = 0; Ue < ue; Ue += 8)
    Qe[Ue >> 5] |= (me[Ue / 8] & 255) << Ue % 32;
  return Qe;
}
function safeAdd(me, ue) {
  const Qe = (me & 65535) + (ue & 65535);
  return (me >> 16) + (ue >> 16) + (Qe >> 16) << 16 | Qe & 65535;
}
function bitRotateLeft(me, ue) {
  return me << ue | me >>> 32 - ue;
}
function md5cmn(me, ue, Qe, Ue, He, Ge) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(ue, me), safeAdd(Ue, Ge)), He), Qe);
}
function md5ff(me, ue, Qe, Ue, He, Ge, Xe) {
  return md5cmn(ue & Qe | ~ue & Ue, me, ue, He, Ge, Xe);
}
function md5gg(me, ue, Qe, Ue, He, Ge, Xe) {
  return md5cmn(ue & Ue | Qe & ~Ue, me, ue, He, Ge, Xe);
}
function md5hh(me, ue, Qe, Ue, He, Ge, Xe) {
  return md5cmn(ue ^ Qe ^ Ue, me, ue, He, Ge, Xe);
}
function md5ii(me, ue, Qe, Ue, He, Ge, Xe) {
  return md5cmn(Qe ^ (ue | ~Ue), me, ue, He, Ge, Xe);
}
var _default$9 = md5;
md5$1.default = _default$9;
Object.defineProperty(v3$1, "__esModule", {
  value: !0
});
v3$1.default = void 0;
var _v$1 = _interopRequireDefault$c(v35$1), _md = _interopRequireDefault$c(md5$1);
function _interopRequireDefault$c(me) {
  return me && me.__esModule ? me : { default: me };
}
const v3 = (0, _v$1.default)("v3", 48, _md.default);
var _default$8 = v3;
v3$1.default = _default$8;
var v4$1 = {}, native = {};
Object.defineProperty(native, "__esModule", {
  value: !0
});
native.default = void 0;
const randomUUID = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var _default$7 = {
  randomUUID
};
native.default = _default$7;
Object.defineProperty(v4$1, "__esModule", {
  value: !0
});
v4$1.default = void 0;
var _native = _interopRequireDefault$b(native), _rng = _interopRequireDefault$b(rng$1), _stringify = stringify$3;
function _interopRequireDefault$b(me) {
  return me && me.__esModule ? me : { default: me };
}
function v4(me, ue, Qe) {
  if (_native.default.randomUUID && !ue && !me)
    return _native.default.randomUUID();
  me = me || {};
  const Ue = me.random || (me.rng || _rng.default)();
  if (Ue[6] = Ue[6] & 15 | 64, Ue[8] = Ue[8] & 63 | 128, ue) {
    Qe = Qe || 0;
    for (let He = 0; He < 16; ++He)
      ue[Qe + He] = Ue[He];
    return ue;
  }
  return (0, _stringify.unsafeStringify)(Ue);
}
var _default$6 = v4;
v4$1.default = _default$6;
var v5$1 = {}, sha1$3 = {};
Object.defineProperty(sha1$3, "__esModule", {
  value: !0
});
sha1$3.default = void 0;
function f$1(me, ue, Qe, Ue) {
  switch (me) {
    case 0:
      return ue & Qe ^ ~ue & Ue;
    case 1:
      return ue ^ Qe ^ Ue;
    case 2:
      return ue & Qe ^ ue & Ue ^ Qe & Ue;
    case 3:
      return ue ^ Qe ^ Ue;
  }
}
function ROTL(me, ue) {
  return me << ue | me >>> 32 - ue;
}
function sha1$2(me) {
  const ue = [1518500249, 1859775393, 2400959708, 3395469782], Qe = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof me == "string") {
    const Xe = unescape(encodeURIComponent(me));
    me = [];
    for (let Ke = 0; Ke < Xe.length; ++Ke)
      me.push(Xe.charCodeAt(Ke));
  } else Array.isArray(me) || (me = Array.prototype.slice.call(me));
  me.push(128);
  const Ue = me.length / 4 + 2, He = Math.ceil(Ue / 16), Ge = new Array(He);
  for (let Xe = 0; Xe < He; ++Xe) {
    const Ke = new Uint32Array(16);
    for (let $e = 0; $e < 16; ++$e)
      Ke[$e] = me[Xe * 64 + $e * 4] << 24 | me[Xe * 64 + $e * 4 + 1] << 16 | me[Xe * 64 + $e * 4 + 2] << 8 | me[Xe * 64 + $e * 4 + 3];
    Ge[Xe] = Ke;
  }
  Ge[He - 1][14] = (me.length - 1) * 8 / Math.pow(2, 32), Ge[He - 1][14] = Math.floor(Ge[He - 1][14]), Ge[He - 1][15] = (me.length - 1) * 8 & 4294967295;
  for (let Xe = 0; Xe < He; ++Xe) {
    const Ke = new Uint32Array(80);
    for (let et = 0; et < 16; ++et)
      Ke[et] = Ge[Xe][et];
    for (let et = 16; et < 80; ++et)
      Ke[et] = ROTL(Ke[et - 3] ^ Ke[et - 8] ^ Ke[et - 14] ^ Ke[et - 16], 1);
    let $e = Qe[0], Je = Qe[1], Ze = Qe[2], nt = Qe[3], tt = Qe[4];
    for (let et = 0; et < 80; ++et) {
      const rt = Math.floor(et / 20), it = ROTL($e, 5) + f$1(rt, Je, Ze, nt) + tt + ue[rt] + Ke[et] >>> 0;
      tt = nt, nt = Ze, Ze = ROTL(Je, 30) >>> 0, Je = $e, $e = it;
    }
    Qe[0] = Qe[0] + $e >>> 0, Qe[1] = Qe[1] + Je >>> 0, Qe[2] = Qe[2] + Ze >>> 0, Qe[3] = Qe[3] + nt >>> 0, Qe[4] = Qe[4] + tt >>> 0;
  }
  return [Qe[0] >> 24 & 255, Qe[0] >> 16 & 255, Qe[0] >> 8 & 255, Qe[0] & 255, Qe[1] >> 24 & 255, Qe[1] >> 16 & 255, Qe[1] >> 8 & 255, Qe[1] & 255, Qe[2] >> 24 & 255, Qe[2] >> 16 & 255, Qe[2] >> 8 & 255, Qe[2] & 255, Qe[3] >> 24 & 255, Qe[3] >> 16 & 255, Qe[3] >> 8 & 255, Qe[3] & 255, Qe[4] >> 24 & 255, Qe[4] >> 16 & 255, Qe[4] >> 8 & 255, Qe[4] & 255];
}
var _default$5 = sha1$2;
sha1$3.default = _default$5;
Object.defineProperty(v5$1, "__esModule", {
  value: !0
});
v5$1.default = void 0;
var _v = _interopRequireDefault$a(v35$1), _sha = _interopRequireDefault$a(sha1$3);
function _interopRequireDefault$a(me) {
  return me && me.__esModule ? me : { default: me };
}
const v5 = (0, _v.default)("v5", 80, _sha.default);
var _default$4 = v5;
v5$1.default = _default$4;
var nil = {};
Object.defineProperty(nil, "__esModule", {
  value: !0
});
nil.default = void 0;
var _default$3 = "00000000-0000-0000-0000-000000000000";
nil.default = _default$3;
var version$4 = {};
Object.defineProperty(version$4, "__esModule", {
  value: !0
});
version$4.default = void 0;
var _validate = _interopRequireDefault$9(validate$1);
function _interopRequireDefault$9(me) {
  return me && me.__esModule ? me : { default: me };
}
function version$3(me) {
  if (!(0, _validate.default)(me))
    throw TypeError("Invalid UUID");
  return parseInt(me.slice(14, 15), 16);
}
var _default$2 = version$3;
version$4.default = _default$2;
(function(me) {
  Object.defineProperty(me, "__esModule", {
    value: !0
  }), Object.defineProperty(me, "NIL", {
    enumerable: !0,
    get: function() {
      return Ge.default;
    }
  }), Object.defineProperty(me, "parse", {
    enumerable: !0,
    get: function() {
      return Je.default;
    }
  }), Object.defineProperty(me, "stringify", {
    enumerable: !0,
    get: function() {
      return $e.default;
    }
  }), Object.defineProperty(me, "v1", {
    enumerable: !0,
    get: function() {
      return ue.default;
    }
  }), Object.defineProperty(me, "v3", {
    enumerable: !0,
    get: function() {
      return Qe.default;
    }
  }), Object.defineProperty(me, "v4", {
    enumerable: !0,
    get: function() {
      return Ue.default;
    }
  }), Object.defineProperty(me, "v5", {
    enumerable: !0,
    get: function() {
      return He.default;
    }
  }), Object.defineProperty(me, "validate", {
    enumerable: !0,
    get: function() {
      return Ke.default;
    }
  }), Object.defineProperty(me, "version", {
    enumerable: !0,
    get: function() {
      return Xe.default;
    }
  });
  var ue = Ze(v1$1), Qe = Ze(v3$1), Ue = Ze(v4$1), He = Ze(v5$1), Ge = Ze(nil), Xe = Ze(version$4), Ke = Ze(validate$1), $e = Ze(stringify$3), Je = Ze(parse$4);
  function Ze(nt) {
    return nt && nt.__esModule ? nt : { default: nt };
  }
})(commonjsBrowser);
var __extends$1k = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) Object.prototype.hasOwnProperty.call(He, Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    if (typeof Qe != "function" && Qe !== null)
      throw new TypeError("Class extends value " + String(Qe) + " is not a constructor or null");
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), __assign$1 = commonjsGlobal && commonjsGlobal.__assign || function() {
  return __assign$1 = Object.assign || function(me) {
    for (var ue, Qe = 1, Ue = arguments.length; Qe < Ue; Qe++) {
      ue = arguments[Qe];
      for (var He in ue) Object.prototype.hasOwnProperty.call(ue, He) && (me[He] = ue[He]);
    }
    return me;
  }, __assign$1.apply(this, arguments);
}, __awaiter$6 = commonjsGlobal && commonjsGlobal.__awaiter || function(me, ue, Qe, Ue) {
  function He(Ge) {
    return Ge instanceof Qe ? Ge : new Qe(function(Xe) {
      Xe(Ge);
    });
  }
  return new (Qe || (Qe = Promise))(function(Ge, Xe) {
    function Ke(Ze) {
      try {
        Je(Ue.next(Ze));
      } catch (nt) {
        Xe(nt);
      }
    }
    function $e(Ze) {
      try {
        Je(Ue.throw(Ze));
      } catch (nt) {
        Xe(nt);
      }
    }
    function Je(Ze) {
      Ze.done ? Ge(Ze.value) : He(Ze.value).then(Ke, $e);
    }
    Je((Ue = Ue.apply(me, ue || [])).next());
  });
}, __generator$5 = commonjsGlobal && commonjsGlobal.__generator || function(me, ue) {
  var Qe = { label: 0, sent: function() {
    if (Ge[0] & 1) throw Ge[1];
    return Ge[1];
  }, trys: [], ops: [] }, Ue, He, Ge, Xe;
  return Xe = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (Xe[Symbol.iterator] = function() {
    return this;
  }), Xe;
  function Ke(Je) {
    return function(Ze) {
      return $e([Je, Ze]);
    };
  }
  function $e(Je) {
    if (Ue) throw new TypeError("Generator is already executing.");
    for (; Xe && (Xe = 0, Je[0] && (Qe = 0)), Qe; ) try {
      if (Ue = 1, He && (Ge = Je[0] & 2 ? He.return : Je[0] ? He.throw || ((Ge = He.return) && Ge.call(He), 0) : He.next) && !(Ge = Ge.call(He, Je[1])).done) return Ge;
      switch (He = 0, Ge && (Je = [Je[0] & 2, Ge.value]), Je[0]) {
        case 0:
        case 1:
          Ge = Je;
          break;
        case 4:
          return Qe.label++, { value: Je[1], done: !1 };
        case 5:
          Qe.label++, He = Je[1], Je = [0];
          continue;
        case 7:
          Je = Qe.ops.pop(), Qe.trys.pop();
          continue;
        default:
          if (Ge = Qe.trys, !(Ge = Ge.length > 0 && Ge[Ge.length - 1]) && (Je[0] === 6 || Je[0] === 2)) {
            Qe = 0;
            continue;
          }
          if (Je[0] === 3 && (!Ge || Je[1] > Ge[0] && Je[1] < Ge[3])) {
            Qe.label = Je[1];
            break;
          }
          if (Je[0] === 6 && Qe.label < Ge[1]) {
            Qe.label = Ge[1], Ge = Je;
            break;
          }
          if (Ge && Qe.label < Ge[2]) {
            Qe.label = Ge[2], Qe.ops.push(Je);
            break;
          }
          Ge[2] && Qe.ops.pop(), Qe.trys.pop();
          continue;
      }
      Je = ue.call(me, Qe);
    } catch (Ze) {
      Je = [6, Ze], He = 0;
    } finally {
      Ue = Ge = 0;
    }
    if (Je[0] & 5) throw Je[1];
    return { value: Je[0] ? Je[1] : void 0, done: !0 };
  }
};
Object.defineProperty(WebRtcPeer$1, "__esModule", { value: !0 });
WebRtcPeer$1.WebRtcPeerSendrecv = WebRtcPeer$1.WebRtcPeerSendonly = WebRtcPeer$1.WebRtcPeerRecvonly = WebRtcPeer$1.WebRtcPeer = void 0;
var freeice = freeice_1, uuid_1$1 = commonjsBrowser, ExceptionEvent_1$2 = ExceptionEvent, OpenViduLogger_1$5 = OpenViduLogger$1, Platform_1$3 = Platform, logger$5 = OpenViduLogger_1$5.OpenViduLogger.getInstance(), WebRtcPeer = (
  /** @class */
  function() {
    function me(ue) {
      var Qe = this;
      this.remoteCandidatesQueue = [], this.localCandidatesQueue = [], this.iceCandidateList = [], Platform_1$3.PlatformUtils.getInstance(), this.configuration = __assign$1(__assign$1({}, ue), { iceServers: ue.iceServers && ue.iceServers.length > 0 ? ue.iceServers : freeice(), mediaStream: ue.mediaStream !== void 0 ? ue.mediaStream : null, mode: ue.mode ? ue.mode : "sendrecv", id: ue.id ? ue.id : this.generateUniqueId() }), logger$5.debug(`[WebRtcPeer] configuration:
`.concat(JSON.stringify(this.configuration, null, 2))), this.pc = new RTCPeerConnection({ iceServers: this.configuration.iceServers }), this.pc.addEventListener("icecandidate", function(Ue) {
        if (Ue.candidate !== null) {
          var He = Ue.candidate, Ge = new RTCIceCandidate(He);
          Qe.configuration.onIceCandidate(Ge), Ge.candidate !== "" && Qe.localCandidatesQueue.push(Ge);
        }
      }), this.pc.addEventListener("signalingstatechange", function() {
        return __awaiter$6(Qe, void 0, void 0, function() {
          var Ue, He;
          return __generator$5(this, function(Ge) {
            switch (Ge.label) {
              case 0:
                if (this.pc.signalingState !== "stable") return [3, 6];
                Ge.label = 1;
              case 1:
                if (!(this.iceCandidateList.length > 0)) return [3, 6];
                Ue = this.iceCandidateList.shift(), Ge.label = 2;
              case 2:
                return Ge.trys.push([2, 4, , 5]), [4, this.pc.addIceCandidate(Ue)];
              case 3:
                return Ge.sent(), [3, 5];
              case 4:
                return He = Ge.sent(), logger$5.error("Error when calling RTCPeerConnection#addIceCandidate for RTCPeerConnection " + this.getId(), He), [3, 5];
              case 5:
                return [3, 1];
              case 6:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      });
    }
    return me.prototype.getId = function() {
      return this.configuration.id;
    }, me.prototype.dispose = function() {
      if (logger$5.debug("Disposing WebRtcPeer"), this.pc) {
        if (this.pc.signalingState === "closed")
          return;
        this.pc.close(), this.remoteCandidatesQueue = [], this.localCandidatesQueue = [];
      }
    }, me.prototype.createOfferLegacy = function() {
      this.configuration.mediaStream && this.deprecatedPeerConnectionTrackApi();
      var ue = this.configuration.mediaConstraints.audio, Qe = this.configuration.mediaConstraints.video, Ue = {
        offerToReceiveAudio: this.configuration.mode !== "sendonly" && ue,
        offerToReceiveVideo: this.configuration.mode !== "sendonly" && Qe
      };
      return logger$5.debug("[createOfferLegacy] RTCPeerConnection.createOffer() options:", JSON.stringify(Ue)), this.pc.createOffer(Ue);
    }, me.prototype.createOffer = function() {
      var ue, Qe, Ue, He, Ge, Xe, Ke, $e;
      return __awaiter$6(this, void 0, void 0, function() {
        var Je, Ze, nt, tt, et, rt, it, ot, at, st, ut, lt, dt, At, pt, gt, wt, It, Bt, Tt, yt, Ct, ht, It;
        return __generator$5(this, function(vt) {
          switch (vt.label) {
            case 0:
              if ("addTransceiver" in this.pc)
                logger$5.debug("[createOffer] Method RTCPeerConnection.addTransceiver() is available; using it");
              else
                return logger$5.warn("[createOffer] Method RTCPeerConnection.addTransceiver() is NOT available; using LEGACY offerToReceive{Audio,Video}"), [2, this.createOfferLegacy()];
              if (this.configuration.mode === "recvonly") return [3, 7];
              if (!this.configuration.mediaStream)
                throw new Error("[WebRtcPeer.createOffer] Direction is '".concat(this.configuration.mode, "', but no stream was configured to be sent"));
              Je = 0, Ze = this.configuration.mediaStream.getTracks(), vt.label = 1;
            case 1:
              if (!(Je < Ze.length)) return [3, 6];
              if (nt = Ze[Je], tt = {
                direction: this.configuration.mode,
                streams: [this.configuration.mediaStream]
              }, nt.kind === "video" && this.configuration.simulcast)
                for (et = nt.getSettings(), rt = nt.getConstraints(), it = (Ue = (Qe = (ue = et.width) !== null && ue !== void 0 ? ue : rt.width.ideal) !== null && Qe !== void 0 ? Qe : rt.width) !== null && Ue !== void 0 ? Ue : 0, ot = (Xe = (Ge = (He = et.height) !== null && He !== void 0 ? He : rt.height.ideal) !== null && Ge !== void 0 ? Ge : rt.height) !== null && Xe !== void 0 ? Xe : 0, logger$5.info("[createOffer] Video track dimensions: ".concat(it, "x").concat(ot)), at = it * ot, st = 0, at >= 960 * 540 ? st = 3 : at >= 480 * 270 ? st = 2 : st = 1, tt.sendEncodings = [], ut = 0; ut < st; ut++)
                  lt = Math.pow(2, st - ut - 1), dt = {
                    rid: "rdiv" + lt.toString(),
                    // @ts-ignore -- Property missing from DOM types.
                    scalabilityMode: "L1T1"
                  }, ["detail", "text"].includes(nt.contentHint) ? (dt.scaleResolutionDownBy = 1, dt.maxFramerate = Math.floor(30 / lt)) : dt.scaleResolutionDownBy = lt, tt.sendEncodings.push(dt);
              if (At = this.pc.addTransceiver(nt, tt), nt.kind !== "video") return [3, 5];
              if (pt = At.sender.getParameters(), gt = !1, !((Ke = pt.degradationPreference) === null || Ke === void 0) && Ke.length || (["detail", "text"].includes(nt.contentHint) ? pt.degradationPreference = "maintain-resolution" : pt.degradationPreference = "balanced", logger$5.info("[createOffer] Video sender Degradation Preference set: ".concat(pt.degradationPreference)), gt = !0), this.configuration.simulcast && (($e = pt.encodings) === null || $e === void 0 ? void 0 : $e.length) !== tt.sendEncodings.length && (pt.encodings = tt.sendEncodings, gt = !0), !gt) return [3, 5];
              logger$5.debug("[createOffer] Setting new RTCRtpSendParameters to video sender"), vt.label = 2;
            case 2:
              return vt.trys.push([2, 4, , 5]), [4, At.sender.setParameters(pt)];
            case 3:
              return vt.sent(), [3, 5];
            case 4:
              throw wt = vt.sent(), It = "[WebRtcPeer.createOffer] Cannot set RTCRtpSendParameters to video sender", wt instanceof Error && (It += ": ".concat(wt.message)), new Error(It);
            case 5:
              return Je++, [3, 1];
            case 6:
              return [3, 8];
            case 7:
              for (Bt = 0, Tt = ["audio", "video"]; Bt < Tt.length; Bt++)
                yt = Tt[Bt], this.configuration.mediaConstraints[yt] && (this.configuration.mediaStream = new MediaStream(), this.pc.addTransceiver(yt, {
                  direction: this.configuration.mode,
                  streams: [this.configuration.mediaStream]
                }));
              vt.label = 8;
            case 8:
              return vt.trys.push([8, 10, , 11]), [4, this.pc.createOffer()];
            case 9:
              return Ct = vt.sent(), [3, 11];
            case 10:
              throw ht = vt.sent(), It = "[WebRtcPeer.createOffer] Browser failed creating an SDP Offer", ht instanceof Error && (It += ": ".concat(ht.message)), new Error(It);
            case 11:
              return [2, Ct];
          }
        });
      });
    }, me.prototype.deprecatedPeerConnectionTrackApi = function() {
      for (var ue = 0, Qe = this.configuration.mediaStream.getTracks(); ue < Qe.length; ue++) {
        var Ue = Qe[ue];
        this.pc.addTrack(Ue, this.configuration.mediaStream);
      }
    }, me.prototype.createAnswer = function() {
      var ue = this;
      return new Promise(function(Qe, Ue) {
        if ("getTransceivers" in ue.pc) {
          logger$5.debug("[createAnswer] Method RTCPeerConnection.getTransceivers() is available; using it");
          for (var He = function(tt) {
            if (!ue.configuration.mediaConstraints[tt])
              return "continue";
            var et = ue.pc.getTransceivers().find(function(rt) {
              return rt.receiver.track.kind === tt;
            });
            if (et)
              et.direction = ue.configuration.mode;
            else
              return { value: Ue(new Error("".concat(tt, " requested, but no transceiver was created from remote description"))) };
          }, Ge = 0, Xe = ["audio", "video"]; Ge < Xe.length; Ge++) {
            var Ke = Xe[Ge], $e = He(Ke);
            if (typeof $e == "object")
              return $e.value;
          }
          ue.pc.createAnswer().then(function(tt) {
            return Qe(tt);
          }).catch(function(tt) {
            return Ue(tt);
          });
        } else {
          var Je = void 0, Ze = !0;
          if (ue.configuration.mediaConstraints) {
            Je = typeof ue.configuration.mediaConstraints.audio == "boolean" ? ue.configuration.mediaConstraints.audio : !0, Ze = typeof ue.configuration.mediaConstraints.video == "boolean" ? ue.configuration.mediaConstraints.video : !0;
            var nt = {
              offerToReceiveAudio: Je,
              offerToReceiveVideo: Ze
            };
            ue.pc.createAnswer(nt).then(function(tt) {
              return Qe(tt);
            }).catch(function(tt) {
              return Ue(tt);
            });
          }
        }
      });
    }, me.prototype.processLocalOffer = function(ue) {
      var Qe = this;
      return new Promise(function(Ue, He) {
        Qe.pc.setLocalDescription(ue).then(function() {
          var Ge = Qe.pc.localDescription;
          return Ge ? (logger$5.debug("Local description set", Ge.sdp), Ue()) : He("Local description is not defined");
        }).catch(function(Ge) {
          return He(Ge);
        });
      });
    }, me.prototype.processRemoteOffer = function(ue) {
      var Qe = this;
      return new Promise(function(Ue, He) {
        var Ge = {
          type: "offer",
          sdp: ue
        };
        if (logger$5.debug("SDP offer received, setting remote description", Ge), Qe.pc.signalingState === "closed")
          return He("RTCPeerConnection is closed when trying to set remote description");
        Qe.setRemoteDescription(Ge).then(function() {
          return Ue();
        }).catch(function(Xe) {
          return He(Xe);
        });
      });
    }, me.prototype.processLocalAnswer = function(ue) {
      var Qe = this;
      return new Promise(function(Ue, He) {
        if (logger$5.debug("SDP answer created, setting local description"), Qe.pc.signalingState === "closed")
          return He("RTCPeerConnection is closed when trying to set local description");
        Qe.pc.setLocalDescription(ue).then(function() {
          return Ue();
        }).catch(function(Ge) {
          return He(Ge);
        });
      });
    }, me.prototype.processRemoteAnswer = function(ue) {
      var Qe = this;
      return new Promise(function(Ue, He) {
        var Ge = {
          type: "answer",
          sdp: ue
        };
        if (logger$5.debug("SDP answer received, setting remote description"), Qe.pc.signalingState === "closed")
          return He("RTCPeerConnection is closed when trying to set remote description");
        Qe.setRemoteDescription(Ge).then(function() {
          Ue();
        }).catch(function(Xe) {
          return He(Xe);
        });
      });
    }, me.prototype.setRemoteDescription = function(ue) {
      return __awaiter$6(this, void 0, void 0, function() {
        return __generator$5(this, function(Qe) {
          return [2, this.pc.setRemoteDescription(ue)];
        });
      });
    }, me.prototype.addIceCandidate = function(ue) {
      var Qe = this;
      return new Promise(function(Ue, He) {
        switch (logger$5.debug("Remote ICE candidate received", ue), Qe.remoteCandidatesQueue.push(ue), Qe.pc.signalingState) {
          case "closed":
            He(new Error("PeerConnection object is closed"));
            break;
          case "stable":
            Qe.pc.remoteDescription ? Qe.pc.addIceCandidate(ue).then(function() {
              return Ue();
            }).catch(function(Ge) {
              return He(Ge);
            }) : (Qe.iceCandidateList.push(ue), Ue());
            break;
          default:
            Qe.iceCandidateList.push(ue), Ue();
        }
      });
    }, me.prototype.addIceConnectionStateChangeListener = function(ue) {
      var Qe = this;
      this.pc.addEventListener("iceconnectionstatechange", function() {
        var Ue = Qe.pc.iceConnectionState;
        switch (Ue) {
          case "disconnected":
            var He = "IceConnectionState of RTCPeerConnection " + Qe.configuration.id + " (" + ue + ') change to "disconnected". Possible network disconnection';
            logger$5.warn(He), Qe.configuration.onIceConnectionStateException(ExceptionEvent_1$2.ExceptionEventName.ICE_CONNECTION_DISCONNECTED, He);
            break;
          case "failed":
            var Ge = "IceConnectionState of RTCPeerConnection " + Qe.configuration.id + " (" + ue + ') to "failed"';
            logger$5.error(Ge), Qe.configuration.onIceConnectionStateException(ExceptionEvent_1$2.ExceptionEventName.ICE_CONNECTION_FAILED, Ge);
            break;
          case "closed":
            logger$5.log("IceConnectionState of RTCPeerConnection " + Qe.configuration.id + " (" + ue + ') change to "closed"');
            break;
          case "new":
            logger$5.log("IceConnectionState of RTCPeerConnection " + Qe.configuration.id + " (" + ue + ') change to "new"');
            break;
          case "checking":
            logger$5.log("IceConnectionState of RTCPeerConnection " + Qe.configuration.id + " (" + ue + ') change to "checking"');
            break;
          case "connected":
            logger$5.log("IceConnectionState of RTCPeerConnection " + Qe.configuration.id + " (" + ue + ') change to "connected"');
            break;
          case "completed":
            logger$5.log("IceConnectionState of RTCPeerConnection " + Qe.configuration.id + " (" + ue + ') change to "completed"');
            break;
        }
      });
    }, me.prototype.generateUniqueId = function() {
      return (0, uuid_1$1.v4)();
    }, me;
  }()
);
WebRtcPeer$1.WebRtcPeer = WebRtcPeer;
var WebRtcPeerRecvonly = (
  /** @class */
  function(me) {
    __extends$1k(ue, me);
    function ue(Qe) {
      return Qe.mode = "recvonly", me.call(this, Qe) || this;
    }
    return ue;
  }(WebRtcPeer)
);
WebRtcPeer$1.WebRtcPeerRecvonly = WebRtcPeerRecvonly;
var WebRtcPeerSendonly = (
  /** @class */
  function(me) {
    __extends$1k(ue, me);
    function ue(Qe) {
      return Qe.mode = "sendonly", me.call(this, Qe) || this;
    }
    return ue;
  }(WebRtcPeer)
);
WebRtcPeer$1.WebRtcPeerSendonly = WebRtcPeerSendonly;
var WebRtcPeerSendrecv = (
  /** @class */
  function(me) {
    __extends$1k(ue, me);
    function ue(Qe) {
      return Qe.mode = "sendrecv", me.call(this, Qe) || this;
    }
    return ue;
  }(WebRtcPeer)
);
WebRtcPeer$1.WebRtcPeerSendrecv = WebRtcPeerSendrecv;
var WebRtcStats$1 = {}, __awaiter$5 = commonjsGlobal && commonjsGlobal.__awaiter || function(me, ue, Qe, Ue) {
  function He(Ge) {
    return Ge instanceof Qe ? Ge : new Qe(function(Xe) {
      Xe(Ge);
    });
  }
  return new (Qe || (Qe = Promise))(function(Ge, Xe) {
    function Ke(Ze) {
      try {
        Je(Ue.next(Ze));
      } catch (nt) {
        Xe(nt);
      }
    }
    function $e(Ze) {
      try {
        Je(Ue.throw(Ze));
      } catch (nt) {
        Xe(nt);
      }
    }
    function Je(Ze) {
      Ze.done ? Ge(Ze.value) : He(Ze.value).then(Ke, $e);
    }
    Je((Ue = Ue.apply(me, ue || [])).next());
  });
}, __generator$4 = commonjsGlobal && commonjsGlobal.__generator || function(me, ue) {
  var Qe = { label: 0, sent: function() {
    if (Ge[0] & 1) throw Ge[1];
    return Ge[1];
  }, trys: [], ops: [] }, Ue, He, Ge, Xe;
  return Xe = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (Xe[Symbol.iterator] = function() {
    return this;
  }), Xe;
  function Ke(Je) {
    return function(Ze) {
      return $e([Je, Ze]);
    };
  }
  function $e(Je) {
    if (Ue) throw new TypeError("Generator is already executing.");
    for (; Xe && (Xe = 0, Je[0] && (Qe = 0)), Qe; ) try {
      if (Ue = 1, He && (Ge = Je[0] & 2 ? He.return : Je[0] ? He.throw || ((Ge = He.return) && Ge.call(He), 0) : He.next) && !(Ge = Ge.call(He, Je[1])).done) return Ge;
      switch (He = 0, Ge && (Je = [Je[0] & 2, Ge.value]), Je[0]) {
        case 0:
        case 1:
          Ge = Je;
          break;
        case 4:
          return Qe.label++, { value: Je[1], done: !1 };
        case 5:
          Qe.label++, He = Je[1], Je = [0];
          continue;
        case 7:
          Je = Qe.ops.pop(), Qe.trys.pop();
          continue;
        default:
          if (Ge = Qe.trys, !(Ge = Ge.length > 0 && Ge[Ge.length - 1]) && (Je[0] === 6 || Je[0] === 2)) {
            Qe = 0;
            continue;
          }
          if (Je[0] === 3 && (!Ge || Je[1] > Ge[0] && Je[1] < Ge[3])) {
            Qe.label = Je[1];
            break;
          }
          if (Je[0] === 6 && Qe.label < Ge[1]) {
            Qe.label = Ge[1], Ge = Je;
            break;
          }
          if (Ge && Qe.label < Ge[2]) {
            Qe.label = Ge[2], Qe.ops.push(Je);
            break;
          }
          Ge[2] && Qe.ops.pop(), Qe.trys.pop();
          continue;
      }
      Je = ue.call(me, Qe);
    } catch (Ze) {
      Je = [6, Ze], He = 0;
    } finally {
      Ue = Ge = 0;
    }
    if (Je[0] & 5) throw Je[1];
    return { value: Je[0] ? Je[1] : void 0, done: !0 };
  }
};
Object.defineProperty(WebRtcStats$1, "__esModule", { value: !0 });
WebRtcStats$1.WebRtcStats = void 0;
var OpenViduLogger_1$4 = OpenViduLogger$1, Platform_1$2 = Platform, logger$4 = OpenViduLogger_1$4.OpenViduLogger.getInstance(), platform$2, WebRtcStats = (
  /** @class */
  function() {
    function me(ue) {
      this.stream = ue, this.STATS_ITEM_NAME = "webrtc-stats-config", this.webRtcStatsEnabled = !1, this.statsInterval = 1, platform$2 = Platform_1$2.PlatformUtils.getInstance();
    }
    return me.prototype.isEnabled = function() {
      return this.webRtcStatsEnabled;
    }, me.prototype.initWebRtcStats = function() {
      var ue = this, Qe;
      try {
        Qe = localStorage.getItem(this.STATS_ITEM_NAME);
      } catch {
      }
      if (Qe) {
        this.webRtcStatsEnabled = !0;
        var Ue = JSON.parse(Qe);
        logger$4.warn("WebRtc stats enabled for stream " + this.stream.streamId + " of connection " + this.stream.connection.connectionId), logger$4.warn("localStorage item: " + JSON.stringify(Ue)), this.POST_URL = Ue.httpEndpoint, this.statsInterval = Ue.interval, this.webRtcStatsIntervalId = setInterval(function() {
          return __awaiter$5(ue, void 0, void 0, function() {
            return __generator$4(this, function(He) {
              switch (He.label) {
                case 0:
                  return [4, this.sendStatsToHttpEndpoint()];
                case 1:
                  return He.sent(), [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }, this.statsInterval * 1e3);
      } else
        logger$4.debug("WebRtc stats not enabled");
    }, me.prototype.getSelectedIceCandidateInfo = function() {
      var ue = this;
      return new Promise(function(Qe, Ue) {
        return __awaiter$5(ue, void 0, void 0, function() {
          var He, Ge, Xe, Ke, $e, Je, Ze, nt, tt, et, rt, it, ot, at, dt, At, st, ut, wt, lt, dt, At, pt, gt, wt;
          return __generator$4(this, function(Bt) {
            switch (Bt.label) {
              case 0:
                return [4, this.stream.getRTCPeerConnection().getStats()];
              case 1:
                if (He = Bt.sent(), Xe = /* @__PURE__ */ new Map(), Ke = /* @__PURE__ */ new Map(), $e = /* @__PURE__ */ new Map(), He.forEach(function(Tt) {
                  switch (Tt.type === "transport" && (platform$2.isChromium() || platform$2.isSafariBrowser() || platform$2.isReactNative()) && (Ge = Tt), Tt.type) {
                    case "candidate-pair":
                      Xe.set(Tt.id, Tt);
                      break;
                    case "local-candidate":
                      Ke.set(Tt.id, Tt);
                      break;
                    case "remote-candidate":
                      $e.set(Tt.id, Tt);
                      break;
                  }
                }), Ge != null)
                  Ze = Ge.selectedCandidatePairId, Je = Xe.get(Ze);
                else
                  for (nt = Xe.size, tt = Xe.values(), et = 0; et < nt; et++)
                    if (rt = tt.next().value, rt.selected) {
                      Je = rt;
                      break;
                    }
                if (it = Je.localCandidateId, ot = Je.remoteCandidateId, at = Ke.get(it), at)
                  for (dt = this.stream.getLocalIceCandidateList(), At = dt.filter(function(Tt) {
                    return !!Tt.candidate && (Tt.candidate.indexOf(at.ip) >= 0 || Tt.candidate.indexOf(at.address) >= 0) && Tt.candidate.indexOf(at.port) >= 0;
                  }), at.raw = [], st = 0, ut = At; st < ut.length; st++)
                    wt = ut[st], at.raw.push(wt.candidate);
                else
                  at = "ERROR: No active local ICE candidate. Probably ICE-TCP is being used";
                if (lt = $e.get(ot), lt)
                  for (dt = this.stream.getRemoteIceCandidateList(), At = dt.filter(function(Tt) {
                    return !!Tt.candidate && (Tt.candidate.indexOf(lt.ip) >= 0 || Tt.candidate.indexOf(lt.address) >= 0) && Tt.candidate.indexOf(lt.port) >= 0;
                  }), lt.raw = [], pt = 0, gt = At; pt < gt.length; pt++)
                    wt = gt[pt], lt.raw.push(wt.candidate);
                else
                  lt = "ERROR: No active remote ICE candidate. Probably ICE-TCP is being used";
                return [2, Qe({
                  localCandidate: at,
                  remoteCandidate: lt
                })];
            }
          });
        });
      });
    }, me.prototype.stopWebRtcStats = function() {
      this.webRtcStatsEnabled && (clearInterval(this.webRtcStatsIntervalId), logger$4.warn("WebRtc stats stopped for disposed stream " + this.stream.streamId + " of connection " + this.stream.connection.connectionId));
    }, me.prototype.sendStats = function(ue, Qe) {
      return __awaiter$5(this, void 0, void 0, function() {
        var Ue, He;
        return __generator$4(this, function(Ge) {
          switch (Ge.label) {
            case 0:
              return Ge.trys.push([0, 2, , 3]), Ue = {
                headers: {
                  "Content-type": "application/json"
                },
                body: JSON.stringify(Qe),
                method: "POST"
              }, [4, fetch(ue, Ue)];
            case 1:
              return Ge.sent(), [3, 3];
            case 2:
              return He = Ge.sent(), logger$4.error("sendStats error: ".concat(JSON.stringify(He))), [3, 3];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, me.prototype.sendStatsToHttpEndpoint = function() {
      return __awaiter$5(this, void 0, void 0, function() {
        var ue, Qe, Ue;
        return __generator$4(this, function(He) {
          switch (He.label) {
            case 0:
              return He.trys.push([0, 3, , 4]), [4, this.getCommonStats()];
            case 1:
              return ue = He.sent(), Qe = this.generateJSONStatsResponse(ue), [4, this.sendStats(this.POST_URL, Qe)];
            case 2:
              return He.sent(), [3, 4];
            case 3:
              return Ue = He.sent(), logger$4.log(Ue), [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, me.prototype.getCommonStats = function() {
      return __awaiter$5(this, void 0, void 0, function() {
        var ue = this;
        return __generator$4(this, function(Qe) {
          return [2, new Promise(function(Ue, He) {
            return __awaiter$5(ue, void 0, void 0, function() {
              var Ge, Xe, Ke, $e, Je, Ze = this;
              return __generator$4(this, function(nt) {
                switch (nt.label) {
                  case 0:
                    return nt.trys.push([0, 2, , 3]), [4, this.stream.getRTCPeerConnection().getStats()];
                  case 1:
                    return Ge = nt.sent(), Xe = this.getWebRtcStatsResponseOutline(), Ke = ["framesReceived", "framesDropped", "framesSent", "frameHeight", "frameWidth"], $e = ["availableOutgoingBitrate", "currentRoundTripTime"], Ge.forEach(function(tt) {
                      var et = tt.mediaType != null ? tt.mediaType : tt.kind, rt = function(it, ot) {
                        tt[ot] != null && Xe[it] != null && (!et && Ke.indexOf(ot) > -1 && (et = "video"), it != null && et != null && ot != null && Xe[it][et] != null ? Xe[it][et][ot] = Number(tt[ot]) : it != null && ot != null && $e.includes(ot) && (Xe[it][ot] = Number(tt[ot])));
                      };
                      switch (tt.type) {
                        case "outbound-rtp":
                          rt("outbound", "bytesSent"), rt("outbound", "packetsSent"), rt("outbound", "framesEncoded"), rt("outbound", "nackCount"), rt("outbound", "firCount"), rt("outbound", "pliCount"), rt("outbound", "qpSum");
                          break;
                        case "inbound-rtp":
                          rt("inbound", "bytesReceived"), rt("inbound", "packetsReceived"), rt("inbound", "packetsLost"), rt("inbound", "jitter"), rt("inbound", "framesDecoded"), rt("inbound", "nackCount"), rt("inbound", "firCount"), rt("inbound", "pliCount");
                          break;
                        case "track":
                          rt("inbound", "jitterBufferDelay"), rt("inbound", "framesReceived"), rt("outbound", "framesDropped"), rt("outbound", "framesSent"), rt(Ze.stream.isLocal() ? "outbound" : "inbound", "frameHeight"), rt(Ze.stream.isLocal() ? "outbound" : "inbound", "frameWidth");
                          break;
                        case "candidate-pair":
                          rt("candidatepair", "currentRoundTripTime"), rt("candidatepair", "availableOutgoingBitrate");
                          break;
                      }
                    }), (!(Xe != null && Xe.candidatepair) || Object.keys(Xe.candidatepair).length === 0) && delete Xe.candidatepair, [2, Ue(Xe)];
                  case 2:
                    return Je = nt.sent(), logger$4.error("Error getting common stats: ", Je), [2, He(Je)];
                  case 3:
                    return [
                      2
                      /*return*/
                    ];
                }
              });
            });
          })];
        });
      });
    }, me.prototype.generateJSONStatsResponse = function(ue) {
      return {
        "@timestamp": (/* @__PURE__ */ new Date()).toISOString(),
        participant_id: this.stream.connection.data,
        session_id: this.stream.session.sessionId,
        platform: platform$2.getName(),
        platform_description: platform$2.getDescription(),
        stream: "webRTC",
        webrtc_stats: ue
      };
    }, me.prototype.getWebRtcStatsResponseOutline = function() {
      return this.stream.isLocal() ? {
        outbound: {
          audio: {},
          video: {}
        },
        candidatepair: {}
      } : {
        inbound: {
          audio: {},
          video: {}
        }
      };
    }, me;
  }()
);
WebRtcStats$1.WebRtcStats = WebRtcStats;
var PublisherSpeakingEvent$1 = {}, __extends$1j = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) Object.prototype.hasOwnProperty.call(He, Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    if (typeof Qe != "function" && Qe !== null)
      throw new TypeError("Class extends value " + String(Qe) + " is not a constructor or null");
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}();
Object.defineProperty(PublisherSpeakingEvent$1, "__esModule", { value: !0 });
PublisherSpeakingEvent$1.PublisherSpeakingEvent = void 0;
var Event_1$8 = Event$2, PublisherSpeakingEvent = (
  /** @class */
  function(me) {
    __extends$1j(ue, me);
    function ue(Qe, Ue, He, Ge) {
      var Xe = me.call(this, !1, Qe, Ue) || this;
      return Xe.type = Ue, Xe.connection = He, Xe.streamId = Ge, Xe;
    }
    return ue.prototype.callDefaultBehavior = function() {
    }, ue;
  }(Event_1$8.Event)
);
PublisherSpeakingEvent$1.PublisherSpeakingEvent = PublisherSpeakingEvent;
var TypeOfVideo = {};
(function(me) {
  Object.defineProperty(me, "__esModule", { value: !0 }), me.TypeOfVideo = void 0, function(ue) {
    ue.CAMERA = "CAMERA", ue.SCREEN = "SCREEN", ue.CUSTOM = "CUSTOM", ue.IPCAM = "IPCAM";
  }(me.TypeOfVideo || (me.TypeOfVideo = {}));
})(TypeOfVideo);
var wildemitter = WildEmitter$1;
function WildEmitter$1() {
}
WildEmitter$1.mixin = function(me) {
  var ue = me.prototype || me;
  ue.isWildEmitter = !0, ue.on = function(Qe, Ue, He) {
    this.callbacks = this.callbacks || {};
    var Ge = arguments.length === 3, Xe = Ge ? arguments[1] : void 0, Ke = Ge ? arguments[2] : arguments[1];
    return Ke._groupName = Xe, (this.callbacks[Qe] = this.callbacks[Qe] || []).push(Ke), this;
  }, ue.once = function(Qe, Ue, He) {
    var Ge = this, Xe = arguments.length === 3, Ke = Xe ? arguments[1] : void 0, $e = Xe ? arguments[2] : arguments[1];
    function Je() {
      Ge.off(Qe, Je), $e.apply(this, arguments);
    }
    return this.on(Qe, Ke, Je), this;
  }, ue.releaseGroup = function(Qe) {
    this.callbacks = this.callbacks || {};
    var Ue, He, Ge, Xe;
    for (Ue in this.callbacks)
      for (Xe = this.callbacks[Ue], He = 0, Ge = Xe.length; He < Ge; He++)
        Xe[He]._groupName === Qe && (Xe.splice(He, 1), He--, Ge--);
    return this;
  }, ue.off = function(Qe, Ue) {
    this.callbacks = this.callbacks || {};
    var He = this.callbacks[Qe], Ge;
    return He ? arguments.length === 1 ? (delete this.callbacks[Qe], this) : (Ge = He.indexOf(Ue), Ge !== -1 && (He.splice(Ge, 1), He.length === 0 && delete this.callbacks[Qe]), this) : this;
  }, ue.emit = function(Qe) {
    this.callbacks = this.callbacks || {};
    var Ue = [].slice.call(arguments, 1), He = this.callbacks[Qe], Ge = this.getWildcardCallbacks(Qe), Xe, Ke, $e;
    if (He)
      for ($e = He.slice(), Xe = 0, Ke = $e.length; Xe < Ke && $e[Xe]; ++Xe)
        $e[Xe].apply(this, Ue);
    if (Ge)
      for (Ke = Ge.length, $e = Ge.slice(), Xe = 0, Ke = $e.length; Xe < Ke && $e[Xe]; ++Xe)
        $e[Xe].apply(this, [Qe].concat(Ue));
    return this;
  }, ue.getWildcardCallbacks = function(Qe) {
    this.callbacks = this.callbacks || {};
    var Ue, He, Ge = [];
    for (Ue in this.callbacks)
      He = Ue.split("*"), (Ue === "*" || He.length === 2 && Qe.slice(0, He[0].length) === He[0]) && (Ge = Ge.concat(this.callbacks[Ue]));
    return Ge;
  };
};
WildEmitter$1.mixin(WildEmitter$1);
var WildEmitter = wildemitter;
function getMaxVolume(me, ue) {
  var Qe = -1 / 0;
  me.getFloatFrequencyData(ue);
  for (var Ue = 4, He = ue.length; Ue < He; Ue++)
    ue[Ue] > Qe && ue[Ue] < 0 && (Qe = ue[Ue]);
  return Qe;
}
var audioContextType;
typeof window < "u" && (audioContextType = window.AudioContext || window.webkitAudioContext);
var audioContext = null, hark$1 = function(me, Ue) {
  var Qe = new WildEmitter();
  if (!audioContextType) return Qe;
  var Ue = Ue || {}, He = Ue.smoothing || 0.1, Ge = Ue.interval || 50, Xe = Ue.threshold, Ke = Ue.play, $e = Ue.history || 10, Je = !0;
  audioContext = Ue.audioContext || audioContext || new audioContextType();
  var Ze, nt, tt;
  tt = audioContext.createAnalyser(), tt.fftSize = 512, tt.smoothingTimeConstant = He, nt = new Float32Array(tt.frequencyBinCount), me.jquery && (me = me[0]), me instanceof HTMLAudioElement || me instanceof HTMLVideoElement ? (Ze = audioContext.createMediaElementSource(me), typeof Ke > "u" && (Ke = !0), Xe = Xe || -50) : (Ze = audioContext.createMediaStreamSource(me), Xe = Xe || -50), Ze.connect(tt), Ke && tt.connect(audioContext.destination), Qe.speaking = !1, Qe.suspend = function() {
    return audioContext.suspend();
  }, Qe.resume = function() {
    return audioContext.resume();
  }, Object.defineProperty(Qe, "state", { get: function() {
    return audioContext.state;
  } }), audioContext.onstatechange = function() {
    Qe.emit("state_change", audioContext.state);
  }, Qe.setThreshold = function(it) {
    Xe = it;
  }, Qe.setInterval = function(it) {
    Ge = it;
  }, Qe.stop = function() {
    Je = !1, Qe.emit("volume_change", -100, Xe), Qe.speaking && (Qe.speaking = !1, Qe.emit("stopped_speaking")), tt.disconnect(), Ze.disconnect();
  }, Qe.speakingHistory = [];
  for (var et = 0; et < $e; et++)
    Qe.speakingHistory.push(0);
  var rt = function() {
    setTimeout(function() {
      if (Je) {
        var it = getMaxVolume(tt, nt);
        Qe.emit("volume_change", it, Xe);
        var ot = 0;
        if (it > Xe && !Qe.speaking) {
          for (var at = Qe.speakingHistory.length - 3; at < Qe.speakingHistory.length; at++)
            ot += Qe.speakingHistory[at];
          ot >= 2 && (Qe.speaking = !0, Qe.emit("speaking"));
        } else if (it < Xe && Qe.speaking) {
          for (var at = 0; at < Qe.speakingHistory.length; at++)
            ot += Qe.speakingHistory[at];
          ot == 0 && (Qe.speaking = !1, Qe.emit("stopped_speaking"));
        }
        Qe.speakingHistory.shift(), Qe.speakingHistory.push(0 + (it > Xe)), rt();
      }
    }, Ge);
  };
  return rt(), Qe;
}, __awaiter$4 = commonjsGlobal && commonjsGlobal.__awaiter || function(me, ue, Qe, Ue) {
  function He(Ge) {
    return Ge instanceof Qe ? Ge : new Qe(function(Xe) {
      Xe(Ge);
    });
  }
  return new (Qe || (Qe = Promise))(function(Ge, Xe) {
    function Ke(Ze) {
      try {
        Je(Ue.next(Ze));
      } catch (nt) {
        Xe(nt);
      }
    }
    function $e(Ze) {
      try {
        Je(Ue.throw(Ze));
      } catch (nt) {
        Xe(nt);
      }
    }
    function Je(Ze) {
      Ze.done ? Ge(Ze.value) : He(Ze.value).then(Ke, $e);
    }
    Je((Ue = Ue.apply(me, ue || [])).next());
  });
}, __generator$3 = commonjsGlobal && commonjsGlobal.__generator || function(me, ue) {
  var Qe = { label: 0, sent: function() {
    if (Ge[0] & 1) throw Ge[1];
    return Ge[1];
  }, trys: [], ops: [] }, Ue, He, Ge, Xe;
  return Xe = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (Xe[Symbol.iterator] = function() {
    return this;
  }), Xe;
  function Ke(Je) {
    return function(Ze) {
      return $e([Je, Ze]);
    };
  }
  function $e(Je) {
    if (Ue) throw new TypeError("Generator is already executing.");
    for (; Xe && (Xe = 0, Je[0] && (Qe = 0)), Qe; ) try {
      if (Ue = 1, He && (Ge = Je[0] & 2 ? He.return : Je[0] ? He.throw || ((Ge = He.return) && Ge.call(He), 0) : He.next) && !(Ge = Ge.call(He, Je[1])).done) return Ge;
      switch (He = 0, Ge && (Je = [Je[0] & 2, Ge.value]), Je[0]) {
        case 0:
        case 1:
          Ge = Je;
          break;
        case 4:
          return Qe.label++, { value: Je[1], done: !1 };
        case 5:
          Qe.label++, He = Je[1], Je = [0];
          continue;
        case 7:
          Je = Qe.ops.pop(), Qe.trys.pop();
          continue;
        default:
          if (Ge = Qe.trys, !(Ge = Ge.length > 0 && Ge[Ge.length - 1]) && (Je[0] === 6 || Je[0] === 2)) {
            Qe = 0;
            continue;
          }
          if (Je[0] === 3 && (!Ge || Je[1] > Ge[0] && Je[1] < Ge[3])) {
            Qe.label = Je[1];
            break;
          }
          if (Je[0] === 6 && Qe.label < Ge[1]) {
            Qe.label = Ge[1], Ge = Je;
            break;
          }
          if (Ge && Qe.label < Ge[2]) {
            Qe.label = Ge[2], Qe.ops.push(Je);
            break;
          }
          Ge[2] && Qe.ops.pop(), Qe.trys.pop();
          continue;
      }
      Je = ue.call(me, Qe);
    } catch (Ze) {
      Je = [6, Ze], He = 0;
    } finally {
      Ue = Ge = 0;
    }
    if (Je[0] & 5) throw Je[1];
    return { value: Je[0] ? Je[1] : void 0, done: !0 };
  }
};
Object.defineProperty(Stream$2, "__esModule", { value: !0 });
Stream$2.Stream = void 0;
var Filter_1 = Filter$1, Subscriber_1 = Subscriber$1, WebRtcPeer_1 = WebRtcPeer$1, WebRtcStats_1 = WebRtcStats$1, ExceptionEvent_1$1 = ExceptionEvent, PublisherSpeakingEvent_1 = PublisherSpeakingEvent$1, StreamManagerEvent_1 = StreamManagerEvent$1, StreamPropertyChangedEvent_1$1 = StreamPropertyChangedEvent$1, OpenViduError_1$1 = OpenViduError, TypeOfVideo_1 = TypeOfVideo, OpenViduLogger_1$3 = OpenViduLogger$1, Platform_1$1 = Platform, uuid_1 = commonjsBrowser, hark = hark$1, EventEmitter$2 = EventEmitterExports, logger$3 = OpenViduLogger_1$3.OpenViduLogger.getInstance(), platform$1, Stream$1 = (
  /** @class */
  function() {
    function me(ue, Qe) {
      var Ue = this;
      this.isSubscribeToRemote = !1, this.isLocalStreamReadyToPublish = !1, this.isLocalStreamPublished = !1, this.publishedOnce = !1, this.harkSpeakingEnabled = !1, this.harkSpeakingEnabledOnce = !1, this.harkStoppedSpeakingEnabled = !1, this.harkStoppedSpeakingEnabledOnce = !1, this.harkVolumeChangeEnabled = !1, this.harkVolumeChangeEnabledOnce = !1, this.ee = new EventEmitter$2(), platform$1 = Platform_1$1.PlatformUtils.getInstance(), this.session = ue, Qe.hasOwnProperty("id") ? (this.inboundStreamOpts = Qe, this.streamId = this.inboundStreamOpts.id, this.creationTime = this.inboundStreamOpts.createdAt, this.hasAudio = this.inboundStreamOpts.hasAudio, this.hasVideo = this.inboundStreamOpts.hasVideo, this.hasAudio && (this.audioActive = this.inboundStreamOpts.audioActive), this.hasVideo && (this.videoActive = this.inboundStreamOpts.videoActive, this.typeOfVideo = this.inboundStreamOpts.typeOfVideo ? this.inboundStreamOpts.typeOfVideo : void 0, this.frameRate = this.inboundStreamOpts.frameRate === -1 ? void 0 : this.inboundStreamOpts.frameRate, this.videoDimensions = this.inboundStreamOpts.videoDimensions), this.inboundStreamOpts.filter && Object.keys(this.inboundStreamOpts.filter).length > 0 && (this.inboundStreamOpts.filter.lastExecMethod && Object.keys(this.inboundStreamOpts.filter.lastExecMethod).length === 0 && delete this.inboundStreamOpts.filter.lastExecMethod, this.filter = this.inboundStreamOpts.filter)) : (this.outboundStreamOpts = Qe, this.hasAudio = this.isSendAudio(), this.hasVideo = this.isSendVideo(), this.hasAudio && (this.audioActive = !!this.outboundStreamOpts.publisherProperties.publishAudio), this.hasVideo && (this.videoActive = !!this.outboundStreamOpts.publisherProperties.publishVideo, this.frameRate = this.outboundStreamOpts.publisherProperties.frameRate, typeof MediaStreamTrack < "u" && this.outboundStreamOpts.publisherProperties.videoSource instanceof MediaStreamTrack ? this.typeOfVideo = TypeOfVideo_1.TypeOfVideo.CUSTOM : this.typeOfVideo = this.isSendScreen() ? TypeOfVideo_1.TypeOfVideo.SCREEN : TypeOfVideo_1.TypeOfVideo.CAMERA), this.outboundStreamOpts.publisherProperties.filter && (this.filter = this.outboundStreamOpts.publisherProperties.filter)), this.ee.on("mediastream-updated", function() {
        var He;
        Ue.streamManager.updateMediaStream(Ue.mediaStream), logger$3.debug("Video srcObject [" + ((He = Ue.mediaStream) === null || He === void 0 ? void 0 : He.id) + "] updated in stream [" + Ue.streamId + "]");
      });
    }
    return me.prototype.reconnect = function() {
      return this.reconnectStream("API");
    }, me.prototype.applyFilter = function(ue, Qe) {
      var Ue = this;
      return new Promise(function(He, Ge) {
        return __awaiter$4(Ue, void 0, void 0, function() {
          var Xe, Ke, $e, Je, Ze, nt, tt = this;
          return __generator$3(this, function(et) {
            if (this.filter)
              return [2, Ge(new OpenViduError_1$1.OpenViduError(OpenViduError_1$1.OpenViduErrorName.GENERIC_ERROR, "There is already a filter applied to Stream " + this.streamId))];
            if (Xe = function(rt, it) {
              if (rt)
                return logger$3.error("Error applying filter for Stream " + tt.streamId, rt), rt.code === 401 ? Ge(new OpenViduError_1$1.OpenViduError(OpenViduError_1$1.OpenViduErrorName.OPENVIDU_PERMISSION_DENIED, "You don't have permissions to apply a filter")) : Ge(rt);
              logger$3.info("Filter successfully applied on Stream " + tt.streamId);
              var ot = tt.filter;
              return tt.filter = new Filter_1.Filter(ue, Qe), tt.filter.stream = tt, it && (tt.session.emitEvent("streamPropertyChanged", [
                new StreamPropertyChangedEvent_1$1.StreamPropertyChangedEvent(tt.session, tt, "filter", tt.filter, ot, "applyFilter")
              ]), tt.streamManager.emitEvent("streamPropertyChanged", [
                new StreamPropertyChangedEvent_1$1.StreamPropertyChangedEvent(tt.streamManager, tt, "filter", tt.filter, ot, "applyFilter")
              ])), He(tt.filter);
            }, ue.startsWith("VB:")) {
              if (!this.hasVideo)
                return [2, Ge(new OpenViduError_1$1.OpenViduError(OpenViduError_1$1.OpenViduErrorName.VIRTUAL_BACKGROUND_ERROR, "The Virtual Background filter requires a video track to be applied"))];
              if (!this.mediaStream || this.streamManager.videos.length === 0)
                return [2, Ge(new OpenViduError_1$1.OpenViduError(OpenViduError_1$1.OpenViduErrorName.VIRTUAL_BACKGROUND_ERROR, "The StreamManager requires some video element to be attached to it in order to apply a Virtual Background filter"))];
              if (this.session.token ? Ke = this.session.token : Ke = Qe.token, !Ke)
                return [2, Ge(new OpenViduError_1$1.OpenViduError(OpenViduError_1$1.OpenViduErrorName.VIRTUAL_BACKGROUND_ERROR, 'Virtual Background requires the client to be connected to a Session or to have a "token" property available in "options" parameter with a valid OpenVidu token'))];
              if ($e = this.session.getTokenParams(Ke), $e.edition !== "pro" && $e.edition !== "enterprise")
                return [2, Ge(new OpenViduError_1$1.OpenViduError(OpenViduError_1$1.OpenViduErrorName.VIRTUAL_BACKGROUND_ERROR, "OpenVidu Virtual Background API is available from OpenVidu Pro edition onwards"))];
              Ke = encodeURIComponent(btoa(Ke)), logger$3.info("Applying Virtual Background to stream " + this.streamId), Je = function() {
                return __awaiter$4(tt, void 0, void 0, function() {
                  var rt, it, ot, at, st, ut, lt;
                  return __generator$3(this, function(dt) {
                    switch (dt.label) {
                      case 0:
                        return dt.trys.push([0, 8, , 9]), rt = this.streamId + "_" + (0, uuid_1.v4)(), it = this.mediaStream.clone(), ot = this.streamManager.videos[0].video.cloneNode(!1), ot.id = VirtualBackground.VirtualBackground.SOURCE_VIDEO_PREFIX + rt, ot.srcObject = it, ot.muted = !0, this.virtualBackgroundSourceElements = { videoClone: ot, mediaStreamClone: it }, VirtualBackground.VirtualBackground.hideHtmlElement(ot, !1), VirtualBackground.VirtualBackground.appendHtmlElementToHiddenContainer(ot, rt), [4, ot.play()];
                      case 1:
                        switch (dt.sent(), at = new VirtualBackground.VirtualBackground({
                          id: rt,
                          openviduServerUrl: new URL($e.httpUri),
                          openviduToken: Ke,
                          inputVideo: ot,
                          inputResolution: "160x96",
                          outputFramerate: 24
                        }), st = void 0, ut = ue, ut) {
                          case "VB:blur":
                            return [3, 2];
                          case "VB:image":
                            return [3, 4];
                        }
                        return [3, 6];
                      case 2:
                        return [4, at.backgroundBlur(Qe)];
                      case 3:
                        return st = dt.sent(), [3, 7];
                      case 4:
                        return [4, at.backgroundImage(Qe)];
                      case 5:
                        return st = dt.sent(), [3, 7];
                      case 6:
                        throw new Error("Unknown Virtual Background filter: " + ue);
                      case 7:
                        return this.virtualBackgroundSinkElements = { VB: at, video: st }, ot.style.display = "none", this.streamManager.remote ? this.streamManager.replaceTrackInMediaStream(this.virtualBackgroundSinkElements.video.srcObject.getVideoTracks()[0], !1) : this.streamManager.replaceTrackAux(this.virtualBackgroundSinkElements.video.srcObject.getVideoTracks()[0], !1), Xe(void 0, !1), [3, 9];
                      case 8:
                        return lt = dt.sent(), lt.name === OpenViduError_1$1.OpenViduErrorName.VIRTUAL_BACKGROUND_ERROR ? Xe(new OpenViduError_1$1.OpenViduError(OpenViduError_1$1.OpenViduErrorName.VIRTUAL_BACKGROUND_ERROR, lt.message), !1) : Xe(lt, !1), [3, 9];
                      case 9:
                        return [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              }, typeof VirtualBackground > "u" ? (Ze = document.createElement("script"), Ze.type = "text/javascript", Ze.src = $e.httpUri + "/openvidu/virtual-background/openvidu-virtual-background.js?token=" + Ke, Ze.onload = function() {
                return __awaiter$4(tt, void 0, void 0, function() {
                  var rt;
                  return __generator$3(this, function(it) {
                    switch (it.label) {
                      case 0:
                        return it.trys.push([0, 2, , 3]), [4, Je()];
                      case 1:
                        return it.sent(), He(new Filter_1.Filter(ue, Qe)), [3, 3];
                      case 2:
                        return rt = it.sent(), Ge(rt), [3, 3];
                      case 3:
                        return [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              }, document.body.appendChild(Ze)) : Je().then(function() {
                return He(new Filter_1.Filter(ue, Qe));
              }).catch(function(rt) {
                return Ge(rt);
              });
            } else {
              if (!this.session.sessionConnected())
                return [2, Ge(this.session.notConnectedError())];
              logger$3.info("Applying server filter to stream " + this.streamId), Qe = Qe ?? {}, nt = Qe, typeof nt != "string" && (nt = JSON.stringify(nt)), this.session.openvidu.sendRequest("applyFilter", { streamId: this.streamId, type: ue, options: nt }, function(rt, it) {
                Xe(rt, !0);
              });
            }
            return [
              2
              /*return*/
            ];
          });
        });
      });
    }, me.prototype.removeFilter = function() {
      return __awaiter$4(this, void 0, void 0, function() {
        return __generator$3(this, function(ue) {
          switch (ue.label) {
            case 0:
              return [4, this.removeFilterAux(!1)];
            case 1:
              return [2, ue.sent()];
          }
        });
      });
    }, me.prototype.getRTCPeerConnection = function() {
      return this.webRtcPeer.pc;
    }, me.prototype.getMediaStream = function() {
      return this.mediaStream;
    }, me.prototype.removeFilterAux = function(ue) {
      var Qe = this;
      return new Promise(function(Ue, He) {
        return __awaiter$4(Qe, void 0, void 0, function() {
          var Ge, Xe, Ke, $e = this, Je;
          return __generator$3(this, function(Ze) {
            switch (Ze.label) {
              case 0:
                if (Ge = function(nt, tt) {
                  if (nt)
                    return delete $e.filter, logger$3.error("Error removing filter for Stream " + $e.streamId, nt), nt.code === 401 ? He(new OpenViduError_1$1.OpenViduError(OpenViduError_1$1.OpenViduErrorName.OPENVIDU_PERMISSION_DENIED, "You don't have permissions to remove a filter")) : He(nt);
                  logger$3.info("Filter successfully removed from Stream " + $e.streamId);
                  var et = $e.filter;
                  return delete $e.filter, tt && ($e.session.emitEvent("streamPropertyChanged", [
                    new StreamPropertyChangedEvent_1$1.StreamPropertyChangedEvent($e.session, $e, "filter", $e.filter, et, "applyFilter")
                  ]), $e.streamManager.emitEvent("streamPropertyChanged", [
                    new StreamPropertyChangedEvent_1$1.StreamPropertyChangedEvent($e.streamManager, $e, "filter", $e.filter, et, "applyFilter")
                  ])), Ue();
                }, !this.filter) return [3, 11];
                if (!(!((Je = this.filter) === null || Je === void 0) && Je.type.startsWith("VB:"))) return [3, 9];
                Ze.label = 1;
              case 1:
                return Ze.trys.push([1, 7, , 8]), Xe = this.virtualBackgroundSourceElements.mediaStreamClone, ue ? [3, 5] : this.streamManager.remote ? (this.streamManager.replaceTrackInMediaStream(Xe.getVideoTracks()[0], !1), [3, 4]) : [3, 2];
              case 2:
                return [4, this.streamManager.replaceTrackAux(Xe.getVideoTracks()[0], !1)];
              case 3:
                Ze.sent(), Ze.label = 4;
              case 4:
                return [3, 6];
              case 5:
                Xe.getTracks().forEach(function(nt) {
                  return nt.stop();
                }), Ze.label = 6;
              case 6:
                return this.virtualBackgroundSinkElements.VB.cleanUp(), delete this.virtualBackgroundSinkElements, delete this.virtualBackgroundSourceElements, [2, Ge(void 0, !1)];
              case 7:
                return Ke = Ze.sent(), [2, Ge(Ke, !1)];
              case 8:
                return [3, 10];
              case 9:
                if (!this.session.sessionConnected())
                  return [2, He(this.session.notConnectedError())];
                logger$3.info("Removing filter of stream " + this.streamId), this.session.openvidu.sendRequest("removeFilter", { streamId: this.streamId }, function(nt, tt) {
                  return Ge(nt, !0);
                }), Ze.label = 10;
              case 10:
                return [3, 12];
              case 11:
                return [2, He(new OpenViduError_1$1.OpenViduError(OpenViduError_1$1.OpenViduErrorName.GENERIC_ERROR, "Stream " + this.streamId + " has no filter applied"))];
              case 12:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      });
    }, me.prototype.setMediaStream = function(ue) {
      this.mediaStream = ue;
    }, me.prototype.updateMediaStreamInVideos = function() {
      this.ee.emitEvent("mediastream-updated", []);
    }, me.prototype.getWebRtcPeer = function() {
      return this.webRtcPeer;
    }, me.prototype.subscribeToMyRemote = function(ue) {
      this.isSubscribeToRemote = ue;
    }, me.prototype.setOutboundStreamOptions = function(ue) {
      this.outboundStreamOpts = ue;
    }, me.prototype.subscribe = function() {
      var ue = this;
      return new Promise(function(Qe, Ue) {
        ue.initWebRtcPeerReceive(!1).then(function() {
          return Qe();
        }).catch(function(He) {
          return Ue(He);
        });
      });
    }, me.prototype.publish = function() {
      var ue = this;
      return new Promise(function(Qe, Ue) {
        ue.isLocalStreamReadyToPublish ? ue.initWebRtcPeerSend(!1).then(function() {
          return Qe();
        }).catch(function(He) {
          return Ue(He);
        }) : ue.ee.once("stream-ready-to-publish", function() {
          ue.publish().then(function() {
            return Qe();
          }).catch(function(He) {
            return Ue(He);
          });
        });
      });
    }, me.prototype.disposeWebRtcPeer = function() {
      var ue;
      this.webRtcPeer && (this.webRtcPeer.dispose(), ue = this.webRtcPeer.getId()), this.stopWebRtcStats(), logger$3.info((this.outboundStreamOpts ? "Outbound " : "Inbound ") + "RTCPeerConnection with id [" + ue + "] from 'Stream' with id [" + this.streamId + "] is now closed");
    }, me.prototype.disposeMediaStream = function() {
      return __awaiter$4(this, void 0, void 0, function() {
        var ue;
        return __generator$3(this, function(Qe) {
          switch (Qe.label) {
            case 0:
              if (!(this.filter && this.filter.type.startsWith("VB:"))) return [3, 4];
              Qe.label = 1;
            case 1:
              return Qe.trys.push([1, 3, , 4]), [4, this.removeFilterAux(!0)];
            case 2:
              return Qe.sent(), console.debug("Success removing Virtual Background filter for stream ".concat(this.streamId)), [3, 4];
            case 3:
              return ue = Qe.sent(), console.error("Error removing Virtual Background filter for stream ".concat(this.streamId), ue), [3, 4];
            case 4:
              return this.mediaStream && (this.mediaStream.getAudioTracks().forEach(function(Ue) {
                Ue.stop();
              }), this.mediaStream.getVideoTracks().forEach(function(Ue) {
                Ue.stop();
              }), delete this.mediaStream), this.localMediaStreamWhenSubscribedToRemote && (this.localMediaStreamWhenSubscribedToRemote.getAudioTracks().forEach(function(Ue) {
                Ue.stop();
              }), this.localMediaStreamWhenSubscribedToRemote.getVideoTracks().forEach(function(Ue) {
                Ue.stop();
              }), delete this.localMediaStreamWhenSubscribedToRemote), this.speechEvent && (this.speechEvent.stop && this.speechEvent.stop(), delete this.speechEvent), logger$3.info((this.outboundStreamOpts ? "Local " : "Remote ") + "MediaStream from 'Stream' with id [" + this.streamId + "] is now disposed"), [
                2
                /*return*/
              ];
          }
        });
      });
    }, me.prototype.displayMyRemote = function() {
      return this.isSubscribeToRemote;
    }, me.prototype.isSendAudio = function() {
      return !!this.outboundStreamOpts && this.outboundStreamOpts.publisherProperties.audioSource !== null && this.outboundStreamOpts.publisherProperties.audioSource !== !1;
    }, me.prototype.isSendVideo = function() {
      return !!this.outboundStreamOpts && this.outboundStreamOpts.publisherProperties.videoSource !== null && this.outboundStreamOpts.publisherProperties.videoSource !== !1;
    }, me.prototype.isSendScreen = function() {
      var ue = !1;
      if (typeof MediaStreamTrack < "u" && this.outboundStreamOpts.publisherProperties.videoSource instanceof MediaStreamTrack) {
        var Qe = this.outboundStreamOpts.publisherProperties.videoSource.getSettings();
        Qe.displaySurface && (ue = ["monitor", "window", "browser"].includes(Qe.displaySurface));
      }
      return !ue && platform$1.isElectron() && (ue = typeof this.outboundStreamOpts.publisherProperties.videoSource == "string" && this.outboundStreamOpts.publisherProperties.videoSource.startsWith("screen:")), ue || (ue = this.outboundStreamOpts.publisherProperties.videoSource === "screen"), !!this.outboundStreamOpts && ue;
    }, me.prototype.enableHarkSpeakingEvent = function() {
      var ue = this;
      this.setHarkListenerIfNotExists(), !this.harkSpeakingEnabled && this.speechEvent && (this.harkSpeakingEnabled = !0, this.speechEvent.on("speaking", function() {
        ue.session.emitEvent("publisherStartSpeaking", [
          new PublisherSpeakingEvent_1.PublisherSpeakingEvent(ue.session, "publisherStartSpeaking", ue.connection, ue.streamId)
        ]), ue.streamManager.emitEvent("publisherStartSpeaking", [
          new PublisherSpeakingEvent_1.PublisherSpeakingEvent(ue.streamManager, "publisherStartSpeaking", ue.connection, ue.streamId)
        ]), ue.harkSpeakingEnabledOnce = !1;
      }));
    }, me.prototype.enableOnceHarkSpeakingEvent = function() {
      var ue = this;
      this.setHarkListenerIfNotExists(), !this.harkSpeakingEnabledOnce && this.speechEvent && (this.harkSpeakingEnabledOnce = !0, this.speechEvent.once("speaking", function() {
        ue.harkSpeakingEnabledOnce && (ue.session.emitEvent("publisherStartSpeaking", [
          new PublisherSpeakingEvent_1.PublisherSpeakingEvent(ue.session, "publisherStartSpeaking", ue.connection, ue.streamId)
        ]), ue.streamManager.emitEvent("publisherStartSpeaking", [
          new PublisherSpeakingEvent_1.PublisherSpeakingEvent(ue.streamManager, "publisherStartSpeaking", ue.connection, ue.streamId)
        ])), ue.disableHarkSpeakingEvent(!0);
      }));
    }, me.prototype.disableHarkSpeakingEvent = function(ue) {
      if (this.speechEvent) {
        if (this.harkSpeakingEnabledOnce = !1, ue) {
          if (this.harkSpeakingEnabled)
            return;
        } else
          this.harkSpeakingEnabled = !1;
        this.harkVolumeChangeEnabled || this.harkVolumeChangeEnabledOnce || this.harkStoppedSpeakingEnabled || this.harkStoppedSpeakingEnabledOnce ? this.speechEvent.off("speaking") : (this.speechEvent.stop(), delete this.speechEvent);
      }
    }, me.prototype.enableHarkStoppedSpeakingEvent = function() {
      var ue = this;
      this.setHarkListenerIfNotExists(), !this.harkStoppedSpeakingEnabled && this.speechEvent && (this.harkStoppedSpeakingEnabled = !0, this.speechEvent.on("stopped_speaking", function() {
        ue.session.emitEvent("publisherStopSpeaking", [
          new PublisherSpeakingEvent_1.PublisherSpeakingEvent(ue.session, "publisherStopSpeaking", ue.connection, ue.streamId)
        ]), ue.streamManager.emitEvent("publisherStopSpeaking", [
          new PublisherSpeakingEvent_1.PublisherSpeakingEvent(ue.streamManager, "publisherStopSpeaking", ue.connection, ue.streamId)
        ]), ue.harkStoppedSpeakingEnabledOnce = !1;
      }));
    }, me.prototype.enableOnceHarkStoppedSpeakingEvent = function() {
      var ue = this;
      this.setHarkListenerIfNotExists(), !this.harkStoppedSpeakingEnabledOnce && this.speechEvent && (this.harkStoppedSpeakingEnabledOnce = !0, this.speechEvent.once("stopped_speaking", function() {
        ue.harkStoppedSpeakingEnabledOnce && (ue.session.emitEvent("publisherStopSpeaking", [
          new PublisherSpeakingEvent_1.PublisherSpeakingEvent(ue.session, "publisherStopSpeaking", ue.connection, ue.streamId)
        ]), ue.streamManager.emitEvent("publisherStopSpeaking", [
          new PublisherSpeakingEvent_1.PublisherSpeakingEvent(ue.streamManager, "publisherStopSpeaking", ue.connection, ue.streamId)
        ])), ue.disableHarkStoppedSpeakingEvent(!0);
      }));
    }, me.prototype.disableHarkStoppedSpeakingEvent = function(ue) {
      if (this.speechEvent) {
        if (this.harkStoppedSpeakingEnabledOnce = !1, ue) {
          if (this.harkStoppedSpeakingEnabled)
            return;
        } else
          this.harkStoppedSpeakingEnabled = !1;
        this.harkVolumeChangeEnabled || this.harkVolumeChangeEnabledOnce || this.harkSpeakingEnabled || this.harkSpeakingEnabledOnce ? this.speechEvent.off("stopped_speaking") : (this.speechEvent.stop(), delete this.speechEvent);
      }
    }, me.prototype.enableHarkVolumeChangeEvent = function(ue) {
      var Qe = this;
      this.setHarkListenerIfNotExists() ? (!this.harkVolumeChangeEnabled || ue) && (this.harkVolumeChangeEnabled = !0, this.speechEvent.on("volume_change", function(Ue) {
        var He = Qe.speechEvent.oldVolumeValue, Ge = { newValue: Ue, oldValue: He };
        Qe.speechEvent.oldVolumeValue = Ue, Qe.streamManager.emitEvent("streamAudioVolumeChange", [
          new StreamManagerEvent_1.StreamManagerEvent(Qe.streamManager, "streamAudioVolumeChange", Ge)
        ]);
      })) : this.harkVolumeChangeEnabled = !0;
    }, me.prototype.enableOnceHarkVolumeChangeEvent = function(ue) {
      var Qe = this;
      this.setHarkListenerIfNotExists() ? (!this.harkVolumeChangeEnabledOnce || ue) && (this.harkVolumeChangeEnabledOnce = !0, this.speechEvent.once("volume_change", function(Ue) {
        var He = Qe.speechEvent.oldVolumeValue, Ge = { newValue: Ue, oldValue: He };
        Qe.speechEvent.oldVolumeValue = Ue, Qe.disableHarkVolumeChangeEvent(!0), Qe.streamManager.emitEvent("streamAudioVolumeChange", [
          new StreamManagerEvent_1.StreamManagerEvent(Qe.streamManager, "streamAudioVolumeChange", Ge)
        ]);
      })) : this.harkVolumeChangeEnabledOnce = !0;
    }, me.prototype.disableHarkVolumeChangeEvent = function(ue) {
      if (this.speechEvent) {
        if (this.harkVolumeChangeEnabledOnce = !1, ue) {
          if (this.harkVolumeChangeEnabled)
            return;
        } else
          this.harkVolumeChangeEnabled = !1;
        this.harkSpeakingEnabled || this.harkSpeakingEnabledOnce || this.harkStoppedSpeakingEnabled || this.harkStoppedSpeakingEnabledOnce ? this.speechEvent.off("volume_change") : (this.speechEvent.stop(), delete this.speechEvent);
      }
    }, me.prototype.isLocal = function() {
      return !this.inboundStreamOpts && !!this.outboundStreamOpts;
    }, me.prototype.getSelectedIceCandidate = function() {
      var ue = this;
      return new Promise(function(Qe, Ue) {
        ue.webRtcStats.getSelectedIceCandidateInfo().then(function(He) {
          return Qe(He);
        }).catch(function(He) {
          return Ue(He);
        });
      });
    }, me.prototype.getRemoteIceCandidateList = function() {
      return this.webRtcPeer.remoteCandidatesQueue;
    }, me.prototype.getLocalIceCandidateList = function() {
      return this.webRtcPeer.localCandidatesQueue;
    }, me.prototype.streamIceConnectionStateBroken = function() {
      if (!this.getWebRtcPeer() || !this.getRTCPeerConnection())
        return !1;
      if (this.session.openvidu.advancedConfiguration.forceMediaReconnectionAfterNetworkDrop)
        return logger$3.warn('OpenVidu Browser advanced configuration option "forceMediaReconnectionAfterNetworkDrop" is enabled. Stream '.concat(this.streamId, " (").concat(this.isLocal() ? "Publisher" : "Subscriber", ") will force a reconnection")), !0;
      var ue = this.getRTCPeerConnection().iceConnectionState;
      return ue !== "connected" && ue !== "completed";
    }, me.prototype.setHarkListenerIfNotExists = function() {
      if (this.mediaStream) {
        if (!this.speechEvent) {
          var ue = this.harkOptions ? this.harkOptions : this.session.openvidu.advancedConfiguration.publisherSpeakingEventsOptions || {};
          ue.interval = typeof ue.interval == "number" ? ue.interval : 100, ue.threshold = typeof ue.threshold == "number" ? ue.threshold : -50, this.speechEvent = hark(this.mediaStream, ue);
        }
        return !0;
      }
      return !1;
    }, me.prototype.setupReconnectionEventEmitter = function(ue, Qe) {
      return this.reconnectionEventEmitter == null ? (this.reconnectionEventEmitter = new EventEmitter$2(), !1) : (console.warn("Trying to reconnect stream ".concat(this.streamId, " (").concat(this.isLocal() ? "Publisher" : "Subscriber", ") but an ongoing reconnection process is active. Waiting for response...")), this.reconnectionEventEmitter.once("success", function() {
        return ue();
      }), this.reconnectionEventEmitter.once("error", function(Ue) {
        return Qe(Ue);
      }), !0);
    }, me.prototype.initWebRtcPeerSend = function(ue) {
      var Qe = this;
      return new Promise(function(Ue, He) {
        var Ge;
        if (ue) {
          if (Qe.setupReconnectionEventEmitter(Ue, He))
            return;
        } else
          Qe.initHarkEvents();
        var Xe = function() {
          var Ze;
          return ue && ((Ze = Qe.reconnectionEventEmitter) === null || Ze === void 0 || Ze.emitEvent("success"), delete Qe.reconnectionEventEmitter), Ue();
        }, Ke = function(Ze) {
          var nt;
          return ue && ((nt = Qe.reconnectionEventEmitter) === null || nt === void 0 || nt.emitEvent("error", [Ze]), delete Qe.reconnectionEventEmitter), He(Ze);
        }, $e = function(Ze) {
          logger$3.debug("Sending SDP offer to publish as " + Qe.streamId, Ze);
          var nt = ue ? "reconnectStream" : "publishVideo", tt;
          if (ue)
            tt = {
              stream: Qe.streamId,
              sdpString: Ze
            };
          else {
            var et = void 0;
            Qe.isSendVideo() && (et = typeof MediaStreamTrack < "u" && Qe.outboundStreamOpts.publisherProperties.videoSource instanceof MediaStreamTrack ? TypeOfVideo_1.TypeOfVideo.CUSTOM : Qe.isSendScreen() ? TypeOfVideo_1.TypeOfVideo.SCREEN : TypeOfVideo_1.TypeOfVideo.CAMERA), tt = {
              doLoopback: Qe.displayMyRemote() || !1,
              hasAudio: Qe.isSendAudio(),
              hasVideo: Qe.isSendVideo(),
              audioActive: Qe.audioActive,
              videoActive: Qe.videoActive,
              typeOfVideo: et,
              frameRate: Qe.frameRate ? Qe.frameRate : -1,
              videoDimensions: JSON.stringify(Qe.videoDimensions),
              filter: Qe.outboundStreamOpts.publisherProperties.filter,
              sdpOffer: Ze
            };
          }
          Qe.session.openvidu.sendRequest(nt, tt, function(rt, it) {
            rt ? rt.code === 401 ? Ke(new OpenViduError_1$1.OpenViduError(OpenViduError_1$1.OpenViduErrorName.OPENVIDU_PERMISSION_DENIED, "You don't have permissions to publish")) : Ke("Error on publishVideo: " + JSON.stringify(rt)) : Qe.webRtcPeer.processRemoteAnswer(it.sdpAnswer).then(function() {
              Qe.streamId = it.id, Qe.creationTime = it.createdAt, Qe.isLocalStreamPublished = !0, Qe.publishedOnce = !0, Qe.displayMyRemote() && (Qe.localMediaStreamWhenSubscribedToRemote = Qe.mediaStream, Qe.remotePeerSuccessfullyEstablished(ue)), ue ? Qe.ee.emitEvent("stream-reconnected-by-publisher", []) : Qe.ee.emitEvent("stream-created-by-publisher", []), Qe.initWebRtcStats(), logger$3.info("'Publisher' (" + Qe.streamId + ") successfully " + (ue ? "reconnected" : "published") + " to session"), Xe();
            }).catch(function(ot) {
              Ke(ot);
            });
          });
        }, Je = {
          mediaConstraints: {
            audio: Qe.hasAudio,
            video: Qe.hasVideo
          },
          simulcast: (Ge = Qe.outboundStreamOpts.publisherProperties.videoSimulcast) !== null && Ge !== void 0 ? Ge : Qe.session.openvidu.videoSimulcast,
          onIceCandidate: Qe.connection.sendIceCandidate.bind(Qe.connection),
          onIceConnectionStateException: Qe.onIceConnectionStateExceptionHandler.bind(Qe),
          iceServers: Qe.getIceServersConf(),
          mediaStream: Qe.mediaStream,
          mediaServer: Qe.session.openvidu.mediaServer,
          typeOfVideo: Qe.typeOfVideo ? TypeOfVideo_1.TypeOfVideo[Qe.typeOfVideo] : void 0
        };
        Qe.session.openvidu.mediaServer !== "mediasoup" && (Je.simulcast = !1), ue && Qe.disposeWebRtcPeer(), Qe.displayMyRemote() ? Qe.webRtcPeer = new WebRtcPeer_1.WebRtcPeerSendrecv(Je) : Qe.webRtcPeer = new WebRtcPeer_1.WebRtcPeerSendonly(Je), Qe.webRtcPeer.addIceConnectionStateChangeListener("publisher of " + Qe.connection.connectionId), Qe.webRtcPeer.createOffer().then(function(Ze) {
          Qe.webRtcPeer.processLocalOffer(Ze).then(function() {
            $e(Ze.sdp);
          }).catch(function(nt) {
            Ke(new Error("(publish) SDP process local offer error: " + JSON.stringify(nt)));
          });
        }).catch(function(Ze) {
          Ke(new Error("(publish) SDP create offer error: " + JSON.stringify(Ze)));
        });
      });
    }, me.prototype.finalResolveForSubscription = function(ue, Qe) {
      var Ue;
      return logger$3.info("'Subscriber' (" + this.streamId + ") successfully " + (ue ? "reconnected" : "subscribed")), this.remotePeerSuccessfullyEstablished(ue), this.initWebRtcStats(), ue && ((Ue = this.reconnectionEventEmitter) === null || Ue === void 0 || Ue.emitEvent("success"), delete this.reconnectionEventEmitter), Qe();
    }, me.prototype.finalRejectForSubscription = function(ue, Qe, Ue) {
      var He;
      return logger$3.error("Error for 'Subscriber' (" + this.streamId + ") while trying to " + (ue ? "reconnect" : "subscribe") + ": " + Qe.toString()), ue && ((He = this.reconnectionEventEmitter) === null || He === void 0 || He.emitEvent("error", [Qe]), delete this.reconnectionEventEmitter), Ue(Qe);
    }, me.prototype.initWebRtcPeerReceive = function(ue) {
      var Qe = this;
      return new Promise(function(Ue, He) {
        ue && Qe.setupReconnectionEventEmitter(Ue, He) || (Qe.session.openvidu.mediaServer === "mediasoup" ? Qe.initWebRtcPeerReceiveFromServer(ue).then(function() {
          return Qe.finalResolveForSubscription(ue, Ue);
        }).catch(function(Ge) {
          return Qe.finalRejectForSubscription(ue, Ge, He);
        }) : Qe.initWebRtcPeerReceiveFromClient(ue).then(function() {
          return Qe.finalResolveForSubscription(ue, Ue);
        }).catch(function(Ge) {
          return Qe.finalRejectForSubscription(ue, Ge, He);
        }));
      });
    }, me.prototype.initWebRtcPeerReceiveFromClient = function(ue) {
      var Qe = this;
      return new Promise(function(Ue, He) {
        Qe.completeWebRtcPeerReceive(ue, !1).then(function(Ge) {
          Qe.webRtcPeer.processRemoteAnswer(Ge.sdpAnswer).then(function() {
            return Ue();
          }).catch(function(Xe) {
            return He(Xe);
          });
        }).catch(function(Ge) {
          return He(Ge);
        });
      });
    }, me.prototype.initWebRtcPeerReceiveFromServer = function(ue) {
      var Qe = this;
      return new Promise(function(Ue, He) {
        Qe.session.openvidu.sendRequest("prepareReceiveVideoFrom", { sender: Qe.streamId, reconnect: ue }, function(Ge, Xe) {
          if (Ge)
            return He(new Error("Error on prepareReceiveVideoFrom: " + JSON.stringify(Ge)));
          Qe.completeWebRtcPeerReceive(ue, !1, Xe.sdpOffer).then(function() {
            return Ue();
          }).catch(function(Ke) {
            return He(Ke);
          });
        });
      });
    }, me.prototype.completeWebRtcPeerReceive = function(ue, Qe, Ue) {
      var He = this;
      return new Promise(function(Ge, Xe) {
        logger$3.debug("'Session.subscribe(Stream)' called");
        var Ke = function(Je) {
          logger$3.debug("Sending local SDP ".concat(Ue ? "answer" : "offer", " to subscribe to ").concat(He.streamId), Je);
          var Ze = ue ? "reconnectStream" : "receiveVideoFrom", nt = {};
          nt[ue ? "stream" : "sender"] = He.streamId, Ue ? nt[ue ? "sdpString" : "sdpAnswer"] = Je : nt.sdpOffer = Je, ue && (nt.forciblyReconnect = Qe), He.session.openvidu.sendRequest(Ze, nt, function(tt, et) {
            return tt ? Xe(new Error("Error on " + Ze + " : " + JSON.stringify(tt))) : Ge(et);
          });
        }, $e = {
          mediaConstraints: {
            audio: He.hasAudio,
            video: He.hasVideo
          },
          simulcast: !1,
          onIceCandidate: He.connection.sendIceCandidate.bind(He.connection),
          onIceConnectionStateException: He.onIceConnectionStateExceptionHandler.bind(He),
          iceServers: He.getIceServersConf(),
          mediaServer: He.session.openvidu.mediaServer,
          typeOfVideo: He.typeOfVideo ? TypeOfVideo_1.TypeOfVideo[He.typeOfVideo] : void 0
        };
        ue && He.disposeWebRtcPeer(), He.webRtcPeer = new WebRtcPeer_1.WebRtcPeerRecvonly($e), He.webRtcPeer.addIceConnectionStateChangeListener(He.streamId), Ue ? He.webRtcPeer.processRemoteOffer(Ue).then(function() {
          He.webRtcPeer.createAnswer().then(function(Je) {
            He.webRtcPeer.processLocalAnswer(Je).then(function() {
              Ke(Je.sdp);
            }).catch(function(Ze) {
              return Xe(new Error("(subscribe) SDP process local answer error: " + JSON.stringify(Ze)));
            });
          }).catch(function(Je) {
            return Xe(new Error("(subscribe) SDP create answer error: " + JSON.stringify(Je)));
          });
        }).catch(function(Je) {
          return Xe(new Error("(subscribe) SDP process remote offer error: " + JSON.stringify(Je)));
        }) : He.webRtcPeer.createOffer().then(function(Je) {
          He.webRtcPeer.processLocalOffer(Je).then(function() {
            Ke(Je.sdp);
          }).catch(function(Ze) {
            return Xe(new Error("(subscribe) SDP process local offer error: " + JSON.stringify(Ze)));
          });
        }).catch(function(Je) {
          return Xe(new Error("(subscribe) SDP create offer error: " + JSON.stringify(Je)));
        });
      });
    }, me.prototype.remotePeerSuccessfullyEstablished = function(ue) {
      ue && this.mediaStream != null && this.disposeMediaStream(), this.mediaStream = new MediaStream();
      for (var Qe, Ue = 0, He = this.webRtcPeer.pc.getReceivers(); Ue < He.length; Ue++)
        Qe = He[Ue], Qe.track && this.mediaStream.addTrack(Qe.track);
      if (logger$3.debug("Peer remote stream", this.mediaStream), this.mediaStream) {
        if (this.streamManager instanceof Subscriber_1.Subscriber) {
          if (this.mediaStream.getAudioTracks()[0]) {
            var Ge = ue ? this.audioActive : !!this.streamManager.properties.subscribeToAudio;
            this.mediaStream.getAudioTracks()[0].enabled = Ge;
          }
          if (this.mediaStream.getVideoTracks()[0]) {
            var Ge = ue ? this.videoActive : !!this.videoActive && !!this.streamManager.properties.subscribeToVideo;
            this.mediaStream.getVideoTracks()[0].enabled = Ge;
          }
        }
        this.updateMediaStreamInVideos(), this.initHarkEvents();
      }
    }, me.prototype.initHarkEvents = function() {
      this.mediaStream.getAudioTracks()[0] && (this.session.anySpeechEventListenerEnabled("publisherStartSpeaking", !0, this.streamManager) && this.enableOnceHarkSpeakingEvent(), this.session.anySpeechEventListenerEnabled("publisherStartSpeaking", !1, this.streamManager) && this.enableHarkSpeakingEvent(), this.session.anySpeechEventListenerEnabled("publisherStopSpeaking", !0, this.streamManager) && this.enableOnceHarkStoppedSpeakingEvent(), this.session.anySpeechEventListenerEnabled("publisherStopSpeaking", !1, this.streamManager) && this.enableHarkStoppedSpeakingEvent(), this.harkVolumeChangeEnabledOnce && this.enableOnceHarkVolumeChangeEvent(!0), this.harkVolumeChangeEnabled && this.enableHarkVolumeChangeEvent(!0));
    }, me.prototype.onIceConnectionStateExceptionHandler = function(ue, Qe, Ue) {
      switch (ue) {
        case ExceptionEvent_1$1.ExceptionEventName.ICE_CONNECTION_FAILED:
          this.onIceConnectionFailed();
          break;
        case ExceptionEvent_1$1.ExceptionEventName.ICE_CONNECTION_DISCONNECTED:
          this.onIceConnectionDisconnected();
          break;
      }
      this.session.emitEvent("exception", [new ExceptionEvent_1$1.ExceptionEvent(this.session, ue, this, Qe, Ue)]);
    }, me.prototype.onIceConnectionFailed = function() {
      logger$3.log("[ICE_CONNECTION_FAILED] Handling ICE_CONNECTION_FAILED event. Reconnecting stream ".concat(this.streamId, " (").concat(this.isLocal() ? "Publisher" : "Subscriber", ")")), this.reconnectStreamAndLogResultingIceConnectionState(ExceptionEvent_1$1.ExceptionEventName.ICE_CONNECTION_FAILED);
    }, me.prototype.onIceConnectionDisconnected = function() {
      var ue = this;
      logger$3.log("[ICE_CONNECTION_DISCONNECTED] Handling ICE_CONNECTION_DISCONNECTED event. Waiting for ICE to be restored and reconnect stream ".concat(this.streamId, " (").concat(this.isLocal() ? "Publisher" : "Subscriber", ") if not possible"));
      var Qe = this.session.openvidu.advancedConfiguration.iceConnectionDisconnectedExceptionTimeout || 4e3;
      this.awaitWebRtcPeerConnectionState(Qe).then(function(Ue) {
        switch (Ue) {
          case "failed":
            logger$3.warn("[ICE_CONNECTION_DISCONNECTED] ICE connection of stream ".concat(ue.streamId, " (").concat(ue.isLocal() ? "Publisher" : "Subscriber", ") is now failed after ICE_CONNECTION_DISCONNECTED"));
            break;
          case "connected":
          case "completed":
            logger$3.log("[ICE_CONNECTION_DISCONNECTED] ICE connection of stream ".concat(ue.streamId, " (").concat(ue.isLocal() ? "Publisher" : "Subscriber", ") automatically restored after ICE_CONNECTION_DISCONNECTED. Current ICE connection state: ").concat(Ue));
            break;
          case "closed":
          case "checking":
          case "new":
          case "disconnected":
            logger$3.warn("[ICE_CONNECTION_DISCONNECTED] ICE connection of stream ".concat(ue.streamId, " (").concat(ue.isLocal() ? "Publisher" : "Subscriber", ") couldn't be restored after ICE_CONNECTION_DISCONNECTED event. Current ICE connection state after ").concat(Qe, " ms: ").concat(Ue)), ue.reconnectStreamAndLogResultingIceConnectionState(ExceptionEvent_1$1.ExceptionEventName.ICE_CONNECTION_DISCONNECTED);
            break;
        }
      });
    }, me.prototype.reconnectStreamAndLogResultingIceConnectionState = function(ue) {
      return __awaiter$4(this, void 0, void 0, function() {
        var Qe, Ue;
        return __generator$3(this, function(He) {
          switch (He.label) {
            case 0:
              return He.trys.push([0, 2, , 3]), [4, this.reconnectStreamAndReturnIceConnectionState(ue)];
            case 1:
              switch (Qe = He.sent(), Qe) {
                case "connected":
                case "completed":
                  logger$3.log("[".concat(ue, "] Stream ").concat(this.streamId, " (").concat(this.isLocal() ? "Publisher" : "Subscriber", ") successfully reconnected after ").concat(ue, ". Current ICE connection state: ").concat(Qe));
                  break;
                default:
                  logger$3.error("[".concat(ue, "] Stream ").concat(this.streamId, " (").concat(this.isLocal() ? "Publisher" : "Subscriber", ") failed to reconnect after ").concat(ue, ". Current ICE connection state: ").concat(Qe));
                  break;
              }
              return [3, 3];
            case 2:
              return Ue = He.sent(), logger$3.error("[".concat(ue, "] Error reconnecting stream ").concat(this.streamId, " (").concat(this.isLocal() ? "Publisher" : "Subscriber", ") after ").concat(ue, ": ").concat(Ue)), [3, 3];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, me.prototype.reconnectStreamAndReturnIceConnectionState = function(ue) {
      return __awaiter$4(this, void 0, void 0, function() {
        var Qe, Ue;
        return __generator$3(this, function(He) {
          switch (He.label) {
            case 0:
              logger$3.log("[".concat(ue, "] Reconnecting stream ").concat(this.streamId, " (").concat(this.isLocal() ? "Publisher" : "Subscriber", ") after event ").concat(ue)), He.label = 1;
            case 1:
              return He.trys.push([1, 3, , 4]), [4, this.reconnectStream(ue)];
            case 2:
              return He.sent(), Qe = this.session.openvidu.advancedConfiguration.iceConnectionDisconnectedExceptionTimeout || 4e3, [2, this.awaitWebRtcPeerConnectionState(Qe)];
            case 3:
              return Ue = He.sent(), logger$3.warn("[".concat(ue, "] Error reconnecting stream ").concat(this.streamId, " (").concat(this.isLocal() ? "Publisher" : "Subscriber", "). Reason: ").concat(Ue)), [2, this.awaitWebRtcPeerConnectionState(1)];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, me.prototype.awaitWebRtcPeerConnectionState = function(ue) {
      return __awaiter$4(this, void 0, void 0, function() {
        var Qe, Ue, He, Ge;
        return __generator$3(this, function(Xe) {
          switch (Xe.label) {
            case 0:
              Qe = this.getRTCPeerConnection().iceConnectionState, Ue = 150, He = Math.ceil(ue / Ue), Ge = 0, Xe.label = 1;
            case 1:
              return Ge < He ? (Qe = this.getRTCPeerConnection().iceConnectionState, Qe === "connected" || Qe === "completed" ? [3, 4] : [4, new Promise(function(Ke) {
                return setTimeout(Ke, Ue);
              })]) : [3, 4];
            case 2:
              Xe.sent(), Xe.label = 3;
            case 3:
              return Ge++, [3, 1];
            case 4:
              return [2, Qe];
          }
        });
      });
    }, me.prototype.reconnectStream = function(ue) {
      return __awaiter$4(this, void 0, void 0, function() {
        var Qe, Ue;
        return __generator$3(this, function(He) {
          switch (He.label) {
            case 0:
              return [4, this.isWebsocketConnected(ue, 3e3)];
            case 1:
              if (Qe = He.sent(), Qe)
                return logger$3.log("[".concat(ue, "] Trying to reconnect stream ").concat(this.streamId, " (").concat(this.isLocal() ? "Publisher" : "Subscriber", ") and the websocket is opened")), this.isLocal() ? [2, this.initWebRtcPeerSend(!0)] : [2, this.initWebRtcPeerReceive(!0)];
              throw Ue = "[".concat(ue, "] Trying to reconnect stream ").concat(this.streamId, " (").concat(this.isLocal() ? "Publisher" : "Subscriber", ") but the websocket wasn't opened"), logger$3.error(Ue), Error(Ue);
          }
        });
      });
    }, me.prototype.isWebsocketConnected = function(ue, Qe) {
      var Ue = this;
      return new Promise(function(He, Ge) {
        var Xe = Ue.session.openvidu.getWsReadyState();
        if (Xe === 1) {
          var Ke = setTimeout(function() {
            return console.warn("[".concat(ue, "] Websocket timeout of ").concat(Qe, "ms")), He(!1);
          }, Qe);
          Ue.session.openvidu.sendRequest("echo", {}, function($e, Je) {
            return clearTimeout(Ke), $e ? (console.warn("[".concat(ue, "] Websocket 'echo' returned error: ").concat($e)), He(!1)) : He(!0);
          });
        } else
          return console.warn("[".concat(ue, "] Websocket readyState is ").concat(Xe)), He(!1);
      });
    }, me.prototype.initWebRtcStats = function() {
      this.webRtcStats = new WebRtcStats_1.WebRtcStats(this), this.webRtcStats.initWebRtcStats();
    }, me.prototype.stopWebRtcStats = function() {
      this.webRtcStats && this.webRtcStats.isEnabled() && this.webRtcStats.stopWebRtcStats();
    }, me.prototype.getIceServersConf = function() {
      var ue;
      return this.session.openvidu.advancedConfiguration.iceServers ? ue = this.session.openvidu.advancedConfiguration.iceServers === "freeice" ? void 0 : this.session.openvidu.advancedConfiguration.iceServers : this.session.openvidu.iceServers ? ue = this.session.openvidu.iceServers : ue = void 0, ue;
    }, me.prototype.gatherStatsForPeer = function() {
      var ue = this;
      return new Promise(function(Qe, Ue) {
        ue.isLocal() ? ue.getRTCPeerConnection().getSenders().forEach(function(He) {
          return He.getStats().then(function(Ge) {
            Ge.forEach(function(Xe) {
              if (ue.isReportWanted(Xe)) {
                var Ke = {};
                Ke.type = Xe.type, Ke.timestamp = Xe.timestamp, Ke.id = Xe.id, Xe.type === "outbound-rtp" && (Ke.ssrc = Xe.ssrc, Ke.firCount = Xe.firCount, Ke.pliCount = Xe.pliCount, Ke.nackCount = Xe.nackCount, Ke.qpSum = Xe.qpSum, Xe.kind ? Ke.mediaType = Xe.kind : Xe.mediaType ? Ke.mediaType = Xe.mediaType : Ke.mediaType = Xe.id.indexOf("VideoStream") !== -1 ? "video" : "audio", Ke.mediaType === "video" && (Ke.framesEncoded = Xe.framesEncoded), Ke.packetsSent = Xe.packetsSent, Ke.bytesSent = Xe.bytesSent), Xe.type === "candidate-pair" && Xe.totalRoundTripTime !== void 0 && (Ke.availableOutgoingBitrate = Xe.availableOutgoingBitrate, Ke.rtt = Xe.currentRoundTripTime, Ke.averageRtt = Xe.totalRoundTripTime / Xe.responsesReceived), Xe.type === "remote-inbound-rtp" || Xe.type, logger$3.log(Ke);
              }
            });
          });
        }) : ue.getRTCPeerConnection().getReceivers().forEach(function(He) {
          return He.getStats().then(function(Ge) {
            Ge.forEach(function(Xe) {
              if (ue.isReportWanted(Xe)) {
                var Ke = {};
                Ke.type = Xe.type, Ke.timestamp = Xe.timestamp, Ke.id = Xe.id, Xe.type === "inbound-rtp" && (Ke.ssrc = Xe.ssrc, Ke.firCount = Xe.firCount, Ke.pliCount = Xe.pliCount, Ke.nackCount = Xe.nackCount, Ke.qpSum = Xe.qpSum, Xe.kind ? Ke.mediaType = Xe.kind : Xe.mediaType ? Ke.mediaType = Xe.mediaType : Ke.mediaType = Xe.id.indexOf("VideoStream") !== -1 ? "video" : "audio", Ke.mediaType === "video" && (Ke.framesDecoded = Xe.framesDecoded), Ke.packetsReceived = Xe.packetsReceived, Ke.packetsLost = Xe.packetsLost, Ke.jitter = Xe.jitter, Ke.bytesReceived = Xe.bytesReceived), Xe.type === "candidate-pair" && Xe.totalRoundTripTime !== void 0 && (Ke.availableIncomingBitrate = Xe.availableIncomingBitrate, Ke.rtt = Xe.currentRoundTripTime, Ke.averageRtt = Xe.totalRoundTripTime / Xe.responsesReceived), Xe.type === "remote-inbound-rtp" || Xe.type, logger$3.log(Ke);
              }
            });
          });
        });
      });
    }, me.prototype.isReportWanted = function(ue) {
      return ue.type === "inbound-rtp" && !this.isLocal() || ue.type === "outbound-rtp" && this.isLocal() || ue.type === "candidate-pair" && ue.nominated && ue.bytesSent > 0;
    }, me;
  }()
);
Stream$2.Stream = Stream$1;
Object.defineProperty(Connection$1, "__esModule", { value: !0 });
Connection$1.Connection = void 0;
var Stream_1 = Stream$2, OpenViduLogger_1$2 = OpenViduLogger$1, ExceptionEvent_1 = ExceptionEvent, logger$2 = OpenViduLogger_1$2.OpenViduLogger.getInstance(), Connection = (
  /** @class */
  function() {
    function me(ue, Qe) {
      this.session = ue, this.disposed = !1;
      var Ue = "'Connection' created ";
      Qe.role ? (this.localOptions = Qe, this.connectionId = this.localOptions.id, this.creationTime = this.localOptions.createdAt, this.data = this.localOptions.metadata, this.rpcSessionId = this.localOptions.sessionId, this.role = this.localOptions.role, this.record = this.localOptions.record, Ue += "(local)") : (this.remoteOptions = Qe, this.connectionId = this.remoteOptions.id, this.creationTime = this.remoteOptions.createdAt, this.remoteOptions.metadata && (this.data = this.remoteOptions.metadata), this.remoteOptions.streams && this.initRemoteStreams(this.remoteOptions.streams), Ue += "(remote) with 'connectionId' [" + this.remoteOptions.id + "]"), logger$2.info(Ue);
    }
    return me.prototype.sendIceCandidate = function(ue) {
      var Qe = this;
      this.disposed ? logger$2.warn("Connection ".concat(this.connectionId, " disposed when trying to send an ICE candidate. ICE candidate not sent")) : (logger$2.debug((this.stream.outboundStreamOpts ? "Local" : "Remote") + "candidate for" + this.connectionId, ue), this.session.openvidu.sendRequest("onIceCandidate", {
        endpointName: this.connectionId,
        candidate: ue.candidate,
        sdpMid: ue.sdpMid,
        sdpMLineIndex: ue.sdpMLineIndex
      }, function(Ue, He) {
        Ue && (logger$2.error("Error sending ICE candidate: " + JSON.stringify(Ue)), Qe.session.emitEvent("exception", [
          new ExceptionEvent_1.ExceptionEvent(Qe.session, ExceptionEvent_1.ExceptionEventName.ICE_CANDIDATE_ERROR, Qe.session, "There was an unexpected error on the server-side processing an ICE candidate generated and sent by the client-side", Ue)
        ]));
      }));
    }, me.prototype.initRemoteStreams = function(ue) {
      var Qe = this;
      ue.forEach(function(Ue) {
        var He = {
          id: Ue.id,
          createdAt: Ue.createdAt,
          connection: Qe,
          hasAudio: Ue.hasAudio,
          hasVideo: Ue.hasVideo,
          audioActive: Ue.audioActive,
          videoActive: Ue.videoActive,
          typeOfVideo: Ue.typeOfVideo,
          frameRate: Ue.frameRate,
          videoDimensions: Ue.videoDimensions ? JSON.parse(Ue.videoDimensions) : void 0,
          filter: Ue.filter ? Ue.filter : void 0
        }, Ge = new Stream_1.Stream(Qe.session, He);
        Qe.addStream(Ge);
      }), logger$2.info("Remote 'Connection' with 'connectionId' [" + this.connectionId + "] is now configured for receiving Streams with options: ", this.stream.inboundStreamOpts);
    }, me.prototype.addStream = function(ue) {
      ue.connection = this, this.stream = ue;
    }, me.prototype.removeStream = function() {
      delete this.stream;
    }, me.prototype.dispose = function() {
      this.disposed = !0, this.removeStream();
    }, me;
  }()
);
Connection$1.Connection = Connection;
var ConnectionEvent$1 = {}, __extends$1i = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) Object.prototype.hasOwnProperty.call(He, Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    if (typeof Qe != "function" && Qe !== null)
      throw new TypeError("Class extends value " + String(Qe) + " is not a constructor or null");
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}();
Object.defineProperty(ConnectionEvent$1, "__esModule", { value: !0 });
ConnectionEvent$1.ConnectionEvent = void 0;
var Event_1$7 = Event$2, ConnectionEvent = (
  /** @class */
  function(me) {
    __extends$1i(ue, me);
    function ue(Qe, Ue, He, Ge, Xe) {
      var Ke = me.call(this, Qe, Ue, He) || this;
      return Ke.connection = Ge, Ke.reason = Xe, Ke;
    }
    return ue.prototype.callDefaultBehavior = function() {
    }, ue;
  }(Event_1$7.Event)
);
ConnectionEvent$1.ConnectionEvent = ConnectionEvent;
var FilterEvent$1 = {}, __extends$1h = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) Object.prototype.hasOwnProperty.call(He, Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    if (typeof Qe != "function" && Qe !== null)
      throw new TypeError("Class extends value " + String(Qe) + " is not a constructor or null");
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}();
Object.defineProperty(FilterEvent$1, "__esModule", { value: !0 });
FilterEvent$1.FilterEvent = void 0;
var Event_1$6 = Event$2, FilterEvent = (
  /** @class */
  function(me) {
    __extends$1h(ue, me);
    function ue(Qe, Ue, He) {
      var Ge = me.call(this, !1, Qe, Ue) || this;
      return Ge.data = He, Ge;
    }
    return ue.prototype.callDefaultBehavior = function() {
    }, ue;
  }(Event_1$6.Event)
);
FilterEvent$1.FilterEvent = FilterEvent;
var RecordingEvent$1 = {}, __extends$1g = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) Object.prototype.hasOwnProperty.call(He, Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    if (typeof Qe != "function" && Qe !== null)
      throw new TypeError("Class extends value " + String(Qe) + " is not a constructor or null");
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}();
Object.defineProperty(RecordingEvent$1, "__esModule", { value: !0 });
RecordingEvent$1.RecordingEvent = void 0;
var Event_1$5 = Event$2, RecordingEvent = (
  /** @class */
  function(me) {
    __extends$1g(ue, me);
    function ue(Qe, Ue, He, Ge, Xe) {
      var Ke = me.call(this, !1, Qe, Ue) || this;
      return Ke.id = He, Ge !== He && (Ke.name = Ge), Ke.reason = Xe, Ke;
    }
    return ue.prototype.callDefaultBehavior = function() {
    }, ue;
  }(Event_1$5.Event)
);
RecordingEvent$1.RecordingEvent = RecordingEvent;
var SessionDisconnectedEvent$1 = {}, __extends$1f = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) Object.prototype.hasOwnProperty.call(He, Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    if (typeof Qe != "function" && Qe !== null)
      throw new TypeError("Class extends value " + String(Qe) + " is not a constructor or null");
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}();
Object.defineProperty(SessionDisconnectedEvent$1, "__esModule", { value: !0 });
SessionDisconnectedEvent$1.SessionDisconnectedEvent = void 0;
var Event_1$4 = Event$2, OpenViduLogger_1$1 = OpenViduLogger$1, logger$1 = OpenViduLogger_1$1.OpenViduLogger.getInstance(), SessionDisconnectedEvent = (
  /** @class */
  function(me) {
    __extends$1f(ue, me);
    function ue(Qe, Ue) {
      var He = me.call(this, !0, Qe, "sessionDisconnected") || this;
      return He.reason = Ue, He;
    }
    return ue.prototype.callDefaultBehavior = function() {
      logger$1.info("Calling default behavior upon '" + this.type + "' event dispatched by 'Session'");
      var Qe = this.target;
      Qe.remoteConnections.forEach(function(Ue) {
        var He, Ge, Xe, Ke, $e, Je, Ze, nt, tt = Ue.connectionId;
        if (!((He = Qe.remoteConnections.get(tt)) === null || He === void 0) && He.stream) {
          (Ge = Qe.remoteConnections.get(tt)) === null || Ge === void 0 || Ge.stream.disposeWebRtcPeer(), (Xe = Qe.remoteConnections.get(tt)) === null || Xe === void 0 || Xe.stream.disposeMediaStream(), !((Ke = Qe.remoteConnections.get(tt)) === null || Ke === void 0) && Ke.stream.streamManager && (($e = Qe.remoteConnections.get(tt)) === null || $e === void 0 || $e.stream.streamManager.removeAllVideos());
          var et = (Ze = (Je = Qe.remoteConnections.get(tt)) === null || Je === void 0 ? void 0 : Je.stream) === null || Ze === void 0 ? void 0 : Ze.streamId;
          et && Qe.remoteStreamsCreated.delete(et), (nt = Qe.remoteConnections.get(tt)) === null || nt === void 0 || nt.dispose();
        }
        Qe.remoteConnections.delete(tt);
      });
    }, ue;
  }(Event_1$4.Event)
);
SessionDisconnectedEvent$1.SessionDisconnectedEvent = SessionDisconnectedEvent;
var SignalEvent$1 = {}, __extends$1e = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) Object.prototype.hasOwnProperty.call(He, Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    if (typeof Qe != "function" && Qe !== null)
      throw new TypeError("Class extends value " + String(Qe) + " is not a constructor or null");
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}();
Object.defineProperty(SignalEvent$1, "__esModule", { value: !0 });
SignalEvent$1.SignalEvent = void 0;
var Event_1$3 = Event$2, SignalEvent = (
  /** @class */
  function(me) {
    __extends$1e(ue, me);
    function ue(Qe, Ue, He, Ge) {
      var Xe = me.call(this, !1, Qe, "signal") || this;
      return Ue && (Xe.type = "signal:" + Ue), Xe.data = He, Xe.from = Ge, Xe;
    }
    return ue.prototype.callDefaultBehavior = function() {
    }, ue;
  }(Event_1$3.Event)
);
SignalEvent$1.SignalEvent = SignalEvent;
var SpeechToTextEvent$1 = {}, __extends$1d = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) Object.prototype.hasOwnProperty.call(He, Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    if (typeof Qe != "function" && Qe !== null)
      throw new TypeError("Class extends value " + String(Qe) + " is not a constructor or null");
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}();
Object.defineProperty(SpeechToTextEvent$1, "__esModule", { value: !0 });
SpeechToTextEvent$1.SpeechToTextEvent = void 0;
var Event_1$2 = Event$2, SpeechToTextEvent = (
  /** @class */
  function(me) {
    __extends$1d(ue, me);
    function ue(Qe, Ue, He, Ge, Xe, Ke) {
      var $e = me.call(this, !1, Qe, "speechToTextMessage") || this;
      return $e.connection = Ue, $e.text = He, $e.reason = Ge, $e.raw = Xe, $e.lang = Ke, $e;
    }
    return ue.prototype.callDefaultBehavior = function() {
    }, ue;
  }(Event_1$2.Event)
);
SpeechToTextEvent$1.SpeechToTextEvent = SpeechToTextEvent;
var StreamEvent = {}, hasRequiredStreamEvent;
function requireStreamEvent() {
  if (hasRequiredStreamEvent) return StreamEvent;
  hasRequiredStreamEvent = 1;
  var me = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
    var Ke = function($e, Je) {
      return Ke = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ze, nt) {
        Ze.__proto__ = nt;
      } || function(Ze, nt) {
        for (var tt in nt) Object.prototype.hasOwnProperty.call(nt, tt) && (Ze[tt] = nt[tt]);
      }, Ke($e, Je);
    };
    return function($e, Je) {
      if (typeof Je != "function" && Je !== null)
        throw new TypeError("Class extends value " + String(Je) + " is not a constructor or null");
      Ke($e, Je);
      function Ze() {
        this.constructor = $e;
      }
      $e.prototype = Je === null ? Object.create(Je) : (Ze.prototype = Je.prototype, new Ze());
    };
  }();
  Object.defineProperty(StreamEvent, "__esModule", { value: !0 }), StreamEvent.StreamEvent = void 0;
  var ue = Event$2, Qe = requirePublisher(), Ue = requireSession(), He = OpenViduLogger$1, Ge = He.OpenViduLogger.getInstance(), Xe = (
    /** @class */
    function(Ke) {
      me($e, Ke);
      function $e(Je, Ze, nt, tt, et) {
        var rt = Ke.call(this, Je, Ze, nt) || this;
        return rt.stream = tt, rt.reason = et, rt;
      }
      return $e.prototype.callDefaultBehavior = function() {
        if (this.type === "streamDestroyed") {
          if (this.target instanceof Ue.Session)
            Ge.info("Calling default behavior upon '" + this.type + "' event dispatched by 'Session'"), this.stream.disposeWebRtcPeer();
          else if (this.target instanceof Qe.Publisher) {
            Ge.info("Calling default behavior upon '" + this.type + "' event dispatched by 'Publisher'"), clearInterval(this.target.screenShareResizeInterval), this.stream.isLocalStreamReadyToPublish = !1;
            for (var Je = this.target.openvidu.publishers, Ze = 0; Ze < Je.length; Ze++)
              if (Je[Ze] === this.target) {
                Je.splice(Ze, 1);
                break;
              }
          }
          this.stream.disposeMediaStream(), this.stream.streamManager && this.stream.streamManager.removeAllVideos(), this.stream.session.remoteStreamsCreated.delete(this.stream.streamId);
          var nt = this.stream.session.remoteConnections.get(this.stream.connection.connectionId);
          if (nt && nt.remoteOptions)
            for (var tt = nt.remoteOptions.streams, Ze = tt.length - 1; Ze >= 0; --Ze)
              tt[Ze].id === this.stream.streamId && tt.splice(Ze, 1);
        }
      }, $e;
    }(ue.Event)
  );
  return StreamEvent.StreamEvent = Xe, StreamEvent;
}
var ConnectionPropertyChangedEvent$1 = {}, __extends$1c = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) Object.prototype.hasOwnProperty.call(He, Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    if (typeof Qe != "function" && Qe !== null)
      throw new TypeError("Class extends value " + String(Qe) + " is not a constructor or null");
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}();
Object.defineProperty(ConnectionPropertyChangedEvent$1, "__esModule", { value: !0 });
ConnectionPropertyChangedEvent$1.ConnectionPropertyChangedEvent = void 0;
var Event_1$1 = Event$2, ConnectionPropertyChangedEvent = (
  /** @class */
  function(me) {
    __extends$1c(ue, me);
    function ue(Qe, Ue, He, Ge, Xe) {
      var Ke = me.call(this, !1, Qe, "connectionPropertyChanged") || this;
      return Ke.connection = Ue, Ke.changedProperty = He, Ke.newValue = Ge, Ke.oldValue = Xe, Ke;
    }
    return ue.prototype.callDefaultBehavior = function() {
    }, ue;
  }(Event_1$1.Event)
);
ConnectionPropertyChangedEvent$1.ConnectionPropertyChangedEvent = ConnectionPropertyChangedEvent;
var NetworkQualityLevelChangedEvent$1 = {}, __extends$1b = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) Object.prototype.hasOwnProperty.call(He, Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    if (typeof Qe != "function" && Qe !== null)
      throw new TypeError("Class extends value " + String(Qe) + " is not a constructor or null");
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}();
Object.defineProperty(NetworkQualityLevelChangedEvent$1, "__esModule", { value: !0 });
NetworkQualityLevelChangedEvent$1.NetworkQualityLevelChangedEvent = void 0;
var Event_1 = Event$2, NetworkQualityLevelChangedEvent = (
  /** @class */
  function(me) {
    __extends$1b(ue, me);
    function ue(Qe, Ue, He, Ge) {
      var Xe = me.call(this, !1, Qe, "networkQualityLevelChanged") || this;
      return Xe.newValue = Ue, Xe.oldValue = He, Xe.connection = Ge, Xe;
    }
    return ue.prototype.callDefaultBehavior = function() {
    }, ue;
  }(Event_1.Event)
);
NetworkQualityLevelChangedEvent$1.NetworkQualityLevelChangedEvent = NetworkQualityLevelChangedEvent;
const debug$1 = typeof process == "object" && process.env && process.env.NODE_DEBUG && /\bsemver\b/i.test(process.env.NODE_DEBUG) ? (...me) => console.error("SEMVER", ...me) : () => {
};
var debug_1 = debug$1;
const SEMVER_SPEC_VERSION = "2.0.0", MAX_LENGTH$1 = 256, MAX_SAFE_INTEGER$1 = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */
9007199254740991, MAX_SAFE_COMPONENT_LENGTH = 16;
var constants = {
  SEMVER_SPEC_VERSION,
  MAX_LENGTH: MAX_LENGTH$1,
  MAX_SAFE_INTEGER: MAX_SAFE_INTEGER$1,
  MAX_SAFE_COMPONENT_LENGTH
}, re$2 = { exports: {} };
(function(me, ue) {
  const { MAX_SAFE_COMPONENT_LENGTH: Qe } = constants, Ue = debug_1;
  ue = me.exports = {};
  const He = ue.re = [], Ge = ue.src = [], Xe = ue.t = {};
  let Ke = 0;
  const $e = (Je, Ze, nt) => {
    const tt = Ke++;
    Ue(Je, tt, Ze), Xe[Je] = tt, Ge[tt] = Ze, He[tt] = new RegExp(Ze, nt ? "g" : void 0);
  };
  $e("NUMERICIDENTIFIER", "0|[1-9]\\d*"), $e("NUMERICIDENTIFIERLOOSE", "[0-9]+"), $e("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*"), $e("MAINVERSION", `(${Ge[Xe.NUMERICIDENTIFIER]})\\.(${Ge[Xe.NUMERICIDENTIFIER]})\\.(${Ge[Xe.NUMERICIDENTIFIER]})`), $e("MAINVERSIONLOOSE", `(${Ge[Xe.NUMERICIDENTIFIERLOOSE]})\\.(${Ge[Xe.NUMERICIDENTIFIERLOOSE]})\\.(${Ge[Xe.NUMERICIDENTIFIERLOOSE]})`), $e("PRERELEASEIDENTIFIER", `(?:${Ge[Xe.NUMERICIDENTIFIER]}|${Ge[Xe.NONNUMERICIDENTIFIER]})`), $e("PRERELEASEIDENTIFIERLOOSE", `(?:${Ge[Xe.NUMERICIDENTIFIERLOOSE]}|${Ge[Xe.NONNUMERICIDENTIFIER]})`), $e("PRERELEASE", `(?:-(${Ge[Xe.PRERELEASEIDENTIFIER]}(?:\\.${Ge[Xe.PRERELEASEIDENTIFIER]})*))`), $e("PRERELEASELOOSE", `(?:-?(${Ge[Xe.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${Ge[Xe.PRERELEASEIDENTIFIERLOOSE]})*))`), $e("BUILDIDENTIFIER", "[0-9A-Za-z-]+"), $e("BUILD", `(?:\\+(${Ge[Xe.BUILDIDENTIFIER]}(?:\\.${Ge[Xe.BUILDIDENTIFIER]})*))`), $e("FULLPLAIN", `v?${Ge[Xe.MAINVERSION]}${Ge[Xe.PRERELEASE]}?${Ge[Xe.BUILD]}?`), $e("FULL", `^${Ge[Xe.FULLPLAIN]}$`), $e("LOOSEPLAIN", `[v=\\s]*${Ge[Xe.MAINVERSIONLOOSE]}${Ge[Xe.PRERELEASELOOSE]}?${Ge[Xe.BUILD]}?`), $e("LOOSE", `^${Ge[Xe.LOOSEPLAIN]}$`), $e("GTLT", "((?:<|>)?=?)"), $e("XRANGEIDENTIFIERLOOSE", `${Ge[Xe.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), $e("XRANGEIDENTIFIER", `${Ge[Xe.NUMERICIDENTIFIER]}|x|X|\\*`), $e("XRANGEPLAIN", `[v=\\s]*(${Ge[Xe.XRANGEIDENTIFIER]})(?:\\.(${Ge[Xe.XRANGEIDENTIFIER]})(?:\\.(${Ge[Xe.XRANGEIDENTIFIER]})(?:${Ge[Xe.PRERELEASE]})?${Ge[Xe.BUILD]}?)?)?`), $e("XRANGEPLAINLOOSE", `[v=\\s]*(${Ge[Xe.XRANGEIDENTIFIERLOOSE]})(?:\\.(${Ge[Xe.XRANGEIDENTIFIERLOOSE]})(?:\\.(${Ge[Xe.XRANGEIDENTIFIERLOOSE]})(?:${Ge[Xe.PRERELEASELOOSE]})?${Ge[Xe.BUILD]}?)?)?`), $e("XRANGE", `^${Ge[Xe.GTLT]}\\s*${Ge[Xe.XRANGEPLAIN]}$`), $e("XRANGELOOSE", `^${Ge[Xe.GTLT]}\\s*${Ge[Xe.XRANGEPLAINLOOSE]}$`), $e("COERCE", `(^|[^\\d])(\\d{1,${Qe}})(?:\\.(\\d{1,${Qe}}))?(?:\\.(\\d{1,${Qe}}))?(?:$|[^\\d])`), $e("COERCERTL", Ge[Xe.COERCE], !0), $e("LONETILDE", "(?:~>?)"), $e("TILDETRIM", `(\\s*)${Ge[Xe.LONETILDE]}\\s+`, !0), ue.tildeTrimReplace = "$1~", $e("TILDE", `^${Ge[Xe.LONETILDE]}${Ge[Xe.XRANGEPLAIN]}$`), $e("TILDELOOSE", `^${Ge[Xe.LONETILDE]}${Ge[Xe.XRANGEPLAINLOOSE]}$`), $e("LONECARET", "(?:\\^)"), $e("CARETTRIM", `(\\s*)${Ge[Xe.LONECARET]}\\s+`, !0), ue.caretTrimReplace = "$1^", $e("CARET", `^${Ge[Xe.LONECARET]}${Ge[Xe.XRANGEPLAIN]}$`), $e("CARETLOOSE", `^${Ge[Xe.LONECARET]}${Ge[Xe.XRANGEPLAINLOOSE]}$`), $e("COMPARATORLOOSE", `^${Ge[Xe.GTLT]}\\s*(${Ge[Xe.LOOSEPLAIN]})$|^$`), $e("COMPARATOR", `^${Ge[Xe.GTLT]}\\s*(${Ge[Xe.FULLPLAIN]})$|^$`), $e("COMPARATORTRIM", `(\\s*)${Ge[Xe.GTLT]}\\s*(${Ge[Xe.LOOSEPLAIN]}|${Ge[Xe.XRANGEPLAIN]})`, !0), ue.comparatorTrimReplace = "$1$2$3", $e("HYPHENRANGE", `^\\s*(${Ge[Xe.XRANGEPLAIN]})\\s+-\\s+(${Ge[Xe.XRANGEPLAIN]})\\s*$`), $e("HYPHENRANGELOOSE", `^\\s*(${Ge[Xe.XRANGEPLAINLOOSE]})\\s+-\\s+(${Ge[Xe.XRANGEPLAINLOOSE]})\\s*$`), $e("STAR", "(<|>)?=?\\s*\\*"), $e("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), $e("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
})(re$2, re$2.exports);
var reExports = re$2.exports;
const opts = ["includePrerelease", "loose", "rtl"], parseOptions$2 = (me) => me ? typeof me != "object" ? { loose: !0 } : opts.filter((ue) => me[ue]).reduce((ue, Qe) => (ue[Qe] = !0, ue), {}) : {};
var parseOptions_1 = parseOptions$2;
const numeric = /^[0-9]+$/, compareIdentifiers$1 = (me, ue) => {
  const Qe = numeric.test(me), Ue = numeric.test(ue);
  return Qe && Ue && (me = +me, ue = +ue), me === ue ? 0 : Qe && !Ue ? -1 : Ue && !Qe ? 1 : me < ue ? -1 : 1;
}, rcompareIdentifiers = (me, ue) => compareIdentifiers$1(ue, me);
var identifiers = {
  compareIdentifiers: compareIdentifiers$1,
  rcompareIdentifiers
};
const debug = debug_1, { MAX_LENGTH, MAX_SAFE_INTEGER } = constants, { re: re$1, t } = reExports, parseOptions$1 = parseOptions_1, { compareIdentifiers } = identifiers;
let SemVer$2 = class La {
  constructor(ue, Qe) {
    if (Qe = parseOptions$1(Qe), ue instanceof La) {
      if (ue.loose === !!Qe.loose && ue.includePrerelease === !!Qe.includePrerelease)
        return ue;
      ue = ue.version;
    } else if (typeof ue != "string")
      throw new TypeError(`Invalid Version: ${ue}`);
    if (ue.length > MAX_LENGTH)
      throw new TypeError(
        `version is longer than ${MAX_LENGTH} characters`
      );
    debug("SemVer", ue, Qe), this.options = Qe, this.loose = !!Qe.loose, this.includePrerelease = !!Qe.includePrerelease;
    const Ue = ue.trim().match(Qe.loose ? re$1[t.LOOSE] : re$1[t.FULL]);
    if (!Ue)
      throw new TypeError(`Invalid Version: ${ue}`);
    if (this.raw = ue, this.major = +Ue[1], this.minor = +Ue[2], this.patch = +Ue[3], this.major > MAX_SAFE_INTEGER || this.major < 0)
      throw new TypeError("Invalid major version");
    if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
      throw new TypeError("Invalid minor version");
    if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
      throw new TypeError("Invalid patch version");
    Ue[4] ? this.prerelease = Ue[4].split(".").map((He) => {
      if (/^[0-9]+$/.test(He)) {
        const Ge = +He;
        if (Ge >= 0 && Ge < MAX_SAFE_INTEGER)
          return Ge;
      }
      return He;
    }) : this.prerelease = [], this.build = Ue[5] ? Ue[5].split(".") : [], this.format();
  }
  format() {
    return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
  }
  toString() {
    return this.version;
  }
  compare(ue) {
    if (debug("SemVer.compare", this.version, this.options, ue), !(ue instanceof La)) {
      if (typeof ue == "string" && ue === this.version)
        return 0;
      ue = new La(ue, this.options);
    }
    return ue.version === this.version ? 0 : this.compareMain(ue) || this.comparePre(ue);
  }
  compareMain(ue) {
    return ue instanceof La || (ue = new La(ue, this.options)), compareIdentifiers(this.major, ue.major) || compareIdentifiers(this.minor, ue.minor) || compareIdentifiers(this.patch, ue.patch);
  }
  comparePre(ue) {
    if (ue instanceof La || (ue = new La(ue, this.options)), this.prerelease.length && !ue.prerelease.length)
      return -1;
    if (!this.prerelease.length && ue.prerelease.length)
      return 1;
    if (!this.prerelease.length && !ue.prerelease.length)
      return 0;
    let Qe = 0;
    do {
      const Ue = this.prerelease[Qe], He = ue.prerelease[Qe];
      if (debug("prerelease compare", Qe, Ue, He), Ue === void 0 && He === void 0)
        return 0;
      if (He === void 0)
        return 1;
      if (Ue === void 0)
        return -1;
      if (Ue === He)
        continue;
      return compareIdentifiers(Ue, He);
    } while (++Qe);
  }
  compareBuild(ue) {
    ue instanceof La || (ue = new La(ue, this.options));
    let Qe = 0;
    do {
      const Ue = this.build[Qe], He = ue.build[Qe];
      if (debug("prerelease compare", Qe, Ue, He), Ue === void 0 && He === void 0)
        return 0;
      if (He === void 0)
        return 1;
      if (Ue === void 0)
        return -1;
      if (Ue === He)
        continue;
      return compareIdentifiers(Ue, He);
    } while (++Qe);
  }
  // preminor will bump the version up to the next minor release, and immediately
  // down to pre-release. premajor and prepatch work the same way.
  inc(ue, Qe) {
    switch (ue) {
      case "premajor":
        this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", Qe);
        break;
      case "preminor":
        this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", Qe);
        break;
      case "prepatch":
        this.prerelease.length = 0, this.inc("patch", Qe), this.inc("pre", Qe);
        break;
      case "prerelease":
        this.prerelease.length === 0 && this.inc("patch", Qe), this.inc("pre", Qe);
        break;
      case "major":
        (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
        break;
      case "minor":
        (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
        break;
      case "patch":
        this.prerelease.length === 0 && this.patch++, this.prerelease = [];
        break;
      case "pre":
        if (this.prerelease.length === 0)
          this.prerelease = [0];
        else {
          let Ue = this.prerelease.length;
          for (; --Ue >= 0; )
            typeof this.prerelease[Ue] == "number" && (this.prerelease[Ue]++, Ue = -2);
          Ue === -1 && this.prerelease.push(0);
        }
        Qe && (compareIdentifiers(this.prerelease[0], Qe) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = [Qe, 0]) : this.prerelease = [Qe, 0]);
        break;
      default:
        throw new Error(`invalid increment argument: ${ue}`);
    }
    return this.format(), this.raw = this.version, this;
  }
};
var semver = SemVer$2;
const SemVer$1 = semver, major = (me, ue) => new SemVer$1(me, ue).major;
var major_1 = major;
const SemVer = semver, minor = (me, ue) => new SemVer(me, ue).minor;
var minor_1 = minor, hasRequiredSession;
function requireSession() {
  if (hasRequiredSession) return Session;
  hasRequiredSession = 1;
  var me = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
    var Tt = function(yt, Ct) {
      return Tt = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(ht, It) {
        ht.__proto__ = It;
      } || function(ht, It) {
        for (var vt in It) Object.prototype.hasOwnProperty.call(It, vt) && (ht[vt] = It[vt]);
      }, Tt(yt, Ct);
    };
    return function(yt, Ct) {
      if (typeof Ct != "function" && Ct !== null)
        throw new TypeError("Class extends value " + String(Ct) + " is not a constructor or null");
      Tt(yt, Ct);
      function ht() {
        this.constructor = yt;
      }
      yt.prototype = Ct === null ? Object.create(Ct) : (ht.prototype = Ct.prototype, new ht());
    };
  }(), ue = commonjsGlobal && commonjsGlobal.__awaiter || function(Tt, yt, Ct, ht) {
    function It(vt) {
      return vt instanceof Ct ? vt : new Ct(function(Et) {
        Et(vt);
      });
    }
    return new (Ct || (Ct = Promise))(function(vt, Et) {
      function bt(kt) {
        try {
          St(ht.next(kt));
        } catch (jt) {
          Et(jt);
        }
      }
      function Rt(kt) {
        try {
          St(ht.throw(kt));
        } catch (jt) {
          Et(jt);
        }
      }
      function St(kt) {
        kt.done ? vt(kt.value) : It(kt.value).then(bt, Rt);
      }
      St((ht = ht.apply(Tt, yt || [])).next());
    });
  }, Qe = commonjsGlobal && commonjsGlobal.__generator || function(Tt, yt) {
    var Ct = { label: 0, sent: function() {
      if (vt[0] & 1) throw vt[1];
      return vt[1];
    }, trys: [], ops: [] }, ht, It, vt, Et;
    return Et = { next: bt(0), throw: bt(1), return: bt(2) }, typeof Symbol == "function" && (Et[Symbol.iterator] = function() {
      return this;
    }), Et;
    function bt(St) {
      return function(kt) {
        return Rt([St, kt]);
      };
    }
    function Rt(St) {
      if (ht) throw new TypeError("Generator is already executing.");
      for (; Et && (Et = 0, St[0] && (Ct = 0)), Ct; ) try {
        if (ht = 1, It && (vt = St[0] & 2 ? It.return : St[0] ? It.throw || ((vt = It.return) && vt.call(It), 0) : It.next) && !(vt = vt.call(It, St[1])).done) return vt;
        switch (It = 0, vt && (St = [St[0] & 2, vt.value]), St[0]) {
          case 0:
          case 1:
            vt = St;
            break;
          case 4:
            return Ct.label++, { value: St[1], done: !1 };
          case 5:
            Ct.label++, It = St[1], St = [0];
            continue;
          case 7:
            St = Ct.ops.pop(), Ct.trys.pop();
            continue;
          default:
            if (vt = Ct.trys, !(vt = vt.length > 0 && vt[vt.length - 1]) && (St[0] === 6 || St[0] === 2)) {
              Ct = 0;
              continue;
            }
            if (St[0] === 3 && (!vt || St[1] > vt[0] && St[1] < vt[3])) {
              Ct.label = St[1];
              break;
            }
            if (St[0] === 6 && Ct.label < vt[1]) {
              Ct.label = vt[1], vt = St;
              break;
            }
            if (vt && Ct.label < vt[2]) {
              Ct.label = vt[2], Ct.ops.push(St);
              break;
            }
            vt[2] && Ct.ops.pop(), Ct.trys.pop();
            continue;
        }
        St = yt.call(Tt, Ct);
      } catch (kt) {
        St = [6, kt], It = 0;
      } finally {
        ht = vt = 0;
      }
      if (St[0] & 5) throw St[1];
      return { value: St[0] ? St[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(Session, "__esModule", { value: !0 }), Session.Session = void 0;
  var Ue = Connection$1, He = Filter$1, Ge = Subscriber$1, Xe = EventDispatcher$1, Ke = ConnectionEvent$1, $e = FilterEvent$1, Je = RecordingEvent$1, Ze = SessionDisconnectedEvent$1, nt = SignalEvent$1, tt = SpeechToTextEvent$1, et = requireStreamEvent(), rt = StreamPropertyChangedEvent$1, it = ConnectionPropertyChangedEvent$1, ot = NetworkQualityLevelChangedEvent$1, at = OpenViduError, st = VideoInsertMode, ut = OpenViduLogger$1, lt = Platform, dt = major_1, At = minor_1, pt = ExceptionEvent, gt = ut.OpenViduLogger.getInstance(), wt, Bt = (
    /** @class */
    function(Tt) {
      me(yt, Tt);
      function yt(Ct) {
        var ht = Tt.call(this) || this;
        return ht.streamManagers = [], ht.remoteStreamsCreated = /* @__PURE__ */ new Map(), ht.remoteConnections = /* @__PURE__ */ new Map(), wt = lt.PlatformUtils.getInstance(), ht.openvidu = Ct, ht;
      }
      return yt.prototype.connect = function(Ct, ht) {
        var It = this;
        return new Promise(function(vt, Et) {
          if (It.processToken(Ct), It.openvidu.checkSystemRequirements())
            It.options = {
              sessionId: It.sessionId,
              participantId: Ct,
              metadata: ht ? It.stringClientMetadata(ht) : ""
            }, It.connectAux(Ct).then(function() {
              return vt();
            }).catch(function(bt) {
              return Et(bt);
            });
          else
            return Et(new at.OpenViduError(at.OpenViduErrorName.BROWSER_NOT_SUPPORTED, "Browser " + wt.getName() + " (version " + wt.getVersion() + ") for " + wt.getFamily() + " is not supported in OpenVidu"));
        });
      }, yt.prototype.disconnect = function() {
        this.leave(!1, "disconnect");
      }, yt.prototype.subscribe = function(Ct, ht, It, vt) {
        var Et = {};
        It && typeof It != "function" ? Et = {
          insertMode: typeof It.insertMode < "u" ? typeof It.insertMode == "string" ? st.VideoInsertMode[It.insertMode] : Et.insertMode : st.VideoInsertMode.APPEND,
          subscribeToAudio: typeof It.subscribeToAudio < "u" ? It.subscribeToAudio : !0,
          subscribeToVideo: typeof It.subscribeToVideo < "u" ? It.subscribeToVideo : !0
        } : Et = {
          insertMode: st.VideoInsertMode.APPEND,
          subscribeToAudio: !0,
          subscribeToVideo: !0
        };
        var bt = void 0;
        if (It && typeof It == "function" ? bt = It : vt && (bt = vt), !this.sessionConnected())
          throw bt !== void 0 && bt(this.notConnectedError()), this.notConnectedError();
        gt.info("Subscribing to " + Ct.connection.connectionId), Ct.subscribe().then(function() {
          gt.info("Subscribed correctly to " + Ct.connection.connectionId), bt !== void 0 && bt(void 0);
        }).catch(function(St) {
          bt !== void 0 && bt(St);
        });
        var Rt = new Ge.Subscriber(Ct, ht, Et);
        return Rt.targetElement && Ct.streamManager.createVideoElement(Rt.targetElement, Et.insertMode), Rt;
      }, yt.prototype.subscribeAsync = function(Ct, ht, It) {
        var vt = this;
        return new Promise(function(Et, bt) {
          if (!vt.sessionConnected())
            return bt(vt.notConnectedError());
          var Rt, St = function(kt) {
            return kt ? bt(kt) : Et(Rt);
          };
          It ? Rt = vt.subscribe(Ct, ht, It, St) : Rt = vt.subscribe(Ct, ht, St);
        });
      }, yt.prototype.unsubscribe = function(Ct) {
        var ht = this;
        return new Promise(function(It, vt) {
          if (ht.sessionConnected()) {
            var Et = Ct.stream.connection.connectionId;
            gt.info("Unsubscribing from " + Et), ht.openvidu.sendRequest("unsubscribeFromVideo", { sender: Ct.stream.connection.connectionId }, function(bt, Rt) {
              return bt ? (gt.error("Error unsubscribing from " + Et), vt(bt)) : (gt.info("Unsubscribed correctly from " + Et), Ct.stream.streamManager.removeAllVideos(), Ct.stream.disposeWebRtcPeer(), Ct.stream.disposeMediaStream(), It());
            });
          } else
            return vt(ht.notConnectedError());
        });
      }, yt.prototype.publish = function(Ct) {
        var ht = this;
        return new Promise(function(It, vt) {
          if (!ht.sessionConnected())
            return vt(ht.notConnectedError());
          Ct.session = ht, Ct.stream.session = ht, Ct.stream.publishedOnce ? Ct.initialize().then(function() {
            ht.connection.addStream(Ct.stream), Ct.reestablishStreamPlayingEvent(), Ct.stream.publish().then(function() {
              return ht.sendVideoData(Ct, 8, !0, 5), It();
            }).catch(function(Et) {
              return vt(Et);
            });
          }).catch(function(Et) {
            return vt(Et);
          }) : (ht.connection.addStream(Ct.stream), Ct.stream.publish().then(function() {
            return ht.sendVideoData(Ct, 8, !0, 5), It();
          }).catch(function(Et) {
            return vt(Et);
          }));
        });
      }, yt.prototype.unpublish = function(Ct) {
        var ht = this;
        return new Promise(function(It, vt) {
          if (!ht.sessionConnected())
            throw ht.notConnectedError();
          var Et = Ct.stream;
          if (Et.connection) {
            if (Et.connection !== ht.connection)
              return vt(new Error("The associated Connection object of this Publisher is not your local Connection.  Only moderators can force unpublish on remote Streams via 'forceUnpublish' method"));
            gt.info("Unpublishing local media (" + Et.connection.connectionId + ")"), ht.openvidu.sendRequest("unpublishVideo", function(bt, Rt) {
              if (bt)
                return vt(bt);
              gt.info("Media unpublished correctly"), Et.disposeWebRtcPeer(), Et.connection.stream == Et && delete Et.connection.stream;
              var St = new et.StreamEvent(!0, Ct, "streamDestroyed", Ct.stream, "unpublish");
              return Ct.emitEvent("streamDestroyed", [St]), St.callDefaultBehavior(), It();
            });
          } else return vt(new Error("The associated Connection object of this Publisher is null"));
        });
      }, yt.prototype.forceDisconnect = function(Ct) {
        var ht = this;
        return new Promise(function(It, vt) {
          if (!ht.sessionConnected())
            return vt(ht.notConnectedError());
          gt.info("Forcing disconnect for connection " + Ct.connectionId), ht.openvidu.sendRequest("forceDisconnect", { connectionId: Ct.connectionId }, function(Et, bt) {
            return Et ? (gt.error("Error forcing disconnect for Connection " + Ct.connectionId, Et), Et.code === 401 ? vt(new at.OpenViduError(at.OpenViduErrorName.OPENVIDU_PERMISSION_DENIED, "You don't have permissions to force a disconnection")) : vt(Et)) : (gt.info("Forcing disconnect correctly for Connection " + Ct.connectionId), It());
          });
        });
      }, yt.prototype.forceUnpublish = function(Ct) {
        var ht = this;
        return new Promise(function(It, vt) {
          if (!ht.sessionConnected())
            return vt(ht.notConnectedError());
          gt.info("Forcing unpublish for stream " + Ct.streamId), ht.openvidu.sendRequest("forceUnpublish", { streamId: Ct.streamId }, function(Et, bt) {
            return Et ? (gt.error("Error forcing unpublish for Stream " + Ct.streamId, Et), Et.code === 401 ? vt(new at.OpenViduError(at.OpenViduErrorName.OPENVIDU_PERMISSION_DENIED, "You don't have permissions to force an unpublishing")) : vt(Et)) : (gt.info("Forcing unpublish correctly for Stream " + Ct.streamId), It());
          });
        });
      }, yt.prototype.signal = function(Ct) {
        var ht = this;
        return new Promise(function(It, vt) {
          if (!ht.sessionConnected())
            return vt(ht.notConnectedError());
          var Et = {};
          if (Ct.to && Ct.to.length > 0) {
            var bt = [];
            Ct.to.forEach(function(St) {
              St.connectionId && bt.push(St.connectionId);
            }), Et.to = bt;
          } else
            Et.to = [];
          Et.data = Ct.data ? Ct.data : "";
          var Rt = Ct.type ? Ct.type : "signal";
          Rt && Rt.substring(0, 7) !== "signal:" && (Rt = "signal:" + Rt), Et.type = Rt, ht.openvidu.sendRequest("sendMessage", {
            message: JSON.stringify(Et)
          }, function(St, kt) {
            return St ? vt(St) : It();
          });
        });
      }, yt.prototype.subscribeToSpeechToText = function(Ct, ht) {
        var It = this;
        return new Promise(function(vt, Et) {
          It.openvidu.sendRequest("subscribeToSpeechToText", {
            connectionId: Ct.connection.connectionId,
            lang: ht
          }, function(bt, Rt) {
            return bt ? Et(bt) : vt();
          });
        });
      }, yt.prototype.unsubscribeFromSpeechToText = function(Ct) {
        var ht = this;
        return new Promise(function(It, vt) {
          ht.openvidu.sendRequest("unsubscribeFromSpeechToText", {
            connectionId: Ct.connection.connectionId
          }, function(Et, bt) {
            return Et ? vt(Et) : It();
          });
        });
      }, yt.prototype.on = function(Ct, ht) {
        var It, vt, Et, bt;
        return Tt.prototype.onAux.call(this, Ct, "Event '" + Ct + "' triggered by 'Session'", ht), Ct === "publisherStartSpeaking" && (this.remoteConnections.forEach(function(Rt) {
          var St;
          !((St = Rt.stream) === null || St === void 0) && St.hasAudio && Rt.stream.enableHarkSpeakingEvent();
        }), !((vt = (It = this.connection) === null || It === void 0 ? void 0 : It.stream) === null || vt === void 0) && vt.hasAudio && this.connection.stream.enableHarkSpeakingEvent()), Ct === "publisherStopSpeaking" && (this.remoteConnections.forEach(function(Rt) {
          var St;
          !((St = Rt.stream) === null || St === void 0) && St.hasAudio && Rt.stream.enableHarkStoppedSpeakingEvent();
        }), !((bt = (Et = this.connection) === null || Et === void 0 ? void 0 : Et.stream) === null || bt === void 0) && bt.hasAudio && this.connection.stream.enableHarkStoppedSpeakingEvent()), this;
      }, yt.prototype.once = function(Ct, ht) {
        var It, vt, Et, bt;
        return Tt.prototype.onceAux.call(this, Ct, "Event '" + Ct + "' triggered once by 'Session'", ht), Ct === "publisherStartSpeaking" && (this.remoteConnections.forEach(function(Rt) {
          var St;
          !((St = Rt.stream) === null || St === void 0) && St.hasAudio && Rt.stream.enableOnceHarkSpeakingEvent();
        }), !((vt = (It = this.connection) === null || It === void 0 ? void 0 : It.stream) === null || vt === void 0) && vt.hasAudio && this.connection.stream.enableOnceHarkSpeakingEvent()), Ct === "publisherStopSpeaking" && (this.remoteConnections.forEach(function(Rt) {
          var St;
          !((St = Rt.stream) === null || St === void 0) && St.hasAudio && Rt.stream.enableOnceHarkStoppedSpeakingEvent();
        }), !((bt = (Et = this.connection) === null || Et === void 0 ? void 0 : Et.stream) === null || bt === void 0) && bt.hasAudio && this.connection.stream.enableOnceHarkStoppedSpeakingEvent()), this;
      }, yt.prototype.off = function(Ct, ht) {
        var It = this, vt, Et, bt, Rt;
        return Tt.prototype.offAux.call(this, Ct, ht), Ct === "publisherStartSpeaking" && (this.anySpeechEventListenerEnabled("publisherStartSpeaking", !1) || (this.remoteConnections.forEach(function(St) {
          var kt;
          !((kt = St.stream) === null || kt === void 0) && kt.streamManager && (It.anySpeechEventListenerEnabled("publisherStartSpeaking", !1, St.stream.streamManager) || St.stream.disableHarkSpeakingEvent(!1));
        }), !((Et = (vt = this.connection) === null || vt === void 0 ? void 0 : vt.stream) === null || Et === void 0) && Et.streamManager && (this.anySpeechEventListenerEnabled("publisherStartSpeaking", !1, this.connection.stream.streamManager) || this.connection.stream.disableHarkSpeakingEvent(!1)))), Ct === "publisherStopSpeaking" && (this.anySpeechEventListenerEnabled("publisherStopSpeaking", !1) || (this.remoteConnections.forEach(function(St) {
          var kt;
          !((kt = St.stream) === null || kt === void 0) && kt.streamManager && (It.anySpeechEventListenerEnabled("publisherStopSpeaking", !1, St.stream.streamManager) || St.stream.disableHarkStoppedSpeakingEvent(!1));
        }), !((Rt = (bt = this.connection) === null || bt === void 0 ? void 0 : bt.stream) === null || Rt === void 0) && Rt.streamManager && (this.anySpeechEventListenerEnabled("publisherStopSpeaking", !1, this.connection.stream.streamManager) || this.connection.stream.disableHarkStoppedSpeakingEvent(!1)))), this;
      }, yt.prototype.onParticipantJoined = function(Ct) {
        var ht = this;
        this.getConnection(Ct.id, "").then(function(It) {
          gt.warn("Connection " + It.connectionId + " already exists in connections list");
        }).catch(function(It) {
          var vt = new Ue.Connection(ht, Ct);
          ht.remoteConnections.set(Ct.id, vt), ht.ee.emitEvent("connectionCreated", [new Ke.ConnectionEvent(!1, ht, "connectionCreated", vt, "")]);
        });
      }, yt.prototype.onParticipantLeft = function(Ct) {
        var ht = this;
        this.getRemoteConnection(Ct.connectionId, "onParticipantLeft").then(function(It) {
          if (It.stream) {
            var vt = It.stream, Et = new et.StreamEvent(!0, ht, "streamDestroyed", vt, Ct.reason);
            ht.ee.emitEvent("streamDestroyed", [Et]), Et.callDefaultBehavior(), ht.remoteStreamsCreated.delete(vt.streamId);
          }
          It.dispose(), ht.remoteConnections.delete(It.connectionId), ht.ee.emitEvent("connectionDestroyed", [
            new Ke.ConnectionEvent(!1, ht, "connectionDestroyed", It, Ct.reason)
          ]);
        }).catch(function(It) {
          gt.error(It);
        });
      }, yt.prototype.onParticipantPublished = function(Ct) {
        var ht = this, It = function(Et) {
          ht.remoteConnections.set(Et.connectionId, Et), ht.remoteStreamsCreated.get(Et.stream.streamId) || ht.ee.emitEvent("streamCreated", [new et.StreamEvent(!1, ht, "streamCreated", Et.stream, "")]), ht.remoteStreamsCreated.set(Et.stream.streamId, !0);
        }, vt;
        this.getRemoteConnection(Ct.id, "onParticipantPublished").then(function(Et) {
          vt = Et, Ct.metadata = Et.data, vt.remoteOptions = Ct, vt.initRemoteStreams(Ct.streams), It(vt);
        }).catch(function(Et) {
          vt = new Ue.Connection(ht, Ct), It(vt);
        });
      }, yt.prototype.onParticipantUnpublished = function(Ct) {
        var ht = this;
        Ct.connectionId === this.connection.connectionId ? this.stopPublisherStream(Ct.reason) : this.getRemoteConnection(Ct.connectionId, "onParticipantUnpublished").then(function(It) {
          var vt = new et.StreamEvent(!0, ht, "streamDestroyed", It.stream, Ct.reason);
          if (ht.ee.emitEvent("streamDestroyed", [vt]), vt.callDefaultBehavior(), It.stream != null) {
            var Et = It.stream.streamId;
            ht.remoteStreamsCreated.delete(Et), It.removeStream();
          }
        }).catch(function(It) {
          gt.error(It);
        });
      }, yt.prototype.onParticipantEvicted = function(Ct) {
        Ct.connectionId === this.connection.connectionId && this.sessionId && !this.connection.disposed && this.leave(!0, Ct.reason);
      }, yt.prototype.onNewMessage = function(Ct) {
        var ht = this;
        gt.info("New signal: " + JSON.stringify(Ct));
        var It = Ct.type ? Ct.type.replace(/^(signal:)/, "") : void 0;
        Ct.from ? this.getConnection(Ct.from, "Connection '" + Ct.from + "' unknown when 'onNewMessage'. Existing remote connections: " + JSON.stringify(this.remoteConnections.keys()) + ". Existing local connection: " + this.connection.connectionId).then(function(vt) {
          ht.ee.emitEvent("signal", [new nt.SignalEvent(ht, It, Ct.data, vt)]), Ct.type && Ct.type !== "signal" && ht.ee.emitEvent(Ct.type, [new nt.SignalEvent(ht, It, Ct.data, vt)]);
        }).catch(function(vt) {
          gt.error(vt);
        }) : (this.ee.emitEvent("signal", [new nt.SignalEvent(this, It, Ct.data, void 0)]), Ct.type && Ct.type !== "signal" && this.ee.emitEvent(Ct.type, [new nt.SignalEvent(this, It, Ct.data, void 0)]));
      }, yt.prototype.onStreamPropertyChanged = function(Ct) {
        var ht = this, It = function(vt) {
          var Et, bt;
          if (vt.stream && vt.stream.streamId === Ct.streamId) {
            var Rt = vt.stream, St = void 0;
            switch (Ct.property) {
              case "audioActive":
                St = Rt.audioActive, Ct.newValue = Ct.newValue === "true", Rt.audioActive = Ct.newValue;
                break;
              case "videoActive":
                St = Rt.videoActive, Ct.newValue = Ct.newValue === "true", Rt.videoActive = Ct.newValue;
                var kt = (bt = (Et = Rt == null ? void 0 : Rt.getMediaStream()) === null || Et === void 0 ? void 0 : Et.getVideoTracks()) === null || bt === void 0 ? void 0 : bt[0];
                kt && !kt.enabled && Rt.videoActive && (kt.enabled = !0);
                break;
              case "videoTrack":
                Ct.newValue = JSON.parse(Ct.newValue);
                break;
              case "audioTrack":
                Ct.newValue = JSON.parse(Ct.newValue);
                break;
              case "videoDimensions":
                St = Rt.videoDimensions, Ct.newValue = JSON.parse(JSON.parse(Ct.newValue)), Rt.videoDimensions = Ct.newValue;
                break;
              case "filter":
                St = Rt.filter, Ct.newValue = Object.keys(Ct.newValue).length > 0 ? Ct.newValue : void 0, Ct.newValue !== void 0 ? (Rt.filter = new He.Filter(Ct.newValue.type, Ct.newValue.options), Rt.filter.stream = Rt, Ct.newValue.lastExecMethod && (Rt.filter.lastExecMethod = Ct.newValue.lastExecMethod)) : delete Rt.filter, Ct.newValue = Rt.filter;
                break;
            }
            ht.ee.emitEvent("streamPropertyChanged", [
              new rt.StreamPropertyChangedEvent(ht, Rt, Ct.property, Ct.newValue, St, Ct.reason)
            ]), Rt.streamManager && Rt.streamManager.emitEvent("streamPropertyChanged", [
              new rt.StreamPropertyChangedEvent(Rt.streamManager, Rt, Ct.property, Ct.newValue, St, Ct.reason)
            ]);
          } else
            gt.error("No stream with streamId '" + Ct.streamId + "' found for connection '" + Ct.connectionId + "' on 'streamPropertyChanged' event");
        };
        Ct.connectionId === this.connection.connectionId ? It(this.connection) : this.getRemoteConnection(Ct.connectionId, "onStreamPropertyChanged").then(function(vt) {
          It(vt);
        }).catch(function(vt) {
          gt.error(vt);
        });
      }, yt.prototype.onConnectionPropertyChanged = function(Ct) {
        var ht;
        switch (Ct.property) {
          case "role":
            ht = this.connection.role.slice(), this.connection.role = Ct.newValue, this.connection.localOptions.role = Ct.newValue;
            break;
          case "record":
            ht = this.connection.record, Ct.newValue = Ct.newValue === "true", this.connection.record = Ct.newValue, this.connection.localOptions.record = Ct.newValue;
            break;
        }
        this.ee.emitEvent("connectionPropertyChanged", [
          new it.ConnectionPropertyChangedEvent(this, this.connection, Ct.property, Ct.newValue, ht)
        ]);
      }, yt.prototype.onNetworkQualityLevelChangedChanged = function(Ct) {
        var ht = this;
        Ct.connectionId === this.connection.connectionId ? this.ee.emitEvent("networkQualityLevelChanged", [
          new ot.NetworkQualityLevelChangedEvent(this, Ct.newValue, Ct.oldValue, this.connection)
        ]) : this.getConnection(Ct.connectionId, "Connection not found for connectionId " + Ct.connectionId).then(function(It) {
          ht.ee.emitEvent("networkQualityLevelChanged", [
            new ot.NetworkQualityLevelChangedEvent(ht, Ct.newValue, Ct.oldValue, It)
          ]);
        }).catch(function(It) {
          gt.error(It);
        });
      }, yt.prototype.recvIceCandidate = function(Ct) {
        var ht = {
          candidate: Ct.candidate,
          sdpMLineIndex: Ct.sdpMLineIndex,
          sdpMid: Ct.sdpMid
        }, It = new RTCIceCandidate(ht);
        this.getConnection(Ct.senderConnectionId, "Connection not found for connectionId " + Ct.senderConnectionId + " owning endpoint " + Ct.endpointName + ". Ice candidate will be ignored: " + It).then(function(vt) {
          var Et = vt.stream;
          Et.getWebRtcPeer().addIceCandidate(It).catch(function(bt) {
            gt.error("Error adding candidate for " + Et.streamId + " stream of endpoint " + Ct.endpointName + ": " + bt);
          });
        }).catch(function(vt) {
          gt.error(vt);
        });
      }, yt.prototype.onSessionClosed = function(Ct) {
        gt.info("Session closed: " + JSON.stringify(Ct));
        var ht = Ct.sessionId;
        ht !== void 0 ? this.ee.emitEvent("session-closed", [
          {
            session: ht
          }
        ]) : gt.warn("Session undefined on session closed", Ct);
      }, yt.prototype.onLostConnection = function(Ct) {
        gt.warn("Lost connection in Session " + this.sessionId), this.sessionId && this.connection && !this.connection.disposed && this.leave(!0, Ct);
      }, yt.prototype.onRecoveredConnection = function() {
        gt.info("Recovered connection in Session " + this.sessionId), this.reconnectBrokenStreams(), this.ee.emitEvent("reconnected", []);
      }, yt.prototype.onMediaError = function(Ct) {
        gt.error("Media error: " + JSON.stringify(Ct));
        var ht = Ct.error;
        ht ? this.ee.emitEvent("error-media", [{ error: ht }]) : gt.warn("Received undefined media error:", Ct);
      }, yt.prototype.onRecordingStarted = function(Ct) {
        this.ee.emitEvent("recordingStarted", [new Je.RecordingEvent(this, "recordingStarted", Ct.id, Ct.name)]);
      }, yt.prototype.onRecordingStopped = function(Ct) {
        this.ee.emitEvent("recordingStopped", [new Je.RecordingEvent(this, "recordingStopped", Ct.id, Ct.name, Ct.reason)]);
      }, yt.prototype.onBroadcastStarted = function() {
        this.ee.emitEvent("broadcastStarted", []);
      }, yt.prototype.onBroadcastStopped = function() {
        this.ee.emitEvent("broadcastStopped", []);
      }, yt.prototype.onFilterEventDispatched = function(Ct) {
        var ht = this, It = Ct.connectionId;
        this.getConnection(It, "No connection found for connectionId " + It).then(function(vt) {
          gt.info('Filter event of type "'.concat(Ct.eventType, '" dispatched'));
          var Et = vt.stream;
          if (!Et || !Et.filter)
            return gt.error('Filter event of type "'.concat(Ct.eventType, '" dispatched for stream ').concat(Et.streamId, " but there is no ").concat(Et ? "filter" : "stream", " defined"));
          var bt = Et.filter.handlers.get(Ct.eventType);
          if (!bt || typeof bt != "function") {
            var Rt = Array.from(Et.filter.handlers.keys());
            return gt.error('Filter event of type "'.concat(Ct.eventType, '" not handled or not a function! Active filter events: ').concat(Rt.join(",")));
          } else
            bt.call(ht, new $e.FilterEvent(Et.filter, Ct.eventType, Ct.data));
        });
      }, yt.prototype.onForciblyReconnectSubscriber = function(Ct) {
        var ht = this;
        return new Promise(function(It, vt) {
          ht.getRemoteConnection(Ct.connectionId, "onForciblyReconnectSubscriber").then(function(Et) {
            if (Et.stream && Et.stream.streamId === Ct.streamId) {
              var bt = Et.stream;
              if (bt.setupReconnectionEventEmitter(It, vt)) {
                if (bt.reconnectionEventEmitter.onForciblyReconnectSubscriberLastEvent != null)
                  return bt.reconnectionEventEmitter.onForciblyReconnectSubscriberLastEvent = Ct, vt("Ongoing forced subscriber reconnection");
                bt.reconnectionEventEmitter.onForciblyReconnectSubscriberLastEvent = Ct;
                var Rt = function() {
                  var kt = bt.reconnectionEventEmitter.onForciblyReconnectSubscriberLastEvent;
                  delete bt.reconnectionEventEmitter.onForciblyReconnectSubscriberLastEvent, ht.onForciblyReconnectSubscriber(kt);
                };
                bt.reconnectionEventEmitter.once("success", function() {
                  Rt();
                }), bt.reconnectionEventEmitter.once("error", function() {
                  Rt();
                });
                return;
              }
              bt.completeWebRtcPeerReceive(!0, !0, Ct.sdpOffer).then(function() {
                return bt.finalResolveForSubscription(!0, It);
              }).catch(function(kt) {
                return bt.finalRejectForSubscription(!0, "Error while forcibly reconnecting remote stream ".concat(Ct.streamId, ": ").concat(kt.toString()), vt);
              });
            } else {
              var St = "No stream with streamId '" + Ct.streamId + "' found for connection '" + Ct.connectionId + "' on 'streamPropertyChanged' event";
              return gt.error(St), vt(St);
            }
          }).catch(function(Et) {
            return gt.error(Et), vt(Et);
          });
        });
      }, yt.prototype.reconnectBrokenStreams = function() {
        gt.info("Re-establishing media connections...");
        var Ct = !1;
        this.connection.stream && this.connection.stream.streamIceConnectionStateBroken() && (gt.warn("Re-establishing Publisher " + this.connection.stream.streamId), this.connection.stream.initWebRtcPeerSend(!0), Ct = !0), this.remoteConnections.forEach(function(ht) {
          ht.stream && ht.stream.streamIceConnectionStateBroken() && (gt.warn("Re-establishing Subscriber " + ht.stream.streamId), ht.stream.initWebRtcPeerReceive(!0), Ct = !0);
        }), Ct || gt.info("There were no media streams in need of a reconnection");
      }, yt.prototype.onSpeechToTextMessage = function(Ct) {
        return ue(this, void 0, void 0, function() {
          var ht, It;
          return Qe(this, function(vt) {
            switch (vt.label) {
              case 0:
                return [4, this.getConnection(Ct.connectionId, "No connection found for connectionId " + Ct.connectionId)];
              case 1:
                return ht = vt.sent(), It = new tt.SpeechToTextEvent(this, ht, Ct.text, Ct.reason.toLowerCase(), Ct.raw, Ct.lang), this.ee.emitEvent("speechToTextMessage", [It]), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, yt.prototype.onSpeechToTextDisconnected = function(Ct) {
        return ue(this, void 0, void 0, function() {
          return Qe(this, function(ht) {
            return this.emitEvent("exception", [new pt.ExceptionEvent(this, pt.ExceptionEventName.SPEECH_TO_TEXT_DISCONNECTED, this, Ct.message)]), [
              2
              /*return*/
            ];
          });
        });
      }, yt.prototype.emitEvent = function(Ct, ht) {
        this.ee.emitEvent(Ct, ht);
      }, yt.prototype.leave = function(Ct, ht) {
        var It = this;
        if (Ct = !!Ct, gt.info("Leaving Session (forced=" + Ct + ")"), this.stopVideoDataIntervals(), this.connection) {
          if (!this.connection.disposed && !Ct ? this.openvidu.sendRequest("leaveRoom", function(Et, bt) {
            Et && gt.error("leaveRoom error: ".concat(JSON.stringify(Et))), It.openvidu.closeWs();
          }) : this.openvidu.closeWs(), this.stopPublisherStream(ht), !this.connection.disposed) {
            var vt = new Ze.SessionDisconnectedEvent(this, ht);
            this.ee.emitEvent("sessionDisconnected", [vt]), vt.callDefaultBehavior();
          }
        } else
          gt.warn("You were not connected to the session " + this.sessionId);
        gt.flush();
      }, yt.prototype.initializeParams = function(Ct) {
        var ht = {
          token: Ct || "",
          session: this.sessionId,
          platform: wt.getDescription() ? wt.getDescription() : "unknown",
          sdkVersion: this.openvidu.libraryVersion,
          metadata: this.options.metadata ? this.options.metadata : "",
          secret: this.openvidu.getSecret(),
          recorder: this.openvidu.getRecorder(),
          stt: this.openvidu.getStt()
        };
        return ht;
      }, yt.prototype.sendVideoData = function(Ct, ht, It, vt) {
        var Et = this, bt, Rt;
        if (ht === void 0 && (ht = 1), It === void 0 && (It = !1), vt === void 0 && (vt = 1), wt.isChromeBrowser() || wt.isChromeMobileBrowser() || wt.isOperaBrowser() || wt.isOperaMobileBrowser() || wt.isEdgeBrowser() || wt.isEdgeMobileBrowser() || wt.isElectron() || wt.isSafariBrowser() && !wt.isIonicIos() || wt.isAndroidBrowser() || wt.isSamsungBrowser() || wt.isIonicAndroid() || wt.isIOSWithSafari()) {
          var St = function() {
            return ue(Et, void 0, void 0, function() {
              var jt, Pt, Qt;
              return Qe(this, function(qt) {
                switch (qt.label) {
                  case 0:
                    return jt = Ct.stream.getRTCPeerConnection(), jt.connectionState !== "connected" ? [3, 2] : [4, jt.getStats()];
                  case 1:
                    Pt = qt.sent(), Qt = [], Pt.forEach(function(_t) {
                      "frameWidth" in _t && "frameHeight" in _t && Qt.length === 0 && Qt.push(_t);
                    }), Qt.length > 0 && this.openvidu.sendRequest("videoData", {
                      height: Qt[0].frameHeight,
                      width: Qt[0].frameWidth,
                      videoActive: Ct.stream.videoActive != null ? Ct.stream.videoActive : !1,
                      audioActive: Ct.stream.audioActive != null ? Ct.stream.audioActive : !1
                    }, function(_t, Yt) {
                      _t && gt.error("Error sending 'videoData' event", _t);
                    }), qt.label = 2;
                  case 2:
                    return [
                      2
                      /*return*/
                    ];
                }
              });
            });
          };
          if (It) {
            var kt = 1;
            this.videoDataInterval = setInterval(function() {
              kt < vt ? (kt++, St()) : clearInterval(Et.videoDataInterval);
            }, ht * 1e3);
          } else
            this.videoDataTimeout = setTimeout(St, ht * 1e3);
        } else wt.isFirefoxBrowser() || wt.isFirefoxMobileBrowser() || wt.isIonicIos() || wt.isReactNative() ? this.openvidu.sendRequest("videoData", {
          height: ((bt = Ct.stream.videoDimensions) === null || bt === void 0 ? void 0 : bt.height) || 0,
          width: ((Rt = Ct.stream.videoDimensions) === null || Rt === void 0 ? void 0 : Rt.width) || 0,
          videoActive: Ct.stream.videoActive != null ? Ct.stream.videoActive : !1,
          audioActive: Ct.stream.audioActive != null ? Ct.stream.audioActive : !1
        }, function(jt, Pt) {
          jt && gt.error("Error sending 'videoData' event", jt);
        }) : gt.error("Browser " + wt.getName() + " (version " + wt.getVersion() + ") for " + wt.getFamily() + " is not supported in OpenVidu for Network Quality");
      }, yt.prototype.sessionConnected = function() {
        return this.connection != null;
      }, yt.prototype.notConnectedError = function() {
        return new at.OpenViduError(at.OpenViduErrorName.OPENVIDU_NOT_CONNECTED, "There is no connection to the session. Method 'Session.connect' must be successfully completed first");
      }, yt.prototype.anySpeechEventListenerEnabled = function(Ct, ht, It) {
        var vt = this.ee.getListeners(Ct);
        ht && (vt = vt.filter(function(St) {
          return St.once;
        }));
        var Et = vt.length;
        if (Et > 0)
          return !0;
        var bt = 0;
        if (It) {
          var Rt = It.ee.getListeners(Ct);
          ht && (Rt = Rt.filter(function(St) {
            return St.once;
          })), bt = Rt.length;
        }
        return bt > 0;
      }, yt.prototype.getTokenParams = function(Ct) {
        var ht = Ct.match(/^(wss?)\:\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
        if (ht) {
          var It = {
            protocol: ht[1],
            host: ht[2],
            hostname: ht[3],
            port: ht[4],
            pathname: ht[5],
            search: ht[6],
            hash: ht[7]
          }, vt = Ct.split("?"), Et = decodeURI(vt[1]).split("&").map(function(bt) {
            return bt.split("=");
          }).reduce(function(bt, Rt) {
            var St = Rt[0], kt = Rt[1];
            return bt[St] = kt, bt;
          }, {});
          return {
            sessionId: Et.sessionId,
            secret: Et.secret,
            recorder: Et.recorder,
            stt: Et.stt,
            webrtcStatsInterval: Et.webrtcStatsInterval,
            sendBrowserLogs: Et.sendBrowserLogs,
            edition: Et.edition,
            wsUri: It.protocol + "://" + It.host + "/openvidu",
            httpUri: "https://" + It.host
          };
        } else
          throw new Error('Token not valid: "'.concat(Ct, '"'));
      }, yt.prototype.connectAux = function(Ct) {
        var ht = this;
        return new Promise(function(It, vt) {
          ht.openvidu.startWs(function(Et) {
            if (Et)
              return vt(Et);
            var bt = ht.initializeParams(Ct);
            ht.openvidu.sendRequest("joinRoom", bt, function(Rt, St) {
              if (Rt)
                return vt(Rt);
              ht.processJoinRoomResponse(St, Ct), ht.connection = new Ue.Connection(ht, St);
              var kt = {
                connections: new Array(),
                streams: new Array()
              }, jt = St.value;
              return jt.forEach(function(Pt) {
                var Qt = new Ue.Connection(ht, Pt);
                ht.remoteConnections.set(Qt.connectionId, Qt), kt.connections.push(Qt), Qt.stream && (ht.remoteStreamsCreated.set(Qt.stream.streamId, !0), kt.streams.push(Qt.stream));
              }), ht.ee.emitEvent("connectionCreated", [
                new Ke.ConnectionEvent(!1, ht, "connectionCreated", ht.connection, "")
              ]), kt.connections.forEach(function(Pt) {
                ht.ee.emitEvent("connectionCreated", [
                  new Ke.ConnectionEvent(!1, ht, "connectionCreated", Pt, "")
                ]);
              }), kt.streams.forEach(function(Pt) {
                ht.ee.emitEvent("streamCreated", [new et.StreamEvent(!1, ht, "streamCreated", Pt, "")]);
              }), St.recordingId && St.recordingName && ht.ee.emitEvent("recordingStarted", [
                new Je.RecordingEvent(ht, "recordingStarted", St.recordingId, St.recordingName)
              ]), It();
            });
          });
        });
      }, yt.prototype.stopPublisherStream = function(Ct) {
        this.connection.stream && (this.connection.stream.disposeWebRtcPeer(), this.connection.stream.isLocalStreamPublished && this.connection.stream.ee.emitEvent("local-stream-destroyed", [Ct]));
      }, yt.prototype.stopVideoDataIntervals = function() {
        clearInterval(this.videoDataInterval), clearTimeout(this.videoDataTimeout);
      }, yt.prototype.stringClientMetadata = function(Ct) {
        return typeof Ct != "string" ? JSON.stringify(Ct) : Ct;
      }, yt.prototype.getConnection = function(Ct, ht) {
        var It = this;
        return new Promise(function(vt, Et) {
          var bt = It.remoteConnections.get(Ct);
          return bt ? vt(bt) : It.connection.connectionId === Ct ? vt(It.connection) : Et(new at.OpenViduError(at.OpenViduErrorName.GENERIC_ERROR, ht));
        });
      }, yt.prototype.getRemoteConnection = function(Ct, ht) {
        var It = this;
        return new Promise(function(vt, Et) {
          var bt = It.remoteConnections.get(Ct);
          if (bt)
            return vt(bt);
          var Rt = "Remote connection " + Ct + " unknown when '" + ht + "'. Existing remote connections: " + JSON.stringify(It.remoteConnections.keys());
          return Et(new at.OpenViduError(at.OpenViduErrorName.GENERIC_ERROR, Rt));
        });
      }, yt.prototype.processToken = function(Ct) {
        var ht = this.getTokenParams(Ct);
        this.sessionId = ht.sessionId, ht.secret && (this.openvidu.secret = ht.secret), ht.recorder && (this.openvidu.recorder = !0), ht.stt && (this.openvidu.stt = !0), ht.webrtcStatsInterval && (this.openvidu.webrtcStatsInterval = ht.webrtcStatsInterval), ht.sendBrowserLogs && (this.openvidu.sendBrowserLogs = ht.sendBrowserLogs), this.openvidu.isAtLeastPro = ht.edition === "pro" || ht.edition === "enterprise", this.openvidu.isEnterprise = ht.edition === "enterprise", this.openvidu.wsUri = ht.wsUri, this.openvidu.httpUri = ht.httpUri;
      }, yt.prototype.processJoinRoomResponse = function(Ct, ht) {
        if (this.sessionId = Ct.session, Ct.customIceServers != null && Ct.customIceServers.length > 0) {
          this.openvidu.iceServers = [];
          for (var It = 0, vt = Ct.customIceServers; It < vt.length; It++) {
            var Et = vt[It], bt = {
              urls: [Et.url]
            };
            gt.log("STUN/TURN server IP: " + Et.url), Et.username != null && Et.credential != null && (bt.username = Et.username, bt.credential = Et.credential, gt.log("TURN credentials [" + Et.username + ":" + Et.credential + "]")), this.openvidu.iceServers.push(bt);
          }
        }
        this.openvidu.role = Ct.role, this.openvidu.finalUserId = Ct.finalUserId, this.openvidu.mediaServer = Ct.mediaServer, this.openvidu.videoSimulcast = Ct.videoSimulcast, this.capabilities = {
          subscribe: !0,
          publish: this.openvidu.role !== "SUBSCRIBER",
          forceUnpublish: this.openvidu.role === "MODERATOR",
          forceDisconnect: this.openvidu.role === "MODERATOR"
        }, gt.info("openvidu-server version: " + Ct.version), Ct.life != null && (this.openvidu.life = Ct.life);
        var Rt = At(Ct.version) - At(this.openvidu.libraryVersion);
        dt(Ct.version) !== dt(this.openvidu.libraryVersion) || !(Rt == 0 || Rt == 1) ? gt.error("openvidu-browser (".concat(this.openvidu.libraryVersion, ") and openvidu-server (").concat(Ct.version, ") versions are incompatible. ") + "Errors are likely to occur. openvidu-browser SDK is only compatible with the same version or the immediately following minor version of an OpenVidu deployment") : Rt == 1 && gt.warn("openvidu-browser version ".concat(this.openvidu.libraryVersion, " does not match openvidu-server version ").concat(Ct.version, ". ") + "These versions are still compatible with each other, but openvidu-browser version must be updated as soon as possible to ".concat(dt(Ct.version), ".").concat(At(Ct.version), ".x. ") + "This client using openvidu-browser ".concat(this.openvidu.libraryVersion, " will become incompatible with the next release of openvidu-server")), ut.OpenViduLogger.configureJSNLog(this.openvidu, ht), this.token = ht;
      }, yt;
    }(Xe.EventDispatcher)
  );
  return Session.Session = Bt, Session;
}
var hasRequiredPublisher;
function requirePublisher() {
  if (hasRequiredPublisher) return Publisher;
  hasRequiredPublisher = 1;
  var me = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
    var it = function(ot, at) {
      return it = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(st, ut) {
        st.__proto__ = ut;
      } || function(st, ut) {
        for (var lt in ut) Object.prototype.hasOwnProperty.call(ut, lt) && (st[lt] = ut[lt]);
      }, it(ot, at);
    };
    return function(ot, at) {
      if (typeof at != "function" && at !== null)
        throw new TypeError("Class extends value " + String(at) + " is not a constructor or null");
      it(ot, at);
      function st() {
        this.constructor = ot;
      }
      ot.prototype = at === null ? Object.create(at) : (st.prototype = at.prototype, new st());
    };
  }(), ue = commonjsGlobal && commonjsGlobal.__awaiter || function(it, ot, at, st) {
    function ut(lt) {
      return lt instanceof at ? lt : new at(function(dt) {
        dt(lt);
      });
    }
    return new (at || (at = Promise))(function(lt, dt) {
      function At(wt) {
        try {
          gt(st.next(wt));
        } catch (Bt) {
          dt(Bt);
        }
      }
      function pt(wt) {
        try {
          gt(st.throw(wt));
        } catch (Bt) {
          dt(Bt);
        }
      }
      function gt(wt) {
        wt.done ? lt(wt.value) : ut(wt.value).then(At, pt);
      }
      gt((st = st.apply(it, ot || [])).next());
    });
  }, Qe = commonjsGlobal && commonjsGlobal.__generator || function(it, ot) {
    var at = { label: 0, sent: function() {
      if (lt[0] & 1) throw lt[1];
      return lt[1];
    }, trys: [], ops: [] }, st, ut, lt, dt;
    return dt = { next: At(0), throw: At(1), return: At(2) }, typeof Symbol == "function" && (dt[Symbol.iterator] = function() {
      return this;
    }), dt;
    function At(gt) {
      return function(wt) {
        return pt([gt, wt]);
      };
    }
    function pt(gt) {
      if (st) throw new TypeError("Generator is already executing.");
      for (; dt && (dt = 0, gt[0] && (at = 0)), at; ) try {
        if (st = 1, ut && (lt = gt[0] & 2 ? ut.return : gt[0] ? ut.throw || ((lt = ut.return) && lt.call(ut), 0) : ut.next) && !(lt = lt.call(ut, gt[1])).done) return lt;
        switch (ut = 0, lt && (gt = [gt[0] & 2, lt.value]), gt[0]) {
          case 0:
          case 1:
            lt = gt;
            break;
          case 4:
            return at.label++, { value: gt[1], done: !1 };
          case 5:
            at.label++, ut = gt[1], gt = [0];
            continue;
          case 7:
            gt = at.ops.pop(), at.trys.pop();
            continue;
          default:
            if (lt = at.trys, !(lt = lt.length > 0 && lt[lt.length - 1]) && (gt[0] === 6 || gt[0] === 2)) {
              at = 0;
              continue;
            }
            if (gt[0] === 3 && (!lt || gt[1] > lt[0] && gt[1] < lt[3])) {
              at.label = gt[1];
              break;
            }
            if (gt[0] === 6 && at.label < lt[1]) {
              at.label = lt[1], lt = gt;
              break;
            }
            if (lt && at.label < lt[2]) {
              at.label = lt[2], at.ops.push(gt);
              break;
            }
            lt[2] && at.ops.pop(), at.trys.pop();
            continue;
        }
        gt = ot.call(it, at);
      } catch (wt) {
        gt = [6, wt], ut = 0;
      } finally {
        st = lt = 0;
      }
      if (gt[0] & 5) throw gt[1];
      return { value: gt[0] ? gt[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(Publisher, "__esModule", { value: !0 }), Publisher.Publisher = void 0;
  var Ue = requireSession(), He = Stream$2, Ge = StreamManager$1, Xe = requireStreamEvent(), Ke = StreamPropertyChangedEvent$1, $e = OpenViduError, Je = OpenViduLogger$1, Ze = Platform, nt = TypeOfVideo, tt = Je.OpenViduLogger.getInstance(), et, rt = (
    /** @class */
    function(it) {
      me(ot, it);
      function ot(at, st, ut) {
        var lt = it.call(this, new He.Stream(ut.session ? ut.session : new Ue.Session(ut), {
          publisherProperties: st,
          mediaConstraints: {}
        }), at) || this;
        return lt.accessAllowed = !1, lt.isSubscribedToRemote = !1, lt.accessDenied = !1, et = Ze.PlatformUtils.getInstance(), lt.properties = st, lt.openvidu = ut, lt.stream.ee.on("local-stream-destroyed", function(dt) {
          lt.stream.isLocalStreamPublished = !1;
          var At = new Xe.StreamEvent(!0, lt, "streamDestroyed", lt.stream, dt);
          lt.emitEvent("streamDestroyed", [At]), At.callDefaultBehavior();
        }), lt;
      }
      return ot.prototype.publishAudio = function(at) {
        var st = this;
        if (this.stream.audioActive !== at) {
          var ut = this.stream.displayMyRemote() ? this.stream.localMediaStreamWhenSubscribedToRemote : this.stream.getMediaStream();
          ut.getAudioTracks().forEach(function(lt) {
            lt.enabled = at;
          }), this.session && this.stream.streamId && this.session.openvidu.sendRequest("streamPropertyChanged", {
            streamId: this.stream.streamId,
            property: "audioActive",
            newValue: at,
            reason: "publishAudio"
          }, function(lt, dt) {
            lt ? tt.error("Error sending 'streamPropertyChanged' event", lt) : (st.session.emitEvent("streamPropertyChanged", [
              new Ke.StreamPropertyChangedEvent(st.session, st.stream, "audioActive", at, !at, "publishAudio")
            ]), st.emitEvent("streamPropertyChanged", [
              new Ke.StreamPropertyChangedEvent(st, st.stream, "audioActive", at, !at, "publishAudio")
            ]), st.session.sendVideoData(st.stream.streamManager));
          }), this.stream.audioActive = at, tt.info("'Publisher' has " + (at ? "published" : "unpublished") + " its audio stream");
        }
      }, ot.prototype.publishVideo = function(at, st) {
        var ut = this;
        return new Promise(function(lt, dt) {
          return ue(ut, void 0, void 0, function() {
            var At, pt, gt, wt, Bt, Tt, yt = this;
            return Qe(this, function(Ct) {
              switch (Ct.label) {
                case 0:
                  return this.stream.videoActive === at ? [3, 9] : (At = this.stream.displayMyRemote() ? this.stream.localMediaStreamWhenSubscribedToRemote : this.stream.getMediaStream(), pt = !1, At.getVideoTracks().forEach(function(ht) {
                    ht.enabled = at, !at && st === !0 ? ht.stop() : at && ht.readyState === "ended" && (pt = !0);
                  }), !at && st === !0 && this.stream.filter && this.stream.filter.type.startsWith("VB:") ? (this.stream.lastVBFilter = this.stream.filter, [4, this.stream.removeFilterAux(!0)]) : [3, 2]);
                case 1:
                  Ct.sent(), Ct.label = 2;
                case 2:
                  return pt ? (gt = At.getVideoTracks()[0], At.removeTrack(gt), wt = function(ht) {
                    return ue(yt, void 0, void 0, function() {
                      var It = this;
                      return Qe(this, function(vt) {
                        switch (vt.label) {
                          case 0:
                            return At.addTrack(ht), this.stream.isLocalStreamPublished ? [4, this.replaceTrackInRtcRtpSender(ht)] : [3, 2];
                          case 1:
                            vt.sent(), vt.label = 2;
                          case 2:
                            return this.stream.lastVBFilter && setTimeout(function() {
                              return ue(It, void 0, void 0, function() {
                                var Et, bt;
                                return Qe(this, function(Rt) {
                                  switch (Rt.label) {
                                    case 0:
                                      return Et = this.stream.lastVBFilter.options, bt = this.stream.lastVBFilter.lastExecMethod, bt && bt.method === "update" && (Et = Object.assign({}, Et, bt.params)), [4, this.stream.applyFilter(this.stream.lastVBFilter.type, Et)];
                                    case 1:
                                      return Rt.sent(), delete this.stream.lastVBFilter, [
                                        2
                                        /*return*/
                                      ];
                                  }
                                });
                              });
                            }, 1), [
                              2
                              /*return*/
                            ];
                        }
                      });
                    });
                  }, st && st instanceof MediaStreamTrack ? [4, wt(st)] : [3, 4]) : [3, 8];
                case 3:
                  return Ct.sent(), [3, 8];
                case 4:
                  return Ct.trys.push([4, 7, , 8]), [4, navigator.mediaDevices.getUserMedia({
                    audio: !1,
                    video: this.stream.lastVideoTrackConstraints
                  })];
                case 5:
                  return Bt = Ct.sent(), [4, wt(Bt.getVideoTracks()[0])];
                case 6:
                  return Ct.sent(), [3, 8];
                case 7:
                  return Tt = Ct.sent(), [2, dt(Tt)];
                case 8:
                  return this.session && this.stream.streamId && this.session.openvidu.sendRequest("streamPropertyChanged", {
                    streamId: this.stream.streamId,
                    property: "videoActive",
                    newValue: at,
                    reason: "publishVideo"
                  }, function(ht, It) {
                    ht ? tt.error("Error sending 'streamPropertyChanged' event", ht) : (yt.session.emitEvent("streamPropertyChanged", [
                      new Ke.StreamPropertyChangedEvent(yt.session, yt.stream, "videoActive", at, !at, "publishVideo")
                    ]), yt.emitEvent("streamPropertyChanged", [
                      new Ke.StreamPropertyChangedEvent(yt, yt.stream, "videoActive", at, !at, "publishVideo")
                    ]), yt.session.sendVideoData(yt.stream.streamManager));
                  }), this.stream.videoActive = at, tt.info("'Publisher' has " + (at ? "published" : "unpublished") + " its video stream"), [2, lt()];
                case 9:
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        });
      }, ot.prototype.subscribeToRemote = function(at) {
        at = at !== void 0 ? at : !0, this.isSubscribedToRemote = at, this.stream.subscribeToMyRemote(at);
      }, ot.prototype.on = function(at, st) {
        var ut = this;
        return it.prototype.on.call(this, at, st), at === "streamCreated" && (this.stream && this.stream.isLocalStreamPublished ? this.emitEvent("streamCreated", [new Xe.StreamEvent(!1, this, "streamCreated", this.stream, "")]) : this.stream.ee.on("stream-created-by-publisher", function() {
          ut.emitEvent("streamCreated", [new Xe.StreamEvent(!1, ut, "streamCreated", ut.stream, "")]);
        })), at === "accessAllowed" && this.accessAllowed && this.emitEvent("accessAllowed", []), at === "accessDenied" && this.accessDenied && this.emitEvent("accessDenied", []), this;
      }, ot.prototype.once = function(at, st) {
        var ut = this;
        return it.prototype.once.call(this, at, st), at === "streamCreated" && (this.stream && this.stream.isLocalStreamPublished ? this.emitEvent("streamCreated", [new Xe.StreamEvent(!1, this, "streamCreated", this.stream, "")]) : this.stream.ee.once("stream-created-by-publisher", function() {
          ut.emitEvent("streamCreated", [new Xe.StreamEvent(!1, ut, "streamCreated", ut.stream, "")]);
        })), at === "accessAllowed" && this.accessAllowed && this.emitEvent("accessAllowed", []), at === "accessDenied" && this.accessDenied && this.emitEvent("accessDenied", []), this;
      }, ot.prototype.off = function(at, st) {
        return it.prototype.off.call(this, at, st), this;
      }, ot.prototype.replaceTrack = function(at) {
        return ue(this, void 0, void 0, function() {
          return Qe(this, function(st) {
            return [2, this.replaceTrackAux(at, !0)];
          });
        });
      }, ot.prototype.initialize = function() {
        var at = this;
        return new Promise(function(st, ut) {
          return ue(at, void 0, void 0, function() {
            var lt, dt, At, pt, gt, wt, Bt, Tt, yt, Ct, ht, It, It, vt, Et, bt = this, Rt, St;
            return Qe(this, function(kt) {
              switch (kt.label) {
                case 0:
                  lt = {}, dt = {}, At = 2e3, gt = function(jt) {
                    return bt.accessDenied = !0, bt.accessAllowed = !1, tt.error("Publisher initialization failed. ".concat(jt.name, ": ").concat(jt.message)), ut(jt);
                  }, wt = function(jt) {
                    var Pt, Qt;
                    if (bt.accessAllowed = !0, bt.accessDenied = !1, typeof MediaStreamTrack < "u" && bt.properties.audioSource instanceof MediaStreamTrack && (jt.removeTrack(jt.getAudioTracks()[0]), jt.addTrack(bt.properties.audioSource)), typeof MediaStreamTrack < "u" && bt.properties.videoSource instanceof MediaStreamTrack && (jt.removeTrack(jt.getVideoTracks()[0]), jt.addTrack(bt.properties.videoSource)), jt.getAudioTracks()[0]) {
                      var qt = bt.stream.audioActive !== void 0 && bt.stream.audioActive !== null ? bt.stream.audioActive : !!bt.stream.outboundStreamOpts.publisherProperties.publishAudio;
                      jt.getAudioTracks()[0].enabled = qt;
                    }
                    if (jt.getVideoTracks()[0]) {
                      var qt = bt.stream.videoActive !== void 0 && bt.stream.videoActive !== null ? bt.stream.videoActive : !!bt.stream.outboundStreamOpts.publisherProperties.publishVideo;
                      jt.getVideoTracks()[0].enabled = qt;
                    }
                    for (var _t = 0, Yt = jt.getAudioTracks(); _t < Yt.length; _t++) {
                      var Xt = Yt[_t];
                      !((Pt = Xt.contentHint) === null || Pt === void 0) && Pt.length || (Xt.contentHint = "", tt.info("Audio track Content Hint set: '".concat(Xt.contentHint, "'")));
                    }
                    for (var Ut = 0, Lt = jt.getVideoTracks(); Ut < Lt.length; Ut++) {
                      var Xt = Lt[Ut];
                      if (!(!((Qt = Xt.contentHint) === null || Qt === void 0) && Qt.length)) {
                        switch (bt.stream.typeOfVideo) {
                          case nt.TypeOfVideo.SCREEN:
                            Xt.contentHint = "detail";
                            break;
                          case nt.TypeOfVideo.CUSTOM:
                            tt.warn("CUSTOM type video track was provided without Content Hint!"), Xt.contentHint = "motion";
                            break;
                          case nt.TypeOfVideo.CAMERA:
                          case nt.TypeOfVideo.IPCAM:
                          default:
                            Xt.contentHint = "motion";
                            break;
                        }
                        tt.info("Video track Content Hint set: '".concat(Xt.contentHint, "'"));
                      }
                    }
                    return bt.initializeVideoReference(jt), bt.stream.displayMyRemote() || bt.stream.updateMediaStreamInVideos(), delete bt.firstVideoElement, bt.stream.isSendVideo() ? bt.getVideoDimensions().then(function(Ot) {
                      bt.stream.videoDimensions = {
                        width: Ot.width,
                        height: Ot.height
                      }, bt.stream.isSendScreen() && (bt.stream.isSendAudio() && jt.getAudioTracks().length === 0 && (bt.stream.audioActive = !1, bt.stream.hasAudio = !1, bt.stream.outboundStreamOpts.publisherProperties.publishAudio = !1, bt.stream.outboundStreamOpts.publisherProperties.audioSource = !1), bt.screenShareResizeInterval = setInterval(function() {
                        var ft = jt.getVideoTracks()[0].getSettings(), Dt = ft.width, Mt = ft.height, Ft = Dt != null && Dt !== bt.stream.videoDimensions.width, Gt = Mt != null && Mt !== bt.stream.videoDimensions.height;
                        bt.stream.isLocalStreamPublished && (Ft || Gt) && bt.openvidu.sendVideoDimensionsChangedEvent(bt, "screenResized", bt.stream.videoDimensions.width, bt.stream.videoDimensions.height, Dt || 0, Mt || 0);
                      }, 650)), bt.stream.isLocalStreamReadyToPublish = !0, bt.stream.ee.emitEvent("stream-ready-to-publish", []);
                    }) : (bt.stream.isLocalStreamReadyToPublish = !0, bt.stream.ee.emitEvent("stream-ready-to-publish", [])), st();
                  }, Bt = function(jt, Pt) {
                    return ue(bt, void 0, void 0, function() {
                      var Qt, qt;
                      return Qe(this, function(_t) {
                        switch (_t.label) {
                          case 0:
                            if (this.clearPermissionDialogTimer(pt, At), !(this.stream.isSendScreen() && this.properties.audioSource !== "screen" && this.stream.isSendAudio())) return [3, 5];
                            dt.audio = Pt, dt.video = !1, pt = Date.now(), this.setPermissionDialogTimer(At), _t.label = 1;
                          case 1:
                            return _t.trys.push([1, 3, , 4]), [4, navigator.mediaDevices.getUserMedia(dt)];
                          case 2:
                            return Qt = _t.sent(), this.clearPermissionDialogTimer(pt, At), jt.addTrack(Qt.getAudioTracks()[0]), wt(jt), [3, 4];
                          case 3:
                            return qt = _t.sent(), this.clearPermissionDialogTimer(pt, At), jt.getAudioTracks().forEach(function(Yt) {
                              Yt.stop();
                            }), jt.getVideoTracks().forEach(function(Yt) {
                              Yt.stop();
                            }), gt(this.openvidu.generateAudioDeviceError(qt, lt)), [
                              2
                              /*return*/
                            ];
                          case 4:
                            return [3, 6];
                          case 5:
                            wt(jt), _t.label = 6;
                          case 6:
                            return [
                              2
                              /*return*/
                            ];
                        }
                      });
                    });
                  }, Tt = function(jt) {
                    return ue(bt, void 0, void 0, function() {
                      var Pt, Qt, qt, Yt, _t, Yt, Xt;
                      return Qe(this, function(Ut) {
                        switch (Ut.label) {
                          case 0:
                            switch (tt.error("getMediaError: ".concat(jt.toString())), this.clearPermissionDialogTimer(pt, At), jt.name === "Error" && (jt.name = jt.constructor.name), qt = jt.name.toLowerCase(), qt) {
                              case "notfounderror":
                                return [3, 1];
                              case "notallowederror":
                                return [3, 5];
                              case "overconstrainederror":
                                return [3, 6];
                              case "aborterror":
                                return [3, 10];
                              case "notreadableerror":
                                return [3, 10];
                            }
                            return [3, 11];
                          case 1:
                            return Ut.trys.push([1, 3, , 4]), [4, navigator.mediaDevices.getUserMedia({
                              audio: !1,
                              video: lt.video
                            })];
                          case 2:
                            return Yt = Ut.sent(), Yt.getVideoTracks().forEach(function(Lt) {
                              Lt.stop();
                            }), Pt = $e.OpenViduErrorName.INPUT_AUDIO_DEVICE_NOT_FOUND, Qt = jt.toString(), gt(new $e.OpenViduError(Pt, Qt)), [3, 4];
                          case 3:
                            return _t = Ut.sent(), Pt = $e.OpenViduErrorName.INPUT_VIDEO_DEVICE_NOT_FOUND, Qt = _t.toString(), gt(new $e.OpenViduError(Pt, Qt)), [3, 4];
                          case 4:
                            return [3, 12];
                          case 5:
                            return Pt = this.stream.isSendScreen() ? $e.OpenViduErrorName.SCREEN_CAPTURE_DENIED : $e.OpenViduErrorName.DEVICE_ACCESS_DENIED, Qt = jt.toString(), gt(new $e.OpenViduError(Pt, Qt)), [3, 12];
                          case 6:
                            return Ut.trys.push([6, 8, , 9]), [4, navigator.mediaDevices.getUserMedia({
                              audio: !1,
                              video: lt.video
                            })];
                          case 7:
                            return Yt = Ut.sent(), Yt.getVideoTracks().forEach(function(Lt) {
                              Lt.stop();
                            }), jt.constraint.toLowerCase() === "deviceid" ? (Pt = $e.OpenViduErrorName.INPUT_AUDIO_DEVICE_NOT_FOUND, Qt = "Audio input device with deviceId '" + lt.audio.deviceId.exact + "' not found") : (Pt = $e.OpenViduErrorName.PUBLISHER_PROPERTIES_ERROR, Qt = "Audio input device doesn't support the value passed for constraint '" + jt.constraint + "'"), gt(new $e.OpenViduError(Pt, Qt)), [3, 9];
                          case 8:
                            return Xt = Ut.sent(), Xt.constraint.toLowerCase() === "deviceid" ? (Pt = $e.OpenViduErrorName.INPUT_VIDEO_DEVICE_NOT_FOUND, Qt = "Video input device with deviceId '" + lt.video.deviceId.exact + "' not found") : (Pt = $e.OpenViduErrorName.PUBLISHER_PROPERTIES_ERROR, Qt = "Video input device doesn't support the value passed for constraint '" + Xt.constraint + "'"), gt(new $e.OpenViduError(Pt, Qt)), [3, 9];
                          case 9:
                            return [3, 12];
                          case 10:
                            return Pt = $e.OpenViduErrorName.DEVICE_ALREADY_IN_USE, Qt = jt.toString(), gt(new $e.OpenViduError(Pt, Qt)), [3, 12];
                          case 11:
                            return Pt = $e.OpenViduErrorName.GENERIC_ERROR, Qt = jt.toString(), gt(new $e.OpenViduError(Pt, Qt)), [3, 12];
                          case 12:
                            return [
                              2
                              /*return*/
                            ];
                        }
                      });
                    });
                  }, kt.label = 1;
                case 1:
                  return kt.trys.push([1, 14, , 15]), [4, this.openvidu.generateMediaConstraints(this.properties)];
                case 2:
                  return yt = kt.sent(), yt.videoTrack && yt.audioTrack || yt.audioTrack && ((Rt = yt.constraints) === null || Rt === void 0 ? void 0 : Rt.video) === !1 || yt.videoTrack && ((St = yt.constraints) === null || St === void 0 ? void 0 : St.audio) === !1 ? (wt(this.openvidu.addAlreadyProvidedTracks(yt, new MediaStream(), this.stream)), [3, 13]) : [3, 3];
                case 3:
                  lt = yt.constraints, Ct = {
                    mediaConstraints: lt,
                    publisherProperties: this.properties
                  }, this.stream.setOutboundStreamOptions(Ct), ht = lt.audio === void 0 ? !0 : lt.audio, dt.audio = this.stream.isSendScreen() ? !1 : ht, dt.video = lt.video, pt = Date.now(), this.setPermissionDialogTimer(At), kt.label = 4;
                case 4:
                  return kt.trys.push([4, 11, , 13]), this.stream.isSendScreen() && navigator.mediaDevices.getDisplayMedia && !et.isElectron() ? [4, navigator.mediaDevices.getDisplayMedia({ video: !0, audio: this.properties.audioSource === "screen" })] : [3, 7];
                case 5:
                  return It = kt.sent(), this.openvidu.addAlreadyProvidedTracks(yt, It), [4, Bt(It, ht)];
                case 6:
                  return kt.sent(), [3, 10];
                case 7:
                  return this.stream.lastVideoTrackConstraints = dt.video, [4, navigator.mediaDevices.getUserMedia(dt)];
                case 8:
                  return It = kt.sent(), this.openvidu.addAlreadyProvidedTracks(yt, It, this.stream), [4, Bt(It, ht)];
                case 9:
                  kt.sent(), kt.label = 10;
                case 10:
                  return [3, 13];
                case 11:
                  return vt = kt.sent(), [4, Tt(vt)];
                case 12:
                  return kt.sent(), [3, 13];
                case 13:
                  return [3, 15];
                case 14:
                  return Et = kt.sent(), gt(Et), [3, 15];
                case 15:
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        });
      }, ot.prototype.replaceTrackAux = function(at, st) {
        return ue(this, void 0, void 0, function() {
          var ut, lt;
          return Qe(this, function(dt) {
            switch (dt.label) {
              case 0:
                ut = at.enabled, at.kind === "video" ? at.enabled = this.stream.videoActive : at.kind === "audio" && (at.enabled = this.stream.audioActive), dt.label = 1;
              case 1:
                return dt.trys.push([1, 5, , 6]), this.stream.isLocalStreamPublished ? (this.replaceTrackInMediaStream(at, st), [4, this.replaceTrackInRtcRtpSender(at)]) : [3, 3];
              case 2:
                return [2, dt.sent()];
              case 3:
                return [2, this.replaceTrackInMediaStream(at, st)];
              case 4:
                return [3, 6];
              case 5:
                throw lt = dt.sent(), at.enabled = ut, lt;
              case 6:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, ot.prototype.getVideoDimensions = function() {
        var at = this;
        return new Promise(function(st, ut) {
          var lt = (et.isIonicIos() || et.isIOSWithSafari()) && at.videoReference.readyState < 1, dt, At = function() {
            var pt, gt;
            if (typeof at.stream.getMediaStream().getVideoTracks()[0].getSettings == "function") {
              var wt = at.stream.getMediaStream().getVideoTracks()[0].getSettings();
              pt = wt.width || at.videoReference.videoWidth, gt = wt.height || at.videoReference.videoHeight;
            } else
              tt.warn("MediaStreamTrack does not have getSettings method on " + et.getDescription()), pt = at.videoReference.videoWidth, gt = at.videoReference.videoHeight;
            return dt != null && at.videoReference.removeEventListener("loadedmetadata", dt), lt && document.body.removeChild(at.videoReference), st({ width: pt, height: gt });
          };
          at.videoReference.readyState >= 1 ? At() : (dt = function() {
            if (at.videoReference.videoWidth)
              At();
            else
              var pt = setInterval(function() {
                at.videoReference.videoWidth && (clearInterval(pt), At());
              }, 40);
          }, at.videoReference.addEventListener("loadedmetadata", dt), lt && document.body.appendChild(at.videoReference));
        });
      }, ot.prototype.reestablishStreamPlayingEvent = function() {
        this.ee.getListeners("streamPlaying").length > 0 && this.addPlayEventToFirstVideo();
      }, ot.prototype.initializeVideoReference = function(at) {
        this.videoReference = document.createElement("video"), this.videoReference.style.display = "none", this.videoReference.muted = !0, this.videoReference.autoplay = !0, this.videoReference.controls = !1, (et.isSafariBrowser() || et.isIPhoneOrIPad() && (et.isChromeMobileBrowser() || et.isEdgeMobileBrowser() || et.isOperaMobileBrowser() || et.isFirefoxMobileBrowser())) && (this.videoReference.playsInline = !0), this.stream.setMediaStream(at), this.firstVideoElement && this.createVideoElement(this.firstVideoElement.targetElement, this.properties.insertMode), this.videoReference.srcObject = this.stream.getMediaStream();
      }, ot.prototype.replaceTrackInMediaStream = function(at, st) {
        var ut = this.stream.displayMyRemote() ? this.stream.localMediaStreamWhenSubscribedToRemote : this.stream.getMediaStream(), lt;
        at.kind === "video" ? (lt = ut.getVideoTracks()[0], st && (this.stream.lastVideoTrackConstraints = at.getConstraints())) : lt = ut.getAudioTracks()[0], lt.enabled = !1, lt.stop(), ut.removeTrack(lt), ut.addTrack(at);
        var dt = {
          oldLabel: (lt == null ? void 0 : lt.label) || "",
          newLabel: (at == null ? void 0 : at.label) || ""
        };
        at.kind === "video" && st ? (this.openvidu.sendNewVideoDimensionsIfRequired(this, "trackReplaced", 50, 30), this.openvidu.sendTrackChangedEvent(this, dt.oldLabel, dt.newLabel, "videoTrack"), this.stream.isLocalStreamPublished && this.session.sendVideoData(this.stream.streamManager, 5, !0, 5)) : at.kind === "audio" && st && this.openvidu.sendTrackChangedEvent(this, dt.oldLabel, dt.newLabel, "audioTrack"), at.kind === "audio" && (this.stream.disableHarkSpeakingEvent(!1), this.stream.disableHarkStoppedSpeakingEvent(!1), this.stream.disableHarkVolumeChangeEvent(!1), this.stream.initHarkEvents());
      }, ot.prototype.setPermissionDialogTimer = function(at) {
        var st = this;
        this.permissionDialogTimeout = setTimeout(function() {
          st.emitEvent("accessDialogOpened", []);
        }, at);
      }, ot.prototype.clearPermissionDialogTimer = function(at, st) {
        clearTimeout(this.permissionDialogTimeout), Date.now() - at > st && this.emitEvent("accessDialogClosed", []);
      }, ot.prototype.replaceTrackInRtcRtpSender = function(at) {
        return ue(this, void 0, void 0, function() {
          var st, ut;
          return Qe(this, function(lt) {
            switch (lt.label) {
              case 0:
                if (st = this.stream.getRTCPeerConnection().getSenders(), at.kind === "video") {
                  if (ut = st.find(function(dt) {
                    return !!dt.track && dt.track.kind === "video";
                  }), !ut)
                    throw new Error("There's no replaceable track for that kind of MediaStreamTrack in this Publisher object");
                } else if (at.kind === "audio") {
                  if (ut = st.find(function(dt) {
                    return !!dt.track && dt.track.kind === "audio";
                  }), !ut)
                    throw new Error("There's no replaceable track for that kind of MediaStreamTrack in this Publisher object");
                } else
                  throw new Error("Unknown track kind " + at.kind);
                return [4, ut.replaceTrack(at)];
              case 1:
                return lt.sent(), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, ot;
    }(Ge.StreamManager)
  );
  return Publisher.Publisher = rt, Publisher;
}
var ScreenCapturingAuto = {};
globalThis.getScreenId = function(me, ue, Qe) {
  if (navigator.userAgent.indexOf("Edge") !== -1 && (navigator.msSaveOrOpenBlob || navigator.msSaveBlob)) {
    ue({
      video: !0
    });
    return;
  }
  if (navigator.mozGetUserMedia) {
    ue(null, "firefox", {
      video: {
        mozMediaSource: me,
        mediaSource: me
      }
    });
    return;
  }
  globalThis.addEventListener("message", Ue);
  function Ue(He) {
    He.data && (He.data.chromeMediaSourceId && (He.data.chromeMediaSourceId === "PermissionDeniedError" ? ue("permission-denied") : ue(null, He.data.chromeMediaSourceId, getScreenConstraints$1(null, He.data.chromeMediaSourceId, He.data.canRequestAudioTrack)), globalThis.removeEventListener("message", Ue)), He.data.chromeExtensionStatus && (ue(He.data.chromeExtensionStatus, null, getScreenConstraints$1(He.data.chromeExtensionStatus)), globalThis.removeEventListener("message", Ue)));
  }
  setTimeout(Qe ? function() {
    postGetSourceIdMessage(Qe);
  } : postGetSourceIdMessage, 100);
};
function getScreenConstraints$1(me, ue, Qe) {
  var Ue = {
    audio: !1,
    video: {
      mandatory: {
        chromeMediaSource: me ? "screen" : "desktop",
        maxWidth: globalThis.screen.width > 1920 ? globalThis.screen.width : 1920,
        maxHeight: globalThis.screen.height > 1080 ? globalThis.screen.height : 1080
      },
      optional: []
    }
  };
  return Qe && (Ue.audio = {
    mandatory: {
      chromeMediaSource: me ? "screen" : "desktop"
    },
    optional: []
  }), ue && (Ue.video.mandatory.chromeMediaSourceId = ue, Ue.audio && Ue.audio.mandatory && (Ue.audio.mandatory.chromeMediaSourceId = ue)), Ue;
}
function postGetSourceIdMessage(me) {
  if (!iframe) {
    loadIFrame(function() {
      postGetSourceIdMessage(me);
    });
    return;
  }
  if (!iframe.isLoaded) {
    setTimeout(function() {
      postGetSourceIdMessage(me);
    }, 100);
    return;
  }
  me ? me.forEach ? iframe.contentWindow.postMessage({
    captureCustomSourceId: me
  }, "*") : iframe.contentWindow.postMessage({
    captureSourceIdWithAudio: !0
  }, "*") : iframe.contentWindow.postMessage({
    captureSourceId: !0
  }, "*");
}
var iframe;
globalThis.getScreenConstraints = function(me) {
  loadIFrame(function() {
    getScreenId(function(ue, Qe, Ue) {
      Ue || (Ue = {
        video: !0
      }), me(ue, Ue.video);
    });
  });
};
function loadIFrame(me) {
  if (iframe) {
    me();
    return;
  }
  iframe = document.createElement("iframe"), iframe.onload = function() {
    iframe.isLoaded = !0, me();
  }, iframe.src = "https://openvidu.github.io/openvidu-screen-sharing-chrome-extension/", iframe.style.display = "none", (document.body || document.documentElement).appendChild(iframe);
}
globalThis.getChromeExtensionStatus = function(me) {
  if (navigator.mozGetUserMedia) {
    me("installed-enabled");
    return;
  }
  globalThis.addEventListener("message", ue);
  function ue(Qe) {
    Qe.data && Qe.data.chromeExtensionStatus && (me(Qe.data.chromeExtensionStatus), globalThis.removeEventListener("message", ue));
  }
  setTimeout(postGetChromeExtensionStatusMessage, 100);
};
function postGetChromeExtensionStatusMessage() {
  if (!iframe) {
    loadIFrame(postGetChromeExtensionStatusMessage);
    return;
  }
  if (!iframe.isLoaded) {
    setTimeout(postGetChromeExtensionStatusMessage, 100);
    return;
  }
  iframe.contentWindow.postMessage({
    getChromeExtensionStatus: !0
  }, "*");
}
ScreenCapturingAuto.getScreenId = globalThis.getScreenId;
var ScreenCapturing = {}, chromeMediaSource = "screen", sourceId, screenCallback;
if (typeof window < "u" && typeof navigator < "u" && typeof navigator.userAgent < "u") {
  var isFirefox = typeof window.InstallTrigger < "u";
  window.opera || navigator.userAgent.indexOf(" OPR/") >= 0, window.addEventListener("message", function(me) {
    me.origin == window.location.origin && onMessageCallback(me.data);
  });
}
function onMessageCallback(me) {
  if (me == "PermissionDeniedError") {
    if (screenCallback)
      return screenCallback("PermissionDeniedError");
    throw new Error("PermissionDeniedError");
  }
  me == "rtcmulticonnection-extension-loaded" && (chromeMediaSource = "desktop"), me.sourceId && screenCallback && screenCallback(sourceId = me.sourceId, me.canRequestAudioTrack === !0);
}
function isChromeExtensionAvailable(me) {
  if (me) {
    if (chromeMediaSource == "desktop")
      return me(!0);
    window.postMessage("are-you-there", "*"), setTimeout(function() {
      chromeMediaSource == "screen" ? me(!1) : me(!0);
    }, 2e3);
  }
}
function getSourceId(me) {
  if (!me)
    throw '"callback" parameter is mandatory.';
  if (sourceId)
    return me(sourceId);
  screenCallback = me, window.postMessage("get-sourceId", "*");
}
function getSourceIdWithAudio(me) {
  if (!me)
    throw '"callback" parameter is mandatory.';
  if (sourceId)
    return me(sourceId);
  screenCallback = me, window.postMessage("audio-plus-tab", "*");
}
function getChromeExtensionStatus(me, ue) {
  if (isFirefox)
    return ue("not-chrome");
  arguments.length != 2 && (ue = me, me = "lfcgfepafnobdloecchnfaclibenjold");
  var Qe = document.createElement("img");
  Qe.src = "chrome-extension://" + me + "/icon.png", Qe.onload = function() {
    chromeMediaSource = "screen", window.postMessage("are-you-there", "*"), setTimeout(function() {
      chromeMediaSource == "screen" ? ue("installed-disabled") : ue("installed-enabled");
    }, 2e3);
  }, Qe.onerror = function() {
    ue("not-installed");
  };
}
function getScreenConstraintsWithAudio(me) {
  getScreenConstraints(me, !0);
}
function getScreenConstraints(me, ue) {
  sourceId = "";
  var Qe = {
    mozMediaSource: "window",
    mediaSource: "window"
  };
  if (isFirefox)
    return me(null, Qe);
  var Ue = {
    mandatory: {
      chromeMediaSource,
      maxWidth: screen.width > 1920 ? screen.width : 1920,
      maxHeight: screen.height > 1080 ? screen.height : 1080
    },
    optional: []
  };
  if (chromeMediaSource == "desktop" && !sourceId) {
    ue ? getSourceIdWithAudio(function(He, Ge) {
      Ue.mandatory.chromeMediaSourceId = He, Ge && (Ue.canRequestAudioTrack = !0), me(He == "PermissionDeniedError" ? He : null, Ue);
    }) : getSourceId(function(He) {
      Ue.mandatory.chromeMediaSourceId = He, me(He == "PermissionDeniedError" ? He : null, Ue);
    });
    return;
  }
  chromeMediaSource == "desktop" && (Ue.mandatory.chromeMediaSourceId = sourceId), me(null, Ue);
}
ScreenCapturing.getScreenConstraints = getScreenConstraints;
ScreenCapturing.getScreenConstraintsWithAudio = getScreenConstraintsWithAudio;
ScreenCapturing.isChromeExtensionAvailable = isChromeExtensionAvailable;
ScreenCapturing.getChromeExtensionStatus = getChromeExtensionStatus;
ScreenCapturing.getSourceId = getSourceId;
var events$2 = { exports: {} }, R$1 = typeof Reflect == "object" ? Reflect : null, ReflectApply = R$1 && typeof R$1.apply == "function" ? R$1.apply : function(ue, Qe, Ue) {
  return Function.prototype.apply.call(ue, Qe, Ue);
}, ReflectOwnKeys;
R$1 && typeof R$1.ownKeys == "function" ? ReflectOwnKeys = R$1.ownKeys : Object.getOwnPropertySymbols ? ReflectOwnKeys = function(ue) {
  return Object.getOwnPropertyNames(ue).concat(Object.getOwnPropertySymbols(ue));
} : ReflectOwnKeys = function(ue) {
  return Object.getOwnPropertyNames(ue);
};
function ProcessEmitWarning(me) {
  console && console.warn && console.warn(me);
}
var NumberIsNaN = Number.isNaN || function(ue) {
  return ue !== ue;
};
function EventEmitter$1() {
  EventEmitter$1.init.call(this);
}
events$2.exports = EventEmitter$1;
events$2.exports.once = once;
EventEmitter$1.EventEmitter = EventEmitter$1;
EventEmitter$1.prototype._events = void 0;
EventEmitter$1.prototype._eventsCount = 0;
EventEmitter$1.prototype._maxListeners = void 0;
var defaultMaxListeners = 10;
function checkListener(me) {
  if (typeof me != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof me);
}
Object.defineProperty(EventEmitter$1, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(me) {
    if (typeof me != "number" || me < 0 || NumberIsNaN(me))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + me + ".");
    defaultMaxListeners = me;
  }
});
EventEmitter$1.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
EventEmitter$1.prototype.setMaxListeners = function(ue) {
  if (typeof ue != "number" || ue < 0 || NumberIsNaN(ue))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + ue + ".");
  return this._maxListeners = ue, this;
};
function _getMaxListeners(me) {
  return me._maxListeners === void 0 ? EventEmitter$1.defaultMaxListeners : me._maxListeners;
}
EventEmitter$1.prototype.getMaxListeners = function() {
  return _getMaxListeners(this);
};
EventEmitter$1.prototype.emit = function(ue) {
  for (var Qe = [], Ue = 1; Ue < arguments.length; Ue++) Qe.push(arguments[Ue]);
  var He = ue === "error", Ge = this._events;
  if (Ge !== void 0)
    He = He && Ge.error === void 0;
  else if (!He)
    return !1;
  if (He) {
    var Xe;
    if (Qe.length > 0 && (Xe = Qe[0]), Xe instanceof Error)
      throw Xe;
    var Ke = new Error("Unhandled error." + (Xe ? " (" + Xe.message + ")" : ""));
    throw Ke.context = Xe, Ke;
  }
  var $e = Ge[ue];
  if ($e === void 0)
    return !1;
  if (typeof $e == "function")
    ReflectApply($e, this, Qe);
  else
    for (var Je = $e.length, Ze = arrayClone($e, Je), Ue = 0; Ue < Je; ++Ue)
      ReflectApply(Ze[Ue], this, Qe);
  return !0;
};
function _addListener(me, ue, Qe, Ue) {
  var He, Ge, Xe;
  if (checkListener(Qe), Ge = me._events, Ge === void 0 ? (Ge = me._events = /* @__PURE__ */ Object.create(null), me._eventsCount = 0) : (Ge.newListener !== void 0 && (me.emit(
    "newListener",
    ue,
    Qe.listener ? Qe.listener : Qe
  ), Ge = me._events), Xe = Ge[ue]), Xe === void 0)
    Xe = Ge[ue] = Qe, ++me._eventsCount;
  else if (typeof Xe == "function" ? Xe = Ge[ue] = Ue ? [Qe, Xe] : [Xe, Qe] : Ue ? Xe.unshift(Qe) : Xe.push(Qe), He = _getMaxListeners(me), He > 0 && Xe.length > He && !Xe.warned) {
    Xe.warned = !0;
    var Ke = new Error("Possible EventEmitter memory leak detected. " + Xe.length + " " + String(ue) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    Ke.name = "MaxListenersExceededWarning", Ke.emitter = me, Ke.type = ue, Ke.count = Xe.length, ProcessEmitWarning(Ke);
  }
  return me;
}
EventEmitter$1.prototype.addListener = function(ue, Qe) {
  return _addListener(this, ue, Qe, !1);
};
EventEmitter$1.prototype.on = EventEmitter$1.prototype.addListener;
EventEmitter$1.prototype.prependListener = function(ue, Qe) {
  return _addListener(this, ue, Qe, !0);
};
function onceWrapper() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function _onceWrap(me, ue, Qe) {
  var Ue = { fired: !1, wrapFn: void 0, target: me, type: ue, listener: Qe }, He = onceWrapper.bind(Ue);
  return He.listener = Qe, Ue.wrapFn = He, He;
}
EventEmitter$1.prototype.once = function(ue, Qe) {
  return checkListener(Qe), this.on(ue, _onceWrap(this, ue, Qe)), this;
};
EventEmitter$1.prototype.prependOnceListener = function(ue, Qe) {
  return checkListener(Qe), this.prependListener(ue, _onceWrap(this, ue, Qe)), this;
};
EventEmitter$1.prototype.removeListener = function(ue, Qe) {
  var Ue, He, Ge, Xe, Ke;
  if (checkListener(Qe), He = this._events, He === void 0)
    return this;
  if (Ue = He[ue], Ue === void 0)
    return this;
  if (Ue === Qe || Ue.listener === Qe)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete He[ue], He.removeListener && this.emit("removeListener", ue, Ue.listener || Qe));
  else if (typeof Ue != "function") {
    for (Ge = -1, Xe = Ue.length - 1; Xe >= 0; Xe--)
      if (Ue[Xe] === Qe || Ue[Xe].listener === Qe) {
        Ke = Ue[Xe].listener, Ge = Xe;
        break;
      }
    if (Ge < 0)
      return this;
    Ge === 0 ? Ue.shift() : spliceOne(Ue, Ge), Ue.length === 1 && (He[ue] = Ue[0]), He.removeListener !== void 0 && this.emit("removeListener", ue, Ke || Qe);
  }
  return this;
};
EventEmitter$1.prototype.off = EventEmitter$1.prototype.removeListener;
EventEmitter$1.prototype.removeAllListeners = function(ue) {
  var Qe, Ue, He;
  if (Ue = this._events, Ue === void 0)
    return this;
  if (Ue.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : Ue[ue] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete Ue[ue]), this;
  if (arguments.length === 0) {
    var Ge = Object.keys(Ue), Xe;
    for (He = 0; He < Ge.length; ++He)
      Xe = Ge[He], Xe !== "removeListener" && this.removeAllListeners(Xe);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (Qe = Ue[ue], typeof Qe == "function")
    this.removeListener(ue, Qe);
  else if (Qe !== void 0)
    for (He = Qe.length - 1; He >= 0; He--)
      this.removeListener(ue, Qe[He]);
  return this;
};
function _listeners(me, ue, Qe) {
  var Ue = me._events;
  if (Ue === void 0)
    return [];
  var He = Ue[ue];
  return He === void 0 ? [] : typeof He == "function" ? Qe ? [He.listener || He] : [He] : Qe ? unwrapListeners(He) : arrayClone(He, He.length);
}
EventEmitter$1.prototype.listeners = function(ue) {
  return _listeners(this, ue, !0);
};
EventEmitter$1.prototype.rawListeners = function(ue) {
  return _listeners(this, ue, !1);
};
EventEmitter$1.listenerCount = function(me, ue) {
  return typeof me.listenerCount == "function" ? me.listenerCount(ue) : listenerCount.call(me, ue);
};
EventEmitter$1.prototype.listenerCount = listenerCount;
function listenerCount(me) {
  var ue = this._events;
  if (ue !== void 0) {
    var Qe = ue[me];
    if (typeof Qe == "function")
      return 1;
    if (Qe !== void 0)
      return Qe.length;
  }
  return 0;
}
EventEmitter$1.prototype.eventNames = function() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(me, ue) {
  for (var Qe = new Array(ue), Ue = 0; Ue < ue; ++Ue)
    Qe[Ue] = me[Ue];
  return Qe;
}
function spliceOne(me, ue) {
  for (; ue + 1 < me.length; ue++)
    me[ue] = me[ue + 1];
  me.pop();
}
function unwrapListeners(me) {
  for (var ue = new Array(me.length), Qe = 0; Qe < ue.length; ++Qe)
    ue[Qe] = me[Qe].listener || me[Qe];
  return ue;
}
function once(me, ue) {
  return new Promise(function(Qe, Ue) {
    function He(Xe) {
      me.removeListener(ue, Ge), Ue(Xe);
    }
    function Ge() {
      typeof me.removeListener == "function" && me.removeListener("error", He), Qe([].slice.call(arguments));
    }
    eventTargetAgnosticAddListener(me, ue, Ge, { once: !0 }), ue !== "error" && addErrorHandlerIfEventEmitter(me, He, { once: !0 });
  });
}
function addErrorHandlerIfEventEmitter(me, ue, Qe) {
  typeof me.on == "function" && eventTargetAgnosticAddListener(me, "error", ue, Qe);
}
function eventTargetAgnosticAddListener(me, ue, Qe, Ue) {
  if (typeof me.on == "function")
    Ue.once ? me.once(ue, Qe) : me.on(ue, Qe);
  else if (typeof me.addEventListener == "function")
    me.addEventListener(ue, function He(Ge) {
      Ue.once && me.removeEventListener(ue, He), Qe(Ge);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof me);
}
var eventsExports = events$2.exports, inherits_browser = { exports: {} };
typeof Object.create == "function" ? inherits_browser.exports = function(ue, Qe) {
  Qe && (ue.super_ = Qe, ue.prototype = Object.create(Qe.prototype, {
    constructor: {
      value: ue,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : inherits_browser.exports = function(ue, Qe) {
  if (Qe) {
    ue.super_ = Qe;
    var Ue = function() {
    };
    Ue.prototype = Qe.prototype, ue.prototype = new Ue(), ue.prototype.constructor = ue;
  }
};
var inherits_browserExports = inherits_browser.exports, packers = {}, JsonRPC$1 = {};
function pack$1(me, ue) {
  var Qe = {
    jsonrpc: "2.0"
  };
  if (me.method)
    Qe.method = me.method, me.params && (Qe.params = me.params), ue != null && (Qe.id = ue);
  else if (ue != null) {
    if (me.error) {
      if (me.result !== void 0)
        throw new TypeError("Both result and error are defined");
      Qe.error = me.error;
    } else if (me.result !== void 0)
      Qe.result = me.result;
    else
      throw new TypeError("No result or error is defined");
    Qe.id = ue;
  }
  return JSON.stringify(Qe);
}
function unpack$1(me) {
  var ue = me;
  (typeof me == "string" || me instanceof String) && (ue = JSON.parse(me));
  var Qe = ue.jsonrpc;
  if (Qe !== "2.0")
    throw new TypeError("Invalid JsonRPC version '" + Qe + "': " + me);
  if (ue.method == null) {
    if (ue.id == null)
      throw new TypeError("Invalid message: " + me);
    var Ue = ue.result !== void 0, He = ue.error !== void 0;
    if (Ue && He)
      throw new TypeError("Both result and error are defined: " + me);
    if (!Ue && !He)
      throw new TypeError("No result or error is defined: " + me);
    ue.ack = ue.id, delete ue.id;
  }
  return ue;
}
JsonRPC$1.pack = pack$1;
JsonRPC$1.unpack = unpack$1;
var XmlRPC$1 = {};
function pack(me) {
  throw new TypeError("Not yet implemented");
}
function unpack(me) {
  throw new TypeError("Not yet implemented");
}
XmlRPC$1.pack = pack;
XmlRPC$1.unpack = unpack;
var JsonRPC = JsonRPC$1, XmlRPC = XmlRPC$1;
packers.JsonRPC = JsonRPC;
packers.XmlRPC = XmlRPC;
function Mapper() {
  var me = {};
  this.forEach = function(ue) {
    for (var Qe in me) {
      var Ue = me[Qe];
      for (var He in Ue)
        ue(Ue[He]);
    }
  }, this.get = function(ue, Qe) {
    var Ue = me[Qe];
    if (Ue != null)
      return Ue[ue];
  }, this.remove = function(ue, Qe) {
    var Ue = me[Qe];
    if (Ue != null) {
      delete Ue[ue];
      for (var He in Ue)
        return !1;
      delete me[Qe];
    }
  }, this.set = function(ue, Qe, Ue) {
    if (ue == null)
      return this.remove(Qe, Ue);
    var He = me[Ue];
    He == null && (me[Ue] = He = {}), He[Qe] = ue;
  };
}
Mapper.prototype.pop = function(me, ue) {
  var Qe = this.get(me, ue);
  if (Qe != null)
    return this.remove(me, ue), Qe;
};
var Mapper_1 = Mapper, clients = {}, webSocketWithReconnection, hasRequiredWebSocketWithReconnection;
function requireWebSocketWithReconnection() {
  if (hasRequiredWebSocketWithReconnection) return webSocketWithReconnection;
  hasRequiredWebSocketWithReconnection = 1;
  var me = OpenViduLogger$1.OpenViduLogger, ue = me.getInstance(), Qe = 2e3, Ue = 3e3, He = 3;
  function Ge(Xe) {
    var Ke = !1, $e, Je = Xe.uri, Ze = !1, nt = new WebSocket(Je);
    nt.onopen = function() {
      ue.debug("WebSocket connected to " + Je), Xe.onconnected && Xe.onconnected();
    }, nt.onerror = function(ot) {
      ue.error("Could not connect to " + Je + " (invoking onerror if defined)", ot), Xe.onerror && Xe.onerror(ot);
    };
    var tt = function() {
      nt.readyState === He ? Ke ? ue.debug("Connection closed by user") : Xe.ismasternodecrashed() ? ue.error("Master Node has crashed. Stopping reconnection process") : (ue.debug("Connection closed unexpectedly. Reconnecting..."), et(Qe, 1)) : ue.debug("Close callback from previous websocket. Ignoring it");
    };
    nt.onclose = tt;
    function et(ot, at) {
      if (ue.debug("reconnect (attempt #" + at + ", max=" + ot + ")"), at === 1) {
        if (Ze) {
          ue.warn("Trying to reconnect when already reconnecting... Ignoring this reconnection.");
          return;
        } else
          Ze = !0;
        Xe.onreconnecting && Xe.onreconnecting();
      }
      it(ot, at);
    }
    function rt(ot) {
      var at = new URLSearchParams(new URL(ot).search);
      return at.has("reconnect") || (ot = Array.from(at).length > 0 ? ot + "&reconnect=true" : ot + "?reconnect=true"), ot;
    }
    function it(ot, at) {
      ue.debug("Reconnection attempt #" + at), nt.close(4104, "Connection closed for reconnection"), Je = rt(Je), nt = new WebSocket(Je), nt.onopen = function() {
        ue.debug("Reconnected to " + Je + " after " + at + " attempts..."), Ze = !1, $e(), Xe.onreconnected && Xe.onreconnected(), nt.onclose = tt;
      }, nt.onerror = function(st) {
        ue.warn("Reconnection error: ", st), at === ot ? Xe.ondisconnect && Xe.ondisconnect() : setTimeout(function() {
          et(ot, at + 1);
        }, Ue);
      };
    }
    this.close = function(ot, at) {
      Ke = !0, nt.close(ot, at);
    }, this.reconnectWs = function() {
      ue.debug("reconnectWs"), et(Qe, 1);
    }, this.send = function(ot) {
      nt.send(ot);
    }, this.addEventListener = function(ot, at) {
      $e = function() {
        nt.addEventListener(ot, at);
      }, $e();
    }, this.getReadyState = function() {
      return nt.readyState;
    };
  }
  return webSocketWithReconnection = Ge, webSocketWithReconnection;
}
var jsonrpcclient, hasRequiredJsonrpcclient;
function requireJsonrpcclient() {
  if (hasRequiredJsonrpcclient) return jsonrpcclient;
  hasRequiredJsonrpcclient = 1;
  var me = requireKurentoJsonrpc(), ue = requireWebSocketWithReconnection(), Qe = OpenViduLogger$1.OpenViduLogger;
  Date.now = Date.now || function() {
    return +/* @__PURE__ */ new Date();
  };
  var Ue = 5e3, He = "RECONNECTING", Ge = "CONNECTED", Xe = "DISCONNECTED", Ke = Qe.getInstance();
  function $e(Je) {
    var Ze = this, nt = Je.ws, tt = -1, et = 0, rt = !0, it = !1, ot, at = Xe, st = nt.onreconnecting, ut = nt.onreconnected, lt = nt.onconnected, dt = nt.onerror;
    Je.rpc.pull = function(Ct, ht) {
      ht.reply(null, "push");
    }, nt.onreconnecting = function() {
      if (Ke.debug("--------- ONRECONNECTING -----------"), at === He) {
        Ke.error("Websocket already in RECONNECTING state when receiving a new ONRECONNECTING message. Ignoring it");
        return;
      }
      yt(), at = He, st && st();
    }, nt.onreconnected = function() {
      if (Ke.debug("--------- ONRECONNECTED -----------"), at === Ge) {
        Ke.error("Websocket already in CONNECTED state when receiving a new ONRECONNECTED message. Ignoring it");
        return;
      }
      at = Ge, wt(), ut && ut();
    }, nt.onconnected = function() {
      if (Ke.debug("--------- ONCONNECTED -----------"), at === Ge) {
        Ke.error("Websocket already in CONNECTED state when receiving a new ONCONNECTED message. Ignoring it");
        return;
      }
      at = Ge, rt = !0, Tt(), lt && lt();
    }, nt.onerror = function(Ct) {
      Ke.debug("--------- ONERROR -----------"), at = Xe, yt(), dt && dt(Ct);
    };
    var At = new ue(nt);
    Ke.debug("Connecting websocket to URI: " + nt.uri);
    var pt = {
      request_timeout: Je.rpc.requestTimeout,
      ping_request_timeout: Je.rpc.heartbeatRequestTimeout
    }, gt = new me(me.packers.JsonRPC, pt, At, function(Ct) {
      Ke.debug("Received request: " + JSON.stringify(Ct));
      try {
        var ht = Je.rpc[Ct.method];
        ht === void 0 ? Ke.error("Method " + Ct.method + " not registered in client") : ht(Ct.params, Ct);
      } catch (It) {
        Ke.error("Exception processing request: " + JSON.stringify(Ct)), Ke.error(It);
      }
    });
    this.send = function(Ct, ht, It) {
      var vt = Date.now();
      gt.encode(Ct, ht, function(Et, bt) {
        if (Et) {
          try {
            Ke.error("ERROR:" + Et.message + " in Request: method:" + Ct + " params:" + JSON.stringify(ht) + " request:" + Et.request), Et.data && Ke.error("ERROR DATA:" + JSON.stringify(Et.data));
          } catch {
          }
          Et.requestTime = vt;
        }
        It && (bt != null && bt.value !== "pong" && Ke.debug("Response: " + JSON.stringify(bt)), It(Et, bt));
      });
    };
    function wt() {
      Ke.debug("notReconnectIfNumLessThan = " + et + " (old=" + tt + ")"), tt = et;
    }
    function Bt() {
      if (rt) {
        var Ct = null;
        (et == 0 || et == tt) && (Ct = {
          interval: Je.heartbeat || Ue
        }), et++, Ze.send("ping", Ct, /* @__PURE__ */ function(ht) {
          return function(It, vt) {
            It && (Ke.debug("Error in ping request #" + ht + " (" + It.message + ")"), ht > tt && (rt = !1, wt(), Ke.debug("Server did not respond to ping message #" + ht + ". Reconnecting... "), At.reconnectWs()));
          };
        }(et));
      } else
        Ke.debug("Trying to send ping, but ping is not enabled");
    }
    function Tt() {
      it || (Ke.debug("Starting ping (if configured)"), it = !0, Je.heartbeat != null && (ot = setInterval(Bt, Je.heartbeat), Bt()));
    }
    function yt() {
      clearInterval(ot), it = !1, rt = !1, et = -1, gt.cancel();
    }
    this.close = function(Ct, ht) {
      Ke.debug("Closing  with code: " + Ct + " because: " + ht), ot != null && (Ke.debug("Clearing ping interval"), clearInterval(ot)), it = !1, rt = !1, At.close(Ct, ht);
    }, this.reconnect = function() {
      At.reconnectWs();
    }, this.resetPing = function() {
      rt = !0, et = 0, Tt();
    }, this.getReadyState = function() {
      return At.getReadyState();
    };
  }
  return jsonrpcclient = $e, jsonrpcclient;
}
var hasRequiredClients;
function requireClients() {
  if (hasRequiredClients) return clients;
  hasRequiredClients = 1;
  var me = requireJsonrpcclient();
  return clients.JsonRpcClient = me, clients;
}
var transports = {}, hasRequiredTransports;
function requireTransports() {
  if (hasRequiredTransports) return transports;
  hasRequiredTransports = 1;
  var me = requireWebSocketWithReconnection();
  return transports.WebSocketWithReconnection = me, transports;
}
var kurentoJsonrpc, hasRequiredKurentoJsonrpc;
function requireKurentoJsonrpc() {
  if (hasRequiredKurentoJsonrpc) return kurentoJsonrpc;
  hasRequiredKurentoJsonrpc = 1;
  var me = !1;
  if (Object.defineProperty)
    try {
      Object.defineProperty({}, "x", {});
    } catch {
      me = !0;
    }
  Function.prototype.bind || (Function.prototype.bind = function(tt) {
    if (typeof this != "function")
      throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");
    var et = Array.prototype.slice.call(arguments, 1), rt = this, it = function() {
    }, ot = function() {
      return rt.apply(this instanceof it && tt ? this : tt, et.concat(Array.prototype.slice.call(arguments)));
    };
    return it.prototype = this.prototype, ot.prototype = new it(), ot;
  });
  var ue = eventsExports.EventEmitter, Qe = inherits_browserExports, Ue = packers, He = Mapper_1, Ge = 5e3;
  function Xe(tt) {
    if (!tt)
      return {};
    for (var et in tt) {
      var rt = tt[et];
      typeof rt == "string" && (tt[et] = {
        response: rt
      });
    }
    return tt;
  }
  function Ke(tt) {
    if (tt) {
      if (tt instanceof Function)
        return {
          send: tt
        };
      if (tt.send instanceof Function)
        return tt;
      if (tt.postMessage instanceof Function)
        return tt.send = tt.postMessage, tt;
      if (tt.write instanceof Function)
        return tt.send = tt.write, tt;
      if (tt.onmessage === void 0 && !(tt.pause instanceof Function))
        throw new SyntaxError("Transport is not a function nor a valid object");
    }
  }
  function $e(tt, et) {
    me ? (this.method = tt, this.params = et) : (Object.defineProperty(this, "method", {
      value: tt,
      enumerable: !0
    }), Object.defineProperty(this, "params", {
      value: et,
      enumerable: !0
    }));
  }
  function Je(tt, et, rt, it) {
    var ot = this;
    if (!tt)
      throw new SyntaxError("Packer is not defined");
    if (!tt.pack || !tt.unpack)
      throw new SyntaxError("Packer is invalid");
    var at = Xe(tt.responseMethods);
    if (et instanceof Function) {
      if (rt != null)
        throw new SyntaxError("There can't be parameters after onRequest");
      it = et, rt = void 0, et = void 0;
    }
    if (et && et.send instanceof Function) {
      if (rt && !(rt instanceof Function))
        throw new SyntaxError("Only a function can be after transport");
      it = rt, rt = et, et = void 0;
    }
    if (rt instanceof Function) {
      if (it != null)
        throw new SyntaxError("There can't be parameters after onRequest");
      it = rt, rt = void 0;
    }
    if (rt && rt.send instanceof Function && it && !(it instanceof Function))
      throw new SyntaxError("Only a function can be after transport");
    et = et || {}, ue.call(this), it && this.on("request", it), me ? this.peerID = et.peerID : Object.defineProperty(this, "peerID", {
      value: et.peerID
    });
    var st = et.max_retries || 0;
    function ut(Et) {
      ot.decode(Et.data || Et);
    }
    this.getTransport = function() {
      return rt;
    }, this.setTransport = function(Et) {
      rt && (rt.removeEventListener ? rt.removeEventListener("message", ut) : rt.removeListener && rt.removeListener("data", ut)), Et && (Et.addEventListener ? Et.addEventListener("message", ut) : Et.addListener && Et.addListener("data", ut)), rt = Ke(Et);
    }, me || Object.defineProperty(this, "transport", {
      get: this.getTransport.bind(this),
      set: this.setTransport.bind(this)
    }), this.setTransport(rt);
    var lt = et.request_timeout || Ge, dt = et.ping_request_timeout || lt, At = et.response_timeout || Ge, pt = et.duplicates_timeout || Ge, gt = 0, wt = new He(), Bt = new He(), Tt = new He(), yt = {};
    function Ct(Et, bt, Rt) {
      var St = {
        message: Et,
        timeout: setTimeout(function() {
          Bt.remove(bt, Rt);
        }, At)
      };
      Bt.set(St, bt, Rt);
    }
    function ht(Et, bt) {
      var Rt = setTimeout(function() {
        Tt.remove(Et, bt);
      }, pt);
      Tt.set(Rt, Et, bt);
    }
    function It(Et, bt, Rt, St, kt) {
      $e.call(this, Et, bt), this.getTransport = function() {
        return kt;
      }, this.setTransport = function(Qt) {
        kt = Ke(Qt);
      }, me || Object.defineProperty(this, "transport", {
        get: this.getTransport.bind(this),
        set: this.setTransport.bind(this)
      });
      var jt = Bt.get(Rt, St);
      kt || ot.getTransport() || (me ? this.duplicated = !!jt : Object.defineProperty(this, "duplicated", {
        value: !!jt
      }));
      var Pt = at[Et];
      this.pack = tt.pack.bind(tt, this, Rt), this.reply = function(Qt, qt, _t) {
        if (Qt instanceof Function || Qt && Qt.send instanceof Function) {
          if (qt != null)
            throw new SyntaxError("There can't be parameters after callback");
          _t = Qt, qt = null, Qt = void 0;
        } else if (qt instanceof Function || qt && qt.send instanceof Function) {
          if (_t != null)
            throw new SyntaxError("There can't be parameters after callback");
          _t = qt, qt = null;
        }
        _t = Ke(_t), jt && clearTimeout(jt.timeout), St != null && (Qt && (Qt.dest = St), qt && (qt.dest = St));
        var Yt;
        if (Qt || qt != null) {
          if (ot.peerID != null && (Qt ? Qt.from = ot.peerID : qt.from = ot.peerID), Pt)
            if (Pt.error == null && Qt)
              Yt = {
                error: Qt
              };
            else {
              var Xt = Qt ? Pt.error : Pt.response;
              Yt = {
                method: Xt,
                params: Qt || qt
              };
            }
          else
            Yt = {
              error: Qt,
              result: qt
            };
          Yt = tt.pack(Yt, Rt);
        } else jt ? Yt = jt.message : Yt = tt.pack({
          result: null
        }, Rt);
        return Ct(Yt, Rt, St), _t = _t || this.getTransport() || ot.getTransport(), _t ? _t.send(Yt) : Yt;
      };
    }
    Qe(It, $e);
    function vt(Et) {
      var bt = yt[Et];
      if (bt) {
        delete yt[Et];
        var Rt = wt.pop(bt.id, bt.dest);
        Rt && (clearTimeout(Rt.timeout), ht(bt.id, bt.dest));
      }
    }
    this.cancel = function(Et) {
      if (Et)
        return vt(Et);
      for (var Et in yt)
        vt(Et);
    }, this.close = function() {
      var Et = this.getTransport();
      Et && Et.close && Et.close(4003, "Cancel request"), this.cancel(), Tt.forEach(clearTimeout), Bt.forEach(function(bt) {
        clearTimeout(bt.timeout);
      });
    }, this.encode = function(Et, bt, Rt, St, kt) {
      if (bt instanceof Function) {
        if (Rt != null)
          throw new SyntaxError("There can't be parameters after callback");
        kt = bt, St = void 0, Rt = void 0, bt = void 0;
      } else if (Rt instanceof Function) {
        if (St != null)
          throw new SyntaxError("There can't be parameters after callback");
        kt = Rt, St = void 0, Rt = void 0;
      } else if (St instanceof Function) {
        if (kt != null)
          throw new SyntaxError("There can't be parameters after callback");
        kt = St, St = void 0;
      }
      ot.peerID != null && (bt = bt || {}, bt.from = ot.peerID), Rt != null && (bt = bt || {}, bt.dest = Rt);
      var jt = {
        method: Et,
        params: bt
      };
      if (kt) {
        let Yt = function(Ot, ft) {
          ot.cancel(jt), kt(Ot, ft);
        }, Xt = function(Ot) {
          var ft = Et === "ping" ? dt : lt;
          return qt.timeout = setTimeout(Lt, ft * Math.pow(2, Qt++)), yt[jt] = {
            id: Pt,
            dest: Rt
          }, wt.set(qt, Pt, Rt), Ot = Ot || _t || ot.getTransport(), Ot ? Ot.send(jt) : jt;
        }, Ut = function(Ot) {
          Ot = Ke(Ot), console.warn(Qt + " retry for request message:", jt);
          var ft = Tt.pop(Pt, Rt);
          return clearTimeout(ft), Xt(Ot);
        }, Lt = function() {
          if (Qt < st)
            return Ut(St);
          var Ot = new Error("Request has timed out");
          Ot.request = jt, Ot.retry = Ut, Yt(Ot);
        };
        var Pt = gt++, Qt = 0;
        jt = tt.pack(jt, Pt);
        var qt = {
          message: jt,
          callback: Yt,
          responseMethods: at[Et] || {}
        }, _t = Ke(St);
        return Xt(St);
      }
      return jt = tt.pack(jt), St = St || this.getTransport(), St ? St.send(jt) : jt;
    }, this.decode = function(Et, bt) {
      if (!Et)
        throw new TypeError("Message is not defined");
      try {
        Et = tt.unpack(Et);
      } catch (Mt) {
        return console.debug(Mt, Et);
      }
      var Rt = Et.id, St = Et.ack, kt = Et.method, jt = Et.params || {}, Pt = jt.from, Qt = jt.dest;
      if (ot.peerID != null && Pt == ot.peerID)
        return;
      if (Rt == null && St == null) {
        var qt = new $e(kt, jt);
        return ot.emit("request", qt) ? void 0 : qt;
      }
      function _t() {
        if (bt = Ke(bt) || ot.getTransport(), bt) {
          var Mt = Bt.get(Rt, Pt);
          if (Mt)
            return bt.send(Mt.message);
        }
        var Ft = Rt ?? St, Gt = new It(kt, jt, Ft, Pt, bt);
        if (!ot.emit("request", Gt))
          return Gt;
      }
      function Yt(Mt, Ft, Gt) {
        Mt.callback(Ft, Gt);
      }
      function Xt(Mt) {
        console.warn("Response already processed", Et), clearTimeout(Mt), ht(St, Pt);
      }
      if (kt) {
        if (Qt == null || Qt == ot.peerID) {
          var Dt = wt.get(St, Pt);
          if (Dt) {
            var Ut = Dt.responseMethods;
            return kt == Ut.error ? Yt(Dt, jt) : kt == Ut.response ? Yt(Dt, null, jt) : _t();
          }
          var Lt = Tt.get(St, Pt);
          if (Lt)
            return Xt(Lt);
        }
        return _t();
      }
      var Ot = Et.error, ft = Et.result;
      if (!(Ot && Ot.dest && Ot.dest != ot.peerID) && !(ft && ft.dest && ft.dest != ot.peerID)) {
        var Dt = wt.get(St, Pt);
        if (!Dt) {
          var Lt = Tt.get(St, Pt);
          return Lt ? Xt(Lt) : console.warn("No callback was defined for this message", Et);
        }
        Yt(Dt, Ot, ft);
      }
    };
  }
  Qe(Je, ue), Je.RpcNotification = $e, kurentoJsonrpc = Je;
  var Ze = requireClients(), nt = requireTransports();
  return Je.clients = Ze, Je.clients.transports = nt, Je.packers = Ue, kurentoJsonrpc;
}
const author = "OpenVidu", dependencies = {
  freeice: "2.2.2",
  hark: "1.2.3",
  jsnlog: "2.30.0",
  mime: "3.0.0",
  platform: "1.3.6",
  semver: "7.3.8",
  uuid: "9.0.0",
  "wolfy87-eventemitter": "5.2.9",
  events: "3.3.0",
  inherits: "2.0.4"
}, description = "OpenVidu Browser", devDependencies = {
  "@types/node": "18.11.9",
  "@types/platform": "1.3.4",
  browserify: "17.0.0",
  grunt: "1.5.3",
  "grunt-cli": "1.4.3",
  "grunt-contrib-copy": "1.0.0",
  "grunt-contrib-sass": "2.0.0",
  "grunt-contrib-uglify": "5.2.2",
  "grunt-contrib-watch": "1.1.0",
  "grunt-postcss": "0.9.0",
  "grunt-string-replace": "1.3.3",
  "grunt-ts": "6.0.0-beta.22",
  terser: "5.15.1",
  tsify: "5.0.4",
  tslint: "6.1.3",
  typedoc: "0.23.21",
  typescript: "4.9.3"
}, license = "Apache-2.0", main = "lib/index.js", name$1 = "openvidu-browser", repository = {
  type: "git",
  url: "git://github.com/OpenVidu/openvidu"
}, scripts = {
  browserify: "VERSION=${VERSION:-dev}; mkdir -p static/js/ && cd src && ../node_modules/browserify/bin/cmd.js Main.ts -p [ tsify ] --exclude kurento-browser-extensions --debug -o ../static/js/openvidu-browser-$VERSION.js -v",
  "browserify-prod": "VERSION=${VERSION:-dev}; mkdir -p static/js/ && cd src && ../node_modules/browserify/bin/cmd.js --debug Main.ts -p [ tsify ] --exclude kurento-browser-extensions | ../node_modules/terser/bin/terser --source-map content=inline --output ../static/js/openvidu-browser-$VERSION.min.js",
  build: "cd src/OpenVidu && ./../../node_modules/typescript/bin/tsc && cd ../.. && ./node_modules/typescript/bin/tsc --declaration src/index.ts --outDir ./lib --sourceMap --target es5 --lib dom,es5,es2015.promise,scripthost && rm -rf ./ts4.4 && mkdir -p ./ts4.4/lib && cp -r ./lib ./ts4.4 && find ./ts4.4/lib -type f ! -iname '*.d.ts' -delete && ./config/replace_for_ts44.sh",
  docs: "./generate-docs.sh"
}, types$1 = "lib/index.d.ts", typesVersions = {
  "<4.4": {
    "*": [
      "ts4.4/*"
    ]
  }
}, version$2 = "2.29.1", require$$14 = {
  author,
  dependencies,
  description,
  devDependencies,
  license,
  main,
  name: name$1,
  repository,
  scripts,
  types: types$1,
  typesVersions,
  version: version$2
};
var __awaiter$3 = commonjsGlobal && commonjsGlobal.__awaiter || function(me, ue, Qe, Ue) {
  function He(Ge) {
    return Ge instanceof Qe ? Ge : new Qe(function(Xe) {
      Xe(Ge);
    });
  }
  return new (Qe || (Qe = Promise))(function(Ge, Xe) {
    function Ke(Ze) {
      try {
        Je(Ue.next(Ze));
      } catch (nt) {
        Xe(nt);
      }
    }
    function $e(Ze) {
      try {
        Je(Ue.throw(Ze));
      } catch (nt) {
        Xe(nt);
      }
    }
    function Je(Ze) {
      Ze.done ? Ge(Ze.value) : He(Ze.value).then(Ke, $e);
    }
    Je((Ue = Ue.apply(me, ue || [])).next());
  });
}, __generator$2 = commonjsGlobal && commonjsGlobal.__generator || function(me, ue) {
  var Qe = { label: 0, sent: function() {
    if (Ge[0] & 1) throw Ge[1];
    return Ge[1];
  }, trys: [], ops: [] }, Ue, He, Ge, Xe;
  return Xe = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (Xe[Symbol.iterator] = function() {
    return this;
  }), Xe;
  function Ke(Je) {
    return function(Ze) {
      return $e([Je, Ze]);
    };
  }
  function $e(Je) {
    if (Ue) throw new TypeError("Generator is already executing.");
    for (; Xe && (Xe = 0, Je[0] && (Qe = 0)), Qe; ) try {
      if (Ue = 1, He && (Ge = Je[0] & 2 ? He.return : Je[0] ? He.throw || ((Ge = He.return) && Ge.call(He), 0) : He.next) && !(Ge = Ge.call(He, Je[1])).done) return Ge;
      switch (He = 0, Ge && (Je = [Je[0] & 2, Ge.value]), Je[0]) {
        case 0:
        case 1:
          Ge = Je;
          break;
        case 4:
          return Qe.label++, { value: Je[1], done: !1 };
        case 5:
          Qe.label++, He = Je[1], Je = [0];
          continue;
        case 7:
          Je = Qe.ops.pop(), Qe.trys.pop();
          continue;
        default:
          if (Ge = Qe.trys, !(Ge = Ge.length > 0 && Ge[Ge.length - 1]) && (Je[0] === 6 || Je[0] === 2)) {
            Qe = 0;
            continue;
          }
          if (Je[0] === 3 && (!Ge || Je[1] > Ge[0] && Je[1] < Ge[3])) {
            Qe.label = Je[1];
            break;
          }
          if (Je[0] === 6 && Qe.label < Ge[1]) {
            Qe.label = Ge[1], Ge = Je;
            break;
          }
          if (Ge && Qe.label < Ge[2]) {
            Qe.label = Ge[2], Qe.ops.push(Je);
            break;
          }
          Ge[2] && Qe.ops.pop(), Qe.trys.pop();
          continue;
      }
      Je = ue.call(me, Qe);
    } catch (Ze) {
      Je = [6, Ze], He = 0;
    } finally {
      Ue = Ge = 0;
    }
    if (Je[0] & 5) throw Je[1];
    return { value: Je[0] ? Je[1] : void 0, done: !0 };
  }
};
Object.defineProperty(OpenVidu$1, "__esModule", { value: !0 });
OpenVidu$1.OpenVidu = void 0;
var LocalRecorder_1 = LocalRecorder$1, Publisher_1 = requirePublisher(), Session_1 = requireSession(), SessionDisconnectedEvent_1 = SessionDisconnectedEvent$1, StreamPropertyChangedEvent_1 = StreamPropertyChangedEvent$1, OpenViduError_1 = OpenViduError, VideoInsertMode_1 = VideoInsertMode, OpenViduLogger_1 = OpenViduLogger$1, Platform_1 = Platform, screenSharingAuto = ScreenCapturingAuto, screenSharing = ScreenCapturing, OpenViduLoggerConfiguration_1 = OpenViduLoggerConfiguration, EventEmitter = EventEmitterExports, RpcBuilder = requireKurentoJsonrpc(), packageJson = require$$14, logger = OpenViduLogger_1.OpenViduLogger.getInstance(), platform, OpenVidu = (
  /** @class */
  function() {
    function me() {
      var ue = this;
      this.masterNodeHasCrashed = !1, this.publishers = [], this.secret = "", this.recorder = !1, this.stt = !1, this.life = -1, this.advancedConfiguration = {}, this.webrtcStatsInterval = -1, this.sendBrowserLogs = OpenViduLoggerConfiguration_1.OpenViduLoggerConfiguration.disabled, this.isAtLeastPro = !1, this.isEnterprise = !1, this.ee = new EventEmitter(), platform = Platform_1.PlatformUtils.getInstance(), this.libraryVersion = packageJson.version, logger.info("OpenVidu initialized"), logger.info("Platform detected: " + platform.getDescription()), logger.info("openvidu-browser version: " + this.libraryVersion), (platform.isMobileDevice() || platform.isReactNative()) && this.onOrientationChanged(function() {
        ue.publishers.forEach(function(Qe) {
          Qe.stream.isLocalStreamPublished && Qe.stream && Qe.stream.hasVideo && ue.sendNewVideoDimensionsIfRequired(Qe, "deviceRotated", 75, 10);
        });
      });
    }
    return me.prototype.initSession = function() {
      return this.session = new Session_1.Session(this), this.session;
    }, me.prototype.initPublisher = function(ue, Qe, Ue) {
      var He;
      Qe && typeof Qe != "function" ? (He = Qe, He = {
        audioSource: typeof He.audioSource < "u" ? He.audioSource : void 0,
        frameRate: typeof MediaStreamTrack < "u" && He.videoSource instanceof MediaStreamTrack ? void 0 : typeof He.frameRate < "u" ? He.frameRate : void 0,
        insertMode: typeof He.insertMode < "u" ? typeof He.insertMode == "string" ? VideoInsertMode_1.VideoInsertMode[He.insertMode] : He.insertMode : VideoInsertMode_1.VideoInsertMode.APPEND,
        mirror: typeof He.mirror < "u" ? He.mirror : !0,
        publishAudio: typeof He.publishAudio < "u" ? He.publishAudio : !0,
        publishVideo: typeof He.publishVideo < "u" ? He.publishVideo : !0,
        resolution: typeof MediaStreamTrack < "u" && He.videoSource instanceof MediaStreamTrack ? void 0 : typeof He.resolution < "u" ? He.resolution : "640x480",
        videoSource: typeof He.videoSource < "u" ? He.videoSource : void 0,
        videoSimulcast: He.videoSimulcast,
        filter: He.filter
      }) : He = {
        insertMode: VideoInsertMode_1.VideoInsertMode.APPEND,
        mirror: !0,
        publishAudio: !0,
        publishVideo: !0,
        resolution: "640x480"
      };
      var Ge = new Publisher_1.Publisher(ue, He, this), Xe;
      return Qe && typeof Qe == "function" ? Xe = Qe : Ue && (Xe = Ue), Ge.initialize().then(function() {
        Xe !== void 0 && Xe(void 0), Ge.emitEvent("accessAllowed", []);
      }).catch(function(Ke) {
        Xe !== void 0 && Xe(Ke), Ge.emitEvent("accessDenied", [Ke]);
      }), this.publishers.push(Ge), Ge;
    }, me.prototype.initPublisherAsync = function(ue, Qe) {
      var Ue = this;
      return new Promise(function(He, Ge) {
        var Xe, Ke = function($e) {
          return $e ? Ge($e) : He(Xe);
        };
        Qe ? Xe = Ue.initPublisher(ue, Qe, Ke) : Xe = Ue.initPublisher(ue, Ke);
      });
    }, me.prototype.initLocalRecorder = function(ue) {
      return new LocalRecorder_1.LocalRecorder(ue);
    }, me.prototype.checkSystemRequirements = function() {
      return platform.isIPhoneOrIPad() ? platform.isIOSWithSafari() || platform.isChromeMobileBrowser() || platform.isFirefoxMobileBrowser() || platform.isOperaMobileBrowser() || platform.isEdgeMobileBrowser() || platform.isIonicIos() : platform.isChromeBrowser() || platform.isChromeMobileBrowser() || platform.isFirefoxBrowser() || platform.isFirefoxMobileBrowser() || platform.isOperaBrowser() || platform.isOperaMobileBrowser() || platform.isEdgeBrowser() || platform.isEdgeMobileBrowser() || platform.isSamsungBrowser() || platform.isSafariBrowser() || platform.isAndroidBrowser() || // Android WebView & Ionic apps for Android
      platform.isElectron() || platform.isNodeJs() || // TODO: remove when updating platform detection library
      platform.isMotorolaEdgeDevice();
    }, me.prototype.checkScreenSharingCapabilities = function() {
      return platform.canScreenShare();
    }, me.prototype.getDevices = function() {
      return new Promise(function(ue, Qe) {
        navigator.mediaDevices.enumerateDevices().then(function(Ue) {
          var He, Ge = [];
          if (platform.isIonicAndroid() && typeof cordova < "u" && (!((He = cordova == null ? void 0 : cordova.plugins) === null || He === void 0) && He.EnumerateDevicesPlugin))
            cordova.plugins.EnumerateDevicesPlugin.getEnumerateDevices().then(function(Xe) {
              var Ke = [], $e = [], Je = [];
              return Ke = Xe.filter(function(Ze) {
                return Ze.kind === "audioinput";
              }), $e = Ue.filter(function(Ze) {
                return Ze.kind === "videoinput";
              }), Je = Ue.filter(function(Ze) {
                return Ze.kind === "audioinput";
              }), $e.forEach(function(Ze, nt) {
                if (Ze.label)
                  Ge.push({
                    kind: Ze.kind,
                    deviceId: Ze.deviceId,
                    label: Ze.label
                  });
                else {
                  var tt = "";
                  nt === 0 ? tt = "Front Camera" : nt === 1 ? tt = "Back Camera" : tt = "Unknown Camera", Ge.push({
                    kind: Ze.kind,
                    deviceId: Ze.deviceId,
                    label: tt
                  });
                }
              }), Je.forEach(function(Ze, nt) {
                if (Ze.label)
                  Ge.push({
                    kind: Ze.kind,
                    deviceId: Ze.deviceId,
                    label: Ze.label
                  });
                else {
                  var tt = "";
                  switch (nt) {
                    case 0:
                      tt = "Default";
                      break;
                    case 1:
                      var et = Ke.filter(function(ot) {
                        return ot.label.includes("Built");
                      })[0];
                      tt = et ? et.label : "Built-in Microphone";
                      break;
                    case 2:
                      var rt = Ke.filter(function(ot) {
                        return ot.label.includes("Wired");
                      })[0];
                      rt ? tt = rt.label : tt = "Headset earpiece";
                      break;
                    case 3:
                      var it = Ke.filter(function(ot) {
                        return ot.label.includes("Bluetooth");
                      })[0];
                      tt = it ? it.label : "Wireless";
                      break;
                    default:
                      tt = "Unknown Microphone";
                      break;
                  }
                  Ge.push({
                    kind: Ze.kind,
                    deviceId: Ze.deviceId,
                    label: tt
                  });
                }
              }), ue(Ge);
            });
          else
            return Ue.forEach(function(Xe) {
              (Xe.kind === "audioinput" || Xe.kind === "videoinput") && Ge.push({
                kind: Xe.kind,
                deviceId: Xe.deviceId,
                label: Xe.label
              });
            }), ue(Ge);
        }).catch(function(Ue) {
          return logger.error("Error getting devices", Ue), Qe(Ue);
        });
      });
    }, me.prototype.getUserMedia = function(ue) {
      var Qe, Ue;
      return __awaiter$3(this, void 0, void 0, function() {
        var He, Ge, Xe, Je, Ke, nt, tt, $e, Je, Ze, nt, tt, et, rt = this;
        return __generator$2(this, function(it) {
          switch (it.label) {
            case 0:
              He = function(ot, at) {
                return __awaiter$3(rt, void 0, void 0, function() {
                  var st, ut, lt, dt;
                  return __generator$2(this, function(At) {
                    switch (At.label) {
                      case 0:
                        st = at.audio === void 0 ? !0 : at.audio, ut = { audio: st, video: !1 }, At.label = 1;
                      case 1:
                        return At.trys.push([1, 3, , 4]), [4, navigator.mediaDevices.getUserMedia(ut)];
                      case 2:
                        return lt = At.sent(), ot.addTrack(lt.getAudioTracks()[0]), [2, ot];
                      case 3:
                        throw dt = At.sent(), ot.getAudioTracks().forEach(function(pt) {
                          pt.stop();
                        }), ot.getVideoTracks().forEach(function(pt) {
                          pt.stop();
                        }), this.generateAudioDeviceError(dt, ut);
                      case 4:
                        return [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              }, it.label = 1;
            case 1:
              return it.trys.push([1, 20, , 21]), [4, this.generateMediaConstraints(ue)];
            case 2:
              return Ge = it.sent(), Ge.videoTrack && Ge.audioTrack || Ge.audioTrack && ((Qe = Ge.constraints) === null || Qe === void 0 ? void 0 : Qe.video) === !1 || Ge.videoTrack && ((Ue = Ge.constraints) === null || Ue === void 0 ? void 0 : Ue.audio) === !1 ? [2, this.addAlreadyProvidedTracks(Ge, new MediaStream())] : [3, 3];
            case 3:
              if (Ge.videoTrack && delete Ge.constraints.video, Ge.audioTrack && delete Ge.constraints.audio, Xe = !1, typeof ue.videoSource != "string") return [3, 12];
              if (!(ue.videoSource === "screen" || ue.videoSource === "window" || platform.isElectron() && ue.videoSource.startsWith("screen:"))) return [3, 12];
              if (Xe = !Ge.audioTrack && ue.audioSource !== null && ue.audioSource !== !1, !(navigator.mediaDevices.getDisplayMedia && !platform.isElectron())) return [3, 11];
              it.label = 4;
            case 4:
              return it.trys.push([4, 9, , 10]), [4, navigator.mediaDevices.getDisplayMedia({ video: !0, audio: ue.audioSource === "screen" })];
            case 5:
              return Je = it.sent(), this.addAlreadyProvidedTracks(Ge, Je), Xe ? [4, He(Je, Ge.constraints)] : [3, 7];
            case 6:
              return [2, it.sent()];
            case 7:
              return [2, Je];
            case 8:
              return [3, 10];
            case 9:
              throw Ke = it.sent(), nt = OpenViduError_1.OpenViduErrorName.SCREEN_CAPTURE_DENIED, tt = Ke.toString(), new OpenViduError_1.OpenViduError(nt, tt);
            case 10:
              return [3, 11];
            case 11:
              return [3, 12];
            case 12:
              $e = Xe ? { video: Ge.constraints.video } : Ge.constraints, it.label = 13;
            case 13:
              return it.trys.push([13, 18, , 19]), [4, navigator.mediaDevices.getUserMedia($e)];
            case 14:
              return Je = it.sent(), this.addAlreadyProvidedTracks(Ge, Je), Xe ? [4, He(Je, Ge.constraints)] : [3, 16];
            case 15:
              return [2, it.sent()];
            case 16:
              return [2, Je];
            case 17:
              return [3, 19];
            case 18:
              throw Ze = it.sent(), nt = void 0, tt = Ze.toString(), ue.videoSource !== "screen" ? nt = OpenViduError_1.OpenViduErrorName.DEVICE_ACCESS_DENIED : nt = OpenViduError_1.OpenViduErrorName.SCREEN_CAPTURE_DENIED, new OpenViduError_1.OpenViduError(nt, tt);
            case 19:
              return [3, 21];
            case 20:
              throw et = it.sent(), et;
            case 21:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, me.prototype.enableProdMode = function() {
      logger.enableProdMode();
    }, me.prototype.setAdvancedConfiguration = function(ue) {
      this.advancedConfiguration = ue;
    }, me.prototype.onOrientationChanged = function(ue) {
      globalThis.addEventListener("orientationchange", ue);
    }, me.prototype.sendNewVideoDimensionsIfRequired = function(ue, Qe, Ue, He) {
      var Ge = this, Xe, Ke, $e, Je, Ze = 0, nt = ((Ke = (Xe = ue == null ? void 0 : ue.stream) === null || Xe === void 0 ? void 0 : Xe.videoDimensions) === null || Ke === void 0 ? void 0 : Ke.width) || 0, tt = ((Je = ($e = ue == null ? void 0 : ue.stream) === null || $e === void 0 ? void 0 : $e.videoDimensions) === null || Je === void 0 ? void 0 : Je.height) || 0, et = setInterval(function() {
        Ze++, Ze > He && clearTimeout(et), ue.getVideoDimensions().then(function(rt) {
          (rt.width !== nt || rt.height !== tt) && (clearTimeout(et), Ge.sendVideoDimensionsChangedEvent(ue, Qe, nt, tt, rt.width, rt.height));
        });
      }, Ue);
    }, me.prototype.sendVideoDimensionsChangedEvent = function(ue, Qe, Ue, He, Ge, Xe) {
      var Ke = this;
      ue.stream.videoDimensions = {
        width: Ge || 0,
        height: Xe || 0
      }, this.sendRequest("streamPropertyChanged", {
        streamId: ue.stream.streamId,
        property: "videoDimensions",
        newValue: JSON.stringify(ue.stream.videoDimensions),
        reason: Qe
      }, function($e, Je) {
        $e ? logger.error("Error sending 'streamPropertyChanged' event", $e) : (Ke.session.emitEvent("streamPropertyChanged", [
          new StreamPropertyChangedEvent_1.StreamPropertyChangedEvent(Ke.session, ue.stream, "videoDimensions", ue.stream.videoDimensions, { width: Ue, height: He }, Qe)
        ]), ue.emitEvent("streamPropertyChanged", [
          new StreamPropertyChangedEvent_1.StreamPropertyChangedEvent(ue, ue.stream, "videoDimensions", ue.stream.videoDimensions, { width: Ue, height: He }, Qe)
        ]), Ke.session.sendVideoData(ue));
      });
    }, me.prototype.sendTrackChangedEvent = function(ue, Qe, Ue, He) {
      var Ge = this, Xe = { label: Qe }, Ke = { label: Ue }, $e = "trackReplaced";
      ue.stream.isLocalStreamPublished ? this.sendRequest("streamPropertyChanged", {
        streamId: ue.stream.streamId,
        property: He,
        newValue: Ke,
        reason: $e
      }, function(Je, Ze) {
        Je ? logger.error("Error sending 'streamPropertyChanged' event", Je) : (Ge.session.emitEvent("streamPropertyChanged", [
          new StreamPropertyChangedEvent_1.StreamPropertyChangedEvent(Ge.session, ue.stream, He, Ke, Xe, $e)
        ]), ue.emitEvent("streamPropertyChanged", [
          new StreamPropertyChangedEvent_1.StreamPropertyChangedEvent(ue, ue.stream, He, Ke, Xe, $e)
        ]));
      }) : (this.session.emitEvent("streamPropertyChanged", [
        new StreamPropertyChangedEvent_1.StreamPropertyChangedEvent(this.session, ue.stream, He, Ke, Xe, $e)
      ]), ue.emitEvent("streamPropertyChanged", [
        new StreamPropertyChangedEvent_1.StreamPropertyChangedEvent(ue, ue.stream, He, Ke, Xe, $e)
      ]));
    }, me.prototype.generateMediaConstraints = function(ue) {
      var Qe = this;
      return new Promise(function(Ue, He) {
        var Ge = {
          audioTrack: void 0,
          videoTrack: void 0,
          constraints: {
            audio: void 0,
            video: void 0
          }
        }, Xe = ue.audioSource, Ke = ue.videoSource;
        if ((Xe === null || Xe === !1) && (Ge.constraints.audio = !1), (Ke === null || Ke === !1) && (Ge.constraints.video = !1), Ge.constraints.audio === !1 && Ge.constraints.video === !1)
          return He(new OpenViduError_1.OpenViduError(OpenViduError_1.OpenViduErrorName.NO_INPUT_SOURCE_SET, "Properties 'audioSource' and 'videoSource' cannot be set to false or null at the same time"));
        if (typeof MediaStreamTrack < "u" && Xe instanceof MediaStreamTrack && (Ge.audioTrack = Xe), typeof MediaStreamTrack < "u" && Ke instanceof MediaStreamTrack && (Ge.videoTrack = Ke), Xe === void 0 && (Ge.constraints.audio = !0), Ke === void 0 && (Ge.constraints.video = {
          width: {
            ideal: 640
          },
          height: {
            ideal: 480
          }
        }), Ke !== null && Ke !== !1) {
          if (ue.resolution) {
            var $e = ue.resolution.toLowerCase().split("x"), Je = Number($e[0]), Ze = Number($e[1]);
            Ge.constraints.video = {
              width: {
                ideal: Je
              },
              height: {
                ideal: Ze
              }
            };
          }
          ue.frameRate && (Ge.constraints.video.frameRate = { ideal: ue.frameRate });
        }
        return Qe.configureDeviceIdOrScreensharing(Ge, ue, Ue, He), Ue(Ge);
      });
    }, me.prototype.startWs = function(ue) {
      var Qe = {
        heartbeat: 5e3,
        ws: {
          uri: this.wsUri + "?sessionId=" + this.session.sessionId,
          onconnected: ue,
          ondisconnect: this.disconnectCallback.bind(this),
          onreconnecting: this.reconnectingCallback.bind(this),
          onreconnected: this.reconnectedCallback.bind(this),
          ismasternodecrashed: this.isMasterNodeCrashed.bind(this)
        },
        rpc: {
          requestTimeout: 1e4,
          heartbeatRequestTimeout: 5e3,
          participantJoined: this.session.onParticipantJoined.bind(this.session),
          participantPublished: this.session.onParticipantPublished.bind(this.session),
          participantUnpublished: this.session.onParticipantUnpublished.bind(this.session),
          participantLeft: this.session.onParticipantLeft.bind(this.session),
          participantEvicted: this.session.onParticipantEvicted.bind(this.session),
          recordingStarted: this.session.onRecordingStarted.bind(this.session),
          recordingStopped: this.session.onRecordingStopped.bind(this.session),
          broadcastStarted: this.session.onBroadcastStarted.bind(this.session),
          broadcastStopped: this.session.onBroadcastStopped.bind(this.session),
          sendMessage: this.session.onNewMessage.bind(this.session),
          streamPropertyChanged: this.session.onStreamPropertyChanged.bind(this.session),
          connectionPropertyChanged: this.session.onConnectionPropertyChanged.bind(this.session),
          networkQualityLevelChanged: this.session.onNetworkQualityLevelChangedChanged.bind(this.session),
          filterEventDispatched: this.session.onFilterEventDispatched.bind(this.session),
          iceCandidate: this.session.recvIceCandidate.bind(this.session),
          mediaError: this.session.onMediaError.bind(this.session),
          masterNodeCrashedNotification: this.onMasterNodeCrashedNotification.bind(this),
          forciblyReconnectSubscriber: this.session.onForciblyReconnectSubscriber.bind(this.session),
          speechToTextMessage: this.session.onSpeechToTextMessage.bind(this.session),
          speechToTextDisconnected: this.session.onSpeechToTextDisconnected.bind(this.session)
        }
      };
      this.jsonRpcClient = new RpcBuilder.clients.JsonRpcClient(Qe);
    }, me.prototype.onMasterNodeCrashedNotification = function(ue) {
      console.error("Master Node has crashed"), this.masterNodeHasCrashed = !0, this.session.onLostConnection("nodeCrashed"), this.jsonRpcClient.close(4103, "Master Node has crashed");
    }, me.prototype.getWsReadyState = function() {
      return this.jsonRpcClient.getReadyState();
    }, me.prototype.closeWs = function() {
      this.jsonRpcClient.close(4102, "Connection closed by client");
    }, me.prototype.sendRequest = function(ue, Qe, Ue) {
      var He;
      Qe && Qe instanceof Function && (Ue = Qe, Qe = {}), logger.debug('Sending request: {method:"' + ue + '", params: ' + JSON.stringify(Qe) + "}"), (He = this.jsonRpcClient) === null || He === void 0 || He.send(ue, Qe, Ue);
    }, me.prototype.getWsUri = function() {
      return this.wsUri;
    }, me.prototype.getSecret = function() {
      return this.secret;
    }, me.prototype.getRecorder = function() {
      return this.recorder;
    }, me.prototype.getStt = function() {
      return this.stt;
    }, me.prototype.generateAudioDeviceError = function(ue, Qe) {
      ue.name === "Error" && (ue.name = ue.constructor.name);
      var Ue, He;
      switch (ue.name.toLowerCase()) {
        case "notfounderror":
          return Ue = OpenViduError_1.OpenViduErrorName.INPUT_AUDIO_DEVICE_NOT_FOUND, He = ue.toString(), new OpenViduError_1.OpenViduError(Ue, He);
        case "notallowederror":
          return Ue = OpenViduError_1.OpenViduErrorName.DEVICE_ACCESS_DENIED, He = ue.toString(), new OpenViduError_1.OpenViduError(Ue, He);
        case "overconstrainederror":
          return ue.constraint.toLowerCase() === "deviceid" ? (Ue = OpenViduError_1.OpenViduErrorName.INPUT_AUDIO_DEVICE_NOT_FOUND, He = "Audio input device with deviceId '" + Qe.audio.deviceId.exact + "' not found") : (Ue = OpenViduError_1.OpenViduErrorName.PUBLISHER_PROPERTIES_ERROR, He = "Audio input device doesn't support the value passed for constraint '" + ue.constraint + "'"), new OpenViduError_1.OpenViduError(Ue, He);
        case "notreadableerror":
          return Ue = OpenViduError_1.OpenViduErrorName.DEVICE_ALREADY_IN_USE, He = ue.toString(), new OpenViduError_1.OpenViduError(Ue, He);
        default:
          return new OpenViduError_1.OpenViduError(OpenViduError_1.OpenViduErrorName.INPUT_AUDIO_DEVICE_GENERIC_ERROR, ue.toString());
      }
    }, me.prototype.addAlreadyProvidedTracks = function(ue, Qe, Ue) {
      return ue.videoTrack && (Qe.addTrack(ue.videoTrack), Ue && (ue.constraints.video ? Ue.lastVideoTrackConstraints = ue.constraints.video : Ue.lastVideoTrackConstraints = ue.videoTrack.getConstraints())), ue.audioTrack && Qe.addTrack(ue.audioTrack), Qe;
    }, me.prototype.configureDeviceIdOrScreensharing = function(ue, Qe, Ue, He) {
      var Ge = this, Xe = Qe.audioSource, Ke = Qe.videoSource;
      if (typeof Xe == "string" && Xe !== "screen" && (ue.constraints.audio = { deviceId: { exact: Xe } }), typeof Ke == "string")
        if (!this.isScreenShare(Ke))
          this.setVideoSource(ue, Ke), Xe === "screen" && (logger.warn('Parameter "audioSource" is set to "screen", which means rquesting audio from screen sharing source. But "videoSource" is not set to "screen". No audio source will be requested'), ue.constraints.audio = !1);
        else if (this.checkScreenSharingCapabilities())
          if (platform.isElectron()) {
            var Je = "screen:", Ze = Ke, nt = Ze.substr(Ze.indexOf(Je) + Je.length);
            return ue.constraints.video = {
              mandatory: {
                chromeMediaSource: "desktop",
                chromeMediaSourceId: nt
              }
            }, Ue(ue);
          } else if (this.advancedConfiguration.screenShareChromeExtension && !(platform.isFirefoxBrowser() || platform.isFirefoxMobileBrowser()) && !navigator.mediaDevices.getDisplayMedia) {
            screenSharing.getScreenConstraints(function(et, rt) {
              if (et || rt.mandatory && rt.mandatory.chromeMediaSource === "screen")
                if (et === "permission-denied" || et === "PermissionDeniedError") {
                  var it = new OpenViduError_1.OpenViduError(OpenViduError_1.OpenViduErrorName.SCREEN_CAPTURE_DENIED, "You must allow access to one window of your desktop");
                  return logger.error(it), He(it);
                } else {
                  var ot = Ge.advancedConfiguration.screenShareChromeExtension.split("/").pop().trim();
                  screenSharing.getChromeExtensionStatus(ot, function(at) {
                    if (at === "installed-disabled") {
                      var st = new OpenViduError_1.OpenViduError(OpenViduError_1.OpenViduErrorName.SCREEN_EXTENSION_DISABLED, "You must enable the screen extension");
                      return logger.error(st), He(st);
                    }
                    if (at === "not-installed") {
                      var ut = new OpenViduError_1.OpenViduError(OpenViduError_1.OpenViduErrorName.SCREEN_EXTENSION_NOT_INSTALLED, Ge.advancedConfiguration.screenShareChromeExtension);
                      return logger.error(ut), He(ut);
                    }
                  });
                  return;
                }
              else
                return ue.constraints.video = rt, Ue(ue);
            });
            return;
          } else {
            if (navigator.mediaDevices.getDisplayMedia)
              return Ue(ue);
            var tt = platform.isFirefoxBrowser() || platform.isFirefoxMobileBrowser() ? Qe.videoSource : void 0;
            screenSharingAuto.getScreenId(tt, function(et, rt, it) {
              if (et)
                if (et === "not-installed") {
                  var ot = Ge.advancedConfiguration.screenShareChromeExtension ? Ge.advancedConfiguration.screenShareChromeExtension : "https://chrome.google.com/webstore/detail/openvidu-screensharing/lfcgfepafnobdloecchnfaclibenjold", at = new OpenViduError_1.OpenViduError(OpenViduError_1.OpenViduErrorName.SCREEN_EXTENSION_NOT_INSTALLED, ot);
                  return logger.error(at), He(at);
                } else if (et === "installed-disabled") {
                  var at = new OpenViduError_1.OpenViduError(OpenViduError_1.OpenViduErrorName.SCREEN_EXTENSION_DISABLED, "You must enable the screen extension");
                  return logger.error(at), He(at);
                } else if (et === "permission-denied") {
                  var at = new OpenViduError_1.OpenViduError(OpenViduError_1.OpenViduErrorName.SCREEN_CAPTURE_DENIED, "You must allow access to one window of your desktop");
                  return logger.error(at), He(at);
                } else {
                  var at = new OpenViduError_1.OpenViduError(OpenViduError_1.OpenViduErrorName.GENERIC_ERROR, "Unknown error when accessing screen share");
                  return logger.error(at), logger.error(et), He(at);
                }
              else
                return ue.constraints.video = it.video, Ue(ue);
            });
            return;
          }
        else {
          var $e = new OpenViduError_1.OpenViduError(OpenViduError_1.OpenViduErrorName.SCREEN_SHARING_NOT_SUPPORTED, "You can only screen share in desktop Chrome, Firefox, Opera, Safari (>=13.0), Edge (>= 80) or Electron. Detected client: " + platform.getName() + " " + platform.getVersion());
          return logger.error($e), He($e);
        }
    }, me.prototype.setVideoSource = function(ue, Qe) {
      ue.constraints.video || (ue.constraints.video = {}), ue.constraints.video.deviceId = { exact: Qe };
    }, me.prototype.disconnectCallback = function() {
      logger.warn("Websocket connection lost"), this.isRoomAvailable() ? this.session.onLostConnection("networkDisconnect") : alert("Connection error. Please reload page.");
    }, me.prototype.reconnectingCallback = function() {
      logger.warn("Websocket connection lost (reconnecting)"), this.isRoomAvailable() ? this.session.emitEvent("reconnecting", []) : alert("Connection error. Please reload page.");
    }, me.prototype.reconnectWebsocketThroughRpcConnectMethod = function(ue) {
      var Qe = this;
      this.sendRequest("connect", { sessionId: ue, reconnect: !0 }, function(Ue, He) {
        if (Ue)
          if (Qe.isMasterNodeCrashed())
            logger.warn("Master Node has crashed!");
          else {
            logger.error(Ue);
            var Ge = function(Ke, $e) {
              logger.warn($e), Qe.session.onLostConnection(Ke), Qe.jsonRpcClient.close(4101, "Reconnection fault: " + $e);
            }, Xe = function() {
              Qe.life === -1 ? Ge("networkDisconnect", "WS successfully reconnected but the user was already evicted due to timeout") : Qe.sendRequest("sessionStatus", { sessionId: Qe.session.sessionId }, function(Ke, $e) {
                Ke != null ? console.error("Error checking session status", Ke) : Qe.life === $e.life ? Ge("networkDisconnect", "WS successfully reconnected but the user was already evicted due to timeout") : Ge("nodeCrashed", "WS successfully reconnected to OpenVidu Server but your Master Node crashed");
              });
            };
            Ue.code === 40007 && Ue.message === "reconnection error" && console.error("Invalid RPC sessionId. Client network disconnection or Master Node crash"), Xe();
          }
        else
          Qe.jsonRpcClient.resetPing(), Qe.session.onRecoveredConnection();
      });
    }, me.prototype.reconnectedCallback = function() {
      if (logger.warn("Websocket reconnected"), this.isRoomAvailable())
        if (this.session.connection)
          this.reconnectWebsocketThroughRpcConnectMethod(this.session.connection.rpcSessionId);
        else {
          logger.warn("There was no previous connection when running reconnection callback");
          var ue = new SessionDisconnectedEvent_1.SessionDisconnectedEvent(this.session, "networkDisconnect");
          this.session.ee.emitEvent("sessionDisconnected", [ue]), ue.callDefaultBehavior();
        }
      else
        alert("Connection error. Please reload page.");
    }, me.prototype.isMasterNodeCrashed = function() {
      return this.masterNodeHasCrashed;
    }, me.prototype.isRoomAvailable = function() {
      return this.session !== void 0 && this.session instanceof Session_1.Session ? !0 : (logger.warn("Session instance not found"), !1);
    }, me.prototype.isScreenShare = function(ue) {
      return ue === "screen" || ue === "window" || platform.isElectron() && ue.startsWith("screen:");
    }, me;
  }()
);
OpenVidu$1.OpenVidu = OpenVidu;
var Types = {};
Object.defineProperty(Types, "__esModule", { value: !0 });
(function(me) {
  var ue = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(Et, bt, Rt, St) {
    St === void 0 && (St = Rt);
    var kt = Object.getOwnPropertyDescriptor(bt, Rt);
    (!kt || ("get" in kt ? !bt.__esModule : kt.writable || kt.configurable)) && (kt = { enumerable: !0, get: function() {
      return bt[Rt];
    } }), Object.defineProperty(Et, St, kt);
  } : function(Et, bt, Rt, St) {
    St === void 0 && (St = Rt), Et[St] = bt[Rt];
  }), Qe = commonjsGlobal && commonjsGlobal.__exportStar || function(Et, bt) {
    for (var Rt in Et) Rt !== "default" && !Object.prototype.hasOwnProperty.call(bt, Rt) && ue(bt, Et, Rt);
  };
  Object.defineProperty(me, "__esModule", { value: !0 }), me.EventDispatcher = me.ExceptionEventName = me.ExceptionEvent = me.SpeechToTextEvent = me.NetworkQualityLevelChangedEvent = me.FilterEvent = me.ConnectionPropertyChangedEvent = me.StreamPropertyChangedEvent = me.VideoElementEvent = me.StreamManagerEvent = me.StreamEvent = me.SignalEvent = me.SessionDisconnectedEvent = me.RecordingEvent = me.PublisherSpeakingEvent = me.ConnectionEvent = me.Event = me.VideoInsertMode = me.TypeOfVideo = me.OpenViduErrorName = me.OpenViduError = me.LocalRecorderState = me.Filter = me.LocalRecorder = me.Connection = me.Stream = me.StreamManager = me.Subscriber = me.Publisher = me.Session = me.OpenVidu = void 0;
  var Ue = jsnlog, He = OpenVidu$1;
  Object.defineProperty(me, "OpenVidu", { enumerable: !0, get: function() {
    return He.OpenVidu;
  } });
  var Ge = requireSession();
  Object.defineProperty(me, "Session", { enumerable: !0, get: function() {
    return Ge.Session;
  } });
  var Xe = requirePublisher();
  Object.defineProperty(me, "Publisher", { enumerable: !0, get: function() {
    return Xe.Publisher;
  } });
  var Ke = Subscriber$1;
  Object.defineProperty(me, "Subscriber", { enumerable: !0, get: function() {
    return Ke.Subscriber;
  } });
  var $e = StreamManager$1;
  Object.defineProperty(me, "StreamManager", { enumerable: !0, get: function() {
    return $e.StreamManager;
  } });
  var Je = Stream$2;
  Object.defineProperty(me, "Stream", { enumerable: !0, get: function() {
    return Je.Stream;
  } });
  var Ze = Connection$1;
  Object.defineProperty(me, "Connection", { enumerable: !0, get: function() {
    return Ze.Connection;
  } });
  var nt = LocalRecorder$1;
  Object.defineProperty(me, "LocalRecorder", { enumerable: !0, get: function() {
    return nt.LocalRecorder;
  } });
  var tt = Filter$1;
  Object.defineProperty(me, "Filter", { enumerable: !0, get: function() {
    return tt.Filter;
  } });
  var et = LocalRecorderState;
  Object.defineProperty(me, "LocalRecorderState", { enumerable: !0, get: function() {
    return et.LocalRecorderState;
  } });
  var rt = OpenViduError;
  Object.defineProperty(me, "OpenViduError", { enumerable: !0, get: function() {
    return rt.OpenViduError;
  } }), Object.defineProperty(me, "OpenViduErrorName", { enumerable: !0, get: function() {
    return rt.OpenViduErrorName;
  } });
  var it = TypeOfVideo;
  Object.defineProperty(me, "TypeOfVideo", { enumerable: !0, get: function() {
    return it.TypeOfVideo;
  } });
  var ot = VideoInsertMode;
  Object.defineProperty(me, "VideoInsertMode", { enumerable: !0, get: function() {
    return ot.VideoInsertMode;
  } });
  var at = Event$2;
  Object.defineProperty(me, "Event", { enumerable: !0, get: function() {
    return at.Event;
  } });
  var st = ConnectionEvent$1;
  Object.defineProperty(me, "ConnectionEvent", { enumerable: !0, get: function() {
    return st.ConnectionEvent;
  } });
  var ut = PublisherSpeakingEvent$1;
  Object.defineProperty(me, "PublisherSpeakingEvent", { enumerable: !0, get: function() {
    return ut.PublisherSpeakingEvent;
  } });
  var lt = RecordingEvent$1;
  Object.defineProperty(me, "RecordingEvent", { enumerable: !0, get: function() {
    return lt.RecordingEvent;
  } });
  var dt = SessionDisconnectedEvent$1;
  Object.defineProperty(me, "SessionDisconnectedEvent", { enumerable: !0, get: function() {
    return dt.SessionDisconnectedEvent;
  } });
  var At = SignalEvent$1;
  Object.defineProperty(me, "SignalEvent", { enumerable: !0, get: function() {
    return At.SignalEvent;
  } });
  var pt = requireStreamEvent();
  Object.defineProperty(me, "StreamEvent", { enumerable: !0, get: function() {
    return pt.StreamEvent;
  } });
  var gt = StreamManagerEvent$1;
  Object.defineProperty(me, "StreamManagerEvent", { enumerable: !0, get: function() {
    return gt.StreamManagerEvent;
  } });
  var wt = VideoElementEvent$1;
  Object.defineProperty(me, "VideoElementEvent", { enumerable: !0, get: function() {
    return wt.VideoElementEvent;
  } });
  var Bt = StreamPropertyChangedEvent$1;
  Object.defineProperty(me, "StreamPropertyChangedEvent", { enumerable: !0, get: function() {
    return Bt.StreamPropertyChangedEvent;
  } });
  var Tt = ConnectionPropertyChangedEvent$1;
  Object.defineProperty(me, "ConnectionPropertyChangedEvent", { enumerable: !0, get: function() {
    return Tt.ConnectionPropertyChangedEvent;
  } });
  var yt = FilterEvent$1;
  Object.defineProperty(me, "FilterEvent", { enumerable: !0, get: function() {
    return yt.FilterEvent;
  } });
  var Ct = NetworkQualityLevelChangedEvent$1;
  Object.defineProperty(me, "NetworkQualityLevelChangedEvent", { enumerable: !0, get: function() {
    return Ct.NetworkQualityLevelChangedEvent;
  } });
  var ht = SpeechToTextEvent$1;
  Object.defineProperty(me, "SpeechToTextEvent", { enumerable: !0, get: function() {
    return ht.SpeechToTextEvent;
  } });
  var It = ExceptionEvent;
  Object.defineProperty(me, "ExceptionEvent", { enumerable: !0, get: function() {
    return It.ExceptionEvent;
  } }), Object.defineProperty(me, "ExceptionEventName", { enumerable: !0, get: function() {
    return It.ExceptionEventName;
  } });
  var vt = EventDispatcher$1;
  Object.defineProperty(me, "EventDispatcher", { enumerable: !0, get: function() {
    return vt.EventDispatcher;
  } }), Qe(Types, me), Ue.JL.setOptions({ enabled: !1 });
})(lib$1);
let tokboxApiKey;
function setTokboxApiKey(me) {
  tokboxApiKey = me;
}
const createRecordingSession = async (me, ue, Qe = "openVidu") => {
  const Ue = Qe === "openVidu" ? "/omni/recordings/create-session/v2" : "/omni/recordings/create-session";
  return (await api.post(
    Ue,
    {
      type: me
    },
    {
      headers: {
        "X-Incode-Hardware-Id": ue
      }
    }
  )).data;
}, startRecording = async (me, ue, Qe = "openVidu", Ue, He, Ge = !1) => {
  const Xe = Qe === "openVidu" ? "/omni/recordings/record-start/v2" : "/omni/recordings/record-start";
  return (await api.post(
    Xe,
    {
      videoRecordingId: me,
      frameRate: 10,
      outputMode: "COMPOSED",
      resolution: He,
      type: Ue,
      hasAudio: Ge
    },
    {
      headers: {
        "X-Incode-Hardware-Id": ue
      }
    }
  )).data;
}, stopRecording = async (me, ue, Qe = "openVidu") => {
  const Ue = Qe === "openVidu" ? "/omni/recordings/record-stop/v2" : "/omni/recordings/record-stop";
  return (await api.post(
    Ue,
    {
      videoRecordingId: me
    },
    {
      headers: {
        "X-Incode-Hardware-Id": ue
      }
    }
  )).data;
}, randomId = Math.random().toString(36).substring(7);
function createElement$1() {
  if (document.getElementById(randomId)) return;
  const me = document.createElement("div");
  me.style.display = "none", me.id = randomId, document.body.appendChild(me);
}
const openViduInitPublisher = async ({
  stream: me,
  type: ue,
  token: Qe
}) => {
  const Ue = new lib$1.OpenVidu(), He = Ue.initSession(), Ge = me.getVideoTracks()[0].getSettings(), Xe = await createRecordingSession(
    ue,
    Qe,
    "openVidu"
  );
  createElement$1(), await He.connect(Xe.token);
  const Ke = me.getAudioTracks().length > 0, $e = Ue.initPublisher(randomId, {
    publishAudio: Ke,
    audioSource: Ke ? me.getAudioTracks()[0] : null,
    videoSource: me.getVideoTracks()[0],
    frameRate: 10
  });
  return He.publish($e), await startRecording(
    Xe.videoRecordingId,
    Qe,
    "openVidu",
    ue,
    `${Ge.width}x${Ge.height}`,
    Ke
  ), Xe;
}, createOpenTokSessionAsync = ({
  recordingSession: me,
  stream: ue
}) => new Promise((Qe, Ue) => {
  const { session: He } = createSession$4({
    apiKey: tokboxApiKey,
    sessionId: me.sessionId,
    token: me.token,
    async onConnect() {
      const Ge = OT.initPublisher(randomId, {
        publishAudio: !1,
        audioSource: null,
        videoSource: ue.getVideoTracks()[0],
        frameRate: 30
      });
      He.publish(Ge, (Xe) => {
        Xe && (console.error("Error publishing:", Xe), Ue(Xe)), Qe();
      });
    }
  });
}), openTokInitPublisher = async ({
  stream: me,
  type: ue,
  token: Qe
}) => {
  const Ue = await createRecordingSession(ue, Qe, "openTok");
  return await createOpenTokSessionAsync({
    recordingSession: Ue,
    stream: me
  }), await startRecording(Ue.videoRecordingId, Qe, "openTok"), Ue;
};
function useMediaRecorder({ token: me, type: ue }) {
  const Qe = useRef(null), [Ue, He] = useState(!1), { recorderProvider: Ge } = options, Xe = async ($e) => {
    try {
      if (Ge === "openVidu") {
        const Je = await openViduInitPublisher({
          stream: $e,
          type: ue,
          token: me
        });
        Qe.current = Je;
      } else {
        const Je = await openTokInitPublisher({
          stream: $e,
          type: ue,
          token: me
        });
        Qe.current = Je;
      }
      He(!0);
    } catch (Je) {
      console.error(Je);
    }
  }, Ke = useCallback(async () => {
    Qe.current && (await stopRecording(
      Qe.current.videoRecordingId,
      me,
      Ge
    ), addEvent({
      code: getScreenRecordingEventCode(ue),
      token: me
    }), Qe.current = null, He(!1));
  }, [me, Ge, ue]);
  return { startRecording: Xe, stopRecording: Ke, recordingStarted: Ue };
}
const getCircleText = (me, ue, Qe) => ({
  uploading: me(`notifications.${Qe ? "verifying" : "uploading"}`),
  success: me("notifications.done"),
  error: ue
});
function CaptureSelfie({
  onError: me,
  onSuccess: ue,
  permission: Qe,
  setPermission: Ue,
  permissionMessage: He,
  permissionBackgroundColor: Ge,
  onLog: Xe,
  token: Ke,
  timeout: $e,
  numberOfTries: Je,
  showPreview: Ze,
  stream: nt,
  onlyCapture: tt,
  showCustomCameraPermissionScreen: et,
  isSecondId: rt,
  assistedOnboarding: it,
  isRecordingEnabled: ot = !1,
  showDoublePermissionsRequest: at,
  onRestartOnboarding: st,
  skipProcessFace: ut = !1,
  isKiosk: lt = !1,
  ageAssurance: dt = !1,
  publishAudio: At = !1
}) {
  var mn;
  const pt = Ke ? Ke == null ? void 0 : Ke.token : (mn = state.token) == null ? void 0 : mn.token, gt = useRef(null), wt = useRef(!1), [Bt, Tt] = useState(null), [yt, Ct] = useState({}), [ht, It] = useState(1), { startRecording: vt, stopRecording: Et, recordingStarted: bt } = useMediaRecorder({
    token: pt,
    type: "selfie",
    screen: "selfie"
  });
  useEffect(() => () => Et(), []);
  const Rt = throttle$1(async (En, Jt) => {
    var cn;
    const an = En.getBase64Image();
    try {
      if (_t !== "idle") return;
      addScreenEvent({
        module: eventModuleNames.selfie,
        screen: eventScreenNames.faceCaptureCamera,
        token: pt,
        shouldOpen: !0
      }), clearTimeout(un.current), Tt(an), addEvent({
        code: "selfieCapture",
        token: pt
      }), await OnboardingAnalytics$1.analyzeFrame(an), MlWasmJSApi$1.resetAllPipelines();
      const dn = await MlWasmJSApi$1.encryptImage(an), { blob: yn, url: Nn } = En.getBlobData();
      if (tt)
        return ue({ imageBase64: an, blob: yn, encryptedImage: dn, url: Nn });
      addScreenEvent({
        module: eventModuleNames.selfie,
        screen: eventScreenNames.faceCaptureCamera,
        token: pt,
        shouldOpen: !1
      }), addScreenEvent({
        module: eventModuleNames.selfie,
        screen: eventScreenNames.faceCaptureUpload,
        token: pt,
        shouldOpen: !0
      }), addEvent({
        token: pt,
        code: "captureAttemptFinished",
        module: "selfieCapture",
        payload: {
          logs: OnboardingAnalytics$1.getPipelineLogs()
        }
      }), addDeviceStats(pt, {
        inspectorOpened: null,
        frontIdStatsAnalysisStatus: "",
        backIdStatsAnalysisStatus: "",
        selfieStatsAnalysisStatus: OnboardingAnalytics$1.getAnalysisStatus(),
        motionStatus: OnboardingAnalytics$1.getMotionStatus()
      });
      const Rn = await capture({
        token: pt,
        image: dn,
        type: selfieType,
        encrypted: !0,
        faceCoordinates: Jt
      }), rn = selfieChecks(Rn);
      if (rn.hasErrors) {
        addScreenEvent({
          module: eventModuleNames.selfie,
          screen: eventScreenNames.faceCaptureUpload,
          token: pt,
          shouldOpen: !1
        }), addScreenEvent({
          module: eventModuleNames.selfie,
          screen: eventScreenNames.faceCaptureError,
          token: pt,
          shouldOpen: !0
        }), Yt("error"), logSelfieChecks(Rn, rn, Xe, Lt, St), Tt(null), addScreenEvent({
          module: eventModuleNames.selfie,
          screen: eventScreenNames.faceCaptureError,
          token: pt,
          shouldOpen: !1
        }), Ct({
          response: Rn,
          livenessPassed: rn.livenessPassed,
          imageBase64: an
        }), hn ? wt.current = !1 : ft();
        return;
      }
      const { faceMatch: ln, existingUser: pn, ...Sn } = await Pt();
      return addScreenEvent({
        module: eventModuleNames.selfie,
        screen: eventScreenNames.faceCaptureUpload,
        token: pt,
        shouldOpen: !1
      }), addScreenEvent({
        module: eventModuleNames.selfie,
        screen: eventScreenNames.faceCaptureSuccess,
        token: pt,
        shouldOpen: !0
      }), Yt("success"), Xe(
        getLogObject("successCapture", {
          response: Rn,
          message: "Selfie uploaded successfully"
        })
      ), Lt(St("notifications.success")), Tt(null), await sleep(3500), addScreenEvent({
        module: eventModuleNames.selfie,
        screen: eventScreenNames.faceCaptureSuccess,
        token: pt,
        shouldOpen: !1
      }), ue({
        ...Rn,
        ...Sn,
        faceMatch: ln,
        existingUser: pn,
        liveness: rn.livenessPassed,
        imageBase64: an
      });
    } catch (dn) {
      addScreenEvent({
        module: eventModuleNames.selfie,
        screen: eventScreenNames.faceCaptureUpload,
        token: pt,
        shouldOpen: !1
      }), addScreenEvent({
        module: eventModuleNames.selfie,
        screen: eventScreenNames.faceCaptureError,
        token: pt,
        shouldOpen: !0
      }), Tt(null), Ot(
        dn.response ? dn.response.data : St("notifications.serverError")
      ), Yt("error"), addScreenEvent({
        module: eventModuleNames.selfie,
        screen: eventScreenNames.faceCaptureError,
        token: pt,
        shouldOpen: !1
      }), Ct({
        response: (cn = dn == null ? void 0 : dn.response) == null ? void 0 : cn.data,
        livenessPassed: null,
        imageBase64: an
      }), hn ? wt.current = !1 : ft();
    }
  }, 300), { t: St } = useTranslation(), kt = async (En, Jt, an, cn) => {
    await updateSession({
      token: pt,
      key: "manualSelfieCheckNeeded",
      value: !0
    });
    const dn = getLogObject("skip", {
      existingUser: En,
      liveness: Jt,
      imageBase64: an,
      faceMatch: cn
    });
    Xe(dn), me(dn);
  };
  async function jt({
    response: En,
    livenessPassed: Jt,
    imageBase64: an
  }) {
    addEvent({
      code: "noAttempts",
      token: pt
    }), Xe(
      getLogObject("noAttemps", {
        response: En,
        message: "No attempt left"
      })
    );
    const { faceMatch: cn, existingUser: dn } = await Pt();
    return kt(dn, Jt, an, cn);
  }
  async function Pt() {
    if (ut)
      return {
        faceMatch: !1
      };
    const En = await processFace({
      token: pt
    });
    rt && await processFaceSecondId({
      token: pt
    });
    const Jt = En.confidence === 1, an = En.existingUser;
    return { faceMatch: Jt, existingUser: an, ...En };
  }
  function Qt(En) {
    It(ht + 1), Xt(En);
  }
  const {
    showManualCapture: qt,
    mode: _t,
    setMode: Yt,
    resetLoading: Xt,
    notificationMessage: Ut,
    setNotificationMessage: Lt,
    handleError: Ot,
    startAutoDetect: ft,
    cameraReady: Dt,
    handleManualCapture: Mt,
    isSuccess: Ft,
    isError: Gt,
    isLoading: zt,
    hideCamera: $t,
    showBorders: Ht,
    shouldShowManualCapture: hn,
    selfieTimeoutRef: un
  } = useSelfie({
    timeout: $e,
    onLog: Xe,
    handleCapture: Rt,
    handleNoAttempsLeft: jt,
    numberOfTries: Je,
    webcam: gt,
    isDetecting: wt,
    token: pt,
    isDesktop: !1,
    onSwitchManualCapture: () => {
      addEvent({
        code: "switchToManualCaptureSelfie",
        token: pt
      });
    },
    onManualCaptureSelfie: () => {
      addEvent({
        code: "manualCaptureSelfie",
        token: pt
      });
    }
  }), An = () => {
    var En;
    if (hn) {
      wt.current = !1;
      return;
    }
    ot && !bt || ot && ((En = gt.current) == null || En.setIsLoadingCamera(!1));
  };
  return useEffect(() => {
    An();
  }, [bt]), /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Container$h,
    {
      className: classNames("IncodeCaptureSelfieContainer", {
        kiosk: lt
      }),
      role: "region",
      "aria-live": "assertive",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(SrOnlyHeading, { children: St("selfie.title") }),
        hn && /* @__PURE__ */ jsxRuntimeExports.jsxs(
          CaptureButtonContainer$2,
          {
            className: classNames("IncodeCaptureSelfieButtonContainer", {
              kiosk: lt
            }),
            initial: {
              scale: 0
            },
            animate: {
              scale: 1
            },
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: St("common.takePhoto") }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("button", { onClick: Mt, type: "button", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: captureButton, alt: "capture button" }) })
            ]
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          WebcamContainer$1,
          {
            className: classNames("IncodeCaptureSelfieWebcamContainer", {
              kiosk: lt
            }),
            children: [
              (zt || Ft) && /* @__PURE__ */ jsxRuntimeExports.jsx(
                BordersContainer,
                {
                  className: classNames("IncodeCaptureSelfieBordersContainer", {
                    kiosk: lt
                  }),
                  children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    LoadingBorders,
                    {
                      className: "IncodeCaptureSelfieLoadingBordersContainer",
                      mode: _t
                    }
                  )
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Hidder,
                {
                  className: "IncodeCaptureSelfieHidder",
                  initial: { width: 0, height: 0 },
                  animate: {
                    width: Dt ? 300 : 10,
                    height: Dt ? 300 : 10
                  },
                  children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    CameraOvalOuter,
                    {
                      className: classNames("IncodeCaptureSelfieCameraOvalOuter", {
                        "no-borders": zt || Ft,
                        "has-error": Gt
                      }),
                      initial: {
                        borderWidth: "0px"
                      },
                      transition: {
                        delay: 0,
                        ease: "linear"
                      },
                      animate: {
                        borderWidth: Ht ? "6px" : "0px",
                        borderColor: Gt ? "#ff5c6f" : "#21273b"
                      },
                      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
                        CameraOvalInner,
                        {
                          className: classNames("IncodeCaptureSelfieCameraOvalInner", {
                            isUploading: $t
                          }),
                          children: [
                            /* @__PURE__ */ jsxRuntimeExports.jsx(
                              FaceFrame$1,
                              {
                                src: faceFrame$1,
                                "aria-hidden": !0,
                                className: classNames({ hidden: $t })
                              }
                            ),
                            Ze && Bt && /* @__PURE__ */ jsxRuntimeExports.jsx(
                              PreviewImage,
                              {
                                className: "IncodeCaptureSelfiePreviewImage",
                                src: `data:image/jpeg;base64,${Bt}`
                              }
                            ),
                            /* @__PURE__ */ jsxRuntimeExports.jsx(
                              Webcam,
                              {
                                ref: gt,
                                onPlay: An,
                                videoSource: it ? "environment" : "user",
                                isSelfie: !0,
                                type: "selfie",
                                className: classNames("video__selfie IncodeCaptureSelfieWebcam", {
                                  hidden: $t,
                                  kiosk: lt
                                }),
                                permission: Qe,
                                setPermission: Ue,
                                permissionMessage: He,
                                permissionBackgroundColor: Ge,
                                onLog: Xe,
                                stream: nt,
                                onError: me,
                                token: pt,
                                interviewId: Ke == null ? void 0 : Ke.interviewId,
                                onStreamReady: ot ? vt : void 0,
                                isRecordingEnabled: ot,
                                showCustomCameraPermissionScreen: et,
                                assistedOnboarding: it,
                                showDoublePermissionsRequest: at,
                                onRestartOnboarding: st,
                                isKiosk: lt,
                                publishAudio: At
                              }
                            ),
                            $t && /* @__PURE__ */ jsxRuntimeExports.jsx(
                              CameraOvalInnerText,
                              {
                                "aria-live": "assertive",
                                "aria-atomic": "true",
                                className: classNames("IncodeCaptureSelfieCameraOvalInnerText", {
                                  isError: Gt
                                }),
                                children: getCircleText(St, Ut, dt)[_t]
                              }
                            )
                          ]
                        }
                      )
                    }
                  )
                }
              )
            ]
          }
        ),
        !$t && /* @__PURE__ */ jsxRuntimeExports.jsx(
          NotificationInline,
          {
            "aria-live": "assertive",
            "aria-atomic": "true",
            initial: {
              scale: 0
            },
            animate: {
              scale: Dt ? 1 : 0
            },
            className: classNames("IncodeCaptureSelfieNotificationInline", {
              hasManualCapture: qt
            }),
            children: Ut || (dt ? St("notifications.selfie.ageAssurance") : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
              St("notifications.selfie.one"),
              " ",
              /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
              St("notifications.selfie.two")
            ] }))
          }
        ),
        Gt && /* @__PURE__ */ jsxRuntimeExports.jsx(RetryButtonsContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button$a, { onClick: () => Qt(yt), children: ht < Je ? St("common.tryAgain") : St("common.continue") }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("canvas", { id: "canvasFrame", hidden: !0 })
      ]
    }
  );
}
const CaptureSelfie$1 = preloadScript$4(CaptureSelfie), conferenceStatus = {
  approve: "approve",
  badInternet: "no-internet",
  close: "close",
  deny: "deny",
  executiveDisconnected: "executive-disconnected",
  genericError: "generic-error",
  noBrowser: "no-browser",
  noDevice: "no-device",
  noPermission: "no-permissions",
  OTPError: "OTPError",
  noConnection: "no-connection"
};
function addConsent({
  title: me,
  content: ue,
  status: Qe,
  session: { token: Ue }
}) {
  return api.post(
    "/omni/add/user-consent",
    { title: me, content: ue, status: Qe },
    {
      headers: {
        "X-Incode-Hardware-Id": Ue
      }
    }
  ).catch((He) => Promise.reject(He.response.data));
}
const getPrivacyConsentData = ({
  session: { token: me },
  type: ue = "PRIVACY",
  regulationType: Qe = "Worldwide"
}) => {
  const Ue = getLanguageCodeWithCountry(i18nInstance.language);
  return api.get("/omni/consents", {
    headers: {
      "X-Incode-Hardware-Id": me
    },
    params: {
      type: ue,
      language: Ue,
      regulationType: Qe
    }
  }).then((He) => He.data);
};
var createRoot, m$1 = ReactDOM__default;
if (process.env.NODE_ENV === "production")
  createRoot = m$1.createRoot, m$1.hydrateRoot;
else {
  var i$2 = m$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  createRoot = function(me, ue) {
    i$2.usingClientEntryPoint = !0;
    try {
      return m$1.createRoot(me, ue);
    } finally {
      i$2.usingClientEntryPoint = !1;
    }
  };
}
let shouldShowCache = !mobile.isBrowserSupported();
function useBrowserNotSupported() {
  const [me, ue] = useState(shouldShowCache);
  function Qe() {
    ue(!1), shouldShowCache = !1;
  }
  return { shouldShow: me, onContinue: Qe };
}
let theme = {
  main: "#007AFF",
  buttonBorderRadius: "31px",
  buttonColor: "#fff",
  modal: {},
  mainButton: {},
  secondaryButton: {}
};
const setTheme = (me) => (theme = {
  ...theme,
  ...me,
  mainButton: { ...theme.mainButton, ...me.mainButton },
  secondaryButton: {
    ...theme.secondaryButton,
    ...me.secondaryButton
  },
  modal: { ...theme.modal, ...me.modal }
}, theme), AppProvider = ({ children: me }) => /* @__PURE__ */ jsxRuntimeExports.jsx(Le, { theme, children: /* @__PURE__ */ jsxRuntimeExports.jsx(I18nextProvider, { i18n: i18nInstance, children: me }) }), Container$b = qe.div`
  height: calc(var(--vh) * 100);
  width: 100vw;
  min-height: 500px;
  position: fixed;
  top: 0;
  left: 0;
  min-height: 100%;

  &.is-desktop {
    position: relative;
  }

  &.kiosk {
    width: 100%;
    height: 100%;
    position: relative;
  }

  &.disable-full-screen {
    position: relative;
    height: 100%;
  }

  * {
    box-sizing: border-box;
  }

  .hidden {
    display: none;
  }
`, App$1 = ({
  disableFullScreen: me = !1,
  isKiosk: ue = !1,
  children: Qe,
  token: Ue
}) => {
  const { isRotated: He } = useOrientation(), { ready: Ge } = useTranslation(), { shouldShow: Xe, onContinue: Ke } = useBrowserNotSupported();
  return useResize(ue), Ge ? options.redirectFromUnsupportedBrowsers && Xe ? /* @__PURE__ */ jsxRuntimeExports.jsx(BrowserNotSupported, { onContinue: Ke, token: Ue }) : /* @__PURE__ */ jsxRuntimeExports.jsx(AppProvider, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Container$b,
    {
      className: classNames("IncodeDefaultComponentContainer", {
        "disable-full-screen": me,
        "is-desktop": mobile.isDesktop(),
        kiosk: ue
      }),
      children: [
        !!mobile.any() && !mobile.isIpad() && He && /* @__PURE__ */ jsxRuntimeExports.jsx(LandscapeNotSupported, {}),
        Qe
      ]
    }
  ) }) : null;
}, LinkButton = qe.button`
  background: none;
  border: none;
  color: #0a6fdd;
  cursor: pointer;
  padding: 2px;
  text-decoration: underline;

  &:hover,
  &:focus {
    text-decoration: none;
    box-shadow: 0 0 0 2px #005fcc;
  }

  &:focus {
    outline: none;
  }
`, Container$a = qe.section`
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
  color: #21273b;
  padding: 50px 10px;
`, ErrorMessage$4 = qe.span`
  font-size: 14px;
  color: #f54f68;
`, Instructions$1 = qe.p`
  margin: 0;
`, TIMER_VALUE = 30;
function SMSOTP({
  token: { token: me },
  onBoarding: ue,
  onError: Qe,
  onLog: Ue,
  onSuccess: He,
  goBack: Ge,
  numberOfTries: Xe,
  isIndianGovernmentValidation: Ke = !1,
  isEmail: $e = !1
}) {
  const [Je, Ze] = useState(""), [nt, tt] = useState(0), [et, rt] = useState(!1), { t: it } = useTranslation(), ot = $e ? "EMAIL" : "PHONE", [at, st] = useState(TIMER_VALUE), [ut, lt] = useState(!0);
  useEffect(() => {
    let Tt;
    return ut && (Tt = setInterval(() => {
      at > 0 ? st((yt) => yt - 1) : (lt(!1), clearInterval(Tt));
    }, 1e3)), () => {
      clearInterval(Tt);
    };
  }, [at, ut]), useScreenEvents({
    module: eventModuleNames.otp,
    screen: eventScreenNames.smsOtp,
    token: me
  });
  const dt = useCallback(() => {
    st(TIMER_VALUE), lt(!0), ue.sendOTPSMS({
      token: me,
      communicationChannel: $e ? "EMAIL" : "SMS"
    }), rt(!1), Ze("");
  }, [ue, me]);
  useEffect(() => {
    Ke || dt();
  }, [dt, Ke]);
  function At(Tt) {
    Tt !== Je && (Ze(Tt), rt(!1));
  }
  async function pt() {
    rt(!0);
    const Tt = nt + 1;
    tt((yt) => yt + 1), addEvent({
      code: "wrongOTPEntered",
      module: ot,
      token: me
    }), Ue(
      getLogObject("otpAttemptFailed", {
        message: "Incorrect OTP"
      })
    ), Xe !== -1 && Tt >= Xe && (Qe("OTPError"), Ue(
      getLogObject("otpNoAttemptsLeft", {
        message: "No attempts left"
      })
    ));
  }
  async function gt() {
    try {
      const { success: Tt } = Ke ? await ue.compareGovValidationOTP({ token: me, code: Je }) : await ue.compareOTP({
        token: me,
        code: Je,
        channel: $e ? "EMAIL" : "SMS"
      });
      Tt ? (addEvent({
        token: me,
        code: "otpSubmitted",
        module: ot
      }), addEvent({
        code: "correctOTPEntered",
        module: ot,
        token: me
      }), Ue(
        getLogObject("otpPassed", {
          message: "Correct OTP"
        })
      ), He()) : pt();
    } catch {
      pt();
    }
  }
  const wt = () => {
    addEvent({
      code: $e ? "changeEmailClicked" : "changePhoneClicked",
      module: ot,
      token: me
    }), Ge();
  }, Bt = () => {
    addEvent({
      code: "tryAgainOTPClicked",
      module: ot,
      token: me
    }), dt();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Container$a, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "aria-live": "polite", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Instructions$1, { children: it($e ? "otp.insertEmail" : "otp.insertSMS") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Instructions$1, { children: it("otp.focus") })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      IndividualCharacterInputBoxes,
      {
        amount: 6,
        onChange: At,
        autoFocus: !0,
        value: Je
      }
    ),
    et && /* @__PURE__ */ jsxRuntimeExports.jsxs(ErrorMessage$4, { className: "IncodeOTPError", children: [
      " ",
      it("otp.error")
    ] }),
    !Ke && /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
      it("otp.didYouNotGetIt"),
      at > 0 ? it("otp.tryAgain", { time: at }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        Ge && /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(LinkButton, { onClick: Bt, children: it("otp.sendAgain") }),
        Ge && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          ` ${it("otp.or")} `,
          /* @__PURE__ */ jsxRuntimeExports.jsx(LinkButton, { onClick: wt, children: it($e ? "otp.changeEmail" : "otp.changePhoneNumber") })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button$a, { onClick: gt, theme, children: it("otp.submit") }) })
  ] });
}
function addPhone({
  token: me,
  phone: ue,
  text: Qe,
  optInGranted: Ue
}) {
  return api.post(
    "/omni/add/phone",
    { phone: ue, text: Qe, optInGranted: Ue },
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).catch((He) => Promise.reject(He.response.data));
}
async function addPhoneInstantVerify({
  token: me,
  phone: ue,
  text: Qe,
  optInGranted: Ue
}) {
  return api.post(
    "/omni/instant/add/phone",
    { phone: ue, text: Qe, optInGranted: Ue },
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).catch((He) => Promise.reject(He.response.data));
}
const getStartInfoUrl = () => "/omni/start-info", getStartInfo = ({ token: me }) => api.get(getStartInfoUrl(), {
  headers: {
    "X-Incode-Hardware-Id": me
  }
}).then((ue) => ue.data).catch((ue) => Promise.reject(ue.response.data)), welcomeLogo = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20width='292px'%20height='52px'%20viewBox='0%200%20292%2052'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3ctitle%3eomni@1x%3c/title%3e%3cg%20id='Page-1'%20stroke='none'%20stroke-width='1'%20fill='none'%20fill-rule='evenodd'%3e%3cg%20id='Artboard'%20transform='translate(-19.000000,%20-4.000000)'%3e%3cg%20id='omni'%20transform='translate(19.000000,%204.000000)'%3e%3cpath%20d='M72.1032448,25.74608%20C75.8706218,25.74608%2078.7228434,26.8033035%2080.644258,28.9301873%20C82.5573834,31.0468072%2083.5084288,34.0957265%2083.5084288,38.065184%20C83.5084288,42.0343831%2082.5262053,45.1059387%2080.5519077,47.26978%20C78.5722946,49.439314%2075.764193,50.521376%2072.1489408,50.521376%20C68.4120271,50.521376%2065.5796573,49.454954%2063.674958,47.3140775%20C61.7761587,45.1813882%2060.8324608,42.094423%2060.8324608,38.065184%20C60.8324608,29.8924221%2064.6170719,25.74608%2072.1032448,25.74608%20Z%20M109.053837,16.6976%20L109.053837,44.690432%20C109.053837,46.0002568%20108.50953,47.1139756%20107.436999,48.007273%20C106.395947,48.8743526%20105.091225,49.5109378%20103.526834,49.9182595%20C101.981251,50.3203291%20100.387468,50.520704%2098.7440128,50.520704%20C95.4130134,50.520704%2092.6619157,49.5756283%2090.5007631,47.6823758%20C88.323357,45.7724437%2087.2460928,42.4689942%2087.2460928,37.788992%20C87.2460928,34.0372132%2088.166472,31.0902795%2090.0162174,28.9555324%20C91.8766716,26.812812%2094.6246912,25.745408%2098.2413568,25.745408%20C99.0878313,25.745408%20100.059332,25.8530858%20101.156662,26.0684644%20C101.848925,26.206917%20102.495848,26.3870925%20103.098033,26.6094189%20L103.45398,26.7478763%20L103.696,26.852%20L103.696653,16.6976%20L109.053837,16.6976%20Z%20M124.973114,25.7455424%20C128.629373,25.7455424%20131.334504,26.9358002%20133.055176,29.3196621%20C134.692147,31.5875624%20135.52325,34.7109476%20135.557105,38.6840936%20L135.557105,39.1649496%20L135.554867,39.4650944%20L119.497,39.465%20L119.500701,39.5017953%20C119.669582,41.2745419%20120.175967,42.6688964%20121.017134,43.6967988%20L121.18983,43.8974967%20L121.371449,44.0884439%20C122.481796,45.2000644%20124.072252,45.7590464%20126.162554,45.7590464%20C127.541497,45.7590464%20128.853978,45.5879105%20130.102787,45.2442261%20C131.195728,44.9457339%20132.179466,44.5705843%20133.050043,44.1220976%20L133.416208,43.9254086%20L133.866362,43.6733225%20L133.866362,48.8627025%20L133.684972,48.9419066%20C131.271213,49.9958783%20128.505287,50.5208384%20125.384378,50.5208384%20C121.860614,50.5208384%20119.077906,49.4476662%20117.053222,47.296958%20C115.031049,45.1503011%20114.023546,42.1115976%20114.023546,38.2017344%20C114.023546,34.2028567%20114.974406,31.1239955%20116.887497,28.9757444%20C118.804841,26.8211604%20121.507925,25.7455424%20124.973114,25.7455424%20Z%20M49.7130112,25.7901632%20C52.2186897,25.7901632%2054.6030725,26.254334%2056.8649768,27.1823297%20L56.8649768,27.1823297%20L57.0525952,27.2593043%20L57.0525952,32.2159191%20L56.632695,32.0388498%20C54.3513333,31.0768139%2052.2734229,30.5976512%2050.3984512,30.5976512%20C48.0676371,30.5976512%2046.3472086,31.1743437%2045.2215889,32.3139699%20C44.0971751,33.4536473%2043.5265792,35.289688%2043.5265792,37.8364352%20C43.5265792,40.5099695%2044.0847831,42.4429368%2045.1837295,43.6413241%20C46.2753123,44.8343316%2048.0525547,45.4380992%2050.5355392,45.4380992%20C52.561789,45.4380992%2054.6047092,44.9466141%2056.6640071,43.9611023%20L56.6640071,43.9611023%20L57.0969472,43.7539115%20L57.0969472,48.7242935%20L56.917599,48.804187%20C54.6885262,49.7971625%2052.3018155,50.2926272%2049.7587072,50.2926272%20C46.4584698,50.2926272%2043.6999932,49.3393479%2041.4957048,47.4316313%20C39.2729911,45.5119517%2038.1693952,42.4270644%2038.1693952,38.2020032%20C38.1693952,33.856692%2039.2555651,30.6912826%2041.4454906,28.7236846%20C43.6207215,26.7680484%2046.3815048,25.7901632%2049.7130112,25.7901632%20Z%20M6.23830656,26.4305792%20L6.28521466,49.8363392%20L0.836031999,49.8363392%20L0.836031999,26.4305792%20L6.23830656,26.4305792%20Z%20M23.529472,25.7902976%20C26.7961245,25.7902976%2029.2251622,26.4796658%2030.8122342,27.8764012%20C32.4078833,29.2819244%2033.199552,31.4501956%2033.199552,34.3636736%20L33.199552,34.3636736%20L33.199552,49.8358016%20L27.796672,49.8358016%20L27.796672,35.0047616%20C27.796672,31.9810247%2026.1271941,30.5077376%2022.661248,30.5077376%20C20.9595614,30.5077376%2019.3335117,30.7907005%2017.7840755,31.3562842%20L17.9816,31.2866%20L17.982784,49.8358016%20L12.57856,49.8358016%20L12.57856,28.2823598%20L12.7435111,28.1981879%20C14.1372859,27.4869669%2015.8275093,26.9085803%2017.819818,26.4588802%20C19.8062558,26.0132225%2021.7085934,25.7902976%2023.529472,25.7902976%20Z%20M72.1032448,30.36944%20C69.9709602,30.36944%2068.4732241,31.0082548%2067.5748603,32.276533%20C66.6565263,33.5742908%2066.1909888,35.502946%2066.1909888,38.065184%20C66.1909888,40.6273838%2066.6709908,42.5698767%2067.6198302,43.8985093%20C68.5479909,45.198691%2070.0315204,45.850976%2072.1032448,45.850976%20C76.1214761,45.850976%2078.1068928,43.3044633%2078.1068928,38.065184%20C78.1068928,35.4455668%2077.6198681,33.5049555%2076.6604054,32.2389265%20C75.717281,30.9957171%2074.2067919,30.36944%2072.1032448,30.36944%20Z%20M98.9267968,30.461504%20C94.7803612,30.461504%2092.7390208,32.8905691%2092.7390208,37.881728%20C92.7390208,40.3851018%2093.2128323,42.3299479%2094.1512388,43.7207552%20C95.0623229,45.0766997%2096.6710511,45.758912%2099.0181888,45.758912%20C100.392013,45.758912%20101.538746,45.597051%20102.459695,45.2745897%20C103.251754,44.9972584%20103.639407,44.6725701%20103.690745,44.3162532%20L103.696653,44.233472%20L103.696,31.662%20L103.537489,31.5745379%20C103.013437,31.29896%20102.449727,31.0725138%20101.84651,30.8960946%20L101.479841,30.7962534%20C100.60193,30.5731671%2099.7507442,30.461504%2098.9267968,30.461504%20Z%20M124.836026,30.2801984%20C123.291326,30.2801984%20122.102441,30.6806016%20121.249649,31.4769595%20C120.495279,32.1814078%20119.964142,33.3417262%20119.66712,34.9638293%20L119.61,35.294%20L130.024,35.294%20L130.023271,35.2823893%20C129.806573,33.6880677%20129.3484,32.4971149%20128.656441,31.7010721%20L128.504589,31.536533%20C127.684071,30.7022776%20126.466486,30.2801984%20124.836026,30.2801984%20Z%20M6.421696,18.2953472%20L6.421696,23.2412672%20L0.697599999,23.2412672%20L0.697599999,18.2953472%20L6.421696,18.2953472%20Z'%20id='Combined-Shape'%20fill='%2321273B'%20fill-rule='nonzero'%3e%3c/path%3e%3cpath%20d='M163.91596,16.64264%20C167.68636,16.64264%20170.72476,17.94464%20173.03116,20.54864%20C175.33756,23.15264%20176.68876,26.36384%20177.08596,30.18344%20C178.809485,30.07339%20180.77784,29.7736461%20182.990054,29.2837229%20C183.447632,26.4119822%20184.107639,23.612091%20184.97032,20.88356%20C185.41672,19.44596%20186.14752,18.39116%20187.16512,17.72156%20C188.18152,17.05196%20189.60832,16.71716%20191.44432,16.71716%20C192.43552,16.71716%20193.12912,16.84196%20193.52752,17.08916%20C193.92352,17.33756%20194.12152,17.80916%20194.12152,18.50276%20C194.12152,19.29716%20193.74952,21.08276%20193.00552,23.85836%20C192.50992,25.84436%20192.11272,27.56756%20191.81512,29.03036%20C191.51752,30.49436%20191.26912,32.31596%20191.07112,34.49876%20C192.41032,30.62996%20194.00992,27.35636%20195.86992,24.67796%20C197.73112,21.99956%20199.64032,20.00396%20201.59872,18.68876%20C203.55832,17.37476%20205.40512,16.71716%20207.14272,16.71716%20C208.87792,16.71716%20210.10432,17.11436%20210.82552,17.90756%20C211.54432,18.70196%20211.90312,19.91636%20211.90312,21.55316%20C211.90312,23.14076%20211.43152,26.01716%20210.49072,30.18356%20C210.09352,31.96916%20209.81992,33.30836%20209.67112,34.20116%20C212.15032,28.10036%20214.90312,23.66156%20217.93072,20.88356%20C220.95472,18.10676%20223.78192,16.71716%20226.41112,16.71716%20C229.63552,16.71716%20231.24712,18.32876%20231.24712,21.55316%20C231.24712,23.48756%20230.70112,26.98436%20229.61032,32.04356%20C228.66832,36.35876%20228.19672,39.21116%20228.19672,40.59956%20C228.19672,42.58436%20228.91552,43.57556%20230.35432,43.57556%20C231.34552,43.57556%20232.52392,42.96836%20233.88952,41.75276%20C234.878106,40.8713071%20236.11009,39.5903026%20237.583636,37.9111229%20C237.702816,31.9566763%20238.61624,26.2805239%20240.3226,20.88356%20C240.769,19.44596%20241.4998,18.39116%20242.5174,17.72156%20C243.5338,17.05196%20244.9606,16.71716%20246.7966,16.71716%20C247.7878,16.71716%20248.4814,16.84196%20248.8798,17.08916%20C249.2758,17.33756%20249.4738,17.80916%20249.4738,18.50276%20C249.4738,19.29716%20249.1018,21.08276%20248.3578,23.85836%20C247.8622,25.84436%20247.465,27.57956%20247.1674,29.06756%20C246.8698,30.55556%20246.6214,32.39156%20246.4234,34.57316%20C248.0602,30.30836%20249.8962,26.83556%20251.9302,24.15716%20C253.963,21.47876%20255.9586,19.56956%20257.9182,18.42836%20C259.8778,17.28836%20261.6766,16.71716%20263.3122,16.71716%20C266.5366,16.71716%20268.1482,18.32876%20268.1482,21.55316%20C268.1482,23.48756%20267.6022,26.98436%20266.5114,32.04356%20C265.5694,36.35876%20265.0978,39.21116%20265.0978,40.59956%20C265.0978,42.58436%20265.8166,43.57556%20267.2554,43.57556%20C268.2478,43.57556%20269.425,42.96836%20270.7906,41.75276%20C271.719548,40.9244824%20272.863412,39.7434065%20274.22067,38.2106744%20C275.001825,32.0105368%20276.052405,26.2356993%20277.37308,20.88308%20C277.77028,19.34588%20278.42668,18.26828%20279.34468,17.64668%20C280.26268,17.02748%20281.73628,16.71788%20283.77148,16.71788%20C285.90388,16.71788%20286.97068,17.58548%20286.97068,19.32188%20C286.97068,19.57028%20286.92148,20.04068%20286.82188,20.73428%20C284.58988,31.34948%20283.25068,40.25348%20282.80428,47.44388%20C282.70468,49.03148%20282.23308,50.14868%20281.39068,50.79188%20C280.54708,51.43628%20279.23308,51.75908%20277.44748,51.75908%20C275.85988,51.75908%20274.76908,51.43628%20274.17388,50.79188%20C273.664941,50.2418974%20273.373592,49.4181726%20273.299832,48.3222062%20C272.889681,48.6391654%20272.474312,48.9414667%20272.0542,49.22996%20C269.599,50.91596%20266.809,51.75836%20263.6854,51.75836%20C261.1546,51.75836%20259.2454,51.02756%20257.9554,49.56476%20C256.6654,48.10316%20256.021,45.98156%20256.021,43.20356%20C256.021,41.81516%20256.3678,39.33476%20257.0626,35.76356%20C257.707,32.63876%20258.031,30.48116%20258.031,29.29076%20C258.031,28.49876%20257.7562,28.10036%20257.2114,28.10036%20C256.567,28.10036%20255.661,28.93196%20254.497,30.59276%20C253.3306,32.25596%20252.1402,34.45076%20250.9246,37.17716%20C249.709,39.90596%20248.731,42.78236%20247.987,45.80756%20C247.4398,48.13916%20246.8074,49.71356%20246.0898,50.53196%20C245.3698,51.35036%20244.2406,51.75836%20242.7034,51.75836%20C240.8182,51.75836%20239.4922,50.76716%20238.723,48.78356%20C238.508608,48.2310229%20238.32414,47.5857293%20238.16957,46.8477831%20C237.193167,47.7255916%20236.187521,48.5196308%20235.15312,49.22996%20C232.69792,50.91596%20229.90792,51.75836%20226.78432,51.75836%20C224.25352,51.75836%20222.34432,51.02756%20221.05432,49.56476%20C219.76432,48.10316%20219.11992,45.98156%20219.11992,43.20356%20C219.11992,41.81516%20219.46672,39.33476%20220.16152,35.76356%20C220.80592,32.63876%20221.12992,30.48116%20221.12992,29.29076%20C221.12992,28.49876%20220.85632,28.10036%20220.31032,28.10036%20C219.66592,28.10036%20218.74792,28.93196%20217.55752,30.59276%20C216.36712,32.25596%20215.17792,34.45076%20213.98752,37.17716%20C212.79592,39.90596%20211.82992,42.78236%20211.08592,45.80756%20C210.53992,48.18836%20209.90632,49.77596%20209.18872,50.56916%20C208.46872,51.36236%20207.31552,51.75836%20205.72912,51.75836%20C204.09232,51.75836%20202.86352,50.97836%20202.04632,49.41596%20C201.22792,47.85356%20200.81752,45.95636%20200.81752,43.72436%20C200.81752,41.84036%20201.06592,39.11036%20201.56152,35.54036%20C201.95872,32.36636%20202.15672,30.28316%20202.15672,29.29076%20C202.15672,28.49876%20201.88432,28.10036%20201.33952,28.10036%20C200.59552,28.10036%20199.65112,28.99316%20198.51112,30.77876%20C197.36992,32.56436%20196.26712,34.84676%20195.20032,37.62356%20C194.13352,40.40276%20193.27792,43.12916%20192.63472,45.80756%20C192.08752,48.13916%20191.45512,49.71356%20190.73752,50.53196%20C190.01752,51.35036%20188.88832,51.75836%20187.35112,51.75836%20C185.46592,51.75836%20184.13992,50.76716%20183.37072,48.78356%20C182.60152,46.80116%20182.21752,43.62476%20182.21752,39.25916%20C182.21752,38.6082129%20182.226881,37.9605328%20182.2456,37.3161222%20C180.423272,37.6857293%20178.504321,37.9115416%20176.49076,37.99544%20C175.54756,42.16184%20173.68756,45.49904%20170.91076,48.00224%20C168.13156,50.50784%20164.98276,51.75944%20161.46076,51.75944%20C158.48596,51.75944%20155.94316,51.04064%20153.83596,49.60184%20C151.72636,48.16304%20150.12676,46.25384%20149.03716,43.87304%20C147.94516,41.49224%20147.40036,38.91344%20147.40036,36.13544%20C147.40036,32.36624%20148.11796,29.00624%20149.55796,26.05424%20C150.99556,23.10464%20152.98036,20.79824%20155.50996,19.13504%20C158.03956,17.47304%20160.84156,16.64264%20163.91596,16.64264%20Z%20M163.99156,24.52904%20L163.61836,24.52904%20C161.63476,24.52904%20159.98476,25.48424%20158.67196,27.39344%20C157.35796,29.30384%20156.70036,31.99424%20156.70036,35.46584%20C156.70036,38.19464%20157.23196,40.27664%20158.29996,41.71544%20C159.36556,43.15544%20160.61716,43.87304%20162.05716,43.87304%20C163.64356,43.87304%20165.01996,43.22864%20166.18636,41.93864%20C167.35156,40.64984%20168.13156,38.78984%20168.52996,36.35864%20C166.99156,35.31704%20165.81316,33.95384%20164.99596,32.26664%20C164.17756,30.58064%20163.76716,28.79504%20163.76716,26.90984%20C163.76716,26.11664%20163.84276,25.32224%20163.99156,24.52904%20Z%20M285.48268,0.19988%20C287.31748,0.19988%20288.80548,0.64628%20289.94668,1.53908%20C291.08668,2.43188%20291.65788,3.69668%20291.65788,5.33348%20C291.65788,7.31828%20291.01348,8.89268%20289.72348,10.05788%20C288.43228,11.22428%20286.72228,11.80628%20284.58988,11.80628%20C282.50668,11.80628%20280.94428,11.32388%20279.90268,10.35548%20C278.86108,9.38828%20278.34028,8.03708%20278.34028,6.30068%20C278.34028,4.56548%20279.02188,3.11468%20280.38628,1.94828%20C281.74948,0.78308%20283.44868,0.19988%20285.48268,0.19988%20Z'%20id='Combined-Shape'%20fill='%2300ADEF'%3e%3c/path%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e", DesktopPhoneContainer = qe.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: #f9faff;
`, DesktopPhoneHeader = qe.header`
  display: flex;
  position: absolute;
  width: 100vw;
  height: 80px;
  top: 0;
  align-items: center;
  padding: 10px 20px;
  background-color: #ffffff;
  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.06);
`, Logo$3 = qe.img`
  height: 40px;
`, DesktopPhoneContent = qe.div`
  ${(me) => me.isInstantVerify ? `
      text-align: center;
    ` : `
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      max-width: 350px;
    `};
`, DesktopPhoneInputLabel = qe.label`
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #20263d;
  align-self: flex-start;
`, DesktopPhoneInput = qe.input`
  border: 2px solid #979797;
  border-radius: 8px;
  width: 350px;
  height: 58px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 17px 16px;
  gap: 16px;
  font-size: 18px;
  margin: 20px 0 20px 0;
`, StyledButton$5 = qe(Button$a)`
  align-self: flex-end;
  text-transform: uppercase;
  margin-top: 60px;
`, EmailLink = qe.div`
  color: #3585f1;
  font-size: 14px;
  font-weight: 700;
  margin-top: 16px;
  text-align: left;
`, DesktopPhone = ({
  formattedNumber: me,
  onChange: ue,
  disabled: Qe,
  onClick: Ue,
  optinEnabled: He,
  optInOnChange: Ge,
  finishGptOptInLabel: Xe,
  isInstantVerify: Ke = !1,
  onStepChange: $e
}) => {
  const { t: Je } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(DesktopPhoneContainer, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(DesktopPhoneHeader, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Logo$3, { src: welcomeLogo, alt: "Incode omni logo" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(DesktopPhoneContent, { isInstantVerify: Ke, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(DesktopPhoneInputLabel, { htmlFor: "phone", children: Je(Ke ? "instantVerifyConsent.enterPhoneNumber" : "phoneNumber") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        DesktopPhoneInput,
        {
          id: "phone",
          autoComplete: "tel",
          value: me,
          onChange: ue
        }
      ),
      Ke ? /* @__PURE__ */ jsxRuntimeExports.jsx(EmailLink, { onClick: $e, children: Je("instantVerifyConsent.emailLinkText") }) : null,
      He ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        Checkbox,
        {
          id: "optInEnabledCheckbox",
          handleChange: Ge,
          text: Xe,
          defaultChecked: He
        }
      ) : null,
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledButton$5, { disabled: Qe, onClick: Ue, children: Je("common.continue") })
    ] })
  ] });
}, asYouType$1 = new AsYouType(), Content$4 = qe.div`
  width: 100%;
  ${(me) => me.isInstantVerify ? `
      height: 100%;
      padding: 20px 24px;
    ` : `
      padding: 12px 24px;
      margin-top: 30px;
    `};
`, PhoneHeader = qe.h2`
  text-align: ${(me) => me.isInstantVerify ? "left" : "center"};
`, Container$9 = qe.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`, getErrorTranslationKey$2 = (me) => me === "Bad Request" ? "phone.invalid" : "phone.genericError", Phone = ({
  token: me,
  optinEnabled: ue,
  optinCompanyName: Qe,
  isInstantVerify: Ue = !1,
  onSuccess: He,
  onStepChange: Ge
}) => {
  const { t: Xe } = useTranslation(), [Ke, $e] = useState(!0), [, Je] = useState(null), [Ze, nt] = useState(!1), [tt, et] = useState(""), [rt, it] = useState(""), [ot, at] = useState(!1), [st, ut] = useState(ue), [lt, dt] = useState();
  useModuleEvents({
    module: eventModuleNames.phone,
    token: me.token
  }), useScreenEvents({
    module: eventModuleNames.phone,
    screen: Ue ? eventScreenNames.instantVerify : eventScreenNames.phoneInput,
    token: me.token
  }), useEffect(() => {
    getStartInfo(me).then((wt) => {
      et(wt.phonePrefix), it(wt.ipIsoCode), at(!0);
    });
  }, [me]);
  const At = async (wt) => {
    try {
      const Bt = Ue ? await addPhoneInstantVerify({
        phone: wt,
        token: me.token,
        ...ue ? { optInGranted: st } : null
      }) : await addPhone({
        phone: wt,
        token: me.token,
        ...ue ? { optInGranted: st } : null
      });
      if (addEvent({
        code: "continue",
        token: me.token,
        module: eventModuleNames.phone,
        screen: Ue ? eventScreenNames.instantVerify : eventScreenNames.phoneInput
      }), Je(null), He)
        return He(Bt.data);
    } catch (Bt) {
      Je(Xe(getErrorTranslationKey$2(Bt.error)));
    } finally {
      nt(!1);
    }
  }, pt = async () => {
    if (!Ze)
      try {
        nt(!0);
        const wt = Ue ? await addPhoneInstantVerify({
          phone: lt,
          token: me.token,
          ...ue ? { optInGranted: st } : null
        }) : await addPhone({
          phone: lt,
          token: me.token,
          ...ue ? { optInGranted: st } : null
        });
        if (addEvent({
          code: "continue",
          token: me.token,
          module: eventModuleNames.phone,
          screen: Ue ? eventScreenNames.instantVerify : eventScreenNames.phoneInput
        }), Je(null), He)
          return He(wt.data);
      } catch (wt) {
        Je(Xe(getErrorTranslationKey$2(wt.error))), nt(!1);
      }
  }, gt = ({ target: { value: wt } }) => {
    const Bt = parsePhoneNumber(wt), Tt = asYouType$1.input(wt);
    et(Tt), asYouType$1.reset(), Je(null), Bt != null && Bt.isValid() ? (dt(wt), $e(!1)) : $e(!0);
  };
  return mobile.isDesktop() ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    DesktopPhone,
    {
      formattedNumber: tt,
      onChange: gt,
      disabled: Ke || Ze,
      onClick: pt,
      optinEnabled: ue,
      optInOnChange: () => ut(!st),
      finishGptOptInLabel: Xe("common.finishGptOptInLabel", {
        company_name: Qe
      }),
      isInstantVerify: Ue,
      onStepChange: Ge
    }
  ) : ot ? /* @__PURE__ */ jsxRuntimeExports.jsx(Container$9, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Content$4, { isInstantVerify: Ue, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(PhoneHeader, { isInstantVerify: Ue, children: Xe(Ue ? "instantVerifyConsent.enterPhoneNumber" : "enterPhoneNumber") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Phone$1,
      {
        handleNext: At,
        countryISOCode: rt,
        translations: {
          nextButtonTitle: Xe("common.continue"),
          searchForCountry: Xe("common.searchForCountry"),
          finishGptOptInLabel: Xe("common.finishGptOptInLabel", {
            company_name: Qe
          }),
          instantVerifyEmailLink: Xe("instantVerifyConsent.emailLinkText")
        },
        optinEnabled: ue,
        optInOnChange: () => ut(!st),
        isInstantVerify: Ue,
        onStepChange: Ge
      }
    )
  ] }) }) : null;
}, phoneNumberSteps = {
  PhoneNumber: 0,
  OTP: 1
};
function PhoneNumberOrchestrator(me) {
  const { setStep: ue, currentStep: Qe } = useSteps(() => phoneNumberSteps.PhoneNumber);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Steps, { currentStep: Qe, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Phone,
      {
        ...me,
        onSuccess: () => me.otpVerification ? ue(phoneNumberSteps.OTP) : me.onSuccess()
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      SMSOTP,
      {
        ...me,
        numberOfTries: 3,
        goBack: () => ue(phoneNumberSteps.PhoneNumber)
      }
    )
  ] });
}
function renderPhone(me, {
  onSuccess: ue,
  onError: Qe,
  session: Ue,
  optinEnabled: He,
  optinCompanyName: Ge,
  otpVerification: Xe,
  onLog: Ke = emptyFunc
}) {
  const $e = createRoot(me), Je = {
    onBoarding: this,
    onLog: Ke,
    token: Ue,
    onSuccess: handleUnmountRoot(ue, $e, me),
    onError: handleUnmountRoot(Qe, $e, me),
    optinEnabled: He,
    optinCompanyName: Ge,
    otpVerification: Xe
  };
  $e.render(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { token: Ue.token, children: /* @__PURE__ */ jsxRuntimeExports.jsx(PhoneNumberOrchestrator, { ...Je }) })
  );
}
const warrningIcon = "data:image/svg+xml,%3csvg%20width='33'%20height='32'%20viewBox='0%200%2033%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_18_21793)'%3e%3cpath%20d='M16.5%2028C23.1274%2028%2028.5%2022.6274%2028.5%2016C28.5%209.37258%2023.1274%204%2016.5%204C9.87258%204%204.5%209.37258%204.5%2016C4.5%2022.6274%209.87258%2028%2016.5%2028Z'%20stroke='%23FF5C6F'%20stroke-width='2'%20stroke-miterlimit='10'/%3e%3cpath%20d='M16.5%2017V10'%20stroke='%23FF5C6F'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M16.5%2023C17.3284%2023%2018%2022.3284%2018%2021.5C18%2020.6716%2017.3284%2020%2016.5%2020C15.6716%2020%2015%2020.6716%2015%2021.5C15%2022.3284%2015.6716%2023%2016.5%2023Z'%20fill='%23FF5C6F'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_18_21793'%3e%3crect%20width='32'%20height='32'%20fill='white'%20transform='translate(0.5)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", ModalIcon = qe.img``, ModalHeader = qe.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`, ModalTitle$1 = qe.div`
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
`, ModalDescription = qe.div`
  text-align: center;
  font-size: 16px;
  font-weight: 400;
`, ModalActions = qe.div`
  display: flex;
  padding: 16px 0px 12px 0px;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  align-self: stretch;
`, ModalActionStyledButton = qe(Button$a)`
  text-transform: unset;
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
`, ModalActionDeclineSharing = qe.div`
  color: #2266d8;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
`, customStyles$4 = {
  overlay: {
    zIndex: 9999999999,
    background: "rgba(0,0,0,0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "fixed",
    top: 0,
    left: 0
  },
  content: {
    display: "flex",
    width: "335px",
    padding: "16px",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
    borderRadius: "16px",
    border: "1px solid #ECECEC",
    background: "#FFF",
    boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.06)"
  }
}, DeclineSharingModal = ({
  isOpen: me,
  onClose: ue
}) => {
  const { t: Qe } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Modal,
    {
      className: "DeclineSharingModal",
      isOpen: me,
      style: customStyles$4,
      appElement: document.body,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(ModalIcon, { src: warrningIcon }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalHeader, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ModalTitle$1, { children: Qe("instantVerifyConsent.declineSharingModal.title") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(ModalDescription, { children: Qe("instantVerifyConsent.declineSharingModal.description") })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalActions, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ModalActionStyledButton, { onClick: () => ue(), children: Qe("instantVerifyConsent.declineSharingModal.no") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(ModalActionDeclineSharing, { onClick: () => ue(!0), children: Qe("instantVerifyConsent.declineSharingModal.yes") })
        ] })
      ]
    }
  );
}, errorIcon = "data:image/svg+xml,%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='8'%20cy='8'%20r='8'%20fill='%23FF5C6F'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M11.1007%206.31501C11.4912%205.92449%2011.4912%205.29132%2011.1007%204.9008C10.7102%204.51028%2010.077%204.51028%209.68649%204.90081L8.00148%206.58582L6.31648%204.90081C5.92596%204.51028%205.2928%204.51028%204.90227%204.9008C4.51174%205.29132%204.51174%205.92449%204.90227%206.31501L6.58728%208.00004L4.90227%209.68506C4.51174%2010.0756%204.51174%2010.7087%204.90227%2011.0993C5.2928%2011.4898%205.92596%2011.4898%206.31648%2011.0993L8.00148%209.41425L9.68649%2011.0993C10.077%2011.4898%2010.7102%2011.4898%2011.1007%2011.0993C11.4912%2010.7087%2011.4912%2010.0756%2011.1007%209.68506L9.41569%208.00004L11.1007%206.31501Z'%20fill='white'/%3e%3c/svg%3e", ErrorWrapper = qe.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  ${(me) => me.centered ? "justify-content: center;" : ""}
`, ErrorText = qe.div`
  color: #ff5c6f;
  font-size: 14px;
  font-weight: 500;
`, ErrorMessage$3 = ({
  errorMessage: me,
  centered: ue
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(ErrorWrapper, { centered: ue, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: errorIcon, alt: "error icon" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorText, { children: me })
] }), instantVerifyScope = {
  NAME: "NAME",
  DATE_OF_BIRTH: "DATE_OF_BIRTH",
  EMAIL: "EMAIL",
  PHONE: "PHONE",
  ADDRESS: "ADDRESS",
  ID_ATTESTATION: "ID_ATTESTATION"
}, addressIcon$1 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%3e%3cpath%20d='M11.9934%202C16.6561%202%2020.5%205.71789%2020.5%2010.3178C20.5%2012.6357%2019.657%2014.7876%2018.2695%2016.6116C16.7388%2018.6235%2014.8522%2020.3765%2012.7285%2021.7524C12.2425%2022.0704%2011.8039%2022.0944%2011.2704%2021.7524C9.13474%2020.3765%207.24809%2018.6235%205.7305%2016.6116C4.34198%2014.7876%203.5%2012.6357%203.5%2010.3178C3.5%205.71789%207.34388%202%2011.9934%202ZM11.9934%207.77683C10.4517%207.77683%209.19423%209.0478%209.19423%2010.5768C9.19423%2012.1177%2010.4517%2013.3297%2011.9934%2013.3297C13.5362%2013.3297%2014.8058%2012.1177%2014.8058%2010.5768C14.8058%209.0478%2013.5362%207.77683%2011.9934%207.77683Z'%20fill='%23636670'/%3e%3c/svg%3e", dateOfBirthIcon = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%3e%3cpath%20d='M15.6497%202C16.0742%201.99901%2016.4099%202.32884%2016.4109%202.76862L16.4119%203.51824C19.1665%203.73414%2020.9862%205.6112%2020.9891%208.48975L21%2016.9155C21.0039%2020.054%2019.0322%2021.985%2015.8718%2021.99L8.15189%2022C5.0112%2022.004%203.01482%2020.027%203.01087%2016.8796L3.00001%208.55272C2.99606%205.65517%204.75153%203.78311%207.50618%203.53024L7.50519%202.78061C7.5042%202.34083%207.83002%202.01%208.26445%202.01C8.69887%202.009%209.02469%202.33883%209.02568%202.77861L9.02666%203.47826L14.8914%203.47027L14.8904%202.77062C14.8894%202.33084%2015.2152%202.001%2015.6497%202ZM16.0525%2016.1919H16.0426C15.5884%2016.2029%2015.2241%2016.5837%2015.234%2017.0435C15.235%2017.5032%2015.6013%2017.882%2016.0555%2017.892C16.5185%2017.891%2016.8937%2017.5102%2016.8927%2017.0405C16.8927%2016.5707%2016.5165%2016.1919%2016.0525%2016.1919ZM7.91691%2016.1929C7.46274%2016.2129%207.1073%2016.5937%207.10828%2017.0535C7.12902%2017.5132%207.5042%2017.8731%207.95837%2017.8521C8.40366%2017.8321%208.75811%2017.4513%208.73738%2016.9915C8.7275%2016.5417%208.3612%2016.1919%207.91691%2016.1929ZM11.9847%2016.1879C11.5305%2016.2089%2011.1761%2016.5887%2011.1761%2017.0485C11.1968%2017.5082%2011.572%2017.8671%2012.0262%2017.8471C12.4705%2017.8261%2012.8259%2017.4463%2012.8052%2016.9855C12.7953%2016.5367%2012.429%2016.1869%2011.9847%2016.1879ZM7.91197%2012.5947C7.4578%2012.6147%207.10335%2012.9955%207.10433%2013.4553C7.12408%2013.915%207.50025%2014.2749%207.95442%2014.2539C8.39872%2014.2339%208.75317%2013.8531%208.73244%2013.3933C8.72257%2012.9435%208.35725%2012.5937%207.91197%2012.5947ZM11.9807%2012.5597C11.5266%2012.5797%2011.1711%2012.9605%2011.1721%2013.4203C11.1919%2013.8801%2011.568%2014.2389%2012.0222%2014.2189C12.4665%2014.1979%2012.821%2013.8181%2012.8012%2013.3583C12.7904%2012.9085%2012.425%2012.5587%2011.9807%2012.5597ZM16.0485%2012.5647C15.5944%2012.5747%2015.2389%2012.9445%2015.2399%2013.4043V13.4153C15.2498%2013.8751%2015.625%2014.2239%2016.0801%2014.2139C16.5244%2014.2029%2016.8789%2013.8221%2016.869%2013.3623C16.8483%2012.9225%2016.4918%2012.5637%2016.0485%2012.5647ZM14.8934%205.0095L9.02864%205.01749L9.02962%205.82609C9.02962%206.25687%208.70479%206.5967%208.27037%206.5967C7.83595%206.5977%207.50914%206.25887%207.50914%205.82809L7.50815%205.05847C5.58286%205.25138%204.51754%206.38281%204.52049%208.55072L4.52149%208.86157L19.4696%208.84158V8.49175C19.4272%206.34283%2018.349%205.21539%2016.4138%205.04748L16.4148%205.81709C16.4148%206.24688%2016.0801%206.58771%2015.6556%206.58771C15.2212%206.58871%2014.8944%206.24888%2014.8944%205.81909L14.8934%205.0095Z'%20fill='%23636670'/%3e%3c/svg%3e", emailIcon = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M19.495%2017.1874L15.144%2012.4564L14.624%2012.8814C13.892%2013.4914%2012.973%2013.7964%2012.052%2013.7964C11.129%2013.7964%2010.206%2013.4904%209.47%2012.8764L8.893%2012.4144L4.503%2017.1824C4.243%2016.6684%204.082%2016.0884%204.034%2015.4764L7.719%2011.4744L4.032%208.52239C4.078%207.94239%204.222%207.40939%204.453%206.93739L10.419%2011.7154C11.354%2012.4944%2012.747%2012.4934%2013.67%2011.7244L19.54%206.92339C19.774%207.39639%2019.92%207.93139%2019.967%208.51239L16.307%2011.5054L19.965%2015.4834C19.916%2016.0944%2019.755%2016.6744%2019.495%2017.1874ZM21.499%2015.1074C21.499%2015.1054%2021.5%2015.1034%2021.5%2015.1004V8.90039C21.5%208.90039%2021.499%208.89739%2021.499%208.89539C21.499%208.59239%2021.467%208.30239%2021.421%208.01839C21.394%207.82839%2021.357%207.64539%2021.313%207.46339C21.31%207.44839%2021.308%207.43339%2021.305%207.41839L21.301%207.42139C21.172%206.89439%2020.983%206.39939%2020.727%205.95339L20.734%205.94739C20.722%205.92839%2020.708%205.91039%2020.696%205.89139C20.648%205.80839%2020.593%205.73139%2020.54%205.65239C20.413%205.45939%2020.275%205.27739%2020.126%205.10539C20.081%205.05339%2020.04%204.99839%2019.993%204.94939C19.794%204.73739%2019.577%204.54739%2019.346%204.37439C19.296%204.33839%2019.245%204.30539%2019.195%204.27039C18.963%204.11039%2018.721%203.96639%2018.463%203.84839C18.443%203.83939%2018.425%203.82839%2018.406%203.81939C18.132%203.69839%2017.843%203.60939%2017.544%203.54039C17.477%203.52439%2017.409%203.51139%2017.341%203.49839C17.04%203.44139%2016.731%203.40239%2016.41%203.40139C16.406%203.40139%2016.403%203.40039%2016.4%203.40039H7.6C7.596%203.40039%207.594%203.40139%207.59%203.40139C7.252%203.40239%206.93%203.44339%206.616%203.50239C6.575%203.51039%206.535%203.51839%206.495%203.52739C5.079%203.83139%203.931%204.70839%203.236%205.96239L3.259%205.98039C3.006%206.42839%202.818%206.92139%202.69%207.44739L2.681%207.44039C2.672%207.48039%202.667%207.52339%202.658%207.56439C2.628%207.70139%202.602%207.84039%202.581%207.98239C2.534%208.27839%202.5%208.58139%202.5%208.89939V15.1004V15.1034C2.5%2015.4394%202.536%2015.7614%202.59%2016.0754C2.627%2016.3094%202.685%2016.5314%202.747%2016.7554C2.755%2016.7864%202.76%2016.8204%202.769%2016.8504L2.773%2016.8464C3.038%2017.7554%203.479%2018.5804%204.1%2019.2004C4.662%2019.7624%205.352%2020.1464%206.123%2020.3724C6.218%2020.4014%206.311%2020.4324%206.408%2020.4554C6.527%2020.4834%206.647%2020.5064%206.77%2020.5254C7.035%2020.5684%207.306%2020.5984%207.587%2020.5994C7.591%2020.5994%207.595%2020.6004%207.6%2020.6004H16.4C16.403%2020.6004%2016.407%2020.5994%2016.41%2020.5994C16.724%2020.5994%2017.025%2020.5634%2017.319%2020.5124C17.34%2020.5084%2017.362%2020.5044%2017.383%2020.5004C18.336%2020.3194%2019.173%2019.8854%2019.838%2019.2484C19.858%2019.2304%2019.88%2019.2184%2019.9%2019.2004C19.936%2019.1644%2019.962%2019.1164%2019.997%2019.0794C20.207%2018.8574%2020.404%2018.6224%2020.574%2018.3614L20.573%2018.3594C20.863%2017.9084%2021.067%2017.3924%2021.225%2016.8524L21.237%2016.8654C21.259%2016.7874%2021.27%2016.7034%2021.29%2016.6244C21.333%2016.4524%2021.378%2016.2844%2021.406%2016.1074C21.462%2015.7854%2021.499%2015.4554%2021.499%2015.1074Z'%20fill='%23636670'/%3e%3c/svg%3e", fullNameIcon = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='20'%20height='20'%20viewBox='0%200%2020%2020'%20fill='none'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M14.0074%2015.335L6.29539%2015.346C6.17639%2015.346%206.06139%2015.299%205.97739%2015.215C5.89439%2015.131%205.84639%2015.017%205.84639%2014.898C5.84639%2013.268%207.17739%2011.624%2010.1514%2011.624C13.1244%2011.624%2014.4544%2013.263%2014.4544%2014.887C14.4544%2015.134%2014.2544%2015.335%2014.0074%2015.335ZM10.1514%204.655C11.6914%204.655%2012.9434%205.908%2012.9434%207.448C12.9434%208.988%2011.6914%2010.241%2010.1514%2010.241C8.6104%2010.241%207.35839%208.988%207.35839%207.448C7.35839%205.908%208.6104%204.655%2010.1514%204.655ZM10.1504%200.5C4.95039%200.5%200.650391%204.8%200.650391%2010C0.650391%2015.2%204.95039%2019.5%2010.1504%2019.5C15.3504%2019.5%2019.6504%2015.2%2019.6504%2010C19.6504%204.8%2015.3504%200.5%2010.1504%200.5Z'%20fill='%23636670'/%3e%3c/svg%3e", idAttestationIcon = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M17.7484%2011.2718H14.2414C13.7874%2011.2718%2013.4184%2010.9038%2013.4184%2010.4498C13.4184%209.99478%2013.7874%209.62678%2014.2414%209.62678H17.7484C18.2024%209.62678%2018.5704%209.99478%2018.5704%2010.4498C18.5704%2010.9038%2018.2024%2011.2718%2017.7484%2011.2718ZM17.7484%2014.9808H15.5654C15.1114%2014.9808%2014.7434%2014.6128%2014.7434%2014.1588C14.7434%2013.7038%2015.1114%2013.3358%2015.5654%2013.3358H17.7484C18.2024%2013.3358%2018.5704%2013.7038%2018.5704%2014.1588C18.5704%2014.6128%2018.2024%2014.9808%2017.7484%2014.9808ZM12.4744%2016.4148L6.07539%2016.4238C5.97639%2016.4238%205.88139%2016.3848%205.81139%2016.3158C5.74239%2016.2458%205.70339%2016.1508%205.70339%2016.0528C5.70339%2014.6998%206.80739%2013.3358%209.27439%2013.3358C11.7414%2013.3358%2012.8464%2014.6958%2012.8464%2016.0438C12.8464%2016.2488%2012.6804%2016.4148%2012.4744%2016.4148ZM9.27439%207.55278C10.5524%207.55278%2011.5914%208.59178%2011.5914%209.86978C11.5914%2011.1478%2010.5524%2012.1878%209.27439%2012.1878C7.99639%2012.1878%206.95739%2011.1478%206.95739%209.86978C6.95739%208.59178%207.99639%207.55278%209.27439%207.55278ZM17.0504%203.80078H7.25039C4.55039%203.80078%202.65039%205.80078%202.65039%208.60078V15.4008C2.65039%2018.2008%204.55039%2020.2008%207.25039%2020.2008H17.0504C19.7504%2020.2008%2021.6504%2018.2008%2021.6504%2015.4008V8.60078C21.6504%205.80078%2019.7504%203.80078%2017.0504%203.80078Z'%20fill='%23636670'/%3e%3c/svg%3e", phoneNumberIcon = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M22%2017.3032C21.987%2016.3322%2021.259%2015.6402%2020.251%2014.6822C20.004%2014.4472%2019.735%2014.1912%2019.453%2013.9072C18.153%2012.6072%2017.076%2013.0282%2016.125%2013.4012C15.039%2013.8252%2014.014%2014.2292%2012.144%2012.3582H12.143C10.273%2010.4912%2010.674%209.46524%2011.099%208.37924C11.471%207.42824%2011.893%206.35024%2010.594%205.04824C10.309%204.76324%2010.052%204.49224%209.81505%204.24324C8.85905%203.23824%208.16805%202.51024%207.19905%202.49824C6.40905%202.48624%205.47905%203.02124%204.16305%204.33724C4.15005%204.35124%204.08205%204.41924%204.07005%204.43424C3.78005%204.71924%203.00705%205.47724%203.00005%206.95124C2.98905%209.25824%204.85005%2012.2932%208.53205%2015.9752C12.201%2019.6442%2015.228%2021.5042%2017.531%2021.5032H17.562C19.037%2021.4922%2019.791%2020.7172%2020.075%2020.4252L20.167%2020.3352C21.479%2019.0222%2022.01%2018.1442%2022%2017.3032Z'%20fill='%23636670'/%3e%3c/svg%3e", instantVerifyPrivacyData = [
  {
    id: instantVerifyScope.NAME,
    icon: fullNameIcon,
    text: "instantVerifyConsent.scopes.fullName",
    alt: "full name icon"
  },
  {
    id: instantVerifyScope.DATE_OF_BIRTH,
    icon: dateOfBirthIcon,
    text: "instantVerifyConsent.scopes.dateOfBirth",
    alt: "date of birth icon"
  },
  {
    id: instantVerifyScope.EMAIL,
    icon: emailIcon,
    text: "instantVerifyConsent.scopes.email",
    alt: "email icon"
  },
  {
    id: instantVerifyScope.PHONE,
    icon: phoneNumberIcon,
    text: "instantVerifyConsent.scopes.phoneNumber",
    alt: "phone number icon"
  },
  {
    id: instantVerifyScope.ADDRESS,
    icon: addressIcon$1,
    text: "instantVerifyConsent.scopes.address",
    alt: "address icon"
  },
  {
    id: instantVerifyScope.ID_ATTESTATION,
    icon: idAttestationIcon,
    text: "instantVerifyConsent.scopes.idAttestation",
    alt: "id attestation icon"
  }
], imagePlaceholder = "data:image/svg+xml,%3csvg%20width='43'%20height='43'%20viewBox='0%200%2043%2043'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_84_5982)'%3e%3cpath%20d='M35.7137%208.5918H6.97897C6.25762%208.5918%205.67285%209.17657%205.67285%209.89792V33.4081C5.67285%2034.1295%206.25762%2034.7142%206.97897%2034.7142H35.7137C36.435%2034.7142%2037.0198%2034.1295%2037.0198%2033.4081V9.89792C37.0198%209.17657%2036.435%208.5918%2035.7137%208.5918Z'%20stroke='white'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M25.9172%2019.0404C26.9992%2019.0404%2027.8764%2018.1633%2027.8764%2017.0813C27.8764%2015.9992%2026.9992%2015.1221%2025.9172%2015.1221C24.8352%2015.1221%2023.958%2015.9992%2023.958%2017.0813C23.958%2018.1633%2024.8352%2019.0404%2025.9172%2019.0404Z'%20fill='white'/%3e%3cpath%20d='M24.499%2027.5306L28.6933%2023.3412C28.9382%2023.0965%2029.2703%2022.959%2029.6166%2022.959C29.9628%2022.959%2030.2949%2023.0965%2030.5398%2023.3412L37.0198%2029.8261'%20stroke='white'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M5.67285%2028.2966L14.5447%2019.4231C14.666%2019.3017%2014.81%2019.2053%2014.9686%2019.1396C15.1272%2019.0739%2015.2971%2019.04%2015.4688%2019.04C15.6404%2019.04%2015.8104%2019.0739%2015.9689%2019.1396C16.1275%2019.2053%2016.2715%2019.3017%2016.3929%2019.4231L31.6826%2034.7145'%20stroke='white'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_84_5982'%3e%3crect%20width='41.7959'%20height='41.7959'%20fill='white'%20transform='translate(0.448242%200.754883)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", lines = "data:image/svg+xml,%3csvg%20width='75'%20height='10'%20viewBox='0%200%2075%2010'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M0%201L75%201.00001'%20stroke='%233585F1'%20stroke-width='3'%20stroke-dasharray='2%207'/%3e%3cpath%20d='M0%209L75%209.00001'%20stroke='%23BCBCBC'%20stroke-width='3'%20stroke-dasharray='2%207'/%3e%3c/svg%3e", incodeIdLogo = "data:image/svg+xml,%3csvg%20width='55'%20height='12'%20viewBox='0%200%2055%2012'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_84_5989)'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M22.5631%204.05342C23.6598%204.05342%2024.4901%204.361%2025.0494%204.97978C25.6063%205.59558%2025.8832%206.48262%2025.8832%207.63747C25.8832%208.79225%2025.5973%209.68587%2025.0225%2010.3154C24.4463%2010.9466%2023.6288%2011.2614%2022.5764%2011.2614C21.4885%2011.2614%2020.664%2010.9512%2020.1095%2010.3283L20.0419%2010.2493C19.5344%209.6325%2019.2821%208.76087%2019.2821%207.63747C19.2821%205.25973%2020.3838%204.05342%2022.5631%204.05342ZM37.9539%204.05326C39.0182%204.05326%2039.8057%204.39955%2040.3066%205.0931C40.7807%205.74946%2041.0226%206.65213%2041.0347%207.79946L41.0343%208.04476H36.3598C36.4143%208.63456%2036.5966%209.08121%2036.9054%209.38985C37.2286%209.71326%2037.6916%209.87589%2038.3001%209.87589C38.7015%209.87589%2039.0836%209.8261%2039.4472%209.72611C39.8108%209.62686%2040.1329%209.49848%2040.4117%209.34242L40.5428%209.26908V10.7788L40.49%2010.8019C39.7873%2011.1085%2038.9821%2011.2613%2038.0736%2011.2613C37.0478%2011.2613%2036.2377%2010.949%2035.6483%2010.3233C35.0597%209.69878%2034.7664%208.81472%2034.7664%207.6772C34.7664%206.51379%2035.0432%205.61804%2035.6001%204.99304C36.1582%204.3662%2036.9451%204.05326%2037.9539%204.05326ZM33.3197%201.4209V9.56499C33.3197%209.94606%2033.1612%2010.2701%2032.849%2010.53C32.5459%2010.7822%2032.1661%2010.9674%2031.7107%2011.0859C31.2608%2011.2029%2030.7968%2011.2612%2030.3184%2011.2612C29.3487%2011.2612%2028.5478%2010.9863%2027.9187%2010.4354C27.2849%209.87978%2026.9713%208.9187%2026.9713%207.55712C26.9713%206.4656%2027.2392%205.60823%2027.7777%204.98716C28.3193%204.36377%2029.1192%204.05322%2030.1721%204.05322C30.4185%204.05322%2030.7013%204.08455%2031.0207%204.14721C31.2908%204.20118%2031.5371%204.27695%2031.7601%204.37481V1.4209H33.3197ZM16.0451%204.06624C16.7745%204.06624%2017.4686%204.20129%2018.1271%204.47127L18.1817%204.49367V5.93572L18.0595%205.8842C17.3954%205.60431%2016.7905%205.46491%2016.2446%205.46491C15.5661%205.46491%2015.0653%205.63269%2014.7376%205.96424C14.4103%206.29582%2014.2442%206.82999%2014.2442%207.57092C14.2442%208.34875%2014.4067%208.91111%2014.7266%209.25977C15.0444%209.60685%2015.5617%209.78251%2016.2846%209.78251C16.8744%209.78251%2017.4691%209.63952%2018.0686%209.3528L18.1946%209.29252V10.7386L18.1424%2010.7618C17.4935%2011.0507%2016.7987%2011.1949%2016.0584%2011.1949C15.1435%2011.1949%2014.3715%2010.9433%2013.7457%2010.4399L13.653%2010.3625L13.5824%2010.299C12.9826%209.73703%2012.6847%208.86095%2012.6847%207.67728C12.6847%206.41308%2013.0009%205.49215%2013.6384%204.91971C14.2716%204.35074%2015.0753%204.06624%2016.0451%204.06624ZM3.38931%204.25256L3.40296%2011.0621H1.81667V4.25256H3.38931ZM8.42289%204.06628C9.37384%204.06628%2010.0809%204.26684%2010.543%204.6732C11.0075%205.08212%2011.2379%205.71294%2011.2379%206.56058V11.062H9.6651V6.74709C9.6651%205.86738%209.17911%205.43875%208.17014%205.43875C7.7486%205.43875%207.34299%205.49836%206.95351%205.61753L6.80821%205.66501V11.062H5.235V4.79131L5.28302%204.76682C5.68876%204.5599%206.18079%204.39163%206.76066%204.26082L6.95262%204.21998C7.46181%204.11753%207.95172%204.06628%208.42289%204.06628ZM22.5631%205.39851C21.9423%205.39851%2021.5063%205.58437%2021.2448%205.95335C20.9775%206.33092%2020.842%206.89203%2020.842%207.63747C20.842%208.38291%2020.9817%208.94805%2021.2579%209.33459C21.5281%209.71286%2021.96%209.90263%2022.5631%209.90263C23.7328%209.90263%2024.3108%209.16176%2024.3108%207.63747C24.3108%206.87534%2024.169%206.31074%2023.8897%205.94241C23.6151%205.58072%2023.1754%205.39851%2022.5631%205.39851ZM30.3716%205.4253C29.1645%205.4253%2028.5703%206.132%2028.5703%207.5841C28.5703%208.31242%2028.7082%208.87824%2028.9814%209.28288C29.2466%209.67737%2029.7149%209.87585%2030.3982%209.87585C30.7981%209.87585%2031.132%209.82876%2031.4%209.73494C31.6277%209.65529%2031.7406%209.56221%2031.7578%209.46011L31.7601%209.43204V5.7741L31.6607%205.72203C31.4923%205.63861%2031.3103%205.57205%2031.1148%205.52269C30.8592%205.45778%2030.6115%205.4253%2030.3716%205.4253ZM37.914%205.37255C37.4643%205.37255%2037.1182%205.48904%2036.8699%205.72073C36.6513%205.92478%2036.4971%206.26029%2036.4104%206.72896L36.3929%206.83143H39.4245L39.4088%206.72662C39.3355%206.28138%2039.1925%205.95267%2038.9819%205.73806C38.743%205.49535%2038.3886%205.37255%2037.914%205.37255ZM3.44269%201.88574V3.32468H1.77637V1.88574H3.44269Z'%20fill='%233585F1'/%3e%3c/g%3e%3cpath%20d='M46.079%2011.0082H44.4854V2.9375H46.079V11.0082Z'%20fill='%233585F1'/%3e%3cpath%20d='M49.432%209.55118H50.6841C52.0046%209.55118%2053.1088%208.73159%2053.1088%206.97856C53.1088%205.22554%2052.016%204.39456%2050.6955%204.39456H49.432V9.55118ZM50.7411%2011.0082H47.8611V2.9375H50.7524C53.0519%202.9375%2054.7366%204.42871%2054.7366%206.97856C54.7366%209.52841%2053.0405%2011.0082%2050.7411%2011.0082Z'%20fill='%233585F1'/%3e%3cdefs%3e%3cclipPath%20id='clip0_84_5989'%3e%3crect%20width='40.5979'%20height='10.976'%20fill='white'%20transform='translate(0.9375%200.853516)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", Container$8 = qe.div`
  padding: 0.75rem 1.5rem;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`, Header$4 = qe.div`
  margin-top: 0.375rem;
  margin-bottom: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.75rem;
`, LogoContainer = qe.div`
  width: 72px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border: 1px solid #e9e9eb;
  border-radius: 8px;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.04);
  padding: 0.25rem;
`, LogoPlaceholder = qe.div`
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #bcbcbc;
  border-radius: 7px;
`, IncodeIdLogo = qe.img``, Lines = qe.img``, Title$e = qe.h1`
  color: #20263d;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  margin-top: 0px;
  margin-bottom: 1rem;
  line-height: 22px;
`, Description$3 = qe.div`
  color: #20263d;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`, CheckBox$4 = qe.input.attrs({ type: "checkbox" })`
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;
`, CustomCheckBox$4 = qe.div`
  height: 25px;
  width: 25px;
  position: relative;
  margin-right: 0.625rem;
  background-color: #eee;
  border-radius: 100%;
  cursor: pointer;

  &:after {
    content: '';
    position: absolute;
    display: none;
  }
`, CheckboxLabelWrapper = qe.div`
  width: 100%;
  max-width: 500px;
  display: flex;
  align-items: end;
  flex-grow: 1;
`, CheckboxLabel$2 = qe.label`
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: normal;
  font-size: 14px;
  margin-top: 21px;
  margin-bottom: 1.25rem;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  ${CheckBox$4}:checked ~ ${CustomCheckBox$4} {
    background-color: ${(me) => me.theme.main};
    border: unset;
  }

  ${CheckBox$4}:checked ~ ${CustomCheckBox$4}:after {
    display: block;
  }

  ${CustomCheckBox$4}:after {
    left: 10px;
    top: 7px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  @media only screen and (max-height: 480px) {
    margin: 15px 0;
  }
`;
CheckboxLabel$2.defaultProps = {
  theme
};
qe.div`
  color: #636670;
  font-size: 12px;
  font-weight: 400;
  line-height: 130%;
`;
qe.div`
  line-height: 25px;
  color: #3585f1;
  font-size: 12px;
  font-weight: 700;
  margin-top: 21px;
  margin-bottom: 1.25rem;
  cursor: pointer;
`;
const ButtonWrapper$4 = qe.div`
  width: 100%;
  max-width: 500px;
  margin-bottom: 0.75rem;
`, StyledButton$4 = qe(Button$a)`
  width: 100%;
  font-size: 18px;
  font-weight: 600;
`, Logo$2 = qe.img``, GridContainer = qe.div`
  width: 100%;
  max-width: 500px;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 0.75rem;
  background-color: #f9faff;
  border: 1px solid #efefef;
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1.25rem;
`, GridItem = qe.div`
  display: grid;
  grid-template-columns: 1.5rem 1fr;
  grid-auto-flow: column;
  align-items: center;
  font-weight: 400;
  gap: 0.75rem;
`, IconContainer = qe.div`
  width: 24px;
  height: 26px;
  display: flex;
  align-items: center;
`, IconImage = qe.img`
  max-width: 100%;
  height: auto;
`, DeclineSharing = qe.div`
  color: #3585f1;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  margin-top: 1.5rem;
  cursor: pointer;
`, Text$6 = qe.div`
  color: #20263d;
`, isConsentVisible = !1, InstantVerifyConsent = ({
  token: me,
  onBoarding: ue,
  logoSrc: Qe,
  onFinish: Ue
}) => {
  const { t: He } = useTranslation(), [Ge, Xe] = useState(!1), [Ke, $e] = useState(!0), [Je, Ze] = useState(!1), [nt, tt] = useState(null);
  useScreenEvents({
    module: eventModuleNames.instantVerifyConsent,
    screen: eventScreenNames.instantVerify,
    token: me
  });
  const et = async () => {
    Xe(!0), tt(null);
    try {
      await ue.instantVerifyShareIdentity({ token: me, consentGiven: Ke }), addEvent({
        code: "continue",
        module: eventModuleNames.instantVerifyConsent,
        screen: eventScreenNames.instantVerify,
        token: me
      }), Ue();
    } catch {
      tt(He("onboarding.errors.serverError.message"));
    } finally {
      Xe(!1);
    }
  }, rt = (it) => {
    Ze(!1), it && Ue();
  };
  return Ge ? /* @__PURE__ */ jsxRuntimeExports.jsx(Loader$2, {}) : /* @__PURE__ */ jsxRuntimeExports.jsxs(Container$8, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Header$4, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(LogoContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(IncodeIdLogo, { src: incodeIdLogo }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Lines, { src: lines }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(LogoContainer, { children: Qe ? /* @__PURE__ */ jsxRuntimeExports.jsx(Logo$2, { src: Qe }) : /* @__PURE__ */ jsxRuntimeExports.jsx(LogoPlaceholder, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Logo$2, { src: imagePlaceholder }) }) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Title$e, { children: He("instantVerifyConsent.title") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Description$3, { children: He("instantVerifyConsent.description") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(GridContainer, { children: instantVerifyPrivacyData.map((it) => /* @__PURE__ */ jsxRuntimeExports.jsxs(GridItem, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(IconContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconImage, { src: it.icon, alt: it.alt }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$6, { children: He(it.text) })
    ] }, it.id)) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxLabelWrapper, { children: isConsentVisible }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonWrapper$4, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        StyledButton$4,
        {
          theme,
          disabled: !Ke,
          onClick: et,
          children: He("common.allow")
        }
      ),
      nt && /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorMessage$3, { errorMessage: nt, centered: !0 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(DeclineSharing, { onClick: () => Ze(!0), children: He("instantVerifyConsent.declineSharing") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        DeclineSharingModal,
        {
          isOpen: Je,
          onClose: rt
        }
      )
    ] })
  ] });
};
async function instantVerifyAddEmail({
  token: me,
  email: ue
}) {
  return api.post(
    "/omni/instant/add/email",
    { email: ue },
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).then((Qe) => Qe.data).catch((Qe) => Promise.reject(Qe.response.data));
}
const DesktopEmailContainer = qe.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: #f9faff;
`, DesktopEmailHeader = qe.header`
  display: flex;
  position: absolute;
  width: 100vw;
  height: 80px;
  top: 0;
  align-items: center;
  padding: 10px 20px;
  background-color: #ffffff;
  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.06);
`, Logo$1 = qe.img`
  height: 40px;
`, DesktopEmailContent = qe.div`
  width: 350px;
  text-align: center;
`, DesktopEmailInputLabel = qe.label`
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #20263d;
  align-self: flex-start;
`, InputContainer$3 = qe.div`
  border: 2px solid #979797;
  border-radius: 8px;
  width: 350px;
  height: 58px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 17px 16px;
  gap: 16px;
  font-size: 18px;
  margin-top: 20px;
`, Input$6 = qe.input`
  width: 100%;
  background-color: transparent;
  border-top: 30px;
  border: none;
  font-size: 16px;
  font-weight: 400;
`, StyledButton$3 = qe(Button$a)`
  align-self: flex-end;
  text-transform: uppercase;
  margin-top: 60px;
`, PhoneLink$1 = qe.div`
  color: #3585f1;
  font-size: 14px;
  font-weight: 700;
  margin-top: 20px;
  text-align: left;
`, DesktopEmail = ({
  email: me,
  error: ue,
  handleChange: Qe,
  onStepChange: Ue,
  disabled: He,
  onClick: Ge
}) => {
  const { t: Xe } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(DesktopEmailContainer, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(DesktopEmailHeader, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Logo$1, { src: welcomeLogo, alt: "logo" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(DesktopEmailContent, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(DesktopEmailInputLabel, { htmlFor: "email", children: Xe("instantVerifyConsent.enterEmail") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(InputContainer$3, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Input$6, { value: me, onChange: (Ke) => Qe(Ke) }) }),
      ue && /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorMessage$3, { errorMessage: ue }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(PhoneLink$1, { onClick: Ue, children: Xe("instantVerifyConsent.phoneLinkText") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledButton$3, { disabled: He, onClick: Ge, children: Xe("common.continue") })
    ] })
  ] });
}, EmailContainer = qe.div`
  width: 100%;
  height: 100%;
  padding: 20px 24px;
`, EmailHeader$1 = qe.h2`
  margin: 20px 0;
`, EmailContentWrapper = qe.div`
  height: 90%;
  min-height: 90%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`, InputContainerWrapper = qe.div``, InputContainer$2 = qe.div`
  width: 100%;
  display: flex;
  position: relative;
  border: 2px solid #979797;
  border-radius: 8px;
  padding: 13px 8px;
  color: #20263d;
`, Input$5 = qe.input`
  width: 100%;
  background-color: transparent;
  border-top: 30px;
  border: none;
  font-size: 16px;
  font-weight: 400;
`, PhoneLink = qe.div`
  color: #3585f1;
  font-size: 14px;
  font-weight: 700;
  margin-top: 16px;
`, Button$9 = qe(Button$a)`
  margin-top: 15px;
  text-transform: uppercase;
`;
function getErrorTranslationKey$1(me) {
  return me === "Bad Request" ? "authorization.emailInvalid" : "phone.genericError";
}
function InstantVerifyEmail({ onSuccess: me, token: ue, onStepChange: Qe }) {
  const { t: Ue } = useTranslation(), [He, Ge] = useState(!0), [Xe, Ke] = useState(null), [$e, Je] = useState(!1), [Ze, nt] = useState("");
  useModuleEvents({
    module: eventModuleNames.instantVerifyEmail,
    token: ue.token
  }), useScreenEvents({
    module: eventModuleNames.instantVerifyEmail,
    screen: eventScreenNames.instantVerify,
    token: ue.token
  });
  const tt = async () => {
    if ($e) return;
    const rt = Ze.trim();
    try {
      Je(!0);
      const it = await instantVerifyAddEmail({
        email: rt,
        token: ue.token
      });
      addEvent({
        code: "continue",
        screen: eventScreenNames.instantVerify,
        module: eventModuleNames.instantVerifyEmail,
        token: ue.token
      }), Ke(null), me({ existingUser: it.emailExist });
    } catch (it) {
      Ke(Ue(getErrorTranslationKey$1(it.error)));
    } finally {
      Je(!1);
    }
  };
  function et({ target: { value: rt } }) {
    nt(rt);
    const it = rt.trim();
    it && regex$1.EMAIL_PATTERN.test(it) ? (Ke(null), Ge(!1)) : (Ke(Ue("instantVerifyConsent.incorrectEmailFormat")), Ge(!0));
  }
  return mobile.isDesktop() ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    DesktopEmail,
    {
      email: Ze,
      error: Xe,
      handleChange: et,
      onStepChange: Qe,
      disabled: He || $e,
      onClick: tt
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsxs(EmailContainer, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(EmailHeader$1, { children: Ue("instantVerifyConsent.enterEmail") }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(EmailContentWrapper, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(InputContainerWrapper, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(InputContainer$2, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Input$5, { value: Ze, onChange: (rt) => et(rt) }) }),
        Xe && /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorMessage$3, { errorMessage: Xe }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(PhoneLink, { onClick: Qe, children: Ue("instantVerifyConsent.phoneLinkText") })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Button$9, { disabled: He || $e, onClick: tt, children: Ue("common.continue") })
    ] })
  ] });
}
const PhoneOrEmailSteps = {
  PHONE: 0,
  EMAIL: 1
}, PhoneOrEmail = ({ session: me, onSuccess: ue }) => {
  const { setStep: Qe, currentStep: Ue } = useSteps(PhoneOrEmailSteps.PHONE), He = () => {
    Qe(PhoneOrEmailSteps.EMAIL);
  }, Ge = () => {
    Qe(PhoneOrEmailSteps.PHONE);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Steps, { currentStep: Ue, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Phone,
      {
        token: me,
        onSuccess: ue,
        onStepChange: He,
        isInstantVerify: !0
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      InstantVerifyEmail,
      {
        token: me,
        onSuccess: ue,
        onStepChange: Ge
      }
    )
  ] }) });
}, instantVerifySteps = {
  PHONE_OR_EMAIL: 0,
  SELFIE_LOGIN: 1,
  CONSENT: 2
}, InstantVerify = ({
  onBoarding: me,
  session: ue,
  logoSrc: Qe,
  onFinish: Ue
}) => {
  const [He, Ge] = useState(!1), { setStep: Xe, currentStep: Ke } = useSteps(() => instantVerifySteps.PHONE_OR_EMAIL), $e = async ({ existingUser: Ze }) => {
    if (Ze) {
      Xe(instantVerifySteps.SELFIE_LOGIN);
      return;
    }
    await Je();
  }, Je = async () => {
    Ge(!0);
    try {
      const { modules: Ze } = await me.getInstantVerifyMissingModules({
        token: ue.token
      });
      Ue(Ze);
    } finally {
      Ge(!1);
    }
  };
  return He ? /* @__PURE__ */ jsxRuntimeExports.jsx(Loader$2, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Steps, { currentStep: Ke, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(PhoneOrEmail, { session: ue, onSuccess: $e }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Login,
      {
        token: ue.token,
        onSuccess: () => Xe(instantVerifySteps.CONSENT),
        onError: Je,
        isInstantVerify: !0
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      InstantVerifyConsent,
      {
        logoSrc: Qe,
        onBoarding: me,
        token: ue.token,
        onFinish: Je
      }
    )
  ] }) });
};
function renderInstantVerify(me, { logoSrc: ue, onFinish: Qe, session: Ue }) {
  const He = createRoot(me), Ge = {
    onBoarding: this,
    session: Ue,
    logoSrc: ue,
    onFinish: handleUnmountRoot(Qe, He, me)
  };
  He.render(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(InstantVerify, { ...Ge }) })
  );
}
const createIncodeID = async ({ token: me }) => api.post(
  "/omni/incode-id/approve",
  {},
  {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }
).then((ue) => ue.data).catch((ue) => Promise.reject(ue.response.data)), bannerBackground = "data:image/svg+xml,%3csvg%20preserveAspectRatio='none'%20width='375'%20height='424'%20viewBox='0%200%20375%20424'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20filter='url(%23filter0_d_74_14975)'%3e%3cpath%20d='M0%2027C0%2012.0883%2012.0883%200%2027%200H348C362.912%200%20375%2012.0883%20375%2027V411.709C375%20411.709%20319.873%20395.659%20281.25%20395.659C242.627%20395.659%20219%20403.515%20187.5%20411.709C152.161%20420.902%20130.827%20424%2093.75%20424C56.6727%20424%200%20411.709%200%20411.709L0%2027Z'%20fill='%233585F1'/%3e%3c/g%3e%3cdefs%3e%3cfilter%20id='filter0_d_74_14975'%20x='-10'%20y='-21'%20width='395'%20height='445'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'%20result='hardAlpha'/%3e%3cfeOffset%20dy='-11'/%3e%3cfeGaussianBlur%20stdDeviation='5'/%3e%3cfeComposite%20in2='hardAlpha'%20operator='out'/%3e%3cfeColorMatrix%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200.06%200'/%3e%3cfeBlend%20mode='normal'%20in2='BackgroundImageFix'%20result='effect1_dropShadow_74_14975'/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='effect1_dropShadow_74_14975'%20result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e", closeIcon = "data:image/svg+xml,%3csvg%20width='17'%20height='17'%20viewBox='0%200%2017%2017'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='X'%3e%3cpath%20id='Union'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M15.9571%202.45711C16.3476%202.06658%2016.3476%201.43342%2015.9571%201.04289C15.5666%200.652369%2014.9334%200.652369%2014.5429%201.04289L8.5%207.08579L2.45711%201.04289C2.06658%200.652369%201.43342%200.652369%201.04289%201.04289C0.652369%201.43342%200.652369%202.06658%201.04289%202.45711L7.08579%208.5L1.04289%2014.5429C0.652369%2014.9334%200.652369%2015.5666%201.04289%2015.9571C1.43342%2016.3476%202.06658%2016.3476%202.45711%2015.9571L8.5%209.91421L14.5429%2015.9571C14.9334%2016.3476%2015.5666%2016.3476%2015.9571%2015.9571C16.3476%2015.5666%2016.3476%2014.9334%2015.9571%2014.5429L9.91421%208.5L15.9571%202.45711Z'%20fill='white'/%3e%3c/g%3e%3c/svg%3e", incodeIDIcon = "data:image/svg+xml,%3csvg%20width='102'%20height='20'%20viewBox='0%200%20102%2020'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M40.7489%205.83106C42.8155%205.83106%2044.38%206.39153%2045.434%207.51906C46.4834%208.64114%2047.0051%2010.2575%2047.0051%2012.3618C47.0051%2014.466%2046.4663%2016.0943%2045.3833%2017.2414C44.2975%2018.3916%2042.7571%2018.9652%2040.774%2018.9652C38.7241%2018.9652%2037.1705%2018.3999%2036.1256%2017.2649L35.9982%2017.1209C35.0419%2015.9971%2034.5664%2014.4088%2034.5664%2012.3618C34.5664%208.02917%2036.6425%205.83106%2040.7489%205.83106ZM69.7501%205.83078C71.7557%205.83078%2073.2396%206.46177%2074.1835%207.72553C75.0767%208.92154%2075.5325%2010.5664%2075.5554%2012.657L75.5547%2013.1039H66.7464C66.8491%2014.1787%2067.1926%2014.9925%2067.7745%2015.5549C68.3836%2016.1442%2069.256%2016.4406%2070.4026%2016.4406C71.159%2016.4406%2071.879%2016.3498%2072.564%2016.1676C73.2491%2015.9868%2073.8561%2015.7529%2074.3815%2015.4685L74.6284%2015.3349V18.0859L74.5289%2018.1279C73.2049%2018.6866%2071.6877%2018.9649%2069.9757%2018.9649C68.0428%2018.9649%2066.5164%2018.396%2065.4058%2017.2559C64.2965%2016.1178%2063.7439%2014.5069%2063.7439%2012.4342C63.7439%2010.3143%2064.2655%208.68206%2065.3149%207.54321C66.3666%206.401%2067.8493%205.83078%2069.7501%205.83078ZM61.0178%201.03418V15.8741C61.0178%2016.5684%2060.7192%2017.1588%2060.1309%2017.6324C59.5598%2018.0921%2058.8441%2018.4296%2057.986%2018.6455C57.1382%2018.8586%2056.2639%2018.9649%2055.3624%2018.9649C53.5353%2018.9649%2052.0262%2018.4638%2050.8407%2017.4602C49.6463%2016.4477%2049.0554%2014.6964%2049.0554%2012.2154C49.0554%2010.2264%2049.5602%208.66419%2050.5749%207.53249C51.5954%206.39657%2053.1028%205.8307%2055.0867%205.8307C55.551%205.8307%2056.0839%205.88779%2056.6859%206.00197C57.1947%206.10031%2057.6589%206.23838%2058.0792%206.41669V1.03418H61.0178ZM28.467%205.85443C29.8414%205.85443%2031.1494%206.1005%2032.3901%206.59246L32.493%206.63327V9.26092L32.2627%209.16705C31.0113%208.65705%2029.8715%208.40303%2028.843%208.40303C27.5644%208.40303%2026.6207%208.70875%2026.0033%209.3129C25.3865%209.91708%2025.0735%2010.8904%2025.0735%2012.2405C25.0735%2013.6579%2025.3797%2014.6826%2025.9825%2015.3179C26.5813%2015.9503%2027.5562%2016.2704%2028.9182%2016.2704C30.0296%2016.2704%2031.1503%2016.0099%2032.2799%2015.4874L32.5174%2015.3776V18.0125L32.419%2018.0549C31.1962%2018.5813%2029.887%2018.844%2028.492%2018.844C26.768%2018.844%2025.3134%2018.3856%2024.1342%2017.4682L23.9594%2017.3272L23.8265%2017.2116C22.6962%2016.1875%2022.1348%2014.5912%2022.1348%2012.4343C22.1348%2010.1307%2022.7307%208.45267%2023.9319%207.40958C25.1251%206.37284%2026.6395%205.85443%2028.467%205.85443ZM4.61938%206.19394L4.64511%2018.6021H1.65601V6.19394H4.61938ZM14.1043%205.8545C15.8962%205.8545%2017.2286%206.21996%2018.0992%206.96041C18.9744%207.70552%2019.4087%208.85499%2019.4087%2010.3995V18.6018H16.445V10.7394C16.445%209.1364%2015.5292%208.35536%2013.628%208.35536C12.8337%208.35536%2012.0694%208.46399%2011.3355%208.68114L11.0617%208.76765V18.6018H8.09726V7.17562L8.18774%207.131C8.95228%206.75396%209.87944%206.44734%2010.9721%206.20899L11.3338%206.13456C12.2933%205.94788%2013.2164%205.8545%2014.1043%205.8545ZM40.7489%208.28205C39.5793%208.28205%2038.7577%208.6207%2038.2649%209.29306C37.7612%209.98104%2037.5058%2011.0035%2037.5058%2012.3618C37.5058%2013.7201%2037.7691%2014.7499%2038.2896%2015.4542C38.7987%2016.1435%2039.6125%2016.4893%2040.7489%2016.4893C42.9531%2016.4893%2044.0422%2015.1393%2044.0422%2012.3618C44.0422%2010.9731%2043.775%209.94428%2043.2487%209.27312C42.7314%208.61406%2041.9028%208.28205%2040.7489%208.28205ZM55.4627%208.33085C53.1882%208.33085%2052.0685%209.61858%2052.0685%2012.2645C52.0685%2013.5917%2052.3284%2014.6227%2052.8431%2015.36C53.3429%2016.0788%2054.2253%2016.4405%2055.5128%2016.4405C56.2664%2016.4405%2056.8955%2016.3547%2057.4006%2016.1837C57.8295%2016.0386%2058.0423%2015.869%2058.0747%2015.6829L58.0792%2015.6318V8.96643L57.8918%208.87155C57.5745%208.71954%2057.2316%208.59826%2056.8632%208.50832C56.3816%208.39005%2055.9147%208.33085%2055.4627%208.33085ZM69.6749%208.23474C68.8276%208.23474%2068.1755%208.44701%2067.7077%208.86918C67.2957%209.24099%2067.0051%209.85234%2066.8418%2010.7063L66.8087%2010.8931H72.5213L72.4917%2010.7021C72.3536%209.89077%2072.0841%209.29182%2071.6873%208.90076C71.2372%208.4585%2070.5693%208.23474%2069.6749%208.23474ZM4.71997%201.8812V4.50318H1.58008V1.8812H4.71997Z'%20fill='white'/%3e%3cpath%20d='M85.6005%2019.2091H82.5884V4.50293H85.6005V19.2091Z'%20fill='white'/%3e%3cpath%20d='M91.938%2016.5541H94.3047C96.8005%2016.5541%2098.8875%2015.0607%2098.8875%2011.8664C98.8875%208.67211%2096.822%207.15793%2094.3262%207.15793H91.938V16.5541ZM94.4123%2019.2091H88.9689V4.50293H94.4338C98.7799%204.50293%20101.964%207.22016%20101.964%2011.8664C101.964%2016.5127%2098.7584%2019.2091%2094.4123%2019.2091Z'%20fill='white'/%3e%3c/svg%3e", success$2 = "data:image/svg+xml,%3csvg%20width='72'%20height='72'%20viewBox='0%200%2072%2072'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M36%2069.75C54.6396%2069.75%2069.75%2054.6396%2069.75%2036C69.75%2017.3604%2054.6396%202.25%2036%202.25C17.3604%202.25%202.25%2017.3604%202.25%2036C2.25%2054.6396%2017.3604%2069.75%2036%2069.75Z'%20fill='%230CD5A2'/%3e%3cpath%20d='M49.5%2027L31.4898%2047.25L22.5%2037.125'%20stroke='white'%20stroke-width='4'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", Wrapper$4 = qe.div`
  display: flex;
  flex-direction: column;
  overflow: scroll;
  height: 100%;
`, HeaderWrapper$1 = qe.div`
  position: relative;
  padding: 20px;

  @media only screen and (max-height: 480px) {
    padding: 20px;
  }
`, BackgroundImg$1 = qe.img`
  width: 100vw;
  height: 110%;
  position: absolute;
  top: -10%;
  left: 0;
  z-index: -1;
`, Header$3 = qe.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 71px;
`, HeaderContent = qe.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`, Title$d = qe.div`
  color: white;
  text-align: center;
  font-size: 30px;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: -0.5px;
  margin-top: 16px;
  margin-bottom: 8px;
`, Subtitle$4 = qe.div`
  color: white;
  text-align: center;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.313rem;
  margin-bottom: 30px;
`, SubtitleBold = qe.span`
  color: white;
  font-size: 14px;
  font-weight: 700;
`, Description$2 = qe(Subtitle$4)`
  margin-bottom: 96px;
`, ContentWrapper$1 = qe.div`
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: end;

  @media only screen and (max-height: 480px) {
    padding: 20px;
  }
`, ButtonWrapper$3 = qe.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 10px;
`, Button$8 = qe(Button$a)`
  width: 100%;
`, SuccessUniversalIdentity = ({
  onDone: me
}) => {
  const { t: ue } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Wrapper$4, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(HeaderWrapper$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(BackgroundImg$1, { src: bannerBackground }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Header$3, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: incodeIDIcon, alt: "incode id icon" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "img",
          {
            src: closeIcon,
            alt: "close icon",
            onClick: me,
            onKeyDown: me
          }
        )
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(HeaderContent, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: success$2, alt: "pending cover" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Title$d, { children: ue("universalIdentity.successfullyVerified.title") }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Subtitle$4, { children: [
          ue("universalIdentity.successfullyVerified.subtitle.firstPart"),
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsxs(SubtitleBold, { children: [
            ue("universalIdentity.successfullyVerified.subtitle.bold"),
            " "
          ] }),
          ue("universalIdentity.successfullyVerified.subtitle.secondPart")
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Description$2, { children: ue("universalIdentity.successfullyVerified.description") })
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ContentWrapper$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonWrapper$3, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button$8, { theme, onClick: me, children: ue("instantVerifyConsent.successfullyVerified.done") }) }) })
  ] });
}, clockWise = "data:image/svg+xml,%3csvg%20width='24'%20height='26'%20viewBox='0%200%2024%2026'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='ClockClockwise'%3e%3cpath%20id='Vector'%20d='M12%209.5V14L15.75%2016.25'%20stroke='%23636670'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20id='Vector_2'%20d='M17.25%2011.75H21V8'%20stroke='%23636670'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20id='Vector_3'%20d='M17.663%2020.0004C16.4836%2021.1132%2015.0025%2021.8538%2013.4046%2022.1297C11.8068%2022.4056%2010.163%2022.2045%208.67881%2021.5515C7.19459%2020.8986%205.93569%2019.8227%205.05942%2018.4584C4.18314%2017.0941%203.72834%2015.5017%203.75184%2013.8804C3.77535%2012.2591%204.27612%2010.6806%205.19157%209.34226C6.10703%208.0039%207.39659%206.96499%208.89912%206.35533C10.4016%205.74568%2012.0505%205.59231%2013.6397%205.9144C15.2289%206.23648%2016.6879%207.01974%2017.8345%208.1663C18.938%209.2838%2019.8492%2010.3375%2021.0005%2011.7504'%20stroke='%23636670'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e", folder = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='FolderNotch'%20clip-path='url(%23clip0_4_12263)'%3e%3cpath%20id='Vector'%20d='M12%207.5H20.25C20.4489%207.5%2020.6397%207.57902%2020.7803%207.71967C20.921%207.86032%2021%208.05109%2021%208.25V18.75C21%2018.9489%2020.921%2019.1397%2020.7803%2019.2803C20.6397%2019.421%2020.4489%2019.5%2020.25%2019.5H3.75C3.55109%2019.5%203.36032%2019.421%203.21967%2019.2803C3.07902%2019.1397%203%2018.9489%203%2018.75V9.75'%20stroke='%23636670'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20id='Vector_2'%20d='M8.74969%209.75H3V6C3%205.80109%203.07902%205.61032%203.21967%205.46967C3.36032%205.32902%203.55109%205.25%203.75%205.25H8.74969C8.91197%205.25%209.06987%205.30263%209.19969%205.4L12%207.5L9.19969%209.6C9.06987%209.69737%208.91197%209.75%208.74969%209.75Z'%20stroke='%23636670'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_4_12263'%3e%3crect%20width='24'%20height='24'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", lockKey = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='LockKey'%20clip-path='url(%23clip0_4_12255)'%3e%3cpath%20id='Vector'%20d='M12%2015C13.0355%2015%2013.875%2014.1605%2013.875%2013.125C13.875%2012.0895%2013.0355%2011.25%2012%2011.25C10.9645%2011.25%2010.125%2012.0895%2010.125%2013.125C10.125%2014.1605%2010.9645%2015%2012%2015Z'%20stroke='%23636670'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20id='Vector_2'%20d='M12%2015V17.25'%20stroke='%23636670'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20id='Vector_3'%20d='M19.5%208.25H4.5C4.08579%208.25%203.75%208.58579%203.75%209V19.5C3.75%2019.9142%204.08579%2020.25%204.5%2020.25H19.5C19.9142%2020.25%2020.25%2019.9142%2020.25%2019.5V9C20.25%208.58579%2019.9142%208.25%2019.5%208.25Z'%20stroke='%23636670'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20id='Vector_4'%20d='M8.25%208.25V5.25C8.25%204.25544%208.64509%203.30161%209.34835%202.59835C10.0516%201.89509%2011.0054%201.5%2012%201.5C12.9946%201.5%2013.9484%201.89509%2014.6517%202.59835C15.3549%203.30161%2015.75%204.25544%2015.75%205.25V8.25'%20stroke='%23636670'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_4_12255'%3e%3crect%20width='24'%20height='24'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", ticket = "data:image/svg+xml,%3csvg%20width='24'%20height='26'%20viewBox='0%200%2024%2026'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9%207.25V20.75'%20stroke='%23636670'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M2.25%2017.6741C2.25018%2017.5013%202.30998%2017.3339%202.4193%2017.2002C2.52862%2017.0665%202.68075%2016.9745%202.85%2016.94C3.52817%2016.8023%204.13788%2016.4344%204.57583%2015.8986C5.01377%2015.3627%205.25301%2014.692%205.25301%2014C5.25301%2013.308%205.01377%2012.6373%204.57583%2012.1014C4.13788%2011.5656%203.52817%2011.1977%202.85%2011.06C2.68075%2011.0255%202.52862%2010.9335%202.4193%2010.7998C2.30998%2010.6661%202.25018%2010.4987%202.25%2010.3259V8C2.25%207.80109%202.32902%207.61032%202.46967%207.46967C2.61032%207.32902%202.80109%207.25%203%207.25H21C21.1989%207.25%2021.3897%207.32902%2021.5303%207.46967C21.671%207.61032%2021.75%207.80109%2021.75%208V10.3259C21.7498%2010.4987%2021.69%2010.6661%2021.5807%2010.7998C21.4714%2010.9335%2021.3192%2011.0255%2021.15%2011.06C20.4718%2011.1977%2019.8621%2011.5656%2019.4242%2012.1014C18.9862%2012.6373%2018.747%2013.308%2018.747%2014C18.747%2014.692%2018.9862%2015.3627%2019.4242%2015.8986C19.8621%2016.4344%2020.4718%2016.8023%2021.15%2016.94C21.3192%2016.9745%2021.4714%2017.0665%2021.5807%2017.2002C21.69%2017.3339%2021.7498%2017.5013%2021.75%2017.6741V20C21.75%2020.1989%2021.671%2020.3897%2021.5303%2020.5303C21.3897%2020.671%2021.1989%2020.75%2021%2020.75H3C2.80109%2020.75%202.61032%2020.671%202.46967%2020.5303C2.32902%2020.3897%202.25%2020.1989%202.25%2020V17.6741Z'%20stroke='%23636670'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", Wrapper$3 = qe.div`
  display: flex;
  flex-direction: column;
  overflow: scroll;
  height: 100%;
`, HeaderWrapper = qe.div`
  position: relative;
  padding: 25px;

  @media only screen and (max-height: 480px) {
    padding: 20px;
  }
`, BackgroundImg = qe.img`
  width: 100vw;
  height: 110%;
  position: absolute;
  top: -10%;
  left: 0;
  z-index: -1;
`, Header$2 = qe.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
`, BenefitsList = qe.ul`
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-bottom: 2rem;
  flex-grow: 1;
`, BenefitsItem = qe.li`
  display: flex;
  align-items: center;
  gap: 12px;
`, BenefitItemLabel = qe.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
`, ContentWrapper = qe.div`
  padding: 25px;
  height: 100%;
  display: flex;
  flex-direction: column;

  @media only screen and (max-height: 480px) {
    padding: 20px;
  }
`, Title$c = qe.h1`
  color: white;
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 34px;

  @media only screen and (max-height: 480px) {
    margin: 0 0 6px 0;
  }
`, Subtitle$3 = qe.h3`
  color: white;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;

  @media only screen and (max-height: 480px) {
    margin: 0 0 15px 0;
  }
`, CustomCheckBox$3 = qe.div`
  position: relative;
  height: 25px;
  width: 25px;
  min-width: 25px;
  margin-right: 10px;
  background-color: #eee;
  border-radius: 100%;
  cursor: pointer;

  &:after {
    content: '';
    position: absolute;
    display: none;
  }
`, CheckBox$3 = qe.input.attrs({ type: "checkbox" })`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`, CheckboxLabel$1 = qe.label`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 16px 0;
  font-size: 12px;
  line-height: 130%;
  font-weight: 400;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  color: var(--text-alternate, #636670);

  ${CheckBox$3}:checked ~ ${CustomCheckBox$3} {
    background-color: ${(me) => me.theme.main};
  }

  ${CheckBox$3}:checked ~ ${CustomCheckBox$3}:after {
    display: block;
  }

  ${CustomCheckBox$3}:after {
    left: 10px;
    top: 7px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  @media only screen and (max-height: 480px) {
    margin: 15px 0;
  }
`;
CheckboxLabel$1.defaultProps = {
  theme
};
const CheckboxLabelLinWrapper = qe.div``, CheckboxLabelLink = qe.span`
  color: #3585f1;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
`, ButtonWrapper$2 = qe.div`
  display: flex;
  justify-content: center;
`;
function AcceptCheck$1({ id: me, consentChecked: ue, setConsentChecked: Qe, t: Ue }) {
  function He() {
    Qe(!ue);
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    CheckboxLabel$1,
    {
      htmlFor: me,
      className: "accept-check",
      onChange: He,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(CheckBox$3, { id: me }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(CustomCheckBox$3, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(CheckboxLabelLinWrapper, { children: [
          Ue("universalIdentity.consent.accept"),
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsxs(CheckboxLabelLink, { children: [
            Ue("universalIdentity.consent.termsAndConditions"),
            " "
          ] }),
          Ue("universalIdentity.consent.authorize"),
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxLabelLink, { children: Ue("universalIdentity.consent.privacyPolicy") }),
          "."
        ] })
      ]
    }
  );
}
const UniversalIdentity = ({
  token: me,
  onSkip: ue,
  onSubmit: Qe
}) => {
  const { t: Ue } = useTranslation(), [He, Ge] = useState(!1), [Xe, Ke] = useState(!1), [$e, Je] = useState(null), { currentStep: Ze, nextStep: nt } = useSteps(), tt = [
    {
      icon: clockWise,
      label: Ue("universalIdentity.benefits.saveTime")
    },
    {
      icon: ticket,
      label: Ue("universalIdentity.benefits.seamlessAccess")
    },
    {
      icon: lockKey,
      label: Ue("universalIdentity.benefits.safeData")
    },
    {
      icon: folder,
      label: Ue("universalIdentity.benefits.allInfoOnePlace")
    }
  ], et = async () => {
    Ge(!0), Je(null);
    try {
      const { success: rt } = await createIncodeID({ token: me });
      rt && nt();
    } catch {
      Je(Ue("onboarding.errors.serverError.message"));
    } finally {
      Ge(!1);
    }
  };
  return He ? /* @__PURE__ */ jsxRuntimeExports.jsx(Loader$2, {}) : /* @__PURE__ */ jsxRuntimeExports.jsxs(Steps, { currentStep: Ze, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Wrapper$3, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(HeaderWrapper, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(BackgroundImg, { src: bannerBackground }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Header$2, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: incodeIDIcon, alt: "incode id icon" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "img",
            {
              src: closeIcon,
              alt: "close icon",
              onClick: ue,
              onKeyDown: ue
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Title$c, { children: Ue("universalIdentity.title") }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Subtitle$3, { children: Ue("universalIdentity.subtitle") })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(ContentWrapper, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(BenefitsList, { children: tt.map((rt) => /* @__PURE__ */ jsxRuntimeExports.jsxs(BenefitsItem, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: rt.icon, alt: "benefit icon" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(BenefitItemLabel, { children: rt.label })
        ] }, rt.label)) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          AcceptCheck$1,
          {
            id: "clientConsent",
            consentChecked: Xe,
            setConsentChecked: Ke,
            t: Ue
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonWrapper$2, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Button$a,
          {
            disabled: !Xe,
            theme,
            onClick: et,
            children: Ue("universalIdentity.getIncodeId")
          }
        ) }),
        $e && /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorMessage$3, { errorMessage: $e, centered: !0 })
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(SuccessUniversalIdentity, { onDone: Qe })
  ] });
};
function renderUniversalIdentity(me, { onSkip: ue, onSubmit: Qe, session: Ue }) {
  const He = createRoot$1(me), Ge = {
    token: Ue,
    onSkip: handleUnmountRoot(ue, He, me),
    onSubmit: handleUnmountRoot(Qe, He, me)
  };
  customRender(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(UniversalIdentity, { ...Ge }) }),
    me,
    He
  );
}
const getAddAddressStatementUrl = (me, ue) => `/omni/add/document?type=${ue}&format=${me === "application/pdf" ? "pdf" : "image"}`, addressStatementUrl = "/omni/add/address-statement/v2";
function addAddressStatement({
  token: me,
  file: ue,
  image: Qe,
  docType: Ue = "addressStatement",
  onProgress: He = emptyFunc
}) {
  let Ge;
  return Qe ? Ge = api.post(
    addressStatementUrl,
    { base64Image: Qe },
    {
      headers: {
        "X-Incode-Hardware-Id": me
      },
      onUploadProgress: ({ loaded: Xe, total: Ke }) => He(Xe / Ke * 100)
    }
  ) : Ge = api.post(getAddAddressStatementUrl(ue.type, Ue), ue, {
    headers: {
      "X-Incode-Hardware-Id": me,
      "Content-Type": ue.type
    },
    onUploadProgress: ({ loaded: Xe, total: Ke }) => He(Xe / Ke * 100)
  }), Ge.then((Xe) => Xe.data).catch((Xe) => Promise.reject(Xe.response.data));
}
const addBankInfo = ({
  token: me,
  bankData: ue
}) => api.post("/omni/bav/fetch/account-info", ue, {
  headers: {
    "X-Incode-Hardware-Id": me
  }
}).then((Qe) => Qe.data).catch((Qe) => Promise.reject(Qe.response.data)), addBarcode = ({ token: me, rawBarcode: ue }) => api.post(
  "/omni/add/barcode",
  { rawBarcode: ue },
  {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }
).catch((Qe) => Promise.reject(Qe.response.data));
function addConferenceEvent({
  token: me,
  interviewId: ue,
  opentokSessionId: Qe,
  eventType: Ue,
  details: He,
  eventSource: Ge
}) {
  return api.post(
    "/omni/conference/add/event",
    {
      interviewId: ue,
      opentokSessionId: Qe,
      eventType: Ue,
      details: He,
      eventSource: Ge
    },
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).catch((Xe) => Promise.reject(Xe.response.data));
}
function addCreditCardBack({ token: me, base64Image: ue, onProgress: Qe = emptyFunc }) {
  return api.post(
    "/omni/add/credit-card-back/v2",
    { base64Image: ue },
    {
      headers: {
        "X-Incode-Hardware-Id": me,
        "Content-Type": "application/json"
      },
      onUploadProgress: ({ loaded: Ue, total: He }) => Qe(Ue / He * 100)
    }
  ).then((Ue) => Ue.data).catch((Ue) => Promise.reject(Ue.response.data));
}
function addCreditCardFront({ token: me, base64Image: ue, onProgress: Qe = emptyFunc }) {
  return api.post(
    "/omni/add/credit-card-front/v2",
    { base64Image: ue },
    {
      headers: {
        "X-Incode-Hardware-Id": me,
        "Content-Type": "application/json"
      },
      onUploadProgress: ({ loaded: Ue, total: He }) => Qe(Ue / He * 100)
    }
  ).then((Ue) => Ue.data).catch((Ue) => Promise.reject(Ue.response.data));
}
const addCurpUrl = "/omni/add/curp";
function addCurp(me, ue) {
  return api.post(
    addCurpUrl,
    { curp: me },
    {
      headers: {
        "X-Incode-Hardware-Id": ue
      }
    }
  ).then((Qe) => Qe.data);
}
const addCurpv2Url = "/omni/add/curp/v2";
function addCurpv2(me, ue) {
  return api.post(addCurpv2Url, me, {
    headers: {
      "X-Incode-Hardware-Id": ue
    }
  }).then((Qe) => Qe.data);
}
const addEmail = ({ token: me, email: ue }) => api.post(
  "/omni/add/email",
  { email: ue },
  {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }
).then((Qe) => Qe.data).catch((Qe) => Promise.reject(Qe.response.data));
function addFrontSecondId({ token: me, image: ue, onProgress: Qe = emptyFunc }) {
  return api.post("/omni/add/front-second-id", ue, {
    headers: {
      "X-Incode-Hardware-Id": me,
      "Content-Type": "image/jpeg"
    },
    onUploadProgress: ({ loaded: Ue, total: He }) => Qe(Ue / He * 100)
  }).then((Ue) => Ue.data).catch((Ue) => Promise.reject(Ue.response.data));
}
function addGeolocation({ token: me, latitude: ue, longitude: Qe }) {
  return api.post(
    "/omni/add/geolocation",
    {
      longitude: Qe,
      latitude: ue
    },
    {
      headers: {
        "X-Incode-Hardware-Id": me.token
      }
    }
  ).then((Ue) => Ue.data).catch((Ue) => {
    var He;
    return Promise.reject((He = Ue.response) == null ? void 0 : He.data);
  });
}
function addInitials({ token: me, image: ue, type: Qe }) {
  return api.post("/omni/add/initials", ue, {
    headers: {
      "X-Incode-Hardware-Id": me,
      "Content-Type": "image/jpeg"
    },
    params: {
      type: Qe
    }
  }).then((Ue) => Ue.data).catch((Ue) => {
    var He;
    return Promise.reject((He = Ue.response) == null ? void 0 : He.data);
  });
}
const addMLConsent = ({ token: me, mlConsentChecked: ue, id: Qe }) => api.post(
  "/omni/consents/submit",
  {
    consents: [
      {
        isSigned: ue,
        id: Qe
      }
    ]
  },
  {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }
).then((Ue) => Ue.data).catch((Ue) => Promise.reject(Ue.response.data));
function addQrCodeText({ token: me, qrText: ue }) {
  return api.post(
    "/omni/add/qr-code-text",
    { qrCodeText: ue },
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).then((Qe) => Qe.data).catch((Qe) => {
    var Ue;
    return Promise.reject((Ue = Qe.response) == null ? void 0 : Ue.data);
  });
}
function addSignature({
  token: me,
  image: ue,
  type: Qe,
  sendBase64: Ue = !1
}) {
  const He = Ue ? "/omni/add/signature/v2" : "/omni/add/signature";
  return api.post(He, Ue ? { base64Image: ue } : ue, {
    headers: {
      "X-Incode-Hardware-Id": me,
      "Content-Type": Ue ? "application/json" : "image/jpeg"
    },
    params: {
      type: Qe
    }
  }).then((Ge) => Ge.data).catch((Ge) => {
    var Xe;
    return Promise.reject((Xe = Ge.response) == null ? void 0 : Xe.data);
  });
}
function addSpeech({ token: me, audio: ue, onProgress: Qe = emptyFunc }) {
  return api.post("/omni/add/speech?audioOnly=true", ue, {
    headers: {
      "X-Incode-Hardware-Id": me,
      "Content-Type": "audio/mp4"
    },
    onUploadProgress: ({ loaded: Ue, total: He }) => Qe(Ue / He * 100)
  }).then((Ue) => Ue.data).catch((Ue) => Promise.reject(Ue.response.data));
}
function addToQueue$1({ token: me, queueName: ue = "", interviewCode: Qe }) {
  return api.put(
    `/omni/queue/conference/add?queueName=${ue}`,
    { interviewCode: Qe },
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).then((Ue) => Ue.data);
}
const fail$1 = "data:image/svg+xml,%3csvg%20width='33'%20height='32'%20viewBox='0%200%2033%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M23.8265%2016.0001L31.7457%208.08092C32.2488%207.57834%2032.4999%206.96783%2032.4999%206.24929C32.4999%205.53094%2032.2481%204.92052%2031.7457%204.41766L28.0825%200.754108C27.5798%200.251432%2026.9693%200%2026.2512%200C25.5325%200%2024.9223%200.251432%2024.4193%200.754108L16.5001%208.67332L8.58083%200.754108C8.07834%200.251432%207.46783%200%206.7492%200C6.03113%200%205.42052%200.251432%204.91756%200.754108L1.2542%204.41766C0.751621%204.92014%200.5%205.53094%200.5%206.24929C0.5%206.96783%200.751338%207.57806%201.2542%208.08092L9.17332%2016.0001L1.2542%2023.9194C0.751621%2024.4223%200.5%2025.0325%200.5%2025.7513C0.5%2026.4692%200.751338%2027.0799%201.2542%2027.5825L4.91766%2031.2458C5.42052%2031.7489%206.03122%2032%206.74929%2032C7.46783%2032%208.07806%2031.7482%208.58092%2031.2458L16.5002%2023.3266L24.42%2031.2458C24.9227%2031.7489%2025.5326%2032%2026.2519%2032C26.97%2032%2027.5805%2031.7482%2028.0833%2031.2458L31.7458%2027.5825C32.2489%2027.0802%2032.5%2026.4692%2032.5%2025.7513C32.5%2025.0325%2032.2489%2024.4223%2031.7458%2023.9194L23.8265%2016.0001Z'%20fill='%23FF5C6F'/%3e%3c/svg%3e", filesImg = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_367_7974)'%3e%3cpath%20d='M15.75%2021H5.25C5.05109%2021%204.86032%2020.921%204.71967%2020.7803C4.57902%2020.6397%204.5%2020.4489%204.5%2020.25V6.75C4.5%206.55109%204.57902%206.36032%204.71967%206.21967C4.86032%206.07902%205.05109%206%205.25%206H12.75L16.5%209.75V20.25C16.5%2020.4489%2016.421%2020.6397%2016.2803%2020.7803C16.1397%2020.921%2015.9489%2021%2015.75%2021Z'%20stroke='%23979797'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M7.5%206V3.75C7.5%203.55109%207.57902%203.36032%207.71967%203.21967C7.86032%203.07902%208.05109%203%208.25%203H15.75L19.5%206.75V17.25C19.5%2017.4489%2019.421%2017.6397%2019.2803%2017.7803C19.1397%2017.921%2018.9489%2018%2018.75%2018H16.5'%20stroke='%23979797'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M8.25%2014.25H12.75'%20stroke='%23979797'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M8.25%2017.25H12.75'%20stroke='%23979797'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_367_7974'%3e%3crect%20width='24'%20height='24'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", success$1 = "data:image/svg+xml,%3csvg%20width='49'%20height='48'%20viewBox='0%200%2049%2048'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M44.7413%2012.0554L41.0562%208.27767C40.5509%207.75929%2039.9364%207.5%2039.214%207.5C38.491%207.5%2037.8765%207.75929%2037.3712%208.27767L19.5955%2026.5278L11.629%2018.3332C11.1231%2017.8146%2010.509%2017.5556%209.78662%2017.5556C9.0638%2017.5556%208.44965%2017.8146%207.94379%2018.3332L4.2587%2022.111C3.75284%2022.6295%203.5%2023.2593%203.5%2024.0002C3.5%2024.7405%203.75284%2025.3709%204.2587%2025.8893L14.0676%2035.9445L17.7529%2039.7222C18.2585%2040.241%2018.8728%2040.5%2019.5955%2040.5C20.3178%2040.5%2020.9322%2040.2403%2021.438%2039.7222L25.1233%2035.9445L44.7413%2015.8334C45.2467%2015.3149%2045.5%2014.6852%2045.5%2013.9443C45.5004%2013.2038%2045.2467%2012.574%2044.7413%2012.0554Z'%20fill='%230CD5A2'/%3e%3c/svg%3e", Container$7 = qe.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-top: 10%;
  height: 100%;
  width: 100vw
  padding-bottom: 30px;
`, Content$3 = qe.div`
  padding: 0 15px;
  width: calc(100vw - 30px);
`, Headline$1 = qe.h1`
  font-size: 25px;
  line-height: 35px;
`, Description$1 = qe.p`
  font-size: 14px;
  line-height: 21px;
  margin-bottom: 15px;
`, DocContainer = qe.div`
  border-top: solid 1px #e9e9eb;
  padding: 10px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:last-of-type {
    border-bottom: solid 1px #e9e9eb;
  }

  & span {
    display: flex;
    align-items: center;
    & span {
      display: inline;
      max-width: 180px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  & a {
    &.remove {
      color: #ff5c6f;
    }

    color: #20263d;
    text-decoration: underline;
  }
`, ChecksContainer = qe.div`
  margin-top: 25px;

  & label {
    margin-bottom: 15px;
  }
`, Spinner$3 = qe.div`
  border: 6px solid #20263d;
  border-radius: 50%;
  border-top: 6px solid transparent;
  width: 38px;
  height: 38px;
  margin-bottom: 15px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`, ProcessingText = qe.div`
  color: #636670;
  font-size: 18px;
  line-height: 26px;
`, SpinnerContainer$1 = qe.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  align-items: center;
  padding: 0 15px;
  width: calc(100% - 30px);
  text-align: center;

  ${Headline$1} {
    margin-top: 0;
  }
`, Button$7 = qe(Button$a)`
  margin-bottom: 30px;

  &.download {
    background-color: white;
    border: solid 1px #20263d;
    color: #20263d;
    text-transform: none;
    font-size: 20px;
  }
`, OpacityText = qe.span`
  opacity: 0.5;
`, FileInput = qe.input`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
`, AddInputLabel = qe.label`
  text-decoration: underline;
`, Finish = qe.a`
  display: block;
  text-align: center;
  margin-bottom: 20px;
  font-weight: 900;
  font-size: 20px;
  color: #636670;
`;
function AdvancedElectronicSignature({
  uploadDocument: me = !1,
  downloadDocument: ue = !1,
  onBoarding: Qe,
  onSuccess: Ue,
  onError: He,
  token: Ge
}) {
  const { t: Xe } = useTranslation(), [Ke, $e] = useState([]), [Je, Ze] = useState(!1), [nt, tt] = useState(null), [et, rt] = useState({
    terms: !1,
    signElectronically: !1,
    signDisplayed: !1
  }), [it, ot] = useState(
    () => me ? "UPLOADING" : "SIGNING"
  ), [at, st] = useState("NONE"), ut = (Tt, yt) => {
    rt((Ct) => ({
      ...Ct,
      [Tt]: yt.target.checked
    }));
  }, lt = Ke.length < 1 || Object.values(et).some((Tt) => !Tt), dt = (Tt, yt = 4e3) => {
    if (Tt === "SUCCESS" && ue) {
      st("SUCCESS"), setTimeout(() => {
        st("NONE"), ot("DOWNLOAD");
      }, 2e3);
      return;
    }
    st(Tt), setTimeout(() => {
      Tt === "SUCCESS" ? Ue() : He();
    }, yt);
  }, At = async () => {
    ot("PROCESSING");
    try {
      const Tt = Ke.map((Ct) => Qe.processAdvancedElectronicSignatureDocs({
        token: Ge,
        documentRef: Ct.documentRef
      }));
      (await Promise.all(Tt)).some((Ct) => !Ct.success) ? dt("FAILED") : dt("SUCCESS");
    } catch {
      dt("FAILED");
    }
    ot("SIGNING");
  }, pt = (Tt) => {
    tt(Tt.target.files[0]);
  }, gt = async () => {
    try {
      Ze(!0);
      const { preSignedUrl: Tt } = await Qe.generateAESDocumentUploadUrl({
        token: Ge
      }), yt = new FileReader();
      yt.readAsArrayBuffer(nt), yt.onload = async () => {
        const Ct = yt.result;
        await api.put(Tt, Ct, {
          headers: {
            "Content-Type": "application/pdf"
          }
        }), Ze(!1), ot("SIGNING");
      };
    } catch {
      tt(null), Ze(!1);
    }
  }, wt = (Tt) => {
    Tt.preventDefault(), tt(null);
  }, Bt = async () => {
    try {
      Ke.forEach((Tt) => {
        window.open(Tt.documentUrl, "_blank");
      });
    } catch (Tt) {
      console.error(Tt);
    }
  };
  return useEffect(() => {
    async function Tt() {
      var yt;
      Ze(!0);
      try {
        const Ct = await Qe.getAdvancedElectronicSignatureUnsignedDocs({
          token: Ge
        });
        ((yt = Ct.documents) == null ? void 0 : yt.length) < 1 ? dt("FAILED", 6e3) : $e(Ct.documents);
      } catch {
        dt("FAILED", 6e3);
      }
      Ze(!1);
    }
    it === "SIGNING" && at === "NONE" && Tt();
  }, [
    Qe.getAdvancedElectronicSignatureUnsignedDocs,
    Ge,
    it
  ]), Je ? /* @__PURE__ */ jsxRuntimeExports.jsx(SpinnerContainer$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$3, {}) }) : at !== "NONE" ? /* @__PURE__ */ jsxRuntimeExports.jsx(Container$7, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(SpinnerContainer$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "img",
      {
        src: at === "SUCCESS" ? success$1 : fail$1,
        alt: "result"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Headline$1, { children: Xe(
      `aes.confirmSignature.${at === "SUCCESS" ? "success" : "fail"}`
    ) })
  ] }) }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(Container$7, { children: [
    it === "PROCESSING" ? /* @__PURE__ */ jsxRuntimeExports.jsxs(SpinnerContainer$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$3, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Headline$1, { children: Xe("aes.confirmSignature.spinner.title") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ProcessingText, { children: Xe("aes.confirmSignature.spinner.subtitle") })
    ] }) : null,
    it === "SIGNING" || it === "DOWNLOAD" ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Content$3, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Headline$1, { children: Xe("aes.confirmSignature.title") }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Description$1, { children: Xe("aes.confirmSignature.subtitle") }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: Ke.map((Tt, yt) => /* @__PURE__ */ jsxRuntimeExports.jsxs(DocContainer, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: filesImg, alt: "contract icon" }),
            Xe("aes.confirmSignature.contract"),
            " ",
            yt + 1
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "a",
            {
              href: Tt.documentUrl,
              target: "_blank",
              rel: "noopener noreferrer",
              children: Xe("aes.confirmSignature.viewDocument")
            }
          )
        ] }, Tt.documentRef)) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(ChecksContainer, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Checkbox,
            {
              id: "terms1",
              text: Xe("aes.confirmSignature.terms1.title"),
              handleChange: (Tt) => ut("terms", Tt),
              variant: "square",
              defaultChecked: et.terms,
              disabled: it === "DOWNLOAD"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Checkbox,
            {
              id: "terms2",
              text: Xe("aes.confirmSignature.terms2.title"),
              handleChange: (Tt) => ut("signElectronically", Tt),
              variant: "square",
              defaultChecked: et.signElectronically,
              disabled: it === "DOWNLOAD"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Checkbox,
            {
              id: "terms3",
              text: Xe("aes.confirmSignature.terms3.title"),
              handleChange: (Tt) => ut("signDisplayed", Tt),
              variant: "square",
              defaultChecked: et.signDisplayed,
              disabled: it === "DOWNLOAD"
            }
          )
        ] })
      ] }),
      it === "DOWNLOAD" ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Button$7,
          {
            onClick: Bt,
            disabled: lt,
            theme,
            className: "IncodeSignatureDoneButton download",
            children: Xe("aes.confirmSignature.downloadDocument")
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Finish, { onClick: Ue, children: Xe("aes.confirmSignature.continueAndFinish") })
      ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button$7,
        {
          onClick: At,
          disabled: lt,
          theme,
          className: "IncodeSignatureDoneButton",
          children: Xe("signature.done")
        }
      )
    ] }) : null,
    it === "UPLOADING" ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Content$3, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Headline$1, { children: Xe("aes.confirmSignature.uploadTitle") }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Description$1, { children: Xe("aes.confirmSignature.uploadDescription") }),
        nt ? /* @__PURE__ */ jsxRuntimeExports.jsxs(DocContainer, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: filesImg, alt: "contract icon" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: nt.name })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("a", { onClick: wt, className: "remove", children: Xe("aes.confirmSignature.removeDocument") }) })
        ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(DocContainer, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(OpacityText, { children: Xe("aes.confirmSignature.empty") }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              FileInput,
              {
                type: "file",
                name: "file",
                id: "file",
                accept: "application/pdf",
                onChange: pt
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(AddInputLabel, { htmlFor: "file", children: Xe("aes.confirmSignature.addDocument") })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button$7,
        {
          theme,
          disabled: !nt,
          className: "IncodeSignatureDoneButton",
          onClick: gt,
          children: Xe("forms.button.continue")
        }
      )
    ] }) : null
  ] });
}
function renderAdvancedElectronicSignature(me, {
  onSuccess: ue,
  onError: Qe,
  token: Ue,
  downloadDocument: He = !1,
  uploadDocument: Ge = !1
}) {
  const Xe = createRoot$1(me), Ke = {
    downloadDocument: He,
    uploadDocument: Ge,
    token: Ue,
    onBoarding: this,
    onSuccess: handleUnmountRoot(ue, Xe, me),
    onError: handleUnmountRoot(Qe, Xe, me)
  };
  customRender(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(AdvancedElectronicSignature, { ...Ke }) }),
    me,
    Xe
  );
}
function renderLogin(me, {
  onSuccess: ue,
  onError: Qe,
  timeout: Ue,
  stopAtAccessDenied: He,
  stopAtError: Ge,
  isOneToOne: Xe,
  oneToOneProps: Ke,
  showCustomCameraPermissionScreen: $e,
  isKiosk: Je = !1
}) {
  const Ze = createRoot$1(me), nt = {
    onSuccess: handleUnmountRoot(ue, Ze, me),
    onError: handleUnmountRoot(Qe, Ze, me),
    onBoarding: this,
    timeout: Ue,
    stopAtAccessDenied: He,
    stopAtError: Ge,
    isOneToOne: Xe,
    oneToOneProps: Ke,
    showCustomCameraPermissionScreen: $e,
    isKiosk: Je
  };
  return customRender(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { isKiosk: Je, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Login, { ...nt }) }),
    me,
    Ze
  ), { close: handleUnmountRoot(emptyFunc, Ze, me) };
}
const CaptureButtonContainer$1 = qe(captureButton)`
  position: absolute;
`;
function LoginDesktop({
  onBoarding: me,
  onError: ue,
  onSuccess: Qe,
  timeout: Ue = 4e4,
  stopAtAccessDenied: He = !1
}) {
  const [Ge, Xe] = useState("selfie"), [Ke, $e] = useState(""), [Je, Ze] = useState(""), nt = useRef(null), tt = useRef(!1), et = throttle$1(
    async (ht, It) => {
      MlWasmJSApi$1.resetAllPipelines();
      const vt = ht.getBase64Image();
      await me.identify({ base64Image: vt, faceCoordinates: It }).then(async (Et) => {
        const bt = Et.spoofAttempt === !1, Rt = !!Et.customerId && !Et.error, St = Et.secondFactor, kt = Et.hasLenses, jt = Et.hasFaceMask;
        if (St) {
          Xe("secondFactor"), $e(Et.transactionId), Ze(vt);
          return;
        }
        if (!bt || !Rt || jt || kt) {
          if (wt("error"), Tt((() => {
            switch (!0) {
              case jt:
                return it("notifications.faceMask");
              case kt:
                return it("notifications.lenses");
              case !bt:
                return it("notifications.spoof");
              case !Rt:
                return it("selfie.accessDenied");
              default:
                return "";
            }
          })()), await sleep(3e3), !Rt && He) {
            const Qt = new Error("AccessDenied");
            console.dir(Qt), ue(Qt);
            return;
          }
          Bt({
            response: Et,
            livenessPassed: bt,
            imageBase64: vt
          }), at();
          return;
        }
        rt(Et, vt);
      }).catch(async (Et) => {
        var bt;
        console.error(Et), gt(Et || it("notifications.serverError")), wt("error"), await sleep(3e3), Bt({
          response: (bt = Et == null ? void 0 : Et.response) == null ? void 0 : bt.data,
          livenessPassed: null,
          imageBase64: vt
        }), at();
      });
    },
    300
  );
  async function rt(ht, It) {
    const vt = await me.createNewSession({
      interviewId: ht.interviewId
    });
    Qe({
      ...ht,
      token: vt.token,
      base64Image: It || Je
    });
  }
  const { t: it } = useTranslation(), {
    notificationMessage: ot,
    startAutoDetect: at,
    handleManualCapture: st,
    isSuccess: ut,
    isError: lt,
    isLoading: dt,
    hideCamera: At,
    shouldShowManualCapture: pt,
    handleError: gt,
    setMode: wt,
    resetLoading: Bt,
    setNotificationMessage: Tt
  } = useSelfie({
    timeout: Ue,
    isDetecting: tt,
    handleCapture: et,
    numberOfTries: -1,
    webcam: nt
  });
  if (Ge === "secondFactor")
    return /* @__PURE__ */ jsxRuntimeExports.jsx(SecondFactor, { transactionId: Ke, onSuccess: rt });
  const yt = dt ? it("notifications.uploading") : ot, Ct = dt || lt || ut;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(LoginContainer, { className: "login-desktop-container IncodeLoginDesktopContainer", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(HiddenTitle, { children: "Login Desktop" }),
    pt && /* @__PURE__ */ jsxRuntimeExports.jsxs(
      CaptureButtonContainer$1,
      {
        className: "capture-button-container IncodeLoginDesktopCaptureButtonContainer",
        initial: {
          scale: 0
        },
        animate: {
          scale: 1
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: it("common.takePhoto") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              className: "capture-button",
              onClick: st,
              type: "button",
              children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: captureButton, alt: "capture button" })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(WebcamDesktopContainer, { className: "webcam-container IncodeLoginDesktopWebcamContainer", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        FaceMask$1,
        {
          desktop: !0,
          className: "face-mask-container IncodeLoginDesktopFaceMask",
          isCapturing: ut,
          isLoading: dt,
          error: lt,
          isUploading: Ct,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            FaceFrame$1,
            {
              src: faceFrame$1,
              alt: "face frame",
              className: classNames(
                { hidden: At },
                "face-frame IncodeLoginDesktopFaceFrame"
              )
            }
          )
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Webcam,
        {
          ref: nt,
          type: "loginDesktop",
          videoSource: "user",
          onPlay: () => {
          },
          isSelfie: !0,
          className: "video__selfie IncodeLoginDesktopWebcam",
          onError: ue
        }
      ),
      yt && /* @__PURE__ */ jsxRuntimeExports.jsx(
        Notification$1,
        {
          className: "notification-container IncodeLoginDesktopNotification",
          isLoading: dt,
          isError: lt,
          "aria-live": "assertive",
          children: yt
        }
      ),
      pt && /* @__PURE__ */ jsxRuntimeExports.jsx(
        CaptureButtonContainer$1,
        {
          className: "capture-button-container IncodeLoginDesktopCaptureButtonContainer",
          initial: {
            scale: 0
          },
          animate: {
            scale: 1
          },
          children: /* @__PURE__ */ jsxRuntimeExports.jsx("button", { onClick: st, type: "button", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: captureButton, alt: "capture button" }) })
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("canvas", { id: "canvasFrame", hidden: !0 })
  ] });
}
function renderLoginDesktop(me, { onSuccess: ue, onError: Qe, timeout: Ue, stopAtAccessDenied: He }) {
  const Ge = createRoot$1(me), Xe = {
    onSuccess: handleUnmountRoot(ue, Ge, me),
    onError: handleUnmountRoot(Qe, Ge, me),
    onBoarding: this,
    timeout: Ue,
    stopAtAccessDenied: He
  };
  customRender(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoginDesktop, { ...Xe }) }),
    me,
    Ge
  );
}
function renderLoginIncodeID(me, {
  onCapture: ue,
  timeout: Qe,
  stopAtAccessDenied: Ue,
  stopAtError: He,
  isOneToOne: Ge,
  oneToOneProps: Xe,
  showCustomCameraPermissionScreen: Ke,
  isKiosk: $e = !1
}) {
  const Je = createRoot$1(me), Ze = {
    onSuccess: emptyFunc,
    onError: emptyFunc,
    onCapture: handleUnmountRoot(ue, Je, me),
    onBoarding: this,
    timeout: Qe,
    stopAtAccessDenied: Ue,
    stopAtError: He,
    isOneToOne: Ge,
    oneToOneProps: Xe,
    showCustomCameraPermissionScreen: Ke,
    isKiosk: $e
  };
  return customRender(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { isKiosk: $e, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Login, { ...Ze }) }),
    me,
    Je
  ), { close: handleUnmountRoot(emptyFunc, Je, me) };
}
function compareBackID({ token: me, image: ue }) {
  return api.post(
    "/omni/videoselfie/compare-back-id/v2",
    { base64Image: ue },
    {
      headers: {
        "X-Incode-Hardware-Id": me,
        "Content-Type": "application/json"
      }
    }
  ).then((Qe) => Qe.data);
}
function compareBackOCR({ token: me, image: ue }) {
  return api.post(
    "omni/videoselfie/compare-back-ocr/v2",
    { base64Image: ue },
    {
      headers: {
        "X-Incode-Hardware-Id": me,
        "Content-Type": "application/json"
      }
    }
  ).then((Qe) => Qe.data);
}
function compareGovValidationOTP({ token: me, code: ue }) {
  return api.post(
    `/omni/submit-otp?code=${ue}`,
    {},
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).then((Qe) => Qe.data).catch((Qe) => Promise.reject(Qe.response.data));
}
function compareID({ token: me, image: ue }) {
  return api.post(
    "/omni/videoselfie/compare-id/v2",
    { base64Image: ue },
    {
      headers: {
        "X-Incode-Hardware-Id": me,
        "Content-Type": "application/json"
      }
    }
  ).then((Qe) => Qe.data);
}
async function compareInstantVerifyOTP({
  token: me,
  code: ue
}) {
  return api.get(`/omni/instant/confirm/otp?code=${ue}`, {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }).then((Qe) => Qe.data).catch((Qe) => Promise.reject(Qe.response.data));
}
function compareOCR({ token: me, image: ue }) {
  return api.post(
    "omni/videoselfie/compare-ocr/v2",
    { base64Image: ue },
    {
      headers: {
        "X-Incode-Hardware-Id": me,
        "Content-Type": "application/json"
      }
    }
  ).then((Qe) => Qe.data);
}
function connectToQueue({ token: me, queueName: ue = "" }) {
  return api.post(
    `/omni/queue/conference/connect?queueName=${ue}`,
    {},
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).then((Qe) => Qe.data);
}
const Wrapper$2 = qe.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 25px;
  overflow: scroll;
  height: 100%;
  justify-content: space-between;
`, Title$b = qe.h1`
  font-size: 25px;
  font-style: normal;
  font-weight: 700;
  line-height: 35px;
  color: #20263d;
  margin-bottom: 16px;
  text-align: center;
`, Description = qe.h3`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
  color: #20263d;
  margin-bottom: 60px;
  text-align: center;
`, ConsentWrapper = qe.div`
  display: flex;
  padding: 20px 16px;
  gap: 8px;
  border-radius: 16px;
  background: #f3f3f3;
  margin-bottom: 24px;
`, Consent = qe.div`
  flex: 1;
`, Paragraph$4 = qe.p`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #20263d;
  margin-block-start: 0;
  margin-block-end: 0;
  a {
    color: ${(me) => me.theme.main};
  }
`;
Paragraph$4.defaultProps = {
  theme
};
const CheckBox$2 = qe.input.attrs({ type: "checkbox" })`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 25px;
  width: 25px;
  z-index: 2;
`, CustomCheckBox$2 = qe.div`
  position: relative;
  height: 25px;
  width: 25px;
  min-width: 25px;
  background-color: #fff;
  border-radius: 100%;
  border: 1px solid #e9e9eb;

  &:after {
    content: '';
    position: absolute;
    display: none;
    left: 9px;
    top: 6px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`, CheckBoxWrapper$1 = qe.div`
  width: 25px;
  height: 25px;

  ${CheckBox$2}:checked ~ ${CustomCheckBox$2} {
    background: ${(me) => me.theme.main};
  }

  ${CheckBox$2}:checked ~ ${CustomCheckBox$2}:after {
    display: block;
  }
`;
CheckBoxWrapper$1.defaultProps = {
  theme
};
const ButtonWrapper$1 = qe.div`
  margin-bottom: 60px;
`, Cancel$1 = qe.p`
  font-size: 15.258px;
  font-style: normal;
  font-weight: 700;
  line-height: 16.86px;
  text-align: center;
  cursor: pointer;
  padding-top: 16px;
`, BiometricConsent = ({
  token: me,
  onCancel: ue,
  onSuccess: Qe,
  regulationType: Ue
}) => {
  const { t: He } = useTranslation(), [Ge, Xe] = useState(!1), [Ke, $e] = useState();
  useEffect(() => {
    getPrivacyConsentData({
      session: me,
      type: "MANDATORY",
      regulationType: Ue
    }).then(({ consents: tt }) => $e(tt[0]));
  }, []);
  const Je = () => {
    Xe((tt) => !tt);
  }, Ze = () => {
    addMLConsent({
      token: me.token,
      mlConsentChecked: Ge,
      id: Ke.id
    }).then(() => Qe());
  }, nt = () => {
    addMLConsent({
      token: me.token,
      mlConsentChecked: !1,
      id: Ke.id
    }).then(() => ue());
  };
  return Ke ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Wrapper$2, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Title$b, { children: Ke.title }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Description, { children: "Your verification is powered by Incode. To comply with state regulations, we need your consent for biometric processing." }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(ConsentWrapper, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(CheckBoxWrapper$1, { onClick: Je, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(CheckBox$2, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx(CustomCheckBox$2, {})
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Consent, { children: Ke.text.split(`
`).filter((tt) => !!tt.trim()).map((tt, et) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          Paragraph$4,
          {
            dangerouslySetInnerHTML: { __html: tt }
          },
          et
        )) })
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonWrapper$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Button$a, { theme, onClick: Ze, disabled: !Ge, children: He("biometricConsent.button.continue") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Cancel$1, { onClick: nt, children: He("biometricConsent.button.cancel") })
    ] })
  ] }) : null;
};
function renderBiometricConsent$1(me, { token: ue, onSuccess: Qe, onCancel: Ue, regulationType: He }) {
  const Ge = createRoot$1(me), Xe = {
    onSuccess: handleUnmountRoot(Qe, Ge, me),
    onBoarding: this,
    onCancel: handleUnmountRoot(Ue, Ge, me),
    token: ue,
    regulationType: He
  };
  customRender(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BiometricConsent, { ...Xe }) }),
    me,
    Ge
  );
}
function ok$1() {
}
function unreachable$1() {
}
function parse$2(me) {
  const ue = [], Qe = String(me || "");
  let Ue = Qe.indexOf(","), He = 0, Ge = !1;
  for (; !Ge; ) {
    Ue === -1 && (Ue = Qe.length, Ge = !0);
    const Xe = Qe.slice(He, Ue).trim();
    (Xe || !Ge) && ue.push(Xe), He = Ue + 1, Ue = Qe.indexOf(",", He);
  }
  return ue;
}
function stringify$1(me, ue) {
  const Qe = {};
  return (me[me.length - 1] === "" ? [...me, ""] : me).join(
    (Qe.padRight ? " " : "") + "," + (Qe.padLeft === !1 ? "" : " ")
  ).trim();
}
const nameRe = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, nameReJsx = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, emptyOptions$3 = {};
function name(me, ue) {
  return (emptyOptions$3.jsx ? nameReJsx : nameRe).test(me);
}
const re = /[ \t\n\f\r]/g;
function whitespace(me) {
  return typeof me == "object" ? me.type === "text" ? empty$1(me.value) : !1 : empty$1(me);
}
function empty$1(me) {
  return me.replace(re, "") === "";
}
class Schema {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(ue, Qe, Ue) {
    this.property = ue, this.normal = Qe, Ue && (this.space = Ue);
  }
}
Schema.prototype.property = {};
Schema.prototype.normal = {};
Schema.prototype.space = null;
function merge$1(me, ue) {
  const Qe = {}, Ue = {};
  let He = -1;
  for (; ++He < me.length; )
    Object.assign(Qe, me[He].property), Object.assign(Ue, me[He].normal);
  return new Schema(Qe, Ue, ue);
}
function normalize$1(me) {
  return me.toLowerCase();
}
class Info {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(ue, Qe) {
    this.property = ue, this.attribute = Qe;
  }
}
Info.prototype.space = null;
Info.prototype.boolean = !1;
Info.prototype.booleanish = !1;
Info.prototype.overloadedBoolean = !1;
Info.prototype.number = !1;
Info.prototype.commaSeparated = !1;
Info.prototype.spaceSeparated = !1;
Info.prototype.commaOrSpaceSeparated = !1;
Info.prototype.mustUseProperty = !1;
Info.prototype.defined = !1;
let powers = 0;
const boolean = increment(), booleanish = increment(), overloadedBoolean = increment(), number = increment(), spaceSeparated = increment(), commaSeparated = increment(), commaOrSpaceSeparated = increment();
function increment() {
  return 2 ** ++powers;
}
const types = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean,
  booleanish,
  commaOrSpaceSeparated,
  commaSeparated,
  number,
  overloadedBoolean,
  spaceSeparated
}, Symbol.toStringTag, { value: "Module" })), checks = Object.keys(types);
class DefinedInfo extends Info {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(ue, Qe, Ue, He) {
    let Ge = -1;
    if (super(ue, Qe), mark(this, "space", He), typeof Ue == "number")
      for (; ++Ge < checks.length; ) {
        const Xe = checks[Ge];
        mark(this, checks[Ge], (Ue & types[Xe]) === types[Xe]);
      }
  }
}
DefinedInfo.prototype.defined = !0;
function mark(me, ue, Qe) {
  Qe && (me[ue] = Qe);
}
const own$8 = {}.hasOwnProperty;
function create$1(me) {
  const ue = {}, Qe = {};
  let Ue;
  for (Ue in me.properties)
    if (own$8.call(me.properties, Ue)) {
      const He = me.properties[Ue], Ge = new DefinedInfo(
        Ue,
        me.transform(me.attributes || {}, Ue),
        He,
        me.space
      );
      me.mustUseProperty && me.mustUseProperty.includes(Ue) && (Ge.mustUseProperty = !0), ue[Ue] = Ge, Qe[normalize$1(Ue)] = Ue, Qe[normalize$1(Ge.attribute)] = Ue;
    }
  return new Schema(ue, Qe, me.space);
}
const xlink = create$1({
  space: "xlink",
  transform(me, ue) {
    return "xlink:" + ue.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), xml = create$1({
  space: "xml",
  transform(me, ue) {
    return "xml:" + ue.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function caseSensitiveTransform(me, ue) {
  return ue in me ? me[ue] : ue;
}
function caseInsensitiveTransform(me, ue) {
  return caseSensitiveTransform(me, ue.toLowerCase());
}
const xmlns = create$1({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: caseInsensitiveTransform,
  properties: { xmlns: null, xmlnsXLink: null }
}), aria = create$1({
  transform(me, ue) {
    return ue === "role" ? ue : "aria-" + ue.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: booleanish,
    ariaAutoComplete: null,
    ariaBusy: booleanish,
    ariaChecked: booleanish,
    ariaColCount: number,
    ariaColIndex: number,
    ariaColSpan: number,
    ariaControls: spaceSeparated,
    ariaCurrent: null,
    ariaDescribedBy: spaceSeparated,
    ariaDetails: null,
    ariaDisabled: booleanish,
    ariaDropEffect: spaceSeparated,
    ariaErrorMessage: null,
    ariaExpanded: booleanish,
    ariaFlowTo: spaceSeparated,
    ariaGrabbed: booleanish,
    ariaHasPopup: null,
    ariaHidden: booleanish,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: spaceSeparated,
    ariaLevel: number,
    ariaLive: null,
    ariaModal: booleanish,
    ariaMultiLine: booleanish,
    ariaMultiSelectable: booleanish,
    ariaOrientation: null,
    ariaOwns: spaceSeparated,
    ariaPlaceholder: null,
    ariaPosInSet: number,
    ariaPressed: booleanish,
    ariaReadOnly: booleanish,
    ariaRelevant: null,
    ariaRequired: booleanish,
    ariaRoleDescription: spaceSeparated,
    ariaRowCount: number,
    ariaRowIndex: number,
    ariaRowSpan: number,
    ariaSelected: booleanish,
    ariaSetSize: number,
    ariaSort: null,
    ariaValueMax: number,
    ariaValueMin: number,
    ariaValueNow: number,
    ariaValueText: null,
    role: null
  }
}), html$2 = create$1({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: caseInsensitiveTransform,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: commaSeparated,
    acceptCharset: spaceSeparated,
    accessKey: spaceSeparated,
    action: null,
    allow: null,
    allowFullScreen: boolean,
    allowPaymentRequest: boolean,
    allowUserMedia: boolean,
    alt: null,
    as: null,
    async: boolean,
    autoCapitalize: null,
    autoComplete: spaceSeparated,
    autoFocus: boolean,
    autoPlay: boolean,
    blocking: spaceSeparated,
    capture: null,
    charSet: null,
    checked: boolean,
    cite: null,
    className: spaceSeparated,
    cols: number,
    colSpan: null,
    content: null,
    contentEditable: booleanish,
    controls: boolean,
    controlsList: spaceSeparated,
    coords: number | commaSeparated,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: boolean,
    defer: boolean,
    dir: null,
    dirName: null,
    disabled: boolean,
    download: overloadedBoolean,
    draggable: booleanish,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: boolean,
    formTarget: null,
    headers: spaceSeparated,
    height: number,
    hidden: boolean,
    high: number,
    href: null,
    hrefLang: null,
    htmlFor: spaceSeparated,
    httpEquiv: spaceSeparated,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: boolean,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: boolean,
    itemId: null,
    itemProp: spaceSeparated,
    itemRef: spaceSeparated,
    itemScope: boolean,
    itemType: spaceSeparated,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: boolean,
    low: number,
    manifest: null,
    max: null,
    maxLength: number,
    media: null,
    method: null,
    min: null,
    minLength: number,
    multiple: boolean,
    muted: boolean,
    name: null,
    nonce: null,
    noModule: boolean,
    noValidate: boolean,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: boolean,
    optimum: number,
    pattern: null,
    ping: spaceSeparated,
    placeholder: null,
    playsInline: boolean,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: boolean,
    referrerPolicy: null,
    rel: spaceSeparated,
    required: boolean,
    reversed: boolean,
    rows: number,
    rowSpan: number,
    sandbox: spaceSeparated,
    scope: null,
    scoped: boolean,
    seamless: boolean,
    selected: boolean,
    shadowRootDelegatesFocus: boolean,
    shadowRootMode: null,
    shape: null,
    size: number,
    sizes: null,
    slot: null,
    span: number,
    spellCheck: booleanish,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: number,
    step: null,
    style: null,
    tabIndex: number,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: boolean,
    useMap: null,
    value: booleanish,
    width: number,
    wrap: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: spaceSeparated,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: number,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: number,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: boolean,
    // Lists. Use CSS to reduce space between items instead
    declare: boolean,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: number,
    // `<img>` and `<object>`
    leftMargin: number,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: number,
    // `<body>`
    marginWidth: number,
    // `<body>`
    noResize: boolean,
    // `<frame>`
    noHref: boolean,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: boolean,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: boolean,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: number,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: booleanish,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: number,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: number,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: boolean,
    disableRemotePlayback: boolean,
    prefix: null,
    property: null,
    results: number,
    security: null,
    unselectable: null
  }
}), svg$1 = create$1({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: caseSensitiveTransform,
  properties: {
    about: commaOrSpaceSeparated,
    accentHeight: number,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: number,
    amplitude: number,
    arabicForm: null,
    ascent: number,
    attributeName: null,
    attributeType: null,
    azimuth: number,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: number,
    by: null,
    calcMode: null,
    capHeight: number,
    className: spaceSeparated,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: number,
    diffuseConstant: number,
    direction: null,
    display: null,
    dur: null,
    divisor: number,
    dominantBaseline: null,
    download: boolean,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: number,
    enableBackground: null,
    end: null,
    event: null,
    exponent: number,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: number,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: commaSeparated,
    g2: commaSeparated,
    glyphName: commaSeparated,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: number,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: number,
    horizOriginX: number,
    horizOriginY: number,
    id: null,
    ideographic: number,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: number,
    k: number,
    k1: number,
    k2: number,
    k3: number,
    k4: number,
    kernelMatrix: commaOrSpaceSeparated,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: number,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: number,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: number,
    overlineThickness: number,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: number,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: spaceSeparated,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: number,
    pointsAtY: number,
    pointsAtZ: number,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: commaOrSpaceSeparated,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: commaOrSpaceSeparated,
    rev: commaOrSpaceSeparated,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: commaOrSpaceSeparated,
    requiredFeatures: commaOrSpaceSeparated,
    requiredFonts: commaOrSpaceSeparated,
    requiredFormats: commaOrSpaceSeparated,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: number,
    specularExponent: number,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: number,
    strikethroughThickness: number,
    string: null,
    stroke: null,
    strokeDashArray: commaOrSpaceSeparated,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: number,
    strokeOpacity: number,
    strokeWidth: null,
    style: null,
    surfaceScale: number,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: commaOrSpaceSeparated,
    tabIndex: number,
    tableValues: null,
    target: null,
    targetX: number,
    targetY: number,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: commaOrSpaceSeparated,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: number,
    underlineThickness: number,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: number,
    values: null,
    vAlphabetic: number,
    vMathematical: number,
    vectorEffect: null,
    vHanging: number,
    vIdeographic: number,
    version: null,
    vertAdvY: number,
    vertOriginX: number,
    vertOriginY: number,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: number,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), valid = /^data[-\w.:]+$/i, dash = /-[a-z]/g, cap$1 = /[A-Z]/g;
function find$1(me, ue) {
  const Qe = normalize$1(ue);
  let Ue = ue, He = Info;
  if (Qe in me.normal)
    return me.property[me.normal[Qe]];
  if (Qe.length > 4 && Qe.slice(0, 4) === "data" && valid.test(ue)) {
    if (ue.charAt(4) === "-") {
      const Ge = ue.slice(5).replace(dash, camelcase);
      Ue = "data" + Ge.charAt(0).toUpperCase() + Ge.slice(1);
    } else {
      const Ge = ue.slice(4);
      if (!dash.test(Ge)) {
        let Xe = Ge.replace(cap$1, kebab);
        Xe.charAt(0) !== "-" && (Xe = "-" + Xe), ue = "data" + Xe;
      }
    }
    He = DefinedInfo;
  }
  return new He(Ue, ue);
}
function kebab(me) {
  return "-" + me.toLowerCase();
}
function camelcase(me) {
  return me.charAt(1).toUpperCase();
}
const hastToReact = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, html$1 = merge$1([xml, xlink, xmlns, aria, html$2], "html"), svg = merge$1([xml, xlink, xmlns, aria, svg$1], "svg");
function parse$1(me) {
  const ue = String(me || "").trim();
  return ue ? ue.split(/[ \t\n\r\f]+/g) : [];
}
function stringify(me) {
  return me.join(" ").trim();
}
var cjs = {}, COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, NEWLINE_REGEX = /\n/g, WHITESPACE_REGEX = /^\s*/, PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, COLON_REGEX = /^:\s*/, VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, SEMICOLON_REGEX = /^[;\s]*/, TRIM_REGEX = /^\s+|\s+$/g, NEWLINE = `
`, FORWARD_SLASH = "/", ASTERISK = "*", EMPTY_STRING = "", TYPE_COMMENT = "comment", TYPE_DECLARATION = "declaration", inlineStyleParser = function(me, ue) {
  if (typeof me != "string")
    throw new TypeError("First argument must be a string");
  if (!me) return [];
  ue = ue || {};
  var Qe = 1, Ue = 1;
  function He(rt) {
    var it = rt.match(NEWLINE_REGEX);
    it && (Qe += it.length);
    var ot = rt.lastIndexOf(NEWLINE);
    Ue = ~ot ? rt.length - ot : Ue + rt.length;
  }
  function Ge() {
    var rt = { line: Qe, column: Ue };
    return function(it) {
      return it.position = new Xe(rt), Je(), it;
    };
  }
  function Xe(rt) {
    this.start = rt, this.end = { line: Qe, column: Ue }, this.source = ue.source;
  }
  Xe.prototype.content = me;
  function Ke(rt) {
    var it = new Error(
      ue.source + ":" + Qe + ":" + Ue + ": " + rt
    );
    if (it.reason = rt, it.filename = ue.source, it.line = Qe, it.column = Ue, it.source = me, !ue.silent) throw it;
  }
  function $e(rt) {
    var it = rt.exec(me);
    if (it) {
      var ot = it[0];
      return He(ot), me = me.slice(ot.length), it;
    }
  }
  function Je() {
    $e(WHITESPACE_REGEX);
  }
  function Ze(rt) {
    var it;
    for (rt = rt || []; it = nt(); )
      it !== !1 && rt.push(it);
    return rt;
  }
  function nt() {
    var rt = Ge();
    if (!(FORWARD_SLASH != me.charAt(0) || ASTERISK != me.charAt(1))) {
      for (var it = 2; EMPTY_STRING != me.charAt(it) && (ASTERISK != me.charAt(it) || FORWARD_SLASH != me.charAt(it + 1)); )
        ++it;
      if (it += 2, EMPTY_STRING === me.charAt(it - 1))
        return Ke("End of comment missing");
      var ot = me.slice(2, it - 2);
      return Ue += 2, He(ot), me = me.slice(it), Ue += 2, rt({
        type: TYPE_COMMENT,
        comment: ot
      });
    }
  }
  function tt() {
    var rt = Ge(), it = $e(PROPERTY_REGEX);
    if (it) {
      if (nt(), !$e(COLON_REGEX)) return Ke("property missing ':'");
      var ot = $e(VALUE_REGEX), at = rt({
        type: TYPE_DECLARATION,
        property: trim$1(it[0].replace(COMMENT_REGEX, EMPTY_STRING)),
        value: ot ? trim$1(ot[0].replace(COMMENT_REGEX, EMPTY_STRING)) : EMPTY_STRING
      });
      return $e(SEMICOLON_REGEX), at;
    }
  }
  function et() {
    var rt = [];
    Ze(rt);
    for (var it; it = tt(); )
      it !== !1 && (rt.push(it), Ze(rt));
    return rt;
  }
  return Je(), et();
};
function trim$1(me) {
  return me ? me.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
}
var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(me) {
  return me && me.__esModule ? me : { default: me };
};
Object.defineProperty(cjs, "__esModule", { value: !0 });
var inline_style_parser_1 = __importDefault(inlineStyleParser);
function StyleToObject(me, ue) {
  var Qe = null;
  if (!me || typeof me != "string")
    return Qe;
  var Ue = (0, inline_style_parser_1.default)(me), He = typeof ue == "function";
  return Ue.forEach(function(Ge) {
    if (Ge.type === "declaration") {
      var Xe = Ge.property, Ke = Ge.value;
      He ? ue(Xe, Ke, Ge) : Ke && (Qe = Qe || {}, Qe[Xe] = Ke);
    }
  }), Qe;
}
var _default$1 = cjs.default = StyleToObject;
const styleToObject = _default$1.default || _default$1, pointEnd = point$3("end"), pointStart = point$3("start");
function point$3(me) {
  return ue;
  function ue(Qe) {
    const Ue = Qe && Qe.position && Qe.position[me] || {};
    if (typeof Ue.line == "number" && Ue.line > 0 && typeof Ue.column == "number" && Ue.column > 0)
      return {
        line: Ue.line,
        column: Ue.column,
        offset: typeof Ue.offset == "number" && Ue.offset > -1 ? Ue.offset : void 0
      };
  }
}
function position$2(me) {
  const ue = pointStart(me), Qe = pointEnd(me);
  if (ue && Qe)
    return { start: ue, end: Qe };
}
function stringifyPosition(me) {
  return !me || typeof me != "object" ? "" : "position" in me || "type" in me ? position$1(me.position) : "start" in me || "end" in me ? position$1(me) : "line" in me || "column" in me ? point$2(me) : "";
}
function point$2(me) {
  return index(me && me.line) + ":" + index(me && me.column);
}
function position$1(me) {
  return point$2(me && me.start) + "-" + point$2(me && me.end);
}
function index(me) {
  return me && typeof me == "number" ? me : 1;
}
class VFileMessage extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(ue, Qe, Ue) {
    super(), typeof Qe == "string" && (Ue = Qe, Qe = void 0);
    let He = "", Ge = {}, Xe = !1;
    if (Qe && ("line" in Qe && "column" in Qe ? Ge = { place: Qe } : "start" in Qe && "end" in Qe ? Ge = { place: Qe } : "type" in Qe ? Ge = {
      ancestors: [Qe],
      place: Qe.position
    } : Ge = { ...Qe }), typeof ue == "string" ? He = ue : !Ge.cause && ue && (Xe = !0, He = ue.message, Ge.cause = ue), !Ge.ruleId && !Ge.source && typeof Ue == "string") {
      const $e = Ue.indexOf(":");
      $e === -1 ? Ge.ruleId = Ue : (Ge.source = Ue.slice(0, $e), Ge.ruleId = Ue.slice($e + 1));
    }
    if (!Ge.place && Ge.ancestors && Ge.ancestors) {
      const $e = Ge.ancestors[Ge.ancestors.length - 1];
      $e && (Ge.place = $e.position);
    }
    const Ke = Ge.place && "start" in Ge.place ? Ge.place.start : Ge.place;
    this.ancestors = Ge.ancestors || void 0, this.cause = Ge.cause || void 0, this.column = Ke ? Ke.column : void 0, this.fatal = void 0, this.file, this.message = He, this.line = Ke ? Ke.line : void 0, this.name = stringifyPosition(Ge.place) || "1:1", this.place = Ge.place || void 0, this.reason = this.message, this.ruleId = Ge.ruleId || void 0, this.source = Ge.source || void 0, this.stack = Xe && Ge.cause && typeof Ge.cause.stack == "string" ? Ge.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
VFileMessage.prototype.file = "";
VFileMessage.prototype.name = "";
VFileMessage.prototype.reason = "";
VFileMessage.prototype.message = "";
VFileMessage.prototype.stack = "";
VFileMessage.prototype.column = void 0;
VFileMessage.prototype.line = void 0;
VFileMessage.prototype.ancestors = void 0;
VFileMessage.prototype.cause = void 0;
VFileMessage.prototype.fatal = void 0;
VFileMessage.prototype.place = void 0;
VFileMessage.prototype.ruleId = void 0;
VFileMessage.prototype.source = void 0;
const own$7 = {}.hasOwnProperty, emptyMap = /* @__PURE__ */ new Map(), cap = /[A-Z]/g, dashSomething = /-([a-z])/g, tableElements = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), tableCellElement = /* @__PURE__ */ new Set(["td", "th"]), docs = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function toJsxRuntime(me, ue) {
  if (!ue || ue.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const Qe = ue.filePath || void 0;
  let Ue;
  if (ue.development) {
    if (typeof ue.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    Ue = developmentCreate(Qe, ue.jsxDEV);
  } else {
    if (typeof ue.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof ue.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    Ue = productionCreate(Qe, ue.jsx, ue.jsxs);
  }
  const He = {
    Fragment: ue.Fragment,
    ancestors: [],
    components: ue.components || {},
    create: Ue,
    elementAttributeNameCase: ue.elementAttributeNameCase || "react",
    evaluater: ue.createEvaluater ? ue.createEvaluater() : void 0,
    filePath: Qe,
    ignoreInvalidStyle: ue.ignoreInvalidStyle || !1,
    passKeys: ue.passKeys !== !1,
    passNode: ue.passNode || !1,
    schema: ue.space === "svg" ? svg : html$1,
    stylePropertyNameCase: ue.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: ue.tableCellAlignToStyle !== !1
  }, Ge = one$3(He, me, void 0);
  return Ge && typeof Ge != "string" ? Ge : He.create(
    me,
    He.Fragment,
    { children: Ge || void 0 },
    void 0
  );
}
function one$3(me, ue, Qe) {
  if (ue.type === "element")
    return element$4(me, ue, Qe);
  if (ue.type === "mdxFlowExpression" || ue.type === "mdxTextExpression")
    return mdxExpression(me, ue);
  if (ue.type === "mdxJsxFlowElement" || ue.type === "mdxJsxTextElement")
    return mdxJsxElement(me, ue, Qe);
  if (ue.type === "mdxjsEsm")
    return mdxEsm(me, ue);
  if (ue.type === "root")
    return root$3(me, ue, Qe);
  if (ue.type === "text")
    return text$5(me, ue);
}
function element$4(me, ue, Qe) {
  const Ue = me.schema;
  let He = Ue;
  ue.tagName.toLowerCase() === "svg" && Ue.space === "html" && (He = svg, me.schema = He), me.ancestors.push(ue);
  const Ge = findComponentFromName(me, ue.tagName, !1), Xe = createElementProps(me, ue);
  let Ke = createChildren(me, ue);
  return tableElements.has(ue.tagName) && (Ke = Ke.filter(function($e) {
    return typeof $e == "string" ? !whitespace($e) : !0;
  })), addNode(me, Xe, Ge, ue), addChildren(Xe, Ke), me.ancestors.pop(), me.schema = Ue, me.create(ue, Ge, Xe, Qe);
}
function mdxExpression(me, ue) {
  if (ue.data && ue.data.estree && me.evaluater) {
    const Ue = ue.data.estree.body[0];
    return Ue.type, /** @type {Child | undefined} */
    me.evaluater.evaluateExpression(Ue.expression);
  }
  crashEstree(me, ue.position);
}
function mdxEsm(me, ue) {
  if (ue.data && ue.data.estree && me.evaluater)
    return (
      /** @type {Child | undefined} */
      me.evaluater.evaluateProgram(ue.data.estree)
    );
  crashEstree(me, ue.position);
}
function mdxJsxElement(me, ue, Qe) {
  const Ue = me.schema;
  let He = Ue;
  ue.name === "svg" && Ue.space === "html" && (He = svg, me.schema = He), me.ancestors.push(ue);
  const Ge = ue.name === null ? me.Fragment : findComponentFromName(me, ue.name, !0), Xe = createJsxElementProps(me, ue), Ke = createChildren(me, ue);
  return addNode(me, Xe, Ge, ue), addChildren(Xe, Ke), me.ancestors.pop(), me.schema = Ue, me.create(ue, Ge, Xe, Qe);
}
function root$3(me, ue, Qe) {
  const Ue = {};
  return addChildren(Ue, createChildren(me, ue)), me.create(ue, me.Fragment, Ue, Qe);
}
function text$5(me, ue) {
  return ue.value;
}
function addNode(me, ue, Qe, Ue) {
  typeof Qe != "string" && Qe !== me.Fragment && me.passNode && (ue.node = Ue);
}
function addChildren(me, ue) {
  if (ue.length > 0) {
    const Qe = ue.length > 1 ? ue : ue[0];
    Qe && (me.children = Qe);
  }
}
function productionCreate(me, ue, Qe) {
  return Ue;
  function Ue(He, Ge, Xe, Ke) {
    const Je = Array.isArray(Xe.children) ? Qe : ue;
    return Ke ? Je(Ge, Xe, Ke) : Je(Ge, Xe);
  }
}
function developmentCreate(me, ue) {
  return Qe;
  function Qe(Ue, He, Ge, Xe) {
    const Ke = Array.isArray(Ge.children), $e = pointStart(Ue);
    return ue(
      He,
      Ge,
      Xe,
      Ke,
      {
        columnNumber: $e ? $e.column - 1 : void 0,
        fileName: me,
        lineNumber: $e ? $e.line : void 0
      },
      void 0
    );
  }
}
function createElementProps(me, ue) {
  const Qe = {};
  let Ue, He;
  for (He in ue.properties)
    if (He !== "children" && own$7.call(ue.properties, He)) {
      const Ge = createProperty$1(me, He, ue.properties[He]);
      if (Ge) {
        const [Xe, Ke] = Ge;
        me.tableCellAlignToStyle && Xe === "align" && typeof Ke == "string" && tableCellElement.has(ue.tagName) ? Ue = Ke : Qe[Xe] = Ke;
      }
    }
  if (Ue) {
    const Ge = (
      /** @type {Style} */
      Qe.style || (Qe.style = {})
    );
    Ge[me.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = Ue;
  }
  return Qe;
}
function createJsxElementProps(me, ue) {
  const Qe = {};
  for (const Ue of ue.attributes)
    if (Ue.type === "mdxJsxExpressionAttribute")
      if (Ue.data && Ue.data.estree && me.evaluater) {
        const Ge = Ue.data.estree.body[0];
        Ge.type;
        const Xe = Ge.expression;
        Xe.type;
        const Ke = Xe.properties[0];
        Ke.type, Object.assign(
          Qe,
          me.evaluater.evaluateExpression(Ke.argument)
        );
      } else
        crashEstree(me, ue.position);
    else {
      const He = Ue.name;
      let Ge;
      if (Ue.value && typeof Ue.value == "object")
        if (Ue.value.data && Ue.value.data.estree && me.evaluater) {
          const Ke = Ue.value.data.estree.body[0];
          Ke.type, Ge = me.evaluater.evaluateExpression(Ke.expression);
        } else
          crashEstree(me, ue.position);
      else
        Ge = Ue.value === null ? !0 : Ue.value;
      Qe[He] = /** @type {Props[keyof Props]} */
      Ge;
    }
  return Qe;
}
function createChildren(me, ue) {
  const Qe = [];
  let Ue = -1;
  const He = me.passKeys ? /* @__PURE__ */ new Map() : emptyMap;
  for (; ++Ue < ue.children.length; ) {
    const Ge = ue.children[Ue];
    let Xe;
    if (me.passKeys) {
      const $e = Ge.type === "element" ? Ge.tagName : Ge.type === "mdxJsxFlowElement" || Ge.type === "mdxJsxTextElement" ? Ge.name : void 0;
      if ($e) {
        const Je = He.get($e) || 0;
        Xe = $e + "-" + Je, He.set($e, Je + 1);
      }
    }
    const Ke = one$3(me, Ge, Xe);
    Ke !== void 0 && Qe.push(Ke);
  }
  return Qe;
}
function createProperty$1(me, ue, Qe) {
  const Ue = find$1(me.schema, ue);
  if (!(Qe == null || typeof Qe == "number" && Number.isNaN(Qe))) {
    if (Array.isArray(Qe) && (Qe = Ue.commaSeparated ? stringify$1(Qe) : stringify(Qe)), Ue.property === "style") {
      let He = typeof Qe == "object" ? Qe : parseStyle(me, String(Qe));
      return me.stylePropertyNameCase === "css" && (He = transformStylesToCssCasing(He)), ["style", He];
    }
    return [
      me.elementAttributeNameCase === "react" && Ue.space ? hastToReact[Ue.property] || Ue.property : Ue.attribute,
      Qe
    ];
  }
}
function parseStyle(me, ue) {
  const Qe = {};
  try {
    styleToObject(ue, Ue);
  } catch (He) {
    if (!me.ignoreInvalidStyle) {
      const Ge = (
        /** @type {Error} */
        He
      ), Xe = new VFileMessage("Cannot parse `style` attribute", {
        ancestors: me.ancestors,
        cause: Ge,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw Xe.file = me.filePath || void 0, Xe.url = docs + "#cannot-parse-style-attribute", Xe;
    }
  }
  return Qe;
  function Ue(He, Ge) {
    let Xe = He;
    Xe.slice(0, 2) !== "--" && (Xe.slice(0, 4) === "-ms-" && (Xe = "ms-" + Xe.slice(4)), Xe = Xe.replace(dashSomething, toCamel)), Qe[Xe] = Ge;
  }
}
function findComponentFromName(me, ue, Qe) {
  let Ue;
  if (!Qe)
    Ue = { type: "Literal", value: ue };
  else if (ue.includes(".")) {
    const He = ue.split(".");
    let Ge = -1, Xe;
    for (; ++Ge < He.length; ) {
      const Ke = name(He[Ge]) ? { type: "Identifier", name: He[Ge] } : { type: "Literal", value: He[Ge] };
      Xe = Xe ? {
        type: "MemberExpression",
        object: Xe,
        property: Ke,
        computed: !!(Ge && Ke.type === "Literal"),
        optional: !1
      } : Ke;
    }
    Ue = Xe;
  } else
    Ue = name(ue) && !/^[a-z]/.test(ue) ? { type: "Identifier", name: ue } : { type: "Literal", value: ue };
  if (Ue.type === "Literal") {
    const He = (
      /** @type {keyof JSX.IntrinsicElements} */
      Ue.value
    );
    return own$7.call(me.components, He) ? me.components[He] : He;
  }
  if (me.evaluater)
    return me.evaluater.evaluateExpression(Ue);
  crashEstree(me);
}
function crashEstree(me, ue) {
  const Qe = new VFileMessage(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: me.ancestors,
      place: ue,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw Qe.file = me.filePath || void 0, Qe.url = docs + "#cannot-handle-mdx-estrees-without-createevaluater", Qe;
}
function transformStylesToCssCasing(me) {
  const ue = {};
  let Qe;
  for (Qe in me)
    own$7.call(me, Qe) && (ue[transformStyleToCssCasing(Qe)] = me[Qe]);
  return ue;
}
function transformStyleToCssCasing(me) {
  let ue = me.replace(cap, toDash);
  return ue.slice(0, 3) === "ms-" && (ue = "-" + ue), ue;
}
function toCamel(me, ue) {
  return ue.toUpperCase();
}
function toDash(me) {
  return "-" + me.toLowerCase();
}
const urlAttributes = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, emptyOptions$2 = {};
function toString$2(me, ue) {
  const Qe = emptyOptions$2, Ue = typeof Qe.includeImageAlt == "boolean" ? Qe.includeImageAlt : !0, He = typeof Qe.includeHtml == "boolean" ? Qe.includeHtml : !0;
  return one$2(me, Ue, He);
}
function one$2(me, ue, Qe) {
  if (node(me)) {
    if ("value" in me)
      return me.type === "html" && !Qe ? "" : me.value;
    if (ue && "alt" in me && me.alt)
      return me.alt;
    if ("children" in me)
      return all$3(me.children, ue, Qe);
  }
  return Array.isArray(me) ? all$3(me, ue, Qe) : "";
}
function all$3(me, ue, Qe) {
  const Ue = [];
  let He = -1;
  for (; ++He < me.length; )
    Ue[He] = one$2(me[He], ue, Qe);
  return Ue.join("");
}
function node(me) {
  return !!(me && typeof me == "object");
}
const element$3 = document.createElement("i");
function decodeNamedCharacterReference(me) {
  const ue = "&" + me + ";";
  element$3.innerHTML = ue;
  const Qe = element$3.textContent;
  return Qe.charCodeAt(Qe.length - 1) === 59 && me !== "semi" || Qe === ue ? !1 : Qe;
}
function splice(me, ue, Qe, Ue) {
  const He = me.length;
  let Ge = 0, Xe;
  if (ue < 0 ? ue = -ue > He ? 0 : He + ue : ue = ue > He ? He : ue, Qe = Qe > 0 ? Qe : 0, Ue.length < 1e4)
    Xe = Array.from(Ue), Xe.unshift(ue, Qe), me.splice(...Xe);
  else
    for (Qe && me.splice(ue, Qe); Ge < Ue.length; )
      Xe = Ue.slice(Ge, Ge + 1e4), Xe.unshift(ue, 0), me.splice(...Xe), Ge += 1e4, ue += 1e4;
}
function push(me, ue) {
  return me.length > 0 ? (splice(me, me.length, 0, ue), me) : ue;
}
const hasOwnProperty = {}.hasOwnProperty;
function combineExtensions(me) {
  const ue = {};
  let Qe = -1;
  for (; ++Qe < me.length; )
    syntaxExtension(ue, me[Qe]);
  return ue;
}
function syntaxExtension(me, ue) {
  let Qe;
  for (Qe in ue) {
    const He = (hasOwnProperty.call(me, Qe) ? me[Qe] : void 0) || (me[Qe] = {}), Ge = ue[Qe];
    let Xe;
    if (Ge)
      for (Xe in Ge) {
        hasOwnProperty.call(He, Xe) || (He[Xe] = []);
        const Ke = Ge[Xe];
        constructs(
          // @ts-expect-error Looks like a list.
          He[Xe],
          Array.isArray(Ke) ? Ke : Ke ? [Ke] : []
        );
      }
  }
}
function constructs(me, ue) {
  let Qe = -1;
  const Ue = [];
  for (; ++Qe < ue.length; )
    (ue[Qe].add === "after" ? me : Ue).push(ue[Qe]);
  splice(me, 0, 0, Ue);
}
function decodeNumericCharacterReference(me, ue) {
  const Qe = Number.parseInt(me, ue);
  return (
    // C0 except for HT, LF, FF, CR, space.
    Qe < 9 || Qe === 11 || Qe > 13 && Qe < 32 || // Control character (DEL) of C0, and C1 controls.
    Qe > 126 && Qe < 160 || // Lone high surrogates and low surrogates.
    Qe > 55295 && Qe < 57344 || // Noncharacters.
    Qe > 64975 && Qe < 65008 || /* eslint-disable no-bitwise */
    (Qe & 65535) === 65535 || (Qe & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    Qe > 1114111 ? "�" : String.fromCodePoint(Qe)
  );
}
function normalizeIdentifier(me) {
  return me.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const asciiAlpha = regexCheck(/[A-Za-z]/), asciiAlphanumeric = regexCheck(/[\dA-Za-z]/), asciiAtext = regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function asciiControl(me) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    me !== null && (me < 32 || me === 127)
  );
}
const asciiDigit = regexCheck(/\d/), asciiHexDigit = regexCheck(/[\dA-Fa-f]/), asciiPunctuation = regexCheck(/[!-/:-@[-`{-~]/);
function markdownLineEnding(me) {
  return me !== null && me < -2;
}
function markdownLineEndingOrSpace(me) {
  return me !== null && (me < 0 || me === 32);
}
function markdownSpace(me) {
  return me === -2 || me === -1 || me === 32;
}
const unicodePunctuation = regexCheck(new RegExp("\\p{P}|\\p{S}", "u")), unicodeWhitespace = regexCheck(/\s/);
function regexCheck(me) {
  return ue;
  function ue(Qe) {
    return Qe !== null && Qe > -1 && me.test(String.fromCharCode(Qe));
  }
}
function normalizeUri(me) {
  const ue = [];
  let Qe = -1, Ue = 0, He = 0;
  for (; ++Qe < me.length; ) {
    const Ge = me.charCodeAt(Qe);
    let Xe = "";
    if (Ge === 37 && asciiAlphanumeric(me.charCodeAt(Qe + 1)) && asciiAlphanumeric(me.charCodeAt(Qe + 2)))
      He = 2;
    else if (Ge < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(Ge)) || (Xe = String.fromCharCode(Ge));
    else if (Ge > 55295 && Ge < 57344) {
      const Ke = me.charCodeAt(Qe + 1);
      Ge < 56320 && Ke > 56319 && Ke < 57344 ? (Xe = String.fromCharCode(Ge, Ke), He = 1) : Xe = "�";
    } else
      Xe = String.fromCharCode(Ge);
    Xe && (ue.push(me.slice(Ue, Qe), encodeURIComponent(Xe)), Ue = Qe + He + 1, Xe = ""), He && (Qe += He, He = 0);
  }
  return ue.join("") + me.slice(Ue);
}
function factorySpace(me, ue, Qe, Ue) {
  const He = Ue ? Ue - 1 : Number.POSITIVE_INFINITY;
  let Ge = 0;
  return Xe;
  function Xe($e) {
    return markdownSpace($e) ? (me.enter(Qe), Ke($e)) : ue($e);
  }
  function Ke($e) {
    return markdownSpace($e) && Ge++ < He ? (me.consume($e), Ke) : (me.exit(Qe), ue($e));
  }
}
const content$1 = {
  tokenize: initializeContent
};
function initializeContent(me) {
  const ue = me.attempt(
    this.parser.constructs.contentInitial,
    Ue,
    He
  );
  let Qe;
  return ue;
  function Ue(Ke) {
    if (Ke === null) {
      me.consume(Ke);
      return;
    }
    return me.enter("lineEnding"), me.consume(Ke), me.exit("lineEnding"), factorySpace(me, ue, "linePrefix");
  }
  function He(Ke) {
    return me.enter("paragraph"), Ge(Ke);
  }
  function Ge(Ke) {
    const $e = me.enter("chunkText", {
      contentType: "text",
      previous: Qe
    });
    return Qe && (Qe.next = $e), Qe = $e, Xe(Ke);
  }
  function Xe(Ke) {
    if (Ke === null) {
      me.exit("chunkText"), me.exit("paragraph"), me.consume(Ke);
      return;
    }
    return markdownLineEnding(Ke) ? (me.consume(Ke), me.exit("chunkText"), Ge) : (me.consume(Ke), Xe);
  }
}
const document$3 = {
  tokenize: initializeDocument
}, containerConstruct = {
  tokenize: tokenizeContainer
};
function initializeDocument(me) {
  const ue = this, Qe = [];
  let Ue = 0, He, Ge, Xe;
  return Ke;
  function Ke(ut) {
    if (Ue < Qe.length) {
      const lt = Qe[Ue];
      return ue.containerState = lt[1], me.attempt(
        lt[0].continuation,
        $e,
        Je
      )(ut);
    }
    return Je(ut);
  }
  function $e(ut) {
    if (Ue++, ue.containerState._closeFlow) {
      ue.containerState._closeFlow = void 0, He && st();
      const lt = ue.events.length;
      let dt = lt, At;
      for (; dt--; )
        if (ue.events[dt][0] === "exit" && ue.events[dt][1].type === "chunkFlow") {
          At = ue.events[dt][1].end;
          break;
        }
      at(Ue);
      let pt = lt;
      for (; pt < ue.events.length; )
        ue.events[pt][1].end = Object.assign({}, At), pt++;
      return splice(
        ue.events,
        dt + 1,
        0,
        ue.events.slice(lt)
      ), ue.events.length = pt, Je(ut);
    }
    return Ke(ut);
  }
  function Je(ut) {
    if (Ue === Qe.length) {
      if (!He)
        return tt(ut);
      if (He.currentConstruct && He.currentConstruct.concrete)
        return rt(ut);
      ue.interrupt = !!(He.currentConstruct && !He._gfmTableDynamicInterruptHack);
    }
    return ue.containerState = {}, me.check(
      containerConstruct,
      Ze,
      nt
    )(ut);
  }
  function Ze(ut) {
    return He && st(), at(Ue), tt(ut);
  }
  function nt(ut) {
    return ue.parser.lazy[ue.now().line] = Ue !== Qe.length, Xe = ue.now().offset, rt(ut);
  }
  function tt(ut) {
    return ue.containerState = {}, me.attempt(
      containerConstruct,
      et,
      rt
    )(ut);
  }
  function et(ut) {
    return Ue++, Qe.push([ue.currentConstruct, ue.containerState]), tt(ut);
  }
  function rt(ut) {
    if (ut === null) {
      He && st(), at(0), me.consume(ut);
      return;
    }
    return He = He || ue.parser.flow(ue.now()), me.enter("chunkFlow", {
      contentType: "flow",
      previous: Ge,
      _tokenizer: He
    }), it(ut);
  }
  function it(ut) {
    if (ut === null) {
      ot(me.exit("chunkFlow"), !0), at(0), me.consume(ut);
      return;
    }
    return markdownLineEnding(ut) ? (me.consume(ut), ot(me.exit("chunkFlow")), Ue = 0, ue.interrupt = void 0, Ke) : (me.consume(ut), it);
  }
  function ot(ut, lt) {
    const dt = ue.sliceStream(ut);
    if (lt && dt.push(null), ut.previous = Ge, Ge && (Ge.next = ut), Ge = ut, He.defineSkip(ut.start), He.write(dt), ue.parser.lazy[ut.start.line]) {
      let At = He.events.length;
      for (; At--; )
        if (
          // The token starts before the line ending…
          He.events[At][1].start.offset < Xe && // …and either is not ended yet…
          (!He.events[At][1].end || // …or ends after it.
          He.events[At][1].end.offset > Xe)
        )
          return;
      const pt = ue.events.length;
      let gt = pt, wt, Bt;
      for (; gt--; )
        if (ue.events[gt][0] === "exit" && ue.events[gt][1].type === "chunkFlow") {
          if (wt) {
            Bt = ue.events[gt][1].end;
            break;
          }
          wt = !0;
        }
      for (at(Ue), At = pt; At < ue.events.length; )
        ue.events[At][1].end = Object.assign({}, Bt), At++;
      splice(
        ue.events,
        gt + 1,
        0,
        ue.events.slice(pt)
      ), ue.events.length = At;
    }
  }
  function at(ut) {
    let lt = Qe.length;
    for (; lt-- > ut; ) {
      const dt = Qe[lt];
      ue.containerState = dt[1], dt[0].exit.call(ue, me);
    }
    Qe.length = ut;
  }
  function st() {
    He.write([null]), Ge = void 0, He = void 0, ue.containerState._closeFlow = void 0;
  }
}
function tokenizeContainer(me, ue, Qe) {
  return factorySpace(
    me,
    me.attempt(this.parser.constructs.document, ue, Qe),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
function classifyCharacter(me) {
  if (me === null || markdownLineEndingOrSpace(me) || unicodeWhitespace(me))
    return 1;
  if (unicodePunctuation(me))
    return 2;
}
function resolveAll(me, ue, Qe) {
  const Ue = [];
  let He = -1;
  for (; ++He < me.length; ) {
    const Ge = me[He].resolveAll;
    Ge && !Ue.includes(Ge) && (ue = Ge(ue, Qe), Ue.push(Ge));
  }
  return ue;
}
const attention = {
  name: "attention",
  tokenize: tokenizeAttention,
  resolveAll: resolveAllAttention
};
function resolveAllAttention(me, ue) {
  let Qe = -1, Ue, He, Ge, Xe, Ke, $e, Je, Ze;
  for (; ++Qe < me.length; )
    if (me[Qe][0] === "enter" && me[Qe][1].type === "attentionSequence" && me[Qe][1]._close) {
      for (Ue = Qe; Ue--; )
        if (me[Ue][0] === "exit" && me[Ue][1].type === "attentionSequence" && me[Ue][1]._open && // If the markers are the same:
        ue.sliceSerialize(me[Ue][1]).charCodeAt(0) === ue.sliceSerialize(me[Qe][1]).charCodeAt(0)) {
          if ((me[Ue][1]._close || me[Qe][1]._open) && (me[Qe][1].end.offset - me[Qe][1].start.offset) % 3 && !((me[Ue][1].end.offset - me[Ue][1].start.offset + me[Qe][1].end.offset - me[Qe][1].start.offset) % 3))
            continue;
          $e = me[Ue][1].end.offset - me[Ue][1].start.offset > 1 && me[Qe][1].end.offset - me[Qe][1].start.offset > 1 ? 2 : 1;
          const nt = Object.assign({}, me[Ue][1].end), tt = Object.assign({}, me[Qe][1].start);
          movePoint(nt, -$e), movePoint(tt, $e), Xe = {
            type: $e > 1 ? "strongSequence" : "emphasisSequence",
            start: nt,
            end: Object.assign({}, me[Ue][1].end)
          }, Ke = {
            type: $e > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, me[Qe][1].start),
            end: tt
          }, Ge = {
            type: $e > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, me[Ue][1].end),
            end: Object.assign({}, me[Qe][1].start)
          }, He = {
            type: $e > 1 ? "strong" : "emphasis",
            start: Object.assign({}, Xe.start),
            end: Object.assign({}, Ke.end)
          }, me[Ue][1].end = Object.assign({}, Xe.start), me[Qe][1].start = Object.assign({}, Ke.end), Je = [], me[Ue][1].end.offset - me[Ue][1].start.offset && (Je = push(Je, [
            ["enter", me[Ue][1], ue],
            ["exit", me[Ue][1], ue]
          ])), Je = push(Je, [
            ["enter", He, ue],
            ["enter", Xe, ue],
            ["exit", Xe, ue],
            ["enter", Ge, ue]
          ]), Je = push(
            Je,
            resolveAll(
              ue.parser.constructs.insideSpan.null,
              me.slice(Ue + 1, Qe),
              ue
            )
          ), Je = push(Je, [
            ["exit", Ge, ue],
            ["enter", Ke, ue],
            ["exit", Ke, ue],
            ["exit", He, ue]
          ]), me[Qe][1].end.offset - me[Qe][1].start.offset ? (Ze = 2, Je = push(Je, [
            ["enter", me[Qe][1], ue],
            ["exit", me[Qe][1], ue]
          ])) : Ze = 0, splice(me, Ue - 1, Qe - Ue + 3, Je), Qe = Ue + Je.length - Ze - 2;
          break;
        }
    }
  for (Qe = -1; ++Qe < me.length; )
    me[Qe][1].type === "attentionSequence" && (me[Qe][1].type = "data");
  return me;
}
function tokenizeAttention(me, ue) {
  const Qe = this.parser.constructs.attentionMarkers.null, Ue = this.previous, He = classifyCharacter(Ue);
  let Ge;
  return Xe;
  function Xe($e) {
    return Ge = $e, me.enter("attentionSequence"), Ke($e);
  }
  function Ke($e) {
    if ($e === Ge)
      return me.consume($e), Ke;
    const Je = me.exit("attentionSequence"), Ze = classifyCharacter($e), nt = !Ze || Ze === 2 && He || Qe.includes($e), tt = !He || He === 2 && Ze || Qe.includes(Ue);
    return Je._open = !!(Ge === 42 ? nt : nt && (He || !tt)), Je._close = !!(Ge === 42 ? tt : tt && (Ze || !nt)), ue($e);
  }
}
function movePoint(me, ue) {
  me.column += ue, me.offset += ue, me._bufferIndex += ue;
}
const autolink = {
  name: "autolink",
  tokenize: tokenizeAutolink
};
function tokenizeAutolink(me, ue, Qe) {
  let Ue = 0;
  return He;
  function He(et) {
    return me.enter("autolink"), me.enter("autolinkMarker"), me.consume(et), me.exit("autolinkMarker"), me.enter("autolinkProtocol"), Ge;
  }
  function Ge(et) {
    return asciiAlpha(et) ? (me.consume(et), Xe) : Je(et);
  }
  function Xe(et) {
    return et === 43 || et === 45 || et === 46 || asciiAlphanumeric(et) ? (Ue = 1, Ke(et)) : Je(et);
  }
  function Ke(et) {
    return et === 58 ? (me.consume(et), Ue = 0, $e) : (et === 43 || et === 45 || et === 46 || asciiAlphanumeric(et)) && Ue++ < 32 ? (me.consume(et), Ke) : (Ue = 0, Je(et));
  }
  function $e(et) {
    return et === 62 ? (me.exit("autolinkProtocol"), me.enter("autolinkMarker"), me.consume(et), me.exit("autolinkMarker"), me.exit("autolink"), ue) : et === null || et === 32 || et === 60 || asciiControl(et) ? Qe(et) : (me.consume(et), $e);
  }
  function Je(et) {
    return et === 64 ? (me.consume(et), Ze) : asciiAtext(et) ? (me.consume(et), Je) : Qe(et);
  }
  function Ze(et) {
    return asciiAlphanumeric(et) ? nt(et) : Qe(et);
  }
  function nt(et) {
    return et === 46 ? (me.consume(et), Ue = 0, Ze) : et === 62 ? (me.exit("autolinkProtocol").type = "autolinkEmail", me.enter("autolinkMarker"), me.consume(et), me.exit("autolinkMarker"), me.exit("autolink"), ue) : tt(et);
  }
  function tt(et) {
    if ((et === 45 || asciiAlphanumeric(et)) && Ue++ < 63) {
      const rt = et === 45 ? tt : nt;
      return me.consume(et), rt;
    }
    return Qe(et);
  }
}
const blankLine = {
  tokenize: tokenizeBlankLine,
  partial: !0
};
function tokenizeBlankLine(me, ue, Qe) {
  return Ue;
  function Ue(Ge) {
    return markdownSpace(Ge) ? factorySpace(me, He, "linePrefix")(Ge) : He(Ge);
  }
  function He(Ge) {
    return Ge === null || markdownLineEnding(Ge) ? ue(Ge) : Qe(Ge);
  }
}
const blockQuote = {
  name: "blockQuote",
  tokenize: tokenizeBlockQuoteStart,
  continuation: {
    tokenize: tokenizeBlockQuoteContinuation
  },
  exit
};
function tokenizeBlockQuoteStart(me, ue, Qe) {
  const Ue = this;
  return He;
  function He(Xe) {
    if (Xe === 62) {
      const Ke = Ue.containerState;
      return Ke.open || (me.enter("blockQuote", {
        _container: !0
      }), Ke.open = !0), me.enter("blockQuotePrefix"), me.enter("blockQuoteMarker"), me.consume(Xe), me.exit("blockQuoteMarker"), Ge;
    }
    return Qe(Xe);
  }
  function Ge(Xe) {
    return markdownSpace(Xe) ? (me.enter("blockQuotePrefixWhitespace"), me.consume(Xe), me.exit("blockQuotePrefixWhitespace"), me.exit("blockQuotePrefix"), ue) : (me.exit("blockQuotePrefix"), ue(Xe));
  }
}
function tokenizeBlockQuoteContinuation(me, ue, Qe) {
  const Ue = this;
  return He;
  function He(Xe) {
    return markdownSpace(Xe) ? factorySpace(
      me,
      Ge,
      "linePrefix",
      Ue.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(Xe) : Ge(Xe);
  }
  function Ge(Xe) {
    return me.attempt(blockQuote, ue, Qe)(Xe);
  }
}
function exit(me) {
  me.exit("blockQuote");
}
const characterEscape = {
  name: "characterEscape",
  tokenize: tokenizeCharacterEscape
};
function tokenizeCharacterEscape(me, ue, Qe) {
  return Ue;
  function Ue(Ge) {
    return me.enter("characterEscape"), me.enter("escapeMarker"), me.consume(Ge), me.exit("escapeMarker"), He;
  }
  function He(Ge) {
    return asciiPunctuation(Ge) ? (me.enter("characterEscapeValue"), me.consume(Ge), me.exit("characterEscapeValue"), me.exit("characterEscape"), ue) : Qe(Ge);
  }
}
const characterReference = {
  name: "characterReference",
  tokenize: tokenizeCharacterReference
};
function tokenizeCharacterReference(me, ue, Qe) {
  const Ue = this;
  let He = 0, Ge, Xe;
  return Ke;
  function Ke(nt) {
    return me.enter("characterReference"), me.enter("characterReferenceMarker"), me.consume(nt), me.exit("characterReferenceMarker"), $e;
  }
  function $e(nt) {
    return nt === 35 ? (me.enter("characterReferenceMarkerNumeric"), me.consume(nt), me.exit("characterReferenceMarkerNumeric"), Je) : (me.enter("characterReferenceValue"), Ge = 31, Xe = asciiAlphanumeric, Ze(nt));
  }
  function Je(nt) {
    return nt === 88 || nt === 120 ? (me.enter("characterReferenceMarkerHexadecimal"), me.consume(nt), me.exit("characterReferenceMarkerHexadecimal"), me.enter("characterReferenceValue"), Ge = 6, Xe = asciiHexDigit, Ze) : (me.enter("characterReferenceValue"), Ge = 7, Xe = asciiDigit, Ze(nt));
  }
  function Ze(nt) {
    if (nt === 59 && He) {
      const tt = me.exit("characterReferenceValue");
      return Xe === asciiAlphanumeric && !decodeNamedCharacterReference(Ue.sliceSerialize(tt)) ? Qe(nt) : (me.enter("characterReferenceMarker"), me.consume(nt), me.exit("characterReferenceMarker"), me.exit("characterReference"), ue);
    }
    return Xe(nt) && He++ < Ge ? (me.consume(nt), Ze) : Qe(nt);
  }
}
const nonLazyContinuation = {
  tokenize: tokenizeNonLazyContinuation,
  partial: !0
}, codeFenced = {
  name: "codeFenced",
  tokenize: tokenizeCodeFenced,
  concrete: !0
};
function tokenizeCodeFenced(me, ue, Qe) {
  const Ue = this, He = {
    tokenize: dt,
    partial: !0
  };
  let Ge = 0, Xe = 0, Ke;
  return $e;
  function $e(At) {
    return Je(At);
  }
  function Je(At) {
    const pt = Ue.events[Ue.events.length - 1];
    return Ge = pt && pt[1].type === "linePrefix" ? pt[2].sliceSerialize(pt[1], !0).length : 0, Ke = At, me.enter("codeFenced"), me.enter("codeFencedFence"), me.enter("codeFencedFenceSequence"), Ze(At);
  }
  function Ze(At) {
    return At === Ke ? (Xe++, me.consume(At), Ze) : Xe < 3 ? Qe(At) : (me.exit("codeFencedFenceSequence"), markdownSpace(At) ? factorySpace(me, nt, "whitespace")(At) : nt(At));
  }
  function nt(At) {
    return At === null || markdownLineEnding(At) ? (me.exit("codeFencedFence"), Ue.interrupt ? ue(At) : me.check(nonLazyContinuation, it, lt)(At)) : (me.enter("codeFencedFenceInfo"), me.enter("chunkString", {
      contentType: "string"
    }), tt(At));
  }
  function tt(At) {
    return At === null || markdownLineEnding(At) ? (me.exit("chunkString"), me.exit("codeFencedFenceInfo"), nt(At)) : markdownSpace(At) ? (me.exit("chunkString"), me.exit("codeFencedFenceInfo"), factorySpace(me, et, "whitespace")(At)) : At === 96 && At === Ke ? Qe(At) : (me.consume(At), tt);
  }
  function et(At) {
    return At === null || markdownLineEnding(At) ? nt(At) : (me.enter("codeFencedFenceMeta"), me.enter("chunkString", {
      contentType: "string"
    }), rt(At));
  }
  function rt(At) {
    return At === null || markdownLineEnding(At) ? (me.exit("chunkString"), me.exit("codeFencedFenceMeta"), nt(At)) : At === 96 && At === Ke ? Qe(At) : (me.consume(At), rt);
  }
  function it(At) {
    return me.attempt(He, lt, ot)(At);
  }
  function ot(At) {
    return me.enter("lineEnding"), me.consume(At), me.exit("lineEnding"), at;
  }
  function at(At) {
    return Ge > 0 && markdownSpace(At) ? factorySpace(
      me,
      st,
      "linePrefix",
      Ge + 1
    )(At) : st(At);
  }
  function st(At) {
    return At === null || markdownLineEnding(At) ? me.check(nonLazyContinuation, it, lt)(At) : (me.enter("codeFlowValue"), ut(At));
  }
  function ut(At) {
    return At === null || markdownLineEnding(At) ? (me.exit("codeFlowValue"), st(At)) : (me.consume(At), ut);
  }
  function lt(At) {
    return me.exit("codeFenced"), ue(At);
  }
  function dt(At, pt, gt) {
    let wt = 0;
    return Bt;
    function Bt(It) {
      return At.enter("lineEnding"), At.consume(It), At.exit("lineEnding"), Tt;
    }
    function Tt(It) {
      return At.enter("codeFencedFence"), markdownSpace(It) ? factorySpace(
        At,
        yt,
        "linePrefix",
        Ue.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
      )(It) : yt(It);
    }
    function yt(It) {
      return It === Ke ? (At.enter("codeFencedFenceSequence"), Ct(It)) : gt(It);
    }
    function Ct(It) {
      return It === Ke ? (wt++, At.consume(It), Ct) : wt >= Xe ? (At.exit("codeFencedFenceSequence"), markdownSpace(It) ? factorySpace(At, ht, "whitespace")(It) : ht(It)) : gt(It);
    }
    function ht(It) {
      return It === null || markdownLineEnding(It) ? (At.exit("codeFencedFence"), pt(It)) : gt(It);
    }
  }
}
function tokenizeNonLazyContinuation(me, ue, Qe) {
  const Ue = this;
  return He;
  function He(Xe) {
    return Xe === null ? Qe(Xe) : (me.enter("lineEnding"), me.consume(Xe), me.exit("lineEnding"), Ge);
  }
  function Ge(Xe) {
    return Ue.parser.lazy[Ue.now().line] ? Qe(Xe) : ue(Xe);
  }
}
const codeIndented = {
  name: "codeIndented",
  tokenize: tokenizeCodeIndented
}, furtherStart = {
  tokenize: tokenizeFurtherStart,
  partial: !0
};
function tokenizeCodeIndented(me, ue, Qe) {
  const Ue = this;
  return He;
  function He(Je) {
    return me.enter("codeIndented"), factorySpace(me, Ge, "linePrefix", 5)(Je);
  }
  function Ge(Je) {
    const Ze = Ue.events[Ue.events.length - 1];
    return Ze && Ze[1].type === "linePrefix" && Ze[2].sliceSerialize(Ze[1], !0).length >= 4 ? Xe(Je) : Qe(Je);
  }
  function Xe(Je) {
    return Je === null ? $e(Je) : markdownLineEnding(Je) ? me.attempt(furtherStart, Xe, $e)(Je) : (me.enter("codeFlowValue"), Ke(Je));
  }
  function Ke(Je) {
    return Je === null || markdownLineEnding(Je) ? (me.exit("codeFlowValue"), Xe(Je)) : (me.consume(Je), Ke);
  }
  function $e(Je) {
    return me.exit("codeIndented"), ue(Je);
  }
}
function tokenizeFurtherStart(me, ue, Qe) {
  const Ue = this;
  return He;
  function He(Xe) {
    return Ue.parser.lazy[Ue.now().line] ? Qe(Xe) : markdownLineEnding(Xe) ? (me.enter("lineEnding"), me.consume(Xe), me.exit("lineEnding"), He) : factorySpace(me, Ge, "linePrefix", 5)(Xe);
  }
  function Ge(Xe) {
    const Ke = Ue.events[Ue.events.length - 1];
    return Ke && Ke[1].type === "linePrefix" && Ke[2].sliceSerialize(Ke[1], !0).length >= 4 ? ue(Xe) : markdownLineEnding(Xe) ? He(Xe) : Qe(Xe);
  }
}
const codeText = {
  name: "codeText",
  tokenize: tokenizeCodeText,
  resolve: resolveCodeText,
  previous
};
function resolveCodeText(me) {
  let ue = me.length - 4, Qe = 3, Ue, He;
  if ((me[Qe][1].type === "lineEnding" || me[Qe][1].type === "space") && (me[ue][1].type === "lineEnding" || me[ue][1].type === "space")) {
    for (Ue = Qe; ++Ue < ue; )
      if (me[Ue][1].type === "codeTextData") {
        me[Qe][1].type = "codeTextPadding", me[ue][1].type = "codeTextPadding", Qe += 2, ue -= 2;
        break;
      }
  }
  for (Ue = Qe - 1, ue++; ++Ue <= ue; )
    He === void 0 ? Ue !== ue && me[Ue][1].type !== "lineEnding" && (He = Ue) : (Ue === ue || me[Ue][1].type === "lineEnding") && (me[He][1].type = "codeTextData", Ue !== He + 2 && (me[He][1].end = me[Ue - 1][1].end, me.splice(He + 2, Ue - He - 2), ue -= Ue - He - 2, Ue = He + 2), He = void 0);
  return me;
}
function previous(me) {
  return me !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function tokenizeCodeText(me, ue, Qe) {
  let Ue = 0, He, Ge;
  return Xe;
  function Xe(nt) {
    return me.enter("codeText"), me.enter("codeTextSequence"), Ke(nt);
  }
  function Ke(nt) {
    return nt === 96 ? (me.consume(nt), Ue++, Ke) : (me.exit("codeTextSequence"), $e(nt));
  }
  function $e(nt) {
    return nt === null ? Qe(nt) : nt === 32 ? (me.enter("space"), me.consume(nt), me.exit("space"), $e) : nt === 96 ? (Ge = me.enter("codeTextSequence"), He = 0, Ze(nt)) : markdownLineEnding(nt) ? (me.enter("lineEnding"), me.consume(nt), me.exit("lineEnding"), $e) : (me.enter("codeTextData"), Je(nt));
  }
  function Je(nt) {
    return nt === null || nt === 32 || nt === 96 || markdownLineEnding(nt) ? (me.exit("codeTextData"), $e(nt)) : (me.consume(nt), Je);
  }
  function Ze(nt) {
    return nt === 96 ? (me.consume(nt), He++, Ze) : He === Ue ? (me.exit("codeTextSequence"), me.exit("codeText"), ue(nt)) : (Ge.type = "codeTextData", Je(nt));
  }
}
function subtokenize(me) {
  const ue = {};
  let Qe = -1, Ue, He, Ge, Xe, Ke, $e, Je;
  for (; ++Qe < me.length; ) {
    for (; Qe in ue; )
      Qe = ue[Qe];
    if (Ue = me[Qe], Qe && Ue[1].type === "chunkFlow" && me[Qe - 1][1].type === "listItemPrefix" && ($e = Ue[1]._tokenizer.events, Ge = 0, Ge < $e.length && $e[Ge][1].type === "lineEndingBlank" && (Ge += 2), Ge < $e.length && $e[Ge][1].type === "content"))
      for (; ++Ge < $e.length && $e[Ge][1].type !== "content"; )
        $e[Ge][1].type === "chunkText" && ($e[Ge][1]._isInFirstContentOfListItem = !0, Ge++);
    if (Ue[0] === "enter")
      Ue[1].contentType && (Object.assign(ue, subcontent(me, Qe)), Qe = ue[Qe], Je = !0);
    else if (Ue[1]._container) {
      for (Ge = Qe, He = void 0; Ge-- && (Xe = me[Ge], Xe[1].type === "lineEnding" || Xe[1].type === "lineEndingBlank"); )
        Xe[0] === "enter" && (He && (me[He][1].type = "lineEndingBlank"), Xe[1].type = "lineEnding", He = Ge);
      He && (Ue[1].end = Object.assign({}, me[He][1].start), Ke = me.slice(He, Qe), Ke.unshift(Ue), splice(me, He, Qe - He + 1, Ke));
    }
  }
  return !Je;
}
function subcontent(me, ue) {
  const Qe = me[ue][1], Ue = me[ue][2];
  let He = ue - 1;
  const Ge = [], Xe = Qe._tokenizer || Ue.parser[Qe.contentType](Qe.start), Ke = Xe.events, $e = [], Je = {};
  let Ze, nt, tt = -1, et = Qe, rt = 0, it = 0;
  const ot = [it];
  for (; et; ) {
    for (; me[++He][1] !== et; )
      ;
    Ge.push(He), et._tokenizer || (Ze = Ue.sliceStream(et), et.next || Ze.push(null), nt && Xe.defineSkip(et.start), et._isInFirstContentOfListItem && (Xe._gfmTasklistFirstContentOfListItem = !0), Xe.write(Ze), et._isInFirstContentOfListItem && (Xe._gfmTasklistFirstContentOfListItem = void 0)), nt = et, et = et.next;
  }
  for (et = Qe; ++tt < Ke.length; )
    // Find a void token that includes a break.
    Ke[tt][0] === "exit" && Ke[tt - 1][0] === "enter" && Ke[tt][1].type === Ke[tt - 1][1].type && Ke[tt][1].start.line !== Ke[tt][1].end.line && (it = tt + 1, ot.push(it), et._tokenizer = void 0, et.previous = void 0, et = et.next);
  for (Xe.events = [], et ? (et._tokenizer = void 0, et.previous = void 0) : ot.pop(), tt = ot.length; tt--; ) {
    const at = Ke.slice(ot[tt], ot[tt + 1]), st = Ge.pop();
    $e.unshift([st, st + at.length - 1]), splice(me, st, 2, at);
  }
  for (tt = -1; ++tt < $e.length; )
    Je[rt + $e[tt][0]] = rt + $e[tt][1], rt += $e[tt][1] - $e[tt][0] - 1;
  return Je;
}
const content = {
  tokenize: tokenizeContent,
  resolve: resolveContent
}, continuationConstruct = {
  tokenize: tokenizeContinuation,
  partial: !0
};
function resolveContent(me) {
  return subtokenize(me), me;
}
function tokenizeContent(me, ue) {
  let Qe;
  return Ue;
  function Ue(Ke) {
    return me.enter("content"), Qe = me.enter("chunkContent", {
      contentType: "content"
    }), He(Ke);
  }
  function He(Ke) {
    return Ke === null ? Ge(Ke) : markdownLineEnding(Ke) ? me.check(
      continuationConstruct,
      Xe,
      Ge
    )(Ke) : (me.consume(Ke), He);
  }
  function Ge(Ke) {
    return me.exit("chunkContent"), me.exit("content"), ue(Ke);
  }
  function Xe(Ke) {
    return me.consume(Ke), me.exit("chunkContent"), Qe.next = me.enter("chunkContent", {
      contentType: "content",
      previous: Qe
    }), Qe = Qe.next, He;
  }
}
function tokenizeContinuation(me, ue, Qe) {
  const Ue = this;
  return He;
  function He(Xe) {
    return me.exit("chunkContent"), me.enter("lineEnding"), me.consume(Xe), me.exit("lineEnding"), factorySpace(me, Ge, "linePrefix");
  }
  function Ge(Xe) {
    if (Xe === null || markdownLineEnding(Xe))
      return Qe(Xe);
    const Ke = Ue.events[Ue.events.length - 1];
    return !Ue.parser.constructs.disable.null.includes("codeIndented") && Ke && Ke[1].type === "linePrefix" && Ke[2].sliceSerialize(Ke[1], !0).length >= 4 ? ue(Xe) : me.interrupt(Ue.parser.constructs.flow, Qe, ue)(Xe);
  }
}
function factoryDestination(me, ue, Qe, Ue, He, Ge, Xe, Ke, $e) {
  const Je = $e || Number.POSITIVE_INFINITY;
  let Ze = 0;
  return nt;
  function nt(at) {
    return at === 60 ? (me.enter(Ue), me.enter(He), me.enter(Ge), me.consume(at), me.exit(Ge), tt) : at === null || at === 32 || at === 41 || asciiControl(at) ? Qe(at) : (me.enter(Ue), me.enter(Xe), me.enter(Ke), me.enter("chunkString", {
      contentType: "string"
    }), it(at));
  }
  function tt(at) {
    return at === 62 ? (me.enter(Ge), me.consume(at), me.exit(Ge), me.exit(He), me.exit(Ue), ue) : (me.enter(Ke), me.enter("chunkString", {
      contentType: "string"
    }), et(at));
  }
  function et(at) {
    return at === 62 ? (me.exit("chunkString"), me.exit(Ke), tt(at)) : at === null || at === 60 || markdownLineEnding(at) ? Qe(at) : (me.consume(at), at === 92 ? rt : et);
  }
  function rt(at) {
    return at === 60 || at === 62 || at === 92 ? (me.consume(at), et) : et(at);
  }
  function it(at) {
    return !Ze && (at === null || at === 41 || markdownLineEndingOrSpace(at)) ? (me.exit("chunkString"), me.exit(Ke), me.exit(Xe), me.exit(Ue), ue(at)) : Ze < Je && at === 40 ? (me.consume(at), Ze++, it) : at === 41 ? (me.consume(at), Ze--, it) : at === null || at === 32 || at === 40 || asciiControl(at) ? Qe(at) : (me.consume(at), at === 92 ? ot : it);
  }
  function ot(at) {
    return at === 40 || at === 41 || at === 92 ? (me.consume(at), it) : it(at);
  }
}
function factoryLabel(me, ue, Qe, Ue, He, Ge) {
  const Xe = this;
  let Ke = 0, $e;
  return Je;
  function Je(et) {
    return me.enter(Ue), me.enter(He), me.consume(et), me.exit(He), me.enter(Ge), Ze;
  }
  function Ze(et) {
    return Ke > 999 || et === null || et === 91 || et === 93 && !$e || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    et === 94 && !Ke && "_hiddenFootnoteSupport" in Xe.parser.constructs ? Qe(et) : et === 93 ? (me.exit(Ge), me.enter(He), me.consume(et), me.exit(He), me.exit(Ue), ue) : markdownLineEnding(et) ? (me.enter("lineEnding"), me.consume(et), me.exit("lineEnding"), Ze) : (me.enter("chunkString", {
      contentType: "string"
    }), nt(et));
  }
  function nt(et) {
    return et === null || et === 91 || et === 93 || markdownLineEnding(et) || Ke++ > 999 ? (me.exit("chunkString"), Ze(et)) : (me.consume(et), $e || ($e = !markdownSpace(et)), et === 92 ? tt : nt);
  }
  function tt(et) {
    return et === 91 || et === 92 || et === 93 ? (me.consume(et), Ke++, nt) : nt(et);
  }
}
function factoryTitle(me, ue, Qe, Ue, He, Ge) {
  let Xe;
  return Ke;
  function Ke(tt) {
    return tt === 34 || tt === 39 || tt === 40 ? (me.enter(Ue), me.enter(He), me.consume(tt), me.exit(He), Xe = tt === 40 ? 41 : tt, $e) : Qe(tt);
  }
  function $e(tt) {
    return tt === Xe ? (me.enter(He), me.consume(tt), me.exit(He), me.exit(Ue), ue) : (me.enter(Ge), Je(tt));
  }
  function Je(tt) {
    return tt === Xe ? (me.exit(Ge), $e(Xe)) : tt === null ? Qe(tt) : markdownLineEnding(tt) ? (me.enter("lineEnding"), me.consume(tt), me.exit("lineEnding"), factorySpace(me, Je, "linePrefix")) : (me.enter("chunkString", {
      contentType: "string"
    }), Ze(tt));
  }
  function Ze(tt) {
    return tt === Xe || tt === null || markdownLineEnding(tt) ? (me.exit("chunkString"), Je(tt)) : (me.consume(tt), tt === 92 ? nt : Ze);
  }
  function nt(tt) {
    return tt === Xe || tt === 92 ? (me.consume(tt), Ze) : Ze(tt);
  }
}
function factoryWhitespace(me, ue) {
  let Qe;
  return Ue;
  function Ue(He) {
    return markdownLineEnding(He) ? (me.enter("lineEnding"), me.consume(He), me.exit("lineEnding"), Qe = !0, Ue) : markdownSpace(He) ? factorySpace(
      me,
      Ue,
      Qe ? "linePrefix" : "lineSuffix"
    )(He) : ue(He);
  }
}
const definition = {
  name: "definition",
  tokenize: tokenizeDefinition
}, titleBefore = {
  tokenize: tokenizeTitleBefore,
  partial: !0
};
function tokenizeDefinition(me, ue, Qe) {
  const Ue = this;
  let He;
  return Ge;
  function Ge(et) {
    return me.enter("definition"), Xe(et);
  }
  function Xe(et) {
    return factoryLabel.call(
      Ue,
      me,
      Ke,
      // Note: we don’t need to reset the way `markdown-rs` does.
      Qe,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(et);
  }
  function Ke(et) {
    return He = normalizeIdentifier(
      Ue.sliceSerialize(Ue.events[Ue.events.length - 1][1]).slice(1, -1)
    ), et === 58 ? (me.enter("definitionMarker"), me.consume(et), me.exit("definitionMarker"), $e) : Qe(et);
  }
  function $e(et) {
    return markdownLineEndingOrSpace(et) ? factoryWhitespace(me, Je)(et) : Je(et);
  }
  function Je(et) {
    return factoryDestination(
      me,
      Ze,
      // Note: we don’t need to reset the way `markdown-rs` does.
      Qe,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(et);
  }
  function Ze(et) {
    return me.attempt(titleBefore, nt, nt)(et);
  }
  function nt(et) {
    return markdownSpace(et) ? factorySpace(me, tt, "whitespace")(et) : tt(et);
  }
  function tt(et) {
    return et === null || markdownLineEnding(et) ? (me.exit("definition"), Ue.parser.defined.push(He), ue(et)) : Qe(et);
  }
}
function tokenizeTitleBefore(me, ue, Qe) {
  return Ue;
  function Ue(Ke) {
    return markdownLineEndingOrSpace(Ke) ? factoryWhitespace(me, He)(Ke) : Qe(Ke);
  }
  function He(Ke) {
    return factoryTitle(
      me,
      Ge,
      Qe,
      "definitionTitle",
      "definitionTitleMarker",
      "definitionTitleString"
    )(Ke);
  }
  function Ge(Ke) {
    return markdownSpace(Ke) ? factorySpace(me, Xe, "whitespace")(Ke) : Xe(Ke);
  }
  function Xe(Ke) {
    return Ke === null || markdownLineEnding(Ke) ? ue(Ke) : Qe(Ke);
  }
}
const hardBreakEscape = {
  name: "hardBreakEscape",
  tokenize: tokenizeHardBreakEscape
};
function tokenizeHardBreakEscape(me, ue, Qe) {
  return Ue;
  function Ue(Ge) {
    return me.enter("hardBreakEscape"), me.consume(Ge), He;
  }
  function He(Ge) {
    return markdownLineEnding(Ge) ? (me.exit("hardBreakEscape"), ue(Ge)) : Qe(Ge);
  }
}
const headingAtx = {
  name: "headingAtx",
  tokenize: tokenizeHeadingAtx,
  resolve: resolveHeadingAtx
};
function resolveHeadingAtx(me, ue) {
  let Qe = me.length - 2, Ue = 3, He, Ge;
  return me[Ue][1].type === "whitespace" && (Ue += 2), Qe - 2 > Ue && me[Qe][1].type === "whitespace" && (Qe -= 2), me[Qe][1].type === "atxHeadingSequence" && (Ue === Qe - 1 || Qe - 4 > Ue && me[Qe - 2][1].type === "whitespace") && (Qe -= Ue + 1 === Qe ? 2 : 4), Qe > Ue && (He = {
    type: "atxHeadingText",
    start: me[Ue][1].start,
    end: me[Qe][1].end
  }, Ge = {
    type: "chunkText",
    start: me[Ue][1].start,
    end: me[Qe][1].end,
    contentType: "text"
  }, splice(me, Ue, Qe - Ue + 1, [
    ["enter", He, ue],
    ["enter", Ge, ue],
    ["exit", Ge, ue],
    ["exit", He, ue]
  ])), me;
}
function tokenizeHeadingAtx(me, ue, Qe) {
  let Ue = 0;
  return He;
  function He(Ze) {
    return me.enter("atxHeading"), Ge(Ze);
  }
  function Ge(Ze) {
    return me.enter("atxHeadingSequence"), Xe(Ze);
  }
  function Xe(Ze) {
    return Ze === 35 && Ue++ < 6 ? (me.consume(Ze), Xe) : Ze === null || markdownLineEndingOrSpace(Ze) ? (me.exit("atxHeadingSequence"), Ke(Ze)) : Qe(Ze);
  }
  function Ke(Ze) {
    return Ze === 35 ? (me.enter("atxHeadingSequence"), $e(Ze)) : Ze === null || markdownLineEnding(Ze) ? (me.exit("atxHeading"), ue(Ze)) : markdownSpace(Ze) ? factorySpace(me, Ke, "whitespace")(Ze) : (me.enter("atxHeadingText"), Je(Ze));
  }
  function $e(Ze) {
    return Ze === 35 ? (me.consume(Ze), $e) : (me.exit("atxHeadingSequence"), Ke(Ze));
  }
  function Je(Ze) {
    return Ze === null || Ze === 35 || markdownLineEndingOrSpace(Ze) ? (me.exit("atxHeadingText"), Ke(Ze)) : (me.consume(Ze), Je);
  }
}
const htmlBlockNames = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], htmlRawNames = ["pre", "script", "style", "textarea"], htmlFlow = {
  name: "htmlFlow",
  tokenize: tokenizeHtmlFlow,
  resolveTo: resolveToHtmlFlow,
  concrete: !0
}, blankLineBefore = {
  tokenize: tokenizeBlankLineBefore,
  partial: !0
}, nonLazyContinuationStart = {
  tokenize: tokenizeNonLazyContinuationStart,
  partial: !0
};
function resolveToHtmlFlow(me) {
  let ue = me.length;
  for (; ue-- && !(me[ue][0] === "enter" && me[ue][1].type === "htmlFlow"); )
    ;
  return ue > 1 && me[ue - 2][1].type === "linePrefix" && (me[ue][1].start = me[ue - 2][1].start, me[ue + 1][1].start = me[ue - 2][1].start, me.splice(ue - 2, 2)), me;
}
function tokenizeHtmlFlow(me, ue, Qe) {
  const Ue = this;
  let He, Ge, Xe, Ke, $e;
  return Je;
  function Je(Pt) {
    return Ze(Pt);
  }
  function Ze(Pt) {
    return me.enter("htmlFlow"), me.enter("htmlFlowData"), me.consume(Pt), nt;
  }
  function nt(Pt) {
    return Pt === 33 ? (me.consume(Pt), tt) : Pt === 47 ? (me.consume(Pt), Ge = !0, it) : Pt === 63 ? (me.consume(Pt), He = 3, Ue.interrupt ? ue : St) : asciiAlpha(Pt) ? (me.consume(Pt), Xe = String.fromCharCode(Pt), ot) : Qe(Pt);
  }
  function tt(Pt) {
    return Pt === 45 ? (me.consume(Pt), He = 2, et) : Pt === 91 ? (me.consume(Pt), He = 5, Ke = 0, rt) : asciiAlpha(Pt) ? (me.consume(Pt), He = 4, Ue.interrupt ? ue : St) : Qe(Pt);
  }
  function et(Pt) {
    return Pt === 45 ? (me.consume(Pt), Ue.interrupt ? ue : St) : Qe(Pt);
  }
  function rt(Pt) {
    const Qt = "CDATA[";
    return Pt === Qt.charCodeAt(Ke++) ? (me.consume(Pt), Ke === Qt.length ? Ue.interrupt ? ue : yt : rt) : Qe(Pt);
  }
  function it(Pt) {
    return asciiAlpha(Pt) ? (me.consume(Pt), Xe = String.fromCharCode(Pt), ot) : Qe(Pt);
  }
  function ot(Pt) {
    if (Pt === null || Pt === 47 || Pt === 62 || markdownLineEndingOrSpace(Pt)) {
      const Qt = Pt === 47, qt = Xe.toLowerCase();
      return !Qt && !Ge && htmlRawNames.includes(qt) ? (He = 1, Ue.interrupt ? ue(Pt) : yt(Pt)) : htmlBlockNames.includes(Xe.toLowerCase()) ? (He = 6, Qt ? (me.consume(Pt), at) : Ue.interrupt ? ue(Pt) : yt(Pt)) : (He = 7, Ue.interrupt && !Ue.parser.lazy[Ue.now().line] ? Qe(Pt) : Ge ? st(Pt) : ut(Pt));
    }
    return Pt === 45 || asciiAlphanumeric(Pt) ? (me.consume(Pt), Xe += String.fromCharCode(Pt), ot) : Qe(Pt);
  }
  function at(Pt) {
    return Pt === 62 ? (me.consume(Pt), Ue.interrupt ? ue : yt) : Qe(Pt);
  }
  function st(Pt) {
    return markdownSpace(Pt) ? (me.consume(Pt), st) : Bt(Pt);
  }
  function ut(Pt) {
    return Pt === 47 ? (me.consume(Pt), Bt) : Pt === 58 || Pt === 95 || asciiAlpha(Pt) ? (me.consume(Pt), lt) : markdownSpace(Pt) ? (me.consume(Pt), ut) : Bt(Pt);
  }
  function lt(Pt) {
    return Pt === 45 || Pt === 46 || Pt === 58 || Pt === 95 || asciiAlphanumeric(Pt) ? (me.consume(Pt), lt) : dt(Pt);
  }
  function dt(Pt) {
    return Pt === 61 ? (me.consume(Pt), At) : markdownSpace(Pt) ? (me.consume(Pt), dt) : ut(Pt);
  }
  function At(Pt) {
    return Pt === null || Pt === 60 || Pt === 61 || Pt === 62 || Pt === 96 ? Qe(Pt) : Pt === 34 || Pt === 39 ? (me.consume(Pt), $e = Pt, pt) : markdownSpace(Pt) ? (me.consume(Pt), At) : gt(Pt);
  }
  function pt(Pt) {
    return Pt === $e ? (me.consume(Pt), $e = null, wt) : Pt === null || markdownLineEnding(Pt) ? Qe(Pt) : (me.consume(Pt), pt);
  }
  function gt(Pt) {
    return Pt === null || Pt === 34 || Pt === 39 || Pt === 47 || Pt === 60 || Pt === 61 || Pt === 62 || Pt === 96 || markdownLineEndingOrSpace(Pt) ? dt(Pt) : (me.consume(Pt), gt);
  }
  function wt(Pt) {
    return Pt === 47 || Pt === 62 || markdownSpace(Pt) ? ut(Pt) : Qe(Pt);
  }
  function Bt(Pt) {
    return Pt === 62 ? (me.consume(Pt), Tt) : Qe(Pt);
  }
  function Tt(Pt) {
    return Pt === null || markdownLineEnding(Pt) ? yt(Pt) : markdownSpace(Pt) ? (me.consume(Pt), Tt) : Qe(Pt);
  }
  function yt(Pt) {
    return Pt === 45 && He === 2 ? (me.consume(Pt), vt) : Pt === 60 && He === 1 ? (me.consume(Pt), Et) : Pt === 62 && He === 4 ? (me.consume(Pt), kt) : Pt === 63 && He === 3 ? (me.consume(Pt), St) : Pt === 93 && He === 5 ? (me.consume(Pt), Rt) : markdownLineEnding(Pt) && (He === 6 || He === 7) ? (me.exit("htmlFlowData"), me.check(
      blankLineBefore,
      jt,
      Ct
    )(Pt)) : Pt === null || markdownLineEnding(Pt) ? (me.exit("htmlFlowData"), Ct(Pt)) : (me.consume(Pt), yt);
  }
  function Ct(Pt) {
    return me.check(
      nonLazyContinuationStart,
      ht,
      jt
    )(Pt);
  }
  function ht(Pt) {
    return me.enter("lineEnding"), me.consume(Pt), me.exit("lineEnding"), It;
  }
  function It(Pt) {
    return Pt === null || markdownLineEnding(Pt) ? Ct(Pt) : (me.enter("htmlFlowData"), yt(Pt));
  }
  function vt(Pt) {
    return Pt === 45 ? (me.consume(Pt), St) : yt(Pt);
  }
  function Et(Pt) {
    return Pt === 47 ? (me.consume(Pt), Xe = "", bt) : yt(Pt);
  }
  function bt(Pt) {
    if (Pt === 62) {
      const Qt = Xe.toLowerCase();
      return htmlRawNames.includes(Qt) ? (me.consume(Pt), kt) : yt(Pt);
    }
    return asciiAlpha(Pt) && Xe.length < 8 ? (me.consume(Pt), Xe += String.fromCharCode(Pt), bt) : yt(Pt);
  }
  function Rt(Pt) {
    return Pt === 93 ? (me.consume(Pt), St) : yt(Pt);
  }
  function St(Pt) {
    return Pt === 62 ? (me.consume(Pt), kt) : Pt === 45 && He === 2 ? (me.consume(Pt), St) : yt(Pt);
  }
  function kt(Pt) {
    return Pt === null || markdownLineEnding(Pt) ? (me.exit("htmlFlowData"), jt(Pt)) : (me.consume(Pt), kt);
  }
  function jt(Pt) {
    return me.exit("htmlFlow"), ue(Pt);
  }
}
function tokenizeNonLazyContinuationStart(me, ue, Qe) {
  const Ue = this;
  return He;
  function He(Xe) {
    return markdownLineEnding(Xe) ? (me.enter("lineEnding"), me.consume(Xe), me.exit("lineEnding"), Ge) : Qe(Xe);
  }
  function Ge(Xe) {
    return Ue.parser.lazy[Ue.now().line] ? Qe(Xe) : ue(Xe);
  }
}
function tokenizeBlankLineBefore(me, ue, Qe) {
  return Ue;
  function Ue(He) {
    return me.enter("lineEnding"), me.consume(He), me.exit("lineEnding"), me.attempt(blankLine, ue, Qe);
  }
}
const htmlText = {
  name: "htmlText",
  tokenize: tokenizeHtmlText
};
function tokenizeHtmlText(me, ue, Qe) {
  const Ue = this;
  let He, Ge, Xe;
  return Ke;
  function Ke(St) {
    return me.enter("htmlText"), me.enter("htmlTextData"), me.consume(St), $e;
  }
  function $e(St) {
    return St === 33 ? (me.consume(St), Je) : St === 47 ? (me.consume(St), dt) : St === 63 ? (me.consume(St), ut) : asciiAlpha(St) ? (me.consume(St), gt) : Qe(St);
  }
  function Je(St) {
    return St === 45 ? (me.consume(St), Ze) : St === 91 ? (me.consume(St), Ge = 0, rt) : asciiAlpha(St) ? (me.consume(St), st) : Qe(St);
  }
  function Ze(St) {
    return St === 45 ? (me.consume(St), et) : Qe(St);
  }
  function nt(St) {
    return St === null ? Qe(St) : St === 45 ? (me.consume(St), tt) : markdownLineEnding(St) ? (Xe = nt, Et(St)) : (me.consume(St), nt);
  }
  function tt(St) {
    return St === 45 ? (me.consume(St), et) : nt(St);
  }
  function et(St) {
    return St === 62 ? vt(St) : St === 45 ? tt(St) : nt(St);
  }
  function rt(St) {
    const kt = "CDATA[";
    return St === kt.charCodeAt(Ge++) ? (me.consume(St), Ge === kt.length ? it : rt) : Qe(St);
  }
  function it(St) {
    return St === null ? Qe(St) : St === 93 ? (me.consume(St), ot) : markdownLineEnding(St) ? (Xe = it, Et(St)) : (me.consume(St), it);
  }
  function ot(St) {
    return St === 93 ? (me.consume(St), at) : it(St);
  }
  function at(St) {
    return St === 62 ? vt(St) : St === 93 ? (me.consume(St), at) : it(St);
  }
  function st(St) {
    return St === null || St === 62 ? vt(St) : markdownLineEnding(St) ? (Xe = st, Et(St)) : (me.consume(St), st);
  }
  function ut(St) {
    return St === null ? Qe(St) : St === 63 ? (me.consume(St), lt) : markdownLineEnding(St) ? (Xe = ut, Et(St)) : (me.consume(St), ut);
  }
  function lt(St) {
    return St === 62 ? vt(St) : ut(St);
  }
  function dt(St) {
    return asciiAlpha(St) ? (me.consume(St), At) : Qe(St);
  }
  function At(St) {
    return St === 45 || asciiAlphanumeric(St) ? (me.consume(St), At) : pt(St);
  }
  function pt(St) {
    return markdownLineEnding(St) ? (Xe = pt, Et(St)) : markdownSpace(St) ? (me.consume(St), pt) : vt(St);
  }
  function gt(St) {
    return St === 45 || asciiAlphanumeric(St) ? (me.consume(St), gt) : St === 47 || St === 62 || markdownLineEndingOrSpace(St) ? wt(St) : Qe(St);
  }
  function wt(St) {
    return St === 47 ? (me.consume(St), vt) : St === 58 || St === 95 || asciiAlpha(St) ? (me.consume(St), Bt) : markdownLineEnding(St) ? (Xe = wt, Et(St)) : markdownSpace(St) ? (me.consume(St), wt) : vt(St);
  }
  function Bt(St) {
    return St === 45 || St === 46 || St === 58 || St === 95 || asciiAlphanumeric(St) ? (me.consume(St), Bt) : Tt(St);
  }
  function Tt(St) {
    return St === 61 ? (me.consume(St), yt) : markdownLineEnding(St) ? (Xe = Tt, Et(St)) : markdownSpace(St) ? (me.consume(St), Tt) : wt(St);
  }
  function yt(St) {
    return St === null || St === 60 || St === 61 || St === 62 || St === 96 ? Qe(St) : St === 34 || St === 39 ? (me.consume(St), He = St, Ct) : markdownLineEnding(St) ? (Xe = yt, Et(St)) : markdownSpace(St) ? (me.consume(St), yt) : (me.consume(St), ht);
  }
  function Ct(St) {
    return St === He ? (me.consume(St), He = void 0, It) : St === null ? Qe(St) : markdownLineEnding(St) ? (Xe = Ct, Et(St)) : (me.consume(St), Ct);
  }
  function ht(St) {
    return St === null || St === 34 || St === 39 || St === 60 || St === 61 || St === 96 ? Qe(St) : St === 47 || St === 62 || markdownLineEndingOrSpace(St) ? wt(St) : (me.consume(St), ht);
  }
  function It(St) {
    return St === 47 || St === 62 || markdownLineEndingOrSpace(St) ? wt(St) : Qe(St);
  }
  function vt(St) {
    return St === 62 ? (me.consume(St), me.exit("htmlTextData"), me.exit("htmlText"), ue) : Qe(St);
  }
  function Et(St) {
    return me.exit("htmlTextData"), me.enter("lineEnding"), me.consume(St), me.exit("lineEnding"), bt;
  }
  function bt(St) {
    return markdownSpace(St) ? factorySpace(
      me,
      Rt,
      "linePrefix",
      Ue.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(St) : Rt(St);
  }
  function Rt(St) {
    return me.enter("htmlTextData"), Xe(St);
  }
}
const labelEnd = {
  name: "labelEnd",
  tokenize: tokenizeLabelEnd,
  resolveTo: resolveToLabelEnd,
  resolveAll: resolveAllLabelEnd
}, resourceConstruct = {
  tokenize: tokenizeResource
}, referenceFullConstruct = {
  tokenize: tokenizeReferenceFull
}, referenceCollapsedConstruct = {
  tokenize: tokenizeReferenceCollapsed
};
function resolveAllLabelEnd(me) {
  let ue = -1;
  for (; ++ue < me.length; ) {
    const Qe = me[ue][1];
    (Qe.type === "labelImage" || Qe.type === "labelLink" || Qe.type === "labelEnd") && (me.splice(ue + 1, Qe.type === "labelImage" ? 4 : 2), Qe.type = "data", ue++);
  }
  return me;
}
function resolveToLabelEnd(me, ue) {
  let Qe = me.length, Ue = 0, He, Ge, Xe, Ke;
  for (; Qe--; )
    if (He = me[Qe][1], Ge) {
      if (He.type === "link" || He.type === "labelLink" && He._inactive)
        break;
      me[Qe][0] === "enter" && He.type === "labelLink" && (He._inactive = !0);
    } else if (Xe) {
      if (me[Qe][0] === "enter" && (He.type === "labelImage" || He.type === "labelLink") && !He._balanced && (Ge = Qe, He.type !== "labelLink")) {
        Ue = 2;
        break;
      }
    } else He.type === "labelEnd" && (Xe = Qe);
  const $e = {
    type: me[Ge][1].type === "labelLink" ? "link" : "image",
    start: Object.assign({}, me[Ge][1].start),
    end: Object.assign({}, me[me.length - 1][1].end)
  }, Je = {
    type: "label",
    start: Object.assign({}, me[Ge][1].start),
    end: Object.assign({}, me[Xe][1].end)
  }, Ze = {
    type: "labelText",
    start: Object.assign({}, me[Ge + Ue + 2][1].end),
    end: Object.assign({}, me[Xe - 2][1].start)
  };
  return Ke = [
    ["enter", $e, ue],
    ["enter", Je, ue]
  ], Ke = push(Ke, me.slice(Ge + 1, Ge + Ue + 3)), Ke = push(Ke, [["enter", Ze, ue]]), Ke = push(
    Ke,
    resolveAll(
      ue.parser.constructs.insideSpan.null,
      me.slice(Ge + Ue + 4, Xe - 3),
      ue
    )
  ), Ke = push(Ke, [
    ["exit", Ze, ue],
    me[Xe - 2],
    me[Xe - 1],
    ["exit", Je, ue]
  ]), Ke = push(Ke, me.slice(Xe + 1)), Ke = push(Ke, [["exit", $e, ue]]), splice(me, Ge, me.length, Ke), me;
}
function tokenizeLabelEnd(me, ue, Qe) {
  const Ue = this;
  let He = Ue.events.length, Ge, Xe;
  for (; He--; )
    if ((Ue.events[He][1].type === "labelImage" || Ue.events[He][1].type === "labelLink") && !Ue.events[He][1]._balanced) {
      Ge = Ue.events[He][1];
      break;
    }
  return Ke;
  function Ke(tt) {
    return Ge ? Ge._inactive ? nt(tt) : (Xe = Ue.parser.defined.includes(
      normalizeIdentifier(
        Ue.sliceSerialize({
          start: Ge.end,
          end: Ue.now()
        })
      )
    ), me.enter("labelEnd"), me.enter("labelMarker"), me.consume(tt), me.exit("labelMarker"), me.exit("labelEnd"), $e) : Qe(tt);
  }
  function $e(tt) {
    return tt === 40 ? me.attempt(
      resourceConstruct,
      Ze,
      Xe ? Ze : nt
    )(tt) : tt === 91 ? me.attempt(
      referenceFullConstruct,
      Ze,
      Xe ? Je : nt
    )(tt) : Xe ? Ze(tt) : nt(tt);
  }
  function Je(tt) {
    return me.attempt(
      referenceCollapsedConstruct,
      Ze,
      nt
    )(tt);
  }
  function Ze(tt) {
    return ue(tt);
  }
  function nt(tt) {
    return Ge._balanced = !0, Qe(tt);
  }
}
function tokenizeResource(me, ue, Qe) {
  return Ue;
  function Ue(nt) {
    return me.enter("resource"), me.enter("resourceMarker"), me.consume(nt), me.exit("resourceMarker"), He;
  }
  function He(nt) {
    return markdownLineEndingOrSpace(nt) ? factoryWhitespace(me, Ge)(nt) : Ge(nt);
  }
  function Ge(nt) {
    return nt === 41 ? Ze(nt) : factoryDestination(
      me,
      Xe,
      Ke,
      "resourceDestination",
      "resourceDestinationLiteral",
      "resourceDestinationLiteralMarker",
      "resourceDestinationRaw",
      "resourceDestinationString",
      32
    )(nt);
  }
  function Xe(nt) {
    return markdownLineEndingOrSpace(nt) ? factoryWhitespace(me, $e)(nt) : Ze(nt);
  }
  function Ke(nt) {
    return Qe(nt);
  }
  function $e(nt) {
    return nt === 34 || nt === 39 || nt === 40 ? factoryTitle(
      me,
      Je,
      Qe,
      "resourceTitle",
      "resourceTitleMarker",
      "resourceTitleString"
    )(nt) : Ze(nt);
  }
  function Je(nt) {
    return markdownLineEndingOrSpace(nt) ? factoryWhitespace(me, Ze)(nt) : Ze(nt);
  }
  function Ze(nt) {
    return nt === 41 ? (me.enter("resourceMarker"), me.consume(nt), me.exit("resourceMarker"), me.exit("resource"), ue) : Qe(nt);
  }
}
function tokenizeReferenceFull(me, ue, Qe) {
  const Ue = this;
  return He;
  function He(Ke) {
    return factoryLabel.call(
      Ue,
      me,
      Ge,
      Xe,
      "reference",
      "referenceMarker",
      "referenceString"
    )(Ke);
  }
  function Ge(Ke) {
    return Ue.parser.defined.includes(
      normalizeIdentifier(
        Ue.sliceSerialize(Ue.events[Ue.events.length - 1][1]).slice(1, -1)
      )
    ) ? ue(Ke) : Qe(Ke);
  }
  function Xe(Ke) {
    return Qe(Ke);
  }
}
function tokenizeReferenceCollapsed(me, ue, Qe) {
  return Ue;
  function Ue(Ge) {
    return me.enter("reference"), me.enter("referenceMarker"), me.consume(Ge), me.exit("referenceMarker"), He;
  }
  function He(Ge) {
    return Ge === 93 ? (me.enter("referenceMarker"), me.consume(Ge), me.exit("referenceMarker"), me.exit("reference"), ue) : Qe(Ge);
  }
}
const labelStartImage = {
  name: "labelStartImage",
  tokenize: tokenizeLabelStartImage,
  resolveAll: labelEnd.resolveAll
};
function tokenizeLabelStartImage(me, ue, Qe) {
  const Ue = this;
  return He;
  function He(Ke) {
    return me.enter("labelImage"), me.enter("labelImageMarker"), me.consume(Ke), me.exit("labelImageMarker"), Ge;
  }
  function Ge(Ke) {
    return Ke === 91 ? (me.enter("labelMarker"), me.consume(Ke), me.exit("labelMarker"), me.exit("labelImage"), Xe) : Qe(Ke);
  }
  function Xe(Ke) {
    return Ke === 94 && "_hiddenFootnoteSupport" in Ue.parser.constructs ? Qe(Ke) : ue(Ke);
  }
}
const labelStartLink = {
  name: "labelStartLink",
  tokenize: tokenizeLabelStartLink,
  resolveAll: labelEnd.resolveAll
};
function tokenizeLabelStartLink(me, ue, Qe) {
  const Ue = this;
  return He;
  function He(Xe) {
    return me.enter("labelLink"), me.enter("labelMarker"), me.consume(Xe), me.exit("labelMarker"), me.exit("labelLink"), Ge;
  }
  function Ge(Xe) {
    return Xe === 94 && "_hiddenFootnoteSupport" in Ue.parser.constructs ? Qe(Xe) : ue(Xe);
  }
}
const lineEnding = {
  name: "lineEnding",
  tokenize: tokenizeLineEnding
};
function tokenizeLineEnding(me, ue) {
  return Qe;
  function Qe(Ue) {
    return me.enter("lineEnding"), me.consume(Ue), me.exit("lineEnding"), factorySpace(me, ue, "linePrefix");
  }
}
const thematicBreak$1 = {
  name: "thematicBreak",
  tokenize: tokenizeThematicBreak
};
function tokenizeThematicBreak(me, ue, Qe) {
  let Ue = 0, He;
  return Ge;
  function Ge(Je) {
    return me.enter("thematicBreak"), Xe(Je);
  }
  function Xe(Je) {
    return He = Je, Ke(Je);
  }
  function Ke(Je) {
    return Je === He ? (me.enter("thematicBreakSequence"), $e(Je)) : Ue >= 3 && (Je === null || markdownLineEnding(Je)) ? (me.exit("thematicBreak"), ue(Je)) : Qe(Je);
  }
  function $e(Je) {
    return Je === He ? (me.consume(Je), Ue++, $e) : (me.exit("thematicBreakSequence"), markdownSpace(Je) ? factorySpace(me, Ke, "whitespace")(Je) : Ke(Je));
  }
}
const list$1 = {
  name: "list",
  tokenize: tokenizeListStart,
  continuation: {
    tokenize: tokenizeListContinuation
  },
  exit: tokenizeListEnd
}, listItemPrefixWhitespaceConstruct = {
  tokenize: tokenizeListItemPrefixWhitespace,
  partial: !0
}, indentConstruct = {
  tokenize: tokenizeIndent,
  partial: !0
};
function tokenizeListStart(me, ue, Qe) {
  const Ue = this, He = Ue.events[Ue.events.length - 1];
  let Ge = He && He[1].type === "linePrefix" ? He[2].sliceSerialize(He[1], !0).length : 0, Xe = 0;
  return Ke;
  function Ke(et) {
    const rt = Ue.containerState.type || (et === 42 || et === 43 || et === 45 ? "listUnordered" : "listOrdered");
    if (rt === "listUnordered" ? !Ue.containerState.marker || et === Ue.containerState.marker : asciiDigit(et)) {
      if (Ue.containerState.type || (Ue.containerState.type = rt, me.enter(rt, {
        _container: !0
      })), rt === "listUnordered")
        return me.enter("listItemPrefix"), et === 42 || et === 45 ? me.check(thematicBreak$1, Qe, Je)(et) : Je(et);
      if (!Ue.interrupt || et === 49)
        return me.enter("listItemPrefix"), me.enter("listItemValue"), $e(et);
    }
    return Qe(et);
  }
  function $e(et) {
    return asciiDigit(et) && ++Xe < 10 ? (me.consume(et), $e) : (!Ue.interrupt || Xe < 2) && (Ue.containerState.marker ? et === Ue.containerState.marker : et === 41 || et === 46) ? (me.exit("listItemValue"), Je(et)) : Qe(et);
  }
  function Je(et) {
    return me.enter("listItemMarker"), me.consume(et), me.exit("listItemMarker"), Ue.containerState.marker = Ue.containerState.marker || et, me.check(
      blankLine,
      // Can’t be empty when interrupting.
      Ue.interrupt ? Qe : Ze,
      me.attempt(
        listItemPrefixWhitespaceConstruct,
        tt,
        nt
      )
    );
  }
  function Ze(et) {
    return Ue.containerState.initialBlankLine = !0, Ge++, tt(et);
  }
  function nt(et) {
    return markdownSpace(et) ? (me.enter("listItemPrefixWhitespace"), me.consume(et), me.exit("listItemPrefixWhitespace"), tt) : Qe(et);
  }
  function tt(et) {
    return Ue.containerState.size = Ge + Ue.sliceSerialize(me.exit("listItemPrefix"), !0).length, ue(et);
  }
}
function tokenizeListContinuation(me, ue, Qe) {
  const Ue = this;
  return Ue.containerState._closeFlow = void 0, me.check(blankLine, He, Ge);
  function He(Ke) {
    return Ue.containerState.furtherBlankLines = Ue.containerState.furtherBlankLines || Ue.containerState.initialBlankLine, factorySpace(
      me,
      ue,
      "listItemIndent",
      Ue.containerState.size + 1
    )(Ke);
  }
  function Ge(Ke) {
    return Ue.containerState.furtherBlankLines || !markdownSpace(Ke) ? (Ue.containerState.furtherBlankLines = void 0, Ue.containerState.initialBlankLine = void 0, Xe(Ke)) : (Ue.containerState.furtherBlankLines = void 0, Ue.containerState.initialBlankLine = void 0, me.attempt(indentConstruct, ue, Xe)(Ke));
  }
  function Xe(Ke) {
    return Ue.containerState._closeFlow = !0, Ue.interrupt = void 0, factorySpace(
      me,
      me.attempt(list$1, ue, Qe),
      "linePrefix",
      Ue.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(Ke);
  }
}
function tokenizeIndent(me, ue, Qe) {
  const Ue = this;
  return factorySpace(
    me,
    He,
    "listItemIndent",
    Ue.containerState.size + 1
  );
  function He(Ge) {
    const Xe = Ue.events[Ue.events.length - 1];
    return Xe && Xe[1].type === "listItemIndent" && Xe[2].sliceSerialize(Xe[1], !0).length === Ue.containerState.size ? ue(Ge) : Qe(Ge);
  }
}
function tokenizeListEnd(me) {
  me.exit(this.containerState.type);
}
function tokenizeListItemPrefixWhitespace(me, ue, Qe) {
  const Ue = this;
  return factorySpace(
    me,
    He,
    "listItemPrefixWhitespace",
    Ue.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5
  );
  function He(Ge) {
    const Xe = Ue.events[Ue.events.length - 1];
    return !markdownSpace(Ge) && Xe && Xe[1].type === "listItemPrefixWhitespace" ? ue(Ge) : Qe(Ge);
  }
}
const setextUnderline = {
  name: "setextUnderline",
  tokenize: tokenizeSetextUnderline,
  resolveTo: resolveToSetextUnderline
};
function resolveToSetextUnderline(me, ue) {
  let Qe = me.length, Ue, He, Ge;
  for (; Qe--; )
    if (me[Qe][0] === "enter") {
      if (me[Qe][1].type === "content") {
        Ue = Qe;
        break;
      }
      me[Qe][1].type === "paragraph" && (He = Qe);
    } else
      me[Qe][1].type === "content" && me.splice(Qe, 1), !Ge && me[Qe][1].type === "definition" && (Ge = Qe);
  const Xe = {
    type: "setextHeading",
    start: Object.assign({}, me[He][1].start),
    end: Object.assign({}, me[me.length - 1][1].end)
  };
  return me[He][1].type = "setextHeadingText", Ge ? (me.splice(He, 0, ["enter", Xe, ue]), me.splice(Ge + 1, 0, ["exit", me[Ue][1], ue]), me[Ue][1].end = Object.assign({}, me[Ge][1].end)) : me[Ue][1] = Xe, me.push(["exit", Xe, ue]), me;
}
function tokenizeSetextUnderline(me, ue, Qe) {
  const Ue = this;
  let He;
  return Ge;
  function Ge(Je) {
    let Ze = Ue.events.length, nt;
    for (; Ze--; )
      if (Ue.events[Ze][1].type !== "lineEnding" && Ue.events[Ze][1].type !== "linePrefix" && Ue.events[Ze][1].type !== "content") {
        nt = Ue.events[Ze][1].type === "paragraph";
        break;
      }
    return !Ue.parser.lazy[Ue.now().line] && (Ue.interrupt || nt) ? (me.enter("setextHeadingLine"), He = Je, Xe(Je)) : Qe(Je);
  }
  function Xe(Je) {
    return me.enter("setextHeadingLineSequence"), Ke(Je);
  }
  function Ke(Je) {
    return Je === He ? (me.consume(Je), Ke) : (me.exit("setextHeadingLineSequence"), markdownSpace(Je) ? factorySpace(me, $e, "lineSuffix")(Je) : $e(Je));
  }
  function $e(Je) {
    return Je === null || markdownLineEnding(Je) ? (me.exit("setextHeadingLine"), ue(Je)) : Qe(Je);
  }
}
const flow$1 = {
  tokenize: initializeFlow
};
function initializeFlow(me) {
  const ue = this, Qe = me.attempt(
    // Try to parse a blank line.
    blankLine,
    Ue,
    // Try to parse initial flow (essentially, only code).
    me.attempt(
      this.parser.constructs.flowInitial,
      He,
      factorySpace(
        me,
        me.attempt(
          this.parser.constructs.flow,
          He,
          me.attempt(content, He)
        ),
        "linePrefix"
      )
    )
  );
  return Qe;
  function Ue(Ge) {
    if (Ge === null) {
      me.consume(Ge);
      return;
    }
    return me.enter("lineEndingBlank"), me.consume(Ge), me.exit("lineEndingBlank"), ue.currentConstruct = void 0, Qe;
  }
  function He(Ge) {
    if (Ge === null) {
      me.consume(Ge);
      return;
    }
    return me.enter("lineEnding"), me.consume(Ge), me.exit("lineEnding"), ue.currentConstruct = void 0, Qe;
  }
}
const resolver = {
  resolveAll: createResolver()
}, string$1 = initializeFactory("string"), text$4 = initializeFactory("text");
function initializeFactory(me) {
  return {
    tokenize: ue,
    resolveAll: createResolver(
      me === "text" ? resolveAllLineSuffixes : void 0
    )
  };
  function ue(Qe) {
    const Ue = this, He = this.parser.constructs[me], Ge = Qe.attempt(He, Xe, Ke);
    return Xe;
    function Xe(Ze) {
      return Je(Ze) ? Ge(Ze) : Ke(Ze);
    }
    function Ke(Ze) {
      if (Ze === null) {
        Qe.consume(Ze);
        return;
      }
      return Qe.enter("data"), Qe.consume(Ze), $e;
    }
    function $e(Ze) {
      return Je(Ze) ? (Qe.exit("data"), Ge(Ze)) : (Qe.consume(Ze), $e);
    }
    function Je(Ze) {
      if (Ze === null)
        return !0;
      const nt = He[Ze];
      let tt = -1;
      if (nt)
        for (; ++tt < nt.length; ) {
          const et = nt[tt];
          if (!et.previous || et.previous.call(Ue, Ue.previous))
            return !0;
        }
      return !1;
    }
  }
}
function createResolver(me) {
  return ue;
  function ue(Qe, Ue) {
    let He = -1, Ge;
    for (; ++He <= Qe.length; )
      Ge === void 0 ? Qe[He] && Qe[He][1].type === "data" && (Ge = He, He++) : (!Qe[He] || Qe[He][1].type !== "data") && (He !== Ge + 2 && (Qe[Ge][1].end = Qe[He - 1][1].end, Qe.splice(Ge + 2, He - Ge - 2), He = Ge + 2), Ge = void 0);
    return me ? me(Qe, Ue) : Qe;
  }
}
function resolveAllLineSuffixes(me, ue) {
  let Qe = 0;
  for (; ++Qe <= me.length; )
    if ((Qe === me.length || me[Qe][1].type === "lineEnding") && me[Qe - 1][1].type === "data") {
      const Ue = me[Qe - 1][1], He = ue.sliceStream(Ue);
      let Ge = He.length, Xe = -1, Ke = 0, $e;
      for (; Ge--; ) {
        const Je = He[Ge];
        if (typeof Je == "string") {
          for (Xe = Je.length; Je.charCodeAt(Xe - 1) === 32; )
            Ke++, Xe--;
          if (Xe) break;
          Xe = -1;
        } else if (Je === -2)
          $e = !0, Ke++;
        else if (Je !== -1) {
          Ge++;
          break;
        }
      }
      if (Ke) {
        const Je = {
          type: Qe === me.length || $e || Ke < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: Ue.end.line,
            column: Ue.end.column - Ke,
            offset: Ue.end.offset - Ke,
            _index: Ue.start._index + Ge,
            _bufferIndex: Ge ? Xe : Ue.start._bufferIndex + Xe
          },
          end: Object.assign({}, Ue.end)
        };
        Ue.end = Object.assign({}, Je.start), Ue.start.offset === Ue.end.offset ? Object.assign(Ue, Je) : (me.splice(
          Qe,
          0,
          ["enter", Je, ue],
          ["exit", Je, ue]
        ), Qe += 2);
      }
      Qe++;
    }
  return me;
}
function createTokenizer(me, ue, Qe) {
  let Ue = Object.assign(
    Qe ? Object.assign({}, Qe) : {
      line: 1,
      column: 1,
      offset: 0
    },
    {
      _index: 0,
      _bufferIndex: -1
    }
  );
  const He = {}, Ge = [];
  let Xe = [], Ke = [];
  const $e = {
    consume: st,
    enter: ut,
    exit: lt,
    attempt: pt(dt),
    check: pt(At),
    interrupt: pt(At, {
      interrupt: !0
    })
  }, Je = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser: me,
    sliceStream: et,
    sliceSerialize: tt,
    now: rt,
    defineSkip: it,
    write: nt
  };
  let Ze = ue.tokenize.call(Je, $e);
  return ue.resolveAll && Ge.push(ue), Je;
  function nt(Tt) {
    return Xe = push(Xe, Tt), ot(), Xe[Xe.length - 1] !== null ? [] : (gt(ue, 0), Je.events = resolveAll(Ge, Je.events, Je), Je.events);
  }
  function tt(Tt, yt) {
    return serializeChunks(et(Tt), yt);
  }
  function et(Tt) {
    return sliceChunks(Xe, Tt);
  }
  function rt() {
    const { line: Tt, column: yt, offset: Ct, _index: ht, _bufferIndex: It } = Ue;
    return {
      line: Tt,
      column: yt,
      offset: Ct,
      _index: ht,
      _bufferIndex: It
    };
  }
  function it(Tt) {
    He[Tt.line] = Tt.column, Bt();
  }
  function ot() {
    let Tt;
    for (; Ue._index < Xe.length; ) {
      const yt = Xe[Ue._index];
      if (typeof yt == "string")
        for (Tt = Ue._index, Ue._bufferIndex < 0 && (Ue._bufferIndex = 0); Ue._index === Tt && Ue._bufferIndex < yt.length; )
          at(yt.charCodeAt(Ue._bufferIndex));
      else
        at(yt);
    }
  }
  function at(Tt) {
    Ze = Ze(Tt);
  }
  function st(Tt) {
    markdownLineEnding(Tt) ? (Ue.line++, Ue.column = 1, Ue.offset += Tt === -3 ? 2 : 1, Bt()) : Tt !== -1 && (Ue.column++, Ue.offset++), Ue._bufferIndex < 0 ? Ue._index++ : (Ue._bufferIndex++, Ue._bufferIndex === Xe[Ue._index].length && (Ue._bufferIndex = -1, Ue._index++)), Je.previous = Tt;
  }
  function ut(Tt, yt) {
    const Ct = yt || {};
    return Ct.type = Tt, Ct.start = rt(), Je.events.push(["enter", Ct, Je]), Ke.push(Ct), Ct;
  }
  function lt(Tt) {
    const yt = Ke.pop();
    return yt.end = rt(), Je.events.push(["exit", yt, Je]), yt;
  }
  function dt(Tt, yt) {
    gt(Tt, yt.from);
  }
  function At(Tt, yt) {
    yt.restore();
  }
  function pt(Tt, yt) {
    return Ct;
    function Ct(ht, It, vt) {
      let Et, bt, Rt, St;
      return Array.isArray(ht) ? jt(ht) : "tokenize" in ht ? (
        // @ts-expect-error Looks like a construct.
        jt([ht])
      ) : kt(ht);
      function kt(_t) {
        return Yt;
        function Yt(Xt) {
          const Ut = Xt !== null && _t[Xt], Lt = Xt !== null && _t.null, Ot = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Ut) ? Ut : Ut ? [Ut] : [],
            ...Array.isArray(Lt) ? Lt : Lt ? [Lt] : []
          ];
          return jt(Ot)(Xt);
        }
      }
      function jt(_t) {
        return Et = _t, bt = 0, _t.length === 0 ? vt : Pt(_t[bt]);
      }
      function Pt(_t) {
        return Yt;
        function Yt(Xt) {
          return St = wt(), Rt = _t, _t.partial || (Je.currentConstruct = _t), _t.name && Je.parser.constructs.disable.null.includes(_t.name) ? qt() : _t.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            yt ? Object.assign(Object.create(Je), yt) : Je,
            $e,
            Qt,
            qt
          )(Xt);
        }
      }
      function Qt(_t) {
        return Tt(Rt, St), It;
      }
      function qt(_t) {
        return St.restore(), ++bt < Et.length ? Pt(Et[bt]) : vt;
      }
    }
  }
  function gt(Tt, yt) {
    Tt.resolveAll && !Ge.includes(Tt) && Ge.push(Tt), Tt.resolve && splice(
      Je.events,
      yt,
      Je.events.length - yt,
      Tt.resolve(Je.events.slice(yt), Je)
    ), Tt.resolveTo && (Je.events = Tt.resolveTo(Je.events, Je));
  }
  function wt() {
    const Tt = rt(), yt = Je.previous, Ct = Je.currentConstruct, ht = Je.events.length, It = Array.from(Ke);
    return {
      restore: vt,
      from: ht
    };
    function vt() {
      Ue = Tt, Je.previous = yt, Je.currentConstruct = Ct, Je.events.length = ht, Ke = It, Bt();
    }
  }
  function Bt() {
    Ue.line in He && Ue.column < 2 && (Ue.column = He[Ue.line], Ue.offset += He[Ue.line] - 1);
  }
}
function sliceChunks(me, ue) {
  const Qe = ue.start._index, Ue = ue.start._bufferIndex, He = ue.end._index, Ge = ue.end._bufferIndex;
  let Xe;
  if (Qe === He)
    Xe = [me[Qe].slice(Ue, Ge)];
  else {
    if (Xe = me.slice(Qe, He), Ue > -1) {
      const Ke = Xe[0];
      typeof Ke == "string" ? Xe[0] = Ke.slice(Ue) : Xe.shift();
    }
    Ge > 0 && Xe.push(me[He].slice(0, Ge));
  }
  return Xe;
}
function serializeChunks(me, ue) {
  let Qe = -1;
  const Ue = [];
  let He;
  for (; ++Qe < me.length; ) {
    const Ge = me[Qe];
    let Xe;
    if (typeof Ge == "string")
      Xe = Ge;
    else
      switch (Ge) {
        case -5: {
          Xe = "\r";
          break;
        }
        case -4: {
          Xe = `
`;
          break;
        }
        case -3: {
          Xe = `\r
`;
          break;
        }
        case -2: {
          Xe = ue ? " " : "	";
          break;
        }
        case -1: {
          if (!ue && He) continue;
          Xe = " ";
          break;
        }
        default:
          Xe = String.fromCharCode(Ge);
      }
    He = Ge === -2, Ue.push(Xe);
  }
  return Ue.join("");
}
const document$2 = {
  42: list$1,
  43: list$1,
  45: list$1,
  48: list$1,
  49: list$1,
  50: list$1,
  51: list$1,
  52: list$1,
  53: list$1,
  54: list$1,
  55: list$1,
  56: list$1,
  57: list$1,
  62: blockQuote
}, contentInitial = {
  91: definition
}, flowInitial = {
  [-2]: codeIndented,
  [-1]: codeIndented,
  32: codeIndented
}, flow = {
  35: headingAtx,
  42: thematicBreak$1,
  45: [setextUnderline, thematicBreak$1],
  60: htmlFlow,
  61: setextUnderline,
  95: thematicBreak$1,
  96: codeFenced,
  126: codeFenced
}, string = {
  38: characterReference,
  92: characterEscape
}, text$3 = {
  [-5]: lineEnding,
  [-4]: lineEnding,
  [-3]: lineEnding,
  33: labelStartImage,
  38: characterReference,
  42: attention,
  60: [autolink, htmlText],
  91: labelStartLink,
  92: [hardBreakEscape, characterEscape],
  93: labelEnd,
  95: attention,
  96: codeText
}, insideSpan = {
  null: [attention, resolver]
}, attentionMarkers = {
  null: [42, 95]
}, disable = {
  null: []
}, defaultConstructs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers,
  contentInitial,
  disable,
  document: document$2,
  flow,
  flowInitial,
  insideSpan,
  string,
  text: text$3
}, Symbol.toStringTag, { value: "Module" }));
function parse(me) {
  const Qe = (
    /** @type {FullNormalizedExtension} */
    combineExtensions([defaultConstructs, ...(me || {}).extensions || []])
  ), Ue = {
    defined: [],
    lazy: {},
    constructs: Qe,
    content: He(content$1),
    document: He(document$3),
    flow: He(flow$1),
    string: He(string$1),
    text: He(text$4)
  };
  return Ue;
  function He(Ge) {
    return Xe;
    function Xe(Ke) {
      return createTokenizer(Ue, Ge, Ke);
    }
  }
}
function postprocess(me) {
  for (; !subtokenize(me); )
    ;
  return me;
}
const search$2 = /[\0\t\n\r]/g;
function preprocess() {
  let me = 1, ue = "", Qe = !0, Ue;
  return He;
  function He(Ge, Xe, Ke) {
    const $e = [];
    let Je, Ze, nt, tt, et;
    for (Ge = ue + (typeof Ge == "string" ? Ge.toString() : new TextDecoder(Xe || void 0).decode(Ge)), nt = 0, ue = "", Qe && (Ge.charCodeAt(0) === 65279 && nt++, Qe = void 0); nt < Ge.length; ) {
      if (search$2.lastIndex = nt, Je = search$2.exec(Ge), tt = Je && Je.index !== void 0 ? Je.index : Ge.length, et = Ge.charCodeAt(tt), !Je) {
        ue = Ge.slice(nt);
        break;
      }
      if (et === 10 && nt === tt && Ue)
        $e.push(-3), Ue = void 0;
      else
        switch (Ue && ($e.push(-5), Ue = void 0), nt < tt && ($e.push(Ge.slice(nt, tt)), me += tt - nt), et) {
          case 0: {
            $e.push(65533), me++;
            break;
          }
          case 9: {
            for (Ze = Math.ceil(me / 4) * 4, $e.push(-2); me++ < Ze; ) $e.push(-1);
            break;
          }
          case 10: {
            $e.push(-4), me = 1;
            break;
          }
          default:
            Ue = !0, me = 1;
        }
      nt = tt + 1;
    }
    return Ke && (Ue && $e.push(-5), ue && $e.push(ue), $e.push(null)), $e;
  }
}
const characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function decodeString(me) {
  return me.replace(characterEscapeOrReference, decode);
}
function decode(me, ue, Qe) {
  if (ue)
    return ue;
  if (Qe.charCodeAt(0) === 35) {
    const He = Qe.charCodeAt(1), Ge = He === 120 || He === 88;
    return decodeNumericCharacterReference(Qe.slice(Ge ? 2 : 1), Ge ? 16 : 10);
  }
  return decodeNamedCharacterReference(Qe) || me;
}
const own$6 = {}.hasOwnProperty;
function fromMarkdown(me, ue, Qe) {
  return typeof ue != "string" && (Qe = ue, ue = void 0), compiler(Qe)(
    postprocess(
      parse(Qe).document().write(preprocess()(me, ue, !0))
    )
  );
}
function compiler(me) {
  const ue = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: Ge($t),
      autolinkProtocol: wt,
      autolinkEmail: wt,
      atxHeading: Ge(Mt),
      blockQuote: Ge(Ut),
      characterEscape: wt,
      characterReference: wt,
      codeFenced: Ge(Lt),
      codeFencedFenceInfo: Xe,
      codeFencedFenceMeta: Xe,
      codeIndented: Ge(Lt, Xe),
      codeText: Ge(Ot, Xe),
      codeTextData: wt,
      data: wt,
      codeFlowValue: wt,
      definition: Ge(ft),
      definitionDestinationString: Xe,
      definitionLabelString: Xe,
      definitionTitleString: Xe,
      emphasis: Ge(Dt),
      hardBreakEscape: Ge(Ft),
      hardBreakTrailing: Ge(Ft),
      htmlFlow: Ge(Gt, Xe),
      htmlFlowData: wt,
      htmlText: Ge(Gt, Xe),
      htmlTextData: wt,
      image: Ge(zt),
      label: Xe,
      link: Ge($t),
      listItem: Ge(hn),
      listItemValue: tt,
      listOrdered: Ge(Ht, nt),
      listUnordered: Ge(Ht),
      paragraph: Ge(un),
      reference: Pt,
      referenceString: Xe,
      resourceDestinationString: Xe,
      resourceTitleString: Xe,
      setextHeading: Ge(Mt),
      strong: Ge(An),
      thematicBreak: Ge(En)
    },
    exit: {
      atxHeading: $e(),
      atxHeadingSequence: dt,
      autolink: $e(),
      autolinkEmail: Xt,
      autolinkProtocol: Yt,
      blockQuote: $e(),
      characterEscapeValue: Bt,
      characterReferenceMarkerHexadecimal: qt,
      characterReferenceMarkerNumeric: qt,
      characterReferenceValue: _t,
      codeFenced: $e(ot),
      codeFencedFence: it,
      codeFencedFenceInfo: et,
      codeFencedFenceMeta: rt,
      codeFlowValue: Bt,
      codeIndented: $e(at),
      codeText: $e(It),
      codeTextData: Bt,
      data: Bt,
      definition: $e(),
      definitionDestinationString: lt,
      definitionLabelString: st,
      definitionTitleString: ut,
      emphasis: $e(),
      hardBreakEscape: $e(yt),
      hardBreakTrailing: $e(yt),
      htmlFlow: $e(Ct),
      htmlFlowData: Bt,
      htmlText: $e(ht),
      htmlTextData: Bt,
      image: $e(Et),
      label: Rt,
      labelText: bt,
      lineEnding: Tt,
      link: $e(vt),
      listItem: $e(),
      listOrdered: $e(),
      listUnordered: $e(),
      paragraph: $e(),
      referenceString: Qt,
      resourceDestinationString: St,
      resourceTitleString: kt,
      resource: jt,
      setextHeading: $e(gt),
      setextHeadingLineSequence: pt,
      setextHeadingText: At,
      strong: $e(),
      thematicBreak: $e()
    }
  };
  configure(ue, (me || {}).mdastExtensions || []);
  const Qe = {};
  return Ue;
  function Ue(Jt) {
    let an = {
      type: "root",
      children: []
    };
    const cn = {
      stack: [an],
      tokenStack: [],
      config: ue,
      enter: Ke,
      exit: Je,
      buffer: Xe,
      resume: Ze,
      data: Qe
    }, dn = [];
    let yn = -1;
    for (; ++yn < Jt.length; )
      if (Jt[yn][1].type === "listOrdered" || Jt[yn][1].type === "listUnordered")
        if (Jt[yn][0] === "enter")
          dn.push(yn);
        else {
          const Nn = dn.pop();
          yn = He(Jt, Nn, yn);
        }
    for (yn = -1; ++yn < Jt.length; ) {
      const Nn = ue[Jt[yn][0]];
      own$6.call(Nn, Jt[yn][1].type) && Nn[Jt[yn][1].type].call(
        Object.assign(
          {
            sliceSerialize: Jt[yn][2].sliceSerialize
          },
          cn
        ),
        Jt[yn][1]
      );
    }
    if (cn.tokenStack.length > 0) {
      const Nn = cn.tokenStack[cn.tokenStack.length - 1];
      (Nn[1] || defaultOnError).call(cn, void 0, Nn[0]);
    }
    for (an.position = {
      start: point$1(
        Jt.length > 0 ? Jt[0][1].start : {
          line: 1,
          column: 1,
          offset: 0
        }
      ),
      end: point$1(
        Jt.length > 0 ? Jt[Jt.length - 2][1].end : {
          line: 1,
          column: 1,
          offset: 0
        }
      )
    }, yn = -1; ++yn < ue.transforms.length; )
      an = ue.transforms[yn](an) || an;
    return an;
  }
  function He(Jt, an, cn) {
    let dn = an - 1, yn = -1, Nn = !1, Rn, rn, ln, pn;
    for (; ++dn <= cn; ) {
      const Sn = Jt[dn];
      switch (Sn[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          Sn[0] === "enter" ? yn++ : yn--, pn = void 0;
          break;
        }
        case "lineEndingBlank": {
          Sn[0] === "enter" && (Rn && !pn && !yn && !ln && (ln = dn), pn = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          pn = void 0;
      }
      if (!yn && Sn[0] === "enter" && Sn[1].type === "listItemPrefix" || yn === -1 && Sn[0] === "exit" && (Sn[1].type === "listUnordered" || Sn[1].type === "listOrdered")) {
        if (Rn) {
          let In = dn;
          for (rn = void 0; In--; ) {
            const Bn = Jt[In];
            if (Bn[1].type === "lineEnding" || Bn[1].type === "lineEndingBlank") {
              if (Bn[0] === "exit") continue;
              rn && (Jt[rn][1].type = "lineEndingBlank", Nn = !0), Bn[1].type = "lineEnding", rn = In;
            } else if (!(Bn[1].type === "linePrefix" || Bn[1].type === "blockQuotePrefix" || Bn[1].type === "blockQuotePrefixWhitespace" || Bn[1].type === "blockQuoteMarker" || Bn[1].type === "listItemIndent")) break;
          }
          ln && (!rn || ln < rn) && (Rn._spread = !0), Rn.end = Object.assign(
            {},
            rn ? Jt[rn][1].start : Sn[1].end
          ), Jt.splice(rn || dn, 0, ["exit", Rn, Sn[2]]), dn++, cn++;
        }
        if (Sn[1].type === "listItemPrefix") {
          const In = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, Sn[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          Rn = In, Jt.splice(dn, 0, ["enter", In, Sn[2]]), dn++, cn++, ln = void 0, pn = !0;
        }
      }
    }
    return Jt[an][1]._spread = Nn, cn;
  }
  function Ge(Jt, an) {
    return cn;
    function cn(dn) {
      Ke.call(this, Jt(dn), dn), an && an.call(this, dn);
    }
  }
  function Xe() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function Ke(Jt, an, cn) {
    this.stack[this.stack.length - 1].children.push(Jt), this.stack.push(Jt), this.tokenStack.push([an, cn]), Jt.position = {
      start: point$1(an.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function $e(Jt) {
    return an;
    function an(cn) {
      Jt && Jt.call(this, cn), Je.call(this, cn);
    }
  }
  function Je(Jt, an) {
    const cn = this.stack.pop(), dn = this.tokenStack.pop();
    if (dn)
      dn[0].type !== Jt.type && (an ? an.call(this, Jt, dn[0]) : (dn[1] || defaultOnError).call(this, Jt, dn[0]));
    else throw new Error(
      "Cannot close `" + Jt.type + "` (" + stringifyPosition({
        start: Jt.start,
        end: Jt.end
      }) + "): it’s not open"
    );
    cn.position.end = point$1(Jt.end);
  }
  function Ze() {
    return toString$2(this.stack.pop());
  }
  function nt() {
    this.data.expectingFirstListItemValue = !0;
  }
  function tt(Jt) {
    if (this.data.expectingFirstListItemValue) {
      const an = this.stack[this.stack.length - 2];
      an.start = Number.parseInt(this.sliceSerialize(Jt), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function et() {
    const Jt = this.resume(), an = this.stack[this.stack.length - 1];
    an.lang = Jt;
  }
  function rt() {
    const Jt = this.resume(), an = this.stack[this.stack.length - 1];
    an.meta = Jt;
  }
  function it() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function ot() {
    const Jt = this.resume(), an = this.stack[this.stack.length - 1];
    an.value = Jt.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function at() {
    const Jt = this.resume(), an = this.stack[this.stack.length - 1];
    an.value = Jt.replace(/(\r?\n|\r)$/g, "");
  }
  function st(Jt) {
    const an = this.resume(), cn = this.stack[this.stack.length - 1];
    cn.label = an, cn.identifier = normalizeIdentifier(
      this.sliceSerialize(Jt)
    ).toLowerCase();
  }
  function ut() {
    const Jt = this.resume(), an = this.stack[this.stack.length - 1];
    an.title = Jt;
  }
  function lt() {
    const Jt = this.resume(), an = this.stack[this.stack.length - 1];
    an.url = Jt;
  }
  function dt(Jt) {
    const an = this.stack[this.stack.length - 1];
    if (!an.depth) {
      const cn = this.sliceSerialize(Jt).length;
      an.depth = cn;
    }
  }
  function At() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function pt(Jt) {
    const an = this.stack[this.stack.length - 1];
    an.depth = this.sliceSerialize(Jt).codePointAt(0) === 61 ? 1 : 2;
  }
  function gt() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function wt(Jt) {
    const cn = this.stack[this.stack.length - 1].children;
    let dn = cn[cn.length - 1];
    (!dn || dn.type !== "text") && (dn = mn(), dn.position = {
      start: point$1(Jt.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, cn.push(dn)), this.stack.push(dn);
  }
  function Bt(Jt) {
    const an = this.stack.pop();
    an.value += this.sliceSerialize(Jt), an.position.end = point$1(Jt.end);
  }
  function Tt(Jt) {
    const an = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const cn = an.children[an.children.length - 1];
      cn.position.end = point$1(Jt.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && ue.canContainEols.includes(an.type) && (wt.call(this, Jt), Bt.call(this, Jt));
  }
  function yt() {
    this.data.atHardBreak = !0;
  }
  function Ct() {
    const Jt = this.resume(), an = this.stack[this.stack.length - 1];
    an.value = Jt;
  }
  function ht() {
    const Jt = this.resume(), an = this.stack[this.stack.length - 1];
    an.value = Jt;
  }
  function It() {
    const Jt = this.resume(), an = this.stack[this.stack.length - 1];
    an.value = Jt;
  }
  function vt() {
    const Jt = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const an = this.data.referenceType || "shortcut";
      Jt.type += "Reference", Jt.referenceType = an, delete Jt.url, delete Jt.title;
    } else
      delete Jt.identifier, delete Jt.label;
    this.data.referenceType = void 0;
  }
  function Et() {
    const Jt = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const an = this.data.referenceType || "shortcut";
      Jt.type += "Reference", Jt.referenceType = an, delete Jt.url, delete Jt.title;
    } else
      delete Jt.identifier, delete Jt.label;
    this.data.referenceType = void 0;
  }
  function bt(Jt) {
    const an = this.sliceSerialize(Jt), cn = this.stack[this.stack.length - 2];
    cn.label = decodeString(an), cn.identifier = normalizeIdentifier(an).toLowerCase();
  }
  function Rt() {
    const Jt = this.stack[this.stack.length - 1], an = this.resume(), cn = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, cn.type === "link") {
      const dn = Jt.children;
      cn.children = dn;
    } else
      cn.alt = an;
  }
  function St() {
    const Jt = this.resume(), an = this.stack[this.stack.length - 1];
    an.url = Jt;
  }
  function kt() {
    const Jt = this.resume(), an = this.stack[this.stack.length - 1];
    an.title = Jt;
  }
  function jt() {
    this.data.inReference = void 0;
  }
  function Pt() {
    this.data.referenceType = "collapsed";
  }
  function Qt(Jt) {
    const an = this.resume(), cn = this.stack[this.stack.length - 1];
    cn.label = an, cn.identifier = normalizeIdentifier(
      this.sliceSerialize(Jt)
    ).toLowerCase(), this.data.referenceType = "full";
  }
  function qt(Jt) {
    this.data.characterReferenceType = Jt.type;
  }
  function _t(Jt) {
    const an = this.sliceSerialize(Jt), cn = this.data.characterReferenceType;
    let dn;
    cn ? (dn = decodeNumericCharacterReference(
      an,
      cn === "characterReferenceMarkerNumeric" ? 10 : 16
    ), this.data.characterReferenceType = void 0) : dn = decodeNamedCharacterReference(an);
    const yn = this.stack.pop();
    yn.value += dn, yn.position.end = point$1(Jt.end);
  }
  function Yt(Jt) {
    Bt.call(this, Jt);
    const an = this.stack[this.stack.length - 1];
    an.url = this.sliceSerialize(Jt);
  }
  function Xt(Jt) {
    Bt.call(this, Jt);
    const an = this.stack[this.stack.length - 1];
    an.url = "mailto:" + this.sliceSerialize(Jt);
  }
  function Ut() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function Lt() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Ot() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function ft() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Dt() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function Mt() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function Ft() {
    return {
      type: "break"
    };
  }
  function Gt() {
    return {
      type: "html",
      value: ""
    };
  }
  function zt() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function $t() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function Ht(Jt) {
    return {
      type: "list",
      ordered: Jt.type === "listOrdered",
      start: null,
      spread: Jt._spread,
      children: []
    };
  }
  function hn(Jt) {
    return {
      type: "listItem",
      spread: Jt._spread,
      checked: null,
      children: []
    };
  }
  function un() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function An() {
    return {
      type: "strong",
      children: []
    };
  }
  function mn() {
    return {
      type: "text",
      value: ""
    };
  }
  function En() {
    return {
      type: "thematicBreak"
    };
  }
}
function point$1(me) {
  return {
    line: me.line,
    column: me.column,
    offset: me.offset
  };
}
function configure(me, ue) {
  let Qe = -1;
  for (; ++Qe < ue.length; ) {
    const Ue = ue[Qe];
    Array.isArray(Ue) ? configure(me, Ue) : extension(me, Ue);
  }
}
function extension(me, ue) {
  let Qe;
  for (Qe in ue)
    if (own$6.call(ue, Qe))
      switch (Qe) {
        case "canContainEols": {
          const Ue = ue[Qe];
          Ue && me[Qe].push(...Ue);
          break;
        }
        case "transforms": {
          const Ue = ue[Qe];
          Ue && me[Qe].push(...Ue);
          break;
        }
        case "enter":
        case "exit": {
          const Ue = ue[Qe];
          Ue && Object.assign(me[Qe], Ue);
          break;
        }
      }
}
function defaultOnError(me, ue) {
  throw me ? new Error(
    "Cannot close `" + me.type + "` (" + stringifyPosition({
      start: me.start,
      end: me.end
    }) + "): a different token (`" + ue.type + "`, " + stringifyPosition({
      start: ue.start,
      end: ue.end
    }) + ") is open"
  ) : new Error(
    "Cannot close document, a token (`" + ue.type + "`, " + stringifyPosition({
      start: ue.start,
      end: ue.end
    }) + ") is still open"
  );
}
function remarkParse(me) {
  const ue = this;
  ue.parser = Qe;
  function Qe(Ue) {
    return fromMarkdown(Ue, {
      ...ue.data("settings"),
      ...me,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: ue.data("micromarkExtensions") || [],
      mdastExtensions: ue.data("fromMarkdownExtensions") || []
    });
  }
}
function blockquote(me, ue) {
  const Qe = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: me.wrap(me.all(ue), !0)
  };
  return me.patch(ue, Qe), me.applyData(ue, Qe);
}
function hardBreak(me, ue) {
  const Qe = { type: "element", tagName: "br", properties: {}, children: [] };
  return me.patch(ue, Qe), [me.applyData(ue, Qe), { type: "text", value: `
` }];
}
function code(me, ue) {
  const Qe = ue.value ? ue.value + `
` : "", Ue = {};
  ue.lang && (Ue.className = ["language-" + ue.lang]);
  let He = {
    type: "element",
    tagName: "code",
    properties: Ue,
    children: [{ type: "text", value: Qe }]
  };
  return ue.meta && (He.data = { meta: ue.meta }), me.patch(ue, He), He = me.applyData(ue, He), He = { type: "element", tagName: "pre", properties: {}, children: [He] }, me.patch(ue, He), He;
}
function strikethrough(me, ue) {
  const Qe = {
    type: "element",
    tagName: "del",
    properties: {},
    children: me.all(ue)
  };
  return me.patch(ue, Qe), me.applyData(ue, Qe);
}
function emphasis(me, ue) {
  const Qe = {
    type: "element",
    tagName: "em",
    properties: {},
    children: me.all(ue)
  };
  return me.patch(ue, Qe), me.applyData(ue, Qe);
}
function footnoteReference(me, ue) {
  const Qe = typeof me.options.clobberPrefix == "string" ? me.options.clobberPrefix : "user-content-", Ue = String(ue.identifier).toUpperCase(), He = normalizeUri(Ue.toLowerCase()), Ge = me.footnoteOrder.indexOf(Ue);
  let Xe, Ke = me.footnoteCounts.get(Ue);
  Ke === void 0 ? (Ke = 0, me.footnoteOrder.push(Ue), Xe = me.footnoteOrder.length) : Xe = Ge + 1, Ke += 1, me.footnoteCounts.set(Ue, Ke);
  const $e = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + Qe + "fn-" + He,
      id: Qe + "fnref-" + He + (Ke > 1 ? "-" + Ke : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(Xe) }]
  };
  me.patch(ue, $e);
  const Je = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [$e]
  };
  return me.patch(ue, Je), me.applyData(ue, Je);
}
function heading(me, ue) {
  const Qe = {
    type: "element",
    tagName: "h" + ue.depth,
    properties: {},
    children: me.all(ue)
  };
  return me.patch(ue, Qe), me.applyData(ue, Qe);
}
function html(me, ue) {
  if (me.options.allowDangerousHtml) {
    const Qe = { type: "raw", value: ue.value };
    return me.patch(ue, Qe), me.applyData(ue, Qe);
  }
}
function revert(me, ue) {
  const Qe = ue.referenceType;
  let Ue = "]";
  if (Qe === "collapsed" ? Ue += "[]" : Qe === "full" && (Ue += "[" + (ue.label || ue.identifier) + "]"), ue.type === "imageReference")
    return [{ type: "text", value: "![" + ue.alt + Ue }];
  const He = me.all(ue), Ge = He[0];
  Ge && Ge.type === "text" ? Ge.value = "[" + Ge.value : He.unshift({ type: "text", value: "[" });
  const Xe = He[He.length - 1];
  return Xe && Xe.type === "text" ? Xe.value += Ue : He.push({ type: "text", value: Ue }), He;
}
function imageReference(me, ue) {
  const Qe = String(ue.identifier).toUpperCase(), Ue = me.definitionById.get(Qe);
  if (!Ue)
    return revert(me, ue);
  const He = { src: normalizeUri(Ue.url || ""), alt: ue.alt };
  Ue.title !== null && Ue.title !== void 0 && (He.title = Ue.title);
  const Ge = { type: "element", tagName: "img", properties: He, children: [] };
  return me.patch(ue, Ge), me.applyData(ue, Ge);
}
function image(me, ue) {
  const Qe = { src: normalizeUri(ue.url) };
  ue.alt !== null && ue.alt !== void 0 && (Qe.alt = ue.alt), ue.title !== null && ue.title !== void 0 && (Qe.title = ue.title);
  const Ue = { type: "element", tagName: "img", properties: Qe, children: [] };
  return me.patch(ue, Ue), me.applyData(ue, Ue);
}
function inlineCode(me, ue) {
  const Qe = { type: "text", value: ue.value.replace(/\r?\n|\r/g, " ") };
  me.patch(ue, Qe);
  const Ue = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [Qe]
  };
  return me.patch(ue, Ue), me.applyData(ue, Ue);
}
function linkReference(me, ue) {
  const Qe = String(ue.identifier).toUpperCase(), Ue = me.definitionById.get(Qe);
  if (!Ue)
    return revert(me, ue);
  const He = { href: normalizeUri(Ue.url || "") };
  Ue.title !== null && Ue.title !== void 0 && (He.title = Ue.title);
  const Ge = {
    type: "element",
    tagName: "a",
    properties: He,
    children: me.all(ue)
  };
  return me.patch(ue, Ge), me.applyData(ue, Ge);
}
function link(me, ue) {
  const Qe = { href: normalizeUri(ue.url) };
  ue.title !== null && ue.title !== void 0 && (Qe.title = ue.title);
  const Ue = {
    type: "element",
    tagName: "a",
    properties: Qe,
    children: me.all(ue)
  };
  return me.patch(ue, Ue), me.applyData(ue, Ue);
}
function listItem(me, ue, Qe) {
  const Ue = me.all(ue), He = Qe ? listLoose(Qe) : listItemLoose(ue), Ge = {}, Xe = [];
  if (typeof ue.checked == "boolean") {
    const Ze = Ue[0];
    let nt;
    Ze && Ze.type === "element" && Ze.tagName === "p" ? nt = Ze : (nt = { type: "element", tagName: "p", properties: {}, children: [] }, Ue.unshift(nt)), nt.children.length > 0 && nt.children.unshift({ type: "text", value: " " }), nt.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: ue.checked, disabled: !0 },
      children: []
    }), Ge.className = ["task-list-item"];
  }
  let Ke = -1;
  for (; ++Ke < Ue.length; ) {
    const Ze = Ue[Ke];
    (He || Ke !== 0 || Ze.type !== "element" || Ze.tagName !== "p") && Xe.push({ type: "text", value: `
` }), Ze.type === "element" && Ze.tagName === "p" && !He ? Xe.push(...Ze.children) : Xe.push(Ze);
  }
  const $e = Ue[Ue.length - 1];
  $e && (He || $e.type !== "element" || $e.tagName !== "p") && Xe.push({ type: "text", value: `
` });
  const Je = { type: "element", tagName: "li", properties: Ge, children: Xe };
  return me.patch(ue, Je), me.applyData(ue, Je);
}
function listLoose(me) {
  let ue = !1;
  if (me.type === "list") {
    ue = me.spread || !1;
    const Qe = me.children;
    let Ue = -1;
    for (; !ue && ++Ue < Qe.length; )
      ue = listItemLoose(Qe[Ue]);
  }
  return ue;
}
function listItemLoose(me) {
  const ue = me.spread;
  return ue ?? me.children.length > 1;
}
function list(me, ue) {
  const Qe = {}, Ue = me.all(ue);
  let He = -1;
  for (typeof ue.start == "number" && ue.start !== 1 && (Qe.start = ue.start); ++He < Ue.length; ) {
    const Xe = Ue[He];
    if (Xe.type === "element" && Xe.tagName === "li" && Xe.properties && Array.isArray(Xe.properties.className) && Xe.properties.className.includes("task-list-item")) {
      Qe.className = ["contains-task-list"];
      break;
    }
  }
  const Ge = {
    type: "element",
    tagName: ue.ordered ? "ol" : "ul",
    properties: Qe,
    children: me.wrap(Ue, !0)
  };
  return me.patch(ue, Ge), me.applyData(ue, Ge);
}
function paragraph(me, ue) {
  const Qe = {
    type: "element",
    tagName: "p",
    properties: {},
    children: me.all(ue)
  };
  return me.patch(ue, Qe), me.applyData(ue, Qe);
}
function root$2(me, ue) {
  const Qe = { type: "root", children: me.wrap(me.all(ue)) };
  return me.patch(ue, Qe), me.applyData(ue, Qe);
}
function strong(me, ue) {
  const Qe = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: me.all(ue)
  };
  return me.patch(ue, Qe), me.applyData(ue, Qe);
}
function table(me, ue) {
  const Qe = me.all(ue), Ue = Qe.shift(), He = [];
  if (Ue) {
    const Xe = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: me.wrap([Ue], !0)
    };
    me.patch(ue.children[0], Xe), He.push(Xe);
  }
  if (Qe.length > 0) {
    const Xe = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: me.wrap(Qe, !0)
    }, Ke = pointStart(ue.children[1]), $e = pointEnd(ue.children[ue.children.length - 1]);
    Ke && $e && (Xe.position = { start: Ke, end: $e }), He.push(Xe);
  }
  const Ge = {
    type: "element",
    tagName: "table",
    properties: {},
    children: me.wrap(He, !0)
  };
  return me.patch(ue, Ge), me.applyData(ue, Ge);
}
function tableRow(me, ue, Qe) {
  const Ue = Qe ? Qe.children : void 0, Ge = (Ue ? Ue.indexOf(ue) : 1) === 0 ? "th" : "td", Xe = Qe && Qe.type === "table" ? Qe.align : void 0, Ke = Xe ? Xe.length : ue.children.length;
  let $e = -1;
  const Je = [];
  for (; ++$e < Ke; ) {
    const nt = ue.children[$e], tt = {}, et = Xe ? Xe[$e] : void 0;
    et && (tt.align = et);
    let rt = { type: "element", tagName: Ge, properties: tt, children: [] };
    nt && (rt.children = me.all(nt), me.patch(nt, rt), rt = me.applyData(nt, rt)), Je.push(rt);
  }
  const Ze = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: me.wrap(Je, !0)
  };
  return me.patch(ue, Ze), me.applyData(ue, Ze);
}
function tableCell(me, ue) {
  const Qe = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: me.all(ue)
  };
  return me.patch(ue, Qe), me.applyData(ue, Qe);
}
const tab = 9, space = 32;
function trimLines(me) {
  const ue = String(me), Qe = /\r?\n|\r/g;
  let Ue = Qe.exec(ue), He = 0;
  const Ge = [];
  for (; Ue; )
    Ge.push(
      trimLine(ue.slice(He, Ue.index), He > 0, !0),
      Ue[0]
    ), He = Ue.index + Ue[0].length, Ue = Qe.exec(ue);
  return Ge.push(trimLine(ue.slice(He), He > 0, !1)), Ge.join("");
}
function trimLine(me, ue, Qe) {
  let Ue = 0, He = me.length;
  if (ue) {
    let Ge = me.codePointAt(Ue);
    for (; Ge === tab || Ge === space; )
      Ue++, Ge = me.codePointAt(Ue);
  }
  if (Qe) {
    let Ge = me.codePointAt(He - 1);
    for (; Ge === tab || Ge === space; )
      He--, Ge = me.codePointAt(He - 1);
  }
  return He > Ue ? me.slice(Ue, He) : "";
}
function text$2(me, ue) {
  const Qe = { type: "text", value: trimLines(String(ue.value)) };
  return me.patch(ue, Qe), me.applyData(ue, Qe);
}
function thematicBreak(me, ue) {
  const Qe = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return me.patch(ue, Qe), me.applyData(ue, Qe);
}
const handlers = {
  blockquote,
  break: hardBreak,
  code,
  delete: strikethrough,
  emphasis,
  footnoteReference,
  heading,
  html,
  imageReference,
  image,
  inlineCode,
  linkReference,
  link,
  listItem,
  list,
  paragraph,
  // @ts-expect-error: root is different, but hard to type.
  root: root$2,
  strong,
  table,
  tableCell,
  tableRow,
  text: text$2,
  thematicBreak,
  toml: ignore,
  yaml: ignore,
  definition: ignore,
  footnoteDefinition: ignore
};
function ignore() {
}
const VOID = -1, PRIMITIVE = 0, ARRAY = 1, OBJECT = 2, DATE = 3, REGEXP = 4, MAP = 5, SET = 6, ERROR = 7, BIGINT = 8, env = typeof self == "object" ? self : globalThis, deserializer = (me, ue) => {
  const Qe = (He, Ge) => (me.set(Ge, He), He), Ue = (He) => {
    if (me.has(He))
      return me.get(He);
    const [Ge, Xe] = ue[He];
    switch (Ge) {
      case PRIMITIVE:
      case VOID:
        return Qe(Xe, He);
      case ARRAY: {
        const Ke = Qe([], He);
        for (const $e of Xe)
          Ke.push(Ue($e));
        return Ke;
      }
      case OBJECT: {
        const Ke = Qe({}, He);
        for (const [$e, Je] of Xe)
          Ke[Ue($e)] = Ue(Je);
        return Ke;
      }
      case DATE:
        return Qe(new Date(Xe), He);
      case REGEXP: {
        const { source: Ke, flags: $e } = Xe;
        return Qe(new RegExp(Ke, $e), He);
      }
      case MAP: {
        const Ke = Qe(/* @__PURE__ */ new Map(), He);
        for (const [$e, Je] of Xe)
          Ke.set(Ue($e), Ue(Je));
        return Ke;
      }
      case SET: {
        const Ke = Qe(/* @__PURE__ */ new Set(), He);
        for (const $e of Xe)
          Ke.add(Ue($e));
        return Ke;
      }
      case ERROR: {
        const { name: Ke, message: $e } = Xe;
        return Qe(new env[Ke]($e), He);
      }
      case BIGINT:
        return Qe(BigInt(Xe), He);
      case "BigInt":
        return Qe(Object(BigInt(Xe)), He);
    }
    return Qe(new env[Ge](Xe), He);
  };
  return Ue;
}, deserialize = (me) => deserializer(/* @__PURE__ */ new Map(), me)(0), EMPTY = "", { toString: toString$1 } = {}, { keys } = Object, typeOf = (me) => {
  const ue = typeof me;
  if (ue !== "object" || !me)
    return [PRIMITIVE, ue];
  const Qe = toString$1.call(me).slice(8, -1);
  switch (Qe) {
    case "Array":
      return [ARRAY, EMPTY];
    case "Object":
      return [OBJECT, EMPTY];
    case "Date":
      return [DATE, EMPTY];
    case "RegExp":
      return [REGEXP, EMPTY];
    case "Map":
      return [MAP, EMPTY];
    case "Set":
      return [SET, EMPTY];
  }
  return Qe.includes("Array") ? [ARRAY, Qe] : Qe.includes("Error") ? [ERROR, Qe] : [OBJECT, Qe];
}, shouldSkip = ([me, ue]) => me === PRIMITIVE && (ue === "function" || ue === "symbol"), serializer = (me, ue, Qe, Ue) => {
  const He = (Xe, Ke) => {
    const $e = Ue.push(Xe) - 1;
    return Qe.set(Ke, $e), $e;
  }, Ge = (Xe) => {
    if (Qe.has(Xe))
      return Qe.get(Xe);
    let [Ke, $e] = typeOf(Xe);
    switch (Ke) {
      case PRIMITIVE: {
        let Ze = Xe;
        switch ($e) {
          case "bigint":
            Ke = BIGINT, Ze = Xe.toString();
            break;
          case "function":
          case "symbol":
            if (me)
              throw new TypeError("unable to serialize " + $e);
            Ze = null;
            break;
          case "undefined":
            return He([VOID], Xe);
        }
        return He([Ke, Ze], Xe);
      }
      case ARRAY: {
        if ($e)
          return He([$e, [...Xe]], Xe);
        const Ze = [], nt = He([Ke, Ze], Xe);
        for (const tt of Xe)
          Ze.push(Ge(tt));
        return nt;
      }
      case OBJECT: {
        if ($e)
          switch ($e) {
            case "BigInt":
              return He([$e, Xe.toString()], Xe);
            case "Boolean":
            case "Number":
            case "String":
              return He([$e, Xe.valueOf()], Xe);
          }
        if (ue && "toJSON" in Xe)
          return Ge(Xe.toJSON());
        const Ze = [], nt = He([Ke, Ze], Xe);
        for (const tt of keys(Xe))
          (me || !shouldSkip(typeOf(Xe[tt]))) && Ze.push([Ge(tt), Ge(Xe[tt])]);
        return nt;
      }
      case DATE:
        return He([Ke, Xe.toISOString()], Xe);
      case REGEXP: {
        const { source: Ze, flags: nt } = Xe;
        return He([Ke, { source: Ze, flags: nt }], Xe);
      }
      case MAP: {
        const Ze = [], nt = He([Ke, Ze], Xe);
        for (const [tt, et] of Xe)
          (me || !(shouldSkip(typeOf(tt)) || shouldSkip(typeOf(et)))) && Ze.push([Ge(tt), Ge(et)]);
        return nt;
      }
      case SET: {
        const Ze = [], nt = He([Ke, Ze], Xe);
        for (const tt of Xe)
          (me || !shouldSkip(typeOf(tt))) && Ze.push(Ge(tt));
        return nt;
      }
    }
    const { message: Je } = Xe;
    return He([Ke, { name: $e, message: Je }], Xe);
  };
  return Ge;
}, serialize = (me, { json: ue, lossy: Qe } = {}) => {
  const Ue = [];
  return serializer(!(ue || Qe), !!ue, /* @__PURE__ */ new Map(), Ue)(me), Ue;
}, structuredClone$1 = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (me, ue) => ue && ("json" in ue || "lossy" in ue) ? deserialize(serialize(me, ue)) : structuredClone(me)
) : (me, ue) => deserialize(serialize(me, ue));
function defaultFootnoteBackContent(me, ue) {
  const Qe = [{ type: "text", value: "↩" }];
  return ue > 1 && Qe.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(ue) }]
  }), Qe;
}
function defaultFootnoteBackLabel(me, ue) {
  return "Back to reference " + (me + 1) + (ue > 1 ? "-" + ue : "");
}
function footer(me) {
  const ue = typeof me.options.clobberPrefix == "string" ? me.options.clobberPrefix : "user-content-", Qe = me.options.footnoteBackContent || defaultFootnoteBackContent, Ue = me.options.footnoteBackLabel || defaultFootnoteBackLabel, He = me.options.footnoteLabel || "Footnotes", Ge = me.options.footnoteLabelTagName || "h2", Xe = me.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, Ke = [];
  let $e = -1;
  for (; ++$e < me.footnoteOrder.length; ) {
    const Je = me.footnoteById.get(me.footnoteOrder[$e]);
    if (!Je)
      continue;
    const Ze = me.all(Je), nt = String(Je.identifier).toUpperCase(), tt = normalizeUri(nt.toLowerCase());
    let et = 0;
    const rt = [], it = me.footnoteCounts.get(nt);
    for (; it !== void 0 && ++et <= it; ) {
      rt.length > 0 && rt.push({ type: "text", value: " " });
      let st = typeof Qe == "string" ? Qe : Qe($e, et);
      typeof st == "string" && (st = { type: "text", value: st }), rt.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + ue + "fnref-" + tt + (et > 1 ? "-" + et : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof Ue == "string" ? Ue : Ue($e, et),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(st) ? st : [st]
      });
    }
    const ot = Ze[Ze.length - 1];
    if (ot && ot.type === "element" && ot.tagName === "p") {
      const st = ot.children[ot.children.length - 1];
      st && st.type === "text" ? st.value += " " : ot.children.push({ type: "text", value: " " }), ot.children.push(...rt);
    } else
      Ze.push(...rt);
    const at = {
      type: "element",
      tagName: "li",
      properties: { id: ue + "fn-" + tt },
      children: me.wrap(Ze, !0)
    };
    me.patch(Je, at), Ke.push(at);
  }
  if (Ke.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: Ge,
          properties: {
            ...structuredClone$1(Xe),
            id: "footnote-label"
          },
          children: [{ type: "text", value: He }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: me.wrap(Ke, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const convert = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(me) {
    if (me == null)
      return ok;
    if (typeof me == "function")
      return castFactory(me);
    if (typeof me == "object")
      return Array.isArray(me) ? anyFactory(me) : propsFactory(me);
    if (typeof me == "string")
      return typeFactory(me);
    throw new Error("Expected function, string, or object as test");
  }
);
function anyFactory(me) {
  const ue = [];
  let Qe = -1;
  for (; ++Qe < me.length; )
    ue[Qe] = convert(me[Qe]);
  return castFactory(Ue);
  function Ue(...He) {
    let Ge = -1;
    for (; ++Ge < ue.length; )
      if (ue[Ge].apply(this, He)) return !0;
    return !1;
  }
}
function propsFactory(me) {
  const ue = (
    /** @type {Record<string, unknown>} */
    me
  );
  return castFactory(Qe);
  function Qe(Ue) {
    const He = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      Ue
    );
    let Ge;
    for (Ge in me)
      if (He[Ge] !== ue[Ge]) return !1;
    return !0;
  }
}
function typeFactory(me) {
  return castFactory(ue);
  function ue(Qe) {
    return Qe && Qe.type === me;
  }
}
function castFactory(me) {
  return ue;
  function ue(Qe, Ue, He) {
    return !!(looksLikeANode(Qe) && me.call(
      this,
      Qe,
      typeof Ue == "number" ? Ue : void 0,
      He || void 0
    ));
  }
}
function ok() {
  return !0;
}
function looksLikeANode(me) {
  return me !== null && typeof me == "object" && "type" in me;
}
function color(me) {
  return me;
}
const empty = [], CONTINUE = !0, EXIT = !1, SKIP = "skip";
function visitParents(me, ue, Qe, Ue) {
  let He;
  typeof ue == "function" && typeof Qe != "function" ? (Ue = Qe, Qe = ue) : He = ue;
  const Ge = convert(He), Xe = Ue ? -1 : 1;
  Ke(me, void 0, [])();
  function Ke($e, Je, Ze) {
    const nt = (
      /** @type {Record<string, unknown>} */
      $e && typeof $e == "object" ? $e : {}
    );
    if (typeof nt.type == "string") {
      const et = (
        // `hast`
        typeof nt.tagName == "string" ? nt.tagName : (
          // `xast`
          typeof nt.name == "string" ? nt.name : void 0
        )
      );
      Object.defineProperty(tt, "name", {
        value: "node (" + ($e.type + (et ? "<" + et + ">" : "")) + ")"
      });
    }
    return tt;
    function tt() {
      let et = empty, rt, it, ot;
      if ((!ue || Ge($e, Je, Ze[Ze.length - 1] || void 0)) && (et = toResult(Qe($e, Ze)), et[0] === EXIT))
        return et;
      if ("children" in $e && $e.children) {
        const at = (
          /** @type {UnistParent} */
          $e
        );
        if (at.children && et[0] !== SKIP)
          for (it = (Ue ? at.children.length : -1) + Xe, ot = Ze.concat(at); it > -1 && it < at.children.length; ) {
            const st = at.children[it];
            if (rt = Ke(st, it, ot)(), rt[0] === EXIT)
              return rt;
            it = typeof rt[1] == "number" ? rt[1] : it + Xe;
          }
      }
      return et;
    }
  }
}
function toResult(me) {
  return Array.isArray(me) ? me : typeof me == "number" ? [CONTINUE, me] : me == null ? empty : [me];
}
function visit(me, ue, Qe, Ue) {
  let He, Ge, Xe;
  typeof ue == "function" && typeof Qe != "function" ? (Ge = void 0, Xe = ue, He = Qe) : (Ge = ue, Xe = Qe, He = Ue), visitParents(me, Ge, Ke, He);
  function Ke($e, Je) {
    const Ze = Je[Je.length - 1], nt = Ze ? Ze.children.indexOf($e) : void 0;
    return Xe($e, nt, Ze);
  }
}
const own$5 = {}.hasOwnProperty, emptyOptions$1 = {};
function createState(me, ue) {
  const Qe = ue || emptyOptions$1, Ue = /* @__PURE__ */ new Map(), He = /* @__PURE__ */ new Map(), Ge = /* @__PURE__ */ new Map(), Xe = { ...handlers, ...Qe.handlers }, Ke = {
    all: Je,
    applyData,
    definitionById: Ue,
    footnoteById: He,
    footnoteCounts: Ge,
    footnoteOrder: [],
    handlers: Xe,
    one: $e,
    options: Qe,
    patch: patch$2,
    wrap: wrap$1
  };
  return visit(me, function(Ze) {
    if (Ze.type === "definition" || Ze.type === "footnoteDefinition") {
      const nt = Ze.type === "definition" ? Ue : He, tt = String(Ze.identifier).toUpperCase();
      nt.has(tt) || nt.set(tt, Ze);
    }
  }), Ke;
  function $e(Ze, nt) {
    const tt = Ze.type, et = Ke.handlers[tt];
    if (own$5.call(Ke.handlers, tt) && et)
      return et(Ke, Ze, nt);
    if (Ke.options.passThrough && Ke.options.passThrough.includes(tt)) {
      if ("children" in Ze) {
        const { children: it, ...ot } = Ze, at = structuredClone$1(ot);
        return at.children = Ke.all(Ze), at;
      }
      return structuredClone$1(Ze);
    }
    return (Ke.options.unknownHandler || defaultUnknownHandler)(Ke, Ze, nt);
  }
  function Je(Ze) {
    const nt = [];
    if ("children" in Ze) {
      const tt = Ze.children;
      let et = -1;
      for (; ++et < tt.length; ) {
        const rt = Ke.one(tt[et], Ze);
        if (rt) {
          if (et && tt[et - 1].type === "break" && (!Array.isArray(rt) && rt.type === "text" && (rt.value = trimMarkdownSpaceStart(rt.value)), !Array.isArray(rt) && rt.type === "element")) {
            const it = rt.children[0];
            it && it.type === "text" && (it.value = trimMarkdownSpaceStart(it.value));
          }
          Array.isArray(rt) ? nt.push(...rt) : nt.push(rt);
        }
      }
    }
    return nt;
  }
}
function patch$2(me, ue) {
  me.position && (ue.position = position$2(me));
}
function applyData(me, ue) {
  let Qe = ue;
  if (me && me.data) {
    const Ue = me.data.hName, He = me.data.hChildren, Ge = me.data.hProperties;
    if (typeof Ue == "string")
      if (Qe.type === "element")
        Qe.tagName = Ue;
      else {
        const Xe = "children" in Qe ? Qe.children : [Qe];
        Qe = { type: "element", tagName: Ue, properties: {}, children: Xe };
      }
    Qe.type === "element" && Ge && Object.assign(Qe.properties, structuredClone$1(Ge)), "children" in Qe && Qe.children && He !== null && He !== void 0 && (Qe.children = He);
  }
  return Qe;
}
function defaultUnknownHandler(me, ue) {
  const Qe = ue.data || {}, Ue = "value" in ue && !(own$5.call(Qe, "hProperties") || own$5.call(Qe, "hChildren")) ? { type: "text", value: ue.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: me.all(ue)
  };
  return me.patch(ue, Ue), me.applyData(ue, Ue);
}
function wrap$1(me, ue) {
  const Qe = [];
  let Ue = -1;
  for (ue && Qe.push({ type: "text", value: `
` }); ++Ue < me.length; )
    Ue && Qe.push({ type: "text", value: `
` }), Qe.push(me[Ue]);
  return ue && me.length > 0 && Qe.push({ type: "text", value: `
` }), Qe;
}
function trimMarkdownSpaceStart(me) {
  let ue = 0, Qe = me.charCodeAt(ue);
  for (; Qe === 9 || Qe === 32; )
    ue++, Qe = me.charCodeAt(ue);
  return me.slice(ue);
}
function toHast(me, ue) {
  const Qe = createState(me, ue), Ue = Qe.one(me, void 0), He = footer(Qe), Ge = Array.isArray(Ue) ? { type: "root", children: Ue } : Ue || { type: "root", children: [] };
  return He && Ge.children.push({ type: "text", value: `
` }, He), Ge;
}
function remarkRehype(me, ue) {
  return me && "run" in me ? async function(Qe, Ue) {
    const He = (
      /** @type {HastRoot} */
      toHast(Qe, { file: Ue, ...ue })
    );
    await me.run(He, Ue);
  } : function(Qe, Ue) {
    return (
      /** @type {HastRoot} */
      toHast(Qe, { file: Ue, ...ue || me })
    );
  };
}
function bail(me) {
  if (me)
    throw me;
}
var hasOwn = Object.prototype.hasOwnProperty, toStr = Object.prototype.toString, defineProperty = Object.defineProperty, gOPD = Object.getOwnPropertyDescriptor, isArray$1 = function(ue) {
  return typeof Array.isArray == "function" ? Array.isArray(ue) : toStr.call(ue) === "[object Array]";
}, isPlainObject$2 = function(ue) {
  if (!ue || toStr.call(ue) !== "[object Object]")
    return !1;
  var Qe = hasOwn.call(ue, "constructor"), Ue = ue.constructor && ue.constructor.prototype && hasOwn.call(ue.constructor.prototype, "isPrototypeOf");
  if (ue.constructor && !Qe && !Ue)
    return !1;
  var He;
  for (He in ue)
    ;
  return typeof He > "u" || hasOwn.call(ue, He);
}, setProperty = function(ue, Qe) {
  defineProperty && Qe.name === "__proto__" ? defineProperty(ue, Qe.name, {
    enumerable: !0,
    configurable: !0,
    value: Qe.newValue,
    writable: !0
  }) : ue[Qe.name] = Qe.newValue;
}, getProperty = function(ue, Qe) {
  if (Qe === "__proto__")
    if (hasOwn.call(ue, Qe)) {
      if (gOPD)
        return gOPD(ue, Qe).value;
    } else return;
  return ue[Qe];
}, extend$4 = function me() {
  var ue, Qe, Ue, He, Ge, Xe, Ke = arguments[0], $e = 1, Je = arguments.length, Ze = !1;
  for (typeof Ke == "boolean" && (Ze = Ke, Ke = arguments[1] || {}, $e = 2), (Ke == null || typeof Ke != "object" && typeof Ke != "function") && (Ke = {}); $e < Je; ++$e)
    if (ue = arguments[$e], ue != null)
      for (Qe in ue)
        Ue = getProperty(Ke, Qe), He = getProperty(ue, Qe), Ke !== He && (Ze && He && (isPlainObject$2(He) || (Ge = isArray$1(He))) ? (Ge ? (Ge = !1, Xe = Ue && isArray$1(Ue) ? Ue : []) : Xe = Ue && isPlainObject$2(Ue) ? Ue : {}, setProperty(Ke, { name: Qe, newValue: me(Ze, Xe, He) })) : typeof He < "u" && setProperty(Ke, { name: Qe, newValue: He }));
  return Ke;
};
const extend$5 = /* @__PURE__ */ getDefaultExportFromCjs(extend$4);
function isPlainObject$1(me) {
  if (typeof me != "object" || me === null)
    return !1;
  const ue = Object.getPrototypeOf(me);
  return (ue === null || ue === Object.prototype || Object.getPrototypeOf(ue) === null) && !(Symbol.toStringTag in me) && !(Symbol.iterator in me);
}
function trough() {
  const me = [], ue = { run: Qe, use: Ue };
  return ue;
  function Qe(...He) {
    let Ge = -1;
    const Xe = He.pop();
    if (typeof Xe != "function")
      throw new TypeError("Expected function as last argument, not " + Xe);
    Ke(null, ...He);
    function Ke($e, ...Je) {
      const Ze = me[++Ge];
      let nt = -1;
      if ($e) {
        Xe($e);
        return;
      }
      for (; ++nt < He.length; )
        (Je[nt] === null || Je[nt] === void 0) && (Je[nt] = He[nt]);
      He = Je, Ze ? wrap(Ze, Ke)(...Je) : Xe(null, ...Je);
    }
  }
  function Ue(He) {
    if (typeof He != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + He
      );
    return me.push(He), ue;
  }
}
function wrap(me, ue) {
  let Qe;
  return Ue;
  function Ue(...Xe) {
    const Ke = me.length > Xe.length;
    let $e;
    Ke && Xe.push(He);
    try {
      $e = me.apply(this, Xe);
    } catch (Je) {
      const Ze = (
        /** @type {Error} */
        Je
      );
      if (Ke && Qe)
        throw Ze;
      return He(Ze);
    }
    Ke || ($e && $e.then && typeof $e.then == "function" ? $e.then(Ge, He) : $e instanceof Error ? He($e) : Ge($e));
  }
  function He(Xe, ...Ke) {
    Qe || (Qe = !0, ue(Xe, ...Ke));
  }
  function Ge(Xe) {
    He(null, Xe);
  }
}
const path = { basename, dirname, extname, join, sep: "/" };
function basename(me, ue) {
  if (ue !== void 0 && typeof ue != "string")
    throw new TypeError('"ext" argument must be a string');
  assertPath$1(me);
  let Qe = 0, Ue = -1, He = me.length, Ge;
  if (ue === void 0 || ue.length === 0 || ue.length > me.length) {
    for (; He--; )
      if (me.codePointAt(He) === 47) {
        if (Ge) {
          Qe = He + 1;
          break;
        }
      } else Ue < 0 && (Ge = !0, Ue = He + 1);
    return Ue < 0 ? "" : me.slice(Qe, Ue);
  }
  if (ue === me)
    return "";
  let Xe = -1, Ke = ue.length - 1;
  for (; He--; )
    if (me.codePointAt(He) === 47) {
      if (Ge) {
        Qe = He + 1;
        break;
      }
    } else
      Xe < 0 && (Ge = !0, Xe = He + 1), Ke > -1 && (me.codePointAt(He) === ue.codePointAt(Ke--) ? Ke < 0 && (Ue = He) : (Ke = -1, Ue = Xe));
  return Qe === Ue ? Ue = Xe : Ue < 0 && (Ue = me.length), me.slice(Qe, Ue);
}
function dirname(me) {
  if (assertPath$1(me), me.length === 0)
    return ".";
  let ue = -1, Qe = me.length, Ue;
  for (; --Qe; )
    if (me.codePointAt(Qe) === 47) {
      if (Ue) {
        ue = Qe;
        break;
      }
    } else Ue || (Ue = !0);
  return ue < 0 ? me.codePointAt(0) === 47 ? "/" : "." : ue === 1 && me.codePointAt(0) === 47 ? "//" : me.slice(0, ue);
}
function extname(me) {
  assertPath$1(me);
  let ue = me.length, Qe = -1, Ue = 0, He = -1, Ge = 0, Xe;
  for (; ue--; ) {
    const Ke = me.codePointAt(ue);
    if (Ke === 47) {
      if (Xe) {
        Ue = ue + 1;
        break;
      }
      continue;
    }
    Qe < 0 && (Xe = !0, Qe = ue + 1), Ke === 46 ? He < 0 ? He = ue : Ge !== 1 && (Ge = 1) : He > -1 && (Ge = -1);
  }
  return He < 0 || Qe < 0 || // We saw a non-dot character immediately before the dot.
  Ge === 0 || // The (right-most) trimmed path component is exactly `..`.
  Ge === 1 && He === Qe - 1 && He === Ue + 1 ? "" : me.slice(He, Qe);
}
function join(...me) {
  let ue = -1, Qe;
  for (; ++ue < me.length; )
    assertPath$1(me[ue]), me[ue] && (Qe = Qe === void 0 ? me[ue] : Qe + "/" + me[ue]);
  return Qe === void 0 ? "." : normalize(Qe);
}
function normalize(me) {
  assertPath$1(me);
  const ue = me.codePointAt(0) === 47;
  let Qe = normalizeString(me, !ue);
  return Qe.length === 0 && !ue && (Qe = "."), Qe.length > 0 && me.codePointAt(me.length - 1) === 47 && (Qe += "/"), ue ? "/" + Qe : Qe;
}
function normalizeString(me, ue) {
  let Qe = "", Ue = 0, He = -1, Ge = 0, Xe = -1, Ke, $e;
  for (; ++Xe <= me.length; ) {
    if (Xe < me.length)
      Ke = me.codePointAt(Xe);
    else {
      if (Ke === 47)
        break;
      Ke = 47;
    }
    if (Ke === 47) {
      if (!(He === Xe - 1 || Ge === 1)) if (He !== Xe - 1 && Ge === 2) {
        if (Qe.length < 2 || Ue !== 2 || Qe.codePointAt(Qe.length - 1) !== 46 || Qe.codePointAt(Qe.length - 2) !== 46) {
          if (Qe.length > 2) {
            if ($e = Qe.lastIndexOf("/"), $e !== Qe.length - 1) {
              $e < 0 ? (Qe = "", Ue = 0) : (Qe = Qe.slice(0, $e), Ue = Qe.length - 1 - Qe.lastIndexOf("/")), He = Xe, Ge = 0;
              continue;
            }
          } else if (Qe.length > 0) {
            Qe = "", Ue = 0, He = Xe, Ge = 0;
            continue;
          }
        }
        ue && (Qe = Qe.length > 0 ? Qe + "/.." : "..", Ue = 2);
      } else
        Qe.length > 0 ? Qe += "/" + me.slice(He + 1, Xe) : Qe = me.slice(He + 1, Xe), Ue = Xe - He - 1;
      He = Xe, Ge = 0;
    } else Ke === 46 && Ge > -1 ? Ge++ : Ge = -1;
  }
  return Qe;
}
function assertPath$1(me) {
  if (typeof me != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(me)
    );
}
const proc = { cwd };
function cwd() {
  return "/";
}
function isUrl(me) {
  return !!(me !== null && typeof me == "object" && "href" in me && me.href && "protocol" in me && me.protocol && // @ts-expect-error: indexing is fine.
  me.auth === void 0);
}
function urlToPath(me) {
  if (typeof me == "string")
    me = new URL(me);
  else if (!isUrl(me)) {
    const ue = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + me + "`"
    );
    throw ue.code = "ERR_INVALID_ARG_TYPE", ue;
  }
  if (me.protocol !== "file:") {
    const ue = new TypeError("The URL must be of scheme file");
    throw ue.code = "ERR_INVALID_URL_SCHEME", ue;
  }
  return getPathFromURLPosix(me);
}
function getPathFromURLPosix(me) {
  if (me.hostname !== "") {
    const Ue = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw Ue.code = "ERR_INVALID_FILE_URL_HOST", Ue;
  }
  const ue = me.pathname;
  let Qe = -1;
  for (; ++Qe < ue.length; )
    if (ue.codePointAt(Qe) === 37 && ue.codePointAt(Qe + 1) === 50) {
      const Ue = ue.codePointAt(Qe + 2);
      if (Ue === 70 || Ue === 102) {
        const He = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw He.code = "ERR_INVALID_FILE_URL_PATH", He;
      }
    }
  return decodeURIComponent(ue);
}
const order = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class VFile {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(ue) {
    let Qe;
    ue ? isUrl(ue) ? Qe = { path: ue } : typeof ue == "string" || isUint8Array$1(ue) ? Qe = { value: ue } : Qe = ue : Qe = {}, this.cwd = proc.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let Ue = -1;
    for (; ++Ue < order.length; ) {
      const Ge = order[Ue];
      Ge in Qe && Qe[Ge] !== void 0 && Qe[Ge] !== null && (this[Ge] = Ge === "history" ? [...Qe[Ge]] : Qe[Ge]);
    }
    let He;
    for (He in Qe)
      order.includes(He) || (this[He] = Qe[He]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? path.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(ue) {
    assertNonEmpty(ue, "basename"), assertPart(ue, "basename"), this.path = path.join(this.dirname || "", ue);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? path.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(ue) {
    assertPath(this.basename, "dirname"), this.path = path.join(ue || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? path.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(ue) {
    if (assertPart(ue, "extname"), assertPath(this.dirname, "extname"), ue) {
      if (ue.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (ue.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = path.join(this.dirname, this.stem + (ue || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(ue) {
    isUrl(ue) && (ue = urlToPath(ue)), assertNonEmpty(ue, "path"), this.path !== ue && this.history.push(ue);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? path.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(ue) {
    assertNonEmpty(ue, "stem"), assertPart(ue, "stem"), this.path = path.join(this.dirname || "", ue + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(ue, Qe, Ue) {
    const He = this.message(ue, Qe, Ue);
    throw He.fatal = !0, He;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(ue, Qe, Ue) {
    const He = this.message(ue, Qe, Ue);
    return He.fatal = void 0, He;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(ue, Qe, Ue) {
    const He = new VFileMessage(
      // @ts-expect-error: the overloads are fine.
      ue,
      Qe,
      Ue
    );
    return this.path && (He.name = this.path + ":" + He.name, He.file = this.path), He.fatal = !1, this.messages.push(He), He;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(ue) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(ue || void 0).decode(this.value);
  }
}
function assertPart(me, ue) {
  if (me && me.includes(path.sep))
    throw new Error(
      "`" + ue + "` cannot be a path: did not expect `" + path.sep + "`"
    );
}
function assertNonEmpty(me, ue) {
  if (!me)
    throw new Error("`" + ue + "` cannot be empty");
}
function assertPath(me, ue) {
  if (!me)
    throw new Error("Setting `" + ue + "` requires `path` to be set too");
}
function isUint8Array$1(me) {
  return !!(me && typeof me == "object" && "byteLength" in me && "byteOffset" in me);
}
const CallableInstance = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(me) {
    const Ue = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), He = Ue[me], Ge = function() {
      return He.apply(Ge, arguments);
    };
    Object.setPrototypeOf(Ge, Ue);
    const Xe = Object.getOwnPropertyNames(He);
    for (const Ke of Xe) {
      const $e = Object.getOwnPropertyDescriptor(He, Ke);
      $e && Object.defineProperty(Ge, Ke, $e);
    }
    return Ge;
  }
), own$4 = {}.hasOwnProperty;
class Processor extends CallableInstance {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = trough();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@link Processor `Processor`}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const ue = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Processor()
    );
    let Qe = -1;
    for (; ++Qe < this.attachers.length; ) {
      const Ue = this.attachers[Qe];
      ue.use(...Ue);
    }
    return ue.data(extend$5(!0, {}, this.namespace)), ue;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > 👉 **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > 👉 **Note**: to register custom data in TypeScript, augment the
   * > {@link Data `Data`} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(ue, Qe) {
    return typeof ue == "string" ? arguments.length === 2 ? (assertUnfrozen("data", this.frozen), this.namespace[ue] = Qe, this) : own$4.call(this.namespace, ue) && this.namespace[ue] || void 0 : ue ? (assertUnfrozen("data", this.frozen), this.namespace = ue, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const ue = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [Qe, ...Ue] = this.attachers[this.freezeIndex];
      if (Ue[0] === !1)
        continue;
      Ue[0] === !0 && (Ue[0] = void 0);
      const He = Qe.call(ue, ...Ue);
      typeof He == "function" && this.transformers.use(He);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > 👉 **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(ue) {
    this.freeze();
    const Qe = vfile(ue), Ue = this.parser || this.Parser;
    return assertParser("parse", Ue), Ue(String(Qe), Qe);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > 👉 **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(ue, Qe) {
    const Ue = this;
    return this.freeze(), assertParser("process", this.parser || this.Parser), assertCompiler("process", this.compiler || this.Compiler), Qe ? He(void 0, Qe) : new Promise(He);
    function He(Ge, Xe) {
      const Ke = vfile(ue), $e = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        Ue.parse(Ke)
      );
      Ue.run($e, Ke, function(Ze, nt, tt) {
        if (Ze || !nt || !tt)
          return Je(Ze);
        const et = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          nt
        ), rt = Ue.stringify(et, tt);
        looksLikeAValue(rt) ? tt.value = rt : tt.result = rt, Je(
          Ze,
          /** @type {VFileWithOutput<CompileResult>} */
          tt
        );
      });
      function Je(Ze, nt) {
        Ze || !nt ? Xe(Ze) : Ge ? Ge(nt) : Qe(void 0, nt);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > 👉 **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(ue) {
    let Qe = !1, Ue;
    return this.freeze(), assertParser("processSync", this.parser || this.Parser), assertCompiler("processSync", this.compiler || this.Compiler), this.process(ue, He), assertDone("processSync", "process", Qe), Ue;
    function He(Ge, Xe) {
      Qe = !0, bail(Ge), Ue = Xe;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > 👉 **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(ue, Qe, Ue) {
    assertNode(ue), this.freeze();
    const He = this.transformers;
    return !Ue && typeof Qe == "function" && (Ue = Qe, Qe = void 0), Ue ? Ge(void 0, Ue) : new Promise(Ge);
    function Ge(Xe, Ke) {
      const $e = vfile(Qe);
      He.run(ue, $e, Je);
      function Je(Ze, nt, tt) {
        const et = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          nt || ue
        );
        Ze ? Ke(Ze) : Xe ? Xe(et) : Ue(void 0, et, tt);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > 👉 **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(ue, Qe) {
    let Ue = !1, He;
    return this.run(ue, Qe, Ge), assertDone("runSync", "run", Ue), He;
    function Ge(Xe, Ke) {
      bail(Xe), He = Ke, Ue = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > 👉 **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(ue, Qe) {
    this.freeze();
    const Ue = vfile(Qe), He = this.compiler || this.Compiler;
    return assertCompiler("stringify", He), assertNode(ue), He(ue, Ue);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > 👉 **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(ue, ...Qe) {
    const Ue = this.attachers, He = this.namespace;
    if (assertUnfrozen("use", this.frozen), ue != null) if (typeof ue == "function")
      $e(ue, Qe);
    else if (typeof ue == "object")
      Array.isArray(ue) ? Ke(ue) : Xe(ue);
    else
      throw new TypeError("Expected usable value, not `" + ue + "`");
    return this;
    function Ge(Je) {
      if (typeof Je == "function")
        $e(Je, []);
      else if (typeof Je == "object")
        if (Array.isArray(Je)) {
          const [Ze, ...nt] = (
            /** @type {PluginTuple<Array<unknown>>} */
            Je
          );
          $e(Ze, nt);
        } else
          Xe(Je);
      else
        throw new TypeError("Expected usable value, not `" + Je + "`");
    }
    function Xe(Je) {
      if (!("plugins" in Je) && !("settings" in Je))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      Ke(Je.plugins), Je.settings && (He.settings = extend$5(!0, He.settings, Je.settings));
    }
    function Ke(Je) {
      let Ze = -1;
      if (Je != null) if (Array.isArray(Je))
        for (; ++Ze < Je.length; ) {
          const nt = Je[Ze];
          Ge(nt);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + Je + "`");
    }
    function $e(Je, Ze) {
      let nt = -1, tt = -1;
      for (; ++nt < Ue.length; )
        if (Ue[nt][0] === Je) {
          tt = nt;
          break;
        }
      if (tt === -1)
        Ue.push([Je, ...Ze]);
      else if (Ze.length > 0) {
        let [et, ...rt] = Ze;
        const it = Ue[tt][1];
        isPlainObject$1(it) && isPlainObject$1(et) && (et = extend$5(!0, it, et)), Ue[tt] = [Je, et, ...rt];
      }
    }
  }
}
const unified = new Processor().freeze();
function assertParser(me, ue) {
  if (typeof ue != "function")
    throw new TypeError("Cannot `" + me + "` without `parser`");
}
function assertCompiler(me, ue) {
  if (typeof ue != "function")
    throw new TypeError("Cannot `" + me + "` without `compiler`");
}
function assertUnfrozen(me, ue) {
  if (ue)
    throw new Error(
      "Cannot call `" + me + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function assertNode(me) {
  if (!isPlainObject$1(me) || typeof me.type != "string")
    throw new TypeError("Expected node, got `" + me + "`");
}
function assertDone(me, ue, Qe) {
  if (!Qe)
    throw new Error(
      "`" + me + "` finished async. Use `" + ue + "` instead"
    );
}
function vfile(me) {
  return looksLikeAVFile(me) ? me : new VFile(me);
}
function looksLikeAVFile(me) {
  return !!(me && typeof me == "object" && "message" in me && "messages" in me);
}
function looksLikeAValue(me) {
  return typeof me == "string" || isUint8Array(me);
}
function isUint8Array(me) {
  return !!(me && typeof me == "object" && "byteLength" in me && "byteOffset" in me);
}
const changelog = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", emptyPlugins = [], emptyRemarkRehypeOptions = { allowDangerousHtml: !0 }, safeProtocol = /^(https?|ircs?|mailto|xmpp)$/i, deprecations = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function Markdown(me) {
  const ue = me.allowedElements, Qe = me.allowElement, Ue = me.children || "", He = me.className, Ge = me.components, Xe = me.disallowedElements, Ke = me.rehypePlugins || emptyPlugins, $e = me.remarkPlugins || emptyPlugins, Je = me.remarkRehypeOptions ? { ...me.remarkRehypeOptions, ...emptyRemarkRehypeOptions } : emptyRemarkRehypeOptions, Ze = me.skipHtml, nt = me.unwrapDisallowed, tt = me.urlTransform || defaultUrlTransform, et = unified().use(remarkParse).use($e).use(remarkRehype, Je).use(Ke), rt = new VFile();
  typeof Ue == "string" && (rt.value = Ue);
  for (const st of deprecations)
    Object.hasOwn(me, st.from) && ("" + st.from + (st.to ? "use `" + st.to + "` instead" : "remove it") + changelog + st.id, void 0);
  const it = et.parse(rt);
  let ot = et.runSync(it, rt);
  return He && (ot = {
    type: "element",
    tagName: "div",
    properties: { className: He },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      ot.type === "root" ? ot.children : [ot]
    )
  }), visit(ot, at), toJsxRuntime(ot, {
    Fragment: jsxRuntimeExports.Fragment,
    components: Ge,
    ignoreInvalidStyle: !0,
    jsx: jsxRuntimeExports.jsx,
    jsxs: jsxRuntimeExports.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function at(st, ut, lt) {
    if (st.type === "raw" && lt && typeof ut == "number")
      return Ze ? lt.children.splice(ut, 1) : lt.children[ut] = { type: "text", value: st.value }, ut;
    if (st.type === "element") {
      let dt;
      for (dt in urlAttributes)
        if (Object.hasOwn(urlAttributes, dt) && Object.hasOwn(st.properties, dt)) {
          const At = st.properties[dt], pt = urlAttributes[dt];
          (pt === null || pt.includes(st.tagName)) && (st.properties[dt] = tt(String(At || ""), dt, st));
        }
    }
    if (st.type === "element") {
      let dt = ue ? !ue.includes(st.tagName) : Xe ? Xe.includes(st.tagName) : !1;
      if (!dt && Qe && typeof ut == "number" && (dt = !Qe(st, ut, lt)), dt && lt && typeof ut == "number")
        return nt && st.children ? lt.children.splice(ut, 1, ...st.children) : lt.children.splice(ut, 1), ut;
    }
  }
}
function defaultUrlTransform(me) {
  const ue = me.indexOf(":"), Qe = me.indexOf("?"), Ue = me.indexOf("#"), He = me.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    ue < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    He > -1 && ue > He || Qe > -1 && ue > Qe || Ue > -1 && ue > Ue || // It is a protocol, it should be allowed.
    safeProtocol.test(me.slice(0, ue)) ? me : ""
  );
}
const search$1 = /[#.]/g;
function parseSelector(me, ue) {
  const Qe = me || "", Ue = {};
  let He = 0, Ge, Xe;
  for (; He < Qe.length; ) {
    search$1.lastIndex = He;
    const Ke = search$1.exec(Qe), $e = Qe.slice(He, Ke ? Ke.index : Qe.length);
    $e && (Ge ? Ge === "#" ? Ue.id = $e : Array.isArray(Ue.className) ? Ue.className.push($e) : Ue.className = [$e] : Xe = $e, He += $e.length), Ke && (Ge = Ke[0], He++);
  }
  return {
    type: "element",
    // @ts-expect-error: tag name is parsed.
    tagName: Xe || ue || "div",
    properties: Ue,
    children: []
  };
}
const buttonTypes = /* @__PURE__ */ new Set(["button", "menu", "reset", "submit"]), own$3 = {}.hasOwnProperty;
function createH(me, ue, Qe) {
  const Ue = Qe && createAdjustMap(Qe);
  function He(Ge, Xe, ...Ke) {
    let $e = -1, Je;
    if (Ge == null) {
      Je = { type: "root", children: [] };
      const Ze = (
        /** @type {Child} */
        Xe
      );
      Ke.unshift(Ze);
    } else if (Je = parseSelector(Ge, ue), Je.tagName = Je.tagName.toLowerCase(), Ue && own$3.call(Ue, Je.tagName) && (Je.tagName = Ue[Je.tagName]), isProperties(Xe, Je.tagName)) {
      let Ze;
      for (Ze in Xe)
        own$3.call(Xe, Ze) && addProperty(me, Je.properties, Ze, Xe[Ze]);
    } else
      Ke.unshift(Xe);
    for (; ++$e < Ke.length; )
      addChild(Je.children, Ke[$e]);
    return Je.type === "element" && Je.tagName === "template" && (Je.content = { type: "root", children: Je.children }, Je.children = []), Je;
  }
  return He;
}
function isProperties(me, ue) {
  return me == null || typeof me != "object" || Array.isArray(me) ? !1 : ue === "input" || !me.type || typeof me.type != "string" ? !0 : "children" in me && Array.isArray(me.children) ? !1 : ue === "button" ? buttonTypes.has(me.type.toLowerCase()) : !("value" in me);
}
function addProperty(me, ue, Qe, Ue) {
  const He = find$1(me, Qe);
  let Ge = -1, Xe;
  if (Ue != null) {
    if (typeof Ue == "number") {
      if (Number.isNaN(Ue)) return;
      Xe = Ue;
    } else typeof Ue == "boolean" ? Xe = Ue : typeof Ue == "string" ? He.spaceSeparated ? Xe = parse$1(Ue) : He.commaSeparated ? Xe = parse$2(Ue) : He.commaOrSpaceSeparated ? Xe = parse$1(parse$2(Ue).join(" ")) : Xe = parsePrimitive(He, He.property, Ue) : Array.isArray(Ue) ? Xe = Ue.concat() : Xe = He.property === "style" ? style(Ue) : String(Ue);
    if (Array.isArray(Xe)) {
      const Ke = [];
      for (; ++Ge < Xe.length; ) {
        const $e = (
          /** @type {number | string} */
          parsePrimitive(He, He.property, Xe[Ge])
        );
        Ke[Ge] = $e;
      }
      Xe = Ke;
    }
    if (He.property === "className" && Array.isArray(ue.className)) {
      const Ke = (
        /** @type {number | string} */
        Xe
      );
      Xe = ue.className.concat(Ke);
    }
    ue[He.property] = Xe;
  }
}
function addChild(me, ue) {
  let Qe = -1;
  if (ue != null) if (typeof ue == "string" || typeof ue == "number")
    me.push({ type: "text", value: String(ue) });
  else if (Array.isArray(ue))
    for (; ++Qe < ue.length; )
      addChild(me, ue[Qe]);
  else if (typeof ue == "object" && "type" in ue)
    ue.type === "root" ? addChild(me, ue.children) : me.push(ue);
  else
    throw new Error("Expected node, nodes, or string, got `" + ue + "`");
}
function parsePrimitive(me, ue, Qe) {
  if (typeof Qe == "string") {
    if (me.number && Qe && !Number.isNaN(Number(Qe)))
      return Number(Qe);
    if ((me.boolean || me.overloadedBoolean) && (Qe === "" || normalize$1(Qe) === normalize$1(ue)))
      return !0;
  }
  return Qe;
}
function style(me) {
  const ue = [];
  let Qe;
  for (Qe in me)
    own$3.call(me, Qe) && ue.push([Qe, me[Qe]].join(": "));
  return ue.join("; ");
}
function createAdjustMap(me) {
  const ue = {};
  let Qe = -1;
  for (; ++Qe < me.length; )
    ue[me[Qe].toLowerCase()] = me[Qe];
  return ue;
}
const svgCaseSensitiveTagNames = [
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "solidColor",
  "textArea",
  "textPath"
], h$1 = createH(html$1, "div"), s$1 = createH(svg, "g", svgCaseSensitiveTagNames), search = /\r?\n|\r/g;
function location$1(me) {
  const ue = String(me), Qe = [];
  for (search.lastIndex = 0; search.test(ue); )
    Qe.push(search.lastIndex);
  return Qe.push(ue.length + 1), { toPoint: Ue, toOffset: He };
  function Ue(Ge) {
    let Xe = -1;
    if (typeof Ge == "number" && Ge > -1 && Ge < Qe[Qe.length - 1]) {
      for (; ++Xe < Qe.length; )
        if (Qe[Xe] > Ge)
          return {
            line: Xe + 1,
            column: Ge - (Xe > 0 ? Qe[Xe - 1] : 0) + 1,
            offset: Ge
          };
    }
  }
  function He(Ge) {
    const Xe = Ge && Ge.line, Ke = Ge && Ge.column;
    if (typeof Xe == "number" && typeof Ke == "number" && !Number.isNaN(Xe) && !Number.isNaN(Ke) && Xe - 1 in Qe) {
      const $e = (Qe[Xe - 2] || 0) + Ke - 1 || 0;
      if ($e > -1 && $e < Qe[Qe.length - 1])
        return $e;
    }
  }
}
const webNamespaces = {
  html: "http://www.w3.org/1999/xhtml",
  mathml: "http://www.w3.org/1998/Math/MathML",
  svg: "http://www.w3.org/2000/svg",
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
}, own$2 = {}.hasOwnProperty, proto$1 = Object.prototype;
function fromParse5(me, ue) {
  const Qe = ue || {};
  return one$1(
    {
      file: Qe.file || void 0,
      location: !1,
      schema: Qe.space === "svg" ? svg : html$1,
      verbose: Qe.verbose || !1
    },
    me
  );
}
function one$1(me, ue) {
  let Qe;
  switch (ue.nodeName) {
    case "#comment": {
      const Ue = (
        /** @type {P5Comment} */
        ue
      );
      return Qe = { type: "comment", value: Ue.data }, patch$1(me, Ue, Qe), Qe;
    }
    case "#document":
    case "#document-fragment": {
      const Ue = (
        /** @type {P5Document | P5DocumentFragment} */
        ue
      ), He = "mode" in Ue ? Ue.mode === "quirks" || Ue.mode === "limited-quirks" : !1;
      if (Qe = {
        type: "root",
        children: all$2(me, ue.childNodes),
        data: { quirksMode: He }
      }, me.file && me.location) {
        const Ge = String(me.file), Xe = location$1(Ge), Ke = Xe.toPoint(0), $e = Xe.toPoint(Ge.length);
        Qe.position = { start: Ke, end: $e };
      }
      return Qe;
    }
    case "#documentType": {
      const Ue = (
        /** @type {P5DocumentType} */
        ue
      );
      return Qe = { type: "doctype" }, patch$1(me, Ue, Qe), Qe;
    }
    case "#text": {
      const Ue = (
        /** @type {P5Text} */
        ue
      );
      return Qe = { type: "text", value: Ue.value }, patch$1(me, Ue, Qe), Qe;
    }
    default:
      return Qe = element$2(
        me,
        /** @type {P5Element} */
        ue
      ), Qe;
  }
}
function all$2(me, ue) {
  let Qe = -1;
  const Ue = [];
  for (; ++Qe < ue.length; ) {
    const He = (
      /** @type {RootContent} */
      one$1(me, ue[Qe])
    );
    Ue.push(He);
  }
  return Ue;
}
function element$2(me, ue) {
  const Qe = me.schema;
  me.schema = ue.namespaceURI === webNamespaces.svg ? svg : html$1;
  let Ue = -1;
  const He = {};
  for (; ++Ue < ue.attrs.length; ) {
    const Ke = ue.attrs[Ue], $e = (Ke.prefix ? Ke.prefix + ":" : "") + Ke.name;
    own$2.call(proto$1, $e) || (He[$e] = Ke.value);
  }
  const Xe = (me.schema.space === "svg" ? s$1 : h$1)(ue.tagName, He, all$2(me, ue.childNodes));
  if (patch$1(me, ue, Xe), Xe.tagName === "template") {
    const Ke = (
      /** @type {P5Template} */
      ue
    ), $e = Ke.sourceCodeLocation, Je = $e && $e.startTag && position($e.startTag), Ze = $e && $e.endTag && position($e.endTag), nt = (
      /** @type {Root} */
      one$1(me, Ke.content)
    );
    Je && Ze && me.file && (nt.position = { start: Je.end, end: Ze.start }), Xe.content = nt;
  }
  return me.schema = Qe, Xe;
}
function patch$1(me, ue, Qe) {
  if ("sourceCodeLocation" in ue && ue.sourceCodeLocation && me.file) {
    const Ue = createLocation(me, Qe, ue.sourceCodeLocation);
    Ue && (me.location = !0, Qe.position = Ue);
  }
}
function createLocation(me, ue, Qe) {
  const Ue = position(Qe);
  if (ue.type === "element") {
    const He = ue.children[ue.children.length - 1];
    if (Ue && !Qe.endTag && He && He.position && He.position.end && (Ue.end = Object.assign({}, He.position.end)), me.verbose) {
      const Ge = {};
      let Xe;
      if (Qe.attrs)
        for (Xe in Qe.attrs)
          own$2.call(Qe.attrs, Xe) && (Ge[find$1(me.schema, Xe).property] = position(
            Qe.attrs[Xe]
          ));
      Qe.startTag;
      const Ke = position(Qe.startTag), $e = Qe.endTag ? position(Qe.endTag) : void 0, Je = { opening: Ke };
      $e && (Je.closing = $e), Je.properties = Ge, ue.data = { position: Je };
    }
  }
  return Ue;
}
function position(me) {
  const ue = point({
    line: me.startLine,
    column: me.startCol,
    offset: me.startOffset
  }), Qe = point({
    line: me.endLine,
    column: me.endCol,
    offset: me.endOffset
  });
  return ue || Qe ? { start: ue, end: Qe } : void 0;
}
function point(me) {
  return me.line && me.column ? me : void 0;
}
const own$1 = {}.hasOwnProperty;
function zwitch(me, ue) {
  const Qe = ue || {};
  function Ue(He, ...Ge) {
    let Xe = Ue.invalid;
    const Ke = Ue.handlers;
    if (He && own$1.call(He, me)) {
      const $e = String(He[me]);
      Xe = own$1.call(Ke, $e) ? Ke[$e] : Ue.unknown;
    }
    if (Xe)
      return Xe.call(this, He, ...Ge);
  }
  return Ue.handlers = Qe.handlers || {}, Ue.invalid = Qe.invalid, Ue.unknown = Qe.unknown, Ue;
}
const emptyOptions = {}, own = {}.hasOwnProperty, one = zwitch("type", { handlers: { root: root$1, element: element$1, text: text$1, comment: comment$1, doctype: doctype$1 } });
function toParse5(me, ue) {
  const Ue = (ue || emptyOptions).space;
  return one(me, Ue === "svg" ? svg : html$1);
}
function root$1(me, ue) {
  const Qe = {
    nodeName: "#document",
    // @ts-expect-error: `parse5` uses enums, which are actually strings.
    mode: (me.data || {}).quirksMode ? "quirks" : "no-quirks",
    childNodes: []
  };
  return Qe.childNodes = all$1(me.children, Qe, ue), patch(me, Qe), Qe;
}
function fragment(me, ue) {
  const Qe = { nodeName: "#document-fragment", childNodes: [] };
  return Qe.childNodes = all$1(me.children, Qe, ue), patch(me, Qe), Qe;
}
function doctype$1(me) {
  const ue = {
    nodeName: "#documentType",
    name: "html",
    publicId: "",
    systemId: "",
    parentNode: null
  };
  return patch(me, ue), ue;
}
function text$1(me) {
  const ue = {
    nodeName: "#text",
    value: me.value,
    parentNode: null
  };
  return patch(me, ue), ue;
}
function comment$1(me) {
  const ue = {
    nodeName: "#comment",
    data: me.value,
    parentNode: null
  };
  return patch(me, ue), ue;
}
function element$1(me, ue) {
  const Qe = ue;
  let Ue = Qe;
  me.type === "element" && me.tagName.toLowerCase() === "svg" && Qe.space === "html" && (Ue = svg);
  const He = [];
  let Ge;
  if (me.properties) {
    for (Ge in me.properties)
      if (Ge !== "children" && own.call(me.properties, Ge)) {
        const $e = createProperty(
          Ue,
          Ge,
          me.properties[Ge]
        );
        $e && He.push($e);
      }
  }
  const Xe = Ue.space, Ke = {
    nodeName: me.tagName,
    tagName: me.tagName,
    attrs: He,
    // @ts-expect-error: `parse5` types are wrong.
    namespaceURI: webNamespaces[Xe],
    childNodes: [],
    parentNode: null
  };
  return Ke.childNodes = all$1(me.children, Ke, Ue), patch(me, Ke), me.tagName === "template" && me.content && (Ke.content = fragment(me.content, Ue)), Ke;
}
function createProperty(me, ue, Qe) {
  const Ue = find$1(me, ue);
  if (Qe === !1 || Qe === null || Qe === void 0 || typeof Qe == "number" && Number.isNaN(Qe) || !Qe && Ue.boolean)
    return;
  Array.isArray(Qe) && (Qe = Ue.commaSeparated ? stringify$1(Qe) : stringify(Qe));
  const He = {
    name: Ue.attribute,
    value: Qe === !0 ? "" : String(Qe)
  };
  if (Ue.space && Ue.space !== "html" && Ue.space !== "svg") {
    const Ge = He.name.indexOf(":");
    Ge < 0 ? He.prefix = "" : (He.name = He.name.slice(Ge + 1), He.prefix = Ue.attribute.slice(0, Ge)), He.namespace = webNamespaces[Ue.space];
  }
  return He;
}
function all$1(me, ue, Qe) {
  let Ue = -1;
  const He = [];
  if (me)
    for (; ++Ue < me.length; ) {
      const Ge = one(me[Ue], Qe);
      Ge.parentNode = ue, He.push(Ge);
    }
  return He;
}
function patch(me, ue) {
  const Qe = me.position;
  Qe && Qe.start && Qe.end && (Qe.start.offset, Qe.end.offset, ue.sourceCodeLocation = {
    startLine: Qe.start.line,
    startCol: Qe.start.column,
    startOffset: Qe.start.offset,
    endLine: Qe.end.line,
    endCol: Qe.end.column,
    endOffset: Qe.end.offset
  });
}
const htmlVoidElements = [
  "area",
  "base",
  "basefont",
  "bgsound",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "image",
  "img",
  "input",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
], UNDEFINED_CODE_POINTS = /* @__PURE__ */ new Set([
  65534,
  65535,
  131070,
  131071,
  196606,
  196607,
  262142,
  262143,
  327678,
  327679,
  393214,
  393215,
  458750,
  458751,
  524286,
  524287,
  589822,
  589823,
  655358,
  655359,
  720894,
  720895,
  786430,
  786431,
  851966,
  851967,
  917502,
  917503,
  983038,
  983039,
  1048574,
  1048575,
  1114110,
  1114111
]), REPLACEMENT_CHARACTER = "�";
var CODE_POINTS;
(function(me) {
  me[me.EOF = -1] = "EOF", me[me.NULL = 0] = "NULL", me[me.TABULATION = 9] = "TABULATION", me[me.CARRIAGE_RETURN = 13] = "CARRIAGE_RETURN", me[me.LINE_FEED = 10] = "LINE_FEED", me[me.FORM_FEED = 12] = "FORM_FEED", me[me.SPACE = 32] = "SPACE", me[me.EXCLAMATION_MARK = 33] = "EXCLAMATION_MARK", me[me.QUOTATION_MARK = 34] = "QUOTATION_MARK", me[me.NUMBER_SIGN = 35] = "NUMBER_SIGN", me[me.AMPERSAND = 38] = "AMPERSAND", me[me.APOSTROPHE = 39] = "APOSTROPHE", me[me.HYPHEN_MINUS = 45] = "HYPHEN_MINUS", me[me.SOLIDUS = 47] = "SOLIDUS", me[me.DIGIT_0 = 48] = "DIGIT_0", me[me.DIGIT_9 = 57] = "DIGIT_9", me[me.SEMICOLON = 59] = "SEMICOLON", me[me.LESS_THAN_SIGN = 60] = "LESS_THAN_SIGN", me[me.EQUALS_SIGN = 61] = "EQUALS_SIGN", me[me.GREATER_THAN_SIGN = 62] = "GREATER_THAN_SIGN", me[me.QUESTION_MARK = 63] = "QUESTION_MARK", me[me.LATIN_CAPITAL_A = 65] = "LATIN_CAPITAL_A", me[me.LATIN_CAPITAL_F = 70] = "LATIN_CAPITAL_F", me[me.LATIN_CAPITAL_X = 88] = "LATIN_CAPITAL_X", me[me.LATIN_CAPITAL_Z = 90] = "LATIN_CAPITAL_Z", me[me.RIGHT_SQUARE_BRACKET = 93] = "RIGHT_SQUARE_BRACKET", me[me.GRAVE_ACCENT = 96] = "GRAVE_ACCENT", me[me.LATIN_SMALL_A = 97] = "LATIN_SMALL_A", me[me.LATIN_SMALL_F = 102] = "LATIN_SMALL_F", me[me.LATIN_SMALL_X = 120] = "LATIN_SMALL_X", me[me.LATIN_SMALL_Z = 122] = "LATIN_SMALL_Z", me[me.REPLACEMENT_CHARACTER = 65533] = "REPLACEMENT_CHARACTER";
})(CODE_POINTS = CODE_POINTS || (CODE_POINTS = {}));
const SEQUENCES = {
  DASH_DASH: "--",
  CDATA_START: "[CDATA[",
  DOCTYPE: "doctype",
  SCRIPT: "script",
  PUBLIC: "public",
  SYSTEM: "system"
};
function isSurrogate(me) {
  return me >= 55296 && me <= 57343;
}
function isSurrogatePair(me) {
  return me >= 56320 && me <= 57343;
}
function getSurrogatePairCodePoint(me, ue) {
  return (me - 55296) * 1024 + 9216 + ue;
}
function isControlCodePoint(me) {
  return me !== 32 && me !== 10 && me !== 13 && me !== 9 && me !== 12 && me >= 1 && me <= 31 || me >= 127 && me <= 159;
}
function isUndefinedCodePoint(me) {
  return me >= 64976 && me <= 65007 || UNDEFINED_CODE_POINTS.has(me);
}
var ERR;
(function(me) {
  me.controlCharacterInInputStream = "control-character-in-input-stream", me.noncharacterInInputStream = "noncharacter-in-input-stream", me.surrogateInInputStream = "surrogate-in-input-stream", me.nonVoidHtmlElementStartTagWithTrailingSolidus = "non-void-html-element-start-tag-with-trailing-solidus", me.endTagWithAttributes = "end-tag-with-attributes", me.endTagWithTrailingSolidus = "end-tag-with-trailing-solidus", me.unexpectedSolidusInTag = "unexpected-solidus-in-tag", me.unexpectedNullCharacter = "unexpected-null-character", me.unexpectedQuestionMarkInsteadOfTagName = "unexpected-question-mark-instead-of-tag-name", me.invalidFirstCharacterOfTagName = "invalid-first-character-of-tag-name", me.unexpectedEqualsSignBeforeAttributeName = "unexpected-equals-sign-before-attribute-name", me.missingEndTagName = "missing-end-tag-name", me.unexpectedCharacterInAttributeName = "unexpected-character-in-attribute-name", me.unknownNamedCharacterReference = "unknown-named-character-reference", me.missingSemicolonAfterCharacterReference = "missing-semicolon-after-character-reference", me.unexpectedCharacterAfterDoctypeSystemIdentifier = "unexpected-character-after-doctype-system-identifier", me.unexpectedCharacterInUnquotedAttributeValue = "unexpected-character-in-unquoted-attribute-value", me.eofBeforeTagName = "eof-before-tag-name", me.eofInTag = "eof-in-tag", me.missingAttributeValue = "missing-attribute-value", me.missingWhitespaceBetweenAttributes = "missing-whitespace-between-attributes", me.missingWhitespaceAfterDoctypePublicKeyword = "missing-whitespace-after-doctype-public-keyword", me.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers = "missing-whitespace-between-doctype-public-and-system-identifiers", me.missingWhitespaceAfterDoctypeSystemKeyword = "missing-whitespace-after-doctype-system-keyword", me.missingQuoteBeforeDoctypePublicIdentifier = "missing-quote-before-doctype-public-identifier", me.missingQuoteBeforeDoctypeSystemIdentifier = "missing-quote-before-doctype-system-identifier", me.missingDoctypePublicIdentifier = "missing-doctype-public-identifier", me.missingDoctypeSystemIdentifier = "missing-doctype-system-identifier", me.abruptDoctypePublicIdentifier = "abrupt-doctype-public-identifier", me.abruptDoctypeSystemIdentifier = "abrupt-doctype-system-identifier", me.cdataInHtmlContent = "cdata-in-html-content", me.incorrectlyOpenedComment = "incorrectly-opened-comment", me.eofInScriptHtmlCommentLikeText = "eof-in-script-html-comment-like-text", me.eofInDoctype = "eof-in-doctype", me.nestedComment = "nested-comment", me.abruptClosingOfEmptyComment = "abrupt-closing-of-empty-comment", me.eofInComment = "eof-in-comment", me.incorrectlyClosedComment = "incorrectly-closed-comment", me.eofInCdata = "eof-in-cdata", me.absenceOfDigitsInNumericCharacterReference = "absence-of-digits-in-numeric-character-reference", me.nullCharacterReference = "null-character-reference", me.surrogateCharacterReference = "surrogate-character-reference", me.characterReferenceOutsideUnicodeRange = "character-reference-outside-unicode-range", me.controlCharacterReference = "control-character-reference", me.noncharacterCharacterReference = "noncharacter-character-reference", me.missingWhitespaceBeforeDoctypeName = "missing-whitespace-before-doctype-name", me.missingDoctypeName = "missing-doctype-name", me.invalidCharacterSequenceAfterDoctypeName = "invalid-character-sequence-after-doctype-name", me.duplicateAttribute = "duplicate-attribute", me.nonConformingDoctype = "non-conforming-doctype", me.missingDoctype = "missing-doctype", me.misplacedDoctype = "misplaced-doctype", me.endTagWithoutMatchingOpenElement = "end-tag-without-matching-open-element", me.closingOfElementWithOpenChildElements = "closing-of-element-with-open-child-elements", me.disallowedContentInNoscriptInHead = "disallowed-content-in-noscript-in-head", me.openElementsLeftAfterEof = "open-elements-left-after-eof", me.abandonedHeadElementChild = "abandoned-head-element-child", me.misplacedStartTagForHeadElement = "misplaced-start-tag-for-head-element", me.nestedNoscriptInHead = "nested-noscript-in-head", me.eofInElementThatCanContainOnlyText = "eof-in-element-that-can-contain-only-text";
})(ERR = ERR || (ERR = {}));
const DEFAULT_BUFFER_WATERLINE = 65536;
class Preprocessor {
  constructor(ue) {
    this.handler = ue, this.html = "", this.pos = -1, this.lastGapPos = -2, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = DEFAULT_BUFFER_WATERLINE, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.line = 1, this.lastErrOffset = -1;
  }
  /** The column on the current line. If we just saw a gap (eg. a surrogate pair), return the index before. */
  get col() {
    return this.pos - this.lineStartPos + +(this.lastGapPos !== this.pos);
  }
  get offset() {
    return this.droppedBufferSize + this.pos;
  }
  getError(ue) {
    const { line: Qe, col: Ue, offset: He } = this;
    return {
      code: ue,
      startLine: Qe,
      endLine: Qe,
      startCol: Ue,
      endCol: Ue,
      startOffset: He,
      endOffset: He
    };
  }
  _err(ue) {
    this.handler.onParseError && this.lastErrOffset !== this.offset && (this.lastErrOffset = this.offset, this.handler.onParseError(this.getError(ue)));
  }
  _addGap() {
    this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
  }
  _processSurrogate(ue) {
    if (this.pos !== this.html.length - 1) {
      const Qe = this.html.charCodeAt(this.pos + 1);
      if (isSurrogatePair(Qe))
        return this.pos++, this._addGap(), getSurrogatePairCodePoint(ue, Qe);
    } else if (!this.lastChunkWritten)
      return this.endOfChunkHit = !0, CODE_POINTS.EOF;
    return this._err(ERR.surrogateInInputStream), ue;
  }
  willDropParsedChunk() {
    return this.pos > this.bufferWaterline;
  }
  dropParsedChunk() {
    this.willDropParsedChunk() && (this.html = this.html.substring(this.pos), this.lineStartPos -= this.pos, this.droppedBufferSize += this.pos, this.pos = 0, this.lastGapPos = -2, this.gapStack.length = 0);
  }
  write(ue, Qe) {
    this.html.length > 0 ? this.html += ue : this.html = ue, this.endOfChunkHit = !1, this.lastChunkWritten = Qe;
  }
  insertHtmlAtCurrentPos(ue) {
    this.html = this.html.substring(0, this.pos + 1) + ue + this.html.substring(this.pos + 1), this.endOfChunkHit = !1;
  }
  startsWith(ue, Qe) {
    if (this.pos + ue.length > this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, !1;
    if (Qe)
      return this.html.startsWith(ue, this.pos);
    for (let Ue = 0; Ue < ue.length; Ue++)
      if ((this.html.charCodeAt(this.pos + Ue) | 32) !== ue.charCodeAt(Ue))
        return !1;
    return !0;
  }
  peek(ue) {
    const Qe = this.pos + ue;
    if (Qe >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, CODE_POINTS.EOF;
    const Ue = this.html.charCodeAt(Qe);
    return Ue === CODE_POINTS.CARRIAGE_RETURN ? CODE_POINTS.LINE_FEED : Ue;
  }
  advance() {
    if (this.pos++, this.isEol && (this.isEol = !1, this.line++, this.lineStartPos = this.pos), this.pos >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, CODE_POINTS.EOF;
    let ue = this.html.charCodeAt(this.pos);
    return ue === CODE_POINTS.CARRIAGE_RETURN ? (this.isEol = !0, this.skipNextNewLine = !0, CODE_POINTS.LINE_FEED) : ue === CODE_POINTS.LINE_FEED && (this.isEol = !0, this.skipNextNewLine) ? (this.line--, this.skipNextNewLine = !1, this._addGap(), this.advance()) : (this.skipNextNewLine = !1, isSurrogate(ue) && (ue = this._processSurrogate(ue)), this.handler.onParseError === null || ue > 31 && ue < 127 || ue === CODE_POINTS.LINE_FEED || ue === CODE_POINTS.CARRIAGE_RETURN || ue > 159 && ue < 64976 || this._checkForProblematicCharacters(ue), ue);
  }
  _checkForProblematicCharacters(ue) {
    isControlCodePoint(ue) ? this._err(ERR.controlCharacterInInputStream) : isUndefinedCodePoint(ue) && this._err(ERR.noncharacterInInputStream);
  }
  retreat(ue) {
    for (this.pos -= ue; this.pos < this.lastGapPos; )
      this.lastGapPos = this.gapStack.pop(), this.pos--;
    this.isEol = !1;
  }
}
var TokenType;
(function(me) {
  me[me.CHARACTER = 0] = "CHARACTER", me[me.NULL_CHARACTER = 1] = "NULL_CHARACTER", me[me.WHITESPACE_CHARACTER = 2] = "WHITESPACE_CHARACTER", me[me.START_TAG = 3] = "START_TAG", me[me.END_TAG = 4] = "END_TAG", me[me.COMMENT = 5] = "COMMENT", me[me.DOCTYPE = 6] = "DOCTYPE", me[me.EOF = 7] = "EOF", me[me.HIBERNATION = 8] = "HIBERNATION";
})(TokenType = TokenType || (TokenType = {}));
function getTokenAttr(me, ue) {
  for (let Qe = me.attrs.length - 1; Qe >= 0; Qe--)
    if (me.attrs[Qe].name === ue)
      return me.attrs[Qe].value;
  return null;
}
const htmlDecodeTree = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((me) => me.charCodeAt(0))
), xmlDecodeTree = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map((me) => me.charCodeAt(0))
);
var _a;
const decodeMap = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]), fromCodePoint = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (_a = String.fromCodePoint) !== null && _a !== void 0 ? _a : function(me) {
    let ue = "";
    return me > 65535 && (me -= 65536, ue += String.fromCharCode(me >>> 10 & 1023 | 55296), me = 56320 | me & 1023), ue += String.fromCharCode(me), ue;
  }
);
function replaceCodePoint(me) {
  var ue;
  return me >= 55296 && me <= 57343 || me > 1114111 ? 65533 : (ue = decodeMap.get(me)) !== null && ue !== void 0 ? ue : me;
}
var CharCodes;
(function(me) {
  me[me.NUM = 35] = "NUM", me[me.SEMI = 59] = "SEMI", me[me.EQUALS = 61] = "EQUALS", me[me.ZERO = 48] = "ZERO", me[me.NINE = 57] = "NINE", me[me.LOWER_A = 97] = "LOWER_A", me[me.LOWER_F = 102] = "LOWER_F", me[me.LOWER_X = 120] = "LOWER_X", me[me.LOWER_Z = 122] = "LOWER_Z", me[me.UPPER_A = 65] = "UPPER_A", me[me.UPPER_F = 70] = "UPPER_F", me[me.UPPER_Z = 90] = "UPPER_Z";
})(CharCodes || (CharCodes = {}));
const TO_LOWER_BIT = 32;
var BinTrieFlags;
(function(me) {
  me[me.VALUE_LENGTH = 49152] = "VALUE_LENGTH", me[me.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", me[me.JUMP_TABLE = 127] = "JUMP_TABLE";
})(BinTrieFlags || (BinTrieFlags = {}));
function isNumber$1(me) {
  return me >= CharCodes.ZERO && me <= CharCodes.NINE;
}
function isHexadecimalCharacter(me) {
  return me >= CharCodes.UPPER_A && me <= CharCodes.UPPER_F || me >= CharCodes.LOWER_A && me <= CharCodes.LOWER_F;
}
function isAsciiAlphaNumeric$1(me) {
  return me >= CharCodes.UPPER_A && me <= CharCodes.UPPER_Z || me >= CharCodes.LOWER_A && me <= CharCodes.LOWER_Z || isNumber$1(me);
}
function isEntityInAttributeInvalidEnd$1(me) {
  return me === CharCodes.EQUALS || isAsciiAlphaNumeric$1(me);
}
var EntityDecoderState;
(function(me) {
  me[me.EntityStart = 0] = "EntityStart", me[me.NumericStart = 1] = "NumericStart", me[me.NumericDecimal = 2] = "NumericDecimal", me[me.NumericHex = 3] = "NumericHex", me[me.NamedEntity = 4] = "NamedEntity";
})(EntityDecoderState || (EntityDecoderState = {}));
var DecodingMode;
(function(me) {
  me[me.Legacy = 0] = "Legacy", me[me.Strict = 1] = "Strict", me[me.Attribute = 2] = "Attribute";
})(DecodingMode || (DecodingMode = {}));
class EntityDecoder {
  constructor(ue, Qe, Ue) {
    this.decodeTree = ue, this.emitCodePoint = Qe, this.errors = Ue, this.state = EntityDecoderState.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = DecodingMode.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(ue) {
    this.decodeMode = ue, this.state = EntityDecoderState.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param string The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(ue, Qe) {
    switch (this.state) {
      case EntityDecoderState.EntityStart:
        return ue.charCodeAt(Qe) === CharCodes.NUM ? (this.state = EntityDecoderState.NumericStart, this.consumed += 1, this.stateNumericStart(ue, Qe + 1)) : (this.state = EntityDecoderState.NamedEntity, this.stateNamedEntity(ue, Qe));
      case EntityDecoderState.NumericStart:
        return this.stateNumericStart(ue, Qe);
      case EntityDecoderState.NumericDecimal:
        return this.stateNumericDecimal(ue, Qe);
      case EntityDecoderState.NumericHex:
        return this.stateNumericHex(ue, Qe);
      case EntityDecoderState.NamedEntity:
        return this.stateNamedEntity(ue, Qe);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(ue, Qe) {
    return Qe >= ue.length ? -1 : (ue.charCodeAt(Qe) | TO_LOWER_BIT) === CharCodes.LOWER_X ? (this.state = EntityDecoderState.NumericHex, this.consumed += 1, this.stateNumericHex(ue, Qe + 1)) : (this.state = EntityDecoderState.NumericDecimal, this.stateNumericDecimal(ue, Qe));
  }
  addToNumericResult(ue, Qe, Ue, He) {
    if (Qe !== Ue) {
      const Ge = Ue - Qe;
      this.result = this.result * Math.pow(He, Ge) + parseInt(ue.substr(Qe, Ge), He), this.consumed += Ge;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(ue, Qe) {
    const Ue = Qe;
    for (; Qe < ue.length; ) {
      const He = ue.charCodeAt(Qe);
      if (isNumber$1(He) || isHexadecimalCharacter(He))
        Qe += 1;
      else
        return this.addToNumericResult(ue, Ue, Qe, 16), this.emitNumericEntity(He, 3);
    }
    return this.addToNumericResult(ue, Ue, Qe, 16), -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(ue, Qe) {
    const Ue = Qe;
    for (; Qe < ue.length; ) {
      const He = ue.charCodeAt(Qe);
      if (isNumber$1(He))
        Qe += 1;
      else
        return this.addToNumericResult(ue, Ue, Qe, 10), this.emitNumericEntity(He, 2);
    }
    return this.addToNumericResult(ue, Ue, Qe, 10), -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(ue, Qe) {
    var Ue;
    if (this.consumed <= Qe)
      return (Ue = this.errors) === null || Ue === void 0 || Ue.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (ue === CharCodes.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === DecodingMode.Strict)
      return 0;
    return this.emitCodePoint(replaceCodePoint(this.result), this.consumed), this.errors && (ue !== CharCodes.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(ue, Qe) {
    const { decodeTree: Ue } = this;
    let He = Ue[this.treeIndex], Ge = (He & BinTrieFlags.VALUE_LENGTH) >> 14;
    for (; Qe < ue.length; Qe++, this.excess++) {
      const Xe = ue.charCodeAt(Qe);
      if (this.treeIndex = determineBranch(Ue, He, this.treeIndex + Math.max(1, Ge), Xe), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === DecodingMode.Attribute && // We shouldn't have consumed any characters after the entity,
        (Ge === 0 || // And there should be no invalid characters.
        isEntityInAttributeInvalidEnd$1(Xe)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (He = Ue[this.treeIndex], Ge = (He & BinTrieFlags.VALUE_LENGTH) >> 14, Ge !== 0) {
        if (Xe === CharCodes.SEMI)
          return this.emitNamedEntityData(this.treeIndex, Ge, this.consumed + this.excess);
        this.decodeMode !== DecodingMode.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var ue;
    const { result: Qe, decodeTree: Ue } = this, He = (Ue[Qe] & BinTrieFlags.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(Qe, He, this.consumed), (ue = this.errors) === null || ue === void 0 || ue.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(ue, Qe, Ue) {
    const { decodeTree: He } = this;
    return this.emitCodePoint(Qe === 1 ? He[ue] & ~BinTrieFlags.VALUE_LENGTH : He[ue + 1], Ue), Qe === 3 && this.emitCodePoint(He[ue + 2], Ue), Ue;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var ue;
    switch (this.state) {
      case EntityDecoderState.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== DecodingMode.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      case EntityDecoderState.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case EntityDecoderState.NumericHex:
        return this.emitNumericEntity(0, 3);
      case EntityDecoderState.NumericStart:
        return (ue = this.errors) === null || ue === void 0 || ue.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case EntityDecoderState.EntityStart:
        return 0;
    }
  }
}
function getDecoder(me) {
  let ue = "";
  const Qe = new EntityDecoder(me, (Ue) => ue += fromCodePoint(Ue));
  return function(He, Ge) {
    let Xe = 0, Ke = 0;
    for (; (Ke = He.indexOf("&", Ke)) >= 0; ) {
      ue += He.slice(Xe, Ke), Qe.startEntity(Ge);
      const Je = Qe.write(
        He,
        // Skip the "&"
        Ke + 1
      );
      if (Je < 0) {
        Xe = Ke + Qe.end();
        break;
      }
      Xe = Ke + Je, Ke = Je === 0 ? Xe + 1 : Xe;
    }
    const $e = ue + He.slice(Xe);
    return ue = "", $e;
  };
}
function determineBranch(me, ue, Qe, Ue) {
  const He = (ue & BinTrieFlags.BRANCH_LENGTH) >> 7, Ge = ue & BinTrieFlags.JUMP_TABLE;
  if (He === 0)
    return Ge !== 0 && Ue === Ge ? Qe : -1;
  if (Ge) {
    const $e = Ue - Ge;
    return $e < 0 || $e >= He ? -1 : me[Qe + $e] - 1;
  }
  let Xe = Qe, Ke = Xe + He - 1;
  for (; Xe <= Ke; ) {
    const $e = Xe + Ke >>> 1, Je = me[$e];
    if (Je < Ue)
      Xe = $e + 1;
    else if (Je > Ue)
      Ke = $e - 1;
    else
      return me[$e + He];
  }
  return -1;
}
getDecoder(htmlDecodeTree);
getDecoder(xmlDecodeTree);
var NS;
(function(me) {
  me.HTML = "http://www.w3.org/1999/xhtml", me.MATHML = "http://www.w3.org/1998/Math/MathML", me.SVG = "http://www.w3.org/2000/svg", me.XLINK = "http://www.w3.org/1999/xlink", me.XML = "http://www.w3.org/XML/1998/namespace", me.XMLNS = "http://www.w3.org/2000/xmlns/";
})(NS = NS || (NS = {}));
var ATTRS;
(function(me) {
  me.TYPE = "type", me.ACTION = "action", me.ENCODING = "encoding", me.PROMPT = "prompt", me.NAME = "name", me.COLOR = "color", me.FACE = "face", me.SIZE = "size";
})(ATTRS = ATTRS || (ATTRS = {}));
var DOCUMENT_MODE;
(function(me) {
  me.NO_QUIRKS = "no-quirks", me.QUIRKS = "quirks", me.LIMITED_QUIRKS = "limited-quirks";
})(DOCUMENT_MODE = DOCUMENT_MODE || (DOCUMENT_MODE = {}));
var TAG_NAMES;
(function(me) {
  me.A = "a", me.ADDRESS = "address", me.ANNOTATION_XML = "annotation-xml", me.APPLET = "applet", me.AREA = "area", me.ARTICLE = "article", me.ASIDE = "aside", me.B = "b", me.BASE = "base", me.BASEFONT = "basefont", me.BGSOUND = "bgsound", me.BIG = "big", me.BLOCKQUOTE = "blockquote", me.BODY = "body", me.BR = "br", me.BUTTON = "button", me.CAPTION = "caption", me.CENTER = "center", me.CODE = "code", me.COL = "col", me.COLGROUP = "colgroup", me.DD = "dd", me.DESC = "desc", me.DETAILS = "details", me.DIALOG = "dialog", me.DIR = "dir", me.DIV = "div", me.DL = "dl", me.DT = "dt", me.EM = "em", me.EMBED = "embed", me.FIELDSET = "fieldset", me.FIGCAPTION = "figcaption", me.FIGURE = "figure", me.FONT = "font", me.FOOTER = "footer", me.FOREIGN_OBJECT = "foreignObject", me.FORM = "form", me.FRAME = "frame", me.FRAMESET = "frameset", me.H1 = "h1", me.H2 = "h2", me.H3 = "h3", me.H4 = "h4", me.H5 = "h5", me.H6 = "h6", me.HEAD = "head", me.HEADER = "header", me.HGROUP = "hgroup", me.HR = "hr", me.HTML = "html", me.I = "i", me.IMG = "img", me.IMAGE = "image", me.INPUT = "input", me.IFRAME = "iframe", me.KEYGEN = "keygen", me.LABEL = "label", me.LI = "li", me.LINK = "link", me.LISTING = "listing", me.MAIN = "main", me.MALIGNMARK = "malignmark", me.MARQUEE = "marquee", me.MATH = "math", me.MENU = "menu", me.META = "meta", me.MGLYPH = "mglyph", me.MI = "mi", me.MO = "mo", me.MN = "mn", me.MS = "ms", me.MTEXT = "mtext", me.NAV = "nav", me.NOBR = "nobr", me.NOFRAMES = "noframes", me.NOEMBED = "noembed", me.NOSCRIPT = "noscript", me.OBJECT = "object", me.OL = "ol", me.OPTGROUP = "optgroup", me.OPTION = "option", me.P = "p", me.PARAM = "param", me.PLAINTEXT = "plaintext", me.PRE = "pre", me.RB = "rb", me.RP = "rp", me.RT = "rt", me.RTC = "rtc", me.RUBY = "ruby", me.S = "s", me.SCRIPT = "script", me.SECTION = "section", me.SELECT = "select", me.SOURCE = "source", me.SMALL = "small", me.SPAN = "span", me.STRIKE = "strike", me.STRONG = "strong", me.STYLE = "style", me.SUB = "sub", me.SUMMARY = "summary", me.SUP = "sup", me.TABLE = "table", me.TBODY = "tbody", me.TEMPLATE = "template", me.TEXTAREA = "textarea", me.TFOOT = "tfoot", me.TD = "td", me.TH = "th", me.THEAD = "thead", me.TITLE = "title", me.TR = "tr", me.TRACK = "track", me.TT = "tt", me.U = "u", me.UL = "ul", me.SVG = "svg", me.VAR = "var", me.WBR = "wbr", me.XMP = "xmp";
})(TAG_NAMES = TAG_NAMES || (TAG_NAMES = {}));
var TAG_ID;
(function(me) {
  me[me.UNKNOWN = 0] = "UNKNOWN", me[me.A = 1] = "A", me[me.ADDRESS = 2] = "ADDRESS", me[me.ANNOTATION_XML = 3] = "ANNOTATION_XML", me[me.APPLET = 4] = "APPLET", me[me.AREA = 5] = "AREA", me[me.ARTICLE = 6] = "ARTICLE", me[me.ASIDE = 7] = "ASIDE", me[me.B = 8] = "B", me[me.BASE = 9] = "BASE", me[me.BASEFONT = 10] = "BASEFONT", me[me.BGSOUND = 11] = "BGSOUND", me[me.BIG = 12] = "BIG", me[me.BLOCKQUOTE = 13] = "BLOCKQUOTE", me[me.BODY = 14] = "BODY", me[me.BR = 15] = "BR", me[me.BUTTON = 16] = "BUTTON", me[me.CAPTION = 17] = "CAPTION", me[me.CENTER = 18] = "CENTER", me[me.CODE = 19] = "CODE", me[me.COL = 20] = "COL", me[me.COLGROUP = 21] = "COLGROUP", me[me.DD = 22] = "DD", me[me.DESC = 23] = "DESC", me[me.DETAILS = 24] = "DETAILS", me[me.DIALOG = 25] = "DIALOG", me[me.DIR = 26] = "DIR", me[me.DIV = 27] = "DIV", me[me.DL = 28] = "DL", me[me.DT = 29] = "DT", me[me.EM = 30] = "EM", me[me.EMBED = 31] = "EMBED", me[me.FIELDSET = 32] = "FIELDSET", me[me.FIGCAPTION = 33] = "FIGCAPTION", me[me.FIGURE = 34] = "FIGURE", me[me.FONT = 35] = "FONT", me[me.FOOTER = 36] = "FOOTER", me[me.FOREIGN_OBJECT = 37] = "FOREIGN_OBJECT", me[me.FORM = 38] = "FORM", me[me.FRAME = 39] = "FRAME", me[me.FRAMESET = 40] = "FRAMESET", me[me.H1 = 41] = "H1", me[me.H2 = 42] = "H2", me[me.H3 = 43] = "H3", me[me.H4 = 44] = "H4", me[me.H5 = 45] = "H5", me[me.H6 = 46] = "H6", me[me.HEAD = 47] = "HEAD", me[me.HEADER = 48] = "HEADER", me[me.HGROUP = 49] = "HGROUP", me[me.HR = 50] = "HR", me[me.HTML = 51] = "HTML", me[me.I = 52] = "I", me[me.IMG = 53] = "IMG", me[me.IMAGE = 54] = "IMAGE", me[me.INPUT = 55] = "INPUT", me[me.IFRAME = 56] = "IFRAME", me[me.KEYGEN = 57] = "KEYGEN", me[me.LABEL = 58] = "LABEL", me[me.LI = 59] = "LI", me[me.LINK = 60] = "LINK", me[me.LISTING = 61] = "LISTING", me[me.MAIN = 62] = "MAIN", me[me.MALIGNMARK = 63] = "MALIGNMARK", me[me.MARQUEE = 64] = "MARQUEE", me[me.MATH = 65] = "MATH", me[me.MENU = 66] = "MENU", me[me.META = 67] = "META", me[me.MGLYPH = 68] = "MGLYPH", me[me.MI = 69] = "MI", me[me.MO = 70] = "MO", me[me.MN = 71] = "MN", me[me.MS = 72] = "MS", me[me.MTEXT = 73] = "MTEXT", me[me.NAV = 74] = "NAV", me[me.NOBR = 75] = "NOBR", me[me.NOFRAMES = 76] = "NOFRAMES", me[me.NOEMBED = 77] = "NOEMBED", me[me.NOSCRIPT = 78] = "NOSCRIPT", me[me.OBJECT = 79] = "OBJECT", me[me.OL = 80] = "OL", me[me.OPTGROUP = 81] = "OPTGROUP", me[me.OPTION = 82] = "OPTION", me[me.P = 83] = "P", me[me.PARAM = 84] = "PARAM", me[me.PLAINTEXT = 85] = "PLAINTEXT", me[me.PRE = 86] = "PRE", me[me.RB = 87] = "RB", me[me.RP = 88] = "RP", me[me.RT = 89] = "RT", me[me.RTC = 90] = "RTC", me[me.RUBY = 91] = "RUBY", me[me.S = 92] = "S", me[me.SCRIPT = 93] = "SCRIPT", me[me.SECTION = 94] = "SECTION", me[me.SELECT = 95] = "SELECT", me[me.SOURCE = 96] = "SOURCE", me[me.SMALL = 97] = "SMALL", me[me.SPAN = 98] = "SPAN", me[me.STRIKE = 99] = "STRIKE", me[me.STRONG = 100] = "STRONG", me[me.STYLE = 101] = "STYLE", me[me.SUB = 102] = "SUB", me[me.SUMMARY = 103] = "SUMMARY", me[me.SUP = 104] = "SUP", me[me.TABLE = 105] = "TABLE", me[me.TBODY = 106] = "TBODY", me[me.TEMPLATE = 107] = "TEMPLATE", me[me.TEXTAREA = 108] = "TEXTAREA", me[me.TFOOT = 109] = "TFOOT", me[me.TD = 110] = "TD", me[me.TH = 111] = "TH", me[me.THEAD = 112] = "THEAD", me[me.TITLE = 113] = "TITLE", me[me.TR = 114] = "TR", me[me.TRACK = 115] = "TRACK", me[me.TT = 116] = "TT", me[me.U = 117] = "U", me[me.UL = 118] = "UL", me[me.SVG = 119] = "SVG", me[me.VAR = 120] = "VAR", me[me.WBR = 121] = "WBR", me[me.XMP = 122] = "XMP";
})(TAG_ID = TAG_ID || (TAG_ID = {}));
const TAG_NAME_TO_ID = /* @__PURE__ */ new Map([
  [TAG_NAMES.A, TAG_ID.A],
  [TAG_NAMES.ADDRESS, TAG_ID.ADDRESS],
  [TAG_NAMES.ANNOTATION_XML, TAG_ID.ANNOTATION_XML],
  [TAG_NAMES.APPLET, TAG_ID.APPLET],
  [TAG_NAMES.AREA, TAG_ID.AREA],
  [TAG_NAMES.ARTICLE, TAG_ID.ARTICLE],
  [TAG_NAMES.ASIDE, TAG_ID.ASIDE],
  [TAG_NAMES.B, TAG_ID.B],
  [TAG_NAMES.BASE, TAG_ID.BASE],
  [TAG_NAMES.BASEFONT, TAG_ID.BASEFONT],
  [TAG_NAMES.BGSOUND, TAG_ID.BGSOUND],
  [TAG_NAMES.BIG, TAG_ID.BIG],
  [TAG_NAMES.BLOCKQUOTE, TAG_ID.BLOCKQUOTE],
  [TAG_NAMES.BODY, TAG_ID.BODY],
  [TAG_NAMES.BR, TAG_ID.BR],
  [TAG_NAMES.BUTTON, TAG_ID.BUTTON],
  [TAG_NAMES.CAPTION, TAG_ID.CAPTION],
  [TAG_NAMES.CENTER, TAG_ID.CENTER],
  [TAG_NAMES.CODE, TAG_ID.CODE],
  [TAG_NAMES.COL, TAG_ID.COL],
  [TAG_NAMES.COLGROUP, TAG_ID.COLGROUP],
  [TAG_NAMES.DD, TAG_ID.DD],
  [TAG_NAMES.DESC, TAG_ID.DESC],
  [TAG_NAMES.DETAILS, TAG_ID.DETAILS],
  [TAG_NAMES.DIALOG, TAG_ID.DIALOG],
  [TAG_NAMES.DIR, TAG_ID.DIR],
  [TAG_NAMES.DIV, TAG_ID.DIV],
  [TAG_NAMES.DL, TAG_ID.DL],
  [TAG_NAMES.DT, TAG_ID.DT],
  [TAG_NAMES.EM, TAG_ID.EM],
  [TAG_NAMES.EMBED, TAG_ID.EMBED],
  [TAG_NAMES.FIELDSET, TAG_ID.FIELDSET],
  [TAG_NAMES.FIGCAPTION, TAG_ID.FIGCAPTION],
  [TAG_NAMES.FIGURE, TAG_ID.FIGURE],
  [TAG_NAMES.FONT, TAG_ID.FONT],
  [TAG_NAMES.FOOTER, TAG_ID.FOOTER],
  [TAG_NAMES.FOREIGN_OBJECT, TAG_ID.FOREIGN_OBJECT],
  [TAG_NAMES.FORM, TAG_ID.FORM],
  [TAG_NAMES.FRAME, TAG_ID.FRAME],
  [TAG_NAMES.FRAMESET, TAG_ID.FRAMESET],
  [TAG_NAMES.H1, TAG_ID.H1],
  [TAG_NAMES.H2, TAG_ID.H2],
  [TAG_NAMES.H3, TAG_ID.H3],
  [TAG_NAMES.H4, TAG_ID.H4],
  [TAG_NAMES.H5, TAG_ID.H5],
  [TAG_NAMES.H6, TAG_ID.H6],
  [TAG_NAMES.HEAD, TAG_ID.HEAD],
  [TAG_NAMES.HEADER, TAG_ID.HEADER],
  [TAG_NAMES.HGROUP, TAG_ID.HGROUP],
  [TAG_NAMES.HR, TAG_ID.HR],
  [TAG_NAMES.HTML, TAG_ID.HTML],
  [TAG_NAMES.I, TAG_ID.I],
  [TAG_NAMES.IMG, TAG_ID.IMG],
  [TAG_NAMES.IMAGE, TAG_ID.IMAGE],
  [TAG_NAMES.INPUT, TAG_ID.INPUT],
  [TAG_NAMES.IFRAME, TAG_ID.IFRAME],
  [TAG_NAMES.KEYGEN, TAG_ID.KEYGEN],
  [TAG_NAMES.LABEL, TAG_ID.LABEL],
  [TAG_NAMES.LI, TAG_ID.LI],
  [TAG_NAMES.LINK, TAG_ID.LINK],
  [TAG_NAMES.LISTING, TAG_ID.LISTING],
  [TAG_NAMES.MAIN, TAG_ID.MAIN],
  [TAG_NAMES.MALIGNMARK, TAG_ID.MALIGNMARK],
  [TAG_NAMES.MARQUEE, TAG_ID.MARQUEE],
  [TAG_NAMES.MATH, TAG_ID.MATH],
  [TAG_NAMES.MENU, TAG_ID.MENU],
  [TAG_NAMES.META, TAG_ID.META],
  [TAG_NAMES.MGLYPH, TAG_ID.MGLYPH],
  [TAG_NAMES.MI, TAG_ID.MI],
  [TAG_NAMES.MO, TAG_ID.MO],
  [TAG_NAMES.MN, TAG_ID.MN],
  [TAG_NAMES.MS, TAG_ID.MS],
  [TAG_NAMES.MTEXT, TAG_ID.MTEXT],
  [TAG_NAMES.NAV, TAG_ID.NAV],
  [TAG_NAMES.NOBR, TAG_ID.NOBR],
  [TAG_NAMES.NOFRAMES, TAG_ID.NOFRAMES],
  [TAG_NAMES.NOEMBED, TAG_ID.NOEMBED],
  [TAG_NAMES.NOSCRIPT, TAG_ID.NOSCRIPT],
  [TAG_NAMES.OBJECT, TAG_ID.OBJECT],
  [TAG_NAMES.OL, TAG_ID.OL],
  [TAG_NAMES.OPTGROUP, TAG_ID.OPTGROUP],
  [TAG_NAMES.OPTION, TAG_ID.OPTION],
  [TAG_NAMES.P, TAG_ID.P],
  [TAG_NAMES.PARAM, TAG_ID.PARAM],
  [TAG_NAMES.PLAINTEXT, TAG_ID.PLAINTEXT],
  [TAG_NAMES.PRE, TAG_ID.PRE],
  [TAG_NAMES.RB, TAG_ID.RB],
  [TAG_NAMES.RP, TAG_ID.RP],
  [TAG_NAMES.RT, TAG_ID.RT],
  [TAG_NAMES.RTC, TAG_ID.RTC],
  [TAG_NAMES.RUBY, TAG_ID.RUBY],
  [TAG_NAMES.S, TAG_ID.S],
  [TAG_NAMES.SCRIPT, TAG_ID.SCRIPT],
  [TAG_NAMES.SECTION, TAG_ID.SECTION],
  [TAG_NAMES.SELECT, TAG_ID.SELECT],
  [TAG_NAMES.SOURCE, TAG_ID.SOURCE],
  [TAG_NAMES.SMALL, TAG_ID.SMALL],
  [TAG_NAMES.SPAN, TAG_ID.SPAN],
  [TAG_NAMES.STRIKE, TAG_ID.STRIKE],
  [TAG_NAMES.STRONG, TAG_ID.STRONG],
  [TAG_NAMES.STYLE, TAG_ID.STYLE],
  [TAG_NAMES.SUB, TAG_ID.SUB],
  [TAG_NAMES.SUMMARY, TAG_ID.SUMMARY],
  [TAG_NAMES.SUP, TAG_ID.SUP],
  [TAG_NAMES.TABLE, TAG_ID.TABLE],
  [TAG_NAMES.TBODY, TAG_ID.TBODY],
  [TAG_NAMES.TEMPLATE, TAG_ID.TEMPLATE],
  [TAG_NAMES.TEXTAREA, TAG_ID.TEXTAREA],
  [TAG_NAMES.TFOOT, TAG_ID.TFOOT],
  [TAG_NAMES.TD, TAG_ID.TD],
  [TAG_NAMES.TH, TAG_ID.TH],
  [TAG_NAMES.THEAD, TAG_ID.THEAD],
  [TAG_NAMES.TITLE, TAG_ID.TITLE],
  [TAG_NAMES.TR, TAG_ID.TR],
  [TAG_NAMES.TRACK, TAG_ID.TRACK],
  [TAG_NAMES.TT, TAG_ID.TT],
  [TAG_NAMES.U, TAG_ID.U],
  [TAG_NAMES.UL, TAG_ID.UL],
  [TAG_NAMES.SVG, TAG_ID.SVG],
  [TAG_NAMES.VAR, TAG_ID.VAR],
  [TAG_NAMES.WBR, TAG_ID.WBR],
  [TAG_NAMES.XMP, TAG_ID.XMP]
]);
function getTagID(me) {
  var ue;
  return (ue = TAG_NAME_TO_ID.get(me)) !== null && ue !== void 0 ? ue : TAG_ID.UNKNOWN;
}
const $ = TAG_ID, SPECIAL_ELEMENTS = {
  [NS.HTML]: /* @__PURE__ */ new Set([
    $.ADDRESS,
    $.APPLET,
    $.AREA,
    $.ARTICLE,
    $.ASIDE,
    $.BASE,
    $.BASEFONT,
    $.BGSOUND,
    $.BLOCKQUOTE,
    $.BODY,
    $.BR,
    $.BUTTON,
    $.CAPTION,
    $.CENTER,
    $.COL,
    $.COLGROUP,
    $.DD,
    $.DETAILS,
    $.DIR,
    $.DIV,
    $.DL,
    $.DT,
    $.EMBED,
    $.FIELDSET,
    $.FIGCAPTION,
    $.FIGURE,
    $.FOOTER,
    $.FORM,
    $.FRAME,
    $.FRAMESET,
    $.H1,
    $.H2,
    $.H3,
    $.H4,
    $.H5,
    $.H6,
    $.HEAD,
    $.HEADER,
    $.HGROUP,
    $.HR,
    $.HTML,
    $.IFRAME,
    $.IMG,
    $.INPUT,
    $.LI,
    $.LINK,
    $.LISTING,
    $.MAIN,
    $.MARQUEE,
    $.MENU,
    $.META,
    $.NAV,
    $.NOEMBED,
    $.NOFRAMES,
    $.NOSCRIPT,
    $.OBJECT,
    $.OL,
    $.P,
    $.PARAM,
    $.PLAINTEXT,
    $.PRE,
    $.SCRIPT,
    $.SECTION,
    $.SELECT,
    $.SOURCE,
    $.STYLE,
    $.SUMMARY,
    $.TABLE,
    $.TBODY,
    $.TD,
    $.TEMPLATE,
    $.TEXTAREA,
    $.TFOOT,
    $.TH,
    $.THEAD,
    $.TITLE,
    $.TR,
    $.TRACK,
    $.UL,
    $.WBR,
    $.XMP
  ]),
  [NS.MATHML]: /* @__PURE__ */ new Set([$.MI, $.MO, $.MN, $.MS, $.MTEXT, $.ANNOTATION_XML]),
  [NS.SVG]: /* @__PURE__ */ new Set([$.TITLE, $.FOREIGN_OBJECT, $.DESC]),
  [NS.XLINK]: /* @__PURE__ */ new Set(),
  [NS.XML]: /* @__PURE__ */ new Set(),
  [NS.XMLNS]: /* @__PURE__ */ new Set()
};
function isNumberedHeader(me) {
  return me === $.H1 || me === $.H2 || me === $.H3 || me === $.H4 || me === $.H5 || me === $.H6;
}
TAG_NAMES.STYLE, TAG_NAMES.SCRIPT, TAG_NAMES.XMP, TAG_NAMES.IFRAME, TAG_NAMES.NOEMBED, TAG_NAMES.NOFRAMES, TAG_NAMES.PLAINTEXT;
const C1_CONTROLS_REFERENCE_REPLACEMENTS = /* @__PURE__ */ new Map([
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]);
var State$1;
(function(me) {
  me[me.DATA = 0] = "DATA", me[me.RCDATA = 1] = "RCDATA", me[me.RAWTEXT = 2] = "RAWTEXT", me[me.SCRIPT_DATA = 3] = "SCRIPT_DATA", me[me.PLAINTEXT = 4] = "PLAINTEXT", me[me.TAG_OPEN = 5] = "TAG_OPEN", me[me.END_TAG_OPEN = 6] = "END_TAG_OPEN", me[me.TAG_NAME = 7] = "TAG_NAME", me[me.RCDATA_LESS_THAN_SIGN = 8] = "RCDATA_LESS_THAN_SIGN", me[me.RCDATA_END_TAG_OPEN = 9] = "RCDATA_END_TAG_OPEN", me[me.RCDATA_END_TAG_NAME = 10] = "RCDATA_END_TAG_NAME", me[me.RAWTEXT_LESS_THAN_SIGN = 11] = "RAWTEXT_LESS_THAN_SIGN", me[me.RAWTEXT_END_TAG_OPEN = 12] = "RAWTEXT_END_TAG_OPEN", me[me.RAWTEXT_END_TAG_NAME = 13] = "RAWTEXT_END_TAG_NAME", me[me.SCRIPT_DATA_LESS_THAN_SIGN = 14] = "SCRIPT_DATA_LESS_THAN_SIGN", me[me.SCRIPT_DATA_END_TAG_OPEN = 15] = "SCRIPT_DATA_END_TAG_OPEN", me[me.SCRIPT_DATA_END_TAG_NAME = 16] = "SCRIPT_DATA_END_TAG_NAME", me[me.SCRIPT_DATA_ESCAPE_START = 17] = "SCRIPT_DATA_ESCAPE_START", me[me.SCRIPT_DATA_ESCAPE_START_DASH = 18] = "SCRIPT_DATA_ESCAPE_START_DASH", me[me.SCRIPT_DATA_ESCAPED = 19] = "SCRIPT_DATA_ESCAPED", me[me.SCRIPT_DATA_ESCAPED_DASH = 20] = "SCRIPT_DATA_ESCAPED_DASH", me[me.SCRIPT_DATA_ESCAPED_DASH_DASH = 21] = "SCRIPT_DATA_ESCAPED_DASH_DASH", me[me.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN = 22] = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN", me[me.SCRIPT_DATA_ESCAPED_END_TAG_OPEN = 23] = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN", me[me.SCRIPT_DATA_ESCAPED_END_TAG_NAME = 24] = "SCRIPT_DATA_ESCAPED_END_TAG_NAME", me[me.SCRIPT_DATA_DOUBLE_ESCAPE_START = 25] = "SCRIPT_DATA_DOUBLE_ESCAPE_START", me[me.SCRIPT_DATA_DOUBLE_ESCAPED = 26] = "SCRIPT_DATA_DOUBLE_ESCAPED", me[me.SCRIPT_DATA_DOUBLE_ESCAPED_DASH = 27] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH", me[me.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH = 28] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH", me[me.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN = 29] = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN", me[me.SCRIPT_DATA_DOUBLE_ESCAPE_END = 30] = "SCRIPT_DATA_DOUBLE_ESCAPE_END", me[me.BEFORE_ATTRIBUTE_NAME = 31] = "BEFORE_ATTRIBUTE_NAME", me[me.ATTRIBUTE_NAME = 32] = "ATTRIBUTE_NAME", me[me.AFTER_ATTRIBUTE_NAME = 33] = "AFTER_ATTRIBUTE_NAME", me[me.BEFORE_ATTRIBUTE_VALUE = 34] = "BEFORE_ATTRIBUTE_VALUE", me[me.ATTRIBUTE_VALUE_DOUBLE_QUOTED = 35] = "ATTRIBUTE_VALUE_DOUBLE_QUOTED", me[me.ATTRIBUTE_VALUE_SINGLE_QUOTED = 36] = "ATTRIBUTE_VALUE_SINGLE_QUOTED", me[me.ATTRIBUTE_VALUE_UNQUOTED = 37] = "ATTRIBUTE_VALUE_UNQUOTED", me[me.AFTER_ATTRIBUTE_VALUE_QUOTED = 38] = "AFTER_ATTRIBUTE_VALUE_QUOTED", me[me.SELF_CLOSING_START_TAG = 39] = "SELF_CLOSING_START_TAG", me[me.BOGUS_COMMENT = 40] = "BOGUS_COMMENT", me[me.MARKUP_DECLARATION_OPEN = 41] = "MARKUP_DECLARATION_OPEN", me[me.COMMENT_START = 42] = "COMMENT_START", me[me.COMMENT_START_DASH = 43] = "COMMENT_START_DASH", me[me.COMMENT = 44] = "COMMENT", me[me.COMMENT_LESS_THAN_SIGN = 45] = "COMMENT_LESS_THAN_SIGN", me[me.COMMENT_LESS_THAN_SIGN_BANG = 46] = "COMMENT_LESS_THAN_SIGN_BANG", me[me.COMMENT_LESS_THAN_SIGN_BANG_DASH = 47] = "COMMENT_LESS_THAN_SIGN_BANG_DASH", me[me.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH = 48] = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH", me[me.COMMENT_END_DASH = 49] = "COMMENT_END_DASH", me[me.COMMENT_END = 50] = "COMMENT_END", me[me.COMMENT_END_BANG = 51] = "COMMENT_END_BANG", me[me.DOCTYPE = 52] = "DOCTYPE", me[me.BEFORE_DOCTYPE_NAME = 53] = "BEFORE_DOCTYPE_NAME", me[me.DOCTYPE_NAME = 54] = "DOCTYPE_NAME", me[me.AFTER_DOCTYPE_NAME = 55] = "AFTER_DOCTYPE_NAME", me[me.AFTER_DOCTYPE_PUBLIC_KEYWORD = 56] = "AFTER_DOCTYPE_PUBLIC_KEYWORD", me[me.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER = 57] = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER", me[me.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED = 58] = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED", me[me.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED = 59] = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED", me[me.AFTER_DOCTYPE_PUBLIC_IDENTIFIER = 60] = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER", me[me.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS = 61] = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS", me[me.AFTER_DOCTYPE_SYSTEM_KEYWORD = 62] = "AFTER_DOCTYPE_SYSTEM_KEYWORD", me[me.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER = 63] = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER", me[me.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED = 64] = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED", me[me.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED = 65] = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED", me[me.AFTER_DOCTYPE_SYSTEM_IDENTIFIER = 66] = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER", me[me.BOGUS_DOCTYPE = 67] = "BOGUS_DOCTYPE", me[me.CDATA_SECTION = 68] = "CDATA_SECTION", me[me.CDATA_SECTION_BRACKET = 69] = "CDATA_SECTION_BRACKET", me[me.CDATA_SECTION_END = 70] = "CDATA_SECTION_END", me[me.CHARACTER_REFERENCE = 71] = "CHARACTER_REFERENCE", me[me.NAMED_CHARACTER_REFERENCE = 72] = "NAMED_CHARACTER_REFERENCE", me[me.AMBIGUOUS_AMPERSAND = 73] = "AMBIGUOUS_AMPERSAND", me[me.NUMERIC_CHARACTER_REFERENCE = 74] = "NUMERIC_CHARACTER_REFERENCE", me[me.HEXADEMICAL_CHARACTER_REFERENCE_START = 75] = "HEXADEMICAL_CHARACTER_REFERENCE_START", me[me.HEXADEMICAL_CHARACTER_REFERENCE = 76] = "HEXADEMICAL_CHARACTER_REFERENCE", me[me.DECIMAL_CHARACTER_REFERENCE = 77] = "DECIMAL_CHARACTER_REFERENCE", me[me.NUMERIC_CHARACTER_REFERENCE_END = 78] = "NUMERIC_CHARACTER_REFERENCE_END";
})(State$1 || (State$1 = {}));
const TokenizerMode = {
  DATA: State$1.DATA,
  RCDATA: State$1.RCDATA,
  RAWTEXT: State$1.RAWTEXT,
  SCRIPT_DATA: State$1.SCRIPT_DATA,
  PLAINTEXT: State$1.PLAINTEXT,
  CDATA_SECTION: State$1.CDATA_SECTION
};
function isAsciiDigit(me) {
  return me >= CODE_POINTS.DIGIT_0 && me <= CODE_POINTS.DIGIT_9;
}
function isAsciiUpper(me) {
  return me >= CODE_POINTS.LATIN_CAPITAL_A && me <= CODE_POINTS.LATIN_CAPITAL_Z;
}
function isAsciiLower(me) {
  return me >= CODE_POINTS.LATIN_SMALL_A && me <= CODE_POINTS.LATIN_SMALL_Z;
}
function isAsciiLetter(me) {
  return isAsciiLower(me) || isAsciiUpper(me);
}
function isAsciiAlphaNumeric(me) {
  return isAsciiLetter(me) || isAsciiDigit(me);
}
function isAsciiUpperHexDigit(me) {
  return me >= CODE_POINTS.LATIN_CAPITAL_A && me <= CODE_POINTS.LATIN_CAPITAL_F;
}
function isAsciiLowerHexDigit(me) {
  return me >= CODE_POINTS.LATIN_SMALL_A && me <= CODE_POINTS.LATIN_SMALL_F;
}
function isAsciiHexDigit(me) {
  return isAsciiDigit(me) || isAsciiUpperHexDigit(me) || isAsciiLowerHexDigit(me);
}
function toAsciiLower(me) {
  return me + 32;
}
function isWhitespace(me) {
  return me === CODE_POINTS.SPACE || me === CODE_POINTS.LINE_FEED || me === CODE_POINTS.TABULATION || me === CODE_POINTS.FORM_FEED;
}
function isEntityInAttributeInvalidEnd(me) {
  return me === CODE_POINTS.EQUALS_SIGN || isAsciiAlphaNumeric(me);
}
function isScriptDataDoubleEscapeSequenceEnd(me) {
  return isWhitespace(me) || me === CODE_POINTS.SOLIDUS || me === CODE_POINTS.GREATER_THAN_SIGN;
}
class Tokenizer {
  constructor(ue, Qe) {
    this.options = ue, this.handler = Qe, this.paused = !1, this.inLoop = !1, this.inForeignNode = !1, this.lastStartTagName = "", this.active = !1, this.state = State$1.DATA, this.returnState = State$1.DATA, this.charRefCode = -1, this.consumedAfterSnapshot = -1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = { name: "", value: "" }, this.preprocessor = new Preprocessor(Qe), this.currentLocation = this.getCurrentLocation(-1);
  }
  //Errors
  _err(ue) {
    var Qe, Ue;
    (Ue = (Qe = this.handler).onParseError) === null || Ue === void 0 || Ue.call(Qe, this.preprocessor.getError(ue));
  }
  // NOTE: `offset` may never run across line boundaries.
  getCurrentLocation(ue) {
    return this.options.sourceCodeLocationInfo ? {
      startLine: this.preprocessor.line,
      startCol: this.preprocessor.col - ue,
      startOffset: this.preprocessor.offset - ue,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    } : null;
  }
  _runParsingLoop() {
    if (!this.inLoop) {
      for (this.inLoop = !0; this.active && !this.paused; ) {
        this.consumedAfterSnapshot = 0;
        const ue = this._consume();
        this._ensureHibernation() || this._callState(ue);
      }
      this.inLoop = !1;
    }
  }
  //API
  pause() {
    this.paused = !0;
  }
  resume(ue) {
    if (!this.paused)
      throw new Error("Parser was already resumed");
    this.paused = !1, !this.inLoop && (this._runParsingLoop(), this.paused || ue == null || ue());
  }
  write(ue, Qe, Ue) {
    this.active = !0, this.preprocessor.write(ue, Qe), this._runParsingLoop(), this.paused || Ue == null || Ue();
  }
  insertHtmlAtCurrentPos(ue) {
    this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(ue), this._runParsingLoop();
  }
  //Hibernation
  _ensureHibernation() {
    return this.preprocessor.endOfChunkHit ? (this._unconsume(this.consumedAfterSnapshot), this.active = !1, !0) : !1;
  }
  //Consumption
  _consume() {
    return this.consumedAfterSnapshot++, this.preprocessor.advance();
  }
  _unconsume(ue) {
    this.consumedAfterSnapshot -= ue, this.preprocessor.retreat(ue);
  }
  _reconsumeInState(ue, Qe) {
    this.state = ue, this._callState(Qe);
  }
  _advanceBy(ue) {
    this.consumedAfterSnapshot += ue;
    for (let Qe = 0; Qe < ue; Qe++)
      this.preprocessor.advance();
  }
  _consumeSequenceIfMatch(ue, Qe) {
    return this.preprocessor.startsWith(ue, Qe) ? (this._advanceBy(ue.length - 1), !0) : !1;
  }
  //Token creation
  _createStartTagToken() {
    this.currentToken = {
      type: TokenType.START_TAG,
      tagName: "",
      tagID: TAG_ID.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(1)
    };
  }
  _createEndTagToken() {
    this.currentToken = {
      type: TokenType.END_TAG,
      tagName: "",
      tagID: TAG_ID.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(2)
    };
  }
  _createCommentToken(ue) {
    this.currentToken = {
      type: TokenType.COMMENT,
      data: "",
      location: this.getCurrentLocation(ue)
    };
  }
  _createDoctypeToken(ue) {
    this.currentToken = {
      type: TokenType.DOCTYPE,
      name: ue,
      forceQuirks: !1,
      publicId: null,
      systemId: null,
      location: this.currentLocation
    };
  }
  _createCharacterToken(ue, Qe) {
    this.currentCharacterToken = {
      type: ue,
      chars: Qe,
      location: this.currentLocation
    };
  }
  //Tag attributes
  _createAttr(ue) {
    this.currentAttr = {
      name: ue,
      value: ""
    }, this.currentLocation = this.getCurrentLocation(0);
  }
  _leaveAttrName() {
    var ue, Qe;
    const Ue = this.currentToken;
    if (getTokenAttr(Ue, this.currentAttr.name) === null) {
      if (Ue.attrs.push(this.currentAttr), Ue.location && this.currentLocation) {
        const He = (ue = (Qe = Ue.location).attrs) !== null && ue !== void 0 ? ue : Qe.attrs = /* @__PURE__ */ Object.create(null);
        He[this.currentAttr.name] = this.currentLocation, this._leaveAttrValue();
      }
    } else
      this._err(ERR.duplicateAttribute);
  }
  _leaveAttrValue() {
    this.currentLocation && (this.currentLocation.endLine = this.preprocessor.line, this.currentLocation.endCol = this.preprocessor.col, this.currentLocation.endOffset = this.preprocessor.offset);
  }
  //Token emission
  prepareToken(ue) {
    this._emitCurrentCharacterToken(ue.location), this.currentToken = null, ue.location && (ue.location.endLine = this.preprocessor.line, ue.location.endCol = this.preprocessor.col + 1, ue.location.endOffset = this.preprocessor.offset + 1), this.currentLocation = this.getCurrentLocation(-1);
  }
  emitCurrentTagToken() {
    const ue = this.currentToken;
    this.prepareToken(ue), ue.tagID = getTagID(ue.tagName), ue.type === TokenType.START_TAG ? (this.lastStartTagName = ue.tagName, this.handler.onStartTag(ue)) : (ue.attrs.length > 0 && this._err(ERR.endTagWithAttributes), ue.selfClosing && this._err(ERR.endTagWithTrailingSolidus), this.handler.onEndTag(ue)), this.preprocessor.dropParsedChunk();
  }
  emitCurrentComment(ue) {
    this.prepareToken(ue), this.handler.onComment(ue), this.preprocessor.dropParsedChunk();
  }
  emitCurrentDoctype(ue) {
    this.prepareToken(ue), this.handler.onDoctype(ue), this.preprocessor.dropParsedChunk();
  }
  _emitCurrentCharacterToken(ue) {
    if (this.currentCharacterToken) {
      switch (ue && this.currentCharacterToken.location && (this.currentCharacterToken.location.endLine = ue.startLine, this.currentCharacterToken.location.endCol = ue.startCol, this.currentCharacterToken.location.endOffset = ue.startOffset), this.currentCharacterToken.type) {
        case TokenType.CHARACTER: {
          this.handler.onCharacter(this.currentCharacterToken);
          break;
        }
        case TokenType.NULL_CHARACTER: {
          this.handler.onNullCharacter(this.currentCharacterToken);
          break;
        }
        case TokenType.WHITESPACE_CHARACTER: {
          this.handler.onWhitespaceCharacter(this.currentCharacterToken);
          break;
        }
      }
      this.currentCharacterToken = null;
    }
  }
  _emitEOFToken() {
    const ue = this.getCurrentLocation(0);
    ue && (ue.endLine = ue.startLine, ue.endCol = ue.startCol, ue.endOffset = ue.startOffset), this._emitCurrentCharacterToken(ue), this.handler.onEof({ type: TokenType.EOF, location: ue }), this.active = !1;
  }
  //Characters emission
  //OPTIMIZATION: specification uses only one type of character tokens (one token per character).
  //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
  //If we have a sequence of characters that belong to the same group, the parser can process it
  //as a single solid character token.
  //So, there are 3 types of character tokens in parse5:
  //1)TokenType.NULL_CHARACTER - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
  //2)TokenType.WHITESPACE_CHARACTER - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
  //3)TokenType.CHARACTER - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
  _appendCharToCurrentCharacterToken(ue, Qe) {
    if (this.currentCharacterToken)
      if (this.currentCharacterToken.type !== ue)
        this.currentLocation = this.getCurrentLocation(0), this._emitCurrentCharacterToken(this.currentLocation), this.preprocessor.dropParsedChunk();
      else {
        this.currentCharacterToken.chars += Qe;
        return;
      }
    this._createCharacterToken(ue, Qe);
  }
  _emitCodePoint(ue) {
    const Qe = isWhitespace(ue) ? TokenType.WHITESPACE_CHARACTER : ue === CODE_POINTS.NULL ? TokenType.NULL_CHARACTER : TokenType.CHARACTER;
    this._appendCharToCurrentCharacterToken(Qe, String.fromCodePoint(ue));
  }
  //NOTE: used when we emit characters explicitly.
  //This is always for non-whitespace and non-null characters, which allows us to avoid additional checks.
  _emitChars(ue) {
    this._appendCharToCurrentCharacterToken(TokenType.CHARACTER, ue);
  }
  // Character reference helpers
  _matchNamedCharacterReference(ue) {
    let Qe = null, Ue = 0, He = !1;
    for (let Ge = 0, Xe = htmlDecodeTree[0]; Ge >= 0 && (Ge = determineBranch(htmlDecodeTree, Xe, Ge + 1, ue), !(Ge < 0)); ue = this._consume()) {
      Ue += 1, Xe = htmlDecodeTree[Ge];
      const Ke = Xe & BinTrieFlags.VALUE_LENGTH;
      if (Ke) {
        const $e = (Ke >> 14) - 1;
        if (ue !== CODE_POINTS.SEMICOLON && this._isCharacterReferenceInAttribute() && isEntityInAttributeInvalidEnd(this.preprocessor.peek(1)) ? (Qe = [CODE_POINTS.AMPERSAND], Ge += $e) : (Qe = $e === 0 ? [htmlDecodeTree[Ge] & ~BinTrieFlags.VALUE_LENGTH] : $e === 1 ? [htmlDecodeTree[++Ge]] : [htmlDecodeTree[++Ge], htmlDecodeTree[++Ge]], Ue = 0, He = ue !== CODE_POINTS.SEMICOLON), $e === 0) {
          this._consume();
          break;
        }
      }
    }
    return this._unconsume(Ue), He && !this.preprocessor.endOfChunkHit && this._err(ERR.missingSemicolonAfterCharacterReference), this._unconsume(1), Qe;
  }
  _isCharacterReferenceInAttribute() {
    return this.returnState === State$1.ATTRIBUTE_VALUE_DOUBLE_QUOTED || this.returnState === State$1.ATTRIBUTE_VALUE_SINGLE_QUOTED || this.returnState === State$1.ATTRIBUTE_VALUE_UNQUOTED;
  }
  _flushCodePointConsumedAsCharacterReference(ue) {
    this._isCharacterReferenceInAttribute() ? this.currentAttr.value += String.fromCodePoint(ue) : this._emitCodePoint(ue);
  }
  // Calling states this way turns out to be much faster than any other approach.
  _callState(ue) {
    switch (this.state) {
      case State$1.DATA: {
        this._stateData(ue);
        break;
      }
      case State$1.RCDATA: {
        this._stateRcdata(ue);
        break;
      }
      case State$1.RAWTEXT: {
        this._stateRawtext(ue);
        break;
      }
      case State$1.SCRIPT_DATA: {
        this._stateScriptData(ue);
        break;
      }
      case State$1.PLAINTEXT: {
        this._statePlaintext(ue);
        break;
      }
      case State$1.TAG_OPEN: {
        this._stateTagOpen(ue);
        break;
      }
      case State$1.END_TAG_OPEN: {
        this._stateEndTagOpen(ue);
        break;
      }
      case State$1.TAG_NAME: {
        this._stateTagName(ue);
        break;
      }
      case State$1.RCDATA_LESS_THAN_SIGN: {
        this._stateRcdataLessThanSign(ue);
        break;
      }
      case State$1.RCDATA_END_TAG_OPEN: {
        this._stateRcdataEndTagOpen(ue);
        break;
      }
      case State$1.RCDATA_END_TAG_NAME: {
        this._stateRcdataEndTagName(ue);
        break;
      }
      case State$1.RAWTEXT_LESS_THAN_SIGN: {
        this._stateRawtextLessThanSign(ue);
        break;
      }
      case State$1.RAWTEXT_END_TAG_OPEN: {
        this._stateRawtextEndTagOpen(ue);
        break;
      }
      case State$1.RAWTEXT_END_TAG_NAME: {
        this._stateRawtextEndTagName(ue);
        break;
      }
      case State$1.SCRIPT_DATA_LESS_THAN_SIGN: {
        this._stateScriptDataLessThanSign(ue);
        break;
      }
      case State$1.SCRIPT_DATA_END_TAG_OPEN: {
        this._stateScriptDataEndTagOpen(ue);
        break;
      }
      case State$1.SCRIPT_DATA_END_TAG_NAME: {
        this._stateScriptDataEndTagName(ue);
        break;
      }
      case State$1.SCRIPT_DATA_ESCAPE_START: {
        this._stateScriptDataEscapeStart(ue);
        break;
      }
      case State$1.SCRIPT_DATA_ESCAPE_START_DASH: {
        this._stateScriptDataEscapeStartDash(ue);
        break;
      }
      case State$1.SCRIPT_DATA_ESCAPED: {
        this._stateScriptDataEscaped(ue);
        break;
      }
      case State$1.SCRIPT_DATA_ESCAPED_DASH: {
        this._stateScriptDataEscapedDash(ue);
        break;
      }
      case State$1.SCRIPT_DATA_ESCAPED_DASH_DASH: {
        this._stateScriptDataEscapedDashDash(ue);
        break;
      }
      case State$1.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataEscapedLessThanSign(ue);
        break;
      }
      case State$1.SCRIPT_DATA_ESCAPED_END_TAG_OPEN: {
        this._stateScriptDataEscapedEndTagOpen(ue);
        break;
      }
      case State$1.SCRIPT_DATA_ESCAPED_END_TAG_NAME: {
        this._stateScriptDataEscapedEndTagName(ue);
        break;
      }
      case State$1.SCRIPT_DATA_DOUBLE_ESCAPE_START: {
        this._stateScriptDataDoubleEscapeStart(ue);
        break;
      }
      case State$1.SCRIPT_DATA_DOUBLE_ESCAPED: {
        this._stateScriptDataDoubleEscaped(ue);
        break;
      }
      case State$1.SCRIPT_DATA_DOUBLE_ESCAPED_DASH: {
        this._stateScriptDataDoubleEscapedDash(ue);
        break;
      }
      case State$1.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH: {
        this._stateScriptDataDoubleEscapedDashDash(ue);
        break;
      }
      case State$1.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataDoubleEscapedLessThanSign(ue);
        break;
      }
      case State$1.SCRIPT_DATA_DOUBLE_ESCAPE_END: {
        this._stateScriptDataDoubleEscapeEnd(ue);
        break;
      }
      case State$1.BEFORE_ATTRIBUTE_NAME: {
        this._stateBeforeAttributeName(ue);
        break;
      }
      case State$1.ATTRIBUTE_NAME: {
        this._stateAttributeName(ue);
        break;
      }
      case State$1.AFTER_ATTRIBUTE_NAME: {
        this._stateAfterAttributeName(ue);
        break;
      }
      case State$1.BEFORE_ATTRIBUTE_VALUE: {
        this._stateBeforeAttributeValue(ue);
        break;
      }
      case State$1.ATTRIBUTE_VALUE_DOUBLE_QUOTED: {
        this._stateAttributeValueDoubleQuoted(ue);
        break;
      }
      case State$1.ATTRIBUTE_VALUE_SINGLE_QUOTED: {
        this._stateAttributeValueSingleQuoted(ue);
        break;
      }
      case State$1.ATTRIBUTE_VALUE_UNQUOTED: {
        this._stateAttributeValueUnquoted(ue);
        break;
      }
      case State$1.AFTER_ATTRIBUTE_VALUE_QUOTED: {
        this._stateAfterAttributeValueQuoted(ue);
        break;
      }
      case State$1.SELF_CLOSING_START_TAG: {
        this._stateSelfClosingStartTag(ue);
        break;
      }
      case State$1.BOGUS_COMMENT: {
        this._stateBogusComment(ue);
        break;
      }
      case State$1.MARKUP_DECLARATION_OPEN: {
        this._stateMarkupDeclarationOpen(ue);
        break;
      }
      case State$1.COMMENT_START: {
        this._stateCommentStart(ue);
        break;
      }
      case State$1.COMMENT_START_DASH: {
        this._stateCommentStartDash(ue);
        break;
      }
      case State$1.COMMENT: {
        this._stateComment(ue);
        break;
      }
      case State$1.COMMENT_LESS_THAN_SIGN: {
        this._stateCommentLessThanSign(ue);
        break;
      }
      case State$1.COMMENT_LESS_THAN_SIGN_BANG: {
        this._stateCommentLessThanSignBang(ue);
        break;
      }
      case State$1.COMMENT_LESS_THAN_SIGN_BANG_DASH: {
        this._stateCommentLessThanSignBangDash(ue);
        break;
      }
      case State$1.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH: {
        this._stateCommentLessThanSignBangDashDash(ue);
        break;
      }
      case State$1.COMMENT_END_DASH: {
        this._stateCommentEndDash(ue);
        break;
      }
      case State$1.COMMENT_END: {
        this._stateCommentEnd(ue);
        break;
      }
      case State$1.COMMENT_END_BANG: {
        this._stateCommentEndBang(ue);
        break;
      }
      case State$1.DOCTYPE: {
        this._stateDoctype(ue);
        break;
      }
      case State$1.BEFORE_DOCTYPE_NAME: {
        this._stateBeforeDoctypeName(ue);
        break;
      }
      case State$1.DOCTYPE_NAME: {
        this._stateDoctypeName(ue);
        break;
      }
      case State$1.AFTER_DOCTYPE_NAME: {
        this._stateAfterDoctypeName(ue);
        break;
      }
      case State$1.AFTER_DOCTYPE_PUBLIC_KEYWORD: {
        this._stateAfterDoctypePublicKeyword(ue);
        break;
      }
      case State$1.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateBeforeDoctypePublicIdentifier(ue);
        break;
      }
      case State$1.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypePublicIdentifierDoubleQuoted(ue);
        break;
      }
      case State$1.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypePublicIdentifierSingleQuoted(ue);
        break;
      }
      case State$1.AFTER_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateAfterDoctypePublicIdentifier(ue);
        break;
      }
      case State$1.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS: {
        this._stateBetweenDoctypePublicAndSystemIdentifiers(ue);
        break;
      }
      case State$1.AFTER_DOCTYPE_SYSTEM_KEYWORD: {
        this._stateAfterDoctypeSystemKeyword(ue);
        break;
      }
      case State$1.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateBeforeDoctypeSystemIdentifier(ue);
        break;
      }
      case State$1.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypeSystemIdentifierDoubleQuoted(ue);
        break;
      }
      case State$1.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypeSystemIdentifierSingleQuoted(ue);
        break;
      }
      case State$1.AFTER_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateAfterDoctypeSystemIdentifier(ue);
        break;
      }
      case State$1.BOGUS_DOCTYPE: {
        this._stateBogusDoctype(ue);
        break;
      }
      case State$1.CDATA_SECTION: {
        this._stateCdataSection(ue);
        break;
      }
      case State$1.CDATA_SECTION_BRACKET: {
        this._stateCdataSectionBracket(ue);
        break;
      }
      case State$1.CDATA_SECTION_END: {
        this._stateCdataSectionEnd(ue);
        break;
      }
      case State$1.CHARACTER_REFERENCE: {
        this._stateCharacterReference(ue);
        break;
      }
      case State$1.NAMED_CHARACTER_REFERENCE: {
        this._stateNamedCharacterReference(ue);
        break;
      }
      case State$1.AMBIGUOUS_AMPERSAND: {
        this._stateAmbiguousAmpersand(ue);
        break;
      }
      case State$1.NUMERIC_CHARACTER_REFERENCE: {
        this._stateNumericCharacterReference(ue);
        break;
      }
      case State$1.HEXADEMICAL_CHARACTER_REFERENCE_START: {
        this._stateHexademicalCharacterReferenceStart(ue);
        break;
      }
      case State$1.HEXADEMICAL_CHARACTER_REFERENCE: {
        this._stateHexademicalCharacterReference(ue);
        break;
      }
      case State$1.DECIMAL_CHARACTER_REFERENCE: {
        this._stateDecimalCharacterReference(ue);
        break;
      }
      case State$1.NUMERIC_CHARACTER_REFERENCE_END: {
        this._stateNumericCharacterReferenceEnd(ue);
        break;
      }
      default:
        throw new Error("Unknown state");
    }
  }
  // State machine
  // Data state
  //------------------------------------------------------------------
  _stateData(ue) {
    switch (ue) {
      case CODE_POINTS.LESS_THAN_SIGN: {
        this.state = State$1.TAG_OPEN;
        break;
      }
      case CODE_POINTS.AMPERSAND: {
        this.returnState = State$1.DATA, this.state = State$1.CHARACTER_REFERENCE;
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this._emitCodePoint(ue);
        break;
      }
      case CODE_POINTS.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(ue);
    }
  }
  //  RCDATA state
  //------------------------------------------------------------------
  _stateRcdata(ue) {
    switch (ue) {
      case CODE_POINTS.AMPERSAND: {
        this.returnState = State$1.RCDATA, this.state = State$1.CHARACTER_REFERENCE;
        break;
      }
      case CODE_POINTS.LESS_THAN_SIGN: {
        this.state = State$1.RCDATA_LESS_THAN_SIGN;
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this._emitChars(REPLACEMENT_CHARACTER);
        break;
      }
      case CODE_POINTS.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(ue);
    }
  }
  // RAWTEXT state
  //------------------------------------------------------------------
  _stateRawtext(ue) {
    switch (ue) {
      case CODE_POINTS.LESS_THAN_SIGN: {
        this.state = State$1.RAWTEXT_LESS_THAN_SIGN;
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this._emitChars(REPLACEMENT_CHARACTER);
        break;
      }
      case CODE_POINTS.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(ue);
    }
  }
  // Script data state
  //------------------------------------------------------------------
  _stateScriptData(ue) {
    switch (ue) {
      case CODE_POINTS.LESS_THAN_SIGN: {
        this.state = State$1.SCRIPT_DATA_LESS_THAN_SIGN;
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this._emitChars(REPLACEMENT_CHARACTER);
        break;
      }
      case CODE_POINTS.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(ue);
    }
  }
  // PLAINTEXT state
  //------------------------------------------------------------------
  _statePlaintext(ue) {
    switch (ue) {
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this._emitChars(REPLACEMENT_CHARACTER);
        break;
      }
      case CODE_POINTS.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(ue);
    }
  }
  // Tag open state
  //------------------------------------------------------------------
  _stateTagOpen(ue) {
    if (isAsciiLetter(ue))
      this._createStartTagToken(), this.state = State$1.TAG_NAME, this._stateTagName(ue);
    else
      switch (ue) {
        case CODE_POINTS.EXCLAMATION_MARK: {
          this.state = State$1.MARKUP_DECLARATION_OPEN;
          break;
        }
        case CODE_POINTS.SOLIDUS: {
          this.state = State$1.END_TAG_OPEN;
          break;
        }
        case CODE_POINTS.QUESTION_MARK: {
          this._err(ERR.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(1), this.state = State$1.BOGUS_COMMENT, this._stateBogusComment(ue);
          break;
        }
        case CODE_POINTS.EOF: {
          this._err(ERR.eofBeforeTagName), this._emitChars("<"), this._emitEOFToken();
          break;
        }
        default:
          this._err(ERR.invalidFirstCharacterOfTagName), this._emitChars("<"), this.state = State$1.DATA, this._stateData(ue);
      }
  }
  // End tag open state
  //------------------------------------------------------------------
  _stateEndTagOpen(ue) {
    if (isAsciiLetter(ue))
      this._createEndTagToken(), this.state = State$1.TAG_NAME, this._stateTagName(ue);
    else
      switch (ue) {
        case CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(ERR.missingEndTagName), this.state = State$1.DATA;
          break;
        }
        case CODE_POINTS.EOF: {
          this._err(ERR.eofBeforeTagName), this._emitChars("</"), this._emitEOFToken();
          break;
        }
        default:
          this._err(ERR.invalidFirstCharacterOfTagName), this._createCommentToken(2), this.state = State$1.BOGUS_COMMENT, this._stateBogusComment(ue);
      }
  }
  // Tag name state
  //------------------------------------------------------------------
  _stateTagName(ue) {
    const Qe = this.currentToken;
    switch (ue) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED: {
        this.state = State$1.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case CODE_POINTS.SOLIDUS: {
        this.state = State$1.SELF_CLOSING_START_TAG;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = State$1.DATA, this.emitCurrentTagToken();
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), Qe.tagName += REPLACEMENT_CHARACTER;
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        Qe.tagName += String.fromCodePoint(isAsciiUpper(ue) ? toAsciiLower(ue) : ue);
    }
  }
  // RCDATA less-than sign state
  //------------------------------------------------------------------
  _stateRcdataLessThanSign(ue) {
    ue === CODE_POINTS.SOLIDUS ? this.state = State$1.RCDATA_END_TAG_OPEN : (this._emitChars("<"), this.state = State$1.RCDATA, this._stateRcdata(ue));
  }
  // RCDATA end tag open state
  //------------------------------------------------------------------
  _stateRcdataEndTagOpen(ue) {
    isAsciiLetter(ue) ? (this.state = State$1.RCDATA_END_TAG_NAME, this._stateRcdataEndTagName(ue)) : (this._emitChars("</"), this.state = State$1.RCDATA, this._stateRcdata(ue));
  }
  handleSpecialEndTag(ue) {
    if (!this.preprocessor.startsWith(this.lastStartTagName, !1))
      return !this._ensureHibernation();
    this._createEndTagToken();
    const Qe = this.currentToken;
    switch (Qe.tagName = this.lastStartTagName, this.preprocessor.peek(this.lastStartTagName.length)) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED:
        return this._advanceBy(this.lastStartTagName.length), this.state = State$1.BEFORE_ATTRIBUTE_NAME, !1;
      case CODE_POINTS.SOLIDUS:
        return this._advanceBy(this.lastStartTagName.length), this.state = State$1.SELF_CLOSING_START_TAG, !1;
      case CODE_POINTS.GREATER_THAN_SIGN:
        return this._advanceBy(this.lastStartTagName.length), this.emitCurrentTagToken(), this.state = State$1.DATA, !1;
      default:
        return !this._ensureHibernation();
    }
  }
  // RCDATA end tag name state
  //------------------------------------------------------------------
  _stateRcdataEndTagName(ue) {
    this.handleSpecialEndTag(ue) && (this._emitChars("</"), this.state = State$1.RCDATA, this._stateRcdata(ue));
  }
  // RAWTEXT less-than sign state
  //------------------------------------------------------------------
  _stateRawtextLessThanSign(ue) {
    ue === CODE_POINTS.SOLIDUS ? this.state = State$1.RAWTEXT_END_TAG_OPEN : (this._emitChars("<"), this.state = State$1.RAWTEXT, this._stateRawtext(ue));
  }
  // RAWTEXT end tag open state
  //------------------------------------------------------------------
  _stateRawtextEndTagOpen(ue) {
    isAsciiLetter(ue) ? (this.state = State$1.RAWTEXT_END_TAG_NAME, this._stateRawtextEndTagName(ue)) : (this._emitChars("</"), this.state = State$1.RAWTEXT, this._stateRawtext(ue));
  }
  // RAWTEXT end tag name state
  //------------------------------------------------------------------
  _stateRawtextEndTagName(ue) {
    this.handleSpecialEndTag(ue) && (this._emitChars("</"), this.state = State$1.RAWTEXT, this._stateRawtext(ue));
  }
  // Script data less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataLessThanSign(ue) {
    switch (ue) {
      case CODE_POINTS.SOLIDUS: {
        this.state = State$1.SCRIPT_DATA_END_TAG_OPEN;
        break;
      }
      case CODE_POINTS.EXCLAMATION_MARK: {
        this.state = State$1.SCRIPT_DATA_ESCAPE_START, this._emitChars("<!");
        break;
      }
      default:
        this._emitChars("<"), this.state = State$1.SCRIPT_DATA, this._stateScriptData(ue);
    }
  }
  // Script data end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEndTagOpen(ue) {
    isAsciiLetter(ue) ? (this.state = State$1.SCRIPT_DATA_END_TAG_NAME, this._stateScriptDataEndTagName(ue)) : (this._emitChars("</"), this.state = State$1.SCRIPT_DATA, this._stateScriptData(ue));
  }
  // Script data end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEndTagName(ue) {
    this.handleSpecialEndTag(ue) && (this._emitChars("</"), this.state = State$1.SCRIPT_DATA, this._stateScriptData(ue));
  }
  // Script data escape start state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStart(ue) {
    ue === CODE_POINTS.HYPHEN_MINUS ? (this.state = State$1.SCRIPT_DATA_ESCAPE_START_DASH, this._emitChars("-")) : (this.state = State$1.SCRIPT_DATA, this._stateScriptData(ue));
  }
  // Script data escape start dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStartDash(ue) {
    ue === CODE_POINTS.HYPHEN_MINUS ? (this.state = State$1.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-")) : (this.state = State$1.SCRIPT_DATA, this._stateScriptData(ue));
  }
  // Script data escaped state
  //------------------------------------------------------------------
  _stateScriptDataEscaped(ue) {
    switch (ue) {
      case CODE_POINTS.HYPHEN_MINUS: {
        this.state = State$1.SCRIPT_DATA_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case CODE_POINTS.LESS_THAN_SIGN: {
        this.state = State$1.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this._emitChars(REPLACEMENT_CHARACTER);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(ue);
    }
  }
  // Script data escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDash(ue) {
    switch (ue) {
      case CODE_POINTS.HYPHEN_MINUS: {
        this.state = State$1.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case CODE_POINTS.LESS_THAN_SIGN: {
        this.state = State$1.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this.state = State$1.SCRIPT_DATA_ESCAPED, this._emitChars(REPLACEMENT_CHARACTER);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = State$1.SCRIPT_DATA_ESCAPED, this._emitCodePoint(ue);
    }
  }
  // Script data escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDashDash(ue) {
    switch (ue) {
      case CODE_POINTS.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case CODE_POINTS.LESS_THAN_SIGN: {
        this.state = State$1.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = State$1.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this.state = State$1.SCRIPT_DATA_ESCAPED, this._emitChars(REPLACEMENT_CHARACTER);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = State$1.SCRIPT_DATA_ESCAPED, this._emitCodePoint(ue);
    }
  }
  // Script data escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataEscapedLessThanSign(ue) {
    ue === CODE_POINTS.SOLIDUS ? this.state = State$1.SCRIPT_DATA_ESCAPED_END_TAG_OPEN : isAsciiLetter(ue) ? (this._emitChars("<"), this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPE_START, this._stateScriptDataDoubleEscapeStart(ue)) : (this._emitChars("<"), this.state = State$1.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(ue));
  }
  // Script data escaped end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagOpen(ue) {
    isAsciiLetter(ue) ? (this.state = State$1.SCRIPT_DATA_ESCAPED_END_TAG_NAME, this._stateScriptDataEscapedEndTagName(ue)) : (this._emitChars("</"), this.state = State$1.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(ue));
  }
  // Script data escaped end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagName(ue) {
    this.handleSpecialEndTag(ue) && (this._emitChars("</"), this.state = State$1.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(ue));
  }
  // Script data double escape start state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeStart(ue) {
    if (this.preprocessor.startsWith(SEQUENCES.SCRIPT, !1) && isScriptDataDoubleEscapeSequenceEnd(this.preprocessor.peek(SEQUENCES.SCRIPT.length))) {
      this._emitCodePoint(ue);
      for (let Qe = 0; Qe < SEQUENCES.SCRIPT.length; Qe++)
        this._emitCodePoint(this._consume());
      this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED;
    } else this._ensureHibernation() || (this.state = State$1.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(ue));
  }
  // Script data double escaped state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscaped(ue) {
    switch (ue) {
      case CODE_POINTS.HYPHEN_MINUS: {
        this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case CODE_POINTS.LESS_THAN_SIGN: {
        this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this._emitChars(REPLACEMENT_CHARACTER);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(ue);
    }
  }
  // Script data double escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDash(ue) {
    switch (ue) {
      case CODE_POINTS.HYPHEN_MINUS: {
        this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case CODE_POINTS.LESS_THAN_SIGN: {
        this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(REPLACEMENT_CHARACTER);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(ue);
    }
  }
  // Script data double escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDashDash(ue) {
    switch (ue) {
      case CODE_POINTS.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case CODE_POINTS.LESS_THAN_SIGN: {
        this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = State$1.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(REPLACEMENT_CHARACTER);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(ue);
    }
  }
  // Script data double escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedLessThanSign(ue) {
    ue === CODE_POINTS.SOLIDUS ? (this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPE_END, this._emitChars("/")) : (this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(ue));
  }
  // Script data double escape end state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeEnd(ue) {
    if (this.preprocessor.startsWith(SEQUENCES.SCRIPT, !1) && isScriptDataDoubleEscapeSequenceEnd(this.preprocessor.peek(SEQUENCES.SCRIPT.length))) {
      this._emitCodePoint(ue);
      for (let Qe = 0; Qe < SEQUENCES.SCRIPT.length; Qe++)
        this._emitCodePoint(this._consume());
      this.state = State$1.SCRIPT_DATA_ESCAPED;
    } else this._ensureHibernation() || (this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(ue));
  }
  // Before attribute name state
  //------------------------------------------------------------------
  _stateBeforeAttributeName(ue) {
    switch (ue) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED:
        break;
      case CODE_POINTS.SOLIDUS:
      case CODE_POINTS.GREATER_THAN_SIGN:
      case CODE_POINTS.EOF: {
        this.state = State$1.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(ue);
        break;
      }
      case CODE_POINTS.EQUALS_SIGN: {
        this._err(ERR.unexpectedEqualsSignBeforeAttributeName), this._createAttr("="), this.state = State$1.ATTRIBUTE_NAME;
        break;
      }
      default:
        this._createAttr(""), this.state = State$1.ATTRIBUTE_NAME, this._stateAttributeName(ue);
    }
  }
  // Attribute name state
  //------------------------------------------------------------------
  _stateAttributeName(ue) {
    switch (ue) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED:
      case CODE_POINTS.SOLIDUS:
      case CODE_POINTS.GREATER_THAN_SIGN:
      case CODE_POINTS.EOF: {
        this._leaveAttrName(), this.state = State$1.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(ue);
        break;
      }
      case CODE_POINTS.EQUALS_SIGN: {
        this._leaveAttrName(), this.state = State$1.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case CODE_POINTS.QUOTATION_MARK:
      case CODE_POINTS.APOSTROPHE:
      case CODE_POINTS.LESS_THAN_SIGN: {
        this._err(ERR.unexpectedCharacterInAttributeName), this.currentAttr.name += String.fromCodePoint(ue);
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this.currentAttr.name += REPLACEMENT_CHARACTER;
        break;
      }
      default:
        this.currentAttr.name += String.fromCodePoint(isAsciiUpper(ue) ? toAsciiLower(ue) : ue);
    }
  }
  // After attribute name state
  //------------------------------------------------------------------
  _stateAfterAttributeName(ue) {
    switch (ue) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED:
        break;
      case CODE_POINTS.SOLIDUS: {
        this.state = State$1.SELF_CLOSING_START_TAG;
        break;
      }
      case CODE_POINTS.EQUALS_SIGN: {
        this.state = State$1.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = State$1.DATA, this.emitCurrentTagToken();
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._createAttr(""), this.state = State$1.ATTRIBUTE_NAME, this._stateAttributeName(ue);
    }
  }
  // Before attribute value state
  //------------------------------------------------------------------
  _stateBeforeAttributeValue(ue) {
    switch (ue) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED:
        break;
      case CODE_POINTS.QUOTATION_MARK: {
        this.state = State$1.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
        break;
      }
      case CODE_POINTS.APOSTROPHE: {
        this.state = State$1.ATTRIBUTE_VALUE_SINGLE_QUOTED;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(ERR.missingAttributeValue), this.state = State$1.DATA, this.emitCurrentTagToken();
        break;
      }
      default:
        this.state = State$1.ATTRIBUTE_VALUE_UNQUOTED, this._stateAttributeValueUnquoted(ue);
    }
  }
  // Attribute value (double-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueDoubleQuoted(ue) {
    switch (ue) {
      case CODE_POINTS.QUOTATION_MARK: {
        this.state = State$1.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case CODE_POINTS.AMPERSAND: {
        this.returnState = State$1.ATTRIBUTE_VALUE_DOUBLE_QUOTED, this.state = State$1.CHARACTER_REFERENCE;
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this.currentAttr.value += REPLACEMENT_CHARACTER;
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(ue);
    }
  }
  // Attribute value (single-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueSingleQuoted(ue) {
    switch (ue) {
      case CODE_POINTS.APOSTROPHE: {
        this.state = State$1.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case CODE_POINTS.AMPERSAND: {
        this.returnState = State$1.ATTRIBUTE_VALUE_SINGLE_QUOTED, this.state = State$1.CHARACTER_REFERENCE;
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this.currentAttr.value += REPLACEMENT_CHARACTER;
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(ue);
    }
  }
  // Attribute value (unquoted) state
  //------------------------------------------------------------------
  _stateAttributeValueUnquoted(ue) {
    switch (ue) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED: {
        this._leaveAttrValue(), this.state = State$1.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case CODE_POINTS.AMPERSAND: {
        this.returnState = State$1.ATTRIBUTE_VALUE_UNQUOTED, this.state = State$1.CHARACTER_REFERENCE;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = State$1.DATA, this.emitCurrentTagToken();
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this.currentAttr.value += REPLACEMENT_CHARACTER;
        break;
      }
      case CODE_POINTS.QUOTATION_MARK:
      case CODE_POINTS.APOSTROPHE:
      case CODE_POINTS.LESS_THAN_SIGN:
      case CODE_POINTS.EQUALS_SIGN:
      case CODE_POINTS.GRAVE_ACCENT: {
        this._err(ERR.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += String.fromCodePoint(ue);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(ue);
    }
  }
  // After attribute value (quoted) state
  //------------------------------------------------------------------
  _stateAfterAttributeValueQuoted(ue) {
    switch (ue) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED: {
        this._leaveAttrValue(), this.state = State$1.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case CODE_POINTS.SOLIDUS: {
        this._leaveAttrValue(), this.state = State$1.SELF_CLOSING_START_TAG;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = State$1.DATA, this.emitCurrentTagToken();
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(ERR.missingWhitespaceBetweenAttributes), this.state = State$1.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(ue);
    }
  }
  // Self-closing start tag state
  //------------------------------------------------------------------
  _stateSelfClosingStartTag(ue) {
    switch (ue) {
      case CODE_POINTS.GREATER_THAN_SIGN: {
        const Qe = this.currentToken;
        Qe.selfClosing = !0, this.state = State$1.DATA, this.emitCurrentTagToken();
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(ERR.unexpectedSolidusInTag), this.state = State$1.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(ue);
    }
  }
  // Bogus comment state
  //------------------------------------------------------------------
  _stateBogusComment(ue) {
    const Qe = this.currentToken;
    switch (ue) {
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = State$1.DATA, this.emitCurrentComment(Qe);
        break;
      }
      case CODE_POINTS.EOF: {
        this.emitCurrentComment(Qe), this._emitEOFToken();
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), Qe.data += REPLACEMENT_CHARACTER;
        break;
      }
      default:
        Qe.data += String.fromCodePoint(ue);
    }
  }
  // Markup declaration open state
  //------------------------------------------------------------------
  _stateMarkupDeclarationOpen(ue) {
    this._consumeSequenceIfMatch(SEQUENCES.DASH_DASH, !0) ? (this._createCommentToken(SEQUENCES.DASH_DASH.length + 1), this.state = State$1.COMMENT_START) : this._consumeSequenceIfMatch(SEQUENCES.DOCTYPE, !1) ? (this.currentLocation = this.getCurrentLocation(SEQUENCES.DOCTYPE.length + 1), this.state = State$1.DOCTYPE) : this._consumeSequenceIfMatch(SEQUENCES.CDATA_START, !0) ? this.inForeignNode ? this.state = State$1.CDATA_SECTION : (this._err(ERR.cdataInHtmlContent), this._createCommentToken(SEQUENCES.CDATA_START.length + 1), this.currentToken.data = "[CDATA[", this.state = State$1.BOGUS_COMMENT) : this._ensureHibernation() || (this._err(ERR.incorrectlyOpenedComment), this._createCommentToken(2), this.state = State$1.BOGUS_COMMENT, this._stateBogusComment(ue));
  }
  // Comment start state
  //------------------------------------------------------------------
  _stateCommentStart(ue) {
    switch (ue) {
      case CODE_POINTS.HYPHEN_MINUS: {
        this.state = State$1.COMMENT_START_DASH;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(ERR.abruptClosingOfEmptyComment), this.state = State$1.DATA;
        const Qe = this.currentToken;
        this.emitCurrentComment(Qe);
        break;
      }
      default:
        this.state = State$1.COMMENT, this._stateComment(ue);
    }
  }
  // Comment start dash state
  //------------------------------------------------------------------
  _stateCommentStartDash(ue) {
    const Qe = this.currentToken;
    switch (ue) {
      case CODE_POINTS.HYPHEN_MINUS: {
        this.state = State$1.COMMENT_END;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(ERR.abruptClosingOfEmptyComment), this.state = State$1.DATA, this.emitCurrentComment(Qe);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInComment), this.emitCurrentComment(Qe), this._emitEOFToken();
        break;
      }
      default:
        Qe.data += "-", this.state = State$1.COMMENT, this._stateComment(ue);
    }
  }
  // Comment state
  //------------------------------------------------------------------
  _stateComment(ue) {
    const Qe = this.currentToken;
    switch (ue) {
      case CODE_POINTS.HYPHEN_MINUS: {
        this.state = State$1.COMMENT_END_DASH;
        break;
      }
      case CODE_POINTS.LESS_THAN_SIGN: {
        Qe.data += "<", this.state = State$1.COMMENT_LESS_THAN_SIGN;
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), Qe.data += REPLACEMENT_CHARACTER;
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInComment), this.emitCurrentComment(Qe), this._emitEOFToken();
        break;
      }
      default:
        Qe.data += String.fromCodePoint(ue);
    }
  }
  // Comment less-than sign state
  //------------------------------------------------------------------
  _stateCommentLessThanSign(ue) {
    const Qe = this.currentToken;
    switch (ue) {
      case CODE_POINTS.EXCLAMATION_MARK: {
        Qe.data += "!", this.state = State$1.COMMENT_LESS_THAN_SIGN_BANG;
        break;
      }
      case CODE_POINTS.LESS_THAN_SIGN: {
        Qe.data += "<";
        break;
      }
      default:
        this.state = State$1.COMMENT, this._stateComment(ue);
    }
  }
  // Comment less-than sign bang state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBang(ue) {
    ue === CODE_POINTS.HYPHEN_MINUS ? this.state = State$1.COMMENT_LESS_THAN_SIGN_BANG_DASH : (this.state = State$1.COMMENT, this._stateComment(ue));
  }
  // Comment less-than sign bang dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDash(ue) {
    ue === CODE_POINTS.HYPHEN_MINUS ? this.state = State$1.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH : (this.state = State$1.COMMENT_END_DASH, this._stateCommentEndDash(ue));
  }
  // Comment less-than sign bang dash dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDashDash(ue) {
    ue !== CODE_POINTS.GREATER_THAN_SIGN && ue !== CODE_POINTS.EOF && this._err(ERR.nestedComment), this.state = State$1.COMMENT_END, this._stateCommentEnd(ue);
  }
  // Comment end dash state
  //------------------------------------------------------------------
  _stateCommentEndDash(ue) {
    const Qe = this.currentToken;
    switch (ue) {
      case CODE_POINTS.HYPHEN_MINUS: {
        this.state = State$1.COMMENT_END;
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInComment), this.emitCurrentComment(Qe), this._emitEOFToken();
        break;
      }
      default:
        Qe.data += "-", this.state = State$1.COMMENT, this._stateComment(ue);
    }
  }
  // Comment end state
  //------------------------------------------------------------------
  _stateCommentEnd(ue) {
    const Qe = this.currentToken;
    switch (ue) {
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = State$1.DATA, this.emitCurrentComment(Qe);
        break;
      }
      case CODE_POINTS.EXCLAMATION_MARK: {
        this.state = State$1.COMMENT_END_BANG;
        break;
      }
      case CODE_POINTS.HYPHEN_MINUS: {
        Qe.data += "-";
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInComment), this.emitCurrentComment(Qe), this._emitEOFToken();
        break;
      }
      default:
        Qe.data += "--", this.state = State$1.COMMENT, this._stateComment(ue);
    }
  }
  // Comment end bang state
  //------------------------------------------------------------------
  _stateCommentEndBang(ue) {
    const Qe = this.currentToken;
    switch (ue) {
      case CODE_POINTS.HYPHEN_MINUS: {
        Qe.data += "--!", this.state = State$1.COMMENT_END_DASH;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(ERR.incorrectlyClosedComment), this.state = State$1.DATA, this.emitCurrentComment(Qe);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInComment), this.emitCurrentComment(Qe), this._emitEOFToken();
        break;
      }
      default:
        Qe.data += "--!", this.state = State$1.COMMENT, this._stateComment(ue);
    }
  }
  // DOCTYPE state
  //------------------------------------------------------------------
  _stateDoctype(ue) {
    switch (ue) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED: {
        this.state = State$1.BEFORE_DOCTYPE_NAME;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = State$1.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(ue);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInDoctype), this._createDoctypeToken(null);
        const Qe = this.currentToken;
        Qe.forceQuirks = !0, this.emitCurrentDoctype(Qe), this._emitEOFToken();
        break;
      }
      default:
        this._err(ERR.missingWhitespaceBeforeDoctypeName), this.state = State$1.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(ue);
    }
  }
  // Before DOCTYPE name state
  //------------------------------------------------------------------
  _stateBeforeDoctypeName(ue) {
    if (isAsciiUpper(ue))
      this._createDoctypeToken(String.fromCharCode(toAsciiLower(ue))), this.state = State$1.DOCTYPE_NAME;
    else
      switch (ue) {
        case CODE_POINTS.SPACE:
        case CODE_POINTS.LINE_FEED:
        case CODE_POINTS.TABULATION:
        case CODE_POINTS.FORM_FEED:
          break;
        case CODE_POINTS.NULL: {
          this._err(ERR.unexpectedNullCharacter), this._createDoctypeToken(REPLACEMENT_CHARACTER), this.state = State$1.DOCTYPE_NAME;
          break;
        }
        case CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(ERR.missingDoctypeName), this._createDoctypeToken(null);
          const Qe = this.currentToken;
          Qe.forceQuirks = !0, this.emitCurrentDoctype(Qe), this.state = State$1.DATA;
          break;
        }
        case CODE_POINTS.EOF: {
          this._err(ERR.eofInDoctype), this._createDoctypeToken(null);
          const Qe = this.currentToken;
          Qe.forceQuirks = !0, this.emitCurrentDoctype(Qe), this._emitEOFToken();
          break;
        }
        default:
          this._createDoctypeToken(String.fromCodePoint(ue)), this.state = State$1.DOCTYPE_NAME;
      }
  }
  // DOCTYPE name state
  //------------------------------------------------------------------
  _stateDoctypeName(ue) {
    const Qe = this.currentToken;
    switch (ue) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED: {
        this.state = State$1.AFTER_DOCTYPE_NAME;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = State$1.DATA, this.emitCurrentDoctype(Qe);
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), Qe.name += REPLACEMENT_CHARACTER;
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInDoctype), Qe.forceQuirks = !0, this.emitCurrentDoctype(Qe), this._emitEOFToken();
        break;
      }
      default:
        Qe.name += String.fromCodePoint(isAsciiUpper(ue) ? toAsciiLower(ue) : ue);
    }
  }
  // After DOCTYPE name state
  //------------------------------------------------------------------
  _stateAfterDoctypeName(ue) {
    const Qe = this.currentToken;
    switch (ue) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED:
        break;
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = State$1.DATA, this.emitCurrentDoctype(Qe);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInDoctype), Qe.forceQuirks = !0, this.emitCurrentDoctype(Qe), this._emitEOFToken();
        break;
      }
      default:
        this._consumeSequenceIfMatch(SEQUENCES.PUBLIC, !1) ? this.state = State$1.AFTER_DOCTYPE_PUBLIC_KEYWORD : this._consumeSequenceIfMatch(SEQUENCES.SYSTEM, !1) ? this.state = State$1.AFTER_DOCTYPE_SYSTEM_KEYWORD : this._ensureHibernation() || (this._err(ERR.invalidCharacterSequenceAfterDoctypeName), Qe.forceQuirks = !0, this.state = State$1.BOGUS_DOCTYPE, this._stateBogusDoctype(ue));
    }
  }
  // After DOCTYPE public keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicKeyword(ue) {
    const Qe = this.currentToken;
    switch (ue) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED: {
        this.state = State$1.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case CODE_POINTS.QUOTATION_MARK: {
        this._err(ERR.missingWhitespaceAfterDoctypePublicKeyword), Qe.publicId = "", this.state = State$1.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case CODE_POINTS.APOSTROPHE: {
        this._err(ERR.missingWhitespaceAfterDoctypePublicKeyword), Qe.publicId = "", this.state = State$1.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(ERR.missingDoctypePublicIdentifier), Qe.forceQuirks = !0, this.state = State$1.DATA, this.emitCurrentDoctype(Qe);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInDoctype), Qe.forceQuirks = !0, this.emitCurrentDoctype(Qe), this._emitEOFToken();
        break;
      }
      default:
        this._err(ERR.missingQuoteBeforeDoctypePublicIdentifier), Qe.forceQuirks = !0, this.state = State$1.BOGUS_DOCTYPE, this._stateBogusDoctype(ue);
    }
  }
  // Before DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypePublicIdentifier(ue) {
    const Qe = this.currentToken;
    switch (ue) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED:
        break;
      case CODE_POINTS.QUOTATION_MARK: {
        Qe.publicId = "", this.state = State$1.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case CODE_POINTS.APOSTROPHE: {
        Qe.publicId = "", this.state = State$1.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(ERR.missingDoctypePublicIdentifier), Qe.forceQuirks = !0, this.state = State$1.DATA, this.emitCurrentDoctype(Qe);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInDoctype), Qe.forceQuirks = !0, this.emitCurrentDoctype(Qe), this._emitEOFToken();
        break;
      }
      default:
        this._err(ERR.missingQuoteBeforeDoctypePublicIdentifier), Qe.forceQuirks = !0, this.state = State$1.BOGUS_DOCTYPE, this._stateBogusDoctype(ue);
    }
  }
  // DOCTYPE public identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierDoubleQuoted(ue) {
    const Qe = this.currentToken;
    switch (ue) {
      case CODE_POINTS.QUOTATION_MARK: {
        this.state = State$1.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), Qe.publicId += REPLACEMENT_CHARACTER;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(ERR.abruptDoctypePublicIdentifier), Qe.forceQuirks = !0, this.emitCurrentDoctype(Qe), this.state = State$1.DATA;
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInDoctype), Qe.forceQuirks = !0, this.emitCurrentDoctype(Qe), this._emitEOFToken();
        break;
      }
      default:
        Qe.publicId += String.fromCodePoint(ue);
    }
  }
  // DOCTYPE public identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierSingleQuoted(ue) {
    const Qe = this.currentToken;
    switch (ue) {
      case CODE_POINTS.APOSTROPHE: {
        this.state = State$1.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), Qe.publicId += REPLACEMENT_CHARACTER;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(ERR.abruptDoctypePublicIdentifier), Qe.forceQuirks = !0, this.emitCurrentDoctype(Qe), this.state = State$1.DATA;
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInDoctype), Qe.forceQuirks = !0, this.emitCurrentDoctype(Qe), this._emitEOFToken();
        break;
      }
      default:
        Qe.publicId += String.fromCodePoint(ue);
    }
  }
  // After DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicIdentifier(ue) {
    const Qe = this.currentToken;
    switch (ue) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED: {
        this.state = State$1.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = State$1.DATA, this.emitCurrentDoctype(Qe);
        break;
      }
      case CODE_POINTS.QUOTATION_MARK: {
        this._err(ERR.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), Qe.systemId = "", this.state = State$1.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case CODE_POINTS.APOSTROPHE: {
        this._err(ERR.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), Qe.systemId = "", this.state = State$1.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInDoctype), Qe.forceQuirks = !0, this.emitCurrentDoctype(Qe), this._emitEOFToken();
        break;
      }
      default:
        this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier), Qe.forceQuirks = !0, this.state = State$1.BOGUS_DOCTYPE, this._stateBogusDoctype(ue);
    }
  }
  // Between DOCTYPE public and system identifiers state
  //------------------------------------------------------------------
  _stateBetweenDoctypePublicAndSystemIdentifiers(ue) {
    const Qe = this.currentToken;
    switch (ue) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED:
        break;
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(Qe), this.state = State$1.DATA;
        break;
      }
      case CODE_POINTS.QUOTATION_MARK: {
        Qe.systemId = "", this.state = State$1.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case CODE_POINTS.APOSTROPHE: {
        Qe.systemId = "", this.state = State$1.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInDoctype), Qe.forceQuirks = !0, this.emitCurrentDoctype(Qe), this._emitEOFToken();
        break;
      }
      default:
        this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier), Qe.forceQuirks = !0, this.state = State$1.BOGUS_DOCTYPE, this._stateBogusDoctype(ue);
    }
  }
  // After DOCTYPE system keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemKeyword(ue) {
    const Qe = this.currentToken;
    switch (ue) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED: {
        this.state = State$1.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case CODE_POINTS.QUOTATION_MARK: {
        this._err(ERR.missingWhitespaceAfterDoctypeSystemKeyword), Qe.systemId = "", this.state = State$1.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case CODE_POINTS.APOSTROPHE: {
        this._err(ERR.missingWhitespaceAfterDoctypeSystemKeyword), Qe.systemId = "", this.state = State$1.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(ERR.missingDoctypeSystemIdentifier), Qe.forceQuirks = !0, this.state = State$1.DATA, this.emitCurrentDoctype(Qe);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInDoctype), Qe.forceQuirks = !0, this.emitCurrentDoctype(Qe), this._emitEOFToken();
        break;
      }
      default:
        this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier), Qe.forceQuirks = !0, this.state = State$1.BOGUS_DOCTYPE, this._stateBogusDoctype(ue);
    }
  }
  // Before DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypeSystemIdentifier(ue) {
    const Qe = this.currentToken;
    switch (ue) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED:
        break;
      case CODE_POINTS.QUOTATION_MARK: {
        Qe.systemId = "", this.state = State$1.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case CODE_POINTS.APOSTROPHE: {
        Qe.systemId = "", this.state = State$1.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(ERR.missingDoctypeSystemIdentifier), Qe.forceQuirks = !0, this.state = State$1.DATA, this.emitCurrentDoctype(Qe);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInDoctype), Qe.forceQuirks = !0, this.emitCurrentDoctype(Qe), this._emitEOFToken();
        break;
      }
      default:
        this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier), Qe.forceQuirks = !0, this.state = State$1.BOGUS_DOCTYPE, this._stateBogusDoctype(ue);
    }
  }
  // DOCTYPE system identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierDoubleQuoted(ue) {
    const Qe = this.currentToken;
    switch (ue) {
      case CODE_POINTS.QUOTATION_MARK: {
        this.state = State$1.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), Qe.systemId += REPLACEMENT_CHARACTER;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(ERR.abruptDoctypeSystemIdentifier), Qe.forceQuirks = !0, this.emitCurrentDoctype(Qe), this.state = State$1.DATA;
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInDoctype), Qe.forceQuirks = !0, this.emitCurrentDoctype(Qe), this._emitEOFToken();
        break;
      }
      default:
        Qe.systemId += String.fromCodePoint(ue);
    }
  }
  // DOCTYPE system identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierSingleQuoted(ue) {
    const Qe = this.currentToken;
    switch (ue) {
      case CODE_POINTS.APOSTROPHE: {
        this.state = State$1.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), Qe.systemId += REPLACEMENT_CHARACTER;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(ERR.abruptDoctypeSystemIdentifier), Qe.forceQuirks = !0, this.emitCurrentDoctype(Qe), this.state = State$1.DATA;
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInDoctype), Qe.forceQuirks = !0, this.emitCurrentDoctype(Qe), this._emitEOFToken();
        break;
      }
      default:
        Qe.systemId += String.fromCodePoint(ue);
    }
  }
  // After DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemIdentifier(ue) {
    const Qe = this.currentToken;
    switch (ue) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED:
        break;
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(Qe), this.state = State$1.DATA;
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInDoctype), Qe.forceQuirks = !0, this.emitCurrentDoctype(Qe), this._emitEOFToken();
        break;
      }
      default:
        this._err(ERR.unexpectedCharacterAfterDoctypeSystemIdentifier), this.state = State$1.BOGUS_DOCTYPE, this._stateBogusDoctype(ue);
    }
  }
  // Bogus DOCTYPE state
  //------------------------------------------------------------------
  _stateBogusDoctype(ue) {
    const Qe = this.currentToken;
    switch (ue) {
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(Qe), this.state = State$1.DATA;
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter);
        break;
      }
      case CODE_POINTS.EOF: {
        this.emitCurrentDoctype(Qe), this._emitEOFToken();
        break;
      }
    }
  }
  // CDATA section state
  //------------------------------------------------------------------
  _stateCdataSection(ue) {
    switch (ue) {
      case CODE_POINTS.RIGHT_SQUARE_BRACKET: {
        this.state = State$1.CDATA_SECTION_BRACKET;
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInCdata), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(ue);
    }
  }
  // CDATA section bracket state
  //------------------------------------------------------------------
  _stateCdataSectionBracket(ue) {
    ue === CODE_POINTS.RIGHT_SQUARE_BRACKET ? this.state = State$1.CDATA_SECTION_END : (this._emitChars("]"), this.state = State$1.CDATA_SECTION, this._stateCdataSection(ue));
  }
  // CDATA section end state
  //------------------------------------------------------------------
  _stateCdataSectionEnd(ue) {
    switch (ue) {
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = State$1.DATA;
        break;
      }
      case CODE_POINTS.RIGHT_SQUARE_BRACKET: {
        this._emitChars("]");
        break;
      }
      default:
        this._emitChars("]]"), this.state = State$1.CDATA_SECTION, this._stateCdataSection(ue);
    }
  }
  // Character reference state
  //------------------------------------------------------------------
  _stateCharacterReference(ue) {
    ue === CODE_POINTS.NUMBER_SIGN ? this.state = State$1.NUMERIC_CHARACTER_REFERENCE : isAsciiAlphaNumeric(ue) ? (this.state = State$1.NAMED_CHARACTER_REFERENCE, this._stateNamedCharacterReference(ue)) : (this._flushCodePointConsumedAsCharacterReference(CODE_POINTS.AMPERSAND), this._reconsumeInState(this.returnState, ue));
  }
  // Named character reference state
  //------------------------------------------------------------------
  _stateNamedCharacterReference(ue) {
    const Qe = this._matchNamedCharacterReference(ue);
    if (!this._ensureHibernation()) if (Qe) {
      for (let Ue = 0; Ue < Qe.length; Ue++)
        this._flushCodePointConsumedAsCharacterReference(Qe[Ue]);
      this.state = this.returnState;
    } else
      this._flushCodePointConsumedAsCharacterReference(CODE_POINTS.AMPERSAND), this.state = State$1.AMBIGUOUS_AMPERSAND;
  }
  // Ambiguos ampersand state
  //------------------------------------------------------------------
  _stateAmbiguousAmpersand(ue) {
    isAsciiAlphaNumeric(ue) ? this._flushCodePointConsumedAsCharacterReference(ue) : (ue === CODE_POINTS.SEMICOLON && this._err(ERR.unknownNamedCharacterReference), this._reconsumeInState(this.returnState, ue));
  }
  // Numeric character reference state
  //------------------------------------------------------------------
  _stateNumericCharacterReference(ue) {
    this.charRefCode = 0, ue === CODE_POINTS.LATIN_SMALL_X || ue === CODE_POINTS.LATIN_CAPITAL_X ? this.state = State$1.HEXADEMICAL_CHARACTER_REFERENCE_START : isAsciiDigit(ue) ? (this.state = State$1.DECIMAL_CHARACTER_REFERENCE, this._stateDecimalCharacterReference(ue)) : (this._err(ERR.absenceOfDigitsInNumericCharacterReference), this._flushCodePointConsumedAsCharacterReference(CODE_POINTS.AMPERSAND), this._flushCodePointConsumedAsCharacterReference(CODE_POINTS.NUMBER_SIGN), this._reconsumeInState(this.returnState, ue));
  }
  // Hexademical character reference start state
  //------------------------------------------------------------------
  _stateHexademicalCharacterReferenceStart(ue) {
    isAsciiHexDigit(ue) ? (this.state = State$1.HEXADEMICAL_CHARACTER_REFERENCE, this._stateHexademicalCharacterReference(ue)) : (this._err(ERR.absenceOfDigitsInNumericCharacterReference), this._flushCodePointConsumedAsCharacterReference(CODE_POINTS.AMPERSAND), this._flushCodePointConsumedAsCharacterReference(CODE_POINTS.NUMBER_SIGN), this._unconsume(2), this.state = this.returnState);
  }
  // Hexademical character reference state
  //------------------------------------------------------------------
  _stateHexademicalCharacterReference(ue) {
    isAsciiUpperHexDigit(ue) ? this.charRefCode = this.charRefCode * 16 + ue - 55 : isAsciiLowerHexDigit(ue) ? this.charRefCode = this.charRefCode * 16 + ue - 87 : isAsciiDigit(ue) ? this.charRefCode = this.charRefCode * 16 + ue - 48 : ue === CODE_POINTS.SEMICOLON ? this.state = State$1.NUMERIC_CHARACTER_REFERENCE_END : (this._err(ERR.missingSemicolonAfterCharacterReference), this.state = State$1.NUMERIC_CHARACTER_REFERENCE_END, this._stateNumericCharacterReferenceEnd(ue));
  }
  // Decimal character reference state
  //------------------------------------------------------------------
  _stateDecimalCharacterReference(ue) {
    isAsciiDigit(ue) ? this.charRefCode = this.charRefCode * 10 + ue - 48 : ue === CODE_POINTS.SEMICOLON ? this.state = State$1.NUMERIC_CHARACTER_REFERENCE_END : (this._err(ERR.missingSemicolonAfterCharacterReference), this.state = State$1.NUMERIC_CHARACTER_REFERENCE_END, this._stateNumericCharacterReferenceEnd(ue));
  }
  // Numeric character reference end state
  //------------------------------------------------------------------
  _stateNumericCharacterReferenceEnd(ue) {
    if (this.charRefCode === CODE_POINTS.NULL)
      this._err(ERR.nullCharacterReference), this.charRefCode = CODE_POINTS.REPLACEMENT_CHARACTER;
    else if (this.charRefCode > 1114111)
      this._err(ERR.characterReferenceOutsideUnicodeRange), this.charRefCode = CODE_POINTS.REPLACEMENT_CHARACTER;
    else if (isSurrogate(this.charRefCode))
      this._err(ERR.surrogateCharacterReference), this.charRefCode = CODE_POINTS.REPLACEMENT_CHARACTER;
    else if (isUndefinedCodePoint(this.charRefCode))
      this._err(ERR.noncharacterCharacterReference);
    else if (isControlCodePoint(this.charRefCode) || this.charRefCode === CODE_POINTS.CARRIAGE_RETURN) {
      this._err(ERR.controlCharacterReference);
      const Qe = C1_CONTROLS_REFERENCE_REPLACEMENTS.get(this.charRefCode);
      Qe !== void 0 && (this.charRefCode = Qe);
    }
    this._flushCodePointConsumedAsCharacterReference(this.charRefCode), this._reconsumeInState(this.returnState, ue);
  }
}
const IMPLICIT_END_TAG_REQUIRED = /* @__PURE__ */ new Set([TAG_ID.DD, TAG_ID.DT, TAG_ID.LI, TAG_ID.OPTGROUP, TAG_ID.OPTION, TAG_ID.P, TAG_ID.RB, TAG_ID.RP, TAG_ID.RT, TAG_ID.RTC]), IMPLICIT_END_TAG_REQUIRED_THOROUGHLY = /* @__PURE__ */ new Set([
  ...IMPLICIT_END_TAG_REQUIRED,
  TAG_ID.CAPTION,
  TAG_ID.COLGROUP,
  TAG_ID.TBODY,
  TAG_ID.TD,
  TAG_ID.TFOOT,
  TAG_ID.TH,
  TAG_ID.THEAD,
  TAG_ID.TR
]), SCOPING_ELEMENT_NS = /* @__PURE__ */ new Map([
  [TAG_ID.APPLET, NS.HTML],
  [TAG_ID.CAPTION, NS.HTML],
  [TAG_ID.HTML, NS.HTML],
  [TAG_ID.MARQUEE, NS.HTML],
  [TAG_ID.OBJECT, NS.HTML],
  [TAG_ID.TABLE, NS.HTML],
  [TAG_ID.TD, NS.HTML],
  [TAG_ID.TEMPLATE, NS.HTML],
  [TAG_ID.TH, NS.HTML],
  [TAG_ID.ANNOTATION_XML, NS.MATHML],
  [TAG_ID.MI, NS.MATHML],
  [TAG_ID.MN, NS.MATHML],
  [TAG_ID.MO, NS.MATHML],
  [TAG_ID.MS, NS.MATHML],
  [TAG_ID.MTEXT, NS.MATHML],
  [TAG_ID.DESC, NS.SVG],
  [TAG_ID.FOREIGN_OBJECT, NS.SVG],
  [TAG_ID.TITLE, NS.SVG]
]), NAMED_HEADERS = [TAG_ID.H1, TAG_ID.H2, TAG_ID.H3, TAG_ID.H4, TAG_ID.H5, TAG_ID.H6], TABLE_ROW_CONTEXT = [TAG_ID.TR, TAG_ID.TEMPLATE, TAG_ID.HTML], TABLE_BODY_CONTEXT = [TAG_ID.TBODY, TAG_ID.TFOOT, TAG_ID.THEAD, TAG_ID.TEMPLATE, TAG_ID.HTML], TABLE_CONTEXT = [TAG_ID.TABLE, TAG_ID.TEMPLATE, TAG_ID.HTML], TABLE_CELLS = [TAG_ID.TD, TAG_ID.TH];
class OpenElementStack {
  get currentTmplContentOrNode() {
    return this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : this.current;
  }
  constructor(ue, Qe, Ue) {
    this.treeAdapter = Qe, this.handler = Ue, this.items = [], this.tagIDs = [], this.stackTop = -1, this.tmplCount = 0, this.currentTagId = TAG_ID.UNKNOWN, this.current = ue;
  }
  //Index of element
  _indexOf(ue) {
    return this.items.lastIndexOf(ue, this.stackTop);
  }
  //Update current element
  _isInTemplate() {
    return this.currentTagId === TAG_ID.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === NS.HTML;
  }
  _updateCurrentElement() {
    this.current = this.items[this.stackTop], this.currentTagId = this.tagIDs[this.stackTop];
  }
  //Mutations
  push(ue, Qe) {
    this.stackTop++, this.items[this.stackTop] = ue, this.current = ue, this.tagIDs[this.stackTop] = Qe, this.currentTagId = Qe, this._isInTemplate() && this.tmplCount++, this.handler.onItemPush(ue, Qe, !0);
  }
  pop() {
    const ue = this.current;
    this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(ue, !0);
  }
  replace(ue, Qe) {
    const Ue = this._indexOf(ue);
    this.items[Ue] = Qe, Ue === this.stackTop && (this.current = Qe);
  }
  insertAfter(ue, Qe, Ue) {
    const He = this._indexOf(ue) + 1;
    this.items.splice(He, 0, Qe), this.tagIDs.splice(He, 0, Ue), this.stackTop++, He === this.stackTop && this._updateCurrentElement(), this.handler.onItemPush(this.current, this.currentTagId, He === this.stackTop);
  }
  popUntilTagNamePopped(ue) {
    let Qe = this.stackTop + 1;
    do
      Qe = this.tagIDs.lastIndexOf(ue, Qe - 1);
    while (Qe > 0 && this.treeAdapter.getNamespaceURI(this.items[Qe]) !== NS.HTML);
    this.shortenToLength(Qe < 0 ? 0 : Qe);
  }
  shortenToLength(ue) {
    for (; this.stackTop >= ue; ) {
      const Qe = this.current;
      this.tmplCount > 0 && this._isInTemplate() && (this.tmplCount -= 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(Qe, this.stackTop < ue);
    }
  }
  popUntilElementPopped(ue) {
    const Qe = this._indexOf(ue);
    this.shortenToLength(Qe < 0 ? 0 : Qe);
  }
  popUntilPopped(ue, Qe) {
    const Ue = this._indexOfTagNames(ue, Qe);
    this.shortenToLength(Ue < 0 ? 0 : Ue);
  }
  popUntilNumberedHeaderPopped() {
    this.popUntilPopped(NAMED_HEADERS, NS.HTML);
  }
  popUntilTableCellPopped() {
    this.popUntilPopped(TABLE_CELLS, NS.HTML);
  }
  popAllUpToHtmlElement() {
    this.tmplCount = 0, this.shortenToLength(1);
  }
  _indexOfTagNames(ue, Qe) {
    for (let Ue = this.stackTop; Ue >= 0; Ue--)
      if (ue.includes(this.tagIDs[Ue]) && this.treeAdapter.getNamespaceURI(this.items[Ue]) === Qe)
        return Ue;
    return -1;
  }
  clearBackTo(ue, Qe) {
    const Ue = this._indexOfTagNames(ue, Qe);
    this.shortenToLength(Ue + 1);
  }
  clearBackToTableContext() {
    this.clearBackTo(TABLE_CONTEXT, NS.HTML);
  }
  clearBackToTableBodyContext() {
    this.clearBackTo(TABLE_BODY_CONTEXT, NS.HTML);
  }
  clearBackToTableRowContext() {
    this.clearBackTo(TABLE_ROW_CONTEXT, NS.HTML);
  }
  remove(ue) {
    const Qe = this._indexOf(ue);
    Qe >= 0 && (Qe === this.stackTop ? this.pop() : (this.items.splice(Qe, 1), this.tagIDs.splice(Qe, 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(ue, !1)));
  }
  //Search
  tryPeekProperlyNestedBodyElement() {
    return this.stackTop >= 1 && this.tagIDs[1] === TAG_ID.BODY ? this.items[1] : null;
  }
  contains(ue) {
    return this._indexOf(ue) > -1;
  }
  getCommonAncestor(ue) {
    const Qe = this._indexOf(ue) - 1;
    return Qe >= 0 ? this.items[Qe] : null;
  }
  isRootHtmlElementCurrent() {
    return this.stackTop === 0 && this.tagIDs[0] === TAG_ID.HTML;
  }
  //Element in scope
  hasInScope(ue) {
    for (let Qe = this.stackTop; Qe >= 0; Qe--) {
      const Ue = this.tagIDs[Qe], He = this.treeAdapter.getNamespaceURI(this.items[Qe]);
      if (Ue === ue && He === NS.HTML)
        return !0;
      if (SCOPING_ELEMENT_NS.get(Ue) === He)
        return !1;
    }
    return !0;
  }
  hasNumberedHeaderInScope() {
    for (let ue = this.stackTop; ue >= 0; ue--) {
      const Qe = this.tagIDs[ue], Ue = this.treeAdapter.getNamespaceURI(this.items[ue]);
      if (isNumberedHeader(Qe) && Ue === NS.HTML)
        return !0;
      if (SCOPING_ELEMENT_NS.get(Qe) === Ue)
        return !1;
    }
    return !0;
  }
  hasInListItemScope(ue) {
    for (let Qe = this.stackTop; Qe >= 0; Qe--) {
      const Ue = this.tagIDs[Qe], He = this.treeAdapter.getNamespaceURI(this.items[Qe]);
      if (Ue === ue && He === NS.HTML)
        return !0;
      if ((Ue === TAG_ID.UL || Ue === TAG_ID.OL) && He === NS.HTML || SCOPING_ELEMENT_NS.get(Ue) === He)
        return !1;
    }
    return !0;
  }
  hasInButtonScope(ue) {
    for (let Qe = this.stackTop; Qe >= 0; Qe--) {
      const Ue = this.tagIDs[Qe], He = this.treeAdapter.getNamespaceURI(this.items[Qe]);
      if (Ue === ue && He === NS.HTML)
        return !0;
      if (Ue === TAG_ID.BUTTON && He === NS.HTML || SCOPING_ELEMENT_NS.get(Ue) === He)
        return !1;
    }
    return !0;
  }
  hasInTableScope(ue) {
    for (let Qe = this.stackTop; Qe >= 0; Qe--) {
      const Ue = this.tagIDs[Qe];
      if (this.treeAdapter.getNamespaceURI(this.items[Qe]) === NS.HTML) {
        if (Ue === ue)
          return !0;
        if (Ue === TAG_ID.TABLE || Ue === TAG_ID.TEMPLATE || Ue === TAG_ID.HTML)
          return !1;
      }
    }
    return !0;
  }
  hasTableBodyContextInTableScope() {
    for (let ue = this.stackTop; ue >= 0; ue--) {
      const Qe = this.tagIDs[ue];
      if (this.treeAdapter.getNamespaceURI(this.items[ue]) === NS.HTML) {
        if (Qe === TAG_ID.TBODY || Qe === TAG_ID.THEAD || Qe === TAG_ID.TFOOT)
          return !0;
        if (Qe === TAG_ID.TABLE || Qe === TAG_ID.HTML)
          return !1;
      }
    }
    return !0;
  }
  hasInSelectScope(ue) {
    for (let Qe = this.stackTop; Qe >= 0; Qe--) {
      const Ue = this.tagIDs[Qe];
      if (this.treeAdapter.getNamespaceURI(this.items[Qe]) === NS.HTML) {
        if (Ue === ue)
          return !0;
        if (Ue !== TAG_ID.OPTION && Ue !== TAG_ID.OPTGROUP)
          return !1;
      }
    }
    return !0;
  }
  //Implied end tags
  generateImpliedEndTags() {
    for (; IMPLICIT_END_TAG_REQUIRED.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsThoroughly() {
    for (; IMPLICIT_END_TAG_REQUIRED_THOROUGHLY.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsWithExclusion(ue) {
    for (; this.currentTagId !== ue && IMPLICIT_END_TAG_REQUIRED_THOROUGHLY.has(this.currentTagId); )
      this.pop();
  }
}
const NOAH_ARK_CAPACITY = 3;
var EntryType;
(function(me) {
  me[me.Marker = 0] = "Marker", me[me.Element = 1] = "Element";
})(EntryType = EntryType || (EntryType = {}));
const MARKER = { type: EntryType.Marker };
class FormattingElementList {
  constructor(ue) {
    this.treeAdapter = ue, this.entries = [], this.bookmark = null;
  }
  //Noah Ark's condition
  //OPTIMIZATION: at first we try to find possible candidates for exclusion using
  //lightweight heuristics without thorough attributes check.
  _getNoahArkConditionCandidates(ue, Qe) {
    const Ue = [], He = Qe.length, Ge = this.treeAdapter.getTagName(ue), Xe = this.treeAdapter.getNamespaceURI(ue);
    for (let Ke = 0; Ke < this.entries.length; Ke++) {
      const $e = this.entries[Ke];
      if ($e.type === EntryType.Marker)
        break;
      const { element: Je } = $e;
      if (this.treeAdapter.getTagName(Je) === Ge && this.treeAdapter.getNamespaceURI(Je) === Xe) {
        const Ze = this.treeAdapter.getAttrList(Je);
        Ze.length === He && Ue.push({ idx: Ke, attrs: Ze });
      }
    }
    return Ue;
  }
  _ensureNoahArkCondition(ue) {
    if (this.entries.length < NOAH_ARK_CAPACITY)
      return;
    const Qe = this.treeAdapter.getAttrList(ue), Ue = this._getNoahArkConditionCandidates(ue, Qe);
    if (Ue.length < NOAH_ARK_CAPACITY)
      return;
    const He = new Map(Qe.map((Xe) => [Xe.name, Xe.value]));
    let Ge = 0;
    for (let Xe = 0; Xe < Ue.length; Xe++) {
      const Ke = Ue[Xe];
      Ke.attrs.every(($e) => He.get($e.name) === $e.value) && (Ge += 1, Ge >= NOAH_ARK_CAPACITY && this.entries.splice(Ke.idx, 1));
    }
  }
  //Mutations
  insertMarker() {
    this.entries.unshift(MARKER);
  }
  pushElement(ue, Qe) {
    this._ensureNoahArkCondition(ue), this.entries.unshift({
      type: EntryType.Element,
      element: ue,
      token: Qe
    });
  }
  insertElementAfterBookmark(ue, Qe) {
    const Ue = this.entries.indexOf(this.bookmark);
    this.entries.splice(Ue, 0, {
      type: EntryType.Element,
      element: ue,
      token: Qe
    });
  }
  removeEntry(ue) {
    const Qe = this.entries.indexOf(ue);
    Qe >= 0 && this.entries.splice(Qe, 1);
  }
  /**
   * Clears the list of formatting elements up to the last marker.
   *
   * @see https://html.spec.whatwg.org/multipage/parsing.html#clear-the-list-of-active-formatting-elements-up-to-the-last-marker
   */
  clearToLastMarker() {
    const ue = this.entries.indexOf(MARKER);
    ue >= 0 ? this.entries.splice(0, ue + 1) : this.entries.length = 0;
  }
  //Search
  getElementEntryInScopeWithTagName(ue) {
    const Qe = this.entries.find((Ue) => Ue.type === EntryType.Marker || this.treeAdapter.getTagName(Ue.element) === ue);
    return Qe && Qe.type === EntryType.Element ? Qe : null;
  }
  getElementEntry(ue) {
    return this.entries.find((Qe) => Qe.type === EntryType.Element && Qe.element === ue);
  }
}
function createTextNode(me) {
  return {
    nodeName: "#text",
    value: me,
    parentNode: null
  };
}
const defaultTreeAdapter = {
  //Node construction
  createDocument() {
    return {
      nodeName: "#document",
      mode: DOCUMENT_MODE.NO_QUIRKS,
      childNodes: []
    };
  },
  createDocumentFragment() {
    return {
      nodeName: "#document-fragment",
      childNodes: []
    };
  },
  createElement(me, ue, Qe) {
    return {
      nodeName: me,
      tagName: me,
      attrs: Qe,
      namespaceURI: ue,
      childNodes: [],
      parentNode: null
    };
  },
  createCommentNode(me) {
    return {
      nodeName: "#comment",
      data: me,
      parentNode: null
    };
  },
  //Tree mutation
  appendChild(me, ue) {
    me.childNodes.push(ue), ue.parentNode = me;
  },
  insertBefore(me, ue, Qe) {
    const Ue = me.childNodes.indexOf(Qe);
    me.childNodes.splice(Ue, 0, ue), ue.parentNode = me;
  },
  setTemplateContent(me, ue) {
    me.content = ue;
  },
  getTemplateContent(me) {
    return me.content;
  },
  setDocumentType(me, ue, Qe, Ue) {
    const He = me.childNodes.find((Ge) => Ge.nodeName === "#documentType");
    if (He)
      He.name = ue, He.publicId = Qe, He.systemId = Ue;
    else {
      const Ge = {
        nodeName: "#documentType",
        name: ue,
        publicId: Qe,
        systemId: Ue,
        parentNode: null
      };
      defaultTreeAdapter.appendChild(me, Ge);
    }
  },
  setDocumentMode(me, ue) {
    me.mode = ue;
  },
  getDocumentMode(me) {
    return me.mode;
  },
  detachNode(me) {
    if (me.parentNode) {
      const ue = me.parentNode.childNodes.indexOf(me);
      me.parentNode.childNodes.splice(ue, 1), me.parentNode = null;
    }
  },
  insertText(me, ue) {
    if (me.childNodes.length > 0) {
      const Qe = me.childNodes[me.childNodes.length - 1];
      if (defaultTreeAdapter.isTextNode(Qe)) {
        Qe.value += ue;
        return;
      }
    }
    defaultTreeAdapter.appendChild(me, createTextNode(ue));
  },
  insertTextBefore(me, ue, Qe) {
    const Ue = me.childNodes[me.childNodes.indexOf(Qe) - 1];
    Ue && defaultTreeAdapter.isTextNode(Ue) ? Ue.value += ue : defaultTreeAdapter.insertBefore(me, createTextNode(ue), Qe);
  },
  adoptAttributes(me, ue) {
    const Qe = new Set(me.attrs.map((Ue) => Ue.name));
    for (let Ue = 0; Ue < ue.length; Ue++)
      Qe.has(ue[Ue].name) || me.attrs.push(ue[Ue]);
  },
  //Tree traversing
  getFirstChild(me) {
    return me.childNodes[0];
  },
  getChildNodes(me) {
    return me.childNodes;
  },
  getParentNode(me) {
    return me.parentNode;
  },
  getAttrList(me) {
    return me.attrs;
  },
  //Node data
  getTagName(me) {
    return me.tagName;
  },
  getNamespaceURI(me) {
    return me.namespaceURI;
  },
  getTextNodeContent(me) {
    return me.value;
  },
  getCommentNodeContent(me) {
    return me.data;
  },
  getDocumentTypeNodeName(me) {
    return me.name;
  },
  getDocumentTypeNodePublicId(me) {
    return me.publicId;
  },
  getDocumentTypeNodeSystemId(me) {
    return me.systemId;
  },
  //Node types
  isTextNode(me) {
    return me.nodeName === "#text";
  },
  isCommentNode(me) {
    return me.nodeName === "#comment";
  },
  isDocumentTypeNode(me) {
    return me.nodeName === "#documentType";
  },
  isElementNode(me) {
    return Object.prototype.hasOwnProperty.call(me, "tagName");
  },
  // Source code location
  setNodeSourceCodeLocation(me, ue) {
    me.sourceCodeLocation = ue;
  },
  getNodeSourceCodeLocation(me) {
    return me.sourceCodeLocation;
  },
  updateNodeSourceCodeLocation(me, ue) {
    me.sourceCodeLocation = { ...me.sourceCodeLocation, ...ue };
  }
}, VALID_DOCTYPE_NAME = "html", VALID_SYSTEM_ID = "about:legacy-compat", QUIRKS_MODE_SYSTEM_ID = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", QUIRKS_MODE_PUBLIC_ID_PREFIXES = [
  "+//silmaril//dtd html pro v0r11 19970101//",
  "-//as//dtd html 3.0 aswedit + extensions//",
  "-//advasoft ltd//dtd html 3.0 aswedit + extensions//",
  "-//ietf//dtd html 2.0 level 1//",
  "-//ietf//dtd html 2.0 level 2//",
  "-//ietf//dtd html 2.0 strict level 1//",
  "-//ietf//dtd html 2.0 strict level 2//",
  "-//ietf//dtd html 2.0 strict//",
  "-//ietf//dtd html 2.0//",
  "-//ietf//dtd html 2.1e//",
  "-//ietf//dtd html 3.0//",
  "-//ietf//dtd html 3.2 final//",
  "-//ietf//dtd html 3.2//",
  "-//ietf//dtd html 3//",
  "-//ietf//dtd html level 0//",
  "-//ietf//dtd html level 1//",
  "-//ietf//dtd html level 2//",
  "-//ietf//dtd html level 3//",
  "-//ietf//dtd html strict level 0//",
  "-//ietf//dtd html strict level 1//",
  "-//ietf//dtd html strict level 2//",
  "-//ietf//dtd html strict level 3//",
  "-//ietf//dtd html strict//",
  "-//ietf//dtd html//",
  "-//metrius//dtd metrius presentational//",
  "-//microsoft//dtd internet explorer 2.0 html strict//",
  "-//microsoft//dtd internet explorer 2.0 html//",
  "-//microsoft//dtd internet explorer 2.0 tables//",
  "-//microsoft//dtd internet explorer 3.0 html strict//",
  "-//microsoft//dtd internet explorer 3.0 html//",
  "-//microsoft//dtd internet explorer 3.0 tables//",
  "-//netscape comm. corp.//dtd html//",
  "-//netscape comm. corp.//dtd strict html//",
  "-//o'reilly and associates//dtd html 2.0//",
  "-//o'reilly and associates//dtd html extended 1.0//",
  "-//o'reilly and associates//dtd html extended relaxed 1.0//",
  "-//sq//dtd html 2.0 hotmetal + extensions//",
  "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//",
  "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//",
  "-//spyglass//dtd html 2.0 extended//",
  "-//sun microsystems corp.//dtd hotjava html//",
  "-//sun microsystems corp.//dtd hotjava strict html//",
  "-//w3c//dtd html 3 1995-03-24//",
  "-//w3c//dtd html 3.2 draft//",
  "-//w3c//dtd html 3.2 final//",
  "-//w3c//dtd html 3.2//",
  "-//w3c//dtd html 3.2s draft//",
  "-//w3c//dtd html 4.0 frameset//",
  "-//w3c//dtd html 4.0 transitional//",
  "-//w3c//dtd html experimental 19960712//",
  "-//w3c//dtd html experimental 970421//",
  "-//w3c//dtd w3 html//",
  "-//w3o//dtd w3 html 3.0//",
  "-//webtechs//dtd mozilla html 2.0//",
  "-//webtechs//dtd mozilla html//"
], QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES = [
  ...QUIRKS_MODE_PUBLIC_ID_PREFIXES,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
], QUIRKS_MODE_PUBLIC_IDS = /* @__PURE__ */ new Set([
  "-//w3o//dtd w3 html strict 3.0//en//",
  "-/w3c/dtd html 4.0 transitional/en",
  "html"
]), LIMITED_QUIRKS_PUBLIC_ID_PREFIXES = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"], LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES = [
  ...LIMITED_QUIRKS_PUBLIC_ID_PREFIXES,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
];
function hasPrefix(me, ue) {
  return ue.some((Qe) => me.startsWith(Qe));
}
function isConforming(me) {
  return me.name === VALID_DOCTYPE_NAME && me.publicId === null && (me.systemId === null || me.systemId === VALID_SYSTEM_ID);
}
function getDocumentMode(me) {
  if (me.name !== VALID_DOCTYPE_NAME)
    return DOCUMENT_MODE.QUIRKS;
  const { systemId: ue } = me;
  if (ue && ue.toLowerCase() === QUIRKS_MODE_SYSTEM_ID)
    return DOCUMENT_MODE.QUIRKS;
  let { publicId: Qe } = me;
  if (Qe !== null) {
    if (Qe = Qe.toLowerCase(), QUIRKS_MODE_PUBLIC_IDS.has(Qe))
      return DOCUMENT_MODE.QUIRKS;
    let Ue = ue === null ? QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES : QUIRKS_MODE_PUBLIC_ID_PREFIXES;
    if (hasPrefix(Qe, Ue))
      return DOCUMENT_MODE.QUIRKS;
    if (Ue = ue === null ? LIMITED_QUIRKS_PUBLIC_ID_PREFIXES : LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES, hasPrefix(Qe, Ue))
      return DOCUMENT_MODE.LIMITED_QUIRKS;
  }
  return DOCUMENT_MODE.NO_QUIRKS;
}
const MIME_TYPES = {
  TEXT_HTML: "text/html",
  APPLICATION_XML: "application/xhtml+xml"
}, DEFINITION_URL_ATTR = "definitionurl", ADJUSTED_DEFINITION_URL_ATTR = "definitionURL", SVG_ATTRS_ADJUSTMENT_MAP = new Map([
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map((me) => [me.toLowerCase(), me])), XML_ATTRS_ADJUSTMENT_MAP = /* @__PURE__ */ new Map([
  ["xlink:actuate", { prefix: "xlink", name: "actuate", namespace: NS.XLINK }],
  ["xlink:arcrole", { prefix: "xlink", name: "arcrole", namespace: NS.XLINK }],
  ["xlink:href", { prefix: "xlink", name: "href", namespace: NS.XLINK }],
  ["xlink:role", { prefix: "xlink", name: "role", namespace: NS.XLINK }],
  ["xlink:show", { prefix: "xlink", name: "show", namespace: NS.XLINK }],
  ["xlink:title", { prefix: "xlink", name: "title", namespace: NS.XLINK }],
  ["xlink:type", { prefix: "xlink", name: "type", namespace: NS.XLINK }],
  ["xml:base", { prefix: "xml", name: "base", namespace: NS.XML }],
  ["xml:lang", { prefix: "xml", name: "lang", namespace: NS.XML }],
  ["xml:space", { prefix: "xml", name: "space", namespace: NS.XML }],
  ["xmlns", { prefix: "", name: "xmlns", namespace: NS.XMLNS }],
  ["xmlns:xlink", { prefix: "xmlns", name: "xlink", namespace: NS.XMLNS }]
]), SVG_TAG_NAMES_ADJUSTMENT_MAP = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map((me) => [me.toLowerCase(), me])), EXITS_FOREIGN_CONTENT = /* @__PURE__ */ new Set([
  TAG_ID.B,
  TAG_ID.BIG,
  TAG_ID.BLOCKQUOTE,
  TAG_ID.BODY,
  TAG_ID.BR,
  TAG_ID.CENTER,
  TAG_ID.CODE,
  TAG_ID.DD,
  TAG_ID.DIV,
  TAG_ID.DL,
  TAG_ID.DT,
  TAG_ID.EM,
  TAG_ID.EMBED,
  TAG_ID.H1,
  TAG_ID.H2,
  TAG_ID.H3,
  TAG_ID.H4,
  TAG_ID.H5,
  TAG_ID.H6,
  TAG_ID.HEAD,
  TAG_ID.HR,
  TAG_ID.I,
  TAG_ID.IMG,
  TAG_ID.LI,
  TAG_ID.LISTING,
  TAG_ID.MENU,
  TAG_ID.META,
  TAG_ID.NOBR,
  TAG_ID.OL,
  TAG_ID.P,
  TAG_ID.PRE,
  TAG_ID.RUBY,
  TAG_ID.S,
  TAG_ID.SMALL,
  TAG_ID.SPAN,
  TAG_ID.STRONG,
  TAG_ID.STRIKE,
  TAG_ID.SUB,
  TAG_ID.SUP,
  TAG_ID.TABLE,
  TAG_ID.TT,
  TAG_ID.U,
  TAG_ID.UL,
  TAG_ID.VAR
]);
function causesExit(me) {
  const ue = me.tagID;
  return ue === TAG_ID.FONT && me.attrs.some(({ name: Ue }) => Ue === ATTRS.COLOR || Ue === ATTRS.SIZE || Ue === ATTRS.FACE) || EXITS_FOREIGN_CONTENT.has(ue);
}
function adjustTokenMathMLAttrs(me) {
  for (let ue = 0; ue < me.attrs.length; ue++)
    if (me.attrs[ue].name === DEFINITION_URL_ATTR) {
      me.attrs[ue].name = ADJUSTED_DEFINITION_URL_ATTR;
      break;
    }
}
function adjustTokenSVGAttrs(me) {
  for (let ue = 0; ue < me.attrs.length; ue++) {
    const Qe = SVG_ATTRS_ADJUSTMENT_MAP.get(me.attrs[ue].name);
    Qe != null && (me.attrs[ue].name = Qe);
  }
}
function adjustTokenXMLAttrs(me) {
  for (let ue = 0; ue < me.attrs.length; ue++) {
    const Qe = XML_ATTRS_ADJUSTMENT_MAP.get(me.attrs[ue].name);
    Qe && (me.attrs[ue].prefix = Qe.prefix, me.attrs[ue].name = Qe.name, me.attrs[ue].namespace = Qe.namespace);
  }
}
function adjustTokenSVGTagName(me) {
  const ue = SVG_TAG_NAMES_ADJUSTMENT_MAP.get(me.tagName);
  ue != null && (me.tagName = ue, me.tagID = getTagID(me.tagName));
}
function isMathMLTextIntegrationPoint(me, ue) {
  return ue === NS.MATHML && (me === TAG_ID.MI || me === TAG_ID.MO || me === TAG_ID.MN || me === TAG_ID.MS || me === TAG_ID.MTEXT);
}
function isHtmlIntegrationPoint(me, ue, Qe) {
  if (ue === NS.MATHML && me === TAG_ID.ANNOTATION_XML) {
    for (let Ue = 0; Ue < Qe.length; Ue++)
      if (Qe[Ue].name === ATTRS.ENCODING) {
        const He = Qe[Ue].value.toLowerCase();
        return He === MIME_TYPES.TEXT_HTML || He === MIME_TYPES.APPLICATION_XML;
      }
  }
  return ue === NS.SVG && (me === TAG_ID.FOREIGN_OBJECT || me === TAG_ID.DESC || me === TAG_ID.TITLE);
}
function isIntegrationPoint(me, ue, Qe, Ue) {
  return (!Ue || Ue === NS.HTML) && isHtmlIntegrationPoint(me, ue, Qe) || (!Ue || Ue === NS.MATHML) && isMathMLTextIntegrationPoint(me, ue);
}
const HIDDEN_INPUT_TYPE = "hidden", AA_OUTER_LOOP_ITER = 8, AA_INNER_LOOP_ITER = 3;
var InsertionMode;
(function(me) {
  me[me.INITIAL = 0] = "INITIAL", me[me.BEFORE_HTML = 1] = "BEFORE_HTML", me[me.BEFORE_HEAD = 2] = "BEFORE_HEAD", me[me.IN_HEAD = 3] = "IN_HEAD", me[me.IN_HEAD_NO_SCRIPT = 4] = "IN_HEAD_NO_SCRIPT", me[me.AFTER_HEAD = 5] = "AFTER_HEAD", me[me.IN_BODY = 6] = "IN_BODY", me[me.TEXT = 7] = "TEXT", me[me.IN_TABLE = 8] = "IN_TABLE", me[me.IN_TABLE_TEXT = 9] = "IN_TABLE_TEXT", me[me.IN_CAPTION = 10] = "IN_CAPTION", me[me.IN_COLUMN_GROUP = 11] = "IN_COLUMN_GROUP", me[me.IN_TABLE_BODY = 12] = "IN_TABLE_BODY", me[me.IN_ROW = 13] = "IN_ROW", me[me.IN_CELL = 14] = "IN_CELL", me[me.IN_SELECT = 15] = "IN_SELECT", me[me.IN_SELECT_IN_TABLE = 16] = "IN_SELECT_IN_TABLE", me[me.IN_TEMPLATE = 17] = "IN_TEMPLATE", me[me.AFTER_BODY = 18] = "AFTER_BODY", me[me.IN_FRAMESET = 19] = "IN_FRAMESET", me[me.AFTER_FRAMESET = 20] = "AFTER_FRAMESET", me[me.AFTER_AFTER_BODY = 21] = "AFTER_AFTER_BODY", me[me.AFTER_AFTER_FRAMESET = 22] = "AFTER_AFTER_FRAMESET";
})(InsertionMode || (InsertionMode = {}));
const BASE_LOC = {
  startLine: -1,
  startCol: -1,
  startOffset: -1,
  endLine: -1,
  endCol: -1,
  endOffset: -1
}, TABLE_STRUCTURE_TAGS = /* @__PURE__ */ new Set([TAG_ID.TABLE, TAG_ID.TBODY, TAG_ID.TFOOT, TAG_ID.THEAD, TAG_ID.TR]), defaultParserOptions = {
  scriptingEnabled: !0,
  sourceCodeLocationInfo: !1,
  treeAdapter: defaultTreeAdapter,
  onParseError: null
};
class Parser {
  constructor(ue, Qe, Ue = null, He = null) {
    this.fragmentContext = Ue, this.scriptHandler = He, this.currentToken = null, this.stopped = !1, this.insertionMode = InsertionMode.INITIAL, this.originalInsertionMode = InsertionMode.INITIAL, this.headElement = null, this.formElement = null, this.currentNotInHTML = !1, this.tmplInsertionModeStack = [], this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1, this.options = {
      ...defaultParserOptions,
      ...ue
    }, this.treeAdapter = this.options.treeAdapter, this.onParseError = this.options.onParseError, this.onParseError && (this.options.sourceCodeLocationInfo = !0), this.document = Qe ?? this.treeAdapter.createDocument(), this.tokenizer = new Tokenizer(this.options, this), this.activeFormattingElements = new FormattingElementList(this.treeAdapter), this.fragmentContextID = Ue ? getTagID(this.treeAdapter.getTagName(Ue)) : TAG_ID.UNKNOWN, this._setContextModes(Ue ?? this.document, this.fragmentContextID), this.openElements = new OpenElementStack(this.document, this.treeAdapter, this);
  }
  // API
  static parse(ue, Qe) {
    const Ue = new this(Qe);
    return Ue.tokenizer.write(ue, !0), Ue.document;
  }
  static getFragmentParser(ue, Qe) {
    const Ue = {
      ...defaultParserOptions,
      ...Qe
    };
    ue ?? (ue = Ue.treeAdapter.createElement(TAG_NAMES.TEMPLATE, NS.HTML, []));
    const He = Ue.treeAdapter.createElement("documentmock", NS.HTML, []), Ge = new this(Ue, He, ue);
    return Ge.fragmentContextID === TAG_ID.TEMPLATE && Ge.tmplInsertionModeStack.unshift(InsertionMode.IN_TEMPLATE), Ge._initTokenizerForFragmentParsing(), Ge._insertFakeRootElement(), Ge._resetInsertionMode(), Ge._findFormInFragmentContext(), Ge;
  }
  getFragment() {
    const ue = this.treeAdapter.getFirstChild(this.document), Qe = this.treeAdapter.createDocumentFragment();
    return this._adoptNodes(ue, Qe), Qe;
  }
  //Errors
  _err(ue, Qe, Ue) {
    var He;
    if (!this.onParseError)
      return;
    const Ge = (He = ue.location) !== null && He !== void 0 ? He : BASE_LOC, Xe = {
      code: Qe,
      startLine: Ge.startLine,
      startCol: Ge.startCol,
      startOffset: Ge.startOffset,
      endLine: Ue ? Ge.startLine : Ge.endLine,
      endCol: Ue ? Ge.startCol : Ge.endCol,
      endOffset: Ue ? Ge.startOffset : Ge.endOffset
    };
    this.onParseError(Xe);
  }
  //Stack events
  onItemPush(ue, Qe, Ue) {
    var He, Ge;
    (Ge = (He = this.treeAdapter).onItemPush) === null || Ge === void 0 || Ge.call(He, ue), Ue && this.openElements.stackTop > 0 && this._setContextModes(ue, Qe);
  }
  onItemPop(ue, Qe) {
    var Ue, He;
    if (this.options.sourceCodeLocationInfo && this._setEndLocation(ue, this.currentToken), (He = (Ue = this.treeAdapter).onItemPop) === null || He === void 0 || He.call(Ue, ue, this.openElements.current), Qe) {
      let Ge, Xe;
      this.openElements.stackTop === 0 && this.fragmentContext ? (Ge = this.fragmentContext, Xe = this.fragmentContextID) : { current: Ge, currentTagId: Xe } = this.openElements, this._setContextModes(Ge, Xe);
    }
  }
  _setContextModes(ue, Qe) {
    const Ue = ue === this.document || this.treeAdapter.getNamespaceURI(ue) === NS.HTML;
    this.currentNotInHTML = !Ue, this.tokenizer.inForeignNode = !Ue && !this._isIntegrationPoint(Qe, ue);
  }
  _switchToTextParsing(ue, Qe) {
    this._insertElement(ue, NS.HTML), this.tokenizer.state = Qe, this.originalInsertionMode = this.insertionMode, this.insertionMode = InsertionMode.TEXT;
  }
  switchToPlaintextParsing() {
    this.insertionMode = InsertionMode.TEXT, this.originalInsertionMode = InsertionMode.IN_BODY, this.tokenizer.state = TokenizerMode.PLAINTEXT;
  }
  //Fragment parsing
  _getAdjustedCurrentElement() {
    return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
  }
  _findFormInFragmentContext() {
    let ue = this.fragmentContext;
    for (; ue; ) {
      if (this.treeAdapter.getTagName(ue) === TAG_NAMES.FORM) {
        this.formElement = ue;
        break;
      }
      ue = this.treeAdapter.getParentNode(ue);
    }
  }
  _initTokenizerForFragmentParsing() {
    if (!(!this.fragmentContext || this.treeAdapter.getNamespaceURI(this.fragmentContext) !== NS.HTML))
      switch (this.fragmentContextID) {
        case TAG_ID.TITLE:
        case TAG_ID.TEXTAREA: {
          this.tokenizer.state = TokenizerMode.RCDATA;
          break;
        }
        case TAG_ID.STYLE:
        case TAG_ID.XMP:
        case TAG_ID.IFRAME:
        case TAG_ID.NOEMBED:
        case TAG_ID.NOFRAMES:
        case TAG_ID.NOSCRIPT: {
          this.tokenizer.state = TokenizerMode.RAWTEXT;
          break;
        }
        case TAG_ID.SCRIPT: {
          this.tokenizer.state = TokenizerMode.SCRIPT_DATA;
          break;
        }
        case TAG_ID.PLAINTEXT: {
          this.tokenizer.state = TokenizerMode.PLAINTEXT;
          break;
        }
      }
  }
  //Tree mutation
  _setDocumentType(ue) {
    const Qe = ue.name || "", Ue = ue.publicId || "", He = ue.systemId || "";
    if (this.treeAdapter.setDocumentType(this.document, Qe, Ue, He), ue.location) {
      const Xe = this.treeAdapter.getChildNodes(this.document).find((Ke) => this.treeAdapter.isDocumentTypeNode(Ke));
      Xe && this.treeAdapter.setNodeSourceCodeLocation(Xe, ue.location);
    }
  }
  _attachElementToTree(ue, Qe) {
    if (this.options.sourceCodeLocationInfo) {
      const Ue = Qe && {
        ...Qe,
        startTag: Qe
      };
      this.treeAdapter.setNodeSourceCodeLocation(ue, Ue);
    }
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentElement(ue);
    else {
      const Ue = this.openElements.currentTmplContentOrNode;
      this.treeAdapter.appendChild(Ue, ue);
    }
  }
  _appendElement(ue, Qe) {
    const Ue = this.treeAdapter.createElement(ue.tagName, Qe, ue.attrs);
    this._attachElementToTree(Ue, ue.location);
  }
  _insertElement(ue, Qe) {
    const Ue = this.treeAdapter.createElement(ue.tagName, Qe, ue.attrs);
    this._attachElementToTree(Ue, ue.location), this.openElements.push(Ue, ue.tagID);
  }
  _insertFakeElement(ue, Qe) {
    const Ue = this.treeAdapter.createElement(ue, NS.HTML, []);
    this._attachElementToTree(Ue, null), this.openElements.push(Ue, Qe);
  }
  _insertTemplate(ue) {
    const Qe = this.treeAdapter.createElement(ue.tagName, NS.HTML, ue.attrs), Ue = this.treeAdapter.createDocumentFragment();
    this.treeAdapter.setTemplateContent(Qe, Ue), this._attachElementToTree(Qe, ue.location), this.openElements.push(Qe, ue.tagID), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(Ue, null);
  }
  _insertFakeRootElement() {
    const ue = this.treeAdapter.createElement(TAG_NAMES.HTML, NS.HTML, []);
    this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(ue, null), this.treeAdapter.appendChild(this.openElements.current, ue), this.openElements.push(ue, TAG_ID.HTML);
  }
  _appendCommentNode(ue, Qe) {
    const Ue = this.treeAdapter.createCommentNode(ue.data);
    this.treeAdapter.appendChild(Qe, Ue), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(Ue, ue.location);
  }
  _insertCharacters(ue) {
    let Qe, Ue;
    if (this._shouldFosterParentOnInsertion() ? ({ parent: Qe, beforeElement: Ue } = this._findFosterParentingLocation(), Ue ? this.treeAdapter.insertTextBefore(Qe, ue.chars, Ue) : this.treeAdapter.insertText(Qe, ue.chars)) : (Qe = this.openElements.currentTmplContentOrNode, this.treeAdapter.insertText(Qe, ue.chars)), !ue.location)
      return;
    const He = this.treeAdapter.getChildNodes(Qe), Ge = Ue ? He.lastIndexOf(Ue) : He.length, Xe = He[Ge - 1];
    if (this.treeAdapter.getNodeSourceCodeLocation(Xe)) {
      const { endLine: $e, endCol: Je, endOffset: Ze } = ue.location;
      this.treeAdapter.updateNodeSourceCodeLocation(Xe, { endLine: $e, endCol: Je, endOffset: Ze });
    } else this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(Xe, ue.location);
  }
  _adoptNodes(ue, Qe) {
    for (let Ue = this.treeAdapter.getFirstChild(ue); Ue; Ue = this.treeAdapter.getFirstChild(ue))
      this.treeAdapter.detachNode(Ue), this.treeAdapter.appendChild(Qe, Ue);
  }
  _setEndLocation(ue, Qe) {
    if (this.treeAdapter.getNodeSourceCodeLocation(ue) && Qe.location) {
      const Ue = Qe.location, He = this.treeAdapter.getTagName(ue), Ge = (
        // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
        // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
        Qe.type === TokenType.END_TAG && He === Qe.tagName ? {
          endTag: { ...Ue },
          endLine: Ue.endLine,
          endCol: Ue.endCol,
          endOffset: Ue.endOffset
        } : {
          endLine: Ue.startLine,
          endCol: Ue.startCol,
          endOffset: Ue.startOffset
        }
      );
      this.treeAdapter.updateNodeSourceCodeLocation(ue, Ge);
    }
  }
  //Token processing
  shouldProcessStartTagTokenInForeignContent(ue) {
    if (!this.currentNotInHTML)
      return !1;
    let Qe, Ue;
    return this.openElements.stackTop === 0 && this.fragmentContext ? (Qe = this.fragmentContext, Ue = this.fragmentContextID) : { current: Qe, currentTagId: Ue } = this.openElements, ue.tagID === TAG_ID.SVG && this.treeAdapter.getTagName(Qe) === TAG_NAMES.ANNOTATION_XML && this.treeAdapter.getNamespaceURI(Qe) === NS.MATHML ? !1 : (
      // Check that `current` is not an integration point for HTML or MathML elements.
      this.tokenizer.inForeignNode || // If it _is_ an integration point, then we might have to check that it is not an HTML
      // integration point.
      (ue.tagID === TAG_ID.MGLYPH || ue.tagID === TAG_ID.MALIGNMARK) && !this._isIntegrationPoint(Ue, Qe, NS.HTML)
    );
  }
  _processToken(ue) {
    switch (ue.type) {
      case TokenType.CHARACTER: {
        this.onCharacter(ue);
        break;
      }
      case TokenType.NULL_CHARACTER: {
        this.onNullCharacter(ue);
        break;
      }
      case TokenType.COMMENT: {
        this.onComment(ue);
        break;
      }
      case TokenType.DOCTYPE: {
        this.onDoctype(ue);
        break;
      }
      case TokenType.START_TAG: {
        this._processStartTag(ue);
        break;
      }
      case TokenType.END_TAG: {
        this.onEndTag(ue);
        break;
      }
      case TokenType.EOF: {
        this.onEof(ue);
        break;
      }
      case TokenType.WHITESPACE_CHARACTER: {
        this.onWhitespaceCharacter(ue);
        break;
      }
    }
  }
  //Integration points
  _isIntegrationPoint(ue, Qe, Ue) {
    const He = this.treeAdapter.getNamespaceURI(Qe), Ge = this.treeAdapter.getAttrList(Qe);
    return isIntegrationPoint(ue, He, Ge, Ue);
  }
  //Active formatting elements reconstruction
  _reconstructActiveFormattingElements() {
    const ue = this.activeFormattingElements.entries.length;
    if (ue) {
      const Qe = this.activeFormattingElements.entries.findIndex((He) => He.type === EntryType.Marker || this.openElements.contains(He.element)), Ue = Qe < 0 ? ue - 1 : Qe - 1;
      for (let He = Ue; He >= 0; He--) {
        const Ge = this.activeFormattingElements.entries[He];
        this._insertElement(Ge.token, this.treeAdapter.getNamespaceURI(Ge.element)), Ge.element = this.openElements.current;
      }
    }
  }
  //Close elements
  _closeTableCell() {
    this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = InsertionMode.IN_ROW;
  }
  _closePElement() {
    this.openElements.generateImpliedEndTagsWithExclusion(TAG_ID.P), this.openElements.popUntilTagNamePopped(TAG_ID.P);
  }
  //Insertion modes
  _resetInsertionMode() {
    for (let ue = this.openElements.stackTop; ue >= 0; ue--)
      switch (ue === 0 && this.fragmentContext ? this.fragmentContextID : this.openElements.tagIDs[ue]) {
        case TAG_ID.TR: {
          this.insertionMode = InsertionMode.IN_ROW;
          return;
        }
        case TAG_ID.TBODY:
        case TAG_ID.THEAD:
        case TAG_ID.TFOOT: {
          this.insertionMode = InsertionMode.IN_TABLE_BODY;
          return;
        }
        case TAG_ID.CAPTION: {
          this.insertionMode = InsertionMode.IN_CAPTION;
          return;
        }
        case TAG_ID.COLGROUP: {
          this.insertionMode = InsertionMode.IN_COLUMN_GROUP;
          return;
        }
        case TAG_ID.TABLE: {
          this.insertionMode = InsertionMode.IN_TABLE;
          return;
        }
        case TAG_ID.BODY: {
          this.insertionMode = InsertionMode.IN_BODY;
          return;
        }
        case TAG_ID.FRAMESET: {
          this.insertionMode = InsertionMode.IN_FRAMESET;
          return;
        }
        case TAG_ID.SELECT: {
          this._resetInsertionModeForSelect(ue);
          return;
        }
        case TAG_ID.TEMPLATE: {
          this.insertionMode = this.tmplInsertionModeStack[0];
          return;
        }
        case TAG_ID.HTML: {
          this.insertionMode = this.headElement ? InsertionMode.AFTER_HEAD : InsertionMode.BEFORE_HEAD;
          return;
        }
        case TAG_ID.TD:
        case TAG_ID.TH: {
          if (ue > 0) {
            this.insertionMode = InsertionMode.IN_CELL;
            return;
          }
          break;
        }
        case TAG_ID.HEAD: {
          if (ue > 0) {
            this.insertionMode = InsertionMode.IN_HEAD;
            return;
          }
          break;
        }
      }
    this.insertionMode = InsertionMode.IN_BODY;
  }
  _resetInsertionModeForSelect(ue) {
    if (ue > 0)
      for (let Qe = ue - 1; Qe > 0; Qe--) {
        const Ue = this.openElements.tagIDs[Qe];
        if (Ue === TAG_ID.TEMPLATE)
          break;
        if (Ue === TAG_ID.TABLE) {
          this.insertionMode = InsertionMode.IN_SELECT_IN_TABLE;
          return;
        }
      }
    this.insertionMode = InsertionMode.IN_SELECT;
  }
  //Foster parenting
  _isElementCausesFosterParenting(ue) {
    return TABLE_STRUCTURE_TAGS.has(ue);
  }
  _shouldFosterParentOnInsertion() {
    return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.currentTagId);
  }
  _findFosterParentingLocation() {
    for (let ue = this.openElements.stackTop; ue >= 0; ue--) {
      const Qe = this.openElements.items[ue];
      switch (this.openElements.tagIDs[ue]) {
        case TAG_ID.TEMPLATE: {
          if (this.treeAdapter.getNamespaceURI(Qe) === NS.HTML)
            return { parent: this.treeAdapter.getTemplateContent(Qe), beforeElement: null };
          break;
        }
        case TAG_ID.TABLE: {
          const Ue = this.treeAdapter.getParentNode(Qe);
          return Ue ? { parent: Ue, beforeElement: Qe } : { parent: this.openElements.items[ue - 1], beforeElement: null };
        }
      }
    }
    return { parent: this.openElements.items[0], beforeElement: null };
  }
  _fosterParentElement(ue) {
    const Qe = this._findFosterParentingLocation();
    Qe.beforeElement ? this.treeAdapter.insertBefore(Qe.parent, ue, Qe.beforeElement) : this.treeAdapter.appendChild(Qe.parent, ue);
  }
  //Special elements
  _isSpecialElement(ue, Qe) {
    const Ue = this.treeAdapter.getNamespaceURI(ue);
    return SPECIAL_ELEMENTS[Ue].has(Qe);
  }
  onCharacter(ue) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      characterInForeignContent(this, ue);
      return;
    }
    switch (this.insertionMode) {
      case InsertionMode.INITIAL: {
        tokenInInitialMode(this, ue);
        break;
      }
      case InsertionMode.BEFORE_HTML: {
        tokenBeforeHtml(this, ue);
        break;
      }
      case InsertionMode.BEFORE_HEAD: {
        tokenBeforeHead(this, ue);
        break;
      }
      case InsertionMode.IN_HEAD: {
        tokenInHead(this, ue);
        break;
      }
      case InsertionMode.IN_HEAD_NO_SCRIPT: {
        tokenInHeadNoScript(this, ue);
        break;
      }
      case InsertionMode.AFTER_HEAD: {
        tokenAfterHead(this, ue);
        break;
      }
      case InsertionMode.IN_BODY:
      case InsertionMode.IN_CAPTION:
      case InsertionMode.IN_CELL:
      case InsertionMode.IN_TEMPLATE: {
        characterInBody(this, ue);
        break;
      }
      case InsertionMode.TEXT:
      case InsertionMode.IN_SELECT:
      case InsertionMode.IN_SELECT_IN_TABLE: {
        this._insertCharacters(ue);
        break;
      }
      case InsertionMode.IN_TABLE:
      case InsertionMode.IN_TABLE_BODY:
      case InsertionMode.IN_ROW: {
        characterInTable(this, ue);
        break;
      }
      case InsertionMode.IN_TABLE_TEXT: {
        characterInTableText(this, ue);
        break;
      }
      case InsertionMode.IN_COLUMN_GROUP: {
        tokenInColumnGroup(this, ue);
        break;
      }
      case InsertionMode.AFTER_BODY: {
        tokenAfterBody(this, ue);
        break;
      }
      case InsertionMode.AFTER_AFTER_BODY: {
        tokenAfterAfterBody(this, ue);
        break;
      }
    }
  }
  onNullCharacter(ue) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      nullCharacterInForeignContent(this, ue);
      return;
    }
    switch (this.insertionMode) {
      case InsertionMode.INITIAL: {
        tokenInInitialMode(this, ue);
        break;
      }
      case InsertionMode.BEFORE_HTML: {
        tokenBeforeHtml(this, ue);
        break;
      }
      case InsertionMode.BEFORE_HEAD: {
        tokenBeforeHead(this, ue);
        break;
      }
      case InsertionMode.IN_HEAD: {
        tokenInHead(this, ue);
        break;
      }
      case InsertionMode.IN_HEAD_NO_SCRIPT: {
        tokenInHeadNoScript(this, ue);
        break;
      }
      case InsertionMode.AFTER_HEAD: {
        tokenAfterHead(this, ue);
        break;
      }
      case InsertionMode.TEXT: {
        this._insertCharacters(ue);
        break;
      }
      case InsertionMode.IN_TABLE:
      case InsertionMode.IN_TABLE_BODY:
      case InsertionMode.IN_ROW: {
        characterInTable(this, ue);
        break;
      }
      case InsertionMode.IN_COLUMN_GROUP: {
        tokenInColumnGroup(this, ue);
        break;
      }
      case InsertionMode.AFTER_BODY: {
        tokenAfterBody(this, ue);
        break;
      }
      case InsertionMode.AFTER_AFTER_BODY: {
        tokenAfterAfterBody(this, ue);
        break;
      }
    }
  }
  onComment(ue) {
    if (this.skipNextNewLine = !1, this.currentNotInHTML) {
      appendComment(this, ue);
      return;
    }
    switch (this.insertionMode) {
      case InsertionMode.INITIAL:
      case InsertionMode.BEFORE_HTML:
      case InsertionMode.BEFORE_HEAD:
      case InsertionMode.IN_HEAD:
      case InsertionMode.IN_HEAD_NO_SCRIPT:
      case InsertionMode.AFTER_HEAD:
      case InsertionMode.IN_BODY:
      case InsertionMode.IN_TABLE:
      case InsertionMode.IN_CAPTION:
      case InsertionMode.IN_COLUMN_GROUP:
      case InsertionMode.IN_TABLE_BODY:
      case InsertionMode.IN_ROW:
      case InsertionMode.IN_CELL:
      case InsertionMode.IN_SELECT:
      case InsertionMode.IN_SELECT_IN_TABLE:
      case InsertionMode.IN_TEMPLATE:
      case InsertionMode.IN_FRAMESET:
      case InsertionMode.AFTER_FRAMESET: {
        appendComment(this, ue);
        break;
      }
      case InsertionMode.IN_TABLE_TEXT: {
        tokenInTableText(this, ue);
        break;
      }
      case InsertionMode.AFTER_BODY: {
        appendCommentToRootHtmlElement(this, ue);
        break;
      }
      case InsertionMode.AFTER_AFTER_BODY:
      case InsertionMode.AFTER_AFTER_FRAMESET: {
        appendCommentToDocument(this, ue);
        break;
      }
    }
  }
  onDoctype(ue) {
    switch (this.skipNextNewLine = !1, this.insertionMode) {
      case InsertionMode.INITIAL: {
        doctypeInInitialMode(this, ue);
        break;
      }
      case InsertionMode.BEFORE_HEAD:
      case InsertionMode.IN_HEAD:
      case InsertionMode.IN_HEAD_NO_SCRIPT:
      case InsertionMode.AFTER_HEAD: {
        this._err(ue, ERR.misplacedDoctype);
        break;
      }
      case InsertionMode.IN_TABLE_TEXT: {
        tokenInTableText(this, ue);
        break;
      }
    }
  }
  onStartTag(ue) {
    this.skipNextNewLine = !1, this.currentToken = ue, this._processStartTag(ue), ue.selfClosing && !ue.ackSelfClosing && this._err(ue, ERR.nonVoidHtmlElementStartTagWithTrailingSolidus);
  }
  /**
   * Processes a given start tag.
   *
   * `onStartTag` checks if a self-closing tag was recognized. When a token
   * is moved inbetween multiple insertion modes, this check for self-closing
   * could lead to false positives. To avoid this, `_processStartTag` is used
   * for nested calls.
   *
   * @param token The token to process.
   */
  _processStartTag(ue) {
    this.shouldProcessStartTagTokenInForeignContent(ue) ? startTagInForeignContent(this, ue) : this._startTagOutsideForeignContent(ue);
  }
  _startTagOutsideForeignContent(ue) {
    switch (this.insertionMode) {
      case InsertionMode.INITIAL: {
        tokenInInitialMode(this, ue);
        break;
      }
      case InsertionMode.BEFORE_HTML: {
        startTagBeforeHtml(this, ue);
        break;
      }
      case InsertionMode.BEFORE_HEAD: {
        startTagBeforeHead(this, ue);
        break;
      }
      case InsertionMode.IN_HEAD: {
        startTagInHead(this, ue);
        break;
      }
      case InsertionMode.IN_HEAD_NO_SCRIPT: {
        startTagInHeadNoScript(this, ue);
        break;
      }
      case InsertionMode.AFTER_HEAD: {
        startTagAfterHead(this, ue);
        break;
      }
      case InsertionMode.IN_BODY: {
        startTagInBody(this, ue);
        break;
      }
      case InsertionMode.IN_TABLE: {
        startTagInTable(this, ue);
        break;
      }
      case InsertionMode.IN_TABLE_TEXT: {
        tokenInTableText(this, ue);
        break;
      }
      case InsertionMode.IN_CAPTION: {
        startTagInCaption(this, ue);
        break;
      }
      case InsertionMode.IN_COLUMN_GROUP: {
        startTagInColumnGroup(this, ue);
        break;
      }
      case InsertionMode.IN_TABLE_BODY: {
        startTagInTableBody(this, ue);
        break;
      }
      case InsertionMode.IN_ROW: {
        startTagInRow(this, ue);
        break;
      }
      case InsertionMode.IN_CELL: {
        startTagInCell(this, ue);
        break;
      }
      case InsertionMode.IN_SELECT: {
        startTagInSelect(this, ue);
        break;
      }
      case InsertionMode.IN_SELECT_IN_TABLE: {
        startTagInSelectInTable(this, ue);
        break;
      }
      case InsertionMode.IN_TEMPLATE: {
        startTagInTemplate(this, ue);
        break;
      }
      case InsertionMode.AFTER_BODY: {
        startTagAfterBody(this, ue);
        break;
      }
      case InsertionMode.IN_FRAMESET: {
        startTagInFrameset(this, ue);
        break;
      }
      case InsertionMode.AFTER_FRAMESET: {
        startTagAfterFrameset(this, ue);
        break;
      }
      case InsertionMode.AFTER_AFTER_BODY: {
        startTagAfterAfterBody(this, ue);
        break;
      }
      case InsertionMode.AFTER_AFTER_FRAMESET: {
        startTagAfterAfterFrameset(this, ue);
        break;
      }
    }
  }
  onEndTag(ue) {
    this.skipNextNewLine = !1, this.currentToken = ue, this.currentNotInHTML ? endTagInForeignContent(this, ue) : this._endTagOutsideForeignContent(ue);
  }
  _endTagOutsideForeignContent(ue) {
    switch (this.insertionMode) {
      case InsertionMode.INITIAL: {
        tokenInInitialMode(this, ue);
        break;
      }
      case InsertionMode.BEFORE_HTML: {
        endTagBeforeHtml(this, ue);
        break;
      }
      case InsertionMode.BEFORE_HEAD: {
        endTagBeforeHead(this, ue);
        break;
      }
      case InsertionMode.IN_HEAD: {
        endTagInHead(this, ue);
        break;
      }
      case InsertionMode.IN_HEAD_NO_SCRIPT: {
        endTagInHeadNoScript(this, ue);
        break;
      }
      case InsertionMode.AFTER_HEAD: {
        endTagAfterHead(this, ue);
        break;
      }
      case InsertionMode.IN_BODY: {
        endTagInBody(this, ue);
        break;
      }
      case InsertionMode.TEXT: {
        endTagInText(this, ue);
        break;
      }
      case InsertionMode.IN_TABLE: {
        endTagInTable(this, ue);
        break;
      }
      case InsertionMode.IN_TABLE_TEXT: {
        tokenInTableText(this, ue);
        break;
      }
      case InsertionMode.IN_CAPTION: {
        endTagInCaption(this, ue);
        break;
      }
      case InsertionMode.IN_COLUMN_GROUP: {
        endTagInColumnGroup(this, ue);
        break;
      }
      case InsertionMode.IN_TABLE_BODY: {
        endTagInTableBody(this, ue);
        break;
      }
      case InsertionMode.IN_ROW: {
        endTagInRow(this, ue);
        break;
      }
      case InsertionMode.IN_CELL: {
        endTagInCell(this, ue);
        break;
      }
      case InsertionMode.IN_SELECT: {
        endTagInSelect(this, ue);
        break;
      }
      case InsertionMode.IN_SELECT_IN_TABLE: {
        endTagInSelectInTable(this, ue);
        break;
      }
      case InsertionMode.IN_TEMPLATE: {
        endTagInTemplate(this, ue);
        break;
      }
      case InsertionMode.AFTER_BODY: {
        endTagAfterBody(this, ue);
        break;
      }
      case InsertionMode.IN_FRAMESET: {
        endTagInFrameset(this, ue);
        break;
      }
      case InsertionMode.AFTER_FRAMESET: {
        endTagAfterFrameset(this, ue);
        break;
      }
      case InsertionMode.AFTER_AFTER_BODY: {
        tokenAfterAfterBody(this, ue);
        break;
      }
    }
  }
  onEof(ue) {
    switch (this.insertionMode) {
      case InsertionMode.INITIAL: {
        tokenInInitialMode(this, ue);
        break;
      }
      case InsertionMode.BEFORE_HTML: {
        tokenBeforeHtml(this, ue);
        break;
      }
      case InsertionMode.BEFORE_HEAD: {
        tokenBeforeHead(this, ue);
        break;
      }
      case InsertionMode.IN_HEAD: {
        tokenInHead(this, ue);
        break;
      }
      case InsertionMode.IN_HEAD_NO_SCRIPT: {
        tokenInHeadNoScript(this, ue);
        break;
      }
      case InsertionMode.AFTER_HEAD: {
        tokenAfterHead(this, ue);
        break;
      }
      case InsertionMode.IN_BODY:
      case InsertionMode.IN_TABLE:
      case InsertionMode.IN_CAPTION:
      case InsertionMode.IN_COLUMN_GROUP:
      case InsertionMode.IN_TABLE_BODY:
      case InsertionMode.IN_ROW:
      case InsertionMode.IN_CELL:
      case InsertionMode.IN_SELECT:
      case InsertionMode.IN_SELECT_IN_TABLE: {
        eofInBody(this, ue);
        break;
      }
      case InsertionMode.TEXT: {
        eofInText(this, ue);
        break;
      }
      case InsertionMode.IN_TABLE_TEXT: {
        tokenInTableText(this, ue);
        break;
      }
      case InsertionMode.IN_TEMPLATE: {
        eofInTemplate(this, ue);
        break;
      }
      case InsertionMode.AFTER_BODY:
      case InsertionMode.IN_FRAMESET:
      case InsertionMode.AFTER_FRAMESET:
      case InsertionMode.AFTER_AFTER_BODY:
      case InsertionMode.AFTER_AFTER_FRAMESET: {
        stopParsing(this, ue);
        break;
      }
    }
  }
  onWhitespaceCharacter(ue) {
    if (this.skipNextNewLine && (this.skipNextNewLine = !1, ue.chars.charCodeAt(0) === CODE_POINTS.LINE_FEED)) {
      if (ue.chars.length === 1)
        return;
      ue.chars = ue.chars.substr(1);
    }
    if (this.tokenizer.inForeignNode) {
      this._insertCharacters(ue);
      return;
    }
    switch (this.insertionMode) {
      case InsertionMode.IN_HEAD:
      case InsertionMode.IN_HEAD_NO_SCRIPT:
      case InsertionMode.AFTER_HEAD:
      case InsertionMode.TEXT:
      case InsertionMode.IN_COLUMN_GROUP:
      case InsertionMode.IN_SELECT:
      case InsertionMode.IN_SELECT_IN_TABLE:
      case InsertionMode.IN_FRAMESET:
      case InsertionMode.AFTER_FRAMESET: {
        this._insertCharacters(ue);
        break;
      }
      case InsertionMode.IN_BODY:
      case InsertionMode.IN_CAPTION:
      case InsertionMode.IN_CELL:
      case InsertionMode.IN_TEMPLATE:
      case InsertionMode.AFTER_BODY:
      case InsertionMode.AFTER_AFTER_BODY:
      case InsertionMode.AFTER_AFTER_FRAMESET: {
        whitespaceCharacterInBody(this, ue);
        break;
      }
      case InsertionMode.IN_TABLE:
      case InsertionMode.IN_TABLE_BODY:
      case InsertionMode.IN_ROW: {
        characterInTable(this, ue);
        break;
      }
      case InsertionMode.IN_TABLE_TEXT: {
        whitespaceCharacterInTableText(this, ue);
        break;
      }
    }
  }
}
function aaObtainFormattingElementEntry(me, ue) {
  let Qe = me.activeFormattingElements.getElementEntryInScopeWithTagName(ue.tagName);
  return Qe ? me.openElements.contains(Qe.element) ? me.openElements.hasInScope(ue.tagID) || (Qe = null) : (me.activeFormattingElements.removeEntry(Qe), Qe = null) : genericEndTagInBody(me, ue), Qe;
}
function aaObtainFurthestBlock(me, ue) {
  let Qe = null, Ue = me.openElements.stackTop;
  for (; Ue >= 0; Ue--) {
    const He = me.openElements.items[Ue];
    if (He === ue.element)
      break;
    me._isSpecialElement(He, me.openElements.tagIDs[Ue]) && (Qe = He);
  }
  return Qe || (me.openElements.shortenToLength(Ue < 0 ? 0 : Ue), me.activeFormattingElements.removeEntry(ue)), Qe;
}
function aaInnerLoop(me, ue, Qe) {
  let Ue = ue, He = me.openElements.getCommonAncestor(ue);
  for (let Ge = 0, Xe = He; Xe !== Qe; Ge++, Xe = He) {
    He = me.openElements.getCommonAncestor(Xe);
    const Ke = me.activeFormattingElements.getElementEntry(Xe), $e = Ke && Ge >= AA_INNER_LOOP_ITER;
    !Ke || $e ? ($e && me.activeFormattingElements.removeEntry(Ke), me.openElements.remove(Xe)) : (Xe = aaRecreateElementFromEntry(me, Ke), Ue === ue && (me.activeFormattingElements.bookmark = Ke), me.treeAdapter.detachNode(Ue), me.treeAdapter.appendChild(Xe, Ue), Ue = Xe);
  }
  return Ue;
}
function aaRecreateElementFromEntry(me, ue) {
  const Qe = me.treeAdapter.getNamespaceURI(ue.element), Ue = me.treeAdapter.createElement(ue.token.tagName, Qe, ue.token.attrs);
  return me.openElements.replace(ue.element, Ue), ue.element = Ue, Ue;
}
function aaInsertLastNodeInCommonAncestor(me, ue, Qe) {
  const Ue = me.treeAdapter.getTagName(ue), He = getTagID(Ue);
  if (me._isElementCausesFosterParenting(He))
    me._fosterParentElement(Qe);
  else {
    const Ge = me.treeAdapter.getNamespaceURI(ue);
    He === TAG_ID.TEMPLATE && Ge === NS.HTML && (ue = me.treeAdapter.getTemplateContent(ue)), me.treeAdapter.appendChild(ue, Qe);
  }
}
function aaReplaceFormattingElement(me, ue, Qe) {
  const Ue = me.treeAdapter.getNamespaceURI(Qe.element), { token: He } = Qe, Ge = me.treeAdapter.createElement(He.tagName, Ue, He.attrs);
  me._adoptNodes(ue, Ge), me.treeAdapter.appendChild(ue, Ge), me.activeFormattingElements.insertElementAfterBookmark(Ge, He), me.activeFormattingElements.removeEntry(Qe), me.openElements.remove(Qe.element), me.openElements.insertAfter(ue, Ge, He.tagID);
}
function callAdoptionAgency(me, ue) {
  for (let Qe = 0; Qe < AA_OUTER_LOOP_ITER; Qe++) {
    const Ue = aaObtainFormattingElementEntry(me, ue);
    if (!Ue)
      break;
    const He = aaObtainFurthestBlock(me, Ue);
    if (!He)
      break;
    me.activeFormattingElements.bookmark = Ue;
    const Ge = aaInnerLoop(me, He, Ue.element), Xe = me.openElements.getCommonAncestor(Ue.element);
    me.treeAdapter.detachNode(Ge), Xe && aaInsertLastNodeInCommonAncestor(me, Xe, Ge), aaReplaceFormattingElement(me, He, Ue);
  }
}
function appendComment(me, ue) {
  me._appendCommentNode(ue, me.openElements.currentTmplContentOrNode);
}
function appendCommentToRootHtmlElement(me, ue) {
  me._appendCommentNode(ue, me.openElements.items[0]);
}
function appendCommentToDocument(me, ue) {
  me._appendCommentNode(ue, me.document);
}
function stopParsing(me, ue) {
  if (me.stopped = !0, ue.location) {
    const Qe = me.fragmentContext ? 0 : 2;
    for (let Ue = me.openElements.stackTop; Ue >= Qe; Ue--)
      me._setEndLocation(me.openElements.items[Ue], ue);
    if (!me.fragmentContext && me.openElements.stackTop >= 0) {
      const Ue = me.openElements.items[0], He = me.treeAdapter.getNodeSourceCodeLocation(Ue);
      if (He && !He.endTag && (me._setEndLocation(Ue, ue), me.openElements.stackTop >= 1)) {
        const Ge = me.openElements.items[1], Xe = me.treeAdapter.getNodeSourceCodeLocation(Ge);
        Xe && !Xe.endTag && me._setEndLocation(Ge, ue);
      }
    }
  }
}
function doctypeInInitialMode(me, ue) {
  me._setDocumentType(ue);
  const Qe = ue.forceQuirks ? DOCUMENT_MODE.QUIRKS : getDocumentMode(ue);
  isConforming(ue) || me._err(ue, ERR.nonConformingDoctype), me.treeAdapter.setDocumentMode(me.document, Qe), me.insertionMode = InsertionMode.BEFORE_HTML;
}
function tokenInInitialMode(me, ue) {
  me._err(ue, ERR.missingDoctype, !0), me.treeAdapter.setDocumentMode(me.document, DOCUMENT_MODE.QUIRKS), me.insertionMode = InsertionMode.BEFORE_HTML, me._processToken(ue);
}
function startTagBeforeHtml(me, ue) {
  ue.tagID === TAG_ID.HTML ? (me._insertElement(ue, NS.HTML), me.insertionMode = InsertionMode.BEFORE_HEAD) : tokenBeforeHtml(me, ue);
}
function endTagBeforeHtml(me, ue) {
  const Qe = ue.tagID;
  (Qe === TAG_ID.HTML || Qe === TAG_ID.HEAD || Qe === TAG_ID.BODY || Qe === TAG_ID.BR) && tokenBeforeHtml(me, ue);
}
function tokenBeforeHtml(me, ue) {
  me._insertFakeRootElement(), me.insertionMode = InsertionMode.BEFORE_HEAD, me._processToken(ue);
}
function startTagBeforeHead(me, ue) {
  switch (ue.tagID) {
    case TAG_ID.HTML: {
      startTagInBody(me, ue);
      break;
    }
    case TAG_ID.HEAD: {
      me._insertElement(ue, NS.HTML), me.headElement = me.openElements.current, me.insertionMode = InsertionMode.IN_HEAD;
      break;
    }
    default:
      tokenBeforeHead(me, ue);
  }
}
function endTagBeforeHead(me, ue) {
  const Qe = ue.tagID;
  Qe === TAG_ID.HEAD || Qe === TAG_ID.BODY || Qe === TAG_ID.HTML || Qe === TAG_ID.BR ? tokenBeforeHead(me, ue) : me._err(ue, ERR.endTagWithoutMatchingOpenElement);
}
function tokenBeforeHead(me, ue) {
  me._insertFakeElement(TAG_NAMES.HEAD, TAG_ID.HEAD), me.headElement = me.openElements.current, me.insertionMode = InsertionMode.IN_HEAD, me._processToken(ue);
}
function startTagInHead(me, ue) {
  switch (ue.tagID) {
    case TAG_ID.HTML: {
      startTagInBody(me, ue);
      break;
    }
    case TAG_ID.BASE:
    case TAG_ID.BASEFONT:
    case TAG_ID.BGSOUND:
    case TAG_ID.LINK:
    case TAG_ID.META: {
      me._appendElement(ue, NS.HTML), ue.ackSelfClosing = !0;
      break;
    }
    case TAG_ID.TITLE: {
      me._switchToTextParsing(ue, TokenizerMode.RCDATA);
      break;
    }
    case TAG_ID.NOSCRIPT: {
      me.options.scriptingEnabled ? me._switchToTextParsing(ue, TokenizerMode.RAWTEXT) : (me._insertElement(ue, NS.HTML), me.insertionMode = InsertionMode.IN_HEAD_NO_SCRIPT);
      break;
    }
    case TAG_ID.NOFRAMES:
    case TAG_ID.STYLE: {
      me._switchToTextParsing(ue, TokenizerMode.RAWTEXT);
      break;
    }
    case TAG_ID.SCRIPT: {
      me._switchToTextParsing(ue, TokenizerMode.SCRIPT_DATA);
      break;
    }
    case TAG_ID.TEMPLATE: {
      me._insertTemplate(ue), me.activeFormattingElements.insertMarker(), me.framesetOk = !1, me.insertionMode = InsertionMode.IN_TEMPLATE, me.tmplInsertionModeStack.unshift(InsertionMode.IN_TEMPLATE);
      break;
    }
    case TAG_ID.HEAD: {
      me._err(ue, ERR.misplacedStartTagForHeadElement);
      break;
    }
    default:
      tokenInHead(me, ue);
  }
}
function endTagInHead(me, ue) {
  switch (ue.tagID) {
    case TAG_ID.HEAD: {
      me.openElements.pop(), me.insertionMode = InsertionMode.AFTER_HEAD;
      break;
    }
    case TAG_ID.BODY:
    case TAG_ID.BR:
    case TAG_ID.HTML: {
      tokenInHead(me, ue);
      break;
    }
    case TAG_ID.TEMPLATE: {
      templateEndTagInHead(me, ue);
      break;
    }
    default:
      me._err(ue, ERR.endTagWithoutMatchingOpenElement);
  }
}
function templateEndTagInHead(me, ue) {
  me.openElements.tmplCount > 0 ? (me.openElements.generateImpliedEndTagsThoroughly(), me.openElements.currentTagId !== TAG_ID.TEMPLATE && me._err(ue, ERR.closingOfElementWithOpenChildElements), me.openElements.popUntilTagNamePopped(TAG_ID.TEMPLATE), me.activeFormattingElements.clearToLastMarker(), me.tmplInsertionModeStack.shift(), me._resetInsertionMode()) : me._err(ue, ERR.endTagWithoutMatchingOpenElement);
}
function tokenInHead(me, ue) {
  me.openElements.pop(), me.insertionMode = InsertionMode.AFTER_HEAD, me._processToken(ue);
}
function startTagInHeadNoScript(me, ue) {
  switch (ue.tagID) {
    case TAG_ID.HTML: {
      startTagInBody(me, ue);
      break;
    }
    case TAG_ID.BASEFONT:
    case TAG_ID.BGSOUND:
    case TAG_ID.HEAD:
    case TAG_ID.LINK:
    case TAG_ID.META:
    case TAG_ID.NOFRAMES:
    case TAG_ID.STYLE: {
      startTagInHead(me, ue);
      break;
    }
    case TAG_ID.NOSCRIPT: {
      me._err(ue, ERR.nestedNoscriptInHead);
      break;
    }
    default:
      tokenInHeadNoScript(me, ue);
  }
}
function endTagInHeadNoScript(me, ue) {
  switch (ue.tagID) {
    case TAG_ID.NOSCRIPT: {
      me.openElements.pop(), me.insertionMode = InsertionMode.IN_HEAD;
      break;
    }
    case TAG_ID.BR: {
      tokenInHeadNoScript(me, ue);
      break;
    }
    default:
      me._err(ue, ERR.endTagWithoutMatchingOpenElement);
  }
}
function tokenInHeadNoScript(me, ue) {
  const Qe = ue.type === TokenType.EOF ? ERR.openElementsLeftAfterEof : ERR.disallowedContentInNoscriptInHead;
  me._err(ue, Qe), me.openElements.pop(), me.insertionMode = InsertionMode.IN_HEAD, me._processToken(ue);
}
function startTagAfterHead(me, ue) {
  switch (ue.tagID) {
    case TAG_ID.HTML: {
      startTagInBody(me, ue);
      break;
    }
    case TAG_ID.BODY: {
      me._insertElement(ue, NS.HTML), me.framesetOk = !1, me.insertionMode = InsertionMode.IN_BODY;
      break;
    }
    case TAG_ID.FRAMESET: {
      me._insertElement(ue, NS.HTML), me.insertionMode = InsertionMode.IN_FRAMESET;
      break;
    }
    case TAG_ID.BASE:
    case TAG_ID.BASEFONT:
    case TAG_ID.BGSOUND:
    case TAG_ID.LINK:
    case TAG_ID.META:
    case TAG_ID.NOFRAMES:
    case TAG_ID.SCRIPT:
    case TAG_ID.STYLE:
    case TAG_ID.TEMPLATE:
    case TAG_ID.TITLE: {
      me._err(ue, ERR.abandonedHeadElementChild), me.openElements.push(me.headElement, TAG_ID.HEAD), startTagInHead(me, ue), me.openElements.remove(me.headElement);
      break;
    }
    case TAG_ID.HEAD: {
      me._err(ue, ERR.misplacedStartTagForHeadElement);
      break;
    }
    default:
      tokenAfterHead(me, ue);
  }
}
function endTagAfterHead(me, ue) {
  switch (ue.tagID) {
    case TAG_ID.BODY:
    case TAG_ID.HTML:
    case TAG_ID.BR: {
      tokenAfterHead(me, ue);
      break;
    }
    case TAG_ID.TEMPLATE: {
      templateEndTagInHead(me, ue);
      break;
    }
    default:
      me._err(ue, ERR.endTagWithoutMatchingOpenElement);
  }
}
function tokenAfterHead(me, ue) {
  me._insertFakeElement(TAG_NAMES.BODY, TAG_ID.BODY), me.insertionMode = InsertionMode.IN_BODY, modeInBody(me, ue);
}
function modeInBody(me, ue) {
  switch (ue.type) {
    case TokenType.CHARACTER: {
      characterInBody(me, ue);
      break;
    }
    case TokenType.WHITESPACE_CHARACTER: {
      whitespaceCharacterInBody(me, ue);
      break;
    }
    case TokenType.COMMENT: {
      appendComment(me, ue);
      break;
    }
    case TokenType.START_TAG: {
      startTagInBody(me, ue);
      break;
    }
    case TokenType.END_TAG: {
      endTagInBody(me, ue);
      break;
    }
    case TokenType.EOF: {
      eofInBody(me, ue);
      break;
    }
  }
}
function whitespaceCharacterInBody(me, ue) {
  me._reconstructActiveFormattingElements(), me._insertCharacters(ue);
}
function characterInBody(me, ue) {
  me._reconstructActiveFormattingElements(), me._insertCharacters(ue), me.framesetOk = !1;
}
function htmlStartTagInBody(me, ue) {
  me.openElements.tmplCount === 0 && me.treeAdapter.adoptAttributes(me.openElements.items[0], ue.attrs);
}
function bodyStartTagInBody(me, ue) {
  const Qe = me.openElements.tryPeekProperlyNestedBodyElement();
  Qe && me.openElements.tmplCount === 0 && (me.framesetOk = !1, me.treeAdapter.adoptAttributes(Qe, ue.attrs));
}
function framesetStartTagInBody(me, ue) {
  const Qe = me.openElements.tryPeekProperlyNestedBodyElement();
  me.framesetOk && Qe && (me.treeAdapter.detachNode(Qe), me.openElements.popAllUpToHtmlElement(), me._insertElement(ue, NS.HTML), me.insertionMode = InsertionMode.IN_FRAMESET);
}
function addressStartTagInBody(me, ue) {
  me.openElements.hasInButtonScope(TAG_ID.P) && me._closePElement(), me._insertElement(ue, NS.HTML);
}
function numberedHeaderStartTagInBody(me, ue) {
  me.openElements.hasInButtonScope(TAG_ID.P) && me._closePElement(), isNumberedHeader(me.openElements.currentTagId) && me.openElements.pop(), me._insertElement(ue, NS.HTML);
}
function preStartTagInBody(me, ue) {
  me.openElements.hasInButtonScope(TAG_ID.P) && me._closePElement(), me._insertElement(ue, NS.HTML), me.skipNextNewLine = !0, me.framesetOk = !1;
}
function formStartTagInBody(me, ue) {
  const Qe = me.openElements.tmplCount > 0;
  (!me.formElement || Qe) && (me.openElements.hasInButtonScope(TAG_ID.P) && me._closePElement(), me._insertElement(ue, NS.HTML), Qe || (me.formElement = me.openElements.current));
}
function listItemStartTagInBody(me, ue) {
  me.framesetOk = !1;
  const Qe = ue.tagID;
  for (let Ue = me.openElements.stackTop; Ue >= 0; Ue--) {
    const He = me.openElements.tagIDs[Ue];
    if (Qe === TAG_ID.LI && He === TAG_ID.LI || (Qe === TAG_ID.DD || Qe === TAG_ID.DT) && (He === TAG_ID.DD || He === TAG_ID.DT)) {
      me.openElements.generateImpliedEndTagsWithExclusion(He), me.openElements.popUntilTagNamePopped(He);
      break;
    }
    if (He !== TAG_ID.ADDRESS && He !== TAG_ID.DIV && He !== TAG_ID.P && me._isSpecialElement(me.openElements.items[Ue], He))
      break;
  }
  me.openElements.hasInButtonScope(TAG_ID.P) && me._closePElement(), me._insertElement(ue, NS.HTML);
}
function plaintextStartTagInBody(me, ue) {
  me.openElements.hasInButtonScope(TAG_ID.P) && me._closePElement(), me._insertElement(ue, NS.HTML), me.tokenizer.state = TokenizerMode.PLAINTEXT;
}
function buttonStartTagInBody(me, ue) {
  me.openElements.hasInScope(TAG_ID.BUTTON) && (me.openElements.generateImpliedEndTags(), me.openElements.popUntilTagNamePopped(TAG_ID.BUTTON)), me._reconstructActiveFormattingElements(), me._insertElement(ue, NS.HTML), me.framesetOk = !1;
}
function aStartTagInBody(me, ue) {
  const Qe = me.activeFormattingElements.getElementEntryInScopeWithTagName(TAG_NAMES.A);
  Qe && (callAdoptionAgency(me, ue), me.openElements.remove(Qe.element), me.activeFormattingElements.removeEntry(Qe)), me._reconstructActiveFormattingElements(), me._insertElement(ue, NS.HTML), me.activeFormattingElements.pushElement(me.openElements.current, ue);
}
function bStartTagInBody(me, ue) {
  me._reconstructActiveFormattingElements(), me._insertElement(ue, NS.HTML), me.activeFormattingElements.pushElement(me.openElements.current, ue);
}
function nobrStartTagInBody(me, ue) {
  me._reconstructActiveFormattingElements(), me.openElements.hasInScope(TAG_ID.NOBR) && (callAdoptionAgency(me, ue), me._reconstructActiveFormattingElements()), me._insertElement(ue, NS.HTML), me.activeFormattingElements.pushElement(me.openElements.current, ue);
}
function appletStartTagInBody(me, ue) {
  me._reconstructActiveFormattingElements(), me._insertElement(ue, NS.HTML), me.activeFormattingElements.insertMarker(), me.framesetOk = !1;
}
function tableStartTagInBody(me, ue) {
  me.treeAdapter.getDocumentMode(me.document) !== DOCUMENT_MODE.QUIRKS && me.openElements.hasInButtonScope(TAG_ID.P) && me._closePElement(), me._insertElement(ue, NS.HTML), me.framesetOk = !1, me.insertionMode = InsertionMode.IN_TABLE;
}
function areaStartTagInBody(me, ue) {
  me._reconstructActiveFormattingElements(), me._appendElement(ue, NS.HTML), me.framesetOk = !1, ue.ackSelfClosing = !0;
}
function isHiddenInput(me) {
  const ue = getTokenAttr(me, ATTRS.TYPE);
  return ue != null && ue.toLowerCase() === HIDDEN_INPUT_TYPE;
}
function inputStartTagInBody(me, ue) {
  me._reconstructActiveFormattingElements(), me._appendElement(ue, NS.HTML), isHiddenInput(ue) || (me.framesetOk = !1), ue.ackSelfClosing = !0;
}
function paramStartTagInBody(me, ue) {
  me._appendElement(ue, NS.HTML), ue.ackSelfClosing = !0;
}
function hrStartTagInBody(me, ue) {
  me.openElements.hasInButtonScope(TAG_ID.P) && me._closePElement(), me._appendElement(ue, NS.HTML), me.framesetOk = !1, ue.ackSelfClosing = !0;
}
function imageStartTagInBody(me, ue) {
  ue.tagName = TAG_NAMES.IMG, ue.tagID = TAG_ID.IMG, areaStartTagInBody(me, ue);
}
function textareaStartTagInBody(me, ue) {
  me._insertElement(ue, NS.HTML), me.skipNextNewLine = !0, me.tokenizer.state = TokenizerMode.RCDATA, me.originalInsertionMode = me.insertionMode, me.framesetOk = !1, me.insertionMode = InsertionMode.TEXT;
}
function xmpStartTagInBody(me, ue) {
  me.openElements.hasInButtonScope(TAG_ID.P) && me._closePElement(), me._reconstructActiveFormattingElements(), me.framesetOk = !1, me._switchToTextParsing(ue, TokenizerMode.RAWTEXT);
}
function iframeStartTagInBody(me, ue) {
  me.framesetOk = !1, me._switchToTextParsing(ue, TokenizerMode.RAWTEXT);
}
function noembedStartTagInBody(me, ue) {
  me._switchToTextParsing(ue, TokenizerMode.RAWTEXT);
}
function selectStartTagInBody(me, ue) {
  me._reconstructActiveFormattingElements(), me._insertElement(ue, NS.HTML), me.framesetOk = !1, me.insertionMode = me.insertionMode === InsertionMode.IN_TABLE || me.insertionMode === InsertionMode.IN_CAPTION || me.insertionMode === InsertionMode.IN_TABLE_BODY || me.insertionMode === InsertionMode.IN_ROW || me.insertionMode === InsertionMode.IN_CELL ? InsertionMode.IN_SELECT_IN_TABLE : InsertionMode.IN_SELECT;
}
function optgroupStartTagInBody(me, ue) {
  me.openElements.currentTagId === TAG_ID.OPTION && me.openElements.pop(), me._reconstructActiveFormattingElements(), me._insertElement(ue, NS.HTML);
}
function rbStartTagInBody(me, ue) {
  me.openElements.hasInScope(TAG_ID.RUBY) && me.openElements.generateImpliedEndTags(), me._insertElement(ue, NS.HTML);
}
function rtStartTagInBody(me, ue) {
  me.openElements.hasInScope(TAG_ID.RUBY) && me.openElements.generateImpliedEndTagsWithExclusion(TAG_ID.RTC), me._insertElement(ue, NS.HTML);
}
function mathStartTagInBody(me, ue) {
  me._reconstructActiveFormattingElements(), adjustTokenMathMLAttrs(ue), adjustTokenXMLAttrs(ue), ue.selfClosing ? me._appendElement(ue, NS.MATHML) : me._insertElement(ue, NS.MATHML), ue.ackSelfClosing = !0;
}
function svgStartTagInBody(me, ue) {
  me._reconstructActiveFormattingElements(), adjustTokenSVGAttrs(ue), adjustTokenXMLAttrs(ue), ue.selfClosing ? me._appendElement(ue, NS.SVG) : me._insertElement(ue, NS.SVG), ue.ackSelfClosing = !0;
}
function genericStartTagInBody(me, ue) {
  me._reconstructActiveFormattingElements(), me._insertElement(ue, NS.HTML);
}
function startTagInBody(me, ue) {
  switch (ue.tagID) {
    case TAG_ID.I:
    case TAG_ID.S:
    case TAG_ID.B:
    case TAG_ID.U:
    case TAG_ID.EM:
    case TAG_ID.TT:
    case TAG_ID.BIG:
    case TAG_ID.CODE:
    case TAG_ID.FONT:
    case TAG_ID.SMALL:
    case TAG_ID.STRIKE:
    case TAG_ID.STRONG: {
      bStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.A: {
      aStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.H1:
    case TAG_ID.H2:
    case TAG_ID.H3:
    case TAG_ID.H4:
    case TAG_ID.H5:
    case TAG_ID.H6: {
      numberedHeaderStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.P:
    case TAG_ID.DL:
    case TAG_ID.OL:
    case TAG_ID.UL:
    case TAG_ID.DIV:
    case TAG_ID.DIR:
    case TAG_ID.NAV:
    case TAG_ID.MAIN:
    case TAG_ID.MENU:
    case TAG_ID.ASIDE:
    case TAG_ID.CENTER:
    case TAG_ID.FIGURE:
    case TAG_ID.FOOTER:
    case TAG_ID.HEADER:
    case TAG_ID.HGROUP:
    case TAG_ID.DIALOG:
    case TAG_ID.DETAILS:
    case TAG_ID.ADDRESS:
    case TAG_ID.ARTICLE:
    case TAG_ID.SECTION:
    case TAG_ID.SUMMARY:
    case TAG_ID.FIELDSET:
    case TAG_ID.BLOCKQUOTE:
    case TAG_ID.FIGCAPTION: {
      addressStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.LI:
    case TAG_ID.DD:
    case TAG_ID.DT: {
      listItemStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.BR:
    case TAG_ID.IMG:
    case TAG_ID.WBR:
    case TAG_ID.AREA:
    case TAG_ID.EMBED:
    case TAG_ID.KEYGEN: {
      areaStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.HR: {
      hrStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.RB:
    case TAG_ID.RTC: {
      rbStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.RT:
    case TAG_ID.RP: {
      rtStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.PRE:
    case TAG_ID.LISTING: {
      preStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.XMP: {
      xmpStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.SVG: {
      svgStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.HTML: {
      htmlStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.BASE:
    case TAG_ID.LINK:
    case TAG_ID.META:
    case TAG_ID.STYLE:
    case TAG_ID.TITLE:
    case TAG_ID.SCRIPT:
    case TAG_ID.BGSOUND:
    case TAG_ID.BASEFONT:
    case TAG_ID.TEMPLATE: {
      startTagInHead(me, ue);
      break;
    }
    case TAG_ID.BODY: {
      bodyStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.FORM: {
      formStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.NOBR: {
      nobrStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.MATH: {
      mathStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.TABLE: {
      tableStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.INPUT: {
      inputStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.PARAM:
    case TAG_ID.TRACK:
    case TAG_ID.SOURCE: {
      paramStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.IMAGE: {
      imageStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.BUTTON: {
      buttonStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.APPLET:
    case TAG_ID.OBJECT:
    case TAG_ID.MARQUEE: {
      appletStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.IFRAME: {
      iframeStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.SELECT: {
      selectStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.OPTION:
    case TAG_ID.OPTGROUP: {
      optgroupStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.NOEMBED: {
      noembedStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.FRAMESET: {
      framesetStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.TEXTAREA: {
      textareaStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.NOSCRIPT: {
      me.options.scriptingEnabled ? noembedStartTagInBody(me, ue) : genericStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.PLAINTEXT: {
      plaintextStartTagInBody(me, ue);
      break;
    }
    case TAG_ID.COL:
    case TAG_ID.TH:
    case TAG_ID.TD:
    case TAG_ID.TR:
    case TAG_ID.HEAD:
    case TAG_ID.FRAME:
    case TAG_ID.TBODY:
    case TAG_ID.TFOOT:
    case TAG_ID.THEAD:
    case TAG_ID.CAPTION:
    case TAG_ID.COLGROUP:
      break;
    default:
      genericStartTagInBody(me, ue);
  }
}
function bodyEndTagInBody(me, ue) {
  if (me.openElements.hasInScope(TAG_ID.BODY) && (me.insertionMode = InsertionMode.AFTER_BODY, me.options.sourceCodeLocationInfo)) {
    const Qe = me.openElements.tryPeekProperlyNestedBodyElement();
    Qe && me._setEndLocation(Qe, ue);
  }
}
function htmlEndTagInBody(me, ue) {
  me.openElements.hasInScope(TAG_ID.BODY) && (me.insertionMode = InsertionMode.AFTER_BODY, endTagAfterBody(me, ue));
}
function addressEndTagInBody(me, ue) {
  const Qe = ue.tagID;
  me.openElements.hasInScope(Qe) && (me.openElements.generateImpliedEndTags(), me.openElements.popUntilTagNamePopped(Qe));
}
function formEndTagInBody(me) {
  const ue = me.openElements.tmplCount > 0, { formElement: Qe } = me;
  ue || (me.formElement = null), (Qe || ue) && me.openElements.hasInScope(TAG_ID.FORM) && (me.openElements.generateImpliedEndTags(), ue ? me.openElements.popUntilTagNamePopped(TAG_ID.FORM) : Qe && me.openElements.remove(Qe));
}
function pEndTagInBody(me) {
  me.openElements.hasInButtonScope(TAG_ID.P) || me._insertFakeElement(TAG_NAMES.P, TAG_ID.P), me._closePElement();
}
function liEndTagInBody(me) {
  me.openElements.hasInListItemScope(TAG_ID.LI) && (me.openElements.generateImpliedEndTagsWithExclusion(TAG_ID.LI), me.openElements.popUntilTagNamePopped(TAG_ID.LI));
}
function ddEndTagInBody(me, ue) {
  const Qe = ue.tagID;
  me.openElements.hasInScope(Qe) && (me.openElements.generateImpliedEndTagsWithExclusion(Qe), me.openElements.popUntilTagNamePopped(Qe));
}
function numberedHeaderEndTagInBody(me) {
  me.openElements.hasNumberedHeaderInScope() && (me.openElements.generateImpliedEndTags(), me.openElements.popUntilNumberedHeaderPopped());
}
function appletEndTagInBody(me, ue) {
  const Qe = ue.tagID;
  me.openElements.hasInScope(Qe) && (me.openElements.generateImpliedEndTags(), me.openElements.popUntilTagNamePopped(Qe), me.activeFormattingElements.clearToLastMarker());
}
function brEndTagInBody(me) {
  me._reconstructActiveFormattingElements(), me._insertFakeElement(TAG_NAMES.BR, TAG_ID.BR), me.openElements.pop(), me.framesetOk = !1;
}
function genericEndTagInBody(me, ue) {
  const Qe = ue.tagName, Ue = ue.tagID;
  for (let He = me.openElements.stackTop; He > 0; He--) {
    const Ge = me.openElements.items[He], Xe = me.openElements.tagIDs[He];
    if (Ue === Xe && (Ue !== TAG_ID.UNKNOWN || me.treeAdapter.getTagName(Ge) === Qe)) {
      me.openElements.generateImpliedEndTagsWithExclusion(Ue), me.openElements.stackTop >= He && me.openElements.shortenToLength(He);
      break;
    }
    if (me._isSpecialElement(Ge, Xe))
      break;
  }
}
function endTagInBody(me, ue) {
  switch (ue.tagID) {
    case TAG_ID.A:
    case TAG_ID.B:
    case TAG_ID.I:
    case TAG_ID.S:
    case TAG_ID.U:
    case TAG_ID.EM:
    case TAG_ID.TT:
    case TAG_ID.BIG:
    case TAG_ID.CODE:
    case TAG_ID.FONT:
    case TAG_ID.NOBR:
    case TAG_ID.SMALL:
    case TAG_ID.STRIKE:
    case TAG_ID.STRONG: {
      callAdoptionAgency(me, ue);
      break;
    }
    case TAG_ID.P: {
      pEndTagInBody(me);
      break;
    }
    case TAG_ID.DL:
    case TAG_ID.UL:
    case TAG_ID.OL:
    case TAG_ID.DIR:
    case TAG_ID.DIV:
    case TAG_ID.NAV:
    case TAG_ID.PRE:
    case TAG_ID.MAIN:
    case TAG_ID.MENU:
    case TAG_ID.ASIDE:
    case TAG_ID.BUTTON:
    case TAG_ID.CENTER:
    case TAG_ID.FIGURE:
    case TAG_ID.FOOTER:
    case TAG_ID.HEADER:
    case TAG_ID.HGROUP:
    case TAG_ID.DIALOG:
    case TAG_ID.ADDRESS:
    case TAG_ID.ARTICLE:
    case TAG_ID.DETAILS:
    case TAG_ID.SECTION:
    case TAG_ID.SUMMARY:
    case TAG_ID.LISTING:
    case TAG_ID.FIELDSET:
    case TAG_ID.BLOCKQUOTE:
    case TAG_ID.FIGCAPTION: {
      addressEndTagInBody(me, ue);
      break;
    }
    case TAG_ID.LI: {
      liEndTagInBody(me);
      break;
    }
    case TAG_ID.DD:
    case TAG_ID.DT: {
      ddEndTagInBody(me, ue);
      break;
    }
    case TAG_ID.H1:
    case TAG_ID.H2:
    case TAG_ID.H3:
    case TAG_ID.H4:
    case TAG_ID.H5:
    case TAG_ID.H6: {
      numberedHeaderEndTagInBody(me);
      break;
    }
    case TAG_ID.BR: {
      brEndTagInBody(me);
      break;
    }
    case TAG_ID.BODY: {
      bodyEndTagInBody(me, ue);
      break;
    }
    case TAG_ID.HTML: {
      htmlEndTagInBody(me, ue);
      break;
    }
    case TAG_ID.FORM: {
      formEndTagInBody(me);
      break;
    }
    case TAG_ID.APPLET:
    case TAG_ID.OBJECT:
    case TAG_ID.MARQUEE: {
      appletEndTagInBody(me, ue);
      break;
    }
    case TAG_ID.TEMPLATE: {
      templateEndTagInHead(me, ue);
      break;
    }
    default:
      genericEndTagInBody(me, ue);
  }
}
function eofInBody(me, ue) {
  me.tmplInsertionModeStack.length > 0 ? eofInTemplate(me, ue) : stopParsing(me, ue);
}
function endTagInText(me, ue) {
  var Qe;
  ue.tagID === TAG_ID.SCRIPT && ((Qe = me.scriptHandler) === null || Qe === void 0 || Qe.call(me, me.openElements.current)), me.openElements.pop(), me.insertionMode = me.originalInsertionMode;
}
function eofInText(me, ue) {
  me._err(ue, ERR.eofInElementThatCanContainOnlyText), me.openElements.pop(), me.insertionMode = me.originalInsertionMode, me.onEof(ue);
}
function characterInTable(me, ue) {
  if (TABLE_STRUCTURE_TAGS.has(me.openElements.currentTagId))
    switch (me.pendingCharacterTokens.length = 0, me.hasNonWhitespacePendingCharacterToken = !1, me.originalInsertionMode = me.insertionMode, me.insertionMode = InsertionMode.IN_TABLE_TEXT, ue.type) {
      case TokenType.CHARACTER: {
        characterInTableText(me, ue);
        break;
      }
      case TokenType.WHITESPACE_CHARACTER: {
        whitespaceCharacterInTableText(me, ue);
        break;
      }
    }
  else
    tokenInTable(me, ue);
}
function captionStartTagInTable(me, ue) {
  me.openElements.clearBackToTableContext(), me.activeFormattingElements.insertMarker(), me._insertElement(ue, NS.HTML), me.insertionMode = InsertionMode.IN_CAPTION;
}
function colgroupStartTagInTable(me, ue) {
  me.openElements.clearBackToTableContext(), me._insertElement(ue, NS.HTML), me.insertionMode = InsertionMode.IN_COLUMN_GROUP;
}
function colStartTagInTable(me, ue) {
  me.openElements.clearBackToTableContext(), me._insertFakeElement(TAG_NAMES.COLGROUP, TAG_ID.COLGROUP), me.insertionMode = InsertionMode.IN_COLUMN_GROUP, startTagInColumnGroup(me, ue);
}
function tbodyStartTagInTable(me, ue) {
  me.openElements.clearBackToTableContext(), me._insertElement(ue, NS.HTML), me.insertionMode = InsertionMode.IN_TABLE_BODY;
}
function tdStartTagInTable(me, ue) {
  me.openElements.clearBackToTableContext(), me._insertFakeElement(TAG_NAMES.TBODY, TAG_ID.TBODY), me.insertionMode = InsertionMode.IN_TABLE_BODY, startTagInTableBody(me, ue);
}
function tableStartTagInTable(me, ue) {
  me.openElements.hasInTableScope(TAG_ID.TABLE) && (me.openElements.popUntilTagNamePopped(TAG_ID.TABLE), me._resetInsertionMode(), me._processStartTag(ue));
}
function inputStartTagInTable(me, ue) {
  isHiddenInput(ue) ? me._appendElement(ue, NS.HTML) : tokenInTable(me, ue), ue.ackSelfClosing = !0;
}
function formStartTagInTable(me, ue) {
  !me.formElement && me.openElements.tmplCount === 0 && (me._insertElement(ue, NS.HTML), me.formElement = me.openElements.current, me.openElements.pop());
}
function startTagInTable(me, ue) {
  switch (ue.tagID) {
    case TAG_ID.TD:
    case TAG_ID.TH:
    case TAG_ID.TR: {
      tdStartTagInTable(me, ue);
      break;
    }
    case TAG_ID.STYLE:
    case TAG_ID.SCRIPT:
    case TAG_ID.TEMPLATE: {
      startTagInHead(me, ue);
      break;
    }
    case TAG_ID.COL: {
      colStartTagInTable(me, ue);
      break;
    }
    case TAG_ID.FORM: {
      formStartTagInTable(me, ue);
      break;
    }
    case TAG_ID.TABLE: {
      tableStartTagInTable(me, ue);
      break;
    }
    case TAG_ID.TBODY:
    case TAG_ID.TFOOT:
    case TAG_ID.THEAD: {
      tbodyStartTagInTable(me, ue);
      break;
    }
    case TAG_ID.INPUT: {
      inputStartTagInTable(me, ue);
      break;
    }
    case TAG_ID.CAPTION: {
      captionStartTagInTable(me, ue);
      break;
    }
    case TAG_ID.COLGROUP: {
      colgroupStartTagInTable(me, ue);
      break;
    }
    default:
      tokenInTable(me, ue);
  }
}
function endTagInTable(me, ue) {
  switch (ue.tagID) {
    case TAG_ID.TABLE: {
      me.openElements.hasInTableScope(TAG_ID.TABLE) && (me.openElements.popUntilTagNamePopped(TAG_ID.TABLE), me._resetInsertionMode());
      break;
    }
    case TAG_ID.TEMPLATE: {
      templateEndTagInHead(me, ue);
      break;
    }
    case TAG_ID.BODY:
    case TAG_ID.CAPTION:
    case TAG_ID.COL:
    case TAG_ID.COLGROUP:
    case TAG_ID.HTML:
    case TAG_ID.TBODY:
    case TAG_ID.TD:
    case TAG_ID.TFOOT:
    case TAG_ID.TH:
    case TAG_ID.THEAD:
    case TAG_ID.TR:
      break;
    default:
      tokenInTable(me, ue);
  }
}
function tokenInTable(me, ue) {
  const Qe = me.fosterParentingEnabled;
  me.fosterParentingEnabled = !0, modeInBody(me, ue), me.fosterParentingEnabled = Qe;
}
function whitespaceCharacterInTableText(me, ue) {
  me.pendingCharacterTokens.push(ue);
}
function characterInTableText(me, ue) {
  me.pendingCharacterTokens.push(ue), me.hasNonWhitespacePendingCharacterToken = !0;
}
function tokenInTableText(me, ue) {
  let Qe = 0;
  if (me.hasNonWhitespacePendingCharacterToken)
    for (; Qe < me.pendingCharacterTokens.length; Qe++)
      tokenInTable(me, me.pendingCharacterTokens[Qe]);
  else
    for (; Qe < me.pendingCharacterTokens.length; Qe++)
      me._insertCharacters(me.pendingCharacterTokens[Qe]);
  me.insertionMode = me.originalInsertionMode, me._processToken(ue);
}
const TABLE_VOID_ELEMENTS = /* @__PURE__ */ new Set([TAG_ID.CAPTION, TAG_ID.COL, TAG_ID.COLGROUP, TAG_ID.TBODY, TAG_ID.TD, TAG_ID.TFOOT, TAG_ID.TH, TAG_ID.THEAD, TAG_ID.TR]);
function startTagInCaption(me, ue) {
  const Qe = ue.tagID;
  TABLE_VOID_ELEMENTS.has(Qe) ? me.openElements.hasInTableScope(TAG_ID.CAPTION) && (me.openElements.generateImpliedEndTags(), me.openElements.popUntilTagNamePopped(TAG_ID.CAPTION), me.activeFormattingElements.clearToLastMarker(), me.insertionMode = InsertionMode.IN_TABLE, startTagInTable(me, ue)) : startTagInBody(me, ue);
}
function endTagInCaption(me, ue) {
  const Qe = ue.tagID;
  switch (Qe) {
    case TAG_ID.CAPTION:
    case TAG_ID.TABLE: {
      me.openElements.hasInTableScope(TAG_ID.CAPTION) && (me.openElements.generateImpliedEndTags(), me.openElements.popUntilTagNamePopped(TAG_ID.CAPTION), me.activeFormattingElements.clearToLastMarker(), me.insertionMode = InsertionMode.IN_TABLE, Qe === TAG_ID.TABLE && endTagInTable(me, ue));
      break;
    }
    case TAG_ID.BODY:
    case TAG_ID.COL:
    case TAG_ID.COLGROUP:
    case TAG_ID.HTML:
    case TAG_ID.TBODY:
    case TAG_ID.TD:
    case TAG_ID.TFOOT:
    case TAG_ID.TH:
    case TAG_ID.THEAD:
    case TAG_ID.TR:
      break;
    default:
      endTagInBody(me, ue);
  }
}
function startTagInColumnGroup(me, ue) {
  switch (ue.tagID) {
    case TAG_ID.HTML: {
      startTagInBody(me, ue);
      break;
    }
    case TAG_ID.COL: {
      me._appendElement(ue, NS.HTML), ue.ackSelfClosing = !0;
      break;
    }
    case TAG_ID.TEMPLATE: {
      startTagInHead(me, ue);
      break;
    }
    default:
      tokenInColumnGroup(me, ue);
  }
}
function endTagInColumnGroup(me, ue) {
  switch (ue.tagID) {
    case TAG_ID.COLGROUP: {
      me.openElements.currentTagId === TAG_ID.COLGROUP && (me.openElements.pop(), me.insertionMode = InsertionMode.IN_TABLE);
      break;
    }
    case TAG_ID.TEMPLATE: {
      templateEndTagInHead(me, ue);
      break;
    }
    case TAG_ID.COL:
      break;
    default:
      tokenInColumnGroup(me, ue);
  }
}
function tokenInColumnGroup(me, ue) {
  me.openElements.currentTagId === TAG_ID.COLGROUP && (me.openElements.pop(), me.insertionMode = InsertionMode.IN_TABLE, me._processToken(ue));
}
function startTagInTableBody(me, ue) {
  switch (ue.tagID) {
    case TAG_ID.TR: {
      me.openElements.clearBackToTableBodyContext(), me._insertElement(ue, NS.HTML), me.insertionMode = InsertionMode.IN_ROW;
      break;
    }
    case TAG_ID.TH:
    case TAG_ID.TD: {
      me.openElements.clearBackToTableBodyContext(), me._insertFakeElement(TAG_NAMES.TR, TAG_ID.TR), me.insertionMode = InsertionMode.IN_ROW, startTagInRow(me, ue);
      break;
    }
    case TAG_ID.CAPTION:
    case TAG_ID.COL:
    case TAG_ID.COLGROUP:
    case TAG_ID.TBODY:
    case TAG_ID.TFOOT:
    case TAG_ID.THEAD: {
      me.openElements.hasTableBodyContextInTableScope() && (me.openElements.clearBackToTableBodyContext(), me.openElements.pop(), me.insertionMode = InsertionMode.IN_TABLE, startTagInTable(me, ue));
      break;
    }
    default:
      startTagInTable(me, ue);
  }
}
function endTagInTableBody(me, ue) {
  const Qe = ue.tagID;
  switch (ue.tagID) {
    case TAG_ID.TBODY:
    case TAG_ID.TFOOT:
    case TAG_ID.THEAD: {
      me.openElements.hasInTableScope(Qe) && (me.openElements.clearBackToTableBodyContext(), me.openElements.pop(), me.insertionMode = InsertionMode.IN_TABLE);
      break;
    }
    case TAG_ID.TABLE: {
      me.openElements.hasTableBodyContextInTableScope() && (me.openElements.clearBackToTableBodyContext(), me.openElements.pop(), me.insertionMode = InsertionMode.IN_TABLE, endTagInTable(me, ue));
      break;
    }
    case TAG_ID.BODY:
    case TAG_ID.CAPTION:
    case TAG_ID.COL:
    case TAG_ID.COLGROUP:
    case TAG_ID.HTML:
    case TAG_ID.TD:
    case TAG_ID.TH:
    case TAG_ID.TR:
      break;
    default:
      endTagInTable(me, ue);
  }
}
function startTagInRow(me, ue) {
  switch (ue.tagID) {
    case TAG_ID.TH:
    case TAG_ID.TD: {
      me.openElements.clearBackToTableRowContext(), me._insertElement(ue, NS.HTML), me.insertionMode = InsertionMode.IN_CELL, me.activeFormattingElements.insertMarker();
      break;
    }
    case TAG_ID.CAPTION:
    case TAG_ID.COL:
    case TAG_ID.COLGROUP:
    case TAG_ID.TBODY:
    case TAG_ID.TFOOT:
    case TAG_ID.THEAD:
    case TAG_ID.TR: {
      me.openElements.hasInTableScope(TAG_ID.TR) && (me.openElements.clearBackToTableRowContext(), me.openElements.pop(), me.insertionMode = InsertionMode.IN_TABLE_BODY, startTagInTableBody(me, ue));
      break;
    }
    default:
      startTagInTable(me, ue);
  }
}
function endTagInRow(me, ue) {
  switch (ue.tagID) {
    case TAG_ID.TR: {
      me.openElements.hasInTableScope(TAG_ID.TR) && (me.openElements.clearBackToTableRowContext(), me.openElements.pop(), me.insertionMode = InsertionMode.IN_TABLE_BODY);
      break;
    }
    case TAG_ID.TABLE: {
      me.openElements.hasInTableScope(TAG_ID.TR) && (me.openElements.clearBackToTableRowContext(), me.openElements.pop(), me.insertionMode = InsertionMode.IN_TABLE_BODY, endTagInTableBody(me, ue));
      break;
    }
    case TAG_ID.TBODY:
    case TAG_ID.TFOOT:
    case TAG_ID.THEAD: {
      (me.openElements.hasInTableScope(ue.tagID) || me.openElements.hasInTableScope(TAG_ID.TR)) && (me.openElements.clearBackToTableRowContext(), me.openElements.pop(), me.insertionMode = InsertionMode.IN_TABLE_BODY, endTagInTableBody(me, ue));
      break;
    }
    case TAG_ID.BODY:
    case TAG_ID.CAPTION:
    case TAG_ID.COL:
    case TAG_ID.COLGROUP:
    case TAG_ID.HTML:
    case TAG_ID.TD:
    case TAG_ID.TH:
      break;
    default:
      endTagInTable(me, ue);
  }
}
function startTagInCell(me, ue) {
  const Qe = ue.tagID;
  TABLE_VOID_ELEMENTS.has(Qe) ? (me.openElements.hasInTableScope(TAG_ID.TD) || me.openElements.hasInTableScope(TAG_ID.TH)) && (me._closeTableCell(), startTagInRow(me, ue)) : startTagInBody(me, ue);
}
function endTagInCell(me, ue) {
  const Qe = ue.tagID;
  switch (Qe) {
    case TAG_ID.TD:
    case TAG_ID.TH: {
      me.openElements.hasInTableScope(Qe) && (me.openElements.generateImpliedEndTags(), me.openElements.popUntilTagNamePopped(Qe), me.activeFormattingElements.clearToLastMarker(), me.insertionMode = InsertionMode.IN_ROW);
      break;
    }
    case TAG_ID.TABLE:
    case TAG_ID.TBODY:
    case TAG_ID.TFOOT:
    case TAG_ID.THEAD:
    case TAG_ID.TR: {
      me.openElements.hasInTableScope(Qe) && (me._closeTableCell(), endTagInRow(me, ue));
      break;
    }
    case TAG_ID.BODY:
    case TAG_ID.CAPTION:
    case TAG_ID.COL:
    case TAG_ID.COLGROUP:
    case TAG_ID.HTML:
      break;
    default:
      endTagInBody(me, ue);
  }
}
function startTagInSelect(me, ue) {
  switch (ue.tagID) {
    case TAG_ID.HTML: {
      startTagInBody(me, ue);
      break;
    }
    case TAG_ID.OPTION: {
      me.openElements.currentTagId === TAG_ID.OPTION && me.openElements.pop(), me._insertElement(ue, NS.HTML);
      break;
    }
    case TAG_ID.OPTGROUP: {
      me.openElements.currentTagId === TAG_ID.OPTION && me.openElements.pop(), me.openElements.currentTagId === TAG_ID.OPTGROUP && me.openElements.pop(), me._insertElement(ue, NS.HTML);
      break;
    }
    case TAG_ID.INPUT:
    case TAG_ID.KEYGEN:
    case TAG_ID.TEXTAREA:
    case TAG_ID.SELECT: {
      me.openElements.hasInSelectScope(TAG_ID.SELECT) && (me.openElements.popUntilTagNamePopped(TAG_ID.SELECT), me._resetInsertionMode(), ue.tagID !== TAG_ID.SELECT && me._processStartTag(ue));
      break;
    }
    case TAG_ID.SCRIPT:
    case TAG_ID.TEMPLATE: {
      startTagInHead(me, ue);
      break;
    }
  }
}
function endTagInSelect(me, ue) {
  switch (ue.tagID) {
    case TAG_ID.OPTGROUP: {
      me.openElements.stackTop > 0 && me.openElements.currentTagId === TAG_ID.OPTION && me.openElements.tagIDs[me.openElements.stackTop - 1] === TAG_ID.OPTGROUP && me.openElements.pop(), me.openElements.currentTagId === TAG_ID.OPTGROUP && me.openElements.pop();
      break;
    }
    case TAG_ID.OPTION: {
      me.openElements.currentTagId === TAG_ID.OPTION && me.openElements.pop();
      break;
    }
    case TAG_ID.SELECT: {
      me.openElements.hasInSelectScope(TAG_ID.SELECT) && (me.openElements.popUntilTagNamePopped(TAG_ID.SELECT), me._resetInsertionMode());
      break;
    }
    case TAG_ID.TEMPLATE: {
      templateEndTagInHead(me, ue);
      break;
    }
  }
}
function startTagInSelectInTable(me, ue) {
  const Qe = ue.tagID;
  Qe === TAG_ID.CAPTION || Qe === TAG_ID.TABLE || Qe === TAG_ID.TBODY || Qe === TAG_ID.TFOOT || Qe === TAG_ID.THEAD || Qe === TAG_ID.TR || Qe === TAG_ID.TD || Qe === TAG_ID.TH ? (me.openElements.popUntilTagNamePopped(TAG_ID.SELECT), me._resetInsertionMode(), me._processStartTag(ue)) : startTagInSelect(me, ue);
}
function endTagInSelectInTable(me, ue) {
  const Qe = ue.tagID;
  Qe === TAG_ID.CAPTION || Qe === TAG_ID.TABLE || Qe === TAG_ID.TBODY || Qe === TAG_ID.TFOOT || Qe === TAG_ID.THEAD || Qe === TAG_ID.TR || Qe === TAG_ID.TD || Qe === TAG_ID.TH ? me.openElements.hasInTableScope(Qe) && (me.openElements.popUntilTagNamePopped(TAG_ID.SELECT), me._resetInsertionMode(), me.onEndTag(ue)) : endTagInSelect(me, ue);
}
function startTagInTemplate(me, ue) {
  switch (ue.tagID) {
    case TAG_ID.BASE:
    case TAG_ID.BASEFONT:
    case TAG_ID.BGSOUND:
    case TAG_ID.LINK:
    case TAG_ID.META:
    case TAG_ID.NOFRAMES:
    case TAG_ID.SCRIPT:
    case TAG_ID.STYLE:
    case TAG_ID.TEMPLATE:
    case TAG_ID.TITLE: {
      startTagInHead(me, ue);
      break;
    }
    case TAG_ID.CAPTION:
    case TAG_ID.COLGROUP:
    case TAG_ID.TBODY:
    case TAG_ID.TFOOT:
    case TAG_ID.THEAD: {
      me.tmplInsertionModeStack[0] = InsertionMode.IN_TABLE, me.insertionMode = InsertionMode.IN_TABLE, startTagInTable(me, ue);
      break;
    }
    case TAG_ID.COL: {
      me.tmplInsertionModeStack[0] = InsertionMode.IN_COLUMN_GROUP, me.insertionMode = InsertionMode.IN_COLUMN_GROUP, startTagInColumnGroup(me, ue);
      break;
    }
    case TAG_ID.TR: {
      me.tmplInsertionModeStack[0] = InsertionMode.IN_TABLE_BODY, me.insertionMode = InsertionMode.IN_TABLE_BODY, startTagInTableBody(me, ue);
      break;
    }
    case TAG_ID.TD:
    case TAG_ID.TH: {
      me.tmplInsertionModeStack[0] = InsertionMode.IN_ROW, me.insertionMode = InsertionMode.IN_ROW, startTagInRow(me, ue);
      break;
    }
    default:
      me.tmplInsertionModeStack[0] = InsertionMode.IN_BODY, me.insertionMode = InsertionMode.IN_BODY, startTagInBody(me, ue);
  }
}
function endTagInTemplate(me, ue) {
  ue.tagID === TAG_ID.TEMPLATE && templateEndTagInHead(me, ue);
}
function eofInTemplate(me, ue) {
  me.openElements.tmplCount > 0 ? (me.openElements.popUntilTagNamePopped(TAG_ID.TEMPLATE), me.activeFormattingElements.clearToLastMarker(), me.tmplInsertionModeStack.shift(), me._resetInsertionMode(), me.onEof(ue)) : stopParsing(me, ue);
}
function startTagAfterBody(me, ue) {
  ue.tagID === TAG_ID.HTML ? startTagInBody(me, ue) : tokenAfterBody(me, ue);
}
function endTagAfterBody(me, ue) {
  var Qe;
  if (ue.tagID === TAG_ID.HTML) {
    if (me.fragmentContext || (me.insertionMode = InsertionMode.AFTER_AFTER_BODY), me.options.sourceCodeLocationInfo && me.openElements.tagIDs[0] === TAG_ID.HTML) {
      me._setEndLocation(me.openElements.items[0], ue);
      const Ue = me.openElements.items[1];
      Ue && !(!((Qe = me.treeAdapter.getNodeSourceCodeLocation(Ue)) === null || Qe === void 0) && Qe.endTag) && me._setEndLocation(Ue, ue);
    }
  } else
    tokenAfterBody(me, ue);
}
function tokenAfterBody(me, ue) {
  me.insertionMode = InsertionMode.IN_BODY, modeInBody(me, ue);
}
function startTagInFrameset(me, ue) {
  switch (ue.tagID) {
    case TAG_ID.HTML: {
      startTagInBody(me, ue);
      break;
    }
    case TAG_ID.FRAMESET: {
      me._insertElement(ue, NS.HTML);
      break;
    }
    case TAG_ID.FRAME: {
      me._appendElement(ue, NS.HTML), ue.ackSelfClosing = !0;
      break;
    }
    case TAG_ID.NOFRAMES: {
      startTagInHead(me, ue);
      break;
    }
  }
}
function endTagInFrameset(me, ue) {
  ue.tagID === TAG_ID.FRAMESET && !me.openElements.isRootHtmlElementCurrent() && (me.openElements.pop(), !me.fragmentContext && me.openElements.currentTagId !== TAG_ID.FRAMESET && (me.insertionMode = InsertionMode.AFTER_FRAMESET));
}
function startTagAfterFrameset(me, ue) {
  switch (ue.tagID) {
    case TAG_ID.HTML: {
      startTagInBody(me, ue);
      break;
    }
    case TAG_ID.NOFRAMES: {
      startTagInHead(me, ue);
      break;
    }
  }
}
function endTagAfterFrameset(me, ue) {
  ue.tagID === TAG_ID.HTML && (me.insertionMode = InsertionMode.AFTER_AFTER_FRAMESET);
}
function startTagAfterAfterBody(me, ue) {
  ue.tagID === TAG_ID.HTML ? startTagInBody(me, ue) : tokenAfterAfterBody(me, ue);
}
function tokenAfterAfterBody(me, ue) {
  me.insertionMode = InsertionMode.IN_BODY, modeInBody(me, ue);
}
function startTagAfterAfterFrameset(me, ue) {
  switch (ue.tagID) {
    case TAG_ID.HTML: {
      startTagInBody(me, ue);
      break;
    }
    case TAG_ID.NOFRAMES: {
      startTagInHead(me, ue);
      break;
    }
  }
}
function nullCharacterInForeignContent(me, ue) {
  ue.chars = REPLACEMENT_CHARACTER, me._insertCharacters(ue);
}
function characterInForeignContent(me, ue) {
  me._insertCharacters(ue), me.framesetOk = !1;
}
function popUntilHtmlOrIntegrationPoint(me) {
  for (; me.treeAdapter.getNamespaceURI(me.openElements.current) !== NS.HTML && !me._isIntegrationPoint(me.openElements.currentTagId, me.openElements.current); )
    me.openElements.pop();
}
function startTagInForeignContent(me, ue) {
  if (causesExit(ue))
    popUntilHtmlOrIntegrationPoint(me), me._startTagOutsideForeignContent(ue);
  else {
    const Qe = me._getAdjustedCurrentElement(), Ue = me.treeAdapter.getNamespaceURI(Qe);
    Ue === NS.MATHML ? adjustTokenMathMLAttrs(ue) : Ue === NS.SVG && (adjustTokenSVGTagName(ue), adjustTokenSVGAttrs(ue)), adjustTokenXMLAttrs(ue), ue.selfClosing ? me._appendElement(ue, Ue) : me._insertElement(ue, Ue), ue.ackSelfClosing = !0;
  }
}
function endTagInForeignContent(me, ue) {
  if (ue.tagID === TAG_ID.P || ue.tagID === TAG_ID.BR) {
    popUntilHtmlOrIntegrationPoint(me), me._endTagOutsideForeignContent(ue);
    return;
  }
  for (let Qe = me.openElements.stackTop; Qe > 0; Qe--) {
    const Ue = me.openElements.items[Qe];
    if (me.treeAdapter.getNamespaceURI(Ue) === NS.HTML) {
      me._endTagOutsideForeignContent(ue);
      break;
    }
    const He = me.treeAdapter.getTagName(Ue);
    if (He.toLowerCase() === ue.tagName) {
      ue.tagName = He, me.openElements.shortenToLength(Qe);
      break;
    }
  }
}
TAG_NAMES.AREA, TAG_NAMES.BASE, TAG_NAMES.BASEFONT, TAG_NAMES.BGSOUND, TAG_NAMES.BR, TAG_NAMES.COL, TAG_NAMES.EMBED, TAG_NAMES.FRAME, TAG_NAMES.HR, TAG_NAMES.IMG, TAG_NAMES.INPUT, TAG_NAMES.KEYGEN, TAG_NAMES.LINK, TAG_NAMES.META, TAG_NAMES.PARAM, TAG_NAMES.SOURCE, TAG_NAMES.TRACK, TAG_NAMES.WBR;
const knownMdxNames = /* @__PURE__ */ new Set([
  "mdxFlowExpression",
  "mdxJsxFlowElement",
  "mdxJsxTextElement",
  "mdxTextExpression",
  "mdxjsEsm"
]), parseOptions = { sourceCodeLocationInfo: !0, scriptingEnabled: !1 };
function raw(me, ue) {
  const Qe = documentMode(me), Ue = zwitch("type", {
    handlers: { root, element, text, comment, doctype, raw: handleRaw },
    unknown
  }), He = {
    parser: Qe ? new Parser(parseOptions) : Parser.getFragmentParser(void 0, parseOptions),
    handle(Ke) {
      Ue(Ke, He);
    },
    stitches: !1,
    options: ue || {}
  };
  Ue(me, He), resetTokenizer(He, pointStart());
  const Ge = Qe ? He.parser.document : He.parser.getFragment(), Xe = fromParse5(Ge, {
    // To do: support `space`?
    file: He.options.file
  });
  return He.stitches && visit(Xe, "comment", function(Ke, $e, Je) {
    const Ze = (
      /** @type {Stitch} */
      /** @type {unknown} */
      Ke
    );
    if (Ze.value.stitch && Je && $e !== void 0) {
      const nt = Je.children;
      return nt[$e] = Ze.value.stitch, $e;
    }
  }), Xe.type === "root" && Xe.children.length === 1 && Xe.children[0].type === me.type ? Xe.children[0] : Xe;
}
function all(me, ue) {
  let Qe = -1;
  if (me)
    for (; ++Qe < me.length; )
      ue.handle(me[Qe]);
}
function root(me, ue) {
  all(me.children, ue);
}
function element(me, ue) {
  startTag(me, ue), all(me.children, ue), endTag(me, ue);
}
function text(me, ue) {
  const Qe = {
    type: TokenType.CHARACTER,
    chars: me.value,
    location: createParse5Location(me)
  };
  resetTokenizer(ue, pointStart(me)), ue.parser.currentToken = Qe, ue.parser._processToken(ue.parser.currentToken);
}
function doctype(me, ue) {
  const Qe = {
    type: TokenType.DOCTYPE,
    name: "html",
    forceQuirks: !1,
    publicId: "",
    systemId: "",
    location: createParse5Location(me)
  };
  resetTokenizer(ue, pointStart(me)), ue.parser.currentToken = Qe, ue.parser._processToken(ue.parser.currentToken);
}
function stitch(me, ue) {
  ue.stitches = !0;
  const Qe = cloneWithoutChildren(me);
  if ("children" in me && "children" in Qe) {
    const Ue = (
      /** @type {Root} */
      raw({ type: "root", children: me.children }, ue.options)
    );
    Qe.children = Ue.children;
  }
  comment({ type: "comment", value: { stitch: Qe } }, ue);
}
function comment(me, ue) {
  const Qe = me.value, Ue = {
    type: TokenType.COMMENT,
    data: Qe,
    location: createParse5Location(me)
  };
  resetTokenizer(ue, pointStart(me)), ue.parser.currentToken = Ue, ue.parser._processToken(ue.parser.currentToken);
}
function handleRaw(me, ue) {
  if (ue.parser.tokenizer.preprocessor.html = "", ue.parser.tokenizer.preprocessor.pos = -1, ue.parser.tokenizer.preprocessor.lastGapPos = -2, ue.parser.tokenizer.preprocessor.gapStack = [], ue.parser.tokenizer.preprocessor.skipNextNewLine = !1, ue.parser.tokenizer.preprocessor.lastChunkWritten = !1, ue.parser.tokenizer.preprocessor.endOfChunkHit = !1, ue.parser.tokenizer.preprocessor.isEol = !1, setPoint(ue, pointStart(me)), ue.parser.tokenizer.write(me.value, !1), ue.parser.tokenizer._runParsingLoop(), ue.parser.tokenizer.state === 72 || ue.parser.tokenizer.state === 78) {
    ue.parser.tokenizer.preprocessor.lastChunkWritten = !0;
    const Qe = ue.parser.tokenizer._consume();
    ue.parser.tokenizer._callState(Qe);
  }
}
function unknown(me, ue) {
  const Qe = (
    /** @type {Nodes} */
    me
  );
  if (ue.options.passThrough && ue.options.passThrough.includes(Qe.type))
    stitch(Qe, ue);
  else {
    let Ue = "";
    throw knownMdxNames.has(Qe.type) && (Ue = ". It looks like you are using MDX nodes with `hast-util-raw` (or `rehype-raw`). If you use this because you are using remark or rehype plugins that inject `'html'` nodes, then please raise an issue with that plugin, as its a bad and slow idea. If you use this because you are using markdown syntax, then you have to configure this utility (or plugin) to pass through these nodes (see `passThrough` in docs), but you can also migrate to use the MDX syntax"), new Error("Cannot compile `" + Qe.type + "` node" + Ue);
  }
}
function resetTokenizer(me, ue) {
  setPoint(me, ue);
  const Qe = me.parser.tokenizer.currentCharacterToken;
  Qe && Qe.location && (Qe.location.endLine = me.parser.tokenizer.preprocessor.line, Qe.location.endCol = me.parser.tokenizer.preprocessor.col + 1, Qe.location.endOffset = me.parser.tokenizer.preprocessor.offset + 1, me.parser.currentToken = Qe, me.parser._processToken(me.parser.currentToken)), me.parser.tokenizer.paused = !1, me.parser.tokenizer.inLoop = !1, me.parser.tokenizer.active = !1, me.parser.tokenizer.returnState = TokenizerMode.DATA, me.parser.tokenizer.charRefCode = -1, me.parser.tokenizer.consumedAfterSnapshot = -1, me.parser.tokenizer.currentLocation = null, me.parser.tokenizer.currentCharacterToken = null, me.parser.tokenizer.currentToken = null, me.parser.tokenizer.currentAttr = { name: "", value: "" };
}
function setPoint(me, ue) {
  if (ue && ue.offset !== void 0) {
    const Qe = {
      startLine: ue.line,
      startCol: ue.column,
      startOffset: ue.offset,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    };
    me.parser.tokenizer.preprocessor.lineStartPos = -ue.column + 1, me.parser.tokenizer.preprocessor.droppedBufferSize = ue.offset, me.parser.tokenizer.preprocessor.line = ue.line, me.parser.tokenizer.currentLocation = Qe;
  }
}
function startTag(me, ue) {
  const Qe = me.tagName.toLowerCase();
  if (ue.parser.tokenizer.state === TokenizerMode.PLAINTEXT) return;
  resetTokenizer(ue, pointStart(me));
  const Ue = ue.parser.openElements.current;
  let He = "namespaceURI" in Ue ? Ue.namespaceURI : webNamespaces.html;
  He === webNamespaces.html && Qe === "svg" && (He = webNamespaces.svg);
  const Ge = toParse5(
    // Shallow clone to not delve into `children`: we only need the attributes.
    { ...me, children: [] },
    { space: He === webNamespaces.svg ? "svg" : "html" }
  ), Xe = {
    type: TokenType.START_TAG,
    tagName: Qe,
    tagID: getTagID(Qe),
    // We always send start and end tags.
    selfClosing: !1,
    ackSelfClosing: !1,
    // Always element.
    /* c8 ignore next */
    attrs: "attrs" in Ge ? Ge.attrs : [],
    location: createParse5Location(me)
  };
  ue.parser.currentToken = Xe, ue.parser._processToken(ue.parser.currentToken), ue.parser.tokenizer.lastStartTagName = Qe;
}
function endTag(me, ue) {
  const Qe = me.tagName.toLowerCase();
  if (!ue.parser.tokenizer.inForeignNode && htmlVoidElements.includes(Qe) || ue.parser.tokenizer.state === TokenizerMode.PLAINTEXT) return;
  resetTokenizer(ue, pointEnd(me));
  const Ue = {
    type: TokenType.END_TAG,
    tagName: Qe,
    tagID: getTagID(Qe),
    selfClosing: !1,
    ackSelfClosing: !1,
    attrs: [],
    location: createParse5Location(me)
  };
  ue.parser.currentToken = Ue, ue.parser._processToken(ue.parser.currentToken), // Current element is closed.
  Qe === ue.parser.tokenizer.lastStartTagName && // `<textarea>` and `<title>`
  (ue.parser.tokenizer.state === TokenizerMode.RCDATA || // `<iframe>`, `<noembed>`, `<style>`, `<xmp>`
  ue.parser.tokenizer.state === TokenizerMode.RAWTEXT || // `<script>`
  ue.parser.tokenizer.state === TokenizerMode.SCRIPT_DATA) && (ue.parser.tokenizer.state = TokenizerMode.DATA);
}
function documentMode(me) {
  const ue = me.type === "root" ? me.children[0] : me;
  return !!(ue && (ue.type === "doctype" || ue.type === "element" && ue.tagName.toLowerCase() === "html"));
}
function createParse5Location(me) {
  const ue = pointStart(me) || {
    line: void 0,
    column: void 0,
    offset: void 0
  }, Qe = pointEnd(me) || {
    line: void 0,
    column: void 0,
    offset: void 0
  };
  return {
    startLine: ue.line,
    startCol: ue.column,
    startOffset: ue.offset,
    endLine: Qe.line,
    endCol: Qe.column,
    endOffset: Qe.offset
  };
}
function cloneWithoutChildren(me) {
  return "children" in me ? structuredClone$1({ ...me, children: [] }) : structuredClone$1(me);
}
function rehypeRaw(me) {
  return function(ue, Qe) {
    return (
      /** @type {Root} */
      raw(ue, { ...me, file: Qe })
    );
  };
}
const Wrapper$1 = qe.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  overflow: scroll;
  height: 100%;
  justify-content: space-between;
  color: #21273b;
`, Title$a = qe.h1`
  font-family: 'DM Sans';
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  margin-bottom: 24px;
`, ConsentText = qe.div`
  font-family: 'DM Sans';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  margin-bottom: 24px;
  h1 {
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
  }
  h2 {
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
  }
  h3 {
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
  }
  h4 {
    font-family: 'DM Sans';
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
  }
  h5 {
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
  }
  h6 {
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 130%;
  }
  p {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
  }
  a {
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
    text-decoration-line: underline;
    color: #0a6fdd;
  }
  hr {
    color: #757575;
    margin-block-start: 24px;
    margin-block-end: 24px;
  }
`, ConsentCheckWrapper = qe.div`
  display: flex;
  padding: 20px 16px;
  gap: 8px;
  border-radius: 16px;
  background: #f2f7ff;
  width: 100%;
  margin-bottom: 24px;
  &.single-line {
    align-items: center;
  }
`, ConsentCheck = qe.div`
  width: 28px;
`, consentCheckTextStyles = Ae`
  font-family: 'DM Sans';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
`, ConsentCheckText = qe.div`
  ${consentCheckTextStyles}
  flex: 1;
  p {
    ${consentCheckTextStyles}
    margin-block-start: 0;
    margin-block-end: 0;
  }
  a {
    color: #0a6fdd;
  }
`, CheckBox$1 = qe.input.attrs({ type: "checkbox" })`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 28px;
  width: 28px;
  z-index: 2;
`, CustomCheckBox$1 = qe.div`
  position: relative;
  height: 28px;
  width: 28px;
  min-width: 28px;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #e9e9eb;

  &:after {
    content: '';
    position: absolute;
    display: none;
    left: 10px;
    top: 7px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`, Button$6 = qe.button`
  width: 100%;
  padding: 18px 16px;
  border-radius: ${(me) => me.theme.buttonBorderRadius ?? "15px"};
  background: ${(me) => me.theme.main};
  color: white;
  font-family: 'DM Sans';
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  &:disabled {
    color: #757575;
    background-color: #e9e9eb;
  }
`, CheckBoxWrapper = qe.div`
  width: 28px;
  height: 28px;

  ${CheckBox$1}:checked ~ ${CustomCheckBox$1} {
    background: ${(me) => me.theme.main};
  }

  ${CheckBox$1}:checked ~ ${CustomCheckBox$1}:after {
    display: block;
  }
`;
CheckBoxWrapper.defaultProps = {
  theme
};
Button$6.defaultProps = {
  theme
};
async function getConsent$1({ token: me, id: ue }) {
  return api.get("/omni/get/combined-consent?", {
    headers: {
      "X-Incode-Hardware-Id": me
    },
    params: {
      id: ue,
      language: i18nInstance.language
    }
  }).then((Qe) => Qe.data);
}
async function submitConsent({ token: me, data: ue }) {
  return api.post(
    "omni/sign-combined-consent",
    { ...ue },
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).then((Qe) => Qe.data);
}
const useIsSingleLine = () => {
  const [me, ue] = useState([]), Qe = useCallback((Ue) => {
    if (Ue !== null) {
      const He = Ue.clientHeight;
      Ue.style.whiteSpace = "nowrap";
      const Ge = Ue.clientHeight;
      Ue.style.whiteSpace = "unset", ue((Xe) => [
        ...Xe,
        He === Ge
      ]);
    }
  }, []);
  return [me, Qe];
};
function CombinedConsent({
  token: me,
  consentId: ue,
  onSuccess: Qe
}) {
  const { t: Ue } = useTranslation(), [He, Ge] = useIsSingleLine(), [Xe, Ke] = useState(null), [$e, Je] = useState(null), Ze = Xe == null ? void 0 : Xe.consents.some((et) => !et.optional && !$e[et.checkboxId]);
  useModuleEvents({
    module: eventModuleNames.combinedConsent,
    token: me.token
  }), useScreenEvents({
    module: eventModuleNames.combinedConsent,
    screen: eventScreenNames.combinedConsent,
    token: me.token
  }), useEffect(() => {
    getConsent$1({ token: me.token, id: ue }).then(
      (et) => {
        var it;
        Ke({
          ...et
        });
        const rt = (it = et == null ? void 0 : et.consents) == null ? void 0 : it.reduce((ot, at) => ({
          // biome-ignore lint/performance/noAccumulatingSpread: fix this
          ...ot,
          [at.checkboxId]: !1
        }), {});
        Je({ ...rt });
      }
    );
  }, [me.token, ue]), useEffect(() => {
    Object.hasOwn || (Object.hasOwn = (et, rt) => Object.prototype.hasOwnProperty.call(et, rt));
  }, []);
  const nt = (et) => {
    Je((rt) => {
      const it = !rt[et];
      return {
        ...rt,
        [et]: it
      };
    });
  }, tt = () => {
    submitConsent({
      token: me.token,
      data: {
        languageConsentId: Xe.languageConsentId,
        checkboxes: { ...$e }
      }
    }).then(() => {
      addEvent({
        token: me.token,
        code: "combinedConsentGiven"
      }), Qe();
    });
  };
  return Xe ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Wrapper$1, { id: "combined-consent", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Title$a, { children: Xe.title }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ConsentText, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Markdown,
        {
          children: Xe.terms.trim(),
          rehypePlugins: [rehypeRaw]
        }
      ) }),
      Xe.consents && !!Xe.consents.length && /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: Xe.consents.map((et, rt) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
        ConsentCheckWrapper,
        {
          className: `combined-consent-label-wrapper${He[rt] ? " single-line" : ""}`,
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(ConsentCheck, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
              CheckBoxWrapper,
              {
                onClick: () => nt(et.checkboxId),
                className: "combined-consent-checkbox-wrapper",
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    CheckBox$1,
                    {
                      className: "combined-consent-checkbox",
                      checked: $e[et.checkboxId]
                    }
                  ),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(CustomCheckBox$1, { className: "combined-consent-custom-checkbox" })
                ]
              }
            ) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(ConsentCheckText, { ref: Ge, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              Markdown,
              {
                children: `${et.consentText} ${et.optional ? "" : "*"}`,
                rehypePlugins: [rehypeRaw]
              }
            ) })
          ]
        },
        et.checkboxId
      )) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button$6,
      {
        theme,
        disabled: Ze,
        onClick: tt,
        className: "combined-consent-button",
        children: Ue("biometricConsent.button.continue")
      }
    )
  ] }) : null;
}
function renderBiometricConsent(me, { token: ue, onSuccess: Qe, consentId: Ue }) {
  const He = createRoot$1(me), Ge = {
    onSuccess: handleUnmountRoot(Qe, He, me),
    onBoarding: this,
    token: ue,
    consentId: Ue
  };
  customRender(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(CombinedConsent, { ...Ge }) }),
    me,
    He
  );
}
const Wrapper = qe.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 25px;
  overflow: scroll;
  height: 100%;

  @media only screen and (max-height: 480px) {
    padding: 20px;
  }
`, Title$9 = qe.h1`
  text-align: center;
  font-size: 2rem;
  font-weight: 700;

  @media only screen and (max-height: 480px) {
    margin: 0 0 15px 0;
  }
`, Paragraph$3 = qe.p`
  font-size: 14px;
  margin-top: 10px;

  a {
    color: ${(me) => me.theme.main};
  }

  &:last-of-type {
    margin-bottom: 0;
  }

  @media only screen and (max-height: 480px) {
    font-size: 12px;
    margin: 0 0 10px 0;
    &:last-of-type {
      margin: 0;
    }
  }
`, CustomCheckBox = qe.div`
  position: relative;
  height: 25px;
  width: 25px;
  min-width: 25px;
  margin-right: 10px;
  background-color: #eee;
  border-radius: 5px;

  &:after {
    content: '';
    position: absolute;
    display: none;
  }
`, CheckBox = qe.input.attrs({ type: "checkbox" })`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`, CheckboxLabel = qe.label`
  display: flex;
  align-items: center;
  position: relative;
  margin: 30px 0;
  font-size: 14px;
  line-height: normal;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  ${CheckBox}:checked ~ ${CustomCheckBox} {
    background-color: ${(me) => me.theme.main};
  }

  ${CheckBox}:checked ~ ${CustomCheckBox}:after {
    display: block;
  }

  ${CustomCheckBox}:after {
    left: 10px;
    top: 7px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  @media only screen and (max-height: 480px) {
    margin: 15px 0;
  }
`;
CheckboxLabel.defaultProps = {
  theme
};
const ButtonWrapper = qe.div`
  display: flex;
  justify-content: center;
`;
Paragraph$3.defaultProps = {
  theme
};
function AcceptCheck({ id: me, consentChecked: ue, setConsentChecked: Qe, text: Ue }) {
  function He() {
    Qe(!ue);
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    CheckboxLabel,
    {
      htmlFor: me,
      className: "accept-check",
      onChange: He,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(CheckBox, { id: me }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(CustomCheckBox, {}),
        Ue
      ]
    }
  );
}
const MLConsent = ({
  token: me,
  onBoarding: ue,
  onSuccess: Qe,
  type: Ue
}) => {
  const { t: He } = useTranslation(), [Ge, Xe] = useState(!1), [Ke, $e] = useState();
  useModuleEvents({
    module: eventModuleNames.mlConsent,
    token: me.token
  }), useScreenEvents({
    module: eventModuleNames.mlConsent,
    screen: eventScreenNames.mlConsent,
    token: me.token
  }), useEffect(() => {
    getPrivacyConsentData({ session: me, type: "ML", regulationType: Ue }).then(
      ({ consents: Ze }) => {
        const nt = Ze.find(
          ({ consentType: tt }) => tt === "ML"
        );
        $e(nt);
      }
    );
  }, [me]);
  const Je = async () => {
    await ue.addMLConsent({
      token: me.token,
      id: Ke.id,
      mlConsentChecked: Ge
    }), Qe();
  };
  return Ke ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Wrapper, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Title$9, { children: Ke.title }),
    Ke.text.split(`
`).filter((Ze) => !!Ze.trim()).map((Ze, nt) => (
      // biome-ignore lint/security/noDangerouslySetInnerHtml: line comes from server and it's already safe
      // biome-ignore lint/suspicious/noArrayIndexKey: key is okay in this case
      /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph$3, { dangerouslySetInnerHTML: { __html: Ze } }, nt)
    )),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AcceptCheck,
      {
        id: "clientConsent",
        consentChecked: Ge,
        setConsentChecked: Xe,
        text: He("mlConsent.checkboxLabel")
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button$a, { theme, onClick: Je, children: He("mlConsent.button.continue") }) })
  ] }) : null;
};
function renderMlConsent(me, { token: ue, type: Qe, onSuccess: Ue }) {
  const He = createRoot$1(me), Ge = {
    onSuccess: handleUnmountRoot(Ue, He, me),
    onBoarding: this,
    type: Qe,
    token: ue
  };
  customRender(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { token: ue.token, children: /* @__PURE__ */ jsxRuntimeExports.jsx(MLConsent, { ...Ge }) }),
    me,
    He
  );
}
const disallowedMarkdownElements = ["img"], defaultPrivacyConsent = {
  default: !0,
  consentType: "PRIVACY",
  title: "newPrivacyConsent.title",
  text: `
newPrivacyConsent.text1

newPrivacyConsent.text2

newPrivacyConsent.text3

newPrivacyConsent.text4
  `
}, getAcceptCheckText = ({
  isAeroMexicoClient: me,
  t: ue
}) => me ? ue("consentCheck.aeromexico") : /* @__PURE__ */ jsxRuntimeExports.jsx(Markdown, { disallowedElements: disallowedMarkdownElements, children: ue("newPrivacyConsent.checkboxLabel") });
function NormalPrivacyConsent({
  goNext: me,
  consent: ue,
  addPrivacyConsent: Qe,
  session: Ue,
  isAeroMexicoClient: He = !1
}) {
  const { t: Ge } = useTranslation(), [Xe, Ke] = useState(!1), [$e, Je] = useState(!1), Ze = () => {
    Qe({
      title: ue.title,
      content: ue.text,
      isDefault: ue.default
    }), addEvent({
      token: Ue.token,
      code: "userConsentGiven"
    }), me();
  }, nt = getAcceptCheckText({
    isAeroMexicoClient: He,
    t: Ge
  }), tt = He ? !Xe || !$e : !Xe, et = ue.default ? Ge(ue.title) : ue.title, rt = ue.text.split(`
`).filter((it) => !!it.trim());
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    ConsentWrapper$1,
    {
      role: "region",
      "aria-live": "assertive",
      className: `
      ${ue.default ? "IncodeDefaultConsent" : "IncodeCustomConsent"}
    `,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(ConsentTitle, { tabIndex: 0, children: et }),
        rt.map((it, ot) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: index is okay in this case
          /* @__PURE__ */ jsxRuntimeExports.jsx(ConsentParagraph, { tabIndex: 0, children: ue.default ? /* @__PURE__ */ jsxRuntimeExports.jsx(Markdown, { disallowedElements: disallowedMarkdownElements, children: Ge(it) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Markdown, { disallowedElements: disallowedMarkdownElements, children: it }) }, ot)
        )),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          AcceptCheck$2,
          {
            consentChecked: Xe,
            setConsentChecked: Ke,
            text: nt,
            id: "one"
          }
        ),
        He ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          AcceptCheck$2,
          {
            consentChecked: $e,
            setConsentChecked: Je,
            text: Ge("privacyCheck.aeromexico"),
            id: "two"
          }
        ) : null,
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Button$a,
          {
            tabIndex: 0,
            "aria-disabled": tt,
            disabled: tt,
            onClick: Ze,
            children: Ge("privacyConsent.button.continue")
          }
        ) })
      ]
    }
  );
}
function PrivacyConsent({
  session: me,
  title: ue,
  text: Qe,
  goNext: Ue,
  isAeroMexicoClient: He
}) {
  const { t: Ge } = useTranslation(), [Xe, Ke] = useState(null);
  useEffect(() => {
    Object.hasOwn || (Object.hasOwn = (Ze, nt) => Object.prototype.hasOwnProperty.call(Ze, nt));
  }, []);
  const $e = (Ze) => {
    const nt = Ze.split(`
`);
    return nt.length === 1 ? nt.join(" ") : nt.filter((tt) => !!tt.trim()).map((tt) => Ge(tt)).join(" ");
  }, Je = ({
    title: Ze,
    content: nt,
    isDefault: tt
  }) => {
    addConsent({
      title: `${tt ? Ge(Ze) : Ze}`,
      content: tt ? $e(nt) : nt,
      status: !0,
      session: me
    });
  };
  return useEffect(() => {
    if (ue || Qe) {
      Ke({
        title: ue || defaultPrivacyConsent.title,
        text: Qe || defaultPrivacyConsent.text,
        consentType: defaultPrivacyConsent.consentType,
        default: !Qe
      });
      return;
    }
    getPrivacyConsentData({ session: me, type: "PRIVACY" }).then(({ consents: Ze }) => {
      const nt = Ze.find(
        ({ consentType: tt }) => tt === "PRIVACY"
      );
      nt != null && nt.text ? Ke({
        ...nt,
        title: (nt == null ? void 0 : nt.title.trim()) || defaultPrivacyConsent.title,
        text: nt.text.trim() || defaultPrivacyConsent.text,
        default: !(nt != null && nt.text)
      }) : Ke(defaultPrivacyConsent);
    }).catch(() => {
      Ke(defaultPrivacyConsent);
    });
  }, [me, ue, Qe]), Xe ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    NormalPrivacyConsent,
    {
      consent: Xe,
      goNext: Ue,
      addPrivacyConsent: Je,
      session: me,
      isAeroMexicoClient: He
    }
  ) : null;
}
function renderUserConsent(me, {
  session: ue,
  onSuccess: Qe,
  title: Ue,
  text: He,
  isAeroMexicoClient: Ge = !1
}) {
  const Xe = createRoot$1(me), Ke = handleUnmountRoot(Qe, Xe, me);
  customRender(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { token: ue.token, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      PrivacyConsent,
      {
        goNext: Ke,
        session: ue,
        title: Ue,
        text: He,
        isAeroMexicoClient: Ge
      }
    ) }),
    me,
    Xe
  );
}
const version$1 = "1.75.1";
function r$1(me) {
  for (var ue = "", Qe = 0; Qe < me.length; ++Qe) if (Qe > 0) {
    var Ue = me[Qe].toLowerCase();
    Ue !== me[Qe] ? ue += " ".concat(Ue) : ue += me[Qe];
  } else ue += me[Qe].toUpperCase();
  return ue;
}
function o(me, ue) {
  return function(Qe, Ue) {
    return Object.prototype.hasOwnProperty.call(Qe, Ue);
  }(me, ue) ? me[ue] : void 0;
}
var i$1 = { default: "endpoint" }, u = { default: "tlsEndpoint" }, a = "Client timeout", R = "Network connection error", c = "Network request aborted", s = "Response cannot be parsed", E = "Blocked by CSP", f = "The endpoint parameter is not a valid URL", d = /* @__PURE__ */ r$1("WrongRegion"), l = /* @__PURE__ */ r$1("SubscriptionNotActive"), _ = /* @__PURE__ */ r$1("UnsupportedVersion"), p = /* @__PURE__ */ r$1("InstallationMethodRestricted"), v = /* @__PURE__ */ r$1("HostnameRestricted"), O = /* @__PURE__ */ r$1("IntegrationFailed"), I = "API key required", h = "API key not found", N = "API key expired", T = "Request cannot be parsed", m = "Request failed", w = "Request failed to process", A = "Too many requests, rate limit exceeded", P = "Not available for this origin", y = "Not available with restricted header", D = I, S = h, L = N, U = "3.8.6", b = "9319";
function g(me, ue) {
  var Qe = [];
  return function(Ue, He) {
    var Ge = 5, Xe = (tt = Ue, et = __spreadArray$1([], tt, !0), { current: function() {
      return et[0];
    }, postpone: function() {
      var it = et.shift();
      it !== void 0 && et.push(it);
    }, exclude: function() {
      et.shift();
    } }), Ke = (Je = 100, Ze = 3e3, nt = 0, function() {
      return Math.random() * Math.min(Ze, Je * Math.pow(2, nt++));
    }), $e = Xe.current(), Je, Ze, nt, tt, et;
    if ($e === void 0) return Promise.reject(new TypeError("The list of script URL patterns is empty"));
    var rt = function(it, ot) {
      return He(it).catch(function(at) {
        if (ot + 1 >= Ge) throw at;
        (function(lt) {
          if (!(lt instanceof Error)) return !1;
          var dt = lt.message;
          return dt === E || dt === b;
        })(at) ? Xe.exclude() : Xe.postpone();
        var st, ut = Xe.current();
        if (ut === void 0) throw at;
        return (st = Ke(), new Promise(function(lt) {
          return setTimeout(lt, st);
        })).then(function() {
          return rt(ut, ot + 1);
        });
      });
    };
    return rt($e, 0);
  }(me, function(Ue) {
    var He = /* @__PURE__ */ new Date(), Ge = function(Ke) {
      return Qe.push({ url: Ue, startedAt: He, finishedAt: /* @__PURE__ */ new Date(), error: Ke });
    }, Xe = ue(Ue);
    return Xe.then(function() {
      return Ge();
    }, Ge), Xe;
  }).then(function(Ue) {
    return [Ue, Qe];
  });
}
var C = "https://fpnpmcdn.net/v<version>/<apiKey>/loader_v<loaderVersion>.js", K = C, M = "Failed to load the JS script of the agent";
function B(me) {
  var ue;
  me.scriptUrlPattern;
  var Qe = me.token, Ue = me.apiKey, He = Ue === void 0 ? Qe : Ue, Ge = __rest$3(me, ["scriptUrlPattern", "token", "apiKey"]), Xe = (ue = o(me, "scriptUrlPattern")) !== null && ue !== void 0 ? ue : C, Ke = function() {
    var Ze = [], nt = function() {
      Ze.push({ time: /* @__PURE__ */ new Date(), state: document.visibilityState });
    }, tt = function(et, rt, it, ot) {
      return et.addEventListener(rt, it, ot), function() {
        return et.removeEventListener(rt, it, ot);
      };
    }(document, "visibilitychange", nt);
    return nt(), [Ze, tt];
  }(), $e = Ke[0], Je = Ke[1];
  return Promise.resolve().then(function() {
    if (!He || typeof He != "string") throw new Error(I);
    var Ze = function(nt, tt) {
      return (Array.isArray(nt) ? nt : [nt]).map(function(et) {
        return function(rt, it) {
          var ot = encodeURIComponent;
          return rt.replace(/<[^<>]+>/g, function(at) {
            return at === "<version>" ? "3" : at === "<apiKey>" ? ot(it) : at === "<loaderVersion>" ? ot(U) : at;
          });
        }(String(et), tt);
      });
    }(Xe, He);
    return g(Ze, F);
  }).catch(function(Ze) {
    throw Je(), function(nt) {
      return nt instanceof Error && nt.message === b ? new Error(M) : nt;
    }(Ze);
  }).then(function(Ze) {
    var nt = Ze[0], tt = Ze[1];
    return Je(), nt.load(__assign$2(__assign$2({}, Ge), { ldi: { attempts: tt, visibilityStates: $e } }));
  });
}
function F(me) {
  return function(ue, Qe, Ue, He) {
    var Ge, Xe = document, Ke = "securitypolicyviolation", $e = function(Ze) {
      var nt = new URL(ue, location.href), tt = Ze.blockedURI;
      tt !== nt.href && tt !== nt.protocol.slice(0, -1) && tt !== nt.origin || (Ge = Ze, Je());
    };
    Xe.addEventListener(Ke, $e);
    var Je = function() {
      return Xe.removeEventListener(Ke, $e);
    };
    return Promise.resolve().then(Qe).then(function(Ze) {
      return Je(), Ze;
    }, function(Ze) {
      return new Promise(function(nt) {
        return setTimeout(nt);
      }).then(function() {
        if (Je(), Ge) return Ue(Ge);
        throw Ze;
      });
    });
  }(me, function() {
    return function(ue) {
      return new Promise(function(Qe, Ue) {
        var He = document.createElement("script"), Ge = function() {
          var Ke;
          return (Ke = He.parentNode) === null || Ke === void 0 ? void 0 : Ke.removeChild(He);
        }, Xe = document.head || document.getElementsByTagName("head")[0];
        He.onload = function() {
          Ge(), Qe();
        }, He.onerror = function() {
          Ge(), Ue(new Error(M));
        }, He.async = !0, He.src = ue, Xe.appendChild(He);
      });
    }(me);
  }, function() {
    throw new Error(E);
  }).then(V);
}
function V() {
  var me = window, ue = "__fpjs_p_l_b", Qe = me[ue];
  if (function(Ue, He) {
    var Ge, Xe = (Ge = Object.getOwnPropertyDescriptor) === null || Ge === void 0 ? void 0 : Ge.call(Object, Ue, He);
    Xe != null && Xe.configurable ? delete Ue[He] : Xe && !Xe.writable || (Ue[He] = void 0);
  }(me, ue), typeof (Qe == null ? void 0 : Qe.load) != "function") throw new Error(b);
  return Qe;
}
var k = { load: B, defaultScriptUrlPattern: K, ERROR_SCRIPT_LOAD_FAIL: M, ERROR_API_KEY_EXPIRED: N, ERROR_API_KEY_INVALID: h, ERROR_API_KEY_MISSING: I, ERROR_BAD_REQUEST_FORMAT: T, ERROR_BAD_RESPONSE_FORMAT: s, ERROR_CLIENT_TIMEOUT: a, ERROR_CSP_BLOCK: E, ERROR_FORBIDDEN_ENDPOINT: v, ERROR_FORBIDDEN_HEADER: y, ERROR_FORBIDDEN_ORIGIN: P, ERROR_GENERAL_SERVER_FAILURE: m, ERROR_INSTALLATION_METHOD_RESTRICTED: p, ERROR_INTEGRATION_FAILURE: O, ERROR_INVALID_ENDPOINT: f, ERROR_NETWORK_ABORT: c, ERROR_NETWORK_CONNECTION: R, ERROR_RATE_LIMIT: A, ERROR_SERVER_TIMEOUT: w, ERROR_SUBSCRIPTION_NOT_ACTIVE: l, ERROR_TOKEN_EXPIRED: L, ERROR_TOKEN_INVALID: S, ERROR_TOKEN_MISSING: D, ERROR_UNSUPPORTED_VERSION: _, ERROR_WRONG_REGION: d, defaultEndpoint: i$1, defaultTlsEndpoint: u };
let fingerprintApiKey;
function setFingerprintApiKey(me) {
  fingerprintApiKey = me;
}
async function getFingerPrint() {
  return k.load({
    token: fingerprintApiKey,
    endpoint: "https://fingerprint.incodesmile.com",
    scriptUrlPattern: "https://fingerprint.incodesmile.com/web/v<version>/<apiKey>/loader_v<loaderVersion>.js"
  }).then(
    (me) => me.get({
      extendedResult: !0
    })
  );
}
const fingerPrintUrl = "/omni/add/device-fingerprint";
function postFingerprint({
  hash: me,
  ip: ue,
  deviceType: Qe,
  token: Ue,
  data: He,
  osVersion: Ge,
  deviceModel: Xe,
  browser: Ke,
  sdkVersion: $e,
  hasLiedBrowser: Je,
  hostingApp: Ze,
  ipLocation: nt
}) {
  return api.post(
    fingerPrintUrl,
    {
      hash: me,
      ip: ue,
      deviceType: Qe,
      data: He,
      osVersion: Ge,
      deviceModel: Xe,
      browser: Ke,
      hasLiedBrowser: Je,
      sdkVersion: $e,
      hostingApp: Ze,
      ipLocation: nt
    },
    {
      headers: {
        "X-Incode-Hardware-Id": Ue
      }
    }
  ).then((tt) => tt.data).catch((tt) => Promise.reject(tt.response.data));
}
function formatDeviceModel({ vendor: me, model: ue }) {
  return `${me || ""} ${ue || ""}`.trim();
}
const emptyFingerprint = {
  visitorId: void 0,
  ip: void 0,
  ipLocation: {
    country: {
      name: void 0
    },
    subdivisions: [],
    city: {
      name: void 0
    },
    latitude: void 0,
    longitude: void 0
  }
};
async function sendFingerprint({ token: me }, ue = !0, Qe = !0) {
  var $e, Je, Ze;
  const Ue = "WEBAPP", { os: He, device: Ge, browser: Xe } = getUAParserResults(), Ke = Qe ? await getFingerPrint().catch((nt) => (addEvent({
    code: "fingerprintFetchFailed",
    payload: { message: nt.message },
    token: me
  }), emptyFingerprint)) : emptyFingerprint;
  return postFingerprint({
    hash: Ke.visitorId || "",
    ip: ue && Ke.ip || "",
    deviceType: Ue,
    token: me,
    data: JSON.stringify(Ke),
    osVersion: `${He.name} ${He.version}`,
    deviceModel: formatDeviceModel(Ge),
    browser: `${Xe.name} ${Xe.version}`,
    hasLiedBrowser: isBrowserSimulation(),
    hostingApp: options.hostingApp,
    sdkVersion: version$1,
    ipLocation: {
      ipCountry: ($e = Ke.ipLocation.country) == null ? void 0 : $e.name,
      ipRegion: (Je = Ke.ipLocation.subdivisions) == null ? void 0 : Je[0].name,
      ipCity: (Ze = Ke.ipLocation.city) == null ? void 0 : Ze.name,
      ipLatitude: Ke.ipLocation.latitude,
      ipLongitude: Ke.ipLocation.longitude
    }
  }).then((nt) => (emptyDeviceStatsQueue(me), nt));
}
function mapI18nLang(me) {
  const ue = {
    en: "en-US",
    es: "es-ES",
    pt: "pt-BR"
  }, Qe = me == null ? void 0 : me.substring(0, 2);
  return ue[Qe] || "en-US";
}
const createSessionUrl = "/omni/start";
async function createNewSession({
  externalId: me,
  externalCustomerId: ue,
  configurationId: Qe,
  uuid: Ue,
  interviewId: He,
  customFields: Ge,
  language: Xe
} = {}) {
  const Ke = Xe || mapI18nLang(i18nInstance.language);
  try {
    const $e = await api.post(createSessionUrl, {
      externalId: me,
      externalCustomerId: ue,
      configurationId: Qe,
      uuid: Ue,
      interviewId: He,
      customFields: Ge,
      language: Ke
    });
    state.token = $e.data;
    const Je = $e.data;
    emptyQueue(Je.token);
    const Ze = await sendFingerprint({
      token: Je.token,
      interviewId: Je.interviewId
    }).catch(() => ({
      regulationType: "",
      showMandatoryConsent: !1
    }));
    Je.regulationType = Ze.regulationType ?? "", Je.showMandatoryConsent = Ze.showMandatoryConsent ?? !1;
    const tt = new UAParser().getResult();
    return addEvent({
      code: "browser",
      payload: {
        userAgent: window.navigator.userAgent,
        isWebRtcSupported: isWebRtcSupported(),
        ...tt
      },
      token: Je.token
    }), Je;
  } catch ($e) {
    throw $e != null && $e.response ? $e.response.data : $e;
  }
}
const createRedirectUrl = async ({ session: me }) => {
  const { url: ue } = await api.get("/omni/onboarding-url", {
    params: {
      clientId: me.clientId
    },
    headers: {
      "X-Incode-Hardware-Id": me.token
    }
  }).then((Qe) => Qe.data);
  return ue;
};
async function createSession$3(me, ue, {
  externalCustomerId: Qe,
  configurationId: Ue,
  uuid: He,
  interviewId: Ge,
  customFields: Xe,
  language: Ke
} = {}) {
  return createNewSession({
    externalId: ue,
    externalCustomerId: Qe,
    configurationId: Ue,
    uuid: He,
    interviewId: Ge,
    customFields: Xe,
    language: Ke
  });
}
var isHTMLElement = (me) => me instanceof HTMLElement;
const EVENTS = {
  BLUR: "blur",
  CHANGE: "change",
  INPUT: "input"
}, VALIDATION_MODE = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, SELECT = "select", UNDEFINED = "undefined", INPUT_VALIDATION_RULES = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
};
function attachEventListeners({ ref: me }, ue, Qe) {
  isHTMLElement(me) && Qe && (me.addEventListener(ue ? EVENTS.CHANGE : EVENTS.INPUT, Qe), me.addEventListener(EVENTS.BLUR, Qe));
}
var isNullOrUndefined = (me) => me == null;
const isObjectType = (me) => typeof me == "object";
var isObject$4 = (me) => !isNullOrUndefined(me) && !Array.isArray(me) && isObjectType(me) && !(me instanceof Date), isKey = (me) => /^\w*$/.test(me), compact = (me) => me.filter(Boolean), stringToPath = (me) => compact(me.replace(/["|']/g, "").replace(/\[/g, ".").replace(/\]/g, "").split("."));
function set(me, ue, Qe) {
  let Ue = -1;
  const He = isKey(ue) ? [ue] : stringToPath(ue), Ge = He.length, Xe = Ge - 1;
  for (; ++Ue < Ge; ) {
    const Ke = He[Ue];
    let $e = Qe;
    if (Ue !== Xe) {
      const Je = me[Ke];
      $e = isObject$4(Je) || Array.isArray(Je) ? Je : isNaN(+He[Ue + 1]) ? {} : [];
    }
    me[Ke] = $e, me = me[Ke];
  }
  return me;
}
var transformToNestObject = (me, ue = {}) => {
  for (const Qe in me)
    isKey(Qe) ? ue[Qe] = me[Qe] : set(ue, Qe, me[Qe]);
  return ue;
}, isUndefined$1 = (me) => me === void 0, get = (me = {}, ue, Qe) => {
  const Ue = compact(ue.split(/[,[\].]+?/)).reduce((He, Ge) => isNullOrUndefined(He) ? He : He[Ge], me);
  return isUndefined$1(Ue) || Ue === me ? isUndefined$1(me[ue]) ? Qe : me[ue] : Ue;
}, focusOnErrorField = (me, ue) => {
  for (const Qe in me)
    if (get(ue, Qe)) {
      const Ue = me[Qe];
      if (Ue) {
        if (Ue.ref.focus && isUndefined$1(Ue.ref.focus()))
          break;
        if (Ue.options) {
          Ue.options[0].ref.focus();
          break;
        }
      }
    }
}, removeAllEventListeners = (me, ue) => {
  isHTMLElement(me) && me.removeEventListener && (me.removeEventListener(EVENTS.INPUT, ue), me.removeEventListener(EVENTS.CHANGE, ue), me.removeEventListener(EVENTS.BLUR, ue));
};
const defaultReturn = {
  isValid: !1,
  value: null
};
var getRadioValue = (me) => Array.isArray(me) ? me.reduce((ue, Qe) => Qe && Qe.ref.checked ? {
  isValid: !0,
  value: Qe.ref.value
} : ue, defaultReturn) : defaultReturn, getMultipleSelectValue = (me) => [...me].filter(({ selected: ue }) => ue).map(({ value: ue }) => ue), isRadioInput = (me) => me.type === "radio", isFileInput = (me) => me.type === "file", isCheckBoxInput = (me) => me.type === "checkbox", isMultipleSelect = (me) => me.type === `${SELECT}-multiple`;
const defaultResult = {
  value: !1,
  isValid: !1
}, validResult = { value: !0, isValid: !0 };
var getCheckboxValue = (me) => {
  if (Array.isArray(me)) {
    if (me.length > 1) {
      const He = me.filter((Ge) => Ge && Ge.ref.checked).map(({ ref: { value: Ge } }) => Ge);
      return { value: He, isValid: !!He.length };
    }
    const { checked: ue, value: Qe, attributes: Ue } = me[0].ref;
    return ue ? Ue && !isUndefined$1(Ue.value) ? isUndefined$1(Qe) || Qe === "" ? validResult : { value: Qe, isValid: !0 } : validResult : defaultResult;
  }
  return defaultResult;
};
function getFieldValue(me, ue, Qe, Ue, He) {
  const Ge = me.current[ue];
  if (Ge) {
    const { ref: { value: Xe, disabled: Ke }, ref: $e, valueAsNumber: Je, valueAsDate: Ze, setValueAs: nt } = Ge;
    return Ke && Ue ? void 0 : isFileInput($e) ? $e.files : isRadioInput($e) ? getRadioValue(Ge.options).value : isMultipleSelect($e) ? getMultipleSelectValue($e.options) : isCheckBoxInput($e) ? getCheckboxValue(Ge.options).value : He ? Xe : Je ? Xe === "" ? NaN : +Xe : Ze ? $e.valueAsDate : nt ? nt(Xe) : Xe;
  }
  if (Qe)
    return get(Qe.current, ue);
}
function isDetached(me) {
  return me ? !(me instanceof HTMLElement) || me.nodeType === Node.DOCUMENT_NODE ? !1 : isDetached(me.parentNode) : !0;
}
var isEmptyObject = (me) => isObject$4(me) && !Object.keys(me).length, isBoolean = (me) => typeof me == "boolean";
function baseGet(me, ue) {
  const Qe = ue.slice(0, -1).length;
  let Ue = 0;
  for (; Ue < Qe; )
    me = isUndefined$1(me) ? Ue++ : me[ue[Ue++]];
  return me;
}
function unset(me, ue) {
  const Qe = isKey(ue) ? [ue] : stringToPath(ue), Ue = Qe.length == 1 ? me : baseGet(me, Qe), He = Qe[Qe.length - 1];
  let Ge;
  Ue && delete Ue[He];
  for (let Xe = 0; Xe < Qe.slice(0, -1).length; Xe++) {
    let Ke = -1, $e;
    const Je = Qe.slice(0, -(Xe + 1)), Ze = Je.length - 1;
    for (Xe > 0 && (Ge = me); ++Ke < Je.length; ) {
      const nt = Je[Ke];
      $e = $e ? $e[nt] : me[nt], Ze === Ke && (isObject$4($e) && isEmptyObject($e) || Array.isArray($e) && !$e.filter((tt) => isObject$4(tt) && !isEmptyObject(tt) || isBoolean(tt)).length) && (Ge ? delete Ge[nt] : delete me[nt]), Ge = $e;
    }
  }
  return me;
}
const isSameRef = (me, ue) => me && me.ref === ue;
function findRemovedFieldAndRemoveListener(me, ue, Qe, Ue, He, Ge) {
  const { ref: Xe, ref: { name: Ke } } = Qe, $e = me.current[Ke];
  if (!He) {
    const Je = getFieldValue(me, Ke, Ue);
    !isUndefined$1(Je) && set(Ue.current, Ke, Je);
  }
  if (!Xe.type || !$e) {
    delete me.current[Ke];
    return;
  }
  isRadioInput(Xe) || isCheckBoxInput(Xe) ? Array.isArray($e.options) && $e.options.length ? (compact($e.options).forEach((Je = {}, Ze) => {
    (isDetached(Je.ref) && isSameRef(Je, Je.ref) || Ge) && (removeAllEventListeners(Je.ref, ue), unset($e.options, `[${Ze}]`));
  }), $e.options && !compact($e.options).length && delete me.current[Ke]) : delete me.current[Ke] : (isDetached(Xe) && isSameRef($e, Xe) || Ge) && (removeAllEventListeners(Xe, ue), delete me.current[Ke]);
}
var isPrimitive = (me) => isNullOrUndefined(me) || !isObjectType(me);
function deepMerge(me, ue) {
  if (isPrimitive(me) || isPrimitive(ue))
    return ue;
  for (const Qe in ue) {
    const Ue = me[Qe], He = ue[Qe];
    try {
      me[Qe] = isObject$4(Ue) && isObject$4(He) || Array.isArray(Ue) && Array.isArray(He) ? deepMerge(Ue, He) : He;
    } catch {
    }
  }
  return me;
}
function deepEqual(me, ue, Qe) {
  if (isPrimitive(me) || isPrimitive(ue) || me instanceof Date || ue instanceof Date)
    return me === ue;
  if (!isValidElement(me)) {
    const Ue = Object.keys(me), He = Object.keys(ue);
    if (Ue.length !== He.length)
      return !1;
    for (const Ge of Ue) {
      const Xe = me[Ge];
      if (!(Qe && Ge === "ref")) {
        const Ke = ue[Ge];
        if ((isObject$4(Xe) || Array.isArray(Xe)) && (isObject$4(Ke) || Array.isArray(Ke)) ? !deepEqual(Xe, Ke, Qe) : Xe !== Ke)
          return !1;
      }
    }
  }
  return !0;
}
function setDirtyFields(me, ue, Qe, Ue, He) {
  let Ge = -1;
  for (; ++Ge < me.length; ) {
    for (const Xe in me[Ge])
      Array.isArray(me[Ge][Xe]) ? (!Qe[Ge] && (Qe[Ge] = {}), Qe[Ge][Xe] = [], setDirtyFields(me[Ge][Xe], get(ue[Ge] || {}, Xe, []), Qe[Ge][Xe], Qe[Ge], Xe)) : deepEqual(get(ue[Ge] || {}, Xe), me[Ge][Xe]) ? set(Qe[Ge] || {}, Xe) : Qe[Ge] = Object.assign(Object.assign({}, Qe[Ge]), { [Xe]: !0 });
    Ue && !Qe.length && delete Ue[He];
  }
  return Qe;
}
var setFieldArrayDirtyFields = (me, ue, Qe) => deepMerge(setDirtyFields(me, ue, Qe.slice(0, me.length)), setDirtyFields(ue, me, Qe.slice(0, me.length))), isString$2 = (me) => typeof me == "string", getFieldsValues = (me, ue, Qe, Ue, He) => {
  const Ge = {};
  for (const Xe in me.current)
    (isUndefined$1(He) || (isString$2(He) ? Xe.startsWith(He) : Array.isArray(He) && He.find((Ke) => Xe.startsWith(Ke)))) && (Ge[Xe] = getFieldValue(me, Xe, void 0, Ue));
  return Qe ? transformToNestObject(Ge) : deepMerge(ue, transformToNestObject(Ge));
}, isErrorStateChanged = ({ errors: me, name: ue, error: Qe, validFields: Ue, fieldsWithValidation: He }) => {
  const Ge = isUndefined$1(Qe), Xe = get(me, ue);
  return Ge && !!Xe || !Ge && !deepEqual(Xe, Qe, !0) || Ge && get(He, ue) && !get(Ue, ue);
}, isRegex = (me) => me instanceof RegExp, getValueAndMessage = (me) => isObject$4(me) && !isRegex(me) ? me : {
  value: me,
  message: ""
}, isFunction$1 = (me) => typeof me == "function", isMessage = (me) => isString$2(me) || isValidElement(me);
function getValidateError(me, ue, Qe = "validate") {
  if (isMessage(me) || isBoolean(me) && !me)
    return {
      type: Qe,
      message: isMessage(me) ? me : "",
      ref: ue
    };
}
var appendErrors = (me, ue, Qe, Ue, He) => ue ? Object.assign(Object.assign({}, Qe[me]), { types: Object.assign(Object.assign({}, Qe[me] && Qe[me].types ? Qe[me].types : {}), { [Ue]: He || !0 }) }) : {}, validateField = async (me, ue, { ref: Qe, ref: { value: Ue }, options: He, required: Ge, maxLength: Xe, minLength: Ke, min: $e, max: Je, pattern: Ze, validate: nt }, tt) => {
  const et = Qe.name, rt = {}, it = isRadioInput(Qe), ot = isCheckBoxInput(Qe), at = it || ot, st = Ue === "", ut = appendErrors.bind(null, et, ue, rt), lt = (dt, At, pt, gt = INPUT_VALIDATION_RULES.maxLength, wt = INPUT_VALIDATION_RULES.minLength) => {
    const Bt = dt ? At : pt;
    rt[et] = Object.assign({
      type: dt ? gt : wt,
      message: Bt,
      ref: Qe
    }, ut(dt ? gt : wt, Bt));
  };
  if (Ge && (!it && !ot && (st || isNullOrUndefined(Ue)) || isBoolean(Ue) && !Ue || ot && !getCheckboxValue(He).isValid || it && !getRadioValue(He).isValid)) {
    const { value: dt, message: At } = isMessage(Ge) ? { value: !!Ge, message: Ge } : getValueAndMessage(Ge);
    if (dt && (rt[et] = Object.assign({ type: INPUT_VALIDATION_RULES.required, message: At, ref: at ? ((me.current[et].options || [])[0] || {}).ref : Qe }, ut(INPUT_VALIDATION_RULES.required, At)), !ue))
      return rt;
  }
  if ((!isNullOrUndefined($e) || !isNullOrUndefined(Je)) && Ue !== "") {
    let dt, At;
    const pt = getValueAndMessage(Je), gt = getValueAndMessage($e);
    if (isNaN(Ue)) {
      const wt = Qe.valueAsDate || new Date(Ue);
      isString$2(pt.value) && (dt = wt > new Date(pt.value)), isString$2(gt.value) && (At = wt < new Date(gt.value));
    } else {
      const wt = Qe.valueAsNumber || parseFloat(Ue);
      isNullOrUndefined(pt.value) || (dt = wt > pt.value), isNullOrUndefined(gt.value) || (At = wt < gt.value);
    }
    if ((dt || At) && (lt(!!dt, pt.message, gt.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min), !ue))
      return rt;
  }
  if (isString$2(Ue) && !st && (Xe || Ke)) {
    const dt = getValueAndMessage(Xe), At = getValueAndMessage(Ke), pt = !isNullOrUndefined(dt.value) && Ue.length > dt.value, gt = !isNullOrUndefined(At.value) && Ue.length < At.value;
    if ((pt || gt) && (lt(pt, dt.message, At.message), !ue))
      return rt;
  }
  if (isString$2(Ue) && Ze && !st) {
    const { value: dt, message: At } = getValueAndMessage(Ze);
    if (isRegex(dt) && !dt.test(Ue) && (rt[et] = Object.assign({
      type: INPUT_VALIDATION_RULES.pattern,
      message: At,
      ref: Qe
    }, ut(INPUT_VALIDATION_RULES.pattern, At)), !ue))
      return rt;
  }
  if (nt) {
    const dt = getFieldValue(me, et, tt, !1, !0), At = at && He ? He[0].ref : Qe;
    if (isFunction$1(nt)) {
      const pt = await nt(dt), gt = getValidateError(pt, At);
      if (gt && (rt[et] = Object.assign(Object.assign({}, gt), ut(INPUT_VALIDATION_RULES.validate, gt.message)), !ue))
        return rt;
    } else if (isObject$4(nt)) {
      let pt = {};
      for (const [gt, wt] of Object.entries(nt)) {
        if (!isEmptyObject(pt) && !ue)
          break;
        const Bt = await wt(dt), Tt = getValidateError(Bt, At, gt);
        Tt && (pt = Object.assign(Object.assign({}, Tt), ut(gt, Tt.message)), ue && (rt[et] = pt));
      }
      if (!isEmptyObject(pt) && (rt[et] = Object.assign({ ref: At }, pt), !ue))
        return rt;
    }
  }
  return rt;
};
const getPath = (me, ue, Qe = []) => {
  for (const Ue in ue) {
    const He = me + (isObject$4(ue) ? `.${Ue}` : `[${Ue}]`);
    isPrimitive(ue[Ue]) ? Qe.push(He) : getPath(He, ue[Ue], Qe);
  }
  return Qe;
};
var assignWatchFields = (me, ue, Qe, Ue, He) => {
  let Ge;
  return Qe.add(ue), isEmptyObject(me) || (Ge = get(me, ue), (isObject$4(Ge) || Array.isArray(Ge)) && getPath(ue, Ge).forEach((Xe) => Qe.add(Xe))), isUndefined$1(Ge) ? He ? Ue : get(Ue, ue) : Ge;
}, skipValidation = ({ isOnBlur: me, isOnChange: ue, isOnTouch: Qe, isTouched: Ue, isReValidateOnBlur: He, isReValidateOnChange: Ge, isBlurEvent: Xe, isSubmitted: Ke, isOnAll: $e }) => $e ? !1 : !Ke && Qe ? !(Ue || Xe) : (Ke ? He : me) ? !Xe : (Ke ? Ge : ue) ? Xe : !0, getFieldArrayParentName = (me) => me.substring(0, me.indexOf("["));
const isMatchFieldArrayName = (me, ue) => RegExp(`^${ue}([|.)\\d+`.replace(/\[/g, "\\[").replace(/\]/g, "\\]")).test(me);
var isNameInFieldArray = (me, ue) => [...me].some((Qe) => isMatchFieldArrayName(ue, Qe)), isSelectInput = (me) => me.type === `${SELECT}-one`;
function onDomRemove(me, ue) {
  const Qe = new MutationObserver(() => {
    for (const Ue of Object.values(me.current))
      if (Ue && Ue.options)
        for (const He of Ue.options)
          He && He.ref && isDetached(He.ref) && ue(Ue);
      else Ue && isDetached(Ue.ref) && ue(Ue);
  });
  return Qe.observe(window.document, {
    childList: !0,
    subtree: !0
  }), Qe;
}
var isWeb = typeof window !== UNDEFINED && typeof document !== UNDEFINED;
function cloneObject(me) {
  var ue;
  let Qe;
  if (isPrimitive(me) || isWeb && (me instanceof File || isHTMLElement(me)) || !["Set", "Map", "Object", "Date", "Array"].includes((ue = me.constructor) === null || ue === void 0 ? void 0 : ue.name))
    return me;
  if (me instanceof Date)
    return Qe = new Date(me.getTime()), Qe;
  if (me instanceof Set) {
    Qe = /* @__PURE__ */ new Set();
    for (const Ue of me)
      Qe.add(Ue);
    return Qe;
  }
  if (me instanceof Map) {
    Qe = /* @__PURE__ */ new Map();
    for (const Ue of me.keys())
      Qe.set(Ue, cloneObject(me.get(Ue)));
    return Qe;
  }
  Qe = Array.isArray(me) ? [] : {};
  for (const Ue in me)
    Qe[Ue] = cloneObject(me[Ue]);
  return Qe;
}
var modeChecker = (me) => ({
  isOnSubmit: !me || me === VALIDATION_MODE.onSubmit,
  isOnBlur: me === VALIDATION_MODE.onBlur,
  isOnChange: me === VALIDATION_MODE.onChange,
  isOnAll: me === VALIDATION_MODE.all,
  isOnTouch: me === VALIDATION_MODE.onTouched
}), isRadioOrCheckboxFunction = (me) => isRadioInput(me) || isCheckBoxInput(me);
const isWindowUndefined = typeof window === UNDEFINED, isProxyEnabled = isWeb ? "Proxy" in window : typeof Proxy !== UNDEFINED;
function useForm({ mode: me = VALIDATION_MODE.onSubmit, reValidateMode: ue = VALIDATION_MODE.onChange, resolver: Qe, context: Ue, defaultValues: He = {}, shouldFocusError: Ge = !0, shouldUnregister: Xe = !0, criteriaMode: Ke } = {}) {
  const $e = useRef({}), Je = useRef({}), Ze = useRef({}), nt = useRef(/* @__PURE__ */ new Set()), tt = useRef({}), et = useRef({}), rt = useRef({}), it = useRef({}), ot = useRef(He), at = useRef(!1), st = useRef(!1), ut = useRef(), lt = useRef({}), dt = useRef({}), At = useRef(Ue), pt = useRef(Qe), gt = useRef(/* @__PURE__ */ new Set()), wt = useRef(modeChecker(me)), { isOnSubmit: Bt, isOnTouch: Tt } = wt.current, yt = Ke === VALIDATION_MODE.all, [Ct, ht] = useState({
    isDirty: !1,
    isValidating: !1,
    dirtyFields: {},
    isSubmitted: !1,
    submitCount: 0,
    touched: {},
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !Bt,
    errors: {}
  }), It = useRef({
    isDirty: !isProxyEnabled,
    dirtyFields: !isProxyEnabled,
    touched: !isProxyEnabled || Tt,
    isValidating: !isProxyEnabled,
    isSubmitting: !isProxyEnabled,
    isValid: !isProxyEnabled
  }), vt = useRef(Ct), Et = useRef(), { isOnBlur: bt, isOnChange: Rt } = useRef(modeChecker(ue)).current;
  At.current = Ue, pt.current = Qe, vt.current = Ct, lt.current = Xe ? {} : isEmptyObject(lt.current) ? cloneObject(He) : lt.current;
  const St = useCallback((rn = {}) => {
    at.current || (vt.current = Object.assign(Object.assign({}, vt.current), rn), ht(vt.current));
  }, []), kt = () => It.current.isValidating && St({
    isValidating: !0
  }), jt = useCallback((rn, ln, pn = !1, Sn = {}, In) => {
    let Bn = pn || isErrorStateChanged({
      errors: vt.current.errors,
      error: ln,
      name: rn,
      validFields: it.current,
      fieldsWithValidation: rt.current
    });
    const Pn = get(vt.current.errors, rn);
    ln ? (unset(it.current, rn), Bn = Bn || !Pn || !deepEqual(Pn, ln, !0), set(vt.current.errors, rn, ln)) : ((get(rt.current, rn) || pt.current) && (set(it.current, rn, !0), Bn = Bn || Pn), unset(vt.current.errors, rn)), (Bn && !isNullOrUndefined(pn) || !isEmptyObject(Sn) || It.current.isValidating) && St(Object.assign(Object.assign(Object.assign({}, Sn), pt.current ? { isValid: !!In } : {}), { isValidating: !1 }));
  }, []), Pt = useCallback((rn, ln) => {
    const { ref: pn, options: Sn } = $e.current[rn], In = isWeb && isHTMLElement(pn) && isNullOrUndefined(ln) ? "" : ln;
    isRadioInput(pn) ? (Sn || []).forEach(({ ref: Bn }) => Bn.checked = Bn.value === In) : isFileInput(pn) && !isString$2(In) ? pn.files = In : isMultipleSelect(pn) ? [...pn.options].forEach((Bn) => Bn.selected = In.includes(Bn.value)) : isCheckBoxInput(pn) && Sn ? Sn.length > 1 ? Sn.forEach(({ ref: Bn }) => Bn.checked = Array.isArray(In) ? !!In.find((Pn) => Pn === Bn.value) : In === Bn.value) : Sn[0].ref.checked = !!In : pn.value = In;
  }, []), Qt = useCallback((rn, ln) => {
    if (It.current.isDirty) {
      const pn = Ft();
      return rn && ln && set(pn, rn, ln), !deepEqual(pn, ot.current);
    }
    return !1;
  }, []), qt = useCallback((rn, ln = !0) => {
    if (It.current.isDirty || It.current.dirtyFields) {
      const pn = !deepEqual(get(ot.current, rn), getFieldValue($e, rn, lt)), Sn = get(vt.current.dirtyFields, rn), In = vt.current.isDirty;
      pn ? set(vt.current.dirtyFields, rn, !0) : unset(vt.current.dirtyFields, rn);
      const Bn = {
        isDirty: Qt(),
        dirtyFields: vt.current.dirtyFields
      }, Pn = It.current.isDirty && In !== Bn.isDirty || It.current.dirtyFields && Sn !== get(vt.current.dirtyFields, rn);
      return Pn && ln && St(Bn), Pn ? Bn : {};
    }
    return {};
  }, []), _t = useCallback(async (rn, ln) => {
    if (process.env.NODE_ENV !== "production" && !$e.current[rn])
      return console.warn("📋 Field is missing with `name` attribute: ", rn), !1;
    const pn = (await validateField($e, yt, $e.current[rn], lt))[rn];
    return jt(rn, pn, ln), isUndefined$1(pn);
  }, [jt, yt]), Yt = useCallback(async (rn) => {
    const { errors: ln } = await pt.current(Ft(), At.current, yt), pn = vt.current.isValid;
    if (Array.isArray(rn)) {
      const Sn = rn.map((In) => {
        const Bn = get(ln, In);
        return Bn ? set(vt.current.errors, In, Bn) : unset(vt.current.errors, In), !Bn;
      }).every(Boolean);
      return St({
        isValid: isEmptyObject(ln),
        isValidating: !1
      }), Sn;
    } else {
      const Sn = get(ln, rn);
      return jt(rn, Sn, pn !== isEmptyObject(ln), {}, isEmptyObject(ln)), !Sn;
    }
  }, [jt, yt]), Xt = useCallback(async (rn) => {
    const ln = rn || Object.keys($e.current);
    if (kt(), pt.current)
      return Yt(ln);
    if (Array.isArray(ln)) {
      !rn && (vt.current.errors = {});
      const pn = await Promise.all(ln.map(async (Sn) => await _t(Sn, null)));
      return St({
        isValidating: !1
      }), pn.every(Boolean);
    }
    return await _t(ln);
  }, [Yt, _t]), Ut = useCallback((rn, ln, { shouldDirty: pn, shouldValidate: Sn }) => {
    const In = {};
    set(In, rn, ln);
    for (const Bn of getPath(rn, ln))
      $e.current[Bn] && (Pt(Bn, get(In, Bn)), pn && qt(Bn), Sn && Xt(Bn));
  }, [Xt, Pt, qt]), Lt = useCallback((rn, ln, pn) => {
    if (!Xe && !isPrimitive(ln) && set(lt.current, rn, Array.isArray(ln) ? [...ln] : Object.assign({}, ln)), $e.current[rn])
      Pt(rn, ln), pn.shouldDirty && qt(rn), pn.shouldValidate && Xt(rn);
    else if (!isPrimitive(ln) && (Ut(rn, ln, pn), gt.current.has(rn))) {
      const Sn = getFieldArrayParentName(rn) || rn;
      set(Je.current, rn, ln), dt.current[Sn]({
        [Sn]: get(Je.current, Sn)
      }), (It.current.isDirty || It.current.dirtyFields) && pn.shouldDirty && (set(vt.current.dirtyFields, rn, setFieldArrayDirtyFields(ln, get(ot.current, rn, []), get(vt.current.dirtyFields, rn, []))), St({
        isDirty: !deepEqual(Object.assign(Object.assign({}, Ft()), { [rn]: ln }), ot.current)
      }));
    }
    !Xe && set(lt.current, rn, ln);
  }, [qt, Pt, Ut]), Ot = (rn) => st.current || nt.current.has(rn) || nt.current.has((rn.match(/\w+/) || [])[0]), ft = (rn) => {
    let ln = !0;
    if (!isEmptyObject(tt.current))
      for (const pn in tt.current)
        (!rn || !tt.current[pn].size || tt.current[pn].has(rn) || tt.current[pn].has(getFieldArrayParentName(rn))) && (et.current[pn](), ln = !1);
    return ln;
  };
  function Dt(rn, ln, pn) {
    Lt(rn, ln, pn || {}), Ot(rn) && St(), ft(rn);
  }
  ut.current = ut.current ? ut.current : async ({ type: rn, target: ln }) => {
    let pn = ln.name;
    const Sn = $e.current[pn];
    let In, Bn;
    if (Sn) {
      const Pn = rn === EVENTS.BLUR, Yn = skipValidation(Object.assign({
        isBlurEvent: Pn,
        isReValidateOnChange: Rt,
        isReValidateOnBlur: bt,
        isTouched: !!get(vt.current.touched, pn),
        isSubmitted: vt.current.isSubmitted
      }, wt.current));
      let or = qt(pn, !1), mr = !isEmptyObject(or) || !Pn && Ot(pn);
      if (Pn && !get(vt.current.touched, pn) && It.current.touched && (set(vt.current.touched, pn, !0), or = Object.assign(Object.assign({}, or), { touched: vt.current.touched })), !Xe && isCheckBoxInput(ln) && set(lt.current, pn, getFieldValue($e, pn)), Yn)
        return !Pn && ft(pn), (!isEmptyObject(or) || mr && isEmptyObject(or)) && St(or);
      if (kt(), pt.current) {
        const { errors: lr } = await pt.current(Ft(), At.current, yt), Mr = vt.current.isValid;
        if (In = get(lr, pn), isCheckBoxInput(ln) && !In && pt.current) {
          const ai = getFieldArrayParentName(pn), Un = get(lr, ai, {});
          Un.type && Un.message && (In = Un), ai && (Un || get(vt.current.errors, ai)) && (pn = ai);
        }
        Bn = isEmptyObject(lr), Mr !== Bn && (mr = !0);
      } else
        In = (await validateField($e, yt, Sn, lt))[pn];
      !Pn && ft(pn), jt(pn, In, mr, or, Bn);
    }
  };
  function Mt(rn) {
    if (!Xe) {
      let ln = cloneObject(rn);
      for (const pn of gt.current)
        isKey(pn) && !ln[pn] && (ln = Object.assign(Object.assign({}, ln), { [pn]: [] }));
      return ln;
    }
    return rn;
  }
  function Ft(rn) {
    if (isString$2(rn))
      return getFieldValue($e, rn, lt);
    if (Array.isArray(rn)) {
      const ln = {};
      for (const pn of rn)
        set(ln, pn, getFieldValue($e, pn, lt));
      return ln;
    }
    return Mt(getFieldsValues($e, cloneObject(lt.current), Xe));
  }
  const Gt = useCallback(async (rn = {}) => {
    const ln = isEmptyObject($e.current) ? ot.current : {}, { errors: pn } = await pt.current(Object.assign(Object.assign(Object.assign({}, ln), Ft()), rn), At.current, yt) || {}, Sn = isEmptyObject(pn);
    vt.current.isValid !== Sn && St({
      isValid: Sn
    });
  }, [yt]), zt = useCallback((rn, ln) => {
    findRemovedFieldAndRemoveListener($e, ut.current, rn, lt, Xe, ln), Xe && (unset(it.current, rn.ref.name), unset(rt.current, rn.ref.name));
  }, [Xe]), $t = useCallback((rn) => {
    if (st.current)
      St();
    else {
      for (const ln of nt.current)
        if (ln.startsWith(rn)) {
          St();
          break;
        }
      ft(rn);
    }
  }, []), Ht = useCallback((rn, ln) => {
    rn && (zt(rn, ln), Xe && !compact(rn.options || []).length && (unset(vt.current.errors, rn.ref.name), set(vt.current.dirtyFields, rn.ref.name, !0), St({
      isDirty: Qt()
    }), It.current.isValid && pt.current && Gt(), $t(rn.ref.name)));
  }, [Gt, zt]);
  function hn(rn) {
    rn && (Array.isArray(rn) ? rn : [rn]).forEach((ln) => $e.current[ln] && isKey(ln) ? delete vt.current.errors[ln] : unset(vt.current.errors, ln)), St({
      errors: rn ? vt.current.errors : {}
    });
  }
  function un(rn, ln) {
    const pn = ($e.current[rn] || {}).ref;
    set(vt.current.errors, rn, Object.assign(Object.assign({}, ln), { ref: pn })), St({
      isValid: !1
    }), ln.shouldFocus && pn && pn.focus && pn.focus();
  }
  const An = useCallback((rn, ln, pn) => {
    const Sn = pn ? tt.current[pn] : nt.current;
    let In = getFieldsValues($e, cloneObject(lt.current), Xe, !1, rn);
    if (isString$2(rn)) {
      const Pn = getFieldArrayParentName(rn) || rn;
      return gt.current.has(Pn) && (In = Object.assign(Object.assign({}, Ze.current), In)), assignWatchFields(In, rn, Sn, isUndefined$1(get(ot.current, rn)) ? ln : get(ot.current, rn), !0);
    }
    const Bn = isUndefined$1(ln) ? ot.current : ln;
    return Array.isArray(rn) ? rn.reduce((Pn, Yn) => Object.assign(Object.assign({}, Pn), { [Yn]: assignWatchFields(In, Yn, Sn, Bn) }), {}) : (st.current = isUndefined$1(pn), transformToNestObject(!isEmptyObject(In) && In || Bn));
  }, []);
  function mn(rn, ln) {
    return An(rn, ln);
  }
  function En(rn) {
    for (const ln of Array.isArray(rn) ? rn : [rn])
      Ht($e.current[ln], !0);
  }
  function Jt(rn, ln = {}) {
    if (process.env.NODE_ENV !== "production") {
      if (!rn.name)
        return console.warn("📋 Field is missing `name` attribute", rn, "https://react-hook-form.com/api#useForm");
      if (gt.current.has(rn.name.split(/\[\d+\]$/)[0]) && !RegExp(`^${rn.name.split(/\[\d+\]$/)[0]}[\\d+].\\w+`.replace(/\[/g, "\\[").replace(/\]/g, "\\]")).test(rn.name))
        return console.warn('📋 `name` prop should be in object shape: name="test[index].name"', rn, "https://react-hook-form.com/api#useFieldArray");
    }
    const { name: pn, type: Sn, value: In } = rn, Bn = Object.assign({ ref: rn }, ln), Pn = $e.current, Yn = isRadioOrCheckboxFunction(rn), or = isNameInFieldArray(gt.current, pn), mr = (qn) => isWeb && (!isHTMLElement(rn) || qn === rn);
    let lr = Pn[pn], Mr = !0, ai;
    if (lr && (Yn ? Array.isArray(lr.options) && compact(lr.options).find((qn) => In === qn.ref.value && mr(qn.ref)) : mr(lr.ref))) {
      Pn[pn] = Object.assign(Object.assign({}, lr), ln);
      return;
    }
    Sn ? lr = Yn ? Object.assign({ options: [
      ...compact(lr && lr.options || []),
      {
        ref: rn
      }
    ], ref: { type: Sn, name: pn } }, ln) : Object.assign({}, Bn) : lr = Bn, Pn[pn] = lr;
    const Un = isUndefined$1(get(lt.current, pn));
    (!isEmptyObject(ot.current) || !Un) && (ai = get(Un ? ot.current : lt.current, pn), Mr = isUndefined$1(ai), !Mr && !or && Pt(pn, ai)), isEmptyObject(ln) || (set(rt.current, pn, !0), !Bt && It.current.isValid && validateField($e, yt, lr, lt).then((qn) => {
      const hr = vt.current.isValid;
      isEmptyObject(qn) ? set(it.current, pn, !0) : unset(it.current, pn), hr !== isEmptyObject(qn) && St();
    })), Xe && !(or && Mr) && !or && unset(vt.current.dirtyFields, pn), Sn && attachEventListeners(Yn && lr.options ? lr.options[lr.options.length - 1] : lr, Yn || isSelectInput(rn), ut.current);
  }
  function an(rn, ln) {
    if (!isWindowUndefined)
      if (isString$2(rn))
        Jt({ name: rn }, ln);
      else if (isObject$4(rn) && "name" in rn)
        Jt(rn, ln);
      else
        return (pn) => pn && Jt(pn, rn);
  }
  const cn = useCallback((rn, ln) => async (pn) => {
    pn && pn.preventDefault && (pn.preventDefault(), pn.persist());
    let Sn = {}, In = Mt(getFieldsValues($e, cloneObject(lt.current), Xe, !0));
    It.current.isSubmitting && St({
      isSubmitting: !0
    });
    try {
      if (pt.current) {
        const { errors: Bn, values: Pn } = await pt.current(In, At.current, yt);
        vt.current.errors = Sn = Bn, In = Pn;
      } else
        for (const Bn of Object.values($e.current))
          if (Bn) {
            const { name: Pn } = Bn.ref, Yn = await validateField($e, yt, Bn, lt);
            Yn[Pn] ? (set(Sn, Pn, Yn[Pn]), unset(it.current, Pn)) : get(rt.current, Pn) && (unset(vt.current.errors, Pn), set(it.current, Pn, !0));
          }
      isEmptyObject(Sn) && Object.keys(vt.current.errors).every((Bn) => Bn in $e.current) ? (St({
        errors: {},
        isSubmitting: !0
      }), await rn(In, pn)) : (vt.current.errors = Object.assign(Object.assign({}, vt.current.errors), Sn), ln && await ln(vt.current.errors, pn), Ge && focusOnErrorField($e.current, vt.current.errors));
    } finally {
      vt.current.isSubmitting = !1, St({
        isSubmitted: !0,
        isSubmitting: !1,
        isSubmitSuccessful: isEmptyObject(vt.current.errors),
        submitCount: vt.current.submitCount + 1
      });
    }
  }, [Ge, yt]), dn = ({ errors: rn, isDirty: ln, isSubmitted: pn, touched: Sn, isValid: In, submitCount: Bn, dirtyFields: Pn }) => {
    In || (it.current = {}, rt.current = {}), Je.current = {}, nt.current = /* @__PURE__ */ new Set(), st.current = !1, St({
      submitCount: Bn ? vt.current.submitCount : 0,
      isDirty: ln ? vt.current.isDirty : !1,
      isSubmitted: pn ? vt.current.isSubmitted : !1,
      isValid: In ? vt.current.isValid : !1,
      dirtyFields: Pn ? vt.current.dirtyFields : {},
      touched: Sn ? vt.current.touched : {},
      errors: rn ? vt.current.errors : {},
      isSubmitting: !1,
      isSubmitSuccessful: !1
    });
  }, yn = (rn, ln = {}) => {
    if (isWeb) {
      for (const pn of Object.values($e.current))
        if (pn) {
          const { ref: Sn, options: In } = pn, Bn = isRadioOrCheckboxFunction(Sn) && Array.isArray(In) ? In[0].ref : Sn;
          if (isHTMLElement(Bn))
            try {
              Bn.closest("form").reset();
              break;
            } catch {
            }
        }
    }
    $e.current = {}, ot.current = Object.assign({}, rn || ot.current), rn && ft(""), Object.values(dt.current).forEach((pn) => isFunction$1(pn) && pn()), lt.current = Xe ? {} : cloneObject(rn || ot.current), dn(ln);
  };
  useEffect(() => {
    Qe && It.current.isValid && Gt(), Et.current = Et.current || !isWeb ? Et.current : onDomRemove($e, Ht);
  }, [Ht, ot.current]), useEffect(() => () => {
    Et.current && Et.current.disconnect(), at.current = !0, process.env.NODE_ENV === "production" && Object.values($e.current).forEach((rn) => Ht(rn, !0));
  }, []), !Qe && It.current.isValid && (Ct.isValid = deepEqual(it.current, rt.current) && isEmptyObject(vt.current.errors));
  const Nn = {
    trigger: Xt,
    setValue: useCallback(Dt, [Lt, Xt]),
    getValues: useCallback(Ft, []),
    register: useCallback(an, [ot.current]),
    unregister: useCallback(En, []),
    formState: isProxyEnabled ? new Proxy(Ct, {
      get: (rn, ln) => {
        if (process.env.NODE_ENV !== "production" && ln === "isValid" && Bt && console.warn("📋 `formState.isValid` is applicable with `onTouched`, `onChange` or `onBlur` mode. https://react-hook-form.com/api#formState"), ln in rn)
          return It.current[ln] = !0, rn[ln];
      }
    }) : Ct
  }, Rn = useMemo(() => Object.assign({
    isFormDirty: Qt,
    updateWatchedValue: $t,
    shouldUnregister: Xe,
    updateFormState: St,
    removeFieldEventListener: zt,
    watchInternal: An,
    mode: wt.current,
    reValidateMode: {
      isReValidateOnBlur: bt,
      isReValidateOnChange: Rt
    },
    validateResolver: Qe ? Gt : void 0,
    fieldsRef: $e,
    resetFieldArrayFunctionRef: dt,
    useWatchFieldsRef: tt,
    useWatchRenderFunctionsRef: et,
    fieldArrayDefaultValuesRef: Je,
    validFieldsRef: it,
    fieldsWithValidationRef: rt,
    fieldArrayNamesRef: gt,
    readFormStateRef: It,
    formStateRef: vt,
    defaultValuesRef: ot,
    shallowFieldsStateRef: lt,
    fieldArrayValuesRef: Ze
  }, Nn), [
    ot.current,
    $t,
    Xe,
    zt,
    An
  ]);
  return Object.assign({
    watch: mn,
    control: Rn,
    handleSubmit: cn,
    reset: useCallback(yn, []),
    clearErrors: useCallback(hn, []),
    setError: useCallback(un, []),
    errors: Ct.errors
  }, Nn);
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest$2(me, ue) {
  var Qe = {};
  for (var Ue in me) Object.prototype.hasOwnProperty.call(me, Ue) && ue.indexOf(Ue) < 0 && (Qe[Ue] = me[Ue]);
  if (me != null && typeof Object.getOwnPropertySymbols == "function")
    for (var He = 0, Ue = Object.getOwnPropertySymbols(me); He < Ue.length; He++)
      ue.indexOf(Ue[He]) < 0 && Object.prototype.propertyIsEnumerable.call(me, Ue[He]) && (Qe[Ue[He]] = me[Ue[He]]);
  return Qe;
}
const FormContext = createContext(null);
FormContext.displayName = "RHFContext";
const useFormContext = () => useContext(FormContext), FormProvider = (me) => {
  var { children: ue } = me, Qe = __rest$2(me, ["children"]);
  return createElement$2(FormContext.Provider, { value: Object.assign({}, Qe) }, ue);
};
function ocrData({ token: me }) {
  return api.get("/omni/get/ocr-data", {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }).then((ue) => ue.data);
}
const greenCheck$1 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='39'%20height='28'%20viewBox='0%200%2039%2028'%3e%3cpath%20fill='%230CD5A2'%20fill-rule='nonzero'%20d='M37.858%206.574L17.284%2026.872a3.941%203.941%200%200%201-5.52%200l-10.62-10.48a3.815%203.815%200%200%201%200-5.445%203.94%203.94%200%200%201%205.518%200l7.862%207.756L32.337%201.128a3.941%203.941%200%200%201%205.52%200%203.816%203.816%200%200%201%200%205.446z'/%3e%3c/svg%3e", loadingLogo = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='43'%20height='43'%20viewBox='0%200%2043%2043'%3e%3cpath%20fill='none'%20fill-rule='evenodd'%20stroke='%2320263D'%20stroke-dasharray='2,3'%20stroke-linejoin='bevel'%20stroke-width='5'%20d='M21.5%2040C31.717%2040%2040%2031.717%2040%2021.5S31.717%203%2021.5%203%203%2011.283%203%2021.5%2011.283%2040%2021.5%2040z'/%3e%3c/svg%3e", redStrike = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='28'%20height='28'%20viewBox='0%200%2028%2028'%3e%3cpath%20fill='%23FF5C6F'%20fill-rule='nonzero'%20d='M27.054%205.515L18.57%2014l8.484%208.484a3.231%203.231%200%200%201-4.568%204.57L14%2018.569l-8.485%208.485A3.22%203.22%200%200%201%203.231%2028a3.231%203.231%200%200%201-2.284-5.516L9.43%2014%20.946%205.515A3.23%203.23%200%200%201%205.515.945L14%209.432%2022.485.946a3.231%203.231%200%200%201%204.569%204.569z'/%3e%3c/svg%3e", states = [
  { value: "AS", label: "Aguascalientes" },
  { value: "BC", label: "Baja California" },
  { value: "BS", label: "Baja California Sur" },
  { value: "CC", label: "Campeche" },
  { value: "CL", label: "Coahuila de Zaragoza" },
  { value: "CM", label: "Colima" },
  { value: "CS", label: "Chiapas" },
  { value: "CH", label: "Chihuahua" },
  { value: "DF", label: "Distrito Federal" },
  { value: "DG", label: "Durango" },
  { value: "GT", label: "Guanajuato" },
  { value: "GR", label: "Guerrero" },
  { value: "HG", label: "Hidalgo" },
  { value: "JC", label: "Jalisco" },
  { value: "MC", label: "Estado de México" },
  { value: "MN", label: "Michoacan de Ocampo" },
  { value: "MS", label: "Morelos" },
  { value: "NT", label: "Nayarit" },
  { value: "NL", label: "Nuevo León" },
  { value: "OC", label: "Oaxaca" },
  { value: "PL", label: "Puebla" },
  { value: "QT", label: "Queretaro de Arteaga" },
  { value: "QR", label: "Quintana Roo" },
  { value: "SP", label: "San Luis Potosi" },
  { value: "SL", label: "Sinaloa" },
  { value: "SR", label: "Sonora" },
  { value: "TC", label: "Tabasco" },
  { value: "TS", label: "Tamaulipas" },
  { value: "TL", label: "Tlaxcala" },
  { value: "VZ", label: "Veracruz" },
  { value: "YN", label: "Yucatan" },
  { value: "ZS", label: "Zacatecas" },
  { value: "NE", label: "Extranjero" }
], EnterCurpContainer = qe.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`, Title$8 = qe.h1`
  width: 100%;
  height: 30px;
  font-weight: bold;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  color: #21273b;
`, Input$4 = qe.input`
  width: 90%;
  max-width: 332px;
  height: 55px;
  margin-bottom: 20px;
  padding: 10px 15px;
  border-radius: 8px;
  background-color: rgba(33, 39, 59, 0.2);
  font-weight: bold;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  color: #21273b;

  &.enterCurp {
    text-transform: uppercase;
  }

  &.error-input {
    background-color: #ff637b;
    color: #fff;
    margin-bottom: 35px;
    &::placeholder {
      color: #fff;
      opacity: 0.5;
    }
  }

  &.curpName {
    &:focus {
      @media only screen and (max-height: 400px) {
        margin-top: 100px;
        color: green;
      }
    }
  }

  @media only screen and (max-height: 600px) {
    font-size: 17px;
    height: 40px;
    margin-bottom: 10px;
    padding: 5px 15px;
  }

  &.birthDate:not(.hasValue) {
    color: lightgray;
    :before {
      color: #21273b;
      content: attr(placeholder);
    }
  }
`, Select$1 = qe.select`
  width: 90%;
  max-width: 332px;
  height: 55px;
  margin-bottom: 20px;
  padding: 10px 15px;
  border-radius: 8px;
  background-color: rgba(33, 39, 59, 0.2);
  font-weight: bold;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  color: #21273b;
  border: none;

  &.error-input {
    border: solid 0.9px #ff5c6f;
    background-color: rgba(255, 92, 111, 0.1);
  }

  @media only screen and (max-height: 600px) {
    font-size: 17px;
    height: 40px;
    margin-bottom: 10px;
    padding: 5px 15px;
  }
`, Paragraph$2 = qe.p`
  height: 27px;
  font-weight: bold;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.69;
  text-align: center;
  color: #21273b;
`, Span$1 = qe.span`
  color: #3cb0f7;
`, Form$1 = qe.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  span {
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    text-transform: uppercase;
    color: #ff637b;
    width: 100%;
    margin-bottom: 40px;
  }
`, Content$2 = qe.div`
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`, errorInputClass = "error-input", spinner$1 = We`
  to {
    transform: rotate(360deg);
  }
`, Text$5 = qe.p`
  font-size: 28px;
  text-align: center;
  font-weight: bold;
  &.weak {
    font-size: 20px;
    font-weight: normal;
  }
`, Image$8 = qe.img`
  &.loading-icon {
    animation: ${spinner$1} 3s linear infinite;
  }
`;
function Loading$1() {
  const { t: me } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Image$8, { src: loadingLogo, alt: "loading...", className: "loading-icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$5, { children: me("curp.verifying") })
  ] });
}
function Success() {
  const { t: me } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Image$8, { src: greenCheck$1, alt: "success" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: me("curp.success") })
  ] });
}
function NotSuccess({ willRetry: me = !1 }) {
  const { t: ue } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Image$8, { src: redStrike, alt: "failure" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$5, { children: ue("curp.failed") }),
    me && /* @__PURE__ */ jsxRuntimeExports.jsx(Text$5, { className: "weak", children: ue("curp.retry") })
  ] });
}
function InProgress() {
  const { t: me } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Image$8, { src: greenCheck$1, alt: "inProgress" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: me("curp.inProgress") })
  ] });
}
const CURP_LENGTH = 18, isValidCurp = (me) => typeof me == "string" && me.length === CURP_LENGTH && me.toUpperCase().match(regex$1.CURP_PATTERN);
function EnterCurp({ onSuccess: me, token: ue }) {
  const { t: Qe } = useTranslation(), { register: Ue, handleSubmit: He, errors: Ge, reset: Xe, watch: Ke } = useForm(), [$e, Je] = useState(!0), [Ze, nt] = useState(!1), [tt, et] = useState("loading"), [rt, it] = useState(!1), ot = useRef(), at = window.visualViewport.height;
  useModuleEvents({
    module: eventModuleNames.curpValidation,
    token: ue
  }), useEventListener("resize", () => {
    const gt = window.visualViewport.height;
    ot.current.style.bottom = `${gt === at ? 25 : at - gt - 125}px`;
  }, window.visualViewport), useEffect(() => {
    addScreenEvent({
      module: eventModuleNames.curpValidation,
      screen: eventScreenNames.curpValidate,
      token: ue,
      shouldOpen: !0
    }), ocrData({
      token: ue
    }).then((gt) => {
      addScreenEvent({
        module: eventModuleNames.curpValidation,
        screen: eventScreenNames.curpValidate,
        token: ue,
        shouldOpen: !1
      });
      const { curp: wt } = gt;
      if (!wt) {
        et("idle"), addScreenEvent({
          module: eventModuleNames.curpValidation,
          screen: eventScreenNames.curpEnter,
          token: ue,
          shouldOpen: !0
        });
        return;
      }
      addScreenEvent({
        module: eventModuleNames.curpValidation,
        screen: eventScreenNames.curpValidation,
        token: ue,
        shouldOpen: !0
      }), addCurp(wt.toUpperCase(), ue).then((Bt) => {
        addScreenEvent({
          module: eventModuleNames.curpValidation,
          screen: eventScreenNames.curpValidation,
          token: ue,
          shouldOpen: !1
        }), Bt.success ? (addScreenEvent({
          module: eventModuleNames.curpValidation,
          screen: eventScreenNames.curpValidationSuccess,
          token: ue,
          shouldOpen: !0
        }), et("success"), setTimeout(() => {
          me(), addScreenEvent({
            module: eventModuleNames.curpValidation,
            screen: eventScreenNames.curpValidationSuccess,
            token: ue,
            shouldOpen: !1
          });
        }, 3e3)) : (et("idle"), it(!0), nt(!0), Xe({ curp: wt }), addScreenEvent({
          module: eventModuleNames.curpValidation,
          screen: eventScreenNames.curpEnter,
          token: ue,
          shouldOpen: !0
        }));
      }).catch(() => {
        et("idle"), it(!0), nt(!0), Xe({ curp: wt }), addScreenEvent({
          module: eventModuleNames.curpValidation,
          screen: eventScreenNames.curpEnter,
          token: ue,
          shouldOpen: !0
        });
      });
    }).catch(() => {
      et("idle"), addScreenEvent({
        module: eventModuleNames.curpValidation,
        screen: eventScreenNames.curpEnter,
        token: ue,
        shouldOpen: !0
      });
    });
  }, [me, Xe]);
  const ut = async (gt) => {
    const wt = $e ? "" : lt(gt.birthDate);
    let Bt = !1;
    et("loading"), addScreenEvent({
      module: eventModuleNames.curpValidation,
      screen: $e ? eventScreenNames.curpEnter : eventScreenNames.curpGenerate,
      token: ue,
      shouldOpen: !1
    }), addScreenEvent({
      module: eventModuleNames.curpValidation,
      screen: eventScreenNames.curpValidation,
      token: ue,
      shouldOpen: !0
    });
    try {
      const Tt = $e ? await addCurp(gt.curp.toUpperCase(), ue) : await addCurpv2({ ...gt, birthDate: wt }, ue);
      if (addScreenEvent({
        module: eventModuleNames.curpValidation,
        screen: eventScreenNames.curpValidation,
        token: ue,
        shouldOpen: !1
      }), Tt.result === "Attempting validation by scraping method")
        et("inProgress"), Bt = !0, addScreenEvent({
          module: eventModuleNames.curpValidation,
          screen: eventScreenNames.curpValidationSuccess,
          token: ue,
          shouldOpen: !0
        });
      else {
        if (Bt = Tt.success, (Tt == null ? void 0 : Tt.deceasedStatus) === "DECEASED") {
          me();
          return;
        }
        et(Bt ? "success" : "failed"), addScreenEvent(Bt ? {
          module: eventModuleNames.curpValidation,
          screen: eventScreenNames.curpValidationSuccess,
          token: ue,
          shouldOpen: !0
        } : {
          module: eventModuleNames.curpValidation,
          screen: eventScreenNames.curpValidationFailed,
          token: ue,
          shouldOpen: !0
        });
      }
    } catch {
      et("failed"), addScreenEvent({
        module: eventModuleNames.curpValidation,
        screen: eventScreenNames.curpValidationFailed,
        token: ue,
        shouldOpen: !0
      });
    }
    setTimeout(() => {
      rt || Bt ? (addScreenEvent({
        module: eventModuleNames.curpValidation,
        screen: Bt ? eventScreenNames.curpValidationSuccess : eventScreenNames.curpValidationFailed,
        token: ue,
        shouldOpen: !1
      }), me()) : (addScreenEvent({
        module: eventModuleNames.curpValidation,
        screen: eventScreenNames.curpValidationFailed,
        token: ue,
        shouldOpen: !1
      }), addScreenEvent({
        module: eventModuleNames.curpValidation,
        screen: $e ? eventScreenNames.curpEnter : eventScreenNames.curpGenerate,
        token: ue,
        shouldOpen: !0
      }), it(!0), et("idle"));
    }, 3e3);
  }, lt = (gt) => {
    const wt = gt.split("-");
    return `${wt[2]}/${wt[1]}/${wt[0]}`;
  }, dt = () => {
    Je(!1), addScreenEvent({
      module: eventModuleNames.curpValidation,
      screen: eventScreenNames.curpEnter,
      token: ue,
      shouldOpen: !1
    }), addScreenEvent({
      module: eventModuleNames.curpValidation,
      screen: eventScreenNames.curpGenerate,
      token: ue,
      shouldOpen: !0
    }), Xe();
  }, At = useMemo(() => {
    let gt = Qe("curp.labels.generate");
    return Ze ? gt = Qe("curp.labels.confirm") : $e && (gt = Qe("curp.labels.enter")), `${gt} ${Qe("curp.labels.yourCURP")}`;
  }, [Ze, $e, Qe]), pt = ((gt) => {
    if (gt === "loading")
      return Loading$1;
    if (gt === "success")
      return Success;
    if (gt === "failed")
      return NotSuccess;
    if (gt === "inProgress")
      return InProgress;
  })(tt);
  return tt !== "idle" ? /* @__PURE__ */ jsxRuntimeExports.jsx(EnterCurpContainer, { className: "IncodeEnterCurpContainer", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    pt,
    {
      className: "IncodeEnterCurpStatus",
      willRetry: !rt,
      enterCurp: $e
    }
  ) }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(EnterCurpContainer, { className: "IncodeEnterCurpContainer", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Content$2, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Title$8, { className: "IncodeEnterCurpTitle", children: At }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Form$1,
        {
          className: "IncodeEnterCurpForm",
          onSubmit: He(ut),
          autoComplete: "false",
          children: [
            $e ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Input$4,
                {
                  id: "curp",
                  name: "curp",
                  placeholder: "CURP",
                  className: classNames("enterCurp", { "error-input": Ge.curp }),
                  ref: Ue({
                    required: Qe("curp.errors.curpRequired"),
                    validate: (gt) => isValidCurp(gt) || Qe("curp.errors.curpInvalid")
                  })
                }
              ),
              !!Ge.curp && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: Ge.curp.message })
            ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Input$4,
                {
                  id: "name",
                  name: "name",
                  className: classNames("curpName", { "error-input": Ge.name }),
                  ref: Ue({
                    required: "required"
                  }),
                  placeholder: Qe("curp.labels.name")
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Input$4,
                {
                  id: "firstLastName",
                  name: "firstLastName",
                  className: Ge.firstLastName && errorInputClass,
                  ref: Ue({
                    required: "required"
                  }),
                  placeholder: Qe("curp.labels.firstLastName")
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Input$4,
                {
                  id: "secondLastName",
                  name: "secondLastName",
                  className: Ge.secondLastName && errorInputClass,
                  ref: Ue,
                  placeholder: Qe("curp.labels.secondLastName")
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsxs(
                Select$1,
                {
                  id: "gender",
                  name: "gender",
                  className: Ge.gender && errorInputClass,
                  ref: Ue({
                    required: "required"
                  }),
                  children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx("option", { disabled: !0, selected: !0, value: "", children: Qe("curp.labels.gender") }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "H", children: Qe("curp.labels.male") }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "M", children: Qe("curp.labels.female") }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "X", children: Qe("curp.labels.nonBinary") })
                  ]
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Input$4,
                {
                  id: "birthDate",
                  name: "birthDate",
                  className: classNames("birthDate", {
                    "error-input": Ge.birthDate,
                    hasValue: Ke("birthDate")
                  }),
                  type: "date",
                  max: formatInputDate(/* @__PURE__ */ new Date()),
                  ref: Ue({
                    required: "required"
                  }),
                  placeholder: Qe("curp.labels.birthDate")
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsxs(
                Select$1,
                {
                  id: "state",
                  name: "state",
                  className: Ge.state && errorInputClass,
                  ref: Ue({
                    required: "required"
                  }),
                  children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx("option", { disabled: !0, selected: !0, value: "", children: Qe("curp.labels.state") }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "NE", children: Qe("curp.labels.bornAbroad") }, "NE"),
                    states.map((gt) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: gt.value, children: gt.label }, gt.value))
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(Button$a, { disabled: tt !== "idle", type: "submit", children: Qe("common.continue") })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("footer", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Paragraph$2, { children: [
      Qe("curp.labels.missing"),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Span$1, { onClick: dt, children: Qe("curp.labels.generate") })
    ] }) })
  ] });
}
function renderEnterCurp(me, { onSuccess: ue, token: Qe }) {
  const Ue = createRoot$1(me), He = {
    onSuccess: handleUnmountRoot(ue, Ue, me),
    onBoarding: this,
    token: Qe
  };
  customRender(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { token: Qe, children: /* @__PURE__ */ jsxRuntimeExports.jsx(EnterCurp, { ...He }) }),
    me,
    Ue
  );
}
function fetchAssets({ token: me }) {
  if (api)
    return api.get("/omni/asset/fetch-all", {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }).then((ue) => ue.data).catch((ue) => Promise.reject(ue.response.data));
}
function fetchModels({ type: me }) {
  return api.get(`/omni/web-libs?type=${me}`).then((ue) => ue.data).catch((ue) => Promise.reject(ue.response.data));
}
const fetchModulesUrl = "/omni/get/onboarding-modules";
function fetchModules({ token: me }) {
  return api.get(fetchModulesUrl, {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }).then((ue) => ue.data).catch((ue) => Promise.reject(ue.response.data));
}
function fetchProcessingStatus({ token: me }) {
  return api.get("/omni/get/postprocess/isfinished", {
    headers: {
      "X-Incode-Hardware-Id": me.token
    }
  }).then((ue) => ue.data).catch((ue) => {
    var Qe;
    return Promise.reject((Qe = ue.response) == null ? void 0 : Qe.data);
  });
}
const Form = qe.form`
  height: 100%;
`, Container$6 = qe.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100vw;
  height: 100%;
  overflow: hidden;
`;
qe.div`
  text-align: center;
`;
const ScreenContainer = qe.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  width: 100%;
  padding: 40px 20px 0;
  overflow: auto;
  height: 100%;
`, Footer$1 = qe.div`
  border: solid 1px #e9e9eb;
  display: flex;
  justify-content: center;
  padding: 30px 0 40px;
  width: 100%;
`, Headline = qe.h1`
  font-size: 25px;
  line-height: 35px;
`;
qe.p`
  font-size: 14px;
  line-height: 21px;
  font-weight: 500;
`;
qe.img`
  margin: 20px auto;
`;
const FormGroup = qe.div`
  margin-bottom: 25px;
`, Label$1 = qe.label`
  display: flex;
  color: #636670;
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 5px;
`, baseInputStyles = Ae`
  border: solid 2px #979797;
  border-radius: 8px;
  padding: 17px 12px;
  width: 100%;
`, Input$3 = qe.input`
  ${baseInputStyles}
`, Textarea = qe.textarea`
  ${baseInputStyles}
`, Select = qe.select`
  ${baseInputStyles}
`, SpinnerContainer = qe.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  align-items: center;
  padding: 0 15px;
  width: calc(100% - 30px);
  text-align: center;

  ${Headline} {
    margin-top: 0;
  }
`, Spinner$2 = qe.div`
  border: 6px solid #20263d;
  border-radius: 50%;
  border-top: 6px solid transparent;
  width: 38px;
  height: 38px;
  margin-bottom: 15px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`, countriesOptions = Object.entries(countries).sort((me, ue) => me[1].name.localeCompare(ue[1].name));
function FormQuestion({ question: me }) {
  const { t: ue } = useTranslation(), Qe = useFormContext();
  return useEffect(() => {
    me.inputType === "PHONE" && Qe.register(me.questionId, { required: !0 });
  }, []), (() => {
    switch (me.inputType ?? me.overrides) {
      case "NUMBER":
      case "NAME":
        return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormGroup, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Label$1, { children: me.question }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Input$3,
            {
              id: me.questionId,
              name: me.questionId,
              type: "text",
              ref: Qe.register({
                required: !0
              }),
              placeholder: ue("forms.placeholder.input")
            }
          )
        ] });
      case "TEXT":
        return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormGroup, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Label$1, { children: me.question }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Textarea,
            {
              id: me.questionId,
              name: me.questionId,
              ref: Qe.register({
                required: !0
              }),
              placeholder: ue("forms.placeholder.input"),
              rows: 6
            }
          )
        ] });
      case "EMAIL":
        return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormGroup, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Label$1, { children: me.question }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Input$3,
            {
              id: me.questionId,
              name: me.questionId,
              type: "text",
              ref: Qe.register({
                required: !0,
                pattern: /^(([^<>()[\]\\.,;:\s@\\"]+(\.[^<>()[\]\\.,;:\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\]\\.,;:\s@\\"]+\.)+[^<>()[\]\\.,;:\s@\\"]{2,})$/i
              }),
              placeholder: "mail@mail.com"
            }
          )
        ] });
      case "DATE":
        return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormGroup, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Label$1, { children: me.question }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Input$3,
            {
              id: me.questionId,
              name: me.questionId,
              type: "text",
              ref: Qe.register({
                required: !0,
                pattern: /(^0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(\d{4}$)/
              }),
              placeholder: "DD/MM/YYYY",
              onChange: (Ge) => {
                const Xe = maskDate(Ge.target.value);
                Qe.setValue(me.questionId, Xe), Qe.trigger(me.questionId);
              }
            }
          )
        ] });
      case "COUNTRY":
      case "NATIONALITY":
        return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormGroup, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Label$1, { children: me.question }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Select,
            {
              id: me.questionId,
              name: me.questionId,
              defaultValue: "usa",
              ref: Qe.register({
                required: !0
              }),
              children: countriesOptions.map(([Ge, Xe]) => /* @__PURE__ */ jsxRuntimeExports.jsxs("option", { value: Xe.alpha3, children: [
                Xe.emoji,
                " ",
                ue(`countries.${Ge}`)
              ] }, Ge))
            }
          )
        ] });
      case "PHONE":
        return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormGroup, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Label$1, { children: me.question }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Phone$1,
            {
              handleNext: () => {
              },
              countryISOCode: "US",
              translations: {
                nextButtonTitle: ue("common.continue"),
                searchForCountry: ue("common.searchForCountry"),
                finishGptOptInLabel: ""
              },
              optinEnabled: !1,
              displayContinueButton: !1,
              onChange: (Ge) => {
                var $e;
                const Xe = parsePhoneNumber(Ge), Ke = !!(($e = Xe == null ? void 0 : Xe.isValid) != null && $e.call(Xe));
                Qe.setValue(me.questionId, Ge, {
                  shouldDirty: !0,
                  shouldValidate: Ke
                }), Ke ? Qe.clearErrors(me.questionId) : Qe.setError(me.questionId, {
                  type: "format"
                });
              }
            }
          )
        ] });
      case "CPF":
        return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormGroup, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Label$1, { children: me.question }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Input$3,
            {
              id: me.questionId,
              name: me.questionId,
              type: "text",
              ref: Qe.register({
                required: !0,
                pattern: /^\d{3}.\d{3}.\d{3}-\d{2}$/
              }),
              placeholder: ue("forms.placeholder.cpf"),
              onKeyDown: (Ge) => {
                if (Ge.key === "Backspace") {
                  Ge.preventDefault();
                  const Xe = document.getElementById(
                    me.questionId
                  ), { selectionStart: Ke, selectionEnd: $e, value: Je } = Xe, Ze = Je.split("");
                  if (Je.length < 1 || Ke === 0 && $e === 0)
                    return;
                  Ke === $e ? Ze.splice(Ke - 1, 1) : Ze.splice(Ke, $e), Qe.setValue(me.questionId, Ze.join("")), Qe.trigger(me.questionId), Xe.setSelectionRange(Ke, Ke);
                }
                (Ge.currentTarget.value.length > 13 || !(Ge.keyCode >= 48 && Ge.keyCode <= 57 || Ge.keyCode >= 96 && Ge.keyCode <= 105 || Ge.keyCode === 65 && (Ge.metaKey || Ge.ctrlKey))) && Ge.preventDefault();
              },
              onChange: (Ge) => {
                const Xe = (Ge.target.value ?? "").replace(/\D/g, "").split("");
                let Ke = "", $e = "", Je = 0, Ze = 0;
                Xe.forEach((nt) => {
                  Je < 3 ? Ze < 2 ? (Ke += nt, Ze++) : (Ke += `${nt}${Je < 2 ? "." : ""}`, Ze = 0, Je++) : $e += nt;
                }), Qe.setValue(
                  me.questionId,
                  `${Ke}${$e ? `-${$e}` : ""}`
                ), Qe.trigger(me.questionId);
              }
            }
          )
        ] });
      case "YESNO":
        return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormGroup, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Label$1, { children: me.question }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Select,
            {
              id: me.questionId,
              name: me.questionId,
              defaultValue: "YES",
              ref: Qe.register({
                required: !0
              }),
              children: ["YES", "NO"].map((Ge) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: Ge, children: ue(`forms.questions.${Ge.toLocaleLowerCase()}`) }, Ge))
            }
          )
        ] });
      default:
        return null;
    }
  })();
}
function Screen$1({
  screen: me,
  onContinue: ue,
  isLastScreen: Qe,
  order: Ue,
  token: He
}) {
  const { t: Ge } = useTranslation(), Xe = useForm({ mode: "all" }), { isValid: Ke } = Xe.formState, { title: $e, hideTitle: Je, questions: Ze } = me;
  useScreenEvents({
    module: eventModuleNames.forms,
    screen: `${eventScreenNames.forms}_${Ue}`,
    token: He
  });
  const nt = (tt) => {
    ue(tt);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormProvider, { ...Xe, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Form, { onSubmit: Xe.handleSubmit(nt), children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Container$6, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ScreenContainer, { children: [
      !Je && $e ? /* @__PURE__ */ jsxRuntimeExports.jsx(Headline, { children: $e }) : null,
      Ze.map((tt) => /* @__PURE__ */ jsxRuntimeExports.jsx(FormQuestion, { question: tt }, tt.questionId))
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Footer$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button$a, { disabled: !Ke, type: "submit", theme, children: Ge(Qe ? "signature.done" : "forms.button.continue") }) })
  ] }) }) });
}
function getAnswerValue(me, ue) {
  switch (me) {
    case "CPF":
      return ue.replace(/[-.]/g, "");
    case "DATE": {
      const [Qe, Ue, He] = ue.split("/");
      return Date.UTC(
        parseInt(He),
        parseInt(Ue) - 1,
        parseInt(Qe),
        0,
        0,
        0,
        0
      ).toString();
    }
    default:
      return ue;
  }
}
function Forms({
  onSuccess: me,
  onError: ue,
  onBoarding: Qe,
  interviewId: Ue,
  token: He,
  flowId: Ge,
  screens: Xe
}) {
  const { currentStep: Ke, nextStep: $e } = useSteps(0), [Je, Ze] = useState(() => (Xe == null ? void 0 : Xe.length) > 0 ? Xe : []), [nt, tt] = useState(
    () => (Xe == null ? void 0 : Xe.length) > 0 ? "none" : "loading"
  );
  useModuleEvents({
    module: eventModuleNames.forms,
    token: He
  });
  const et = (it) => {
    it === "success" ? me() : ue();
  }, rt = (it) => async (ot) => {
    var at;
    addEvent({
      token: He,
      code: "submitAnswersClicked"
    });
    try {
      const st = (at = Je[it]) == null ? void 0 : at.questions;
      for (let ut = 0; ut < st.length; ut++) {
        const lt = st[ut], dt = ot[lt.questionId];
        await Qe.submitAnswer({
          token: He,
          answer: {
            interviewId: Ue,
            questionId: lt.questionId,
            answerDetails: {
              singleAnswer: getAnswerValue(lt.inputType ?? lt.overrides, dt)
            }
          }
        });
      }
      Ke >= Je.length - 1 ? et("success") : $e();
    } catch {
      et("error");
    }
  };
  return useEffect(() => {
    async function it() {
      try {
        const ot = await Qe.getForms({ flowId: Ge, token: He });
        Ze(ot.screens), tt("none");
      } catch {
        et("error");
      }
    }
    nt === "loading" && Ge && it();
  }, [Ge, Qe.getForms, nt, He]), nt === "loading" ? /* @__PURE__ */ jsxRuntimeExports.jsx(SpinnerContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$2, {}) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Steps, { currentStep: Ke, children: Je.map((it, ot) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    Screen$1,
    {
      order: ot + 1,
      screen: it,
      onContinue: rt(ot),
      isLastScreen: ot === Je.length - 1,
      token: He
    },
    ot
  )) });
}
function renderForms(me, { onSuccess: ue, onError: Qe, token: Ue, interviewId: He, flowId: Ge, screens: Xe }) {
  const Ke = createRoot$1(me), $e = {
    token: Ue,
    interviewId: He,
    onBoarding: this,
    flowId: Ge,
    onSuccess: handleUnmountRoot(ue, Ke, me),
    onError: handleUnmountRoot(Qe, Ke, me),
    screens: Xe
  };
  customRender(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { token: Ue, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Forms, { ...$e }) }),
    me,
    Ke
  );
}
const getGenerateDocumentUploadUrl = () => "/omni/es/generateDocumentUploadUrl";
function generateAESDocumentUploadUrl({
  token: me
}) {
  return api.post(
    getGenerateDocumentUploadUrl(),
    {},
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).then((ue) => ue.data);
}
const generateOTPUrl = "/omni/code/generate";
function generateOTP({ token: me }) {
  return api.get(generateOTPUrl, {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }).then((ue) => ue.data).catch((ue) => Promise.reject(ue.response.data));
}
const getUnsignedDocsURL = () => "/omni/es/documents/unsigned";
function getAdvancedElectronicSignatureUnsignedDocs({
  token: me
}) {
  return api.get(getUnsignedDocsURL(), {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }).then((ue) => ue.data);
}
const getBelvoWidgetToken = async ({ token: me }) => api.get("/omni/bav/get/token", {
  headers: {
    "X-Incode-Hardware-Id": me
  }
}).then((ue) => ue.data).catch((ue) => Promise.reject(ue.response.data));
function getConnectionDetails(me) {
  return api.get(`/omni/queue/conference/connection-details?uuid=${me}`).then((ue) => ue.data).catch((ue) => ({ error: `Error: ${ue}` }));
}
const getCustomFields = ({ token: me }) => api.get("/omni/get/custom-fields", {
  headers: {
    "X-Incode-Hardware-Id": me
  }
}).then((ue) => ue.data).catch((ue) => Promise.reject(ue.response.data)), getFinishStatus = (me, { token: ue }) => api.get(`/omni/finish-status${me ? `?flowId=${me}` : ""}`, {
  headers: {
    "X-Incode-Hardware-Id": ue
  }
}).then((Qe) => Qe.data), getFormsURL = ({ flowId: me }) => `/omni/flow/onboarding/configuration?id=${me}&moduleKey=DYNAMIC_FORMS`;
function getForms({
  token: me,
  flowId: ue
}) {
  return api.get(getFormsURL({ flowId: ue }), {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }).then((Qe) => Qe.data);
}
function getImages$1({ token: me, body: ue, onDownloadProgress: Qe }) {
  return api.post("/omni/get/images", ue, {
    headers: {
      "X-Incode-Hardware-Id": me
    },
    onDownloadProgress: ({ loaded: Ue, total: He }) => {
      Qe == null || Qe(Ue * 100 / He);
    }
  }).then((Ue) => Ue.data);
}
function getImages({ token: me, body: ue }) {
  return api.post("/omni/get/images/v2", ue, {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }).then((Qe) => Qe.data);
}
async function getInstantVerifyMissingModules({
  token: me
}) {
  return api.get("/omni/instant/missing-modules", {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }).then((ue) => ue.data).catch((ue) => Promise.reject(ue.response.data));
}
const getInterviewData = (me) => api.get("/omni/get/data", {
  headers: {
    "X-Incode-Hardware-Id": me
  }
}).then((ue) => ue.data).catch((ue) => Promise.reject(ue.response));
function getInterviewerName({ token: me }) {
  return api.get("/omni/get/interviewer-info", {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }).then((ue) => ue.data);
}
const getLocationSuggestionsURL = "/omni/externalVerification/addressAutocomplete";
function getLocationSuggestions({ token: me, search: ue }) {
  return api.post(
    getLocationSuggestionsURL,
    {
      search: ue
    },
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).then((Qe) => Qe.data).catch((Qe) => Promise.reject(Qe.response.data));
}
function getMedicalOcrData({ token: me }) {
  return api.get("/omni/get/medical-ocr-data", {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }).then((ue) => ue.data).catch((ue) => ({ error: `Error: ${ue}` }));
}
const getModuleConfigURL = ({ flowId: me, module: ue }) => `/omni/flow/onboarding/configuration?id=${me}&moduleKey=${ue}`;
function getModuleConfig({
  token: me,
  flowId: ue,
  module: Qe
}) {
  return api.get(getModuleConfigURL({ flowId: ue, module: Qe }), {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }).then((Ue) => Ue.data);
}
const getOnboardingStatusUrl = (me) => `/omni/get/onboarding/status?=${me}`;
function getOnboardingStatus(me) {
  return api.get(getOnboardingStatusUrl(me.interviewId), {
    headers: {
      "X-Incode-Hardware-Id": me.token
    }
  }).then((ue) => ue.data).catch((ue) => Promise.reject(ue.response.data));
}
function getOpenTokTest({ token: me }) {
  return api.get("/omni/get/opentok-test", {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }).then((ue) => ue.data);
}
const getOtpStatusURL = () => "/omni/session/otp-status";
function getOtpStatus({
  token: me
}) {
  return api.get(getOtpStatusURL(), {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }).then((ue) => ue.data);
}
function getQueueIndex({ token: me, queueName: ue }) {
  return api.get(`/omni/queue/conference/index?queueName=${ue}`, {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }).then((Qe) => Qe.data);
}
function getRandomQuestions({ token: me, numberOfQuestions: ue = 3 }) {
  return api.get("/omni/get/questionAndAnswer", {
    headers: {
      "X-Incode-Hardware-Id": me
    },
    params: { numberOfQuestions: ue }
  }).then((Qe) => Qe.data);
}
const getRedirectUrl = (me, { token: ue }) => api.get(`omni/redirection-url${me ? `?flowId=${me}` : ""}`, {
  headers: {
    "X-Incode-Hardware-Id": ue
  }
}).then((Qe) => Qe.data), getScoreUrl = () => "/omni/get/score";
async function getScore({ token: me }) {
  return (await api.get(getScoreUrl(), {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  })).data;
}
function getSecondIdImages({ token: me, body: ue }) {
  return api.post("/omni/get/images-second-id", ue, {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }).then((Qe) => Qe.data);
}
function getSecondIdImagesV2({ token: me, body: ue }) {
  return api.post("/omni/get/images-second-id", ue, {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }).then((Qe) => Qe.data);
}
const getWatchlistUrl = (me) => `/omni/updated-watchlist-result?id=${me}`;
async function getWatchlist(me, { token: ue }) {
  try {
    return (await api.get(getWatchlistUrl(me), {
      headers: {
        "X-Incode-Hardware-Id": ue
      }
    })).data;
  } catch {
    return {};
  }
}
async function instantVerifyShareIdentity({
  token: me,
  consentGiven: ue
}) {
  return api.post(
    "/omni/instant/share-identity",
    {
      consentGiven: ue
    },
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).then((Qe) => Qe.data).catch((Qe) => Promise.reject(Qe.response.data));
}
async function instantVerifyUpdate({ token: me }) {
  return api.post(
    "/omni/instant/update-identity",
    {},
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).then((ue) => ue.data).catch((ue) => Promise.reject(ue.response.data));
}
function lastNameMatch({ token: me }) {
  return api.get("/omni/last-name-match", {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }).then((ue) => ue.data).catch((ue) => Promise.reject(ue.response));
}
function lastNameMatchByCustomer({ token: me }) {
  return api.get("/omni/customer/last-name-match ", {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }).then((ue) => ue.data).catch((ue) => Promise.reject(ue.response));
}
const okCheck = "data:image/svg+xml,%3csvg%20width='25'%20height='24'%20viewBox='0%200%2025%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_6614_23528)'%3e%3cellipse%20cx='12.7864'%20cy='12'%20rx='12.2136'%20ry='12'%20fill='%231FB834'/%3e%3cpath%20d='M16.3919%209.19405L10.9524%2014.4012L8.75362%2012.2966C8.48341%2012.0383%208.04569%2012.0381%207.77549%2012.2968C7.50518%2012.5556%207.50518%2012.9747%207.77549%2013.2333L10.4635%2015.8062C10.5985%2015.9354%2010.7755%2016%2010.9524%2016C11.1294%2016%2011.3068%2015.9354%2011.4419%2015.806C11.4423%2015.8055%2017.37%2010.1304%2017.37%2010.1304C17.6403%209.87192%2017.6403%209.45252%2017.37%209.194C17.0999%208.93532%2016.6618%208.93532%2016.3919%209.19405Z'%20fill='white'%20stroke='white'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_6614_23528'%3e%3crect%20width='24.4273'%20height='24'%20fill='white'%20transform='translate(0.572754)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", ManualIdUploadContainer = qe.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  padding-top: 25px;
  h1 {
    font-size: 1.5625rem;
  }
`, UploadDocumentContainer = qe.div`
  background: #f5f5f5;
  padding: 25px 25px 40px;
  display: flex;
  flex-direction: column;  
    ul {
      padding: 14px 16px 14px 16px;
      background: #EAEAEA;
      margin: 30px 15px 0;
      border-radius: 6px;
      list-style-type: disc;
      li {
        margin-left: 15px;
        text-align: left;
        font-size: .875rem;
        line-height: 1.625rem;
        font-weight: 100;
        color: #636670;
        text-transform: ;
      }
    }
`, UploadLabel = qe.label`
  background: #006AFF;
  color: #FFF;
  font-size: .875rem;
  padding: 5px 10px;
  border-radius: 6px;
  justify-self: flex-end;
`, UploadDocButton = qe.button`
  background: #FFF;
  padding: 20px 26px 20px 20px;
  margin-bottom: 10px;
  text-align: left;
  border-radius: 10px;
  font-size: .93rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`, CompleteUploadButton = qe.button`
  background: ${(me) => me.disabled ? "#e9e9eb" : "#006AFF"};
  color: ${(me) => me.disabled ? "#636670" : "#FFF"};
  font-size: 1rem;
  padding: 10px 20px;
  border-radius: 6px;
  margin-top: 20px;
  width: auto;
  padding: 19px 32px;
  align-self: center;
  min-width: 250px;
  margin-bottom: 40px;
`, ManualIdUploadTabs = qe.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  button {
    flex: 1;
    padding: 10px 0 0;
    color: #60667C;
    &:after {
      content: '';
      width: 50%;
      min-width: 100px;
      background: transparent;
      height: 2px;
      display: block;
      margin: auto;
      margin-top: 10px;

    }
    &.selected {
      &:after {
        background: #006AFF;
      }
    }
  }
`, UploadingScreen = qe.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  h1 {
    font-size: 1.5625rem;
    margin-bottom: 0;
  }
`, ErrorMessage$2 = qe.div`
  margin-bottom: auto;
  p {
    color: #FF0000;
    font-size: 1rem;
    margin-top: 10px;
  }
`, CaptureManualId = (me) => {
  const [ue, Qe] = useState("id"), [Ue, He] = useState({
    front: !1,
    back: !1,
    passport: !1
  }), [Ge, Xe] = useState(
    me.token.idCaptureRetries - 3 || 3
  ), [Ke, $e] = useState(null), [Je, Ze] = useState(!1), [nt, tt] = useState(null), et = useRef(null), { t: rt } = useTranslation(), it = useMemo(
    () => Object.values(Ue).some((lt) => lt === !0),
    [Ue]
  ), ot = (lt) => {
    const dt = {
      WRONG_DOCUMENT_SIDE: rt("manualIdUpload.wrongSide"),
      WRONG_ONE_SIDED_DOCUMENT: rt("manualIdUpload.wrongSide"),
      UNKNOWN_DOCUMENT_TYPE: rt("manualIdUpload.pleaseUploadCorrectDocument")
    };
    return dt[lt.failReason] ? ($e(dt[lt.failReason]), Xe(Ge - 1), !0) : lt.failReason ? ($e(rt("manualIdUpload.somethingWentWrong")), Xe(Ge - 1), !0) : nt === "passport" && lt.typeOfId !== "Passport" || ["front", "back"].includes(nt) && lt.typeOfId === "Passport" ? ($e(rt("manualIdUpload.pleaseUploadCorrectDocument")), Xe(Ge - 1), !0) : !1;
  }, at = async (lt) => {
    const dt = lt.target.files[0], At = 5 * 1024 * 1024;
    if (dt.size > At) {
      $e(rt("manualIdUpload.fileTooBig"));
      return;
    }
    Ze(!0), $e(null), (async () => {
      Ze(!0);
      try {
        const gt = await capture({
          token: me.token.token,
          image: dt,
          type: ["front", "passport"].includes(nt) ? "front" : "back",
          onProgress: () => {
          },
          sendBase64: !1,
          onlyFront: !1,
          isRetry: !1,
          isSecondId: !1,
          encrypted: !1,
          faceCoordinates: void 0,
          imageType: dt.type,
          shouldSkipGlareBack: !1,
          shouldSkipGlareFront: !1,
          captureType: "UPLOAD"
        });
        ot(gt) || (He((wt) => ({ ...wt, [nt]: !0 })), lt.target.value = "");
      } catch (gt) {
        console.error("Error uploading image:", gt);
      } finally {
        Ze(!1);
      }
    })();
  }, st = (lt) => {
    tt(lt), et.current && et.current.click();
  }, ut = () => ue === "id" ? !(Ue.front && Ue.back) : !Ue.passport;
  return Je ? /* @__PURE__ */ jsxRuntimeExports.jsxs(UploadingScreen, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$5, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: rt("manualIdUpload.holdOnASec") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: rt("manualIdUpload.uploadingYourFile") })
  ] }) : Ge === 0 ? (setTimeout(() => {
    me.onSuccess();
  }, 5e3), /* @__PURE__ */ jsxRuntimeExports.jsxs(UploadingScreen, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: rt("manualIdUpload.tooManyTries") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: rt("manualIdUpload.contactedByAdmin") })
  ] })) : /* @__PURE__ */ jsxRuntimeExports.jsxs(ManualIdUploadContainer, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: rt("manualIdUpload.title") }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ManualIdUploadTabs, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          type: "button",
          onClick: () => Qe("id"),
          className: ue === "id" && "selected",
          disabled: it,
          children: rt("manualIdUpload.id")
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          type: "button",
          onClick: () => Qe("passport"),
          className: ue === "passport" && "selected",
          disabled: it,
          children: rt("manualIdUpload.passport")
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(UploadDocumentContainer, { className: "IncodeManualUploadSectionContainer", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          type: "file",
          style: { display: "none" },
          ref: et,
          onChange: at,
          accept: "image/*"
        }
      ),
      ue === "id" && /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          UploadDocButton,
          {
            type: "button",
            onClick: () => st("front"),
            disabled: Ue.front,
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: rt("manualIdUpload.frontId") }),
              Ue.front ? /* @__PURE__ */ jsxRuntimeExports.jsx("img", { height: "24", src: okCheck, alt: "uploaded check" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(UploadLabel, { children: rt("manualIdUpload.upload") })
            ]
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          UploadDocButton,
          {
            type: "button",
            onClick: () => st("back"),
            disabled: Ue.back,
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: rt("manualIdUpload.backId") }),
              Ue.back ? /* @__PURE__ */ jsxRuntimeExports.jsx("img", { height: "24", src: okCheck, alt: "uploaded check" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(UploadLabel, { children: rt("manualIdUpload.upload") })
            ]
          }
        )
      ] }),
      ue === "passport" && /* @__PURE__ */ jsxRuntimeExports.jsx(Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        UploadDocButton,
        {
          type: "button",
          onClick: () => st("passport"),
          disabled: Ue.passport,
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: rt("manualIdUpload.passport") }),
            Ue.passport ? /* @__PURE__ */ jsxRuntimeExports.jsx("img", { height: "24", src: okCheck, alt: "uploaded check" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(UploadLabel, { children: rt("manualIdUpload.upload") })
          ]
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("ul", { className: "IncodeManualUploadInstrucctions", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: rt(`manualIdUpload.${ue}Text`) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: rt("manualIdUpload.glareFree") }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: rt("manualIdUpload.avoidBlur") })
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorMessage$2, { children: Ke && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: Ke }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CompleteUploadButton,
      {
        type: "button",
        onClick: () => me.onSuccess(),
        disabled: ut(),
        children: rt("manualIdUpload.continue")
      }
    )
  ] });
};
function manualIdUpload(me, { token: ue, onSuccess: Qe, type: Ue } = {}) {
  const He = createRoot$1(me), Ge = {
    onSuccess: handleUnmountRoot(Qe, He, me),
    onBoarding: this,
    type: Ue,
    token: ue
  };
  customRender(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { token: ue.token, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CaptureManualId, { token: ue, ...Ge }) }),
    me,
    He
  );
}
function mock({
  token: me,
  interviewId: ue
}) {
  return api.get(`/omni/mock?interviewId=${ue}`, {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  });
}
function ocrDataSecondId({ token: me }) {
  return api.get("/omni/get/ocr-data-second-id", {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }).then((ue) => ue.data);
}
function compareOTP({ token: me, code: ue, channel: Qe = "SMS" }) {
  return api.get(`/omni/compare/otp?code=${ue}&channel=${Qe}`, {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }).then((Ue) => Ue.data).catch((Ue) => Promise.reject(Ue.response.data));
}
function sendOTPSMS({
  token: me,
  communicationChannel: ue = "SMS"
}) {
  return api.get(`/omni/send/sms-otp?communicationchannel=${ue}`, {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }).then((Qe) => Qe.data).catch((Qe) => Promise.reject(Qe.response.data));
}
function processAddressStatement({ token: me }) {
  return api.post("/omni/process/address", null, {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }).catch((ue) => Promise.reject(ue.response.data));
}
const getProcessDocsURL = () => "/omni/es/process/sign";
function processAdvancedElectronicSignatureDocs({
  token: me,
  documentRef: ue
}) {
  return api.post(
    getProcessDocsURL(),
    {
      documentRef: ue,
      userConsented: !0
    },
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).then((Qe) => Qe.data);
}
const processAntiFraud = ({ token: me, interviewId: ue }) => api.get(`/omni/process/antifraud?id=${ue}`, {
  headers: {
    "X-Incode-Hardware-Id": me
  }
}).catch((Qe) => Promise.reject(Qe.response.data));
function processCreditCard({ token: me }) {
  return api.post(
    "/omni/process/credit-card",
    {},
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).catch((ue) => Promise.reject(ue.response.data));
}
function processCrossDocumentData({ token: me }) {
  return api.post(
    "/omni/cross-doc-data-check/process",
    {},
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).then((ue) => ue.data).catch((ue) => Promise.reject(ue.response.data));
}
function processGlobalWatchlist({ token: me }) {
  return api.post(
    "/omni/process/global-watchlist",
    {},
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).then((ue) => ue.data).catch((ue) => Promise.reject(ue.response.data));
}
function processGovernmentValidation({ token: me }) {
  return api.post(
    "/omni/process/government-validation",
    {},
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).then((ue) => ue.data).catch((ue) => Promise.reject(ue.response.data));
}
function processId({ token: me, queueName: ue = "" }) {
  return api.post(
    `/omni/process/id?queueName=${ue}`,
    {},
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).catch((Qe) => Promise.reject(Qe.response.data));
}
function processImss({ token: me, curp: ue = "" }) {
  return api.post(
    "/omni/process/imss",
    { curp: ue },
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).catch((Qe) => Promise.reject(Qe.response.data));
}
function processSecondId({ token: me, queueName: ue = "" }) {
  return api.post(
    `/omni/process/second-id?queueName=${ue}`,
    {},
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).catch((Qe) => Promise.reject(Qe.response.data));
}
function processWatchlist({ token: me }) {
  return api.post(
    "/omni/process/watchlist",
    {},
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).then((ue) => ue.data).catch((ue) => Promise.reject(ue.response.data));
}
/*! For license information please see bundle.js.LICENSE.txt */
(() => {
  var me = { 5766: (He, Ge) => {
    Ge.byteLength = function(rt) {
      var it = tt(rt), ot = it[0], at = it[1];
      return 3 * (ot + at) / 4 - at;
    }, Ge.toByteArray = function(rt) {
      var it, ot, at = tt(rt), st = at[0], ut = at[1], lt = new $e(function(pt, gt, wt) {
        return 3 * (gt + wt) / 4 - wt;
      }(0, st, ut)), dt = 0, At = ut > 0 ? st - 4 : st;
      for (ot = 0; ot < At; ot += 4) it = Ke[rt.charCodeAt(ot)] << 18 | Ke[rt.charCodeAt(ot + 1)] << 12 | Ke[rt.charCodeAt(ot + 2)] << 6 | Ke[rt.charCodeAt(ot + 3)], lt[dt++] = it >> 16 & 255, lt[dt++] = it >> 8 & 255, lt[dt++] = 255 & it;
      return ut === 2 && (it = Ke[rt.charCodeAt(ot)] << 2 | Ke[rt.charCodeAt(ot + 1)] >> 4, lt[dt++] = 255 & it), ut === 1 && (it = Ke[rt.charCodeAt(ot)] << 10 | Ke[rt.charCodeAt(ot + 1)] << 4 | Ke[rt.charCodeAt(ot + 2)] >> 2, lt[dt++] = it >> 8 & 255, lt[dt++] = 255 & it), lt;
    }, Ge.fromByteArray = function(rt) {
      for (var it, ot = rt.length, at = ot % 3, st = [], ut = 16383, lt = 0, dt = ot - at; lt < dt; lt += ut) st.push(et(rt, lt, lt + ut > dt ? dt : lt + ut));
      return at === 1 ? (it = rt[ot - 1], st.push(Xe[it >> 2] + Xe[it << 4 & 63] + "==")) : at === 2 && (it = (rt[ot - 2] << 8) + rt[ot - 1], st.push(Xe[it >> 10] + Xe[it >> 4 & 63] + Xe[it << 2 & 63] + "=")), st.join("");
    };
    for (var Xe = [], Ke = [], $e = typeof Uint8Array < "u" ? Uint8Array : Array, Je = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Ze = 0, nt = Je.length; Ze < nt; ++Ze) Xe[Ze] = Je[Ze], Ke[Je.charCodeAt(Ze)] = Ze;
    function tt(rt) {
      var it = rt.length;
      if (it % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
      var ot = rt.indexOf("=");
      return ot === -1 && (ot = it), [ot, ot === it ? 0 : 4 - ot % 4];
    }
    function et(rt, it, ot) {
      for (var at, st, ut = [], lt = it; lt < ot; lt += 3) at = (rt[lt] << 16 & 16711680) + (rt[lt + 1] << 8 & 65280) + (255 & rt[lt + 2]), ut.push(Xe[(st = at) >> 18 & 63] + Xe[st >> 12 & 63] + Xe[st >> 6 & 63] + Xe[63 & st]);
      return ut.join("");
    }
    Ke[45] = 62, Ke[95] = 63;
  }, 8834: (He, Ge, Xe) => {
    var Ke = Xe(5766), $e = Xe(2333), Je = Xe(7906);
    function Ze() {
      return tt.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
    }
    function nt(Ot, ft) {
      if (Ze() < ft) throw new RangeError("Invalid typed array length");
      return tt.TYPED_ARRAY_SUPPORT ? (Ot = new Uint8Array(ft)).__proto__ = tt.prototype : (Ot === null && (Ot = new tt(ft)), Ot.length = ft), Ot;
    }
    function tt(Ot, ft, Dt) {
      if (!(tt.TYPED_ARRAY_SUPPORT || this instanceof tt)) return new tt(Ot, ft, Dt);
      if (typeof Ot == "number") {
        if (typeof ft == "string") throw new Error("If encoding is specified then the first argument must be a string");
        return it(this, Ot);
      }
      return et(this, Ot, ft, Dt);
    }
    function et(Ot, ft, Dt, Mt) {
      if (typeof ft == "number") throw new TypeError('"value" argument must not be a number');
      return typeof ArrayBuffer < "u" && ft instanceof ArrayBuffer ? function(Ft, Gt, zt, $t) {
        if (Gt.byteLength, zt < 0 || Gt.byteLength < zt) throw new RangeError("'offset' is out of bounds");
        if (Gt.byteLength < zt + ($t || 0)) throw new RangeError("'length' is out of bounds");
        return Gt = zt === void 0 && $t === void 0 ? new Uint8Array(Gt) : $t === void 0 ? new Uint8Array(Gt, zt) : new Uint8Array(Gt, zt, $t), tt.TYPED_ARRAY_SUPPORT ? (Ft = Gt).__proto__ = tt.prototype : Ft = ot(Ft, Gt), Ft;
      }(Ot, ft, Dt, Mt) : typeof ft == "string" ? function(Ft, Gt, zt) {
        if (typeof zt == "string" && zt !== "" || (zt = "utf8"), !tt.isEncoding(zt)) throw new TypeError('"encoding" must be a valid string encoding');
        var $t = 0 | st(Gt, zt), Ht = (Ft = nt(Ft, $t)).write(Gt, zt);
        return Ht !== $t && (Ft = Ft.slice(0, Ht)), Ft;
      }(Ot, ft, Dt) : function(Ft, Gt) {
        if (tt.isBuffer(Gt)) {
          var zt = 0 | at(Gt.length);
          return (Ft = nt(Ft, zt)).length === 0 || Gt.copy(Ft, 0, 0, zt), Ft;
        }
        if (Gt) {
          if (typeof ArrayBuffer < "u" && Gt.buffer instanceof ArrayBuffer || "length" in Gt) return typeof Gt.length != "number" || ($t = Gt.length) != $t ? nt(Ft, 0) : ot(Ft, Gt);
          if (Gt.type === "Buffer" && Je(Gt.data)) return ot(Ft, Gt.data);
        }
        var $t;
        throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
      }(Ot, ft);
    }
    function rt(Ot) {
      if (typeof Ot != "number") throw new TypeError('"size" argument must be a number');
      if (Ot < 0) throw new RangeError('"size" argument must not be negative');
    }
    function it(Ot, ft) {
      if (rt(ft), Ot = nt(Ot, ft < 0 ? 0 : 0 | at(ft)), !tt.TYPED_ARRAY_SUPPORT) for (var Dt = 0; Dt < ft; ++Dt) Ot[Dt] = 0;
      return Ot;
    }
    function ot(Ot, ft) {
      var Dt = ft.length < 0 ? 0 : 0 | at(ft.length);
      Ot = nt(Ot, Dt);
      for (var Mt = 0; Mt < Dt; Mt += 1) Ot[Mt] = 255 & ft[Mt];
      return Ot;
    }
    function at(Ot) {
      if (Ot >= Ze()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + Ze().toString(16) + " bytes");
      return 0 | Ot;
    }
    function st(Ot, ft) {
      if (tt.isBuffer(Ot)) return Ot.length;
      if (typeof ArrayBuffer < "u" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(Ot) || Ot instanceof ArrayBuffer)) return Ot.byteLength;
      typeof Ot != "string" && (Ot = "" + Ot);
      var Dt = Ot.length;
      if (Dt === 0) return 0;
      for (var Mt = !1; ; ) switch (ft) {
        case "ascii":
        case "latin1":
        case "binary":
          return Dt;
        case "utf8":
        case "utf-8":
        case void 0:
          return Xt(Ot).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return 2 * Dt;
        case "hex":
          return Dt >>> 1;
        case "base64":
          return Ut(Ot).length;
        default:
          if (Mt) return Xt(Ot).length;
          ft = ("" + ft).toLowerCase(), Mt = !0;
      }
    }
    function ut(Ot, ft, Dt) {
      var Mt = !1;
      if ((ft === void 0 || ft < 0) && (ft = 0), ft > this.length || ((Dt === void 0 || Dt > this.length) && (Dt = this.length), Dt <= 0) || (Dt >>>= 0) <= (ft >>>= 0)) return "";
      for (Ot || (Ot = "utf8"); ; ) switch (Ot) {
        case "hex":
          return bt(this, ft, Dt);
        case "utf8":
        case "utf-8":
          return ht(this, ft, Dt);
        case "ascii":
          return vt(this, ft, Dt);
        case "latin1":
        case "binary":
          return Et(this, ft, Dt);
        case "base64":
          return Ct(this, ft, Dt);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Rt(this, ft, Dt);
        default:
          if (Mt) throw new TypeError("Unknown encoding: " + Ot);
          Ot = (Ot + "").toLowerCase(), Mt = !0;
      }
    }
    function lt(Ot, ft, Dt) {
      var Mt = Ot[ft];
      Ot[ft] = Ot[Dt], Ot[Dt] = Mt;
    }
    function dt(Ot, ft, Dt, Mt, Ft) {
      if (Ot.length === 0) return -1;
      if (typeof Dt == "string" ? (Mt = Dt, Dt = 0) : Dt > 2147483647 ? Dt = 2147483647 : Dt < -2147483648 && (Dt = -2147483648), Dt = +Dt, isNaN(Dt) && (Dt = Ft ? 0 : Ot.length - 1), Dt < 0 && (Dt = Ot.length + Dt), Dt >= Ot.length) {
        if (Ft) return -1;
        Dt = Ot.length - 1;
      } else if (Dt < 0) {
        if (!Ft) return -1;
        Dt = 0;
      }
      if (typeof ft == "string" && (ft = tt.from(ft, Mt)), tt.isBuffer(ft)) return ft.length === 0 ? -1 : At(Ot, ft, Dt, Mt, Ft);
      if (typeof ft == "number") return ft &= 255, tt.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? Ft ? Uint8Array.prototype.indexOf.call(Ot, ft, Dt) : Uint8Array.prototype.lastIndexOf.call(Ot, ft, Dt) : At(Ot, [ft], Dt, Mt, Ft);
      throw new TypeError("val must be string, number or Buffer");
    }
    function At(Ot, ft, Dt, Mt, Ft) {
      var Gt, zt = 1, $t = Ot.length, Ht = ft.length;
      if (Mt !== void 0 && ((Mt = String(Mt).toLowerCase()) === "ucs2" || Mt === "ucs-2" || Mt === "utf16le" || Mt === "utf-16le")) {
        if (Ot.length < 2 || ft.length < 2) return -1;
        zt = 2, $t /= 2, Ht /= 2, Dt /= 2;
      }
      function hn(En, Jt) {
        return zt === 1 ? En[Jt] : En.readUInt16BE(Jt * zt);
      }
      if (Ft) {
        var un = -1;
        for (Gt = Dt; Gt < $t; Gt++) if (hn(Ot, Gt) === hn(ft, un === -1 ? 0 : Gt - un)) {
          if (un === -1 && (un = Gt), Gt - un + 1 === Ht) return un * zt;
        } else un !== -1 && (Gt -= Gt - un), un = -1;
      } else for (Dt + Ht > $t && (Dt = $t - Ht), Gt = Dt; Gt >= 0; Gt--) {
        for (var An = !0, mn = 0; mn < Ht; mn++) if (hn(Ot, Gt + mn) !== hn(ft, mn)) {
          An = !1;
          break;
        }
        if (An) return Gt;
      }
      return -1;
    }
    function pt(Ot, ft, Dt, Mt) {
      Dt = Number(Dt) || 0;
      var Ft = Ot.length - Dt;
      Mt ? (Mt = Number(Mt)) > Ft && (Mt = Ft) : Mt = Ft;
      var Gt = ft.length;
      if (Gt % 2 != 0) throw new TypeError("Invalid hex string");
      Mt > Gt / 2 && (Mt = Gt / 2);
      for (var zt = 0; zt < Mt; ++zt) {
        var $t = parseInt(ft.substr(2 * zt, 2), 16);
        if (isNaN($t)) return zt;
        Ot[Dt + zt] = $t;
      }
      return zt;
    }
    function gt(Ot, ft, Dt, Mt) {
      return Lt(Xt(ft, Ot.length - Dt), Ot, Dt, Mt);
    }
    function wt(Ot, ft, Dt, Mt) {
      return Lt(function(Ft) {
        for (var Gt = [], zt = 0; zt < Ft.length; ++zt) Gt.push(255 & Ft.charCodeAt(zt));
        return Gt;
      }(ft), Ot, Dt, Mt);
    }
    function Bt(Ot, ft, Dt, Mt) {
      return wt(Ot, ft, Dt, Mt);
    }
    function Tt(Ot, ft, Dt, Mt) {
      return Lt(Ut(ft), Ot, Dt, Mt);
    }
    function yt(Ot, ft, Dt, Mt) {
      return Lt(function(Ft, Gt) {
        for (var zt, $t, Ht, hn = [], un = 0; un < Ft.length && !((Gt -= 2) < 0); ++un) $t = (zt = Ft.charCodeAt(un)) >> 8, Ht = zt % 256, hn.push(Ht), hn.push($t);
        return hn;
      }(ft, Ot.length - Dt), Ot, Dt, Mt);
    }
    function Ct(Ot, ft, Dt) {
      return ft === 0 && Dt === Ot.length ? Ke.fromByteArray(Ot) : Ke.fromByteArray(Ot.slice(ft, Dt));
    }
    function ht(Ot, ft, Dt) {
      Dt = Math.min(Ot.length, Dt);
      for (var Mt = [], Ft = ft; Ft < Dt; ) {
        var Gt, zt, $t, Ht, hn = Ot[Ft], un = null, An = hn > 239 ? 4 : hn > 223 ? 3 : hn > 191 ? 2 : 1;
        if (Ft + An <= Dt) switch (An) {
          case 1:
            hn < 128 && (un = hn);
            break;
          case 2:
            (192 & (Gt = Ot[Ft + 1])) == 128 && (Ht = (31 & hn) << 6 | 63 & Gt) > 127 && (un = Ht);
            break;
          case 3:
            Gt = Ot[Ft + 1], zt = Ot[Ft + 2], (192 & Gt) == 128 && (192 & zt) == 128 && (Ht = (15 & hn) << 12 | (63 & Gt) << 6 | 63 & zt) > 2047 && (Ht < 55296 || Ht > 57343) && (un = Ht);
            break;
          case 4:
            Gt = Ot[Ft + 1], zt = Ot[Ft + 2], $t = Ot[Ft + 3], (192 & Gt) == 128 && (192 & zt) == 128 && (192 & $t) == 128 && (Ht = (15 & hn) << 18 | (63 & Gt) << 12 | (63 & zt) << 6 | 63 & $t) > 65535 && Ht < 1114112 && (un = Ht);
        }
        un === null ? (un = 65533, An = 1) : un > 65535 && (un -= 65536, Mt.push(un >>> 10 & 1023 | 55296), un = 56320 | 1023 & un), Mt.push(un), Ft += An;
      }
      return function(mn) {
        var En = mn.length;
        if (En <= It) return String.fromCharCode.apply(String, mn);
        for (var Jt = "", an = 0; an < En; ) Jt += String.fromCharCode.apply(String, mn.slice(an, an += It));
        return Jt;
      }(Mt);
    }
    Ge.Buffer = tt, Ge.SlowBuffer = function(Ot) {
      return +Ot != Ot && (Ot = 0), tt.alloc(+Ot);
    }, Ge.INSPECT_MAX_BYTES = 50, tt.TYPED_ARRAY_SUPPORT = Xe.g.TYPED_ARRAY_SUPPORT !== void 0 ? Xe.g.TYPED_ARRAY_SUPPORT : function() {
      try {
        var Ot = new Uint8Array(1);
        return Ot.__proto__ = { __proto__: Uint8Array.prototype, foo: function() {
          return 42;
        } }, Ot.foo() === 42 && typeof Ot.subarray == "function" && Ot.subarray(1, 1).byteLength === 0;
      } catch {
        return !1;
      }
    }(), Ge.kMaxLength = Ze(), tt.poolSize = 8192, tt._augment = function(Ot) {
      return Ot.__proto__ = tt.prototype, Ot;
    }, tt.from = function(Ot, ft, Dt) {
      return et(null, Ot, ft, Dt);
    }, tt.TYPED_ARRAY_SUPPORT && (tt.prototype.__proto__ = Uint8Array.prototype, tt.__proto__ = Uint8Array, typeof Symbol < "u" && Symbol.species && tt[Symbol.species] === tt && Object.defineProperty(tt, Symbol.species, { value: null, configurable: !0 })), tt.alloc = function(Ot, ft, Dt) {
      return function(Mt, Ft, Gt, zt) {
        return rt(Ft), Ft <= 0 ? nt(Mt, Ft) : Gt !== void 0 ? typeof zt == "string" ? nt(Mt, Ft).fill(Gt, zt) : nt(Mt, Ft).fill(Gt) : nt(Mt, Ft);
      }(null, Ot, ft, Dt);
    }, tt.allocUnsafe = function(Ot) {
      return it(null, Ot);
    }, tt.allocUnsafeSlow = function(Ot) {
      return it(null, Ot);
    }, tt.isBuffer = function(Ot) {
      return !(Ot == null || !Ot._isBuffer);
    }, tt.compare = function(Ot, ft) {
      if (!tt.isBuffer(Ot) || !tt.isBuffer(ft)) throw new TypeError("Arguments must be Buffers");
      if (Ot === ft) return 0;
      for (var Dt = Ot.length, Mt = ft.length, Ft = 0, Gt = Math.min(Dt, Mt); Ft < Gt; ++Ft) if (Ot[Ft] !== ft[Ft]) {
        Dt = Ot[Ft], Mt = ft[Ft];
        break;
      }
      return Dt < Mt ? -1 : Mt < Dt ? 1 : 0;
    }, tt.isEncoding = function(Ot) {
      switch (String(Ot).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return !0;
        default:
          return !1;
      }
    }, tt.concat = function(Ot, ft) {
      if (!Je(Ot)) throw new TypeError('"list" argument must be an Array of Buffers');
      if (Ot.length === 0) return tt.alloc(0);
      var Dt;
      if (ft === void 0) for (ft = 0, Dt = 0; Dt < Ot.length; ++Dt) ft += Ot[Dt].length;
      var Mt = tt.allocUnsafe(ft), Ft = 0;
      for (Dt = 0; Dt < Ot.length; ++Dt) {
        var Gt = Ot[Dt];
        if (!tt.isBuffer(Gt)) throw new TypeError('"list" argument must be an Array of Buffers');
        Gt.copy(Mt, Ft), Ft += Gt.length;
      }
      return Mt;
    }, tt.byteLength = st, tt.prototype._isBuffer = !0, tt.prototype.swap16 = function() {
      var Ot = this.length;
      if (Ot % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
      for (var ft = 0; ft < Ot; ft += 2) lt(this, ft, ft + 1);
      return this;
    }, tt.prototype.swap32 = function() {
      var Ot = this.length;
      if (Ot % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
      for (var ft = 0; ft < Ot; ft += 4) lt(this, ft, ft + 3), lt(this, ft + 1, ft + 2);
      return this;
    }, tt.prototype.swap64 = function() {
      var Ot = this.length;
      if (Ot % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
      for (var ft = 0; ft < Ot; ft += 8) lt(this, ft, ft + 7), lt(this, ft + 1, ft + 6), lt(this, ft + 2, ft + 5), lt(this, ft + 3, ft + 4);
      return this;
    }, tt.prototype.toString = function() {
      var Ot = 0 | this.length;
      return Ot === 0 ? "" : arguments.length === 0 ? ht(this, 0, Ot) : ut.apply(this, arguments);
    }, tt.prototype.equals = function(Ot) {
      if (!tt.isBuffer(Ot)) throw new TypeError("Argument must be a Buffer");
      return this === Ot || tt.compare(this, Ot) === 0;
    }, tt.prototype.inspect = function() {
      var Ot = "", ft = Ge.INSPECT_MAX_BYTES;
      return this.length > 0 && (Ot = this.toString("hex", 0, ft).match(/.{2}/g).join(" "), this.length > ft && (Ot += " ... ")), "<Buffer " + Ot + ">";
    }, tt.prototype.compare = function(Ot, ft, Dt, Mt, Ft) {
      if (!tt.isBuffer(Ot)) throw new TypeError("Argument must be a Buffer");
      if (ft === void 0 && (ft = 0), Dt === void 0 && (Dt = Ot ? Ot.length : 0), Mt === void 0 && (Mt = 0), Ft === void 0 && (Ft = this.length), ft < 0 || Dt > Ot.length || Mt < 0 || Ft > this.length) throw new RangeError("out of range index");
      if (Mt >= Ft && ft >= Dt) return 0;
      if (Mt >= Ft) return -1;
      if (ft >= Dt) return 1;
      if (this === Ot) return 0;
      for (var Gt = (Ft >>>= 0) - (Mt >>>= 0), zt = (Dt >>>= 0) - (ft >>>= 0), $t = Math.min(Gt, zt), Ht = this.slice(Mt, Ft), hn = Ot.slice(ft, Dt), un = 0; un < $t; ++un) if (Ht[un] !== hn[un]) {
        Gt = Ht[un], zt = hn[un];
        break;
      }
      return Gt < zt ? -1 : zt < Gt ? 1 : 0;
    }, tt.prototype.includes = function(Ot, ft, Dt) {
      return this.indexOf(Ot, ft, Dt) !== -1;
    }, tt.prototype.indexOf = function(Ot, ft, Dt) {
      return dt(this, Ot, ft, Dt, !0);
    }, tt.prototype.lastIndexOf = function(Ot, ft, Dt) {
      return dt(this, Ot, ft, Dt, !1);
    }, tt.prototype.write = function(Ot, ft, Dt, Mt) {
      if (ft === void 0) Mt = "utf8", Dt = this.length, ft = 0;
      else if (Dt === void 0 && typeof ft == "string") Mt = ft, Dt = this.length, ft = 0;
      else {
        if (!isFinite(ft)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
        ft |= 0, isFinite(Dt) ? (Dt |= 0, Mt === void 0 && (Mt = "utf8")) : (Mt = Dt, Dt = void 0);
      }
      var Ft = this.length - ft;
      if ((Dt === void 0 || Dt > Ft) && (Dt = Ft), Ot.length > 0 && (Dt < 0 || ft < 0) || ft > this.length) throw new RangeError("Attempt to write outside buffer bounds");
      Mt || (Mt = "utf8");
      for (var Gt = !1; ; ) switch (Mt) {
        case "hex":
          return pt(this, Ot, ft, Dt);
        case "utf8":
        case "utf-8":
          return gt(this, Ot, ft, Dt);
        case "ascii":
          return wt(this, Ot, ft, Dt);
        case "latin1":
        case "binary":
          return Bt(this, Ot, ft, Dt);
        case "base64":
          return Tt(this, Ot, ft, Dt);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return yt(this, Ot, ft, Dt);
        default:
          if (Gt) throw new TypeError("Unknown encoding: " + Mt);
          Mt = ("" + Mt).toLowerCase(), Gt = !0;
      }
    }, tt.prototype.toJSON = function() {
      return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
    };
    var It = 4096;
    function vt(Ot, ft, Dt) {
      var Mt = "";
      Dt = Math.min(Ot.length, Dt);
      for (var Ft = ft; Ft < Dt; ++Ft) Mt += String.fromCharCode(127 & Ot[Ft]);
      return Mt;
    }
    function Et(Ot, ft, Dt) {
      var Mt = "";
      Dt = Math.min(Ot.length, Dt);
      for (var Ft = ft; Ft < Dt; ++Ft) Mt += String.fromCharCode(Ot[Ft]);
      return Mt;
    }
    function bt(Ot, ft, Dt) {
      var Mt, Ft = Ot.length;
      (!ft || ft < 0) && (ft = 0), (!Dt || Dt < 0 || Dt > Ft) && (Dt = Ft);
      for (var Gt = "", zt = ft; zt < Dt; ++zt) Gt += (Mt = Ot[zt]) < 16 ? "0" + Mt.toString(16) : Mt.toString(16);
      return Gt;
    }
    function Rt(Ot, ft, Dt) {
      for (var Mt = Ot.slice(ft, Dt), Ft = "", Gt = 0; Gt < Mt.length; Gt += 2) Ft += String.fromCharCode(Mt[Gt] + 256 * Mt[Gt + 1]);
      return Ft;
    }
    function St(Ot, ft, Dt) {
      if (Ot % 1 != 0 || Ot < 0) throw new RangeError("offset is not uint");
      if (Ot + ft > Dt) throw new RangeError("Trying to access beyond buffer length");
    }
    function kt(Ot, ft, Dt, Mt, Ft, Gt) {
      if (!tt.isBuffer(Ot)) throw new TypeError('"buffer" argument must be a Buffer instance');
      if (ft > Ft || ft < Gt) throw new RangeError('"value" argument is out of bounds');
      if (Dt + Mt > Ot.length) throw new RangeError("Index out of range");
    }
    function jt(Ot, ft, Dt, Mt) {
      ft < 0 && (ft = 65535 + ft + 1);
      for (var Ft = 0, Gt = Math.min(Ot.length - Dt, 2); Ft < Gt; ++Ft) Ot[Dt + Ft] = (ft & 255 << 8 * (Mt ? Ft : 1 - Ft)) >>> 8 * (Mt ? Ft : 1 - Ft);
    }
    function Pt(Ot, ft, Dt, Mt) {
      ft < 0 && (ft = 4294967295 + ft + 1);
      for (var Ft = 0, Gt = Math.min(Ot.length - Dt, 4); Ft < Gt; ++Ft) Ot[Dt + Ft] = ft >>> 8 * (Mt ? Ft : 3 - Ft) & 255;
    }
    function Qt(Ot, ft, Dt, Mt, Ft, Gt) {
      if (Dt + Mt > Ot.length) throw new RangeError("Index out of range");
      if (Dt < 0) throw new RangeError("Index out of range");
    }
    function qt(Ot, ft, Dt, Mt, Ft) {
      return Ft || Qt(Ot, 0, Dt, 4), $e.write(Ot, ft, Dt, Mt, 23, 4), Dt + 4;
    }
    function _t(Ot, ft, Dt, Mt, Ft) {
      return Ft || Qt(Ot, 0, Dt, 8), $e.write(Ot, ft, Dt, Mt, 52, 8), Dt + 8;
    }
    tt.prototype.slice = function(Ot, ft) {
      var Dt, Mt = this.length;
      if ((Ot = ~~Ot) < 0 ? (Ot += Mt) < 0 && (Ot = 0) : Ot > Mt && (Ot = Mt), (ft = ft === void 0 ? Mt : ~~ft) < 0 ? (ft += Mt) < 0 && (ft = 0) : ft > Mt && (ft = Mt), ft < Ot && (ft = Ot), tt.TYPED_ARRAY_SUPPORT) (Dt = this.subarray(Ot, ft)).__proto__ = tt.prototype;
      else {
        var Ft = ft - Ot;
        Dt = new tt(Ft, void 0);
        for (var Gt = 0; Gt < Ft; ++Gt) Dt[Gt] = this[Gt + Ot];
      }
      return Dt;
    }, tt.prototype.readUIntLE = function(Ot, ft, Dt) {
      Ot |= 0, ft |= 0, Dt || St(Ot, ft, this.length);
      for (var Mt = this[Ot], Ft = 1, Gt = 0; ++Gt < ft && (Ft *= 256); ) Mt += this[Ot + Gt] * Ft;
      return Mt;
    }, tt.prototype.readUIntBE = function(Ot, ft, Dt) {
      Ot |= 0, ft |= 0, Dt || St(Ot, ft, this.length);
      for (var Mt = this[Ot + --ft], Ft = 1; ft > 0 && (Ft *= 256); ) Mt += this[Ot + --ft] * Ft;
      return Mt;
    }, tt.prototype.readUInt8 = function(Ot, ft) {
      return ft || St(Ot, 1, this.length), this[Ot];
    }, tt.prototype.readUInt16LE = function(Ot, ft) {
      return ft || St(Ot, 2, this.length), this[Ot] | this[Ot + 1] << 8;
    }, tt.prototype.readUInt16BE = function(Ot, ft) {
      return ft || St(Ot, 2, this.length), this[Ot] << 8 | this[Ot + 1];
    }, tt.prototype.readUInt32LE = function(Ot, ft) {
      return ft || St(Ot, 4, this.length), (this[Ot] | this[Ot + 1] << 8 | this[Ot + 2] << 16) + 16777216 * this[Ot + 3];
    }, tt.prototype.readUInt32BE = function(Ot, ft) {
      return ft || St(Ot, 4, this.length), 16777216 * this[Ot] + (this[Ot + 1] << 16 | this[Ot + 2] << 8 | this[Ot + 3]);
    }, tt.prototype.readIntLE = function(Ot, ft, Dt) {
      Ot |= 0, ft |= 0, Dt || St(Ot, ft, this.length);
      for (var Mt = this[Ot], Ft = 1, Gt = 0; ++Gt < ft && (Ft *= 256); ) Mt += this[Ot + Gt] * Ft;
      return Mt >= (Ft *= 128) && (Mt -= Math.pow(2, 8 * ft)), Mt;
    }, tt.prototype.readIntBE = function(Ot, ft, Dt) {
      Ot |= 0, ft |= 0, Dt || St(Ot, ft, this.length);
      for (var Mt = ft, Ft = 1, Gt = this[Ot + --Mt]; Mt > 0 && (Ft *= 256); ) Gt += this[Ot + --Mt] * Ft;
      return Gt >= (Ft *= 128) && (Gt -= Math.pow(2, 8 * ft)), Gt;
    }, tt.prototype.readInt8 = function(Ot, ft) {
      return ft || St(Ot, 1, this.length), 128 & this[Ot] ? -1 * (255 - this[Ot] + 1) : this[Ot];
    }, tt.prototype.readInt16LE = function(Ot, ft) {
      ft || St(Ot, 2, this.length);
      var Dt = this[Ot] | this[Ot + 1] << 8;
      return 32768 & Dt ? 4294901760 | Dt : Dt;
    }, tt.prototype.readInt16BE = function(Ot, ft) {
      ft || St(Ot, 2, this.length);
      var Dt = this[Ot + 1] | this[Ot] << 8;
      return 32768 & Dt ? 4294901760 | Dt : Dt;
    }, tt.prototype.readInt32LE = function(Ot, ft) {
      return ft || St(Ot, 4, this.length), this[Ot] | this[Ot + 1] << 8 | this[Ot + 2] << 16 | this[Ot + 3] << 24;
    }, tt.prototype.readInt32BE = function(Ot, ft) {
      return ft || St(Ot, 4, this.length), this[Ot] << 24 | this[Ot + 1] << 16 | this[Ot + 2] << 8 | this[Ot + 3];
    }, tt.prototype.readFloatLE = function(Ot, ft) {
      return ft || St(Ot, 4, this.length), $e.read(this, Ot, !0, 23, 4);
    }, tt.prototype.readFloatBE = function(Ot, ft) {
      return ft || St(Ot, 4, this.length), $e.read(this, Ot, !1, 23, 4);
    }, tt.prototype.readDoubleLE = function(Ot, ft) {
      return ft || St(Ot, 8, this.length), $e.read(this, Ot, !0, 52, 8);
    }, tt.prototype.readDoubleBE = function(Ot, ft) {
      return ft || St(Ot, 8, this.length), $e.read(this, Ot, !1, 52, 8);
    }, tt.prototype.writeUIntLE = function(Ot, ft, Dt, Mt) {
      Ot = +Ot, ft |= 0, Dt |= 0, Mt || kt(this, Ot, ft, Dt, Math.pow(2, 8 * Dt) - 1, 0);
      var Ft = 1, Gt = 0;
      for (this[ft] = 255 & Ot; ++Gt < Dt && (Ft *= 256); ) this[ft + Gt] = Ot / Ft & 255;
      return ft + Dt;
    }, tt.prototype.writeUIntBE = function(Ot, ft, Dt, Mt) {
      Ot = +Ot, ft |= 0, Dt |= 0, Mt || kt(this, Ot, ft, Dt, Math.pow(2, 8 * Dt) - 1, 0);
      var Ft = Dt - 1, Gt = 1;
      for (this[ft + Ft] = 255 & Ot; --Ft >= 0 && (Gt *= 256); ) this[ft + Ft] = Ot / Gt & 255;
      return ft + Dt;
    }, tt.prototype.writeUInt8 = function(Ot, ft, Dt) {
      return Ot = +Ot, ft |= 0, Dt || kt(this, Ot, ft, 1, 255, 0), tt.TYPED_ARRAY_SUPPORT || (Ot = Math.floor(Ot)), this[ft] = 255 & Ot, ft + 1;
    }, tt.prototype.writeUInt16LE = function(Ot, ft, Dt) {
      return Ot = +Ot, ft |= 0, Dt || kt(this, Ot, ft, 2, 65535, 0), tt.TYPED_ARRAY_SUPPORT ? (this[ft] = 255 & Ot, this[ft + 1] = Ot >>> 8) : jt(this, Ot, ft, !0), ft + 2;
    }, tt.prototype.writeUInt16BE = function(Ot, ft, Dt) {
      return Ot = +Ot, ft |= 0, Dt || kt(this, Ot, ft, 2, 65535, 0), tt.TYPED_ARRAY_SUPPORT ? (this[ft] = Ot >>> 8, this[ft + 1] = 255 & Ot) : jt(this, Ot, ft, !1), ft + 2;
    }, tt.prototype.writeUInt32LE = function(Ot, ft, Dt) {
      return Ot = +Ot, ft |= 0, Dt || kt(this, Ot, ft, 4, 4294967295, 0), tt.TYPED_ARRAY_SUPPORT ? (this[ft + 3] = Ot >>> 24, this[ft + 2] = Ot >>> 16, this[ft + 1] = Ot >>> 8, this[ft] = 255 & Ot) : Pt(this, Ot, ft, !0), ft + 4;
    }, tt.prototype.writeUInt32BE = function(Ot, ft, Dt) {
      return Ot = +Ot, ft |= 0, Dt || kt(this, Ot, ft, 4, 4294967295, 0), tt.TYPED_ARRAY_SUPPORT ? (this[ft] = Ot >>> 24, this[ft + 1] = Ot >>> 16, this[ft + 2] = Ot >>> 8, this[ft + 3] = 255 & Ot) : Pt(this, Ot, ft, !1), ft + 4;
    }, tt.prototype.writeIntLE = function(Ot, ft, Dt, Mt) {
      if (Ot = +Ot, ft |= 0, !Mt) {
        var Ft = Math.pow(2, 8 * Dt - 1);
        kt(this, Ot, ft, Dt, Ft - 1, -Ft);
      }
      var Gt = 0, zt = 1, $t = 0;
      for (this[ft] = 255 & Ot; ++Gt < Dt && (zt *= 256); ) Ot < 0 && $t === 0 && this[ft + Gt - 1] !== 0 && ($t = 1), this[ft + Gt] = (Ot / zt >> 0) - $t & 255;
      return ft + Dt;
    }, tt.prototype.writeIntBE = function(Ot, ft, Dt, Mt) {
      if (Ot = +Ot, ft |= 0, !Mt) {
        var Ft = Math.pow(2, 8 * Dt - 1);
        kt(this, Ot, ft, Dt, Ft - 1, -Ft);
      }
      var Gt = Dt - 1, zt = 1, $t = 0;
      for (this[ft + Gt] = 255 & Ot; --Gt >= 0 && (zt *= 256); ) Ot < 0 && $t === 0 && this[ft + Gt + 1] !== 0 && ($t = 1), this[ft + Gt] = (Ot / zt >> 0) - $t & 255;
      return ft + Dt;
    }, tt.prototype.writeInt8 = function(Ot, ft, Dt) {
      return Ot = +Ot, ft |= 0, Dt || kt(this, Ot, ft, 1, 127, -128), tt.TYPED_ARRAY_SUPPORT || (Ot = Math.floor(Ot)), Ot < 0 && (Ot = 255 + Ot + 1), this[ft] = 255 & Ot, ft + 1;
    }, tt.prototype.writeInt16LE = function(Ot, ft, Dt) {
      return Ot = +Ot, ft |= 0, Dt || kt(this, Ot, ft, 2, 32767, -32768), tt.TYPED_ARRAY_SUPPORT ? (this[ft] = 255 & Ot, this[ft + 1] = Ot >>> 8) : jt(this, Ot, ft, !0), ft + 2;
    }, tt.prototype.writeInt16BE = function(Ot, ft, Dt) {
      return Ot = +Ot, ft |= 0, Dt || kt(this, Ot, ft, 2, 32767, -32768), tt.TYPED_ARRAY_SUPPORT ? (this[ft] = Ot >>> 8, this[ft + 1] = 255 & Ot) : jt(this, Ot, ft, !1), ft + 2;
    }, tt.prototype.writeInt32LE = function(Ot, ft, Dt) {
      return Ot = +Ot, ft |= 0, Dt || kt(this, Ot, ft, 4, 2147483647, -2147483648), tt.TYPED_ARRAY_SUPPORT ? (this[ft] = 255 & Ot, this[ft + 1] = Ot >>> 8, this[ft + 2] = Ot >>> 16, this[ft + 3] = Ot >>> 24) : Pt(this, Ot, ft, !0), ft + 4;
    }, tt.prototype.writeInt32BE = function(Ot, ft, Dt) {
      return Ot = +Ot, ft |= 0, Dt || kt(this, Ot, ft, 4, 2147483647, -2147483648), Ot < 0 && (Ot = 4294967295 + Ot + 1), tt.TYPED_ARRAY_SUPPORT ? (this[ft] = Ot >>> 24, this[ft + 1] = Ot >>> 16, this[ft + 2] = Ot >>> 8, this[ft + 3] = 255 & Ot) : Pt(this, Ot, ft, !1), ft + 4;
    }, tt.prototype.writeFloatLE = function(Ot, ft, Dt) {
      return qt(this, Ot, ft, !0, Dt);
    }, tt.prototype.writeFloatBE = function(Ot, ft, Dt) {
      return qt(this, Ot, ft, !1, Dt);
    }, tt.prototype.writeDoubleLE = function(Ot, ft, Dt) {
      return _t(this, Ot, ft, !0, Dt);
    }, tt.prototype.writeDoubleBE = function(Ot, ft, Dt) {
      return _t(this, Ot, ft, !1, Dt);
    }, tt.prototype.copy = function(Ot, ft, Dt, Mt) {
      if (Dt || (Dt = 0), Mt || Mt === 0 || (Mt = this.length), ft >= Ot.length && (ft = Ot.length), ft || (ft = 0), Mt > 0 && Mt < Dt && (Mt = Dt), Mt === Dt || Ot.length === 0 || this.length === 0) return 0;
      if (ft < 0) throw new RangeError("targetStart out of bounds");
      if (Dt < 0 || Dt >= this.length) throw new RangeError("sourceStart out of bounds");
      if (Mt < 0) throw new RangeError("sourceEnd out of bounds");
      Mt > this.length && (Mt = this.length), Ot.length - ft < Mt - Dt && (Mt = Ot.length - ft + Dt);
      var Ft, Gt = Mt - Dt;
      if (this === Ot && Dt < ft && ft < Mt) for (Ft = Gt - 1; Ft >= 0; --Ft) Ot[Ft + ft] = this[Ft + Dt];
      else if (Gt < 1e3 || !tt.TYPED_ARRAY_SUPPORT) for (Ft = 0; Ft < Gt; ++Ft) Ot[Ft + ft] = this[Ft + Dt];
      else Uint8Array.prototype.set.call(Ot, this.subarray(Dt, Dt + Gt), ft);
      return Gt;
    }, tt.prototype.fill = function(Ot, ft, Dt, Mt) {
      if (typeof Ot == "string") {
        if (typeof ft == "string" ? (Mt = ft, ft = 0, Dt = this.length) : typeof Dt == "string" && (Mt = Dt, Dt = this.length), Ot.length === 1) {
          var Ft = Ot.charCodeAt(0);
          Ft < 256 && (Ot = Ft);
        }
        if (Mt !== void 0 && typeof Mt != "string") throw new TypeError("encoding must be a string");
        if (typeof Mt == "string" && !tt.isEncoding(Mt)) throw new TypeError("Unknown encoding: " + Mt);
      } else typeof Ot == "number" && (Ot &= 255);
      if (ft < 0 || this.length < ft || this.length < Dt) throw new RangeError("Out of range index");
      if (Dt <= ft) return this;
      var Gt;
      if (ft >>>= 0, Dt = Dt === void 0 ? this.length : Dt >>> 0, Ot || (Ot = 0), typeof Ot == "number") for (Gt = ft; Gt < Dt; ++Gt) this[Gt] = Ot;
      else {
        var zt = tt.isBuffer(Ot) ? Ot : Xt(new tt(Ot, Mt).toString()), $t = zt.length;
        for (Gt = 0; Gt < Dt - ft; ++Gt) this[Gt + ft] = zt[Gt % $t];
      }
      return this;
    };
    var Yt = /[^+\/0-9A-Za-z-_]/g;
    function Xt(Ot, ft) {
      var Dt;
      ft = ft || 1 / 0;
      for (var Mt = Ot.length, Ft = null, Gt = [], zt = 0; zt < Mt; ++zt) {
        if ((Dt = Ot.charCodeAt(zt)) > 55295 && Dt < 57344) {
          if (!Ft) {
            if (Dt > 56319) {
              (ft -= 3) > -1 && Gt.push(239, 191, 189);
              continue;
            }
            if (zt + 1 === Mt) {
              (ft -= 3) > -1 && Gt.push(239, 191, 189);
              continue;
            }
            Ft = Dt;
            continue;
          }
          if (Dt < 56320) {
            (ft -= 3) > -1 && Gt.push(239, 191, 189), Ft = Dt;
            continue;
          }
          Dt = 65536 + (Ft - 55296 << 10 | Dt - 56320);
        } else Ft && (ft -= 3) > -1 && Gt.push(239, 191, 189);
        if (Ft = null, Dt < 128) {
          if ((ft -= 1) < 0) break;
          Gt.push(Dt);
        } else if (Dt < 2048) {
          if ((ft -= 2) < 0) break;
          Gt.push(Dt >> 6 | 192, 63 & Dt | 128);
        } else if (Dt < 65536) {
          if ((ft -= 3) < 0) break;
          Gt.push(Dt >> 12 | 224, Dt >> 6 & 63 | 128, 63 & Dt | 128);
        } else {
          if (!(Dt < 1114112)) throw new Error("Invalid code point");
          if ((ft -= 4) < 0) break;
          Gt.push(Dt >> 18 | 240, Dt >> 12 & 63 | 128, Dt >> 6 & 63 | 128, 63 & Dt | 128);
        }
      }
      return Gt;
    }
    function Ut(Ot) {
      return Ke.toByteArray(function(ft) {
        if ((ft = function(Dt) {
          return Dt.trim ? Dt.trim() : Dt.replace(/^\s+|\s+$/g, "");
        }(ft).replace(Yt, "")).length < 2) return "";
        for (; ft.length % 4 != 0; ) ft += "=";
        return ft;
      }(Ot));
    }
    function Lt(Ot, ft, Dt, Mt) {
      for (var Ft = 0; Ft < Mt && !(Ft + Dt >= ft.length || Ft >= Ot.length); ++Ft) ft[Ft + Dt] = Ot[Ft];
      return Ft;
    }
  }, 3973: (He, Ge, Xe) => {
    var Ke = Xe(7834).Buffer, $e = Xe(4851).Transform, Je = Xe(214).s;
    function Ze(nt) {
      $e.call(this), this.hashMode = typeof nt == "string", this.hashMode ? this[nt] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
    }
    Xe(1285)(Ze, $e), Ze.prototype.update = function(nt, tt, et) {
      typeof nt == "string" && (nt = Ke.from(nt, tt));
      var rt = this._update(nt);
      return this.hashMode ? this : (et && (rt = this._toString(rt, et)), rt);
    }, Ze.prototype.setAutoPadding = function() {
    }, Ze.prototype.getAuthTag = function() {
      throw new Error("trying to get auth tag in unsupported state");
    }, Ze.prototype.setAuthTag = function() {
      throw new Error("trying to set auth tag in unsupported state");
    }, Ze.prototype.setAAD = function() {
      throw new Error("trying to set aad in unsupported state");
    }, Ze.prototype._transform = function(nt, tt, et) {
      var rt;
      try {
        this.hashMode ? this._update(nt) : this.push(this._update(nt));
      } catch (it) {
        rt = it;
      } finally {
        et(rt);
      }
    }, Ze.prototype._flush = function(nt) {
      var tt;
      try {
        this.push(this.__final());
      } catch (et) {
        tt = et;
      }
      nt(tt);
    }, Ze.prototype._finalOrDigest = function(nt) {
      var tt = this.__final() || Ke.alloc(0);
      return nt && (tt = this._toString(tt, nt, !0)), tt;
    }, Ze.prototype._toString = function(nt, tt, et) {
      if (this._decoder || (this._decoder = new Je(tt), this._encoding = tt), this._encoding !== tt) throw new Error("can't switch encodings");
      var rt = this._decoder.write(nt);
      return et && (rt += this._decoder.end()), rt;
    }, He.exports = Ze;
  }, 2511: (He, Ge, Xe) => {
    var Ke = Xe(7993);
    He.exports = function($e) {
      return new Ke().update($e).digest();
    };
  }, 11: (He, Ge, Xe) => {
    var Ke = Xe(1285), $e = Xe(6456), Je = Xe(3973), Ze = Xe(7834).Buffer, nt = Xe(2511), tt = Xe(1445), et = Xe(9065), rt = Ze.alloc(128);
    function it(ot, at) {
      Je.call(this, "digest"), typeof at == "string" && (at = Ze.from(at));
      var st = ot === "sha512" || ot === "sha384" ? 128 : 64;
      this._alg = ot, this._key = at, at.length > st ? at = (ot === "rmd160" ? new tt() : et(ot)).update(at).digest() : at.length < st && (at = Ze.concat([at, rt], st));
      for (var ut = this._ipad = Ze.allocUnsafe(st), lt = this._opad = Ze.allocUnsafe(st), dt = 0; dt < st; dt++) ut[dt] = 54 ^ at[dt], lt[dt] = 92 ^ at[dt];
      this._hash = ot === "rmd160" ? new tt() : et(ot), this._hash.update(ut);
    }
    Ke(it, Je), it.prototype._update = function(ot) {
      this._hash.update(ot);
    }, it.prototype._final = function() {
      var ot = this._hash.digest();
      return (this._alg === "rmd160" ? new tt() : et(this._alg)).update(this._opad).update(ot).digest();
    }, He.exports = function(ot, at) {
      return (ot = ot.toLowerCase()) === "rmd160" || ot === "ripemd160" ? new it("rmd160", at) : ot === "md5" ? new $e(nt, at) : new it(ot, at);
    };
  }, 6456: (He, Ge, Xe) => {
    var Ke = Xe(1285), $e = Xe(7834).Buffer, Je = Xe(3973), Ze = $e.alloc(128), nt = 64;
    function tt(et, rt) {
      Je.call(this, "digest"), typeof rt == "string" && (rt = $e.from(rt)), this._alg = et, this._key = rt, rt.length > nt ? rt = et(rt) : rt.length < nt && (rt = $e.concat([rt, Ze], nt));
      for (var it = this._ipad = $e.allocUnsafe(nt), ot = this._opad = $e.allocUnsafe(nt), at = 0; at < nt; at++) it[at] = 54 ^ rt[at], ot[at] = 92 ^ rt[at];
      this._hash = [it];
    }
    Ke(tt, Je), tt.prototype._update = function(et) {
      this._hash.push(et);
    }, tt.prototype._final = function() {
      var et = this._alg($e.concat(this._hash));
      return this._alg($e.concat([this._opad, et]));
    }, He.exports = tt;
  }, 2699: (He) => {
    var Ge, Xe = typeof Reflect == "object" ? Reflect : null, Ke = Xe && typeof Xe.apply == "function" ? Xe.apply : function(lt, dt, At) {
      return Function.prototype.apply.call(lt, dt, At);
    };
    Ge = Xe && typeof Xe.ownKeys == "function" ? Xe.ownKeys : Object.getOwnPropertySymbols ? function(lt) {
      return Object.getOwnPropertyNames(lt).concat(Object.getOwnPropertySymbols(lt));
    } : function(lt) {
      return Object.getOwnPropertyNames(lt);
    };
    var $e = Number.isNaN || function(lt) {
      return lt != lt;
    };
    function Je() {
      Je.init.call(this);
    }
    He.exports = Je, He.exports.once = function(lt, dt) {
      return new Promise(function(At, pt) {
        function gt(Bt) {
          lt.removeListener(dt, wt), pt(Bt);
        }
        function wt() {
          typeof lt.removeListener == "function" && lt.removeListener("error", gt), At([].slice.call(arguments));
        }
        ut(lt, dt, wt, { once: !0 }), dt !== "error" && function(Bt, Tt, yt) {
          typeof Bt.on == "function" && ut(Bt, "error", Tt, { once: !0 });
        }(lt, gt);
      });
    }, Je.EventEmitter = Je, Je.prototype._events = void 0, Je.prototype._eventsCount = 0, Je.prototype._maxListeners = void 0;
    var Ze = 10;
    function nt(lt) {
      if (typeof lt != "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof lt);
    }
    function tt(lt) {
      return lt._maxListeners === void 0 ? Je.defaultMaxListeners : lt._maxListeners;
    }
    function et(lt, dt, At, pt) {
      var gt, wt, Bt, Tt;
      if (nt(At), (wt = lt._events) === void 0 ? (wt = lt._events = /* @__PURE__ */ Object.create(null), lt._eventsCount = 0) : (wt.newListener !== void 0 && (lt.emit("newListener", dt, At.listener ? At.listener : At), wt = lt._events), Bt = wt[dt]), Bt === void 0) Bt = wt[dt] = At, ++lt._eventsCount;
      else if (typeof Bt == "function" ? Bt = wt[dt] = pt ? [At, Bt] : [Bt, At] : pt ? Bt.unshift(At) : Bt.push(At), (gt = tt(lt)) > 0 && Bt.length > gt && !Bt.warned) {
        Bt.warned = !0;
        var yt = new Error("Possible EventEmitter memory leak detected. " + Bt.length + " " + String(dt) + " listeners added. Use emitter.setMaxListeners() to increase limit");
        yt.name = "MaxListenersExceededWarning", yt.emitter = lt, yt.type = dt, yt.count = Bt.length, Tt = yt, console && console.warn && console.warn(Tt);
      }
      return lt;
    }
    function rt() {
      if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
    }
    function it(lt, dt, At) {
      var pt = { fired: !1, wrapFn: void 0, target: lt, type: dt, listener: At }, gt = rt.bind(pt);
      return gt.listener = At, pt.wrapFn = gt, gt;
    }
    function ot(lt, dt, At) {
      var pt = lt._events;
      if (pt === void 0) return [];
      var gt = pt[dt];
      return gt === void 0 ? [] : typeof gt == "function" ? At ? [gt.listener || gt] : [gt] : At ? function(wt) {
        for (var Bt = new Array(wt.length), Tt = 0; Tt < Bt.length; ++Tt) Bt[Tt] = wt[Tt].listener || wt[Tt];
        return Bt;
      }(gt) : st(gt, gt.length);
    }
    function at(lt) {
      var dt = this._events;
      if (dt !== void 0) {
        var At = dt[lt];
        if (typeof At == "function") return 1;
        if (At !== void 0) return At.length;
      }
      return 0;
    }
    function st(lt, dt) {
      for (var At = new Array(dt), pt = 0; pt < dt; ++pt) At[pt] = lt[pt];
      return At;
    }
    function ut(lt, dt, At, pt) {
      if (typeof lt.on == "function") pt.once ? lt.once(dt, At) : lt.on(dt, At);
      else {
        if (typeof lt.addEventListener != "function") throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof lt);
        lt.addEventListener(dt, function gt(wt) {
          pt.once && lt.removeEventListener(dt, gt), At(wt);
        });
      }
    }
    Object.defineProperty(Je, "defaultMaxListeners", { enumerable: !0, get: function() {
      return Ze;
    }, set: function(lt) {
      if (typeof lt != "number" || lt < 0 || $e(lt)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + lt + ".");
      Ze = lt;
    } }), Je.init = function() {
      this._events !== void 0 && this._events !== Object.getPrototypeOf(this)._events || (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
    }, Je.prototype.setMaxListeners = function(lt) {
      if (typeof lt != "number" || lt < 0 || $e(lt)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + lt + ".");
      return this._maxListeners = lt, this;
    }, Je.prototype.getMaxListeners = function() {
      return tt(this);
    }, Je.prototype.emit = function(lt) {
      for (var dt = [], At = 1; At < arguments.length; At++) dt.push(arguments[At]);
      var pt = lt === "error", gt = this._events;
      if (gt !== void 0) pt = pt && gt.error === void 0;
      else if (!pt) return !1;
      if (pt) {
        var wt;
        if (dt.length > 0 && (wt = dt[0]), wt instanceof Error) throw wt;
        var Bt = new Error("Unhandled error." + (wt ? " (" + wt.message + ")" : ""));
        throw Bt.context = wt, Bt;
      }
      var Tt = gt[lt];
      if (Tt === void 0) return !1;
      if (typeof Tt == "function") Ke(Tt, this, dt);
      else {
        var yt = Tt.length, Ct = st(Tt, yt);
        for (At = 0; At < yt; ++At) Ke(Ct[At], this, dt);
      }
      return !0;
    }, Je.prototype.addListener = function(lt, dt) {
      return et(this, lt, dt, !1);
    }, Je.prototype.on = Je.prototype.addListener, Je.prototype.prependListener = function(lt, dt) {
      return et(this, lt, dt, !0);
    }, Je.prototype.once = function(lt, dt) {
      return nt(dt), this.on(lt, it(this, lt, dt)), this;
    }, Je.prototype.prependOnceListener = function(lt, dt) {
      return nt(dt), this.prependListener(lt, it(this, lt, dt)), this;
    }, Je.prototype.removeListener = function(lt, dt) {
      var At, pt, gt, wt, Bt;
      if (nt(dt), (pt = this._events) === void 0) return this;
      if ((At = pt[lt]) === void 0) return this;
      if (At === dt || At.listener === dt) --this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete pt[lt], pt.removeListener && this.emit("removeListener", lt, At.listener || dt));
      else if (typeof At != "function") {
        for (gt = -1, wt = At.length - 1; wt >= 0; wt--) if (At[wt] === dt || At[wt].listener === dt) {
          Bt = At[wt].listener, gt = wt;
          break;
        }
        if (gt < 0) return this;
        gt === 0 ? At.shift() : function(Tt, yt) {
          for (; yt + 1 < Tt.length; yt++) Tt[yt] = Tt[yt + 1];
          Tt.pop();
        }(At, gt), At.length === 1 && (pt[lt] = At[0]), pt.removeListener !== void 0 && this.emit("removeListener", lt, Bt || dt);
      }
      return this;
    }, Je.prototype.off = Je.prototype.removeListener, Je.prototype.removeAllListeners = function(lt) {
      var dt, At, pt;
      if ((At = this._events) === void 0) return this;
      if (At.removeListener === void 0) return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : At[lt] !== void 0 && (--this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete At[lt]), this;
      if (arguments.length === 0) {
        var gt, wt = Object.keys(At);
        for (pt = 0; pt < wt.length; ++pt) (gt = wt[pt]) !== "removeListener" && this.removeAllListeners(gt);
        return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
      }
      if (typeof (dt = At[lt]) == "function") this.removeListener(lt, dt);
      else if (dt !== void 0) for (pt = dt.length - 1; pt >= 0; pt--) this.removeListener(lt, dt[pt]);
      return this;
    }, Je.prototype.listeners = function(lt) {
      return ot(this, lt, !0);
    }, Je.prototype.rawListeners = function(lt) {
      return ot(this, lt, !1);
    }, Je.listenerCount = function(lt, dt) {
      return typeof lt.listenerCount == "function" ? lt.listenerCount(dt) : at.call(lt, dt);
    }, Je.prototype.listenerCount = at, Je.prototype.eventNames = function() {
      return this._eventsCount > 0 ? Ge(this._events) : [];
    };
  }, 4485: (He, Ge, Xe) => {
    var Ke = Xe(7834).Buffer, $e = Xe(7525).Transform;
    function Je(Ze) {
      $e.call(this), this._block = Ke.allocUnsafe(Ze), this._blockSize = Ze, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
    }
    Xe(1285)(Je, $e), Je.prototype._transform = function(Ze, nt, tt) {
      var et = null;
      try {
        this.update(Ze, nt);
      } catch (rt) {
        et = rt;
      }
      tt(et);
    }, Je.prototype._flush = function(Ze) {
      var nt = null;
      try {
        this.push(this.digest());
      } catch (tt) {
        nt = tt;
      }
      Ze(nt);
    }, Je.prototype.update = function(Ze, nt) {
      if (function(at, st) {
        if (!Ke.isBuffer(at) && typeof at != "string") throw new TypeError("Data must be a string or a buffer");
      }(Ze), this._finalized) throw new Error("Digest already called");
      Ke.isBuffer(Ze) || (Ze = Ke.from(Ze, nt));
      for (var tt = this._block, et = 0; this._blockOffset + Ze.length - et >= this._blockSize; ) {
        for (var rt = this._blockOffset; rt < this._blockSize; ) tt[rt++] = Ze[et++];
        this._update(), this._blockOffset = 0;
      }
      for (; et < Ze.length; ) tt[this._blockOffset++] = Ze[et++];
      for (var it = 0, ot = 8 * Ze.length; ot > 0; ++it) this._length[it] += ot, (ot = this._length[it] / 4294967296 | 0) > 0 && (this._length[it] -= 4294967296 * ot);
      return this;
    }, Je.prototype._update = function() {
      throw new Error("_update is not implemented");
    }, Je.prototype.digest = function(Ze) {
      if (this._finalized) throw new Error("Digest already called");
      this._finalized = !0;
      var nt = this._digest();
      Ze !== void 0 && (nt = nt.toString(Ze)), this._block.fill(0), this._blockOffset = 0;
      for (var tt = 0; tt < 4; ++tt) this._length[tt] = 0;
      return nt;
    }, Je.prototype._digest = function() {
      throw new Error("_digest is not implemented");
    }, He.exports = Je;
  }, 2333: (He, Ge) => {
    Ge.read = function(Xe, Ke, $e, Je, Ze) {
      var nt, tt, et = 8 * Ze - Je - 1, rt = (1 << et) - 1, it = rt >> 1, ot = -7, at = $e ? Ze - 1 : 0, st = $e ? -1 : 1, ut = Xe[Ke + at];
      for (at += st, nt = ut & (1 << -ot) - 1, ut >>= -ot, ot += et; ot > 0; nt = 256 * nt + Xe[Ke + at], at += st, ot -= 8) ;
      for (tt = nt & (1 << -ot) - 1, nt >>= -ot, ot += Je; ot > 0; tt = 256 * tt + Xe[Ke + at], at += st, ot -= 8) ;
      if (nt === 0) nt = 1 - it;
      else {
        if (nt === rt) return tt ? NaN : 1 / 0 * (ut ? -1 : 1);
        tt += Math.pow(2, Je), nt -= it;
      }
      return (ut ? -1 : 1) * tt * Math.pow(2, nt - Je);
    }, Ge.write = function(Xe, Ke, $e, Je, Ze, nt) {
      var tt, et, rt, it = 8 * nt - Ze - 1, ot = (1 << it) - 1, at = ot >> 1, st = Ze === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, ut = Je ? 0 : nt - 1, lt = Je ? 1 : -1, dt = Ke < 0 || Ke === 0 && 1 / Ke < 0 ? 1 : 0;
      for (Ke = Math.abs(Ke), isNaN(Ke) || Ke === 1 / 0 ? (et = isNaN(Ke) ? 1 : 0, tt = ot) : (tt = Math.floor(Math.log(Ke) / Math.LN2), Ke * (rt = Math.pow(2, -tt)) < 1 && (tt--, rt *= 2), (Ke += tt + at >= 1 ? st / rt : st * Math.pow(2, 1 - at)) * rt >= 2 && (tt++, rt /= 2), tt + at >= ot ? (et = 0, tt = ot) : tt + at >= 1 ? (et = (Ke * rt - 1) * Math.pow(2, Ze), tt += at) : (et = Ke * Math.pow(2, at - 1) * Math.pow(2, Ze), tt = 0)); Ze >= 8; Xe[$e + ut] = 255 & et, ut += lt, et /= 256, Ze -= 8) ;
      for (tt = tt << Ze | et, it += Ze; it > 0; Xe[$e + ut] = 255 & tt, ut += lt, tt /= 256, it -= 8) ;
      Xe[$e + ut - lt] |= 128 * dt;
    };
  }, 1285: (He) => {
    typeof Object.create == "function" ? He.exports = function(Ge, Xe) {
      Xe && (Ge.super_ = Xe, Ge.prototype = Object.create(Xe.prototype, { constructor: { value: Ge, enumerable: !1, writable: !0, configurable: !0 } }));
    } : He.exports = function(Ge, Xe) {
      if (Xe) {
        Ge.super_ = Xe;
        var Ke = function() {
        };
        Ke.prototype = Xe.prototype, Ge.prototype = new Ke(), Ge.prototype.constructor = Ge;
      }
    };
  }, 7906: (He) => {
    var Ge = {}.toString;
    He.exports = Array.isArray || function(Xe) {
      return Ge.call(Xe) == "[object Array]";
    };
  }, 7993: (He, Ge, Xe) => {
    var Ke = Xe(1285), $e = Xe(4485), Je = Xe(7834).Buffer, Ze = new Array(16);
    function nt() {
      $e.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
    }
    function tt(at, st) {
      return at << st | at >>> 32 - st;
    }
    function et(at, st, ut, lt, dt, At, pt) {
      return tt(at + (st & ut | ~st & lt) + dt + At | 0, pt) + st | 0;
    }
    function rt(at, st, ut, lt, dt, At, pt) {
      return tt(at + (st & lt | ut & ~lt) + dt + At | 0, pt) + st | 0;
    }
    function it(at, st, ut, lt, dt, At, pt) {
      return tt(at + (st ^ ut ^ lt) + dt + At | 0, pt) + st | 0;
    }
    function ot(at, st, ut, lt, dt, At, pt) {
      return tt(at + (ut ^ (st | ~lt)) + dt + At | 0, pt) + st | 0;
    }
    Ke(nt, $e), nt.prototype._update = function() {
      for (var at = Ze, st = 0; st < 16; ++st) at[st] = this._block.readInt32LE(4 * st);
      var ut = this._a, lt = this._b, dt = this._c, At = this._d;
      ut = et(ut, lt, dt, At, at[0], 3614090360, 7), At = et(At, ut, lt, dt, at[1], 3905402710, 12), dt = et(dt, At, ut, lt, at[2], 606105819, 17), lt = et(lt, dt, At, ut, at[3], 3250441966, 22), ut = et(ut, lt, dt, At, at[4], 4118548399, 7), At = et(At, ut, lt, dt, at[5], 1200080426, 12), dt = et(dt, At, ut, lt, at[6], 2821735955, 17), lt = et(lt, dt, At, ut, at[7], 4249261313, 22), ut = et(ut, lt, dt, At, at[8], 1770035416, 7), At = et(At, ut, lt, dt, at[9], 2336552879, 12), dt = et(dt, At, ut, lt, at[10], 4294925233, 17), lt = et(lt, dt, At, ut, at[11], 2304563134, 22), ut = et(ut, lt, dt, At, at[12], 1804603682, 7), At = et(At, ut, lt, dt, at[13], 4254626195, 12), dt = et(dt, At, ut, lt, at[14], 2792965006, 17), ut = rt(ut, lt = et(lt, dt, At, ut, at[15], 1236535329, 22), dt, At, at[1], 4129170786, 5), At = rt(At, ut, lt, dt, at[6], 3225465664, 9), dt = rt(dt, At, ut, lt, at[11], 643717713, 14), lt = rt(lt, dt, At, ut, at[0], 3921069994, 20), ut = rt(ut, lt, dt, At, at[5], 3593408605, 5), At = rt(At, ut, lt, dt, at[10], 38016083, 9), dt = rt(dt, At, ut, lt, at[15], 3634488961, 14), lt = rt(lt, dt, At, ut, at[4], 3889429448, 20), ut = rt(ut, lt, dt, At, at[9], 568446438, 5), At = rt(At, ut, lt, dt, at[14], 3275163606, 9), dt = rt(dt, At, ut, lt, at[3], 4107603335, 14), lt = rt(lt, dt, At, ut, at[8], 1163531501, 20), ut = rt(ut, lt, dt, At, at[13], 2850285829, 5), At = rt(At, ut, lt, dt, at[2], 4243563512, 9), dt = rt(dt, At, ut, lt, at[7], 1735328473, 14), ut = it(ut, lt = rt(lt, dt, At, ut, at[12], 2368359562, 20), dt, At, at[5], 4294588738, 4), At = it(At, ut, lt, dt, at[8], 2272392833, 11), dt = it(dt, At, ut, lt, at[11], 1839030562, 16), lt = it(lt, dt, At, ut, at[14], 4259657740, 23), ut = it(ut, lt, dt, At, at[1], 2763975236, 4), At = it(At, ut, lt, dt, at[4], 1272893353, 11), dt = it(dt, At, ut, lt, at[7], 4139469664, 16), lt = it(lt, dt, At, ut, at[10], 3200236656, 23), ut = it(ut, lt, dt, At, at[13], 681279174, 4), At = it(At, ut, lt, dt, at[0], 3936430074, 11), dt = it(dt, At, ut, lt, at[3], 3572445317, 16), lt = it(lt, dt, At, ut, at[6], 76029189, 23), ut = it(ut, lt, dt, At, at[9], 3654602809, 4), At = it(At, ut, lt, dt, at[12], 3873151461, 11), dt = it(dt, At, ut, lt, at[15], 530742520, 16), ut = ot(ut, lt = it(lt, dt, At, ut, at[2], 3299628645, 23), dt, At, at[0], 4096336452, 6), At = ot(At, ut, lt, dt, at[7], 1126891415, 10), dt = ot(dt, At, ut, lt, at[14], 2878612391, 15), lt = ot(lt, dt, At, ut, at[5], 4237533241, 21), ut = ot(ut, lt, dt, At, at[12], 1700485571, 6), At = ot(At, ut, lt, dt, at[3], 2399980690, 10), dt = ot(dt, At, ut, lt, at[10], 4293915773, 15), lt = ot(lt, dt, At, ut, at[1], 2240044497, 21), ut = ot(ut, lt, dt, At, at[8], 1873313359, 6), At = ot(At, ut, lt, dt, at[15], 4264355552, 10), dt = ot(dt, At, ut, lt, at[6], 2734768916, 15), lt = ot(lt, dt, At, ut, at[13], 1309151649, 21), ut = ot(ut, lt, dt, At, at[4], 4149444226, 6), At = ot(At, ut, lt, dt, at[11], 3174756917, 10), dt = ot(dt, At, ut, lt, at[2], 718787259, 15), lt = ot(lt, dt, At, ut, at[9], 3951481745, 21), this._a = this._a + ut | 0, this._b = this._b + lt | 0, this._c = this._c + dt | 0, this._d = this._d + At | 0;
    }, nt.prototype._digest = function() {
      this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
      var at = Je.allocUnsafe(16);
      return at.writeInt32LE(this._a, 0), at.writeInt32LE(this._b, 4), at.writeInt32LE(this._c, 8), at.writeInt32LE(this._d, 12), at;
    }, He.exports = nt;
  }, 1482: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    function $e(ut, lt) {
      Ke.cipher.registerAlgorithm(ut, function() {
        return new Ke.aes.Algorithm(ut, lt);
      });
    }
    Xe(4609), Xe(9554), Xe(3103), He.exports = Ke.aes = Ke.aes || {}, Ke.aes.startEncrypting = function(ut, lt, dt, At) {
      var pt = st({ key: ut, output: dt, decrypt: !1, mode: At });
      return pt.start(lt), pt;
    }, Ke.aes.createEncryptionCipher = function(ut, lt) {
      return st({ key: ut, output: null, decrypt: !1, mode: lt });
    }, Ke.aes.startDecrypting = function(ut, lt, dt, At) {
      var pt = st({ key: ut, output: dt, decrypt: !0, mode: At });
      return pt.start(lt), pt;
    }, Ke.aes.createDecryptionCipher = function(ut, lt) {
      return st({ key: ut, output: null, decrypt: !0, mode: lt });
    }, Ke.aes.Algorithm = function(ut, lt) {
      rt || it();
      var dt = this;
      dt.name = ut, dt.mode = new lt({ blockSize: 16, cipher: { encrypt: function(At, pt) {
        return at(dt._w, At, pt, !1);
      }, decrypt: function(At, pt) {
        return at(dt._w, At, pt, !0);
      } } }), dt._init = !1;
    }, Ke.aes.Algorithm.prototype.initialize = function(ut) {
      if (!this._init) {
        var lt, dt = ut.key;
        if (typeof dt != "string" || dt.length !== 16 && dt.length !== 24 && dt.length !== 32) {
          if (Ke.util.isArray(dt) && (dt.length === 16 || dt.length === 24 || dt.length === 32)) {
            lt = dt, dt = Ke.util.createBuffer();
            for (var At = 0; At < lt.length; ++At) dt.putByte(lt[At]);
          }
        } else dt = Ke.util.createBuffer(dt);
        if (!Ke.util.isArray(dt)) {
          lt = dt, dt = [];
          var pt = lt.length();
          if (pt === 16 || pt === 24 || pt === 32) for (pt >>>= 2, At = 0; At < pt; ++At) dt.push(lt.getInt32());
        }
        if (!Ke.util.isArray(dt) || dt.length !== 4 && dt.length !== 6 && dt.length !== 8) throw new Error("Invalid key parameter.");
        var gt = this.mode.name, wt = ["CFB", "OFB", "CTR", "GCM"].indexOf(gt) !== -1;
        this._w = ot(dt, ut.decrypt && !wt), this._init = !0;
      }
    }, Ke.aes._expandKey = function(ut, lt) {
      return rt || it(), ot(ut, lt);
    }, Ke.aes._updateBlock = at, $e("AES-ECB", Ke.cipher.modes.ecb), $e("AES-CBC", Ke.cipher.modes.cbc), $e("AES-CFB", Ke.cipher.modes.cfb), $e("AES-OFB", Ke.cipher.modes.ofb), $e("AES-CTR", Ke.cipher.modes.ctr), $e("AES-GCM", Ke.cipher.modes.gcm);
    var Je, Ze, nt, tt, et, rt = !1;
    function it() {
      rt = !0, nt = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54];
      for (var ut = new Array(256), lt = 0; lt < 128; ++lt) ut[lt] = lt << 1, ut[lt + 128] = lt + 128 << 1 ^ 283;
      for (Je = new Array(256), Ze = new Array(256), tt = new Array(4), et = new Array(4), lt = 0; lt < 4; ++lt) tt[lt] = new Array(256), et[lt] = new Array(256);
      var dt, At, pt, gt, wt, Bt, Tt, yt = 0, Ct = 0;
      for (lt = 0; lt < 256; ++lt) {
        gt = (gt = Ct ^ Ct << 1 ^ Ct << 2 ^ Ct << 3 ^ Ct << 4) >> 8 ^ 255 & gt ^ 99, Je[yt] = gt, Ze[gt] = yt, Bt = (wt = ut[gt]) << 24 ^ gt << 16 ^ gt << 8 ^ gt ^ wt, Tt = ((dt = ut[yt]) ^ (At = ut[dt]) ^ (pt = ut[At])) << 24 ^ (yt ^ pt) << 16 ^ (yt ^ At ^ pt) << 8 ^ yt ^ dt ^ pt;
        for (var ht = 0; ht < 4; ++ht) tt[ht][yt] = Bt, et[ht][gt] = Tt, Bt = Bt << 24 | Bt >>> 8, Tt = Tt << 24 | Tt >>> 8;
        yt === 0 ? yt = Ct = 1 : (yt = dt ^ ut[ut[ut[dt ^ pt]]], Ct ^= ut[ut[Ct]]);
      }
    }
    function ot(ut, lt) {
      for (var dt, At = ut.slice(0), pt = 1, gt = At.length, wt = 4 * (gt + 6 + 1), Bt = gt; Bt < wt; ++Bt) dt = At[Bt - 1], Bt % gt == 0 ? (dt = Je[dt >>> 16 & 255] << 24 ^ Je[dt >>> 8 & 255] << 16 ^ Je[255 & dt] << 8 ^ Je[dt >>> 24] ^ nt[pt] << 24, pt++) : gt > 6 && Bt % gt == 4 && (dt = Je[dt >>> 24] << 24 ^ Je[dt >>> 16 & 255] << 16 ^ Je[dt >>> 8 & 255] << 8 ^ Je[255 & dt]), At[Bt] = At[Bt - gt] ^ dt;
      if (lt) {
        for (var Tt, yt = et[0], Ct = et[1], ht = et[2], It = et[3], vt = At.slice(0), Et = (Bt = 0, (wt = At.length) - 4); Bt < wt; Bt += 4, Et -= 4) if (Bt === 0 || Bt === wt - 4) vt[Bt] = At[Et], vt[Bt + 1] = At[Et + 3], vt[Bt + 2] = At[Et + 2], vt[Bt + 3] = At[Et + 1];
        else for (var bt = 0; bt < 4; ++bt) Tt = At[Et + bt], vt[Bt + (3 & -bt)] = yt[Je[Tt >>> 24]] ^ Ct[Je[Tt >>> 16 & 255]] ^ ht[Je[Tt >>> 8 & 255]] ^ It[Je[255 & Tt]];
        At = vt;
      }
      return At;
    }
    function at(ut, lt, dt, At) {
      var pt, gt, wt, Bt, Tt, yt, Ct, ht, It, vt, Et, bt, Rt = ut.length / 4 - 1;
      At ? (pt = et[0], gt = et[1], wt = et[2], Bt = et[3], Tt = Ze) : (pt = tt[0], gt = tt[1], wt = tt[2], Bt = tt[3], Tt = Je), yt = lt[0] ^ ut[0], Ct = lt[At ? 3 : 1] ^ ut[1], ht = lt[2] ^ ut[2], It = lt[At ? 1 : 3] ^ ut[3];
      for (var St = 3, kt = 1; kt < Rt; ++kt) vt = pt[yt >>> 24] ^ gt[Ct >>> 16 & 255] ^ wt[ht >>> 8 & 255] ^ Bt[255 & It] ^ ut[++St], Et = pt[Ct >>> 24] ^ gt[ht >>> 16 & 255] ^ wt[It >>> 8 & 255] ^ Bt[255 & yt] ^ ut[++St], bt = pt[ht >>> 24] ^ gt[It >>> 16 & 255] ^ wt[yt >>> 8 & 255] ^ Bt[255 & Ct] ^ ut[++St], It = pt[It >>> 24] ^ gt[yt >>> 16 & 255] ^ wt[Ct >>> 8 & 255] ^ Bt[255 & ht] ^ ut[++St], yt = vt, Ct = Et, ht = bt;
      dt[0] = Tt[yt >>> 24] << 24 ^ Tt[Ct >>> 16 & 255] << 16 ^ Tt[ht >>> 8 & 255] << 8 ^ Tt[255 & It] ^ ut[++St], dt[At ? 3 : 1] = Tt[Ct >>> 24] << 24 ^ Tt[ht >>> 16 & 255] << 16 ^ Tt[It >>> 8 & 255] << 8 ^ Tt[255 & yt] ^ ut[++St], dt[2] = Tt[ht >>> 24] << 24 ^ Tt[It >>> 16 & 255] << 16 ^ Tt[yt >>> 8 & 255] << 8 ^ Tt[255 & Ct] ^ ut[++St], dt[At ? 1 : 3] = Tt[It >>> 24] << 24 ^ Tt[yt >>> 16 & 255] << 16 ^ Tt[Ct >>> 8 & 255] << 8 ^ Tt[255 & ht] ^ ut[++St];
    }
    function st(ut) {
      var lt, dt = "AES-" + ((ut = ut || {}).mode || "CBC").toUpperCase(), At = (lt = ut.decrypt ? Ke.cipher.createDecipher(dt, ut.key) : Ke.cipher.createCipher(dt, ut.key)).start;
      return lt.start = function(pt, gt) {
        var wt = null;
        gt instanceof Ke.util.ByteBuffer && (wt = gt, gt = {}), (gt = gt || {}).output = wt, gt.iv = pt, At.call(lt, gt);
      }, lt;
    }
  }, 6898: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    Xe(1482), Xe(8472);
    var $e = He.exports = Ke.tls;
    function Je(rt, it, ot) {
      var at = it.entity === Ke.tls.ConnectionEnd.client;
      rt.read.cipherState = { init: !1, cipher: Ke.cipher.createDecipher("AES-CBC", at ? ot.keys.server_write_key : ot.keys.client_write_key), iv: at ? ot.keys.server_write_IV : ot.keys.client_write_IV }, rt.write.cipherState = { init: !1, cipher: Ke.cipher.createCipher("AES-CBC", at ? ot.keys.client_write_key : ot.keys.server_write_key), iv: at ? ot.keys.client_write_IV : ot.keys.server_write_IV }, rt.read.cipherFunction = et, rt.write.cipherFunction = Ze, rt.read.macLength = rt.write.macLength = ot.mac_length, rt.read.macFunction = rt.write.macFunction = $e.hmac_sha1;
    }
    function Ze(rt, it) {
      var ot, at = !1, st = it.macFunction(it.macKey, it.sequenceNumber, rt);
      rt.fragment.putBytes(st), it.updateSequenceNumber(), ot = rt.version.minor === $e.Versions.TLS_1_0.minor ? it.cipherState.init ? null : it.cipherState.iv : Ke.random.getBytesSync(16), it.cipherState.init = !0;
      var ut = it.cipherState.cipher;
      return ut.start({ iv: ot }), rt.version.minor >= $e.Versions.TLS_1_1.minor && ut.output.putBytes(ot), ut.update(rt.fragment), ut.finish(nt) && (rt.fragment = ut.output, rt.length = rt.fragment.length(), at = !0), at;
    }
    function nt(rt, it, ot) {
      if (!ot) {
        var at = rt - it.length() % rt;
        it.fillWithByte(at - 1, at);
      }
      return !0;
    }
    function tt(rt, it, ot) {
      var at = !0;
      if (ot) {
        for (var st = it.length(), ut = it.last(), lt = st - 1 - ut; lt < st - 1; ++lt) at = at && it.at(lt) == ut;
        at && it.truncate(ut + 1);
      }
      return at;
    }
    function et(rt, it) {
      var ot, at = !1;
      ot = rt.version.minor === $e.Versions.TLS_1_0.minor ? it.cipherState.init ? null : it.cipherState.iv : rt.fragment.getBytes(16), it.cipherState.init = !0;
      var st = it.cipherState.cipher;
      st.start({ iv: ot }), st.update(rt.fragment), at = st.finish(tt);
      var ut = it.macLength, lt = Ke.random.getBytesSync(ut), dt = st.output.length();
      dt >= ut ? (rt.fragment = st.output.getBytes(dt - ut), lt = st.output.getBytes(ut)) : rt.fragment = st.output.getBytes(), rt.fragment = Ke.util.createBuffer(rt.fragment), rt.length = rt.fragment.length();
      var At = it.macFunction(it.macKey, it.sequenceNumber, rt);
      return it.updateSequenceNumber(), at = function(pt, gt, wt) {
        var Bt = Ke.hmac.create();
        return Bt.start("SHA1", pt), Bt.update(gt), gt = Bt.digest().getBytes(), Bt.start(null, null), Bt.update(wt), gt === (wt = Bt.digest().getBytes());
      }(it.macKey, lt, At) && at, at;
    }
    $e.CipherSuites.TLS_RSA_WITH_AES_128_CBC_SHA = { id: [0, 47], name: "TLS_RSA_WITH_AES_128_CBC_SHA", initSecurityParameters: function(rt) {
      rt.bulk_cipher_algorithm = $e.BulkCipherAlgorithm.aes, rt.cipher_type = $e.CipherType.block, rt.enc_key_length = 16, rt.block_length = 16, rt.fixed_iv_length = 16, rt.record_iv_length = 16, rt.mac_algorithm = $e.MACAlgorithm.hmac_sha1, rt.mac_length = 20, rt.mac_key_length = 20;
    }, initConnectionState: Je }, $e.CipherSuites.TLS_RSA_WITH_AES_256_CBC_SHA = { id: [0, 53], name: "TLS_RSA_WITH_AES_256_CBC_SHA", initSecurityParameters: function(rt) {
      rt.bulk_cipher_algorithm = $e.BulkCipherAlgorithm.aes, rt.cipher_type = $e.CipherType.block, rt.enc_key_length = 32, rt.block_length = 16, rt.fixed_iv_length = 16, rt.record_iv_length = 16, rt.mac_algorithm = $e.MACAlgorithm.hmac_sha1, rt.mac_length = 20, rt.mac_key_length = 20;
    }, initConnectionState: Je };
  }, 5235: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    Xe(2624);
    var $e = Ke.asn1;
    Ge.privateKeyValidator = { name: "PrivateKeyInfo", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "PrivateKeyInfo.version", tagClass: $e.Class.UNIVERSAL, type: $e.Type.INTEGER, constructed: !1, capture: "privateKeyVersion" }, { name: "PrivateKeyInfo.privateKeyAlgorithm", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "AlgorithmIdentifier.algorithm", tagClass: $e.Class.UNIVERSAL, type: $e.Type.OID, constructed: !1, capture: "privateKeyOid" }] }, { name: "PrivateKeyInfo", tagClass: $e.Class.UNIVERSAL, type: $e.Type.OCTETSTRING, constructed: !1, capture: "privateKey" }] }, Ge.publicKeyValidator = { name: "SubjectPublicKeyInfo", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, captureAsn1: "subjectPublicKeyInfo", value: [{ name: "SubjectPublicKeyInfo.AlgorithmIdentifier", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "AlgorithmIdentifier.algorithm", tagClass: $e.Class.UNIVERSAL, type: $e.Type.OID, constructed: !1, capture: "publicKeyOid" }] }, { tagClass: $e.Class.UNIVERSAL, type: $e.Type.BITSTRING, constructed: !1, composed: !0, captureBitStringValue: "ed25519PublicKey" }] };
  }, 2624: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    Xe(3103), Xe(2884);
    var $e = He.exports = Ke.asn1 = Ke.asn1 || {};
    function Je(tt, et, rt) {
      if (rt > et) {
        var it = new Error("Too few bytes to parse DER.");
        throw it.available = tt.length(), it.remaining = et, it.requested = rt, it;
      }
    }
    function Ze(tt, et, rt, it) {
      var ot;
      Je(tt, et, 2);
      var at = tt.getByte();
      et--;
      var st = 192 & at, ut = 31 & at;
      ot = tt.length();
      var lt, dt, At = function(vt, Et) {
        var bt = vt.getByte();
        if (Et--, bt !== 128) {
          var Rt;
          if (128 & bt) {
            var St = 127 & bt;
            Je(vt, Et, St), Rt = vt.getInt(St << 3);
          } else Rt = bt;
          if (Rt < 0) throw new Error("Negative length: " + Rt);
          return Rt;
        }
      }(tt, et);
      if (et -= ot - tt.length(), At !== void 0 && At > et) {
        if (it.strict) {
          var pt = new Error("Too few bytes to read ASN.1 value.");
          throw pt.available = tt.length(), pt.remaining = et, pt.requested = At, pt;
        }
        At = et;
      }
      var gt = (32 & at) == 32;
      if (gt) if (lt = [], At === void 0) for (; ; ) {
        if (Je(tt, et, 2), tt.bytes(2) === "\0\0") {
          tt.getBytes(2), et -= 2;
          break;
        }
        ot = tt.length(), lt.push(Ze(tt, et, rt + 1, it)), et -= ot - tt.length();
      }
      else for (; At > 0; ) ot = tt.length(), lt.push(Ze(tt, At, rt + 1, it)), et -= ot - tt.length(), At -= ot - tt.length();
      if (lt === void 0 && st === $e.Class.UNIVERSAL && ut === $e.Type.BITSTRING && (dt = tt.bytes(At)), lt === void 0 && it.decodeBitStrings && st === $e.Class.UNIVERSAL && ut === $e.Type.BITSTRING && At > 1) {
        var wt = tt.read, Bt = et, Tt = 0;
        if (ut === $e.Type.BITSTRING && (Je(tt, et, 1), Tt = tt.getByte(), et--), Tt === 0) try {
          ot = tt.length();
          var yt = Ze(tt, et, rt + 1, { strict: !0, decodeBitStrings: !0 }), Ct = ot - tt.length();
          et -= Ct, ut == $e.Type.BITSTRING && Ct++;
          var ht = yt.tagClass;
          Ct !== At || ht !== $e.Class.UNIVERSAL && ht !== $e.Class.CONTEXT_SPECIFIC || (lt = [yt]);
        } catch {
        }
        lt === void 0 && (tt.read = wt, et = Bt);
      }
      if (lt === void 0) {
        if (At === void 0) {
          if (it.strict) throw new Error("Non-constructed ASN.1 object of indefinite length.");
          At = et;
        }
        if (ut === $e.Type.BMPSTRING) for (lt = ""; At > 0; At -= 2) Je(tt, et, 2), lt += String.fromCharCode(tt.getInt16()), et -= 2;
        else lt = tt.getBytes(At), et -= At;
      }
      var It = dt === void 0 ? null : { bitStringContents: dt };
      return $e.create(st, ut, gt, lt, It);
    }
    $e.Class = { UNIVERSAL: 0, APPLICATION: 64, CONTEXT_SPECIFIC: 128, PRIVATE: 192 }, $e.Type = { NONE: 0, BOOLEAN: 1, INTEGER: 2, BITSTRING: 3, OCTETSTRING: 4, NULL: 5, OID: 6, ODESC: 7, EXTERNAL: 8, REAL: 9, ENUMERATED: 10, EMBEDDED: 11, UTF8: 12, ROID: 13, SEQUENCE: 16, SET: 17, PRINTABLESTRING: 19, IA5STRING: 22, UTCTIME: 23, GENERALIZEDTIME: 24, BMPSTRING: 30 }, $e.create = function(tt, et, rt, it, ot) {
      if (Ke.util.isArray(it)) {
        for (var at = [], st = 0; st < it.length; ++st) it[st] !== void 0 && at.push(it[st]);
        it = at;
      }
      var ut = { tagClass: tt, type: et, constructed: rt, composed: rt || Ke.util.isArray(it), value: it };
      return ot && "bitStringContents" in ot && (ut.bitStringContents = ot.bitStringContents, ut.original = $e.copy(ut)), ut;
    }, $e.copy = function(tt, et) {
      var rt;
      if (Ke.util.isArray(tt)) {
        rt = [];
        for (var it = 0; it < tt.length; ++it) rt.push($e.copy(tt[it], et));
        return rt;
      }
      return typeof tt == "string" ? tt : (rt = { tagClass: tt.tagClass, type: tt.type, constructed: tt.constructed, composed: tt.composed, value: $e.copy(tt.value, et) }, et && !et.excludeBitStringContents && (rt.bitStringContents = tt.bitStringContents), rt);
    }, $e.equals = function(tt, et, rt) {
      if (Ke.util.isArray(tt)) {
        if (!Ke.util.isArray(et) || tt.length !== et.length) return !1;
        for (var it = 0; it < tt.length; ++it) if (!$e.equals(tt[it], et[it])) return !1;
        return !0;
      }
      if (typeof tt != typeof et) return !1;
      if (typeof tt == "string") return tt === et;
      var ot = tt.tagClass === et.tagClass && tt.type === et.type && tt.constructed === et.constructed && tt.composed === et.composed && $e.equals(tt.value, et.value);
      return rt && rt.includeBitStringContents && (ot = ot && tt.bitStringContents === et.bitStringContents), ot;
    }, $e.getBerValueLength = function(tt) {
      var et = tt.getByte();
      if (et !== 128) return 128 & et ? tt.getInt((127 & et) << 3) : et;
    }, $e.fromDer = function(tt, et) {
      et === void 0 && (et = { strict: !0, parseAllBytes: !0, decodeBitStrings: !0 }), typeof et == "boolean" && (et = { strict: et, parseAllBytes: !0, decodeBitStrings: !0 }), "strict" in et || (et.strict = !0), "parseAllBytes" in et || (et.parseAllBytes = !0), "decodeBitStrings" in et || (et.decodeBitStrings = !0), typeof tt == "string" && (tt = Ke.util.createBuffer(tt));
      var rt = tt.length(), it = Ze(tt, tt.length(), 0, et);
      if (et.parseAllBytes && tt.length() !== 0) {
        var ot = new Error("Unparsed DER bytes remain after ASN.1 parsing.");
        throw ot.byteCount = rt, ot.remaining = tt.length(), ot;
      }
      return it;
    }, $e.toDer = function(tt) {
      var et = Ke.util.createBuffer(), rt = tt.tagClass | tt.type, it = Ke.util.createBuffer(), ot = !1;
      if ("bitStringContents" in tt && (ot = !0, tt.original && (ot = $e.equals(tt, tt.original))), ot) it.putBytes(tt.bitStringContents);
      else if (tt.composed) {
        tt.constructed ? rt |= 32 : it.putByte(0);
        for (var at = 0; at < tt.value.length; ++at) tt.value[at] !== void 0 && it.putBuffer($e.toDer(tt.value[at]));
      } else if (tt.type === $e.Type.BMPSTRING) for (at = 0; at < tt.value.length; ++at) it.putInt16(tt.value.charCodeAt(at));
      else tt.type === $e.Type.INTEGER && tt.value.length > 1 && (tt.value.charCodeAt(0) === 0 && !(128 & tt.value.charCodeAt(1)) || tt.value.charCodeAt(0) === 255 && (128 & tt.value.charCodeAt(1)) == 128) ? it.putBytes(tt.value.substr(1)) : it.putBytes(tt.value);
      if (et.putByte(rt), it.length() <= 127) et.putByte(127 & it.length());
      else {
        var st = it.length(), ut = "";
        do
          ut += String.fromCharCode(255 & st), st >>>= 8;
        while (st > 0);
        for (et.putByte(128 | ut.length), at = ut.length - 1; at >= 0; --at) et.putByte(ut.charCodeAt(at));
      }
      return et.putBuffer(it), et;
    }, $e.oidToDer = function(tt) {
      var et, rt, it, ot, at = tt.split("."), st = Ke.util.createBuffer();
      st.putByte(40 * parseInt(at[0], 10) + parseInt(at[1], 10));
      for (var ut = 2; ut < at.length; ++ut) {
        et = !0, rt = [], it = parseInt(at[ut], 10);
        do
          ot = 127 & it, it >>>= 7, et || (ot |= 128), rt.push(ot), et = !1;
        while (it > 0);
        for (var lt = rt.length - 1; lt >= 0; --lt) st.putByte(rt[lt]);
      }
      return st;
    }, $e.derToOid = function(tt) {
      var et;
      typeof tt == "string" && (tt = Ke.util.createBuffer(tt));
      var rt = tt.getByte();
      et = Math.floor(rt / 40) + "." + rt % 40;
      for (var it = 0; tt.length() > 0; ) it <<= 7, 128 & (rt = tt.getByte()) ? it += 127 & rt : (et += "." + (it + rt), it = 0);
      return et;
    }, $e.utcTimeToDate = function(tt) {
      var et = /* @__PURE__ */ new Date(), rt = parseInt(tt.substr(0, 2), 10);
      rt = rt >= 50 ? 1900 + rt : 2e3 + rt;
      var it = parseInt(tt.substr(2, 2), 10) - 1, ot = parseInt(tt.substr(4, 2), 10), at = parseInt(tt.substr(6, 2), 10), st = parseInt(tt.substr(8, 2), 10), ut = 0;
      if (tt.length > 11) {
        var lt = tt.charAt(10), dt = 10;
        lt !== "+" && lt !== "-" && (ut = parseInt(tt.substr(10, 2), 10), dt += 2);
      }
      if (et.setUTCFullYear(rt, it, ot), et.setUTCHours(at, st, ut, 0), dt && ((lt = tt.charAt(dt)) === "+" || lt === "-")) {
        var At = 60 * parseInt(tt.substr(dt + 1, 2), 10) + parseInt(tt.substr(dt + 4, 2), 10);
        At *= 6e4, lt === "+" ? et.setTime(+et - At) : et.setTime(+et + At);
      }
      return et;
    }, $e.generalizedTimeToDate = function(tt) {
      var et = /* @__PURE__ */ new Date(), rt = parseInt(tt.substr(0, 4), 10), it = parseInt(tt.substr(4, 2), 10) - 1, ot = parseInt(tt.substr(6, 2), 10), at = parseInt(tt.substr(8, 2), 10), st = parseInt(tt.substr(10, 2), 10), ut = parseInt(tt.substr(12, 2), 10), lt = 0, dt = 0, At = !1;
      tt.charAt(tt.length - 1) === "Z" && (At = !0);
      var pt = tt.length - 5, gt = tt.charAt(pt);
      return gt !== "+" && gt !== "-" || (dt = 60 * parseInt(tt.substr(pt + 1, 2), 10) + parseInt(tt.substr(pt + 4, 2), 10), dt *= 6e4, gt === "+" && (dt *= -1), At = !0), tt.charAt(14) === "." && (lt = 1e3 * parseFloat(tt.substr(14), 10)), At ? (et.setUTCFullYear(rt, it, ot), et.setUTCHours(at, st, ut, lt), et.setTime(+et + dt)) : (et.setFullYear(rt, it, ot), et.setHours(at, st, ut, lt)), et;
    }, $e.dateToUtcTime = function(tt) {
      if (typeof tt == "string") return tt;
      var et = "", rt = [];
      rt.push(("" + tt.getUTCFullYear()).substr(2)), rt.push("" + (tt.getUTCMonth() + 1)), rt.push("" + tt.getUTCDate()), rt.push("" + tt.getUTCHours()), rt.push("" + tt.getUTCMinutes()), rt.push("" + tt.getUTCSeconds());
      for (var it = 0; it < rt.length; ++it) rt[it].length < 2 && (et += "0"), et += rt[it];
      return et + "Z";
    }, $e.dateToGeneralizedTime = function(tt) {
      if (typeof tt == "string") return tt;
      var et = "", rt = [];
      rt.push("" + tt.getUTCFullYear()), rt.push("" + (tt.getUTCMonth() + 1)), rt.push("" + tt.getUTCDate()), rt.push("" + tt.getUTCHours()), rt.push("" + tt.getUTCMinutes()), rt.push("" + tt.getUTCSeconds());
      for (var it = 0; it < rt.length; ++it) rt[it].length < 2 && (et += "0"), et += rt[it];
      return et + "Z";
    }, $e.integerToDer = function(tt) {
      var et = Ke.util.createBuffer();
      if (tt >= -128 && tt < 128) return et.putSignedInt(tt, 8);
      if (tt >= -32768 && tt < 32768) return et.putSignedInt(tt, 16);
      if (tt >= -8388608 && tt < 8388608) return et.putSignedInt(tt, 24);
      if (tt >= -2147483648 && tt < 2147483648) return et.putSignedInt(tt, 32);
      var rt = new Error("Integer too large; max is 32-bits.");
      throw rt.integer = tt, rt;
    }, $e.derToInteger = function(tt) {
      typeof tt == "string" && (tt = Ke.util.createBuffer(tt));
      var et = 8 * tt.length();
      if (et > 32) throw new Error("Integer too large; max is 32-bits.");
      return tt.getSignedInt(et);
    }, $e.validate = function(tt, et, rt, it) {
      var ot = !1;
      if (tt.tagClass !== et.tagClass && et.tagClass !== void 0 || tt.type !== et.type && et.type !== void 0) it && (tt.tagClass !== et.tagClass && it.push("[" + et.name + '] Expected tag class "' + et.tagClass + '", got "' + tt.tagClass + '"'), tt.type !== et.type && it.push("[" + et.name + '] Expected type "' + et.type + '", got "' + tt.type + '"'));
      else if (tt.constructed === et.constructed || et.constructed === void 0) {
        if (ot = !0, et.value && Ke.util.isArray(et.value)) for (var at = 0, st = 0; ot && st < et.value.length; ++st) ot = et.value[st].optional || !1, tt.value[at] && ((ot = $e.validate(tt.value[at], et.value[st], rt, it)) ? ++at : et.value[st].optional && (ot = !0)), !ot && it && it.push("[" + et.name + '] Tag class "' + et.tagClass + '", type "' + et.type + '" expected value length "' + et.value.length + '", got "' + tt.value.length + '"');
        if (ot && rt && (et.capture && (rt[et.capture] = tt.value), et.captureAsn1 && (rt[et.captureAsn1] = tt), et.captureBitStringContents && "bitStringContents" in tt && (rt[et.captureBitStringContents] = tt.bitStringContents), et.captureBitStringValue && "bitStringContents" in tt)) if (tt.bitStringContents.length < 2) rt[et.captureBitStringValue] = "";
        else {
          if (tt.bitStringContents.charCodeAt(0) !== 0) throw new Error("captureBitStringValue only supported for zero unused bits");
          rt[et.captureBitStringValue] = tt.bitStringContents.slice(1);
        }
      } else it && it.push("[" + et.name + '] Expected constructed "' + et.constructed + '", got "' + tt.constructed + '"');
      return ot;
    };
    var nt = /[^\\u0000-\\u00ff]/;
    $e.prettyPrint = function(tt, et, rt) {
      var it = "";
      rt = rt || 2, (et = et || 0) > 0 && (it += `
`);
      for (var ot = "", at = 0; at < et * rt; ++at) ot += " ";
      switch (it += ot + "Tag: ", tt.tagClass) {
        case $e.Class.UNIVERSAL:
          it += "Universal:";
          break;
        case $e.Class.APPLICATION:
          it += "Application:";
          break;
        case $e.Class.CONTEXT_SPECIFIC:
          it += "Context-Specific:";
          break;
        case $e.Class.PRIVATE:
          it += "Private:";
      }
      if (tt.tagClass === $e.Class.UNIVERSAL) switch (it += tt.type, tt.type) {
        case $e.Type.NONE:
          it += " (None)";
          break;
        case $e.Type.BOOLEAN:
          it += " (Boolean)";
          break;
        case $e.Type.INTEGER:
          it += " (Integer)";
          break;
        case $e.Type.BITSTRING:
          it += " (Bit string)";
          break;
        case $e.Type.OCTETSTRING:
          it += " (Octet string)";
          break;
        case $e.Type.NULL:
          it += " (Null)";
          break;
        case $e.Type.OID:
          it += " (Object Identifier)";
          break;
        case $e.Type.ODESC:
          it += " (Object Descriptor)";
          break;
        case $e.Type.EXTERNAL:
          it += " (External or Instance of)";
          break;
        case $e.Type.REAL:
          it += " (Real)";
          break;
        case $e.Type.ENUMERATED:
          it += " (Enumerated)";
          break;
        case $e.Type.EMBEDDED:
          it += " (Embedded PDV)";
          break;
        case $e.Type.UTF8:
          it += " (UTF8)";
          break;
        case $e.Type.ROID:
          it += " (Relative Object Identifier)";
          break;
        case $e.Type.SEQUENCE:
          it += " (Sequence)";
          break;
        case $e.Type.SET:
          it += " (Set)";
          break;
        case $e.Type.PRINTABLESTRING:
          it += " (Printable String)";
          break;
        case $e.Type.IA5String:
          it += " (IA5String (ASCII))";
          break;
        case $e.Type.UTCTIME:
          it += " (UTC time)";
          break;
        case $e.Type.GENERALIZEDTIME:
          it += " (Generalized time)";
          break;
        case $e.Type.BMPSTRING:
          it += " (BMP String)";
      }
      else it += tt.type;
      if (it += `
`, it += ot + "Constructed: " + tt.constructed + `
`, tt.composed) {
        var st = 0, ut = "";
        for (at = 0; at < tt.value.length; ++at) tt.value[at] !== void 0 && (st += 1, ut += $e.prettyPrint(tt.value[at], et + 1, rt), at + 1 < tt.value.length && (ut += ","));
        it += ot + "Sub values: " + st + ut;
      } else {
        if (it += ot + "Value: ", tt.type === $e.Type.OID) {
          var lt = $e.derToOid(tt.value);
          it += lt, Ke.pki && Ke.pki.oids && lt in Ke.pki.oids && (it += " (" + Ke.pki.oids[lt] + ") ");
        }
        if (tt.type === $e.Type.INTEGER) try {
          it += $e.derToInteger(tt.value);
        } catch {
          it += "0x" + Ke.util.bytesToHex(tt.value);
        }
        else if (tt.type === $e.Type.BITSTRING) {
          if (tt.value.length > 1 ? it += "0x" + Ke.util.bytesToHex(tt.value.slice(1)) : it += "(none)", tt.value.length > 0) {
            var dt = tt.value.charCodeAt(0);
            dt == 1 ? it += " (1 unused bit shown)" : dt > 1 && (it += " (" + dt + " unused bits shown)");
          }
        } else if (tt.type === $e.Type.OCTETSTRING) nt.test(tt.value) || (it += "(" + tt.value + ") "), it += "0x" + Ke.util.bytesToHex(tt.value);
        else if (tt.type === $e.Type.UTF8) try {
          it += Ke.util.decodeUtf8(tt.value);
        } catch (At) {
          if (At.message !== "URI malformed") throw At;
          it += "0x" + Ke.util.bytesToHex(tt.value) + " (malformed UTF8)";
        }
        else tt.type === $e.Type.PRINTABLESTRING || tt.type === $e.Type.IA5String ? it += tt.value : nt.test(tt.value) ? it += "0x" + Ke.util.bytesToHex(tt.value) : tt.value.length === 0 ? it += "[null]" : it += tt.value;
      }
      return it;
    };
  }, 7858: (He, Ge, Xe) => {
    var Ke = Xe(7573).Buffer, $e = {};
    He.exports = $e;
    var Je = {};
    $e.encode = function(Ze, nt, tt) {
      if (typeof nt != "string") throw new TypeError('"alphabet" must be a string.');
      if (tt !== void 0 && typeof tt != "number") throw new TypeError('"maxline" must be a number.');
      var et = "";
      if (Ze instanceof Uint8Array) {
        var rt = 0, it = nt.length, ot = nt.charAt(0), at = [0];
        for (rt = 0; rt < Ze.length; ++rt) {
          for (var st = 0, ut = Ze[rt]; st < at.length; ++st) ut += at[st] << 8, at[st] = ut % it, ut = ut / it | 0;
          for (; ut > 0; ) at.push(ut % it), ut = ut / it | 0;
        }
        for (rt = 0; Ze[rt] === 0 && rt < Ze.length - 1; ++rt) et += ot;
        for (rt = at.length - 1; rt >= 0; --rt) et += nt[at[rt]];
      } else et = function(dt, At) {
        var pt = 0, gt = At.length, wt = At.charAt(0), Bt = [0];
        for (pt = 0; pt < dt.length(); ++pt) {
          for (var Tt = 0, yt = dt.at(pt); Tt < Bt.length; ++Tt) yt += Bt[Tt] << 8, Bt[Tt] = yt % gt, yt = yt / gt | 0;
          for (; yt > 0; ) Bt.push(yt % gt), yt = yt / gt | 0;
        }
        var Ct = "";
        for (pt = 0; dt.at(pt) === 0 && pt < dt.length() - 1; ++pt) Ct += wt;
        for (pt = Bt.length - 1; pt >= 0; --pt) Ct += At[Bt[pt]];
        return Ct;
      }(Ze, nt);
      if (tt) {
        var lt = new RegExp(".{1," + tt + "}", "g");
        et = et.match(lt).join(`\r
`);
      }
      return et;
    }, $e.decode = function(Ze, nt) {
      if (typeof Ze != "string") throw new TypeError('"input" must be a string.');
      if (typeof nt != "string") throw new TypeError('"alphabet" must be a string.');
      var tt = Je[nt];
      if (!tt) {
        tt = Je[nt] = [];
        for (var et = 0; et < nt.length; ++et) tt[nt.charCodeAt(et)] = et;
      }
      Ze = Ze.replace(/\s/g, "");
      var rt = nt.length, it = nt.charAt(0), ot = [0];
      for (et = 0; et < Ze.length; et++) {
        var at = tt[Ze.charCodeAt(et)];
        if (at === void 0) return;
        for (var st = 0, ut = at; st < ot.length; ++st) ut += ot[st] * rt, ot[st] = 255 & ut, ut >>= 8;
        for (; ut > 0; ) ot.push(255 & ut), ut >>= 8;
      }
      for (var lt = 0; Ze[lt] === it && lt < Ze.length - 1; ++lt) ot.push(0);
      return Ke !== void 0 ? Ke.from(ot.reverse()) : new Uint8Array(ot.reverse());
    };
  }, 4609: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    Xe(3103), He.exports = Ke.cipher = Ke.cipher || {}, Ke.cipher.algorithms = Ke.cipher.algorithms || {}, Ke.cipher.createCipher = function(Je, Ze) {
      var nt = Je;
      if (typeof nt == "string" && (nt = Ke.cipher.getAlgorithm(nt)) && (nt = nt()), !nt) throw new Error("Unsupported algorithm: " + Je);
      return new Ke.cipher.BlockCipher({ algorithm: nt, key: Ze, decrypt: !1 });
    }, Ke.cipher.createDecipher = function(Je, Ze) {
      var nt = Je;
      if (typeof nt == "string" && (nt = Ke.cipher.getAlgorithm(nt)) && (nt = nt()), !nt) throw new Error("Unsupported algorithm: " + Je);
      return new Ke.cipher.BlockCipher({ algorithm: nt, key: Ze, decrypt: !0 });
    }, Ke.cipher.registerAlgorithm = function(Je, Ze) {
      Je = Je.toUpperCase(), Ke.cipher.algorithms[Je] = Ze;
    }, Ke.cipher.getAlgorithm = function(Je) {
      return (Je = Je.toUpperCase()) in Ke.cipher.algorithms ? Ke.cipher.algorithms[Je] : null;
    };
    var $e = Ke.cipher.BlockCipher = function(Je) {
      this.algorithm = Je.algorithm, this.mode = this.algorithm.mode, this.blockSize = this.mode.blockSize, this._finish = !1, this._input = null, this.output = null, this._op = Je.decrypt ? this.mode.decrypt : this.mode.encrypt, this._decrypt = Je.decrypt, this.algorithm.initialize(Je);
    };
    $e.prototype.start = function(Je) {
      Je = Je || {};
      var Ze = {};
      for (var nt in Je) Ze[nt] = Je[nt];
      Ze.decrypt = this._decrypt, this._finish = !1, this._input = Ke.util.createBuffer(), this.output = Je.output || Ke.util.createBuffer(), this.mode.start(Ze);
    }, $e.prototype.update = function(Je) {
      for (Je && this._input.putBuffer(Je); !this._op.call(this.mode, this._input, this.output, this._finish) && !this._finish; ) ;
      this._input.compact();
    }, $e.prototype.finish = function(Je) {
      !Je || this.mode.name !== "ECB" && this.mode.name !== "CBC" || (this.mode.pad = function(nt) {
        return Je(this.blockSize, nt, !1);
      }, this.mode.unpad = function(nt) {
        return Je(this.blockSize, nt, !0);
      });
      var Ze = {};
      return Ze.decrypt = this._decrypt, Ze.overflow = this._input.length() % this.blockSize, !(!this._decrypt && this.mode.pad && !this.mode.pad(this._input, Ze) || (this._finish = !0, this.update(), this._decrypt && this.mode.unpad && !this.mode.unpad(this.output, Ze) || this.mode.afterFinish && !this.mode.afterFinish(this.output, Ze)));
    };
  }, 9554: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    Xe(3103), Ke.cipher = Ke.cipher || {};
    var $e = He.exports = Ke.cipher.modes = Ke.cipher.modes || {};
    function Je(tt, et) {
      if (typeof tt == "string" && (tt = Ke.util.createBuffer(tt)), Ke.util.isArray(tt) && tt.length > 4) {
        var rt = tt;
        tt = Ke.util.createBuffer();
        for (var it = 0; it < rt.length; ++it) tt.putByte(rt[it]);
      }
      if (tt.length() < et) throw new Error("Invalid IV length; got " + tt.length() + " bytes and expected " + et + " bytes.");
      if (!Ke.util.isArray(tt)) {
        var ot = [], at = et / 4;
        for (it = 0; it < at; ++it) ot.push(tt.getInt32());
        tt = ot;
      }
      return tt;
    }
    function Ze(tt) {
      tt[tt.length - 1] = tt[tt.length - 1] + 1 & 4294967295;
    }
    function nt(tt) {
      return [tt / 4294967296 | 0, 4294967295 & tt];
    }
    $e.ecb = function(tt) {
      tt = tt || {}, this.name = "ECB", this.cipher = tt.cipher, this.blockSize = tt.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = new Array(this._ints), this._outBlock = new Array(this._ints);
    }, $e.ecb.prototype.start = function(tt) {
    }, $e.ecb.prototype.encrypt = function(tt, et, rt) {
      if (tt.length() < this.blockSize && !(rt && tt.length() > 0)) return !0;
      for (var it = 0; it < this._ints; ++it) this._inBlock[it] = tt.getInt32();
      for (this.cipher.encrypt(this._inBlock, this._outBlock), it = 0; it < this._ints; ++it) et.putInt32(this._outBlock[it]);
    }, $e.ecb.prototype.decrypt = function(tt, et, rt) {
      if (tt.length() < this.blockSize && !(rt && tt.length() > 0)) return !0;
      for (var it = 0; it < this._ints; ++it) this._inBlock[it] = tt.getInt32();
      for (this.cipher.decrypt(this._inBlock, this._outBlock), it = 0; it < this._ints; ++it) et.putInt32(this._outBlock[it]);
    }, $e.ecb.prototype.pad = function(tt, et) {
      var rt = tt.length() === this.blockSize ? this.blockSize : this.blockSize - tt.length();
      return tt.fillWithByte(rt, rt), !0;
    }, $e.ecb.prototype.unpad = function(tt, et) {
      if (et.overflow > 0) return !1;
      var rt = tt.length(), it = tt.at(rt - 1);
      return !(it > this.blockSize << 2 || (tt.truncate(it), 0));
    }, $e.cbc = function(tt) {
      tt = tt || {}, this.name = "CBC", this.cipher = tt.cipher, this.blockSize = tt.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = new Array(this._ints), this._outBlock = new Array(this._ints);
    }, $e.cbc.prototype.start = function(tt) {
      if (tt.iv === null) {
        if (!this._prev) throw new Error("Invalid IV parameter.");
        this._iv = this._prev.slice(0);
      } else {
        if (!("iv" in tt)) throw new Error("Invalid IV parameter.");
        this._iv = Je(tt.iv, this.blockSize), this._prev = this._iv.slice(0);
      }
    }, $e.cbc.prototype.encrypt = function(tt, et, rt) {
      if (tt.length() < this.blockSize && !(rt && tt.length() > 0)) return !0;
      for (var it = 0; it < this._ints; ++it) this._inBlock[it] = this._prev[it] ^ tt.getInt32();
      for (this.cipher.encrypt(this._inBlock, this._outBlock), it = 0; it < this._ints; ++it) et.putInt32(this._outBlock[it]);
      this._prev = this._outBlock;
    }, $e.cbc.prototype.decrypt = function(tt, et, rt) {
      if (tt.length() < this.blockSize && !(rt && tt.length() > 0)) return !0;
      for (var it = 0; it < this._ints; ++it) this._inBlock[it] = tt.getInt32();
      for (this.cipher.decrypt(this._inBlock, this._outBlock), it = 0; it < this._ints; ++it) et.putInt32(this._prev[it] ^ this._outBlock[it]);
      this._prev = this._inBlock.slice(0);
    }, $e.cbc.prototype.pad = function(tt, et) {
      var rt = tt.length() === this.blockSize ? this.blockSize : this.blockSize - tt.length();
      return tt.fillWithByte(rt, rt), !0;
    }, $e.cbc.prototype.unpad = function(tt, et) {
      if (et.overflow > 0) return !1;
      var rt = tt.length(), it = tt.at(rt - 1);
      return !(it > this.blockSize << 2 || (tt.truncate(it), 0));
    }, $e.cfb = function(tt) {
      tt = tt || {}, this.name = "CFB", this.cipher = tt.cipher, this.blockSize = tt.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = null, this._outBlock = new Array(this._ints), this._partialBlock = new Array(this._ints), this._partialOutput = Ke.util.createBuffer(), this._partialBytes = 0;
    }, $e.cfb.prototype.start = function(tt) {
      if (!("iv" in tt)) throw new Error("Invalid IV parameter.");
      this._iv = Je(tt.iv, this.blockSize), this._inBlock = this._iv.slice(0), this._partialBytes = 0;
    }, $e.cfb.prototype.encrypt = function(tt, et, rt) {
      var it = tt.length();
      if (it === 0) return !0;
      if (this.cipher.encrypt(this._inBlock, this._outBlock), this._partialBytes === 0 && it >= this.blockSize) for (var ot = 0; ot < this._ints; ++ot) this._inBlock[ot] = tt.getInt32() ^ this._outBlock[ot], et.putInt32(this._inBlock[ot]);
      else {
        var at = (this.blockSize - it) % this.blockSize;
        for (at > 0 && (at = this.blockSize - at), this._partialOutput.clear(), ot = 0; ot < this._ints; ++ot) this._partialBlock[ot] = tt.getInt32() ^ this._outBlock[ot], this._partialOutput.putInt32(this._partialBlock[ot]);
        if (at > 0) tt.read -= this.blockSize;
        else for (ot = 0; ot < this._ints; ++ot) this._inBlock[ot] = this._partialBlock[ot];
        if (this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), at > 0 && !rt) return et.putBytes(this._partialOutput.getBytes(at - this._partialBytes)), this._partialBytes = at, !0;
        et.putBytes(this._partialOutput.getBytes(it - this._partialBytes)), this._partialBytes = 0;
      }
    }, $e.cfb.prototype.decrypt = function(tt, et, rt) {
      var it = tt.length();
      if (it === 0) return !0;
      if (this.cipher.encrypt(this._inBlock, this._outBlock), this._partialBytes === 0 && it >= this.blockSize) for (var ot = 0; ot < this._ints; ++ot) this._inBlock[ot] = tt.getInt32(), et.putInt32(this._inBlock[ot] ^ this._outBlock[ot]);
      else {
        var at = (this.blockSize - it) % this.blockSize;
        for (at > 0 && (at = this.blockSize - at), this._partialOutput.clear(), ot = 0; ot < this._ints; ++ot) this._partialBlock[ot] = tt.getInt32(), this._partialOutput.putInt32(this._partialBlock[ot] ^ this._outBlock[ot]);
        if (at > 0) tt.read -= this.blockSize;
        else for (ot = 0; ot < this._ints; ++ot) this._inBlock[ot] = this._partialBlock[ot];
        if (this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), at > 0 && !rt) return et.putBytes(this._partialOutput.getBytes(at - this._partialBytes)), this._partialBytes = at, !0;
        et.putBytes(this._partialOutput.getBytes(it - this._partialBytes)), this._partialBytes = 0;
      }
    }, $e.ofb = function(tt) {
      tt = tt || {}, this.name = "OFB", this.cipher = tt.cipher, this.blockSize = tt.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = null, this._outBlock = new Array(this._ints), this._partialOutput = Ke.util.createBuffer(), this._partialBytes = 0;
    }, $e.ofb.prototype.start = function(tt) {
      if (!("iv" in tt)) throw new Error("Invalid IV parameter.");
      this._iv = Je(tt.iv, this.blockSize), this._inBlock = this._iv.slice(0), this._partialBytes = 0;
    }, $e.ofb.prototype.encrypt = function(tt, et, rt) {
      var it = tt.length();
      if (tt.length() === 0) return !0;
      if (this.cipher.encrypt(this._inBlock, this._outBlock), this._partialBytes === 0 && it >= this.blockSize) for (var ot = 0; ot < this._ints; ++ot) et.putInt32(tt.getInt32() ^ this._outBlock[ot]), this._inBlock[ot] = this._outBlock[ot];
      else {
        var at = (this.blockSize - it) % this.blockSize;
        for (at > 0 && (at = this.blockSize - at), this._partialOutput.clear(), ot = 0; ot < this._ints; ++ot) this._partialOutput.putInt32(tt.getInt32() ^ this._outBlock[ot]);
        if (at > 0) tt.read -= this.blockSize;
        else for (ot = 0; ot < this._ints; ++ot) this._inBlock[ot] = this._outBlock[ot];
        if (this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), at > 0 && !rt) return et.putBytes(this._partialOutput.getBytes(at - this._partialBytes)), this._partialBytes = at, !0;
        et.putBytes(this._partialOutput.getBytes(it - this._partialBytes)), this._partialBytes = 0;
      }
    }, $e.ofb.prototype.decrypt = $e.ofb.prototype.encrypt, $e.ctr = function(tt) {
      tt = tt || {}, this.name = "CTR", this.cipher = tt.cipher, this.blockSize = tt.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = null, this._outBlock = new Array(this._ints), this._partialOutput = Ke.util.createBuffer(), this._partialBytes = 0;
    }, $e.ctr.prototype.start = function(tt) {
      if (!("iv" in tt)) throw new Error("Invalid IV parameter.");
      this._iv = Je(tt.iv, this.blockSize), this._inBlock = this._iv.slice(0), this._partialBytes = 0;
    }, $e.ctr.prototype.encrypt = function(tt, et, rt) {
      var it = tt.length();
      if (it === 0) return !0;
      if (this.cipher.encrypt(this._inBlock, this._outBlock), this._partialBytes === 0 && it >= this.blockSize) for (var ot = 0; ot < this._ints; ++ot) et.putInt32(tt.getInt32() ^ this._outBlock[ot]);
      else {
        var at = (this.blockSize - it) % this.blockSize;
        for (at > 0 && (at = this.blockSize - at), this._partialOutput.clear(), ot = 0; ot < this._ints; ++ot) this._partialOutput.putInt32(tt.getInt32() ^ this._outBlock[ot]);
        if (at > 0 && (tt.read -= this.blockSize), this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), at > 0 && !rt) return et.putBytes(this._partialOutput.getBytes(at - this._partialBytes)), this._partialBytes = at, !0;
        et.putBytes(this._partialOutput.getBytes(it - this._partialBytes)), this._partialBytes = 0;
      }
      Ze(this._inBlock);
    }, $e.ctr.prototype.decrypt = $e.ctr.prototype.encrypt, $e.gcm = function(tt) {
      tt = tt || {}, this.name = "GCM", this.cipher = tt.cipher, this.blockSize = tt.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = new Array(this._ints), this._outBlock = new Array(this._ints), this._partialOutput = Ke.util.createBuffer(), this._partialBytes = 0, this._R = 3774873600;
    }, $e.gcm.prototype.start = function(tt) {
      if (!("iv" in tt)) throw new Error("Invalid IV parameter.");
      var et, rt = Ke.util.createBuffer(tt.iv);
      if (this._cipherLength = 0, et = "additionalData" in tt ? Ke.util.createBuffer(tt.additionalData) : Ke.util.createBuffer(), this._tagLength = "tagLength" in tt ? tt.tagLength : 128, this._tag = null, tt.decrypt && (this._tag = Ke.util.createBuffer(tt.tag).getBytes(), this._tag.length !== this._tagLength / 8)) throw new Error("Authentication tag does not match tag length.");
      this._hashBlock = new Array(this._ints), this.tag = null, this._hashSubkey = new Array(this._ints), this.cipher.encrypt([0, 0, 0, 0], this._hashSubkey), this.componentBits = 4, this._m = this.generateHashTable(this._hashSubkey, this.componentBits);
      var it = rt.length();
      if (it === 12) this._j0 = [rt.getInt32(), rt.getInt32(), rt.getInt32(), 1];
      else {
        for (this._j0 = [0, 0, 0, 0]; rt.length() > 0; ) this._j0 = this.ghash(this._hashSubkey, this._j0, [rt.getInt32(), rt.getInt32(), rt.getInt32(), rt.getInt32()]);
        this._j0 = this.ghash(this._hashSubkey, this._j0, [0, 0].concat(nt(8 * it)));
      }
      this._inBlock = this._j0.slice(0), Ze(this._inBlock), this._partialBytes = 0, et = Ke.util.createBuffer(et), this._aDataLength = nt(8 * et.length());
      var ot = et.length() % this.blockSize;
      for (ot && et.fillWithByte(0, this.blockSize - ot), this._s = [0, 0, 0, 0]; et.length() > 0; ) this._s = this.ghash(this._hashSubkey, this._s, [et.getInt32(), et.getInt32(), et.getInt32(), et.getInt32()]);
    }, $e.gcm.prototype.encrypt = function(tt, et, rt) {
      var it = tt.length();
      if (it === 0) return !0;
      if (this.cipher.encrypt(this._inBlock, this._outBlock), this._partialBytes === 0 && it >= this.blockSize) {
        for (var ot = 0; ot < this._ints; ++ot) et.putInt32(this._outBlock[ot] ^= tt.getInt32());
        this._cipherLength += this.blockSize;
      } else {
        var at = (this.blockSize - it) % this.blockSize;
        for (at > 0 && (at = this.blockSize - at), this._partialOutput.clear(), ot = 0; ot < this._ints; ++ot) this._partialOutput.putInt32(tt.getInt32() ^ this._outBlock[ot]);
        if (at <= 0 || rt) {
          if (rt) {
            var st = it % this.blockSize;
            this._cipherLength += st, this._partialOutput.truncate(this.blockSize - st);
          } else this._cipherLength += this.blockSize;
          for (ot = 0; ot < this._ints; ++ot) this._outBlock[ot] = this._partialOutput.getInt32();
          this._partialOutput.read -= this.blockSize;
        }
        if (this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), at > 0 && !rt) return tt.read -= this.blockSize, et.putBytes(this._partialOutput.getBytes(at - this._partialBytes)), this._partialBytes = at, !0;
        et.putBytes(this._partialOutput.getBytes(it - this._partialBytes)), this._partialBytes = 0;
      }
      this._s = this.ghash(this._hashSubkey, this._s, this._outBlock), Ze(this._inBlock);
    }, $e.gcm.prototype.decrypt = function(tt, et, rt) {
      var it = tt.length();
      if (it < this.blockSize && !(rt && it > 0)) return !0;
      this.cipher.encrypt(this._inBlock, this._outBlock), Ze(this._inBlock), this._hashBlock[0] = tt.getInt32(), this._hashBlock[1] = tt.getInt32(), this._hashBlock[2] = tt.getInt32(), this._hashBlock[3] = tt.getInt32(), this._s = this.ghash(this._hashSubkey, this._s, this._hashBlock);
      for (var ot = 0; ot < this._ints; ++ot) et.putInt32(this._outBlock[ot] ^ this._hashBlock[ot]);
      it < this.blockSize ? this._cipherLength += it % this.blockSize : this._cipherLength += this.blockSize;
    }, $e.gcm.prototype.afterFinish = function(tt, et) {
      var rt = !0;
      et.decrypt && et.overflow && tt.truncate(this.blockSize - et.overflow), this.tag = Ke.util.createBuffer();
      var it = this._aDataLength.concat(nt(8 * this._cipherLength));
      this._s = this.ghash(this._hashSubkey, this._s, it);
      var ot = [];
      this.cipher.encrypt(this._j0, ot);
      for (var at = 0; at < this._ints; ++at) this.tag.putInt32(this._s[at] ^ ot[at]);
      return this.tag.truncate(this.tag.length() % (this._tagLength / 8)), et.decrypt && this.tag.bytes() !== this._tag && (rt = !1), rt;
    }, $e.gcm.prototype.multiply = function(tt, et) {
      for (var rt = [0, 0, 0, 0], it = et.slice(0), ot = 0; ot < 128; ++ot) tt[ot / 32 | 0] & 1 << 31 - ot % 32 && (rt[0] ^= it[0], rt[1] ^= it[1], rt[2] ^= it[2], rt[3] ^= it[3]), this.pow(it, it);
      return rt;
    }, $e.gcm.prototype.pow = function(tt, et) {
      for (var rt = 1 & tt[3], it = 3; it > 0; --it) et[it] = tt[it] >>> 1 | (1 & tt[it - 1]) << 31;
      et[0] = tt[0] >>> 1, rt && (et[0] ^= this._R);
    }, $e.gcm.prototype.tableMultiply = function(tt) {
      for (var et = [0, 0, 0, 0], rt = 0; rt < 32; ++rt) {
        var it = tt[rt / 8 | 0] >>> 4 * (7 - rt % 8) & 15, ot = this._m[rt][it];
        et[0] ^= ot[0], et[1] ^= ot[1], et[2] ^= ot[2], et[3] ^= ot[3];
      }
      return et;
    }, $e.gcm.prototype.ghash = function(tt, et, rt) {
      return et[0] ^= rt[0], et[1] ^= rt[1], et[2] ^= rt[2], et[3] ^= rt[3], this.tableMultiply(et);
    }, $e.gcm.prototype.generateHashTable = function(tt, et) {
      for (var rt = 8 / et, it = 4 * rt, ot = 16 * rt, at = new Array(ot), st = 0; st < ot; ++st) {
        var ut = [0, 0, 0, 0], lt = (it - 1 - st % it) * et;
        ut[st / it | 0] = 1 << et - 1 << lt, at[st] = this.generateSubHashTable(this.multiply(ut, tt), et);
      }
      return at;
    }, $e.gcm.prototype.generateSubHashTable = function(tt, et) {
      var rt = 1 << et, it = rt >>> 1, ot = new Array(rt);
      ot[it] = tt.slice(0);
      for (var at = it >>> 1; at > 0; ) this.pow(ot[2 * at], ot[at] = []), at >>= 1;
      for (at = 2; at < it; ) {
        for (var st = 1; st < at; ++st) {
          var ut = ot[at], lt = ot[st];
          ot[at + st] = [ut[0] ^ lt[0], ut[1] ^ lt[1], ut[2] ^ lt[2], ut[3] ^ lt[3]];
        }
        at *= 2;
      }
      for (ot[0] = [0, 0, 0, 0], at = it + 1; at < rt; ++at) {
        var dt = ot[at ^ it];
        ot[at] = [tt[0] ^ dt[0], tt[1] ^ dt[1], tt[2] ^ dt[2], tt[3] ^ dt[3]];
      }
      return ot;
    };
  }, 2023: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    function $e(ut, lt) {
      Ke.cipher.registerAlgorithm(ut, function() {
        return new Ke.des.Algorithm(ut, lt);
      });
    }
    Xe(4609), Xe(9554), Xe(3103), He.exports = Ke.des = Ke.des || {}, Ke.des.startEncrypting = function(ut, lt, dt, At) {
      var pt = st({ key: ut, output: dt, decrypt: !1, mode: At || (lt === null ? "ECB" : "CBC") });
      return pt.start(lt), pt;
    }, Ke.des.createEncryptionCipher = function(ut, lt) {
      return st({ key: ut, output: null, decrypt: !1, mode: lt });
    }, Ke.des.startDecrypting = function(ut, lt, dt, At) {
      var pt = st({ key: ut, output: dt, decrypt: !0, mode: At || (lt === null ? "ECB" : "CBC") });
      return pt.start(lt), pt;
    }, Ke.des.createDecryptionCipher = function(ut, lt) {
      return st({ key: ut, output: null, decrypt: !0, mode: lt });
    }, Ke.des.Algorithm = function(ut, lt) {
      var dt = this;
      dt.name = ut, dt.mode = new lt({ blockSize: 8, cipher: { encrypt: function(At, pt) {
        return at(dt._keys, At, pt, !1);
      }, decrypt: function(At, pt) {
        return at(dt._keys, At, pt, !0);
      } } }), dt._init = !1;
    }, Ke.des.Algorithm.prototype.initialize = function(ut) {
      if (!this._init) {
        var lt = Ke.util.createBuffer(ut.key);
        if (this.name.indexOf("3DES") === 0 && lt.length() !== 24) throw new Error("Invalid Triple-DES key size: " + 8 * lt.length());
        this._keys = function(dt) {
          for (var At, pt = [0, 4, 536870912, 536870916, 65536, 65540, 536936448, 536936452, 512, 516, 536871424, 536871428, 66048, 66052, 536936960, 536936964], gt = [0, 1, 1048576, 1048577, 67108864, 67108865, 68157440, 68157441, 256, 257, 1048832, 1048833, 67109120, 67109121, 68157696, 68157697], wt = [0, 8, 2048, 2056, 16777216, 16777224, 16779264, 16779272, 0, 8, 2048, 2056, 16777216, 16777224, 16779264, 16779272], Bt = [0, 2097152, 134217728, 136314880, 8192, 2105344, 134225920, 136323072, 131072, 2228224, 134348800, 136445952, 139264, 2236416, 134356992, 136454144], Tt = [0, 262144, 16, 262160, 0, 262144, 16, 262160, 4096, 266240, 4112, 266256, 4096, 266240, 4112, 266256], yt = [0, 1024, 32, 1056, 0, 1024, 32, 1056, 33554432, 33555456, 33554464, 33555488, 33554432, 33555456, 33554464, 33555488], Ct = [0, 268435456, 524288, 268959744, 2, 268435458, 524290, 268959746, 0, 268435456, 524288, 268959744, 2, 268435458, 524290, 268959746], ht = [0, 65536, 2048, 67584, 536870912, 536936448, 536872960, 536938496, 131072, 196608, 133120, 198656, 537001984, 537067520, 537004032, 537069568], It = [0, 262144, 0, 262144, 2, 262146, 2, 262146, 33554432, 33816576, 33554432, 33816576, 33554434, 33816578, 33554434, 33816578], vt = [0, 268435456, 8, 268435464, 0, 268435456, 8, 268435464, 1024, 268436480, 1032, 268436488, 1024, 268436480, 1032, 268436488], Et = [0, 32, 0, 32, 1048576, 1048608, 1048576, 1048608, 8192, 8224, 8192, 8224, 1056768, 1056800, 1056768, 1056800], bt = [0, 16777216, 512, 16777728, 2097152, 18874368, 2097664, 18874880, 67108864, 83886080, 67109376, 83886592, 69206016, 85983232, 69206528, 85983744], Rt = [0, 4096, 134217728, 134221824, 524288, 528384, 134742016, 134746112, 16, 4112, 134217744, 134221840, 524304, 528400, 134742032, 134746128], St = [0, 4, 256, 260, 0, 4, 256, 260, 1, 5, 257, 261, 1, 5, 257, 261], kt = dt.length() > 8 ? 3 : 1, jt = [], Pt = [0, 0, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 0], Qt = 0, qt = 0; qt < kt; qt++) {
            var _t = dt.getInt32(), Yt = dt.getInt32();
            _t ^= (At = 252645135 & (_t >>> 4 ^ Yt)) << 4, _t ^= At = 65535 & ((Yt ^= At) >>> -16 ^ _t), _t ^= (At = 858993459 & (_t >>> 2 ^ (Yt ^= At << -16))) << 2, _t ^= At = 65535 & ((Yt ^= At) >>> -16 ^ _t), _t ^= (At = 1431655765 & (_t >>> 1 ^ (Yt ^= At << -16))) << 1, _t ^= At = 16711935 & ((Yt ^= At) >>> 8 ^ _t), At = (_t ^= (At = 1431655765 & (_t >>> 1 ^ (Yt ^= At << 8))) << 1) << 8 | (Yt ^= At) >>> 20 & 240, _t = Yt << 24 | Yt << 8 & 16711680 | Yt >>> 8 & 65280 | Yt >>> 24 & 240, Yt = At;
            for (var Xt = 0; Xt < Pt.length; ++Xt) {
              Pt[Xt] ? (_t = _t << 2 | _t >>> 26, Yt = Yt << 2 | Yt >>> 26) : (_t = _t << 1 | _t >>> 27, Yt = Yt << 1 | Yt >>> 27);
              var Ut = pt[(_t &= -15) >>> 28] | gt[_t >>> 24 & 15] | wt[_t >>> 20 & 15] | Bt[_t >>> 16 & 15] | Tt[_t >>> 12 & 15] | yt[_t >>> 8 & 15] | Ct[_t >>> 4 & 15], Lt = ht[(Yt &= -15) >>> 28] | It[Yt >>> 24 & 15] | vt[Yt >>> 20 & 15] | Et[Yt >>> 16 & 15] | bt[Yt >>> 12 & 15] | Rt[Yt >>> 8 & 15] | St[Yt >>> 4 & 15];
              At = 65535 & (Lt >>> 16 ^ Ut), jt[Qt++] = Ut ^ At, jt[Qt++] = Lt ^ At << 16;
            }
          }
          return jt;
        }(lt), this._init = !0;
      }
    }, $e("DES-ECB", Ke.cipher.modes.ecb), $e("DES-CBC", Ke.cipher.modes.cbc), $e("DES-CFB", Ke.cipher.modes.cfb), $e("DES-OFB", Ke.cipher.modes.ofb), $e("DES-CTR", Ke.cipher.modes.ctr), $e("3DES-ECB", Ke.cipher.modes.ecb), $e("3DES-CBC", Ke.cipher.modes.cbc), $e("3DES-CFB", Ke.cipher.modes.cfb), $e("3DES-OFB", Ke.cipher.modes.ofb), $e("3DES-CTR", Ke.cipher.modes.ctr);
    var Je = [16843776, 0, 65536, 16843780, 16842756, 66564, 4, 65536, 1024, 16843776, 16843780, 1024, 16778244, 16842756, 16777216, 4, 1028, 16778240, 16778240, 66560, 66560, 16842752, 16842752, 16778244, 65540, 16777220, 16777220, 65540, 0, 1028, 66564, 16777216, 65536, 16843780, 4, 16842752, 16843776, 16777216, 16777216, 1024, 16842756, 65536, 66560, 16777220, 1024, 4, 16778244, 66564, 16843780, 65540, 16842752, 16778244, 16777220, 1028, 66564, 16843776, 1028, 16778240, 16778240, 0, 65540, 66560, 0, 16842756], Ze = [-2146402272, -2147450880, 32768, 1081376, 1048576, 32, -2146435040, -2147450848, -2147483616, -2146402272, -2146402304, -2147483648, -2147450880, 1048576, 32, -2146435040, 1081344, 1048608, -2147450848, 0, -2147483648, 32768, 1081376, -2146435072, 1048608, -2147483616, 0, 1081344, 32800, -2146402304, -2146435072, 32800, 0, 1081376, -2146435040, 1048576, -2147450848, -2146435072, -2146402304, 32768, -2146435072, -2147450880, 32, -2146402272, 1081376, 32, 32768, -2147483648, 32800, -2146402304, 1048576, -2147483616, 1048608, -2147450848, -2147483616, 1048608, 1081344, 0, -2147450880, 32800, -2147483648, -2146435040, -2146402272, 1081344], nt = [520, 134349312, 0, 134348808, 134218240, 0, 131592, 134218240, 131080, 134217736, 134217736, 131072, 134349320, 131080, 134348800, 520, 134217728, 8, 134349312, 512, 131584, 134348800, 134348808, 131592, 134218248, 131584, 131072, 134218248, 8, 134349320, 512, 134217728, 134349312, 134217728, 131080, 520, 131072, 134349312, 134218240, 0, 512, 131080, 134349320, 134218240, 134217736, 512, 0, 134348808, 134218248, 131072, 134217728, 134349320, 8, 131592, 131584, 134217736, 134348800, 134218248, 520, 134348800, 131592, 8, 134348808, 131584], tt = [8396801, 8321, 8321, 128, 8396928, 8388737, 8388609, 8193, 0, 8396800, 8396800, 8396929, 129, 0, 8388736, 8388609, 1, 8192, 8388608, 8396801, 128, 8388608, 8193, 8320, 8388737, 1, 8320, 8388736, 8192, 8396928, 8396929, 129, 8388736, 8388609, 8396800, 8396929, 129, 0, 0, 8396800, 8320, 8388736, 8388737, 1, 8396801, 8321, 8321, 128, 8396929, 129, 1, 8192, 8388609, 8193, 8396928, 8388737, 8193, 8320, 8388608, 8396801, 128, 8388608, 8192, 8396928], et = [256, 34078976, 34078720, 1107296512, 524288, 256, 1073741824, 34078720, 1074266368, 524288, 33554688, 1074266368, 1107296512, 1107820544, 524544, 1073741824, 33554432, 1074266112, 1074266112, 0, 1073742080, 1107820800, 1107820800, 33554688, 1107820544, 1073742080, 0, 1107296256, 34078976, 33554432, 1107296256, 524544, 524288, 1107296512, 256, 33554432, 1073741824, 34078720, 1107296512, 1074266368, 33554688, 1073741824, 1107820544, 34078976, 1074266368, 256, 33554432, 1107820544, 1107820800, 524544, 1107296256, 1107820800, 34078720, 0, 1074266112, 1107296256, 524544, 33554688, 1073742080, 524288, 0, 1074266112, 34078976, 1073742080], rt = [536870928, 541065216, 16384, 541081616, 541065216, 16, 541081616, 4194304, 536887296, 4210704, 4194304, 536870928, 4194320, 536887296, 536870912, 16400, 0, 4194320, 536887312, 16384, 4210688, 536887312, 16, 541065232, 541065232, 0, 4210704, 541081600, 16400, 4210688, 541081600, 536870912, 536887296, 16, 541065232, 4210688, 541081616, 4194304, 16400, 536870928, 4194304, 536887296, 536870912, 16400, 536870928, 541081616, 4210688, 541065216, 4210704, 541081600, 0, 541065232, 16, 16384, 541065216, 4210704, 16384, 4194320, 536887312, 0, 541081600, 536870912, 4194320, 536887312], it = [2097152, 69206018, 67110914, 0, 2048, 67110914, 2099202, 69208064, 69208066, 2097152, 0, 67108866, 2, 67108864, 69206018, 2050, 67110912, 2099202, 2097154, 67110912, 67108866, 69206016, 69208064, 2097154, 69206016, 2048, 2050, 69208066, 2099200, 2, 67108864, 2099200, 67108864, 2099200, 2097152, 67110914, 67110914, 69206018, 69206018, 2, 2097154, 67108864, 67110912, 2097152, 69208064, 2050, 2099202, 69208064, 2050, 67108866, 69208066, 69206016, 2099200, 0, 2, 69208066, 0, 2099202, 69206016, 2048, 67108866, 67110912, 2048, 2097154], ot = [268439616, 4096, 262144, 268701760, 268435456, 268439616, 64, 268435456, 262208, 268697600, 268701760, 266240, 268701696, 266304, 4096, 64, 268697600, 268435520, 268439552, 4160, 266240, 262208, 268697664, 268701696, 4160, 0, 0, 268697664, 268435520, 268439552, 266304, 262144, 266304, 262144, 268701696, 4096, 64, 268697664, 4096, 266304, 268439552, 64, 268435520, 268697600, 268697664, 268435456, 262144, 268439616, 0, 268701760, 262208, 268435520, 268697600, 268439552, 268439616, 0, 268701760, 266240, 266240, 4160, 4160, 262208, 268435456, 268701696];
    function at(ut, lt, dt, At) {
      var pt, gt, wt = ut.length === 32 ? 3 : 9;
      pt = wt === 3 ? At ? [30, -2, -2] : [0, 32, 2] : At ? [94, 62, -2, 32, 64, 2, 30, -2, -2] : [0, 32, 2, 62, 30, -2, 64, 96, 2];
      var Bt = lt[0], Tt = lt[1];
      Bt ^= (gt = 252645135 & (Bt >>> 4 ^ Tt)) << 4, Bt ^= (gt = 65535 & (Bt >>> 16 ^ (Tt ^= gt))) << 16, Bt ^= gt = 858993459 & ((Tt ^= gt) >>> 2 ^ Bt), Bt ^= gt = 16711935 & ((Tt ^= gt << 2) >>> 8 ^ Bt), Bt = (Bt ^= (gt = 1431655765 & (Bt >>> 1 ^ (Tt ^= gt << 8))) << 1) << 1 | Bt >>> 31, Tt = (Tt ^= gt) << 1 | Tt >>> 31;
      for (var yt = 0; yt < wt; yt += 3) {
        for (var Ct = pt[yt + 1], ht = pt[yt + 2], It = pt[yt]; It != Ct; It += ht) {
          var vt = Tt ^ ut[It], Et = (Tt >>> 4 | Tt << 28) ^ ut[It + 1];
          gt = Bt, Bt = Tt, Tt = gt ^ (Ze[vt >>> 24 & 63] | tt[vt >>> 16 & 63] | rt[vt >>> 8 & 63] | ot[63 & vt] | Je[Et >>> 24 & 63] | nt[Et >>> 16 & 63] | et[Et >>> 8 & 63] | it[63 & Et]);
        }
        gt = Bt, Bt = Tt, Tt = gt;
      }
      Tt = Tt >>> 1 | Tt << 31, Tt ^= gt = 1431655765 & ((Bt = Bt >>> 1 | Bt << 31) >>> 1 ^ Tt), Tt ^= (gt = 16711935 & (Tt >>> 8 ^ (Bt ^= gt << 1))) << 8, Tt ^= (gt = 858993459 & (Tt >>> 2 ^ (Bt ^= gt))) << 2, Tt ^= gt = 65535 & ((Bt ^= gt) >>> 16 ^ Tt), Tt ^= gt = 252645135 & ((Bt ^= gt << 16) >>> 4 ^ Tt), Bt ^= gt << 4, dt[0] = Bt, dt[1] = Tt;
    }
    function st(ut) {
      var lt, dt = "DES-" + ((ut = ut || {}).mode || "CBC").toUpperCase(), At = (lt = ut.decrypt ? Ke.cipher.createDecipher(dt, ut.key) : Ke.cipher.createCipher(dt, ut.key)).start;
      return lt.start = function(pt, gt) {
        var wt = null;
        gt instanceof Ke.util.ByteBuffer && (wt = gt, gt = {}), (gt = gt || {}).output = wt, gt.iv = pt, At.call(lt, gt);
      }, lt;
    }
  }, 2554: (He, Ge, Xe) => {
    var Ke = Xe(7573).Buffer, $e = Xe(7768);
    Xe(1633), Xe(4097), Xe(8672), Xe(3103);
    var Je = Xe(5235), Ze = Je.publicKeyValidator, nt = Je.privateKeyValidator;
    if (tt === void 0) var tt = $e.jsbn.BigInteger;
    var et = $e.util.ByteBuffer, rt = Ke === void 0 ? Uint8Array : Ke;
    $e.pki = $e.pki || {}, He.exports = $e.pki.ed25519 = $e.ed25519 = $e.ed25519 || {};
    var it = $e.ed25519;
    function ot(Ut) {
      var Lt = Ut.message;
      if (Lt instanceof Uint8Array || Lt instanceof rt) return Lt;
      var Ot = Ut.encoding;
      if (Lt === void 0) {
        if (!Ut.md) throw new TypeError('"options.message" or "options.md" not specified.');
        Lt = Ut.md.digest().getBytes(), Ot = "binary";
      }
      if (typeof Lt == "string" && !Ot) throw new TypeError('"options.encoding" must be "binary" or "utf8".');
      if (typeof Lt == "string") {
        if (Ke !== void 0) return Ke.from(Lt, Ot);
        Lt = new et(Lt, Ot);
      } else if (!(Lt instanceof et)) throw new TypeError('"options.message" must be a node.js Buffer, a Uint8Array, a forge ByteBuffer, or a string with "options.encoding" specifying its encoding.');
      for (var ft = new rt(Lt.length()), Dt = 0; Dt < ft.length; ++Dt) ft[Dt] = Lt.at(Dt);
      return ft;
    }
    it.constants = {}, it.constants.PUBLIC_KEY_BYTE_LENGTH = 32, it.constants.PRIVATE_KEY_BYTE_LENGTH = 64, it.constants.SEED_BYTE_LENGTH = 32, it.constants.SIGN_BYTE_LENGTH = 64, it.constants.HASH_BYTE_LENGTH = 64, it.generateKeyPair = function(Ut) {
      var Lt = (Ut = Ut || {}).seed;
      if (Lt === void 0) Lt = $e.random.getBytesSync(it.constants.SEED_BYTE_LENGTH);
      else if (typeof Lt == "string") {
        if (Lt.length !== it.constants.SEED_BYTE_LENGTH) throw new TypeError('"seed" must be ' + it.constants.SEED_BYTE_LENGTH + " bytes in length.");
      } else if (!(Lt instanceof Uint8Array)) throw new TypeError('"seed" must be a node.js Buffer, Uint8Array, or a binary string.');
      Lt = ot({ message: Lt, encoding: "binary" });
      for (var Ot = new rt(it.constants.PUBLIC_KEY_BYTE_LENGTH), ft = new rt(it.constants.PRIVATE_KEY_BYTE_LENGTH), Dt = 0; Dt < 32; ++Dt) ft[Dt] = Lt[Dt];
      return function(Mt, Ft) {
        var Gt, zt = [Qt(), Qt(), Qt(), Qt()], $t = wt(Ft, 32);
        for ($t[0] &= 248, $t[31] &= 127, $t[31] |= 64, St(zt, $t), ht(Mt, zt), Gt = 0; Gt < 32; ++Gt) Ft[Gt + 32] = Mt[Gt];
      }(Ot, ft), { publicKey: Ot, privateKey: ft };
    }, it.privateKeyFromAsn1 = function(Ut) {
      var Lt = {}, Ot = [];
      if (!$e.asn1.validate(Ut, nt, Lt, Ot)) {
        var ft = new Error("Invalid Key.");
        throw ft.errors = Ot, ft;
      }
      var Dt = $e.asn1.derToOid(Lt.privateKeyOid), Mt = $e.oids.EdDSA25519;
      if (Dt !== Mt) throw new Error('Invalid OID "' + Dt + '"; OID must be "' + Mt + '".');
      var Ft = Lt.privateKey;
      return { privateKeyBytes: ot({ message: $e.asn1.fromDer(Ft).value, encoding: "binary" }) };
    }, it.publicKeyFromAsn1 = function(Ut) {
      var Lt = {}, Ot = [];
      if (!$e.asn1.validate(Ut, Ze, Lt, Ot)) {
        var ft = new Error("Invalid Key.");
        throw ft.errors = Ot, ft;
      }
      var Dt = $e.asn1.derToOid(Lt.publicKeyOid), Mt = $e.oids.EdDSA25519;
      if (Dt !== Mt) throw new Error('Invalid OID "' + Dt + '"; OID must be "' + Mt + '".');
      var Ft = Lt.ed25519PublicKey;
      if (Ft.length !== it.constants.PUBLIC_KEY_BYTE_LENGTH) throw new Error("Key length is invalid.");
      return ot({ message: Ft, encoding: "binary" });
    }, it.publicKeyFromPrivateKey = function(Ut) {
      var Lt = ot({ message: (Ut = Ut || {}).privateKey, encoding: "binary" });
      if (Lt.length !== it.constants.PRIVATE_KEY_BYTE_LENGTH) throw new TypeError('"options.privateKey" must have a byte length of ' + it.constants.PRIVATE_KEY_BYTE_LENGTH);
      for (var Ot = new rt(it.constants.PUBLIC_KEY_BYTE_LENGTH), ft = 0; ft < Ot.length; ++ft) Ot[ft] = Lt[32 + ft];
      return Ot;
    }, it.sign = function(Ut) {
      var Lt = ot(Ut = Ut || {}), Ot = ot({ message: Ut.privateKey, encoding: "binary" });
      if (Ot.length === it.constants.SEED_BYTE_LENGTH) Ot = it.generateKeyPair({ seed: Ot }).privateKey;
      else if (Ot.length !== it.constants.PRIVATE_KEY_BYTE_LENGTH) throw new TypeError('"options.privateKey" must have a byte length of ' + it.constants.SEED_BYTE_LENGTH + " or " + it.constants.PRIVATE_KEY_BYTE_LENGTH);
      var ft = new rt(it.constants.SIGN_BYTE_LENGTH + Lt.length);
      (function(Ft, Gt, zt, $t) {
        var Ht, hn, un = new Float64Array(64), An = [Qt(), Qt(), Qt(), Qt()], mn = wt($t, 32);
        for (mn[0] &= 248, mn[31] &= 127, mn[31] |= 64, Ht = 0; Ht < zt; ++Ht) Ft[64 + Ht] = Gt[Ht];
        for (Ht = 0; Ht < 32; ++Ht) Ft[32 + Ht] = mn[32 + Ht];
        var En = wt(Ft.subarray(32), zt + 32);
        for (Tt(En), St(An, En), ht(Ft, An), Ht = 32; Ht < 64; ++Ht) Ft[Ht] = $t[Ht];
        var Jt = wt(Ft, zt + 64);
        for (Tt(Jt), Ht = 32; Ht < 64; ++Ht) un[Ht] = 0;
        for (Ht = 0; Ht < 32; ++Ht) un[Ht] = En[Ht];
        for (Ht = 0; Ht < 32; ++Ht) for (hn = 0; hn < 32; hn++) un[Ht + hn] += Jt[Ht] * mn[hn];
        Bt(Ft.subarray(32), un);
      })(ft, Lt, Lt.length, Ot);
      for (var Dt = new rt(it.constants.SIGN_BYTE_LENGTH), Mt = 0; Mt < Dt.length; ++Mt) Dt[Mt] = ft[Mt];
      return Dt;
    }, it.verify = function(Ut) {
      var Lt = ot(Ut = Ut || {});
      if (Ut.signature === void 0) throw new TypeError('"options.signature" must be a node.js Buffer, a Uint8Array, a forge ByteBuffer, or a binary string.');
      var Ot = ot({ message: Ut.signature, encoding: "binary" });
      if (Ot.length !== it.constants.SIGN_BYTE_LENGTH) throw new TypeError('"options.signature" must have a byte length of ' + it.constants.SIGN_BYTE_LENGTH);
      var ft = ot({ message: Ut.publicKey, encoding: "binary" });
      if (ft.length !== it.constants.PUBLIC_KEY_BYTE_LENGTH) throw new TypeError('"options.publicKey" must have a byte length of ' + it.constants.PUBLIC_KEY_BYTE_LENGTH);
      var Dt, Mt = new rt(it.constants.SIGN_BYTE_LENGTH + Lt.length), Ft = new rt(it.constants.SIGN_BYTE_LENGTH + Lt.length);
      for (Dt = 0; Dt < it.constants.SIGN_BYTE_LENGTH; ++Dt) Mt[Dt] = Ot[Dt];
      for (Dt = 0; Dt < Lt.length; ++Dt) Mt[Dt + it.constants.SIGN_BYTE_LENGTH] = Lt[Dt];
      return function(Gt, zt, $t, Ht) {
        var hn, un = new rt(32), An = [Qt(), Qt(), Qt(), Qt()], mn = [Qt(), Qt(), Qt(), Qt()];
        if ($t < 64 || function(Jt, an) {
          var cn = Qt(), dn = Qt(), yn = Qt(), Nn = Qt(), Rn = Qt(), rn = Qt(), ln = Qt();
          return kt(Jt[2], st), function(pn, Sn) {
            var In;
            for (In = 0; In < 16; ++In) pn[In] = Sn[2 * In] + (Sn[2 * In + 1] << 8);
            pn[15] &= 32767;
          }(Jt[1], an), Yt(yn, Jt[1]), Xt(Nn, yn, ut), _t(yn, yn, Jt[2]), qt(Nn, Jt[2], Nn), Yt(Rn, Nn), Yt(rn, Rn), Xt(ln, rn, Rn), Xt(cn, ln, yn), Xt(cn, cn, Nn), function(pn, Sn) {
            var In, Bn = Qt();
            for (In = 0; In < 16; ++In) Bn[In] = Sn[In];
            for (In = 250; In >= 0; --In) Yt(Bn, Bn), In !== 1 && Xt(Bn, Bn, Sn);
            for (In = 0; In < 16; ++In) pn[In] = Bn[In];
          }(cn, cn), Xt(cn, cn, yn), Xt(cn, cn, Nn), Xt(cn, cn, Nn), Xt(Jt[0], cn, Nn), Yt(dn, Jt[0]), Xt(dn, dn, Nn), vt(dn, yn) && Xt(Jt[0], Jt[0], gt), Yt(dn, Jt[0]), Xt(dn, dn, Nn), vt(dn, yn) ? -1 : (bt(Jt[0]) === an[31] >> 7 && _t(Jt[0], at, Jt[0]), Xt(Jt[3], Jt[0], Jt[1]), 0);
        }(mn, Ht)) return -1;
        for (hn = 0; hn < $t; ++hn) Gt[hn] = zt[hn];
        for (hn = 0; hn < 32; ++hn) Gt[hn + 32] = Ht[hn];
        var En = wt(Gt, $t);
        if (Tt(En), Rt(An, mn, En), St(mn, zt.subarray(32)), yt(An, mn), ht(un, An), $t -= 64, Et(zt, 0, un, 0)) {
          for (hn = 0; hn < $t; ++hn) Gt[hn] = 0;
          return -1;
        }
        for (hn = 0; hn < $t; ++hn) Gt[hn] = zt[hn + 64];
        return $t;
      }(Ft, Mt, Mt.length, ft) >= 0;
    };
    var at = Qt(), st = Qt([1]), ut = Qt([30883, 4953, 19914, 30187, 55467, 16705, 2637, 112, 59544, 30585, 16505, 36039, 65139, 11119, 27886, 20995]), lt = Qt([61785, 9906, 39828, 60374, 45398, 33411, 5274, 224, 53552, 61171, 33010, 6542, 64743, 22239, 55772, 9222]), dt = Qt([54554, 36645, 11616, 51542, 42930, 38181, 51040, 26924, 56412, 64982, 57905, 49316, 21502, 52590, 14035, 8553]), At = Qt([26200, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214]), pt = new Float64Array([237, 211, 245, 92, 26, 99, 18, 88, 214, 156, 247, 162, 222, 249, 222, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16]), gt = Qt([41136, 18958, 6951, 50414, 58488, 44335, 6150, 12099, 55207, 15867, 153, 11085, 57099, 20417, 9344, 11139]);
    function wt(Ut, Lt) {
      var Ot = $e.md.sha512.create(), ft = new et(Ut);
      Ot.update(ft.getBytes(Lt), "binary");
      var Dt = Ot.digest().getBytes();
      if (Ke !== void 0) return Ke.from(Dt, "binary");
      for (var Mt = new rt(it.constants.HASH_BYTE_LENGTH), Ft = 0; Ft < 64; ++Ft) Mt[Ft] = Dt.charCodeAt(Ft);
      return Mt;
    }
    function Bt(Ut, Lt) {
      var Ot, ft, Dt, Mt;
      for (ft = 63; ft >= 32; --ft) {
        for (Ot = 0, Dt = ft - 32, Mt = ft - 12; Dt < Mt; ++Dt) Lt[Dt] += Ot - 16 * Lt[ft] * pt[Dt - (ft - 32)], Ot = Lt[Dt] + 128 >> 8, Lt[Dt] -= 256 * Ot;
        Lt[Dt] += Ot, Lt[ft] = 0;
      }
      for (Ot = 0, Dt = 0; Dt < 32; ++Dt) Lt[Dt] += Ot - (Lt[31] >> 4) * pt[Dt], Ot = Lt[Dt] >> 8, Lt[Dt] &= 255;
      for (Dt = 0; Dt < 32; ++Dt) Lt[Dt] -= Ot * pt[Dt];
      for (ft = 0; ft < 32; ++ft) Lt[ft + 1] += Lt[ft] >> 8, Ut[ft] = 255 & Lt[ft];
    }
    function Tt(Ut) {
      for (var Lt = new Float64Array(64), Ot = 0; Ot < 64; ++Ot) Lt[Ot] = Ut[Ot], Ut[Ot] = 0;
      Bt(Ut, Lt);
    }
    function yt(Ut, Lt) {
      var Ot = Qt(), ft = Qt(), Dt = Qt(), Mt = Qt(), Ft = Qt(), Gt = Qt(), zt = Qt(), $t = Qt(), Ht = Qt();
      _t(Ot, Ut[1], Ut[0]), _t(Ht, Lt[1], Lt[0]), Xt(Ot, Ot, Ht), qt(ft, Ut[0], Ut[1]), qt(Ht, Lt[0], Lt[1]), Xt(ft, ft, Ht), Xt(Dt, Ut[3], Lt[3]), Xt(Dt, Dt, lt), Xt(Mt, Ut[2], Lt[2]), qt(Mt, Mt, Mt), _t(Ft, ft, Ot), _t(Gt, Mt, Dt), qt(zt, Mt, Dt), qt($t, ft, Ot), Xt(Ut[0], Ft, Gt), Xt(Ut[1], $t, zt), Xt(Ut[2], zt, Gt), Xt(Ut[3], Ft, $t);
    }
    function Ct(Ut, Lt, Ot) {
      for (var ft = 0; ft < 4; ++ft) Pt(Ut[ft], Lt[ft], Ot);
    }
    function ht(Ut, Lt) {
      var Ot = Qt(), ft = Qt(), Dt = Qt();
      (function(Mt, Ft) {
        var Gt, zt = Qt();
        for (Gt = 0; Gt < 16; ++Gt) zt[Gt] = Ft[Gt];
        for (Gt = 253; Gt >= 0; --Gt) Yt(zt, zt), Gt !== 2 && Gt !== 4 && Xt(zt, zt, Ft);
        for (Gt = 0; Gt < 16; ++Gt) Mt[Gt] = zt[Gt];
      })(Dt, Lt[2]), Xt(Ot, Lt[0], Dt), Xt(ft, Lt[1], Dt), It(Ut, ft), Ut[31] ^= bt(Ot) << 7;
    }
    function It(Ut, Lt) {
      var Ot, ft, Dt, Mt = Qt(), Ft = Qt();
      for (Ot = 0; Ot < 16; ++Ot) Ft[Ot] = Lt[Ot];
      for (jt(Ft), jt(Ft), jt(Ft), ft = 0; ft < 2; ++ft) {
        for (Mt[0] = Ft[0] - 65517, Ot = 1; Ot < 15; ++Ot) Mt[Ot] = Ft[Ot] - 65535 - (Mt[Ot - 1] >> 16 & 1), Mt[Ot - 1] &= 65535;
        Mt[15] = Ft[15] - 32767 - (Mt[14] >> 16 & 1), Dt = Mt[15] >> 16 & 1, Mt[14] &= 65535, Pt(Ft, Mt, 1 - Dt);
      }
      for (Ot = 0; Ot < 16; Ot++) Ut[2 * Ot] = 255 & Ft[Ot], Ut[2 * Ot + 1] = Ft[Ot] >> 8;
    }
    function vt(Ut, Lt) {
      var Ot = new rt(32), ft = new rt(32);
      return It(Ot, Ut), It(ft, Lt), Et(Ot, 0, ft, 0);
    }
    function Et(Ut, Lt, Ot, ft) {
      return function(Dt, Mt, Ft, Gt, zt) {
        var $t, Ht = 0;
        for ($t = 0; $t < 32; ++$t) Ht |= Dt[Mt + $t] ^ Ft[Gt + $t];
        return (1 & Ht - 1 >>> 8) - 1;
      }(Ut, Lt, Ot, ft);
    }
    function bt(Ut) {
      var Lt = new rt(32);
      return It(Lt, Ut), 1 & Lt[0];
    }
    function Rt(Ut, Lt, Ot) {
      var ft, Dt;
      for (kt(Ut[0], at), kt(Ut[1], st), kt(Ut[2], st), kt(Ut[3], at), Dt = 255; Dt >= 0; --Dt) Ct(Ut, Lt, ft = Ot[Dt / 8 | 0] >> (7 & Dt) & 1), yt(Lt, Ut), yt(Ut, Ut), Ct(Ut, Lt, ft);
    }
    function St(Ut, Lt) {
      var Ot = [Qt(), Qt(), Qt(), Qt()];
      kt(Ot[0], dt), kt(Ot[1], At), kt(Ot[2], st), Xt(Ot[3], dt, At), Rt(Ut, Ot, Lt);
    }
    function kt(Ut, Lt) {
      var Ot;
      for (Ot = 0; Ot < 16; Ot++) Ut[Ot] = 0 | Lt[Ot];
    }
    function jt(Ut) {
      var Lt, Ot, ft = 1;
      for (Lt = 0; Lt < 16; ++Lt) Ot = Ut[Lt] + ft + 65535, ft = Math.floor(Ot / 65536), Ut[Lt] = Ot - 65536 * ft;
      Ut[0] += ft - 1 + 37 * (ft - 1);
    }
    function Pt(Ut, Lt, Ot) {
      for (var ft, Dt = ~(Ot - 1), Mt = 0; Mt < 16; ++Mt) ft = Dt & (Ut[Mt] ^ Lt[Mt]), Ut[Mt] ^= ft, Lt[Mt] ^= ft;
    }
    function Qt(Ut) {
      var Lt, Ot = new Float64Array(16);
      if (Ut) for (Lt = 0; Lt < Ut.length; ++Lt) Ot[Lt] = Ut[Lt];
      return Ot;
    }
    function qt(Ut, Lt, Ot) {
      for (var ft = 0; ft < 16; ++ft) Ut[ft] = Lt[ft] + Ot[ft];
    }
    function _t(Ut, Lt, Ot) {
      for (var ft = 0; ft < 16; ++ft) Ut[ft] = Lt[ft] - Ot[ft];
    }
    function Yt(Ut, Lt) {
      Xt(Ut, Lt, Lt);
    }
    function Xt(Ut, Lt, Ot) {
      var ft, Dt, Mt = 0, Ft = 0, Gt = 0, zt = 0, $t = 0, Ht = 0, hn = 0, un = 0, An = 0, mn = 0, En = 0, Jt = 0, an = 0, cn = 0, dn = 0, yn = 0, Nn = 0, Rn = 0, rn = 0, ln = 0, pn = 0, Sn = 0, In = 0, Bn = 0, Pn = 0, Yn = 0, or = 0, mr = 0, lr = 0, Mr = 0, ai = 0, Un = Ot[0], qn = Ot[1], hr = Ot[2], Vr = Ot[3], Pr = Ot[4], Er = Ot[5], xr = Ot[6], kr = Ot[7], Rr = Ot[8], sr = Ot[9], br = Ot[10], Gr = Ot[11], on = Ot[12], bn = Ot[13], vn = Ot[14], Ln = Ot[15];
      Mt += (ft = Lt[0]) * Un, Ft += ft * qn, Gt += ft * hr, zt += ft * Vr, $t += ft * Pr, Ht += ft * Er, hn += ft * xr, un += ft * kr, An += ft * Rr, mn += ft * sr, En += ft * br, Jt += ft * Gr, an += ft * on, cn += ft * bn, dn += ft * vn, yn += ft * Ln, Ft += (ft = Lt[1]) * Un, Gt += ft * qn, zt += ft * hr, $t += ft * Vr, Ht += ft * Pr, hn += ft * Er, un += ft * xr, An += ft * kr, mn += ft * Rr, En += ft * sr, Jt += ft * br, an += ft * Gr, cn += ft * on, dn += ft * bn, yn += ft * vn, Nn += ft * Ln, Gt += (ft = Lt[2]) * Un, zt += ft * qn, $t += ft * hr, Ht += ft * Vr, hn += ft * Pr, un += ft * Er, An += ft * xr, mn += ft * kr, En += ft * Rr, Jt += ft * sr, an += ft * br, cn += ft * Gr, dn += ft * on, yn += ft * bn, Nn += ft * vn, Rn += ft * Ln, zt += (ft = Lt[3]) * Un, $t += ft * qn, Ht += ft * hr, hn += ft * Vr, un += ft * Pr, An += ft * Er, mn += ft * xr, En += ft * kr, Jt += ft * Rr, an += ft * sr, cn += ft * br, dn += ft * Gr, yn += ft * on, Nn += ft * bn, Rn += ft * vn, rn += ft * Ln, $t += (ft = Lt[4]) * Un, Ht += ft * qn, hn += ft * hr, un += ft * Vr, An += ft * Pr, mn += ft * Er, En += ft * xr, Jt += ft * kr, an += ft * Rr, cn += ft * sr, dn += ft * br, yn += ft * Gr, Nn += ft * on, Rn += ft * bn, rn += ft * vn, ln += ft * Ln, Ht += (ft = Lt[5]) * Un, hn += ft * qn, un += ft * hr, An += ft * Vr, mn += ft * Pr, En += ft * Er, Jt += ft * xr, an += ft * kr, cn += ft * Rr, dn += ft * sr, yn += ft * br, Nn += ft * Gr, Rn += ft * on, rn += ft * bn, ln += ft * vn, pn += ft * Ln, hn += (ft = Lt[6]) * Un, un += ft * qn, An += ft * hr, mn += ft * Vr, En += ft * Pr, Jt += ft * Er, an += ft * xr, cn += ft * kr, dn += ft * Rr, yn += ft * sr, Nn += ft * br, Rn += ft * Gr, rn += ft * on, ln += ft * bn, pn += ft * vn, Sn += ft * Ln, un += (ft = Lt[7]) * Un, An += ft * qn, mn += ft * hr, En += ft * Vr, Jt += ft * Pr, an += ft * Er, cn += ft * xr, dn += ft * kr, yn += ft * Rr, Nn += ft * sr, Rn += ft * br, rn += ft * Gr, ln += ft * on, pn += ft * bn, Sn += ft * vn, In += ft * Ln, An += (ft = Lt[8]) * Un, mn += ft * qn, En += ft * hr, Jt += ft * Vr, an += ft * Pr, cn += ft * Er, dn += ft * xr, yn += ft * kr, Nn += ft * Rr, Rn += ft * sr, rn += ft * br, ln += ft * Gr, pn += ft * on, Sn += ft * bn, In += ft * vn, Bn += ft * Ln, mn += (ft = Lt[9]) * Un, En += ft * qn, Jt += ft * hr, an += ft * Vr, cn += ft * Pr, dn += ft * Er, yn += ft * xr, Nn += ft * kr, Rn += ft * Rr, rn += ft * sr, ln += ft * br, pn += ft * Gr, Sn += ft * on, In += ft * bn, Bn += ft * vn, Pn += ft * Ln, En += (ft = Lt[10]) * Un, Jt += ft * qn, an += ft * hr, cn += ft * Vr, dn += ft * Pr, yn += ft * Er, Nn += ft * xr, Rn += ft * kr, rn += ft * Rr, ln += ft * sr, pn += ft * br, Sn += ft * Gr, In += ft * on, Bn += ft * bn, Pn += ft * vn, Yn += ft * Ln, Jt += (ft = Lt[11]) * Un, an += ft * qn, cn += ft * hr, dn += ft * Vr, yn += ft * Pr, Nn += ft * Er, Rn += ft * xr, rn += ft * kr, ln += ft * Rr, pn += ft * sr, Sn += ft * br, In += ft * Gr, Bn += ft * on, Pn += ft * bn, Yn += ft * vn, or += ft * Ln, an += (ft = Lt[12]) * Un, cn += ft * qn, dn += ft * hr, yn += ft * Vr, Nn += ft * Pr, Rn += ft * Er, rn += ft * xr, ln += ft * kr, pn += ft * Rr, Sn += ft * sr, In += ft * br, Bn += ft * Gr, Pn += ft * on, Yn += ft * bn, or += ft * vn, mr += ft * Ln, cn += (ft = Lt[13]) * Un, dn += ft * qn, yn += ft * hr, Nn += ft * Vr, Rn += ft * Pr, rn += ft * Er, ln += ft * xr, pn += ft * kr, Sn += ft * Rr, In += ft * sr, Bn += ft * br, Pn += ft * Gr, Yn += ft * on, or += ft * bn, mr += ft * vn, lr += ft * Ln, dn += (ft = Lt[14]) * Un, yn += ft * qn, Nn += ft * hr, Rn += ft * Vr, rn += ft * Pr, ln += ft * Er, pn += ft * xr, Sn += ft * kr, In += ft * Rr, Bn += ft * sr, Pn += ft * br, Yn += ft * Gr, or += ft * on, mr += ft * bn, lr += ft * vn, Mr += ft * Ln, yn += (ft = Lt[15]) * Un, Ft += 38 * (Rn += ft * hr), Gt += 38 * (rn += ft * Vr), zt += 38 * (ln += ft * Pr), $t += 38 * (pn += ft * Er), Ht += 38 * (Sn += ft * xr), hn += 38 * (In += ft * kr), un += 38 * (Bn += ft * Rr), An += 38 * (Pn += ft * sr), mn += 38 * (Yn += ft * br), En += 38 * (or += ft * Gr), Jt += 38 * (mr += ft * on), an += 38 * (lr += ft * bn), cn += 38 * (Mr += ft * vn), dn += 38 * (ai += ft * Ln), Mt = (ft = (Mt += 38 * (Nn += ft * qn)) + (Dt = 1) + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), Ft = (ft = Ft + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), Gt = (ft = Gt + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), zt = (ft = zt + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), $t = (ft = $t + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), Ht = (ft = Ht + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), hn = (ft = hn + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), un = (ft = un + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), An = (ft = An + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), mn = (ft = mn + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), En = (ft = En + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), Jt = (ft = Jt + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), an = (ft = an + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), cn = (ft = cn + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), dn = (ft = dn + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), yn = (ft = yn + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), Mt = (ft = (Mt += Dt - 1 + 37 * (Dt - 1)) + (Dt = 1) + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), Ft = (ft = Ft + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), Gt = (ft = Gt + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), zt = (ft = zt + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), $t = (ft = $t + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), Ht = (ft = Ht + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), hn = (ft = hn + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), un = (ft = un + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), An = (ft = An + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), mn = (ft = mn + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), En = (ft = En + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), Jt = (ft = Jt + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), an = (ft = an + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), cn = (ft = cn + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), dn = (ft = dn + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), yn = (ft = yn + Dt + 65535) - 65536 * (Dt = Math.floor(ft / 65536)), Mt += Dt - 1 + 37 * (Dt - 1), Ut[0] = Mt, Ut[1] = Ft, Ut[2] = Gt, Ut[3] = zt, Ut[4] = $t, Ut[5] = Ht, Ut[6] = hn, Ut[7] = un, Ut[8] = An, Ut[9] = mn, Ut[10] = En, Ut[11] = Jt, Ut[12] = an, Ut[13] = cn, Ut[14] = dn, Ut[15] = yn;
    }
  }, 7768: (He) => {
    He.exports = { options: { usePureJavaScript: !1 } };
  }, 7461: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    Xe(6067), Xe(3103), (He.exports = Ke.hmac = Ke.hmac || {}).create = function() {
      var $e = null, Je = null, Ze = null, nt = null, tt = { start: function(et, rt) {
        if (et !== null) if (typeof et == "string") {
          if (!((et = et.toLowerCase()) in Ke.md.algorithms)) throw new Error('Unknown hash algorithm "' + et + '"');
          Je = Ke.md.algorithms[et].create();
        } else Je = et;
        if (rt === null) rt = $e;
        else {
          if (typeof rt == "string") rt = Ke.util.createBuffer(rt);
          else if (Ke.util.isArray(rt)) {
            var it = rt;
            rt = Ke.util.createBuffer();
            for (var ot = 0; ot < it.length; ++ot) rt.putByte(it[ot]);
          }
          var at = rt.length();
          for (at > Je.blockLength && (Je.start(), Je.update(rt.bytes()), rt = Je.digest()), Ze = Ke.util.createBuffer(), nt = Ke.util.createBuffer(), at = rt.length(), ot = 0; ot < at; ++ot) it = rt.at(ot), Ze.putByte(54 ^ it), nt.putByte(92 ^ it);
          if (at < Je.blockLength) for (it = Je.blockLength - at, ot = 0; ot < it; ++ot) Ze.putByte(54), nt.putByte(92);
          $e = rt, Ze = Ze.bytes(), nt = nt.bytes();
        }
        Je.start(), Je.update(Ze);
      }, update: function(et) {
        Je.update(et);
      }, getMac: function() {
        var et = Je.digest().bytes();
        return Je.start(), Je.update(nt), Je.update(et), Je.digest();
      } };
      return tt.digest = tt.getMac, tt;
    };
  }, 6432: (He, Ge, Xe) => {
    He.exports = Xe(7768), Xe(1482), Xe(6898), Xe(2624), Xe(4609), Xe(2023), Xe(2554), Xe(7461), Xe(1169), Xe(7316), Xe(7847), Xe(5024), Xe(9580), Xe(5477), Xe(4034), Xe(779), Xe(1559), Xe(4885), Xe(8547), Xe(3930), Xe(665), Xe(4097), Xe(3323), Xe(2676), Xe(8472), Xe(3103);
  }, 1633: (He, Ge, Xe) => {
    var Ke, $e = Xe(7768);
    function Je(vt, Et, bt) {
      this.data = [], vt != null && (typeof vt == "number" ? this.fromNumber(vt, Et, bt) : Et == null && typeof vt != "string" ? this.fromString(vt, 256) : this.fromString(vt, Et));
    }
    function Ze() {
      return new Je(null);
    }
    function nt(vt, Et, bt, Rt, St, kt) {
      for (var jt = 16383 & Et, Pt = Et >> 14; --kt >= 0; ) {
        var Qt = 16383 & this.data[vt], qt = this.data[vt++] >> 14, _t = Pt * Qt + qt * jt;
        St = ((Qt = jt * Qt + ((16383 & _t) << 14) + bt.data[Rt] + St) >> 28) + (_t >> 14) + Pt * qt, bt.data[Rt++] = 268435455 & Qt;
      }
      return St;
    }
    He.exports = $e.jsbn = $e.jsbn || {}, $e.jsbn.BigInteger = Je, typeof navigator > "u" ? (Je.prototype.am = nt, Ke = 28) : navigator.appName == "Microsoft Internet Explorer" ? (Je.prototype.am = function(vt, Et, bt, Rt, St, kt) {
      for (var jt = 32767 & Et, Pt = Et >> 15; --kt >= 0; ) {
        var Qt = 32767 & this.data[vt], qt = this.data[vt++] >> 15, _t = Pt * Qt + qt * jt;
        St = ((Qt = jt * Qt + ((32767 & _t) << 15) + bt.data[Rt] + (1073741823 & St)) >>> 30) + (_t >>> 15) + Pt * qt + (St >>> 30), bt.data[Rt++] = 1073741823 & Qt;
      }
      return St;
    }, Ke = 30) : navigator.appName != "Netscape" ? (Je.prototype.am = function(vt, Et, bt, Rt, St, kt) {
      for (; --kt >= 0; ) {
        var jt = Et * this.data[vt++] + bt.data[Rt] + St;
        St = Math.floor(jt / 67108864), bt.data[Rt++] = 67108863 & jt;
      }
      return St;
    }, Ke = 26) : (Je.prototype.am = nt, Ke = 28), Je.prototype.DB = Ke, Je.prototype.DM = (1 << Ke) - 1, Je.prototype.DV = 1 << Ke, Je.prototype.FV = Math.pow(2, 52), Je.prototype.F1 = 52 - Ke, Je.prototype.F2 = 2 * Ke - 52;
    var tt, et, rt = new Array();
    for (tt = 48, et = 0; et <= 9; ++et) rt[tt++] = et;
    for (tt = 97, et = 10; et < 36; ++et) rt[tt++] = et;
    for (tt = 65, et = 10; et < 36; ++et) rt[tt++] = et;
    function it(vt) {
      return "0123456789abcdefghijklmnopqrstuvwxyz".charAt(vt);
    }
    function ot(vt, Et) {
      var bt = rt[vt.charCodeAt(Et)];
      return bt ?? -1;
    }
    function at(vt) {
      var Et = Ze();
      return Et.fromInt(vt), Et;
    }
    function st(vt) {
      var Et, bt = 1;
      return (Et = vt >>> 16) != 0 && (vt = Et, bt += 16), (Et = vt >> 8) != 0 && (vt = Et, bt += 8), (Et = vt >> 4) != 0 && (vt = Et, bt += 4), (Et = vt >> 2) != 0 && (vt = Et, bt += 2), (Et = vt >> 1) != 0 && (vt = Et, bt += 1), bt;
    }
    function ut(vt) {
      this.m = vt;
    }
    function lt(vt) {
      this.m = vt, this.mp = vt.invDigit(), this.mpl = 32767 & this.mp, this.mph = this.mp >> 15, this.um = (1 << vt.DB - 15) - 1, this.mt2 = 2 * vt.t;
    }
    function dt(vt, Et) {
      return vt & Et;
    }
    function At(vt, Et) {
      return vt | Et;
    }
    function pt(vt, Et) {
      return vt ^ Et;
    }
    function gt(vt, Et) {
      return vt & ~Et;
    }
    function wt(vt) {
      if (vt == 0) return -1;
      var Et = 0;
      return !(65535 & vt) && (vt >>= 16, Et += 16), !(255 & vt) && (vt >>= 8, Et += 8), !(15 & vt) && (vt >>= 4, Et += 4), !(3 & vt) && (vt >>= 2, Et += 2), !(1 & vt) && ++Et, Et;
    }
    function Bt(vt) {
      for (var Et = 0; vt != 0; ) vt &= vt - 1, ++Et;
      return Et;
    }
    function Tt() {
    }
    function yt(vt) {
      return vt;
    }
    function Ct(vt) {
      this.r2 = Ze(), this.q3 = Ze(), Je.ONE.dlShiftTo(2 * vt.t, this.r2), this.mu = this.r2.divide(vt), this.m = vt;
    }
    ut.prototype.convert = function(vt) {
      return vt.s < 0 || vt.compareTo(this.m) >= 0 ? vt.mod(this.m) : vt;
    }, ut.prototype.revert = function(vt) {
      return vt;
    }, ut.prototype.reduce = function(vt) {
      vt.divRemTo(this.m, null, vt);
    }, ut.prototype.mulTo = function(vt, Et, bt) {
      vt.multiplyTo(Et, bt), this.reduce(bt);
    }, ut.prototype.sqrTo = function(vt, Et) {
      vt.squareTo(Et), this.reduce(Et);
    }, lt.prototype.convert = function(vt) {
      var Et = Ze();
      return vt.abs().dlShiftTo(this.m.t, Et), Et.divRemTo(this.m, null, Et), vt.s < 0 && Et.compareTo(Je.ZERO) > 0 && this.m.subTo(Et, Et), Et;
    }, lt.prototype.revert = function(vt) {
      var Et = Ze();
      return vt.copyTo(Et), this.reduce(Et), Et;
    }, lt.prototype.reduce = function(vt) {
      for (; vt.t <= this.mt2; ) vt.data[vt.t++] = 0;
      for (var Et = 0; Et < this.m.t; ++Et) {
        var bt = 32767 & vt.data[Et], Rt = bt * this.mpl + ((bt * this.mph + (vt.data[Et] >> 15) * this.mpl & this.um) << 15) & vt.DM;
        for (bt = Et + this.m.t, vt.data[bt] += this.m.am(0, Rt, vt, Et, 0, this.m.t); vt.data[bt] >= vt.DV; ) vt.data[bt] -= vt.DV, vt.data[++bt]++;
      }
      vt.clamp(), vt.drShiftTo(this.m.t, vt), vt.compareTo(this.m) >= 0 && vt.subTo(this.m, vt);
    }, lt.prototype.mulTo = function(vt, Et, bt) {
      vt.multiplyTo(Et, bt), this.reduce(bt);
    }, lt.prototype.sqrTo = function(vt, Et) {
      vt.squareTo(Et), this.reduce(Et);
    }, Je.prototype.copyTo = function(vt) {
      for (var Et = this.t - 1; Et >= 0; --Et) vt.data[Et] = this.data[Et];
      vt.t = this.t, vt.s = this.s;
    }, Je.prototype.fromInt = function(vt) {
      this.t = 1, this.s = vt < 0 ? -1 : 0, vt > 0 ? this.data[0] = vt : vt < -1 ? this.data[0] = vt + this.DV : this.t = 0;
    }, Je.prototype.fromString = function(vt, Et) {
      var bt;
      if (Et == 16) bt = 4;
      else if (Et == 8) bt = 3;
      else if (Et == 256) bt = 8;
      else if (Et == 2) bt = 1;
      else if (Et == 32) bt = 5;
      else {
        if (Et != 4) return void this.fromRadix(vt, Et);
        bt = 2;
      }
      this.t = 0, this.s = 0;
      for (var Rt = vt.length, St = !1, kt = 0; --Rt >= 0; ) {
        var jt = bt == 8 ? 255 & vt[Rt] : ot(vt, Rt);
        jt < 0 ? vt.charAt(Rt) == "-" && (St = !0) : (St = !1, kt == 0 ? this.data[this.t++] = jt : kt + bt > this.DB ? (this.data[this.t - 1] |= (jt & (1 << this.DB - kt) - 1) << kt, this.data[this.t++] = jt >> this.DB - kt) : this.data[this.t - 1] |= jt << kt, (kt += bt) >= this.DB && (kt -= this.DB));
      }
      bt == 8 && 128 & vt[0] && (this.s = -1, kt > 0 && (this.data[this.t - 1] |= (1 << this.DB - kt) - 1 << kt)), this.clamp(), St && Je.ZERO.subTo(this, this);
    }, Je.prototype.clamp = function() {
      for (var vt = this.s & this.DM; this.t > 0 && this.data[this.t - 1] == vt; ) --this.t;
    }, Je.prototype.dlShiftTo = function(vt, Et) {
      var bt;
      for (bt = this.t - 1; bt >= 0; --bt) Et.data[bt + vt] = this.data[bt];
      for (bt = vt - 1; bt >= 0; --bt) Et.data[bt] = 0;
      Et.t = this.t + vt, Et.s = this.s;
    }, Je.prototype.drShiftTo = function(vt, Et) {
      for (var bt = vt; bt < this.t; ++bt) Et.data[bt - vt] = this.data[bt];
      Et.t = Math.max(this.t - vt, 0), Et.s = this.s;
    }, Je.prototype.lShiftTo = function(vt, Et) {
      var bt, Rt = vt % this.DB, St = this.DB - Rt, kt = (1 << St) - 1, jt = Math.floor(vt / this.DB), Pt = this.s << Rt & this.DM;
      for (bt = this.t - 1; bt >= 0; --bt) Et.data[bt + jt + 1] = this.data[bt] >> St | Pt, Pt = (this.data[bt] & kt) << Rt;
      for (bt = jt - 1; bt >= 0; --bt) Et.data[bt] = 0;
      Et.data[jt] = Pt, Et.t = this.t + jt + 1, Et.s = this.s, Et.clamp();
    }, Je.prototype.rShiftTo = function(vt, Et) {
      Et.s = this.s;
      var bt = Math.floor(vt / this.DB);
      if (bt >= this.t) Et.t = 0;
      else {
        var Rt = vt % this.DB, St = this.DB - Rt, kt = (1 << Rt) - 1;
        Et.data[0] = this.data[bt] >> Rt;
        for (var jt = bt + 1; jt < this.t; ++jt) Et.data[jt - bt - 1] |= (this.data[jt] & kt) << St, Et.data[jt - bt] = this.data[jt] >> Rt;
        Rt > 0 && (Et.data[this.t - bt - 1] |= (this.s & kt) << St), Et.t = this.t - bt, Et.clamp();
      }
    }, Je.prototype.subTo = function(vt, Et) {
      for (var bt = 0, Rt = 0, St = Math.min(vt.t, this.t); bt < St; ) Rt += this.data[bt] - vt.data[bt], Et.data[bt++] = Rt & this.DM, Rt >>= this.DB;
      if (vt.t < this.t) {
        for (Rt -= vt.s; bt < this.t; ) Rt += this.data[bt], Et.data[bt++] = Rt & this.DM, Rt >>= this.DB;
        Rt += this.s;
      } else {
        for (Rt += this.s; bt < vt.t; ) Rt -= vt.data[bt], Et.data[bt++] = Rt & this.DM, Rt >>= this.DB;
        Rt -= vt.s;
      }
      Et.s = Rt < 0 ? -1 : 0, Rt < -1 ? Et.data[bt++] = this.DV + Rt : Rt > 0 && (Et.data[bt++] = Rt), Et.t = bt, Et.clamp();
    }, Je.prototype.multiplyTo = function(vt, Et) {
      var bt = this.abs(), Rt = vt.abs(), St = bt.t;
      for (Et.t = St + Rt.t; --St >= 0; ) Et.data[St] = 0;
      for (St = 0; St < Rt.t; ++St) Et.data[St + bt.t] = bt.am(0, Rt.data[St], Et, St, 0, bt.t);
      Et.s = 0, Et.clamp(), this.s != vt.s && Je.ZERO.subTo(Et, Et);
    }, Je.prototype.squareTo = function(vt) {
      for (var Et = this.abs(), bt = vt.t = 2 * Et.t; --bt >= 0; ) vt.data[bt] = 0;
      for (bt = 0; bt < Et.t - 1; ++bt) {
        var Rt = Et.am(bt, Et.data[bt], vt, 2 * bt, 0, 1);
        (vt.data[bt + Et.t] += Et.am(bt + 1, 2 * Et.data[bt], vt, 2 * bt + 1, Rt, Et.t - bt - 1)) >= Et.DV && (vt.data[bt + Et.t] -= Et.DV, vt.data[bt + Et.t + 1] = 1);
      }
      vt.t > 0 && (vt.data[vt.t - 1] += Et.am(bt, Et.data[bt], vt, 2 * bt, 0, 1)), vt.s = 0, vt.clamp();
    }, Je.prototype.divRemTo = function(vt, Et, bt) {
      var Rt = vt.abs();
      if (!(Rt.t <= 0)) {
        var St = this.abs();
        if (St.t < Rt.t) return Et != null && Et.fromInt(0), void (bt != null && this.copyTo(bt));
        bt == null && (bt = Ze());
        var kt = Ze(), jt = this.s, Pt = vt.s, Qt = this.DB - st(Rt.data[Rt.t - 1]);
        Qt > 0 ? (Rt.lShiftTo(Qt, kt), St.lShiftTo(Qt, bt)) : (Rt.copyTo(kt), St.copyTo(bt));
        var qt = kt.t, _t = kt.data[qt - 1];
        if (_t != 0) {
          var Yt = _t * (1 << this.F1) + (qt > 1 ? kt.data[qt - 2] >> this.F2 : 0), Xt = this.FV / Yt, Ut = (1 << this.F1) / Yt, Lt = 1 << this.F2, Ot = bt.t, ft = Ot - qt, Dt = Et ?? Ze();
          for (kt.dlShiftTo(ft, Dt), bt.compareTo(Dt) >= 0 && (bt.data[bt.t++] = 1, bt.subTo(Dt, bt)), Je.ONE.dlShiftTo(qt, Dt), Dt.subTo(kt, kt); kt.t < qt; ) kt.data[kt.t++] = 0;
          for (; --ft >= 0; ) {
            var Mt = bt.data[--Ot] == _t ? this.DM : Math.floor(bt.data[Ot] * Xt + (bt.data[Ot - 1] + Lt) * Ut);
            if ((bt.data[Ot] += kt.am(0, Mt, bt, ft, 0, qt)) < Mt) for (kt.dlShiftTo(ft, Dt), bt.subTo(Dt, bt); bt.data[Ot] < --Mt; ) bt.subTo(Dt, bt);
          }
          Et != null && (bt.drShiftTo(qt, Et), jt != Pt && Je.ZERO.subTo(Et, Et)), bt.t = qt, bt.clamp(), Qt > 0 && bt.rShiftTo(Qt, bt), jt < 0 && Je.ZERO.subTo(bt, bt);
        }
      }
    }, Je.prototype.invDigit = function() {
      if (this.t < 1) return 0;
      var vt = this.data[0];
      if (!(1 & vt)) return 0;
      var Et = 3 & vt;
      return (Et = (Et = (Et = (Et = Et * (2 - (15 & vt) * Et) & 15) * (2 - (255 & vt) * Et) & 255) * (2 - ((65535 & vt) * Et & 65535)) & 65535) * (2 - vt * Et % this.DV) % this.DV) > 0 ? this.DV - Et : -Et;
    }, Je.prototype.isEven = function() {
      return (this.t > 0 ? 1 & this.data[0] : this.s) == 0;
    }, Je.prototype.exp = function(vt, Et) {
      if (vt > 4294967295 || vt < 1) return Je.ONE;
      var bt = Ze(), Rt = Ze(), St = Et.convert(this), kt = st(vt) - 1;
      for (St.copyTo(bt); --kt >= 0; ) if (Et.sqrTo(bt, Rt), (vt & 1 << kt) > 0) Et.mulTo(Rt, St, bt);
      else {
        var jt = bt;
        bt = Rt, Rt = jt;
      }
      return Et.revert(bt);
    }, Je.prototype.toString = function(vt) {
      if (this.s < 0) return "-" + this.negate().toString(vt);
      var Et;
      if (vt == 16) Et = 4;
      else if (vt == 8) Et = 3;
      else if (vt == 2) Et = 1;
      else if (vt == 32) Et = 5;
      else {
        if (vt != 4) return this.toRadix(vt);
        Et = 2;
      }
      var bt, Rt = (1 << Et) - 1, St = !1, kt = "", jt = this.t, Pt = this.DB - jt * this.DB % Et;
      if (jt-- > 0) for (Pt < this.DB && (bt = this.data[jt] >> Pt) > 0 && (St = !0, kt = it(bt)); jt >= 0; ) Pt < Et ? (bt = (this.data[jt] & (1 << Pt) - 1) << Et - Pt, bt |= this.data[--jt] >> (Pt += this.DB - Et)) : (bt = this.data[jt] >> (Pt -= Et) & Rt, Pt <= 0 && (Pt += this.DB, --jt)), bt > 0 && (St = !0), St && (kt += it(bt));
      return St ? kt : "0";
    }, Je.prototype.negate = function() {
      var vt = Ze();
      return Je.ZERO.subTo(this, vt), vt;
    }, Je.prototype.abs = function() {
      return this.s < 0 ? this.negate() : this;
    }, Je.prototype.compareTo = function(vt) {
      var Et = this.s - vt.s;
      if (Et != 0) return Et;
      var bt = this.t;
      if ((Et = bt - vt.t) != 0) return this.s < 0 ? -Et : Et;
      for (; --bt >= 0; ) if ((Et = this.data[bt] - vt.data[bt]) != 0) return Et;
      return 0;
    }, Je.prototype.bitLength = function() {
      return this.t <= 0 ? 0 : this.DB * (this.t - 1) + st(this.data[this.t - 1] ^ this.s & this.DM);
    }, Je.prototype.mod = function(vt) {
      var Et = Ze();
      return this.abs().divRemTo(vt, null, Et), this.s < 0 && Et.compareTo(Je.ZERO) > 0 && vt.subTo(Et, Et), Et;
    }, Je.prototype.modPowInt = function(vt, Et) {
      var bt;
      return bt = vt < 256 || Et.isEven() ? new ut(Et) : new lt(Et), this.exp(vt, bt);
    }, Je.ZERO = at(0), Je.ONE = at(1), Tt.prototype.convert = yt, Tt.prototype.revert = yt, Tt.prototype.mulTo = function(vt, Et, bt) {
      vt.multiplyTo(Et, bt);
    }, Tt.prototype.sqrTo = function(vt, Et) {
      vt.squareTo(Et);
    }, Ct.prototype.convert = function(vt) {
      if (vt.s < 0 || vt.t > 2 * this.m.t) return vt.mod(this.m);
      if (vt.compareTo(this.m) < 0) return vt;
      var Et = Ze();
      return vt.copyTo(Et), this.reduce(Et), Et;
    }, Ct.prototype.revert = function(vt) {
      return vt;
    }, Ct.prototype.reduce = function(vt) {
      for (vt.drShiftTo(this.m.t - 1, this.r2), vt.t > this.m.t + 1 && (vt.t = this.m.t + 1, vt.clamp()), this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3), this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2); vt.compareTo(this.r2) < 0; ) vt.dAddOffset(1, this.m.t + 1);
      for (vt.subTo(this.r2, vt); vt.compareTo(this.m) >= 0; ) vt.subTo(this.m, vt);
    }, Ct.prototype.mulTo = function(vt, Et, bt) {
      vt.multiplyTo(Et, bt), this.reduce(bt);
    }, Ct.prototype.sqrTo = function(vt, Et) {
      vt.squareTo(Et), this.reduce(Et);
    };
    var ht = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509], It = (1 << 26) / ht[ht.length - 1];
    Je.prototype.chunkSize = function(vt) {
      return Math.floor(Math.LN2 * this.DB / Math.log(vt));
    }, Je.prototype.toRadix = function(vt) {
      if (vt == null && (vt = 10), this.signum() == 0 || vt < 2 || vt > 36) return "0";
      var Et = this.chunkSize(vt), bt = Math.pow(vt, Et), Rt = at(bt), St = Ze(), kt = Ze(), jt = "";
      for (this.divRemTo(Rt, St, kt); St.signum() > 0; ) jt = (bt + kt.intValue()).toString(vt).substr(1) + jt, St.divRemTo(Rt, St, kt);
      return kt.intValue().toString(vt) + jt;
    }, Je.prototype.fromRadix = function(vt, Et) {
      this.fromInt(0), Et == null && (Et = 10);
      for (var bt = this.chunkSize(Et), Rt = Math.pow(Et, bt), St = !1, kt = 0, jt = 0, Pt = 0; Pt < vt.length; ++Pt) {
        var Qt = ot(vt, Pt);
        Qt < 0 ? vt.charAt(Pt) == "-" && this.signum() == 0 && (St = !0) : (jt = Et * jt + Qt, ++kt >= bt && (this.dMultiply(Rt), this.dAddOffset(jt, 0), kt = 0, jt = 0));
      }
      kt > 0 && (this.dMultiply(Math.pow(Et, kt)), this.dAddOffset(jt, 0)), St && Je.ZERO.subTo(this, this);
    }, Je.prototype.fromNumber = function(vt, Et, bt) {
      if (typeof Et == "number") if (vt < 2) this.fromInt(1);
      else for (this.fromNumber(vt, bt), this.testBit(vt - 1) || this.bitwiseTo(Je.ONE.shiftLeft(vt - 1), At, this), this.isEven() && this.dAddOffset(1, 0); !this.isProbablePrime(Et); ) this.dAddOffset(2, 0), this.bitLength() > vt && this.subTo(Je.ONE.shiftLeft(vt - 1), this);
      else {
        var Rt = new Array(), St = 7 & vt;
        Rt.length = 1 + (vt >> 3), Et.nextBytes(Rt), St > 0 ? Rt[0] &= (1 << St) - 1 : Rt[0] = 0, this.fromString(Rt, 256);
      }
    }, Je.prototype.bitwiseTo = function(vt, Et, bt) {
      var Rt, St, kt = Math.min(vt.t, this.t);
      for (Rt = 0; Rt < kt; ++Rt) bt.data[Rt] = Et(this.data[Rt], vt.data[Rt]);
      if (vt.t < this.t) {
        for (St = vt.s & this.DM, Rt = kt; Rt < this.t; ++Rt) bt.data[Rt] = Et(this.data[Rt], St);
        bt.t = this.t;
      } else {
        for (St = this.s & this.DM, Rt = kt; Rt < vt.t; ++Rt) bt.data[Rt] = Et(St, vt.data[Rt]);
        bt.t = vt.t;
      }
      bt.s = Et(this.s, vt.s), bt.clamp();
    }, Je.prototype.changeBit = function(vt, Et) {
      var bt = Je.ONE.shiftLeft(vt);
      return this.bitwiseTo(bt, Et, bt), bt;
    }, Je.prototype.addTo = function(vt, Et) {
      for (var bt = 0, Rt = 0, St = Math.min(vt.t, this.t); bt < St; ) Rt += this.data[bt] + vt.data[bt], Et.data[bt++] = Rt & this.DM, Rt >>= this.DB;
      if (vt.t < this.t) {
        for (Rt += vt.s; bt < this.t; ) Rt += this.data[bt], Et.data[bt++] = Rt & this.DM, Rt >>= this.DB;
        Rt += this.s;
      } else {
        for (Rt += this.s; bt < vt.t; ) Rt += vt.data[bt], Et.data[bt++] = Rt & this.DM, Rt >>= this.DB;
        Rt += vt.s;
      }
      Et.s = Rt < 0 ? -1 : 0, Rt > 0 ? Et.data[bt++] = Rt : Rt < -1 && (Et.data[bt++] = this.DV + Rt), Et.t = bt, Et.clamp();
    }, Je.prototype.dMultiply = function(vt) {
      this.data[this.t] = this.am(0, vt - 1, this, 0, 0, this.t), ++this.t, this.clamp();
    }, Je.prototype.dAddOffset = function(vt, Et) {
      if (vt != 0) {
        for (; this.t <= Et; ) this.data[this.t++] = 0;
        for (this.data[Et] += vt; this.data[Et] >= this.DV; ) this.data[Et] -= this.DV, ++Et >= this.t && (this.data[this.t++] = 0), ++this.data[Et];
      }
    }, Je.prototype.multiplyLowerTo = function(vt, Et, bt) {
      var Rt, St = Math.min(this.t + vt.t, Et);
      for (bt.s = 0, bt.t = St; St > 0; ) bt.data[--St] = 0;
      for (Rt = bt.t - this.t; St < Rt; ++St) bt.data[St + this.t] = this.am(0, vt.data[St], bt, St, 0, this.t);
      for (Rt = Math.min(vt.t, Et); St < Rt; ++St) this.am(0, vt.data[St], bt, St, 0, Et - St);
      bt.clamp();
    }, Je.prototype.multiplyUpperTo = function(vt, Et, bt) {
      --Et;
      var Rt = bt.t = this.t + vt.t - Et;
      for (bt.s = 0; --Rt >= 0; ) bt.data[Rt] = 0;
      for (Rt = Math.max(Et - this.t, 0); Rt < vt.t; ++Rt) bt.data[this.t + Rt - Et] = this.am(Et - Rt, vt.data[Rt], bt, 0, 0, this.t + Rt - Et);
      bt.clamp(), bt.drShiftTo(1, bt);
    }, Je.prototype.modInt = function(vt) {
      if (vt <= 0) return 0;
      var Et = this.DV % vt, bt = this.s < 0 ? vt - 1 : 0;
      if (this.t > 0) if (Et == 0) bt = this.data[0] % vt;
      else for (var Rt = this.t - 1; Rt >= 0; --Rt) bt = (Et * bt + this.data[Rt]) % vt;
      return bt;
    }, Je.prototype.millerRabin = function(vt) {
      var Et = this.subtract(Je.ONE), bt = Et.getLowestSetBit();
      if (bt <= 0) return !1;
      for (var Rt, St = Et.shiftRight(bt), kt = { nextBytes: function(qt) {
        for (var _t = 0; _t < qt.length; ++_t) qt[_t] = Math.floor(256 * Math.random());
      } }, jt = 0; jt < vt; ++jt) {
        do
          Rt = new Je(this.bitLength(), kt);
        while (Rt.compareTo(Je.ONE) <= 0 || Rt.compareTo(Et) >= 0);
        var Pt = Rt.modPow(St, this);
        if (Pt.compareTo(Je.ONE) != 0 && Pt.compareTo(Et) != 0) {
          for (var Qt = 1; Qt++ < bt && Pt.compareTo(Et) != 0; ) if ((Pt = Pt.modPowInt(2, this)).compareTo(Je.ONE) == 0) return !1;
          if (Pt.compareTo(Et) != 0) return !1;
        }
      }
      return !0;
    }, Je.prototype.clone = function() {
      var vt = Ze();
      return this.copyTo(vt), vt;
    }, Je.prototype.intValue = function() {
      if (this.s < 0) {
        if (this.t == 1) return this.data[0] - this.DV;
        if (this.t == 0) return -1;
      } else {
        if (this.t == 1) return this.data[0];
        if (this.t == 0) return 0;
      }
      return (this.data[1] & (1 << 32 - this.DB) - 1) << this.DB | this.data[0];
    }, Je.prototype.byteValue = function() {
      return this.t == 0 ? this.s : this.data[0] << 24 >> 24;
    }, Je.prototype.shortValue = function() {
      return this.t == 0 ? this.s : this.data[0] << 16 >> 16;
    }, Je.prototype.signum = function() {
      return this.s < 0 ? -1 : this.t <= 0 || this.t == 1 && this.data[0] <= 0 ? 0 : 1;
    }, Je.prototype.toByteArray = function() {
      var vt = this.t, Et = new Array();
      Et[0] = this.s;
      var bt, Rt = this.DB - vt * this.DB % 8, St = 0;
      if (vt-- > 0) for (Rt < this.DB && (bt = this.data[vt] >> Rt) != (this.s & this.DM) >> Rt && (Et[St++] = bt | this.s << this.DB - Rt); vt >= 0; ) Rt < 8 ? (bt = (this.data[vt] & (1 << Rt) - 1) << 8 - Rt, bt |= this.data[--vt] >> (Rt += this.DB - 8)) : (bt = this.data[vt] >> (Rt -= 8) & 255, Rt <= 0 && (Rt += this.DB, --vt)), 128 & bt && (bt |= -256), St == 0 && (128 & this.s) != (128 & bt) && ++St, (St > 0 || bt != this.s) && (Et[St++] = bt);
      return Et;
    }, Je.prototype.equals = function(vt) {
      return this.compareTo(vt) == 0;
    }, Je.prototype.min = function(vt) {
      return this.compareTo(vt) < 0 ? this : vt;
    }, Je.prototype.max = function(vt) {
      return this.compareTo(vt) > 0 ? this : vt;
    }, Je.prototype.and = function(vt) {
      var Et = Ze();
      return this.bitwiseTo(vt, dt, Et), Et;
    }, Je.prototype.or = function(vt) {
      var Et = Ze();
      return this.bitwiseTo(vt, At, Et), Et;
    }, Je.prototype.xor = function(vt) {
      var Et = Ze();
      return this.bitwiseTo(vt, pt, Et), Et;
    }, Je.prototype.andNot = function(vt) {
      var Et = Ze();
      return this.bitwiseTo(vt, gt, Et), Et;
    }, Je.prototype.not = function() {
      for (var vt = Ze(), Et = 0; Et < this.t; ++Et) vt.data[Et] = this.DM & ~this.data[Et];
      return vt.t = this.t, vt.s = ~this.s, vt;
    }, Je.prototype.shiftLeft = function(vt) {
      var Et = Ze();
      return vt < 0 ? this.rShiftTo(-vt, Et) : this.lShiftTo(vt, Et), Et;
    }, Je.prototype.shiftRight = function(vt) {
      var Et = Ze();
      return vt < 0 ? this.lShiftTo(-vt, Et) : this.rShiftTo(vt, Et), Et;
    }, Je.prototype.getLowestSetBit = function() {
      for (var vt = 0; vt < this.t; ++vt) if (this.data[vt] != 0) return vt * this.DB + wt(this.data[vt]);
      return this.s < 0 ? this.t * this.DB : -1;
    }, Je.prototype.bitCount = function() {
      for (var vt = 0, Et = this.s & this.DM, bt = 0; bt < this.t; ++bt) vt += Bt(this.data[bt] ^ Et);
      return vt;
    }, Je.prototype.testBit = function(vt) {
      var Et = Math.floor(vt / this.DB);
      return Et >= this.t ? this.s != 0 : (this.data[Et] & 1 << vt % this.DB) != 0;
    }, Je.prototype.setBit = function(vt) {
      return this.changeBit(vt, At);
    }, Je.prototype.clearBit = function(vt) {
      return this.changeBit(vt, gt);
    }, Je.prototype.flipBit = function(vt) {
      return this.changeBit(vt, pt);
    }, Je.prototype.add = function(vt) {
      var Et = Ze();
      return this.addTo(vt, Et), Et;
    }, Je.prototype.subtract = function(vt) {
      var Et = Ze();
      return this.subTo(vt, Et), Et;
    }, Je.prototype.multiply = function(vt) {
      var Et = Ze();
      return this.multiplyTo(vt, Et), Et;
    }, Je.prototype.divide = function(vt) {
      var Et = Ze();
      return this.divRemTo(vt, Et, null), Et;
    }, Je.prototype.remainder = function(vt) {
      var Et = Ze();
      return this.divRemTo(vt, null, Et), Et;
    }, Je.prototype.divideAndRemainder = function(vt) {
      var Et = Ze(), bt = Ze();
      return this.divRemTo(vt, Et, bt), new Array(Et, bt);
    }, Je.prototype.modPow = function(vt, Et) {
      var bt, Rt, St = vt.bitLength(), kt = at(1);
      if (St <= 0) return kt;
      bt = St < 18 ? 1 : St < 48 ? 3 : St < 144 ? 4 : St < 768 ? 5 : 6, Rt = St < 8 ? new ut(Et) : Et.isEven() ? new Ct(Et) : new lt(Et);
      var jt = new Array(), Pt = 3, Qt = bt - 1, qt = (1 << bt) - 1;
      if (jt[1] = Rt.convert(this), bt > 1) {
        var _t = Ze();
        for (Rt.sqrTo(jt[1], _t); Pt <= qt; ) jt[Pt] = Ze(), Rt.mulTo(_t, jt[Pt - 2], jt[Pt]), Pt += 2;
      }
      var Yt, Xt, Ut = vt.t - 1, Lt = !0, Ot = Ze();
      for (St = st(vt.data[Ut]) - 1; Ut >= 0; ) {
        for (St >= Qt ? Yt = vt.data[Ut] >> St - Qt & qt : (Yt = (vt.data[Ut] & (1 << St + 1) - 1) << Qt - St, Ut > 0 && (Yt |= vt.data[Ut - 1] >> this.DB + St - Qt)), Pt = bt; !(1 & Yt); ) Yt >>= 1, --Pt;
        if ((St -= Pt) < 0 && (St += this.DB, --Ut), Lt) jt[Yt].copyTo(kt), Lt = !1;
        else {
          for (; Pt > 1; ) Rt.sqrTo(kt, Ot), Rt.sqrTo(Ot, kt), Pt -= 2;
          Pt > 0 ? Rt.sqrTo(kt, Ot) : (Xt = kt, kt = Ot, Ot = Xt), Rt.mulTo(Ot, jt[Yt], kt);
        }
        for (; Ut >= 0 && !(vt.data[Ut] & 1 << St); ) Rt.sqrTo(kt, Ot), Xt = kt, kt = Ot, Ot = Xt, --St < 0 && (St = this.DB - 1, --Ut);
      }
      return Rt.revert(kt);
    }, Je.prototype.modInverse = function(vt) {
      var Et = vt.isEven();
      if (this.isEven() && Et || vt.signum() == 0) return Je.ZERO;
      for (var bt = vt.clone(), Rt = this.clone(), St = at(1), kt = at(0), jt = at(0), Pt = at(1); bt.signum() != 0; ) {
        for (; bt.isEven(); ) bt.rShiftTo(1, bt), Et ? (St.isEven() && kt.isEven() || (St.addTo(this, St), kt.subTo(vt, kt)), St.rShiftTo(1, St)) : kt.isEven() || kt.subTo(vt, kt), kt.rShiftTo(1, kt);
        for (; Rt.isEven(); ) Rt.rShiftTo(1, Rt), Et ? (jt.isEven() && Pt.isEven() || (jt.addTo(this, jt), Pt.subTo(vt, Pt)), jt.rShiftTo(1, jt)) : Pt.isEven() || Pt.subTo(vt, Pt), Pt.rShiftTo(1, Pt);
        bt.compareTo(Rt) >= 0 ? (bt.subTo(Rt, bt), Et && St.subTo(jt, St), kt.subTo(Pt, kt)) : (Rt.subTo(bt, Rt), Et && jt.subTo(St, jt), Pt.subTo(kt, Pt));
      }
      return Rt.compareTo(Je.ONE) != 0 ? Je.ZERO : Pt.compareTo(vt) >= 0 ? Pt.subtract(vt) : Pt.signum() < 0 ? (Pt.addTo(vt, Pt), Pt.signum() < 0 ? Pt.add(vt) : Pt) : Pt;
    }, Je.prototype.pow = function(vt) {
      return this.exp(vt, new Tt());
    }, Je.prototype.gcd = function(vt) {
      var Et = this.s < 0 ? this.negate() : this.clone(), bt = vt.s < 0 ? vt.negate() : vt.clone();
      if (Et.compareTo(bt) < 0) {
        var Rt = Et;
        Et = bt, bt = Rt;
      }
      var St = Et.getLowestSetBit(), kt = bt.getLowestSetBit();
      if (kt < 0) return Et;
      for (St < kt && (kt = St), kt > 0 && (Et.rShiftTo(kt, Et), bt.rShiftTo(kt, bt)); Et.signum() > 0; ) (St = Et.getLowestSetBit()) > 0 && Et.rShiftTo(St, Et), (St = bt.getLowestSetBit()) > 0 && bt.rShiftTo(St, bt), Et.compareTo(bt) >= 0 ? (Et.subTo(bt, Et), Et.rShiftTo(1, Et)) : (bt.subTo(Et, bt), bt.rShiftTo(1, bt));
      return kt > 0 && bt.lShiftTo(kt, bt), bt;
    }, Je.prototype.isProbablePrime = function(vt) {
      var Et, bt = this.abs();
      if (bt.t == 1 && bt.data[0] <= ht[ht.length - 1]) {
        for (Et = 0; Et < ht.length; ++Et) if (bt.data[0] == ht[Et]) return !0;
        return !1;
      }
      if (bt.isEven()) return !1;
      for (Et = 1; Et < ht.length; ) {
        for (var Rt = ht[Et], St = Et + 1; St < ht.length && Rt < It; ) Rt *= ht[St++];
        for (Rt = bt.modInt(Rt); Et < St; ) if (Rt % ht[Et++] == 0) return !1;
      }
      return bt.millerRabin(vt);
    };
  }, 1169: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    Xe(3103), Xe(4097), Xe(1633), He.exports = Ke.kem = Ke.kem || {};
    var $e = Ke.jsbn.BigInteger;
    function Je(Ze, nt, tt, et) {
      Ze.generate = function(rt, it) {
        for (var ot = new Ke.util.ByteBuffer(), at = Math.ceil(it / et) + tt, st = new Ke.util.ByteBuffer(), ut = tt; ut < at; ++ut) {
          st.putInt32(ut), nt.start(), nt.update(rt + st.getBytes());
          var lt = nt.digest();
          ot.putBytes(lt.getBytes(et));
        }
        return ot.truncate(ot.length() - it), ot.getBytes();
      };
    }
    Ke.kem.rsa = {}, Ke.kem.rsa.create = function(Ze, nt) {
      var tt = (nt = nt || {}).prng || Ke.random;
      return { encrypt: function(et, rt) {
        var it, ot = Math.ceil(et.n.bitLength() / 8);
        do
          it = new $e(Ke.util.bytesToHex(tt.getBytesSync(ot)), 16).mod(et.n);
        while (it.compareTo($e.ONE) <= 0);
        var at = ot - (it = Ke.util.hexToBytes(it.toString(16))).length;
        return at > 0 && (it = Ke.util.fillString("\0", at) + it), { encapsulation: et.encrypt(it, "NONE"), key: Ze.generate(it, rt) };
      }, decrypt: function(et, rt, it) {
        var ot = et.decrypt(rt, "NONE");
        return Ze.generate(ot, it);
      } };
    }, Ke.kem.kdf1 = function(Ze, nt) {
      Je(this, Ze, 0, nt || Ze.digestLength);
    }, Ke.kem.kdf2 = function(Ze, nt) {
      Je(this, Ze, 1, nt || Ze.digestLength);
    };
  }, 7316: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    Xe(3103), He.exports = Ke.log = Ke.log || {}, Ke.log.levels = ["none", "error", "warning", "info", "debug", "verbose", "max"];
    var $e = {}, Je = [], Ze = null;
    Ke.log.LEVEL_LOCKED = 2, Ke.log.NO_LEVEL_CHECK = 4, Ke.log.INTERPOLATE = 8;
    for (var nt = 0; nt < Ke.log.levels.length; ++nt) {
      var tt = Ke.log.levels[nt];
      $e[tt] = { index: nt, name: tt.toUpperCase() };
    }
    Ke.log.logMessage = function(st) {
      for (var ut = $e[st.level].index, lt = 0; lt < Je.length; ++lt) {
        var dt = Je[lt];
        dt.flags & Ke.log.NO_LEVEL_CHECK ? dt.f(st) : ut <= $e[dt.level].index && dt.f(dt, st);
      }
    }, Ke.log.prepareStandard = function(st) {
      "standard" in st || (st.standard = $e[st.level].name + " [" + st.category + "] " + st.message);
    }, Ke.log.prepareFull = function(st) {
      if (!("full" in st)) {
        var ut = [st.message];
        ut = ut.concat([]), st.full = Ke.util.format.apply(this, ut);
      }
    }, Ke.log.prepareStandardFull = function(st) {
      "standardFull" in st || (Ke.log.prepareStandard(st), st.standardFull = st.standard);
    };
    var et = ["error", "warning", "info", "debug", "verbose"];
    for (nt = 0; nt < et.length; ++nt) (function(st) {
      Ke.log[st] = function(ut, lt) {
        var dt = Array.prototype.slice.call(arguments).slice(2), At = { timestamp: /* @__PURE__ */ new Date(), level: st, category: ut, message: lt, arguments: dt };
        Ke.log.logMessage(At);
      };
    })(et[nt]);
    if (Ke.log.makeLogger = function(st) {
      var ut = { flags: 0, f: st };
      return Ke.log.setLevel(ut, "none"), ut;
    }, Ke.log.setLevel = function(st, ut) {
      var lt = !1;
      if (st && !(st.flags & Ke.log.LEVEL_LOCKED)) {
        for (var dt = 0; dt < Ke.log.levels.length; ++dt) if (ut == Ke.log.levels[dt]) {
          st.level = ut, lt = !0;
          break;
        }
      }
      return lt;
    }, Ke.log.lock = function(st, ut) {
      ut === void 0 || ut ? st.flags |= Ke.log.LEVEL_LOCKED : st.flags &= ~Ke.log.LEVEL_LOCKED;
    }, Ke.log.addLogger = function(st) {
      Je.push(st);
    }, typeof console < "u" && "log" in console) {
      var rt;
      if (console.error && console.warn && console.info && console.debug) {
        var it = { error: console.error, warning: console.warn, info: console.info, debug: console.debug, verbose: console.debug }, ot = function(st, ut) {
          Ke.log.prepareStandard(ut);
          var lt = it[ut.level], dt = [ut.standard];
          dt = dt.concat(ut.arguments.slice()), lt.apply(console, dt);
        };
        rt = Ke.log.makeLogger(ot);
      } else ot = function(st, ut) {
        Ke.log.prepareStandardFull(ut), console.log(ut.standardFull);
      }, rt = Ke.log.makeLogger(ot);
      Ke.log.setLevel(rt, "debug"), Ke.log.addLogger(rt), Ze = rt;
    } else console = { log: function() {
    } };
    if (Ze !== null && typeof window < "u" && window.location) {
      var at = new URL(window.location.href).searchParams;
      at.has("console.level") && Ke.log.setLevel(Ze, at.get("console.level").slice(-1)[0]), at.has("console.lock") && at.get("console.lock").slice(-1)[0] == "true" && Ke.log.lock(Ze);
    }
    Ke.log.consoleLogger = Ze;
  }, 7847: (He, Ge, Xe) => {
    He.exports = Xe(6067), Xe(4581), Xe(2936), Xe(9141), Xe(8672);
  }, 6067: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    He.exports = Ke.md = Ke.md || {}, Ke.md.algorithms = Ke.md.algorithms || {};
  }, 4581: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    Xe(6067), Xe(3103);
    var $e = He.exports = Ke.md5 = Ke.md5 || {};
    Ke.md.md5 = Ke.md.algorithms.md5 = $e, $e.create = function() {
      et || function() {
        Je = "", Je += Ke.util.fillString("\0", 64), Ze = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 1, 6, 11, 0, 5, 10, 15, 4, 9, 14, 3, 8, 13, 2, 7, 12, 5, 8, 11, 14, 1, 4, 7, 10, 13, 0, 3, 6, 9, 12, 15, 2, 0, 7, 14, 5, 12, 3, 10, 1, 8, 15, 6, 13, 4, 11, 2, 9], nt = [7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21], tt = new Array(64);
        for (var ut = 0; ut < 64; ++ut) tt[ut] = Math.floor(4294967296 * Math.abs(Math.sin(ut + 1)));
        et = !0;
      }();
      var it = null, ot = Ke.util.createBuffer(), at = new Array(16), st = { algorithm: "md5", blockLength: 64, digestLength: 16, messageLength: 0, fullMessageLength: null, messageLengthSize: 8, start: function() {
        st.messageLength = 0, st.fullMessageLength = st.messageLength64 = [];
        for (var ut = st.messageLengthSize / 4, lt = 0; lt < ut; ++lt) st.fullMessageLength.push(0);
        return ot = Ke.util.createBuffer(), it = { h0: 1732584193, h1: 4023233417, h2: 2562383102, h3: 271733878 }, st;
      } };
      return st.start(), st.update = function(ut, lt) {
        lt === "utf8" && (ut = Ke.util.encodeUtf8(ut));
        var dt = ut.length;
        st.messageLength += dt, dt = [dt / 4294967296 >>> 0, dt >>> 0];
        for (var At = st.fullMessageLength.length - 1; At >= 0; --At) st.fullMessageLength[At] += dt[1], dt[1] = dt[0] + (st.fullMessageLength[At] / 4294967296 >>> 0), st.fullMessageLength[At] = st.fullMessageLength[At] >>> 0, dt[0] = dt[1] / 4294967296 >>> 0;
        return ot.putBytes(ut), rt(it, at, ot), (ot.read > 2048 || ot.length() === 0) && ot.compact(), st;
      }, st.digest = function() {
        var ut = Ke.util.createBuffer();
        ut.putBytes(ot.bytes());
        var lt = st.fullMessageLength[st.fullMessageLength.length - 1] + st.messageLengthSize & st.blockLength - 1;
        ut.putBytes(Je.substr(0, st.blockLength - lt));
        for (var dt, At = 0, pt = st.fullMessageLength.length - 1; pt >= 0; --pt) At = (dt = 8 * st.fullMessageLength[pt] + At) / 4294967296 >>> 0, ut.putInt32Le(dt >>> 0);
        var gt = { h0: it.h0, h1: it.h1, h2: it.h2, h3: it.h3 };
        rt(gt, at, ut);
        var wt = Ke.util.createBuffer();
        return wt.putInt32Le(gt.h0), wt.putInt32Le(gt.h1), wt.putInt32Le(gt.h2), wt.putInt32Le(gt.h3), wt;
      }, st;
    };
    var Je = null, Ze = null, nt = null, tt = null, et = !1;
    function rt(it, ot, at) {
      for (var st, ut, lt, dt, At, pt, gt, wt = at.length(); wt >= 64; ) {
        for (ut = it.h0, lt = it.h1, dt = it.h2, At = it.h3, gt = 0; gt < 16; ++gt) ot[gt] = at.getInt32Le(), st = ut + (At ^ lt & (dt ^ At)) + tt[gt] + ot[gt], ut = At, At = dt, dt = lt, lt += st << (pt = nt[gt]) | st >>> 32 - pt;
        for (; gt < 32; ++gt) st = ut + (dt ^ At & (lt ^ dt)) + tt[gt] + ot[Ze[gt]], ut = At, At = dt, dt = lt, lt += st << (pt = nt[gt]) | st >>> 32 - pt;
        for (; gt < 48; ++gt) st = ut + (lt ^ dt ^ At) + tt[gt] + ot[Ze[gt]], ut = At, At = dt, dt = lt, lt += st << (pt = nt[gt]) | st >>> 32 - pt;
        for (; gt < 64; ++gt) st = ut + (dt ^ (lt | ~At)) + tt[gt] + ot[Ze[gt]], ut = At, At = dt, dt = lt, lt += st << (pt = nt[gt]) | st >>> 32 - pt;
        it.h0 = it.h0 + ut | 0, it.h1 = it.h1 + lt | 0, it.h2 = it.h2 + dt | 0, it.h3 = it.h3 + At | 0, wt -= 64;
      }
    }
  }, 826: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    Xe(5024), He.exports = Ke.mgf = Ke.mgf || {}, Ke.mgf.mgf1 = Ke.mgf1;
  }, 5024: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    Xe(3103), Ke.mgf = Ke.mgf || {}, (He.exports = Ke.mgf.mgf1 = Ke.mgf1 = Ke.mgf1 || {}).create = function($e) {
      return { generate: function(Je, Ze) {
        for (var nt = new Ke.util.ByteBuffer(), tt = Math.ceil(Ze / $e.digestLength), et = 0; et < tt; et++) {
          var rt = new Ke.util.ByteBuffer();
          rt.putInt32(et), $e.start(), $e.update(Je + rt.getBytes()), nt.putBuffer($e.digest());
        }
        return nt.truncate(nt.length() - Ze), nt.getBytes();
      } };
    };
  }, 2884: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    Ke.pki = Ke.pki || {};
    var $e = He.exports = Ke.pki.oids = Ke.oids = Ke.oids || {};
    function Je(nt, tt) {
      $e[nt] = tt, $e[tt] = nt;
    }
    function Ze(nt, tt) {
      $e[nt] = tt;
    }
    Je("1.2.840.113549.1.1.1", "rsaEncryption"), Je("1.2.840.113549.1.1.4", "md5WithRSAEncryption"), Je("1.2.840.113549.1.1.5", "sha1WithRSAEncryption"), Je("1.2.840.113549.1.1.7", "RSAES-OAEP"), Je("1.2.840.113549.1.1.8", "mgf1"), Je("1.2.840.113549.1.1.9", "pSpecified"), Je("1.2.840.113549.1.1.10", "RSASSA-PSS"), Je("1.2.840.113549.1.1.11", "sha256WithRSAEncryption"), Je("1.2.840.113549.1.1.12", "sha384WithRSAEncryption"), Je("1.2.840.113549.1.1.13", "sha512WithRSAEncryption"), Je("1.3.101.112", "EdDSA25519"), Je("1.2.840.10040.4.3", "dsa-with-sha1"), Je("1.3.14.3.2.7", "desCBC"), Je("1.3.14.3.2.26", "sha1"), Je("1.3.14.3.2.29", "sha1WithRSASignature"), Je("2.16.840.1.101.3.4.2.1", "sha256"), Je("2.16.840.1.101.3.4.2.2", "sha384"), Je("2.16.840.1.101.3.4.2.3", "sha512"), Je("2.16.840.1.101.3.4.2.4", "sha224"), Je("2.16.840.1.101.3.4.2.5", "sha512-224"), Je("2.16.840.1.101.3.4.2.6", "sha512-256"), Je("1.2.840.113549.2.2", "md2"), Je("1.2.840.113549.2.5", "md5"), Je("1.2.840.113549.1.7.1", "data"), Je("1.2.840.113549.1.7.2", "signedData"), Je("1.2.840.113549.1.7.3", "envelopedData"), Je("1.2.840.113549.1.7.4", "signedAndEnvelopedData"), Je("1.2.840.113549.1.7.5", "digestedData"), Je("1.2.840.113549.1.7.6", "encryptedData"), Je("1.2.840.113549.1.9.1", "emailAddress"), Je("1.2.840.113549.1.9.2", "unstructuredName"), Je("1.2.840.113549.1.9.3", "contentType"), Je("1.2.840.113549.1.9.4", "messageDigest"), Je("1.2.840.113549.1.9.5", "signingTime"), Je("1.2.840.113549.1.9.6", "counterSignature"), Je("1.2.840.113549.1.9.7", "challengePassword"), Je("1.2.840.113549.1.9.8", "unstructuredAddress"), Je("1.2.840.113549.1.9.14", "extensionRequest"), Je("1.2.840.113549.1.9.20", "friendlyName"), Je("1.2.840.113549.1.9.21", "localKeyId"), Je("1.2.840.113549.1.9.22.1", "x509Certificate"), Je("1.2.840.113549.1.12.10.1.1", "keyBag"), Je("1.2.840.113549.1.12.10.1.2", "pkcs8ShroudedKeyBag"), Je("1.2.840.113549.1.12.10.1.3", "certBag"), Je("1.2.840.113549.1.12.10.1.4", "crlBag"), Je("1.2.840.113549.1.12.10.1.5", "secretBag"), Je("1.2.840.113549.1.12.10.1.6", "safeContentsBag"), Je("1.2.840.113549.1.5.13", "pkcs5PBES2"), Je("1.2.840.113549.1.5.12", "pkcs5PBKDF2"), Je("1.2.840.113549.1.12.1.1", "pbeWithSHAAnd128BitRC4"), Je("1.2.840.113549.1.12.1.2", "pbeWithSHAAnd40BitRC4"), Je("1.2.840.113549.1.12.1.3", "pbeWithSHAAnd3-KeyTripleDES-CBC"), Je("1.2.840.113549.1.12.1.4", "pbeWithSHAAnd2-KeyTripleDES-CBC"), Je("1.2.840.113549.1.12.1.5", "pbeWithSHAAnd128BitRC2-CBC"), Je("1.2.840.113549.1.12.1.6", "pbewithSHAAnd40BitRC2-CBC"), Je("1.2.840.113549.2.7", "hmacWithSHA1"), Je("1.2.840.113549.2.8", "hmacWithSHA224"), Je("1.2.840.113549.2.9", "hmacWithSHA256"), Je("1.2.840.113549.2.10", "hmacWithSHA384"), Je("1.2.840.113549.2.11", "hmacWithSHA512"), Je("1.2.840.113549.3.7", "des-EDE3-CBC"), Je("2.16.840.1.101.3.4.1.2", "aes128-CBC"), Je("2.16.840.1.101.3.4.1.22", "aes192-CBC"), Je("2.16.840.1.101.3.4.1.42", "aes256-CBC"), Je("2.5.4.3", "commonName"), Je("2.5.4.4", "surname"), Je("2.5.4.5", "serialNumber"), Je("2.5.4.6", "countryName"), Je("2.5.4.7", "localityName"), Je("2.5.4.8", "stateOrProvinceName"), Je("2.5.4.9", "streetAddress"), Je("2.5.4.10", "organizationName"), Je("2.5.4.11", "organizationalUnitName"), Je("2.5.4.12", "title"), Je("2.5.4.13", "description"), Je("2.5.4.15", "businessCategory"), Je("2.5.4.17", "postalCode"), Je("2.5.4.42", "givenName"), Je("1.3.6.1.4.1.311.60.2.1.2", "jurisdictionOfIncorporationStateOrProvinceName"), Je("1.3.6.1.4.1.311.60.2.1.3", "jurisdictionOfIncorporationCountryName"), Je("2.16.840.1.113730.1.1", "nsCertType"), Je("2.16.840.1.113730.1.13", "nsComment"), Ze("2.5.29.1", "authorityKeyIdentifier"), Ze("2.5.29.2", "keyAttributes"), Ze("2.5.29.3", "certificatePolicies"), Ze("2.5.29.4", "keyUsageRestriction"), Ze("2.5.29.5", "policyMapping"), Ze("2.5.29.6", "subtreesConstraint"), Ze("2.5.29.7", "subjectAltName"), Ze("2.5.29.8", "issuerAltName"), Ze("2.5.29.9", "subjectDirectoryAttributes"), Ze("2.5.29.10", "basicConstraints"), Ze("2.5.29.11", "nameConstraints"), Ze("2.5.29.12", "policyConstraints"), Ze("2.5.29.13", "basicConstraints"), Je("2.5.29.14", "subjectKeyIdentifier"), Je("2.5.29.15", "keyUsage"), Ze("2.5.29.16", "privateKeyUsagePeriod"), Je("2.5.29.17", "subjectAltName"), Je("2.5.29.18", "issuerAltName"), Je("2.5.29.19", "basicConstraints"), Ze("2.5.29.20", "cRLNumber"), Ze("2.5.29.21", "cRLReason"), Ze("2.5.29.22", "expirationDate"), Ze("2.5.29.23", "instructionCode"), Ze("2.5.29.24", "invalidityDate"), Ze("2.5.29.25", "cRLDistributionPoints"), Ze("2.5.29.26", "issuingDistributionPoint"), Ze("2.5.29.27", "deltaCRLIndicator"), Ze("2.5.29.28", "issuingDistributionPoint"), Ze("2.5.29.29", "certificateIssuer"), Ze("2.5.29.30", "nameConstraints"), Je("2.5.29.31", "cRLDistributionPoints"), Je("2.5.29.32", "certificatePolicies"), Ze("2.5.29.33", "policyMappings"), Ze("2.5.29.34", "policyConstraints"), Je("2.5.29.35", "authorityKeyIdentifier"), Ze("2.5.29.36", "policyConstraints"), Je("2.5.29.37", "extKeyUsage"), Ze("2.5.29.46", "freshestCRL"), Ze("2.5.29.54", "inhibitAnyPolicy"), Je("1.3.6.1.4.1.11129.2.4.2", "timestampList"), Je("1.3.6.1.5.5.7.1.1", "authorityInfoAccess"), Je("1.3.6.1.5.5.7.3.1", "serverAuth"), Je("1.3.6.1.5.5.7.3.2", "clientAuth"), Je("1.3.6.1.5.5.7.3.3", "codeSigning"), Je("1.3.6.1.5.5.7.3.4", "emailProtection"), Je("1.3.6.1.5.5.7.3.8", "timeStamping");
  }, 6635: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    if (Xe(1482), Xe(2624), Xe(2023), Xe(6067), Xe(2884), Xe(9580), Xe(5477), Xe(4097), Xe(3323), Xe(144), Xe(3103), $e === void 0) var $e = Ke.jsbn.BigInteger;
    var Je = Ke.asn1, Ze = Ke.pki = Ke.pki || {};
    He.exports = Ze.pbe = Ke.pbe = Ke.pbe || {};
    var nt = Ze.oids, tt = { name: "EncryptedPrivateKeyInfo", tagClass: Je.Class.UNIVERSAL, type: Je.Type.SEQUENCE, constructed: !0, value: [{ name: "EncryptedPrivateKeyInfo.encryptionAlgorithm", tagClass: Je.Class.UNIVERSAL, type: Je.Type.SEQUENCE, constructed: !0, value: [{ name: "AlgorithmIdentifier.algorithm", tagClass: Je.Class.UNIVERSAL, type: Je.Type.OID, constructed: !1, capture: "encryptionOid" }, { name: "AlgorithmIdentifier.parameters", tagClass: Je.Class.UNIVERSAL, type: Je.Type.SEQUENCE, constructed: !0, captureAsn1: "encryptionParams" }] }, { name: "EncryptedPrivateKeyInfo.encryptedData", tagClass: Je.Class.UNIVERSAL, type: Je.Type.OCTETSTRING, constructed: !1, capture: "encryptedData" }] }, et = { name: "PBES2Algorithms", tagClass: Je.Class.UNIVERSAL, type: Je.Type.SEQUENCE, constructed: !0, value: [{ name: "PBES2Algorithms.keyDerivationFunc", tagClass: Je.Class.UNIVERSAL, type: Je.Type.SEQUENCE, constructed: !0, value: [{ name: "PBES2Algorithms.keyDerivationFunc.oid", tagClass: Je.Class.UNIVERSAL, type: Je.Type.OID, constructed: !1, capture: "kdfOid" }, { name: "PBES2Algorithms.params", tagClass: Je.Class.UNIVERSAL, type: Je.Type.SEQUENCE, constructed: !0, value: [{ name: "PBES2Algorithms.params.salt", tagClass: Je.Class.UNIVERSAL, type: Je.Type.OCTETSTRING, constructed: !1, capture: "kdfSalt" }, { name: "PBES2Algorithms.params.iterationCount", tagClass: Je.Class.UNIVERSAL, type: Je.Type.INTEGER, constructed: !1, capture: "kdfIterationCount" }, { name: "PBES2Algorithms.params.keyLength", tagClass: Je.Class.UNIVERSAL, type: Je.Type.INTEGER, constructed: !1, optional: !0, capture: "keyLength" }, { name: "PBES2Algorithms.params.prf", tagClass: Je.Class.UNIVERSAL, type: Je.Type.SEQUENCE, constructed: !0, optional: !0, value: [{ name: "PBES2Algorithms.params.prf.algorithm", tagClass: Je.Class.UNIVERSAL, type: Je.Type.OID, constructed: !1, capture: "prfOid" }] }] }] }, { name: "PBES2Algorithms.encryptionScheme", tagClass: Je.Class.UNIVERSAL, type: Je.Type.SEQUENCE, constructed: !0, value: [{ name: "PBES2Algorithms.encryptionScheme.oid", tagClass: Je.Class.UNIVERSAL, type: Je.Type.OID, constructed: !1, capture: "encOid" }, { name: "PBES2Algorithms.encryptionScheme.iv", tagClass: Je.Class.UNIVERSAL, type: Je.Type.OCTETSTRING, constructed: !1, capture: "encIv" }] }] }, rt = { name: "pkcs-12PbeParams", tagClass: Je.Class.UNIVERSAL, type: Je.Type.SEQUENCE, constructed: !0, value: [{ name: "pkcs-12PbeParams.salt", tagClass: Je.Class.UNIVERSAL, type: Je.Type.OCTETSTRING, constructed: !1, capture: "salt" }, { name: "pkcs-12PbeParams.iterations", tagClass: Je.Class.UNIVERSAL, type: Je.Type.INTEGER, constructed: !1, capture: "iterations" }] };
    function it(st, ut) {
      return st.start().update(ut).digest().getBytes();
    }
    function ot(st) {
      var ut;
      if (st) {
        if (!(ut = Ze.oids[Je.derToOid(st)])) {
          var lt = new Error("Unsupported PRF OID.");
          throw lt.oid = st, lt.supported = ["hmacWithSHA1", "hmacWithSHA224", "hmacWithSHA256", "hmacWithSHA384", "hmacWithSHA512"], lt;
        }
      } else ut = "hmacWithSHA1";
      return at(ut);
    }
    function at(st) {
      var ut = Ke.md;
      switch (st) {
        case "hmacWithSHA224":
          ut = Ke.md.sha512;
        case "hmacWithSHA1":
        case "hmacWithSHA256":
        case "hmacWithSHA384":
        case "hmacWithSHA512":
          st = st.substr(8).toLowerCase();
          break;
        default:
          var lt = new Error("Unsupported PRF algorithm.");
          throw lt.algorithm = st, lt.supported = ["hmacWithSHA1", "hmacWithSHA224", "hmacWithSHA256", "hmacWithSHA384", "hmacWithSHA512"], lt;
      }
      if (!ut || !(st in ut)) throw new Error("Unknown hash algorithm: " + st);
      return ut[st].create();
    }
    Ze.encryptPrivateKeyInfo = function(st, ut, lt) {
      (lt = lt || {}).saltSize = lt.saltSize || 8, lt.count = lt.count || 2048, lt.algorithm = lt.algorithm || "aes128", lt.prfAlgorithm = lt.prfAlgorithm || "sha1";
      var dt, At, pt, gt = Ke.random.getBytesSync(lt.saltSize), wt = lt.count, Bt = Je.integerToDer(wt);
      if (lt.algorithm.indexOf("aes") === 0 || lt.algorithm === "des") {
        var Tt, yt, Ct;
        switch (lt.algorithm) {
          case "aes128":
            dt = 16, Tt = 16, yt = nt["aes128-CBC"], Ct = Ke.aes.createEncryptionCipher;
            break;
          case "aes192":
            dt = 24, Tt = 16, yt = nt["aes192-CBC"], Ct = Ke.aes.createEncryptionCipher;
            break;
          case "aes256":
            dt = 32, Tt = 16, yt = nt["aes256-CBC"], Ct = Ke.aes.createEncryptionCipher;
            break;
          case "des":
            dt = 8, Tt = 8, yt = nt.desCBC, Ct = Ke.des.createEncryptionCipher;
            break;
          default:
            throw (Rt = new Error("Cannot encrypt private key. Unknown encryption algorithm.")).algorithm = lt.algorithm, Rt;
        }
        var ht = "hmacWith" + lt.prfAlgorithm.toUpperCase(), It = at(ht), vt = Ke.pkcs5.pbkdf2(ut, gt, wt, dt, It), Et = Ke.random.getBytesSync(Tt);
        (St = Ct(vt)).start(Et), St.update(Je.toDer(st)), St.finish(), pt = St.output.getBytes();
        var bt = function(jt, Pt, Qt, qt) {
          var _t = Je.create(Je.Class.UNIVERSAL, Je.Type.SEQUENCE, !0, [Je.create(Je.Class.UNIVERSAL, Je.Type.OCTETSTRING, !1, jt), Je.create(Je.Class.UNIVERSAL, Je.Type.INTEGER, !1, Pt.getBytes())]);
          return qt !== "hmacWithSHA1" && _t.value.push(Je.create(Je.Class.UNIVERSAL, Je.Type.INTEGER, !1, Ke.util.hexToBytes(Qt.toString(16))), Je.create(Je.Class.UNIVERSAL, Je.Type.SEQUENCE, !0, [Je.create(Je.Class.UNIVERSAL, Je.Type.OID, !1, Je.oidToDer(Ze.oids[qt]).getBytes()), Je.create(Je.Class.UNIVERSAL, Je.Type.NULL, !1, "")])), _t;
        }(gt, Bt, dt, ht);
        At = Je.create(Je.Class.UNIVERSAL, Je.Type.SEQUENCE, !0, [Je.create(Je.Class.UNIVERSAL, Je.Type.OID, !1, Je.oidToDer(nt.pkcs5PBES2).getBytes()), Je.create(Je.Class.UNIVERSAL, Je.Type.SEQUENCE, !0, [Je.create(Je.Class.UNIVERSAL, Je.Type.SEQUENCE, !0, [Je.create(Je.Class.UNIVERSAL, Je.Type.OID, !1, Je.oidToDer(nt.pkcs5PBKDF2).getBytes()), bt]), Je.create(Je.Class.UNIVERSAL, Je.Type.SEQUENCE, !0, [Je.create(Je.Class.UNIVERSAL, Je.Type.OID, !1, Je.oidToDer(yt).getBytes()), Je.create(Je.Class.UNIVERSAL, Je.Type.OCTETSTRING, !1, Et)])])]);
      } else {
        var Rt;
        if (lt.algorithm !== "3des") throw (Rt = new Error("Cannot encrypt private key. Unknown encryption algorithm.")).algorithm = lt.algorithm, Rt;
        dt = 24;
        var St, kt = new Ke.util.ByteBuffer(gt);
        vt = Ze.pbe.generatePkcs12Key(ut, kt, 1, wt, dt), Et = Ze.pbe.generatePkcs12Key(ut, kt, 2, wt, dt), (St = Ke.des.createEncryptionCipher(vt)).start(Et), St.update(Je.toDer(st)), St.finish(), pt = St.output.getBytes(), At = Je.create(Je.Class.UNIVERSAL, Je.Type.SEQUENCE, !0, [Je.create(Je.Class.UNIVERSAL, Je.Type.OID, !1, Je.oidToDer(nt["pbeWithSHAAnd3-KeyTripleDES-CBC"]).getBytes()), Je.create(Je.Class.UNIVERSAL, Je.Type.SEQUENCE, !0, [Je.create(Je.Class.UNIVERSAL, Je.Type.OCTETSTRING, !1, gt), Je.create(Je.Class.UNIVERSAL, Je.Type.INTEGER, !1, Bt.getBytes())])]);
      }
      return Je.create(Je.Class.UNIVERSAL, Je.Type.SEQUENCE, !0, [At, Je.create(Je.Class.UNIVERSAL, Je.Type.OCTETSTRING, !1, pt)]);
    }, Ze.decryptPrivateKeyInfo = function(st, ut) {
      var lt = null, dt = {}, At = [];
      if (!Je.validate(st, tt, dt, At)) {
        var pt = new Error("Cannot read encrypted private key. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
        throw pt.errors = At, pt;
      }
      var gt = Je.derToOid(dt.encryptionOid), wt = Ze.pbe.getCipher(gt, dt.encryptionParams, ut), Bt = Ke.util.createBuffer(dt.encryptedData);
      return wt.update(Bt), wt.finish() && (lt = Je.fromDer(wt.output)), lt;
    }, Ze.encryptedPrivateKeyToPem = function(st, ut) {
      var lt = { type: "ENCRYPTED PRIVATE KEY", body: Je.toDer(st).getBytes() };
      return Ke.pem.encode(lt, { maxline: ut });
    }, Ze.encryptedPrivateKeyFromPem = function(st) {
      var ut = Ke.pem.decode(st)[0];
      if (ut.type !== "ENCRYPTED PRIVATE KEY") {
        var lt = new Error('Could not convert encrypted private key from PEM; PEM header type is "ENCRYPTED PRIVATE KEY".');
        throw lt.headerType = ut.type, lt;
      }
      if (ut.procType && ut.procType.type === "ENCRYPTED") throw new Error("Could not convert encrypted private key from PEM; PEM is encrypted.");
      return Je.fromDer(ut.body);
    }, Ze.encryptRsaPrivateKey = function(st, ut, lt) {
      if (!(lt = lt || {}).legacy) {
        var dt = Ze.wrapRsaPrivateKey(Ze.privateKeyToAsn1(st));
        return dt = Ze.encryptPrivateKeyInfo(dt, ut, lt), Ze.encryptedPrivateKeyToPem(dt);
      }
      var At, pt, gt, wt;
      switch (lt.algorithm) {
        case "aes128":
          At = "AES-128-CBC", gt = 16, pt = Ke.random.getBytesSync(16), wt = Ke.aes.createEncryptionCipher;
          break;
        case "aes192":
          At = "AES-192-CBC", gt = 24, pt = Ke.random.getBytesSync(16), wt = Ke.aes.createEncryptionCipher;
          break;
        case "aes256":
          At = "AES-256-CBC", gt = 32, pt = Ke.random.getBytesSync(16), wt = Ke.aes.createEncryptionCipher;
          break;
        case "3des":
          At = "DES-EDE3-CBC", gt = 24, pt = Ke.random.getBytesSync(8), wt = Ke.des.createEncryptionCipher;
          break;
        case "des":
          At = "DES-CBC", gt = 8, pt = Ke.random.getBytesSync(8), wt = Ke.des.createEncryptionCipher;
          break;
        default:
          var Bt = new Error('Could not encrypt RSA private key; unsupported encryption algorithm "' + lt.algorithm + '".');
          throw Bt.algorithm = lt.algorithm, Bt;
      }
      var Tt = wt(Ke.pbe.opensslDeriveBytes(ut, pt.substr(0, 8), gt));
      Tt.start(pt), Tt.update(Je.toDer(Ze.privateKeyToAsn1(st))), Tt.finish();
      var yt = { type: "RSA PRIVATE KEY", procType: { version: "4", type: "ENCRYPTED" }, dekInfo: { algorithm: At, parameters: Ke.util.bytesToHex(pt).toUpperCase() }, body: Tt.output.getBytes() };
      return Ke.pem.encode(yt);
    }, Ze.decryptRsaPrivateKey = function(st, ut) {
      var lt = null, dt = Ke.pem.decode(st)[0];
      if (dt.type !== "ENCRYPTED PRIVATE KEY" && dt.type !== "PRIVATE KEY" && dt.type !== "RSA PRIVATE KEY") throw (gt = new Error('Could not convert private key from PEM; PEM header type is not "ENCRYPTED PRIVATE KEY", "PRIVATE KEY", or "RSA PRIVATE KEY".')).headerType = gt, gt;
      if (dt.procType && dt.procType.type === "ENCRYPTED") {
        var At, pt;
        switch (dt.dekInfo.algorithm) {
          case "DES-CBC":
            At = 8, pt = Ke.des.createDecryptionCipher;
            break;
          case "DES-EDE3-CBC":
            At = 24, pt = Ke.des.createDecryptionCipher;
            break;
          case "AES-128-CBC":
            At = 16, pt = Ke.aes.createDecryptionCipher;
            break;
          case "AES-192-CBC":
            At = 24, pt = Ke.aes.createDecryptionCipher;
            break;
          case "AES-256-CBC":
            At = 32, pt = Ke.aes.createDecryptionCipher;
            break;
          case "RC2-40-CBC":
            At = 5, pt = function(Tt) {
              return Ke.rc2.createDecryptionCipher(Tt, 40);
            };
            break;
          case "RC2-64-CBC":
            At = 8, pt = function(Tt) {
              return Ke.rc2.createDecryptionCipher(Tt, 64);
            };
            break;
          case "RC2-128-CBC":
            At = 16, pt = function(Tt) {
              return Ke.rc2.createDecryptionCipher(Tt, 128);
            };
            break;
          default:
            var gt;
            throw (gt = new Error('Could not decrypt private key; unsupported encryption algorithm "' + dt.dekInfo.algorithm + '".')).algorithm = dt.dekInfo.algorithm, gt;
        }
        var wt = Ke.util.hexToBytes(dt.dekInfo.parameters), Bt = pt(Ke.pbe.opensslDeriveBytes(ut, wt.substr(0, 8), At));
        if (Bt.start(wt), Bt.update(Ke.util.createBuffer(dt.body)), !Bt.finish()) return lt;
        lt = Bt.output.getBytes();
      } else lt = dt.body;
      return (lt = dt.type === "ENCRYPTED PRIVATE KEY" ? Ze.decryptPrivateKeyInfo(Je.fromDer(lt), ut) : Je.fromDer(lt)) !== null && (lt = Ze.privateKeyFromAsn1(lt)), lt;
    }, Ze.pbe.generatePkcs12Key = function(st, ut, lt, dt, At, pt) {
      var gt, wt;
      if (pt == null) {
        if (!("sha1" in Ke.md)) throw new Error('"sha1" hash algorithm unavailable.');
        pt = Ke.md.sha1.create();
      }
      var Bt = pt.digestLength, Tt = pt.blockLength, yt = new Ke.util.ByteBuffer(), Ct = new Ke.util.ByteBuffer();
      if (st != null) {
        for (wt = 0; wt < st.length; wt++) Ct.putInt16(st.charCodeAt(wt));
        Ct.putInt16(0);
      }
      var ht = Ct.length(), It = ut.length(), vt = new Ke.util.ByteBuffer();
      vt.fillWithByte(lt, Tt);
      var Et = Tt * Math.ceil(It / Tt), bt = new Ke.util.ByteBuffer();
      for (wt = 0; wt < Et; wt++) bt.putByte(ut.at(wt % It));
      var Rt = Tt * Math.ceil(ht / Tt), St = new Ke.util.ByteBuffer();
      for (wt = 0; wt < Rt; wt++) St.putByte(Ct.at(wt % ht));
      var kt = bt;
      kt.putBuffer(St);
      for (var jt = Math.ceil(At / Bt), Pt = 1; Pt <= jt; Pt++) {
        var Qt = new Ke.util.ByteBuffer();
        Qt.putBytes(vt.bytes()), Qt.putBytes(kt.bytes());
        for (var qt = 0; qt < dt; qt++) pt.start(), pt.update(Qt.getBytes()), Qt = pt.digest();
        var _t = new Ke.util.ByteBuffer();
        for (wt = 0; wt < Tt; wt++) _t.putByte(Qt.at(wt % Bt));
        var Yt = Math.ceil(It / Tt) + Math.ceil(ht / Tt), Xt = new Ke.util.ByteBuffer();
        for (gt = 0; gt < Yt; gt++) {
          var Ut = new Ke.util.ByteBuffer(kt.getBytes(Tt)), Lt = 511;
          for (wt = _t.length() - 1; wt >= 0; wt--) Lt >>= 8, Lt += _t.at(wt) + Ut.at(wt), Ut.setAt(wt, 255 & Lt);
          Xt.putBuffer(Ut);
        }
        kt = Xt, yt.putBuffer(Qt);
      }
      return yt.truncate(yt.length() - At), yt;
    }, Ze.pbe.getCipher = function(st, ut, lt) {
      switch (st) {
        case Ze.oids.pkcs5PBES2:
          return Ze.pbe.getCipherForPBES2(st, ut, lt);
        case Ze.oids["pbeWithSHAAnd3-KeyTripleDES-CBC"]:
        case Ze.oids["pbewithSHAAnd40BitRC2-CBC"]:
          return Ze.pbe.getCipherForPKCS12PBE(st, ut, lt);
        default:
          var dt = new Error("Cannot read encrypted PBE data block. Unsupported OID.");
          throw dt.oid = st, dt.supportedOids = ["pkcs5PBES2", "pbeWithSHAAnd3-KeyTripleDES-CBC", "pbewithSHAAnd40BitRC2-CBC"], dt;
      }
    }, Ze.pbe.getCipherForPBES2 = function(st, ut, lt) {
      var dt, At = {}, pt = [];
      if (!Je.validate(ut, et, At, pt)) throw (dt = new Error("Cannot read password-based-encryption algorithm parameters. ASN.1 object is not a supported EncryptedPrivateKeyInfo.")).errors = pt, dt;
      if ((st = Je.derToOid(At.kdfOid)) !== Ze.oids.pkcs5PBKDF2) throw (dt = new Error("Cannot read encrypted private key. Unsupported key derivation function OID.")).oid = st, dt.supportedOids = ["pkcs5PBKDF2"], dt;
      if ((st = Je.derToOid(At.encOid)) !== Ze.oids["aes128-CBC"] && st !== Ze.oids["aes192-CBC"] && st !== Ze.oids["aes256-CBC"] && st !== Ze.oids["des-EDE3-CBC"] && st !== Ze.oids.desCBC) throw (dt = new Error("Cannot read encrypted private key. Unsupported encryption scheme OID.")).oid = st, dt.supportedOids = ["aes128-CBC", "aes192-CBC", "aes256-CBC", "des-EDE3-CBC", "desCBC"], dt;
      var gt, wt, Bt = At.kdfSalt, Tt = Ke.util.createBuffer(At.kdfIterationCount);
      switch (Tt = Tt.getInt(Tt.length() << 3), Ze.oids[st]) {
        case "aes128-CBC":
          gt = 16, wt = Ke.aes.createDecryptionCipher;
          break;
        case "aes192-CBC":
          gt = 24, wt = Ke.aes.createDecryptionCipher;
          break;
        case "aes256-CBC":
          gt = 32, wt = Ke.aes.createDecryptionCipher;
          break;
        case "des-EDE3-CBC":
          gt = 24, wt = Ke.des.createDecryptionCipher;
          break;
        case "desCBC":
          gt = 8, wt = Ke.des.createDecryptionCipher;
      }
      var yt = ot(At.prfOid), Ct = Ke.pkcs5.pbkdf2(lt, Bt, Tt, gt, yt), ht = At.encIv, It = wt(Ct);
      return It.start(ht), It;
    }, Ze.pbe.getCipherForPKCS12PBE = function(st, ut, lt) {
      var dt = {}, At = [];
      if (!Je.validate(ut, rt, dt, At)) throw (yt = new Error("Cannot read password-based-encryption algorithm parameters. ASN.1 object is not a supported EncryptedPrivateKeyInfo.")).errors = At, yt;
      var pt, gt, wt, Bt = Ke.util.createBuffer(dt.salt), Tt = Ke.util.createBuffer(dt.iterations);
      switch (Tt = Tt.getInt(Tt.length() << 3), st) {
        case Ze.oids["pbeWithSHAAnd3-KeyTripleDES-CBC"]:
          pt = 24, gt = 8, wt = Ke.des.startDecrypting;
          break;
        case Ze.oids["pbewithSHAAnd40BitRC2-CBC"]:
          pt = 5, gt = 8, wt = function(It, vt) {
            var Et = Ke.rc2.createDecryptionCipher(It, 40);
            return Et.start(vt, null), Et;
          };
          break;
        default:
          var yt;
          throw (yt = new Error("Cannot read PKCS #12 PBE data block. Unsupported OID.")).oid = st, yt;
      }
      var Ct = ot(dt.prfOid), ht = Ze.pbe.generatePkcs12Key(lt, Bt, 1, Tt, pt, Ct);
      return Ct.start(), wt(ht, Ze.pbe.generatePkcs12Key(lt, Bt, 2, Tt, gt, Ct));
    }, Ze.pbe.opensslDeriveBytes = function(st, ut, lt, dt) {
      if (dt == null) {
        if (!("md5" in Ke.md)) throw new Error('"md5" hash algorithm unavailable.');
        dt = Ke.md.md5.create();
      }
      ut === null && (ut = "");
      for (var At = [it(dt, st + ut)], pt = 16, gt = 1; pt < lt; ++gt, pt += 16) At.push(it(dt, At[gt - 1] + st + ut));
      return At.join("").substr(0, lt);
    };
  }, 9580: (He, Ge, Xe) => {
    var Ke = Xe(7573).Buffer, $e = Xe(7768);
    Xe(7461), Xe(6067), Xe(3103);
    var Je, Ze = $e.pkcs5 = $e.pkcs5 || {};
    $e.util.isNodejs && !$e.options.usePureJavaScript && (Je = Xe(5942)), He.exports = $e.pbkdf2 = Ze.pbkdf2 = function(nt, tt, et, rt, it, ot) {
      if (typeof it == "function" && (ot = it, it = null), $e.util.isNodejs && !$e.options.usePureJavaScript && Je.pbkdf2 && (it === null || typeof it != "object") && (Je.pbkdf2Sync.length > 4 || !it || it === "sha1")) return typeof it != "string" && (it = "sha1"), nt = Ke.from(nt, "binary"), tt = Ke.from(tt, "binary"), ot ? Je.pbkdf2Sync.length === 4 ? Je.pbkdf2(nt, tt, et, rt, function(ht, It) {
        if (ht) return ot(ht);
        ot(null, It.toString("binary"));
      }) : Je.pbkdf2(nt, tt, et, rt, it, function(ht, It) {
        if (ht) return ot(ht);
        ot(null, It.toString("binary"));
      }) : Je.pbkdf2Sync.length === 4 ? Je.pbkdf2Sync(nt, tt, et, rt).toString("binary") : Je.pbkdf2Sync(nt, tt, et, rt, it).toString("binary");
      if (it == null && (it = "sha1"), typeof it == "string") {
        if (!(it in $e.md.algorithms)) throw new Error("Unknown hash algorithm: " + it);
        it = $e.md[it].create();
      }
      var at = it.digestLength;
      if (rt > 4294967295 * at) {
        var st = new Error("Derived key is too long.");
        if (ot) return ot(st);
        throw st;
      }
      var ut = Math.ceil(rt / at), lt = rt - (ut - 1) * at, dt = $e.hmac.create();
      dt.start(it, nt);
      var At, pt, gt, wt = "";
      if (!ot) {
        for (var Bt = 1; Bt <= ut; ++Bt) {
          dt.start(null, null), dt.update(tt), dt.update($e.util.int32ToBytes(Bt)), At = gt = dt.digest().getBytes();
          for (var Tt = 2; Tt <= et; ++Tt) dt.start(null, null), dt.update(gt), pt = dt.digest().getBytes(), At = $e.util.xorBytes(At, pt, at), gt = pt;
          wt += Bt < ut ? At : At.substr(0, lt);
        }
        return wt;
      }
      function yt() {
        if (Bt > ut) return ot(null, wt);
        dt.start(null, null), dt.update(tt), dt.update($e.util.int32ToBytes(Bt)), At = gt = dt.digest().getBytes(), Tt = 2, Ct();
      }
      function Ct() {
        if (Tt <= et) return dt.start(null, null), dt.update(gt), pt = dt.digest().getBytes(), At = $e.util.xorBytes(At, pt, at), gt = pt, ++Tt, $e.util.setImmediate(Ct);
        wt += Bt < ut ? At : At.substr(0, lt), ++Bt, yt();
      }
      Bt = 1, yt();
    };
  }, 5477: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    Xe(3103);
    var $e = He.exports = Ke.pem = Ke.pem || {};
    function Je(nt) {
      for (var tt = nt.name + ": ", et = [], rt = function(ut, lt) {
        return " " + lt;
      }, it = 0; it < nt.values.length; ++it) et.push(nt.values[it].replace(/^(\S+\r\n)/, rt));
      tt += et.join(",") + `\r
`;
      var ot = 0, at = -1;
      for (it = 0; it < tt.length; ++it, ++ot) if (ot > 65 && at !== -1) {
        var st = tt[at];
        st === "," ? (++at, tt = tt.substr(0, at) + `\r
 ` + tt.substr(at)) : tt = tt.substr(0, at) + `\r
` + st + tt.substr(at + 1), ot = it - at - 1, at = -1, ++it;
      } else tt[it] !== " " && tt[it] !== "	" && tt[it] !== "," || (at = it);
      return tt;
    }
    function Ze(nt) {
      return nt.replace(/^\s+/, "");
    }
    $e.encode = function(nt, tt) {
      tt = tt || {};
      var et, rt = "-----BEGIN " + nt.type + `-----\r
`;
      if (nt.procType && (rt += Je(et = { name: "Proc-Type", values: [String(nt.procType.version), nt.procType.type] })), nt.contentDomain && (rt += Je(et = { name: "Content-Domain", values: [nt.contentDomain] })), nt.dekInfo && (et = { name: "DEK-Info", values: [nt.dekInfo.algorithm] }, nt.dekInfo.parameters && et.values.push(nt.dekInfo.parameters), rt += Je(et)), nt.headers) for (var it = 0; it < nt.headers.length; ++it) rt += Je(nt.headers[it]);
      return nt.procType && (rt += `\r
`), (rt += Ke.util.encode64(nt.body, tt.maxline || 64) + `\r
`) + "-----END " + nt.type + `-----\r
`;
    }, $e.decode = function(nt) {
      for (var tt, et = [], rt = /\s*-----BEGIN ([A-Z0-9- ]+)-----\r?\n?([\x21-\x7e\s]+?(?:\r?\n\r?\n))?([:A-Za-z0-9+\/=\s]+?)-----END \1-----/g, it = /([\x21-\x7e]+):\s*([\x21-\x7e\s^:]+)/, ot = /\r?\n/; tt = rt.exec(nt); ) {
        var at = tt[1];
        at === "NEW CERTIFICATE REQUEST" && (at = "CERTIFICATE REQUEST");
        var st = { type: at, procType: null, contentDomain: null, dekInfo: null, headers: [], body: Ke.util.decode64(tt[3]) };
        if (et.push(st), tt[2]) {
          for (var ut = tt[2].split(ot), lt = 0; tt && lt < ut.length; ) {
            for (var dt = ut[lt].replace(/\s+$/, ""), At = lt + 1; At < ut.length; ++At) {
              var pt = ut[At];
              if (!/\s/.test(pt[0])) break;
              dt += pt, lt = At;
            }
            if (tt = dt.match(it)) {
              for (var gt = { name: tt[1], values: [] }, wt = tt[2].split(","), Bt = 0; Bt < wt.length; ++Bt) gt.values.push(Ze(wt[Bt]));
              if (st.procType) if (st.contentDomain || gt.name !== "Content-Domain") if (st.dekInfo || gt.name !== "DEK-Info") st.headers.push(gt);
              else {
                if (gt.values.length === 0) throw new Error('Invalid PEM formatted message. The "DEK-Info" header must have at least one subfield.');
                st.dekInfo = { algorithm: wt[0], parameters: wt[1] || null };
              }
              else st.contentDomain = wt[0] || "";
              else {
                if (gt.name !== "Proc-Type") throw new Error('Invalid PEM formatted message. The first encapsulated header must be "Proc-Type".');
                if (gt.values.length !== 2) throw new Error('Invalid PEM formatted message. The "Proc-Type" header must have two subfields.');
                st.procType = { version: wt[0], type: wt[1] };
              }
            }
            ++lt;
          }
          if (st.procType === "ENCRYPTED" && !st.dekInfo) throw new Error('Invalid PEM formatted message. The "DEK-Info" header must be present if "Proc-Type" is "ENCRYPTED".');
        }
      }
      if (et.length === 0) throw new Error("Invalid PEM formatted message.");
      return et;
    };
  }, 4034: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    Xe(3103), Xe(4097), Xe(2936);
    var $e = He.exports = Ke.pkcs1 = Ke.pkcs1 || {};
    function Je(Ze, nt, tt) {
      tt || (tt = Ke.md.sha1.create());
      for (var et = "", rt = Math.ceil(nt / tt.digestLength), it = 0; it < rt; ++it) {
        var ot = String.fromCharCode(it >> 24 & 255, it >> 16 & 255, it >> 8 & 255, 255 & it);
        tt.start(), tt.update(Ze + ot), et += tt.digest().getBytes();
      }
      return et.substring(0, nt);
    }
    $e.encode_rsa_oaep = function(Ze, nt, tt) {
      var et, rt, it, ot;
      typeof tt == "string" ? (et = tt, rt = arguments[3] || void 0, it = arguments[4] || void 0) : tt && (et = tt.label || void 0, rt = tt.seed || void 0, it = tt.md || void 0, tt.mgf1 && tt.mgf1.md && (ot = tt.mgf1.md)), it ? it.start() : it = Ke.md.sha1.create(), ot || (ot = it);
      var at = Math.ceil(Ze.n.bitLength() / 8), st = at - 2 * it.digestLength - 2;
      if (nt.length > st) throw (gt = new Error("RSAES-OAEP input message length is too long.")).length = nt.length, gt.maxLength = st, gt;
      et || (et = ""), it.update(et, "raw");
      for (var ut = it.digest(), lt = "", dt = st - nt.length, At = 0; At < dt; At++) lt += "\0";
      var pt = ut.getBytes() + lt + "" + nt;
      if (rt) {
        if (rt.length !== it.digestLength) {
          var gt;
          throw (gt = new Error("Invalid RSAES-OAEP seed. The seed length must match the digest length.")).seedLength = rt.length, gt.digestLength = it.digestLength, gt;
        }
      } else rt = Ke.random.getBytes(it.digestLength);
      var wt = Je(rt, at - it.digestLength - 1, ot), Bt = Ke.util.xorBytes(pt, wt, pt.length), Tt = Je(Bt, it.digestLength, ot), yt = Ke.util.xorBytes(rt, Tt, rt.length);
      return "\0" + yt + Bt;
    }, $e.decode_rsa_oaep = function(Ze, nt, tt) {
      var et, rt, it;
      typeof tt == "string" ? (et = tt, rt = arguments[3] || void 0) : tt && (et = tt.label || void 0, rt = tt.md || void 0, tt.mgf1 && tt.mgf1.md && (it = tt.mgf1.md));
      var ot = Math.ceil(Ze.n.bitLength() / 8);
      if (nt.length !== ot) throw (Bt = new Error("RSAES-OAEP encoded message length is invalid.")).length = nt.length, Bt.expectedLength = ot, Bt;
      if (rt === void 0 ? rt = Ke.md.sha1.create() : rt.start(), it || (it = rt), ot < 2 * rt.digestLength + 2) throw new Error("RSAES-OAEP key is too short for the hash function.");
      et || (et = ""), rt.update(et, "raw");
      for (var at = rt.digest().getBytes(), st = nt.charAt(0), ut = nt.substring(1, rt.digestLength + 1), lt = nt.substring(1 + rt.digestLength), dt = Je(lt, rt.digestLength, it), At = Ke.util.xorBytes(ut, dt, ut.length), pt = Je(At, ot - rt.digestLength - 1, it), gt = Ke.util.xorBytes(lt, pt, lt.length), wt = gt.substring(0, rt.digestLength), Bt = st !== "\0", Tt = 0; Tt < rt.digestLength; ++Tt) Bt |= at.charAt(Tt) !== wt.charAt(Tt);
      for (var yt = 1, Ct = rt.digestLength, ht = rt.digestLength; ht < gt.length; ht++) {
        var It = gt.charCodeAt(ht), vt = 1 & It ^ 1, Et = yt ? 65534 : 0;
        Bt |= It & Et, Ct += yt &= vt;
      }
      if (Bt || gt.charCodeAt(Ct) !== 1) throw new Error("Invalid RSAES-OAEP padding.");
      return gt.substring(Ct + 1);
    };
  }, 779: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    Xe(2624), Xe(7461), Xe(2884), Xe(8989), Xe(6635), Xe(4097), Xe(144), Xe(2936), Xe(3103), Xe(6446);
    var $e = Ke.asn1, Je = Ke.pki, Ze = He.exports = Ke.pkcs12 = Ke.pkcs12 || {}, nt = { name: "ContentInfo", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "ContentInfo.contentType", tagClass: $e.Class.UNIVERSAL, type: $e.Type.OID, constructed: !1, capture: "contentType" }, { name: "ContentInfo.content", tagClass: $e.Class.CONTEXT_SPECIFIC, constructed: !0, captureAsn1: "content" }] }, tt = { name: "PFX", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "PFX.version", tagClass: $e.Class.UNIVERSAL, type: $e.Type.INTEGER, constructed: !1, capture: "version" }, nt, { name: "PFX.macData", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, optional: !0, captureAsn1: "mac", value: [{ name: "PFX.macData.mac", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "PFX.macData.mac.digestAlgorithm", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "PFX.macData.mac.digestAlgorithm.algorithm", tagClass: $e.Class.UNIVERSAL, type: $e.Type.OID, constructed: !1, capture: "macAlgorithm" }, { name: "PFX.macData.mac.digestAlgorithm.parameters", tagClass: $e.Class.UNIVERSAL, captureAsn1: "macAlgorithmParameters" }] }, { name: "PFX.macData.mac.digest", tagClass: $e.Class.UNIVERSAL, type: $e.Type.OCTETSTRING, constructed: !1, capture: "macDigest" }] }, { name: "PFX.macData.macSalt", tagClass: $e.Class.UNIVERSAL, type: $e.Type.OCTETSTRING, constructed: !1, capture: "macSalt" }, { name: "PFX.macData.iterations", tagClass: $e.Class.UNIVERSAL, type: $e.Type.INTEGER, constructed: !1, optional: !0, capture: "macIterations" }] }] }, et = { name: "SafeBag", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "SafeBag.bagId", tagClass: $e.Class.UNIVERSAL, type: $e.Type.OID, constructed: !1, capture: "bagId" }, { name: "SafeBag.bagValue", tagClass: $e.Class.CONTEXT_SPECIFIC, constructed: !0, captureAsn1: "bagValue" }, { name: "SafeBag.bagAttributes", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SET, constructed: !0, optional: !0, capture: "bagAttributes" }] }, rt = { name: "Attribute", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "Attribute.attrId", tagClass: $e.Class.UNIVERSAL, type: $e.Type.OID, constructed: !1, capture: "oid" }, { name: "Attribute.attrValues", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SET, constructed: !0, capture: "values" }] }, it = { name: "CertBag", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "CertBag.certId", tagClass: $e.Class.UNIVERSAL, type: $e.Type.OID, constructed: !1, capture: "certId" }, { name: "CertBag.certValue", tagClass: $e.Class.CONTEXT_SPECIFIC, constructed: !0, value: [{ name: "CertBag.certValue[0]", tagClass: $e.Class.UNIVERSAL, type: $e.Class.OCTETSTRING, constructed: !1, capture: "cert" }] }] };
    function ot(dt, At, pt, gt) {
      for (var wt = [], Bt = 0; Bt < dt.length; Bt++) for (var Tt = 0; Tt < dt[Bt].safeBags.length; Tt++) {
        var yt = dt[Bt].safeBags[Tt];
        gt !== void 0 && yt.type !== gt || (At !== null ? yt.attributes[At] !== void 0 && yt.attributes[At].indexOf(pt) >= 0 && wt.push(yt) : wt.push(yt));
      }
      return wt;
    }
    function at(dt) {
      if (dt.composed || dt.constructed) {
        for (var At = Ke.util.createBuffer(), pt = 0; pt < dt.value.length; ++pt) At.putBytes(dt.value[pt].value);
        dt.composed = dt.constructed = !1, dt.value = At.getBytes();
      }
      return dt;
    }
    function st(dt, At) {
      var pt = {}, gt = [];
      if (!$e.validate(dt, Ke.pkcs7.asn1.encryptedDataValidator, pt, gt)) throw (wt = new Error("Cannot read EncryptedContentInfo.")).errors = gt, wt;
      var wt, Bt = $e.derToOid(pt.contentType);
      if (Bt !== Je.oids.data) throw (wt = new Error("PKCS#12 EncryptedContentInfo ContentType is not Data.")).oid = Bt, wt;
      Bt = $e.derToOid(pt.encAlgorithm);
      var Tt = Je.pbe.getCipher(Bt, pt.encParameter, At), yt = at(pt.encryptedContentAsn1), Ct = Ke.util.createBuffer(yt.value);
      if (Tt.update(Ct), !Tt.finish()) throw new Error("Failed to decrypt PKCS#12 SafeContents.");
      return Tt.output.getBytes();
    }
    function ut(dt, At, pt) {
      if (!At && dt.length === 0) return [];
      if ((dt = $e.fromDer(dt, At)).tagClass !== $e.Class.UNIVERSAL || dt.type !== $e.Type.SEQUENCE || dt.constructed !== !0) throw new Error("PKCS#12 SafeContents expected to be a SEQUENCE OF SafeBag.");
      for (var gt = [], wt = 0; wt < dt.value.length; wt++) {
        var Bt = dt.value[wt], Tt = {}, yt = [];
        if (!$e.validate(Bt, et, Tt, yt)) throw (Et = new Error("Cannot read SafeBag.")).errors = yt, Et;
        var Ct, ht, It = { type: $e.derToOid(Tt.bagId), attributes: lt(Tt.bagAttributes) };
        gt.push(It);
        var vt = Tt.bagValue.value[0];
        switch (It.type) {
          case Je.oids.pkcs8ShroudedKeyBag:
            if ((vt = Je.decryptPrivateKeyInfo(vt, pt)) === null) throw new Error("Unable to decrypt PKCS#8 ShroudedKeyBag, wrong password?");
          case Je.oids.keyBag:
            try {
              It.key = Je.privateKeyFromAsn1(vt);
            } catch {
              It.key = null, It.asn1 = vt;
            }
            continue;
          case Je.oids.certBag:
            Ct = it, ht = function() {
              if ($e.derToOid(Tt.certId) !== Je.oids.x509Certificate) {
                var bt = new Error("Unsupported certificate type, only X.509 supported.");
                throw bt.oid = $e.derToOid(Tt.certId), bt;
              }
              var Rt = $e.fromDer(Tt.cert, At);
              try {
                It.cert = Je.certificateFromAsn1(Rt, !0);
              } catch {
                It.cert = null, It.asn1 = Rt;
              }
            };
            break;
          default:
            var Et;
            throw (Et = new Error("Unsupported PKCS#12 SafeBag type.")).oid = It.type, Et;
        }
        if (Ct !== void 0 && !$e.validate(vt, Ct, Tt, yt)) throw (Et = new Error("Cannot read PKCS#12 " + Ct.name)).errors = yt, Et;
        ht();
      }
      return gt;
    }
    function lt(dt) {
      var At = {};
      if (dt !== void 0) for (var pt = 0; pt < dt.length; ++pt) {
        var gt = {}, wt = [];
        if (!$e.validate(dt[pt], rt, gt, wt)) {
          var Bt = new Error("Cannot read PKCS#12 BagAttribute.");
          throw Bt.errors = wt, Bt;
        }
        var Tt = $e.derToOid(gt.oid);
        if (Je.oids[Tt] !== void 0) {
          At[Je.oids[Tt]] = [];
          for (var yt = 0; yt < gt.values.length; ++yt) At[Je.oids[Tt]].push(gt.values[yt].value);
        }
      }
      return At;
    }
    Ze.pkcs12FromAsn1 = function(dt, At, pt) {
      typeof At == "string" ? (pt = At, At = !0) : At === void 0 && (At = !0);
      var gt = {};
      if (!$e.validate(dt, tt, gt, [])) throw (wt = new Error("Cannot read PKCS#12 PFX. ASN.1 object is not an PKCS#12 PFX.")).errors = wt, wt;
      var wt, Bt = { version: gt.version.charCodeAt(0), safeContents: [], getBags: function(Rt) {
        var St, kt = {};
        return "localKeyId" in Rt ? St = Rt.localKeyId : "localKeyIdHex" in Rt && (St = Ke.util.hexToBytes(Rt.localKeyIdHex)), St === void 0 && !("friendlyName" in Rt) && "bagType" in Rt && (kt[Rt.bagType] = ot(Bt.safeContents, null, null, Rt.bagType)), St !== void 0 && (kt.localKeyId = ot(Bt.safeContents, "localKeyId", St, Rt.bagType)), "friendlyName" in Rt && (kt.friendlyName = ot(Bt.safeContents, "friendlyName", Rt.friendlyName, Rt.bagType)), kt;
      }, getBagsByFriendlyName: function(Rt, St) {
        return ot(Bt.safeContents, "friendlyName", Rt, St);
      }, getBagsByLocalKeyId: function(Rt, St) {
        return ot(Bt.safeContents, "localKeyId", Rt, St);
      } };
      if (gt.version.charCodeAt(0) !== 3) throw (wt = new Error("PKCS#12 PFX of version other than 3 not supported.")).version = gt.version.charCodeAt(0), wt;
      if ($e.derToOid(gt.contentType) !== Je.oids.data) throw (wt = new Error("Only PKCS#12 PFX in password integrity mode supported.")).oid = $e.derToOid(gt.contentType), wt;
      var Tt = gt.content.value[0];
      if (Tt.tagClass !== $e.Class.UNIVERSAL || Tt.type !== $e.Type.OCTETSTRING) throw new Error("PKCS#12 authSafe content data is not an OCTET STRING.");
      if (Tt = at(Tt), gt.mac) {
        var yt = null, Ct = 0, ht = $e.derToOid(gt.macAlgorithm);
        switch (ht) {
          case Je.oids.sha1:
            yt = Ke.md.sha1.create(), Ct = 20;
            break;
          case Je.oids.sha256:
            yt = Ke.md.sha256.create(), Ct = 32;
            break;
          case Je.oids.sha384:
            yt = Ke.md.sha384.create(), Ct = 48;
            break;
          case Je.oids.sha512:
            yt = Ke.md.sha512.create(), Ct = 64;
            break;
          case Je.oids.md5:
            yt = Ke.md.md5.create(), Ct = 16;
        }
        if (yt === null) throw new Error("PKCS#12 uses unsupported MAC algorithm: " + ht);
        var It = new Ke.util.ByteBuffer(gt.macSalt), vt = "macIterations" in gt ? parseInt(Ke.util.bytesToHex(gt.macIterations), 16) : 1, Et = Ze.generateKey(pt, It, 3, vt, Ct, yt), bt = Ke.hmac.create();
        if (bt.start(yt, Et), bt.update(Tt.value), bt.getMac().getBytes() !== gt.macDigest) throw new Error("PKCS#12 MAC could not be verified. Invalid password?");
      }
      return function(Rt, St, kt, jt) {
        if ((St = $e.fromDer(St, kt)).tagClass !== $e.Class.UNIVERSAL || St.type !== $e.Type.SEQUENCE || St.constructed !== !0) throw new Error("PKCS#12 AuthenticatedSafe expected to be a SEQUENCE OF ContentInfo");
        for (var Pt = 0; Pt < St.value.length; Pt++) {
          var Qt = St.value[Pt], qt = {}, _t = [];
          if (!$e.validate(Qt, nt, qt, _t)) throw (Lt = new Error("Cannot read ContentInfo.")).errors = _t, Lt;
          var Yt = { encrypted: !1 }, Xt = null, Ut = qt.content.value[0];
          switch ($e.derToOid(qt.contentType)) {
            case Je.oids.data:
              if (Ut.tagClass !== $e.Class.UNIVERSAL || Ut.type !== $e.Type.OCTETSTRING) throw new Error("PKCS#12 SafeContents Data is not an OCTET STRING.");
              Xt = at(Ut).value;
              break;
            case Je.oids.encryptedData:
              Xt = st(Ut, jt), Yt.encrypted = !0;
              break;
            default:
              var Lt;
              throw (Lt = new Error("Unsupported PKCS#12 contentType.")).contentType = $e.derToOid(qt.contentType), Lt;
          }
          Yt.safeBags = ut(Xt, kt, jt), Rt.safeContents.push(Yt);
        }
      }(Bt, Tt.value, At, pt), Bt;
    }, Ze.toPkcs12Asn1 = function(dt, At, pt, gt) {
      (gt = gt || {}).saltSize = gt.saltSize || 8, gt.count = gt.count || 2048, gt.algorithm = gt.algorithm || gt.encAlgorithm || "aes128", "useMac" in gt || (gt.useMac = !0), "localKeyId" in gt || (gt.localKeyId = null), "generateLocalKeyId" in gt || (gt.generateLocalKeyId = !0);
      var wt, Bt = gt.localKeyId;
      if (Bt !== null) Bt = Ke.util.hexToBytes(Bt);
      else if (gt.generateLocalKeyId) if (At) {
        var Tt = Ke.util.isArray(At) ? At[0] : At;
        typeof Tt == "string" && (Tt = Je.certificateFromPem(Tt)), (Xt = Ke.md.sha1.create()).update($e.toDer(Je.certificateToAsn1(Tt)).getBytes()), Bt = Xt.digest().getBytes();
      } else Bt = Ke.random.getBytes(20);
      var yt = [];
      Bt !== null && yt.push($e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(Je.oids.localKeyId).getBytes()), $e.create($e.Class.UNIVERSAL, $e.Type.SET, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OCTETSTRING, !1, Bt)])])), "friendlyName" in gt && yt.push($e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(Je.oids.friendlyName).getBytes()), $e.create($e.Class.UNIVERSAL, $e.Type.SET, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.BMPSTRING, !1, gt.friendlyName)])])), yt.length > 0 && (wt = $e.create($e.Class.UNIVERSAL, $e.Type.SET, !0, yt));
      var Ct = [], ht = [];
      At !== null && (ht = Ke.util.isArray(At) ? At : [At]);
      for (var It = [], vt = 0; vt < ht.length; ++vt) {
        typeof (At = ht[vt]) == "string" && (At = Je.certificateFromPem(At));
        var Et = vt === 0 ? wt : void 0, bt = Je.certificateToAsn1(At), Rt = $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(Je.oids.certBag).getBytes()), $e.create($e.Class.CONTEXT_SPECIFIC, 0, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(Je.oids.x509Certificate).getBytes()), $e.create($e.Class.CONTEXT_SPECIFIC, 0, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OCTETSTRING, !1, $e.toDer(bt).getBytes())])])]), Et]);
        It.push(Rt);
      }
      if (It.length > 0) {
        var St = $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, It), kt = $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(Je.oids.data).getBytes()), $e.create($e.Class.CONTEXT_SPECIFIC, 0, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OCTETSTRING, !1, $e.toDer(St).getBytes())])]);
        Ct.push(kt);
      }
      var jt = null;
      if (dt !== null) {
        var Pt = Je.wrapRsaPrivateKey(Je.privateKeyToAsn1(dt));
        jt = pt === null ? $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(Je.oids.keyBag).getBytes()), $e.create($e.Class.CONTEXT_SPECIFIC, 0, !0, [Pt]), wt]) : $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(Je.oids.pkcs8ShroudedKeyBag).getBytes()), $e.create($e.Class.CONTEXT_SPECIFIC, 0, !0, [Je.encryptPrivateKeyInfo(Pt, pt, gt)]), wt]);
        var Qt = $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [jt]), qt = $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(Je.oids.data).getBytes()), $e.create($e.Class.CONTEXT_SPECIFIC, 0, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OCTETSTRING, !1, $e.toDer(Qt).getBytes())])]);
        Ct.push(qt);
      }
      var _t, Yt = $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, Ct);
      if (gt.useMac) {
        var Xt = Ke.md.sha1.create(), Ut = new Ke.util.ByteBuffer(Ke.random.getBytes(gt.saltSize)), Lt = gt.count, Ot = (dt = Ze.generateKey(pt, Ut, 3, Lt, 20), Ke.hmac.create());
        Ot.start(Xt, dt), Ot.update($e.toDer(Yt).getBytes());
        var ft = Ot.getMac();
        _t = $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(Je.oids.sha1).getBytes()), $e.create($e.Class.UNIVERSAL, $e.Type.NULL, !1, "")]), $e.create($e.Class.UNIVERSAL, $e.Type.OCTETSTRING, !1, ft.getBytes())]), $e.create($e.Class.UNIVERSAL, $e.Type.OCTETSTRING, !1, Ut.getBytes()), $e.create($e.Class.UNIVERSAL, $e.Type.INTEGER, !1, $e.integerToDer(Lt).getBytes())]);
      }
      return $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.INTEGER, !1, $e.integerToDer(3).getBytes()), $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(Je.oids.data).getBytes()), $e.create($e.Class.CONTEXT_SPECIFIC, 0, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OCTETSTRING, !1, $e.toDer(Yt).getBytes())])]), _t]);
    }, Ze.generateKey = Ke.pbe.generatePkcs12Key;
  }, 1559: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    Xe(1482), Xe(2624), Xe(2023), Xe(2884), Xe(5477), Xe(8989), Xe(4097), Xe(3103), Xe(6446);
    var $e = Ke.asn1, Je = He.exports = Ke.pkcs7 = Ke.pkcs7 || {};
    function Ze(ot) {
      var at = {}, st = [];
      if (!$e.validate(ot, Je.asn1.recipientInfoValidator, at, st)) {
        var ut = new Error("Cannot read PKCS#7 RecipientInfo. ASN.1 object is not an PKCS#7 RecipientInfo.");
        throw ut.errors = st, ut;
      }
      return { version: at.version.charCodeAt(0), issuer: Ke.pki.RDNAttributesAsArray(at.issuer), serialNumber: Ke.util.createBuffer(at.serial).toHex(), encryptedContent: { algorithm: $e.derToOid(at.encAlgorithm), parameter: at.encParameter ? at.encParameter.value : void 0, content: at.encKey } };
    }
    function nt(ot) {
      for (var at, st = [], ut = 0; ut < ot.length; ++ut) st.push((at = ot[ut], $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.INTEGER, !1, $e.integerToDer(at.version).getBytes()), $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [Ke.pki.distinguishedNameToAsn1({ attributes: at.issuer }), $e.create($e.Class.UNIVERSAL, $e.Type.INTEGER, !1, Ke.util.hexToBytes(at.serialNumber))]), $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(at.encryptedContent.algorithm).getBytes()), $e.create($e.Class.UNIVERSAL, $e.Type.NULL, !1, "")]), $e.create($e.Class.UNIVERSAL, $e.Type.OCTETSTRING, !1, at.encryptedContent.content)])));
      return st;
    }
    function tt(ot) {
      var at = $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.INTEGER, !1, $e.integerToDer(ot.version).getBytes()), $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [Ke.pki.distinguishedNameToAsn1({ attributes: ot.issuer }), $e.create($e.Class.UNIVERSAL, $e.Type.INTEGER, !1, Ke.util.hexToBytes(ot.serialNumber))]), $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(ot.digestAlgorithm).getBytes()), $e.create($e.Class.UNIVERSAL, $e.Type.NULL, !1, "")])]);
      if (ot.authenticatedAttributesAsn1 && at.value.push(ot.authenticatedAttributesAsn1), at.value.push($e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(ot.signatureAlgorithm).getBytes()), $e.create($e.Class.UNIVERSAL, $e.Type.NULL, !1, "")])), at.value.push($e.create($e.Class.UNIVERSAL, $e.Type.OCTETSTRING, !1, ot.signature)), ot.unauthenticatedAttributes.length > 0) {
        for (var st = $e.create($e.Class.CONTEXT_SPECIFIC, 1, !0, []), ut = 0; ut < ot.unauthenticatedAttributes.length; ++ut) {
          var lt = ot.unauthenticatedAttributes[ut];
          st.values.push(et(lt));
        }
        at.value.push(st);
      }
      return at;
    }
    function et(ot) {
      var at;
      if (ot.type === Ke.pki.oids.contentType) at = $e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(ot.value).getBytes());
      else if (ot.type === Ke.pki.oids.messageDigest) at = $e.create($e.Class.UNIVERSAL, $e.Type.OCTETSTRING, !1, ot.value.bytes());
      else if (ot.type === Ke.pki.oids.signingTime) {
        var st = /* @__PURE__ */ new Date("1950-01-01T00:00:00Z"), ut = /* @__PURE__ */ new Date("2050-01-01T00:00:00Z"), lt = ot.value;
        if (typeof lt == "string") {
          var dt = Date.parse(lt);
          lt = isNaN(dt) ? lt.length === 13 ? $e.utcTimeToDate(lt) : $e.generalizedTimeToDate(lt) : new Date(dt);
        }
        at = lt >= st && lt < ut ? $e.create($e.Class.UNIVERSAL, $e.Type.UTCTIME, !1, $e.dateToUtcTime(lt)) : $e.create($e.Class.UNIVERSAL, $e.Type.GENERALIZEDTIME, !1, $e.dateToGeneralizedTime(lt));
      }
      return $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(ot.type).getBytes()), $e.create($e.Class.UNIVERSAL, $e.Type.SET, !0, [at])]);
    }
    function rt(ot, at, st) {
      var ut = {};
      if (!$e.validate(at, st, ut, [])) {
        var lt = new Error("Cannot read PKCS#7 message. ASN.1 object is not a supported PKCS#7 message.");
        throw lt.errors = lt, lt;
      }
      if ($e.derToOid(ut.contentType) !== Ke.pki.oids.data) throw new Error("Unsupported PKCS#7 message. Only wrapped ContentType Data supported.");
      if (ut.encryptedContent) {
        var dt = "";
        if (Ke.util.isArray(ut.encryptedContent)) for (var At = 0; At < ut.encryptedContent.length; ++At) {
          if (ut.encryptedContent[At].type !== $e.Type.OCTETSTRING) throw new Error("Malformed PKCS#7 message, expecting encrypted content constructed of only OCTET STRING objects.");
          dt += ut.encryptedContent[At].value;
        }
        else dt = ut.encryptedContent;
        ot.encryptedContent = { algorithm: $e.derToOid(ut.encAlgorithm), parameter: Ke.util.createBuffer(ut.encParameter.value), content: Ke.util.createBuffer(dt) };
      }
      if (ut.content) {
        if (dt = "", Ke.util.isArray(ut.content)) for (At = 0; At < ut.content.length; ++At) {
          if (ut.content[At].type !== $e.Type.OCTETSTRING) throw new Error("Malformed PKCS#7 message, expecting content constructed of only OCTET STRING objects.");
          dt += ut.content[At].value;
        }
        else dt = ut.content;
        ot.content = Ke.util.createBuffer(dt);
      }
      return ot.version = ut.version.charCodeAt(0), ot.rawCapture = ut, ut;
    }
    function it(ot) {
      if (ot.encryptedContent.key === void 0) throw new Error("Symmetric key not available.");
      if (ot.content === void 0) {
        var at;
        switch (ot.encryptedContent.algorithm) {
          case Ke.pki.oids["aes128-CBC"]:
          case Ke.pki.oids["aes192-CBC"]:
          case Ke.pki.oids["aes256-CBC"]:
            at = Ke.aes.createDecryptionCipher(ot.encryptedContent.key);
            break;
          case Ke.pki.oids.desCBC:
          case Ke.pki.oids["des-EDE3-CBC"]:
            at = Ke.des.createDecryptionCipher(ot.encryptedContent.key);
            break;
          default:
            throw new Error("Unsupported symmetric cipher, OID " + ot.encryptedContent.algorithm);
        }
        if (at.start(ot.encryptedContent.parameter), at.update(ot.encryptedContent.content), !at.finish()) throw new Error("Symmetric decryption failed.");
        ot.content = at.output;
      }
    }
    Je.messageFromPem = function(ot) {
      var at = Ke.pem.decode(ot)[0];
      if (at.type !== "PKCS7") {
        var st = new Error('Could not convert PKCS#7 message from PEM; PEM header type is not "PKCS#7".');
        throw st.headerType = at.type, st;
      }
      if (at.procType && at.procType.type === "ENCRYPTED") throw new Error("Could not convert PKCS#7 message from PEM; PEM is encrypted.");
      var ut = $e.fromDer(at.body);
      return Je.messageFromAsn1(ut);
    }, Je.messageToPem = function(ot, at) {
      var st = { type: "PKCS7", body: $e.toDer(ot.toAsn1()).getBytes() };
      return Ke.pem.encode(st, { maxline: at });
    }, Je.messageFromAsn1 = function(ot) {
      var at = {}, st = [];
      if (!$e.validate(ot, Je.asn1.contentInfoValidator, at, st)) {
        var ut = new Error("Cannot read PKCS#7 message. ASN.1 object is not an PKCS#7 ContentInfo.");
        throw ut.errors = st, ut;
      }
      var lt, dt = $e.derToOid(at.contentType);
      switch (dt) {
        case Ke.pki.oids.envelopedData:
          lt = Je.createEnvelopedData();
          break;
        case Ke.pki.oids.encryptedData:
          lt = Je.createEncryptedData();
          break;
        case Ke.pki.oids.signedData:
          lt = Je.createSignedData();
          break;
        default:
          throw new Error("Cannot read PKCS#7 message. ContentType with OID " + dt + " is not (yet) supported.");
      }
      return lt.fromAsn1(at.content.value[0]), lt;
    }, Je.createSignedData = function() {
      var ot = null;
      return ot = { type: Ke.pki.oids.signedData, version: 1, certificates: [], crls: [], signers: [], digestAlgorithmIdentifiers: [], contentInfo: null, signerInfos: [], fromAsn1: function(at) {
        if (rt(ot, at, Je.asn1.signedDataValidator), ot.certificates = [], ot.crls = [], ot.digestAlgorithmIdentifiers = [], ot.contentInfo = null, ot.signerInfos = [], ot.rawCapture.certificates) for (var st = ot.rawCapture.certificates.value, ut = 0; ut < st.length; ++ut) ot.certificates.push(Ke.pki.certificateFromAsn1(st[ut]));
      }, toAsn1: function() {
        ot.contentInfo || ot.sign();
        for (var at = [], st = 0; st < ot.certificates.length; ++st) at.push(Ke.pki.certificateToAsn1(ot.certificates[st]));
        var ut = [], lt = $e.create($e.Class.CONTEXT_SPECIFIC, 0, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.INTEGER, !1, $e.integerToDer(ot.version).getBytes()), $e.create($e.Class.UNIVERSAL, $e.Type.SET, !0, ot.digestAlgorithmIdentifiers), ot.contentInfo])]);
        return at.length > 0 && lt.value[0].value.push($e.create($e.Class.CONTEXT_SPECIFIC, 0, !0, at)), ut.length > 0 && lt.value[0].value.push($e.create($e.Class.CONTEXT_SPECIFIC, 1, !0, ut)), lt.value[0].value.push($e.create($e.Class.UNIVERSAL, $e.Type.SET, !0, ot.signerInfos)), $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(ot.type).getBytes()), lt]);
      }, addSigner: function(at) {
        var st = at.issuer, ut = at.serialNumber;
        if (at.certificate) {
          var lt = at.certificate;
          typeof lt == "string" && (lt = Ke.pki.certificateFromPem(lt)), st = lt.issuer.attributes, ut = lt.serialNumber;
        }
        var dt = at.key;
        if (!dt) throw new Error("Could not add PKCS#7 signer; no private key specified.");
        typeof dt == "string" && (dt = Ke.pki.privateKeyFromPem(dt));
        var At = at.digestAlgorithm || Ke.pki.oids.sha1;
        switch (At) {
          case Ke.pki.oids.sha1:
          case Ke.pki.oids.sha256:
          case Ke.pki.oids.sha384:
          case Ke.pki.oids.sha512:
          case Ke.pki.oids.md5:
            break;
          default:
            throw new Error("Could not add PKCS#7 signer; unknown message digest algorithm: " + At);
        }
        var pt = at.authenticatedAttributes || [];
        if (pt.length > 0) {
          for (var gt = !1, wt = !1, Bt = 0; Bt < pt.length; ++Bt) {
            var Tt = pt[Bt];
            if (gt || Tt.type !== Ke.pki.oids.contentType) {
              if (!(wt || Tt.type !== Ke.pki.oids.messageDigest)) {
                if (wt = !0, gt) break;
              }
            } else if (gt = !0, wt) break;
          }
          if (!gt || !wt) throw new Error("Invalid signer.authenticatedAttributes. If signer.authenticatedAttributes is specified, then it must contain at least two attributes, PKCS #9 content-type and PKCS #9 message-digest.");
        }
        ot.signers.push({ key: dt, version: 1, issuer: st, serialNumber: ut, digestAlgorithm: At, signatureAlgorithm: Ke.pki.oids.rsaEncryption, signature: null, authenticatedAttributes: pt, unauthenticatedAttributes: [] });
      }, sign: function(at) {
        var st;
        at = at || {}, (typeof ot.content != "object" || ot.contentInfo === null) && (ot.contentInfo = $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(Ke.pki.oids.data).getBytes())]), "content" in ot && (ot.content instanceof Ke.util.ByteBuffer ? st = ot.content.bytes() : typeof ot.content == "string" && (st = Ke.util.encodeUtf8(ot.content)), at.detached ? ot.detachedContent = $e.create($e.Class.UNIVERSAL, $e.Type.OCTETSTRING, !1, st) : ot.contentInfo.value.push($e.create($e.Class.CONTEXT_SPECIFIC, 0, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OCTETSTRING, !1, st)])))), ot.signers.length !== 0 && function(ut) {
          var lt;
          if (!(lt = ot.detachedContent ? ot.detachedContent : (lt = ot.contentInfo.value[1]).value[0])) throw new Error("Could not sign PKCS#7 message; there is no content to sign.");
          var dt = $e.derToOid(ot.contentInfo.value[0].value), At = $e.toDer(lt);
          for (var pt in At.getByte(), $e.getBerValueLength(At), At = At.getBytes(), ut) ut[pt].start().update(At);
          for (var gt = /* @__PURE__ */ new Date(), wt = 0; wt < ot.signers.length; ++wt) {
            var Bt = ot.signers[wt];
            if (Bt.authenticatedAttributes.length === 0) {
              if (dt !== Ke.pki.oids.data) throw new Error("Invalid signer; authenticatedAttributes must be present when the ContentInfo content type is not PKCS#7 Data.");
            } else {
              Bt.authenticatedAttributesAsn1 = $e.create($e.Class.CONTEXT_SPECIFIC, 0, !0, []);
              for (var Tt = $e.create($e.Class.UNIVERSAL, $e.Type.SET, !0, []), yt = 0; yt < Bt.authenticatedAttributes.length; ++yt) {
                var Ct = Bt.authenticatedAttributes[yt];
                Ct.type === Ke.pki.oids.messageDigest ? Ct.value = ut[Bt.digestAlgorithm].digest() : Ct.type === Ke.pki.oids.signingTime && (Ct.value || (Ct.value = gt)), Tt.value.push(et(Ct)), Bt.authenticatedAttributesAsn1.value.push(et(Ct));
              }
              At = $e.toDer(Tt).getBytes(), Bt.md.start().update(At);
            }
            Bt.signature = Bt.key.sign(Bt.md, "RSASSA-PKCS1-V1_5");
          }
          ot.signerInfos = function(ht) {
            for (var It = [], vt = 0; vt < ht.length; ++vt) It.push(tt(ht[vt]));
            return It;
          }(ot.signers);
        }(function() {
          for (var ut = {}, lt = 0; lt < ot.signers.length; ++lt) {
            var dt = ot.signers[lt];
            (At = dt.digestAlgorithm) in ut || (ut[At] = Ke.md[Ke.pki.oids[At]].create()), dt.authenticatedAttributes.length === 0 ? dt.md = ut[At] : dt.md = Ke.md[Ke.pki.oids[At]].create();
          }
          for (var At in ot.digestAlgorithmIdentifiers = [], ut) ot.digestAlgorithmIdentifiers.push($e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(At).getBytes()), $e.create($e.Class.UNIVERSAL, $e.Type.NULL, !1, "")]));
          return ut;
        }());
      }, verify: function() {
        throw new Error("PKCS#7 signature verification not yet implemented.");
      }, addCertificate: function(at) {
        typeof at == "string" && (at = Ke.pki.certificateFromPem(at)), ot.certificates.push(at);
      }, addCertificateRevokationList: function(at) {
        throw new Error("PKCS#7 CRL support not yet implemented.");
      } };
    }, Je.createEncryptedData = function() {
      var ot = null;
      return ot = { type: Ke.pki.oids.encryptedData, version: 0, encryptedContent: { algorithm: Ke.pki.oids["aes256-CBC"] }, fromAsn1: function(at) {
        rt(ot, at, Je.asn1.encryptedDataValidator);
      }, decrypt: function(at) {
        at !== void 0 && (ot.encryptedContent.key = at), it(ot);
      } };
    }, Je.createEnvelopedData = function() {
      var ot = null;
      return ot = { type: Ke.pki.oids.envelopedData, version: 0, recipients: [], encryptedContent: { algorithm: Ke.pki.oids["aes256-CBC"] }, fromAsn1: function(at) {
        var st = rt(ot, at, Je.asn1.envelopedDataValidator);
        ot.recipients = function(ut) {
          for (var lt = [], dt = 0; dt < ut.length; ++dt) lt.push(Ze(ut[dt]));
          return lt;
        }(st.recipientInfos.value);
      }, toAsn1: function() {
        return $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(ot.type).getBytes()), $e.create($e.Class.CONTEXT_SPECIFIC, 0, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.INTEGER, !1, $e.integerToDer(ot.version).getBytes()), $e.create($e.Class.UNIVERSAL, $e.Type.SET, !0, nt(ot.recipients)), $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, (at = ot.encryptedContent, [$e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(Ke.pki.oids.data).getBytes()), $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(at.algorithm).getBytes()), at.parameter ? $e.create($e.Class.UNIVERSAL, $e.Type.OCTETSTRING, !1, at.parameter.getBytes()) : void 0]), $e.create($e.Class.CONTEXT_SPECIFIC, 0, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OCTETSTRING, !1, at.content.getBytes())])]))])])]);
        var at;
      }, findRecipient: function(at) {
        for (var st = at.issuer.attributes, ut = 0; ut < ot.recipients.length; ++ut) {
          var lt = ot.recipients[ut], dt = lt.issuer;
          if (lt.serialNumber === at.serialNumber && dt.length === st.length) {
            for (var At = !0, pt = 0; pt < st.length; ++pt) if (dt[pt].type !== st[pt].type || dt[pt].value !== st[pt].value) {
              At = !1;
              break;
            }
            if (At) return lt;
          }
        }
        return null;
      }, decrypt: function(at, st) {
        if (ot.encryptedContent.key === void 0 && at !== void 0 && st !== void 0) switch (at.encryptedContent.algorithm) {
          case Ke.pki.oids.rsaEncryption:
          case Ke.pki.oids.desCBC:
            var ut = st.decrypt(at.encryptedContent.content);
            ot.encryptedContent.key = Ke.util.createBuffer(ut);
            break;
          default:
            throw new Error("Unsupported asymmetric cipher, OID " + at.encryptedContent.algorithm);
        }
        it(ot);
      }, addRecipient: function(at) {
        ot.recipients.push({ version: 0, issuer: at.issuer.attributes, serialNumber: at.serialNumber, encryptedContent: { algorithm: Ke.pki.oids.rsaEncryption, key: at.publicKey } });
      }, encrypt: function(at, st) {
        if (ot.encryptedContent.content === void 0) {
          var ut, lt, dt;
          switch (st = st || ot.encryptedContent.algorithm, at = at || ot.encryptedContent.key, st) {
            case Ke.pki.oids["aes128-CBC"]:
              ut = 16, lt = 16, dt = Ke.aes.createEncryptionCipher;
              break;
            case Ke.pki.oids["aes192-CBC"]:
              ut = 24, lt = 16, dt = Ke.aes.createEncryptionCipher;
              break;
            case Ke.pki.oids["aes256-CBC"]:
              ut = 32, lt = 16, dt = Ke.aes.createEncryptionCipher;
              break;
            case Ke.pki.oids["des-EDE3-CBC"]:
              ut = 24, lt = 8, dt = Ke.des.createEncryptionCipher;
              break;
            default:
              throw new Error("Unsupported symmetric cipher, OID " + st);
          }
          if (at === void 0) at = Ke.util.createBuffer(Ke.random.getBytes(ut));
          else if (at.length() != ut) throw new Error("Symmetric key has wrong length; got " + at.length() + " bytes, expected " + ut + ".");
          ot.encryptedContent.algorithm = st, ot.encryptedContent.key = at, ot.encryptedContent.parameter = Ke.util.createBuffer(Ke.random.getBytes(lt));
          var At = dt(at);
          if (At.start(ot.encryptedContent.parameter.copy()), At.update(ot.content), !At.finish()) throw new Error("Symmetric encryption failed.");
          ot.encryptedContent.content = At.output;
        }
        for (var pt = 0; pt < ot.recipients.length; ++pt) {
          var gt = ot.recipients[pt];
          if (gt.encryptedContent.content === void 0) {
            if (gt.encryptedContent.algorithm !== Ke.pki.oids.rsaEncryption) throw new Error("Unsupported asymmetric cipher, OID " + gt.encryptedContent.algorithm);
            gt.encryptedContent.content = gt.encryptedContent.key.encrypt(ot.encryptedContent.key.data);
          }
        }
      } };
    };
  }, 8989: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    Xe(2624), Xe(3103);
    var $e = Ke.asn1, Je = He.exports = Ke.pkcs7asn1 = Ke.pkcs7asn1 || {};
    Ke.pkcs7 = Ke.pkcs7 || {}, Ke.pkcs7.asn1 = Je;
    var Ze = { name: "ContentInfo", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "ContentInfo.ContentType", tagClass: $e.Class.UNIVERSAL, type: $e.Type.OID, constructed: !1, capture: "contentType" }, { name: "ContentInfo.content", tagClass: $e.Class.CONTEXT_SPECIFIC, type: 0, constructed: !0, optional: !0, captureAsn1: "content" }] };
    Je.contentInfoValidator = Ze;
    var nt = { name: "EncryptedContentInfo", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "EncryptedContentInfo.contentType", tagClass: $e.Class.UNIVERSAL, type: $e.Type.OID, constructed: !1, capture: "contentType" }, { name: "EncryptedContentInfo.contentEncryptionAlgorithm", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "EncryptedContentInfo.contentEncryptionAlgorithm.algorithm", tagClass: $e.Class.UNIVERSAL, type: $e.Type.OID, constructed: !1, capture: "encAlgorithm" }, { name: "EncryptedContentInfo.contentEncryptionAlgorithm.parameter", tagClass: $e.Class.UNIVERSAL, captureAsn1: "encParameter" }] }, { name: "EncryptedContentInfo.encryptedContent", tagClass: $e.Class.CONTEXT_SPECIFIC, type: 0, capture: "encryptedContent", captureAsn1: "encryptedContentAsn1" }] };
    Je.envelopedDataValidator = { name: "EnvelopedData", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "EnvelopedData.Version", tagClass: $e.Class.UNIVERSAL, type: $e.Type.INTEGER, constructed: !1, capture: "version" }, { name: "EnvelopedData.RecipientInfos", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SET, constructed: !0, captureAsn1: "recipientInfos" }].concat(nt) }, Je.encryptedDataValidator = { name: "EncryptedData", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "EncryptedData.Version", tagClass: $e.Class.UNIVERSAL, type: $e.Type.INTEGER, constructed: !1, capture: "version" }].concat(nt) };
    var tt = { name: "SignerInfo", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "SignerInfo.version", tagClass: $e.Class.UNIVERSAL, type: $e.Type.INTEGER, constructed: !1 }, { name: "SignerInfo.issuerAndSerialNumber", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "SignerInfo.issuerAndSerialNumber.issuer", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, captureAsn1: "issuer" }, { name: "SignerInfo.issuerAndSerialNumber.serialNumber", tagClass: $e.Class.UNIVERSAL, type: $e.Type.INTEGER, constructed: !1, capture: "serial" }] }, { name: "SignerInfo.digestAlgorithm", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "SignerInfo.digestAlgorithm.algorithm", tagClass: $e.Class.UNIVERSAL, type: $e.Type.OID, constructed: !1, capture: "digestAlgorithm" }, { name: "SignerInfo.digestAlgorithm.parameter", tagClass: $e.Class.UNIVERSAL, constructed: !1, captureAsn1: "digestParameter", optional: !0 }] }, { name: "SignerInfo.authenticatedAttributes", tagClass: $e.Class.CONTEXT_SPECIFIC, type: 0, constructed: !0, optional: !0, capture: "authenticatedAttributes" }, { name: "SignerInfo.digestEncryptionAlgorithm", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, capture: "signatureAlgorithm" }, { name: "SignerInfo.encryptedDigest", tagClass: $e.Class.UNIVERSAL, type: $e.Type.OCTETSTRING, constructed: !1, capture: "signature" }, { name: "SignerInfo.unauthenticatedAttributes", tagClass: $e.Class.CONTEXT_SPECIFIC, type: 1, constructed: !0, optional: !0, capture: "unauthenticatedAttributes" }] };
    Je.signedDataValidator = { name: "SignedData", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "SignedData.Version", tagClass: $e.Class.UNIVERSAL, type: $e.Type.INTEGER, constructed: !1, capture: "version" }, { name: "SignedData.DigestAlgorithms", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SET, constructed: !0, captureAsn1: "digestAlgorithms" }, Ze, { name: "SignedData.Certificates", tagClass: $e.Class.CONTEXT_SPECIFIC, type: 0, optional: !0, captureAsn1: "certificates" }, { name: "SignedData.CertificateRevocationLists", tagClass: $e.Class.CONTEXT_SPECIFIC, type: 1, optional: !0, captureAsn1: "crls" }, { name: "SignedData.SignerInfos", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SET, capture: "signerInfos", optional: !0, value: [tt] }] }, Je.recipientInfoValidator = { name: "RecipientInfo", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "RecipientInfo.version", tagClass: $e.Class.UNIVERSAL, type: $e.Type.INTEGER, constructed: !1, capture: "version" }, { name: "RecipientInfo.issuerAndSerial", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "RecipientInfo.issuerAndSerial.issuer", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, captureAsn1: "issuer" }, { name: "RecipientInfo.issuerAndSerial.serialNumber", tagClass: $e.Class.UNIVERSAL, type: $e.Type.INTEGER, constructed: !1, capture: "serial" }] }, { name: "RecipientInfo.keyEncryptionAlgorithm", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "RecipientInfo.keyEncryptionAlgorithm.algorithm", tagClass: $e.Class.UNIVERSAL, type: $e.Type.OID, constructed: !1, capture: "encAlgorithm" }, { name: "RecipientInfo.keyEncryptionAlgorithm.parameter", tagClass: $e.Class.UNIVERSAL, constructed: !1, captureAsn1: "encParameter", optional: !0 }] }, { name: "RecipientInfo.encryptedKey", tagClass: $e.Class.UNIVERSAL, type: $e.Type.OCTETSTRING, constructed: !1, capture: "encKey" }] };
  }, 4885: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    Xe(2624), Xe(2884), Xe(6635), Xe(5477), Xe(9580), Xe(779), Xe(665), Xe(144), Xe(3103), Xe(6446);
    var $e = Ke.asn1, Je = He.exports = Ke.pki = Ke.pki || {};
    Je.pemToDer = function(Ze) {
      var nt = Ke.pem.decode(Ze)[0];
      if (nt.procType && nt.procType.type === "ENCRYPTED") throw new Error("Could not convert PEM to DER; PEM is encrypted.");
      return Ke.util.createBuffer(nt.body);
    }, Je.privateKeyFromPem = function(Ze) {
      var nt = Ke.pem.decode(Ze)[0];
      if (nt.type !== "PRIVATE KEY" && nt.type !== "RSA PRIVATE KEY") {
        var tt = new Error('Could not convert private key from PEM; PEM header type is not "PRIVATE KEY" or "RSA PRIVATE KEY".');
        throw tt.headerType = nt.type, tt;
      }
      if (nt.procType && nt.procType.type === "ENCRYPTED") throw new Error("Could not convert private key from PEM; PEM is encrypted.");
      var et = $e.fromDer(nt.body);
      return Je.privateKeyFromAsn1(et);
    }, Je.privateKeyToPem = function(Ze, nt) {
      var tt = { type: "RSA PRIVATE KEY", body: $e.toDer(Je.privateKeyToAsn1(Ze)).getBytes() };
      return Ke.pem.encode(tt, { maxline: nt });
    }, Je.privateKeyInfoToPem = function(Ze, nt) {
      var tt = { type: "PRIVATE KEY", body: $e.toDer(Ze).getBytes() };
      return Ke.pem.encode(tt, { maxline: nt });
    };
  }, 8547: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    Xe(3103), Xe(1633), Xe(4097), function() {
      if (Ke.prime) He.exports = Ke.prime;
      else {
        var $e = He.exports = Ke.prime = Ke.prime || {}, Je = Ke.jsbn.BigInteger, Ze = [6, 4, 2, 4, 2, 4, 6, 2], nt = new Je(null);
        nt.fromInt(30);
        var tt = function(ot, at) {
          return ot | at;
        };
        $e.generateProbablePrime = function(ot, at, st) {
          typeof at == "function" && (st = at, at = {});
          var ut = (at = at || {}).algorithm || "PRIMEINC";
          typeof ut == "string" && (ut = { name: ut }), ut.options = ut.options || {};
          var lt = at.prng || Ke.random, dt = { nextBytes: function(At) {
            for (var pt = lt.getBytesSync(At.length), gt = 0; gt < At.length; ++gt) At[gt] = pt.charCodeAt(gt);
          } };
          if (ut.name === "PRIMEINC") return function(At, pt, gt, wt) {
            return "workers" in gt ? function(Bt, Tt, yt, Ct) {
              if (typeof Worker > "u") return et(Bt, Tt, yt, Ct);
              var ht = it(Bt, Tt), It = yt.workers, vt = yt.workLoad || 100, Et = 30 * vt / 8, bt = yt.workerScript || "forge/prime.worker.js";
              if (It === -1) return Ke.util.estimateCores(function(St, kt) {
                St && (kt = 2), It = kt - 1, Rt();
              });
              function Rt() {
                It = Math.max(1, It);
                for (var St = [], kt = 0; kt < It; ++kt) St[kt] = new Worker(bt);
                for (kt = 0; kt < It; ++kt) St[kt].addEventListener("message", Pt);
                var jt = !1;
                function Pt(Qt) {
                  if (!jt) {
                    var qt = Qt.data;
                    if (qt.found) {
                      for (var _t = 0; _t < St.length; ++_t) St[_t].terminate();
                      return jt = !0, Ct(null, new Je(qt.prime, 16));
                    }
                    ht.bitLength() > Bt && (ht = it(Bt, Tt));
                    var Yt = ht.toString(16);
                    Qt.target.postMessage({ hex: Yt, workLoad: vt }), ht.dAddOffset(Et, 0);
                  }
                }
              }
              Rt();
            }(At, pt, gt, wt) : et(At, pt, gt, wt);
          }(ot, dt, ut.options, st);
          throw new Error("Invalid prime generation algorithm: " + ut.name);
        };
      }
      function et(ot, at, st, ut) {
        var lt = it(ot, at), dt = function(pt) {
          return pt <= 100 ? 27 : pt <= 150 ? 18 : pt <= 200 ? 15 : pt <= 250 ? 12 : pt <= 300 ? 9 : pt <= 350 ? 8 : pt <= 400 ? 7 : pt <= 500 ? 6 : pt <= 600 ? 5 : pt <= 800 ? 4 : pt <= 1250 ? 3 : 2;
        }(lt.bitLength());
        "millerRabinTests" in st && (dt = st.millerRabinTests);
        var At = 10;
        "maxBlockTime" in st && (At = st.maxBlockTime), rt(lt, ot, at, 0, dt, At, ut);
      }
      function rt(ot, at, st, ut, lt, dt, At) {
        var pt = +/* @__PURE__ */ new Date();
        do {
          if (ot.bitLength() > at && (ot = it(at, st)), ot.isProbablePrime(lt)) return At(null, ot);
          ot.dAddOffset(Ze[ut++ % 8], 0);
        } while (dt < 0 || +/* @__PURE__ */ new Date() - pt < dt);
        Ke.util.setImmediate(function() {
          rt(ot, at, st, ut, lt, dt, At);
        });
      }
      function it(ot, at) {
        var st = new Je(ot, at), ut = ot - 1;
        return st.testBit(ut) || st.bitwiseTo(Je.ONE.shiftLeft(ut), tt, st), st.dAddOffset(31 - st.mod(nt).byteValue(), 0), st;
      }
    }();
  }, 3930: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    Xe(3103);
    var $e = null;
    !Ke.util.isNodejs || Ke.options.usePureJavaScript || process.versions["node-webkit"] || ($e = Xe(5942)), (He.exports = Ke.prng = Ke.prng || {}).create = function(Je) {
      for (var Ze = { plugin: Je, key: null, seed: null, time: null, reseeds: 0, generated: 0, keyBytes: "" }, nt = Je.md, tt = new Array(32), et = 0; et < 32; ++et) tt[et] = nt.create();
      function rt() {
        if (Ze.pools[0].messageLength >= 32) return it();
        var at = 32 - Ze.pools[0].messageLength << 5;
        Ze.collect(Ze.seedFileSync(at)), it();
      }
      function it() {
        Ze.reseeds = Ze.reseeds === 4294967295 ? 0 : Ze.reseeds + 1;
        var at = Ze.plugin.md.create();
        at.update(Ze.keyBytes);
        for (var st = 1, ut = 0; ut < 32; ++ut) Ze.reseeds % st == 0 && (at.update(Ze.pools[ut].digest().getBytes()), Ze.pools[ut].start()), st <<= 1;
        Ze.keyBytes = at.digest().getBytes(), at.start(), at.update(Ze.keyBytes);
        var lt = at.digest().getBytes();
        Ze.key = Ze.plugin.formatKey(Ze.keyBytes), Ze.seed = Ze.plugin.formatSeed(lt), Ze.generated = 0;
      }
      function ot(at) {
        var st = null, ut = Ke.util.globalScope, lt = ut.crypto || ut.msCrypto;
        lt && lt.getRandomValues && (st = function(Ct) {
          return lt.getRandomValues(Ct);
        });
        var dt = Ke.util.createBuffer();
        if (st) for (; dt.length() < at; ) {
          var At = Math.max(1, Math.min(at - dt.length(), 65536) / 4), pt = new Uint32Array(Math.floor(At));
          try {
            st(pt);
            for (var gt = 0; gt < pt.length; ++gt) dt.putInt32(pt[gt]);
          } catch (Ct) {
            if (!(typeof QuotaExceededError < "u" && Ct instanceof QuotaExceededError)) throw Ct;
          }
        }
        if (dt.length() < at) for (var wt, Bt, Tt, yt = Math.floor(65536 * Math.random()); dt.length() < at; ) for (Bt = 16807 * (65535 & yt), Bt += (32767 & (wt = 16807 * (yt >> 16))) << 16, yt = 4294967295 & (Bt = (2147483647 & (Bt += wt >> 15)) + (Bt >> 31)), gt = 0; gt < 3; ++gt) Tt = yt >>> (gt << 3), Tt ^= Math.floor(256 * Math.random()), dt.putByte(255 & Tt);
        return dt.getBytes(at);
      }
      return Ze.pools = tt, Ze.pool = 0, Ze.generate = function(at, st) {
        if (!st) return Ze.generateSync(at);
        var ut = Ze.plugin.cipher, lt = Ze.plugin.increment, dt = Ze.plugin.formatKey, At = Ze.plugin.formatSeed, pt = Ke.util.createBuffer();
        Ze.key = null, function gt(wt) {
          if (wt) return st(wt);
          if (pt.length() >= at) return st(null, pt.getBytes(at));
          if (Ze.generated > 1048575 && (Ze.key = null), Ze.key === null) return Ke.util.nextTick(function() {
            (function(Tt) {
              if (Ze.pools[0].messageLength >= 32) return it(), Tt();
              var yt = 32 - Ze.pools[0].messageLength << 5;
              Ze.seedFile(yt, function(Ct, ht) {
                if (Ct) return Tt(Ct);
                Ze.collect(ht), it(), Tt();
              });
            })(gt);
          });
          var Bt = ut(Ze.key, Ze.seed);
          Ze.generated += Bt.length, pt.putBytes(Bt), Ze.key = dt(ut(Ze.key, lt(Ze.seed))), Ze.seed = At(ut(Ze.key, Ze.seed)), Ke.util.setImmediate(gt);
        }();
      }, Ze.generateSync = function(at) {
        var st = Ze.plugin.cipher, ut = Ze.plugin.increment, lt = Ze.plugin.formatKey, dt = Ze.plugin.formatSeed;
        Ze.key = null;
        for (var At = Ke.util.createBuffer(); At.length() < at; ) {
          Ze.generated > 1048575 && (Ze.key = null), Ze.key === null && rt();
          var pt = st(Ze.key, Ze.seed);
          Ze.generated += pt.length, At.putBytes(pt), Ze.key = lt(st(Ze.key, ut(Ze.seed))), Ze.seed = dt(st(Ze.key, Ze.seed));
        }
        return At.getBytes(at);
      }, $e ? (Ze.seedFile = function(at, st) {
        $e.randomBytes(at, function(ut, lt) {
          if (ut) return st(ut);
          st(null, lt.toString());
        });
      }, Ze.seedFileSync = function(at) {
        return $e.randomBytes(at).toString();
      }) : (Ze.seedFile = function(at, st) {
        try {
          st(null, ot(at));
        } catch (ut) {
          st(ut);
        }
      }, Ze.seedFileSync = ot), Ze.collect = function(at) {
        for (var st = at.length, ut = 0; ut < st; ++ut) Ze.pools[Ze.pool].update(at.substr(ut, 1)), Ze.pool = Ze.pool === 31 ? 0 : Ze.pool + 1;
      }, Ze.collectInt = function(at, st) {
        for (var ut = "", lt = 0; lt < st; lt += 8) ut += String.fromCharCode(at >> lt & 255);
        Ze.collect(ut);
      }, Ze.registerWorker = function(at) {
        at === self ? Ze.seedFile = function(st, ut) {
          self.addEventListener("message", function lt(dt) {
            var At = dt.data;
            At.forge && At.forge.prng && (self.removeEventListener("message", lt), ut(At.forge.prng.err, At.forge.prng.bytes));
          }), self.postMessage({ forge: { prng: { needed: st } } });
        } : at.addEventListener("message", function(st) {
          var ut = st.data;
          ut.forge && ut.forge.prng && Ze.seedFile(ut.forge.prng.needed, function(lt, dt) {
            at.postMessage({ forge: { prng: { err: lt, bytes: dt } } });
          });
        });
      }, Ze;
    };
  }, 665: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    Xe(4097), Xe(3103), (He.exports = Ke.pss = Ke.pss || {}).create = function($e) {
      arguments.length === 3 && ($e = { md: arguments[0], mgf: arguments[1], saltLength: arguments[2] });
      var Je, Ze = $e.md, nt = $e.mgf, tt = Ze.digestLength, et = $e.salt || null;
      if (typeof et == "string" && (et = Ke.util.createBuffer(et)), "saltLength" in $e) Je = $e.saltLength;
      else {
        if (et === null) throw new Error("Salt length not specified or specific salt not given.");
        Je = et.length();
      }
      if (et !== null && et.length() !== Je) throw new Error("Given salt length does not match length of given salt.");
      var rt = $e.prng || Ke.random, it = { encode: function(ot, at) {
        var st, ut, lt = at - 1, dt = Math.ceil(lt / 8), At = ot.digest().getBytes();
        if (dt < tt + Je + 2) throw new Error("Message is too long to encrypt.");
        ut = et === null ? rt.getBytesSync(Je) : et.bytes();
        var pt = new Ke.util.ByteBuffer();
        pt.fillWithByte(0, 8), pt.putBytes(At), pt.putBytes(ut), Ze.start(), Ze.update(pt.getBytes());
        var gt = Ze.digest().getBytes(), wt = new Ke.util.ByteBuffer();
        wt.fillWithByte(0, dt - Je - tt - 2), wt.putByte(1), wt.putBytes(ut);
        var Bt = wt.getBytes(), Tt = dt - tt - 1, yt = nt.generate(gt, Tt), Ct = "";
        for (st = 0; st < Tt; st++) Ct += String.fromCharCode(Bt.charCodeAt(st) ^ yt.charCodeAt(st));
        var ht = 65280 >> 8 * dt - lt & 255;
        return (Ct = String.fromCharCode(Ct.charCodeAt(0) & ~ht) + Ct.substr(1)) + gt + "¼";
      }, verify: function(ot, at, st) {
        var ut, lt = st - 1, dt = Math.ceil(lt / 8);
        if (at = at.substr(-dt), dt < tt + Je + 2) throw new Error("Inconsistent parameters to PSS signature verification.");
        if (at.charCodeAt(dt - 1) !== 188) throw new Error("Encoded message does not end in 0xBC.");
        var At = dt - tt - 1, pt = at.substr(0, At), gt = at.substr(At, tt), wt = 65280 >> 8 * dt - lt & 255;
        if (pt.charCodeAt(0) & wt) throw new Error("Bits beyond keysize not zero as expected.");
        var Bt = nt.generate(gt, At), Tt = "";
        for (ut = 0; ut < At; ut++) Tt += String.fromCharCode(pt.charCodeAt(ut) ^ Bt.charCodeAt(ut));
        Tt = String.fromCharCode(Tt.charCodeAt(0) & ~wt) + Tt.substr(1);
        var yt = dt - tt - Je - 2;
        for (ut = 0; ut < yt; ut++) if (Tt.charCodeAt(ut) !== 0) throw new Error("Leftmost octets not zero as expected");
        if (Tt.charCodeAt(yt) !== 1) throw new Error("Inconsistent PSS signature, 0x01 marker not found");
        var Ct = Tt.substr(-Je), ht = new Ke.util.ByteBuffer();
        return ht.fillWithByte(0, 8), ht.putBytes(ot), ht.putBytes(Ct), Ze.start(), Ze.update(ht.getBytes()), gt === Ze.digest().getBytes();
      } };
      return it;
    };
  }, 4097: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    Xe(1482), Xe(9141), Xe(3930), Xe(3103), Ke.random && Ke.random.getBytes ? He.exports = Ke.random : function($e) {
      var Je = {}, Ze = new Array(4), nt = Ke.util.createBuffer();
      function tt() {
        var ut = Ke.prng.create(Je);
        return ut.getBytes = function(lt, dt) {
          return ut.generate(lt, dt);
        }, ut.getBytesSync = function(lt) {
          return ut.generate(lt);
        }, ut;
      }
      Je.formatKey = function(ut) {
        var lt = Ke.util.createBuffer(ut);
        return (ut = new Array(4))[0] = lt.getInt32(), ut[1] = lt.getInt32(), ut[2] = lt.getInt32(), ut[3] = lt.getInt32(), Ke.aes._expandKey(ut, !1);
      }, Je.formatSeed = function(ut) {
        var lt = Ke.util.createBuffer(ut);
        return (ut = new Array(4))[0] = lt.getInt32(), ut[1] = lt.getInt32(), ut[2] = lt.getInt32(), ut[3] = lt.getInt32(), ut;
      }, Je.cipher = function(ut, lt) {
        return Ke.aes._updateBlock(ut, lt, Ze, !1), nt.putInt32(Ze[0]), nt.putInt32(Ze[1]), nt.putInt32(Ze[2]), nt.putInt32(Ze[3]), nt.getBytes();
      }, Je.increment = function(ut) {
        return ++ut[3], ut;
      }, Je.md = Ke.md.sha256;
      var et = tt(), rt = null, it = Ke.util.globalScope, ot = it.crypto || it.msCrypto;
      if (ot && ot.getRandomValues && (rt = function(ut) {
        return ot.getRandomValues(ut);
      }), Ke.options.usePureJavaScript || !Ke.util.isNodejs && !rt) {
        if (et.collectInt(+/* @__PURE__ */ new Date(), 32), typeof navigator < "u") {
          var at = "";
          for (var st in navigator) try {
            typeof navigator[st] == "string" && (at += navigator[st]);
          } catch {
          }
          et.collect(at), at = null;
        }
        $e && ($e().mousemove(function(ut) {
          et.collectInt(ut.clientX, 16), et.collectInt(ut.clientY, 16);
        }), $e().keypress(function(ut) {
          et.collectInt(ut.charCode, 8);
        }));
      }
      if (Ke.random) for (var st in et) Ke.random[st] = et[st];
      else Ke.random = et;
      Ke.random.createInstance = tt, He.exports = Ke.random;
    }(typeof jQuery < "u" ? jQuery : null);
  }, 3323: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    Xe(3103);
    var $e = [217, 120, 249, 196, 25, 221, 181, 237, 40, 233, 253, 121, 74, 160, 216, 157, 198, 126, 55, 131, 43, 118, 83, 142, 98, 76, 100, 136, 68, 139, 251, 162, 23, 154, 89, 245, 135, 179, 79, 19, 97, 69, 109, 141, 9, 129, 125, 50, 189, 143, 64, 235, 134, 183, 123, 11, 240, 149, 33, 34, 92, 107, 78, 130, 84, 214, 101, 147, 206, 96, 178, 28, 115, 86, 192, 20, 167, 140, 241, 220, 18, 117, 202, 31, 59, 190, 228, 209, 66, 61, 212, 48, 163, 60, 182, 38, 111, 191, 14, 218, 70, 105, 7, 87, 39, 242, 29, 155, 188, 148, 67, 3, 248, 17, 199, 246, 144, 239, 62, 231, 6, 195, 213, 47, 200, 102, 30, 215, 8, 232, 234, 222, 128, 82, 238, 247, 132, 170, 114, 172, 53, 77, 106, 42, 150, 26, 210, 113, 90, 21, 73, 116, 75, 159, 208, 94, 4, 24, 164, 236, 194, 224, 65, 110, 15, 81, 203, 204, 36, 145, 175, 80, 161, 244, 112, 57, 153, 124, 58, 133, 35, 184, 180, 122, 252, 2, 54, 91, 37, 85, 151, 49, 45, 93, 250, 152, 227, 138, 146, 174, 5, 223, 41, 16, 103, 108, 186, 201, 211, 0, 230, 207, 225, 158, 168, 44, 99, 22, 1, 63, 88, 226, 137, 169, 13, 56, 52, 27, 171, 51, 255, 176, 187, 72, 12, 95, 185, 177, 205, 46, 197, 243, 219, 71, 229, 165, 156, 119, 10, 166, 32, 104, 254, 127, 193, 173], Je = [1, 2, 3, 5], Ze = function(et, rt) {
      return et << rt & 65535 | (65535 & et) >> 16 - rt;
    }, nt = function(et, rt) {
      return (65535 & et) >> rt | et << 16 - rt & 65535;
    };
    He.exports = Ke.rc2 = Ke.rc2 || {}, Ke.rc2.expandKey = function(et, rt) {
      typeof et == "string" && (et = Ke.util.createBuffer(et)), rt = rt || 128;
      var it, ot = et, at = et.length(), st = rt, ut = Math.ceil(st / 8), lt = 255 >> (7 & st);
      for (it = at; it < 128; it++) ot.putByte($e[ot.at(it - 1) + ot.at(it - at) & 255]);
      for (ot.setAt(128 - ut, $e[ot.at(128 - ut) & lt]), it = 127 - ut; it >= 0; it--) ot.setAt(it, $e[ot.at(it + 1) ^ ot.at(it + ut)]);
      return ot;
    };
    var tt = function(et, rt, it) {
      var ot, at, st, ut, lt = !1, dt = null, At = null, pt = null, gt = [];
      for (et = Ke.rc2.expandKey(et, rt), st = 0; st < 64; st++) gt.push(et.getInt16Le());
      it ? (ot = function(Tt) {
        for (st = 0; st < 4; st++) Tt[st] += gt[ut] + (Tt[(st + 3) % 4] & Tt[(st + 2) % 4]) + (~Tt[(st + 3) % 4] & Tt[(st + 1) % 4]), Tt[st] = Ze(Tt[st], Je[st]), ut++;
      }, at = function(Tt) {
        for (st = 0; st < 4; st++) Tt[st] += gt[63 & Tt[(st + 3) % 4]];
      }) : (ot = function(Tt) {
        for (st = 3; st >= 0; st--) Tt[st] = nt(Tt[st], Je[st]), Tt[st] -= gt[ut] + (Tt[(st + 3) % 4] & Tt[(st + 2) % 4]) + (~Tt[(st + 3) % 4] & Tt[(st + 1) % 4]), ut--;
      }, at = function(Tt) {
        for (st = 3; st >= 0; st--) Tt[st] -= gt[63 & Tt[(st + 3) % 4]];
      });
      var wt = function(Tt) {
        var yt = [];
        for (st = 0; st < 4; st++) {
          var Ct = dt.getInt16Le();
          pt !== null && (it ? Ct ^= pt.getInt16Le() : pt.putInt16Le(Ct)), yt.push(65535 & Ct);
        }
        ut = it ? 0 : 63;
        for (var ht = 0; ht < Tt.length; ht++) for (var It = 0; It < Tt[ht][0]; It++) Tt[ht][1](yt);
        for (st = 0; st < 4; st++) pt !== null && (it ? pt.putInt16Le(yt[st]) : yt[st] ^= pt.getInt16Le()), At.putInt16Le(yt[st]);
      }, Bt = null;
      return Bt = { start: function(Tt, yt) {
        Tt && typeof Tt == "string" && (Tt = Ke.util.createBuffer(Tt)), lt = !1, dt = Ke.util.createBuffer(), At = yt || new Ke.util.createBuffer(), pt = Tt, Bt.output = At;
      }, update: function(Tt) {
        for (lt || dt.putBuffer(Tt); dt.length() >= 8; ) wt([[5, ot], [1, at], [6, ot], [1, at], [5, ot]]);
      }, finish: function(Tt) {
        var yt = !0;
        if (it) if (Tt) yt = Tt(8, dt, !it);
        else {
          var Ct = dt.length() === 8 ? 8 : 8 - dt.length();
          dt.fillWithByte(Ct, Ct);
        }
        if (yt && (lt = !0, Bt.update()), !it && (yt = dt.length() === 0)) if (Tt) yt = Tt(8, At, !it);
        else {
          var ht = At.length(), It = At.at(ht - 1);
          It > ht ? yt = !1 : At.truncate(It);
        }
        return yt;
      } };
    };
    Ke.rc2.startEncrypting = function(et, rt, it) {
      var ot = Ke.rc2.createEncryptionCipher(et, 128);
      return ot.start(rt, it), ot;
    }, Ke.rc2.createEncryptionCipher = function(et, rt) {
      return tt(et, rt, !0);
    }, Ke.rc2.startDecrypting = function(et, rt, it) {
      var ot = Ke.rc2.createDecryptionCipher(et, 128);
      return ot.start(rt, it), ot;
    }, Ke.rc2.createDecryptionCipher = function(et, rt) {
      return tt(et, rt, !1);
    };
  }, 144: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    if (Xe(2624), Xe(1633), Xe(2884), Xe(4034), Xe(8547), Xe(4097), Xe(3103), $e === void 0) var $e = Ke.jsbn.BigInteger;
    var Je = Ke.util.isNodejs ? Xe(5942) : null, Ze = Ke.asn1, nt = Ke.util;
    Ke.pki = Ke.pki || {}, He.exports = Ke.pki.rsa = Ke.rsa = Ke.rsa || {};
    var tt = Ke.pki, et = [6, 4, 2, 4, 2, 4, 6, 2], rt = { name: "PrivateKeyInfo", tagClass: Ze.Class.UNIVERSAL, type: Ze.Type.SEQUENCE, constructed: !0, value: [{ name: "PrivateKeyInfo.version", tagClass: Ze.Class.UNIVERSAL, type: Ze.Type.INTEGER, constructed: !1, capture: "privateKeyVersion" }, { name: "PrivateKeyInfo.privateKeyAlgorithm", tagClass: Ze.Class.UNIVERSAL, type: Ze.Type.SEQUENCE, constructed: !0, value: [{ name: "AlgorithmIdentifier.algorithm", tagClass: Ze.Class.UNIVERSAL, type: Ze.Type.OID, constructed: !1, capture: "privateKeyOid" }] }, { name: "PrivateKeyInfo", tagClass: Ze.Class.UNIVERSAL, type: Ze.Type.OCTETSTRING, constructed: !1, capture: "privateKey" }] }, it = { name: "RSAPrivateKey", tagClass: Ze.Class.UNIVERSAL, type: Ze.Type.SEQUENCE, constructed: !0, value: [{ name: "RSAPrivateKey.version", tagClass: Ze.Class.UNIVERSAL, type: Ze.Type.INTEGER, constructed: !1, capture: "privateKeyVersion" }, { name: "RSAPrivateKey.modulus", tagClass: Ze.Class.UNIVERSAL, type: Ze.Type.INTEGER, constructed: !1, capture: "privateKeyModulus" }, { name: "RSAPrivateKey.publicExponent", tagClass: Ze.Class.UNIVERSAL, type: Ze.Type.INTEGER, constructed: !1, capture: "privateKeyPublicExponent" }, { name: "RSAPrivateKey.privateExponent", tagClass: Ze.Class.UNIVERSAL, type: Ze.Type.INTEGER, constructed: !1, capture: "privateKeyPrivateExponent" }, { name: "RSAPrivateKey.prime1", tagClass: Ze.Class.UNIVERSAL, type: Ze.Type.INTEGER, constructed: !1, capture: "privateKeyPrime1" }, { name: "RSAPrivateKey.prime2", tagClass: Ze.Class.UNIVERSAL, type: Ze.Type.INTEGER, constructed: !1, capture: "privateKeyPrime2" }, { name: "RSAPrivateKey.exponent1", tagClass: Ze.Class.UNIVERSAL, type: Ze.Type.INTEGER, constructed: !1, capture: "privateKeyExponent1" }, { name: "RSAPrivateKey.exponent2", tagClass: Ze.Class.UNIVERSAL, type: Ze.Type.INTEGER, constructed: !1, capture: "privateKeyExponent2" }, { name: "RSAPrivateKey.coefficient", tagClass: Ze.Class.UNIVERSAL, type: Ze.Type.INTEGER, constructed: !1, capture: "privateKeyCoefficient" }] }, ot = { name: "RSAPublicKey", tagClass: Ze.Class.UNIVERSAL, type: Ze.Type.SEQUENCE, constructed: !0, value: [{ name: "RSAPublicKey.modulus", tagClass: Ze.Class.UNIVERSAL, type: Ze.Type.INTEGER, constructed: !1, capture: "publicKeyModulus" }, { name: "RSAPublicKey.exponent", tagClass: Ze.Class.UNIVERSAL, type: Ze.Type.INTEGER, constructed: !1, capture: "publicKeyExponent" }] }, at = Ke.pki.rsa.publicKeyValidator = { name: "SubjectPublicKeyInfo", tagClass: Ze.Class.UNIVERSAL, type: Ze.Type.SEQUENCE, constructed: !0, captureAsn1: "subjectPublicKeyInfo", value: [{ name: "SubjectPublicKeyInfo.AlgorithmIdentifier", tagClass: Ze.Class.UNIVERSAL, type: Ze.Type.SEQUENCE, constructed: !0, value: [{ name: "AlgorithmIdentifier.algorithm", tagClass: Ze.Class.UNIVERSAL, type: Ze.Type.OID, constructed: !1, capture: "publicKeyOid" }] }, { name: "SubjectPublicKeyInfo.subjectPublicKey", tagClass: Ze.Class.UNIVERSAL, type: Ze.Type.BITSTRING, constructed: !1, value: [{ name: "SubjectPublicKeyInfo.subjectPublicKey.RSAPublicKey", tagClass: Ze.Class.UNIVERSAL, type: Ze.Type.SEQUENCE, constructed: !0, optional: !0, captureAsn1: "rsaPublicKey" }] }] }, st = { name: "DigestInfo", tagClass: Ze.Class.UNIVERSAL, type: Ze.Type.SEQUENCE, constructed: !0, value: [{ name: "DigestInfo.DigestAlgorithm", tagClass: Ze.Class.UNIVERSAL, type: Ze.Type.SEQUENCE, constructed: !0, value: [{ name: "DigestInfo.DigestAlgorithm.algorithmIdentifier", tagClass: Ze.Class.UNIVERSAL, type: Ze.Type.OID, constructed: !1, capture: "algorithmIdentifier" }, { name: "DigestInfo.DigestAlgorithm.parameters", tagClass: Ze.Class.UNIVERSAL, type: Ze.Type.NULL, capture: "parameters", optional: !0, constructed: !1 }] }, { name: "DigestInfo.digest", tagClass: Ze.Class.UNIVERSAL, type: Ze.Type.OCTETSTRING, constructed: !1, capture: "digest" }] }, ut = function(ht) {
      var It;
      if (!(ht.algorithm in tt.oids)) {
        var vt = new Error("Unknown message digest algorithm.");
        throw vt.algorithm = ht.algorithm, vt;
      }
      It = tt.oids[ht.algorithm];
      var Et = Ze.oidToDer(It).getBytes(), bt = Ze.create(Ze.Class.UNIVERSAL, Ze.Type.SEQUENCE, !0, []), Rt = Ze.create(Ze.Class.UNIVERSAL, Ze.Type.SEQUENCE, !0, []);
      Rt.value.push(Ze.create(Ze.Class.UNIVERSAL, Ze.Type.OID, !1, Et)), Rt.value.push(Ze.create(Ze.Class.UNIVERSAL, Ze.Type.NULL, !1, ""));
      var St = Ze.create(Ze.Class.UNIVERSAL, Ze.Type.OCTETSTRING, !1, ht.digest().getBytes());
      return bt.value.push(Rt), bt.value.push(St), Ze.toDer(bt).getBytes();
    }, lt = function(ht, It, vt) {
      if (vt) return ht.modPow(It.e, It.n);
      if (!It.p || !It.q) return ht.modPow(It.d, It.n);
      var Et;
      It.dP || (It.dP = It.d.mod(It.p.subtract($e.ONE))), It.dQ || (It.dQ = It.d.mod(It.q.subtract($e.ONE))), It.qInv || (It.qInv = It.q.modInverse(It.p));
      do
        Et = new $e(Ke.util.bytesToHex(Ke.random.getBytes(It.n.bitLength() / 8)), 16);
      while (Et.compareTo(It.n) >= 0 || !Et.gcd(It.n).equals($e.ONE));
      for (var bt = (ht = ht.multiply(Et.modPow(It.e, It.n)).mod(It.n)).mod(It.p).modPow(It.dP, It.p), Rt = ht.mod(It.q).modPow(It.dQ, It.q); bt.compareTo(Rt) < 0; ) bt = bt.add(It.p);
      var St = bt.subtract(Rt).multiply(It.qInv).mod(It.p).multiply(It.q).add(Rt);
      return St.multiply(Et.modInverse(It.n)).mod(It.n);
    };
    function dt(ht, It, vt) {
      var Et = Ke.util.createBuffer(), bt = Math.ceil(It.n.bitLength() / 8);
      if (ht.length > bt - 11) {
        var Rt = new Error("Message is too long for PKCS#1 v1.5 padding.");
        throw Rt.length = ht.length, Rt.max = bt - 11, Rt;
      }
      Et.putByte(0), Et.putByte(vt);
      var St, kt = bt - 3 - ht.length;
      if (vt === 0 || vt === 1) {
        St = vt === 0 ? 0 : 255;
        for (var jt = 0; jt < kt; ++jt) Et.putByte(St);
      } else for (; kt > 0; ) {
        var Pt = 0, Qt = Ke.random.getBytes(kt);
        for (jt = 0; jt < kt; ++jt) (St = Qt.charCodeAt(jt)) === 0 ? ++Pt : Et.putByte(St);
        kt = Pt;
      }
      return Et.putByte(0), Et.putBytes(ht), Et;
    }
    function At(ht, It, vt, Et) {
      var bt = Math.ceil(It.n.bitLength() / 8), Rt = Ke.util.createBuffer(ht), St = Rt.getByte(), kt = Rt.getByte();
      if (St !== 0 || vt && kt !== 0 && kt !== 1 || !vt && kt != 2 || vt && kt === 0 && Et === void 0) throw new Error("Encryption block is invalid.");
      var jt = 0;
      if (kt === 0) {
        jt = bt - 3 - Et;
        for (var Pt = 0; Pt < jt; ++Pt) if (Rt.getByte() !== 0) throw new Error("Encryption block is invalid.");
      } else if (kt === 1) for (jt = 0; Rt.length() > 1; ) {
        if (Rt.getByte() !== 255) {
          --Rt.read;
          break;
        }
        ++jt;
      }
      else if (kt === 2) for (jt = 0; Rt.length() > 1; ) {
        if (Rt.getByte() === 0) {
          --Rt.read;
          break;
        }
        ++jt;
      }
      if (Rt.getByte() !== 0 || jt !== bt - 3 - Rt.length()) throw new Error("Encryption block is invalid.");
      return Rt.getBytes();
    }
    function pt(ht, It, vt) {
      typeof It == "function" && (vt = It, It = {});
      var Et = { algorithm: { name: (It = It || {}).algorithm || "PRIMEINC", options: { workers: It.workers || 2, workLoad: It.workLoad || 100, workerScript: It.workerScript } } };
      function bt() {
        Rt(ht.pBits, function(kt, jt) {
          return kt ? vt(kt) : (ht.p = jt, ht.q !== null ? St(kt, ht.q) : void Rt(ht.qBits, St));
        });
      }
      function Rt(kt, jt) {
        Ke.prime.generateProbablePrime(kt, Et, jt);
      }
      function St(kt, jt) {
        if (kt) return vt(kt);
        if (ht.q = jt, ht.p.compareTo(ht.q) < 0) {
          var Pt = ht.p;
          ht.p = ht.q, ht.q = Pt;
        }
        if (ht.p.subtract($e.ONE).gcd(ht.e).compareTo($e.ONE) !== 0) return ht.p = null, void bt();
        if (ht.q.subtract($e.ONE).gcd(ht.e).compareTo($e.ONE) !== 0) return ht.q = null, void Rt(ht.qBits, St);
        if (ht.p1 = ht.p.subtract($e.ONE), ht.q1 = ht.q.subtract($e.ONE), ht.phi = ht.p1.multiply(ht.q1), ht.phi.gcd(ht.e).compareTo($e.ONE) !== 0) return ht.p = ht.q = null, void bt();
        if (ht.n = ht.p.multiply(ht.q), ht.n.bitLength() !== ht.bits) return ht.q = null, void Rt(ht.qBits, St);
        var Qt = ht.e.modInverse(ht.phi);
        ht.keys = { privateKey: tt.rsa.setPrivateKey(ht.n, ht.e, Qt, ht.p, ht.q, Qt.mod(ht.p1), Qt.mod(ht.q1), ht.q.modInverse(ht.p)), publicKey: tt.rsa.setPublicKey(ht.n, ht.e) }, vt(null, ht.keys);
      }
      "prng" in It && (Et.prng = It.prng), bt();
    }
    function gt(ht) {
      var It = ht.toString(16);
      It[0] >= "8" && (It = "00" + It);
      var vt = Ke.util.hexToBytes(It);
      return vt.length > 1 && (vt.charCodeAt(0) === 0 && !(128 & vt.charCodeAt(1)) || vt.charCodeAt(0) === 255 && (128 & vt.charCodeAt(1)) == 128) ? vt.substr(1) : vt;
    }
    function wt(ht) {
      return ht <= 100 ? 27 : ht <= 150 ? 18 : ht <= 200 ? 15 : ht <= 250 ? 12 : ht <= 300 ? 9 : ht <= 350 ? 8 : ht <= 400 ? 7 : ht <= 500 ? 6 : ht <= 600 ? 5 : ht <= 800 ? 4 : ht <= 1250 ? 3 : 2;
    }
    function Bt(ht) {
      return Ke.util.isNodejs && typeof Je[ht] == "function";
    }
    function Tt(ht) {
      return nt.globalScope !== void 0 && typeof nt.globalScope.crypto == "object" && typeof nt.globalScope.crypto.subtle == "object" && typeof nt.globalScope.crypto.subtle[ht] == "function";
    }
    function yt(ht) {
      return nt.globalScope !== void 0 && typeof nt.globalScope.msCrypto == "object" && typeof nt.globalScope.msCrypto.subtle == "object" && typeof nt.globalScope.msCrypto.subtle[ht] == "function";
    }
    function Ct(ht) {
      for (var It = Ke.util.hexToBytes(ht.toString(16)), vt = new Uint8Array(It.length), Et = 0; Et < It.length; ++Et) vt[Et] = It.charCodeAt(Et);
      return vt;
    }
    tt.rsa.encrypt = function(ht, It, vt) {
      var Et, bt = vt, Rt = Math.ceil(It.n.bitLength() / 8);
      vt !== !1 && vt !== !0 ? (bt = vt === 2, Et = dt(ht, It, vt)) : (Et = Ke.util.createBuffer()).putBytes(ht);
      for (var St = new $e(Et.toHex(), 16), kt = lt(St, It, bt).toString(16), jt = Ke.util.createBuffer(), Pt = Rt - Math.ceil(kt.length / 2); Pt > 0; ) jt.putByte(0), --Pt;
      return jt.putBytes(Ke.util.hexToBytes(kt)), jt.getBytes();
    }, tt.rsa.decrypt = function(ht, It, vt, Et) {
      var bt = Math.ceil(It.n.bitLength() / 8);
      if (ht.length !== bt) {
        var Rt = new Error("Encrypted message length is invalid.");
        throw Rt.length = ht.length, Rt.expected = bt, Rt;
      }
      var St = new $e(Ke.util.createBuffer(ht).toHex(), 16);
      if (St.compareTo(It.n) >= 0) throw new Error("Encrypted message is invalid.");
      for (var kt = lt(St, It, vt).toString(16), jt = Ke.util.createBuffer(), Pt = bt - Math.ceil(kt.length / 2); Pt > 0; ) jt.putByte(0), --Pt;
      return jt.putBytes(Ke.util.hexToBytes(kt)), Et !== !1 ? At(jt.getBytes(), It, vt) : jt.getBytes();
    }, tt.rsa.createKeyPairGenerationState = function(ht, It, vt) {
      typeof ht == "string" && (ht = parseInt(ht, 10)), ht = ht || 2048;
      var Et, bt = (vt = vt || {}).prng || Ke.random, Rt = { nextBytes: function(kt) {
        for (var jt = bt.getBytesSync(kt.length), Pt = 0; Pt < kt.length; ++Pt) kt[Pt] = jt.charCodeAt(Pt);
      } }, St = vt.algorithm || "PRIMEINC";
      if (St !== "PRIMEINC") throw new Error("Invalid key generation algorithm: " + St);
      return (Et = { algorithm: St, state: 0, bits: ht, rng: Rt, eInt: It || 65537, e: new $e(null), p: null, q: null, qBits: ht >> 1, pBits: ht - (ht >> 1), pqState: 0, num: null, keys: null }).e.fromInt(Et.eInt), Et;
    }, tt.rsa.stepKeyPairGenerationState = function(ht, It) {
      "algorithm" in ht || (ht.algorithm = "PRIMEINC");
      var vt = new $e(null);
      vt.fromInt(30);
      for (var Et, bt = 0, Rt = function(qt, _t) {
        return qt | _t;
      }, St = +/* @__PURE__ */ new Date(), kt = 0; ht.keys === null && (It <= 0 || kt < It); ) {
        if (ht.state === 0) {
          var jt = ht.p === null ? ht.pBits : ht.qBits, Pt = jt - 1;
          ht.pqState === 0 ? (ht.num = new $e(jt, ht.rng), ht.num.testBit(Pt) || ht.num.bitwiseTo($e.ONE.shiftLeft(Pt), Rt, ht.num), ht.num.dAddOffset(31 - ht.num.mod(vt).byteValue(), 0), bt = 0, ++ht.pqState) : ht.pqState === 1 ? ht.num.bitLength() > jt ? ht.pqState = 0 : ht.num.isProbablePrime(wt(ht.num.bitLength())) ? ++ht.pqState : ht.num.dAddOffset(et[bt++ % 8], 0) : ht.pqState === 2 ? ht.pqState = ht.num.subtract($e.ONE).gcd(ht.e).compareTo($e.ONE) === 0 ? 3 : 0 : ht.pqState === 3 && (ht.pqState = 0, ht.p === null ? ht.p = ht.num : ht.q = ht.num, ht.p !== null && ht.q !== null && ++ht.state, ht.num = null);
        } else if (ht.state === 1) ht.p.compareTo(ht.q) < 0 && (ht.num = ht.p, ht.p = ht.q, ht.q = ht.num), ++ht.state;
        else if (ht.state === 2) ht.p1 = ht.p.subtract($e.ONE), ht.q1 = ht.q.subtract($e.ONE), ht.phi = ht.p1.multiply(ht.q1), ++ht.state;
        else if (ht.state === 3) ht.phi.gcd(ht.e).compareTo($e.ONE) === 0 ? ++ht.state : (ht.p = null, ht.q = null, ht.state = 0);
        else if (ht.state === 4) ht.n = ht.p.multiply(ht.q), ht.n.bitLength() === ht.bits ? ++ht.state : (ht.q = null, ht.state = 0);
        else if (ht.state === 5) {
          var Qt = ht.e.modInverse(ht.phi);
          ht.keys = { privateKey: tt.rsa.setPrivateKey(ht.n, ht.e, Qt, ht.p, ht.q, Qt.mod(ht.p1), Qt.mod(ht.q1), ht.q.modInverse(ht.p)), publicKey: tt.rsa.setPublicKey(ht.n, ht.e) };
        }
        kt += (Et = +/* @__PURE__ */ new Date()) - St, St = Et;
      }
      return ht.keys !== null;
    }, tt.rsa.generateKeyPair = function(ht, It, vt, Et) {
      if (arguments.length === 1 ? typeof ht == "object" ? (vt = ht, ht = void 0) : typeof ht == "function" && (Et = ht, ht = void 0) : arguments.length === 2 ? typeof ht == "number" ? typeof It == "function" ? (Et = It, It = void 0) : typeof It != "number" && (vt = It, It = void 0) : (vt = ht, Et = It, ht = void 0, It = void 0) : arguments.length === 3 && (typeof It == "number" ? typeof vt == "function" && (Et = vt, vt = void 0) : (Et = vt, vt = It, It = void 0)), vt = vt || {}, ht === void 0 && (ht = vt.bits || 2048), It === void 0 && (It = vt.e || 65537), !Ke.options.usePureJavaScript && !vt.prng && ht >= 256 && ht <= 16384 && (It === 65537 || It === 3)) {
        if (Et) {
          if (Bt("generateKeyPair")) return Je.generateKeyPair("rsa", { modulusLength: ht, publicExponent: It, publicKeyEncoding: { type: "spki", format: "pem" }, privateKeyEncoding: { type: "pkcs8", format: "pem" } }, function(kt, jt, Pt) {
            if (kt) return Et(kt);
            Et(null, { privateKey: tt.privateKeyFromPem(Pt), publicKey: tt.publicKeyFromPem(jt) });
          });
          if (Tt("generateKey") && Tt("exportKey")) return nt.globalScope.crypto.subtle.generateKey({ name: "RSASSA-PKCS1-v1_5", modulusLength: ht, publicExponent: Ct(It), hash: { name: "SHA-256" } }, !0, ["sign", "verify"]).then(function(kt) {
            return nt.globalScope.crypto.subtle.exportKey("pkcs8", kt.privateKey);
          }).then(void 0, function(kt) {
            Et(kt);
          }).then(function(kt) {
            if (kt) {
              var jt = tt.privateKeyFromAsn1(Ze.fromDer(Ke.util.createBuffer(kt)));
              Et(null, { privateKey: jt, publicKey: tt.setRsaPublicKey(jt.n, jt.e) });
            }
          });
          if (yt("generateKey") && yt("exportKey")) {
            var bt = nt.globalScope.msCrypto.subtle.generateKey({ name: "RSASSA-PKCS1-v1_5", modulusLength: ht, publicExponent: Ct(It), hash: { name: "SHA-256" } }, !0, ["sign", "verify"]);
            return bt.oncomplete = function(kt) {
              var jt = kt.target.result, Pt = nt.globalScope.msCrypto.subtle.exportKey("pkcs8", jt.privateKey);
              Pt.oncomplete = function(Qt) {
                var qt = Qt.target.result, _t = tt.privateKeyFromAsn1(Ze.fromDer(Ke.util.createBuffer(qt)));
                Et(null, { privateKey: _t, publicKey: tt.setRsaPublicKey(_t.n, _t.e) });
              }, Pt.onerror = function(Qt) {
                Et(Qt);
              };
            }, void (bt.onerror = function(kt) {
              Et(kt);
            });
          }
        } else if (Bt("generateKeyPairSync")) {
          var Rt = Je.generateKeyPairSync("rsa", { modulusLength: ht, publicExponent: It, publicKeyEncoding: { type: "spki", format: "pem" }, privateKeyEncoding: { type: "pkcs8", format: "pem" } });
          return { privateKey: tt.privateKeyFromPem(Rt.privateKey), publicKey: tt.publicKeyFromPem(Rt.publicKey) };
        }
      }
      var St = tt.rsa.createKeyPairGenerationState(ht, It, vt);
      if (!Et) return tt.rsa.stepKeyPairGenerationState(St, 0), St.keys;
      pt(St, vt, Et);
    }, tt.setRsaPublicKey = tt.rsa.setPublicKey = function(ht, It) {
      var vt = { n: ht, e: It, encrypt: function(Et, bt, Rt) {
        if (typeof bt == "string" ? bt = bt.toUpperCase() : bt === void 0 && (bt = "RSAES-PKCS1-V1_5"), bt === "RSAES-PKCS1-V1_5") bt = { encode: function(kt, jt, Pt) {
          return dt(kt, jt, 2).getBytes();
        } };
        else if (bt === "RSA-OAEP" || bt === "RSAES-OAEP") bt = { encode: function(kt, jt) {
          return Ke.pkcs1.encode_rsa_oaep(jt, kt, Rt);
        } };
        else if (["RAW", "NONE", "NULL", null].indexOf(bt) !== -1) bt = { encode: function(kt) {
          return kt;
        } };
        else if (typeof bt == "string") throw new Error('Unsupported encryption scheme: "' + bt + '".');
        var St = bt.encode(Et, vt, !0);
        return tt.rsa.encrypt(St, vt, !0);
      }, verify: function(Et, bt, Rt, St) {
        typeof Rt == "string" ? Rt = Rt.toUpperCase() : Rt === void 0 && (Rt = "RSASSA-PKCS1-V1_5"), St === void 0 && (St = { _parseAllDigestBytes: !0 }), "_parseAllDigestBytes" in St || (St._parseAllDigestBytes = !0), Rt === "RSASSA-PKCS1-V1_5" ? Rt = { verify: function(jt, Pt) {
          Pt = At(Pt, vt, !0);
          var Qt = Ze.fromDer(Pt, { parseAllBytes: St._parseAllDigestBytes }), qt = {}, _t = [];
          if (!Ze.validate(Qt, st, qt, _t)) throw (Yt = new Error("ASN.1 object does not contain a valid RSASSA-PKCS1-v1_5 DigestInfo value.")).errors = _t, Yt;
          var Yt, Xt = Ze.derToOid(qt.algorithmIdentifier);
          if (Xt !== Ke.oids.md2 && Xt !== Ke.oids.md5 && Xt !== Ke.oids.sha1 && Xt !== Ke.oids.sha224 && Xt !== Ke.oids.sha256 && Xt !== Ke.oids.sha384 && Xt !== Ke.oids.sha512 && Xt !== Ke.oids["sha512-224"] && Xt !== Ke.oids["sha512-256"]) throw (Yt = new Error("Unknown RSASSA-PKCS1-v1_5 DigestAlgorithm identifier.")).oid = Xt, Yt;
          if ((Xt === Ke.oids.md2 || Xt === Ke.oids.md5) && !("parameters" in qt)) throw new Error("ASN.1 object does not contain a valid RSASSA-PKCS1-v1_5 DigestInfo value. Missing algorithm identifer NULL parameters.");
          return jt === qt.digest;
        } } : Rt !== "NONE" && Rt !== "NULL" && Rt !== null || (Rt = { verify: function(jt, Pt) {
          return jt === At(Pt, vt, !0);
        } });
        var kt = tt.rsa.decrypt(bt, vt, !0, !1);
        return Rt.verify(Et, kt, vt.n.bitLength());
      } };
      return vt;
    }, tt.setRsaPrivateKey = tt.rsa.setPrivateKey = function(ht, It, vt, Et, bt, Rt, St, kt) {
      var jt = { n: ht, e: It, d: vt, p: Et, q: bt, dP: Rt, dQ: St, qInv: kt, decrypt: function(Pt, Qt, qt) {
        typeof Qt == "string" ? Qt = Qt.toUpperCase() : Qt === void 0 && (Qt = "RSAES-PKCS1-V1_5");
        var _t = tt.rsa.decrypt(Pt, jt, !1, !1);
        if (Qt === "RSAES-PKCS1-V1_5") Qt = { decode: At };
        else if (Qt === "RSA-OAEP" || Qt === "RSAES-OAEP") Qt = { decode: function(Yt, Xt) {
          return Ke.pkcs1.decode_rsa_oaep(Xt, Yt, qt);
        } };
        else {
          if (["RAW", "NONE", "NULL", null].indexOf(Qt) === -1) throw new Error('Unsupported encryption scheme: "' + Qt + '".');
          Qt = { decode: function(Yt) {
            return Yt;
          } };
        }
        return Qt.decode(_t, jt, !1);
      }, sign: function(Pt, Qt) {
        var qt = !1;
        typeof Qt == "string" && (Qt = Qt.toUpperCase()), Qt === void 0 || Qt === "RSASSA-PKCS1-V1_5" ? (Qt = { encode: ut }, qt = 1) : Qt !== "NONE" && Qt !== "NULL" && Qt !== null || (Qt = { encode: function() {
          return Pt;
        } }, qt = 1);
        var _t = Qt.encode(Pt, jt.n.bitLength());
        return tt.rsa.encrypt(_t, jt, qt);
      } };
      return jt;
    }, tt.wrapRsaPrivateKey = function(ht) {
      return Ze.create(Ze.Class.UNIVERSAL, Ze.Type.SEQUENCE, !0, [Ze.create(Ze.Class.UNIVERSAL, Ze.Type.INTEGER, !1, Ze.integerToDer(0).getBytes()), Ze.create(Ze.Class.UNIVERSAL, Ze.Type.SEQUENCE, !0, [Ze.create(Ze.Class.UNIVERSAL, Ze.Type.OID, !1, Ze.oidToDer(tt.oids.rsaEncryption).getBytes()), Ze.create(Ze.Class.UNIVERSAL, Ze.Type.NULL, !1, "")]), Ze.create(Ze.Class.UNIVERSAL, Ze.Type.OCTETSTRING, !1, Ze.toDer(ht).getBytes())]);
    }, tt.privateKeyFromAsn1 = function(ht) {
      var It, vt, Et, bt, Rt, St, kt, jt, Pt = {}, Qt = [];
      if (Ze.validate(ht, rt, Pt, Qt) && (ht = Ze.fromDer(Ke.util.createBuffer(Pt.privateKey))), Pt = {}, Qt = [], !Ze.validate(ht, it, Pt, Qt)) {
        var qt = new Error("Cannot read private key. ASN.1 object does not contain an RSAPrivateKey.");
        throw qt.errors = Qt, qt;
      }
      return It = Ke.util.createBuffer(Pt.privateKeyModulus).toHex(), vt = Ke.util.createBuffer(Pt.privateKeyPublicExponent).toHex(), Et = Ke.util.createBuffer(Pt.privateKeyPrivateExponent).toHex(), bt = Ke.util.createBuffer(Pt.privateKeyPrime1).toHex(), Rt = Ke.util.createBuffer(Pt.privateKeyPrime2).toHex(), St = Ke.util.createBuffer(Pt.privateKeyExponent1).toHex(), kt = Ke.util.createBuffer(Pt.privateKeyExponent2).toHex(), jt = Ke.util.createBuffer(Pt.privateKeyCoefficient).toHex(), tt.setRsaPrivateKey(new $e(It, 16), new $e(vt, 16), new $e(Et, 16), new $e(bt, 16), new $e(Rt, 16), new $e(St, 16), new $e(kt, 16), new $e(jt, 16));
    }, tt.privateKeyToAsn1 = tt.privateKeyToRSAPrivateKey = function(ht) {
      return Ze.create(Ze.Class.UNIVERSAL, Ze.Type.SEQUENCE, !0, [Ze.create(Ze.Class.UNIVERSAL, Ze.Type.INTEGER, !1, Ze.integerToDer(0).getBytes()), Ze.create(Ze.Class.UNIVERSAL, Ze.Type.INTEGER, !1, gt(ht.n)), Ze.create(Ze.Class.UNIVERSAL, Ze.Type.INTEGER, !1, gt(ht.e)), Ze.create(Ze.Class.UNIVERSAL, Ze.Type.INTEGER, !1, gt(ht.d)), Ze.create(Ze.Class.UNIVERSAL, Ze.Type.INTEGER, !1, gt(ht.p)), Ze.create(Ze.Class.UNIVERSAL, Ze.Type.INTEGER, !1, gt(ht.q)), Ze.create(Ze.Class.UNIVERSAL, Ze.Type.INTEGER, !1, gt(ht.dP)), Ze.create(Ze.Class.UNIVERSAL, Ze.Type.INTEGER, !1, gt(ht.dQ)), Ze.create(Ze.Class.UNIVERSAL, Ze.Type.INTEGER, !1, gt(ht.qInv))]);
    }, tt.publicKeyFromAsn1 = function(ht) {
      var It = {}, vt = [];
      if (Ze.validate(ht, at, It, vt)) {
        var Et, bt = Ze.derToOid(It.publicKeyOid);
        if (bt !== tt.oids.rsaEncryption) throw (Et = new Error("Cannot read public key. Unknown OID.")).oid = bt, Et;
        ht = It.rsaPublicKey;
      }
      if (vt = [], !Ze.validate(ht, ot, It, vt)) throw (Et = new Error("Cannot read public key. ASN.1 object does not contain an RSAPublicKey.")).errors = vt, Et;
      var Rt = Ke.util.createBuffer(It.publicKeyModulus).toHex(), St = Ke.util.createBuffer(It.publicKeyExponent).toHex();
      return tt.setRsaPublicKey(new $e(Rt, 16), new $e(St, 16));
    }, tt.publicKeyToAsn1 = tt.publicKeyToSubjectPublicKeyInfo = function(ht) {
      return Ze.create(Ze.Class.UNIVERSAL, Ze.Type.SEQUENCE, !0, [Ze.create(Ze.Class.UNIVERSAL, Ze.Type.SEQUENCE, !0, [Ze.create(Ze.Class.UNIVERSAL, Ze.Type.OID, !1, Ze.oidToDer(tt.oids.rsaEncryption).getBytes()), Ze.create(Ze.Class.UNIVERSAL, Ze.Type.NULL, !1, "")]), Ze.create(Ze.Class.UNIVERSAL, Ze.Type.BITSTRING, !1, [tt.publicKeyToRSAPublicKey(ht)])]);
    }, tt.publicKeyToRSAPublicKey = function(ht) {
      return Ze.create(Ze.Class.UNIVERSAL, Ze.Type.SEQUENCE, !0, [Ze.create(Ze.Class.UNIVERSAL, Ze.Type.INTEGER, !1, gt(ht.n)), Ze.create(Ze.Class.UNIVERSAL, Ze.Type.INTEGER, !1, gt(ht.e))]);
    };
  }, 2936: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    Xe(6067), Xe(3103);
    var $e = He.exports = Ke.sha1 = Ke.sha1 || {};
    Ke.md.sha1 = Ke.md.algorithms.sha1 = $e, $e.create = function() {
      Ze || (Je = "", Je += Ke.util.fillString("\0", 64), Ze = !0);
      var tt = null, et = Ke.util.createBuffer(), rt = new Array(80), it = { algorithm: "sha1", blockLength: 64, digestLength: 20, messageLength: 0, fullMessageLength: null, messageLengthSize: 8, start: function() {
        it.messageLength = 0, it.fullMessageLength = it.messageLength64 = [];
        for (var ot = it.messageLengthSize / 4, at = 0; at < ot; ++at) it.fullMessageLength.push(0);
        return et = Ke.util.createBuffer(), tt = { h0: 1732584193, h1: 4023233417, h2: 2562383102, h3: 271733878, h4: 3285377520 }, it;
      } };
      return it.start(), it.update = function(ot, at) {
        at === "utf8" && (ot = Ke.util.encodeUtf8(ot));
        var st = ot.length;
        it.messageLength += st, st = [st / 4294967296 >>> 0, st >>> 0];
        for (var ut = it.fullMessageLength.length - 1; ut >= 0; --ut) it.fullMessageLength[ut] += st[1], st[1] = st[0] + (it.fullMessageLength[ut] / 4294967296 >>> 0), it.fullMessageLength[ut] = it.fullMessageLength[ut] >>> 0, st[0] = st[1] / 4294967296 >>> 0;
        return et.putBytes(ot), nt(tt, rt, et), (et.read > 2048 || et.length() === 0) && et.compact(), it;
      }, it.digest = function() {
        var ot = Ke.util.createBuffer();
        ot.putBytes(et.bytes());
        var at, st = it.fullMessageLength[it.fullMessageLength.length - 1] + it.messageLengthSize & it.blockLength - 1;
        ot.putBytes(Je.substr(0, it.blockLength - st));
        for (var ut = 8 * it.fullMessageLength[0], lt = 0; lt < it.fullMessageLength.length - 1; ++lt) ut += (at = 8 * it.fullMessageLength[lt + 1]) / 4294967296 >>> 0, ot.putInt32(ut >>> 0), ut = at >>> 0;
        ot.putInt32(ut);
        var dt = { h0: tt.h0, h1: tt.h1, h2: tt.h2, h3: tt.h3, h4: tt.h4 };
        nt(dt, rt, ot);
        var At = Ke.util.createBuffer();
        return At.putInt32(dt.h0), At.putInt32(dt.h1), At.putInt32(dt.h2), At.putInt32(dt.h3), At.putInt32(dt.h4), At;
      }, it;
    };
    var Je = null, Ze = !1;
    function nt(tt, et, rt) {
      for (var it, ot, at, st, ut, lt, dt, At = rt.length(); At >= 64; ) {
        for (ot = tt.h0, at = tt.h1, st = tt.h2, ut = tt.h3, lt = tt.h4, dt = 0; dt < 16; ++dt) it = rt.getInt32(), et[dt] = it, it = (ot << 5 | ot >>> 27) + (ut ^ at & (st ^ ut)) + lt + 1518500249 + it, lt = ut, ut = st, st = (at << 30 | at >>> 2) >>> 0, at = ot, ot = it;
        for (; dt < 20; ++dt) it = (it = et[dt - 3] ^ et[dt - 8] ^ et[dt - 14] ^ et[dt - 16]) << 1 | it >>> 31, et[dt] = it, it = (ot << 5 | ot >>> 27) + (ut ^ at & (st ^ ut)) + lt + 1518500249 + it, lt = ut, ut = st, st = (at << 30 | at >>> 2) >>> 0, at = ot, ot = it;
        for (; dt < 32; ++dt) it = (it = et[dt - 3] ^ et[dt - 8] ^ et[dt - 14] ^ et[dt - 16]) << 1 | it >>> 31, et[dt] = it, it = (ot << 5 | ot >>> 27) + (at ^ st ^ ut) + lt + 1859775393 + it, lt = ut, ut = st, st = (at << 30 | at >>> 2) >>> 0, at = ot, ot = it;
        for (; dt < 40; ++dt) it = (it = et[dt - 6] ^ et[dt - 16] ^ et[dt - 28] ^ et[dt - 32]) << 2 | it >>> 30, et[dt] = it, it = (ot << 5 | ot >>> 27) + (at ^ st ^ ut) + lt + 1859775393 + it, lt = ut, ut = st, st = (at << 30 | at >>> 2) >>> 0, at = ot, ot = it;
        for (; dt < 60; ++dt) it = (it = et[dt - 6] ^ et[dt - 16] ^ et[dt - 28] ^ et[dt - 32]) << 2 | it >>> 30, et[dt] = it, it = (ot << 5 | ot >>> 27) + (at & st | ut & (at ^ st)) + lt + 2400959708 + it, lt = ut, ut = st, st = (at << 30 | at >>> 2) >>> 0, at = ot, ot = it;
        for (; dt < 80; ++dt) it = (it = et[dt - 6] ^ et[dt - 16] ^ et[dt - 28] ^ et[dt - 32]) << 2 | it >>> 30, et[dt] = it, it = (ot << 5 | ot >>> 27) + (at ^ st ^ ut) + lt + 3395469782 + it, lt = ut, ut = st, st = (at << 30 | at >>> 2) >>> 0, at = ot, ot = it;
        tt.h0 = tt.h0 + ot | 0, tt.h1 = tt.h1 + at | 0, tt.h2 = tt.h2 + st | 0, tt.h3 = tt.h3 + ut | 0, tt.h4 = tt.h4 + lt | 0, At -= 64;
      }
    }
  }, 9141: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    Xe(6067), Xe(3103);
    var $e = He.exports = Ke.sha256 = Ke.sha256 || {};
    Ke.md.sha256 = Ke.md.algorithms.sha256 = $e, $e.create = function() {
      Ze || (Je = "", Je += Ke.util.fillString("\0", 64), nt = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298], Ze = !0);
      var et = null, rt = Ke.util.createBuffer(), it = new Array(64), ot = { algorithm: "sha256", blockLength: 64, digestLength: 32, messageLength: 0, fullMessageLength: null, messageLengthSize: 8, start: function() {
        ot.messageLength = 0, ot.fullMessageLength = ot.messageLength64 = [];
        for (var at = ot.messageLengthSize / 4, st = 0; st < at; ++st) ot.fullMessageLength.push(0);
        return rt = Ke.util.createBuffer(), et = { h0: 1779033703, h1: 3144134277, h2: 1013904242, h3: 2773480762, h4: 1359893119, h5: 2600822924, h6: 528734635, h7: 1541459225 }, ot;
      } };
      return ot.start(), ot.update = function(at, st) {
        st === "utf8" && (at = Ke.util.encodeUtf8(at));
        var ut = at.length;
        ot.messageLength += ut, ut = [ut / 4294967296 >>> 0, ut >>> 0];
        for (var lt = ot.fullMessageLength.length - 1; lt >= 0; --lt) ot.fullMessageLength[lt] += ut[1], ut[1] = ut[0] + (ot.fullMessageLength[lt] / 4294967296 >>> 0), ot.fullMessageLength[lt] = ot.fullMessageLength[lt] >>> 0, ut[0] = ut[1] / 4294967296 >>> 0;
        return rt.putBytes(at), tt(et, it, rt), (rt.read > 2048 || rt.length() === 0) && rt.compact(), ot;
      }, ot.digest = function() {
        var at = Ke.util.createBuffer();
        at.putBytes(rt.bytes());
        var st, ut = ot.fullMessageLength[ot.fullMessageLength.length - 1] + ot.messageLengthSize & ot.blockLength - 1;
        at.putBytes(Je.substr(0, ot.blockLength - ut));
        for (var lt = 8 * ot.fullMessageLength[0], dt = 0; dt < ot.fullMessageLength.length - 1; ++dt) lt += (st = 8 * ot.fullMessageLength[dt + 1]) / 4294967296 >>> 0, at.putInt32(lt >>> 0), lt = st >>> 0;
        at.putInt32(lt);
        var At = { h0: et.h0, h1: et.h1, h2: et.h2, h3: et.h3, h4: et.h4, h5: et.h5, h6: et.h6, h7: et.h7 };
        tt(At, it, at);
        var pt = Ke.util.createBuffer();
        return pt.putInt32(At.h0), pt.putInt32(At.h1), pt.putInt32(At.h2), pt.putInt32(At.h3), pt.putInt32(At.h4), pt.putInt32(At.h5), pt.putInt32(At.h6), pt.putInt32(At.h7), pt;
      }, ot;
    };
    var Je = null, Ze = !1, nt = null;
    function tt(et, rt, it) {
      for (var ot, at, st, ut, lt, dt, At, pt, gt, wt, Bt, Tt, yt, Ct = it.length(); Ct >= 64; ) {
        for (lt = 0; lt < 16; ++lt) rt[lt] = it.getInt32();
        for (; lt < 64; ++lt) ot = ((ot = rt[lt - 2]) >>> 17 | ot << 15) ^ (ot >>> 19 | ot << 13) ^ ot >>> 10, at = ((at = rt[lt - 15]) >>> 7 | at << 25) ^ (at >>> 18 | at << 14) ^ at >>> 3, rt[lt] = ot + rt[lt - 7] + at + rt[lt - 16] | 0;
        for (dt = et.h0, At = et.h1, pt = et.h2, gt = et.h3, wt = et.h4, Bt = et.h5, Tt = et.h6, yt = et.h7, lt = 0; lt < 64; ++lt) st = (dt >>> 2 | dt << 30) ^ (dt >>> 13 | dt << 19) ^ (dt >>> 22 | dt << 10), ut = dt & At | pt & (dt ^ At), ot = yt + ((wt >>> 6 | wt << 26) ^ (wt >>> 11 | wt << 21) ^ (wt >>> 25 | wt << 7)) + (Tt ^ wt & (Bt ^ Tt)) + nt[lt] + rt[lt], yt = Tt, Tt = Bt, Bt = wt, wt = gt + ot >>> 0, gt = pt, pt = At, At = dt, dt = ot + (at = st + ut) >>> 0;
        et.h0 = et.h0 + dt | 0, et.h1 = et.h1 + At | 0, et.h2 = et.h2 + pt | 0, et.h3 = et.h3 + gt | 0, et.h4 = et.h4 + wt | 0, et.h5 = et.h5 + Bt | 0, et.h6 = et.h6 + Tt | 0, et.h7 = et.h7 + yt | 0, Ct -= 64;
      }
    }
  }, 8672: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    Xe(6067), Xe(3103);
    var $e = He.exports = Ke.sha512 = Ke.sha512 || {};
    Ke.md.sha512 = Ke.md.algorithms.sha512 = $e;
    var Je = Ke.sha384 = Ke.sha512.sha384 = Ke.sha512.sha384 || {};
    Je.create = function() {
      return $e.create("SHA-384");
    }, Ke.md.sha384 = Ke.md.algorithms.sha384 = Je, Ke.sha512.sha256 = Ke.sha512.sha256 || { create: function() {
      return $e.create("SHA-512/256");
    } }, Ke.md["sha512/256"] = Ke.md.algorithms["sha512/256"] = Ke.sha512.sha256, Ke.sha512.sha224 = Ke.sha512.sha224 || { create: function() {
      return $e.create("SHA-512/224");
    } }, Ke.md["sha512/224"] = Ke.md.algorithms["sha512/224"] = Ke.sha512.sha224, $e.create = function(it) {
      if (nt || (Ze = "", Ze += Ke.util.fillString("\0", 128), tt = [[1116352408, 3609767458], [1899447441, 602891725], [3049323471, 3964484399], [3921009573, 2173295548], [961987163, 4081628472], [1508970993, 3053834265], [2453635748, 2937671579], [2870763221, 3664609560], [3624381080, 2734883394], [310598401, 1164996542], [607225278, 1323610764], [1426881987, 3590304994], [1925078388, 4068182383], [2162078206, 991336113], [2614888103, 633803317], [3248222580, 3479774868], [3835390401, 2666613458], [4022224774, 944711139], [264347078, 2341262773], [604807628, 2007800933], [770255983, 1495990901], [1249150122, 1856431235], [1555081692, 3175218132], [1996064986, 2198950837], [2554220882, 3999719339], [2821834349, 766784016], [2952996808, 2566594879], [3210313671, 3203337956], [3336571891, 1034457026], [3584528711, 2466948901], [113926993, 3758326383], [338241895, 168717936], [666307205, 1188179964], [773529912, 1546045734], [1294757372, 1522805485], [1396182291, 2643833823], [1695183700, 2343527390], [1986661051, 1014477480], [2177026350, 1206759142], [2456956037, 344077627], [2730485921, 1290863460], [2820302411, 3158454273], [3259730800, 3505952657], [3345764771, 106217008], [3516065817, 3606008344], [3600352804, 1432725776], [4094571909, 1467031594], [275423344, 851169720], [430227734, 3100823752], [506948616, 1363258195], [659060556, 3750685593], [883997877, 3785050280], [958139571, 3318307427], [1322822218, 3812723403], [1537002063, 2003034995], [1747873779, 3602036899], [1955562222, 1575990012], [2024104815, 1125592928], [2227730452, 2716904306], [2361852424, 442776044], [2428436474, 593698344], [2756734187, 3733110249], [3204031479, 2999351573], [3329325298, 3815920427], [3391569614, 3928383900], [3515267271, 566280711], [3940187606, 3454069534], [4118630271, 4000239992], [116418474, 1914138554], [174292421, 2731055270], [289380356, 3203993006], [460393269, 320620315], [685471733, 587496836], [852142971, 1086792851], [1017036298, 365543100], [1126000580, 2618297676], [1288033470, 3409855158], [1501505948, 4234509866], [1607167915, 987167468], [1816402316, 1246189591]], (et = {})["SHA-512"] = [[1779033703, 4089235720], [3144134277, 2227873595], [1013904242, 4271175723], [2773480762, 1595750129], [1359893119, 2917565137], [2600822924, 725511199], [528734635, 4215389547], [1541459225, 327033209]], et["SHA-384"] = [[3418070365, 3238371032], [1654270250, 914150663], [2438529370, 812702999], [355462360, 4144912697], [1731405415, 4290775857], [2394180231, 1750603025], [3675008525, 1694076839], [1203062813, 3204075428]], et["SHA-512/256"] = [[573645204, 4230739756], [2673172387, 3360449730], [596883563, 1867755857], [2520282905, 1497426621], [2519219938, 2827943907], [3193839141, 1401305490], [721525244, 746961066], [246885852, 2177182882]], et["SHA-512/224"] = [[2352822216, 424955298], [1944164710, 2312950998], [502970286, 855612546], [1738396948, 1479516111], [258812777, 2077511080], [2011393907, 79989058], [1067287976, 1780299464], [286451373, 2446758561]], nt = !0), it === void 0 && (it = "SHA-512"), !(it in et)) throw new Error("Invalid SHA-512 algorithm: " + it);
      for (var ot = et[it], at = null, st = Ke.util.createBuffer(), ut = new Array(80), lt = 0; lt < 80; ++lt) ut[lt] = new Array(2);
      var dt = 64;
      switch (it) {
        case "SHA-384":
          dt = 48;
          break;
        case "SHA-512/256":
          dt = 32;
          break;
        case "SHA-512/224":
          dt = 28;
      }
      var At = { algorithm: it.replace("-", "").toLowerCase(), blockLength: 128, digestLength: dt, messageLength: 0, fullMessageLength: null, messageLengthSize: 16, start: function() {
        At.messageLength = 0, At.fullMessageLength = At.messageLength128 = [];
        for (var pt = At.messageLengthSize / 4, gt = 0; gt < pt; ++gt) At.fullMessageLength.push(0);
        for (st = Ke.util.createBuffer(), at = new Array(ot.length), gt = 0; gt < ot.length; ++gt) at[gt] = ot[gt].slice(0);
        return At;
      } };
      return At.start(), At.update = function(pt, gt) {
        gt === "utf8" && (pt = Ke.util.encodeUtf8(pt));
        var wt = pt.length;
        At.messageLength += wt, wt = [wt / 4294967296 >>> 0, wt >>> 0];
        for (var Bt = At.fullMessageLength.length - 1; Bt >= 0; --Bt) At.fullMessageLength[Bt] += wt[1], wt[1] = wt[0] + (At.fullMessageLength[Bt] / 4294967296 >>> 0), At.fullMessageLength[Bt] = At.fullMessageLength[Bt] >>> 0, wt[0] = wt[1] / 4294967296 >>> 0;
        return st.putBytes(pt), rt(at, ut, st), (st.read > 2048 || st.length() === 0) && st.compact(), At;
      }, At.digest = function() {
        var pt = Ke.util.createBuffer();
        pt.putBytes(st.bytes());
        var gt, wt = At.fullMessageLength[At.fullMessageLength.length - 1] + At.messageLengthSize & At.blockLength - 1;
        pt.putBytes(Ze.substr(0, At.blockLength - wt));
        for (var Bt = 8 * At.fullMessageLength[0], Tt = 0; Tt < At.fullMessageLength.length - 1; ++Tt) Bt += (gt = 8 * At.fullMessageLength[Tt + 1]) / 4294967296 >>> 0, pt.putInt32(Bt >>> 0), Bt = gt >>> 0;
        pt.putInt32(Bt);
        var yt = new Array(at.length);
        for (Tt = 0; Tt < at.length; ++Tt) yt[Tt] = at[Tt].slice(0);
        rt(yt, ut, pt);
        var Ct, ht = Ke.util.createBuffer();
        for (Ct = it === "SHA-512" ? yt.length : it === "SHA-384" ? yt.length - 2 : yt.length - 4, Tt = 0; Tt < Ct; ++Tt) ht.putInt32(yt[Tt][0]), Tt === Ct - 1 && it === "SHA-512/224" || ht.putInt32(yt[Tt][1]);
        return ht;
      }, At;
    };
    var Ze = null, nt = !1, tt = null, et = null;
    function rt(it, ot, at) {
      for (var st, ut, lt, dt, At, pt, gt, wt, Bt, Tt, yt, Ct, ht, It, vt, Et, bt, Rt, St, kt, jt, Pt, Qt, qt, _t, Yt, Xt, Ut, Lt, Ot, ft, Dt, Mt, Ft = at.length(); Ft >= 128; ) {
        for (Xt = 0; Xt < 16; ++Xt) ot[Xt][0] = at.getInt32() >>> 0, ot[Xt][1] = at.getInt32() >>> 0;
        for (; Xt < 80; ++Xt) st = (((Ut = (Ot = ot[Xt - 2])[0]) >>> 19 | (Lt = Ot[1]) << 13) ^ (Lt >>> 29 | Ut << 3) ^ Ut >>> 6) >>> 0, ut = ((Ut << 13 | Lt >>> 19) ^ (Lt << 3 | Ut >>> 29) ^ (Ut << 26 | Lt >>> 6)) >>> 0, lt = (((Ut = (Dt = ot[Xt - 15])[0]) >>> 1 | (Lt = Dt[1]) << 31) ^ (Ut >>> 8 | Lt << 24) ^ Ut >>> 7) >>> 0, dt = ((Ut << 31 | Lt >>> 1) ^ (Ut << 24 | Lt >>> 8) ^ (Ut << 25 | Lt >>> 7)) >>> 0, ft = ot[Xt - 7], Mt = ot[Xt - 16], Lt = ut + ft[1] + dt + Mt[1], ot[Xt][0] = st + ft[0] + lt + Mt[0] + (Lt / 4294967296 >>> 0) >>> 0, ot[Xt][1] = Lt >>> 0;
        for (yt = it[0][0], Ct = it[0][1], ht = it[1][0], It = it[1][1], vt = it[2][0], Et = it[2][1], bt = it[3][0], Rt = it[3][1], St = it[4][0], kt = it[4][1], jt = it[5][0], Pt = it[5][1], Qt = it[6][0], qt = it[6][1], _t = it[7][0], Yt = it[7][1], Xt = 0; Xt < 80; ++Xt) gt = ((St >>> 14 | kt << 18) ^ (St >>> 18 | kt << 14) ^ (kt >>> 9 | St << 23)) >>> 0, wt = (Qt ^ St & (jt ^ Qt)) >>> 0, At = ((yt >>> 28 | Ct << 4) ^ (Ct >>> 2 | yt << 30) ^ (Ct >>> 7 | yt << 25)) >>> 0, pt = ((yt << 4 | Ct >>> 28) ^ (Ct << 30 | yt >>> 2) ^ (Ct << 25 | yt >>> 7)) >>> 0, Bt = (yt & ht | vt & (yt ^ ht)) >>> 0, Tt = (Ct & It | Et & (Ct ^ It)) >>> 0, Lt = Yt + (((St << 18 | kt >>> 14) ^ (St << 14 | kt >>> 18) ^ (kt << 23 | St >>> 9)) >>> 0) + ((qt ^ kt & (Pt ^ qt)) >>> 0) + tt[Xt][1] + ot[Xt][1], st = _t + gt + wt + tt[Xt][0] + ot[Xt][0] + (Lt / 4294967296 >>> 0) >>> 0, ut = Lt >>> 0, lt = At + Bt + ((Lt = pt + Tt) / 4294967296 >>> 0) >>> 0, dt = Lt >>> 0, _t = Qt, Yt = qt, Qt = jt, qt = Pt, jt = St, Pt = kt, St = bt + st + ((Lt = Rt + ut) / 4294967296 >>> 0) >>> 0, kt = Lt >>> 0, bt = vt, Rt = Et, vt = ht, Et = It, ht = yt, It = Ct, yt = st + lt + ((Lt = ut + dt) / 4294967296 >>> 0) >>> 0, Ct = Lt >>> 0;
        Lt = it[0][1] + Ct, it[0][0] = it[0][0] + yt + (Lt / 4294967296 >>> 0) >>> 0, it[0][1] = Lt >>> 0, Lt = it[1][1] + It, it[1][0] = it[1][0] + ht + (Lt / 4294967296 >>> 0) >>> 0, it[1][1] = Lt >>> 0, Lt = it[2][1] + Et, it[2][0] = it[2][0] + vt + (Lt / 4294967296 >>> 0) >>> 0, it[2][1] = Lt >>> 0, Lt = it[3][1] + Rt, it[3][0] = it[3][0] + bt + (Lt / 4294967296 >>> 0) >>> 0, it[3][1] = Lt >>> 0, Lt = it[4][1] + kt, it[4][0] = it[4][0] + St + (Lt / 4294967296 >>> 0) >>> 0, it[4][1] = Lt >>> 0, Lt = it[5][1] + Pt, it[5][0] = it[5][0] + jt + (Lt / 4294967296 >>> 0) >>> 0, it[5][1] = Lt >>> 0, Lt = it[6][1] + qt, it[6][0] = it[6][0] + Qt + (Lt / 4294967296 >>> 0) >>> 0, it[6][1] = Lt >>> 0, Lt = it[7][1] + Yt, it[7][0] = it[7][0] + _t + (Lt / 4294967296 >>> 0) >>> 0, it[7][1] = Lt >>> 0, Ft -= 128;
      }
    }
  }, 2676: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    Xe(1482), Xe(7461), Xe(4581), Xe(2936), Xe(3103);
    var $e = He.exports = Ke.ssh = Ke.ssh || {};
    function Je(tt, et) {
      var rt = et.toString(16);
      rt[0] >= "8" && (rt = "00" + rt);
      var it = Ke.util.hexToBytes(rt);
      tt.putInt32(it.length), tt.putBytes(it);
    }
    function Ze(tt, et) {
      tt.putInt32(et.length), tt.putString(et);
    }
    function nt() {
      for (var tt = Ke.md.sha1.create(), et = arguments.length, rt = 0; rt < et; ++rt) tt.update(arguments[rt]);
      return tt.digest();
    }
    $e.privateKeyToPutty = function(tt, et, rt) {
      var it = "ssh-rsa", ot = (et = et || "") === "" ? "none" : "aes256-cbc", at = `PuTTY-User-Key-File-2: ssh-rsa\r
`;
      at += "Encryption: " + ot + `\r
`, at += "Comment: " + (rt = rt || "") + `\r
`;
      var st = Ke.util.createBuffer();
      Ze(st, it), Je(st, tt.e), Je(st, tt.n);
      var ut = Ke.util.encode64(st.bytes(), 64), lt = Math.floor(ut.length / 66) + 1;
      at += "Public-Lines: " + lt + `\r
`, at += ut;
      var dt, At = Ke.util.createBuffer();
      if (Je(At, tt.d), Je(At, tt.p), Je(At, tt.q), Je(At, tt.qInv), et) {
        var pt = At.length() + 16 - 1;
        pt -= pt % 16;
        var gt = nt(At.bytes());
        gt.truncate(gt.length() - pt + At.length()), At.putBuffer(gt);
        var wt = Ke.util.createBuffer();
        wt.putBuffer(nt("\0\0\0\0", et)), wt.putBuffer(nt("\0\0\0", et));
        var Bt = Ke.aes.createEncryptionCipher(wt.truncate(8), "CBC");
        Bt.start(Ke.util.createBuffer().fillWithByte(0, 16)), Bt.update(At.copy()), Bt.finish();
        var Tt = Bt.output;
        Tt.truncate(16), dt = Ke.util.encode64(Tt.bytes(), 64);
      } else dt = Ke.util.encode64(At.bytes(), 64);
      at += `\r
Private-Lines: ` + (lt = Math.floor(dt.length / 66) + 1) + `\r
`, at += dt;
      var yt = nt("putty-private-key-file-mac-key", et), Ct = Ke.util.createBuffer();
      Ze(Ct, it), Ze(Ct, ot), Ze(Ct, rt), Ct.putInt32(st.length()), Ct.putBuffer(st), Ct.putInt32(At.length()), Ct.putBuffer(At);
      var ht = Ke.hmac.create();
      return ht.start("sha1", yt), ht.update(Ct.bytes()), at + `\r
Private-MAC: ` + ht.digest().toHex() + `\r
`;
    }, $e.publicKeyToOpenSSH = function(tt, et) {
      var rt = "ssh-rsa";
      et = et || "";
      var it = Ke.util.createBuffer();
      return Ze(it, rt), Je(it, tt.e), Je(it, tt.n), rt + " " + Ke.util.encode64(it.bytes()) + " " + et;
    }, $e.privateKeyToOpenSSH = function(tt, et) {
      return et ? Ke.pki.encryptRsaPrivateKey(tt, et, { legacy: !0, algorithm: "aes128" }) : Ke.pki.privateKeyToPem(tt);
    }, $e.getPublicKeyFingerprint = function(tt, et) {
      var rt = (et = et || {}).md || Ke.md.md5.create(), it = Ke.util.createBuffer();
      Ze(it, "ssh-rsa"), Je(it, tt.e), Je(it, tt.n), rt.start(), rt.update(it.getBytes());
      var ot = rt.digest();
      if (et.encoding === "hex") {
        var at = ot.toHex();
        return et.delimiter ? at.match(/.{2}/g).join(et.delimiter) : at;
      }
      if (et.encoding === "binary") return ot.getBytes();
      if (et.encoding) throw new Error('Unknown encoding "' + et.encoding + '".');
      return ot;
    };
  }, 8472: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    Xe(2624), Xe(7461), Xe(4581), Xe(5477), Xe(4885), Xe(4097), Xe(2936), Xe(3103);
    var $e = function(ft, Dt, Mt, Ft) {
      var Gt = Ke.util.createBuffer(), zt = ft.length >> 1, $t = zt + (1 & ft.length), Ht = ft.substr(0, $t), hn = ft.substr(zt, $t), un = Ke.util.createBuffer(), An = Ke.hmac.create();
      Mt = Dt + Mt;
      var mn = Math.ceil(Ft / 16), En = Math.ceil(Ft / 20);
      An.start("MD5", Ht);
      var Jt = Ke.util.createBuffer();
      un.putBytes(Mt);
      for (var an = 0; an < mn; ++an) An.start(null, null), An.update(un.getBytes()), un.putBuffer(An.digest()), An.start(null, null), An.update(un.bytes() + Mt), Jt.putBuffer(An.digest());
      An.start("SHA1", hn);
      var cn = Ke.util.createBuffer();
      for (un.clear(), un.putBytes(Mt), an = 0; an < En; ++an) An.start(null, null), An.update(un.getBytes()), un.putBuffer(An.digest()), An.start(null, null), An.update(un.bytes() + Mt), cn.putBuffer(An.digest());
      return Gt.putBytes(Ke.util.xorBytes(Jt.getBytes(), cn.getBytes(), Ft)), Gt;
    }, Je = function(ft, Dt, Mt) {
      var Ft = !1;
      try {
        var Gt = ft.deflate(Dt.fragment.getBytes());
        Dt.fragment = Ke.util.createBuffer(Gt), Dt.length = Gt.length, Ft = !0;
      } catch {
      }
      return Ft;
    }, Ze = function(ft, Dt, Mt) {
      var Ft = !1;
      try {
        var Gt = ft.inflate(Dt.fragment.getBytes());
        Dt.fragment = Ke.util.createBuffer(Gt), Dt.length = Gt.length, Ft = !0;
      } catch {
      }
      return Ft;
    }, nt = function(ft, Dt) {
      var Mt = 0;
      switch (Dt) {
        case 1:
          Mt = ft.getByte();
          break;
        case 2:
          Mt = ft.getInt16();
          break;
        case 3:
          Mt = ft.getInt24();
          break;
        case 4:
          Mt = ft.getInt32();
      }
      return Ke.util.createBuffer(ft.getBytes(Mt));
    }, tt = function(ft, Dt, Mt) {
      ft.putInt(Mt.length(), Dt << 3), ft.putBuffer(Mt);
    }, et = { Versions: { TLS_1_0: { major: 3, minor: 1 }, TLS_1_1: { major: 3, minor: 2 }, TLS_1_2: { major: 3, minor: 3 } } };
    et.SupportedVersions = [et.Versions.TLS_1_1, et.Versions.TLS_1_0], et.Version = et.SupportedVersions[0], et.MaxFragment = 15360, et.ConnectionEnd = { server: 0, client: 1 }, et.PRFAlgorithm = { tls_prf_sha256: 0 }, et.BulkCipherAlgorithm = { none: null, rc4: 0, des3: 1, aes: 2 }, et.CipherType = { stream: 0, block: 1, aead: 2 }, et.MACAlgorithm = { none: null, hmac_md5: 0, hmac_sha1: 1, hmac_sha256: 2, hmac_sha384: 3, hmac_sha512: 4 }, et.CompressionMethod = { none: 0, deflate: 1 }, et.ContentType = { change_cipher_spec: 20, alert: 21, handshake: 22, application_data: 23, heartbeat: 24 }, et.HandshakeType = { hello_request: 0, client_hello: 1, server_hello: 2, certificate: 11, server_key_exchange: 12, certificate_request: 13, server_hello_done: 14, certificate_verify: 15, client_key_exchange: 16, finished: 20 }, et.Alert = {}, et.Alert.Level = { warning: 1, fatal: 2 }, et.Alert.Description = { close_notify: 0, unexpected_message: 10, bad_record_mac: 20, decryption_failed: 21, record_overflow: 22, decompression_failure: 30, handshake_failure: 40, bad_certificate: 42, unsupported_certificate: 43, certificate_revoked: 44, certificate_expired: 45, certificate_unknown: 46, illegal_parameter: 47, unknown_ca: 48, access_denied: 49, decode_error: 50, decrypt_error: 51, export_restriction: 60, protocol_version: 70, insufficient_security: 71, internal_error: 80, user_canceled: 90, no_renegotiation: 100 }, et.HeartbeatMessageType = { heartbeat_request: 1, heartbeat_response: 2 }, et.CipherSuites = {}, et.getCipherSuite = function(ft) {
      var Dt = null;
      for (var Mt in et.CipherSuites) {
        var Ft = et.CipherSuites[Mt];
        if (Ft.id[0] === ft.charCodeAt(0) && Ft.id[1] === ft.charCodeAt(1)) {
          Dt = Ft;
          break;
        }
      }
      return Dt;
    }, et.handleUnexpected = function(ft, Dt) {
      !ft.open && ft.entity === et.ConnectionEnd.client || ft.error(ft, { message: "Unexpected message. Received TLS record out of order.", send: !0, alert: { level: et.Alert.Level.fatal, description: et.Alert.Description.unexpected_message } });
    }, et.handleHelloRequest = function(ft, Dt, Mt) {
      !ft.handshaking && ft.handshakes > 0 && (et.queue(ft, et.createAlert(ft, { level: et.Alert.Level.warning, description: et.Alert.Description.no_renegotiation })), et.flush(ft)), ft.process();
    }, et.parseHelloMessage = function(ft, Dt, Mt) {
      var Ft = null, Gt = ft.entity === et.ConnectionEnd.client;
      if (Mt < 38) ft.error(ft, { message: Gt ? "Invalid ServerHello message. Message too short." : "Invalid ClientHello message. Message too short.", send: !0, alert: { level: et.Alert.Level.fatal, description: et.Alert.Description.illegal_parameter } });
      else {
        var zt = Dt.fragment, $t = zt.length();
        if (Ft = { version: { major: zt.getByte(), minor: zt.getByte() }, random: Ke.util.createBuffer(zt.getBytes(32)), session_id: nt(zt, 1), extensions: [] }, Gt ? (Ft.cipher_suite = zt.getBytes(2), Ft.compression_method = zt.getByte()) : (Ft.cipher_suites = nt(zt, 2), Ft.compression_methods = nt(zt, 1)), ($t = Mt - ($t - zt.length())) > 0) {
          for (var Ht = nt(zt, 2); Ht.length() > 0; ) Ft.extensions.push({ type: [Ht.getByte(), Ht.getByte()], data: nt(Ht, 2) });
          if (!Gt) for (var hn = 0; hn < Ft.extensions.length; ++hn) {
            var un = Ft.extensions[hn];
            if (un.type[0] === 0 && un.type[1] === 0) for (var An = nt(un.data, 2); An.length() > 0 && An.getByte() === 0; ) ft.session.extensions.server_name.serverNameList.push(nt(An, 2).getBytes());
          }
        }
        if (ft.session.version && (Ft.version.major !== ft.session.version.major || Ft.version.minor !== ft.session.version.minor)) return ft.error(ft, { message: "TLS version change is disallowed during renegotiation.", send: !0, alert: { level: et.Alert.Level.fatal, description: et.Alert.Description.protocol_version } });
        if (Gt) ft.session.cipherSuite = et.getCipherSuite(Ft.cipher_suite);
        else for (var mn = Ke.util.createBuffer(Ft.cipher_suites.bytes()); mn.length() > 0 && (ft.session.cipherSuite = et.getCipherSuite(mn.getBytes(2)), ft.session.cipherSuite === null); ) ;
        if (ft.session.cipherSuite === null) return ft.error(ft, { message: "No cipher suites in common.", send: !0, alert: { level: et.Alert.Level.fatal, description: et.Alert.Description.handshake_failure }, cipherSuite: Ke.util.bytesToHex(Ft.cipher_suite) });
        ft.session.compressionMethod = Gt ? Ft.compression_method : et.CompressionMethod.none;
      }
      return Ft;
    }, et.createSecurityParameters = function(ft, Dt) {
      var Mt = ft.entity === et.ConnectionEnd.client, Ft = Dt.random.bytes(), Gt = Mt ? ft.session.sp.client_random : Ft, zt = Mt ? Ft : et.createRandom().getBytes();
      ft.session.sp = { entity: ft.entity, prf_algorithm: et.PRFAlgorithm.tls_prf_sha256, bulk_cipher_algorithm: null, cipher_type: null, enc_key_length: null, block_length: null, fixed_iv_length: null, record_iv_length: null, mac_algorithm: null, mac_length: null, mac_key_length: null, compression_algorithm: ft.session.compressionMethod, pre_master_secret: null, master_secret: null, client_random: Gt, server_random: zt };
    }, et.handleServerHello = function(ft, Dt, Mt) {
      var Ft = et.parseHelloMessage(ft, Dt, Mt);
      if (!ft.fail) {
        if (!(Ft.version.minor <= ft.version.minor)) return ft.error(ft, { message: "Incompatible TLS version.", send: !0, alert: { level: et.Alert.Level.fatal, description: et.Alert.Description.protocol_version } });
        ft.version.minor = Ft.version.minor, ft.session.version = ft.version;
        var Gt = Ft.session_id.bytes();
        Gt.length > 0 && Gt === ft.session.id ? (ft.expect = st, ft.session.resuming = !0, ft.session.sp.server_random = Ft.random.bytes()) : (ft.expect = rt, ft.session.resuming = !1, et.createSecurityParameters(ft, Ft)), ft.session.id = Gt, ft.process();
      }
    }, et.handleClientHello = function(ft, Dt, Mt) {
      var Ft = et.parseHelloMessage(ft, Dt, Mt);
      if (!ft.fail) {
        var Gt = Ft.session_id.bytes(), zt = null;
        if (ft.sessionCache && ((zt = ft.sessionCache.getSession(Gt)) === null ? Gt = "" : (zt.version.major !== Ft.version.major || zt.version.minor > Ft.version.minor) && (zt = null, Gt = "")), Gt.length === 0 && (Gt = Ke.random.getBytes(32)), ft.session.id = Gt, ft.session.clientHelloVersion = Ft.version, ft.session.sp = {}, zt) ft.version = ft.session.version = zt.version, ft.session.sp = zt.sp;
        else {
          for (var $t, Ht = 1; Ht < et.SupportedVersions.length && !(($t = et.SupportedVersions[Ht]).minor <= Ft.version.minor); ++Ht) ;
          ft.version = { major: $t.major, minor: $t.minor }, ft.session.version = ft.version;
        }
        zt !== null ? (ft.expect = wt, ft.session.resuming = !0, ft.session.sp.client_random = Ft.random.bytes()) : (ft.expect = ft.verifyClient !== !1 ? At : pt, ft.session.resuming = !1, et.createSecurityParameters(ft, Ft)), ft.open = !0, et.queue(ft, et.createRecord(ft, { type: et.ContentType.handshake, data: et.createServerHello(ft) })), ft.session.resuming ? (et.queue(ft, et.createRecord(ft, { type: et.ContentType.change_cipher_spec, data: et.createChangeCipherSpec() })), ft.state.pending = et.createConnectionState(ft), ft.state.current.write = ft.state.pending.write, et.queue(ft, et.createRecord(ft, { type: et.ContentType.handshake, data: et.createFinished(ft) }))) : (et.queue(ft, et.createRecord(ft, { type: et.ContentType.handshake, data: et.createCertificate(ft) })), ft.fail || (et.queue(ft, et.createRecord(ft, { type: et.ContentType.handshake, data: et.createServerKeyExchange(ft) })), ft.verifyClient !== !1 && et.queue(ft, et.createRecord(ft, { type: et.ContentType.handshake, data: et.createCertificateRequest(ft) })), et.queue(ft, et.createRecord(ft, { type: et.ContentType.handshake, data: et.createServerHelloDone(ft) })))), et.flush(ft), ft.process();
      }
    }, et.handleCertificate = function(ft, Dt, Mt) {
      if (Mt < 3) return ft.error(ft, { message: "Invalid Certificate message. Message too short.", send: !0, alert: { level: et.Alert.Level.fatal, description: et.Alert.Description.illegal_parameter } });
      var Ft, Gt, zt = Dt.fragment, $t = { certificate_list: nt(zt, 3) }, Ht = [];
      try {
        for (; $t.certificate_list.length() > 0; ) Ft = nt($t.certificate_list, 3), Gt = Ke.asn1.fromDer(Ft), Ft = Ke.pki.certificateFromAsn1(Gt, !0), Ht.push(Ft);
      } catch (un) {
        return ft.error(ft, { message: "Could not parse certificate list.", cause: un, send: !0, alert: { level: et.Alert.Level.fatal, description: et.Alert.Description.bad_certificate } });
      }
      var hn = ft.entity === et.ConnectionEnd.client;
      !hn && ft.verifyClient !== !0 || Ht.length !== 0 ? Ht.length === 0 ? ft.expect = hn ? it : pt : (hn ? ft.session.serverCertificate = Ht[0] : ft.session.clientCertificate = Ht[0], et.verifyCertificateChain(ft, Ht) && (ft.expect = hn ? it : pt)) : ft.error(ft, { message: hn ? "No server certificate provided." : "No client certificate provided.", send: !0, alert: { level: et.Alert.Level.fatal, description: et.Alert.Description.illegal_parameter } }), ft.process();
    }, et.handleServerKeyExchange = function(ft, Dt, Mt) {
      if (Mt > 0) return ft.error(ft, { message: "Invalid key parameters. Only RSA is supported.", send: !0, alert: { level: et.Alert.Level.fatal, description: et.Alert.Description.unsupported_certificate } });
      ft.expect = ot, ft.process();
    }, et.handleClientKeyExchange = function(ft, Dt, Mt) {
      if (Mt < 48) return ft.error(ft, { message: "Invalid key parameters. Only RSA is supported.", send: !0, alert: { level: et.Alert.Level.fatal, description: et.Alert.Description.unsupported_certificate } });
      var Ft = Dt.fragment, Gt = { enc_pre_master_secret: nt(Ft, 2).getBytes() }, zt = null;
      if (ft.getPrivateKey) try {
        zt = ft.getPrivateKey(ft, ft.session.serverCertificate), zt = Ke.pki.privateKeyFromPem(zt);
      } catch (hn) {
        ft.error(ft, { message: "Could not get private key.", cause: hn, send: !0, alert: { level: et.Alert.Level.fatal, description: et.Alert.Description.internal_error } });
      }
      if (zt === null) return ft.error(ft, { message: "No private key set.", send: !0, alert: { level: et.Alert.Level.fatal, description: et.Alert.Description.internal_error } });
      try {
        var $t = ft.session.sp;
        $t.pre_master_secret = zt.decrypt(Gt.enc_pre_master_secret);
        var Ht = ft.session.clientHelloVersion;
        if (Ht.major !== $t.pre_master_secret.charCodeAt(0) || Ht.minor !== $t.pre_master_secret.charCodeAt(1)) throw new Error("TLS version rollback attack detected.");
      } catch {
        $t.pre_master_secret = Ke.random.getBytes(48);
      }
      ft.expect = wt, ft.session.clientCertificate !== null && (ft.expect = gt), ft.process();
    }, et.handleCertificateRequest = function(ft, Dt, Mt) {
      if (Mt < 3) return ft.error(ft, { message: "Invalid CertificateRequest. Message too short.", send: !0, alert: { level: et.Alert.Level.fatal, description: et.Alert.Description.illegal_parameter } });
      var Ft = Dt.fragment, Gt = { certificate_types: nt(Ft, 1), certificate_authorities: nt(Ft, 2) };
      ft.session.certificateRequest = Gt, ft.expect = at, ft.process();
    }, et.handleCertificateVerify = function(ft, Dt, Mt) {
      if (Mt < 2) return ft.error(ft, { message: "Invalid CertificateVerify. Message too short.", send: !0, alert: { level: et.Alert.Level.fatal, description: et.Alert.Description.illegal_parameter } });
      var Ft = Dt.fragment;
      Ft.read -= 4;
      var Gt = Ft.bytes();
      Ft.read += 4;
      var zt = { signature: nt(Ft, 2).getBytes() }, $t = Ke.util.createBuffer();
      $t.putBuffer(ft.session.md5.digest()), $t.putBuffer(ft.session.sha1.digest()), $t = $t.getBytes();
      try {
        if (!ft.session.clientCertificate.publicKey.verify($t, zt.signature, "NONE")) throw new Error("CertificateVerify signature does not match.");
        ft.session.md5.update(Gt), ft.session.sha1.update(Gt);
      } catch {
        return ft.error(ft, { message: "Bad signature in CertificateVerify.", send: !0, alert: { level: et.Alert.Level.fatal, description: et.Alert.Description.handshake_failure } });
      }
      ft.expect = wt, ft.process();
    }, et.handleServerHelloDone = function(ft, Dt, Mt) {
      if (Mt > 0) return ft.error(ft, { message: "Invalid ServerHelloDone message. Invalid length.", send: !0, alert: { level: et.Alert.Level.fatal, description: et.Alert.Description.record_overflow } });
      if (ft.serverCertificate === null) {
        var Ft = { message: "No server certificate provided. Not enough security.", send: !0, alert: { level: et.Alert.Level.fatal, description: et.Alert.Description.insufficient_security } }, Gt = ft.verify(ft, Ft.alert.description, 0, []);
        if (Gt !== !0) return (Gt || Gt === 0) && (typeof Gt != "object" || Ke.util.isArray(Gt) ? typeof Gt == "number" && (Ft.alert.description = Gt) : (Gt.message && (Ft.message = Gt.message), Gt.alert && (Ft.alert.description = Gt.alert))), ft.error(ft, Ft);
      }
      ft.session.certificateRequest !== null && (Dt = et.createRecord(ft, { type: et.ContentType.handshake, data: et.createCertificate(ft) }), et.queue(ft, Dt)), Dt = et.createRecord(ft, { type: et.ContentType.handshake, data: et.createClientKeyExchange(ft) }), et.queue(ft, Dt), ft.expect = dt;
      var zt = function($t, Ht) {
        $t.session.certificateRequest !== null && $t.session.clientCertificate !== null && et.queue($t, et.createRecord($t, { type: et.ContentType.handshake, data: et.createCertificateVerify($t, Ht) })), et.queue($t, et.createRecord($t, { type: et.ContentType.change_cipher_spec, data: et.createChangeCipherSpec() })), $t.state.pending = et.createConnectionState($t), $t.state.current.write = $t.state.pending.write, et.queue($t, et.createRecord($t, { type: et.ContentType.handshake, data: et.createFinished($t) })), $t.expect = st, et.flush($t), $t.process();
      };
      if (ft.session.certificateRequest === null || ft.session.clientCertificate === null) return zt(ft, null);
      et.getClientSignature(ft, zt);
    }, et.handleChangeCipherSpec = function(ft, Dt) {
      if (Dt.fragment.getByte() !== 1) return ft.error(ft, { message: "Invalid ChangeCipherSpec message received.", send: !0, alert: { level: et.Alert.Level.fatal, description: et.Alert.Description.illegal_parameter } });
      var Mt = ft.entity === et.ConnectionEnd.client;
      (ft.session.resuming && Mt || !ft.session.resuming && !Mt) && (ft.state.pending = et.createConnectionState(ft)), ft.state.current.read = ft.state.pending.read, (!ft.session.resuming && Mt || ft.session.resuming && !Mt) && (ft.state.pending = null), ft.expect = Mt ? ut : Bt, ft.process();
    }, et.handleFinished = function(ft, Dt, Mt) {
      var Ft = Dt.fragment;
      Ft.read -= 4;
      var Gt = Ft.bytes();
      Ft.read += 4;
      var zt = Dt.fragment.getBytes();
      (Ft = Ke.util.createBuffer()).putBuffer(ft.session.md5.digest()), Ft.putBuffer(ft.session.sha1.digest());
      var $t = ft.entity === et.ConnectionEnd.client, Ht = $t ? "server finished" : "client finished", hn = ft.session.sp;
      if ((Ft = $e(hn.master_secret, Ht, Ft.getBytes(), 12)).getBytes() !== zt) return ft.error(ft, { message: "Invalid verify_data in Finished message.", send: !0, alert: { level: et.Alert.Level.fatal, description: et.Alert.Description.decrypt_error } });
      ft.session.md5.update(Gt), ft.session.sha1.update(Gt), (ft.session.resuming && $t || !ft.session.resuming && !$t) && (et.queue(ft, et.createRecord(ft, { type: et.ContentType.change_cipher_spec, data: et.createChangeCipherSpec() })), ft.state.current.write = ft.state.pending.write, ft.state.pending = null, et.queue(ft, et.createRecord(ft, { type: et.ContentType.handshake, data: et.createFinished(ft) }))), ft.expect = $t ? lt : Tt, ft.handshaking = !1, ++ft.handshakes, ft.peerCertificate = $t ? ft.session.serverCertificate : ft.session.clientCertificate, et.flush(ft), ft.isConnected = !0, ft.connected(ft), ft.process();
    }, et.handleAlert = function(ft, Dt) {
      var Mt, Ft = Dt.fragment, Gt = { level: Ft.getByte(), description: Ft.getByte() };
      switch (Gt.description) {
        case et.Alert.Description.close_notify:
          Mt = "Connection closed.";
          break;
        case et.Alert.Description.unexpected_message:
          Mt = "Unexpected message.";
          break;
        case et.Alert.Description.bad_record_mac:
          Mt = "Bad record MAC.";
          break;
        case et.Alert.Description.decryption_failed:
          Mt = "Decryption failed.";
          break;
        case et.Alert.Description.record_overflow:
          Mt = "Record overflow.";
          break;
        case et.Alert.Description.decompression_failure:
          Mt = "Decompression failed.";
          break;
        case et.Alert.Description.handshake_failure:
          Mt = "Handshake failure.";
          break;
        case et.Alert.Description.bad_certificate:
          Mt = "Bad certificate.";
          break;
        case et.Alert.Description.unsupported_certificate:
          Mt = "Unsupported certificate.";
          break;
        case et.Alert.Description.certificate_revoked:
          Mt = "Certificate revoked.";
          break;
        case et.Alert.Description.certificate_expired:
          Mt = "Certificate expired.";
          break;
        case et.Alert.Description.certificate_unknown:
          Mt = "Certificate unknown.";
          break;
        case et.Alert.Description.illegal_parameter:
          Mt = "Illegal parameter.";
          break;
        case et.Alert.Description.unknown_ca:
          Mt = "Unknown certificate authority.";
          break;
        case et.Alert.Description.access_denied:
          Mt = "Access denied.";
          break;
        case et.Alert.Description.decode_error:
          Mt = "Decode error.";
          break;
        case et.Alert.Description.decrypt_error:
          Mt = "Decrypt error.";
          break;
        case et.Alert.Description.export_restriction:
          Mt = "Export restriction.";
          break;
        case et.Alert.Description.protocol_version:
          Mt = "Unsupported protocol version.";
          break;
        case et.Alert.Description.insufficient_security:
          Mt = "Insufficient security.";
          break;
        case et.Alert.Description.internal_error:
          Mt = "Internal error.";
          break;
        case et.Alert.Description.user_canceled:
          Mt = "User canceled.";
          break;
        case et.Alert.Description.no_renegotiation:
          Mt = "Renegotiation not supported.";
          break;
        default:
          Mt = "Unknown error.";
      }
      if (Gt.description === et.Alert.Description.close_notify) return ft.close();
      ft.error(ft, { message: Mt, send: !1, origin: ft.entity === et.ConnectionEnd.client ? "server" : "client", alert: Gt }), ft.process();
    }, et.handleHandshake = function(ft, Dt) {
      var Mt = Dt.fragment, Ft = Mt.getByte(), Gt = Mt.getInt24();
      if (Gt > Mt.length()) return ft.fragmented = Dt, Dt.fragment = Ke.util.createBuffer(), Mt.read -= 4, ft.process();
      ft.fragmented = null, Mt.read -= 4;
      var zt = Mt.bytes(Gt + 4);
      Mt.read += 4, Ft in _t[ft.entity][ft.expect] ? (ft.entity !== et.ConnectionEnd.server || ft.open || ft.fail || (ft.handshaking = !0, ft.session = { version: null, extensions: { server_name: { serverNameList: [] } }, cipherSuite: null, compressionMethod: null, serverCertificate: null, clientCertificate: null, md5: Ke.md.md5.create(), sha1: Ke.md.sha1.create() }), Ft !== et.HandshakeType.hello_request && Ft !== et.HandshakeType.certificate_verify && Ft !== et.HandshakeType.finished && (ft.session.md5.update(zt), ft.session.sha1.update(zt)), _t[ft.entity][ft.expect][Ft](ft, Dt, Gt)) : et.handleUnexpected(ft, Dt);
    }, et.handleApplicationData = function(ft, Dt) {
      ft.data.putBuffer(Dt.fragment), ft.dataReady(ft), ft.process();
    }, et.handleHeartbeat = function(ft, Dt) {
      var Mt = Dt.fragment, Ft = Mt.getByte(), Gt = Mt.getInt16(), zt = Mt.getBytes(Gt);
      if (Ft === et.HeartbeatMessageType.heartbeat_request) {
        if (ft.handshaking || Gt > zt.length) return ft.process();
        et.queue(ft, et.createRecord(ft, { type: et.ContentType.heartbeat, data: et.createHeartbeat(et.HeartbeatMessageType.heartbeat_response, zt) })), et.flush(ft);
      } else if (Ft === et.HeartbeatMessageType.heartbeat_response) {
        if (zt !== ft.expectedHeartbeatPayload) return ft.process();
        ft.heartbeatReceived && ft.heartbeatReceived(ft, Ke.util.createBuffer(zt));
      }
      ft.process();
    };
    var rt = 1, it = 2, ot = 3, at = 4, st = 5, ut = 6, lt = 7, dt = 8, At = 1, pt = 2, gt = 3, wt = 4, Bt = 5, Tt = 6, yt = et.handleUnexpected, Ct = et.handleChangeCipherSpec, ht = et.handleAlert, It = et.handleHandshake, vt = et.handleApplicationData, Et = et.handleHeartbeat, bt = [];
    bt[et.ConnectionEnd.client] = [[yt, ht, It, yt, Et], [yt, ht, It, yt, Et], [yt, ht, It, yt, Et], [yt, ht, It, yt, Et], [yt, ht, It, yt, Et], [Ct, ht, yt, yt, Et], [yt, ht, It, yt, Et], [yt, ht, It, vt, Et], [yt, ht, It, yt, Et]], bt[et.ConnectionEnd.server] = [[yt, ht, It, yt, Et], [yt, ht, It, yt, Et], [yt, ht, It, yt, Et], [yt, ht, It, yt, Et], [Ct, ht, yt, yt, Et], [yt, ht, It, yt, Et], [yt, ht, It, vt, Et], [yt, ht, It, yt, Et]];
    var Rt = et.handleHelloRequest, St = et.handleServerHello, kt = et.handleCertificate, jt = et.handleServerKeyExchange, Pt = et.handleCertificateRequest, Qt = et.handleServerHelloDone, qt = et.handleFinished, _t = [];
    _t[et.ConnectionEnd.client] = [[yt, yt, St, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt], [Rt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, kt, jt, Pt, Qt, yt, yt, yt, yt, yt, yt], [Rt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, jt, Pt, Qt, yt, yt, yt, yt, yt, yt], [Rt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, Pt, Qt, yt, yt, yt, yt, yt, yt], [Rt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, Qt, yt, yt, yt, yt, yt, yt], [Rt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt], [Rt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, qt], [Rt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt], [Rt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt]];
    var Yt = et.handleClientHello, Xt = et.handleClientKeyExchange, Ut = et.handleCertificateVerify;
    _t[et.ConnectionEnd.server] = [[yt, Yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt], [yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, kt, yt, yt, yt, yt, yt, yt, yt, yt, yt], [yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, Xt, yt, yt, yt, yt], [yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, Ut, yt, yt, yt, yt, yt], [yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt], [yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, qt], [yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt], [yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt, yt]], et.generateKeys = function(ft, Dt) {
      var Mt = $e, Ft = Dt.client_random + Dt.server_random;
      ft.session.resuming || (Dt.master_secret = Mt(Dt.pre_master_secret, "master secret", Ft, 48).bytes(), Dt.pre_master_secret = null), Ft = Dt.server_random + Dt.client_random;
      var Gt = 2 * Dt.mac_key_length + 2 * Dt.enc_key_length, zt = ft.version.major === et.Versions.TLS_1_0.major && ft.version.minor === et.Versions.TLS_1_0.minor;
      zt && (Gt += 2 * Dt.fixed_iv_length);
      var $t = Mt(Dt.master_secret, "key expansion", Ft, Gt), Ht = { client_write_MAC_key: $t.getBytes(Dt.mac_key_length), server_write_MAC_key: $t.getBytes(Dt.mac_key_length), client_write_key: $t.getBytes(Dt.enc_key_length), server_write_key: $t.getBytes(Dt.enc_key_length) };
      return zt && (Ht.client_write_IV = $t.getBytes(Dt.fixed_iv_length), Ht.server_write_IV = $t.getBytes(Dt.fixed_iv_length)), Ht;
    }, et.createConnectionState = function(ft) {
      var Dt = ft.entity === et.ConnectionEnd.client, Mt = function() {
        var zt = { sequenceNumber: [0, 0], macKey: null, macLength: 0, macFunction: null, cipherState: null, cipherFunction: function($t) {
          return !0;
        }, compressionState: null, compressFunction: function($t) {
          return !0;
        }, updateSequenceNumber: function() {
          zt.sequenceNumber[1] === 4294967295 ? (zt.sequenceNumber[1] = 0, ++zt.sequenceNumber[0]) : ++zt.sequenceNumber[1];
        } };
        return zt;
      }, Ft = { read: Mt(), write: Mt() };
      if (Ft.read.update = function(zt, $t) {
        return Ft.read.cipherFunction($t, Ft.read) ? Ft.read.compressFunction(zt, $t, Ft.read) || zt.error(zt, { message: "Could not decompress record.", send: !0, alert: { level: et.Alert.Level.fatal, description: et.Alert.Description.decompression_failure } }) : zt.error(zt, { message: "Could not decrypt record or bad MAC.", send: !0, alert: { level: et.Alert.Level.fatal, description: et.Alert.Description.bad_record_mac } }), !zt.fail;
      }, Ft.write.update = function(zt, $t) {
        return Ft.write.compressFunction(zt, $t, Ft.write) ? Ft.write.cipherFunction($t, Ft.write) || zt.error(zt, { message: "Could not encrypt record.", send: !1, alert: { level: et.Alert.Level.fatal, description: et.Alert.Description.internal_error } }) : zt.error(zt, { message: "Could not compress record.", send: !1, alert: { level: et.Alert.Level.fatal, description: et.Alert.Description.internal_error } }), !zt.fail;
      }, ft.session) {
        var Gt = ft.session.sp;
        switch (ft.session.cipherSuite.initSecurityParameters(Gt), Gt.keys = et.generateKeys(ft, Gt), Ft.read.macKey = Dt ? Gt.keys.server_write_MAC_key : Gt.keys.client_write_MAC_key, Ft.write.macKey = Dt ? Gt.keys.client_write_MAC_key : Gt.keys.server_write_MAC_key, ft.session.cipherSuite.initConnectionState(Ft, ft, Gt), Gt.compression_algorithm) {
          case et.CompressionMethod.none:
            break;
          case et.CompressionMethod.deflate:
            Ft.read.compressFunction = Ze, Ft.write.compressFunction = Je;
            break;
          default:
            throw new Error("Unsupported compression algorithm.");
        }
      }
      return Ft;
    }, et.createRandom = function() {
      var ft = /* @__PURE__ */ new Date(), Dt = +ft + 6e4 * ft.getTimezoneOffset(), Mt = Ke.util.createBuffer();
      return Mt.putInt32(Dt), Mt.putBytes(Ke.random.getBytes(28)), Mt;
    }, et.createRecord = function(ft, Dt) {
      return Dt.data ? { type: Dt.type, version: { major: ft.version.major, minor: ft.version.minor }, length: Dt.data.length(), fragment: Dt.data } : null;
    }, et.createAlert = function(ft, Dt) {
      var Mt = Ke.util.createBuffer();
      return Mt.putByte(Dt.level), Mt.putByte(Dt.description), et.createRecord(ft, { type: et.ContentType.alert, data: Mt });
    }, et.createClientHello = function(ft) {
      ft.session.clientHelloVersion = { major: ft.version.major, minor: ft.version.minor };
      for (var Dt = Ke.util.createBuffer(), Mt = 0; Mt < ft.cipherSuites.length; ++Mt) {
        var Ft = ft.cipherSuites[Mt];
        Dt.putByte(Ft.id[0]), Dt.putByte(Ft.id[1]);
      }
      var Gt = Dt.length(), zt = Ke.util.createBuffer();
      zt.putByte(et.CompressionMethod.none);
      var $t = zt.length(), Ht = Ke.util.createBuffer();
      if (ft.virtualHost) {
        var hn = Ke.util.createBuffer();
        hn.putByte(0), hn.putByte(0);
        var un = Ke.util.createBuffer();
        un.putByte(0), tt(un, 2, Ke.util.createBuffer(ft.virtualHost));
        var An = Ke.util.createBuffer();
        tt(An, 2, un), tt(hn, 2, An), Ht.putBuffer(hn);
      }
      var mn = Ht.length();
      mn > 0 && (mn += 2);
      var En = ft.session.id, Jt = En.length + 1 + 2 + 4 + 28 + 2 + Gt + 1 + $t + mn, an = Ke.util.createBuffer();
      return an.putByte(et.HandshakeType.client_hello), an.putInt24(Jt), an.putByte(ft.version.major), an.putByte(ft.version.minor), an.putBytes(ft.session.sp.client_random), tt(an, 1, Ke.util.createBuffer(En)), tt(an, 2, Dt), tt(an, 1, zt), mn > 0 && tt(an, 2, Ht), an;
    }, et.createServerHello = function(ft) {
      var Dt = ft.session.id, Mt = Dt.length + 1 + 2 + 4 + 28 + 2 + 1, Ft = Ke.util.createBuffer();
      return Ft.putByte(et.HandshakeType.server_hello), Ft.putInt24(Mt), Ft.putByte(ft.version.major), Ft.putByte(ft.version.minor), Ft.putBytes(ft.session.sp.server_random), tt(Ft, 1, Ke.util.createBuffer(Dt)), Ft.putByte(ft.session.cipherSuite.id[0]), Ft.putByte(ft.session.cipherSuite.id[1]), Ft.putByte(ft.session.compressionMethod), Ft;
    }, et.createCertificate = function(ft) {
      var Dt, Mt = ft.entity === et.ConnectionEnd.client, Ft = null;
      ft.getCertificate && (Dt = Mt ? ft.session.certificateRequest : ft.session.extensions.server_name.serverNameList, Ft = ft.getCertificate(ft, Dt));
      var Gt = Ke.util.createBuffer();
      if (Ft !== null) try {
        Ke.util.isArray(Ft) || (Ft = [Ft]);
        for (var zt = null, $t = 0; $t < Ft.length; ++$t) {
          var Ht = Ke.pem.decode(Ft[$t])[0];
          if (Ht.type !== "CERTIFICATE" && Ht.type !== "X509 CERTIFICATE" && Ht.type !== "TRUSTED CERTIFICATE") {
            var hn = new Error('Could not convert certificate from PEM; PEM header type is not "CERTIFICATE", "X509 CERTIFICATE", or "TRUSTED CERTIFICATE".');
            throw hn.headerType = Ht.type, hn;
          }
          if (Ht.procType && Ht.procType.type === "ENCRYPTED") throw new Error("Could not convert certificate from PEM; PEM is encrypted.");
          var un = Ke.util.createBuffer(Ht.body);
          zt === null && (zt = Ke.asn1.fromDer(un.bytes(), !1));
          var An = Ke.util.createBuffer();
          tt(An, 3, un), Gt.putBuffer(An);
        }
        Ft = Ke.pki.certificateFromAsn1(zt), Mt ? ft.session.clientCertificate = Ft : ft.session.serverCertificate = Ft;
      } catch (Jt) {
        return ft.error(ft, { message: "Could not send certificate list.", cause: Jt, send: !0, alert: { level: et.Alert.Level.fatal, description: et.Alert.Description.bad_certificate } });
      }
      var mn = 3 + Gt.length(), En = Ke.util.createBuffer();
      return En.putByte(et.HandshakeType.certificate), En.putInt24(mn), tt(En, 3, Gt), En;
    }, et.createClientKeyExchange = function(ft) {
      var Dt = Ke.util.createBuffer();
      Dt.putByte(ft.session.clientHelloVersion.major), Dt.putByte(ft.session.clientHelloVersion.minor), Dt.putBytes(Ke.random.getBytes(46));
      var Mt = ft.session.sp;
      Mt.pre_master_secret = Dt.getBytes();
      var Ft = (Dt = ft.session.serverCertificate.publicKey.encrypt(Mt.pre_master_secret)).length + 2, Gt = Ke.util.createBuffer();
      return Gt.putByte(et.HandshakeType.client_key_exchange), Gt.putInt24(Ft), Gt.putInt16(Dt.length), Gt.putBytes(Dt), Gt;
    }, et.createServerKeyExchange = function(ft) {
      return Ke.util.createBuffer();
    }, et.getClientSignature = function(ft, Dt) {
      var Mt = Ke.util.createBuffer();
      Mt.putBuffer(ft.session.md5.digest()), Mt.putBuffer(ft.session.sha1.digest()), Mt = Mt.getBytes(), ft.getSignature = ft.getSignature || function(Ft, Gt, zt) {
        var $t = null;
        if (Ft.getPrivateKey) try {
          $t = Ft.getPrivateKey(Ft, Ft.session.clientCertificate), $t = Ke.pki.privateKeyFromPem($t);
        } catch (Ht) {
          Ft.error(Ft, { message: "Could not get private key.", cause: Ht, send: !0, alert: { level: et.Alert.Level.fatal, description: et.Alert.Description.internal_error } });
        }
        $t === null ? Ft.error(Ft, { message: "No private key set.", send: !0, alert: { level: et.Alert.Level.fatal, description: et.Alert.Description.internal_error } }) : Gt = $t.sign(Gt, null), zt(Ft, Gt);
      }, ft.getSignature(ft, Mt, Dt);
    }, et.createCertificateVerify = function(ft, Dt) {
      var Mt = Dt.length + 2, Ft = Ke.util.createBuffer();
      return Ft.putByte(et.HandshakeType.certificate_verify), Ft.putInt24(Mt), Ft.putInt16(Dt.length), Ft.putBytes(Dt), Ft;
    }, et.createCertificateRequest = function(ft) {
      var Dt = Ke.util.createBuffer();
      Dt.putByte(1);
      var Mt = Ke.util.createBuffer();
      for (var Ft in ft.caStore.certs) {
        var Gt = ft.caStore.certs[Ft], zt = Ke.pki.distinguishedNameToAsn1(Gt.subject), $t = Ke.asn1.toDer(zt);
        Mt.putInt16($t.length()), Mt.putBuffer($t);
      }
      var Ht = 1 + Dt.length() + 2 + Mt.length(), hn = Ke.util.createBuffer();
      return hn.putByte(et.HandshakeType.certificate_request), hn.putInt24(Ht), tt(hn, 1, Dt), tt(hn, 2, Mt), hn;
    }, et.createServerHelloDone = function(ft) {
      var Dt = Ke.util.createBuffer();
      return Dt.putByte(et.HandshakeType.server_hello_done), Dt.putInt24(0), Dt;
    }, et.createChangeCipherSpec = function() {
      var ft = Ke.util.createBuffer();
      return ft.putByte(1), ft;
    }, et.createFinished = function(ft) {
      var Dt = Ke.util.createBuffer();
      Dt.putBuffer(ft.session.md5.digest()), Dt.putBuffer(ft.session.sha1.digest());
      var Mt = ft.entity === et.ConnectionEnd.client, Ft = ft.session.sp, Gt = Mt ? "client finished" : "server finished";
      Dt = $e(Ft.master_secret, Gt, Dt.getBytes(), 12);
      var zt = Ke.util.createBuffer();
      return zt.putByte(et.HandshakeType.finished), zt.putInt24(Dt.length()), zt.putBuffer(Dt), zt;
    }, et.createHeartbeat = function(ft, Dt, Mt) {
      Mt === void 0 && (Mt = Dt.length);
      var Ft = Ke.util.createBuffer();
      Ft.putByte(ft), Ft.putInt16(Mt), Ft.putBytes(Dt);
      var Gt = Ft.length(), zt = Math.max(16, Gt - Mt - 3);
      return Ft.putBytes(Ke.random.getBytes(zt)), Ft;
    }, et.queue = function(ft, Dt) {
      if (Dt && (Dt.fragment.length() !== 0 || Dt.type !== et.ContentType.handshake && Dt.type !== et.ContentType.alert && Dt.type !== et.ContentType.change_cipher_spec)) {
        if (Dt.type === et.ContentType.handshake) {
          var Mt = Dt.fragment.bytes();
          ft.session.md5.update(Mt), ft.session.sha1.update(Mt), Mt = null;
        }
        var Ft;
        if (Dt.fragment.length() <= et.MaxFragment) Ft = [Dt];
        else {
          Ft = [];
          for (var Gt = Dt.fragment.bytes(); Gt.length > et.MaxFragment; ) Ft.push(et.createRecord(ft, { type: Dt.type, data: Ke.util.createBuffer(Gt.slice(0, et.MaxFragment)) })), Gt = Gt.slice(et.MaxFragment);
          Gt.length > 0 && Ft.push(et.createRecord(ft, { type: Dt.type, data: Ke.util.createBuffer(Gt) }));
        }
        for (var zt = 0; zt < Ft.length && !ft.fail; ++zt) {
          var $t = Ft[zt];
          ft.state.current.write.update(ft, $t) && ft.records.push($t);
        }
      }
    }, et.flush = function(ft) {
      for (var Dt = 0; Dt < ft.records.length; ++Dt) {
        var Mt = ft.records[Dt];
        ft.tlsData.putByte(Mt.type), ft.tlsData.putByte(Mt.version.major), ft.tlsData.putByte(Mt.version.minor), ft.tlsData.putInt16(Mt.fragment.length()), ft.tlsData.putBuffer(ft.records[Dt].fragment);
      }
      return ft.records = [], ft.tlsDataReady(ft);
    };
    var Lt = function(ft) {
      switch (ft) {
        case !0:
          return !0;
        case Ke.pki.certificateError.bad_certificate:
          return et.Alert.Description.bad_certificate;
        case Ke.pki.certificateError.unsupported_certificate:
          return et.Alert.Description.unsupported_certificate;
        case Ke.pki.certificateError.certificate_revoked:
          return et.Alert.Description.certificate_revoked;
        case Ke.pki.certificateError.certificate_expired:
          return et.Alert.Description.certificate_expired;
        case Ke.pki.certificateError.certificate_unknown:
          return et.Alert.Description.certificate_unknown;
        case Ke.pki.certificateError.unknown_ca:
          return et.Alert.Description.unknown_ca;
        default:
          return et.Alert.Description.bad_certificate;
      }
    };
    for (var Ot in et.verifyCertificateChain = function(ft, Dt) {
      try {
        var Mt = {};
        for (var Ft in ft.verifyOptions) Mt[Ft] = ft.verifyOptions[Ft];
        Mt.verify = function(zt, $t, Ht) {
          Lt(zt);
          var hn = ft.verify(ft, zt, $t, Ht);
          if (hn !== !0) {
            if (typeof hn == "object" && !Ke.util.isArray(hn)) {
              var un = new Error("The application rejected the certificate.");
              throw un.send = !0, un.alert = { level: et.Alert.Level.fatal, description: et.Alert.Description.bad_certificate }, hn.message && (un.message = hn.message), hn.alert && (un.alert.description = hn.alert), un;
            }
            hn !== zt && (hn = function(An) {
              switch (An) {
                case !0:
                  return !0;
                case et.Alert.Description.bad_certificate:
                  return Ke.pki.certificateError.bad_certificate;
                case et.Alert.Description.unsupported_certificate:
                  return Ke.pki.certificateError.unsupported_certificate;
                case et.Alert.Description.certificate_revoked:
                  return Ke.pki.certificateError.certificate_revoked;
                case et.Alert.Description.certificate_expired:
                  return Ke.pki.certificateError.certificate_expired;
                case et.Alert.Description.certificate_unknown:
                  return Ke.pki.certificateError.certificate_unknown;
                case et.Alert.Description.unknown_ca:
                  return Ke.pki.certificateError.unknown_ca;
                default:
                  return Ke.pki.certificateError.bad_certificate;
              }
            }(hn));
          }
          return hn;
        }, Ke.pki.verifyCertificateChain(ft.caStore, Dt, Mt);
      } catch (zt) {
        var Gt = zt;
        (typeof Gt != "object" || Ke.util.isArray(Gt)) && (Gt = { send: !0, alert: { level: et.Alert.Level.fatal, description: Lt(zt) } }), "send" in Gt || (Gt.send = !0), "alert" in Gt || (Gt.alert = { level: et.Alert.Level.fatal, description: Lt(Gt.error) }), ft.error(ft, Gt);
      }
      return !ft.fail;
    }, et.createSessionCache = function(ft, Dt) {
      var Mt = null;
      if (ft && ft.getSession && ft.setSession && ft.order) Mt = ft;
      else {
        for (var Ft in (Mt = {}).cache = ft || {}, Mt.capacity = Math.max(Dt || 100, 1), Mt.order = [], ft) Mt.order.length <= Dt ? Mt.order.push(Ft) : delete ft[Ft];
        Mt.getSession = function(Gt) {
          var zt = null, $t = null;
          if (Gt ? $t = Ke.util.bytesToHex(Gt) : Mt.order.length > 0 && ($t = Mt.order[0]), $t !== null && $t in Mt.cache) {
            for (var Ht in zt = Mt.cache[$t], delete Mt.cache[$t], Mt.order) if (Mt.order[Ht] === $t) {
              Mt.order.splice(Ht, 1);
              break;
            }
          }
          return zt;
        }, Mt.setSession = function(Gt, zt) {
          if (Mt.order.length === Mt.capacity) {
            var $t = Mt.order.shift();
            delete Mt.cache[$t];
          }
          $t = Ke.util.bytesToHex(Gt), Mt.order.push($t), Mt.cache[$t] = zt;
        };
      }
      return Mt;
    }, et.createConnection = function(ft) {
      var Dt;
      Dt = ft.caStore ? Ke.util.isArray(ft.caStore) ? Ke.pki.createCaStore(ft.caStore) : ft.caStore : Ke.pki.createCaStore();
      var Mt = ft.cipherSuites || null;
      if (Mt === null) for (var Ft in Mt = [], et.CipherSuites) Mt.push(et.CipherSuites[Ft]);
      var Gt = ft.server ? et.ConnectionEnd.server : et.ConnectionEnd.client, zt = ft.sessionCache ? et.createSessionCache(ft.sessionCache) : null, $t = { version: { major: et.Version.major, minor: et.Version.minor }, entity: Gt, sessionId: ft.sessionId, caStore: Dt, sessionCache: zt, cipherSuites: Mt, connected: ft.connected, virtualHost: ft.virtualHost || null, verifyClient: ft.verifyClient || !1, verify: ft.verify || function(Ht, hn, un, An) {
        return hn;
      }, verifyOptions: ft.verifyOptions || {}, getCertificate: ft.getCertificate || null, getPrivateKey: ft.getPrivateKey || null, getSignature: ft.getSignature || null, input: Ke.util.createBuffer(), tlsData: Ke.util.createBuffer(), data: Ke.util.createBuffer(), tlsDataReady: ft.tlsDataReady, dataReady: ft.dataReady, heartbeatReceived: ft.heartbeatReceived, closed: ft.closed, error: function(Ht, hn) {
        hn.origin = hn.origin || (Ht.entity === et.ConnectionEnd.client ? "client" : "server"), hn.send && (et.queue(Ht, et.createAlert(Ht, hn.alert)), et.flush(Ht));
        var un = hn.fatal !== !1;
        un && (Ht.fail = !0), ft.error(Ht, hn), un && Ht.close(!1);
      }, deflate: ft.deflate || null, inflate: ft.inflate || null, reset: function(Ht) {
        $t.version = { major: et.Version.major, minor: et.Version.minor }, $t.record = null, $t.session = null, $t.peerCertificate = null, $t.state = { pending: null, current: null }, $t.expect = ($t.entity, et.ConnectionEnd.client, 0), $t.fragmented = null, $t.records = [], $t.open = !1, $t.handshakes = 0, $t.handshaking = !1, $t.isConnected = !1, $t.fail = !(Ht || Ht === void 0), $t.input.clear(), $t.tlsData.clear(), $t.data.clear(), $t.state.current = et.createConnectionState($t);
      } };
      return $t.reset(), $t.handshake = function(Ht) {
        if ($t.entity !== et.ConnectionEnd.client) $t.error($t, { message: "Cannot initiate handshake as a server.", fatal: !1 });
        else if ($t.handshaking) $t.error($t, { message: "Handshake already in progress.", fatal: !1 });
        else {
          $t.fail && !$t.open && $t.handshakes === 0 && ($t.fail = !1), $t.handshaking = !0;
          var hn = null;
          (Ht = Ht || "").length > 0 && ($t.sessionCache && (hn = $t.sessionCache.getSession(Ht)), hn === null && (Ht = "")), Ht.length === 0 && $t.sessionCache && (hn = $t.sessionCache.getSession()) !== null && (Ht = hn.id), $t.session = { id: Ht, version: null, cipherSuite: null, compressionMethod: null, serverCertificate: null, certificateRequest: null, clientCertificate: null, sp: {}, md5: Ke.md.md5.create(), sha1: Ke.md.sha1.create() }, hn && ($t.version = hn.version, $t.session.sp = hn.sp), $t.session.sp.client_random = et.createRandom().getBytes(), $t.open = !0, et.queue($t, et.createRecord($t, { type: et.ContentType.handshake, data: et.createClientHello($t) })), et.flush($t);
        }
      }, $t.process = function(Ht) {
        var hn = 0;
        return Ht && $t.input.putBytes(Ht), $t.fail || ($t.record !== null && $t.record.ready && $t.record.fragment.isEmpty() && ($t.record = null), $t.record === null && (hn = function(un) {
          var An = 0, mn = un.input, En = mn.length();
          if (En < 5) An = 5 - En;
          else {
            un.record = { type: mn.getByte(), version: { major: mn.getByte(), minor: mn.getByte() }, length: mn.getInt16(), fragment: Ke.util.createBuffer(), ready: !1 };
            var Jt = un.record.version.major === un.version.major;
            Jt && un.session && un.session.version && (Jt = un.record.version.minor === un.version.minor), Jt || un.error(un, { message: "Incompatible TLS version.", send: !0, alert: { level: et.Alert.Level.fatal, description: et.Alert.Description.protocol_version } });
          }
          return An;
        }($t)), $t.fail || $t.record === null || $t.record.ready || (hn = function(un) {
          var An = 0, mn = un.input, En = mn.length();
          return En < un.record.length ? An = un.record.length - En : (un.record.fragment.putBytes(mn.getBytes(un.record.length)), mn.compact(), un.state.current.read.update(un, un.record) && (un.fragmented !== null && (un.fragmented.type === un.record.type ? (un.fragmented.fragment.putBuffer(un.record.fragment), un.record = un.fragmented) : un.error(un, { message: "Invalid fragmented record.", send: !0, alert: { level: et.Alert.Level.fatal, description: et.Alert.Description.unexpected_message } })), un.record.ready = !0)), An;
        }($t)), !$t.fail && $t.record !== null && $t.record.ready && function(un, An) {
          var mn = An.type - et.ContentType.change_cipher_spec, En = bt[un.entity][un.expect];
          mn in En ? En[mn](un, An) : et.handleUnexpected(un, An);
        }($t, $t.record)), hn;
      }, $t.prepare = function(Ht) {
        return et.queue($t, et.createRecord($t, { type: et.ContentType.application_data, data: Ke.util.createBuffer(Ht) })), et.flush($t);
      }, $t.prepareHeartbeatRequest = function(Ht, hn) {
        return Ht instanceof Ke.util.ByteBuffer && (Ht = Ht.bytes()), hn === void 0 && (hn = Ht.length), $t.expectedHeartbeatPayload = Ht, et.queue($t, et.createRecord($t, { type: et.ContentType.heartbeat, data: et.createHeartbeat(et.HeartbeatMessageType.heartbeat_request, Ht, hn) })), et.flush($t);
      }, $t.close = function(Ht) {
        if (!$t.fail && $t.sessionCache && $t.session) {
          var hn = { id: $t.session.id, version: $t.session.version, sp: $t.session.sp };
          hn.sp.keys = null, $t.sessionCache.setSession(hn.id, hn);
        }
        $t.open && ($t.open = !1, $t.input.clear(), ($t.isConnected || $t.handshaking) && ($t.isConnected = $t.handshaking = !1, et.queue($t, et.createAlert($t, { level: et.Alert.Level.warning, description: et.Alert.Description.close_notify })), et.flush($t)), $t.closed($t)), $t.reset(Ht);
      }, $t;
    }, He.exports = Ke.tls = Ke.tls || {}, et) typeof et[Ot] != "function" && (Ke.tls[Ot] = et[Ot]);
    Ke.tls.prf_tls1 = $e, Ke.tls.hmac_sha1 = function(ft, Dt, Mt) {
      var Ft = Ke.hmac.create();
      Ft.start("SHA1", ft);
      var Gt = Ke.util.createBuffer();
      return Gt.putInt32(Dt[0]), Gt.putInt32(Dt[1]), Gt.putByte(Mt.type), Gt.putByte(Mt.version.major), Gt.putByte(Mt.version.minor), Gt.putInt16(Mt.length), Gt.putBytes(Mt.fragment.bytes()), Ft.update(Gt.getBytes()), Ft.digest().getBytes();
    }, Ke.tls.createSessionCache = et.createSessionCache, Ke.tls.createConnection = et.createConnection;
  }, 3103: (He, Ge, Xe) => {
    var Ke = Xe(7573).Buffer, $e = Xe(7768), Je = Xe(7858), Ze = He.exports = $e.util = $e.util || {};
    function nt(pt) {
      if (pt !== 8 && pt !== 16 && pt !== 24 && pt !== 32) throw new Error("Only 8, 16, 24, or 32 bits supported: " + pt);
    }
    function tt(pt) {
      if (this.data = "", this.read = 0, typeof pt == "string") this.data = pt;
      else if (Ze.isArrayBuffer(pt) || Ze.isArrayBufferView(pt)) if (Ke !== void 0 && pt instanceof Ke) this.data = pt.toString("binary");
      else {
        var gt = new Uint8Array(pt);
        try {
          this.data = String.fromCharCode.apply(null, gt);
        } catch {
          for (var wt = 0; wt < gt.length; ++wt) this.putByte(gt[wt]);
        }
      }
      else (pt instanceof tt || typeof pt == "object" && typeof pt.data == "string" && typeof pt.read == "number") && (this.data = pt.data, this.read = pt.read);
      this._constructedStringLength = 0;
    }
    (function() {
      if (typeof process < "u" && process.nextTick && !process.browser) return Ze.nextTick = process.nextTick, void (typeof setImmediate == "function" ? Ze.setImmediate = setImmediate : Ze.setImmediate = Ze.nextTick);
      if (typeof setImmediate == "function") return Ze.setImmediate = function() {
        return setImmediate.apply(void 0, arguments);
      }, void (Ze.nextTick = function(Ct) {
        return setImmediate(Ct);
      });
      if (Ze.setImmediate = function(Ct) {
        setTimeout(Ct, 0);
      }, typeof window < "u" && typeof window.postMessage == "function") {
        var pt = "forge.setImmediate", gt = [];
        Ze.setImmediate = function(Ct) {
          gt.push(Ct), gt.length === 1 && window.postMessage(pt, "*");
        }, window.addEventListener("message", function(Ct) {
          if (Ct.source === window && Ct.data === pt) {
            Ct.stopPropagation();
            var ht = gt.slice();
            gt.length = 0, ht.forEach(function(It) {
              It();
            });
          }
        }, !0);
      }
      if (typeof MutationObserver < "u") {
        var wt = Date.now(), Bt = !0, Tt = document.createElement("div");
        gt = [], new MutationObserver(function() {
          var Ct = gt.slice();
          gt.length = 0, Ct.forEach(function(ht) {
            ht();
          });
        }).observe(Tt, { attributes: !0 });
        var yt = Ze.setImmediate;
        Ze.setImmediate = function(Ct) {
          Date.now() - wt > 15 ? (wt = Date.now(), yt(Ct)) : (gt.push(Ct), gt.length === 1 && Tt.setAttribute("a", Bt = !Bt));
        };
      }
      Ze.nextTick = Ze.setImmediate;
    })(), Ze.isNodejs = typeof process < "u" && process.versions && process.versions.node, Ze.globalScope = Ze.isNodejs ? Xe.g : typeof self > "u" ? window : self, Ze.isArray = Array.isArray || function(pt) {
      return Object.prototype.toString.call(pt) === "[object Array]";
    }, Ze.isArrayBuffer = function(pt) {
      return typeof ArrayBuffer < "u" && pt instanceof ArrayBuffer;
    }, Ze.isArrayBufferView = function(pt) {
      return pt && Ze.isArrayBuffer(pt.buffer) && pt.byteLength !== void 0;
    }, Ze.ByteBuffer = tt, Ze.ByteStringBuffer = tt, Ze.ByteStringBuffer.prototype._optimizeConstructedString = function(pt) {
      this._constructedStringLength += pt, this._constructedStringLength > 4096 && (this.data.substr(0, 1), this._constructedStringLength = 0);
    }, Ze.ByteStringBuffer.prototype.length = function() {
      return this.data.length - this.read;
    }, Ze.ByteStringBuffer.prototype.isEmpty = function() {
      return this.length() <= 0;
    }, Ze.ByteStringBuffer.prototype.putByte = function(pt) {
      return this.putBytes(String.fromCharCode(pt));
    }, Ze.ByteStringBuffer.prototype.fillWithByte = function(pt, gt) {
      pt = String.fromCharCode(pt);
      for (var wt = this.data; gt > 0; ) 1 & gt && (wt += pt), (gt >>>= 1) > 0 && (pt += pt);
      return this.data = wt, this._optimizeConstructedString(gt), this;
    }, Ze.ByteStringBuffer.prototype.putBytes = function(pt) {
      return this.data += pt, this._optimizeConstructedString(pt.length), this;
    }, Ze.ByteStringBuffer.prototype.putString = function(pt) {
      return this.putBytes(Ze.encodeUtf8(pt));
    }, Ze.ByteStringBuffer.prototype.putInt16 = function(pt) {
      return this.putBytes(String.fromCharCode(pt >> 8 & 255) + String.fromCharCode(255 & pt));
    }, Ze.ByteStringBuffer.prototype.putInt24 = function(pt) {
      return this.putBytes(String.fromCharCode(pt >> 16 & 255) + String.fromCharCode(pt >> 8 & 255) + String.fromCharCode(255 & pt));
    }, Ze.ByteStringBuffer.prototype.putInt32 = function(pt) {
      return this.putBytes(String.fromCharCode(pt >> 24 & 255) + String.fromCharCode(pt >> 16 & 255) + String.fromCharCode(pt >> 8 & 255) + String.fromCharCode(255 & pt));
    }, Ze.ByteStringBuffer.prototype.putInt16Le = function(pt) {
      return this.putBytes(String.fromCharCode(255 & pt) + String.fromCharCode(pt >> 8 & 255));
    }, Ze.ByteStringBuffer.prototype.putInt24Le = function(pt) {
      return this.putBytes(String.fromCharCode(255 & pt) + String.fromCharCode(pt >> 8 & 255) + String.fromCharCode(pt >> 16 & 255));
    }, Ze.ByteStringBuffer.prototype.putInt32Le = function(pt) {
      return this.putBytes(String.fromCharCode(255 & pt) + String.fromCharCode(pt >> 8 & 255) + String.fromCharCode(pt >> 16 & 255) + String.fromCharCode(pt >> 24 & 255));
    }, Ze.ByteStringBuffer.prototype.putInt = function(pt, gt) {
      nt(gt);
      var wt = "";
      do
        gt -= 8, wt += String.fromCharCode(pt >> gt & 255);
      while (gt > 0);
      return this.putBytes(wt);
    }, Ze.ByteStringBuffer.prototype.putSignedInt = function(pt, gt) {
      return pt < 0 && (pt += 2 << gt - 1), this.putInt(pt, gt);
    }, Ze.ByteStringBuffer.prototype.putBuffer = function(pt) {
      return this.putBytes(pt.getBytes());
    }, Ze.ByteStringBuffer.prototype.getByte = function() {
      return this.data.charCodeAt(this.read++);
    }, Ze.ByteStringBuffer.prototype.getInt16 = function() {
      var pt = this.data.charCodeAt(this.read) << 8 ^ this.data.charCodeAt(this.read + 1);
      return this.read += 2, pt;
    }, Ze.ByteStringBuffer.prototype.getInt24 = function() {
      var pt = this.data.charCodeAt(this.read) << 16 ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2);
      return this.read += 3, pt;
    }, Ze.ByteStringBuffer.prototype.getInt32 = function() {
      var pt = this.data.charCodeAt(this.read) << 24 ^ this.data.charCodeAt(this.read + 1) << 16 ^ this.data.charCodeAt(this.read + 2) << 8 ^ this.data.charCodeAt(this.read + 3);
      return this.read += 4, pt;
    }, Ze.ByteStringBuffer.prototype.getInt16Le = function() {
      var pt = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8;
      return this.read += 2, pt;
    }, Ze.ByteStringBuffer.prototype.getInt24Le = function() {
      var pt = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2) << 16;
      return this.read += 3, pt;
    }, Ze.ByteStringBuffer.prototype.getInt32Le = function() {
      var pt = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2) << 16 ^ this.data.charCodeAt(this.read + 3) << 24;
      return this.read += 4, pt;
    }, Ze.ByteStringBuffer.prototype.getInt = function(pt) {
      nt(pt);
      var gt = 0;
      do
        gt = (gt << 8) + this.data.charCodeAt(this.read++), pt -= 8;
      while (pt > 0);
      return gt;
    }, Ze.ByteStringBuffer.prototype.getSignedInt = function(pt) {
      var gt = this.getInt(pt), wt = 2 << pt - 2;
      return gt >= wt && (gt -= wt << 1), gt;
    }, Ze.ByteStringBuffer.prototype.getBytes = function(pt) {
      var gt;
      return pt ? (pt = Math.min(this.length(), pt), gt = this.data.slice(this.read, this.read + pt), this.read += pt) : pt === 0 ? gt = "" : (gt = this.read === 0 ? this.data : this.data.slice(this.read), this.clear()), gt;
    }, Ze.ByteStringBuffer.prototype.bytes = function(pt) {
      return pt === void 0 ? this.data.slice(this.read) : this.data.slice(this.read, this.read + pt);
    }, Ze.ByteStringBuffer.prototype.at = function(pt) {
      return this.data.charCodeAt(this.read + pt);
    }, Ze.ByteStringBuffer.prototype.setAt = function(pt, gt) {
      return this.data = this.data.substr(0, this.read + pt) + String.fromCharCode(gt) + this.data.substr(this.read + pt + 1), this;
    }, Ze.ByteStringBuffer.prototype.last = function() {
      return this.data.charCodeAt(this.data.length - 1);
    }, Ze.ByteStringBuffer.prototype.copy = function() {
      var pt = Ze.createBuffer(this.data);
      return pt.read = this.read, pt;
    }, Ze.ByteStringBuffer.prototype.compact = function() {
      return this.read > 0 && (this.data = this.data.slice(this.read), this.read = 0), this;
    }, Ze.ByteStringBuffer.prototype.clear = function() {
      return this.data = "", this.read = 0, this;
    }, Ze.ByteStringBuffer.prototype.truncate = function(pt) {
      var gt = Math.max(0, this.length() - pt);
      return this.data = this.data.substr(this.read, gt), this.read = 0, this;
    }, Ze.ByteStringBuffer.prototype.toHex = function() {
      for (var pt = "", gt = this.read; gt < this.data.length; ++gt) {
        var wt = this.data.charCodeAt(gt);
        wt < 16 && (pt += "0"), pt += wt.toString(16);
      }
      return pt;
    }, Ze.ByteStringBuffer.prototype.toString = function() {
      return Ze.decodeUtf8(this.bytes());
    }, Ze.DataBuffer = function(pt, gt) {
      gt = gt || {}, this.read = gt.readOffset || 0, this.growSize = gt.growSize || 1024;
      var wt = Ze.isArrayBuffer(pt), Bt = Ze.isArrayBufferView(pt);
      if (wt || Bt) return this.data = wt ? new DataView(pt) : new DataView(pt.buffer, pt.byteOffset, pt.byteLength), void (this.write = "writeOffset" in gt ? gt.writeOffset : this.data.byteLength);
      this.data = new DataView(new ArrayBuffer(0)), this.write = 0, pt != null && this.putBytes(pt), "writeOffset" in gt && (this.write = gt.writeOffset);
    }, Ze.DataBuffer.prototype.length = function() {
      return this.write - this.read;
    }, Ze.DataBuffer.prototype.isEmpty = function() {
      return this.length() <= 0;
    }, Ze.DataBuffer.prototype.accommodate = function(pt, gt) {
      if (this.length() >= pt) return this;
      gt = Math.max(gt || this.growSize, pt);
      var wt = new Uint8Array(this.data.buffer, this.data.byteOffset, this.data.byteLength), Bt = new Uint8Array(this.length() + gt);
      return Bt.set(wt), this.data = new DataView(Bt.buffer), this;
    }, Ze.DataBuffer.prototype.putByte = function(pt) {
      return this.accommodate(1), this.data.setUint8(this.write++, pt), this;
    }, Ze.DataBuffer.prototype.fillWithByte = function(pt, gt) {
      this.accommodate(gt);
      for (var wt = 0; wt < gt; ++wt) this.data.setUint8(pt);
      return this;
    }, Ze.DataBuffer.prototype.putBytes = function(pt, gt) {
      if (Ze.isArrayBufferView(pt)) {
        var wt = (Bt = new Uint8Array(pt.buffer, pt.byteOffset, pt.byteLength)).byteLength - Bt.byteOffset;
        return this.accommodate(wt), new Uint8Array(this.data.buffer, this.write).set(Bt), this.write += wt, this;
      }
      if (Ze.isArrayBuffer(pt)) {
        var Bt = new Uint8Array(pt);
        return this.accommodate(Bt.byteLength), new Uint8Array(this.data.buffer).set(Bt, this.write), this.write += Bt.byteLength, this;
      }
      if (pt instanceof Ze.DataBuffer || typeof pt == "object" && typeof pt.read == "number" && typeof pt.write == "number" && Ze.isArrayBufferView(pt.data)) return Bt = new Uint8Array(pt.data.byteLength, pt.read, pt.length()), this.accommodate(Bt.byteLength), new Uint8Array(pt.data.byteLength, this.write).set(Bt), this.write += Bt.byteLength, this;
      if (pt instanceof Ze.ByteStringBuffer && (pt = pt.data, gt = "binary"), gt = gt || "binary", typeof pt == "string") {
        var Tt;
        if (gt === "hex") return this.accommodate(Math.ceil(pt.length / 2)), Tt = new Uint8Array(this.data.buffer, this.write), this.write += Ze.binary.hex.decode(pt, Tt, this.write), this;
        if (gt === "base64") return this.accommodate(3 * Math.ceil(pt.length / 4)), Tt = new Uint8Array(this.data.buffer, this.write), this.write += Ze.binary.base64.decode(pt, Tt, this.write), this;
        if (gt === "utf8" && (pt = Ze.encodeUtf8(pt), gt = "binary"), gt === "binary" || gt === "raw") return this.accommodate(pt.length), Tt = new Uint8Array(this.data.buffer, this.write), this.write += Ze.binary.raw.decode(Tt), this;
        if (gt === "utf16") return this.accommodate(2 * pt.length), Tt = new Uint16Array(this.data.buffer, this.write), this.write += Ze.text.utf16.encode(Tt), this;
        throw new Error("Invalid encoding: " + gt);
      }
      throw Error("Invalid parameter: " + pt);
    }, Ze.DataBuffer.prototype.putBuffer = function(pt) {
      return this.putBytes(pt), pt.clear(), this;
    }, Ze.DataBuffer.prototype.putString = function(pt) {
      return this.putBytes(pt, "utf16");
    }, Ze.DataBuffer.prototype.putInt16 = function(pt) {
      return this.accommodate(2), this.data.setInt16(this.write, pt), this.write += 2, this;
    }, Ze.DataBuffer.prototype.putInt24 = function(pt) {
      return this.accommodate(3), this.data.setInt16(this.write, pt >> 8 & 65535), this.data.setInt8(this.write, pt >> 16 & 255), this.write += 3, this;
    }, Ze.DataBuffer.prototype.putInt32 = function(pt) {
      return this.accommodate(4), this.data.setInt32(this.write, pt), this.write += 4, this;
    }, Ze.DataBuffer.prototype.putInt16Le = function(pt) {
      return this.accommodate(2), this.data.setInt16(this.write, pt, !0), this.write += 2, this;
    }, Ze.DataBuffer.prototype.putInt24Le = function(pt) {
      return this.accommodate(3), this.data.setInt8(this.write, pt >> 16 & 255), this.data.setInt16(this.write, pt >> 8 & 65535, !0), this.write += 3, this;
    }, Ze.DataBuffer.prototype.putInt32Le = function(pt) {
      return this.accommodate(4), this.data.setInt32(this.write, pt, !0), this.write += 4, this;
    }, Ze.DataBuffer.prototype.putInt = function(pt, gt) {
      nt(gt), this.accommodate(gt / 8);
      do
        gt -= 8, this.data.setInt8(this.write++, pt >> gt & 255);
      while (gt > 0);
      return this;
    }, Ze.DataBuffer.prototype.putSignedInt = function(pt, gt) {
      return nt(gt), this.accommodate(gt / 8), pt < 0 && (pt += 2 << gt - 1), this.putInt(pt, gt);
    }, Ze.DataBuffer.prototype.getByte = function() {
      return this.data.getInt8(this.read++);
    }, Ze.DataBuffer.prototype.getInt16 = function() {
      var pt = this.data.getInt16(this.read);
      return this.read += 2, pt;
    }, Ze.DataBuffer.prototype.getInt24 = function() {
      var pt = this.data.getInt16(this.read) << 8 ^ this.data.getInt8(this.read + 2);
      return this.read += 3, pt;
    }, Ze.DataBuffer.prototype.getInt32 = function() {
      var pt = this.data.getInt32(this.read);
      return this.read += 4, pt;
    }, Ze.DataBuffer.prototype.getInt16Le = function() {
      var pt = this.data.getInt16(this.read, !0);
      return this.read += 2, pt;
    }, Ze.DataBuffer.prototype.getInt24Le = function() {
      var pt = this.data.getInt8(this.read) ^ this.data.getInt16(this.read + 1, !0) << 8;
      return this.read += 3, pt;
    }, Ze.DataBuffer.prototype.getInt32Le = function() {
      var pt = this.data.getInt32(this.read, !0);
      return this.read += 4, pt;
    }, Ze.DataBuffer.prototype.getInt = function(pt) {
      nt(pt);
      var gt = 0;
      do
        gt = (gt << 8) + this.data.getInt8(this.read++), pt -= 8;
      while (pt > 0);
      return gt;
    }, Ze.DataBuffer.prototype.getSignedInt = function(pt) {
      var gt = this.getInt(pt), wt = 2 << pt - 2;
      return gt >= wt && (gt -= wt << 1), gt;
    }, Ze.DataBuffer.prototype.getBytes = function(pt) {
      var gt;
      return pt ? (pt = Math.min(this.length(), pt), gt = this.data.slice(this.read, this.read + pt), this.read += pt) : pt === 0 ? gt = "" : (gt = this.read === 0 ? this.data : this.data.slice(this.read), this.clear()), gt;
    }, Ze.DataBuffer.prototype.bytes = function(pt) {
      return pt === void 0 ? this.data.slice(this.read) : this.data.slice(this.read, this.read + pt);
    }, Ze.DataBuffer.prototype.at = function(pt) {
      return this.data.getUint8(this.read + pt);
    }, Ze.DataBuffer.prototype.setAt = function(pt, gt) {
      return this.data.setUint8(pt, gt), this;
    }, Ze.DataBuffer.prototype.last = function() {
      return this.data.getUint8(this.write - 1);
    }, Ze.DataBuffer.prototype.copy = function() {
      return new Ze.DataBuffer(this);
    }, Ze.DataBuffer.prototype.compact = function() {
      if (this.read > 0) {
        var pt = new Uint8Array(this.data.buffer, this.read), gt = new Uint8Array(pt.byteLength);
        gt.set(pt), this.data = new DataView(gt), this.write -= this.read, this.read = 0;
      }
      return this;
    }, Ze.DataBuffer.prototype.clear = function() {
      return this.data = new DataView(new ArrayBuffer(0)), this.read = this.write = 0, this;
    }, Ze.DataBuffer.prototype.truncate = function(pt) {
      return this.write = Math.max(0, this.length() - pt), this.read = Math.min(this.read, this.write), this;
    }, Ze.DataBuffer.prototype.toHex = function() {
      for (var pt = "", gt = this.read; gt < this.data.byteLength; ++gt) {
        var wt = this.data.getUint8(gt);
        wt < 16 && (pt += "0"), pt += wt.toString(16);
      }
      return pt;
    }, Ze.DataBuffer.prototype.toString = function(pt) {
      var gt = new Uint8Array(this.data, this.read, this.length());
      if ((pt = pt || "utf8") === "binary" || pt === "raw") return Ze.binary.raw.encode(gt);
      if (pt === "hex") return Ze.binary.hex.encode(gt);
      if (pt === "base64") return Ze.binary.base64.encode(gt);
      if (pt === "utf8") return Ze.text.utf8.decode(gt);
      if (pt === "utf16") return Ze.text.utf16.decode(gt);
      throw new Error("Invalid encoding: " + pt);
    }, Ze.createBuffer = function(pt, gt) {
      return gt = gt || "raw", pt !== void 0 && gt === "utf8" && (pt = Ze.encodeUtf8(pt)), new Ze.ByteBuffer(pt);
    }, Ze.fillString = function(pt, gt) {
      for (var wt = ""; gt > 0; ) 1 & gt && (wt += pt), (gt >>>= 1) > 0 && (pt += pt);
      return wt;
    }, Ze.xorBytes = function(pt, gt, wt) {
      for (var Bt = "", Tt = "", yt = "", Ct = 0, ht = 0; wt > 0; --wt, ++Ct) Tt = pt.charCodeAt(Ct) ^ gt.charCodeAt(Ct), ht >= 10 && (Bt += yt, yt = "", ht = 0), yt += String.fromCharCode(Tt), ++ht;
      return Bt + yt;
    }, Ze.hexToBytes = function(pt) {
      var gt = "", wt = 0;
      for (!0 & pt.length && (wt = 1, gt += String.fromCharCode(parseInt(pt[0], 16))); wt < pt.length; wt += 2) gt += String.fromCharCode(parseInt(pt.substr(wt, 2), 16));
      return gt;
    }, Ze.bytesToHex = function(pt) {
      return Ze.createBuffer(pt).toHex();
    }, Ze.int32ToBytes = function(pt) {
      return String.fromCharCode(pt >> 24 & 255) + String.fromCharCode(pt >> 16 & 255) + String.fromCharCode(pt >> 8 & 255) + String.fromCharCode(255 & pt);
    };
    var et = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", rt = [62, -1, -1, -1, 63, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1, -1, -1, 64, -1, -1, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, -1, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51], it = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
    Ze.encode64 = function(pt, gt) {
      for (var wt, Bt, Tt, yt = "", Ct = "", ht = 0; ht < pt.length; ) wt = pt.charCodeAt(ht++), Bt = pt.charCodeAt(ht++), Tt = pt.charCodeAt(ht++), yt += et.charAt(wt >> 2), yt += et.charAt((3 & wt) << 4 | Bt >> 4), isNaN(Bt) ? yt += "==" : (yt += et.charAt((15 & Bt) << 2 | Tt >> 6), yt += isNaN(Tt) ? "=" : et.charAt(63 & Tt)), gt && yt.length > gt && (Ct += yt.substr(0, gt) + `\r
`, yt = yt.substr(gt));
      return Ct + yt;
    }, Ze.decode64 = function(pt) {
      pt = pt.replace(/[^A-Za-z0-9\+\/\=]/g, "");
      for (var gt, wt, Bt, Tt, yt = "", Ct = 0; Ct < pt.length; ) gt = rt[pt.charCodeAt(Ct++) - 43], wt = rt[pt.charCodeAt(Ct++) - 43], Bt = rt[pt.charCodeAt(Ct++) - 43], Tt = rt[pt.charCodeAt(Ct++) - 43], yt += String.fromCharCode(gt << 2 | wt >> 4), Bt !== 64 && (yt += String.fromCharCode((15 & wt) << 4 | Bt >> 2), Tt !== 64 && (yt += String.fromCharCode((3 & Bt) << 6 | Tt)));
      return yt;
    }, Ze.encodeUtf8 = function(pt) {
      return unescape(encodeURIComponent(pt));
    }, Ze.decodeUtf8 = function(pt) {
      return decodeURIComponent(escape(pt));
    }, Ze.binary = { raw: {}, hex: {}, base64: {}, base58: {}, baseN: { encode: Je.encode, decode: Je.decode } }, Ze.binary.raw.encode = function(pt) {
      return String.fromCharCode.apply(null, pt);
    }, Ze.binary.raw.decode = function(pt, gt, wt) {
      var Bt = gt;
      Bt || (Bt = new Uint8Array(pt.length));
      for (var Tt = wt = wt || 0, yt = 0; yt < pt.length; ++yt) Bt[Tt++] = pt.charCodeAt(yt);
      return gt ? Tt - wt : Bt;
    }, Ze.binary.hex.encode = Ze.bytesToHex, Ze.binary.hex.decode = function(pt, gt, wt) {
      var Bt = gt;
      Bt || (Bt = new Uint8Array(Math.ceil(pt.length / 2)));
      var Tt = 0, yt = wt = wt || 0;
      for (1 & pt.length && (Tt = 1, Bt[yt++] = parseInt(pt[0], 16)); Tt < pt.length; Tt += 2) Bt[yt++] = parseInt(pt.substr(Tt, 2), 16);
      return gt ? yt - wt : Bt;
    }, Ze.binary.base64.encode = function(pt, gt) {
      for (var wt, Bt, Tt, yt = "", Ct = "", ht = 0; ht < pt.byteLength; ) wt = pt[ht++], Bt = pt[ht++], Tt = pt[ht++], yt += et.charAt(wt >> 2), yt += et.charAt((3 & wt) << 4 | Bt >> 4), isNaN(Bt) ? yt += "==" : (yt += et.charAt((15 & Bt) << 2 | Tt >> 6), yt += isNaN(Tt) ? "=" : et.charAt(63 & Tt)), gt && yt.length > gt && (Ct += yt.substr(0, gt) + `\r
`, yt = yt.substr(gt));
      return Ct + yt;
    }, Ze.binary.base64.decode = function(pt, gt, wt) {
      var Bt, Tt, yt, Ct, ht = gt;
      ht || (ht = new Uint8Array(3 * Math.ceil(pt.length / 4))), pt = pt.replace(/[^A-Za-z0-9\+\/\=]/g, "");
      for (var It = 0, vt = wt = wt || 0; It < pt.length; ) Bt = rt[pt.charCodeAt(It++) - 43], Tt = rt[pt.charCodeAt(It++) - 43], yt = rt[pt.charCodeAt(It++) - 43], Ct = rt[pt.charCodeAt(It++) - 43], ht[vt++] = Bt << 2 | Tt >> 4, yt !== 64 && (ht[vt++] = (15 & Tt) << 4 | yt >> 2, Ct !== 64 && (ht[vt++] = (3 & yt) << 6 | Ct));
      return gt ? vt - wt : ht.subarray(0, vt);
    }, Ze.binary.base58.encode = function(pt, gt) {
      return Ze.binary.baseN.encode(pt, it, gt);
    }, Ze.binary.base58.decode = function(pt, gt) {
      return Ze.binary.baseN.decode(pt, it, gt);
    }, Ze.text = { utf8: {}, utf16: {} }, Ze.text.utf8.encode = function(pt, gt, wt) {
      pt = Ze.encodeUtf8(pt);
      var Bt = gt;
      Bt || (Bt = new Uint8Array(pt.length));
      for (var Tt = wt = wt || 0, yt = 0; yt < pt.length; ++yt) Bt[Tt++] = pt.charCodeAt(yt);
      return gt ? Tt - wt : Bt;
    }, Ze.text.utf8.decode = function(pt) {
      return Ze.decodeUtf8(String.fromCharCode.apply(null, pt));
    }, Ze.text.utf16.encode = function(pt, gt, wt) {
      var Bt = gt;
      Bt || (Bt = new Uint8Array(2 * pt.length));
      for (var Tt = new Uint16Array(Bt.buffer), yt = wt = wt || 0, Ct = wt, ht = 0; ht < pt.length; ++ht) Tt[Ct++] = pt.charCodeAt(ht), yt += 2;
      return gt ? yt - wt : Bt;
    }, Ze.text.utf16.decode = function(pt) {
      return String.fromCharCode.apply(null, new Uint16Array(pt.buffer));
    }, Ze.deflate = function(pt, gt, wt) {
      if (gt = Ze.decode64(pt.deflate(Ze.encode64(gt)).rval), wt) {
        var Bt = 2;
        32 & gt.charCodeAt(1) && (Bt = 6), gt = gt.substring(Bt, gt.length - 4);
      }
      return gt;
    }, Ze.inflate = function(pt, gt, wt) {
      var Bt = pt.inflate(Ze.encode64(gt)).rval;
      return Bt === null ? null : Ze.decode64(Bt);
    };
    var ot = function(pt, gt, wt) {
      if (!pt) throw new Error("WebStorage not available.");
      var Bt;
      if (wt === null ? Bt = pt.removeItem(gt) : (wt = Ze.encode64(JSON.stringify(wt)), Bt = pt.setItem(gt, wt)), Bt !== void 0 && Bt.rval !== !0) {
        var Tt = new Error(Bt.error.message);
        throw Tt.id = Bt.error.id, Tt.name = Bt.error.name, Tt;
      }
    }, at = function(pt, gt) {
      if (!pt) throw new Error("WebStorage not available.");
      var wt = pt.getItem(gt);
      if (pt.init) if (wt.rval === null) {
        if (wt.error) {
          var Bt = new Error(wt.error.message);
          throw Bt.id = wt.error.id, Bt.name = wt.error.name, Bt;
        }
        wt = null;
      } else wt = wt.rval;
      return wt !== null && (wt = JSON.parse(Ze.decode64(wt))), wt;
    }, st = function(pt, gt, wt, Bt) {
      var Tt = at(pt, gt);
      Tt === null && (Tt = {}), Tt[wt] = Bt, ot(pt, gt, Tt);
    }, ut = function(pt, gt, wt) {
      var Bt = at(pt, gt);
      return Bt !== null && (Bt = wt in Bt ? Bt[wt] : null), Bt;
    }, lt = function(pt, gt, wt) {
      var Bt = at(pt, gt);
      if (Bt !== null && wt in Bt) {
        delete Bt[wt];
        var Tt = !0;
        for (var yt in Bt) {
          Tt = !1;
          break;
        }
        Tt && (Bt = null), ot(pt, gt, Bt);
      }
    }, dt = function(pt, gt) {
      ot(pt, gt, null);
    }, At = function(pt, gt, wt) {
      var Bt, Tt = null;
      wt === void 0 && (wt = ["web", "flash"]);
      var yt = !1, Ct = null;
      for (var ht in wt) {
        Bt = wt[ht];
        try {
          if (Bt === "flash" || Bt === "both") {
            if (gt[0] === null) throw new Error("Flash local storage not available.");
            Tt = pt.apply(this, gt), yt = Bt === "flash";
          }
          Bt !== "web" && Bt !== "both" || (gt[0] = localStorage, Tt = pt.apply(this, gt), yt = !0);
        } catch (It) {
          Ct = It;
        }
        if (yt) break;
      }
      if (!yt) throw Ct;
      return Tt;
    };
    Ze.setItem = function(pt, gt, wt, Bt, Tt) {
      At(st, arguments, Tt);
    }, Ze.getItem = function(pt, gt, wt, Bt) {
      return At(ut, arguments, Bt);
    }, Ze.removeItem = function(pt, gt, wt, Bt) {
      At(lt, arguments, Bt);
    }, Ze.clearItems = function(pt, gt, wt) {
      At(dt, arguments, wt);
    }, Ze.isEmpty = function(pt) {
      for (var gt in pt) if (pt.hasOwnProperty(gt)) return !1;
      return !0;
    }, Ze.format = function(pt) {
      for (var gt, wt, Bt = /%./g, Tt = 0, yt = [], Ct = 0; gt = Bt.exec(pt); ) {
        (wt = pt.substring(Ct, Bt.lastIndex - 2)).length > 0 && yt.push(wt), Ct = Bt.lastIndex;
        var ht = gt[0][1];
        switch (ht) {
          case "s":
          case "o":
            Tt < arguments.length ? yt.push(arguments[1 + Tt++]) : yt.push("<?>");
            break;
          case "%":
            yt.push("%");
            break;
          default:
            yt.push("<%" + ht + "?>");
        }
      }
      return yt.push(pt.substring(Ct)), yt.join("");
    }, Ze.formatNumber = function(pt, gt, wt, Bt) {
      var Tt = pt, yt = isNaN(gt = Math.abs(gt)) ? 2 : gt, Ct = wt === void 0 ? "," : wt, ht = Bt === void 0 ? "." : Bt, It = Tt < 0 ? "-" : "", vt = parseInt(Tt = Math.abs(+Tt || 0).toFixed(yt), 10) + "", Et = vt.length > 3 ? vt.length % 3 : 0;
      return It + (Et ? vt.substr(0, Et) + ht : "") + vt.substr(Et).replace(/(\d{3})(?=\d)/g, "$1" + ht) + (yt ? Ct + Math.abs(Tt - vt).toFixed(yt).slice(2) : "");
    }, Ze.formatSize = function(pt) {
      return pt >= 1073741824 ? Ze.formatNumber(pt / 1073741824, 2, ".", "") + " GiB" : pt >= 1048576 ? Ze.formatNumber(pt / 1048576, 2, ".", "") + " MiB" : pt >= 1024 ? Ze.formatNumber(pt / 1024, 0) + " KiB" : Ze.formatNumber(pt, 0) + " bytes";
    }, Ze.bytesFromIP = function(pt) {
      return pt.indexOf(".") !== -1 ? Ze.bytesFromIPv4(pt) : pt.indexOf(":") !== -1 ? Ze.bytesFromIPv6(pt) : null;
    }, Ze.bytesFromIPv4 = function(pt) {
      if ((pt = pt.split(".")).length !== 4) return null;
      for (var gt = Ze.createBuffer(), wt = 0; wt < pt.length; ++wt) {
        var Bt = parseInt(pt[wt], 10);
        if (isNaN(Bt)) return null;
        gt.putByte(Bt);
      }
      return gt.getBytes();
    }, Ze.bytesFromIPv6 = function(pt) {
      for (var gt = 0, wt = 2 * (8 - (pt = pt.split(":").filter(function(Ct) {
        return Ct.length === 0 && ++gt, !0;
      })).length + gt), Bt = Ze.createBuffer(), Tt = 0; Tt < 8; ++Tt) if (pt[Tt] && pt[Tt].length !== 0) {
        var yt = Ze.hexToBytes(pt[Tt]);
        yt.length < 2 && Bt.putByte(0), Bt.putBytes(yt);
      } else Bt.fillWithByte(0, wt), wt = 0;
      return Bt.getBytes();
    }, Ze.bytesToIP = function(pt) {
      return pt.length === 4 ? Ze.bytesToIPv4(pt) : pt.length === 16 ? Ze.bytesToIPv6(pt) : null;
    }, Ze.bytesToIPv4 = function(pt) {
      if (pt.length !== 4) return null;
      for (var gt = [], wt = 0; wt < pt.length; ++wt) gt.push(pt.charCodeAt(wt));
      return gt.join(".");
    }, Ze.bytesToIPv6 = function(pt) {
      if (pt.length !== 16) return null;
      for (var gt = [], wt = [], Bt = 0, Tt = 0; Tt < pt.length; Tt += 2) {
        for (var yt = Ze.bytesToHex(pt[Tt] + pt[Tt + 1]); yt[0] === "0" && yt !== "0"; ) yt = yt.substr(1);
        if (yt === "0") {
          var Ct = wt[wt.length - 1], ht = gt.length;
          Ct && ht === Ct.end + 1 ? (Ct.end = ht, Ct.end - Ct.start > wt[Bt].end - wt[Bt].start && (Bt = wt.length - 1)) : wt.push({ start: ht, end: ht });
        }
        gt.push(yt);
      }
      if (wt.length > 0) {
        var It = wt[Bt];
        It.end - It.start > 0 && (gt.splice(It.start, It.end - It.start + 1, ""), It.start === 0 && gt.unshift(""), It.end === 7 && gt.push(""));
      }
      return gt.join(":");
    }, Ze.estimateCores = function(pt, gt) {
      if (typeof pt == "function" && (gt = pt, pt = {}), pt = pt || {}, "cores" in Ze && !pt.update) return gt(null, Ze.cores);
      if (typeof navigator < "u" && "hardwareConcurrency" in navigator && navigator.hardwareConcurrency > 0) return Ze.cores = navigator.hardwareConcurrency, gt(null, Ze.cores);
      if (typeof Worker > "u") return Ze.cores = 1, gt(null, Ze.cores);
      if (typeof Blob > "u") return Ze.cores = 2, gt(null, Ze.cores);
      var wt = URL.createObjectURL(new Blob(["(", (function() {
        self.addEventListener("message", function(Bt) {
          for (var Tt = Date.now(), yt = Tt + 4; Date.now() < yt; ) ;
          self.postMessage({ st: Tt, et: yt });
        });
      }).toString(), ")()"], { type: "application/javascript" }));
      (function Bt(Tt, yt, Ct) {
        if (yt === 0) {
          var ht = Math.floor(Tt.reduce(function(It, vt) {
            return It + vt;
          }, 0) / Tt.length);
          return Ze.cores = Math.max(1, ht), URL.revokeObjectURL(wt), gt(null, Ze.cores);
        }
        (function(It, vt) {
          for (var Et = [], bt = [], Rt = 0; Rt < It; ++Rt) {
            var St = new Worker(wt);
            St.addEventListener("message", function(kt) {
              if (bt.push(kt.data), bt.length === It) {
                for (var jt = 0; jt < It; ++jt) Et[jt].terminate();
                vt(0, bt);
              }
            }), Et.push(St);
          }
          for (Rt = 0; Rt < It; ++Rt) Et[Rt].postMessage(Rt);
        })(Ct, function(It, vt) {
          Tt.push(function(Et, bt) {
            for (var Rt = [], St = 0; St < Et; ++St) for (var kt = bt[St], jt = Rt[St] = [], Pt = 0; Pt < Et; ++Pt) if (St !== Pt) {
              var Qt = bt[Pt];
              (kt.st > Qt.st && kt.st < Qt.et || Qt.st > kt.st && Qt.st < kt.et) && jt.push(Pt);
            }
            return Rt.reduce(function(qt, _t) {
              return Math.max(qt, _t.length);
            }, 0);
          }(Ct, vt)), Bt(Tt, yt - 1, Ct);
        });
      })([], 5, 16);
    };
  }, 6446: (He, Ge, Xe) => {
    var Ke = Xe(7768);
    Xe(1482), Xe(2624), Xe(2023), Xe(6067), Xe(826), Xe(2884), Xe(5477), Xe(665), Xe(144), Xe(3103);
    var $e = Ke.asn1, Je = He.exports = Ke.pki = Ke.pki || {}, Ze = Je.oids, nt = {};
    nt.CN = Ze.commonName, nt.commonName = "CN", nt.C = Ze.countryName, nt.countryName = "C", nt.L = Ze.localityName, nt.localityName = "L", nt.ST = Ze.stateOrProvinceName, nt.stateOrProvinceName = "ST", nt.O = Ze.organizationName, nt.organizationName = "O", nt.OU = Ze.organizationalUnitName, nt.organizationalUnitName = "OU", nt.E = Ze.emailAddress, nt.emailAddress = "E";
    var tt = Ke.pki.rsa.publicKeyValidator, et = { name: "Certificate", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "Certificate.TBSCertificate", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, captureAsn1: "tbsCertificate", value: [{ name: "Certificate.TBSCertificate.version", tagClass: $e.Class.CONTEXT_SPECIFIC, type: 0, constructed: !0, optional: !0, value: [{ name: "Certificate.TBSCertificate.version.integer", tagClass: $e.Class.UNIVERSAL, type: $e.Type.INTEGER, constructed: !1, capture: "certVersion" }] }, { name: "Certificate.TBSCertificate.serialNumber", tagClass: $e.Class.UNIVERSAL, type: $e.Type.INTEGER, constructed: !1, capture: "certSerialNumber" }, { name: "Certificate.TBSCertificate.signature", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "Certificate.TBSCertificate.signature.algorithm", tagClass: $e.Class.UNIVERSAL, type: $e.Type.OID, constructed: !1, capture: "certinfoSignatureOid" }, { name: "Certificate.TBSCertificate.signature.parameters", tagClass: $e.Class.UNIVERSAL, optional: !0, captureAsn1: "certinfoSignatureParams" }] }, { name: "Certificate.TBSCertificate.issuer", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, captureAsn1: "certIssuer" }, { name: "Certificate.TBSCertificate.validity", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "Certificate.TBSCertificate.validity.notBefore (utc)", tagClass: $e.Class.UNIVERSAL, type: $e.Type.UTCTIME, constructed: !1, optional: !0, capture: "certValidity1UTCTime" }, { name: "Certificate.TBSCertificate.validity.notBefore (generalized)", tagClass: $e.Class.UNIVERSAL, type: $e.Type.GENERALIZEDTIME, constructed: !1, optional: !0, capture: "certValidity2GeneralizedTime" }, { name: "Certificate.TBSCertificate.validity.notAfter (utc)", tagClass: $e.Class.UNIVERSAL, type: $e.Type.UTCTIME, constructed: !1, optional: !0, capture: "certValidity3UTCTime" }, { name: "Certificate.TBSCertificate.validity.notAfter (generalized)", tagClass: $e.Class.UNIVERSAL, type: $e.Type.GENERALIZEDTIME, constructed: !1, optional: !0, capture: "certValidity4GeneralizedTime" }] }, { name: "Certificate.TBSCertificate.subject", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, captureAsn1: "certSubject" }, tt, { name: "Certificate.TBSCertificate.issuerUniqueID", tagClass: $e.Class.CONTEXT_SPECIFIC, type: 1, constructed: !0, optional: !0, value: [{ name: "Certificate.TBSCertificate.issuerUniqueID.id", tagClass: $e.Class.UNIVERSAL, type: $e.Type.BITSTRING, constructed: !1, captureBitStringValue: "certIssuerUniqueId" }] }, { name: "Certificate.TBSCertificate.subjectUniqueID", tagClass: $e.Class.CONTEXT_SPECIFIC, type: 2, constructed: !0, optional: !0, value: [{ name: "Certificate.TBSCertificate.subjectUniqueID.id", tagClass: $e.Class.UNIVERSAL, type: $e.Type.BITSTRING, constructed: !1, captureBitStringValue: "certSubjectUniqueId" }] }, { name: "Certificate.TBSCertificate.extensions", tagClass: $e.Class.CONTEXT_SPECIFIC, type: 3, constructed: !0, captureAsn1: "certExtensions", optional: !0 }] }, { name: "Certificate.signatureAlgorithm", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "Certificate.signatureAlgorithm.algorithm", tagClass: $e.Class.UNIVERSAL, type: $e.Type.OID, constructed: !1, capture: "certSignatureOid" }, { name: "Certificate.TBSCertificate.signature.parameters", tagClass: $e.Class.UNIVERSAL, optional: !0, captureAsn1: "certSignatureParams" }] }, { name: "Certificate.signatureValue", tagClass: $e.Class.UNIVERSAL, type: $e.Type.BITSTRING, constructed: !1, captureBitStringValue: "certSignature" }] }, rt = { name: "rsapss", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "rsapss.hashAlgorithm", tagClass: $e.Class.CONTEXT_SPECIFIC, type: 0, constructed: !0, value: [{ name: "rsapss.hashAlgorithm.AlgorithmIdentifier", tagClass: $e.Class.UNIVERSAL, type: $e.Class.SEQUENCE, constructed: !0, optional: !0, value: [{ name: "rsapss.hashAlgorithm.AlgorithmIdentifier.algorithm", tagClass: $e.Class.UNIVERSAL, type: $e.Type.OID, constructed: !1, capture: "hashOid" }] }] }, { name: "rsapss.maskGenAlgorithm", tagClass: $e.Class.CONTEXT_SPECIFIC, type: 1, constructed: !0, value: [{ name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier", tagClass: $e.Class.UNIVERSAL, type: $e.Class.SEQUENCE, constructed: !0, optional: !0, value: [{ name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.algorithm", tagClass: $e.Class.UNIVERSAL, type: $e.Type.OID, constructed: !1, capture: "maskGenOid" }, { name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.params", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.params.algorithm", tagClass: $e.Class.UNIVERSAL, type: $e.Type.OID, constructed: !1, capture: "maskGenHashOid" }] }] }] }, { name: "rsapss.saltLength", tagClass: $e.Class.CONTEXT_SPECIFIC, type: 2, optional: !0, value: [{ name: "rsapss.saltLength.saltLength", tagClass: $e.Class.UNIVERSAL, type: $e.Class.INTEGER, constructed: !1, capture: "saltLength" }] }, { name: "rsapss.trailerField", tagClass: $e.Class.CONTEXT_SPECIFIC, type: 3, optional: !0, value: [{ name: "rsapss.trailer.trailer", tagClass: $e.Class.UNIVERSAL, type: $e.Class.INTEGER, constructed: !1, capture: "trailer" }] }] }, it = { name: "CertificationRequestInfo", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, captureAsn1: "certificationRequestInfo", value: [{ name: "CertificationRequestInfo.integer", tagClass: $e.Class.UNIVERSAL, type: $e.Type.INTEGER, constructed: !1, capture: "certificationRequestInfoVersion" }, { name: "CertificationRequestInfo.subject", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, captureAsn1: "certificationRequestInfoSubject" }, tt, { name: "CertificationRequestInfo.attributes", tagClass: $e.Class.CONTEXT_SPECIFIC, type: 0, constructed: !0, optional: !0, capture: "certificationRequestInfoAttributes", value: [{ name: "CertificationRequestInfo.attributes", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "CertificationRequestInfo.attributes.type", tagClass: $e.Class.UNIVERSAL, type: $e.Type.OID, constructed: !1 }, { name: "CertificationRequestInfo.attributes.value", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SET, constructed: !0 }] }] }] }, ot = { name: "CertificationRequest", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, captureAsn1: "csr", value: [it, { name: "CertificationRequest.signatureAlgorithm", tagClass: $e.Class.UNIVERSAL, type: $e.Type.SEQUENCE, constructed: !0, value: [{ name: "CertificationRequest.signatureAlgorithm.algorithm", tagClass: $e.Class.UNIVERSAL, type: $e.Type.OID, constructed: !1, capture: "csrSignatureOid" }, { name: "CertificationRequest.signatureAlgorithm.parameters", tagClass: $e.Class.UNIVERSAL, optional: !0, captureAsn1: "csrSignatureParams" }] }, { name: "CertificationRequest.signature", tagClass: $e.Class.UNIVERSAL, type: $e.Type.BITSTRING, constructed: !1, captureBitStringValue: "csrSignature" }] };
    function at(Ct, ht) {
      typeof ht == "string" && (ht = { shortName: ht });
      for (var It, vt = null, Et = 0; vt === null && Et < Ct.attributes.length; ++Et) It = Ct.attributes[Et], (ht.type && ht.type === It.type || ht.name && ht.name === It.name || ht.shortName && ht.shortName === It.shortName) && (vt = It);
      return vt;
    }
    Je.RDNAttributesAsArray = function(Ct, ht) {
      for (var It, vt, Et, bt = [], Rt = 0; Rt < Ct.value.length; ++Rt) {
        It = Ct.value[Rt];
        for (var St = 0; St < It.value.length; ++St) Et = {}, vt = It.value[St], Et.type = $e.derToOid(vt.value[0].value), Et.value = vt.value[1].value, Et.valueTagClass = vt.value[1].type, Et.type in Ze && (Et.name = Ze[Et.type], Et.name in nt && (Et.shortName = nt[Et.name])), ht && (ht.update(Et.type), ht.update(Et.value)), bt.push(Et);
      }
      return bt;
    }, Je.CRIAttributesAsArray = function(Ct) {
      for (var ht = [], It = 0; It < Ct.length; ++It) for (var vt = Ct[It], Et = $e.derToOid(vt.value[0].value), bt = vt.value[1].value, Rt = 0; Rt < bt.length; ++Rt) {
        var St = {};
        if (St.type = Et, St.value = bt[Rt].value, St.valueTagClass = bt[Rt].type, St.type in Ze && (St.name = Ze[St.type], St.name in nt && (St.shortName = nt[St.name])), St.type === Ze.extensionRequest) {
          St.extensions = [];
          for (var kt = 0; kt < St.value.length; ++kt) St.extensions.push(Je.certificateExtensionFromAsn1(St.value[kt]));
        }
        ht.push(St);
      }
      return ht;
    };
    var st = function(Ct, ht, It) {
      var vt = {};
      if (Ct !== Ze["RSASSA-PSS"]) return vt;
      It && (vt = { hash: { algorithmOid: Ze.sha1 }, mgf: { algorithmOid: Ze.mgf1, hash: { algorithmOid: Ze.sha1 } }, saltLength: 20 });
      var Et = {}, bt = [];
      if (!$e.validate(ht, rt, Et, bt)) {
        var Rt = new Error("Cannot read RSASSA-PSS parameter block.");
        throw Rt.errors = bt, Rt;
      }
      return Et.hashOid !== void 0 && (vt.hash = vt.hash || {}, vt.hash.algorithmOid = $e.derToOid(Et.hashOid)), Et.maskGenOid !== void 0 && (vt.mgf = vt.mgf || {}, vt.mgf.algorithmOid = $e.derToOid(Et.maskGenOid), vt.mgf.hash = vt.mgf.hash || {}, vt.mgf.hash.algorithmOid = $e.derToOid(Et.maskGenHashOid)), Et.saltLength !== void 0 && (vt.saltLength = Et.saltLength.charCodeAt(0)), vt;
    }, ut = function(Ct) {
      switch (Ze[Ct.signatureOid]) {
        case "sha1WithRSAEncryption":
        case "sha1WithRSASignature":
          return Ke.md.sha1.create();
        case "md5WithRSAEncryption":
          return Ke.md.md5.create();
        case "sha256WithRSAEncryption":
        case "RSASSA-PSS":
          return Ke.md.sha256.create();
        case "sha384WithRSAEncryption":
          return Ke.md.sha384.create();
        case "sha512WithRSAEncryption":
          return Ke.md.sha512.create();
        default:
          var ht = new Error("Could not compute " + Ct.type + " digest. Unknown signature OID.");
          throw ht.signatureOid = Ct.signatureOid, ht;
      }
    }, lt = function(Ct) {
      var ht, It = Ct.certificate;
      switch (It.signatureOid) {
        case Ze.sha1WithRSAEncryption:
        case Ze.sha1WithRSASignature:
          break;
        case Ze["RSASSA-PSS"]:
          var vt, Et, bt;
          if ((vt = Ze[It.signatureParameters.mgf.hash.algorithmOid]) === void 0 || Ke.md[vt] === void 0) throw (bt = new Error("Unsupported MGF hash function.")).oid = It.signatureParameters.mgf.hash.algorithmOid, bt.name = vt, bt;
          if ((Et = Ze[It.signatureParameters.mgf.algorithmOid]) === void 0 || Ke.mgf[Et] === void 0) throw (bt = new Error("Unsupported MGF function.")).oid = It.signatureParameters.mgf.algorithmOid, bt.name = Et, bt;
          if (Et = Ke.mgf[Et].create(Ke.md[vt].create()), (vt = Ze[It.signatureParameters.hash.algorithmOid]) === void 0 || Ke.md[vt] === void 0) throw (bt = new Error("Unsupported RSASSA-PSS hash function.")).oid = It.signatureParameters.hash.algorithmOid, bt.name = vt, bt;
          ht = Ke.pss.create(Ke.md[vt].create(), Et, It.signatureParameters.saltLength);
      }
      return It.publicKey.verify(Ct.md.digest().getBytes(), Ct.signature, ht);
    };
    function dt(Ct) {
      for (var ht, It, vt = $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, []), Et = Ct.attributes, bt = 0; bt < Et.length; ++bt) {
        var Rt = (ht = Et[bt]).value, St = $e.Type.PRINTABLESTRING;
        "valueTagClass" in ht && (St = ht.valueTagClass) === $e.Type.UTF8 && (Rt = Ke.util.encodeUtf8(Rt)), It = $e.create($e.Class.UNIVERSAL, $e.Type.SET, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(ht.type).getBytes()), $e.create($e.Class.UNIVERSAL, St, !1, Rt)])]), vt.value.push(It);
      }
      return vt;
    }
    function At(Ct) {
      for (var ht, It = 0; It < Ct.length; ++It) {
        if ((ht = Ct[It]).name === void 0 && (ht.type && ht.type in Je.oids ? ht.name = Je.oids[ht.type] : ht.shortName && ht.shortName in nt && (ht.name = Je.oids[nt[ht.shortName]])), ht.type === void 0) {
          if (!ht.name || !(ht.name in Je.oids)) throw (Et = new Error("Attribute type not specified.")).attribute = ht, Et;
          ht.type = Je.oids[ht.name];
        }
        if (ht.shortName === void 0 && ht.name && ht.name in nt && (ht.shortName = nt[ht.name]), ht.type === Ze.extensionRequest && (ht.valueConstructed = !0, ht.valueTagClass = $e.Type.SEQUENCE, !ht.value && ht.extensions)) {
          ht.value = [];
          for (var vt = 0; vt < ht.extensions.length; ++vt) ht.value.push(Je.certificateExtensionToAsn1(pt(ht.extensions[vt])));
        }
        var Et;
        if (ht.value === void 0) throw (Et = new Error("Attribute value not specified.")).attribute = ht, Et;
      }
    }
    function pt(Ct, ht) {
      if (ht = ht || {}, Ct.name === void 0 && Ct.id && Ct.id in Je.oids && (Ct.name = Je.oids[Ct.id]), Ct.id === void 0) {
        if (!Ct.name || !(Ct.name in Je.oids)) throw (Ut = new Error("Extension ID not specified.")).extension = Ct, Ut;
        Ct.id = Je.oids[Ct.name];
      }
      if (Ct.value !== void 0) return Ct;
      if (Ct.name === "keyUsage") {
        var It = 0, vt = 0, Et = 0;
        Ct.digitalSignature && (vt |= 128, It = 7), Ct.nonRepudiation && (vt |= 64, It = 6), Ct.keyEncipherment && (vt |= 32, It = 5), Ct.dataEncipherment && (vt |= 16, It = 4), Ct.keyAgreement && (vt |= 8, It = 3), Ct.keyCertSign && (vt |= 4, It = 2), Ct.cRLSign && (vt |= 2, It = 1), Ct.encipherOnly && (vt |= 1, It = 0), Ct.decipherOnly && (Et |= 128, It = 7);
        var bt = String.fromCharCode(It);
        Et !== 0 ? bt += String.fromCharCode(vt) + String.fromCharCode(Et) : vt !== 0 && (bt += String.fromCharCode(vt)), Ct.value = $e.create($e.Class.UNIVERSAL, $e.Type.BITSTRING, !1, bt);
      } else if (Ct.name === "basicConstraints") Ct.value = $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, []), Ct.cA && Ct.value.value.push($e.create($e.Class.UNIVERSAL, $e.Type.BOOLEAN, !1, "ÿ")), "pathLenConstraint" in Ct && Ct.value.value.push($e.create($e.Class.UNIVERSAL, $e.Type.INTEGER, !1, $e.integerToDer(Ct.pathLenConstraint).getBytes()));
      else if (Ct.name === "extKeyUsage") {
        Ct.value = $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, []);
        var Rt = Ct.value.value;
        for (var St in Ct) Ct[St] === !0 && (St in Ze ? Rt.push($e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(Ze[St]).getBytes())) : St.indexOf(".") !== -1 && Rt.push($e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(St).getBytes())));
      } else if (Ct.name === "nsCertType") It = 0, vt = 0, Ct.client && (vt |= 128, It = 7), Ct.server && (vt |= 64, It = 6), Ct.email && (vt |= 32, It = 5), Ct.objsign && (vt |= 16, It = 4), Ct.reserved && (vt |= 8, It = 3), Ct.sslCA && (vt |= 4, It = 2), Ct.emailCA && (vt |= 2, It = 1), Ct.objCA && (vt |= 1, It = 0), bt = String.fromCharCode(It), vt !== 0 && (bt += String.fromCharCode(vt)), Ct.value = $e.create($e.Class.UNIVERSAL, $e.Type.BITSTRING, !1, bt);
      else if (Ct.name === "subjectAltName" || Ct.name === "issuerAltName") {
        Ct.value = $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, []);
        for (var kt = 0; kt < Ct.altNames.length; ++kt) {
          if (bt = (_t = Ct.altNames[kt]).value, _t.type === 7 && _t.ip) {
            if ((bt = Ke.util.bytesFromIP(_t.ip)) === null) throw (Ut = new Error('Extension "ip" value is not a valid IPv4 or IPv6 address.')).extension = Ct, Ut;
          } else _t.type === 8 && (bt = _t.oid ? $e.oidToDer($e.oidToDer(_t.oid)) : $e.oidToDer(bt));
          Ct.value.value.push($e.create($e.Class.CONTEXT_SPECIFIC, _t.type, !1, bt));
        }
      } else if (Ct.name === "nsComment" && ht.cert) {
        if (!/^[\x00-\x7F]*$/.test(Ct.comment) || Ct.comment.length < 1 || Ct.comment.length > 128) throw new Error('Invalid "nsComment" content.');
        Ct.value = $e.create($e.Class.UNIVERSAL, $e.Type.IA5STRING, !1, Ct.comment);
      } else if (Ct.name === "subjectKeyIdentifier" && ht.cert) {
        var jt = ht.cert.generateSubjectKeyIdentifier();
        Ct.subjectKeyIdentifier = jt.toHex(), Ct.value = $e.create($e.Class.UNIVERSAL, $e.Type.OCTETSTRING, !1, jt.getBytes());
      } else if (Ct.name === "authorityKeyIdentifier" && ht.cert) {
        if (Ct.value = $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, []), Rt = Ct.value.value, Ct.keyIdentifier) {
          var Pt = Ct.keyIdentifier === !0 ? ht.cert.generateSubjectKeyIdentifier().getBytes() : Ct.keyIdentifier;
          Rt.push($e.create($e.Class.CONTEXT_SPECIFIC, 0, !1, Pt));
        }
        if (Ct.authorityCertIssuer) {
          var Qt = [$e.create($e.Class.CONTEXT_SPECIFIC, 4, !0, [dt(Ct.authorityCertIssuer === !0 ? ht.cert.issuer : Ct.authorityCertIssuer)])];
          Rt.push($e.create($e.Class.CONTEXT_SPECIFIC, 1, !0, Qt));
        }
        if (Ct.serialNumber) {
          var qt = Ke.util.hexToBytes(Ct.serialNumber === !0 ? ht.cert.serialNumber : Ct.serialNumber);
          Rt.push($e.create($e.Class.CONTEXT_SPECIFIC, 2, !1, qt));
        }
      } else if (Ct.name === "cRLDistributionPoints") {
        Ct.value = $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, []), Rt = Ct.value.value;
        var _t, Yt = $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, []), Xt = $e.create($e.Class.CONTEXT_SPECIFIC, 0, !0, []);
        for (kt = 0; kt < Ct.altNames.length; ++kt) {
          if (bt = (_t = Ct.altNames[kt]).value, _t.type === 7 && _t.ip) {
            if ((bt = Ke.util.bytesFromIP(_t.ip)) === null) throw (Ut = new Error('Extension "ip" value is not a valid IPv4 or IPv6 address.')).extension = Ct, Ut;
          } else _t.type === 8 && (bt = _t.oid ? $e.oidToDer($e.oidToDer(_t.oid)) : $e.oidToDer(bt));
          Xt.value.push($e.create($e.Class.CONTEXT_SPECIFIC, _t.type, !1, bt));
        }
        Yt.value.push($e.create($e.Class.CONTEXT_SPECIFIC, 0, !0, [Xt])), Rt.push(Yt);
      }
      var Ut;
      if (Ct.value === void 0) throw (Ut = new Error("Extension value not specified.")).extension = Ct, Ut;
      return Ct;
    }
    function gt(Ct, ht) {
      if (Ct === Ze["RSASSA-PSS"]) {
        var It = [];
        return ht.hash.algorithmOid !== void 0 && It.push($e.create($e.Class.CONTEXT_SPECIFIC, 0, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(ht.hash.algorithmOid).getBytes()), $e.create($e.Class.UNIVERSAL, $e.Type.NULL, !1, "")])])), ht.mgf.algorithmOid !== void 0 && It.push($e.create($e.Class.CONTEXT_SPECIFIC, 1, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(ht.mgf.algorithmOid).getBytes()), $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(ht.mgf.hash.algorithmOid).getBytes()), $e.create($e.Class.UNIVERSAL, $e.Type.NULL, !1, "")])])])), ht.saltLength !== void 0 && It.push($e.create($e.Class.CONTEXT_SPECIFIC, 2, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.INTEGER, !1, $e.integerToDer(ht.saltLength).getBytes())])), $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, It);
      }
      return $e.create($e.Class.UNIVERSAL, $e.Type.NULL, !1, "");
    }
    function wt(Ct) {
      var ht = $e.create($e.Class.CONTEXT_SPECIFIC, 0, !0, []);
      if (Ct.attributes.length === 0) return ht;
      for (var It = Ct.attributes, vt = 0; vt < It.length; ++vt) {
        var Et = It[vt], bt = Et.value, Rt = $e.Type.UTF8;
        "valueTagClass" in Et && (Rt = Et.valueTagClass), Rt === $e.Type.UTF8 && (bt = Ke.util.encodeUtf8(bt));
        var St = !1;
        "valueConstructed" in Et && (St = Et.valueConstructed);
        var kt = $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(Et.type).getBytes()), $e.create($e.Class.UNIVERSAL, $e.Type.SET, !0, [$e.create($e.Class.UNIVERSAL, Rt, St, bt)])]);
        ht.value.push(kt);
      }
      return ht;
    }
    Je.certificateFromPem = function(Ct, ht, It) {
      var vt = Ke.pem.decode(Ct)[0];
      if (vt.type !== "CERTIFICATE" && vt.type !== "X509 CERTIFICATE" && vt.type !== "TRUSTED CERTIFICATE") {
        var Et = new Error('Could not convert certificate from PEM; PEM header type is not "CERTIFICATE", "X509 CERTIFICATE", or "TRUSTED CERTIFICATE".');
        throw Et.headerType = vt.type, Et;
      }
      if (vt.procType && vt.procType.type === "ENCRYPTED") throw new Error("Could not convert certificate from PEM; PEM is encrypted.");
      var bt = $e.fromDer(vt.body, It);
      return Je.certificateFromAsn1(bt, ht);
    }, Je.certificateToPem = function(Ct, ht) {
      var It = { type: "CERTIFICATE", body: $e.toDer(Je.certificateToAsn1(Ct)).getBytes() };
      return Ke.pem.encode(It, { maxline: ht });
    }, Je.publicKeyFromPem = function(Ct) {
      var ht = Ke.pem.decode(Ct)[0];
      if (ht.type !== "PUBLIC KEY" && ht.type !== "RSA PUBLIC KEY") {
        var It = new Error('Could not convert public key from PEM; PEM header type is not "PUBLIC KEY" or "RSA PUBLIC KEY".');
        throw It.headerType = ht.type, It;
      }
      if (ht.procType && ht.procType.type === "ENCRYPTED") throw new Error("Could not convert public key from PEM; PEM is encrypted.");
      var vt = $e.fromDer(ht.body);
      return Je.publicKeyFromAsn1(vt);
    }, Je.publicKeyToPem = function(Ct, ht) {
      var It = { type: "PUBLIC KEY", body: $e.toDer(Je.publicKeyToAsn1(Ct)).getBytes() };
      return Ke.pem.encode(It, { maxline: ht });
    }, Je.publicKeyToRSAPublicKeyPem = function(Ct, ht) {
      var It = { type: "RSA PUBLIC KEY", body: $e.toDer(Je.publicKeyToRSAPublicKey(Ct)).getBytes() };
      return Ke.pem.encode(It, { maxline: ht });
    }, Je.getPublicKeyFingerprint = function(Ct, ht) {
      var It, vt = (ht = ht || {}).md || Ke.md.sha1.create();
      switch (ht.type || "RSAPublicKey") {
        case "RSAPublicKey":
          It = $e.toDer(Je.publicKeyToRSAPublicKey(Ct)).getBytes();
          break;
        case "SubjectPublicKeyInfo":
          It = $e.toDer(Je.publicKeyToAsn1(Ct)).getBytes();
          break;
        default:
          throw new Error('Unknown fingerprint type "' + ht.type + '".');
      }
      vt.start(), vt.update(It);
      var Et = vt.digest();
      if (ht.encoding === "hex") {
        var bt = Et.toHex();
        return ht.delimiter ? bt.match(/.{2}/g).join(ht.delimiter) : bt;
      }
      if (ht.encoding === "binary") return Et.getBytes();
      if (ht.encoding) throw new Error('Unknown encoding "' + ht.encoding + '".');
      return Et;
    }, Je.certificationRequestFromPem = function(Ct, ht, It) {
      var vt = Ke.pem.decode(Ct)[0];
      if (vt.type !== "CERTIFICATE REQUEST") {
        var Et = new Error('Could not convert certification request from PEM; PEM header type is not "CERTIFICATE REQUEST".');
        throw Et.headerType = vt.type, Et;
      }
      if (vt.procType && vt.procType.type === "ENCRYPTED") throw new Error("Could not convert certification request from PEM; PEM is encrypted.");
      var bt = $e.fromDer(vt.body, It);
      return Je.certificationRequestFromAsn1(bt, ht);
    }, Je.certificationRequestToPem = function(Ct, ht) {
      var It = { type: "CERTIFICATE REQUEST", body: $e.toDer(Je.certificationRequestToAsn1(Ct)).getBytes() };
      return Ke.pem.encode(It, { maxline: ht });
    }, Je.createCertificate = function() {
      var Ct = { version: 2, serialNumber: "00", signatureOid: null, signature: null, siginfo: {} };
      return Ct.siginfo.algorithmOid = null, Ct.validity = {}, Ct.validity.notBefore = /* @__PURE__ */ new Date(), Ct.validity.notAfter = /* @__PURE__ */ new Date(), Ct.issuer = {}, Ct.issuer.getField = function(ht) {
        return at(Ct.issuer, ht);
      }, Ct.issuer.addField = function(ht) {
        At([ht]), Ct.issuer.attributes.push(ht);
      }, Ct.issuer.attributes = [], Ct.issuer.hash = null, Ct.subject = {}, Ct.subject.getField = function(ht) {
        return at(Ct.subject, ht);
      }, Ct.subject.addField = function(ht) {
        At([ht]), Ct.subject.attributes.push(ht);
      }, Ct.subject.attributes = [], Ct.subject.hash = null, Ct.extensions = [], Ct.publicKey = null, Ct.md = null, Ct.setSubject = function(ht, It) {
        At(ht), Ct.subject.attributes = ht, delete Ct.subject.uniqueId, It && (Ct.subject.uniqueId = It), Ct.subject.hash = null;
      }, Ct.setIssuer = function(ht, It) {
        At(ht), Ct.issuer.attributes = ht, delete Ct.issuer.uniqueId, It && (Ct.issuer.uniqueId = It), Ct.issuer.hash = null;
      }, Ct.setExtensions = function(ht) {
        for (var It = 0; It < ht.length; ++It) pt(ht[It], { cert: Ct });
        Ct.extensions = ht;
      }, Ct.getExtension = function(ht) {
        typeof ht == "string" && (ht = { name: ht });
        for (var It, vt = null, Et = 0; vt === null && Et < Ct.extensions.length; ++Et) It = Ct.extensions[Et], (ht.id && It.id === ht.id || ht.name && It.name === ht.name) && (vt = It);
        return vt;
      }, Ct.sign = function(ht, It) {
        Ct.md = It || Ke.md.sha1.create();
        var vt = Ze[Ct.md.algorithm + "WithRSAEncryption"];
        if (!vt) {
          var Et = new Error("Could not compute certificate digest. Unknown message digest algorithm OID.");
          throw Et.algorithm = Ct.md.algorithm, Et;
        }
        Ct.signatureOid = Ct.siginfo.algorithmOid = vt, Ct.tbsCertificate = Je.getTBSCertificate(Ct);
        var bt = $e.toDer(Ct.tbsCertificate);
        Ct.md.update(bt.getBytes()), Ct.signature = ht.sign(Ct.md);
      }, Ct.verify = function(ht) {
        var It = !1;
        if (!Ct.issued(ht)) {
          var vt = ht.issuer, Et = Ct.subject, bt = new Error("The parent certificate did not issue the given child certificate; the child certificate's issuer does not match the parent's subject.");
          throw bt.expectedIssuer = Et.attributes, bt.actualIssuer = vt.attributes, bt;
        }
        var Rt = ht.md;
        if (Rt === null) {
          Rt = ut({ signatureOid: ht.signatureOid, type: "certificate" });
          var St = ht.tbsCertificate || Je.getTBSCertificate(ht), kt = $e.toDer(St);
          Rt.update(kt.getBytes());
        }
        return Rt !== null && (It = lt({ certificate: Ct, md: Rt, signature: ht.signature })), It;
      }, Ct.isIssuer = function(ht) {
        var It = !1, vt = Ct.issuer, Et = ht.subject;
        if (vt.hash && Et.hash) It = vt.hash === Et.hash;
        else if (vt.attributes.length === Et.attributes.length) {
          var bt, Rt;
          It = !0;
          for (var St = 0; It && St < vt.attributes.length; ++St) bt = vt.attributes[St], Rt = Et.attributes[St], bt.type === Rt.type && bt.value === Rt.value || (It = !1);
        }
        return It;
      }, Ct.issued = function(ht) {
        return ht.isIssuer(Ct);
      }, Ct.generateSubjectKeyIdentifier = function() {
        return Je.getPublicKeyFingerprint(Ct.publicKey, { type: "RSAPublicKey" });
      }, Ct.verifySubjectKeyIdentifier = function() {
        for (var ht = Ze.subjectKeyIdentifier, It = 0; It < Ct.extensions.length; ++It) {
          var vt = Ct.extensions[It];
          if (vt.id === ht) {
            var Et = Ct.generateSubjectKeyIdentifier().getBytes();
            return Ke.util.hexToBytes(vt.subjectKeyIdentifier) === Et;
          }
        }
        return !1;
      }, Ct;
    }, Je.certificateFromAsn1 = function(Ct, ht) {
      var It = {}, vt = [];
      if (!$e.validate(Ct, et, It, vt)) {
        var Et = new Error("Cannot read X.509 certificate. ASN.1 object is not an X509v3 Certificate.");
        throw Et.errors = vt, Et;
      }
      if ($e.derToOid(It.publicKeyOid) !== Je.oids.rsaEncryption) throw new Error("Cannot read public key. OID is not RSA.");
      var bt = Je.createCertificate();
      bt.version = It.certVersion ? It.certVersion.charCodeAt(0) : 0;
      var Rt = Ke.util.createBuffer(It.certSerialNumber);
      bt.serialNumber = Rt.toHex(), bt.signatureOid = Ke.asn1.derToOid(It.certSignatureOid), bt.signatureParameters = st(bt.signatureOid, It.certSignatureParams, !0), bt.siginfo.algorithmOid = Ke.asn1.derToOid(It.certinfoSignatureOid), bt.siginfo.parameters = st(bt.siginfo.algorithmOid, It.certinfoSignatureParams, !1), bt.signature = It.certSignature;
      var St = [];
      if (It.certValidity1UTCTime !== void 0 && St.push($e.utcTimeToDate(It.certValidity1UTCTime)), It.certValidity2GeneralizedTime !== void 0 && St.push($e.generalizedTimeToDate(It.certValidity2GeneralizedTime)), It.certValidity3UTCTime !== void 0 && St.push($e.utcTimeToDate(It.certValidity3UTCTime)), It.certValidity4GeneralizedTime !== void 0 && St.push($e.generalizedTimeToDate(It.certValidity4GeneralizedTime)), St.length > 2) throw new Error("Cannot read notBefore/notAfter validity times; more than two times were provided in the certificate.");
      if (St.length < 2) throw new Error("Cannot read notBefore/notAfter validity times; they were not provided as either UTCTime or GeneralizedTime.");
      if (bt.validity.notBefore = St[0], bt.validity.notAfter = St[1], bt.tbsCertificate = It.tbsCertificate, ht) {
        bt.md = ut({ signatureOid: bt.signatureOid, type: "certificate" });
        var kt = $e.toDer(bt.tbsCertificate);
        bt.md.update(kt.getBytes());
      }
      var jt = Ke.md.sha1.create(), Pt = $e.toDer(It.certIssuer);
      jt.update(Pt.getBytes()), bt.issuer.getField = function(_t) {
        return at(bt.issuer, _t);
      }, bt.issuer.addField = function(_t) {
        At([_t]), bt.issuer.attributes.push(_t);
      }, bt.issuer.attributes = Je.RDNAttributesAsArray(It.certIssuer), It.certIssuerUniqueId && (bt.issuer.uniqueId = It.certIssuerUniqueId), bt.issuer.hash = jt.digest().toHex();
      var Qt = Ke.md.sha1.create(), qt = $e.toDer(It.certSubject);
      return Qt.update(qt.getBytes()), bt.subject.getField = function(_t) {
        return at(bt.subject, _t);
      }, bt.subject.addField = function(_t) {
        At([_t]), bt.subject.attributes.push(_t);
      }, bt.subject.attributes = Je.RDNAttributesAsArray(It.certSubject), It.certSubjectUniqueId && (bt.subject.uniqueId = It.certSubjectUniqueId), bt.subject.hash = Qt.digest().toHex(), It.certExtensions ? bt.extensions = Je.certificateExtensionsFromAsn1(It.certExtensions) : bt.extensions = [], bt.publicKey = Je.publicKeyFromAsn1(It.subjectPublicKeyInfo), bt;
    }, Je.certificateExtensionsFromAsn1 = function(Ct) {
      for (var ht = [], It = 0; It < Ct.value.length; ++It) for (var vt = Ct.value[It], Et = 0; Et < vt.value.length; ++Et) ht.push(Je.certificateExtensionFromAsn1(vt.value[Et]));
      return ht;
    }, Je.certificateExtensionFromAsn1 = function(Ct) {
      var ht = {};
      if (ht.id = $e.derToOid(Ct.value[0].value), ht.critical = !1, Ct.value[1].type === $e.Type.BOOLEAN ? (ht.critical = Ct.value[1].value.charCodeAt(0) !== 0, ht.value = Ct.value[2].value) : ht.value = Ct.value[1].value, ht.id in Ze) if (ht.name = Ze[ht.id], ht.name === "keyUsage") {
        var It = 0, vt = 0;
        (bt = $e.fromDer(ht.value)).value.length > 1 && (It = bt.value.charCodeAt(1), vt = bt.value.length > 2 ? bt.value.charCodeAt(2) : 0), ht.digitalSignature = (128 & It) == 128, ht.nonRepudiation = (64 & It) == 64, ht.keyEncipherment = (32 & It) == 32, ht.dataEncipherment = (16 & It) == 16, ht.keyAgreement = (8 & It) == 8, ht.keyCertSign = (4 & It) == 4, ht.cRLSign = (2 & It) == 2, ht.encipherOnly = (1 & It) == 1, ht.decipherOnly = (128 & vt) == 128;
      } else if (ht.name === "basicConstraints") {
        (bt = $e.fromDer(ht.value)).value.length > 0 && bt.value[0].type === $e.Type.BOOLEAN ? ht.cA = bt.value[0].value.charCodeAt(0) !== 0 : ht.cA = !1;
        var Et = null;
        bt.value.length > 0 && bt.value[0].type === $e.Type.INTEGER ? Et = bt.value[0].value : bt.value.length > 1 && (Et = bt.value[1].value), Et !== null && (ht.pathLenConstraint = $e.derToInteger(Et));
      } else if (ht.name === "extKeyUsage") for (var bt = $e.fromDer(ht.value), Rt = 0; Rt < bt.value.length; ++Rt) {
        var St = $e.derToOid(bt.value[Rt].value);
        St in Ze ? ht[Ze[St]] = !0 : ht[St] = !0;
      }
      else if (ht.name === "nsCertType") It = 0, (bt = $e.fromDer(ht.value)).value.length > 1 && (It = bt.value.charCodeAt(1)), ht.client = (128 & It) == 128, ht.server = (64 & It) == 64, ht.email = (32 & It) == 32, ht.objsign = (16 & It) == 16, ht.reserved = (8 & It) == 8, ht.sslCA = (4 & It) == 4, ht.emailCA = (2 & It) == 2, ht.objCA = (1 & It) == 1;
      else if (ht.name === "subjectAltName" || ht.name === "issuerAltName") {
        var kt;
        ht.altNames = [], bt = $e.fromDer(ht.value);
        for (var jt = 0; jt < bt.value.length; ++jt) {
          var Pt = { type: (kt = bt.value[jt]).type, value: kt.value };
          switch (ht.altNames.push(Pt), kt.type) {
            case 1:
            case 2:
            case 6:
              break;
            case 7:
              Pt.ip = Ke.util.bytesToIP(kt.value);
              break;
            case 8:
              Pt.oid = $e.derToOid(kt.value);
          }
        }
      } else ht.name === "subjectKeyIdentifier" && (bt = $e.fromDer(ht.value), ht.subjectKeyIdentifier = Ke.util.bytesToHex(bt.value));
      return ht;
    }, Je.certificationRequestFromAsn1 = function(Ct, ht) {
      var It = {}, vt = [];
      if (!$e.validate(Ct, ot, It, vt)) {
        var Et = new Error("Cannot read PKCS#10 certificate request. ASN.1 object is not a PKCS#10 CertificationRequest.");
        throw Et.errors = vt, Et;
      }
      if ($e.derToOid(It.publicKeyOid) !== Je.oids.rsaEncryption) throw new Error("Cannot read public key. OID is not RSA.");
      var bt = Je.createCertificationRequest();
      if (bt.version = It.csrVersion ? It.csrVersion.charCodeAt(0) : 0, bt.signatureOid = Ke.asn1.derToOid(It.csrSignatureOid), bt.signatureParameters = st(bt.signatureOid, It.csrSignatureParams, !0), bt.siginfo.algorithmOid = Ke.asn1.derToOid(It.csrSignatureOid), bt.siginfo.parameters = st(bt.siginfo.algorithmOid, It.csrSignatureParams, !1), bt.signature = It.csrSignature, bt.certificationRequestInfo = It.certificationRequestInfo, ht) {
        bt.md = ut({ signatureOid: bt.signatureOid, type: "certification request" });
        var Rt = $e.toDer(bt.certificationRequestInfo);
        bt.md.update(Rt.getBytes());
      }
      var St = Ke.md.sha1.create();
      return bt.subject.getField = function(kt) {
        return at(bt.subject, kt);
      }, bt.subject.addField = function(kt) {
        At([kt]), bt.subject.attributes.push(kt);
      }, bt.subject.attributes = Je.RDNAttributesAsArray(It.certificationRequestInfoSubject, St), bt.subject.hash = St.digest().toHex(), bt.publicKey = Je.publicKeyFromAsn1(It.subjectPublicKeyInfo), bt.getAttribute = function(kt) {
        return at(bt, kt);
      }, bt.addAttribute = function(kt) {
        At([kt]), bt.attributes.push(kt);
      }, bt.attributes = Je.CRIAttributesAsArray(It.certificationRequestInfoAttributes || []), bt;
    }, Je.createCertificationRequest = function() {
      var Ct = { version: 0, signatureOid: null, signature: null, siginfo: {} };
      return Ct.siginfo.algorithmOid = null, Ct.subject = {}, Ct.subject.getField = function(ht) {
        return at(Ct.subject, ht);
      }, Ct.subject.addField = function(ht) {
        At([ht]), Ct.subject.attributes.push(ht);
      }, Ct.subject.attributes = [], Ct.subject.hash = null, Ct.publicKey = null, Ct.attributes = [], Ct.getAttribute = function(ht) {
        return at(Ct, ht);
      }, Ct.addAttribute = function(ht) {
        At([ht]), Ct.attributes.push(ht);
      }, Ct.md = null, Ct.setSubject = function(ht) {
        At(ht), Ct.subject.attributes = ht, Ct.subject.hash = null;
      }, Ct.setAttributes = function(ht) {
        At(ht), Ct.attributes = ht;
      }, Ct.sign = function(ht, It) {
        Ct.md = It || Ke.md.sha1.create();
        var vt = Ze[Ct.md.algorithm + "WithRSAEncryption"];
        if (!vt) {
          var Et = new Error("Could not compute certification request digest. Unknown message digest algorithm OID.");
          throw Et.algorithm = Ct.md.algorithm, Et;
        }
        Ct.signatureOid = Ct.siginfo.algorithmOid = vt, Ct.certificationRequestInfo = Je.getCertificationRequestInfo(Ct);
        var bt = $e.toDer(Ct.certificationRequestInfo);
        Ct.md.update(bt.getBytes()), Ct.signature = ht.sign(Ct.md);
      }, Ct.verify = function() {
        var ht = !1, It = Ct.md;
        if (It === null) {
          It = ut({ signatureOid: Ct.signatureOid, type: "certification request" });
          var vt = Ct.certificationRequestInfo || Je.getCertificationRequestInfo(Ct), Et = $e.toDer(vt);
          It.update(Et.getBytes());
        }
        return It !== null && (ht = lt({ certificate: Ct, md: It, signature: Ct.signature })), ht;
      }, Ct;
    };
    var Bt = /* @__PURE__ */ new Date("1950-01-01T00:00:00Z"), Tt = /* @__PURE__ */ new Date("2050-01-01T00:00:00Z");
    function yt(Ct) {
      return Ct >= Bt && Ct < Tt ? $e.create($e.Class.UNIVERSAL, $e.Type.UTCTIME, !1, $e.dateToUtcTime(Ct)) : $e.create($e.Class.UNIVERSAL, $e.Type.GENERALIZEDTIME, !1, $e.dateToGeneralizedTime(Ct));
    }
    Je.getTBSCertificate = function(Ct) {
      var ht = yt(Ct.validity.notBefore), It = yt(Ct.validity.notAfter), vt = $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.CONTEXT_SPECIFIC, 0, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.INTEGER, !1, $e.integerToDer(Ct.version).getBytes())]), $e.create($e.Class.UNIVERSAL, $e.Type.INTEGER, !1, Ke.util.hexToBytes(Ct.serialNumber)), $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(Ct.siginfo.algorithmOid).getBytes()), gt(Ct.siginfo.algorithmOid, Ct.siginfo.parameters)]), dt(Ct.issuer), $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [ht, It]), dt(Ct.subject), Je.publicKeyToAsn1(Ct.publicKey)]);
      return Ct.issuer.uniqueId && vt.value.push($e.create($e.Class.CONTEXT_SPECIFIC, 1, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.BITSTRING, !1, "\0" + Ct.issuer.uniqueId)])), Ct.subject.uniqueId && vt.value.push($e.create($e.Class.CONTEXT_SPECIFIC, 2, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.BITSTRING, !1, "\0" + Ct.subject.uniqueId)])), Ct.extensions.length > 0 && vt.value.push(Je.certificateExtensionsToAsn1(Ct.extensions)), vt;
    }, Je.getCertificationRequestInfo = function(Ct) {
      return $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.INTEGER, !1, $e.integerToDer(Ct.version).getBytes()), dt(Ct.subject), Je.publicKeyToAsn1(Ct.publicKey), wt(Ct)]);
    }, Je.distinguishedNameToAsn1 = function(Ct) {
      return dt(Ct);
    }, Je.certificateToAsn1 = function(Ct) {
      var ht = Ct.tbsCertificate || Je.getTBSCertificate(Ct);
      return $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [ht, $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(Ct.signatureOid).getBytes()), gt(Ct.signatureOid, Ct.signatureParameters)]), $e.create($e.Class.UNIVERSAL, $e.Type.BITSTRING, !1, "\0" + Ct.signature)]);
    }, Je.certificateExtensionsToAsn1 = function(Ct) {
      var ht = $e.create($e.Class.CONTEXT_SPECIFIC, 3, !0, []), It = $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, []);
      ht.value.push(It);
      for (var vt = 0; vt < Ct.length; ++vt) It.value.push(Je.certificateExtensionToAsn1(Ct[vt]));
      return ht;
    }, Je.certificateExtensionToAsn1 = function(Ct) {
      var ht = $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, []);
      ht.value.push($e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(Ct.id).getBytes())), Ct.critical && ht.value.push($e.create($e.Class.UNIVERSAL, $e.Type.BOOLEAN, !1, "ÿ"));
      var It = Ct.value;
      return typeof Ct.value != "string" && (It = $e.toDer(It).getBytes()), ht.value.push($e.create($e.Class.UNIVERSAL, $e.Type.OCTETSTRING, !1, It)), ht;
    }, Je.certificationRequestToAsn1 = function(Ct) {
      var ht = Ct.certificationRequestInfo || Je.getCertificationRequestInfo(Ct);
      return $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [ht, $e.create($e.Class.UNIVERSAL, $e.Type.SEQUENCE, !0, [$e.create($e.Class.UNIVERSAL, $e.Type.OID, !1, $e.oidToDer(Ct.signatureOid).getBytes()), gt(Ct.signatureOid, Ct.signatureParameters)]), $e.create($e.Class.UNIVERSAL, $e.Type.BITSTRING, !1, "\0" + Ct.signature)]);
    }, Je.createCaStore = function(Ct) {
      var ht = { certs: {} };
      function It(Rt) {
        return vt(Rt), ht.certs[Rt.hash] || null;
      }
      function vt(Rt) {
        if (!Rt.hash) {
          var St = Ke.md.sha1.create();
          Rt.attributes = Je.RDNAttributesAsArray(dt(Rt), St), Rt.hash = St.digest().toHex();
        }
      }
      if (ht.getIssuer = function(Rt) {
        return It(Rt.issuer);
      }, ht.addCertificate = function(Rt) {
        if (typeof Rt == "string" && (Rt = Ke.pki.certificateFromPem(Rt)), vt(Rt.subject), !ht.hasCertificate(Rt)) if (Rt.subject.hash in ht.certs) {
          var St = ht.certs[Rt.subject.hash];
          Ke.util.isArray(St) || (St = [St]), St.push(Rt), ht.certs[Rt.subject.hash] = St;
        } else ht.certs[Rt.subject.hash] = Rt;
      }, ht.hasCertificate = function(Rt) {
        typeof Rt == "string" && (Rt = Ke.pki.certificateFromPem(Rt));
        var St = It(Rt.subject);
        if (!St) return !1;
        Ke.util.isArray(St) || (St = [St]);
        for (var kt = $e.toDer(Je.certificateToAsn1(Rt)).getBytes(), jt = 0; jt < St.length; ++jt) if (kt === $e.toDer(Je.certificateToAsn1(St[jt])).getBytes()) return !0;
        return !1;
      }, ht.listAllCertificates = function() {
        var Rt = [];
        for (var St in ht.certs) if (ht.certs.hasOwnProperty(St)) {
          var kt = ht.certs[St];
          if (Ke.util.isArray(kt)) for (var jt = 0; jt < kt.length; ++jt) Rt.push(kt[jt]);
          else Rt.push(kt);
        }
        return Rt;
      }, ht.removeCertificate = function(Rt) {
        var St;
        if (typeof Rt == "string" && (Rt = Ke.pki.certificateFromPem(Rt)), vt(Rt.subject), !ht.hasCertificate(Rt)) return null;
        var kt = It(Rt.subject);
        if (!Ke.util.isArray(kt)) return St = ht.certs[Rt.subject.hash], delete ht.certs[Rt.subject.hash], St;
        for (var jt = $e.toDer(Je.certificateToAsn1(Rt)).getBytes(), Pt = 0; Pt < kt.length; ++Pt) jt === $e.toDer(Je.certificateToAsn1(kt[Pt])).getBytes() && (St = kt[Pt], kt.splice(Pt, 1));
        return kt.length === 0 && delete ht.certs[Rt.subject.hash], St;
      }, Ct) for (var Et = 0; Et < Ct.length; ++Et) {
        var bt = Ct[Et];
        ht.addCertificate(bt);
      }
      return ht;
    }, Je.certificateError = { bad_certificate: "forge.pki.BadCertificate", unsupported_certificate: "forge.pki.UnsupportedCertificate", certificate_revoked: "forge.pki.CertificateRevoked", certificate_expired: "forge.pki.CertificateExpired", certificate_unknown: "forge.pki.CertificateUnknown", unknown_ca: "forge.pki.UnknownCertificateAuthority" }, Je.verifyCertificateChain = function(Ct, ht, It) {
      typeof It == "function" && (It = { verify: It }), It = It || {};
      var vt = (ht = ht.slice(0)).slice(0), Et = It.validityCheckDate;
      Et === void 0 && (Et = /* @__PURE__ */ new Date());
      var bt = !0, Rt = null, St = 0;
      do {
        var kt = ht.shift(), jt = null, Pt = !1;
        if (Et && (Et < kt.validity.notBefore || Et > kt.validity.notAfter) && (Rt = { message: "Certificate is not valid yet or has expired.", error: Je.certificateError.certificate_expired, notBefore: kt.validity.notBefore, notAfter: kt.validity.notAfter, now: Et }), Rt === null) {
          if ((jt = ht[0] || Ct.getIssuer(kt)) === null && kt.isIssuer(kt) && (Pt = !0, jt = kt), jt) {
            var Qt = jt;
            Ke.util.isArray(Qt) || (Qt = [Qt]);
            for (var qt = !1; !qt && Qt.length > 0; ) {
              jt = Qt.shift();
              try {
                qt = jt.verify(kt);
              } catch {
              }
            }
            qt || (Rt = { message: "Certificate signature is invalid.", error: Je.certificateError.bad_certificate });
          }
          Rt !== null || jt && !Pt || Ct.hasCertificate(kt) || (Rt = { message: "Certificate is not trusted.", error: Je.certificateError.unknown_ca });
        }
        if (Rt === null && jt && !kt.isIssuer(jt) && (Rt = { message: "Certificate issuer is invalid.", error: Je.certificateError.bad_certificate }), Rt === null) for (var _t = { keyUsage: !0, basicConstraints: !0 }, Yt = 0; Rt === null && Yt < kt.extensions.length; ++Yt) {
          var Xt = kt.extensions[Yt];
          Xt.critical && !(Xt.name in _t) && (Rt = { message: "Certificate has an unsupported critical extension.", error: Je.certificateError.unsupported_certificate });
        }
        if (Rt === null && (!bt || ht.length === 0 && (!jt || Pt))) {
          var Ut = kt.getExtension("basicConstraints"), Lt = kt.getExtension("keyUsage");
          Lt !== null && (Lt.keyCertSign && Ut !== null || (Rt = { message: "Certificate keyUsage or basicConstraints conflict or indicate that the certificate is not a CA. If the certificate is the only one in the chain or isn't the first then the certificate must be a valid CA.", error: Je.certificateError.bad_certificate })), Rt !== null || Ut === null || Ut.cA || (Rt = { message: "Certificate basicConstraints indicates the certificate is not a CA.", error: Je.certificateError.bad_certificate }), Rt === null && Lt !== null && "pathLenConstraint" in Ut && St - 1 > Ut.pathLenConstraint && (Rt = { message: "Certificate basicConstraints pathLenConstraint violated.", error: Je.certificateError.bad_certificate });
        }
        var Ot = Rt === null || Rt.error, ft = It.verify ? It.verify(Ot, St, vt) : Ot;
        if (ft !== !0) throw Ot === !0 && (Rt = { message: "The application rejected the certificate.", error: Je.certificateError.bad_certificate }), (ft || ft === 0) && (typeof ft != "object" || Ke.util.isArray(ft) ? typeof ft == "string" && (Rt.error = ft) : (ft.message && (Rt.message = ft.message), ft.error && (Rt.error = ft.error))), Rt;
        Rt = null, bt = !1, ++St;
      } while (ht.length > 0);
      return !0;
    };
  }, 4406: (He) => {
    var Ge, Xe, Ke = He.exports = {};
    function $e() {
      throw new Error("setTimeout has not been defined");
    }
    function Je() {
      throw new Error("clearTimeout has not been defined");
    }
    function Ze(ut) {
      if (Ge === setTimeout) return setTimeout(ut, 0);
      if ((Ge === $e || !Ge) && setTimeout) return Ge = setTimeout, setTimeout(ut, 0);
      try {
        return Ge(ut, 0);
      } catch {
        try {
          return Ge.call(null, ut, 0);
        } catch {
          return Ge.call(this, ut, 0);
        }
      }
    }
    (function() {
      try {
        Ge = typeof setTimeout == "function" ? setTimeout : $e;
      } catch {
        Ge = $e;
      }
      try {
        Xe = typeof clearTimeout == "function" ? clearTimeout : Je;
      } catch {
        Xe = Je;
      }
    })();
    var nt, tt = [], et = !1, rt = -1;
    function it() {
      et && nt && (et = !1, nt.length ? tt = nt.concat(tt) : rt = -1, tt.length && ot());
    }
    function ot() {
      if (!et) {
        var ut = Ze(it);
        et = !0;
        for (var lt = tt.length; lt; ) {
          for (nt = tt, tt = []; ++rt < lt; ) nt && nt[rt].run();
          rt = -1, lt = tt.length;
        }
        nt = null, et = !1, function(dt) {
          if (Xe === clearTimeout) return clearTimeout(dt);
          if ((Xe === Je || !Xe) && clearTimeout) return Xe = clearTimeout, clearTimeout(dt);
          try {
            Xe(dt);
          } catch {
            try {
              return Xe.call(null, dt);
            } catch {
              return Xe.call(this, dt);
            }
          }
        }(ut);
      }
    }
    function at(ut, lt) {
      this.fun = ut, this.array = lt;
    }
    function st() {
    }
    Ke.nextTick = function(ut) {
      var lt = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var dt = 1; dt < arguments.length; dt++) lt[dt - 1] = arguments[dt];
      tt.push(new at(ut, lt)), tt.length !== 1 || et || Ze(ot);
    }, at.prototype.run = function() {
      this.fun.apply(null, this.array);
    }, Ke.title = "browser", Ke.browser = !0, Ke.env = {}, Ke.argv = [], Ke.version = "", Ke.versions = {}, Ke.on = st, Ke.addListener = st, Ke.once = st, Ke.off = st, Ke.removeListener = st, Ke.removeAllListeners = st, Ke.emit = st, Ke.prependListener = st, Ke.prependOnceListener = st, Ke.listeners = function(ut) {
      return [];
    }, Ke.binding = function(ut) {
      throw new Error("process.binding is not supported");
    }, Ke.cwd = function() {
      return "/";
    }, Ke.chdir = function(ut) {
      throw new Error("process.chdir is not supported");
    }, Ke.umask = function() {
      return 0;
    };
  }, 4452: (He) => {
    var Ge = {};
    function Xe($e, Je, Ze) {
      Ze || (Ze = Error);
      var nt = function(tt) {
        var et, rt;
        function it(ot, at, st) {
          return tt.call(this, function(ut, lt, dt) {
            return typeof Je == "string" ? Je : Je(ut, lt, dt);
          }(ot, at, st)) || this;
        }
        return rt = tt, (et = it).prototype = Object.create(rt.prototype), et.prototype.constructor = et, et.__proto__ = rt, it;
      }(Ze);
      nt.prototype.name = Ze.name, nt.prototype.code = $e, Ge[$e] = nt;
    }
    function Ke($e, Je) {
      if (Array.isArray($e)) {
        var Ze = $e.length;
        return $e = $e.map(function(nt) {
          return String(nt);
        }), Ze > 2 ? "one of ".concat(Je, " ").concat($e.slice(0, Ze - 1).join(", "), ", or ") + $e[Ze - 1] : Ze === 2 ? "one of ".concat(Je, " ").concat($e[0], " or ").concat($e[1]) : "of ".concat(Je, " ").concat($e[0]);
      }
      return "of ".concat(Je, " ").concat(String($e));
    }
    Xe("ERR_INVALID_OPT_VALUE", function($e, Je) {
      return 'The value "' + Je + '" is invalid for option "' + $e + '"';
    }, TypeError), Xe("ERR_INVALID_ARG_TYPE", function($e, Je, Ze) {
      var nt, tt, et, rt, it;
      if (typeof Je == "string" && (tt = "not ", Je.substr(0, tt.length) === tt) ? (nt = "must not be", Je = Je.replace(/^not /, "")) : nt = "must be", function(at, st, ut) {
        return (ut === void 0 || ut > at.length) && (ut = at.length), at.substring(ut - st.length, ut) === st;
      }($e, " argument")) et = "The ".concat($e, " ").concat(nt, " ").concat(Ke(Je, "type"));
      else {
        var ot = (typeof it != "number" && (it = 0), it + 1 > (rt = $e).length || rt.indexOf(".", it) === -1 ? "argument" : "property");
        et = 'The "'.concat($e, '" ').concat(ot, " ").concat(nt, " ").concat(Ke(Je, "type"));
      }
      return et + ". Received type ".concat(typeof Ze);
    }, TypeError), Xe("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), Xe("ERR_METHOD_NOT_IMPLEMENTED", function($e) {
      return "The " + $e + " method is not implemented";
    }), Xe("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), Xe("ERR_STREAM_DESTROYED", function($e) {
      return "Cannot call " + $e + " after a stream was destroyed";
    }), Xe("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), Xe("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), Xe("ERR_STREAM_WRITE_AFTER_END", "write after end"), Xe("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), Xe("ERR_UNKNOWN_ENCODING", function($e) {
      return "Unknown encoding: " + $e;
    }, TypeError), Xe("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), He.exports.q = Ge;
  }, 7073: (He, Ge, Xe) => {
    var Ke = Object.keys || function(ot) {
      var at = [];
      for (var st in ot) at.push(st);
      return at;
    };
    He.exports = et;
    var $e = Xe(8051), Je = Xe(2557);
    Xe(1285)(et, $e);
    for (var Ze = Ke(Je.prototype), nt = 0; nt < Ze.length; nt++) {
      var tt = Ze[nt];
      et.prototype[tt] || (et.prototype[tt] = Je.prototype[tt]);
    }
    function et(ot) {
      if (!(this instanceof et)) return new et(ot);
      $e.call(this, ot), Je.call(this, ot), this.allowHalfOpen = !0, ot && (ot.readable === !1 && (this.readable = !1), ot.writable === !1 && (this.writable = !1), ot.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", rt)));
    }
    function rt() {
      this._writableState.ended || process.nextTick(it, this);
    }
    function it(ot) {
      ot.end();
    }
    Object.defineProperty(et.prototype, "writableHighWaterMark", { enumerable: !1, get: function() {
      return this._writableState.highWaterMark;
    } }), Object.defineProperty(et.prototype, "writableBuffer", { enumerable: !1, get: function() {
      return this._writableState && this._writableState.getBuffer();
    } }), Object.defineProperty(et.prototype, "writableLength", { enumerable: !1, get: function() {
      return this._writableState.length;
    } }), Object.defineProperty(et.prototype, "destroyed", { enumerable: !1, get: function() {
      return this._readableState !== void 0 && this._writableState !== void 0 && this._readableState.destroyed && this._writableState.destroyed;
    }, set: function(ot) {
      this._readableState !== void 0 && this._writableState !== void 0 && (this._readableState.destroyed = ot, this._writableState.destroyed = ot);
    } });
  }, 5163: (He, Ge, Xe) => {
    He.exports = $e;
    var Ke = Xe(7640);
    function $e(Je) {
      if (!(this instanceof $e)) return new $e(Je);
      Ke.call(this, Je);
    }
    Xe(1285)($e, Ke), $e.prototype._transform = function(Je, Ze, nt) {
      nt(null, Je);
    };
  }, 8051: (He, Ge, Xe) => {
    var Ke;
    He.exports = yt, yt.ReadableState = Tt, Xe(2699).EventEmitter;
    var $e, Je = function(Ut, Lt) {
      return Ut.listeners(Lt).length;
    }, Ze = Xe(5010), nt = Xe(8834).Buffer, tt = Xe.g.Uint8Array || function() {
    }, et = Xe(6602);
    $e = et && et.debuglog ? et.debuglog("stream") : function() {
    };
    var rt, it, ot, at = Xe(6637), st = Xe(2262), ut = Xe(7605).getHighWaterMark, lt = Xe(4452).q, dt = lt.ERR_INVALID_ARG_TYPE, At = lt.ERR_STREAM_PUSH_AFTER_EOF, pt = lt.ERR_METHOD_NOT_IMPLEMENTED, gt = lt.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
    Xe(1285)(yt, Ze);
    var wt = st.errorOrDestroy, Bt = ["error", "close", "destroy", "pause", "resume"];
    function Tt(Ut, Lt, Ot) {
      Ke = Ke || Xe(7073), Ut = Ut || {}, typeof Ot != "boolean" && (Ot = Lt instanceof Ke), this.objectMode = !!Ut.objectMode, Ot && (this.objectMode = this.objectMode || !!Ut.readableObjectMode), this.highWaterMark = ut(this, Ut, "readableHighWaterMark", Ot), this.buffer = new at(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = Ut.emitClose !== !1, this.autoDestroy = !!Ut.autoDestroy, this.destroyed = !1, this.defaultEncoding = Ut.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, Ut.encoding && (rt || (rt = Xe(214).s), this.decoder = new rt(Ut.encoding), this.encoding = Ut.encoding);
    }
    function yt(Ut) {
      if (Ke = Ke || Xe(7073), !(this instanceof yt)) return new yt(Ut);
      var Lt = this instanceof Ke;
      this._readableState = new Tt(Ut, this, Lt), this.readable = !0, Ut && (typeof Ut.read == "function" && (this._read = Ut.read), typeof Ut.destroy == "function" && (this._destroy = Ut.destroy)), Ze.call(this);
    }
    function Ct(Ut, Lt, Ot, ft, Dt) {
      $e("readableAddChunk", Lt);
      var Mt, Ft = Ut._readableState;
      if (Lt === null) Ft.reading = !1, function(Gt, zt) {
        if ($e("onEofChunk"), !zt.ended) {
          if (zt.decoder) {
            var $t = zt.decoder.end();
            $t && $t.length && (zt.buffer.push($t), zt.length += zt.objectMode ? 1 : $t.length);
          }
          zt.ended = !0, zt.sync ? Et(Gt) : (zt.needReadable = !1, zt.emittedReadable || (zt.emittedReadable = !0, bt(Gt)));
        }
      }(Ut, Ft);
      else if (Dt || (Mt = function(Gt, zt) {
        var $t, Ht;
        return Ht = zt, nt.isBuffer(Ht) || Ht instanceof tt || typeof zt == "string" || zt === void 0 || Gt.objectMode || ($t = new dt("chunk", ["string", "Buffer", "Uint8Array"], zt)), $t;
      }(Ft, Lt)), Mt) wt(Ut, Mt);
      else if (Ft.objectMode || Lt && Lt.length > 0) if (typeof Lt == "string" || Ft.objectMode || Object.getPrototypeOf(Lt) === nt.prototype || (Lt = function(Gt) {
        return nt.from(Gt);
      }(Lt)), ft) Ft.endEmitted ? wt(Ut, new gt()) : ht(Ut, Ft, Lt, !0);
      else if (Ft.ended) wt(Ut, new At());
      else {
        if (Ft.destroyed) return !1;
        Ft.reading = !1, Ft.decoder && !Ot ? (Lt = Ft.decoder.write(Lt), Ft.objectMode || Lt.length !== 0 ? ht(Ut, Ft, Lt, !1) : Rt(Ut, Ft)) : ht(Ut, Ft, Lt, !1);
      }
      else ft || (Ft.reading = !1, Rt(Ut, Ft));
      return !Ft.ended && (Ft.length < Ft.highWaterMark || Ft.length === 0);
    }
    function ht(Ut, Lt, Ot, ft) {
      Lt.flowing && Lt.length === 0 && !Lt.sync ? (Lt.awaitDrain = 0, Ut.emit("data", Ot)) : (Lt.length += Lt.objectMode ? 1 : Ot.length, ft ? Lt.buffer.unshift(Ot) : Lt.buffer.push(Ot), Lt.needReadable && Et(Ut)), Rt(Ut, Lt);
    }
    Object.defineProperty(yt.prototype, "destroyed", { enumerable: !1, get: function() {
      return this._readableState !== void 0 && this._readableState.destroyed;
    }, set: function(Ut) {
      this._readableState && (this._readableState.destroyed = Ut);
    } }), yt.prototype.destroy = st.destroy, yt.prototype._undestroy = st.undestroy, yt.prototype._destroy = function(Ut, Lt) {
      Lt(Ut);
    }, yt.prototype.push = function(Ut, Lt) {
      var Ot, ft = this._readableState;
      return ft.objectMode ? Ot = !0 : typeof Ut == "string" && ((Lt = Lt || ft.defaultEncoding) !== ft.encoding && (Ut = nt.from(Ut, Lt), Lt = ""), Ot = !0), Ct(this, Ut, Lt, !1, Ot);
    }, yt.prototype.unshift = function(Ut) {
      return Ct(this, Ut, null, !0, !1);
    }, yt.prototype.isPaused = function() {
      return this._readableState.flowing === !1;
    }, yt.prototype.setEncoding = function(Ut) {
      rt || (rt = Xe(214).s);
      var Lt = new rt(Ut);
      this._readableState.decoder = Lt, this._readableState.encoding = this._readableState.decoder.encoding;
      for (var Ot = this._readableState.buffer.head, ft = ""; Ot !== null; ) ft += Lt.write(Ot.data), Ot = Ot.next;
      return this._readableState.buffer.clear(), ft !== "" && this._readableState.buffer.push(ft), this._readableState.length = ft.length, this;
    };
    var It = 1073741824;
    function vt(Ut, Lt) {
      return Ut <= 0 || Lt.length === 0 && Lt.ended ? 0 : Lt.objectMode ? 1 : Ut != Ut ? Lt.flowing && Lt.length ? Lt.buffer.head.data.length : Lt.length : (Ut > Lt.highWaterMark && (Lt.highWaterMark = function(Ot) {
        return Ot >= It ? Ot = It : (Ot--, Ot |= Ot >>> 1, Ot |= Ot >>> 2, Ot |= Ot >>> 4, Ot |= Ot >>> 8, Ot |= Ot >>> 16, Ot++), Ot;
      }(Ut)), Ut <= Lt.length ? Ut : Lt.ended ? Lt.length : (Lt.needReadable = !0, 0));
    }
    function Et(Ut) {
      var Lt = Ut._readableState;
      $e("emitReadable", Lt.needReadable, Lt.emittedReadable), Lt.needReadable = !1, Lt.emittedReadable || ($e("emitReadable", Lt.flowing), Lt.emittedReadable = !0, process.nextTick(bt, Ut));
    }
    function bt(Ut) {
      var Lt = Ut._readableState;
      $e("emitReadable_", Lt.destroyed, Lt.length, Lt.ended), Lt.destroyed || !Lt.length && !Lt.ended || (Ut.emit("readable"), Lt.emittedReadable = !1), Lt.needReadable = !Lt.flowing && !Lt.ended && Lt.length <= Lt.highWaterMark, Qt(Ut);
    }
    function Rt(Ut, Lt) {
      Lt.readingMore || (Lt.readingMore = !0, process.nextTick(St, Ut, Lt));
    }
    function St(Ut, Lt) {
      for (; !Lt.reading && !Lt.ended && (Lt.length < Lt.highWaterMark || Lt.flowing && Lt.length === 0); ) {
        var Ot = Lt.length;
        if ($e("maybeReadMore read 0"), Ut.read(0), Ot === Lt.length) break;
      }
      Lt.readingMore = !1;
    }
    function kt(Ut) {
      var Lt = Ut._readableState;
      Lt.readableListening = Ut.listenerCount("readable") > 0, Lt.resumeScheduled && !Lt.paused ? Lt.flowing = !0 : Ut.listenerCount("data") > 0 && Ut.resume();
    }
    function jt(Ut) {
      $e("readable nexttick read 0"), Ut.read(0);
    }
    function Pt(Ut, Lt) {
      $e("resume", Lt.reading), Lt.reading || Ut.read(0), Lt.resumeScheduled = !1, Ut.emit("resume"), Qt(Ut), Lt.flowing && !Lt.reading && Ut.read(0);
    }
    function Qt(Ut) {
      var Lt = Ut._readableState;
      for ($e("flow", Lt.flowing); Lt.flowing && Ut.read() !== null; ) ;
    }
    function qt(Ut, Lt) {
      return Lt.length === 0 ? null : (Lt.objectMode ? Ot = Lt.buffer.shift() : !Ut || Ut >= Lt.length ? (Ot = Lt.decoder ? Lt.buffer.join("") : Lt.buffer.length === 1 ? Lt.buffer.first() : Lt.buffer.concat(Lt.length), Lt.buffer.clear()) : Ot = Lt.buffer.consume(Ut, Lt.decoder), Ot);
      var Ot;
    }
    function _t(Ut) {
      var Lt = Ut._readableState;
      $e("endReadable", Lt.endEmitted), Lt.endEmitted || (Lt.ended = !0, process.nextTick(Yt, Lt, Ut));
    }
    function Yt(Ut, Lt) {
      if ($e("endReadableNT", Ut.endEmitted, Ut.length), !Ut.endEmitted && Ut.length === 0 && (Ut.endEmitted = !0, Lt.readable = !1, Lt.emit("end"), Ut.autoDestroy)) {
        var Ot = Lt._writableState;
        (!Ot || Ot.autoDestroy && Ot.finished) && Lt.destroy();
      }
    }
    function Xt(Ut, Lt) {
      for (var Ot = 0, ft = Ut.length; Ot < ft; Ot++) if (Ut[Ot] === Lt) return Ot;
      return -1;
    }
    yt.prototype.read = function(Ut) {
      $e("read", Ut), Ut = parseInt(Ut, 10);
      var Lt = this._readableState, Ot = Ut;
      if (Ut !== 0 && (Lt.emittedReadable = !1), Ut === 0 && Lt.needReadable && ((Lt.highWaterMark !== 0 ? Lt.length >= Lt.highWaterMark : Lt.length > 0) || Lt.ended)) return $e("read: emitReadable", Lt.length, Lt.ended), Lt.length === 0 && Lt.ended ? _t(this) : Et(this), null;
      if ((Ut = vt(Ut, Lt)) === 0 && Lt.ended) return Lt.length === 0 && _t(this), null;
      var ft, Dt = Lt.needReadable;
      return $e("need readable", Dt), (Lt.length === 0 || Lt.length - Ut < Lt.highWaterMark) && $e("length less than watermark", Dt = !0), Lt.ended || Lt.reading ? $e("reading or ended", Dt = !1) : Dt && ($e("do read"), Lt.reading = !0, Lt.sync = !0, Lt.length === 0 && (Lt.needReadable = !0), this._read(Lt.highWaterMark), Lt.sync = !1, Lt.reading || (Ut = vt(Ot, Lt))), (ft = Ut > 0 ? qt(Ut, Lt) : null) === null ? (Lt.needReadable = Lt.length <= Lt.highWaterMark, Ut = 0) : (Lt.length -= Ut, Lt.awaitDrain = 0), Lt.length === 0 && (Lt.ended || (Lt.needReadable = !0), Ot !== Ut && Lt.ended && _t(this)), ft !== null && this.emit("data", ft), ft;
    }, yt.prototype._read = function(Ut) {
      wt(this, new pt("_read()"));
    }, yt.prototype.pipe = function(Ut, Lt) {
      var Ot = this, ft = this._readableState;
      switch (ft.pipesCount) {
        case 0:
          ft.pipes = Ut;
          break;
        case 1:
          ft.pipes = [ft.pipes, Ut];
          break;
        default:
          ft.pipes.push(Ut);
      }
      ft.pipesCount += 1, $e("pipe count=%d opts=%j", ft.pipesCount, Lt);
      var Dt = Lt && Lt.end === !1 || Ut === process.stdout || Ut === process.stderr ? un : Mt;
      function Mt() {
        $e("onend"), Ut.end();
      }
      ft.endEmitted ? process.nextTick(Dt) : Ot.once("end", Dt), Ut.on("unpipe", function An(mn, En) {
        $e("onunpipe"), mn === Ot && En && En.hasUnpiped === !1 && (En.hasUnpiped = !0, $e("cleanup"), Ut.removeListener("close", Ht), Ut.removeListener("finish", hn), Ut.removeListener("drain", Ft), Ut.removeListener("error", $t), Ut.removeListener("unpipe", An), Ot.removeListener("end", Mt), Ot.removeListener("end", un), Ot.removeListener("data", zt), Gt = !0, !ft.awaitDrain || Ut._writableState && !Ut._writableState.needDrain || Ft());
      });
      var Ft = /* @__PURE__ */ function(An) {
        return function() {
          var mn = An._readableState;
          $e("pipeOnDrain", mn.awaitDrain), mn.awaitDrain && mn.awaitDrain--, mn.awaitDrain === 0 && Je(An, "data") && (mn.flowing = !0, Qt(An));
        };
      }(Ot);
      Ut.on("drain", Ft);
      var Gt = !1;
      function zt(An) {
        $e("ondata");
        var mn = Ut.write(An);
        $e("dest.write", mn), mn === !1 && ((ft.pipesCount === 1 && ft.pipes === Ut || ft.pipesCount > 1 && Xt(ft.pipes, Ut) !== -1) && !Gt && ($e("false write response, pause", ft.awaitDrain), ft.awaitDrain++), Ot.pause());
      }
      function $t(An) {
        $e("onerror", An), un(), Ut.removeListener("error", $t), Je(Ut, "error") === 0 && wt(Ut, An);
      }
      function Ht() {
        Ut.removeListener("finish", hn), un();
      }
      function hn() {
        $e("onfinish"), Ut.removeListener("close", Ht), un();
      }
      function un() {
        $e("unpipe"), Ot.unpipe(Ut);
      }
      return Ot.on("data", zt), function(An, mn, En) {
        if (typeof An.prependListener == "function") return An.prependListener(mn, En);
        An._events && An._events.error ? Array.isArray(An._events.error) ? An._events.error.unshift(En) : An._events.error = [En, An._events.error] : An.on(mn, En);
      }(Ut, "error", $t), Ut.once("close", Ht), Ut.once("finish", hn), Ut.emit("pipe", Ot), ft.flowing || ($e("pipe resume"), Ot.resume()), Ut;
    }, yt.prototype.unpipe = function(Ut) {
      var Lt = this._readableState, Ot = { hasUnpiped: !1 };
      if (Lt.pipesCount === 0) return this;
      if (Lt.pipesCount === 1) return Ut && Ut !== Lt.pipes || (Ut || (Ut = Lt.pipes), Lt.pipes = null, Lt.pipesCount = 0, Lt.flowing = !1, Ut && Ut.emit("unpipe", this, Ot)), this;
      if (!Ut) {
        var ft = Lt.pipes, Dt = Lt.pipesCount;
        Lt.pipes = null, Lt.pipesCount = 0, Lt.flowing = !1;
        for (var Mt = 0; Mt < Dt; Mt++) ft[Mt].emit("unpipe", this, { hasUnpiped: !1 });
        return this;
      }
      var Ft = Xt(Lt.pipes, Ut);
      return Ft === -1 || (Lt.pipes.splice(Ft, 1), Lt.pipesCount -= 1, Lt.pipesCount === 1 && (Lt.pipes = Lt.pipes[0]), Ut.emit("unpipe", this, Ot)), this;
    }, yt.prototype.on = function(Ut, Lt) {
      var Ot = Ze.prototype.on.call(this, Ut, Lt), ft = this._readableState;
      return Ut === "data" ? (ft.readableListening = this.listenerCount("readable") > 0, ft.flowing !== !1 && this.resume()) : Ut === "readable" && (ft.endEmitted || ft.readableListening || (ft.readableListening = ft.needReadable = !0, ft.flowing = !1, ft.emittedReadable = !1, $e("on readable", ft.length, ft.reading), ft.length ? Et(this) : ft.reading || process.nextTick(jt, this))), Ot;
    }, yt.prototype.addListener = yt.prototype.on, yt.prototype.removeListener = function(Ut, Lt) {
      var Ot = Ze.prototype.removeListener.call(this, Ut, Lt);
      return Ut === "readable" && process.nextTick(kt, this), Ot;
    }, yt.prototype.removeAllListeners = function(Ut) {
      var Lt = Ze.prototype.removeAllListeners.apply(this, arguments);
      return Ut !== "readable" && Ut !== void 0 || process.nextTick(kt, this), Lt;
    }, yt.prototype.resume = function() {
      var Ut = this._readableState;
      return Ut.flowing || ($e("resume"), Ut.flowing = !Ut.readableListening, function(Lt, Ot) {
        Ot.resumeScheduled || (Ot.resumeScheduled = !0, process.nextTick(Pt, Lt, Ot));
      }(this, Ut)), Ut.paused = !1, this;
    }, yt.prototype.pause = function() {
      return $e("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && ($e("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
    }, yt.prototype.wrap = function(Ut) {
      var Lt = this, Ot = this._readableState, ft = !1;
      for (var Dt in Ut.on("end", function() {
        if ($e("wrapped end"), Ot.decoder && !Ot.ended) {
          var Ft = Ot.decoder.end();
          Ft && Ft.length && Lt.push(Ft);
        }
        Lt.push(null);
      }), Ut.on("data", function(Ft) {
        $e("wrapped data"), Ot.decoder && (Ft = Ot.decoder.write(Ft)), Ot.objectMode && Ft == null || (Ot.objectMode || Ft && Ft.length) && (Lt.push(Ft) || (ft = !0, Ut.pause()));
      }), Ut) this[Dt] === void 0 && typeof Ut[Dt] == "function" && (this[Dt] = /* @__PURE__ */ function(Ft) {
        return function() {
          return Ut[Ft].apply(Ut, arguments);
        };
      }(Dt));
      for (var Mt = 0; Mt < Bt.length; Mt++) Ut.on(Bt[Mt], this.emit.bind(this, Bt[Mt]));
      return this._read = function(Ft) {
        $e("wrapped _read", Ft), ft && (ft = !1, Ut.resume());
      }, this;
    }, typeof Symbol == "function" && (yt.prototype[Symbol.asyncIterator] = function() {
      return it === void 0 && (it = Xe(1029)), it(this);
    }), Object.defineProperty(yt.prototype, "readableHighWaterMark", { enumerable: !1, get: function() {
      return this._readableState.highWaterMark;
    } }), Object.defineProperty(yt.prototype, "readableBuffer", { enumerable: !1, get: function() {
      return this._readableState && this._readableState.buffer;
    } }), Object.defineProperty(yt.prototype, "readableFlowing", { enumerable: !1, get: function() {
      return this._readableState.flowing;
    }, set: function(Ut) {
      this._readableState && (this._readableState.flowing = Ut);
    } }), yt._fromList = qt, Object.defineProperty(yt.prototype, "readableLength", { enumerable: !1, get: function() {
      return this._readableState.length;
    } }), typeof Symbol == "function" && (yt.from = function(Ut, Lt) {
      return ot === void 0 && (ot = Xe(352)), ot(yt, Ut, Lt);
    });
  }, 7640: (He, Ge, Xe) => {
    He.exports = rt;
    var Ke = Xe(4452).q, $e = Ke.ERR_METHOD_NOT_IMPLEMENTED, Je = Ke.ERR_MULTIPLE_CALLBACK, Ze = Ke.ERR_TRANSFORM_ALREADY_TRANSFORMING, nt = Ke.ERR_TRANSFORM_WITH_LENGTH_0, tt = Xe(7073);
    function et(at, st) {
      var ut = this._transformState;
      ut.transforming = !1;
      var lt = ut.writecb;
      if (lt === null) return this.emit("error", new Je());
      ut.writechunk = null, ut.writecb = null, st != null && this.push(st), lt(at);
      var dt = this._readableState;
      dt.reading = !1, (dt.needReadable || dt.length < dt.highWaterMark) && this._read(dt.highWaterMark);
    }
    function rt(at) {
      if (!(this instanceof rt)) return new rt(at);
      tt.call(this, at), this._transformState = { afterTransform: et.bind(this), needTransform: !1, transforming: !1, writecb: null, writechunk: null, writeencoding: null }, this._readableState.needReadable = !0, this._readableState.sync = !1, at && (typeof at.transform == "function" && (this._transform = at.transform), typeof at.flush == "function" && (this._flush = at.flush)), this.on("prefinish", it);
    }
    function it() {
      var at = this;
      typeof this._flush != "function" || this._readableState.destroyed ? ot(this, null, null) : this._flush(function(st, ut) {
        ot(at, st, ut);
      });
    }
    function ot(at, st, ut) {
      if (st) return at.emit("error", st);
      if (ut != null && at.push(ut), at._writableState.length) throw new nt();
      if (at._transformState.transforming) throw new Ze();
      return at.push(null);
    }
    Xe(1285)(rt, tt), rt.prototype.push = function(at, st) {
      return this._transformState.needTransform = !1, tt.prototype.push.call(this, at, st);
    }, rt.prototype._transform = function(at, st, ut) {
      ut(new $e("_transform()"));
    }, rt.prototype._write = function(at, st, ut) {
      var lt = this._transformState;
      if (lt.writecb = ut, lt.writechunk = at, lt.writeencoding = st, !lt.transforming) {
        var dt = this._readableState;
        (lt.needTransform || dt.needReadable || dt.length < dt.highWaterMark) && this._read(dt.highWaterMark);
      }
    }, rt.prototype._read = function(at) {
      var st = this._transformState;
      st.writechunk === null || st.transforming ? st.needTransform = !0 : (st.transforming = !0, this._transform(st.writechunk, st.writeencoding, st.afterTransform));
    }, rt.prototype._destroy = function(at, st) {
      tt.prototype._destroy.call(this, at, function(ut) {
        st(ut);
      });
    };
  }, 2557: (He, Ge, Xe) => {
    function Ke(Rt) {
      var St = this;
      this.next = null, this.entry = null, this.finish = function() {
        (function(kt, jt, Pt) {
          var Qt = kt.entry;
          for (kt.entry = null; Qt; ) {
            var qt = Qt.callback;
            jt.pendingcb--, qt(void 0), Qt = Qt.next;
          }
          jt.corkedRequestsFree.next = kt;
        })(St, Rt);
      };
    }
    var $e;
    He.exports = yt, yt.WritableState = Tt;
    var Je, Ze = { deprecate: Xe(5803) }, nt = Xe(5010), tt = Xe(8834).Buffer, et = Xe.g.Uint8Array || function() {
    }, rt = Xe(2262), it = Xe(7605).getHighWaterMark, ot = Xe(4452).q, at = ot.ERR_INVALID_ARG_TYPE, st = ot.ERR_METHOD_NOT_IMPLEMENTED, ut = ot.ERR_MULTIPLE_CALLBACK, lt = ot.ERR_STREAM_CANNOT_PIPE, dt = ot.ERR_STREAM_DESTROYED, At = ot.ERR_STREAM_NULL_VALUES, pt = ot.ERR_STREAM_WRITE_AFTER_END, gt = ot.ERR_UNKNOWN_ENCODING, wt = rt.errorOrDestroy;
    function Bt() {
    }
    function Tt(Rt, St, kt) {
      $e = $e || Xe(7073), Rt = Rt || {}, typeof kt != "boolean" && (kt = St instanceof $e), this.objectMode = !!Rt.objectMode, kt && (this.objectMode = this.objectMode || !!Rt.writableObjectMode), this.highWaterMark = it(this, Rt, "writableHighWaterMark", kt), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
      var jt = Rt.decodeStrings === !1;
      this.decodeStrings = !jt, this.defaultEncoding = Rt.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(Pt) {
        (function(Qt, qt) {
          var _t = Qt._writableState, Yt = _t.sync, Xt = _t.writecb;
          if (typeof Xt != "function") throw new ut();
          if (function(Lt) {
            Lt.writing = !1, Lt.writecb = null, Lt.length -= Lt.writelen, Lt.writelen = 0;
          }(_t), qt) (function(Lt, Ot, ft, Dt, Mt) {
            --Ot.pendingcb, ft ? (process.nextTick(Mt, Dt), process.nextTick(bt, Lt, Ot), Lt._writableState.errorEmitted = !0, wt(Lt, Dt)) : (Mt(Dt), Lt._writableState.errorEmitted = !0, wt(Lt, Dt), bt(Lt, Ot));
          })(Qt, _t, Yt, qt, Xt);
          else {
            var Ut = vt(_t) || Qt.destroyed;
            Ut || _t.corked || _t.bufferProcessing || !_t.bufferedRequest || It(Qt, _t), Yt ? process.nextTick(ht, Qt, _t, Ut, Xt) : ht(Qt, _t, Ut, Xt);
          }
        })(St, Pt);
      }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = Rt.emitClose !== !1, this.autoDestroy = !!Rt.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new Ke(this);
    }
    function yt(Rt) {
      var St = this instanceof ($e = $e || Xe(7073));
      if (!St && !Je.call(yt, this)) return new yt(Rt);
      this._writableState = new Tt(Rt, this, St), this.writable = !0, Rt && (typeof Rt.write == "function" && (this._write = Rt.write), typeof Rt.writev == "function" && (this._writev = Rt.writev), typeof Rt.destroy == "function" && (this._destroy = Rt.destroy), typeof Rt.final == "function" && (this._final = Rt.final)), nt.call(this);
    }
    function Ct(Rt, St, kt, jt, Pt, Qt, qt) {
      St.writelen = jt, St.writecb = qt, St.writing = !0, St.sync = !0, St.destroyed ? St.onwrite(new dt("write")) : kt ? Rt._writev(Pt, St.onwrite) : Rt._write(Pt, Qt, St.onwrite), St.sync = !1;
    }
    function ht(Rt, St, kt, jt) {
      kt || function(Pt, Qt) {
        Qt.length === 0 && Qt.needDrain && (Qt.needDrain = !1, Pt.emit("drain"));
      }(Rt, St), St.pendingcb--, jt(), bt(Rt, St);
    }
    function It(Rt, St) {
      St.bufferProcessing = !0;
      var kt = St.bufferedRequest;
      if (Rt._writev && kt && kt.next) {
        var jt = St.bufferedRequestCount, Pt = new Array(jt), Qt = St.corkedRequestsFree;
        Qt.entry = kt;
        for (var qt = 0, _t = !0; kt; ) Pt[qt] = kt, kt.isBuf || (_t = !1), kt = kt.next, qt += 1;
        Pt.allBuffers = _t, Ct(Rt, St, !0, St.length, Pt, "", Qt.finish), St.pendingcb++, St.lastBufferedRequest = null, Qt.next ? (St.corkedRequestsFree = Qt.next, Qt.next = null) : St.corkedRequestsFree = new Ke(St), St.bufferedRequestCount = 0;
      } else {
        for (; kt; ) {
          var Yt = kt.chunk, Xt = kt.encoding, Ut = kt.callback;
          if (Ct(Rt, St, !1, St.objectMode ? 1 : Yt.length, Yt, Xt, Ut), kt = kt.next, St.bufferedRequestCount--, St.writing) break;
        }
        kt === null && (St.lastBufferedRequest = null);
      }
      St.bufferedRequest = kt, St.bufferProcessing = !1;
    }
    function vt(Rt) {
      return Rt.ending && Rt.length === 0 && Rt.bufferedRequest === null && !Rt.finished && !Rt.writing;
    }
    function Et(Rt, St) {
      Rt._final(function(kt) {
        St.pendingcb--, kt && wt(Rt, kt), St.prefinished = !0, Rt.emit("prefinish"), bt(Rt, St);
      });
    }
    function bt(Rt, St) {
      var kt = vt(St);
      if (kt && (function(Pt, Qt) {
        Qt.prefinished || Qt.finalCalled || (typeof Pt._final != "function" || Qt.destroyed ? (Qt.prefinished = !0, Pt.emit("prefinish")) : (Qt.pendingcb++, Qt.finalCalled = !0, process.nextTick(Et, Pt, Qt)));
      }(Rt, St), St.pendingcb === 0 && (St.finished = !0, Rt.emit("finish"), St.autoDestroy))) {
        var jt = Rt._readableState;
        (!jt || jt.autoDestroy && jt.endEmitted) && Rt.destroy();
      }
      return kt;
    }
    Xe(1285)(yt, nt), Tt.prototype.getBuffer = function() {
      for (var Rt = this.bufferedRequest, St = []; Rt; ) St.push(Rt), Rt = Rt.next;
      return St;
    }, function() {
      try {
        Object.defineProperty(Tt.prototype, "buffer", { get: Ze.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003") });
      } catch {
      }
    }(), typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (Je = Function.prototype[Symbol.hasInstance], Object.defineProperty(yt, Symbol.hasInstance, { value: function(Rt) {
      return !!Je.call(this, Rt) || this === yt && Rt && Rt._writableState instanceof Tt;
    } })) : Je = function(Rt) {
      return Rt instanceof this;
    }, yt.prototype.pipe = function() {
      wt(this, new lt());
    }, yt.prototype.write = function(Rt, St, kt) {
      var jt, Pt = this._writableState, Qt = !1, qt = !Pt.objectMode && (jt = Rt, tt.isBuffer(jt) || jt instanceof et);
      return qt && !tt.isBuffer(Rt) && (Rt = function(_t) {
        return tt.from(_t);
      }(Rt)), typeof St == "function" && (kt = St, St = null), qt ? St = "buffer" : St || (St = Pt.defaultEncoding), typeof kt != "function" && (kt = Bt), Pt.ending ? function(_t, Yt) {
        var Xt = new pt();
        wt(_t, Xt), process.nextTick(Yt, Xt);
      }(this, kt) : (qt || function(_t, Yt, Xt, Ut) {
        var Lt;
        return Xt === null ? Lt = new At() : typeof Xt == "string" || Yt.objectMode || (Lt = new at("chunk", ["string", "Buffer"], Xt)), !Lt || (wt(_t, Lt), process.nextTick(Ut, Lt), !1);
      }(this, Pt, Rt, kt)) && (Pt.pendingcb++, Qt = function(_t, Yt, Xt, Ut, Lt, Ot) {
        if (!Xt) {
          var ft = function(Gt, zt, $t) {
            return Gt.objectMode || Gt.decodeStrings === !1 || typeof zt != "string" || (zt = tt.from(zt, $t)), zt;
          }(Yt, Ut, Lt);
          Ut !== ft && (Xt = !0, Lt = "buffer", Ut = ft);
        }
        var Dt = Yt.objectMode ? 1 : Ut.length;
        Yt.length += Dt;
        var Mt = Yt.length < Yt.highWaterMark;
        if (Mt || (Yt.needDrain = !0), Yt.writing || Yt.corked) {
          var Ft = Yt.lastBufferedRequest;
          Yt.lastBufferedRequest = { chunk: Ut, encoding: Lt, isBuf: Xt, callback: Ot, next: null }, Ft ? Ft.next = Yt.lastBufferedRequest : Yt.bufferedRequest = Yt.lastBufferedRequest, Yt.bufferedRequestCount += 1;
        } else Ct(_t, Yt, !1, Dt, Ut, Lt, Ot);
        return Mt;
      }(this, Pt, qt, Rt, St, kt)), Qt;
    }, yt.prototype.cork = function() {
      this._writableState.corked++;
    }, yt.prototype.uncork = function() {
      var Rt = this._writableState;
      Rt.corked && (Rt.corked--, Rt.writing || Rt.corked || Rt.bufferProcessing || !Rt.bufferedRequest || It(this, Rt));
    }, yt.prototype.setDefaultEncoding = function(Rt) {
      if (typeof Rt == "string" && (Rt = Rt.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((Rt + "").toLowerCase()) > -1)) throw new gt(Rt);
      return this._writableState.defaultEncoding = Rt, this;
    }, Object.defineProperty(yt.prototype, "writableBuffer", { enumerable: !1, get: function() {
      return this._writableState && this._writableState.getBuffer();
    } }), Object.defineProperty(yt.prototype, "writableHighWaterMark", { enumerable: !1, get: function() {
      return this._writableState.highWaterMark;
    } }), yt.prototype._write = function(Rt, St, kt) {
      kt(new st("_write()"));
    }, yt.prototype._writev = null, yt.prototype.end = function(Rt, St, kt) {
      var jt = this._writableState;
      return typeof Rt == "function" ? (kt = Rt, Rt = null, St = null) : typeof St == "function" && (kt = St, St = null), Rt != null && this.write(Rt, St), jt.corked && (jt.corked = 1, this.uncork()), jt.ending || function(Pt, Qt, qt) {
        Qt.ending = !0, bt(Pt, Qt), qt && (Qt.finished ? process.nextTick(qt) : Pt.once("finish", qt)), Qt.ended = !0, Pt.writable = !1;
      }(this, jt, kt), this;
    }, Object.defineProperty(yt.prototype, "writableLength", { enumerable: !1, get: function() {
      return this._writableState.length;
    } }), Object.defineProperty(yt.prototype, "destroyed", { enumerable: !1, get: function() {
      return this._writableState !== void 0 && this._writableState.destroyed;
    }, set: function(Rt) {
      this._writableState && (this._writableState.destroyed = Rt);
    } }), yt.prototype.destroy = rt.destroy, yt.prototype._undestroy = rt.undestroy, yt.prototype._destroy = function(Rt, St) {
      St(Rt);
    };
  }, 1029: (He, Ge, Xe) => {
    var Ke;
    function $e(At, pt, gt) {
      return pt in At ? Object.defineProperty(At, pt, { value: gt, enumerable: !0, configurable: !0, writable: !0 }) : At[pt] = gt, At;
    }
    var Je = Xe(9885), Ze = Symbol("lastResolve"), nt = Symbol("lastReject"), tt = Symbol("error"), et = Symbol("ended"), rt = Symbol("lastPromise"), it = Symbol("handlePromise"), ot = Symbol("stream");
    function at(At, pt) {
      return { value: At, done: pt };
    }
    function st(At) {
      var pt = At[Ze];
      if (pt !== null) {
        var gt = At[ot].read();
        gt !== null && (At[rt] = null, At[Ze] = null, At[nt] = null, pt(at(gt, !1)));
      }
    }
    function ut(At) {
      process.nextTick(st, At);
    }
    var lt = Object.getPrototypeOf(function() {
    }), dt = Object.setPrototypeOf(($e(Ke = { get stream() {
      return this[ot];
    }, next: function() {
      var At = this, pt = this[tt];
      if (pt !== null) return Promise.reject(pt);
      if (this[et]) return Promise.resolve(at(void 0, !0));
      if (this[ot].destroyed) return new Promise(function(Tt, yt) {
        process.nextTick(function() {
          At[tt] ? yt(At[tt]) : Tt(at(void 0, !0));
        });
      });
      var gt, wt = this[rt];
      if (wt) gt = new Promise(/* @__PURE__ */ function(Tt, yt) {
        return function(Ct, ht) {
          Tt.then(function() {
            yt[et] ? Ct(at(void 0, !0)) : yt[it](Ct, ht);
          }, ht);
        };
      }(wt, this));
      else {
        var Bt = this[ot].read();
        if (Bt !== null) return Promise.resolve(at(Bt, !1));
        gt = new Promise(this[it]);
      }
      return this[rt] = gt, gt;
    } }, Symbol.asyncIterator, function() {
      return this;
    }), $e(Ke, "return", function() {
      var At = this;
      return new Promise(function(pt, gt) {
        At[ot].destroy(null, function(wt) {
          wt ? gt(wt) : pt(at(void 0, !0));
        });
      });
    }), Ke), lt);
    He.exports = function(At) {
      var pt, gt = Object.create(dt, ($e(pt = {}, ot, { value: At, writable: !0 }), $e(pt, Ze, { value: null, writable: !0 }), $e(pt, nt, { value: null, writable: !0 }), $e(pt, tt, { value: null, writable: !0 }), $e(pt, et, { value: At._readableState.endEmitted, writable: !0 }), $e(pt, it, { value: function(wt, Bt) {
        var Tt = gt[ot].read();
        Tt ? (gt[rt] = null, gt[Ze] = null, gt[nt] = null, wt(at(Tt, !1))) : (gt[Ze] = wt, gt[nt] = Bt);
      }, writable: !0 }), pt));
      return gt[rt] = null, Je(At, function(wt) {
        if (wt && wt.code !== "ERR_STREAM_PREMATURE_CLOSE") {
          var Bt = gt[nt];
          return Bt !== null && (gt[rt] = null, gt[Ze] = null, gt[nt] = null, Bt(wt)), void (gt[tt] = wt);
        }
        var Tt = gt[Ze];
        Tt !== null && (gt[rt] = null, gt[Ze] = null, gt[nt] = null, Tt(at(void 0, !0))), gt[et] = !0;
      }), At.on("readable", ut.bind(null, gt)), gt;
    };
  }, 6637: (He, Ge, Xe) => {
    function Ke(et, rt) {
      var it = Object.keys(et);
      if (Object.getOwnPropertySymbols) {
        var ot = Object.getOwnPropertySymbols(et);
        rt && (ot = ot.filter(function(at) {
          return Object.getOwnPropertyDescriptor(et, at).enumerable;
        })), it.push.apply(it, ot);
      }
      return it;
    }
    function $e(et, rt, it) {
      return rt in et ? Object.defineProperty(et, rt, { value: it, enumerable: !0, configurable: !0, writable: !0 }) : et[rt] = it, et;
    }
    function Je(et, rt) {
      for (var it = 0; it < rt.length; it++) {
        var ot = rt[it];
        ot.enumerable = ot.enumerable || !1, ot.configurable = !0, "value" in ot && (ot.writable = !0), Object.defineProperty(et, ot.key, ot);
      }
    }
    var Ze = Xe(8834).Buffer, nt = Xe(4854).inspect, tt = nt && nt.custom || "inspect";
    He.exports = function() {
      function et() {
        (function(ot, at) {
          if (!(ot instanceof at)) throw new TypeError("Cannot call a class as a function");
        })(this, et), this.head = null, this.tail = null, this.length = 0;
      }
      var rt, it;
      return rt = et, it = [{ key: "push", value: function(ot) {
        var at = { data: ot, next: null };
        this.length > 0 ? this.tail.next = at : this.head = at, this.tail = at, ++this.length;
      } }, { key: "unshift", value: function(ot) {
        var at = { data: ot, next: this.head };
        this.length === 0 && (this.tail = at), this.head = at, ++this.length;
      } }, { key: "shift", value: function() {
        if (this.length !== 0) {
          var ot = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, ot;
        }
      } }, { key: "clear", value: function() {
        this.head = this.tail = null, this.length = 0;
      } }, { key: "join", value: function(ot) {
        if (this.length === 0) return "";
        for (var at = this.head, st = "" + at.data; at = at.next; ) st += ot + at.data;
        return st;
      } }, { key: "concat", value: function(ot) {
        if (this.length === 0) return Ze.alloc(0);
        for (var at, st, ut, lt = Ze.allocUnsafe(ot >>> 0), dt = this.head, At = 0; dt; ) at = dt.data, st = lt, ut = At, Ze.prototype.copy.call(at, st, ut), At += dt.data.length, dt = dt.next;
        return lt;
      } }, { key: "consume", value: function(ot, at) {
        var st;
        return ot < this.head.data.length ? (st = this.head.data.slice(0, ot), this.head.data = this.head.data.slice(ot)) : st = ot === this.head.data.length ? this.shift() : at ? this._getString(ot) : this._getBuffer(ot), st;
      } }, { key: "first", value: function() {
        return this.head.data;
      } }, { key: "_getString", value: function(ot) {
        var at = this.head, st = 1, ut = at.data;
        for (ot -= ut.length; at = at.next; ) {
          var lt = at.data, dt = ot > lt.length ? lt.length : ot;
          if (dt === lt.length ? ut += lt : ut += lt.slice(0, ot), (ot -= dt) == 0) {
            dt === lt.length ? (++st, at.next ? this.head = at.next : this.head = this.tail = null) : (this.head = at, at.data = lt.slice(dt));
            break;
          }
          ++st;
        }
        return this.length -= st, ut;
      } }, { key: "_getBuffer", value: function(ot) {
        var at = Ze.allocUnsafe(ot), st = this.head, ut = 1;
        for (st.data.copy(at), ot -= st.data.length; st = st.next; ) {
          var lt = st.data, dt = ot > lt.length ? lt.length : ot;
          if (lt.copy(at, at.length - ot, 0, dt), (ot -= dt) == 0) {
            dt === lt.length ? (++ut, st.next ? this.head = st.next : this.head = this.tail = null) : (this.head = st, st.data = lt.slice(dt));
            break;
          }
          ++ut;
        }
        return this.length -= ut, at;
      } }, { key: tt, value: function(ot, at) {
        return nt(this, function(st) {
          for (var ut = 1; ut < arguments.length; ut++) {
            var lt = arguments[ut] != null ? arguments[ut] : {};
            ut % 2 ? Ke(Object(lt), !0).forEach(function(dt) {
              $e(st, dt, lt[dt]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(st, Object.getOwnPropertyDescriptors(lt)) : Ke(Object(lt)).forEach(function(dt) {
              Object.defineProperty(st, dt, Object.getOwnPropertyDescriptor(lt, dt));
            });
          }
          return st;
        }({}, at, { depth: 0, customInspect: !1 }));
      } }], it && Je(rt.prototype, it), et;
    }();
  }, 2262: (He) => {
    function Ge($e, Je) {
      Ke($e, Je), Xe($e);
    }
    function Xe($e) {
      $e._writableState && !$e._writableState.emitClose || $e._readableState && !$e._readableState.emitClose || $e.emit("close");
    }
    function Ke($e, Je) {
      $e.emit("error", Je);
    }
    He.exports = { destroy: function($e, Je) {
      var Ze = this, nt = this._readableState && this._readableState.destroyed, tt = this._writableState && this._writableState.destroyed;
      return nt || tt ? (Je ? Je($e) : $e && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, process.nextTick(Ke, this, $e)) : process.nextTick(Ke, this, $e)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy($e || null, function(et) {
        !Je && et ? Ze._writableState ? Ze._writableState.errorEmitted ? process.nextTick(Xe, Ze) : (Ze._writableState.errorEmitted = !0, process.nextTick(Ge, Ze, et)) : process.nextTick(Ge, Ze, et) : Je ? (process.nextTick(Xe, Ze), Je(et)) : process.nextTick(Xe, Ze);
      }), this);
    }, undestroy: function() {
      this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
    }, errorOrDestroy: function($e, Je) {
      var Ze = $e._readableState, nt = $e._writableState;
      Ze && Ze.autoDestroy || nt && nt.autoDestroy ? $e.destroy(Je) : $e.emit("error", Je);
    } };
  }, 9885: (He, Ge, Xe) => {
    var Ke = Xe(4452).q.ERR_STREAM_PREMATURE_CLOSE;
    function $e() {
    }
    He.exports = function Je(Ze, nt, tt) {
      if (typeof nt == "function") return Je(Ze, null, nt);
      nt || (nt = {}), tt = /* @__PURE__ */ function(pt) {
        var gt = !1;
        return function() {
          if (!gt) {
            gt = !0;
            for (var wt = arguments.length, Bt = new Array(wt), Tt = 0; Tt < wt; Tt++) Bt[Tt] = arguments[Tt];
            pt.apply(this, Bt);
          }
        };
      }(tt || $e);
      var et = nt.readable || nt.readable !== !1 && Ze.readable, rt = nt.writable || nt.writable !== !1 && Ze.writable, it = function() {
        Ze.writable || at();
      }, ot = Ze._writableState && Ze._writableState.finished, at = function() {
        rt = !1, ot = !0, et || tt.call(Ze);
      }, st = Ze._readableState && Ze._readableState.endEmitted, ut = function() {
        et = !1, st = !0, rt || tt.call(Ze);
      }, lt = function(pt) {
        tt.call(Ze, pt);
      }, dt = function() {
        var pt;
        return et && !st ? (Ze._readableState && Ze._readableState.ended || (pt = new Ke()), tt.call(Ze, pt)) : rt && !ot ? (Ze._writableState && Ze._writableState.ended || (pt = new Ke()), tt.call(Ze, pt)) : void 0;
      }, At = function() {
        Ze.req.on("finish", at);
      };
      return function(pt) {
        return pt.setHeader && typeof pt.abort == "function";
      }(Ze) ? (Ze.on("complete", at), Ze.on("abort", dt), Ze.req ? At() : Ze.on("request", At)) : rt && !Ze._writableState && (Ze.on("end", it), Ze.on("close", it)), Ze.on("end", ut), Ze.on("finish", at), nt.error !== !1 && Ze.on("error", lt), Ze.on("close", dt), function() {
        Ze.removeListener("complete", at), Ze.removeListener("abort", dt), Ze.removeListener("request", At), Ze.req && Ze.req.removeListener("finish", at), Ze.removeListener("end", it), Ze.removeListener("close", it), Ze.removeListener("finish", at), Ze.removeListener("end", ut), Ze.removeListener("error", lt), Ze.removeListener("close", dt);
      };
    };
  }, 352: (He) => {
    He.exports = function() {
      throw new Error("Readable.from is not available in the browser");
    };
  }, 3495: (He, Ge, Xe) => {
    var Ke, $e = Xe(4452).q, Je = $e.ERR_MISSING_ARGS, Ze = $e.ERR_STREAM_DESTROYED;
    function nt(ot) {
      if (ot) throw ot;
    }
    function tt(ot, at, st, ut) {
      ut = /* @__PURE__ */ function(At) {
        var pt = !1;
        return function() {
          pt || (pt = !0, At.apply(void 0, arguments));
        };
      }(ut);
      var lt = !1;
      ot.on("close", function() {
        lt = !0;
      }), Ke === void 0 && (Ke = Xe(9885)), Ke(ot, { readable: at, writable: st }, function(At) {
        if (At) return ut(At);
        lt = !0, ut();
      });
      var dt = !1;
      return function(At) {
        if (!lt && !dt) return dt = !0, function(pt) {
          return pt.setHeader && typeof pt.abort == "function";
        }(ot) ? ot.abort() : typeof ot.destroy == "function" ? ot.destroy() : void ut(At || new Ze("pipe"));
      };
    }
    function et(ot) {
      ot();
    }
    function rt(ot, at) {
      return ot.pipe(at);
    }
    function it(ot) {
      return ot.length ? typeof ot[ot.length - 1] != "function" ? nt : ot.pop() : nt;
    }
    He.exports = function() {
      for (var ot = arguments.length, at = new Array(ot), st = 0; st < ot; st++) at[st] = arguments[st];
      var ut, lt = it(at);
      if (Array.isArray(at[0]) && (at = at[0]), at.length < 2) throw new Je("streams");
      var dt = at.map(function(At, pt) {
        var gt = pt < at.length - 1;
        return tt(At, gt, pt > 0, function(wt) {
          ut || (ut = wt), wt && dt.forEach(et), gt || (dt.forEach(et), lt(ut));
        });
      });
      return at.reduce(rt);
    };
  }, 7605: (He, Ge, Xe) => {
    var Ke = Xe(4452).q.ERR_INVALID_OPT_VALUE;
    He.exports = { getHighWaterMark: function($e, Je, Ze, nt) {
      var tt = function(et, rt, it) {
        return et.highWaterMark != null ? et.highWaterMark : rt ? et[it] : null;
      }(Je, nt, Ze);
      if (tt != null) {
        if (!isFinite(tt) || Math.floor(tt) !== tt || tt < 0) throw new Ke(nt ? Ze : "highWaterMark", tt);
        return Math.floor(tt);
      }
      return $e.objectMode ? 16 : 16384;
    } };
  }, 5010: (He, Ge, Xe) => {
    He.exports = Xe(2699).EventEmitter;
  }, 7525: (He, Ge, Xe) => {
    (Ge = He.exports = Xe(8051)).Stream = Ge, Ge.Readable = Ge, Ge.Writable = Xe(2557), Ge.Duplex = Xe(7073), Ge.Transform = Xe(7640), Ge.PassThrough = Xe(5163), Ge.finished = Xe(9885), Ge.pipeline = Xe(3495);
  }, 1445: (He, Ge, Xe) => {
    var Ke = Xe(8834).Buffer, $e = Xe(1285), Je = Xe(4485), Ze = new Array(16), nt = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13], tt = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11], et = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6], rt = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11], it = [0, 1518500249, 1859775393, 2400959708, 2840853838], ot = [1352829926, 1548603684, 1836072691, 2053994217, 0];
    function at() {
      Je.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
    }
    function st(gt, wt) {
      return gt << wt | gt >>> 32 - wt;
    }
    function ut(gt, wt, Bt, Tt, yt, Ct, ht, It) {
      return st(gt + (wt ^ Bt ^ Tt) + Ct + ht | 0, It) + yt | 0;
    }
    function lt(gt, wt, Bt, Tt, yt, Ct, ht, It) {
      return st(gt + (wt & Bt | ~wt & Tt) + Ct + ht | 0, It) + yt | 0;
    }
    function dt(gt, wt, Bt, Tt, yt, Ct, ht, It) {
      return st(gt + ((wt | ~Bt) ^ Tt) + Ct + ht | 0, It) + yt | 0;
    }
    function At(gt, wt, Bt, Tt, yt, Ct, ht, It) {
      return st(gt + (wt & Tt | Bt & ~Tt) + Ct + ht | 0, It) + yt | 0;
    }
    function pt(gt, wt, Bt, Tt, yt, Ct, ht, It) {
      return st(gt + (wt ^ (Bt | ~Tt)) + Ct + ht | 0, It) + yt | 0;
    }
    $e(at, Je), at.prototype._update = function() {
      for (var gt = Ze, wt = 0; wt < 16; ++wt) gt[wt] = this._block.readInt32LE(4 * wt);
      for (var Bt = 0 | this._a, Tt = 0 | this._b, yt = 0 | this._c, Ct = 0 | this._d, ht = 0 | this._e, It = 0 | this._a, vt = 0 | this._b, Et = 0 | this._c, bt = 0 | this._d, Rt = 0 | this._e, St = 0; St < 80; St += 1) {
        var kt, jt;
        St < 16 ? (kt = ut(Bt, Tt, yt, Ct, ht, gt[nt[St]], it[0], et[St]), jt = pt(It, vt, Et, bt, Rt, gt[tt[St]], ot[0], rt[St])) : St < 32 ? (kt = lt(Bt, Tt, yt, Ct, ht, gt[nt[St]], it[1], et[St]), jt = At(It, vt, Et, bt, Rt, gt[tt[St]], ot[1], rt[St])) : St < 48 ? (kt = dt(Bt, Tt, yt, Ct, ht, gt[nt[St]], it[2], et[St]), jt = dt(It, vt, Et, bt, Rt, gt[tt[St]], ot[2], rt[St])) : St < 64 ? (kt = At(Bt, Tt, yt, Ct, ht, gt[nt[St]], it[3], et[St]), jt = lt(It, vt, Et, bt, Rt, gt[tt[St]], ot[3], rt[St])) : (kt = pt(Bt, Tt, yt, Ct, ht, gt[nt[St]], it[4], et[St]), jt = ut(It, vt, Et, bt, Rt, gt[tt[St]], ot[4], rt[St])), Bt = ht, ht = Ct, Ct = st(yt, 10), yt = Tt, Tt = kt, It = Rt, Rt = bt, bt = st(Et, 10), Et = vt, vt = jt;
      }
      var Pt = this._b + yt + bt | 0;
      this._b = this._c + Ct + Rt | 0, this._c = this._d + ht + It | 0, this._d = this._e + Bt + vt | 0, this._e = this._a + Tt + Et | 0, this._a = Pt;
    }, at.prototype._digest = function() {
      this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
      var gt = Ke.alloc ? Ke.alloc(20) : new Ke(20);
      return gt.writeInt32LE(this._a, 0), gt.writeInt32LE(this._b, 4), gt.writeInt32LE(this._c, 8), gt.writeInt32LE(this._d, 12), gt.writeInt32LE(this._e, 16), gt;
    }, He.exports = at;
  }, 7834: (He, Ge, Xe) => {
    var Ke = Xe(8834), $e = Ke.Buffer;
    function Je(nt, tt) {
      for (var et in nt) tt[et] = nt[et];
    }
    function Ze(nt, tt, et) {
      return $e(nt, tt, et);
    }
    $e.from && $e.alloc && $e.allocUnsafe && $e.allocUnsafeSlow ? He.exports = Ke : (Je(Ke, Ge), Ge.Buffer = Ze), Ze.prototype = Object.create($e.prototype), Je($e, Ze), Ze.from = function(nt, tt, et) {
      if (typeof nt == "number") throw new TypeError("Argument must not be a number");
      return $e(nt, tt, et);
    }, Ze.alloc = function(nt, tt, et) {
      if (typeof nt != "number") throw new TypeError("Argument must be a number");
      var rt = $e(nt);
      return tt !== void 0 ? typeof et == "string" ? rt.fill(tt, et) : rt.fill(tt) : rt.fill(0), rt;
    }, Ze.allocUnsafe = function(nt) {
      if (typeof nt != "number") throw new TypeError("Argument must be a number");
      return $e(nt);
    }, Ze.allocUnsafeSlow = function(nt) {
      if (typeof nt != "number") throw new TypeError("Argument must be a number");
      return Ke.SlowBuffer(nt);
    };
  }, 3327: (He, Ge, Xe) => {
    var Ke = Xe(7834).Buffer;
    function $e(Je, Ze) {
      this._block = Ke.alloc(Je), this._finalSize = Ze, this._blockSize = Je, this._len = 0;
    }
    $e.prototype.update = function(Je, Ze) {
      typeof Je == "string" && (Ze = Ze || "utf8", Je = Ke.from(Je, Ze));
      for (var nt = this._block, tt = this._blockSize, et = Je.length, rt = this._len, it = 0; it < et; ) {
        for (var ot = rt % tt, at = Math.min(et - it, tt - ot), st = 0; st < at; st++) nt[ot + st] = Je[it + st];
        it += at, (rt += at) % tt == 0 && this._update(nt);
      }
      return this._len += et, this;
    }, $e.prototype.digest = function(Je) {
      var Ze = this._len % this._blockSize;
      this._block[Ze] = 128, this._block.fill(0, Ze + 1), Ze >= this._finalSize && (this._update(this._block), this._block.fill(0));
      var nt = 8 * this._len;
      if (nt <= 4294967295) this._block.writeUInt32BE(nt, this._blockSize - 4);
      else {
        var tt = (4294967295 & nt) >>> 0, et = (nt - tt) / 4294967296;
        this._block.writeUInt32BE(et, this._blockSize - 8), this._block.writeUInt32BE(tt, this._blockSize - 4);
      }
      this._update(this._block);
      var rt = this._hash();
      return Je ? rt.toString(Je) : rt;
    }, $e.prototype._update = function() {
      throw new Error("_update must be implemented by subclass");
    }, He.exports = $e;
  }, 9065: (He, Ge, Xe) => {
    var Ke = He.exports = function($e) {
      $e = $e.toLowerCase();
      var Je = Ke[$e];
      if (!Je) throw new Error($e + " is not supported (we accept pull requests)");
      return new Je();
    };
    Ke.sha = Xe(8820), Ke.sha1 = Xe(7885), Ke.sha224 = Xe(8321), Ke.sha256 = Xe(4424), Ke.sha384 = Xe(213), Ke.sha512 = Xe(5596);
  }, 8820: (He, Ge, Xe) => {
    var Ke = Xe(1285), $e = Xe(3327), Je = Xe(7834).Buffer, Ze = [1518500249, 1859775393, -1894007588, -899497514], nt = new Array(80);
    function tt() {
      this.init(), this._w = nt, $e.call(this, 64, 56);
    }
    function et(it) {
      return it << 30 | it >>> 2;
    }
    function rt(it, ot, at, st) {
      return it === 0 ? ot & at | ~ot & st : it === 2 ? ot & at | ot & st | at & st : ot ^ at ^ st;
    }
    Ke(tt, $e), tt.prototype.init = function() {
      return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
    }, tt.prototype._update = function(it) {
      for (var ot, at = this._w, st = 0 | this._a, ut = 0 | this._b, lt = 0 | this._c, dt = 0 | this._d, At = 0 | this._e, pt = 0; pt < 16; ++pt) at[pt] = it.readInt32BE(4 * pt);
      for (; pt < 80; ++pt) at[pt] = at[pt - 3] ^ at[pt - 8] ^ at[pt - 14] ^ at[pt - 16];
      for (var gt = 0; gt < 80; ++gt) {
        var wt = ~~(gt / 20), Bt = 0 | ((ot = st) << 5 | ot >>> 27) + rt(wt, ut, lt, dt) + At + at[gt] + Ze[wt];
        At = dt, dt = lt, lt = et(ut), ut = st, st = Bt;
      }
      this._a = st + this._a | 0, this._b = ut + this._b | 0, this._c = lt + this._c | 0, this._d = dt + this._d | 0, this._e = At + this._e | 0;
    }, tt.prototype._hash = function() {
      var it = Je.allocUnsafe(20);
      return it.writeInt32BE(0 | this._a, 0), it.writeInt32BE(0 | this._b, 4), it.writeInt32BE(0 | this._c, 8), it.writeInt32BE(0 | this._d, 12), it.writeInt32BE(0 | this._e, 16), it;
    }, He.exports = tt;
  }, 7885: (He, Ge, Xe) => {
    var Ke = Xe(1285), $e = Xe(3327), Je = Xe(7834).Buffer, Ze = [1518500249, 1859775393, -1894007588, -899497514], nt = new Array(80);
    function tt() {
      this.init(), this._w = nt, $e.call(this, 64, 56);
    }
    function et(ot) {
      return ot << 5 | ot >>> 27;
    }
    function rt(ot) {
      return ot << 30 | ot >>> 2;
    }
    function it(ot, at, st, ut) {
      return ot === 0 ? at & st | ~at & ut : ot === 2 ? at & st | at & ut | st & ut : at ^ st ^ ut;
    }
    Ke(tt, $e), tt.prototype.init = function() {
      return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
    }, tt.prototype._update = function(ot) {
      for (var at, st = this._w, ut = 0 | this._a, lt = 0 | this._b, dt = 0 | this._c, At = 0 | this._d, pt = 0 | this._e, gt = 0; gt < 16; ++gt) st[gt] = ot.readInt32BE(4 * gt);
      for (; gt < 80; ++gt) st[gt] = (at = st[gt - 3] ^ st[gt - 8] ^ st[gt - 14] ^ st[gt - 16]) << 1 | at >>> 31;
      for (var wt = 0; wt < 80; ++wt) {
        var Bt = ~~(wt / 20), Tt = et(ut) + it(Bt, lt, dt, At) + pt + st[wt] + Ze[Bt] | 0;
        pt = At, At = dt, dt = rt(lt), lt = ut, ut = Tt;
      }
      this._a = ut + this._a | 0, this._b = lt + this._b | 0, this._c = dt + this._c | 0, this._d = At + this._d | 0, this._e = pt + this._e | 0;
    }, tt.prototype._hash = function() {
      var ot = Je.allocUnsafe(20);
      return ot.writeInt32BE(0 | this._a, 0), ot.writeInt32BE(0 | this._b, 4), ot.writeInt32BE(0 | this._c, 8), ot.writeInt32BE(0 | this._d, 12), ot.writeInt32BE(0 | this._e, 16), ot;
    }, He.exports = tt;
  }, 8321: (He, Ge, Xe) => {
    var Ke = Xe(1285), $e = Xe(4424), Je = Xe(3327), Ze = Xe(7834).Buffer, nt = new Array(64);
    function tt() {
      this.init(), this._w = nt, Je.call(this, 64, 56);
    }
    Ke(tt, $e), tt.prototype.init = function() {
      return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
    }, tt.prototype._hash = function() {
      var et = Ze.allocUnsafe(28);
      return et.writeInt32BE(this._a, 0), et.writeInt32BE(this._b, 4), et.writeInt32BE(this._c, 8), et.writeInt32BE(this._d, 12), et.writeInt32BE(this._e, 16), et.writeInt32BE(this._f, 20), et.writeInt32BE(this._g, 24), et;
    }, He.exports = tt;
  }, 4424: (He, Ge, Xe) => {
    var Ke = Xe(1285), $e = Xe(3327), Je = Xe(7834).Buffer, Ze = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298], nt = new Array(64);
    function tt() {
      this.init(), this._w = nt, $e.call(this, 64, 56);
    }
    function et(st, ut, lt) {
      return lt ^ st & (ut ^ lt);
    }
    function rt(st, ut, lt) {
      return st & ut | lt & (st | ut);
    }
    function it(st) {
      return (st >>> 2 | st << 30) ^ (st >>> 13 | st << 19) ^ (st >>> 22 | st << 10);
    }
    function ot(st) {
      return (st >>> 6 | st << 26) ^ (st >>> 11 | st << 21) ^ (st >>> 25 | st << 7);
    }
    function at(st) {
      return (st >>> 7 | st << 25) ^ (st >>> 18 | st << 14) ^ st >>> 3;
    }
    Ke(tt, $e), tt.prototype.init = function() {
      return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
    }, tt.prototype._update = function(st) {
      for (var ut, lt = this._w, dt = 0 | this._a, At = 0 | this._b, pt = 0 | this._c, gt = 0 | this._d, wt = 0 | this._e, Bt = 0 | this._f, Tt = 0 | this._g, yt = 0 | this._h, Ct = 0; Ct < 16; ++Ct) lt[Ct] = st.readInt32BE(4 * Ct);
      for (; Ct < 64; ++Ct) lt[Ct] = 0 | (((ut = lt[Ct - 2]) >>> 17 | ut << 15) ^ (ut >>> 19 | ut << 13) ^ ut >>> 10) + lt[Ct - 7] + at(lt[Ct - 15]) + lt[Ct - 16];
      for (var ht = 0; ht < 64; ++ht) {
        var It = yt + ot(wt) + et(wt, Bt, Tt) + Ze[ht] + lt[ht] | 0, vt = it(dt) + rt(dt, At, pt) | 0;
        yt = Tt, Tt = Bt, Bt = wt, wt = gt + It | 0, gt = pt, pt = At, At = dt, dt = It + vt | 0;
      }
      this._a = dt + this._a | 0, this._b = At + this._b | 0, this._c = pt + this._c | 0, this._d = gt + this._d | 0, this._e = wt + this._e | 0, this._f = Bt + this._f | 0, this._g = Tt + this._g | 0, this._h = yt + this._h | 0;
    }, tt.prototype._hash = function() {
      var st = Je.allocUnsafe(32);
      return st.writeInt32BE(this._a, 0), st.writeInt32BE(this._b, 4), st.writeInt32BE(this._c, 8), st.writeInt32BE(this._d, 12), st.writeInt32BE(this._e, 16), st.writeInt32BE(this._f, 20), st.writeInt32BE(this._g, 24), st.writeInt32BE(this._h, 28), st;
    }, He.exports = tt;
  }, 213: (He, Ge, Xe) => {
    var Ke = Xe(1285), $e = Xe(5596), Je = Xe(3327), Ze = Xe(7834).Buffer, nt = new Array(160);
    function tt() {
      this.init(), this._w = nt, Je.call(this, 128, 112);
    }
    Ke(tt, $e), tt.prototype.init = function() {
      return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
    }, tt.prototype._hash = function() {
      var et = Ze.allocUnsafe(48);
      function rt(it, ot, at) {
        et.writeInt32BE(it, at), et.writeInt32BE(ot, at + 4);
      }
      return rt(this._ah, this._al, 0), rt(this._bh, this._bl, 8), rt(this._ch, this._cl, 16), rt(this._dh, this._dl, 24), rt(this._eh, this._el, 32), rt(this._fh, this._fl, 40), et;
    }, He.exports = tt;
  }, 5596: (He, Ge, Xe) => {
    var Ke = Xe(1285), $e = Xe(3327), Je = Xe(7834).Buffer, Ze = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591], nt = new Array(160);
    function tt() {
      this.init(), this._w = nt, $e.call(this, 128, 112);
    }
    function et(At, pt, gt) {
      return gt ^ At & (pt ^ gt);
    }
    function rt(At, pt, gt) {
      return At & pt | gt & (At | pt);
    }
    function it(At, pt) {
      return (At >>> 28 | pt << 4) ^ (pt >>> 2 | At << 30) ^ (pt >>> 7 | At << 25);
    }
    function ot(At, pt) {
      return (At >>> 14 | pt << 18) ^ (At >>> 18 | pt << 14) ^ (pt >>> 9 | At << 23);
    }
    function at(At, pt) {
      return (At >>> 1 | pt << 31) ^ (At >>> 8 | pt << 24) ^ At >>> 7;
    }
    function st(At, pt) {
      return (At >>> 1 | pt << 31) ^ (At >>> 8 | pt << 24) ^ (At >>> 7 | pt << 25);
    }
    function ut(At, pt) {
      return (At >>> 19 | pt << 13) ^ (pt >>> 29 | At << 3) ^ At >>> 6;
    }
    function lt(At, pt) {
      return (At >>> 19 | pt << 13) ^ (pt >>> 29 | At << 3) ^ (At >>> 6 | pt << 26);
    }
    function dt(At, pt) {
      return At >>> 0 < pt >>> 0 ? 1 : 0;
    }
    Ke(tt, $e), tt.prototype.init = function() {
      return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
    }, tt.prototype._update = function(At) {
      for (var pt = this._w, gt = 0 | this._ah, wt = 0 | this._bh, Bt = 0 | this._ch, Tt = 0 | this._dh, yt = 0 | this._eh, Ct = 0 | this._fh, ht = 0 | this._gh, It = 0 | this._hh, vt = 0 | this._al, Et = 0 | this._bl, bt = 0 | this._cl, Rt = 0 | this._dl, St = 0 | this._el, kt = 0 | this._fl, jt = 0 | this._gl, Pt = 0 | this._hl, Qt = 0; Qt < 32; Qt += 2) pt[Qt] = At.readInt32BE(4 * Qt), pt[Qt + 1] = At.readInt32BE(4 * Qt + 4);
      for (; Qt < 160; Qt += 2) {
        var qt = pt[Qt - 30], _t = pt[Qt - 30 + 1], Yt = at(qt, _t), Xt = st(_t, qt), Ut = ut(qt = pt[Qt - 4], _t = pt[Qt - 4 + 1]), Lt = lt(_t, qt), Ot = pt[Qt - 14], ft = pt[Qt - 14 + 1], Dt = pt[Qt - 32], Mt = pt[Qt - 32 + 1], Ft = Xt + ft | 0, Gt = Yt + Ot + dt(Ft, Xt) | 0;
        Gt = (Gt = Gt + Ut + dt(Ft = Ft + Lt | 0, Lt) | 0) + Dt + dt(Ft = Ft + Mt | 0, Mt) | 0, pt[Qt] = Gt, pt[Qt + 1] = Ft;
      }
      for (var zt = 0; zt < 160; zt += 2) {
        Gt = pt[zt], Ft = pt[zt + 1];
        var $t = rt(gt, wt, Bt), Ht = rt(vt, Et, bt), hn = it(gt, vt), un = it(vt, gt), An = ot(yt, St), mn = ot(St, yt), En = Ze[zt], Jt = Ze[zt + 1], an = et(yt, Ct, ht), cn = et(St, kt, jt), dn = Pt + mn | 0, yn = It + An + dt(dn, Pt) | 0;
        yn = (yn = (yn = yn + an + dt(dn = dn + cn | 0, cn) | 0) + En + dt(dn = dn + Jt | 0, Jt) | 0) + Gt + dt(dn = dn + Ft | 0, Ft) | 0;
        var Nn = un + Ht | 0, Rn = hn + $t + dt(Nn, un) | 0;
        It = ht, Pt = jt, ht = Ct, jt = kt, Ct = yt, kt = St, yt = Tt + yn + dt(St = Rt + dn | 0, Rt) | 0, Tt = Bt, Rt = bt, Bt = wt, bt = Et, wt = gt, Et = vt, gt = yn + Rn + dt(vt = dn + Nn | 0, dn) | 0;
      }
      this._al = this._al + vt | 0, this._bl = this._bl + Et | 0, this._cl = this._cl + bt | 0, this._dl = this._dl + Rt | 0, this._el = this._el + St | 0, this._fl = this._fl + kt | 0, this._gl = this._gl + jt | 0, this._hl = this._hl + Pt | 0, this._ah = this._ah + gt + dt(this._al, vt) | 0, this._bh = this._bh + wt + dt(this._bl, Et) | 0, this._ch = this._ch + Bt + dt(this._cl, bt) | 0, this._dh = this._dh + Tt + dt(this._dl, Rt) | 0, this._eh = this._eh + yt + dt(this._el, St) | 0, this._fh = this._fh + Ct + dt(this._fl, kt) | 0, this._gh = this._gh + ht + dt(this._gl, jt) | 0, this._hh = this._hh + It + dt(this._hl, Pt) | 0;
    }, tt.prototype._hash = function() {
      var At = Je.allocUnsafe(64);
      function pt(gt, wt, Bt) {
        At.writeInt32BE(gt, Bt), At.writeInt32BE(wt, Bt + 4);
      }
      return pt(this._ah, this._al, 0), pt(this._bh, this._bl, 8), pt(this._ch, this._cl, 16), pt(this._dh, this._dl, 24), pt(this._eh, this._el, 32), pt(this._fh, this._fl, 40), pt(this._gh, this._gl, 48), pt(this._hh, this._hl, 56), At;
    }, He.exports = tt;
  }, 4851: (He, Ge, Xe) => {
    He.exports = $e;
    var Ke = Xe(2699).EventEmitter;
    function $e() {
      Ke.call(this);
    }
    Xe(1285)($e, Ke), $e.Readable = Xe(8051), $e.Writable = Xe(2557), $e.Duplex = Xe(7073), $e.Transform = Xe(7640), $e.PassThrough = Xe(5163), $e.finished = Xe(9885), $e.pipeline = Xe(3495), $e.Stream = $e, $e.prototype.pipe = function(Je, Ze) {
      var nt = this;
      function tt(ut) {
        Je.writable && Je.write(ut) === !1 && nt.pause && nt.pause();
      }
      function et() {
        nt.readable && nt.resume && nt.resume();
      }
      nt.on("data", tt), Je.on("drain", et), Je._isStdio || Ze && Ze.end === !1 || (nt.on("end", it), nt.on("close", ot));
      var rt = !1;
      function it() {
        rt || (rt = !0, Je.end());
      }
      function ot() {
        rt || (rt = !0, typeof Je.destroy == "function" && Je.destroy());
      }
      function at(ut) {
        if (st(), Ke.listenerCount(this, "error") === 0) throw ut;
      }
      function st() {
        nt.removeListener("data", tt), Je.removeListener("drain", et), nt.removeListener("end", it), nt.removeListener("close", ot), nt.removeListener("error", at), Je.removeListener("error", at), nt.removeListener("end", st), nt.removeListener("close", st), Je.removeListener("close", st);
      }
      return nt.on("error", at), Je.on("error", at), nt.on("end", st), nt.on("close", st), Je.on("close", st), Je.emit("pipe", nt), Je;
    };
  }, 214: (He, Ge, Xe) => {
    var Ke = Xe(7834).Buffer, $e = Ke.isEncoding || function(st) {
      switch ((st = "" + st) && st.toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
          return !0;
        default:
          return !1;
      }
    };
    function Je(st) {
      var ut;
      switch (this.encoding = function(lt) {
        var dt = function(At) {
          if (!At) return "utf8";
          for (var pt; ; ) switch (At) {
            case "utf8":
            case "utf-8":
              return "utf8";
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return "utf16le";
            case "latin1":
            case "binary":
              return "latin1";
            case "base64":
            case "ascii":
            case "hex":
              return At;
            default:
              if (pt) return;
              At = ("" + At).toLowerCase(), pt = !0;
          }
        }(lt);
        if (typeof dt != "string" && (Ke.isEncoding === $e || !$e(lt))) throw new Error("Unknown encoding: " + lt);
        return dt || lt;
      }(st), this.encoding) {
        case "utf16le":
          this.text = tt, this.end = et, ut = 4;
          break;
        case "utf8":
          this.fillLast = nt, ut = 4;
          break;
        case "base64":
          this.text = rt, this.end = it, ut = 3;
          break;
        default:
          return this.write = ot, void (this.end = at);
      }
      this.lastNeed = 0, this.lastTotal = 0, this.lastChar = Ke.allocUnsafe(ut);
    }
    function Ze(st) {
      return st <= 127 ? 0 : st >> 5 == 6 ? 2 : st >> 4 == 14 ? 3 : st >> 3 == 30 ? 4 : st >> 6 == 2 ? -1 : -2;
    }
    function nt(st) {
      var ut = this.lastTotal - this.lastNeed, lt = function(dt, At, pt) {
        if ((192 & At[0]) != 128) return dt.lastNeed = 0, "�";
        if (dt.lastNeed > 1 && At.length > 1) {
          if ((192 & At[1]) != 128) return dt.lastNeed = 1, "�";
          if (dt.lastNeed > 2 && At.length > 2 && (192 & At[2]) != 128) return dt.lastNeed = 2, "�";
        }
      }(this, st);
      return lt !== void 0 ? lt : this.lastNeed <= st.length ? (st.copy(this.lastChar, ut, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (st.copy(this.lastChar, ut, 0, st.length), void (this.lastNeed -= st.length));
    }
    function tt(st, ut) {
      if ((st.length - ut) % 2 == 0) {
        var lt = st.toString("utf16le", ut);
        if (lt) {
          var dt = lt.charCodeAt(lt.length - 1);
          if (dt >= 55296 && dt <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = st[st.length - 2], this.lastChar[1] = st[st.length - 1], lt.slice(0, -1);
        }
        return lt;
      }
      return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = st[st.length - 1], st.toString("utf16le", ut, st.length - 1);
    }
    function et(st) {
      var ut = st && st.length ? this.write(st) : "";
      if (this.lastNeed) {
        var lt = this.lastTotal - this.lastNeed;
        return ut + this.lastChar.toString("utf16le", 0, lt);
      }
      return ut;
    }
    function rt(st, ut) {
      var lt = (st.length - ut) % 3;
      return lt === 0 ? st.toString("base64", ut) : (this.lastNeed = 3 - lt, this.lastTotal = 3, lt === 1 ? this.lastChar[0] = st[st.length - 1] : (this.lastChar[0] = st[st.length - 2], this.lastChar[1] = st[st.length - 1]), st.toString("base64", ut, st.length - lt));
    }
    function it(st) {
      var ut = st && st.length ? this.write(st) : "";
      return this.lastNeed ? ut + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : ut;
    }
    function ot(st) {
      return st.toString(this.encoding);
    }
    function at(st) {
      return st && st.length ? this.write(st) : "";
    }
    Ge.s = Je, Je.prototype.write = function(st) {
      if (st.length === 0) return "";
      var ut, lt;
      if (this.lastNeed) {
        if ((ut = this.fillLast(st)) === void 0) return "";
        lt = this.lastNeed, this.lastNeed = 0;
      } else lt = 0;
      return lt < st.length ? ut ? ut + this.text(st, lt) : this.text(st, lt) : ut || "";
    }, Je.prototype.end = function(st) {
      var ut = st && st.length ? this.write(st) : "";
      return this.lastNeed ? ut + "�" : ut;
    }, Je.prototype.text = function(st, ut) {
      var lt = function(At, pt, gt) {
        var wt = pt.length - 1;
        if (wt < gt) return 0;
        var Bt = Ze(pt[wt]);
        return Bt >= 0 ? (Bt > 0 && (At.lastNeed = Bt - 1), Bt) : --wt < gt || Bt === -2 ? 0 : (Bt = Ze(pt[wt])) >= 0 ? (Bt > 0 && (At.lastNeed = Bt - 2), Bt) : --wt < gt || Bt === -2 ? 0 : (Bt = Ze(pt[wt])) >= 0 ? (Bt > 0 && (Bt === 2 ? Bt = 0 : At.lastNeed = Bt - 3), Bt) : 0;
      }(this, st, ut);
      if (!this.lastNeed) return st.toString("utf8", ut);
      this.lastTotal = lt;
      var dt = st.length - (lt - this.lastNeed);
      return st.copy(this.lastChar, 0, dt), st.toString("utf8", ut, dt);
    }, Je.prototype.fillLast = function(st) {
      if (this.lastNeed <= st.length) return st.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
      st.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, st.length), this.lastNeed -= st.length;
    };
  }, 5803: (He, Ge, Xe) => {
    function Ke($e) {
      try {
        if (!Xe.g.localStorage) return !1;
      } catch {
        return !1;
      }
      var Je = Xe.g.localStorage[$e];
      return Je != null && String(Je).toLowerCase() === "true";
    }
    He.exports = function($e, Je) {
      if (Ke("noDeprecation")) return $e;
      var Ze = !1;
      return function() {
        if (!Ze) {
          if (Ke("throwDeprecation")) throw new Error(Je);
          Ke("traceDeprecation") ? console.trace(Je) : console.warn(Je), Ze = !0;
        }
        return $e.apply(this, arguments);
      };
    };
  }, 7573: () => {
  }, 5942: () => {
  }, 4854: () => {
  }, 6602: () => {
  } }, ue = {};
  function Qe(He) {
    var Ge = ue[He];
    if (Ge !== void 0) return Ge.exports;
    var Xe = ue[He] = { exports: {} };
    return me[He](Xe, Xe.exports, Qe), Xe.exports;
  }
  Qe.n = (He) => {
    var Ge = He && He.__esModule ? () => He.default : () => He;
    return Qe.d(Ge, { a: Ge }), Ge;
  }, Qe.d = (He, Ge) => {
    for (var Xe in Ge) Qe.o(Ge, Xe) && !Qe.o(He, Xe) && Object.defineProperty(He, Xe, { enumerable: !0, get: Ge[Xe] });
  }, Qe.g = function() {
    if (typeof globalThis == "object") return globalThis;
    try {
      return this || new Function("return this")();
    } catch {
      if (typeof window == "object") return window;
    }
  }(), Qe.o = (He, Ge) => Object.prototype.hasOwnProperty.call(He, Ge), Qe.r = (He) => {
    typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(He, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(He, "__esModule", { value: !0 });
  };
  var Ue = {};
  (() => {
    Qe.r(Ue), Qe.d(Ue, { encryptImage: () => Je, forge: () => tt() });
    var He = Qe(11), Ge = Qe.n(He), Xe = Qe(4406), Ke = Qe.n(Xe);
    function $e(et) {
      return new Promise(function(rt) {
        var it = Ge()("", "");
        it.on("readable", function() {
          var ot = it.read();
          ot && rt(ot.toString("hex"));
        }), it.write(et), it.end();
      });
    }
    function Je(et) {
      return rt = this, it = void 0, at = function() {
        var st;
        return function(ut, lt) {
          var dt, At, pt, gt, wt = { label: 0, sent: function() {
            if (1 & pt[0]) throw pt[1];
            return pt[1];
          }, trys: [], ops: [] };
          return gt = { next: Bt(0), throw: Bt(1), return: Bt(2) }, typeof Symbol == "function" && (gt[Symbol.iterator] = function() {
            return this;
          }), gt;
          function Bt(Tt) {
            return function(yt) {
              return function(Ct) {
                if (dt) throw new TypeError("Generator is already executing.");
                for (; wt; ) try {
                  if (dt = 1, At && (pt = 2 & Ct[0] ? At.return : Ct[0] ? At.throw || ((pt = At.return) && pt.call(At), 0) : At.next) && !(pt = pt.call(At, Ct[1])).done) return pt;
                  switch (At = 0, pt && (Ct = [2 & Ct[0], pt.value]), Ct[0]) {
                    case 0:
                    case 1:
                      pt = Ct;
                      break;
                    case 4:
                      return wt.label++, { value: Ct[1], done: !1 };
                    case 5:
                      wt.label++, At = Ct[1], Ct = [0];
                      continue;
                    case 7:
                      Ct = wt.ops.pop(), wt.trys.pop();
                      continue;
                    default:
                      if (!((pt = (pt = wt.trys).length > 0 && pt[pt.length - 1]) || Ct[0] !== 6 && Ct[0] !== 2)) {
                        wt = 0;
                        continue;
                      }
                      if (Ct[0] === 3 && (!pt || Ct[1] > pt[0] && Ct[1] < pt[3])) {
                        wt.label = Ct[1];
                        break;
                      }
                      if (Ct[0] === 6 && wt.label < pt[1]) {
                        wt.label = pt[1], pt = Ct;
                        break;
                      }
                      if (pt && wt.label < pt[2]) {
                        wt.label = pt[2], wt.ops.push(Ct);
                        break;
                      }
                      pt[2] && wt.ops.pop(), wt.trys.pop();
                      continue;
                  }
                  Ct = lt.call(ut, wt);
                } catch (ht) {
                  Ct = [6, ht], At = 0;
                } finally {
                  dt = pt = 0;
                }
                if (5 & Ct[0]) throw Ct[1];
                return { value: Ct[0] ? Ct[1] : void 0, done: !0 };
              }([Tt, yt]);
            };
          }
        }(this, function(ut) {
          switch (ut.label) {
            case 0:
              return [4, $e(et)];
            case 1:
              return st = ut.sent(), [2, Ze(et, st)];
          }
        });
      }, new ((ot = void 0) || (ot = Promise))(function(st, ut) {
        function lt(pt) {
          try {
            At(at.next(pt));
          } catch (gt) {
            ut(gt);
          }
        }
        function dt(pt) {
          try {
            At(at.throw(pt));
          } catch (gt) {
            ut(gt);
          }
        }
        function At(pt) {
          var gt;
          pt.done ? st(pt.value) : (gt = pt.value, gt instanceof ot ? gt : new ot(function(wt) {
            wt(gt);
          })).then(lt, dt);
        }
        At((at = at.apply(rt, it || [])).next());
      });
      var rt, it, ot, at;
    }
    function Ze(et, rt) {
      for (var it, ot, at, st = et, ut = 0; ut < rt.length; ut++) it = st, ot = ut + 64 * (ut + 1), at = rt.charAt(ut), st = "".concat(it.substring(0, ot)).concat(at).concat(it.substring(ot));
      return st;
    }
    Qe.g.process = Ke();
    var nt = Qe(6432), tt = Qe.n(nt);
  })(), window.__MODULE_DEFAULT_EXPORT__ = Ue;
})();
const __MODULE_DEFAULT_EXPORT__ = window.__MODULE_DEFAULT_EXPORT__;
delete window.__MODULE_DEFAULT_EXPORT__;
const { forge } = __MODULE_DEFAULT_EXPORT__, publicKeyUrl = "/e2ee/key/v2", postPublicKeyUrl = "/e2ee/key";
function getPublicKey() {
  return api.get(publicKeyUrl).then((me) => me.data).catch(emptyFunc);
}
function encryptRsaOaepSha1Mgf1(me, ue) {
  const Qe = me.encrypt(ue, "RSA-OAEP", {
    md: forge.md.sha256.create(),
    mgf1: {
      md: forge.md.sha1.create()
    }
  });
  return forge.util.bytesToHex(Qe);
}
function encryptAesGcm(me, ue, Qe) {
  try {
    const Ue = forge.random.getBytesSync(12), He = forge.cipher.createCipher("AES-GCM", me);
    He.start({ iv: Ue }), He.update(forge.util.createBuffer(JSON.stringify(ue), "utf8")), He.finish();
    const Ge = He.output.toHex(), Xe = He.mode.tag.toHex(), Ke = forge.util.bytesToHex(Ue);
    return {
      encryptedData: Ge + Xe,
      iv: Ke,
      encryptedKey: Qe
    };
  } catch (Ue) {
    throw new Error(Ue);
  }
}
function decryptAesGcm(me, ue) {
  try {
    const Qe = forge.util.hexToBytes(ue.iv), Ue = forge.util.hexToBytes(ue.encryptedData.slice(-32)), He = forge.cipher.createDecipher("AES-GCM", me);
    He.start({ iv: Qe, tag: Ue }), He.update(
      forge.util.createBuffer(
        forge.util.hexToBytes(ue.encryptedData.slice(0, -32))
      )
    ), He.finish();
    const Ge = He.output.getBytes();
    return forge.util.decodeUtf8(Ge);
  } catch (Qe) {
    throw new Error(Qe);
  }
}
function postPublicKey(me, ue, Qe, Ue) {
  return api.post(
    postPublicKeyUrl,
    {
      encryptedKey: me,
      encryptedIv: ue
    },
    {
      headers: {
        sessionId: Qe,
        "X-Incode-Hardware-Id": Ue
      }
    }
  ).then((He) => He.data);
}
async function publishKeys(me) {
  const ue = forge.random.getBytesSync(32), Qe = forge.random.getBytesSync(16), Ue = await getPublicKey(), He = `-----BEGIN PUBLIC KEY-----
${Ue.publicKey}
-----END PUBLIC KEY-----`, Ge = forge.pki.publicKeyFromPem(He), Xe = encryptRsaOaepSha1Mgf1(Ge, ue), Ke = encryptRsaOaepSha1Mgf1(Ge, Qe), $e = Ue.sessionId;
  return await postPublicKey(Xe, Ke, $e, me), api.interceptors.request.use(
    (Je) => {
      Je.headers.sessionid = $e;
      const Ze = encryptAesGcm(ue, Je.data, Xe);
      return Je.data = Ze, Je;
    },
    (Je) => Promise.reject(Je)
  ), api.interceptors.response.use(
    (Je) => {
      const Ze = decryptAesGcm(ue, Je.data);
      return Je.data = JSON.parse(Ze), Je;
    },
    (Je) => Promise.reject(Je)
  ), Xe;
}
function fixProto(me, ue) {
  var Qe = Object.setPrototypeOf;
  Qe ? Qe(me, ue) : me.__proto__ = ue;
}
function fixStack(me, ue) {
  ue === void 0 && (ue = me.constructor);
  var Qe = Error.captureStackTrace;
  Qe && Qe(me, ue);
}
var __extends$1a = /* @__PURE__ */ function() {
  var me = function(Qe, Ue) {
    return me = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function(He, Ge) {
      He.__proto__ = Ge;
    } || function(He, Ge) {
      for (var Xe in Ge)
        Object.prototype.hasOwnProperty.call(Ge, Xe) && (He[Xe] = Ge[Xe]);
    }, me(Qe, Ue);
  };
  return function(ue, Qe) {
    if (typeof Qe != "function" && Qe !== null) throw new TypeError("Class extends value " + String(Qe) + " is not a constructor or null");
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), CustomError = function(me) {
  __extends$1a(ue, me);
  function ue(Qe, Ue) {
    var He = this.constructor, Ge = me.call(this, Qe, Ue) || this;
    return Object.defineProperty(Ge, "name", {
      value: He.name,
      enumerable: !1,
      configurable: !0
    }), fixProto(Ge, He.prototype), fixStack(Ge), Ge;
  }
  return ue;
}(Error), __extends$19 = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), Exception = (
  /** @class */
  function(me) {
    __extends$19(ue, me);
    function ue(Qe) {
      Qe === void 0 && (Qe = void 0);
      var Ue = me.call(this, Qe) || this;
      return Ue.message = Qe, Ue;
    }
    return ue.prototype.getKind = function() {
      var Qe = this.constructor;
      return Qe.kind;
    }, ue.kind = "Exception", ue;
  }(CustomError)
), __extends$18 = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), ArgumentException = (
  /** @class */
  function(me) {
    __extends$18(ue, me);
    function ue() {
      return me !== null && me.apply(this, arguments) || this;
    }
    return ue.kind = "ArgumentException", ue;
  }(Exception)
), __extends$17 = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), IllegalArgumentException = (
  /** @class */
  function(me) {
    __extends$17(ue, me);
    function ue() {
      return me !== null && me.apply(this, arguments) || this;
    }
    return ue.kind = "IllegalArgumentException", ue;
  }(Exception)
), BinaryBitmap = (
  /** @class */
  function() {
    function me(ue) {
      if (this.binarizer = ue, ue === null)
        throw new IllegalArgumentException("Binarizer must be non-null.");
    }
    return me.prototype.getWidth = function() {
      return this.binarizer.getWidth();
    }, me.prototype.getHeight = function() {
      return this.binarizer.getHeight();
    }, me.prototype.getBlackRow = function(ue, Qe) {
      return this.binarizer.getBlackRow(ue, Qe);
    }, me.prototype.getBlackMatrix = function() {
      return (this.matrix === null || this.matrix === void 0) && (this.matrix = this.binarizer.getBlackMatrix()), this.matrix;
    }, me.prototype.isCropSupported = function() {
      return this.binarizer.getLuminanceSource().isCropSupported();
    }, me.prototype.crop = function(ue, Qe, Ue, He) {
      var Ge = this.binarizer.getLuminanceSource().crop(ue, Qe, Ue, He);
      return new me(this.binarizer.createBinarizer(Ge));
    }, me.prototype.isRotateSupported = function() {
      return this.binarizer.getLuminanceSource().isRotateSupported();
    }, me.prototype.rotateCounterClockwise = function() {
      var ue = this.binarizer.getLuminanceSource().rotateCounterClockwise();
      return new me(this.binarizer.createBinarizer(ue));
    }, me.prototype.rotateCounterClockwise45 = function() {
      var ue = this.binarizer.getLuminanceSource().rotateCounterClockwise45();
      return new me(this.binarizer.createBinarizer(ue));
    }, me.prototype.toString = function() {
      try {
        return this.getBlackMatrix().toString();
      } catch {
        return "";
      }
    }, me;
  }()
), __extends$16 = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), ChecksumException = (
  /** @class */
  function(me) {
    __extends$16(ue, me);
    function ue() {
      return me !== null && me.apply(this, arguments) || this;
    }
    return ue.getChecksumInstance = function() {
      return new ue();
    }, ue.kind = "ChecksumException", ue;
  }(Exception)
), Binarizer = (
  /** @class */
  function() {
    function me(ue) {
      this.source = ue;
    }
    return me.prototype.getLuminanceSource = function() {
      return this.source;
    }, me.prototype.getWidth = function() {
      return this.source.getWidth();
    }, me.prototype.getHeight = function() {
      return this.source.getHeight();
    }, me;
  }()
), System = (
  /** @class */
  function() {
    function me() {
    }
    return me.arraycopy = function(ue, Qe, Ue, He, Ge) {
      for (; Ge--; )
        Ue[He++] = ue[Qe++];
    }, me.currentTimeMillis = function() {
      return Date.now();
    }, me;
  }()
), __extends$15 = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), IndexOutOfBoundsException = (
  /** @class */
  function(me) {
    __extends$15(ue, me);
    function ue() {
      return me !== null && me.apply(this, arguments) || this;
    }
    return ue.kind = "IndexOutOfBoundsException", ue;
  }(Exception)
), __extends$14 = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), ArrayIndexOutOfBoundsException = (
  /** @class */
  function(me) {
    __extends$14(ue, me);
    function ue(Qe, Ue) {
      Qe === void 0 && (Qe = void 0), Ue === void 0 && (Ue = void 0);
      var He = me.call(this, Ue) || this;
      return He.index = Qe, He.message = Ue, He;
    }
    return ue.kind = "ArrayIndexOutOfBoundsException", ue;
  }(IndexOutOfBoundsException)
), __values$H = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Arrays = (
  /** @class */
  function() {
    function me() {
    }
    return me.fill = function(ue, Qe) {
      for (var Ue = 0, He = ue.length; Ue < He; Ue++)
        ue[Ue] = Qe;
    }, me.fillWithin = function(ue, Qe, Ue, He) {
      me.rangeCheck(ue.length, Qe, Ue);
      for (var Ge = Qe; Ge < Ue; Ge++)
        ue[Ge] = He;
    }, me.rangeCheck = function(ue, Qe, Ue) {
      if (Qe > Ue)
        throw new IllegalArgumentException("fromIndex(" + Qe + ") > toIndex(" + Ue + ")");
      if (Qe < 0)
        throw new ArrayIndexOutOfBoundsException(Qe);
      if (Ue > ue)
        throw new ArrayIndexOutOfBoundsException(Ue);
    }, me.asList = function() {
      for (var ue = [], Qe = 0; Qe < arguments.length; Qe++)
        ue[Qe] = arguments[Qe];
      return ue;
    }, me.create = function(ue, Qe, Ue) {
      var He = Array.from({ length: ue });
      return He.map(function(Ge) {
        return Array.from({ length: Qe }).fill(Ue);
      });
    }, me.createInt32Array = function(ue, Qe, Ue) {
      var He = Array.from({ length: ue });
      return He.map(function(Ge) {
        return Int32Array.from({ length: Qe }).fill(Ue);
      });
    }, me.equals = function(ue, Qe) {
      if (!ue || !Qe || !ue.length || !Qe.length || ue.length !== Qe.length)
        return !1;
      for (var Ue = 0, He = ue.length; Ue < He; Ue++)
        if (ue[Ue] !== Qe[Ue])
          return !1;
      return !0;
    }, me.hashCode = function(ue) {
      var Qe, Ue;
      if (ue === null)
        return 0;
      var He = 1;
      try {
        for (var Ge = __values$H(ue), Xe = Ge.next(); !Xe.done; Xe = Ge.next()) {
          var Ke = Xe.value;
          He = 31 * He + Ke;
        }
      } catch ($e) {
        Qe = { error: $e };
      } finally {
        try {
          Xe && !Xe.done && (Ue = Ge.return) && Ue.call(Ge);
        } finally {
          if (Qe) throw Qe.error;
        }
      }
      return He;
    }, me.fillUint8Array = function(ue, Qe) {
      for (var Ue = 0; Ue !== ue.length; Ue++)
        ue[Ue] = Qe;
    }, me.copyOf = function(ue, Qe) {
      return ue.slice(0, Qe);
    }, me.copyOfUint8Array = function(ue, Qe) {
      if (ue.length <= Qe) {
        var Ue = new Uint8Array(Qe);
        return Ue.set(ue), Ue;
      }
      return ue.slice(0, Qe);
    }, me.copyOfRange = function(ue, Qe, Ue) {
      var He = Ue - Qe, Ge = new Int32Array(He);
      return System.arraycopy(ue, Qe, Ge, 0, He), Ge;
    }, me.binarySearch = function(ue, Qe, Ue) {
      Ue === void 0 && (Ue = me.numberComparator);
      for (var He = 0, Ge = ue.length - 1; He <= Ge; ) {
        var Xe = Ge + He >> 1, Ke = Ue(Qe, ue[Xe]);
        if (Ke > 0)
          He = Xe + 1;
        else if (Ke < 0)
          Ge = Xe - 1;
        else
          return Xe;
      }
      return -He - 1;
    }, me.numberComparator = function(ue, Qe) {
      return ue - Qe;
    }, me;
  }()
), Integer = (
  /** @class */
  function() {
    function me() {
    }
    return me.numberOfTrailingZeros = function(ue) {
      var Qe;
      if (ue === 0)
        return 32;
      var Ue = 31;
      return Qe = ue << 16, Qe !== 0 && (Ue -= 16, ue = Qe), Qe = ue << 8, Qe !== 0 && (Ue -= 8, ue = Qe), Qe = ue << 4, Qe !== 0 && (Ue -= 4, ue = Qe), Qe = ue << 2, Qe !== 0 && (Ue -= 2, ue = Qe), Ue - (ue << 1 >>> 31);
    }, me.numberOfLeadingZeros = function(ue) {
      if (ue === 0)
        return 32;
      var Qe = 1;
      return ue >>> 16 || (Qe += 16, ue <<= 16), ue >>> 24 || (Qe += 8, ue <<= 8), ue >>> 28 || (Qe += 4, ue <<= 4), ue >>> 30 || (Qe += 2, ue <<= 2), Qe -= ue >>> 31, Qe;
    }, me.toHexString = function(ue) {
      return ue.toString(16);
    }, me.toBinaryString = function(ue) {
      return String(parseInt(String(ue), 2));
    }, me.bitCount = function(ue) {
      return ue = ue - (ue >>> 1 & 1431655765), ue = (ue & 858993459) + (ue >>> 2 & 858993459), ue = ue + (ue >>> 4) & 252645135, ue = ue + (ue >>> 8), ue = ue + (ue >>> 16), ue & 63;
    }, me.truncDivision = function(ue, Qe) {
      return Math.trunc(ue / Qe);
    }, me.parseInt = function(ue, Qe) {
      return Qe === void 0 && (Qe = void 0), parseInt(ue, Qe);
    }, me.MIN_VALUE_32_BITS = -2147483648, me.MAX_VALUE = Number.MAX_SAFE_INTEGER, me;
  }()
), BitArray = (
  /** @class */
  function() {
    function me(ue, Qe) {
      ue === void 0 ? (this.size = 0, this.bits = new Int32Array(1)) : (this.size = ue, Qe == null ? this.bits = me.makeArray(ue) : this.bits = Qe);
    }
    return me.prototype.getSize = function() {
      return this.size;
    }, me.prototype.getSizeInBytes = function() {
      return Math.floor((this.size + 7) / 8);
    }, me.prototype.ensureCapacity = function(ue) {
      if (ue > this.bits.length * 32) {
        var Qe = me.makeArray(ue);
        System.arraycopy(this.bits, 0, Qe, 0, this.bits.length), this.bits = Qe;
      }
    }, me.prototype.get = function(ue) {
      return (this.bits[Math.floor(ue / 32)] & 1 << (ue & 31)) !== 0;
    }, me.prototype.set = function(ue) {
      this.bits[Math.floor(ue / 32)] |= 1 << (ue & 31);
    }, me.prototype.flip = function(ue) {
      this.bits[Math.floor(ue / 32)] ^= 1 << (ue & 31);
    }, me.prototype.getNextSet = function(ue) {
      var Qe = this.size;
      if (ue >= Qe)
        return Qe;
      var Ue = this.bits, He = Math.floor(ue / 32), Ge = Ue[He];
      Ge &= ~((1 << (ue & 31)) - 1);
      for (var Xe = Ue.length; Ge === 0; ) {
        if (++He === Xe)
          return Qe;
        Ge = Ue[He];
      }
      var Ke = He * 32 + Integer.numberOfTrailingZeros(Ge);
      return Ke > Qe ? Qe : Ke;
    }, me.prototype.getNextUnset = function(ue) {
      var Qe = this.size;
      if (ue >= Qe)
        return Qe;
      var Ue = this.bits, He = Math.floor(ue / 32), Ge = ~Ue[He];
      Ge &= ~((1 << (ue & 31)) - 1);
      for (var Xe = Ue.length; Ge === 0; ) {
        if (++He === Xe)
          return Qe;
        Ge = ~Ue[He];
      }
      var Ke = He * 32 + Integer.numberOfTrailingZeros(Ge);
      return Ke > Qe ? Qe : Ke;
    }, me.prototype.setBulk = function(ue, Qe) {
      this.bits[Math.floor(ue / 32)] = Qe;
    }, me.prototype.setRange = function(ue, Qe) {
      if (Qe < ue || ue < 0 || Qe > this.size)
        throw new IllegalArgumentException();
      if (Qe !== ue) {
        Qe--;
        for (var Ue = Math.floor(ue / 32), He = Math.floor(Qe / 32), Ge = this.bits, Xe = Ue; Xe <= He; Xe++) {
          var Ke = Xe > Ue ? 0 : ue & 31, $e = Xe < He ? 31 : Qe & 31, Je = (2 << $e) - (1 << Ke);
          Ge[Xe] |= Je;
        }
      }
    }, me.prototype.clear = function() {
      for (var ue = this.bits.length, Qe = this.bits, Ue = 0; Ue < ue; Ue++)
        Qe[Ue] = 0;
    }, me.prototype.isRange = function(ue, Qe, Ue) {
      if (Qe < ue || ue < 0 || Qe > this.size)
        throw new IllegalArgumentException();
      if (Qe === ue)
        return !0;
      Qe--;
      for (var He = Math.floor(ue / 32), Ge = Math.floor(Qe / 32), Xe = this.bits, Ke = He; Ke <= Ge; Ke++) {
        var $e = Ke > He ? 0 : ue & 31, Je = Ke < Ge ? 31 : Qe & 31, Ze = (2 << Je) - (1 << $e) & 4294967295;
        if ((Xe[Ke] & Ze) !== (Ue ? Ze : 0))
          return !1;
      }
      return !0;
    }, me.prototype.appendBit = function(ue) {
      this.ensureCapacity(this.size + 1), ue && (this.bits[Math.floor(this.size / 32)] |= 1 << (this.size & 31)), this.size++;
    }, me.prototype.appendBits = function(ue, Qe) {
      if (Qe < 0 || Qe > 32)
        throw new IllegalArgumentException("Num bits must be between 0 and 32");
      this.ensureCapacity(this.size + Qe);
      for (var Ue = Qe; Ue > 0; Ue--)
        this.appendBit((ue >> Ue - 1 & 1) === 1);
    }, me.prototype.appendBitArray = function(ue) {
      var Qe = ue.size;
      this.ensureCapacity(this.size + Qe);
      for (var Ue = 0; Ue < Qe; Ue++)
        this.appendBit(ue.get(Ue));
    }, me.prototype.xor = function(ue) {
      if (this.size !== ue.size)
        throw new IllegalArgumentException("Sizes don't match");
      for (var Qe = this.bits, Ue = 0, He = Qe.length; Ue < He; Ue++)
        Qe[Ue] ^= ue.bits[Ue];
    }, me.prototype.toBytes = function(ue, Qe, Ue, He) {
      for (var Ge = 0; Ge < He; Ge++) {
        for (var Xe = 0, Ke = 0; Ke < 8; Ke++)
          this.get(ue) && (Xe |= 1 << 7 - Ke), ue++;
        Qe[Ue + Ge] = /*(byte)*/
        Xe;
      }
    }, me.prototype.getBitArray = function() {
      return this.bits;
    }, me.prototype.reverse = function() {
      for (var ue = new Int32Array(this.bits.length), Qe = Math.floor((this.size - 1) / 32), Ue = Qe + 1, He = this.bits, Ge = 0; Ge < Ue; Ge++) {
        var Xe = He[Ge];
        Xe = Xe >> 1 & 1431655765 | (Xe & 1431655765) << 1, Xe = Xe >> 2 & 858993459 | (Xe & 858993459) << 2, Xe = Xe >> 4 & 252645135 | (Xe & 252645135) << 4, Xe = Xe >> 8 & 16711935 | (Xe & 16711935) << 8, Xe = Xe >> 16 & 65535 | (Xe & 65535) << 16, ue[Qe - Ge] = /*(int)*/
        Xe;
      }
      if (this.size !== Ue * 32) {
        for (var Ke = Ue * 32 - this.size, $e = ue[0] >>> Ke, Ge = 1; Ge < Ue; Ge++) {
          var Je = ue[Ge];
          $e |= Je << 32 - Ke, ue[Ge - 1] = $e, $e = Je >>> Ke;
        }
        ue[Ue - 1] = $e;
      }
      this.bits = ue;
    }, me.makeArray = function(ue) {
      return new Int32Array(Math.floor((ue + 31) / 32));
    }, me.prototype.equals = function(ue) {
      if (!(ue instanceof me))
        return !1;
      var Qe = ue;
      return this.size === Qe.size && Arrays.equals(this.bits, Qe.bits);
    }, me.prototype.hashCode = function() {
      return 31 * this.size + Arrays.hashCode(this.bits);
    }, me.prototype.toString = function() {
      for (var ue = "", Qe = 0, Ue = this.size; Qe < Ue; Qe++)
        Qe & 7 || (ue += " "), ue += this.get(Qe) ? "X" : ".";
      return ue;
    }, me.prototype.clone = function() {
      return new me(this.size, this.bits.slice());
    }, me;
  }()
), DecodeHintType;
(function(me) {
  me[me.OTHER = 0] = "OTHER", me[me.PURE_BARCODE = 1] = "PURE_BARCODE", me[me.POSSIBLE_FORMATS = 2] = "POSSIBLE_FORMATS", me[me.TRY_HARDER = 3] = "TRY_HARDER", me[me.CHARACTER_SET = 4] = "CHARACTER_SET", me[me.ALLOWED_LENGTHS = 5] = "ALLOWED_LENGTHS", me[me.ASSUME_CODE_39_CHECK_DIGIT = 6] = "ASSUME_CODE_39_CHECK_DIGIT", me[me.ASSUME_GS1 = 7] = "ASSUME_GS1", me[me.RETURN_CODABAR_START_END = 8] = "RETURN_CODABAR_START_END", me[me.NEED_RESULT_POINT_CALLBACK = 9] = "NEED_RESULT_POINT_CALLBACK", me[me.ALLOWED_EAN_EXTENSIONS = 10] = "ALLOWED_EAN_EXTENSIONS";
})(DecodeHintType || (DecodeHintType = {}));
const DecodeHintType$1 = DecodeHintType;
var __extends$13 = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), FormatException = (
  /** @class */
  function(me) {
    __extends$13(ue, me);
    function ue() {
      return me !== null && me.apply(this, arguments) || this;
    }
    return ue.getFormatInstance = function() {
      return new ue();
    }, ue.kind = "FormatException", ue;
  }(Exception)
), __values$G = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, CharacterSetValueIdentifiers;
(function(me) {
  me[me.Cp437 = 0] = "Cp437", me[me.ISO8859_1 = 1] = "ISO8859_1", me[me.ISO8859_2 = 2] = "ISO8859_2", me[me.ISO8859_3 = 3] = "ISO8859_3", me[me.ISO8859_4 = 4] = "ISO8859_4", me[me.ISO8859_5 = 5] = "ISO8859_5", me[me.ISO8859_6 = 6] = "ISO8859_6", me[me.ISO8859_7 = 7] = "ISO8859_7", me[me.ISO8859_8 = 8] = "ISO8859_8", me[me.ISO8859_9 = 9] = "ISO8859_9", me[me.ISO8859_10 = 10] = "ISO8859_10", me[me.ISO8859_11 = 11] = "ISO8859_11", me[me.ISO8859_13 = 12] = "ISO8859_13", me[me.ISO8859_14 = 13] = "ISO8859_14", me[me.ISO8859_15 = 14] = "ISO8859_15", me[me.ISO8859_16 = 15] = "ISO8859_16", me[me.SJIS = 16] = "SJIS", me[me.Cp1250 = 17] = "Cp1250", me[me.Cp1251 = 18] = "Cp1251", me[me.Cp1252 = 19] = "Cp1252", me[me.Cp1256 = 20] = "Cp1256", me[me.UnicodeBigUnmarked = 21] = "UnicodeBigUnmarked", me[me.UTF8 = 22] = "UTF8", me[me.ASCII = 23] = "ASCII", me[me.Big5 = 24] = "Big5", me[me.GB18030 = 25] = "GB18030", me[me.EUC_KR = 26] = "EUC_KR";
})(CharacterSetValueIdentifiers || (CharacterSetValueIdentifiers = {}));
var CharacterSetECI = (
  /** @class */
  function() {
    function me(ue, Qe, Ue) {
      for (var He, Ge, Xe = [], Ke = 3; Ke < arguments.length; Ke++)
        Xe[Ke - 3] = arguments[Ke];
      this.valueIdentifier = ue, this.name = Ue, typeof Qe == "number" ? this.values = Int32Array.from([Qe]) : this.values = Qe, this.otherEncodingNames = Xe, me.VALUE_IDENTIFIER_TO_ECI.set(ue, this), me.NAME_TO_ECI.set(Ue, this);
      for (var $e = this.values, Je = 0, Ze = $e.length; Je !== Ze; Je++) {
        var nt = $e[Je];
        me.VALUES_TO_ECI.set(nt, this);
      }
      try {
        for (var tt = __values$G(Xe), et = tt.next(); !et.done; et = tt.next()) {
          var rt = et.value;
          me.NAME_TO_ECI.set(rt, this);
        }
      } catch (it) {
        He = { error: it };
      } finally {
        try {
          et && !et.done && (Ge = tt.return) && Ge.call(tt);
        } finally {
          if (He) throw He.error;
        }
      }
    }
    return me.prototype.getValueIdentifier = function() {
      return this.valueIdentifier;
    }, me.prototype.getName = function() {
      return this.name;
    }, me.prototype.getValue = function() {
      return this.values[0];
    }, me.getCharacterSetECIByValue = function(ue) {
      if (ue < 0 || ue >= 900)
        throw new FormatException("incorect value");
      var Qe = me.VALUES_TO_ECI.get(ue);
      if (Qe === void 0)
        throw new FormatException("incorect value");
      return Qe;
    }, me.getCharacterSetECIByName = function(ue) {
      var Qe = me.NAME_TO_ECI.get(ue);
      if (Qe === void 0)
        throw new FormatException("incorect value");
      return Qe;
    }, me.prototype.equals = function(ue) {
      if (!(ue instanceof me))
        return !1;
      var Qe = ue;
      return this.getName() === Qe.getName();
    }, me.VALUE_IDENTIFIER_TO_ECI = /* @__PURE__ */ new Map(), me.VALUES_TO_ECI = /* @__PURE__ */ new Map(), me.NAME_TO_ECI = /* @__PURE__ */ new Map(), me.Cp437 = new me(CharacterSetValueIdentifiers.Cp437, Int32Array.from([0, 2]), "Cp437"), me.ISO8859_1 = new me(CharacterSetValueIdentifiers.ISO8859_1, Int32Array.from([1, 3]), "ISO-8859-1", "ISO88591", "ISO8859_1"), me.ISO8859_2 = new me(CharacterSetValueIdentifiers.ISO8859_2, 4, "ISO-8859-2", "ISO88592", "ISO8859_2"), me.ISO8859_3 = new me(CharacterSetValueIdentifiers.ISO8859_3, 5, "ISO-8859-3", "ISO88593", "ISO8859_3"), me.ISO8859_4 = new me(CharacterSetValueIdentifiers.ISO8859_4, 6, "ISO-8859-4", "ISO88594", "ISO8859_4"), me.ISO8859_5 = new me(CharacterSetValueIdentifiers.ISO8859_5, 7, "ISO-8859-5", "ISO88595", "ISO8859_5"), me.ISO8859_6 = new me(CharacterSetValueIdentifiers.ISO8859_6, 8, "ISO-8859-6", "ISO88596", "ISO8859_6"), me.ISO8859_7 = new me(CharacterSetValueIdentifiers.ISO8859_7, 9, "ISO-8859-7", "ISO88597", "ISO8859_7"), me.ISO8859_8 = new me(CharacterSetValueIdentifiers.ISO8859_8, 10, "ISO-8859-8", "ISO88598", "ISO8859_8"), me.ISO8859_9 = new me(CharacterSetValueIdentifiers.ISO8859_9, 11, "ISO-8859-9", "ISO88599", "ISO8859_9"), me.ISO8859_10 = new me(CharacterSetValueIdentifiers.ISO8859_10, 12, "ISO-8859-10", "ISO885910", "ISO8859_10"), me.ISO8859_11 = new me(CharacterSetValueIdentifiers.ISO8859_11, 13, "ISO-8859-11", "ISO885911", "ISO8859_11"), me.ISO8859_13 = new me(CharacterSetValueIdentifiers.ISO8859_13, 15, "ISO-8859-13", "ISO885913", "ISO8859_13"), me.ISO8859_14 = new me(CharacterSetValueIdentifiers.ISO8859_14, 16, "ISO-8859-14", "ISO885914", "ISO8859_14"), me.ISO8859_15 = new me(CharacterSetValueIdentifiers.ISO8859_15, 17, "ISO-8859-15", "ISO885915", "ISO8859_15"), me.ISO8859_16 = new me(CharacterSetValueIdentifiers.ISO8859_16, 18, "ISO-8859-16", "ISO885916", "ISO8859_16"), me.SJIS = new me(CharacterSetValueIdentifiers.SJIS, 20, "SJIS", "Shift_JIS"), me.Cp1250 = new me(CharacterSetValueIdentifiers.Cp1250, 21, "Cp1250", "windows-1250"), me.Cp1251 = new me(CharacterSetValueIdentifiers.Cp1251, 22, "Cp1251", "windows-1251"), me.Cp1252 = new me(CharacterSetValueIdentifiers.Cp1252, 23, "Cp1252", "windows-1252"), me.Cp1256 = new me(CharacterSetValueIdentifiers.Cp1256, 24, "Cp1256", "windows-1256"), me.UnicodeBigUnmarked = new me(CharacterSetValueIdentifiers.UnicodeBigUnmarked, 25, "UnicodeBigUnmarked", "UTF-16BE", "UnicodeBig"), me.UTF8 = new me(CharacterSetValueIdentifiers.UTF8, 26, "UTF8", "UTF-8"), me.ASCII = new me(CharacterSetValueIdentifiers.ASCII, Int32Array.from([27, 170]), "ASCII", "US-ASCII"), me.Big5 = new me(CharacterSetValueIdentifiers.Big5, 28, "Big5"), me.GB18030 = new me(CharacterSetValueIdentifiers.GB18030, 29, "GB18030", "GB2312", "EUC_CN", "GBK"), me.EUC_KR = new me(CharacterSetValueIdentifiers.EUC_KR, 30, "EUC_KR", "EUC-KR"), me;
  }()
), __extends$12 = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), UnsupportedOperationException = (
  /** @class */
  function(me) {
    __extends$12(ue, me);
    function ue() {
      return me !== null && me.apply(this, arguments) || this;
    }
    return ue.kind = "UnsupportedOperationException", ue;
  }(Exception)
), StringEncoding = (
  /** @class */
  function() {
    function me() {
    }
    return me.decode = function(ue, Qe) {
      var Ue = this.encodingName(Qe);
      return this.customDecoder ? this.customDecoder(ue, Ue) : typeof TextDecoder > "u" || this.shouldDecodeOnFallback(Ue) ? this.decodeFallback(ue, Ue) : new TextDecoder(Ue).decode(ue);
    }, me.shouldDecodeOnFallback = function(ue) {
      return !me.isBrowser() && ue === "ISO-8859-1";
    }, me.encode = function(ue, Qe) {
      var Ue = this.encodingName(Qe);
      return this.customEncoder ? this.customEncoder(ue, Ue) : typeof TextEncoder > "u" ? this.encodeFallback(ue) : new TextEncoder().encode(ue);
    }, me.isBrowser = function() {
      return typeof window < "u" && {}.toString.call(window) === "[object Window]";
    }, me.encodingName = function(ue) {
      return typeof ue == "string" ? ue : ue.getName();
    }, me.encodingCharacterSet = function(ue) {
      return ue instanceof CharacterSetECI ? ue : CharacterSetECI.getCharacterSetECIByName(ue);
    }, me.decodeFallback = function(ue, Qe) {
      var Ue = this.encodingCharacterSet(Qe);
      if (me.isDecodeFallbackSupported(Ue)) {
        for (var He = "", Ge = 0, Xe = ue.length; Ge < Xe; Ge++) {
          var Ke = ue[Ge].toString(16);
          Ke.length < 2 && (Ke = "0" + Ke), He += "%" + Ke;
        }
        return decodeURIComponent(He);
      }
      if (Ue.equals(CharacterSetECI.UnicodeBigUnmarked))
        return String.fromCharCode.apply(null, new Uint16Array(ue.buffer));
      throw new UnsupportedOperationException("Encoding " + this.encodingName(Qe) + " not supported by fallback.");
    }, me.isDecodeFallbackSupported = function(ue) {
      return ue.equals(CharacterSetECI.UTF8) || ue.equals(CharacterSetECI.ISO8859_1) || ue.equals(CharacterSetECI.ASCII);
    }, me.encodeFallback = function(ue) {
      for (var Qe = btoa(unescape(encodeURIComponent(ue))), Ue = Qe.split(""), He = [], Ge = 0; Ge < Ue.length; Ge++)
        He.push(Ue[Ge].charCodeAt(0));
      return new Uint8Array(He);
    }, me;
  }()
), StringUtils = (
  /** @class */
  function() {
    function me() {
    }
    return me.castAsNonUtf8Char = function(ue, Qe) {
      Qe === void 0 && (Qe = null);
      var Ue = Qe ? Qe.getName() : this.ISO88591;
      return StringEncoding.decode(new Uint8Array([ue]), Ue);
    }, me.guessEncoding = function(ue, Qe) {
      if (Qe != null && Qe.get(DecodeHintType$1.CHARACTER_SET) !== void 0)
        return Qe.get(DecodeHintType$1.CHARACTER_SET).toString();
      for (var Ue = ue.length, He = !0, Ge = !0, Xe = !0, Ke = 0, $e = 0, Je = 0, Ze = 0, nt = 0, tt = 0, et = 0, rt = 0, it = 0, ot = 0, at = 0, st = ue.length > 3 && ue[0] === /*(byte) */
      239 && ue[1] === /*(byte) */
      187 && ue[2] === /*(byte) */
      191, ut = 0; ut < Ue && (He || Ge || Xe); ut++) {
        var lt = ue[ut] & 255;
        Xe && (Ke > 0 ? lt & 128 ? Ke-- : Xe = !1 : lt & 128 && (lt & 64 ? (Ke++, lt & 32 ? (Ke++, lt & 16 ? (Ke++, lt & 8 ? Xe = !1 : Ze++) : Je++) : $e++) : Xe = !1)), He && (lt > 127 && lt < 160 ? He = !1 : lt > 159 && (lt < 192 || lt === 215 || lt === 247) && at++), Ge && (nt > 0 ? lt < 64 || lt === 127 || lt > 252 ? Ge = !1 : nt-- : lt === 128 || lt === 160 || lt > 239 ? Ge = !1 : lt > 160 && lt < 224 ? (tt++, rt = 0, et++, et > it && (it = et)) : lt > 127 ? (nt++, et = 0, rt++, rt > ot && (ot = rt)) : (et = 0, rt = 0));
      }
      return Xe && Ke > 0 && (Xe = !1), Ge && nt > 0 && (Ge = !1), Xe && (st || $e + Je + Ze > 0) ? me.UTF8 : Ge && (me.ASSUME_SHIFT_JIS || it >= 3 || ot >= 3) ? me.SHIFT_JIS : He && Ge ? it === 2 && tt === 2 || at * 10 >= Ue ? me.SHIFT_JIS : me.ISO88591 : He ? me.ISO88591 : Ge ? me.SHIFT_JIS : Xe ? me.UTF8 : me.PLATFORM_DEFAULT_ENCODING;
    }, me.format = function(ue) {
      for (var Qe = [], Ue = 1; Ue < arguments.length; Ue++)
        Qe[Ue - 1] = arguments[Ue];
      var He = -1;
      function Ge(Ke, $e, Je, Ze, nt, tt) {
        if (Ke === "%%")
          return "%";
        if (Qe[++He] !== void 0) {
          Ke = Ze ? parseInt(Ze.substr(1)) : void 0;
          var et = nt ? parseInt(nt.substr(1)) : void 0, rt;
          switch (tt) {
            case "s":
              rt = Qe[He];
              break;
            case "c":
              rt = Qe[He][0];
              break;
            case "f":
              rt = parseFloat(Qe[He]).toFixed(Ke);
              break;
            case "p":
              rt = parseFloat(Qe[He]).toPrecision(Ke);
              break;
            case "e":
              rt = parseFloat(Qe[He]).toExponential(Ke);
              break;
            case "x":
              rt = parseInt(Qe[He]).toString(et || 16);
              break;
            case "d":
              rt = parseFloat(parseInt(Qe[He], et || 10).toPrecision(Ke)).toFixed(0);
              break;
          }
          rt = typeof rt == "object" ? JSON.stringify(rt) : (+rt).toString(et);
          for (var it = parseInt(Je), ot = Je && Je[0] + "" == "0" ? "0" : " "; rt.length < it; )
            rt = $e !== void 0 ? rt + ot : ot + rt;
          return rt;
        }
      }
      var Xe = /%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g;
      return ue.replace(Xe, Ge);
    }, me.getBytes = function(ue, Qe) {
      return StringEncoding.encode(ue, Qe);
    }, me.getCharCode = function(ue, Qe) {
      return Qe === void 0 && (Qe = 0), ue.charCodeAt(Qe);
    }, me.getCharAt = function(ue) {
      return String.fromCharCode(ue);
    }, me.SHIFT_JIS = CharacterSetECI.SJIS.getName(), me.GB2312 = "GB2312", me.ISO88591 = CharacterSetECI.ISO8859_1.getName(), me.EUC_JP = "EUC_JP", me.UTF8 = CharacterSetECI.UTF8.getName(), me.PLATFORM_DEFAULT_ENCODING = me.UTF8, me.ASSUME_SHIFT_JIS = !1, me;
  }()
), StringBuilder = (
  /** @class */
  function() {
    function me(ue) {
      ue === void 0 && (ue = ""), this.value = ue;
    }
    return me.prototype.enableDecoding = function(ue) {
      return this.encoding = ue, this;
    }, me.prototype.append = function(ue) {
      return typeof ue == "string" ? this.value += ue.toString() : this.encoding ? this.value += StringUtils.castAsNonUtf8Char(ue, this.encoding) : this.value += String.fromCharCode(ue), this;
    }, me.prototype.appendChars = function(ue, Qe, Ue) {
      for (var He = Qe; Qe < Qe + Ue; He++)
        this.append(ue[He]);
      return this;
    }, me.prototype.length = function() {
      return this.value.length;
    }, me.prototype.charAt = function(ue) {
      return this.value.charAt(ue);
    }, me.prototype.deleteCharAt = function(ue) {
      this.value = this.value.substr(0, ue) + this.value.substring(ue + 1);
    }, me.prototype.setCharAt = function(ue, Qe) {
      this.value = this.value.substr(0, ue) + Qe + this.value.substr(ue + 1);
    }, me.prototype.substring = function(ue, Qe) {
      return this.value.substring(ue, Qe);
    }, me.prototype.setLengthToZero = function() {
      this.value = "";
    }, me.prototype.toString = function() {
      return this.value;
    }, me.prototype.insert = function(ue, Qe) {
      this.value = this.value.substr(0, ue) + Qe + this.value.substr(ue + Qe.length);
    }, me;
  }()
), BitMatrix = (
  /** @class */
  function() {
    function me(ue, Qe, Ue, He) {
      if (this.width = ue, this.height = Qe, this.rowSize = Ue, this.bits = He, Qe == null && (Qe = ue), this.height = Qe, ue < 1 || Qe < 1)
        throw new IllegalArgumentException("Both dimensions must be greater than 0");
      Ue == null && (Ue = Math.floor((ue + 31) / 32)), this.rowSize = Ue, He == null && (this.bits = new Int32Array(this.rowSize * this.height));
    }
    return me.parseFromBooleanArray = function(ue) {
      for (var Qe = ue.length, Ue = ue[0].length, He = new me(Ue, Qe), Ge = 0; Ge < Qe; Ge++)
        for (var Xe = ue[Ge], Ke = 0; Ke < Ue; Ke++)
          Xe[Ke] && He.set(Ke, Ge);
      return He;
    }, me.parseFromString = function(ue, Qe, Ue) {
      if (ue === null)
        throw new IllegalArgumentException("stringRepresentation cannot be null");
      for (var He = new Array(ue.length), Ge = 0, Xe = 0, Ke = -1, $e = 0, Je = 0; Je < ue.length; )
        if (ue.charAt(Je) === `
` || ue.charAt(Je) === "\r") {
          if (Ge > Xe) {
            if (Ke === -1)
              Ke = Ge - Xe;
            else if (Ge - Xe !== Ke)
              throw new IllegalArgumentException("row lengths do not match");
            Xe = Ge, $e++;
          }
          Je++;
        } else if (ue.substring(Je, Je + Qe.length) === Qe)
          Je += Qe.length, He[Ge] = !0, Ge++;
        else if (ue.substring(Je, Je + Ue.length) === Ue)
          Je += Ue.length, He[Ge] = !1, Ge++;
        else
          throw new IllegalArgumentException("illegal character encountered: " + ue.substring(Je));
      if (Ge > Xe) {
        if (Ke === -1)
          Ke = Ge - Xe;
        else if (Ge - Xe !== Ke)
          throw new IllegalArgumentException("row lengths do not match");
        $e++;
      }
      for (var Ze = new me(Ke, $e), nt = 0; nt < Ge; nt++)
        He[nt] && Ze.set(Math.floor(nt % Ke), Math.floor(nt / Ke));
      return Ze;
    }, me.prototype.get = function(ue, Qe) {
      var Ue = Qe * this.rowSize + Math.floor(ue / 32);
      return (this.bits[Ue] >>> (ue & 31) & 1) !== 0;
    }, me.prototype.set = function(ue, Qe) {
      var Ue = Qe * this.rowSize + Math.floor(ue / 32);
      this.bits[Ue] |= 1 << (ue & 31) & 4294967295;
    }, me.prototype.unset = function(ue, Qe) {
      var Ue = Qe * this.rowSize + Math.floor(ue / 32);
      this.bits[Ue] &= ~(1 << (ue & 31) & 4294967295);
    }, me.prototype.flip = function(ue, Qe) {
      var Ue = Qe * this.rowSize + Math.floor(ue / 32);
      this.bits[Ue] ^= 1 << (ue & 31) & 4294967295;
    }, me.prototype.xor = function(ue) {
      if (this.width !== ue.getWidth() || this.height !== ue.getHeight() || this.rowSize !== ue.getRowSize())
        throw new IllegalArgumentException("input matrix dimensions do not match");
      for (var Qe = new BitArray(Math.floor(this.width / 32) + 1), Ue = this.rowSize, He = this.bits, Ge = 0, Xe = this.height; Ge < Xe; Ge++)
        for (var Ke = Ge * Ue, $e = ue.getRow(Ge, Qe).getBitArray(), Je = 0; Je < Ue; Je++)
          He[Ke + Je] ^= $e[Je];
    }, me.prototype.clear = function() {
      for (var ue = this.bits, Qe = ue.length, Ue = 0; Ue < Qe; Ue++)
        ue[Ue] = 0;
    }, me.prototype.setRegion = function(ue, Qe, Ue, He) {
      if (Qe < 0 || ue < 0)
        throw new IllegalArgumentException("Left and top must be nonnegative");
      if (He < 1 || Ue < 1)
        throw new IllegalArgumentException("Height and width must be at least 1");
      var Ge = ue + Ue, Xe = Qe + He;
      if (Xe > this.height || Ge > this.width)
        throw new IllegalArgumentException("The region must fit inside the matrix");
      for (var Ke = this.rowSize, $e = this.bits, Je = Qe; Je < Xe; Je++)
        for (var Ze = Je * Ke, nt = ue; nt < Ge; nt++)
          $e[Ze + Math.floor(nt / 32)] |= 1 << (nt & 31) & 4294967295;
    }, me.prototype.getRow = function(ue, Qe) {
      Qe == null || Qe.getSize() < this.width ? Qe = new BitArray(this.width) : Qe.clear();
      for (var Ue = this.rowSize, He = this.bits, Ge = ue * Ue, Xe = 0; Xe < Ue; Xe++)
        Qe.setBulk(Xe * 32, He[Ge + Xe]);
      return Qe;
    }, me.prototype.setRow = function(ue, Qe) {
      System.arraycopy(Qe.getBitArray(), 0, this.bits, ue * this.rowSize, this.rowSize);
    }, me.prototype.rotate180 = function() {
      for (var ue = this.getWidth(), Qe = this.getHeight(), Ue = new BitArray(ue), He = new BitArray(ue), Ge = 0, Xe = Math.floor((Qe + 1) / 2); Ge < Xe; Ge++)
        Ue = this.getRow(Ge, Ue), He = this.getRow(Qe - 1 - Ge, He), Ue.reverse(), He.reverse(), this.setRow(Ge, He), this.setRow(Qe - 1 - Ge, Ue);
    }, me.prototype.getEnclosingRectangle = function() {
      for (var ue = this.width, Qe = this.height, Ue = this.rowSize, He = this.bits, Ge = ue, Xe = Qe, Ke = -1, $e = -1, Je = 0; Je < Qe; Je++)
        for (var Ze = 0; Ze < Ue; Ze++) {
          var nt = He[Je * Ue + Ze];
          if (nt !== 0) {
            if (Je < Xe && (Xe = Je), Je > $e && ($e = Je), Ze * 32 < Ge) {
              for (var tt = 0; !(nt << 31 - tt & 4294967295); )
                tt++;
              Ze * 32 + tt < Ge && (Ge = Ze * 32 + tt);
            }
            if (Ze * 32 + 31 > Ke) {
              for (var tt = 31; !(nt >>> tt); )
                tt--;
              Ze * 32 + tt > Ke && (Ke = Ze * 32 + tt);
            }
          }
        }
      return Ke < Ge || $e < Xe ? null : Int32Array.from([Ge, Xe, Ke - Ge + 1, $e - Xe + 1]);
    }, me.prototype.getTopLeftOnBit = function() {
      for (var ue = this.rowSize, Qe = this.bits, Ue = 0; Ue < Qe.length && Qe[Ue] === 0; )
        Ue++;
      if (Ue === Qe.length)
        return null;
      for (var He = Ue / ue, Ge = Ue % ue * 32, Xe = Qe[Ue], Ke = 0; !(Xe << 31 - Ke & 4294967295); )
        Ke++;
      return Ge += Ke, Int32Array.from([Ge, He]);
    }, me.prototype.getBottomRightOnBit = function() {
      for (var ue = this.rowSize, Qe = this.bits, Ue = Qe.length - 1; Ue >= 0 && Qe[Ue] === 0; )
        Ue--;
      if (Ue < 0)
        return null;
      for (var He = Math.floor(Ue / ue), Ge = Math.floor(Ue % ue) * 32, Xe = Qe[Ue], Ke = 31; !(Xe >>> Ke); )
        Ke--;
      return Ge += Ke, Int32Array.from([Ge, He]);
    }, me.prototype.getWidth = function() {
      return this.width;
    }, me.prototype.getHeight = function() {
      return this.height;
    }, me.prototype.getRowSize = function() {
      return this.rowSize;
    }, me.prototype.equals = function(ue) {
      if (!(ue instanceof me))
        return !1;
      var Qe = ue;
      return this.width === Qe.width && this.height === Qe.height && this.rowSize === Qe.rowSize && Arrays.equals(this.bits, Qe.bits);
    }, me.prototype.hashCode = function() {
      var ue = this.width;
      return ue = 31 * ue + this.width, ue = 31 * ue + this.height, ue = 31 * ue + this.rowSize, ue = 31 * ue + Arrays.hashCode(this.bits), ue;
    }, me.prototype.toString = function(ue, Qe, Ue) {
      return ue === void 0 && (ue = "X "), Qe === void 0 && (Qe = "  "), Ue === void 0 && (Ue = `
`), this.buildToString(ue, Qe, Ue);
    }, me.prototype.buildToString = function(ue, Qe, Ue) {
      for (var He = new StringBuilder(), Ge = 0, Xe = this.height; Ge < Xe; Ge++) {
        for (var Ke = 0, $e = this.width; Ke < $e; Ke++)
          He.append(this.get(Ke, Ge) ? ue : Qe);
        He.append(Ue);
      }
      return He.toString();
    }, me.prototype.clone = function() {
      return new me(this.width, this.height, this.rowSize, this.bits.slice());
    }, me;
  }()
), __extends$11 = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), NotFoundException = (
  /** @class */
  function(me) {
    __extends$11(ue, me);
    function ue() {
      return me !== null && me.apply(this, arguments) || this;
    }
    return ue.getNotFoundInstance = function() {
      return new ue();
    }, ue.kind = "NotFoundException", ue;
  }(Exception)
), __extends$10 = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), GlobalHistogramBinarizer = (
  /** @class */
  function(me) {
    __extends$10(ue, me);
    function ue(Qe) {
      var Ue = me.call(this, Qe) || this;
      return Ue.luminances = ue.EMPTY, Ue.buckets = new Int32Array(ue.LUMINANCE_BUCKETS), Ue;
    }
    return ue.prototype.getBlackRow = function(Qe, Ue) {
      var He = this.getLuminanceSource(), Ge = He.getWidth();
      Ue == null || Ue.getSize() < Ge ? Ue = new BitArray(Ge) : Ue.clear(), this.initArrays(Ge);
      for (var Xe = He.getRow(Qe, this.luminances), Ke = this.buckets, $e = 0; $e < Ge; $e++)
        Ke[(Xe[$e] & 255) >> ue.LUMINANCE_SHIFT]++;
      var Je = ue.estimateBlackPoint(Ke);
      if (Ge < 3)
        for (var $e = 0; $e < Ge; $e++)
          (Xe[$e] & 255) < Je && Ue.set($e);
      else
        for (var Ze = Xe[0] & 255, nt = Xe[1] & 255, $e = 1; $e < Ge - 1; $e++) {
          var tt = Xe[$e + 1] & 255;
          (nt * 4 - Ze - tt) / 2 < Je && Ue.set($e), Ze = nt, nt = tt;
        }
      return Ue;
    }, ue.prototype.getBlackMatrix = function() {
      var Qe = this.getLuminanceSource(), Ue = Qe.getWidth(), He = Qe.getHeight(), Ge = new BitMatrix(Ue, He);
      this.initArrays(Ue);
      for (var Xe = this.buckets, Ke = 1; Ke < 5; Ke++)
        for (var $e = Math.floor(He * Ke / 5), Je = Qe.getRow($e, this.luminances), Ze = Math.floor(Ue * 4 / 5), nt = Math.floor(Ue / 5); nt < Ze; nt++) {
          var tt = Je[nt] & 255;
          Xe[tt >> ue.LUMINANCE_SHIFT]++;
        }
      for (var et = ue.estimateBlackPoint(Xe), rt = Qe.getMatrix(), Ke = 0; Ke < He; Ke++)
        for (var it = Ke * Ue, nt = 0; nt < Ue; nt++) {
          var tt = rt[it + nt] & 255;
          tt < et && Ge.set(nt, Ke);
        }
      return Ge;
    }, ue.prototype.createBinarizer = function(Qe) {
      return new ue(Qe);
    }, ue.prototype.initArrays = function(Qe) {
      this.luminances.length < Qe && (this.luminances = new Uint8ClampedArray(Qe));
      for (var Ue = this.buckets, He = 0; He < ue.LUMINANCE_BUCKETS; He++)
        Ue[He] = 0;
    }, ue.estimateBlackPoint = function(Qe) {
      for (var Ue = Qe.length, He = 0, Ge = 0, Xe = 0, Ke = 0; Ke < Ue; Ke++)
        Qe[Ke] > Xe && (Ge = Ke, Xe = Qe[Ke]), Qe[Ke] > He && (He = Qe[Ke]);
      for (var $e = 0, Je = 0, Ke = 0; Ke < Ue; Ke++) {
        var Ze = Ke - Ge, nt = Qe[Ke] * Ze * Ze;
        nt > Je && ($e = Ke, Je = nt);
      }
      if (Ge > $e) {
        var tt = Ge;
        Ge = $e, $e = tt;
      }
      if ($e - Ge <= Ue / 16)
        throw new NotFoundException();
      for (var et = $e - 1, rt = -1, Ke = $e - 1; Ke > Ge; Ke--) {
        var it = Ke - Ge, nt = it * it * ($e - Ke) * (He - Qe[Ke]);
        nt > rt && (et = Ke, rt = nt);
      }
      return et << ue.LUMINANCE_SHIFT;
    }, ue.LUMINANCE_BITS = 5, ue.LUMINANCE_SHIFT = 8 - ue.LUMINANCE_BITS, ue.LUMINANCE_BUCKETS = 1 << ue.LUMINANCE_BITS, ue.EMPTY = Uint8ClampedArray.from([0]), ue;
  }(Binarizer)
), __extends$$ = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), HybridBinarizer = (
  /** @class */
  function(me) {
    __extends$$(ue, me);
    function ue(Qe) {
      var Ue = me.call(this, Qe) || this;
      return Ue.matrix = null, Ue;
    }
    return ue.prototype.getBlackMatrix = function() {
      if (this.matrix !== null)
        return this.matrix;
      var Qe = this.getLuminanceSource(), Ue = Qe.getWidth(), He = Qe.getHeight();
      if (Ue >= ue.MINIMUM_DIMENSION && He >= ue.MINIMUM_DIMENSION) {
        var Ge = Qe.getMatrix(), Xe = Ue >> ue.BLOCK_SIZE_POWER;
        Ue & ue.BLOCK_SIZE_MASK && Xe++;
        var Ke = He >> ue.BLOCK_SIZE_POWER;
        He & ue.BLOCK_SIZE_MASK && Ke++;
        var $e = ue.calculateBlackPoints(Ge, Xe, Ke, Ue, He), Je = new BitMatrix(Ue, He);
        ue.calculateThresholdForBlock(Ge, Xe, Ke, Ue, He, $e, Je), this.matrix = Je;
      } else
        this.matrix = me.prototype.getBlackMatrix.call(this);
      return this.matrix;
    }, ue.prototype.createBinarizer = function(Qe) {
      return new ue(Qe);
    }, ue.calculateThresholdForBlock = function(Qe, Ue, He, Ge, Xe, Ke, $e) {
      for (var Je = Xe - ue.BLOCK_SIZE, Ze = Ge - ue.BLOCK_SIZE, nt = 0; nt < He; nt++) {
        var tt = nt << ue.BLOCK_SIZE_POWER;
        tt > Je && (tt = Je);
        for (var et = ue.cap(nt, 2, He - 3), rt = 0; rt < Ue; rt++) {
          var it = rt << ue.BLOCK_SIZE_POWER;
          it > Ze && (it = Ze);
          for (var ot = ue.cap(rt, 2, Ue - 3), at = 0, st = -2; st <= 2; st++) {
            var ut = Ke[et + st];
            at += ut[ot - 2] + ut[ot - 1] + ut[ot] + ut[ot + 1] + ut[ot + 2];
          }
          var lt = at / 25;
          ue.thresholdBlock(Qe, it, tt, lt, Ge, $e);
        }
      }
    }, ue.cap = function(Qe, Ue, He) {
      return Qe < Ue ? Ue : Qe > He ? He : Qe;
    }, ue.thresholdBlock = function(Qe, Ue, He, Ge, Xe, Ke) {
      for (var $e = 0, Je = He * Xe + Ue; $e < ue.BLOCK_SIZE; $e++, Je += Xe)
        for (var Ze = 0; Ze < ue.BLOCK_SIZE; Ze++)
          (Qe[Je + Ze] & 255) <= Ge && Ke.set(Ue + Ze, He + $e);
    }, ue.calculateBlackPoints = function(Qe, Ue, He, Ge, Xe) {
      for (var Ke = Xe - ue.BLOCK_SIZE, $e = Ge - ue.BLOCK_SIZE, Je = new Array(He), Ze = 0; Ze < He; Ze++) {
        Je[Ze] = new Int32Array(Ue);
        var nt = Ze << ue.BLOCK_SIZE_POWER;
        nt > Ke && (nt = Ke);
        for (var tt = 0; tt < Ue; tt++) {
          var et = tt << ue.BLOCK_SIZE_POWER;
          et > $e && (et = $e);
          for (var rt = 0, it = 255, ot = 0, at = 0, st = nt * Ge + et; at < ue.BLOCK_SIZE; at++, st += Ge) {
            for (var ut = 0; ut < ue.BLOCK_SIZE; ut++) {
              var lt = Qe[st + ut] & 255;
              rt += lt, lt < it && (it = lt), lt > ot && (ot = lt);
            }
            if (ot - it > ue.MIN_DYNAMIC_RANGE)
              for (at++, st += Ge; at < ue.BLOCK_SIZE; at++, st += Ge)
                for (var ut = 0; ut < ue.BLOCK_SIZE; ut++)
                  rt += Qe[st + ut] & 255;
          }
          var dt = rt >> ue.BLOCK_SIZE_POWER * 2;
          if (ot - it <= ue.MIN_DYNAMIC_RANGE && (dt = it / 2, Ze > 0 && tt > 0)) {
            var At = (Je[Ze - 1][tt] + 2 * Je[Ze][tt - 1] + Je[Ze - 1][tt - 1]) / 4;
            it < At && (dt = At);
          }
          Je[Ze][tt] = dt;
        }
      }
      return Je;
    }, ue.BLOCK_SIZE_POWER = 3, ue.BLOCK_SIZE = 1 << ue.BLOCK_SIZE_POWER, ue.BLOCK_SIZE_MASK = ue.BLOCK_SIZE - 1, ue.MINIMUM_DIMENSION = ue.BLOCK_SIZE * 5, ue.MIN_DYNAMIC_RANGE = 24, ue;
  }(GlobalHistogramBinarizer)
), LuminanceSource = (
  /** @class */
  function() {
    function me(ue, Qe) {
      this.width = ue, this.height = Qe;
    }
    return me.prototype.getWidth = function() {
      return this.width;
    }, me.prototype.getHeight = function() {
      return this.height;
    }, me.prototype.isCropSupported = function() {
      return !1;
    }, me.prototype.crop = function(ue, Qe, Ue, He) {
      throw new UnsupportedOperationException("This luminance source does not support cropping.");
    }, me.prototype.isRotateSupported = function() {
      return !1;
    }, me.prototype.rotateCounterClockwise = function() {
      throw new UnsupportedOperationException("This luminance source does not support rotation by 90 degrees.");
    }, me.prototype.rotateCounterClockwise45 = function() {
      throw new UnsupportedOperationException("This luminance source does not support rotation by 45 degrees.");
    }, me.prototype.toString = function() {
      for (var ue = new Uint8ClampedArray(this.width), Qe = new StringBuilder(), Ue = 0; Ue < this.height; Ue++) {
        for (var He = this.getRow(Ue, ue), Ge = 0; Ge < this.width; Ge++) {
          var Xe = He[Ge] & 255, Ke = void 0;
          Xe < 64 ? Ke = "#" : Xe < 128 ? Ke = "+" : Xe < 192 ? Ke = "." : Ke = " ", Qe.append(Ke);
        }
        Qe.append(`
`);
      }
      return Qe.toString();
    }, me;
  }()
), __extends$_ = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), InvertedLuminanceSource = (
  /** @class */
  function(me) {
    __extends$_(ue, me);
    function ue(Qe) {
      var Ue = me.call(this, Qe.getWidth(), Qe.getHeight()) || this;
      return Ue.delegate = Qe, Ue;
    }
    return ue.prototype.getRow = function(Qe, Ue) {
      for (var He = this.delegate.getRow(Qe, Ue), Ge = this.getWidth(), Xe = 0; Xe < Ge; Xe++)
        He[Xe] = /*(byte)*/
        255 - (He[Xe] & 255);
      return He;
    }, ue.prototype.getMatrix = function() {
      for (var Qe = this.delegate.getMatrix(), Ue = this.getWidth() * this.getHeight(), He = new Uint8ClampedArray(Ue), Ge = 0; Ge < Ue; Ge++)
        He[Ge] = /*(byte)*/
        255 - (Qe[Ge] & 255);
      return He;
    }, ue.prototype.isCropSupported = function() {
      return this.delegate.isCropSupported();
    }, ue.prototype.crop = function(Qe, Ue, He, Ge) {
      return new ue(this.delegate.crop(Qe, Ue, He, Ge));
    }, ue.prototype.isRotateSupported = function() {
      return this.delegate.isRotateSupported();
    }, ue.prototype.invert = function() {
      return this.delegate;
    }, ue.prototype.rotateCounterClockwise = function() {
      return new ue(this.delegate.rotateCounterClockwise());
    }, ue.prototype.rotateCounterClockwise45 = function() {
      return new ue(this.delegate.rotateCounterClockwise45());
    }, ue;
  }(LuminanceSource)
), __extends$Z = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), HTMLCanvasElementLuminanceSource$1 = (
  /** @class */
  function(me) {
    __extends$Z(ue, me);
    function ue(Qe) {
      var Ue = me.call(this, Qe.width, Qe.height) || this;
      return Ue.canvas = Qe, Ue.tempCanvasElement = null, Ue.buffer = ue.makeBufferFromCanvasImageData(Qe), Ue;
    }
    return ue.makeBufferFromCanvasImageData = function(Qe) {
      var Ue = Qe.getContext("2d").getImageData(0, 0, Qe.width, Qe.height);
      return ue.toGrayscaleBuffer(Ue.data, Qe.width, Qe.height);
    }, ue.toGrayscaleBuffer = function(Qe, Ue, He) {
      for (var Ge = new Uint8ClampedArray(Ue * He), Xe = 0, Ke = 0, $e = Qe.length; Xe < $e; Xe += 4, Ke++) {
        var Je = void 0, Ze = Qe[Xe + 3];
        if (Ze === 0)
          Je = 255;
        else {
          var nt = Qe[Xe], tt = Qe[Xe + 1], et = Qe[Xe + 2];
          Je = 306 * nt + 601 * tt + 117 * et + 512 >> 10;
        }
        Ge[Ke] = Je;
      }
      return Ge;
    }, ue.prototype.getRow = function(Qe, Ue) {
      if (Qe < 0 || Qe >= this.getHeight())
        throw new IllegalArgumentException("Requested row is outside the image: " + Qe);
      var He = this.getWidth(), Ge = Qe * He;
      return Ue === null ? Ue = this.buffer.slice(Ge, Ge + He) : (Ue.length < He && (Ue = new Uint8ClampedArray(He)), Ue.set(this.buffer.slice(Ge, Ge + He))), Ue;
    }, ue.prototype.getMatrix = function() {
      return this.buffer;
    }, ue.prototype.isCropSupported = function() {
      return !0;
    }, ue.prototype.crop = function(Qe, Ue, He, Ge) {
      return me.prototype.crop.call(this, Qe, Ue, He, Ge), this;
    }, ue.prototype.isRotateSupported = function() {
      return !0;
    }, ue.prototype.rotateCounterClockwise = function() {
      return this.rotate(-90), this;
    }, ue.prototype.rotateCounterClockwise45 = function() {
      return this.rotate(-45), this;
    }, ue.prototype.getTempCanvasElement = function() {
      if (this.tempCanvasElement === null) {
        var Qe = this.canvas.ownerDocument.createElement("canvas");
        Qe.width = this.canvas.width, Qe.height = this.canvas.height, this.tempCanvasElement = Qe;
      }
      return this.tempCanvasElement;
    }, ue.prototype.rotate = function(Qe) {
      var Ue = this.getTempCanvasElement(), He = Ue.getContext("2d"), Ge = Qe * ue.DEGREE_TO_RADIANS, Xe = this.canvas.width, Ke = this.canvas.height, $e = Math.ceil(Math.abs(Math.cos(Ge)) * Xe + Math.abs(Math.sin(Ge)) * Ke), Je = Math.ceil(Math.abs(Math.sin(Ge)) * Xe + Math.abs(Math.cos(Ge)) * Ke);
      return Ue.width = $e, Ue.height = Je, He.translate($e / 2, Je / 2), He.rotate(Ge), He.drawImage(this.canvas, Xe / -2, Ke / -2), this.buffer = ue.makeBufferFromCanvasImageData(Ue), this;
    }, ue.prototype.invert = function() {
      return new InvertedLuminanceSource(this);
    }, ue.DEGREE_TO_RADIANS = Math.PI / 180, ue;
  }(LuminanceSource)
), VideoInputDevice = (
  /** @class */
  function() {
    function me(ue, Qe, Ue) {
      this.deviceId = ue, this.label = Qe, this.kind = "videoinput", this.groupId = Ue || void 0;
    }
    return me.prototype.toJSON = function() {
      return {
        kind: this.kind,
        groupId: this.groupId,
        deviceId: this.deviceId,
        label: this.label
      };
    }, me;
  }()
), __awaiter$2 = function(me, ue, Qe, Ue) {
  function He(Ge) {
    return Ge instanceof Qe ? Ge : new Qe(function(Xe) {
      Xe(Ge);
    });
  }
  return new (Qe || (Qe = Promise))(function(Ge, Xe) {
    function Ke(Ze) {
      try {
        Je(Ue.next(Ze));
      } catch (nt) {
        Xe(nt);
      }
    }
    function $e(Ze) {
      try {
        Je(Ue.throw(Ze));
      } catch (nt) {
        Xe(nt);
      }
    }
    function Je(Ze) {
      Ze.done ? Ge(Ze.value) : He(Ze.value).then(Ke, $e);
    }
    Je((Ue = Ue.apply(me, ue || [])).next());
  });
}, __generator$1 = function(me, ue) {
  var Qe = { label: 0, sent: function() {
    if (Ge[0] & 1) throw Ge[1];
    return Ge[1];
  }, trys: [], ops: [] }, Ue, He, Ge, Xe;
  return Xe = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (Xe[Symbol.iterator] = function() {
    return this;
  }), Xe;
  function Ke(Je) {
    return function(Ze) {
      return $e([Je, Ze]);
    };
  }
  function $e(Je) {
    if (Ue) throw new TypeError("Generator is already executing.");
    for (; Qe; ) try {
      if (Ue = 1, He && (Ge = Je[0] & 2 ? He.return : Je[0] ? He.throw || ((Ge = He.return) && Ge.call(He), 0) : He.next) && !(Ge = Ge.call(He, Je[1])).done) return Ge;
      switch (He = 0, Ge && (Je = [Je[0] & 2, Ge.value]), Je[0]) {
        case 0:
        case 1:
          Ge = Je;
          break;
        case 4:
          return Qe.label++, { value: Je[1], done: !1 };
        case 5:
          Qe.label++, He = Je[1], Je = [0];
          continue;
        case 7:
          Je = Qe.ops.pop(), Qe.trys.pop();
          continue;
        default:
          if (Ge = Qe.trys, !(Ge = Ge.length > 0 && Ge[Ge.length - 1]) && (Je[0] === 6 || Je[0] === 2)) {
            Qe = 0;
            continue;
          }
          if (Je[0] === 3 && (!Ge || Je[1] > Ge[0] && Je[1] < Ge[3])) {
            Qe.label = Je[1];
            break;
          }
          if (Je[0] === 6 && Qe.label < Ge[1]) {
            Qe.label = Ge[1], Ge = Je;
            break;
          }
          if (Ge && Qe.label < Ge[2]) {
            Qe.label = Ge[2], Qe.ops.push(Je);
            break;
          }
          Ge[2] && Qe.ops.pop(), Qe.trys.pop();
          continue;
      }
      Je = ue.call(me, Qe);
    } catch (Ze) {
      Je = [6, Ze], He = 0;
    } finally {
      Ue = Ge = 0;
    }
    if (Je[0] & 5) throw Je[1];
    return { value: Je[0] ? Je[1] : void 0, done: !0 };
  }
}, __values$F = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, BrowserCodeReader$1 = (
  /** @class */
  function() {
    function me(ue, Qe, Ue) {
      Qe === void 0 && (Qe = 500), this.reader = ue, this.timeBetweenScansMillis = Qe, this._hints = Ue, this._stopContinuousDecode = !1, this._stopAsyncDecode = !1, this._timeBetweenDecodingAttempts = 0;
    }
    return Object.defineProperty(me.prototype, "hasNavigator", {
      /**
       * If navigator is present.
       */
      get: function() {
        return typeof navigator < "u";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(me.prototype, "isMediaDevicesSuported", {
      /**
       * If mediaDevices under navigator is supported.
       */
      get: function() {
        return this.hasNavigator && !!navigator.mediaDevices;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(me.prototype, "canEnumerateDevices", {
      /**
       * If enumerateDevices under navigator is supported.
       */
      get: function() {
        return !!(this.isMediaDevicesSuported && navigator.mediaDevices.enumerateDevices);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(me.prototype, "timeBetweenDecodingAttempts", {
      /** Time between two decoding tries in milli seconds. */
      get: function() {
        return this._timeBetweenDecodingAttempts;
      },
      /**
       * Change the time span the decoder waits between two decoding tries.
       *
       * @param {number} millis Time between two decoding tries in milli seconds.
       */
      set: function(ue) {
        this._timeBetweenDecodingAttempts = ue < 0 ? 0 : ue;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(me.prototype, "hints", {
      /**
       * Sets the hints.
       */
      get: function() {
        return this._hints;
      },
      /**
       * Sets the hints.
       */
      set: function(ue) {
        this._hints = ue || null;
      },
      enumerable: !1,
      configurable: !0
    }), me.prototype.listVideoInputDevices = function() {
      return __awaiter$2(this, void 0, void 0, function() {
        var ue, Qe, Ue, He, Ge, Xe, Ke, $e, Je, Ze, nt, tt;
        return __generator$1(this, function(et) {
          switch (et.label) {
            case 0:
              if (!this.hasNavigator)
                throw new Error("Can't enumerate devices, navigator is not present.");
              if (!this.canEnumerateDevices)
                throw new Error("Can't enumerate devices, method not supported.");
              return [4, navigator.mediaDevices.enumerateDevices()];
            case 1:
              ue = et.sent(), Qe = [];
              try {
                for (Ue = __values$F(ue), He = Ue.next(); !He.done; He = Ue.next())
                  Ge = He.value, Xe = Ge.kind === "video" ? "videoinput" : Ge.kind, Xe === "videoinput" && (Ke = Ge.deviceId || Ge.id, $e = Ge.label || "Video device " + (Qe.length + 1), Je = Ge.groupId, Ze = { deviceId: Ke, label: $e, kind: Xe, groupId: Je }, Qe.push(Ze));
              } catch (rt) {
                nt = { error: rt };
              } finally {
                try {
                  He && !He.done && (tt = Ue.return) && tt.call(Ue);
                } finally {
                  if (nt) throw nt.error;
                }
              }
              return [2, Qe];
          }
        });
      });
    }, me.prototype.getVideoInputDevices = function() {
      return __awaiter$2(this, void 0, void 0, function() {
        var ue;
        return __generator$1(this, function(Qe) {
          switch (Qe.label) {
            case 0:
              return [4, this.listVideoInputDevices()];
            case 1:
              return ue = Qe.sent(), [2, ue.map(function(Ue) {
                return new VideoInputDevice(Ue.deviceId, Ue.label);
              })];
          }
        });
      });
    }, me.prototype.findDeviceById = function(ue) {
      return __awaiter$2(this, void 0, void 0, function() {
        var Qe;
        return __generator$1(this, function(Ue) {
          switch (Ue.label) {
            case 0:
              return [4, this.listVideoInputDevices()];
            case 1:
              return Qe = Ue.sent(), Qe ? [2, Qe.find(function(He) {
                return He.deviceId === ue;
              })] : [2, null];
          }
        });
      });
    }, me.prototype.decodeFromInputVideoDevice = function(ue, Qe) {
      return __awaiter$2(this, void 0, void 0, function() {
        return __generator$1(this, function(Ue) {
          switch (Ue.label) {
            case 0:
              return [4, this.decodeOnceFromVideoDevice(ue, Qe)];
            case 1:
              return [2, Ue.sent()];
          }
        });
      });
    }, me.prototype.decodeOnceFromVideoDevice = function(ue, Qe) {
      return __awaiter$2(this, void 0, void 0, function() {
        var Ue, He;
        return __generator$1(this, function(Ge) {
          switch (Ge.label) {
            case 0:
              return this.reset(), ue ? Ue = { deviceId: { exact: ue } } : Ue = { facingMode: "environment" }, He = { video: Ue }, [4, this.decodeOnceFromConstraints(He, Qe)];
            case 1:
              return [2, Ge.sent()];
          }
        });
      });
    }, me.prototype.decodeOnceFromConstraints = function(ue, Qe) {
      return __awaiter$2(this, void 0, void 0, function() {
        var Ue;
        return __generator$1(this, function(He) {
          switch (He.label) {
            case 0:
              return [4, navigator.mediaDevices.getUserMedia(ue)];
            case 1:
              return Ue = He.sent(), [4, this.decodeOnceFromStream(Ue, Qe)];
            case 2:
              return [2, He.sent()];
          }
        });
      });
    }, me.prototype.decodeOnceFromStream = function(ue, Qe) {
      return __awaiter$2(this, void 0, void 0, function() {
        var Ue, He;
        return __generator$1(this, function(Ge) {
          switch (Ge.label) {
            case 0:
              return this.reset(), [4, this.attachStreamToVideo(ue, Qe)];
            case 1:
              return Ue = Ge.sent(), [4, this.decodeOnce(Ue)];
            case 2:
              return He = Ge.sent(), [2, He];
          }
        });
      });
    }, me.prototype.decodeFromInputVideoDeviceContinuously = function(ue, Qe, Ue) {
      return __awaiter$2(this, void 0, void 0, function() {
        return __generator$1(this, function(He) {
          switch (He.label) {
            case 0:
              return [4, this.decodeFromVideoDevice(ue, Qe, Ue)];
            case 1:
              return [2, He.sent()];
          }
        });
      });
    }, me.prototype.decodeFromVideoDevice = function(ue, Qe, Ue) {
      return __awaiter$2(this, void 0, void 0, function() {
        var He, Ge;
        return __generator$1(this, function(Xe) {
          switch (Xe.label) {
            case 0:
              return ue ? He = { deviceId: { exact: ue } } : He = { facingMode: "environment" }, Ge = { video: He }, [4, this.decodeFromConstraints(Ge, Qe, Ue)];
            case 1:
              return [2, Xe.sent()];
          }
        });
      });
    }, me.prototype.decodeFromConstraints = function(ue, Qe, Ue) {
      return __awaiter$2(this, void 0, void 0, function() {
        var He;
        return __generator$1(this, function(Ge) {
          switch (Ge.label) {
            case 0:
              return [4, navigator.mediaDevices.getUserMedia(ue)];
            case 1:
              return He = Ge.sent(), [4, this.decodeFromStream(He, Qe, Ue)];
            case 2:
              return [2, Ge.sent()];
          }
        });
      });
    }, me.prototype.decodeFromStream = function(ue, Qe, Ue) {
      return __awaiter$2(this, void 0, void 0, function() {
        var He;
        return __generator$1(this, function(Ge) {
          switch (Ge.label) {
            case 0:
              return this.reset(), [4, this.attachStreamToVideo(ue, Qe)];
            case 1:
              return He = Ge.sent(), [4, this.decodeContinuously(He, Ue)];
            case 2:
              return [2, Ge.sent()];
          }
        });
      });
    }, me.prototype.stopAsyncDecode = function() {
      this._stopAsyncDecode = !0;
    }, me.prototype.stopContinuousDecode = function() {
      this._stopContinuousDecode = !0;
    }, me.prototype.attachStreamToVideo = function(ue, Qe) {
      return __awaiter$2(this, void 0, void 0, function() {
        var Ue;
        return __generator$1(this, function(He) {
          switch (He.label) {
            case 0:
              return Ue = this.prepareVideoElement(Qe), this.addVideoSource(Ue, ue), this.videoElement = Ue, this.stream = ue, [4, this.playVideoOnLoadAsync(Ue)];
            case 1:
              return He.sent(), [2, Ue];
          }
        });
      });
    }, me.prototype.playVideoOnLoadAsync = function(ue) {
      var Qe = this;
      return new Promise(function(Ue, He) {
        return Qe.playVideoOnLoad(ue, function() {
          return Ue();
        });
      });
    }, me.prototype.playVideoOnLoad = function(ue, Qe) {
      var Ue = this;
      this.videoEndedListener = function() {
        return Ue.stopStreams();
      }, this.videoCanPlayListener = function() {
        return Ue.tryPlayVideo(ue);
      }, ue.addEventListener("ended", this.videoEndedListener), ue.addEventListener("canplay", this.videoCanPlayListener), ue.addEventListener("playing", Qe), this.tryPlayVideo(ue);
    }, me.prototype.isVideoPlaying = function(ue) {
      return ue.currentTime > 0 && !ue.paused && !ue.ended && ue.readyState > 2;
    }, me.prototype.tryPlayVideo = function(ue) {
      return __awaiter$2(this, void 0, void 0, function() {
        return __generator$1(this, function(Qe) {
          switch (Qe.label) {
            case 0:
              if (this.isVideoPlaying(ue))
                return console.warn("Trying to play video that is already playing."), [
                  2
                  /*return*/
                ];
              Qe.label = 1;
            case 1:
              return Qe.trys.push([1, 3, , 4]), [4, ue.play()];
            case 2:
              return Qe.sent(), [3, 4];
            case 3:
              return Qe.sent(), console.warn("It was not possible to play the video."), [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, me.prototype.getMediaElement = function(ue, Qe) {
      var Ue = document.getElementById(ue);
      if (!Ue)
        throw new ArgumentException("element with id '" + ue + "' not found");
      if (Ue.nodeName.toLowerCase() !== Qe.toLowerCase())
        throw new ArgumentException("element with id '" + ue + "' must be an " + Qe + " element");
      return Ue;
    }, me.prototype.decodeFromImage = function(ue, Qe) {
      if (!ue && !Qe)
        throw new ArgumentException("either imageElement with a src set or an url must be provided");
      return Qe && !ue ? this.decodeFromImageUrl(Qe) : this.decodeFromImageElement(ue);
    }, me.prototype.decodeFromVideo = function(ue, Qe) {
      if (!ue && !Qe)
        throw new ArgumentException("Either an element with a src set or an URL must be provided");
      return Qe && !ue ? this.decodeFromVideoUrl(Qe) : this.decodeFromVideoElement(ue);
    }, me.prototype.decodeFromVideoContinuously = function(ue, Qe, Ue) {
      if (ue === void 0 && Qe === void 0)
        throw new ArgumentException("Either an element with a src set or an URL must be provided");
      return Qe && !ue ? this.decodeFromVideoUrlContinuously(Qe, Ue) : this.decodeFromVideoElementContinuously(ue, Ue);
    }, me.prototype.decodeFromImageElement = function(ue) {
      if (!ue)
        throw new ArgumentException("An image element must be provided.");
      this.reset();
      var Qe = this.prepareImageElement(ue);
      this.imageElement = Qe;
      var Ue;
      return this.isImageLoaded(Qe) ? Ue = this.decodeOnce(Qe, !1, !0) : Ue = this._decodeOnLoadImage(Qe), Ue;
    }, me.prototype.decodeFromVideoElement = function(ue) {
      var Qe = this._decodeFromVideoElementSetup(ue);
      return this._decodeOnLoadVideo(Qe);
    }, me.prototype.decodeFromVideoElementContinuously = function(ue, Qe) {
      var Ue = this._decodeFromVideoElementSetup(ue);
      return this._decodeOnLoadVideoContinuously(Ue, Qe);
    }, me.prototype._decodeFromVideoElementSetup = function(ue) {
      if (!ue)
        throw new ArgumentException("A video element must be provided.");
      this.reset();
      var Qe = this.prepareVideoElement(ue);
      return this.videoElement = Qe, Qe;
    }, me.prototype.decodeFromImageUrl = function(ue) {
      if (!ue)
        throw new ArgumentException("An URL must be provided.");
      this.reset();
      var Qe = this.prepareImageElement();
      this.imageElement = Qe;
      var Ue = this._decodeOnLoadImage(Qe);
      return Qe.src = ue, Ue;
    }, me.prototype.decodeFromVideoUrl = function(ue) {
      if (!ue)
        throw new ArgumentException("An URL must be provided.");
      this.reset();
      var Qe = this.prepareVideoElement(), Ue = this.decodeFromVideoElement(Qe);
      return Qe.src = ue, Ue;
    }, me.prototype.decodeFromVideoUrlContinuously = function(ue, Qe) {
      if (!ue)
        throw new ArgumentException("An URL must be provided.");
      this.reset();
      var Ue = this.prepareVideoElement(), He = this.decodeFromVideoElementContinuously(Ue, Qe);
      return Ue.src = ue, He;
    }, me.prototype._decodeOnLoadImage = function(ue) {
      var Qe = this;
      return new Promise(function(Ue, He) {
        Qe.imageLoadedListener = function() {
          return Qe.decodeOnce(ue, !1, !0).then(Ue, He);
        }, ue.addEventListener("load", Qe.imageLoadedListener);
      });
    }, me.prototype._decodeOnLoadVideo = function(ue) {
      return __awaiter$2(this, void 0, void 0, function() {
        return __generator$1(this, function(Qe) {
          switch (Qe.label) {
            case 0:
              return [4, this.playVideoOnLoadAsync(ue)];
            case 1:
              return Qe.sent(), [4, this.decodeOnce(ue)];
            case 2:
              return [2, Qe.sent()];
          }
        });
      });
    }, me.prototype._decodeOnLoadVideoContinuously = function(ue, Qe) {
      return __awaiter$2(this, void 0, void 0, function() {
        return __generator$1(this, function(Ue) {
          switch (Ue.label) {
            case 0:
              return [4, this.playVideoOnLoadAsync(ue)];
            case 1:
              return Ue.sent(), this.decodeContinuously(ue, Qe), [
                2
                /*return*/
              ];
          }
        });
      });
    }, me.prototype.isImageLoaded = function(ue) {
      return !(!ue.complete || ue.naturalWidth === 0);
    }, me.prototype.prepareImageElement = function(ue) {
      var Qe;
      return typeof ue > "u" && (Qe = document.createElement("img"), Qe.width = 200, Qe.height = 200), typeof ue == "string" && (Qe = this.getMediaElement(ue, "img")), ue instanceof HTMLImageElement && (Qe = ue), Qe;
    }, me.prototype.prepareVideoElement = function(ue) {
      var Qe;
      return !ue && typeof document < "u" && (Qe = document.createElement("video"), Qe.width = 200, Qe.height = 200), typeof ue == "string" && (Qe = this.getMediaElement(ue, "video")), ue instanceof HTMLVideoElement && (Qe = ue), Qe.setAttribute("autoplay", "true"), Qe.setAttribute("muted", "true"), Qe.setAttribute("playsinline", "true"), Qe;
    }, me.prototype.decodeOnce = function(ue, Qe, Ue) {
      var He = this;
      Qe === void 0 && (Qe = !0), Ue === void 0 && (Ue = !0), this._stopAsyncDecode = !1;
      var Ge = function(Xe, Ke) {
        if (He._stopAsyncDecode) {
          Ke(new NotFoundException("Video stream has ended before any code could be detected.")), He._stopAsyncDecode = void 0;
          return;
        }
        try {
          var $e = He.decode(ue);
          Xe($e);
        } catch (tt) {
          var Je = Qe && tt instanceof NotFoundException, Ze = tt instanceof ChecksumException || tt instanceof FormatException, nt = Ze && Ue;
          if (Je || nt)
            return setTimeout(Ge, He._timeBetweenDecodingAttempts, Xe, Ke);
          Ke(tt);
        }
      };
      return new Promise(function(Xe, Ke) {
        return Ge(Xe, Ke);
      });
    }, me.prototype.decodeContinuously = function(ue, Qe) {
      var Ue = this;
      this._stopContinuousDecode = !1;
      var He = function() {
        if (Ue._stopContinuousDecode) {
          Ue._stopContinuousDecode = void 0;
          return;
        }
        try {
          var Ge = Ue.decode(ue);
          Qe(Ge, null), setTimeout(He, Ue.timeBetweenScansMillis);
        } catch ($e) {
          Qe(null, $e);
          var Xe = $e instanceof ChecksumException || $e instanceof FormatException, Ke = $e instanceof NotFoundException;
          (Xe || Ke) && setTimeout(He, Ue._timeBetweenDecodingAttempts);
        }
      };
      He();
    }, me.prototype.decode = function(ue) {
      var Qe = this.createBinaryBitmap(ue);
      return this.decodeBitmap(Qe);
    }, me.prototype._isHTMLVideoElement = function(ue) {
      var Qe = ue;
      return Qe.videoWidth !== 0;
    }, me.prototype.createBinaryBitmap = function(ue) {
      this.getCaptureCanvasContext(ue), this._isHTMLVideoElement(ue) ? this.drawFrameOnCanvas(ue) : this.drawImageOnCanvas(ue);
      var Qe = this.getCaptureCanvas(ue), Ue = new HTMLCanvasElementLuminanceSource$1(Qe), He = new HybridBinarizer(Ue);
      return new BinaryBitmap(He);
    }, me.prototype.getCaptureCanvasContext = function(ue) {
      if (!this.captureCanvasContext) {
        var Qe = this.getCaptureCanvas(ue), Ue = void 0;
        try {
          Ue = Qe.getContext("2d", { willReadFrequently: !0 });
        } catch {
          Ue = Qe.getContext("2d");
        }
        this.captureCanvasContext = Ue;
      }
      return this.captureCanvasContext;
    }, me.prototype.getCaptureCanvas = function(ue) {
      if (!this.captureCanvas) {
        var Qe = this.createCaptureCanvas(ue);
        this.captureCanvas = Qe;
      }
      return this.captureCanvas;
    }, me.prototype.drawFrameOnCanvas = function(ue, Qe, Ue) {
      Qe === void 0 && (Qe = { sx: 0, sy: 0, sWidth: ue.videoWidth, sHeight: ue.videoHeight, dx: 0, dy: 0, dWidth: ue.videoWidth, dHeight: ue.videoHeight }), Ue === void 0 && (Ue = this.captureCanvasContext), Ue.drawImage(ue, Qe.sx, Qe.sy, Qe.sWidth, Qe.sHeight, Qe.dx, Qe.dy, Qe.dWidth, Qe.dHeight);
    }, me.prototype.drawImageOnCanvas = function(ue, Qe, Ue) {
      Qe === void 0 && (Qe = { sx: 0, sy: 0, sWidth: ue.naturalWidth, sHeight: ue.naturalHeight, dx: 0, dy: 0, dWidth: ue.naturalWidth, dHeight: ue.naturalHeight }), Ue === void 0 && (Ue = this.captureCanvasContext), Ue.drawImage(ue, Qe.sx, Qe.sy, Qe.sWidth, Qe.sHeight, Qe.dx, Qe.dy, Qe.dWidth, Qe.dHeight);
    }, me.prototype.decodeBitmap = function(ue) {
      return this.reader.decode(ue, this._hints);
    }, me.prototype.createCaptureCanvas = function(ue) {
      if (typeof document > "u")
        return this._destroyCaptureCanvas(), null;
      var Qe = document.createElement("canvas"), Ue, He;
      return typeof ue < "u" && (ue instanceof HTMLVideoElement ? (Ue = ue.videoWidth, He = ue.videoHeight) : ue instanceof HTMLImageElement && (Ue = ue.naturalWidth || ue.width, He = ue.naturalHeight || ue.height)), Qe.style.width = Ue + "px", Qe.style.height = He + "px", Qe.width = Ue, Qe.height = He, Qe;
    }, me.prototype.stopStreams = function() {
      this.stream && (this.stream.getVideoTracks().forEach(function(ue) {
        return ue.stop();
      }), this.stream = void 0), this._stopAsyncDecode === !1 && this.stopAsyncDecode(), this._stopContinuousDecode === !1 && this.stopContinuousDecode();
    }, me.prototype.reset = function() {
      this.stopStreams(), this._destroyVideoElement(), this._destroyImageElement(), this._destroyCaptureCanvas();
    }, me.prototype._destroyVideoElement = function() {
      this.videoElement && (typeof this.videoEndedListener < "u" && this.videoElement.removeEventListener("ended", this.videoEndedListener), typeof this.videoPlayingEventListener < "u" && this.videoElement.removeEventListener("playing", this.videoPlayingEventListener), typeof this.videoCanPlayListener < "u" && this.videoElement.removeEventListener("loadedmetadata", this.videoCanPlayListener), this.cleanVideoSource(this.videoElement), this.videoElement = void 0);
    }, me.prototype._destroyImageElement = function() {
      this.imageElement && (this.imageLoadedListener !== void 0 && this.imageElement.removeEventListener("load", this.imageLoadedListener), this.imageElement.src = void 0, this.imageElement.removeAttribute("src"), this.imageElement = void 0);
    }, me.prototype._destroyCaptureCanvas = function() {
      this.captureCanvasContext = void 0, this.captureCanvas = void 0;
    }, me.prototype.addVideoSource = function(ue, Qe) {
      try {
        ue.srcObject = Qe;
      } catch {
        ue.src = URL.createObjectURL(Qe);
      }
    }, me.prototype.cleanVideoSource = function(ue) {
      try {
        ue.srcObject = null;
      } catch {
        ue.src = "";
      }
      this.videoElement.removeAttribute("src");
    }, me;
  }()
), Result = (
  /** @class */
  function() {
    function me(ue, Qe, Ue, He, Ge, Xe) {
      Ue === void 0 && (Ue = Qe == null ? 0 : 8 * Qe.length), Xe === void 0 && (Xe = System.currentTimeMillis()), this.text = ue, this.rawBytes = Qe, this.numBits = Ue, this.resultPoints = He, this.format = Ge, this.timestamp = Xe, this.text = ue, this.rawBytes = Qe, Ue == null ? this.numBits = Qe == null ? 0 : 8 * Qe.length : this.numBits = Ue, this.resultPoints = He, this.format = Ge, this.resultMetadata = null, Xe == null ? this.timestamp = System.currentTimeMillis() : this.timestamp = Xe;
    }
    return me.prototype.getText = function() {
      return this.text;
    }, me.prototype.getRawBytes = function() {
      return this.rawBytes;
    }, me.prototype.getNumBits = function() {
      return this.numBits;
    }, me.prototype.getResultPoints = function() {
      return this.resultPoints;
    }, me.prototype.getBarcodeFormat = function() {
      return this.format;
    }, me.prototype.getResultMetadata = function() {
      return this.resultMetadata;
    }, me.prototype.putMetadata = function(ue, Qe) {
      this.resultMetadata === null && (this.resultMetadata = /* @__PURE__ */ new Map()), this.resultMetadata.set(ue, Qe);
    }, me.prototype.putAllMetadata = function(ue) {
      ue !== null && (this.resultMetadata === null ? this.resultMetadata = ue : this.resultMetadata = new Map(ue));
    }, me.prototype.addResultPoints = function(ue) {
      var Qe = this.resultPoints;
      if (Qe === null)
        this.resultPoints = ue;
      else if (ue !== null && ue.length > 0) {
        var Ue = new Array(Qe.length + ue.length);
        System.arraycopy(Qe, 0, Ue, 0, Qe.length), System.arraycopy(ue, 0, Ue, Qe.length, ue.length), this.resultPoints = Ue;
      }
    }, me.prototype.getTimestamp = function() {
      return this.timestamp;
    }, me.prototype.toString = function() {
      return this.text;
    }, me;
  }()
), BarcodeFormat;
(function(me) {
  me[me.AZTEC = 0] = "AZTEC", me[me.CODABAR = 1] = "CODABAR", me[me.CODE_39 = 2] = "CODE_39", me[me.CODE_93 = 3] = "CODE_93", me[me.CODE_128 = 4] = "CODE_128", me[me.DATA_MATRIX = 5] = "DATA_MATRIX", me[me.EAN_8 = 6] = "EAN_8", me[me.EAN_13 = 7] = "EAN_13", me[me.ITF = 8] = "ITF", me[me.MAXICODE = 9] = "MAXICODE", me[me.PDF_417 = 10] = "PDF_417", me[me.QR_CODE = 11] = "QR_CODE", me[me.RSS_14 = 12] = "RSS_14", me[me.RSS_EXPANDED = 13] = "RSS_EXPANDED", me[me.UPC_A = 14] = "UPC_A", me[me.UPC_E = 15] = "UPC_E", me[me.UPC_EAN_EXTENSION = 16] = "UPC_EAN_EXTENSION";
})(BarcodeFormat || (BarcodeFormat = {}));
const BarcodeFormat$1 = BarcodeFormat;
var ResultMetadataType;
(function(me) {
  me[me.OTHER = 0] = "OTHER", me[me.ORIENTATION = 1] = "ORIENTATION", me[me.BYTE_SEGMENTS = 2] = "BYTE_SEGMENTS", me[me.ERROR_CORRECTION_LEVEL = 3] = "ERROR_CORRECTION_LEVEL", me[me.ISSUE_NUMBER = 4] = "ISSUE_NUMBER", me[me.SUGGESTED_PRICE = 5] = "SUGGESTED_PRICE", me[me.POSSIBLE_COUNTRY = 6] = "POSSIBLE_COUNTRY", me[me.UPC_EAN_EXTENSION = 7] = "UPC_EAN_EXTENSION", me[me.PDF417_EXTRA_METADATA = 8] = "PDF417_EXTRA_METADATA", me[me.STRUCTURED_APPEND_SEQUENCE = 9] = "STRUCTURED_APPEND_SEQUENCE", me[me.STRUCTURED_APPEND_PARITY = 10] = "STRUCTURED_APPEND_PARITY";
})(ResultMetadataType || (ResultMetadataType = {}));
const ResultMetadataType$1 = ResultMetadataType;
var DecoderResult = (
  /** @class */
  function() {
    function me(ue, Qe, Ue, He, Ge, Xe) {
      Ge === void 0 && (Ge = -1), Xe === void 0 && (Xe = -1), this.rawBytes = ue, this.text = Qe, this.byteSegments = Ue, this.ecLevel = He, this.structuredAppendSequenceNumber = Ge, this.structuredAppendParity = Xe, this.numBits = ue == null ? 0 : 8 * ue.length;
    }
    return me.prototype.getRawBytes = function() {
      return this.rawBytes;
    }, me.prototype.getNumBits = function() {
      return this.numBits;
    }, me.prototype.setNumBits = function(ue) {
      this.numBits = ue;
    }, me.prototype.getText = function() {
      return this.text;
    }, me.prototype.getByteSegments = function() {
      return this.byteSegments;
    }, me.prototype.getECLevel = function() {
      return this.ecLevel;
    }, me.prototype.getErrorsCorrected = function() {
      return this.errorsCorrected;
    }, me.prototype.setErrorsCorrected = function(ue) {
      this.errorsCorrected = ue;
    }, me.prototype.getErasures = function() {
      return this.erasures;
    }, me.prototype.setErasures = function(ue) {
      this.erasures = ue;
    }, me.prototype.getOther = function() {
      return this.other;
    }, me.prototype.setOther = function(ue) {
      this.other = ue;
    }, me.prototype.hasStructuredAppend = function() {
      return this.structuredAppendParity >= 0 && this.structuredAppendSequenceNumber >= 0;
    }, me.prototype.getStructuredAppendParity = function() {
      return this.structuredAppendParity;
    }, me.prototype.getStructuredAppendSequenceNumber = function() {
      return this.structuredAppendSequenceNumber;
    }, me;
  }()
), AbstractGenericGF = (
  /** @class */
  function() {
    function me() {
    }
    return me.prototype.exp = function(ue) {
      return this.expTable[ue];
    }, me.prototype.log = function(ue) {
      if (ue === 0)
        throw new IllegalArgumentException();
      return this.logTable[ue];
    }, me.addOrSubtract = function(ue, Qe) {
      return ue ^ Qe;
    }, me;
  }()
), GenericGFPoly = (
  /** @class */
  function() {
    function me(ue, Qe) {
      if (Qe.length === 0)
        throw new IllegalArgumentException();
      this.field = ue;
      var Ue = Qe.length;
      if (Ue > 1 && Qe[0] === 0) {
        for (var He = 1; He < Ue && Qe[He] === 0; )
          He++;
        He === Ue ? this.coefficients = Int32Array.from([0]) : (this.coefficients = new Int32Array(Ue - He), System.arraycopy(Qe, He, this.coefficients, 0, this.coefficients.length));
      } else
        this.coefficients = Qe;
    }
    return me.prototype.getCoefficients = function() {
      return this.coefficients;
    }, me.prototype.getDegree = function() {
      return this.coefficients.length - 1;
    }, me.prototype.isZero = function() {
      return this.coefficients[0] === 0;
    }, me.prototype.getCoefficient = function(ue) {
      return this.coefficients[this.coefficients.length - 1 - ue];
    }, me.prototype.evaluateAt = function(ue) {
      if (ue === 0)
        return this.getCoefficient(0);
      var Qe = this.coefficients, Ue;
      if (ue === 1) {
        Ue = 0;
        for (var He = 0, Ge = Qe.length; He !== Ge; He++) {
          var Xe = Qe[He];
          Ue = AbstractGenericGF.addOrSubtract(Ue, Xe);
        }
        return Ue;
      }
      Ue = Qe[0];
      for (var Ke = Qe.length, $e = this.field, He = 1; He < Ke; He++)
        Ue = AbstractGenericGF.addOrSubtract($e.multiply(ue, Ue), Qe[He]);
      return Ue;
    }, me.prototype.addOrSubtract = function(ue) {
      if (!this.field.equals(ue.field))
        throw new IllegalArgumentException("GenericGFPolys do not have same GenericGF field");
      if (this.isZero())
        return ue;
      if (ue.isZero())
        return this;
      var Qe = this.coefficients, Ue = ue.coefficients;
      if (Qe.length > Ue.length) {
        var He = Qe;
        Qe = Ue, Ue = He;
      }
      var Ge = new Int32Array(Ue.length), Xe = Ue.length - Qe.length;
      System.arraycopy(Ue, 0, Ge, 0, Xe);
      for (var Ke = Xe; Ke < Ue.length; Ke++)
        Ge[Ke] = AbstractGenericGF.addOrSubtract(Qe[Ke - Xe], Ue[Ke]);
      return new me(this.field, Ge);
    }, me.prototype.multiply = function(ue) {
      if (!this.field.equals(ue.field))
        throw new IllegalArgumentException("GenericGFPolys do not have same GenericGF field");
      if (this.isZero() || ue.isZero())
        return this.field.getZero();
      for (var Qe = this.coefficients, Ue = Qe.length, He = ue.coefficients, Ge = He.length, Xe = new Int32Array(Ue + Ge - 1), Ke = this.field, $e = 0; $e < Ue; $e++)
        for (var Je = Qe[$e], Ze = 0; Ze < Ge; Ze++)
          Xe[$e + Ze] = AbstractGenericGF.addOrSubtract(Xe[$e + Ze], Ke.multiply(Je, He[Ze]));
      return new me(Ke, Xe);
    }, me.prototype.multiplyScalar = function(ue) {
      if (ue === 0)
        return this.field.getZero();
      if (ue === 1)
        return this;
      for (var Qe = this.coefficients.length, Ue = this.field, He = new Int32Array(Qe), Ge = this.coefficients, Xe = 0; Xe < Qe; Xe++)
        He[Xe] = Ue.multiply(Ge[Xe], ue);
      return new me(Ue, He);
    }, me.prototype.multiplyByMonomial = function(ue, Qe) {
      if (ue < 0)
        throw new IllegalArgumentException();
      if (Qe === 0)
        return this.field.getZero();
      for (var Ue = this.coefficients, He = Ue.length, Ge = new Int32Array(He + ue), Xe = this.field, Ke = 0; Ke < He; Ke++)
        Ge[Ke] = Xe.multiply(Ue[Ke], Qe);
      return new me(Xe, Ge);
    }, me.prototype.divide = function(ue) {
      if (!this.field.equals(ue.field))
        throw new IllegalArgumentException("GenericGFPolys do not have same GenericGF field");
      if (ue.isZero())
        throw new IllegalArgumentException("Divide by 0");
      for (var Qe = this.field, Ue = Qe.getZero(), He = this, Ge = ue.getCoefficient(ue.getDegree()), Xe = Qe.inverse(Ge); He.getDegree() >= ue.getDegree() && !He.isZero(); ) {
        var Ke = He.getDegree() - ue.getDegree(), $e = Qe.multiply(He.getCoefficient(He.getDegree()), Xe), Je = ue.multiplyByMonomial(Ke, $e), Ze = Qe.buildMonomial(Ke, $e);
        Ue = Ue.addOrSubtract(Ze), He = He.addOrSubtract(Je);
      }
      return [Ue, He];
    }, me.prototype.toString = function() {
      for (var ue = "", Qe = this.getDegree(); Qe >= 0; Qe--) {
        var Ue = this.getCoefficient(Qe);
        if (Ue !== 0) {
          if (Ue < 0 ? (ue += " - ", Ue = -Ue) : ue.length > 0 && (ue += " + "), Qe === 0 || Ue !== 1) {
            var He = this.field.log(Ue);
            He === 0 ? ue += "1" : He === 1 ? ue += "a" : (ue += "a^", ue += He);
          }
          Qe !== 0 && (Qe === 1 ? ue += "x" : (ue += "x^", ue += Qe));
        }
      }
      return ue;
    }, me;
  }()
), __extends$Y = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), ArithmeticException = (
  /** @class */
  function(me) {
    __extends$Y(ue, me);
    function ue() {
      return me !== null && me.apply(this, arguments) || this;
    }
    return ue.kind = "ArithmeticException", ue;
  }(Exception)
), __extends$X = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), GenericGF = (
  /** @class */
  function(me) {
    __extends$X(ue, me);
    function ue(Qe, Ue, He) {
      var Ge = me.call(this) || this;
      Ge.primitive = Qe, Ge.size = Ue, Ge.generatorBase = He;
      for (var Xe = new Int32Array(Ue), Ke = 1, $e = 0; $e < Ue; $e++)
        Xe[$e] = Ke, Ke *= 2, Ke >= Ue && (Ke ^= Qe, Ke &= Ue - 1);
      Ge.expTable = Xe;
      for (var Je = new Int32Array(Ue), $e = 0; $e < Ue - 1; $e++)
        Je[Xe[$e]] = $e;
      return Ge.logTable = Je, Ge.zero = new GenericGFPoly(Ge, Int32Array.from([0])), Ge.one = new GenericGFPoly(Ge, Int32Array.from([1])), Ge;
    }
    return ue.prototype.getZero = function() {
      return this.zero;
    }, ue.prototype.getOne = function() {
      return this.one;
    }, ue.prototype.buildMonomial = function(Qe, Ue) {
      if (Qe < 0)
        throw new IllegalArgumentException();
      if (Ue === 0)
        return this.zero;
      var He = new Int32Array(Qe + 1);
      return He[0] = Ue, new GenericGFPoly(this, He);
    }, ue.prototype.inverse = function(Qe) {
      if (Qe === 0)
        throw new ArithmeticException();
      return this.expTable[this.size - this.logTable[Qe] - 1];
    }, ue.prototype.multiply = function(Qe, Ue) {
      return Qe === 0 || Ue === 0 ? 0 : this.expTable[(this.logTable[Qe] + this.logTable[Ue]) % (this.size - 1)];
    }, ue.prototype.getSize = function() {
      return this.size;
    }, ue.prototype.getGeneratorBase = function() {
      return this.generatorBase;
    }, ue.prototype.toString = function() {
      return "GF(0x" + Integer.toHexString(this.primitive) + "," + this.size + ")";
    }, ue.prototype.equals = function(Qe) {
      return Qe === this;
    }, ue.AZTEC_DATA_12 = new ue(4201, 4096, 1), ue.AZTEC_DATA_10 = new ue(1033, 1024, 1), ue.AZTEC_DATA_6 = new ue(67, 64, 1), ue.AZTEC_PARAM = new ue(19, 16, 1), ue.QR_CODE_FIELD_256 = new ue(285, 256, 0), ue.DATA_MATRIX_FIELD_256 = new ue(301, 256, 1), ue.AZTEC_DATA_8 = ue.DATA_MATRIX_FIELD_256, ue.MAXICODE_FIELD_64 = ue.AZTEC_DATA_6, ue;
  }(AbstractGenericGF)
), __extends$W = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), ReedSolomonException = (
  /** @class */
  function(me) {
    __extends$W(ue, me);
    function ue() {
      return me !== null && me.apply(this, arguments) || this;
    }
    return ue.kind = "ReedSolomonException", ue;
  }(Exception)
), __extends$V = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), IllegalStateException = (
  /** @class */
  function(me) {
    __extends$V(ue, me);
    function ue() {
      return me !== null && me.apply(this, arguments) || this;
    }
    return ue.kind = "IllegalStateException", ue;
  }(Exception)
), ReedSolomonDecoder = (
  /** @class */
  function() {
    function me(ue) {
      this.field = ue;
    }
    return me.prototype.decode = function(ue, Qe) {
      for (var Ue = this.field, He = new GenericGFPoly(Ue, ue), Ge = new Int32Array(Qe), Xe = !0, Ke = 0; Ke < Qe; Ke++) {
        var $e = He.evaluateAt(Ue.exp(Ke + Ue.getGeneratorBase()));
        Ge[Ge.length - 1 - Ke] = $e, $e !== 0 && (Xe = !1);
      }
      if (!Xe)
        for (var Je = new GenericGFPoly(Ue, Ge), Ze = this.runEuclideanAlgorithm(Ue.buildMonomial(Qe, 1), Je, Qe), nt = Ze[0], tt = Ze[1], et = this.findErrorLocations(nt), rt = this.findErrorMagnitudes(tt, et), Ke = 0; Ke < et.length; Ke++) {
          var it = ue.length - 1 - Ue.log(et[Ke]);
          if (it < 0)
            throw new ReedSolomonException("Bad error location");
          ue[it] = GenericGF.addOrSubtract(ue[it], rt[Ke]);
        }
    }, me.prototype.runEuclideanAlgorithm = function(ue, Qe, Ue) {
      if (ue.getDegree() < Qe.getDegree()) {
        var He = ue;
        ue = Qe, Qe = He;
      }
      for (var Ge = this.field, Xe = ue, Ke = Qe, $e = Ge.getZero(), Je = Ge.getOne(); Ke.getDegree() >= (Ue / 2 | 0); ) {
        var Ze = Xe, nt = $e;
        if (Xe = Ke, $e = Je, Xe.isZero())
          throw new ReedSolomonException("r_{i-1} was zero");
        Ke = Ze;
        for (var tt = Ge.getZero(), et = Xe.getCoefficient(Xe.getDegree()), rt = Ge.inverse(et); Ke.getDegree() >= Xe.getDegree() && !Ke.isZero(); ) {
          var it = Ke.getDegree() - Xe.getDegree(), ot = Ge.multiply(Ke.getCoefficient(Ke.getDegree()), rt);
          tt = tt.addOrSubtract(Ge.buildMonomial(it, ot)), Ke = Ke.addOrSubtract(Xe.multiplyByMonomial(it, ot));
        }
        if (Je = tt.multiply($e).addOrSubtract(nt), Ke.getDegree() >= Xe.getDegree())
          throw new IllegalStateException("Division algorithm failed to reduce polynomial?");
      }
      var at = Je.getCoefficient(0);
      if (at === 0)
        throw new ReedSolomonException("sigmaTilde(0) was zero");
      var st = Ge.inverse(at), ut = Je.multiplyScalar(st), lt = Ke.multiplyScalar(st);
      return [ut, lt];
    }, me.prototype.findErrorLocations = function(ue) {
      var Qe = ue.getDegree();
      if (Qe === 1)
        return Int32Array.from([ue.getCoefficient(1)]);
      for (var Ue = new Int32Array(Qe), He = 0, Ge = this.field, Xe = 1; Xe < Ge.getSize() && He < Qe; Xe++)
        ue.evaluateAt(Xe) === 0 && (Ue[He] = Ge.inverse(Xe), He++);
      if (He !== Qe)
        throw new ReedSolomonException("Error locator degree does not match number of roots");
      return Ue;
    }, me.prototype.findErrorMagnitudes = function(ue, Qe) {
      for (var Ue = Qe.length, He = new Int32Array(Ue), Ge = this.field, Xe = 0; Xe < Ue; Xe++) {
        for (var Ke = Ge.inverse(Qe[Xe]), $e = 1, Je = 0; Je < Ue; Je++)
          if (Xe !== Je) {
            var Ze = Ge.multiply(Qe[Je], Ke), nt = Ze & 1 ? Ze & -2 : Ze | 1;
            $e = Ge.multiply($e, nt);
          }
        He[Xe] = Ge.multiply(ue.evaluateAt(Ke), Ge.inverse($e)), Ge.getGeneratorBase() !== 0 && (He[Xe] = Ge.multiply(He[Xe], Ke));
      }
      return He;
    }, me;
  }()
), Table$1;
(function(me) {
  me[me.UPPER = 0] = "UPPER", me[me.LOWER = 1] = "LOWER", me[me.MIXED = 2] = "MIXED", me[me.DIGIT = 3] = "DIGIT", me[me.PUNCT = 4] = "PUNCT", me[me.BINARY = 5] = "BINARY";
})(Table$1 || (Table$1 = {}));
var Decoder$2 = (
  /** @class */
  function() {
    function me() {
    }
    return me.prototype.decode = function(ue) {
      this.ddata = ue;
      var Qe = ue.getBits(), Ue = this.extractBits(Qe), He = this.correctBits(Ue), Ge = me.convertBoolArrayToByteArray(He), Xe = me.getEncodedData(He), Ke = new DecoderResult(Ge, Xe, null, null);
      return Ke.setNumBits(He.length), Ke;
    }, me.highLevelDecode = function(ue) {
      return this.getEncodedData(ue);
    }, me.getEncodedData = function(ue) {
      for (var Qe = ue.length, Ue = Table$1.UPPER, He = Table$1.UPPER, Ge = "", Xe = 0; Xe < Qe; )
        if (He === Table$1.BINARY) {
          if (Qe - Xe < 5)
            break;
          var Ke = me.readCode(ue, Xe, 5);
          if (Xe += 5, Ke === 0) {
            if (Qe - Xe < 11)
              break;
            Ke = me.readCode(ue, Xe, 11) + 31, Xe += 11;
          }
          for (var $e = 0; $e < Ke; $e++) {
            if (Qe - Xe < 8) {
              Xe = Qe;
              break;
            }
            var Je = me.readCode(ue, Xe, 8);
            Ge += /*(char)*/
            StringUtils.castAsNonUtf8Char(Je), Xe += 8;
          }
          He = Ue;
        } else {
          var Ze = He === Table$1.DIGIT ? 4 : 5;
          if (Qe - Xe < Ze)
            break;
          var Je = me.readCode(ue, Xe, Ze);
          Xe += Ze;
          var nt = me.getCharacter(He, Je);
          nt.startsWith("CTRL_") ? (Ue = He, He = me.getTable(nt.charAt(5)), nt.charAt(6) === "L" && (Ue = He)) : (Ge += nt, He = Ue);
        }
      return Ge;
    }, me.getTable = function(ue) {
      switch (ue) {
        case "L":
          return Table$1.LOWER;
        case "P":
          return Table$1.PUNCT;
        case "M":
          return Table$1.MIXED;
        case "D":
          return Table$1.DIGIT;
        case "B":
          return Table$1.BINARY;
        case "U":
        default:
          return Table$1.UPPER;
      }
    }, me.getCharacter = function(ue, Qe) {
      switch (ue) {
        case Table$1.UPPER:
          return me.UPPER_TABLE[Qe];
        case Table$1.LOWER:
          return me.LOWER_TABLE[Qe];
        case Table$1.MIXED:
          return me.MIXED_TABLE[Qe];
        case Table$1.PUNCT:
          return me.PUNCT_TABLE[Qe];
        case Table$1.DIGIT:
          return me.DIGIT_TABLE[Qe];
        default:
          throw new IllegalStateException("Bad table");
      }
    }, me.prototype.correctBits = function(ue) {
      var Qe, Ue;
      this.ddata.getNbLayers() <= 2 ? (Ue = 6, Qe = GenericGF.AZTEC_DATA_6) : this.ddata.getNbLayers() <= 8 ? (Ue = 8, Qe = GenericGF.AZTEC_DATA_8) : this.ddata.getNbLayers() <= 22 ? (Ue = 10, Qe = GenericGF.AZTEC_DATA_10) : (Ue = 12, Qe = GenericGF.AZTEC_DATA_12);
      var He = this.ddata.getNbDatablocks(), Ge = ue.length / Ue;
      if (Ge < He)
        throw new FormatException();
      for (var Xe = ue.length % Ue, Ke = new Int32Array(Ge), $e = 0; $e < Ge; $e++, Xe += Ue)
        Ke[$e] = me.readCode(ue, Xe, Ue);
      try {
        var Je = new ReedSolomonDecoder(Qe);
        Je.decode(Ke, Ge - He);
      } catch (ot) {
        throw new FormatException(ot);
      }
      for (var Ze = (1 << Ue) - 1, nt = 0, $e = 0; $e < He; $e++) {
        var tt = Ke[$e];
        if (tt === 0 || tt === Ze)
          throw new FormatException();
        (tt === 1 || tt === Ze - 1) && nt++;
      }
      for (var et = new Array(He * Ue - nt), rt = 0, $e = 0; $e < He; $e++) {
        var tt = Ke[$e];
        if (tt === 1 || tt === Ze - 1)
          et.fill(tt > 1, rt, rt + Ue - 1), rt += Ue - 1;
        else
          for (var it = Ue - 1; it >= 0; --it)
            et[rt++] = (tt & 1 << it) !== 0;
      }
      return et;
    }, me.prototype.extractBits = function(ue) {
      var Qe = this.ddata.isCompact(), Ue = this.ddata.getNbLayers(), He = (Qe ? 11 : 14) + Ue * 4, Ge = new Int32Array(He), Xe = new Array(this.totalBitsInLayer(Ue, Qe));
      if (Qe)
        for (var Ke = 0; Ke < Ge.length; Ke++)
          Ge[Ke] = Ke;
      else
        for (var $e = He + 1 + 2 * Integer.truncDivision(Integer.truncDivision(He, 2) - 1, 15), Je = He / 2, Ze = Integer.truncDivision($e, 2), Ke = 0; Ke < Je; Ke++) {
          var nt = Ke + Integer.truncDivision(Ke, 15);
          Ge[Je - Ke - 1] = Ze - nt - 1, Ge[Je + Ke] = Ze + nt + 1;
        }
      for (var Ke = 0, tt = 0; Ke < Ue; Ke++) {
        for (var et = (Ue - Ke) * 4 + (Qe ? 9 : 12), rt = Ke * 2, it = He - 1 - rt, ot = 0; ot < et; ot++)
          for (var at = ot * 2, st = 0; st < 2; st++)
            Xe[tt + at + st] = ue.get(Ge[rt + st], Ge[rt + ot]), Xe[tt + 2 * et + at + st] = ue.get(Ge[rt + ot], Ge[it - st]), Xe[tt + 4 * et + at + st] = ue.get(Ge[it - st], Ge[it - ot]), Xe[tt + 6 * et + at + st] = ue.get(Ge[it - ot], Ge[rt + st]);
        tt += et * 8;
      }
      return Xe;
    }, me.readCode = function(ue, Qe, Ue) {
      for (var He = 0, Ge = Qe; Ge < Qe + Ue; Ge++)
        He <<= 1, ue[Ge] && (He |= 1);
      return He;
    }, me.readByte = function(ue, Qe) {
      var Ue = ue.length - Qe;
      return Ue >= 8 ? me.readCode(ue, Qe, 8) : me.readCode(ue, Qe, Ue) << 8 - Ue;
    }, me.convertBoolArrayToByteArray = function(ue) {
      for (var Qe = new Uint8Array((ue.length + 7) / 8), Ue = 0; Ue < Qe.length; Ue++)
        Qe[Ue] = me.readByte(ue, 8 * Ue);
      return Qe;
    }, me.prototype.totalBitsInLayer = function(ue, Qe) {
      return ((Qe ? 88 : 112) + 16 * ue) * ue;
    }, me.UPPER_TABLE = [
      "CTRL_PS",
      " ",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
      "CTRL_LL",
      "CTRL_ML",
      "CTRL_DL",
      "CTRL_BS"
    ], me.LOWER_TABLE = [
      "CTRL_PS",
      " ",
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z",
      "CTRL_US",
      "CTRL_ML",
      "CTRL_DL",
      "CTRL_BS"
    ], me.MIXED_TABLE = [
      // Module parse failed: Octal literal in strict mode (50:29)
      // so number string were scaped
      "CTRL_PS",
      " ",
      "\\1",
      "\\2",
      "\\3",
      "\\4",
      "\\5",
      "\\6",
      "\\7",
      "\b",
      "	",
      `
`,
      "\\13",
      "\f",
      "\r",
      "\\33",
      "\\34",
      "\\35",
      "\\36",
      "\\37",
      "@",
      "\\",
      "^",
      "_",
      "`",
      "|",
      "~",
      "\\177",
      "CTRL_LL",
      "CTRL_UL",
      "CTRL_PL",
      "CTRL_BS"
    ], me.PUNCT_TABLE = [
      "",
      "\r",
      `\r
`,
      ". ",
      ", ",
      ": ",
      "!",
      '"',
      "#",
      "$",
      "%",
      "&",
      "'",
      "(",
      ")",
      "*",
      "+",
      ",",
      "-",
      ".",
      "/",
      ":",
      ";",
      "<",
      "=",
      ">",
      "?",
      "[",
      "]",
      "{",
      "}",
      "CTRL_UL"
    ], me.DIGIT_TABLE = [
      "CTRL_PS",
      " ",
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      ",",
      ".",
      "CTRL_UL",
      "CTRL_US"
    ], me;
  }()
), MathUtils = (
  /** @class */
  function() {
    function me() {
    }
    return me.round = function(ue) {
      return isNaN(ue) ? 0 : ue <= Number.MIN_SAFE_INTEGER ? Number.MIN_SAFE_INTEGER : ue >= Number.MAX_SAFE_INTEGER ? Number.MAX_SAFE_INTEGER : (
        /*(int) */
        ue + (ue < 0 ? -0.5 : 0.5) | 0
      );
    }, me.distance = function(ue, Qe, Ue, He) {
      var Ge = ue - Ue, Xe = Qe - He;
      return (
        /*(float) */
        Math.sqrt(Ge * Ge + Xe * Xe)
      );
    }, me.sum = function(ue) {
      for (var Qe = 0, Ue = 0, He = ue.length; Ue !== He; Ue++) {
        var Ge = ue[Ue];
        Qe += Ge;
      }
      return Qe;
    }, me;
  }()
), Float = (
  /** @class */
  function() {
    function me() {
    }
    return me.floatToIntBits = function(ue) {
      return ue;
    }, me.MAX_VALUE = Number.MAX_SAFE_INTEGER, me;
  }()
), ResultPoint = (
  /** @class */
  function() {
    function me(ue, Qe) {
      this.x = ue, this.y = Qe;
    }
    return me.prototype.getX = function() {
      return this.x;
    }, me.prototype.getY = function() {
      return this.y;
    }, me.prototype.equals = function(ue) {
      if (ue instanceof me) {
        var Qe = ue;
        return this.x === Qe.x && this.y === Qe.y;
      }
      return !1;
    }, me.prototype.hashCode = function() {
      return 31 * Float.floatToIntBits(this.x) + Float.floatToIntBits(this.y);
    }, me.prototype.toString = function() {
      return "(" + this.x + "," + this.y + ")";
    }, me.orderBestPatterns = function(ue) {
      var Qe = this.distance(ue[0], ue[1]), Ue = this.distance(ue[1], ue[2]), He = this.distance(ue[0], ue[2]), Ge, Xe, Ke;
      if (Ue >= Qe && Ue >= He ? (Xe = ue[0], Ge = ue[1], Ke = ue[2]) : He >= Ue && He >= Qe ? (Xe = ue[1], Ge = ue[0], Ke = ue[2]) : (Xe = ue[2], Ge = ue[0], Ke = ue[1]), this.crossProductZ(Ge, Xe, Ke) < 0) {
        var $e = Ge;
        Ge = Ke, Ke = $e;
      }
      ue[0] = Ge, ue[1] = Xe, ue[2] = Ke;
    }, me.distance = function(ue, Qe) {
      return MathUtils.distance(ue.x, ue.y, Qe.x, Qe.y);
    }, me.crossProductZ = function(ue, Qe, Ue) {
      var He = Qe.x, Ge = Qe.y;
      return (Ue.x - He) * (ue.y - Ge) - (Ue.y - Ge) * (ue.x - He);
    }, me;
  }()
), DetectorResult = (
  /** @class */
  function() {
    function me(ue, Qe) {
      this.bits = ue, this.points = Qe;
    }
    return me.prototype.getBits = function() {
      return this.bits;
    }, me.prototype.getPoints = function() {
      return this.points;
    }, me;
  }()
), __extends$U = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), AztecDetectorResult = (
  /** @class */
  function(me) {
    __extends$U(ue, me);
    function ue(Qe, Ue, He, Ge, Xe) {
      var Ke = me.call(this, Qe, Ue) || this;
      return Ke.compact = He, Ke.nbDatablocks = Ge, Ke.nbLayers = Xe, Ke;
    }
    return ue.prototype.getNbLayers = function() {
      return this.nbLayers;
    }, ue.prototype.getNbDatablocks = function() {
      return this.nbDatablocks;
    }, ue.prototype.isCompact = function() {
      return this.compact;
    }, ue;
  }(DetectorResult)
), WhiteRectangleDetector = (
  /** @class */
  function() {
    function me(ue, Qe, Ue, He) {
      this.image = ue, this.height = ue.getHeight(), this.width = ue.getWidth(), Qe == null && (Qe = me.INIT_SIZE), Ue == null && (Ue = ue.getWidth() / 2 | 0), He == null && (He = ue.getHeight() / 2 | 0);
      var Ge = Qe / 2 | 0;
      if (this.leftInit = Ue - Ge, this.rightInit = Ue + Ge, this.upInit = He - Ge, this.downInit = He + Ge, this.upInit < 0 || this.leftInit < 0 || this.downInit >= this.height || this.rightInit >= this.width)
        throw new NotFoundException();
    }
    return me.prototype.detect = function() {
      for (var ue = this.leftInit, Qe = this.rightInit, Ue = this.upInit, He = this.downInit, Ge = !1, Xe = !0, Ke = !1, $e = !1, Je = !1, Ze = !1, nt = !1, tt = this.width, et = this.height; Xe; ) {
        Xe = !1;
        for (var rt = !0; (rt || !$e) && Qe < tt; )
          rt = this.containsBlackPoint(Ue, He, Qe, !1), rt ? (Qe++, Xe = !0, $e = !0) : $e || Qe++;
        if (Qe >= tt) {
          Ge = !0;
          break;
        }
        for (var it = !0; (it || !Je) && He < et; )
          it = this.containsBlackPoint(ue, Qe, He, !0), it ? (He++, Xe = !0, Je = !0) : Je || He++;
        if (He >= et) {
          Ge = !0;
          break;
        }
        for (var ot = !0; (ot || !Ze) && ue >= 0; )
          ot = this.containsBlackPoint(Ue, He, ue, !1), ot ? (ue--, Xe = !0, Ze = !0) : Ze || ue--;
        if (ue < 0) {
          Ge = !0;
          break;
        }
        for (var at = !0; (at || !nt) && Ue >= 0; )
          at = this.containsBlackPoint(ue, Qe, Ue, !0), at ? (Ue--, Xe = !0, nt = !0) : nt || Ue--;
        if (Ue < 0) {
          Ge = !0;
          break;
        }
        Xe && (Ke = !0);
      }
      if (!Ge && Ke) {
        for (var st = Qe - ue, ut = null, lt = 1; ut === null && lt < st; lt++)
          ut = this.getBlackPointOnSegment(ue, He - lt, ue + lt, He);
        if (ut == null)
          throw new NotFoundException();
        for (var dt = null, lt = 1; dt === null && lt < st; lt++)
          dt = this.getBlackPointOnSegment(ue, Ue + lt, ue + lt, Ue);
        if (dt == null)
          throw new NotFoundException();
        for (var At = null, lt = 1; At === null && lt < st; lt++)
          At = this.getBlackPointOnSegment(Qe, Ue + lt, Qe - lt, Ue);
        if (At == null)
          throw new NotFoundException();
        for (var pt = null, lt = 1; pt === null && lt < st; lt++)
          pt = this.getBlackPointOnSegment(Qe, He - lt, Qe - lt, He);
        if (pt == null)
          throw new NotFoundException();
        return this.centerEdges(pt, ut, At, dt);
      } else
        throw new NotFoundException();
    }, me.prototype.getBlackPointOnSegment = function(ue, Qe, Ue, He) {
      for (var Ge = MathUtils.round(MathUtils.distance(ue, Qe, Ue, He)), Xe = (Ue - ue) / Ge, Ke = (He - Qe) / Ge, $e = this.image, Je = 0; Je < Ge; Je++) {
        var Ze = MathUtils.round(ue + Je * Xe), nt = MathUtils.round(Qe + Je * Ke);
        if ($e.get(Ze, nt))
          return new ResultPoint(Ze, nt);
      }
      return null;
    }, me.prototype.centerEdges = function(ue, Qe, Ue, He) {
      var Ge = ue.getX(), Xe = ue.getY(), Ke = Qe.getX(), $e = Qe.getY(), Je = Ue.getX(), Ze = Ue.getY(), nt = He.getX(), tt = He.getY(), et = me.CORR;
      return Ge < this.width / 2 ? [
        new ResultPoint(nt - et, tt + et),
        new ResultPoint(Ke + et, $e + et),
        new ResultPoint(Je - et, Ze - et),
        new ResultPoint(Ge + et, Xe - et)
      ] : [
        new ResultPoint(nt + et, tt + et),
        new ResultPoint(Ke + et, $e - et),
        new ResultPoint(Je - et, Ze + et),
        new ResultPoint(Ge - et, Xe - et)
      ];
    }, me.prototype.containsBlackPoint = function(ue, Qe, Ue, He) {
      var Ge = this.image;
      if (He) {
        for (var Xe = ue; Xe <= Qe; Xe++)
          if (Ge.get(Xe, Ue))
            return !0;
      } else
        for (var Ke = ue; Ke <= Qe; Ke++)
          if (Ge.get(Ue, Ke))
            return !0;
      return !1;
    }, me.INIT_SIZE = 10, me.CORR = 1, me;
  }()
), GridSampler = (
  /** @class */
  function() {
    function me() {
    }
    return me.checkAndNudgePoints = function(ue, Qe) {
      for (var Ue = ue.getWidth(), He = ue.getHeight(), Ge = !0, Xe = 0; Xe < Qe.length && Ge; Xe += 2) {
        var Ke = Math.floor(Qe[Xe]), $e = Math.floor(Qe[Xe + 1]);
        if (Ke < -1 || Ke > Ue || $e < -1 || $e > He)
          throw new NotFoundException();
        Ge = !1, Ke === -1 ? (Qe[Xe] = 0, Ge = !0) : Ke === Ue && (Qe[Xe] = Ue - 1, Ge = !0), $e === -1 ? (Qe[Xe + 1] = 0, Ge = !0) : $e === He && (Qe[Xe + 1] = He - 1, Ge = !0);
      }
      Ge = !0;
      for (var Xe = Qe.length - 2; Xe >= 0 && Ge; Xe -= 2) {
        var Ke = Math.floor(Qe[Xe]), $e = Math.floor(Qe[Xe + 1]);
        if (Ke < -1 || Ke > Ue || $e < -1 || $e > He)
          throw new NotFoundException();
        Ge = !1, Ke === -1 ? (Qe[Xe] = 0, Ge = !0) : Ke === Ue && (Qe[Xe] = Ue - 1, Ge = !0), $e === -1 ? (Qe[Xe + 1] = 0, Ge = !0) : $e === He && (Qe[Xe + 1] = He - 1, Ge = !0);
      }
    }, me;
  }()
), PerspectiveTransform = (
  /** @class */
  function() {
    function me(ue, Qe, Ue, He, Ge, Xe, Ke, $e, Je) {
      this.a11 = ue, this.a21 = Qe, this.a31 = Ue, this.a12 = He, this.a22 = Ge, this.a32 = Xe, this.a13 = Ke, this.a23 = $e, this.a33 = Je;
    }
    return me.quadrilateralToQuadrilateral = function(ue, Qe, Ue, He, Ge, Xe, Ke, $e, Je, Ze, nt, tt, et, rt, it, ot) {
      var at = me.quadrilateralToSquare(ue, Qe, Ue, He, Ge, Xe, Ke, $e), st = me.squareToQuadrilateral(Je, Ze, nt, tt, et, rt, it, ot);
      return st.times(at);
    }, me.prototype.transformPoints = function(ue) {
      for (var Qe = ue.length, Ue = this.a11, He = this.a12, Ge = this.a13, Xe = this.a21, Ke = this.a22, $e = this.a23, Je = this.a31, Ze = this.a32, nt = this.a33, tt = 0; tt < Qe; tt += 2) {
        var et = ue[tt], rt = ue[tt + 1], it = Ge * et + $e * rt + nt;
        ue[tt] = (Ue * et + Xe * rt + Je) / it, ue[tt + 1] = (He * et + Ke * rt + Ze) / it;
      }
    }, me.prototype.transformPointsWithValues = function(ue, Qe) {
      for (var Ue = this.a11, He = this.a12, Ge = this.a13, Xe = this.a21, Ke = this.a22, $e = this.a23, Je = this.a31, Ze = this.a32, nt = this.a33, tt = ue.length, et = 0; et < tt; et++) {
        var rt = ue[et], it = Qe[et], ot = Ge * rt + $e * it + nt;
        ue[et] = (Ue * rt + Xe * it + Je) / ot, Qe[et] = (He * rt + Ke * it + Ze) / ot;
      }
    }, me.squareToQuadrilateral = function(ue, Qe, Ue, He, Ge, Xe, Ke, $e) {
      var Je = ue - Ue + Ge - Ke, Ze = Qe - He + Xe - $e;
      if (Je === 0 && Ze === 0)
        return new me(Ue - ue, Ge - Ue, ue, He - Qe, Xe - He, Qe, 0, 0, 1);
      var nt = Ue - Ge, tt = Ke - Ge, et = He - Xe, rt = $e - Xe, it = nt * rt - tt * et, ot = (Je * rt - tt * Ze) / it, at = (nt * Ze - Je * et) / it;
      return new me(Ue - ue + ot * Ue, Ke - ue + at * Ke, ue, He - Qe + ot * He, $e - Qe + at * $e, Qe, ot, at, 1);
    }, me.quadrilateralToSquare = function(ue, Qe, Ue, He, Ge, Xe, Ke, $e) {
      return me.squareToQuadrilateral(ue, Qe, Ue, He, Ge, Xe, Ke, $e).buildAdjoint();
    }, me.prototype.buildAdjoint = function() {
      return new me(this.a22 * this.a33 - this.a23 * this.a32, this.a23 * this.a31 - this.a21 * this.a33, this.a21 * this.a32 - this.a22 * this.a31, this.a13 * this.a32 - this.a12 * this.a33, this.a11 * this.a33 - this.a13 * this.a31, this.a12 * this.a31 - this.a11 * this.a32, this.a12 * this.a23 - this.a13 * this.a22, this.a13 * this.a21 - this.a11 * this.a23, this.a11 * this.a22 - this.a12 * this.a21);
    }, me.prototype.times = function(ue) {
      return new me(this.a11 * ue.a11 + this.a21 * ue.a12 + this.a31 * ue.a13, this.a11 * ue.a21 + this.a21 * ue.a22 + this.a31 * ue.a23, this.a11 * ue.a31 + this.a21 * ue.a32 + this.a31 * ue.a33, this.a12 * ue.a11 + this.a22 * ue.a12 + this.a32 * ue.a13, this.a12 * ue.a21 + this.a22 * ue.a22 + this.a32 * ue.a23, this.a12 * ue.a31 + this.a22 * ue.a32 + this.a32 * ue.a33, this.a13 * ue.a11 + this.a23 * ue.a12 + this.a33 * ue.a13, this.a13 * ue.a21 + this.a23 * ue.a22 + this.a33 * ue.a23, this.a13 * ue.a31 + this.a23 * ue.a32 + this.a33 * ue.a33);
    }, me;
  }()
), __extends$T = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), DefaultGridSampler = (
  /** @class */
  function(me) {
    __extends$T(ue, me);
    function ue() {
      return me !== null && me.apply(this, arguments) || this;
    }
    return ue.prototype.sampleGrid = function(Qe, Ue, He, Ge, Xe, Ke, $e, Je, Ze, nt, tt, et, rt, it, ot, at, st, ut, lt) {
      var dt = PerspectiveTransform.quadrilateralToQuadrilateral(Ge, Xe, Ke, $e, Je, Ze, nt, tt, et, rt, it, ot, at, st, ut, lt);
      return this.sampleGridWithTransform(Qe, Ue, He, dt);
    }, ue.prototype.sampleGridWithTransform = function(Qe, Ue, He, Ge) {
      if (Ue <= 0 || He <= 0)
        throw new NotFoundException();
      for (var Xe = new BitMatrix(Ue, He), Ke = new Float32Array(2 * Ue), $e = 0; $e < He; $e++) {
        for (var Je = Ke.length, Ze = $e + 0.5, nt = 0; nt < Je; nt += 2)
          Ke[nt] = nt / 2 + 0.5, Ke[nt + 1] = Ze;
        Ge.transformPoints(Ke), GridSampler.checkAndNudgePoints(Qe, Ke);
        try {
          for (var nt = 0; nt < Je; nt += 2)
            Qe.get(Math.floor(Ke[nt]), Math.floor(Ke[nt + 1])) && Xe.set(nt / 2, $e);
        } catch {
          throw new NotFoundException();
        }
      }
      return Xe;
    }, ue;
  }(GridSampler)
), GridSamplerInstance = (
  /** @class */
  function() {
    function me() {
    }
    return me.setGridSampler = function(ue) {
      me.gridSampler = ue;
    }, me.getInstance = function() {
      return me.gridSampler;
    }, me.gridSampler = new DefaultGridSampler(), me;
  }()
), Point$1 = (
  /** @class */
  function() {
    function me(ue, Qe) {
      this.x = ue, this.y = Qe;
    }
    return me.prototype.toResultPoint = function() {
      return new ResultPoint(this.getX(), this.getY());
    }, me.prototype.getX = function() {
      return this.x;
    }, me.prototype.getY = function() {
      return this.y;
    }, me;
  }()
), Detector$3 = (
  /** @class */
  function() {
    function me(ue) {
      this.EXPECTED_CORNER_BITS = new Int32Array([
        3808,
        476,
        2107,
        1799
      ]), this.image = ue;
    }
    return me.prototype.detect = function() {
      return this.detectMirror(!1);
    }, me.prototype.detectMirror = function(ue) {
      var Qe = this.getMatrixCenter(), Ue = this.getBullsEyeCorners(Qe);
      if (ue) {
        var He = Ue[0];
        Ue[0] = Ue[2], Ue[2] = He;
      }
      this.extractParameters(Ue);
      var Ge = this.sampleGrid(this.image, Ue[this.shift % 4], Ue[(this.shift + 1) % 4], Ue[(this.shift + 2) % 4], Ue[(this.shift + 3) % 4]), Xe = this.getMatrixCornerPoints(Ue);
      return new AztecDetectorResult(Ge, Xe, this.compact, this.nbDataBlocks, this.nbLayers);
    }, me.prototype.extractParameters = function(ue) {
      if (!this.isValidPoint(ue[0]) || !this.isValidPoint(ue[1]) || !this.isValidPoint(ue[2]) || !this.isValidPoint(ue[3]))
        throw new NotFoundException();
      var Qe = 2 * this.nbCenterLayers, Ue = new Int32Array([
        this.sampleLine(ue[0], ue[1], Qe),
        this.sampleLine(ue[1], ue[2], Qe),
        this.sampleLine(ue[2], ue[3], Qe),
        this.sampleLine(ue[3], ue[0], Qe)
        // Top
      ]);
      this.shift = this.getRotation(Ue, Qe);
      for (var He = 0, Ge = 0; Ge < 4; Ge++) {
        var Xe = Ue[(this.shift + Ge) % 4];
        this.compact ? (He <<= 7, He += Xe >> 1 & 127) : (He <<= 10, He += (Xe >> 2 & 992) + (Xe >> 1 & 31));
      }
      var Ke = this.getCorrectedParameterData(He, this.compact);
      this.compact ? (this.nbLayers = (Ke >> 6) + 1, this.nbDataBlocks = (Ke & 63) + 1) : (this.nbLayers = (Ke >> 11) + 1, this.nbDataBlocks = (Ke & 2047) + 1);
    }, me.prototype.getRotation = function(ue, Qe) {
      var Ue = 0;
      ue.forEach(function(Ge, Xe, Ke) {
        var $e = (Ge >> Qe - 2 << 1) + (Ge & 1);
        Ue = (Ue << 3) + $e;
      }), Ue = ((Ue & 1) << 11) + (Ue >> 1);
      for (var He = 0; He < 4; He++)
        if (Integer.bitCount(Ue ^ this.EXPECTED_CORNER_BITS[He]) <= 2)
          return He;
      throw new NotFoundException();
    }, me.prototype.getCorrectedParameterData = function(ue, Qe) {
      var Ue, He;
      Qe ? (Ue = 7, He = 2) : (Ue = 10, He = 4);
      for (var Ge = Ue - He, Xe = new Int32Array(Ue), Ke = Ue - 1; Ke >= 0; --Ke)
        Xe[Ke] = ue & 15, ue >>= 4;
      try {
        var $e = new ReedSolomonDecoder(GenericGF.AZTEC_PARAM);
        $e.decode(Xe, Ge);
      } catch {
        throw new NotFoundException();
      }
      for (var Je = 0, Ke = 0; Ke < He; Ke++)
        Je = (Je << 4) + Xe[Ke];
      return Je;
    }, me.prototype.getBullsEyeCorners = function(ue) {
      var Qe = ue, Ue = ue, He = ue, Ge = ue, Xe = !0;
      for (this.nbCenterLayers = 1; this.nbCenterLayers < 9; this.nbCenterLayers++) {
        var Ke = this.getFirstDifferent(Qe, Xe, 1, -1), $e = this.getFirstDifferent(Ue, Xe, 1, 1), Je = this.getFirstDifferent(He, Xe, -1, 1), Ze = this.getFirstDifferent(Ge, Xe, -1, -1);
        if (this.nbCenterLayers > 2) {
          var nt = this.distancePoint(Ze, Ke) * this.nbCenterLayers / (this.distancePoint(Ge, Qe) * (this.nbCenterLayers + 2));
          if (nt < 0.75 || nt > 1.25 || !this.isWhiteOrBlackRectangle(Ke, $e, Je, Ze))
            break;
        }
        Qe = Ke, Ue = $e, He = Je, Ge = Ze, Xe = !Xe;
      }
      if (this.nbCenterLayers !== 5 && this.nbCenterLayers !== 7)
        throw new NotFoundException();
      this.compact = this.nbCenterLayers === 5;
      var tt = new ResultPoint(Qe.getX() + 0.5, Qe.getY() - 0.5), et = new ResultPoint(Ue.getX() + 0.5, Ue.getY() + 0.5), rt = new ResultPoint(He.getX() - 0.5, He.getY() + 0.5), it = new ResultPoint(Ge.getX() - 0.5, Ge.getY() - 0.5);
      return this.expandSquare([tt, et, rt, it], 2 * this.nbCenterLayers - 3, 2 * this.nbCenterLayers);
    }, me.prototype.getMatrixCenter = function() {
      var ue, Qe, Ue, He;
      try {
        var Ge = new WhiteRectangleDetector(this.image).detect();
        ue = Ge[0], Qe = Ge[1], Ue = Ge[2], He = Ge[3];
      } catch {
        var Xe = this.image.getWidth() / 2, Ke = this.image.getHeight() / 2;
        ue = this.getFirstDifferent(new Point$1(Xe + 7, Ke - 7), !1, 1, -1).toResultPoint(), Qe = this.getFirstDifferent(new Point$1(Xe + 7, Ke + 7), !1, 1, 1).toResultPoint(), Ue = this.getFirstDifferent(new Point$1(Xe - 7, Ke + 7), !1, -1, 1).toResultPoint(), He = this.getFirstDifferent(new Point$1(Xe - 7, Ke - 7), !1, -1, -1).toResultPoint();
      }
      var $e = MathUtils.round((ue.getX() + He.getX() + Qe.getX() + Ue.getX()) / 4), Je = MathUtils.round((ue.getY() + He.getY() + Qe.getY() + Ue.getY()) / 4);
      try {
        var Ge = new WhiteRectangleDetector(this.image, 15, $e, Je).detect();
        ue = Ge[0], Qe = Ge[1], Ue = Ge[2], He = Ge[3];
      } catch {
        ue = this.getFirstDifferent(new Point$1($e + 7, Je - 7), !1, 1, -1).toResultPoint(), Qe = this.getFirstDifferent(new Point$1($e + 7, Je + 7), !1, 1, 1).toResultPoint(), Ue = this.getFirstDifferent(new Point$1($e - 7, Je + 7), !1, -1, 1).toResultPoint(), He = this.getFirstDifferent(new Point$1($e - 7, Je - 7), !1, -1, -1).toResultPoint();
      }
      return $e = MathUtils.round((ue.getX() + He.getX() + Qe.getX() + Ue.getX()) / 4), Je = MathUtils.round((ue.getY() + He.getY() + Qe.getY() + Ue.getY()) / 4), new Point$1($e, Je);
    }, me.prototype.getMatrixCornerPoints = function(ue) {
      return this.expandSquare(ue, 2 * this.nbCenterLayers, this.getDimension());
    }, me.prototype.sampleGrid = function(ue, Qe, Ue, He, Ge) {
      var Xe = GridSamplerInstance.getInstance(), Ke = this.getDimension(), $e = Ke / 2 - this.nbCenterLayers, Je = Ke / 2 + this.nbCenterLayers;
      return Xe.sampleGrid(
        ue,
        Ke,
        Ke,
        $e,
        $e,
        // topleft
        Je,
        $e,
        // topright
        Je,
        Je,
        // bottomright
        $e,
        Je,
        // bottomleft
        Qe.getX(),
        Qe.getY(),
        Ue.getX(),
        Ue.getY(),
        He.getX(),
        He.getY(),
        Ge.getX(),
        Ge.getY()
      );
    }, me.prototype.sampleLine = function(ue, Qe, Ue) {
      for (var He = 0, Ge = this.distanceResultPoint(ue, Qe), Xe = Ge / Ue, Ke = ue.getX(), $e = ue.getY(), Je = Xe * (Qe.getX() - ue.getX()) / Ge, Ze = Xe * (Qe.getY() - ue.getY()) / Ge, nt = 0; nt < Ue; nt++)
        this.image.get(MathUtils.round(Ke + nt * Je), MathUtils.round($e + nt * Ze)) && (He |= 1 << Ue - nt - 1);
      return He;
    }, me.prototype.isWhiteOrBlackRectangle = function(ue, Qe, Ue, He) {
      var Ge = 3;
      ue = new Point$1(ue.getX() - Ge, ue.getY() + Ge), Qe = new Point$1(Qe.getX() - Ge, Qe.getY() - Ge), Ue = new Point$1(Ue.getX() + Ge, Ue.getY() - Ge), He = new Point$1(He.getX() + Ge, He.getY() + Ge);
      var Xe = this.getColor(He, ue);
      if (Xe === 0)
        return !1;
      var Ke = this.getColor(ue, Qe);
      return Ke !== Xe || (Ke = this.getColor(Qe, Ue), Ke !== Xe) ? !1 : (Ke = this.getColor(Ue, He), Ke === Xe);
    }, me.prototype.getColor = function(ue, Qe) {
      for (var Ue = this.distancePoint(ue, Qe), He = (Qe.getX() - ue.getX()) / Ue, Ge = (Qe.getY() - ue.getY()) / Ue, Xe = 0, Ke = ue.getX(), $e = ue.getY(), Je = this.image.get(ue.getX(), ue.getY()), Ze = Math.ceil(Ue), nt = 0; nt < Ze; nt++)
        Ke += He, $e += Ge, this.image.get(MathUtils.round(Ke), MathUtils.round($e)) !== Je && Xe++;
      var tt = Xe / Ue;
      return tt > 0.1 && tt < 0.9 ? 0 : tt <= 0.1 === Je ? 1 : -1;
    }, me.prototype.getFirstDifferent = function(ue, Qe, Ue, He) {
      for (var Ge = ue.getX() + Ue, Xe = ue.getY() + He; this.isValid(Ge, Xe) && this.image.get(Ge, Xe) === Qe; )
        Ge += Ue, Xe += He;
      for (Ge -= Ue, Xe -= He; this.isValid(Ge, Xe) && this.image.get(Ge, Xe) === Qe; )
        Ge += Ue;
      for (Ge -= Ue; this.isValid(Ge, Xe) && this.image.get(Ge, Xe) === Qe; )
        Xe += He;
      return Xe -= He, new Point$1(Ge, Xe);
    }, me.prototype.expandSquare = function(ue, Qe, Ue) {
      var He = Ue / (2 * Qe), Ge = ue[0].getX() - ue[2].getX(), Xe = ue[0].getY() - ue[2].getY(), Ke = (ue[0].getX() + ue[2].getX()) / 2, $e = (ue[0].getY() + ue[2].getY()) / 2, Je = new ResultPoint(Ke + He * Ge, $e + He * Xe), Ze = new ResultPoint(Ke - He * Ge, $e - He * Xe);
      Ge = ue[1].getX() - ue[3].getX(), Xe = ue[1].getY() - ue[3].getY(), Ke = (ue[1].getX() + ue[3].getX()) / 2, $e = (ue[1].getY() + ue[3].getY()) / 2;
      var nt = new ResultPoint(Ke + He * Ge, $e + He * Xe), tt = new ResultPoint(Ke - He * Ge, $e - He * Xe), et = [Je, nt, Ze, tt];
      return et;
    }, me.prototype.isValid = function(ue, Qe) {
      return ue >= 0 && ue < this.image.getWidth() && Qe > 0 && Qe < this.image.getHeight();
    }, me.prototype.isValidPoint = function(ue) {
      var Qe = MathUtils.round(ue.getX()), Ue = MathUtils.round(ue.getY());
      return this.isValid(Qe, Ue);
    }, me.prototype.distancePoint = function(ue, Qe) {
      return MathUtils.distance(ue.getX(), ue.getY(), Qe.getX(), Qe.getY());
    }, me.prototype.distanceResultPoint = function(ue, Qe) {
      return MathUtils.distance(ue.getX(), ue.getY(), Qe.getX(), Qe.getY());
    }, me.prototype.getDimension = function() {
      return this.compact ? 4 * this.nbLayers + 11 : this.nbLayers <= 4 ? 4 * this.nbLayers + 15 : 4 * this.nbLayers + 2 * (Integer.truncDivision(this.nbLayers - 4, 8) + 1) + 15;
    }, me;
  }()
), AztecReader = (
  /** @class */
  function() {
    function me() {
    }
    return me.prototype.decode = function(ue, Qe) {
      Qe === void 0 && (Qe = null);
      var Ue = null, He = new Detector$3(ue.getBlackMatrix()), Ge = null, Xe = null;
      try {
        var Ke = He.detectMirror(!1);
        Ge = Ke.getPoints(), this.reportFoundResultPoints(Qe, Ge), Xe = new Decoder$2().decode(Ke);
      } catch (nt) {
        Ue = nt;
      }
      if (Xe == null)
        try {
          var Ke = He.detectMirror(!0);
          Ge = Ke.getPoints(), this.reportFoundResultPoints(Qe, Ge), Xe = new Decoder$2().decode(Ke);
        } catch (nt) {
          throw Ue ?? nt;
        }
      var $e = new Result(Xe.getText(), Xe.getRawBytes(), Xe.getNumBits(), Ge, BarcodeFormat$1.AZTEC, System.currentTimeMillis()), Je = Xe.getByteSegments();
      Je != null && $e.putMetadata(ResultMetadataType$1.BYTE_SEGMENTS, Je);
      var Ze = Xe.getECLevel();
      return Ze != null && $e.putMetadata(ResultMetadataType$1.ERROR_CORRECTION_LEVEL, Ze), $e;
    }, me.prototype.reportFoundResultPoints = function(ue, Qe) {
      if (ue != null) {
        var Ue = ue.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK);
        Ue != null && Qe.forEach(function(He, Ge, Xe) {
          Ue.foundPossibleResultPoint(He);
        });
      }
    }, me.prototype.reset = function() {
    }, me;
  }()
), __extends$S = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}();
(function(me) {
  __extends$S(ue, me);
  function ue(Qe) {
    return Qe === void 0 && (Qe = 500), me.call(this, new AztecReader(), Qe) || this;
  }
  return ue;
})(BrowserCodeReader$1);
var OneDReader = (
  /** @class */
  function() {
    function me() {
    }
    return me.prototype.decode = function(ue, Qe) {
      try {
        return this.doDecode(ue, Qe);
      } catch {
        var Ue = Qe && Qe.get(DecodeHintType$1.TRY_HARDER) === !0;
        if (Ue && ue.isRotateSupported()) {
          var He = ue.rotateCounterClockwise(), Ge = this.doDecode(He, Qe), Xe = Ge.getResultMetadata(), Ke = 270;
          Xe !== null && Xe.get(ResultMetadataType$1.ORIENTATION) === !0 && (Ke = Ke + Xe.get(ResultMetadataType$1.ORIENTATION) % 360), Ge.putMetadata(ResultMetadataType$1.ORIENTATION, Ke);
          var $e = Ge.getResultPoints();
          if ($e !== null)
            for (var Je = He.getHeight(), Ze = 0; Ze < $e.length; Ze++)
              $e[Ze] = new ResultPoint(Je - $e[Ze].getY() - 1, $e[Ze].getX());
          return Ge;
        } else
          throw new NotFoundException();
      }
    }, me.prototype.reset = function() {
    }, me.prototype.doDecode = function(ue, Qe) {
      var Ue = ue.getWidth(), He = ue.getHeight(), Ge = new BitArray(Ue), Xe = Qe && Qe.get(DecodeHintType$1.TRY_HARDER) === !0, Ke = Math.max(1, He >> (Xe ? 8 : 5)), $e;
      Xe ? $e = He : $e = 15;
      for (var Je = Math.trunc(He / 2), Ze = 0; Ze < $e; Ze++) {
        var nt = Math.trunc((Ze + 1) / 2), tt = (Ze & 1) === 0, et = Je + Ke * (tt ? nt : -nt);
        if (et < 0 || et >= He)
          break;
        try {
          Ge = ue.getBlackRow(et, Ge);
        } catch {
          continue;
        }
        for (var rt = function(st) {
          if (st === 1 && (Ge.reverse(), Qe && Qe.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK) === !0)) {
            var ut = /* @__PURE__ */ new Map();
            Qe.forEach(function(At, pt) {
              return ut.set(pt, At);
            }), ut.delete(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK), Qe = ut;
          }
          try {
            var lt = it.decodeRow(et, Ge, Qe);
            if (st === 1) {
              lt.putMetadata(ResultMetadataType$1.ORIENTATION, 180);
              var dt = lt.getResultPoints();
              dt !== null && (dt[0] = new ResultPoint(Ue - dt[0].getX() - 1, dt[0].getY()), dt[1] = new ResultPoint(Ue - dt[1].getX() - 1, dt[1].getY()));
            }
            return { value: lt };
          } catch {
          }
        }, it = this, ot = 0; ot < 2; ot++) {
          var at = rt(ot);
          if (typeof at == "object")
            return at.value;
        }
      }
      throw new NotFoundException();
    }, me.recordPattern = function(ue, Qe, Ue) {
      for (var He = Ue.length, Ge = 0; Ge < He; Ge++)
        Ue[Ge] = 0;
      var Xe = ue.getSize();
      if (Qe >= Xe)
        throw new NotFoundException();
      for (var Ke = !ue.get(Qe), $e = 0, Je = Qe; Je < Xe; ) {
        if (ue.get(Je) !== Ke)
          Ue[$e]++;
        else {
          if (++$e === He)
            break;
          Ue[$e] = 1, Ke = !Ke;
        }
        Je++;
      }
      if (!($e === He || $e === He - 1 && Je === Xe))
        throw new NotFoundException();
    }, me.recordPatternInReverse = function(ue, Qe, Ue) {
      for (var He = Ue.length, Ge = ue.get(Qe); Qe > 0 && He >= 0; )
        ue.get(--Qe) !== Ge && (He--, Ge = !Ge);
      if (He >= 0)
        throw new NotFoundException();
      me.recordPattern(ue, Qe + 1, Ue);
    }, me.patternMatchVariance = function(ue, Qe, Ue) {
      for (var He = ue.length, Ge = 0, Xe = 0, Ke = 0; Ke < He; Ke++)
        Ge += ue[Ke], Xe += Qe[Ke];
      if (Ge < Xe)
        return Number.POSITIVE_INFINITY;
      var $e = Ge / Xe;
      Ue *= $e;
      for (var Je = 0, Ze = 0; Ze < He; Ze++) {
        var nt = ue[Ze], tt = Qe[Ze] * $e, et = nt > tt ? nt - tt : tt - nt;
        if (et > Ue)
          return Number.POSITIVE_INFINITY;
        Je += et;
      }
      return Je / Ge;
    }, me;
  }()
), __extends$R = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), Code128Reader = (
  /** @class */
  function(me) {
    __extends$R(ue, me);
    function ue() {
      return me !== null && me.apply(this, arguments) || this;
    }
    return ue.findStartPattern = function(Qe) {
      for (var Ue = Qe.getSize(), He = Qe.getNextSet(0), Ge = 0, Xe = Int32Array.from([0, 0, 0, 0, 0, 0]), Ke = He, $e = !1, Je = 6, Ze = He; Ze < Ue; Ze++)
        if (Qe.get(Ze) !== $e)
          Xe[Ge]++;
        else {
          if (Ge === Je - 1) {
            for (var nt = ue.MAX_AVG_VARIANCE, tt = -1, et = ue.CODE_START_A; et <= ue.CODE_START_C; et++) {
              var rt = OneDReader.patternMatchVariance(Xe, ue.CODE_PATTERNS[et], ue.MAX_INDIVIDUAL_VARIANCE);
              rt < nt && (nt = rt, tt = et);
            }
            if (tt >= 0 && Qe.isRange(Math.max(0, Ke - (Ze - Ke) / 2), Ke, !1))
              return Int32Array.from([Ke, Ze, tt]);
            Ke += Xe[0] + Xe[1], Xe = Xe.slice(2, Xe.length - 1), Xe[Ge - 1] = 0, Xe[Ge] = 0, Ge--;
          } else
            Ge++;
          Xe[Ge] = 1, $e = !$e;
        }
      throw new NotFoundException();
    }, ue.decodeCode = function(Qe, Ue, He) {
      OneDReader.recordPattern(Qe, He, Ue);
      for (var Ge = ue.MAX_AVG_VARIANCE, Xe = -1, Ke = 0; Ke < ue.CODE_PATTERNS.length; Ke++) {
        var $e = ue.CODE_PATTERNS[Ke], Je = this.patternMatchVariance(Ue, $e, ue.MAX_INDIVIDUAL_VARIANCE);
        Je < Ge && (Ge = Je, Xe = Ke);
      }
      if (Xe >= 0)
        return Xe;
      throw new NotFoundException();
    }, ue.prototype.decodeRow = function(Qe, Ue, He) {
      var Ge = He && He.get(DecodeHintType$1.ASSUME_GS1) === !0, Xe = ue.findStartPattern(Ue), Ke = Xe[2], $e = 0, Je = new Uint8Array(20);
      Je[$e++] = Ke;
      var Ze;
      switch (Ke) {
        case ue.CODE_START_A:
          Ze = ue.CODE_CODE_A;
          break;
        case ue.CODE_START_B:
          Ze = ue.CODE_CODE_B;
          break;
        case ue.CODE_START_C:
          Ze = ue.CODE_CODE_C;
          break;
        default:
          throw new FormatException();
      }
      for (var nt = !1, tt = !1, et = "", rt = Xe[0], it = Xe[1], ot = Int32Array.from([0, 0, 0, 0, 0, 0]), at = 0, st = 0, ut = Ke, lt = 0, dt = !0, At = !1, pt = !1; !nt; ) {
        var gt = tt;
        switch (tt = !1, at = st, st = ue.decodeCode(Ue, ot, it), Je[$e++] = st, st !== ue.CODE_STOP && (dt = !0), st !== ue.CODE_STOP && (lt++, ut += lt * st), rt = it, it += ot.reduce(function(Et, bt) {
          return Et + bt;
        }, 0), st) {
          case ue.CODE_START_A:
          case ue.CODE_START_B:
          case ue.CODE_START_C:
            throw new FormatException();
        }
        switch (Ze) {
          case ue.CODE_CODE_A:
            if (st < 64)
              pt === At ? et += String.fromCharCode(32 + st) : et += String.fromCharCode(32 + st + 128), pt = !1;
            else if (st < 96)
              pt === At ? et += String.fromCharCode(st - 64) : et += String.fromCharCode(st + 64), pt = !1;
            else
              switch (st !== ue.CODE_STOP && (dt = !1), st) {
                case ue.CODE_FNC_1:
                  Ge && (et.length === 0 ? et += "]C1" : et += "");
                  break;
                case ue.CODE_FNC_2:
                case ue.CODE_FNC_3:
                  break;
                case ue.CODE_FNC_4_A:
                  !At && pt ? (At = !0, pt = !1) : At && pt ? (At = !1, pt = !1) : pt = !0;
                  break;
                case ue.CODE_SHIFT:
                  tt = !0, Ze = ue.CODE_CODE_B;
                  break;
                case ue.CODE_CODE_B:
                  Ze = ue.CODE_CODE_B;
                  break;
                case ue.CODE_CODE_C:
                  Ze = ue.CODE_CODE_C;
                  break;
                case ue.CODE_STOP:
                  nt = !0;
                  break;
              }
            break;
          case ue.CODE_CODE_B:
            if (st < 96)
              pt === At ? et += String.fromCharCode(32 + st) : et += String.fromCharCode(32 + st + 128), pt = !1;
            else
              switch (st !== ue.CODE_STOP && (dt = !1), st) {
                case ue.CODE_FNC_1:
                  Ge && (et.length === 0 ? et += "]C1" : et += "");
                  break;
                case ue.CODE_FNC_2:
                case ue.CODE_FNC_3:
                  break;
                case ue.CODE_FNC_4_B:
                  !At && pt ? (At = !0, pt = !1) : At && pt ? (At = !1, pt = !1) : pt = !0;
                  break;
                case ue.CODE_SHIFT:
                  tt = !0, Ze = ue.CODE_CODE_A;
                  break;
                case ue.CODE_CODE_A:
                  Ze = ue.CODE_CODE_A;
                  break;
                case ue.CODE_CODE_C:
                  Ze = ue.CODE_CODE_C;
                  break;
                case ue.CODE_STOP:
                  nt = !0;
                  break;
              }
            break;
          case ue.CODE_CODE_C:
            if (st < 100)
              st < 10 && (et += "0"), et += st;
            else
              switch (st !== ue.CODE_STOP && (dt = !1), st) {
                case ue.CODE_FNC_1:
                  Ge && (et.length === 0 ? et += "]C1" : et += "");
                  break;
                case ue.CODE_CODE_A:
                  Ze = ue.CODE_CODE_A;
                  break;
                case ue.CODE_CODE_B:
                  Ze = ue.CODE_CODE_B;
                  break;
                case ue.CODE_STOP:
                  nt = !0;
                  break;
              }
            break;
        }
        gt && (Ze = Ze === ue.CODE_CODE_A ? ue.CODE_CODE_B : ue.CODE_CODE_A);
      }
      var wt = it - rt;
      if (it = Ue.getNextUnset(it), !Ue.isRange(it, Math.min(Ue.getSize(), it + (it - rt) / 2), !1))
        throw new NotFoundException();
      if (ut -= lt * at, ut % 103 !== at)
        throw new ChecksumException();
      var Bt = et.length;
      if (Bt === 0)
        throw new NotFoundException();
      Bt > 0 && dt && (Ze === ue.CODE_CODE_C ? et = et.substring(0, Bt - 2) : et = et.substring(0, Bt - 1));
      for (var Tt = (Xe[1] + Xe[0]) / 2, yt = rt + wt / 2, Ct = Je.length, ht = new Uint8Array(Ct), It = 0; It < Ct; It++)
        ht[It] = Je[It];
      var vt = [new ResultPoint(Tt, Qe), new ResultPoint(yt, Qe)];
      return new Result(et, ht, 0, vt, BarcodeFormat$1.CODE_128, (/* @__PURE__ */ new Date()).getTime());
    }, ue.CODE_PATTERNS = [
      Int32Array.from([2, 1, 2, 2, 2, 2]),
      Int32Array.from([2, 2, 2, 1, 2, 2]),
      Int32Array.from([2, 2, 2, 2, 2, 1]),
      Int32Array.from([1, 2, 1, 2, 2, 3]),
      Int32Array.from([1, 2, 1, 3, 2, 2]),
      Int32Array.from([1, 3, 1, 2, 2, 2]),
      Int32Array.from([1, 2, 2, 2, 1, 3]),
      Int32Array.from([1, 2, 2, 3, 1, 2]),
      Int32Array.from([1, 3, 2, 2, 1, 2]),
      Int32Array.from([2, 2, 1, 2, 1, 3]),
      Int32Array.from([2, 2, 1, 3, 1, 2]),
      Int32Array.from([2, 3, 1, 2, 1, 2]),
      Int32Array.from([1, 1, 2, 2, 3, 2]),
      Int32Array.from([1, 2, 2, 1, 3, 2]),
      Int32Array.from([1, 2, 2, 2, 3, 1]),
      Int32Array.from([1, 1, 3, 2, 2, 2]),
      Int32Array.from([1, 2, 3, 1, 2, 2]),
      Int32Array.from([1, 2, 3, 2, 2, 1]),
      Int32Array.from([2, 2, 3, 2, 1, 1]),
      Int32Array.from([2, 2, 1, 1, 3, 2]),
      Int32Array.from([2, 2, 1, 2, 3, 1]),
      Int32Array.from([2, 1, 3, 2, 1, 2]),
      Int32Array.from([2, 2, 3, 1, 1, 2]),
      Int32Array.from([3, 1, 2, 1, 3, 1]),
      Int32Array.from([3, 1, 1, 2, 2, 2]),
      Int32Array.from([3, 2, 1, 1, 2, 2]),
      Int32Array.from([3, 2, 1, 2, 2, 1]),
      Int32Array.from([3, 1, 2, 2, 1, 2]),
      Int32Array.from([3, 2, 2, 1, 1, 2]),
      Int32Array.from([3, 2, 2, 2, 1, 1]),
      Int32Array.from([2, 1, 2, 1, 2, 3]),
      Int32Array.from([2, 1, 2, 3, 2, 1]),
      Int32Array.from([2, 3, 2, 1, 2, 1]),
      Int32Array.from([1, 1, 1, 3, 2, 3]),
      Int32Array.from([1, 3, 1, 1, 2, 3]),
      Int32Array.from([1, 3, 1, 3, 2, 1]),
      Int32Array.from([1, 1, 2, 3, 1, 3]),
      Int32Array.from([1, 3, 2, 1, 1, 3]),
      Int32Array.from([1, 3, 2, 3, 1, 1]),
      Int32Array.from([2, 1, 1, 3, 1, 3]),
      Int32Array.from([2, 3, 1, 1, 1, 3]),
      Int32Array.from([2, 3, 1, 3, 1, 1]),
      Int32Array.from([1, 1, 2, 1, 3, 3]),
      Int32Array.from([1, 1, 2, 3, 3, 1]),
      Int32Array.from([1, 3, 2, 1, 3, 1]),
      Int32Array.from([1, 1, 3, 1, 2, 3]),
      Int32Array.from([1, 1, 3, 3, 2, 1]),
      Int32Array.from([1, 3, 3, 1, 2, 1]),
      Int32Array.from([3, 1, 3, 1, 2, 1]),
      Int32Array.from([2, 1, 1, 3, 3, 1]),
      Int32Array.from([2, 3, 1, 1, 3, 1]),
      Int32Array.from([2, 1, 3, 1, 1, 3]),
      Int32Array.from([2, 1, 3, 3, 1, 1]),
      Int32Array.from([2, 1, 3, 1, 3, 1]),
      Int32Array.from([3, 1, 1, 1, 2, 3]),
      Int32Array.from([3, 1, 1, 3, 2, 1]),
      Int32Array.from([3, 3, 1, 1, 2, 1]),
      Int32Array.from([3, 1, 2, 1, 1, 3]),
      Int32Array.from([3, 1, 2, 3, 1, 1]),
      Int32Array.from([3, 3, 2, 1, 1, 1]),
      Int32Array.from([3, 1, 4, 1, 1, 1]),
      Int32Array.from([2, 2, 1, 4, 1, 1]),
      Int32Array.from([4, 3, 1, 1, 1, 1]),
      Int32Array.from([1, 1, 1, 2, 2, 4]),
      Int32Array.from([1, 1, 1, 4, 2, 2]),
      Int32Array.from([1, 2, 1, 1, 2, 4]),
      Int32Array.from([1, 2, 1, 4, 2, 1]),
      Int32Array.from([1, 4, 1, 1, 2, 2]),
      Int32Array.from([1, 4, 1, 2, 2, 1]),
      Int32Array.from([1, 1, 2, 2, 1, 4]),
      Int32Array.from([1, 1, 2, 4, 1, 2]),
      Int32Array.from([1, 2, 2, 1, 1, 4]),
      Int32Array.from([1, 2, 2, 4, 1, 1]),
      Int32Array.from([1, 4, 2, 1, 1, 2]),
      Int32Array.from([1, 4, 2, 2, 1, 1]),
      Int32Array.from([2, 4, 1, 2, 1, 1]),
      Int32Array.from([2, 2, 1, 1, 1, 4]),
      Int32Array.from([4, 1, 3, 1, 1, 1]),
      Int32Array.from([2, 4, 1, 1, 1, 2]),
      Int32Array.from([1, 3, 4, 1, 1, 1]),
      Int32Array.from([1, 1, 1, 2, 4, 2]),
      Int32Array.from([1, 2, 1, 1, 4, 2]),
      Int32Array.from([1, 2, 1, 2, 4, 1]),
      Int32Array.from([1, 1, 4, 2, 1, 2]),
      Int32Array.from([1, 2, 4, 1, 1, 2]),
      Int32Array.from([1, 2, 4, 2, 1, 1]),
      Int32Array.from([4, 1, 1, 2, 1, 2]),
      Int32Array.from([4, 2, 1, 1, 1, 2]),
      Int32Array.from([4, 2, 1, 2, 1, 1]),
      Int32Array.from([2, 1, 2, 1, 4, 1]),
      Int32Array.from([2, 1, 4, 1, 2, 1]),
      Int32Array.from([4, 1, 2, 1, 2, 1]),
      Int32Array.from([1, 1, 1, 1, 4, 3]),
      Int32Array.from([1, 1, 1, 3, 4, 1]),
      Int32Array.from([1, 3, 1, 1, 4, 1]),
      Int32Array.from([1, 1, 4, 1, 1, 3]),
      Int32Array.from([1, 1, 4, 3, 1, 1]),
      Int32Array.from([4, 1, 1, 1, 1, 3]),
      Int32Array.from([4, 1, 1, 3, 1, 1]),
      Int32Array.from([1, 1, 3, 1, 4, 1]),
      Int32Array.from([1, 1, 4, 1, 3, 1]),
      Int32Array.from([3, 1, 1, 1, 4, 1]),
      Int32Array.from([4, 1, 1, 1, 3, 1]),
      Int32Array.from([2, 1, 1, 4, 1, 2]),
      Int32Array.from([2, 1, 1, 2, 1, 4]),
      Int32Array.from([2, 1, 1, 2, 3, 2]),
      Int32Array.from([2, 3, 3, 1, 1, 1, 2])
    ], ue.MAX_AVG_VARIANCE = 0.25, ue.MAX_INDIVIDUAL_VARIANCE = 0.7, ue.CODE_SHIFT = 98, ue.CODE_CODE_C = 99, ue.CODE_CODE_B = 100, ue.CODE_CODE_A = 101, ue.CODE_FNC_1 = 102, ue.CODE_FNC_2 = 97, ue.CODE_FNC_3 = 96, ue.CODE_FNC_4_A = 101, ue.CODE_FNC_4_B = 100, ue.CODE_START_A = 103, ue.CODE_START_B = 104, ue.CODE_START_C = 105, ue.CODE_STOP = 106, ue;
  }(OneDReader)
), __extends$Q = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), __values$E = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Code39Reader = (
  /** @class */
  function(me) {
    __extends$Q(ue, me);
    function ue(Qe, Ue) {
      Qe === void 0 && (Qe = !1), Ue === void 0 && (Ue = !1);
      var He = me.call(this) || this;
      return He.usingCheckDigit = Qe, He.extendedMode = Ue, He.decodeRowResult = "", He.counters = new Int32Array(9), He;
    }
    return ue.prototype.decodeRow = function(Qe, Ue, He) {
      var Ge, Xe, Ke, $e, Je = this.counters;
      Je.fill(0), this.decodeRowResult = "";
      var Ze = ue.findAsteriskPattern(Ue, Je), nt = Ue.getNextSet(Ze[1]), tt = Ue.getSize(), et, rt;
      do {
        ue.recordPattern(Ue, nt, Je);
        var it = ue.toNarrowWidePattern(Je);
        if (it < 0)
          throw new NotFoundException();
        et = ue.patternToChar(it), this.decodeRowResult += et, rt = nt;
        try {
          for (var ot = (Ge = void 0, __values$E(Je)), at = ot.next(); !at.done; at = ot.next()) {
            var st = at.value;
            nt += st;
          }
        } catch (Ct) {
          Ge = { error: Ct };
        } finally {
          try {
            at && !at.done && (Xe = ot.return) && Xe.call(ot);
          } finally {
            if (Ge) throw Ge.error;
          }
        }
        nt = Ue.getNextSet(nt);
      } while (et !== "*");
      this.decodeRowResult = this.decodeRowResult.substring(0, this.decodeRowResult.length - 1);
      var ut = 0;
      try {
        for (var lt = __values$E(Je), dt = lt.next(); !dt.done; dt = lt.next()) {
          var st = dt.value;
          ut += st;
        }
      } catch (Ct) {
        Ke = { error: Ct };
      } finally {
        try {
          dt && !dt.done && ($e = lt.return) && $e.call(lt);
        } finally {
          if (Ke) throw Ke.error;
        }
      }
      var At = nt - rt - ut;
      if (nt !== tt && At * 2 < ut)
        throw new NotFoundException();
      if (this.usingCheckDigit) {
        for (var pt = this.decodeRowResult.length - 1, gt = 0, wt = 0; wt < pt; wt++)
          gt += ue.ALPHABET_STRING.indexOf(this.decodeRowResult.charAt(wt));
        if (this.decodeRowResult.charAt(pt) !== ue.ALPHABET_STRING.charAt(gt % 43))
          throw new ChecksumException();
        this.decodeRowResult = this.decodeRowResult.substring(0, pt);
      }
      if (this.decodeRowResult.length === 0)
        throw new NotFoundException();
      var Bt;
      this.extendedMode ? Bt = ue.decodeExtended(this.decodeRowResult) : Bt = this.decodeRowResult;
      var Tt = (Ze[1] + Ze[0]) / 2, yt = rt + ut / 2;
      return new Result(Bt, null, 0, [new ResultPoint(Tt, Qe), new ResultPoint(yt, Qe)], BarcodeFormat$1.CODE_39, (/* @__PURE__ */ new Date()).getTime());
    }, ue.findAsteriskPattern = function(Qe, Ue) {
      for (var He = Qe.getSize(), Ge = Qe.getNextSet(0), Xe = 0, Ke = Ge, $e = !1, Je = Ue.length, Ze = Ge; Ze < He; Ze++)
        if (Qe.get(Ze) !== $e)
          Ue[Xe]++;
        else {
          if (Xe === Je - 1) {
            if (this.toNarrowWidePattern(Ue) === ue.ASTERISK_ENCODING && Qe.isRange(Math.max(0, Ke - Math.floor((Ze - Ke) / 2)), Ke, !1))
              return [Ke, Ze];
            Ke += Ue[0] + Ue[1], Ue.copyWithin(0, 2, 2 + Xe - 1), Ue[Xe - 1] = 0, Ue[Xe] = 0, Xe--;
          } else
            Xe++;
          Ue[Xe] = 1, $e = !$e;
        }
      throw new NotFoundException();
    }, ue.toNarrowWidePattern = function(Qe) {
      var Ue, He, Ge = Qe.length, Xe = 0, Ke;
      do {
        var $e = 2147483647;
        try {
          for (var Je = (Ue = void 0, __values$E(Qe)), Ze = Je.next(); !Ze.done; Ze = Je.next()) {
            var nt = Ze.value;
            nt < $e && nt > Xe && ($e = nt);
          }
        } catch (it) {
          Ue = { error: it };
        } finally {
          try {
            Ze && !Ze.done && (He = Je.return) && He.call(Je);
          } finally {
            if (Ue) throw Ue.error;
          }
        }
        Xe = $e, Ke = 0;
        for (var tt = 0, et = 0, rt = 0; rt < Ge; rt++) {
          var nt = Qe[rt];
          nt > Xe && (et |= 1 << Ge - 1 - rt, Ke++, tt += nt);
        }
        if (Ke === 3) {
          for (var rt = 0; rt < Ge && Ke > 0; rt++) {
            var nt = Qe[rt];
            if (nt > Xe && (Ke--, nt * 2 >= tt))
              return -1;
          }
          return et;
        }
      } while (Ke > 3);
      return -1;
    }, ue.patternToChar = function(Qe) {
      for (var Ue = 0; Ue < ue.CHARACTER_ENCODINGS.length; Ue++)
        if (ue.CHARACTER_ENCODINGS[Ue] === Qe)
          return ue.ALPHABET_STRING.charAt(Ue);
      if (Qe === ue.ASTERISK_ENCODING)
        return "*";
      throw new NotFoundException();
    }, ue.decodeExtended = function(Qe) {
      for (var Ue = Qe.length, He = "", Ge = 0; Ge < Ue; Ge++) {
        var Xe = Qe.charAt(Ge);
        if (Xe === "+" || Xe === "$" || Xe === "%" || Xe === "/") {
          var Ke = Qe.charAt(Ge + 1), $e = "\0";
          switch (Xe) {
            case "+":
              if (Ke >= "A" && Ke <= "Z")
                $e = String.fromCharCode(Ke.charCodeAt(0) + 32);
              else
                throw new FormatException();
              break;
            case "$":
              if (Ke >= "A" && Ke <= "Z")
                $e = String.fromCharCode(Ke.charCodeAt(0) - 64);
              else
                throw new FormatException();
              break;
            case "%":
              if (Ke >= "A" && Ke <= "E")
                $e = String.fromCharCode(Ke.charCodeAt(0) - 38);
              else if (Ke >= "F" && Ke <= "J")
                $e = String.fromCharCode(Ke.charCodeAt(0) - 11);
              else if (Ke >= "K" && Ke <= "O")
                $e = String.fromCharCode(Ke.charCodeAt(0) + 16);
              else if (Ke >= "P" && Ke <= "T")
                $e = String.fromCharCode(Ke.charCodeAt(0) + 43);
              else if (Ke === "U")
                $e = "\0";
              else if (Ke === "V")
                $e = "@";
              else if (Ke === "W")
                $e = "`";
              else if (Ke === "X" || Ke === "Y" || Ke === "Z")
                $e = "";
              else
                throw new FormatException();
              break;
            case "/":
              if (Ke >= "A" && Ke <= "O")
                $e = String.fromCharCode(Ke.charCodeAt(0) - 32);
              else if (Ke === "Z")
                $e = ":";
              else
                throw new FormatException();
              break;
          }
          He += $e, Ge++;
        } else
          He += Xe;
      }
      return He;
    }, ue.ALPHABET_STRING = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%", ue.CHARACTER_ENCODINGS = [
      52,
      289,
      97,
      352,
      49,
      304,
      112,
      37,
      292,
      100,
      265,
      73,
      328,
      25,
      280,
      88,
      13,
      268,
      76,
      28,
      259,
      67,
      322,
      19,
      274,
      82,
      7,
      262,
      70,
      22,
      385,
      193,
      448,
      145,
      400,
      208,
      133,
      388,
      196,
      168,
      162,
      138,
      42
      // /-%
    ], ue.ASTERISK_ENCODING = 148, ue;
  }(OneDReader)
), __extends$P = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), __values$D = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, ITFReader = (
  /** @class */
  function(me) {
    __extends$P(ue, me);
    function ue() {
      var Qe = me !== null && me.apply(this, arguments) || this;
      return Qe.narrowLineWidth = -1, Qe;
    }
    return ue.prototype.decodeRow = function(Qe, Ue, He) {
      var Ge, Xe, Ke = this.decodeStart(Ue), $e = this.decodeEnd(Ue), Je = new StringBuilder();
      ue.decodeMiddle(Ue, Ke[1], $e[0], Je);
      var Ze = Je.toString(), nt = null;
      He != null && (nt = He.get(DecodeHintType$1.ALLOWED_LENGTHS)), nt == null && (nt = ue.DEFAULT_ALLOWED_LENGTHS);
      var tt = Ze.length, et = !1, rt = 0;
      try {
        for (var it = __values$D(nt), ot = it.next(); !ot.done; ot = it.next()) {
          var at = ot.value;
          if (tt === at) {
            et = !0;
            break;
          }
          at > rt && (rt = at);
        }
      } catch (lt) {
        Ge = { error: lt };
      } finally {
        try {
          ot && !ot.done && (Xe = it.return) && Xe.call(it);
        } finally {
          if (Ge) throw Ge.error;
        }
      }
      if (!et && tt > rt && (et = !0), !et)
        throw new FormatException();
      var st = [new ResultPoint(Ke[1], Qe), new ResultPoint($e[0], Qe)], ut = new Result(
        Ze,
        null,
        // no natural byte representation for these barcodes
        0,
        st,
        BarcodeFormat$1.ITF,
        (/* @__PURE__ */ new Date()).getTime()
      );
      return ut;
    }, ue.decodeMiddle = function(Qe, Ue, He, Ge) {
      var Xe = new Int32Array(10), Ke = new Int32Array(5), $e = new Int32Array(5);
      for (Xe.fill(0), Ke.fill(0), $e.fill(0); Ue < He; ) {
        OneDReader.recordPattern(Qe, Ue, Xe);
        for (var Je = 0; Je < 5; Je++) {
          var Ze = 2 * Je;
          Ke[Je] = Xe[Ze], $e[Je] = Xe[Ze + 1];
        }
        var nt = ue.decodeDigit(Ke);
        Ge.append(nt.toString()), nt = this.decodeDigit($e), Ge.append(nt.toString()), Xe.forEach(function(tt) {
          Ue += tt;
        });
      }
    }, ue.prototype.decodeStart = function(Qe) {
      var Ue = ue.skipWhiteSpace(Qe), He = ue.findGuardPattern(Qe, Ue, ue.START_PATTERN);
      return this.narrowLineWidth = (He[1] - He[0]) / 4, this.validateQuietZone(Qe, He[0]), He;
    }, ue.prototype.validateQuietZone = function(Qe, Ue) {
      var He = this.narrowLineWidth * 10;
      He = He < Ue ? He : Ue;
      for (var Ge = Ue - 1; He > 0 && Ge >= 0 && !Qe.get(Ge); Ge--)
        He--;
      if (He !== 0)
        throw new NotFoundException();
    }, ue.skipWhiteSpace = function(Qe) {
      var Ue = Qe.getSize(), He = Qe.getNextSet(0);
      if (He === Ue)
        throw new NotFoundException();
      return He;
    }, ue.prototype.decodeEnd = function(Qe) {
      Qe.reverse();
      try {
        var Ue = ue.skipWhiteSpace(Qe), He = void 0;
        try {
          He = ue.findGuardPattern(Qe, Ue, ue.END_PATTERN_REVERSED[0]);
        } catch (Xe) {
          Xe instanceof NotFoundException && (He = ue.findGuardPattern(Qe, Ue, ue.END_PATTERN_REVERSED[1]));
        }
        this.validateQuietZone(Qe, He[0]);
        var Ge = He[0];
        return He[0] = Qe.getSize() - He[1], He[1] = Qe.getSize() - Ge, He;
      } finally {
        Qe.reverse();
      }
    }, ue.findGuardPattern = function(Qe, Ue, He) {
      var Ge = He.length, Xe = new Int32Array(Ge), Ke = Qe.getSize(), $e = !1, Je = 0, Ze = Ue;
      Xe.fill(0);
      for (var nt = Ue; nt < Ke; nt++)
        if (Qe.get(nt) !== $e)
          Xe[Je]++;
        else {
          if (Je === Ge - 1) {
            if (OneDReader.patternMatchVariance(Xe, He, ue.MAX_INDIVIDUAL_VARIANCE) < ue.MAX_AVG_VARIANCE)
              return [Ze, nt];
            Ze += Xe[0] + Xe[1], System.arraycopy(Xe, 2, Xe, 0, Je - 1), Xe[Je - 1] = 0, Xe[Je] = 0, Je--;
          } else
            Je++;
          Xe[Je] = 1, $e = !$e;
        }
      throw new NotFoundException();
    }, ue.decodeDigit = function(Qe) {
      for (var Ue = ue.MAX_AVG_VARIANCE, He = -1, Ge = ue.PATTERNS.length, Xe = 0; Xe < Ge; Xe++) {
        var Ke = ue.PATTERNS[Xe], $e = OneDReader.patternMatchVariance(Qe, Ke, ue.MAX_INDIVIDUAL_VARIANCE);
        $e < Ue ? (Ue = $e, He = Xe) : $e === Ue && (He = -1);
      }
      if (He >= 0)
        return He % 10;
      throw new NotFoundException();
    }, ue.PATTERNS = [
      Int32Array.from([1, 1, 2, 2, 1]),
      Int32Array.from([2, 1, 1, 1, 2]),
      Int32Array.from([1, 2, 1, 1, 2]),
      Int32Array.from([2, 2, 1, 1, 1]),
      Int32Array.from([1, 1, 2, 1, 2]),
      Int32Array.from([2, 1, 2, 1, 1]),
      Int32Array.from([1, 2, 2, 1, 1]),
      Int32Array.from([1, 1, 1, 2, 2]),
      Int32Array.from([2, 1, 1, 2, 1]),
      Int32Array.from([1, 2, 1, 2, 1]),
      Int32Array.from([1, 1, 3, 3, 1]),
      Int32Array.from([3, 1, 1, 1, 3]),
      Int32Array.from([1, 3, 1, 1, 3]),
      Int32Array.from([3, 3, 1, 1, 1]),
      Int32Array.from([1, 1, 3, 1, 3]),
      Int32Array.from([3, 1, 3, 1, 1]),
      Int32Array.from([1, 3, 3, 1, 1]),
      Int32Array.from([1, 1, 1, 3, 3]),
      Int32Array.from([3, 1, 1, 3, 1]),
      Int32Array.from([1, 3, 1, 3, 1])
      // 9
    ], ue.MAX_AVG_VARIANCE = 0.38, ue.MAX_INDIVIDUAL_VARIANCE = 0.5, ue.DEFAULT_ALLOWED_LENGTHS = [6, 8, 10, 12, 14], ue.START_PATTERN = Int32Array.from([1, 1, 1, 1]), ue.END_PATTERN_REVERSED = [
      Int32Array.from([1, 1, 2]),
      Int32Array.from([1, 1, 3])
      // 3x
    ], ue;
  }(OneDReader)
), __extends$O = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), AbstractUPCEANReader = (
  /** @class */
  function(me) {
    __extends$O(ue, me);
    function ue() {
      var Qe = me !== null && me.apply(this, arguments) || this;
      return Qe.decodeRowStringBuffer = "", Qe;
    }
    return ue.findStartGuardPattern = function(Qe) {
      for (var Ue = !1, He, Ge = 0, Xe = Int32Array.from([0, 0, 0]); !Ue; ) {
        Xe = Int32Array.from([0, 0, 0]), He = ue.findGuardPattern(Qe, Ge, !1, this.START_END_PATTERN, Xe);
        var Ke = He[0];
        Ge = He[1];
        var $e = Ke - (Ge - Ke);
        $e >= 0 && (Ue = Qe.isRange($e, Ke, !1));
      }
      return He;
    }, ue.checkChecksum = function(Qe) {
      return ue.checkStandardUPCEANChecksum(Qe);
    }, ue.checkStandardUPCEANChecksum = function(Qe) {
      var Ue = Qe.length;
      if (Ue === 0)
        return !1;
      var He = parseInt(Qe.charAt(Ue - 1), 10);
      return ue.getStandardUPCEANChecksum(Qe.substring(0, Ue - 1)) === He;
    }, ue.getStandardUPCEANChecksum = function(Qe) {
      for (var Ue = Qe.length, He = 0, Ge = Ue - 1; Ge >= 0; Ge -= 2) {
        var Xe = Qe.charAt(Ge).charCodeAt(0) - 48;
        if (Xe < 0 || Xe > 9)
          throw new FormatException();
        He += Xe;
      }
      He *= 3;
      for (var Ge = Ue - 2; Ge >= 0; Ge -= 2) {
        var Xe = Qe.charAt(Ge).charCodeAt(0) - 48;
        if (Xe < 0 || Xe > 9)
          throw new FormatException();
        He += Xe;
      }
      return (1e3 - He) % 10;
    }, ue.decodeEnd = function(Qe, Ue) {
      return ue.findGuardPattern(Qe, Ue, !1, ue.START_END_PATTERN, new Int32Array(ue.START_END_PATTERN.length).fill(0));
    }, ue.findGuardPatternWithoutCounters = function(Qe, Ue, He, Ge) {
      return this.findGuardPattern(Qe, Ue, He, Ge, new Int32Array(Ge.length));
    }, ue.findGuardPattern = function(Qe, Ue, He, Ge, Xe) {
      var Ke = Qe.getSize();
      Ue = He ? Qe.getNextUnset(Ue) : Qe.getNextSet(Ue);
      for (var $e = 0, Je = Ue, Ze = Ge.length, nt = He, tt = Ue; tt < Ke; tt++)
        if (Qe.get(tt) !== nt)
          Xe[$e]++;
        else {
          if ($e === Ze - 1) {
            if (OneDReader.patternMatchVariance(Xe, Ge, ue.MAX_INDIVIDUAL_VARIANCE) < ue.MAX_AVG_VARIANCE)
              return Int32Array.from([Je, tt]);
            Je += Xe[0] + Xe[1];
            for (var et = Xe.slice(2, Xe.length - 1), rt = 0; rt < $e - 1; rt++)
              Xe[rt] = et[rt];
            Xe[$e - 1] = 0, Xe[$e] = 0, $e--;
          } else
            $e++;
          Xe[$e] = 1, nt = !nt;
        }
      throw new NotFoundException();
    }, ue.decodeDigit = function(Qe, Ue, He, Ge) {
      this.recordPattern(Qe, He, Ue);
      for (var Xe = this.MAX_AVG_VARIANCE, Ke = -1, $e = Ge.length, Je = 0; Je < $e; Je++) {
        var Ze = Ge[Je], nt = OneDReader.patternMatchVariance(Ue, Ze, ue.MAX_INDIVIDUAL_VARIANCE);
        nt < Xe && (Xe = nt, Ke = Je);
      }
      if (Ke >= 0)
        return Ke;
      throw new NotFoundException();
    }, ue.MAX_AVG_VARIANCE = 0.48, ue.MAX_INDIVIDUAL_VARIANCE = 0.7, ue.START_END_PATTERN = Int32Array.from([1, 1, 1]), ue.MIDDLE_PATTERN = Int32Array.from([1, 1, 1, 1, 1]), ue.END_PATTERN = Int32Array.from([1, 1, 1, 1, 1, 1]), ue.L_PATTERNS = [
      Int32Array.from([3, 2, 1, 1]),
      Int32Array.from([2, 2, 2, 1]),
      Int32Array.from([2, 1, 2, 2]),
      Int32Array.from([1, 4, 1, 1]),
      Int32Array.from([1, 1, 3, 2]),
      Int32Array.from([1, 2, 3, 1]),
      Int32Array.from([1, 1, 1, 4]),
      Int32Array.from([1, 3, 1, 2]),
      Int32Array.from([1, 2, 1, 3]),
      Int32Array.from([3, 1, 1, 2])
    ], ue;
  }(OneDReader)
), __values$C = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, UPCEANExtension5Support = (
  /** @class */
  function() {
    function me() {
      this.CHECK_DIGIT_ENCODINGS = [24, 20, 18, 17, 12, 6, 3, 10, 9, 5], this.decodeMiddleCounters = Int32Array.from([0, 0, 0, 0]), this.decodeRowStringBuffer = "";
    }
    return me.prototype.decodeRow = function(ue, Qe, Ue) {
      var He = this.decodeRowStringBuffer, Ge = this.decodeMiddle(Qe, Ue, He), Xe = He.toString(), Ke = me.parseExtensionString(Xe), $e = [
        new ResultPoint((Ue[0] + Ue[1]) / 2, ue),
        new ResultPoint(Ge, ue)
      ], Je = new Result(Xe, null, 0, $e, BarcodeFormat$1.UPC_EAN_EXTENSION, (/* @__PURE__ */ new Date()).getTime());
      return Ke != null && Je.putAllMetadata(Ke), Je;
    }, me.prototype.decodeMiddle = function(ue, Qe, Ue) {
      var He, Ge, Xe = this.decodeMiddleCounters;
      Xe[0] = 0, Xe[1] = 0, Xe[2] = 0, Xe[3] = 0;
      for (var Ke = ue.getSize(), $e = Qe[1], Je = 0, Ze = 0; Ze < 5 && $e < Ke; Ze++) {
        var nt = AbstractUPCEANReader.decodeDigit(ue, Xe, $e, AbstractUPCEANReader.L_AND_G_PATTERNS);
        Ue += String.fromCharCode(48 + nt % 10);
        try {
          for (var tt = (He = void 0, __values$C(Xe)), et = tt.next(); !et.done; et = tt.next()) {
            var rt = et.value;
            $e += rt;
          }
        } catch (ot) {
          He = { error: ot };
        } finally {
          try {
            et && !et.done && (Ge = tt.return) && Ge.call(tt);
          } finally {
            if (He) throw He.error;
          }
        }
        nt >= 10 && (Je |= 1 << 4 - Ze), Ze !== 4 && ($e = ue.getNextSet($e), $e = ue.getNextUnset($e));
      }
      if (Ue.length !== 5)
        throw new NotFoundException();
      var it = this.determineCheckDigit(Je);
      if (me.extensionChecksum(Ue.toString()) !== it)
        throw new NotFoundException();
      return $e;
    }, me.extensionChecksum = function(ue) {
      for (var Qe = ue.length, Ue = 0, He = Qe - 2; He >= 0; He -= 2)
        Ue += ue.charAt(He).charCodeAt(0) - 48;
      Ue *= 3;
      for (var He = Qe - 1; He >= 0; He -= 2)
        Ue += ue.charAt(He).charCodeAt(0) - 48;
      return Ue *= 3, Ue % 10;
    }, me.prototype.determineCheckDigit = function(ue) {
      for (var Qe = 0; Qe < 10; Qe++)
        if (ue === this.CHECK_DIGIT_ENCODINGS[Qe])
          return Qe;
      throw new NotFoundException();
    }, me.parseExtensionString = function(ue) {
      if (ue.length !== 5)
        return null;
      var Qe = me.parseExtension5String(ue);
      return Qe == null ? null : /* @__PURE__ */ new Map([[ResultMetadataType$1.SUGGESTED_PRICE, Qe]]);
    }, me.parseExtension5String = function(ue) {
      var Qe;
      switch (ue.charAt(0)) {
        case "0":
          Qe = "£";
          break;
        case "5":
          Qe = "$";
          break;
        case "9":
          switch (ue) {
            case "90000":
              return null;
            case "99991":
              return "0.00";
            case "99990":
              return "Used";
          }
          Qe = "";
          break;
        default:
          Qe = "";
          break;
      }
      var Ue = parseInt(ue.substring(1)), He = (Ue / 100).toString(), Ge = Ue % 100, Xe = Ge < 10 ? "0" + Ge : Ge.toString();
      return Qe + He + "." + Xe;
    }, me;
  }()
), __values$B = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, UPCEANExtension2Support = (
  /** @class */
  function() {
    function me() {
      this.decodeMiddleCounters = Int32Array.from([0, 0, 0, 0]), this.decodeRowStringBuffer = "";
    }
    return me.prototype.decodeRow = function(ue, Qe, Ue) {
      var He = this.decodeRowStringBuffer, Ge = this.decodeMiddle(Qe, Ue, He), Xe = He.toString(), Ke = me.parseExtensionString(Xe), $e = [
        new ResultPoint((Ue[0] + Ue[1]) / 2, ue),
        new ResultPoint(Ge, ue)
      ], Je = new Result(Xe, null, 0, $e, BarcodeFormat$1.UPC_EAN_EXTENSION, (/* @__PURE__ */ new Date()).getTime());
      return Ke != null && Je.putAllMetadata(Ke), Je;
    }, me.prototype.decodeMiddle = function(ue, Qe, Ue) {
      var He, Ge, Xe = this.decodeMiddleCounters;
      Xe[0] = 0, Xe[1] = 0, Xe[2] = 0, Xe[3] = 0;
      for (var Ke = ue.getSize(), $e = Qe[1], Je = 0, Ze = 0; Ze < 2 && $e < Ke; Ze++) {
        var nt = AbstractUPCEANReader.decodeDigit(ue, Xe, $e, AbstractUPCEANReader.L_AND_G_PATTERNS);
        Ue += String.fromCharCode(48 + nt % 10);
        try {
          for (var tt = (He = void 0, __values$B(Xe)), et = tt.next(); !et.done; et = tt.next()) {
            var rt = et.value;
            $e += rt;
          }
        } catch (it) {
          He = { error: it };
        } finally {
          try {
            et && !et.done && (Ge = tt.return) && Ge.call(tt);
          } finally {
            if (He) throw He.error;
          }
        }
        nt >= 10 && (Je |= 1 << 1 - Ze), Ze !== 1 && ($e = ue.getNextSet($e), $e = ue.getNextUnset($e));
      }
      if (Ue.length !== 2)
        throw new NotFoundException();
      if (parseInt(Ue.toString()) % 4 !== Je)
        throw new NotFoundException();
      return $e;
    }, me.parseExtensionString = function(ue) {
      return ue.length !== 2 ? null : /* @__PURE__ */ new Map([[ResultMetadataType$1.ISSUE_NUMBER, parseInt(ue)]]);
    }, me;
  }()
), UPCEANExtensionSupport = (
  /** @class */
  function() {
    function me() {
    }
    return me.decodeRow = function(ue, Qe, Ue) {
      var He = AbstractUPCEANReader.findGuardPattern(Qe, Ue, !1, this.EXTENSION_START_PATTERN, new Int32Array(this.EXTENSION_START_PATTERN.length).fill(0));
      try {
        var Ge = new UPCEANExtension5Support();
        return Ge.decodeRow(ue, Qe, He);
      } catch {
        var Xe = new UPCEANExtension2Support();
        return Xe.decodeRow(ue, Qe, He);
      }
    }, me.EXTENSION_START_PATTERN = Int32Array.from([1, 1, 2]), me;
  }()
), __extends$N = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), UPCEANReader = (
  /** @class */
  function(me) {
    __extends$N(ue, me);
    function ue() {
      var Qe = me.call(this) || this;
      Qe.decodeRowStringBuffer = "", ue.L_AND_G_PATTERNS = ue.L_PATTERNS.map(function(Ke) {
        return Int32Array.from(Ke);
      });
      for (var Ue = 10; Ue < 20; Ue++) {
        for (var He = ue.L_PATTERNS[Ue - 10], Ge = new Int32Array(He.length), Xe = 0; Xe < He.length; Xe++)
          Ge[Xe] = He[He.length - Xe - 1];
        ue.L_AND_G_PATTERNS[Ue] = Ge;
      }
      return Qe;
    }
    return ue.prototype.decodeRow = function(Qe, Ue, He) {
      var Ge = ue.findStartGuardPattern(Ue), Xe = He == null ? null : He.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK);
      if (Xe != null) {
        var Ke = new ResultPoint((Ge[0] + Ge[1]) / 2, Qe);
        Xe.foundPossibleResultPoint(Ke);
      }
      var $e = this.decodeMiddle(Ue, Ge, this.decodeRowStringBuffer), Je = $e.rowOffset, Ze = $e.resultString;
      if (Xe != null) {
        var nt = new ResultPoint(Je, Qe);
        Xe.foundPossibleResultPoint(nt);
      }
      var tt = ue.decodeEnd(Ue, Je);
      if (Xe != null) {
        var et = new ResultPoint((tt[0] + tt[1]) / 2, Qe);
        Xe.foundPossibleResultPoint(et);
      }
      var rt = tt[1], it = rt + (rt - tt[0]);
      if (it >= Ue.getSize() || !Ue.isRange(rt, it, !1))
        throw new NotFoundException();
      var ot = Ze.toString();
      if (ot.length < 8)
        throw new FormatException();
      if (!ue.checkChecksum(ot))
        throw new ChecksumException();
      var at = (Ge[1] + Ge[0]) / 2, st = (tt[1] + tt[0]) / 2, ut = this.getBarcodeFormat(), lt = [new ResultPoint(at, Qe), new ResultPoint(st, Qe)], dt = new Result(ot, null, 0, lt, ut, (/* @__PURE__ */ new Date()).getTime()), At = 0;
      try {
        var pt = UPCEANExtensionSupport.decodeRow(Qe, Ue, tt[1]);
        dt.putMetadata(ResultMetadataType$1.UPC_EAN_EXTENSION, pt.getText()), dt.putAllMetadata(pt.getResultMetadata()), dt.addResultPoints(pt.getResultPoints()), At = pt.getText().length;
      } catch {
      }
      var gt = He == null ? null : He.get(DecodeHintType$1.ALLOWED_EAN_EXTENSIONS);
      if (gt != null) {
        var wt = !1;
        for (var Bt in gt)
          if (At.toString() === Bt) {
            wt = !0;
            break;
          }
        if (!wt)
          throw new NotFoundException();
      }
      return ut === BarcodeFormat$1.EAN_13 || BarcodeFormat$1.UPC_A, dt;
    }, ue.checkChecksum = function(Qe) {
      return ue.checkStandardUPCEANChecksum(Qe);
    }, ue.checkStandardUPCEANChecksum = function(Qe) {
      var Ue = Qe.length;
      if (Ue === 0)
        return !1;
      var He = parseInt(Qe.charAt(Ue - 1), 10);
      return ue.getStandardUPCEANChecksum(Qe.substring(0, Ue - 1)) === He;
    }, ue.getStandardUPCEANChecksum = function(Qe) {
      for (var Ue = Qe.length, He = 0, Ge = Ue - 1; Ge >= 0; Ge -= 2) {
        var Xe = Qe.charAt(Ge).charCodeAt(0) - 48;
        if (Xe < 0 || Xe > 9)
          throw new FormatException();
        He += Xe;
      }
      He *= 3;
      for (var Ge = Ue - 2; Ge >= 0; Ge -= 2) {
        var Xe = Qe.charAt(Ge).charCodeAt(0) - 48;
        if (Xe < 0 || Xe > 9)
          throw new FormatException();
        He += Xe;
      }
      return (1e3 - He) % 10;
    }, ue.decodeEnd = function(Qe, Ue) {
      return ue.findGuardPattern(Qe, Ue, !1, ue.START_END_PATTERN, new Int32Array(ue.START_END_PATTERN.length).fill(0));
    }, ue;
  }(AbstractUPCEANReader)
), __extends$M = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), __values$A = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, EAN13Reader = (
  /** @class */
  function(me) {
    __extends$M(ue, me);
    function ue() {
      var Qe = me.call(this) || this;
      return Qe.decodeMiddleCounters = Int32Array.from([0, 0, 0, 0]), Qe;
    }
    return ue.prototype.decodeMiddle = function(Qe, Ue, He) {
      var Ge, Xe, Ke, $e, Je = this.decodeMiddleCounters;
      Je[0] = 0, Je[1] = 0, Je[2] = 0, Je[3] = 0;
      for (var Ze = Qe.getSize(), nt = Ue[1], tt = 0, et = 0; et < 6 && nt < Ze; et++) {
        var rt = UPCEANReader.decodeDigit(Qe, Je, nt, UPCEANReader.L_AND_G_PATTERNS);
        He += String.fromCharCode(48 + rt % 10);
        try {
          for (var it = (Ge = void 0, __values$A(Je)), ot = it.next(); !ot.done; ot = it.next()) {
            var at = ot.value;
            nt += at;
          }
        } catch (dt) {
          Ge = { error: dt };
        } finally {
          try {
            ot && !ot.done && (Xe = it.return) && Xe.call(it);
          } finally {
            if (Ge) throw Ge.error;
          }
        }
        rt >= 10 && (tt |= 1 << 5 - et);
      }
      He = ue.determineFirstDigit(He, tt);
      var st = UPCEANReader.findGuardPattern(Qe, nt, !0, UPCEANReader.MIDDLE_PATTERN, new Int32Array(UPCEANReader.MIDDLE_PATTERN.length).fill(0));
      nt = st[1];
      for (var et = 0; et < 6 && nt < Ze; et++) {
        var rt = UPCEANReader.decodeDigit(Qe, Je, nt, UPCEANReader.L_PATTERNS);
        He += String.fromCharCode(48 + rt);
        try {
          for (var ut = (Ke = void 0, __values$A(Je)), lt = ut.next(); !lt.done; lt = ut.next()) {
            var at = lt.value;
            nt += at;
          }
        } catch (pt) {
          Ke = { error: pt };
        } finally {
          try {
            lt && !lt.done && ($e = ut.return) && $e.call(ut);
          } finally {
            if (Ke) throw Ke.error;
          }
        }
      }
      return { rowOffset: nt, resultString: He };
    }, ue.prototype.getBarcodeFormat = function() {
      return BarcodeFormat$1.EAN_13;
    }, ue.determineFirstDigit = function(Qe, Ue) {
      for (var He = 0; He < 10; He++)
        if (Ue === this.FIRST_DIGIT_ENCODINGS[He])
          return Qe = String.fromCharCode(48 + He) + Qe, Qe;
      throw new NotFoundException();
    }, ue.FIRST_DIGIT_ENCODINGS = [0, 11, 13, 14, 19, 25, 28, 21, 22, 26], ue;
  }(UPCEANReader)
), __extends$L = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), __values$z = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, EAN8Reader = (
  /** @class */
  function(me) {
    __extends$L(ue, me);
    function ue() {
      var Qe = me.call(this) || this;
      return Qe.decodeMiddleCounters = Int32Array.from([0, 0, 0, 0]), Qe;
    }
    return ue.prototype.decodeMiddle = function(Qe, Ue, He) {
      var Ge, Xe, Ke, $e, Je = this.decodeMiddleCounters;
      Je[0] = 0, Je[1] = 0, Je[2] = 0, Je[3] = 0;
      for (var Ze = Qe.getSize(), nt = Ue[1], tt = 0; tt < 4 && nt < Ze; tt++) {
        var et = UPCEANReader.decodeDigit(Qe, Je, nt, UPCEANReader.L_PATTERNS);
        He += String.fromCharCode(48 + et);
        try {
          for (var rt = (Ge = void 0, __values$z(Je)), it = rt.next(); !it.done; it = rt.next()) {
            var ot = it.value;
            nt += ot;
          }
        } catch (lt) {
          Ge = { error: lt };
        } finally {
          try {
            it && !it.done && (Xe = rt.return) && Xe.call(rt);
          } finally {
            if (Ge) throw Ge.error;
          }
        }
      }
      var at = UPCEANReader.findGuardPattern(Qe, nt, !0, UPCEANReader.MIDDLE_PATTERN, new Int32Array(UPCEANReader.MIDDLE_PATTERN.length).fill(0));
      nt = at[1];
      for (var tt = 0; tt < 4 && nt < Ze; tt++) {
        var et = UPCEANReader.decodeDigit(Qe, Je, nt, UPCEANReader.L_PATTERNS);
        He += String.fromCharCode(48 + et);
        try {
          for (var st = (Ke = void 0, __values$z(Je)), ut = st.next(); !ut.done; ut = st.next()) {
            var ot = ut.value;
            nt += ot;
          }
        } catch (At) {
          Ke = { error: At };
        } finally {
          try {
            ut && !ut.done && ($e = st.return) && $e.call(st);
          } finally {
            if (Ke) throw Ke.error;
          }
        }
      }
      return { rowOffset: nt, resultString: He };
    }, ue.prototype.getBarcodeFormat = function() {
      return BarcodeFormat$1.EAN_8;
    }, ue;
  }(UPCEANReader)
), __extends$K = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), UPCAReader = (
  /** @class */
  function(me) {
    __extends$K(ue, me);
    function ue() {
      var Qe = me !== null && me.apply(this, arguments) || this;
      return Qe.ean13Reader = new EAN13Reader(), Qe;
    }
    return ue.prototype.getBarcodeFormat = function() {
      return BarcodeFormat$1.UPC_A;
    }, ue.prototype.decode = function(Qe, Ue) {
      return this.maybeReturnResult(this.ean13Reader.decode(Qe));
    }, ue.prototype.decodeRow = function(Qe, Ue, He) {
      return this.maybeReturnResult(this.ean13Reader.decodeRow(Qe, Ue, He));
    }, ue.prototype.decodeMiddle = function(Qe, Ue, He) {
      return this.ean13Reader.decodeMiddle(Qe, Ue, He);
    }, ue.prototype.maybeReturnResult = function(Qe) {
      var Ue = Qe.getText();
      if (Ue.charAt(0) === "0") {
        var He = new Result(Ue.substring(1), null, null, Qe.getResultPoints(), BarcodeFormat$1.UPC_A);
        return Qe.getResultMetadata() != null && He.putAllMetadata(Qe.getResultMetadata()), He;
      } else
        throw new NotFoundException();
    }, ue.prototype.reset = function() {
      this.ean13Reader.reset();
    }, ue;
  }(UPCEANReader)
), __extends$J = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), __values$y = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, UPCEReader = (
  /** @class */
  function(me) {
    __extends$J(ue, me);
    function ue() {
      var Qe = me.call(this) || this;
      return Qe.decodeMiddleCounters = new Int32Array(4), Qe;
    }
    return ue.prototype.decodeMiddle = function(Qe, Ue, He) {
      var Ge, Xe, Ke = this.decodeMiddleCounters.map(function(ot) {
        return ot;
      });
      Ke[0] = 0, Ke[1] = 0, Ke[2] = 0, Ke[3] = 0;
      for (var $e = Qe.getSize(), Je = Ue[1], Ze = 0, nt = 0; nt < 6 && Je < $e; nt++) {
        var tt = ue.decodeDigit(Qe, Ke, Je, ue.L_AND_G_PATTERNS);
        He += String.fromCharCode(48 + tt % 10);
        try {
          for (var et = (Ge = void 0, __values$y(Ke)), rt = et.next(); !rt.done; rt = et.next()) {
            var it = rt.value;
            Je += it;
          }
        } catch (ot) {
          Ge = { error: ot };
        } finally {
          try {
            rt && !rt.done && (Xe = et.return) && Xe.call(et);
          } finally {
            if (Ge) throw Ge.error;
          }
        }
        tt >= 10 && (Ze |= 1 << 5 - nt);
      }
      return ue.determineNumSysAndCheckDigit(new StringBuilder(He), Ze), Je;
    }, ue.prototype.decodeEnd = function(Qe, Ue) {
      return ue.findGuardPatternWithoutCounters(Qe, Ue, !0, ue.MIDDLE_END_PATTERN);
    }, ue.prototype.checkChecksum = function(Qe) {
      return UPCEANReader.checkChecksum(ue.convertUPCEtoUPCA(Qe));
    }, ue.determineNumSysAndCheckDigit = function(Qe, Ue) {
      for (var He = 0; He <= 1; He++)
        for (var Ge = 0; Ge < 10; Ge++)
          if (Ue === this.NUMSYS_AND_CHECK_DIGIT_PATTERNS[He][Ge]) {
            Qe.insert(
              0,
              /*(char)*/
              "0" + He
            ), Qe.append(
              /*(char)*/
              "0" + Ge
            );
            return;
          }
      throw NotFoundException.getNotFoundInstance();
    }, ue.prototype.getBarcodeFormat = function() {
      return BarcodeFormat$1.UPC_E;
    }, ue.convertUPCEtoUPCA = function(Qe) {
      var Ue = Qe.slice(1, 7).split("").map(function(Xe) {
        return Xe.charCodeAt(0);
      }), He = new StringBuilder(
        /*12*/
      );
      He.append(Qe.charAt(0));
      var Ge = Ue[5];
      switch (Ge) {
        case 0:
        case 1:
        case 2:
          He.appendChars(Ue, 0, 2), He.append(Ge), He.append("0000"), He.appendChars(Ue, 2, 3);
          break;
        case 3:
          He.appendChars(Ue, 0, 3), He.append("00000"), He.appendChars(Ue, 3, 2);
          break;
        case 4:
          He.appendChars(Ue, 0, 4), He.append("00000"), He.append(Ue[4]);
          break;
        default:
          He.appendChars(Ue, 0, 5), He.append("0000"), He.append(Ge);
          break;
      }
      return Qe.length >= 8 && He.append(Qe.charAt(7)), He.toString();
    }, ue.MIDDLE_END_PATTERN = Int32Array.from([1, 1, 1, 1, 1, 1]), ue.NUMSYS_AND_CHECK_DIGIT_PATTERNS = [
      Int32Array.from([56, 52, 50, 49, 44, 38, 35, 42, 41, 37]),
      Int32Array.from([7, 11, 13, 14, 19, 25, 28, 21, 22, 1])
    ], ue;
  }(UPCEANReader)
), __extends$I = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), __values$x = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, MultiFormatUPCEANReader = (
  /** @class */
  function(me) {
    __extends$I(ue, me);
    function ue(Qe) {
      var Ue = me.call(this) || this, He = Qe == null ? null : Qe.get(DecodeHintType$1.POSSIBLE_FORMATS), Ge = [];
      return He != null && (He.indexOf(BarcodeFormat$1.EAN_13) > -1 && Ge.push(new EAN13Reader()), He.indexOf(BarcodeFormat$1.UPC_A) > -1 && Ge.push(new UPCAReader()), He.indexOf(BarcodeFormat$1.EAN_8) > -1 && Ge.push(new EAN8Reader()), He.indexOf(BarcodeFormat$1.UPC_E) > -1 && Ge.push(new UPCEReader())), Ge.length === 0 && (Ge.push(new EAN13Reader()), Ge.push(new UPCAReader()), Ge.push(new EAN8Reader()), Ge.push(new UPCEReader())), Ue.readers = Ge, Ue;
    }
    return ue.prototype.decodeRow = function(Qe, Ue, He) {
      var Ge, Xe;
      try {
        for (var Ke = __values$x(this.readers), $e = Ke.next(); !$e.done; $e = Ke.next()) {
          var Je = $e.value;
          try {
            var Ze = Je.decodeRow(Qe, Ue, He), nt = Ze.getBarcodeFormat() === BarcodeFormat$1.EAN_13 && Ze.getText().charAt(0) === "0", tt = He == null ? null : He.get(DecodeHintType$1.POSSIBLE_FORMATS), et = tt == null || tt.includes(BarcodeFormat$1.UPC_A);
            if (nt && et) {
              var rt = Ze.getRawBytes(), it = new Result(Ze.getText().substring(1), rt, rt ? rt.length : null, Ze.getResultPoints(), BarcodeFormat$1.UPC_A);
              return it.putAllMetadata(Ze.getResultMetadata()), it;
            }
            return Ze;
          } catch {
          }
        }
      } catch (ot) {
        Ge = { error: ot };
      } finally {
        try {
          $e && !$e.done && (Xe = Ke.return) && Xe.call(Ke);
        } finally {
          if (Ge) throw Ge.error;
        }
      }
      throw new NotFoundException();
    }, ue.prototype.reset = function() {
      var Qe, Ue;
      try {
        for (var He = __values$x(this.readers), Ge = He.next(); !Ge.done; Ge = He.next()) {
          var Xe = Ge.value;
          Xe.reset();
        }
      } catch (Ke) {
        Qe = { error: Ke };
      } finally {
        try {
          Ge && !Ge.done && (Ue = He.return) && Ue.call(He);
        } finally {
          if (Qe) throw Qe.error;
        }
      }
    }, ue;
  }(OneDReader)
), __extends$H = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), __values$w = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, AbstractRSSReader = (
  /** @class */
  function(me) {
    __extends$H(ue, me);
    function ue() {
      var Qe = me.call(this) || this;
      return Qe.decodeFinderCounters = new Int32Array(4), Qe.dataCharacterCounters = new Int32Array(8), Qe.oddRoundingErrors = new Array(4), Qe.evenRoundingErrors = new Array(4), Qe.oddCounts = new Array(Qe.dataCharacterCounters.length / 2), Qe.evenCounts = new Array(Qe.dataCharacterCounters.length / 2), Qe;
    }
    return ue.prototype.getDecodeFinderCounters = function() {
      return this.decodeFinderCounters;
    }, ue.prototype.getDataCharacterCounters = function() {
      return this.dataCharacterCounters;
    }, ue.prototype.getOddRoundingErrors = function() {
      return this.oddRoundingErrors;
    }, ue.prototype.getEvenRoundingErrors = function() {
      return this.evenRoundingErrors;
    }, ue.prototype.getOddCounts = function() {
      return this.oddCounts;
    }, ue.prototype.getEvenCounts = function() {
      return this.evenCounts;
    }, ue.prototype.parseFinderValue = function(Qe, Ue) {
      for (var He = 0; He < Ue.length; He++)
        if (OneDReader.patternMatchVariance(Qe, Ue[He], ue.MAX_INDIVIDUAL_VARIANCE) < ue.MAX_AVG_VARIANCE)
          return He;
      throw new NotFoundException();
    }, ue.count = function(Qe) {
      return MathUtils.sum(new Int32Array(Qe));
    }, ue.increment = function(Qe, Ue) {
      for (var He = 0, Ge = Ue[0], Xe = 1; Xe < Qe.length; Xe++)
        Ue[Xe] > Ge && (Ge = Ue[Xe], He = Xe);
      Qe[He]++;
    }, ue.decrement = function(Qe, Ue) {
      for (var He = 0, Ge = Ue[0], Xe = 1; Xe < Qe.length; Xe++)
        Ue[Xe] < Ge && (Ge = Ue[Xe], He = Xe);
      Qe[He]--;
    }, ue.isFinderPattern = function(Qe) {
      var Ue, He, Ge = Qe[0] + Qe[1], Xe = Ge + Qe[2] + Qe[3], Ke = Ge / Xe;
      if (Ke >= ue.MIN_FINDER_PATTERN_RATIO && Ke <= ue.MAX_FINDER_PATTERN_RATIO) {
        var $e = Number.MAX_SAFE_INTEGER, Je = Number.MIN_SAFE_INTEGER;
        try {
          for (var Ze = __values$w(Qe), nt = Ze.next(); !nt.done; nt = Ze.next()) {
            var tt = nt.value;
            tt > Je && (Je = tt), tt < $e && ($e = tt);
          }
        } catch (et) {
          Ue = { error: et };
        } finally {
          try {
            nt && !nt.done && (He = Ze.return) && He.call(Ze);
          } finally {
            if (Ue) throw Ue.error;
          }
        }
        return Je < 10 * $e;
      }
      return !1;
    }, ue.MAX_AVG_VARIANCE = 0.2, ue.MAX_INDIVIDUAL_VARIANCE = 0.45, ue.MIN_FINDER_PATTERN_RATIO = 9.5 / 12, ue.MAX_FINDER_PATTERN_RATIO = 12.5 / 14, ue;
  }(OneDReader)
), DataCharacter = (
  /** @class */
  function() {
    function me(ue, Qe) {
      this.value = ue, this.checksumPortion = Qe;
    }
    return me.prototype.getValue = function() {
      return this.value;
    }, me.prototype.getChecksumPortion = function() {
      return this.checksumPortion;
    }, me.prototype.toString = function() {
      return this.value + "(" + this.checksumPortion + ")";
    }, me.prototype.equals = function(ue) {
      if (!(ue instanceof me))
        return !1;
      var Qe = ue;
      return this.value === Qe.value && this.checksumPortion === Qe.checksumPortion;
    }, me.prototype.hashCode = function() {
      return this.value ^ this.checksumPortion;
    }, me;
  }()
), FinderPattern$1 = (
  /** @class */
  function() {
    function me(ue, Qe, Ue, He, Ge) {
      this.value = ue, this.startEnd = Qe, this.value = ue, this.startEnd = Qe, this.resultPoints = new Array(), this.resultPoints.push(new ResultPoint(Ue, Ge)), this.resultPoints.push(new ResultPoint(He, Ge));
    }
    return me.prototype.getValue = function() {
      return this.value;
    }, me.prototype.getStartEnd = function() {
      return this.startEnd;
    }, me.prototype.getResultPoints = function() {
      return this.resultPoints;
    }, me.prototype.equals = function(ue) {
      if (!(ue instanceof me))
        return !1;
      var Qe = ue;
      return this.value === Qe.value;
    }, me.prototype.hashCode = function() {
      return this.value;
    }, me;
  }()
), __values$v = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, RSSUtils = (
  /** @class */
  function() {
    function me() {
    }
    return me.getRSSvalue = function(ue, Qe, Ue) {
      var He, Ge, Xe = 0;
      try {
        for (var Ke = __values$v(ue), $e = Ke.next(); !$e.done; $e = Ke.next()) {
          var Je = $e.value;
          Xe += Je;
        }
      } catch (st) {
        He = { error: st };
      } finally {
        try {
          $e && !$e.done && (Ge = Ke.return) && Ge.call(Ke);
        } finally {
          if (He) throw He.error;
        }
      }
      for (var Ze = 0, nt = 0, tt = ue.length, et = 0; et < tt - 1; et++) {
        var rt = void 0;
        for (rt = 1, nt |= 1 << et; rt < ue[et]; rt++, nt &= ~(1 << et)) {
          var it = me.combins(Xe - rt - 1, tt - et - 2);
          if (Ue && nt === 0 && Xe - rt - (tt - et - 1) >= tt - et - 1 && (it -= me.combins(Xe - rt - (tt - et), tt - et - 2)), tt - et - 1 > 1) {
            for (var ot = 0, at = Xe - rt - (tt - et - 2); at > Qe; at--)
              ot += me.combins(Xe - rt - at - 1, tt - et - 3);
            it -= ot * (tt - 1 - et);
          } else Xe - rt > Qe && it--;
          Ze += it;
        }
        Xe -= rt;
      }
      return Ze;
    }, me.combins = function(ue, Qe) {
      var Ue, He;
      ue - Qe > Qe ? (He = Qe, Ue = ue - Qe) : (He = ue - Qe, Ue = Qe);
      for (var Ge = 1, Xe = 1, Ke = ue; Ke > Ue; Ke--)
        Ge *= Ke, Xe <= He && (Ge /= Xe, Xe++);
      for (; Xe <= He; )
        Ge /= Xe, Xe++;
      return Ge;
    }, me;
  }()
), BitArrayBuilder = (
  /** @class */
  function() {
    function me() {
    }
    return me.buildBitArray = function(ue) {
      var Qe = ue.length * 2 - 1;
      ue[ue.length - 1].getRightChar() == null && (Qe -= 1);
      for (var Ue = 12 * Qe, He = new BitArray(Ue), Ge = 0, Xe = ue[0], Ke = Xe.getRightChar().getValue(), $e = 11; $e >= 0; --$e)
        Ke & 1 << $e && He.set(Ge), Ge++;
      for (var $e = 1; $e < ue.length; ++$e) {
        for (var Je = ue[$e], Ze = Je.getLeftChar().getValue(), nt = 11; nt >= 0; --nt)
          Ze & 1 << nt && He.set(Ge), Ge++;
        if (Je.getRightChar() != null)
          for (var tt = Je.getRightChar().getValue(), nt = 11; nt >= 0; --nt)
            tt & 1 << nt && He.set(Ge), Ge++;
      }
      return He;
    }, me;
  }()
), BlockParsedResult = (
  /** @class */
  function() {
    function me(ue, Qe) {
      Qe ? this.decodedInformation = null : (this.finished = ue, this.decodedInformation = Qe);
    }
    return me.prototype.getDecodedInformation = function() {
      return this.decodedInformation;
    }, me.prototype.isFinished = function() {
      return this.finished;
    }, me;
  }()
), DecodedObject = (
  /** @class */
  function() {
    function me(ue) {
      this.newPosition = ue;
    }
    return me.prototype.getNewPosition = function() {
      return this.newPosition;
    }, me;
  }()
), __extends$G = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), DecodedChar = (
  /** @class */
  function(me) {
    __extends$G(ue, me);
    function ue(Qe, Ue) {
      var He = me.call(this, Qe) || this;
      return He.value = Ue, He;
    }
    return ue.prototype.getValue = function() {
      return this.value;
    }, ue.prototype.isFNC1 = function() {
      return this.value === ue.FNC1;
    }, ue.FNC1 = "$", ue;
  }(DecodedObject)
), __extends$F = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), DecodedInformation = (
  /** @class */
  function(me) {
    __extends$F(ue, me);
    function ue(Qe, Ue, He) {
      var Ge = me.call(this, Qe) || this;
      return He ? (Ge.remaining = !0, Ge.remainingValue = Ge.remainingValue) : (Ge.remaining = !1, Ge.remainingValue = 0), Ge.newString = Ue, Ge;
    }
    return ue.prototype.getNewString = function() {
      return this.newString;
    }, ue.prototype.isRemaining = function() {
      return this.remaining;
    }, ue.prototype.getRemainingValue = function() {
      return this.remainingValue;
    }, ue;
  }(DecodedObject)
), __extends$E = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), DecodedNumeric = (
  /** @class */
  function(me) {
    __extends$E(ue, me);
    function ue(Qe, Ue, He) {
      var Ge = me.call(this, Qe) || this;
      if (Ue < 0 || Ue > 10 || He < 0 || He > 10)
        throw new FormatException();
      return Ge.firstDigit = Ue, Ge.secondDigit = He, Ge;
    }
    return ue.prototype.getFirstDigit = function() {
      return this.firstDigit;
    }, ue.prototype.getSecondDigit = function() {
      return this.secondDigit;
    }, ue.prototype.getValue = function() {
      return this.firstDigit * 10 + this.secondDigit;
    }, ue.prototype.isFirstDigitFNC1 = function() {
      return this.firstDigit === ue.FNC1;
    }, ue.prototype.isSecondDigitFNC1 = function() {
      return this.secondDigit === ue.FNC1;
    }, ue.prototype.isAnyFNC1 = function() {
      return this.firstDigit === ue.FNC1 || this.secondDigit === ue.FNC1;
    }, ue.FNC1 = 10, ue;
  }(DecodedObject)
), __values$u = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, FieldParser = (
  /** @class */
  function() {
    function me() {
    }
    return me.parseFieldsInGeneralPurpose = function(ue) {
      var Qe, Ue, He, Ge, Xe, Ke, $e, Je;
      if (!ue)
        return null;
      if (ue.length < 2)
        throw new NotFoundException();
      var Ze = ue.substring(0, 2);
      try {
        for (var nt = __values$u(me.TWO_DIGIT_DATA_LENGTH), tt = nt.next(); !tt.done; tt = nt.next()) {
          var et = tt.value;
          if (et[0] === Ze)
            return et[1] === me.VARIABLE_LENGTH ? me.processVariableAI(2, et[2], ue) : me.processFixedAI(2, et[1], ue);
        }
      } catch (At) {
        Qe = { error: At };
      } finally {
        try {
          tt && !tt.done && (Ue = nt.return) && Ue.call(nt);
        } finally {
          if (Qe) throw Qe.error;
        }
      }
      if (ue.length < 3)
        throw new NotFoundException();
      var rt = ue.substring(0, 3);
      try {
        for (var it = __values$u(me.THREE_DIGIT_DATA_LENGTH), ot = it.next(); !ot.done; ot = it.next()) {
          var et = ot.value;
          if (et[0] === rt)
            return et[1] === me.VARIABLE_LENGTH ? me.processVariableAI(3, et[2], ue) : me.processFixedAI(3, et[1], ue);
        }
      } catch (At) {
        He = { error: At };
      } finally {
        try {
          ot && !ot.done && (Ge = it.return) && Ge.call(it);
        } finally {
          if (He) throw He.error;
        }
      }
      try {
        for (var at = __values$u(me.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH), st = at.next(); !st.done; st = at.next()) {
          var et = st.value;
          if (et[0] === rt)
            return et[1] === me.VARIABLE_LENGTH ? me.processVariableAI(4, et[2], ue) : me.processFixedAI(4, et[1], ue);
        }
      } catch (At) {
        Xe = { error: At };
      } finally {
        try {
          st && !st.done && (Ke = at.return) && Ke.call(at);
        } finally {
          if (Xe) throw Xe.error;
        }
      }
      if (ue.length < 4)
        throw new NotFoundException();
      var ut = ue.substring(0, 4);
      try {
        for (var lt = __values$u(me.FOUR_DIGIT_DATA_LENGTH), dt = lt.next(); !dt.done; dt = lt.next()) {
          var et = dt.value;
          if (et[0] === ut)
            return et[1] === me.VARIABLE_LENGTH ? me.processVariableAI(4, et[2], ue) : me.processFixedAI(4, et[1], ue);
        }
      } catch (At) {
        $e = { error: At };
      } finally {
        try {
          dt && !dt.done && (Je = lt.return) && Je.call(lt);
        } finally {
          if ($e) throw $e.error;
        }
      }
      throw new NotFoundException();
    }, me.processFixedAI = function(ue, Qe, Ue) {
      if (Ue.length < ue)
        throw new NotFoundException();
      var He = Ue.substring(0, ue);
      if (Ue.length < ue + Qe)
        throw new NotFoundException();
      var Ge = Ue.substring(ue, ue + Qe), Xe = Ue.substring(ue + Qe), Ke = "(" + He + ")" + Ge, $e = me.parseFieldsInGeneralPurpose(Xe);
      return $e == null ? Ke : Ke + $e;
    }, me.processVariableAI = function(ue, Qe, Ue) {
      var He = Ue.substring(0, ue), Ge;
      Ue.length < ue + Qe ? Ge = Ue.length : Ge = ue + Qe;
      var Xe = Ue.substring(ue, Ge), Ke = Ue.substring(Ge), $e = "(" + He + ")" + Xe, Je = me.parseFieldsInGeneralPurpose(Ke);
      return Je == null ? $e : $e + Je;
    }, me.VARIABLE_LENGTH = [], me.TWO_DIGIT_DATA_LENGTH = [
      ["00", 18],
      ["01", 14],
      ["02", 14],
      ["10", me.VARIABLE_LENGTH, 20],
      ["11", 6],
      ["12", 6],
      ["13", 6],
      ["15", 6],
      ["17", 6],
      ["20", 2],
      ["21", me.VARIABLE_LENGTH, 20],
      ["22", me.VARIABLE_LENGTH, 29],
      ["30", me.VARIABLE_LENGTH, 8],
      ["37", me.VARIABLE_LENGTH, 8],
      // internal company codes
      ["90", me.VARIABLE_LENGTH, 30],
      ["91", me.VARIABLE_LENGTH, 30],
      ["92", me.VARIABLE_LENGTH, 30],
      ["93", me.VARIABLE_LENGTH, 30],
      ["94", me.VARIABLE_LENGTH, 30],
      ["95", me.VARIABLE_LENGTH, 30],
      ["96", me.VARIABLE_LENGTH, 30],
      ["97", me.VARIABLE_LENGTH, 3],
      ["98", me.VARIABLE_LENGTH, 30],
      ["99", me.VARIABLE_LENGTH, 30]
    ], me.THREE_DIGIT_DATA_LENGTH = [
      // Same format as above
      ["240", me.VARIABLE_LENGTH, 30],
      ["241", me.VARIABLE_LENGTH, 30],
      ["242", me.VARIABLE_LENGTH, 6],
      ["250", me.VARIABLE_LENGTH, 30],
      ["251", me.VARIABLE_LENGTH, 30],
      ["253", me.VARIABLE_LENGTH, 17],
      ["254", me.VARIABLE_LENGTH, 20],
      ["400", me.VARIABLE_LENGTH, 30],
      ["401", me.VARIABLE_LENGTH, 30],
      ["402", 17],
      ["403", me.VARIABLE_LENGTH, 30],
      ["410", 13],
      ["411", 13],
      ["412", 13],
      ["413", 13],
      ["414", 13],
      ["420", me.VARIABLE_LENGTH, 20],
      ["421", me.VARIABLE_LENGTH, 15],
      ["422", 3],
      ["423", me.VARIABLE_LENGTH, 15],
      ["424", 3],
      ["425", 3],
      ["426", 3]
    ], me.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH = [
      // Same format as above
      ["310", 6],
      ["311", 6],
      ["312", 6],
      ["313", 6],
      ["314", 6],
      ["315", 6],
      ["316", 6],
      ["320", 6],
      ["321", 6],
      ["322", 6],
      ["323", 6],
      ["324", 6],
      ["325", 6],
      ["326", 6],
      ["327", 6],
      ["328", 6],
      ["329", 6],
      ["330", 6],
      ["331", 6],
      ["332", 6],
      ["333", 6],
      ["334", 6],
      ["335", 6],
      ["336", 6],
      ["340", 6],
      ["341", 6],
      ["342", 6],
      ["343", 6],
      ["344", 6],
      ["345", 6],
      ["346", 6],
      ["347", 6],
      ["348", 6],
      ["349", 6],
      ["350", 6],
      ["351", 6],
      ["352", 6],
      ["353", 6],
      ["354", 6],
      ["355", 6],
      ["356", 6],
      ["357", 6],
      ["360", 6],
      ["361", 6],
      ["362", 6],
      ["363", 6],
      ["364", 6],
      ["365", 6],
      ["366", 6],
      ["367", 6],
      ["368", 6],
      ["369", 6],
      ["390", me.VARIABLE_LENGTH, 15],
      ["391", me.VARIABLE_LENGTH, 18],
      ["392", me.VARIABLE_LENGTH, 15],
      ["393", me.VARIABLE_LENGTH, 18],
      ["703", me.VARIABLE_LENGTH, 30]
    ], me.FOUR_DIGIT_DATA_LENGTH = [
      // Same format as above
      ["7001", 13],
      ["7002", me.VARIABLE_LENGTH, 30],
      ["7003", 10],
      ["8001", 14],
      ["8002", me.VARIABLE_LENGTH, 20],
      ["8003", me.VARIABLE_LENGTH, 30],
      ["8004", me.VARIABLE_LENGTH, 30],
      ["8005", 6],
      ["8006", 18],
      ["8007", me.VARIABLE_LENGTH, 30],
      ["8008", me.VARIABLE_LENGTH, 12],
      ["8018", 18],
      ["8020", me.VARIABLE_LENGTH, 25],
      ["8100", 6],
      ["8101", 10],
      ["8102", 2],
      ["8110", me.VARIABLE_LENGTH, 70],
      ["8200", me.VARIABLE_LENGTH, 70]
    ], me;
  }()
), GeneralAppIdDecoder = (
  /** @class */
  function() {
    function me(ue) {
      this.buffer = new StringBuilder(), this.information = ue;
    }
    return me.prototype.decodeAllCodes = function(ue, Qe) {
      var Ue = Qe, He = null;
      do {
        var Ge = this.decodeGeneralPurposeField(Ue, He), Xe = FieldParser.parseFieldsInGeneralPurpose(Ge.getNewString());
        if (Xe != null && ue.append(Xe), Ge.isRemaining() ? He = "" + Ge.getRemainingValue() : He = null, Ue === Ge.getNewPosition())
          break;
        Ue = Ge.getNewPosition();
      } while (!0);
      return ue.toString();
    }, me.prototype.isStillNumeric = function(ue) {
      if (ue + 7 > this.information.getSize())
        return ue + 4 <= this.information.getSize();
      for (var Qe = ue; Qe < ue + 3; ++Qe)
        if (this.information.get(Qe))
          return !0;
      return this.information.get(ue + 3);
    }, me.prototype.decodeNumeric = function(ue) {
      if (ue + 7 > this.information.getSize()) {
        var Qe = this.extractNumericValueFromBitArray(ue, 4);
        return Qe === 0 ? new DecodedNumeric(this.information.getSize(), DecodedNumeric.FNC1, DecodedNumeric.FNC1) : new DecodedNumeric(this.information.getSize(), Qe - 1, DecodedNumeric.FNC1);
      }
      var Ue = this.extractNumericValueFromBitArray(ue, 7), He = (Ue - 8) / 11, Ge = (Ue - 8) % 11;
      return new DecodedNumeric(ue + 7, He, Ge);
    }, me.prototype.extractNumericValueFromBitArray = function(ue, Qe) {
      return me.extractNumericValueFromBitArray(this.information, ue, Qe);
    }, me.extractNumericValueFromBitArray = function(ue, Qe, Ue) {
      for (var He = 0, Ge = 0; Ge < Ue; ++Ge)
        ue.get(Qe + Ge) && (He |= 1 << Ue - Ge - 1);
      return He;
    }, me.prototype.decodeGeneralPurposeField = function(ue, Qe) {
      this.buffer.setLengthToZero(), Qe != null && this.buffer.append(Qe), this.current.setPosition(ue);
      var Ue = this.parseBlocks();
      return Ue != null && Ue.isRemaining() ? new DecodedInformation(this.current.getPosition(), this.buffer.toString(), Ue.getRemainingValue()) : new DecodedInformation(this.current.getPosition(), this.buffer.toString());
    }, me.prototype.parseBlocks = function() {
      var ue, Qe;
      do {
        var Ue = this.current.getPosition();
        this.current.isAlpha() ? (Qe = this.parseAlphaBlock(), ue = Qe.isFinished()) : this.current.isIsoIec646() ? (Qe = this.parseIsoIec646Block(), ue = Qe.isFinished()) : (Qe = this.parseNumericBlock(), ue = Qe.isFinished());
        var He = Ue !== this.current.getPosition();
        if (!He && !ue)
          break;
      } while (!ue);
      return Qe.getDecodedInformation();
    }, me.prototype.parseNumericBlock = function() {
      for (; this.isStillNumeric(this.current.getPosition()); ) {
        var ue = this.decodeNumeric(this.current.getPosition());
        if (this.current.setPosition(ue.getNewPosition()), ue.isFirstDigitFNC1()) {
          var Qe = void 0;
          return ue.isSecondDigitFNC1() ? Qe = new DecodedInformation(this.current.getPosition(), this.buffer.toString()) : Qe = new DecodedInformation(this.current.getPosition(), this.buffer.toString(), ue.getSecondDigit()), new BlockParsedResult(!0, Qe);
        }
        if (this.buffer.append(ue.getFirstDigit()), ue.isSecondDigitFNC1()) {
          var Qe = new DecodedInformation(this.current.getPosition(), this.buffer.toString());
          return new BlockParsedResult(!0, Qe);
        }
        this.buffer.append(ue.getSecondDigit());
      }
      return this.isNumericToAlphaNumericLatch(this.current.getPosition()) && (this.current.setAlpha(), this.current.incrementPosition(4)), new BlockParsedResult(!1);
    }, me.prototype.parseIsoIec646Block = function() {
      for (; this.isStillIsoIec646(this.current.getPosition()); ) {
        var ue = this.decodeIsoIec646(this.current.getPosition());
        if (this.current.setPosition(ue.getNewPosition()), ue.isFNC1()) {
          var Qe = new DecodedInformation(this.current.getPosition(), this.buffer.toString());
          return new BlockParsedResult(!0, Qe);
        }
        this.buffer.append(ue.getValue());
      }
      return this.isAlphaOr646ToNumericLatch(this.current.getPosition()) ? (this.current.incrementPosition(3), this.current.setNumeric()) : this.isAlphaTo646ToAlphaLatch(this.current.getPosition()) && (this.current.getPosition() + 5 < this.information.getSize() ? this.current.incrementPosition(5) : this.current.setPosition(this.information.getSize()), this.current.setAlpha()), new BlockParsedResult(!1);
    }, me.prototype.parseAlphaBlock = function() {
      for (; this.isStillAlpha(this.current.getPosition()); ) {
        var ue = this.decodeAlphanumeric(this.current.getPosition());
        if (this.current.setPosition(ue.getNewPosition()), ue.isFNC1()) {
          var Qe = new DecodedInformation(this.current.getPosition(), this.buffer.toString());
          return new BlockParsedResult(!0, Qe);
        }
        this.buffer.append(ue.getValue());
      }
      return this.isAlphaOr646ToNumericLatch(this.current.getPosition()) ? (this.current.incrementPosition(3), this.current.setNumeric()) : this.isAlphaTo646ToAlphaLatch(this.current.getPosition()) && (this.current.getPosition() + 5 < this.information.getSize() ? this.current.incrementPosition(5) : this.current.setPosition(this.information.getSize()), this.current.setIsoIec646()), new BlockParsedResult(!1);
    }, me.prototype.isStillIsoIec646 = function(ue) {
      if (ue + 5 > this.information.getSize())
        return !1;
      var Qe = this.extractNumericValueFromBitArray(ue, 5);
      if (Qe >= 5 && Qe < 16)
        return !0;
      if (ue + 7 > this.information.getSize())
        return !1;
      var Ue = this.extractNumericValueFromBitArray(ue, 7);
      if (Ue >= 64 && Ue < 116)
        return !0;
      if (ue + 8 > this.information.getSize())
        return !1;
      var He = this.extractNumericValueFromBitArray(ue, 8);
      return He >= 232 && He < 253;
    }, me.prototype.decodeIsoIec646 = function(ue) {
      var Qe = this.extractNumericValueFromBitArray(ue, 5);
      if (Qe === 15)
        return new DecodedChar(ue + 5, DecodedChar.FNC1);
      if (Qe >= 5 && Qe < 15)
        return new DecodedChar(ue + 5, "0" + (Qe - 5));
      var Ue = this.extractNumericValueFromBitArray(ue, 7);
      if (Ue >= 64 && Ue < 90)
        return new DecodedChar(ue + 7, "" + (Ue + 1));
      if (Ue >= 90 && Ue < 116)
        return new DecodedChar(ue + 7, "" + (Ue + 7));
      var He = this.extractNumericValueFromBitArray(ue, 8), Ge;
      switch (He) {
        case 232:
          Ge = "!";
          break;
        case 233:
          Ge = '"';
          break;
        case 234:
          Ge = "%";
          break;
        case 235:
          Ge = "&";
          break;
        case 236:
          Ge = "'";
          break;
        case 237:
          Ge = "(";
          break;
        case 238:
          Ge = ")";
          break;
        case 239:
          Ge = "*";
          break;
        case 240:
          Ge = "+";
          break;
        case 241:
          Ge = ",";
          break;
        case 242:
          Ge = "-";
          break;
        case 243:
          Ge = ".";
          break;
        case 244:
          Ge = "/";
          break;
        case 245:
          Ge = ":";
          break;
        case 246:
          Ge = ";";
          break;
        case 247:
          Ge = "<";
          break;
        case 248:
          Ge = "=";
          break;
        case 249:
          Ge = ">";
          break;
        case 250:
          Ge = "?";
          break;
        case 251:
          Ge = "_";
          break;
        case 252:
          Ge = " ";
          break;
        default:
          throw new FormatException();
      }
      return new DecodedChar(ue + 8, Ge);
    }, me.prototype.isStillAlpha = function(ue) {
      if (ue + 5 > this.information.getSize())
        return !1;
      var Qe = this.extractNumericValueFromBitArray(ue, 5);
      if (Qe >= 5 && Qe < 16)
        return !0;
      if (ue + 6 > this.information.getSize())
        return !1;
      var Ue = this.extractNumericValueFromBitArray(ue, 6);
      return Ue >= 16 && Ue < 63;
    }, me.prototype.decodeAlphanumeric = function(ue) {
      var Qe = this.extractNumericValueFromBitArray(ue, 5);
      if (Qe === 15)
        return new DecodedChar(ue + 5, DecodedChar.FNC1);
      if (Qe >= 5 && Qe < 15)
        return new DecodedChar(ue + 5, "0" + (Qe - 5));
      var Ue = this.extractNumericValueFromBitArray(ue, 6);
      if (Ue >= 32 && Ue < 58)
        return new DecodedChar(ue + 6, "" + (Ue + 33));
      var He;
      switch (Ue) {
        case 58:
          He = "*";
          break;
        case 59:
          He = ",";
          break;
        case 60:
          He = "-";
          break;
        case 61:
          He = ".";
          break;
        case 62:
          He = "/";
          break;
        default:
          throw new IllegalStateException("Decoding invalid alphanumeric value: " + Ue);
      }
      return new DecodedChar(ue + 6, He);
    }, me.prototype.isAlphaTo646ToAlphaLatch = function(ue) {
      if (ue + 1 > this.information.getSize())
        return !1;
      for (var Qe = 0; Qe < 5 && Qe + ue < this.information.getSize(); ++Qe)
        if (Qe === 2) {
          if (!this.information.get(ue + 2))
            return !1;
        } else if (this.information.get(ue + Qe))
          return !1;
      return !0;
    }, me.prototype.isAlphaOr646ToNumericLatch = function(ue) {
      if (ue + 3 > this.information.getSize())
        return !1;
      for (var Qe = ue; Qe < ue + 3; ++Qe)
        if (this.information.get(Qe))
          return !1;
      return !0;
    }, me.prototype.isNumericToAlphaNumericLatch = function(ue) {
      if (ue + 1 > this.information.getSize())
        return !1;
      for (var Qe = 0; Qe < 4 && Qe + ue < this.information.getSize(); ++Qe)
        if (this.information.get(ue + Qe))
          return !1;
      return !0;
    }, me;
  }()
), AbstractExpandedDecoder = (
  /** @class */
  function() {
    function me(ue) {
      this.information = ue, this.generalDecoder = new GeneralAppIdDecoder(ue);
    }
    return me.prototype.getInformation = function() {
      return this.information;
    }, me.prototype.getGeneralDecoder = function() {
      return this.generalDecoder;
    }, me;
  }()
), __extends$D = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), AI01decoder = (
  /** @class */
  function(me) {
    __extends$D(ue, me);
    function ue(Qe) {
      return me.call(this, Qe) || this;
    }
    return ue.prototype.encodeCompressedGtin = function(Qe, Ue) {
      Qe.append("(01)");
      var He = Qe.length();
      Qe.append("9"), this.encodeCompressedGtinWithoutAI(Qe, Ue, He);
    }, ue.prototype.encodeCompressedGtinWithoutAI = function(Qe, Ue, He) {
      for (var Ge = 0; Ge < 4; ++Ge) {
        var Xe = this.getGeneralDecoder().extractNumericValueFromBitArray(Ue + 10 * Ge, 10);
        Xe / 100 === 0 && Qe.append("0"), Xe / 10 === 0 && Qe.append("0"), Qe.append(Xe);
      }
      ue.appendCheckDigit(Qe, He);
    }, ue.appendCheckDigit = function(Qe, Ue) {
      for (var He = 0, Ge = 0; Ge < 13; Ge++) {
        var Xe = Qe.charAt(Ge + Ue).charCodeAt(0) - 48;
        He += Ge & 1 ? Xe : 3 * Xe;
      }
      He = 10 - He % 10, He === 10 && (He = 0), Qe.append(He);
    }, ue.GTIN_SIZE = 40, ue;
  }(AbstractExpandedDecoder)
), __extends$C = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), AI01AndOtherAIs = (
  /** @class */
  function(me) {
    __extends$C(ue, me);
    function ue(Qe) {
      return me.call(this, Qe) || this;
    }
    return ue.prototype.parseInformation = function() {
      var Qe = new StringBuilder();
      Qe.append("(01)");
      var Ue = Qe.length(), He = this.getGeneralDecoder().extractNumericValueFromBitArray(ue.HEADER_SIZE, 4);
      return Qe.append(He), this.encodeCompressedGtinWithoutAI(Qe, ue.HEADER_SIZE + 4, Ue), this.getGeneralDecoder().decodeAllCodes(Qe, ue.HEADER_SIZE + 44);
    }, ue.HEADER_SIZE = 4, ue;
  }(AI01decoder)
), __extends$B = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), AnyAIDecoder = (
  /** @class */
  function(me) {
    __extends$B(ue, me);
    function ue(Qe) {
      return me.call(this, Qe) || this;
    }
    return ue.prototype.parseInformation = function() {
      var Qe = new StringBuilder();
      return this.getGeneralDecoder().decodeAllCodes(Qe, ue.HEADER_SIZE);
    }, ue.HEADER_SIZE = 5, ue;
  }(AbstractExpandedDecoder)
), __extends$A = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), AI01weightDecoder = (
  /** @class */
  function(me) {
    __extends$A(ue, me);
    function ue(Qe) {
      return me.call(this, Qe) || this;
    }
    return ue.prototype.encodeCompressedWeight = function(Qe, Ue, He) {
      var Ge = this.getGeneralDecoder().extractNumericValueFromBitArray(Ue, He);
      this.addWeightCode(Qe, Ge);
      for (var Xe = this.checkWeight(Ge), Ke = 1e5, $e = 0; $e < 5; ++$e)
        Xe / Ke === 0 && Qe.append("0"), Ke /= 10;
      Qe.append(Xe);
    }, ue;
  }(AI01decoder)
), __extends$z = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), AI013x0xDecoder = (
  /** @class */
  function(me) {
    __extends$z(ue, me);
    function ue(Qe) {
      return me.call(this, Qe) || this;
    }
    return ue.prototype.parseInformation = function() {
      if (this.getInformation().getSize() != ue.HEADER_SIZE + AI01weightDecoder.GTIN_SIZE + ue.WEIGHT_SIZE)
        throw new NotFoundException();
      var Qe = new StringBuilder();
      return this.encodeCompressedGtin(Qe, ue.HEADER_SIZE), this.encodeCompressedWeight(Qe, ue.HEADER_SIZE + AI01weightDecoder.GTIN_SIZE, ue.WEIGHT_SIZE), Qe.toString();
    }, ue.HEADER_SIZE = 5, ue.WEIGHT_SIZE = 15, ue;
  }(AI01weightDecoder)
), __extends$y = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), AI013103decoder = (
  /** @class */
  function(me) {
    __extends$y(ue, me);
    function ue(Qe) {
      return me.call(this, Qe) || this;
    }
    return ue.prototype.addWeightCode = function(Qe, Ue) {
      Qe.append("(3103)");
    }, ue.prototype.checkWeight = function(Qe) {
      return Qe;
    }, ue;
  }(AI013x0xDecoder)
), __extends$x = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), AI01320xDecoder = (
  /** @class */
  function(me) {
    __extends$x(ue, me);
    function ue(Qe) {
      return me.call(this, Qe) || this;
    }
    return ue.prototype.addWeightCode = function(Qe, Ue) {
      Ue < 1e4 ? Qe.append("(3202)") : Qe.append("(3203)");
    }, ue.prototype.checkWeight = function(Qe) {
      return Qe < 1e4 ? Qe : Qe - 1e4;
    }, ue;
  }(AI013x0xDecoder)
), __extends$w = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), AI01392xDecoder = (
  /** @class */
  function(me) {
    __extends$w(ue, me);
    function ue(Qe) {
      return me.call(this, Qe) || this;
    }
    return ue.prototype.parseInformation = function() {
      if (this.getInformation().getSize() < ue.HEADER_SIZE + AI01decoder.GTIN_SIZE)
        throw new NotFoundException();
      var Qe = new StringBuilder();
      this.encodeCompressedGtin(Qe, ue.HEADER_SIZE);
      var Ue = this.getGeneralDecoder().extractNumericValueFromBitArray(ue.HEADER_SIZE + AI01decoder.GTIN_SIZE, ue.LAST_DIGIT_SIZE);
      Qe.append("(392"), Qe.append(Ue), Qe.append(")");
      var He = this.getGeneralDecoder().decodeGeneralPurposeField(ue.HEADER_SIZE + AI01decoder.GTIN_SIZE + ue.LAST_DIGIT_SIZE, null);
      return Qe.append(He.getNewString()), Qe.toString();
    }, ue.HEADER_SIZE = 8, ue.LAST_DIGIT_SIZE = 2, ue;
  }(AI01decoder)
), __extends$v = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), AI01393xDecoder = (
  /** @class */
  function(me) {
    __extends$v(ue, me);
    function ue(Qe) {
      return me.call(this, Qe) || this;
    }
    return ue.prototype.parseInformation = function() {
      if (this.getInformation().getSize() < ue.HEADER_SIZE + AI01decoder.GTIN_SIZE)
        throw new NotFoundException();
      var Qe = new StringBuilder();
      this.encodeCompressedGtin(Qe, ue.HEADER_SIZE);
      var Ue = this.getGeneralDecoder().extractNumericValueFromBitArray(ue.HEADER_SIZE + AI01decoder.GTIN_SIZE, ue.LAST_DIGIT_SIZE);
      Qe.append("(393"), Qe.append(Ue), Qe.append(")");
      var He = this.getGeneralDecoder().extractNumericValueFromBitArray(ue.HEADER_SIZE + AI01decoder.GTIN_SIZE + ue.LAST_DIGIT_SIZE, ue.FIRST_THREE_DIGITS_SIZE);
      He / 100 == 0 && Qe.append("0"), He / 10 == 0 && Qe.append("0"), Qe.append(He);
      var Ge = this.getGeneralDecoder().decodeGeneralPurposeField(ue.HEADER_SIZE + AI01decoder.GTIN_SIZE + ue.LAST_DIGIT_SIZE + ue.FIRST_THREE_DIGITS_SIZE, null);
      return Qe.append(Ge.getNewString()), Qe.toString();
    }, ue.HEADER_SIZE = 8, ue.LAST_DIGIT_SIZE = 2, ue.FIRST_THREE_DIGITS_SIZE = 10, ue;
  }(AI01decoder)
), __extends$u = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), AI013x0x1xDecoder = (
  /** @class */
  function(me) {
    __extends$u(ue, me);
    function ue(Qe, Ue, He) {
      var Ge = me.call(this, Qe) || this;
      return Ge.dateCode = He, Ge.firstAIdigits = Ue, Ge;
    }
    return ue.prototype.parseInformation = function() {
      if (this.getInformation().getSize() != ue.HEADER_SIZE + ue.GTIN_SIZE + ue.WEIGHT_SIZE + ue.DATE_SIZE)
        throw new NotFoundException();
      var Qe = new StringBuilder();
      return this.encodeCompressedGtin(Qe, ue.HEADER_SIZE), this.encodeCompressedWeight(Qe, ue.HEADER_SIZE + ue.GTIN_SIZE, ue.WEIGHT_SIZE), this.encodeCompressedDate(Qe, ue.HEADER_SIZE + ue.GTIN_SIZE + ue.WEIGHT_SIZE), Qe.toString();
    }, ue.prototype.encodeCompressedDate = function(Qe, Ue) {
      var He = this.getGeneralDecoder().extractNumericValueFromBitArray(Ue, ue.DATE_SIZE);
      if (He != 38400) {
        Qe.append("("), Qe.append(this.dateCode), Qe.append(")");
        var Ge = He % 32;
        He /= 32;
        var Xe = He % 12 + 1;
        He /= 12;
        var Ke = He;
        Ke / 10 == 0 && Qe.append("0"), Qe.append(Ke), Xe / 10 == 0 && Qe.append("0"), Qe.append(Xe), Ge / 10 == 0 && Qe.append("0"), Qe.append(Ge);
      }
    }, ue.prototype.addWeightCode = function(Qe, Ue) {
      Qe.append("("), Qe.append(this.firstAIdigits), Qe.append(Ue / 1e5), Qe.append(")");
    }, ue.prototype.checkWeight = function(Qe) {
      return Qe % 1e5;
    }, ue.HEADER_SIZE = 8, ue.WEIGHT_SIZE = 20, ue.DATE_SIZE = 16, ue;
  }(AI01weightDecoder)
);
function createDecoder(me) {
  try {
    if (me.get(1))
      return new AI01AndOtherAIs(me);
    if (!me.get(2))
      return new AnyAIDecoder(me);
    var ue = GeneralAppIdDecoder.extractNumericValueFromBitArray(me, 1, 4);
    switch (ue) {
      case 4:
        return new AI013103decoder(me);
      case 5:
        return new AI01320xDecoder(me);
    }
    var Qe = GeneralAppIdDecoder.extractNumericValueFromBitArray(me, 1, 5);
    switch (Qe) {
      case 12:
        return new AI01392xDecoder(me);
      case 13:
        return new AI01393xDecoder(me);
    }
    var Ue = GeneralAppIdDecoder.extractNumericValueFromBitArray(me, 1, 7);
    switch (Ue) {
      case 56:
        return new AI013x0x1xDecoder(me, "310", "11");
      case 57:
        return new AI013x0x1xDecoder(me, "320", "11");
      case 58:
        return new AI013x0x1xDecoder(me, "310", "13");
      case 59:
        return new AI013x0x1xDecoder(me, "320", "13");
      case 60:
        return new AI013x0x1xDecoder(me, "310", "15");
      case 61:
        return new AI013x0x1xDecoder(me, "320", "15");
      case 62:
        return new AI013x0x1xDecoder(me, "310", "17");
      case 63:
        return new AI013x0x1xDecoder(me, "320", "17");
    }
  } catch (He) {
    throw console.log(He), new IllegalStateException("unknown decoder: " + me);
  }
}
var ExpandedPair = (
  /** @class */
  function() {
    function me(ue, Qe, Ue, He) {
      this.leftchar = ue, this.rightchar = Qe, this.finderpattern = Ue, this.maybeLast = He;
    }
    return me.prototype.mayBeLast = function() {
      return this.maybeLast;
    }, me.prototype.getLeftChar = function() {
      return this.leftchar;
    }, me.prototype.getRightChar = function() {
      return this.rightchar;
    }, me.prototype.getFinderPattern = function() {
      return this.finderpattern;
    }, me.prototype.mustBeLast = function() {
      return this.rightchar == null;
    }, me.prototype.toString = function() {
      return "[ " + this.leftchar + ", " + this.rightchar + " : " + (this.finderpattern == null ? "null" : this.finderpattern.getValue()) + " ]";
    }, me.equals = function(ue, Qe) {
      return ue instanceof me ? me.equalsOrNull(ue.leftchar, Qe.leftchar) && me.equalsOrNull(ue.rightchar, Qe.rightchar) && me.equalsOrNull(ue.finderpattern, Qe.finderpattern) : !1;
    }, me.equalsOrNull = function(ue, Qe) {
      return ue === null ? Qe === null : me.equals(ue, Qe);
    }, me.prototype.hashCode = function() {
      var ue = this.leftchar.getValue() ^ this.rightchar.getValue() ^ this.finderpattern.getValue();
      return ue;
    }, me;
  }()
), ExpandedRow = (
  /** @class */
  function() {
    function me(ue, Qe, Ue) {
      this.pairs = ue, this.rowNumber = Qe, this.wasReversed = Ue;
    }
    return me.prototype.getPairs = function() {
      return this.pairs;
    }, me.prototype.getRowNumber = function() {
      return this.rowNumber;
    }, me.prototype.isReversed = function() {
      return this.wasReversed;
    }, me.prototype.isEquivalent = function(ue) {
      return this.checkEqualitity(this, ue);
    }, me.prototype.toString = function() {
      return "{ " + this.pairs + " }";
    }, me.prototype.equals = function(ue, Qe) {
      return ue instanceof me ? this.checkEqualitity(ue, Qe) && ue.wasReversed === Qe.wasReversed : !1;
    }, me.prototype.checkEqualitity = function(ue, Qe) {
      if (!(!ue || !Qe)) {
        var Ue;
        return ue.forEach(function(He, Ge) {
          Qe.forEach(function(Xe) {
            He.getLeftChar().getValue() === Xe.getLeftChar().getValue() && He.getRightChar().getValue() === Xe.getRightChar().getValue() && He.getFinderPatter().getValue() === Xe.getFinderPatter().getValue() && (Ue = !0);
          });
        }), Ue;
      }
    }, me;
  }()
), __extends$t = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), __values$t = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, RSSExpandedReader = (
  /** @class */
  function(me) {
    __extends$t(ue, me);
    function ue() {
      var Qe = me !== null && me.apply(this, arguments) || this;
      return Qe.pairs = new Array(ue.MAX_PAIRS), Qe.rows = new Array(), Qe.startEnd = [2], Qe;
    }
    return ue.prototype.decodeRow = function(Qe, Ue, He) {
      this.pairs.length = 0, this.startFromEven = !1;
      try {
        return ue.constructResult(this.decodeRow2pairs(Qe, Ue));
      } catch {
      }
      return this.pairs.length = 0, this.startFromEven = !0, ue.constructResult(this.decodeRow2pairs(Qe, Ue));
    }, ue.prototype.reset = function() {
      this.pairs.length = 0, this.rows.length = 0;
    }, ue.prototype.decodeRow2pairs = function(Qe, Ue) {
      for (var He = !1; !He; )
        try {
          this.pairs.push(this.retrieveNextPair(Ue, this.pairs, Qe));
        } catch (Ke) {
          if (Ke instanceof NotFoundException) {
            if (!this.pairs.length)
              throw new NotFoundException();
            He = !0;
          }
        }
      if (this.checkChecksum())
        return this.pairs;
      var Ge;
      if (this.rows.length ? Ge = !0 : Ge = !1, this.storeRow(Qe, !1), Ge) {
        var Xe = this.checkRowsBoolean(!1);
        if (Xe != null || (Xe = this.checkRowsBoolean(!0), Xe != null))
          return Xe;
      }
      throw new NotFoundException();
    }, ue.prototype.checkRowsBoolean = function(Qe) {
      if (this.rows.length > 25)
        return this.rows.length = 0, null;
      this.pairs.length = 0, Qe && (this.rows = this.rows.reverse());
      var Ue = null;
      try {
        Ue = this.checkRows(new Array(), 0);
      } catch (He) {
        console.log(He);
      }
      return Qe && (this.rows = this.rows.reverse()), Ue;
    }, ue.prototype.checkRows = function(Qe, Ue) {
      for (var He, Ge, Xe = Ue; Xe < this.rows.length; Xe++) {
        var Ke = this.rows[Xe];
        this.pairs.length = 0;
        try {
          for (var $e = (He = void 0, __values$t(Qe)), Je = $e.next(); !Je.done; Je = $e.next()) {
            var Ze = Je.value;
            this.pairs.push(Ze.getPairs());
          }
        } catch (tt) {
          He = { error: tt };
        } finally {
          try {
            Je && !Je.done && (Ge = $e.return) && Ge.call($e);
          } finally {
            if (He) throw He.error;
          }
        }
        if (this.pairs.push(Ke.getPairs()), !!ue.isValidSequence(this.pairs)) {
          if (this.checkChecksum())
            return this.pairs;
          var nt = new Array(Qe);
          nt.push(Ke);
          try {
            return this.checkRows(nt, Xe + 1);
          } catch (tt) {
            console.log(tt);
          }
        }
      }
      throw new NotFoundException();
    }, ue.isValidSequence = function(Qe) {
      var Ue, He;
      try {
        for (var Ge = __values$t(ue.FINDER_PATTERN_SEQUENCES), Xe = Ge.next(); !Xe.done; Xe = Ge.next()) {
          var Ke = Xe.value;
          if (!(Qe.length > Ke.length)) {
            for (var $e = !0, Je = 0; Je < Qe.length; Je++)
              if (Qe[Je].getFinderPattern().getValue() != Ke[Je]) {
                $e = !1;
                break;
              }
            if ($e)
              return !0;
          }
        }
      } catch (Ze) {
        Ue = { error: Ze };
      } finally {
        try {
          Xe && !Xe.done && (He = Ge.return) && He.call(Ge);
        } finally {
          if (Ue) throw Ue.error;
        }
      }
      return !1;
    }, ue.prototype.storeRow = function(Qe, Ue) {
      for (var He = 0, Ge = !1, Xe = !1; He < this.rows.length; ) {
        var Ke = this.rows[He];
        if (Ke.getRowNumber() > Qe) {
          Xe = Ke.isEquivalent(this.pairs);
          break;
        }
        Ge = Ke.isEquivalent(this.pairs), He++;
      }
      Xe || Ge || ue.isPartialRow(this.pairs, this.rows) || (this.rows.push(He, new ExpandedRow(this.pairs, Qe, Ue)), this.removePartialRows(this.pairs, this.rows));
    }, ue.prototype.removePartialRows = function(Qe, Ue) {
      var He, Ge, Xe, Ke, $e, Je;
      try {
        for (var Ze = __values$t(Ue), nt = Ze.next(); !nt.done; nt = Ze.next()) {
          var tt = nt.value;
          if (tt.getPairs().length !== Qe.length) {
            var et = !0;
            try {
              for (var rt = (Xe = void 0, __values$t(tt.getPairs())), it = rt.next(); !it.done; it = rt.next()) {
                var ot = it.value, at = !1;
                try {
                  for (var st = ($e = void 0, __values$t(Qe)), ut = st.next(); !ut.done; ut = st.next()) {
                    var lt = ut.value;
                    if (ExpandedPair.equals(ot, lt)) {
                      at = !0;
                      break;
                    }
                  }
                } catch (dt) {
                  $e = { error: dt };
                } finally {
                  try {
                    ut && !ut.done && (Je = st.return) && Je.call(st);
                  } finally {
                    if ($e) throw $e.error;
                  }
                }
                at || (et = !1);
              }
            } catch (dt) {
              Xe = { error: dt };
            } finally {
              try {
                it && !it.done && (Ke = rt.return) && Ke.call(rt);
              } finally {
                if (Xe) throw Xe.error;
              }
            }
          }
        }
      } catch (dt) {
        He = { error: dt };
      } finally {
        try {
          nt && !nt.done && (Ge = Ze.return) && Ge.call(Ze);
        } finally {
          if (He) throw He.error;
        }
      }
    }, ue.isPartialRow = function(Qe, Ue) {
      var He, Ge, Xe, Ke, $e, Je;
      try {
        for (var Ze = __values$t(Ue), nt = Ze.next(); !nt.done; nt = Ze.next()) {
          var tt = nt.value, et = !0;
          try {
            for (var rt = (Xe = void 0, __values$t(Qe)), it = rt.next(); !it.done; it = rt.next()) {
              var ot = it.value, at = !1;
              try {
                for (var st = ($e = void 0, __values$t(tt.getPairs())), ut = st.next(); !ut.done; ut = st.next()) {
                  var lt = ut.value;
                  if (ot.equals(lt)) {
                    at = !0;
                    break;
                  }
                }
              } catch (dt) {
                $e = { error: dt };
              } finally {
                try {
                  ut && !ut.done && (Je = st.return) && Je.call(st);
                } finally {
                  if ($e) throw $e.error;
                }
              }
              if (!at) {
                et = !1;
                break;
              }
            }
          } catch (dt) {
            Xe = { error: dt };
          } finally {
            try {
              it && !it.done && (Ke = rt.return) && Ke.call(rt);
            } finally {
              if (Xe) throw Xe.error;
            }
          }
          if (et)
            return !0;
        }
      } catch (dt) {
        He = { error: dt };
      } finally {
        try {
          nt && !nt.done && (Ge = Ze.return) && Ge.call(Ze);
        } finally {
          if (He) throw He.error;
        }
      }
      return !1;
    }, ue.prototype.getRows = function() {
      return this.rows;
    }, ue.constructResult = function(Qe) {
      var Ue = BitArrayBuilder.buildBitArray(Qe), He = createDecoder(Ue), Ge = He.parseInformation(), Xe = Qe[0].getFinderPattern().getResultPoints(), Ke = Qe[Qe.length - 1].getFinderPattern().getResultPoints(), $e = [Xe[0], Xe[1], Ke[0], Ke[1]];
      return new Result(Ge, null, null, $e, BarcodeFormat$1.RSS_EXPANDED, null);
    }, ue.prototype.checkChecksum = function() {
      var Qe = this.pairs.get(0), Ue = Qe.getLeftChar(), He = Qe.getRightChar();
      if (He == null)
        return !1;
      for (var Ge = He.getChecksumPortion(), Xe = 2, Ke = 1; Ke < this.pairs.size(); ++Ke) {
        var $e = this.pairs.get(Ke);
        Ge += $e.getLeftChar().getChecksumPortion(), Xe++;
        var Je = $e.getRightChar();
        Je != null && (Ge += Je.getChecksumPortion(), Xe++);
      }
      Ge %= 211;
      var Ze = 211 * (Xe - 4) + Ge;
      return Ze == Ue.getValue();
    }, ue.getNextSecondBar = function(Qe, Ue) {
      var He;
      return Qe.get(Ue) ? (He = Qe.getNextUnset(Ue), He = Qe.getNextSet(He)) : (He = Qe.getNextSet(Ue), He = Qe.getNextUnset(He)), He;
    }, ue.prototype.retrieveNextPair = function(Qe, Ue, He) {
      var Ge = Ue.length % 2 == 0;
      this.startFromEven && (Ge = !Ge);
      var Xe, Ke = !0, $e = -1;
      do
        this.findNextPair(Qe, Ue, $e), Xe = this.parseFoundFinderPattern(Qe, He, Ge), Xe == null ? $e = ue.getNextSecondBar(Qe, this.startEnd[0]) : Ke = !1;
      while (Ke);
      var Je = this.decodeDataCharacter(Qe, Xe, Ge, !0);
      if (!this.isEmptyPair(Ue) && Ue[Ue.length - 1].mustBeLast())
        throw new NotFoundException();
      var Ze;
      try {
        Ze = this.decodeDataCharacter(Qe, Xe, Ge, !1);
      } catch (nt) {
        Ze = null, console.log(nt);
      }
      return new ExpandedPair(Je, Ze, Xe, !0);
    }, ue.prototype.isEmptyPair = function(Qe) {
      return Qe.length === 0;
    }, ue.prototype.findNextPair = function(Qe, Ue, He) {
      var Ge = this.getDecodeFinderCounters();
      Ge[0] = 0, Ge[1] = 0, Ge[2] = 0, Ge[3] = 0;
      var Xe = Qe.getSize(), Ke;
      if (He >= 0)
        Ke = He;
      else if (this.isEmptyPair(Ue))
        Ke = 0;
      else {
        var $e = Ue[Ue.length - 1];
        Ke = $e.getFinderPattern().getStartEnd()[1];
      }
      var Je = Ue.length % 2 != 0;
      this.startFromEven && (Je = !Je);
      for (var Ze = !1; Ke < Xe && (Ze = !Qe.get(Ke), !!Ze); )
        Ke++;
      for (var nt = 0, tt = Ke, et = Ke; et < Xe; et++)
        if (Qe.get(et) != Ze)
          Ge[nt]++;
        else {
          if (nt == 3) {
            if (Je && ue.reverseCounters(Ge), ue.isFinderPattern(Ge)) {
              this.startEnd[0] = tt, this.startEnd[1] = et;
              return;
            }
            Je && ue.reverseCounters(Ge), tt += Ge[0] + Ge[1], Ge[0] = Ge[2], Ge[1] = Ge[3], Ge[2] = 0, Ge[3] = 0, nt--;
          } else
            nt++;
          Ge[nt] = 1, Ze = !Ze;
        }
      throw new NotFoundException();
    }, ue.reverseCounters = function(Qe) {
      for (var Ue = Qe.length, He = 0; He < Ue / 2; ++He) {
        var Ge = Qe[He];
        Qe[He] = Qe[Ue - He - 1], Qe[Ue - He - 1] = Ge;
      }
    }, ue.prototype.parseFoundFinderPattern = function(Qe, Ue, He) {
      var Ge, Xe, Ke;
      if (He) {
        for (var $e = this.startEnd[0] - 1; $e >= 0 && !Qe.get($e); )
          $e--;
        $e++, Ge = this.startEnd[0] - $e, Xe = $e, Ke = this.startEnd[1];
      } else
        Xe = this.startEnd[0], Ke = Qe.getNextUnset(this.startEnd[1] + 1), Ge = Ke - this.startEnd[1];
      var Je = this.getDecodeFinderCounters();
      System.arraycopy(Je, 0, Je, 1, Je.length - 1), Je[0] = Ge;
      var Ze;
      try {
        Ze = this.parseFinderValue(Je, ue.FINDER_PATTERNS);
      } catch {
        return null;
      }
      return new FinderPattern$1(Ze, [Xe, Ke], Xe, Ke, Ue);
    }, ue.prototype.decodeDataCharacter = function(Qe, Ue, He, Ge) {
      for (var Xe = this.getDataCharacterCounters(), Ke = 0; Ke < Xe.length; Ke++)
        Xe[Ke] = 0;
      if (Ge)
        ue.recordPatternInReverse(Qe, Ue.getStartEnd()[0], Xe);
      else {
        ue.recordPattern(Qe, Ue.getStartEnd()[1], Xe);
        for (var $e = 0, Je = Xe.length - 1; $e < Je; $e++, Je--) {
          var Ze = Xe[$e];
          Xe[$e] = Xe[Je], Xe[Je] = Ze;
        }
      }
      var nt = 17, tt = MathUtils.sum(new Int32Array(Xe)) / nt, et = (Ue.getStartEnd()[1] - Ue.getStartEnd()[0]) / 15;
      if (Math.abs(tt - et) / et > 0.3)
        throw new NotFoundException();
      for (var rt = this.getOddCounts(), it = this.getEvenCounts(), ot = this.getOddRoundingErrors(), at = this.getEvenRoundingErrors(), $e = 0; $e < Xe.length; $e++) {
        var st = 1 * Xe[$e] / tt, ut = st + 0.5;
        if (ut < 1) {
          if (st < 0.3)
            throw new NotFoundException();
          ut = 1;
        } else if (ut > 8) {
          if (st > 8.7)
            throw new NotFoundException();
          ut = 8;
        }
        var lt = $e / 2;
        $e & 1 ? (it[lt] = ut, at[lt] = st - ut) : (rt[lt] = ut, ot[lt] = st - ut);
      }
      this.adjustOddEvenCounts(nt);
      for (var dt = 4 * Ue.getValue() + (He ? 0 : 2) + (Ge ? 0 : 1) - 1, At = 0, pt = 0, $e = rt.length - 1; $e >= 0; $e--) {
        if (ue.isNotA1left(Ue, He, Ge)) {
          var gt = ue.WEIGHTS[dt][2 * $e];
          pt += rt[$e] * gt;
        }
        At += rt[$e];
      }
      for (var wt = 0, $e = it.length - 1; $e >= 0; $e--)
        if (ue.isNotA1left(Ue, He, Ge)) {
          var gt = ue.WEIGHTS[dt][2 * $e + 1];
          wt += it[$e] * gt;
        }
      var Bt = pt + wt;
      if (At & 1 || At > 13 || At < 4)
        throw new NotFoundException();
      var Tt = (13 - At) / 2, yt = ue.SYMBOL_WIDEST[Tt], Ct = 9 - yt, ht = RSSUtils.getRSSvalue(rt, yt, !0), It = RSSUtils.getRSSvalue(it, Ct, !1), vt = ue.EVEN_TOTAL_SUBSET[Tt], Et = ue.GSUM[Tt], bt = ht * vt + It + Et;
      return new DataCharacter(bt, Bt);
    }, ue.isNotA1left = function(Qe, Ue, He) {
      return !(Qe.getValue() == 0 && Ue && He);
    }, ue.prototype.adjustOddEvenCounts = function(Qe) {
      var Ue = MathUtils.sum(new Int32Array(this.getOddCounts())), He = MathUtils.sum(new Int32Array(this.getEvenCounts())), Ge = !1, Xe = !1;
      Ue > 13 ? Xe = !0 : Ue < 4 && (Ge = !0);
      var Ke = !1, $e = !1;
      He > 13 ? $e = !0 : He < 4 && (Ke = !0);
      var Je = Ue + He - Qe, Ze = (Ue & 1) == 1, nt = (He & 1) == 0;
      if (Je == 1)
        if (Ze) {
          if (nt)
            throw new NotFoundException();
          Xe = !0;
        } else {
          if (!nt)
            throw new NotFoundException();
          $e = !0;
        }
      else if (Je == -1)
        if (Ze) {
          if (nt)
            throw new NotFoundException();
          Ge = !0;
        } else {
          if (!nt)
            throw new NotFoundException();
          Ke = !0;
        }
      else if (Je == 0) {
        if (Ze) {
          if (!nt)
            throw new NotFoundException();
          Ue < He ? (Ge = !0, $e = !0) : (Xe = !0, Ke = !0);
        } else if (nt)
          throw new NotFoundException();
      } else
        throw new NotFoundException();
      if (Ge) {
        if (Xe)
          throw new NotFoundException();
        ue.increment(this.getOddCounts(), this.getOddRoundingErrors());
      }
      if (Xe && ue.decrement(this.getOddCounts(), this.getOddRoundingErrors()), Ke) {
        if ($e)
          throw new NotFoundException();
        ue.increment(this.getEvenCounts(), this.getOddRoundingErrors());
      }
      $e && ue.decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
    }, ue.SYMBOL_WIDEST = [7, 5, 4, 3, 1], ue.EVEN_TOTAL_SUBSET = [4, 20, 52, 104, 204], ue.GSUM = [0, 348, 1388, 2948, 3988], ue.FINDER_PATTERNS = [
      Int32Array.from([1, 8, 4, 1]),
      Int32Array.from([3, 6, 4, 1]),
      Int32Array.from([3, 4, 6, 1]),
      Int32Array.from([3, 2, 8, 1]),
      Int32Array.from([2, 6, 5, 1]),
      Int32Array.from([2, 2, 9, 1])
      // F
    ], ue.WEIGHTS = [
      [1, 3, 9, 27, 81, 32, 96, 77],
      [20, 60, 180, 118, 143, 7, 21, 63],
      [189, 145, 13, 39, 117, 140, 209, 205],
      [193, 157, 49, 147, 19, 57, 171, 91],
      [62, 186, 136, 197, 169, 85, 44, 132],
      [185, 133, 188, 142, 4, 12, 36, 108],
      [113, 128, 173, 97, 80, 29, 87, 50],
      [150, 28, 84, 41, 123, 158, 52, 156],
      [46, 138, 203, 187, 139, 206, 196, 166],
      [76, 17, 51, 153, 37, 111, 122, 155],
      [43, 129, 176, 106, 107, 110, 119, 146],
      [16, 48, 144, 10, 30, 90, 59, 177],
      [109, 116, 137, 200, 178, 112, 125, 164],
      [70, 210, 208, 202, 184, 130, 179, 115],
      [134, 191, 151, 31, 93, 68, 204, 190],
      [148, 22, 66, 198, 172, 94, 71, 2],
      [6, 18, 54, 162, 64, 192, 154, 40],
      [120, 149, 25, 75, 14, 42, 126, 167],
      [79, 26, 78, 23, 69, 207, 199, 175],
      [103, 98, 83, 38, 114, 131, 182, 124],
      [161, 61, 183, 127, 170, 88, 53, 159],
      [55, 165, 73, 8, 24, 72, 5, 15],
      [45, 135, 194, 160, 58, 174, 100, 89]
    ], ue.FINDER_PAT_A = 0, ue.FINDER_PAT_B = 1, ue.FINDER_PAT_C = 2, ue.FINDER_PAT_D = 3, ue.FINDER_PAT_E = 4, ue.FINDER_PAT_F = 5, ue.FINDER_PATTERN_SEQUENCES = [
      [ue.FINDER_PAT_A, ue.FINDER_PAT_A],
      [ue.FINDER_PAT_A, ue.FINDER_PAT_B, ue.FINDER_PAT_B],
      [ue.FINDER_PAT_A, ue.FINDER_PAT_C, ue.FINDER_PAT_B, ue.FINDER_PAT_D],
      [ue.FINDER_PAT_A, ue.FINDER_PAT_E, ue.FINDER_PAT_B, ue.FINDER_PAT_D, ue.FINDER_PAT_C],
      [ue.FINDER_PAT_A, ue.FINDER_PAT_E, ue.FINDER_PAT_B, ue.FINDER_PAT_D, ue.FINDER_PAT_D, ue.FINDER_PAT_F],
      [ue.FINDER_PAT_A, ue.FINDER_PAT_E, ue.FINDER_PAT_B, ue.FINDER_PAT_D, ue.FINDER_PAT_E, ue.FINDER_PAT_F, ue.FINDER_PAT_F],
      [ue.FINDER_PAT_A, ue.FINDER_PAT_A, ue.FINDER_PAT_B, ue.FINDER_PAT_B, ue.FINDER_PAT_C, ue.FINDER_PAT_C, ue.FINDER_PAT_D, ue.FINDER_PAT_D],
      [ue.FINDER_PAT_A, ue.FINDER_PAT_A, ue.FINDER_PAT_B, ue.FINDER_PAT_B, ue.FINDER_PAT_C, ue.FINDER_PAT_C, ue.FINDER_PAT_D, ue.FINDER_PAT_E, ue.FINDER_PAT_E],
      [ue.FINDER_PAT_A, ue.FINDER_PAT_A, ue.FINDER_PAT_B, ue.FINDER_PAT_B, ue.FINDER_PAT_C, ue.FINDER_PAT_C, ue.FINDER_PAT_D, ue.FINDER_PAT_E, ue.FINDER_PAT_F, ue.FINDER_PAT_F],
      [ue.FINDER_PAT_A, ue.FINDER_PAT_A, ue.FINDER_PAT_B, ue.FINDER_PAT_B, ue.FINDER_PAT_C, ue.FINDER_PAT_D, ue.FINDER_PAT_D, ue.FINDER_PAT_E, ue.FINDER_PAT_E, ue.FINDER_PAT_F, ue.FINDER_PAT_F]
    ], ue.MAX_PAIRS = 11, ue;
  }(AbstractRSSReader)
), __extends$s = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), Pair = (
  /** @class */
  function(me) {
    __extends$s(ue, me);
    function ue(Qe, Ue, He) {
      var Ge = me.call(this, Qe, Ue) || this;
      return Ge.count = 0, Ge.finderPattern = He, Ge;
    }
    return ue.prototype.getFinderPattern = function() {
      return this.finderPattern;
    }, ue.prototype.getCount = function() {
      return this.count;
    }, ue.prototype.incrementCount = function() {
      this.count++;
    }, ue;
  }(DataCharacter)
), __extends$r = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), __values$s = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, RSS14Reader = (
  /** @class */
  function(me) {
    __extends$r(ue, me);
    function ue() {
      var Qe = me !== null && me.apply(this, arguments) || this;
      return Qe.possibleLeftPairs = [], Qe.possibleRightPairs = [], Qe;
    }
    return ue.prototype.decodeRow = function(Qe, Ue, He) {
      var Ge, Xe, Ke, $e, Je = this.decodePair(Ue, !1, Qe, He);
      ue.addOrTally(this.possibleLeftPairs, Je), Ue.reverse();
      var Ze = this.decodePair(Ue, !0, Qe, He);
      ue.addOrTally(this.possibleRightPairs, Ze), Ue.reverse();
      try {
        for (var nt = __values$s(this.possibleLeftPairs), tt = nt.next(); !tt.done; tt = nt.next()) {
          var et = tt.value;
          if (et.getCount() > 1)
            try {
              for (var rt = (Ke = void 0, __values$s(this.possibleRightPairs)), it = rt.next(); !it.done; it = rt.next()) {
                var ot = it.value;
                if (ot.getCount() > 1 && ue.checkChecksum(et, ot))
                  return ue.constructResult(et, ot);
              }
            } catch (at) {
              Ke = { error: at };
            } finally {
              try {
                it && !it.done && ($e = rt.return) && $e.call(rt);
              } finally {
                if (Ke) throw Ke.error;
              }
            }
        }
      } catch (at) {
        Ge = { error: at };
      } finally {
        try {
          tt && !tt.done && (Xe = nt.return) && Xe.call(nt);
        } finally {
          if (Ge) throw Ge.error;
        }
      }
      throw new NotFoundException();
    }, ue.addOrTally = function(Qe, Ue) {
      var He, Ge;
      if (Ue != null) {
        var Xe = !1;
        try {
          for (var Ke = __values$s(Qe), $e = Ke.next(); !$e.done; $e = Ke.next()) {
            var Je = $e.value;
            if (Je.getValue() === Ue.getValue()) {
              Je.incrementCount(), Xe = !0;
              break;
            }
          }
        } catch (Ze) {
          He = { error: Ze };
        } finally {
          try {
            $e && !$e.done && (Ge = Ke.return) && Ge.call(Ke);
          } finally {
            if (He) throw He.error;
          }
        }
        Xe || Qe.push(Ue);
      }
    }, ue.prototype.reset = function() {
      this.possibleLeftPairs.length = 0, this.possibleRightPairs.length = 0;
    }, ue.constructResult = function(Qe, Ue) {
      for (var He = 4537077 * Qe.getValue() + Ue.getValue(), Ge = new String(He).toString(), Xe = new StringBuilder(), Ke = 13 - Ge.length; Ke > 0; Ke--)
        Xe.append("0");
      Xe.append(Ge);
      for (var $e = 0, Ke = 0; Ke < 13; Ke++) {
        var Je = Xe.charAt(Ke).charCodeAt(0) - 48;
        $e += Ke & 1 ? Je : 3 * Je;
      }
      $e = 10 - $e % 10, $e === 10 && ($e = 0), Xe.append($e.toString());
      var Ze = Qe.getFinderPattern().getResultPoints(), nt = Ue.getFinderPattern().getResultPoints();
      return new Result(Xe.toString(), null, 0, [Ze[0], Ze[1], nt[0], nt[1]], BarcodeFormat$1.RSS_14, (/* @__PURE__ */ new Date()).getTime());
    }, ue.checkChecksum = function(Qe, Ue) {
      var He = (Qe.getChecksumPortion() + 16 * Ue.getChecksumPortion()) % 79, Ge = 9 * Qe.getFinderPattern().getValue() + Ue.getFinderPattern().getValue();
      return Ge > 72 && Ge--, Ge > 8 && Ge--, He === Ge;
    }, ue.prototype.decodePair = function(Qe, Ue, He, Ge) {
      try {
        var Xe = this.findFinderPattern(Qe, Ue), Ke = this.parseFoundFinderPattern(Qe, He, Ue, Xe), $e = Ge == null ? null : Ge.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK);
        if ($e != null) {
          var Je = (Xe[0] + Xe[1]) / 2;
          Ue && (Je = Qe.getSize() - 1 - Je), $e.foundPossibleResultPoint(new ResultPoint(Je, He));
        }
        var Ze = this.decodeDataCharacter(Qe, Ke, !0), nt = this.decodeDataCharacter(Qe, Ke, !1);
        return new Pair(1597 * Ze.getValue() + nt.getValue(), Ze.getChecksumPortion() + 4 * nt.getChecksumPortion(), Ke);
      } catch {
        return null;
      }
    }, ue.prototype.decodeDataCharacter = function(Qe, Ue, He) {
      for (var Ge = this.getDataCharacterCounters(), Xe = 0; Xe < Ge.length; Xe++)
        Ge[Xe] = 0;
      if (He)
        OneDReader.recordPatternInReverse(Qe, Ue.getStartEnd()[0], Ge);
      else {
        OneDReader.recordPattern(Qe, Ue.getStartEnd()[1] + 1, Ge);
        for (var Ke = 0, $e = Ge.length - 1; Ke < $e; Ke++, $e--) {
          var Je = Ge[Ke];
          Ge[Ke] = Ge[$e], Ge[$e] = Je;
        }
      }
      for (var Ze = He ? 16 : 15, nt = MathUtils.sum(new Int32Array(Ge)) / Ze, tt = this.getOddCounts(), et = this.getEvenCounts(), rt = this.getOddRoundingErrors(), it = this.getEvenRoundingErrors(), Ke = 0; Ke < Ge.length; Ke++) {
        var ot = Ge[Ke] / nt, at = Math.floor(ot + 0.5);
        at < 1 ? at = 1 : at > 8 && (at = 8);
        var st = Math.floor(Ke / 2);
        Ke & 1 ? (et[st] = at, it[st] = ot - at) : (tt[st] = at, rt[st] = ot - at);
      }
      this.adjustOddEvenCounts(He, Ze);
      for (var ut = 0, lt = 0, Ke = tt.length - 1; Ke >= 0; Ke--)
        lt *= 9, lt += tt[Ke], ut += tt[Ke];
      for (var dt = 0, At = 0, Ke = et.length - 1; Ke >= 0; Ke--)
        dt *= 9, dt += et[Ke], At += et[Ke];
      var pt = lt + 3 * dt;
      if (He) {
        if (ut & 1 || ut > 12 || ut < 4)
          throw new NotFoundException();
        var gt = (12 - ut) / 2, wt = ue.OUTSIDE_ODD_WIDEST[gt], Bt = 9 - wt, Tt = RSSUtils.getRSSvalue(tt, wt, !1), yt = RSSUtils.getRSSvalue(et, Bt, !0), Ct = ue.OUTSIDE_EVEN_TOTAL_SUBSET[gt], ht = ue.OUTSIDE_GSUM[gt];
        return new DataCharacter(Tt * Ct + yt + ht, pt);
      } else {
        if (At & 1 || At > 10 || At < 4)
          throw new NotFoundException();
        var gt = (10 - At) / 2, wt = ue.INSIDE_ODD_WIDEST[gt], Bt = 9 - wt, Tt = RSSUtils.getRSSvalue(tt, wt, !0), yt = RSSUtils.getRSSvalue(et, Bt, !1), It = ue.INSIDE_ODD_TOTAL_SUBSET[gt], ht = ue.INSIDE_GSUM[gt];
        return new DataCharacter(yt * It + Tt + ht, pt);
      }
    }, ue.prototype.findFinderPattern = function(Qe, Ue) {
      var He = this.getDecodeFinderCounters();
      He[0] = 0, He[1] = 0, He[2] = 0, He[3] = 0;
      for (var Ge = Qe.getSize(), Xe = !1, Ke = 0; Ke < Ge && (Xe = !Qe.get(Ke), Ue !== Xe); )
        Ke++;
      for (var $e = 0, Je = Ke, Ze = Ke; Ze < Ge; Ze++)
        if (Qe.get(Ze) !== Xe)
          He[$e]++;
        else {
          if ($e === 3) {
            if (AbstractRSSReader.isFinderPattern(He))
              return [Je, Ze];
            Je += He[0] + He[1], He[0] = He[2], He[1] = He[3], He[2] = 0, He[3] = 0, $e--;
          } else
            $e++;
          He[$e] = 1, Xe = !Xe;
        }
      throw new NotFoundException();
    }, ue.prototype.parseFoundFinderPattern = function(Qe, Ue, He, Ge) {
      for (var Xe = Qe.get(Ge[0]), Ke = Ge[0] - 1; Ke >= 0 && Xe !== Qe.get(Ke); )
        Ke--;
      Ke++;
      var $e = Ge[0] - Ke, Je = this.getDecodeFinderCounters(), Ze = new Int32Array(Je.length);
      System.arraycopy(Je, 0, Ze, 1, Je.length - 1), Ze[0] = $e;
      var nt = this.parseFinderValue(Ze, ue.FINDER_PATTERNS), tt = Ke, et = Ge[1];
      return He && (tt = Qe.getSize() - 1 - tt, et = Qe.getSize() - 1 - et), new FinderPattern$1(nt, [Ke, Ge[1]], tt, et, Ue);
    }, ue.prototype.adjustOddEvenCounts = function(Qe, Ue) {
      var He = MathUtils.sum(new Int32Array(this.getOddCounts())), Ge = MathUtils.sum(new Int32Array(this.getEvenCounts())), Xe = !1, Ke = !1, $e = !1, Je = !1;
      Qe ? (He > 12 ? Ke = !0 : He < 4 && (Xe = !0), Ge > 12 ? Je = !0 : Ge < 4 && ($e = !0)) : (He > 11 ? Ke = !0 : He < 5 && (Xe = !0), Ge > 10 ? Je = !0 : Ge < 4 && ($e = !0));
      var Ze = He + Ge - Ue, nt = (He & 1) === (Qe ? 1 : 0), tt = (Ge & 1) === 1;
      if (Ze === 1)
        if (nt) {
          if (tt)
            throw new NotFoundException();
          Ke = !0;
        } else {
          if (!tt)
            throw new NotFoundException();
          Je = !0;
        }
      else if (Ze === -1)
        if (nt) {
          if (tt)
            throw new NotFoundException();
          Xe = !0;
        } else {
          if (!tt)
            throw new NotFoundException();
          $e = !0;
        }
      else if (Ze === 0) {
        if (nt) {
          if (!tt)
            throw new NotFoundException();
          He < Ge ? (Xe = !0, Je = !0) : (Ke = !0, $e = !0);
        } else if (tt)
          throw new NotFoundException();
      } else
        throw new NotFoundException();
      if (Xe) {
        if (Ke)
          throw new NotFoundException();
        AbstractRSSReader.increment(this.getOddCounts(), this.getOddRoundingErrors());
      }
      if (Ke && AbstractRSSReader.decrement(this.getOddCounts(), this.getOddRoundingErrors()), $e) {
        if (Je)
          throw new NotFoundException();
        AbstractRSSReader.increment(this.getEvenCounts(), this.getOddRoundingErrors());
      }
      Je && AbstractRSSReader.decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
    }, ue.OUTSIDE_EVEN_TOTAL_SUBSET = [1, 10, 34, 70, 126], ue.INSIDE_ODD_TOTAL_SUBSET = [4, 20, 48, 81], ue.OUTSIDE_GSUM = [0, 161, 961, 2015, 2715], ue.INSIDE_GSUM = [0, 336, 1036, 1516], ue.OUTSIDE_ODD_WIDEST = [8, 6, 4, 3, 1], ue.INSIDE_ODD_WIDEST = [2, 4, 6, 8], ue.FINDER_PATTERNS = [
      Int32Array.from([3, 8, 2, 1]),
      Int32Array.from([3, 5, 5, 1]),
      Int32Array.from([3, 3, 7, 1]),
      Int32Array.from([3, 1, 9, 1]),
      Int32Array.from([2, 7, 4, 1]),
      Int32Array.from([2, 5, 6, 1]),
      Int32Array.from([2, 3, 8, 1]),
      Int32Array.from([1, 5, 7, 1]),
      Int32Array.from([1, 3, 9, 1])
    ], ue;
  }(AbstractRSSReader)
), __extends$q = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), MultiFormatOneDReader = (
  /** @class */
  function(me) {
    __extends$q(ue, me);
    function ue(Qe) {
      var Ue = me.call(this) || this;
      Ue.readers = [];
      var He = Qe ? Qe.get(DecodeHintType$1.POSSIBLE_FORMATS) : null, Ge = Qe && Qe.get(DecodeHintType$1.ASSUME_CODE_39_CHECK_DIGIT) !== void 0;
      return He && ((He.includes(BarcodeFormat$1.EAN_13) || He.includes(BarcodeFormat$1.UPC_A) || He.includes(BarcodeFormat$1.EAN_8) || He.includes(BarcodeFormat$1.UPC_E)) && Ue.readers.push(new MultiFormatUPCEANReader(Qe)), He.includes(BarcodeFormat$1.CODE_39) && Ue.readers.push(new Code39Reader(Ge)), He.includes(BarcodeFormat$1.CODE_128) && Ue.readers.push(new Code128Reader()), He.includes(BarcodeFormat$1.ITF) && Ue.readers.push(new ITFReader()), He.includes(BarcodeFormat$1.RSS_14) && Ue.readers.push(new RSS14Reader()), He.includes(BarcodeFormat$1.RSS_EXPANDED) && (console.warn("RSS Expanded reader IS NOT ready for production yet! use at your own risk."), Ue.readers.push(new RSSExpandedReader()))), Ue.readers.length === 0 && (Ue.readers.push(new MultiFormatUPCEANReader(Qe)), Ue.readers.push(new Code39Reader()), Ue.readers.push(new MultiFormatUPCEANReader(Qe)), Ue.readers.push(new Code128Reader()), Ue.readers.push(new ITFReader()), Ue.readers.push(new RSS14Reader())), Ue;
    }
    return ue.prototype.decodeRow = function(Qe, Ue, He) {
      for (var Ge = 0; Ge < this.readers.length; Ge++)
        try {
          return this.readers[Ge].decodeRow(Qe, Ue, He);
        } catch {
        }
      throw new NotFoundException();
    }, ue.prototype.reset = function() {
      this.readers.forEach(function(Qe) {
        return Qe.reset();
      });
    }, ue;
  }(OneDReader)
), __extends$p = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}();
(function(me) {
  __extends$p(ue, me);
  function ue(Qe, Ue) {
    return Qe === void 0 && (Qe = 500), me.call(this, new MultiFormatOneDReader(Ue), Qe, Ue) || this;
  }
  return ue;
})(BrowserCodeReader$1);
var __values$r = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, ECBlocks$1 = (
  /** @class */
  function() {
    function me(ue, Qe, Ue) {
      this.ecCodewords = ue, this.ecBlocks = [Qe], Ue && this.ecBlocks.push(Ue);
    }
    return me.prototype.getECCodewords = function() {
      return this.ecCodewords;
    }, me.prototype.getECBlocks = function() {
      return this.ecBlocks;
    }, me;
  }()
), ECB$1 = (
  /** @class */
  function() {
    function me(ue, Qe) {
      this.count = ue, this.dataCodewords = Qe;
    }
    return me.prototype.getCount = function() {
      return this.count;
    }, me.prototype.getDataCodewords = function() {
      return this.dataCodewords;
    }, me;
  }()
), Version$1 = (
  /** @class */
  function() {
    function me(ue, Qe, Ue, He, Ge, Xe) {
      var Ke, $e;
      this.versionNumber = ue, this.symbolSizeRows = Qe, this.symbolSizeColumns = Ue, this.dataRegionSizeRows = He, this.dataRegionSizeColumns = Ge, this.ecBlocks = Xe;
      var Je = 0, Ze = Xe.getECCodewords(), nt = Xe.getECBlocks();
      try {
        for (var tt = __values$r(nt), et = tt.next(); !et.done; et = tt.next()) {
          var rt = et.value;
          Je += rt.getCount() * (rt.getDataCodewords() + Ze);
        }
      } catch (it) {
        Ke = { error: it };
      } finally {
        try {
          et && !et.done && ($e = tt.return) && $e.call(tt);
        } finally {
          if (Ke) throw Ke.error;
        }
      }
      this.totalCodewords = Je;
    }
    return me.prototype.getVersionNumber = function() {
      return this.versionNumber;
    }, me.prototype.getSymbolSizeRows = function() {
      return this.symbolSizeRows;
    }, me.prototype.getSymbolSizeColumns = function() {
      return this.symbolSizeColumns;
    }, me.prototype.getDataRegionSizeRows = function() {
      return this.dataRegionSizeRows;
    }, me.prototype.getDataRegionSizeColumns = function() {
      return this.dataRegionSizeColumns;
    }, me.prototype.getTotalCodewords = function() {
      return this.totalCodewords;
    }, me.prototype.getECBlocks = function() {
      return this.ecBlocks;
    }, me.getVersionForDimensions = function(ue, Qe) {
      var Ue, He;
      if (ue & 1 || Qe & 1)
        throw new FormatException();
      try {
        for (var Ge = __values$r(me.VERSIONS), Xe = Ge.next(); !Xe.done; Xe = Ge.next()) {
          var Ke = Xe.value;
          if (Ke.symbolSizeRows === ue && Ke.symbolSizeColumns === Qe)
            return Ke;
        }
      } catch ($e) {
        Ue = { error: $e };
      } finally {
        try {
          Xe && !Xe.done && (He = Ge.return) && He.call(Ge);
        } finally {
          if (Ue) throw Ue.error;
        }
      }
      throw new FormatException();
    }, me.prototype.toString = function() {
      return "" + this.versionNumber;
    }, me.buildVersions = function() {
      return [
        new me(1, 10, 10, 8, 8, new ECBlocks$1(5, new ECB$1(1, 3))),
        new me(2, 12, 12, 10, 10, new ECBlocks$1(7, new ECB$1(1, 5))),
        new me(3, 14, 14, 12, 12, new ECBlocks$1(10, new ECB$1(1, 8))),
        new me(4, 16, 16, 14, 14, new ECBlocks$1(12, new ECB$1(1, 12))),
        new me(5, 18, 18, 16, 16, new ECBlocks$1(14, new ECB$1(1, 18))),
        new me(6, 20, 20, 18, 18, new ECBlocks$1(18, new ECB$1(1, 22))),
        new me(7, 22, 22, 20, 20, new ECBlocks$1(20, new ECB$1(1, 30))),
        new me(8, 24, 24, 22, 22, new ECBlocks$1(24, new ECB$1(1, 36))),
        new me(9, 26, 26, 24, 24, new ECBlocks$1(28, new ECB$1(1, 44))),
        new me(10, 32, 32, 14, 14, new ECBlocks$1(36, new ECB$1(1, 62))),
        new me(11, 36, 36, 16, 16, new ECBlocks$1(42, new ECB$1(1, 86))),
        new me(12, 40, 40, 18, 18, new ECBlocks$1(48, new ECB$1(1, 114))),
        new me(13, 44, 44, 20, 20, new ECBlocks$1(56, new ECB$1(1, 144))),
        new me(14, 48, 48, 22, 22, new ECBlocks$1(68, new ECB$1(1, 174))),
        new me(15, 52, 52, 24, 24, new ECBlocks$1(42, new ECB$1(2, 102))),
        new me(16, 64, 64, 14, 14, new ECBlocks$1(56, new ECB$1(2, 140))),
        new me(17, 72, 72, 16, 16, new ECBlocks$1(36, new ECB$1(4, 92))),
        new me(18, 80, 80, 18, 18, new ECBlocks$1(48, new ECB$1(4, 114))),
        new me(19, 88, 88, 20, 20, new ECBlocks$1(56, new ECB$1(4, 144))),
        new me(20, 96, 96, 22, 22, new ECBlocks$1(68, new ECB$1(4, 174))),
        new me(21, 104, 104, 24, 24, new ECBlocks$1(56, new ECB$1(6, 136))),
        new me(22, 120, 120, 18, 18, new ECBlocks$1(68, new ECB$1(6, 175))),
        new me(23, 132, 132, 20, 20, new ECBlocks$1(62, new ECB$1(8, 163))),
        new me(24, 144, 144, 22, 22, new ECBlocks$1(62, new ECB$1(8, 156), new ECB$1(2, 155))),
        new me(25, 8, 18, 6, 16, new ECBlocks$1(7, new ECB$1(1, 5))),
        new me(26, 8, 32, 6, 14, new ECBlocks$1(11, new ECB$1(1, 10))),
        new me(27, 12, 26, 10, 24, new ECBlocks$1(14, new ECB$1(1, 16))),
        new me(28, 12, 36, 10, 16, new ECBlocks$1(18, new ECB$1(1, 22))),
        new me(29, 16, 36, 14, 16, new ECBlocks$1(24, new ECB$1(1, 32))),
        new me(30, 16, 48, 14, 22, new ECBlocks$1(28, new ECB$1(1, 49)))
      ];
    }, me.VERSIONS = me.buildVersions(), me;
  }()
), BitMatrixParser$1 = (
  /** @class */
  function() {
    function me(ue) {
      var Qe = ue.getHeight();
      if (Qe < 8 || Qe > 144 || Qe & 1)
        throw new FormatException();
      this.version = me.readVersion(ue), this.mappingBitMatrix = this.extractDataRegion(ue), this.readMappingMatrix = new BitMatrix(this.mappingBitMatrix.getWidth(), this.mappingBitMatrix.getHeight());
    }
    return me.prototype.getVersion = function() {
      return this.version;
    }, me.readVersion = function(ue) {
      var Qe = ue.getHeight(), Ue = ue.getWidth();
      return Version$1.getVersionForDimensions(Qe, Ue);
    }, me.prototype.readCodewords = function() {
      var ue = new Int8Array(this.version.getTotalCodewords()), Qe = 0, Ue = 4, He = 0, Ge = this.mappingBitMatrix.getHeight(), Xe = this.mappingBitMatrix.getWidth(), Ke = !1, $e = !1, Je = !1, Ze = !1;
      do
        if (Ue === Ge && He === 0 && !Ke)
          ue[Qe++] = this.readCorner1(Ge, Xe) & 255, Ue -= 2, He += 2, Ke = !0;
        else if (Ue === Ge - 2 && He === 0 && Xe & 3 && !$e)
          ue[Qe++] = this.readCorner2(Ge, Xe) & 255, Ue -= 2, He += 2, $e = !0;
        else if (Ue === Ge + 4 && He === 2 && !(Xe & 7) && !Je)
          ue[Qe++] = this.readCorner3(Ge, Xe) & 255, Ue -= 2, He += 2, Je = !0;
        else if (Ue === Ge - 2 && He === 0 && (Xe & 7) === 4 && !Ze)
          ue[Qe++] = this.readCorner4(Ge, Xe) & 255, Ue -= 2, He += 2, Ze = !0;
        else {
          do
            Ue < Ge && He >= 0 && !this.readMappingMatrix.get(He, Ue) && (ue[Qe++] = this.readUtah(Ue, He, Ge, Xe) & 255), Ue -= 2, He += 2;
          while (Ue >= 0 && He < Xe);
          Ue += 1, He += 3;
          do
            Ue >= 0 && He < Xe && !this.readMappingMatrix.get(He, Ue) && (ue[Qe++] = this.readUtah(Ue, He, Ge, Xe) & 255), Ue += 2, He -= 2;
          while (Ue < Ge && He >= 0);
          Ue += 3, He += 1;
        }
      while (Ue < Ge || He < Xe);
      if (Qe !== this.version.getTotalCodewords())
        throw new FormatException();
      return ue;
    }, me.prototype.readModule = function(ue, Qe, Ue, He) {
      return ue < 0 && (ue += Ue, Qe += 4 - (Ue + 4 & 7)), Qe < 0 && (Qe += He, ue += 4 - (He + 4 & 7)), this.readMappingMatrix.set(Qe, ue), this.mappingBitMatrix.get(Qe, ue);
    }, me.prototype.readUtah = function(ue, Qe, Ue, He) {
      var Ge = 0;
      return this.readModule(ue - 2, Qe - 2, Ue, He) && (Ge |= 1), Ge <<= 1, this.readModule(ue - 2, Qe - 1, Ue, He) && (Ge |= 1), Ge <<= 1, this.readModule(ue - 1, Qe - 2, Ue, He) && (Ge |= 1), Ge <<= 1, this.readModule(ue - 1, Qe - 1, Ue, He) && (Ge |= 1), Ge <<= 1, this.readModule(ue - 1, Qe, Ue, He) && (Ge |= 1), Ge <<= 1, this.readModule(ue, Qe - 2, Ue, He) && (Ge |= 1), Ge <<= 1, this.readModule(ue, Qe - 1, Ue, He) && (Ge |= 1), Ge <<= 1, this.readModule(ue, Qe, Ue, He) && (Ge |= 1), Ge;
    }, me.prototype.readCorner1 = function(ue, Qe) {
      var Ue = 0;
      return this.readModule(ue - 1, 0, ue, Qe) && (Ue |= 1), Ue <<= 1, this.readModule(ue - 1, 1, ue, Qe) && (Ue |= 1), Ue <<= 1, this.readModule(ue - 1, 2, ue, Qe) && (Ue |= 1), Ue <<= 1, this.readModule(0, Qe - 2, ue, Qe) && (Ue |= 1), Ue <<= 1, this.readModule(0, Qe - 1, ue, Qe) && (Ue |= 1), Ue <<= 1, this.readModule(1, Qe - 1, ue, Qe) && (Ue |= 1), Ue <<= 1, this.readModule(2, Qe - 1, ue, Qe) && (Ue |= 1), Ue <<= 1, this.readModule(3, Qe - 1, ue, Qe) && (Ue |= 1), Ue;
    }, me.prototype.readCorner2 = function(ue, Qe) {
      var Ue = 0;
      return this.readModule(ue - 3, 0, ue, Qe) && (Ue |= 1), Ue <<= 1, this.readModule(ue - 2, 0, ue, Qe) && (Ue |= 1), Ue <<= 1, this.readModule(ue - 1, 0, ue, Qe) && (Ue |= 1), Ue <<= 1, this.readModule(0, Qe - 4, ue, Qe) && (Ue |= 1), Ue <<= 1, this.readModule(0, Qe - 3, ue, Qe) && (Ue |= 1), Ue <<= 1, this.readModule(0, Qe - 2, ue, Qe) && (Ue |= 1), Ue <<= 1, this.readModule(0, Qe - 1, ue, Qe) && (Ue |= 1), Ue <<= 1, this.readModule(1, Qe - 1, ue, Qe) && (Ue |= 1), Ue;
    }, me.prototype.readCorner3 = function(ue, Qe) {
      var Ue = 0;
      return this.readModule(ue - 1, 0, ue, Qe) && (Ue |= 1), Ue <<= 1, this.readModule(ue - 1, Qe - 1, ue, Qe) && (Ue |= 1), Ue <<= 1, this.readModule(0, Qe - 3, ue, Qe) && (Ue |= 1), Ue <<= 1, this.readModule(0, Qe - 2, ue, Qe) && (Ue |= 1), Ue <<= 1, this.readModule(0, Qe - 1, ue, Qe) && (Ue |= 1), Ue <<= 1, this.readModule(1, Qe - 3, ue, Qe) && (Ue |= 1), Ue <<= 1, this.readModule(1, Qe - 2, ue, Qe) && (Ue |= 1), Ue <<= 1, this.readModule(1, Qe - 1, ue, Qe) && (Ue |= 1), Ue;
    }, me.prototype.readCorner4 = function(ue, Qe) {
      var Ue = 0;
      return this.readModule(ue - 3, 0, ue, Qe) && (Ue |= 1), Ue <<= 1, this.readModule(ue - 2, 0, ue, Qe) && (Ue |= 1), Ue <<= 1, this.readModule(ue - 1, 0, ue, Qe) && (Ue |= 1), Ue <<= 1, this.readModule(0, Qe - 2, ue, Qe) && (Ue |= 1), Ue <<= 1, this.readModule(0, Qe - 1, ue, Qe) && (Ue |= 1), Ue <<= 1, this.readModule(1, Qe - 1, ue, Qe) && (Ue |= 1), Ue <<= 1, this.readModule(2, Qe - 1, ue, Qe) && (Ue |= 1), Ue <<= 1, this.readModule(3, Qe - 1, ue, Qe) && (Ue |= 1), Ue;
    }, me.prototype.extractDataRegion = function(ue) {
      var Qe = this.version.getSymbolSizeRows(), Ue = this.version.getSymbolSizeColumns();
      if (ue.getHeight() !== Qe)
        throw new IllegalArgumentException("Dimension of bitMatrix must match the version size");
      for (var He = this.version.getDataRegionSizeRows(), Ge = this.version.getDataRegionSizeColumns(), Xe = Qe / He | 0, Ke = Ue / Ge | 0, $e = Xe * He, Je = Ke * Ge, Ze = new BitMatrix(Je, $e), nt = 0; nt < Xe; ++nt)
        for (var tt = nt * He, et = 0; et < Ke; ++et)
          for (var rt = et * Ge, it = 0; it < He; ++it)
            for (var ot = nt * (He + 2) + 1 + it, at = tt + it, st = 0; st < Ge; ++st) {
              var ut = et * (Ge + 2) + 1 + st;
              if (ue.get(ut, ot)) {
                var lt = rt + st;
                Ze.set(lt, at);
              }
            }
      return Ze;
    }, me;
  }()
), __values$q = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, DataBlock$1 = (
  /** @class */
  function() {
    function me(ue, Qe) {
      this.numDataCodewords = ue, this.codewords = Qe;
    }
    return me.getDataBlocks = function(ue, Qe) {
      var Ue, He, Ge, Xe, Ke = Qe.getECBlocks(), $e = 0, Je = Ke.getECBlocks();
      try {
        for (var Ze = __values$q(Je), nt = Ze.next(); !nt.done; nt = Ze.next()) {
          var tt = nt.value;
          $e += tt.getCount();
        }
      } catch (ht) {
        Ue = { error: ht };
      } finally {
        try {
          nt && !nt.done && (He = Ze.return) && He.call(Ze);
        } finally {
          if (Ue) throw Ue.error;
        }
      }
      var et = new Array($e), rt = 0;
      try {
        for (var it = __values$q(Je), ot = it.next(); !ot.done; ot = it.next())
          for (var tt = ot.value, at = 0; at < tt.getCount(); at++) {
            var st = tt.getDataCodewords(), ut = Ke.getECCodewords() + st;
            et[rt++] = new me(st, new Uint8Array(ut));
          }
      } catch (ht) {
        Ge = { error: ht };
      } finally {
        try {
          ot && !ot.done && (Xe = it.return) && Xe.call(it);
        } finally {
          if (Ge) throw Ge.error;
        }
      }
      for (var lt = et[0].codewords.length, dt = lt - Ke.getECCodewords(), At = dt - 1, pt = 0, at = 0; at < At; at++)
        for (var gt = 0; gt < rt; gt++)
          et[gt].codewords[at] = ue[pt++];
      for (var wt = Qe.getVersionNumber() === 24, Bt = wt ? 8 : rt, gt = 0; gt < Bt; gt++)
        et[gt].codewords[dt - 1] = ue[pt++];
      for (var Tt = et[0].codewords.length, at = dt; at < Tt; at++)
        for (var gt = 0; gt < rt; gt++) {
          var yt = wt ? (gt + 8) % rt : gt, Ct = wt && yt > 7 ? at - 1 : at;
          et[yt].codewords[Ct] = ue[pt++];
        }
      if (pt !== ue.length)
        throw new IllegalArgumentException();
      return et;
    }, me.prototype.getNumDataCodewords = function() {
      return this.numDataCodewords;
    }, me.prototype.getCodewords = function() {
      return this.codewords;
    }, me;
  }()
), BitSource = (
  /** @class */
  function() {
    function me(ue) {
      this.bytes = ue, this.byteOffset = 0, this.bitOffset = 0;
    }
    return me.prototype.getBitOffset = function() {
      return this.bitOffset;
    }, me.prototype.getByteOffset = function() {
      return this.byteOffset;
    }, me.prototype.readBits = function(ue) {
      if (ue < 1 || ue > 32 || ue > this.available())
        throw new IllegalArgumentException("" + ue);
      var Qe = 0, Ue = this.bitOffset, He = this.byteOffset, Ge = this.bytes;
      if (Ue > 0) {
        var Xe = 8 - Ue, Ke = ue < Xe ? ue : Xe, $e = Xe - Ke, Je = 255 >> 8 - Ke << $e;
        Qe = (Ge[He] & Je) >> $e, ue -= Ke, Ue += Ke, Ue === 8 && (Ue = 0, He++);
      }
      if (ue > 0) {
        for (; ue >= 8; )
          Qe = Qe << 8 | Ge[He] & 255, He++, ue -= 8;
        if (ue > 0) {
          var $e = 8 - ue, Je = 255 >> $e << $e;
          Qe = Qe << ue | (Ge[He] & Je) >> $e, Ue += ue;
        }
      }
      return this.bitOffset = Ue, this.byteOffset = He, Qe;
    }, me.prototype.available = function() {
      return 8 * (this.bytes.length - this.byteOffset) - this.bitOffset;
    }, me;
  }()
), Mode$3;
(function(me) {
  me[me.PAD_ENCODE = 0] = "PAD_ENCODE", me[me.ASCII_ENCODE = 1] = "ASCII_ENCODE", me[me.C40_ENCODE = 2] = "C40_ENCODE", me[me.TEXT_ENCODE = 3] = "TEXT_ENCODE", me[me.ANSIX12_ENCODE = 4] = "ANSIX12_ENCODE", me[me.EDIFACT_ENCODE = 5] = "EDIFACT_ENCODE", me[me.BASE256_ENCODE = 6] = "BASE256_ENCODE";
})(Mode$3 || (Mode$3 = {}));
var DecodedBitStreamParser$2 = (
  /** @class */
  function() {
    function me() {
    }
    return me.decode = function(ue) {
      var Qe = new BitSource(ue), Ue = new StringBuilder(), He = new StringBuilder(), Ge = new Array(), Xe = Mode$3.ASCII_ENCODE;
      do
        if (Xe === Mode$3.ASCII_ENCODE)
          Xe = this.decodeAsciiSegment(Qe, Ue, He);
        else {
          switch (Xe) {
            case Mode$3.C40_ENCODE:
              this.decodeC40Segment(Qe, Ue);
              break;
            case Mode$3.TEXT_ENCODE:
              this.decodeTextSegment(Qe, Ue);
              break;
            case Mode$3.ANSIX12_ENCODE:
              this.decodeAnsiX12Segment(Qe, Ue);
              break;
            case Mode$3.EDIFACT_ENCODE:
              this.decodeEdifactSegment(Qe, Ue);
              break;
            case Mode$3.BASE256_ENCODE:
              this.decodeBase256Segment(Qe, Ue, Ge);
              break;
            default:
              throw new FormatException();
          }
          Xe = Mode$3.ASCII_ENCODE;
        }
      while (Xe !== Mode$3.PAD_ENCODE && Qe.available() > 0);
      return He.length() > 0 && Ue.append(He.toString()), new DecoderResult(ue, Ue.toString(), Ge.length === 0 ? null : Ge, null);
    }, me.decodeAsciiSegment = function(ue, Qe, Ue) {
      var He = !1;
      do {
        var Ge = ue.readBits(8);
        if (Ge === 0)
          throw new FormatException();
        if (Ge <= 128)
          return He && (Ge += 128), Qe.append(String.fromCharCode(Ge - 1)), Mode$3.ASCII_ENCODE;
        if (Ge === 129)
          return Mode$3.PAD_ENCODE;
        if (Ge <= 229) {
          var Xe = Ge - 130;
          Xe < 10 && Qe.append("0"), Qe.append("" + Xe);
        } else
          switch (Ge) {
            case 230:
              return Mode$3.C40_ENCODE;
            case 231:
              return Mode$3.BASE256_ENCODE;
            case 232:
              Qe.append("");
              break;
            case 233:
            case 234:
              break;
            case 235:
              He = !0;
              break;
            case 236:
              Qe.append("[)>05"), Ue.insert(0, "");
              break;
            case 237:
              Qe.append("[)>06"), Ue.insert(0, "");
              break;
            case 238:
              return Mode$3.ANSIX12_ENCODE;
            case 239:
              return Mode$3.TEXT_ENCODE;
            case 240:
              return Mode$3.EDIFACT_ENCODE;
            case 241:
              break;
            default:
              if (Ge !== 254 || ue.available() !== 0)
                throw new FormatException();
              break;
          }
      } while (ue.available() > 0);
      return Mode$3.ASCII_ENCODE;
    }, me.decodeC40Segment = function(ue, Qe) {
      var Ue = !1, He = [], Ge = 0;
      do {
        if (ue.available() === 8)
          return;
        var Xe = ue.readBits(8);
        if (Xe === 254)
          return;
        this.parseTwoBytes(Xe, ue.readBits(8), He);
        for (var Ke = 0; Ke < 3; Ke++) {
          var $e = He[Ke];
          switch (Ge) {
            case 0:
              if ($e < 3)
                Ge = $e + 1;
              else if ($e < this.C40_BASIC_SET_CHARS.length) {
                var Je = this.C40_BASIC_SET_CHARS[$e];
                Ue ? (Qe.append(String.fromCharCode(Je.charCodeAt(0) + 128)), Ue = !1) : Qe.append(Je);
              } else
                throw new FormatException();
              break;
            case 1:
              Ue ? (Qe.append(String.fromCharCode($e + 128)), Ue = !1) : Qe.append(String.fromCharCode($e)), Ge = 0;
              break;
            case 2:
              if ($e < this.C40_SHIFT2_SET_CHARS.length) {
                var Je = this.C40_SHIFT2_SET_CHARS[$e];
                Ue ? (Qe.append(String.fromCharCode(Je.charCodeAt(0) + 128)), Ue = !1) : Qe.append(Je);
              } else
                switch ($e) {
                  case 27:
                    Qe.append("");
                    break;
                  case 30:
                    Ue = !0;
                    break;
                  default:
                    throw new FormatException();
                }
              Ge = 0;
              break;
            case 3:
              Ue ? (Qe.append(String.fromCharCode($e + 224)), Ue = !1) : Qe.append(String.fromCharCode($e + 96)), Ge = 0;
              break;
            default:
              throw new FormatException();
          }
        }
      } while (ue.available() > 0);
    }, me.decodeTextSegment = function(ue, Qe) {
      var Ue = !1, He = [], Ge = 0;
      do {
        if (ue.available() === 8)
          return;
        var Xe = ue.readBits(8);
        if (Xe === 254)
          return;
        this.parseTwoBytes(Xe, ue.readBits(8), He);
        for (var Ke = 0; Ke < 3; Ke++) {
          var $e = He[Ke];
          switch (Ge) {
            case 0:
              if ($e < 3)
                Ge = $e + 1;
              else if ($e < this.TEXT_BASIC_SET_CHARS.length) {
                var Je = this.TEXT_BASIC_SET_CHARS[$e];
                Ue ? (Qe.append(String.fromCharCode(Je.charCodeAt(0) + 128)), Ue = !1) : Qe.append(Je);
              } else
                throw new FormatException();
              break;
            case 1:
              Ue ? (Qe.append(String.fromCharCode($e + 128)), Ue = !1) : Qe.append(String.fromCharCode($e)), Ge = 0;
              break;
            case 2:
              if ($e < this.TEXT_SHIFT2_SET_CHARS.length) {
                var Je = this.TEXT_SHIFT2_SET_CHARS[$e];
                Ue ? (Qe.append(String.fromCharCode(Je.charCodeAt(0) + 128)), Ue = !1) : Qe.append(Je);
              } else
                switch ($e) {
                  case 27:
                    Qe.append("");
                    break;
                  case 30:
                    Ue = !0;
                    break;
                  default:
                    throw new FormatException();
                }
              Ge = 0;
              break;
            case 3:
              if ($e < this.TEXT_SHIFT3_SET_CHARS.length) {
                var Je = this.TEXT_SHIFT3_SET_CHARS[$e];
                Ue ? (Qe.append(String.fromCharCode(Je.charCodeAt(0) + 128)), Ue = !1) : Qe.append(Je), Ge = 0;
              } else
                throw new FormatException();
              break;
            default:
              throw new FormatException();
          }
        }
      } while (ue.available() > 0);
    }, me.decodeAnsiX12Segment = function(ue, Qe) {
      var Ue = [];
      do {
        if (ue.available() === 8)
          return;
        var He = ue.readBits(8);
        if (He === 254)
          return;
        this.parseTwoBytes(He, ue.readBits(8), Ue);
        for (var Ge = 0; Ge < 3; Ge++) {
          var Xe = Ue[Ge];
          switch (Xe) {
            case 0:
              Qe.append("\r");
              break;
            case 1:
              Qe.append("*");
              break;
            case 2:
              Qe.append(">");
              break;
            case 3:
              Qe.append(" ");
              break;
            default:
              if (Xe < 14)
                Qe.append(String.fromCharCode(Xe + 44));
              else if (Xe < 40)
                Qe.append(String.fromCharCode(Xe + 51));
              else
                throw new FormatException();
              break;
          }
        }
      } while (ue.available() > 0);
    }, me.parseTwoBytes = function(ue, Qe, Ue) {
      var He = (ue << 8) + Qe - 1, Ge = Math.floor(He / 1600);
      Ue[0] = Ge, He -= Ge * 1600, Ge = Math.floor(He / 40), Ue[1] = Ge, Ue[2] = He - Ge * 40;
    }, me.decodeEdifactSegment = function(ue, Qe) {
      do {
        if (ue.available() <= 16)
          return;
        for (var Ue = 0; Ue < 4; Ue++) {
          var He = ue.readBits(6);
          if (He === 31) {
            var Ge = 8 - ue.getBitOffset();
            Ge !== 8 && ue.readBits(Ge);
            return;
          }
          He & 32 || (He |= 64), Qe.append(String.fromCharCode(He));
        }
      } while (ue.available() > 0);
    }, me.decodeBase256Segment = function(ue, Qe, Ue) {
      var He = 1 + ue.getByteOffset(), Ge = this.unrandomize255State(ue.readBits(8), He++), Xe;
      if (Ge === 0 ? Xe = ue.available() / 8 | 0 : Ge < 250 ? Xe = Ge : Xe = 250 * (Ge - 249) + this.unrandomize255State(ue.readBits(8), He++), Xe < 0)
        throw new FormatException();
      for (var Ke = new Uint8Array(Xe), $e = 0; $e < Xe; $e++) {
        if (ue.available() < 8)
          throw new FormatException();
        Ke[$e] = this.unrandomize255State(ue.readBits(8), He++);
      }
      Ue.push(Ke);
      try {
        Qe.append(StringEncoding.decode(Ke, StringUtils.ISO88591));
      } catch (Je) {
        throw new IllegalStateException("Platform does not support required encoding: " + Je.message);
      }
    }, me.unrandomize255State = function(ue, Qe) {
      var Ue = 149 * Qe % 255 + 1, He = ue - Ue;
      return He >= 0 ? He : He + 256;
    }, me.C40_BASIC_SET_CHARS = [
      "*",
      "*",
      "*",
      " ",
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z"
    ], me.C40_SHIFT2_SET_CHARS = [
      "!",
      '"',
      "#",
      "$",
      "%",
      "&",
      "'",
      "(",
      ")",
      "*",
      "+",
      ",",
      "-",
      ".",
      "/",
      ":",
      ";",
      "<",
      "=",
      ">",
      "?",
      "@",
      "[",
      "\\",
      "]",
      "^",
      "_"
    ], me.TEXT_BASIC_SET_CHARS = [
      "*",
      "*",
      "*",
      " ",
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z"
    ], me.TEXT_SHIFT2_SET_CHARS = me.C40_SHIFT2_SET_CHARS, me.TEXT_SHIFT3_SET_CHARS = [
      "`",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
      "{",
      "|",
      "}",
      "~",
      ""
    ], me;
  }()
), __values$p = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Decoder$1 = (
  /** @class */
  function() {
    function me() {
      this.rsDecoder = new ReedSolomonDecoder(GenericGF.DATA_MATRIX_FIELD_256);
    }
    return me.prototype.decode = function(ue) {
      var Qe, Ue, He = new BitMatrixParser$1(ue), Ge = He.getVersion(), Xe = He.readCodewords(), Ke = DataBlock$1.getDataBlocks(Xe, Ge), $e = 0;
      try {
        for (var Je = __values$p(Ke), Ze = Je.next(); !Ze.done; Ze = Je.next()) {
          var nt = Ze.value;
          $e += nt.getNumDataCodewords();
        }
      } catch (ut) {
        Qe = { error: ut };
      } finally {
        try {
          Ze && !Ze.done && (Ue = Je.return) && Ue.call(Je);
        } finally {
          if (Qe) throw Qe.error;
        }
      }
      for (var tt = new Uint8Array($e), et = Ke.length, rt = 0; rt < et; rt++) {
        var it = Ke[rt], ot = it.getCodewords(), at = it.getNumDataCodewords();
        this.correctErrors(ot, at);
        for (var st = 0; st < at; st++)
          tt[st * et + rt] = ot[st];
      }
      return DecodedBitStreamParser$2.decode(tt);
    }, me.prototype.correctErrors = function(ue, Qe) {
      var Ue = new Int32Array(ue);
      try {
        this.rsDecoder.decode(Ue, ue.length - Qe);
      } catch {
        throw new ChecksumException();
      }
      for (var He = 0; He < Qe; He++)
        ue[He] = Ue[He];
    }, me;
  }()
), Detector$2 = (
  /** @class */
  function() {
    function me(ue) {
      this.image = ue, this.rectangleDetector = new WhiteRectangleDetector(this.image);
    }
    return me.prototype.detect = function() {
      var ue = this.rectangleDetector.detect(), Qe = this.detectSolid1(ue);
      if (Qe = this.detectSolid2(Qe), Qe[3] = this.correctTopRight(Qe), !Qe[3])
        throw new NotFoundException();
      Qe = this.shiftToModuleCenter(Qe);
      var Ue = Qe[0], He = Qe[1], Ge = Qe[2], Xe = Qe[3], Ke = this.transitionsBetween(Ue, Xe) + 1, $e = this.transitionsBetween(Ge, Xe) + 1;
      (Ke & 1) === 1 && (Ke += 1), ($e & 1) === 1 && ($e += 1), 4 * Ke < 7 * $e && 4 * $e < 7 * Ke && (Ke = $e = Math.max(Ke, $e));
      var Je = me.sampleGrid(this.image, Ue, He, Ge, Xe, Ke, $e);
      return new DetectorResult(Je, [Ue, He, Ge, Xe]);
    }, me.shiftPoint = function(ue, Qe, Ue) {
      var He = (Qe.getX() - ue.getX()) / (Ue + 1), Ge = (Qe.getY() - ue.getY()) / (Ue + 1);
      return new ResultPoint(ue.getX() + He, ue.getY() + Ge);
    }, me.moveAway = function(ue, Qe, Ue) {
      var He = ue.getX(), Ge = ue.getY();
      return He < Qe ? He -= 1 : He += 1, Ge < Ue ? Ge -= 1 : Ge += 1, new ResultPoint(He, Ge);
    }, me.prototype.detectSolid1 = function(ue) {
      var Qe = ue[0], Ue = ue[1], He = ue[3], Ge = ue[2], Xe = this.transitionsBetween(Qe, Ue), Ke = this.transitionsBetween(Ue, He), $e = this.transitionsBetween(He, Ge), Je = this.transitionsBetween(Ge, Qe), Ze = Xe, nt = [Ge, Qe, Ue, He];
      return Ze > Ke && (Ze = Ke, nt[0] = Qe, nt[1] = Ue, nt[2] = He, nt[3] = Ge), Ze > $e && (Ze = $e, nt[0] = Ue, nt[1] = He, nt[2] = Ge, nt[3] = Qe), Ze > Je && (nt[0] = He, nt[1] = Ge, nt[2] = Qe, nt[3] = Ue), nt;
    }, me.prototype.detectSolid2 = function(ue) {
      var Qe = ue[0], Ue = ue[1], He = ue[2], Ge = ue[3], Xe = this.transitionsBetween(Qe, Ge), Ke = me.shiftPoint(Ue, He, (Xe + 1) * 4), $e = me.shiftPoint(He, Ue, (Xe + 1) * 4), Je = this.transitionsBetween(Ke, Qe), Ze = this.transitionsBetween($e, Ge);
      return Je < Ze ? (ue[0] = Qe, ue[1] = Ue, ue[2] = He, ue[3] = Ge) : (ue[0] = Ue, ue[1] = He, ue[2] = Ge, ue[3] = Qe), ue;
    }, me.prototype.correctTopRight = function(ue) {
      var Qe = ue[0], Ue = ue[1], He = ue[2], Ge = ue[3], Xe = this.transitionsBetween(Qe, Ge), Ke = this.transitionsBetween(Ue, Ge), $e = me.shiftPoint(Qe, Ue, (Ke + 1) * 4), Je = me.shiftPoint(He, Ue, (Xe + 1) * 4);
      Xe = this.transitionsBetween($e, Ge), Ke = this.transitionsBetween(Je, Ge);
      var Ze = new ResultPoint(Ge.getX() + (He.getX() - Ue.getX()) / (Xe + 1), Ge.getY() + (He.getY() - Ue.getY()) / (Xe + 1)), nt = new ResultPoint(Ge.getX() + (Qe.getX() - Ue.getX()) / (Ke + 1), Ge.getY() + (Qe.getY() - Ue.getY()) / (Ke + 1));
      if (!this.isValid(Ze))
        return this.isValid(nt) ? nt : null;
      if (!this.isValid(nt))
        return Ze;
      var tt = this.transitionsBetween($e, Ze) + this.transitionsBetween(Je, Ze), et = this.transitionsBetween($e, nt) + this.transitionsBetween(Je, nt);
      return tt > et ? Ze : nt;
    }, me.prototype.shiftToModuleCenter = function(ue) {
      var Qe = ue[0], Ue = ue[1], He = ue[2], Ge = ue[3], Xe = this.transitionsBetween(Qe, Ge) + 1, Ke = this.transitionsBetween(He, Ge) + 1, $e = me.shiftPoint(Qe, Ue, Ke * 4), Je = me.shiftPoint(He, Ue, Xe * 4);
      Xe = this.transitionsBetween($e, Ge) + 1, Ke = this.transitionsBetween(Je, Ge) + 1, (Xe & 1) === 1 && (Xe += 1), (Ke & 1) === 1 && (Ke += 1);
      var Ze = (Qe.getX() + Ue.getX() + He.getX() + Ge.getX()) / 4, nt = (Qe.getY() + Ue.getY() + He.getY() + Ge.getY()) / 4;
      Qe = me.moveAway(Qe, Ze, nt), Ue = me.moveAway(Ue, Ze, nt), He = me.moveAway(He, Ze, nt), Ge = me.moveAway(Ge, Ze, nt);
      var tt, et;
      return $e = me.shiftPoint(Qe, Ue, Ke * 4), $e = me.shiftPoint($e, Ge, Xe * 4), tt = me.shiftPoint(Ue, Qe, Ke * 4), tt = me.shiftPoint(tt, He, Xe * 4), Je = me.shiftPoint(He, Ge, Ke * 4), Je = me.shiftPoint(Je, Ue, Xe * 4), et = me.shiftPoint(Ge, He, Ke * 4), et = me.shiftPoint(et, Qe, Xe * 4), [$e, tt, Je, et];
    }, me.prototype.isValid = function(ue) {
      return ue.getX() >= 0 && ue.getX() < this.image.getWidth() && ue.getY() > 0 && ue.getY() < this.image.getHeight();
    }, me.sampleGrid = function(ue, Qe, Ue, He, Ge, Xe, Ke) {
      var $e = GridSamplerInstance.getInstance();
      return $e.sampleGrid(ue, Xe, Ke, 0.5, 0.5, Xe - 0.5, 0.5, Xe - 0.5, Ke - 0.5, 0.5, Ke - 0.5, Qe.getX(), Qe.getY(), Ge.getX(), Ge.getY(), He.getX(), He.getY(), Ue.getX(), Ue.getY());
    }, me.prototype.transitionsBetween = function(ue, Qe) {
      var Ue = Math.trunc(ue.getX()), He = Math.trunc(ue.getY()), Ge = Math.trunc(Qe.getX()), Xe = Math.trunc(Qe.getY()), Ke = Math.abs(Xe - He) > Math.abs(Ge - Ue);
      if (Ke) {
        var $e = Ue;
        Ue = He, He = $e, $e = Ge, Ge = Xe, Xe = $e;
      }
      for (var Je = Math.abs(Ge - Ue), Ze = Math.abs(Xe - He), nt = -Je / 2, tt = He < Xe ? 1 : -1, et = Ue < Ge ? 1 : -1, rt = 0, it = this.image.get(Ke ? He : Ue, Ke ? Ue : He), ot = Ue, at = He; ot !== Ge; ot += et) {
        var st = this.image.get(Ke ? at : ot, Ke ? ot : at);
        if (st !== it && (rt++, it = st), nt += Ze, nt > 0) {
          if (at === Xe)
            break;
          at += tt, nt -= Je;
        }
      }
      return rt;
    }, me;
  }()
), DataMatrixReader = (
  /** @class */
  function() {
    function me() {
      this.decoder = new Decoder$1();
    }
    return me.prototype.decode = function(ue, Qe) {
      Qe === void 0 && (Qe = null);
      var Ue, He;
      if (Qe != null && Qe.has(DecodeHintType$1.PURE_BARCODE)) {
        var Ge = me.extractPureBits(ue.getBlackMatrix());
        Ue = this.decoder.decode(Ge), He = me.NO_POINTS;
      } else {
        var Xe = new Detector$2(ue.getBlackMatrix()).detect();
        Ue = this.decoder.decode(Xe.getBits()), He = Xe.getPoints();
      }
      var Ke = Ue.getRawBytes(), $e = new Result(Ue.getText(), Ke, 8 * Ke.length, He, BarcodeFormat$1.DATA_MATRIX, System.currentTimeMillis()), Je = Ue.getByteSegments();
      Je != null && $e.putMetadata(ResultMetadataType$1.BYTE_SEGMENTS, Je);
      var Ze = Ue.getECLevel();
      return Ze != null && $e.putMetadata(ResultMetadataType$1.ERROR_CORRECTION_LEVEL, Ze), $e;
    }, me.prototype.reset = function() {
    }, me.extractPureBits = function(ue) {
      var Qe = ue.getTopLeftOnBit(), Ue = ue.getBottomRightOnBit();
      if (Qe == null || Ue == null)
        throw new NotFoundException();
      var He = this.moduleSize(Qe, ue), Ge = Qe[1], Xe = Ue[1], Ke = Qe[0], $e = Ue[0], Je = ($e - Ke + 1) / He, Ze = (Xe - Ge + 1) / He;
      if (Je <= 0 || Ze <= 0)
        throw new NotFoundException();
      var nt = He / 2;
      Ge += nt, Ke += nt;
      for (var tt = new BitMatrix(Je, Ze), et = 0; et < Ze; et++)
        for (var rt = Ge + et * He, it = 0; it < Je; it++)
          ue.get(Ke + it * He, rt) && tt.set(it, et);
      return tt;
    }, me.moduleSize = function(ue, Qe) {
      for (var Ue = Qe.getWidth(), He = ue[0], Ge = ue[1]; He < Ue && Qe.get(He, Ge); )
        He++;
      if (He === Ue)
        throw new NotFoundException();
      var Xe = He - ue[0];
      if (Xe === 0)
        throw new NotFoundException();
      return Xe;
    }, me.NO_POINTS = [], me;
  }()
), __extends$o = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}();
(function(me) {
  __extends$o(ue, me);
  function ue(Qe) {
    return Qe === void 0 && (Qe = 500), me.call(this, new DataMatrixReader(), Qe) || this;
  }
  return ue;
})(BrowserCodeReader$1);
var ErrorCorrectionLevelValues;
(function(me) {
  me[me.L = 0] = "L", me[me.M = 1] = "M", me[me.Q = 2] = "Q", me[me.H = 3] = "H";
})(ErrorCorrectionLevelValues || (ErrorCorrectionLevelValues = {}));
var ErrorCorrectionLevel = (
  /** @class */
  function() {
    function me(ue, Qe, Ue) {
      this.value = ue, this.stringValue = Qe, this.bits = Ue, me.FOR_BITS.set(Ue, this), me.FOR_VALUE.set(ue, this);
    }
    return me.prototype.getValue = function() {
      return this.value;
    }, me.prototype.getBits = function() {
      return this.bits;
    }, me.fromString = function(ue) {
      switch (ue) {
        case "L":
          return me.L;
        case "M":
          return me.M;
        case "Q":
          return me.Q;
        case "H":
          return me.H;
        default:
          throw new ArgumentException(ue + "not available");
      }
    }, me.prototype.toString = function() {
      return this.stringValue;
    }, me.prototype.equals = function(ue) {
      if (!(ue instanceof me))
        return !1;
      var Qe = ue;
      return this.value === Qe.value;
    }, me.forBits = function(ue) {
      if (ue < 0 || ue >= me.FOR_BITS.size)
        throw new IllegalArgumentException();
      return me.FOR_BITS.get(ue);
    }, me.FOR_BITS = /* @__PURE__ */ new Map(), me.FOR_VALUE = /* @__PURE__ */ new Map(), me.L = new me(ErrorCorrectionLevelValues.L, "L", 1), me.M = new me(ErrorCorrectionLevelValues.M, "M", 0), me.Q = new me(ErrorCorrectionLevelValues.Q, "Q", 3), me.H = new me(ErrorCorrectionLevelValues.H, "H", 2), me;
  }()
), __values$o = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, FormatInformation = (
  /** @class */
  function() {
    function me(ue) {
      this.errorCorrectionLevel = ErrorCorrectionLevel.forBits(ue >> 3 & 3), this.dataMask = /*(byte) */
      ue & 7;
    }
    return me.numBitsDiffering = function(ue, Qe) {
      return Integer.bitCount(ue ^ Qe);
    }, me.decodeFormatInformation = function(ue, Qe) {
      var Ue = me.doDecodeFormatInformation(ue, Qe);
      return Ue !== null ? Ue : me.doDecodeFormatInformation(ue ^ me.FORMAT_INFO_MASK_QR, Qe ^ me.FORMAT_INFO_MASK_QR);
    }, me.doDecodeFormatInformation = function(ue, Qe) {
      var Ue, He, Ge = Number.MAX_SAFE_INTEGER, Xe = 0;
      try {
        for (var Ke = __values$o(me.FORMAT_INFO_DECODE_LOOKUP), $e = Ke.next(); !$e.done; $e = Ke.next()) {
          var Je = $e.value, Ze = Je[0];
          if (Ze === ue || Ze === Qe)
            return new me(Je[1]);
          var nt = me.numBitsDiffering(ue, Ze);
          nt < Ge && (Xe = Je[1], Ge = nt), ue !== Qe && (nt = me.numBitsDiffering(Qe, Ze), nt < Ge && (Xe = Je[1], Ge = nt));
        }
      } catch (tt) {
        Ue = { error: tt };
      } finally {
        try {
          $e && !$e.done && (He = Ke.return) && He.call(Ke);
        } finally {
          if (Ue) throw Ue.error;
        }
      }
      return Ge <= 3 ? new me(Xe) : null;
    }, me.prototype.getErrorCorrectionLevel = function() {
      return this.errorCorrectionLevel;
    }, me.prototype.getDataMask = function() {
      return this.dataMask;
    }, me.prototype.hashCode = function() {
      return this.errorCorrectionLevel.getBits() << 3 | this.dataMask;
    }, me.prototype.equals = function(ue) {
      if (!(ue instanceof me))
        return !1;
      var Qe = ue;
      return this.errorCorrectionLevel === Qe.errorCorrectionLevel && this.dataMask === Qe.dataMask;
    }, me.FORMAT_INFO_MASK_QR = 21522, me.FORMAT_INFO_DECODE_LOOKUP = [
      Int32Array.from([21522, 0]),
      Int32Array.from([20773, 1]),
      Int32Array.from([24188, 2]),
      Int32Array.from([23371, 3]),
      Int32Array.from([17913, 4]),
      Int32Array.from([16590, 5]),
      Int32Array.from([20375, 6]),
      Int32Array.from([19104, 7]),
      Int32Array.from([30660, 8]),
      Int32Array.from([29427, 9]),
      Int32Array.from([32170, 10]),
      Int32Array.from([30877, 11]),
      Int32Array.from([26159, 12]),
      Int32Array.from([25368, 13]),
      Int32Array.from([27713, 14]),
      Int32Array.from([26998, 15]),
      Int32Array.from([5769, 16]),
      Int32Array.from([5054, 17]),
      Int32Array.from([7399, 18]),
      Int32Array.from([6608, 19]),
      Int32Array.from([1890, 20]),
      Int32Array.from([597, 21]),
      Int32Array.from([3340, 22]),
      Int32Array.from([2107, 23]),
      Int32Array.from([13663, 24]),
      Int32Array.from([12392, 25]),
      Int32Array.from([16177, 26]),
      Int32Array.from([14854, 27]),
      Int32Array.from([9396, 28]),
      Int32Array.from([8579, 29]),
      Int32Array.from([11994, 30]),
      Int32Array.from([11245, 31])
    ], me;
  }()
), __values$n = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, ECBlocks = (
  /** @class */
  function() {
    function me(ue) {
      for (var Qe = [], Ue = 1; Ue < arguments.length; Ue++)
        Qe[Ue - 1] = arguments[Ue];
      this.ecCodewordsPerBlock = ue, this.ecBlocks = Qe;
    }
    return me.prototype.getECCodewordsPerBlock = function() {
      return this.ecCodewordsPerBlock;
    }, me.prototype.getNumBlocks = function() {
      var ue, Qe, Ue = 0, He = this.ecBlocks;
      try {
        for (var Ge = __values$n(He), Xe = Ge.next(); !Xe.done; Xe = Ge.next()) {
          var Ke = Xe.value;
          Ue += Ke.getCount();
        }
      } catch ($e) {
        ue = { error: $e };
      } finally {
        try {
          Xe && !Xe.done && (Qe = Ge.return) && Qe.call(Ge);
        } finally {
          if (ue) throw ue.error;
        }
      }
      return Ue;
    }, me.prototype.getTotalECCodewords = function() {
      return this.ecCodewordsPerBlock * this.getNumBlocks();
    }, me.prototype.getECBlocks = function() {
      return this.ecBlocks;
    }, me;
  }()
), ECB = (
  /** @class */
  function() {
    function me(ue, Qe) {
      this.count = ue, this.dataCodewords = Qe;
    }
    return me.prototype.getCount = function() {
      return this.count;
    }, me.prototype.getDataCodewords = function() {
      return this.dataCodewords;
    }, me;
  }()
), __values$m = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Version = (
  /** @class */
  function() {
    function me(ue, Qe) {
      for (var Ue, He, Ge = [], Xe = 2; Xe < arguments.length; Xe++)
        Ge[Xe - 2] = arguments[Xe];
      this.versionNumber = ue, this.alignmentPatternCenters = Qe, this.ecBlocks = Ge;
      var Ke = 0, $e = Ge[0].getECCodewordsPerBlock(), Je = Ge[0].getECBlocks();
      try {
        for (var Ze = __values$m(Je), nt = Ze.next(); !nt.done; nt = Ze.next()) {
          var tt = nt.value;
          Ke += tt.getCount() * (tt.getDataCodewords() + $e);
        }
      } catch (et) {
        Ue = { error: et };
      } finally {
        try {
          nt && !nt.done && (He = Ze.return) && He.call(Ze);
        } finally {
          if (Ue) throw Ue.error;
        }
      }
      this.totalCodewords = Ke;
    }
    return me.prototype.getVersionNumber = function() {
      return this.versionNumber;
    }, me.prototype.getAlignmentPatternCenters = function() {
      return this.alignmentPatternCenters;
    }, me.prototype.getTotalCodewords = function() {
      return this.totalCodewords;
    }, me.prototype.getDimensionForVersion = function() {
      return 17 + 4 * this.versionNumber;
    }, me.prototype.getECBlocksForLevel = function(ue) {
      return this.ecBlocks[ue.getValue()];
    }, me.getProvisionalVersionForDimension = function(ue) {
      if (ue % 4 !== 1)
        throw new FormatException();
      try {
        return this.getVersionForNumber((ue - 17) / 4);
      } catch {
        throw new FormatException();
      }
    }, me.getVersionForNumber = function(ue) {
      if (ue < 1 || ue > 40)
        throw new IllegalArgumentException();
      return me.VERSIONS[ue - 1];
    }, me.decodeVersionInformation = function(ue) {
      for (var Qe = Number.MAX_SAFE_INTEGER, Ue = 0, He = 0; He < me.VERSION_DECODE_INFO.length; He++) {
        var Ge = me.VERSION_DECODE_INFO[He];
        if (Ge === ue)
          return me.getVersionForNumber(He + 7);
        var Xe = FormatInformation.numBitsDiffering(ue, Ge);
        Xe < Qe && (Ue = He + 7, Qe = Xe);
      }
      return Qe <= 3 ? me.getVersionForNumber(Ue) : null;
    }, me.prototype.buildFunctionPattern = function() {
      var ue = this.getDimensionForVersion(), Qe = new BitMatrix(ue);
      Qe.setRegion(0, 0, 9, 9), Qe.setRegion(ue - 8, 0, 8, 9), Qe.setRegion(0, ue - 8, 9, 8);
      for (var Ue = this.alignmentPatternCenters.length, He = 0; He < Ue; He++)
        for (var Ge = this.alignmentPatternCenters[He] - 2, Xe = 0; Xe < Ue; Xe++)
          He === 0 && (Xe === 0 || Xe === Ue - 1) || He === Ue - 1 && Xe === 0 || Qe.setRegion(this.alignmentPatternCenters[Xe] - 2, Ge, 5, 5);
      return Qe.setRegion(6, 9, 1, ue - 17), Qe.setRegion(9, 6, ue - 17, 1), this.versionNumber > 6 && (Qe.setRegion(ue - 11, 0, 3, 6), Qe.setRegion(0, ue - 11, 6, 3)), Qe;
    }, me.prototype.toString = function() {
      return "" + this.versionNumber;
    }, me.VERSION_DECODE_INFO = Int32Array.from([
      31892,
      34236,
      39577,
      42195,
      48118,
      51042,
      55367,
      58893,
      63784,
      68472,
      70749,
      76311,
      79154,
      84390,
      87683,
      92361,
      96236,
      102084,
      102881,
      110507,
      110734,
      117786,
      119615,
      126325,
      127568,
      133589,
      136944,
      141498,
      145311,
      150283,
      152622,
      158308,
      161089,
      167017
    ]), me.VERSIONS = [
      new me(1, new Int32Array(0), new ECBlocks(7, new ECB(1, 19)), new ECBlocks(10, new ECB(1, 16)), new ECBlocks(13, new ECB(1, 13)), new ECBlocks(17, new ECB(1, 9))),
      new me(2, Int32Array.from([6, 18]), new ECBlocks(10, new ECB(1, 34)), new ECBlocks(16, new ECB(1, 28)), new ECBlocks(22, new ECB(1, 22)), new ECBlocks(28, new ECB(1, 16))),
      new me(3, Int32Array.from([6, 22]), new ECBlocks(15, new ECB(1, 55)), new ECBlocks(26, new ECB(1, 44)), new ECBlocks(18, new ECB(2, 17)), new ECBlocks(22, new ECB(2, 13))),
      new me(4, Int32Array.from([6, 26]), new ECBlocks(20, new ECB(1, 80)), new ECBlocks(18, new ECB(2, 32)), new ECBlocks(26, new ECB(2, 24)), new ECBlocks(16, new ECB(4, 9))),
      new me(5, Int32Array.from([6, 30]), new ECBlocks(26, new ECB(1, 108)), new ECBlocks(24, new ECB(2, 43)), new ECBlocks(18, new ECB(2, 15), new ECB(2, 16)), new ECBlocks(22, new ECB(2, 11), new ECB(2, 12))),
      new me(6, Int32Array.from([6, 34]), new ECBlocks(18, new ECB(2, 68)), new ECBlocks(16, new ECB(4, 27)), new ECBlocks(24, new ECB(4, 19)), new ECBlocks(28, new ECB(4, 15))),
      new me(7, Int32Array.from([6, 22, 38]), new ECBlocks(20, new ECB(2, 78)), new ECBlocks(18, new ECB(4, 31)), new ECBlocks(18, new ECB(2, 14), new ECB(4, 15)), new ECBlocks(26, new ECB(4, 13), new ECB(1, 14))),
      new me(8, Int32Array.from([6, 24, 42]), new ECBlocks(24, new ECB(2, 97)), new ECBlocks(22, new ECB(2, 38), new ECB(2, 39)), new ECBlocks(22, new ECB(4, 18), new ECB(2, 19)), new ECBlocks(26, new ECB(4, 14), new ECB(2, 15))),
      new me(9, Int32Array.from([6, 26, 46]), new ECBlocks(30, new ECB(2, 116)), new ECBlocks(22, new ECB(3, 36), new ECB(2, 37)), new ECBlocks(20, new ECB(4, 16), new ECB(4, 17)), new ECBlocks(24, new ECB(4, 12), new ECB(4, 13))),
      new me(10, Int32Array.from([6, 28, 50]), new ECBlocks(18, new ECB(2, 68), new ECB(2, 69)), new ECBlocks(26, new ECB(4, 43), new ECB(1, 44)), new ECBlocks(24, new ECB(6, 19), new ECB(2, 20)), new ECBlocks(28, new ECB(6, 15), new ECB(2, 16))),
      new me(11, Int32Array.from([6, 30, 54]), new ECBlocks(20, new ECB(4, 81)), new ECBlocks(30, new ECB(1, 50), new ECB(4, 51)), new ECBlocks(28, new ECB(4, 22), new ECB(4, 23)), new ECBlocks(24, new ECB(3, 12), new ECB(8, 13))),
      new me(12, Int32Array.from([6, 32, 58]), new ECBlocks(24, new ECB(2, 92), new ECB(2, 93)), new ECBlocks(22, new ECB(6, 36), new ECB(2, 37)), new ECBlocks(26, new ECB(4, 20), new ECB(6, 21)), new ECBlocks(28, new ECB(7, 14), new ECB(4, 15))),
      new me(13, Int32Array.from([6, 34, 62]), new ECBlocks(26, new ECB(4, 107)), new ECBlocks(22, new ECB(8, 37), new ECB(1, 38)), new ECBlocks(24, new ECB(8, 20), new ECB(4, 21)), new ECBlocks(22, new ECB(12, 11), new ECB(4, 12))),
      new me(14, Int32Array.from([6, 26, 46, 66]), new ECBlocks(30, new ECB(3, 115), new ECB(1, 116)), new ECBlocks(24, new ECB(4, 40), new ECB(5, 41)), new ECBlocks(20, new ECB(11, 16), new ECB(5, 17)), new ECBlocks(24, new ECB(11, 12), new ECB(5, 13))),
      new me(15, Int32Array.from([6, 26, 48, 70]), new ECBlocks(22, new ECB(5, 87), new ECB(1, 88)), new ECBlocks(24, new ECB(5, 41), new ECB(5, 42)), new ECBlocks(30, new ECB(5, 24), new ECB(7, 25)), new ECBlocks(24, new ECB(11, 12), new ECB(7, 13))),
      new me(16, Int32Array.from([6, 26, 50, 74]), new ECBlocks(24, new ECB(5, 98), new ECB(1, 99)), new ECBlocks(28, new ECB(7, 45), new ECB(3, 46)), new ECBlocks(24, new ECB(15, 19), new ECB(2, 20)), new ECBlocks(30, new ECB(3, 15), new ECB(13, 16))),
      new me(17, Int32Array.from([6, 30, 54, 78]), new ECBlocks(28, new ECB(1, 107), new ECB(5, 108)), new ECBlocks(28, new ECB(10, 46), new ECB(1, 47)), new ECBlocks(28, new ECB(1, 22), new ECB(15, 23)), new ECBlocks(28, new ECB(2, 14), new ECB(17, 15))),
      new me(18, Int32Array.from([6, 30, 56, 82]), new ECBlocks(30, new ECB(5, 120), new ECB(1, 121)), new ECBlocks(26, new ECB(9, 43), new ECB(4, 44)), new ECBlocks(28, new ECB(17, 22), new ECB(1, 23)), new ECBlocks(28, new ECB(2, 14), new ECB(19, 15))),
      new me(19, Int32Array.from([6, 30, 58, 86]), new ECBlocks(28, new ECB(3, 113), new ECB(4, 114)), new ECBlocks(26, new ECB(3, 44), new ECB(11, 45)), new ECBlocks(26, new ECB(17, 21), new ECB(4, 22)), new ECBlocks(26, new ECB(9, 13), new ECB(16, 14))),
      new me(20, Int32Array.from([6, 34, 62, 90]), new ECBlocks(28, new ECB(3, 107), new ECB(5, 108)), new ECBlocks(26, new ECB(3, 41), new ECB(13, 42)), new ECBlocks(30, new ECB(15, 24), new ECB(5, 25)), new ECBlocks(28, new ECB(15, 15), new ECB(10, 16))),
      new me(21, Int32Array.from([6, 28, 50, 72, 94]), new ECBlocks(28, new ECB(4, 116), new ECB(4, 117)), new ECBlocks(26, new ECB(17, 42)), new ECBlocks(28, new ECB(17, 22), new ECB(6, 23)), new ECBlocks(30, new ECB(19, 16), new ECB(6, 17))),
      new me(22, Int32Array.from([6, 26, 50, 74, 98]), new ECBlocks(28, new ECB(2, 111), new ECB(7, 112)), new ECBlocks(28, new ECB(17, 46)), new ECBlocks(30, new ECB(7, 24), new ECB(16, 25)), new ECBlocks(24, new ECB(34, 13))),
      new me(23, Int32Array.from([6, 30, 54, 78, 102]), new ECBlocks(30, new ECB(4, 121), new ECB(5, 122)), new ECBlocks(28, new ECB(4, 47), new ECB(14, 48)), new ECBlocks(30, new ECB(11, 24), new ECB(14, 25)), new ECBlocks(30, new ECB(16, 15), new ECB(14, 16))),
      new me(24, Int32Array.from([6, 28, 54, 80, 106]), new ECBlocks(30, new ECB(6, 117), new ECB(4, 118)), new ECBlocks(28, new ECB(6, 45), new ECB(14, 46)), new ECBlocks(30, new ECB(11, 24), new ECB(16, 25)), new ECBlocks(30, new ECB(30, 16), new ECB(2, 17))),
      new me(25, Int32Array.from([6, 32, 58, 84, 110]), new ECBlocks(26, new ECB(8, 106), new ECB(4, 107)), new ECBlocks(28, new ECB(8, 47), new ECB(13, 48)), new ECBlocks(30, new ECB(7, 24), new ECB(22, 25)), new ECBlocks(30, new ECB(22, 15), new ECB(13, 16))),
      new me(26, Int32Array.from([6, 30, 58, 86, 114]), new ECBlocks(28, new ECB(10, 114), new ECB(2, 115)), new ECBlocks(28, new ECB(19, 46), new ECB(4, 47)), new ECBlocks(28, new ECB(28, 22), new ECB(6, 23)), new ECBlocks(30, new ECB(33, 16), new ECB(4, 17))),
      new me(27, Int32Array.from([6, 34, 62, 90, 118]), new ECBlocks(30, new ECB(8, 122), new ECB(4, 123)), new ECBlocks(28, new ECB(22, 45), new ECB(3, 46)), new ECBlocks(30, new ECB(8, 23), new ECB(26, 24)), new ECBlocks(30, new ECB(12, 15), new ECB(28, 16))),
      new me(28, Int32Array.from([6, 26, 50, 74, 98, 122]), new ECBlocks(30, new ECB(3, 117), new ECB(10, 118)), new ECBlocks(28, new ECB(3, 45), new ECB(23, 46)), new ECBlocks(30, new ECB(4, 24), new ECB(31, 25)), new ECBlocks(30, new ECB(11, 15), new ECB(31, 16))),
      new me(29, Int32Array.from([6, 30, 54, 78, 102, 126]), new ECBlocks(30, new ECB(7, 116), new ECB(7, 117)), new ECBlocks(28, new ECB(21, 45), new ECB(7, 46)), new ECBlocks(30, new ECB(1, 23), new ECB(37, 24)), new ECBlocks(30, new ECB(19, 15), new ECB(26, 16))),
      new me(30, Int32Array.from([6, 26, 52, 78, 104, 130]), new ECBlocks(30, new ECB(5, 115), new ECB(10, 116)), new ECBlocks(28, new ECB(19, 47), new ECB(10, 48)), new ECBlocks(30, new ECB(15, 24), new ECB(25, 25)), new ECBlocks(30, new ECB(23, 15), new ECB(25, 16))),
      new me(31, Int32Array.from([6, 30, 56, 82, 108, 134]), new ECBlocks(30, new ECB(13, 115), new ECB(3, 116)), new ECBlocks(28, new ECB(2, 46), new ECB(29, 47)), new ECBlocks(30, new ECB(42, 24), new ECB(1, 25)), new ECBlocks(30, new ECB(23, 15), new ECB(28, 16))),
      new me(32, Int32Array.from([6, 34, 60, 86, 112, 138]), new ECBlocks(30, new ECB(17, 115)), new ECBlocks(28, new ECB(10, 46), new ECB(23, 47)), new ECBlocks(30, new ECB(10, 24), new ECB(35, 25)), new ECBlocks(30, new ECB(19, 15), new ECB(35, 16))),
      new me(33, Int32Array.from([6, 30, 58, 86, 114, 142]), new ECBlocks(30, new ECB(17, 115), new ECB(1, 116)), new ECBlocks(28, new ECB(14, 46), new ECB(21, 47)), new ECBlocks(30, new ECB(29, 24), new ECB(19, 25)), new ECBlocks(30, new ECB(11, 15), new ECB(46, 16))),
      new me(34, Int32Array.from([6, 34, 62, 90, 118, 146]), new ECBlocks(30, new ECB(13, 115), new ECB(6, 116)), new ECBlocks(28, new ECB(14, 46), new ECB(23, 47)), new ECBlocks(30, new ECB(44, 24), new ECB(7, 25)), new ECBlocks(30, new ECB(59, 16), new ECB(1, 17))),
      new me(35, Int32Array.from([6, 30, 54, 78, 102, 126, 150]), new ECBlocks(30, new ECB(12, 121), new ECB(7, 122)), new ECBlocks(28, new ECB(12, 47), new ECB(26, 48)), new ECBlocks(30, new ECB(39, 24), new ECB(14, 25)), new ECBlocks(30, new ECB(22, 15), new ECB(41, 16))),
      new me(36, Int32Array.from([6, 24, 50, 76, 102, 128, 154]), new ECBlocks(30, new ECB(6, 121), new ECB(14, 122)), new ECBlocks(28, new ECB(6, 47), new ECB(34, 48)), new ECBlocks(30, new ECB(46, 24), new ECB(10, 25)), new ECBlocks(30, new ECB(2, 15), new ECB(64, 16))),
      new me(37, Int32Array.from([6, 28, 54, 80, 106, 132, 158]), new ECBlocks(30, new ECB(17, 122), new ECB(4, 123)), new ECBlocks(28, new ECB(29, 46), new ECB(14, 47)), new ECBlocks(30, new ECB(49, 24), new ECB(10, 25)), new ECBlocks(30, new ECB(24, 15), new ECB(46, 16))),
      new me(38, Int32Array.from([6, 32, 58, 84, 110, 136, 162]), new ECBlocks(30, new ECB(4, 122), new ECB(18, 123)), new ECBlocks(28, new ECB(13, 46), new ECB(32, 47)), new ECBlocks(30, new ECB(48, 24), new ECB(14, 25)), new ECBlocks(30, new ECB(42, 15), new ECB(32, 16))),
      new me(39, Int32Array.from([6, 26, 54, 82, 110, 138, 166]), new ECBlocks(30, new ECB(20, 117), new ECB(4, 118)), new ECBlocks(28, new ECB(40, 47), new ECB(7, 48)), new ECBlocks(30, new ECB(43, 24), new ECB(22, 25)), new ECBlocks(30, new ECB(10, 15), new ECB(67, 16))),
      new me(40, Int32Array.from([6, 30, 58, 86, 114, 142, 170]), new ECBlocks(30, new ECB(19, 118), new ECB(6, 119)), new ECBlocks(28, new ECB(18, 47), new ECB(31, 48)), new ECBlocks(30, new ECB(34, 24), new ECB(34, 25)), new ECBlocks(30, new ECB(20, 15), new ECB(61, 16)))
    ], me;
  }()
), DataMaskValues;
(function(me) {
  me[me.DATA_MASK_000 = 0] = "DATA_MASK_000", me[me.DATA_MASK_001 = 1] = "DATA_MASK_001", me[me.DATA_MASK_010 = 2] = "DATA_MASK_010", me[me.DATA_MASK_011 = 3] = "DATA_MASK_011", me[me.DATA_MASK_100 = 4] = "DATA_MASK_100", me[me.DATA_MASK_101 = 5] = "DATA_MASK_101", me[me.DATA_MASK_110 = 6] = "DATA_MASK_110", me[me.DATA_MASK_111 = 7] = "DATA_MASK_111";
})(DataMaskValues || (DataMaskValues = {}));
var DataMask = (
  /** @class */
  function() {
    function me(ue, Qe) {
      this.value = ue, this.isMasked = Qe;
    }
    return me.prototype.unmaskBitMatrix = function(ue, Qe) {
      for (var Ue = 0; Ue < Qe; Ue++)
        for (var He = 0; He < Qe; He++)
          this.isMasked(Ue, He) && ue.flip(He, Ue);
    }, me.values = /* @__PURE__ */ new Map([
      /**
       * 000: mask bits for which (x + y) mod 2 == 0
       */
      [DataMaskValues.DATA_MASK_000, new me(DataMaskValues.DATA_MASK_000, function(ue, Qe) {
        return (ue + Qe & 1) === 0;
      })],
      /**
       * 001: mask bits for which x mod 2 == 0
       */
      [DataMaskValues.DATA_MASK_001, new me(DataMaskValues.DATA_MASK_001, function(ue, Qe) {
        return (ue & 1) === 0;
      })],
      /**
       * 010: mask bits for which y mod 3 == 0
       */
      [DataMaskValues.DATA_MASK_010, new me(DataMaskValues.DATA_MASK_010, function(ue, Qe) {
        return Qe % 3 === 0;
      })],
      /**
       * 011: mask bits for which (x + y) mod 3 == 0
       */
      [DataMaskValues.DATA_MASK_011, new me(DataMaskValues.DATA_MASK_011, function(ue, Qe) {
        return (ue + Qe) % 3 === 0;
      })],
      /**
       * 100: mask bits for which (x/2 + y/3) mod 2 == 0
       */
      [DataMaskValues.DATA_MASK_100, new me(DataMaskValues.DATA_MASK_100, function(ue, Qe) {
        return (Math.floor(ue / 2) + Math.floor(Qe / 3) & 1) === 0;
      })],
      /**
       * 101: mask bits for which xy mod 2 + xy mod 3 == 0
       * equivalently, such that xy mod 6 == 0
       */
      [DataMaskValues.DATA_MASK_101, new me(DataMaskValues.DATA_MASK_101, function(ue, Qe) {
        return ue * Qe % 6 === 0;
      })],
      /**
       * 110: mask bits for which (xy mod 2 + xy mod 3) mod 2 == 0
       * equivalently, such that xy mod 6 < 3
       */
      [DataMaskValues.DATA_MASK_110, new me(DataMaskValues.DATA_MASK_110, function(ue, Qe) {
        return ue * Qe % 6 < 3;
      })],
      /**
       * 111: mask bits for which ((x+y)mod 2 + xy mod 3) mod 2 == 0
       * equivalently, such that (x + y + xy mod 3) mod 2 == 0
       */
      [DataMaskValues.DATA_MASK_111, new me(DataMaskValues.DATA_MASK_111, function(ue, Qe) {
        return (ue + Qe + ue * Qe % 3 & 1) === 0;
      })]
    ]), me;
  }()
), BitMatrixParser = (
  /** @class */
  function() {
    function me(ue) {
      var Qe = ue.getHeight();
      if (Qe < 21 || (Qe & 3) !== 1)
        throw new FormatException();
      this.bitMatrix = ue;
    }
    return me.prototype.readFormatInformation = function() {
      if (this.parsedFormatInfo !== null && this.parsedFormatInfo !== void 0)
        return this.parsedFormatInfo;
      for (var ue = 0, Qe = 0; Qe < 6; Qe++)
        ue = this.copyBit(Qe, 8, ue);
      ue = this.copyBit(7, 8, ue), ue = this.copyBit(8, 8, ue), ue = this.copyBit(8, 7, ue);
      for (var Ue = 5; Ue >= 0; Ue--)
        ue = this.copyBit(8, Ue, ue);
      for (var He = this.bitMatrix.getHeight(), Ge = 0, Xe = He - 7, Ue = He - 1; Ue >= Xe; Ue--)
        Ge = this.copyBit(8, Ue, Ge);
      for (var Qe = He - 8; Qe < He; Qe++)
        Ge = this.copyBit(Qe, 8, Ge);
      if (this.parsedFormatInfo = FormatInformation.decodeFormatInformation(ue, Ge), this.parsedFormatInfo !== null)
        return this.parsedFormatInfo;
      throw new FormatException();
    }, me.prototype.readVersion = function() {
      if (this.parsedVersion !== null && this.parsedVersion !== void 0)
        return this.parsedVersion;
      var ue = this.bitMatrix.getHeight(), Qe = Math.floor((ue - 17) / 4);
      if (Qe <= 6)
        return Version.getVersionForNumber(Qe);
      for (var Ue = 0, He = ue - 11, Ge = 5; Ge >= 0; Ge--)
        for (var Xe = ue - 9; Xe >= He; Xe--)
          Ue = this.copyBit(Xe, Ge, Ue);
      var Ke = Version.decodeVersionInformation(Ue);
      if (Ke !== null && Ke.getDimensionForVersion() === ue)
        return this.parsedVersion = Ke, Ke;
      Ue = 0;
      for (var Xe = 5; Xe >= 0; Xe--)
        for (var Ge = ue - 9; Ge >= He; Ge--)
          Ue = this.copyBit(Xe, Ge, Ue);
      if (Ke = Version.decodeVersionInformation(Ue), Ke !== null && Ke.getDimensionForVersion() === ue)
        return this.parsedVersion = Ke, Ke;
      throw new FormatException();
    }, me.prototype.copyBit = function(ue, Qe, Ue) {
      var He = this.isMirror ? this.bitMatrix.get(Qe, ue) : this.bitMatrix.get(ue, Qe);
      return He ? Ue << 1 | 1 : Ue << 1;
    }, me.prototype.readCodewords = function() {
      var ue = this.readFormatInformation(), Qe = this.readVersion(), Ue = DataMask.values.get(ue.getDataMask()), He = this.bitMatrix.getHeight();
      Ue.unmaskBitMatrix(this.bitMatrix, He);
      for (var Ge = Qe.buildFunctionPattern(), Xe = !0, Ke = new Uint8Array(Qe.getTotalCodewords()), $e = 0, Je = 0, Ze = 0, nt = He - 1; nt > 0; nt -= 2) {
        nt === 6 && nt--;
        for (var tt = 0; tt < He; tt++)
          for (var et = Xe ? He - 1 - tt : tt, rt = 0; rt < 2; rt++)
            Ge.get(nt - rt, et) || (Ze++, Je <<= 1, this.bitMatrix.get(nt - rt, et) && (Je |= 1), Ze === 8 && (Ke[$e++] = /*(byte) */
            Je, Ze = 0, Je = 0));
        Xe = !Xe;
      }
      if ($e !== Qe.getTotalCodewords())
        throw new FormatException();
      return Ke;
    }, me.prototype.remask = function() {
      if (this.parsedFormatInfo !== null) {
        var ue = DataMask.values[this.parsedFormatInfo.getDataMask()], Qe = this.bitMatrix.getHeight();
        ue.unmaskBitMatrix(this.bitMatrix, Qe);
      }
    }, me.prototype.setMirror = function(ue) {
      this.parsedVersion = null, this.parsedFormatInfo = null, this.isMirror = ue;
    }, me.prototype.mirror = function() {
      for (var ue = this.bitMatrix, Qe = 0, Ue = ue.getWidth(); Qe < Ue; Qe++)
        for (var He = Qe + 1, Ge = ue.getHeight(); He < Ge; He++)
          ue.get(Qe, He) !== ue.get(He, Qe) && (ue.flip(He, Qe), ue.flip(Qe, He));
    }, me;
  }()
), __values$l = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, DataBlock = (
  /** @class */
  function() {
    function me(ue, Qe) {
      this.numDataCodewords = ue, this.codewords = Qe;
    }
    return me.getDataBlocks = function(ue, Qe, Ue) {
      var He, Ge, Xe, Ke;
      if (ue.length !== Qe.getTotalCodewords())
        throw new IllegalArgumentException();
      var $e = Qe.getECBlocksForLevel(Ue), Je = 0, Ze = $e.getECBlocks();
      try {
        for (var nt = __values$l(Ze), tt = nt.next(); !tt.done; tt = nt.next()) {
          var et = tt.value;
          Je += et.getCount();
        }
      } catch (Ct) {
        He = { error: Ct };
      } finally {
        try {
          tt && !tt.done && (Ge = nt.return) && Ge.call(nt);
        } finally {
          if (He) throw He.error;
        }
      }
      var rt = new Array(Je), it = 0;
      try {
        for (var ot = __values$l(Ze), at = ot.next(); !at.done; at = ot.next())
          for (var et = at.value, st = 0; st < et.getCount(); st++) {
            var ut = et.getDataCodewords(), lt = $e.getECCodewordsPerBlock() + ut;
            rt[it++] = new me(ut, new Uint8Array(lt));
          }
      } catch (Ct) {
        Xe = { error: Ct };
      } finally {
        try {
          at && !at.done && (Ke = ot.return) && Ke.call(ot);
        } finally {
          if (Xe) throw Xe.error;
        }
      }
      for (var dt = rt[0].codewords.length, At = rt.length - 1; At >= 0; ) {
        var pt = rt[At].codewords.length;
        if (pt === dt)
          break;
        At--;
      }
      At++;
      for (var gt = dt - $e.getECCodewordsPerBlock(), wt = 0, st = 0; st < gt; st++)
        for (var Bt = 0; Bt < it; Bt++)
          rt[Bt].codewords[st] = ue[wt++];
      for (var Bt = At; Bt < it; Bt++)
        rt[Bt].codewords[gt] = ue[wt++];
      for (var Tt = rt[0].codewords.length, st = gt; st < Tt; st++)
        for (var Bt = 0; Bt < it; Bt++) {
          var yt = Bt < At ? st : st + 1;
          rt[Bt].codewords[yt] = ue[wt++];
        }
      return rt;
    }, me.prototype.getNumDataCodewords = function() {
      return this.numDataCodewords;
    }, me.prototype.getCodewords = function() {
      return this.codewords;
    }, me;
  }()
), ModeValues;
(function(me) {
  me[me.TERMINATOR = 0] = "TERMINATOR", me[me.NUMERIC = 1] = "NUMERIC", me[me.ALPHANUMERIC = 2] = "ALPHANUMERIC", me[me.STRUCTURED_APPEND = 3] = "STRUCTURED_APPEND", me[me.BYTE = 4] = "BYTE", me[me.ECI = 5] = "ECI", me[me.KANJI = 6] = "KANJI", me[me.FNC1_FIRST_POSITION = 7] = "FNC1_FIRST_POSITION", me[me.FNC1_SECOND_POSITION = 8] = "FNC1_SECOND_POSITION", me[me.HANZI = 9] = "HANZI";
})(ModeValues || (ModeValues = {}));
var Mode$2 = (
  /** @class */
  function() {
    function me(ue, Qe, Ue, He) {
      this.value = ue, this.stringValue = Qe, this.characterCountBitsForVersions = Ue, this.bits = He, me.FOR_BITS.set(He, this), me.FOR_VALUE.set(ue, this);
    }
    return me.forBits = function(ue) {
      var Qe = me.FOR_BITS.get(ue);
      if (Qe === void 0)
        throw new IllegalArgumentException();
      return Qe;
    }, me.prototype.getCharacterCountBits = function(ue) {
      var Qe = ue.getVersionNumber(), Ue;
      return Qe <= 9 ? Ue = 0 : Qe <= 26 ? Ue = 1 : Ue = 2, this.characterCountBitsForVersions[Ue];
    }, me.prototype.getValue = function() {
      return this.value;
    }, me.prototype.getBits = function() {
      return this.bits;
    }, me.prototype.equals = function(ue) {
      if (!(ue instanceof me))
        return !1;
      var Qe = ue;
      return this.value === Qe.value;
    }, me.prototype.toString = function() {
      return this.stringValue;
    }, me.FOR_BITS = /* @__PURE__ */ new Map(), me.FOR_VALUE = /* @__PURE__ */ new Map(), me.TERMINATOR = new me(ModeValues.TERMINATOR, "TERMINATOR", Int32Array.from([0, 0, 0]), 0), me.NUMERIC = new me(ModeValues.NUMERIC, "NUMERIC", Int32Array.from([10, 12, 14]), 1), me.ALPHANUMERIC = new me(ModeValues.ALPHANUMERIC, "ALPHANUMERIC", Int32Array.from([9, 11, 13]), 2), me.STRUCTURED_APPEND = new me(ModeValues.STRUCTURED_APPEND, "STRUCTURED_APPEND", Int32Array.from([0, 0, 0]), 3), me.BYTE = new me(ModeValues.BYTE, "BYTE", Int32Array.from([8, 16, 16]), 4), me.ECI = new me(ModeValues.ECI, "ECI", Int32Array.from([0, 0, 0]), 7), me.KANJI = new me(ModeValues.KANJI, "KANJI", Int32Array.from([8, 10, 12]), 8), me.FNC1_FIRST_POSITION = new me(ModeValues.FNC1_FIRST_POSITION, "FNC1_FIRST_POSITION", Int32Array.from([0, 0, 0]), 5), me.FNC1_SECOND_POSITION = new me(ModeValues.FNC1_SECOND_POSITION, "FNC1_SECOND_POSITION", Int32Array.from([0, 0, 0]), 9), me.HANZI = new me(ModeValues.HANZI, "HANZI", Int32Array.from([8, 10, 12]), 13), me;
  }()
), DecodedBitStreamParser$1 = (
  /** @class */
  function() {
    function me() {
    }
    return me.decode = function(ue, Qe, Ue, He) {
      var Ge = new BitSource(ue), Xe = new StringBuilder(), Ke = new Array(), $e = -1, Je = -1;
      try {
        var Ze = null, nt = !1, tt = void 0;
        do {
          if (Ge.available() < 4)
            tt = Mode$2.TERMINATOR;
          else {
            var et = Ge.readBits(4);
            tt = Mode$2.forBits(et);
          }
          switch (tt) {
            case Mode$2.TERMINATOR:
              break;
            case Mode$2.FNC1_FIRST_POSITION:
            case Mode$2.FNC1_SECOND_POSITION:
              nt = !0;
              break;
            case Mode$2.STRUCTURED_APPEND:
              if (Ge.available() < 16)
                throw new FormatException();
              $e = Ge.readBits(8), Je = Ge.readBits(8);
              break;
            case Mode$2.ECI:
              var rt = me.parseECIValue(Ge);
              if (Ze = CharacterSetECI.getCharacterSetECIByValue(rt), Ze === null)
                throw new FormatException();
              break;
            case Mode$2.HANZI:
              var it = Ge.readBits(4), ot = Ge.readBits(tt.getCharacterCountBits(Qe));
              it === me.GB2312_SUBSET && me.decodeHanziSegment(Ge, Xe, ot);
              break;
            default:
              var at = Ge.readBits(tt.getCharacterCountBits(Qe));
              switch (tt) {
                case Mode$2.NUMERIC:
                  me.decodeNumericSegment(Ge, Xe, at);
                  break;
                case Mode$2.ALPHANUMERIC:
                  me.decodeAlphanumericSegment(Ge, Xe, at, nt);
                  break;
                case Mode$2.BYTE:
                  me.decodeByteSegment(Ge, Xe, at, Ze, Ke, He);
                  break;
                case Mode$2.KANJI:
                  me.decodeKanjiSegment(Ge, Xe, at);
                  break;
                default:
                  throw new FormatException();
              }
              break;
          }
        } while (tt !== Mode$2.TERMINATOR);
      } catch {
        throw new FormatException();
      }
      return new DecoderResult(ue, Xe.toString(), Ke.length === 0 ? null : Ke, Ue === null ? null : Ue.toString(), $e, Je);
    }, me.decodeHanziSegment = function(ue, Qe, Ue) {
      if (Ue * 13 > ue.available())
        throw new FormatException();
      for (var He = new Uint8Array(2 * Ue), Ge = 0; Ue > 0; ) {
        var Xe = ue.readBits(13), Ke = Xe / 96 << 8 & 4294967295 | Xe % 96;
        Ke < 959 ? Ke += 41377 : Ke += 42657, He[Ge] = /*(byte) */
        Ke >> 8 & 255, He[Ge + 1] = /*(byte) */
        Ke & 255, Ge += 2, Ue--;
      }
      try {
        Qe.append(StringEncoding.decode(He, StringUtils.GB2312));
      } catch ($e) {
        throw new FormatException($e);
      }
    }, me.decodeKanjiSegment = function(ue, Qe, Ue) {
      if (Ue * 13 > ue.available())
        throw new FormatException();
      for (var He = new Uint8Array(2 * Ue), Ge = 0; Ue > 0; ) {
        var Xe = ue.readBits(13), Ke = Xe / 192 << 8 & 4294967295 | Xe % 192;
        Ke < 7936 ? Ke += 33088 : Ke += 49472, He[Ge] = /*(byte) */
        Ke >> 8, He[Ge + 1] = /*(byte) */
        Ke, Ge += 2, Ue--;
      }
      try {
        Qe.append(StringEncoding.decode(He, StringUtils.SHIFT_JIS));
      } catch ($e) {
        throw new FormatException($e);
      }
    }, me.decodeByteSegment = function(ue, Qe, Ue, He, Ge, Xe) {
      if (8 * Ue > ue.available())
        throw new FormatException();
      for (var Ke = new Uint8Array(Ue), $e = 0; $e < Ue; $e++)
        Ke[$e] = /*(byte) */
        ue.readBits(8);
      var Je;
      He === null ? Je = StringUtils.guessEncoding(Ke, Xe) : Je = He.getName();
      try {
        Qe.append(StringEncoding.decode(Ke, Je));
      } catch (Ze) {
        throw new FormatException(Ze);
      }
      Ge.push(Ke);
    }, me.toAlphaNumericChar = function(ue) {
      if (ue >= me.ALPHANUMERIC_CHARS.length)
        throw new FormatException();
      return me.ALPHANUMERIC_CHARS[ue];
    }, me.decodeAlphanumericSegment = function(ue, Qe, Ue, He) {
      for (var Ge = Qe.length(); Ue > 1; ) {
        if (ue.available() < 11)
          throw new FormatException();
        var Xe = ue.readBits(11);
        Qe.append(me.toAlphaNumericChar(Math.floor(Xe / 45))), Qe.append(me.toAlphaNumericChar(Xe % 45)), Ue -= 2;
      }
      if (Ue === 1) {
        if (ue.available() < 6)
          throw new FormatException();
        Qe.append(me.toAlphaNumericChar(ue.readBits(6)));
      }
      if (He)
        for (var Ke = Ge; Ke < Qe.length(); Ke++)
          Qe.charAt(Ke) === "%" && (Ke < Qe.length() - 1 && Qe.charAt(Ke + 1) === "%" ? Qe.deleteCharAt(Ke + 1) : Qe.setCharAt(Ke, ""));
    }, me.decodeNumericSegment = function(ue, Qe, Ue) {
      for (; Ue >= 3; ) {
        if (ue.available() < 10)
          throw new FormatException();
        var He = ue.readBits(10);
        if (He >= 1e3)
          throw new FormatException();
        Qe.append(me.toAlphaNumericChar(Math.floor(He / 100))), Qe.append(me.toAlphaNumericChar(Math.floor(He / 10) % 10)), Qe.append(me.toAlphaNumericChar(He % 10)), Ue -= 3;
      }
      if (Ue === 2) {
        if (ue.available() < 7)
          throw new FormatException();
        var Ge = ue.readBits(7);
        if (Ge >= 100)
          throw new FormatException();
        Qe.append(me.toAlphaNumericChar(Math.floor(Ge / 10))), Qe.append(me.toAlphaNumericChar(Ge % 10));
      } else if (Ue === 1) {
        if (ue.available() < 4)
          throw new FormatException();
        var Xe = ue.readBits(4);
        if (Xe >= 10)
          throw new FormatException();
        Qe.append(me.toAlphaNumericChar(Xe));
      }
    }, me.parseECIValue = function(ue) {
      var Qe = ue.readBits(8);
      if (!(Qe & 128))
        return Qe & 127;
      if ((Qe & 192) === 128) {
        var Ue = ue.readBits(8);
        return (Qe & 63) << 8 & 4294967295 | Ue;
      }
      if ((Qe & 224) === 192) {
        var He = ue.readBits(16);
        return (Qe & 31) << 16 & 4294967295 | He;
      }
      throw new FormatException();
    }, me.ALPHANUMERIC_CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:", me.GB2312_SUBSET = 1, me;
  }()
), QRCodeDecoderMetaData = (
  /** @class */
  function() {
    function me(ue) {
      this.mirrored = ue;
    }
    return me.prototype.isMirrored = function() {
      return this.mirrored;
    }, me.prototype.applyMirroredCorrection = function(ue) {
      if (!(!this.mirrored || ue === null || ue.length < 3)) {
        var Qe = ue[0];
        ue[0] = ue[2], ue[2] = Qe;
      }
    }, me;
  }()
), __values$k = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Decoder = (
  /** @class */
  function() {
    function me() {
      this.rsDecoder = new ReedSolomonDecoder(GenericGF.QR_CODE_FIELD_256);
    }
    return me.prototype.decodeBooleanArray = function(ue, Qe) {
      return this.decodeBitMatrix(BitMatrix.parseFromBooleanArray(ue), Qe);
    }, me.prototype.decodeBitMatrix = function(ue, Qe) {
      var Ue = new BitMatrixParser(ue), He = null;
      try {
        return this.decodeBitMatrixParser(Ue, Qe);
      } catch (Xe) {
        He = Xe;
      }
      try {
        Ue.remask(), Ue.setMirror(!0), Ue.readVersion(), Ue.readFormatInformation(), Ue.mirror();
        var Ge = this.decodeBitMatrixParser(Ue, Qe);
        return Ge.setOther(new QRCodeDecoderMetaData(!0)), Ge;
      } catch (Xe) {
        throw He !== null ? He : Xe;
      }
    }, me.prototype.decodeBitMatrixParser = function(ue, Qe) {
      var Ue, He, Ge, Xe, Ke = ue.readVersion(), $e = ue.readFormatInformation().getErrorCorrectionLevel(), Je = ue.readCodewords(), Ze = DataBlock.getDataBlocks(Je, Ke, $e), nt = 0;
      try {
        for (var tt = __values$k(Ze), et = tt.next(); !et.done; et = tt.next()) {
          var rt = et.value;
          nt += rt.getNumDataCodewords();
        }
      } catch (At) {
        Ue = { error: At };
      } finally {
        try {
          et && !et.done && (He = tt.return) && He.call(tt);
        } finally {
          if (Ue) throw Ue.error;
        }
      }
      var it = new Uint8Array(nt), ot = 0;
      try {
        for (var at = __values$k(Ze), st = at.next(); !st.done; st = at.next()) {
          var rt = st.value, ut = rt.getCodewords(), lt = rt.getNumDataCodewords();
          this.correctErrors(ut, lt);
          for (var dt = 0; dt < lt; dt++)
            it[ot++] = ut[dt];
        }
      } catch (At) {
        Ge = { error: At };
      } finally {
        try {
          st && !st.done && (Xe = at.return) && Xe.call(at);
        } finally {
          if (Ge) throw Ge.error;
        }
      }
      return DecodedBitStreamParser$1.decode(it, Ke, $e, Qe);
    }, me.prototype.correctErrors = function(ue, Qe) {
      var Ue = new Int32Array(ue);
      try {
        this.rsDecoder.decode(Ue, ue.length - Qe);
      } catch {
        throw new ChecksumException();
      }
      for (var He = 0; He < Qe; He++)
        ue[He] = /*(byte) */
        Ue[He];
    }, me;
  }()
), __extends$n = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), AlignmentPattern = (
  /** @class */
  function(me) {
    __extends$n(ue, me);
    function ue(Qe, Ue, He) {
      var Ge = me.call(this, Qe, Ue) || this;
      return Ge.estimatedModuleSize = He, Ge;
    }
    return ue.prototype.aboutEquals = function(Qe, Ue, He) {
      if (Math.abs(Ue - this.getY()) <= Qe && Math.abs(He - this.getX()) <= Qe) {
        var Ge = Math.abs(Qe - this.estimatedModuleSize);
        return Ge <= 1 || Ge <= this.estimatedModuleSize;
      }
      return !1;
    }, ue.prototype.combineEstimate = function(Qe, Ue, He) {
      var Ge = (this.getX() + Ue) / 2, Xe = (this.getY() + Qe) / 2, Ke = (this.estimatedModuleSize + He) / 2;
      return new ue(Ge, Xe, Ke);
    }, ue;
  }(ResultPoint)
), __values$j = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, AlignmentPatternFinder = (
  /** @class */
  function() {
    function me(ue, Qe, Ue, He, Ge, Xe, Ke) {
      this.image = ue, this.startX = Qe, this.startY = Ue, this.width = He, this.height = Ge, this.moduleSize = Xe, this.resultPointCallback = Ke, this.possibleCenters = [], this.crossCheckStateCount = new Int32Array(3);
    }
    return me.prototype.find = function() {
      for (var ue = this.startX, Qe = this.height, Ue = this.width, He = ue + Ue, Ge = this.startY + Qe / 2, Xe = new Int32Array(3), Ke = this.image, $e = 0; $e < Qe; $e++) {
        var Je = Ge + ($e & 1 ? -Math.floor(($e + 1) / 2) : Math.floor(($e + 1) / 2));
        Xe[0] = 0, Xe[1] = 0, Xe[2] = 0;
        for (var Ze = ue; Ze < He && !Ke.get(Ze, Je); )
          Ze++;
        for (var nt = 0; Ze < He; ) {
          if (Ke.get(Ze, Je))
            if (nt === 1)
              Xe[1]++;
            else if (nt === 2) {
              if (this.foundPatternCross(Xe)) {
                var tt = this.handlePossibleCenter(Xe, Je, Ze);
                if (tt !== null)
                  return tt;
              }
              Xe[0] = Xe[2], Xe[1] = 1, Xe[2] = 0, nt = 1;
            } else
              Xe[++nt]++;
          else
            nt === 1 && nt++, Xe[nt]++;
          Ze++;
        }
        if (this.foundPatternCross(Xe)) {
          var tt = this.handlePossibleCenter(Xe, Je, He);
          if (tt !== null)
            return tt;
        }
      }
      if (this.possibleCenters.length !== 0)
        return this.possibleCenters[0];
      throw new NotFoundException();
    }, me.centerFromEnd = function(ue, Qe) {
      return Qe - ue[2] - ue[1] / 2;
    }, me.prototype.foundPatternCross = function(ue) {
      for (var Qe = this.moduleSize, Ue = Qe / 2, He = 0; He < 3; He++)
        if (Math.abs(Qe - ue[He]) >= Ue)
          return !1;
      return !0;
    }, me.prototype.crossCheckVertical = function(ue, Qe, Ue, He) {
      var Ge = this.image, Xe = Ge.getHeight(), Ke = this.crossCheckStateCount;
      Ke[0] = 0, Ke[1] = 0, Ke[2] = 0;
      for (var $e = ue; $e >= 0 && Ge.get(Qe, $e) && Ke[1] <= Ue; )
        Ke[1]++, $e--;
      if ($e < 0 || Ke[1] > Ue)
        return NaN;
      for (; $e >= 0 && !Ge.get(Qe, $e) && Ke[0] <= Ue; )
        Ke[0]++, $e--;
      if (Ke[0] > Ue)
        return NaN;
      for ($e = ue + 1; $e < Xe && Ge.get(Qe, $e) && Ke[1] <= Ue; )
        Ke[1]++, $e++;
      if ($e === Xe || Ke[1] > Ue)
        return NaN;
      for (; $e < Xe && !Ge.get(Qe, $e) && Ke[2] <= Ue; )
        Ke[2]++, $e++;
      if (Ke[2] > Ue)
        return NaN;
      var Je = Ke[0] + Ke[1] + Ke[2];
      return 5 * Math.abs(Je - He) >= 2 * He ? NaN : this.foundPatternCross(Ke) ? me.centerFromEnd(Ke, $e) : NaN;
    }, me.prototype.handlePossibleCenter = function(ue, Qe, Ue) {
      var He, Ge, Xe = ue[0] + ue[1] + ue[2], Ke = me.centerFromEnd(ue, Ue), $e = this.crossCheckVertical(
        Qe,
        /*(int) */
        Ke,
        2 * ue[1],
        Xe
      );
      if (!isNaN($e)) {
        var Je = (ue[0] + ue[1] + ue[2]) / 3;
        try {
          for (var Ze = __values$j(this.possibleCenters), nt = Ze.next(); !nt.done; nt = Ze.next()) {
            var tt = nt.value;
            if (tt.aboutEquals(Je, $e, Ke))
              return tt.combineEstimate($e, Ke, Je);
          }
        } catch (rt) {
          He = { error: rt };
        } finally {
          try {
            nt && !nt.done && (Ge = Ze.return) && Ge.call(Ze);
          } finally {
            if (He) throw He.error;
          }
        }
        var et = new AlignmentPattern(Ke, $e, Je);
        this.possibleCenters.push(et), this.resultPointCallback !== null && this.resultPointCallback !== void 0 && this.resultPointCallback.foundPossibleResultPoint(et);
      }
      return null;
    }, me;
  }()
), __extends$m = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), FinderPattern = (
  /** @class */
  function(me) {
    __extends$m(ue, me);
    function ue(Qe, Ue, He, Ge) {
      var Xe = me.call(this, Qe, Ue) || this;
      return Xe.estimatedModuleSize = He, Xe.count = Ge, Ge === void 0 && (Xe.count = 1), Xe;
    }
    return ue.prototype.getEstimatedModuleSize = function() {
      return this.estimatedModuleSize;
    }, ue.prototype.getCount = function() {
      return this.count;
    }, ue.prototype.aboutEquals = function(Qe, Ue, He) {
      if (Math.abs(Ue - this.getY()) <= Qe && Math.abs(He - this.getX()) <= Qe) {
        var Ge = Math.abs(Qe - this.estimatedModuleSize);
        return Ge <= 1 || Ge <= this.estimatedModuleSize;
      }
      return !1;
    }, ue.prototype.combineEstimate = function(Qe, Ue, He) {
      var Ge = this.count + 1, Xe = (this.count * this.getX() + Ue) / Ge, Ke = (this.count * this.getY() + Qe) / Ge, $e = (this.count * this.estimatedModuleSize + He) / Ge;
      return new ue(Xe, Ke, $e, Ge);
    }, ue;
  }(ResultPoint)
), FinderPatternInfo = (
  /** @class */
  function() {
    function me(ue) {
      this.bottomLeft = ue[0], this.topLeft = ue[1], this.topRight = ue[2];
    }
    return me.prototype.getBottomLeft = function() {
      return this.bottomLeft;
    }, me.prototype.getTopLeft = function() {
      return this.topLeft;
    }, me.prototype.getTopRight = function() {
      return this.topRight;
    }, me;
  }()
), __values$i = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, FinderPatternFinder = (
  /** @class */
  function() {
    function me(ue, Qe) {
      this.image = ue, this.resultPointCallback = Qe, this.possibleCenters = [], this.crossCheckStateCount = new Int32Array(5), this.resultPointCallback = Qe;
    }
    return me.prototype.getImage = function() {
      return this.image;
    }, me.prototype.getPossibleCenters = function() {
      return this.possibleCenters;
    }, me.prototype.find = function(ue) {
      var Qe = ue != null && ue.get(DecodeHintType$1.TRY_HARDER) !== void 0, Ue = ue != null && ue.get(DecodeHintType$1.PURE_BARCODE) !== void 0, He = this.image, Ge = He.getHeight(), Xe = He.getWidth(), Ke = Math.floor(3 * Ge / (4 * me.MAX_MODULES));
      (Ke < me.MIN_SKIP || Qe) && (Ke = me.MIN_SKIP);
      for (var $e = !1, Je = new Int32Array(5), Ze = Ke - 1; Ze < Ge && !$e; Ze += Ke) {
        Je[0] = 0, Je[1] = 0, Je[2] = 0, Je[3] = 0, Je[4] = 0;
        for (var nt = 0, tt = 0; tt < Xe; tt++)
          if (He.get(tt, Ze))
            (nt & 1) === 1 && nt++, Je[nt]++;
          else if (nt & 1)
            Je[nt]++;
          else if (nt === 4)
            if (me.foundPatternCross(Je)) {
              var et = this.handlePossibleCenter(Je, Ze, tt, Ue);
              if (et === !0)
                if (Ke = 2, this.hasSkipped === !0)
                  $e = this.haveMultiplyConfirmedCenters();
                else {
                  var rt = this.findRowSkip();
                  rt > Je[2] && (Ze += rt - Je[2] - Ke, tt = Xe - 1);
                }
              else {
                Je[0] = Je[2], Je[1] = Je[3], Je[2] = Je[4], Je[3] = 1, Je[4] = 0, nt = 3;
                continue;
              }
              nt = 0, Je[0] = 0, Je[1] = 0, Je[2] = 0, Je[3] = 0, Je[4] = 0;
            } else
              Je[0] = Je[2], Je[1] = Je[3], Je[2] = Je[4], Je[3] = 1, Je[4] = 0, nt = 3;
          else
            Je[++nt]++;
        if (me.foundPatternCross(Je)) {
          var et = this.handlePossibleCenter(Je, Ze, Xe, Ue);
          et === !0 && (Ke = Je[0], this.hasSkipped && ($e = this.haveMultiplyConfirmedCenters()));
        }
      }
      var it = this.selectBestPatterns();
      return ResultPoint.orderBestPatterns(it), new FinderPatternInfo(it);
    }, me.centerFromEnd = function(ue, Qe) {
      return Qe - ue[4] - ue[3] - ue[2] / 2;
    }, me.foundPatternCross = function(ue) {
      for (var Qe = 0, Ue = 0; Ue < 5; Ue++) {
        var He = ue[Ue];
        if (He === 0)
          return !1;
        Qe += He;
      }
      if (Qe < 7)
        return !1;
      var Ge = Qe / 7, Xe = Ge / 2;
      return Math.abs(Ge - ue[0]) < Xe && Math.abs(Ge - ue[1]) < Xe && Math.abs(3 * Ge - ue[2]) < 3 * Xe && Math.abs(Ge - ue[3]) < Xe && Math.abs(Ge - ue[4]) < Xe;
    }, me.prototype.getCrossCheckStateCount = function() {
      var ue = this.crossCheckStateCount;
      return ue[0] = 0, ue[1] = 0, ue[2] = 0, ue[3] = 0, ue[4] = 0, ue;
    }, me.prototype.crossCheckDiagonal = function(ue, Qe, Ue, He) {
      for (var Ge = this.getCrossCheckStateCount(), Xe = 0, Ke = this.image; ue >= Xe && Qe >= Xe && Ke.get(Qe - Xe, ue - Xe); )
        Ge[2]++, Xe++;
      if (ue < Xe || Qe < Xe)
        return !1;
      for (; ue >= Xe && Qe >= Xe && !Ke.get(Qe - Xe, ue - Xe) && Ge[1] <= Ue; )
        Ge[1]++, Xe++;
      if (ue < Xe || Qe < Xe || Ge[1] > Ue)
        return !1;
      for (; ue >= Xe && Qe >= Xe && Ke.get(Qe - Xe, ue - Xe) && Ge[0] <= Ue; )
        Ge[0]++, Xe++;
      if (Ge[0] > Ue)
        return !1;
      var $e = Ke.getHeight(), Je = Ke.getWidth();
      for (Xe = 1; ue + Xe < $e && Qe + Xe < Je && Ke.get(Qe + Xe, ue + Xe); )
        Ge[2]++, Xe++;
      if (ue + Xe >= $e || Qe + Xe >= Je)
        return !1;
      for (; ue + Xe < $e && Qe + Xe < Je && !Ke.get(Qe + Xe, ue + Xe) && Ge[3] < Ue; )
        Ge[3]++, Xe++;
      if (ue + Xe >= $e || Qe + Xe >= Je || Ge[3] >= Ue)
        return !1;
      for (; ue + Xe < $e && Qe + Xe < Je && Ke.get(Qe + Xe, ue + Xe) && Ge[4] < Ue; )
        Ge[4]++, Xe++;
      if (Ge[4] >= Ue)
        return !1;
      var Ze = Ge[0] + Ge[1] + Ge[2] + Ge[3] + Ge[4];
      return Math.abs(Ze - He) < 2 * He && me.foundPatternCross(Ge);
    }, me.prototype.crossCheckVertical = function(ue, Qe, Ue, He) {
      for (var Ge = this.image, Xe = Ge.getHeight(), Ke = this.getCrossCheckStateCount(), $e = ue; $e >= 0 && Ge.get(Qe, $e); )
        Ke[2]++, $e--;
      if ($e < 0)
        return NaN;
      for (; $e >= 0 && !Ge.get(Qe, $e) && Ke[1] <= Ue; )
        Ke[1]++, $e--;
      if ($e < 0 || Ke[1] > Ue)
        return NaN;
      for (; $e >= 0 && Ge.get(Qe, $e) && Ke[0] <= Ue; )
        Ke[0]++, $e--;
      if (Ke[0] > Ue)
        return NaN;
      for ($e = ue + 1; $e < Xe && Ge.get(Qe, $e); )
        Ke[2]++, $e++;
      if ($e === Xe)
        return NaN;
      for (; $e < Xe && !Ge.get(Qe, $e) && Ke[3] < Ue; )
        Ke[3]++, $e++;
      if ($e === Xe || Ke[3] >= Ue)
        return NaN;
      for (; $e < Xe && Ge.get(Qe, $e) && Ke[4] < Ue; )
        Ke[4]++, $e++;
      if (Ke[4] >= Ue)
        return NaN;
      var Je = Ke[0] + Ke[1] + Ke[2] + Ke[3] + Ke[4];
      return 5 * Math.abs(Je - He) >= 2 * He ? NaN : me.foundPatternCross(Ke) ? me.centerFromEnd(Ke, $e) : NaN;
    }, me.prototype.crossCheckHorizontal = function(ue, Qe, Ue, He) {
      for (var Ge = this.image, Xe = Ge.getWidth(), Ke = this.getCrossCheckStateCount(), $e = ue; $e >= 0 && Ge.get($e, Qe); )
        Ke[2]++, $e--;
      if ($e < 0)
        return NaN;
      for (; $e >= 0 && !Ge.get($e, Qe) && Ke[1] <= Ue; )
        Ke[1]++, $e--;
      if ($e < 0 || Ke[1] > Ue)
        return NaN;
      for (; $e >= 0 && Ge.get($e, Qe) && Ke[0] <= Ue; )
        Ke[0]++, $e--;
      if (Ke[0] > Ue)
        return NaN;
      for ($e = ue + 1; $e < Xe && Ge.get($e, Qe); )
        Ke[2]++, $e++;
      if ($e === Xe)
        return NaN;
      for (; $e < Xe && !Ge.get($e, Qe) && Ke[3] < Ue; )
        Ke[3]++, $e++;
      if ($e === Xe || Ke[3] >= Ue)
        return NaN;
      for (; $e < Xe && Ge.get($e, Qe) && Ke[4] < Ue; )
        Ke[4]++, $e++;
      if (Ke[4] >= Ue)
        return NaN;
      var Je = Ke[0] + Ke[1] + Ke[2] + Ke[3] + Ke[4];
      return 5 * Math.abs(Je - He) >= He ? NaN : me.foundPatternCross(Ke) ? me.centerFromEnd(Ke, $e) : NaN;
    }, me.prototype.handlePossibleCenter = function(ue, Qe, Ue, He) {
      var Ge = ue[0] + ue[1] + ue[2] + ue[3] + ue[4], Xe = me.centerFromEnd(ue, Ue), Ke = this.crossCheckVertical(
        Qe,
        /*(int) */
        Math.floor(Xe),
        ue[2],
        Ge
      );
      if (!isNaN(Ke) && (Xe = this.crossCheckHorizontal(
        /*(int) */
        Math.floor(Xe),
        /*(int) */
        Math.floor(Ke),
        ue[2],
        Ge
      ), !isNaN(Xe) && (!He || this.crossCheckDiagonal(
        /*(int) */
        Math.floor(Ke),
        /*(int) */
        Math.floor(Xe),
        ue[2],
        Ge
      )))) {
        for (var $e = Ge / 7, Je = !1, Ze = this.possibleCenters, nt = 0, tt = Ze.length; nt < tt; nt++) {
          var et = Ze[nt];
          if (et.aboutEquals($e, Ke, Xe)) {
            Ze[nt] = et.combineEstimate(Ke, Xe, $e), Je = !0;
            break;
          }
        }
        if (!Je) {
          var rt = new FinderPattern(Xe, Ke, $e);
          Ze.push(rt), this.resultPointCallback !== null && this.resultPointCallback !== void 0 && this.resultPointCallback.foundPossibleResultPoint(rt);
        }
        return !0;
      }
      return !1;
    }, me.prototype.findRowSkip = function() {
      var ue, Qe, Ue = this.possibleCenters.length;
      if (Ue <= 1)
        return 0;
      var He = null;
      try {
        for (var Ge = __values$i(this.possibleCenters), Xe = Ge.next(); !Xe.done; Xe = Ge.next()) {
          var Ke = Xe.value;
          if (Ke.getCount() >= me.CENTER_QUORUM)
            if (He == null)
              He = Ke;
            else
              return this.hasSkipped = !0, /*(int) */
              Math.floor((Math.abs(He.getX() - Ke.getX()) - Math.abs(He.getY() - Ke.getY())) / 2);
        }
      } catch ($e) {
        ue = { error: $e };
      } finally {
        try {
          Xe && !Xe.done && (Qe = Ge.return) && Qe.call(Ge);
        } finally {
          if (ue) throw ue.error;
        }
      }
      return 0;
    }, me.prototype.haveMultiplyConfirmedCenters = function() {
      var ue, Qe, Ue, He, Ge = 0, Xe = 0, Ke = this.possibleCenters.length;
      try {
        for (var $e = __values$i(this.possibleCenters), Je = $e.next(); !Je.done; Je = $e.next()) {
          var Ze = Je.value;
          Ze.getCount() >= me.CENTER_QUORUM && (Ge++, Xe += Ze.getEstimatedModuleSize());
        }
      } catch (it) {
        ue = { error: it };
      } finally {
        try {
          Je && !Je.done && (Qe = $e.return) && Qe.call($e);
        } finally {
          if (ue) throw ue.error;
        }
      }
      if (Ge < 3)
        return !1;
      var nt = Xe / Ke, tt = 0;
      try {
        for (var et = __values$i(this.possibleCenters), rt = et.next(); !rt.done; rt = et.next()) {
          var Ze = rt.value;
          tt += Math.abs(Ze.getEstimatedModuleSize() - nt);
        }
      } catch (it) {
        Ue = { error: it };
      } finally {
        try {
          rt && !rt.done && (He = et.return) && He.call(et);
        } finally {
          if (Ue) throw Ue.error;
        }
      }
      return tt <= 0.05 * Xe;
    }, me.prototype.selectBestPatterns = function() {
      var ue, Qe, Ue, He, Ge = this.possibleCenters.length;
      if (Ge < 3)
        throw new NotFoundException();
      var Xe = this.possibleCenters, Ke;
      if (Ge > 3) {
        var $e = 0, Je = 0;
        try {
          for (var Ze = __values$i(this.possibleCenters), nt = Ze.next(); !nt.done; nt = Ze.next()) {
            var tt = nt.value, et = tt.getEstimatedModuleSize();
            $e += et, Je += et * et;
          }
        } catch (dt) {
          ue = { error: dt };
        } finally {
          try {
            nt && !nt.done && (Qe = Ze.return) && Qe.call(Ze);
          } finally {
            if (ue) throw ue.error;
          }
        }
        Ke = $e / Ge;
        var rt = Math.sqrt(Je / Ge - Ke * Ke);
        Xe.sort(
          /**
           * <p>Orders by furthest from average</p>
           */
          // FurthestFromAverageComparator implements Comparator<FinderPattern>
          function(dt, At) {
            var pt = Math.abs(At.getEstimatedModuleSize() - Ke), gt = Math.abs(dt.getEstimatedModuleSize() - Ke);
            return pt < gt ? -1 : pt > gt ? 1 : 0;
          }
        );
        for (var it = Math.max(0.2 * Ke, rt), ot = 0; ot < Xe.length && Xe.length > 3; ot++) {
          var at = Xe[ot];
          Math.abs(at.getEstimatedModuleSize() - Ke) > it && (Xe.splice(ot, 1), ot--);
        }
      }
      if (Xe.length > 3) {
        var $e = 0;
        try {
          for (var st = __values$i(Xe), ut = st.next(); !ut.done; ut = st.next()) {
            var lt = ut.value;
            $e += lt.getEstimatedModuleSize();
          }
        } catch (At) {
          Ue = { error: At };
        } finally {
          try {
            ut && !ut.done && (He = st.return) && He.call(st);
          } finally {
            if (Ue) throw Ue.error;
          }
        }
        Ke = $e / Xe.length, Xe.sort(
          /**
           * <p>Orders by {@link FinderPattern#getCount()}, descending.</p>
           */
          // CenterComparator implements Comparator<FinderPattern>
          function(At, pt) {
            if (pt.getCount() === At.getCount()) {
              var gt = Math.abs(pt.getEstimatedModuleSize() - Ke), wt = Math.abs(At.getEstimatedModuleSize() - Ke);
              return gt < wt ? 1 : gt > wt ? -1 : 0;
            } else
              return pt.getCount() - At.getCount();
          }
        ), Xe.splice(3);
      }
      return [
        Xe[0],
        Xe[1],
        Xe[2]
      ];
    }, me.CENTER_QUORUM = 2, me.MIN_SKIP = 3, me.MAX_MODULES = 57, me;
  }()
), Detector$1 = (
  /** @class */
  function() {
    function me(ue) {
      this.image = ue;
    }
    return me.prototype.getImage = function() {
      return this.image;
    }, me.prototype.getResultPointCallback = function() {
      return this.resultPointCallback;
    }, me.prototype.detect = function(ue) {
      this.resultPointCallback = ue == null ? null : (
        /*(ResultPointCallback) */
        ue.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK)
      );
      var Qe = new FinderPatternFinder(this.image, this.resultPointCallback), Ue = Qe.find(ue);
      return this.processFinderPatternInfo(Ue);
    }, me.prototype.processFinderPatternInfo = function(ue) {
      var Qe = ue.getTopLeft(), Ue = ue.getTopRight(), He = ue.getBottomLeft(), Ge = this.calculateModuleSize(Qe, Ue, He);
      if (Ge < 1)
        throw new NotFoundException("No pattern found in proccess finder.");
      var Xe = me.computeDimension(Qe, Ue, He, Ge), Ke = Version.getProvisionalVersionForDimension(Xe), $e = Ke.getDimensionForVersion() - 7, Je = null;
      if (Ke.getAlignmentPatternCenters().length > 0)
        for (var Ze = Ue.getX() - Qe.getX() + He.getX(), nt = Ue.getY() - Qe.getY() + He.getY(), tt = 1 - 3 / $e, et = (
          /*(int) */
          Math.floor(Qe.getX() + tt * (Ze - Qe.getX()))
        ), rt = (
          /*(int) */
          Math.floor(Qe.getY() + tt * (nt - Qe.getY()))
        ), it = 4; it <= 16; it <<= 1)
          try {
            Je = this.findAlignmentInRegion(Ge, et, rt, it);
            break;
          } catch (ut) {
            if (!(ut instanceof NotFoundException))
              throw ut;
          }
      var ot = me.createTransform(Qe, Ue, He, Je, Xe), at = me.sampleGrid(this.image, ot, Xe), st;
      return Je === null ? st = [He, Qe, Ue] : st = [He, Qe, Ue, Je], new DetectorResult(at, st);
    }, me.createTransform = function(ue, Qe, Ue, He, Ge) {
      var Xe = Ge - 3.5, Ke, $e, Je, Ze;
      return He !== null ? (Ke = He.getX(), $e = He.getY(), Je = Xe - 3, Ze = Je) : (Ke = Qe.getX() - ue.getX() + Ue.getX(), $e = Qe.getY() - ue.getY() + Ue.getY(), Je = Xe, Ze = Xe), PerspectiveTransform.quadrilateralToQuadrilateral(3.5, 3.5, Xe, 3.5, Je, Ze, 3.5, Xe, ue.getX(), ue.getY(), Qe.getX(), Qe.getY(), Ke, $e, Ue.getX(), Ue.getY());
    }, me.sampleGrid = function(ue, Qe, Ue) {
      var He = GridSamplerInstance.getInstance();
      return He.sampleGridWithTransform(ue, Ue, Ue, Qe);
    }, me.computeDimension = function(ue, Qe, Ue, He) {
      var Ge = MathUtils.round(ResultPoint.distance(ue, Qe) / He), Xe = MathUtils.round(ResultPoint.distance(ue, Ue) / He), Ke = Math.floor((Ge + Xe) / 2) + 7;
      switch (Ke & 3) {
        case 0:
          Ke++;
          break;
        case 2:
          Ke--;
          break;
        case 3:
          throw new NotFoundException("Dimensions could be not found.");
      }
      return Ke;
    }, me.prototype.calculateModuleSize = function(ue, Qe, Ue) {
      return (this.calculateModuleSizeOneWay(ue, Qe) + this.calculateModuleSizeOneWay(ue, Ue)) / 2;
    }, me.prototype.calculateModuleSizeOneWay = function(ue, Qe) {
      var Ue = this.sizeOfBlackWhiteBlackRunBothWays(
        /*(int) */
        Math.floor(ue.getX()),
        /*(int) */
        Math.floor(ue.getY()),
        /*(int) */
        Math.floor(Qe.getX()),
        /*(int) */
        Math.floor(Qe.getY())
      ), He = this.sizeOfBlackWhiteBlackRunBothWays(
        /*(int) */
        Math.floor(Qe.getX()),
        /*(int) */
        Math.floor(Qe.getY()),
        /*(int) */
        Math.floor(ue.getX()),
        /*(int) */
        Math.floor(ue.getY())
      );
      return isNaN(Ue) ? He / 7 : isNaN(He) ? Ue / 7 : (Ue + He) / 14;
    }, me.prototype.sizeOfBlackWhiteBlackRunBothWays = function(ue, Qe, Ue, He) {
      var Ge = this.sizeOfBlackWhiteBlackRun(ue, Qe, Ue, He), Xe = 1, Ke = ue - (Ue - ue);
      Ke < 0 ? (Xe = ue / /*(float) */
      (ue - Ke), Ke = 0) : Ke >= this.image.getWidth() && (Xe = (this.image.getWidth() - 1 - ue) / /*(float) */
      (Ke - ue), Ke = this.image.getWidth() - 1);
      var $e = (
        /*(int) */
        Math.floor(Qe - (He - Qe) * Xe)
      );
      return Xe = 1, $e < 0 ? (Xe = Qe / /*(float) */
      (Qe - $e), $e = 0) : $e >= this.image.getHeight() && (Xe = (this.image.getHeight() - 1 - Qe) / /*(float) */
      ($e - Qe), $e = this.image.getHeight() - 1), Ke = /*(int) */
      Math.floor(ue + (Ke - ue) * Xe), Ge += this.sizeOfBlackWhiteBlackRun(ue, Qe, Ke, $e), Ge - 1;
    }, me.prototype.sizeOfBlackWhiteBlackRun = function(ue, Qe, Ue, He) {
      var Ge = Math.abs(He - Qe) > Math.abs(Ue - ue);
      if (Ge) {
        var Xe = ue;
        ue = Qe, Qe = Xe, Xe = Ue, Ue = He, He = Xe;
      }
      for (var Ke = Math.abs(Ue - ue), $e = Math.abs(He - Qe), Je = -Ke / 2, Ze = ue < Ue ? 1 : -1, nt = Qe < He ? 1 : -1, tt = 0, et = Ue + Ze, rt = ue, it = Qe; rt !== et; rt += Ze) {
        var ot = Ge ? it : rt, at = Ge ? rt : it;
        if (tt === 1 === this.image.get(ot, at)) {
          if (tt === 2)
            return MathUtils.distance(rt, it, ue, Qe);
          tt++;
        }
        if (Je += $e, Je > 0) {
          if (it === He)
            break;
          it += nt, Je -= Ke;
        }
      }
      return tt === 2 ? MathUtils.distance(Ue + Ze, He, ue, Qe) : NaN;
    }, me.prototype.findAlignmentInRegion = function(ue, Qe, Ue, He) {
      var Ge = (
        /*(int) */
        Math.floor(He * ue)
      ), Xe = Math.max(0, Qe - Ge), Ke = Math.min(this.image.getWidth() - 1, Qe + Ge);
      if (Ke - Xe < ue * 3)
        throw new NotFoundException("Alignment top exceeds estimated module size.");
      var $e = Math.max(0, Ue - Ge), Je = Math.min(this.image.getHeight() - 1, Ue + Ge);
      if (Je - $e < ue * 3)
        throw new NotFoundException("Alignment bottom exceeds estimated module size.");
      var Ze = new AlignmentPatternFinder(this.image, Xe, $e, Ke - Xe, Je - $e, ue, this.resultPointCallback);
      return Ze.find();
    }, me;
  }()
), QRCodeReader = (
  /** @class */
  function() {
    function me() {
      this.decoder = new Decoder();
    }
    return me.prototype.getDecoder = function() {
      return this.decoder;
    }, me.prototype.decode = function(ue, Qe) {
      var Ue, He;
      if (Qe != null && Qe.get(DecodeHintType$1.PURE_BARCODE) !== void 0) {
        var Ge = me.extractPureBits(ue.getBlackMatrix());
        Ue = this.decoder.decodeBitMatrix(Ge, Qe), He = me.NO_POINTS;
      } else {
        var Xe = new Detector$1(ue.getBlackMatrix()).detect(Qe);
        Ue = this.decoder.decodeBitMatrix(Xe.getBits(), Qe), He = Xe.getPoints();
      }
      Ue.getOther() instanceof QRCodeDecoderMetaData && Ue.getOther().applyMirroredCorrection(He);
      var Ke = new Result(Ue.getText(), Ue.getRawBytes(), void 0, He, BarcodeFormat$1.QR_CODE, void 0), $e = Ue.getByteSegments();
      $e !== null && Ke.putMetadata(ResultMetadataType$1.BYTE_SEGMENTS, $e);
      var Je = Ue.getECLevel();
      return Je !== null && Ke.putMetadata(ResultMetadataType$1.ERROR_CORRECTION_LEVEL, Je), Ue.hasStructuredAppend() && (Ke.putMetadata(ResultMetadataType$1.STRUCTURED_APPEND_SEQUENCE, Ue.getStructuredAppendSequenceNumber()), Ke.putMetadata(ResultMetadataType$1.STRUCTURED_APPEND_PARITY, Ue.getStructuredAppendParity())), Ke;
    }, me.prototype.reset = function() {
    }, me.extractPureBits = function(ue) {
      var Qe = ue.getTopLeftOnBit(), Ue = ue.getBottomRightOnBit();
      if (Qe === null || Ue === null)
        throw new NotFoundException();
      var He = this.moduleSize(Qe, ue), Ge = Qe[1], Xe = Ue[1], Ke = Qe[0], $e = Ue[0];
      if (Ke >= $e || Ge >= Xe)
        throw new NotFoundException();
      if (Xe - Ge !== $e - Ke && ($e = Ke + (Xe - Ge), $e >= ue.getWidth()))
        throw new NotFoundException();
      var Je = Math.round(($e - Ke + 1) / He), Ze = Math.round((Xe - Ge + 1) / He);
      if (Je <= 0 || Ze <= 0)
        throw new NotFoundException();
      if (Ze !== Je)
        throw new NotFoundException();
      var nt = (
        /*(int) */
        Math.floor(He / 2)
      );
      Ge += nt, Ke += nt;
      var tt = Ke + /*(int) */
      Math.floor((Je - 1) * He) - $e;
      if (tt > 0) {
        if (tt > nt)
          throw new NotFoundException();
        Ke -= tt;
      }
      var et = Ge + /*(int) */
      Math.floor((Ze - 1) * He) - Xe;
      if (et > 0) {
        if (et > nt)
          throw new NotFoundException();
        Ge -= et;
      }
      for (var rt = new BitMatrix(Je, Ze), it = 0; it < Ze; it++)
        for (var ot = Ge + /*(int) */
        Math.floor(it * He), at = 0; at < Je; at++)
          ue.get(Ke + /*(int) */
          Math.floor(at * He), ot) && rt.set(at, it);
      return rt;
    }, me.moduleSize = function(ue, Qe) {
      for (var Ue = Qe.getHeight(), He = Qe.getWidth(), Ge = ue[0], Xe = ue[1], Ke = !0, $e = 0; Ge < He && Xe < Ue; ) {
        if (Ke !== Qe.get(Ge, Xe)) {
          if (++$e === 5)
            break;
          Ke = !Ke;
        }
        Ge++, Xe++;
      }
      if (Ge === He || Xe === Ue)
        throw new NotFoundException();
      return (Ge - ue[0]) / 7;
    }, me.NO_POINTS = new Array(), me;
  }()
), __values$h = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, PDF417Common = (
  /** @class */
  function() {
    function me() {
    }
    return me.prototype.PDF417Common = function() {
    }, me.getBitCountSum = function(ue) {
      return MathUtils.sum(ue);
    }, me.toIntArray = function(ue) {
      var Qe, Ue;
      if (ue == null || !ue.length)
        return me.EMPTY_INT_ARRAY;
      var He = new Int32Array(ue.length), Ge = 0;
      try {
        for (var Xe = __values$h(ue), Ke = Xe.next(); !Ke.done; Ke = Xe.next()) {
          var $e = Ke.value;
          He[Ge++] = $e;
        }
      } catch (Je) {
        Qe = { error: Je };
      } finally {
        try {
          Ke && !Ke.done && (Ue = Xe.return) && Ue.call(Xe);
        } finally {
          if (Qe) throw Qe.error;
        }
      }
      return He;
    }, me.getCodeword = function(ue) {
      var Qe = Arrays.binarySearch(me.SYMBOL_TABLE, ue & 262143);
      return Qe < 0 ? -1 : (me.CODEWORD_TABLE[Qe] - 1) % me.NUMBER_OF_CODEWORDS;
    }, me.NUMBER_OF_CODEWORDS = 929, me.MAX_CODEWORDS_IN_BARCODE = me.NUMBER_OF_CODEWORDS - 1, me.MIN_ROWS_IN_BARCODE = 3, me.MAX_ROWS_IN_BARCODE = 90, me.MODULES_IN_CODEWORD = 17, me.MODULES_IN_STOP_PATTERN = 18, me.BARS_IN_MODULE = 8, me.EMPTY_INT_ARRAY = new Int32Array([]), me.SYMBOL_TABLE = Int32Array.from([
      66142,
      66170,
      66206,
      66236,
      66290,
      66292,
      66350,
      66382,
      66396,
      66454,
      66470,
      66476,
      66594,
      66600,
      66614,
      66626,
      66628,
      66632,
      66640,
      66654,
      66662,
      66668,
      66682,
      66690,
      66718,
      66720,
      66748,
      66758,
      66776,
      66798,
      66802,
      66804,
      66820,
      66824,
      66832,
      66846,
      66848,
      66876,
      66880,
      66936,
      66950,
      66956,
      66968,
      66992,
      67006,
      67022,
      67036,
      67042,
      67044,
      67048,
      67062,
      67118,
      67150,
      67164,
      67214,
      67228,
      67256,
      67294,
      67322,
      67350,
      67366,
      67372,
      67398,
      67404,
      67416,
      67438,
      67474,
      67476,
      67490,
      67492,
      67496,
      67510,
      67618,
      67624,
      67650,
      67656,
      67664,
      67678,
      67686,
      67692,
      67706,
      67714,
      67716,
      67728,
      67742,
      67744,
      67772,
      67782,
      67788,
      67800,
      67822,
      67826,
      67828,
      67842,
      67848,
      67870,
      67872,
      67900,
      67904,
      67960,
      67974,
      67992,
      68016,
      68030,
      68046,
      68060,
      68066,
      68068,
      68072,
      68086,
      68104,
      68112,
      68126,
      68128,
      68156,
      68160,
      68216,
      68336,
      68358,
      68364,
      68376,
      68400,
      68414,
      68448,
      68476,
      68494,
      68508,
      68536,
      68546,
      68548,
      68552,
      68560,
      68574,
      68582,
      68588,
      68654,
      68686,
      68700,
      68706,
      68708,
      68712,
      68726,
      68750,
      68764,
      68792,
      68802,
      68804,
      68808,
      68816,
      68830,
      68838,
      68844,
      68858,
      68878,
      68892,
      68920,
      68976,
      68990,
      68994,
      68996,
      69e3,
      69008,
      69022,
      69024,
      69052,
      69062,
      69068,
      69080,
      69102,
      69106,
      69108,
      69142,
      69158,
      69164,
      69190,
      69208,
      69230,
      69254,
      69260,
      69272,
      69296,
      69310,
      69326,
      69340,
      69386,
      69394,
      69396,
      69410,
      69416,
      69430,
      69442,
      69444,
      69448,
      69456,
      69470,
      69478,
      69484,
      69554,
      69556,
      69666,
      69672,
      69698,
      69704,
      69712,
      69726,
      69754,
      69762,
      69764,
      69776,
      69790,
      69792,
      69820,
      69830,
      69836,
      69848,
      69870,
      69874,
      69876,
      69890,
      69918,
      69920,
      69948,
      69952,
      70008,
      70022,
      70040,
      70064,
      70078,
      70094,
      70108,
      70114,
      70116,
      70120,
      70134,
      70152,
      70174,
      70176,
      70264,
      70384,
      70412,
      70448,
      70462,
      70496,
      70524,
      70542,
      70556,
      70584,
      70594,
      70600,
      70608,
      70622,
      70630,
      70636,
      70664,
      70672,
      70686,
      70688,
      70716,
      70720,
      70776,
      70896,
      71136,
      71180,
      71192,
      71216,
      71230,
      71264,
      71292,
      71360,
      71416,
      71452,
      71480,
      71536,
      71550,
      71554,
      71556,
      71560,
      71568,
      71582,
      71584,
      71612,
      71622,
      71628,
      71640,
      71662,
      71726,
      71732,
      71758,
      71772,
      71778,
      71780,
      71784,
      71798,
      71822,
      71836,
      71864,
      71874,
      71880,
      71888,
      71902,
      71910,
      71916,
      71930,
      71950,
      71964,
      71992,
      72048,
      72062,
      72066,
      72068,
      72080,
      72094,
      72096,
      72124,
      72134,
      72140,
      72152,
      72174,
      72178,
      72180,
      72206,
      72220,
      72248,
      72304,
      72318,
      72416,
      72444,
      72456,
      72464,
      72478,
      72480,
      72508,
      72512,
      72568,
      72588,
      72600,
      72624,
      72638,
      72654,
      72668,
      72674,
      72676,
      72680,
      72694,
      72726,
      72742,
      72748,
      72774,
      72780,
      72792,
      72814,
      72838,
      72856,
      72880,
      72894,
      72910,
      72924,
      72930,
      72932,
      72936,
      72950,
      72966,
      72972,
      72984,
      73008,
      73022,
      73056,
      73084,
      73102,
      73116,
      73144,
      73156,
      73160,
      73168,
      73182,
      73190,
      73196,
      73210,
      73226,
      73234,
      73236,
      73250,
      73252,
      73256,
      73270,
      73282,
      73284,
      73296,
      73310,
      73318,
      73324,
      73346,
      73348,
      73352,
      73360,
      73374,
      73376,
      73404,
      73414,
      73420,
      73432,
      73454,
      73498,
      73518,
      73522,
      73524,
      73550,
      73564,
      73570,
      73572,
      73576,
      73590,
      73800,
      73822,
      73858,
      73860,
      73872,
      73886,
      73888,
      73916,
      73944,
      73970,
      73972,
      73992,
      74014,
      74016,
      74044,
      74048,
      74104,
      74118,
      74136,
      74160,
      74174,
      74210,
      74212,
      74216,
      74230,
      74244,
      74256,
      74270,
      74272,
      74360,
      74480,
      74502,
      74508,
      74544,
      74558,
      74592,
      74620,
      74638,
      74652,
      74680,
      74690,
      74696,
      74704,
      74726,
      74732,
      74782,
      74784,
      74812,
      74992,
      75232,
      75288,
      75326,
      75360,
      75388,
      75456,
      75512,
      75576,
      75632,
      75646,
      75650,
      75652,
      75664,
      75678,
      75680,
      75708,
      75718,
      75724,
      75736,
      75758,
      75808,
      75836,
      75840,
      75896,
      76016,
      76256,
      76736,
      76824,
      76848,
      76862,
      76896,
      76924,
      76992,
      77048,
      77296,
      77340,
      77368,
      77424,
      77438,
      77536,
      77564,
      77572,
      77576,
      77584,
      77600,
      77628,
      77632,
      77688,
      77702,
      77708,
      77720,
      77744,
      77758,
      77774,
      77788,
      77870,
      77902,
      77916,
      77922,
      77928,
      77966,
      77980,
      78008,
      78018,
      78024,
      78032,
      78046,
      78060,
      78074,
      78094,
      78136,
      78192,
      78206,
      78210,
      78212,
      78224,
      78238,
      78240,
      78268,
      78278,
      78284,
      78296,
      78322,
      78324,
      78350,
      78364,
      78448,
      78462,
      78560,
      78588,
      78600,
      78622,
      78624,
      78652,
      78656,
      78712,
      78726,
      78744,
      78768,
      78782,
      78798,
      78812,
      78818,
      78820,
      78824,
      78838,
      78862,
      78876,
      78904,
      78960,
      78974,
      79072,
      79100,
      79296,
      79352,
      79368,
      79376,
      79390,
      79392,
      79420,
      79424,
      79480,
      79600,
      79628,
      79640,
      79664,
      79678,
      79712,
      79740,
      79772,
      79800,
      79810,
      79812,
      79816,
      79824,
      79838,
      79846,
      79852,
      79894,
      79910,
      79916,
      79942,
      79948,
      79960,
      79982,
      79988,
      80006,
      80024,
      80048,
      80062,
      80078,
      80092,
      80098,
      80100,
      80104,
      80134,
      80140,
      80176,
      80190,
      80224,
      80252,
      80270,
      80284,
      80312,
      80328,
      80336,
      80350,
      80358,
      80364,
      80378,
      80390,
      80396,
      80408,
      80432,
      80446,
      80480,
      80508,
      80576,
      80632,
      80654,
      80668,
      80696,
      80752,
      80766,
      80776,
      80784,
      80798,
      80800,
      80828,
      80844,
      80856,
      80878,
      80882,
      80884,
      80914,
      80916,
      80930,
      80932,
      80936,
      80950,
      80962,
      80968,
      80976,
      80990,
      80998,
      81004,
      81026,
      81028,
      81040,
      81054,
      81056,
      81084,
      81094,
      81100,
      81112,
      81134,
      81154,
      81156,
      81160,
      81168,
      81182,
      81184,
      81212,
      81216,
      81272,
      81286,
      81292,
      81304,
      81328,
      81342,
      81358,
      81372,
      81380,
      81384,
      81398,
      81434,
      81454,
      81458,
      81460,
      81486,
      81500,
      81506,
      81508,
      81512,
      81526,
      81550,
      81564,
      81592,
      81602,
      81604,
      81608,
      81616,
      81630,
      81638,
      81644,
      81702,
      81708,
      81722,
      81734,
      81740,
      81752,
      81774,
      81778,
      81780,
      82050,
      82078,
      82080,
      82108,
      82180,
      82184,
      82192,
      82206,
      82208,
      82236,
      82240,
      82296,
      82316,
      82328,
      82352,
      82366,
      82402,
      82404,
      82408,
      82440,
      82448,
      82462,
      82464,
      82492,
      82496,
      82552,
      82672,
      82694,
      82700,
      82712,
      82736,
      82750,
      82784,
      82812,
      82830,
      82882,
      82884,
      82888,
      82896,
      82918,
      82924,
      82952,
      82960,
      82974,
      82976,
      83004,
      83008,
      83064,
      83184,
      83424,
      83468,
      83480,
      83504,
      83518,
      83552,
      83580,
      83648,
      83704,
      83740,
      83768,
      83824,
      83838,
      83842,
      83844,
      83848,
      83856,
      83872,
      83900,
      83910,
      83916,
      83928,
      83950,
      83984,
      84e3,
      84028,
      84032,
      84088,
      84208,
      84448,
      84928,
      85040,
      85054,
      85088,
      85116,
      85184,
      85240,
      85488,
      85560,
      85616,
      85630,
      85728,
      85756,
      85764,
      85768,
      85776,
      85790,
      85792,
      85820,
      85824,
      85880,
      85894,
      85900,
      85912,
      85936,
      85966,
      85980,
      86048,
      86080,
      86136,
      86256,
      86496,
      86976,
      88160,
      88188,
      88256,
      88312,
      88560,
      89056,
      89200,
      89214,
      89312,
      89340,
      89536,
      89592,
      89608,
      89616,
      89632,
      89664,
      89720,
      89840,
      89868,
      89880,
      89904,
      89952,
      89980,
      89998,
      90012,
      90040,
      90190,
      90204,
      90254,
      90268,
      90296,
      90306,
      90308,
      90312,
      90334,
      90382,
      90396,
      90424,
      90480,
      90494,
      90500,
      90504,
      90512,
      90526,
      90528,
      90556,
      90566,
      90572,
      90584,
      90610,
      90612,
      90638,
      90652,
      90680,
      90736,
      90750,
      90848,
      90876,
      90884,
      90888,
      90896,
      90910,
      90912,
      90940,
      90944,
      91e3,
      91014,
      91020,
      91032,
      91056,
      91070,
      91086,
      91100,
      91106,
      91108,
      91112,
      91126,
      91150,
      91164,
      91192,
      91248,
      91262,
      91360,
      91388,
      91584,
      91640,
      91664,
      91678,
      91680,
      91708,
      91712,
      91768,
      91888,
      91928,
      91952,
      91966,
      92e3,
      92028,
      92046,
      92060,
      92088,
      92098,
      92100,
      92104,
      92112,
      92126,
      92134,
      92140,
      92188,
      92216,
      92272,
      92384,
      92412,
      92608,
      92664,
      93168,
      93200,
      93214,
      93216,
      93244,
      93248,
      93304,
      93424,
      93664,
      93720,
      93744,
      93758,
      93792,
      93820,
      93888,
      93944,
      93980,
      94008,
      94064,
      94078,
      94084,
      94088,
      94096,
      94110,
      94112,
      94140,
      94150,
      94156,
      94168,
      94246,
      94252,
      94278,
      94284,
      94296,
      94318,
      94342,
      94348,
      94360,
      94384,
      94398,
      94414,
      94428,
      94440,
      94470,
      94476,
      94488,
      94512,
      94526,
      94560,
      94588,
      94606,
      94620,
      94648,
      94658,
      94660,
      94664,
      94672,
      94686,
      94694,
      94700,
      94714,
      94726,
      94732,
      94744,
      94768,
      94782,
      94816,
      94844,
      94912,
      94968,
      94990,
      95004,
      95032,
      95088,
      95102,
      95112,
      95120,
      95134,
      95136,
      95164,
      95180,
      95192,
      95214,
      95218,
      95220,
      95244,
      95256,
      95280,
      95294,
      95328,
      95356,
      95424,
      95480,
      95728,
      95758,
      95772,
      95800,
      95856,
      95870,
      95968,
      95996,
      96008,
      96016,
      96030,
      96032,
      96060,
      96064,
      96120,
      96152,
      96176,
      96190,
      96220,
      96226,
      96228,
      96232,
      96290,
      96292,
      96296,
      96310,
      96322,
      96324,
      96328,
      96336,
      96350,
      96358,
      96364,
      96386,
      96388,
      96392,
      96400,
      96414,
      96416,
      96444,
      96454,
      96460,
      96472,
      96494,
      96498,
      96500,
      96514,
      96516,
      96520,
      96528,
      96542,
      96544,
      96572,
      96576,
      96632,
      96646,
      96652,
      96664,
      96688,
      96702,
      96718,
      96732,
      96738,
      96740,
      96744,
      96758,
      96772,
      96776,
      96784,
      96798,
      96800,
      96828,
      96832,
      96888,
      97008,
      97030,
      97036,
      97048,
      97072,
      97086,
      97120,
      97148,
      97166,
      97180,
      97208,
      97220,
      97224,
      97232,
      97246,
      97254,
      97260,
      97326,
      97330,
      97332,
      97358,
      97372,
      97378,
      97380,
      97384,
      97398,
      97422,
      97436,
      97464,
      97474,
      97476,
      97480,
      97488,
      97502,
      97510,
      97516,
      97550,
      97564,
      97592,
      97648,
      97666,
      97668,
      97672,
      97680,
      97694,
      97696,
      97724,
      97734,
      97740,
      97752,
      97774,
      97830,
      97836,
      97850,
      97862,
      97868,
      97880,
      97902,
      97906,
      97908,
      97926,
      97932,
      97944,
      97968,
      97998,
      98012,
      98018,
      98020,
      98024,
      98038,
      98618,
      98674,
      98676,
      98838,
      98854,
      98874,
      98892,
      98904,
      98926,
      98930,
      98932,
      98968,
      99006,
      99042,
      99044,
      99048,
      99062,
      99166,
      99194,
      99246,
      99286,
      99350,
      99366,
      99372,
      99386,
      99398,
      99416,
      99438,
      99442,
      99444,
      99462,
      99504,
      99518,
      99534,
      99548,
      99554,
      99556,
      99560,
      99574,
      99590,
      99596,
      99608,
      99632,
      99646,
      99680,
      99708,
      99726,
      99740,
      99768,
      99778,
      99780,
      99784,
      99792,
      99806,
      99814,
      99820,
      99834,
      99858,
      99860,
      99874,
      99880,
      99894,
      99906,
      99920,
      99934,
      99962,
      99970,
      99972,
      99976,
      99984,
      99998,
      1e5,
      100028,
      100038,
      100044,
      100056,
      100078,
      100082,
      100084,
      100142,
      100174,
      100188,
      100246,
      100262,
      100268,
      100306,
      100308,
      100390,
      100396,
      100410,
      100422,
      100428,
      100440,
      100462,
      100466,
      100468,
      100486,
      100504,
      100528,
      100542,
      100558,
      100572,
      100578,
      100580,
      100584,
      100598,
      100620,
      100656,
      100670,
      100704,
      100732,
      100750,
      100792,
      100802,
      100808,
      100816,
      100830,
      100838,
      100844,
      100858,
      100888,
      100912,
      100926,
      100960,
      100988,
      101056,
      101112,
      101148,
      101176,
      101232,
      101246,
      101250,
      101252,
      101256,
      101264,
      101278,
      101280,
      101308,
      101318,
      101324,
      101336,
      101358,
      101362,
      101364,
      101410,
      101412,
      101416,
      101430,
      101442,
      101448,
      101456,
      101470,
      101478,
      101498,
      101506,
      101508,
      101520,
      101534,
      101536,
      101564,
      101580,
      101618,
      101620,
      101636,
      101640,
      101648,
      101662,
      101664,
      101692,
      101696,
      101752,
      101766,
      101784,
      101838,
      101858,
      101860,
      101864,
      101934,
      101938,
      101940,
      101966,
      101980,
      101986,
      101988,
      101992,
      102030,
      102044,
      102072,
      102082,
      102084,
      102088,
      102096,
      102138,
      102166,
      102182,
      102188,
      102214,
      102220,
      102232,
      102254,
      102282,
      102290,
      102292,
      102306,
      102308,
      102312,
      102326,
      102444,
      102458,
      102470,
      102476,
      102488,
      102514,
      102516,
      102534,
      102552,
      102576,
      102590,
      102606,
      102620,
      102626,
      102632,
      102646,
      102662,
      102668,
      102704,
      102718,
      102752,
      102780,
      102798,
      102812,
      102840,
      102850,
      102856,
      102864,
      102878,
      102886,
      102892,
      102906,
      102936,
      102974,
      103008,
      103036,
      103104,
      103160,
      103224,
      103280,
      103294,
      103298,
      103300,
      103312,
      103326,
      103328,
      103356,
      103366,
      103372,
      103384,
      103406,
      103410,
      103412,
      103472,
      103486,
      103520,
      103548,
      103616,
      103672,
      103920,
      103992,
      104048,
      104062,
      104160,
      104188,
      104194,
      104196,
      104200,
      104208,
      104224,
      104252,
      104256,
      104312,
      104326,
      104332,
      104344,
      104368,
      104382,
      104398,
      104412,
      104418,
      104420,
      104424,
      104482,
      104484,
      104514,
      104520,
      104528,
      104542,
      104550,
      104570,
      104578,
      104580,
      104592,
      104606,
      104608,
      104636,
      104652,
      104690,
      104692,
      104706,
      104712,
      104734,
      104736,
      104764,
      104768,
      104824,
      104838,
      104856,
      104910,
      104930,
      104932,
      104936,
      104968,
      104976,
      104990,
      104992,
      105020,
      105024,
      105080,
      105200,
      105240,
      105278,
      105312,
      105372,
      105410,
      105412,
      105416,
      105424,
      105446,
      105518,
      105524,
      105550,
      105564,
      105570,
      105572,
      105576,
      105614,
      105628,
      105656,
      105666,
      105672,
      105680,
      105702,
      105722,
      105742,
      105756,
      105784,
      105840,
      105854,
      105858,
      105860,
      105864,
      105872,
      105888,
      105932,
      105970,
      105972,
      106006,
      106022,
      106028,
      106054,
      106060,
      106072,
      106100,
      106118,
      106124,
      106136,
      106160,
      106174,
      106190,
      106210,
      106212,
      106216,
      106250,
      106258,
      106260,
      106274,
      106276,
      106280,
      106306,
      106308,
      106312,
      106320,
      106334,
      106348,
      106394,
      106414,
      106418,
      106420,
      106566,
      106572,
      106610,
      106612,
      106630,
      106636,
      106648,
      106672,
      106686,
      106722,
      106724,
      106728,
      106742,
      106758,
      106764,
      106776,
      106800,
      106814,
      106848,
      106876,
      106894,
      106908,
      106936,
      106946,
      106948,
      106952,
      106960,
      106974,
      106982,
      106988,
      107032,
      107056,
      107070,
      107104,
      107132,
      107200,
      107256,
      107292,
      107320,
      107376,
      107390,
      107394,
      107396,
      107400,
      107408,
      107422,
      107424,
      107452,
      107462,
      107468,
      107480,
      107502,
      107506,
      107508,
      107544,
      107568,
      107582,
      107616,
      107644,
      107712,
      107768,
      108016,
      108060,
      108088,
      108144,
      108158,
      108256,
      108284,
      108290,
      108292,
      108296,
      108304,
      108318,
      108320,
      108348,
      108352,
      108408,
      108422,
      108428,
      108440,
      108464,
      108478,
      108494,
      108508,
      108514,
      108516,
      108520,
      108592,
      108640,
      108668,
      108736,
      108792,
      109040,
      109536,
      109680,
      109694,
      109792,
      109820,
      110016,
      110072,
      110084,
      110088,
      110096,
      110112,
      110140,
      110144,
      110200,
      110320,
      110342,
      110348,
      110360,
      110384,
      110398,
      110432,
      110460,
      110478,
      110492,
      110520,
      110532,
      110536,
      110544,
      110558,
      110658,
      110686,
      110714,
      110722,
      110724,
      110728,
      110736,
      110750,
      110752,
      110780,
      110796,
      110834,
      110836,
      110850,
      110852,
      110856,
      110864,
      110878,
      110880,
      110908,
      110912,
      110968,
      110982,
      111e3,
      111054,
      111074,
      111076,
      111080,
      111108,
      111112,
      111120,
      111134,
      111136,
      111164,
      111168,
      111224,
      111344,
      111372,
      111422,
      111456,
      111516,
      111554,
      111556,
      111560,
      111568,
      111590,
      111632,
      111646,
      111648,
      111676,
      111680,
      111736,
      111856,
      112096,
      112152,
      112224,
      112252,
      112320,
      112440,
      112514,
      112516,
      112520,
      112528,
      112542,
      112544,
      112588,
      112686,
      112718,
      112732,
      112782,
      112796,
      112824,
      112834,
      112836,
      112840,
      112848,
      112870,
      112890,
      112910,
      112924,
      112952,
      113008,
      113022,
      113026,
      113028,
      113032,
      113040,
      113054,
      113056,
      113100,
      113138,
      113140,
      113166,
      113180,
      113208,
      113264,
      113278,
      113376,
      113404,
      113416,
      113424,
      113440,
      113468,
      113472,
      113560,
      113614,
      113634,
      113636,
      113640,
      113686,
      113702,
      113708,
      113734,
      113740,
      113752,
      113778,
      113780,
      113798,
      113804,
      113816,
      113840,
      113854,
      113870,
      113890,
      113892,
      113896,
      113926,
      113932,
      113944,
      113968,
      113982,
      114016,
      114044,
      114076,
      114114,
      114116,
      114120,
      114128,
      114150,
      114170,
      114194,
      114196,
      114210,
      114212,
      114216,
      114242,
      114244,
      114248,
      114256,
      114270,
      114278,
      114306,
      114308,
      114312,
      114320,
      114334,
      114336,
      114364,
      114380,
      114420,
      114458,
      114478,
      114482,
      114484,
      114510,
      114524,
      114530,
      114532,
      114536,
      114842,
      114866,
      114868,
      114970,
      114994,
      114996,
      115042,
      115044,
      115048,
      115062,
      115130,
      115226,
      115250,
      115252,
      115278,
      115292,
      115298,
      115300,
      115304,
      115318,
      115342,
      115394,
      115396,
      115400,
      115408,
      115422,
      115430,
      115436,
      115450,
      115478,
      115494,
      115514,
      115526,
      115532,
      115570,
      115572,
      115738,
      115758,
      115762,
      115764,
      115790,
      115804,
      115810,
      115812,
      115816,
      115830,
      115854,
      115868,
      115896,
      115906,
      115912,
      115920,
      115934,
      115942,
      115948,
      115962,
      115996,
      116024,
      116080,
      116094,
      116098,
      116100,
      116104,
      116112,
      116126,
      116128,
      116156,
      116166,
      116172,
      116184,
      116206,
      116210,
      116212,
      116246,
      116262,
      116268,
      116282,
      116294,
      116300,
      116312,
      116334,
      116338,
      116340,
      116358,
      116364,
      116376,
      116400,
      116414,
      116430,
      116444,
      116450,
      116452,
      116456,
      116498,
      116500,
      116514,
      116520,
      116534,
      116546,
      116548,
      116552,
      116560,
      116574,
      116582,
      116588,
      116602,
      116654,
      116694,
      116714,
      116762,
      116782,
      116786,
      116788,
      116814,
      116828,
      116834,
      116836,
      116840,
      116854,
      116878,
      116892,
      116920,
      116930,
      116936,
      116944,
      116958,
      116966,
      116972,
      116986,
      117006,
      117048,
      117104,
      117118,
      117122,
      117124,
      117136,
      117150,
      117152,
      117180,
      117190,
      117196,
      117208,
      117230,
      117234,
      117236,
      117304,
      117360,
      117374,
      117472,
      117500,
      117506,
      117508,
      117512,
      117520,
      117536,
      117564,
      117568,
      117624,
      117638,
      117644,
      117656,
      117680,
      117694,
      117710,
      117724,
      117730,
      117732,
      117736,
      117750,
      117782,
      117798,
      117804,
      117818,
      117830,
      117848,
      117874,
      117876,
      117894,
      117936,
      117950,
      117966,
      117986,
      117988,
      117992,
      118022,
      118028,
      118040,
      118064,
      118078,
      118112,
      118140,
      118172,
      118210,
      118212,
      118216,
      118224,
      118238,
      118246,
      118266,
      118306,
      118312,
      118338,
      118352,
      118366,
      118374,
      118394,
      118402,
      118404,
      118408,
      118416,
      118430,
      118432,
      118460,
      118476,
      118514,
      118516,
      118574,
      118578,
      118580,
      118606,
      118620,
      118626,
      118628,
      118632,
      118678,
      118694,
      118700,
      118730,
      118738,
      118740,
      118830,
      118834,
      118836,
      118862,
      118876,
      118882,
      118884,
      118888,
      118902,
      118926,
      118940,
      118968,
      118978,
      118980,
      118984,
      118992,
      119006,
      119014,
      119020,
      119034,
      119068,
      119096,
      119152,
      119166,
      119170,
      119172,
      119176,
      119184,
      119198,
      119200,
      119228,
      119238,
      119244,
      119256,
      119278,
      119282,
      119284,
      119324,
      119352,
      119408,
      119422,
      119520,
      119548,
      119554,
      119556,
      119560,
      119568,
      119582,
      119584,
      119612,
      119616,
      119672,
      119686,
      119692,
      119704,
      119728,
      119742,
      119758,
      119772,
      119778,
      119780,
      119784,
      119798,
      119920,
      119934,
      120032,
      120060,
      120256,
      120312,
      120324,
      120328,
      120336,
      120352,
      120384,
      120440,
      120560,
      120582,
      120588,
      120600,
      120624,
      120638,
      120672,
      120700,
      120718,
      120732,
      120760,
      120770,
      120772,
      120776,
      120784,
      120798,
      120806,
      120812,
      120870,
      120876,
      120890,
      120902,
      120908,
      120920,
      120946,
      120948,
      120966,
      120972,
      120984,
      121008,
      121022,
      121038,
      121058,
      121060,
      121064,
      121078,
      121100,
      121112,
      121136,
      121150,
      121184,
      121212,
      121244,
      121282,
      121284,
      121288,
      121296,
      121318,
      121338,
      121356,
      121368,
      121392,
      121406,
      121440,
      121468,
      121536,
      121592,
      121656,
      121730,
      121732,
      121736,
      121744,
      121758,
      121760,
      121804,
      121842,
      121844,
      121890,
      121922,
      121924,
      121928,
      121936,
      121950,
      121958,
      121978,
      121986,
      121988,
      121992,
      122e3,
      122014,
      122016,
      122044,
      122060,
      122098,
      122100,
      122116,
      122120,
      122128,
      122142,
      122144,
      122172,
      122176,
      122232,
      122246,
      122264,
      122318,
      122338,
      122340,
      122344,
      122414,
      122418,
      122420,
      122446,
      122460,
      122466,
      122468,
      122472,
      122510,
      122524,
      122552,
      122562,
      122564,
      122568,
      122576,
      122598,
      122618,
      122646,
      122662,
      122668,
      122694,
      122700,
      122712,
      122738,
      122740,
      122762,
      122770,
      122772,
      122786,
      122788,
      122792,
      123018,
      123026,
      123028,
      123042,
      123044,
      123048,
      123062,
      123098,
      123146,
      123154,
      123156,
      123170,
      123172,
      123176,
      123190,
      123202,
      123204,
      123208,
      123216,
      123238,
      123244,
      123258,
      123290,
      123314,
      123316,
      123402,
      123410,
      123412,
      123426,
      123428,
      123432,
      123446,
      123458,
      123464,
      123472,
      123486,
      123494,
      123500,
      123514,
      123522,
      123524,
      123528,
      123536,
      123552,
      123580,
      123590,
      123596,
      123608,
      123630,
      123634,
      123636,
      123674,
      123698,
      123700,
      123740,
      123746,
      123748,
      123752,
      123834,
      123914,
      123922,
      123924,
      123938,
      123944,
      123958,
      123970,
      123976,
      123984,
      123998,
      124006,
      124012,
      124026,
      124034,
      124036,
      124048,
      124062,
      124064,
      124092,
      124102,
      124108,
      124120,
      124142,
      124146,
      124148,
      124162,
      124164,
      124168,
      124176,
      124190,
      124192,
      124220,
      124224,
      124280,
      124294,
      124300,
      124312,
      124336,
      124350,
      124366,
      124380,
      124386,
      124388,
      124392,
      124406,
      124442,
      124462,
      124466,
      124468,
      124494,
      124508,
      124514,
      124520,
      124558,
      124572,
      124600,
      124610,
      124612,
      124616,
      124624,
      124646,
      124666,
      124694,
      124710,
      124716,
      124730,
      124742,
      124748,
      124760,
      124786,
      124788,
      124818,
      124820,
      124834,
      124836,
      124840,
      124854,
      124946,
      124948,
      124962,
      124964,
      124968,
      124982,
      124994,
      124996,
      125e3,
      125008,
      125022,
      125030,
      125036,
      125050,
      125058,
      125060,
      125064,
      125072,
      125086,
      125088,
      125116,
      125126,
      125132,
      125144,
      125166,
      125170,
      125172,
      125186,
      125188,
      125192,
      125200,
      125216,
      125244,
      125248,
      125304,
      125318,
      125324,
      125336,
      125360,
      125374,
      125390,
      125404,
      125410,
      125412,
      125416,
      125430,
      125444,
      125448,
      125456,
      125472,
      125504,
      125560,
      125680,
      125702,
      125708,
      125720,
      125744,
      125758,
      125792,
      125820,
      125838,
      125852,
      125880,
      125890,
      125892,
      125896,
      125904,
      125918,
      125926,
      125932,
      125978,
      125998,
      126002,
      126004,
      126030,
      126044,
      126050,
      126052,
      126056,
      126094,
      126108,
      126136,
      126146,
      126148,
      126152,
      126160,
      126182,
      126202,
      126222,
      126236,
      126264,
      126320,
      126334,
      126338,
      126340,
      126344,
      126352,
      126366,
      126368,
      126412,
      126450,
      126452,
      126486,
      126502,
      126508,
      126522,
      126534,
      126540,
      126552,
      126574,
      126578,
      126580,
      126598,
      126604,
      126616,
      126640,
      126654,
      126670,
      126684,
      126690,
      126692,
      126696,
      126738,
      126754,
      126756,
      126760,
      126774,
      126786,
      126788,
      126792,
      126800,
      126814,
      126822,
      126828,
      126842,
      126894,
      126898,
      126900,
      126934,
      127126,
      127142,
      127148,
      127162,
      127178,
      127186,
      127188,
      127254,
      127270,
      127276,
      127290,
      127302,
      127308,
      127320,
      127342,
      127346,
      127348,
      127370,
      127378,
      127380,
      127394,
      127396,
      127400,
      127450,
      127510,
      127526,
      127532,
      127546,
      127558,
      127576,
      127598,
      127602,
      127604,
      127622,
      127628,
      127640,
      127664,
      127678,
      127694,
      127708,
      127714,
      127716,
      127720,
      127734,
      127754,
      127762,
      127764,
      127778,
      127784,
      127810,
      127812,
      127816,
      127824,
      127838,
      127846,
      127866,
      127898,
      127918,
      127922,
      127924,
      128022,
      128038,
      128044,
      128058,
      128070,
      128076,
      128088,
      128110,
      128114,
      128116,
      128134,
      128140,
      128152,
      128176,
      128190,
      128206,
      128220,
      128226,
      128228,
      128232,
      128246,
      128262,
      128268,
      128280,
      128304,
      128318,
      128352,
      128380,
      128398,
      128412,
      128440,
      128450,
      128452,
      128456,
      128464,
      128478,
      128486,
      128492,
      128506,
      128522,
      128530,
      128532,
      128546,
      128548,
      128552,
      128566,
      128578,
      128580,
      128584,
      128592,
      128606,
      128614,
      128634,
      128642,
      128644,
      128648,
      128656,
      128670,
      128672,
      128700,
      128716,
      128754,
      128756,
      128794,
      128814,
      128818,
      128820,
      128846,
      128860,
      128866,
      128868,
      128872,
      128886,
      128918,
      128934,
      128940,
      128954,
      128978,
      128980,
      129178,
      129198,
      129202,
      129204,
      129238,
      129258,
      129306,
      129326,
      129330,
      129332,
      129358,
      129372,
      129378,
      129380,
      129384,
      129398,
      129430,
      129446,
      129452,
      129466,
      129482,
      129490,
      129492,
      129562,
      129582,
      129586,
      129588,
      129614,
      129628,
      129634,
      129636,
      129640,
      129654,
      129678,
      129692,
      129720,
      129730,
      129732,
      129736,
      129744,
      129758,
      129766,
      129772,
      129814,
      129830,
      129836,
      129850,
      129862,
      129868,
      129880,
      129902,
      129906,
      129908,
      129930,
      129938,
      129940,
      129954,
      129956,
      129960,
      129974,
      130010
    ]), me.CODEWORD_TABLE = Int32Array.from([
      2627,
      1819,
      2622,
      2621,
      1813,
      1812,
      2729,
      2724,
      2723,
      2779,
      2774,
      2773,
      902,
      896,
      908,
      868,
      865,
      861,
      859,
      2511,
      873,
      871,
      1780,
      835,
      2493,
      825,
      2491,
      842,
      837,
      844,
      1764,
      1762,
      811,
      810,
      809,
      2483,
      807,
      2482,
      806,
      2480,
      815,
      814,
      813,
      812,
      2484,
      817,
      816,
      1745,
      1744,
      1742,
      1746,
      2655,
      2637,
      2635,
      2626,
      2625,
      2623,
      2628,
      1820,
      2752,
      2739,
      2737,
      2728,
      2727,
      2725,
      2730,
      2785,
      2783,
      2778,
      2777,
      2775,
      2780,
      787,
      781,
      747,
      739,
      736,
      2413,
      754,
      752,
      1719,
      692,
      689,
      681,
      2371,
      678,
      2369,
      700,
      697,
      694,
      703,
      1688,
      1686,
      642,
      638,
      2343,
      631,
      2341,
      627,
      2338,
      651,
      646,
      643,
      2345,
      654,
      652,
      1652,
      1650,
      1647,
      1654,
      601,
      599,
      2322,
      596,
      2321,
      594,
      2319,
      2317,
      611,
      610,
      608,
      606,
      2324,
      603,
      2323,
      615,
      614,
      612,
      1617,
      1616,
      1614,
      1612,
      616,
      1619,
      1618,
      2575,
      2538,
      2536,
      905,
      901,
      898,
      909,
      2509,
      2507,
      2504,
      870,
      867,
      864,
      860,
      2512,
      875,
      872,
      1781,
      2490,
      2489,
      2487,
      2485,
      1748,
      836,
      834,
      832,
      830,
      2494,
      827,
      2492,
      843,
      841,
      839,
      845,
      1765,
      1763,
      2701,
      2676,
      2674,
      2653,
      2648,
      2656,
      2634,
      2633,
      2631,
      2629,
      1821,
      2638,
      2636,
      2770,
      2763,
      2761,
      2750,
      2745,
      2753,
      2736,
      2735,
      2733,
      2731,
      1848,
      2740,
      2738,
      2786,
      2784,
      591,
      588,
      576,
      569,
      566,
      2296,
      1590,
      537,
      534,
      526,
      2276,
      522,
      2274,
      545,
      542,
      539,
      548,
      1572,
      1570,
      481,
      2245,
      466,
      2242,
      462,
      2239,
      492,
      485,
      482,
      2249,
      496,
      494,
      1534,
      1531,
      1528,
      1538,
      413,
      2196,
      406,
      2191,
      2188,
      425,
      419,
      2202,
      415,
      2199,
      432,
      430,
      427,
      1472,
      1467,
      1464,
      433,
      1476,
      1474,
      368,
      367,
      2160,
      365,
      2159,
      362,
      2157,
      2155,
      2152,
      378,
      377,
      375,
      2166,
      372,
      2165,
      369,
      2162,
      383,
      381,
      379,
      2168,
      1419,
      1418,
      1416,
      1414,
      385,
      1411,
      384,
      1423,
      1422,
      1420,
      1424,
      2461,
      802,
      2441,
      2439,
      790,
      786,
      783,
      794,
      2409,
      2406,
      2403,
      750,
      742,
      738,
      2414,
      756,
      753,
      1720,
      2367,
      2365,
      2362,
      2359,
      1663,
      693,
      691,
      684,
      2373,
      680,
      2370,
      702,
      699,
      696,
      704,
      1690,
      1687,
      2337,
      2336,
      2334,
      2332,
      1624,
      2329,
      1622,
      640,
      637,
      2344,
      634,
      2342,
      630,
      2340,
      650,
      648,
      645,
      2346,
      655,
      653,
      1653,
      1651,
      1649,
      1655,
      2612,
      2597,
      2595,
      2571,
      2568,
      2565,
      2576,
      2534,
      2529,
      2526,
      1787,
      2540,
      2537,
      907,
      904,
      900,
      910,
      2503,
      2502,
      2500,
      2498,
      1768,
      2495,
      1767,
      2510,
      2508,
      2506,
      869,
      866,
      863,
      2513,
      876,
      874,
      1782,
      2720,
      2713,
      2711,
      2697,
      2694,
      2691,
      2702,
      2672,
      2670,
      2664,
      1828,
      2678,
      2675,
      2647,
      2646,
      2644,
      2642,
      1823,
      2639,
      1822,
      2654,
      2652,
      2650,
      2657,
      2771,
      1855,
      2765,
      2762,
      1850,
      1849,
      2751,
      2749,
      2747,
      2754,
      353,
      2148,
      344,
      342,
      336,
      2142,
      332,
      2140,
      345,
      1375,
      1373,
      306,
      2130,
      299,
      2128,
      295,
      2125,
      319,
      314,
      311,
      2132,
      1354,
      1352,
      1349,
      1356,
      262,
      257,
      2101,
      253,
      2096,
      2093,
      274,
      273,
      267,
      2107,
      263,
      2104,
      280,
      278,
      275,
      1316,
      1311,
      1308,
      1320,
      1318,
      2052,
      202,
      2050,
      2044,
      2040,
      219,
      2063,
      212,
      2060,
      208,
      2055,
      224,
      221,
      2066,
      1260,
      1258,
      1252,
      231,
      1248,
      229,
      1266,
      1264,
      1261,
      1268,
      155,
      1998,
      153,
      1996,
      1994,
      1991,
      1988,
      165,
      164,
      2007,
      162,
      2006,
      159,
      2003,
      2e3,
      172,
      171,
      169,
      2012,
      166,
      2010,
      1186,
      1184,
      1182,
      1179,
      175,
      1176,
      173,
      1192,
      1191,
      1189,
      1187,
      176,
      1194,
      1193,
      2313,
      2307,
      2305,
      592,
      589,
      2294,
      2292,
      2289,
      578,
      572,
      568,
      2297,
      580,
      1591,
      2272,
      2267,
      2264,
      1547,
      538,
      536,
      529,
      2278,
      525,
      2275,
      547,
      544,
      541,
      1574,
      1571,
      2237,
      2235,
      2229,
      1493,
      2225,
      1489,
      478,
      2247,
      470,
      2244,
      465,
      2241,
      493,
      488,
      484,
      2250,
      498,
      495,
      1536,
      1533,
      1530,
      1539,
      2187,
      2186,
      2184,
      2182,
      1432,
      2179,
      1430,
      2176,
      1427,
      414,
      412,
      2197,
      409,
      2195,
      405,
      2193,
      2190,
      426,
      424,
      421,
      2203,
      418,
      2201,
      431,
      429,
      1473,
      1471,
      1469,
      1466,
      434,
      1477,
      1475,
      2478,
      2472,
      2470,
      2459,
      2457,
      2454,
      2462,
      803,
      2437,
      2432,
      2429,
      1726,
      2443,
      2440,
      792,
      789,
      785,
      2401,
      2399,
      2393,
      1702,
      2389,
      1699,
      2411,
      2408,
      2405,
      745,
      741,
      2415,
      758,
      755,
      1721,
      2358,
      2357,
      2355,
      2353,
      1661,
      2350,
      1660,
      2347,
      1657,
      2368,
      2366,
      2364,
      2361,
      1666,
      690,
      687,
      2374,
      683,
      2372,
      701,
      698,
      705,
      1691,
      1689,
      2619,
      2617,
      2610,
      2608,
      2605,
      2613,
      2593,
      2588,
      2585,
      1803,
      2599,
      2596,
      2563,
      2561,
      2555,
      1797,
      2551,
      1795,
      2573,
      2570,
      2567,
      2577,
      2525,
      2524,
      2522,
      2520,
      1786,
      2517,
      1785,
      2514,
      1783,
      2535,
      2533,
      2531,
      2528,
      1788,
      2541,
      2539,
      906,
      903,
      911,
      2721,
      1844,
      2715,
      2712,
      1838,
      1836,
      2699,
      2696,
      2693,
      2703,
      1827,
      1826,
      1824,
      2673,
      2671,
      2669,
      2666,
      1829,
      2679,
      2677,
      1858,
      1857,
      2772,
      1854,
      1853,
      1851,
      1856,
      2766,
      2764,
      143,
      1987,
      139,
      1986,
      135,
      133,
      131,
      1984,
      128,
      1983,
      125,
      1981,
      138,
      137,
      136,
      1985,
      1133,
      1132,
      1130,
      112,
      110,
      1974,
      107,
      1973,
      104,
      1971,
      1969,
      122,
      121,
      119,
      117,
      1977,
      114,
      1976,
      124,
      1115,
      1114,
      1112,
      1110,
      1117,
      1116,
      84,
      83,
      1953,
      81,
      1952,
      78,
      1950,
      1948,
      1945,
      94,
      93,
      91,
      1959,
      88,
      1958,
      85,
      1955,
      99,
      97,
      95,
      1961,
      1086,
      1085,
      1083,
      1081,
      1078,
      100,
      1090,
      1089,
      1087,
      1091,
      49,
      47,
      1917,
      44,
      1915,
      1913,
      1910,
      1907,
      59,
      1926,
      56,
      1925,
      53,
      1922,
      1919,
      66,
      64,
      1931,
      61,
      1929,
      1042,
      1040,
      1038,
      71,
      1035,
      70,
      1032,
      68,
      1048,
      1047,
      1045,
      1043,
      1050,
      1049,
      12,
      10,
      1869,
      1867,
      1864,
      1861,
      21,
      1880,
      19,
      1877,
      1874,
      1871,
      28,
      1888,
      25,
      1886,
      22,
      1883,
      982,
      980,
      977,
      974,
      32,
      30,
      991,
      989,
      987,
      984,
      34,
      995,
      994,
      992,
      2151,
      2150,
      2147,
      2146,
      2144,
      356,
      355,
      354,
      2149,
      2139,
      2138,
      2136,
      2134,
      1359,
      343,
      341,
      338,
      2143,
      335,
      2141,
      348,
      347,
      346,
      1376,
      1374,
      2124,
      2123,
      2121,
      2119,
      1326,
      2116,
      1324,
      310,
      308,
      305,
      2131,
      302,
      2129,
      298,
      2127,
      320,
      318,
      316,
      313,
      2133,
      322,
      321,
      1355,
      1353,
      1351,
      1357,
      2092,
      2091,
      2089,
      2087,
      1276,
      2084,
      1274,
      2081,
      1271,
      259,
      2102,
      256,
      2100,
      252,
      2098,
      2095,
      272,
      269,
      2108,
      266,
      2106,
      281,
      279,
      277,
      1317,
      1315,
      1313,
      1310,
      282,
      1321,
      1319,
      2039,
      2037,
      2035,
      2032,
      1203,
      2029,
      1200,
      1197,
      207,
      2053,
      205,
      2051,
      201,
      2049,
      2046,
      2043,
      220,
      218,
      2064,
      215,
      2062,
      211,
      2059,
      228,
      226,
      223,
      2069,
      1259,
      1257,
      1254,
      232,
      1251,
      230,
      1267,
      1265,
      1263,
      2316,
      2315,
      2312,
      2311,
      2309,
      2314,
      2304,
      2303,
      2301,
      2299,
      1593,
      2308,
      2306,
      590,
      2288,
      2287,
      2285,
      2283,
      1578,
      2280,
      1577,
      2295,
      2293,
      2291,
      579,
      577,
      574,
      571,
      2298,
      582,
      581,
      1592,
      2263,
      2262,
      2260,
      2258,
      1545,
      2255,
      1544,
      2252,
      1541,
      2273,
      2271,
      2269,
      2266,
      1550,
      535,
      532,
      2279,
      528,
      2277,
      546,
      543,
      549,
      1575,
      1573,
      2224,
      2222,
      2220,
      1486,
      2217,
      1485,
      2214,
      1482,
      1479,
      2238,
      2236,
      2234,
      2231,
      1496,
      2228,
      1492,
      480,
      477,
      2248,
      473,
      2246,
      469,
      2243,
      490,
      487,
      2251,
      497,
      1537,
      1535,
      1532,
      2477,
      2476,
      2474,
      2479,
      2469,
      2468,
      2466,
      2464,
      1730,
      2473,
      2471,
      2453,
      2452,
      2450,
      2448,
      1729,
      2445,
      1728,
      2460,
      2458,
      2456,
      2463,
      805,
      804,
      2428,
      2427,
      2425,
      2423,
      1725,
      2420,
      1724,
      2417,
      1722,
      2438,
      2436,
      2434,
      2431,
      1727,
      2444,
      2442,
      793,
      791,
      788,
      795,
      2388,
      2386,
      2384,
      1697,
      2381,
      1696,
      2378,
      1694,
      1692,
      2402,
      2400,
      2398,
      2395,
      1703,
      2392,
      1701,
      2412,
      2410,
      2407,
      751,
      748,
      744,
      2416,
      759,
      757,
      1807,
      2620,
      2618,
      1806,
      1805,
      2611,
      2609,
      2607,
      2614,
      1802,
      1801,
      1799,
      2594,
      2592,
      2590,
      2587,
      1804,
      2600,
      2598,
      1794,
      1793,
      1791,
      1789,
      2564,
      2562,
      2560,
      2557,
      1798,
      2554,
      1796,
      2574,
      2572,
      2569,
      2578,
      1847,
      1846,
      2722,
      1843,
      1842,
      1840,
      1845,
      2716,
      2714,
      1835,
      1834,
      1832,
      1830,
      1839,
      1837,
      2700,
      2698,
      2695,
      2704,
      1817,
      1811,
      1810,
      897,
      862,
      1777,
      829,
      826,
      838,
      1760,
      1758,
      808,
      2481,
      1741,
      1740,
      1738,
      1743,
      2624,
      1818,
      2726,
      2776,
      782,
      740,
      737,
      1715,
      686,
      679,
      695,
      1682,
      1680,
      639,
      628,
      2339,
      647,
      644,
      1645,
      1643,
      1640,
      1648,
      602,
      600,
      597,
      595,
      2320,
      593,
      2318,
      609,
      607,
      604,
      1611,
      1610,
      1608,
      1606,
      613,
      1615,
      1613,
      2328,
      926,
      924,
      892,
      886,
      899,
      857,
      850,
      2505,
      1778,
      824,
      823,
      821,
      819,
      2488,
      818,
      2486,
      833,
      831,
      828,
      840,
      1761,
      1759,
      2649,
      2632,
      2630,
      2746,
      2734,
      2732,
      2782,
      2781,
      570,
      567,
      1587,
      531,
      527,
      523,
      540,
      1566,
      1564,
      476,
      467,
      463,
      2240,
      486,
      483,
      1524,
      1521,
      1518,
      1529,
      411,
      403,
      2192,
      399,
      2189,
      423,
      416,
      1462,
      1457,
      1454,
      428,
      1468,
      1465,
      2210,
      366,
      363,
      2158,
      360,
      2156,
      357,
      2153,
      376,
      373,
      370,
      2163,
      1410,
      1409,
      1407,
      1405,
      382,
      1402,
      380,
      1417,
      1415,
      1412,
      1421,
      2175,
      2174,
      777,
      774,
      771,
      784,
      732,
      725,
      722,
      2404,
      743,
      1716,
      676,
      674,
      668,
      2363,
      665,
      2360,
      685,
      1684,
      1681,
      626,
      624,
      622,
      2335,
      620,
      2333,
      617,
      2330,
      641,
      635,
      649,
      1646,
      1644,
      1642,
      2566,
      928,
      925,
      2530,
      2527,
      894,
      891,
      888,
      2501,
      2499,
      2496,
      858,
      856,
      854,
      851,
      1779,
      2692,
      2668,
      2665,
      2645,
      2643,
      2640,
      2651,
      2768,
      2759,
      2757,
      2744,
      2743,
      2741,
      2748,
      352,
      1382,
      340,
      337,
      333,
      1371,
      1369,
      307,
      300,
      296,
      2126,
      315,
      312,
      1347,
      1342,
      1350,
      261,
      258,
      250,
      2097,
      246,
      2094,
      271,
      268,
      264,
      1306,
      1301,
      1298,
      276,
      1312,
      1309,
      2115,
      203,
      2048,
      195,
      2045,
      191,
      2041,
      213,
      209,
      2056,
      1246,
      1244,
      1238,
      225,
      1234,
      222,
      1256,
      1253,
      1249,
      1262,
      2080,
      2079,
      154,
      1997,
      150,
      1995,
      147,
      1992,
      1989,
      163,
      160,
      2004,
      156,
      2001,
      1175,
      1174,
      1172,
      1170,
      1167,
      170,
      1164,
      167,
      1185,
      1183,
      1180,
      1177,
      174,
      1190,
      1188,
      2025,
      2024,
      2022,
      587,
      586,
      564,
      559,
      556,
      2290,
      573,
      1588,
      520,
      518,
      512,
      2268,
      508,
      2265,
      530,
      1568,
      1565,
      461,
      457,
      2233,
      450,
      2230,
      446,
      2226,
      479,
      471,
      489,
      1526,
      1523,
      1520,
      397,
      395,
      2185,
      392,
      2183,
      389,
      2180,
      2177,
      410,
      2194,
      402,
      422,
      1463,
      1461,
      1459,
      1456,
      1470,
      2455,
      799,
      2433,
      2430,
      779,
      776,
      773,
      2397,
      2394,
      2390,
      734,
      728,
      724,
      746,
      1717,
      2356,
      2354,
      2351,
      2348,
      1658,
      677,
      675,
      673,
      670,
      667,
      688,
      1685,
      1683,
      2606,
      2589,
      2586,
      2559,
      2556,
      2552,
      927,
      2523,
      2521,
      2518,
      2515,
      1784,
      2532,
      895,
      893,
      890,
      2718,
      2709,
      2707,
      2689,
      2687,
      2684,
      2663,
      2662,
      2660,
      2658,
      1825,
      2667,
      2769,
      1852,
      2760,
      2758,
      142,
      141,
      1139,
      1138,
      134,
      132,
      129,
      126,
      1982,
      1129,
      1128,
      1126,
      1131,
      113,
      111,
      108,
      105,
      1972,
      101,
      1970,
      120,
      118,
      115,
      1109,
      1108,
      1106,
      1104,
      123,
      1113,
      1111,
      82,
      79,
      1951,
      75,
      1949,
      72,
      1946,
      92,
      89,
      86,
      1956,
      1077,
      1076,
      1074,
      1072,
      98,
      1069,
      96,
      1084,
      1082,
      1079,
      1088,
      1968,
      1967,
      48,
      45,
      1916,
      42,
      1914,
      39,
      1911,
      1908,
      60,
      57,
      54,
      1923,
      50,
      1920,
      1031,
      1030,
      1028,
      1026,
      67,
      1023,
      65,
      1020,
      62,
      1041,
      1039,
      1036,
      1033,
      69,
      1046,
      1044,
      1944,
      1943,
      1941,
      11,
      9,
      1868,
      7,
      1865,
      1862,
      1859,
      20,
      1878,
      16,
      1875,
      13,
      1872,
      970,
      968,
      966,
      963,
      29,
      960,
      26,
      23,
      983,
      981,
      978,
      975,
      33,
      971,
      31,
      990,
      988,
      985,
      1906,
      1904,
      1902,
      993,
      351,
      2145,
      1383,
      331,
      330,
      328,
      326,
      2137,
      323,
      2135,
      339,
      1372,
      1370,
      294,
      293,
      291,
      289,
      2122,
      286,
      2120,
      283,
      2117,
      309,
      303,
      317,
      1348,
      1346,
      1344,
      245,
      244,
      242,
      2090,
      239,
      2088,
      236,
      2085,
      2082,
      260,
      2099,
      249,
      270,
      1307,
      1305,
      1303,
      1300,
      1314,
      189,
      2038,
      186,
      2036,
      183,
      2033,
      2030,
      2026,
      206,
      198,
      2047,
      194,
      216,
      1247,
      1245,
      1243,
      1240,
      227,
      1237,
      1255,
      2310,
      2302,
      2300,
      2286,
      2284,
      2281,
      565,
      563,
      561,
      558,
      575,
      1589,
      2261,
      2259,
      2256,
      2253,
      1542,
      521,
      519,
      517,
      514,
      2270,
      511,
      533,
      1569,
      1567,
      2223,
      2221,
      2218,
      2215,
      1483,
      2211,
      1480,
      459,
      456,
      453,
      2232,
      449,
      474,
      491,
      1527,
      1525,
      1522,
      2475,
      2467,
      2465,
      2451,
      2449,
      2446,
      801,
      800,
      2426,
      2424,
      2421,
      2418,
      1723,
      2435,
      780,
      778,
      775,
      2387,
      2385,
      2382,
      2379,
      1695,
      2375,
      1693,
      2396,
      735,
      733,
      730,
      727,
      749,
      1718,
      2616,
      2615,
      2604,
      2603,
      2601,
      2584,
      2583,
      2581,
      2579,
      1800,
      2591,
      2550,
      2549,
      2547,
      2545,
      1792,
      2542,
      1790,
      2558,
      929,
      2719,
      1841,
      2710,
      2708,
      1833,
      1831,
      2690,
      2688,
      2686,
      1815,
      1809,
      1808,
      1774,
      1756,
      1754,
      1737,
      1736,
      1734,
      1739,
      1816,
      1711,
      1676,
      1674,
      633,
      629,
      1638,
      1636,
      1633,
      1641,
      598,
      1605,
      1604,
      1602,
      1600,
      605,
      1609,
      1607,
      2327,
      887,
      853,
      1775,
      822,
      820,
      1757,
      1755,
      1584,
      524,
      1560,
      1558,
      468,
      464,
      1514,
      1511,
      1508,
      1519,
      408,
      404,
      400,
      1452,
      1447,
      1444,
      417,
      1458,
      1455,
      2208,
      364,
      361,
      358,
      2154,
      1401,
      1400,
      1398,
      1396,
      374,
      1393,
      371,
      1408,
      1406,
      1403,
      1413,
      2173,
      2172,
      772,
      726,
      723,
      1712,
      672,
      669,
      666,
      682,
      1678,
      1675,
      625,
      623,
      621,
      618,
      2331,
      636,
      632,
      1639,
      1637,
      1635,
      920,
      918,
      884,
      880,
      889,
      849,
      848,
      847,
      846,
      2497,
      855,
      852,
      1776,
      2641,
      2742,
      2787,
      1380,
      334,
      1367,
      1365,
      301,
      297,
      1340,
      1338,
      1335,
      1343,
      255,
      251,
      247,
      1296,
      1291,
      1288,
      265,
      1302,
      1299,
      2113,
      204,
      196,
      192,
      2042,
      1232,
      1230,
      1224,
      214,
      1220,
      210,
      1242,
      1239,
      1235,
      1250,
      2077,
      2075,
      151,
      148,
      1993,
      144,
      1990,
      1163,
      1162,
      1160,
      1158,
      1155,
      161,
      1152,
      157,
      1173,
      1171,
      1168,
      1165,
      168,
      1181,
      1178,
      2021,
      2020,
      2018,
      2023,
      585,
      560,
      557,
      1585,
      516,
      509,
      1562,
      1559,
      458,
      447,
      2227,
      472,
      1516,
      1513,
      1510,
      398,
      396,
      393,
      390,
      2181,
      386,
      2178,
      407,
      1453,
      1451,
      1449,
      1446,
      420,
      1460,
      2209,
      769,
      764,
      720,
      712,
      2391,
      729,
      1713,
      664,
      663,
      661,
      659,
      2352,
      656,
      2349,
      671,
      1679,
      1677,
      2553,
      922,
      919,
      2519,
      2516,
      885,
      883,
      881,
      2685,
      2661,
      2659,
      2767,
      2756,
      2755,
      140,
      1137,
      1136,
      130,
      127,
      1125,
      1124,
      1122,
      1127,
      109,
      106,
      102,
      1103,
      1102,
      1100,
      1098,
      116,
      1107,
      1105,
      1980,
      80,
      76,
      73,
      1947,
      1068,
      1067,
      1065,
      1063,
      90,
      1060,
      87,
      1075,
      1073,
      1070,
      1080,
      1966,
      1965,
      46,
      43,
      40,
      1912,
      36,
      1909,
      1019,
      1018,
      1016,
      1014,
      58,
      1011,
      55,
      1008,
      51,
      1029,
      1027,
      1024,
      1021,
      63,
      1037,
      1034,
      1940,
      1939,
      1937,
      1942,
      8,
      1866,
      4,
      1863,
      1,
      1860,
      956,
      954,
      952,
      949,
      946,
      17,
      14,
      969,
      967,
      964,
      961,
      27,
      957,
      24,
      979,
      976,
      972,
      1901,
      1900,
      1898,
      1896,
      986,
      1905,
      1903,
      350,
      349,
      1381,
      329,
      327,
      324,
      1368,
      1366,
      292,
      290,
      287,
      284,
      2118,
      304,
      1341,
      1339,
      1337,
      1345,
      243,
      240,
      237,
      2086,
      233,
      2083,
      254,
      1297,
      1295,
      1293,
      1290,
      1304,
      2114,
      190,
      187,
      184,
      2034,
      180,
      2031,
      177,
      2027,
      199,
      1233,
      1231,
      1229,
      1226,
      217,
      1223,
      1241,
      2078,
      2076,
      584,
      555,
      554,
      552,
      550,
      2282,
      562,
      1586,
      507,
      506,
      504,
      502,
      2257,
      499,
      2254,
      515,
      1563,
      1561,
      445,
      443,
      441,
      2219,
      438,
      2216,
      435,
      2212,
      460,
      454,
      475,
      1517,
      1515,
      1512,
      2447,
      798,
      797,
      2422,
      2419,
      770,
      768,
      766,
      2383,
      2380,
      2376,
      721,
      719,
      717,
      714,
      731,
      1714,
      2602,
      2582,
      2580,
      2548,
      2546,
      2543,
      923,
      921,
      2717,
      2706,
      2705,
      2683,
      2682,
      2680,
      1771,
      1752,
      1750,
      1733,
      1732,
      1731,
      1735,
      1814,
      1707,
      1670,
      1668,
      1631,
      1629,
      1626,
      1634,
      1599,
      1598,
      1596,
      1594,
      1603,
      1601,
      2326,
      1772,
      1753,
      1751,
      1581,
      1554,
      1552,
      1504,
      1501,
      1498,
      1509,
      1442,
      1437,
      1434,
      401,
      1448,
      1445,
      2206,
      1392,
      1391,
      1389,
      1387,
      1384,
      359,
      1399,
      1397,
      1394,
      1404,
      2171,
      2170,
      1708,
      1672,
      1669,
      619,
      1632,
      1630,
      1628,
      1773,
      1378,
      1363,
      1361,
      1333,
      1328,
      1336,
      1286,
      1281,
      1278,
      248,
      1292,
      1289,
      2111,
      1218,
      1216,
      1210,
      197,
      1206,
      193,
      1228,
      1225,
      1221,
      1236,
      2073,
      2071,
      1151,
      1150,
      1148,
      1146,
      152,
      1143,
      149,
      1140,
      145,
      1161,
      1159,
      1156,
      1153,
      158,
      1169,
      1166,
      2017,
      2016,
      2014,
      2019,
      1582,
      510,
      1556,
      1553,
      452,
      448,
      1506,
      1500,
      394,
      391,
      387,
      1443,
      1441,
      1439,
      1436,
      1450,
      2207,
      765,
      716,
      713,
      1709,
      662,
      660,
      657,
      1673,
      1671,
      916,
      914,
      879,
      878,
      877,
      882,
      1135,
      1134,
      1121,
      1120,
      1118,
      1123,
      1097,
      1096,
      1094,
      1092,
      103,
      1101,
      1099,
      1979,
      1059,
      1058,
      1056,
      1054,
      77,
      1051,
      74,
      1066,
      1064,
      1061,
      1071,
      1964,
      1963,
      1007,
      1006,
      1004,
      1002,
      999,
      41,
      996,
      37,
      1017,
      1015,
      1012,
      1009,
      52,
      1025,
      1022,
      1936,
      1935,
      1933,
      1938,
      942,
      940,
      938,
      935,
      932,
      5,
      2,
      955,
      953,
      950,
      947,
      18,
      943,
      15,
      965,
      962,
      958,
      1895,
      1894,
      1892,
      1890,
      973,
      1899,
      1897,
      1379,
      325,
      1364,
      1362,
      288,
      285,
      1334,
      1332,
      1330,
      241,
      238,
      234,
      1287,
      1285,
      1283,
      1280,
      1294,
      2112,
      188,
      185,
      181,
      178,
      2028,
      1219,
      1217,
      1215,
      1212,
      200,
      1209,
      1227,
      2074,
      2072,
      583,
      553,
      551,
      1583,
      505,
      503,
      500,
      513,
      1557,
      1555,
      444,
      442,
      439,
      436,
      2213,
      455,
      451,
      1507,
      1505,
      1502,
      796,
      763,
      762,
      760,
      767,
      711,
      710,
      708,
      706,
      2377,
      718,
      715,
      1710,
      2544,
      917,
      915,
      2681,
      1627,
      1597,
      1595,
      2325,
      1769,
      1749,
      1747,
      1499,
      1438,
      1435,
      2204,
      1390,
      1388,
      1385,
      1395,
      2169,
      2167,
      1704,
      1665,
      1662,
      1625,
      1623,
      1620,
      1770,
      1329,
      1282,
      1279,
      2109,
      1214,
      1207,
      1222,
      2068,
      2065,
      1149,
      1147,
      1144,
      1141,
      146,
      1157,
      1154,
      2013,
      2011,
      2008,
      2015,
      1579,
      1549,
      1546,
      1495,
      1487,
      1433,
      1431,
      1428,
      1425,
      388,
      1440,
      2205,
      1705,
      658,
      1667,
      1664,
      1119,
      1095,
      1093,
      1978,
      1057,
      1055,
      1052,
      1062,
      1962,
      1960,
      1005,
      1003,
      1e3,
      997,
      38,
      1013,
      1010,
      1932,
      1930,
      1927,
      1934,
      941,
      939,
      936,
      933,
      6,
      930,
      3,
      951,
      948,
      944,
      1889,
      1887,
      1884,
      1881,
      959,
      1893,
      1891,
      35,
      1377,
      1360,
      1358,
      1327,
      1325,
      1322,
      1331,
      1277,
      1275,
      1272,
      1269,
      235,
      1284,
      2110,
      1205,
      1204,
      1201,
      1198,
      182,
      1195,
      179,
      1213,
      2070,
      2067,
      1580,
      501,
      1551,
      1548,
      440,
      437,
      1497,
      1494,
      1490,
      1503,
      761,
      709,
      707,
      1706,
      913,
      912,
      2198,
      1386,
      2164,
      2161,
      1621,
      1766,
      2103,
      1208,
      2058,
      2054,
      1145,
      1142,
      2005,
      2002,
      1999,
      2009,
      1488,
      1429,
      1426,
      2200,
      1698,
      1659,
      1656,
      1975,
      1053,
      1957,
      1954,
      1001,
      998,
      1924,
      1921,
      1918,
      1928,
      937,
      934,
      931,
      1879,
      1876,
      1873,
      1870,
      945,
      1885,
      1882,
      1323,
      1273,
      1270,
      2105,
      1202,
      1199,
      1196,
      1211,
      2061,
      2057,
      1576,
      1543,
      1540,
      1484,
      1481,
      1478,
      1491,
      1700
    ]), me;
  }()
), PDF417DetectorResult = (
  /** @class */
  function() {
    function me(ue, Qe) {
      this.bits = ue, this.points = Qe;
    }
    return me.prototype.getBits = function() {
      return this.bits;
    }, me.prototype.getPoints = function() {
      return this.points;
    }, me;
  }()
), __values$g = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Detector = (
  /** @class */
  function() {
    function me() {
    }
    return me.detectMultiple = function(ue, Qe, Ue) {
      var He = ue.getBlackMatrix(), Ge = me.detect(Ue, He);
      return Ge.length || (He = He.clone(), He.rotate180(), Ge = me.detect(Ue, He)), new PDF417DetectorResult(He, Ge);
    }, me.detect = function(ue, Qe) {
      for (var Ue, He, Ge = new Array(), Xe = 0, Ke = 0, $e = !1; Xe < Qe.getHeight(); ) {
        var Je = me.findVertices(Qe, Xe, Ke);
        if (Je[0] == null && Je[3] == null) {
          if (!$e)
            break;
          $e = !1, Ke = 0;
          try {
            for (var Ze = (Ue = void 0, __values$g(Ge)), nt = Ze.next(); !nt.done; nt = Ze.next()) {
              var tt = nt.value;
              tt[1] != null && (Xe = Math.trunc(Math.max(Xe, tt[1].getY()))), tt[3] != null && (Xe = Math.max(Xe, Math.trunc(tt[3].getY())));
            }
          } catch (et) {
            Ue = { error: et };
          } finally {
            try {
              nt && !nt.done && (He = Ze.return) && He.call(Ze);
            } finally {
              if (Ue) throw Ue.error;
            }
          }
          Xe += me.ROW_STEP;
          continue;
        }
        if ($e = !0, Ge.push(Je), !ue)
          break;
        Je[2] != null ? (Ke = Math.trunc(Je[2].getX()), Xe = Math.trunc(Je[2].getY())) : (Ke = Math.trunc(Je[4].getX()), Xe = Math.trunc(Je[4].getY()));
      }
      return Ge;
    }, me.findVertices = function(ue, Qe, Ue) {
      var He = ue.getHeight(), Ge = ue.getWidth(), Xe = new Array(8);
      return me.copyToResult(Xe, me.findRowsWithPattern(ue, He, Ge, Qe, Ue, me.START_PATTERN), me.INDEXES_START_PATTERN), Xe[4] != null && (Ue = Math.trunc(Xe[4].getX()), Qe = Math.trunc(Xe[4].getY())), me.copyToResult(Xe, me.findRowsWithPattern(ue, He, Ge, Qe, Ue, me.STOP_PATTERN), me.INDEXES_STOP_PATTERN), Xe;
    }, me.copyToResult = function(ue, Qe, Ue) {
      for (var He = 0; He < Ue.length; He++)
        ue[Ue[He]] = Qe[He];
    }, me.findRowsWithPattern = function(ue, Qe, Ue, He, Ge, Xe) {
      for (var Ke = new Array(4), $e = !1, Je = new Int32Array(Xe.length); He < Qe; He += me.ROW_STEP) {
        var Ze = me.findGuardPattern(ue, Ge, He, Ue, !1, Xe, Je);
        if (Ze != null) {
          for (; He > 0; ) {
            var nt = me.findGuardPattern(ue, Ge, --He, Ue, !1, Xe, Je);
            if (nt != null)
              Ze = nt;
            else {
              He++;
              break;
            }
          }
          Ke[0] = new ResultPoint(Ze[0], He), Ke[1] = new ResultPoint(Ze[1], He), $e = !0;
          break;
        }
      }
      var tt = He + 1;
      if ($e) {
        for (var et = 0, nt = Int32Array.from([Math.trunc(Ke[0].getX()), Math.trunc(Ke[1].getX())]); tt < Qe; tt++) {
          var Ze = me.findGuardPattern(ue, nt[0], tt, Ue, !1, Xe, Je);
          if (Ze != null && Math.abs(nt[0] - Ze[0]) < me.MAX_PATTERN_DRIFT && Math.abs(nt[1] - Ze[1]) < me.MAX_PATTERN_DRIFT)
            nt = Ze, et = 0;
          else {
            if (et > me.SKIPPED_ROW_COUNT_MAX)
              break;
            et++;
          }
        }
        tt -= et + 1, Ke[2] = new ResultPoint(nt[0], tt), Ke[3] = new ResultPoint(nt[1], tt);
      }
      return tt - He < me.BARCODE_MIN_HEIGHT && Arrays.fill(Ke, null), Ke;
    }, me.findGuardPattern = function(ue, Qe, Ue, He, Ge, Xe, Ke) {
      Arrays.fillWithin(Ke, 0, Ke.length, 0);
      for (var $e = Qe, Je = 0; ue.get($e, Ue) && $e > 0 && Je++ < me.MAX_PIXEL_DRIFT; )
        $e--;
      for (var Ze = $e, nt = 0, tt = Xe.length, et = Ge; Ze < He; Ze++) {
        var rt = ue.get(Ze, Ue);
        if (rt !== et)
          Ke[nt]++;
        else {
          if (nt === tt - 1) {
            if (me.patternMatchVariance(Ke, Xe, me.MAX_INDIVIDUAL_VARIANCE) < me.MAX_AVG_VARIANCE)
              return new Int32Array([$e, Ze]);
            $e += Ke[0] + Ke[1], System.arraycopy(Ke, 2, Ke, 0, nt - 1), Ke[nt - 1] = 0, Ke[nt] = 0, nt--;
          } else
            nt++;
          Ke[nt] = 1, et = !et;
        }
      }
      return nt === tt - 1 && me.patternMatchVariance(Ke, Xe, me.MAX_INDIVIDUAL_VARIANCE) < me.MAX_AVG_VARIANCE ? new Int32Array([$e, Ze - 1]) : null;
    }, me.patternMatchVariance = function(ue, Qe, Ue) {
      for (var He = ue.length, Ge = 0, Xe = 0, Ke = 0; Ke < He; Ke++)
        Ge += ue[Ke], Xe += Qe[Ke];
      if (Ge < Xe)
        return (
          /*Float.POSITIVE_INFINITY*/
          1 / 0
        );
      var $e = Ge / Xe;
      Ue *= $e;
      for (var Je = 0, Ze = 0; Ze < He; Ze++) {
        var nt = ue[Ze], tt = Qe[Ze] * $e, et = nt > tt ? nt - tt : tt - nt;
        if (et > Ue)
          return (
            /*Float.POSITIVE_INFINITY*/
            1 / 0
          );
        Je += et;
      }
      return Je / Ge;
    }, me.INDEXES_START_PATTERN = Int32Array.from([0, 4, 1, 5]), me.INDEXES_STOP_PATTERN = Int32Array.from([6, 2, 7, 3]), me.MAX_AVG_VARIANCE = 0.42, me.MAX_INDIVIDUAL_VARIANCE = 0.8, me.START_PATTERN = Int32Array.from([8, 1, 1, 1, 1, 1, 1, 3]), me.STOP_PATTERN = Int32Array.from([7, 1, 1, 3, 1, 1, 1, 2, 1]), me.MAX_PIXEL_DRIFT = 3, me.MAX_PATTERN_DRIFT = 5, me.SKIPPED_ROW_COUNT_MAX = 25, me.ROW_STEP = 5, me.BARCODE_MIN_HEIGHT = 10, me;
  }()
), __values$f = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, ModulusPoly = (
  /** @class */
  function() {
    function me(ue, Qe) {
      if (Qe.length === 0)
        throw new IllegalArgumentException();
      this.field = ue;
      var Ue = (
        /*int*/
        Qe.length
      );
      if (Ue > 1 && Qe[0] === 0) {
        for (var He = (
          /*int*/
          1
        ); He < Ue && Qe[He] === 0; )
          He++;
        He === Ue ? this.coefficients = new Int32Array([0]) : (this.coefficients = new Int32Array(Ue - He), System.arraycopy(Qe, He, this.coefficients, 0, this.coefficients.length));
      } else
        this.coefficients = Qe;
    }
    return me.prototype.getCoefficients = function() {
      return this.coefficients;
    }, me.prototype.getDegree = function() {
      return this.coefficients.length - 1;
    }, me.prototype.isZero = function() {
      return this.coefficients[0] === 0;
    }, me.prototype.getCoefficient = function(ue) {
      return this.coefficients[this.coefficients.length - 1 - ue];
    }, me.prototype.evaluateAt = function(ue) {
      var Qe, Ue;
      if (ue === 0)
        return this.getCoefficient(0);
      if (ue === 1) {
        var He = (
          /*int*/
          0
        );
        try {
          for (var Ge = __values$f(this.coefficients), Xe = Ge.next(); !Xe.done; Xe = Ge.next()) {
            var Ke = Xe.value;
            He = this.field.add(He, Ke);
          }
        } catch (nt) {
          Qe = { error: nt };
        } finally {
          try {
            Xe && !Xe.done && (Ue = Ge.return) && Ue.call(Ge);
          } finally {
            if (Qe) throw Qe.error;
          }
        }
        return He;
      }
      for (var $e = (
        /*int*/
        this.coefficients[0]
      ), Je = (
        /*int*/
        this.coefficients.length
      ), Ze = 1; Ze < Je; Ze++)
        $e = this.field.add(this.field.multiply(ue, $e), this.coefficients[Ze]);
      return $e;
    }, me.prototype.add = function(ue) {
      if (!this.field.equals(ue.field))
        throw new IllegalArgumentException("ModulusPolys do not have same ModulusGF field");
      if (this.isZero())
        return ue;
      if (ue.isZero())
        return this;
      var Qe = this.coefficients, Ue = ue.coefficients;
      if (Qe.length > Ue.length) {
        var He = Qe;
        Qe = Ue, Ue = He;
      }
      var Ge = new Int32Array(Ue.length), Xe = (
        /*int*/
        Ue.length - Qe.length
      );
      System.arraycopy(Ue, 0, Ge, 0, Xe);
      for (var Ke = Xe; Ke < Ue.length; Ke++)
        Ge[Ke] = this.field.add(Qe[Ke - Xe], Ue[Ke]);
      return new me(this.field, Ge);
    }, me.prototype.subtract = function(ue) {
      if (!this.field.equals(ue.field))
        throw new IllegalArgumentException("ModulusPolys do not have same ModulusGF field");
      return ue.isZero() ? this : this.add(ue.negative());
    }, me.prototype.multiply = function(ue) {
      return ue instanceof me ? this.multiplyOther(ue) : this.multiplyScalar(ue);
    }, me.prototype.multiplyOther = function(ue) {
      if (!this.field.equals(ue.field))
        throw new IllegalArgumentException("ModulusPolys do not have same ModulusGF field");
      if (this.isZero() || ue.isZero())
        return new me(this.field, new Int32Array([0]));
      for (var Qe = this.coefficients, Ue = (
        /*int*/
        Qe.length
      ), He = ue.coefficients, Ge = (
        /*int*/
        He.length
      ), Xe = new Int32Array(Ue + Ge - 1), Ke = 0; Ke < Ue; Ke++)
        for (var $e = (
          /*int*/
          Qe[Ke]
        ), Je = 0; Je < Ge; Je++)
          Xe[Ke + Je] = this.field.add(Xe[Ke + Je], this.field.multiply($e, He[Je]));
      return new me(this.field, Xe);
    }, me.prototype.negative = function() {
      for (var ue = (
        /*int*/
        this.coefficients.length
      ), Qe = new Int32Array(ue), Ue = 0; Ue < ue; Ue++)
        Qe[Ue] = this.field.subtract(0, this.coefficients[Ue]);
      return new me(this.field, Qe);
    }, me.prototype.multiplyScalar = function(ue) {
      if (ue === 0)
        return new me(this.field, new Int32Array([0]));
      if (ue === 1)
        return this;
      for (var Qe = (
        /*int*/
        this.coefficients.length
      ), Ue = new Int32Array(Qe), He = 0; He < Qe; He++)
        Ue[He] = this.field.multiply(this.coefficients[He], ue);
      return new me(this.field, Ue);
    }, me.prototype.multiplyByMonomial = function(ue, Qe) {
      if (ue < 0)
        throw new IllegalArgumentException();
      if (Qe === 0)
        return new me(this.field, new Int32Array([0]));
      for (var Ue = (
        /*int*/
        this.coefficients.length
      ), He = new Int32Array(Ue + ue), Ge = 0; Ge < Ue; Ge++)
        He[Ge] = this.field.multiply(this.coefficients[Ge], Qe);
      return new me(this.field, He);
    }, me.prototype.toString = function() {
      for (var ue = new StringBuilder(
        /*8 * this.getDegree()*/
      ), Qe = this.getDegree(); Qe >= 0; Qe--) {
        var Ue = (
          /*int*/
          this.getCoefficient(Qe)
        );
        Ue !== 0 && (Ue < 0 ? (ue.append(" - "), Ue = -Ue) : ue.length() > 0 && ue.append(" + "), (Qe === 0 || Ue !== 1) && ue.append(Ue), Qe !== 0 && (Qe === 1 ? ue.append("x") : (ue.append("x^"), ue.append(Qe))));
      }
      return ue.toString();
    }, me;
  }()
), ModulusBase = (
  /** @class */
  function() {
    function me() {
    }
    return me.prototype.add = function(ue, Qe) {
      return (ue + Qe) % this.modulus;
    }, me.prototype.subtract = function(ue, Qe) {
      return (this.modulus + ue - Qe) % this.modulus;
    }, me.prototype.exp = function(ue) {
      return this.expTable[ue];
    }, me.prototype.log = function(ue) {
      if (ue === 0)
        throw new IllegalArgumentException();
      return this.logTable[ue];
    }, me.prototype.inverse = function(ue) {
      if (ue === 0)
        throw new ArithmeticException();
      return this.expTable[this.modulus - this.logTable[ue] - 1];
    }, me.prototype.multiply = function(ue, Qe) {
      return ue === 0 || Qe === 0 ? 0 : this.expTable[(this.logTable[ue] + this.logTable[Qe]) % (this.modulus - 1)];
    }, me.prototype.getSize = function() {
      return this.modulus;
    }, me.prototype.equals = function(ue) {
      return ue === this;
    }, me;
  }()
), __extends$l = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), ModulusGF = (
  /** @class */
  function(me) {
    __extends$l(ue, me);
    function ue(Qe, Ue) {
      var He = me.call(this) || this;
      He.modulus = Qe, He.expTable = new Int32Array(Qe), He.logTable = new Int32Array(Qe);
      for (var Ge = (
        /*int*/
        1
      ), Xe = 0; Xe < Qe; Xe++)
        He.expTable[Xe] = Ge, Ge = Ge * Ue % Qe;
      for (var Xe = 0; Xe < Qe - 1; Xe++)
        He.logTable[He.expTable[Xe]] = Xe;
      return He.zero = new ModulusPoly(He, new Int32Array([0])), He.one = new ModulusPoly(He, new Int32Array([1])), He;
    }
    return ue.prototype.getZero = function() {
      return this.zero;
    }, ue.prototype.getOne = function() {
      return this.one;
    }, ue.prototype.buildMonomial = function(Qe, Ue) {
      if (Qe < 0)
        throw new IllegalArgumentException();
      if (Ue === 0)
        return this.zero;
      var He = new Int32Array(Qe + 1);
      return He[0] = Ue, new ModulusPoly(this, He);
    }, ue.PDF417_GF = new ue(PDF417Common.NUMBER_OF_CODEWORDS, 3), ue;
  }(ModulusBase)
), __values$e = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, ErrorCorrection = (
  /** @class */
  function() {
    function me() {
      this.field = ModulusGF.PDF417_GF;
    }
    return me.prototype.decode = function(ue, Qe, Ue) {
      for (var He, Ge, Xe = new ModulusPoly(this.field, ue), Ke = new Int32Array(Qe), $e = !1, Je = Qe; Je > 0; Je--) {
        var Ze = Xe.evaluateAt(this.field.exp(Je));
        Ke[Qe - Je] = Ze, Ze !== 0 && ($e = !0);
      }
      if (!$e)
        return 0;
      var nt = this.field.getOne();
      if (Ue != null)
        try {
          for (var tt = __values$e(Ue), et = tt.next(); !et.done; et = tt.next()) {
            var rt = et.value, it = this.field.exp(ue.length - 1 - rt), ot = new ModulusPoly(this.field, new Int32Array([this.field.subtract(0, it), 1]));
            nt = nt.multiply(ot);
          }
        } catch (gt) {
          He = { error: gt };
        } finally {
          try {
            et && !et.done && (Ge = tt.return) && Ge.call(tt);
          } finally {
            if (He) throw He.error;
          }
        }
      for (var at = new ModulusPoly(this.field, Ke), st = this.runEuclideanAlgorithm(this.field.buildMonomial(Qe, 1), at, Qe), ut = st[0], lt = st[1], dt = this.findErrorLocations(ut), At = this.findErrorMagnitudes(lt, ut, dt), Je = 0; Je < dt.length; Je++) {
        var pt = ue.length - 1 - this.field.log(dt[Je]);
        if (pt < 0)
          throw ChecksumException.getChecksumInstance();
        ue[pt] = this.field.subtract(ue[pt], At[Je]);
      }
      return dt.length;
    }, me.prototype.runEuclideanAlgorithm = function(ue, Qe, Ue) {
      if (ue.getDegree() < Qe.getDegree()) {
        var He = ue;
        ue = Qe, Qe = He;
      }
      for (var Ge = ue, Xe = Qe, Ke = this.field.getZero(), $e = this.field.getOne(); Xe.getDegree() >= Math.round(Ue / 2); ) {
        var Je = Ge, Ze = Ke;
        if (Ge = Xe, Ke = $e, Ge.isZero())
          throw ChecksumException.getChecksumInstance();
        Xe = Je;
        for (var nt = this.field.getZero(), tt = Ge.getCoefficient(Ge.getDegree()), et = this.field.inverse(tt); Xe.getDegree() >= Ge.getDegree() && !Xe.isZero(); ) {
          var rt = Xe.getDegree() - Ge.getDegree(), it = this.field.multiply(Xe.getCoefficient(Xe.getDegree()), et);
          nt = nt.add(this.field.buildMonomial(rt, it)), Xe = Xe.subtract(Ge.multiplyByMonomial(rt, it));
        }
        $e = nt.multiply(Ke).subtract(Ze).negative();
      }
      var ot = $e.getCoefficient(0);
      if (ot === 0)
        throw ChecksumException.getChecksumInstance();
      var at = this.field.inverse(ot), st = $e.multiply(at), ut = Xe.multiply(at);
      return [st, ut];
    }, me.prototype.findErrorLocations = function(ue) {
      for (var Qe = ue.getDegree(), Ue = new Int32Array(Qe), He = 0, Ge = 1; Ge < this.field.getSize() && He < Qe; Ge++)
        ue.evaluateAt(Ge) === 0 && (Ue[He] = this.field.inverse(Ge), He++);
      if (He !== Qe)
        throw ChecksumException.getChecksumInstance();
      return Ue;
    }, me.prototype.findErrorMagnitudes = function(ue, Qe, Ue) {
      for (var He = Qe.getDegree(), Ge = new Int32Array(He), Xe = 1; Xe <= He; Xe++)
        Ge[He - Xe] = this.field.multiply(Xe, Qe.getCoefficient(Xe));
      for (var Ke = new ModulusPoly(this.field, Ge), $e = Ue.length, Je = new Int32Array($e), Xe = 0; Xe < $e; Xe++) {
        var Ze = this.field.inverse(Ue[Xe]), nt = this.field.subtract(0, ue.evaluateAt(Ze)), tt = this.field.inverse(Ke.evaluateAt(Ze));
        Je[Xe] = this.field.multiply(nt, tt);
      }
      return Je;
    }, me;
  }()
), BoundingBox = (
  /** @class */
  function() {
    function me(ue, Qe, Ue, He, Ge) {
      ue instanceof me ? this.constructor_2(ue) : this.constructor_1(ue, Qe, Ue, He, Ge);
    }
    return me.prototype.constructor_1 = function(ue, Qe, Ue, He, Ge) {
      var Xe = Qe == null || Ue == null, Ke = He == null || Ge == null;
      if (Xe && Ke)
        throw new NotFoundException();
      Xe ? (Qe = new ResultPoint(0, He.getY()), Ue = new ResultPoint(0, Ge.getY())) : Ke && (He = new ResultPoint(ue.getWidth() - 1, Qe.getY()), Ge = new ResultPoint(ue.getWidth() - 1, Ue.getY())), this.image = ue, this.topLeft = Qe, this.bottomLeft = Ue, this.topRight = He, this.bottomRight = Ge, this.minX = Math.trunc(Math.min(Qe.getX(), Ue.getX())), this.maxX = Math.trunc(Math.max(He.getX(), Ge.getX())), this.minY = Math.trunc(Math.min(Qe.getY(), He.getY())), this.maxY = Math.trunc(Math.max(Ue.getY(), Ge.getY()));
    }, me.prototype.constructor_2 = function(ue) {
      this.image = ue.image, this.topLeft = ue.getTopLeft(), this.bottomLeft = ue.getBottomLeft(), this.topRight = ue.getTopRight(), this.bottomRight = ue.getBottomRight(), this.minX = ue.getMinX(), this.maxX = ue.getMaxX(), this.minY = ue.getMinY(), this.maxY = ue.getMaxY();
    }, me.merge = function(ue, Qe) {
      return ue == null ? Qe : Qe == null ? ue : new me(ue.image, ue.topLeft, ue.bottomLeft, Qe.topRight, Qe.bottomRight);
    }, me.prototype.addMissingRows = function(ue, Qe, Ue) {
      var He = this.topLeft, Ge = this.bottomLeft, Xe = this.topRight, Ke = this.bottomRight;
      if (ue > 0) {
        var $e = Ue ? this.topLeft : this.topRight, Je = Math.trunc($e.getY() - ue);
        Je < 0 && (Je = 0);
        var Ze = new ResultPoint($e.getX(), Je);
        Ue ? He = Ze : Xe = Ze;
      }
      if (Qe > 0) {
        var nt = Ue ? this.bottomLeft : this.bottomRight, tt = Math.trunc(nt.getY() + Qe);
        tt >= this.image.getHeight() && (tt = this.image.getHeight() - 1);
        var et = new ResultPoint(nt.getX(), tt);
        Ue ? Ge = et : Ke = et;
      }
      return new me(this.image, He, Ge, Xe, Ke);
    }, me.prototype.getMinX = function() {
      return this.minX;
    }, me.prototype.getMaxX = function() {
      return this.maxX;
    }, me.prototype.getMinY = function() {
      return this.minY;
    }, me.prototype.getMaxY = function() {
      return this.maxY;
    }, me.prototype.getTopLeft = function() {
      return this.topLeft;
    }, me.prototype.getTopRight = function() {
      return this.topRight;
    }, me.prototype.getBottomLeft = function() {
      return this.bottomLeft;
    }, me.prototype.getBottomRight = function() {
      return this.bottomRight;
    }, me;
  }()
), BarcodeMetadata = (
  /** @class */
  function() {
    function me(ue, Qe, Ue, He) {
      this.columnCount = ue, this.errorCorrectionLevel = He, this.rowCountUpperPart = Qe, this.rowCountLowerPart = Ue, this.rowCount = Qe + Ue;
    }
    return me.prototype.getColumnCount = function() {
      return this.columnCount;
    }, me.prototype.getErrorCorrectionLevel = function() {
      return this.errorCorrectionLevel;
    }, me.prototype.getRowCount = function() {
      return this.rowCount;
    }, me.prototype.getRowCountUpperPart = function() {
      return this.rowCountUpperPart;
    }, me.prototype.getRowCountLowerPart = function() {
      return this.rowCountLowerPart;
    }, me;
  }()
), Formatter = (
  /** @class */
  function() {
    function me() {
      this.buffer = "";
    }
    return me.form = function(ue, Qe) {
      var Ue = -1;
      function He(Xe, Ke, $e, Je, Ze, nt) {
        if (Xe === "%%")
          return "%";
        if (Qe[++Ue] !== void 0) {
          Xe = Je ? parseInt(Je.substr(1)) : void 0;
          var tt = Ze ? parseInt(Ze.substr(1)) : void 0, et;
          switch (nt) {
            case "s":
              et = Qe[Ue];
              break;
            case "c":
              et = Qe[Ue][0];
              break;
            case "f":
              et = parseFloat(Qe[Ue]).toFixed(Xe);
              break;
            case "p":
              et = parseFloat(Qe[Ue]).toPrecision(Xe);
              break;
            case "e":
              et = parseFloat(Qe[Ue]).toExponential(Xe);
              break;
            case "x":
              et = parseInt(Qe[Ue]).toString(tt || 16);
              break;
            case "d":
              et = parseFloat(parseInt(Qe[Ue], tt || 10).toPrecision(Xe)).toFixed(0);
              break;
          }
          et = typeof et == "object" ? JSON.stringify(et) : (+et).toString(tt);
          for (var rt = parseInt($e), it = $e && $e[0] + "" == "0" ? "0" : " "; et.length < rt; )
            et = Ke !== void 0 ? et + it : it + et;
          return et;
        }
      }
      var Ge = /%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g;
      return ue.replace(Ge, He);
    }, me.prototype.format = function(ue) {
      for (var Qe = [], Ue = 1; Ue < arguments.length; Ue++)
        Qe[Ue - 1] = arguments[Ue];
      this.buffer += me.form(ue, Qe);
    }, me.prototype.toString = function() {
      return this.buffer;
    }, me;
  }()
), __values$d = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, DetectionResultColumn = (
  /** @class */
  function() {
    function me(ue) {
      this.boundingBox = new BoundingBox(ue), this.codewords = new Array(ue.getMaxY() - ue.getMinY() + 1);
    }
    return me.prototype.getCodewordNearby = function(ue) {
      var Qe = this.getCodeword(ue);
      if (Qe != null)
        return Qe;
      for (var Ue = 1; Ue < me.MAX_NEARBY_DISTANCE; Ue++) {
        var He = this.imageRowToCodewordIndex(ue) - Ue;
        if (He >= 0 && (Qe = this.codewords[He], Qe != null) || (He = this.imageRowToCodewordIndex(ue) + Ue, He < this.codewords.length && (Qe = this.codewords[He], Qe != null)))
          return Qe;
      }
      return null;
    }, me.prototype.imageRowToCodewordIndex = function(ue) {
      return ue - this.boundingBox.getMinY();
    }, me.prototype.setCodeword = function(ue, Qe) {
      this.codewords[this.imageRowToCodewordIndex(ue)] = Qe;
    }, me.prototype.getCodeword = function(ue) {
      return this.codewords[this.imageRowToCodewordIndex(ue)];
    }, me.prototype.getBoundingBox = function() {
      return this.boundingBox;
    }, me.prototype.getCodewords = function() {
      return this.codewords;
    }, me.prototype.toString = function() {
      var ue, Qe, Ue = new Formatter(), He = 0;
      try {
        for (var Ge = __values$d(this.codewords), Xe = Ge.next(); !Xe.done; Xe = Ge.next()) {
          var Ke = Xe.value;
          if (Ke == null) {
            Ue.format("%3d:    |   %n", He++);
            continue;
          }
          Ue.format("%3d: %3d|%3d%n", He++, Ke.getRowNumber(), Ke.getValue());
        }
      } catch ($e) {
        ue = { error: $e };
      } finally {
        try {
          Xe && !Xe.done && (Qe = Ge.return) && Qe.call(Ge);
        } finally {
          if (ue) throw ue.error;
        }
      }
      return Ue.toString();
    }, me.MAX_NEARBY_DISTANCE = 5, me;
  }()
), __values$c = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, __read = function(me, ue) {
  var Qe = typeof Symbol == "function" && me[Symbol.iterator];
  if (!Qe) return me;
  var Ue = Qe.call(me), He, Ge = [], Xe;
  try {
    for (; (ue === void 0 || ue-- > 0) && !(He = Ue.next()).done; ) Ge.push(He.value);
  } catch (Ke) {
    Xe = { error: Ke };
  } finally {
    try {
      He && !He.done && (Qe = Ue.return) && Qe.call(Ue);
    } finally {
      if (Xe) throw Xe.error;
    }
  }
  return Ge;
}, BarcodeValue = (
  /** @class */
  function() {
    function me() {
      this.values = /* @__PURE__ */ new Map();
    }
    return me.prototype.setValue = function(ue) {
      ue = Math.trunc(ue);
      var Qe = this.values.get(ue);
      Qe == null && (Qe = 0), Qe++, this.values.set(ue, Qe);
    }, me.prototype.getValue = function() {
      var ue, Qe, Ue = -1, He = new Array(), Ge = function(nt, tt) {
        var et = {
          getKey: function() {
            return nt;
          },
          getValue: function() {
            return tt;
          }
        };
        et.getValue() > Ue ? (Ue = et.getValue(), He = [], He.push(et.getKey())) : et.getValue() === Ue && He.push(et.getKey());
      };
      try {
        for (var Xe = __values$c(this.values.entries()), Ke = Xe.next(); !Ke.done; Ke = Xe.next()) {
          var $e = __read(Ke.value, 2), Je = $e[0], Ze = $e[1];
          Ge(Je, Ze);
        }
      } catch (nt) {
        ue = { error: nt };
      } finally {
        try {
          Ke && !Ke.done && (Qe = Xe.return) && Qe.call(Xe);
        } finally {
          if (ue) throw ue.error;
        }
      }
      return PDF417Common.toIntArray(He);
    }, me.prototype.getConfidence = function(ue) {
      return this.values.get(ue);
    }, me;
  }()
), __extends$k = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), __values$b = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, DetectionResultRowIndicatorColumn = (
  /** @class */
  function(me) {
    __extends$k(ue, me);
    function ue(Qe, Ue) {
      var He = me.call(this, Qe) || this;
      return He._isLeft = Ue, He;
    }
    return ue.prototype.setRowNumbers = function() {
      var Qe, Ue;
      try {
        for (var He = __values$b(this.getCodewords()), Ge = He.next(); !Ge.done; Ge = He.next()) {
          var Xe = Ge.value;
          Xe != null && Xe.setRowNumberAsRowIndicatorColumn();
        }
      } catch (Ke) {
        Qe = { error: Ke };
      } finally {
        try {
          Ge && !Ge.done && (Ue = He.return) && Ue.call(He);
        } finally {
          if (Qe) throw Qe.error;
        }
      }
    }, ue.prototype.adjustCompleteIndicatorColumnRowNumbers = function(Qe) {
      var Ue = this.getCodewords();
      this.setRowNumbers(), this.removeIncorrectCodewords(Ue, Qe);
      for (var He = this.getBoundingBox(), Ge = this._isLeft ? He.getTopLeft() : He.getTopRight(), Xe = this._isLeft ? He.getBottomLeft() : He.getBottomRight(), Ke = this.imageRowToCodewordIndex(Math.trunc(Ge.getY())), $e = this.imageRowToCodewordIndex(Math.trunc(Xe.getY())), Je = -1, Ze = 1, nt = 0, tt = Ke; tt < $e; tt++)
        if (Ue[tt] != null) {
          var et = Ue[tt], rt = et.getRowNumber() - Je;
          if (rt === 0)
            nt++;
          else if (rt === 1)
            Ze = Math.max(Ze, nt), nt = 1, Je = et.getRowNumber();
          else if (rt < 0 || et.getRowNumber() >= Qe.getRowCount() || rt > tt)
            Ue[tt] = null;
          else {
            var it = void 0;
            Ze > 2 ? it = (Ze - 2) * rt : it = rt;
            for (var ot = it >= tt, at = 1; at <= it && !ot; at++)
              ot = Ue[tt - at] != null;
            ot ? Ue[tt] = null : (Je = et.getRowNumber(), nt = 1);
          }
        }
    }, ue.prototype.getRowHeights = function() {
      var Qe, Ue, He = this.getBarcodeMetadata();
      if (He == null)
        return null;
      this.adjustIncompleteIndicatorColumnRowNumbers(He);
      var Ge = new Int32Array(He.getRowCount());
      try {
        for (var Xe = __values$b(this.getCodewords()), Ke = Xe.next(); !Ke.done; Ke = Xe.next()) {
          var $e = Ke.value;
          if ($e != null) {
            var Je = $e.getRowNumber();
            if (Je >= Ge.length)
              continue;
            Ge[Je]++;
          }
        }
      } catch (Ze) {
        Qe = { error: Ze };
      } finally {
        try {
          Ke && !Ke.done && (Ue = Xe.return) && Ue.call(Xe);
        } finally {
          if (Qe) throw Qe.error;
        }
      }
      return Ge;
    }, ue.prototype.adjustIncompleteIndicatorColumnRowNumbers = function(Qe) {
      for (var Ue = this.getBoundingBox(), He = this._isLeft ? Ue.getTopLeft() : Ue.getTopRight(), Ge = this._isLeft ? Ue.getBottomLeft() : Ue.getBottomRight(), Xe = this.imageRowToCodewordIndex(Math.trunc(He.getY())), Ke = this.imageRowToCodewordIndex(Math.trunc(Ge.getY())), $e = this.getCodewords(), Je = -1, Ze = Xe; Ze < Ke; Ze++)
        if ($e[Ze] != null) {
          var nt = $e[Ze];
          nt.setRowNumberAsRowIndicatorColumn();
          var tt = nt.getRowNumber() - Je;
          tt === 0 || (tt === 1 ? Je = nt.getRowNumber() : nt.getRowNumber() >= Qe.getRowCount() ? $e[Ze] = null : Je = nt.getRowNumber());
        }
    }, ue.prototype.getBarcodeMetadata = function() {
      var Qe, Ue, He = this.getCodewords(), Ge = new BarcodeValue(), Xe = new BarcodeValue(), Ke = new BarcodeValue(), $e = new BarcodeValue();
      try {
        for (var Je = __values$b(He), Ze = Je.next(); !Ze.done; Ze = Je.next()) {
          var nt = Ze.value;
          if (nt != null) {
            nt.setRowNumberAsRowIndicatorColumn();
            var tt = nt.getValue() % 30, et = nt.getRowNumber();
            switch (this._isLeft || (et += 2), et % 3) {
              case 0:
                Xe.setValue(tt * 3 + 1);
                break;
              case 1:
                $e.setValue(tt / 3), Ke.setValue(tt % 3);
                break;
              case 2:
                Ge.setValue(tt + 1);
                break;
            }
          }
        }
      } catch (it) {
        Qe = { error: it };
      } finally {
        try {
          Ze && !Ze.done && (Ue = Je.return) && Ue.call(Je);
        } finally {
          if (Qe) throw Qe.error;
        }
      }
      if (Ge.getValue().length === 0 || Xe.getValue().length === 0 || Ke.getValue().length === 0 || $e.getValue().length === 0 || Ge.getValue()[0] < 1 || Xe.getValue()[0] + Ke.getValue()[0] < PDF417Common.MIN_ROWS_IN_BARCODE || Xe.getValue()[0] + Ke.getValue()[0] > PDF417Common.MAX_ROWS_IN_BARCODE)
        return null;
      var rt = new BarcodeMetadata(Ge.getValue()[0], Xe.getValue()[0], Ke.getValue()[0], $e.getValue()[0]);
      return this.removeIncorrectCodewords(He, rt), rt;
    }, ue.prototype.removeIncorrectCodewords = function(Qe, Ue) {
      for (var He = 0; He < Qe.length; He++) {
        var Ge = Qe[He];
        if (Qe[He] != null) {
          var Xe = Ge.getValue() % 30, Ke = Ge.getRowNumber();
          if (Ke > Ue.getRowCount()) {
            Qe[He] = null;
            continue;
          }
          switch (this._isLeft || (Ke += 2), Ke % 3) {
            case 0:
              Xe * 3 + 1 !== Ue.getRowCountUpperPart() && (Qe[He] = null);
              break;
            case 1:
              (Math.trunc(Xe / 3) !== Ue.getErrorCorrectionLevel() || Xe % 3 !== Ue.getRowCountLowerPart()) && (Qe[He] = null);
              break;
            case 2:
              Xe + 1 !== Ue.getColumnCount() && (Qe[He] = null);
              break;
          }
        }
      }
    }, ue.prototype.isLeft = function() {
      return this._isLeft;
    }, ue.prototype.toString = function() {
      return "IsLeft: " + this._isLeft + `
` + me.prototype.toString.call(this);
    }, ue;
  }(DetectionResultColumn)
), __values$a = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, DetectionResult = (
  /** @class */
  function() {
    function me(ue, Qe) {
      this.ADJUST_ROW_NUMBER_SKIP = 2, this.barcodeMetadata = ue, this.barcodeColumnCount = ue.getColumnCount(), this.boundingBox = Qe, this.detectionResultColumns = new Array(this.barcodeColumnCount + 2);
    }
    return me.prototype.getDetectionResultColumns = function() {
      this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[0]), this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[this.barcodeColumnCount + 1]);
      var ue = PDF417Common.MAX_CODEWORDS_IN_BARCODE, Qe;
      do
        Qe = ue, ue = this.adjustRowNumbersAndGetCount();
      while (ue > 0 && ue < Qe);
      return this.detectionResultColumns;
    }, me.prototype.adjustIndicatorColumnRowNumbers = function(ue) {
      ue != null && ue.adjustCompleteIndicatorColumnRowNumbers(this.barcodeMetadata);
    }, me.prototype.adjustRowNumbersAndGetCount = function() {
      var ue = this.adjustRowNumbersByRow();
      if (ue === 0)
        return 0;
      for (var Qe = 1; Qe < this.barcodeColumnCount + 1; Qe++)
        for (var Ue = this.detectionResultColumns[Qe].getCodewords(), He = 0; He < Ue.length; He++)
          Ue[He] != null && (Ue[He].hasValidRowNumber() || this.adjustRowNumbers(Qe, He, Ue));
      return ue;
    }, me.prototype.adjustRowNumbersByRow = function() {
      this.adjustRowNumbersFromBothRI();
      var ue = this.adjustRowNumbersFromLRI();
      return ue + this.adjustRowNumbersFromRRI();
    }, me.prototype.adjustRowNumbersFromBothRI = function() {
      if (!(this.detectionResultColumns[0] == null || this.detectionResultColumns[this.barcodeColumnCount + 1] == null)) {
        for (var ue = this.detectionResultColumns[0].getCodewords(), Qe = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords(), Ue = 0; Ue < ue.length; Ue++)
          if (ue[Ue] != null && Qe[Ue] != null && ue[Ue].getRowNumber() === Qe[Ue].getRowNumber())
            for (var He = 1; He <= this.barcodeColumnCount; He++) {
              var Ge = this.detectionResultColumns[He].getCodewords()[Ue];
              Ge != null && (Ge.setRowNumber(ue[Ue].getRowNumber()), Ge.hasValidRowNumber() || (this.detectionResultColumns[He].getCodewords()[Ue] = null));
            }
      }
    }, me.prototype.adjustRowNumbersFromRRI = function() {
      if (this.detectionResultColumns[this.barcodeColumnCount + 1] == null)
        return 0;
      for (var ue = 0, Qe = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords(), Ue = 0; Ue < Qe.length; Ue++)
        if (Qe[Ue] != null)
          for (var He = Qe[Ue].getRowNumber(), Ge = 0, Xe = this.barcodeColumnCount + 1; Xe > 0 && Ge < this.ADJUST_ROW_NUMBER_SKIP; Xe--) {
            var Ke = this.detectionResultColumns[Xe].getCodewords()[Ue];
            Ke != null && (Ge = me.adjustRowNumberIfValid(He, Ge, Ke), Ke.hasValidRowNumber() || ue++);
          }
      return ue;
    }, me.prototype.adjustRowNumbersFromLRI = function() {
      if (this.detectionResultColumns[0] == null)
        return 0;
      for (var ue = 0, Qe = this.detectionResultColumns[0].getCodewords(), Ue = 0; Ue < Qe.length; Ue++)
        if (Qe[Ue] != null)
          for (var He = Qe[Ue].getRowNumber(), Ge = 0, Xe = 1; Xe < this.barcodeColumnCount + 1 && Ge < this.ADJUST_ROW_NUMBER_SKIP; Xe++) {
            var Ke = this.detectionResultColumns[Xe].getCodewords()[Ue];
            Ke != null && (Ge = me.adjustRowNumberIfValid(He, Ge, Ke), Ke.hasValidRowNumber() || ue++);
          }
      return ue;
    }, me.adjustRowNumberIfValid = function(ue, Qe, Ue) {
      return Ue == null || Ue.hasValidRowNumber() || (Ue.isValidRowNumber(ue) ? (Ue.setRowNumber(ue), Qe = 0) : ++Qe), Qe;
    }, me.prototype.adjustRowNumbers = function(ue, Qe, Ue) {
      var He, Ge;
      if (this.detectionResultColumns[ue - 1] != null) {
        var Xe = Ue[Qe], Ke = this.detectionResultColumns[ue - 1].getCodewords(), $e = Ke;
        this.detectionResultColumns[ue + 1] != null && ($e = this.detectionResultColumns[ue + 1].getCodewords());
        var Je = new Array(14);
        Je[2] = Ke[Qe], Je[3] = $e[Qe], Qe > 0 && (Je[0] = Ue[Qe - 1], Je[4] = Ke[Qe - 1], Je[5] = $e[Qe - 1]), Qe > 1 && (Je[8] = Ue[Qe - 2], Je[10] = Ke[Qe - 2], Je[11] = $e[Qe - 2]), Qe < Ue.length - 1 && (Je[1] = Ue[Qe + 1], Je[6] = Ke[Qe + 1], Je[7] = $e[Qe + 1]), Qe < Ue.length - 2 && (Je[9] = Ue[Qe + 2], Je[12] = Ke[Qe + 2], Je[13] = $e[Qe + 2]);
        try {
          for (var Ze = __values$a(Je), nt = Ze.next(); !nt.done; nt = Ze.next()) {
            var tt = nt.value;
            if (me.adjustRowNumber(Xe, tt))
              return;
          }
        } catch (et) {
          He = { error: et };
        } finally {
          try {
            nt && !nt.done && (Ge = Ze.return) && Ge.call(Ze);
          } finally {
            if (He) throw He.error;
          }
        }
      }
    }, me.adjustRowNumber = function(ue, Qe) {
      return Qe == null ? !1 : Qe.hasValidRowNumber() && Qe.getBucket() === ue.getBucket() ? (ue.setRowNumber(Qe.getRowNumber()), !0) : !1;
    }, me.prototype.getBarcodeColumnCount = function() {
      return this.barcodeColumnCount;
    }, me.prototype.getBarcodeRowCount = function() {
      return this.barcodeMetadata.getRowCount();
    }, me.prototype.getBarcodeECLevel = function() {
      return this.barcodeMetadata.getErrorCorrectionLevel();
    }, me.prototype.setBoundingBox = function(ue) {
      this.boundingBox = ue;
    }, me.prototype.getBoundingBox = function() {
      return this.boundingBox;
    }, me.prototype.setDetectionResultColumn = function(ue, Qe) {
      this.detectionResultColumns[ue] = Qe;
    }, me.prototype.getDetectionResultColumn = function(ue) {
      return this.detectionResultColumns[ue];
    }, me.prototype.toString = function() {
      var ue = this.detectionResultColumns[0];
      ue == null && (ue = this.detectionResultColumns[this.barcodeColumnCount + 1]);
      for (var Qe = new Formatter(), Ue = 0; Ue < ue.getCodewords().length; Ue++) {
        Qe.format("CW %3d:", Ue);
        for (var He = 0; He < this.barcodeColumnCount + 2; He++) {
          if (this.detectionResultColumns[He] == null) {
            Qe.format("    |   ");
            continue;
          }
          var Ge = this.detectionResultColumns[He].getCodewords()[Ue];
          if (Ge == null) {
            Qe.format("    |   ");
            continue;
          }
          Qe.format(" %3d|%3d", Ge.getRowNumber(), Ge.getValue());
        }
        Qe.format("%n");
      }
      return Qe.toString();
    }, me;
  }()
), Codeword = (
  /** @class */
  function() {
    function me(ue, Qe, Ue, He) {
      this.rowNumber = me.BARCODE_ROW_UNKNOWN, this.startX = Math.trunc(ue), this.endX = Math.trunc(Qe), this.bucket = Math.trunc(Ue), this.value = Math.trunc(He);
    }
    return me.prototype.hasValidRowNumber = function() {
      return this.isValidRowNumber(this.rowNumber);
    }, me.prototype.isValidRowNumber = function(ue) {
      return ue !== me.BARCODE_ROW_UNKNOWN && this.bucket === ue % 3 * 3;
    }, me.prototype.setRowNumberAsRowIndicatorColumn = function() {
      this.rowNumber = Math.trunc(Math.trunc(this.value / 30) * 3 + Math.trunc(this.bucket / 3));
    }, me.prototype.getWidth = function() {
      return this.endX - this.startX;
    }, me.prototype.getStartX = function() {
      return this.startX;
    }, me.prototype.getEndX = function() {
      return this.endX;
    }, me.prototype.getBucket = function() {
      return this.bucket;
    }, me.prototype.getValue = function() {
      return this.value;
    }, me.prototype.getRowNumber = function() {
      return this.rowNumber;
    }, me.prototype.setRowNumber = function(ue) {
      this.rowNumber = ue;
    }, me.prototype.toString = function() {
      return this.rowNumber + "|" + this.value;
    }, me.BARCODE_ROW_UNKNOWN = -1, me;
  }()
), PDF417CodewordDecoder = (
  /** @class */
  function() {
    function me() {
    }
    return me.initialize = function() {
      for (var ue = 0; ue < PDF417Common.SYMBOL_TABLE.length; ue++)
        for (var Qe = PDF417Common.SYMBOL_TABLE[ue], Ue = Qe & 1, He = 0; He < PDF417Common.BARS_IN_MODULE; He++) {
          for (var Ge = 0; (Qe & 1) === Ue; )
            Ge += 1, Qe >>= 1;
          Ue = Qe & 1, me.RATIOS_TABLE[ue] || (me.RATIOS_TABLE[ue] = new Array(PDF417Common.BARS_IN_MODULE)), me.RATIOS_TABLE[ue][PDF417Common.BARS_IN_MODULE - He - 1] = Math.fround(Ge / PDF417Common.MODULES_IN_CODEWORD);
        }
      this.bSymbolTableReady = !0;
    }, me.getDecodedValue = function(ue) {
      var Qe = me.getDecodedCodewordValue(me.sampleBitCounts(ue));
      return Qe !== -1 ? Qe : me.getClosestDecodedValue(ue);
    }, me.sampleBitCounts = function(ue) {
      for (var Qe = MathUtils.sum(ue), Ue = new Int32Array(PDF417Common.BARS_IN_MODULE), He = 0, Ge = 0, Xe = 0; Xe < PDF417Common.MODULES_IN_CODEWORD; Xe++) {
        var Ke = Qe / (2 * PDF417Common.MODULES_IN_CODEWORD) + Xe * Qe / PDF417Common.MODULES_IN_CODEWORD;
        Ge + ue[He] <= Ke && (Ge += ue[He], He++), Ue[He]++;
      }
      return Ue;
    }, me.getDecodedCodewordValue = function(ue) {
      var Qe = me.getBitValue(ue);
      return PDF417Common.getCodeword(Qe) === -1 ? -1 : Qe;
    }, me.getBitValue = function(ue) {
      for (var Qe = (
        /*long*/
        0
      ), Ue = 0; Ue < ue.length; Ue++)
        for (var He = 0; He < ue[Ue]; He++)
          Qe = Qe << 1 | (Ue % 2 === 0 ? 1 : 0);
      return Math.trunc(Qe);
    }, me.getClosestDecodedValue = function(ue) {
      var Qe = MathUtils.sum(ue), Ue = new Array(PDF417Common.BARS_IN_MODULE);
      if (Qe > 1)
        for (var He = 0; He < Ue.length; He++)
          Ue[He] = Math.fround(ue[He] / Qe);
      var Ge = Float.MAX_VALUE, Xe = -1;
      this.bSymbolTableReady || me.initialize();
      for (var Ke = 0; Ke < me.RATIOS_TABLE.length; Ke++) {
        for (var $e = 0, Je = me.RATIOS_TABLE[Ke], Ze = 0; Ze < PDF417Common.BARS_IN_MODULE; Ze++) {
          var nt = Math.fround(Je[Ze] - Ue[Ze]);
          if ($e += Math.fround(nt * nt), $e >= Ge)
            break;
        }
        $e < Ge && (Ge = $e, Xe = PDF417Common.SYMBOL_TABLE[Ke]);
      }
      return Xe;
    }, me.bSymbolTableReady = !1, me.RATIOS_TABLE = new Array(PDF417Common.SYMBOL_TABLE.length).map(function(ue) {
      return new Array(PDF417Common.BARS_IN_MODULE);
    }), me;
  }()
), PDF417ResultMetadata = (
  /** @class */
  function() {
    function me() {
      this.segmentCount = -1, this.fileSize = -1, this.timestamp = -1, this.checksum = -1;
    }
    return me.prototype.getSegmentIndex = function() {
      return this.segmentIndex;
    }, me.prototype.setSegmentIndex = function(ue) {
      this.segmentIndex = ue;
    }, me.prototype.getFileId = function() {
      return this.fileId;
    }, me.prototype.setFileId = function(ue) {
      this.fileId = ue;
    }, me.prototype.getOptionalData = function() {
      return this.optionalData;
    }, me.prototype.setOptionalData = function(ue) {
      this.optionalData = ue;
    }, me.prototype.isLastSegment = function() {
      return this.lastSegment;
    }, me.prototype.setLastSegment = function(ue) {
      this.lastSegment = ue;
    }, me.prototype.getSegmentCount = function() {
      return this.segmentCount;
    }, me.prototype.setSegmentCount = function(ue) {
      this.segmentCount = ue;
    }, me.prototype.getSender = function() {
      return this.sender || null;
    }, me.prototype.setSender = function(ue) {
      this.sender = ue;
    }, me.prototype.getAddressee = function() {
      return this.addressee || null;
    }, me.prototype.setAddressee = function(ue) {
      this.addressee = ue;
    }, me.prototype.getFileName = function() {
      return this.fileName;
    }, me.prototype.setFileName = function(ue) {
      this.fileName = ue;
    }, me.prototype.getFileSize = function() {
      return this.fileSize;
    }, me.prototype.setFileSize = function(ue) {
      this.fileSize = ue;
    }, me.prototype.getChecksum = function() {
      return this.checksum;
    }, me.prototype.setChecksum = function(ue) {
      this.checksum = ue;
    }, me.prototype.getTimestamp = function() {
      return this.timestamp;
    }, me.prototype.setTimestamp = function(ue) {
      this.timestamp = ue;
    }, me;
  }()
), Long = (
  /** @class */
  function() {
    function me() {
    }
    return me.parseLong = function(ue, Qe) {
      return Qe === void 0 && (Qe = void 0), parseInt(ue, Qe);
    }, me;
  }()
), __extends$j = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), NullPointerException = (
  /** @class */
  function(me) {
    __extends$j(ue, me);
    function ue() {
      return me !== null && me.apply(this, arguments) || this;
    }
    return ue.kind = "NullPointerException", ue;
  }(Exception)
), OutputStream = (
  /** @class */
  function() {
    function me() {
    }
    return me.prototype.writeBytes = function(ue) {
      this.writeBytesOffset(ue, 0, ue.length);
    }, me.prototype.writeBytesOffset = function(ue, Qe, Ue) {
      if (ue == null)
        throw new NullPointerException();
      if (Qe < 0 || Qe > ue.length || Ue < 0 || Qe + Ue > ue.length || Qe + Ue < 0)
        throw new IndexOutOfBoundsException();
      if (Ue === 0)
        return;
      for (var He = 0; He < Ue; He++)
        this.write(ue[Qe + He]);
    }, me.prototype.flush = function() {
    }, me.prototype.close = function() {
    }, me;
  }()
), __extends$i = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), OutOfMemoryError = (
  /** @class */
  function(me) {
    __extends$i(ue, me);
    function ue() {
      return me !== null && me.apply(this, arguments) || this;
    }
    return ue;
  }(Exception)
), __extends$h = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), ByteArrayOutputStream = (
  /** @class */
  function(me) {
    __extends$h(ue, me);
    function ue(Qe) {
      Qe === void 0 && (Qe = 32);
      var Ue = me.call(this) || this;
      if (Ue.count = 0, Qe < 0)
        throw new IllegalArgumentException("Negative initial size: " + Qe);
      return Ue.buf = new Uint8Array(Qe), Ue;
    }
    return ue.prototype.ensureCapacity = function(Qe) {
      Qe - this.buf.length > 0 && this.grow(Qe);
    }, ue.prototype.grow = function(Qe) {
      var Ue = this.buf.length, He = Ue << 1;
      if (He - Qe < 0 && (He = Qe), He < 0) {
        if (Qe < 0)
          throw new OutOfMemoryError();
        He = Integer.MAX_VALUE;
      }
      this.buf = Arrays.copyOfUint8Array(this.buf, He);
    }, ue.prototype.write = function(Qe) {
      this.ensureCapacity(this.count + 1), this.buf[this.count] = /*(byte)*/
      Qe, this.count += 1;
    }, ue.prototype.writeBytesOffset = function(Qe, Ue, He) {
      if (Ue < 0 || Ue > Qe.length || He < 0 || Ue + He - Qe.length > 0)
        throw new IndexOutOfBoundsException();
      this.ensureCapacity(this.count + He), System.arraycopy(Qe, Ue, this.buf, this.count, He), this.count += He;
    }, ue.prototype.writeTo = function(Qe) {
      Qe.writeBytesOffset(this.buf, 0, this.count);
    }, ue.prototype.reset = function() {
      this.count = 0;
    }, ue.prototype.toByteArray = function() {
      return Arrays.copyOfUint8Array(this.buf, this.count);
    }, ue.prototype.size = function() {
      return this.count;
    }, ue.prototype.toString = function(Qe) {
      return Qe ? typeof Qe == "string" ? this.toString_string(Qe) : this.toString_number(Qe) : this.toString_void();
    }, ue.prototype.toString_void = function() {
      return new String(
        this.buf
        /*, 0, this.count*/
      ).toString();
    }, ue.prototype.toString_string = function(Qe) {
      return new String(
        this.buf
        /*, 0, this.count, charsetName*/
      ).toString();
    }, ue.prototype.toString_number = function(Qe) {
      return new String(
        this.buf
        /*, hibyte, 0, this.count*/
      ).toString();
    }, ue.prototype.close = function() {
    }, ue;
  }(OutputStream)
), Mode$1;
(function(me) {
  me[me.ALPHA = 0] = "ALPHA", me[me.LOWER = 1] = "LOWER", me[me.MIXED = 2] = "MIXED", me[me.PUNCT = 3] = "PUNCT", me[me.ALPHA_SHIFT = 4] = "ALPHA_SHIFT", me[me.PUNCT_SHIFT = 5] = "PUNCT_SHIFT";
})(Mode$1 || (Mode$1 = {}));
function getBigIntConstructor() {
  if (typeof window < "u")
    return window.BigInt || null;
  if (typeof global < "u")
    return global.BigInt || null;
  if (typeof self < "u")
    return self.BigInt || null;
  throw new Error("Can't search globals for BigInt!");
}
var BigInteger;
function createBigInt(me) {
  if (typeof BigInteger > "u" && (BigInteger = getBigIntConstructor()), BigInteger === null)
    throw new Error("BigInt is not supported!");
  return BigInteger(me);
}
function getEXP900() {
  var me = [];
  me[0] = createBigInt(1);
  var ue = createBigInt(900);
  me[1] = ue;
  for (var Qe = 2; Qe < 16; Qe++)
    me[Qe] = me[Qe - 1] * ue;
  return me;
}
var DecodedBitStreamParser = (
  /** @class */
  function() {
    function me() {
    }
    return me.decode = function(ue, Qe) {
      var Ue = new StringBuilder(""), He = CharacterSetECI.ISO8859_1;
      Ue.enableDecoding(He);
      for (var Ge = 1, Xe = ue[Ge++], Ke = new PDF417ResultMetadata(); Ge < ue[0]; ) {
        switch (Xe) {
          case me.TEXT_COMPACTION_MODE_LATCH:
            Ge = me.textCompaction(ue, Ge, Ue);
            break;
          case me.BYTE_COMPACTION_MODE_LATCH:
          case me.BYTE_COMPACTION_MODE_LATCH_6:
            Ge = me.byteCompaction(Xe, ue, He, Ge, Ue);
            break;
          case me.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
            Ue.append(
              /*(char)*/
              ue[Ge++]
            );
            break;
          case me.NUMERIC_COMPACTION_MODE_LATCH:
            Ge = me.numericCompaction(ue, Ge, Ue);
            break;
          case me.ECI_CHARSET:
            CharacterSetECI.getCharacterSetECIByValue(ue[Ge++]);
            break;
          case me.ECI_GENERAL_PURPOSE:
            Ge += 2;
            break;
          case me.ECI_USER_DEFINED:
            Ge++;
            break;
          case me.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
            Ge = me.decodeMacroBlock(ue, Ge, Ke);
            break;
          case me.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
          case me.MACRO_PDF417_TERMINATOR:
            throw new FormatException();
          default:
            Ge--, Ge = me.textCompaction(ue, Ge, Ue);
            break;
        }
        if (Ge < ue.length)
          Xe = ue[Ge++];
        else
          throw FormatException.getFormatInstance();
      }
      if (Ue.length() === 0)
        throw FormatException.getFormatInstance();
      var $e = new DecoderResult(null, Ue.toString(), null, Qe);
      return $e.setOther(Ke), $e;
    }, me.decodeMacroBlock = function(ue, Qe, Ue) {
      if (Qe + me.NUMBER_OF_SEQUENCE_CODEWORDS > ue[0])
        throw FormatException.getFormatInstance();
      for (var He = new Int32Array(me.NUMBER_OF_SEQUENCE_CODEWORDS), Ge = 0; Ge < me.NUMBER_OF_SEQUENCE_CODEWORDS; Ge++, Qe++)
        He[Ge] = ue[Qe];
      Ue.setSegmentIndex(Integer.parseInt(me.decodeBase900toBase10(He, me.NUMBER_OF_SEQUENCE_CODEWORDS)));
      var Xe = new StringBuilder();
      Qe = me.textCompaction(ue, Qe, Xe), Ue.setFileId(Xe.toString());
      var Ke = -1;
      for (ue[Qe] === me.BEGIN_MACRO_PDF417_OPTIONAL_FIELD && (Ke = Qe + 1); Qe < ue[0]; )
        switch (ue[Qe]) {
          case me.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
            switch (Qe++, ue[Qe]) {
              case me.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME:
                var $e = new StringBuilder();
                Qe = me.textCompaction(ue, Qe + 1, $e), Ue.setFileName($e.toString());
                break;
              case me.MACRO_PDF417_OPTIONAL_FIELD_SENDER:
                var Je = new StringBuilder();
                Qe = me.textCompaction(ue, Qe + 1, Je), Ue.setSender(Je.toString());
                break;
              case me.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE:
                var Ze = new StringBuilder();
                Qe = me.textCompaction(ue, Qe + 1, Ze), Ue.setAddressee(Ze.toString());
                break;
              case me.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT:
                var nt = new StringBuilder();
                Qe = me.numericCompaction(ue, Qe + 1, nt), Ue.setSegmentCount(Integer.parseInt(nt.toString()));
                break;
              case me.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP:
                var tt = new StringBuilder();
                Qe = me.numericCompaction(ue, Qe + 1, tt), Ue.setTimestamp(Long.parseLong(tt.toString()));
                break;
              case me.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM:
                var et = new StringBuilder();
                Qe = me.numericCompaction(ue, Qe + 1, et), Ue.setChecksum(Integer.parseInt(et.toString()));
                break;
              case me.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE:
                var rt = new StringBuilder();
                Qe = me.numericCompaction(ue, Qe + 1, rt), Ue.setFileSize(Long.parseLong(rt.toString()));
                break;
              default:
                throw FormatException.getFormatInstance();
            }
            break;
          case me.MACRO_PDF417_TERMINATOR:
            Qe++, Ue.setLastSegment(!0);
            break;
          default:
            throw FormatException.getFormatInstance();
        }
      if (Ke !== -1) {
        var it = Qe - Ke;
        Ue.isLastSegment() && it--, Ue.setOptionalData(Arrays.copyOfRange(ue, Ke, Ke + it));
      }
      return Qe;
    }, me.textCompaction = function(ue, Qe, Ue) {
      for (var He = new Int32Array((ue[0] - Qe) * 2), Ge = new Int32Array((ue[0] - Qe) * 2), Xe = 0, Ke = !1; Qe < ue[0] && !Ke; ) {
        var $e = ue[Qe++];
        if ($e < me.TEXT_COMPACTION_MODE_LATCH)
          He[Xe] = $e / 30, He[Xe + 1] = $e % 30, Xe += 2;
        else
          switch ($e) {
            case me.TEXT_COMPACTION_MODE_LATCH:
              He[Xe++] = me.TEXT_COMPACTION_MODE_LATCH;
              break;
            case me.BYTE_COMPACTION_MODE_LATCH:
            case me.BYTE_COMPACTION_MODE_LATCH_6:
            case me.NUMERIC_COMPACTION_MODE_LATCH:
            case me.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
            case me.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
            case me.MACRO_PDF417_TERMINATOR:
              Qe--, Ke = !0;
              break;
            case me.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
              He[Xe] = me.MODE_SHIFT_TO_BYTE_COMPACTION_MODE, $e = ue[Qe++], Ge[Xe] = $e, Xe++;
              break;
          }
      }
      return me.decodeTextCompaction(He, Ge, Xe, Ue), Qe;
    }, me.decodeTextCompaction = function(ue, Qe, Ue, He) {
      for (var Ge = Mode$1.ALPHA, Xe = Mode$1.ALPHA, Ke = 0; Ke < Ue; ) {
        var $e = ue[Ke], Je = (
          /*char*/
          ""
        );
        switch (Ge) {
          case Mode$1.ALPHA:
            if ($e < 26)
              Je = /*(char)('A' + subModeCh) */
              String.fromCharCode(65 + $e);
            else
              switch ($e) {
                case 26:
                  Je = " ";
                  break;
                case me.LL:
                  Ge = Mode$1.LOWER;
                  break;
                case me.ML:
                  Ge = Mode$1.MIXED;
                  break;
                case me.PS:
                  Xe = Ge, Ge = Mode$1.PUNCT_SHIFT;
                  break;
                case me.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                  He.append(
                    /*(char)*/
                    Qe[Ke]
                  );
                  break;
                case me.TEXT_COMPACTION_MODE_LATCH:
                  Ge = Mode$1.ALPHA;
                  break;
              }
            break;
          case Mode$1.LOWER:
            if ($e < 26)
              Je = /*(char)('a' + subModeCh)*/
              String.fromCharCode(97 + $e);
            else
              switch ($e) {
                case 26:
                  Je = " ";
                  break;
                case me.AS:
                  Xe = Ge, Ge = Mode$1.ALPHA_SHIFT;
                  break;
                case me.ML:
                  Ge = Mode$1.MIXED;
                  break;
                case me.PS:
                  Xe = Ge, Ge = Mode$1.PUNCT_SHIFT;
                  break;
                case me.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                  He.append(
                    /*(char)*/
                    Qe[Ke]
                  );
                  break;
                case me.TEXT_COMPACTION_MODE_LATCH:
                  Ge = Mode$1.ALPHA;
                  break;
              }
            break;
          case Mode$1.MIXED:
            if ($e < me.PL)
              Je = me.MIXED_CHARS[$e];
            else
              switch ($e) {
                case me.PL:
                  Ge = Mode$1.PUNCT;
                  break;
                case 26:
                  Je = " ";
                  break;
                case me.LL:
                  Ge = Mode$1.LOWER;
                  break;
                case me.AL:
                  Ge = Mode$1.ALPHA;
                  break;
                case me.PS:
                  Xe = Ge, Ge = Mode$1.PUNCT_SHIFT;
                  break;
                case me.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                  He.append(
                    /*(char)*/
                    Qe[Ke]
                  );
                  break;
                case me.TEXT_COMPACTION_MODE_LATCH:
                  Ge = Mode$1.ALPHA;
                  break;
              }
            break;
          case Mode$1.PUNCT:
            if ($e < me.PAL)
              Je = me.PUNCT_CHARS[$e];
            else
              switch ($e) {
                case me.PAL:
                  Ge = Mode$1.ALPHA;
                  break;
                case me.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                  He.append(
                    /*(char)*/
                    Qe[Ke]
                  );
                  break;
                case me.TEXT_COMPACTION_MODE_LATCH:
                  Ge = Mode$1.ALPHA;
                  break;
              }
            break;
          case Mode$1.ALPHA_SHIFT:
            if (Ge = Xe, $e < 26)
              Je = /*(char)('A' + subModeCh)*/
              String.fromCharCode(65 + $e);
            else
              switch ($e) {
                case 26:
                  Je = " ";
                  break;
                case me.TEXT_COMPACTION_MODE_LATCH:
                  Ge = Mode$1.ALPHA;
                  break;
              }
            break;
          case Mode$1.PUNCT_SHIFT:
            if (Ge = Xe, $e < me.PAL)
              Je = me.PUNCT_CHARS[$e];
            else
              switch ($e) {
                case me.PAL:
                  Ge = Mode$1.ALPHA;
                  break;
                case me.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                  He.append(
                    /*(char)*/
                    Qe[Ke]
                  );
                  break;
                case me.TEXT_COMPACTION_MODE_LATCH:
                  Ge = Mode$1.ALPHA;
                  break;
              }
            break;
        }
        Je !== "" && He.append(Je), Ke++;
      }
    }, me.byteCompaction = function(ue, Qe, Ue, He, Ge) {
      var Xe = new ByteArrayOutputStream(), Ke = 0, $e = (
        /*long*/
        0
      ), Je = !1;
      switch (ue) {
        case me.BYTE_COMPACTION_MODE_LATCH:
          for (var Ze = new Int32Array(6), nt = Qe[He++]; He < Qe[0] && !Je; )
            switch (Ze[Ke++] = nt, $e = 900 * $e + nt, nt = Qe[He++], nt) {
              case me.TEXT_COMPACTION_MODE_LATCH:
              case me.BYTE_COMPACTION_MODE_LATCH:
              case me.NUMERIC_COMPACTION_MODE_LATCH:
              case me.BYTE_COMPACTION_MODE_LATCH_6:
              case me.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
              case me.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
              case me.MACRO_PDF417_TERMINATOR:
                He--, Je = !0;
                break;
              default:
                if (Ke % 5 === 0 && Ke > 0) {
                  for (var tt = 0; tt < 6; ++tt)
                    Xe.write(
                      /*(byte)*/
                      Number(createBigInt($e) >> createBigInt(8 * (5 - tt)))
                    );
                  $e = 0, Ke = 0;
                }
                break;
            }
          He === Qe[0] && nt < me.TEXT_COMPACTION_MODE_LATCH && (Ze[Ke++] = nt);
          for (var et = 0; et < Ke; et++)
            Xe.write(
              /*(byte)*/
              Ze[et]
            );
          break;
        case me.BYTE_COMPACTION_MODE_LATCH_6:
          for (; He < Qe[0] && !Je; ) {
            var rt = Qe[He++];
            if (rt < me.TEXT_COMPACTION_MODE_LATCH)
              Ke++, $e = 900 * $e + rt;
            else
              switch (rt) {
                case me.TEXT_COMPACTION_MODE_LATCH:
                case me.BYTE_COMPACTION_MODE_LATCH:
                case me.NUMERIC_COMPACTION_MODE_LATCH:
                case me.BYTE_COMPACTION_MODE_LATCH_6:
                case me.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                case me.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                case me.MACRO_PDF417_TERMINATOR:
                  He--, Je = !0;
                  break;
              }
            if (Ke % 5 === 0 && Ke > 0) {
              for (var tt = 0; tt < 6; ++tt)
                Xe.write(
                  /*(byte)*/
                  Number(createBigInt($e) >> createBigInt(8 * (5 - tt)))
                );
              $e = 0, Ke = 0;
            }
          }
          break;
      }
      return Ge.append(StringEncoding.decode(Xe.toByteArray(), Ue)), He;
    }, me.numericCompaction = function(ue, Qe, Ue) {
      for (var He = 0, Ge = !1, Xe = new Int32Array(me.MAX_NUMERIC_CODEWORDS); Qe < ue[0] && !Ge; ) {
        var Ke = ue[Qe++];
        if (Qe === ue[0] && (Ge = !0), Ke < me.TEXT_COMPACTION_MODE_LATCH)
          Xe[He] = Ke, He++;
        else
          switch (Ke) {
            case me.TEXT_COMPACTION_MODE_LATCH:
            case me.BYTE_COMPACTION_MODE_LATCH:
            case me.BYTE_COMPACTION_MODE_LATCH_6:
            case me.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
            case me.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
            case me.MACRO_PDF417_TERMINATOR:
              Qe--, Ge = !0;
              break;
          }
        (He % me.MAX_NUMERIC_CODEWORDS === 0 || Ke === me.NUMERIC_COMPACTION_MODE_LATCH || Ge) && He > 0 && (Ue.append(me.decodeBase900toBase10(Xe, He)), He = 0);
      }
      return Qe;
    }, me.decodeBase900toBase10 = function(ue, Qe) {
      for (var Ue = createBigInt(0), He = 0; He < Qe; He++)
        Ue += me.EXP900[Qe - He - 1] * createBigInt(ue[He]);
      var Ge = Ue.toString();
      if (Ge.charAt(0) !== "1")
        throw new FormatException();
      return Ge.substring(1);
    }, me.TEXT_COMPACTION_MODE_LATCH = 900, me.BYTE_COMPACTION_MODE_LATCH = 901, me.NUMERIC_COMPACTION_MODE_LATCH = 902, me.BYTE_COMPACTION_MODE_LATCH_6 = 924, me.ECI_USER_DEFINED = 925, me.ECI_GENERAL_PURPOSE = 926, me.ECI_CHARSET = 927, me.BEGIN_MACRO_PDF417_CONTROL_BLOCK = 928, me.BEGIN_MACRO_PDF417_OPTIONAL_FIELD = 923, me.MACRO_PDF417_TERMINATOR = 922, me.MODE_SHIFT_TO_BYTE_COMPACTION_MODE = 913, me.MAX_NUMERIC_CODEWORDS = 15, me.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME = 0, me.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT = 1, me.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP = 2, me.MACRO_PDF417_OPTIONAL_FIELD_SENDER = 3, me.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE = 4, me.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE = 5, me.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM = 6, me.PL = 25, me.LL = 27, me.AS = 27, me.ML = 28, me.AL = 28, me.PS = 29, me.PAL = 29, me.PUNCT_CHARS = `;<>@[\\]_\`~!\r	,:
-.$/"|*()?{}'`, me.MIXED_CHARS = "0123456789&\r	,:#-.$/+%*=^", me.EXP900 = getBigIntConstructor() ? getEXP900() : [], me.NUMBER_OF_SEQUENCE_CODEWORDS = 2, me;
  }()
), __values$9 = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, PDF417ScanningDecoder = (
  /** @class */
  function() {
    function me() {
    }
    return me.decode = function(ue, Qe, Ue, He, Ge, Xe, Ke) {
      for (var $e = new BoundingBox(ue, Qe, Ue, He, Ge), Je = null, Ze = null, nt, tt = !0; ; tt = !1) {
        if (Qe != null && (Je = me.getRowIndicatorColumn(ue, $e, Qe, !0, Xe, Ke)), He != null && (Ze = me.getRowIndicatorColumn(ue, $e, He, !1, Xe, Ke)), nt = me.merge(Je, Ze), nt == null)
          throw NotFoundException.getNotFoundInstance();
        var et = nt.getBoundingBox();
        if (tt && et != null && (et.getMinY() < $e.getMinY() || et.getMaxY() > $e.getMaxY()))
          $e = et;
        else
          break;
      }
      nt.setBoundingBox($e);
      var rt = nt.getBarcodeColumnCount() + 1;
      nt.setDetectionResultColumn(0, Je), nt.setDetectionResultColumn(rt, Ze);
      for (var it = Je != null, ot = 1; ot <= rt; ot++) {
        var at = it ? ot : rt - ot;
        if (nt.getDetectionResultColumn(at) === /* null */
        void 0) {
          var st = void 0;
          at === 0 || at === rt ? st = new DetectionResultRowIndicatorColumn($e, at === 0) : st = new DetectionResultColumn($e), nt.setDetectionResultColumn(at, st);
          for (var ut = -1, lt = ut, dt = $e.getMinY(); dt <= $e.getMaxY(); dt++) {
            if (ut = me.getStartColumn(nt, at, dt, it), ut < 0 || ut > $e.getMaxX()) {
              if (lt === -1)
                continue;
              ut = lt;
            }
            var At = me.detectCodeword(ue, $e.getMinX(), $e.getMaxX(), it, ut, dt, Xe, Ke);
            At != null && (st.setCodeword(dt, At), lt = ut, Xe = Math.min(Xe, At.getWidth()), Ke = Math.max(Ke, At.getWidth()));
          }
        }
      }
      return me.createDecoderResult(nt);
    }, me.merge = function(ue, Qe) {
      if (ue == null && Qe == null)
        return null;
      var Ue = me.getBarcodeMetadata(ue, Qe);
      if (Ue == null)
        return null;
      var He = BoundingBox.merge(me.adjustBoundingBox(ue), me.adjustBoundingBox(Qe));
      return new DetectionResult(Ue, He);
    }, me.adjustBoundingBox = function(ue) {
      var Qe, Ue;
      if (ue == null)
        return null;
      var He = ue.getRowHeights();
      if (He == null)
        return null;
      var Ge = me.getMax(He), Xe = 0;
      try {
        for (var Ke = __values$9(He), $e = Ke.next(); !$e.done; $e = Ke.next()) {
          var Je = $e.value;
          if (Xe += Ge - Je, Je > 0)
            break;
        }
      } catch (et) {
        Qe = { error: et };
      } finally {
        try {
          $e && !$e.done && (Ue = Ke.return) && Ue.call(Ke);
        } finally {
          if (Qe) throw Qe.error;
        }
      }
      for (var Ze = ue.getCodewords(), nt = 0; Xe > 0 && Ze[nt] == null; nt++)
        Xe--;
      for (var tt = 0, nt = He.length - 1; nt >= 0 && (tt += Ge - He[nt], !(He[nt] > 0)); nt--)
        ;
      for (var nt = Ze.length - 1; tt > 0 && Ze[nt] == null; nt--)
        tt--;
      return ue.getBoundingBox().addMissingRows(Xe, tt, ue.isLeft());
    }, me.getMax = function(ue) {
      var Qe, Ue, He = -1;
      try {
        for (var Ge = __values$9(ue), Xe = Ge.next(); !Xe.done; Xe = Ge.next()) {
          var Ke = Xe.value;
          He = Math.max(He, Ke);
        }
      } catch ($e) {
        Qe = { error: $e };
      } finally {
        try {
          Xe && !Xe.done && (Ue = Ge.return) && Ue.call(Ge);
        } finally {
          if (Qe) throw Qe.error;
        }
      }
      return He;
    }, me.getBarcodeMetadata = function(ue, Qe) {
      var Ue;
      if (ue == null || (Ue = ue.getBarcodeMetadata()) == null)
        return Qe == null ? null : Qe.getBarcodeMetadata();
      var He;
      return Qe == null || (He = Qe.getBarcodeMetadata()) == null ? Ue : Ue.getColumnCount() !== He.getColumnCount() && Ue.getErrorCorrectionLevel() !== He.getErrorCorrectionLevel() && Ue.getRowCount() !== He.getRowCount() ? null : Ue;
    }, me.getRowIndicatorColumn = function(ue, Qe, Ue, He, Ge, Xe) {
      for (var Ke = new DetectionResultRowIndicatorColumn(Qe, He), $e = 0; $e < 2; $e++)
        for (var Je = $e === 0 ? 1 : -1, Ze = Math.trunc(Math.trunc(Ue.getX())), nt = Math.trunc(Math.trunc(Ue.getY())); nt <= Qe.getMaxY() && nt >= Qe.getMinY(); nt += Je) {
          var tt = me.detectCodeword(ue, 0, ue.getWidth(), He, Ze, nt, Ge, Xe);
          tt != null && (Ke.setCodeword(nt, tt), He ? Ze = tt.getStartX() : Ze = tt.getEndX());
        }
      return Ke;
    }, me.adjustCodewordCount = function(ue, Qe) {
      var Ue = Qe[0][1], He = Ue.getValue(), Ge = ue.getBarcodeColumnCount() * ue.getBarcodeRowCount() - me.getNumberOfECCodeWords(ue.getBarcodeECLevel());
      if (He.length === 0) {
        if (Ge < 1 || Ge > PDF417Common.MAX_CODEWORDS_IN_BARCODE)
          throw NotFoundException.getNotFoundInstance();
        Ue.setValue(Ge);
      } else He[0] !== Ge && Ue.setValue(Ge);
    }, me.createDecoderResult = function(ue) {
      var Qe = me.createBarcodeMatrix(ue);
      me.adjustCodewordCount(ue, Qe);
      for (var Ue = new Array(), He = new Int32Array(ue.getBarcodeRowCount() * ue.getBarcodeColumnCount()), Ge = (
        /*List<int[]>*/
        []
      ), Xe = (
        /*Collection<Integer>*/
        new Array()
      ), Ke = 0; Ke < ue.getBarcodeRowCount(); Ke++)
        for (var $e = 0; $e < ue.getBarcodeColumnCount(); $e++) {
          var Je = Qe[Ke][$e + 1].getValue(), Ze = Ke * ue.getBarcodeColumnCount() + $e;
          Je.length === 0 ? Ue.push(Ze) : Je.length === 1 ? He[Ze] = Je[0] : (Xe.push(Ze), Ge.push(Je));
        }
      for (var nt = new Array(Ge.length), tt = 0; tt < nt.length; tt++)
        nt[tt] = Ge[tt];
      return me.createDecoderResultFromAmbiguousValues(ue.getBarcodeECLevel(), He, PDF417Common.toIntArray(Ue), PDF417Common.toIntArray(Xe), nt);
    }, me.createDecoderResultFromAmbiguousValues = function(ue, Qe, Ue, He, Ge) {
      for (var Xe = new Int32Array(He.length), Ke = 100; Ke-- > 0; ) {
        for (var $e = 0; $e < Xe.length; $e++)
          Qe[He[$e]] = Ge[$e][Xe[$e]];
        try {
          return me.decodeCodewords(Qe, ue, Ue);
        } catch (Ze) {
          var Je = Ze instanceof ChecksumException;
          if (!Je)
            throw Ze;
        }
        if (Xe.length === 0)
          throw ChecksumException.getChecksumInstance();
        for (var $e = 0; $e < Xe.length; $e++)
          if (Xe[$e] < Ge[$e].length - 1) {
            Xe[$e]++;
            break;
          } else if (Xe[$e] = 0, $e === Xe.length - 1)
            throw ChecksumException.getChecksumInstance();
      }
      throw ChecksumException.getChecksumInstance();
    }, me.createBarcodeMatrix = function(ue) {
      for (var Qe, Ue, He, Ge, Xe = Array.from({ length: ue.getBarcodeRowCount() }, function() {
        return new Array(ue.getBarcodeColumnCount() + 2);
      }), Ke = 0; Ke < Xe.length; Ke++)
        for (var $e = 0; $e < Xe[Ke].length; $e++)
          Xe[Ke][$e] = new BarcodeValue();
      var Je = 0;
      try {
        for (var Ze = __values$9(ue.getDetectionResultColumns()), nt = Ze.next(); !nt.done; nt = Ze.next()) {
          var tt = nt.value;
          if (tt != null)
            try {
              for (var et = (He = void 0, __values$9(tt.getCodewords())), rt = et.next(); !rt.done; rt = et.next()) {
                var it = rt.value;
                if (it != null) {
                  var ot = it.getRowNumber();
                  if (ot >= 0) {
                    if (ot >= Xe.length)
                      continue;
                    Xe[ot][Je].setValue(it.getValue());
                  }
                }
              }
            } catch (at) {
              He = { error: at };
            } finally {
              try {
                rt && !rt.done && (Ge = et.return) && Ge.call(et);
              } finally {
                if (He) throw He.error;
              }
            }
          Je++;
        }
      } catch (at) {
        Qe = { error: at };
      } finally {
        try {
          nt && !nt.done && (Ue = Ze.return) && Ue.call(Ze);
        } finally {
          if (Qe) throw Qe.error;
        }
      }
      return Xe;
    }, me.isValidBarcodeColumn = function(ue, Qe) {
      return Qe >= 0 && Qe <= ue.getBarcodeColumnCount() + 1;
    }, me.getStartColumn = function(ue, Qe, Ue, He) {
      var Ge, Xe, Ke = He ? 1 : -1, $e = null;
      if (me.isValidBarcodeColumn(ue, Qe - Ke) && ($e = ue.getDetectionResultColumn(Qe - Ke).getCodeword(Ue)), $e != null)
        return He ? $e.getEndX() : $e.getStartX();
      if ($e = ue.getDetectionResultColumn(Qe).getCodewordNearby(Ue), $e != null)
        return He ? $e.getStartX() : $e.getEndX();
      if (me.isValidBarcodeColumn(ue, Qe - Ke) && ($e = ue.getDetectionResultColumn(Qe - Ke).getCodewordNearby(Ue)), $e != null)
        return He ? $e.getEndX() : $e.getStartX();
      for (var Je = 0; me.isValidBarcodeColumn(ue, Qe - Ke); ) {
        Qe -= Ke;
        try {
          for (var Ze = (Ge = void 0, __values$9(ue.getDetectionResultColumn(Qe).getCodewords())), nt = Ze.next(); !nt.done; nt = Ze.next()) {
            var tt = nt.value;
            if (tt != null)
              return (He ? tt.getEndX() : tt.getStartX()) + Ke * Je * (tt.getEndX() - tt.getStartX());
          }
        } catch (et) {
          Ge = { error: et };
        } finally {
          try {
            nt && !nt.done && (Xe = Ze.return) && Xe.call(Ze);
          } finally {
            if (Ge) throw Ge.error;
          }
        }
        Je++;
      }
      return He ? ue.getBoundingBox().getMinX() : ue.getBoundingBox().getMaxX();
    }, me.detectCodeword = function(ue, Qe, Ue, He, Ge, Xe, Ke, $e) {
      Ge = me.adjustCodewordStartColumn(ue, Qe, Ue, He, Ge, Xe);
      var Je = me.getModuleBitCount(ue, Qe, Ue, He, Ge, Xe);
      if (Je == null)
        return null;
      var Ze, nt = MathUtils.sum(Je);
      if (He)
        Ze = Ge + nt;
      else {
        for (var tt = 0; tt < Je.length / 2; tt++) {
          var et = Je[tt];
          Je[tt] = Je[Je.length - 1 - tt], Je[Je.length - 1 - tt] = et;
        }
        Ze = Ge, Ge = Ze - nt;
      }
      if (!me.checkCodewordSkew(nt, Ke, $e))
        return null;
      var rt = PDF417CodewordDecoder.getDecodedValue(Je), it = PDF417Common.getCodeword(rt);
      return it === -1 ? null : new Codeword(Ge, Ze, me.getCodewordBucketNumber(rt), it);
    }, me.getModuleBitCount = function(ue, Qe, Ue, He, Ge, Xe) {
      for (var Ke = Ge, $e = new Int32Array(8), Je = 0, Ze = He ? 1 : -1, nt = He; (He ? Ke < Ue : Ke >= Qe) && Je < $e.length; )
        ue.get(Ke, Xe) === nt ? ($e[Je]++, Ke += Ze) : (Je++, nt = !nt);
      return Je === $e.length || Ke === (He ? Ue : Qe) && Je === $e.length - 1 ? $e : null;
    }, me.getNumberOfECCodeWords = function(ue) {
      return 2 << ue;
    }, me.adjustCodewordStartColumn = function(ue, Qe, Ue, He, Ge, Xe) {
      for (var Ke = Ge, $e = He ? -1 : 1, Je = 0; Je < 2; Je++) {
        for (; (He ? Ke >= Qe : Ke < Ue) && He === ue.get(Ke, Xe); ) {
          if (Math.abs(Ge - Ke) > me.CODEWORD_SKEW_SIZE)
            return Ge;
          Ke += $e;
        }
        $e = -$e, He = !He;
      }
      return Ke;
    }, me.checkCodewordSkew = function(ue, Qe, Ue) {
      return Qe - me.CODEWORD_SKEW_SIZE <= ue && ue <= Ue + me.CODEWORD_SKEW_SIZE;
    }, me.decodeCodewords = function(ue, Qe, Ue) {
      if (ue.length === 0)
        throw FormatException.getFormatInstance();
      var He = 1 << Qe + 1, Ge = me.correctErrors(ue, Ue, He);
      me.verifyCodewordCount(ue, He);
      var Xe = DecodedBitStreamParser.decode(ue, "" + Qe);
      return Xe.setErrorsCorrected(Ge), Xe.setErasures(Ue.length), Xe;
    }, me.correctErrors = function(ue, Qe, Ue) {
      if (Qe != null && Qe.length > Ue / 2 + me.MAX_ERRORS || Ue < 0 || Ue > me.MAX_EC_CODEWORDS)
        throw ChecksumException.getChecksumInstance();
      return me.errorCorrection.decode(ue, Ue, Qe);
    }, me.verifyCodewordCount = function(ue, Qe) {
      if (ue.length < 4)
        throw FormatException.getFormatInstance();
      var Ue = ue[0];
      if (Ue > ue.length)
        throw FormatException.getFormatInstance();
      if (Ue === 0)
        if (Qe < ue.length)
          ue[0] = ue.length - Qe;
        else
          throw FormatException.getFormatInstance();
    }, me.getBitCountForCodeword = function(ue) {
      for (var Qe = new Int32Array(8), Ue = 0, He = Qe.length - 1; !((ue & 1) !== Ue && (Ue = ue & 1, He--, He < 0)); )
        Qe[He]++, ue >>= 1;
      return Qe;
    }, me.getCodewordBucketNumber = function(ue) {
      return ue instanceof Int32Array ? this.getCodewordBucketNumber_Int32Array(ue) : this.getCodewordBucketNumber_number(ue);
    }, me.getCodewordBucketNumber_number = function(ue) {
      return me.getCodewordBucketNumber(me.getBitCountForCodeword(ue));
    }, me.getCodewordBucketNumber_Int32Array = function(ue) {
      return (ue[0] - ue[2] + ue[4] - ue[6] + 9) % 9;
    }, me.toString = function(ue) {
      for (var Qe = new Formatter(), Ue = 0; Ue < ue.length; Ue++) {
        Qe.format("Row %2d: ", Ue);
        for (var He = 0; He < ue[Ue].length; He++) {
          var Ge = ue[Ue][He];
          Ge.getValue().length === 0 ? Qe.format("        ", null) : Qe.format("%4d(%2d)", Ge.getValue()[0], Ge.getConfidence(Ge.getValue()[0]));
        }
        Qe.format("%n");
      }
      return Qe.toString();
    }, me.CODEWORD_SKEW_SIZE = 2, me.MAX_ERRORS = 3, me.MAX_EC_CODEWORDS = 512, me.errorCorrection = new ErrorCorrection(), me;
  }()
), __values$8 = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, PDF417Reader = (
  /** @class */
  function() {
    function me() {
    }
    return me.prototype.decode = function(ue, Qe) {
      Qe === void 0 && (Qe = null);
      var Ue = me.decode(ue, Qe, !1);
      if (Ue == null || Ue.length === 0 || Ue[0] == null)
        throw NotFoundException.getNotFoundInstance();
      return Ue[0];
    }, me.prototype.decodeMultiple = function(ue, Qe) {
      Qe === void 0 && (Qe = null);
      try {
        return me.decode(ue, Qe, !0);
      } catch (Ue) {
        throw Ue instanceof FormatException || Ue instanceof ChecksumException ? NotFoundException.getNotFoundInstance() : Ue;
      }
    }, me.decode = function(ue, Qe, Ue) {
      var He, Ge, Xe = new Array(), Ke = Detector.detectMultiple(ue, Qe, Ue);
      try {
        for (var $e = __values$8(Ke.getPoints()), Je = $e.next(); !Je.done; Je = $e.next()) {
          var Ze = Je.value, nt = PDF417ScanningDecoder.decode(Ke.getBits(), Ze[4], Ze[5], Ze[6], Ze[7], me.getMinCodewordWidth(Ze), me.getMaxCodewordWidth(Ze)), tt = new Result(nt.getText(), nt.getRawBytes(), void 0, Ze, BarcodeFormat$1.PDF_417);
          tt.putMetadata(ResultMetadataType$1.ERROR_CORRECTION_LEVEL, nt.getECLevel());
          var et = nt.getOther();
          et != null && tt.putMetadata(ResultMetadataType$1.PDF417_EXTRA_METADATA, et), Xe.push(tt);
        }
      } catch (rt) {
        He = { error: rt };
      } finally {
        try {
          Je && !Je.done && (Ge = $e.return) && Ge.call($e);
        } finally {
          if (He) throw He.error;
        }
      }
      return Xe.map(function(rt) {
        return rt;
      });
    }, me.getMaxWidth = function(ue, Qe) {
      return ue == null || Qe == null ? 0 : Math.trunc(Math.abs(ue.getX() - Qe.getX()));
    }, me.getMinWidth = function(ue, Qe) {
      return ue == null || Qe == null ? Integer.MAX_VALUE : Math.trunc(Math.abs(ue.getX() - Qe.getX()));
    }, me.getMaxCodewordWidth = function(ue) {
      return Math.floor(Math.max(Math.max(me.getMaxWidth(ue[0], ue[4]), me.getMaxWidth(ue[6], ue[2]) * PDF417Common.MODULES_IN_CODEWORD / PDF417Common.MODULES_IN_STOP_PATTERN), Math.max(me.getMaxWidth(ue[1], ue[5]), me.getMaxWidth(ue[7], ue[3]) * PDF417Common.MODULES_IN_CODEWORD / PDF417Common.MODULES_IN_STOP_PATTERN)));
    }, me.getMinCodewordWidth = function(ue) {
      return Math.floor(Math.min(Math.min(me.getMinWidth(ue[0], ue[4]), me.getMinWidth(ue[6], ue[2]) * PDF417Common.MODULES_IN_CODEWORD / PDF417Common.MODULES_IN_STOP_PATTERN), Math.min(me.getMinWidth(ue[1], ue[5]), me.getMinWidth(ue[7], ue[3]) * PDF417Common.MODULES_IN_CODEWORD / PDF417Common.MODULES_IN_STOP_PATTERN)));
    }, me.prototype.reset = function() {
    }, me;
  }()
), __extends$g = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), ReaderException = (
  /** @class */
  function(me) {
    __extends$g(ue, me);
    function ue() {
      return me !== null && me.apply(this, arguments) || this;
    }
    return ue.kind = "ReaderException", ue;
  }(Exception)
), __values$7 = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, MultiFormatReader = (
  /** @class */
  function() {
    function me() {
    }
    return me.prototype.decode = function(ue, Qe) {
      return this.setHints(Qe), this.decodeInternal(ue);
    }, me.prototype.decodeWithState = function(ue) {
      return (this.readers === null || this.readers === void 0) && this.setHints(null), this.decodeInternal(ue);
    }, me.prototype.setHints = function(ue) {
      this.hints = ue;
      var Qe = ue != null && ue.get(DecodeHintType$1.TRY_HARDER) !== void 0, Ue = ue == null ? null : ue.get(DecodeHintType$1.POSSIBLE_FORMATS), He = new Array();
      if (Ue != null) {
        var Ge = Ue.some(function(Xe) {
          return Xe === BarcodeFormat$1.UPC_A || Xe === BarcodeFormat$1.UPC_E || Xe === BarcodeFormat$1.EAN_13 || Xe === BarcodeFormat$1.EAN_8 || Xe === BarcodeFormat$1.CODABAR || Xe === BarcodeFormat$1.CODE_39 || Xe === BarcodeFormat$1.CODE_93 || Xe === BarcodeFormat$1.CODE_128 || Xe === BarcodeFormat$1.ITF || Xe === BarcodeFormat$1.RSS_14 || Xe === BarcodeFormat$1.RSS_EXPANDED;
        });
        Ge && !Qe && He.push(new MultiFormatOneDReader(ue)), Ue.includes(BarcodeFormat$1.QR_CODE) && He.push(new QRCodeReader()), Ue.includes(BarcodeFormat$1.DATA_MATRIX) && He.push(new DataMatrixReader()), Ue.includes(BarcodeFormat$1.AZTEC) && He.push(new AztecReader()), Ue.includes(BarcodeFormat$1.PDF_417) && He.push(new PDF417Reader()), Ge && Qe && He.push(new MultiFormatOneDReader(ue));
      }
      He.length === 0 && (Qe || He.push(new MultiFormatOneDReader(ue)), He.push(new QRCodeReader()), He.push(new DataMatrixReader()), He.push(new AztecReader()), He.push(new PDF417Reader()), Qe && He.push(new MultiFormatOneDReader(ue))), this.readers = He;
    }, me.prototype.reset = function() {
      var ue, Qe;
      if (this.readers !== null)
        try {
          for (var Ue = __values$7(this.readers), He = Ue.next(); !He.done; He = Ue.next()) {
            var Ge = He.value;
            Ge.reset();
          }
        } catch (Xe) {
          ue = { error: Xe };
        } finally {
          try {
            He && !He.done && (Qe = Ue.return) && Qe.call(Ue);
          } finally {
            if (ue) throw ue.error;
          }
        }
    }, me.prototype.decodeInternal = function(ue) {
      var Qe, Ue;
      if (this.readers === null)
        throw new ReaderException("No readers where selected, nothing can be read.");
      try {
        for (var He = __values$7(this.readers), Ge = He.next(); !Ge.done; Ge = He.next()) {
          var Xe = Ge.value;
          try {
            return Xe.decode(ue, this.hints);
          } catch (Ke) {
            if (Ke instanceof ReaderException)
              continue;
          }
        }
      } catch (Ke) {
        Qe = { error: Ke };
      } finally {
        try {
          Ge && !Ge.done && (Ue = He.return) && Ue.call(He);
        } finally {
          if (Qe) throw Qe.error;
        }
      }
      throw new NotFoundException("No MultiFormat Readers were able to detect the code.");
    }, me;
  }()
), __extends$f = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}();
(function(me) {
  __extends$f(ue, me);
  function ue(Qe, Ue) {
    Qe === void 0 && (Qe = null), Ue === void 0 && (Ue = 500);
    var He = this, Ge = new MultiFormatReader();
    return Ge.setHints(Qe), He = me.call(this, Ge, Ue) || this, He;
  }
  return ue.prototype.decodeBitmap = function(Qe) {
    return this.reader.decodeWithState(Qe);
  }, ue;
})(BrowserCodeReader$1);
var __extends$e = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}();
(function(me) {
  __extends$e(ue, me);
  function ue(Qe) {
    return Qe === void 0 && (Qe = 500), me.call(this, new PDF417Reader(), Qe) || this;
  }
  return ue;
})(BrowserCodeReader$1);
var __extends$d = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}();
(function(me) {
  __extends$d(ue, me);
  function ue(Qe) {
    return Qe === void 0 && (Qe = 500), me.call(this, new QRCodeReader(), Qe) || this;
  }
  return ue;
})(BrowserCodeReader$1);
var EncodeHintType;
(function(me) {
  me[me.ERROR_CORRECTION = 0] = "ERROR_CORRECTION", me[me.CHARACTER_SET = 1] = "CHARACTER_SET", me[me.DATA_MATRIX_SHAPE = 2] = "DATA_MATRIX_SHAPE", me[me.MIN_SIZE = 3] = "MIN_SIZE", me[me.MAX_SIZE = 4] = "MAX_SIZE", me[me.MARGIN = 5] = "MARGIN", me[me.PDF417_COMPACT = 6] = "PDF417_COMPACT", me[me.PDF417_COMPACTION = 7] = "PDF417_COMPACTION", me[me.PDF417_DIMENSIONS = 8] = "PDF417_DIMENSIONS", me[me.AZTEC_LAYERS = 9] = "AZTEC_LAYERS", me[me.QR_VERSION = 10] = "QR_VERSION";
})(EncodeHintType || (EncodeHintType = {}));
const EncodeHintType$1 = EncodeHintType;
var ReedSolomonEncoder = (
  /** @class */
  function() {
    function me(ue) {
      this.field = ue, this.cachedGenerators = [], this.cachedGenerators.push(new GenericGFPoly(ue, Int32Array.from([1])));
    }
    return me.prototype.buildGenerator = function(ue) {
      var Qe = this.cachedGenerators;
      if (ue >= Qe.length)
        for (var Ue = Qe[Qe.length - 1], He = this.field, Ge = Qe.length; Ge <= ue; Ge++) {
          var Xe = Ue.multiply(new GenericGFPoly(He, Int32Array.from([1, He.exp(Ge - 1 + He.getGeneratorBase())])));
          Qe.push(Xe), Ue = Xe;
        }
      return Qe[ue];
    }, me.prototype.encode = function(ue, Qe) {
      if (Qe === 0)
        throw new IllegalArgumentException("No error correction bytes");
      var Ue = ue.length - Qe;
      if (Ue <= 0)
        throw new IllegalArgumentException("No data bytes provided");
      var He = this.buildGenerator(Qe), Ge = new Int32Array(Ue);
      System.arraycopy(ue, 0, Ge, 0, Ue);
      var Xe = new GenericGFPoly(this.field, Ge);
      Xe = Xe.multiplyByMonomial(Qe, 1);
      for (var Ke = Xe.divide(He)[1], $e = Ke.getCoefficients(), Je = Qe - $e.length, Ze = 0; Ze < Je; Ze++)
        ue[Ue + Ze] = 0;
      System.arraycopy($e, 0, ue, Ue + Je, $e.length);
    }, me;
  }()
), MaskUtil = (
  /** @class */
  function() {
    function me() {
    }
    return me.applyMaskPenaltyRule1 = function(ue) {
      return me.applyMaskPenaltyRule1Internal(ue, !0) + me.applyMaskPenaltyRule1Internal(ue, !1);
    }, me.applyMaskPenaltyRule2 = function(ue) {
      for (var Qe = 0, Ue = ue.getArray(), He = ue.getWidth(), Ge = ue.getHeight(), Xe = 0; Xe < Ge - 1; Xe++)
        for (var Ke = Ue[Xe], $e = 0; $e < He - 1; $e++) {
          var Je = Ke[$e];
          Je === Ke[$e + 1] && Je === Ue[Xe + 1][$e] && Je === Ue[Xe + 1][$e + 1] && Qe++;
        }
      return me.N2 * Qe;
    }, me.applyMaskPenaltyRule3 = function(ue) {
      for (var Qe = 0, Ue = ue.getArray(), He = ue.getWidth(), Ge = ue.getHeight(), Xe = 0; Xe < Ge; Xe++)
        for (var Ke = 0; Ke < He; Ke++) {
          var $e = Ue[Xe];
          Ke + 6 < He && $e[Ke] === 1 && $e[Ke + 1] === 0 && $e[Ke + 2] === 1 && $e[Ke + 3] === 1 && $e[Ke + 4] === 1 && $e[Ke + 5] === 0 && $e[Ke + 6] === 1 && (me.isWhiteHorizontal($e, Ke - 4, Ke) || me.isWhiteHorizontal($e, Ke + 7, Ke + 11)) && Qe++, Xe + 6 < Ge && Ue[Xe][Ke] === 1 && Ue[Xe + 1][Ke] === 0 && Ue[Xe + 2][Ke] === 1 && Ue[Xe + 3][Ke] === 1 && Ue[Xe + 4][Ke] === 1 && Ue[Xe + 5][Ke] === 0 && Ue[Xe + 6][Ke] === 1 && (me.isWhiteVertical(Ue, Ke, Xe - 4, Xe) || me.isWhiteVertical(Ue, Ke, Xe + 7, Xe + 11)) && Qe++;
        }
      return Qe * me.N3;
    }, me.isWhiteHorizontal = function(ue, Qe, Ue) {
      Qe = Math.max(Qe, 0), Ue = Math.min(Ue, ue.length);
      for (var He = Qe; He < Ue; He++)
        if (ue[He] === 1)
          return !1;
      return !0;
    }, me.isWhiteVertical = function(ue, Qe, Ue, He) {
      Ue = Math.max(Ue, 0), He = Math.min(He, ue.length);
      for (var Ge = Ue; Ge < He; Ge++)
        if (ue[Ge][Qe] === 1)
          return !1;
      return !0;
    }, me.applyMaskPenaltyRule4 = function(ue) {
      for (var Qe = 0, Ue = ue.getArray(), He = ue.getWidth(), Ge = ue.getHeight(), Xe = 0; Xe < Ge; Xe++)
        for (var Ke = Ue[Xe], $e = 0; $e < He; $e++)
          Ke[$e] === 1 && Qe++;
      var Je = ue.getHeight() * ue.getWidth(), Ze = Math.floor(Math.abs(Qe * 2 - Je) * 10 / Je);
      return Ze * me.N4;
    }, me.getDataMaskBit = function(ue, Qe, Ue) {
      var He, Ge;
      switch (ue) {
        case 0:
          He = Ue + Qe & 1;
          break;
        case 1:
          He = Ue & 1;
          break;
        case 2:
          He = Qe % 3;
          break;
        case 3:
          He = (Ue + Qe) % 3;
          break;
        case 4:
          He = Math.floor(Ue / 2) + Math.floor(Qe / 3) & 1;
          break;
        case 5:
          Ge = Ue * Qe, He = (Ge & 1) + Ge % 3;
          break;
        case 6:
          Ge = Ue * Qe, He = (Ge & 1) + Ge % 3 & 1;
          break;
        case 7:
          Ge = Ue * Qe, He = Ge % 3 + (Ue + Qe & 1) & 1;
          break;
        default:
          throw new IllegalArgumentException("Invalid mask pattern: " + ue);
      }
      return He === 0;
    }, me.applyMaskPenaltyRule1Internal = function(ue, Qe) {
      for (var Ue = 0, He = Qe ? ue.getHeight() : ue.getWidth(), Ge = Qe ? ue.getWidth() : ue.getHeight(), Xe = ue.getArray(), Ke = 0; Ke < He; Ke++) {
        for (var $e = 0, Je = -1, Ze = 0; Ze < Ge; Ze++) {
          var nt = Qe ? Xe[Ke][Ze] : Xe[Ze][Ke];
          nt === Je ? $e++ : ($e >= 5 && (Ue += me.N1 + ($e - 5)), $e = 1, Je = nt);
        }
        $e >= 5 && (Ue += me.N1 + ($e - 5));
      }
      return Ue;
    }, me.N1 = 3, me.N2 = 3, me.N3 = 40, me.N4 = 10, me;
  }()
), __values$6 = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, ByteMatrix = (
  /** @class */
  function() {
    function me(ue, Qe) {
      this.width = ue, this.height = Qe;
      for (var Ue = new Array(Qe), He = 0; He !== Qe; He++)
        Ue[He] = new Uint8Array(ue);
      this.bytes = Ue;
    }
    return me.prototype.getHeight = function() {
      return this.height;
    }, me.prototype.getWidth = function() {
      return this.width;
    }, me.prototype.get = function(ue, Qe) {
      return this.bytes[Qe][ue];
    }, me.prototype.getArray = function() {
      return this.bytes;
    }, me.prototype.setNumber = function(ue, Qe, Ue) {
      this.bytes[Qe][ue] = Ue;
    }, me.prototype.setBoolean = function(ue, Qe, Ue) {
      this.bytes[Qe][ue] = /*(byte) */
      Ue ? 1 : 0;
    }, me.prototype.clear = function(ue) {
      var Qe, Ue;
      try {
        for (var He = __values$6(this.bytes), Ge = He.next(); !Ge.done; Ge = He.next()) {
          var Xe = Ge.value;
          Arrays.fill(Xe, ue);
        }
      } catch (Ke) {
        Qe = { error: Ke };
      } finally {
        try {
          Ge && !Ge.done && (Ue = He.return) && Ue.call(He);
        } finally {
          if (Qe) throw Qe.error;
        }
      }
    }, me.prototype.equals = function(ue) {
      if (!(ue instanceof me))
        return !1;
      var Qe = ue;
      if (this.width !== Qe.width || this.height !== Qe.height)
        return !1;
      for (var Ue = 0, He = this.height; Ue < He; ++Ue)
        for (var Ge = this.bytes[Ue], Xe = Qe.bytes[Ue], Ke = 0, $e = this.width; Ke < $e; ++Ke)
          if (Ge[Ke] !== Xe[Ke])
            return !1;
      return !0;
    }, me.prototype.toString = function() {
      for (var ue = new StringBuilder(), Qe = 0, Ue = this.height; Qe < Ue; ++Qe) {
        for (var He = this.bytes[Qe], Ge = 0, Xe = this.width; Ge < Xe; ++Ge)
          switch (He[Ge]) {
            case 0:
              ue.append(" 0");
              break;
            case 1:
              ue.append(" 1");
              break;
            default:
              ue.append("  ");
              break;
          }
        ue.append(`
`);
      }
      return ue.toString();
    }, me;
  }()
), QRCode$2 = (
  /** @class */
  function() {
    function me() {
      this.maskPattern = -1;
    }
    return me.prototype.getMode = function() {
      return this.mode;
    }, me.prototype.getECLevel = function() {
      return this.ecLevel;
    }, me.prototype.getVersion = function() {
      return this.version;
    }, me.prototype.getMaskPattern = function() {
      return this.maskPattern;
    }, me.prototype.getMatrix = function() {
      return this.matrix;
    }, me.prototype.toString = function() {
      var ue = new StringBuilder();
      return ue.append(`<<
`), ue.append(" mode: "), ue.append(this.mode ? this.mode.toString() : "null"), ue.append(`
 ecLevel: `), ue.append(this.ecLevel ? this.ecLevel.toString() : "null"), ue.append(`
 version: `), ue.append(this.version ? this.version.toString() : "null"), ue.append(`
 maskPattern: `), ue.append(this.maskPattern.toString()), this.matrix ? (ue.append(`
 matrix:
`), ue.append(this.matrix.toString())) : ue.append(`
 matrix: null
`), ue.append(`>>
`), ue.toString();
    }, me.prototype.setMode = function(ue) {
      this.mode = ue;
    }, me.prototype.setECLevel = function(ue) {
      this.ecLevel = ue;
    }, me.prototype.setVersion = function(ue) {
      this.version = ue;
    }, me.prototype.setMaskPattern = function(ue) {
      this.maskPattern = ue;
    }, me.prototype.setMatrix = function(ue) {
      this.matrix = ue;
    }, me.isValidMaskPattern = function(ue) {
      return ue >= 0 && ue < me.NUM_MASK_PATTERNS;
    }, me.NUM_MASK_PATTERNS = 8, me;
  }()
), __extends$c = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), WriterException = (
  /** @class */
  function(me) {
    __extends$c(ue, me);
    function ue() {
      return me !== null && me.apply(this, arguments) || this;
    }
    return ue.kind = "WriterException", ue;
  }(Exception)
), MatrixUtil = (
  /** @class */
  function() {
    function me() {
    }
    return me.clearMatrix = function(ue) {
      ue.clear(
        /*(byte) */
        /*-1*/
        255
      );
    }, me.buildMatrix = function(ue, Qe, Ue, He, Ge) {
      me.clearMatrix(Ge), me.embedBasicPatterns(Ue, Ge), me.embedTypeInfo(Qe, He, Ge), me.maybeEmbedVersionInfo(Ue, Ge), me.embedDataBits(ue, He, Ge);
    }, me.embedBasicPatterns = function(ue, Qe) {
      me.embedPositionDetectionPatternsAndSeparators(Qe), me.embedDarkDotAtLeftBottomCorner(Qe), me.maybeEmbedPositionAdjustmentPatterns(ue, Qe), me.embedTimingPatterns(Qe);
    }, me.embedTypeInfo = function(ue, Qe, Ue) {
      var He = new BitArray();
      me.makeTypeInfoBits(ue, Qe, He);
      for (var Ge = 0, Xe = He.getSize(); Ge < Xe; ++Ge) {
        var Ke = He.get(He.getSize() - 1 - Ge), $e = me.TYPE_INFO_COORDINATES[Ge], Je = $e[0], Ze = $e[1];
        if (Ue.setBoolean(Je, Ze, Ke), Ge < 8) {
          var nt = Ue.getWidth() - Ge - 1, tt = 8;
          Ue.setBoolean(nt, tt, Ke);
        } else {
          var nt = 8, tt = Ue.getHeight() - 7 + (Ge - 8);
          Ue.setBoolean(nt, tt, Ke);
        }
      }
    }, me.maybeEmbedVersionInfo = function(ue, Qe) {
      if (!(ue.getVersionNumber() < 7)) {
        var Ue = new BitArray();
        me.makeVersionInfoBits(ue, Ue);
        for (var He = 6 * 3 - 1, Ge = 0; Ge < 6; ++Ge)
          for (var Xe = 0; Xe < 3; ++Xe) {
            var Ke = Ue.get(He);
            He--, Qe.setBoolean(Ge, Qe.getHeight() - 11 + Xe, Ke), Qe.setBoolean(Qe.getHeight() - 11 + Xe, Ge, Ke);
          }
      }
    }, me.embedDataBits = function(ue, Qe, Ue) {
      for (var He = 0, Ge = -1, Xe = Ue.getWidth() - 1, Ke = Ue.getHeight() - 1; Xe > 0; ) {
        for (Xe === 6 && (Xe -= 1); Ke >= 0 && Ke < Ue.getHeight(); ) {
          for (var $e = 0; $e < 2; ++$e) {
            var Je = Xe - $e;
            if (me.isEmpty(Ue.get(Je, Ke))) {
              var Ze = void 0;
              He < ue.getSize() ? (Ze = ue.get(He), ++He) : Ze = !1, Qe !== 255 && MaskUtil.getDataMaskBit(Qe, Je, Ke) && (Ze = !Ze), Ue.setBoolean(Je, Ke, Ze);
            }
          }
          Ke += Ge;
        }
        Ge = -Ge, Ke += Ge, Xe -= 2;
      }
      if (He !== ue.getSize())
        throw new WriterException("Not all bits consumed: " + He + "/" + ue.getSize());
    }, me.findMSBSet = function(ue) {
      return 32 - Integer.numberOfLeadingZeros(ue);
    }, me.calculateBCHCode = function(ue, Qe) {
      if (Qe === 0)
        throw new IllegalArgumentException("0 polynomial");
      var Ue = me.findMSBSet(Qe);
      for (ue <<= Ue - 1; me.findMSBSet(ue) >= Ue; )
        ue ^= Qe << me.findMSBSet(ue) - Ue;
      return ue;
    }, me.makeTypeInfoBits = function(ue, Qe, Ue) {
      if (!QRCode$2.isValidMaskPattern(Qe))
        throw new WriterException("Invalid mask pattern");
      var He = ue.getBits() << 3 | Qe;
      Ue.appendBits(He, 5);
      var Ge = me.calculateBCHCode(He, me.TYPE_INFO_POLY);
      Ue.appendBits(Ge, 10);
      var Xe = new BitArray();
      if (Xe.appendBits(me.TYPE_INFO_MASK_PATTERN, 15), Ue.xor(Xe), Ue.getSize() !== 15)
        throw new WriterException("should not happen but we got: " + Ue.getSize());
    }, me.makeVersionInfoBits = function(ue, Qe) {
      Qe.appendBits(ue.getVersionNumber(), 6);
      var Ue = me.calculateBCHCode(ue.getVersionNumber(), me.VERSION_INFO_POLY);
      if (Qe.appendBits(Ue, 12), Qe.getSize() !== 18)
        throw new WriterException("should not happen but we got: " + Qe.getSize());
    }, me.isEmpty = function(ue) {
      return ue === 255;
    }, me.embedTimingPatterns = function(ue) {
      for (var Qe = 8; Qe < ue.getWidth() - 8; ++Qe) {
        var Ue = (Qe + 1) % 2;
        me.isEmpty(ue.get(Qe, 6)) && ue.setNumber(Qe, 6, Ue), me.isEmpty(ue.get(6, Qe)) && ue.setNumber(6, Qe, Ue);
      }
    }, me.embedDarkDotAtLeftBottomCorner = function(ue) {
      if (ue.get(8, ue.getHeight() - 8) === 0)
        throw new WriterException();
      ue.setNumber(8, ue.getHeight() - 8, 1);
    }, me.embedHorizontalSeparationPattern = function(ue, Qe, Ue) {
      for (var He = 0; He < 8; ++He) {
        if (!me.isEmpty(Ue.get(ue + He, Qe)))
          throw new WriterException();
        Ue.setNumber(ue + He, Qe, 0);
      }
    }, me.embedVerticalSeparationPattern = function(ue, Qe, Ue) {
      for (var He = 0; He < 7; ++He) {
        if (!me.isEmpty(Ue.get(ue, Qe + He)))
          throw new WriterException();
        Ue.setNumber(ue, Qe + He, 0);
      }
    }, me.embedPositionAdjustmentPattern = function(ue, Qe, Ue) {
      for (var He = 0; He < 5; ++He)
        for (var Ge = me.POSITION_ADJUSTMENT_PATTERN[He], Xe = 0; Xe < 5; ++Xe)
          Ue.setNumber(ue + Xe, Qe + He, Ge[Xe]);
    }, me.embedPositionDetectionPattern = function(ue, Qe, Ue) {
      for (var He = 0; He < 7; ++He)
        for (var Ge = me.POSITION_DETECTION_PATTERN[He], Xe = 0; Xe < 7; ++Xe)
          Ue.setNumber(ue + Xe, Qe + He, Ge[Xe]);
    }, me.embedPositionDetectionPatternsAndSeparators = function(ue) {
      var Qe = me.POSITION_DETECTION_PATTERN[0].length;
      me.embedPositionDetectionPattern(0, 0, ue), me.embedPositionDetectionPattern(ue.getWidth() - Qe, 0, ue), me.embedPositionDetectionPattern(0, ue.getWidth() - Qe, ue);
      var Ue = 8;
      me.embedHorizontalSeparationPattern(0, Ue - 1, ue), me.embedHorizontalSeparationPattern(ue.getWidth() - Ue, Ue - 1, ue), me.embedHorizontalSeparationPattern(0, ue.getWidth() - Ue, ue);
      var He = 7;
      me.embedVerticalSeparationPattern(He, 0, ue), me.embedVerticalSeparationPattern(ue.getHeight() - He - 1, 0, ue), me.embedVerticalSeparationPattern(He, ue.getHeight() - He, ue);
    }, me.maybeEmbedPositionAdjustmentPatterns = function(ue, Qe) {
      if (!(ue.getVersionNumber() < 2))
        for (var Ue = ue.getVersionNumber() - 1, He = me.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE[Ue], Ge = 0, Xe = He.length; Ge !== Xe; Ge++) {
          var Ke = He[Ge];
          if (Ke >= 0)
            for (var $e = 0; $e !== Xe; $e++) {
              var Je = He[$e];
              Je >= 0 && me.isEmpty(Qe.get(Je, Ke)) && me.embedPositionAdjustmentPattern(Je - 2, Ke - 2, Qe);
            }
        }
    }, me.POSITION_DETECTION_PATTERN = Array.from([
      Int32Array.from([1, 1, 1, 1, 1, 1, 1]),
      Int32Array.from([1, 0, 0, 0, 0, 0, 1]),
      Int32Array.from([1, 0, 1, 1, 1, 0, 1]),
      Int32Array.from([1, 0, 1, 1, 1, 0, 1]),
      Int32Array.from([1, 0, 1, 1, 1, 0, 1]),
      Int32Array.from([1, 0, 0, 0, 0, 0, 1]),
      Int32Array.from([1, 1, 1, 1, 1, 1, 1])
    ]), me.POSITION_ADJUSTMENT_PATTERN = Array.from([
      Int32Array.from([1, 1, 1, 1, 1]),
      Int32Array.from([1, 0, 0, 0, 1]),
      Int32Array.from([1, 0, 1, 0, 1]),
      Int32Array.from([1, 0, 0, 0, 1]),
      Int32Array.from([1, 1, 1, 1, 1])
    ]), me.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE = Array.from([
      Int32Array.from([-1, -1, -1, -1, -1, -1, -1]),
      Int32Array.from([6, 18, -1, -1, -1, -1, -1]),
      Int32Array.from([6, 22, -1, -1, -1, -1, -1]),
      Int32Array.from([6, 26, -1, -1, -1, -1, -1]),
      Int32Array.from([6, 30, -1, -1, -1, -1, -1]),
      Int32Array.from([6, 34, -1, -1, -1, -1, -1]),
      Int32Array.from([6, 22, 38, -1, -1, -1, -1]),
      Int32Array.from([6, 24, 42, -1, -1, -1, -1]),
      Int32Array.from([6, 26, 46, -1, -1, -1, -1]),
      Int32Array.from([6, 28, 50, -1, -1, -1, -1]),
      Int32Array.from([6, 30, 54, -1, -1, -1, -1]),
      Int32Array.from([6, 32, 58, -1, -1, -1, -1]),
      Int32Array.from([6, 34, 62, -1, -1, -1, -1]),
      Int32Array.from([6, 26, 46, 66, -1, -1, -1]),
      Int32Array.from([6, 26, 48, 70, -1, -1, -1]),
      Int32Array.from([6, 26, 50, 74, -1, -1, -1]),
      Int32Array.from([6, 30, 54, 78, -1, -1, -1]),
      Int32Array.from([6, 30, 56, 82, -1, -1, -1]),
      Int32Array.from([6, 30, 58, 86, -1, -1, -1]),
      Int32Array.from([6, 34, 62, 90, -1, -1, -1]),
      Int32Array.from([6, 28, 50, 72, 94, -1, -1]),
      Int32Array.from([6, 26, 50, 74, 98, -1, -1]),
      Int32Array.from([6, 30, 54, 78, 102, -1, -1]),
      Int32Array.from([6, 28, 54, 80, 106, -1, -1]),
      Int32Array.from([6, 32, 58, 84, 110, -1, -1]),
      Int32Array.from([6, 30, 58, 86, 114, -1, -1]),
      Int32Array.from([6, 34, 62, 90, 118, -1, -1]),
      Int32Array.from([6, 26, 50, 74, 98, 122, -1]),
      Int32Array.from([6, 30, 54, 78, 102, 126, -1]),
      Int32Array.from([6, 26, 52, 78, 104, 130, -1]),
      Int32Array.from([6, 30, 56, 82, 108, 134, -1]),
      Int32Array.from([6, 34, 60, 86, 112, 138, -1]),
      Int32Array.from([6, 30, 58, 86, 114, 142, -1]),
      Int32Array.from([6, 34, 62, 90, 118, 146, -1]),
      Int32Array.from([6, 30, 54, 78, 102, 126, 150]),
      Int32Array.from([6, 24, 50, 76, 102, 128, 154]),
      Int32Array.from([6, 28, 54, 80, 106, 132, 158]),
      Int32Array.from([6, 32, 58, 84, 110, 136, 162]),
      Int32Array.from([6, 26, 54, 82, 110, 138, 166]),
      Int32Array.from([6, 30, 58, 86, 114, 142, 170])
    ]), me.TYPE_INFO_COORDINATES = Array.from([
      Int32Array.from([8, 0]),
      Int32Array.from([8, 1]),
      Int32Array.from([8, 2]),
      Int32Array.from([8, 3]),
      Int32Array.from([8, 4]),
      Int32Array.from([8, 5]),
      Int32Array.from([8, 7]),
      Int32Array.from([8, 8]),
      Int32Array.from([7, 8]),
      Int32Array.from([5, 8]),
      Int32Array.from([4, 8]),
      Int32Array.from([3, 8]),
      Int32Array.from([2, 8]),
      Int32Array.from([1, 8]),
      Int32Array.from([0, 8])
    ]), me.VERSION_INFO_POLY = 7973, me.TYPE_INFO_POLY = 1335, me.TYPE_INFO_MASK_PATTERN = 21522, me;
  }()
), BlockPair = (
  /** @class */
  function() {
    function me(ue, Qe) {
      this.dataBytes = ue, this.errorCorrectionBytes = Qe;
    }
    return me.prototype.getDataBytes = function() {
      return this.dataBytes;
    }, me.prototype.getErrorCorrectionBytes = function() {
      return this.errorCorrectionBytes;
    }, me;
  }()
), __values$5 = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
(function() {
  function me() {
  }
  return me.calculateMaskPenalty = function(ue) {
    return MaskUtil.applyMaskPenaltyRule1(ue) + MaskUtil.applyMaskPenaltyRule2(ue) + MaskUtil.applyMaskPenaltyRule3(ue) + MaskUtil.applyMaskPenaltyRule4(ue);
  }, me.encode = function(ue, Qe, Ue) {
    Ue === void 0 && (Ue = null);
    var He = me.DEFAULT_BYTE_MODE_ENCODING, Ge = Ue !== null && Ue.get(EncodeHintType$1.CHARACTER_SET) !== void 0;
    Ge && (He = Ue.get(EncodeHintType$1.CHARACTER_SET).toString());
    var Xe = this.chooseMode(ue, He), Ke = new BitArray();
    if (Xe === Mode$2.BYTE && (Ge || me.DEFAULT_BYTE_MODE_ENCODING !== He)) {
      var $e = CharacterSetECI.getCharacterSetECIByName(He);
      $e !== void 0 && this.appendECI($e, Ke);
    }
    this.appendModeInfo(Xe, Ke);
    var Je = new BitArray();
    this.appendBytes(ue, Xe, Je, He);
    var Ze;
    if (Ue !== null && Ue.get(EncodeHintType$1.QR_VERSION) !== void 0) {
      var nt = Number.parseInt(Ue.get(EncodeHintType$1.QR_VERSION).toString(), 10);
      Ze = Version.getVersionForNumber(nt);
      var tt = this.calculateBitsNeeded(Xe, Ke, Je, Ze);
      if (!this.willFit(tt, Ze, Qe))
        throw new WriterException("Data too big for requested version");
    } else
      Ze = this.recommendVersion(Qe, Xe, Ke, Je);
    var et = new BitArray();
    et.appendBitArray(Ke);
    var rt = Xe === Mode$2.BYTE ? Je.getSizeInBytes() : ue.length;
    this.appendLengthInfo(rt, Ze, Xe, et), et.appendBitArray(Je);
    var it = Ze.getECBlocksForLevel(Qe), ot = Ze.getTotalCodewords() - it.getTotalECCodewords();
    this.terminateBits(ot, et);
    var at = this.interleaveWithECBytes(et, Ze.getTotalCodewords(), ot, it.getNumBlocks()), st = new QRCode$2();
    st.setECLevel(Qe), st.setMode(Xe), st.setVersion(Ze);
    var ut = Ze.getDimensionForVersion(), lt = new ByteMatrix(ut, ut), dt = this.chooseMaskPattern(at, Qe, Ze, lt);
    return st.setMaskPattern(dt), MatrixUtil.buildMatrix(at, Qe, Ze, dt, lt), st.setMatrix(lt), st;
  }, me.recommendVersion = function(ue, Qe, Ue, He) {
    var Ge = this.calculateBitsNeeded(Qe, Ue, He, Version.getVersionForNumber(1)), Xe = this.chooseVersion(Ge, ue), Ke = this.calculateBitsNeeded(Qe, Ue, He, Xe);
    return this.chooseVersion(Ke, ue);
  }, me.calculateBitsNeeded = function(ue, Qe, Ue, He) {
    return Qe.getSize() + ue.getCharacterCountBits(He) + Ue.getSize();
  }, me.getAlphanumericCode = function(ue) {
    return ue < me.ALPHANUMERIC_TABLE.length ? me.ALPHANUMERIC_TABLE[ue] : -1;
  }, me.chooseMode = function(ue, Qe) {
    if (Qe === void 0 && (Qe = null), CharacterSetECI.SJIS.getName() === Qe && this.isOnlyDoubleByteKanji(ue))
      return Mode$2.KANJI;
    for (var Ue = !1, He = !1, Ge = 0, Xe = ue.length; Ge < Xe; ++Ge) {
      var Ke = ue.charAt(Ge);
      if (me.isDigit(Ke))
        Ue = !0;
      else if (this.getAlphanumericCode(Ke.charCodeAt(0)) !== -1)
        He = !0;
      else
        return Mode$2.BYTE;
    }
    return He ? Mode$2.ALPHANUMERIC : Ue ? Mode$2.NUMERIC : Mode$2.BYTE;
  }, me.isOnlyDoubleByteKanji = function(ue) {
    var Qe;
    try {
      Qe = StringEncoding.encode(ue, CharacterSetECI.SJIS);
    } catch {
      return !1;
    }
    var Ue = Qe.length;
    if (Ue % 2 !== 0)
      return !1;
    for (var He = 0; He < Ue; He += 2) {
      var Ge = Qe[He] & 255;
      if ((Ge < 129 || Ge > 159) && (Ge < 224 || Ge > 235))
        return !1;
    }
    return !0;
  }, me.chooseMaskPattern = function(ue, Qe, Ue, He) {
    for (var Ge = Number.MAX_SAFE_INTEGER, Xe = -1, Ke = 0; Ke < QRCode$2.NUM_MASK_PATTERNS; Ke++) {
      MatrixUtil.buildMatrix(ue, Qe, Ue, Ke, He);
      var $e = this.calculateMaskPenalty(He);
      $e < Ge && (Ge = $e, Xe = Ke);
    }
    return Xe;
  }, me.chooseVersion = function(ue, Qe) {
    for (var Ue = 1; Ue <= 40; Ue++) {
      var He = Version.getVersionForNumber(Ue);
      if (me.willFit(ue, He, Qe))
        return He;
    }
    throw new WriterException("Data too big");
  }, me.willFit = function(ue, Qe, Ue) {
    var He = Qe.getTotalCodewords(), Ge = Qe.getECBlocksForLevel(Ue), Xe = Ge.getTotalECCodewords(), Ke = He - Xe, $e = (ue + 7) / 8;
    return Ke >= $e;
  }, me.terminateBits = function(ue, Qe) {
    var Ue = ue * 8;
    if (Qe.getSize() > Ue)
      throw new WriterException("data bits cannot fit in the QR Code" + Qe.getSize() + " > " + Ue);
    for (var He = 0; He < 4 && Qe.getSize() < Ue; ++He)
      Qe.appendBit(!1);
    var Ge = Qe.getSize() & 7;
    if (Ge > 0)
      for (var He = Ge; He < 8; He++)
        Qe.appendBit(!1);
    for (var Xe = ue - Qe.getSizeInBytes(), He = 0; He < Xe; ++He)
      Qe.appendBits(He & 1 ? 17 : 236, 8);
    if (Qe.getSize() !== Ue)
      throw new WriterException("Bits size does not equal capacity");
  }, me.getNumDataBytesAndNumECBytesForBlockID = function(ue, Qe, Ue, He, Ge, Xe) {
    if (He >= Ue)
      throw new WriterException("Block ID too large");
    var Ke = ue % Ue, $e = Ue - Ke, Je = Math.floor(ue / Ue), Ze = Je + 1, nt = Math.floor(Qe / Ue), tt = nt + 1, et = Je - nt, rt = Ze - tt;
    if (et !== rt)
      throw new WriterException("EC bytes mismatch");
    if (Ue !== $e + Ke)
      throw new WriterException("RS blocks mismatch");
    if (ue !== (nt + et) * $e + (tt + rt) * Ke)
      throw new WriterException("Total bytes mismatch");
    He < $e ? (Ge[0] = nt, Xe[0] = et) : (Ge[0] = tt, Xe[0] = rt);
  }, me.interleaveWithECBytes = function(ue, Qe, Ue, He) {
    var Ge, Xe, Ke, $e;
    if (ue.getSizeInBytes() !== Ue)
      throw new WriterException("Number of bits and data bytes does not match");
    for (var Je = 0, Ze = 0, nt = 0, tt = new Array(), et = 0; et < He; ++et) {
      var rt = new Int32Array(1), it = new Int32Array(1);
      me.getNumDataBytesAndNumECBytesForBlockID(Qe, Ue, He, et, rt, it);
      var ot = rt[0], at = new Uint8Array(ot);
      ue.toBytes(8 * Je, at, 0, ot);
      var st = me.generateECBytes(at, it[0]);
      tt.push(new BlockPair(at, st)), Ze = Math.max(Ze, ot), nt = Math.max(nt, st.length), Je += rt[0];
    }
    if (Ue !== Je)
      throw new WriterException("Data bytes does not match offset");
    for (var ut = new BitArray(), et = 0; et < Ze; ++et)
      try {
        for (var lt = (Ge = void 0, __values$5(tt)), dt = lt.next(); !dt.done; dt = lt.next()) {
          var At = dt.value, at = At.getDataBytes();
          et < at.length && ut.appendBits(at[et], 8);
        }
      } catch (Bt) {
        Ge = { error: Bt };
      } finally {
        try {
          dt && !dt.done && (Xe = lt.return) && Xe.call(lt);
        } finally {
          if (Ge) throw Ge.error;
        }
      }
    for (var et = 0; et < nt; ++et)
      try {
        for (var pt = (Ke = void 0, __values$5(tt)), gt = pt.next(); !gt.done; gt = pt.next()) {
          var At = gt.value, st = At.getErrorCorrectionBytes();
          et < st.length && ut.appendBits(st[et], 8);
        }
      } catch (Bt) {
        Ke = { error: Bt };
      } finally {
        try {
          gt && !gt.done && ($e = pt.return) && $e.call(pt);
        } finally {
          if (Ke) throw Ke.error;
        }
      }
    if (Qe !== ut.getSizeInBytes())
      throw new WriterException("Interleaving error: " + Qe + " and " + ut.getSizeInBytes() + " differ.");
    return ut;
  }, me.generateECBytes = function(ue, Qe) {
    for (var Ue = ue.length, He = new Int32Array(Ue + Qe), Ge = 0; Ge < Ue; Ge++)
      He[Ge] = ue[Ge] & 255;
    new ReedSolomonEncoder(GenericGF.QR_CODE_FIELD_256).encode(He, Qe);
    for (var Xe = new Uint8Array(Qe), Ge = 0; Ge < Qe; Ge++)
      Xe[Ge] = /*(byte) */
      He[Ue + Ge];
    return Xe;
  }, me.appendModeInfo = function(ue, Qe) {
    Qe.appendBits(ue.getBits(), 4);
  }, me.appendLengthInfo = function(ue, Qe, Ue, He) {
    var Ge = Ue.getCharacterCountBits(Qe);
    if (ue >= 1 << Ge)
      throw new WriterException(ue + " is bigger than " + ((1 << Ge) - 1));
    He.appendBits(ue, Ge);
  }, me.appendBytes = function(ue, Qe, Ue, He) {
    switch (Qe) {
      case Mode$2.NUMERIC:
        me.appendNumericBytes(ue, Ue);
        break;
      case Mode$2.ALPHANUMERIC:
        me.appendAlphanumericBytes(ue, Ue);
        break;
      case Mode$2.BYTE:
        me.append8BitBytes(ue, Ue, He);
        break;
      case Mode$2.KANJI:
        me.appendKanjiBytes(ue, Ue);
        break;
      default:
        throw new WriterException("Invalid mode: " + Qe);
    }
  }, me.getDigit = function(ue) {
    return ue.charCodeAt(0) - 48;
  }, me.isDigit = function(ue) {
    var Qe = me.getDigit(ue);
    return Qe >= 0 && Qe <= 9;
  }, me.appendNumericBytes = function(ue, Qe) {
    for (var Ue = ue.length, He = 0; He < Ue; ) {
      var Ge = me.getDigit(ue.charAt(He));
      if (He + 2 < Ue) {
        var Xe = me.getDigit(ue.charAt(He + 1)), Ke = me.getDigit(ue.charAt(He + 2));
        Qe.appendBits(Ge * 100 + Xe * 10 + Ke, 10), He += 3;
      } else if (He + 1 < Ue) {
        var Xe = me.getDigit(ue.charAt(He + 1));
        Qe.appendBits(Ge * 10 + Xe, 7), He += 2;
      } else
        Qe.appendBits(Ge, 4), He++;
    }
  }, me.appendAlphanumericBytes = function(ue, Qe) {
    for (var Ue = ue.length, He = 0; He < Ue; ) {
      var Ge = me.getAlphanumericCode(ue.charCodeAt(He));
      if (Ge === -1)
        throw new WriterException();
      if (He + 1 < Ue) {
        var Xe = me.getAlphanumericCode(ue.charCodeAt(He + 1));
        if (Xe === -1)
          throw new WriterException();
        Qe.appendBits(Ge * 45 + Xe, 11), He += 2;
      } else
        Qe.appendBits(Ge, 6), He++;
    }
  }, me.append8BitBytes = function(ue, Qe, Ue) {
    var He;
    try {
      He = StringEncoding.encode(ue, Ue);
    } catch ($e) {
      throw new WriterException($e);
    }
    for (var Ge = 0, Xe = He.length; Ge !== Xe; Ge++) {
      var Ke = He[Ge];
      Qe.appendBits(Ke, 8);
    }
  }, me.appendKanjiBytes = function(ue, Qe) {
    var Ue;
    try {
      Ue = StringEncoding.encode(ue, CharacterSetECI.SJIS);
    } catch (nt) {
      throw new WriterException(nt);
    }
    for (var He = Ue.length, Ge = 0; Ge < He; Ge += 2) {
      var Xe = Ue[Ge] & 255, Ke = Ue[Ge + 1] & 255, $e = Xe << 8 & 4294967295 | Ke, Je = -1;
      if ($e >= 33088 && $e <= 40956 ? Je = $e - 33088 : $e >= 57408 && $e <= 60351 && (Je = $e - 49472), Je === -1)
        throw new WriterException("Invalid byte sequence");
      var Ze = (Je >> 8) * 192 + (Je & 255);
      Qe.appendBits(Ze, 13);
    }
  }, me.appendECI = function(ue, Qe) {
    Qe.appendBits(Mode$2.ECI.getBits(), 4), Qe.appendBits(ue.getValue(), 8);
  }, me.ALPHANUMERIC_TABLE = Int32Array.from([
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    36,
    -1,
    -1,
    -1,
    37,
    38,
    -1,
    -1,
    -1,
    -1,
    39,
    40,
    -1,
    41,
    42,
    43,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    44,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    -1,
    -1,
    -1,
    -1,
    -1
  ]), me.DEFAULT_BYTE_MODE_ENCODING = CharacterSetECI.UTF8.getName(), me;
})();
var __extends$b = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}();
(function(me) {
  __extends$b(ue, me);
  function ue(Qe, Ue, He, Ge, Xe, Ke, $e, Je) {
    var Ze = me.call(this, Ke, $e) || this;
    if (Ze.yuvData = Qe, Ze.dataWidth = Ue, Ze.dataHeight = He, Ze.left = Ge, Ze.top = Xe, Ge + Ke > Ue || Xe + $e > He)
      throw new IllegalArgumentException("Crop rectangle does not fit within image data.");
    return Je && Ze.reverseHorizontal(Ke, $e), Ze;
  }
  return ue.prototype.getRow = function(Qe, Ue) {
    if (Qe < 0 || Qe >= this.getHeight())
      throw new IllegalArgumentException("Requested row is outside the image: " + Qe);
    var He = this.getWidth();
    (Ue == null || Ue.length < He) && (Ue = new Uint8ClampedArray(He));
    var Ge = (Qe + this.top) * this.dataWidth + this.left;
    return System.arraycopy(this.yuvData, Ge, Ue, 0, He), Ue;
  }, ue.prototype.getMatrix = function() {
    var Qe = this.getWidth(), Ue = this.getHeight();
    if (Qe === this.dataWidth && Ue === this.dataHeight)
      return this.yuvData;
    var He = Qe * Ue, Ge = new Uint8ClampedArray(He), Xe = this.top * this.dataWidth + this.left;
    if (Qe === this.dataWidth)
      return System.arraycopy(this.yuvData, Xe, Ge, 0, He), Ge;
    for (var Ke = 0; Ke < Ue; Ke++) {
      var $e = Ke * Qe;
      System.arraycopy(this.yuvData, Xe, Ge, $e, Qe), Xe += this.dataWidth;
    }
    return Ge;
  }, ue.prototype.isCropSupported = function() {
    return !0;
  }, ue.prototype.crop = function(Qe, Ue, He, Ge) {
    return new ue(this.yuvData, this.dataWidth, this.dataHeight, this.left + Qe, this.top + Ue, He, Ge, !1);
  }, ue.prototype.renderThumbnail = function() {
    for (var Qe = this.getWidth() / ue.THUMBNAIL_SCALE_FACTOR, Ue = this.getHeight() / ue.THUMBNAIL_SCALE_FACTOR, He = new Int32Array(Qe * Ue), Ge = this.yuvData, Xe = this.top * this.dataWidth + this.left, Ke = 0; Ke < Ue; Ke++) {
      for (var $e = Ke * Qe, Je = 0; Je < Qe; Je++) {
        var Ze = Ge[Xe + Je * ue.THUMBNAIL_SCALE_FACTOR] & 255;
        He[$e + Je] = 4278190080 | Ze * 65793;
      }
      Xe += this.dataWidth * ue.THUMBNAIL_SCALE_FACTOR;
    }
    return He;
  }, ue.prototype.getThumbnailWidth = function() {
    return this.getWidth() / ue.THUMBNAIL_SCALE_FACTOR;
  }, ue.prototype.getThumbnailHeight = function() {
    return this.getHeight() / ue.THUMBNAIL_SCALE_FACTOR;
  }, ue.prototype.reverseHorizontal = function(Qe, Ue) {
    for (var He = this.yuvData, Ge = 0, Xe = this.top * this.dataWidth + this.left; Ge < Ue; Ge++, Xe += this.dataWidth)
      for (var Ke = Xe + Qe / 2, $e = Xe, Je = Xe + Qe - 1; $e < Ke; $e++, Je--) {
        var Ze = He[$e];
        He[$e] = He[Je], He[Je] = Ze;
      }
  }, ue.prototype.invert = function() {
    return new InvertedLuminanceSource(this);
  }, ue.THUMBNAIL_SCALE_FACTOR = 2, ue;
})(LuminanceSource);
var __extends$a = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}();
(function(me) {
  __extends$a(ue, me);
  function ue(Qe, Ue, He, Ge, Xe, Ke, $e) {
    var Je = me.call(this, Ue, He) || this;
    if (Je.dataWidth = Ge, Je.dataHeight = Xe, Je.left = Ke, Je.top = $e, Qe.BYTES_PER_ELEMENT === 4) {
      for (var Ze = Ue * He, nt = new Uint8ClampedArray(Ze), tt = 0; tt < Ze; tt++) {
        var et = Qe[tt], rt = et >> 16 & 255, it = et >> 7 & 510, ot = et & 255;
        nt[tt] = /*(byte) */
        (rt + it + ot) / 4 & 255;
      }
      Je.luminances = nt;
    } else
      Je.luminances = Qe;
    if (Ge === void 0 && (Je.dataWidth = Ue), Xe === void 0 && (Je.dataHeight = He), Ke === void 0 && (Je.left = 0), $e === void 0 && (Je.top = 0), Je.left + Ue > Je.dataWidth || Je.top + He > Je.dataHeight)
      throw new IllegalArgumentException("Crop rectangle does not fit within image data.");
    return Je;
  }
  return ue.prototype.getRow = function(Qe, Ue) {
    if (Qe < 0 || Qe >= this.getHeight())
      throw new IllegalArgumentException("Requested row is outside the image: " + Qe);
    var He = this.getWidth();
    (Ue == null || Ue.length < He) && (Ue = new Uint8ClampedArray(He));
    var Ge = (Qe + this.top) * this.dataWidth + this.left;
    return System.arraycopy(this.luminances, Ge, Ue, 0, He), Ue;
  }, ue.prototype.getMatrix = function() {
    var Qe = this.getWidth(), Ue = this.getHeight();
    if (Qe === this.dataWidth && Ue === this.dataHeight)
      return this.luminances;
    var He = Qe * Ue, Ge = new Uint8ClampedArray(He), Xe = this.top * this.dataWidth + this.left;
    if (Qe === this.dataWidth)
      return System.arraycopy(this.luminances, Xe, Ge, 0, He), Ge;
    for (var Ke = 0; Ke < Ue; Ke++) {
      var $e = Ke * Qe;
      System.arraycopy(this.luminances, Xe, Ge, $e, Qe), Xe += this.dataWidth;
    }
    return Ge;
  }, ue.prototype.isCropSupported = function() {
    return !0;
  }, ue.prototype.crop = function(Qe, Ue, He, Ge) {
    return new ue(this.luminances, He, Ge, this.dataWidth, this.dataHeight, this.left + Qe, this.top + Ue);
  }, ue.prototype.invert = function() {
    return new InvertedLuminanceSource(this);
  }, ue;
})(LuminanceSource);
var __extends$9 = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}();
(function(me) {
  __extends$9(ue, me);
  function ue() {
    return me !== null && me.apply(this, arguments) || this;
  }
  return ue.forName = function(Qe) {
    return this.getCharacterSetECIByName(Qe);
  }, ue;
})(CharacterSetECI);
(function() {
  function me() {
  }
  return me.ISO_8859_1 = CharacterSetECI.ISO8859_1, me;
})();
var AztecCode = (
  /** @class */
  function() {
    function me() {
    }
    return me.prototype.isCompact = function() {
      return this.compact;
    }, me.prototype.setCompact = function(ue) {
      this.compact = ue;
    }, me.prototype.getSize = function() {
      return this.size;
    }, me.prototype.setSize = function(ue) {
      this.size = ue;
    }, me.prototype.getLayers = function() {
      return this.layers;
    }, me.prototype.setLayers = function(ue) {
      this.layers = ue;
    }, me.prototype.getCodeWords = function() {
      return this.codeWords;
    }, me.prototype.setCodeWords = function(ue) {
      this.codeWords = ue;
    }, me.prototype.getMatrix = function() {
      return this.matrix;
    }, me.prototype.setMatrix = function(ue) {
      this.matrix = ue;
    }, me;
  }()
), Collections = (
  /** @class */
  function() {
    function me() {
    }
    return me.singletonList = function(ue) {
      return [ue];
    }, me.min = function(ue, Qe) {
      return ue.sort(Qe)[0];
    }, me;
  }()
), Token = (
  /** @class */
  function() {
    function me(ue) {
      this.previous = ue;
    }
    return me.prototype.getPrevious = function() {
      return this.previous;
    }, me;
  }()
), __extends$8 = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), SimpleToken = (
  /** @class */
  function(me) {
    __extends$8(ue, me);
    function ue(Qe, Ue, He) {
      var Ge = me.call(this, Qe) || this;
      return Ge.value = Ue, Ge.bitCount = He, Ge;
    }
    return ue.prototype.appendTo = function(Qe, Ue) {
      Qe.appendBits(this.value, this.bitCount);
    }, ue.prototype.add = function(Qe, Ue) {
      return new ue(this, Qe, Ue);
    }, ue.prototype.addBinaryShift = function(Qe, Ue) {
      return console.warn("addBinaryShift on SimpleToken, this simply returns a copy of this token"), new ue(this, Qe, Ue);
    }, ue.prototype.toString = function() {
      var Qe = this.value & (1 << this.bitCount) - 1;
      return Qe |= 1 << this.bitCount, "<" + Integer.toBinaryString(Qe | 1 << this.bitCount).substring(1) + ">";
    }, ue;
  }(Token)
), __extends$7 = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) He.hasOwnProperty(Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), BinaryShiftToken = (
  /** @class */
  function(me) {
    __extends$7(ue, me);
    function ue(Qe, Ue, He) {
      var Ge = me.call(this, Qe, 0, 0) || this;
      return Ge.binaryShiftStart = Ue, Ge.binaryShiftByteCount = He, Ge;
    }
    return ue.prototype.appendTo = function(Qe, Ue) {
      for (var He = 0; He < this.binaryShiftByteCount; He++)
        (He === 0 || He === 31 && this.binaryShiftByteCount <= 62) && (Qe.appendBits(31, 5), this.binaryShiftByteCount > 62 ? Qe.appendBits(this.binaryShiftByteCount - 31, 16) : He === 0 ? Qe.appendBits(Math.min(this.binaryShiftByteCount, 31), 5) : Qe.appendBits(this.binaryShiftByteCount - 31, 5)), Qe.appendBits(Ue[this.binaryShiftStart + He], 8);
    }, ue.prototype.addBinaryShift = function(Qe, Ue) {
      return new ue(this, Qe, Ue);
    }, ue.prototype.toString = function() {
      return "<" + this.binaryShiftStart + "::" + (this.binaryShiftStart + this.binaryShiftByteCount - 1) + ">";
    }, ue;
  }(SimpleToken)
);
function addBinaryShift(me, ue, Qe) {
  return new BinaryShiftToken(me, ue, Qe);
}
function add(me, ue, Qe) {
  return new SimpleToken(me, ue, Qe);
}
var MODE_NAMES = [
  "UPPER",
  "LOWER",
  "DIGIT",
  "MIXED",
  "PUNCT"
], MODE_UPPER = 0, MODE_LOWER = 1, MODE_DIGIT = 2, MODE_MIXED = 3, MODE_PUNCT = 4, EMPTY_TOKEN = new SimpleToken(null, 0, 0), LATCH_TABLE = [
  Int32Array.from([
    0,
    (5 << 16) + 28,
    (5 << 16) + 30,
    (5 << 16) + 29,
    656318
    // UPPER -> MIXED -> PUNCT
  ]),
  Int32Array.from([
    (9 << 16) + 480 + 14,
    0,
    (5 << 16) + 30,
    (5 << 16) + 29,
    656318
    // LOWER -> MIXED -> PUNCT
  ]),
  Int32Array.from([
    (4 << 16) + 14,
    (9 << 16) + 448 + 28,
    0,
    (9 << 16) + 448 + 29,
    932798
    // DIGIT -> UPPER -> MIXED -> PUNCT
  ]),
  Int32Array.from([
    (5 << 16) + 29,
    (5 << 16) + 28,
    656318,
    0,
    (5 << 16) + 30
    // MIXED -> PUNCT
  ]),
  Int32Array.from([
    (5 << 16) + 31,
    656380,
    656382,
    656381,
    0
  ])
], __values$4 = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function static_SHIFT_TABLE(me) {
  var ue, Qe;
  try {
    for (var Ue = __values$4(me), He = Ue.next(); !He.done; He = Ue.next()) {
      var Ge = He.value;
      Arrays.fill(Ge, -1);
    }
  } catch (Xe) {
    ue = { error: Xe };
  } finally {
    try {
      He && !He.done && (Qe = Ue.return) && Qe.call(Ue);
    } finally {
      if (ue) throw ue.error;
    }
  }
  return me[MODE_UPPER][MODE_PUNCT] = 0, me[MODE_LOWER][MODE_PUNCT] = 0, me[MODE_LOWER][MODE_UPPER] = 28, me[MODE_MIXED][MODE_PUNCT] = 0, me[MODE_DIGIT][MODE_PUNCT] = 0, me[MODE_DIGIT][MODE_UPPER] = 15, me;
}
var SHIFT_TABLE = static_SHIFT_TABLE(Arrays.createInt32Array(6, 6)), __values$3 = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, State = (
  /** @class */
  function() {
    function me(ue, Qe, Ue, He) {
      this.token = ue, this.mode = Qe, this.binaryShiftByteCount = Ue, this.bitCount = He;
    }
    return me.prototype.getMode = function() {
      return this.mode;
    }, me.prototype.getToken = function() {
      return this.token;
    }, me.prototype.getBinaryShiftByteCount = function() {
      return this.binaryShiftByteCount;
    }, me.prototype.getBitCount = function() {
      return this.bitCount;
    }, me.prototype.latchAndAppend = function(ue, Qe) {
      var Ue = this.bitCount, He = this.token;
      if (ue !== this.mode) {
        var Ge = LATCH_TABLE[this.mode][ue];
        He = add(He, Ge & 65535, Ge >> 16), Ue += Ge >> 16;
      }
      var Xe = ue === MODE_DIGIT ? 4 : 5;
      return He = add(He, Qe, Xe), new me(He, ue, 0, Ue + Xe);
    }, me.prototype.shiftAndAppend = function(ue, Qe) {
      var Ue = this.token, He = this.mode === MODE_DIGIT ? 4 : 5;
      return Ue = add(Ue, SHIFT_TABLE[this.mode][ue], He), Ue = add(Ue, Qe, 5), new me(Ue, this.mode, 0, this.bitCount + He + 5);
    }, me.prototype.addBinaryShiftChar = function(ue) {
      var Qe = this.token, Ue = this.mode, He = this.bitCount;
      if (this.mode === MODE_PUNCT || this.mode === MODE_DIGIT) {
        var Ge = LATCH_TABLE[Ue][MODE_UPPER];
        Qe = add(Qe, Ge & 65535, Ge >> 16), He += Ge >> 16, Ue = MODE_UPPER;
      }
      var Xe = this.binaryShiftByteCount === 0 || this.binaryShiftByteCount === 31 ? 18 : this.binaryShiftByteCount === 62 ? 9 : 8, Ke = new me(Qe, Ue, this.binaryShiftByteCount + 1, He + Xe);
      return Ke.binaryShiftByteCount === 2078 && (Ke = Ke.endBinaryShift(ue + 1)), Ke;
    }, me.prototype.endBinaryShift = function(ue) {
      if (this.binaryShiftByteCount === 0)
        return this;
      var Qe = this.token;
      return Qe = addBinaryShift(Qe, ue - this.binaryShiftByteCount, this.binaryShiftByteCount), new me(Qe, this.mode, 0, this.bitCount);
    }, me.prototype.isBetterThanOrEqualTo = function(ue) {
      var Qe = this.bitCount + (LATCH_TABLE[this.mode][ue.mode] >> 16);
      return this.binaryShiftByteCount < ue.binaryShiftByteCount ? Qe += me.calculateBinaryShiftCost(ue) - me.calculateBinaryShiftCost(this) : this.binaryShiftByteCount > ue.binaryShiftByteCount && ue.binaryShiftByteCount > 0 && (Qe += 10), Qe <= ue.bitCount;
    }, me.prototype.toBitArray = function(ue) {
      for (var Qe, Ue, He = [], Ge = this.endBinaryShift(ue.length).token; Ge !== null; Ge = Ge.getPrevious())
        He.unshift(Ge);
      var Xe = new BitArray();
      try {
        for (var Ke = __values$3(He), $e = Ke.next(); !$e.done; $e = Ke.next()) {
          var Je = $e.value;
          Je.appendTo(Xe, ue);
        }
      } catch (Ze) {
        Qe = { error: Ze };
      } finally {
        try {
          $e && !$e.done && (Ue = Ke.return) && Ue.call(Ke);
        } finally {
          if (Qe) throw Qe.error;
        }
      }
      return Xe;
    }, me.prototype.toString = function() {
      return StringUtils.format("%s bits=%d bytes=%d", MODE_NAMES[this.mode], this.bitCount, this.binaryShiftByteCount);
    }, me.calculateBinaryShiftCost = function(ue) {
      return ue.binaryShiftByteCount > 62 ? 21 : ue.binaryShiftByteCount > 31 ? 20 : ue.binaryShiftByteCount > 0 ? 10 : 0;
    }, me.INITIAL_STATE = new me(EMPTY_TOKEN, MODE_UPPER, 0, 0), me;
  }()
);
function static_CHAR_MAP(me) {
  var ue = StringUtils.getCharCode(" "), Qe = StringUtils.getCharCode("."), Ue = StringUtils.getCharCode(",");
  me[MODE_UPPER][ue] = 1;
  for (var He = StringUtils.getCharCode("Z"), Ge = StringUtils.getCharCode("A"), Xe = Ge; Xe <= He; Xe++)
    me[MODE_UPPER][Xe] = Xe - Ge + 2;
  me[MODE_LOWER][ue] = 1;
  for (var Ke = StringUtils.getCharCode("z"), $e = StringUtils.getCharCode("a"), Xe = $e; Xe <= Ke; Xe++)
    me[MODE_LOWER][Xe] = Xe - $e + 2;
  me[MODE_DIGIT][ue] = 1;
  for (var Je = StringUtils.getCharCode("9"), Ze = StringUtils.getCharCode("0"), Xe = Ze; Xe <= Je; Xe++)
    me[MODE_DIGIT][Xe] = Xe - Ze + 2;
  me[MODE_DIGIT][Ue] = 12, me[MODE_DIGIT][Qe] = 13;
  for (var nt = [
    "\0",
    " ",
    "",
    "",
    "",
    "",
    "",
    "",
    "\x07",
    "\b",
    "	",
    `
`,
    "\v",
    "\f",
    "\r",
    "\x1B",
    "",
    "",
    "",
    "",
    "@",
    "\\",
    "^",
    "_",
    "`",
    "|",
    "~",
    ""
  ], tt = 0; tt < nt.length; tt++)
    me[MODE_MIXED][StringUtils.getCharCode(nt[tt])] = tt;
  for (var et = [
    "\0",
    "\r",
    "\0",
    "\0",
    "\0",
    "\0",
    "!",
    "'",
    "#",
    "$",
    "%",
    "&",
    "'",
    "(",
    ")",
    "*",
    "+",
    ",",
    "-",
    ".",
    "/",
    ":",
    ";",
    "<",
    "=",
    ">",
    "?",
    "[",
    "]",
    "{",
    "}"
  ], tt = 0; tt < et.length; tt++)
    StringUtils.getCharCode(et[tt]) > 0 && (me[MODE_PUNCT][StringUtils.getCharCode(et[tt])] = tt);
  return me;
}
var CHAR_MAP = static_CHAR_MAP(Arrays.createInt32Array(5, 256)), __values$2 = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, HighLevelEncoder = (
  /** @class */
  function() {
    function me(ue) {
      this.text = ue;
    }
    return me.prototype.encode = function() {
      for (var ue = StringUtils.getCharCode(" "), Qe = StringUtils.getCharCode(`
`), Ue = Collections.singletonList(State.INITIAL_STATE), He = 0; He < this.text.length; He++) {
        var Ge = void 0, Xe = He + 1 < this.text.length ? this.text[He + 1] : 0;
        switch (this.text[He]) {
          case StringUtils.getCharCode("\r"):
            Ge = Xe === Qe ? 2 : 0;
            break;
          case StringUtils.getCharCode("."):
            Ge = Xe === ue ? 3 : 0;
            break;
          case StringUtils.getCharCode(","):
            Ge = Xe === ue ? 4 : 0;
            break;
          case StringUtils.getCharCode(":"):
            Ge = Xe === ue ? 5 : 0;
            break;
          default:
            Ge = 0;
        }
        Ge > 0 ? (Ue = me.updateStateListForPair(Ue, He, Ge), He++) : Ue = this.updateStateListForChar(Ue, He);
      }
      var Ke = Collections.min(Ue, function($e, Je) {
        return $e.getBitCount() - Je.getBitCount();
      });
      return Ke.toBitArray(this.text);
    }, me.prototype.updateStateListForChar = function(ue, Qe) {
      var Ue, He, Ge = [];
      try {
        for (var Xe = __values$2(ue), Ke = Xe.next(); !Ke.done; Ke = Xe.next()) {
          var $e = Ke.value;
          this.updateStateForChar($e, Qe, Ge);
        }
      } catch (Je) {
        Ue = { error: Je };
      } finally {
        try {
          Ke && !Ke.done && (He = Xe.return) && He.call(Xe);
        } finally {
          if (Ue) throw Ue.error;
        }
      }
      return me.simplifyStates(Ge);
    }, me.prototype.updateStateForChar = function(ue, Qe, Ue) {
      for (var He = this.text[Qe] & 255, Ge = CHAR_MAP[ue.getMode()][He] > 0, Xe = null, Ke = 0; Ke <= MODE_PUNCT; Ke++) {
        var $e = CHAR_MAP[Ke][He];
        if ($e > 0) {
          if (Xe == null && (Xe = ue.endBinaryShift(Qe)), !Ge || Ke === ue.getMode() || Ke === MODE_DIGIT) {
            var Je = Xe.latchAndAppend(Ke, $e);
            Ue.push(Je);
          }
          if (!Ge && SHIFT_TABLE[ue.getMode()][Ke] >= 0) {
            var Ze = Xe.shiftAndAppend(Ke, $e);
            Ue.push(Ze);
          }
        }
      }
      if (ue.getBinaryShiftByteCount() > 0 || CHAR_MAP[ue.getMode()][He] === 0) {
        var nt = ue.addBinaryShiftChar(Qe);
        Ue.push(nt);
      }
    }, me.updateStateListForPair = function(ue, Qe, Ue) {
      var He, Ge, Xe = [];
      try {
        for (var Ke = __values$2(ue), $e = Ke.next(); !$e.done; $e = Ke.next()) {
          var Je = $e.value;
          this.updateStateForPair(Je, Qe, Ue, Xe);
        }
      } catch (Ze) {
        He = { error: Ze };
      } finally {
        try {
          $e && !$e.done && (Ge = Ke.return) && Ge.call(Ke);
        } finally {
          if (He) throw He.error;
        }
      }
      return this.simplifyStates(Xe);
    }, me.updateStateForPair = function(ue, Qe, Ue, He) {
      var Ge = ue.endBinaryShift(Qe);
      if (He.push(Ge.latchAndAppend(MODE_PUNCT, Ue)), ue.getMode() !== MODE_PUNCT && He.push(Ge.shiftAndAppend(MODE_PUNCT, Ue)), Ue === 3 || Ue === 4) {
        var Xe = Ge.latchAndAppend(MODE_DIGIT, 16 - Ue).latchAndAppend(MODE_DIGIT, 1);
        He.push(Xe);
      }
      if (ue.getBinaryShiftByteCount() > 0) {
        var Ke = ue.addBinaryShiftChar(Qe).addBinaryShiftChar(Qe + 1);
        He.push(Ke);
      }
    }, me.simplifyStates = function(ue) {
      var Qe, Ue, He, Ge, Xe = [];
      try {
        for (var Ke = __values$2(ue), $e = Ke.next(); !$e.done; $e = Ke.next()) {
          var Je = $e.value, Ze = !0, nt = function(ot) {
            if (ot.isBetterThanOrEqualTo(Je))
              return Ze = !1, "break";
            Je.isBetterThanOrEqualTo(ot) && (Xe = Xe.filter(function(at) {
              return at !== ot;
            }));
          };
          try {
            for (var tt = (He = void 0, __values$2(Xe)), et = tt.next(); !et.done; et = tt.next()) {
              var rt = et.value, it = nt(rt);
              if (it === "break")
                break;
            }
          } catch (ot) {
            He = { error: ot };
          } finally {
            try {
              et && !et.done && (Ge = tt.return) && Ge.call(tt);
            } finally {
              if (He) throw He.error;
            }
          }
          Ze && Xe.push(Je);
        }
      } catch (ot) {
        Qe = { error: ot };
      } finally {
        try {
          $e && !$e.done && (Ue = Ke.return) && Ue.call(Ke);
        } finally {
          if (Qe) throw Qe.error;
        }
      }
      return Xe;
    }, me;
  }()
), __values$1 = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
(function() {
  function me() {
  }
  return me.encodeBytes = function(ue) {
    return me.encode(ue, me.DEFAULT_EC_PERCENT, me.DEFAULT_AZTEC_LAYERS);
  }, me.encode = function(ue, Qe, Ue) {
    var He = new HighLevelEncoder(ue).encode(), Ge = Integer.truncDivision(He.getSize() * Qe, 100) + 11, Xe = He.getSize() + Ge, Ke, $e, Je, Ze, nt;
    if (Ue !== me.DEFAULT_AZTEC_LAYERS) {
      if (Ke = Ue < 0, $e = Math.abs(Ue), $e > (Ke ? me.MAX_NB_BITS_COMPACT : me.MAX_NB_BITS))
        throw new IllegalArgumentException(StringUtils.format("Illegal value %s for layers", Ue));
      Je = me.totalBitsInLayer($e, Ke), Ze = me.WORD_SIZE[$e];
      var tt = Je - Je % Ze;
      if (nt = me.stuffBits(He, Ze), nt.getSize() + Ge > tt)
        throw new IllegalArgumentException("Data to large for user specified layer");
      if (Ke && nt.getSize() > Ze * 64)
        throw new IllegalArgumentException("Data to large for user specified layer");
    } else {
      Ze = 0, nt = null;
      for (var et = 0; ; et++) {
        if (et > me.MAX_NB_BITS)
          throw new IllegalArgumentException("Data too large for an Aztec code");
        if (Ke = et <= 3, $e = Ke ? et + 1 : et, Je = me.totalBitsInLayer($e, Ke), !(Xe > Je)) {
          (nt == null || Ze !== me.WORD_SIZE[$e]) && (Ze = me.WORD_SIZE[$e], nt = me.stuffBits(He, Ze));
          var tt = Je - Je % Ze;
          if (!(Ke && nt.getSize() > Ze * 64) && nt.getSize() + Ge <= tt)
            break;
        }
      }
    }
    var rt = me.generateCheckWords(nt, Je, Ze), it = nt.getSize() / Ze, ot = me.generateModeMessage(Ke, $e, it), at = (Ke ? 11 : 14) + $e * 4, st = new Int32Array(at), ut;
    if (Ke) {
      ut = at;
      for (var et = 0; et < st.length; et++)
        st[et] = et;
    } else {
      ut = at + 1 + 2 * Integer.truncDivision(Integer.truncDivision(at, 2) - 1, 15);
      for (var lt = Integer.truncDivision(at, 2), dt = Integer.truncDivision(ut, 2), et = 0; et < lt; et++) {
        var At = et + Integer.truncDivision(et, 15);
        st[lt - et - 1] = dt - At - 1, st[lt + et] = dt + At + 1;
      }
    }
    for (var pt = new BitMatrix(ut), et = 0, gt = 0; et < $e; et++) {
      for (var wt = ($e - et) * 4 + (Ke ? 9 : 12), Bt = 0; Bt < wt; Bt++)
        for (var Tt = Bt * 2, yt = 0; yt < 2; yt++)
          rt.get(gt + Tt + yt) && pt.set(st[et * 2 + yt], st[et * 2 + Bt]), rt.get(gt + wt * 2 + Tt + yt) && pt.set(st[et * 2 + Bt], st[at - 1 - et * 2 - yt]), rt.get(gt + wt * 4 + Tt + yt) && pt.set(st[at - 1 - et * 2 - yt], st[at - 1 - et * 2 - Bt]), rt.get(gt + wt * 6 + Tt + yt) && pt.set(st[at - 1 - et * 2 - Bt], st[et * 2 + yt]);
      gt += wt * 8;
    }
    if (me.drawModeMessage(pt, Ke, ut, ot), Ke)
      me.drawBullsEye(pt, Integer.truncDivision(ut, 2), 5);
    else {
      me.drawBullsEye(pt, Integer.truncDivision(ut, 2), 7);
      for (var et = 0, Bt = 0; et < Integer.truncDivision(at, 2) - 1; et += 15, Bt += 16)
        for (var yt = Integer.truncDivision(ut, 2) & 1; yt < ut; yt += 2)
          pt.set(Integer.truncDivision(ut, 2) - Bt, yt), pt.set(Integer.truncDivision(ut, 2) + Bt, yt), pt.set(yt, Integer.truncDivision(ut, 2) - Bt), pt.set(yt, Integer.truncDivision(ut, 2) + Bt);
    }
    var Ct = new AztecCode();
    return Ct.setCompact(Ke), Ct.setSize(ut), Ct.setLayers($e), Ct.setCodeWords(it), Ct.setMatrix(pt), Ct;
  }, me.drawBullsEye = function(ue, Qe, Ue) {
    for (var He = 0; He < Ue; He += 2)
      for (var Ge = Qe - He; Ge <= Qe + He; Ge++)
        ue.set(Ge, Qe - He), ue.set(Ge, Qe + He), ue.set(Qe - He, Ge), ue.set(Qe + He, Ge);
    ue.set(Qe - Ue, Qe - Ue), ue.set(Qe - Ue + 1, Qe - Ue), ue.set(Qe - Ue, Qe - Ue + 1), ue.set(Qe + Ue, Qe - Ue), ue.set(Qe + Ue, Qe - Ue + 1), ue.set(Qe + Ue, Qe + Ue - 1);
  }, me.generateModeMessage = function(ue, Qe, Ue) {
    var He = new BitArray();
    return ue ? (He.appendBits(Qe - 1, 2), He.appendBits(Ue - 1, 6), He = me.generateCheckWords(He, 28, 4)) : (He.appendBits(Qe - 1, 5), He.appendBits(Ue - 1, 11), He = me.generateCheckWords(He, 40, 4)), He;
  }, me.drawModeMessage = function(ue, Qe, Ue, He) {
    var Ge = Integer.truncDivision(Ue, 2);
    if (Qe)
      for (var Xe = 0; Xe < 7; Xe++) {
        var Ke = Ge - 3 + Xe;
        He.get(Xe) && ue.set(Ke, Ge - 5), He.get(Xe + 7) && ue.set(Ge + 5, Ke), He.get(20 - Xe) && ue.set(Ke, Ge + 5), He.get(27 - Xe) && ue.set(Ge - 5, Ke);
      }
    else
      for (var Xe = 0; Xe < 10; Xe++) {
        var Ke = Ge - 5 + Xe + Integer.truncDivision(Xe, 5);
        He.get(Xe) && ue.set(Ke, Ge - 7), He.get(Xe + 10) && ue.set(Ge + 7, Ke), He.get(29 - Xe) && ue.set(Ke, Ge + 7), He.get(39 - Xe) && ue.set(Ge - 7, Ke);
      }
  }, me.generateCheckWords = function(ue, Qe, Ue) {
    var He, Ge, Xe = ue.getSize() / Ue, Ke = new ReedSolomonEncoder(me.getGF(Ue)), $e = Integer.truncDivision(Qe, Ue), Je = me.bitsToWords(ue, Ue, $e);
    Ke.encode(Je, $e - Xe);
    var Ze = Qe % Ue, nt = new BitArray();
    nt.appendBits(0, Ze);
    try {
      for (var tt = __values$1(Array.from(Je)), et = tt.next(); !et.done; et = tt.next()) {
        var rt = et.value;
        nt.appendBits(rt, Ue);
      }
    } catch (it) {
      He = { error: it };
    } finally {
      try {
        et && !et.done && (Ge = tt.return) && Ge.call(tt);
      } finally {
        if (He) throw He.error;
      }
    }
    return nt;
  }, me.bitsToWords = function(ue, Qe, Ue) {
    var He = new Int32Array(Ue), Ge, Xe;
    for (Ge = 0, Xe = ue.getSize() / Qe; Ge < Xe; Ge++) {
      for (var Ke = 0, $e = 0; $e < Qe; $e++)
        Ke |= ue.get(Ge * Qe + $e) ? 1 << Qe - $e - 1 : 0;
      He[Ge] = Ke;
    }
    return He;
  }, me.getGF = function(ue) {
    switch (ue) {
      case 4:
        return GenericGF.AZTEC_PARAM;
      case 6:
        return GenericGF.AZTEC_DATA_6;
      case 8:
        return GenericGF.AZTEC_DATA_8;
      case 10:
        return GenericGF.AZTEC_DATA_10;
      case 12:
        return GenericGF.AZTEC_DATA_12;
      default:
        throw new IllegalArgumentException("Unsupported word size " + ue);
    }
  }, me.stuffBits = function(ue, Qe) {
    for (var Ue = new BitArray(), He = ue.getSize(), Ge = (1 << Qe) - 2, Xe = 0; Xe < He; Xe += Qe) {
      for (var Ke = 0, $e = 0; $e < Qe; $e++)
        (Xe + $e >= He || ue.get(Xe + $e)) && (Ke |= 1 << Qe - 1 - $e);
      (Ke & Ge) === Ge ? (Ue.appendBits(Ke & Ge, Qe), Xe--) : Ke & Ge ? Ue.appendBits(Ke, Qe) : (Ue.appendBits(Ke | 1, Qe), Xe--);
    }
    return Ue;
  }, me.totalBitsInLayer = function(ue, Qe) {
    return ((Qe ? 88 : 112) + 16 * ue) * ue;
  }, me.DEFAULT_EC_PERCENT = 33, me.DEFAULT_AZTEC_LAYERS = 0, me.MAX_NB_BITS = 32, me.MAX_NB_BITS_COMPACT = 4, me.WORD_SIZE = Int32Array.from([
    4,
    6,
    6,
    8,
    8,
    8,
    8,
    8,
    8,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12
  ]), me;
})();
var __extends$6 = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) Object.prototype.hasOwnProperty.call(He, Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    if (typeof Qe != "function" && Qe !== null)
      throw new TypeError("Class extends value " + String(Qe) + " is not a constructor or null");
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), HTMLCanvasElementLuminanceSource = (
  /** @class */
  function(me) {
    __extends$6(ue, me);
    function ue(Qe) {
      var Ue = me.call(this, Qe.width, Qe.height) || this;
      return Ue.canvas = Qe, Ue.tempCanvasElement = null, Ue.buffer = ue.makeBufferFromCanvasImageData(Qe), Ue;
    }
    return ue.makeBufferFromCanvasImageData = function(Qe) {
      var Ue = Qe.getContext("2d");
      if (!Ue)
        throw new Error("Couldn't get canvas context.");
      var He = Ue.getImageData(0, 0, Qe.width, Qe.height);
      return ue.toGrayscaleBuffer(He.data, Qe.width, Qe.height);
    }, ue.toGrayscaleBuffer = function(Qe, Ue, He) {
      for (var Ge = new Uint8ClampedArray(Ue * He), Xe = 0, Ke = 0, $e = Qe.length; Xe < $e; Xe += 4, Ke++) {
        var Je = void 0, Ze = Qe[Xe + 3];
        if (Ze === 0)
          Je = 255;
        else {
          var nt = Qe[Xe], tt = Qe[Xe + 1], et = Qe[Xe + 2];
          Je = 306 * nt + 601 * tt + 117 * et + 512 >> 10;
        }
        Ge[Ke] = Je;
      }
      return Ge;
    }, ue.prototype.getRow = function(Qe, Ue) {
      if (Qe < 0 || Qe >= this.getHeight())
        throw new IllegalArgumentException("Requested row is outside the image: " + Qe);
      var He = this.getWidth(), Ge = Qe * He;
      return Ue === null ? Ue = this.buffer.slice(Ge, Ge + He) : (Ue.length < He && (Ue = new Uint8ClampedArray(He)), Ue.set(this.buffer.slice(Ge, Ge + He))), Ue;
    }, ue.prototype.getMatrix = function() {
      return this.buffer;
    }, ue.prototype.isCropSupported = function() {
      return !0;
    }, ue.prototype.crop = function(Qe, Ue, He, Ge) {
      return me.prototype.crop.call(this, Qe, Ue, He, Ge), this;
    }, ue.prototype.isRotateSupported = function() {
      return !0;
    }, ue.prototype.rotateCounterClockwise = function() {
      return this.rotate(-90), this;
    }, ue.prototype.rotateCounterClockwise45 = function() {
      return this.rotate(-45), this;
    }, ue.prototype.invert = function() {
      return new InvertedLuminanceSource(this);
    }, ue.prototype.getTempCanvasElement = function() {
      if (this.tempCanvasElement === null) {
        var Qe = this.canvas.ownerDocument.createElement("canvas");
        Qe.width = this.canvas.width, Qe.height = this.canvas.height, this.tempCanvasElement = Qe;
      }
      return this.tempCanvasElement;
    }, ue.prototype.rotate = function(Qe) {
      var Ue = this.getTempCanvasElement();
      if (!Ue)
        throw new Error("Could not create a Canvas element.");
      var He = Qe * ue.DEGREE_TO_RADIANS, Ge = this.canvas.width, Xe = this.canvas.height, Ke = Math.ceil(Math.abs(Math.cos(He)) * Ge + Math.abs(Math.sin(He)) * Xe), $e = Math.ceil(Math.abs(Math.sin(He)) * Ge + Math.abs(Math.cos(He)) * Xe);
      Ue.width = Ke, Ue.height = $e;
      var Je = Ue.getContext("2d");
      if (!Je)
        throw new Error("Could not create a Canvas Context element.");
      return Je.translate(Ke / 2, $e / 2), Je.rotate(He), Je.drawImage(this.canvas, Ge / -2, Xe / -2), this.buffer = ue.makeBufferFromCanvasImageData(Ue), this;
    }, ue.DEGREE_TO_RADIANS = Math.PI / 180, ue;
  }(LuminanceSource)
);
function hasNavigator() {
  return typeof navigator < "u";
}
function isMediaDevicesSupported() {
  return hasNavigator() && !!navigator.mediaDevices;
}
function canEnumerateDevices() {
  return !!(isMediaDevicesSupported() && navigator.mediaDevices.enumerateDevices);
}
var __assign = function() {
  return __assign = Object.assign || function(me) {
    for (var ue, Qe = 1, Ue = arguments.length; Qe < Ue; Qe++) {
      ue = arguments[Qe];
      for (var He in ue) Object.prototype.hasOwnProperty.call(ue, He) && (me[He] = ue[He]);
    }
    return me;
  }, __assign.apply(this, arguments);
}, __awaiter$1 = function(me, ue, Qe, Ue) {
  function He(Ge) {
    return Ge instanceof Qe ? Ge : new Qe(function(Xe) {
      Xe(Ge);
    });
  }
  return new (Qe || (Qe = Promise))(function(Ge, Xe) {
    function Ke(Ze) {
      try {
        Je(Ue.next(Ze));
      } catch (nt) {
        Xe(nt);
      }
    }
    function $e(Ze) {
      try {
        Je(Ue.throw(Ze));
      } catch (nt) {
        Xe(nt);
      }
    }
    function Je(Ze) {
      Ze.done ? Ge(Ze.value) : He(Ze.value).then(Ke, $e);
    }
    Je((Ue = Ue.apply(me, ue || [])).next());
  });
}, __generator = function(me, ue) {
  var Qe = { label: 0, sent: function() {
    if (Ge[0] & 1) throw Ge[1];
    return Ge[1];
  }, trys: [], ops: [] }, Ue, He, Ge, Xe;
  return Xe = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && (Xe[Symbol.iterator] = function() {
    return this;
  }), Xe;
  function Ke(Je) {
    return function(Ze) {
      return $e([Je, Ze]);
    };
  }
  function $e(Je) {
    if (Ue) throw new TypeError("Generator is already executing.");
    for (; Qe; ) try {
      if (Ue = 1, He && (Ge = Je[0] & 2 ? He.return : Je[0] ? He.throw || ((Ge = He.return) && Ge.call(He), 0) : He.next) && !(Ge = Ge.call(He, Je[1])).done) return Ge;
      switch (He = 0, Ge && (Je = [Je[0] & 2, Ge.value]), Je[0]) {
        case 0:
        case 1:
          Ge = Je;
          break;
        case 4:
          return Qe.label++, { value: Je[1], done: !1 };
        case 5:
          Qe.label++, He = Je[1], Je = [0];
          continue;
        case 7:
          Je = Qe.ops.pop(), Qe.trys.pop();
          continue;
        default:
          if (Ge = Qe.trys, !(Ge = Ge.length > 0 && Ge[Ge.length - 1]) && (Je[0] === 6 || Je[0] === 2)) {
            Qe = 0;
            continue;
          }
          if (Je[0] === 3 && (!Ge || Je[1] > Ge[0] && Je[1] < Ge[3])) {
            Qe.label = Je[1];
            break;
          }
          if (Je[0] === 6 && Qe.label < Ge[1]) {
            Qe.label = Ge[1], Ge = Je;
            break;
          }
          if (Ge && Qe.label < Ge[2]) {
            Qe.label = Ge[2], Qe.ops.push(Je);
            break;
          }
          Ge[2] && Qe.ops.pop(), Qe.trys.pop();
          continue;
      }
      Je = ue.call(me, Qe);
    } catch (Ze) {
      Je = [6, Ze], He = 0;
    } finally {
      Ue = Ge = 0;
    }
    if (Je[0] & 5) throw Je[1];
    return { value: Je[0] ? Je[1] : void 0, done: !0 };
  }
}, __values = function(me) {
  var ue = typeof Symbol == "function" && Symbol.iterator, Qe = ue && me[ue], Ue = 0;
  if (Qe) return Qe.call(me);
  if (me && typeof me.length == "number") return {
    next: function() {
      return me && Ue >= me.length && (me = void 0), { value: me && me[Ue++], done: !me };
    }
  };
  throw new TypeError(ue ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, defaultOptions = {
  delayBetweenScanAttempts: 500,
  delayBetweenScanSuccess: 500,
  tryPlayVideoTimeout: 5e3
}, BrowserCodeReader = (
  /** @class */
  function() {
    function me(ue, Qe, Ue) {
      Qe === void 0 && (Qe = /* @__PURE__ */ new Map()), Ue === void 0 && (Ue = {}), this.reader = ue, this.hints = Qe, this.options = __assign(__assign({}, defaultOptions), Ue);
    }
    return Object.defineProperty(me.prototype, "possibleFormats", {
      /**
       * Allows to change the possible formats the decoder should
       * search for while scanning some image. Useful for changing
       * the possible formats during BrowserCodeReader::scan.
       */
      set: function(ue) {
        this.hints.set(DecodeHintType$1.POSSIBLE_FORMATS, ue);
      },
      enumerable: !1,
      configurable: !0
    }), me.addVideoSource = function(ue, Qe) {
      try {
        ue.srcObject = Qe;
      } catch {
        console.error("got interrupted by new loading request");
      }
    }, me.mediaStreamSetTorch = function(ue, Qe) {
      return __awaiter$1(this, void 0, void 0, function() {
        return __generator(this, function(Ue) {
          switch (Ue.label) {
            case 0:
              return [4, ue.applyConstraints({
                advanced: [{
                  fillLightMode: Qe ? "flash" : "off",
                  torch: !!Qe
                }]
              })];
            case 1:
              return Ue.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, me.mediaStreamIsTorchCompatible = function(ue) {
      var Qe, Ue, He = ue.getVideoTracks();
      try {
        for (var Ge = __values(He), Xe = Ge.next(); !Xe.done; Xe = Ge.next()) {
          var Ke = Xe.value;
          if (me.mediaStreamIsTorchCompatibleTrack(Ke))
            return !0;
        }
      } catch ($e) {
        Qe = { error: $e };
      } finally {
        try {
          Xe && !Xe.done && (Ue = Ge.return) && Ue.call(Ge);
        } finally {
          if (Qe) throw Qe.error;
        }
      }
      return !1;
    }, me.mediaStreamIsTorchCompatibleTrack = function(ue) {
      try {
        var Qe = ue.getCapabilities();
        return "torch" in Qe;
      } catch (Ue) {
        return console.error(Ue), console.warn("Your browser may be not fully compatible with WebRTC and/or ImageCapture specs. Torch will not be available."), !1;
      }
    }, me.isVideoPlaying = function(ue) {
      return ue.currentTime > 0 && !ue.paused && ue.readyState > 2;
    }, me.getMediaElement = function(ue, Qe) {
      var Ue = document.getElementById(ue);
      if (!Ue)
        throw new ArgumentException("element with id '".concat(ue, "' not found"));
      if (Ue.nodeName.toLowerCase() !== Qe.toLowerCase())
        throw new ArgumentException("element with id '".concat(ue, "' must be an ").concat(Qe, " element"));
      return Ue;
    }, me.createVideoElement = function(ue) {
      if (ue instanceof HTMLVideoElement)
        return ue;
      if (typeof ue == "string")
        return me.getMediaElement(ue, "video");
      if (!ue && typeof document < "u") {
        var Qe = document.createElement("video");
        return Qe.width = 200, Qe.height = 200, Qe;
      }
      throw new Error("Couldn't get videoElement from videoSource!");
    }, me.prepareImageElement = function(ue) {
      if (ue instanceof HTMLImageElement)
        return ue;
      if (typeof ue == "string")
        return me.getMediaElement(ue, "img");
      if (typeof ue > "u") {
        var Qe = document.createElement("img");
        return Qe.width = 200, Qe.height = 200, Qe;
      }
      throw new Error("Couldn't get imageElement from imageSource!");
    }, me.prepareVideoElement = function(ue) {
      var Qe = me.createVideoElement(ue);
      return Qe.setAttribute("autoplay", "true"), Qe.setAttribute("muted", "true"), Qe.setAttribute("playsinline", "true"), Qe;
    }, me.isImageLoaded = function(ue) {
      return !(!ue.complete || ue.naturalWidth === 0);
    }, me.createBinaryBitmapFromCanvas = function(ue) {
      var Qe = new HTMLCanvasElementLuminanceSource(ue), Ue = new HybridBinarizer(Qe);
      return new BinaryBitmap(Ue);
    }, me.drawImageOnCanvas = function(ue, Qe) {
      ue.drawImage(Qe, 0, 0);
    }, me.getMediaElementDimensions = function(ue) {
      if (ue instanceof HTMLVideoElement)
        return {
          height: ue.videoHeight,
          width: ue.videoWidth
        };
      if (ue instanceof HTMLImageElement)
        return {
          height: ue.naturalHeight || ue.height,
          width: ue.naturalWidth || ue.width
        };
      throw new Error("Couldn't find the Source's dimensions!");
    }, me.createCaptureCanvas = function(ue) {
      if (!ue)
        throw new ArgumentException("Cannot create a capture canvas without a media element.");
      if (typeof document > "u")
        throw new Error(`The page "Document" is undefined, make sure you're running in a browser.`);
      var Qe = document.createElement("canvas"), Ue = me.getMediaElementDimensions(ue), He = Ue.width, Ge = Ue.height;
      return Qe.style.width = He + "px", Qe.style.height = Ge + "px", Qe.width = He, Qe.height = Ge, Qe;
    }, me.tryPlayVideo = function(ue) {
      return __awaiter$1(this, void 0, void 0, function() {
        var Qe;
        return __generator(this, function(Ue) {
          switch (Ue.label) {
            case 0:
              if (ue != null && ue.ended)
                return console.error("Trying to play video that has ended."), [2, !1];
              if (me.isVideoPlaying(ue))
                return console.warn("Trying to play video that is already playing."), [2, !0];
              Ue.label = 1;
            case 1:
              return Ue.trys.push([1, 3, , 4]), [4, ue.play()];
            case 2:
              return Ue.sent(), [2, !0];
            case 3:
              return Qe = Ue.sent(), console.warn("It was not possible to play the video.", Qe), [2, !1];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, me.createCanvasFromMediaElement = function(ue) {
      var Qe = me.createCaptureCanvas(ue), Ue = Qe.getContext("2d");
      if (!Ue)
        throw new Error("Couldn't find Canvas 2D Context.");
      return me.drawImageOnCanvas(Ue, ue), Qe;
    }, me.createBinaryBitmapFromMediaElem = function(ue) {
      var Qe = me.createCanvasFromMediaElement(ue);
      return me.createBinaryBitmapFromCanvas(Qe);
    }, me.destroyImageElement = function(ue) {
      ue.src = "", ue.removeAttribute("src"), ue = void 0;
    }, me.listVideoInputDevices = function() {
      return __awaiter$1(this, void 0, void 0, function() {
        var ue, Qe, Ue, He, Ge, Xe, Ke, $e, Je, Ze, nt, tt;
        return __generator(this, function(et) {
          switch (et.label) {
            case 0:
              if (!hasNavigator())
                throw new Error("Can't enumerate devices, navigator is not present.");
              if (!canEnumerateDevices())
                throw new Error("Can't enumerate devices, method not supported.");
              return [4, navigator.mediaDevices.enumerateDevices()];
            case 1:
              ue = et.sent(), Qe = [];
              try {
                for (Ue = __values(ue), He = Ue.next(); !He.done; He = Ue.next())
                  Ge = He.value, Xe = Ge.kind === "video" ? "videoinput" : Ge.kind, Xe === "videoinput" && (Ke = Ge.deviceId || Ge.id, $e = Ge.label || "Video device ".concat(Qe.length + 1), Je = Ge.groupId, Ze = { deviceId: Ke, label: $e, kind: Xe, groupId: Je }, Qe.push(Ze));
              } catch (rt) {
                nt = { error: rt };
              } finally {
                try {
                  He && !He.done && (tt = Ue.return) && tt.call(Ue);
                } finally {
                  if (nt) throw nt.error;
                }
              }
              return [2, Qe];
          }
        });
      });
    }, me.findDeviceById = function(ue) {
      return __awaiter$1(this, void 0, void 0, function() {
        var Qe;
        return __generator(this, function(Ue) {
          switch (Ue.label) {
            case 0:
              return [4, me.listVideoInputDevices()];
            case 1:
              return Qe = Ue.sent(), Qe ? [2, Qe.find(function(He) {
                return He.deviceId === ue;
              })] : [
                2
                /*return*/
              ];
          }
        });
      });
    }, me.cleanVideoSource = function(ue) {
      if (ue) {
        try {
          ue.srcObject = null;
        } catch {
          ue.src = "";
        }
        ue && ue.removeAttribute("src");
      }
    }, me.releaseAllStreams = function() {
      me.streamTracker.length !== 0 && me.streamTracker.forEach(function(ue) {
        ue.getTracks().forEach(function(Qe) {
          return Qe.stop();
        });
      }), me.streamTracker = [];
    }, me.playVideoOnLoadAsync = function(ue, Qe) {
      return __awaiter$1(this, void 0, void 0, function() {
        var Ue;
        return __generator(this, function(He) {
          switch (He.label) {
            case 0:
              return [4, me.tryPlayVideo(ue)];
            case 1:
              return Ue = He.sent(), Ue ? [2, !0] : [2, new Promise(function(Ge, Xe) {
                var Ke = setTimeout(function() {
                  me.isVideoPlaying(ue) || (Xe(!1), ue.removeEventListener("canplay", $e));
                }, Qe), $e = function() {
                  me.tryPlayVideo(ue).then(function(Je) {
                    clearTimeout(Ke), ue.removeEventListener("canplay", $e), Ge(Je);
                  });
                };
                ue.addEventListener("canplay", $e);
              })];
          }
        });
      });
    }, me.attachStreamToVideo = function(ue, Qe, Ue) {
      return Ue === void 0 && (Ue = 5e3), __awaiter$1(this, void 0, void 0, function() {
        var He;
        return __generator(this, function(Ge) {
          switch (Ge.label) {
            case 0:
              return He = me.prepareVideoElement(Qe), me.addVideoSource(He, ue), [4, me.playVideoOnLoadAsync(He, Ue)];
            case 1:
              return Ge.sent(), [2, He];
          }
        });
      });
    }, me._waitImageLoad = function(ue) {
      return new Promise(function(Qe, Ue) {
        var He = 1e4, Ge = setTimeout(function() {
          me.isImageLoaded(ue) || (ue.removeEventListener("load", Xe), Ue());
        }, He), Xe = function() {
          clearTimeout(Ge), ue.removeEventListener("load", Xe), Qe();
        };
        ue.addEventListener("load", Xe);
      });
    }, me.checkCallbackFnOrThrow = function(ue) {
      if (!ue)
        throw new ArgumentException("`callbackFn` is a required parameter, you cannot capture results without it.");
    }, me.disposeMediaStream = function(ue) {
      ue.getVideoTracks().forEach(function(Qe) {
        return Qe.stop();
      }), ue = void 0;
    }, me.prototype.decode = function(ue) {
      var Qe = me.createCanvasFromMediaElement(ue);
      return this.decodeFromCanvas(Qe);
    }, me.prototype.decodeBitmap = function(ue) {
      return this.reader.decode(ue, this.hints);
    }, me.prototype.decodeFromCanvas = function(ue) {
      var Qe = me.createBinaryBitmapFromCanvas(ue);
      return this.decodeBitmap(Qe);
    }, me.prototype.decodeFromImageElement = function(ue) {
      return __awaiter$1(this, void 0, void 0, function() {
        var Qe;
        return __generator(this, function(Ue) {
          switch (Ue.label) {
            case 0:
              if (!ue)
                throw new ArgumentException("An image element must be provided.");
              return Qe = me.prepareImageElement(ue), [4, this._decodeOnLoadImage(Qe)];
            case 1:
              return [2, Ue.sent()];
          }
        });
      });
    }, me.prototype.decodeFromImageUrl = function(ue) {
      return __awaiter$1(this, void 0, void 0, function() {
        var Qe;
        return __generator(this, function(Ue) {
          switch (Ue.label) {
            case 0:
              if (!ue)
                throw new ArgumentException("An URL must be provided.");
              Qe = me.prepareImageElement(), Qe.src = ue, Ue.label = 1;
            case 1:
              return Ue.trys.push([1, , 3, 4]), [4, this.decodeFromImageElement(Qe)];
            case 2:
              return [2, Ue.sent()];
            case 3:
              return me.destroyImageElement(Qe), [
                7
                /*endfinally*/
              ];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, me.prototype.decodeFromConstraints = function(ue, Qe, Ue) {
      return __awaiter$1(this, void 0, void 0, function() {
        var He, Ge;
        return __generator(this, function(Xe) {
          switch (Xe.label) {
            case 0:
              return me.checkCallbackFnOrThrow(Ue), [4, this.getUserMedia(ue)];
            case 1:
              He = Xe.sent(), Xe.label = 2;
            case 2:
              return Xe.trys.push([2, 4, , 5]), [4, this.decodeFromStream(He, Qe, Ue)];
            case 3:
              return [2, Xe.sent()];
            case 4:
              throw Ge = Xe.sent(), me.disposeMediaStream(He), Ge;
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, me.prototype.decodeFromStream = function(ue, Qe, Ue) {
      return __awaiter$1(this, void 0, void 0, function() {
        var He, Ge, Xe, Ke, $e, Je, Ze, nt, tt, et = this;
        return __generator(this, function(rt) {
          switch (rt.label) {
            case 0:
              return me.checkCallbackFnOrThrow(Ue), He = this.options.tryPlayVideoTimeout, [4, me.attachStreamToVideo(ue, Qe, He)];
            case 1:
              return Ge = rt.sent(), Xe = function() {
                me.disposeMediaStream(ue), me.cleanVideoSource(Ge);
              }, Ke = this.scan(Ge, Ue, Xe), $e = ue.getVideoTracks(), Je = __assign(__assign({}, Ke), { stop: function() {
                Ke.stop();
              }, streamVideoConstraintsApply: function(it, ot) {
                return __awaiter$1(this, void 0, void 0, function() {
                  var at, st, ut, lt, dt, At, pt;
                  return __generator(this, function(gt) {
                    switch (gt.label) {
                      case 0:
                        at = ot ? $e.filter(ot) : $e, gt.label = 1;
                      case 1:
                        gt.trys.push([1, 6, 7, 8]), st = __values(at), ut = st.next(), gt.label = 2;
                      case 2:
                        return ut.done ? [3, 5] : (lt = ut.value, [4, lt.applyConstraints(it)]);
                      case 3:
                        gt.sent(), gt.label = 4;
                      case 4:
                        return ut = st.next(), [3, 2];
                      case 5:
                        return [3, 8];
                      case 6:
                        return dt = gt.sent(), At = { error: dt }, [3, 8];
                      case 7:
                        try {
                          ut && !ut.done && (pt = st.return) && pt.call(st);
                        } finally {
                          if (At) throw At.error;
                        }
                        return [
                          7
                          /*endfinally*/
                        ];
                      case 8:
                        return [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              }, streamVideoConstraintsGet: function(it) {
                return $e.find(it).getConstraints();
              }, streamVideoSettingsGet: function(it) {
                return $e.find(it).getSettings();
              }, streamVideoCapabilitiesGet: function(it) {
                return $e.find(it).getCapabilities();
              } }), Ze = me.mediaStreamIsTorchCompatible(ue), Ze && (nt = $e == null ? void 0 : $e.find(function(it) {
                return me.mediaStreamIsTorchCompatibleTrack(it);
              }), tt = function(it) {
                return __awaiter$1(et, void 0, void 0, function() {
                  return __generator(this, function(ot) {
                    switch (ot.label) {
                      case 0:
                        return [4, me.mediaStreamSetTorch(nt, it)];
                      case 1:
                        return ot.sent(), [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              }, Je.switchTorch = tt, Je.stop = function() {
                return __awaiter$1(et, void 0, void 0, function() {
                  return __generator(this, function(it) {
                    switch (it.label) {
                      case 0:
                        return Ke.stop(), [4, tt(!1)];
                      case 1:
                        return it.sent(), [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              }), [2, Je];
          }
        });
      });
    }, me.prototype.decodeFromVideoDevice = function(ue, Qe, Ue) {
      return __awaiter$1(this, void 0, void 0, function() {
        var He, Ge;
        return __generator(this, function(Xe) {
          switch (Xe.label) {
            case 0:
              return me.checkCallbackFnOrThrow(Ue), ue ? He = { deviceId: { exact: ue } } : He = { facingMode: "environment" }, Ge = { video: He }, [4, this.decodeFromConstraints(Ge, Qe, Ue)];
            case 1:
              return [2, Xe.sent()];
          }
        });
      });
    }, me.prototype.decodeFromVideoElement = function(ue, Qe) {
      return __awaiter$1(this, void 0, void 0, function() {
        var Ue, He;
        return __generator(this, function(Ge) {
          switch (Ge.label) {
            case 0:
              if (me.checkCallbackFnOrThrow(Qe), !ue)
                throw new ArgumentException("A video element must be provided.");
              return Ue = me.prepareVideoElement(ue), He = this.options.tryPlayVideoTimeout, [4, me.playVideoOnLoadAsync(Ue, He)];
            case 1:
              return Ge.sent(), [2, this.scan(Ue, Qe)];
          }
        });
      });
    }, me.prototype.decodeFromVideoUrl = function(ue, Qe) {
      return __awaiter$1(this, void 0, void 0, function() {
        var Ue, He, Ge, Xe;
        return __generator(this, function(Ke) {
          switch (Ke.label) {
            case 0:
              if (me.checkCallbackFnOrThrow(Qe), !ue)
                throw new ArgumentException("An URL must be provided.");
              return Ue = me.prepareVideoElement(), Ue.src = ue, He = function() {
                me.cleanVideoSource(Ue);
              }, Ge = this.options.tryPlayVideoTimeout, [4, me.playVideoOnLoadAsync(Ue, Ge)];
            case 1:
              return Ke.sent(), Xe = this.scan(Ue, Qe, He), [2, Xe];
          }
        });
      });
    }, me.prototype.decodeOnceFromConstraints = function(ue, Qe) {
      return __awaiter$1(this, void 0, void 0, function() {
        var Ue;
        return __generator(this, function(He) {
          switch (He.label) {
            case 0:
              return [4, this.getUserMedia(ue)];
            case 1:
              return Ue = He.sent(), [4, this.decodeOnceFromStream(Ue, Qe)];
            case 2:
              return [2, He.sent()];
          }
        });
      });
    }, me.prototype.decodeOnceFromStream = function(ue, Qe) {
      return __awaiter$1(this, void 0, void 0, function() {
        var Ue, He, Ge;
        return __generator(this, function(Xe) {
          switch (Xe.label) {
            case 0:
              return Ue = !!Qe, [4, me.attachStreamToVideo(ue, Qe)];
            case 1:
              He = Xe.sent(), Xe.label = 2;
            case 2:
              return Xe.trys.push([2, , 4, 5]), [4, this.scanOneResult(He)];
            case 3:
              return Ge = Xe.sent(), [2, Ge];
            case 4:
              return Ue || me.cleanVideoSource(He), [
                7
                /*endfinally*/
              ];
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, me.prototype.decodeOnceFromVideoDevice = function(ue, Qe) {
      return __awaiter$1(this, void 0, void 0, function() {
        var Ue, He;
        return __generator(this, function(Ge) {
          switch (Ge.label) {
            case 0:
              return ue ? Ue = { deviceId: { exact: ue } } : Ue = { facingMode: "environment" }, He = { video: Ue }, [4, this.decodeOnceFromConstraints(He, Qe)];
            case 1:
              return [2, Ge.sent()];
          }
        });
      });
    }, me.prototype.decodeOnceFromVideoElement = function(ue) {
      return __awaiter$1(this, void 0, void 0, function() {
        var Qe, Ue;
        return __generator(this, function(He) {
          switch (He.label) {
            case 0:
              if (!ue)
                throw new ArgumentException("A video element must be provided.");
              return Qe = me.prepareVideoElement(ue), Ue = this.options.tryPlayVideoTimeout, [4, me.playVideoOnLoadAsync(Qe, Ue)];
            case 1:
              return He.sent(), [4, this.scanOneResult(Qe)];
            case 2:
              return [2, He.sent()];
          }
        });
      });
    }, me.prototype.decodeOnceFromVideoUrl = function(ue) {
      return __awaiter$1(this, void 0, void 0, function() {
        var Qe, Ue;
        return __generator(this, function(He) {
          switch (He.label) {
            case 0:
              if (!ue)
                throw new ArgumentException("An URL must be provided.");
              Qe = me.prepareVideoElement(), Qe.src = ue, Ue = this.decodeOnceFromVideoElement(Qe), He.label = 1;
            case 1:
              return He.trys.push([1, , 3, 4]), [4, Ue];
            case 2:
              return [2, He.sent()];
            case 3:
              return me.cleanVideoSource(Qe), [
                7
                /*endfinally*/
              ];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, me.prototype.scanOneResult = function(ue, Qe, Ue, He) {
      var Ge = this;
      return Qe === void 0 && (Qe = !0), Ue === void 0 && (Ue = !0), He === void 0 && (He = !0), new Promise(function(Xe, Ke) {
        Ge.scan(ue, function($e, Je, Ze) {
          if ($e) {
            Xe($e), Ze.stop();
            return;
          }
          if (Je) {
            if (Je instanceof NotFoundException && Qe || Je instanceof ChecksumException && Ue || Je instanceof FormatException && He)
              return;
            Ze.stop(), Ke(Je);
          }
        });
      });
    }, me.prototype.scan = function(ue, Qe, Ue) {
      var He = this;
      me.checkCallbackFnOrThrow(Qe);
      var Ge = me.createCaptureCanvas(ue), Xe = Ge.getContext("2d");
      if (!Xe)
        throw new Error("Couldn't create canvas for visual element scan.");
      var Ke = function() {
        Xe = void 0, Ge = void 0;
      }, $e = !1, Je, Ze = function() {
        $e = !0, clearTimeout(Je), Ke(), Ue && Ue();
      }, nt = { stop: Ze }, tt = function() {
        if (!$e)
          try {
            me.drawImageOnCanvas(Xe, ue);
            var et = He.decodeFromCanvas(Ge);
            Qe(et, void 0, nt), Je = setTimeout(tt, He.options.delayBetweenScanSuccess);
          } catch (at) {
            Qe(void 0, at, nt);
            var rt = at instanceof ChecksumException, it = at instanceof FormatException, ot = at instanceof NotFoundException;
            if (rt || it || ot) {
              Je = setTimeout(tt, He.options.delayBetweenScanAttempts);
              return;
            }
            Ke(), Ue && Ue(at);
          }
      };
      return tt(), nt;
    }, me.prototype._decodeOnLoadImage = function(ue) {
      return __awaiter$1(this, void 0, void 0, function() {
        var Qe;
        return __generator(this, function(Ue) {
          switch (Ue.label) {
            case 0:
              return Qe = me.isImageLoaded(ue), Qe ? [3, 2] : [4, me._waitImageLoad(ue)];
            case 1:
              Ue.sent(), Ue.label = 2;
            case 2:
              return [2, this.decode(ue)];
          }
        });
      });
    }, me.prototype.getUserMedia = function(ue) {
      return __awaiter$1(this, void 0, void 0, function() {
        var Qe;
        return __generator(this, function(Ue) {
          switch (Ue.label) {
            case 0:
              return [4, navigator.mediaDevices.getUserMedia(ue)];
            case 1:
              return Qe = Ue.sent(), me.streamTracker.push(Qe), [2, Qe];
          }
        });
      });
    }, me.streamTracker = [], me;
  }()
), __extends$5 = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) Object.prototype.hasOwnProperty.call(He, Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    if (typeof Qe != "function" && Qe !== null)
      throw new TypeError("Class extends value " + String(Qe) + " is not a constructor or null");
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}();
(function(me) {
  __extends$5(ue, me);
  function ue(Qe, Ue) {
    return me.call(this, new AztecReader(), Qe, Ue) || this;
  }
  return ue;
})(BrowserCodeReader);
var __extends$4 = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) Object.prototype.hasOwnProperty.call(He, Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    if (typeof Qe != "function" && Qe !== null)
      throw new TypeError("Class extends value " + String(Qe) + " is not a constructor or null");
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}();
(function(me) {
  __extends$4(ue, me);
  function ue(Qe, Ue) {
    return me.call(this, new MultiFormatOneDReader(Qe), Qe, Ue) || this;
  }
  return ue;
})(BrowserCodeReader);
var __extends$3 = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) Object.prototype.hasOwnProperty.call(He, Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    if (typeof Qe != "function" && Qe !== null)
      throw new TypeError("Class extends value " + String(Qe) + " is not a constructor or null");
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}();
(function(me) {
  __extends$3(ue, me);
  function ue(Qe, Ue) {
    return me.call(this, new DataMatrixReader(), Qe, Ue) || this;
  }
  return ue;
})(BrowserCodeReader);
var __extends$2 = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) Object.prototype.hasOwnProperty.call(He, Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    if (typeof Qe != "function" && Qe !== null)
      throw new TypeError("Class extends value " + String(Qe) + " is not a constructor or null");
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}(), BrowserMultiFormatReader = (
  /** @class */
  function(me) {
    __extends$2(ue, me);
    function ue(Qe, Ue) {
      var He = this, Ge = new MultiFormatReader();
      return Ge.setHints(Qe), He = me.call(this, Ge, Qe, Ue) || this, He.reader = Ge, He;
    }
    return Object.defineProperty(ue.prototype, "possibleFormats", {
      set: function(Qe) {
        this.hints.set(DecodeHintType$1.POSSIBLE_FORMATS, Qe), this.reader.setHints(this.hints);
      },
      enumerable: !1,
      configurable: !0
    }), ue.prototype.decodeBitmap = function(Qe) {
      return this.reader.decodeWithState(Qe);
    }, ue.prototype.setHints = function(Qe) {
      this.hints = Qe, this.reader.setHints(this.hints);
    }, ue;
  }(BrowserCodeReader)
), __extends$1 = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) Object.prototype.hasOwnProperty.call(He, Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    if (typeof Qe != "function" && Qe !== null)
      throw new TypeError("Class extends value " + String(Qe) + " is not a constructor or null");
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}();
(function(me) {
  __extends$1(ue, me);
  function ue(Qe, Ue) {
    return me.call(this, new PDF417Reader(), Qe, Ue) || this;
  }
  return ue;
})(BrowserCodeReader);
var __extends = /* @__PURE__ */ function() {
  var me = function(ue, Qe) {
    return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ue, He) {
      Ue.__proto__ = He;
    } || function(Ue, He) {
      for (var Ge in He) Object.prototype.hasOwnProperty.call(He, Ge) && (Ue[Ge] = He[Ge]);
    }, me(ue, Qe);
  };
  return function(ue, Qe) {
    if (typeof Qe != "function" && Qe !== null)
      throw new TypeError("Class extends value " + String(Qe) + " is not a constructor or null");
    me(ue, Qe);
    function Ue() {
      this.constructor = ue;
    }
    ue.prototype = Qe === null ? Object.create(Qe) : (Ue.prototype = Qe.prototype, new Ue());
  };
}();
(function(me) {
  __extends(ue, me);
  function ue(Qe, Ue) {
    return me.call(this, new QRCodeReader(), Qe, Ue) || this;
  }
  return ue;
})(BrowserCodeReader);
const overlayImg = "data:image/svg+xml,%3csvg%20width='229'%20height='229'%20viewBox='0%200%20229%20229'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20opacity='0.4'%3e%3cpath%20d='M130.324%20136.69V130.324C130.324%20129.445%20131.036%20128.732%20131.915%20128.732H138.281C140.039%20128.732%20141.465%20130.158%20141.465%20131.916V138.282C141.465%20140.04%20140.039%20141.465%20138.281%20141.465H133.507C131.749%20141.465%20130.324%20142.89%20130.324%20144.648V147.831C130.324%20149.589%20131.749%20151.014%20133.507%20151.014H138.281C140.039%20151.014%20141.465%20152.439%20141.465%20154.197V158.972C141.465%20160.73%20140.039%20162.155%20138.281%20162.155H123.958C122.2%20162.155%20120.774%20160.73%20120.774%20158.972V143.056C120.774%20141.298%20122.2%20139.873%20123.958%20139.873H127.141C128.899%20139.873%20130.324%20138.448%20130.324%20136.69Z'%20fill='%23BCBCBC'/%3e%3cpath%20d='M216.268%20117.592V112.817C216.268%20111.059%20217.693%20109.634%20219.451%20109.634H224.225C225.983%20109.634%20227.408%20111.059%20227.408%20112.817V117.592C227.408%20119.35%20225.983%20120.775%20224.225%20120.775H219.451C217.693%20120.775%20216.268%20119.35%20216.268%20117.592Z'%20fill='%23BCBCBC'/%3e%3cpath%20d='M205.127%2095.3103V90.5356C205.127%2088.7777%20206.552%2087.3525%20208.31%2087.3525H224.226C225.984%2087.3525%20227.409%2088.7777%20227.409%2090.5356V95.3103C227.409%2097.0683%20225.984%2098.4934%20224.226%2098.4934H208.31C206.552%2098.4934%20205.127%2097.0683%20205.127%2095.3103Z'%20fill='%23BCBCBC'/%3e%3cpath%20d='M111.226%2041.1968V34.8306C111.226%2033.0726%20109.8%2031.6475%20108.042%2031.6475H95.3101C93.5521%2031.6475%2092.127%2033.0726%2092.127%2034.8306V41.1968C92.127%2042.9547%2093.5521%2044.3799%2095.3101%2044.3799H108.042C109.8%2044.3799%20111.226%2042.9547%20111.226%2041.1968Z'%20fill='%23BCBCBC'/%3e%3cpath%20d='M23.6904%20104.86V90.5356C23.6904%2088.7777%2025.1156%2087.3525%2026.8735%2087.3525H42.789C44.547%2087.3525%2045.9721%2088.7777%2045.9721%2090.5356V95.3103C45.9721%2097.0683%2044.547%2098.4934%2042.789%2098.4934H41.1975C39.4395%2098.4934%2038.0144%2099.9185%2038.0144%20101.676V104.86C38.0144%20106.618%2039.4395%20108.043%2041.1975%20108.043H53.9299C55.6878%20108.043%2057.113%20109.468%2057.113%20111.226V116C57.113%20117.758%2058.5381%20119.184%2060.2961%20119.184H63.4792C65.2371%20119.184%2066.6623%20117.758%2066.6623%20116V111.226C66.6623%20109.468%2068.0874%20108.043%2069.8454%20108.043H74.62C76.378%20108.043%2077.8031%20109.468%2077.8031%20111.226V119.184C77.8031%20120.942%2076.378%20122.367%2074.62%20122.367H69.8454C68.0874%20122.367%2066.6623%20123.792%2066.6623%20125.55C66.6623%20127.308%2068.0874%20128.733%2069.8454%20128.733H73.0285C74.7864%20128.733%2076.2116%20130.158%2076.2116%20131.916V136.691C76.2116%20138.449%2074.7864%20139.874%2073.0285%20139.874H26.8735C25.1156%20139.874%2023.6904%20138.449%2023.6904%20136.691V131.916C23.6904%20130.158%2025.1156%20128.733%2026.8735%20128.733H31.6482C33.4062%20128.733%2034.8313%20127.308%2034.8313%20125.55V111.226C34.8313%20109.468%2033.4062%20108.043%2031.6482%20108.043H26.8735C25.1156%20108.043%2023.6904%20106.618%2023.6904%20104.86Z'%20fill='%23BCBCBC'/%3e%3cpath%20d='M10.9577%2087.3525H6.1831C4.42512%2087.3525%203%2088.7777%203%2090.5356V136.691C3%20138.449%204.42512%20139.874%206.1831%20139.874H10.9577C12.7157%20139.874%2014.1408%20138.449%2014.1408%20136.691V90.5356C14.1408%2088.7777%2012.7157%2087.3525%2010.9577%2087.3525Z'%20fill='%23BCBCBC'/%3e%3crect%20x='6.18262'%20y='6.18262'%20width='66.8451'%20height='66.8451'%20rx='3.1831'%20stroke='%23BCBCBC'%20stroke-width='11.1408'/%3e%3crect%20x='155.789'%20y='6.18262'%20width='66.8451'%20height='66.8451'%20rx='3.1831'%20stroke='%23BCBCBC'%20stroke-width='11.1408'/%3e%3cpath%20d='M95.3095%2023.6901H92.1264C90.3684%2023.6901%2088.9433%2022.265%2088.9433%2020.507V6.1831C88.9433%204.42512%2090.3684%203%2092.1264%203H117.591C119.349%203%20120.774%204.42512%20120.774%206.1831V20.507C120.774%2022.265%20122.199%2023.6901%20123.957%2023.6901H128.732C130.49%2023.6901%20131.915%2022.265%20131.915%2020.507V6.1831C131.915%204.42512%20133.34%203%20135.098%203H136.69C138.448%203%20139.873%204.42512%20139.873%206.1831V28.4648C139.873%2030.2228%20138.448%2031.6479%20136.69%2031.6479H135.098C133.34%2031.6479%20131.915%2033.073%20131.915%2034.831V53.9296C131.915%2055.6876%20133.34%2057.1127%20135.098%2057.1127H136.69C138.448%2057.1127%20139.873%2058.5378%20139.873%2060.2958V95.3099C139.873%2097.0678%20141.298%2098.493%20143.056%2098.493H149.422C151.18%2098.493%20152.605%2097.0678%20152.605%2095.3099V88.9437C152.605%2087.1857%20154.03%2085.7606%20155.788%2085.7606H158.971C160.729%2085.7606%20162.155%2087.1857%20162.155%2088.9437V103.268C162.155%20105.026%20160.729%20106.451%20158.971%20106.451H131.915C130.157%20106.451%20128.732%20107.876%20128.732%20109.634V125.549C128.732%20127.307%20127.307%20128.732%20125.549%20128.732H123.957C122.199%20128.732%20120.774%20130.158%20120.774%20131.915V136.69C120.774%20138.448%20119.349%20139.873%20117.591%20139.873H112.817C111.059%20139.873%20109.633%20141.298%20109.633%20143.056V147.831C109.633%20149.589%20108.208%20151.014%20106.45%20151.014H101.676C99.9177%20151.014%2098.4926%20152.439%2098.4926%20154.197V158.972C98.4926%20160.73%2099.9177%20162.155%20101.676%20162.155H108.042C109.8%20162.155%20111.225%20163.58%20111.225%20165.338V170.113C111.225%20171.871%20112.65%20173.296%20114.408%20173.296H117.591C119.349%20173.296%20120.774%20174.721%20120.774%20176.479V182.845C120.774%20184.603%20122.199%20186.028%20123.957%20186.028H128.732C130.49%20186.028%20131.915%20187.453%20131.915%20189.211V192.394C131.915%20194.152%20133.34%20195.577%20135.098%20195.577H138.281C140.039%20195.577%20141.464%20197.003%20141.464%20198.761C141.464%20200.519%20142.89%20201.944%20144.648%20201.944H149.422C151.18%20201.944%20152.605%20200.519%20152.605%20198.761V186.028C152.605%20184.27%20151.18%20182.845%20149.422%20182.845H135.098C133.34%20182.845%20131.915%20181.42%20131.915%20179.662V176.479C131.915%20174.721%20133.34%20173.296%20135.098%20173.296H160.563C162.321%20173.296%20163.746%20171.871%20163.746%20170.113V154.197C163.746%20152.439%20165.171%20151.014%20166.929%20151.014H170.112C171.87%20151.014%20173.295%20152.439%20173.295%20154.197V162.155C173.295%20163.913%20174.721%20165.338%20176.479%20165.338H179.662C181.42%20165.338%20182.845%20166.763%20182.845%20168.521V179.662C182.845%20181.42%20184.27%20182.845%20186.028%20182.845H209.901C211.659%20182.845%20213.084%20181.42%20213.084%20179.662V176.479C213.084%20174.721%20211.659%20173.296%20209.901%20173.296H195.577C193.819%20173.296%20192.394%20171.871%20192.394%20170.113V165.338C192.394%20163.58%20190.969%20162.155%20189.211%20162.155H186.028C184.27%20162.155%20182.845%20160.73%20182.845%20158.972V143.056C182.845%20141.298%20184.27%20139.873%20186.028%20139.873H190.802C192.56%20139.873%20193.986%20138.448%20193.986%20136.69V131.915C193.986%20130.158%20192.56%20128.732%20190.802%20128.732H176.479C174.721%20128.732%20173.295%20130.158%20173.295%20131.915V136.69C173.295%20138.448%20171.87%20139.873%20170.112%20139.873H166.929C165.171%20139.873%20163.746%20138.448%20163.746%20136.69V131.915C163.746%20130.158%20162.321%20128.732%20160.563%20128.732H155.788C154.03%20128.732%20152.605%20127.307%20152.605%20125.549V122.366C152.605%20120.608%20154.03%20119.183%20155.788%20119.183H179.662C181.42%20119.183%20182.845%20117.758%20182.845%20116V88.9437C182.845%2087.1857%20184.27%2085.7606%20186.028%2085.7606H190.802C192.56%2085.7606%20193.986%2087.1857%20193.986%2088.9437V106.451C193.986%20108.209%20195.411%20109.634%20197.169%20109.634H203.535C205.293%20109.634%20206.718%20111.059%20206.718%20112.817V136.69C206.718%20138.448%20205.293%20139.873%20203.535%20139.873H200.352C198.594%20139.873%20197.169%20141.298%20197.169%20143.056V158.972C197.169%20160.73%20198.594%20162.155%20200.352%20162.155H213.084C214.842%20162.155%20216.267%20163.58%20216.267%20165.338V170.113C216.267%20171.871%20217.692%20173.296%20219.45%20173.296H225.817C227.575%20173.296%20229%20174.721%20229%20176.479V179.662C229%20181.42%20227.575%20182.845%20225.817%20182.845H219.45C217.692%20182.845%20216.267%20184.27%20216.267%20186.028V192.394C216.267%20194.152%20214.842%20195.577%20213.084%20195.577H176.479C174.721%20195.577%20173.295%20197.003%20173.295%20198.761V209.901C173.295%20211.659%20174.721%20213.085%20176.479%20213.085H182.845C184.603%20213.085%20186.028%20214.51%20186.028%20216.268V224.225C186.028%20225.983%20184.603%20227.408%20182.845%20227.408H176.479C174.721%20227.408%20173.295%20225.983%20173.295%20224.225V219.451C173.295%20217.693%20171.87%20216.268%20170.112%20216.268H165.338C163.58%20216.268%20162.155%20214.842%20162.155%20213.085V208.31C162.155%20206.552%20160.729%20205.127%20158.971%20205.127H157.38C155.622%20205.127%20154.197%20206.552%20154.197%20208.31V225.817C154.197%20227.575%20152.772%20229%20151.014%20229H143.056C141.298%20229%20139.873%20227.575%20139.873%20225.817V208.31C139.873%20206.552%20138.448%20205.127%20136.69%20205.127H131.915C130.157%20205.127%20128.732%20203.702%20128.732%20201.944V198.761C128.732%20197.003%20127.307%20195.577%20125.549%20195.577H123.957C122.199%20195.577%20120.774%20197.003%20120.774%20198.761V213.085C120.774%20214.842%20119.349%20216.268%20117.591%20216.268H112.817C111.059%20216.268%20109.633%20217.693%20109.633%20219.451V224.225C109.633%20225.983%20108.208%20227.408%20106.45%20227.408H88.9433C87.1853%20227.408%2085.7602%20225.983%2085.7602%20224.225V216.268C85.7602%20214.51%2087.1853%20213.085%2088.9433%20213.085H106.45C108.208%20213.085%20109.633%20211.659%20109.633%20209.901V208.31C109.633%20206.552%20108.208%20205.127%20106.45%20205.127H95.3095C93.5515%20205.127%2092.1264%20203.702%2092.1264%20201.944V186.028C92.1264%20184.27%2093.5515%20182.845%2095.3095%20182.845H106.45C108.208%20182.845%20109.633%20181.42%20109.633%20179.662V176.479C109.633%20174.721%20108.208%20173.296%20106.45%20173.296H92.1264C90.3684%20173.296%2088.9433%20171.871%2088.9433%20170.113V143.056C88.9433%20141.298%2090.3684%20139.873%2092.1264%20139.873H96.901C98.659%20139.873%20100.084%20138.448%20100.084%20136.69V131.915C100.084%20130.158%20101.509%20128.732%20103.267%20128.732H106.45C108.208%20128.732%20109.633%20127.307%20109.633%20125.549V109.634C109.633%20107.876%20108.208%20106.451%20106.45%20106.451H101.676C99.9177%20106.451%2098.4926%20107.876%2098.4926%20109.634V125.549C98.4926%20127.307%2097.0675%20128.732%2095.3095%20128.732C93.5515%20128.732%2092.1264%20127.307%2092.1264%20125.549V101.676C92.1264%2099.9181%2093.5515%2098.493%2095.3095%2098.493C97.0675%2098.493%2098.4926%2097.0678%2098.4926%2095.3099V92.1268C98.4926%2090.3688%2097.0675%2088.9437%2095.3095%2088.9437H92.1264C90.3684%2088.9437%2088.9433%2090.3688%2088.9433%2092.1268V95.3099C88.9433%2097.0678%2087.5182%2098.493%2085.7602%2098.493H60.2954C58.5374%2098.493%2057.1123%2097.0678%2057.1123%2095.3099V88.9437C57.1123%2087.1857%2058.5374%2085.7606%2060.2954%2085.7606H85.7602C87.5182%2085.7606%2088.9433%2084.3354%2088.9433%2082.5775V69.8451C88.9433%2068.0871%2090.3684%2066.662%2092.1264%2066.662H95.3095C97.0675%2066.662%2098.4926%2068.0871%2098.4926%2069.8451V74.6197C98.4926%2076.3777%2099.9177%2077.8028%20101.676%2077.8028H106.45C108.208%2077.8028%20109.633%2076.3777%20109.633%2074.6197V69.8451C109.633%2068.0871%20111.059%2066.662%20112.817%2066.662H114.408C116.166%2066.662%20117.591%2068.0871%20117.591%2069.8451V76.2113C117.591%2077.9692%20116.166%2079.3944%20114.408%2079.3944H112.817C111.059%2079.3944%20109.633%2080.8195%20109.633%2082.5775V95.3099C109.633%2097.0678%20111.059%2098.493%20112.817%2098.493H117.591C119.349%2098.493%20120.774%2097.0678%20120.774%2095.3099V80.9859C120.774%2079.2279%20122.199%2077.8028%20123.957%2077.8028H128.732C130.49%2077.8028%20131.915%2076.3777%20131.915%2074.6197V66.662C131.915%2064.904%20130.49%2063.4789%20128.732%2063.4789H123.957C122.199%2063.4789%20120.774%2062.0538%20120.774%2060.2958V34.831C120.774%2033.073%20119.349%2031.6479%20117.591%2031.6479H114.408C112.65%2031.6479%20111.225%2030.2228%20111.225%2028.4648V15.7324C111.225%2013.9744%20109.8%2012.5493%20108.042%2012.5493H101.676C99.9177%2012.5493%2098.4926%2013.9744%2098.4926%2015.7324V20.507C98.4926%2022.265%2097.0675%2023.6901%2095.3095%2023.6901Z'%20fill='%23BCBCBC'/%3e%3crect%20x='6.18262'%20y='155.789'%20width='66.8451'%20height='66.8451'%20rx='3.1831'%20stroke='%23BCBCBC'%20stroke-width='11.1408'/%3e%3crect%20x='25.2812'%20y='25.2812'%20width='28.6479'%20height='28.6479'%20rx='3.1831'%20fill='%23BCBCBC'/%3e%3crect%20x='174.888'%20y='25.2812'%20width='28.6479'%20height='28.6479'%20rx='3.1831'%20fill='%23BCBCBC'/%3e%3crect%20x='25.2812'%20y='174.888'%20width='28.6479'%20height='28.6479'%20rx='3.1831'%20fill='%23BCBCBC'/%3e%3c/g%3e%3c/svg%3e", tutorial = "data:image/svg+xml,%3csvg%20width='285'%20height='279'%20viewBox='0%200%20285%20279'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3crect%20width='285'%20height='279'%20fill='url(%23pattern0)'/%3e%3cdefs%3e%3cpattern%20id='pattern0'%20patternContentUnits='objectBoundingBox'%20width='1'%20height='1'%3e%3cuse%20xlink:href='%23image0_1167_27543'%20transform='matrix(0.001%200%200%200.00102151%200%20-0.000537634)'/%3e%3c/pattern%3e%3cimage%20id='image0_1167_27543'%20width='1000'%20height='980'%20xlink:href='data:image/png;base64,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'/%3e%3c/defs%3e%3c/svg%3e", codeReader = new BrowserMultiFormatReader(), QrScannerTutorialContainer = qe.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5em 2em;
  text-align: center;
  height: 100%;

  .img-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`, QRScanner = ({ token: me, onSuccess: ue }) => {
  const { currentStep: Qe, nextStep: Ue } = useSteps();
  return useModuleEvents({
    module: eventModuleNames.generateQR,
    token: me.token
  }), /* @__PURE__ */ jsxRuntimeExports.jsxs(Steps, { currentStep: Qe, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(QRScannerTutorial, { nextStep: Ue, token: me.token }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(QRScannerMain, { token: me.token, onSuccess: ue })
  ] });
}, QRScannerTutorial = ({ nextStep: me, token: ue }) => {
  const { t: Qe } = useTranslation();
  return useScreenEvents({
    module: eventModuleNames.generateQR,
    screen: eventScreenNames.qrTutorial,
    token: ue
  }), /* @__PURE__ */ jsxRuntimeExports.jsxs(QrScannerTutorialContainer, { className: "IncodeQrScannerTutorialContainer", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "IncodeQrScannerTutorialTitle", children: Qe("qrScanner.tutorialTitle") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "IncodeQrScannerTutorialSubtitle", children: Qe("qrScanner.tutorialSubtitle") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "img-container IncodeQrScannerTutorialImageContainer", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "img",
      {
        className: "IncodeQrScannerTutorialImage",
        src: tutorial,
        alt: "scan barcode"
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button$a, { className: "IncodeQrScannerTutorialButton", onClick: me, children: Qe("common.continue") }) })
  ] });
};
function getBorderColor(me) {
  switch (me) {
    case "success":
      return "#0cd5a2";
    case "capturing":
      return "#00b2fd";
    case "error":
      return "#ff5c6f";
    default:
      return "#fff";
  }
}
function getBoxShadowColor(me) {
  switch (me) {
    case "success":
    case "capturing":
    case "error":
      return "0 0 0 99999px rgba(255, 255, 255, 1)";
    default:
      return "0 0 0 99999px rgba(0, 0, 0, 0.6)";
  }
}
function getBackgroundColor(me) {
  switch (me) {
    case "success":
    case "capturing":
    case "error":
      return "white";
    default:
      return "transparent";
  }
}
const Mask$1 = qe.img`
  z-index: 4;
  position: absolute;
  top: 50%;
  width: 200px;
  height: 200px;
  transform: translate(-50%, -50%);
  left: 50%;
  border: solid 5px;
  border-color: ${(me) => getBorderColor(me.mode)};
  box-shadow: ${(me) => getBoxShadowColor(me.mode)};
  background-color: ${(me) => getBackgroundColor(me.mode)};
  border-radius: 20px;
  padding: 5px;
`, Instructions = qe.h1`
  z-index: 6;
  position: absolute;
  top: 20%;
  transform: translate(-50%, -50%);
  left: 50%;
  color: white;
  text-align: center;
  width: 100%;
`, QRScannerMain = ({ token: me, onSuccess: ue }) => {
  const [Qe, Ue] = useState(""), He = useRef(null), { t: Ge } = useTranslation();
  useScreenEvents({
    module: eventModuleNames.generateQR,
    screen: eventScreenNames.qrScan,
    token: me
  });
  const Xe = async () => {
    const Je = He.current, Ze = Je.getCanvas(
      Je.video.videoWidth,
      Je.video.videoHeight
    );
    try {
      const nt = codeReader.decodeFromCanvas(Ze);
      Ue("capturing"), await addQrCodeText({ token: me, qrText: nt.getText() }), await sleep(3e3), Ue("success"), await sleep(3e3), ue();
    } catch {
      await sleep(1e3), Xe();
    }
  }, Ke = async () => {
    await sleep(3e3), Xe();
  }, $e = useCallback(() => {
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "IncodeQrScannerContainer", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Instructions, { className: "IncodeQrScannerInstructions", children: Ge("qrScanner.instructions") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph$1, { children: Ge(getStatusLabel(Qe)) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Mask$1, { className: "IncodeQrScannerMask", mode: Qe, src: overlayImg }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Webcam,
      {
        className: "IncodeQrScannerTutorialWebcam",
        ref: He,
        onPlay: Ke,
        videoSource: "environment",
        onError: $e,
        token: me,
        showCustomCameraPermissionScreen: !1
      }
    )
  ] });
}, Paragraph$1 = qe.p`
  color: black;
  text-align: center;
  z-index: 7;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
  max-width: 200px;
  font-size: 26px;
`, getStatusLabel = (me) => {
  switch (me) {
    case "success":
      return "qrScanner.done";
    case "capturing":
      return "qrScanner.processing";
    case "error":
      return "qrScanner.unsuccessful";
    default:
      return null;
  }
};
function renderQrScanner(me, { onSuccess: ue, session: Qe }) {
  const Ue = createRoot$1(me), He = {
    token: Qe,
    onSuccess: handleUnmountRoot(ue, Ue, me)
  };
  customRender(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { token: Qe.token, children: /* @__PURE__ */ jsxRuntimeExports.jsx(QRScanner, { ...He }) }),
    me,
    Ue
  );
}
const checkCircle = "data:image/svg+xml,%3csvg%20width='33'%20height='32'%20viewBox='0%200%2033%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M16.5%2031C24.7843%2031%2031.5%2024.2843%2031.5%2016C31.5%207.71573%2024.7843%201%2016.5%201C8.21573%201%201.5%207.71573%201.5%2016C1.5%2024.2843%208.21573%2031%2016.5%2031Z'%20fill='%230CD5A2'/%3e%3cpath%20d='M22.5%2012L14.4955%2021L10.5%2016.5'%20stroke='white'%20stroke-width='3'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", Screen = qe.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`, EndScreen = () => {
  const { t: me } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Screen, { "aria-live": "assertive", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: checkCircle, alt: "All done" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: me("videoSelfie.allGood") })
  ] });
}, SuccessVS = "data:image/svg+xml,%3csvg%20width='64'%20height='64'%20viewBox='0%200%2064%2064'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M42.6026%2026.3467L40.6723%2024.4006C40.4076%2024.1336%2040.0857%2024%2039.7074%2024C39.3286%2024%2039.0067%2024.1336%2038.7421%2024.4006L29.431%2033.8022L25.258%2029.5807C24.9931%2029.3136%2024.6714%2029.1802%2024.293%2029.1802C23.9144%2029.1802%2023.5927%2029.3136%2023.3277%2029.5807L21.3974%2031.5269C21.1324%2031.794%2021%2032.1184%2021%2032.5001C21%2032.8815%2021.1324%2033.2062%2021.3974%2033.4733L26.5354%2038.6532L28.4658%2040.5993C28.7306%2040.8666%2029.0524%2041%2029.431%2041C29.8093%2041%2030.1311%2040.8662%2030.3961%2040.5993L32.3265%2038.6532L42.6026%2028.293C42.8673%2028.0258%2043%2027.7014%2043%2027.3198C43.0002%2026.9383%2042.8673%2026.6139%2042.6026%2026.3467Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M44.5%209C43.6716%209%2043%209.67157%2043%2010.5C43%2011.3284%2043.6716%2012%2044.5%2012H51.5C51.6326%2012%2051.7598%2012.0527%2051.8536%2012.1464C51.9473%2012.2402%2052%2012.3674%2052%2012.5V19.5C52%2020.3284%2052.6716%2021%2053.5%2021C54.3284%2021%2055%2020.3284%2055%2019.5V12.5C55%2011.5717%2054.6313%2010.6815%2053.9749%2010.0251C53.3185%209.36875%2052.4283%209%2051.5%209H44.5ZM55%2045.5C55%2044.6716%2054.3284%2044%2053.5%2044C52.6716%2044%2052%2044.6716%2052%2045.5V52.5C52%2052.6326%2051.9473%2052.7598%2051.8536%2052.8536C51.7598%2052.9473%2051.6326%2053%2051.5%2053H44.5C43.6716%2053%2043%2053.6716%2043%2054.5C43%2055.3284%2043.6716%2056%2044.5%2056H51.5C52.4283%2056%2053.3185%2055.6313%2053.9749%2054.9749C54.6313%2054.3185%2055%2053.4283%2055%2052.5V45.5ZM9.5%2044C10.3284%2044%2011%2044.6716%2011%2045.5V52.5C11%2052.6326%2011.0527%2052.7598%2011.1464%2052.8536C11.2402%2052.9473%2011.3674%2053%2011.5%2053H18.5C19.3284%2053%2020%2053.6716%2020%2054.5C20%2055.3284%2019.3284%2056%2018.5%2056H11.5C10.5717%2056%209.68151%2055.6313%209.02513%2054.9749C8.36875%2054.3185%208%2053.4283%208%2052.5V45.5C8%2044.6716%208.67157%2044%209.5%2044ZM11.5%209C10.5717%209%209.6815%209.36875%209.02513%2010.0251C8.36875%2010.6815%208%2011.5717%208%2012.5V19.5C8%2020.3284%208.67157%2021%209.5%2021C10.3284%2021%2011%2020.3284%2011%2019.5V12.5C11%2012.3674%2011.0527%2012.2402%2011.1464%2012.1464C11.2402%2012.0527%2011.3674%2012%2011.5%2012H18.5C19.3284%2012%2020%2011.3284%2020%2010.5C20%209.67157%2019.3284%209%2018.5%209H11.5Z'%20fill='%230CD5A2'/%3e%3c/svg%3e", FailVS = "data:image/svg+xml,%3csvg%20width='64'%20height='64'%20viewBox='0%200%2064%2064'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M45%208.5C44.1716%208.5%2043.5%209.17157%2043.5%2010C43.5%2010.8284%2044.1716%2011.5%2045%2011.5H52C52.1326%2011.5%2052.2598%2011.5527%2052.3536%2011.6464C52.4473%2011.7402%2052.5%2011.8674%2052.5%2012V19C52.5%2019.8284%2053.1716%2020.5%2054%2020.5C54.8284%2020.5%2055.5%2019.8284%2055.5%2019V12C55.5%2011.0717%2055.1313%2010.1815%2054.4749%209.52513C53.8185%208.86875%2052.9283%208.5%2052%208.5H45ZM55.5%2045C55.5%2044.1716%2054.8284%2043.5%2054%2043.5C53.1716%2043.5%2052.5%2044.1716%2052.5%2045V52C52.5%2052.1326%2052.4473%2052.2598%2052.3536%2052.3536C52.2598%2052.4473%2052.1326%2052.5%2052%2052.5H45C44.1716%2052.5%2043.5%2053.1716%2043.5%2054C43.5%2054.8284%2044.1716%2055.5%2045%2055.5H52C52.9283%2055.5%2053.8185%2055.1313%2054.4749%2054.4749C55.1313%2053.8185%2055.5%2052.9283%2055.5%2052V45ZM10%2043.5C10.8284%2043.5%2011.5%2044.1716%2011.5%2045V52C11.5%2052.1326%2011.5527%2052.2598%2011.6464%2052.3536C11.7402%2052.4473%2011.8674%2052.5%2012%2052.5H19C19.8284%2052.5%2020.5%2053.1716%2020.5%2054C20.5%2054.8284%2019.8284%2055.5%2019%2055.5H12C11.0717%2055.5%2010.1815%2055.1313%209.52513%2054.4749C8.86875%2053.8185%208.5%2052.9283%208.5%2052V45C8.5%2044.1716%209.17157%2043.5%2010%2043.5ZM12%208.5C11.0717%208.5%2010.1815%208.86875%209.52513%209.52513C8.86875%2010.1815%208.5%2011.0717%208.5%2012V19C8.5%2019.8284%209.17157%2020.5%2010%2020.5C10.8284%2020.5%2011.5%2019.8284%2011.5%2019V12C11.5%2011.8674%2011.5527%2011.7402%2011.6464%2011.6464C11.7402%2011.5527%2011.8674%2011.5%2012%2011.5H19C19.8284%2011.5%2020.5%2010.8284%2020.5%2010C20.5%209.17157%2019.8284%208.5%2019%208.5H12Z'%20fill='%23FF5C6F'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M41.4142%2025.4142C42.1953%2024.6332%2042.1953%2023.3668%2041.4142%2022.5858C40.6332%2021.8047%2039.3668%2021.8047%2038.5858%2022.5858L32%2029.1716L25.4142%2022.5858C24.6332%2021.8047%2023.3668%2021.8047%2022.5858%2022.5858C21.8047%2023.3668%2021.8047%2024.6332%2022.5858%2025.4142L29.1716%2032L22.5858%2038.5858C21.8047%2039.3668%2021.8047%2040.6332%2022.5858%2041.4142C23.3668%2042.1953%2024.6332%2042.1953%2025.4142%2041.4142L32%2034.8284L38.5858%2041.4142C39.3668%2042.1953%2040.6332%2042.1953%2041.4142%2041.4142C42.1953%2040.6332%2042.1953%2039.3668%2041.4142%2038.5858L34.8284%2032L41.4142%2025.4142Z'%20fill='white'/%3e%3c/svg%3e", Spinner$1 = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'%20standalone='no'?%3e%3c!--%20Created%20with%20Inkscape%20(http://www.inkscape.org/)%20--%3e%3csvg%20width='48'%20height='48'%20viewBox='0%200%2012.7%2012.7'%20version='1.1'%20id='svg1'%20inkscape:version='1.3%20(0e150ed,%202023-07-21)'%20sodipodi:docname='spinner.svg'%20xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape'%20xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:svg='http://www.w3.org/2000/svg'%3e%3csodipodi:namedview%20id='namedview1'%20pagecolor='%23ffffff'%20bordercolor='%23000000'%20borderopacity='0.25'%20inkscape:showpageshadow='2'%20inkscape:pageopacity='0.0'%20inkscape:pagecheckerboard='0'%20inkscape:deskcolor='%23d1d1d1'%20inkscape:document-units='mm'%20inkscape:zoom='12.310189'%20inkscape:cx='25.629176'%20inkscape:cy='22.095518'%20inkscape:window-width='1568'%20inkscape:window-height='1091'%20inkscape:window-x='1084'%20inkscape:window-y='318'%20inkscape:window-maximized='0'%20inkscape:current-layer='layer1'%20/%3e%3cdefs%20id='defs1'%20/%3e%3cg%20inkscape:label='Layer%201'%20inkscape:groupmode='layer'%20id='layer1'%3e%3cg%20id='g4'%20transform='matrix(2.0610545,0,0,2.0621418,-1290.7384,-517.766)'%3e%3cg%20style='fill:none'%20id='g2'%20transform='matrix(0.12786788,0,0,0.12786788,626.26875,251.04547)'%3e%3cpath%20opacity='0.3'%20d='m%2048,24.4541%20c%200,13.2548%20-10.7452,24%20-24,24%20-13.2548,0%20-24,-10.7452%20-24,-24%20C%200,11.1993%2010.7452,0.454102%2024,0.454102%20c%2013.2548,0%2024,10.745198%2024,23.999998%20z%20m%20-40.51639,0%20c%200,9.1218%207.39459,16.5164%2016.51639,16.5164%209.1218,0%2016.5164,-7.3946%2016.5164,-16.5164%20C%2040.5164,15.3323%2033.1218,7.93771%2024,7.93771%2014.8782,7.93771%207.48361,15.3323%207.48361,24.4541%20Z'%20fill='%23ffffff'%20id='path1-8'%20/%3e%3c/g%3e%3cg%20style='fill:none'%20id='g3'%20transform='matrix(0.12786788,0,0,0.12786788,629.34991,250.99928)'%3e%3cpath%20d='m%2020.2582,24.4541%20c%202.0665,0%203.7716,-1.6852%203.4507,-3.7267%20C%2023.4151,18.8582%2022.9006,17.0259%2022.1731,15.2697%2020.967,12.3579%2019.1992,9.71214%2016.9706,7.48354%2014.742,5.25493%2012.0962,3.48711%209.1844,2.28099%207.42818,1.55354%205.59591,1.03902%203.72669,0.745204%201.68521,0.424313%20-1.90735e-6,2.12936%200,4.1959%20c%200,2.06655%201.69616,3.69967%203.7099,4.16386%200.88977,0.2051%201.76308,0.48411%202.61065,0.83518%202.00386,0.83006%203.82465,2.04666%205.35835,3.58026%201.5336,1.5337%202.7502,3.3545%203.5803,5.3584%200.351,0.8475%200.63,1.7208%200.8351,2.6106%200.4642,2.0137%202.0974,3.7099%204.1639,3.7099%20z'%20fill='%23ffffff'%20id='path1-83'%20/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e", IDBack = "data:image/svg+xml,%3csvg%20width='34'%20height='50'%20viewBox='0%200%2034%2050'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M34%202C34%200.89543%2033.1046%20-3.91396e-08%2032%20-8.74219e-08L2%20-1.39876e-06C0.895432%20-1.44705e-06%20-3.91405e-08%200.895429%20-8.74228e-08%202L-2.09815e-06%2048C-2.14643e-06%2049.1046%200.895429%2050%202%2050L32%2050C33.1046%2050%2034%2049.1046%2034%2048L34%202ZM32%2047C32%2047.5523%2031.5523%2048%2031%2048L3%2048C2.44771%2048%202%2047.5523%202%2047L2%203C2%202.44771%202.44772%202%203%202L31%202C31.5523%202%2032%202.44772%2032%203L32%2047ZM29%205L29%209L23%209L23%205L29%205ZM29%2011L29%2013L23%2013L23%2011L29%2011ZM29%2015L29%2019L23%2019L23%2015L29%2015ZM29%2039L29%2035L23%2035L23%2039L29%2039ZM29%2034L29%2022L23%2022L23%2034L29%2034ZM29%2040L29%2045L23%2045L23%2040L29%2040ZM29%2021L29%2020L23%2020L23%2021L29%2021ZM6%205C6.55228%205%207%205.44772%207%206L7%2023.5C7%2024.0523%206.55228%2024.5%206%2024.5C5.44771%2024.5%205%2024.0523%205%2023.5L5%206C5%205.44771%205.44771%205%206%205Z'%20fill='white'/%3e%3c/svg%3e", IDFront = "data:image/svg+xml,%3csvg%20width='34'%20height='50'%20viewBox='0%200%2034%2050'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M32%20-0.00097665C33.1046%20-0.000976602%2034%200.894454%2034%201.99902L34%2047.999C34%2049.1036%2033.1046%2049.999%2032%2049.999L1.99999%2049.999C0.895425%2049.999%20-6.19955e-06%2049.1036%20-6.15126e-06%2047.999L-4.14054e-06%201.99902C-4.09226e-06%200.894453%200.895428%20-0.00097801%202%20-0.000977961L32%20-0.00097665ZM31%2047.999C31.5523%2047.999%2032%2047.5513%2032%2046.999L32%202.99902C32%202.44674%2031.5523%201.99902%2031%201.99902L3%201.99902C2.44771%201.99902%202%202.44674%202%202.99902L1.99999%2046.999C1.99999%2047.5513%202.44771%2047.999%202.99999%2047.999L31%2047.999ZM27%2025.0184C27%2024.4554%2026.5523%2023.999%2026%2023.999C25.4477%2023.999%2025%2024.4554%2025%2025.0184L25%2042.9796C25%2043.5426%2025.4477%2043.999%2026%2043.999C26.5523%2043.999%2027%2043.5426%2027%2042.9796L27%2025.0184ZM23%2025.043C23%2024.4771%2022.5523%2024.0183%2022%2024.0183C21.4477%2024.0183%2021%2024.4771%2021%2025.043L21%2038.9936C21%2039.5595%2021.4477%2040.0183%2022%2040.0183C22.5523%2040.0183%2023%2039.5595%2023%2038.9936L23%2025.043ZM18%2024.0183C18.5523%2024.0183%2019%2024.4771%2019%2025.043L19%2034.9936C19%2035.5595%2018.5523%2036.0183%2018%2036.0183C17.4477%2036.0183%2017%2035.5595%2017%2034.9936L17%2025.043C17%2024.4771%2017.4477%2024.0183%2018%2024.0183ZM15%2025.043C15%2024.4771%2014.5523%2024.0183%2014%2024.0183C13.4477%2024.0183%2013%2024.4771%2013%2025.043L13%2034.9936C13%2035.5595%2013.4477%2036.0183%2014%2036.0183C14.5523%2036.0183%2015%2035.5595%2015%2034.9936L15%2025.043ZM7%206.99902C7.55228%206.99902%208%207.4578%208%208.02372L8%2017.9743C8%2018.5402%207.55228%2018.999%207%2018.999C6.44771%2018.999%206%2018.5402%206%2017.9743L6%208.02372C6%207.4578%206.44771%206.99902%207%206.99902ZM23%2012.999C23%2011.8945%2022.1046%2010.999%2021%2010.999C19.8954%2010.999%2019%2011.8945%2019%2012.999C19%2014.1036%2019.8954%2014.999%2021%2014.999C22.1046%2014.999%2023%2014.1036%2023%2012.999ZM21%208.99902C23.2091%208.99902%2025%2010.7899%2025%2012.999C25%2015.2082%2023.2091%2016.999%2021%2016.999C19.5805%2016.999%2018.3336%2016.2596%2017.6237%2015.1448C17.4135%2015.7246%2017.118%2016.2725%2016.7438%2016.7682C15.9295%2017.8472%2014.7888%2018.618%2013.5009%2018.9595C13.3318%2019.0044%2013.1618%2019.0099%2013%2018.9817L13%2018.999L27%2018.999L27%206.99902L13.1998%206.99902C13.2991%206.99906%2013.4%207.01182%2013.5005%207.03849C14.7884%207.37998%2015.9291%208.1507%2016.7436%209.22957C17.1178%209.72537%2017.4134%2010.2733%2017.6237%2010.8532C18.3336%209.73849%2019.5804%208.99902%2021%208.99902ZM13.199%206.99902L13%206.99902L13%207.01627C13.0652%207.00492%2013.1317%206.99905%2013.199%206.99902ZM13%2016.5479C13.7319%2016.3306%2014.3787%2015.8804%2014.8462%2015.261C15.3349%2014.6135%2015.6001%2013.8178%2015.6001%2012.9989C15.6001%2012.1801%2015.3348%2011.3844%2014.8461%2010.737C14.3785%2010.1176%2013.7318%209.6675%2013%209.45022L13%2016.5479ZM28%204.99902C28.5523%204.99902%2029%205.44674%2029%205.99902L29%2019.999C29%2020.5513%2028.5523%2020.999%2028%2020.999L12%2020.999C11.4477%2020.999%2011%2020.5513%2011%2019.999L11%205.99902C11%205.44674%2011.4477%204.99902%2012%204.99902L28%204.99902Z'%20fill='white'/%3e%3c/svg%3e", IdMaskContainer = qe.div`
  height: 100%;
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  top: 0;
  align-items: center;
  padding-top: 65px;

  .label-container {
    position: absolute;
    max-width: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 50%;
    background-color: #00000080;
    aspect-ratio: 1/1;
    border-radius: 25px;
    img {
      z-index: 999999999;
      width: 50px;
      height: 50px;
      object-fit: contain;
      margin-top: 20px;
    }
  }
`, CaptureIdMask = qe.div`
  z-index: 5;
  width: 75vw;
  border-radius: 9px;
  border: solid 6.9px;
  aspect-ratio: 2.125/3.375;
  @supports not (aspect-ratio: 16 / 9) {
    padding-bottom: calc((3.375 * 75vw) / 2.125);
  }
  border-color: ${(me) => me.isCapturing ? "#ffffff" : me.isSuccess ? "#0cd5a2" : me.isError ? "#ff5c6f" : "#fff"};
  ${(me) => me.isCapturing && "border-style: dashed;"}
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.8);
`, SpinImage = qe.img`
  @keyframes spinner {
    to {
      transform: rotate(360deg);
    }
  }
  margin-bottom: 10px;
  width: 64px;
  height: 64px;
  animation: spinner 1s linear infinite;
  &.inverted {
    filter: invert(1);
    margin-top: 25px;
  }
`, Text$4 = qe.p`
  z-index: 5;
  font-size: 1.125rem;
  font-weight: bold;
  text-align: center;
  padding: 0 25px;
  color: ${(me) => me.isCapturing ? "#ffffff" : me.isSuccess ? "#0CD5A2" : me.isError ? "#ffffff  " : "#ffffff"};
  z-index: 6;
`, imageMap = {
  isError: { imageSrc: FailVS, imageKey: "IncodeIDVSInstructionsFail" },
  isSuccess: { imageSrc: SuccessVS, imageKey: "IncodeIDVSInstructionsSuccess" },
  front: { imageSrc: IDFront, imageKey: "IncodeIDVSInstructionsFront" },
  back: { imageSrc: IDBack, imageKey: "IncodeIDVSInstructionsBack" },
  default: { imageSrc: FailVS, imageKey: "IncodeIDVSInstructionsFail" }
};
function imageToShow(me, ue, Qe) {
  return ue ? imageMap.isError : Qe ? imageMap.isSuccess : imageMap[me] || imageMap.default;
}
function ImageAndText({
  mode: me,
  isCapturing: ue,
  isError: Qe,
  message: Ue,
  isSuccess: He
}) {
  const { t: Ge } = useTranslation(), Xe = Ge("videoSelfie.processingSelfie"), Ke = Ge(me === "front" ? "videoSelfie.showFront" : "videoSelfie.showBack"), { imageSrc: $e, imageKey: Je } = imageToShow(me, Qe, He);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "label-container", children: [
    !ue && /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: $e, alt: me, className: Je }, Je),
    ue && /* @__PURE__ */ jsxRuntimeExports.jsx(SpinImage, { src: Spinner$1 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Text$4,
      {
        role: "region",
        "aria-live": "polite",
        isCapturing: ue,
        isError: Qe,
        isSuccess: He,
        className: "id IncodeRecorderIdMaskText",
        children: Qe || He ? Ue : ue ? Xe : Ke
      }
    )
  ] });
}
function IdMask({
  isCapturing: me,
  isError: ue,
  isSuccess: Qe,
  mode: Ue,
  message: He
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(IdMaskContainer, { className: "IncodeRecorderIdMaskContainer", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ImageAndText,
      {
        isCapturing: me,
        isError: ue,
        isSuccess: Qe,
        mode: Ue,
        message: He
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CaptureIdMask,
      {
        className: "IncodeRecorderCaptureIdMask",
        isError: ue,
        isSuccess: Qe,
        isCapturing: me
      }
    )
  ] });
}
function addCapturingEvents({
  currentMode: me,
  session: ue
}) {
  addScreenEvent({
    module: eventModuleNames.videoSelfie,
    screen: me === "front" ? eventScreenNames.videoSelfieFrontIdCapture : eventScreenNames.videoSelfieBackIdCapture,
    token: ue.token,
    shouldOpen: !1
  }), addScreenEvent({
    module: eventModuleNames.videoSelfie,
    screen: me === "front" ? eventScreenNames.videoSelfieFrontIdUploadProgress : eventScreenNames.videoSelfieBackIdUploadProgress,
    token: ue.token,
    shouldOpen: !0
  });
}
async function backCapture({
  image: me,
  session: ue,
  shouldCompareOCR: Qe,
  shouldCompareID: Ue,
  t: He
}) {
  if (!Qe && !Ue) {
    await sleep(3e3);
    return;
  }
  try {
    const Ge = [];
    if (Ue) {
      const Xe = compareBackID({
        token: ue.token,
        image: me
      }).then((Ke) => {
        if (!Ke.idTypeMatched || !Ke.idSideMatched || Ke.success === !1)
          throw new Error(He("notifications.compareID.scanFailed"));
      }).catch(() => {
        throw new Error(He("notifications.compareID.scanFailed"));
      });
      Ge.push(Xe);
    }
    if (Qe) {
      const Xe = compareBackOCR({
        token: ue.token,
        image: me
      }).then((Ke) => {
        if (!Ke.success)
          throw new Error(He("notifications.compareID.scanFailed"));
      }).catch(() => {
        throw new Error(He("notifications.compareID.ocrFailed"));
      });
      Ge.push(Xe);
    }
    await Promise.all(Ge);
  } catch (Ge) {
    throw addScreenEvent({
      module: eventModuleNames.videoSelfie,
      screen: eventScreenNames.videoSelfieBackIdUploadProgress,
      token: ue.token,
      shouldOpen: !1
    }), addScreenEvent({
      module: eventModuleNames.videoSelfie,
      screen: eventScreenNames.videoSelfieBackIdAttemptFailed,
      token: ue.token,
      shouldOpen: !0
    }), Ge;
  }
}
async function frontCapture({
  image: me,
  session: ue,
  shouldCompareOCR: Qe,
  shouldCompareID: Ue,
  t: He
}) {
  if (!Qe && !Ue) {
    await sleep(3e3);
    return;
  }
  try {
    const Ge = [];
    if (Ue) {
      const Xe = compareID({
        token: ue.token,
        image: me
      }).then((Ke) => {
        if (!Ke.idTypeMatched)
          throw new Error(He("notifications.compareID.scanFailed"));
        if (Ke.faceRecognitionConfidence !== 1)
          throw new Error(
            He("notifications.compareID.photoVerificationFailed")
          );
      }).catch(() => {
        throw new Error(He("notifications.compareID.scanFailed"));
      });
      Ge.push(Xe);
    }
    if (Qe) {
      const Xe = compareOCR({
        token: ue.token,
        image: me
      }).then((Ke) => {
        if (!Ke.success)
          throw new Error(
            He("notifications.compareID.nameVerificationFailed")
          );
      }).catch(() => {
        throw new Error(He("notifications.compareID.ocrFailed"));
      });
      Ge.push(Xe);
    }
    await Promise.all(Ge), addScreenEvent({
      module: eventModuleNames.videoSelfie,
      screen: eventScreenNames.videoSelfieFrontIdUploadProgress,
      token: ue.token,
      shouldOpen: !1
    }), addScreenEvent({
      module: eventModuleNames.videoSelfie,
      screen: eventScreenNames.videoSelfieFrontIdUploadSucceeded,
      token: ue.token,
      shouldOpen: !0
    });
  } catch (Ge) {
    throw addScreenEvent({
      module: eventModuleNames.videoSelfie,
      screen: eventScreenNames.videoSelfieFrontIdUploadProgress,
      token: ue.token,
      shouldOpen: !1
    }), addScreenEvent({
      module: eventModuleNames.videoSelfie,
      screen: eventScreenNames.videoSelfieFrontIdAttemptFailed,
      token: ue.token,
      shouldOpen: !0
    }), Ge;
  }
}
const videoSelfieMode = {
  selfie: "selfie",
  captureId: "captureId"
}, captureIdEventsCount = {
  imageTooBlurry: { count: 0 },
  fillFrame: { count: 0 },
  checkCameraOrLighting: { count: 0 },
  frontIdCaptureStarted: { count: 0 },
  lookAtCamera: { count: 0 },
  moveCloser: { count: 0 }
}, logVideoSelfieEvent = ({
  event: me,
  type: ue,
  mode: Qe,
  session: Ue
}) => {
  if (captureIdEventsCount[me] && captureIdEventsCount[me].count === 0) {
    const He = Qe === "front" ? eventScreenNames.videoSelfieFrontIdCapture : eventScreenNames.videoSelfieBackIdCapture, Ge = ue === videoSelfieMode.selfie ? eventScreenNames.videoSelfieFaceCapture : He;
    captureIdEventsCount[me].count++, screenEvent({
      module: eventModuleNames.videoSelfie,
      token: Ue.token,
      code: me,
      screen: Ge
    });
  }
};
class IdDetectorBase {
  constructor() {
    this.pipelineProfile = null, this.currentCanvas = null;
  }
  async initialize({
    onCapturing: ue,
    onFarAway: Qe,
    onGlare: Ue,
    onBlur: He,
    onIDNotDetected: Ge,
    onMaskChange: Xe,
    onDetectionStarted: Ke,
    onSwitchToManualCapture: $e,
    onIDTypeChange: Je,
    onIDSideChange: Ze,
    idType: nt,
    isFixedMask: tt,
    isBlurCheckEnabled: et,
    isGlareCheckEnabled: rt,
    pipelineProfile: it,
    autocaptureTimeout: ot = -1
  }) {
    this.pipelineProfile = it;
    const at = this.pipelineProfile.pipelineType;
    this.pipelineProfile.reconfigureParams(mobile.isDesktop()), await MlWasmJSApi$1.setIdCaptureCallbacks(
      at,
      Qe,
      Ke,
      Xe,
      He,
      Ue,
      this.getOnCapturing(ue),
      Ge,
      $e,
      Je,
      Ze
    ), await MlWasmJSApi$1.setIdCaptureThresholds(
      at,
      it.parameters.sharpnessThreshold,
      it.parameters.sharpnessChangeThreshold,
      it.parameters.glareThreshold,
      it.parameters.classificationThreshold,
      ot
    ), await MlWasmJSApi$1.setIdCaptureConfigParams(
      at,
      tt,
      localStorage.getItem("isIPhone14OrHigher") === "true",
      nt,
      et,
      rt
    ), await MlWasmJSApi$1.setIdCaptureGeometryParams(
      at,
      it.parameters.areaDown,
      it.parameters.areaUp,
      it.parameters.areaIOSPassportUp,
      it.parameters.areaIOSPassportDown,
      it.parameters.widthIOSUp,
      it.parameters.widthIOSDown,
      it.parameters.widthDown,
      it.parameters.widthUp,
      window.outerWidth,
      window.outerHeight,
      window.innerWidth,
      window.innerHeight
    );
  }
  async detectCommon(ue, Qe) {
    try {
      this.currentCanvas = ue;
      const Ue = ue.getImageData();
      await MlWasmJSApi$1.allocateImageBuffers(Ue.width, Ue.height), await MlWasmJSApi$1.process(Ue, Qe), this.currentCanvas.release();
    } catch (Ue) {
      console.error(`Exception: ${Ue}`);
    }
  }
}
class IdCapture extends IdDetectorBase {
  getOnCapturing(ue) {
    return (Qe, Ue) => {
      const He = this.currentCanvas.clone();
      He.updateBase64Image(), He.updateBlob(), ue(He, {
        sharpness: Qe,
        glare: Ue
      });
    };
  }
  async detect(ue) {
    this.detectCommon(ue, WasmPipelineType.IdCapturePipeline);
  }
}
class IdVideoSelfie extends IdDetectorBase {
  getOnCapturing(ue) {
    return () => {
      ue(this.currentMode);
    };
  }
  async detect(ue) {
    this.detectCommon(ue, WasmPipelineType.IdVideoSelfiePipeline);
  }
  updateCurrentMode(ue) {
    this.currentMode = ue;
  }
}
const WAIT_FOR_MESSAGE = 3e3, useDetectId = ({
  webcam: me,
  mode: ue,
  numberOfTries: Qe
}, Ue) => {
  const He = useRef(null), [Ge, Xe] = useState("idle"), [Ke, $e] = useState(""), Je = useRef(!0), Ze = useRef(!1), nt = useRef(1), { t: tt } = useTranslation(), et = async (it) => {
    Je.current = !1, Xe("capturing");
    const ot = me.getCanvas().getBase64Image();
    MlWasmJSApi$1.resetAllPipelines();
    try {
      await Ue.onCapturing({ currentMode: it, image: ot }), Xe("success"), $e(tt("videoSelfie.allGood")), await sleep(WAIT_FOR_MESSAGE), Ue.onSuccessfulCapture();
    } catch (at) {
      if ($e(at.message), Xe("error"), await sleep(WAIT_FOR_MESSAGE), nt.current === Qe) {
        await Ue.onNoAttemptsLeft(at.message);
        return;
      }
      Xe("idle"), Je.current = !0, $e(""), nt.current += 1;
    }
  };
  async function rt() {
    He.current = new IdVideoSelfie(), await He.current.initialize({
      onCapturing: throttle$1(et, 1e3),
      onGlare: Ue.onGlare,
      onBlur: Ue.onBlur,
      onFarAway: Ue.onFarAway,
      onIDNotDetected: emptyFunc,
      onMaskChange: emptyFunc,
      onDetectionStarted: emptyFunc,
      onSwitchToManualCapture: emptyFunc,
      onIDTypeChange: emptyFunc,
      idType: "null",
      isFixedMask: !1,
      isBlurCheckEnabled: !1,
      isGlareCheckEnabled: !1,
      pipelineProfile: detectionSetup.getProfile(DetectionType.IdVideoSelfie),
      autocaptureTimeout: -1
    });
  }
  return useEffect(() => {
    const it = async () => {
      if (!(!Je.current || Ze.current)) {
        Ze.current = !0, He.current || await rt();
        try {
          await MlWasmJSApi$1.handleDetectionCallAndUpdateState(
            detectionSetup.getProfile(DetectionType.IdVideoSelfie).pipelineType
          ), He.current.updateCurrentMode(ue);
          const ot = me.getCanvas();
          await He.current.detect(ot);
        } catch (ot) {
          console.error(ot);
        } finally {
          Ze.current = !1;
        }
      }
    };
    return onFrameEmitter.on("newFrame", it), () => {
      onFrameEmitter.off("newFrame", it);
    };
  }, [me, ue]), { status: Ge, message: Ke };
}, VideoSelfieIdCapture = ({
  webcam: me,
  onSuccessfulCapture: ue,
  mode: Qe,
  onError: Ue,
  session: He,
  config: { shouldCompareOCR: Ge, shouldCompareID: Xe, numberOfTries: Ke }
}) => {
  const { t: $e } = useTranslation(), { status: Je, message: Ze } = useDetectId(
    { webcam: me, mode: Qe, numberOfTries: Ke },
    {
      onCapturing: async ({ image: rt }) => {
        addCapturingEvents({ currentMode: Qe, session: He }), Qe === "front" ? await frontCapture({
          image: rt,
          session: He,
          shouldCompareID: Xe,
          shouldCompareOCR: Ge,
          t: $e
        }) : await backCapture({
          image: rt,
          session: He,
          shouldCompareID: Xe,
          shouldCompareOCR: Ge,
          t: $e
        });
      },
      onSuccessfulCapture: ue,
      onFarAway: () => {
        logVideoSelfieEvent({
          event: videoSelfieEvents.fillFrame,
          type: "captureId",
          session: He,
          mode: Qe
        });
      },
      onGlare: () => {
        logVideoSelfieEvent({
          event: videoSelfieEvents.checkCameraOrLighting,
          type: "captureId",
          session: He,
          mode: Qe
        });
      },
      onBlur: () => {
        logVideoSelfieEvent({
          event: videoSelfieEvents.imageTooBlurry,
          type: "captureId",
          session: He,
          mode: Qe
        });
      },
      onNoAttemptsLeft: async (rt) => {
        Ue(rt);
      }
    }
  ), nt = Je === "capturing", tt = Je === "error", et = Je === "success";
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    IdMask,
    {
      isCapturing: nt,
      isError: tt,
      isSuccess: et,
      mode: Qe,
      message: Ze
    }
  );
}, spinner = "data:image/svg+xml,%3csvg%20width='65'%20height='64'%20viewBox='0%200%2065%2064'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20opacity='0.3'%20d='M56.5%2032.4541C56.5%2045.7089%2045.7548%2056.4541%2032.5%2056.4541C19.2452%2056.4541%208.5%2045.7089%208.5%2032.4541C8.5%2019.1993%2019.2452%208.4541%2032.5%208.4541C45.7548%208.4541%2056.5%2019.1993%2056.5%2032.4541ZM15.9836%2032.4541C15.9836%2041.5759%2023.3782%2048.9705%2032.5%2048.9705C41.6218%2048.9705%2049.0164%2041.5759%2049.0164%2032.4541C49.0164%2023.3323%2041.6218%2015.9377%2032.5%2015.9377C23.3782%2015.9377%2015.9836%2023.3323%2015.9836%2032.4541Z'%20fill='%2320263D'/%3e%3cpath%20d='M52.7582%2032.4541C54.8247%2032.4541%2056.5298%2030.7689%2056.2089%2028.7274C55.9151%2026.8582%2055.4006%2025.0259%2054.6731%2023.2697C53.467%2020.3579%2051.6992%2017.7121%2049.4706%2015.4835C47.242%2013.2549%2044.5962%2011.4871%2041.6844%2010.281C39.9282%209.55354%2038.0959%209.03902%2036.2267%208.7452C34.1852%208.42431%2032.5%2010.1294%2032.5%2012.1959C32.5%2014.2624%2034.1962%2015.8956%2036.2099%2016.3598C37.0997%2016.5649%2037.973%2016.8439%2038.8205%2017.1949C40.8244%2018.025%2042.6452%2019.2416%2044.1789%2020.7752C45.7125%2022.3089%2046.9291%2024.1297%2047.7592%2026.1336C48.1102%2026.9811%2048.3892%2027.8544%2048.5943%2028.7442C49.0585%2030.7579%2050.6917%2032.4541%2052.7582%2032.4541Z'%20fill='%2320263D'/%3e%3c/svg%3e", LoadingText = qe.p`
  font-size: 23px;
  font-weight: bold;
  text-align: center;
  color: #21273b;
`, ProcessingContainer$1 = qe.div`
  position: fixed;
  width: 100% !important;
  height: 100% !important;
  z-index: 10;
  opacity: 1;
  z-index: 2000;
  background: #fff;
  top: 0;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 0 25px;
  img {
    margin: 0;
  }
  h1 {
    font-size: 1.5rem;
  }
  p {
    font-size: 1.125rem;
    line-height: 1.625rem;
    margin-top: 0;
    color: #636670;
  }
`, Loading = ({ children: me }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  ProcessingContainer$1,
  {
    className: "IncodeRecorderProcessingContainer",
    "aria-live": "assertive",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(SpinImage, { src: spinner, alt: "spinner" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingText, { className: "IncodeRecorderProcessingContent", children: me })
    ]
  }
), Processing$1 = () => {
  const { t: me } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Loading, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: me("videoSelfie.processingSelfie") }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      me("videoSelfie.kindlyWait"),
      " "
    ] })
  ] }) });
}, Button$5 = qe.button`
  text-transform: lowercase;
`, ProofOfAddressMaskContainer = qe.div``, ProofOfAddressTopMask = qe.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 5;
  min-height: 115px;
  padding-top: 80px;
  padding-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;

  h1 {
    font-size: 1.5rem;
    line-height: 1.4;
    font-weight: bold;
    color: #fff;
    margin: 0;
    text-align: center;
  }
`, Blue = qe.span`
  color: #00b2fd;
`, ProofOfAddressBottomMask = qe.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 5;
  height: 68px;
  display: flex;
  justify-content: center;
  align-items: center;

  button {
    background: transparent;
    color: white;
    box-shadow: none;
    border: none;
    border-bottom: 2px solid #fff;
    font-size: 1.25rem;
    font-weight: bold;
    padding: 10px;
    text-transform: capitalize;
  }
`;
function ProofOfAddress({ onNext: me, token: ue }) {
  const { t: Qe } = useTranslation();
  return useScreenEvents({
    module: eventModuleNames.videoSelfie,
    screen: eventScreenNames.videoSelfieDocumentCapture,
    token: ue
  }), /* @__PURE__ */ jsxRuntimeExports.jsxs(
    ProofOfAddressMaskContainer,
    {
      className: "IncodeRecorderPOAMaskContainer",
      "aria-live": "assertive",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(ProofOfAddressTopMask, { className: "IncodeRecorderPOAMaskTop", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "h1",
          {
            className: "IncodeRecorderPOAMaskText",
            "aria-label": `${Qe("videoSelfie.showPoaOne")} ${Qe(
              "videoSelfie.showPoaTwo"
            )} ${Qe("videoSelfie.showPoaThree")}`,
            children: [
              Qe("videoSelfie.showPoaOne"),
              " ",
              /* @__PURE__ */ jsxRuntimeExports.jsx(Blue, { children: Qe("videoSelfie.showPoaTwo") }),
              " ",
              /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
              Qe("videoSelfie.showPoaThree")
            ]
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ProofOfAddressBottomMask, { className: "IncodeRecorderPOAMaskBottom", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button$5, { className: "IncodeRecorderPOAMaskButton", onClick: me, children: Qe("common.continue") }) })
      ]
    }
  );
}
function SoundWave() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "sound", style: { width: "48px", position: "relative" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: "wave",
        style: { width: "3px", background: "#fff", borderRadius: "3px" }
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: "wave",
        style: {
          width: "3px",
          background: "#fff",
          borderRadius: "3px",
          left: "8px"
        }
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: "wave",
        style: {
          width: "3px",
          background: "#fff",
          borderRadius: "3px",
          left: "16px"
        }
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: "wave",
        style: {
          width: "3px",
          background: "#fff",
          borderRadius: "3px",
          left: "24px"
        }
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: "wave",
        style: {
          width: "3px",
          background: "#fff",
          borderRadius: "3px",
          left: "32px"
        }
      }
    )
  ] });
}
const MicrophoneContainer = qe.div`
  z-index: 5;
  position: ${(me) => me.isQuestions ? "fixed" : "absolute"};
  top: 100px;
  display: flex;
  justify-content: center;
  transform: translate(-50%, 0%);
  left: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 70vw;
  height: 70vw;
  border-radius: 100%;
  transition: all 0.2s ease-out;
  opacity: ${(me) => me.recording ? 1 : 0};
  display: flex;
  color: #fff;
  font-size: 2.25rem;
  .sound {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    height: 50px;
    margin-bottom: 15px;
    .wave {
      background: #fff;
      border-radius: 3px;
      width: 3px;
      height: 12px;
      animation: sound 0.7s infinite;
      &:nth-child(1) {
        height: 36px;
        animation-delay: 0.2s;
      }
      &:nth-child(2) {
        height: 24px;
        animation-delay: 0.4s;
      }
      &:nth-child(3) {
        height: 12px;
        animation-delay: 0.6s;
      }
      &:nth-child(4) {
        height: 18px;
        animation-delay: 0.2s;
      }
      &:nth-child(5) {
        height: 18px;
        animation-delay: 0.7s;
      }
      @keyframes sound {
        0% {
          height: 12px;
        }
        50% {
          height: 36px;
        }
        100% {
          height: 12px;
        }
      }
    }
  }
`;
function Microphone({ sound: me, isQuestions: ue, recording: Qe }) {
  const [Ue, He] = useState(me), { t: Ge } = useTranslation();
  useEffect(() => {
    He(me);
  }, [me]);
  const Xe = Ue > 0.6;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    MicrophoneContainer,
    {
      className: "IncodeRecorderMicrophoneContainer",
      isQuestions: ue,
      recording: Qe,
      "aria-live": "assertive",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(SoundWave, { size: "big", active: Xe }),
        Ge("videoSelfie.recording")
      ]
    }
  );
}
const speechBuuble = "data:image/svg+xml,%3csvg%20width='33'%20height='32'%20viewBox='0%200%2033%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_5353_4515)'%3e%3cg%20clip-path='url(%23clip1_5353_4515)'%3e%3cpath%20d='M16.5%2017.5C17.3284%2017.5%2018%2016.8284%2018%2016C18%2015.1716%2017.3284%2014.5%2016.5%2014.5C15.6716%2014.5%2015%2015.1716%2015%2016C15%2016.8284%2015.6716%2017.5%2016.5%2017.5Z'%20fill='%2320263D'/%3e%3cpath%20d='M11%2017.5C11.8284%2017.5%2012.5%2016.8284%2012.5%2016C12.5%2015.1716%2011.8284%2014.5%2011%2014.5C10.1716%2014.5%209.5%2015.1716%209.5%2016C9.5%2016.8284%2010.1716%2017.5%2011%2017.5Z'%20fill='%2320263D'/%3e%3cpath%20d='M22%2017.5C22.8284%2017.5%2023.5%2016.8284%2023.5%2016C23.5%2015.1716%2022.8284%2014.5%2022%2014.5C21.1716%2014.5%2020.5%2015.1716%2020.5%2016C20.5%2016.8284%2021.1716%2017.5%2022%2017.5Z'%20fill='%2320263D'/%3e%3cpath%20d='M10.4911%2026.3889C13.0118%2027.8478%2015.9769%2028.3401%2018.8338%2027.7742C21.6907%2027.2083%2024.2443%2025.6227%2026.0184%2023.3131C27.7926%2021.0035%2028.6663%2018.1275%2028.4766%2015.2213C28.2869%2012.3151%2027.0467%209.57703%2024.9873%207.51766C22.928%205.45829%2020.1899%204.21814%2017.2837%204.02843C14.3775%203.83872%2011.5015%204.71239%209.19189%206.48656C6.88228%208.26073%205.2967%2010.8143%204.73078%2013.6712C4.16486%2016.5281%204.65723%2019.4932%206.11609%2022.0139L4.55234%2026.6827C4.49358%2026.8589%204.48505%2027.0479%204.52771%2027.2287C4.57037%2027.4095%204.66254%2027.5748%204.79387%2027.7061C4.92521%2027.8375%205.09052%2027.9296%205.27129%2027.9723C5.45206%2028.0149%205.64114%2028.0064%205.81734%2027.9477L10.4911%2026.3889Z'%20stroke='%2320263D'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_5353_4515'%3e%3crect%20width='32'%20height='32'%20fill='white'%20transform='translate(0.5)'/%3e%3c/clipPath%3e%3cclipPath%20id='clip1_5353_4515'%3e%3crect%20width='32'%20height='32'%20fill='white'%20transform='translate(0.5)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", QuestionMaskContainer = qe.div`
  position: fixed;
  background: #fff;
  left: 10px;
  right: 0;
  bottom: 10px;
  border-radius: 25px;
  z-index: 5;
  display: flex;
  height: auto;
  justify-content: space-between;
  gap: 10px;
  padding: 15px;
  flex-direction: column;
  align-items: center;
  overflow: auto;
  color: #000;
  width: calc(100% - 20px);
  box-shadow: 0px 0px 0px 1000px rgba(0, 0, 0, 0.4);
  border: ${(me) => me.recording ? "5px solid #00b2fd" : "none"};
  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }
  h1,
  span {
    font-size: 1.125rem !important;
    color: #636670;
    margin-bottom: 0;
  }
  p {
    font-size: 1.5rem;
    line-height: 1.9rem;
    font-weight: bold;
    text-align: center;
    color: #000;
    text-align: center;
    width: 100%;
    padding: 0 30px;
  }

  button {
    width: 100%;
    padding: 20px;
    white-space: nowrap;
  }
  &.speech {
    p {
      margin-top: 0;
    }
  }
`, QuestionsContainer = ({
  token: me,
  onNext: ue,
  sound: Qe,
  questionsCount: Ue
}) => {
  const [He, Ge] = useState([]), [Xe, Ke] = useState("home");
  return useEffect(() => {
    async function $e() {
      const { questionAndAnswers: Je } = await getRandomQuestions({
        token: me,
        numberOfQuestions: Number(Ue)
      });
      Ge(Je || []);
    }
    $e();
  }, [me]), Xe === "home" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    QuestionsMask,
    {
      onNext: () => Ke("questions"),
      plural: He.length > 1
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    Questions,
    {
      questions: He,
      onNext: ue,
      sound: Qe,
      addEvent: ($e) => addEvent({ token: me, ...$e }),
      token: me
    }
  );
};
function QuestionsMask({ onNext: me, plural: ue }) {
  const { t: Qe } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    QuestionMaskContainer,
    {
      className: "IncodeRecorderQuestionMaskContainer",
      recording: !1,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: Qe("videoSelfie.answerOutLoud") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "IncodeRecorderQuestionMaskTitle", "aria-live": "assertive", children: Qe(ue ? "videoSelfie.weNeedVerbalAnswersPlural" : "videoSelfie.weNeedVerbalAnswer") })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Button$a, { className: "IncodeRecorderQuestionMaskButton", onClick: me, children: Qe("videoSelfie.readyAnswer") })
      ]
    }
  );
}
const Question$1 = qe.p`
  color: #000 !important;
  font-size: 1.4rem !important;
  font-weight: bold;
  text-align: center;
  line-height: normal;
  margin-top: 10px;
  margin-bottom: 10px;

  @media only screen and (max-height: 500px) {
    font-size: 1.56rem !important;
  }
`;
qe.p`
  font-size: 1.06rem;
  font-weight: bold;
  color: #000;
  text-align: center;

  @media only screen and (max-height: 550px) {
    font-size: 0.75rem;
  }
`;
const QuestionButton = qe.button`
  font-size: 1.125rem;
  font-weight: bold;
  color: #fff;
  border: none;
  background-color: #007aff;
  border-radius: 31px;
  max-width: 375px;
  width: 100%;
  display: flex;
  align-items: center;
  flex-grow: 0;
  justify-content: center;
  img {
    margin-right: 10px;
  }
  &.inverted {
    padding: 12px 20px;
    background-color: transparent;
    color: #000;
    border: 1px solid #000;
  }
`, BottomContainer = qe.div`
  text-align: center;
  margin-bottom: 15px;
  width: 100%;
`, QuestionStepper = qe.div`
  display: flex;
  position: fixed;
  top: 50px;
  z-index: 10;
  width: 100%;
  padding: 0 20px;
`, QuestionStep = qe.div`
  height: 4px;
  border-radius: 2px;
  background-color: #fff;
  flex: 1;
  margin-right: 10px;

  &::last-child {
    margin-right: 0px;
  }

  &.active {
    background-color: #00b2fd;
  }
`;
function Questions({ questions: me, onNext: ue, sound: Qe, addEvent: Ue, token: He }) {
  const { t: Ge } = useTranslation(), [Xe, Ke] = useState(0), [$e, Je] = useState(!0), Ze = useRef(null), nt = useRef(null);
  useEffect(() => {
    addScreenEvent({
      module: eventModuleNames.videoSelfie,
      screen: `${eventScreenNames.videoSelfieVoiceQuestion}_1`,
      token: He,
      shouldOpen: !0
    });
  }, []), useEffect(() => {
    !$e && nt.current && nt.current.focus(), $e && Ze.current && Ze.current.focus();
  }, [$e]);
  function tt() {
    const rt = Xe + 1;
    if (addScreenEvent({
      module: eventModuleNames.videoSelfie,
      screen: `${eventScreenNames.videoSelfieVoiceQuestion}_${rt}`,
      token: He,
      shouldOpen: !1
    }), Ue({
      code: `videoSelfieQuestion${Xe + 1}Answered`,
      payload: { question: me[Xe] }
    }), rt >= me.length) {
      ue();
      return;
    }
    addScreenEvent({
      module: eventModuleNames.videoSelfie,
      screen: `${eventScreenNames.videoSelfieVoiceQuestion}_${rt + 1}`,
      token: He,
      shouldOpen: !0
    }), screenEvent({
      module: eventModuleNames.videoSelfie,
      code: videoSelfieEvents.audioStreamClosed,
      payload: { question: me[Xe] },
      token: He.token
    }), Ke(rt), Je(!0);
  }
  function et() {
    screenEvent({
      module: eventModuleNames.videoSelfie,
      code: videoSelfieEvents.audioStreamOpened,
      payload: { question: me[Xe] },
      token: He.token
    }), Je(!1);
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(QuestionMaskContainer, { recording: !$e, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: Ge("videoSelfie.answerOutLoud") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(QuestionStepper, { children: me.map(({ id: rt }, it) => /* @__PURE__ */ jsxRuntimeExports.jsx(
        QuestionStep,
        {
          className: classNames({ active: Xe >= it })
        },
        rt
      )) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Steps, { currentStep: Xe, children: me.map(({ id: rt, question: it }) => /* @__PURE__ */ jsxRuntimeExports.jsx(Question$1, { "aria-live": "assertive", children: it }, rt)) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(BottomContainer, { children: $e ? /* @__PURE__ */ jsxRuntimeExports.jsxs(
      QuestionButton,
      {
        ref: Ze,
        className: "inverted",
        onClick: et,
        "aria-live": "polite",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: speechBuuble, alt: "speech bubble" }),
          Ge("common.tapToAnswer")
        ]
      }
    ) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Microphone,
        {
          sound: Qe,
          isQuestions: !0,
          recording: !$e
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        QuestionButton,
        {
          ref: nt,
          onClick: tt,
          "aria-live": "polite",
          children: Ge("common.tapWhenDone")
        }
      )
    ] }) })
  ] });
}
var dist = {}, OTSession$1 = {}, createSession$2 = {};
Object.defineProperty(createSession$2, "__esModule", {
  value: !0
});
createSession$2.default = createSession$1;
function createSession$1() {
  var me = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ue = me.apiKey, Qe = me.sessionId, Ue = me.token, He = me.onStreamsUpdated, Ge = me.onConnect, Xe = me.onError, Ke = me.options;
  if (!ue)
    throw new Error("Missing apiKey");
  if (!Qe)
    throw new Error("Missing sessionId");
  if (!Ue)
    throw new Error("Missing token");
  var $e = [], Je = function(rt) {
    var it = $e.findIndex(function(ot) {
      return ot.id === rt.stream.id;
    });
    it < 0 && ($e.push(rt.stream), He($e));
  }, Ze = function(rt) {
    var it = $e.findIndex(function(ot) {
      return ot.id === rt.stream.id;
    });
    it >= 0 && ($e.splice(it, 1), He($e));
  }, nt = {
    streamCreated: Je,
    streamDestroyed: Ze
  }, tt = OT.initSession(ue, Qe, Ke);
  return tt.on(nt), tt.connect(Ue, function(et) {
    tt && (et && typeof Xe == "function" ? Xe(et) : !et && typeof Ge == "function" && Ge());
  }), {
    session: tt,
    streams: $e,
    disconnect: function() {
      tt && (tt.off(nt), tt.disconnect()), $e = null, Je = null, Ze = null, nt = null, tt = null, this.session = null, this.streams = null;
    }
  };
}
Object.defineProperty(OTSession$1, "__esModule", {
  value: !0
});
var _typeof$2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(me) {
  return typeof me;
} : function(me) {
  return me && typeof Symbol == "function" && me.constructor === Symbol && me !== Symbol.prototype ? "symbol" : typeof me;
}, _createClass$4 = /* @__PURE__ */ function() {
  function me(ue, Qe) {
    for (var Ue = 0; Ue < Qe.length; Ue++) {
      var He = Qe[Ue];
      He.enumerable = He.enumerable || !1, He.configurable = !0, "value" in He && (He.writable = !0), Object.defineProperty(ue, He.key, He);
    }
  }
  return function(ue, Qe, Ue) {
    return Qe && me(ue.prototype, Qe), Ue && me(ue, Ue), ue;
  };
}(), _react$7 = React__default, _react2$7 = _interopRequireDefault$8(_react$7), _propTypes$7 = propTypesExports, _propTypes2$7 = _interopRequireDefault$8(_propTypes$7), _createSession2$1 = createSession$2, _createSession3 = _interopRequireDefault$8(_createSession2$1);
function _interopRequireDefault$8(me) {
  return me && me.__esModule ? me : { default: me };
}
function _classCallCheck$4(me, ue) {
  if (!(me instanceof ue))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$4(me, ue) {
  if (!me)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return ue && (typeof ue == "object" || typeof ue == "function") ? ue : me;
}
function _inherits$4(me, ue) {
  if (typeof ue != "function" && ue !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof ue);
  me.prototype = Object.create(ue && ue.prototype, { constructor: { value: me, enumerable: !1, writable: !0, configurable: !0 } }), ue && (Object.setPrototypeOf ? Object.setPrototypeOf(me, ue) : me.__proto__ = ue);
}
var OTSession = function(me) {
  _inherits$4(ue, me);
  function ue(Qe) {
    _classCallCheck$4(this, ue);
    var Ue = _possibleConstructorReturn$4(this, (ue.__proto__ || Object.getPrototypeOf(ue)).call(this, Qe));
    return Ue.state = {
      streams: []
    }, Ue;
  }
  return _createClass$4(ue, [{
    key: "getChildContext",
    value: function() {
      return { session: this.sessionHelper.session, streams: this.state.streams };
    }
  }, {
    key: "componentWillMount",
    value: function() {
      this.createSession();
    }
  }, {
    key: "componentDidUpdate",
    value: function(Ue) {
      (Ue.apiKey !== this.props.apiKey || Ue.sessionId !== this.props.sessionId || Ue.token !== this.props.token) && this.createSession();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.destroySession();
    }
  }, {
    key: "createSession",
    value: function() {
      var Ue = this;
      this.destroySession(), this.sessionHelper = (0, _createSession3.default)({
        apiKey: this.props.apiKey,
        sessionId: this.props.sessionId,
        token: this.props.token,
        onStreamsUpdated: function(Xe) {
          Ue.setState({ streams: Xe });
        },
        onConnect: this.props.onConnect,
        onError: this.props.onError,
        options: this.props.options
      }), this.props.eventHandlers && _typeof$2(this.props.eventHandlers) === "object" && this.sessionHelper.session.on(this.props.eventHandlers);
      var He = this.sessionHelper.streams;
      this.setState({ streams: He });
    }
  }, {
    key: "destroySession",
    value: function() {
      this.sessionHelper && (this.props.eventHandlers && _typeof$2(this.props.eventHandlers) === "object" && this.sessionHelper.session.off(this.props.eventHandlers), this.sessionHelper.disconnect());
    }
  }, {
    key: "render",
    value: function() {
      return _react2$7.default.createElement(
        "div",
        null,
        this.props.children
      );
    }
  }]), ue;
}(_react$7.Component);
OTSession$1.default = OTSession;
OTSession.propTypes = {
  children: _propTypes2$7.default.oneOfType([_propTypes2$7.default.element, _propTypes2$7.default.arrayOf(_propTypes2$7.default.element)]).isRequired,
  apiKey: _propTypes2$7.default.string.isRequired,
  sessionId: _propTypes2$7.default.string.isRequired,
  token: _propTypes2$7.default.string.isRequired,
  eventHandlers: _propTypes2$7.default.objectOf(_propTypes2$7.default.func),
  onConnect: _propTypes2$7.default.func,
  onError: _propTypes2$7.default.func,
  options: _propTypes2$7.default.object
};
OTSession.defaultProps = {
  eventHandlers: null,
  onConnect: null,
  onError: null,
  options: {}
};
OTSession.childContextTypes = {
  streams: _propTypes2$7.default.arrayOf(_propTypes2$7.default.object),
  session: _propTypes2$7.default.shape({
    subscribe: _propTypes2$7.default.func,
    unsubscribe: _propTypes2$7.default.func
  })
};
var OTPublisher$1 = {};
Object.defineProperty(OTPublisher$1, "__esModule", {
  value: !0
});
var _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(me) {
  return typeof me;
} : function(me) {
  return me && typeof Symbol == "function" && me.constructor === Symbol && me !== Symbol.prototype ? "symbol" : typeof me;
}, _createClass$3 = /* @__PURE__ */ function() {
  function me(ue, Qe) {
    for (var Ue = 0; Ue < Qe.length; Ue++) {
      var He = Qe[Ue];
      He.enumerable = He.enumerable || !1, He.configurable = !0, "value" in He && (He.writable = !0), Object.defineProperty(ue, He.key, He);
    }
  }
  return function(ue, Qe, Ue) {
    return Qe && me(ue.prototype, Qe), Ue && me(ue, Ue), ue;
  };
}(), _react$6 = React__default, _react2$6 = _interopRequireDefault$7(_react$6), _propTypes$6 = propTypesExports, _propTypes2$6 = _interopRequireDefault$7(_propTypes$6), _once = once_1, _once2 = _interopRequireDefault$7(_once), _fp = fp, _uuid$1 = uuid_1$2, _uuid2$1 = _interopRequireDefault$7(_uuid$1);
function _interopRequireDefault$7(me) {
  return me && me.__esModule ? me : { default: me };
}
function _classCallCheck$3(me, ue) {
  if (!(me instanceof ue))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$3(me, ue) {
  if (!me)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return ue && (typeof ue == "object" || typeof ue == "function") ? ue : me;
}
function _inherits$3(me, ue) {
  if (typeof ue != "function" && ue !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof ue);
  me.prototype = Object.create(ue && ue.prototype, { constructor: { value: me, enumerable: !1, writable: !0, configurable: !0 } }), ue && (Object.setPrototypeOf ? Object.setPrototypeOf(me, ue) : me.__proto__ = ue);
}
var OTPublisher = function(me) {
  _inherits$3(ue, me);
  function ue(Qe, Ue) {
    _classCallCheck$3(this, ue);
    var He = _possibleConstructorReturn$3(this, (ue.__proto__ || Object.getPrototypeOf(ue)).call(this, Qe));
    return He.sessionConnectedHandler = function() {
      He.publishToSession(He.state.publisher);
    }, He.streamCreatedHandler = function(Ge) {
      He.setState({ lastStreamId: Ge.stream.id });
    }, He.state = {
      publisher: null,
      lastStreamId: "",
      session: Qe.session || Ue.session || null
    }, He;
  }
  return _createClass$3(ue, [{
    key: "componentDidMount",
    value: function() {
      this.createPublisher();
    }
  }, {
    key: "componentDidUpdate",
    value: function(Ue, He) {
      var Ge = this, Xe = function(Ze, nt) {
        return Ze === void 0 ? nt : Ze;
      }, Ke = function(Ze, nt) {
        var tt = Xe(Ue.properties[Ze], nt), et = Xe(Ge.props.properties[Ze], nt);
        return tt !== et;
      }, $e = function(Ze, nt) {
        if (Ke(Ze, nt)) {
          var tt = Xe(Ge.props.properties[Ze], nt);
          Ge.state.publisher[Ze](tt);
        }
      };
      if (Ke("videoSource", void 0)) {
        this.destroyPublisher(), this.createPublisher();
        return;
      }
      $e("publishAudio", !0), $e("publishVideo", !0), this.state.session !== He.session && (this.destroyPublisher(He.session), this.createPublisher());
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.state.session && this.state.session.off("sessionConnected", this.sessionConnectedHandler), this.destroyPublisher();
    }
  }, {
    key: "getPublisher",
    value: function() {
      return this.state.publisher;
    }
  }, {
    key: "destroyPublisher",
    value: function() {
      var Ue = this, He = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.state.session;
      delete this.publisherId, this.state.publisher && (this.state.publisher.off("streamCreated", this.streamCreatedHandler), this.props.eventHandlers && _typeof$1(this.props.eventHandlers) === "object" && this.state.publisher.once("destroyed", function() {
        Ue.state.publisher.off(Ue.props.eventHandlers);
      }), He && He.unpublish(this.state.publisher), this.state.publisher.destroy());
    }
  }, {
    key: "publishToSession",
    value: function(Ue) {
      var He = this, Ge = this.publisherId;
      this.state.session.publish(Ue, function(Xe) {
        Ge === He.publisherId && (Xe ? He.errorHandler(Xe) : typeof He.props.onPublish == "function" && He.props.onPublish());
      });
    }
  }, {
    key: "createPublisher",
    value: function() {
      var Ue = this;
      if (!this.state.session) {
        this.setState({ publisher: null, lastStreamId: "" });
        return;
      }
      var He = this.props.properties || {}, Ge = void 0;
      He.insertDefaultUI !== !1 && (Ge = document.createElement("div"), Ge.setAttribute("class", "OTPublisherContainer"), this.node.appendChild(Ge)), this.publisherId = (0, _uuid2$1.default)();
      var Xe = this.publisherId;
      this.errorHandler = (0, _once2.default)(function(Je) {
        Xe === Ue.publisherId && typeof Ue.props.onError == "function" && Ue.props.onError(Je);
      });
      var Ke = OT.initPublisher(Ge, He, function(Je) {
        Xe === Ue.publisherId && (Je ? Ue.errorHandler(Je) : typeof Ue.props.onInit == "function" && Ue.props.onInit());
      });
      if (Ke.on("streamCreated", this.streamCreatedHandler), this.props.eventHandlers && _typeof$1(this.props.eventHandlers) === "object") {
        var $e = (0, _fp.omitBy)(_fp.isNil)(this.props.eventHandlers);
        Ke.on($e);
      }
      this.state.session.connection ? this.publishToSession(Ke) : this.state.session.once("sessionConnected", this.sessionConnectedHandler), this.setState({ publisher: Ke, lastStreamId: "" });
    }
  }, {
    key: "render",
    value: function() {
      var Ue = this, He = this.props, Ge = He.className, Xe = He.style;
      return _react2$6.default.createElement("div", { className: Ge, style: Xe, ref: function($e) {
        Ue.node = $e;
      } });
    }
  }]), ue;
}(_react$6.Component);
OTPublisher$1.default = OTPublisher;
OTPublisher.propTypes = {
  session: _propTypes2$6.default.shape({
    connection: _propTypes2$6.default.shape({
      connectionId: _propTypes2$6.default.string
    }),
    once: _propTypes2$6.default.func,
    off: _propTypes2$6.default.func,
    publish: _propTypes2$6.default.func,
    unpublish: _propTypes2$6.default.func
  }),
  className: _propTypes2$6.default.string,
  style: _propTypes2$6.default.object,
  // eslint-disable-line react/forbid-prop-types
  properties: _propTypes2$6.default.object,
  // eslint-disable-line react/forbid-prop-types
  eventHandlers: _propTypes2$6.default.objectOf(_propTypes2$6.default.func),
  onInit: _propTypes2$6.default.func,
  onPublish: _propTypes2$6.default.func,
  onError: _propTypes2$6.default.func
};
OTPublisher.defaultProps = {
  session: null,
  className: "",
  style: {},
  properties: {},
  eventHandlers: null,
  onInit: null,
  onPublish: null,
  onError: null
};
OTPublisher.contextTypes = {
  session: _propTypes2$6.default.shape({
    connection: _propTypes2$6.default.shape({
      connectionId: _propTypes2$6.default.string
    }),
    once: _propTypes2$6.default.func,
    off: _propTypes2$6.default.func,
    publish: _propTypes2$6.default.func,
    unpublish: _propTypes2$6.default.func
  })
};
var OTStreams$1 = {}, OTSubscriberContext$1 = {};
Object.defineProperty(OTSubscriberContext$1, "__esModule", {
  value: !0
});
var _createClass$2 = /* @__PURE__ */ function() {
  function me(ue, Qe) {
    for (var Ue = 0; Ue < Qe.length; Ue++) {
      var He = Qe[Ue];
      He.enumerable = He.enumerable || !1, He.configurable = !0, "value" in He && (He.writable = !0), Object.defineProperty(ue, He.key, He);
    }
  }
  return function(ue, Qe, Ue) {
    return Qe && me(ue.prototype, Qe), Ue && me(ue, Ue), ue;
  };
}(), _react$5 = React__default, _react2$5 = _interopRequireDefault$6(_react$5), _propTypes$5 = propTypesExports, _propTypes2$5 = _interopRequireDefault$6(_propTypes$5);
function _interopRequireDefault$6(me) {
  return me && me.__esModule ? me : { default: me };
}
function _classCallCheck$2(me, ue) {
  if (!(me instanceof ue))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$2(me, ue) {
  if (!me)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return ue && (typeof ue == "object" || typeof ue == "function") ? ue : me;
}
function _inherits$2(me, ue) {
  if (typeof ue != "function" && ue !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof ue);
  me.prototype = Object.create(ue && ue.prototype, { constructor: { value: me, enumerable: !1, writable: !0, configurable: !0 } }), ue && (Object.setPrototypeOf ? Object.setPrototypeOf(me, ue) : me.__proto__ = ue);
}
var OTSubscriberContext = function(me) {
  _inherits$2(ue, me);
  function ue() {
    return _classCallCheck$2(this, ue), _possibleConstructorReturn$2(this, (ue.__proto__ || Object.getPrototypeOf(ue)).apply(this, arguments));
  }
  return _createClass$2(ue, [{
    key: "getChildContext",
    value: function() {
      return { stream: this.props.stream };
    }
  }, {
    key: "render",
    value: function() {
      return _react2$5.default.createElement(
        "div",
        null,
        this.props.children
      );
    }
  }]), ue;
}(_react$5.Component);
OTSubscriberContext$1.default = OTSubscriberContext;
OTSubscriberContext.propTypes = {
  children: _propTypes2$5.default.element.isRequired,
  stream: _propTypes2$5.default.shape({
    streamId: _propTypes2$5.default.string
  }).isRequired
};
OTSubscriberContext.childContextTypes = {
  stream: _propTypes2$5.default.shape({
    streamId: _propTypes2$5.default.string
  })
};
Object.defineProperty(OTStreams$1, "__esModule", {
  value: !0
});
OTStreams$1.default = OTStreams;
var _react$4 = React__default, _react2$4 = _interopRequireDefault$5(_react$4), _propTypes$4 = propTypesExports, _propTypes2$4 = _interopRequireDefault$5(_propTypes$4), _OTSubscriberContext = OTSubscriberContext$1, _OTSubscriberContext2 = _interopRequireDefault$5(_OTSubscriberContext);
function _interopRequireDefault$5(me) {
  return me && me.__esModule ? me : { default: me };
}
function OTStreams(me, ue) {
  var Qe = me.session || ue.session || null, Ue = me.streams || ue.streams || null;
  if (!Qe)
    return _react2$4.default.createElement("div", null);
  var He = _react$4.Children.only(me.children), Ge = Array.isArray(Ue) ? Ue.map(function(Xe) {
    return He && _react2$4.default.createElement(
      _OTSubscriberContext2.default,
      { stream: Xe, key: Xe.id },
      (0, _react$4.cloneElement)(He)
    );
  }) : null;
  return _react2$4.default.createElement(
    "div",
    null,
    Ge
  );
}
OTStreams.propTypes = {
  children: _propTypes2$4.default.element.isRequired,
  session: _propTypes2$4.default.shape({ publish: _propTypes2$4.default.func, subscribe: _propTypes2$4.default.func }),
  streams: _propTypes2$4.default.arrayOf(_propTypes2$4.default.object)
};
OTStreams.defaultProps = {
  session: null,
  streams: null
};
OTStreams.contextTypes = {
  session: _propTypes2$4.default.shape({ publish: _propTypes2$4.default.func, subscribe: _propTypes2$4.default.func }),
  streams: _propTypes2$4.default.arrayOf(_propTypes2$4.default.object)
};
var OTSubscriber$1 = {};
Object.defineProperty(OTSubscriber$1, "__esModule", {
  value: !0
});
var _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(me) {
  return typeof me;
} : function(me) {
  return me && typeof Symbol == "function" && me.constructor === Symbol && me !== Symbol.prototype ? "symbol" : typeof me;
}, _createClass$1 = /* @__PURE__ */ function() {
  function me(ue, Qe) {
    for (var Ue = 0; Ue < Qe.length; Ue++) {
      var He = Qe[Ue];
      He.enumerable = He.enumerable || !1, He.configurable = !0, "value" in He && (He.writable = !0), Object.defineProperty(ue, He.key, He);
    }
  }
  return function(ue, Qe, Ue) {
    return Qe && me(ue.prototype, Qe), Ue && me(ue, Ue), ue;
  };
}(), _react$3 = React__default, _react2$3 = _interopRequireDefault$4(_react$3), _propTypes$3 = propTypesExports, _propTypes2$3 = _interopRequireDefault$4(_propTypes$3), _uuid = uuid_1$2, _uuid2 = _interopRequireDefault$4(_uuid);
function _interopRequireDefault$4(me) {
  return me && me.__esModule ? me : { default: me };
}
function _classCallCheck$1(me, ue) {
  if (!(me instanceof ue))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$1(me, ue) {
  if (!me)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return ue && (typeof ue == "object" || typeof ue == "function") ? ue : me;
}
function _inherits$1(me, ue) {
  if (typeof ue != "function" && ue !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof ue);
  me.prototype = Object.create(ue && ue.prototype, { constructor: { value: me, enumerable: !1, writable: !0, configurable: !0 } }), ue && (Object.setPrototypeOf ? Object.setPrototypeOf(me, ue) : me.__proto__ = ue);
}
var OTSubscriber = function(me) {
  _inherits$1(ue, me);
  function ue(Qe, Ue) {
    _classCallCheck$1(this, ue);
    var He = _possibleConstructorReturn$1(this, (ue.__proto__ || Object.getPrototypeOf(ue)).call(this, Qe));
    return He.state = {
      subscriber: null,
      stream: Qe.stream || Ue.stream || null,
      session: Qe.session || Ue.session || null,
      currentRetryAttempt: 0
    }, He.maxRetryAttempts = Qe.maxRetryAttempts || 5, He.retryAttemptTimeout = Qe.retryAttemptTimeout || 1e3, He;
  }
  return _createClass$1(ue, [{
    key: "componentDidMount",
    value: function() {
      this.createSubscriber();
    }
  }, {
    key: "componentDidUpdate",
    value: function(Ue, He) {
      var Ge = this, Xe = function(Je, Ze, nt) {
        return Je === void 0 ? nt : Ze(Je);
      }, Ke = function(Je) {
        var Ze = Xe(Ue.properties[Je], Boolean, !0), nt = Xe(Ge.props.properties[Je], Boolean, !0);
        Ze !== nt && Ge.state.subscriber[Je](nt);
      };
      Ke("subscribeToAudio"), Ke("subscribeToVideo"), (He.session !== this.state.session || He.stream !== this.state.stream) && (this.destroySubscriber(He.session), this.createSubscriber());
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.destroySubscriber();
    }
  }, {
    key: "getSubscriber",
    value: function() {
      return this.state.subscriber;
    }
  }, {
    key: "createSubscriber",
    value: function() {
      var Ue = this;
      if (!this.state.session || !this.state.stream) {
        this.setState({ subscriber: null });
        return;
      }
      var He = this.props.properties || {}, Ge = void 0;
      He.insertDefaultUI !== !1 && (Ge = document.createElement("div"), Ge.setAttribute("class", "OTSubscriberContainer"), this.node.appendChild(Ge)), this.subscriberId = (0, _uuid2.default)();
      var Xe = this.subscriberId, Ke = this.state.session.subscribe(this.state.stream, Ge, this.props.properties, function($e) {
        Xe === Ue.subscriberId && ($e && Ue.props.retry && Ue.state.currentRetryAttempt < Ue.maxRetryAttempts - 1 && Ue.handleRetrySubscriber(), $e && typeof Ue.props.onError == "function" ? Ue.props.onError($e) : !$e && typeof Ue.props.onSubscribe == "function" && Ue.props.onSubscribe());
      });
      this.props.eventHandlers && _typeof(this.props.eventHandlers) === "object" && Ke.on(this.props.eventHandlers), this.setState({ subscriber: Ke });
    }
  }, {
    key: "handleRetrySubscriber",
    value: function() {
      var Ue = this;
      setTimeout(function() {
        Ue.setState(function(He) {
          return {
            currentRetryAttempt: He.currentRetryAttempt + 1,
            subscriber: null
          };
        }), Ue.createSubscriber();
      }, this.retryAttemptTimeout);
    }
  }, {
    key: "destroySubscriber",
    value: function() {
      var Ue = this, He = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props.session;
      delete this.subscriberId, this.state.subscriber && (this.props.eventHandlers && _typeof(this.props.eventHandlers) === "object" && this.state.subscriber.once("destroyed", function() {
        Ue.state.subscriber.off(Ue.props.eventHandlers);
      }), He && He.unsubscribe(this.state.subscriber));
    }
  }, {
    key: "render",
    value: function() {
      var Ue = this, He = this.props, Ge = He.className, Xe = He.style;
      return _react2$3.default.createElement("div", { className: Ge, style: Xe, ref: function($e) {
        Ue.node = $e;
      } });
    }
  }]), ue;
}(_react$3.Component);
OTSubscriber$1.default = OTSubscriber;
OTSubscriber.propTypes = {
  stream: _propTypes2$3.default.shape({
    streamId: _propTypes2$3.default.string
  }),
  session: _propTypes2$3.default.shape({
    subscribe: _propTypes2$3.default.func,
    unsubscribe: _propTypes2$3.default.func
  }),
  className: _propTypes2$3.default.string,
  style: _propTypes2$3.default.object,
  // eslint-disable-line react/forbid-prop-types
  properties: _propTypes2$3.default.object,
  // eslint-disable-line react/forbid-prop-types
  retry: _propTypes2$3.default.bool,
  maxRetryAttempts: _propTypes2$3.default.number,
  retryAttemptTimeout: _propTypes2$3.default.number,
  eventHandlers: _propTypes2$3.default.objectOf(_propTypes2$3.default.func),
  onSubscribe: _propTypes2$3.default.func,
  onError: _propTypes2$3.default.func
};
OTSubscriber.defaultProps = {
  stream: null,
  session: null,
  className: "",
  style: {},
  properties: {},
  retry: !1,
  maxRetryAttempts: 5,
  retryAttemptTimeout: 1e3,
  eventHandlers: null,
  onSubscribe: null,
  onError: null
};
OTSubscriber.contextTypes = {
  stream: _propTypes2$3.default.shape({
    streamId: _propTypes2$3.default.string
  }),
  session: _propTypes2$3.default.shape({
    subscribe: _propTypes2$3.default.func,
    unsubscribe: _propTypes2$3.default.func
  })
};
var preloadScript$2 = {};
Object.defineProperty(preloadScript$2, "__esModule", {
  value: !0
});
var _createClass = /* @__PURE__ */ function() {
  function me(ue, Qe) {
    for (var Ue = 0; Ue < Qe.length; Ue++) {
      var He = Qe[Ue];
      He.enumerable = He.enumerable || !1, He.configurable = !0, "value" in He && (He.writable = !0), Object.defineProperty(ue, He.key, He);
    }
  }
  return function(ue, Qe, Ue) {
    return Qe && me(ue.prototype, Qe), Ue && me(ue, Ue), ue;
  };
}();
preloadScript$2.default = preloadScript$1;
var _react$2 = React__default, _react2$2 = _interopRequireDefault$3(_react$2), _propTypes$2 = propTypesExports, _propTypes2$2 = _interopRequireDefault$3(_propTypes$2), _reactDisplayName = getDisplayName$1, _reactDisplayName2 = _interopRequireDefault$3(_reactDisplayName), _scriptjs = scriptExports, _scriptjs2 = _interopRequireDefault$3(_scriptjs);
function _interopRequireDefault$3(me) {
  return me && me.__esModule ? me : { default: me };
}
function _objectWithoutProperties$2(me, ue) {
  var Qe = {};
  for (var Ue in me)
    ue.indexOf(Ue) >= 0 || Object.prototype.hasOwnProperty.call(me, Ue) && (Qe[Ue] = me[Ue]);
  return Qe;
}
function _classCallCheck(me, ue) {
  if (!(me instanceof ue))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(me, ue) {
  if (!me)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return ue && (typeof ue == "object" || typeof ue == "function") ? ue : me;
}
function _inherits(me, ue) {
  if (typeof ue != "function" && ue !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof ue);
  me.prototype = Object.create(ue && ue.prototype, { constructor: { value: me, enumerable: !1, writable: !0, configurable: !0 } }), ue && (Object.setPrototypeOf ? Object.setPrototypeOf(me, ue) : me.__proto__ = ue);
}
var DEFAULT_SCRIPT_URL = "https://static.opentok.com/v2/js/opentok.min.js";
function preloadScript$1(me) {
  var ue = function(Qe) {
    _inherits(Ue, Qe);
    function Ue(He) {
      _classCallCheck(this, Ue);
      var Ge = _possibleConstructorReturn(this, (Ue.__proto__ || Object.getPrototypeOf(Ue)).call(this, He));
      return Ge.onScriptLoad = function() {
        Ge.isPresent && Ge.setState({ scriptLoaded: !0 });
      }, Ge.state = {
        scriptLoaded: typeof OT < "u"
      }, Ge.isPresent = !1, Ge;
    }
    return _createClass(Ue, [{
      key: "componentDidMount",
      value: function() {
        if (this.isPresent = !0, !(this.scriptLoading || this.state.scriptLoaded)) {
          this.scriptLoading = !0;
          var Ge = this.props.opentokClientUrl;
          (0, _scriptjs2.default)(Ge, this.onScriptLoad);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.isPresent = !1;
      }
    }, {
      key: "render",
      value: function() {
        var Ge = this.props;
        Ge.opentokClientUrl;
        var Xe = Ge.loadingDelegate, Ke = _objectWithoutProperties$2(Ge, ["opentokClientUrl", "loadingDelegate"]);
        return this.state.scriptLoaded ? _react2$2.default.createElement(me, Ke) : Xe;
      }
    }]), Ue;
  }(_react$2.Component);
  return ue.displayName = "preloadScript(" + (0, _reactDisplayName2.default)(me) + ")", ue.propTypes = {
    opentokClientUrl: _propTypes2$2.default.string,
    loadingDelegate: _propTypes2$2.default.node
  }, ue.defaultProps = {
    opentokClientUrl: DEFAULT_SCRIPT_URL,
    loadingDelegate: _react2$2.default.createElement("div", null)
  }, ue;
}
Object.defineProperty(dist, "__esModule", {
  value: !0
});
var preloadScript = dist.preloadScript = createSession = dist.createSession = dist.OTSubscriber = dist.OTStreams = dist.OTPublisher = dist.OTSession = void 0, _OTSession = OTSession$1, _OTSession2 = _interopRequireDefault$2(_OTSession), _OTPublisher = OTPublisher$1, _OTPublisher2 = _interopRequireDefault$2(_OTPublisher), _OTStreams = OTStreams$1, _OTStreams2 = _interopRequireDefault$2(_OTStreams), _OTSubscriber = OTSubscriber$1, _OTSubscriber2 = _interopRequireDefault$2(_OTSubscriber), _createSession = createSession$2, _createSession2 = _interopRequireDefault$2(_createSession), _preloadScript = preloadScript$2, _preloadScript2 = _interopRequireDefault$2(_preloadScript);
function _interopRequireDefault$2(me) {
  return me && me.__esModule ? me : { default: me };
}
dist.default = {
  OTSession: _OTSession2.default,
  OTPublisher: _OTPublisher2.default,
  OTStreams: _OTStreams2.default,
  OTSubscriber: _OTSubscriber2.default,
  createSession: _createSession2.default,
  preloadScript: _preloadScript2.default
};
dist.OTSession = _OTSession2.default;
dist.OTPublisher = _OTPublisher2.default;
dist.OTStreams = _OTStreams2.default;
dist.OTSubscriber = _OTSubscriber2.default;
var createSession = dist.createSession = _createSession2.default;
preloadScript = dist.preloadScript = _preloadScript2.default;
const Container$5 = qe.div`
  display: grid;
  grid-template-rows: repeat(2, auto);
  align-items: center;
  grid-gap: 33px;
  color: #000;
  position: fixed;
  top: 0;
  z-index: 30;
  background: #fff;
  padding-top: 0;
  width: 100%;
  padding-top: 85px;
  height: 100%;
  text-align: left;
`, Title$7 = qe.h1`
  color: #000 !important;
  margin-bottom: 0;
  &.IncodeRecorderFailureTitle {
    text-align: left;
    width: 85%;
    font-size: 2.25rem !important;
  }
`, Content$1 = qe.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 20px 25px;
  color: #000;
  width: 100%;
  padding: 0 20px 25px;
`, List$1 = qe.ul`
  counter-reset: countLi;
  display: grid;
  grid-template-rows: auto;
  grid-gap: 20px;
  li {
    counter-increment: countLi;
    font-size: 0.875rem;
    position: relative;
    max-width: 300px;
    padding-left: 70px;
    line-height: 1.3rem;
    &::before {
      content: counter(countLi);
      position: absolute;
      width: 40px;
      height: 40px;
      background: white;
      left: 8px;
      border-radius: 50%;
      color: black;
      text-align: center;
      top: 50%;
      transform: translateY(-50%);
      line-height: 2;
      border: 2px solid #e9e9eb;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      z-index: 1;
    }
    &:after {
      content: '';
      position: absolute;
      width: 2px;
      height: 33px;
      background: #e9e9eb;
      left: 28px;
      bottom: -100%;
      transform: translateY(-50%);
    }
    &:last-child {
      &:after {
        display: none;
      }
    }
  }
`, StyledButton$2 = qe(Button$a)`
  width: 210px;
  min-width: 215px;
  border-radius: 31px;
  font-size: 1.25rem;
  margin: 0 auto;
`;
function SpeechRecommendations({ tryAgain: me = emptyFunc }) {
  const { t: ue } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Container$5,
    {
      className: "IncodeRecorderRecommendContainer",
      "aria-live": "assertive",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Title$7, { className: "IncodeRecorderFailureTitle", children: ue("common.somethingWrong") }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Content$1, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(List$1, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: ue("selfieInstructions.quietPlace") }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: ue("selfieInstructions.headphonesMicrophone") }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: ue("selfieInstructions.clearPronunciation") })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(StyledButton$2, { onClick: me, children: ue("common.tryAgain") })
        ] })
      ]
    }
  );
}
const consentTutorialSettingsAndroidImg = "data:image/png;base64,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", consentTutorialSettingsImg = "data:image/png;base64,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", consentTutorialToggleAndroidImg = "data:image/png;base64,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", consentTutorialToggleImg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAUDSURBVHgB7ZtPTFxVFMa/N8OwkGkyLmpluoFaWdSkYmgTtIkM0VYWLBwNBBY13dh0R5uwBzbGRROpq6Zs0C7AtgEXXRho0mEhIUJ12sQuEOsYI8U0xjEdmmpneJ7zmDHzB5h7Z967M9Hz2wBv8t5hvjn3nHvPOQMIgiAIgiAIgiAIgiAIgiAIgiD897HgMceuvx2hH+2w0WXDardgh+jvELwlSW8tAdgJsnsXPsRW+m7F4AGeCBiZfTeUSqeG6J8/D+/FUsJiQUlIv98/thT9KgGXcFXArHAjWeHqFstnTbolpGsCHr9xcsjeskdRJx5XDscjgbHl/vlJVIErAlKc+8S01+0LBNF18A107D+KttBhNDe9SNeanNceP9vEw80NrCZ/xJ1Hd7Hw6yJdS+34HMvyjS/3zV1AhVQlYHbJzpJ4ERiChRo8HEVv6zv/CqbCzcQcJu5fxToJW4oVTweauuPRL5PQpCoBj187+Z0Nux0GYI/78JXTGHz5PVTD1A8zmPj+aqlHWk6m7oYmFQtoctmy112OXET4uQNwg4ebv+HcwnCJN1aynP2oAPK8M/TjYxiA49unb37kmnjMvsYgIuETTnz8/ekfea/YneH3D/25fuPBkuqztD2wc7anJfMsc5uWbgs8xm3PK2YXT0ymA8FW1XjogyaZTGbEhHgc87wUj2luOoDLXRcdW3mEAuknI6rP0BKQvY/2emdgAE4YXoqXg0VkW/nY9tb5dtphqNyvJSB7HwzgbFWqzLY6sK0w2cyn4e+UUoLUW8JbZvZ7Z4+chmkGaG9ZgIUhlfuUBeSqiqnY19tyCqbpbT1VEguzlaQ9UfdAQ97Hx7Na4BwNw0W2Myh7SFAX0I9XYYCO/UbM7Gz7haOFF3zlnUZdQBstMEBb6CXUCt6050MVm7KfZt0JyNuKWlFs296unu+JThY2UucrCuRG2cG2qwIKO6AjoHatrBJ2K3zWyHbZ96wsIHXUjAjIB/xaUWw7W/bfE2UBLZ8dhwG4DF8rim1TEvm53D06WXgBBuAaXa0osW2jrNPoxEAjHrhXA8iE7QKoj1zuHmUBs519z+Mgi3fzpzmYhptO+R8cxz+VaQa9bYyNSzDA1NoMTDNx//PiSzEooCVgujE9DgNwNpxenYUppldnqKxfmIH9Gf+Yyr1aAsajsSRlJiNeeIU8Yv3JBryGG/BXiryPlu/k0qDa2Id+TySQGYWhWHguNuypiCweN5V4kiEHxz5V72O025obXySehvsP/UW/9sBjUvTGvn10D683H3P9jMziDS+OIvH4l4LrJOCFbwbmYqrPqagvvH79wVJzX+vzZKwTHsN924X1RafQ6paIOc8rFo9OW5dW+ue1+t1VjXZQyfu2qbkYFu/skQ8w0BZFNXDC4JiXv2wZcob4cv/8a9CkKgHbZyOhhnQDi2hkPobhmh0LqdM3ye0tp9dKs62DhViwIRiNmR4uytFx7a1x+gSVulhuwZNZXQdPOC0ArmKzsLklzoLxVmg1uUbHs3t0wvi6xONy8LK90z9f8YyPewOW2/MyRqYWXCJJjbKxlYFbVe1tXSuo8qQnpf9uy7Y+Q53DXhcMBFurFY/xZMi8c6qnJeOj/aLFk/l145FJPooGG4PjlcS63TDzNQfuKVvUFrWoMbXdnPL8aw5cALZANUzLKcPFvfqagyAIgiAIgiAIgiAIgiAIgiAIwv+BfwArv9pzjdDTzAAAAABJRU5ErkJggg==", InstructionsContainer = qe.div`
  z-index: 110;
  position: fixed;
  width: 100vw;
  height: 100%;
  background-color: #fff;
  padding: 25px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  h1 {
    width: 100%;
    font-size: 2.25rem;
  }
  div, label {
    font-size: 1.125rem;
    line-height: 1.625rem;
    margin-bottom: 15px;
    display: block;
  }
  div.small {
    font-size: 0.9375rem;
    line-height: 1.215rem;
  }
  ul {
    margin-bottom: 25px;
    li {
      min-height: 30px;
      display: flex;
      align-items: center;
      &:after {
        bottom: -100%;
        height: 40px;
        transform: translateY(0);
      }
      img {
        margin-left: 10px;
        max-width: 40px;
        max-height: 40px;
        object-fit: contain;
      }
    }
  }
  button {
    margin-top: 25px;
    padding: 19px 30px;
    margin-top
  }


`, ConsentInstructions = ({
  interviewID: me
}) => {
  const { t: ue } = useTranslation(), Qe = () => {
    const Xe = new URL(window.location.href);
    Xe.searchParams.set("interviewId", me.toString()), console.log(Xe.toString()), window.location.href = Xe.toString();
  }, Ue = "videoSelfie.consentInstructions", He = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: ue(`${Ue}.allowPermissions`) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: ue(`${Ue}.toContinueOnboarding`) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("label", { children: ue(`${Ue}.micPermissions`) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(List$1, { className: "IncodeRecorderInstructionsList", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
        ue(`${Ue}.iOS.step1`),
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: consentTutorialSettingsImg, alt: "settings icon" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: ue(`${Ue}.iOS.step2`) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: ue(`${Ue}.iOS.step3`) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: ue(`${Ue}.iOS.step4`) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
        ue(`${Ue}.iOS.step5`),
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: consentTutorialToggleImg, alt: "toggle" })
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("label", { children: ue(`${Ue}.screenPermissions`) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "small", children: ue(`${Ue}.iOS.step6`) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledButton$2, { onClick: Qe, children: [
      " ",
      ue("cameraPermission.retry")
    ] })
  ] }), Ge = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: ue(`${Ue}.allowPermissions`) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: ue(`${Ue}.toContinueOnboarding`) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("label", { children: ue(`${Ue}.micPermissions`) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(List$1, { className: "IncodeRecorderInstructionsList", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
        ue(`${Ue}.android.step1`),
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: consentTutorialSettingsAndroidImg, alt: "settings icon" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: ue(`${Ue}.android.step2`) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: ue(`${Ue}.android.step3`) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: ue(`${Ue}.android.step4`) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
        ue(`${Ue}.android.step5`),
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: consentTutorialToggleAndroidImg, alt: "toggle icon" })
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("label", { children: ue(`${Ue}.screenPermissions`) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(List$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
        ue(`${Ue}.android.step1`),
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: consentTutorialSettingsAndroidImg, alt: "settings icon" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: ue(`${Ue}.android.step2`) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: ue(`${Ue}.android.step3v2`) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: ue(`${Ue}.android.step4`) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
        ue(`${Ue}.android.step5`),
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: consentTutorialToggleAndroidImg, alt: "toggle icon" })
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "small", children: ue(`${Ue}.android.note`) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledButton$2, { onClick: Qe, children: [
      " ",
      ue("cameraPermission.retry")
    ] })
  ] });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InstructionsContainer, { className: "IncodeVideoSelfiePermissionsInstructions", children: mobile.iOS() ? He : Ge });
}, successSelfieImg = "data:image/svg+xml,%3csvg%20width='48'%20height='48'%20viewBox='0%200%2048%2048'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M44.2413%2012.0554L40.5562%208.27767C40.0509%207.75929%2039.4364%207.5%2038.714%207.5C37.991%207.5%2037.3765%207.75929%2036.8712%208.27767L19.0955%2026.5278L11.129%2018.3332C10.6231%2017.8146%2010.009%2017.5556%209.28662%2017.5556C8.5638%2017.5556%207.94965%2017.8146%207.44379%2018.3332L3.7587%2022.111C3.25284%2022.6295%203%2023.2593%203%2024.0002C3%2024.7405%203.25284%2025.3709%203.7587%2025.8893L13.5676%2035.9445L17.2529%2039.7222C17.7585%2040.241%2018.3728%2040.5%2019.0955%2040.5C19.8178%2040.5%2020.4322%2040.2403%2020.938%2039.7222L24.6233%2035.9445L44.2413%2015.8334C44.7467%2015.3149%2045%2014.6852%2045%2013.9443C45.0004%2013.2038%2044.7467%2012.574%2044.2413%2012.0554Z'%20fill='%230CD5A2'/%3e%3c/svg%3e", faceFrame = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='336'%20height='518'%20viewBox='0%200%20336%20518'%3e%3cpath%20fill='none'%20fill-rule='evenodd'%20stroke='%23FFF'%20stroke-dasharray='7.139999675750732,19.03999967575073'%20stroke-width='9.044'%20d='M168%20513.392c76.83%200%20162.893-113.92%20162.893-254.447S280.236%204.498%20168%204.498%205.107%20118.418%205.107%20258.945%2091.17%20513.392%20168%20513.392z'/%3e%3c/svg%3e", errorSelfieImg = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'%20standalone='no'?%3e%3csvg%20width='64'%20height='64'%20viewBox='0%200%2064%2064'%20fill='none'%20version='1.1'%20id='svg2'%20sodipodi:docname='fail_videoselfie_solid.svg'%20inkscape:version='1.3%20(0e150ed,%202023-07-21)'%20xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape'%20xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:svg='http://www.w3.org/2000/svg'%3e%3cdefs%20id='defs2'%20/%3e%3csodipodi:namedview%20id='namedview2'%20pagecolor='%23ffffff'%20bordercolor='%23000000'%20borderopacity='0.25'%20inkscape:showpageshadow='2'%20inkscape:pageopacity='0.0'%20inkscape:pagecheckerboard='0'%20inkscape:deskcolor='%23d1d1d1'%20inkscape:zoom='3.6875'%20inkscape:cx='31.864407'%20inkscape:cy='32'%20inkscape:window-width='3840'%20inkscape:window-height='2107'%20inkscape:window-x='0'%20inkscape:window-y='25'%20inkscape:window-maximized='1'%20inkscape:current-layer='svg2'%20/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M45%208.5C44.1716%208.5%2043.5%209.17157%2043.5%2010C43.5%2010.8284%2044.1716%2011.5%2045%2011.5H52C52.1326%2011.5%2052.2598%2011.5527%2052.3536%2011.6464C52.4473%2011.7402%2052.5%2011.8674%2052.5%2012V19C52.5%2019.8284%2053.1716%2020.5%2054%2020.5C54.8284%2020.5%2055.5%2019.8284%2055.5%2019V12C55.5%2011.0717%2055.1313%2010.1815%2054.4749%209.52513C53.8185%208.86875%2052.9283%208.5%2052%208.5H45ZM55.5%2045C55.5%2044.1716%2054.8284%2043.5%2054%2043.5C53.1716%2043.5%2052.5%2044.1716%2052.5%2045V52C52.5%2052.1326%2052.4473%2052.2598%2052.3536%2052.3536C52.2598%2052.4473%2052.1326%2052.5%2052%2052.5H45C44.1716%2052.5%2043.5%2053.1716%2043.5%2054C43.5%2054.8284%2044.1716%2055.5%2045%2055.5H52C52.9283%2055.5%2053.8185%2055.1313%2054.4749%2054.4749C55.1313%2053.8185%2055.5%2052.9283%2055.5%2052V45ZM10%2043.5C10.8284%2043.5%2011.5%2044.1716%2011.5%2045V52C11.5%2052.1326%2011.5527%2052.2598%2011.6464%2052.3536C11.7402%2052.4473%2011.8674%2052.5%2012%2052.5H19C19.8284%2052.5%2020.5%2053.1716%2020.5%2054C20.5%2054.8284%2019.8284%2055.5%2019%2055.5H12C11.0717%2055.5%2010.1815%2055.1313%209.52513%2054.4749C8.86875%2053.8185%208.5%2052.9283%208.5%2052V45C8.5%2044.1716%209.17157%2043.5%2010%2043.5ZM12%208.5C11.0717%208.5%2010.1815%208.86875%209.52513%209.52513C8.86875%2010.1815%208.5%2011.0717%208.5%2012V19C8.5%2019.8284%209.17157%2020.5%2010%2020.5C10.8284%2020.5%2011.5%2019.8284%2011.5%2019V12C11.5%2011.8674%2011.5527%2011.7402%2011.6464%2011.6464C11.7402%2011.5527%2011.8674%2011.5%2012%2011.5H19C19.8284%2011.5%2020.5%2010.8284%2020.5%2010C20.5%209.17157%2019.8284%208.5%2019%208.5H12Z'%20fill='%23FF5C6F'%20id='path1'%20style='fill:%23ff5c6f;fill-opacity:1'%20/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M41.4142%2025.4142C42.1953%2024.6332%2042.1953%2023.3668%2041.4142%2022.5858C40.6332%2021.8047%2039.3668%2021.8047%2038.5858%2022.5858L32%2029.1716L25.4142%2022.5858C24.6332%2021.8047%2023.3668%2021.8047%2022.5858%2022.5858C21.8047%2023.3668%2021.8047%2024.6332%2022.5858%2025.4142L29.1716%2032L22.5858%2038.5858C21.8047%2039.3668%2021.8047%2040.6332%2022.5858%2041.4142C23.3668%2042.1953%2024.6332%2042.1953%2025.4142%2041.4142L32%2034.8284L38.5858%2041.4142C39.3668%2042.1953%2040.6332%2042.1953%2041.4142%2041.4142C42.1953%2040.6332%2042.1953%2039.3668%2041.4142%2038.5858L34.8284%2032L41.4142%2025.4142Z'%20fill='white'%20id='path2'%20style='fill:%23ff5c6f;fill-opacity:1'%20/%3e%3c/svg%3e", getSelfieBoarderColor = ({ isCapturing: me, isLoading: ue, error: Qe }) => me ? "#0CD5A2" : ue ? "#0093FD" : Qe ? "#FF5C6F" : "#FFF", FaceMask = qe.div`
  z-index: 5;
  position: absolute;
  width: 90vw;
  height: 90vw;
  top: 100px;
  transform: translate(-50%, 0);
  left: 50%;
  border: solid 8px;
  border-radius: 50%;
  box-shadow: 0 0 0 99999px rgba(255, 255, 255, 1);
  top: 50%;
  transform: translate(-50%, -50%);
  border: solid 6.9px;
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.6);
  border-color: ${getSelfieBoarderColor};
`, Text$3 = qe.p`
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 5;
  font-size: 2rem;
  font-weight: bold;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  text-align: center;
  color: ${(me) => me.isCapturing ? "#0cd5a2" : "#ffffff"};
  max-width: 80%;
  line-height: 2rem;
  img {
    width: 2rem;
    height: 2rem;
    margin-bottom: 5px;
  }
  &.id {
    bottom: 500px;
  }
  &.selfie {
    top: calc(50% + (90vw / 2));
    padding-top: 35px;
    width: 100%;
    color: #fff;
    font-size: 1.75rem;
    @media only screen and (max-height: 600px) {
      font-size: 1.2rem;
    }
  }
  &.speech {
    top: 10px;
  }
`, FaceFrame = qe.img`
  z-index: 5;
  position: absolute;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
  height: calc(85vw - 40px);
`, SelfieMask = ({
  isCapturing: me,
  isLoading: ue,
  error: Qe,
  isSuccessful: Ue,
  notification: He
}) => {
  const { t: Ge } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      FaceMask,
      {
        className: "IncodeVideoRecorderFaceMask",
        isCapturing: me,
        isLoading: ue,
        error: Qe,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          FaceFrame,
          {
            src: faceFrame,
            alt: "face frame",
            className: "face-frame IncodeVideoRecorderFaceFrame"
          }
        )
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Text$3,
      {
        className: "selfie IncodeRecorderTextNotification",
        role: "region",
        "aria-live": "polite",
        children: [
          Qe ? /* @__PURE__ */ jsxRuntimeExports.jsx(
            "img",
            {
              src: errorSelfieImg,
              "aria-hidden": !0,
              role: "img",
              alt: "selfie error"
            }
          ) : null,
          Ue ? /* @__PURE__ */ jsxRuntimeExports.jsx(
            "img",
            {
              src: successSelfieImg,
              "aria-hidden": !0,
              role: "img",
              alt: "selfie success"
            }
          ) : null,
          He || Ge("videoSelfie.lookCamera")
        ]
      }
    )
  ] });
}, waveEncoder = () => {
  let me = 2, ue = [];
  function Qe(He) {
    let Ge = He.length, Xe = new Uint8Array(Ge * me);
    for (let Ke = 0; Ke < Ge; Ke++) {
      let $e = Ke * me, Je = He[Ke];
      Je > 1 ? Je = 1 : Je < -1 && (Je = -1), Je = Je * 32768, Xe[$e] = Je, Xe[$e + 1] = Je >> 8;
    }
    ue.push(Xe);
  }
  function Ue(He) {
    let Ge = ue.length ? ue[0].length : 0, Xe = ue.length * Ge, Ke = new Uint8Array(44 + Xe), $e = new DataView(Ke.buffer);
    $e.setUint32(0, 1380533830, !1), $e.setUint32(4, 36 + Xe, !0), $e.setUint32(8, 1463899717, !1), $e.setUint32(12, 1718449184, !1), $e.setUint32(16, 16, !0), $e.setUint16(20, 1, !0), $e.setUint16(22, 1, !0), $e.setUint32(24, He, !0), $e.setUint32(28, He * me, !0), $e.setUint16(32, me, !0), $e.setUint16(34, 8 * me, !0), $e.setUint32(36, 1684108385, !1), $e.setUint32(40, Xe, !0);
    for (let Je = 0; Je < ue.length; Je++)
      Ke.set(ue[Je], Je * Ge + 44);
    ue = [], postMessage(Ke.buffer, [Ke.buffer]);
  }
  onmessage = (He) => {
    He.data[0] === "encode" ? Qe(He.data[1]) : He.data[0] === "dump" && Ue(He.data[1]);
  };
};
let AudioContext = window.AudioContext || window.webkitAudioContext, createWorker = (me) => {
  let ue = me.toString().replace(/^(\(\)\s*=>|function\s*\(\))\s*{/, "").replace(/}$/, ""), Qe = new Blob([ue]);
  return new Worker(URL.createObjectURL(Qe));
}, error = (me) => {
  let ue = new Event("error");
  return ue.data = new Error("Wrong state for " + me), ue;
}, context, MediaRecorder$2 = class WA {
  /**
   * @param {MediaStream} stream The audio stream to record.
   */
  constructor(ue, Qe = null) {
    this.stream = ue, this.config = Qe, this.state = "inactive", this.em = document.createDocumentFragment(), this.encoder = createWorker(WA.encoder);
    let Ue = this;
    this.encoder.addEventListener("message", (He) => {
      let Ge = new Event("dataavailable");
      Ge.data = new Blob([He.data], { type: Ue.mimeType }), Ue.em.dispatchEvent(Ge), Ue.state === "inactive" && Ue.em.dispatchEvent(new Event("stop"));
    });
  }
  /**
   * Begins recording media.
   *
   * @param {number} [timeslice] The milliseconds to record into each `Blob`.
   *                             If this parameter isn’t included, single `Blob`
   *                             will be recorded.
   *
   * @return {undefined}
   *
   * @example
   * recordButton.addEventListener('click', () => {
   *   recorder.start()
   * })
   */
  start(ue) {
    if (this.state !== "inactive")
      return this.em.dispatchEvent(error("start"));
    this.state = "recording", context || (context = new AudioContext(this.config)), this.clone = this.stream.clone(), this.input = context.createMediaStreamSource(this.clone), this.processor = context.createScriptProcessor(2048, 1, 1), this.encoder.postMessage(["init", context.sampleRate]), this.processor.onaudioprocess = (Qe) => {
      this.state === "recording" && this.encoder.postMessage(["encode", Qe.inputBuffer.getChannelData(0)]);
    }, this.input.connect(this.processor), this.processor.connect(context.destination), this.em.dispatchEvent(new Event("start")), ue && (this.slicing = setInterval(() => {
      this.state === "recording" && this.requestData();
    }, ue));
  }
  /**
   * Stop media capture and raise `dataavailable` event with recorded data.
   *
   * @return {undefined}
   *
   * @example
   * finishButton.addEventListener('click', () => {
   *   recorder.stop()
   * })
   */
  stop() {
    return this.state === "inactive" ? this.em.dispatchEvent(error("stop")) : (this.requestData(), this.state = "inactive", this.clone.getTracks().forEach((ue) => {
      ue.stop();
    }), this.processor.disconnect(), this.input.disconnect(), clearInterval(this.slicing));
  }
  /**
   * Pauses recording of media streams.
   *
   * @return {undefined}
   *
   * @example
   * pauseButton.addEventListener('click', () => {
   *   recorder.pause()
   * })
   */
  pause() {
    return this.state !== "recording" ? this.em.dispatchEvent(error("pause")) : (this.state = "paused", this.em.dispatchEvent(new Event("pause")));
  }
  /**
   * Resumes media recording when it has been previously paused.
   *
   * @return {undefined}
   *
   * @example
   * resumeButton.addEventListener('click', () => {
   *   recorder.resume()
   * })
   */
  resume() {
    return this.state !== "paused" ? this.em.dispatchEvent(error("resume")) : (this.state = "recording", this.em.dispatchEvent(new Event("resume")));
  }
  /**
   * Raise a `dataavailable` event containing the captured media.
   *
   * @return {undefined}
   *
   * @example
   * this.on('nextData', () => {
   *   recorder.requestData()
   * })
   */
  requestData() {
    return this.state === "inactive" ? this.em.dispatchEvent(error("requestData")) : this.encoder.postMessage(["dump", context.sampleRate]);
  }
  /**
   * Add listener for specified event type.
   *
   * @param {"start"|"stop"|"pause"|"resume"|"dataavailable"|"error"}
   * type Event type.
   * @param {function} listener The listener function.
   *
   * @return {undefined}
   *
   * @example
   * recorder.addEventListener('dataavailable', e => {
   *   audio.src = URL.createObjectURL(e.data)
   * })
   */
  addEventListener(...ue) {
    this.em.addEventListener(...ue);
  }
  /**
   * Remove event listener.
   *
   * @param {"start"|"stop"|"pause"|"resume"|"dataavailable"|"error"}
   * type Event type.
   * @param {function} listener The same function used in `addEventListener`.
   *
   * @return {undefined}
   */
  removeEventListener(...ue) {
    this.em.removeEventListener(...ue);
  }
  /**
   * Calls each of the listeners registered for a given event.
   *
   * @param {Event} event The event object.
   *
   * @return {boolean} Is event was no canceled by any listener.
   */
  dispatchEvent(...ue) {
    this.em.dispatchEvent(...ue);
  }
};
MediaRecorder$2.prototype.mimeType = "audio/wav";
MediaRecorder$2.isTypeSupported = (me) => MediaRecorder$2.prototype.mimeType === me;
MediaRecorder$2.notSupported = !navigator.mediaDevices || !AudioContext;
MediaRecorder$2.encoder = waveEncoder;
const mpegEncoder = () => {
  importScripts(
    "https://cdnjs.cloudflare.com/ajax/libs/lamejs/1.2.0/lame.min.js"
  );
  let me = 1, ue = 128, Qe = 44100, Ue, He = new Int8Array();
  function Ge(Je, Ze) {
    if (Ze.length === 0)
      return Je;
    let nt = new Int8Array(Je.length + Ze.length);
    return nt.set(Je), nt.set(Ze, Je.length), nt;
  }
  function Xe(Je) {
    Ue = new lamejs.Mp3Encoder(
      me,
      Je || Qe,
      ue
    );
  }
  function Ke(Je) {
    for (let nt = 0; nt < Je.length; nt++)
      Je[nt] = Je[nt] * 32767.5;
    let Ze = Ue.encodeBuffer(Je);
    He = Ge(He, Ze);
  }
  function $e() {
    let Je = Ue.flush();
    He = Ge(He, Je);
    let Ze = He.buffer;
    He = new Int8Array(), postMessage(Ze, [Ze]);
  }
  onmessage = (Je) => {
    Je.data[0] === "init" ? Xe(Je.data[1]) : Je.data[0] === "encode" ? Ke(Je.data[1]) : $e(Je.data[1]);
  };
}, getVideoSelfieConfig = ({
  session: { token: me }
}) => api.get("/omni/get/videoselfie/config", {
  headers: {
    "X-Incode-Hardware-Id": me
  }
}).then((ue) => ue.data), allGoodImg = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'%20standalone='no'?%3e%3csvg%20width='64'%20height='64'%20viewBox='0%200%2064%2064'%20fill='none'%20version='1.1'%20id='svg2'%20sodipodi:docname='all-good--solid.svg'%20inkscape:version='1.3%20(0e150ed,%202023-07-21)'%20xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape'%20xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:svg='http://www.w3.org/2000/svg'%3e%3cdefs%20id='defs2'%20/%3e%3csodipodi:namedview%20id='namedview2'%20pagecolor='%23ffffff'%20bordercolor='%23000000'%20borderopacity='0.25'%20inkscape:showpageshadow='2'%20inkscape:pageopacity='0.0'%20inkscape:pagecheckerboard='0'%20inkscape:deskcolor='%23d1d1d1'%20inkscape:zoom='3.6875'%20inkscape:cx='31.864407'%20inkscape:cy='32'%20inkscape:window-width='3840'%20inkscape:window-height='2107'%20inkscape:window-x='0'%20inkscape:window-y='25'%20inkscape:window-maximized='1'%20inkscape:current-layer='svg2'%20/%3e%3cpath%20d='M42.6026%2026.3467L40.6723%2024.4006C40.4076%2024.1336%2040.0857%2024%2039.7074%2024C39.3286%2024%2039.0067%2024.1336%2038.7421%2024.4006L29.431%2033.8022L25.258%2029.5807C24.9931%2029.3136%2024.6714%2029.1802%2024.293%2029.1802C23.9144%2029.1802%2023.5927%2029.3136%2023.3277%2029.5807L21.3974%2031.5269C21.1324%2031.794%2021%2032.1184%2021%2032.5001C21%2032.8815%2021.1324%2033.2062%2021.3974%2033.4733L26.5354%2038.6532L28.4658%2040.5993C28.7306%2040.8666%2029.0524%2041%2029.431%2041C29.8093%2041%2030.1311%2040.8662%2030.3961%2040.5993L32.3265%2038.6532L42.6026%2028.293C42.8673%2028.0258%2043%2027.7014%2043%2027.3198C43.0002%2026.9383%2042.8673%2026.6139%2042.6026%2026.3467Z'%20fill='white'%20id='path1'%20style='fill:%230cd5a2;fill-opacity:1'%20/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M44.5%209C43.6716%209%2043%209.67157%2043%2010.5C43%2011.3284%2043.6716%2012%2044.5%2012H51.5C51.6326%2012%2051.7598%2012.0527%2051.8536%2012.1464C51.9473%2012.2402%2052%2012.3674%2052%2012.5V19.5C52%2020.3284%2052.6716%2021%2053.5%2021C54.3284%2021%2055%2020.3284%2055%2019.5V12.5C55%2011.5717%2054.6313%2010.6815%2053.9749%2010.0251C53.3185%209.36875%2052.4283%209%2051.5%209H44.5ZM55%2045.5C55%2044.6716%2054.3284%2044%2053.5%2044C52.6716%2044%2052%2044.6716%2052%2045.5V52.5C52%2052.6326%2051.9473%2052.7598%2051.8536%2052.8536C51.7598%2052.9473%2051.6326%2053%2051.5%2053H44.5C43.6716%2053%2043%2053.6716%2043%2054.5C43%2055.3284%2043.6716%2056%2044.5%2056H51.5C52.4283%2056%2053.3185%2055.6313%2053.9749%2054.9749C54.6313%2054.3185%2055%2053.4283%2055%2052.5V45.5ZM9.5%2044C10.3284%2044%2011%2044.6716%2011%2045.5V52.5C11%2052.6326%2011.0527%2052.7598%2011.1464%2052.8536C11.2402%2052.9473%2011.3674%2053%2011.5%2053H18.5C19.3284%2053%2020%2053.6716%2020%2054.5C20%2055.3284%2019.3284%2056%2018.5%2056H11.5C10.5717%2056%209.68151%2055.6313%209.02513%2054.9749C8.36875%2054.3185%208%2053.4283%208%2052.5V45.5C8%2044.6716%208.67157%2044%209.5%2044ZM11.5%209C10.5717%209%209.6815%209.36875%209.02513%2010.0251C8.36875%2010.6815%208%2011.5717%208%2012.5V19.5C8%2020.3284%208.67157%2021%209.5%2021C10.3284%2021%2011%2020.3284%2011%2019.5V12.5C11%2012.3674%2011.0527%2012.2402%2011.1464%2012.1464C11.2402%2012.0527%2011.3674%2012%2011.5%2012H18.5C19.3284%2012%2020%2011.3284%2020%2010.5C20%209.67157%2019.3284%209%2018.5%209H11.5Z'%20fill='%230CD5A2'%20id='path2'%20style='fill:%230cd5a2;fill-opacity:1'%20/%3e%3c/svg%3e";
MediaRecorder$2.encoder = mpegEncoder;
MediaRecorder$2.prototype.mimeType = "audio/mpeg";
const MediaRecorder$1 = MediaRecorder$2, Question = qe(Question$1)`
  font-size: 1.5rem;
  span {
    font-size: 1.125rem !important;
    margin-bottom: -15px;
  }
`, stateMachineStatus = {
  IDLE: "idle",
  PENDING: "pending",
  SUCCESS: "success",
  REJECTED: "rejected",
  ALL_GOOD: "allGood"
}, stateMachineReducer = (me, ue) => {
  switch (ue.type) {
    case "idle":
      return { status: "idle", error: null };
    case "pending":
      return { status: "pending", error: null };
    case "success":
      return { status: "resolved", error: null };
    case "rejected":
      return { status: "rejected", error: ue.error };
    case "allGood":
      return { status: "allGood", error: null };
    default:
      throw new Error(`Unhandled action type: ${ue.type}`);
  }
}, useStateMachine = () => {
  const [me, ue] = useReducer(stateMachineReducer, {
    status: "idle",
    error: null
  });
  return {
    status: me.status,
    error: me.error,
    setStatus: ue
  };
}, getConsent = (me, ue) => {
  const Qe = ue.split("-")[0], Ue = Object.keys(me.consents).find(
    (He) => He.startsWith(Qe)
  );
  return me.consents[Ue || "en-US"].answer;
}, ProcessingContainer = qe.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  margin-top: 50px;
  margin-bottom: -50px;
  img {
    margin-bottom: 15px;
  }
  h1 {
    font-size: 2.25rem !important;
    color: #000 !important;
  }
`, RanOutAlert = qe.div`
  position: fixed;
  width: calc(80%);
  top: 50%;
  transform: translateY(-50%);
  background: #fff;
  left: 10%;
  border-radius: 25px;
  padding: 20px;
  text-align: left;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 0px 0px 1000px rgba(0, 0, 0, 0.4);
  strong {
    font-size: 1.325rem;
    margin-bottom: 15px;
  }
  div {
    font-size: 0.875rem;
    line-height: 1.25rem;
    margin-bottom: 15px;
  }
  button {
    margin: 0 auto;
    padding: 19px 30px;
  }
  a {
    margin-top: 15px;
    font-size: 1.125rem;
    text-decoration: underline;
    color: #000;
    text-align: center;
  }
`;
function Processing({ status: me, message: ue }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ProcessingContainer, { children: [
    me === stateMachineStatus.PENDING ? /* @__PURE__ */ jsxRuntimeExports.jsx(SpinImage, { src: spinner, alt: "spinner" }) : /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: allGoodImg, alt: "all good" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: ue })
  ] });
}
const SpeechMask = ({
  onNext: me,
  speechToTextCheck: ue,
  stopRecording: Qe,
  token: Ue,
  stream: He,
  numberOfTries: Ge,
  sound: Xe
}) => {
  const { t: Ke, i18n: $e } = useTranslation(), [Je, Ze] = useState(), [nt, tt] = useState(!0), et = useRef(), rt = useRef(0), { status: it, setStatus: ot } = useStateMachine(), [at, st] = useState(null), [ut, lt] = useState(null);
  useScreenEvents({
    module: eventModuleNames.videoSelfie,
    screen: eventScreenNames.videoSelfieVoiceFinalQuestion,
    token: Ue.token
  }), useEffect(() => {
    async function yt() {
      const Ct = new MediaRecorder$1(He.clone());
      et.current = Ct, screenEvent({
        module: eventModuleNames.videoSelfie,
        code: videoSelfieEvents.audioStreamOpened,
        token: Ue.token
      });
    }
    return yt(), () => {
    };
  }, [He]), useEffect(() => {
    getVideoSelfieConfig({ session: Ue }).then((yt) => {
      const Ct = getConsent(yt, $e.language);
      Ze(Ct);
    });
  }, []);
  function dt() {
    var ht, It, vt, Et;
    if ((ht = et.current) == null || ht.stop(), !Je)
      return;
    if (ue === !1) {
      me(!0);
      return;
    }
    ut && clearTimeout(ut), st(!1), ot({ type: stateMachineStatus.PENDING });
    let yt = [];
    async function Ct(bt) {
      if (!(bt.data.size > 0))
        return me(!0);
      yt.push(bt.data);
      const Rt = new Blob(yt, {
        type: "audio/mp3"
      }), { success: St } = await addSpeech({
        token: Ue.token,
        audio: Rt
      }).catch(() => ({ success: !1 }));
      if (et.current.removeEventListener(
        "dataavailable",
        Ct
      ), St)
        return ot({ type: stateMachineStatus.ALL_GOOD }), addEvent({
          module: eventModuleNames.videoSelfie,
          token: Ue.token,
          code: videoSelfieEvents.videoSelfieTosAccepted
        }), await sleep(3e3), ot({ type: stateMachineStatus.SUCCESS }), Qe(() => me(!0));
      addEvent({
        module: eventModuleNames.videoSelfie,
        token: Ue.token,
        code: videoSelfieEvents.videoSelfieTosNotAccepted
      }), yt = [];
      const kt = rt.current + 1;
      if (rt.current = kt, Ge !== -1 && kt >= Ge)
        return Qe(() => me(!1));
      ot({ type: stateMachineStatus.REJECTED }), tt(!0);
    }
    et.current.addEventListener(
      "dataavailable",
      Ct
    );
    try {
      (It = et.current) == null || It.stop(), screenEvent({
        module: eventModuleNames.videoSelfie,
        code: videoSelfieEvents.audioStreamClosed,
        token: Ue.token
      }), (Et = (vt = et.current) == null ? void 0 : vt.stream) == null || Et.getTracks().forEach((bt) => bt.stop());
    } catch (bt) {
      console.error(bt);
    }
  }
  function At() {
    var yt;
    (yt = et.current) == null || yt.stop(), ot({ type: stateMachineStatus.IDLE }), tt(!0), st(!1);
  }
  function pt() {
    var yt;
    (yt = et.current) == null || yt.start(), tt(!1), lt(
      setTimeout(() => {
        st(!0);
      }, 1e4)
    );
  }
  const gt = it === stateMachineStatus.IDLE || it === stateMachineStatus.SUCCESS, wt = it === stateMachineStatus.REJECTED, Bt = [
    stateMachineStatus.PENDING,
    stateMachineStatus.ALL_GOOD
  ].includes(it);
  if (at)
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(RanOutAlert, { className: "ranout-alert IncodeRecorderRanoutTimeAlert", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: Ke("videoSelfie.finishedSpeaking") }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
          Ke("videoSelfie.didYouSay"),
          ' "',
          Je,
          '"?'
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "pl-1", children: Ke("videoSelfie.ifYouHavent") })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(QuestionButton, { onClick: dt, children: Ke("videoSelfie.imDone") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("a", { onClick: At, children: Ke("videoSelfie.tryAgain") })
    ] });
  const Tt = !nt && !Bt;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    QuestionMaskContainer,
    {
      className: "speech question-container IncodeRecorderQuestionContainer",
      recording: Tt,
      children: [
        Bt && /* @__PURE__ */ jsxRuntimeExports.jsx(
          Processing,
          {
            "aria-live": "assertive",
            status: it,
            message: Ke(`videoSelfie.${it}`)
          }
        ),
        gt && !Bt && !at && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: Ke("videoSelfie.sayOutLoud") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Question, { className: "IncodeRecorderQuestion", "aria-live": "assertive", children: Je || "" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(BottomContainer, { className: "IncodeRecorderQuestionBottomContainer", children: nt ? /* @__PURE__ */ jsxRuntimeExports.jsxs(
            QuestionButton,
            {
              className: "inverted",
              onClick: pt,
              disabled: !Je,
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: speechBuuble, alt: "speech bubble" }),
                Ke("common.tapToSpeak")
              ]
            }
          ) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Microphone,
              {
                sound: Xe,
                isQuestions: !0,
                recording: !nt
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(QuestionButton, { role: "button", onClick: dt, children: Ke("common.tapWhenDone") })
          ] }) })
        ] }),
        wt && /* @__PURE__ */ jsxRuntimeExports.jsx(SpeechRecommendations, { tryAgain: At })
      ]
    }
  );
}, greenCheck = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M21.3334%2013.333L14.0001%2019.9997L10.6667%2016.6663'%20stroke='%230CD5A2'%20stroke-width='2'%20stroke-linecap='square'/%3e%3c/svg%3e", check = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M21.3337%2013.333L14.0003%2019.9997L10.667%2016.6663'%20stroke='white'%20stroke-width='2'%20stroke-linecap='square'/%3e%3c/svg%3e", consent = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'%20standalone='no'?%3e%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20version='1.1'%20id='svg6'%20sodipodi:docname='consent.svg'%20xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape'%20xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:svg='http://www.w3.org/2000/svg'%3e%3csodipodi:namedview%20id='namedview6'%20pagecolor='%23ffffff'%20bordercolor='%23000000'%20borderopacity='0.25'%20inkscape:showpageshadow='2'%20inkscape:pageopacity='0.0'%20inkscape:pagecheckerboard='0'%20inkscape:deskcolor='%23d1d1d1'%20/%3e%3cg%20clip-path='url(%23clip0_5487_4295)'%20id='g5'%3e%3cg%20clip-path='url(%23clip1_5487_4295)'%20id='g4'%3e%3cpath%20d='m%2016,17.5%20c%200.8284,0%201.5,-0.6716%201.5,-1.5%200,-0.8284%20-0.6716,-1.5%20-1.5,-1.5%20-0.8284,0%20-1.5,0.6716%20-1.5,1.5%200,0.8284%200.6716,1.5%201.5,1.5%20z'%20fill='%2320263D'%20id='path1'%20style='fill:%23ffffff;fill-opacity:1;stroke:%23ffffff;stroke-opacity:1'%20/%3e%3cpath%20d='M%2010.5,17.5%20C%2011.3284,17.5%2012,16.8284%2012,16%2012,15.1716%2011.3284,14.5%2010.5,14.5%209.67157,14.5%209,15.1716%209,16%20c%200,0.8284%200.67157,1.5%201.5,1.5%20z'%20fill='%2320263D'%20id='path2'%20style='fill:%23ffffff;fill-opacity:1;stroke:%23ffffff;stroke-opacity:1'%20/%3e%3cpath%20d='m%2021.5,17.5%20c%200.8284,0%201.5,-0.6716%201.5,-1.5%200,-0.8284%20-0.6716,-1.5%20-1.5,-1.5%20-0.8284,0%20-1.5,0.6716%20-1.5,1.5%200,0.8284%200.6716,1.5%201.5,1.5%20z'%20fill='%2320263D'%20id='path3'%20style='fill:%23ffffff;fill-opacity:1;stroke:%23ffffff;stroke-opacity:1'%20/%3e%3cpath%20d='m%209.99125,26.3889%20c%202.52065,1.4589%205.48585,1.9512%208.34275,1.3853%202.8569,-0.5659%205.4104,-2.1515%207.1846,-4.4611%201.7742,-2.3096%202.6478,-5.1856%202.4581,-8.0918%20C%2027.787,12.3151%2026.5469,9.57703%2024.4875,7.51766%2022.4281,5.45829%2019.6901,4.21814%2016.7839,4.02843%2013.8777,3.83872%2011.0017,4.71239%208.69205,6.48656%206.38244,8.26073%204.79686,10.8143%204.23094,13.6712%203.66502,16.5281%204.15739,19.4932%205.61625,22.0139%20L%204.0525,26.6827%20c%20-0.05876,0.1762%20-0.06729,0.3652%20-0.02463,0.546%200.04266,0.1808%200.13483,0.3461%200.26616,0.4774%200.13134,0.1314%200.29665,0.2235%200.47742,0.2662%200.18077,0.0426%200.36985,0.0341%200.54605,-0.0246%20z'%20stroke='%2320263D'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'%20id='path4'%20style='stroke:%23ffffff;stroke-opacity:1'%20/%3e%3c/g%3e%3c/g%3e%3cdefs%20id='defs6'%3e%3cclipPath%20id='clip0_5487_4295'%3e%3crect%20width='32'%20height='32'%20fill='%23ffffff'%20id='rect5'%20x='0'%20y='0'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip1_5487_4295'%3e%3crect%20width='32'%20height='32'%20fill='%23ffffff'%20id='rect6'%20x='0'%20y='0'%20/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", document$1 = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'%20standalone='no'?%3e%3c!--%20Created%20with%20Inkscape%20(http://www.inkscape.org/)%20--%3e%3csvg%20width='31.999998'%20height='31.999998'%20viewBox='0%200%208.4666652%208.4666652'%20version='1.1'%20id='svg1'%20xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape'%20xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:svg='http://www.w3.org/2000/svg'%3e%3csodipodi:namedview%20id='namedview1'%20pagecolor='%23ffffff'%20bordercolor='%23000000'%20borderopacity='0.25'%20inkscape:showpageshadow='2'%20inkscape:pageopacity='0.0'%20inkscape:pagecheckerboard='0'%20inkscape:deskcolor='%23d1d1d1'%20inkscape:document-units='mm'%20inkscape:zoom='0.2102413'%20inkscape:cx='397.16269'%20inkscape:cy='561.25984'%20inkscape:window-width='3840'%20inkscape:window-height='2107'%20inkscape:window-x='0'%20inkscape:window-y='25'%20inkscape:window-maximized='1'%20inkscape:current-layer='layer1'%20/%3e%3cdefs%20id='defs1'%20/%3e%3cg%20inkscape:label='Layer%201'%20inkscape:groupmode='layer'%20id='layer1'%3e%3cpath%20style='fill:%23ffffff;fill-opacity:1;stroke-width:0.0503003'%20d='M%202.1371681,7.7074283%20C%201.9146058,7.6474895%201.7424188,7.4694912%201.6961309,7.2515073%201.6749942,7.1519719%201.6747939,1.4912877%201.6959298,1.3903826%201.7427446,1.1668083%201.9330318,0.97660662%202.1575996,0.92892102%20c%200.049768,-0.010567%200.4940888,-0.0149762%201.5096506,-0.0149762%201.406191,0%201.4403639,5.906e-4%201.4932344,0.026299%200.076817,0.037335%201.6624558,1.62568108%201.6905239,1.69340948%200.018191,0.043897%200.020505,0.3032023%200.020505,2.2984042%200,1.6155244%20-0.00422,2.2687877%20-0.014976,2.3194495%20-0.047686,0.2245679%20-0.2378872,0.414855%20-0.4614616,0.4616698%20-0.050013,0.010472%20-0.6693229,0.014514%20-2.129375,0.013893%20-1.7278226,-7.447e-4%20-2.0700522,-0.00389%20-2.128526,-0.01964%20z%20M%206.3661312,7.3018906%20c%200.033808,-0.017249%200.062074,-0.045514%200.079321,-0.079321%200.026526,-0.051994%200.026796,-0.074043%200.026796,-2.1824299%20V%202.9102343%20H%205.9427011%20c%20-0.5730301,0%20-0.6110751,-0.00377%20-0.7505148,-0.074433%20C%205.050964,2.764239%204.9246581,2.5961044%204.8901936,2.433797%204.8805433,2.3883481%204.8752173,2.1765201%204.8752173,1.8380492%20V%201.3128264%20l%20-1.3341865,0.00352%20-1.3341866,0.00352%20-0.041612,0.029682%20c%20-0.092355,0.065869%20-0.085371,-0.1898289%20-0.081583,2.9869071%20l%200.00341,2.8658%200.029521,0.041386%20c%200.064842,0.090902%20-0.1004627,0.084408%202.1569454,0.084742%202.0186586,3.082e-4%202.0406237,2.24e-5%202.0925975,-0.026493%20z%20M%202.9910365,6.5032965%20C%202.9285541,6.4723678%202.8789284,6.3958966%202.8789284,6.3305425%20c%200,-0.061244%200.048052,-0.1385801%200.1065228,-0.1714428%200.049611,-0.027883%200.059196,-0.028186%200.8916217,-0.028186%200.8404552,0%200.8415345,3.51e-5%200.8931899,0.029068%200.054483,0.030621%200.1049548,0.1126427%200.1049548,0.1705615%200,0.06345%20-0.051658,0.1432569%20-0.1114707,0.1722117%20-0.055334,0.026786%20-0.075744,0.027417%20-0.8875486,0.027407%20-0.8065441,-1e-5%20-0.8325034,-7.961e-4%20-0.8851618,-0.026864%20z%20m%200,-0.7985154%20C%202.9285541,5.6738526%202.8789284,5.5973809%202.8789284,5.5320268%20c%200,-0.061244%200.048052,-0.1385801%200.1065228,-0.1714426%200.050084,-0.028149%200.051789,-0.028186%201.2908795,-0.028186%20h%201.2407295%20l%200.051718,0.029067%20c%200.054483,0.030621%200.1049548,0.1126432%200.1049548,0.1705615%200,0.06345%20-0.051658,0.1432571%20-0.1114707,0.1722119%20-0.055935,0.027078%20-0.071861,0.027417%20-1.2868065,0.027407%20C%203.0684819,5.7316354%203.0442629,5.731132%202.9910365,5.7047811%20Z%20m%200,-0.7985155%20C%202.9285541,4.8753369%202.8789284,4.7988654%202.8789284,4.7335114%20c%200,-0.061244%200.048052,-0.1385802%200.1065228,-0.1714429%200.050084,-0.028149%200.051789,-0.028186%201.2908795,-0.028186%20h%201.2407295%20l%200.051718,0.029067%20c%200.054483,0.030621%200.1049548,0.1126432%200.1049548,0.1705618%200,0.06345%20-0.051658,0.1432571%20-0.1114707,0.1722116%20-0.055935,0.027078%20-0.071861,0.027417%20-1.2868065,0.027407%20-1.2069739,-10e-6%20-1.2311929,-5.136e-4%20-1.2844193,-0.026864%20z%20m%200,-0.7985157%20C%202.9285541,4.0768214%202.8789284,4.0003497%202.8789284,3.9349957%20c%200,-0.061244%200.048052,-0.1385802%200.1065228,-0.1714429%200.050084,-0.028149%200.051789,-0.028186%201.2908795,-0.028186%20h%201.2407295%20l%200.051718,0.029067%20c%200.054483,0.030621%200.1049548,0.1126432%200.1049548,0.1705616%200,0.06345%20-0.051658,0.1432571%20-0.1114707,0.1722119%20-0.055935,0.027078%20-0.071861,0.027417%20-1.2868065,0.027407%20C%203.0684822,4.1346039%203.0442632,4.1341006%202.9910365,4.1077499%20Z%20M%205.7335483,2.0583358%205.2811298,1.6056951%20l%20-0.00398,0.10329%20c%20-0.00218,0.05681%20-0.00218,0.2320508%200,0.3894249%200.00377,0.2708478%200.00556,0.2883457%200.033505,0.3275204%200.057864,0.081121%200.07711,0.084408%200.4960949,0.084743%20l%200.3792217,3.082e-4%20z'%20id='path39'%20/%3e%3c/g%3e%3c/svg%3e", idBack = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M5%205C3.89543%205%203%205.89543%203%207V25C3%2026.1046%203.89543%2027%205%2027H27C28.1046%2027%2029%2026.1046%2029%2025V7C29%205.89543%2028.1046%205%2027%205H5ZM5%207H27V25H5V7ZM7%2010H9V13H7V10ZM11%2010H15V13H11V10ZM25%2010H18V13H25V10ZM9.5%2010H10.5V13H9.5V10ZM17%2010H16V13H17V10ZM7%2021C7%2020.4477%207.44772%2020%208%2020H13C13.5523%2020%2014%2020.4477%2014%2021C14%2021.5523%2013.5523%2022%2013%2022H8C7.44772%2022%207%2021.5523%207%2021Z'%20fill='white'/%3e%3c/svg%3e", idFront = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M5%205C3.89543%205%203%205.89543%203%207V25C3%2026.1046%203.89543%2027%205%2027H27C28.1046%2027%2029%2026.1046%2029%2025V7C29%205.89543%2028.1046%205%2027%205H5ZM5%207H27V25H5V7ZM9.5127%2015C9.5127%2013.8954%2010.4081%2013%2011.5127%2013C12.6173%2013%2013.5127%2013.8954%2013.5127%2015C13.5127%2016.1046%2012.6173%2017%2011.5127%2017H11.5125C10.408%2016.9999%209.5127%2016.1045%209.5127%2015ZM14.3123%2017.857C15.0531%2017.131%2015.5127%2016.1192%2015.5127%2015C15.5127%2012.7909%2013.7218%2011%2011.5127%2011C9.30356%2011%207.5127%2012.7909%207.5127%2015C7.5127%2016.1192%207.97231%2017.131%208.71309%2017.857C8.62373%2017.9173%208.53613%2017.9807%208.45044%2018.0471C7.57401%2018.7258%206.9479%2019.6765%206.67049%2020.7497C6.53228%2021.2844%206.8537%2021.8299%207.38841%2021.9681C7.92312%2022.1063%208.46864%2021.7849%208.60685%2021.2502C8.77332%2020.6061%209.14905%2020.0357%209.675%2019.6284C10.201%2019.221%2010.8473%2019%2011.5125%2019H11.5127C12.1779%2019%2012.8242%2019.221%2013.3501%2019.6282C13.8761%2020.0355%2014.2519%2020.606%2014.4184%2021.25C14.5566%2021.7847%2015.1022%2022.1061%2015.6369%2021.9678C16.1716%2021.8296%2016.4929%2021.2841%2016.3547%2020.7493C16.0772%2019.6761%2015.451%2018.7255%2014.5746%2018.0469C14.489%2017.9806%2014.4015%2017.9173%2014.3123%2017.857ZM19%2013C18.4477%2013%2018%2013.4477%2018%2014C18%2014.5523%2018.4477%2015%2019%2015H24C24.5523%2015%2025%2014.5523%2025%2014C25%2013.4477%2024.5523%2013%2024%2013H19ZM19%2017C18.4477%2017%2018%2017.4477%2018%2018C18%2018.5523%2018.4477%2019%2019%2019H24C24.5523%2019%2025%2018.5523%2025%2018C25%2017.4477%2024.5523%2017%2024%2017H19Z'%20fill='white'/%3e%3c/svg%3e", questions = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'%20standalone='no'?%3e%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20version='1.1'%20id='svg3'%20sodipodi:docname='questions.svg'%20xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape'%20xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:svg='http://www.w3.org/2000/svg'%3e%3csodipodi:namedview%20id='namedview3'%20pagecolor='%23ffffff'%20bordercolor='%23000000'%20borderopacity='0.25'%20inkscape:showpageshadow='2'%20inkscape:pageopacity='0.0'%20inkscape:pagecheckerboard='0'%20inkscape:deskcolor='%23d1d1d1'%20/%3e%3cg%20clip-path='url(%23clip0_5487_3779)'%20id='g2'%3e%3cg%20clip-path='url(%23clip1_5487_3779)'%20id='g1'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M%207.52551,4.14935%20C%207.82033,4.33156%207.99978,4.65342%207.99978,5%20v%208%20c%200,0.5523%20-0.44771,1%20-1,1%20-0.55228,0%20-1,-0.4477%20-1,-1%20V%206.61804%20L%205.447,6.89443%20C%204.95302,7.14142%204.35235,6.94119%204.10536,6.44721%203.85837,5.95324%204.05859,5.35256%204.55257,5.10557%20l%202,-1%20C%206.86256,3.95058%207.2307,3.96714%207.52551,4.14935%20Z%20M%2011.9998,8%20c%200,-0.55228%200.4477,-1%201,-1%20h%2014%20c%200.5523,0%201,0.44772%201,1%200,0.55229%20-0.4477,1%20-1,1%20h%20-14%20c%20-0.5523,0%20-1,-0.44771%20-1,-1%20z%20m%200,8%20c%200,-0.5523%200.4477,-1%201,-1%20h%2014%20c%200.5523,0%201,0.4477%201,1%200,0.5523%20-0.4477,1%20-1,1%20h%20-14%20c%20-0.5523,0%20-1,-0.4477%20-1,-1%20z%20m%201,7%20c%20-0.5523,0%20-1,0.4477%20-1,1%200,0.5523%200.4477,1%201,1%20h%2014%20c%200.5523,0%201,-0.4477%201,-1%200,-0.5523%20-0.4477,-1%20-1,-1%20z%20M%209.56817,18.4581%20C%209.36149,18.1184%209.08854,17.8239%208.76561,17.592%208.11924,17.1216%207.31599,16.9193%206.52383,17.0275%205.73012,17.136%205.00928,17.5477%204.51265,18.1762%20h%20-2e-5%20l%20-0.00461,0.0059%20c%20-0.19037,0.2447%20-0.3414,0.5176%20-0.44766,0.8088%20-0.1893,0.5188%200.07784,1.0929%200.59667,1.2822%200.51883,0.1893%201.09288,-0.0778%201.28218,-0.5967%200.03455,-0.0947%200.08348,-0.1835%200.14507,-0.2633%200.17589,-0.221%200.43027,-0.3657%200.71024,-0.404%200.28122,-0.0384%200.56639,0.0336%200.79564,0.201%20h%20-2e-5%20l%200.00768,0.0055%20c%200.10538,0.0754%200.19442,0.1714%200.26177,0.2821%200.06736,0.1107%200.11164,0.2339%200.13018,0.3621%200.01854,0.1282%200.01096,0.2589%20-0.02228,0.3842%20-0.03325,0.1252%20-0.09147,0.2424%20-0.17117,0.3446%20l%20-0.01251,0.0164%20-3.585,4.7962%20c%20-0.2266,0.3032%20-0.26263,0.7083%20-0.09309,1.0467%200.16954,0.3383%200.51559,0.552%200.89406,0.552%20h%204%20c%200.55229,0%201,-0.4477%201,-1%200,-0.5523%20-0.44771,-1%20-1,-1%20H%206.99572%20l%202.3845,-3.1901%20C%209.62217,21.4972%209.79911,21.1392%209.90055,20.7571%2010.003,20.3712%2010.0263,19.9687%209.96919,19.5736%209.91207,19.1785%209.77566,18.7991%209.56817,18.4581%20Z'%20fill='%2320263D'%20id='path1'%20style='fill:%23ffffff;fill-opacity:1'%20/%3e%3c/g%3e%3c/g%3e%3cdefs%20id='defs3'%3e%3cclipPath%20id='clip0_5487_3779'%3e%3crect%20width='32'%20height='32'%20fill='%23ffffff'%20id='rect2'%20x='0'%20y='0'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip1_5487_3779'%3e%3crect%20width='32'%20height='32'%20fill='%23ffffff'%20id='rect3'%20x='0'%20y='0'%20/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", selfie = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M22.5%204C21.9477%204%2021.5%204.44772%2021.5%205C21.5%205.55228%2021.9477%206%2022.5%206L26%206V9.49995C26%2010.0522%2026.4477%2010.5%2027%2010.5C27.5523%2010.5%2028%2010.0522%2028%209.49995V6C28%205.46957%2027.7893%204.96086%2027.4142%204.58579C27.0391%204.21071%2026.5304%204%2026%204H22.5ZM28%2022.5C28%2021.9477%2027.5523%2021.5%2027%2021.5C26.4477%2021.5%2026%2021.9477%2026%2022.5V26H22.5C21.9477%2026%2021.5%2026.4478%2021.5%2027C21.5%2027.5523%2021.9477%2028%2022.5%2028H26C26.5304%2028%2027.0391%2027.7893%2027.4142%2027.4143C27.7893%2027.0392%2028%2026.5305%2028%2026V22.5ZM5%2021.5C5.55228%2021.5%206%2021.9477%206%2022.5V26H9.5C10.0523%2026%2010.5%2026.4478%2010.5%2027C10.5%2027.5523%2010.0523%2028%209.5%2028H6C5.46957%2028%204.96086%2027.7893%204.58579%2027.4143C4.21071%2027.0392%204%2026.5305%204%2026V22.5C4%2021.9477%204.44772%2021.5%205%2021.5ZM6%204C5.46957%204%204.96086%204.21071%204.58579%204.58579C4.21071%204.96086%204%205.46957%204%206V9.49995C4%2010.0522%204.44772%2010.5%205%2010.5C5.55228%2010.5%206%2010.0522%206%209.49995L6%206L9.5%206C10.0523%206%2010.5%205.55228%2010.5%205C10.5%204.44772%2010.0523%204%209.5%204H6ZM16%2011C14.3431%2011%2013%2012.3431%2013%2014C13%2015.6569%2014.3431%2017%2016%2017C17.6569%2017%2019%2015.6569%2019%2014C19%2012.3431%2017.6569%2011%2016%2011ZM19.2688%2017.7836C20.3291%2016.8668%2021%2015.5117%2021%2014C21%2011.2386%2018.7614%209%2016%209C13.2386%209%2011%2011.2386%2011%2014C11%2015.5117%2011.6709%2016.8668%2012.7312%2017.7836C12.4728%2017.9138%2012.2204%2018.0597%2011.9752%2018.2209C10.7604%2019.0197%209.76848%2020.1648%209.10624%2021.533C8.86984%2022.0213%209.04119%2022.6263%209.48896%2022.8841C9.93673%2023.142%2010.4914%2022.9551%2010.7278%2022.4667C11.2342%2021.4203%2011.9928%2020.5445%2012.9219%2019.9337C13.8461%2019.326%2014.904%2019.0033%2015.9829%2019C15.9886%2019%2015.9943%2019%2016%2019C16.0057%2019%2016.0114%2019%2016.0171%2019C17.096%2019.0033%2018.1539%2019.326%2019.0781%2019.9337C20.0072%2020.5446%2020.7658%2021.4203%2021.2722%2022.4667C21.5086%2022.9551%2022.0633%2023.142%2022.511%2022.8841C22.9588%2022.6263%2023.1302%2022.0214%2022.8938%2021.533C22.2315%2020.1648%2021.2396%2019.0197%2020.0248%2018.2209C19.7796%2018.0597%2019.5272%2017.9138%2019.2688%2017.7836Z'%20fill='white'/%3e%3c/svg%3e", StepsContainer = qe.ol`
  display: flex;
  gap: 5px;
  position: fixed;
  width: 100%;
  padding: 0 15px;
  height: 65px;
  top: 0;
  left: 0;
  z-index: 20;
  list-style-type: none;
  ${(me) => me.isBlack ? "background: #000;" : "background: #fff;"}
`, Step = qe.li`
  width: 100%;
  height: 100%;
  color: #fff;
  flex: 1;
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 10px;
  img {
    width: 32px;
  }
  &:after {
    position: absolute;
    content: '';
    width: 100%;
    height: 3px;
    top: 5px;
    left: 0;
    background: #fff;
    border-radius: 5px;
    opacity: 20%;
    top: 7px;
  }
  ${(me) => me.active && `
    &:after {
      opacity: 40%;
      height: 5px;
      top: 6px;
    }
    `}
  ${(me) => me.current && `
      &:after {
        opacity: 100%;
        top: 6px;
      }
    `}
  ${(me) => !me.isBlack && !me.isFinished && `
      color: #000;
      img {
        filter: invert(1);
      }
      &:after {
        background: #000;
      }
    `}
  ${(me) => me.isFinished && `
    &:after {
      opacity: 100%;
      top:6px;
      height: 5px;
      background: #0CD5A2;
    }
  `}
`, stepsImages = {
  front: idFront,
  back: idBack,
  selfie,
  questions,
  speech: consent,
  poa: document$1
}, stepsAltText = {
  front: "Scan the Front of ID",
  back: "Scan the Back of ID",
  selfie: "Selfie Capture",
  questions: "Answer questions out loud",
  speech: "Speak words displayed on the screen",
  poa: "Proof of Address"
}, StepsHeader = ({ modules: me, modeIndex: ue }) => {
  const Qe = me[ue], Ue = ["front", "back", "poa"].includes(Qe), He = me.length <= ue;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    StepsContainer,
    {
      isBlack: Ue,
      "aria-label": "Progress steps",
      className: "IncodeRecorderStepsProgress",
      children: me.map((Ge, Xe) => /* @__PURE__ */ jsxRuntimeExports.jsx(
        Step,
        {
          active: Xe <= ue && !He,
          current: Xe === ue && !He,
          isBlack: Ue && !He,
          isFinished: He,
          className: "IncodeRecorderStepsProgressStep",
          "aria-current": Xe === ue && !He ? "step" : void 0,
          children: He ? /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: greenCheck, alt: "Completed" }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            Xe < ue && /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: check, alt: "Completed step" }),
            Xe === ue && /* @__PURE__ */ jsxRuntimeExports.jsx(
              "img",
              {
                src: stepsImages[Qe],
                alt: stepsAltText[Ge]
              }
            )
          ] })
        },
        Ge
      ))
    }
  );
}, cameraRotate = "data:image/svg+xml,%3csvg%20width='49'%20height='48'%20viewBox='0%200%2049%2048'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M17.2519%206.66795C17.5301%206.25065%2017.9985%206%2018.5%206H30.5C31.0015%206%2031.4699%206.25065%2031.7481%206.66795L34.3028%2010.5H39.5C40.6935%2010.5%2041.8381%2010.9741%2042.682%2011.818C43.5259%2012.6619%2044%2013.8065%2044%2015V36C44%2037.1935%2043.5259%2038.3381%2042.682%2039.182C41.8381%2040.0259%2040.6935%2040.5%2039.5%2040.5H9.5C8.30653%2040.5%207.16193%2040.0259%206.31802%2039.182C5.47411%2038.3381%205%2037.1935%205%2036V15C5%2013.8065%205.47411%2012.6619%206.31802%2011.818C7.16193%2010.9741%208.30653%2010.5%209.5%2010.5H14.6972L17.2519%206.66795ZM19.3028%209L16.7481%2012.832C16.4699%2013.2493%2016.0015%2013.5%2015.5%2013.5H9.5C9.10218%2013.5%208.72064%2013.658%208.43934%2013.9393C8.15804%2014.2206%208%2014.6022%208%2015V36C8%2036.3978%208.15804%2036.7794%208.43934%2037.0607C8.72064%2037.342%209.10218%2037.5%209.5%2037.5H39.5C39.8978%2037.5%2040.2794%2037.342%2040.5607%2037.0607C40.842%2036.7794%2041%2036.3978%2041%2036V15C41%2014.6022%2040.842%2014.2206%2040.5607%2013.9393C40.2794%2013.658%2039.8978%2013.5%2039.5%2013.5H33.5C32.9985%2013.5%2032.5301%2013.2493%2032.2519%2012.832L29.6972%209H19.3028Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M32%2016.5C32.8284%2016.5%2033.5%2017.1716%2033.5%2018V22.5C33.5%2023.3284%2032.8284%2024%2032%2024H27.5C26.6716%2024%2026%2023.3284%2026%2022.5C26%2021.6716%2026.6716%2021%2027.5%2021H30.5V18C30.5%2017.1716%2031.1716%2016.5%2032%2016.5Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M15.5%2027C15.5%2026.1716%2016.1716%2025.5%2017%2025.5H21.5C22.3284%2025.5%2023%2026.1716%2023%2027C23%2027.8284%2022.3284%2028.5%2021.5%2028.5H18.5V31.5C18.5%2032.3284%2017.8284%2033%2017%2033C16.1716%2033%2015.5%2032.3284%2015.5%2031.5V27Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M19.1003%2018.3002C20.8335%2017.0007%2022.9772%2016.3699%2025.138%2016.5237C27.2987%2016.6774%2029.3315%2017.6054%2030.8633%2019.1372L30.8877%2019.1622L33.0852%2021.4647C33.6572%2022.064%2033.635%2023.0135%2033.0357%2023.5854C32.4364%2024.1574%2031.4869%2024.1352%2030.915%2023.5359L28.7302%2021.2468C27.7104%2020.2325%2026.36%2019.6182%2024.925%2019.5161C23.4845%2019.4136%2022.0554%2019.8341%2020.8999%2020.7004C20.2371%2021.1974%2019.2969%2021.0629%2018.8%2020.4001C18.303%2019.7373%2018.4375%2018.7971%2019.1003%2018.3002Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M15.9639%2025.9153C16.563%2025.3431%2017.5125%2025.3649%2018.0847%2025.9639L20.2698%2028.2516C21.2894%2029.2662%2022.6398%2029.8809%2024.075%2029.9833C25.5155%2030.0861%2026.9448%2029.6658%2028.1004%2028.7997C28.7633%2028.3029%2029.7035%2028.4375%2030.2003%2029.1004C30.6971%2029.7633%2030.5625%2030.7035%2029.8996%2031.2003C28.1662%2032.4995%2026.0223%2033.1299%2023.8615%2032.9757C21.7007%2032.8215%2019.668%2031.8932%2018.1366%2030.3611L18.1128%2030.3367L15.9153%2028.0361C15.3431%2027.437%2015.3649%2026.4875%2015.9639%2025.9153Z'%20fill='white'/%3e%3c/svg%3e";
async function getOpentokSession(me) {
  return (await api.post(
    "/omni/speech/create-session",
    {},
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  )).data;
}
async function getOpenViduSession({ token: me }) {
  return (await api.post(
    "/omni/speech/create-session/v2",
    {},
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  )).data;
}
async function startRecordingOpenVidu({
  token: me,
  videoRecordingId: ue,
  resolution: Qe
}) {
  return (await api.post(
    "/omni/speech/record-start/v2",
    {
      videoRecordingId: ue,
      outputMode: "COMPOSED",
      resolution: Qe,
      frameRate: 10
    },
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  )).data;
}
async function stopRecorderOpenVidu({ token: me }) {
  return (await api.post(
    "/omni/speech/record-stop/v2",
    {},
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  )).data;
}
async function startRecorder(me) {
  return (await api.post(
    "/omni/speech/record-start",
    {
      resolution: "720x1280"
    },
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  )).data;
}
async function stopRecorder(me) {
  return (await api.post(
    "/omni/speech/record-stop",
    {},
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  )).data;
}
async function processRecordedSpeech(me) {
  return (await api.post(
    "/omni/process/speech",
    {},
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  )).data;
}
async function setSpeechOffset(me, ue) {
  return (await api.post(
    "/omni/speech/offset",
    {
      offset: ue
    },
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  )).data;
}
const recorderRepository = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getOpenViduSession,
  getOpentokSession,
  processRecordedSpeech,
  setSpeechOffset,
  startRecorder,
  startRecordingOpenVidu,
  stopRecorder,
  stopRecorderOpenVidu
}, Symbol.toStringTag, { value: "Module" })), Container$4 = qe.div`
  position: relative;
  height: 100%;
  min-height: 487px;
  overflow: auto;
  #opentok-container-vs {
    &.mirrored {
      transform: scaleX(-1);
      .OT_video-element {
        height: 100vh;
        width: 100vw;
        object-fit: cover;
        margin: 0 auto;
      }
    }
    .OT_video-loading {
      display: none !important;
    }
  }
`, RecordConsentContainer = qe.div`
  position: fixed;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  background: #000;
  z-index: 100;
  color: #fff;
  padding-top: 35px;
  text-align: center;
  * {
    max-width: 80%;
    margin: 0 auto;
  }
  p {
    font-size: 1.125rem;
    line-height: 1.5rem;
    color: white;
  }
  .consentAllow {
    font-size: 1.55rem;
    margin-top: 0;
    color: #00b2fd;
    line-height: 2.2rem;
  }
`, SwitchingCameraMask = qe.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background: #000;
  z-index: 10;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  flex-direction: column;
  img {
    margin-bottom: 15px;
    width: 64px;
  }
`, BACK_FACING_MODES$1 = ["front", "back", "poa"], FRONT_FACING_MODES = ["selfie", "questions", "speech"], MODULES_WITH_SAME_CAMERA = {
  front: BACK_FACING_MODES$1,
  back: BACK_FACING_MODES$1,
  poa: BACK_FACING_MODES$1,
  selfie: FRONT_FACING_MODES,
  questions: FRONT_FACING_MODES,
  speech: FRONT_FACING_MODES
}, timeoutSleep = 2e3;
let userMedia;
const VideoSelfieMode = {
  selfie: "selfie",
  captureId: "captureId"
}, defaultEventsCount = {
  imageTooBlurry: { count: 0 },
  fillFrame: { count: 0 },
  checkCameraOrLighting: { count: 0 },
  frontIdCaptureStarted: { count: 0 },
  lookAtCamera: { count: 0 },
  moveCloser: { count: 0 }
};
function chooseCameraByLabel(me, ue) {
  for (const Qe of ue) {
    const Ue = me.findIndex(
      (He) => Qe.includes(He.label)
    );
    if (Ue !== -1)
      return Ue;
  }
  return -1;
}
async function chooseCamera() {
  try {
    const me = navigator.userAgent, Qe = (await navigator.mediaDevices.enumerateDevices()).filter(
      (Xe) => Xe.kind === "videoinput"
    );
    if (!me.includes("iPhone"))
      return chooseCameraByLabel(Qe, [
        ["camera 0, facing back"],
        ["camera2 0, facing back"]
      ]);
    let Ue = -1;
    if (Qe.length === 2)
      return -1;
    let He = [["Back Camera", "Cámara trasera"]];
    if (Qe.length === 7) {
      const Xe = [
        [
          "Back Ultra Wide Camera",
          "Cámara trasera con ultra gran angular",
          "Cámara ultra amplia posterior doble"
        ]
      ], Ke = [
        { width: 430, height: 932 },
        // 14pro max and 15pro max
        { width: 393, height: 852 }
        // 14pro and 15pro
      ], $e = {
        width: screen.width,
        height: screen.height
      };
      Ke.find(
        (Ze) => $e.width === Ze.width && $e.height === Ze.height
      ) && (He = Xe);
    }
    if (Ue = chooseCameraByLabel(Qe, He), Ue !== -1)
      return Ue;
    let Ge = 1 / 0;
    for (let Xe = 0; Xe < Qe.length; Xe++) {
      const $e = Qe[Xe].getCapabilities();
      $e.focusDistance && $e.focusDistance.min <= Ge && (Ge = $e.focusDistance.min, Ue = Xe);
    }
    return Ue;
  } catch {
    return -1;
  }
}
const getAndPublishStream = (me, ue, Qe) => new Promise((Ue) => {
  const He = document.getElementById("opentok-container-vs");
  if (!He)
    throw new Error("Element with id 'opentok-container-vs' not found");
  const Ge = BACK_FACING_MODES$1.includes(ue[0]), Xe = OT.initPublisher(He, {
    frameRate: 30,
    height: "100%",
    width: "100%",
    fitMode: "cover",
    showControls: !1,
    resolution: "640x480",
    facingMode: Ge ? "environment" : "user",
    mirror: !1
  });
  me.publish(Xe, async () => {
    await (Qe == null ? void 0 : Qe()), Ue(Xe);
  });
}), useOpentok = (me, ue, Qe, Ue) => {
  const [He, Ge] = useState(), [Xe, Ke] = useState(), [$e, Je] = useState(), [Ze, nt] = useState(!1), tt = useRef(ue);
  return useEffect(() => {
    tt.current = ue;
  }, [ue]), useEffect(() => {
    (async () => {
      if (!Xe) {
        const { sessionId: rt, token: it } = await getOpentokSession(
          me.token
        ), ot = createSession({
          apiKey: tokboxApiKey,
          sessionId: rt,
          token: it,
          // @ts-ignore
          async onConnect() {
            try {
              Ke(ot);
              const at = await getAndPublishStream(
                ot.session,
                Ue,
                async () => {
                  await startRecorder(me.token);
                }
              );
              Ge(at);
              const st = at.element.querySelector("video");
              if (Je(st.srcObject), BACK_FACING_MODES$1.includes(Ue[0])) {
                const lt = (await navigator.mediaDevices.enumerateDevices()).filter(
                  (At) => At.kind === "videoinput"
                ), dt = await chooseCamera();
                dt !== -1 && await cycleVideo(
                  at,
                  lt[dt].deviceId
                );
              }
              nt(!0), tt.current();
            } catch {
              addEvent({
                code: "videoSelfieCompletedUnsuccessfully",
                token: me.token
              }), Qe(!0);
            }
          }
        });
      }
    })();
  }, [me.token]), useEffect(() => {
    Xe && Xe.session.on("streamDestroyed", () => {
      Ge(void 0);
    });
  }, [Xe]), { publisher: He, sessionHelper: Xe, stream: $e, ready: Ze };
}, getDeviceToUse = async (me, ue) => {
  killStream(userMedia || (ue == null ? void 0 : ue.srcObject), !0);
  const Ue = await getStream(me === "front" ? "user" : "environment");
  return userMedia = Ue, Ue.getVideoTracks()[0].getSettings();
}, KNOWN_CYCLE_UNSUPORTED_DEVICES = [
  "SM-A127M",
  "SM-A127",
  "HUAWEIMAR",
  "SM-A125",
  "SEA-AL00",
  "SM-A135",
  "SM-A137",
  "10; K",
  "SM-G9"
];
async function cycleVideo(me, ue) {
  let Qe;
  do
    Qe = await me.cycleVideo();
  while (ue && Qe.deviceId !== ue);
  return Qe;
}
const switchCamera = async (me, ue, Qe, Ue) => {
  const He = me.element.querySelector("video"), Ge = await getDeviceToUse(ue, He), Xe = navigator.userAgent;
  KNOWN_CYCLE_UNSUPORTED_DEVICES.some(
    ($e) => Xe.includes($e)
  ) ? await me.setVideoSource(Ge.deviceId) : await cycleVideo(me, Ge.deviceId), await sleep(1e3), Ue(!1), screenEvent({
    module: eventModuleNames.videoSelfie,
    code: ue === "back" ? videoSelfieEvents.cameraSwitchToBack : videoSelfieEvents.cameraSwitchToFront,
    token: Qe.token
  });
}, getWebcamObject = (me) => ({
  video: me.element.querySelector("video"),
  getBase64ScreenShot: () => me.getImgData(),
  getFullImage: () => me.getImgData(),
  getCanvas: (ue, Qe) => {
    const Ue = document.createElement("canvas");
    Ue.width = ue, Ue.height = Qe / ue > 2 ? 0.7 * Qe : Qe;
    const He = Ue.getContext("2d");
    return He.clearRect(0, 0, Ue.width, Ue.height), He.drawImage(me.element.querySelector("video"), 0, 0), Ue;
  }
}), VideoRecorder = ({
  onSuccess: me,
  onError: ue,
  token: Qe,
  modules: Ue,
  speechToTextCheck: He,
  numberOfTries: Ge,
  performLiveness: Xe = !1,
  videoSelfieAsSelfie: Ke,
  compareOCREnabled: $e = !1,
  compareIDEnabled: Je = !0,
  compareBackOCREnabled: Ze = !1,
  compareBackIDEnabled: nt = !1,
  questionsCount: tt
}) => {
  const et = BACK_FACING_MODES$1.includes(Ue[0]) ? "back" : "front", rt = useRef(-1), [it, ot] = useState(!1), at = useRef(!1), [st, ut] = useState(), [lt, dt] = useState(!1), [At, pt] = useState(!1), [gt, wt] = useState(!1), [Bt, Tt] = useState(!1), [yt, Ct] = useState(!1), [ht, It] = useState(""), [vt, Et] = useState(0), [bt, Rt] = useState(!1), [St, kt] = useState(et), [jt, Pt] = useState(!1), [Qt, qt] = useState(!1), _t = useRef(), Yt = useRef(), Xt = useRef(emptyFunc), Ut = useRef(defaultEventsCount), Lt = useRef(1), Ot = useRef(1), ft = useRef(1), { t: Dt } = useTranslation(), Mt = useRef(null), Ft = useRef(null), Gt = Dt("videoSelfie.allGood"), zt = Ue[rt.current], { stream: $t, publisher: Ht, sessionHelper: hn, ready: un } = useOpentok(
    Qe,
    () => {
      Jt(), Yt.current = /* @__PURE__ */ new Date();
    },
    Pt,
    Ue
  );
  useEffect(() => {
    addScreenEvent({
      module: eventModuleNames.videoSelfie,
      screen: eventScreenNames.videoSelfieFaceCapture,
      token: Qe.token,
      shouldOpen: !0
    });
  }, []), useEffect(() => {
    if (Ht) {
      const rn = (ln) => {
        ut(ln.audioLevel);
      };
      return Ht.on("audioLevelUpdated", rn), () => {
        Ht.off("audioLevelUpdated", rn);
      };
    }
  }, [Ht]), useInterval(
    () => {
      Et(vt + 1);
    },
    un ? 1e3 : null
  );
  const An = useCallback(
    (...rn) => {
      addEvent({
        code: "videoSelfieCompletedSuccessfully",
        token: Qe.token
      }), me(rn);
    },
    [me, Qe]
  ), mn = useCallback(
    (...rn) => {
      addEvent({
        code: "videoSelfieCompletedUnsuccessfully",
        token: Qe.token
      }), ue(rn);
    },
    [ue, Qe]
  ), En = useCallback(
    async (rn = emptyFunc) => {
      addScreenEvent({
        module: eventModuleNames.videoSelfie,
        screen: eventScreenNames.videoSelfieVideoUpload,
        token: Qe.token,
        shouldOpen: !0
      }), dt(!0), hn.disconnect(), killStream(userMedia || Ht.element.querySelector("video").srcObject), await stopRecorder(Qe.token), addEvent({
        module: eventModuleNames.videoSelfie,
        token: Qe.token,
        code: videoSelfieEvents.videoSelfieVideoUploadInProgress
      }), dt(!1), addScreenEvent({
        module: eventModuleNames.videoSelfie,
        screen: eventScreenNames.videoSelfieVideoUpload,
        token: Qe.token,
        shouldOpen: !1
      }), rn == null || rn();
    },
    [$t, Qe.token]
  ), Jt = useCallback(async () => {
    if (zt && !MODULES_WITH_SAME_CAMERA[zt].includes(Ue[rt.current + 1]) && (Rt(!0), sleep(500)), rt.current++, rt.current >= Ue.length) {
      await En(), qt(!0), await sleep(3e3), qt(!1), An();
      return;
    }
  }, [zt, Ue.length, An, En]), an = ({
    event: rn,
    type: ln
  }) => {
    if (Ut.current[rn] && Ut.current[rn].count === 0) {
      const pn = zt === "front" ? eventScreenNames.videoSelfieFrontIdCapture : eventScreenNames.videoSelfieBackIdCapture, Sn = ln === VideoSelfieMode.selfie ? eventScreenNames.videoSelfieFaceCapture : pn;
      Ut.current[rn].count++, screenEvent({
        module: eventModuleNames.videoSelfie,
        token: Qe.token,
        code: rn,
        screen: Sn
      });
    }
  };
  useEffect(() => {
    if (!un || zt !== "selfie") return;
    const rn = () => {
      screenEvent({
        module: eventModuleNames.videoSelfie,
        screen: eventScreenNames.videoSelfieFaceCapture,
        token: Qe.token,
        code: "getReady"
      }), screenEvent({
        module: eventModuleNames.videoSelfie,
        screen: eventScreenNames.videoSelfieFaceCapture,
        token: Qe.token,
        code: videoSelfieEvents.lookAtCamera
      });
    };
    async function ln(In, Bn) {
      try {
        const Pn = In.getBase64Image();
        It(Dt("videoSelfie.processingSelfie")), at.current = !1;
        const Yn = selfieType, or = await MlWasmJSApi$1.encryptImage(Pn);
        addScreenEvent({
          module: eventModuleNames.videoSelfie,
          screen: eventScreenNames.videoSelfieFaceCapture,
          token: Qe.token,
          shouldOpen: !1
        }), addScreenEvent({
          module: eventModuleNames.videoSelfie,
          screen: eventScreenNames.videoSelfieFaceUploadProgress,
          token: Qe.token,
          shouldOpen: !0
        });
        const mr = await capture({
          token: Qe.token,
          image: or,
          type: Yn,
          encrypted: !0,
          imageType: Ke ? "selfie" : "videoSelfie",
          sendBase64: !0,
          isRetry: !1,
          isSecondId: !1,
          onlyFront: !1,
          faceCoordinates: Bn,
          onProgress: () => {
          }
        });
        if (!(Xe ? mr.confidence < 0.6 : !0)) {
          Ct(!1);
          const Un = new Error("Liveness failed");
          throw Un.cause = {
            data: {
              errorMessage: "liveness-failed"
            }
          }, Un;
        }
        const Mr = await processFace({
          token: Qe.token,
          imageType: Ke ? "selfie" : "videoSelfie"
        });
        if (!(Mr.confidence != null ? Mr.confidence > 0.3 : !0)) {
          Ct(!1);
          const Un = new Error("No match!");
          throw Un.cause = {
            data: {
              errorMessage: "no-match"
            }
          }, Un;
        }
        addScreenEvent({
          module: eventModuleNames.videoSelfie,
          screen: eventScreenNames.videoSelfieFaceUploadProgress,
          token: Qe.token,
          shouldOpen: !1
        }), addScreenEvent({
          module: eventModuleNames.videoSelfie,
          screen: eventScreenNames.videoSelfieFaceUploadSucceeded,
          token: Qe.token,
          shouldOpen: !0
        }), Ct(!1), ot(!0), wt(!0), It(Gt), await sleep(3e3), addScreenEvent({
          module: eventModuleNames.videoSelfie,
          screen: eventScreenNames.videoSelfieFaceUploadSucceeded,
          token: Qe.token,
          shouldOpen: !1
        }), addScreenEvent({
          module: eventModuleNames.videoSelfie,
          screen: eventScreenNames.videoSelfieFrontIdCapture,
          token: Qe.token,
          shouldOpen: !0
        }), ot(!1), Jt();
      } catch (Pn) {
        MlWasmJSApi$1.resetAllPipelines(), ot(!1), Ct(!1), pt(!0), addScreenEvent({
          module: eventModuleNames.videoSelfie,
          screen: eventScreenNames.videoSelfieFaceUploadProgress,
          token: Qe.token,
          shouldOpen: !1
        }), addScreenEvent({
          module: eventModuleNames.videoSelfie,
          screen: eventScreenNames.videoSelfieFaceAttemptFailed,
          token: Qe.token,
          shouldOpen: !0
        });
        const Yn = Pn.response ? Pn.response.data : Dt("notifications.serverError");
        switch ((Yn == null ? void 0 : Yn.errorMessage) || (Yn == null ? void 0 : Yn.message) || (Yn == null ? void 0 : Yn.reason)) {
          case "No faces found on the image":
            It(Dt("notifications.face"));
            break;
          case "BadRequestException: More than one face detected.":
            It(Dt("notifications.multiple"));
            break;
          case "Cropping area goes off the image.":
            It(Dt("notifications.crop"));
            break;
          case "Image in portrait orientation is expected.":
            It(Dt("notifications.portrait"));
            break;
          case "no-match":
            It(Dt("notifications.noMatch"));
            break;
          case "liveness-failed":
            It(Dt("notifications.spoof"));
            break;
          default:
            It(Dt("notifications.error"));
            break;
        }
        const { current: mr } = Lt;
        if (await sleep(3e3), pt(!1), addScreenEvent({
          module: eventModuleNames.videoSelfie,
          screen: eventScreenNames.videoSelfieFaceAttemptFailed,
          token: Qe.token,
          shouldOpen: !1
        }), mr >= Ge) {
          try {
            await processFace({
              token: Qe.token,
              imageType: Ke ? "selfie" : "videoSelfie"
            });
          } catch (lr) {
            MlWasmJSApi$1.resetAllPipelines(), console.error("Error processing face:", lr);
          } finally {
            Jt();
          }
          return;
        }
        addScreenEvent({
          module: eventModuleNames.videoSelfie,
          screen: eventScreenNames.videoSelfieFaceCapture,
          token: Qe.token,
          shouldOpen: !0
        }), It(""), at.current = !0, Sn(), Lt.current = mr + 1;
      }
    }
    const pn = async () => {
      Ft.current = new FaceDetection(), await Ft.current.initialize({
        onNoFace: () => {
          Ct(!1), It("");
        },
        onCaptureFace: emptyFunc,
        onTooManyFaces: () => {
          It(Dt("notifications.tooManyFaces"));
        },
        onTooClose: () => {
          It(Dt("notifications.moveAway"));
        },
        onCenterFace: () => {
          It(Dt("notifications.centerFace"));
        },
        onFarAway: () => {
          an({
            event: videoSelfieEvents.moveCloser,
            type: VideoSelfieMode.selfie
          }), It(Dt("notifications.moveCloser"));
        },
        onCapturing: () => {
          Ct(!0), It(Dt("notifications.getReady"));
        },
        onBlur: () => {
          an({
            event: videoSelfieEvents.imageTooBlurry,
            type: VideoSelfieMode.selfie
          }), It(Dt("notifications.onBlur"));
        },
        onDark: () => {
          It(Dt("notifications.onDark"));
        },
        onFaceAngle: () => {
          It(Dt("notifications.onFaceAngle"));
        },
        onHeadWear: emptyFunc,
        onLenses: emptyFunc,
        onEyesClosed: emptyFunc,
        onFaceMask: emptyFunc,
        onSwitchToManualCapture: emptyFunc,
        onCapture: throttle$1(ln, 1e3),
        isLensesCheckEnabled: !1,
        isMaskCheckEnabled: !1,
        isClosedEyesCheckEnabled: !1,
        isHeadWearCheckEnabled: !1,
        isVideoSelfie: !0,
        pipelineProfile: detectionSetup.getProfile(DetectionType.Selfie),
        autocaptureTimeout: -1
      });
    };
    async function Sn() {
      if (rn(), await sleep(timeoutSleep), !!at.current) {
        Ft.current || await pn();
        try {
          await MlWasmJSApi$1.handleDetectionCallAndUpdateState(
            detectionSetup.getProfile(DetectionType.Selfie).pipelineType
          );
          const In = getWebcamObject(Ht), Bn = In.video.videoWidth, Pn = In.video.videoHeight, Yn = new IncodeCanvas(In.getCanvas(Bn, Pn));
          await Ft.current.detect(Yn);
        } catch (In) {
          console.error(In);
        }
        Sn();
      }
    }
    at.current || (at.current = !0, Sn());
  }, [
    un,
    zt,
    Dt,
    Qe.token,
    Gt,
    Jt,
    Ge,
    mn,
    En,
    Xe,
    Ke
  ]), useEffect(() => {
    const rn = async (ln, pn = "front") => {
      pn === "front" ? ft.current = 1 : Ot.current = 1, addScreenEvent({
        module: eventModuleNames.videoSelfie,
        screen: pn === "front" ? eventScreenNames.videoSelfieFrontIdUploadProgress : eventScreenNames.videoSelfieBackIdUploadProgress,
        token: Qe.token,
        shouldOpen: !1
      }), addScreenEvent({
        module: eventModuleNames.videoSelfie,
        screen: pn === "front" ? eventScreenNames.videoSelfieFrontIdAttemptFailed : eventScreenNames.videoSelfieBackIdAttemptFailed,
        token: Qe.token,
        shouldOpen: !0
      }), ot(!1), pt(!0), It(ln);
      const { current: Sn } = Ot, { current: In } = ft;
      if (await sleep(3e3), pt(!1), addScreenEvent({
        module: eventModuleNames.videoSelfie,
        screen: pn === "front" ? eventScreenNames.videoSelfieFrontIdAttemptFailed : eventScreenNames.videoSelfieBackIdAttemptFailed,
        token: Qe.token,
        shouldOpen: !1
      }), Sn >= 3 || In >= 3) {
        await En(), mn(ln);
        return;
      }
      addScreenEvent({
        module: eventModuleNames.videoSelfie,
        screen: pn === "front" ? eventScreenNames.videoSelfieFrontIdCapture : eventScreenNames.videoSelfieBackIdCapture,
        token: Qe.token,
        shouldOpen: !0
      }), It(""), dn(), pn === "front" ? Ot.current = Sn + 1 : ft.current = In + 1;
    };
    Xt.current = async (ln) => {
      if (!["front", "back"].includes(ln))
        return;
      at.current = !1, addScreenEvent({
        module: eventModuleNames.videoSelfie,
        screen: ln === "front" ? eventScreenNames.videoSelfieFrontIdCapture : eventScreenNames.videoSelfieBackIdCapture,
        token: Qe.token,
        shouldOpen: !1
      }), addScreenEvent({
        module: eventModuleNames.videoSelfie,
        screen: ln === "front" ? eventScreenNames.videoSelfieFrontIdUploadProgress : eventScreenNames.videoSelfieBackIdUploadProgress,
        token: Qe.token,
        shouldOpen: !0
      }), window.cancelAnimationFrame(_t.current), ot(!0);
      const pn = Ht.getImgData();
      if (ln === "front" && ($e || Je)) {
        ot(!0);
        const Sn = $e ? compareOCR({
          token: Qe.token,
          image: pn
        }) : Promise.resolve({ success: !0 }), In = Je ? compareID({
          token: Qe.token,
          image: pn
        }) : Promise.resolve({
          faceRecognitionConfidence: 1,
          idTypeMatched: !0
        }), [Bn, Pn] = await Promise.allSettled([Sn, In]);
        if (Bn.status === "rejected" || Pn.status === "rejected" || !Pn.value.idTypeMatched) {
          MlWasmJSApi$1.resetAllPipelines(), rn(Dt("notifications.compareID.scanFailed"));
          return;
        }
        if (Pn.value.faceRecognitionConfidence !== 1) {
          MlWasmJSApi$1.resetAllPipelines(), rn(Dt("notifications.compareID.photoVerificationFailed"));
          return;
        }
        if (!Bn.value.success) {
          MlWasmJSApi$1.resetAllPipelines(), rn(Dt("notifications.compareID.nameVerificationFailed"));
          return;
        }
      } else if (ln === "back" && (nt || Ze)) {
        ot(!0);
        const Sn = nt ? compareBackID({
          token: Qe.token,
          image: pn
        }) : Promise.resolve({ idTypeMatched: !0, idSideMatched: !0 }), In = Ze ? compareBackOCR({
          token: Qe.token,
          image: pn
        }) : Promise.resolve({ success: !0 }), [Bn, Pn] = await Promise.allSettled([
          Sn,
          In
        ]);
        if (Bn.status === "rejected" || Pn.status === "rejected" || !Bn.value.idTypeMatched || !Bn.value.idSideMatched || Pn.value.success === !1 || Bn.value.success === !1) {
          MlWasmJSApi$1.resetAllPipelines(), rn(Dt("notifications.compareID.scanFailed"), "back");
          return;
        }
      } else ["back", "front"].includes(ln) && (ot(!0), await sleep(3e3), ot(!1));
      addScreenEvent({
        module: eventModuleNames.videoSelfie,
        screen: ln === "front" ? eventScreenNames.videoSelfieFrontIdUploadProgress : eventScreenNames.videoSelfieBackIdUploadProgress,
        token: Qe.token,
        shouldOpen: !1
      }), addScreenEvent({
        module: eventModuleNames.videoSelfie,
        screen: ln === "front" ? eventScreenNames.videoSelfieFrontIdUploadSucceeded : eventScreenNames.videoSelfieBackIdUploadSucceeded,
        token: Qe.token,
        shouldOpen: !0
      }), ot(!1), Tt(!0), It(Gt), await sleep(3e3), It(""), Tt(!1), addScreenEvent({
        module: eventModuleNames.videoSelfie,
        screen: ln === "front" ? eventScreenNames.videoSelfieFrontIdUploadSucceeded : eventScreenNames.videoSelfieBackIdUploadSucceeded,
        token: Qe.token,
        shouldOpen: !1
      }), ln === "front" && Ue.includes("back") && addScreenEvent({
        module: eventModuleNames.videoSelfie,
        screen: eventScreenNames.videoSelfieBackIdCapture,
        token: Qe.token,
        shouldOpen: !0
      }), Jt(), addEvent({
        code: ln === "front" ? "videoSelfieIdFrontDetected" : "videoSelfieIdBackDetected",
        token: Qe.token
      });
    };
  }, [zt, Jt, Qe.token, Ht]);
  const cn = async () => {
    Mt.current = new IdVideoSelfie(), await Mt.current.initialize({
      onCapturing: throttle$1(Xt.current, 1e3),
      onFarAway: () => {
        an({
          event: videoSelfieEvents.fillFrame,
          type: VideoSelfieMode.captureId
        });
      },
      onGlare: () => {
        an({
          event: videoSelfieEvents.checkCameraOrLighting,
          type: VideoSelfieMode.captureId
        });
      },
      onBlur: () => {
        an({
          event: videoSelfieEvents.imageTooBlurry,
          type: VideoSelfieMode.captureId
        });
      },
      onIDNotDetected: emptyFunc,
      onMaskChange: emptyFunc,
      onDetectionStarted: () => {
      },
      onSwitchToManualCapture: emptyFunc,
      onIDTypeChange: emptyFunc,
      idType: "null",
      isFixedMask: !1,
      isBlurCheckEnabled: !1,
      isGlareCheckEnabled: !1,
      pipelineProfile: detectionSetup.getProfile(DetectionType.IdVideoSelfie),
      autocaptureTimeout: -1
    });
  }, dn = useCallback(() => {
    const rn = async () => {
      if (at.current) {
        Mt.current || await cn();
        try {
          await MlWasmJSApi$1.handleDetectionCallAndUpdateState(
            detectionSetup.getProfile(DetectionType.IdVideoSelfie).pipelineType
          ), Mt.current.updateCurrentMode(
            Ue[rt.current]
          );
          const ln = getWebcamObject(Ht), pn = ln.video.videoWidth, Sn = ln.video.videoHeight, In = new IncodeCanvas(ln.getCanvas(pn, Sn));
          await Mt.current.detect(In);
        } catch (ln) {
          console.error(ln);
        }
        await sleep(1e3), _t.current = window.requestAnimationFrame(rn);
      }
    };
    at.current || (at.current = !0, _t.current = window.requestAnimationFrame(rn));
  }, [Ht]);
  useEffect(() => {
    un && (zt === "front" || zt === "back") && (Ut.current = defaultEventsCount, zt === "front" && an({
      event: videoSelfieEvents.frontIdCaptureStarted,
      type: VideoSelfieMode.captureId
    }), screenEvent({
      module: eventModuleNames.videoSelfie,
      screen: zt === "front" ? eventScreenNames.videoSelfieFrontIdCapture : eventScreenNames.videoSelfieBackIdCapture,
      code: zt === "front" ? videoSelfieEvents.lookingForFrontId : videoSelfieEvents.lookingForBackId,
      token: Qe.token
    }), sleep(3e3).then(() => {
      dn();
    }));
  }, [un, zt, dn]), useEffect(() => {
    if (!un) return;
    const rn = ["poa", "front", "back"].includes(zt) ? "back" : "front";
    St !== rn && (switchCamera(Ht, rn, Qe, Rt), kt(rn));
  }, [zt]);
  async function yn(rn) {
    rn ? (rt.current++, qt(!0), sleep(3e3).then(() => {
      An();
    })) : mn();
  }
  function Nn() {
    addEvent({
      code: "videoSelfiePoaScanned",
      token: Qe.token
    }), Jt();
  }
  function Rn() {
    Jt();
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Container$4, { className: "IncodeVideoRecorderContainer", children: [
    jt && /* @__PURE__ */ jsxRuntimeExports.jsx(ConsentInstructions, { interviewID: Qe.interviewId }),
    !un && /* @__PURE__ */ jsxRuntimeExports.jsx(RecordConsent, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StepsHeader, { modules: Ue, modeIndex: rt.current }),
    bt && zt && /* @__PURE__ */ jsxRuntimeExports.jsxs(SwitchingCameraMask, { className: "IncodeRecorderSwitchCamera", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: cameraRotate, alt: "rotate" }),
      ["selfie", "speech", "questions"].includes(zt) ? Dt("videoSelfie.switchingToFront") : Dt("videoSelfie.switchingToBack")
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        id: "opentok-container-vs",
        className: `${["selfie", "questions", "speech"].includes(zt) && "mirrored"}`
      }
    ),
    ["selfie"].includes(zt) && !bt && /* @__PURE__ */ jsxRuntimeExports.jsx(
      SelfieMask,
      {
        isSuccessful: gt,
        error: At,
        isCapturing: it,
        notification: ht,
        isLoading: yt
      }
    ),
    ["front", "back"].includes(zt) && !bt && /* @__PURE__ */ jsxRuntimeExports.jsx(
      IdMask,
      {
        isSuccess: Bt,
        isError: At,
        isCapturing: it,
        message: ht,
        mode: zt
      }
    ),
    zt === "poa" && !bt && /* @__PURE__ */ jsxRuntimeExports.jsx(ProofOfAddress, { onNext: Nn, token: Qe.token }),
    zt === "questions" && !bt && /* @__PURE__ */ jsxRuntimeExports.jsx(
      QuestionsContainer,
      {
        onNext: Rn,
        token: Qe.token,
        sound: st,
        questionsCount: tt
      }
    ),
    zt === "speech" && !bt && /* @__PURE__ */ jsxRuntimeExports.jsx(
      SpeechMask,
      {
        onNext: yn,
        speechToTextCheck: He,
        stopRecording: En,
        stream: $t,
        token: Qe,
        numberOfTries: Ge,
        sound: st
      }
    ),
    Qt && /* @__PURE__ */ jsxRuntimeExports.jsx(EndScreen, {}),
    lt && /* @__PURE__ */ jsxRuntimeExports.jsx(Processing$1, {})
  ] });
}, VideoRecorder$1 = preloadScript(VideoRecorder);
function RecordConsent() {
  const { t: me } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    RecordConsentContainer,
    {
      className: "IncodeRecorderConsentContainer",
      "aria-live": "assertive",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: me("videoSelfie.recordConsentReasons") }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "consentAllow", children: me("videoSelfie.recordConsentAllow") }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(SpinImage, { src: spinner, alt: "loading", className: "inverted" })
      ]
    }
  );
}
const notificationMessages = {
  "No faces found on the image": "notifications.face",
  "BadRequestException: More than one face detected.": "notifications.multiple",
  "Cropping area goes off the image.": "notifications.crop",
  "Image in portrait orientation is expected.": "notifications.portrait",
  "no-match": "notifications.noMatch",
  "liveness-failed": "notifications.spoof"
};
function getErrorKey(me) {
  return notificationMessages[me] || "notifications.error";
}
async function faceCapture({
  encryptedImage: me,
  session: ue,
  t: Qe,
  videoSelfieAsSelfie: Ue,
  faceCoordinates: He,
  performLiveness: Ge
}) {
  var Xe;
  addScreenEvent({
    module: eventModuleNames.videoSelfie,
    screen: eventScreenNames.videoSelfieFaceCapture,
    token: ue.token,
    shouldOpen: !1
  }), addScreenEvent({
    module: eventModuleNames.videoSelfie,
    screen: eventScreenNames.videoSelfieFaceUploadProgress,
    token: ue.token,
    shouldOpen: !0
  });
  try {
    const Ke = await capture({
      token: ue.token,
      image: me,
      type: "selfie",
      encrypted: !0,
      imageType: Ue ? "selfie" : "videoSelfie",
      sendBase64: !0,
      isRetry: !1,
      isSecondId: !1,
      onlyFront: !1,
      faceCoordinates: He,
      onProgress: () => {
      }
    });
    if (!(Ge ? Ke.confidence < 0.6 : !0)) {
      const et = new Error("Liveness failed");
      throw et.cause = {
        data: {
          errorMessage: "liveness-failed"
        }
      }, et;
    }
    if (!(((await processFace({
      token: ue.token,
      imageType: Ue ? "selfie" : "videoSelfie"
    })).confidence ?? 1) > 0.3)) {
      const et = new Error("No match!");
      throw et.cause = {
        data: {
          errorMessage: "no-match"
        }
      }, et;
    }
    addScreenEvent({
      module: eventModuleNames.videoSelfie,
      screen: eventScreenNames.videoSelfieFaceUploadProgress,
      token: ue.token,
      shouldOpen: !1
    }), addScreenEvent({
      module: eventModuleNames.videoSelfie,
      screen: eventScreenNames.videoSelfieFaceUploadSucceeded,
      token: ue.token,
      shouldOpen: !0
    });
  } catch (Ke) {
    addScreenEvent({
      module: eventModuleNames.videoSelfie,
      screen: eventScreenNames.videoSelfieFaceUploadProgress,
      token: ue.token,
      shouldOpen: !1
    }), addScreenEvent({
      module: eventModuleNames.videoSelfie,
      screen: eventScreenNames.videoSelfieFaceAttemptFailed,
      token: ue.token,
      shouldOpen: !0
    });
    const $e = ((Xe = Ke.response) == null ? void 0 : Xe.data) ?? Qe("notifications.serverError"), Je = ($e == null ? void 0 : $e.errorMessage) ?? ($e == null ? void 0 : $e.message) ?? ($e == null ? void 0 : $e.reason), Ze = getErrorKey(Je);
    throw new Error(Qe(Ze));
  }
}
const useDetectSelfie = ({ webcam: me, numberOfTries: ue }, Qe) => {
  const [Ue, He] = useState(""), [Ge, Xe] = useState("idle"), Ke = useRef(1), $e = useRef(!0), Je = useRef(!1), Ze = useRef(null), { t: nt } = useTranslation();
  async function tt(rt, it) {
    $e.current = !1, MlWasmJSApi$1.resetAllPipelines();
    try {
      const ot = rt.getBase64Image();
      Xe("loading"), He(nt("videoSelfie.processingSelfie"));
      const at = await MlWasmJSApi$1.encryptImage(ot);
      await Qe.onCapturing({ encryptedImage: at, faceCoordinates: it }), Xe("capturing"), He(nt("videoSelfie.allGood")), await sleep(3e3), Xe("success"), Qe.onSuccessfulCapture();
    } catch (ot) {
      if (Xe("error"), He(ot.message), await sleep(3e3), Xe("idle"), He(""), Ke.current === ue) {
        await Qe.onNoAttemptsLeft();
        return;
      }
      Ke.current += 1, $e.current = !0;
    }
  }
  const et = useCallback(async () => {
    Ze.current = new FaceDetection(), await Ze.current.initialize({
      onNoFace: () => {
        Xe("idle"), He("");
      },
      onCaptureFace: emptyFunc,
      onTooManyFaces: () => {
        He(nt("notifications.tooManyFaces"));
      },
      onTooClose: () => {
        He(nt("notifications.moveAway"));
      },
      onCenterFace: () => {
        He(nt("notifications.centerFace"));
      },
      onFarAway: () => {
        He(nt("notifications.moveCloser"));
      },
      onCapturing: () => {
        Xe("loading"), He(nt("notifications.getReady"));
      },
      onBlur: () => {
        He(nt("notifications.onBlur"));
      },
      onDark: () => {
        He(nt("notifications.onDark"));
      },
      onFaceAngle: () => {
        He(nt("notifications.onFaceAngle"));
      },
      onHeadWear: emptyFunc,
      onLenses: emptyFunc,
      onEyesClosed: emptyFunc,
      onFaceMask: emptyFunc,
      onSwitchToManualCapture: emptyFunc,
      onCapture: throttle$1(tt, 1e3),
      isLensesCheckEnabled: !1,
      isMaskCheckEnabled: !1,
      isClosedEyesCheckEnabled: !1,
      isHeadWearCheckEnabled: !1,
      isVideoSelfie: !0,
      pipelineProfile: detectionSetup.getProfile(DetectionType.Selfie),
      autocaptureTimeout: -1
    });
  }, [nt]);
  return useEffect(() => {
    const rt = async () => {
      if (!(!$e.current || Je.current)) {
        Je.current = !0, Ze.current || await et();
        try {
          await MlWasmJSApi$1.handleDetectionCallAndUpdateState(
            detectionSetup.getProfile(DetectionType.Selfie).pipelineType
          );
          const it = me.getCanvas();
          if (!it)
            return;
          await Ze.current.detect(it);
        } catch (it) {
          console.error(it);
        } finally {
          Je.current = !1;
        }
      }
    };
    return onFrameEmitter.on("newFrame", rt), () => {
      onFrameEmitter.off("newFrame", rt);
    };
  }, [me, et]), {
    status: Ge,
    notification: Ue
  };
}, SelfieCapture = ({ onNext: me, webcam: ue, session: Qe, config: Ue, onError: He }) => {
  const { t: Ge } = useTranslation(), { status: Xe, notification: Ke } = useDetectSelfie(
    { webcam: ue, numberOfTries: Ue.numberOfTries },
    {
      onCapturing: async ({ encryptedImage: tt, faceCoordinates: et }) => {
        await faceCapture({
          encryptedImage: tt,
          session: Qe,
          t: Ge,
          videoSelfieAsSelfie: Ue.videoSelfieAsSelfie,
          faceCoordinates: et,
          performLiveness: Ue.performLiveness
        });
      },
      onSuccessfulCapture: () => {
        addScreenEvent({
          module: eventModuleNames.videoSelfie,
          screen: eventScreenNames.videoSelfieFaceUploadSucceeded,
          token: Qe.token,
          shouldOpen: !1
        }), addScreenEvent({
          module: eventModuleNames.videoSelfie,
          screen: eventScreenNames.videoSelfieFrontIdCapture,
          token: Qe.token,
          shouldOpen: !0
        }), me();
      },
      onNoAttemptsLeft: async () => {
        await processFace({
          token: Qe.token,
          imageType: Ue.videoSelfieAsSelfie ? "selfie" : "videoSelfie"
        }), He(Ge("videoSelfie.noAttemptsLeft"));
      }
    }
  ), $e = Xe === "capturing" || Xe === "success", Je = Xe === "loading", Ze = Xe === "error", nt = Xe === "success";
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    SelfieMask,
    {
      isCapturing: $e,
      isLoading: Je,
      error: Ze,
      isSuccessful: nt,
      notification: Ke
    }
  );
};
let OV = null;
const useOpenVidu = ({ token: me }) => {
  const [ue, Qe] = useState(!1), Ue = useRef(null), He = useRef(null);
  return { isRecording: ue, publishAndStartRecording: async (Ke) => {
    OV = OV ?? new lib$1.OpenVidu();
    const $e = Ke.getVideoTracks()[0], Je = Ke.getAudioTracks()[0];
    if (Ue.current) {
      await Ue.current.replaceTrack(Ke.getVideoTracks()[0]), await Ue.current.replaceTrack(Ke.getAudioTracks()[0]);
      return;
    }
    const Ze = OV.initSession(), nt = await getOpenViduSession({ token: me });
    await Ze.connect(nt.token);
    const tt = OV.initPublisher(null, {
      videoSource: $e,
      audioSource: Je
    }), et = $e.getSettings();
    await Ze.publish(tt), await startRecordingOpenVidu({
      videoRecordingId: nt.videoRecordingId,
      token: me,
      resolution: `${et.width}x${et.height}`
    }), Qe(!0), Ue.current = tt, He.current = Ze;
  }, stopRecording: async () => {
    !Ue.current || !He.current || (await He.current.unpublish(Ue.current), await stopRecorderOpenVidu({ token: me }), Qe(!1));
  } };
}, VideoSelfieContainer = qe.div`
  height: 100%;
`, components = {
  front: (me) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    VideoSelfieIdCapture,
    {
      onSuccessfulCapture: me.onSuccess,
      webcam: me.webcam,
      mode: "front",
      session: me.session,
      config: {
        shouldCompareOCR: me.config.compareOCREnabled,
        shouldCompareID: me.config.compareIDEnabled,
        numberOfTries: me.config.numberOfTries
      },
      onError: me.onError
    }
  ),
  back: (me) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    VideoSelfieIdCapture,
    {
      onSuccessfulCapture: me.onSuccess,
      webcam: me.webcam,
      mode: "back",
      session: me.session,
      config: {
        shouldCompareOCR: me.config.compareOCREnabled,
        shouldCompareID: me.config.compareIDEnabled,
        numberOfTries: me.config.numberOfTries
      },
      onError: me.onError
    }
  ),
  poa: (me) => /* @__PURE__ */ jsxRuntimeExports.jsx(ProofOfAddress, { onNext: me.onSuccess, token: me.session.token }),
  selfie: (me) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    SelfieCapture,
    {
      onNext: me.onSuccess,
      token: me.session.token,
      webcam: me.webcam,
      session: me.session,
      onError: me.onError,
      config: {
        numberOfTries: me.config.numberOfTries,
        videoSelfieAsSelfie: me.config.videoSelfieAsSelfie,
        performLiveness: me.config.performLiveness
      }
    }
  ),
  questions: (me) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    QuestionsContainer,
    {
      onNext: me.onSuccess,
      token: me.session.token,
      questionsCount: me.config.questionsCount,
      sound: 0
    }
  ),
  speech: (me) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    SpeechMask,
    {
      onNext: me.onFinished,
      speechToTextCheck: me.config.speechToTextCheck,
      stopRecording: me.stopRecording,
      stream: me.stream,
      token: me.session,
      numberOfTries: me.config.numberOfTries,
      sound: 0
    }
  )
}, BACK_FACING_MODES = ["front", "back", "poa"], getVideoSource = (me) => BACK_FACING_MODES.includes(me) ? "environment" : "user", OpenViduVideoSelfie = ({
  token: me,
  modules: ue,
  numberOfTries: Qe,
  questionsCount: Ue,
  speechToTextCheck: He,
  onSuccess: Ge,
  onError: Xe,
  compareIDEnabled: Ke,
  compareOCREnabled: $e,
  compareBackIDEnabled: Je,
  compareBackOCREnabled: Ze,
  performLiveness: nt,
  videoSelfieAsSelfie: tt
}) => {
  const [et, rt] = useState(!1), [it, ot] = useState(
    "idle"
  ), [at, st] = useState(null), { currentStep: ut, nextStep: lt, setStep: dt } = useSteps(0), { publishAndStartRecording: At, stopRecording: pt } = useOpenVidu({
    token: me.token
  });
  useEffect(() => {
    addScreenEvent({
      module: eventModuleNames.videoSelfie,
      screen: eventScreenNames.videoSelfieFaceCapture,
      token: me.token,
      shouldOpen: !0
    });
  }, [me.token]), useEffect(() => {
    ue.includes("speech") || ut === ue.length && wt(() => Bt(!0));
  }, [ut, ue]);
  const gt = async (ht) => {
    rt(!1), await At(ht), rt(!0);
  }, wt = async (ht = emptyFunc) => {
    dt(ue.length), ot("processing"), await pt(), ht();
  };
  async function Bt(ht) {
    ht ? (ot("finished"), await sleep(3e3), Ge()) : Xe();
  }
  const Tt = ue[ut], yt = components[Tt] || (() => null), Ct = getVideoSource(Tt);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(VideoSelfieContainer, { children: [
    !et && /* @__PURE__ */ jsxRuntimeExports.jsx(RecordConsent, {}),
    !!Tt && /* @__PURE__ */ jsxRuntimeExports.jsx(
      Webcam,
      {
        onError: Xe,
        videoSource: Ct,
        onStreamReady: gt,
        ref: (ht) => {
          if (ht) {
            if (!at) {
              st(ht);
              return;
            }
            at.stream !== ht.stream && st(ht);
          }
        },
        publishAudio: !0,
        isSelfie: Ct === "user",
        fullHeight: Ct === "user"
      },
      Ct
    ),
    it === "processing" && /* @__PURE__ */ jsxRuntimeExports.jsx(Processing$1, {}),
    it === "finished" && /* @__PURE__ */ jsxRuntimeExports.jsx(EndScreen, {}),
    et && at ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(StepsHeader, { modules: ue, modeIndex: ut }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        yt,
        {
          webcam: at,
          onSuccess: lt,
          session: me,
          stopRecording: wt,
          stream: at == null ? void 0 : at.stream,
          onFinished: Bt,
          onError: (ht) => {
            wt(() => Xe(ht));
          },
          config: {
            compareIDEnabled: Ke,
            compareOCREnabled: $e,
            compareBackIDEnabled: Je,
            compareBackOCREnabled: Ze,
            speechToTextCheck: He,
            questionsCount: Ue,
            numberOfTries: Qe,
            performLiveness: nt,
            videoSelfieAsSelfie: tt
          }
        }
      )
    ] }) : null
  ] });
}, captureFaceImg = "data:image/svg+xml,%3csvg%20width='64'%20height='64'%20viewBox='0%200%2064%2064'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M36%2054.3077V13.6923C36%2011.6531%2034.3211%2010%2032.25%2010L9.75%2010C7.67893%2010%206%2011.6531%206%2013.6923L6%2054.3077C6%2056.3469%207.67893%2058%209.75%2058H32.25C34.3211%2058%2036%2056.3469%2036%2054.3077Z'%20fill='%23E9E9EB'/%3e%3cpath%20d='M36%2054.3077V13.6923C36%2011.6531%2034.3211%2010%2032.25%2010L9.75%2010C7.67893%2010%206%2011.6531%206%2013.6923L6%2054.3077C6%2056.3469%207.67893%2058%209.75%2058H32.25C34.3211%2058%2036%2056.3469%2036%2054.3077Z'%20stroke='%2320263D'%20stroke-width='3'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M17%2053.5C17%2052.6716%2017.6716%2052%2018.5%2052H23.5C24.3284%2052%2025%2052.6716%2025%2053.5C25%2054.3284%2024.3284%2055%2023.5%2055H18.5C17.6716%2055%2017%2054.3284%2017%2053.5Z'%20fill='%2320263D'/%3e%3crect%20x='25.5'%20y='1.5'%20width='37'%20height='37'%20rx='18.5'%20fill='%23E9E9EB'/%3e%3crect%20x='25.5'%20y='1.5'%20width='37'%20height='37'%20rx='18.5'%20stroke='%2320263D'%20stroke-width='3'/%3e%3cpath%20d='M50%2018.6667L54%2016V24L50%2021.3333'%20stroke='%2320263D'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M49.3182%2015H35.6818C35.3053%2015%2035%2015.2798%2035%2015.625V24.375C35%2024.7202%2035.3053%2025%2035.6818%2025H49.3182C49.6947%2025%2050%2024.7202%2050%2024.375V15.625C50%2015.2798%2049.6947%2015%2049.3182%2015Z'%20stroke='%2320263D'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", addressIcon = "data:image/svg+xml,%3csvg%20width='44'%20height='44'%20viewBox='0%200%2044%2044'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1'%20y='1'%20width='42'%20height='42'%20rx='11'%20stroke='%23E9E9EB'%20stroke-width='2'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M22.5548%209.16795C22.2189%208.94402%2021.7813%208.94402%2021.4454%209.16795L9.46156%2017.1571C9.38484%2017.2061%209.31392%2017.2662%209.25135%2017.3371C9.20878%2017.3852%209.17107%2017.4371%209.13865%2017.4921C9.0432%2017.6535%208.9981%2017.8329%209.00006%2018.0103V31C9.00006%2031.5304%209.21077%2032.0391%209.58585%2032.4142C9.96092%2032.7893%2010.4696%2033%2011.0001%2033H33.0001C33.5305%2033%2034.0392%2032.7893%2034.4143%2032.4142C34.7894%2032.0391%2035.0001%2031.5304%2035.0001%2031V18.0131C35.0026%2017.826%2034.9529%2017.6366%2034.847%2017.4683C34.8226%2017.4294%2034.7955%2017.3922%2034.7658%2017.3568C34.699%2017.2771%2034.6219%2017.2102%2034.5378%2017.1566L22.5548%209.16795ZM32.2388%2018.0277L22.0001%2011.2019L11.7613%2018.0277L20.1382%2024.0001H23.862L32.2388%2018.0277ZM11.0001%2019.9412V30.0048L18.0905%2024.9964L11.0001%2019.9412ZM20.1361%2026.0001L13.0577%2031H30.9426L23.8642%2026.0001H20.1361ZM25.9097%2024.9964L33.0001%2030.0047V19.9412L25.9097%2024.9964Z'%20fill='%2320263D'/%3e%3c/svg%3e", backIdIcon = "data:image/svg+xml,%3csvg%20width='44'%20height='44'%20viewBox='0%200%2044%2044'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1'%20y='1'%20width='42'%20height='42'%20rx='11'%20stroke='%23E9E9EB'%20stroke-width='2'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M11%2011C9.89543%2011%209%2011.8954%209%2013V31C9%2032.1046%209.89543%2033%2011%2033H33C34.1046%2033%2035%2032.1046%2035%2031V13C35%2011.8954%2034.1046%2011%2033%2011H11ZM11%2013H33V31H11V13ZM13%2016H15V19H13V16ZM17%2016H21V19H17V16ZM31%2016H24V19H31V16ZM15.5%2016H16.5V19H15.5V16ZM23%2016H22V19H23V16ZM13%2027C13%2026.4477%2013.4477%2026%2014%2026H19C19.5523%2026%2020%2026.4477%2020%2027C20%2027.5523%2019.5523%2028%2019%2028H14C13.4477%2028%2013%2027.5523%2013%2027Z'%20fill='%2320263D'/%3e%3c/svg%3e", permissionIcon = "data:image/svg+xml,%3csvg%20width='44'%20height='44'%20viewBox='0%200%2044%2044'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1'%20y='1'%20width='42'%20height='42'%20rx='11'%20stroke='%23E9E9EB'%20stroke-width='2'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M13%2014C13%2012.3431%2014.3431%2011%2016%2011C17.6569%2011%2019%2012.3431%2019%2014C19%2015.6569%2017.6569%2017%2016%2017C14.3431%2017%2013%2015.6569%2013%2014ZM19.2688%2017.7836C20.3291%2016.8668%2021%2015.5117%2021%2014C21%2011.2386%2018.7614%209%2016%209C13.2386%209%2011%2011.2386%2011%2014C11%2015.5117%2011.6709%2016.8668%2012.7312%2017.7836C12.4728%2017.9138%2012.2204%2018.0597%2011.9752%2018.2209C10.7604%2019.0197%209.76848%2020.1648%209.10624%2021.533C8.86984%2022.0213%209.04119%2022.6263%209.48896%2022.8841C9.93673%2023.142%2010.4914%2022.9551%2010.7278%2022.4667C11.2342%2021.4203%2011.9928%2020.5445%2012.9219%2019.9337C13.8461%2019.326%2014.904%2019.0033%2015.9829%2019C15.9886%2019%2015.9943%2019%2016%2019C16.0057%2019%2016.0114%2019%2016.0171%2019C17.096%2019.0033%2018.1539%2019.326%2019.0781%2019.9337C20.0072%2020.5446%2020.7658%2021.4203%2021.2722%2022.4667C21.5086%2022.9551%2022.0633%2023.142%2022.511%2022.8841C22.9588%2022.6263%2023.1302%2022.0214%2022.8938%2021.533C22.2315%2020.1648%2021.2396%2019.0197%2020.0248%2018.2209C19.7796%2018.0597%2019.5272%2017.9138%2019.2688%2017.7836Z'%20fill='%2320263D'/%3e%3cpath%20d='M30.5%2025L26.8333%2028.5L25%2026.75'%20stroke='%2320263D'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M27.5%2033C31.0899%2033%2034%2030.0899%2034%2026.5C34%2022.9101%2031.0899%2020%2027.5%2020C23.9101%2020%2021%2022.9101%2021%2026.5C21%2030.0899%2023.9101%2033%2027.5%2033Z'%20stroke='%2320263D'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", questionIcon = "data:image/svg+xml,%3csvg%20width='44'%20height='44'%20viewBox='0%200%2044%2044'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1'%20y='1'%20width='42'%20height='42'%20rx='11'%20stroke='%23E9E9EB'%20stroke-width='2'/%3e%3cg%20clip-path='url(%23clip0_8374_20039)'%3e%3cg%20clip-path='url(%23clip1_8374_20039)'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M13.526%2010.1494C13.8208%2010.3316%2014.0003%2010.6534%2014.0003%2011V19C14.0003%2019.5523%2013.5526%2020%2013.0003%2020C12.448%2020%2012.0003%2019.5523%2012.0003%2019V12.618L11.4475%2012.8944C10.9535%2013.1414%2010.3528%2012.9412%2010.1058%2012.4472C9.85886%2011.9532%2010.0591%2011.3526%2010.5531%2011.1056L12.5531%2010.1056C12.863%209.95058%2013.2312%209.96714%2013.526%2010.1494ZM18.0003%2014C18.0003%2013.4477%2018.448%2013%2019.0003%2013H33.0003C33.5526%2013%2034.0003%2013.4477%2034.0003%2014C34.0003%2014.5523%2033.5526%2015%2033.0003%2015H19.0003C18.448%2015%2018.0003%2014.5523%2018.0003%2014ZM18.0003%2022C18.0003%2021.4477%2018.448%2021%2019.0003%2021H33.0003C33.5526%2021%2034.0003%2021.4477%2034.0003%2022C34.0003%2022.5523%2033.5526%2023%2033.0003%2023H19.0003C18.448%2023%2018.0003%2022.5523%2018.0003%2022ZM19.0003%2029C18.448%2029%2018.0003%2029.4477%2018.0003%2030C18.0003%2030.5523%2018.448%2031%2019.0003%2031H33.0003C33.5526%2031%2034.0003%2030.5523%2034.0003%2030C34.0003%2029.4477%2033.5526%2029%2033.0003%2029H19.0003ZM15.5687%2024.4581C15.362%2024.1184%2015.089%2023.8239%2014.7661%2023.592C14.1197%2023.1216%2013.3165%2022.9193%2012.5243%2023.0275C11.7306%2023.136%2011.0098%2023.5477%2010.5131%2024.1762L10.5131%2024.1762L10.5085%2024.1821C10.3181%2024.4268%2010.1671%2024.6997%2010.0608%2024.9909C9.87155%2025.5097%2010.1387%2026.0838%2010.6575%2026.2731C11.1763%2026.4624%2011.7504%2026.1953%2011.9397%2025.6764C11.9742%2025.5817%2012.0232%2025.4929%2012.0848%2025.4131C12.2607%2025.1921%2012.515%2025.0474%2012.795%2025.0091C13.0762%2024.9707%2013.3614%2025.0427%2013.5907%2025.2101L13.5906%2025.2101L13.5983%2025.2156C13.7037%2025.291%2013.7927%2025.387%2013.8601%2025.4977C13.9274%2025.6084%2013.9717%2025.7316%2013.9903%2025.8598C14.0088%2025.988%2014.0012%2026.1187%2013.968%2026.244C13.9347%2026.3692%2013.8765%2026.4864%2013.7968%2026.5886L13.7843%2026.605L10.1993%2031.4012C9.9727%2031.7044%209.93667%2032.1095%2010.1062%2032.4479C10.2757%2032.7862%2010.6218%2032.9999%2011.0003%2032.9999H15.0003C15.5526%2032.9999%2016.0003%2032.5522%2016.0003%2031.9999C16.0003%2031.4476%2015.5526%2030.9999%2015.0003%2030.9999H12.9962L15.3807%2027.8098C15.6227%2027.4972%2015.7996%2027.1392%2015.901%2026.7571C16.0034%2026.3712%2016.0268%2025.9687%2015.9697%2025.5736C15.9126%2025.1785%2015.7762%2024.7991%2015.5687%2024.4581Z'%20fill='%2320263D'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_8374_20039'%3e%3crect%20width='32'%20height='32'%20fill='white'%20transform='translate(6%206)'/%3e%3c/clipPath%3e%3cclipPath%20id='clip1_8374_20039'%3e%3crect%20width='32'%20height='32'%20fill='white'%20transform='translate(6%206)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", vsTS1 = "data:image/svg+xml,%3csvg%20width='44'%20height='44'%20viewBox='0%200%2044%2044'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1'%20y='1'%20width='42'%20height='42'%20rx='11'%20stroke='%23E9E9EB'%20stroke-width='2'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M11%2011C9.89543%2011%209%2011.8954%209%2013V31C9%2032.1046%209.89543%2033%2011%2033H33C34.1046%2033%2035%2032.1046%2035%2031V13C35%2011.8954%2034.1046%2011%2033%2011H11ZM11%2013H33V31H11V13ZM15.5127%2021C15.5127%2019.8954%2016.4081%2019%2017.5127%2019C18.6173%2019%2019.5127%2019.8954%2019.5127%2021C19.5127%2022.1046%2018.6173%2023%2017.5127%2023H17.5125C16.408%2022.9999%2015.5127%2022.1045%2015.5127%2021ZM20.3123%2023.857C21.0531%2023.131%2021.5127%2022.1192%2021.5127%2021C21.5127%2018.7909%2019.7218%2017%2017.5127%2017C15.3036%2017%2013.5127%2018.7909%2013.5127%2021C13.5127%2022.1192%2013.9723%2023.131%2014.7131%2023.857C14.6237%2023.9173%2014.5361%2023.9807%2014.4504%2024.0471C13.574%2024.7258%2012.9479%2025.6765%2012.6705%2026.7497C12.5323%2027.2844%2012.8537%2027.8299%2013.3884%2027.9681C13.9231%2028.1063%2014.4686%2027.7849%2014.6068%2027.2502C14.7733%2026.6061%2015.1491%2026.0357%2015.675%2025.6284C16.201%2025.221%2016.8473%2025%2017.5125%2025H17.5127C18.1779%2025%2018.8242%2025.221%2019.3501%2025.6282C19.8761%2026.0355%2020.2519%2026.606%2020.4184%2027.25C20.5566%2027.7847%2021.1022%2028.1061%2021.6369%2027.9678C22.1716%2027.8296%2022.4929%2027.2841%2022.3547%2026.7493C22.0772%2025.6761%2021.451%2024.7255%2020.5746%2024.0469C20.489%2023.9806%2020.4015%2023.9173%2020.3123%2023.857ZM25%2019C24.4477%2019%2024%2019.4477%2024%2020C24%2020.5523%2024.4477%2021%2025%2021H30C30.5523%2021%2031%2020.5523%2031%2020C31%2019.4477%2030.5523%2019%2030%2019H25ZM25%2023C24.4477%2023%2024%2023.4477%2024%2024C24%2024.5523%2024.4477%2025%2025%2025H30C30.5523%2025%2031%2024.5523%2031%2024C31%2023.4477%2030.5523%2023%2030%2023H25Z'%20fill='%2320263D'/%3e%3c/svg%3e", vsTS2 = "data:image/svg+xml,%3csvg%20width='44'%20height='44'%20viewBox='0%200%2044%2044'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1'%20y='1'%20width='42'%20height='42'%20rx='11'%20stroke='%23E9E9EB'%20stroke-width='2'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M28.5%2010C27.9477%2010%2027.5%2010.4477%2027.5%2011C27.5%2011.5523%2027.9477%2012%2028.5%2012L32%2012V15.5C32%2016.0522%2032.4477%2016.5%2033%2016.5C33.5523%2016.5%2034%2016.0522%2034%2015.5V12C34%2011.4696%2033.7893%2010.9609%2033.4142%2010.5858C33.0391%2010.2107%2032.5304%2010%2032%2010H28.5ZM34%2028.5C34%2027.9477%2033.5523%2027.5%2033%2027.5C32.4477%2027.5%2032%2027.9477%2032%2028.5V32H28.5C27.9477%2032%2027.5%2032.4478%2027.5%2033C27.5%2033.5523%2027.9477%2034%2028.5%2034H32C32.5304%2034%2033.0391%2033.7893%2033.4142%2033.4143C33.7893%2033.0392%2034%2032.5305%2034%2032V28.5ZM11%2027.5C11.5523%2027.5%2012%2027.9477%2012%2028.5V32H15.5C16.0523%2032%2016.5%2032.4478%2016.5%2033C16.5%2033.5523%2016.0523%2034%2015.5%2034H12C11.4696%2034%2010.9609%2033.7893%2010.5858%2033.4143C10.2107%2033.0392%2010%2032.5305%2010%2032V28.5C10%2027.9477%2010.4477%2027.5%2011%2027.5ZM12%2010C11.4696%2010%2010.9609%2010.2107%2010.5858%2010.5858C10.2107%2010.9609%2010%2011.4696%2010%2012V15.5C10%2016.0522%2010.4477%2016.5%2011%2016.5C11.5523%2016.5%2012%2016.0522%2012%2015.5L12%2012L15.5%2012C16.0523%2012%2016.5%2011.5523%2016.5%2011C16.5%2010.4477%2016.0523%2010%2015.5%2010H12ZM22%2017C20.3431%2017%2019%2018.3431%2019%2020C19%2021.6569%2020.3431%2023%2022%2023C23.6569%2023%2025%2021.6569%2025%2020C25%2018.3431%2023.6569%2017%2022%2017ZM25.2688%2023.7836C26.3291%2022.8668%2027%2021.5117%2027%2020C27%2017.2386%2024.7614%2015%2022%2015C19.2386%2015%2017%2017.2386%2017%2020C17%2021.5117%2017.6709%2022.8668%2018.7312%2023.7836C18.4728%2023.9138%2018.2204%2024.0597%2017.9752%2024.2209C16.7604%2025.0197%2015.7685%2026.1648%2015.1062%2027.533C14.8698%2028.0213%2015.0412%2028.6263%2015.489%2028.8841C15.9367%2029.142%2016.4914%2028.9551%2016.7278%2028.4667C17.2342%2027.4203%2017.9928%2026.5445%2018.9219%2025.9337C19.8461%2025.326%2020.904%2025.0033%2021.9829%2025C21.9886%2025%2021.9943%2025%2022%2025C22.0057%2025%2022.0114%2025%2022.0171%2025C23.096%2025.0033%2024.1539%2025.326%2025.0781%2025.9337C26.0072%2026.5446%2026.7658%2027.4203%2027.2722%2028.4667C27.5086%2028.9551%2028.0633%2029.142%2028.511%2028.8841C28.9588%2028.6263%2029.1302%2028.0214%2028.8938%2027.533C28.2315%2026.1648%2027.2396%2025.0197%2026.0248%2024.2209C25.7796%2024.0597%2025.5272%2023.9138%2025.2688%2023.7836Z'%20fill='%2320263D'/%3e%3c/svg%3e", vsTS3 = "data:image/svg+xml,%3csvg%20width='44'%20height='44'%20viewBox='0%200%2044%2044'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1'%20y='1'%20width='42'%20height='42'%20rx='11'%20stroke='%23E9E9EB'%20stroke-width='2'/%3e%3cg%20clip-path='url(%23clip0_5344_66577)'%3e%3cg%20clip-path='url(%23clip1_5344_66577)'%3e%3cpath%20d='M22%2023.5C22.8284%2023.5%2023.5%2022.8284%2023.5%2022C23.5%2021.1716%2022.8284%2020.5%2022%2020.5C21.1716%2020.5%2020.5%2021.1716%2020.5%2022C20.5%2022.8284%2021.1716%2023.5%2022%2023.5Z'%20fill='%2320263D'/%3e%3cpath%20d='M16.5%2023.5C17.3284%2023.5%2018%2022.8284%2018%2022C18%2021.1716%2017.3284%2020.5%2016.5%2020.5C15.6716%2020.5%2015%2021.1716%2015%2022C15%2022.8284%2015.6716%2023.5%2016.5%2023.5Z'%20fill='%2320263D'/%3e%3cpath%20d='M27.5%2023.5C28.3284%2023.5%2029%2022.8284%2029%2022C29%2021.1716%2028.3284%2020.5%2027.5%2020.5C26.6716%2020.5%2026%2021.1716%2026%2022C26%2022.8284%2026.6716%2023.5%2027.5%2023.5Z'%20fill='%2320263D'/%3e%3cpath%20d='M15.9911%2032.3889C18.5118%2033.8478%2021.4769%2034.3401%2024.3338%2033.7742C27.1907%2033.2083%2029.7443%2031.6227%2031.5184%2029.3131C33.2926%2027.0035%2034.1663%2024.1275%2033.9766%2021.2213C33.7869%2018.3151%2032.5467%2015.577%2030.4873%2013.5177C28.428%2011.4583%2025.6899%2010.2181%2022.7837%2010.0284C19.8775%209.83872%2017.0015%2010.7124%2014.6919%2012.4866C12.3823%2014.2607%2010.7967%2016.8143%2010.2308%2019.6712C9.66486%2022.5281%2010.1572%2025.4932%2011.6161%2028.0139L10.0523%2032.6827C9.99358%2032.8589%209.98505%2033.0479%2010.0277%2033.2287C10.0704%2033.4095%2010.1625%2033.5748%2010.2939%2033.7061C10.4252%2033.8375%2010.5905%2033.9296%2010.7713%2033.9723C10.9521%2034.0149%2011.1411%2034.0064%2011.3173%2033.9477L15.9911%2032.3889Z'%20stroke='%2320263D'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_5344_66577'%3e%3crect%20width='32'%20height='32'%20fill='white'%20transform='translate(6%206)'/%3e%3c/clipPath%3e%3cclipPath%20id='clip1_5344_66577'%3e%3crect%20width='32'%20height='32'%20fill='white'%20transform='translate(6%206)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", TutorialContainer$2 = qe.div`
  min-height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  padding: 50px 15px 0;
  @media only screen and (max-height: 600px) {
    padding: 15px;
  }
`, TutorialHeader$1 = qe.div`
  padding: 0 25px 10px;
  text-align: left;
  .blue {
    color: #00b2fd;
  }

  h1 {
    font-size: 2.25rem;
  }
  span {
    font-size: 1.125rem;
    line-height: 1.625rem;
  }

  @media only screen and (max-height: 600px) {
    padding: 0 0 10px 0;

    h1 {
      display: block;
      font-size: 1.2rem;
      margin-top: 0.83em;
      margin-bottom: 0.83em;
      margin-left: 0;
      margin-right: 0;
      font-weight: bold;
    }
    span {
      font-size: 0.8rem;
      line-height: 1.2rem;
    }
  }
`, Image$7 = qe.img`
  margin: 0;
  display: block;
  flex: 1;
  max-width: 80%;
  flex-grow: 0;

  @media only screen and (max-height: 600px) {
    max-width: 36px;
  }
`, TutorialAction$2 = qe.div`
  margin-bottom: calc(var(--vw) * 15);
  min-height: 82px;
  min-width: 50px;
  margin-top: 1rem;
  text-align: center;
  width: calc(100% - 50px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  align-items: center;
`, Button$4 = qe(Button$a)`
  font-size: 1.25rem;
  text-transform: lowercase;
  &::first-letter {
    text-transform: uppercase;
  }
  @media only screen and (max-height: 600px) {
    font-size: 1rem;
  }
`, TutorialStepsContainer = qe.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 30px;
  div {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
    position: relative;
    span {
      text-align: left;
    }
    @media only screen and (max-height: 600px) {
      span {
        font-size: 0.8rem;
      }
    }
    &:after {
      content: '';
      position: absolute;
      height: 1rem;
      width: 2px;
      left: 22px;
      bottom: -1rem;
      border: 1px solid #e9e9eb;
    }
    &:last-child {
      &:after {
        display: none;
      }
    }
    img {
      margin-right: 1rem;
    }
  }
`;
function Tutorial$1({ goNext: me, token: ue, modules: Qe }) {
  const { t: Ue } = useTranslation();
  return useScreenEvents({
    module: eventModuleNames.videoSelfie,
    screen: eventScreenNames.videoSelfieTutorial,
    token: ue.token
  }), /* @__PURE__ */ jsxRuntimeExports.jsxs(
    TutorialContainer$2,
    {
      className: "IncodeRecorderTutorialContainer",
      "aria-live": "assertive",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(TutorialHeader$1, { className: "IncodeRecorderTutorialHeader", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Image$7,
            {
              role: "img",
              src: captureFaceImg,
              alt: "incode recorder tutorial image",
              className: "IncodeRecorderTutorialImage"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { className: "IncodeRecorderTutorialTitle", "aria-live": "assertive", children: Ue("videoSelfie.tutorial.videoCheck") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "IncodeRecorderTutorialBody", "aria-live": "polite", children: Ue("videoSelfie.tutorial.legalReason") })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(TutorialAction$2, { className: "IncodeRecorderTutorialContent", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(TutorialStepsContainer, { className: "IncodeRecorderStepsContainer", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "IncodeRecorderStep", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Image$7,
                {
                  role: "img",
                  src: permissionIcon,
                  alt: "",
                  width: 44,
                  className: "IncodeRecorderTutorialImage"
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "aria-live": "polite", children: Ue("videoSelfie.tutorial.permissions") })
            ] }),
            Qe.includes("front") && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "IncodeRecorderStep", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Image$7,
                {
                  role: "img",
                  src: vsTS1,
                  alt: "",
                  width: 44,
                  className: "IncodeRecorderTutorialImage"
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "aria-live": "polite", children: Ue("videoSelfie.tutorial.scanFrontId") })
            ] }),
            Qe.includes("back") && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "IncodeRecorderStep", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Image$7,
                {
                  role: "img",
                  src: backIdIcon,
                  alt: "",
                  width: 44,
                  className: "IncodeRecorderTutorialImage"
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "aria-live": "polite", children: Ue("videoSelfie.tutorial.scanBackId") })
            ] }),
            Qe.includes("poa") && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "IncodeRecorderStep", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Image$7,
                {
                  role: "img",
                  src: addressIcon,
                  width: 44,
                  alt: "",
                  className: "IncodeRecorderTutorialImage"
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "aria-live": "polite", children: Ue("videoSelfie.tutorial.poa") })
            ] }),
            Qe.includes("selfie") && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "IncodeRecorderStep", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Image$7,
                {
                  role: "img",
                  src: vsTS2,
                  width: 44,
                  alt: "",
                  className: "IncodeRecorderTutorialImage"
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "aria-live": "polite", children: Ue("videoSelfie.tutorial.takeSelfie") })
            ] }),
            Qe.includes("questions") && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "IncodeRecorderStep", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Image$7,
                {
                  role: "img",
                  src: questionIcon,
                  width: 44,
                  alt: "",
                  className: "IncodeRecorderTutorialImage"
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "aria-live": "polite", children: Ue("videoSelfie.tutorial.questions") })
            ] }),
            Qe.includes("speech") && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "IncodeRecorderStep", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Image$7,
                {
                  role: "img",
                  src: vsTS3,
                  width: 44,
                  alt: "",
                  className: "IncodeRecorderTutorialImage"
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "aria-live": "polite", children: Ue("videoSelfie.tutorial.recordVoiceMessage") })
            ] })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$4, { className: "IncodeRecorderTutorialButton", onClick: me, children: Ue("videoSelfie.tutorial.startVideoSelfie") })
        ] })
      ]
    }
  );
}
const steps$1 = ["tutorial", "videoRecorder"];
function Recorder(me) {
  const [ue, Qe] = useState(
    steps$1.indexOf(me.showTutorial ? "tutorial" : "videoRecorder")
  );
  useModuleEvents({
    module: eventModuleNames.videoSelfie,
    token: me.token.token
  });
  function Ue(Xe) {
    return Qe(steps$1.indexOf(Xe));
  }
  const Ge = me.useOpenVidu ? OpenViduVideoSelfie : VideoRecorder$1;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { token: me.token.token, disableFullScreen: ue === 0, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Steps, { currentStep: ue, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Tutorial$1, { goNext: () => Ue("videoRecorder"), ...me }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Ge,
      {
        goNext: (Xe) => Ue(Xe ? "success" : "not-success"),
        ...me
      }
    )
  ] }) });
}
function renderVideoSelfie(me, {
  token: ue,
  showTutorial: Qe = !1,
  modules: Ue = ["selfie", "front", "back", "poa", "questions", "speech"],
  speechToTextCheck: He = !0,
  performLiveness: Ge = !1,
  videoSelfieAsSelfie: Xe = !1,
  compareOCREnabled: Ke = !1,
  compareIDEnabled: $e = !0,
  compareBackOCREnabled: Je = !1,
  compareBackIDEnabled: Ze = !1,
  useOpenVidu: nt = !1,
  questionsCount: tt = 3
}, {
  onSuccess: et,
  onError: rt,
  onLog: it = () => {
  },
  numberOfTries: ot = 3
}) {
  const at = createRoot$1(me), st = {
    onSuccess: handleUnmountRoot(et, at, me),
    onError: handleUnmountRoot(rt, at, me)
  };
  customRender(
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Recorder,
      {
        onBoarding: this,
        token: ue,
        onSuccess: st.onSuccess,
        onError: st.onError,
        showTutorial: Qe,
        modules: Ue,
        speechToTextCheck: He,
        onLog: it,
        numberOfTries: ot,
        performLiveness: Ge,
        videoSelfieAsSelfie: Xe,
        compareOCREnabled: Ke,
        compareIDEnabled: $e,
        compareBackOCREnabled: Je,
        compareBackIDEnabled: Ze,
        questionsCount: tt,
        useOpenVidu: nt
      }
    ),
    me,
    at
  );
}
function removeFromQueue({ token: me, queueName: ue = "" }) {
  return api.post(
    `/omni/queue/conference/disconnect?queueName=${ue}`,
    {},
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).then((Qe) => Qe.data);
}
const StyledButton$1 = qe(Button$a)`
  height: 58px;
  text-transform: uppercase;

  &.button-hidden {
    display: none;
  }
`, FrontTutorialAction = qe.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`, TutorialAction$1 = qe.div`
  flex: auto;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-bottom: 14px;
  @media only screen and (min-width: 992px) {
    margin-bottom: 0;
  }
`, VideoContainer = qe.div`
  align-items: center;
  display: flex;
  flex: auto;
  justify-content: center;
  video {
    display: flex;
    height: calc(100vh * 0.5);
  }
`, TutorialContainer$1 = qe.div`
  padding: 0 10px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  .swiper {
    width: 100%;

    & .swiper-pagination {
    }
  }

  .swiper-slide {
    text-align: center;
    font-size: 18px;
    background: #fff;

    /* Center slide text vertically */
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`, TutorialHeader = qe.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${({ ageAssurance: me, isDekstop: ue }) => ue ? "80px 10px 10px 10px" : me ? "0px 10px 0px 10px" : "25px 10px 10px 10px"};
  text-align: center;

  .blue {
    color: ${(me) => me.theme.main};
  }

  .blue.IncodeHighlightedText {
    display: inline;
  }

  h1 {
    display: block;
    font-size: 25px;
    line-height: 1.2;
  }

  span {
    font-size: 15px;
    line-height: 22px;
  }

  h1 span {
    font-weight: bold;
    font-size: 28px;
  }

  @media only screen and (max-height: 600px) {
    padding: 0;

    h1 {
      display: inline-block;
      font-size: 20px;
      margin-bottom: 5px;
      width: 100%;
    }

    span {
      font-family: 'CircularStd-Medium';
      font-size: 14px;
      display: inline-block;
    }

    h1 span {
      font-weight: bold;
      font-size: 24px;
    }
  }
`, TutorialSubtitle = qe.h3`
  font-weight: 500;
  font-size: 18px;
  line-height: 23px;
  text-align: center;
  max-width: 310px;
`;
qe.div`
  width: 100%;
  overflow: hidden;
`;
const SourceContainer = qe.div`
  align-items: center;
  display: flex;
  flex: auto;
  justify-content: center;
  flex-direction: column;

  &.isCreditCard {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`, Image$6 = qe.img`
  display: flex;
  height: 50vh;
  object-fit: cover;

  &.isCreditCard {
    padding-top: 0;
    width: 100%;
    height: auto;
    max-height: 100%;
    background-color: #586c74;
    padding: 40px 70px;
    border-radius: 5px;
  }
`, Video = qe.video`
  height: 50vh;
  object-fit: cover;
`, AgeStepsWrapper = qe.div`
  display: flex;
  flex-direction: column;
  padding: 0 10px;
  width: 100%;
`, AgeStepContainer = qe.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;

  img {
    width: 73px !important;
  }
`, AgeStep = qe.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: solid 2px #e9e9eb;
  height: 44px;
  width: 44px;
  border-radius: 12px;
  color: #20263d;
  font-size: 18px;
  line-height: 26px;
`, AgeText = qe.div`
  font-size: 13px;
  line-height: 18px;
  font-weight: 500;
  width: calc(100% - 88px);
  padding: 0 12px;
  text-align: left;
  height: 54px;
  display: flex;
  align-items: center;
`, AgeStepDivder = qe.div`
  background-color: #e9e9eb;
  width: 2px;
  height: 26px;
  position: relative;
  margin: -5px 0 -5px calc(44px / 2 - 2px);
`, AgeComponent = qe.div`
  position: relative;
  height: 48px;
  width: 148px;
  border: solid 2px rgba(0, 0, 0, 0.2);
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  top: -90px;
`, TutorialInfo = qe.span`
  text-align: center;
  position: relative;
  top: -60px;
  padding: 0 10px;
`;
function Tutorial({
  src: me,
  next: ue,
  header: Qe,
  selfie: Ue,
  noWait: He = !1,
  children: Ge,
  type: Xe = "",
  disabledButton: Ke = !1,
  creditCard: $e,
  ageAssurance: Je = !1,
  token: Ze
}) {
  const [nt, tt] = useState(He), { t: et } = useTranslation(), rt = useRef(null), it = useRef(null);
  useAutoFocus(rt, !0);
  const ot = me.endsWith(".mp4");
  useScreenEvents({
    module: eventModuleNames[Xe.toLowerCase()],
    screen: tutorialScreenNamesMapper[Xe.toLowerCase()],
    token: Ze == null ? void 0 : Ze.token
  }), useEffect(() => {
    const lt = setTimeout(() => {
      nt === !1 && tt(!0);
    }, 100);
    return () => clearTimeout(lt);
  }, [nt]);
  const at = () => {
    switch (Xe) {
      case "Back":
        return `${et("tutorial.back.titleAriaFrame")}`;
      case "selfie":
        return ` ${et("tutorial.selfie.titleAriaFrame")}`;
      case "passport":
        return `${et("tutorial.ariaLabelPassport")}`;
      default:
        return "";
    }
  }, st = () => {
    switch (Xe) {
      case "Front":
        return `${et("tutorial.ariaLabelFront")}`;
      case "Back":
        return `${et("tutorial.ariaLabelBack")}`;
      case "passport":
        return `${et("tutorial.ariaLabelPassport")}`;
      default:
        return "";
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    TutorialContainer$1,
    {
      role: "region",
      "aria-live": "assertive",
      ref: rt,
      tabIndex: -1,
      className: `IncodeTutorialContainer${Xe}`,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          TutorialHeader,
          {
            className: classNames(
              "IncodeTutorialHeaderContainer",
              `IncodeTutorialHeaderContainer${Xe}`
            ),
            ageAssurance: Je,
            isDekstop: mobile.isDesktop(),
            children: Qe
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          SourceContainer,
          {
            className: classNames({
              isCreditCard: $e
            }),
            children: [
              ot ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                Video,
                {
                  ref: it,
                  "aria-label": st(),
                  className: classNames("IncodeTutorialVideo", `IncodeTutorialVideo${Xe}`, {
                    isSelfie: Ue,
                    isCreditCard: $e
                  }),
                  preload: "auto",
                  playsInline: !0,
                  src: me,
                  autoPlay: !0,
                  loop: !0,
                  muted: !0
                }
              ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
                Image$6,
                {
                  ref: it,
                  "aria-label": et("tutorial.ariaLabelPassportExtra"),
                  alt: at(),
                  className: classNames("IncodeTutorialVideo", `IncodeTutorialVideo${Xe}`, {
                    isSelfie: Ue,
                    isCreditCard: $e
                  }),
                  role: "img",
                  src: me
                }
              ),
              Je ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(AgeComponent, { children: et("tutorial.age") }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(TutorialInfo, { children: et("tutorial.ageAssurance3") })
              ] }) : null
            ]
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          TutorialAction$1,
          {
            className: classNames(
              "IncodeTutorialButtonContainer",
              `IncodeTutorialButtonContainer${Xe}`
            ),
            children: Ge || /* @__PURE__ */ jsxRuntimeExports.jsx(
              StyledButton$1,
              {
                className: classNames(
                  "IncodeTutorialButton",
                  `IncodeTutorialButton${Xe}`,
                  {
                    "button-hidden": !nt
                  }
                ),
                disabled: Ke,
                onClick: ue,
                children: et("common.continue")
              }
            )
          }
        )
      ]
    }
  );
}
const TutorialBackHeader = () => {
  const { t: me } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "IncodeTutorialHeader IncodeTutorialHeaderBack", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    "h1",
    {
      "aria-live": "assertive",
      className: "IncodeText IncodeH1 IncodeTutorialHeaderTitle IncodeTutorialHeaderTitleBack",
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Trans, { t: me, i18nKey: "tutorial.back.title", children: [
        "Now scan the",
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "blue IncodeHighlightedText", children: "back side" }),
        "of your ID"
      ] })
    }
  ) });
};
function TutorialBack({ onSuccess: me, token: ue, ...Qe }) {
  const Ue = () => mobile.isDesktop() ? "https://sdk.incode.com/sdk/tutorials/tutorial-back-desktop.mp4" : options.darkMode ? "https://sdk.incode.com/sdk/tutorials/back-dark.mp4" : "https://sdk.incode.com/sdk/tutorials/back.gif";
  useEffect(() => {
    ue != null && ue.token && (addEvent({
      token: ue.token,
      code: "tutorialVideoStarted",
      payload: {
        tutorialFrontID: !0
      },
      module: "ID Capture",
      screen: "Back ID capture tutorial"
    }), addEvent({
      token: ue.token,
      code: "tutorialBackId",
      payload: { tutorialBackID: !0 }
    }));
  }, [ue]);
  function He() {
    addEvent({
      token: ue == null ? void 0 : ue.token,
      code: "ctaTapped",
      payload: {
        cta: "Continue"
      },
      module: "ID capture",
      screen: "Back ID capture tutorial"
    }), me();
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Tutorial,
    {
      ...Qe,
      token: ue,
      src: Ue(),
      next: He,
      header: /* @__PURE__ */ jsxRuntimeExports.jsx(TutorialBackHeader, {}),
      type: "Back"
    }
  );
}
const isWebRtcNotSupported$2 = !isWebRtcSupported();
function renderBackTutorial(me, { onSuccess: ue, noWait: Qe, token: Ue = {}, videoSrc: He }) {
  isWebRtcNotSupported$2 && ue();
  const Ge = createRoot$1(me), Xe = {
    onSuccess: handleUnmountRoot(ue, Ge, me),
    onBoarding: this,
    noWait: Qe,
    token: Ue,
    videoSrc: He
  };
  customRender(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(TutorialBack, { ...Xe }) }),
    me,
    Ge
  );
}
const isSurface$1 = isSurfaceTablet(), NotificationContainer = qe.div`
  border-radius: 20px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 15px 20px 15px 20px;
  position: fixed;
  top: 120px;
  left: 0;
  right: 0;
  display: ${(me) => me.isOpen ? "block" : "none"};
  max-width: calc(100% - 50px); // 40px are for the padding
  width: fit-content;
  margin: auto;
  box-sizing: content-box;

  &:focus {
    outline: ${(me) => me.isOpen ? "auto" : "none"};
  }

  &.center {
    font-size: 18px;

    .icon {
      text-align: center;
    }

    .notification-text {
      line-height: 1.5;
      margin: 0;
    }
  }

  &.inline {
    display: flex;
  }

  &.desktop {
    top: unset;
    padding: 0;
    background-color: transparent;
    color: #20263d;
    display: block;
    position: relative;
  }
`, NotificationText = qe.div`
  text-align: center;

  &.desktop {
    div {
      font-size: 24px;
      line-height: 22px;

      &.surface {
        font-size: 55px;
        line-height: unset;
      }

      div {
        margin-top: 10px;
      }
    }
  }
`, DEFAULT_DURATION = 3e4, NotificationContext = createContext({}), reducer$1 = (me, ue) => {
  switch (ue.type) {
    case "showNotification":
      return me.isOpen ? me : {
        ...me,
        children: ue.children,
        icon: ue.icon,
        isOpen: !0
      };
    case "showPriorityNotification":
      return window.clearTimeout(closeTimeout), {
        ...me,
        children: ue.children,
        icon: ue.icon,
        isOpen: !0
      };
    case "closeNotification":
      return {
        ...me,
        children: null,
        icon: "",
        isOpen: !1
      };
    default:
      return me;
  }
};
let closeTimeout;
const showNotification = (me, ue) => (Qe, Ue) => {
  me({ type: ue, children: Qe, icon: Ue }), closeTimeout = setTimeout(() => {
    closeNotification(me);
  }, DEFAULT_DURATION);
}, closeNotification = (me) => {
  me({ type: "closeNotification" });
}, NotificationProvider = ({ children: me, initialValue: ue }) => /* @__PURE__ */ jsxRuntimeExports.jsx(NotificationContext.Provider, { value: useReducer(reducer$1, ue), children: me }), useNotifications = () => {
  const [me, ue] = useContext(NotificationContext);
  return {
    ...me,
    showNotification: useCallback(
      showNotification(ue, "showNotification"),
      []
    ),
    showPriorityNotification: useCallback(
      showNotification(ue, "showPriorityNotification"),
      []
    ),
    closeNotification: useCallback(
      () => closeNotification(ue),
      [ue]
    )
  };
};
function Portal({ children: me }) {
  const ue = useRef(null), [, Qe] = useState();
  return useLayoutEffect(() => (ue.current = document.createElement("portal"), document.body.appendChild(ue.current), Qe({}), () => {
    ue.current && document.body.removeChild(ue.current);
  }), []), ue.current ? createPortal(me, ue.current) : null;
}
function Notification({
  center: me = !1,
  inline: ue = !0,
  noPortal: Qe = !1,
  isKiosk: Ue = !1
}) {
  const [{ isOpen: He, children: Ge }] = useContext(NotificationContext);
  return Qe ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    NotificationContainer,
    {
      className: classNames("IncodeNotificationContainer", {
        center: me,
        inline: ue,
        desktop: mobile.isDesktop() || Ue
      }),
      isOpen: He,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        NotificationText,
        {
          role: "alert",
          "aria-live": "assertive",
          className: classNames({
            desktop: mobile.isDesktop() || Ue,
            surface: isSurface$1
          }),
          children: Ge
        }
      )
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(Portal, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    NotificationContainer,
    {
      className: classNames("IncodeNotificationContainer", {
        center: me,
        inline: ue,
        desktop: mobile.isDesktop() || Ue
      }),
      isOpen: He,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        NotificationText,
        {
          className: classNames({
            desktop: mobile.isDesktop() || Ue
          }),
          role: "alert",
          "aria-live": "assertive",
          children: Ge
        }
      )
    }
  ) });
}
var __webpack_require__ = {};
__webpack_require__.d = (me, ue) => {
  for (var Qe in ue)
    __webpack_require__.o(ue, Qe) && !__webpack_require__.o(me, Qe) && Object.defineProperty(me, Qe, { enumerable: !0, get: ue[Qe] });
};
__webpack_require__.o = (me, ue) => Object.prototype.hasOwnProperty.call(me, ue);
var __webpack_exports__ = globalThis.pdfjsLib = {};
__webpack_require__.d(__webpack_exports__, {
  AbortException: () => (
    /* reexport */
    AbortException
  ),
  AnnotationEditorLayer: () => (
    /* reexport */
    AnnotationEditorLayer
  ),
  AnnotationEditorParamsType: () => (
    /* reexport */
    AnnotationEditorParamsType
  ),
  AnnotationEditorType: () => (
    /* reexport */
    AnnotationEditorType
  ),
  AnnotationEditorUIManager: () => (
    /* reexport */
    AnnotationEditorUIManager
  ),
  AnnotationLayer: () => (
    /* reexport */
    AnnotationLayer$1
  ),
  AnnotationMode: () => (
    /* reexport */
    AnnotationMode
  ),
  CMapCompressionType: () => (
    /* reexport */
    CMapCompressionType
  ),
  ColorPicker: () => (
    /* reexport */
    ColorPicker
  ),
  DOMSVGFactory: () => (
    /* reexport */
    DOMSVGFactory
  ),
  DrawLayer: () => (
    /* reexport */
    DrawLayer
  ),
  FeatureTest: () => (
    /* reexport */
    util_FeatureTest
  ),
  GlobalWorkerOptions: () => (
    /* reexport */
    GlobalWorkerOptions
  ),
  ImageKind: () => (
    /* reexport */
    util_ImageKind
  ),
  InvalidPDFException: () => (
    /* reexport */
    InvalidPDFException
  ),
  MissingPDFException: () => (
    /* reexport */
    MissingPDFException
  ),
  OPS: () => (
    /* reexport */
    OPS
  ),
  Outliner: () => (
    /* reexport */
    Outliner
  ),
  PDFDataRangeTransport: () => (
    /* reexport */
    PDFDataRangeTransport$1
  ),
  PDFDateString: () => (
    /* reexport */
    PDFDateString
  ),
  PDFWorker: () => (
    /* reexport */
    PDFWorker
  ),
  PasswordResponses: () => (
    /* reexport */
    PasswordResponses$1
  ),
  PermissionFlag: () => (
    /* reexport */
    PermissionFlag
  ),
  PixelsPerInch: () => (
    /* reexport */
    PixelsPerInch
  ),
  RenderingCancelledException: () => (
    /* reexport */
    RenderingCancelledException
  ),
  TextLayer: () => (
    /* reexport */
    TextLayer$1
  ),
  UnexpectedResponseException: () => (
    /* reexport */
    UnexpectedResponseException
  ),
  Util: () => (
    /* reexport */
    Util
  ),
  VerbosityLevel: () => (
    /* reexport */
    VerbosityLevel
  ),
  XfaLayer: () => (
    /* reexport */
    XfaLayer
  ),
  build: () => (
    /* reexport */
    build
  ),
  createValidAbsoluteUrl: () => (
    /* reexport */
    createValidAbsoluteUrl
  ),
  fetchData: () => (
    /* reexport */
    fetchData
  ),
  getDocument: () => (
    /* reexport */
    getDocument$1
  ),
  getFilenameFromUrl: () => (
    /* reexport */
    getFilenameFromUrl
  ),
  getPdfFilenameFromUrl: () => (
    /* reexport */
    getPdfFilenameFromUrl
  ),
  getXfaPageViewport: () => (
    /* reexport */
    getXfaPageViewport
  ),
  isDataScheme: () => (
    /* reexport */
    isDataScheme
  ),
  isPdfFile: () => (
    /* reexport */
    isPdfFile
  ),
  noContextMenu: () => (
    /* reexport */
    noContextMenu
  ),
  normalizeUnicode: () => (
    /* reexport */
    normalizeUnicode
  ),
  renderTextLayer: () => (
    /* reexport */
    renderTextLayer
  ),
  setLayerDimensions: () => (
    /* reexport */
    setLayerDimensions
  ),
  shadow: () => (
    /* reexport */
    shadow
  ),
  updateTextLayer: () => (
    /* reexport */
    updateTextLayer
  ),
  version: () => (
    /* reexport */
    version
  )
});
const isNodeJS = typeof process == "object" && process + "" == "[object process]" && !process.versions.nw && !(process.versions.electron && process.type && process.type !== "browser"), IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0], FONT_IDENTITY_MATRIX = [1e-3, 0, 0, 1e-3, 0, 0], MAX_IMAGE_SIZE_TO_CACHE = 1e7, LINE_FACTOR = 1.35, RenderingIntentFlag = {
  ANY: 1,
  DISPLAY: 2,
  PRINT: 4,
  SAVE: 8,
  ANNOTATIONS_FORMS: 16,
  ANNOTATIONS_STORAGE: 32,
  ANNOTATIONS_DISABLE: 64,
  OPLIST: 256
}, AnnotationMode = {
  DISABLE: 0,
  ENABLE: 1,
  ENABLE_FORMS: 2,
  ENABLE_STORAGE: 3
}, AnnotationEditorPrefix = "pdfjs_internal_editor_", AnnotationEditorType = {
  DISABLE: -1,
  NONE: 0,
  FREETEXT: 3,
  HIGHLIGHT: 9,
  STAMP: 13,
  INK: 15
}, AnnotationEditorParamsType = {
  RESIZE: 1,
  CREATE: 2,
  FREETEXT_SIZE: 11,
  FREETEXT_COLOR: 12,
  FREETEXT_OPACITY: 13,
  INK_COLOR: 21,
  INK_THICKNESS: 22,
  INK_OPACITY: 23,
  HIGHLIGHT_COLOR: 31,
  HIGHLIGHT_DEFAULT_COLOR: 32,
  HIGHLIGHT_THICKNESS: 33,
  HIGHLIGHT_FREE: 34,
  HIGHLIGHT_SHOW_ALL: 35
}, PermissionFlag = {
  PRINT: 4,
  MODIFY_CONTENTS: 8,
  COPY: 16,
  MODIFY_ANNOTATIONS: 32,
  FILL_INTERACTIVE_FORMS: 256,
  COPY_FOR_ACCESSIBILITY: 512,
  ASSEMBLE: 1024,
  PRINT_HIGH_QUALITY: 2048
}, TextRenderingMode = {
  FILL: 0,
  STROKE: 1,
  FILL_STROKE: 2,
  INVISIBLE: 3,
  FILL_ADD_TO_PATH: 4,
  STROKE_ADD_TO_PATH: 5,
  FILL_STROKE_ADD_TO_PATH: 6,
  ADD_TO_PATH: 7,
  FILL_STROKE_MASK: 3,
  ADD_TO_PATH_FLAG: 4
}, util_ImageKind = {
  GRAYSCALE_1BPP: 1,
  RGB_24BPP: 2,
  RGBA_32BPP: 3
}, AnnotationType = {
  TEXT: 1,
  LINK: 2,
  FREETEXT: 3,
  LINE: 4,
  SQUARE: 5,
  CIRCLE: 6,
  POLYGON: 7,
  POLYLINE: 8,
  HIGHLIGHT: 9,
  UNDERLINE: 10,
  SQUIGGLY: 11,
  STRIKEOUT: 12,
  STAMP: 13,
  CARET: 14,
  INK: 15,
  POPUP: 16,
  FILEATTACHMENT: 17,
  SOUND: 18,
  MOVIE: 19,
  WIDGET: 20,
  SCREEN: 21,
  PRINTERMARK: 22,
  TRAPNET: 23,
  WATERMARK: 24,
  THREED: 25,
  REDACT: 26
}, AnnotationBorderStyleType = {
  SOLID: 1,
  DASHED: 2,
  BEVELED: 3,
  INSET: 4,
  UNDERLINE: 5
}, VerbosityLevel = {
  ERRORS: 0,
  WARNINGS: 1,
  INFOS: 5
}, CMapCompressionType = {
  NONE: 0,
  BINARY: 1
}, OPS = {
  dependency: 1,
  setLineWidth: 2,
  setLineCap: 3,
  setLineJoin: 4,
  setMiterLimit: 5,
  setDash: 6,
  setRenderingIntent: 7,
  setFlatness: 8,
  setGState: 9,
  save: 10,
  restore: 11,
  transform: 12,
  moveTo: 13,
  lineTo: 14,
  curveTo: 15,
  curveTo2: 16,
  curveTo3: 17,
  closePath: 18,
  rectangle: 19,
  stroke: 20,
  closeStroke: 21,
  fill: 22,
  eoFill: 23,
  fillStroke: 24,
  eoFillStroke: 25,
  closeFillStroke: 26,
  closeEOFillStroke: 27,
  endPath: 28,
  clip: 29,
  eoClip: 30,
  beginText: 31,
  endText: 32,
  setCharSpacing: 33,
  setWordSpacing: 34,
  setHScale: 35,
  setLeading: 36,
  setFont: 37,
  setTextRenderingMode: 38,
  setTextRise: 39,
  moveText: 40,
  setLeadingMoveText: 41,
  setTextMatrix: 42,
  nextLine: 43,
  showText: 44,
  showSpacedText: 45,
  nextLineShowText: 46,
  nextLineSetSpacingShowText: 47,
  setCharWidth: 48,
  setCharWidthAndBounds: 49,
  setStrokeColorSpace: 50,
  setFillColorSpace: 51,
  setStrokeColor: 52,
  setStrokeColorN: 53,
  setFillColor: 54,
  setFillColorN: 55,
  setStrokeGray: 56,
  setFillGray: 57,
  setStrokeRGBColor: 58,
  setFillRGBColor: 59,
  setStrokeCMYKColor: 60,
  setFillCMYKColor: 61,
  shadingFill: 62,
  beginInlineImage: 63,
  beginImageData: 64,
  endInlineImage: 65,
  paintXObject: 66,
  markPoint: 67,
  markPointProps: 68,
  beginMarkedContent: 69,
  beginMarkedContentProps: 70,
  endMarkedContent: 71,
  beginCompat: 72,
  endCompat: 73,
  paintFormXObjectBegin: 74,
  paintFormXObjectEnd: 75,
  beginGroup: 76,
  endGroup: 77,
  beginAnnotation: 80,
  endAnnotation: 81,
  paintImageMaskXObject: 83,
  paintImageMaskXObjectGroup: 84,
  paintImageXObject: 85,
  paintInlineImageXObject: 86,
  paintInlineImageXObjectGroup: 87,
  paintImageXObjectRepeat: 88,
  paintImageMaskXObjectRepeat: 89,
  paintSolidColorImageMask: 90,
  constructPath: 91
}, PasswordResponses$1 = {
  NEED_PASSWORD: 1,
  INCORRECT_PASSWORD: 2
};
let verbosity = VerbosityLevel.WARNINGS;
function setVerbosityLevel(me) {
  Number.isInteger(me) && (verbosity = me);
}
function getVerbosityLevel() {
  return verbosity;
}
function info(me) {
  verbosity >= VerbosityLevel.INFOS && console.log(`Info: ${me}`);
}
function warn(me) {
  verbosity >= VerbosityLevel.WARNINGS && console.log(`Warning: ${me}`);
}
function unreachable(me) {
  throw new Error(me);
}
function assert(me, ue) {
  me || unreachable(ue);
}
function _isValidProtocol(me) {
  switch (me == null ? void 0 : me.protocol) {
    case "http:":
    case "https:":
    case "ftp:":
    case "mailto:":
    case "tel:":
      return !0;
    default:
      return !1;
  }
}
function createValidAbsoluteUrl(me, ue = null, Qe = null) {
  if (!me)
    return null;
  try {
    if (Qe && typeof me == "string") {
      if (Qe.addDefaultProtocol && me.startsWith("www.")) {
        const He = me.match(/\./g);
        (He == null ? void 0 : He.length) >= 2 && (me = `http://${me}`);
      }
      if (Qe.tryConvertEncoding)
        try {
          me = stringToUTF8String(me);
        } catch {
        }
    }
    const Ue = ue ? new URL(me, ue) : new URL(me);
    if (_isValidProtocol(Ue))
      return Ue;
  } catch {
  }
  return null;
}
function shadow(me, ue, Qe, Ue = !1) {
  return Object.defineProperty(me, ue, {
    value: Qe,
    enumerable: !Ue,
    configurable: !0,
    writable: !1
  }), Qe;
}
const BaseException = function() {
  function ue(Qe, Ue) {
    this.constructor === ue && unreachable("Cannot initialize BaseException."), this.message = Qe, this.name = Ue;
  }
  return ue.prototype = new Error(), ue.constructor = ue, ue;
}();
class PasswordException extends BaseException {
  constructor(ue, Qe) {
    super(ue, "PasswordException"), this.code = Qe;
  }
}
class UnknownErrorException extends BaseException {
  constructor(ue, Qe) {
    super(ue, "UnknownErrorException"), this.details = Qe;
  }
}
class InvalidPDFException extends BaseException {
  constructor(ue) {
    super(ue, "InvalidPDFException");
  }
}
class MissingPDFException extends BaseException {
  constructor(ue) {
    super(ue, "MissingPDFException");
  }
}
class UnexpectedResponseException extends BaseException {
  constructor(ue, Qe) {
    super(ue, "UnexpectedResponseException"), this.status = Qe;
  }
}
class FormatError extends BaseException {
  constructor(ue) {
    super(ue, "FormatError");
  }
}
class AbortException extends BaseException {
  constructor(ue) {
    super(ue, "AbortException");
  }
}
function bytesToString(me) {
  (typeof me != "object" || (me == null ? void 0 : me.length) === void 0) && unreachable("Invalid argument for bytesToString");
  const ue = me.length, Qe = 8192;
  if (ue < Qe)
    return String.fromCharCode.apply(null, me);
  const Ue = [];
  for (let He = 0; He < ue; He += Qe) {
    const Ge = Math.min(He + Qe, ue), Xe = me.subarray(He, Ge);
    Ue.push(String.fromCharCode.apply(null, Xe));
  }
  return Ue.join("");
}
function stringToBytes(me) {
  typeof me != "string" && unreachable("Invalid argument for stringToBytes");
  const ue = me.length, Qe = new Uint8Array(ue);
  for (let Ue = 0; Ue < ue; ++Ue)
    Qe[Ue] = me.charCodeAt(Ue) & 255;
  return Qe;
}
function string32(me) {
  return String.fromCharCode(me >> 24 & 255, me >> 16 & 255, me >> 8 & 255, me & 255);
}
function objectFromMap(me) {
  const ue = /* @__PURE__ */ Object.create(null);
  for (const [Qe, Ue] of me)
    ue[Qe] = Ue;
  return ue;
}
function isLittleEndian() {
  const me = new Uint8Array(4);
  return me[0] = 1, new Uint32Array(me.buffer, 0, 1)[0] === 1;
}
function isEvalSupported() {
  try {
    return new Function(""), !0;
  } catch {
    return !1;
  }
}
class util_FeatureTest {
  static get isLittleEndian() {
    return shadow(this, "isLittleEndian", isLittleEndian());
  }
  static get isEvalSupported() {
    return shadow(this, "isEvalSupported", isEvalSupported());
  }
  static get isOffscreenCanvasSupported() {
    return shadow(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas < "u");
  }
  static get platform() {
    return typeof navigator < "u" && typeof (navigator == null ? void 0 : navigator.platform) == "string" ? shadow(this, "platform", {
      isMac: navigator.platform.includes("Mac")
    }) : shadow(this, "platform", {
      isMac: !1
    });
  }
  static get isCSSRoundSupported() {
    var ue, Qe;
    return shadow(this, "isCSSRoundSupported", (Qe = (ue = globalThis.CSS) == null ? void 0 : ue.supports) == null ? void 0 : Qe.call(ue, "width: round(1.5px, 1px)"));
  }
}
const hexNumbers = Array.from(Array(256).keys(), (me) => me.toString(16).padStart(2, "0"));
var Uo, E2, xh;
class Util {
  static makeHexColor(ue, Qe, Ue) {
    return `#${hexNumbers[ue]}${hexNumbers[Qe]}${hexNumbers[Ue]}`;
  }
  static scaleMinMax(ue, Qe) {
    let Ue;
    ue[0] ? (ue[0] < 0 && (Ue = Qe[0], Qe[0] = Qe[2], Qe[2] = Ue), Qe[0] *= ue[0], Qe[2] *= ue[0], ue[3] < 0 && (Ue = Qe[1], Qe[1] = Qe[3], Qe[3] = Ue), Qe[1] *= ue[3], Qe[3] *= ue[3]) : (Ue = Qe[0], Qe[0] = Qe[1], Qe[1] = Ue, Ue = Qe[2], Qe[2] = Qe[3], Qe[3] = Ue, ue[1] < 0 && (Ue = Qe[1], Qe[1] = Qe[3], Qe[3] = Ue), Qe[1] *= ue[1], Qe[3] *= ue[1], ue[2] < 0 && (Ue = Qe[0], Qe[0] = Qe[2], Qe[2] = Ue), Qe[0] *= ue[2], Qe[2] *= ue[2]), Qe[0] += ue[4], Qe[1] += ue[5], Qe[2] += ue[4], Qe[3] += ue[5];
  }
  static transform(ue, Qe) {
    return [ue[0] * Qe[0] + ue[2] * Qe[1], ue[1] * Qe[0] + ue[3] * Qe[1], ue[0] * Qe[2] + ue[2] * Qe[3], ue[1] * Qe[2] + ue[3] * Qe[3], ue[0] * Qe[4] + ue[2] * Qe[5] + ue[4], ue[1] * Qe[4] + ue[3] * Qe[5] + ue[5]];
  }
  static applyTransform(ue, Qe) {
    const Ue = ue[0] * Qe[0] + ue[1] * Qe[2] + Qe[4], He = ue[0] * Qe[1] + ue[1] * Qe[3] + Qe[5];
    return [Ue, He];
  }
  static applyInverseTransform(ue, Qe) {
    const Ue = Qe[0] * Qe[3] - Qe[1] * Qe[2], He = (ue[0] * Qe[3] - ue[1] * Qe[2] + Qe[2] * Qe[5] - Qe[4] * Qe[3]) / Ue, Ge = (-ue[0] * Qe[1] + ue[1] * Qe[0] + Qe[4] * Qe[1] - Qe[5] * Qe[0]) / Ue;
    return [He, Ge];
  }
  static getAxialAlignedBoundingBox(ue, Qe) {
    const Ue = this.applyTransform(ue, Qe), He = this.applyTransform(ue.slice(2, 4), Qe), Ge = this.applyTransform([ue[0], ue[3]], Qe), Xe = this.applyTransform([ue[2], ue[1]], Qe);
    return [Math.min(Ue[0], He[0], Ge[0], Xe[0]), Math.min(Ue[1], He[1], Ge[1], Xe[1]), Math.max(Ue[0], He[0], Ge[0], Xe[0]), Math.max(Ue[1], He[1], Ge[1], Xe[1])];
  }
  static inverseTransform(ue) {
    const Qe = ue[0] * ue[3] - ue[1] * ue[2];
    return [ue[3] / Qe, -ue[1] / Qe, -ue[2] / Qe, ue[0] / Qe, (ue[2] * ue[5] - ue[4] * ue[3]) / Qe, (ue[4] * ue[1] - ue[5] * ue[0]) / Qe];
  }
  static singularValueDecompose2dScale(ue) {
    const Qe = [ue[0], ue[2], ue[1], ue[3]], Ue = ue[0] * Qe[0] + ue[1] * Qe[2], He = ue[0] * Qe[1] + ue[1] * Qe[3], Ge = ue[2] * Qe[0] + ue[3] * Qe[2], Xe = ue[2] * Qe[1] + ue[3] * Qe[3], Ke = (Ue + Xe) / 2, $e = Math.sqrt((Ue + Xe) ** 2 - 4 * (Ue * Xe - Ge * He)) / 2, Je = Ke + $e || 1, Ze = Ke - $e || 1;
    return [Math.sqrt(Je), Math.sqrt(Ze)];
  }
  static normalizeRect(ue) {
    const Qe = ue.slice(0);
    return ue[0] > ue[2] && (Qe[0] = ue[2], Qe[2] = ue[0]), ue[1] > ue[3] && (Qe[1] = ue[3], Qe[3] = ue[1]), Qe;
  }
  static intersect(ue, Qe) {
    const Ue = Math.max(Math.min(ue[0], ue[2]), Math.min(Qe[0], Qe[2])), He = Math.min(Math.max(ue[0], ue[2]), Math.max(Qe[0], Qe[2]));
    if (Ue > He)
      return null;
    const Ge = Math.max(Math.min(ue[1], ue[3]), Math.min(Qe[1], Qe[3])), Xe = Math.min(Math.max(ue[1], ue[3]), Math.max(Qe[1], Qe[3]));
    return Ge > Xe ? null : [Ue, Ge, He, Xe];
  }
  static bezierBoundingBox(ue, Qe, Ue, He, Ge, Xe, Ke, $e, Je) {
    return Je ? (Je[0] = Math.min(Je[0], ue, Ke), Je[1] = Math.min(Je[1], Qe, $e), Je[2] = Math.max(Je[2], ue, Ke), Je[3] = Math.max(Je[3], Qe, $e)) : Je = [Math.min(ue, Ke), Math.min(Qe, $e), Math.max(ue, Ke), Math.max(Qe, $e)], en(this, Uo, xh).call(this, ue, Ue, Ge, Ke, Qe, He, Xe, $e, 3 * (-ue + 3 * (Ue - Ge) + Ke), 6 * (ue - 2 * Ue + Ge), 3 * (Ue - ue), Je), en(this, Uo, xh).call(this, ue, Ue, Ge, Ke, Qe, He, Xe, $e, 3 * (-Qe + 3 * (He - Xe) + $e), 6 * (Qe - 2 * He + Xe), 3 * (He - Qe), Je), Je;
  }
}
Uo = new WeakSet(), E2 = function(ue, Qe, Ue, He, Ge, Xe, Ke, $e, Je, Ze) {
  if (Je <= 0 || Je >= 1)
    return;
  const nt = 1 - Je, tt = Je * Je, et = tt * Je, rt = nt * (nt * (nt * ue + 3 * Je * Qe) + 3 * tt * Ue) + et * He, it = nt * (nt * (nt * Ge + 3 * Je * Xe) + 3 * tt * Ke) + et * $e;
  Ze[0] = Math.min(Ze[0], rt), Ze[1] = Math.min(Ze[1], it), Ze[2] = Math.max(Ze[2], rt), Ze[3] = Math.max(Ze[3], it);
}, xh = function(ue, Qe, Ue, He, Ge, Xe, Ke, $e, Je, Ze, nt, tt) {
  if (Math.abs(Je) < 1e-12) {
    Math.abs(Ze) >= 1e-12 && en(this, Uo, E2).call(this, ue, Qe, Ue, He, Ge, Xe, Ke, $e, -nt / Ze, tt);
    return;
  }
  const et = Ze ** 2 - 4 * nt * Je;
  if (et < 0)
    return;
  const rt = Math.sqrt(et), it = 2 * Je;
  en(this, Uo, E2).call(this, ue, Qe, Ue, He, Ge, Xe, Ke, $e, (-Ze + rt) / it, tt), en(this, Uo, E2).call(this, ue, Qe, Ue, He, Ge, Xe, Ke, $e, (-Ze - rt) / it, tt);
}, tn(Util, Uo);
function stringToUTF8String(me) {
  return decodeURIComponent(escape(me));
}
let NormalizeRegex = null, NormalizationMap = null;
function normalizeUnicode(me) {
  return NormalizeRegex || (NormalizeRegex = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu, NormalizationMap = /* @__PURE__ */ new Map([["ﬅ", "ſt"]])), me.replaceAll(NormalizeRegex, (ue, Qe, Ue) => Qe ? Qe.normalize("NFKC") : NormalizationMap.get(Ue));
}
function getUuid() {
  if (typeof crypto < "u" && typeof (crypto == null ? void 0 : crypto.randomUUID) == "function")
    return crypto.randomUUID();
  const me = new Uint8Array(32);
  if (typeof crypto < "u" && typeof (crypto == null ? void 0 : crypto.getRandomValues) == "function")
    crypto.getRandomValues(me);
  else
    for (let ue = 0; ue < 32; ue++)
      me[ue] = Math.floor(Math.random() * 255);
  return bytesToString(me);
}
const AnnotationPrefix = "pdfjs_internal_id_", FontRenderOps = {
  BEZIER_CURVE_TO: 0,
  MOVE_TO: 1,
  LINE_TO: 2,
  QUADRATIC_CURVE_TO: 3,
  RESTORE: 4,
  SAVE: 5,
  SCALE: 6,
  TRANSFORM: 7,
  TRANSLATE: 8
};
class BaseFilterFactory {
  constructor() {
    this.constructor === BaseFilterFactory && unreachable("Cannot initialize BaseFilterFactory.");
  }
  addFilter(ue) {
    return "none";
  }
  addHCMFilter(ue, Qe) {
    return "none";
  }
  addAlphaFilter(ue) {
    return "none";
  }
  addLuminosityFilter(ue) {
    return "none";
  }
  addHighlightHCMFilter(ue, Qe, Ue, He, Ge) {
    return "none";
  }
  destroy(ue = !1) {
  }
}
class BaseCanvasFactory {
  constructor() {
    this.constructor === BaseCanvasFactory && unreachable("Cannot initialize BaseCanvasFactory.");
  }
  create(ue, Qe) {
    if (ue <= 0 || Qe <= 0)
      throw new Error("Invalid canvas size");
    const Ue = this._createCanvas(ue, Qe);
    return {
      canvas: Ue,
      context: Ue.getContext("2d")
    };
  }
  reset(ue, Qe, Ue) {
    if (!ue.canvas)
      throw new Error("Canvas is not specified");
    if (Qe <= 0 || Ue <= 0)
      throw new Error("Invalid canvas size");
    ue.canvas.width = Qe, ue.canvas.height = Ue;
  }
  destroy(ue) {
    if (!ue.canvas)
      throw new Error("Canvas is not specified");
    ue.canvas.width = 0, ue.canvas.height = 0, ue.canvas = null, ue.context = null;
  }
  _createCanvas(ue, Qe) {
    unreachable("Abstract method `_createCanvas` called.");
  }
}
class BaseCMapReaderFactory {
  constructor({
    baseUrl: ue = null,
    isCompressed: Qe = !0
  }) {
    this.constructor === BaseCMapReaderFactory && unreachable("Cannot initialize BaseCMapReaderFactory."), this.baseUrl = ue, this.isCompressed = Qe;
  }
  async fetch({
    name: ue
  }) {
    if (!this.baseUrl)
      throw new Error('The CMap "baseUrl" parameter must be specified, ensure that the "cMapUrl" and "cMapPacked" API parameters are provided.');
    if (!ue)
      throw new Error("CMap name must be specified.");
    const Qe = this.baseUrl + ue + (this.isCompressed ? ".bcmap" : ""), Ue = this.isCompressed ? CMapCompressionType.BINARY : CMapCompressionType.NONE;
    return this._fetchData(Qe, Ue).catch((He) => {
      throw new Error(`Unable to load ${this.isCompressed ? "binary " : ""}CMap at: ${Qe}`);
    });
  }
  _fetchData(ue, Qe) {
    unreachable("Abstract method `_fetchData` called.");
  }
}
class BaseStandardFontDataFactory {
  constructor({
    baseUrl: ue = null
  }) {
    this.constructor === BaseStandardFontDataFactory && unreachable("Cannot initialize BaseStandardFontDataFactory."), this.baseUrl = ue;
  }
  async fetch({
    filename: ue
  }) {
    if (!this.baseUrl)
      throw new Error('The standard font "baseUrl" parameter must be specified, ensure that the "standardFontDataUrl" API parameter is provided.');
    if (!ue)
      throw new Error("Font filename must be specified.");
    const Qe = `${this.baseUrl}${ue}`;
    return this._fetchData(Qe).catch((Ue) => {
      throw new Error(`Unable to load font data at: ${Qe}`);
    });
  }
  _fetchData(ue) {
    unreachable("Abstract method `_fetchData` called.");
  }
}
class BaseSVGFactory {
  constructor() {
    this.constructor === BaseSVGFactory && unreachable("Cannot initialize BaseSVGFactory.");
  }
  create(ue, Qe, Ue = !1) {
    if (ue <= 0 || Qe <= 0)
      throw new Error("Invalid SVG dimensions");
    const He = this._createSVG("svg:svg");
    return He.setAttribute("version", "1.1"), Ue || (He.setAttribute("width", `${ue}px`), He.setAttribute("height", `${Qe}px`)), He.setAttribute("preserveAspectRatio", "none"), He.setAttribute("viewBox", `0 0 ${ue} ${Qe}`), He;
  }
  createElement(ue) {
    if (typeof ue != "string")
      throw new Error("Invalid SVG element type");
    return this._createSVG(ue);
  }
  _createSVG(ue) {
    unreachable("Abstract method `_createSVG` called.");
  }
}
const SVG_NS = "http://www.w3.org/2000/svg", zs = class zs {
};
$n(zs, "CSS", 96), $n(zs, "PDF", 72), $n(zs, "PDF_TO_CSS_UNITS", zs.CSS / zs.PDF);
let PixelsPerInch = zs;
var Ks, Ma, Eo, Vi, U2, Ys, Fn, Si, du, fu, C2, qA, bh, hu, Pl, kl, Sh, _l;
class DOMFilterFactory extends BaseFilterFactory {
  constructor({
    docId: Qe,
    ownerDocument: Ue = globalThis.document
  } = {}) {
    super();
    tn(this, Fn);
    tn(this, Ks);
    tn(this, Ma);
    tn(this, Eo);
    tn(this, Vi);
    tn(this, U2);
    tn(this, Ys, 0);
    Zt(this, Eo, Qe), Zt(this, Vi, Ue);
  }
  addFilter(Qe) {
    if (!Qe)
      return "none";
    let Ue = xt(this, Fn, Si).get(Qe);
    if (Ue)
      return Ue;
    const [He, Ge, Xe] = en(this, Fn, C2).call(this, Qe), Ke = Qe.length === 1 ? He : `${He}${Ge}${Xe}`;
    if (Ue = xt(this, Fn, Si).get(Ke), Ue)
      return xt(this, Fn, Si).set(Qe, Ue), Ue;
    const $e = `g_${xt(this, Eo)}_transfer_map_${Xi(this, Ys)._++}`, Je = `url(#${$e})`;
    xt(this, Fn, Si).set(Qe, Je), xt(this, Fn, Si).set(Ke, Je);
    const Ze = en(this, Fn, hu).call(this, $e);
    return en(this, Fn, kl).call(this, He, Ge, Xe, Ze), Je;
  }
  addHCMFilter(Qe, Ue) {
    var rt;
    const He = `${Qe}-${Ue}`, Ge = "base";
    let Xe = xt(this, Fn, du).get(Ge);
    if ((Xe == null ? void 0 : Xe.key) === He || (Xe ? ((rt = Xe.filter) == null || rt.remove(), Xe.key = He, Xe.url = "none", Xe.filter = null) : (Xe = {
      key: He,
      url: "none",
      filter: null
    }, xt(this, Fn, du).set(Ge, Xe)), !Qe || !Ue))
      return Xe.url;
    const Ke = en(this, Fn, _l).call(this, Qe);
    Qe = Util.makeHexColor(...Ke);
    const $e = en(this, Fn, _l).call(this, Ue);
    if (Ue = Util.makeHexColor(...$e), xt(this, Fn, fu).style.color = "", Qe === "#000000" && Ue === "#ffffff" || Qe === Ue)
      return Xe.url;
    const Je = new Array(256);
    for (let it = 0; it <= 255; it++) {
      const ot = it / 255;
      Je[it] = ot <= 0.03928 ? ot / 12.92 : ((ot + 0.055) / 1.055) ** 2.4;
    }
    const Ze = Je.join(","), nt = `g_${xt(this, Eo)}_hcm_filter`, tt = Xe.filter = en(this, Fn, hu).call(this, nt);
    en(this, Fn, kl).call(this, Ze, Ze, Ze, tt), en(this, Fn, bh).call(this, tt);
    const et = (it, ot) => {
      const at = Ke[it] / 255, st = $e[it] / 255, ut = new Array(ot + 1);
      for (let lt = 0; lt <= ot; lt++)
        ut[lt] = at + lt / ot * (st - at);
      return ut.join(",");
    };
    return en(this, Fn, kl).call(this, et(0, 5), et(1, 5), et(2, 5), tt), Xe.url = `url(#${nt})`, Xe.url;
  }
  addAlphaFilter(Qe) {
    let Ue = xt(this, Fn, Si).get(Qe);
    if (Ue)
      return Ue;
    const [He] = en(this, Fn, C2).call(this, [Qe]), Ge = `alpha_${He}`;
    if (Ue = xt(this, Fn, Si).get(Ge), Ue)
      return xt(this, Fn, Si).set(Qe, Ue), Ue;
    const Xe = `g_${xt(this, Eo)}_alpha_map_${Xi(this, Ys)._++}`, Ke = `url(#${Xe})`;
    xt(this, Fn, Si).set(Qe, Ke), xt(this, Fn, Si).set(Ge, Ke);
    const $e = en(this, Fn, hu).call(this, Xe);
    return en(this, Fn, Sh).call(this, He, $e), Ke;
  }
  addLuminosityFilter(Qe) {
    let Ue = xt(this, Fn, Si).get(Qe || "luminosity");
    if (Ue)
      return Ue;
    let He, Ge;
    if (Qe ? ([He] = en(this, Fn, C2).call(this, [Qe]), Ge = `luminosity_${He}`) : Ge = "luminosity", Ue = xt(this, Fn, Si).get(Ge), Ue)
      return xt(this, Fn, Si).set(Qe, Ue), Ue;
    const Xe = `g_${xt(this, Eo)}_luminosity_map_${Xi(this, Ys)._++}`, Ke = `url(#${Xe})`;
    xt(this, Fn, Si).set(Qe, Ke), xt(this, Fn, Si).set(Ge, Ke);
    const $e = en(this, Fn, hu).call(this, Xe);
    return en(this, Fn, qA).call(this, $e), Qe && en(this, Fn, Sh).call(this, He, $e), Ke;
  }
  addHighlightHCMFilter(Qe, Ue, He, Ge, Xe) {
    var st;
    const Ke = `${Ue}-${He}-${Ge}-${Xe}`;
    let $e = xt(this, Fn, du).get(Qe);
    if (($e == null ? void 0 : $e.key) === Ke || ($e ? ((st = $e.filter) == null || st.remove(), $e.key = Ke, $e.url = "none", $e.filter = null) : ($e = {
      key: Ke,
      url: "none",
      filter: null
    }, xt(this, Fn, du).set(Qe, $e)), !Ue || !He))
      return $e.url;
    const [Je, Ze] = [Ue, He].map(en(this, Fn, _l).bind(this));
    let nt = Math.round(0.2126 * Je[0] + 0.7152 * Je[1] + 0.0722 * Je[2]), tt = Math.round(0.2126 * Ze[0] + 0.7152 * Ze[1] + 0.0722 * Ze[2]), [et, rt] = [Ge, Xe].map(en(this, Fn, _l).bind(this));
    tt < nt && ([nt, tt, et, rt] = [tt, nt, rt, et]), xt(this, Fn, fu).style.color = "";
    const it = (ut, lt, dt) => {
      const At = new Array(256), pt = (tt - nt) / dt, gt = ut / 255, wt = (lt - ut) / (255 * dt);
      let Bt = 0;
      for (let Tt = 0; Tt <= dt; Tt++) {
        const yt = Math.round(nt + Tt * pt), Ct = gt + Tt * wt;
        for (let ht = Bt; ht <= yt; ht++)
          At[ht] = Ct;
        Bt = yt + 1;
      }
      for (let Tt = Bt; Tt < 256; Tt++)
        At[Tt] = At[Bt - 1];
      return At.join(",");
    }, ot = `g_${xt(this, Eo)}_hcm_${Qe}_filter`, at = $e.filter = en(this, Fn, hu).call(this, ot);
    return en(this, Fn, bh).call(this, at), en(this, Fn, kl).call(this, it(et[0], rt[0], 5), it(et[1], rt[1], 5), it(et[2], rt[2], 5), at), $e.url = `url(#${ot})`, $e.url;
  }
  destroy(Qe = !1) {
    Qe && xt(this, Fn, du).size !== 0 || (xt(this, Ma) && (xt(this, Ma).parentNode.parentNode.remove(), Zt(this, Ma, null)), xt(this, Ks) && (xt(this, Ks).clear(), Zt(this, Ks, null)), Zt(this, Ys, 0));
  }
}
Ks = new WeakMap(), Ma = new WeakMap(), Eo = new WeakMap(), Vi = new WeakMap(), U2 = new WeakMap(), Ys = new WeakMap(), Fn = new WeakSet(), Si = function() {
  return xt(this, Ks) || Zt(this, Ks, /* @__PURE__ */ new Map());
}, du = function() {
  return xt(this, U2) || Zt(this, U2, /* @__PURE__ */ new Map());
}, fu = function() {
  if (!xt(this, Ma)) {
    const Qe = xt(this, Vi).createElement("div"), {
      style: Ue
    } = Qe;
    Ue.visibility = "hidden", Ue.contain = "strict", Ue.width = Ue.height = 0, Ue.position = "absolute", Ue.top = Ue.left = 0, Ue.zIndex = -1;
    const He = xt(this, Vi).createElementNS(SVG_NS, "svg");
    He.setAttribute("width", 0), He.setAttribute("height", 0), Zt(this, Ma, xt(this, Vi).createElementNS(SVG_NS, "defs")), Qe.append(He), He.append(xt(this, Ma)), xt(this, Vi).body.append(Qe);
  }
  return xt(this, Ma);
}, C2 = function(Qe) {
  if (Qe.length === 1) {
    const Je = Qe[0], Ze = new Array(256);
    for (let tt = 0; tt < 256; tt++)
      Ze[tt] = Je[tt] / 255;
    const nt = Ze.join(",");
    return [nt, nt, nt];
  }
  const [Ue, He, Ge] = Qe, Xe = new Array(256), Ke = new Array(256), $e = new Array(256);
  for (let Je = 0; Je < 256; Je++)
    Xe[Je] = Ue[Je] / 255, Ke[Je] = He[Je] / 255, $e[Je] = Ge[Je] / 255;
  return [Xe.join(","), Ke.join(","), $e.join(",")];
}, qA = function(Qe) {
  const Ue = xt(this, Vi).createElementNS(SVG_NS, "feColorMatrix");
  Ue.setAttribute("type", "matrix"), Ue.setAttribute("values", "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0.59 0.11 0 0"), Qe.append(Ue);
}, bh = function(Qe) {
  const Ue = xt(this, Vi).createElementNS(SVG_NS, "feColorMatrix");
  Ue.setAttribute("type", "matrix"), Ue.setAttribute("values", "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"), Qe.append(Ue);
}, hu = function(Qe) {
  const Ue = xt(this, Vi).createElementNS(SVG_NS, "filter");
  return Ue.setAttribute("color-interpolation-filters", "sRGB"), Ue.setAttribute("id", Qe), xt(this, Fn, fu).append(Ue), Ue;
}, Pl = function(Qe, Ue, He) {
  const Ge = xt(this, Vi).createElementNS(SVG_NS, Ue);
  Ge.setAttribute("type", "discrete"), Ge.setAttribute("tableValues", He), Qe.append(Ge);
}, kl = function(Qe, Ue, He, Ge) {
  const Xe = xt(this, Vi).createElementNS(SVG_NS, "feComponentTransfer");
  Ge.append(Xe), en(this, Fn, Pl).call(this, Xe, "feFuncR", Qe), en(this, Fn, Pl).call(this, Xe, "feFuncG", Ue), en(this, Fn, Pl).call(this, Xe, "feFuncB", He);
}, Sh = function(Qe, Ue) {
  const He = xt(this, Vi).createElementNS(SVG_NS, "feComponentTransfer");
  Ue.append(He), en(this, Fn, Pl).call(this, He, "feFuncA", Qe);
}, _l = function(Qe) {
  return xt(this, Fn, fu).style.color = Qe, getRGB(getComputedStyle(xt(this, Fn, fu)).getPropertyValue("color"));
};
class DOMCanvasFactory extends BaseCanvasFactory {
  constructor({
    ownerDocument: ue = globalThis.document
  } = {}) {
    super(), this._document = ue;
  }
  _createCanvas(ue, Qe) {
    const Ue = this._document.createElement("canvas");
    return Ue.width = ue, Ue.height = Qe, Ue;
  }
}
async function fetchData(me, ue = "text") {
  if (isValidFetchUrl(me, document.baseURI)) {
    const Qe = await fetch(me);
    if (!Qe.ok)
      throw new Error(Qe.statusText);
    switch (ue) {
      case "arraybuffer":
        return Qe.arrayBuffer();
      case "blob":
        return Qe.blob();
      case "json":
        return Qe.json();
    }
    return Qe.text();
  }
  return new Promise((Qe, Ue) => {
    const He = new XMLHttpRequest();
    He.open("GET", me, !0), He.responseType = ue, He.onreadystatechange = () => {
      if (He.readyState === XMLHttpRequest.DONE) {
        if (He.status === 200 || He.status === 0) {
          switch (ue) {
            case "arraybuffer":
            case "blob":
            case "json":
              Qe(He.response);
              return;
          }
          Qe(He.responseText);
          return;
        }
        Ue(new Error(He.statusText));
      }
    }, He.send(null);
  });
}
class DOMCMapReaderFactory extends BaseCMapReaderFactory {
  _fetchData(ue, Qe) {
    return fetchData(ue, this.isCompressed ? "arraybuffer" : "text").then((Ue) => ({
      cMapData: Ue instanceof ArrayBuffer ? new Uint8Array(Ue) : stringToBytes(Ue),
      compressionType: Qe
    }));
  }
}
class DOMStandardFontDataFactory extends BaseStandardFontDataFactory {
  _fetchData(ue) {
    return fetchData(ue, "arraybuffer").then((Qe) => new Uint8Array(Qe));
  }
}
class DOMSVGFactory extends BaseSVGFactory {
  _createSVG(ue) {
    return document.createElementNS(SVG_NS, ue);
  }
}
class PageViewport {
  constructor({
    viewBox: ue,
    scale: Qe,
    rotation: Ue,
    offsetX: He = 0,
    offsetY: Ge = 0,
    dontFlip: Xe = !1
  }) {
    this.viewBox = ue, this.scale = Qe, this.rotation = Ue, this.offsetX = He, this.offsetY = Ge;
    const Ke = (ue[2] + ue[0]) / 2, $e = (ue[3] + ue[1]) / 2;
    let Je, Ze, nt, tt;
    switch (Ue %= 360, Ue < 0 && (Ue += 360), Ue) {
      case 180:
        Je = -1, Ze = 0, nt = 0, tt = 1;
        break;
      case 90:
        Je = 0, Ze = 1, nt = 1, tt = 0;
        break;
      case 270:
        Je = 0, Ze = -1, nt = -1, tt = 0;
        break;
      case 0:
        Je = 1, Ze = 0, nt = 0, tt = -1;
        break;
      default:
        throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
    }
    Xe && (nt = -nt, tt = -tt);
    let et, rt, it, ot;
    Je === 0 ? (et = Math.abs($e - ue[1]) * Qe + He, rt = Math.abs(Ke - ue[0]) * Qe + Ge, it = (ue[3] - ue[1]) * Qe, ot = (ue[2] - ue[0]) * Qe) : (et = Math.abs(Ke - ue[0]) * Qe + He, rt = Math.abs($e - ue[1]) * Qe + Ge, it = (ue[2] - ue[0]) * Qe, ot = (ue[3] - ue[1]) * Qe), this.transform = [Je * Qe, Ze * Qe, nt * Qe, tt * Qe, et - Je * Qe * Ke - nt * Qe * $e, rt - Ze * Qe * Ke - tt * Qe * $e], this.width = it, this.height = ot;
  }
  get rawDims() {
    const {
      viewBox: ue
    } = this;
    return shadow(this, "rawDims", {
      pageWidth: ue[2] - ue[0],
      pageHeight: ue[3] - ue[1],
      pageX: ue[0],
      pageY: ue[1]
    });
  }
  clone({
    scale: ue = this.scale,
    rotation: Qe = this.rotation,
    offsetX: Ue = this.offsetX,
    offsetY: He = this.offsetY,
    dontFlip: Ge = !1
  } = {}) {
    return new PageViewport({
      viewBox: this.viewBox.slice(),
      scale: ue,
      rotation: Qe,
      offsetX: Ue,
      offsetY: He,
      dontFlip: Ge
    });
  }
  convertToViewportPoint(ue, Qe) {
    return Util.applyTransform([ue, Qe], this.transform);
  }
  convertToViewportRectangle(ue) {
    const Qe = Util.applyTransform([ue[0], ue[1]], this.transform), Ue = Util.applyTransform([ue[2], ue[3]], this.transform);
    return [Qe[0], Qe[1], Ue[0], Ue[1]];
  }
  convertToPdfPoint(ue, Qe) {
    return Util.applyInverseTransform([ue, Qe], this.transform);
  }
}
class RenderingCancelledException extends BaseException {
  constructor(ue, Qe = 0) {
    super(ue, "RenderingCancelledException"), this.extraDelay = Qe;
  }
}
function isDataScheme(me) {
  const ue = me.length;
  let Qe = 0;
  for (; Qe < ue && me[Qe].trim() === ""; )
    Qe++;
  return me.substring(Qe, Qe + 5).toLowerCase() === "data:";
}
function isPdfFile(me) {
  return typeof me == "string" && /\.pdf$/i.test(me);
}
function getFilenameFromUrl(me) {
  return [me] = me.split(/[#?]/, 1), me.substring(me.lastIndexOf("/") + 1);
}
function getPdfFilenameFromUrl(me, ue = "document.pdf") {
  if (typeof me != "string")
    return ue;
  if (isDataScheme(me))
    return warn('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.'), ue;
  const Qe = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/, Ue = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i, He = Qe.exec(me);
  let Ge = Ue.exec(He[1]) || Ue.exec(He[2]) || Ue.exec(He[3]);
  if (Ge && (Ge = Ge[0], Ge.includes("%")))
    try {
      Ge = Ue.exec(decodeURIComponent(Ge))[0];
    } catch {
    }
  return Ge || ue;
}
class StatTimer {
  constructor() {
    $n(this, "started", /* @__PURE__ */ Object.create(null));
    $n(this, "times", []);
  }
  time(ue) {
    ue in this.started && warn(`Timer is already running for ${ue}`), this.started[ue] = Date.now();
  }
  timeEnd(ue) {
    ue in this.started || warn(`Timer has not been started for ${ue}`), this.times.push({
      name: ue,
      start: this.started[ue],
      end: Date.now()
    }), delete this.started[ue];
  }
  toString() {
    const ue = [];
    let Qe = 0;
    for (const {
      name: Ue
    } of this.times)
      Qe = Math.max(Ue.length, Qe);
    for (const {
      name: Ue,
      start: He,
      end: Ge
    } of this.times)
      ue.push(`${Ue.padEnd(Qe)} ${Ge - He}ms
`);
    return ue.join("");
  }
}
function isValidFetchUrl(me, ue) {
  try {
    const {
      protocol: Qe
    } = ue ? new URL(me, ue) : new URL(me);
    return Qe === "http:" || Qe === "https:";
  } catch {
    return !1;
  }
}
function noContextMenu(me) {
  me.preventDefault();
}
function deprecated(me) {
  console.log("Deprecated API usage: " + me);
}
let pdfDateStringRegex;
class PDFDateString {
  static toDateObject(ue) {
    if (!ue || typeof ue != "string")
      return null;
    pdfDateStringRegex || (pdfDateStringRegex = new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?"));
    const Qe = pdfDateStringRegex.exec(ue);
    if (!Qe)
      return null;
    const Ue = parseInt(Qe[1], 10);
    let He = parseInt(Qe[2], 10);
    He = He >= 1 && He <= 12 ? He - 1 : 0;
    let Ge = parseInt(Qe[3], 10);
    Ge = Ge >= 1 && Ge <= 31 ? Ge : 1;
    let Xe = parseInt(Qe[4], 10);
    Xe = Xe >= 0 && Xe <= 23 ? Xe : 0;
    let Ke = parseInt(Qe[5], 10);
    Ke = Ke >= 0 && Ke <= 59 ? Ke : 0;
    let $e = parseInt(Qe[6], 10);
    $e = $e >= 0 && $e <= 59 ? $e : 0;
    const Je = Qe[7] || "Z";
    let Ze = parseInt(Qe[8], 10);
    Ze = Ze >= 0 && Ze <= 23 ? Ze : 0;
    let nt = parseInt(Qe[9], 10) || 0;
    return nt = nt >= 0 && nt <= 59 ? nt : 0, Je === "-" ? (Xe += Ze, Ke += nt) : Je === "+" && (Xe -= Ze, Ke -= nt), new Date(Date.UTC(Ue, He, Ge, Xe, Ke, $e));
  }
}
function getXfaPageViewport(me, {
  scale: ue = 1,
  rotation: Qe = 0
}) {
  const {
    width: Ue,
    height: He
  } = me.attributes.style, Ge = [0, 0, parseInt(Ue), parseInt(He)];
  return new PageViewport({
    viewBox: Ge,
    scale: ue,
    rotation: Qe
  });
}
function getRGB(me) {
  if (me.startsWith("#")) {
    const ue = parseInt(me.slice(1), 16);
    return [(ue & 16711680) >> 16, (ue & 65280) >> 8, ue & 255];
  }
  return me.startsWith("rgb(") ? me.slice(4, -1).split(",").map((ue) => parseInt(ue)) : me.startsWith("rgba(") ? me.slice(5, -1).split(",").map((ue) => parseInt(ue)).slice(0, 3) : (warn(`Not a valid color format: "${me}"`), [0, 0, 0]);
}
function getColorValues(me) {
  const ue = document.createElement("span");
  ue.style.visibility = "hidden", document.body.append(ue);
  for (const Qe of me.keys()) {
    ue.style.color = Qe;
    const Ue = window.getComputedStyle(ue).color;
    me.set(Qe, getRGB(Ue));
  }
  ue.remove();
}
function getCurrentTransform(me) {
  const {
    a: ue,
    b: Qe,
    c: Ue,
    d: He,
    e: Ge,
    f: Xe
  } = me.getTransform();
  return [ue, Qe, Ue, He, Ge, Xe];
}
function getCurrentTransformInverse(me) {
  const {
    a: ue,
    b: Qe,
    c: Ue,
    d: He,
    e: Ge,
    f: Xe
  } = me.getTransform().invertSelf();
  return [ue, Qe, Ue, He, Ge, Xe];
}
function setLayerDimensions(me, ue, Qe = !1, Ue = !0) {
  if (ue instanceof PageViewport) {
    const {
      pageWidth: He,
      pageHeight: Ge
    } = ue.rawDims, {
      style: Xe
    } = me, Ke = util_FeatureTest.isCSSRoundSupported, $e = `var(--scale-factor) * ${He}px`, Je = `var(--scale-factor) * ${Ge}px`, Ze = Ke ? `round(${$e}, 1px)` : `calc(${$e})`, nt = Ke ? `round(${Je}, 1px)` : `calc(${Je})`;
    !Qe || ue.rotation % 180 === 0 ? (Xe.width = Ze, Xe.height = nt) : (Xe.width = nt, Xe.height = Ze);
  }
  Ue && me.setAttribute("data-main-rotation", ue.rotation);
}
var $s, Js, Qa, Zs, H2, zA, Pi, XA, KA, v2, YA, wh;
const G2 = class G2 {
  constructor(ue) {
    tn(this, Pi);
    tn(this, $s, null);
    tn(this, Js, null);
    tn(this, Qa);
    tn(this, Zs, null);
    Zt(this, Qa, ue);
  }
  render() {
    const ue = Zt(this, $s, document.createElement("div"));
    ue.className = "editToolbar", ue.setAttribute("role", "toolbar"), ue.addEventListener("contextmenu", noContextMenu), ue.addEventListener("pointerdown", en(G2, H2, zA));
    const Qe = Zt(this, Zs, document.createElement("div"));
    Qe.className = "buttons", ue.append(Qe);
    const Ue = xt(this, Qa).toolbarPosition;
    if (Ue) {
      const {
        style: He
      } = ue, Ge = xt(this, Qa)._uiManager.direction === "ltr" ? 1 - Ue[0] : Ue[0];
      He.insetInlineEnd = `${100 * Ge}%`, He.top = `calc(${100 * Ue[1]}% + var(--editor-toolbar-vert-offset))`;
    }
    return en(this, Pi, YA).call(this), ue;
  }
  hide() {
    var ue;
    xt(this, $s).classList.add("hidden"), (ue = xt(this, Js)) == null || ue.hideDropdown();
  }
  show() {
    xt(this, $s).classList.remove("hidden");
  }
  addAltTextButton(ue) {
    en(this, Pi, v2).call(this, ue), xt(this, Zs).prepend(ue, xt(this, Pi, wh));
  }
  addColorPicker(ue) {
    Zt(this, Js, ue);
    const Qe = ue.renderButton();
    en(this, Pi, v2).call(this, Qe), xt(this, Zs).prepend(Qe, xt(this, Pi, wh));
  }
  remove() {
    var ue;
    xt(this, $s).remove(), (ue = xt(this, Js)) == null || ue.destroy(), Zt(this, Js, null);
  }
};
$s = new WeakMap(), Js = new WeakMap(), Qa = new WeakMap(), Zs = new WeakMap(), H2 = new WeakSet(), zA = function(ue) {
  ue.stopPropagation();
}, Pi = new WeakSet(), XA = function(ue) {
  xt(this, Qa)._focusEventsAllowed = !1, ue.preventDefault(), ue.stopPropagation();
}, KA = function(ue) {
  xt(this, Qa)._focusEventsAllowed = !0, ue.preventDefault(), ue.stopPropagation();
}, v2 = function(ue) {
  ue.addEventListener("focusin", en(this, Pi, XA).bind(this), {
    capture: !0
  }), ue.addEventListener("focusout", en(this, Pi, KA).bind(this), {
    capture: !0
  }), ue.addEventListener("contextmenu", noContextMenu);
}, YA = function() {
  const ue = document.createElement("button");
  ue.className = "delete", ue.tabIndex = 0, ue.setAttribute("data-l10n-id", `pdfjs-editor-remove-${xt(this, Qa).editorType}-button`), en(this, Pi, v2).call(this, ue), ue.addEventListener("click", (Qe) => {
    xt(this, Qa)._uiManager.delete();
  }), xt(this, Zs).append(ue);
}, wh = function() {
  const ue = document.createElement("div");
  return ue.className = "divider", ue;
}, tn(G2, H2);
let EditorToolbar = G2;
var zl, ec, Xl, Ss, $A, JA, ZA;
class HighlightToolbar {
  constructor(ue) {
    tn(this, Ss);
    tn(this, zl, null);
    tn(this, ec, null);
    tn(this, Xl);
    Zt(this, Xl, ue);
  }
  show(ue, Qe, Ue) {
    const [He, Ge] = en(this, Ss, JA).call(this, Qe, Ue), {
      style: Xe
    } = xt(this, ec) || Zt(this, ec, en(this, Ss, $A).call(this));
    ue.append(xt(this, ec)), Xe.insetInlineEnd = `${100 * He}%`, Xe.top = `calc(${100 * Ge}% + var(--editor-toolbar-vert-offset))`;
  }
  hide() {
    xt(this, ec).remove();
  }
}
zl = new WeakMap(), ec = new WeakMap(), Xl = new WeakMap(), Ss = new WeakSet(), $A = function() {
  const ue = Zt(this, ec, document.createElement("div"));
  ue.className = "editToolbar", ue.setAttribute("role", "toolbar"), ue.addEventListener("contextmenu", noContextMenu);
  const Qe = Zt(this, zl, document.createElement("div"));
  return Qe.className = "buttons", ue.append(Qe), en(this, Ss, ZA).call(this), ue;
}, JA = function(ue, Qe) {
  let Ue = 0, He = 0;
  for (const Ge of ue) {
    const Xe = Ge.y + Ge.height;
    if (Xe < Ue)
      continue;
    const Ke = Ge.x + (Qe ? Ge.width : 0);
    if (Xe > Ue) {
      He = Ke, Ue = Xe;
      continue;
    }
    Qe ? Ke > He && (He = Ke) : Ke < He && (He = Ke);
  }
  return [Qe ? 1 - He : He, Ue];
}, ZA = function() {
  const ue = document.createElement("button");
  ue.className = "highlightButton", ue.tabIndex = 0, ue.setAttribute("data-l10n-id", "pdfjs-highlight-floating-button1");
  const Qe = document.createElement("span");
  ue.append(Qe), Qe.className = "visuallyHidden", Qe.setAttribute("data-l10n-id", "pdfjs-highlight-floating-button-label"), ue.addEventListener("contextmenu", noContextMenu), ue.addEventListener("click", () => {
    xt(this, Xl).highlightSelection("floating_button");
  }), xt(this, zl).append(ue);
};
function bindEvents(me, ue, Qe) {
  for (const Ue of Qe)
    ue.addEventListener(Ue, me[Ue].bind(me));
}
function opacityToHex(me) {
  return Math.round(Math.min(255, Math.max(1, 255 * me))).toString(16).padStart(2, "0");
}
var W2;
class IdManager {
  constructor() {
    tn(this, W2, 0);
  }
  get id() {
    return `${AnnotationEditorPrefix}${Xi(this, W2)._++}`;
  }
}
W2 = new WeakMap();
var Kl, q2, da, Yl, Th;
const y1 = class y1 {
  constructor() {
    tn(this, Yl);
    tn(this, Kl, getUuid());
    tn(this, q2, 0);
    tn(this, da, null);
  }
  static get _isSVGFittingCanvas() {
    const ue = 'data:image/svg+xml;charset=UTF-8,<svg viewBox="0 0 1 1" width="1" height="1" xmlns="http://www.w3.org/2000/svg"><rect width="1" height="1" style="fill:red;"/></svg>', Ue = new OffscreenCanvas(1, 3).getContext("2d"), He = new Image();
    He.src = ue;
    const Ge = He.decode().then(() => (Ue.drawImage(He, 0, 0, 1, 1, 0, 0, 1, 3), new Uint32Array(Ue.getImageData(0, 0, 1, 1).data.buffer)[0] === 0));
    return shadow(this, "_isSVGFittingCanvas", Ge);
  }
  async getFromFile(ue) {
    const {
      lastModified: Qe,
      name: Ue,
      size: He,
      type: Ge
    } = ue;
    return en(this, Yl, Th).call(this, `${Qe}_${Ue}_${He}_${Ge}`, ue);
  }
  async getFromUrl(ue) {
    return en(this, Yl, Th).call(this, ue, ue);
  }
  async getFromId(ue) {
    xt(this, da) || Zt(this, da, /* @__PURE__ */ new Map());
    const Qe = xt(this, da).get(ue);
    return Qe ? Qe.bitmap ? (Qe.refCounter += 1, Qe) : Qe.file ? this.getFromFile(Qe.file) : this.getFromUrl(Qe.url) : null;
  }
  getSvgUrl(ue) {
    const Qe = xt(this, da).get(ue);
    return Qe != null && Qe.isSvg ? Qe.svgUrl : null;
  }
  deleteId(ue) {
    xt(this, da) || Zt(this, da, /* @__PURE__ */ new Map());
    const Qe = xt(this, da).get(ue);
    Qe && (Qe.refCounter -= 1, Qe.refCounter === 0 && (Qe.bitmap = null));
  }
  isValidId(ue) {
    return ue.startsWith(`image_${xt(this, Kl)}_`);
  }
};
Kl = new WeakMap(), q2 = new WeakMap(), da = new WeakMap(), Yl = new WeakSet(), Th = async function(ue, Qe) {
  xt(this, da) || Zt(this, da, /* @__PURE__ */ new Map());
  let Ue = xt(this, da).get(ue);
  if (Ue === null)
    return null;
  if (Ue != null && Ue.bitmap)
    return Ue.refCounter += 1, Ue;
  try {
    Ue || (Ue = {
      bitmap: null,
      id: `image_${xt(this, Kl)}_${Xi(this, q2)._++}`,
      refCounter: 0,
      isSvg: !1
    });
    let He;
    if (typeof Qe == "string" ? (Ue.url = Qe, He = await fetchData(Qe, "blob")) : He = Ue.file = Qe, He.type === "image/svg+xml") {
      const Ge = y1._isSVGFittingCanvas, Xe = new FileReader(), Ke = new Image(), $e = new Promise((Je, Ze) => {
        Ke.onload = () => {
          Ue.bitmap = Ke, Ue.isSvg = !0, Je();
        }, Xe.onload = async () => {
          const nt = Ue.svgUrl = Xe.result;
          Ke.src = await Ge ? `${nt}#svgView(preserveAspectRatio(none))` : nt;
        }, Ke.onerror = Xe.onerror = Ze;
      });
      Xe.readAsDataURL(He), await $e;
    } else
      Ue.bitmap = await createImageBitmap(He);
    Ue.refCounter = 1;
  } catch (He) {
    console.error(He), Ue = null;
  }
  return xt(this, da).set(ue, Ue), Ue && xt(this, da).set(Ue.id, Ue), Ue;
};
let ImageManager = y1;
var ci, is, $l, ui;
class CommandManager {
  constructor(ue = 128) {
    tn(this, ci, []);
    tn(this, is, !1);
    tn(this, $l);
    tn(this, ui, -1);
    Zt(this, $l, ue);
  }
  add({
    cmd: ue,
    undo: Qe,
    post: Ue,
    mustExec: He,
    type: Ge = NaN,
    overwriteIfSameType: Xe = !1,
    keepUndo: Ke = !1
  }) {
    if (He && ue(), xt(this, is))
      return;
    const $e = {
      cmd: ue,
      undo: Qe,
      post: Ue,
      type: Ge
    };
    if (xt(this, ui) === -1) {
      xt(this, ci).length > 0 && (xt(this, ci).length = 0), Zt(this, ui, 0), xt(this, ci).push($e);
      return;
    }
    if (Xe && xt(this, ci)[xt(this, ui)].type === Ge) {
      Ke && ($e.undo = xt(this, ci)[xt(this, ui)].undo), xt(this, ci)[xt(this, ui)] = $e;
      return;
    }
    const Je = xt(this, ui) + 1;
    Je === xt(this, $l) ? xt(this, ci).splice(0, 1) : (Zt(this, ui, Je), Je < xt(this, ci).length && xt(this, ci).splice(Je)), xt(this, ci).push($e);
  }
  undo() {
    if (xt(this, ui) === -1)
      return;
    Zt(this, is, !0);
    const {
      undo: ue,
      post: Qe
    } = xt(this, ci)[xt(this, ui)];
    ue(), Qe == null || Qe(), Zt(this, is, !1), Zt(this, ui, xt(this, ui) - 1);
  }
  redo() {
    if (xt(this, ui) < xt(this, ci).length - 1) {
      Zt(this, ui, xt(this, ui) + 1), Zt(this, is, !0);
      const {
        cmd: ue,
        post: Qe
      } = xt(this, ci)[xt(this, ui)];
      ue(), Qe == null || Qe(), Zt(this, is, !1);
    }
  }
  hasSomethingToUndo() {
    return xt(this, ui) !== -1;
  }
  hasSomethingToRedo() {
    return xt(this, ui) < xt(this, ci).length - 1;
  }
  destroy() {
    Zt(this, ci, null);
  }
}
ci = new WeakMap(), is = new WeakMap(), $l = new WeakMap(), ui = new WeakMap();
var z2, eg;
class KeyboardManager {
  constructor(ue) {
    tn(this, z2);
    this.buffer = [], this.callbacks = /* @__PURE__ */ new Map(), this.allKeys = /* @__PURE__ */ new Set();
    const {
      isMac: Qe
    } = util_FeatureTest.platform;
    for (const [Ue, He, Ge = {}] of ue)
      for (const Xe of Ue) {
        const Ke = Xe.startsWith("mac+");
        Qe && Ke ? (this.callbacks.set(Xe.slice(4), {
          callback: He,
          options: Ge
        }), this.allKeys.add(Xe.split("+").at(-1))) : !Qe && !Ke && (this.callbacks.set(Xe, {
          callback: He,
          options: Ge
        }), this.allKeys.add(Xe.split("+").at(-1)));
      }
  }
  exec(ue, Qe) {
    if (!this.allKeys.has(Qe.key))
      return;
    const Ue = this.callbacks.get(en(this, z2, eg).call(this, Qe));
    if (!Ue)
      return;
    const {
      callback: He,
      options: {
        bubbles: Ge = !1,
        args: Xe = [],
        checker: Ke = null
      }
    } = Ue;
    Ke && !Ke(ue, Qe) || (He.bind(ue, ...Xe, Qe)(), Ge || (Qe.stopPropagation(), Qe.preventDefault()));
  }
}
z2 = new WeakSet(), eg = function(ue) {
  ue.altKey && this.buffer.push("alt"), ue.ctrlKey && this.buffer.push("ctrl"), ue.metaKey && this.buffer.push("meta"), ue.shiftKey && this.buffer.push("shift"), this.buffer.push(ue.key);
  const Qe = this.buffer.join("+");
  return this.buffer.length = 0, Qe;
};
const X2 = class X2 {
  get _colors() {
    const ue = /* @__PURE__ */ new Map([["CanvasText", null], ["Canvas", null]]);
    return getColorValues(ue), shadow(this, "_colors", ue);
  }
  convert(ue) {
    const Qe = getRGB(ue);
    if (!window.matchMedia("(forced-colors: active)").matches)
      return Qe;
    for (const [Ue, He] of this._colors)
      if (He.every((Ge, Xe) => Ge === Qe[Xe]))
        return X2._colorsMapping.get(Ue);
    return Qe;
  }
  getHexCode(ue) {
    const Qe = this._colors.get(ue);
    return Qe ? Util.makeHexColor(...Qe) : ue;
  }
};
$n(X2, "_colorsMapping", /* @__PURE__ */ new Map([["CanvasText", [0, 0, 0]], ["Canvas", [255, 255, 255]]]));
let ColorManager = X2;
var Yi, ti, hi, Eu, Co, Cu, va, vu, tc, Fa, vo, nc, Jl, Zl, ja, yu, as, Va, K2, os, e0, rc, t0, Iu, pi, wr, yo, ic, n0, r0, i0, a0, o0, s0, c0, u0, l0, d0, f0, h0, p0, A0, ss, Ua, Io, g0, Dn, y2, tg, ng, I2, rg, ig, ag, Bh, Rh, Oh, Nh, Dh, Ri, ns, og, sg, Ph, cg, Ll, kh;
const mu = class mu {
  constructor(ue, Qe, Ue, He, Ge, Xe, Ke, $e, Je) {
    tn(this, Dn);
    tn(this, Yi, null);
    tn(this, ti, /* @__PURE__ */ new Map());
    tn(this, hi, /* @__PURE__ */ new Map());
    tn(this, Eu, null);
    tn(this, Co, null);
    tn(this, Cu, null);
    tn(this, va, new CommandManager());
    tn(this, vu, 0);
    tn(this, tc, /* @__PURE__ */ new Set());
    tn(this, Fa, null);
    tn(this, vo, null);
    tn(this, nc, /* @__PURE__ */ new Set());
    tn(this, Jl, !1);
    tn(this, Zl, null);
    tn(this, ja, null);
    tn(this, yu, null);
    tn(this, as, !1);
    tn(this, Va, null);
    tn(this, K2, new IdManager());
    tn(this, os, !1);
    tn(this, e0, !1);
    tn(this, rc, null);
    tn(this, t0, null);
    tn(this, Iu, null);
    tn(this, pi, AnnotationEditorType.NONE);
    tn(this, wr, /* @__PURE__ */ new Set());
    tn(this, yo, null);
    tn(this, ic, null);
    tn(this, n0, null);
    tn(this, r0, this.blur.bind(this));
    tn(this, i0, this.focus.bind(this));
    tn(this, a0, this.copy.bind(this));
    tn(this, o0, this.cut.bind(this));
    tn(this, s0, this.paste.bind(this));
    tn(this, c0, this.keydown.bind(this));
    tn(this, u0, this.keyup.bind(this));
    tn(this, l0, this.onEditingAction.bind(this));
    tn(this, d0, this.onPageChanging.bind(this));
    tn(this, f0, this.onScaleChanging.bind(this));
    tn(this, h0, en(this, Dn, ng).bind(this));
    tn(this, p0, this.onRotationChanging.bind(this));
    tn(this, A0, {
      isEditing: !1,
      isEmpty: !0,
      hasSomethingToUndo: !1,
      hasSomethingToRedo: !1,
      hasSelectedEditor: !1,
      hasSelectedText: !1
    });
    tn(this, ss, [0, 0]);
    tn(this, Ua, null);
    tn(this, Io, null);
    tn(this, g0, null);
    Zt(this, Io, ue), Zt(this, g0, Qe), Zt(this, Eu, Ue), this._eventBus = He, this._eventBus._on("editingaction", xt(this, l0)), this._eventBus._on("pagechanging", xt(this, d0)), this._eventBus._on("scalechanging", xt(this, f0)), this._eventBus._on("rotationchanging", xt(this, p0)), en(this, Dn, rg).call(this), en(this, Dn, Rh).call(this), Zt(this, Co, Ge.annotationStorage), Zt(this, Zl, Ge.filterFactory), Zt(this, ic, Xe), Zt(this, yu, Ke || null), Zt(this, Jl, $e), Zt(this, Iu, Je || null), this.viewParameters = {
      realScale: PixelsPerInch.PDF_TO_CSS_UNITS,
      rotation: 0
    }, this.isShiftKeyDown = !1;
  }
  static get _keyboardManager() {
    const ue = mu.prototype, Qe = (Xe) => xt(Xe, Io).contains(document.activeElement) && document.activeElement.tagName !== "BUTTON" && Xe.hasSomethingToControl(), Ue = (Xe, {
      target: Ke
    }) => {
      if (Ke instanceof HTMLInputElement) {
        const {
          type: $e
        } = Ke;
        return $e !== "text" && $e !== "number";
      }
      return !0;
    }, He = this.TRANSLATE_SMALL, Ge = this.TRANSLATE_BIG;
    return shadow(this, "_keyboardManager", new KeyboardManager([[["ctrl+a", "mac+meta+a"], ue.selectAll, {
      checker: Ue
    }], [["ctrl+z", "mac+meta+z"], ue.undo, {
      checker: Ue
    }], [["ctrl+y", "ctrl+shift+z", "mac+meta+shift+z", "ctrl+shift+Z", "mac+meta+shift+Z"], ue.redo, {
      checker: Ue
    }], [["Backspace", "alt+Backspace", "ctrl+Backspace", "shift+Backspace", "mac+Backspace", "mac+alt+Backspace", "mac+ctrl+Backspace", "Delete", "ctrl+Delete", "shift+Delete", "mac+Delete"], ue.delete, {
      checker: Ue
    }], [["Enter", "mac+Enter"], ue.addNewEditorFromKeyboard, {
      checker: (Xe, {
        target: Ke
      }) => !(Ke instanceof HTMLButtonElement) && xt(Xe, Io).contains(Ke) && !Xe.isEnterHandled
    }], [[" ", "mac+ "], ue.addNewEditorFromKeyboard, {
      checker: (Xe, {
        target: Ke
      }) => !(Ke instanceof HTMLButtonElement) && xt(Xe, Io).contains(document.activeElement)
    }], [["Escape", "mac+Escape"], ue.unselectAll], [["ArrowLeft", "mac+ArrowLeft"], ue.translateSelectedEditors, {
      args: [-He, 0],
      checker: Qe
    }], [["ctrl+ArrowLeft", "mac+shift+ArrowLeft"], ue.translateSelectedEditors, {
      args: [-Ge, 0],
      checker: Qe
    }], [["ArrowRight", "mac+ArrowRight"], ue.translateSelectedEditors, {
      args: [He, 0],
      checker: Qe
    }], [["ctrl+ArrowRight", "mac+shift+ArrowRight"], ue.translateSelectedEditors, {
      args: [Ge, 0],
      checker: Qe
    }], [["ArrowUp", "mac+ArrowUp"], ue.translateSelectedEditors, {
      args: [0, -He],
      checker: Qe
    }], [["ctrl+ArrowUp", "mac+shift+ArrowUp"], ue.translateSelectedEditors, {
      args: [0, -Ge],
      checker: Qe
    }], [["ArrowDown", "mac+ArrowDown"], ue.translateSelectedEditors, {
      args: [0, He],
      checker: Qe
    }], [["ctrl+ArrowDown", "mac+shift+ArrowDown"], ue.translateSelectedEditors, {
      args: [0, Ge],
      checker: Qe
    }]]));
  }
  destroy() {
    var ue, Qe;
    en(this, Dn, Oh).call(this), en(this, Dn, Bh).call(this), this._eventBus._off("editingaction", xt(this, l0)), this._eventBus._off("pagechanging", xt(this, d0)), this._eventBus._off("scalechanging", xt(this, f0)), this._eventBus._off("rotationchanging", xt(this, p0));
    for (const Ue of xt(this, hi).values())
      Ue.destroy();
    xt(this, hi).clear(), xt(this, ti).clear(), xt(this, nc).clear(), Zt(this, Yi, null), xt(this, wr).clear(), xt(this, va).destroy(), (ue = xt(this, Eu)) == null || ue.destroy(), (Qe = xt(this, Va)) == null || Qe.hide(), Zt(this, Va, null), xt(this, ja) && (clearTimeout(xt(this, ja)), Zt(this, ja, null)), xt(this, Ua) && (clearTimeout(xt(this, Ua)), Zt(this, Ua, null)), en(this, Dn, ig).call(this);
  }
  async mlGuess(ue) {
    var Qe;
    return ((Qe = xt(this, Iu)) == null ? void 0 : Qe.guess(ue)) || null;
  }
  get hasMLManager() {
    return !!xt(this, Iu);
  }
  get hcmFilter() {
    return shadow(this, "hcmFilter", xt(this, ic) ? xt(this, Zl).addHCMFilter(xt(this, ic).foreground, xt(this, ic).background) : "none");
  }
  get direction() {
    return shadow(this, "direction", getComputedStyle(xt(this, Io)).direction);
  }
  get highlightColors() {
    return shadow(this, "highlightColors", xt(this, yu) ? new Map(xt(this, yu).split(",").map((ue) => ue.split("=").map((Qe) => Qe.trim()))) : null);
  }
  get highlightColorNames() {
    return shadow(this, "highlightColorNames", this.highlightColors ? new Map(Array.from(this.highlightColors, (ue) => ue.reverse())) : null);
  }
  setMainHighlightColorPicker(ue) {
    Zt(this, t0, ue);
  }
  editAltText(ue) {
    var Qe;
    (Qe = xt(this, Eu)) == null || Qe.editAltText(this, ue);
  }
  onPageChanging({
    pageNumber: ue
  }) {
    Zt(this, vu, ue - 1);
  }
  focusMainContainer() {
    xt(this, Io).focus();
  }
  findParent(ue, Qe) {
    for (const Ue of xt(this, hi).values()) {
      const {
        x: He,
        y: Ge,
        width: Xe,
        height: Ke
      } = Ue.div.getBoundingClientRect();
      if (ue >= He && ue <= He + Xe && Qe >= Ge && Qe <= Ge + Ke)
        return Ue;
    }
    return null;
  }
  disableUserSelect(ue = !1) {
    xt(this, g0).classList.toggle("noUserSelect", ue);
  }
  addShouldRescale(ue) {
    xt(this, nc).add(ue);
  }
  removeShouldRescale(ue) {
    xt(this, nc).delete(ue);
  }
  onScaleChanging({
    scale: ue
  }) {
    this.commitOrRemove(), this.viewParameters.realScale = ue * PixelsPerInch.PDF_TO_CSS_UNITS;
    for (const Qe of xt(this, nc))
      Qe.onScaleChanging();
  }
  onRotationChanging({
    pagesRotation: ue
  }) {
    this.commitOrRemove(), this.viewParameters.rotation = ue;
  }
  highlightSelection(ue = "") {
    const Qe = document.getSelection();
    if (!Qe || Qe.isCollapsed)
      return;
    const {
      anchorNode: Ue,
      anchorOffset: He,
      focusNode: Ge,
      focusOffset: Xe
    } = Qe, Ke = Qe.toString(), Je = en(this, Dn, y2).call(this, Qe).closest(".textLayer"), Ze = this.getSelectionBoxes(Je);
    if (Ze) {
      Qe.empty(), xt(this, pi) === AnnotationEditorType.NONE && (this._eventBus.dispatch("showannotationeditorui", {
        source: this,
        mode: AnnotationEditorType.HIGHLIGHT
      }), this.showAllEditors("highlight", !0, !0));
      for (const nt of xt(this, hi).values())
        if (nt.hasTextLayer(Je)) {
          nt.createAndAddNewEditor({
            x: 0,
            y: 0
          }, !1, {
            methodOfCreation: ue,
            boxes: Ze,
            anchorNode: Ue,
            anchorOffset: He,
            focusNode: Ge,
            focusOffset: Xe,
            text: Ke
          });
          break;
        }
    }
  }
  addToAnnotationStorage(ue) {
    !ue.isEmpty() && xt(this, Co) && !xt(this, Co).has(ue.id) && xt(this, Co).setValue(ue.id, ue);
  }
  blur() {
    if (this.isShiftKeyDown = !1, xt(this, as) && (Zt(this, as, !1), en(this, Dn, I2).call(this, "main_toolbar")), !this.hasSelection)
      return;
    const {
      activeElement: ue
    } = document;
    for (const Qe of xt(this, wr))
      if (Qe.div.contains(ue)) {
        Zt(this, rc, [Qe, ue]), Qe._focusEventsAllowed = !1;
        break;
      }
  }
  focus() {
    if (!xt(this, rc))
      return;
    const [ue, Qe] = xt(this, rc);
    Zt(this, rc, null), Qe.addEventListener("focusin", () => {
      ue._focusEventsAllowed = !0;
    }, {
      once: !0
    }), Qe.focus();
  }
  addEditListeners() {
    en(this, Dn, Rh).call(this), en(this, Dn, Nh).call(this);
  }
  removeEditListeners() {
    en(this, Dn, Oh).call(this), en(this, Dn, Dh).call(this);
  }
  copy(ue) {
    var Ue;
    if (ue.preventDefault(), (Ue = xt(this, Yi)) == null || Ue.commitOrRemove(), !this.hasSelection)
      return;
    const Qe = [];
    for (const He of xt(this, wr)) {
      const Ge = He.serialize(!0);
      Ge && Qe.push(Ge);
    }
    Qe.length !== 0 && ue.clipboardData.setData("application/pdfjs", JSON.stringify(Qe));
  }
  cut(ue) {
    this.copy(ue), this.delete();
  }
  paste(ue) {
    ue.preventDefault();
    const {
      clipboardData: Qe
    } = ue;
    for (const Ge of Qe.items)
      for (const Xe of xt(this, vo))
        if (Xe.isHandlingMimeForPasting(Ge.type)) {
          Xe.paste(Ge, this.currentLayer);
          return;
        }
    let Ue = Qe.getData("application/pdfjs");
    if (!Ue)
      return;
    try {
      Ue = JSON.parse(Ue);
    } catch (Ge) {
      warn(`paste: "${Ge.message}".`);
      return;
    }
    if (!Array.isArray(Ue))
      return;
    this.unselectAll();
    const He = this.currentLayer;
    try {
      const Ge = [];
      for (const $e of Ue) {
        const Je = He.deserialize($e);
        if (!Je)
          return;
        Ge.push(Je);
      }
      const Xe = () => {
        for (const $e of Ge)
          en(this, Dn, Ph).call(this, $e);
        en(this, Dn, kh).call(this, Ge);
      }, Ke = () => {
        for (const $e of Ge)
          $e.remove();
      };
      this.addCommands({
        cmd: Xe,
        undo: Ke,
        mustExec: !0
      });
    } catch (Ge) {
      warn(`paste: "${Ge.message}".`);
    }
  }
  keydown(ue) {
    !this.isShiftKeyDown && ue.key === "Shift" && (this.isShiftKeyDown = !0), xt(this, pi) !== AnnotationEditorType.NONE && !this.isEditorHandlingKeyboard && mu._keyboardManager.exec(this, ue);
  }
  keyup(ue) {
    this.isShiftKeyDown && ue.key === "Shift" && (this.isShiftKeyDown = !1, xt(this, as) && (Zt(this, as, !1), en(this, Dn, I2).call(this, "main_toolbar")));
  }
  onEditingAction({
    name: ue
  }) {
    switch (ue) {
      case "undo":
      case "redo":
      case "delete":
      case "selectAll":
        this[ue]();
        break;
      case "highlightSelection":
        this.highlightSelection("context_menu");
        break;
    }
  }
  setEditingState(ue) {
    ue ? (en(this, Dn, ag).call(this), en(this, Dn, Nh).call(this), en(this, Dn, Ri).call(this, {
      isEditing: xt(this, pi) !== AnnotationEditorType.NONE,
      isEmpty: en(this, Dn, Ll).call(this),
      hasSomethingToUndo: xt(this, va).hasSomethingToUndo(),
      hasSomethingToRedo: xt(this, va).hasSomethingToRedo(),
      hasSelectedEditor: !1
    })) : (en(this, Dn, Bh).call(this), en(this, Dn, Dh).call(this), en(this, Dn, Ri).call(this, {
      isEditing: !1
    }), this.disableUserSelect(!1));
  }
  registerEditorTypes(ue) {
    if (!xt(this, vo)) {
      Zt(this, vo, ue);
      for (const Qe of xt(this, vo))
        en(this, Dn, ns).call(this, Qe.defaultPropertiesToUpdate);
    }
  }
  getId() {
    return xt(this, K2).id;
  }
  get currentLayer() {
    return xt(this, hi).get(xt(this, vu));
  }
  getLayer(ue) {
    return xt(this, hi).get(ue);
  }
  get currentPageIndex() {
    return xt(this, vu);
  }
  addLayer(ue) {
    xt(this, hi).set(ue.pageIndex, ue), xt(this, os) ? ue.enable() : ue.disable();
  }
  removeLayer(ue) {
    xt(this, hi).delete(ue.pageIndex);
  }
  updateMode(ue, Qe = null, Ue = !1) {
    if (xt(this, pi) !== ue) {
      if (Zt(this, pi, ue), ue === AnnotationEditorType.NONE) {
        this.setEditingState(!1), en(this, Dn, sg).call(this);
        return;
      }
      this.setEditingState(!0), en(this, Dn, og).call(this), this.unselectAll();
      for (const He of xt(this, hi).values())
        He.updateMode(ue);
      if (!Qe && Ue) {
        this.addNewEditorFromKeyboard();
        return;
      }
      if (Qe) {
        for (const He of xt(this, ti).values())
          if (He.annotationElementId === Qe) {
            this.setSelected(He), He.enterInEditMode();
            break;
          }
      }
    }
  }
  addNewEditorFromKeyboard() {
    this.currentLayer.canCreateNewEmptyEditor() && this.currentLayer.addNewEditor();
  }
  updateToolbar(ue) {
    ue !== xt(this, pi) && this._eventBus.dispatch("switchannotationeditormode", {
      source: this,
      mode: ue
    });
  }
  updateParams(ue, Qe) {
    var Ue;
    if (xt(this, vo)) {
      switch (ue) {
        case AnnotationEditorParamsType.CREATE:
          this.currentLayer.addNewEditor();
          return;
        case AnnotationEditorParamsType.HIGHLIGHT_DEFAULT_COLOR:
          (Ue = xt(this, t0)) == null || Ue.updateColor(Qe);
          break;
        case AnnotationEditorParamsType.HIGHLIGHT_SHOW_ALL:
          this._eventBus.dispatch("reporttelemetry", {
            source: this,
            details: {
              type: "editing",
              data: {
                type: "highlight",
                action: "toggle_visibility"
              }
            }
          }), (xt(this, n0) || Zt(this, n0, /* @__PURE__ */ new Map())).set(ue, Qe), this.showAllEditors("highlight", Qe);
          break;
      }
      for (const He of xt(this, wr))
        He.updateParams(ue, Qe);
      for (const He of xt(this, vo))
        He.updateDefaultParams(ue, Qe);
    }
  }
  showAllEditors(ue, Qe, Ue = !1) {
    var Ge;
    for (const Xe of xt(this, ti).values())
      Xe.editorType === ue && Xe.show(Qe);
    (((Ge = xt(this, n0)) == null ? void 0 : Ge.get(AnnotationEditorParamsType.HIGHLIGHT_SHOW_ALL)) ?? !0) !== Qe && en(this, Dn, ns).call(this, [[AnnotationEditorParamsType.HIGHLIGHT_SHOW_ALL, Qe]]);
  }
  enableWaiting(ue = !1) {
    if (xt(this, e0) !== ue) {
      Zt(this, e0, ue);
      for (const Qe of xt(this, hi).values())
        ue ? Qe.disableClick() : Qe.enableClick(), Qe.div.classList.toggle("waiting", ue);
    }
  }
  getEditors(ue) {
    const Qe = [];
    for (const Ue of xt(this, ti).values())
      Ue.pageIndex === ue && Qe.push(Ue);
    return Qe;
  }
  getEditor(ue) {
    return xt(this, ti).get(ue);
  }
  addEditor(ue) {
    xt(this, ti).set(ue.id, ue);
  }
  removeEditor(ue) {
    var Qe;
    ue.div.contains(document.activeElement) && (xt(this, ja) && clearTimeout(xt(this, ja)), Zt(this, ja, setTimeout(() => {
      this.focusMainContainer(), Zt(this, ja, null);
    }, 0))), xt(this, ti).delete(ue.id), this.unselect(ue), (!ue.annotationElementId || !xt(this, tc).has(ue.annotationElementId)) && ((Qe = xt(this, Co)) == null || Qe.remove(ue.id));
  }
  addDeletedAnnotationElement(ue) {
    xt(this, tc).add(ue.annotationElementId), this.addChangedExistingAnnotation(ue), ue.deleted = !0;
  }
  isDeletedAnnotationElement(ue) {
    return xt(this, tc).has(ue);
  }
  removeDeletedAnnotationElement(ue) {
    xt(this, tc).delete(ue.annotationElementId), this.removeChangedExistingAnnotation(ue), ue.deleted = !1;
  }
  setActiveEditor(ue) {
    xt(this, Yi) !== ue && (Zt(this, Yi, ue), ue && en(this, Dn, ns).call(this, ue.propertiesToUpdate));
  }
  updateUI(ue) {
    xt(this, Dn, cg) === ue && en(this, Dn, ns).call(this, ue.propertiesToUpdate);
  }
  toggleSelected(ue) {
    if (xt(this, wr).has(ue)) {
      xt(this, wr).delete(ue), ue.unselect(), en(this, Dn, Ri).call(this, {
        hasSelectedEditor: this.hasSelection
      });
      return;
    }
    xt(this, wr).add(ue), ue.select(), en(this, Dn, ns).call(this, ue.propertiesToUpdate), en(this, Dn, Ri).call(this, {
      hasSelectedEditor: !0
    });
  }
  setSelected(ue) {
    for (const Qe of xt(this, wr))
      Qe !== ue && Qe.unselect();
    xt(this, wr).clear(), xt(this, wr).add(ue), ue.select(), en(this, Dn, ns).call(this, ue.propertiesToUpdate), en(this, Dn, Ri).call(this, {
      hasSelectedEditor: !0
    });
  }
  isSelected(ue) {
    return xt(this, wr).has(ue);
  }
  get firstSelectedEditor() {
    return xt(this, wr).values().next().value;
  }
  unselect(ue) {
    ue.unselect(), xt(this, wr).delete(ue), en(this, Dn, Ri).call(this, {
      hasSelectedEditor: this.hasSelection
    });
  }
  get hasSelection() {
    return xt(this, wr).size !== 0;
  }
  get isEnterHandled() {
    return xt(this, wr).size === 1 && this.firstSelectedEditor.isEnterHandled;
  }
  undo() {
    xt(this, va).undo(), en(this, Dn, Ri).call(this, {
      hasSomethingToUndo: xt(this, va).hasSomethingToUndo(),
      hasSomethingToRedo: !0,
      isEmpty: en(this, Dn, Ll).call(this)
    });
  }
  redo() {
    xt(this, va).redo(), en(this, Dn, Ri).call(this, {
      hasSomethingToUndo: !0,
      hasSomethingToRedo: xt(this, va).hasSomethingToRedo(),
      isEmpty: en(this, Dn, Ll).call(this)
    });
  }
  addCommands(ue) {
    xt(this, va).add(ue), en(this, Dn, Ri).call(this, {
      hasSomethingToUndo: !0,
      hasSomethingToRedo: !1,
      isEmpty: en(this, Dn, Ll).call(this)
    });
  }
  delete() {
    if (this.commitOrRemove(), !this.hasSelection)
      return;
    const ue = [...xt(this, wr)], Qe = () => {
      for (const He of ue)
        He.remove();
    }, Ue = () => {
      for (const He of ue)
        en(this, Dn, Ph).call(this, He);
    };
    this.addCommands({
      cmd: Qe,
      undo: Ue,
      mustExec: !0
    });
  }
  commitOrRemove() {
    var ue;
    (ue = xt(this, Yi)) == null || ue.commitOrRemove();
  }
  hasSomethingToControl() {
    return xt(this, Yi) || this.hasSelection;
  }
  selectAll() {
    for (const ue of xt(this, wr))
      ue.commit();
    en(this, Dn, kh).call(this, xt(this, ti).values());
  }
  unselectAll() {
    if (!(xt(this, Yi) && (xt(this, Yi).commitOrRemove(), xt(this, pi) !== AnnotationEditorType.NONE)) && this.hasSelection) {
      for (const ue of xt(this, wr))
        ue.unselect();
      xt(this, wr).clear(), en(this, Dn, Ri).call(this, {
        hasSelectedEditor: !1
      });
    }
  }
  translateSelectedEditors(ue, Qe, Ue = !1) {
    if (Ue || this.commitOrRemove(), !this.hasSelection)
      return;
    xt(this, ss)[0] += ue, xt(this, ss)[1] += Qe;
    const [He, Ge] = xt(this, ss), Xe = [...xt(this, wr)], Ke = 1e3;
    xt(this, Ua) && clearTimeout(xt(this, Ua)), Zt(this, Ua, setTimeout(() => {
      Zt(this, Ua, null), xt(this, ss)[0] = xt(this, ss)[1] = 0, this.addCommands({
        cmd: () => {
          for (const $e of Xe)
            xt(this, ti).has($e.id) && $e.translateInPage(He, Ge);
        },
        undo: () => {
          for (const $e of Xe)
            xt(this, ti).has($e.id) && $e.translateInPage(-He, -Ge);
        },
        mustExec: !1
      });
    }, Ke));
    for (const $e of Xe)
      $e.translateInPage(ue, Qe);
  }
  setUpDragSession() {
    if (this.hasSelection) {
      this.disableUserSelect(!0), Zt(this, Fa, /* @__PURE__ */ new Map());
      for (const ue of xt(this, wr))
        xt(this, Fa).set(ue, {
          savedX: ue.x,
          savedY: ue.y,
          savedPageIndex: ue.pageIndex,
          newX: 0,
          newY: 0,
          newPageIndex: -1
        });
    }
  }
  endDragSession() {
    if (!xt(this, Fa))
      return !1;
    this.disableUserSelect(!1);
    const ue = xt(this, Fa);
    Zt(this, Fa, null);
    let Qe = !1;
    for (const [{
      x: He,
      y: Ge,
      pageIndex: Xe
    }, Ke] of ue)
      Ke.newX = He, Ke.newY = Ge, Ke.newPageIndex = Xe, Qe || (Qe = He !== Ke.savedX || Ge !== Ke.savedY || Xe !== Ke.savedPageIndex);
    if (!Qe)
      return !1;
    const Ue = (He, Ge, Xe, Ke) => {
      if (xt(this, ti).has(He.id)) {
        const $e = xt(this, hi).get(Ke);
        $e ? He._setParentAndPosition($e, Ge, Xe) : (He.pageIndex = Ke, He.x = Ge, He.y = Xe);
      }
    };
    return this.addCommands({
      cmd: () => {
        for (const [He, {
          newX: Ge,
          newY: Xe,
          newPageIndex: Ke
        }] of ue)
          Ue(He, Ge, Xe, Ke);
      },
      undo: () => {
        for (const [He, {
          savedX: Ge,
          savedY: Xe,
          savedPageIndex: Ke
        }] of ue)
          Ue(He, Ge, Xe, Ke);
      },
      mustExec: !0
    }), !0;
  }
  dragSelectedEditors(ue, Qe) {
    if (xt(this, Fa))
      for (const Ue of xt(this, Fa).keys())
        Ue.drag(ue, Qe);
  }
  rebuild(ue) {
    if (ue.parent === null) {
      const Qe = this.getLayer(ue.pageIndex);
      Qe ? (Qe.changeParent(ue), Qe.addOrRebuild(ue)) : (this.addEditor(ue), this.addToAnnotationStorage(ue), ue.rebuild());
    } else
      ue.parent.addOrRebuild(ue);
  }
  get isEditorHandlingKeyboard() {
    var ue;
    return ((ue = this.getActive()) == null ? void 0 : ue.shouldGetKeyboardEvents()) || xt(this, wr).size === 1 && this.firstSelectedEditor.shouldGetKeyboardEvents();
  }
  isActive(ue) {
    return xt(this, Yi) === ue;
  }
  getActive() {
    return xt(this, Yi);
  }
  getMode() {
    return xt(this, pi);
  }
  get imageManager() {
    return shadow(this, "imageManager", new ImageManager());
  }
  getSelectionBoxes(ue) {
    if (!ue)
      return null;
    const Qe = document.getSelection();
    for (let Je = 0, Ze = Qe.rangeCount; Je < Ze; Je++)
      if (!ue.contains(Qe.getRangeAt(Je).commonAncestorContainer))
        return null;
    const {
      x: Ue,
      y: He,
      width: Ge,
      height: Xe
    } = ue.getBoundingClientRect();
    let Ke;
    switch (ue.getAttribute("data-main-rotation")) {
      case "90":
        Ke = (Je, Ze, nt, tt) => ({
          x: (Ze - He) / Xe,
          y: 1 - (Je + nt - Ue) / Ge,
          width: tt / Xe,
          height: nt / Ge
        });
        break;
      case "180":
        Ke = (Je, Ze, nt, tt) => ({
          x: 1 - (Je + nt - Ue) / Ge,
          y: 1 - (Ze + tt - He) / Xe,
          width: nt / Ge,
          height: tt / Xe
        });
        break;
      case "270":
        Ke = (Je, Ze, nt, tt) => ({
          x: 1 - (Ze + tt - He) / Xe,
          y: (Je - Ue) / Ge,
          width: tt / Xe,
          height: nt / Ge
        });
        break;
      default:
        Ke = (Je, Ze, nt, tt) => ({
          x: (Je - Ue) / Ge,
          y: (Ze - He) / Xe,
          width: nt / Ge,
          height: tt / Xe
        });
        break;
    }
    const $e = [];
    for (let Je = 0, Ze = Qe.rangeCount; Je < Ze; Je++) {
      const nt = Qe.getRangeAt(Je);
      if (!nt.collapsed)
        for (const {
          x: tt,
          y: et,
          width: rt,
          height: it
        } of nt.getClientRects())
          rt === 0 || it === 0 || $e.push(Ke(tt, et, rt, it));
    }
    return $e.length === 0 ? null : $e;
  }
  addChangedExistingAnnotation({
    annotationElementId: ue,
    id: Qe
  }) {
    (xt(this, Cu) || Zt(this, Cu, /* @__PURE__ */ new Map())).set(ue, Qe);
  }
  removeChangedExistingAnnotation({
    annotationElementId: ue
  }) {
    var Qe;
    (Qe = xt(this, Cu)) == null || Qe.delete(ue);
  }
  renderAnnotationElement(ue) {
    var He;
    const Qe = (He = xt(this, Cu)) == null ? void 0 : He.get(ue.data.id);
    if (!Qe)
      return;
    const Ue = xt(this, Co).getRawValue(Qe);
    Ue && (xt(this, pi) === AnnotationEditorType.NONE && !Ue.hasBeenModified || Ue.renderAnnotationElement(ue));
  }
};
Yi = new WeakMap(), ti = new WeakMap(), hi = new WeakMap(), Eu = new WeakMap(), Co = new WeakMap(), Cu = new WeakMap(), va = new WeakMap(), vu = new WeakMap(), tc = new WeakMap(), Fa = new WeakMap(), vo = new WeakMap(), nc = new WeakMap(), Jl = new WeakMap(), Zl = new WeakMap(), ja = new WeakMap(), yu = new WeakMap(), as = new WeakMap(), Va = new WeakMap(), K2 = new WeakMap(), os = new WeakMap(), e0 = new WeakMap(), rc = new WeakMap(), t0 = new WeakMap(), Iu = new WeakMap(), pi = new WeakMap(), wr = new WeakMap(), yo = new WeakMap(), ic = new WeakMap(), n0 = new WeakMap(), r0 = new WeakMap(), i0 = new WeakMap(), a0 = new WeakMap(), o0 = new WeakMap(), s0 = new WeakMap(), c0 = new WeakMap(), u0 = new WeakMap(), l0 = new WeakMap(), d0 = new WeakMap(), f0 = new WeakMap(), h0 = new WeakMap(), p0 = new WeakMap(), A0 = new WeakMap(), ss = new WeakMap(), Ua = new WeakMap(), Io = new WeakMap(), g0 = new WeakMap(), Dn = new WeakSet(), y2 = function({
  anchorNode: ue
}) {
  return ue.nodeType === Node.TEXT_NODE ? ue.parentElement : ue;
}, tg = function() {
  const ue = document.getSelection();
  if (!ue || ue.isCollapsed)
    return;
  const Ue = en(this, Dn, y2).call(this, ue).closest(".textLayer"), He = this.getSelectionBoxes(Ue);
  He && (xt(this, Va) || Zt(this, Va, new HighlightToolbar(this)), xt(this, Va).show(Ue, He, this.direction === "ltr"));
}, ng = function() {
  var Ge, Xe, Ke;
  const ue = document.getSelection();
  if (!ue || ue.isCollapsed) {
    xt(this, yo) && ((Ge = xt(this, Va)) == null || Ge.hide(), Zt(this, yo, null), en(this, Dn, Ri).call(this, {
      hasSelectedText: !1
    }));
    return;
  }
  const {
    anchorNode: Qe
  } = ue;
  if (Qe === xt(this, yo))
    return;
  if (!en(this, Dn, y2).call(this, ue).closest(".textLayer")) {
    xt(this, yo) && ((Xe = xt(this, Va)) == null || Xe.hide(), Zt(this, yo, null), en(this, Dn, Ri).call(this, {
      hasSelectedText: !1
    }));
    return;
  }
  if ((Ke = xt(this, Va)) == null || Ke.hide(), Zt(this, yo, Qe), en(this, Dn, Ri).call(this, {
    hasSelectedText: !0
  }), !(xt(this, pi) !== AnnotationEditorType.HIGHLIGHT && xt(this, pi) !== AnnotationEditorType.NONE) && (xt(this, pi) === AnnotationEditorType.HIGHLIGHT && this.showAllEditors("highlight", !0, !0), Zt(this, as, this.isShiftKeyDown), !this.isShiftKeyDown)) {
    const $e = (Je) => {
      Je.type === "pointerup" && Je.button !== 0 || (window.removeEventListener("pointerup", $e), window.removeEventListener("blur", $e), Je.type === "pointerup" && en(this, Dn, I2).call(this, "main_toolbar"));
    };
    window.addEventListener("pointerup", $e), window.addEventListener("blur", $e);
  }
}, I2 = function(ue = "") {
  xt(this, pi) === AnnotationEditorType.HIGHLIGHT ? this.highlightSelection(ue) : xt(this, Jl) && en(this, Dn, tg).call(this);
}, rg = function() {
  document.addEventListener("selectionchange", xt(this, h0));
}, ig = function() {
  document.removeEventListener("selectionchange", xt(this, h0));
}, ag = function() {
  window.addEventListener("focus", xt(this, i0)), window.addEventListener("blur", xt(this, r0));
}, Bh = function() {
  window.removeEventListener("focus", xt(this, i0)), window.removeEventListener("blur", xt(this, r0));
}, Rh = function() {
  window.addEventListener("keydown", xt(this, c0)), window.addEventListener("keyup", xt(this, u0));
}, Oh = function() {
  window.removeEventListener("keydown", xt(this, c0)), window.removeEventListener("keyup", xt(this, u0));
}, Nh = function() {
  document.addEventListener("copy", xt(this, a0)), document.addEventListener("cut", xt(this, o0)), document.addEventListener("paste", xt(this, s0));
}, Dh = function() {
  document.removeEventListener("copy", xt(this, a0)), document.removeEventListener("cut", xt(this, o0)), document.removeEventListener("paste", xt(this, s0));
}, Ri = function(ue) {
  Object.entries(ue).some(([Ue, He]) => xt(this, A0)[Ue] !== He) && (this._eventBus.dispatch("annotationeditorstateschanged", {
    source: this,
    details: Object.assign(xt(this, A0), ue)
  }), xt(this, pi) === AnnotationEditorType.HIGHLIGHT && ue.hasSelectedEditor === !1 && en(this, Dn, ns).call(this, [[AnnotationEditorParamsType.HIGHLIGHT_FREE, !0]]));
}, ns = function(ue) {
  this._eventBus.dispatch("annotationeditorparamschanged", {
    source: this,
    details: ue
  });
}, og = function() {
  if (!xt(this, os)) {
    Zt(this, os, !0);
    for (const ue of xt(this, hi).values())
      ue.enable();
    for (const ue of xt(this, ti).values())
      ue.enable();
  }
}, sg = function() {
  if (this.unselectAll(), xt(this, os)) {
    Zt(this, os, !1);
    for (const ue of xt(this, hi).values())
      ue.disable();
    for (const ue of xt(this, ti).values())
      ue.disable();
  }
}, Ph = function(ue) {
  const Qe = xt(this, hi).get(ue.pageIndex);
  Qe ? Qe.addOrRebuild(ue) : (this.addEditor(ue), this.addToAnnotationStorage(ue));
}, cg = function() {
  let ue = null;
  for (ue of xt(this, wr))
    ;
  return ue;
}, Ll = function() {
  if (xt(this, ti).size === 0)
    return !0;
  if (xt(this, ti).size === 1)
    for (const ue of xt(this, ti).values())
      return ue.isEmpty();
  return !1;
}, kh = function(ue) {
  for (const Qe of xt(this, wr))
    Qe.unselect();
  xt(this, wr).clear();
  for (const Qe of ue)
    Qe.isEmpty() || (xt(this, wr).add(Qe), Qe.select());
  en(this, Dn, Ri).call(this, {
    hasSelectedEditor: this.hasSelection
  });
}, $n(mu, "TRANSLATE_SMALL", 1), $n(mu, "TRANSLATE_BIG", 10);
let AnnotationEditorUIManager = mu;
var xo, bo, ya, So, Ia, xu, wo, m0, _h;
const Ao = class Ao {
  constructor(ue) {
    tn(this, m0);
    tn(this, xo, "");
    tn(this, bo, !1);
    tn(this, ya, null);
    tn(this, So, null);
    tn(this, Ia, null);
    tn(this, xu, !1);
    tn(this, wo, null);
    Zt(this, wo, ue);
  }
  static initialize(ue) {
    Ao._l10nPromise || (Ao._l10nPromise = ue);
  }
  async render() {
    const ue = Zt(this, ya, document.createElement("button"));
    ue.className = "altText";
    const Qe = await Ao._l10nPromise.get("pdfjs-editor-alt-text-button-label");
    ue.textContent = Qe, ue.setAttribute("aria-label", Qe), ue.tabIndex = "0", ue.addEventListener("contextmenu", noContextMenu), ue.addEventListener("pointerdown", (He) => He.stopPropagation());
    const Ue = (He) => {
      He.preventDefault(), xt(this, wo)._uiManager.editAltText(xt(this, wo));
    };
    return ue.addEventListener("click", Ue, {
      capture: !0
    }), ue.addEventListener("keydown", (He) => {
      He.target === ue && He.key === "Enter" && (Zt(this, xu, !0), Ue(He));
    }), await en(this, m0, _h).call(this), ue;
  }
  finish() {
    xt(this, ya) && (xt(this, ya).focus({
      focusVisible: xt(this, xu)
    }), Zt(this, xu, !1));
  }
  isEmpty() {
    return !xt(this, xo) && !xt(this, bo);
  }
  get data() {
    return {
      altText: xt(this, xo),
      decorative: xt(this, bo)
    };
  }
  set data({
    altText: ue,
    decorative: Qe
  }) {
    xt(this, xo) === ue && xt(this, bo) === Qe || (Zt(this, xo, ue), Zt(this, bo, Qe), en(this, m0, _h).call(this));
  }
  toggle(ue = !1) {
    xt(this, ya) && (!ue && xt(this, Ia) && (clearTimeout(xt(this, Ia)), Zt(this, Ia, null)), xt(this, ya).disabled = !ue);
  }
  destroy() {
    var ue;
    (ue = xt(this, ya)) == null || ue.remove(), Zt(this, ya, null), Zt(this, So, null);
  }
};
xo = new WeakMap(), bo = new WeakMap(), ya = new WeakMap(), So = new WeakMap(), Ia = new WeakMap(), xu = new WeakMap(), wo = new WeakMap(), m0 = new WeakSet(), _h = async function() {
  var He;
  const ue = xt(this, ya);
  if (!ue)
    return;
  if (!xt(this, xo) && !xt(this, bo)) {
    ue.classList.remove("done"), (He = xt(this, So)) == null || He.remove();
    return;
  }
  ue.classList.add("done"), Ao._l10nPromise.get("pdfjs-editor-alt-text-edit-button-label").then((Ge) => {
    ue.setAttribute("aria-label", Ge);
  });
  let Qe = xt(this, So);
  if (!Qe) {
    Zt(this, So, Qe = document.createElement("span")), Qe.className = "tooltip", Qe.setAttribute("role", "tooltip");
    const Ge = Qe.id = `alt-text-tooltip-${xt(this, wo).id}`;
    ue.setAttribute("aria-describedby", Ge);
    const Xe = 100;
    ue.addEventListener("mouseenter", () => {
      Zt(this, Ia, setTimeout(() => {
        Zt(this, Ia, null), xt(this, So).classList.add("show"), xt(this, wo)._reportTelemetry({
          action: "alt_text_tooltip"
        });
      }, Xe));
    }), ue.addEventListener("mouseleave", () => {
      var Ke;
      xt(this, Ia) && (clearTimeout(xt(this, Ia)), Zt(this, Ia, null)), (Ke = xt(this, So)) == null || Ke.classList.remove("show");
    });
  }
  Qe.innerText = xt(this, bo) ? await Ao._l10nPromise.get("pdfjs-editor-alt-text-decorative-tooltip") : xt(this, xo), Qe.parentNode || ue.append(Qe);
  const Ue = xt(this, wo).getImageForAltText();
  Ue == null || Ue.setAttribute("aria-describedby", Qe.id);
}, $n(Ao, "_l10nPromise", null);
let AltText = Ao;
var xa, Oi, bu, ac, Ai, oc, Su, wu, wi, E0, sc, cs, C0, uc, To, Ha, Tu, Bu, fa, v0, Y2, dr, Lh, y0, Mh, Qh, ug, lg, Fh, jh, Vh, dg, fg, hg, pg, Uh, Ml;
const Nr = class Nr {
  constructor(ue) {
    tn(this, dr);
    tn(this, xa, null);
    tn(this, Oi, null);
    tn(this, bu, !1);
    tn(this, ac, !1);
    tn(this, Ai, null);
    tn(this, oc, null);
    tn(this, Su, this.focusin.bind(this));
    tn(this, wu, this.focusout.bind(this));
    tn(this, wi, null);
    tn(this, E0, "");
    tn(this, sc, !1);
    tn(this, cs, null);
    tn(this, C0, !1);
    tn(this, uc, !1);
    tn(this, To, !1);
    tn(this, Ha, null);
    tn(this, Tu, 0);
    tn(this, Bu, 0);
    tn(this, fa, null);
    $n(this, "_initialOptions", /* @__PURE__ */ Object.create(null));
    $n(this, "_isVisible", !0);
    $n(this, "_uiManager", null);
    $n(this, "_focusEventsAllowed", !0);
    $n(this, "_l10nPromise", null);
    tn(this, v0, !1);
    tn(this, Y2, Nr._zIndex++);
    this.constructor === Nr && unreachable("Cannot initialize AnnotationEditor."), this.parent = ue.parent, this.id = ue.id, this.width = this.height = null, this.pageIndex = ue.parent.pageIndex, this.name = ue.name, this.div = null, this._uiManager = ue.uiManager, this.annotationElementId = null, this._willKeepAspectRatio = !1, this._initialOptions.isCentered = ue.isCentered, this._structTreeParentId = null;
    const {
      rotation: Qe,
      rawDims: {
        pageWidth: Ue,
        pageHeight: He,
        pageX: Ge,
        pageY: Xe
      }
    } = this.parent.viewport;
    this.rotation = Qe, this.pageRotation = (360 + Qe - this._uiManager.viewParameters.rotation) % 360, this.pageDimensions = [Ue, He], this.pageTranslation = [Ge, Xe];
    const [Ke, $e] = this.parentDimensions;
    this.x = ue.x / Ke, this.y = ue.y / $e, this.isAttachedToDOM = !1, this.deleted = !1;
  }
  static get _resizerKeyboardManager() {
    const ue = Nr.prototype._resizeWithKeyboard, Qe = AnnotationEditorUIManager.TRANSLATE_SMALL, Ue = AnnotationEditorUIManager.TRANSLATE_BIG;
    return shadow(this, "_resizerKeyboardManager", new KeyboardManager([[["ArrowLeft", "mac+ArrowLeft"], ue, {
      args: [-Qe, 0]
    }], [["ctrl+ArrowLeft", "mac+shift+ArrowLeft"], ue, {
      args: [-Ue, 0]
    }], [["ArrowRight", "mac+ArrowRight"], ue, {
      args: [Qe, 0]
    }], [["ctrl+ArrowRight", "mac+shift+ArrowRight"], ue, {
      args: [Ue, 0]
    }], [["ArrowUp", "mac+ArrowUp"], ue, {
      args: [0, -Qe]
    }], [["ctrl+ArrowUp", "mac+shift+ArrowUp"], ue, {
      args: [0, -Ue]
    }], [["ArrowDown", "mac+ArrowDown"], ue, {
      args: [0, Qe]
    }], [["ctrl+ArrowDown", "mac+shift+ArrowDown"], ue, {
      args: [0, Ue]
    }], [["Escape", "mac+Escape"], Nr.prototype._stopResizingWithKeyboard]]));
  }
  get editorType() {
    return Object.getPrototypeOf(this).constructor._type;
  }
  static get _defaultLineColor() {
    return shadow(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
  }
  static deleteAnnotationElement(ue) {
    const Qe = new FakeEditor({
      id: ue.parent.getNextId(),
      parent: ue.parent,
      uiManager: ue._uiManager
    });
    Qe.annotationElementId = ue.annotationElementId, Qe.deleted = !0, Qe._uiManager.addToAnnotationStorage(Qe);
  }
  static initialize(ue, Qe, Ue) {
    if (Nr._l10nPromise || (Nr._l10nPromise = new Map(["pdfjs-editor-alt-text-button-label", "pdfjs-editor-alt-text-edit-button-label", "pdfjs-editor-alt-text-decorative-tooltip", "pdfjs-editor-resizer-label-topLeft", "pdfjs-editor-resizer-label-topMiddle", "pdfjs-editor-resizer-label-topRight", "pdfjs-editor-resizer-label-middleRight", "pdfjs-editor-resizer-label-bottomRight", "pdfjs-editor-resizer-label-bottomMiddle", "pdfjs-editor-resizer-label-bottomLeft", "pdfjs-editor-resizer-label-middleLeft"].map((Ge) => [Ge, ue.get(Ge.replaceAll(/([A-Z])/g, (Xe) => `-${Xe.toLowerCase()}`))]))), Ue != null && Ue.strings)
      for (const Ge of Ue.strings)
        Nr._l10nPromise.set(Ge, ue.get(Ge));
    if (Nr._borderLineWidth !== -1)
      return;
    const He = getComputedStyle(document.documentElement);
    Nr._borderLineWidth = parseFloat(He.getPropertyValue("--outline-width")) || 0;
  }
  static updateDefaultParams(ue, Qe) {
  }
  static get defaultPropertiesToUpdate() {
    return [];
  }
  static isHandlingMimeForPasting(ue) {
    return !1;
  }
  static paste(ue, Qe) {
    unreachable("Not implemented");
  }
  get propertiesToUpdate() {
    return [];
  }
  get _isDraggable() {
    return xt(this, v0);
  }
  set _isDraggable(ue) {
    var Qe;
    Zt(this, v0, ue), (Qe = this.div) == null || Qe.classList.toggle("draggable", ue);
  }
  get isEnterHandled() {
    return !0;
  }
  center() {
    const [ue, Qe] = this.pageDimensions;
    switch (this.parentRotation) {
      case 90:
        this.x -= this.height * Qe / (ue * 2), this.y += this.width * ue / (Qe * 2);
        break;
      case 180:
        this.x += this.width / 2, this.y += this.height / 2;
        break;
      case 270:
        this.x += this.height * Qe / (ue * 2), this.y -= this.width * ue / (Qe * 2);
        break;
      default:
        this.x -= this.width / 2, this.y -= this.height / 2;
        break;
    }
    this.fixAndSetPosition();
  }
  addCommands(ue) {
    this._uiManager.addCommands(ue);
  }
  get currentLayer() {
    return this._uiManager.currentLayer;
  }
  setInBackground() {
    this.div.style.zIndex = 0;
  }
  setInForeground() {
    this.div.style.zIndex = xt(this, Y2);
  }
  setParent(ue) {
    ue !== null ? (this.pageIndex = ue.pageIndex, this.pageDimensions = ue.pageDimensions) : en(this, dr, Ml).call(this), this.parent = ue;
  }
  focusin(ue) {
    this._focusEventsAllowed && (xt(this, sc) ? Zt(this, sc, !1) : this.parent.setSelected(this));
  }
  focusout(ue) {
    var Ue;
    if (!this._focusEventsAllowed || !this.isAttachedToDOM)
      return;
    const Qe = ue.relatedTarget;
    Qe != null && Qe.closest(`#${this.id}`) || (ue.preventDefault(), (Ue = this.parent) != null && Ue.isMultipleSelection || this.commitOrRemove());
  }
  commitOrRemove() {
    this.isEmpty() ? this.remove() : this.commit();
  }
  commit() {
    this.addToAnnotationStorage();
  }
  addToAnnotationStorage() {
    this._uiManager.addToAnnotationStorage(this);
  }
  setAt(ue, Qe, Ue, He) {
    const [Ge, Xe] = this.parentDimensions;
    [Ue, He] = this.screenToPageTranslation(Ue, He), this.x = (ue + Ue) / Ge, this.y = (Qe + He) / Xe, this.fixAndSetPosition();
  }
  translate(ue, Qe) {
    en(this, dr, Lh).call(this, this.parentDimensions, ue, Qe);
  }
  translateInPage(ue, Qe) {
    xt(this, cs) || Zt(this, cs, [this.x, this.y]), en(this, dr, Lh).call(this, this.pageDimensions, ue, Qe), this.div.scrollIntoView({
      block: "nearest"
    });
  }
  drag(ue, Qe) {
    xt(this, cs) || Zt(this, cs, [this.x, this.y]);
    const [Ue, He] = this.parentDimensions;
    if (this.x += ue / Ue, this.y += Qe / He, this.parent && (this.x < 0 || this.x > 1 || this.y < 0 || this.y > 1)) {
      const {
        x: Je,
        y: Ze
      } = this.div.getBoundingClientRect();
      this.parent.findNewParent(this, Je, Ze) && (this.x -= Math.floor(this.x), this.y -= Math.floor(this.y));
    }
    let {
      x: Ge,
      y: Xe
    } = this;
    const [Ke, $e] = this.getBaseTranslation();
    Ge += Ke, Xe += $e, this.div.style.left = `${(100 * Ge).toFixed(2)}%`, this.div.style.top = `${(100 * Xe).toFixed(2)}%`, this.div.scrollIntoView({
      block: "nearest"
    });
  }
  get _hasBeenMoved() {
    return !!xt(this, cs) && (xt(this, cs)[0] !== this.x || xt(this, cs)[1] !== this.y);
  }
  getBaseTranslation() {
    const [ue, Qe] = this.parentDimensions, {
      _borderLineWidth: Ue
    } = Nr, He = Ue / ue, Ge = Ue / Qe;
    switch (this.rotation) {
      case 90:
        return [-He, Ge];
      case 180:
        return [He, Ge];
      case 270:
        return [He, -Ge];
      default:
        return [-He, -Ge];
    }
  }
  get _mustFixPosition() {
    return !0;
  }
  fixAndSetPosition(ue = this.rotation) {
    const [Qe, Ue] = this.pageDimensions;
    let {
      x: He,
      y: Ge,
      width: Xe,
      height: Ke
    } = this;
    if (Xe *= Qe, Ke *= Ue, He *= Qe, Ge *= Ue, this._mustFixPosition)
      switch (ue) {
        case 0:
          He = Math.max(0, Math.min(Qe - Xe, He)), Ge = Math.max(0, Math.min(Ue - Ke, Ge));
          break;
        case 90:
          He = Math.max(0, Math.min(Qe - Ke, He)), Ge = Math.min(Ue, Math.max(Xe, Ge));
          break;
        case 180:
          He = Math.min(Qe, Math.max(Xe, He)), Ge = Math.min(Ue, Math.max(Ke, Ge));
          break;
        case 270:
          He = Math.min(Qe, Math.max(Ke, He)), Ge = Math.max(0, Math.min(Ue - Xe, Ge));
          break;
      }
    this.x = He /= Qe, this.y = Ge /= Ue;
    const [$e, Je] = this.getBaseTranslation();
    He += $e, Ge += Je;
    const {
      style: Ze
    } = this.div;
    Ze.left = `${(100 * He).toFixed(2)}%`, Ze.top = `${(100 * Ge).toFixed(2)}%`, this.moveInDOM();
  }
  screenToPageTranslation(ue, Qe) {
    var Ue;
    return en(Ue = Nr, y0, Mh).call(Ue, ue, Qe, this.parentRotation);
  }
  pageTranslationToScreen(ue, Qe) {
    var Ue;
    return en(Ue = Nr, y0, Mh).call(Ue, ue, Qe, 360 - this.parentRotation);
  }
  get parentScale() {
    return this._uiManager.viewParameters.realScale;
  }
  get parentRotation() {
    return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
  }
  get parentDimensions() {
    const {
      parentScale: ue,
      pageDimensions: [Qe, Ue]
    } = this, He = Qe * ue, Ge = Ue * ue;
    return util_FeatureTest.isCSSRoundSupported ? [Math.round(He), Math.round(Ge)] : [He, Ge];
  }
  setDims(ue, Qe) {
    const [Ue, He] = this.parentDimensions;
    this.div.style.width = `${(100 * ue / Ue).toFixed(2)}%`, xt(this, ac) || (this.div.style.height = `${(100 * Qe / He).toFixed(2)}%`);
  }
  fixDims() {
    const {
      style: ue
    } = this.div, {
      height: Qe,
      width: Ue
    } = ue, He = Ue.endsWith("%"), Ge = !xt(this, ac) && Qe.endsWith("%");
    if (He && Ge)
      return;
    const [Xe, Ke] = this.parentDimensions;
    He || (ue.width = `${(100 * parseFloat(Ue) / Xe).toFixed(2)}%`), !xt(this, ac) && !Ge && (ue.height = `${(100 * parseFloat(Qe) / Ke).toFixed(2)}%`);
  }
  getInitialTranslation() {
    return [0, 0];
  }
  altTextFinish() {
    var ue;
    (ue = xt(this, Oi)) == null || ue.finish();
  }
  async addEditToolbar() {
    return xt(this, wi) || xt(this, uc) ? xt(this, wi) : (Zt(this, wi, new EditorToolbar(this)), this.div.append(xt(this, wi).render()), xt(this, Oi) && xt(this, wi).addAltTextButton(await xt(this, Oi).render()), xt(this, wi));
  }
  removeEditToolbar() {
    var ue;
    xt(this, wi) && (xt(this, wi).remove(), Zt(this, wi, null), (ue = xt(this, Oi)) == null || ue.destroy());
  }
  getClientDimensions() {
    return this.div.getBoundingClientRect();
  }
  async addAltTextButton() {
    xt(this, Oi) || (AltText.initialize(Nr._l10nPromise), Zt(this, Oi, new AltText(this)), await this.addEditToolbar());
  }
  get altTextData() {
    var ue;
    return (ue = xt(this, Oi)) == null ? void 0 : ue.data;
  }
  set altTextData(ue) {
    xt(this, Oi) && (xt(this, Oi).data = ue);
  }
  hasAltText() {
    var ue;
    return !((ue = xt(this, Oi)) != null && ue.isEmpty());
  }
  render() {
    this.div = document.createElement("div"), this.div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360), this.div.className = this.name, this.div.setAttribute("id", this.id), this.div.tabIndex = xt(this, bu) ? -1 : 0, this._isVisible || this.div.classList.add("hidden"), this.setInForeground(), this.div.addEventListener("focusin", xt(this, Su)), this.div.addEventListener("focusout", xt(this, wu));
    const [ue, Qe] = this.parentDimensions;
    this.parentRotation % 180 !== 0 && (this.div.style.maxWidth = `${(100 * Qe / ue).toFixed(2)}%`, this.div.style.maxHeight = `${(100 * ue / Qe).toFixed(2)}%`);
    const [Ue, He] = this.getInitialTranslation();
    return this.translate(Ue, He), bindEvents(this, this.div, ["pointerdown"]), this.div;
  }
  pointerdown(ue) {
    const {
      isMac: Qe
    } = util_FeatureTest.platform;
    if (ue.button !== 0 || ue.ctrlKey && Qe) {
      ue.preventDefault();
      return;
    }
    if (Zt(this, sc, !0), this._isDraggable) {
      en(this, dr, dg).call(this, ue);
      return;
    }
    en(this, dr, Vh).call(this, ue);
  }
  moveInDOM() {
    xt(this, Ha) && clearTimeout(xt(this, Ha)), Zt(this, Ha, setTimeout(() => {
      var ue;
      Zt(this, Ha, null), (ue = this.parent) == null || ue.moveEditorInDOM(this);
    }, 0));
  }
  _setParentAndPosition(ue, Qe, Ue) {
    ue.changeParent(this), this.x = Qe, this.y = Ue, this.fixAndSetPosition();
  }
  getRect(ue, Qe, Ue = this.rotation) {
    const He = this.parentScale, [Ge, Xe] = this.pageDimensions, [Ke, $e] = this.pageTranslation, Je = ue / He, Ze = Qe / He, nt = this.x * Ge, tt = this.y * Xe, et = this.width * Ge, rt = this.height * Xe;
    switch (Ue) {
      case 0:
        return [nt + Je + Ke, Xe - tt - Ze - rt + $e, nt + Je + et + Ke, Xe - tt - Ze + $e];
      case 90:
        return [nt + Ze + Ke, Xe - tt + Je + $e, nt + Ze + rt + Ke, Xe - tt + Je + et + $e];
      case 180:
        return [nt - Je - et + Ke, Xe - tt + Ze + $e, nt - Je + Ke, Xe - tt + Ze + rt + $e];
      case 270:
        return [nt - Ze - rt + Ke, Xe - tt - Je - et + $e, nt - Ze + Ke, Xe - tt - Je + $e];
      default:
        throw new Error("Invalid rotation");
    }
  }
  getRectInCurrentCoords(ue, Qe) {
    const [Ue, He, Ge, Xe] = ue, Ke = Ge - Ue, $e = Xe - He;
    switch (this.rotation) {
      case 0:
        return [Ue, Qe - Xe, Ke, $e];
      case 90:
        return [Ue, Qe - He, $e, Ke];
      case 180:
        return [Ge, Qe - He, Ke, $e];
      case 270:
        return [Ge, Qe - Xe, $e, Ke];
      default:
        throw new Error("Invalid rotation");
    }
  }
  onceAdded() {
  }
  isEmpty() {
    return !1;
  }
  enableEditMode() {
    Zt(this, uc, !0);
  }
  disableEditMode() {
    Zt(this, uc, !1);
  }
  isInEditMode() {
    return xt(this, uc);
  }
  shouldGetKeyboardEvents() {
    return xt(this, To);
  }
  needsToBeRebuilt() {
    return this.div && !this.isAttachedToDOM;
  }
  rebuild() {
    var ue, Qe;
    (ue = this.div) == null || ue.addEventListener("focusin", xt(this, Su)), (Qe = this.div) == null || Qe.addEventListener("focusout", xt(this, wu));
  }
  rotate(ue) {
  }
  serialize(ue = !1, Qe = null) {
    unreachable("An editor must be serializable");
  }
  static deserialize(ue, Qe, Ue) {
    const He = new this.prototype.constructor({
      parent: Qe,
      id: Qe.getNextId(),
      uiManager: Ue
    });
    He.rotation = ue.rotation;
    const [Ge, Xe] = He.pageDimensions, [Ke, $e, Je, Ze] = He.getRectInCurrentCoords(ue.rect, Xe);
    return He.x = Ke / Ge, He.y = $e / Xe, He.width = Je / Ge, He.height = Ze / Xe, He;
  }
  get hasBeenModified() {
    return !!this.annotationElementId && (this.deleted || this.serialize() !== null);
  }
  remove() {
    if (this.div.removeEventListener("focusin", xt(this, Su)), this.div.removeEventListener("focusout", xt(this, wu)), this.isEmpty() || this.commit(), this.parent ? this.parent.remove(this) : this._uiManager.removeEditor(this), xt(this, Ha) && (clearTimeout(xt(this, Ha)), Zt(this, Ha, null)), en(this, dr, Ml).call(this), this.removeEditToolbar(), xt(this, fa)) {
      for (const ue of xt(this, fa).values())
        clearTimeout(ue);
      Zt(this, fa, null);
    }
    this.parent = null;
  }
  get isResizable() {
    return !1;
  }
  makeResizable() {
    this.isResizable && (en(this, dr, ug).call(this), xt(this, Ai).classList.remove("hidden"), bindEvents(this, this.div, ["keydown"]));
  }
  get toolbarPosition() {
    return null;
  }
  keydown(ue) {
    if (!this.isResizable || ue.target !== this.div || ue.key !== "Enter")
      return;
    this._uiManager.setSelected(this), Zt(this, oc, {
      savedX: this.x,
      savedY: this.y,
      savedWidth: this.width,
      savedHeight: this.height
    });
    const Qe = xt(this, Ai).children;
    if (!xt(this, xa)) {
      Zt(this, xa, Array.from(Qe));
      const Xe = en(this, dr, fg).bind(this), Ke = en(this, dr, hg).bind(this);
      for (const $e of xt(this, xa)) {
        const Je = $e.getAttribute("data-resizer-name");
        $e.setAttribute("role", "spinbutton"), $e.addEventListener("keydown", Xe), $e.addEventListener("blur", Ke), $e.addEventListener("focus", en(this, dr, pg).bind(this, Je)), Nr._l10nPromise.get(`pdfjs-editor-resizer-label-${Je}`).then((Ze) => $e.setAttribute("aria-label", Ze));
      }
    }
    const Ue = xt(this, xa)[0];
    let He = 0;
    for (const Xe of Qe) {
      if (Xe === Ue)
        break;
      He++;
    }
    const Ge = (360 - this.rotation + this.parentRotation) % 360 / 90 * (xt(this, xa).length / 4);
    if (Ge !== He) {
      if (Ge < He)
        for (let Ke = 0; Ke < He - Ge; Ke++)
          xt(this, Ai).append(xt(this, Ai).firstChild);
      else if (Ge > He)
        for (let Ke = 0; Ke < Ge - He; Ke++)
          xt(this, Ai).firstChild.before(xt(this, Ai).lastChild);
      let Xe = 0;
      for (const Ke of Qe) {
        const Je = xt(this, xa)[Xe++].getAttribute("data-resizer-name");
        Nr._l10nPromise.get(`pdfjs-editor-resizer-label-${Je}`).then((Ze) => Ke.setAttribute("aria-label", Ze));
      }
    }
    en(this, dr, Uh).call(this, 0), Zt(this, To, !0), xt(this, Ai).firstChild.focus({
      focusVisible: !0
    }), ue.preventDefault(), ue.stopImmediatePropagation();
  }
  _resizeWithKeyboard(ue, Qe) {
    xt(this, To) && en(this, dr, jh).call(this, xt(this, E0), {
      movementX: ue,
      movementY: Qe
    });
  }
  _stopResizingWithKeyboard() {
    en(this, dr, Ml).call(this), this.div.focus();
  }
  select() {
    var ue, Qe;
    if (this.makeResizable(), (ue = this.div) == null || ue.classList.add("selectedEditor"), !xt(this, wi)) {
      this.addEditToolbar().then(() => {
        var Ue, He;
        (Ue = this.div) != null && Ue.classList.contains("selectedEditor") && ((He = xt(this, wi)) == null || He.show());
      });
      return;
    }
    (Qe = xt(this, wi)) == null || Qe.show();
  }
  unselect() {
    var ue, Qe, Ue, He;
    (ue = xt(this, Ai)) == null || ue.classList.add("hidden"), (Qe = this.div) == null || Qe.classList.remove("selectedEditor"), (Ue = this.div) != null && Ue.contains(document.activeElement) && this._uiManager.currentLayer.div.focus({
      preventScroll: !0
    }), (He = xt(this, wi)) == null || He.hide();
  }
  updateParams(ue, Qe) {
  }
  disableEditing() {
  }
  enableEditing() {
  }
  enterInEditMode() {
  }
  getImageForAltText() {
    return null;
  }
  get contentDiv() {
    return this.div;
  }
  get isEditing() {
    return xt(this, C0);
  }
  set isEditing(ue) {
    Zt(this, C0, ue), this.parent && (ue ? (this.parent.setSelected(this), this.parent.setActiveEditor(this)) : this.parent.setActiveEditor(null));
  }
  setAspectRatio(ue, Qe) {
    Zt(this, ac, !0);
    const Ue = ue / Qe, {
      style: He
    } = this.div;
    He.aspectRatio = Ue, He.height = "auto";
  }
  static get MIN_SIZE() {
    return 16;
  }
  static canCreateNewEmptyEditor() {
    return !0;
  }
  get telemetryInitialData() {
    return {
      action: "added"
    };
  }
  get telemetryFinalData() {
    return null;
  }
  _reportTelemetry(ue, Qe = !1) {
    if (Qe) {
      xt(this, fa) || Zt(this, fa, /* @__PURE__ */ new Map());
      const {
        action: Ue
      } = ue;
      let He = xt(this, fa).get(Ue);
      He && clearTimeout(He), He = setTimeout(() => {
        this._reportTelemetry(ue), xt(this, fa).delete(Ue), xt(this, fa).size === 0 && Zt(this, fa, null);
      }, Nr._telemetryTimeout), xt(this, fa).set(Ue, He);
      return;
    }
    ue.type || (ue.type = this.editorType), this._uiManager._eventBus.dispatch("reporttelemetry", {
      source: this,
      details: {
        type: "editing",
        data: ue
      }
    });
  }
  show(ue = this._isVisible) {
    this.div.classList.toggle("hidden", !ue), this._isVisible = ue;
  }
  enable() {
    this.div && (this.div.tabIndex = 0), Zt(this, bu, !1);
  }
  disable() {
    this.div && (this.div.tabIndex = -1), Zt(this, bu, !0);
  }
  renderAnnotationElement(ue) {
    let Qe = ue.container.querySelector(".annotationContent");
    if (!Qe)
      Qe = document.createElement("div"), Qe.classList.add("annotationContent", this.editorType), ue.container.prepend(Qe);
    else if (Qe.nodeName === "CANVAS") {
      const Ue = Qe;
      Qe = document.createElement("div"), Qe.classList.add("annotationContent", this.editorType), Ue.before(Qe);
    }
    return Qe;
  }
  resetAnnotationElement(ue) {
    const {
      firstChild: Qe
    } = ue.container;
    Qe.nodeName === "DIV" && Qe.classList.contains("annotationContent") && Qe.remove();
  }
};
xa = new WeakMap(), Oi = new WeakMap(), bu = new WeakMap(), ac = new WeakMap(), Ai = new WeakMap(), oc = new WeakMap(), Su = new WeakMap(), wu = new WeakMap(), wi = new WeakMap(), E0 = new WeakMap(), sc = new WeakMap(), cs = new WeakMap(), C0 = new WeakMap(), uc = new WeakMap(), To = new WeakMap(), Ha = new WeakMap(), Tu = new WeakMap(), Bu = new WeakMap(), fa = new WeakMap(), v0 = new WeakMap(), Y2 = new WeakMap(), dr = new WeakSet(), Lh = function([ue, Qe], Ue, He) {
  [Ue, He] = this.screenToPageTranslation(Ue, He), this.x += Ue / ue, this.y += He / Qe, this.fixAndSetPosition();
}, y0 = new WeakSet(), Mh = function(ue, Qe, Ue) {
  switch (Ue) {
    case 90:
      return [Qe, -ue];
    case 180:
      return [-ue, -Qe];
    case 270:
      return [-Qe, ue];
    default:
      return [ue, Qe];
  }
}, Qh = function(ue) {
  switch (ue) {
    case 90: {
      const [Qe, Ue] = this.pageDimensions;
      return [0, -Qe / Ue, Ue / Qe, 0];
    }
    case 180:
      return [-1, 0, 0, -1];
    case 270: {
      const [Qe, Ue] = this.pageDimensions;
      return [0, Qe / Ue, -Ue / Qe, 0];
    }
    default:
      return [1, 0, 0, 1];
  }
}, ug = function() {
  if (xt(this, Ai))
    return;
  Zt(this, Ai, document.createElement("div")), xt(this, Ai).classList.add("resizers");
  const ue = this._willKeepAspectRatio ? ["topLeft", "topRight", "bottomRight", "bottomLeft"] : ["topLeft", "topMiddle", "topRight", "middleRight", "bottomRight", "bottomMiddle", "bottomLeft", "middleLeft"];
  for (const Qe of ue) {
    const Ue = document.createElement("div");
    xt(this, Ai).append(Ue), Ue.classList.add("resizer", Qe), Ue.setAttribute("data-resizer-name", Qe), Ue.addEventListener("pointerdown", en(this, dr, lg).bind(this, Qe)), Ue.addEventListener("contextmenu", noContextMenu), Ue.tabIndex = -1;
  }
  this.div.prepend(xt(this, Ai));
}, lg = function(ue, Qe) {
  var rt;
  Qe.preventDefault();
  const {
    isMac: Ue
  } = util_FeatureTest.platform;
  if (Qe.button !== 0 || Qe.ctrlKey && Ue)
    return;
  (rt = xt(this, Oi)) == null || rt.toggle(!1);
  const He = en(this, dr, jh).bind(this, ue), Ge = this._isDraggable;
  this._isDraggable = !1;
  const Xe = {
    passive: !0,
    capture: !0
  };
  this.parent.togglePointerEvents(!1), window.addEventListener("pointermove", He, Xe), window.addEventListener("contextmenu", noContextMenu);
  const Ke = this.x, $e = this.y, Je = this.width, Ze = this.height, nt = this.parent.div.style.cursor, tt = this.div.style.cursor;
  this.div.style.cursor = this.parent.div.style.cursor = window.getComputedStyle(Qe.target).cursor;
  const et = () => {
    var it;
    this.parent.togglePointerEvents(!0), (it = xt(this, Oi)) == null || it.toggle(!0), this._isDraggable = Ge, window.removeEventListener("pointerup", et), window.removeEventListener("blur", et), window.removeEventListener("pointermove", He, Xe), window.removeEventListener("contextmenu", noContextMenu), this.parent.div.style.cursor = nt, this.div.style.cursor = tt, en(this, dr, Fh).call(this, Ke, $e, Je, Ze);
  };
  window.addEventListener("pointerup", et), window.addEventListener("blur", et);
}, Fh = function(ue, Qe, Ue, He) {
  const Ge = this.x, Xe = this.y, Ke = this.width, $e = this.height;
  Ge === ue && Xe === Qe && Ke === Ue && $e === He || this.addCommands({
    cmd: () => {
      this.width = Ke, this.height = $e, this.x = Ge, this.y = Xe;
      const [Je, Ze] = this.parentDimensions;
      this.setDims(Je * Ke, Ze * $e), this.fixAndSetPosition();
    },
    undo: () => {
      this.width = Ue, this.height = He, this.x = ue, this.y = Qe;
      const [Je, Ze] = this.parentDimensions;
      this.setDims(Je * Ue, Ze * He), this.fixAndSetPosition();
    },
    mustExec: !0
  });
}, jh = function(ue, Qe) {
  const [Ue, He] = this.parentDimensions, Ge = this.x, Xe = this.y, Ke = this.width, $e = this.height, Je = Nr.MIN_SIZE / Ue, Ze = Nr.MIN_SIZE / He, nt = (Et) => Math.round(Et * 1e4) / 1e4, tt = en(this, dr, Qh).call(this, this.rotation), et = (Et, bt) => [tt[0] * Et + tt[2] * bt, tt[1] * Et + tt[3] * bt], rt = en(this, dr, Qh).call(this, 360 - this.rotation), it = (Et, bt) => [rt[0] * Et + rt[2] * bt, rt[1] * Et + rt[3] * bt];
  let ot, at, st = !1, ut = !1;
  switch (ue) {
    case "topLeft":
      st = !0, ot = (Et, bt) => [0, 0], at = (Et, bt) => [Et, bt];
      break;
    case "topMiddle":
      ot = (Et, bt) => [Et / 2, 0], at = (Et, bt) => [Et / 2, bt];
      break;
    case "topRight":
      st = !0, ot = (Et, bt) => [Et, 0], at = (Et, bt) => [0, bt];
      break;
    case "middleRight":
      ut = !0, ot = (Et, bt) => [Et, bt / 2], at = (Et, bt) => [0, bt / 2];
      break;
    case "bottomRight":
      st = !0, ot = (Et, bt) => [Et, bt], at = (Et, bt) => [0, 0];
      break;
    case "bottomMiddle":
      ot = (Et, bt) => [Et / 2, bt], at = (Et, bt) => [Et / 2, 0];
      break;
    case "bottomLeft":
      st = !0, ot = (Et, bt) => [0, bt], at = (Et, bt) => [Et, 0];
      break;
    case "middleLeft":
      ut = !0, ot = (Et, bt) => [0, bt / 2], at = (Et, bt) => [Et, bt / 2];
      break;
  }
  const lt = ot(Ke, $e), dt = at(Ke, $e);
  let At = et(...dt);
  const pt = nt(Ge + At[0]), gt = nt(Xe + At[1]);
  let wt = 1, Bt = 1, [Tt, yt] = this.screenToPageTranslation(Qe.movementX, Qe.movementY);
  if ([Tt, yt] = it(Tt / Ue, yt / He), st) {
    const Et = Math.hypot(Ke, $e);
    wt = Bt = Math.max(Math.min(Math.hypot(dt[0] - lt[0] - Tt, dt[1] - lt[1] - yt) / Et, 1 / Ke, 1 / $e), Je / Ke, Ze / $e);
  } else ut ? wt = Math.max(Je, Math.min(1, Math.abs(dt[0] - lt[0] - Tt))) / Ke : Bt = Math.max(Ze, Math.min(1, Math.abs(dt[1] - lt[1] - yt))) / $e;
  const Ct = nt(Ke * wt), ht = nt($e * Bt);
  At = et(...at(Ct, ht));
  const It = pt - At[0], vt = gt - At[1];
  this.width = Ct, this.height = ht, this.x = It, this.y = vt, this.setDims(Ue * Ct, He * ht), this.fixAndSetPosition();
}, Vh = function(ue) {
  const {
    isMac: Qe
  } = util_FeatureTest.platform;
  ue.ctrlKey && !Qe || ue.shiftKey || ue.metaKey && Qe ? this.parent.toggleSelected(this) : this.parent.setSelected(this);
}, dg = function(ue) {
  const Qe = this._uiManager.isSelected(this);
  this._uiManager.setUpDragSession();
  let Ue, He;
  Qe && (this.div.classList.add("moving"), Ue = {
    passive: !0,
    capture: !0
  }, Zt(this, Tu, ue.clientX), Zt(this, Bu, ue.clientY), He = (Xe) => {
    const {
      clientX: Ke,
      clientY: $e
    } = Xe, [Je, Ze] = this.screenToPageTranslation(Ke - xt(this, Tu), $e - xt(this, Bu));
    Zt(this, Tu, Ke), Zt(this, Bu, $e), this._uiManager.dragSelectedEditors(Je, Ze);
  }, window.addEventListener("pointermove", He, Ue));
  const Ge = () => {
    window.removeEventListener("pointerup", Ge), window.removeEventListener("blur", Ge), Qe && (this.div.classList.remove("moving"), window.removeEventListener("pointermove", He, Ue)), Zt(this, sc, !1), this._uiManager.endDragSession() || en(this, dr, Vh).call(this, ue);
  };
  window.addEventListener("pointerup", Ge), window.addEventListener("blur", Ge);
}, fg = function(ue) {
  Nr._resizerKeyboardManager.exec(this, ue);
}, hg = function(ue) {
  var Qe;
  xt(this, To) && ((Qe = ue.relatedTarget) == null ? void 0 : Qe.parentNode) !== xt(this, Ai) && en(this, dr, Ml).call(this);
}, pg = function(ue) {
  Zt(this, E0, xt(this, To) ? ue : "");
}, Uh = function(ue) {
  if (xt(this, xa))
    for (const Qe of xt(this, xa))
      Qe.tabIndex = ue;
}, Ml = function() {
  if (Zt(this, To, !1), en(this, dr, Uh).call(this, -1), xt(this, oc)) {
    const {
      savedX: ue,
      savedY: Qe,
      savedWidth: Ue,
      savedHeight: He
    } = xt(this, oc);
    en(this, dr, Fh).call(this, ue, Qe, Ue, He), Zt(this, oc, null);
  }
}, tn(Nr, y0), $n(Nr, "_borderLineWidth", -1), $n(Nr, "_colorManager", new ColorManager()), $n(Nr, "_zIndex", 1), $n(Nr, "_telemetryTimeout", 1e3);
let AnnotationEditor = Nr;
class FakeEditor extends AnnotationEditor {
  constructor(ue) {
    super(ue), this.annotationElementId = ue.annotationElementId, this.deleted = !0;
  }
  serialize() {
    return {
      id: this.annotationElementId,
      deleted: !0,
      pageIndex: this.pageIndex
    };
  }
}
const SEED = 3285377520, MASK_HIGH = 4294901760, MASK_LOW = 65535;
class MurmurHash3_64 {
  constructor(ue) {
    this.h1 = ue ? ue & 4294967295 : SEED, this.h2 = ue ? ue & 4294967295 : SEED;
  }
  update(ue) {
    let Qe, Ue;
    if (typeof ue == "string") {
      Qe = new Uint8Array(ue.length * 2), Ue = 0;
      for (let it = 0, ot = ue.length; it < ot; it++) {
        const at = ue.charCodeAt(it);
        at <= 255 ? Qe[Ue++] = at : (Qe[Ue++] = at >>> 8, Qe[Ue++] = at & 255);
      }
    } else if (ArrayBuffer.isView(ue))
      Qe = ue.slice(), Ue = Qe.byteLength;
    else
      throw new Error("Invalid data format, must be a string or TypedArray.");
    const He = Ue >> 2, Ge = Ue - He * 4, Xe = new Uint32Array(Qe.buffer, 0, He);
    let Ke = 0, $e = 0, Je = this.h1, Ze = this.h2;
    const nt = 3432918353, tt = 461845907, et = nt & MASK_LOW, rt = tt & MASK_LOW;
    for (let it = 0; it < He; it++)
      it & 1 ? (Ke = Xe[it], Ke = Ke * nt & MASK_HIGH | Ke * et & MASK_LOW, Ke = Ke << 15 | Ke >>> 17, Ke = Ke * tt & MASK_HIGH | Ke * rt & MASK_LOW, Je ^= Ke, Je = Je << 13 | Je >>> 19, Je = Je * 5 + 3864292196) : ($e = Xe[it], $e = $e * nt & MASK_HIGH | $e * et & MASK_LOW, $e = $e << 15 | $e >>> 17, $e = $e * tt & MASK_HIGH | $e * rt & MASK_LOW, Ze ^= $e, Ze = Ze << 13 | Ze >>> 19, Ze = Ze * 5 + 3864292196);
    switch (Ke = 0, Ge) {
      case 3:
        Ke ^= Qe[He * 4 + 2] << 16;
      case 2:
        Ke ^= Qe[He * 4 + 1] << 8;
      case 1:
        Ke ^= Qe[He * 4], Ke = Ke * nt & MASK_HIGH | Ke * et & MASK_LOW, Ke = Ke << 15 | Ke >>> 17, Ke = Ke * tt & MASK_HIGH | Ke * rt & MASK_LOW, He & 1 ? Je ^= Ke : Ze ^= Ke;
    }
    this.h1 = Je, this.h2 = Ze;
  }
  hexdigest() {
    let ue = this.h1, Qe = this.h2;
    return ue ^= Qe >>> 1, ue = ue * 3981806797 & MASK_HIGH | ue * 36045 & MASK_LOW, Qe = Qe * 4283543511 & MASK_HIGH | ((Qe << 16 | ue >>> 16) * 2950163797 & MASK_HIGH) >>> 16, ue ^= Qe >>> 1, ue = ue * 444984403 & MASK_HIGH | ue * 60499 & MASK_LOW, Qe = Qe * 3301882366 & MASK_HIGH | ((Qe << 16 | ue >>> 16) * 3120437893 & MASK_HIGH) >>> 16, ue ^= Qe >>> 1, (ue >>> 0).toString(16).padStart(8, "0") + (Qe >>> 0).toString(16).padStart(8, "0");
  }
}
const SerializableEmpty = Object.freeze({
  map: null,
  hash: "",
  transfer: void 0
});
var lc, gi, $2, Ag;
class AnnotationStorage {
  constructor() {
    tn(this, $2);
    tn(this, lc, !1);
    tn(this, gi, /* @__PURE__ */ new Map());
    this.onSetModified = null, this.onResetModified = null, this.onAnnotationEditor = null;
  }
  getValue(ue, Qe) {
    const Ue = xt(this, gi).get(ue);
    return Ue === void 0 ? Qe : Object.assign(Qe, Ue);
  }
  getRawValue(ue) {
    return xt(this, gi).get(ue);
  }
  remove(ue) {
    if (xt(this, gi).delete(ue), xt(this, gi).size === 0 && this.resetModified(), typeof this.onAnnotationEditor == "function") {
      for (const Qe of xt(this, gi).values())
        if (Qe instanceof AnnotationEditor)
          return;
      this.onAnnotationEditor(null);
    }
  }
  setValue(ue, Qe) {
    const Ue = xt(this, gi).get(ue);
    let He = !1;
    if (Ue !== void 0)
      for (const [Ge, Xe] of Object.entries(Qe))
        Ue[Ge] !== Xe && (He = !0, Ue[Ge] = Xe);
    else
      He = !0, xt(this, gi).set(ue, Qe);
    He && en(this, $2, Ag).call(this), Qe instanceof AnnotationEditor && typeof this.onAnnotationEditor == "function" && this.onAnnotationEditor(Qe.constructor._type);
  }
  has(ue) {
    return xt(this, gi).has(ue);
  }
  getAll() {
    return xt(this, gi).size > 0 ? objectFromMap(xt(this, gi)) : null;
  }
  setAll(ue) {
    for (const [Qe, Ue] of Object.entries(ue))
      this.setValue(Qe, Ue);
  }
  get size() {
    return xt(this, gi).size;
  }
  resetModified() {
    xt(this, lc) && (Zt(this, lc, !1), typeof this.onResetModified == "function" && this.onResetModified());
  }
  get print() {
    return new PrintAnnotationStorage(this);
  }
  get serializable() {
    if (xt(this, gi).size === 0)
      return SerializableEmpty;
    const ue = /* @__PURE__ */ new Map(), Qe = new MurmurHash3_64(), Ue = [], He = /* @__PURE__ */ Object.create(null);
    let Ge = !1;
    for (const [Xe, Ke] of xt(this, gi)) {
      const $e = Ke instanceof AnnotationEditor ? Ke.serialize(!1, He) : Ke;
      $e && (ue.set(Xe, $e), Qe.update(`${Xe}:${JSON.stringify($e)}`), Ge || (Ge = !!$e.bitmap));
    }
    if (Ge)
      for (const Xe of ue.values())
        Xe.bitmap && Ue.push(Xe.bitmap);
    return ue.size > 0 ? {
      map: ue,
      hash: Qe.hexdigest(),
      transfer: Ue
    } : SerializableEmpty;
  }
  get editorStats() {
    let ue = null;
    const Qe = /* @__PURE__ */ new Map();
    for (const Ue of xt(this, gi).values()) {
      if (!(Ue instanceof AnnotationEditor))
        continue;
      const He = Ue.telemetryFinalData;
      if (!He)
        continue;
      const {
        type: Ge
      } = He;
      Qe.has(Ge) || Qe.set(Ge, Object.getPrototypeOf(Ue).constructor), ue || (ue = /* @__PURE__ */ Object.create(null));
      const Xe = ue[Ge] || (ue[Ge] = /* @__PURE__ */ new Map());
      for (const [Ke, $e] of Object.entries(He)) {
        if (Ke === "type")
          continue;
        let Je = Xe.get(Ke);
        Je || (Je = /* @__PURE__ */ new Map(), Xe.set(Ke, Je));
        const Ze = Je.get($e) ?? 0;
        Je.set($e, Ze + 1);
      }
    }
    for (const [Ue, He] of Qe)
      ue[Ue] = He.computeTelemetryFinalData(ue[Ue]);
    return ue;
  }
}
lc = new WeakMap(), gi = new WeakMap(), $2 = new WeakSet(), Ag = function() {
  xt(this, lc) || (Zt(this, lc, !0), typeof this.onSetModified == "function" && this.onSetModified());
};
var I0;
class PrintAnnotationStorage extends AnnotationStorage {
  constructor(Qe) {
    super();
    tn(this, I0);
    const {
      map: Ue,
      hash: He,
      transfer: Ge
    } = Qe.serializable, Xe = structuredClone(Ue, Ge ? {
      transfer: Ge
    } : null);
    Zt(this, I0, {
      map: Xe,
      hash: He,
      transfer: Ge
    });
  }
  get print() {
    unreachable("Should not call PrintAnnotationStorage.print");
  }
  get serializable() {
    return xt(this, I0);
  }
}
I0 = new WeakMap();
var Ru;
class FontLoader {
  constructor({
    ownerDocument: ue = globalThis.document,
    styleElement: Qe = null
  }) {
    tn(this, Ru, /* @__PURE__ */ new Set());
    this._document = ue, this.nativeFontFaces = /* @__PURE__ */ new Set(), this.styleElement = null, this.loadingRequests = [], this.loadTestFontId = 0;
  }
  addNativeFontFace(ue) {
    this.nativeFontFaces.add(ue), this._document.fonts.add(ue);
  }
  removeNativeFontFace(ue) {
    this.nativeFontFaces.delete(ue), this._document.fonts.delete(ue);
  }
  insertRule(ue) {
    this.styleElement || (this.styleElement = this._document.createElement("style"), this._document.documentElement.getElementsByTagName("head")[0].append(this.styleElement));
    const Qe = this.styleElement.sheet;
    Qe.insertRule(ue, Qe.cssRules.length);
  }
  clear() {
    for (const ue of this.nativeFontFaces)
      this._document.fonts.delete(ue);
    this.nativeFontFaces.clear(), xt(this, Ru).clear(), this.styleElement && (this.styleElement.remove(), this.styleElement = null);
  }
  async loadSystemFont({
    systemFontInfo: ue,
    _inspectFont: Qe
  }) {
    if (!(!ue || xt(this, Ru).has(ue.loadedName))) {
      if (assert(!this.disableFontFace, "loadSystemFont shouldn't be called when `disableFontFace` is set."), this.isFontLoadingAPISupported) {
        const {
          loadedName: Ue,
          src: He,
          style: Ge
        } = ue, Xe = new FontFace(Ue, He, Ge);
        this.addNativeFontFace(Xe);
        try {
          await Xe.load(), xt(this, Ru).add(Ue), Qe == null || Qe(ue);
        } catch {
          warn(`Cannot load system font: ${ue.baseFontName}, installing it could help to improve PDF rendering.`), this.removeNativeFontFace(Xe);
        }
        return;
      }
      unreachable("Not implemented: loadSystemFont without the Font Loading API.");
    }
  }
  async bind(ue) {
    if (ue.attached || ue.missingFile && !ue.systemFontInfo)
      return;
    if (ue.attached = !0, ue.systemFontInfo) {
      await this.loadSystemFont(ue);
      return;
    }
    if (this.isFontLoadingAPISupported) {
      const Ue = ue.createNativeFontFace();
      if (Ue) {
        this.addNativeFontFace(Ue);
        try {
          await Ue.loaded;
        } catch (He) {
          throw warn(`Failed to load font '${Ue.family}': '${He}'.`), ue.disableFontFace = !0, He;
        }
      }
      return;
    }
    const Qe = ue.createFontFaceRule();
    if (Qe) {
      if (this.insertRule(Qe), this.isSyncFontLoadingSupported)
        return;
      await new Promise((Ue) => {
        const He = this._queueLoadingCallback(Ue);
        this._prepareFontLoadEvent(ue, He);
      });
    }
  }
  get isFontLoadingAPISupported() {
    var Qe;
    const ue = !!((Qe = this._document) != null && Qe.fonts);
    return shadow(this, "isFontLoadingAPISupported", ue);
  }
  get isSyncFontLoadingSupported() {
    let ue = !1;
    return (isNodeJS || typeof navigator < "u" && typeof (navigator == null ? void 0 : navigator.userAgent) == "string" && /Mozilla\/5.0.*?rv:\d+.*? Gecko/.test(navigator.userAgent)) && (ue = !0), shadow(this, "isSyncFontLoadingSupported", ue);
  }
  _queueLoadingCallback(ue) {
    function Qe() {
      for (assert(!He.done, "completeRequest() cannot be called twice."), He.done = !0; Ue.length > 0 && Ue[0].done; ) {
        const Ge = Ue.shift();
        setTimeout(Ge.callback, 0);
      }
    }
    const {
      loadingRequests: Ue
    } = this, He = {
      done: !1,
      complete: Qe,
      callback: ue
    };
    return Ue.push(He), He;
  }
  get _loadTestFont() {
    const ue = atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
    return shadow(this, "_loadTestFont", ue);
  }
  _prepareFontLoadEvent(ue, Qe) {
    function Ue(lt, dt) {
      return lt.charCodeAt(dt) << 24 | lt.charCodeAt(dt + 1) << 16 | lt.charCodeAt(dt + 2) << 8 | lt.charCodeAt(dt + 3) & 255;
    }
    function He(lt, dt, At, pt) {
      const gt = lt.substring(0, dt), wt = lt.substring(dt + At);
      return gt + pt + wt;
    }
    let Ge, Xe;
    const Ke = this._document.createElement("canvas");
    Ke.width = 1, Ke.height = 1;
    const $e = Ke.getContext("2d");
    let Je = 0;
    function Ze(lt, dt) {
      if (++Je > 30) {
        warn("Load test font never loaded."), dt();
        return;
      }
      if ($e.font = "30px " + lt, $e.fillText(".", 0, 20), $e.getImageData(0, 0, 1, 1).data[3] > 0) {
        dt();
        return;
      }
      setTimeout(Ze.bind(null, lt, dt));
    }
    const nt = `lt${Date.now()}${this.loadTestFontId++}`;
    let tt = this._loadTestFont;
    tt = He(tt, 976, nt.length, nt);
    const rt = 16, it = 1482184792;
    let ot = Ue(tt, rt);
    for (Ge = 0, Xe = nt.length - 3; Ge < Xe; Ge += 4)
      ot = ot - it + Ue(nt, Ge) | 0;
    Ge < nt.length && (ot = ot - it + Ue(nt + "XXX", Ge) | 0), tt = He(tt, rt, 4, string32(ot));
    const at = `url(data:font/opentype;base64,${btoa(tt)});`, st = `@font-face {font-family:"${nt}";src:${at}}`;
    this.insertRule(st);
    const ut = this._document.createElement("div");
    ut.style.visibility = "hidden", ut.style.width = ut.style.height = "10px", ut.style.position = "absolute", ut.style.top = ut.style.left = "0px";
    for (const lt of [ue.loadedName, nt]) {
      const dt = this._document.createElement("span");
      dt.textContent = "Hi", dt.style.fontFamily = lt, ut.append(dt);
    }
    this._document.body.append(ut), Ze(nt, () => {
      ut.remove(), Qe.complete();
    });
  }
}
Ru = new WeakMap();
class FontFaceObject {
  constructor(ue, {
    disableFontFace: Qe = !1,
    inspectFont: Ue = null
  }) {
    this.compiledGlyphs = /* @__PURE__ */ Object.create(null);
    for (const He in ue)
      this[He] = ue[He];
    this.disableFontFace = Qe === !0, this._inspectFont = Ue;
  }
  createNativeFontFace() {
    var Qe;
    if (!this.data || this.disableFontFace)
      return null;
    let ue;
    if (!this.cssFontInfo)
      ue = new FontFace(this.loadedName, this.data, {});
    else {
      const Ue = {
        weight: this.cssFontInfo.fontWeight
      };
      this.cssFontInfo.italicAngle && (Ue.style = `oblique ${this.cssFontInfo.italicAngle}deg`), ue = new FontFace(this.cssFontInfo.fontFamily, this.data, Ue);
    }
    return (Qe = this._inspectFont) == null || Qe.call(this, this), ue;
  }
  createFontFaceRule() {
    var He;
    if (!this.data || this.disableFontFace)
      return null;
    const ue = bytesToString(this.data), Qe = `url(data:${this.mimetype};base64,${btoa(ue)});`;
    let Ue;
    if (!this.cssFontInfo)
      Ue = `@font-face {font-family:"${this.loadedName}";src:${Qe}}`;
    else {
      let Ge = `font-weight: ${this.cssFontInfo.fontWeight};`;
      this.cssFontInfo.italicAngle && (Ge += `font-style: oblique ${this.cssFontInfo.italicAngle}deg;`), Ue = `@font-face {font-family:"${this.cssFontInfo.fontFamily}";${Ge}src:${Qe}}`;
    }
    return (He = this._inspectFont) == null || He.call(this, this, Qe), Ue;
  }
  getPathGenerator(ue, Qe) {
    if (this.compiledGlyphs[Qe] !== void 0)
      return this.compiledGlyphs[Qe];
    let Ue;
    try {
      Ue = ue.get(this.loadedName + "_path_" + Qe);
    } catch (Ge) {
      warn(`getPathGenerator - ignoring character: "${Ge}".`);
    }
    if (!Array.isArray(Ue) || Ue.length === 0)
      return this.compiledGlyphs[Qe] = function(Ge, Xe) {
      };
    const He = [];
    for (let Ge = 0, Xe = Ue.length; Ge < Xe; )
      switch (Ue[Ge++]) {
        case FontRenderOps.BEZIER_CURVE_TO:
          {
            const [Ke, $e, Je, Ze, nt, tt] = Ue.slice(Ge, Ge + 6);
            He.push((et) => et.bezierCurveTo(Ke, $e, Je, Ze, nt, tt)), Ge += 6;
          }
          break;
        case FontRenderOps.MOVE_TO:
          {
            const [Ke, $e] = Ue.slice(Ge, Ge + 2);
            He.push((Je) => Je.moveTo(Ke, $e)), Ge += 2;
          }
          break;
        case FontRenderOps.LINE_TO:
          {
            const [Ke, $e] = Ue.slice(Ge, Ge + 2);
            He.push((Je) => Je.lineTo(Ke, $e)), Ge += 2;
          }
          break;
        case FontRenderOps.QUADRATIC_CURVE_TO:
          {
            const [Ke, $e, Je, Ze] = Ue.slice(Ge, Ge + 4);
            He.push((nt) => nt.quadraticCurveTo(Ke, $e, Je, Ze)), Ge += 4;
          }
          break;
        case FontRenderOps.RESTORE:
          He.push((Ke) => Ke.restore());
          break;
        case FontRenderOps.SAVE:
          He.push((Ke) => Ke.save());
          break;
        case FontRenderOps.SCALE:
          assert(He.length === 2, "Scale command is only valid at the third position.");
          break;
        case FontRenderOps.TRANSFORM:
          {
            const [Ke, $e, Je, Ze, nt, tt] = Ue.slice(Ge, Ge + 6);
            He.push((et) => et.transform(Ke, $e, Je, Ze, nt, tt)), Ge += 6;
          }
          break;
        case FontRenderOps.TRANSLATE:
          {
            const [Ke, $e] = Ue.slice(Ge, Ge + 2);
            He.push((Je) => Je.translate(Ke, $e)), Ge += 2;
          }
          break;
      }
    return this.compiledGlyphs[Qe] = function(Xe, Ke) {
      He[0](Xe), He[1](Xe), Xe.scale(Ke, -Ke);
      for (let $e = 2, Je = He.length; $e < Je; $e++)
        He[$e](Xe);
    };
  }
}
if (isNodeJS) {
  var packageCapability = Promise.withResolvers(), packageMap = null;
  (async () => {
    const ue = await import(
      /*webpackIgnore: true*/
      "./__vite-browser-external-DYxpcVy9.mjs"
    ), Qe = await import(
      /*webpackIgnore: true*/
      "./__vite-browser-external-DYxpcVy9.mjs"
    ), Ue = await import(
      /*webpackIgnore: true*/
      "./__vite-browser-external-DYxpcVy9.mjs"
    ), He = await import(
      /*webpackIgnore: true*/
      "./__vite-browser-external-DYxpcVy9.mjs"
    );
    let Ge, Xe;
    return new Map(Object.entries({
      fs: ue,
      http: Qe,
      https: Ue,
      url: He,
      canvas: Ge,
      path2d: Xe
    }));
  })().then((ue) => {
    packageMap = ue, packageCapability.resolve();
  }, (ue) => {
    warn(`loadPackages: ${ue}`), packageMap = /* @__PURE__ */ new Map(), packageCapability.resolve();
  });
}
class NodePackages {
  static get promise() {
    return packageCapability.promise;
  }
  static get(ue) {
    return packageMap == null ? void 0 : packageMap.get(ue);
  }
}
const node_utils_fetchData = function(me) {
  return NodePackages.get("fs").promises.readFile(me).then((Qe) => new Uint8Array(Qe));
};
class NodeFilterFactory extends BaseFilterFactory {
}
class NodeCanvasFactory extends BaseCanvasFactory {
  _createCanvas(ue, Qe) {
    return NodePackages.get("canvas").createCanvas(ue, Qe);
  }
}
class NodeCMapReaderFactory extends BaseCMapReaderFactory {
  _fetchData(ue, Qe) {
    return node_utils_fetchData(ue).then((Ue) => ({
      cMapData: Ue,
      compressionType: Qe
    }));
  }
}
class NodeStandardFontDataFactory extends BaseStandardFontDataFactory {
  _fetchData(ue) {
    return node_utils_fetchData(ue);
  }
}
const PathType = {
  FILL: "Fill",
  STROKE: "Stroke",
  SHADING: "Shading"
};
function applyBoundingBox(me, ue) {
  if (!ue)
    return;
  const Qe = ue[2] - ue[0], Ue = ue[3] - ue[1], He = new Path2D();
  He.rect(ue[0], ue[1], Qe, Ue), me.clip(He);
}
class BaseShadingPattern {
  constructor() {
    this.constructor === BaseShadingPattern && unreachable("Cannot initialize BaseShadingPattern.");
  }
  getPattern() {
    unreachable("Abstract method `getPattern` called.");
  }
}
class RadialAxialShadingPattern extends BaseShadingPattern {
  constructor(ue) {
    super(), this._type = ue[1], this._bbox = ue[2], this._colorStops = ue[3], this._p0 = ue[4], this._p1 = ue[5], this._r0 = ue[6], this._r1 = ue[7], this.matrix = null;
  }
  _createGradient(ue) {
    let Qe;
    this._type === "axial" ? Qe = ue.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]) : this._type === "radial" && (Qe = ue.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1));
    for (const Ue of this._colorStops)
      Qe.addColorStop(Ue[0], Ue[1]);
    return Qe;
  }
  getPattern(ue, Qe, Ue, He) {
    let Ge;
    if (He === PathType.STROKE || He === PathType.FILL) {
      const Xe = Qe.current.getClippedPathBoundingBox(He, getCurrentTransform(ue)) || [0, 0, 0, 0], Ke = Math.ceil(Xe[2] - Xe[0]) || 1, $e = Math.ceil(Xe[3] - Xe[1]) || 1, Je = Qe.cachedCanvases.getCanvas("pattern", Ke, $e, !0), Ze = Je.context;
      Ze.clearRect(0, 0, Ze.canvas.width, Ze.canvas.height), Ze.beginPath(), Ze.rect(0, 0, Ze.canvas.width, Ze.canvas.height), Ze.translate(-Xe[0], -Xe[1]), Ue = Util.transform(Ue, [1, 0, 0, 1, Xe[0], Xe[1]]), Ze.transform(...Qe.baseTransform), this.matrix && Ze.transform(...this.matrix), applyBoundingBox(Ze, this._bbox), Ze.fillStyle = this._createGradient(Ze), Ze.fill(), Ge = ue.createPattern(Je.canvas, "no-repeat");
      const nt = new DOMMatrix(Ue);
      Ge.setTransform(nt);
    } else
      applyBoundingBox(ue, this._bbox), Ge = this._createGradient(ue);
    return Ge;
  }
}
function drawTriangle(me, ue, Qe, Ue, He, Ge, Xe, Ke) {
  const $e = ue.coords, Je = ue.colors, Ze = me.data, nt = me.width * 4;
  let tt;
  $e[Qe + 1] > $e[Ue + 1] && (tt = Qe, Qe = Ue, Ue = tt, tt = Ge, Ge = Xe, Xe = tt), $e[Ue + 1] > $e[He + 1] && (tt = Ue, Ue = He, He = tt, tt = Xe, Xe = Ke, Ke = tt), $e[Qe + 1] > $e[Ue + 1] && (tt = Qe, Qe = Ue, Ue = tt, tt = Ge, Ge = Xe, Xe = tt);
  const et = ($e[Qe] + ue.offsetX) * ue.scaleX, rt = ($e[Qe + 1] + ue.offsetY) * ue.scaleY, it = ($e[Ue] + ue.offsetX) * ue.scaleX, ot = ($e[Ue + 1] + ue.offsetY) * ue.scaleY, at = ($e[He] + ue.offsetX) * ue.scaleX, st = ($e[He + 1] + ue.offsetY) * ue.scaleY;
  if (rt >= st)
    return;
  const ut = Je[Ge], lt = Je[Ge + 1], dt = Je[Ge + 2], At = Je[Xe], pt = Je[Xe + 1], gt = Je[Xe + 2], wt = Je[Ke], Bt = Je[Ke + 1], Tt = Je[Ke + 2], yt = Math.round(rt), Ct = Math.round(st);
  let ht, It, vt, Et, bt, Rt, St, kt;
  for (let jt = yt; jt <= Ct; jt++) {
    if (jt < ot) {
      const Yt = jt < rt ? 0 : (rt - jt) / (rt - ot);
      ht = et - (et - it) * Yt, It = ut - (ut - At) * Yt, vt = lt - (lt - pt) * Yt, Et = dt - (dt - gt) * Yt;
    } else {
      let Yt;
      jt > st ? Yt = 1 : ot === st ? Yt = 0 : Yt = (ot - jt) / (ot - st), ht = it - (it - at) * Yt, It = At - (At - wt) * Yt, vt = pt - (pt - Bt) * Yt, Et = gt - (gt - Tt) * Yt;
    }
    let Pt;
    jt < rt ? Pt = 0 : jt > st ? Pt = 1 : Pt = (rt - jt) / (rt - st), bt = et - (et - at) * Pt, Rt = ut - (ut - wt) * Pt, St = lt - (lt - Bt) * Pt, kt = dt - (dt - Tt) * Pt;
    const Qt = Math.round(Math.min(ht, bt)), qt = Math.round(Math.max(ht, bt));
    let _t = nt * jt + Qt * 4;
    for (let Yt = Qt; Yt <= qt; Yt++)
      Pt = (ht - Yt) / (ht - bt), Pt < 0 ? Pt = 0 : Pt > 1 && (Pt = 1), Ze[_t++] = It - (It - Rt) * Pt | 0, Ze[_t++] = vt - (vt - St) * Pt | 0, Ze[_t++] = Et - (Et - kt) * Pt | 0, Ze[_t++] = 255;
  }
}
function drawFigure(me, ue, Qe) {
  const Ue = ue.coords, He = ue.colors;
  let Ge, Xe;
  switch (ue.type) {
    case "lattice":
      const Ke = ue.verticesPerRow, $e = Math.floor(Ue.length / Ke) - 1, Je = Ke - 1;
      for (Ge = 0; Ge < $e; Ge++) {
        let Ze = Ge * Ke;
        for (let nt = 0; nt < Je; nt++, Ze++)
          drawTriangle(me, Qe, Ue[Ze], Ue[Ze + 1], Ue[Ze + Ke], He[Ze], He[Ze + 1], He[Ze + Ke]), drawTriangle(me, Qe, Ue[Ze + Ke + 1], Ue[Ze + 1], Ue[Ze + Ke], He[Ze + Ke + 1], He[Ze + 1], He[Ze + Ke]);
      }
      break;
    case "triangles":
      for (Ge = 0, Xe = Ue.length; Ge < Xe; Ge += 3)
        drawTriangle(me, Qe, Ue[Ge], Ue[Ge + 1], Ue[Ge + 2], He[Ge], He[Ge + 1], He[Ge + 2]);
      break;
    default:
      throw new Error("illegal figure");
  }
}
class MeshShadingPattern extends BaseShadingPattern {
  constructor(ue) {
    super(), this._coords = ue[2], this._colors = ue[3], this._figures = ue[4], this._bounds = ue[5], this._bbox = ue[7], this._background = ue[8], this.matrix = null;
  }
  _createMeshCanvas(ue, Qe, Ue) {
    const Ke = Math.floor(this._bounds[0]), $e = Math.floor(this._bounds[1]), Je = Math.ceil(this._bounds[2]) - Ke, Ze = Math.ceil(this._bounds[3]) - $e, nt = Math.min(Math.ceil(Math.abs(Je * ue[0] * 1.1)), 3e3), tt = Math.min(Math.ceil(Math.abs(Ze * ue[1] * 1.1)), 3e3), et = Je / nt, rt = Ze / tt, it = {
      coords: this._coords,
      colors: this._colors,
      offsetX: -Ke,
      offsetY: -$e,
      scaleX: 1 / et,
      scaleY: 1 / rt
    }, ot = nt + 2 * 2, at = tt + 2 * 2, st = Ue.getCanvas("mesh", ot, at, !1), ut = st.context, lt = ut.createImageData(nt, tt);
    if (Qe) {
      const At = lt.data;
      for (let pt = 0, gt = At.length; pt < gt; pt += 4)
        At[pt] = Qe[0], At[pt + 1] = Qe[1], At[pt + 2] = Qe[2], At[pt + 3] = 255;
    }
    for (const At of this._figures)
      drawFigure(lt, At, it);
    return ut.putImageData(lt, 2, 2), {
      canvas: st.canvas,
      offsetX: Ke - 2 * et,
      offsetY: $e - 2 * rt,
      scaleX: et,
      scaleY: rt
    };
  }
  getPattern(ue, Qe, Ue, He) {
    applyBoundingBox(ue, this._bbox);
    let Ge;
    if (He === PathType.SHADING)
      Ge = Util.singularValueDecompose2dScale(getCurrentTransform(ue));
    else if (Ge = Util.singularValueDecompose2dScale(Qe.baseTransform), this.matrix) {
      const Ke = Util.singularValueDecompose2dScale(this.matrix);
      Ge = [Ge[0] * Ke[0], Ge[1] * Ke[1]];
    }
    const Xe = this._createMeshCanvas(Ge, He === PathType.SHADING ? null : this._background, Qe.cachedCanvases);
    return He !== PathType.SHADING && (ue.setTransform(...Qe.baseTransform), this.matrix && ue.transform(...this.matrix)), ue.translate(Xe.offsetX, Xe.offsetY), ue.scale(Xe.scaleX, Xe.scaleY), ue.createPattern(Xe.canvas, "no-repeat");
  }
}
class DummyShadingPattern extends BaseShadingPattern {
  getPattern() {
    return "hotpink";
  }
}
function getShadingPattern(me) {
  switch (me[0]) {
    case "RadialAxial":
      return new RadialAxialShadingPattern(me);
    case "Mesh":
      return new MeshShadingPattern(me);
    case "Dummy":
      return new DummyShadingPattern();
  }
  throw new Error(`Unknown IR type: ${me[0]}`);
}
const PaintType = {
  COLORED: 1,
  UNCOLORED: 2
}, J2 = class J2 {
  constructor(ue, Qe, Ue, He, Ge) {
    this.operatorList = ue[2], this.matrix = ue[3], this.bbox = ue[4], this.xstep = ue[5], this.ystep = ue[6], this.paintType = ue[7], this.tilingType = ue[8], this.color = Qe, this.ctx = Ue, this.canvasGraphicsFactory = He, this.baseTransform = Ge;
  }
  createPatternCanvas(ue) {
    const Qe = this.operatorList, Ue = this.bbox, He = this.xstep, Ge = this.ystep, Xe = this.paintType, Ke = this.tilingType, $e = this.color, Je = this.canvasGraphicsFactory;
    info("TilingType: " + Ke);
    const Ze = Ue[0], nt = Ue[1], tt = Ue[2], et = Ue[3], rt = Util.singularValueDecompose2dScale(this.matrix), it = Util.singularValueDecompose2dScale(this.baseTransform), ot = [rt[0] * it[0], rt[1] * it[1]], at = this.getSizeAndScale(He, this.ctx.canvas.width, ot[0]), st = this.getSizeAndScale(Ge, this.ctx.canvas.height, ot[1]), ut = ue.cachedCanvases.getCanvas("pattern", at.size, st.size, !0), lt = ut.context, dt = Je.createCanvasGraphics(lt);
    dt.groupLevel = ue.groupLevel, this.setFillAndStrokeStyleToContext(dt, Xe, $e);
    let At = Ze, pt = nt, gt = tt, wt = et;
    return Ze < 0 && (At = 0, gt += Math.abs(Ze)), nt < 0 && (pt = 0, wt += Math.abs(nt)), lt.translate(-(at.scale * At), -(st.scale * pt)), dt.transform(at.scale, 0, 0, st.scale, 0, 0), lt.save(), this.clipBbox(dt, At, pt, gt, wt), dt.baseTransform = getCurrentTransform(dt.ctx), dt.executeOperatorList(Qe), dt.endDrawing(), {
      canvas: ut.canvas,
      scaleX: at.scale,
      scaleY: st.scale,
      offsetX: At,
      offsetY: pt
    };
  }
  getSizeAndScale(ue, Qe, Ue) {
    ue = Math.abs(ue);
    const He = Math.max(J2.MAX_PATTERN_SIZE, Qe);
    let Ge = Math.ceil(ue * Ue);
    return Ge >= He ? Ge = He : Ue = Ge / ue, {
      scale: Ue,
      size: Ge
    };
  }
  clipBbox(ue, Qe, Ue, He, Ge) {
    const Xe = He - Qe, Ke = Ge - Ue;
    ue.ctx.rect(Qe, Ue, Xe, Ke), ue.current.updateRectMinMax(getCurrentTransform(ue.ctx), [Qe, Ue, He, Ge]), ue.clip(), ue.endPath();
  }
  setFillAndStrokeStyleToContext(ue, Qe, Ue) {
    const He = ue.ctx, Ge = ue.current;
    switch (Qe) {
      case PaintType.COLORED:
        const Xe = this.ctx;
        He.fillStyle = Xe.fillStyle, He.strokeStyle = Xe.strokeStyle, Ge.fillColor = Xe.fillStyle, Ge.strokeColor = Xe.strokeStyle;
        break;
      case PaintType.UNCOLORED:
        const Ke = Util.makeHexColor(Ue[0], Ue[1], Ue[2]);
        He.fillStyle = Ke, He.strokeStyle = Ke, Ge.fillColor = Ke, Ge.strokeColor = Ke;
        break;
      default:
        throw new FormatError(`Unsupported paint type: ${Qe}`);
    }
  }
  getPattern(ue, Qe, Ue, He) {
    let Ge = Ue;
    He !== PathType.SHADING && (Ge = Util.transform(Ge, Qe.baseTransform), this.matrix && (Ge = Util.transform(Ge, this.matrix)));
    const Xe = this.createPatternCanvas(Qe);
    let Ke = new DOMMatrix(Ge);
    Ke = Ke.translate(Xe.offsetX, Xe.offsetY), Ke = Ke.scale(1 / Xe.scaleX, 1 / Xe.scaleY);
    const $e = ue.createPattern(Xe.canvas, "repeat");
    return $e.setTransform(Ke), $e;
  }
};
$n(J2, "MAX_PATTERN_SIZE", 3e3);
let TilingPattern = J2;
function convertBlackAndWhiteToRGBA({
  src: me,
  srcPos: ue = 0,
  dest: Qe,
  width: Ue,
  height: He,
  nonBlackColor: Ge = 4294967295,
  inverseDecode: Xe = !1
}) {
  const Ke = util_FeatureTest.isLittleEndian ? 4278190080 : 255, [$e, Je] = Xe ? [Ge, Ke] : [Ke, Ge], Ze = Ue >> 3, nt = Ue & 7, tt = me.length;
  Qe = new Uint32Array(Qe.buffer);
  let et = 0;
  for (let rt = 0; rt < He; rt++) {
    for (const ot = ue + Ze; ue < ot; ue++) {
      const at = ue < tt ? me[ue] : 255;
      Qe[et++] = at & 128 ? Je : $e, Qe[et++] = at & 64 ? Je : $e, Qe[et++] = at & 32 ? Je : $e, Qe[et++] = at & 16 ? Je : $e, Qe[et++] = at & 8 ? Je : $e, Qe[et++] = at & 4 ? Je : $e, Qe[et++] = at & 2 ? Je : $e, Qe[et++] = at & 1 ? Je : $e;
    }
    if (nt === 0)
      continue;
    const it = ue < tt ? me[ue++] : 255;
    for (let ot = 0; ot < nt; ot++)
      Qe[et++] = it & 1 << 7 - ot ? Je : $e;
  }
  return {
    srcPos: ue,
    destPos: et
  };
}
const MIN_FONT_SIZE = 16, MAX_FONT_SIZE = 100, EXECUTION_TIME = 15, EXECUTION_STEPS = 10, MAX_SIZE_TO_COMPILE = 1e3, FULL_CHUNK_HEIGHT = 16;
function mirrorContextOperations(me, ue) {
  if (me._removeMirroring)
    throw new Error("Context is already forwarding operations.");
  me.__originalSave = me.save, me.__originalRestore = me.restore, me.__originalRotate = me.rotate, me.__originalScale = me.scale, me.__originalTranslate = me.translate, me.__originalTransform = me.transform, me.__originalSetTransform = me.setTransform, me.__originalResetTransform = me.resetTransform, me.__originalClip = me.clip, me.__originalMoveTo = me.moveTo, me.__originalLineTo = me.lineTo, me.__originalBezierCurveTo = me.bezierCurveTo, me.__originalRect = me.rect, me.__originalClosePath = me.closePath, me.__originalBeginPath = me.beginPath, me._removeMirroring = () => {
    me.save = me.__originalSave, me.restore = me.__originalRestore, me.rotate = me.__originalRotate, me.scale = me.__originalScale, me.translate = me.__originalTranslate, me.transform = me.__originalTransform, me.setTransform = me.__originalSetTransform, me.resetTransform = me.__originalResetTransform, me.clip = me.__originalClip, me.moveTo = me.__originalMoveTo, me.lineTo = me.__originalLineTo, me.bezierCurveTo = me.__originalBezierCurveTo, me.rect = me.__originalRect, me.closePath = me.__originalClosePath, me.beginPath = me.__originalBeginPath, delete me._removeMirroring;
  }, me.save = function() {
    ue.save(), this.__originalSave();
  }, me.restore = function() {
    ue.restore(), this.__originalRestore();
  }, me.translate = function(Ue, He) {
    ue.translate(Ue, He), this.__originalTranslate(Ue, He);
  }, me.scale = function(Ue, He) {
    ue.scale(Ue, He), this.__originalScale(Ue, He);
  }, me.transform = function(Ue, He, Ge, Xe, Ke, $e) {
    ue.transform(Ue, He, Ge, Xe, Ke, $e), this.__originalTransform(Ue, He, Ge, Xe, Ke, $e);
  }, me.setTransform = function(Ue, He, Ge, Xe, Ke, $e) {
    ue.setTransform(Ue, He, Ge, Xe, Ke, $e), this.__originalSetTransform(Ue, He, Ge, Xe, Ke, $e);
  }, me.resetTransform = function() {
    ue.resetTransform(), this.__originalResetTransform();
  }, me.rotate = function(Ue) {
    ue.rotate(Ue), this.__originalRotate(Ue);
  }, me.clip = function(Ue) {
    ue.clip(Ue), this.__originalClip(Ue);
  }, me.moveTo = function(Qe, Ue) {
    ue.moveTo(Qe, Ue), this.__originalMoveTo(Qe, Ue);
  }, me.lineTo = function(Qe, Ue) {
    ue.lineTo(Qe, Ue), this.__originalLineTo(Qe, Ue);
  }, me.bezierCurveTo = function(Qe, Ue, He, Ge, Xe, Ke) {
    ue.bezierCurveTo(Qe, Ue, He, Ge, Xe, Ke), this.__originalBezierCurveTo(Qe, Ue, He, Ge, Xe, Ke);
  }, me.rect = function(Qe, Ue, He, Ge) {
    ue.rect(Qe, Ue, He, Ge), this.__originalRect(Qe, Ue, He, Ge);
  }, me.closePath = function() {
    ue.closePath(), this.__originalClosePath();
  }, me.beginPath = function() {
    ue.beginPath(), this.__originalBeginPath();
  };
}
class CachedCanvases {
  constructor(ue) {
    this.canvasFactory = ue, this.cache = /* @__PURE__ */ Object.create(null);
  }
  getCanvas(ue, Qe, Ue) {
    let He;
    return this.cache[ue] !== void 0 ? (He = this.cache[ue], this.canvasFactory.reset(He, Qe, Ue)) : (He = this.canvasFactory.create(Qe, Ue), this.cache[ue] = He), He;
  }
  delete(ue) {
    delete this.cache[ue];
  }
  clear() {
    for (const ue in this.cache) {
      const Qe = this.cache[ue];
      this.canvasFactory.destroy(Qe), delete this.cache[ue];
    }
  }
}
function drawImageAtIntegerCoords(me, ue, Qe, Ue, He, Ge, Xe, Ke, $e, Je) {
  const [Ze, nt, tt, et, rt, it] = getCurrentTransform(me);
  if (nt === 0 && tt === 0) {
    const st = Xe * Ze + rt, ut = Math.round(st), lt = Ke * et + it, dt = Math.round(lt), At = (Xe + $e) * Ze + rt, pt = Math.abs(Math.round(At) - ut) || 1, gt = (Ke + Je) * et + it, wt = Math.abs(Math.round(gt) - dt) || 1;
    return me.setTransform(Math.sign(Ze), 0, 0, Math.sign(et), ut, dt), me.drawImage(ue, Qe, Ue, He, Ge, 0, 0, pt, wt), me.setTransform(Ze, nt, tt, et, rt, it), [pt, wt];
  }
  if (Ze === 0 && et === 0) {
    const st = Ke * tt + rt, ut = Math.round(st), lt = Xe * nt + it, dt = Math.round(lt), At = (Ke + Je) * tt + rt, pt = Math.abs(Math.round(At) - ut) || 1, gt = (Xe + $e) * nt + it, wt = Math.abs(Math.round(gt) - dt) || 1;
    return me.setTransform(0, Math.sign(nt), Math.sign(tt), 0, ut, dt), me.drawImage(ue, Qe, Ue, He, Ge, 0, 0, wt, pt), me.setTransform(Ze, nt, tt, et, rt, it), [wt, pt];
  }
  me.drawImage(ue, Qe, Ue, He, Ge, Xe, Ke, $e, Je);
  const ot = Math.hypot(Ze, nt), at = Math.hypot(tt, et);
  return [ot * $e, at * Je];
}
function compileType3Glyph(me) {
  const {
    width: ue,
    height: Qe
  } = me;
  if (ue > MAX_SIZE_TO_COMPILE || Qe > MAX_SIZE_TO_COMPILE)
    return null;
  const Ue = 1e3, He = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]), Ge = ue + 1;
  let Xe = new Uint8Array(Ge * (Qe + 1)), Ke, $e, Je;
  const Ze = ue + 7 & -8;
  let nt = new Uint8Array(Ze * Qe), tt = 0;
  for (const at of me.data) {
    let st = 128;
    for (; st > 0; )
      nt[tt++] = at & st ? 0 : 255, st >>= 1;
  }
  let et = 0;
  for (tt = 0, nt[tt] !== 0 && (Xe[0] = 1, ++et), $e = 1; $e < ue; $e++)
    nt[tt] !== nt[tt + 1] && (Xe[$e] = nt[tt] ? 2 : 1, ++et), tt++;
  for (nt[tt] !== 0 && (Xe[$e] = 2, ++et), Ke = 1; Ke < Qe; Ke++) {
    tt = Ke * Ze, Je = Ke * Ge, nt[tt - Ze] !== nt[tt] && (Xe[Je] = nt[tt] ? 1 : 8, ++et);
    let at = (nt[tt] ? 4 : 0) + (nt[tt - Ze] ? 8 : 0);
    for ($e = 1; $e < ue; $e++)
      at = (at >> 2) + (nt[tt + 1] ? 4 : 0) + (nt[tt - Ze + 1] ? 8 : 0), He[at] && (Xe[Je + $e] = He[at], ++et), tt++;
    if (nt[tt - Ze] !== nt[tt] && (Xe[Je + $e] = nt[tt] ? 2 : 4, ++et), et > Ue)
      return null;
  }
  for (tt = Ze * (Qe - 1), Je = Ke * Ge, nt[tt] !== 0 && (Xe[Je] = 8, ++et), $e = 1; $e < ue; $e++)
    nt[tt] !== nt[tt + 1] && (Xe[Je + $e] = nt[tt] ? 4 : 8, ++et), tt++;
  if (nt[tt] !== 0 && (Xe[Je + $e] = 4, ++et), et > Ue)
    return null;
  const rt = new Int32Array([0, Ge, -1, 0, -Ge, 0, 0, 0, 1]), it = new Path2D();
  for (Ke = 0; et && Ke <= Qe; Ke++) {
    let at = Ke * Ge;
    const st = at + ue;
    for (; at < st && !Xe[at]; )
      at++;
    if (at === st)
      continue;
    it.moveTo(at % Ge, Ke);
    const ut = at;
    let lt = Xe[at];
    do {
      const dt = rt[lt];
      do
        at += dt;
      while (!Xe[at]);
      const At = Xe[at];
      At !== 5 && At !== 10 ? (lt = At, Xe[at] = 0) : (lt = At & 51 * lt >> 4, Xe[at] &= lt >> 2 | lt << 2), it.lineTo(at % Ge, at / Ge | 0), Xe[at] || --et;
    } while (ut !== at);
    --Ke;
  }
  return nt = null, Xe = null, function(at) {
    at.save(), at.scale(1 / ue, -1 / Qe), at.translate(0, -Qe), at.fill(it), at.beginPath(), at.restore();
  };
}
class CanvasExtraState {
  constructor(ue, Qe) {
    this.alphaIsShape = !1, this.fontSize = 0, this.fontSizeScale = 1, this.textMatrix = IDENTITY_MATRIX, this.textMatrixScale = 1, this.fontMatrix = FONT_IDENTITY_MATRIX, this.leading = 0, this.x = 0, this.y = 0, this.lineX = 0, this.lineY = 0, this.charSpacing = 0, this.wordSpacing = 0, this.textHScale = 1, this.textRenderingMode = TextRenderingMode.FILL, this.textRise = 0, this.fillColor = "#000000", this.strokeColor = "#000000", this.patternFill = !1, this.fillAlpha = 1, this.strokeAlpha = 1, this.lineWidth = 1, this.activeSMask = null, this.transferMaps = "none", this.startNewPathAndClipBox([0, 0, ue, Qe]);
  }
  clone() {
    const ue = Object.create(this);
    return ue.clipBox = this.clipBox.slice(), ue;
  }
  setCurrentPoint(ue, Qe) {
    this.x = ue, this.y = Qe;
  }
  updatePathMinMax(ue, Qe, Ue) {
    [Qe, Ue] = Util.applyTransform([Qe, Ue], ue), this.minX = Math.min(this.minX, Qe), this.minY = Math.min(this.minY, Ue), this.maxX = Math.max(this.maxX, Qe), this.maxY = Math.max(this.maxY, Ue);
  }
  updateRectMinMax(ue, Qe) {
    const Ue = Util.applyTransform(Qe, ue), He = Util.applyTransform(Qe.slice(2), ue), Ge = Util.applyTransform([Qe[0], Qe[3]], ue), Xe = Util.applyTransform([Qe[2], Qe[1]], ue);
    this.minX = Math.min(this.minX, Ue[0], He[0], Ge[0], Xe[0]), this.minY = Math.min(this.minY, Ue[1], He[1], Ge[1], Xe[1]), this.maxX = Math.max(this.maxX, Ue[0], He[0], Ge[0], Xe[0]), this.maxY = Math.max(this.maxY, Ue[1], He[1], Ge[1], Xe[1]);
  }
  updateScalingPathMinMax(ue, Qe) {
    Util.scaleMinMax(ue, Qe), this.minX = Math.min(this.minX, Qe[0]), this.minY = Math.min(this.minY, Qe[1]), this.maxX = Math.max(this.maxX, Qe[2]), this.maxY = Math.max(this.maxY, Qe[3]);
  }
  updateCurvePathMinMax(ue, Qe, Ue, He, Ge, Xe, Ke, $e, Je, Ze) {
    const nt = Util.bezierBoundingBox(Qe, Ue, He, Ge, Xe, Ke, $e, Je, Ze);
    Ze || this.updateRectMinMax(ue, nt);
  }
  getPathBoundingBox(ue = PathType.FILL, Qe = null) {
    const Ue = [this.minX, this.minY, this.maxX, this.maxY];
    if (ue === PathType.STROKE) {
      Qe || unreachable("Stroke bounding box must include transform.");
      const He = Util.singularValueDecompose2dScale(Qe), Ge = He[0] * this.lineWidth / 2, Xe = He[1] * this.lineWidth / 2;
      Ue[0] -= Ge, Ue[1] -= Xe, Ue[2] += Ge, Ue[3] += Xe;
    }
    return Ue;
  }
  updateClipFromPath() {
    const ue = Util.intersect(this.clipBox, this.getPathBoundingBox());
    this.startNewPathAndClipBox(ue || [0, 0, 0, 0]);
  }
  isEmptyClip() {
    return this.minX === 1 / 0;
  }
  startNewPathAndClipBox(ue) {
    this.clipBox = ue, this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = 0, this.maxY = 0;
  }
  getClippedPathBoundingBox(ue = PathType.FILL, Qe = null) {
    return Util.intersect(this.clipBox, this.getPathBoundingBox(ue, Qe));
  }
}
function putBinaryImageData(me, ue) {
  if (typeof ImageData < "u" && ue instanceof ImageData) {
    me.putImageData(ue, 0, 0);
    return;
  }
  const Qe = ue.height, Ue = ue.width, He = Qe % FULL_CHUNK_HEIGHT, Ge = (Qe - He) / FULL_CHUNK_HEIGHT, Xe = He === 0 ? Ge : Ge + 1, Ke = me.createImageData(Ue, FULL_CHUNK_HEIGHT);
  let $e = 0, Je;
  const Ze = ue.data, nt = Ke.data;
  let tt, et, rt, it;
  if (ue.kind === util_ImageKind.GRAYSCALE_1BPP) {
    const ot = Ze.byteLength, at = new Uint32Array(nt.buffer, 0, nt.byteLength >> 2), st = at.length, ut = Ue + 7 >> 3, lt = 4294967295, dt = util_FeatureTest.isLittleEndian ? 4278190080 : 255;
    for (tt = 0; tt < Xe; tt++) {
      for (rt = tt < Ge ? FULL_CHUNK_HEIGHT : He, Je = 0, et = 0; et < rt; et++) {
        const At = ot - $e;
        let pt = 0;
        const gt = At > ut ? Ue : At * 8 - 7, wt = gt & -8;
        let Bt = 0, Tt = 0;
        for (; pt < wt; pt += 8)
          Tt = Ze[$e++], at[Je++] = Tt & 128 ? lt : dt, at[Je++] = Tt & 64 ? lt : dt, at[Je++] = Tt & 32 ? lt : dt, at[Je++] = Tt & 16 ? lt : dt, at[Je++] = Tt & 8 ? lt : dt, at[Je++] = Tt & 4 ? lt : dt, at[Je++] = Tt & 2 ? lt : dt, at[Je++] = Tt & 1 ? lt : dt;
        for (; pt < gt; pt++)
          Bt === 0 && (Tt = Ze[$e++], Bt = 128), at[Je++] = Tt & Bt ? lt : dt, Bt >>= 1;
      }
      for (; Je < st; )
        at[Je++] = 0;
      me.putImageData(Ke, 0, tt * FULL_CHUNK_HEIGHT);
    }
  } else if (ue.kind === util_ImageKind.RGBA_32BPP) {
    for (et = 0, it = Ue * FULL_CHUNK_HEIGHT * 4, tt = 0; tt < Ge; tt++)
      nt.set(Ze.subarray($e, $e + it)), $e += it, me.putImageData(Ke, 0, et), et += FULL_CHUNK_HEIGHT;
    tt < Xe && (it = Ue * He * 4, nt.set(Ze.subarray($e, $e + it)), me.putImageData(Ke, 0, et));
  } else if (ue.kind === util_ImageKind.RGB_24BPP)
    for (rt = FULL_CHUNK_HEIGHT, it = Ue * rt, tt = 0; tt < Xe; tt++) {
      for (tt >= Ge && (rt = He, it = Ue * rt), Je = 0, et = it; et--; )
        nt[Je++] = Ze[$e++], nt[Je++] = Ze[$e++], nt[Je++] = Ze[$e++], nt[Je++] = 255;
      me.putImageData(Ke, 0, tt * FULL_CHUNK_HEIGHT);
    }
  else
    throw new Error(`bad image kind: ${ue.kind}`);
}
function putBinaryImageMask(me, ue) {
  if (ue.bitmap) {
    me.drawImage(ue.bitmap, 0, 0);
    return;
  }
  const Qe = ue.height, Ue = ue.width, He = Qe % FULL_CHUNK_HEIGHT, Ge = (Qe - He) / FULL_CHUNK_HEIGHT, Xe = He === 0 ? Ge : Ge + 1, Ke = me.createImageData(Ue, FULL_CHUNK_HEIGHT);
  let $e = 0;
  const Je = ue.data, Ze = Ke.data;
  for (let nt = 0; nt < Xe; nt++) {
    const tt = nt < Ge ? FULL_CHUNK_HEIGHT : He;
    ({
      srcPos: $e
    } = convertBlackAndWhiteToRGBA({
      src: Je,
      srcPos: $e,
      dest: Ze,
      width: Ue,
      height: tt,
      nonBlackColor: 0
    })), me.putImageData(Ke, 0, nt * FULL_CHUNK_HEIGHT);
  }
}
function copyCtxState(me, ue) {
  const Qe = ["strokeStyle", "fillStyle", "fillRule", "globalAlpha", "lineWidth", "lineCap", "lineJoin", "miterLimit", "globalCompositeOperation", "font", "filter"];
  for (const Ue of Qe)
    me[Ue] !== void 0 && (ue[Ue] = me[Ue]);
  me.setLineDash !== void 0 && (ue.setLineDash(me.getLineDash()), ue.lineDashOffset = me.lineDashOffset);
}
function resetCtxToDefault(me) {
  if (me.strokeStyle = me.fillStyle = "#000000", me.fillRule = "nonzero", me.globalAlpha = 1, me.lineWidth = 1, me.lineCap = "butt", me.lineJoin = "miter", me.miterLimit = 10, me.globalCompositeOperation = "source-over", me.font = "10px sans-serif", me.setLineDash !== void 0 && (me.setLineDash([]), me.lineDashOffset = 0), !isNodeJS) {
    const {
      filter: ue
    } = me;
    ue !== "none" && ue !== "" && (me.filter = "none");
  }
}
function getImageSmoothingEnabled(me, ue) {
  if (ue)
    return !0;
  const Qe = Util.singularValueDecompose2dScale(me);
  Qe[0] = Math.fround(Qe[0]), Qe[1] = Math.fround(Qe[1]);
  const Ue = Math.fround((globalThis.devicePixelRatio || 1) * PixelsPerInch.PDF_TO_CSS_UNITS);
  return Qe[0] <= Ue && Qe[1] <= Ue;
}
const LINE_CAP_STYLES = ["butt", "round", "square"], LINE_JOIN_STYLES = ["miter", "round", "bevel"], NORMAL_CLIP = {}, EO_CLIP = {};
var ws, Hh, Gh;
const I1 = class I1 {
  constructor(ue, Qe, Ue, He, Ge, {
    optionalContentConfig: Xe,
    markedContentStack: Ke = null
  }, $e, Je) {
    tn(this, ws);
    this.ctx = ue, this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height), this.stateStack = [], this.pendingClip = null, this.pendingEOFill = !1, this.res = null, this.xobjs = null, this.commonObjs = Qe, this.objs = Ue, this.canvasFactory = He, this.filterFactory = Ge, this.groupStack = [], this.processingType3 = null, this.baseTransform = null, this.baseTransformStack = [], this.groupLevel = 0, this.smaskStack = [], this.smaskCounter = 0, this.tempSMask = null, this.suspendedCtx = null, this.contentVisible = !0, this.markedContentStack = Ke || [], this.optionalContentConfig = Xe, this.cachedCanvases = new CachedCanvases(this.canvasFactory), this.cachedPatterns = /* @__PURE__ */ new Map(), this.annotationCanvasMap = $e, this.viewportScale = 1, this.outputScaleX = 1, this.outputScaleY = 1, this.pageColors = Je, this._cachedScaleForStroking = [-1, 0], this._cachedGetSinglePixelWidth = null, this._cachedBitmapsMap = /* @__PURE__ */ new Map();
  }
  getObject(ue, Qe = null) {
    return typeof ue == "string" ? ue.startsWith("g_") ? this.commonObjs.get(ue) : this.objs.get(ue) : Qe;
  }
  beginDrawing({
    transform: ue,
    viewport: Qe,
    transparency: Ue = !1,
    background: He = null
  }) {
    const Ge = this.ctx.canvas.width, Xe = this.ctx.canvas.height, Ke = this.ctx.fillStyle;
    if (this.ctx.fillStyle = He || "#ffffff", this.ctx.fillRect(0, 0, Ge, Xe), this.ctx.fillStyle = Ke, Ue) {
      const $e = this.cachedCanvases.getCanvas("transparent", Ge, Xe);
      this.compositeCtx = this.ctx, this.transparentCanvas = $e.canvas, this.ctx = $e.context, this.ctx.save(), this.ctx.transform(...getCurrentTransform(this.compositeCtx));
    }
    this.ctx.save(), resetCtxToDefault(this.ctx), ue && (this.ctx.transform(...ue), this.outputScaleX = ue[0], this.outputScaleY = ue[0]), this.ctx.transform(...Qe.transform), this.viewportScale = Qe.scale, this.baseTransform = getCurrentTransform(this.ctx);
  }
  executeOperatorList(ue, Qe, Ue, He) {
    const Ge = ue.argsArray, Xe = ue.fnArray;
    let Ke = Qe || 0;
    const $e = Ge.length;
    if ($e === Ke)
      return Ke;
    const Je = $e - Ke > EXECUTION_STEPS && typeof Ue == "function", Ze = Je ? Date.now() + EXECUTION_TIME : 0;
    let nt = 0;
    const tt = this.commonObjs, et = this.objs;
    let rt;
    for (; ; ) {
      if (He !== void 0 && Ke === He.nextBreakPoint)
        return He.breakIt(Ke, Ue), Ke;
      if (rt = Xe[Ke], rt !== OPS.dependency)
        this[rt].apply(this, Ge[Ke]);
      else
        for (const it of Ge[Ke]) {
          const ot = it.startsWith("g_") ? tt : et;
          if (!ot.has(it))
            return ot.get(it, Ue), Ke;
        }
      if (Ke++, Ke === $e)
        return Ke;
      if (Je && ++nt > EXECUTION_STEPS) {
        if (Date.now() > Ze)
          return Ue(), Ke;
        nt = 0;
      }
    }
  }
  endDrawing() {
    en(this, ws, Hh).call(this), this.cachedCanvases.clear(), this.cachedPatterns.clear();
    for (const ue of this._cachedBitmapsMap.values()) {
      for (const Qe of ue.values())
        typeof HTMLCanvasElement < "u" && Qe instanceof HTMLCanvasElement && (Qe.width = Qe.height = 0);
      ue.clear();
    }
    this._cachedBitmapsMap.clear(), en(this, ws, Gh).call(this);
  }
  _scaleImage(ue, Qe) {
    const Ue = ue.width, He = ue.height;
    let Ge = Math.max(Math.hypot(Qe[0], Qe[1]), 1), Xe = Math.max(Math.hypot(Qe[2], Qe[3]), 1), Ke = Ue, $e = He, Je = "prescale1", Ze, nt;
    for (; Ge > 2 && Ke > 1 || Xe > 2 && $e > 1; ) {
      let tt = Ke, et = $e;
      Ge > 2 && Ke > 1 && (tt = Ke >= 16384 ? Math.floor(Ke / 2) - 1 || 1 : Math.ceil(Ke / 2), Ge /= Ke / tt), Xe > 2 && $e > 1 && (et = $e >= 16384 ? Math.floor($e / 2) - 1 || 1 : Math.ceil($e) / 2, Xe /= $e / et), Ze = this.cachedCanvases.getCanvas(Je, tt, et), nt = Ze.context, nt.clearRect(0, 0, tt, et), nt.drawImage(ue, 0, 0, Ke, $e, 0, 0, tt, et), ue = Ze.canvas, Ke = tt, $e = et, Je = Je === "prescale1" ? "prescale2" : "prescale1";
    }
    return {
      img: ue,
      paintWidth: Ke,
      paintHeight: $e
    };
  }
  _createMaskCanvas(ue) {
    const Qe = this.ctx, {
      width: Ue,
      height: He
    } = ue, Ge = this.current.fillColor, Xe = this.current.patternFill, Ke = getCurrentTransform(Qe);
    let $e, Je, Ze, nt;
    if ((ue.bitmap || ue.data) && ue.count > 1) {
      const gt = ue.bitmap || ue.data.buffer;
      Je = JSON.stringify(Xe ? Ke : [Ke.slice(0, 4), Ge]), $e = this._cachedBitmapsMap.get(gt), $e || ($e = /* @__PURE__ */ new Map(), this._cachedBitmapsMap.set(gt, $e));
      const wt = $e.get(Je);
      if (wt && !Xe) {
        const Bt = Math.round(Math.min(Ke[0], Ke[2]) + Ke[4]), Tt = Math.round(Math.min(Ke[1], Ke[3]) + Ke[5]);
        return {
          canvas: wt,
          offsetX: Bt,
          offsetY: Tt
        };
      }
      Ze = wt;
    }
    Ze || (nt = this.cachedCanvases.getCanvas("maskCanvas", Ue, He), putBinaryImageMask(nt.context, ue));
    let tt = Util.transform(Ke, [1 / Ue, 0, 0, -1 / He, 0, 0]);
    tt = Util.transform(tt, [1, 0, 0, 1, 0, -He]);
    const [et, rt, it, ot] = Util.getAxialAlignedBoundingBox([0, 0, Ue, He], tt), at = Math.round(it - et) || 1, st = Math.round(ot - rt) || 1, ut = this.cachedCanvases.getCanvas("fillCanvas", at, st), lt = ut.context, dt = et, At = rt;
    lt.translate(-dt, -At), lt.transform(...tt), Ze || (Ze = this._scaleImage(nt.canvas, getCurrentTransformInverse(lt)), Ze = Ze.img, $e && Xe && $e.set(Je, Ze)), lt.imageSmoothingEnabled = getImageSmoothingEnabled(getCurrentTransform(lt), ue.interpolate), drawImageAtIntegerCoords(lt, Ze, 0, 0, Ze.width, Ze.height, 0, 0, Ue, He), lt.globalCompositeOperation = "source-in";
    const pt = Util.transform(getCurrentTransformInverse(lt), [1, 0, 0, 1, -dt, -At]);
    return lt.fillStyle = Xe ? Ge.getPattern(Qe, this, pt, PathType.FILL) : Ge, lt.fillRect(0, 0, Ue, He), $e && !Xe && (this.cachedCanvases.delete("fillCanvas"), $e.set(Je, ut.canvas)), {
      canvas: ut.canvas,
      offsetX: Math.round(dt),
      offsetY: Math.round(At)
    };
  }
  setLineWidth(ue) {
    ue !== this.current.lineWidth && (this._cachedScaleForStroking[0] = -1), this.current.lineWidth = ue, this.ctx.lineWidth = ue;
  }
  setLineCap(ue) {
    this.ctx.lineCap = LINE_CAP_STYLES[ue];
  }
  setLineJoin(ue) {
    this.ctx.lineJoin = LINE_JOIN_STYLES[ue];
  }
  setMiterLimit(ue) {
    this.ctx.miterLimit = ue;
  }
  setDash(ue, Qe) {
    const Ue = this.ctx;
    Ue.setLineDash !== void 0 && (Ue.setLineDash(ue), Ue.lineDashOffset = Qe);
  }
  setRenderingIntent(ue) {
  }
  setFlatness(ue) {
  }
  setGState(ue) {
    for (const [Qe, Ue] of ue)
      switch (Qe) {
        case "LW":
          this.setLineWidth(Ue);
          break;
        case "LC":
          this.setLineCap(Ue);
          break;
        case "LJ":
          this.setLineJoin(Ue);
          break;
        case "ML":
          this.setMiterLimit(Ue);
          break;
        case "D":
          this.setDash(Ue[0], Ue[1]);
          break;
        case "RI":
          this.setRenderingIntent(Ue);
          break;
        case "FL":
          this.setFlatness(Ue);
          break;
        case "Font":
          this.setFont(Ue[0], Ue[1]);
          break;
        case "CA":
          this.current.strokeAlpha = Ue;
          break;
        case "ca":
          this.current.fillAlpha = Ue, this.ctx.globalAlpha = Ue;
          break;
        case "BM":
          this.ctx.globalCompositeOperation = Ue;
          break;
        case "SMask":
          this.current.activeSMask = Ue ? this.tempSMask : null, this.tempSMask = null, this.checkSMaskState();
          break;
        case "TR":
          this.ctx.filter = this.current.transferMaps = this.filterFactory.addFilter(Ue);
          break;
      }
  }
  get inSMaskMode() {
    return !!this.suspendedCtx;
  }
  checkSMaskState() {
    const ue = this.inSMaskMode;
    this.current.activeSMask && !ue ? this.beginSMaskMode() : !this.current.activeSMask && ue && this.endSMaskMode();
  }
  beginSMaskMode() {
    if (this.inSMaskMode)
      throw new Error("beginSMaskMode called while already in smask mode");
    const ue = this.ctx.canvas.width, Qe = this.ctx.canvas.height, Ue = "smaskGroupAt" + this.groupLevel, He = this.cachedCanvases.getCanvas(Ue, ue, Qe);
    this.suspendedCtx = this.ctx, this.ctx = He.context;
    const Ge = this.ctx;
    Ge.setTransform(...getCurrentTransform(this.suspendedCtx)), copyCtxState(this.suspendedCtx, Ge), mirrorContextOperations(Ge, this.suspendedCtx), this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]);
  }
  endSMaskMode() {
    if (!this.inSMaskMode)
      throw new Error("endSMaskMode called while not in smask mode");
    this.ctx._removeMirroring(), copyCtxState(this.ctx, this.suspendedCtx), this.ctx = this.suspendedCtx, this.suspendedCtx = null;
  }
  compose(ue) {
    if (!this.current.activeSMask)
      return;
    ue ? (ue[0] = Math.floor(ue[0]), ue[1] = Math.floor(ue[1]), ue[2] = Math.ceil(ue[2]), ue[3] = Math.ceil(ue[3])) : ue = [0, 0, this.ctx.canvas.width, this.ctx.canvas.height];
    const Qe = this.current.activeSMask, Ue = this.suspendedCtx;
    this.composeSMask(Ue, Qe, this.ctx, ue), this.ctx.save(), this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height), this.ctx.restore();
  }
  composeSMask(ue, Qe, Ue, He) {
    const Ge = He[0], Xe = He[1], Ke = He[2] - Ge, $e = He[3] - Xe;
    Ke === 0 || $e === 0 || (this.genericComposeSMask(Qe.context, Ue, Ke, $e, Qe.subtype, Qe.backdrop, Qe.transferMap, Ge, Xe, Qe.offsetX, Qe.offsetY), ue.save(), ue.globalAlpha = 1, ue.globalCompositeOperation = "source-over", ue.setTransform(1, 0, 0, 1, 0, 0), ue.drawImage(Ue.canvas, 0, 0), ue.restore());
  }
  genericComposeSMask(ue, Qe, Ue, He, Ge, Xe, Ke, $e, Je, Ze, nt) {
    let tt = ue.canvas, et = $e - Ze, rt = Je - nt;
    if (Xe) {
      if (et < 0 || rt < 0 || et + Ue > tt.width || rt + He > tt.height) {
        const ot = this.cachedCanvases.getCanvas("maskExtension", Ue, He), at = ot.context;
        at.drawImage(tt, -et, -rt), Xe.some((st) => st !== 0) && (at.globalCompositeOperation = "destination-atop", at.fillStyle = Util.makeHexColor(...Xe), at.fillRect(0, 0, Ue, He), at.globalCompositeOperation = "source-over"), tt = ot.canvas, et = rt = 0;
      } else if (Xe.some((ot) => ot !== 0)) {
        ue.save(), ue.globalAlpha = 1, ue.setTransform(1, 0, 0, 1, 0, 0);
        const ot = new Path2D();
        ot.rect(et, rt, Ue, He), ue.clip(ot), ue.globalCompositeOperation = "destination-atop", ue.fillStyle = Util.makeHexColor(...Xe), ue.fillRect(et, rt, Ue, He), ue.restore();
      }
    }
    Qe.save(), Qe.globalAlpha = 1, Qe.setTransform(1, 0, 0, 1, 0, 0), Ge === "Alpha" && Ke ? Qe.filter = this.filterFactory.addAlphaFilter(Ke) : Ge === "Luminosity" && (Qe.filter = this.filterFactory.addLuminosityFilter(Ke));
    const it = new Path2D();
    it.rect($e, Je, Ue, He), Qe.clip(it), Qe.globalCompositeOperation = "destination-in", Qe.drawImage(tt, et, rt, Ue, He, $e, Je, Ue, He), Qe.restore();
  }
  save() {
    this.inSMaskMode ? (copyCtxState(this.ctx, this.suspendedCtx), this.suspendedCtx.save()) : this.ctx.save();
    const ue = this.current;
    this.stateStack.push(ue), this.current = ue.clone();
  }
  restore() {
    this.stateStack.length === 0 && this.inSMaskMode && this.endSMaskMode(), this.stateStack.length !== 0 && (this.current = this.stateStack.pop(), this.inSMaskMode ? (this.suspendedCtx.restore(), copyCtxState(this.suspendedCtx, this.ctx)) : this.ctx.restore(), this.checkSMaskState(), this.pendingClip = null, this._cachedScaleForStroking[0] = -1, this._cachedGetSinglePixelWidth = null);
  }
  transform(ue, Qe, Ue, He, Ge, Xe) {
    this.ctx.transform(ue, Qe, Ue, He, Ge, Xe), this._cachedScaleForStroking[0] = -1, this._cachedGetSinglePixelWidth = null;
  }
  constructPath(ue, Qe, Ue) {
    const He = this.ctx, Ge = this.current;
    let Xe = Ge.x, Ke = Ge.y, $e, Je;
    const Ze = getCurrentTransform(He), nt = Ze[0] === 0 && Ze[3] === 0 || Ze[1] === 0 && Ze[2] === 0, tt = nt ? Ue.slice(0) : null;
    for (let et = 0, rt = 0, it = ue.length; et < it; et++)
      switch (ue[et] | 0) {
        case OPS.rectangle:
          Xe = Qe[rt++], Ke = Qe[rt++];
          const ot = Qe[rt++], at = Qe[rt++], st = Xe + ot, ut = Ke + at;
          He.moveTo(Xe, Ke), ot === 0 || at === 0 ? He.lineTo(st, ut) : (He.lineTo(st, Ke), He.lineTo(st, ut), He.lineTo(Xe, ut)), nt || Ge.updateRectMinMax(Ze, [Xe, Ke, st, ut]), He.closePath();
          break;
        case OPS.moveTo:
          Xe = Qe[rt++], Ke = Qe[rt++], He.moveTo(Xe, Ke), nt || Ge.updatePathMinMax(Ze, Xe, Ke);
          break;
        case OPS.lineTo:
          Xe = Qe[rt++], Ke = Qe[rt++], He.lineTo(Xe, Ke), nt || Ge.updatePathMinMax(Ze, Xe, Ke);
          break;
        case OPS.curveTo:
          $e = Xe, Je = Ke, Xe = Qe[rt + 4], Ke = Qe[rt + 5], He.bezierCurveTo(Qe[rt], Qe[rt + 1], Qe[rt + 2], Qe[rt + 3], Xe, Ke), Ge.updateCurvePathMinMax(Ze, $e, Je, Qe[rt], Qe[rt + 1], Qe[rt + 2], Qe[rt + 3], Xe, Ke, tt), rt += 6;
          break;
        case OPS.curveTo2:
          $e = Xe, Je = Ke, He.bezierCurveTo(Xe, Ke, Qe[rt], Qe[rt + 1], Qe[rt + 2], Qe[rt + 3]), Ge.updateCurvePathMinMax(Ze, $e, Je, Xe, Ke, Qe[rt], Qe[rt + 1], Qe[rt + 2], Qe[rt + 3], tt), Xe = Qe[rt + 2], Ke = Qe[rt + 3], rt += 4;
          break;
        case OPS.curveTo3:
          $e = Xe, Je = Ke, Xe = Qe[rt + 2], Ke = Qe[rt + 3], He.bezierCurveTo(Qe[rt], Qe[rt + 1], Xe, Ke, Xe, Ke), Ge.updateCurvePathMinMax(Ze, $e, Je, Qe[rt], Qe[rt + 1], Xe, Ke, Xe, Ke, tt), rt += 4;
          break;
        case OPS.closePath:
          He.closePath();
          break;
      }
    nt && Ge.updateScalingPathMinMax(Ze, tt), Ge.setCurrentPoint(Xe, Ke);
  }
  closePath() {
    this.ctx.closePath();
  }
  stroke(ue = !0) {
    const Qe = this.ctx, Ue = this.current.strokeColor;
    Qe.globalAlpha = this.current.strokeAlpha, this.contentVisible && (typeof Ue == "object" && (Ue != null && Ue.getPattern) ? (Qe.save(), Qe.strokeStyle = Ue.getPattern(Qe, this, getCurrentTransformInverse(Qe), PathType.STROKE), this.rescaleAndStroke(!1), Qe.restore()) : this.rescaleAndStroke(!0)), ue && this.consumePath(this.current.getClippedPathBoundingBox()), Qe.globalAlpha = this.current.fillAlpha;
  }
  closeStroke() {
    this.closePath(), this.stroke();
  }
  fill(ue = !0) {
    const Qe = this.ctx, Ue = this.current.fillColor, He = this.current.patternFill;
    let Ge = !1;
    He && (Qe.save(), Qe.fillStyle = Ue.getPattern(Qe, this, getCurrentTransformInverse(Qe), PathType.FILL), Ge = !0);
    const Xe = this.current.getClippedPathBoundingBox();
    this.contentVisible && Xe !== null && (this.pendingEOFill ? (Qe.fill("evenodd"), this.pendingEOFill = !1) : Qe.fill()), Ge && Qe.restore(), ue && this.consumePath(Xe);
  }
  eoFill() {
    this.pendingEOFill = !0, this.fill();
  }
  fillStroke() {
    this.fill(!1), this.stroke(!1), this.consumePath();
  }
  eoFillStroke() {
    this.pendingEOFill = !0, this.fillStroke();
  }
  closeFillStroke() {
    this.closePath(), this.fillStroke();
  }
  closeEOFillStroke() {
    this.pendingEOFill = !0, this.closePath(), this.fillStroke();
  }
  endPath() {
    this.consumePath();
  }
  clip() {
    this.pendingClip = NORMAL_CLIP;
  }
  eoClip() {
    this.pendingClip = EO_CLIP;
  }
  beginText() {
    this.current.textMatrix = IDENTITY_MATRIX, this.current.textMatrixScale = 1, this.current.x = this.current.lineX = 0, this.current.y = this.current.lineY = 0;
  }
  endText() {
    const ue = this.pendingTextPaths, Qe = this.ctx;
    if (ue === void 0) {
      Qe.beginPath();
      return;
    }
    Qe.save(), Qe.beginPath();
    for (const Ue of ue)
      Qe.setTransform(...Ue.transform), Qe.translate(Ue.x, Ue.y), Ue.addToPath(Qe, Ue.fontSize);
    Qe.restore(), Qe.clip(), Qe.beginPath(), delete this.pendingTextPaths;
  }
  setCharSpacing(ue) {
    this.current.charSpacing = ue;
  }
  setWordSpacing(ue) {
    this.current.wordSpacing = ue;
  }
  setHScale(ue) {
    this.current.textHScale = ue / 100;
  }
  setLeading(ue) {
    this.current.leading = -ue;
  }
  setFont(ue, Qe) {
    var Ze;
    const Ue = this.commonObjs.get(ue), He = this.current;
    if (!Ue)
      throw new Error(`Can't find font for ${ue}`);
    if (He.fontMatrix = Ue.fontMatrix || FONT_IDENTITY_MATRIX, (He.fontMatrix[0] === 0 || He.fontMatrix[3] === 0) && warn("Invalid font matrix for font " + ue), Qe < 0 ? (Qe = -Qe, He.fontDirection = -1) : He.fontDirection = 1, this.current.font = Ue, this.current.fontSize = Qe, Ue.isType3Font)
      return;
    const Ge = Ue.loadedName || "sans-serif", Xe = ((Ze = Ue.systemFontInfo) == null ? void 0 : Ze.css) || `"${Ge}", ${Ue.fallbackName}`;
    let Ke = "normal";
    Ue.black ? Ke = "900" : Ue.bold && (Ke = "bold");
    const $e = Ue.italic ? "italic" : "normal";
    let Je = Qe;
    Qe < MIN_FONT_SIZE ? Je = MIN_FONT_SIZE : Qe > MAX_FONT_SIZE && (Je = MAX_FONT_SIZE), this.current.fontSizeScale = Qe / Je, this.ctx.font = `${$e} ${Ke} ${Je}px ${Xe}`;
  }
  setTextRenderingMode(ue) {
    this.current.textRenderingMode = ue;
  }
  setTextRise(ue) {
    this.current.textRise = ue;
  }
  moveText(ue, Qe) {
    this.current.x = this.current.lineX += ue, this.current.y = this.current.lineY += Qe;
  }
  setLeadingMoveText(ue, Qe) {
    this.setLeading(-Qe), this.moveText(ue, Qe);
  }
  setTextMatrix(ue, Qe, Ue, He, Ge, Xe) {
    this.current.textMatrix = [ue, Qe, Ue, He, Ge, Xe], this.current.textMatrixScale = Math.hypot(ue, Qe), this.current.x = this.current.lineX = 0, this.current.y = this.current.lineY = 0;
  }
  nextLine() {
    this.moveText(0, this.current.leading);
  }
  paintChar(ue, Qe, Ue, He) {
    const Ge = this.ctx, Xe = this.current, Ke = Xe.font, $e = Xe.textRenderingMode, Je = Xe.fontSize / Xe.fontSizeScale, Ze = $e & TextRenderingMode.FILL_STROKE_MASK, nt = !!($e & TextRenderingMode.ADD_TO_PATH_FLAG), tt = Xe.patternFill && !Ke.missingFile;
    let et;
    (Ke.disableFontFace || nt || tt) && (et = Ke.getPathGenerator(this.commonObjs, ue)), Ke.disableFontFace || tt ? (Ge.save(), Ge.translate(Qe, Ue), Ge.beginPath(), et(Ge, Je), He && Ge.setTransform(...He), (Ze === TextRenderingMode.FILL || Ze === TextRenderingMode.FILL_STROKE) && Ge.fill(), (Ze === TextRenderingMode.STROKE || Ze === TextRenderingMode.FILL_STROKE) && Ge.stroke(), Ge.restore()) : ((Ze === TextRenderingMode.FILL || Ze === TextRenderingMode.FILL_STROKE) && Ge.fillText(ue, Qe, Ue), (Ze === TextRenderingMode.STROKE || Ze === TextRenderingMode.FILL_STROKE) && Ge.strokeText(ue, Qe, Ue)), nt && (this.pendingTextPaths || (this.pendingTextPaths = [])).push({
      transform: getCurrentTransform(Ge),
      x: Qe,
      y: Ue,
      fontSize: Je,
      addToPath: et
    });
  }
  get isFontSubpixelAAEnabled() {
    const {
      context: ue
    } = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10);
    ue.scale(1.5, 1), ue.fillText("I", 0, 10);
    const Qe = ue.getImageData(0, 0, 10, 10).data;
    let Ue = !1;
    for (let He = 3; He < Qe.length; He += 4)
      if (Qe[He] > 0 && Qe[He] < 255) {
        Ue = !0;
        break;
      }
    return shadow(this, "isFontSubpixelAAEnabled", Ue);
  }
  showText(ue) {
    const Qe = this.current, Ue = Qe.font;
    if (Ue.isType3Font)
      return this.showType3Text(ue);
    const He = Qe.fontSize;
    if (He === 0)
      return;
    const Ge = this.ctx, Xe = Qe.fontSizeScale, Ke = Qe.charSpacing, $e = Qe.wordSpacing, Je = Qe.fontDirection, Ze = Qe.textHScale * Je, nt = ue.length, tt = Ue.vertical, et = tt ? 1 : -1, rt = Ue.defaultVMetrics, it = He * Qe.fontMatrix[0], ot = Qe.textRenderingMode === TextRenderingMode.FILL && !Ue.disableFontFace && !Qe.patternFill;
    Ge.save(), Ge.transform(...Qe.textMatrix), Ge.translate(Qe.x, Qe.y + Qe.textRise), Je > 0 ? Ge.scale(Ze, -1) : Ge.scale(Ze, 1);
    let at;
    if (Qe.patternFill) {
      Ge.save();
      const At = Qe.fillColor.getPattern(Ge, this, getCurrentTransformInverse(Ge), PathType.FILL);
      at = getCurrentTransform(Ge), Ge.restore(), Ge.fillStyle = At;
    }
    let st = Qe.lineWidth;
    const ut = Qe.textMatrixScale;
    if (ut === 0 || st === 0) {
      const At = Qe.textRenderingMode & TextRenderingMode.FILL_STROKE_MASK;
      (At === TextRenderingMode.STROKE || At === TextRenderingMode.FILL_STROKE) && (st = this.getSinglePixelWidth());
    } else
      st /= ut;
    if (Xe !== 1 && (Ge.scale(Xe, Xe), st /= Xe), Ge.lineWidth = st, Ue.isInvalidPDFjsFont) {
      const At = [];
      let pt = 0;
      for (const gt of ue)
        At.push(gt.unicode), pt += gt.width;
      Ge.fillText(At.join(""), 0, 0), Qe.x += pt * it * Ze, Ge.restore(), this.compose();
      return;
    }
    let lt = 0, dt;
    for (dt = 0; dt < nt; ++dt) {
      const At = ue[dt];
      if (typeof At == "number") {
        lt += et * At * He / 1e3;
        continue;
      }
      let pt = !1;
      const gt = (At.isSpace ? $e : 0) + Ke, wt = At.fontChar, Bt = At.accent;
      let Tt, yt, Ct = At.width;
      if (tt) {
        const It = At.vmetric || rt, vt = -(At.vmetric ? It[1] : Ct * 0.5) * it, Et = It[2] * it;
        Ct = It ? -It[0] : Ct, Tt = vt / Xe, yt = (lt + Et) / Xe;
      } else
        Tt = lt / Xe, yt = 0;
      if (Ue.remeasure && Ct > 0) {
        const It = Ge.measureText(wt).width * 1e3 / He * Xe;
        if (Ct < It && this.isFontSubpixelAAEnabled) {
          const vt = Ct / It;
          pt = !0, Ge.save(), Ge.scale(vt, 1), Tt /= vt;
        } else Ct !== It && (Tt += (Ct - It) / 2e3 * He / Xe);
      }
      if (this.contentVisible && (At.isInFont || Ue.missingFile)) {
        if (ot && !Bt)
          Ge.fillText(wt, Tt, yt);
        else if (this.paintChar(wt, Tt, yt, at), Bt) {
          const It = Tt + He * Bt.offset.x / Xe, vt = yt - He * Bt.offset.y / Xe;
          this.paintChar(Bt.fontChar, It, vt, at);
        }
      }
      const ht = tt ? Ct * it - gt * Je : Ct * it + gt * Je;
      lt += ht, pt && Ge.restore();
    }
    tt ? Qe.y -= lt : Qe.x += lt * Ze, Ge.restore(), this.compose();
  }
  showType3Text(ue) {
    const Qe = this.ctx, Ue = this.current, He = Ue.font, Ge = Ue.fontSize, Xe = Ue.fontDirection, Ke = He.vertical ? 1 : -1, $e = Ue.charSpacing, Je = Ue.wordSpacing, Ze = Ue.textHScale * Xe, nt = Ue.fontMatrix || FONT_IDENTITY_MATRIX, tt = ue.length, et = Ue.textRenderingMode === TextRenderingMode.INVISIBLE;
    let rt, it, ot, at;
    if (!(et || Ge === 0)) {
      for (this._cachedScaleForStroking[0] = -1, this._cachedGetSinglePixelWidth = null, Qe.save(), Qe.transform(...Ue.textMatrix), Qe.translate(Ue.x, Ue.y), Qe.scale(Ze, Xe), rt = 0; rt < tt; ++rt) {
        if (it = ue[rt], typeof it == "number") {
          at = Ke * it * Ge / 1e3, this.ctx.translate(at, 0), Ue.x += at * Ze;
          continue;
        }
        const st = (it.isSpace ? Je : 0) + $e, ut = He.charProcOperatorList[it.operatorListId];
        if (!ut) {
          warn(`Type3 character "${it.operatorListId}" is not available.`);
          continue;
        }
        this.contentVisible && (this.processingType3 = it, this.save(), Qe.scale(Ge, Ge), Qe.transform(...nt), this.executeOperatorList(ut), this.restore()), ot = Util.applyTransform([it.width, 0], nt)[0] * Ge + st, Qe.translate(ot, 0), Ue.x += ot * Ze;
      }
      Qe.restore(), this.processingType3 = null;
    }
  }
  setCharWidth(ue, Qe) {
  }
  setCharWidthAndBounds(ue, Qe, Ue, He, Ge, Xe) {
    this.ctx.rect(Ue, He, Ge - Ue, Xe - He), this.ctx.clip(), this.endPath();
  }
  getColorN_Pattern(ue) {
    let Qe;
    if (ue[0] === "TilingPattern") {
      const Ue = ue[1], He = this.baseTransform || getCurrentTransform(this.ctx), Ge = {
        createCanvasGraphics: (Xe) => new I1(Xe, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
          optionalContentConfig: this.optionalContentConfig,
          markedContentStack: this.markedContentStack
        })
      };
      Qe = new TilingPattern(ue, Ue, this.ctx, Ge, He);
    } else
      Qe = this._getPattern(ue[1], ue[2]);
    return Qe;
  }
  setStrokeColorN() {
    this.current.strokeColor = this.getColorN_Pattern(arguments);
  }
  setFillColorN() {
    this.current.fillColor = this.getColorN_Pattern(arguments), this.current.patternFill = !0;
  }
  setStrokeRGBColor(ue, Qe, Ue) {
    const He = Util.makeHexColor(ue, Qe, Ue);
    this.ctx.strokeStyle = He, this.current.strokeColor = He;
  }
  setFillRGBColor(ue, Qe, Ue) {
    const He = Util.makeHexColor(ue, Qe, Ue);
    this.ctx.fillStyle = He, this.current.fillColor = He, this.current.patternFill = !1;
  }
  _getPattern(ue, Qe = null) {
    let Ue;
    return this.cachedPatterns.has(ue) ? Ue = this.cachedPatterns.get(ue) : (Ue = getShadingPattern(this.getObject(ue)), this.cachedPatterns.set(ue, Ue)), Qe && (Ue.matrix = Qe), Ue;
  }
  shadingFill(ue) {
    if (!this.contentVisible)
      return;
    const Qe = this.ctx;
    this.save();
    const Ue = this._getPattern(ue);
    Qe.fillStyle = Ue.getPattern(Qe, this, getCurrentTransformInverse(Qe), PathType.SHADING);
    const He = getCurrentTransformInverse(Qe);
    if (He) {
      const {
        width: Ge,
        height: Xe
      } = Qe.canvas, [Ke, $e, Je, Ze] = Util.getAxialAlignedBoundingBox([0, 0, Ge, Xe], He);
      this.ctx.fillRect(Ke, $e, Je - Ke, Ze - $e);
    } else
      this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
    this.compose(this.current.getClippedPathBoundingBox()), this.restore();
  }
  beginInlineImage() {
    unreachable("Should not call beginInlineImage");
  }
  beginImageData() {
    unreachable("Should not call beginImageData");
  }
  paintFormXObjectBegin(ue, Qe) {
    if (this.contentVisible && (this.save(), this.baseTransformStack.push(this.baseTransform), ue && this.transform(...ue), this.baseTransform = getCurrentTransform(this.ctx), Qe)) {
      const Ue = Qe[2] - Qe[0], He = Qe[3] - Qe[1];
      this.ctx.rect(Qe[0], Qe[1], Ue, He), this.current.updateRectMinMax(getCurrentTransform(this.ctx), Qe), this.clip(), this.endPath();
    }
  }
  paintFormXObjectEnd() {
    this.contentVisible && (this.restore(), this.baseTransform = this.baseTransformStack.pop());
  }
  beginGroup(ue) {
    if (!this.contentVisible)
      return;
    this.save(), this.inSMaskMode && (this.endSMaskMode(), this.current.activeSMask = null);
    const Qe = this.ctx;
    ue.isolated || info("TODO: Support non-isolated groups."), ue.knockout && warn("Knockout groups not supported.");
    const Ue = getCurrentTransform(Qe);
    if (ue.matrix && Qe.transform(...ue.matrix), !ue.bbox)
      throw new Error("Bounding box is required.");
    let He = Util.getAxialAlignedBoundingBox(ue.bbox, getCurrentTransform(Qe));
    const Ge = [0, 0, Qe.canvas.width, Qe.canvas.height];
    He = Util.intersect(He, Ge) || [0, 0, 0, 0];
    const Xe = Math.floor(He[0]), Ke = Math.floor(He[1]), $e = Math.max(Math.ceil(He[2]) - Xe, 1), Je = Math.max(Math.ceil(He[3]) - Ke, 1);
    this.current.startNewPathAndClipBox([0, 0, $e, Je]);
    let Ze = "groupAt" + this.groupLevel;
    ue.smask && (Ze += "_smask_" + this.smaskCounter++ % 2);
    const nt = this.cachedCanvases.getCanvas(Ze, $e, Je), tt = nt.context;
    tt.translate(-Xe, -Ke), tt.transform(...Ue), ue.smask ? this.smaskStack.push({
      canvas: nt.canvas,
      context: tt,
      offsetX: Xe,
      offsetY: Ke,
      subtype: ue.smask.subtype,
      backdrop: ue.smask.backdrop,
      transferMap: ue.smask.transferMap || null,
      startTransformInverse: null
    }) : (Qe.setTransform(1, 0, 0, 1, 0, 0), Qe.translate(Xe, Ke), Qe.save()), copyCtxState(Qe, tt), this.ctx = tt, this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]), this.groupStack.push(Qe), this.groupLevel++;
  }
  endGroup(ue) {
    if (!this.contentVisible)
      return;
    this.groupLevel--;
    const Qe = this.ctx, Ue = this.groupStack.pop();
    if (this.ctx = Ue, this.ctx.imageSmoothingEnabled = !1, ue.smask)
      this.tempSMask = this.smaskStack.pop(), this.restore();
    else {
      this.ctx.restore();
      const He = getCurrentTransform(this.ctx);
      this.restore(), this.ctx.save(), this.ctx.setTransform(...He);
      const Ge = Util.getAxialAlignedBoundingBox([0, 0, Qe.canvas.width, Qe.canvas.height], He);
      this.ctx.drawImage(Qe.canvas, 0, 0), this.ctx.restore(), this.compose(Ge);
    }
  }
  beginAnnotation(ue, Qe, Ue, He, Ge) {
    if (en(this, ws, Hh).call(this), resetCtxToDefault(this.ctx), this.ctx.save(), this.save(), this.baseTransform && this.ctx.setTransform(...this.baseTransform), Qe) {
      const Xe = Qe[2] - Qe[0], Ke = Qe[3] - Qe[1];
      if (Ge && this.annotationCanvasMap) {
        Ue = Ue.slice(), Ue[4] -= Qe[0], Ue[5] -= Qe[1], Qe = Qe.slice(), Qe[0] = Qe[1] = 0, Qe[2] = Xe, Qe[3] = Ke;
        const [$e, Je] = Util.singularValueDecompose2dScale(getCurrentTransform(this.ctx)), {
          viewportScale: Ze
        } = this, nt = Math.ceil(Xe * this.outputScaleX * Ze), tt = Math.ceil(Ke * this.outputScaleY * Ze);
        this.annotationCanvas = this.canvasFactory.create(nt, tt);
        const {
          canvas: et,
          context: rt
        } = this.annotationCanvas;
        this.annotationCanvasMap.set(ue, et), this.annotationCanvas.savedCtx = this.ctx, this.ctx = rt, this.ctx.save(), this.ctx.setTransform($e, 0, 0, -Je, 0, Ke * Je), resetCtxToDefault(this.ctx);
      } else
        resetCtxToDefault(this.ctx), this.ctx.rect(Qe[0], Qe[1], Xe, Ke), this.ctx.clip(), this.endPath();
    }
    this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height), this.transform(...Ue), this.transform(...He);
  }
  endAnnotation() {
    this.annotationCanvas && (this.ctx.restore(), en(this, ws, Gh).call(this), this.ctx = this.annotationCanvas.savedCtx, delete this.annotationCanvas.savedCtx, delete this.annotationCanvas);
  }
  paintImageMaskXObject(ue) {
    if (!this.contentVisible)
      return;
    const Qe = ue.count;
    ue = this.getObject(ue.data, ue), ue.count = Qe;
    const Ue = this.ctx, He = this.processingType3;
    if (He && (He.compiled === void 0 && (He.compiled = compileType3Glyph(ue)), He.compiled)) {
      He.compiled(Ue);
      return;
    }
    const Ge = this._createMaskCanvas(ue), Xe = Ge.canvas;
    Ue.save(), Ue.setTransform(1, 0, 0, 1, 0, 0), Ue.drawImage(Xe, Ge.offsetX, Ge.offsetY), Ue.restore(), this.compose();
  }
  paintImageMaskXObjectRepeat(ue, Qe, Ue = 0, He = 0, Ge, Xe) {
    if (!this.contentVisible)
      return;
    ue = this.getObject(ue.data, ue);
    const Ke = this.ctx;
    Ke.save();
    const $e = getCurrentTransform(Ke);
    Ke.transform(Qe, Ue, He, Ge, 0, 0);
    const Je = this._createMaskCanvas(ue);
    Ke.setTransform(1, 0, 0, 1, Je.offsetX - $e[4], Je.offsetY - $e[5]);
    for (let Ze = 0, nt = Xe.length; Ze < nt; Ze += 2) {
      const tt = Util.transform($e, [Qe, Ue, He, Ge, Xe[Ze], Xe[Ze + 1]]), [et, rt] = Util.applyTransform([0, 0], tt);
      Ke.drawImage(Je.canvas, et, rt);
    }
    Ke.restore(), this.compose();
  }
  paintImageMaskXObjectGroup(ue) {
    if (!this.contentVisible)
      return;
    const Qe = this.ctx, Ue = this.current.fillColor, He = this.current.patternFill;
    for (const Ge of ue) {
      const {
        data: Xe,
        width: Ke,
        height: $e,
        transform: Je
      } = Ge, Ze = this.cachedCanvases.getCanvas("maskCanvas", Ke, $e), nt = Ze.context;
      nt.save();
      const tt = this.getObject(Xe, Ge);
      putBinaryImageMask(nt, tt), nt.globalCompositeOperation = "source-in", nt.fillStyle = He ? Ue.getPattern(nt, this, getCurrentTransformInverse(Qe), PathType.FILL) : Ue, nt.fillRect(0, 0, Ke, $e), nt.restore(), Qe.save(), Qe.transform(...Je), Qe.scale(1, -1), drawImageAtIntegerCoords(Qe, Ze.canvas, 0, 0, Ke, $e, 0, -1, 1, 1), Qe.restore();
    }
    this.compose();
  }
  paintImageXObject(ue) {
    if (!this.contentVisible)
      return;
    const Qe = this.getObject(ue);
    if (!Qe) {
      warn("Dependent image isn't ready yet");
      return;
    }
    this.paintInlineImageXObject(Qe);
  }
  paintImageXObjectRepeat(ue, Qe, Ue, He) {
    if (!this.contentVisible)
      return;
    const Ge = this.getObject(ue);
    if (!Ge) {
      warn("Dependent image isn't ready yet");
      return;
    }
    const Xe = Ge.width, Ke = Ge.height, $e = [];
    for (let Je = 0, Ze = He.length; Je < Ze; Je += 2)
      $e.push({
        transform: [Qe, 0, 0, Ue, He[Je], He[Je + 1]],
        x: 0,
        y: 0,
        w: Xe,
        h: Ke
      });
    this.paintInlineImageXObjectGroup(Ge, $e);
  }
  applyTransferMapsToCanvas(ue) {
    return this.current.transferMaps !== "none" && (ue.filter = this.current.transferMaps, ue.drawImage(ue.canvas, 0, 0), ue.filter = "none"), ue.canvas;
  }
  applyTransferMapsToBitmap(ue) {
    if (this.current.transferMaps === "none")
      return ue.bitmap;
    const {
      bitmap: Qe,
      width: Ue,
      height: He
    } = ue, Ge = this.cachedCanvases.getCanvas("inlineImage", Ue, He), Xe = Ge.context;
    return Xe.filter = this.current.transferMaps, Xe.drawImage(Qe, 0, 0), Xe.filter = "none", Ge.canvas;
  }
  paintInlineImageXObject(ue) {
    if (!this.contentVisible)
      return;
    const Qe = ue.width, Ue = ue.height, He = this.ctx;
    if (this.save(), !isNodeJS) {
      const {
        filter: Ke
      } = He;
      Ke !== "none" && Ke !== "" && (He.filter = "none");
    }
    He.scale(1 / Qe, -1 / Ue);
    let Ge;
    if (ue.bitmap)
      Ge = this.applyTransferMapsToBitmap(ue);
    else if (typeof HTMLElement == "function" && ue instanceof HTMLElement || !ue.data)
      Ge = ue;
    else {
      const $e = this.cachedCanvases.getCanvas("inlineImage", Qe, Ue).context;
      putBinaryImageData($e, ue), Ge = this.applyTransferMapsToCanvas($e);
    }
    const Xe = this._scaleImage(Ge, getCurrentTransformInverse(He));
    He.imageSmoothingEnabled = getImageSmoothingEnabled(getCurrentTransform(He), ue.interpolate), drawImageAtIntegerCoords(He, Xe.img, 0, 0, Xe.paintWidth, Xe.paintHeight, 0, -Ue, Qe, Ue), this.compose(), this.restore();
  }
  paintInlineImageXObjectGroup(ue, Qe) {
    if (!this.contentVisible)
      return;
    const Ue = this.ctx;
    let He;
    if (ue.bitmap)
      He = ue.bitmap;
    else {
      const Ge = ue.width, Xe = ue.height, $e = this.cachedCanvases.getCanvas("inlineImage", Ge, Xe).context;
      putBinaryImageData($e, ue), He = this.applyTransferMapsToCanvas($e);
    }
    for (const Ge of Qe)
      Ue.save(), Ue.transform(...Ge.transform), Ue.scale(1, -1), drawImageAtIntegerCoords(Ue, He, Ge.x, Ge.y, Ge.w, Ge.h, 0, -1, 1, 1), Ue.restore();
    this.compose();
  }
  paintSolidColorImageMask() {
    this.contentVisible && (this.ctx.fillRect(0, 0, 1, 1), this.compose());
  }
  markPoint(ue) {
  }
  markPointProps(ue, Qe) {
  }
  beginMarkedContent(ue) {
    this.markedContentStack.push({
      visible: !0
    });
  }
  beginMarkedContentProps(ue, Qe) {
    ue === "OC" ? this.markedContentStack.push({
      visible: this.optionalContentConfig.isVisible(Qe)
    }) : this.markedContentStack.push({
      visible: !0
    }), this.contentVisible = this.isContentVisible();
  }
  endMarkedContent() {
    this.markedContentStack.pop(), this.contentVisible = this.isContentVisible();
  }
  beginCompat() {
  }
  endCompat() {
  }
  consumePath(ue) {
    const Qe = this.current.isEmptyClip();
    this.pendingClip && this.current.updateClipFromPath(), this.pendingClip || this.compose(ue);
    const Ue = this.ctx;
    this.pendingClip && (Qe || (this.pendingClip === EO_CLIP ? Ue.clip("evenodd") : Ue.clip()), this.pendingClip = null), this.current.startNewPathAndClipBox(this.current.clipBox), Ue.beginPath();
  }
  getSinglePixelWidth() {
    if (!this._cachedGetSinglePixelWidth) {
      const ue = getCurrentTransform(this.ctx);
      if (ue[1] === 0 && ue[2] === 0)
        this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(ue[0]), Math.abs(ue[3]));
      else {
        const Qe = Math.abs(ue[0] * ue[3] - ue[2] * ue[1]), Ue = Math.hypot(ue[0], ue[2]), He = Math.hypot(ue[1], ue[3]);
        this._cachedGetSinglePixelWidth = Math.max(Ue, He) / Qe;
      }
    }
    return this._cachedGetSinglePixelWidth;
  }
  getScaleForStroking() {
    if (this._cachedScaleForStroking[0] === -1) {
      const {
        lineWidth: ue
      } = this.current, {
        a: Qe,
        b: Ue,
        c: He,
        d: Ge
      } = this.ctx.getTransform();
      let Xe, Ke;
      if (Ue === 0 && He === 0) {
        const $e = Math.abs(Qe), Je = Math.abs(Ge);
        if ($e === Je)
          if (ue === 0)
            Xe = Ke = 1 / $e;
          else {
            const Ze = $e * ue;
            Xe = Ke = Ze < 1 ? 1 / Ze : 1;
          }
        else if (ue === 0)
          Xe = 1 / $e, Ke = 1 / Je;
        else {
          const Ze = $e * ue, nt = Je * ue;
          Xe = Ze < 1 ? 1 / Ze : 1, Ke = nt < 1 ? 1 / nt : 1;
        }
      } else {
        const $e = Math.abs(Qe * Ge - Ue * He), Je = Math.hypot(Qe, Ue), Ze = Math.hypot(He, Ge);
        if (ue === 0)
          Xe = Ze / $e, Ke = Je / $e;
        else {
          const nt = ue * $e;
          Xe = Ze > nt ? Ze / nt : 1, Ke = Je > nt ? Je / nt : 1;
        }
      }
      this._cachedScaleForStroking[0] = Xe, this._cachedScaleForStroking[1] = Ke;
    }
    return this._cachedScaleForStroking;
  }
  rescaleAndStroke(ue) {
    const {
      ctx: Qe
    } = this, {
      lineWidth: Ue
    } = this.current, [He, Ge] = this.getScaleForStroking();
    if (Qe.lineWidth = Ue || 1, He === 1 && Ge === 1) {
      Qe.stroke();
      return;
    }
    const Xe = Qe.getLineDash();
    if (ue && Qe.save(), Qe.scale(He, Ge), Xe.length > 0) {
      const Ke = Math.max(He, Ge);
      Qe.setLineDash(Xe.map(($e) => $e / Ke)), Qe.lineDashOffset /= Ke;
    }
    Qe.stroke(), ue && Qe.restore();
  }
  isContentVisible() {
    for (let ue = this.markedContentStack.length - 1; ue >= 0; ue--)
      if (!this.markedContentStack[ue].visible)
        return !1;
    return !0;
  }
};
ws = new WeakSet(), Hh = function() {
  for (; this.stateStack.length || this.inSMaskMode; )
    this.restore();
  this.ctx.restore(), this.transparentCanvas && (this.ctx = this.compositeCtx, this.ctx.save(), this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.drawImage(this.transparentCanvas, 0, 0), this.ctx.restore(), this.transparentCanvas = null);
}, Gh = function() {
  if (this.pageColors) {
    const ue = this.filterFactory.addHCMFilter(this.pageColors.foreground, this.pageColors.background);
    if (ue !== "none") {
      const Qe = this.ctx.filter;
      this.ctx.filter = ue, this.ctx.drawImage(this.ctx.canvas, 0, 0), this.ctx.filter = Qe;
    }
  }
};
let CanvasGraphics = I1;
for (const me in OPS)
  CanvasGraphics.prototype[me] !== void 0 && (CanvasGraphics.prototype[OPS[me]] = CanvasGraphics.prototype[me]);
var x0, b0;
class GlobalWorkerOptions {
  static get workerPort() {
    return xt(this, x0);
  }
  static set workerPort(ue) {
    if (!(typeof Worker < "u" && ue instanceof Worker) && ue !== null)
      throw new Error("Invalid `workerPort` type.");
    Zt(this, x0, ue);
  }
  static get workerSrc() {
    return xt(this, b0);
  }
  static set workerSrc(ue) {
    if (typeof ue != "string")
      throw new Error("Invalid `workerSrc` type.");
    Zt(this, b0, ue);
  }
}
x0 = new WeakMap(), b0 = new WeakMap(), tn(GlobalWorkerOptions, x0, null), tn(GlobalWorkerOptions, b0, "");
const CallbackKind = {
  UNKNOWN: 0,
  DATA: 1,
  ERROR: 2
}, StreamKind = {
  UNKNOWN: 0,
  CANCEL: 1,
  CANCEL_COMPLETE: 2,
  CLOSE: 3,
  ENQUEUE: 4,
  ERROR: 5,
  PULL: 6,
  PULL_COMPLETE: 7,
  START_COMPLETE: 8
};
function wrapReason(me) {
  switch (me instanceof Error || typeof me == "object" && me !== null || unreachable('wrapReason: Expected "reason" to be a (possibly cloned) Error.'), me.name) {
    case "AbortException":
      return new AbortException(me.message);
    case "MissingPDFException":
      return new MissingPDFException(me.message);
    case "PasswordException":
      return new PasswordException(me.message, me.code);
    case "UnexpectedResponseException":
      return new UnexpectedResponseException(me.message, me.status);
    case "UnknownErrorException":
      return new UnknownErrorException(me.message, me.details);
    default:
      return new UnknownErrorException(me.message, me.toString());
  }
}
var eo, gg, mg, x2;
class MessageHandler {
  constructor(ue, Qe, Ue) {
    tn(this, eo);
    this.sourceName = ue, this.targetName = Qe, this.comObj = Ue, this.callbackId = 1, this.streamId = 1, this.streamSinks = /* @__PURE__ */ Object.create(null), this.streamControllers = /* @__PURE__ */ Object.create(null), this.callbackCapabilities = /* @__PURE__ */ Object.create(null), this.actionHandler = /* @__PURE__ */ Object.create(null), this._onComObjOnMessage = (He) => {
      const Ge = He.data;
      if (Ge.targetName !== this.sourceName)
        return;
      if (Ge.stream) {
        en(this, eo, mg).call(this, Ge);
        return;
      }
      if (Ge.callback) {
        const Ke = Ge.callbackId, $e = this.callbackCapabilities[Ke];
        if (!$e)
          throw new Error(`Cannot resolve callback ${Ke}`);
        if (delete this.callbackCapabilities[Ke], Ge.callback === CallbackKind.DATA)
          $e.resolve(Ge.data);
        else if (Ge.callback === CallbackKind.ERROR)
          $e.reject(wrapReason(Ge.reason));
        else
          throw new Error("Unexpected callback case");
        return;
      }
      const Xe = this.actionHandler[Ge.action];
      if (!Xe)
        throw new Error(`Unknown action from worker: ${Ge.action}`);
      if (Ge.callbackId) {
        const Ke = this.sourceName, $e = Ge.sourceName;
        new Promise(function(Je) {
          Je(Xe(Ge.data));
        }).then(function(Je) {
          Ue.postMessage({
            sourceName: Ke,
            targetName: $e,
            callback: CallbackKind.DATA,
            callbackId: Ge.callbackId,
            data: Je
          });
        }, function(Je) {
          Ue.postMessage({
            sourceName: Ke,
            targetName: $e,
            callback: CallbackKind.ERROR,
            callbackId: Ge.callbackId,
            reason: wrapReason(Je)
          });
        });
        return;
      }
      if (Ge.streamId) {
        en(this, eo, gg).call(this, Ge);
        return;
      }
      Xe(Ge.data);
    }, Ue.addEventListener("message", this._onComObjOnMessage);
  }
  on(ue, Qe) {
    const Ue = this.actionHandler;
    if (Ue[ue])
      throw new Error(`There is already an actionName called "${ue}"`);
    Ue[ue] = Qe;
  }
  send(ue, Qe, Ue) {
    this.comObj.postMessage({
      sourceName: this.sourceName,
      targetName: this.targetName,
      action: ue,
      data: Qe
    }, Ue);
  }
  sendWithPromise(ue, Qe, Ue) {
    const He = this.callbackId++, Ge = Promise.withResolvers();
    this.callbackCapabilities[He] = Ge;
    try {
      this.comObj.postMessage({
        sourceName: this.sourceName,
        targetName: this.targetName,
        action: ue,
        callbackId: He,
        data: Qe
      }, Ue);
    } catch (Xe) {
      Ge.reject(Xe);
    }
    return Ge.promise;
  }
  sendWithStream(ue, Qe, Ue, He) {
    const Ge = this.streamId++, Xe = this.sourceName, Ke = this.targetName, $e = this.comObj;
    return new ReadableStream({
      start: (Je) => {
        const Ze = Promise.withResolvers();
        return this.streamControllers[Ge] = {
          controller: Je,
          startCall: Ze,
          pullCall: null,
          cancelCall: null,
          isClosed: !1
        }, $e.postMessage({
          sourceName: Xe,
          targetName: Ke,
          action: ue,
          streamId: Ge,
          data: Qe,
          desiredSize: Je.desiredSize
        }, He), Ze.promise;
      },
      pull: (Je) => {
        const Ze = Promise.withResolvers();
        return this.streamControllers[Ge].pullCall = Ze, $e.postMessage({
          sourceName: Xe,
          targetName: Ke,
          stream: StreamKind.PULL,
          streamId: Ge,
          desiredSize: Je.desiredSize
        }), Ze.promise;
      },
      cancel: (Je) => {
        assert(Je instanceof Error, "cancel must have a valid reason");
        const Ze = Promise.withResolvers();
        return this.streamControllers[Ge].cancelCall = Ze, this.streamControllers[Ge].isClosed = !0, $e.postMessage({
          sourceName: Xe,
          targetName: Ke,
          stream: StreamKind.CANCEL,
          streamId: Ge,
          reason: wrapReason(Je)
        }), Ze.promise;
      }
    }, Ue);
  }
  destroy() {
    this.comObj.removeEventListener("message", this._onComObjOnMessage);
  }
}
eo = new WeakSet(), gg = function(ue) {
  const Qe = ue.streamId, Ue = this.sourceName, He = ue.sourceName, Ge = this.comObj, Xe = this, Ke = this.actionHandler[ue.action], $e = {
    enqueue(Je, Ze = 1, nt) {
      if (this.isCancelled)
        return;
      const tt = this.desiredSize;
      this.desiredSize -= Ze, tt > 0 && this.desiredSize <= 0 && (this.sinkCapability = Promise.withResolvers(), this.ready = this.sinkCapability.promise), Ge.postMessage({
        sourceName: Ue,
        targetName: He,
        stream: StreamKind.ENQUEUE,
        streamId: Qe,
        chunk: Je
      }, nt);
    },
    close() {
      this.isCancelled || (this.isCancelled = !0, Ge.postMessage({
        sourceName: Ue,
        targetName: He,
        stream: StreamKind.CLOSE,
        streamId: Qe
      }), delete Xe.streamSinks[Qe]);
    },
    error(Je) {
      assert(Je instanceof Error, "error must have a valid reason"), !this.isCancelled && (this.isCancelled = !0, Ge.postMessage({
        sourceName: Ue,
        targetName: He,
        stream: StreamKind.ERROR,
        streamId: Qe,
        reason: wrapReason(Je)
      }));
    },
    sinkCapability: Promise.withResolvers(),
    onPull: null,
    onCancel: null,
    isCancelled: !1,
    desiredSize: ue.desiredSize,
    ready: null
  };
  $e.sinkCapability.resolve(), $e.ready = $e.sinkCapability.promise, this.streamSinks[Qe] = $e, new Promise(function(Je) {
    Je(Ke(ue.data, $e));
  }).then(function() {
    Ge.postMessage({
      sourceName: Ue,
      targetName: He,
      stream: StreamKind.START_COMPLETE,
      streamId: Qe,
      success: !0
    });
  }, function(Je) {
    Ge.postMessage({
      sourceName: Ue,
      targetName: He,
      stream: StreamKind.START_COMPLETE,
      streamId: Qe,
      reason: wrapReason(Je)
    });
  });
}, mg = function(ue) {
  const Qe = ue.streamId, Ue = this.sourceName, He = ue.sourceName, Ge = this.comObj, Xe = this.streamControllers[Qe], Ke = this.streamSinks[Qe];
  switch (ue.stream) {
    case StreamKind.START_COMPLETE:
      ue.success ? Xe.startCall.resolve() : Xe.startCall.reject(wrapReason(ue.reason));
      break;
    case StreamKind.PULL_COMPLETE:
      ue.success ? Xe.pullCall.resolve() : Xe.pullCall.reject(wrapReason(ue.reason));
      break;
    case StreamKind.PULL:
      if (!Ke) {
        Ge.postMessage({
          sourceName: Ue,
          targetName: He,
          stream: StreamKind.PULL_COMPLETE,
          streamId: Qe,
          success: !0
        });
        break;
      }
      Ke.desiredSize <= 0 && ue.desiredSize > 0 && Ke.sinkCapability.resolve(), Ke.desiredSize = ue.desiredSize, new Promise(function($e) {
        var Je;
        $e((Je = Ke.onPull) == null ? void 0 : Je.call(Ke));
      }).then(function() {
        Ge.postMessage({
          sourceName: Ue,
          targetName: He,
          stream: StreamKind.PULL_COMPLETE,
          streamId: Qe,
          success: !0
        });
      }, function($e) {
        Ge.postMessage({
          sourceName: Ue,
          targetName: He,
          stream: StreamKind.PULL_COMPLETE,
          streamId: Qe,
          reason: wrapReason($e)
        });
      });
      break;
    case StreamKind.ENQUEUE:
      if (assert(Xe, "enqueue should have stream controller"), Xe.isClosed)
        break;
      Xe.controller.enqueue(ue.chunk);
      break;
    case StreamKind.CLOSE:
      if (assert(Xe, "close should have stream controller"), Xe.isClosed)
        break;
      Xe.isClosed = !0, Xe.controller.close(), en(this, eo, x2).call(this, Xe, Qe);
      break;
    case StreamKind.ERROR:
      assert(Xe, "error should have stream controller"), Xe.controller.error(wrapReason(ue.reason)), en(this, eo, x2).call(this, Xe, Qe);
      break;
    case StreamKind.CANCEL_COMPLETE:
      ue.success ? Xe.cancelCall.resolve() : Xe.cancelCall.reject(wrapReason(ue.reason)), en(this, eo, x2).call(this, Xe, Qe);
      break;
    case StreamKind.CANCEL:
      if (!Ke)
        break;
      new Promise(function($e) {
        var Je;
        $e((Je = Ke.onCancel) == null ? void 0 : Je.call(Ke, wrapReason(ue.reason)));
      }).then(function() {
        Ge.postMessage({
          sourceName: Ue,
          targetName: He,
          stream: StreamKind.CANCEL_COMPLETE,
          streamId: Qe,
          success: !0
        });
      }, function($e) {
        Ge.postMessage({
          sourceName: Ue,
          targetName: He,
          stream: StreamKind.CANCEL_COMPLETE,
          streamId: Qe,
          reason: wrapReason($e)
        });
      }), Ke.sinkCapability.reject(wrapReason(ue.reason)), Ke.isCancelled = !0, delete this.streamSinks[Qe];
      break;
    default:
      throw new Error("Unexpected stream case");
  }
}, x2 = async function(ue, Qe) {
  var Ue, He, Ge;
  await Promise.allSettled([(Ue = ue.startCall) == null ? void 0 : Ue.promise, (He = ue.pullCall) == null ? void 0 : He.promise, (Ge = ue.cancelCall) == null ? void 0 : Ge.promise]), delete this.streamControllers[Qe];
};
var dc, S0;
class Metadata {
  constructor({
    parsedData: ue,
    rawData: Qe
  }) {
    tn(this, dc);
    tn(this, S0);
    Zt(this, dc, ue), Zt(this, S0, Qe);
  }
  getRaw() {
    return xt(this, S0);
  }
  get(ue) {
    return xt(this, dc).get(ue) ?? null;
  }
  getAll() {
    return objectFromMap(xt(this, dc));
  }
  has(ue) {
    return xt(this, dc).has(ue);
  }
}
dc = new WeakMap(), S0 = new WeakMap();
const INTERNAL = Symbol("INTERNAL");
var w0, T0, B0, Ou;
class OptionalContentGroup {
  constructor(ue, {
    name: Qe,
    intent: Ue,
    usage: He
  }) {
    tn(this, w0, !1);
    tn(this, T0, !1);
    tn(this, B0, !1);
    tn(this, Ou, !0);
    Zt(this, w0, !!(ue & RenderingIntentFlag.DISPLAY)), Zt(this, T0, !!(ue & RenderingIntentFlag.PRINT)), this.name = Qe, this.intent = Ue, this.usage = He;
  }
  get visible() {
    if (xt(this, B0))
      return xt(this, Ou);
    if (!xt(this, Ou))
      return !1;
    const {
      print: ue,
      view: Qe
    } = this.usage;
    return xt(this, w0) ? (Qe == null ? void 0 : Qe.viewState) !== "OFF" : xt(this, T0) ? (ue == null ? void 0 : ue.printState) !== "OFF" : !0;
  }
  _setVisible(ue, Qe, Ue = !1) {
    ue !== INTERNAL && unreachable("Internal method `_setVisible` called."), Zt(this, B0, Ue), Zt(this, Ou, Qe);
  }
}
w0 = new WeakMap(), T0 = new WeakMap(), B0 = new WeakMap(), Ou = new WeakMap();
var us, Tr, Nu, Du, R0, Wh;
class OptionalContentConfig {
  constructor(ue, Qe = RenderingIntentFlag.DISPLAY) {
    tn(this, R0);
    tn(this, us, null);
    tn(this, Tr, /* @__PURE__ */ new Map());
    tn(this, Nu, null);
    tn(this, Du, null);
    if (this.renderingIntent = Qe, this.name = null, this.creator = null, ue !== null) {
      this.name = ue.name, this.creator = ue.creator, Zt(this, Du, ue.order);
      for (const Ue of ue.groups)
        xt(this, Tr).set(Ue.id, new OptionalContentGroup(Qe, Ue));
      if (ue.baseState === "OFF")
        for (const Ue of xt(this, Tr).values())
          Ue._setVisible(INTERNAL, !1);
      for (const Ue of ue.on)
        xt(this, Tr).get(Ue)._setVisible(INTERNAL, !0);
      for (const Ue of ue.off)
        xt(this, Tr).get(Ue)._setVisible(INTERNAL, !1);
      Zt(this, Nu, this.getHash());
    }
  }
  isVisible(ue) {
    if (xt(this, Tr).size === 0)
      return !0;
    if (!ue)
      return info("Optional content group not defined."), !0;
    if (ue.type === "OCG")
      return xt(this, Tr).has(ue.id) ? xt(this, Tr).get(ue.id).visible : (warn(`Optional content group not found: ${ue.id}`), !0);
    if (ue.type === "OCMD") {
      if (ue.expression)
        return en(this, R0, Wh).call(this, ue.expression);
      if (!ue.policy || ue.policy === "AnyOn") {
        for (const Qe of ue.ids) {
          if (!xt(this, Tr).has(Qe))
            return warn(`Optional content group not found: ${Qe}`), !0;
          if (xt(this, Tr).get(Qe).visible)
            return !0;
        }
        return !1;
      } else if (ue.policy === "AllOn") {
        for (const Qe of ue.ids) {
          if (!xt(this, Tr).has(Qe))
            return warn(`Optional content group not found: ${Qe}`), !0;
          if (!xt(this, Tr).get(Qe).visible)
            return !1;
        }
        return !0;
      } else if (ue.policy === "AnyOff") {
        for (const Qe of ue.ids) {
          if (!xt(this, Tr).has(Qe))
            return warn(`Optional content group not found: ${Qe}`), !0;
          if (!xt(this, Tr).get(Qe).visible)
            return !0;
        }
        return !1;
      } else if (ue.policy === "AllOff") {
        for (const Qe of ue.ids) {
          if (!xt(this, Tr).has(Qe))
            return warn(`Optional content group not found: ${Qe}`), !0;
          if (xt(this, Tr).get(Qe).visible)
            return !1;
        }
        return !0;
      }
      return warn(`Unknown optional content policy ${ue.policy}.`), !0;
    }
    return warn(`Unknown group type ${ue.type}.`), !0;
  }
  setVisibility(ue, Qe = !0) {
    const Ue = xt(this, Tr).get(ue);
    if (!Ue) {
      warn(`Optional content group not found: ${ue}`);
      return;
    }
    Ue._setVisible(INTERNAL, !!Qe, !0), Zt(this, us, null);
  }
  setOCGState({
    state: ue,
    preserveRB: Qe
  }) {
    let Ue;
    for (const He of ue) {
      switch (He) {
        case "ON":
        case "OFF":
        case "Toggle":
          Ue = He;
          continue;
      }
      const Ge = xt(this, Tr).get(He);
      if (Ge)
        switch (Ue) {
          case "ON":
            Ge._setVisible(INTERNAL, !0);
            break;
          case "OFF":
            Ge._setVisible(INTERNAL, !1);
            break;
          case "Toggle":
            Ge._setVisible(INTERNAL, !Ge.visible);
            break;
        }
    }
    Zt(this, us, null);
  }
  get hasInitialVisibility() {
    return xt(this, Nu) === null || this.getHash() === xt(this, Nu);
  }
  getOrder() {
    return xt(this, Tr).size ? xt(this, Du) ? xt(this, Du).slice() : [...xt(this, Tr).keys()] : null;
  }
  getGroups() {
    return xt(this, Tr).size > 0 ? objectFromMap(xt(this, Tr)) : null;
  }
  getGroup(ue) {
    return xt(this, Tr).get(ue) || null;
  }
  getHash() {
    if (xt(this, us) !== null)
      return xt(this, us);
    const ue = new MurmurHash3_64();
    for (const [Qe, Ue] of xt(this, Tr))
      ue.update(`${Qe}:${Ue.visible}`);
    return Zt(this, us, ue.hexdigest());
  }
}
us = new WeakMap(), Tr = new WeakMap(), Nu = new WeakMap(), Du = new WeakMap(), R0 = new WeakSet(), Wh = function(ue) {
  const Qe = ue.length;
  if (Qe < 2)
    return !0;
  const Ue = ue[0];
  for (let He = 1; He < Qe; He++) {
    const Ge = ue[He];
    let Xe;
    if (Array.isArray(Ge))
      Xe = en(this, R0, Wh).call(this, Ge);
    else if (xt(this, Tr).has(Ge))
      Xe = xt(this, Tr).get(Ge).visible;
    else
      return warn(`Optional content group not found: ${Ge}`), !0;
    switch (Ue) {
      case "And":
        if (!Xe)
          return !1;
        break;
      case "Or":
        if (Xe)
          return !0;
        break;
      case "Not":
        return !Xe;
      default:
        return !0;
    }
  }
  return Ue === "And";
};
class PDFDataTransportStream {
  constructor(ue, {
    disableRange: Qe = !1,
    disableStream: Ue = !1
  }) {
    assert(ue, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.');
    const {
      length: He,
      initialData: Ge,
      progressiveDone: Xe,
      contentDispositionFilename: Ke
    } = ue;
    if (this._queuedChunks = [], this._progressiveDone = Xe, this._contentDispositionFilename = Ke, (Ge == null ? void 0 : Ge.length) > 0) {
      const $e = Ge instanceof Uint8Array && Ge.byteLength === Ge.buffer.byteLength ? Ge.buffer : new Uint8Array(Ge).buffer;
      this._queuedChunks.push($e);
    }
    this._pdfDataRangeTransport = ue, this._isStreamingSupported = !Ue, this._isRangeSupported = !Qe, this._contentLength = He, this._fullRequestReader = null, this._rangeReaders = [], ue.addRangeListener(($e, Je) => {
      this._onReceiveData({
        begin: $e,
        chunk: Je
      });
    }), ue.addProgressListener(($e, Je) => {
      this._onProgress({
        loaded: $e,
        total: Je
      });
    }), ue.addProgressiveReadListener(($e) => {
      this._onReceiveData({
        chunk: $e
      });
    }), ue.addProgressiveDoneListener(() => {
      this._onProgressiveDone();
    }), ue.transportReady();
  }
  _onReceiveData({
    begin: ue,
    chunk: Qe
  }) {
    const Ue = Qe instanceof Uint8Array && Qe.byteLength === Qe.buffer.byteLength ? Qe.buffer : new Uint8Array(Qe).buffer;
    if (ue === void 0)
      this._fullRequestReader ? this._fullRequestReader._enqueue(Ue) : this._queuedChunks.push(Ue);
    else {
      const He = this._rangeReaders.some(function(Ge) {
        return Ge._begin !== ue ? !1 : (Ge._enqueue(Ue), !0);
      });
      assert(He, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
    }
  }
  get _progressiveDataLength() {
    var ue;
    return ((ue = this._fullRequestReader) == null ? void 0 : ue._loaded) ?? 0;
  }
  _onProgress(ue) {
    var Qe, Ue, He, Ge;
    ue.total === void 0 ? (Ue = (Qe = this._rangeReaders[0]) == null ? void 0 : Qe.onProgress) == null || Ue.call(Qe, {
      loaded: ue.loaded
    }) : (Ge = (He = this._fullRequestReader) == null ? void 0 : He.onProgress) == null || Ge.call(He, {
      loaded: ue.loaded,
      total: ue.total
    });
  }
  _onProgressiveDone() {
    var ue;
    (ue = this._fullRequestReader) == null || ue.progressiveDone(), this._progressiveDone = !0;
  }
  _removeRangeReader(ue) {
    const Qe = this._rangeReaders.indexOf(ue);
    Qe >= 0 && this._rangeReaders.splice(Qe, 1);
  }
  getFullReader() {
    assert(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
    const ue = this._queuedChunks;
    return this._queuedChunks = null, new PDFDataTransportStreamReader(this, ue, this._progressiveDone, this._contentDispositionFilename);
  }
  getRangeReader(ue, Qe) {
    if (Qe <= this._progressiveDataLength)
      return null;
    const Ue = new PDFDataTransportStreamRangeReader(this, ue, Qe);
    return this._pdfDataRangeTransport.requestDataRange(ue, Qe), this._rangeReaders.push(Ue), Ue;
  }
  cancelAllRequests(ue) {
    var Qe;
    (Qe = this._fullRequestReader) == null || Qe.cancel(ue);
    for (const Ue of this._rangeReaders.slice(0))
      Ue.cancel(ue);
    this._pdfDataRangeTransport.abort();
  }
}
class PDFDataTransportStreamReader {
  constructor(ue, Qe, Ue = !1, He = null) {
    this._stream = ue, this._done = Ue || !1, this._filename = isPdfFile(He) ? He : null, this._queuedChunks = Qe || [], this._loaded = 0;
    for (const Ge of this._queuedChunks)
      this._loaded += Ge.byteLength;
    this._requests = [], this._headersReady = Promise.resolve(), ue._fullRequestReader = this, this.onProgress = null;
  }
  _enqueue(ue) {
    this._done || (this._requests.length > 0 ? this._requests.shift().resolve({
      value: ue,
      done: !1
    }) : this._queuedChunks.push(ue), this._loaded += ue.byteLength);
  }
  get headersReady() {
    return this._headersReady;
  }
  get filename() {
    return this._filename;
  }
  get isRangeSupported() {
    return this._stream._isRangeSupported;
  }
  get isStreamingSupported() {
    return this._stream._isStreamingSupported;
  }
  get contentLength() {
    return this._stream._contentLength;
  }
  async read() {
    if (this._queuedChunks.length > 0)
      return {
        value: this._queuedChunks.shift(),
        done: !1
      };
    if (this._done)
      return {
        value: void 0,
        done: !0
      };
    const ue = Promise.withResolvers();
    return this._requests.push(ue), ue.promise;
  }
  cancel(ue) {
    this._done = !0;
    for (const Qe of this._requests)
      Qe.resolve({
        value: void 0,
        done: !0
      });
    this._requests.length = 0;
  }
  progressiveDone() {
    this._done || (this._done = !0);
  }
}
class PDFDataTransportStreamRangeReader {
  constructor(ue, Qe, Ue) {
    this._stream = ue, this._begin = Qe, this._end = Ue, this._queuedChunk = null, this._requests = [], this._done = !1, this.onProgress = null;
  }
  _enqueue(ue) {
    if (!this._done) {
      if (this._requests.length === 0)
        this._queuedChunk = ue;
      else {
        this._requests.shift().resolve({
          value: ue,
          done: !1
        });
        for (const Ue of this._requests)
          Ue.resolve({
            value: void 0,
            done: !0
          });
        this._requests.length = 0;
      }
      this._done = !0, this._stream._removeRangeReader(this);
    }
  }
  get isStreamingSupported() {
    return !1;
  }
  async read() {
    if (this._queuedChunk) {
      const Qe = this._queuedChunk;
      return this._queuedChunk = null, {
        value: Qe,
        done: !1
      };
    }
    if (this._done)
      return {
        value: void 0,
        done: !0
      };
    const ue = Promise.withResolvers();
    return this._requests.push(ue), ue.promise;
  }
  cancel(ue) {
    this._done = !0;
    for (const Qe of this._requests)
      Qe.resolve({
        value: void 0,
        done: !0
      });
    this._requests.length = 0, this._stream._removeRangeReader(this);
  }
}
function getFilenameFromContentDispositionHeader(me) {
  let ue = !0, Qe = Ue("filename\\*", "i").exec(me);
  if (Qe) {
    Qe = Qe[1];
    let Ze = Ke(Qe);
    return Ze = unescape(Ze), Ze = $e(Ze), Ze = Je(Ze), Ge(Ze);
  }
  if (Qe = Xe(me), Qe) {
    const Ze = Je(Qe);
    return Ge(Ze);
  }
  if (Qe = Ue("filename", "i").exec(me), Qe) {
    Qe = Qe[1];
    let Ze = Ke(Qe);
    return Ze = Je(Ze), Ge(Ze);
  }
  function Ue(Ze, nt) {
    return new RegExp("(?:^|;)\\s*" + Ze + '\\s*=\\s*([^";\\s][^;\\s]*|"(?:[^"\\\\]|\\\\"?)+"?)', nt);
  }
  function He(Ze, nt) {
    if (Ze) {
      if (!/^[\x00-\xFF]+$/.test(nt))
        return nt;
      try {
        const tt = new TextDecoder(Ze, {
          fatal: !0
        }), et = stringToBytes(nt);
        nt = tt.decode(et), ue = !1;
      } catch {
      }
    }
    return nt;
  }
  function Ge(Ze) {
    return ue && /[\x80-\xff]/.test(Ze) && (Ze = He("utf-8", Ze), ue && (Ze = He("iso-8859-1", Ze))), Ze;
  }
  function Xe(Ze) {
    const nt = [];
    let tt;
    const et = Ue("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
    for (; (tt = et.exec(Ze)) !== null; ) {
      let [, it, ot, at] = tt;
      if (it = parseInt(it, 10), it in nt) {
        if (it === 0)
          break;
        continue;
      }
      nt[it] = [ot, at];
    }
    const rt = [];
    for (let it = 0; it < nt.length && it in nt; ++it) {
      let [ot, at] = nt[it];
      at = Ke(at), ot && (at = unescape(at), it === 0 && (at = $e(at))), rt.push(at);
    }
    return rt.join("");
  }
  function Ke(Ze) {
    if (Ze.startsWith('"')) {
      const nt = Ze.slice(1).split('\\"');
      for (let tt = 0; tt < nt.length; ++tt) {
        const et = nt[tt].indexOf('"');
        et !== -1 && (nt[tt] = nt[tt].slice(0, et), nt.length = tt + 1), nt[tt] = nt[tt].replaceAll(/\\(.)/g, "$1");
      }
      Ze = nt.join('"');
    }
    return Ze;
  }
  function $e(Ze) {
    const nt = Ze.indexOf("'");
    if (nt === -1)
      return Ze;
    const tt = Ze.slice(0, nt), rt = Ze.slice(nt + 1).replace(/^[^']*'/, "");
    return He(tt, rt);
  }
  function Je(Ze) {
    return !Ze.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(Ze) ? Ze : Ze.replaceAll(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(nt, tt, et, rt) {
      if (et === "q" || et === "Q")
        return rt = rt.replaceAll("_", " "), rt = rt.replaceAll(/=([0-9a-fA-F]{2})/g, function(it, ot) {
          return String.fromCharCode(parseInt(ot, 16));
        }), He(tt, rt);
      try {
        rt = atob(rt);
      } catch {
      }
      return He(tt, rt);
    });
  }
  return "";
}
function validateRangeRequestCapabilities({
  getResponseHeader: me,
  isHttp: ue,
  rangeChunkSize: Qe,
  disableRange: Ue
}) {
  const He = {
    allowRangeRequests: !1,
    suggestedLength: void 0
  }, Ge = parseInt(me("Content-Length"), 10);
  return !Number.isInteger(Ge) || (He.suggestedLength = Ge, Ge <= 2 * Qe) || Ue || !ue || me("Accept-Ranges") !== "bytes" || (me("Content-Encoding") || "identity") !== "identity" || (He.allowRangeRequests = !0), He;
}
function extractFilenameFromHeader(me) {
  const ue = me("Content-Disposition");
  if (ue) {
    let Qe = getFilenameFromContentDispositionHeader(ue);
    if (Qe.includes("%"))
      try {
        Qe = decodeURIComponent(Qe);
      } catch {
      }
    if (isPdfFile(Qe))
      return Qe;
  }
  return null;
}
function createResponseStatusError(me, ue) {
  return me === 404 || me === 0 && ue.startsWith("file:") ? new MissingPDFException('Missing PDF "' + ue + '".') : new UnexpectedResponseException(`Unexpected server response (${me}) while retrieving PDF "${ue}".`, me);
}
function validateResponseStatus(me) {
  return me === 200 || me === 206;
}
function createFetchOptions(me, ue, Qe) {
  return {
    method: "GET",
    headers: me,
    signal: Qe.signal,
    mode: "cors",
    credentials: ue ? "include" : "same-origin",
    redirect: "follow"
  };
}
function createHeaders(me) {
  const ue = new Headers();
  for (const Qe in me) {
    const Ue = me[Qe];
    Ue !== void 0 && ue.append(Qe, Ue);
  }
  return ue;
}
function getArrayBuffer(me) {
  return me instanceof Uint8Array ? me.buffer : me instanceof ArrayBuffer ? me : (warn(`getArrayBuffer - unexpected data format: ${me}`), new Uint8Array(me).buffer);
}
class PDFFetchStream {
  constructor(ue) {
    this.source = ue, this.isHttp = /^https?:/i.test(ue.url), this.httpHeaders = this.isHttp && ue.httpHeaders || {}, this._fullRequestReader = null, this._rangeRequestReaders = [];
  }
  get _progressiveDataLength() {
    var ue;
    return ((ue = this._fullRequestReader) == null ? void 0 : ue._loaded) ?? 0;
  }
  getFullReader() {
    return assert(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once."), this._fullRequestReader = new PDFFetchStreamReader(this), this._fullRequestReader;
  }
  getRangeReader(ue, Qe) {
    if (Qe <= this._progressiveDataLength)
      return null;
    const Ue = new PDFFetchStreamRangeReader(this, ue, Qe);
    return this._rangeRequestReaders.push(Ue), Ue;
  }
  cancelAllRequests(ue) {
    var Qe;
    (Qe = this._fullRequestReader) == null || Qe.cancel(ue);
    for (const Ue of this._rangeRequestReaders.slice(0))
      Ue.cancel(ue);
  }
}
class PDFFetchStreamReader {
  constructor(ue) {
    this._stream = ue, this._reader = null, this._loaded = 0, this._filename = null;
    const Qe = ue.source;
    this._withCredentials = Qe.withCredentials || !1, this._contentLength = Qe.length, this._headersCapability = Promise.withResolvers(), this._disableRange = Qe.disableRange || !1, this._rangeChunkSize = Qe.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._abortController = new AbortController(), this._isStreamingSupported = !Qe.disableStream, this._isRangeSupported = !Qe.disableRange, this._headers = createHeaders(this._stream.httpHeaders);
    const Ue = Qe.url;
    fetch(Ue, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then((He) => {
      if (!validateResponseStatus(He.status))
        throw createResponseStatusError(He.status, Ue);
      this._reader = He.body.getReader(), this._headersCapability.resolve();
      const Ge = ($e) => He.headers.get($e), {
        allowRangeRequests: Xe,
        suggestedLength: Ke
      } = validateRangeRequestCapabilities({
        getResponseHeader: Ge,
        isHttp: this._stream.isHttp,
        rangeChunkSize: this._rangeChunkSize,
        disableRange: this._disableRange
      });
      this._isRangeSupported = Xe, this._contentLength = Ke || this._contentLength, this._filename = extractFilenameFromHeader(Ge), !this._isStreamingSupported && this._isRangeSupported && this.cancel(new AbortException("Streaming is disabled."));
    }).catch(this._headersCapability.reject), this.onProgress = null;
  }
  get headersReady() {
    return this._headersCapability.promise;
  }
  get filename() {
    return this._filename;
  }
  get contentLength() {
    return this._contentLength;
  }
  get isRangeSupported() {
    return this._isRangeSupported;
  }
  get isStreamingSupported() {
    return this._isStreamingSupported;
  }
  async read() {
    var Ue;
    await this._headersCapability.promise;
    const {
      value: ue,
      done: Qe
    } = await this._reader.read();
    return Qe ? {
      value: ue,
      done: Qe
    } : (this._loaded += ue.byteLength, (Ue = this.onProgress) == null || Ue.call(this, {
      loaded: this._loaded,
      total: this._contentLength
    }), {
      value: getArrayBuffer(ue),
      done: !1
    });
  }
  cancel(ue) {
    var Qe;
    (Qe = this._reader) == null || Qe.cancel(ue), this._abortController.abort();
  }
}
class PDFFetchStreamRangeReader {
  constructor(ue, Qe, Ue) {
    this._stream = ue, this._reader = null, this._loaded = 0;
    const He = ue.source;
    this._withCredentials = He.withCredentials || !1, this._readCapability = Promise.withResolvers(), this._isStreamingSupported = !He.disableStream, this._abortController = new AbortController(), this._headers = createHeaders(this._stream.httpHeaders), this._headers.append("Range", `bytes=${Qe}-${Ue - 1}`);
    const Ge = He.url;
    fetch(Ge, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then((Xe) => {
      if (!validateResponseStatus(Xe.status))
        throw createResponseStatusError(Xe.status, Ge);
      this._readCapability.resolve(), this._reader = Xe.body.getReader();
    }).catch(this._readCapability.reject), this.onProgress = null;
  }
  get isStreamingSupported() {
    return this._isStreamingSupported;
  }
  async read() {
    var Ue;
    await this._readCapability.promise;
    const {
      value: ue,
      done: Qe
    } = await this._reader.read();
    return Qe ? {
      value: ue,
      done: Qe
    } : (this._loaded += ue.byteLength, (Ue = this.onProgress) == null || Ue.call(this, {
      loaded: this._loaded
    }), {
      value: getArrayBuffer(ue),
      done: !1
    });
  }
  cancel(ue) {
    var Qe;
    (Qe = this._reader) == null || Qe.cancel(ue), this._abortController.abort();
  }
}
const OK_RESPONSE = 200, PARTIAL_CONTENT_RESPONSE = 206;
function network_getArrayBuffer(me) {
  const ue = me.response;
  return typeof ue != "string" ? ue : stringToBytes(ue).buffer;
}
class NetworkManager {
  constructor(ue, Qe = {}) {
    this.url = ue, this.isHttp = /^https?:/i.test(ue), this.httpHeaders = this.isHttp && Qe.httpHeaders || /* @__PURE__ */ Object.create(null), this.withCredentials = Qe.withCredentials || !1, this.currXhrId = 0, this.pendingRequests = /* @__PURE__ */ Object.create(null);
  }
  requestRange(ue, Qe, Ue) {
    const He = {
      begin: ue,
      end: Qe
    };
    for (const Ge in Ue)
      He[Ge] = Ue[Ge];
    return this.request(He);
  }
  requestFull(ue) {
    return this.request(ue);
  }
  request(ue) {
    const Qe = new XMLHttpRequest(), Ue = this.currXhrId++, He = this.pendingRequests[Ue] = {
      xhr: Qe
    };
    Qe.open("GET", this.url), Qe.withCredentials = this.withCredentials;
    for (const Ge in this.httpHeaders) {
      const Xe = this.httpHeaders[Ge];
      Xe !== void 0 && Qe.setRequestHeader(Ge, Xe);
    }
    return this.isHttp && "begin" in ue && "end" in ue ? (Qe.setRequestHeader("Range", `bytes=${ue.begin}-${ue.end - 1}`), He.expectedStatus = PARTIAL_CONTENT_RESPONSE) : He.expectedStatus = OK_RESPONSE, Qe.responseType = "arraybuffer", ue.onError && (Qe.onerror = function(Ge) {
      ue.onError(Qe.status);
    }), Qe.onreadystatechange = this.onStateChange.bind(this, Ue), Qe.onprogress = this.onProgress.bind(this, Ue), He.onHeadersReceived = ue.onHeadersReceived, He.onDone = ue.onDone, He.onError = ue.onError, He.onProgress = ue.onProgress, Qe.send(null), Ue;
  }
  onProgress(ue, Qe) {
    var He;
    const Ue = this.pendingRequests[ue];
    Ue && ((He = Ue.onProgress) == null || He.call(Ue, Qe));
  }
  onStateChange(ue, Qe) {
    var $e, Je, Ze;
    const Ue = this.pendingRequests[ue];
    if (!Ue)
      return;
    const He = Ue.xhr;
    if (He.readyState >= 2 && Ue.onHeadersReceived && (Ue.onHeadersReceived(), delete Ue.onHeadersReceived), He.readyState !== 4 || !(ue in this.pendingRequests))
      return;
    if (delete this.pendingRequests[ue], He.status === 0 && this.isHttp) {
      ($e = Ue.onError) == null || $e.call(Ue, He.status);
      return;
    }
    const Ge = He.status || OK_RESPONSE;
    if (!(Ge === OK_RESPONSE && Ue.expectedStatus === PARTIAL_CONTENT_RESPONSE) && Ge !== Ue.expectedStatus) {
      (Je = Ue.onError) == null || Je.call(Ue, He.status);
      return;
    }
    const Ke = network_getArrayBuffer(He);
    if (Ge === PARTIAL_CONTENT_RESPONSE) {
      const nt = He.getResponseHeader("Content-Range"), tt = /bytes (\d+)-(\d+)\/(\d+)/.exec(nt);
      Ue.onDone({
        begin: parseInt(tt[1], 10),
        chunk: Ke
      });
    } else Ke ? Ue.onDone({
      begin: 0,
      chunk: Ke
    }) : (Ze = Ue.onError) == null || Ze.call(Ue, He.status);
  }
  getRequestXhr(ue) {
    return this.pendingRequests[ue].xhr;
  }
  isPendingRequest(ue) {
    return ue in this.pendingRequests;
  }
  abortRequest(ue) {
    const Qe = this.pendingRequests[ue].xhr;
    delete this.pendingRequests[ue], Qe.abort();
  }
}
class PDFNetworkStream {
  constructor(ue) {
    this._source = ue, this._manager = new NetworkManager(ue.url, {
      httpHeaders: ue.httpHeaders,
      withCredentials: ue.withCredentials
    }), this._rangeChunkSize = ue.rangeChunkSize, this._fullRequestReader = null, this._rangeRequestReaders = [];
  }
  _onRangeRequestReaderClosed(ue) {
    const Qe = this._rangeRequestReaders.indexOf(ue);
    Qe >= 0 && this._rangeRequestReaders.splice(Qe, 1);
  }
  getFullReader() {
    return assert(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once."), this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._source), this._fullRequestReader;
  }
  getRangeReader(ue, Qe) {
    const Ue = new PDFNetworkStreamRangeRequestReader(this._manager, ue, Qe);
    return Ue.onClosed = this._onRangeRequestReaderClosed.bind(this), this._rangeRequestReaders.push(Ue), Ue;
  }
  cancelAllRequests(ue) {
    var Qe;
    (Qe = this._fullRequestReader) == null || Qe.cancel(ue);
    for (const Ue of this._rangeRequestReaders.slice(0))
      Ue.cancel(ue);
  }
}
class PDFNetworkStreamFullRequestReader {
  constructor(ue, Qe) {
    this._manager = ue;
    const Ue = {
      onHeadersReceived: this._onHeadersReceived.bind(this),
      onDone: this._onDone.bind(this),
      onError: this._onError.bind(this),
      onProgress: this._onProgress.bind(this)
    };
    this._url = Qe.url, this._fullRequestId = ue.requestFull(Ue), this._headersReceivedCapability = Promise.withResolvers(), this._disableRange = Qe.disableRange || !1, this._contentLength = Qe.length, this._rangeChunkSize = Qe.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._isStreamingSupported = !1, this._isRangeSupported = !1, this._cachedChunks = [], this._requests = [], this._done = !1, this._storedError = void 0, this._filename = null, this.onProgress = null;
  }
  _onHeadersReceived() {
    const ue = this._fullRequestId, Qe = this._manager.getRequestXhr(ue), Ue = (Xe) => Qe.getResponseHeader(Xe), {
      allowRangeRequests: He,
      suggestedLength: Ge
    } = validateRangeRequestCapabilities({
      getResponseHeader: Ue,
      isHttp: this._manager.isHttp,
      rangeChunkSize: this._rangeChunkSize,
      disableRange: this._disableRange
    });
    He && (this._isRangeSupported = !0), this._contentLength = Ge || this._contentLength, this._filename = extractFilenameFromHeader(Ue), this._isRangeSupported && this._manager.abortRequest(ue), this._headersReceivedCapability.resolve();
  }
  _onDone(ue) {
    if (ue && (this._requests.length > 0 ? this._requests.shift().resolve({
      value: ue.chunk,
      done: !1
    }) : this._cachedChunks.push(ue.chunk)), this._done = !0, !(this._cachedChunks.length > 0)) {
      for (const Qe of this._requests)
        Qe.resolve({
          value: void 0,
          done: !0
        });
      this._requests.length = 0;
    }
  }
  _onError(ue) {
    this._storedError = createResponseStatusError(ue, this._url), this._headersReceivedCapability.reject(this._storedError);
    for (const Qe of this._requests)
      Qe.reject(this._storedError);
    this._requests.length = 0, this._cachedChunks.length = 0;
  }
  _onProgress(ue) {
    var Qe;
    (Qe = this.onProgress) == null || Qe.call(this, {
      loaded: ue.loaded,
      total: ue.lengthComputable ? ue.total : this._contentLength
    });
  }
  get filename() {
    return this._filename;
  }
  get isRangeSupported() {
    return this._isRangeSupported;
  }
  get isStreamingSupported() {
    return this._isStreamingSupported;
  }
  get contentLength() {
    return this._contentLength;
  }
  get headersReady() {
    return this._headersReceivedCapability.promise;
  }
  async read() {
    if (this._storedError)
      throw this._storedError;
    if (this._cachedChunks.length > 0)
      return {
        value: this._cachedChunks.shift(),
        done: !1
      };
    if (this._done)
      return {
        value: void 0,
        done: !0
      };
    const ue = Promise.withResolvers();
    return this._requests.push(ue), ue.promise;
  }
  cancel(ue) {
    this._done = !0, this._headersReceivedCapability.reject(ue);
    for (const Qe of this._requests)
      Qe.resolve({
        value: void 0,
        done: !0
      });
    this._requests.length = 0, this._manager.isPendingRequest(this._fullRequestId) && this._manager.abortRequest(this._fullRequestId), this._fullRequestReader = null;
  }
}
class PDFNetworkStreamRangeRequestReader {
  constructor(ue, Qe, Ue) {
    this._manager = ue;
    const He = {
      onDone: this._onDone.bind(this),
      onError: this._onError.bind(this),
      onProgress: this._onProgress.bind(this)
    };
    this._url = ue.url, this._requestId = ue.requestRange(Qe, Ue, He), this._requests = [], this._queuedChunk = null, this._done = !1, this._storedError = void 0, this.onProgress = null, this.onClosed = null;
  }
  _close() {
    var ue;
    (ue = this.onClosed) == null || ue.call(this, this);
  }
  _onDone(ue) {
    const Qe = ue.chunk;
    this._requests.length > 0 ? this._requests.shift().resolve({
      value: Qe,
      done: !1
    }) : this._queuedChunk = Qe, this._done = !0;
    for (const Ue of this._requests)
      Ue.resolve({
        value: void 0,
        done: !0
      });
    this._requests.length = 0, this._close();
  }
  _onError(ue) {
    this._storedError = createResponseStatusError(ue, this._url);
    for (const Qe of this._requests)
      Qe.reject(this._storedError);
    this._requests.length = 0, this._queuedChunk = null;
  }
  _onProgress(ue) {
    var Qe;
    this.isStreamingSupported || (Qe = this.onProgress) == null || Qe.call(this, {
      loaded: ue.loaded
    });
  }
  get isStreamingSupported() {
    return !1;
  }
  async read() {
    if (this._storedError)
      throw this._storedError;
    if (this._queuedChunk !== null) {
      const Qe = this._queuedChunk;
      return this._queuedChunk = null, {
        value: Qe,
        done: !1
      };
    }
    if (this._done)
      return {
        value: void 0,
        done: !0
      };
    const ue = Promise.withResolvers();
    return this._requests.push(ue), ue.promise;
  }
  cancel(ue) {
    this._done = !0;
    for (const Qe of this._requests)
      Qe.resolve({
        value: void 0,
        done: !0
      });
    this._requests.length = 0, this._manager.isPendingRequest(this._requestId) && this._manager.abortRequest(this._requestId), this._close();
  }
}
const fileUriRegex = /^file:\/\/\/[a-zA-Z]:\//;
function parseUrl(me) {
  const ue = NodePackages.get("url"), Qe = ue.parse(me);
  return Qe.protocol === "file:" || Qe.host ? Qe : /^[a-z]:[/\\]/i.test(me) ? ue.parse(`file:///${me}`) : (Qe.host || (Qe.protocol = "file:"), Qe);
}
class PDFNodeStream {
  constructor(ue) {
    this.source = ue, this.url = parseUrl(ue.url), this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:", this.isFsUrl = this.url.protocol === "file:", this.httpHeaders = this.isHttp && ue.httpHeaders || {}, this._fullRequestReader = null, this._rangeRequestReaders = [];
  }
  get _progressiveDataLength() {
    var ue;
    return ((ue = this._fullRequestReader) == null ? void 0 : ue._loaded) ?? 0;
  }
  getFullReader() {
    return assert(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once."), this._fullRequestReader = this.isFsUrl ? new PDFNodeStreamFsFullReader(this) : new PDFNodeStreamFullReader(this), this._fullRequestReader;
  }
  getRangeReader(ue, Qe) {
    if (Qe <= this._progressiveDataLength)
      return null;
    const Ue = this.isFsUrl ? new PDFNodeStreamFsRangeReader(this, ue, Qe) : new PDFNodeStreamRangeReader(this, ue, Qe);
    return this._rangeRequestReaders.push(Ue), Ue;
  }
  cancelAllRequests(ue) {
    var Qe;
    (Qe = this._fullRequestReader) == null || Qe.cancel(ue);
    for (const Ue of this._rangeRequestReaders.slice(0))
      Ue.cancel(ue);
  }
}
class BaseFullReader {
  constructor(ue) {
    this._url = ue.url, this._done = !1, this._storedError = null, this.onProgress = null;
    const Qe = ue.source;
    this._contentLength = Qe.length, this._loaded = 0, this._filename = null, this._disableRange = Qe.disableRange || !1, this._rangeChunkSize = Qe.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._isStreamingSupported = !Qe.disableStream, this._isRangeSupported = !Qe.disableRange, this._readableStream = null, this._readCapability = Promise.withResolvers(), this._headersCapability = Promise.withResolvers();
  }
  get headersReady() {
    return this._headersCapability.promise;
  }
  get filename() {
    return this._filename;
  }
  get contentLength() {
    return this._contentLength;
  }
  get isRangeSupported() {
    return this._isRangeSupported;
  }
  get isStreamingSupported() {
    return this._isStreamingSupported;
  }
  async read() {
    var Ue;
    if (await this._readCapability.promise, this._done)
      return {
        value: void 0,
        done: !0
      };
    if (this._storedError)
      throw this._storedError;
    const ue = this._readableStream.read();
    return ue === null ? (this._readCapability = Promise.withResolvers(), this.read()) : (this._loaded += ue.length, (Ue = this.onProgress) == null || Ue.call(this, {
      loaded: this._loaded,
      total: this._contentLength
    }), {
      value: new Uint8Array(ue).buffer,
      done: !1
    });
  }
  cancel(ue) {
    if (!this._readableStream) {
      this._error(ue);
      return;
    }
    this._readableStream.destroy(ue);
  }
  _error(ue) {
    this._storedError = ue, this._readCapability.resolve();
  }
  _setReadableStream(ue) {
    this._readableStream = ue, ue.on("readable", () => {
      this._readCapability.resolve();
    }), ue.on("end", () => {
      ue.destroy(), this._done = !0, this._readCapability.resolve();
    }), ue.on("error", (Qe) => {
      this._error(Qe);
    }), !this._isStreamingSupported && this._isRangeSupported && this._error(new AbortException("streaming is disabled")), this._storedError && this._readableStream.destroy(this._storedError);
  }
}
class BaseRangeReader {
  constructor(ue) {
    this._url = ue.url, this._done = !1, this._storedError = null, this.onProgress = null, this._loaded = 0, this._readableStream = null, this._readCapability = Promise.withResolvers();
    const Qe = ue.source;
    this._isStreamingSupported = !Qe.disableStream;
  }
  get isStreamingSupported() {
    return this._isStreamingSupported;
  }
  async read() {
    var Ue;
    if (await this._readCapability.promise, this._done)
      return {
        value: void 0,
        done: !0
      };
    if (this._storedError)
      throw this._storedError;
    const ue = this._readableStream.read();
    return ue === null ? (this._readCapability = Promise.withResolvers(), this.read()) : (this._loaded += ue.length, (Ue = this.onProgress) == null || Ue.call(this, {
      loaded: this._loaded
    }), {
      value: new Uint8Array(ue).buffer,
      done: !1
    });
  }
  cancel(ue) {
    if (!this._readableStream) {
      this._error(ue);
      return;
    }
    this._readableStream.destroy(ue);
  }
  _error(ue) {
    this._storedError = ue, this._readCapability.resolve();
  }
  _setReadableStream(ue) {
    this._readableStream = ue, ue.on("readable", () => {
      this._readCapability.resolve();
    }), ue.on("end", () => {
      ue.destroy(), this._done = !0, this._readCapability.resolve();
    }), ue.on("error", (Qe) => {
      this._error(Qe);
    }), this._storedError && this._readableStream.destroy(this._storedError);
  }
}
function createRequestOptions(me, ue) {
  return {
    protocol: me.protocol,
    auth: me.auth,
    host: me.hostname,
    port: me.port,
    path: me.path,
    method: "GET",
    headers: ue
  };
}
class PDFNodeStreamFullReader extends BaseFullReader {
  constructor(ue) {
    super(ue);
    const Qe = (Ue) => {
      if (Ue.statusCode === 404) {
        const Ke = new MissingPDFException(`Missing PDF "${this._url}".`);
        this._storedError = Ke, this._headersCapability.reject(Ke);
        return;
      }
      this._headersCapability.resolve(), this._setReadableStream(Ue);
      const He = (Ke) => this._readableStream.headers[Ke.toLowerCase()], {
        allowRangeRequests: Ge,
        suggestedLength: Xe
      } = validateRangeRequestCapabilities({
        getResponseHeader: He,
        isHttp: ue.isHttp,
        rangeChunkSize: this._rangeChunkSize,
        disableRange: this._disableRange
      });
      this._isRangeSupported = Ge, this._contentLength = Xe || this._contentLength, this._filename = extractFilenameFromHeader(He);
    };
    if (this._request = null, this._url.protocol === "http:") {
      const Ue = NodePackages.get("http");
      this._request = Ue.request(createRequestOptions(this._url, ue.httpHeaders), Qe);
    } else {
      const Ue = NodePackages.get("https");
      this._request = Ue.request(createRequestOptions(this._url, ue.httpHeaders), Qe);
    }
    this._request.on("error", (Ue) => {
      this._storedError = Ue, this._headersCapability.reject(Ue);
    }), this._request.end();
  }
}
class PDFNodeStreamRangeReader extends BaseRangeReader {
  constructor(ue, Qe, Ue) {
    super(ue), this._httpHeaders = {};
    for (const Ge in ue.httpHeaders) {
      const Xe = ue.httpHeaders[Ge];
      Xe !== void 0 && (this._httpHeaders[Ge] = Xe);
    }
    this._httpHeaders.Range = `bytes=${Qe}-${Ue - 1}`;
    const He = (Ge) => {
      if (Ge.statusCode === 404) {
        const Xe = new MissingPDFException(`Missing PDF "${this._url}".`);
        this._storedError = Xe;
        return;
      }
      this._setReadableStream(Ge);
    };
    if (this._request = null, this._url.protocol === "http:") {
      const Ge = NodePackages.get("http");
      this._request = Ge.request(createRequestOptions(this._url, this._httpHeaders), He);
    } else {
      const Ge = NodePackages.get("https");
      this._request = Ge.request(createRequestOptions(this._url, this._httpHeaders), He);
    }
    this._request.on("error", (Ge) => {
      this._storedError = Ge;
    }), this._request.end();
  }
}
class PDFNodeStreamFsFullReader extends BaseFullReader {
  constructor(ue) {
    super(ue);
    let Qe = decodeURIComponent(this._url.path);
    fileUriRegex.test(this._url.href) && (Qe = Qe.replace(/^\//, ""));
    const Ue = NodePackages.get("fs");
    Ue.promises.lstat(Qe).then((He) => {
      this._contentLength = He.size, this._setReadableStream(Ue.createReadStream(Qe)), this._headersCapability.resolve();
    }, (He) => {
      He.code === "ENOENT" && (He = new MissingPDFException(`Missing PDF "${Qe}".`)), this._storedError = He, this._headersCapability.reject(He);
    });
  }
}
class PDFNodeStreamFsRangeReader extends BaseRangeReader {
  constructor(ue, Qe, Ue) {
    super(ue);
    let He = decodeURIComponent(this._url.path);
    fileUriRegex.test(this._url.href) && (He = He.replace(/^\//, ""));
    const Ge = NodePackages.get("fs");
    this._setReadableStream(Ge.createReadStream(He, {
      start: Qe,
      end: Ue - 1
    }));
  }
}
const MAX_TEXT_DIVS_TO_RENDER = 1e5, DEFAULT_FONT_SIZE = 30, DEFAULT_FONT_ASCENT = 0.8;
var HA, ls, Ui, O0, N0, fc, Bo, D0, P0, hc, Pu, ku, ds, _u, k0, Lu, pc, _0, L0, Hi, Ac, gc, Mu, Go, Eg, Cg, qh, bs, b2, vg;
let TextLayer$1 = (Hi = class {
  constructor({
    textContentSource: ue,
    container: Qe,
    viewport: Ue
  }) {
    tn(this, Go);
    tn(this, ls, Promise.withResolvers());
    tn(this, Ui, null);
    tn(this, O0, !1);
    tn(this, N0, !!((HA = globalThis.FontInspector) != null && HA.enabled));
    tn(this, fc, null);
    tn(this, Bo, null);
    tn(this, D0, 0);
    tn(this, P0, 0);
    tn(this, hc, null);
    tn(this, Pu, null);
    tn(this, ku, 0);
    tn(this, ds, 0);
    tn(this, _u, /* @__PURE__ */ Object.create(null));
    tn(this, k0, []);
    tn(this, Lu, null);
    tn(this, pc, []);
    tn(this, _0, /* @__PURE__ */ new WeakMap());
    tn(this, L0, null);
    if (ue instanceof ReadableStream)
      Zt(this, Lu, ue);
    else if (typeof ue == "object")
      Zt(this, Lu, new ReadableStream({
        start($e) {
          $e.enqueue(ue), $e.close();
        }
      }));
    else
      throw new Error('No "textContentSource" parameter specified.');
    Zt(this, Ui, Zt(this, Pu, Qe)), Zt(this, ds, Ue.scale * (globalThis.devicePixelRatio || 1)), Zt(this, ku, Ue.rotation), Zt(this, Bo, {
      prevFontSize: null,
      prevFontFamily: null,
      div: null,
      properties: null,
      ctx: null
    });
    const {
      pageWidth: He,
      pageHeight: Ge,
      pageX: Xe,
      pageY: Ke
    } = Ue.rawDims;
    Zt(this, L0, [1, 0, 0, -1, -Xe, Ke + Ge]), Zt(this, P0, He), Zt(this, D0, Ge), setLayerDimensions(Qe, Ue), xt(this, ls).promise.catch(() => {
    }).then(() => {
      xt(Hi, Mu).delete(this), Zt(this, Bo, null), Zt(this, _u, null);
    });
  }
  render() {
    const ue = () => {
      xt(this, hc).read().then(({
        value: Qe,
        done: Ue
      }) => {
        if (Ue) {
          xt(this, ls).resolve();
          return;
        }
        xt(this, fc) ?? Zt(this, fc, Qe.lang), Object.assign(xt(this, _u), Qe.styles), en(this, Go, Eg).call(this, Qe.items), ue();
      }, xt(this, ls).reject);
    };
    return Zt(this, hc, xt(this, Lu).getReader()), xt(Hi, Mu).add(this), ue(), xt(this, ls).promise;
  }
  update({
    viewport: ue,
    onBefore: Qe = null
  }) {
    var Ge;
    const Ue = ue.scale * (globalThis.devicePixelRatio || 1), He = ue.rotation;
    if (He !== xt(this, ku) && (Qe == null || Qe(), Zt(this, ku, He), setLayerDimensions(xt(this, Pu), {
      rotation: He
    })), Ue !== xt(this, ds)) {
      Qe == null || Qe(), Zt(this, ds, Ue);
      const Xe = {
        prevFontSize: null,
        prevFontFamily: null,
        div: null,
        properties: null,
        ctx: en(Ge = Hi, bs, b2).call(Ge, xt(this, fc))
      };
      for (const Ke of xt(this, pc))
        Xe.properties = xt(this, _0).get(Ke), Xe.div = Ke, en(this, Go, qh).call(this, Xe);
    }
  }
  cancel() {
    var Qe;
    const ue = new AbortException("TextLayer task cancelled.");
    (Qe = xt(this, hc)) == null || Qe.cancel(ue).catch(() => {
    }), Zt(this, hc, null), xt(this, ls).reject(ue);
  }
  get textDivs() {
    return xt(this, pc);
  }
  get textContentItemsStr() {
    return xt(this, k0);
  }
  static cleanup() {
    if (!(xt(this, Mu).size > 0)) {
      xt(this, Ac).clear();
      for (const {
        canvas: ue
      } of xt(this, gc).values())
        ue.remove();
      xt(this, gc).clear();
    }
  }
}, ls = new WeakMap(), Ui = new WeakMap(), O0 = new WeakMap(), N0 = new WeakMap(), fc = new WeakMap(), Bo = new WeakMap(), D0 = new WeakMap(), P0 = new WeakMap(), hc = new WeakMap(), Pu = new WeakMap(), ku = new WeakMap(), ds = new WeakMap(), _u = new WeakMap(), k0 = new WeakMap(), Lu = new WeakMap(), pc = new WeakMap(), _0 = new WeakMap(), L0 = new WeakMap(), Ac = new WeakMap(), gc = new WeakMap(), Mu = new WeakMap(), Go = new WeakSet(), Eg = function(ue) {
  var He, Ge;
  if (xt(this, O0))
    return;
  (Ge = xt(this, Bo)).ctx || (Ge.ctx = en(He = Hi, bs, b2).call(He, xt(this, fc)));
  const Qe = xt(this, pc), Ue = xt(this, k0);
  for (const Xe of ue) {
    if (Qe.length > MAX_TEXT_DIVS_TO_RENDER) {
      warn("Ignoring additional textDivs for performance reasons."), Zt(this, O0, !0);
      return;
    }
    if (Xe.str === void 0) {
      if (Xe.type === "beginMarkedContentProps" || Xe.type === "beginMarkedContent") {
        const Ke = xt(this, Ui);
        Zt(this, Ui, document.createElement("span")), xt(this, Ui).classList.add("markedContent"), Xe.id !== null && xt(this, Ui).setAttribute("id", `${Xe.id}`), Ke.append(xt(this, Ui));
      } else Xe.type === "endMarkedContent" && Zt(this, Ui, xt(this, Ui).parentNode);
      continue;
    }
    Ue.push(Xe.str), en(this, Go, Cg).call(this, Xe);
  }
}, Cg = function(ue) {
  var it;
  const Qe = document.createElement("span"), Ue = {
    angle: 0,
    canvasWidth: 0,
    hasText: ue.str !== "",
    hasEOL: ue.hasEOL,
    fontSize: 0
  };
  xt(this, pc).push(Qe);
  const He = Util.transform(xt(this, L0), ue.transform);
  let Ge = Math.atan2(He[1], He[0]);
  const Xe = xt(this, _u)[ue.fontName];
  Xe.vertical && (Ge += Math.PI / 2);
  const Ke = xt(this, N0) && Xe.fontSubstitution || Xe.fontFamily, $e = Math.hypot(He[2], He[3]), Je = $e * en(it = Hi, bs, vg).call(it, Ke, xt(this, fc));
  let Ze, nt;
  Ge === 0 ? (Ze = He[4], nt = He[5] - Je) : (Ze = He[4] + Je * Math.sin(Ge), nt = He[5] - Je * Math.cos(Ge));
  const tt = "calc(var(--scale-factor)*", et = Qe.style;
  xt(this, Ui) === xt(this, Pu) ? (et.left = `${(100 * Ze / xt(this, P0)).toFixed(2)}%`, et.top = `${(100 * nt / xt(this, D0)).toFixed(2)}%`) : (et.left = `${tt}${Ze.toFixed(2)}px)`, et.top = `${tt}${nt.toFixed(2)}px)`), et.fontSize = `${tt}${$e.toFixed(2)}px)`, et.fontFamily = Ke, Ue.fontSize = $e, Qe.setAttribute("role", "presentation"), Qe.textContent = ue.str, Qe.dir = ue.dir, xt(this, N0) && (Qe.dataset.fontName = Xe.fontSubstitutionLoadedName || ue.fontName), Ge !== 0 && (Ue.angle = Ge * (180 / Math.PI));
  let rt = !1;
  if (ue.str.length > 1)
    rt = !0;
  else if (ue.str !== " " && ue.transform[0] !== ue.transform[3]) {
    const ot = Math.abs(ue.transform[0]), at = Math.abs(ue.transform[3]);
    ot !== at && Math.max(ot, at) / Math.min(ot, at) > 1.5 && (rt = !0);
  }
  if (rt && (Ue.canvasWidth = Xe.vertical ? ue.height : ue.width), xt(this, _0).set(Qe, Ue), xt(this, Bo).div = Qe, xt(this, Bo).properties = Ue, en(this, Go, qh).call(this, xt(this, Bo)), Ue.hasText && xt(this, Ui).append(Qe), Ue.hasEOL) {
    const ot = document.createElement("br");
    ot.setAttribute("role", "presentation"), xt(this, Ui).append(ot);
  }
}, qh = function(ue) {
  const {
    div: Qe,
    properties: Ue,
    ctx: He,
    prevFontSize: Ge,
    prevFontFamily: Xe
  } = ue, {
    style: Ke
  } = Qe;
  let $e = "";
  if (Ue.canvasWidth !== 0 && Ue.hasText) {
    const {
      fontFamily: Je
    } = Ke, {
      canvasWidth: Ze,
      fontSize: nt
    } = Ue;
    (Ge !== nt || Xe !== Je) && (He.font = `${nt * xt(this, ds)}px ${Je}`, ue.prevFontSize = nt, ue.prevFontFamily = Je);
    const {
      width: tt
    } = He.measureText(Qe.textContent);
    tt > 0 && ($e = `scaleX(${Ze * xt(this, ds) / tt})`);
  }
  Ue.angle !== 0 && ($e = `rotate(${Ue.angle}deg) ${$e}`), $e.length > 0 && (Ke.transform = $e);
}, bs = new WeakSet(), b2 = function(ue = null) {
  let Qe = xt(this, gc).get(ue || (ue = ""));
  if (!Qe) {
    const Ue = document.createElement("canvas");
    Ue.className = "hiddenCanvasElement", Ue.lang = ue, document.body.append(Ue), Qe = Ue.getContext("2d", {
      alpha: !1
    }), xt(this, gc).set(ue, Qe);
  }
  return Qe;
}, vg = function(ue, Qe) {
  const Ue = xt(this, Ac).get(ue);
  if (Ue)
    return Ue;
  const He = en(this, bs, b2).call(this, Qe), Ge = He.font;
  He.canvas.width = He.canvas.height = DEFAULT_FONT_SIZE, He.font = `${DEFAULT_FONT_SIZE}px ${ue}`;
  const Xe = He.measureText("");
  let Ke = Xe.fontBoundingBoxAscent, $e = Math.abs(Xe.fontBoundingBoxDescent);
  if (Ke) {
    const nt = Ke / (Ke + $e);
    return xt(this, Ac).set(ue, nt), He.canvas.width = He.canvas.height = 0, He.font = Ge, nt;
  }
  He.strokeStyle = "red", He.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE), He.strokeText("g", 0, 0);
  let Je = He.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
  $e = 0;
  for (let nt = Je.length - 1 - 3; nt >= 0; nt -= 4)
    if (Je[nt] > 0) {
      $e = Math.ceil(nt / 4 / DEFAULT_FONT_SIZE);
      break;
    }
  He.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE), He.strokeText("A", 0, DEFAULT_FONT_SIZE), Je = He.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data, Ke = 0;
  for (let nt = 0, tt = Je.length; nt < tt; nt += 4)
    if (Je[nt] > 0) {
      Ke = DEFAULT_FONT_SIZE - Math.floor(nt / 4 / DEFAULT_FONT_SIZE);
      break;
    }
  He.canvas.width = He.canvas.height = 0, He.font = Ge;
  const Ze = Ke ? Ke / (Ke + $e) : DEFAULT_FONT_ASCENT;
  return xt(this, Ac).set(ue, Ze), Ze;
}, tn(Hi, bs), tn(Hi, Ac, /* @__PURE__ */ new Map()), tn(Hi, gc, /* @__PURE__ */ new Map()), tn(Hi, Mu, /* @__PURE__ */ new Set()), Hi);
function renderTextLayer() {
  deprecated("`renderTextLayer`, please use `TextLayer` instead.");
  const {
    textContentSource: me,
    container: ue,
    viewport: Qe,
    ...Ue
  } = arguments[0], He = Object.keys(Ue);
  He.length > 0 && warn("Ignoring `renderTextLayer` parameters: " + He.join(", "));
  const Ge = new TextLayer$1({
    textContentSource: me,
    container: ue,
    viewport: Qe
  }), {
    textDivs: Xe,
    textContentItemsStr: Ke
  } = Ge;
  return {
    promise: Ge.render(),
    textDivs: Xe,
    textContentItemsStr: Ke
  };
}
function updateTextLayer() {
  deprecated("`updateTextLayer`, please use `TextLayer` instead.");
}
class XfaText {
  static textContent(ue) {
    const Qe = [], Ue = {
      items: Qe,
      styles: /* @__PURE__ */ Object.create(null)
    };
    function He(Ge) {
      var $e;
      if (!Ge)
        return;
      let Xe = null;
      const Ke = Ge.name;
      if (Ke === "#text")
        Xe = Ge.value;
      else if (XfaText.shouldBuildText(Ke))
        ($e = Ge == null ? void 0 : Ge.attributes) != null && $e.textContent ? Xe = Ge.attributes.textContent : Ge.value && (Xe = Ge.value);
      else return;
      if (Xe !== null && Qe.push({
        str: Xe
      }), !!Ge.children)
        for (const Je of Ge.children)
          He(Je);
    }
    return He(ue), Ue;
  }
  static shouldBuildText(ue) {
    return !(ue === "textarea" || ue === "input" || ue === "option" || ue === "select");
  }
}
const DEFAULT_RANGE_CHUNK_SIZE = 65536, RENDERING_CANCELLED_TIMEOUT = 100, DELAYED_CLEANUP_TIMEOUT = 5e3, DefaultCanvasFactory = isNodeJS ? NodeCanvasFactory : DOMCanvasFactory, DefaultCMapReaderFactory = isNodeJS ? NodeCMapReaderFactory : DOMCMapReaderFactory, DefaultFilterFactory = isNodeJS ? NodeFilterFactory : DOMFilterFactory, DefaultStandardFontDataFactory = isNodeJS ? NodeStandardFontDataFactory : DOMStandardFontDataFactory;
function getDocument$1(me) {
  if (typeof me == "string" || me instanceof URL ? me = {
    url: me
  } : (me instanceof ArrayBuffer || ArrayBuffer.isView(me)) && (me = {
    data: me
  }), typeof me != "object")
    throw new Error("Invalid parameter in getDocument, need parameter object.");
  if (!me.url && !me.data && !me.range)
    throw new Error("Invalid parameter object: need either .data, .range or .url");
  const ue = new PDFDocumentLoadingTask(), {
    docId: Qe
  } = ue, Ue = me.url ? getUrlProp(me.url) : null, He = me.data ? getDataProp(me.data) : null, Ge = me.httpHeaders || null, Xe = me.withCredentials === !0, Ke = me.password ?? null, $e = me.range instanceof PDFDataRangeTransport$1 ? me.range : null, Je = Number.isInteger(me.rangeChunkSize) && me.rangeChunkSize > 0 ? me.rangeChunkSize : DEFAULT_RANGE_CHUNK_SIZE;
  let Ze = me.worker instanceof PDFWorker ? me.worker : null;
  const nt = me.verbosity, tt = typeof me.docBaseUrl == "string" && !isDataScheme(me.docBaseUrl) ? me.docBaseUrl : null, et = typeof me.cMapUrl == "string" ? me.cMapUrl : null, rt = me.cMapPacked !== !1, it = me.CMapReaderFactory || DefaultCMapReaderFactory, ot = typeof me.standardFontDataUrl == "string" ? me.standardFontDataUrl : null, at = me.StandardFontDataFactory || DefaultStandardFontDataFactory, st = me.stopAtErrors !== !0, ut = Number.isInteger(me.maxImageSize) && me.maxImageSize > -1 ? me.maxImageSize : -1, lt = me.isEvalSupported !== !1, dt = typeof me.isOffscreenCanvasSupported == "boolean" ? me.isOffscreenCanvasSupported : !isNodeJS, At = Number.isInteger(me.canvasMaxAreaInBytes) ? me.canvasMaxAreaInBytes : -1, pt = typeof me.disableFontFace == "boolean" ? me.disableFontFace : isNodeJS, gt = me.fontExtraProperties === !0, wt = me.enableXfa === !0, Bt = me.ownerDocument || globalThis.document, Tt = me.disableRange === !0, yt = me.disableStream === !0, Ct = me.disableAutoFetch === !0, ht = me.pdfBug === !0, It = $e ? $e.length : me.length ?? NaN, vt = typeof me.useSystemFonts == "boolean" ? me.useSystemFonts : !isNodeJS && !pt, Et = typeof me.useWorkerFetch == "boolean" ? me.useWorkerFetch : it === DOMCMapReaderFactory && at === DOMStandardFontDataFactory && et && ot && isValidFetchUrl(et, document.baseURI) && isValidFetchUrl(ot, document.baseURI), bt = me.canvasFactory || new DefaultCanvasFactory({
    ownerDocument: Bt
  }), Rt = me.filterFactory || new DefaultFilterFactory({
    docId: Qe,
    ownerDocument: Bt
  }), St = null;
  setVerbosityLevel(nt);
  const kt = {
    canvasFactory: bt,
    filterFactory: Rt
  };
  if (Et || (kt.cMapReaderFactory = new it({
    baseUrl: et,
    isCompressed: rt
  }), kt.standardFontDataFactory = new at({
    baseUrl: ot
  })), !Ze) {
    const Qt = {
      verbosity: nt,
      port: GlobalWorkerOptions.workerPort
    };
    Ze = Qt.port ? PDFWorker.fromPort(Qt) : new PDFWorker(Qt), ue._worker = Ze;
  }
  const jt = {
    docId: Qe,
    apiVersion: "4.3.136",
    data: He,
    password: Ke,
    disableAutoFetch: Ct,
    rangeChunkSize: Je,
    length: It,
    docBaseUrl: tt,
    enableXfa: wt,
    evaluatorOptions: {
      maxImageSize: ut,
      disableFontFace: pt,
      ignoreErrors: st,
      isEvalSupported: lt,
      isOffscreenCanvasSupported: dt,
      canvasMaxAreaInBytes: At,
      fontExtraProperties: gt,
      useSystemFonts: vt,
      cMapUrl: Et ? et : null,
      standardFontDataUrl: Et ? ot : null
    }
  }, Pt = {
    disableFontFace: pt,
    fontExtraProperties: gt,
    ownerDocument: Bt,
    pdfBug: ht,
    styleElement: St,
    loadingParams: {
      disableAutoFetch: Ct,
      enableXfa: wt
    }
  };
  return Ze.promise.then(function() {
    if (ue.destroyed)
      throw new Error("Loading aborted");
    if (Ze.destroyed)
      throw new Error("Worker was destroyed");
    const Qt = Ze.messageHandler.sendWithPromise("GetDocRequest", jt, He ? [He.buffer] : null);
    let qt;
    return $e ? qt = new PDFDataTransportStream($e, {
      disableRange: Tt,
      disableStream: yt
    }) : He || (qt = ((Yt) => isNodeJS ? function() {
      return typeof fetch < "u" && typeof Response < "u" && "body" in Response.prototype;
    }() && isValidFetchUrl(Yt.url) ? new PDFFetchStream(Yt) : new PDFNodeStream(Yt) : isValidFetchUrl(Yt.url) ? new PDFFetchStream(Yt) : new PDFNetworkStream(Yt))({
      url: Ue,
      length: It,
      httpHeaders: Ge,
      withCredentials: Xe,
      rangeChunkSize: Je,
      disableRange: Tt,
      disableStream: yt
    })), Qt.then((_t) => {
      if (ue.destroyed)
        throw new Error("Loading aborted");
      if (Ze.destroyed)
        throw new Error("Worker was destroyed");
      const Yt = new MessageHandler(Qe, _t, Ze.port), Xt = new WorkerTransport(Yt, ue, qt, Pt, kt);
      ue._transport = Xt, Yt.send("Ready", null);
    });
  }).catch(ue._capability.reject), ue;
}
function getUrlProp(me) {
  if (me instanceof URL)
    return me.href;
  try {
    return new URL(me, window.location).href;
  } catch {
    if (isNodeJS && typeof me == "string")
      return me;
  }
  throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
}
function getDataProp(me) {
  if (isNodeJS && typeof Buffer < "u" && me instanceof Buffer)
    throw new Error("Please provide binary data as `Uint8Array`, rather than `Buffer`.");
  if (me instanceof Uint8Array && me.byteLength === me.buffer.byteLength)
    return me;
  if (typeof me == "string")
    return stringToBytes(me);
  if (me instanceof ArrayBuffer || ArrayBuffer.isView(me) || typeof me == "object" && !isNaN(me == null ? void 0 : me.length))
    return new Uint8Array(me);
  throw new Error("Invalid PDF binary data: either TypedArray, string, or array-like object is expected in the data property.");
}
function isRefProxy(me) {
  return typeof me == "object" && Number.isInteger(me == null ? void 0 : me.num) && me.num >= 0 && Number.isInteger(me == null ? void 0 : me.gen) && me.gen >= 0;
}
var Z2;
const ef = class ef {
  constructor() {
    this._capability = Promise.withResolvers(), this._transport = null, this._worker = null, this.docId = `d${Xi(ef, Z2)._++}`, this.destroyed = !1, this.onPassword = null, this.onProgress = null;
  }
  get promise() {
    return this._capability.promise;
  }
  async destroy() {
    var ue, Qe, Ue;
    this.destroyed = !0;
    try {
      (ue = this._worker) != null && ue.port && (this._worker._pendingDestroy = !0), await ((Qe = this._transport) == null ? void 0 : Qe.destroy());
    } catch (He) {
      throw (Ue = this._worker) != null && Ue.port && delete this._worker._pendingDestroy, He;
    }
    this._transport = null, this._worker && (this._worker.destroy(), this._worker = null);
  }
};
Z2 = new WeakMap(), tn(ef, Z2, 0);
let PDFDocumentLoadingTask = ef, PDFDataRangeTransport$1 = class {
  constructor(ue, Qe, Ue = !1, He = null) {
    this.length = ue, this.initialData = Qe, this.progressiveDone = Ue, this.contentDispositionFilename = He, this._rangeListeners = [], this._progressListeners = [], this._progressiveReadListeners = [], this._progressiveDoneListeners = [], this._readyCapability = Promise.withResolvers();
  }
  addRangeListener(ue) {
    this._rangeListeners.push(ue);
  }
  addProgressListener(ue) {
    this._progressListeners.push(ue);
  }
  addProgressiveReadListener(ue) {
    this._progressiveReadListeners.push(ue);
  }
  addProgressiveDoneListener(ue) {
    this._progressiveDoneListeners.push(ue);
  }
  onDataRange(ue, Qe) {
    for (const Ue of this._rangeListeners)
      Ue(ue, Qe);
  }
  onDataProgress(ue, Qe) {
    this._readyCapability.promise.then(() => {
      for (const Ue of this._progressListeners)
        Ue(ue, Qe);
    });
  }
  onDataProgressiveRead(ue) {
    this._readyCapability.promise.then(() => {
      for (const Qe of this._progressiveReadListeners)
        Qe(ue);
    });
  }
  onDataProgressiveDone() {
    this._readyCapability.promise.then(() => {
      for (const ue of this._progressiveDoneListeners)
        ue();
    });
  }
  transportReady() {
    this._readyCapability.resolve();
  }
  requestDataRange(ue, Qe) {
    unreachable("Abstract method PDFDataRangeTransport.requestDataRange");
  }
  abort() {
  }
};
class PDFDocumentProxy {
  constructor(ue, Qe) {
    this._pdfInfo = ue, this._transport = Qe;
  }
  get annotationStorage() {
    return this._transport.annotationStorage;
  }
  get filterFactory() {
    return this._transport.filterFactory;
  }
  get numPages() {
    return this._pdfInfo.numPages;
  }
  get fingerprints() {
    return this._pdfInfo.fingerprints;
  }
  get isPureXfa() {
    return shadow(this, "isPureXfa", !!this._transport._htmlForXfa);
  }
  get allXfaHtml() {
    return this._transport._htmlForXfa;
  }
  getPage(ue) {
    return this._transport.getPage(ue);
  }
  getPageIndex(ue) {
    return this._transport.getPageIndex(ue);
  }
  getDestinations() {
    return this._transport.getDestinations();
  }
  getDestination(ue) {
    return this._transport.getDestination(ue);
  }
  getPageLabels() {
    return this._transport.getPageLabels();
  }
  getPageLayout() {
    return this._transport.getPageLayout();
  }
  getPageMode() {
    return this._transport.getPageMode();
  }
  getViewerPreferences() {
    return this._transport.getViewerPreferences();
  }
  getOpenAction() {
    return this._transport.getOpenAction();
  }
  getAttachments() {
    return this._transport.getAttachments();
  }
  getJSActions() {
    return this._transport.getDocJSActions();
  }
  getOutline() {
    return this._transport.getOutline();
  }
  getOptionalContentConfig({
    intent: ue = "display"
  } = {}) {
    const {
      renderingIntent: Qe
    } = this._transport.getRenderingIntent(ue);
    return this._transport.getOptionalContentConfig(Qe);
  }
  getPermissions() {
    return this._transport.getPermissions();
  }
  getMetadata() {
    return this._transport.getMetadata();
  }
  getMarkInfo() {
    return this._transport.getMarkInfo();
  }
  getData() {
    return this._transport.getData();
  }
  saveDocument() {
    return this._transport.saveDocument();
  }
  getDownloadInfo() {
    return this._transport.downloadInfoCapability.promise;
  }
  cleanup(ue = !1) {
    return this._transport.startCleanup(ue || this.isPureXfa);
  }
  destroy() {
    return this.loadingTask.destroy();
  }
  cachedPageNumber(ue) {
    return this._transport.cachedPageNumber(ue);
  }
  get loadingParams() {
    return this._transport.loadingParams;
  }
  get loadingTask() {
    return this._transport.loadingTask;
  }
  getFieldObjects() {
    return this._transport.getFieldObjects();
  }
  hasJSActions() {
    return this._transport.hasJSActions();
  }
  getCalculationOrderIds() {
    return this._transport.getCalculationOrderIds();
  }
}
var fs, Ro, Aa, pu, S2;
class PDFPageProxy {
  constructor(ue, Qe, Ue, He = !1) {
    tn(this, Aa);
    tn(this, fs, null);
    tn(this, Ro, !1);
    this._pageIndex = ue, this._pageInfo = Qe, this._transport = Ue, this._stats = He ? new StatTimer() : null, this._pdfBug = He, this.commonObjs = Ue.commonObjs, this.objs = new PDFObjects(), this._maybeCleanupAfterRender = !1, this._intentStates = /* @__PURE__ */ new Map(), this.destroyed = !1;
  }
  get pageNumber() {
    return this._pageIndex + 1;
  }
  get rotate() {
    return this._pageInfo.rotate;
  }
  get ref() {
    return this._pageInfo.ref;
  }
  get userUnit() {
    return this._pageInfo.userUnit;
  }
  get view() {
    return this._pageInfo.view;
  }
  getViewport({
    scale: ue,
    rotation: Qe = this.rotate,
    offsetX: Ue = 0,
    offsetY: He = 0,
    dontFlip: Ge = !1
  } = {}) {
    return new PageViewport({
      viewBox: this.view,
      scale: ue,
      rotation: Qe,
      offsetX: Ue,
      offsetY: He,
      dontFlip: Ge
    });
  }
  getAnnotations({
    intent: ue = "display"
  } = {}) {
    const {
      renderingIntent: Qe
    } = this._transport.getRenderingIntent(ue);
    return this._transport.getAnnotations(this._pageIndex, Qe);
  }
  getJSActions() {
    return this._transport.getPageJSActions(this._pageIndex);
  }
  get filterFactory() {
    return this._transport.filterFactory;
  }
  get isPureXfa() {
    return shadow(this, "isPureXfa", !!this._transport._htmlForXfa);
  }
  async getXfa() {
    var ue;
    return ((ue = this._transport._htmlForXfa) == null ? void 0 : ue.children[this._pageIndex]) || null;
  }
  render({
    canvasContext: ue,
    viewport: Qe,
    intent: Ue = "display",
    annotationMode: He = AnnotationMode.ENABLE,
    transform: Ge = null,
    background: Xe = null,
    optionalContentConfigPromise: Ke = null,
    annotationCanvasMap: $e = null,
    pageColors: Je = null,
    printAnnotationStorage: Ze = null
  }) {
    var ut, lt;
    (ut = this._stats) == null || ut.time("Overall");
    const nt = this._transport.getRenderingIntent(Ue, He, Ze), {
      renderingIntent: tt,
      cacheKey: et
    } = nt;
    Zt(this, Ro, !1), en(this, Aa, S2).call(this), Ke || (Ke = this._transport.getOptionalContentConfig(tt));
    let rt = this._intentStates.get(et);
    rt || (rt = /* @__PURE__ */ Object.create(null), this._intentStates.set(et, rt)), rt.streamReaderCancelTimeout && (clearTimeout(rt.streamReaderCancelTimeout), rt.streamReaderCancelTimeout = null);
    const it = !!(tt & RenderingIntentFlag.PRINT);
    rt.displayReadyCapability || (rt.displayReadyCapability = Promise.withResolvers(), rt.operatorList = {
      fnArray: [],
      argsArray: [],
      lastChunk: !1,
      separateAnnots: null
    }, (lt = this._stats) == null || lt.time("Page Request"), this._pumpOperatorList(nt));
    const ot = (dt) => {
      var At;
      rt.renderTasks.delete(at), (this._maybeCleanupAfterRender || it) && Zt(this, Ro, !0), en(this, Aa, pu).call(this, !it), dt ? (at.capability.reject(dt), this._abortOperatorList({
        intentState: rt,
        reason: dt instanceof Error ? dt : new Error(dt)
      })) : at.capability.resolve(), this._stats && (this._stats.timeEnd("Rendering"), this._stats.timeEnd("Overall"), (At = globalThis.Stats) != null && At.enabled && globalThis.Stats.add(this.pageNumber, this._stats));
    }, at = new InternalRenderTask({
      callback: ot,
      params: {
        canvasContext: ue,
        viewport: Qe,
        transform: Ge,
        background: Xe
      },
      objs: this.objs,
      commonObjs: this.commonObjs,
      annotationCanvasMap: $e,
      operatorList: rt.operatorList,
      pageIndex: this._pageIndex,
      canvasFactory: this._transport.canvasFactory,
      filterFactory: this._transport.filterFactory,
      useRequestAnimationFrame: !it,
      pdfBug: this._pdfBug,
      pageColors: Je
    });
    (rt.renderTasks || (rt.renderTasks = /* @__PURE__ */ new Set())).add(at);
    const st = at.task;
    return Promise.all([rt.displayReadyCapability.promise, Ke]).then(([dt, At]) => {
      var pt;
      if (this.destroyed) {
        ot();
        return;
      }
      if ((pt = this._stats) == null || pt.time("Rendering"), !(At.renderingIntent & tt))
        throw new Error("Must use the same `intent`-argument when calling the `PDFPageProxy.render` and `PDFDocumentProxy.getOptionalContentConfig` methods.");
      at.initializeGraphics({
        transparency: dt,
        optionalContentConfig: At
      }), at.operatorListChanged();
    }).catch(ot), st;
  }
  getOperatorList({
    intent: ue = "display",
    annotationMode: Qe = AnnotationMode.ENABLE,
    printAnnotationStorage: Ue = null
  } = {}) {
    var $e;
    function He() {
      Xe.operatorList.lastChunk && (Xe.opListReadCapability.resolve(Xe.operatorList), Xe.renderTasks.delete(Ke));
    }
    const Ge = this._transport.getRenderingIntent(ue, Qe, Ue, !0);
    let Xe = this._intentStates.get(Ge.cacheKey);
    Xe || (Xe = /* @__PURE__ */ Object.create(null), this._intentStates.set(Ge.cacheKey, Xe));
    let Ke;
    return Xe.opListReadCapability || (Ke = /* @__PURE__ */ Object.create(null), Ke.operatorListChanged = He, Xe.opListReadCapability = Promise.withResolvers(), (Xe.renderTasks || (Xe.renderTasks = /* @__PURE__ */ new Set())).add(Ke), Xe.operatorList = {
      fnArray: [],
      argsArray: [],
      lastChunk: !1,
      separateAnnots: null
    }, ($e = this._stats) == null || $e.time("Page Request"), this._pumpOperatorList(Ge)), Xe.opListReadCapability.promise;
  }
  streamTextContent({
    includeMarkedContent: ue = !1,
    disableNormalization: Qe = !1
  } = {}) {
    return this._transport.messageHandler.sendWithStream("GetTextContent", {
      pageIndex: this._pageIndex,
      includeMarkedContent: ue === !0,
      disableNormalization: Qe === !0
    }, {
      highWaterMark: 100,
      size(He) {
        return He.items.length;
      }
    });
  }
  getTextContent(ue = {}) {
    if (this._transport._htmlForXfa)
      return this.getXfa().then((Ue) => XfaText.textContent(Ue));
    const Qe = this.streamTextContent(ue);
    return new Promise(function(Ue, He) {
      function Ge() {
        Xe.read().then(function({
          value: $e,
          done: Je
        }) {
          if (Je) {
            Ue(Ke);
            return;
          }
          Ke.lang ?? (Ke.lang = $e.lang), Object.assign(Ke.styles, $e.styles), Ke.items.push(...$e.items), Ge();
        }, He);
      }
      const Xe = Qe.getReader(), Ke = {
        items: [],
        styles: /* @__PURE__ */ Object.create(null),
        lang: null
      };
      Ge();
    });
  }
  getStructTree() {
    return this._transport.getStructTree(this._pageIndex);
  }
  _destroy() {
    this.destroyed = !0;
    const ue = [];
    for (const Qe of this._intentStates.values())
      if (this._abortOperatorList({
        intentState: Qe,
        reason: new Error("Page was destroyed."),
        force: !0
      }), !Qe.opListReadCapability)
        for (const Ue of Qe.renderTasks)
          ue.push(Ue.completed), Ue.cancel();
    return this.objs.clear(), Zt(this, Ro, !1), en(this, Aa, S2).call(this), Promise.all(ue);
  }
  cleanup(ue = !1) {
    Zt(this, Ro, !0);
    const Qe = en(this, Aa, pu).call(this, !1);
    return ue && Qe && this._stats && (this._stats = new StatTimer()), Qe;
  }
  _startRenderPage(ue, Qe) {
    var He, Ge;
    const Ue = this._intentStates.get(Qe);
    Ue && ((He = this._stats) == null || He.timeEnd("Page Request"), (Ge = Ue.displayReadyCapability) == null || Ge.resolve(ue));
  }
  _renderPageChunk(ue, Qe) {
    for (let Ue = 0, He = ue.length; Ue < He; Ue++)
      Qe.operatorList.fnArray.push(ue.fnArray[Ue]), Qe.operatorList.argsArray.push(ue.argsArray[Ue]);
    Qe.operatorList.lastChunk = ue.lastChunk, Qe.operatorList.separateAnnots = ue.separateAnnots;
    for (const Ue of Qe.renderTasks)
      Ue.operatorListChanged();
    ue.lastChunk && en(this, Aa, pu).call(this, !0);
  }
  _pumpOperatorList({
    renderingIntent: ue,
    cacheKey: Qe,
    annotationStorageSerializable: Ue
  }) {
    const {
      map: He,
      transfer: Ge
    } = Ue, Ke = this._transport.messageHandler.sendWithStream("GetOperatorList", {
      pageIndex: this._pageIndex,
      intent: ue,
      cacheKey: Qe,
      annotationStorage: He
    }, Ge).getReader(), $e = this._intentStates.get(Qe);
    $e.streamReader = Ke;
    const Je = () => {
      Ke.read().then(({
        value: Ze,
        done: nt
      }) => {
        if (nt) {
          $e.streamReader = null;
          return;
        }
        this._transport.destroyed || (this._renderPageChunk(Ze, $e), Je());
      }, (Ze) => {
        if ($e.streamReader = null, !this._transport.destroyed) {
          if ($e.operatorList) {
            $e.operatorList.lastChunk = !0;
            for (const nt of $e.renderTasks)
              nt.operatorListChanged();
            en(this, Aa, pu).call(this, !0);
          }
          if ($e.displayReadyCapability)
            $e.displayReadyCapability.reject(Ze);
          else if ($e.opListReadCapability)
            $e.opListReadCapability.reject(Ze);
          else
            throw Ze;
        }
      });
    };
    Je();
  }
  _abortOperatorList({
    intentState: ue,
    reason: Qe,
    force: Ue = !1
  }) {
    if (ue.streamReader) {
      if (ue.streamReaderCancelTimeout && (clearTimeout(ue.streamReaderCancelTimeout), ue.streamReaderCancelTimeout = null), !Ue) {
        if (ue.renderTasks.size > 0)
          return;
        if (Qe instanceof RenderingCancelledException) {
          let He = RENDERING_CANCELLED_TIMEOUT;
          Qe.extraDelay > 0 && Qe.extraDelay < 1e3 && (He += Qe.extraDelay), ue.streamReaderCancelTimeout = setTimeout(() => {
            ue.streamReaderCancelTimeout = null, this._abortOperatorList({
              intentState: ue,
              reason: Qe,
              force: !0
            });
          }, He);
          return;
        }
      }
      if (ue.streamReader.cancel(new AbortException(Qe.message)).catch(() => {
      }), ue.streamReader = null, !this._transport.destroyed) {
        for (const [He, Ge] of this._intentStates)
          if (Ge === ue) {
            this._intentStates.delete(He);
            break;
          }
        this.cleanup();
      }
    }
  }
  get stats() {
    return this._stats;
  }
}
fs = new WeakMap(), Ro = new WeakMap(), Aa = new WeakSet(), pu = function(ue = !1) {
  if (en(this, Aa, S2).call(this), !xt(this, Ro) || this.destroyed)
    return !1;
  if (ue)
    return Zt(this, fs, setTimeout(() => {
      Zt(this, fs, null), en(this, Aa, pu).call(this, !1);
    }, DELAYED_CLEANUP_TIMEOUT)), !1;
  for (const {
    renderTasks: Qe,
    operatorList: Ue
  } of this._intentStates.values())
    if (Qe.size > 0 || !Ue.lastChunk)
      return !1;
  return this._intentStates.clear(), this.objs.clear(), Zt(this, Ro, !1), !0;
}, S2 = function() {
  xt(this, fs) && (clearTimeout(xt(this, fs)), Zt(this, fs, null));
};
var mc, tf;
class LoopbackPort {
  constructor() {
    tn(this, mc, /* @__PURE__ */ new Set());
    tn(this, tf, Promise.resolve());
  }
  postMessage(ue, Qe) {
    const Ue = {
      data: structuredClone(ue, Qe ? {
        transfer: Qe
      } : null)
    };
    xt(this, tf).then(() => {
      for (const He of xt(this, mc))
        He.call(this, Ue);
    });
  }
  addEventListener(ue, Qe) {
    xt(this, mc).add(Qe);
  }
  removeEventListener(ue, Qe) {
    xt(this, mc).delete(Qe);
  }
  terminate() {
    xt(this, mc).clear();
  }
}
mc = new WeakMap(), tf = new WeakMap();
const PDFWorkerUtil = {
  isWorkerDisabled: !1,
  fakeWorkerId: 0
};
isNodeJS && (PDFWorkerUtil.isWorkerDisabled = !0, GlobalWorkerOptions.workerSrc || (GlobalWorkerOptions.workerSrc = "./pdf.worker.mjs")), PDFWorkerUtil.isSameOrigin = function(me, ue) {
  let Qe;
  try {
    if (Qe = new URL(me), !Qe.origin || Qe.origin === "null")
      return !1;
  } catch {
    return !1;
  }
  const Ue = new URL(ue, Qe);
  return Qe.origin === Ue.origin;
}, PDFWorkerUtil.createCDNWrapper = function(me) {
  const ue = `await import("${me}");`;
  return URL.createObjectURL(new Blob([ue], {
    type: "text/javascript"
  }));
};
var Ec, Qu, w2;
const Ki = class Ki {
  constructor({
    name: ue = null,
    port: Qe = null,
    verbosity: Ue = getVerbosityLevel()
  } = {}) {
    var He;
    if (this.name = ue, this.destroyed = !1, this.verbosity = Ue, this._readyCapability = Promise.withResolvers(), this._port = null, this._webWorker = null, this._messageHandler = null, Qe) {
      if ((He = xt(Ki, Ec)) != null && He.has(Qe))
        throw new Error("Cannot use more than one PDFWorker per port.");
      (xt(Ki, Ec) || Zt(Ki, Ec, /* @__PURE__ */ new WeakMap())).set(Qe, this), this._initializeFromPort(Qe);
      return;
    }
    this._initialize();
  }
  get promise() {
    return isNodeJS ? Promise.all([NodePackages.promise, this._readyCapability.promise]) : this._readyCapability.promise;
  }
  get port() {
    return this._port;
  }
  get messageHandler() {
    return this._messageHandler;
  }
  _initializeFromPort(ue) {
    this._port = ue, this._messageHandler = new MessageHandler("main", "worker", ue), this._messageHandler.on("ready", function() {
    }), this._readyCapability.resolve(), this._messageHandler.send("configure", {
      verbosity: this.verbosity
    });
  }
  _initialize() {
    if (!PDFWorkerUtil.isWorkerDisabled && !xt(Ki, Qu, w2)) {
      let {
        workerSrc: ue
      } = Ki;
      try {
        PDFWorkerUtil.isSameOrigin(window.location.href, ue) || (ue = PDFWorkerUtil.createCDNWrapper(new URL(ue, window.location).href));
        const Qe = new Worker(ue, {
          type: "module"
        }), Ue = new MessageHandler("main", "worker", Qe), He = () => {
          Qe.removeEventListener("error", Ge), Ue.destroy(), Qe.terminate(), this.destroyed ? this._readyCapability.reject(new Error("Worker was destroyed")) : this._setupFakeWorker();
        }, Ge = () => {
          this._webWorker || He();
        };
        Qe.addEventListener("error", Ge), Ue.on("test", (Ke) => {
          if (Qe.removeEventListener("error", Ge), this.destroyed) {
            He();
            return;
          }
          Ke ? (this._messageHandler = Ue, this._port = Qe, this._webWorker = Qe, this._readyCapability.resolve(), Ue.send("configure", {
            verbosity: this.verbosity
          })) : (this._setupFakeWorker(), Ue.destroy(), Qe.terminate());
        }), Ue.on("ready", (Ke) => {
          if (Qe.removeEventListener("error", Ge), this.destroyed) {
            He();
            return;
          }
          try {
            Xe();
          } catch {
            this._setupFakeWorker();
          }
        });
        const Xe = () => {
          const Ke = new Uint8Array();
          Ue.send("test", Ke, [Ke.buffer]);
        };
        Xe();
        return;
      } catch {
        info("The worker has been disabled.");
      }
    }
    this._setupFakeWorker();
  }
  _setupFakeWorker() {
    PDFWorkerUtil.isWorkerDisabled || (warn("Setting up fake worker."), PDFWorkerUtil.isWorkerDisabled = !0), Ki._setupFakeWorkerGlobal.then((ue) => {
      if (this.destroyed) {
        this._readyCapability.reject(new Error("Worker was destroyed"));
        return;
      }
      const Qe = new LoopbackPort();
      this._port = Qe;
      const Ue = `fake${PDFWorkerUtil.fakeWorkerId++}`, He = new MessageHandler(Ue + "_worker", Ue, Qe);
      ue.setup(He, Qe);
      const Ge = new MessageHandler(Ue, Ue + "_worker", Qe);
      this._messageHandler = Ge, this._readyCapability.resolve(), Ge.send("configure", {
        verbosity: this.verbosity
      });
    }).catch((ue) => {
      this._readyCapability.reject(new Error(`Setting up fake worker failed: "${ue.message}".`));
    });
  }
  destroy() {
    var ue;
    this.destroyed = !0, this._webWorker && (this._webWorker.terminate(), this._webWorker = null), (ue = xt(Ki, Ec)) == null || ue.delete(this._port), this._port = null, this._messageHandler && (this._messageHandler.destroy(), this._messageHandler = null);
  }
  static fromPort(ue) {
    var Ue;
    if (!(ue != null && ue.port))
      throw new Error("PDFWorker.fromPort - invalid method signature.");
    const Qe = (Ue = xt(this, Ec)) == null ? void 0 : Ue.get(ue.port);
    if (Qe) {
      if (Qe._pendingDestroy)
        throw new Error("PDFWorker.fromPort - the worker is being destroyed.\nPlease remember to await `PDFDocumentLoadingTask.destroy()`-calls.");
      return Qe;
    }
    return new Ki(ue);
  }
  static get workerSrc() {
    if (GlobalWorkerOptions.workerSrc)
      return GlobalWorkerOptions.workerSrc;
    throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
  }
  static get _setupFakeWorkerGlobal() {
    return shadow(this, "_setupFakeWorkerGlobal", (async () => xt(this, Qu, w2) ? xt(this, Qu, w2) : (await import(
      /*webpackIgnore: true*/
      this.workerSrc
    )).WorkerMessageHandler)());
  }
};
Ec = new WeakMap(), Qu = new WeakSet(), w2 = function() {
  var ue;
  try {
    return ((ue = globalThis.pdfjsWorker) == null ? void 0 : ue.WorkerMessageHandler) || null;
  } catch {
    return null;
  }
}, tn(Ki, Qu), tn(Ki, Ec);
let PDFWorker = Ki;
var Oo, Ga, Fu, ju, Wa, Cc, Ql;
class WorkerTransport {
  constructor(ue, Qe, Ue, He, Ge) {
    tn(this, Cc);
    tn(this, Oo, /* @__PURE__ */ new Map());
    tn(this, Ga, /* @__PURE__ */ new Map());
    tn(this, Fu, /* @__PURE__ */ new Map());
    tn(this, ju, /* @__PURE__ */ new Map());
    tn(this, Wa, null);
    this.messageHandler = ue, this.loadingTask = Qe, this.commonObjs = new PDFObjects(), this.fontLoader = new FontLoader({
      ownerDocument: He.ownerDocument,
      styleElement: He.styleElement
    }), this.loadingParams = He.loadingParams, this._params = He, this.canvasFactory = Ge.canvasFactory, this.filterFactory = Ge.filterFactory, this.cMapReaderFactory = Ge.cMapReaderFactory, this.standardFontDataFactory = Ge.standardFontDataFactory, this.destroyed = !1, this.destroyCapability = null, this._networkStream = Ue, this._fullReader = null, this._lastProgress = null, this.downloadInfoCapability = Promise.withResolvers(), this.setupMessageHandler();
  }
  get annotationStorage() {
    return shadow(this, "annotationStorage", new AnnotationStorage());
  }
  getRenderingIntent(ue, Qe = AnnotationMode.ENABLE, Ue = null, He = !1) {
    let Ge = RenderingIntentFlag.DISPLAY, Xe = SerializableEmpty;
    switch (ue) {
      case "any":
        Ge = RenderingIntentFlag.ANY;
        break;
      case "display":
        break;
      case "print":
        Ge = RenderingIntentFlag.PRINT;
        break;
      default:
        warn(`getRenderingIntent - invalid intent: ${ue}`);
    }
    switch (Qe) {
      case AnnotationMode.DISABLE:
        Ge += RenderingIntentFlag.ANNOTATIONS_DISABLE;
        break;
      case AnnotationMode.ENABLE:
        break;
      case AnnotationMode.ENABLE_FORMS:
        Ge += RenderingIntentFlag.ANNOTATIONS_FORMS;
        break;
      case AnnotationMode.ENABLE_STORAGE:
        Ge += RenderingIntentFlag.ANNOTATIONS_STORAGE, Xe = (Ge & RenderingIntentFlag.PRINT && Ue instanceof PrintAnnotationStorage ? Ue : this.annotationStorage).serializable;
        break;
      default:
        warn(`getRenderingIntent - invalid annotationMode: ${Qe}`);
    }
    return He && (Ge += RenderingIntentFlag.OPLIST), {
      renderingIntent: Ge,
      cacheKey: `${Ge}_${Xe.hash}`,
      annotationStorageSerializable: Xe
    };
  }
  destroy() {
    var Ue;
    if (this.destroyCapability)
      return this.destroyCapability.promise;
    this.destroyed = !0, this.destroyCapability = Promise.withResolvers(), (Ue = xt(this, Wa)) == null || Ue.reject(new Error("Worker was destroyed during onPassword callback"));
    const ue = [];
    for (const He of xt(this, Ga).values())
      ue.push(He._destroy());
    xt(this, Ga).clear(), xt(this, Fu).clear(), xt(this, ju).clear(), this.hasOwnProperty("annotationStorage") && this.annotationStorage.resetModified();
    const Qe = this.messageHandler.sendWithPromise("Terminate", null);
    return ue.push(Qe), Promise.all(ue).then(() => {
      var He;
      this.commonObjs.clear(), this.fontLoader.clear(), xt(this, Oo).clear(), this.filterFactory.destroy(), TextLayer$1.cleanup(), (He = this._networkStream) == null || He.cancelAllRequests(new AbortException("Worker was terminated.")), this.messageHandler && (this.messageHandler.destroy(), this.messageHandler = null), this.destroyCapability.resolve();
    }, this.destroyCapability.reject), this.destroyCapability.promise;
  }
  setupMessageHandler() {
    const {
      messageHandler: ue,
      loadingTask: Qe
    } = this;
    ue.on("GetReader", (Ue, He) => {
      assert(this._networkStream, "GetReader - no `IPDFStream` instance available."), this._fullReader = this._networkStream.getFullReader(), this._fullReader.onProgress = (Ge) => {
        this._lastProgress = {
          loaded: Ge.loaded,
          total: Ge.total
        };
      }, He.onPull = () => {
        this._fullReader.read().then(function({
          value: Ge,
          done: Xe
        }) {
          if (Xe) {
            He.close();
            return;
          }
          assert(Ge instanceof ArrayBuffer, "GetReader - expected an ArrayBuffer."), He.enqueue(new Uint8Array(Ge), 1, [Ge]);
        }).catch((Ge) => {
          He.error(Ge);
        });
      }, He.onCancel = (Ge) => {
        this._fullReader.cancel(Ge), He.ready.catch((Xe) => {
          if (!this.destroyed)
            throw Xe;
        });
      };
    }), ue.on("ReaderHeadersReady", (Ue) => {
      const He = Promise.withResolvers(), Ge = this._fullReader;
      return Ge.headersReady.then(() => {
        var Xe;
        (!Ge.isStreamingSupported || !Ge.isRangeSupported) && (this._lastProgress && ((Xe = Qe.onProgress) == null || Xe.call(Qe, this._lastProgress)), Ge.onProgress = (Ke) => {
          var $e;
          ($e = Qe.onProgress) == null || $e.call(Qe, {
            loaded: Ke.loaded,
            total: Ke.total
          });
        }), He.resolve({
          isStreamingSupported: Ge.isStreamingSupported,
          isRangeSupported: Ge.isRangeSupported,
          contentLength: Ge.contentLength
        });
      }, He.reject), He.promise;
    }), ue.on("GetRangeReader", (Ue, He) => {
      assert(this._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
      const Ge = this._networkStream.getRangeReader(Ue.begin, Ue.end);
      if (!Ge) {
        He.close();
        return;
      }
      He.onPull = () => {
        Ge.read().then(function({
          value: Xe,
          done: Ke
        }) {
          if (Ke) {
            He.close();
            return;
          }
          assert(Xe instanceof ArrayBuffer, "GetRangeReader - expected an ArrayBuffer."), He.enqueue(new Uint8Array(Xe), 1, [Xe]);
        }).catch((Xe) => {
          He.error(Xe);
        });
      }, He.onCancel = (Xe) => {
        Ge.cancel(Xe), He.ready.catch((Ke) => {
          if (!this.destroyed)
            throw Ke;
        });
      };
    }), ue.on("GetDoc", ({
      pdfInfo: Ue
    }) => {
      this._numPages = Ue.numPages, this._htmlForXfa = Ue.htmlForXfa, delete Ue.htmlForXfa, Qe._capability.resolve(new PDFDocumentProxy(Ue, this));
    }), ue.on("DocException", function(Ue) {
      let He;
      switch (Ue.name) {
        case "PasswordException":
          He = new PasswordException(Ue.message, Ue.code);
          break;
        case "InvalidPDFException":
          He = new InvalidPDFException(Ue.message);
          break;
        case "MissingPDFException":
          He = new MissingPDFException(Ue.message);
          break;
        case "UnexpectedResponseException":
          He = new UnexpectedResponseException(Ue.message, Ue.status);
          break;
        case "UnknownErrorException":
          He = new UnknownErrorException(Ue.message, Ue.details);
          break;
        default:
          unreachable("DocException - expected a valid Error.");
      }
      Qe._capability.reject(He);
    }), ue.on("PasswordRequest", (Ue) => {
      if (Zt(this, Wa, Promise.withResolvers()), Qe.onPassword) {
        const He = (Ge) => {
          Ge instanceof Error ? xt(this, Wa).reject(Ge) : xt(this, Wa).resolve({
            password: Ge
          });
        };
        try {
          Qe.onPassword(He, Ue.code);
        } catch (Ge) {
          xt(this, Wa).reject(Ge);
        }
      } else
        xt(this, Wa).reject(new PasswordException(Ue.message, Ue.code));
      return xt(this, Wa).promise;
    }), ue.on("DataLoaded", (Ue) => {
      var He;
      (He = Qe.onProgress) == null || He.call(Qe, {
        loaded: Ue.length,
        total: Ue.length
      }), this.downloadInfoCapability.resolve(Ue);
    }), ue.on("StartRenderPage", (Ue) => {
      if (this.destroyed)
        return;
      xt(this, Ga).get(Ue.pageIndex)._startRenderPage(Ue.transparency, Ue.cacheKey);
    }), ue.on("commonobj", ([Ue, He, Ge]) => {
      var Xe;
      if (this.destroyed || this.commonObjs.has(Ue))
        return null;
      switch (He) {
        case "Font":
          const {
            disableFontFace: Ke,
            fontExtraProperties: $e,
            pdfBug: Je
          } = this._params;
          if ("error" in Ge) {
            const et = Ge.error;
            warn(`Error during font loading: ${et}`), this.commonObjs.resolve(Ue, et);
            break;
          }
          const Ze = Je && ((Xe = globalThis.FontInspector) != null && Xe.enabled) ? (et, rt) => globalThis.FontInspector.fontAdded(et, rt) : null, nt = new FontFaceObject(Ge, {
            disableFontFace: Ke,
            inspectFont: Ze
          });
          this.fontLoader.bind(nt).catch(() => ue.sendWithPromise("FontFallback", {
            id: Ue
          })).finally(() => {
            !$e && nt.data && (nt.data = null), this.commonObjs.resolve(Ue, nt);
          });
          break;
        case "CopyLocalImage":
          const {
            imageRef: tt
          } = Ge;
          assert(tt, "The imageRef must be defined.");
          for (const et of xt(this, Ga).values())
            for (const [, rt] of et.objs)
              if ((rt == null ? void 0 : rt.ref) === tt)
                return rt.dataLen ? (this.commonObjs.resolve(Ue, structuredClone(rt)), rt.dataLen) : null;
          break;
        case "FontPath":
        case "Image":
        case "Pattern":
          this.commonObjs.resolve(Ue, Ge);
          break;
        default:
          throw new Error(`Got unknown common object type ${He}`);
      }
      return null;
    }), ue.on("obj", ([Ue, He, Ge, Xe]) => {
      var $e;
      if (this.destroyed)
        return;
      const Ke = xt(this, Ga).get(He);
      if (!Ke.objs.has(Ue)) {
        if (Ke._intentStates.size === 0) {
          ($e = Xe == null ? void 0 : Xe.bitmap) == null || $e.close();
          return;
        }
        switch (Ge) {
          case "Image":
            Ke.objs.resolve(Ue, Xe), (Xe == null ? void 0 : Xe.dataLen) > MAX_IMAGE_SIZE_TO_CACHE && (Ke._maybeCleanupAfterRender = !0);
            break;
          case "Pattern":
            Ke.objs.resolve(Ue, Xe);
            break;
          default:
            throw new Error(`Got unknown object type ${Ge}`);
        }
      }
    }), ue.on("DocProgress", (Ue) => {
      var He;
      this.destroyed || (He = Qe.onProgress) == null || He.call(Qe, {
        loaded: Ue.loaded,
        total: Ue.total
      });
    }), ue.on("FetchBuiltInCMap", (Ue) => this.destroyed ? Promise.reject(new Error("Worker was destroyed.")) : this.cMapReaderFactory ? this.cMapReaderFactory.fetch(Ue) : Promise.reject(new Error("CMapReaderFactory not initialized, see the `useWorkerFetch` parameter."))), ue.on("FetchStandardFontData", (Ue) => this.destroyed ? Promise.reject(new Error("Worker was destroyed.")) : this.standardFontDataFactory ? this.standardFontDataFactory.fetch(Ue) : Promise.reject(new Error("StandardFontDataFactory not initialized, see the `useWorkerFetch` parameter.")));
  }
  getData() {
    return this.messageHandler.sendWithPromise("GetData", null);
  }
  saveDocument() {
    var Ue;
    this.annotationStorage.size <= 0 && warn("saveDocument called while `annotationStorage` is empty, please use the getData-method instead.");
    const {
      map: ue,
      transfer: Qe
    } = this.annotationStorage.serializable;
    return this.messageHandler.sendWithPromise("SaveDocument", {
      isPureXfa: !!this._htmlForXfa,
      numPages: this._numPages,
      annotationStorage: ue,
      filename: ((Ue = this._fullReader) == null ? void 0 : Ue.filename) ?? null
    }, Qe).finally(() => {
      this.annotationStorage.resetModified();
    });
  }
  getPage(ue) {
    if (!Number.isInteger(ue) || ue <= 0 || ue > this._numPages)
      return Promise.reject(new Error("Invalid page request."));
    const Qe = ue - 1, Ue = xt(this, Fu).get(Qe);
    if (Ue)
      return Ue;
    const He = this.messageHandler.sendWithPromise("GetPage", {
      pageIndex: Qe
    }).then((Ge) => {
      if (this.destroyed)
        throw new Error("Transport destroyed");
      Ge.refStr && xt(this, ju).set(Ge.refStr, ue);
      const Xe = new PDFPageProxy(Qe, Ge, this, this._params.pdfBug);
      return xt(this, Ga).set(Qe, Xe), Xe;
    });
    return xt(this, Fu).set(Qe, He), He;
  }
  getPageIndex(ue) {
    return isRefProxy(ue) ? this.messageHandler.sendWithPromise("GetPageIndex", {
      num: ue.num,
      gen: ue.gen
    }) : Promise.reject(new Error("Invalid pageIndex request."));
  }
  getAnnotations(ue, Qe) {
    return this.messageHandler.sendWithPromise("GetAnnotations", {
      pageIndex: ue,
      intent: Qe
    });
  }
  getFieldObjects() {
    return en(this, Cc, Ql).call(this, "GetFieldObjects");
  }
  hasJSActions() {
    return en(this, Cc, Ql).call(this, "HasJSActions");
  }
  getCalculationOrderIds() {
    return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
  }
  getDestinations() {
    return this.messageHandler.sendWithPromise("GetDestinations", null);
  }
  getDestination(ue) {
    return typeof ue != "string" ? Promise.reject(new Error("Invalid destination request.")) : this.messageHandler.sendWithPromise("GetDestination", {
      id: ue
    });
  }
  getPageLabels() {
    return this.messageHandler.sendWithPromise("GetPageLabels", null);
  }
  getPageLayout() {
    return this.messageHandler.sendWithPromise("GetPageLayout", null);
  }
  getPageMode() {
    return this.messageHandler.sendWithPromise("GetPageMode", null);
  }
  getViewerPreferences() {
    return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
  }
  getOpenAction() {
    return this.messageHandler.sendWithPromise("GetOpenAction", null);
  }
  getAttachments() {
    return this.messageHandler.sendWithPromise("GetAttachments", null);
  }
  getDocJSActions() {
    return en(this, Cc, Ql).call(this, "GetDocJSActions");
  }
  getPageJSActions(ue) {
    return this.messageHandler.sendWithPromise("GetPageJSActions", {
      pageIndex: ue
    });
  }
  getStructTree(ue) {
    return this.messageHandler.sendWithPromise("GetStructTree", {
      pageIndex: ue
    });
  }
  getOutline() {
    return this.messageHandler.sendWithPromise("GetOutline", null);
  }
  getOptionalContentConfig(ue) {
    return en(this, Cc, Ql).call(this, "GetOptionalContentConfig").then((Qe) => new OptionalContentConfig(Qe, ue));
  }
  getPermissions() {
    return this.messageHandler.sendWithPromise("GetPermissions", null);
  }
  getMetadata() {
    const ue = "GetMetadata", Qe = xt(this, Oo).get(ue);
    if (Qe)
      return Qe;
    const Ue = this.messageHandler.sendWithPromise(ue, null).then((He) => {
      var Ge, Xe;
      return {
        info: He[0],
        metadata: He[1] ? new Metadata(He[1]) : null,
        contentDispositionFilename: ((Ge = this._fullReader) == null ? void 0 : Ge.filename) ?? null,
        contentLength: ((Xe = this._fullReader) == null ? void 0 : Xe.contentLength) ?? null
      };
    });
    return xt(this, Oo).set(ue, Ue), Ue;
  }
  getMarkInfo() {
    return this.messageHandler.sendWithPromise("GetMarkInfo", null);
  }
  async startCleanup(ue = !1) {
    if (!this.destroyed) {
      await this.messageHandler.sendWithPromise("Cleanup", null);
      for (const Qe of xt(this, Ga).values())
        if (!Qe.cleanup())
          throw new Error(`startCleanup: Page ${Qe.pageNumber} is currently rendering.`);
      this.commonObjs.clear(), ue || this.fontLoader.clear(), xt(this, Oo).clear(), this.filterFactory.destroy(!0), TextLayer$1.cleanup();
    }
  }
  cachedPageNumber(ue) {
    if (!isRefProxy(ue))
      return null;
    const Qe = ue.gen === 0 ? `${ue.num}R` : `${ue.num}R${ue.gen}`;
    return xt(this, ju).get(Qe) ?? null;
  }
}
Oo = new WeakMap(), Ga = new WeakMap(), Fu = new WeakMap(), ju = new WeakMap(), Wa = new WeakMap(), Cc = new WeakSet(), Ql = function(ue, Qe = null) {
  const Ue = xt(this, Oo).get(ue);
  if (Ue)
    return Ue;
  const He = this.messageHandler.sendWithPromise(ue, Qe);
  return xt(this, Oo).set(ue, He), He;
};
const INITIAL_DATA = Symbol("INITIAL_DATA");
var ba, M0, zh;
class PDFObjects {
  constructor() {
    tn(this, M0);
    tn(this, ba, /* @__PURE__ */ Object.create(null));
  }
  get(ue, Qe = null) {
    if (Qe) {
      const He = en(this, M0, zh).call(this, ue);
      return He.promise.then(() => Qe(He.data)), null;
    }
    const Ue = xt(this, ba)[ue];
    if (!Ue || Ue.data === INITIAL_DATA)
      throw new Error(`Requesting object that isn't resolved yet ${ue}.`);
    return Ue.data;
  }
  has(ue) {
    const Qe = xt(this, ba)[ue];
    return !!Qe && Qe.data !== INITIAL_DATA;
  }
  resolve(ue, Qe = null) {
    const Ue = en(this, M0, zh).call(this, ue);
    Ue.data = Qe, Ue.resolve();
  }
  clear() {
    var ue;
    for (const Qe in xt(this, ba)) {
      const {
        data: Ue
      } = xt(this, ba)[Qe];
      (ue = Ue == null ? void 0 : Ue.bitmap) == null || ue.close();
    }
    Zt(this, ba, /* @__PURE__ */ Object.create(null));
  }
  *[Symbol.iterator]() {
    for (const ue in xt(this, ba)) {
      const {
        data: Qe
      } = xt(this, ba)[ue];
      Qe !== INITIAL_DATA && (yield [ue, Qe]);
    }
  }
}
ba = new WeakMap(), M0 = new WeakSet(), zh = function(ue) {
  var Qe;
  return (Qe = xt(this, ba))[ue] || (Qe[ue] = {
    ...Promise.withResolvers(),
    data: INITIAL_DATA
  });
};
var hs;
class RenderTask {
  constructor(ue) {
    tn(this, hs, null);
    Zt(this, hs, ue), this.onContinue = null;
  }
  get promise() {
    return xt(this, hs).capability.promise;
  }
  cancel(ue = 0) {
    xt(this, hs).cancel(null, ue);
  }
  get separateAnnots() {
    const {
      separateAnnots: ue
    } = xt(this, hs).operatorList;
    if (!ue)
      return !1;
    const {
      annotationCanvasMap: Qe
    } = xt(this, hs);
    return ue.form || ue.canvas && (Qe == null ? void 0 : Qe.size) > 0;
  }
}
hs = new WeakMap();
var vc;
const Xs = class Xs {
  constructor({
    callback: ue,
    params: Qe,
    objs: Ue,
    commonObjs: He,
    annotationCanvasMap: Ge,
    operatorList: Xe,
    pageIndex: Ke,
    canvasFactory: $e,
    filterFactory: Je,
    useRequestAnimationFrame: Ze = !1,
    pdfBug: nt = !1,
    pageColors: tt = null
  }) {
    this.callback = ue, this.params = Qe, this.objs = Ue, this.commonObjs = He, this.annotationCanvasMap = Ge, this.operatorListIdx = null, this.operatorList = Xe, this._pageIndex = Ke, this.canvasFactory = $e, this.filterFactory = Je, this._pdfBug = nt, this.pageColors = tt, this.running = !1, this.graphicsReadyCallback = null, this.graphicsReady = !1, this._useRequestAnimationFrame = Ze === !0 && typeof window < "u", this.cancelled = !1, this.capability = Promise.withResolvers(), this.task = new RenderTask(this), this._cancelBound = this.cancel.bind(this), this._continueBound = this._continue.bind(this), this._scheduleNextBound = this._scheduleNext.bind(this), this._nextBound = this._next.bind(this), this._canvas = Qe.canvasContext.canvas;
  }
  get completed() {
    return this.capability.promise.catch(function() {
    });
  }
  initializeGraphics({
    transparency: ue = !1,
    optionalContentConfig: Qe
  }) {
    var Ke, $e;
    if (this.cancelled)
      return;
    if (this._canvas) {
      if (xt(Xs, vc).has(this._canvas))
        throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
      xt(Xs, vc).add(this._canvas);
    }
    this._pdfBug && ((Ke = globalThis.StepperManager) != null && Ke.enabled) && (this.stepper = globalThis.StepperManager.create(this._pageIndex), this.stepper.init(this.operatorList), this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint());
    const {
      canvasContext: Ue,
      viewport: He,
      transform: Ge,
      background: Xe
    } = this.params;
    this.gfx = new CanvasGraphics(Ue, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
      optionalContentConfig: Qe
    }, this.annotationCanvasMap, this.pageColors), this.gfx.beginDrawing({
      transform: Ge,
      viewport: He,
      transparency: ue,
      background: Xe
    }), this.operatorListIdx = 0, this.graphicsReady = !0, ($e = this.graphicsReadyCallback) == null || $e.call(this);
  }
  cancel(ue = null, Qe = 0) {
    var Ue;
    this.running = !1, this.cancelled = !0, (Ue = this.gfx) == null || Ue.endDrawing(), xt(Xs, vc).delete(this._canvas), this.callback(ue || new RenderingCancelledException(`Rendering cancelled, page ${this._pageIndex + 1}`, Qe));
  }
  operatorListChanged() {
    var ue;
    if (!this.graphicsReady) {
      this.graphicsReadyCallback || (this.graphicsReadyCallback = this._continueBound);
      return;
    }
    (ue = this.stepper) == null || ue.updateOperatorList(this.operatorList), !this.running && this._continue();
  }
  _continue() {
    this.running = !0, !this.cancelled && (this.task.onContinue ? this.task.onContinue(this._scheduleNextBound) : this._scheduleNext());
  }
  _scheduleNext() {
    this._useRequestAnimationFrame ? window.requestAnimationFrame(() => {
      this._nextBound().catch(this._cancelBound);
    }) : Promise.resolve().then(this._nextBound).catch(this._cancelBound);
  }
  async _next() {
    this.cancelled || (this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper), this.operatorListIdx === this.operatorList.argsArray.length && (this.running = !1, this.operatorList.lastChunk && (this.gfx.endDrawing(), xt(Xs, vc).delete(this._canvas), this.callback())));
  }
};
vc = new WeakMap(), tn(Xs, vc, /* @__PURE__ */ new WeakSet());
let InternalRenderTask = Xs;
const version = "4.3.136", build = "0cec64437";
function makeColorComp(me) {
  return Math.floor(Math.max(0, Math.min(1, me)) * 255).toString(16).padStart(2, "0");
}
function scaleAndClamp(me) {
  return Math.max(0, Math.min(255, 255 * me));
}
class ColorConverters {
  static CMYK_G([ue, Qe, Ue, He]) {
    return ["G", 1 - Math.min(1, 0.3 * ue + 0.59 * Ue + 0.11 * Qe + He)];
  }
  static G_CMYK([ue]) {
    return ["CMYK", 0, 0, 0, 1 - ue];
  }
  static G_RGB([ue]) {
    return ["RGB", ue, ue, ue];
  }
  static G_rgb([ue]) {
    return ue = scaleAndClamp(ue), [ue, ue, ue];
  }
  static G_HTML([ue]) {
    const Qe = makeColorComp(ue);
    return `#${Qe}${Qe}${Qe}`;
  }
  static RGB_G([ue, Qe, Ue]) {
    return ["G", 0.3 * ue + 0.59 * Qe + 0.11 * Ue];
  }
  static RGB_rgb(ue) {
    return ue.map(scaleAndClamp);
  }
  static RGB_HTML(ue) {
    return `#${ue.map(makeColorComp).join("")}`;
  }
  static T_HTML() {
    return "#00000000";
  }
  static T_rgb() {
    return [null];
  }
  static CMYK_RGB([ue, Qe, Ue, He]) {
    return ["RGB", 1 - Math.min(1, ue + He), 1 - Math.min(1, Ue + He), 1 - Math.min(1, Qe + He)];
  }
  static CMYK_rgb([ue, Qe, Ue, He]) {
    return [scaleAndClamp(1 - Math.min(1, ue + He)), scaleAndClamp(1 - Math.min(1, Ue + He)), scaleAndClamp(1 - Math.min(1, Qe + He))];
  }
  static CMYK_HTML(ue) {
    const Qe = this.CMYK_RGB(ue).slice(1);
    return this.RGB_HTML(Qe);
  }
  static RGB_CMYK([ue, Qe, Ue]) {
    const He = 1 - ue, Ge = 1 - Qe, Xe = 1 - Ue, Ke = Math.min(He, Ge, Xe);
    return ["CMYK", He, Ge, Xe, Ke];
  }
}
class XfaLayer {
  static setupStorage(ue, Qe, Ue, He, Ge) {
    const Xe = He.getValue(Qe, {
      value: null
    });
    switch (Ue.name) {
      case "textarea":
        if (Xe.value !== null && (ue.textContent = Xe.value), Ge === "print")
          break;
        ue.addEventListener("input", (Ke) => {
          He.setValue(Qe, {
            value: Ke.target.value
          });
        });
        break;
      case "input":
        if (Ue.attributes.type === "radio" || Ue.attributes.type === "checkbox") {
          if (Xe.value === Ue.attributes.xfaOn ? ue.setAttribute("checked", !0) : Xe.value === Ue.attributes.xfaOff && ue.removeAttribute("checked"), Ge === "print")
            break;
          ue.addEventListener("change", (Ke) => {
            He.setValue(Qe, {
              value: Ke.target.checked ? Ke.target.getAttribute("xfaOn") : Ke.target.getAttribute("xfaOff")
            });
          });
        } else {
          if (Xe.value !== null && ue.setAttribute("value", Xe.value), Ge === "print")
            break;
          ue.addEventListener("input", (Ke) => {
            He.setValue(Qe, {
              value: Ke.target.value
            });
          });
        }
        break;
      case "select":
        if (Xe.value !== null) {
          ue.setAttribute("value", Xe.value);
          for (const Ke of Ue.children)
            Ke.attributes.value === Xe.value ? Ke.attributes.selected = !0 : Ke.attributes.hasOwnProperty("selected") && delete Ke.attributes.selected;
        }
        ue.addEventListener("input", (Ke) => {
          const $e = Ke.target.options, Je = $e.selectedIndex === -1 ? "" : $e[$e.selectedIndex].value;
          He.setValue(Qe, {
            value: Je
          });
        });
        break;
    }
  }
  static setAttributes({
    html: ue,
    element: Qe,
    storage: Ue = null,
    intent: He,
    linkService: Ge
  }) {
    const {
      attributes: Xe
    } = Qe, Ke = ue instanceof HTMLAnchorElement;
    Xe.type === "radio" && (Xe.name = `${Xe.name}-${He}`);
    for (const [$e, Je] of Object.entries(Xe))
      if (Je != null)
        switch ($e) {
          case "class":
            Je.length && ue.setAttribute($e, Je.join(" "));
            break;
          case "dataId":
            break;
          case "id":
            ue.setAttribute("data-element-id", Je);
            break;
          case "style":
            Object.assign(ue.style, Je);
            break;
          case "textContent":
            ue.textContent = Je;
            break;
          default:
            (!Ke || $e !== "href" && $e !== "newWindow") && ue.setAttribute($e, Je);
        }
    Ke && Ge.addLinkAttributes(ue, Xe.href, Xe.newWindow), Ue && Xe.dataId && this.setupStorage(ue, Xe.dataId, Qe, Ue);
  }
  static render(ue) {
    var nt, tt;
    const Qe = ue.annotationStorage, Ue = ue.linkService, He = ue.xfaHtml, Ge = ue.intent || "display", Xe = document.createElement(He.name);
    He.attributes && this.setAttributes({
      html: Xe,
      element: He,
      intent: Ge,
      linkService: Ue
    });
    const Ke = Ge !== "richText", $e = ue.div;
    if ($e.append(Xe), ue.viewport) {
      const et = `matrix(${ue.viewport.transform.join(",")})`;
      $e.style.transform = et;
    }
    Ke && $e.setAttribute("class", "xfaLayer xfaFont");
    const Je = [];
    if (He.children.length === 0) {
      if (He.value) {
        const et = document.createTextNode(He.value);
        Xe.append(et), Ke && XfaText.shouldBuildText(He.name) && Je.push(et);
      }
      return {
        textDivs: Je
      };
    }
    const Ze = [[He, -1, Xe]];
    for (; Ze.length > 0; ) {
      const [et, rt, it] = Ze.at(-1);
      if (rt + 1 === et.children.length) {
        Ze.pop();
        continue;
      }
      const ot = et.children[++Ze.at(-1)[1]];
      if (ot === null)
        continue;
      const {
        name: at
      } = ot;
      if (at === "#text") {
        const ut = document.createTextNode(ot.value);
        Je.push(ut), it.append(ut);
        continue;
      }
      const st = (nt = ot == null ? void 0 : ot.attributes) != null && nt.xmlns ? document.createElementNS(ot.attributes.xmlns, at) : document.createElement(at);
      if (it.append(st), ot.attributes && this.setAttributes({
        html: st,
        element: ot,
        storage: Qe,
        intent: Ge,
        linkService: Ue
      }), ((tt = ot.children) == null ? void 0 : tt.length) > 0)
        Ze.push([ot, -1, st]);
      else if (ot.value) {
        const ut = document.createTextNode(ot.value);
        Ke && XfaText.shouldBuildText(at) && Je.push(ut), st.append(ut);
      }
    }
    for (const et of $e.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea"))
      et.setAttribute("readOnly", !0);
    return {
      textDivs: Je
    };
  }
  static update(ue) {
    const Qe = `matrix(${ue.viewport.transform.join(",")})`;
    ue.div.style.transform = Qe, ue.div.hidden = !1;
  }
}
const DEFAULT_TAB_INDEX = 1e3, annotation_layer_DEFAULT_FONT_SIZE = 9, GetElementsByNameSet = /* @__PURE__ */ new WeakSet();
function getRectDims(me) {
  return {
    width: me[2] - me[0],
    height: me[3] - me[1]
  };
}
class AnnotationElementFactory {
  static create(ue) {
    switch (ue.data.annotationType) {
      case AnnotationType.LINK:
        return new LinkAnnotationElement(ue);
      case AnnotationType.TEXT:
        return new TextAnnotationElement(ue);
      case AnnotationType.WIDGET:
        switch (ue.data.fieldType) {
          case "Tx":
            return new TextWidgetAnnotationElement(ue);
          case "Btn":
            return ue.data.radioButton ? new RadioButtonWidgetAnnotationElement(ue) : ue.data.checkBox ? new CheckboxWidgetAnnotationElement(ue) : new PushButtonWidgetAnnotationElement(ue);
          case "Ch":
            return new ChoiceWidgetAnnotationElement(ue);
          case "Sig":
            return new SignatureWidgetAnnotationElement(ue);
        }
        return new WidgetAnnotationElement(ue);
      case AnnotationType.POPUP:
        return new PopupAnnotationElement(ue);
      case AnnotationType.FREETEXT:
        return new FreeTextAnnotationElement(ue);
      case AnnotationType.LINE:
        return new LineAnnotationElement(ue);
      case AnnotationType.SQUARE:
        return new SquareAnnotationElement(ue);
      case AnnotationType.CIRCLE:
        return new CircleAnnotationElement(ue);
      case AnnotationType.POLYLINE:
        return new PolylineAnnotationElement(ue);
      case AnnotationType.CARET:
        return new CaretAnnotationElement(ue);
      case AnnotationType.INK:
        return new InkAnnotationElement(ue);
      case AnnotationType.POLYGON:
        return new PolygonAnnotationElement(ue);
      case AnnotationType.HIGHLIGHT:
        return new HighlightAnnotationElement(ue);
      case AnnotationType.UNDERLINE:
        return new UnderlineAnnotationElement(ue);
      case AnnotationType.SQUIGGLY:
        return new SquigglyAnnotationElement(ue);
      case AnnotationType.STRIKEOUT:
        return new StrikeOutAnnotationElement(ue);
      case AnnotationType.STAMP:
        return new StampAnnotationElement(ue);
      case AnnotationType.FILEATTACHMENT:
        return new FileAttachmentAnnotationElement(ue);
      default:
        return new AnnotationElement(ue);
    }
  }
}
var yc, Vu, Uu, Q0, Xh;
const x1 = class x1 {
  constructor(ue, {
    isRenderable: Qe = !1,
    ignoreBorder: Ue = !1,
    createQuadrilaterals: He = !1
  } = {}) {
    tn(this, Q0);
    tn(this, yc, null);
    tn(this, Vu, !1);
    tn(this, Uu, null);
    this.isRenderable = Qe, this.data = ue.data, this.layer = ue.layer, this.linkService = ue.linkService, this.downloadManager = ue.downloadManager, this.imageResourcesPath = ue.imageResourcesPath, this.renderForms = ue.renderForms, this.svgFactory = ue.svgFactory, this.annotationStorage = ue.annotationStorage, this.enableScripting = ue.enableScripting, this.hasJSActions = ue.hasJSActions, this._fieldObjects = ue.fieldObjects, this.parent = ue.parent, Qe && (this.container = this._createContainer(Ue)), He && this._createQuadrilaterals();
  }
  static _hasPopupData({
    titleObj: ue,
    contentsObj: Qe,
    richText: Ue
  }) {
    return !!(ue != null && ue.str || Qe != null && Qe.str || Ue != null && Ue.str);
  }
  get hasPopupData() {
    return x1._hasPopupData(this.data);
  }
  updateEdited(ue) {
    var Ue;
    if (!this.container)
      return;
    xt(this, yc) || Zt(this, yc, {
      rect: this.data.rect.slice(0)
    });
    const {
      rect: Qe
    } = ue;
    Qe && en(this, Q0, Xh).call(this, Qe), (Ue = xt(this, Uu)) == null || Ue.popup.updateEdited(ue);
  }
  resetEdited() {
    var ue;
    xt(this, yc) && (en(this, Q0, Xh).call(this, xt(this, yc).rect), (ue = xt(this, Uu)) == null || ue.popup.resetEdited(), Zt(this, yc, null));
  }
  _createContainer(ue) {
    const {
      data: Qe,
      parent: {
        page: Ue,
        viewport: He
      }
    } = this, Ge = document.createElement("section");
    Ge.setAttribute("data-annotation-id", Qe.id), this instanceof WidgetAnnotationElement || (Ge.tabIndex = DEFAULT_TAB_INDEX);
    const {
      style: Xe
    } = Ge;
    if (Xe.zIndex = this.parent.zIndex++, Qe.popupRef && Ge.setAttribute("aria-haspopup", "dialog"), Qe.alternativeText && (Ge.title = Qe.alternativeText), Qe.noRotate && Ge.classList.add("norotate"), !Qe.rect || this instanceof PopupAnnotationElement) {
      const {
        rotation: it
      } = Qe;
      return !Qe.hasOwnCanvas && it !== 0 && this.setRotation(it, Ge), Ge;
    }
    const {
      width: Ke,
      height: $e
    } = getRectDims(Qe.rect);
    if (!ue && Qe.borderStyle.width > 0) {
      Xe.borderWidth = `${Qe.borderStyle.width}px`;
      const it = Qe.borderStyle.horizontalCornerRadius, ot = Qe.borderStyle.verticalCornerRadius;
      if (it > 0 || ot > 0) {
        const st = `calc(${it}px * var(--scale-factor)) / calc(${ot}px * var(--scale-factor))`;
        Xe.borderRadius = st;
      } else if (this instanceof RadioButtonWidgetAnnotationElement) {
        const st = `calc(${Ke}px * var(--scale-factor)) / calc(${$e}px * var(--scale-factor))`;
        Xe.borderRadius = st;
      }
      switch (Qe.borderStyle.style) {
        case AnnotationBorderStyleType.SOLID:
          Xe.borderStyle = "solid";
          break;
        case AnnotationBorderStyleType.DASHED:
          Xe.borderStyle = "dashed";
          break;
        case AnnotationBorderStyleType.BEVELED:
          warn("Unimplemented border style: beveled");
          break;
        case AnnotationBorderStyleType.INSET:
          warn("Unimplemented border style: inset");
          break;
        case AnnotationBorderStyleType.UNDERLINE:
          Xe.borderBottomStyle = "solid";
          break;
      }
      const at = Qe.borderColor || null;
      at ? (Zt(this, Vu, !0), Xe.borderColor = Util.makeHexColor(at[0] | 0, at[1] | 0, at[2] | 0)) : Xe.borderWidth = 0;
    }
    const Je = Util.normalizeRect([Qe.rect[0], Ue.view[3] - Qe.rect[1] + Ue.view[1], Qe.rect[2], Ue.view[3] - Qe.rect[3] + Ue.view[1]]), {
      pageWidth: Ze,
      pageHeight: nt,
      pageX: tt,
      pageY: et
    } = He.rawDims;
    Xe.left = `${100 * (Je[0] - tt) / Ze}%`, Xe.top = `${100 * (Je[1] - et) / nt}%`;
    const {
      rotation: rt
    } = Qe;
    return Qe.hasOwnCanvas || rt === 0 ? (Xe.width = `${100 * Ke / Ze}%`, Xe.height = `${100 * $e / nt}%`) : this.setRotation(rt, Ge), Ge;
  }
  setRotation(ue, Qe = this.container) {
    if (!this.data.rect)
      return;
    const {
      pageWidth: Ue,
      pageHeight: He
    } = this.parent.viewport.rawDims, {
      width: Ge,
      height: Xe
    } = getRectDims(this.data.rect);
    let Ke, $e;
    ue % 180 === 0 ? (Ke = 100 * Ge / Ue, $e = 100 * Xe / He) : (Ke = 100 * Xe / Ue, $e = 100 * Ge / He), Qe.style.width = `${Ke}%`, Qe.style.height = `${$e}%`, Qe.setAttribute("data-main-rotation", (360 - ue) % 360);
  }
  get _commonActions() {
    const ue = (Qe, Ue, He) => {
      const Ge = He.detail[Qe], Xe = Ge[0], Ke = Ge.slice(1);
      He.target.style[Ue] = ColorConverters[`${Xe}_HTML`](Ke), this.annotationStorage.setValue(this.data.id, {
        [Ue]: ColorConverters[`${Xe}_rgb`](Ke)
      });
    };
    return shadow(this, "_commonActions", {
      display: (Qe) => {
        const {
          display: Ue
        } = Qe.detail, He = Ue % 2 === 1;
        this.container.style.visibility = He ? "hidden" : "visible", this.annotationStorage.setValue(this.data.id, {
          noView: He,
          noPrint: Ue === 1 || Ue === 2
        });
      },
      print: (Qe) => {
        this.annotationStorage.setValue(this.data.id, {
          noPrint: !Qe.detail.print
        });
      },
      hidden: (Qe) => {
        const {
          hidden: Ue
        } = Qe.detail;
        this.container.style.visibility = Ue ? "hidden" : "visible", this.annotationStorage.setValue(this.data.id, {
          noPrint: Ue,
          noView: Ue
        });
      },
      focus: (Qe) => {
        setTimeout(() => Qe.target.focus({
          preventScroll: !1
        }), 0);
      },
      userName: (Qe) => {
        Qe.target.title = Qe.detail.userName;
      },
      readonly: (Qe) => {
        Qe.target.disabled = Qe.detail.readonly;
      },
      required: (Qe) => {
        this._setRequired(Qe.target, Qe.detail.required);
      },
      bgColor: (Qe) => {
        ue("bgColor", "backgroundColor", Qe);
      },
      fillColor: (Qe) => {
        ue("fillColor", "backgroundColor", Qe);
      },
      fgColor: (Qe) => {
        ue("fgColor", "color", Qe);
      },
      textColor: (Qe) => {
        ue("textColor", "color", Qe);
      },
      borderColor: (Qe) => {
        ue("borderColor", "borderColor", Qe);
      },
      strokeColor: (Qe) => {
        ue("strokeColor", "borderColor", Qe);
      },
      rotation: (Qe) => {
        const Ue = Qe.detail.rotation;
        this.setRotation(Ue), this.annotationStorage.setValue(this.data.id, {
          rotation: Ue
        });
      }
    });
  }
  _dispatchEventFromSandbox(ue, Qe) {
    const Ue = this._commonActions;
    for (const He of Object.keys(Qe.detail)) {
      const Ge = ue[He] || Ue[He];
      Ge == null || Ge(Qe);
    }
  }
  _setDefaultPropertiesFromJS(ue) {
    if (!this.enableScripting)
      return;
    const Qe = this.annotationStorage.getRawValue(this.data.id);
    if (!Qe)
      return;
    const Ue = this._commonActions;
    for (const [He, Ge] of Object.entries(Qe)) {
      const Xe = Ue[He];
      if (Xe) {
        const Ke = {
          detail: {
            [He]: Ge
          },
          target: ue
        };
        Xe(Ke), delete Qe[He];
      }
    }
  }
  _createQuadrilaterals() {
    if (!this.container)
      return;
    const {
      quadPoints: ue
    } = this.data;
    if (!ue)
      return;
    const [Qe, Ue, He, Ge] = this.data.rect;
    if (ue.length === 1) {
      const [, {
        x: it,
        y: ot
      }, {
        x: at,
        y: st
      }] = ue[0];
      if (He === it && Ge === ot && Qe === at && Ue === st)
        return;
    }
    const {
      style: Xe
    } = this.container;
    let Ke;
    if (xt(this, Vu)) {
      const {
        borderColor: it,
        borderWidth: ot
      } = Xe;
      Xe.borderWidth = 0, Ke = ["url('data:image/svg+xml;utf8,", '<svg xmlns="http://www.w3.org/2000/svg"', ' preserveAspectRatio="none" viewBox="0 0 1 1">', `<g fill="transparent" stroke="${it}" stroke-width="${ot}">`], this.container.classList.add("hasBorder");
    }
    const $e = He - Qe, Je = Ge - Ue, {
      svgFactory: Ze
    } = this, nt = Ze.createElement("svg");
    nt.classList.add("quadrilateralsContainer"), nt.setAttribute("width", 0), nt.setAttribute("height", 0);
    const tt = Ze.createElement("defs");
    nt.append(tt);
    const et = Ze.createElement("clipPath"), rt = `clippath_${this.data.id}`;
    et.setAttribute("id", rt), et.setAttribute("clipPathUnits", "objectBoundingBox"), tt.append(et);
    for (const [, {
      x: it,
      y: ot
    }, {
      x: at,
      y: st
    }] of ue) {
      const ut = Ze.createElement("rect"), lt = (at - Qe) / $e, dt = (Ge - ot) / Je, At = (it - at) / $e, pt = (ot - st) / Je;
      ut.setAttribute("x", lt), ut.setAttribute("y", dt), ut.setAttribute("width", At), ut.setAttribute("height", pt), et.append(ut), Ke == null || Ke.push(`<rect vector-effect="non-scaling-stroke" x="${lt}" y="${dt}" width="${At}" height="${pt}"/>`);
    }
    xt(this, Vu) && (Ke.push("</g></svg>')"), Xe.backgroundImage = Ke.join("")), this.container.append(nt), this.container.style.clipPath = `url(#${rt})`;
  }
  _createPopup() {
    const {
      container: ue,
      data: Qe
    } = this;
    ue.setAttribute("aria-haspopup", "dialog");
    const Ue = Zt(this, Uu, new PopupAnnotationElement({
      data: {
        color: Qe.color,
        titleObj: Qe.titleObj,
        modificationDate: Qe.modificationDate,
        contentsObj: Qe.contentsObj,
        richText: Qe.richText,
        parentRect: Qe.rect,
        borderStyle: 0,
        id: `popup_${Qe.id}`,
        rotation: Qe.rotation
      },
      parent: this.parent,
      elements: [this]
    }));
    this.parent.div.append(Ue.render());
  }
  render() {
    unreachable("Abstract method `AnnotationElement.render` called");
  }
  _getElementsByName(ue, Qe = null) {
    const Ue = [];
    if (this._fieldObjects) {
      const He = this._fieldObjects[ue];
      if (He)
        for (const {
          page: Ge,
          id: Xe,
          exportValues: Ke
        } of He) {
          if (Ge === -1 || Xe === Qe)
            continue;
          const $e = typeof Ke == "string" ? Ke : null, Je = document.querySelector(`[data-element-id="${Xe}"]`);
          if (Je && !GetElementsByNameSet.has(Je)) {
            warn(`_getElementsByName - element not allowed: ${Xe}`);
            continue;
          }
          Ue.push({
            id: Xe,
            exportValue: $e,
            domElement: Je
          });
        }
      return Ue;
    }
    for (const He of document.getElementsByName(ue)) {
      const {
        exportValue: Ge
      } = He, Xe = He.getAttribute("data-element-id");
      Xe !== Qe && GetElementsByNameSet.has(He) && Ue.push({
        id: Xe,
        exportValue: Ge,
        domElement: He
      });
    }
    return Ue;
  }
  show() {
    var ue;
    this.container && (this.container.hidden = !1), (ue = this.popup) == null || ue.maybeShow();
  }
  hide() {
    var ue;
    this.container && (this.container.hidden = !0), (ue = this.popup) == null || ue.forceHide();
  }
  getElementsToTriggerPopup() {
    return this.container;
  }
  addHighlightArea() {
    const ue = this.getElementsToTriggerPopup();
    if (Array.isArray(ue))
      for (const Qe of ue)
        Qe.classList.add("highlightArea");
    else
      ue.classList.add("highlightArea");
  }
  get _isEditable() {
    return !1;
  }
  _editOnDoubleClick() {
    if (!this._isEditable)
      return;
    const {
      annotationEditorType: ue,
      data: {
        id: Qe
      }
    } = this;
    this.container.addEventListener("dblclick", () => {
      var Ue;
      (Ue = this.linkService.eventBus) == null || Ue.dispatch("switchannotationeditormode", {
        source: this,
        mode: ue,
        editId: Qe
      });
    });
  }
};
yc = new WeakMap(), Vu = new WeakMap(), Uu = new WeakMap(), Q0 = new WeakSet(), Xh = function(ue) {
  const {
    container: {
      style: Qe
    },
    data: {
      rect: Ue,
      rotation: He
    },
    parent: {
      viewport: {
        rawDims: {
          pageWidth: Ge,
          pageHeight: Xe,
          pageX: Ke,
          pageY: $e
        }
      }
    }
  } = this;
  Ue == null || Ue.splice(0, 4, ...ue);
  const {
    width: Je,
    height: Ze
  } = getRectDims(ue);
  Qe.left = `${100 * (ue[0] - Ke) / Ge}%`, Qe.top = `${100 * (Xe - ue[3] + $e) / Xe}%`, He === 0 ? (Qe.width = `${100 * Je / Ge}%`, Qe.height = `${100 * Ze / Xe}%`) : this.setRotation(He);
};
let AnnotationElement = x1;
var na, Gs, yg, Ig;
class LinkAnnotationElement extends AnnotationElement {
  constructor(Qe, Ue = null) {
    super(Qe, {
      isRenderable: !0,
      ignoreBorder: !!(Ue != null && Ue.ignoreBorder),
      createQuadrilaterals: !0
    });
    tn(this, na);
    this.isTooltipOnly = Qe.data.isTooltipOnly;
  }
  render() {
    const {
      data: Qe,
      linkService: Ue
    } = this, He = document.createElement("a");
    He.setAttribute("data-element-id", Qe.id);
    let Ge = !1;
    return Qe.url ? (Ue.addLinkAttributes(He, Qe.url, Qe.newWindow), Ge = !0) : Qe.action ? (this._bindNamedAction(He, Qe.action), Ge = !0) : Qe.attachment ? (en(this, na, yg).call(this, He, Qe.attachment, Qe.attachmentDest), Ge = !0) : Qe.setOCGState ? (en(this, na, Ig).call(this, He, Qe.setOCGState), Ge = !0) : Qe.dest ? (this._bindLink(He, Qe.dest), Ge = !0) : (Qe.actions && (Qe.actions.Action || Qe.actions["Mouse Up"] || Qe.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions && (this._bindJSAction(He, Qe), Ge = !0), Qe.resetForm ? (this._bindResetFormAction(He, Qe.resetForm), Ge = !0) : this.isTooltipOnly && !Ge && (this._bindLink(He, ""), Ge = !0)), this.container.classList.add("linkAnnotation"), Ge && this.container.append(He), this.container;
  }
  _bindLink(Qe, Ue) {
    Qe.href = this.linkService.getDestinationHash(Ue), Qe.onclick = () => (Ue && this.linkService.goToDestination(Ue), !1), (Ue || Ue === "") && en(this, na, Gs).call(this);
  }
  _bindNamedAction(Qe, Ue) {
    Qe.href = this.linkService.getAnchorUrl(""), Qe.onclick = () => (this.linkService.executeNamedAction(Ue), !1), en(this, na, Gs).call(this);
  }
  _bindJSAction(Qe, Ue) {
    Qe.href = this.linkService.getAnchorUrl("");
    const He = /* @__PURE__ */ new Map([["Action", "onclick"], ["Mouse Up", "onmouseup"], ["Mouse Down", "onmousedown"]]);
    for (const Ge of Object.keys(Ue.actions)) {
      const Xe = He.get(Ge);
      Xe && (Qe[Xe] = () => {
        var Ke;
        return (Ke = this.linkService.eventBus) == null || Ke.dispatch("dispatcheventinsandbox", {
          source: this,
          detail: {
            id: Ue.id,
            name: Ge
          }
        }), !1;
      });
    }
    Qe.onclick || (Qe.onclick = () => !1), en(this, na, Gs).call(this);
  }
  _bindResetFormAction(Qe, Ue) {
    const He = Qe.onclick;
    if (He || (Qe.href = this.linkService.getAnchorUrl("")), en(this, na, Gs).call(this), !this._fieldObjects) {
      warn('_bindResetFormAction - "resetForm" action not supported, ensure that the `fieldObjects` parameter is provided.'), He || (Qe.onclick = () => !1);
      return;
    }
    Qe.onclick = () => {
      var nt;
      He == null || He();
      const {
        fields: Ge,
        refs: Xe,
        include: Ke
      } = Ue, $e = [];
      if (Ge.length !== 0 || Xe.length !== 0) {
        const tt = new Set(Xe);
        for (const et of Ge) {
          const rt = this._fieldObjects[et] || [];
          for (const {
            id: it
          } of rt)
            tt.add(it);
        }
        for (const et of Object.values(this._fieldObjects))
          for (const rt of et)
            tt.has(rt.id) === Ke && $e.push(rt);
      } else
        for (const tt of Object.values(this._fieldObjects))
          $e.push(...tt);
      const Je = this.annotationStorage, Ze = [];
      for (const tt of $e) {
        const {
          id: et
        } = tt;
        switch (Ze.push(et), tt.type) {
          case "text": {
            const it = tt.defaultValue || "";
            Je.setValue(et, {
              value: it
            });
            break;
          }
          case "checkbox":
          case "radiobutton": {
            const it = tt.defaultValue === tt.exportValues;
            Je.setValue(et, {
              value: it
            });
            break;
          }
          case "combobox":
          case "listbox": {
            const it = tt.defaultValue || "";
            Je.setValue(et, {
              value: it
            });
            break;
          }
          default:
            continue;
        }
        const rt = document.querySelector(`[data-element-id="${et}"]`);
        if (rt) {
          if (!GetElementsByNameSet.has(rt)) {
            warn(`_bindResetFormAction - element not allowed: ${et}`);
            continue;
          }
        } else continue;
        rt.dispatchEvent(new Event("resetform"));
      }
      return this.enableScripting && ((nt = this.linkService.eventBus) == null || nt.dispatch("dispatcheventinsandbox", {
        source: this,
        detail: {
          id: "app",
          ids: Ze,
          name: "ResetForm"
        }
      })), !1;
    };
  }
}
na = new WeakSet(), Gs = function() {
  this.container.setAttribute("data-internal-link", "");
}, yg = function(Qe, Ue, He = null) {
  Qe.href = this.linkService.getAnchorUrl(""), Ue.description && (Qe.title = Ue.description), Qe.onclick = () => {
    var Ge;
    return (Ge = this.downloadManager) == null || Ge.openOrDownloadData(Ue.content, Ue.filename, He), !1;
  }, en(this, na, Gs).call(this);
}, Ig = function(Qe, Ue) {
  Qe.href = this.linkService.getAnchorUrl(""), Qe.onclick = () => (this.linkService.executeSetOCGState(Ue), !1), en(this, na, Gs).call(this);
};
class TextAnnotationElement extends AnnotationElement {
  constructor(ue) {
    super(ue, {
      isRenderable: !0
    });
  }
  render() {
    this.container.classList.add("textAnnotation");
    const ue = document.createElement("img");
    return ue.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg", ue.setAttribute("data-l10n-id", "pdfjs-text-annotation-type"), ue.setAttribute("data-l10n-args", JSON.stringify({
      type: this.data.name
    })), !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container.append(ue), this.container;
  }
}
class WidgetAnnotationElement extends AnnotationElement {
  render() {
    return this.container;
  }
  showElementAndHideCanvas(ue) {
    var Qe;
    this.data.hasOwnCanvas && (((Qe = ue.previousSibling) == null ? void 0 : Qe.nodeName) === "CANVAS" && (ue.previousSibling.hidden = !0), ue.hidden = !1);
  }
  _getKeyModifier(ue) {
    return util_FeatureTest.platform.isMac ? ue.metaKey : ue.ctrlKey;
  }
  _setEventListener(ue, Qe, Ue, He, Ge) {
    Ue.includes("mouse") ? ue.addEventListener(Ue, (Xe) => {
      var Ke;
      (Ke = this.linkService.eventBus) == null || Ke.dispatch("dispatcheventinsandbox", {
        source: this,
        detail: {
          id: this.data.id,
          name: He,
          value: Ge(Xe),
          shift: Xe.shiftKey,
          modifier: this._getKeyModifier(Xe)
        }
      });
    }) : ue.addEventListener(Ue, (Xe) => {
      var Ke;
      if (Ue === "blur") {
        if (!Qe.focused || !Xe.relatedTarget)
          return;
        Qe.focused = !1;
      } else if (Ue === "focus") {
        if (Qe.focused)
          return;
        Qe.focused = !0;
      }
      Ge && ((Ke = this.linkService.eventBus) == null || Ke.dispatch("dispatcheventinsandbox", {
        source: this,
        detail: {
          id: this.data.id,
          name: He,
          value: Ge(Xe)
        }
      }));
    });
  }
  _setEventListeners(ue, Qe, Ue, He) {
    var Ge, Xe, Ke;
    for (const [$e, Je] of Ue)
      (Je === "Action" || (Ge = this.data.actions) != null && Ge[Je]) && ((Je === "Focus" || Je === "Blur") && (Qe || (Qe = {
        focused: !1
      })), this._setEventListener(ue, Qe, $e, Je, He), Je === "Focus" && !((Xe = this.data.actions) != null && Xe.Blur) ? this._setEventListener(ue, Qe, "blur", "Blur", null) : Je === "Blur" && !((Ke = this.data.actions) != null && Ke.Focus) && this._setEventListener(ue, Qe, "focus", "Focus", null));
  }
  _setBackgroundColor(ue) {
    const Qe = this.data.backgroundColor || null;
    ue.style.backgroundColor = Qe === null ? "transparent" : Util.makeHexColor(Qe[0], Qe[1], Qe[2]);
  }
  _setTextStyle(ue) {
    const Qe = ["left", "center", "right"], {
      fontColor: Ue
    } = this.data.defaultAppearanceData, He = this.data.defaultAppearanceData.fontSize || annotation_layer_DEFAULT_FONT_SIZE, Ge = ue.style;
    let Xe;
    const Ke = 2, $e = (Je) => Math.round(10 * Je) / 10;
    if (this.data.multiLine) {
      const Je = Math.abs(this.data.rect[3] - this.data.rect[1] - Ke), Ze = Math.round(Je / (LINE_FACTOR * He)) || 1, nt = Je / Ze;
      Xe = Math.min(He, $e(nt / LINE_FACTOR));
    } else {
      const Je = Math.abs(this.data.rect[3] - this.data.rect[1] - Ke);
      Xe = Math.min(He, $e(Je / LINE_FACTOR));
    }
    Ge.fontSize = `calc(${Xe}px * var(--scale-factor))`, Ge.color = Util.makeHexColor(Ue[0], Ue[1], Ue[2]), this.data.textAlignment !== null && (Ge.textAlign = Qe[this.data.textAlignment]);
  }
  _setRequired(ue, Qe) {
    Qe ? ue.setAttribute("required", !0) : ue.removeAttribute("required"), ue.setAttribute("aria-required", Qe);
  }
}
class TextWidgetAnnotationElement extends WidgetAnnotationElement {
  constructor(ue) {
    const Qe = ue.renderForms || ue.data.hasOwnCanvas || !ue.data.hasAppearance && !!ue.data.fieldValue;
    super(ue, {
      isRenderable: Qe
    });
  }
  setPropertyOnSiblings(ue, Qe, Ue, He) {
    const Ge = this.annotationStorage;
    for (const Xe of this._getElementsByName(ue.name, ue.id))
      Xe.domElement && (Xe.domElement[Qe] = Ue), Ge.setValue(Xe.id, {
        [He]: Ue
      });
  }
  render() {
    var He, Ge;
    const ue = this.annotationStorage, Qe = this.data.id;
    this.container.classList.add("textWidgetAnnotation");
    let Ue = null;
    if (this.renderForms) {
      const Xe = ue.getValue(Qe, {
        value: this.data.fieldValue
      });
      let Ke = Xe.value || "";
      const $e = ue.getValue(Qe, {
        charLimit: this.data.maxLen
      }).charLimit;
      $e && Ke.length > $e && (Ke = Ke.slice(0, $e));
      let Je = Xe.formattedValue || ((He = this.data.textContent) == null ? void 0 : He.join(`
`)) || null;
      Je && this.data.comb && (Je = Je.replaceAll(/\s+/g, ""));
      const Ze = {
        userValue: Ke,
        formattedValue: Je,
        lastCommittedValue: null,
        commitKey: 1,
        focused: !1
      };
      this.data.multiLine ? (Ue = document.createElement("textarea"), Ue.textContent = Je ?? Ke, this.data.doNotScroll && (Ue.style.overflowY = "hidden")) : (Ue = document.createElement("input"), Ue.type = "text", Ue.setAttribute("value", Je ?? Ke), this.data.doNotScroll && (Ue.style.overflowX = "hidden")), this.data.hasOwnCanvas && (Ue.hidden = !0), GetElementsByNameSet.add(Ue), Ue.setAttribute("data-element-id", Qe), Ue.disabled = this.data.readOnly, Ue.name = this.data.fieldName, Ue.tabIndex = DEFAULT_TAB_INDEX, this._setRequired(Ue, this.data.required), $e && (Ue.maxLength = $e), Ue.addEventListener("input", (tt) => {
        ue.setValue(Qe, {
          value: tt.target.value
        }), this.setPropertyOnSiblings(Ue, "value", tt.target.value, "value"), Ze.formattedValue = null;
      }), Ue.addEventListener("resetform", (tt) => {
        const et = this.data.defaultFieldValue ?? "";
        Ue.value = Ze.userValue = et, Ze.formattedValue = null;
      });
      let nt = (tt) => {
        const {
          formattedValue: et
        } = Ze;
        et != null && (tt.target.value = et), tt.target.scrollLeft = 0;
      };
      if (this.enableScripting && this.hasJSActions) {
        Ue.addEventListener("focus", (et) => {
          var it;
          if (Ze.focused)
            return;
          const {
            target: rt
          } = et;
          Ze.userValue && (rt.value = Ze.userValue), Ze.lastCommittedValue = rt.value, Ze.commitKey = 1, (it = this.data.actions) != null && it.Focus || (Ze.focused = !0);
        }), Ue.addEventListener("updatefromsandbox", (et) => {
          this.showElementAndHideCanvas(et.target);
          const rt = {
            value(it) {
              Ze.userValue = it.detail.value ?? "", ue.setValue(Qe, {
                value: Ze.userValue.toString()
              }), it.target.value = Ze.userValue;
            },
            formattedValue(it) {
              const {
                formattedValue: ot
              } = it.detail;
              Ze.formattedValue = ot, ot != null && it.target !== document.activeElement && (it.target.value = ot), ue.setValue(Qe, {
                formattedValue: ot
              });
            },
            selRange(it) {
              it.target.setSelectionRange(...it.detail.selRange);
            },
            charLimit: (it) => {
              var ut;
              const {
                charLimit: ot
              } = it.detail, {
                target: at
              } = it;
              if (ot === 0) {
                at.removeAttribute("maxLength");
                return;
              }
              at.setAttribute("maxLength", ot);
              let st = Ze.userValue;
              !st || st.length <= ot || (st = st.slice(0, ot), at.value = Ze.userValue = st, ue.setValue(Qe, {
                value: st
              }), (ut = this.linkService.eventBus) == null || ut.dispatch("dispatcheventinsandbox", {
                source: this,
                detail: {
                  id: Qe,
                  name: "Keystroke",
                  value: st,
                  willCommit: !0,
                  commitKey: 1,
                  selStart: at.selectionStart,
                  selEnd: at.selectionEnd
                }
              }));
            }
          };
          this._dispatchEventFromSandbox(rt, et);
        }), Ue.addEventListener("keydown", (et) => {
          var ot;
          Ze.commitKey = 1;
          let rt = -1;
          if (et.key === "Escape" ? rt = 0 : et.key === "Enter" && !this.data.multiLine ? rt = 2 : et.key === "Tab" && (Ze.commitKey = 3), rt === -1)
            return;
          const {
            value: it
          } = et.target;
          Ze.lastCommittedValue !== it && (Ze.lastCommittedValue = it, Ze.userValue = it, (ot = this.linkService.eventBus) == null || ot.dispatch("dispatcheventinsandbox", {
            source: this,
            detail: {
              id: Qe,
              name: "Keystroke",
              value: it,
              willCommit: !0,
              commitKey: rt,
              selStart: et.target.selectionStart,
              selEnd: et.target.selectionEnd
            }
          }));
        });
        const tt = nt;
        nt = null, Ue.addEventListener("blur", (et) => {
          var it, ot;
          if (!Ze.focused || !et.relatedTarget)
            return;
          (it = this.data.actions) != null && it.Blur || (Ze.focused = !1);
          const {
            value: rt
          } = et.target;
          Ze.userValue = rt, Ze.lastCommittedValue !== rt && ((ot = this.linkService.eventBus) == null || ot.dispatch("dispatcheventinsandbox", {
            source: this,
            detail: {
              id: Qe,
              name: "Keystroke",
              value: rt,
              willCommit: !0,
              commitKey: Ze.commitKey,
              selStart: et.target.selectionStart,
              selEnd: et.target.selectionEnd
            }
          })), tt(et);
        }), (Ge = this.data.actions) != null && Ge.Keystroke && Ue.addEventListener("beforeinput", (et) => {
          var dt;
          Ze.lastCommittedValue = null;
          const {
            data: rt,
            target: it
          } = et, {
            value: ot,
            selectionStart: at,
            selectionEnd: st
          } = it;
          let ut = at, lt = st;
          switch (et.inputType) {
            case "deleteWordBackward": {
              const At = ot.substring(0, at).match(/\w*[^\w]*$/);
              At && (ut -= At[0].length);
              break;
            }
            case "deleteWordForward": {
              const At = ot.substring(at).match(/^[^\w]*\w*/);
              At && (lt += At[0].length);
              break;
            }
            case "deleteContentBackward":
              at === st && (ut -= 1);
              break;
            case "deleteContentForward":
              at === st && (lt += 1);
              break;
          }
          et.preventDefault(), (dt = this.linkService.eventBus) == null || dt.dispatch("dispatcheventinsandbox", {
            source: this,
            detail: {
              id: Qe,
              name: "Keystroke",
              value: ot,
              change: rt || "",
              willCommit: !1,
              selStart: ut,
              selEnd: lt
            }
          });
        }), this._setEventListeners(Ue, Ze, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (et) => et.target.value);
      }
      if (nt && Ue.addEventListener("blur", nt), this.data.comb) {
        const et = (this.data.rect[2] - this.data.rect[0]) / $e;
        Ue.classList.add("comb"), Ue.style.letterSpacing = `calc(${et}px * var(--scale-factor) - 1ch)`;
      }
    } else
      Ue = document.createElement("div"), Ue.textContent = this.data.fieldValue, Ue.style.verticalAlign = "middle", Ue.style.display = "table-cell", this.data.hasOwnCanvas && (Ue.hidden = !0);
    return this._setTextStyle(Ue), this._setBackgroundColor(Ue), this._setDefaultPropertiesFromJS(Ue), this.container.append(Ue), this.container;
  }
}
class SignatureWidgetAnnotationElement extends WidgetAnnotationElement {
  constructor(ue) {
    super(ue, {
      isRenderable: !!ue.data.hasOwnCanvas
    });
  }
}
class CheckboxWidgetAnnotationElement extends WidgetAnnotationElement {
  constructor(ue) {
    super(ue, {
      isRenderable: ue.renderForms
    });
  }
  render() {
    const ue = this.annotationStorage, Qe = this.data, Ue = Qe.id;
    let He = ue.getValue(Ue, {
      value: Qe.exportValue === Qe.fieldValue
    }).value;
    typeof He == "string" && (He = He !== "Off", ue.setValue(Ue, {
      value: He
    })), this.container.classList.add("buttonWidgetAnnotation", "checkBox");
    const Ge = document.createElement("input");
    return GetElementsByNameSet.add(Ge), Ge.setAttribute("data-element-id", Ue), Ge.disabled = Qe.readOnly, this._setRequired(Ge, this.data.required), Ge.type = "checkbox", Ge.name = Qe.fieldName, He && Ge.setAttribute("checked", !0), Ge.setAttribute("exportValue", Qe.exportValue), Ge.tabIndex = DEFAULT_TAB_INDEX, Ge.addEventListener("change", (Xe) => {
      const {
        name: Ke,
        checked: $e
      } = Xe.target;
      for (const Je of this._getElementsByName(Ke, Ue)) {
        const Ze = $e && Je.exportValue === Qe.exportValue;
        Je.domElement && (Je.domElement.checked = Ze), ue.setValue(Je.id, {
          value: Ze
        });
      }
      ue.setValue(Ue, {
        value: $e
      });
    }), Ge.addEventListener("resetform", (Xe) => {
      const Ke = Qe.defaultFieldValue || "Off";
      Xe.target.checked = Ke === Qe.exportValue;
    }), this.enableScripting && this.hasJSActions && (Ge.addEventListener("updatefromsandbox", (Xe) => {
      const Ke = {
        value($e) {
          $e.target.checked = $e.detail.value !== "Off", ue.setValue(Ue, {
            value: $e.target.checked
          });
        }
      };
      this._dispatchEventFromSandbox(Ke, Xe);
    }), this._setEventListeners(Ge, null, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (Xe) => Xe.target.checked)), this._setBackgroundColor(Ge), this._setDefaultPropertiesFromJS(Ge), this.container.append(Ge), this.container;
  }
}
class RadioButtonWidgetAnnotationElement extends WidgetAnnotationElement {
  constructor(ue) {
    super(ue, {
      isRenderable: ue.renderForms
    });
  }
  render() {
    this.container.classList.add("buttonWidgetAnnotation", "radioButton");
    const ue = this.annotationStorage, Qe = this.data, Ue = Qe.id;
    let He = ue.getValue(Ue, {
      value: Qe.fieldValue === Qe.buttonValue
    }).value;
    if (typeof He == "string" && (He = He !== Qe.buttonValue, ue.setValue(Ue, {
      value: He
    })), He)
      for (const Xe of this._getElementsByName(Qe.fieldName, Ue))
        ue.setValue(Xe.id, {
          value: !1
        });
    const Ge = document.createElement("input");
    if (GetElementsByNameSet.add(Ge), Ge.setAttribute("data-element-id", Ue), Ge.disabled = Qe.readOnly, this._setRequired(Ge, this.data.required), Ge.type = "radio", Ge.name = Qe.fieldName, He && Ge.setAttribute("checked", !0), Ge.tabIndex = DEFAULT_TAB_INDEX, Ge.addEventListener("change", (Xe) => {
      const {
        name: Ke,
        checked: $e
      } = Xe.target;
      for (const Je of this._getElementsByName(Ke, Ue))
        ue.setValue(Je.id, {
          value: !1
        });
      ue.setValue(Ue, {
        value: $e
      });
    }), Ge.addEventListener("resetform", (Xe) => {
      const Ke = Qe.defaultFieldValue;
      Xe.target.checked = Ke != null && Ke === Qe.buttonValue;
    }), this.enableScripting && this.hasJSActions) {
      const Xe = Qe.buttonValue;
      Ge.addEventListener("updatefromsandbox", (Ke) => {
        const $e = {
          value: (Je) => {
            const Ze = Xe === Je.detail.value;
            for (const nt of this._getElementsByName(Je.target.name)) {
              const tt = Ze && nt.id === Ue;
              nt.domElement && (nt.domElement.checked = tt), ue.setValue(nt.id, {
                value: tt
              });
            }
          }
        };
        this._dispatchEventFromSandbox($e, Ke);
      }), this._setEventListeners(Ge, null, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (Ke) => Ke.target.checked);
    }
    return this._setBackgroundColor(Ge), this._setDefaultPropertiesFromJS(Ge), this.container.append(Ge), this.container;
  }
}
class PushButtonWidgetAnnotationElement extends LinkAnnotationElement {
  constructor(ue) {
    super(ue, {
      ignoreBorder: ue.data.hasAppearance
    });
  }
  render() {
    const ue = super.render();
    ue.classList.add("buttonWidgetAnnotation", "pushButton");
    const Qe = ue.lastChild;
    return this.enableScripting && this.hasJSActions && Qe && (this._setDefaultPropertiesFromJS(Qe), Qe.addEventListener("updatefromsandbox", (Ue) => {
      this._dispatchEventFromSandbox({}, Ue);
    })), ue;
  }
}
class ChoiceWidgetAnnotationElement extends WidgetAnnotationElement {
  constructor(ue) {
    super(ue, {
      isRenderable: ue.renderForms
    });
  }
  render() {
    this.container.classList.add("choiceWidgetAnnotation");
    const ue = this.annotationStorage, Qe = this.data.id, Ue = ue.getValue(Qe, {
      value: this.data.fieldValue
    }), He = document.createElement("select");
    GetElementsByNameSet.add(He), He.setAttribute("data-element-id", Qe), He.disabled = this.data.readOnly, this._setRequired(He, this.data.required), He.name = this.data.fieldName, He.tabIndex = DEFAULT_TAB_INDEX;
    let Ge = this.data.combo && this.data.options.length > 0;
    this.data.combo || (He.size = this.data.options.length, this.data.multiSelect && (He.multiple = !0)), He.addEventListener("resetform", (Ze) => {
      const nt = this.data.defaultFieldValue;
      for (const tt of He.options)
        tt.selected = tt.value === nt;
    });
    for (const Ze of this.data.options) {
      const nt = document.createElement("option");
      nt.textContent = Ze.displayValue, nt.value = Ze.exportValue, Ue.value.includes(Ze.exportValue) && (nt.setAttribute("selected", !0), Ge = !1), He.append(nt);
    }
    let Xe = null;
    if (Ge) {
      const Ze = document.createElement("option");
      Ze.value = " ", Ze.setAttribute("hidden", !0), Ze.setAttribute("selected", !0), He.prepend(Ze), Xe = () => {
        Ze.remove(), He.removeEventListener("input", Xe), Xe = null;
      }, He.addEventListener("input", Xe);
    }
    const Ke = (Ze) => {
      const nt = Ze ? "value" : "textContent", {
        options: tt,
        multiple: et
      } = He;
      return et ? Array.prototype.filter.call(tt, (rt) => rt.selected).map((rt) => rt[nt]) : tt.selectedIndex === -1 ? null : tt[tt.selectedIndex][nt];
    };
    let $e = Ke(!1);
    const Je = (Ze) => {
      const nt = Ze.target.options;
      return Array.prototype.map.call(nt, (tt) => ({
        displayValue: tt.textContent,
        exportValue: tt.value
      }));
    };
    return this.enableScripting && this.hasJSActions ? (He.addEventListener("updatefromsandbox", (Ze) => {
      const nt = {
        value(tt) {
          Xe == null || Xe();
          const et = tt.detail.value, rt = new Set(Array.isArray(et) ? et : [et]);
          for (const it of He.options)
            it.selected = rt.has(it.value);
          ue.setValue(Qe, {
            value: Ke(!0)
          }), $e = Ke(!1);
        },
        multipleSelection(tt) {
          He.multiple = !0;
        },
        remove(tt) {
          const et = He.options, rt = tt.detail.remove;
          et[rt].selected = !1, He.remove(rt), et.length > 0 && Array.prototype.findIndex.call(et, (ot) => ot.selected) === -1 && (et[0].selected = !0), ue.setValue(Qe, {
            value: Ke(!0),
            items: Je(tt)
          }), $e = Ke(!1);
        },
        clear(tt) {
          for (; He.length !== 0; )
            He.remove(0);
          ue.setValue(Qe, {
            value: null,
            items: []
          }), $e = Ke(!1);
        },
        insert(tt) {
          const {
            index: et,
            displayValue: rt,
            exportValue: it
          } = tt.detail.insert, ot = He.children[et], at = document.createElement("option");
          at.textContent = rt, at.value = it, ot ? ot.before(at) : He.append(at), ue.setValue(Qe, {
            value: Ke(!0),
            items: Je(tt)
          }), $e = Ke(!1);
        },
        items(tt) {
          const {
            items: et
          } = tt.detail;
          for (; He.length !== 0; )
            He.remove(0);
          for (const rt of et) {
            const {
              displayValue: it,
              exportValue: ot
            } = rt, at = document.createElement("option");
            at.textContent = it, at.value = ot, He.append(at);
          }
          He.options.length > 0 && (He.options[0].selected = !0), ue.setValue(Qe, {
            value: Ke(!0),
            items: Je(tt)
          }), $e = Ke(!1);
        },
        indices(tt) {
          const et = new Set(tt.detail.indices);
          for (const rt of tt.target.options)
            rt.selected = et.has(rt.index);
          ue.setValue(Qe, {
            value: Ke(!0)
          }), $e = Ke(!1);
        },
        editable(tt) {
          tt.target.disabled = !tt.detail.editable;
        }
      };
      this._dispatchEventFromSandbox(nt, Ze);
    }), He.addEventListener("input", (Ze) => {
      var et;
      const nt = Ke(!0), tt = Ke(!1);
      ue.setValue(Qe, {
        value: nt
      }), Ze.preventDefault(), (et = this.linkService.eventBus) == null || et.dispatch("dispatcheventinsandbox", {
        source: this,
        detail: {
          id: Qe,
          name: "Keystroke",
          value: $e,
          change: tt,
          changeEx: nt,
          willCommit: !1,
          commitKey: 1,
          keyDown: !1
        }
      });
    }), this._setEventListeners(He, null, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"], ["input", "Action"], ["input", "Validate"]], (Ze) => Ze.target.value)) : He.addEventListener("input", function(Ze) {
      ue.setValue(Qe, {
        value: Ke(!0)
      });
    }), this.data.combo && this._setTextStyle(He), this._setBackgroundColor(He), this._setDefaultPropertiesFromJS(He), this.container.append(He), this.container;
  }
}
class PopupAnnotationElement extends AnnotationElement {
  constructor(ue) {
    const {
      data: Qe,
      elements: Ue
    } = ue;
    super(ue, {
      isRenderable: AnnotationElement._hasPopupData(Qe)
    }), this.elements = Ue, this.popup = null;
  }
  render() {
    this.container.classList.add("popupAnnotation");
    const ue = this.popup = new PopupElement({
      container: this.container,
      color: this.data.color,
      titleObj: this.data.titleObj,
      modificationDate: this.data.modificationDate,
      contentsObj: this.data.contentsObj,
      richText: this.data.richText,
      rect: this.data.rect,
      parentRect: this.data.parentRect || null,
      parent: this.parent,
      elements: this.elements,
      open: this.data.open
    }), Qe = [];
    for (const Ue of this.elements)
      Ue.popup = ue, Qe.push(Ue.data.id), Ue.addHighlightArea();
    return this.container.setAttribute("aria-controls", Qe.map((Ue) => `${AnnotationPrefix}${Ue}`).join(",")), this.container;
  }
}
var Hu, nf, rf, Gu, Ic, Xr, No, xc, F0, j0, Wu, Do, Sa, Po, V0, ko, U0, bc, Sc, Br, T2, Kh, xg, bg, Sg, wg, B2, R2, Yh;
class PopupElement {
  constructor({
    container: ue,
    color: Qe,
    elements: Ue,
    titleObj: He,
    modificationDate: Ge,
    contentsObj: Xe,
    richText: Ke,
    parent: $e,
    rect: Je,
    parentRect: Ze,
    open: nt
  }) {
    tn(this, Br);
    tn(this, Hu, en(this, Br, Sg).bind(this));
    tn(this, nf, en(this, Br, Yh).bind(this));
    tn(this, rf, en(this, Br, R2).bind(this));
    tn(this, Gu, en(this, Br, B2).bind(this));
    tn(this, Ic, null);
    tn(this, Xr, null);
    tn(this, No, null);
    tn(this, xc, null);
    tn(this, F0, null);
    tn(this, j0, null);
    tn(this, Wu, null);
    tn(this, Do, !1);
    tn(this, Sa, null);
    tn(this, Po, null);
    tn(this, V0, null);
    tn(this, ko, null);
    tn(this, U0, null);
    tn(this, bc, null);
    tn(this, Sc, !1);
    var tt;
    Zt(this, Xr, ue), Zt(this, U0, He), Zt(this, No, Xe), Zt(this, ko, Ke), Zt(this, j0, $e), Zt(this, Ic, Qe), Zt(this, V0, Je), Zt(this, Wu, Ze), Zt(this, F0, Ue), Zt(this, xc, PDFDateString.toDateObject(Ge)), this.trigger = Ue.flatMap((et) => et.getElementsToTriggerPopup());
    for (const et of this.trigger)
      et.addEventListener("click", xt(this, Gu)), et.addEventListener("mouseenter", xt(this, rf)), et.addEventListener("mouseleave", xt(this, nf)), et.classList.add("popupTriggerArea");
    for (const et of Ue)
      (tt = et.container) == null || tt.addEventListener("keydown", xt(this, Hu));
    xt(this, Xr).hidden = !0, nt && en(this, Br, B2).call(this);
  }
  render() {
    if (xt(this, Sa))
      return;
    const ue = Zt(this, Sa, document.createElement("div"));
    if (ue.className = "popup", xt(this, Ic)) {
      const Ge = ue.style.outlineColor = Util.makeHexColor(...xt(this, Ic));
      CSS.supports("background-color", "color-mix(in srgb, red 30%, white)") ? ue.style.backgroundColor = `color-mix(in srgb, ${Ge} 30%, white)` : ue.style.backgroundColor = Util.makeHexColor(...xt(this, Ic).map((Ke) => Math.floor(0.7 * (255 - Ke) + Ke)));
    }
    const Qe = document.createElement("span");
    Qe.className = "header";
    const Ue = document.createElement("h1");
    if (Qe.append(Ue), {
      dir: Ue.dir,
      str: Ue.textContent
    } = xt(this, U0), ue.append(Qe), xt(this, xc)) {
      const Ge = document.createElement("span");
      Ge.classList.add("popupDate"), Ge.setAttribute("data-l10n-id", "pdfjs-annotation-date-string"), Ge.setAttribute("data-l10n-args", JSON.stringify({
        date: xt(this, xc).toLocaleDateString(),
        time: xt(this, xc).toLocaleTimeString()
      })), Qe.append(Ge);
    }
    const He = xt(this, Br, T2);
    if (He)
      XfaLayer.render({
        xfaHtml: He,
        intent: "richText",
        div: ue
      }), ue.lastChild.classList.add("richText", "popupContent");
    else {
      const Ge = this._formatContents(xt(this, No));
      ue.append(Ge);
    }
    xt(this, Xr).append(ue);
  }
  _formatContents({
    str: ue,
    dir: Qe
  }) {
    const Ue = document.createElement("p");
    Ue.classList.add("popupContent"), Ue.dir = Qe;
    const He = ue.split(/(?:\r\n?|\n)/);
    for (let Ge = 0, Xe = He.length; Ge < Xe; ++Ge) {
      const Ke = He[Ge];
      Ue.append(document.createTextNode(Ke)), Ge < Xe - 1 && Ue.append(document.createElement("br"));
    }
    return Ue;
  }
  updateEdited({
    rect: ue,
    popupContent: Qe
  }) {
    var Ue;
    xt(this, bc) || Zt(this, bc, {
      contentsObj: xt(this, No),
      richText: xt(this, ko)
    }), ue && Zt(this, Po, null), Qe && (Zt(this, ko, en(this, Br, bg).call(this, Qe)), Zt(this, No, null)), (Ue = xt(this, Sa)) == null || Ue.remove(), Zt(this, Sa, null);
  }
  resetEdited() {
    var ue;
    xt(this, bc) && ({
      contentsObj: Xi(this, No)._,
      richText: Xi(this, ko)._
    } = xt(this, bc), Zt(this, bc, null), (ue = xt(this, Sa)) == null || ue.remove(), Zt(this, Sa, null), Zt(this, Po, null));
  }
  forceHide() {
    Zt(this, Sc, this.isVisible), xt(this, Sc) && (xt(this, Xr).hidden = !0);
  }
  maybeShow() {
    xt(this, Sc) && (xt(this, Sa) || en(this, Br, R2).call(this), Zt(this, Sc, !1), xt(this, Xr).hidden = !1);
  }
  get isVisible() {
    return xt(this, Xr).hidden === !1;
  }
}
Hu = new WeakMap(), nf = new WeakMap(), rf = new WeakMap(), Gu = new WeakMap(), Ic = new WeakMap(), Xr = new WeakMap(), No = new WeakMap(), xc = new WeakMap(), F0 = new WeakMap(), j0 = new WeakMap(), Wu = new WeakMap(), Do = new WeakMap(), Sa = new WeakMap(), Po = new WeakMap(), V0 = new WeakMap(), ko = new WeakMap(), U0 = new WeakMap(), bc = new WeakMap(), Sc = new WeakMap(), Br = new WeakSet(), T2 = function() {
  const ue = xt(this, ko), Qe = xt(this, No);
  return ue != null && ue.str && (!(Qe != null && Qe.str) || Qe.str === ue.str) && xt(this, ko).html || null;
}, Kh = function() {
  var ue, Qe, Ue;
  return ((Ue = (Qe = (ue = xt(this, Br, T2)) == null ? void 0 : ue.attributes) == null ? void 0 : Qe.style) == null ? void 0 : Ue.fontSize) || 0;
}, xg = function() {
  var ue, Qe, Ue;
  return ((Ue = (Qe = (ue = xt(this, Br, T2)) == null ? void 0 : ue.attributes) == null ? void 0 : Qe.style) == null ? void 0 : Ue.color) || null;
}, bg = function(ue) {
  const Qe = [], Ue = {
    str: ue,
    html: {
      name: "div",
      attributes: {
        dir: "auto"
      },
      children: [{
        name: "p",
        children: Qe
      }]
    }
  }, He = {
    style: {
      color: xt(this, Br, xg),
      fontSize: xt(this, Br, Kh) ? `calc(${xt(this, Br, Kh)}px * var(--scale-factor))` : ""
    }
  };
  for (const Ge of ue.split(`
`))
    Qe.push({
      name: "span",
      value: Ge,
      attributes: He
    });
  return Ue;
}, Sg = function(ue) {
  ue.altKey || ue.shiftKey || ue.ctrlKey || ue.metaKey || (ue.key === "Enter" || ue.key === "Escape" && xt(this, Do)) && en(this, Br, B2).call(this);
}, wg = function() {
  if (xt(this, Po) !== null)
    return;
  const {
    page: {
      view: ue
    },
    viewport: {
      rawDims: {
        pageWidth: Qe,
        pageHeight: Ue,
        pageX: He,
        pageY: Ge
      }
    }
  } = xt(this, j0);
  let Xe = !!xt(this, Wu), Ke = Xe ? xt(this, Wu) : xt(this, V0);
  for (const rt of xt(this, F0))
    if (!Ke || Util.intersect(rt.data.rect, Ke) !== null) {
      Ke = rt.data.rect, Xe = !0;
      break;
    }
  const $e = Util.normalizeRect([Ke[0], ue[3] - Ke[1] + ue[1], Ke[2], ue[3] - Ke[3] + ue[1]]), Ze = Xe ? Ke[2] - Ke[0] + 5 : 0, nt = $e[0] + Ze, tt = $e[1];
  Zt(this, Po, [100 * (nt - He) / Qe, 100 * (tt - Ge) / Ue]);
  const {
    style: et
  } = xt(this, Xr);
  et.left = `${xt(this, Po)[0]}%`, et.top = `${xt(this, Po)[1]}%`;
}, B2 = function() {
  Zt(this, Do, !xt(this, Do)), xt(this, Do) ? (en(this, Br, R2).call(this), xt(this, Xr).addEventListener("click", xt(this, Gu)), xt(this, Xr).addEventListener("keydown", xt(this, Hu))) : (en(this, Br, Yh).call(this), xt(this, Xr).removeEventListener("click", xt(this, Gu)), xt(this, Xr).removeEventListener("keydown", xt(this, Hu)));
}, R2 = function() {
  xt(this, Sa) || this.render(), this.isVisible ? xt(this, Do) && xt(this, Xr).classList.add("focused") : (en(this, Br, wg).call(this), xt(this, Xr).hidden = !1, xt(this, Xr).style.zIndex = parseInt(xt(this, Xr).style.zIndex) + 1e3);
}, Yh = function() {
  xt(this, Xr).classList.remove("focused"), !(xt(this, Do) || !this.isVisible) && (xt(this, Xr).hidden = !0, xt(this, Xr).style.zIndex = parseInt(xt(this, Xr).style.zIndex) - 1e3);
};
class FreeTextAnnotationElement extends AnnotationElement {
  constructor(ue) {
    super(ue, {
      isRenderable: !0,
      ignoreBorder: !0
    }), this.textContent = ue.data.textContent, this.textPosition = ue.data.textPosition, this.annotationEditorType = AnnotationEditorType.FREETEXT;
  }
  render() {
    if (this.container.classList.add("freeTextAnnotation"), this.textContent) {
      const ue = document.createElement("div");
      ue.classList.add("annotationTextContent"), ue.setAttribute("role", "comment");
      for (const Qe of this.textContent) {
        const Ue = document.createElement("span");
        Ue.textContent = Qe, ue.append(Ue);
      }
      this.container.append(ue);
    }
    return !this.data.popupRef && this.hasPopupData && this._createPopup(), this._editOnDoubleClick(), this.container;
  }
  get _isEditable() {
    return this.data.hasOwnCanvas;
  }
}
var H0;
class LineAnnotationElement extends AnnotationElement {
  constructor(Qe) {
    super(Qe, {
      isRenderable: !0,
      ignoreBorder: !0
    });
    tn(this, H0, null);
  }
  render() {
    this.container.classList.add("lineAnnotation");
    const Qe = this.data, {
      width: Ue,
      height: He
    } = getRectDims(Qe.rect), Ge = this.svgFactory.create(Ue, He, !0), Xe = Zt(this, H0, this.svgFactory.createElement("svg:line"));
    return Xe.setAttribute("x1", Qe.rect[2] - Qe.lineCoordinates[0]), Xe.setAttribute("y1", Qe.rect[3] - Qe.lineCoordinates[1]), Xe.setAttribute("x2", Qe.rect[2] - Qe.lineCoordinates[2]), Xe.setAttribute("y2", Qe.rect[3] - Qe.lineCoordinates[3]), Xe.setAttribute("stroke-width", Qe.borderStyle.width || 1), Xe.setAttribute("stroke", "transparent"), Xe.setAttribute("fill", "transparent"), Ge.append(Xe), this.container.append(Ge), !Qe.popupRef && this.hasPopupData && this._createPopup(), this.container;
  }
  getElementsToTriggerPopup() {
    return xt(this, H0);
  }
  addHighlightArea() {
    this.container.classList.add("highlightArea");
  }
}
H0 = new WeakMap();
var G0;
class SquareAnnotationElement extends AnnotationElement {
  constructor(Qe) {
    super(Qe, {
      isRenderable: !0,
      ignoreBorder: !0
    });
    tn(this, G0, null);
  }
  render() {
    this.container.classList.add("squareAnnotation");
    const Qe = this.data, {
      width: Ue,
      height: He
    } = getRectDims(Qe.rect), Ge = this.svgFactory.create(Ue, He, !0), Xe = Qe.borderStyle.width, Ke = Zt(this, G0, this.svgFactory.createElement("svg:rect"));
    return Ke.setAttribute("x", Xe / 2), Ke.setAttribute("y", Xe / 2), Ke.setAttribute("width", Ue - Xe), Ke.setAttribute("height", He - Xe), Ke.setAttribute("stroke-width", Xe || 1), Ke.setAttribute("stroke", "transparent"), Ke.setAttribute("fill", "transparent"), Ge.append(Ke), this.container.append(Ge), !Qe.popupRef && this.hasPopupData && this._createPopup(), this.container;
  }
  getElementsToTriggerPopup() {
    return xt(this, G0);
  }
  addHighlightArea() {
    this.container.classList.add("highlightArea");
  }
}
G0 = new WeakMap();
var W0;
class CircleAnnotationElement extends AnnotationElement {
  constructor(Qe) {
    super(Qe, {
      isRenderable: !0,
      ignoreBorder: !0
    });
    tn(this, W0, null);
  }
  render() {
    this.container.classList.add("circleAnnotation");
    const Qe = this.data, {
      width: Ue,
      height: He
    } = getRectDims(Qe.rect), Ge = this.svgFactory.create(Ue, He, !0), Xe = Qe.borderStyle.width, Ke = Zt(this, W0, this.svgFactory.createElement("svg:ellipse"));
    return Ke.setAttribute("cx", Ue / 2), Ke.setAttribute("cy", He / 2), Ke.setAttribute("rx", Ue / 2 - Xe / 2), Ke.setAttribute("ry", He / 2 - Xe / 2), Ke.setAttribute("stroke-width", Xe || 1), Ke.setAttribute("stroke", "transparent"), Ke.setAttribute("fill", "transparent"), Ge.append(Ke), this.container.append(Ge), !Qe.popupRef && this.hasPopupData && this._createPopup(), this.container;
  }
  getElementsToTriggerPopup() {
    return xt(this, W0);
  }
  addHighlightArea() {
    this.container.classList.add("highlightArea");
  }
}
W0 = new WeakMap();
var q0;
class PolylineAnnotationElement extends AnnotationElement {
  constructor(Qe) {
    super(Qe, {
      isRenderable: !0,
      ignoreBorder: !0
    });
    tn(this, q0, null);
    this.containerClassName = "polylineAnnotation", this.svgElementName = "svg:polyline";
  }
  render() {
    this.container.classList.add(this.containerClassName);
    const Qe = this.data, {
      width: Ue,
      height: He
    } = getRectDims(Qe.rect), Ge = this.svgFactory.create(Ue, He, !0);
    let Xe = [];
    for (const $e of Qe.vertices) {
      const Je = $e.x - Qe.rect[0], Ze = Qe.rect[3] - $e.y;
      Xe.push(Je + "," + Ze);
    }
    Xe = Xe.join(" ");
    const Ke = Zt(this, q0, this.svgFactory.createElement(this.svgElementName));
    return Ke.setAttribute("points", Xe), Ke.setAttribute("stroke-width", Qe.borderStyle.width || 1), Ke.setAttribute("stroke", "transparent"), Ke.setAttribute("fill", "transparent"), Ge.append(Ke), this.container.append(Ge), !Qe.popupRef && this.hasPopupData && this._createPopup(), this.container;
  }
  getElementsToTriggerPopup() {
    return xt(this, q0);
  }
  addHighlightArea() {
    this.container.classList.add("highlightArea");
  }
}
q0 = new WeakMap();
class PolygonAnnotationElement extends PolylineAnnotationElement {
  constructor(ue) {
    super(ue), this.containerClassName = "polygonAnnotation", this.svgElementName = "svg:polygon";
  }
}
class CaretAnnotationElement extends AnnotationElement {
  constructor(ue) {
    super(ue, {
      isRenderable: !0,
      ignoreBorder: !0
    });
  }
  render() {
    return this.container.classList.add("caretAnnotation"), !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container;
  }
}
var z0;
class InkAnnotationElement extends AnnotationElement {
  constructor(Qe) {
    super(Qe, {
      isRenderable: !0,
      ignoreBorder: !0
    });
    tn(this, z0, []);
    this.containerClassName = "inkAnnotation", this.svgElementName = "svg:polyline", this.annotationEditorType = AnnotationEditorType.INK;
  }
  render() {
    this.container.classList.add(this.containerClassName);
    const Qe = this.data, {
      width: Ue,
      height: He
    } = getRectDims(Qe.rect), Ge = this.svgFactory.create(Ue, He, !0);
    for (const Xe of Qe.inkLists) {
      let Ke = [];
      for (const Je of Xe) {
        const Ze = Je.x - Qe.rect[0], nt = Qe.rect[3] - Je.y;
        Ke.push(`${Ze},${nt}`);
      }
      Ke = Ke.join(" ");
      const $e = this.svgFactory.createElement(this.svgElementName);
      xt(this, z0).push($e), $e.setAttribute("points", Ke), $e.setAttribute("stroke-width", Qe.borderStyle.width || 1), $e.setAttribute("stroke", "transparent"), $e.setAttribute("fill", "transparent"), !Qe.popupRef && this.hasPopupData && this._createPopup(), Ge.append($e);
    }
    return this.container.append(Ge), this.container;
  }
  getElementsToTriggerPopup() {
    return xt(this, z0);
  }
  addHighlightArea() {
    this.container.classList.add("highlightArea");
  }
}
z0 = new WeakMap();
class HighlightAnnotationElement extends AnnotationElement {
  constructor(ue) {
    super(ue, {
      isRenderable: !0,
      ignoreBorder: !0,
      createQuadrilaterals: !0
    });
  }
  render() {
    return !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container.classList.add("highlightAnnotation"), this.container;
  }
}
class UnderlineAnnotationElement extends AnnotationElement {
  constructor(ue) {
    super(ue, {
      isRenderable: !0,
      ignoreBorder: !0,
      createQuadrilaterals: !0
    });
  }
  render() {
    return !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container.classList.add("underlineAnnotation"), this.container;
  }
}
class SquigglyAnnotationElement extends AnnotationElement {
  constructor(ue) {
    super(ue, {
      isRenderable: !0,
      ignoreBorder: !0,
      createQuadrilaterals: !0
    });
  }
  render() {
    return !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container.classList.add("squigglyAnnotation"), this.container;
  }
}
class StrikeOutAnnotationElement extends AnnotationElement {
  constructor(ue) {
    super(ue, {
      isRenderable: !0,
      ignoreBorder: !0,
      createQuadrilaterals: !0
    });
  }
  render() {
    return !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container.classList.add("strikeoutAnnotation"), this.container;
  }
}
class StampAnnotationElement extends AnnotationElement {
  constructor(ue) {
    super(ue, {
      isRenderable: !0,
      ignoreBorder: !0
    });
  }
  render() {
    return this.container.classList.add("stampAnnotation"), !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container;
  }
}
var X0, K0, $h;
class FileAttachmentAnnotationElement extends AnnotationElement {
  constructor(Qe) {
    var He;
    super(Qe, {
      isRenderable: !0
    });
    tn(this, K0);
    tn(this, X0, null);
    const {
      file: Ue
    } = this.data;
    this.filename = Ue.filename, this.content = Ue.content, (He = this.linkService.eventBus) == null || He.dispatch("fileattachmentannotation", {
      source: this,
      ...Ue
    });
  }
  render() {
    this.container.classList.add("fileAttachmentAnnotation");
    const {
      container: Qe,
      data: Ue
    } = this;
    let He;
    Ue.hasAppearance || Ue.fillAlpha === 0 ? He = document.createElement("div") : (He = document.createElement("img"), He.src = `${this.imageResourcesPath}annotation-${/paperclip/i.test(Ue.name) ? "paperclip" : "pushpin"}.svg`, Ue.fillAlpha && Ue.fillAlpha < 1 && (He.style = `filter: opacity(${Math.round(Ue.fillAlpha * 100)}%);`)), He.addEventListener("dblclick", en(this, K0, $h).bind(this)), Zt(this, X0, He);
    const {
      isMac: Ge
    } = util_FeatureTest.platform;
    return Qe.addEventListener("keydown", (Xe) => {
      Xe.key === "Enter" && (Ge ? Xe.metaKey : Xe.ctrlKey) && en(this, K0, $h).call(this);
    }), !Ue.popupRef && this.hasPopupData ? this._createPopup() : He.classList.add("popupTriggerArea"), Qe.append(He), Qe;
  }
  getElementsToTriggerPopup() {
    return xt(this, X0);
  }
  addHighlightArea() {
    this.container.classList.add("highlightArea");
  }
}
X0 = new WeakMap(), K0 = new WeakSet(), $h = function() {
  var Qe;
  (Qe = this.downloadManager) == null || Qe.openOrDownloadData(this.content, this.filename);
};
var Y0, wc, qu, Wc, Tg, Jh, GA;
let AnnotationLayer$1 = (GA = class {
  constructor({
    div: ue,
    accessibilityManager: Qe,
    annotationCanvasMap: Ue,
    annotationEditorUIManager: He,
    page: Ge,
    viewport: Xe
  }) {
    tn(this, Wc);
    tn(this, Y0, null);
    tn(this, wc, null);
    tn(this, qu, /* @__PURE__ */ new Map());
    this.div = ue, Zt(this, Y0, Qe), Zt(this, wc, Ue), this.page = Ge, this.viewport = Xe, this.zIndex = 0, this._annotationEditorUIManager = He;
  }
  async render(ue) {
    var Xe;
    const {
      annotations: Qe
    } = ue, Ue = this.div;
    setLayerDimensions(Ue, this.viewport);
    const He = /* @__PURE__ */ new Map(), Ge = {
      data: null,
      layer: Ue,
      linkService: ue.linkService,
      downloadManager: ue.downloadManager,
      imageResourcesPath: ue.imageResourcesPath || "",
      renderForms: ue.renderForms !== !1,
      svgFactory: new DOMSVGFactory(),
      annotationStorage: ue.annotationStorage || new AnnotationStorage(),
      enableScripting: ue.enableScripting === !0,
      hasJSActions: ue.hasJSActions,
      fieldObjects: ue.fieldObjects,
      parent: this,
      elements: null
    };
    for (const Ke of Qe) {
      if (Ke.noHTML)
        continue;
      const $e = Ke.annotationType === AnnotationType.POPUP;
      if ($e) {
        const nt = He.get(Ke.id);
        if (!nt)
          continue;
        Ge.elements = nt;
      } else {
        const {
          width: nt,
          height: tt
        } = getRectDims(Ke.rect);
        if (nt <= 0 || tt <= 0)
          continue;
      }
      Ge.data = Ke;
      const Je = AnnotationElementFactory.create(Ge);
      if (!Je.isRenderable)
        continue;
      if (!$e && Ke.popupRef) {
        const nt = He.get(Ke.popupRef);
        nt ? nt.push(Je) : He.set(Ke.popupRef, [Je]);
      }
      const Ze = Je.render();
      Ke.hidden && (Ze.style.visibility = "hidden"), en(this, Wc, Tg).call(this, Ze, Ke.id), Je.annotationEditorType > 0 && (xt(this, qu).set(Je.data.id, Je), (Xe = this._annotationEditorUIManager) == null || Xe.renderAnnotationElement(Je));
    }
    en(this, Wc, Jh).call(this);
  }
  update({
    viewport: ue
  }) {
    const Qe = this.div;
    this.viewport = ue, setLayerDimensions(Qe, {
      rotation: ue.rotation
    }), en(this, Wc, Jh).call(this), Qe.hidden = !1;
  }
  getEditableAnnotations() {
    return Array.from(xt(this, qu).values());
  }
  getEditableAnnotation(ue) {
    return xt(this, qu).get(ue);
  }
}, Y0 = new WeakMap(), wc = new WeakMap(), qu = new WeakMap(), Wc = new WeakSet(), Tg = function(ue, Qe) {
  var He;
  const Ue = ue.firstChild || ue;
  Ue.id = `${AnnotationPrefix}${Qe}`, this.div.append(ue), (He = xt(this, Y0)) == null || He.moveElementInDOM(this.div, ue, Ue, !1);
}, Jh = function() {
  if (!xt(this, wc))
    return;
  const ue = this.div;
  for (const [Qe, Ue] of xt(this, wc)) {
    const He = ue.querySelector(`[data-annotation-id="${Qe}"]`);
    if (!He)
      continue;
    Ue.className = "annotationContent";
    const {
      firstChild: Ge
    } = He;
    Ge ? Ge.nodeName === "CANVAS" ? Ge.replaceWith(Ue) : Ge.classList.contains("annotationContent") ? Ge.after(Ue) : Ge.before(Ue) : He.append(Ue);
  }
  xt(this, wc).clear();
}, GA);
const EOL_PATTERN = /\r\n?|\n/g;
var $0, J0, Z0, ed, td, wa, $i, nd, Ji, zu, Jr, Bg, Rg, Og, O2, Ho, N2, D2, Ng, Zh, Dg;
const Lr = class Lr extends AnnotationEditor {
  constructor(Qe) {
    super({
      ...Qe,
      name: "freeTextEditor"
    });
    tn(this, Jr);
    tn(this, $0, this.editorDivBlur.bind(this));
    tn(this, J0, this.editorDivFocus.bind(this));
    tn(this, Z0, this.editorDivInput.bind(this));
    tn(this, ed, this.editorDivKeydown.bind(this));
    tn(this, td, this.editorDivPaste.bind(this));
    tn(this, wa);
    tn(this, $i, "");
    tn(this, nd, `${this.id}-editor`);
    tn(this, Ji);
    tn(this, zu, null);
    Zt(this, wa, Qe.color || Lr._defaultColor || AnnotationEditor._defaultLineColor), Zt(this, Ji, Qe.fontSize || Lr._defaultFontSize);
  }
  static get _keyboardManager() {
    const Qe = Lr.prototype, Ue = (Xe) => Xe.isEmpty(), He = AnnotationEditorUIManager.TRANSLATE_SMALL, Ge = AnnotationEditorUIManager.TRANSLATE_BIG;
    return shadow(this, "_keyboardManager", new KeyboardManager([[["ctrl+s", "mac+meta+s", "ctrl+p", "mac+meta+p"], Qe.commitOrRemove, {
      bubbles: !0
    }], [["ctrl+Enter", "mac+meta+Enter", "Escape", "mac+Escape"], Qe.commitOrRemove], [["ArrowLeft", "mac+ArrowLeft"], Qe._translateEmpty, {
      args: [-He, 0],
      checker: Ue
    }], [["ctrl+ArrowLeft", "mac+shift+ArrowLeft"], Qe._translateEmpty, {
      args: [-Ge, 0],
      checker: Ue
    }], [["ArrowRight", "mac+ArrowRight"], Qe._translateEmpty, {
      args: [He, 0],
      checker: Ue
    }], [["ctrl+ArrowRight", "mac+shift+ArrowRight"], Qe._translateEmpty, {
      args: [Ge, 0],
      checker: Ue
    }], [["ArrowUp", "mac+ArrowUp"], Qe._translateEmpty, {
      args: [0, -He],
      checker: Ue
    }], [["ctrl+ArrowUp", "mac+shift+ArrowUp"], Qe._translateEmpty, {
      args: [0, -Ge],
      checker: Ue
    }], [["ArrowDown", "mac+ArrowDown"], Qe._translateEmpty, {
      args: [0, He],
      checker: Ue
    }], [["ctrl+ArrowDown", "mac+shift+ArrowDown"], Qe._translateEmpty, {
      args: [0, Ge],
      checker: Ue
    }]]));
  }
  static initialize(Qe, Ue) {
    AnnotationEditor.initialize(Qe, Ue, {
      strings: ["pdfjs-free-text-default-content"]
    });
    const He = getComputedStyle(document.documentElement);
    this._internalPadding = parseFloat(He.getPropertyValue("--freetext-padding"));
  }
  static updateDefaultParams(Qe, Ue) {
    switch (Qe) {
      case AnnotationEditorParamsType.FREETEXT_SIZE:
        Lr._defaultFontSize = Ue;
        break;
      case AnnotationEditorParamsType.FREETEXT_COLOR:
        Lr._defaultColor = Ue;
        break;
    }
  }
  updateParams(Qe, Ue) {
    switch (Qe) {
      case AnnotationEditorParamsType.FREETEXT_SIZE:
        en(this, Jr, Bg).call(this, Ue);
        break;
      case AnnotationEditorParamsType.FREETEXT_COLOR:
        en(this, Jr, Rg).call(this, Ue);
        break;
    }
  }
  static get defaultPropertiesToUpdate() {
    return [[AnnotationEditorParamsType.FREETEXT_SIZE, Lr._defaultFontSize], [AnnotationEditorParamsType.FREETEXT_COLOR, Lr._defaultColor || AnnotationEditor._defaultLineColor]];
  }
  get propertiesToUpdate() {
    return [[AnnotationEditorParamsType.FREETEXT_SIZE, xt(this, Ji)], [AnnotationEditorParamsType.FREETEXT_COLOR, xt(this, wa)]];
  }
  _translateEmpty(Qe, Ue) {
    this._uiManager.translateSelectedEditors(Qe, Ue, !0);
  }
  getInitialTranslation() {
    const Qe = this.parentScale;
    return [-Lr._internalPadding * Qe, -(Lr._internalPadding + xt(this, Ji)) * Qe];
  }
  rebuild() {
    this.parent && (super.rebuild(), this.div !== null && (this.isAttachedToDOM || this.parent.add(this)));
  }
  enableEditMode() {
    this.isInEditMode() || (this.parent.setEditingState(!1), this.parent.updateToolbar(AnnotationEditorType.FREETEXT), super.enableEditMode(), this.overlayDiv.classList.remove("enabled"), this.editorDiv.contentEditable = !0, this._isDraggable = !1, this.div.removeAttribute("aria-activedescendant"), this.editorDiv.addEventListener("keydown", xt(this, ed)), this.editorDiv.addEventListener("focus", xt(this, J0)), this.editorDiv.addEventListener("blur", xt(this, $0)), this.editorDiv.addEventListener("input", xt(this, Z0)), this.editorDiv.addEventListener("paste", xt(this, td)));
  }
  disableEditMode() {
    this.isInEditMode() && (this.parent.setEditingState(!0), super.disableEditMode(), this.overlayDiv.classList.add("enabled"), this.editorDiv.contentEditable = !1, this.div.setAttribute("aria-activedescendant", xt(this, nd)), this._isDraggable = !0, this.editorDiv.removeEventListener("keydown", xt(this, ed)), this.editorDiv.removeEventListener("focus", xt(this, J0)), this.editorDiv.removeEventListener("blur", xt(this, $0)), this.editorDiv.removeEventListener("input", xt(this, Z0)), this.editorDiv.removeEventListener("paste", xt(this, td)), this.div.focus({
      preventScroll: !0
    }), this.isEditing = !1, this.parent.div.classList.add("freetextEditing"));
  }
  focusin(Qe) {
    this._focusEventsAllowed && (super.focusin(Qe), Qe.target !== this.editorDiv && this.editorDiv.focus());
  }
  onceAdded() {
    var Qe;
    this.width || (this.enableEditMode(), this.editorDiv.focus(), (Qe = this._initialOptions) != null && Qe.isCentered && this.center(), this._initialOptions = null);
  }
  isEmpty() {
    return !this.editorDiv || this.editorDiv.innerText.trim() === "";
  }
  remove() {
    this.isEditing = !1, this.parent && (this.parent.setEditingState(!0), this.parent.div.classList.add("freetextEditing")), super.remove();
  }
  commit() {
    if (!this.isInEditMode())
      return;
    super.commit(), this.disableEditMode();
    const Qe = xt(this, $i), Ue = Zt(this, $i, en(this, Jr, Og).call(this).trimEnd());
    if (Qe === Ue)
      return;
    const He = (Ge) => {
      if (Zt(this, $i, Ge), !Ge) {
        this.remove();
        return;
      }
      en(this, Jr, D2).call(this), this._uiManager.rebuild(this), en(this, Jr, O2).call(this);
    };
    this.addCommands({
      cmd: () => {
        He(Ue);
      },
      undo: () => {
        He(Qe);
      },
      mustExec: !1
    }), en(this, Jr, O2).call(this);
  }
  shouldGetKeyboardEvents() {
    return this.isInEditMode();
  }
  enterInEditMode() {
    this.enableEditMode(), this.editorDiv.focus();
  }
  dblclick(Qe) {
    this.enterInEditMode();
  }
  keydown(Qe) {
    Qe.target === this.div && Qe.key === "Enter" && (this.enterInEditMode(), Qe.preventDefault());
  }
  editorDivKeydown(Qe) {
    Lr._keyboardManager.exec(this, Qe);
  }
  editorDivFocus(Qe) {
    this.isEditing = !0;
  }
  editorDivBlur(Qe) {
    this.isEditing = !1;
  }
  editorDivInput(Qe) {
    this.parent.div.classList.toggle("freetextEditing", this.isEmpty());
  }
  disableEditing() {
    this.editorDiv.setAttribute("role", "comment"), this.editorDiv.removeAttribute("aria-multiline");
  }
  enableEditing() {
    this.editorDiv.setAttribute("role", "textbox"), this.editorDiv.setAttribute("aria-multiline", !0);
  }
  render() {
    if (this.div)
      return this.div;
    let Qe, Ue;
    this.width && (Qe = this.x, Ue = this.y), super.render(), this.editorDiv = document.createElement("div"), this.editorDiv.className = "internal", this.editorDiv.setAttribute("id", xt(this, nd)), this.editorDiv.setAttribute("data-l10n-id", "pdfjs-free-text"), this.enableEditing(), AnnotationEditor._l10nPromise.get("pdfjs-free-text-default-content").then((Ge) => {
      var Xe;
      return (Xe = this.editorDiv) == null ? void 0 : Xe.setAttribute("default-content", Ge);
    }), this.editorDiv.contentEditable = !0;
    const {
      style: He
    } = this.editorDiv;
    if (He.fontSize = `calc(${xt(this, Ji)}px * var(--scale-factor))`, He.color = xt(this, wa), this.div.append(this.editorDiv), this.overlayDiv = document.createElement("div"), this.overlayDiv.classList.add("overlay", "enabled"), this.div.append(this.overlayDiv), bindEvents(this, this.div, ["dblclick", "keydown"]), this.width) {
      const [Ge, Xe] = this.parentDimensions;
      if (this.annotationElementId) {
        const {
          position: Ke
        } = xt(this, zu);
        let [$e, Je] = this.getInitialTranslation();
        [$e, Je] = this.pageTranslationToScreen($e, Je);
        const [Ze, nt] = this.pageDimensions, [tt, et] = this.pageTranslation;
        let rt, it;
        switch (this.rotation) {
          case 0:
            rt = Qe + (Ke[0] - tt) / Ze, it = Ue + this.height - (Ke[1] - et) / nt;
            break;
          case 90:
            rt = Qe + (Ke[0] - tt) / Ze, it = Ue - (Ke[1] - et) / nt, [$e, Je] = [Je, -$e];
            break;
          case 180:
            rt = Qe - this.width + (Ke[0] - tt) / Ze, it = Ue - (Ke[1] - et) / nt, [$e, Je] = [-$e, -Je];
            break;
          case 270:
            rt = Qe + (Ke[0] - tt - this.height * nt) / Ze, it = Ue + (Ke[1] - et - this.width * Ze) / nt, [$e, Je] = [-Je, $e];
            break;
        }
        this.setAt(rt * Ge, it * Xe, $e, Je);
      } else
        this.setAt(Qe * Ge, Ue * Xe, this.width * Ge, this.height * Xe);
      en(this, Jr, D2).call(this), this._isDraggable = !0, this.editorDiv.contentEditable = !1;
    } else
      this._isDraggable = !1, this.editorDiv.contentEditable = !0;
    return this.div;
  }
  editorDivPaste(Qe) {
    var rt, it, ot;
    const Ue = Qe.clipboardData || window.clipboardData, {
      types: He
    } = Ue;
    if (He.length === 1 && He[0] === "text/plain")
      return;
    Qe.preventDefault();
    const Ge = en(rt = Lr, Ho, Zh).call(rt, Ue.getData("text") || "").replaceAll(EOL_PATTERN, `
`);
    if (!Ge)
      return;
    const Xe = window.getSelection();
    if (!Xe.rangeCount)
      return;
    this.editorDiv.normalize(), Xe.deleteFromDocument();
    const Ke = Xe.getRangeAt(0);
    if (!Ge.includes(`
`)) {
      Ke.insertNode(document.createTextNode(Ge)), this.editorDiv.normalize(), Xe.collapseToStart();
      return;
    }
    const {
      startContainer: $e,
      startOffset: Je
    } = Ke, Ze = [], nt = [];
    if ($e.nodeType === Node.TEXT_NODE) {
      const at = $e.parentElement;
      if (nt.push($e.nodeValue.slice(Je).replaceAll(EOL_PATTERN, "")), at !== this.editorDiv) {
        let st = Ze;
        for (const ut of this.editorDiv.childNodes) {
          if (ut === at) {
            st = nt;
            continue;
          }
          st.push(en(it = Lr, Ho, N2).call(it, ut));
        }
      }
      Ze.push($e.nodeValue.slice(0, Je).replaceAll(EOL_PATTERN, ""));
    } else if ($e === this.editorDiv) {
      let at = Ze, st = 0;
      for (const ut of this.editorDiv.childNodes)
        st++ === Je && (at = nt), at.push(en(ot = Lr, Ho, N2).call(ot, ut));
    }
    Zt(this, $i, `${Ze.join(`
`)}${Ge}${nt.join(`
`)}`), en(this, Jr, D2).call(this);
    const tt = new Range();
    let et = Ze.reduce((at, st) => at + st.length, 0);
    for (const {
      firstChild: at
    } of this.editorDiv.childNodes)
      if (at.nodeType === Node.TEXT_NODE) {
        const st = at.nodeValue.length;
        if (et <= st) {
          tt.setStart(at, et), tt.setEnd(at, et);
          break;
        }
        et -= st;
      }
    Xe.removeAllRanges(), Xe.addRange(tt);
  }
  get contentDiv() {
    return this.editorDiv;
  }
  static deserialize(Qe, Ue, He) {
    var Ke;
    let Ge = null;
    if (Qe instanceof FreeTextAnnotationElement) {
      const {
        data: {
          defaultAppearanceData: {
            fontSize: $e,
            fontColor: Je
          },
          rect: Ze,
          rotation: nt,
          id: tt
        },
        textContent: et,
        textPosition: rt,
        parent: {
          page: {
            pageNumber: it
          }
        }
      } = Qe;
      if (!et || et.length === 0)
        return null;
      Ge = Qe = {
        annotationType: AnnotationEditorType.FREETEXT,
        color: Array.from(Je),
        fontSize: $e,
        value: et.join(`
`),
        position: rt,
        pageIndex: it - 1,
        rect: Ze.slice(0),
        rotation: nt,
        id: tt,
        deleted: !1
      };
    }
    const Xe = super.deserialize(Qe, Ue, He);
    return Zt(Xe, Ji, Qe.fontSize), Zt(Xe, wa, Util.makeHexColor(...Qe.color)), Zt(Xe, $i, en(Ke = Lr, Ho, Zh).call(Ke, Qe.value)), Xe.annotationElementId = Qe.id || null, Zt(Xe, zu, Ge), Xe;
  }
  serialize(Qe = !1) {
    if (this.isEmpty())
      return null;
    if (this.deleted)
      return {
        pageIndex: this.pageIndex,
        id: this.annotationElementId,
        deleted: !0
      };
    const Ue = Lr._internalPadding * this.parentScale, He = this.getRect(Ue, Ue), Ge = AnnotationEditor._colorManager.convert(this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : xt(this, wa)), Xe = {
      annotationType: AnnotationEditorType.FREETEXT,
      color: Ge,
      fontSize: xt(this, Ji),
      value: en(this, Jr, Ng).call(this),
      pageIndex: this.pageIndex,
      rect: He,
      rotation: this.rotation,
      structTreeParentId: this._structTreeParentId
    };
    return Qe ? Xe : this.annotationElementId && !en(this, Jr, Dg).call(this, Xe) ? null : (Xe.id = this.annotationElementId, Xe);
  }
  renderAnnotationElement(Qe) {
    const Ue = super.renderAnnotationElement(Qe);
    if (this.deleted)
      return Ue;
    const {
      style: He
    } = Ue;
    He.fontSize = `calc(${xt(this, Ji)}px * var(--scale-factor))`, He.color = xt(this, wa), Ue.replaceChildren();
    for (const Xe of xt(this, $i).split(`
`)) {
      const Ke = document.createElement("div");
      Ke.append(Xe ? document.createTextNode(Xe) : document.createElement("br")), Ue.append(Ke);
    }
    const Ge = Lr._internalPadding * this.parentScale;
    return Qe.updateEdited({
      rect: this.getRect(Ge, Ge),
      popupContent: xt(this, $i)
    }), Ue;
  }
  resetAnnotationElement(Qe) {
    super.resetAnnotationElement(Qe), Qe.resetEdited();
  }
};
$0 = new WeakMap(), J0 = new WeakMap(), Z0 = new WeakMap(), ed = new WeakMap(), td = new WeakMap(), wa = new WeakMap(), $i = new WeakMap(), nd = new WeakMap(), Ji = new WeakMap(), zu = new WeakMap(), Jr = new WeakSet(), Bg = function(Qe) {
  const Ue = (Ge) => {
    this.editorDiv.style.fontSize = `calc(${Ge}px * var(--scale-factor))`, this.translate(0, -(Ge - xt(this, Ji)) * this.parentScale), Zt(this, Ji, Ge), en(this, Jr, O2).call(this);
  }, He = xt(this, Ji);
  this.addCommands({
    cmd: Ue.bind(this, Qe),
    undo: Ue.bind(this, He),
    post: this._uiManager.updateUI.bind(this._uiManager, this),
    mustExec: !0,
    type: AnnotationEditorParamsType.FREETEXT_SIZE,
    overwriteIfSameType: !0,
    keepUndo: !0
  });
}, Rg = function(Qe) {
  const Ue = (Ge) => {
    Zt(this, wa, this.editorDiv.style.color = Ge);
  }, He = xt(this, wa);
  this.addCommands({
    cmd: Ue.bind(this, Qe),
    undo: Ue.bind(this, He),
    post: this._uiManager.updateUI.bind(this._uiManager, this),
    mustExec: !0,
    type: AnnotationEditorParamsType.FREETEXT_COLOR,
    overwriteIfSameType: !0,
    keepUndo: !0
  });
}, Og = function() {
  var Ue;
  const Qe = [];
  this.editorDiv.normalize();
  for (const He of this.editorDiv.childNodes)
    Qe.push(en(Ue = Lr, Ho, N2).call(Ue, He));
  return Qe.join(`
`);
}, O2 = function() {
  const [Qe, Ue] = this.parentDimensions;
  let He;
  if (this.isAttachedToDOM)
    He = this.div.getBoundingClientRect();
  else {
    const {
      currentLayer: Ge,
      div: Xe
    } = this, Ke = Xe.style.display, $e = Xe.classList.contains("hidden");
    Xe.classList.remove("hidden"), Xe.style.display = "hidden", Ge.div.append(this.div), He = Xe.getBoundingClientRect(), Xe.remove(), Xe.style.display = Ke, Xe.classList.toggle("hidden", $e);
  }
  this.rotation % 180 === this.parentRotation % 180 ? (this.width = He.width / Qe, this.height = He.height / Ue) : (this.width = He.height / Qe, this.height = He.width / Ue), this.fixAndSetPosition();
}, Ho = new WeakSet(), N2 = function(Qe) {
  return (Qe.nodeType === Node.TEXT_NODE ? Qe.nodeValue : Qe.innerText).replaceAll(EOL_PATTERN, "");
}, D2 = function() {
  if (this.editorDiv.replaceChildren(), !!xt(this, $i))
    for (const Qe of xt(this, $i).split(`
`)) {
      const Ue = document.createElement("div");
      Ue.append(Qe ? document.createTextNode(Qe) : document.createElement("br")), this.editorDiv.append(Ue);
    }
}, Ng = function() {
  return xt(this, $i).replaceAll(" ", " ");
}, Zh = function(Qe) {
  return Qe.replaceAll(" ", " ");
}, Dg = function(Qe) {
  const {
    value: Ue,
    fontSize: He,
    color: Ge,
    pageIndex: Xe
  } = xt(this, zu);
  return this._hasBeenMoved || Qe.value !== Ue || Qe.fontSize !== He || Qe.color.some((Ke, $e) => Ke !== Ge[$e]) || Qe.pageIndex !== Xe;
}, tn(Lr, Ho), $n(Lr, "_freeTextDefaultContent", ""), $n(Lr, "_internalPadding", 0), $n(Lr, "_defaultColor", null), $n(Lr, "_defaultFontSize", 10), $n(Lr, "_type", "freetext"), $n(Lr, "_editorType", AnnotationEditorType.FREETEXT);
let FreeTextEditor = Lr;
var rd, ps, Ta, ki, Pg, P2, kg, _g, e1;
class Outliner {
  constructor(ue, Qe = 0, Ue = 0, He = !0) {
    tn(this, ki);
    tn(this, rd);
    tn(this, ps, []);
    tn(this, Ta, []);
    let Ge = 1 / 0, Xe = -1 / 0, Ke = 1 / 0, $e = -1 / 0;
    const Ze = 10 ** -4;
    for (const {
      x: at,
      y: st,
      width: ut,
      height: lt
    } of ue) {
      const dt = Math.floor((at - Qe) / Ze) * Ze, At = Math.ceil((at + ut + Qe) / Ze) * Ze, pt = Math.floor((st - Qe) / Ze) * Ze, gt = Math.ceil((st + lt + Qe) / Ze) * Ze, wt = [dt, pt, gt, !0], Bt = [At, pt, gt, !1];
      xt(this, ps).push(wt, Bt), Ge = Math.min(Ge, dt), Xe = Math.max(Xe, At), Ke = Math.min(Ke, pt), $e = Math.max($e, gt);
    }
    const nt = Xe - Ge + 2 * Ue, tt = $e - Ke + 2 * Ue, et = Ge - Ue, rt = Ke - Ue, it = xt(this, ps).at(He ? -1 : -2), ot = [it[0], it[2]];
    for (const at of xt(this, ps)) {
      const [st, ut, lt] = at;
      at[0] = (st - et) / nt, at[1] = (ut - rt) / tt, at[2] = (lt - rt) / tt;
    }
    Zt(this, rd, {
      x: et,
      y: rt,
      width: nt,
      height: tt,
      lastPoint: ot
    });
  }
  getOutlines() {
    xt(this, ps).sort((Qe, Ue) => Qe[0] - Ue[0] || Qe[1] - Ue[1] || Qe[2] - Ue[2]);
    const ue = [];
    for (const Qe of xt(this, ps))
      Qe[3] ? (ue.push(...en(this, ki, e1).call(this, Qe)), en(this, ki, kg).call(this, Qe)) : (en(this, ki, _g).call(this, Qe), ue.push(...en(this, ki, e1).call(this, Qe)));
    return en(this, ki, Pg).call(this, ue);
  }
}
rd = new WeakMap(), ps = new WeakMap(), Ta = new WeakMap(), ki = new WeakSet(), Pg = function(ue) {
  const Qe = [], Ue = /* @__PURE__ */ new Set();
  for (const Xe of ue) {
    const [Ke, $e, Je] = Xe;
    Qe.push([Ke, $e, Xe], [Ke, Je, Xe]);
  }
  Qe.sort((Xe, Ke) => Xe[1] - Ke[1] || Xe[0] - Ke[0]);
  for (let Xe = 0, Ke = Qe.length; Xe < Ke; Xe += 2) {
    const $e = Qe[Xe][2], Je = Qe[Xe + 1][2];
    $e.push(Je), Je.push($e), Ue.add($e), Ue.add(Je);
  }
  const He = [];
  let Ge;
  for (; Ue.size > 0; ) {
    const Xe = Ue.values().next().value;
    let [Ke, $e, Je, Ze, nt] = Xe;
    Ue.delete(Xe);
    let tt = Ke, et = $e;
    for (Ge = [Ke, Je], He.push(Ge); ; ) {
      let rt;
      if (Ue.has(Ze))
        rt = Ze;
      else if (Ue.has(nt))
        rt = nt;
      else
        break;
      Ue.delete(rt), [Ke, $e, Je, Ze, nt] = rt, tt !== Ke && (Ge.push(tt, et, Ke, et === $e ? $e : Je), tt = Ke), et = et === $e ? Je : $e;
    }
    Ge.push(tt, et);
  }
  return new HighlightOutline(He, xt(this, rd));
}, P2 = function(ue) {
  const Qe = xt(this, Ta);
  let Ue = 0, He = Qe.length - 1;
  for (; Ue <= He; ) {
    const Ge = Ue + He >> 1, Xe = Qe[Ge][0];
    if (Xe === ue)
      return Ge;
    Xe < ue ? Ue = Ge + 1 : He = Ge - 1;
  }
  return He + 1;
}, kg = function([, ue, Qe]) {
  const Ue = en(this, ki, P2).call(this, ue);
  xt(this, Ta).splice(Ue, 0, [ue, Qe]);
}, _g = function([, ue, Qe]) {
  const Ue = en(this, ki, P2).call(this, ue);
  for (let He = Ue; He < xt(this, Ta).length; He++) {
    const [Ge, Xe] = xt(this, Ta)[He];
    if (Ge !== ue)
      break;
    if (Ge === ue && Xe === Qe) {
      xt(this, Ta).splice(He, 1);
      return;
    }
  }
  for (let He = Ue - 1; He >= 0; He--) {
    const [Ge, Xe] = xt(this, Ta)[He];
    if (Ge !== ue)
      break;
    if (Ge === ue && Xe === Qe) {
      xt(this, Ta).splice(He, 1);
      return;
    }
  }
}, e1 = function(ue) {
  const [Qe, Ue, He] = ue, Ge = [[Qe, Ue, He]], Xe = en(this, ki, P2).call(this, He);
  for (let Ke = 0; Ke < Xe; Ke++) {
    const [$e, Je] = xt(this, Ta)[Ke];
    for (let Ze = 0, nt = Ge.length; Ze < nt; Ze++) {
      const [, tt, et] = Ge[Ze];
      if (!(Je <= tt || et <= $e)) {
        if (tt >= $e) {
          if (et > Je)
            Ge[Ze][1] = Je;
          else {
            if (nt === 1)
              return [];
            Ge.splice(Ze, 1), Ze--, nt--;
          }
          continue;
        }
        Ge[Ze][2] = $e, et > Je && Ge.push([Qe, Je, et]);
      }
    }
  }
  return Ge;
};
class Outline {
  toSVGPath() {
    throw new Error("Abstract method `toSVGPath` must be implemented.");
  }
  get box() {
    throw new Error("Abstract getter `box` must be implemented.");
  }
  serialize(ue, Qe) {
    throw new Error("Abstract method `serialize` must be implemented.");
  }
  get free() {
    return this instanceof FreeHighlightOutline;
  }
}
var ad, Xu;
class HighlightOutline extends Outline {
  constructor(Qe, Ue) {
    super();
    tn(this, ad);
    tn(this, Xu);
    Zt(this, Xu, Qe), Zt(this, ad, Ue);
  }
  toSVGPath() {
    const Qe = [];
    for (const Ue of xt(this, Xu)) {
      let [He, Ge] = Ue;
      Qe.push(`M${He} ${Ge}`);
      for (let Xe = 2; Xe < Ue.length; Xe += 2) {
        const Ke = Ue[Xe], $e = Ue[Xe + 1];
        Ke === He ? (Qe.push(`V${$e}`), Ge = $e) : $e === Ge && (Qe.push(`H${Ke}`), He = Ke);
      }
      Qe.push("Z");
    }
    return Qe.join(" ");
  }
  serialize([Qe, Ue, He, Ge], Xe) {
    const Ke = [], $e = He - Qe, Je = Ge - Ue;
    for (const Ze of xt(this, Xu)) {
      const nt = new Array(Ze.length);
      for (let tt = 0; tt < Ze.length; tt += 2)
        nt[tt] = Qe + Ze[tt] * $e, nt[tt + 1] = Ge - Ze[tt + 1] * Je;
      Ke.push(nt);
    }
    return Ke;
  }
  get box() {
    return xt(this, ad);
  }
}
ad = new WeakMap(), Xu = new WeakMap();
var qa, _o, Ku, Yu, za, Ar, Tc, Bc, od, sd, $u, Ju, As, cd, af, of, ud, t1;
const go = class go {
  constructor({
    x: ue,
    y: Qe
  }, Ue, He, Ge, Xe, Ke = 0) {
    tn(this, ud);
    tn(this, qa);
    tn(this, _o, []);
    tn(this, Ku);
    tn(this, Yu);
    tn(this, za, []);
    tn(this, Ar, new Float64Array(18));
    tn(this, Tc);
    tn(this, Bc);
    tn(this, od);
    tn(this, sd);
    tn(this, $u);
    tn(this, Ju);
    tn(this, As, []);
    Zt(this, qa, Ue), Zt(this, Ju, Ge * He), Zt(this, Yu, Xe), xt(this, Ar).set([NaN, NaN, NaN, NaN, ue, Qe], 6), Zt(this, Ku, Ke), Zt(this, sd, xt(go, cd) * He), Zt(this, od, xt(go, of) * He), Zt(this, $u, He), xt(this, As).push(ue, Qe);
  }
  get free() {
    return !0;
  }
  isEmpty() {
    return isNaN(xt(this, Ar)[8]);
  }
  add({
    x: ue,
    y: Qe
  }) {
    var wt;
    Zt(this, Tc, ue), Zt(this, Bc, Qe);
    const [Ue, He, Ge, Xe] = xt(this, qa);
    let [Ke, $e, Je, Ze] = xt(this, Ar).subarray(8, 12);
    const nt = ue - Je, tt = Qe - Ze, et = Math.hypot(nt, tt);
    if (et < xt(this, od))
      return !1;
    const rt = et - xt(this, sd), it = rt / et, ot = it * nt, at = it * tt;
    let st = Ke, ut = $e;
    Ke = Je, $e = Ze, Je += ot, Ze += at, (wt = xt(this, As)) == null || wt.push(ue, Qe);
    const lt = -at / rt, dt = ot / rt, At = lt * xt(this, Ju), pt = dt * xt(this, Ju);
    return xt(this, Ar).set(xt(this, Ar).subarray(2, 8), 0), xt(this, Ar).set([Je + At, Ze + pt], 4), xt(this, Ar).set(xt(this, Ar).subarray(14, 18), 12), xt(this, Ar).set([Je - At, Ze - pt], 16), isNaN(xt(this, Ar)[6]) ? (xt(this, za).length === 0 && (xt(this, Ar).set([Ke + At, $e + pt], 2), xt(this, za).push(NaN, NaN, NaN, NaN, (Ke + At - Ue) / Ge, ($e + pt - He) / Xe), xt(this, Ar).set([Ke - At, $e - pt], 14), xt(this, _o).push(NaN, NaN, NaN, NaN, (Ke - At - Ue) / Ge, ($e - pt - He) / Xe)), xt(this, Ar).set([st, ut, Ke, $e, Je, Ze], 6), !this.isEmpty()) : (xt(this, Ar).set([st, ut, Ke, $e, Je, Ze], 6), Math.abs(Math.atan2(ut - $e, st - Ke) - Math.atan2(at, ot)) < Math.PI / 2 ? ([Ke, $e, Je, Ze] = xt(this, Ar).subarray(2, 6), xt(this, za).push(NaN, NaN, NaN, NaN, ((Ke + Je) / 2 - Ue) / Ge, (($e + Ze) / 2 - He) / Xe), [Ke, $e, st, ut] = xt(this, Ar).subarray(14, 18), xt(this, _o).push(NaN, NaN, NaN, NaN, ((st + Ke) / 2 - Ue) / Ge, ((ut + $e) / 2 - He) / Xe), !0) : ([st, ut, Ke, $e, Je, Ze] = xt(this, Ar).subarray(0, 6), xt(this, za).push(((st + 5 * Ke) / 6 - Ue) / Ge, ((ut + 5 * $e) / 6 - He) / Xe, ((5 * Ke + Je) / 6 - Ue) / Ge, ((5 * $e + Ze) / 6 - He) / Xe, ((Ke + Je) / 2 - Ue) / Ge, (($e + Ze) / 2 - He) / Xe), [Je, Ze, Ke, $e, st, ut] = xt(this, Ar).subarray(12, 18), xt(this, _o).push(((st + 5 * Ke) / 6 - Ue) / Ge, ((ut + 5 * $e) / 6 - He) / Xe, ((5 * Ke + Je) / 6 - Ue) / Ge, ((5 * $e + Ze) / 6 - He) / Xe, ((Ke + Je) / 2 - Ue) / Ge, (($e + Ze) / 2 - He) / Xe), !0));
  }
  toSVGPath() {
    if (this.isEmpty())
      return "";
    const ue = xt(this, za), Qe = xt(this, _o), Ue = xt(this, Ar).subarray(4, 6), He = xt(this, Ar).subarray(16, 18), [Ge, Xe, Ke, $e] = xt(this, qa), [Je, Ze, nt, tt] = en(this, ud, t1).call(this);
    if (isNaN(xt(this, Ar)[6]) && !this.isEmpty())
      return `M${(xt(this, Ar)[2] - Ge) / Ke} ${(xt(this, Ar)[3] - Xe) / $e} L${(xt(this, Ar)[4] - Ge) / Ke} ${(xt(this, Ar)[5] - Xe) / $e} L${Je} ${Ze} L${nt} ${tt} L${(xt(this, Ar)[16] - Ge) / Ke} ${(xt(this, Ar)[17] - Xe) / $e} L${(xt(this, Ar)[14] - Ge) / Ke} ${(xt(this, Ar)[15] - Xe) / $e} Z`;
    const et = [];
    et.push(`M${ue[4]} ${ue[5]}`);
    for (let rt = 6; rt < ue.length; rt += 6)
      isNaN(ue[rt]) ? et.push(`L${ue[rt + 4]} ${ue[rt + 5]}`) : et.push(`C${ue[rt]} ${ue[rt + 1]} ${ue[rt + 2]} ${ue[rt + 3]} ${ue[rt + 4]} ${ue[rt + 5]}`);
    et.push(`L${(Ue[0] - Ge) / Ke} ${(Ue[1] - Xe) / $e} L${Je} ${Ze} L${nt} ${tt} L${(He[0] - Ge) / Ke} ${(He[1] - Xe) / $e}`);
    for (let rt = Qe.length - 6; rt >= 6; rt -= 6)
      isNaN(Qe[rt]) ? et.push(`L${Qe[rt + 4]} ${Qe[rt + 5]}`) : et.push(`C${Qe[rt]} ${Qe[rt + 1]} ${Qe[rt + 2]} ${Qe[rt + 3]} ${Qe[rt + 4]} ${Qe[rt + 5]}`);
    return et.push(`L${Qe[4]} ${Qe[5]} Z`), et.join(" ");
  }
  getOutlines() {
    var at;
    const ue = xt(this, za), Qe = xt(this, _o), Ue = xt(this, Ar), He = Ue.subarray(4, 6), Ge = Ue.subarray(16, 18), [Xe, Ke, $e, Je] = xt(this, qa), Ze = new Float64Array((((at = xt(this, As)) == null ? void 0 : at.length) ?? 0) + 2);
    for (let st = 0, ut = Ze.length - 2; st < ut; st += 2)
      Ze[st] = (xt(this, As)[st] - Xe) / $e, Ze[st + 1] = (xt(this, As)[st + 1] - Ke) / Je;
    Ze[Ze.length - 2] = (xt(this, Tc) - Xe) / $e, Ze[Ze.length - 1] = (xt(this, Bc) - Ke) / Je;
    const [nt, tt, et, rt] = en(this, ud, t1).call(this);
    if (isNaN(Ue[6]) && !this.isEmpty()) {
      const st = new Float64Array(36);
      return st.set([NaN, NaN, NaN, NaN, (Ue[2] - Xe) / $e, (Ue[3] - Ke) / Je, NaN, NaN, NaN, NaN, (Ue[4] - Xe) / $e, (Ue[5] - Ke) / Je, NaN, NaN, NaN, NaN, nt, tt, NaN, NaN, NaN, NaN, et, rt, NaN, NaN, NaN, NaN, (Ue[16] - Xe) / $e, (Ue[17] - Ke) / Je, NaN, NaN, NaN, NaN, (Ue[14] - Xe) / $e, (Ue[15] - Ke) / Je], 0), new FreeHighlightOutline(st, Ze, xt(this, qa), xt(this, $u), xt(this, Ku), xt(this, Yu));
    }
    const it = new Float64Array(xt(this, za).length + 24 + xt(this, _o).length);
    let ot = ue.length;
    for (let st = 0; st < ot; st += 2) {
      if (isNaN(ue[st])) {
        it[st] = it[st + 1] = NaN;
        continue;
      }
      it[st] = ue[st], it[st + 1] = ue[st + 1];
    }
    it.set([NaN, NaN, NaN, NaN, (He[0] - Xe) / $e, (He[1] - Ke) / Je, NaN, NaN, NaN, NaN, nt, tt, NaN, NaN, NaN, NaN, et, rt, NaN, NaN, NaN, NaN, (Ge[0] - Xe) / $e, (Ge[1] - Ke) / Je], ot), ot += 24;
    for (let st = Qe.length - 6; st >= 6; st -= 6)
      for (let ut = 0; ut < 6; ut += 2) {
        if (isNaN(Qe[st + ut])) {
          it[ot] = it[ot + 1] = NaN, ot += 2;
          continue;
        }
        it[ot] = Qe[st + ut], it[ot + 1] = Qe[st + ut + 1], ot += 2;
      }
    return it.set([NaN, NaN, NaN, NaN, Qe[4], Qe[5]], ot), new FreeHighlightOutline(it, Ze, xt(this, qa), xt(this, $u), xt(this, Ku), xt(this, Yu));
  }
};
qa = new WeakMap(), _o = new WeakMap(), Ku = new WeakMap(), Yu = new WeakMap(), za = new WeakMap(), Ar = new WeakMap(), Tc = new WeakMap(), Bc = new WeakMap(), od = new WeakMap(), sd = new WeakMap(), $u = new WeakMap(), Ju = new WeakMap(), As = new WeakMap(), cd = new WeakMap(), af = new WeakMap(), of = new WeakMap(), ud = new WeakSet(), t1 = function() {
  const ue = xt(this, Ar).subarray(4, 6), Qe = xt(this, Ar).subarray(16, 18), [Ue, He, Ge, Xe] = xt(this, qa);
  return [(xt(this, Tc) + (ue[0] - Qe[0]) / 2 - Ue) / Ge, (xt(this, Bc) + (ue[1] - Qe[1]) / 2 - He) / Xe, (xt(this, Tc) + (Qe[0] - ue[0]) / 2 - Ue) / Ge, (xt(this, Bc) + (Qe[1] - ue[1]) / 2 - He) / Xe];
}, tn(go, cd, 8), tn(go, af, 2), tn(go, of, xt(go, cd) + xt(go, af));
let FreeOutliner = go;
var Zu, Rc, Lo, ld, Zi, dd, Yr, Gi, Fl, jl, Lg;
class FreeHighlightOutline extends Outline {
  constructor(Qe, Ue, He, Ge, Xe, Ke) {
    super();
    tn(this, Gi);
    tn(this, Zu);
    tn(this, Rc, null);
    tn(this, Lo);
    tn(this, ld);
    tn(this, Zi);
    tn(this, dd);
    tn(this, Yr);
    Zt(this, Yr, Qe), Zt(this, Zi, Ue), Zt(this, Zu, He), Zt(this, dd, Ge), Zt(this, Lo, Xe), Zt(this, ld, Ke), en(this, Gi, Lg).call(this, Ke);
    const {
      x: $e,
      y: Je,
      width: Ze,
      height: nt
    } = xt(this, Rc);
    for (let tt = 0, et = Qe.length; tt < et; tt += 2)
      Qe[tt] = (Qe[tt] - $e) / Ze, Qe[tt + 1] = (Qe[tt + 1] - Je) / nt;
    for (let tt = 0, et = Ue.length; tt < et; tt += 2)
      Ue[tt] = (Ue[tt] - $e) / Ze, Ue[tt + 1] = (Ue[tt + 1] - Je) / nt;
  }
  toSVGPath() {
    const Qe = [`M${xt(this, Yr)[4]} ${xt(this, Yr)[5]}`];
    for (let Ue = 6, He = xt(this, Yr).length; Ue < He; Ue += 6) {
      if (isNaN(xt(this, Yr)[Ue])) {
        Qe.push(`L${xt(this, Yr)[Ue + 4]} ${xt(this, Yr)[Ue + 5]}`);
        continue;
      }
      Qe.push(`C${xt(this, Yr)[Ue]} ${xt(this, Yr)[Ue + 1]} ${xt(this, Yr)[Ue + 2]} ${xt(this, Yr)[Ue + 3]} ${xt(this, Yr)[Ue + 4]} ${xt(this, Yr)[Ue + 5]}`);
    }
    return Qe.push("Z"), Qe.join(" ");
  }
  serialize([Qe, Ue, He, Ge], Xe) {
    const Ke = He - Qe, $e = Ge - Ue;
    let Je, Ze;
    switch (Xe) {
      case 0:
        Je = en(this, Gi, Fl).call(this, xt(this, Yr), Qe, Ge, Ke, -$e), Ze = en(this, Gi, Fl).call(this, xt(this, Zi), Qe, Ge, Ke, -$e);
        break;
      case 90:
        Je = en(this, Gi, jl).call(this, xt(this, Yr), Qe, Ue, Ke, $e), Ze = en(this, Gi, jl).call(this, xt(this, Zi), Qe, Ue, Ke, $e);
        break;
      case 180:
        Je = en(this, Gi, Fl).call(this, xt(this, Yr), He, Ue, -Ke, $e), Ze = en(this, Gi, Fl).call(this, xt(this, Zi), He, Ue, -Ke, $e);
        break;
      case 270:
        Je = en(this, Gi, jl).call(this, xt(this, Yr), He, Ge, -Ke, -$e), Ze = en(this, Gi, jl).call(this, xt(this, Zi), He, Ge, -Ke, -$e);
        break;
    }
    return {
      outline: Array.from(Je),
      points: [Array.from(Ze)]
    };
  }
  get box() {
    return xt(this, Rc);
  }
  getNewOutline(Qe, Ue) {
    const {
      x: He,
      y: Ge,
      width: Xe,
      height: Ke
    } = xt(this, Rc), [$e, Je, Ze, nt] = xt(this, Zu), tt = Xe * Ze, et = Ke * nt, rt = He * Ze + $e, it = Ge * nt + Je, ot = new FreeOutliner({
      x: xt(this, Zi)[0] * tt + rt,
      y: xt(this, Zi)[1] * et + it
    }, xt(this, Zu), xt(this, dd), Qe, xt(this, ld), Ue ?? xt(this, Lo));
    for (let at = 2; at < xt(this, Zi).length; at += 2)
      ot.add({
        x: xt(this, Zi)[at] * tt + rt,
        y: xt(this, Zi)[at + 1] * et + it
      });
    return ot.getOutlines();
  }
}
Zu = new WeakMap(), Rc = new WeakMap(), Lo = new WeakMap(), ld = new WeakMap(), Zi = new WeakMap(), dd = new WeakMap(), Yr = new WeakMap(), Gi = new WeakSet(), Fl = function(Qe, Ue, He, Ge, Xe) {
  const Ke = new Float64Array(Qe.length);
  for (let $e = 0, Je = Qe.length; $e < Je; $e += 2)
    Ke[$e] = Ue + Qe[$e] * Ge, Ke[$e + 1] = He + Qe[$e + 1] * Xe;
  return Ke;
}, jl = function(Qe, Ue, He, Ge, Xe) {
  const Ke = new Float64Array(Qe.length);
  for (let $e = 0, Je = Qe.length; $e < Je; $e += 2)
    Ke[$e] = Ue + Qe[$e + 1] * Ge, Ke[$e + 1] = He + Qe[$e] * Xe;
  return Ke;
}, Lg = function(Qe) {
  const Ue = xt(this, Yr);
  let He = Ue[4], Ge = Ue[5], Xe = He, Ke = Ge, $e = He, Je = Ge, Ze = He, nt = Ge;
  const tt = Qe ? Math.max : Math.min;
  for (let at = 6, st = Ue.length; at < st; at += 6) {
    if (isNaN(Ue[at]))
      Xe = Math.min(Xe, Ue[at + 4]), Ke = Math.min(Ke, Ue[at + 5]), $e = Math.max($e, Ue[at + 4]), Je = Math.max(Je, Ue[at + 5]), nt < Ue[at + 5] ? (Ze = Ue[at + 4], nt = Ue[at + 5]) : nt === Ue[at + 5] && (Ze = tt(Ze, Ue[at + 4]));
    else {
      const ut = Util.bezierBoundingBox(He, Ge, ...Ue.slice(at, at + 6));
      Xe = Math.min(Xe, ut[0]), Ke = Math.min(Ke, ut[1]), $e = Math.max($e, ut[2]), Je = Math.max(Je, ut[3]), nt < ut[3] ? (Ze = ut[2], nt = ut[3]) : nt === ut[3] && (Ze = tt(Ze, ut[2]));
    }
    He = Ue[at + 4], Ge = Ue[at + 5];
  }
  const et = Xe - xt(this, Lo), rt = Ke - xt(this, Lo), it = $e - Xe + 2 * xt(this, Lo), ot = Je - Ke + 2 * xt(this, Lo);
  Zt(this, Rc, {
    x: et,
    y: rt,
    width: it,
    height: ot,
    lastPoint: [Ze, nt]
  });
};
var fd, hd, Ba, Oc, el, ni, pd, tl, Ad, gd, gs, nl, Dr, n1, r1, Mg, Ws, Qg, rs;
const mo = class mo {
  constructor({
    editor: ue = null,
    uiManager: Qe = null
  }) {
    tn(this, Dr);
    tn(this, fd, en(this, Dr, Mg).bind(this));
    tn(this, hd, en(this, Dr, Qg).bind(this));
    tn(this, Ba, null);
    tn(this, Oc, null);
    tn(this, el);
    tn(this, ni, null);
    tn(this, pd, !1);
    tn(this, tl, !1);
    tn(this, Ad, null);
    tn(this, gd);
    tn(this, gs, null);
    tn(this, nl);
    var Ue;
    ue ? (Zt(this, tl, !1), Zt(this, nl, AnnotationEditorParamsType.HIGHLIGHT_COLOR), Zt(this, Ad, ue)) : (Zt(this, tl, !0), Zt(this, nl, AnnotationEditorParamsType.HIGHLIGHT_DEFAULT_COLOR)), Zt(this, gs, (ue == null ? void 0 : ue._uiManager) || Qe), Zt(this, gd, xt(this, gs)._eventBus), Zt(this, el, (ue == null ? void 0 : ue.color) || ((Ue = xt(this, gs)) == null ? void 0 : Ue.highlightColors.values().next().value) || "#FFFF98");
  }
  static get _keyboardManager() {
    return shadow(this, "_keyboardManager", new KeyboardManager([[["Escape", "mac+Escape"], mo.prototype._hideDropdownFromKeyboard], [[" ", "mac+ "], mo.prototype._colorSelectFromKeyboard], [["ArrowDown", "ArrowRight", "mac+ArrowDown", "mac+ArrowRight"], mo.prototype._moveToNext], [["ArrowUp", "ArrowLeft", "mac+ArrowUp", "mac+ArrowLeft"], mo.prototype._moveToPrevious], [["Home", "mac+Home"], mo.prototype._moveToBeginning], [["End", "mac+End"], mo.prototype._moveToEnd]]));
  }
  renderButton() {
    const ue = Zt(this, Ba, document.createElement("button"));
    ue.className = "colorPicker", ue.tabIndex = "0", ue.setAttribute("data-l10n-id", "pdfjs-editor-colorpicker-button"), ue.setAttribute("aria-haspopup", !0), ue.addEventListener("click", en(this, Dr, Ws).bind(this)), ue.addEventListener("keydown", xt(this, fd));
    const Qe = Zt(this, Oc, document.createElement("span"));
    return Qe.className = "swatch", Qe.setAttribute("aria-hidden", !0), Qe.style.backgroundColor = xt(this, el), ue.append(Qe), ue;
  }
  renderMainDropdown() {
    const ue = Zt(this, ni, en(this, Dr, n1).call(this));
    return ue.setAttribute("aria-orientation", "horizontal"), ue.setAttribute("aria-labelledby", "highlightColorPickerLabel"), ue;
  }
  _colorSelectFromKeyboard(ue) {
    if (ue.target === xt(this, Ba)) {
      en(this, Dr, Ws).call(this, ue);
      return;
    }
    const Qe = ue.target.getAttribute("data-color");
    Qe && en(this, Dr, r1).call(this, Qe, ue);
  }
  _moveToNext(ue) {
    var Qe, Ue;
    if (!xt(this, Dr, rs)) {
      en(this, Dr, Ws).call(this, ue);
      return;
    }
    if (ue.target === xt(this, Ba)) {
      (Qe = xt(this, ni).firstChild) == null || Qe.focus();
      return;
    }
    (Ue = ue.target.nextSibling) == null || Ue.focus();
  }
  _moveToPrevious(ue) {
    var Qe, Ue;
    if (ue.target === ((Qe = xt(this, ni)) == null ? void 0 : Qe.firstChild) || ue.target === xt(this, Ba)) {
      xt(this, Dr, rs) && this._hideDropdownFromKeyboard();
      return;
    }
    xt(this, Dr, rs) || en(this, Dr, Ws).call(this, ue), (Ue = ue.target.previousSibling) == null || Ue.focus();
  }
  _moveToBeginning(ue) {
    var Qe;
    if (!xt(this, Dr, rs)) {
      en(this, Dr, Ws).call(this, ue);
      return;
    }
    (Qe = xt(this, ni).firstChild) == null || Qe.focus();
  }
  _moveToEnd(ue) {
    var Qe;
    if (!xt(this, Dr, rs)) {
      en(this, Dr, Ws).call(this, ue);
      return;
    }
    (Qe = xt(this, ni).lastChild) == null || Qe.focus();
  }
  hideDropdown() {
    var ue;
    (ue = xt(this, ni)) == null || ue.classList.add("hidden"), window.removeEventListener("pointerdown", xt(this, hd));
  }
  _hideDropdownFromKeyboard() {
    var ue;
    if (!xt(this, tl)) {
      if (!xt(this, Dr, rs)) {
        (ue = xt(this, Ad)) == null || ue.unselect();
        return;
      }
      this.hideDropdown(), xt(this, Ba).focus({
        preventScroll: !0,
        focusVisible: xt(this, pd)
      });
    }
  }
  updateColor(ue) {
    if (xt(this, Oc) && (xt(this, Oc).style.backgroundColor = ue), !xt(this, ni))
      return;
    const Qe = xt(this, gs).highlightColors.values();
    for (const Ue of xt(this, ni).children)
      Ue.setAttribute("aria-selected", Qe.next().value === ue);
  }
  destroy() {
    var ue, Qe;
    (ue = xt(this, Ba)) == null || ue.remove(), Zt(this, Ba, null), Zt(this, Oc, null), (Qe = xt(this, ni)) == null || Qe.remove(), Zt(this, ni, null);
  }
};
fd = new WeakMap(), hd = new WeakMap(), Ba = new WeakMap(), Oc = new WeakMap(), el = new WeakMap(), ni = new WeakMap(), pd = new WeakMap(), tl = new WeakMap(), Ad = new WeakMap(), gd = new WeakMap(), gs = new WeakMap(), nl = new WeakMap(), Dr = new WeakSet(), n1 = function() {
  const ue = document.createElement("div");
  ue.addEventListener("contextmenu", noContextMenu), ue.className = "dropdown", ue.role = "listbox", ue.setAttribute("aria-multiselectable", !1), ue.setAttribute("aria-orientation", "vertical"), ue.setAttribute("data-l10n-id", "pdfjs-editor-colorpicker-dropdown");
  for (const [Qe, Ue] of xt(this, gs).highlightColors) {
    const He = document.createElement("button");
    He.tabIndex = "0", He.role = "option", He.setAttribute("data-color", Ue), He.title = Qe, He.setAttribute("data-l10n-id", `pdfjs-editor-colorpicker-${Qe}`);
    const Ge = document.createElement("span");
    He.append(Ge), Ge.className = "swatch", Ge.style.backgroundColor = Ue, He.setAttribute("aria-selected", Ue === xt(this, el)), He.addEventListener("click", en(this, Dr, r1).bind(this, Ue)), ue.append(He);
  }
  return ue.addEventListener("keydown", xt(this, fd)), ue;
}, r1 = function(ue, Qe) {
  Qe.stopPropagation(), xt(this, gd).dispatch("switchannotationeditorparams", {
    source: this,
    type: xt(this, nl),
    value: ue
  });
}, Mg = function(ue) {
  mo._keyboardManager.exec(this, ue);
}, Ws = function(ue) {
  if (xt(this, Dr, rs)) {
    this.hideDropdown();
    return;
  }
  if (Zt(this, pd, ue.detail === 0), window.addEventListener("pointerdown", xt(this, hd)), xt(this, ni)) {
    xt(this, ni).classList.remove("hidden");
    return;
  }
  const Qe = Zt(this, ni, en(this, Dr, n1).call(this));
  xt(this, Ba).append(Qe);
}, Qg = function(ue) {
  var Qe;
  (Qe = xt(this, ni)) != null && Qe.contains(ue.target) || this.hideDropdown();
}, rs = function() {
  return xt(this, ni) && !xt(this, ni).classList.contains("hidden");
};
let ColorPicker = mo;
var rl, md, ms, Nc, il, ha, Ed, Cd, Dc, Ra, Ni, ea, sf, al, Pc, ri, ol, Xa, vd, fr, i1, a1, Fg, jg, Vg, o1, Vl, ga, Au, Ug, k2, Ul, Hg, Gg, Wg, qg;
const vr = class vr extends AnnotationEditor {
  constructor(Qe) {
    super({
      ...Qe,
      name: "highlightEditor"
    });
    tn(this, fr);
    tn(this, rl, null);
    tn(this, md, 0);
    tn(this, ms);
    tn(this, Nc, null);
    tn(this, il, null);
    tn(this, ha, null);
    tn(this, Ed, null);
    tn(this, Cd, 0);
    tn(this, Dc, null);
    tn(this, Ra, null);
    tn(this, Ni, null);
    tn(this, ea, !1);
    tn(this, sf, en(this, fr, Ug).bind(this));
    tn(this, al, null);
    tn(this, Pc);
    tn(this, ri, null);
    tn(this, ol, "");
    tn(this, Xa);
    tn(this, vd, "");
    this.color = Qe.color || vr._defaultColor, Zt(this, Xa, Qe.thickness || vr._defaultThickness), Zt(this, Pc, Qe.opacity || vr._defaultOpacity), Zt(this, ms, Qe.boxes || null), Zt(this, vd, Qe.methodOfCreation || ""), Zt(this, ol, Qe.text || ""), this._isDraggable = !1, Qe.highlightId > -1 ? (Zt(this, ea, !0), en(this, fr, a1).call(this, Qe), en(this, fr, Vl).call(this)) : (Zt(this, rl, Qe.anchorNode), Zt(this, md, Qe.anchorOffset), Zt(this, Ed, Qe.focusNode), Zt(this, Cd, Qe.focusOffset), en(this, fr, i1).call(this), en(this, fr, Vl).call(this), this.rotate(this.rotation));
  }
  static get _keyboardManager() {
    const Qe = vr.prototype;
    return shadow(this, "_keyboardManager", new KeyboardManager([[["ArrowLeft", "mac+ArrowLeft"], Qe._moveCaret, {
      args: [0]
    }], [["ArrowRight", "mac+ArrowRight"], Qe._moveCaret, {
      args: [1]
    }], [["ArrowUp", "mac+ArrowUp"], Qe._moveCaret, {
      args: [2]
    }], [["ArrowDown", "mac+ArrowDown"], Qe._moveCaret, {
      args: [3]
    }]]));
  }
  get telemetryInitialData() {
    return {
      action: "added",
      type: xt(this, ea) ? "free_highlight" : "highlight",
      color: this._uiManager.highlightColorNames.get(this.color),
      thickness: xt(this, Xa),
      methodOfCreation: xt(this, vd)
    };
  }
  get telemetryFinalData() {
    return {
      type: "highlight",
      color: this._uiManager.highlightColorNames.get(this.color)
    };
  }
  static computeTelemetryFinalData(Qe) {
    return {
      numberOfColors: Qe.get("color").size
    };
  }
  static initialize(Qe, Ue) {
    var He;
    AnnotationEditor.initialize(Qe, Ue), vr._defaultColor || (vr._defaultColor = ((He = Ue.highlightColors) == null ? void 0 : He.values().next().value) || "#fff066");
  }
  static updateDefaultParams(Qe, Ue) {
    switch (Qe) {
      case AnnotationEditorParamsType.HIGHLIGHT_DEFAULT_COLOR:
        vr._defaultColor = Ue;
        break;
      case AnnotationEditorParamsType.HIGHLIGHT_THICKNESS:
        vr._defaultThickness = Ue;
        break;
    }
  }
  translateInPage(Qe, Ue) {
  }
  get toolbarPosition() {
    return xt(this, al);
  }
  updateParams(Qe, Ue) {
    switch (Qe) {
      case AnnotationEditorParamsType.HIGHLIGHT_COLOR:
        en(this, fr, Fg).call(this, Ue);
        break;
      case AnnotationEditorParamsType.HIGHLIGHT_THICKNESS:
        en(this, fr, jg).call(this, Ue);
        break;
    }
  }
  static get defaultPropertiesToUpdate() {
    return [[AnnotationEditorParamsType.HIGHLIGHT_DEFAULT_COLOR, vr._defaultColor], [AnnotationEditorParamsType.HIGHLIGHT_THICKNESS, vr._defaultThickness]];
  }
  get propertiesToUpdate() {
    return [[AnnotationEditorParamsType.HIGHLIGHT_COLOR, this.color || vr._defaultColor], [AnnotationEditorParamsType.HIGHLIGHT_THICKNESS, xt(this, Xa) || vr._defaultThickness], [AnnotationEditorParamsType.HIGHLIGHT_FREE, xt(this, ea)]];
  }
  async addEditToolbar() {
    const Qe = await super.addEditToolbar();
    return Qe ? (this._uiManager.highlightColors && (Zt(this, il, new ColorPicker({
      editor: this
    })), Qe.addColorPicker(xt(this, il))), Qe) : null;
  }
  disableEditing() {
    super.disableEditing(), this.div.classList.toggle("disabled", !0);
  }
  enableEditing() {
    super.enableEditing(), this.div.classList.toggle("disabled", !1);
  }
  fixAndSetPosition() {
    return super.fixAndSetPosition(en(this, fr, Ul).call(this));
  }
  getBaseTranslation() {
    return [0, 0];
  }
  getRect(Qe, Ue) {
    return super.getRect(Qe, Ue, en(this, fr, Ul).call(this));
  }
  onceAdded() {
    this.parent.addUndoableEditor(this), this.div.focus();
  }
  remove() {
    en(this, fr, o1).call(this), this._reportTelemetry({
      action: "deleted"
    }), super.remove();
  }
  rebuild() {
    this.parent && (super.rebuild(), this.div !== null && (en(this, fr, Vl).call(this), this.isAttachedToDOM || this.parent.add(this)));
  }
  setParent(Qe) {
    var He;
    let Ue = !1;
    this.parent && !Qe ? en(this, fr, o1).call(this) : Qe && (en(this, fr, Vl).call(this, Qe), Ue = !this.parent && ((He = this.div) == null ? void 0 : He.classList.contains("selectedEditor"))), super.setParent(Qe), this.show(this._isVisible), Ue && this.select();
  }
  rotate(Qe) {
    var Ge, Xe, Ke;
    const {
      drawLayer: Ue
    } = this.parent;
    let He;
    xt(this, ea) ? (Qe = (Qe - this.rotation + 360) % 360, He = en(Ge = vr, ga, Au).call(Ge, xt(this, Ra).box, Qe)) : He = en(Xe = vr, ga, Au).call(Xe, this, Qe), Ue.rotate(xt(this, Ni), Qe), Ue.rotate(xt(this, ri), Qe), Ue.updateBox(xt(this, Ni), He), Ue.updateBox(xt(this, ri), en(Ke = vr, ga, Au).call(Ke, xt(this, ha).box, Qe));
  }
  render() {
    if (this.div)
      return this.div;
    const Qe = super.render();
    xt(this, ol) && (Qe.setAttribute("aria-label", xt(this, ol)), Qe.setAttribute("role", "mark")), xt(this, ea) ? Qe.classList.add("free") : this.div.addEventListener("keydown", xt(this, sf));
    const Ue = Zt(this, Dc, document.createElement("div"));
    Qe.append(Ue), Ue.setAttribute("aria-hidden", "true"), Ue.className = "internal", Ue.style.clipPath = xt(this, Nc);
    const [He, Ge] = this.parentDimensions;
    return this.setDims(this.width * He, this.height * Ge), bindEvents(this, xt(this, Dc), ["pointerover", "pointerleave"]), this.enableEditing(), Qe;
  }
  pointerover() {
    this.parent.drawLayer.addClass(xt(this, ri), "hovered");
  }
  pointerleave() {
    this.parent.drawLayer.removeClass(xt(this, ri), "hovered");
  }
  _moveCaret(Qe) {
    switch (this.parent.unselect(this), Qe) {
      case 0:
      case 2:
        en(this, fr, k2).call(this, !0);
        break;
      case 1:
      case 3:
        en(this, fr, k2).call(this, !1);
        break;
    }
  }
  select() {
    var Qe, Ue;
    super.select(), xt(this, ri) && ((Qe = this.parent) == null || Qe.drawLayer.removeClass(xt(this, ri), "hovered"), (Ue = this.parent) == null || Ue.drawLayer.addClass(xt(this, ri), "selected"));
  }
  unselect() {
    var Qe;
    super.unselect(), xt(this, ri) && ((Qe = this.parent) == null || Qe.drawLayer.removeClass(xt(this, ri), "selected"), xt(this, ea) || en(this, fr, k2).call(this, !1));
  }
  get _mustFixPosition() {
    return !xt(this, ea);
  }
  show(Qe = this._isVisible) {
    super.show(Qe), this.parent && (this.parent.drawLayer.show(xt(this, Ni), Qe), this.parent.drawLayer.show(xt(this, ri), Qe));
  }
  static startHighlighting(Qe, Ue, {
    target: He,
    x: Ge,
    y: Xe
  }) {
    const {
      x: Ke,
      y: $e,
      width: Je,
      height: Ze
    } = He.getBoundingClientRect(), nt = (it) => {
      en(this, ga, Wg).call(this, Qe, it);
    }, tt = {
      capture: !0,
      passive: !1
    }, et = (it) => {
      it.preventDefault(), it.stopPropagation();
    }, rt = (it) => {
      He.removeEventListener("pointermove", nt), window.removeEventListener("blur", rt), window.removeEventListener("pointerup", rt), window.removeEventListener("pointerdown", et, tt), window.removeEventListener("contextmenu", noContextMenu), en(this, ga, qg).call(this, Qe, it);
    };
    window.addEventListener("blur", rt), window.addEventListener("pointerup", rt), window.addEventListener("pointerdown", et, tt), window.addEventListener("contextmenu", noContextMenu), He.addEventListener("pointermove", nt), this._freeHighlight = new FreeOutliner({
      x: Ge,
      y: Xe
    }, [Ke, $e, Je, Ze], Qe.scale, this._defaultThickness / 2, Ue, 1e-3), {
      id: this._freeHighlightId,
      clipPathId: this._freeHighlightClipId
    } = Qe.drawLayer.highlight(this._freeHighlight, this._defaultColor, this._defaultOpacity, !0);
  }
  static deserialize(Qe, Ue, He) {
    var it;
    const Ge = super.deserialize(Qe, Ue, He), {
      rect: [Xe, Ke, $e, Je],
      color: Ze,
      quadPoints: nt
    } = Qe;
    Ge.color = Util.makeHexColor(...Ze), Zt(Ge, Pc, Qe.opacity);
    const [tt, et] = Ge.pageDimensions;
    Ge.width = ($e - Xe) / tt, Ge.height = (Je - Ke) / et;
    const rt = Zt(Ge, ms, []);
    for (let ot = 0; ot < nt.length; ot += 8)
      rt.push({
        x: (nt[4] - $e) / tt,
        y: (Je - (1 - nt[ot + 5])) / et,
        width: (nt[ot + 2] - nt[ot]) / tt,
        height: (nt[ot + 5] - nt[ot + 1]) / et
      });
    return en(it = Ge, fr, i1).call(it), Ge;
  }
  serialize(Qe = !1) {
    if (this.isEmpty() || Qe)
      return null;
    const Ue = this.getRect(0, 0), He = AnnotationEditor._colorManager.convert(this.color);
    return {
      annotationType: AnnotationEditorType.HIGHLIGHT,
      color: He,
      opacity: xt(this, Pc),
      thickness: xt(this, Xa),
      quadPoints: en(this, fr, Hg).call(this),
      outlines: en(this, fr, Gg).call(this, Ue),
      pageIndex: this.pageIndex,
      rect: Ue,
      rotation: en(this, fr, Ul).call(this),
      structTreeParentId: this._structTreeParentId
    };
  }
  static canCreateNewEmptyEditor() {
    return !1;
  }
};
rl = new WeakMap(), md = new WeakMap(), ms = new WeakMap(), Nc = new WeakMap(), il = new WeakMap(), ha = new WeakMap(), Ed = new WeakMap(), Cd = new WeakMap(), Dc = new WeakMap(), Ra = new WeakMap(), Ni = new WeakMap(), ea = new WeakMap(), sf = new WeakMap(), al = new WeakMap(), Pc = new WeakMap(), ri = new WeakMap(), ol = new WeakMap(), Xa = new WeakMap(), vd = new WeakMap(), fr = new WeakSet(), i1 = function() {
  const Qe = new Outliner(xt(this, ms), 1e-3);
  Zt(this, Ra, Qe.getOutlines()), {
    x: this.x,
    y: this.y,
    width: this.width,
    height: this.height
  } = xt(this, Ra).box;
  const Ue = new Outliner(xt(this, ms), 25e-4, 1e-3, this._uiManager.direction === "ltr");
  Zt(this, ha, Ue.getOutlines());
  const {
    lastPoint: He
  } = xt(this, ha).box;
  Zt(this, al, [(He[0] - this.x) / this.width, (He[1] - this.y) / this.height]);
}, a1 = function({
  highlightOutlines: Qe,
  highlightId: Ue,
  clipPathId: He
}) {
  var nt, tt;
  if (Zt(this, Ra, Qe), Zt(this, ha, Qe.getNewOutline(xt(this, Xa) / 2 + 1.5, 25e-4)), Ue >= 0)
    Zt(this, Ni, Ue), Zt(this, Nc, He), this.parent.drawLayer.finalizeLine(Ue, Qe), Zt(this, ri, this.parent.drawLayer.highlightOutline(xt(this, ha)));
  else if (this.parent) {
    const et = this.parent.viewport.rotation;
    this.parent.drawLayer.updateLine(xt(this, Ni), Qe), this.parent.drawLayer.updateBox(xt(this, Ni), en(nt = vr, ga, Au).call(nt, xt(this, Ra).box, (et - this.rotation + 360) % 360)), this.parent.drawLayer.updateLine(xt(this, ri), xt(this, ha)), this.parent.drawLayer.updateBox(xt(this, ri), en(tt = vr, ga, Au).call(tt, xt(this, ha).box, et));
  }
  const {
    x: Xe,
    y: Ke,
    width: $e,
    height: Je
  } = Qe.box;
  switch (this.rotation) {
    case 0:
      this.x = Xe, this.y = Ke, this.width = $e, this.height = Je;
      break;
    case 90: {
      const [et, rt] = this.parentDimensions;
      this.x = Ke, this.y = 1 - Xe, this.width = $e * rt / et, this.height = Je * et / rt;
      break;
    }
    case 180:
      this.x = 1 - Xe, this.y = 1 - Ke, this.width = $e, this.height = Je;
      break;
    case 270: {
      const [et, rt] = this.parentDimensions;
      this.x = 1 - Ke, this.y = Xe, this.width = $e * rt / et, this.height = Je * et / rt;
      break;
    }
  }
  const {
    lastPoint: Ze
  } = xt(this, ha).box;
  Zt(this, al, [(Ze[0] - Xe) / $e, (Ze[1] - Ke) / Je]);
}, Fg = function(Qe) {
  const Ue = (Ge) => {
    var Xe, Ke;
    this.color = Ge, (Xe = this.parent) == null || Xe.drawLayer.changeColor(xt(this, Ni), Ge), (Ke = xt(this, il)) == null || Ke.updateColor(Ge);
  }, He = this.color;
  this.addCommands({
    cmd: Ue.bind(this, Qe),
    undo: Ue.bind(this, He),
    post: this._uiManager.updateUI.bind(this._uiManager, this),
    mustExec: !0,
    type: AnnotationEditorParamsType.HIGHLIGHT_COLOR,
    overwriteIfSameType: !0,
    keepUndo: !0
  }), this._reportTelemetry({
    action: "color_changed",
    color: this._uiManager.highlightColorNames.get(Qe)
  }, !0);
}, jg = function(Qe) {
  const Ue = xt(this, Xa), He = (Ge) => {
    Zt(this, Xa, Ge), en(this, fr, Vg).call(this, Ge);
  };
  this.addCommands({
    cmd: He.bind(this, Qe),
    undo: He.bind(this, Ue),
    post: this._uiManager.updateUI.bind(this._uiManager, this),
    mustExec: !0,
    type: AnnotationEditorParamsType.INK_THICKNESS,
    overwriteIfSameType: !0,
    keepUndo: !0
  }), this._reportTelemetry({
    action: "thickness_changed",
    thickness: Qe
  }, !0);
}, Vg = function(Qe) {
  if (!xt(this, ea))
    return;
  en(this, fr, a1).call(this, {
    highlightOutlines: xt(this, Ra).getNewOutline(Qe / 2)
  }), this.fixAndSetPosition();
  const [Ue, He] = this.parentDimensions;
  this.setDims(this.width * Ue, this.height * He);
}, o1 = function() {
  xt(this, Ni) === null || !this.parent || (this.parent.drawLayer.remove(xt(this, Ni)), Zt(this, Ni, null), this.parent.drawLayer.remove(xt(this, ri)), Zt(this, ri, null));
}, Vl = function(Qe = this.parent) {
  xt(this, Ni) === null && ({
    id: Xi(this, Ni)._,
    clipPathId: Xi(this, Nc)._
  } = Qe.drawLayer.highlight(xt(this, Ra), this.color, xt(this, Pc)), Zt(this, ri, Qe.drawLayer.highlightOutline(xt(this, ha))), xt(this, Dc) && (xt(this, Dc).style.clipPath = xt(this, Nc)));
}, ga = new WeakSet(), Au = function({
  x: Qe,
  y: Ue,
  width: He,
  height: Ge
}, Xe) {
  switch (Xe) {
    case 90:
      return {
        x: 1 - Ue - Ge,
        y: Qe,
        width: Ge,
        height: He
      };
    case 180:
      return {
        x: 1 - Qe - He,
        y: 1 - Ue - Ge,
        width: He,
        height: Ge
      };
    case 270:
      return {
        x: Ue,
        y: 1 - Qe - He,
        width: Ge,
        height: He
      };
  }
  return {
    x: Qe,
    y: Ue,
    width: He,
    height: Ge
  };
}, Ug = function(Qe) {
  vr._keyboardManager.exec(this, Qe);
}, k2 = function(Qe) {
  if (!xt(this, rl))
    return;
  const Ue = window.getSelection();
  Qe ? Ue.setPosition(xt(this, rl), xt(this, md)) : Ue.setPosition(xt(this, Ed), xt(this, Cd));
}, Ul = function() {
  return xt(this, ea) ? this.rotation : 0;
}, Hg = function() {
  if (xt(this, ea))
    return null;
  const [Qe, Ue] = this.pageDimensions, He = xt(this, ms), Ge = new Array(He.length * 8);
  let Xe = 0;
  for (const {
    x: Ke,
    y: $e,
    width: Je,
    height: Ze
  } of He) {
    const nt = Ke * Qe, tt = (1 - $e - Ze) * Ue;
    Ge[Xe] = Ge[Xe + 4] = nt, Ge[Xe + 1] = Ge[Xe + 3] = tt, Ge[Xe + 2] = Ge[Xe + 6] = nt + Je * Qe, Ge[Xe + 5] = Ge[Xe + 7] = tt + Ze * Ue, Xe += 8;
  }
  return Ge;
}, Gg = function(Qe) {
  return xt(this, Ra).serialize(Qe, en(this, fr, Ul).call(this));
}, Wg = function(Qe, Ue) {
  this._freeHighlight.add(Ue) && Qe.drawLayer.updatePath(this._freeHighlightId, this._freeHighlight);
}, qg = function(Qe, Ue) {
  this._freeHighlight.isEmpty() ? Qe.drawLayer.removeFreeHighlight(this._freeHighlightId) : Qe.createAndAddNewEditor(Ue, !1, {
    highlightId: this._freeHighlightId,
    highlightOutlines: this._freeHighlight.getOutlines(),
    clipPathId: this._freeHighlightClipId,
    methodOfCreation: "main_toolbar"
  }), this._freeHighlightId = -1, this._freeHighlight = null, this._freeHighlightClipId = "";
}, tn(vr, ga), $n(vr, "_defaultColor", null), $n(vr, "_defaultOpacity", 1), $n(vr, "_defaultThickness", 12), $n(vr, "_l10nPromise"), $n(vr, "_type", "highlight"), $n(vr, "_editorType", AnnotationEditorType.HIGHLIGHT), $n(vr, "_freeHighlightId", -1), $n(vr, "_freeHighlight", null), $n(vr, "_freeHighlightClipId", "");
let HighlightEditor = vr;
var kc, _c, yd, Id, xd, Lc, Ka, Mo, pa, Mc, Qc, Fc, jc, Vc, Es, kn, zg, Xg, Kg, Yg, s1, $g, c1, Jg, Zg, em, tm, nm, qs, u1, _2, L2, gu, l1, M2, Wo, rm, d1, im, am, f1, Q2, Hl;
const Hr = class Hr extends AnnotationEditor {
  constructor(Qe) {
    super({
      ...Qe,
      name: "inkEditor"
    });
    tn(this, kn);
    tn(this, kc, 0);
    tn(this, _c, 0);
    tn(this, yd, this.canvasPointermove.bind(this));
    tn(this, Id, this.canvasPointerleave.bind(this));
    tn(this, xd, this.canvasPointerup.bind(this));
    tn(this, Lc, this.canvasPointerdown.bind(this));
    tn(this, Ka, null);
    tn(this, Mo, new Path2D());
    tn(this, pa, !1);
    tn(this, Mc, !1);
    tn(this, Qc, !1);
    tn(this, Fc, null);
    tn(this, jc, 0);
    tn(this, Vc, 0);
    tn(this, Es, null);
    this.color = Qe.color || null, this.thickness = Qe.thickness || null, this.opacity = Qe.opacity || null, this.paths = [], this.bezierPath2D = [], this.allRawPaths = [], this.currentPath = [], this.scaleFactor = 1, this.translationX = this.translationY = 0, this.x = 0, this.y = 0, this._willKeepAspectRatio = !0;
  }
  static initialize(Qe, Ue) {
    AnnotationEditor.initialize(Qe, Ue);
  }
  static updateDefaultParams(Qe, Ue) {
    switch (Qe) {
      case AnnotationEditorParamsType.INK_THICKNESS:
        Hr._defaultThickness = Ue;
        break;
      case AnnotationEditorParamsType.INK_COLOR:
        Hr._defaultColor = Ue;
        break;
      case AnnotationEditorParamsType.INK_OPACITY:
        Hr._defaultOpacity = Ue / 100;
        break;
    }
  }
  updateParams(Qe, Ue) {
    switch (Qe) {
      case AnnotationEditorParamsType.INK_THICKNESS:
        en(this, kn, zg).call(this, Ue);
        break;
      case AnnotationEditorParamsType.INK_COLOR:
        en(this, kn, Xg).call(this, Ue);
        break;
      case AnnotationEditorParamsType.INK_OPACITY:
        en(this, kn, Kg).call(this, Ue);
        break;
    }
  }
  static get defaultPropertiesToUpdate() {
    return [[AnnotationEditorParamsType.INK_THICKNESS, Hr._defaultThickness], [AnnotationEditorParamsType.INK_COLOR, Hr._defaultColor || AnnotationEditor._defaultLineColor], [AnnotationEditorParamsType.INK_OPACITY, Math.round(Hr._defaultOpacity * 100)]];
  }
  get propertiesToUpdate() {
    return [[AnnotationEditorParamsType.INK_THICKNESS, this.thickness || Hr._defaultThickness], [AnnotationEditorParamsType.INK_COLOR, this.color || Hr._defaultColor || AnnotationEditor._defaultLineColor], [AnnotationEditorParamsType.INK_OPACITY, Math.round(100 * (this.opacity ?? Hr._defaultOpacity))]];
  }
  rebuild() {
    this.parent && (super.rebuild(), this.div !== null && (this.canvas || (en(this, kn, _2).call(this), en(this, kn, L2).call(this)), this.isAttachedToDOM || (this.parent.add(this), en(this, kn, gu).call(this)), en(this, kn, Hl).call(this)));
  }
  remove() {
    this.canvas !== null && (this.isEmpty() || this.commit(), this.canvas.width = this.canvas.height = 0, this.canvas.remove(), this.canvas = null, xt(this, Ka) && (clearTimeout(xt(this, Ka)), Zt(this, Ka, null)), xt(this, Fc).disconnect(), Zt(this, Fc, null), super.remove());
  }
  setParent(Qe) {
    !this.parent && Qe ? this._uiManager.removeShouldRescale(this) : this.parent && Qe === null && this._uiManager.addShouldRescale(this), super.setParent(Qe);
  }
  onScaleChanging() {
    const [Qe, Ue] = this.parentDimensions, He = this.width * Qe, Ge = this.height * Ue;
    this.setDimensions(He, Ge);
  }
  enableEditMode() {
    xt(this, pa) || this.canvas === null || (super.enableEditMode(), this._isDraggable = !1, this.canvas.addEventListener("pointerdown", xt(this, Lc)));
  }
  disableEditMode() {
    !this.isInEditMode() || this.canvas === null || (super.disableEditMode(), this._isDraggable = !this.isEmpty(), this.div.classList.remove("editing"), this.canvas.removeEventListener("pointerdown", xt(this, Lc)));
  }
  onceAdded() {
    this._isDraggable = !this.isEmpty();
  }
  isEmpty() {
    return this.paths.length === 0 || this.paths.length === 1 && this.paths[0].length === 0;
  }
  commit() {
    xt(this, pa) || (super.commit(), this.isEditing = !1, this.disableEditMode(), this.setInForeground(), Zt(this, pa, !0), this.div.classList.add("disabled"), en(this, kn, Hl).call(this, !0), this.select(), this.parent.addInkEditorIfNeeded(!0), this.moveInDOM(), this.div.focus({
      preventScroll: !0
    }));
  }
  focusin(Qe) {
    this._focusEventsAllowed && (super.focusin(Qe), this.enableEditMode());
  }
  canvasPointerdown(Qe) {
    Qe.button !== 0 || !this.isInEditMode() || xt(this, pa) || (this.setInForeground(), Qe.preventDefault(), this.div.contains(document.activeElement) || this.div.focus({
      preventScroll: !0
    }), en(this, kn, $g).call(this, Qe.offsetX, Qe.offsetY));
  }
  canvasPointermove(Qe) {
    Qe.preventDefault(), en(this, kn, c1).call(this, Qe.offsetX, Qe.offsetY);
  }
  canvasPointerup(Qe) {
    Qe.preventDefault(), en(this, kn, u1).call(this, Qe);
  }
  canvasPointerleave(Qe) {
    en(this, kn, u1).call(this, Qe);
  }
  get isResizable() {
    return !this.isEmpty() && xt(this, pa);
  }
  render() {
    if (this.div)
      return this.div;
    let Qe, Ue;
    this.width && (Qe = this.x, Ue = this.y), super.render(), this.div.setAttribute("data-l10n-id", "pdfjs-ink");
    const [He, Ge, Xe, Ke] = en(this, kn, Yg).call(this);
    if (this.setAt(He, Ge, 0, 0), this.setDims(Xe, Ke), en(this, kn, _2).call(this), this.width) {
      const [$e, Je] = this.parentDimensions;
      this.setAspectRatio(this.width * $e, this.height * Je), this.setAt(Qe * $e, Ue * Je, this.width * $e, this.height * Je), Zt(this, Qc, !0), en(this, kn, gu).call(this), this.setDims(this.width * $e, this.height * Je), en(this, kn, qs).call(this), this.div.classList.add("disabled");
    } else
      this.div.classList.add("editing"), this.enableEditMode();
    return en(this, kn, L2).call(this), this.div;
  }
  setDimensions(Qe, Ue) {
    const He = Math.round(Qe), Ge = Math.round(Ue);
    if (xt(this, jc) === He && xt(this, Vc) === Ge)
      return;
    Zt(this, jc, He), Zt(this, Vc, Ge), this.canvas.style.visibility = "hidden";
    const [Xe, Ke] = this.parentDimensions;
    this.width = Qe / Xe, this.height = Ue / Ke, this.fixAndSetPosition(), xt(this, pa) && en(this, kn, l1).call(this, Qe, Ue), en(this, kn, gu).call(this), en(this, kn, qs).call(this), this.canvas.style.visibility = "visible", this.fixDims();
  }
  static deserialize(Qe, Ue, He) {
    var ot, at, st;
    if (Qe instanceof InkAnnotationElement)
      return null;
    const Ge = super.deserialize(Qe, Ue, He);
    Ge.thickness = Qe.thickness, Ge.color = Util.makeHexColor(...Qe.color), Ge.opacity = Qe.opacity;
    const [Xe, Ke] = Ge.pageDimensions, $e = Ge.width * Xe, Je = Ge.height * Ke, Ze = Ge.parentScale, nt = Qe.thickness / 2;
    Zt(Ge, pa, !0), Zt(Ge, jc, Math.round($e)), Zt(Ge, Vc, Math.round(Je));
    const {
      paths: tt,
      rect: et,
      rotation: rt
    } = Qe;
    for (let {
      bezier: ut
    } of tt) {
      ut = en(ot = Hr, Wo, im).call(ot, ut, et, rt);
      const lt = [];
      Ge.paths.push(lt);
      let dt = Ze * (ut[0] - nt), At = Ze * (ut[1] - nt);
      for (let gt = 2, wt = ut.length; gt < wt; gt += 6) {
        const Bt = Ze * (ut[gt] - nt), Tt = Ze * (ut[gt + 1] - nt), yt = Ze * (ut[gt + 2] - nt), Ct = Ze * (ut[gt + 3] - nt), ht = Ze * (ut[gt + 4] - nt), It = Ze * (ut[gt + 5] - nt);
        lt.push([[dt, At], [Bt, Tt], [yt, Ct], [ht, It]]), dt = ht, At = It;
      }
      const pt = en(this, Wo, rm).call(this, lt);
      Ge.bezierPath2D.push(pt);
    }
    const it = en(at = Ge, kn, f1).call(at);
    return Zt(Ge, _c, Math.max(AnnotationEditor.MIN_SIZE, it[2] - it[0])), Zt(Ge, kc, Math.max(AnnotationEditor.MIN_SIZE, it[3] - it[1])), en(st = Ge, kn, l1).call(st, $e, Je), Ge;
  }
  serialize() {
    if (this.isEmpty())
      return null;
    const Qe = this.getRect(0, 0), Ue = AnnotationEditor._colorManager.convert(this.ctx.strokeStyle);
    return {
      annotationType: AnnotationEditorType.INK,
      color: Ue,
      thickness: this.thickness,
      opacity: this.opacity,
      paths: en(this, kn, am).call(this, this.scaleFactor / this.parentScale, this.translationX, this.translationY, Qe),
      pageIndex: this.pageIndex,
      rect: Qe,
      rotation: this.rotation,
      structTreeParentId: this._structTreeParentId
    };
  }
};
kc = new WeakMap(), _c = new WeakMap(), yd = new WeakMap(), Id = new WeakMap(), xd = new WeakMap(), Lc = new WeakMap(), Ka = new WeakMap(), Mo = new WeakMap(), pa = new WeakMap(), Mc = new WeakMap(), Qc = new WeakMap(), Fc = new WeakMap(), jc = new WeakMap(), Vc = new WeakMap(), Es = new WeakMap(), kn = new WeakSet(), zg = function(Qe) {
  const Ue = (Ge) => {
    this.thickness = Ge, en(this, kn, Hl).call(this);
  }, He = this.thickness;
  this.addCommands({
    cmd: Ue.bind(this, Qe),
    undo: Ue.bind(this, He),
    post: this._uiManager.updateUI.bind(this._uiManager, this),
    mustExec: !0,
    type: AnnotationEditorParamsType.INK_THICKNESS,
    overwriteIfSameType: !0,
    keepUndo: !0
  });
}, Xg = function(Qe) {
  const Ue = (Ge) => {
    this.color = Ge, en(this, kn, qs).call(this);
  }, He = this.color;
  this.addCommands({
    cmd: Ue.bind(this, Qe),
    undo: Ue.bind(this, He),
    post: this._uiManager.updateUI.bind(this._uiManager, this),
    mustExec: !0,
    type: AnnotationEditorParamsType.INK_COLOR,
    overwriteIfSameType: !0,
    keepUndo: !0
  });
}, Kg = function(Qe) {
  const Ue = (Ge) => {
    this.opacity = Ge, en(this, kn, qs).call(this);
  };
  Qe /= 100;
  const He = this.opacity;
  this.addCommands({
    cmd: Ue.bind(this, Qe),
    undo: Ue.bind(this, He),
    post: this._uiManager.updateUI.bind(this._uiManager, this),
    mustExec: !0,
    type: AnnotationEditorParamsType.INK_OPACITY,
    overwriteIfSameType: !0,
    keepUndo: !0
  });
}, Yg = function() {
  const {
    parentRotation: Qe,
    parentDimensions: [Ue, He]
  } = this;
  switch (Qe) {
    case 90:
      return [0, He, He, Ue];
    case 180:
      return [Ue, He, Ue, He];
    case 270:
      return [Ue, 0, He, Ue];
    default:
      return [0, 0, Ue, He];
  }
}, s1 = function() {
  const {
    ctx: Qe,
    color: Ue,
    opacity: He,
    thickness: Ge,
    parentScale: Xe,
    scaleFactor: Ke
  } = this;
  Qe.lineWidth = Ge * Xe / Ke, Qe.lineCap = "round", Qe.lineJoin = "round", Qe.miterLimit = 10, Qe.strokeStyle = `${Ue}${opacityToHex(He)}`;
}, $g = function(Qe, Ue) {
  this.canvas.addEventListener("contextmenu", noContextMenu), this.canvas.addEventListener("pointerleave", xt(this, Id)), this.canvas.addEventListener("pointermove", xt(this, yd)), this.canvas.addEventListener("pointerup", xt(this, xd)), this.canvas.removeEventListener("pointerdown", xt(this, Lc)), this.isEditing = !0, xt(this, Qc) || (Zt(this, Qc, !0), en(this, kn, gu).call(this), this.thickness || (this.thickness = Hr._defaultThickness), this.color || (this.color = Hr._defaultColor || AnnotationEditor._defaultLineColor), this.opacity ?? (this.opacity = Hr._defaultOpacity)), this.currentPath.push([Qe, Ue]), Zt(this, Mc, !1), en(this, kn, s1).call(this), Zt(this, Es, () => {
    en(this, kn, em).call(this), xt(this, Es) && window.requestAnimationFrame(xt(this, Es));
  }), window.requestAnimationFrame(xt(this, Es));
}, c1 = function(Qe, Ue) {
  const [He, Ge] = this.currentPath.at(-1);
  if (this.currentPath.length > 1 && Qe === He && Ue === Ge)
    return;
  const Xe = this.currentPath;
  let Ke = xt(this, Mo);
  if (Xe.push([Qe, Ue]), Zt(this, Mc, !0), Xe.length <= 2) {
    Ke.moveTo(...Xe[0]), Ke.lineTo(Qe, Ue);
    return;
  }
  Xe.length === 3 && (Zt(this, Mo, Ke = new Path2D()), Ke.moveTo(...Xe[0])), en(this, kn, tm).call(this, Ke, ...Xe.at(-3), ...Xe.at(-2), Qe, Ue);
}, Jg = function() {
  if (this.currentPath.length === 0)
    return;
  const Qe = this.currentPath.at(-1);
  xt(this, Mo).lineTo(...Qe);
}, Zg = function(Qe, Ue) {
  Zt(this, Es, null), Qe = Math.min(Math.max(Qe, 0), this.canvas.width), Ue = Math.min(Math.max(Ue, 0), this.canvas.height), en(this, kn, c1).call(this, Qe, Ue), en(this, kn, Jg).call(this);
  let He;
  if (this.currentPath.length !== 1)
    He = en(this, kn, nm).call(this);
  else {
    const Je = [Qe, Ue];
    He = [[Je, Je.slice(), Je.slice(), Je]];
  }
  const Ge = xt(this, Mo), Xe = this.currentPath;
  this.currentPath = [], Zt(this, Mo, new Path2D());
  const Ke = () => {
    this.allRawPaths.push(Xe), this.paths.push(He), this.bezierPath2D.push(Ge), this._uiManager.rebuild(this);
  }, $e = () => {
    this.allRawPaths.pop(), this.paths.pop(), this.bezierPath2D.pop(), this.paths.length === 0 ? this.remove() : (this.canvas || (en(this, kn, _2).call(this), en(this, kn, L2).call(this)), en(this, kn, Hl).call(this));
  };
  this.addCommands({
    cmd: Ke,
    undo: $e,
    mustExec: !0
  });
}, em = function() {
  if (!xt(this, Mc))
    return;
  Zt(this, Mc, !1);
  const Qe = Math.ceil(this.thickness * this.parentScale), Ue = this.currentPath.slice(-3), He = Ue.map((Ke) => Ke[0]), Ge = Ue.map((Ke) => Ke[1]);
  Math.min(...He) - Qe, Math.max(...He) + Qe, Math.min(...Ge) - Qe, Math.max(...Ge) + Qe;
  const {
    ctx: Xe
  } = this;
  Xe.save(), Xe.clearRect(0, 0, this.canvas.width, this.canvas.height);
  for (const Ke of this.bezierPath2D)
    Xe.stroke(Ke);
  Xe.stroke(xt(this, Mo)), Xe.restore();
}, tm = function(Qe, Ue, He, Ge, Xe, Ke, $e) {
  const Je = (Ue + Ge) / 2, Ze = (He + Xe) / 2, nt = (Ge + Ke) / 2, tt = (Xe + $e) / 2;
  Qe.bezierCurveTo(Je + 2 * (Ge - Je) / 3, Ze + 2 * (Xe - Ze) / 3, nt + 2 * (Ge - nt) / 3, tt + 2 * (Xe - tt) / 3, nt, tt);
}, nm = function() {
  const Qe = this.currentPath;
  if (Qe.length <= 2)
    return [[Qe[0], Qe[0], Qe.at(-1), Qe.at(-1)]];
  const Ue = [];
  let He, [Ge, Xe] = Qe[0];
  for (He = 1; He < Qe.length - 2; He++) {
    const [et, rt] = Qe[He], [it, ot] = Qe[He + 1], at = (et + it) / 2, st = (rt + ot) / 2, ut = [Ge + 2 * (et - Ge) / 3, Xe + 2 * (rt - Xe) / 3], lt = [at + 2 * (et - at) / 3, st + 2 * (rt - st) / 3];
    Ue.push([[Ge, Xe], ut, lt, [at, st]]), [Ge, Xe] = [at, st];
  }
  const [Ke, $e] = Qe[He], [Je, Ze] = Qe[He + 1], nt = [Ge + 2 * (Ke - Ge) / 3, Xe + 2 * ($e - Xe) / 3], tt = [Je + 2 * (Ke - Je) / 3, Ze + 2 * ($e - Ze) / 3];
  return Ue.push([[Ge, Xe], nt, tt, [Je, Ze]]), Ue;
}, qs = function() {
  if (this.isEmpty()) {
    en(this, kn, M2).call(this);
    return;
  }
  en(this, kn, s1).call(this);
  const {
    canvas: Qe,
    ctx: Ue
  } = this;
  Ue.setTransform(1, 0, 0, 1, 0, 0), Ue.clearRect(0, 0, Qe.width, Qe.height), en(this, kn, M2).call(this);
  for (const He of this.bezierPath2D)
    Ue.stroke(He);
}, u1 = function(Qe) {
  this.canvas.removeEventListener("pointerleave", xt(this, Id)), this.canvas.removeEventListener("pointermove", xt(this, yd)), this.canvas.removeEventListener("pointerup", xt(this, xd)), this.canvas.addEventListener("pointerdown", xt(this, Lc)), xt(this, Ka) && clearTimeout(xt(this, Ka)), Zt(this, Ka, setTimeout(() => {
    Zt(this, Ka, null), this.canvas.removeEventListener("contextmenu", noContextMenu);
  }, 10)), en(this, kn, Zg).call(this, Qe.offsetX, Qe.offsetY), this.addToAnnotationStorage(), this.setInBackground();
}, _2 = function() {
  this.canvas = document.createElement("canvas"), this.canvas.width = this.canvas.height = 0, this.canvas.className = "inkEditorCanvas", this.canvas.setAttribute("data-l10n-id", "pdfjs-ink-canvas"), this.div.append(this.canvas), this.ctx = this.canvas.getContext("2d");
}, L2 = function() {
  Zt(this, Fc, new ResizeObserver((Qe) => {
    const Ue = Qe[0].contentRect;
    Ue.width && Ue.height && this.setDimensions(Ue.width, Ue.height);
  })), xt(this, Fc).observe(this.div);
}, gu = function() {
  if (!xt(this, Qc))
    return;
  const [Qe, Ue] = this.parentDimensions;
  this.canvas.width = Math.ceil(this.width * Qe), this.canvas.height = Math.ceil(this.height * Ue), en(this, kn, M2).call(this);
}, l1 = function(Qe, Ue) {
  const He = en(this, kn, Q2).call(this), Ge = (Qe - He) / xt(this, _c), Xe = (Ue - He) / xt(this, kc);
  this.scaleFactor = Math.min(Ge, Xe);
}, M2 = function() {
  const Qe = en(this, kn, Q2).call(this) / 2;
  this.ctx.setTransform(this.scaleFactor, 0, 0, this.scaleFactor, this.translationX * this.scaleFactor + Qe, this.translationY * this.scaleFactor + Qe);
}, Wo = new WeakSet(), rm = function(Qe) {
  const Ue = new Path2D();
  for (let He = 0, Ge = Qe.length; He < Ge; He++) {
    const [Xe, Ke, $e, Je] = Qe[He];
    He === 0 && Ue.moveTo(...Xe), Ue.bezierCurveTo(Ke[0], Ke[1], $e[0], $e[1], Je[0], Je[1]);
  }
  return Ue;
}, d1 = function(Qe, Ue, He) {
  const [Ge, Xe, Ke, $e] = Ue;
  switch (He) {
    case 0:
      for (let Je = 0, Ze = Qe.length; Je < Ze; Je += 2)
        Qe[Je] += Ge, Qe[Je + 1] = $e - Qe[Je + 1];
      break;
    case 90:
      for (let Je = 0, Ze = Qe.length; Je < Ze; Je += 2) {
        const nt = Qe[Je];
        Qe[Je] = Qe[Je + 1] + Ge, Qe[Je + 1] = nt + Xe;
      }
      break;
    case 180:
      for (let Je = 0, Ze = Qe.length; Je < Ze; Je += 2)
        Qe[Je] = Ke - Qe[Je], Qe[Je + 1] += Xe;
      break;
    case 270:
      for (let Je = 0, Ze = Qe.length; Je < Ze; Je += 2) {
        const nt = Qe[Je];
        Qe[Je] = Ke - Qe[Je + 1], Qe[Je + 1] = $e - nt;
      }
      break;
    default:
      throw new Error("Invalid rotation");
  }
  return Qe;
}, im = function(Qe, Ue, He) {
  const [Ge, Xe, Ke, $e] = Ue;
  switch (He) {
    case 0:
      for (let Je = 0, Ze = Qe.length; Je < Ze; Je += 2)
        Qe[Je] -= Ge, Qe[Je + 1] = $e - Qe[Je + 1];
      break;
    case 90:
      for (let Je = 0, Ze = Qe.length; Je < Ze; Je += 2) {
        const nt = Qe[Je];
        Qe[Je] = Qe[Je + 1] - Xe, Qe[Je + 1] = nt - Ge;
      }
      break;
    case 180:
      for (let Je = 0, Ze = Qe.length; Je < Ze; Je += 2)
        Qe[Je] = Ke - Qe[Je], Qe[Je + 1] -= Xe;
      break;
    case 270:
      for (let Je = 0, Ze = Qe.length; Je < Ze; Je += 2) {
        const nt = Qe[Je];
        Qe[Je] = $e - Qe[Je + 1], Qe[Je + 1] = Ke - nt;
      }
      break;
    default:
      throw new Error("Invalid rotation");
  }
  return Qe;
}, am = function(Qe, Ue, He, Ge) {
  var Ze, nt;
  const Xe = [], Ke = this.thickness / 2, $e = Qe * Ue + Ke, Je = Qe * He + Ke;
  for (const tt of this.paths) {
    const et = [], rt = [];
    for (let it = 0, ot = tt.length; it < ot; it++) {
      const [at, st, ut, lt] = tt[it];
      if (at[0] === lt[0] && at[1] === lt[1] && ot === 1) {
        const Ct = Qe * at[0] + $e, ht = Qe * at[1] + Je;
        et.push(Ct, ht), rt.push(Ct, ht);
        break;
      }
      const dt = Qe * at[0] + $e, At = Qe * at[1] + Je, pt = Qe * st[0] + $e, gt = Qe * st[1] + Je, wt = Qe * ut[0] + $e, Bt = Qe * ut[1] + Je, Tt = Qe * lt[0] + $e, yt = Qe * lt[1] + Je;
      it === 0 && (et.push(dt, At), rt.push(dt, At)), et.push(pt, gt, wt, Bt, Tt, yt), rt.push(pt, gt), it === ot - 1 && rt.push(Tt, yt);
    }
    Xe.push({
      bezier: en(Ze = Hr, Wo, d1).call(Ze, et, Ge, this.rotation),
      points: en(nt = Hr, Wo, d1).call(nt, rt, Ge, this.rotation)
    });
  }
  return Xe;
}, f1 = function() {
  let Qe = 1 / 0, Ue = -1 / 0, He = 1 / 0, Ge = -1 / 0;
  for (const Xe of this.paths)
    for (const [Ke, $e, Je, Ze] of Xe) {
      const nt = Util.bezierBoundingBox(...Ke, ...$e, ...Je, ...Ze);
      Qe = Math.min(Qe, nt[0]), He = Math.min(He, nt[1]), Ue = Math.max(Ue, nt[2]), Ge = Math.max(Ge, nt[3]);
    }
  return [Qe, He, Ue, Ge];
}, Q2 = function() {
  return xt(this, pa) ? Math.ceil(this.thickness * this.parentScale) : 0;
}, Hl = function(Qe = !1) {
  if (this.isEmpty())
    return;
  if (!xt(this, pa)) {
    en(this, kn, qs).call(this);
    return;
  }
  const Ue = en(this, kn, f1).call(this), He = en(this, kn, Q2).call(this);
  Zt(this, _c, Math.max(AnnotationEditor.MIN_SIZE, Ue[2] - Ue[0])), Zt(this, kc, Math.max(AnnotationEditor.MIN_SIZE, Ue[3] - Ue[1]));
  const Ge = Math.ceil(He + xt(this, _c) * this.scaleFactor), Xe = Math.ceil(He + xt(this, kc) * this.scaleFactor), [Ke, $e] = this.parentDimensions;
  this.width = Ge / Ke, this.height = Xe / $e, this.setAspectRatio(Ge, Xe);
  const Je = this.translationX, Ze = this.translationY;
  this.translationX = -Ue[0], this.translationY = -Ue[1], en(this, kn, gu).call(this), en(this, kn, qs).call(this), Zt(this, jc, Ge), Zt(this, Vc, Xe), this.setDims(Ge, Xe);
  const nt = Qe ? He / this.scaleFactor / 2 : 0;
  this.translate(Je - this.translationX - nt, Ze - this.translationY - nt);
}, tn(Hr, Wo), $n(Hr, "_defaultColor", null), $n(Hr, "_defaultOpacity", 1), $n(Hr, "_defaultThickness", 1), $n(Hr, "_type", "ink"), $n(Hr, "_editorType", AnnotationEditorType.INK);
let InkEditor = Hr;
var mi, Ei, Cs, Qo, vs, sl, Ya, Uc, $a, Oa, bd, gr, Gl, Wl, F2, h1, om, sm, p1, j2, cm;
const ql = class ql extends AnnotationEditor {
  constructor(Qe) {
    super({
      ...Qe,
      name: "stampEditor"
    });
    tn(this, gr);
    tn(this, mi, null);
    tn(this, Ei, null);
    tn(this, Cs, null);
    tn(this, Qo, null);
    tn(this, vs, null);
    tn(this, sl, "");
    tn(this, Ya, null);
    tn(this, Uc, null);
    tn(this, $a, null);
    tn(this, Oa, !1);
    tn(this, bd, !1);
    Zt(this, Qo, Qe.bitmapUrl), Zt(this, vs, Qe.bitmapFile);
  }
  static initialize(Qe, Ue) {
    AnnotationEditor.initialize(Qe, Ue);
  }
  static get supportedTypes() {
    return shadow(this, "supportedTypes", ["apng", "avif", "bmp", "gif", "jpeg", "png", "svg+xml", "webp", "x-icon"].map((Ue) => `image/${Ue}`));
  }
  static get supportedTypesStr() {
    return shadow(this, "supportedTypesStr", this.supportedTypes.join(","));
  }
  static isHandlingMimeForPasting(Qe) {
    return this.supportedTypes.includes(Qe);
  }
  static paste(Qe, Ue) {
    Ue.pasteEditor(AnnotationEditorType.STAMP, {
      bitmapFile: Qe.getAsFile()
    });
  }
  remove() {
    var Qe, Ue;
    xt(this, Ei) && (Zt(this, mi, null), this._uiManager.imageManager.deleteId(xt(this, Ei)), (Qe = xt(this, Ya)) == null || Qe.remove(), Zt(this, Ya, null), (Ue = xt(this, Uc)) == null || Ue.disconnect(), Zt(this, Uc, null), xt(this, $a) && (clearTimeout(xt(this, $a)), Zt(this, $a, null))), super.remove();
  }
  rebuild() {
    if (!this.parent) {
      xt(this, Ei) && en(this, gr, F2).call(this);
      return;
    }
    super.rebuild(), this.div !== null && (xt(this, Ei) && xt(this, Ya) === null && en(this, gr, F2).call(this), this.isAttachedToDOM || this.parent.add(this));
  }
  onceAdded() {
    this._isDraggable = !0, this.div.focus();
  }
  isEmpty() {
    return !(xt(this, Cs) || xt(this, mi) || xt(this, Qo) || xt(this, vs) || xt(this, Ei));
  }
  get isResizable() {
    return !0;
  }
  render() {
    if (this.div)
      return this.div;
    let Qe, Ue;
    if (this.width && (Qe = this.x, Ue = this.y), super.render(), this.div.hidden = !0, this.addAltTextButton(), xt(this, mi) ? en(this, gr, h1).call(this) : en(this, gr, F2).call(this), this.width) {
      const [He, Ge] = this.parentDimensions;
      this.setAt(Qe * He, Ue * Ge, this.width * He, this.height * Ge);
    }
    return this.div;
  }
  getImageForAltText() {
    return xt(this, Ya);
  }
  static deserialize(Qe, Ue, He) {
    if (Qe instanceof StampAnnotationElement)
      return null;
    const Ge = super.deserialize(Qe, Ue, He), {
      rect: Xe,
      bitmapUrl: Ke,
      bitmapId: $e,
      isSvg: Je,
      accessibilityData: Ze
    } = Qe;
    $e && He.imageManager.isValidId($e) ? Zt(Ge, Ei, $e) : Zt(Ge, Qo, Ke), Zt(Ge, Oa, Je);
    const [nt, tt] = Ge.pageDimensions;
    return Ge.width = (Xe[2] - Xe[0]) / nt, Ge.height = (Xe[3] - Xe[1]) / tt, Ze && (Ge.altTextData = Ze), Ge;
  }
  serialize(Qe = !1, Ue = null) {
    if (this.isEmpty())
      return null;
    const He = {
      annotationType: AnnotationEditorType.STAMP,
      bitmapId: xt(this, Ei),
      pageIndex: this.pageIndex,
      rect: this.getRect(0, 0),
      rotation: this.rotation,
      isSvg: xt(this, Oa),
      structTreeParentId: this._structTreeParentId
    };
    if (Qe)
      return He.bitmapUrl = en(this, gr, j2).call(this, !0), He.accessibilityData = this.altTextData, He;
    const {
      decorative: Ge,
      altText: Xe
    } = this.altTextData;
    if (!Ge && Xe && (He.accessibilityData = {
      type: "Figure",
      alt: Xe
    }), Ue === null)
      return He;
    Ue.stamps || (Ue.stamps = /* @__PURE__ */ new Map());
    const Ke = xt(this, Oa) ? (He.rect[2] - He.rect[0]) * (He.rect[3] - He.rect[1]) : null;
    if (!Ue.stamps.has(xt(this, Ei)))
      Ue.stamps.set(xt(this, Ei), {
        area: Ke,
        serialized: He
      }), He.bitmap = en(this, gr, j2).call(this, !1);
    else if (xt(this, Oa)) {
      const $e = Ue.stamps.get(xt(this, Ei));
      Ke > $e.area && ($e.area = Ke, $e.serialized.bitmap.close(), $e.serialized.bitmap = en(this, gr, j2).call(this, !1));
    }
    return He;
  }
};
mi = new WeakMap(), Ei = new WeakMap(), Cs = new WeakMap(), Qo = new WeakMap(), vs = new WeakMap(), sl = new WeakMap(), Ya = new WeakMap(), Uc = new WeakMap(), $a = new WeakMap(), Oa = new WeakMap(), bd = new WeakMap(), gr = new WeakSet(), Gl = function(Qe, Ue = !1) {
  if (!Qe) {
    this.remove();
    return;
  }
  Zt(this, mi, Qe.bitmap), Ue || (Zt(this, Ei, Qe.id), Zt(this, Oa, Qe.isSvg)), Qe.file && Zt(this, sl, Qe.file.name), en(this, gr, h1).call(this);
}, Wl = function() {
  Zt(this, Cs, null), this._uiManager.enableWaiting(!1), xt(this, Ya) && this.div.focus();
}, F2 = function() {
  if (xt(this, Ei)) {
    this._uiManager.enableWaiting(!0), this._uiManager.imageManager.getFromId(xt(this, Ei)).then((Ue) => en(this, gr, Gl).call(this, Ue, !0)).finally(() => en(this, gr, Wl).call(this));
    return;
  }
  if (xt(this, Qo)) {
    const Ue = xt(this, Qo);
    Zt(this, Qo, null), this._uiManager.enableWaiting(!0), Zt(this, Cs, this._uiManager.imageManager.getFromUrl(Ue).then((He) => en(this, gr, Gl).call(this, He)).finally(() => en(this, gr, Wl).call(this)));
    return;
  }
  if (xt(this, vs)) {
    const Ue = xt(this, vs);
    Zt(this, vs, null), this._uiManager.enableWaiting(!0), Zt(this, Cs, this._uiManager.imageManager.getFromFile(Ue).then((He) => en(this, gr, Gl).call(this, He)).finally(() => en(this, gr, Wl).call(this)));
    return;
  }
  const Qe = document.createElement("input");
  Qe.type = "file", Qe.accept = ql.supportedTypesStr, Zt(this, Cs, new Promise((Ue) => {
    Qe.addEventListener("change", async () => {
      if (!Qe.files || Qe.files.length === 0)
        this.remove();
      else {
        this._uiManager.enableWaiting(!0);
        const He = await this._uiManager.imageManager.getFromFile(Qe.files[0]);
        en(this, gr, Gl).call(this, He);
      }
      Ue();
    }), Qe.addEventListener("cancel", () => {
      this.remove(), Ue();
    });
  }).finally(() => en(this, gr, Wl).call(this))), Qe.click();
}, h1 = function() {
  const {
    div: Qe
  } = this;
  let {
    width: Ue,
    height: He
  } = xt(this, mi);
  const [Ge, Xe] = this.pageDimensions, Ke = 0.75;
  if (this.width)
    Ue = this.width * Ge, He = this.height * Xe;
  else if (Ue > Ke * Ge || He > Ke * Xe) {
    const nt = Math.min(Ke * Ge / Ue, Ke * Xe / He);
    Ue *= nt, He *= nt;
  }
  const [$e, Je] = this.parentDimensions;
  this.setDims(Ue * $e / Ge, He * Je / Xe), this._uiManager.enableWaiting(!1);
  const Ze = Zt(this, Ya, document.createElement("canvas"));
  Qe.append(Ze), Qe.hidden = !1, en(this, gr, p1).call(this, Ue, He), en(this, gr, cm).call(this), xt(this, bd) || (this.parent.addUndoableEditor(this), Zt(this, bd, !0)), this._reportTelemetry({
    action: "inserted_image"
  }), xt(this, sl) && Ze.setAttribute("aria-label", xt(this, sl));
}, om = function(Qe, Ue) {
  var Ke;
  const [He, Ge] = this.parentDimensions;
  this.width = Qe / He, this.height = Ue / Ge, this.setDims(Qe, Ue), (Ke = this._initialOptions) != null && Ke.isCentered ? this.center() : this.fixAndSetPosition(), this._initialOptions = null, xt(this, $a) !== null && clearTimeout(xt(this, $a)), Zt(this, $a, setTimeout(() => {
    Zt(this, $a, null), en(this, gr, p1).call(this, Qe, Ue);
  }, 200));
}, sm = function(Qe, Ue) {
  const {
    width: He,
    height: Ge
  } = xt(this, mi);
  let Xe = He, Ke = Ge, $e = xt(this, mi);
  for (; Xe > 2 * Qe || Ke > 2 * Ue; ) {
    const Je = Xe, Ze = Ke;
    Xe > 2 * Qe && (Xe = Xe >= 16384 ? Math.floor(Xe / 2) - 1 : Math.ceil(Xe / 2)), Ke > 2 * Ue && (Ke = Ke >= 16384 ? Math.floor(Ke / 2) - 1 : Math.ceil(Ke / 2));
    const nt = new OffscreenCanvas(Xe, Ke);
    nt.getContext("2d").drawImage($e, 0, 0, Je, Ze, 0, 0, Xe, Ke), $e = nt.transferToImageBitmap();
  }
  return $e;
}, p1 = function(Qe, Ue) {
  Qe = Math.ceil(Qe), Ue = Math.ceil(Ue);
  const He = xt(this, Ya);
  if (!He || He.width === Qe && He.height === Ue)
    return;
  He.width = Qe, He.height = Ue;
  const Ge = xt(this, Oa) ? xt(this, mi) : en(this, gr, sm).call(this, Qe, Ue);
  if (this._uiManager.hasMLManager && !this.hasAltText()) {
    const $e = new OffscreenCanvas(Qe, Ue).getContext("2d");
    $e.drawImage(Ge, 0, 0, Ge.width, Ge.height, 0, 0, Qe, Ue), this._uiManager.mlGuess({
      service: "image-to-text",
      request: {
        data: $e.getImageData(0, 0, Qe, Ue).data,
        width: Qe,
        height: Ue,
        channels: 4
      }
    }).then((Je) => {
      const Ze = (Je == null ? void 0 : Je.output) || "";
      this.parent && Ze && !this.hasAltText() && (this.altTextData = {
        altText: Ze,
        decorative: !1
      });
    });
  }
  const Xe = He.getContext("2d");
  Xe.filter = this._uiManager.hcmFilter, Xe.drawImage(Ge, 0, 0, Ge.width, Ge.height, 0, 0, Qe, Ue);
}, j2 = function(Qe) {
  if (Qe) {
    if (xt(this, Oa)) {
      const Ge = this._uiManager.imageManager.getSvgUrl(xt(this, Ei));
      if (Ge)
        return Ge;
    }
    const Ue = document.createElement("canvas");
    return {
      width: Ue.width,
      height: Ue.height
    } = xt(this, mi), Ue.getContext("2d").drawImage(xt(this, mi), 0, 0), Ue.toDataURL();
  }
  if (xt(this, Oa)) {
    const [Ue, He] = this.pageDimensions, Ge = Math.round(this.width * Ue * PixelsPerInch.PDF_TO_CSS_UNITS), Xe = Math.round(this.height * He * PixelsPerInch.PDF_TO_CSS_UNITS), Ke = new OffscreenCanvas(Ge, Xe);
    return Ke.getContext("2d").drawImage(xt(this, mi), 0, 0, xt(this, mi).width, xt(this, mi).height, 0, 0, Ge, Xe), Ke.transferToImageBitmap();
  }
  return structuredClone(xt(this, mi));
}, cm = function() {
  Zt(this, Uc, new ResizeObserver((Qe) => {
    const Ue = Qe[0].contentRect;
    Ue.width && Ue.height && en(this, gr, om).call(this, Ue.width, Ue.height);
  })), xt(this, Uc).observe(this.div);
}, $n(ql, "_type", "stamp"), $n(ql, "_editorType", AnnotationEditorType.STAMP);
let StampEditor = ql;
var Hc, cl, Ja, Gc, Fo, jo, Vo, ta, ys, ul, ll, Di, Xn, Is, Ci, um, A1, g1, m1, V2;
const Ca = class Ca {
  constructor({
    uiManager: ue,
    pageIndex: Qe,
    div: Ue,
    accessibilityManager: He,
    annotationLayer: Ge,
    drawLayer: Xe,
    textLayer: Ke,
    viewport: $e,
    l10n: Je
  }) {
    tn(this, Ci);
    tn(this, Hc);
    tn(this, cl, !1);
    tn(this, Ja, null);
    tn(this, Gc, null);
    tn(this, Fo, null);
    tn(this, jo, null);
    tn(this, Vo, null);
    tn(this, ta, /* @__PURE__ */ new Map());
    tn(this, ys, !1);
    tn(this, ul, !1);
    tn(this, ll, !1);
    tn(this, Di, null);
    tn(this, Xn);
    const Ze = [...xt(Ca, Is).values()];
    if (!Ca._initialized) {
      Ca._initialized = !0;
      for (const nt of Ze)
        nt.initialize(Je, ue);
    }
    ue.registerEditorTypes(Ze), Zt(this, Xn, ue), this.pageIndex = Qe, this.div = Ue, Zt(this, Hc, He), Zt(this, Ja, Ge), this.viewport = $e, Zt(this, Di, Ke), this.drawLayer = Xe, xt(this, Xn).addLayer(this);
  }
  get isEmpty() {
    return xt(this, ta).size === 0;
  }
  get isInvisible() {
    return this.isEmpty && xt(this, Xn).getMode() === AnnotationEditorType.NONE;
  }
  updateToolbar(ue) {
    xt(this, Xn).updateToolbar(ue);
  }
  updateMode(ue = xt(this, Xn).getMode()) {
    switch (en(this, Ci, V2).call(this), ue) {
      case AnnotationEditorType.NONE:
        this.disableTextSelection(), this.togglePointerEvents(!1), this.toggleAnnotationLayerPointerEvents(!0), this.disableClick();
        return;
      case AnnotationEditorType.INK:
        this.addInkEditorIfNeeded(!1), this.disableTextSelection(), this.togglePointerEvents(!0), this.disableClick();
        break;
      case AnnotationEditorType.HIGHLIGHT:
        this.enableTextSelection(), this.togglePointerEvents(!1), this.disableClick();
        break;
      default:
        this.disableTextSelection(), this.togglePointerEvents(!0), this.enableClick();
    }
    this.toggleAnnotationLayerPointerEvents(!1);
    const {
      classList: Qe
    } = this.div;
    for (const Ue of xt(Ca, Is).values())
      Qe.toggle(`${Ue._type}Editing`, ue === Ue._editorType);
    this.div.hidden = !1;
  }
  hasTextLayer(ue) {
    var Qe;
    return ue === ((Qe = xt(this, Di)) == null ? void 0 : Qe.div);
  }
  addInkEditorIfNeeded(ue) {
    if (xt(this, Xn).getMode() !== AnnotationEditorType.INK)
      return;
    if (!ue) {
      for (const Ue of xt(this, ta).values())
        if (Ue.isEmpty()) {
          Ue.setInBackground();
          return;
        }
    }
    this.createAndAddNewEditor({
      offsetX: 0,
      offsetY: 0
    }, !1).setInBackground();
  }
  setEditingState(ue) {
    xt(this, Xn).setEditingState(ue);
  }
  addCommands(ue) {
    xt(this, Xn).addCommands(ue);
  }
  togglePointerEvents(ue = !1) {
    this.div.classList.toggle("disabled", !ue);
  }
  toggleAnnotationLayerPointerEvents(ue = !1) {
    var Qe;
    (Qe = xt(this, Ja)) == null || Qe.div.classList.toggle("disabled", !ue);
  }
  enable() {
    this.div.tabIndex = 0, this.togglePointerEvents(!0);
    const ue = /* @__PURE__ */ new Set();
    for (const Ue of xt(this, ta).values())
      Ue.enableEditing(), Ue.show(!0), Ue.annotationElementId && (xt(this, Xn).removeChangedExistingAnnotation(Ue), ue.add(Ue.annotationElementId));
    if (!xt(this, Ja))
      return;
    const Qe = xt(this, Ja).getEditableAnnotations();
    for (const Ue of Qe) {
      if (Ue.hide(), xt(this, Xn).isDeletedAnnotationElement(Ue.data.id) || ue.has(Ue.data.id))
        continue;
      const He = this.deserialize(Ue);
      He && (this.addOrRebuild(He), He.enableEditing());
    }
  }
  disable() {
    var He;
    Zt(this, ll, !0), this.div.tabIndex = -1, this.togglePointerEvents(!1);
    const ue = /* @__PURE__ */ new Map(), Qe = /* @__PURE__ */ new Map();
    for (const Ge of xt(this, ta).values())
      if (Ge.disableEditing(), !!Ge.annotationElementId) {
        if (Ge.serialize() !== null) {
          ue.set(Ge.annotationElementId, Ge);
          continue;
        } else
          Qe.set(Ge.annotationElementId, Ge);
        (He = this.getEditableAnnotation(Ge.annotationElementId)) == null || He.show(), Ge.remove();
      }
    if (xt(this, Ja)) {
      const Ge = xt(this, Ja).getEditableAnnotations();
      for (const Xe of Ge) {
        const {
          id: Ke
        } = Xe.data;
        if (xt(this, Xn).isDeletedAnnotationElement(Ke))
          continue;
        let $e = Qe.get(Ke);
        if ($e) {
          $e.resetAnnotationElement(Xe), $e.show(!1), Xe.show();
          continue;
        }
        $e = ue.get(Ke), $e && (xt(this, Xn).addChangedExistingAnnotation($e), $e.renderAnnotationElement(Xe), $e.show(!1)), Xe.show();
      }
    }
    en(this, Ci, V2).call(this), this.isEmpty && (this.div.hidden = !0);
    const {
      classList: Ue
    } = this.div;
    for (const Ge of xt(Ca, Is).values())
      Ue.remove(`${Ge._type}Editing`);
    this.disableTextSelection(), this.toggleAnnotationLayerPointerEvents(!0), Zt(this, ll, !1);
  }
  getEditableAnnotation(ue) {
    var Qe;
    return ((Qe = xt(this, Ja)) == null ? void 0 : Qe.getEditableAnnotation(ue)) || null;
  }
  setActiveEditor(ue) {
    xt(this, Xn).getActive() !== ue && xt(this, Xn).setActiveEditor(ue);
  }
  enableTextSelection() {
    var ue;
    this.div.tabIndex = -1, (ue = xt(this, Di)) != null && ue.div && !xt(this, jo) && (Zt(this, jo, en(this, Ci, um).bind(this)), xt(this, Di).div.addEventListener("pointerdown", xt(this, jo)), xt(this, Di).div.classList.add("highlighting"));
  }
  disableTextSelection() {
    var ue;
    this.div.tabIndex = 0, (ue = xt(this, Di)) != null && ue.div && xt(this, jo) && (xt(this, Di).div.removeEventListener("pointerdown", xt(this, jo)), Zt(this, jo, null), xt(this, Di).div.classList.remove("highlighting"));
  }
  enableClick() {
    xt(this, Fo) || (Zt(this, Fo, this.pointerdown.bind(this)), Zt(this, Gc, this.pointerup.bind(this)), this.div.addEventListener("pointerdown", xt(this, Fo)), this.div.addEventListener("pointerup", xt(this, Gc)));
  }
  disableClick() {
    xt(this, Fo) && (this.div.removeEventListener("pointerdown", xt(this, Fo)), this.div.removeEventListener("pointerup", xt(this, Gc)), Zt(this, Fo, null), Zt(this, Gc, null));
  }
  attach(ue) {
    xt(this, ta).set(ue.id, ue);
    const {
      annotationElementId: Qe
    } = ue;
    Qe && xt(this, Xn).isDeletedAnnotationElement(Qe) && xt(this, Xn).removeDeletedAnnotationElement(ue);
  }
  detach(ue) {
    var Qe;
    xt(this, ta).delete(ue.id), (Qe = xt(this, Hc)) == null || Qe.removePointerInTextLayer(ue.contentDiv), !xt(this, ll) && ue.annotationElementId && xt(this, Xn).addDeletedAnnotationElement(ue);
  }
  remove(ue) {
    this.detach(ue), xt(this, Xn).removeEditor(ue), ue.div.remove(), ue.isAttachedToDOM = !1, xt(this, ul) || this.addInkEditorIfNeeded(!1);
  }
  changeParent(ue) {
    var Qe;
    ue.parent !== this && (ue.parent && ue.annotationElementId && (xt(this, Xn).addDeletedAnnotationElement(ue.annotationElementId), AnnotationEditor.deleteAnnotationElement(ue), ue.annotationElementId = null), this.attach(ue), (Qe = ue.parent) == null || Qe.detach(ue), ue.setParent(this), ue.div && ue.isAttachedToDOM && (ue.div.remove(), this.div.append(ue.div)));
  }
  add(ue) {
    if (!(ue.parent === this && ue.isAttachedToDOM)) {
      if (this.changeParent(ue), xt(this, Xn).addEditor(ue), this.attach(ue), !ue.isAttachedToDOM) {
        const Qe = ue.render();
        this.div.append(Qe), ue.isAttachedToDOM = !0;
      }
      ue.fixAndSetPosition(), ue.onceAdded(), xt(this, Xn).addToAnnotationStorage(ue), ue._reportTelemetry(ue.telemetryInitialData);
    }
  }
  moveEditorInDOM(ue) {
    var Ue;
    if (!ue.isAttachedToDOM)
      return;
    const {
      activeElement: Qe
    } = document;
    ue.div.contains(Qe) && !xt(this, Vo) && (ue._focusEventsAllowed = !1, Zt(this, Vo, setTimeout(() => {
      Zt(this, Vo, null), ue.div.contains(document.activeElement) ? ue._focusEventsAllowed = !0 : (ue.div.addEventListener("focusin", () => {
        ue._focusEventsAllowed = !0;
      }, {
        once: !0
      }), Qe.focus());
    }, 0))), ue._structTreeParentId = (Ue = xt(this, Hc)) == null ? void 0 : Ue.moveElementInDOM(this.div, ue.div, ue.contentDiv, !0);
  }
  addOrRebuild(ue) {
    ue.needsToBeRebuilt() ? (ue.parent || (ue.parent = this), ue.rebuild(), ue.show()) : this.add(ue);
  }
  addUndoableEditor(ue) {
    const Qe = () => ue._uiManager.rebuild(ue), Ue = () => {
      ue.remove();
    };
    this.addCommands({
      cmd: Qe,
      undo: Ue,
      mustExec: !1
    });
  }
  getNextId() {
    return xt(this, Xn).getId();
  }
  canCreateNewEmptyEditor() {
    var ue;
    return (ue = xt(this, Ci, A1)) == null ? void 0 : ue.canCreateNewEmptyEditor();
  }
  pasteEditor(ue, Qe) {
    xt(this, Xn).updateToolbar(ue), xt(this, Xn).updateMode(ue);
    const {
      offsetX: Ue,
      offsetY: He
    } = en(this, Ci, m1).call(this), Ge = this.getNextId(), Xe = en(this, Ci, g1).call(this, {
      parent: this,
      id: Ge,
      x: Ue,
      y: He,
      uiManager: xt(this, Xn),
      isCentered: !0,
      ...Qe
    });
    Xe && this.add(Xe);
  }
  deserialize(ue) {
    var Qe;
    return ((Qe = xt(Ca, Is).get(ue.annotationType ?? ue.annotationEditorType)) == null ? void 0 : Qe.deserialize(ue, this, xt(this, Xn))) || null;
  }
  createAndAddNewEditor(ue, Qe, Ue = {}) {
    const He = this.getNextId(), Ge = en(this, Ci, g1).call(this, {
      parent: this,
      id: He,
      x: ue.offsetX,
      y: ue.offsetY,
      uiManager: xt(this, Xn),
      isCentered: Qe,
      ...Ue
    });
    return Ge && this.add(Ge), Ge;
  }
  addNewEditor() {
    this.createAndAddNewEditor(en(this, Ci, m1).call(this), !0);
  }
  setSelected(ue) {
    xt(this, Xn).setSelected(ue);
  }
  toggleSelected(ue) {
    xt(this, Xn).toggleSelected(ue);
  }
  isSelected(ue) {
    return xt(this, Xn).isSelected(ue);
  }
  unselect(ue) {
    xt(this, Xn).unselect(ue);
  }
  pointerup(ue) {
    const {
      isMac: Qe
    } = util_FeatureTest.platform;
    if (!(ue.button !== 0 || ue.ctrlKey && Qe) && ue.target === this.div && xt(this, ys)) {
      if (Zt(this, ys, !1), !xt(this, cl)) {
        Zt(this, cl, !0);
        return;
      }
      if (xt(this, Xn).getMode() === AnnotationEditorType.STAMP) {
        xt(this, Xn).unselectAll();
        return;
      }
      this.createAndAddNewEditor(ue, !1);
    }
  }
  pointerdown(ue) {
    if (xt(this, Xn).getMode() === AnnotationEditorType.HIGHLIGHT && this.enableTextSelection(), xt(this, ys)) {
      Zt(this, ys, !1);
      return;
    }
    const {
      isMac: Qe
    } = util_FeatureTest.platform;
    if (ue.button !== 0 || ue.ctrlKey && Qe || ue.target !== this.div)
      return;
    Zt(this, ys, !0);
    const Ue = xt(this, Xn).getActive();
    Zt(this, cl, !Ue || Ue.isEmpty());
  }
  findNewParent(ue, Qe, Ue) {
    const He = xt(this, Xn).findParent(Qe, Ue);
    return He === null || He === this ? !1 : (He.changeParent(ue), !0);
  }
  destroy() {
    var ue, Qe;
    ((ue = xt(this, Xn).getActive()) == null ? void 0 : ue.parent) === this && (xt(this, Xn).commitOrRemove(), xt(this, Xn).setActiveEditor(null)), xt(this, Vo) && (clearTimeout(xt(this, Vo)), Zt(this, Vo, null));
    for (const Ue of xt(this, ta).values())
      (Qe = xt(this, Hc)) == null || Qe.removePointerInTextLayer(Ue.contentDiv), Ue.setParent(null), Ue.isAttachedToDOM = !1, Ue.div.remove();
    this.div = null, xt(this, ta).clear(), xt(this, Xn).removeLayer(this);
  }
  render({
    viewport: ue
  }) {
    this.viewport = ue, setLayerDimensions(this.div, ue);
    for (const Qe of xt(this, Xn).getEditors(this.pageIndex))
      this.add(Qe), Qe.rebuild();
    this.updateMode();
  }
  update({
    viewport: ue
  }) {
    xt(this, Xn).commitOrRemove(), en(this, Ci, V2).call(this);
    const Qe = this.viewport.rotation, Ue = ue.rotation;
    if (this.viewport = ue, setLayerDimensions(this.div, {
      rotation: Ue
    }), Qe !== Ue)
      for (const He of xt(this, ta).values())
        He.rotate(Ue);
    this.addInkEditorIfNeeded(!1);
  }
  get pageDimensions() {
    const {
      pageWidth: ue,
      pageHeight: Qe
    } = this.viewport.rawDims;
    return [ue, Qe];
  }
  get scale() {
    return xt(this, Xn).viewParameters.realScale;
  }
};
Hc = new WeakMap(), cl = new WeakMap(), Ja = new WeakMap(), Gc = new WeakMap(), Fo = new WeakMap(), jo = new WeakMap(), Vo = new WeakMap(), ta = new WeakMap(), ys = new WeakMap(), ul = new WeakMap(), ll = new WeakMap(), Di = new WeakMap(), Xn = new WeakMap(), Is = new WeakMap(), Ci = new WeakSet(), um = function(ue) {
  if (xt(this, Xn).unselectAll(), ue.target === xt(this, Di).div) {
    const {
      isMac: Qe
    } = util_FeatureTest.platform;
    if (ue.button !== 0 || ue.ctrlKey && Qe)
      return;
    xt(this, Xn).showAllEditors("highlight", !0, !0), xt(this, Di).div.classList.add("free"), HighlightEditor.startHighlighting(this, xt(this, Xn).direction === "ltr", ue), xt(this, Di).div.addEventListener("pointerup", () => {
      xt(this, Di).div.classList.remove("free");
    }, {
      once: !0
    }), ue.preventDefault();
  }
}, A1 = function() {
  return xt(Ca, Is).get(xt(this, Xn).getMode());
}, g1 = function(ue) {
  const Qe = xt(this, Ci, A1);
  return Qe ? new Qe.prototype.constructor(ue) : null;
}, m1 = function() {
  const {
    x: ue,
    y: Qe,
    width: Ue,
    height: He
  } = this.div.getBoundingClientRect(), Ge = Math.max(0, ue), Xe = Math.max(0, Qe), Ke = Math.min(window.innerWidth, ue + Ue), $e = Math.min(window.innerHeight, Qe + He), Je = (Ge + Ke) / 2 - ue, Ze = (Xe + $e) / 2 - Qe, [nt, tt] = this.viewport.rotation % 180 === 0 ? [Je, Ze] : [Ze, Je];
  return {
    offsetX: nt,
    offsetY: tt
  };
}, V2 = function() {
  Zt(this, ul, !0);
  for (const ue of xt(this, ta).values())
    ue.isEmpty() && ue.remove();
  Zt(this, ul, !1);
}, $n(Ca, "_initialized", !1), tn(Ca, Is, new Map([FreeTextEditor, InkEditor, StampEditor, HighlightEditor].map((ue) => [ue._editorType, ue])));
let AnnotationEditorLayer = Ca;
var Za, Sd, ii, xs, wd, E1, qc, C1, lm;
const fi = class fi {
  constructor({
    pageIndex: ue
  }) {
    tn(this, qc);
    tn(this, Za, null);
    tn(this, Sd, 0);
    tn(this, ii, /* @__PURE__ */ new Map());
    tn(this, xs, /* @__PURE__ */ new Map());
    this.pageIndex = ue;
  }
  setParent(ue) {
    if (!xt(this, Za)) {
      Zt(this, Za, ue);
      return;
    }
    if (xt(this, Za) !== ue) {
      if (xt(this, ii).size > 0)
        for (const Qe of xt(this, ii).values())
          Qe.remove(), ue.append(Qe);
      Zt(this, Za, ue);
    }
  }
  static get _svgFactory() {
    return shadow(this, "_svgFactory", new DOMSVGFactory());
  }
  highlight(ue, Qe, Ue, He = !1) {
    const Ge = Xi(this, Sd)._++, Xe = en(this, qc, C1).call(this, ue.box);
    Xe.classList.add("highlight"), ue.free && Xe.classList.add("free");
    const Ke = fi._svgFactory.createElement("defs");
    Xe.append(Ke);
    const $e = fi._svgFactory.createElement("path");
    Ke.append($e);
    const Je = `path_p${this.pageIndex}_${Ge}`;
    $e.setAttribute("id", Je), $e.setAttribute("d", ue.toSVGPath()), He && xt(this, xs).set(Ge, $e);
    const Ze = en(this, qc, lm).call(this, Ke, Je), nt = fi._svgFactory.createElement("use");
    return Xe.append(nt), Xe.setAttribute("fill", Qe), Xe.setAttribute("fill-opacity", Ue), nt.setAttribute("href", `#${Je}`), xt(this, ii).set(Ge, Xe), {
      id: Ge,
      clipPathId: `url(#${Ze})`
    };
  }
  highlightOutline(ue) {
    const Qe = Xi(this, Sd)._++, Ue = en(this, qc, C1).call(this, ue.box);
    Ue.classList.add("highlightOutline");
    const He = fi._svgFactory.createElement("defs");
    Ue.append(He);
    const Ge = fi._svgFactory.createElement("path");
    He.append(Ge);
    const Xe = `path_p${this.pageIndex}_${Qe}`;
    Ge.setAttribute("id", Xe), Ge.setAttribute("d", ue.toSVGPath()), Ge.setAttribute("vector-effect", "non-scaling-stroke");
    let Ke;
    if (ue.free) {
      Ue.classList.add("free");
      const Ze = fi._svgFactory.createElement("mask");
      He.append(Ze), Ke = `mask_p${this.pageIndex}_${Qe}`, Ze.setAttribute("id", Ke), Ze.setAttribute("maskUnits", "objectBoundingBox");
      const nt = fi._svgFactory.createElement("rect");
      Ze.append(nt), nt.setAttribute("width", "1"), nt.setAttribute("height", "1"), nt.setAttribute("fill", "white");
      const tt = fi._svgFactory.createElement("use");
      Ze.append(tt), tt.setAttribute("href", `#${Xe}`), tt.setAttribute("stroke", "none"), tt.setAttribute("fill", "black"), tt.setAttribute("fill-rule", "nonzero"), tt.classList.add("mask");
    }
    const $e = fi._svgFactory.createElement("use");
    Ue.append($e), $e.setAttribute("href", `#${Xe}`), Ke && $e.setAttribute("mask", `url(#${Ke})`);
    const Je = $e.cloneNode();
    return Ue.append(Je), $e.classList.add("mainOutline"), Je.classList.add("secondaryOutline"), xt(this, ii).set(Qe, Ue), Qe;
  }
  finalizeLine(ue, Qe) {
    const Ue = xt(this, xs).get(ue);
    xt(this, xs).delete(ue), this.updateBox(ue, Qe.box), Ue.setAttribute("d", Qe.toSVGPath());
  }
  updateLine(ue, Qe) {
    xt(this, ii).get(ue).firstChild.firstChild.setAttribute("d", Qe.toSVGPath());
  }
  removeFreeHighlight(ue) {
    this.remove(ue), xt(this, xs).delete(ue);
  }
  updatePath(ue, Qe) {
    xt(this, xs).get(ue).setAttribute("d", Qe.toSVGPath());
  }
  updateBox(ue, Qe) {
    var Ue;
    en(Ue = fi, wd, E1).call(Ue, xt(this, ii).get(ue), Qe);
  }
  show(ue, Qe) {
    xt(this, ii).get(ue).classList.toggle("hidden", !Qe);
  }
  rotate(ue, Qe) {
    xt(this, ii).get(ue).setAttribute("data-main-rotation", Qe);
  }
  changeColor(ue, Qe) {
    xt(this, ii).get(ue).setAttribute("fill", Qe);
  }
  changeOpacity(ue, Qe) {
    xt(this, ii).get(ue).setAttribute("fill-opacity", Qe);
  }
  addClass(ue, Qe) {
    xt(this, ii).get(ue).classList.add(Qe);
  }
  removeClass(ue, Qe) {
    xt(this, ii).get(ue).classList.remove(Qe);
  }
  remove(ue) {
    xt(this, Za) !== null && (xt(this, ii).get(ue).remove(), xt(this, ii).delete(ue));
  }
  destroy() {
    Zt(this, Za, null);
    for (const ue of xt(this, ii).values())
      ue.remove();
    xt(this, ii).clear();
  }
};
Za = new WeakMap(), Sd = new WeakMap(), ii = new WeakMap(), xs = new WeakMap(), wd = new WeakSet(), E1 = function(ue, {
  x: Qe = 0,
  y: Ue = 0,
  width: He = 1,
  height: Ge = 1
} = {}) {
  const {
    style: Xe
  } = ue;
  Xe.top = `${100 * Ue}%`, Xe.left = `${100 * Qe}%`, Xe.width = `${100 * He}%`, Xe.height = `${100 * Ge}%`;
}, qc = new WeakSet(), C1 = function(ue) {
  var Ue;
  const Qe = fi._svgFactory.create(1, 1, !0);
  return xt(this, Za).append(Qe), Qe.setAttribute("aria-hidden", !0), en(Ue = fi, wd, E1).call(Ue, Qe, ue), Qe;
}, lm = function(ue, Qe) {
  const Ue = fi._svgFactory.createElement("clipPath");
  ue.append(Ue);
  const He = `clip_${Qe}`;
  Ue.setAttribute("id", He), Ue.setAttribute("clipPathUnits", "objectBoundingBox");
  const Ge = fi._svgFactory.createElement("use");
  return Ue.append(Ge), Ge.setAttribute("href", `#${Qe}`), Ge.classList.add("clip"), He;
}, tn(fi, wd);
let DrawLayer = fi;
var __webpack_exports__AbortException = __webpack_exports__.AbortException, __webpack_exports__AnnotationEditorLayer = __webpack_exports__.AnnotationEditorLayer, __webpack_exports__AnnotationEditorParamsType = __webpack_exports__.AnnotationEditorParamsType, __webpack_exports__AnnotationEditorType = __webpack_exports__.AnnotationEditorType, __webpack_exports__AnnotationEditorUIManager = __webpack_exports__.AnnotationEditorUIManager, __webpack_exports__AnnotationLayer = __webpack_exports__.AnnotationLayer, __webpack_exports__AnnotationMode = __webpack_exports__.AnnotationMode, __webpack_exports__CMapCompressionType = __webpack_exports__.CMapCompressionType, __webpack_exports__ColorPicker = __webpack_exports__.ColorPicker, __webpack_exports__DOMSVGFactory = __webpack_exports__.DOMSVGFactory, __webpack_exports__DrawLayer = __webpack_exports__.DrawLayer, __webpack_exports__FeatureTest = __webpack_exports__.FeatureTest, __webpack_exports__GlobalWorkerOptions = __webpack_exports__.GlobalWorkerOptions, __webpack_exports__ImageKind = __webpack_exports__.ImageKind, __webpack_exports__InvalidPDFException = __webpack_exports__.InvalidPDFException, __webpack_exports__MissingPDFException = __webpack_exports__.MissingPDFException, __webpack_exports__OPS = __webpack_exports__.OPS, __webpack_exports__Outliner = __webpack_exports__.Outliner, __webpack_exports__PDFDataRangeTransport = __webpack_exports__.PDFDataRangeTransport, __webpack_exports__PDFDateString = __webpack_exports__.PDFDateString, __webpack_exports__PDFWorker = __webpack_exports__.PDFWorker, __webpack_exports__PasswordResponses = __webpack_exports__.PasswordResponses, __webpack_exports__PermissionFlag = __webpack_exports__.PermissionFlag, __webpack_exports__PixelsPerInch = __webpack_exports__.PixelsPerInch, __webpack_exports__RenderingCancelledException = __webpack_exports__.RenderingCancelledException, __webpack_exports__TextLayer = __webpack_exports__.TextLayer, __webpack_exports__UnexpectedResponseException = __webpack_exports__.UnexpectedResponseException, __webpack_exports__Util = __webpack_exports__.Util, __webpack_exports__VerbosityLevel = __webpack_exports__.VerbosityLevel, __webpack_exports__XfaLayer = __webpack_exports__.XfaLayer, __webpack_exports__build = __webpack_exports__.build, __webpack_exports__createValidAbsoluteUrl = __webpack_exports__.createValidAbsoluteUrl, __webpack_exports__fetchData = __webpack_exports__.fetchData, __webpack_exports__getDocument = __webpack_exports__.getDocument, __webpack_exports__getFilenameFromUrl = __webpack_exports__.getFilenameFromUrl, __webpack_exports__getPdfFilenameFromUrl = __webpack_exports__.getPdfFilenameFromUrl, __webpack_exports__getXfaPageViewport = __webpack_exports__.getXfaPageViewport, __webpack_exports__isDataScheme = __webpack_exports__.isDataScheme, __webpack_exports__isPdfFile = __webpack_exports__.isPdfFile, __webpack_exports__noContextMenu = __webpack_exports__.noContextMenu, __webpack_exports__normalizeUnicode = __webpack_exports__.normalizeUnicode, __webpack_exports__renderTextLayer = __webpack_exports__.renderTextLayer, __webpack_exports__setLayerDimensions = __webpack_exports__.setLayerDimensions, __webpack_exports__shadow = __webpack_exports__.shadow, __webpack_exports__updateTextLayer = __webpack_exports__.updateTextLayer, __webpack_exports__version = __webpack_exports__.version;
const pdfjs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AbortException: __webpack_exports__AbortException,
  AnnotationEditorLayer: __webpack_exports__AnnotationEditorLayer,
  AnnotationEditorParamsType: __webpack_exports__AnnotationEditorParamsType,
  AnnotationEditorType: __webpack_exports__AnnotationEditorType,
  AnnotationEditorUIManager: __webpack_exports__AnnotationEditorUIManager,
  AnnotationLayer: __webpack_exports__AnnotationLayer,
  AnnotationMode: __webpack_exports__AnnotationMode,
  CMapCompressionType: __webpack_exports__CMapCompressionType,
  ColorPicker: __webpack_exports__ColorPicker,
  DOMSVGFactory: __webpack_exports__DOMSVGFactory,
  DrawLayer: __webpack_exports__DrawLayer,
  FeatureTest: __webpack_exports__FeatureTest,
  GlobalWorkerOptions: __webpack_exports__GlobalWorkerOptions,
  ImageKind: __webpack_exports__ImageKind,
  InvalidPDFException: __webpack_exports__InvalidPDFException,
  MissingPDFException: __webpack_exports__MissingPDFException,
  OPS: __webpack_exports__OPS,
  Outliner: __webpack_exports__Outliner,
  PDFDataRangeTransport: __webpack_exports__PDFDataRangeTransport,
  PDFDateString: __webpack_exports__PDFDateString,
  PDFWorker: __webpack_exports__PDFWorker,
  PasswordResponses: __webpack_exports__PasswordResponses,
  PermissionFlag: __webpack_exports__PermissionFlag,
  PixelsPerInch: __webpack_exports__PixelsPerInch,
  RenderingCancelledException: __webpack_exports__RenderingCancelledException,
  TextLayer: __webpack_exports__TextLayer,
  UnexpectedResponseException: __webpack_exports__UnexpectedResponseException,
  Util: __webpack_exports__Util,
  VerbosityLevel: __webpack_exports__VerbosityLevel,
  XfaLayer: __webpack_exports__XfaLayer,
  build: __webpack_exports__build,
  createValidAbsoluteUrl: __webpack_exports__createValidAbsoluteUrl,
  fetchData: __webpack_exports__fetchData,
  getDocument: __webpack_exports__getDocument,
  getFilenameFromUrl: __webpack_exports__getFilenameFromUrl,
  getPdfFilenameFromUrl: __webpack_exports__getPdfFilenameFromUrl,
  getXfaPageViewport: __webpack_exports__getXfaPageViewport,
  isDataScheme: __webpack_exports__isDataScheme,
  isPdfFile: __webpack_exports__isPdfFile,
  noContextMenu: __webpack_exports__noContextMenu,
  normalizeUnicode: __webpack_exports__normalizeUnicode,
  renderTextLayer: __webpack_exports__renderTextLayer,
  setLayerDimensions: __webpack_exports__setLayerDimensions,
  shadow: __webpack_exports__shadow,
  updateTextLayer: __webpack_exports__updateTextLayer,
  version: __webpack_exports__version
}, Symbol.toStringTag, { value: "Module" }));
var __spreadArray = function(me, ue, Qe) {
  if (Qe || arguments.length === 2) for (var Ue = 0, He = ue.length, Ge; Ue < He; Ue++)
    (Ge || !(Ue in ue)) && (Ge || (Ge = Array.prototype.slice.call(ue, 0, Ue)), Ge[Ue] = ue[Ue]);
  return me.concat(Ge || Array.prototype.slice.call(ue));
}, clipboardEvents = ["onCopy", "onCut", "onPaste"], compositionEvents = [
  "onCompositionEnd",
  "onCompositionStart",
  "onCompositionUpdate"
], focusEvents = ["onFocus", "onBlur"], formEvents = ["onInput", "onInvalid", "onReset", "onSubmit"], imageEvents = ["onLoad", "onError"], keyboardEvents = ["onKeyDown", "onKeyPress", "onKeyUp"], mediaEvents = [
  "onAbort",
  "onCanPlay",
  "onCanPlayThrough",
  "onDurationChange",
  "onEmptied",
  "onEncrypted",
  "onEnded",
  "onError",
  "onLoadedData",
  "onLoadedMetadata",
  "onLoadStart",
  "onPause",
  "onPlay",
  "onPlaying",
  "onProgress",
  "onRateChange",
  "onSeeked",
  "onSeeking",
  "onStalled",
  "onSuspend",
  "onTimeUpdate",
  "onVolumeChange",
  "onWaiting"
], mouseEvents = [
  "onClick",
  "onContextMenu",
  "onDoubleClick",
  "onMouseDown",
  "onMouseEnter",
  "onMouseLeave",
  "onMouseMove",
  "onMouseOut",
  "onMouseOver",
  "onMouseUp"
], dragEvents = [
  "onDrag",
  "onDragEnd",
  "onDragEnter",
  "onDragExit",
  "onDragLeave",
  "onDragOver",
  "onDragStart",
  "onDrop"
], selectionEvents = ["onSelect"], touchEvents = ["onTouchCancel", "onTouchEnd", "onTouchMove", "onTouchStart"], pointerEvents = [
  "onPointerDown",
  "onPointerMove",
  "onPointerUp",
  "onPointerCancel",
  "onGotPointerCapture",
  "onLostPointerCapture",
  "onPointerEnter",
  "onPointerLeave",
  "onPointerOver",
  "onPointerOut"
], uiEvents = ["onScroll"], wheelEvents = ["onWheel"], animationEvents = [
  "onAnimationStart",
  "onAnimationEnd",
  "onAnimationIteration"
], transitionEvents = ["onTransitionEnd"], otherEvents = ["onToggle"], changeEvents = ["onChange"], allEvents = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], clipboardEvents, !0), compositionEvents, !0), focusEvents, !0), formEvents, !0), imageEvents, !0), keyboardEvents, !0), mediaEvents, !0), mouseEvents, !0), dragEvents, !0), selectionEvents, !0), touchEvents, !0), pointerEvents, !0), uiEvents, !0), wheelEvents, !0), animationEvents, !0), transitionEvents, !0), changeEvents, !0), otherEvents, !0);
function makeEventProps(me, ue) {
  var Qe = {};
  return allEvents.forEach(function(Ue) {
    var He = me[Ue];
    He && (ue ? Qe[Ue] = function(Ge) {
      return He(Ge, ue(Ue));
    } : Qe[Ue] = He);
  }), Qe;
}
function makeCancellablePromise(me) {
  var ue = !1, Qe = new Promise(function(Ue, He) {
    me.then(function(Ge) {
      return !ue && Ue(Ge);
    }).catch(function(Ge) {
      return !ue && He(Ge);
    });
  });
  return {
    promise: Qe,
    cancel: function() {
      ue = !0;
    }
  };
}
function r(me) {
  var ue, Qe, Ue = "";
  if (typeof me == "string" || typeof me == "number") Ue += me;
  else if (typeof me == "object") if (Array.isArray(me)) {
    var He = me.length;
    for (ue = 0; ue < He; ue++) me[ue] && (Qe = r(me[ue])) && (Ue && (Ue += " "), Ue += Qe);
  } else for (Qe in me) me[Qe] && (Ue && (Ue += " "), Ue += Qe);
  return Ue;
}
function clsx() {
  for (var me, ue, Qe = 0, Ue = "", He = arguments.length; Qe < He; Qe++) (me = arguments[Qe]) && (ue = r(me)) && (Ue && (Ue += " "), Ue += ue);
  return Ue;
}
var isProduction = process.env.NODE_ENV === "production", prefix = "Invariant failed";
function invariant(me, ue) {
  if (!me) {
    if (isProduction)
      throw new Error(prefix);
    var Qe = typeof ue == "function" ? ue() : ue, Ue = Qe ? "".concat(prefix, ": ").concat(Qe) : prefix;
    throw new Error(Ue);
  }
}
var has = Object.prototype.hasOwnProperty;
function find(me, ue, Qe) {
  for (Qe of me.keys())
    if (dequal(Qe, ue)) return Qe;
}
function dequal(me, ue) {
  var Qe, Ue, He;
  if (me === ue) return !0;
  if (me && ue && (Qe = me.constructor) === ue.constructor) {
    if (Qe === Date) return me.getTime() === ue.getTime();
    if (Qe === RegExp) return me.toString() === ue.toString();
    if (Qe === Array) {
      if ((Ue = me.length) === ue.length)
        for (; Ue-- && dequal(me[Ue], ue[Ue]); ) ;
      return Ue === -1;
    }
    if (Qe === Set) {
      if (me.size !== ue.size)
        return !1;
      for (Ue of me)
        if (He = Ue, He && typeof He == "object" && (He = find(ue, He), !He) || !ue.has(He)) return !1;
      return !0;
    }
    if (Qe === Map) {
      if (me.size !== ue.size)
        return !1;
      for (Ue of me)
        if (He = Ue[0], He && typeof He == "object" && (He = find(ue, He), !He) || !dequal(Ue[1], ue.get(He)))
          return !1;
      return !0;
    }
    if (Qe === ArrayBuffer)
      me = new Uint8Array(me), ue = new Uint8Array(ue);
    else if (Qe === DataView) {
      if ((Ue = me.byteLength) === ue.byteLength)
        for (; Ue-- && me.getInt8(Ue) === ue.getInt8(Ue); ) ;
      return Ue === -1;
    }
    if (ArrayBuffer.isView(me)) {
      if ((Ue = me.byteLength) === ue.byteLength)
        for (; Ue-- && me[Ue] === ue[Ue]; ) ;
      return Ue === -1;
    }
    if (!Qe || typeof me == "object") {
      Ue = 0;
      for (Qe in me)
        if (has.call(me, Qe) && ++Ue && !has.call(ue, Qe) || !(Qe in ue) || !dequal(me[Qe], ue[Qe])) return !1;
      return Object.keys(ue).length === Ue;
    }
  }
  return me !== me && ue !== ue;
}
const DocumentContext = createContext(null);
function Message$3({ children: me, type: ue }) {
  return jsxRuntimeExports.jsx("div", { className: `react-pdf__message react-pdf__message--${ue}`, children: me });
}
const DEFAULT_LINK_REL = "noopener noreferrer nofollow";
class LinkService {
  constructor() {
    this.externalLinkEnabled = !0, this.externalLinkRel = void 0, this.externalLinkTarget = void 0, this.isInPresentationMode = !1, this.pdfDocument = void 0, this.pdfViewer = void 0;
  }
  setDocument(ue) {
    this.pdfDocument = ue;
  }
  setViewer(ue) {
    this.pdfViewer = ue;
  }
  setExternalLinkRel(ue) {
    this.externalLinkRel = ue;
  }
  setExternalLinkTarget(ue) {
    this.externalLinkTarget = ue;
  }
  setHistory() {
  }
  get pagesCount() {
    return this.pdfDocument ? this.pdfDocument.numPages : 0;
  }
  get page() {
    return invariant(this.pdfViewer, "PDF viewer is not initialized."), this.pdfViewer.currentPageNumber || 0;
  }
  set page(ue) {
    invariant(this.pdfViewer, "PDF viewer is not initialized."), this.pdfViewer.currentPageNumber = ue;
  }
  // eslint-disable-next-line @typescript-eslint/class-literal-property-style
  get rotation() {
    return 0;
  }
  set rotation(ue) {
  }
  goToDestination(ue) {
    return new Promise((Qe) => {
      invariant(this.pdfDocument, "PDF document not loaded."), invariant(ue, "Destination is not specified."), typeof ue == "string" ? this.pdfDocument.getDestination(ue).then(Qe) : Array.isArray(ue) ? Qe(ue) : ue.then(Qe);
    }).then((Qe) => {
      invariant(Array.isArray(Qe), `"${Qe}" is not a valid destination array.`);
      const Ue = Qe[0];
      new Promise((He) => {
        invariant(this.pdfDocument, "PDF document not loaded."), Ue instanceof Object ? this.pdfDocument.getPageIndex(Ue).then((Ge) => {
          He(Ge);
        }).catch(() => {
          invariant(!1, `"${Ue}" is not a valid page reference.`);
        }) : typeof Ue == "number" ? He(Ue) : invariant(!1, `"${Ue}" is not a valid destination reference.`);
      }).then((He) => {
        const Ge = He + 1;
        invariant(this.pdfViewer, "PDF viewer is not initialized."), invariant(Ge >= 1 && Ge <= this.pagesCount, `"${Ge}" is not a valid page number.`), this.pdfViewer.scrollPageIntoView({
          dest: Qe,
          pageIndex: He,
          pageNumber: Ge
        });
      });
    });
  }
  navigateTo(ue) {
    this.goToDestination(ue);
  }
  goToPage(ue) {
    const Qe = ue - 1;
    invariant(this.pdfViewer, "PDF viewer is not initialized."), invariant(ue >= 1 && ue <= this.pagesCount, `"${ue}" is not a valid page number.`), this.pdfViewer.scrollPageIntoView({
      pageIndex: Qe,
      pageNumber: ue
    });
  }
  addLinkAttributes(ue, Qe, Ue) {
    ue.href = Qe, ue.rel = this.externalLinkRel || DEFAULT_LINK_REL, ue.target = Ue ? "_blank" : this.externalLinkTarget || "";
  }
  getDestinationHash() {
    return "#";
  }
  getAnchorUrl() {
    return "#";
  }
  setHash() {
  }
  executeNamedAction() {
  }
  cachePageRef() {
  }
  isPageVisible() {
    return !0;
  }
  isPageCached() {
    return !0;
  }
  executeSetOCGState() {
  }
}
const PasswordResponses = {
  NEED_PASSWORD: 1,
  INCORRECT_PASSWORD: 2
}, isBrowser = typeof document < "u", isLocalFileSystem = isBrowser && window.location.protocol === "file:";
function isDefined(me) {
  return typeof me < "u";
}
function isProvided(me) {
  return isDefined(me) && me !== null;
}
function isString$1(me) {
  return typeof me == "string";
}
function isArrayBuffer$1(me) {
  return me instanceof ArrayBuffer;
}
function isBlob$1(me) {
  return invariant(isBrowser, "isBlob can only be used in a browser environment"), me instanceof Blob;
}
function isDataURI(me) {
  return isString$1(me) && /^data:/.test(me);
}
function dataURItoByteString(me) {
  invariant(isDataURI(me), "Invalid data URI.");
  const [ue = "", Qe = ""] = me.split(",");
  return ue.split(";").indexOf("base64") !== -1 ? atob(Qe) : unescape(Qe);
}
function getDevicePixelRatio() {
  return isBrowser && window.devicePixelRatio || 1;
}
const allowFileAccessFromFilesTip = "On Chromium based browsers, you can use --allow-file-access-from-files flag for debugging purposes.";
function displayCORSWarning() {
  warning$2(!isLocalFileSystem, `Loading PDF as base64 strings/URLs may not work on protocols other than HTTP/HTTPS. ${allowFileAccessFromFilesTip}`);
}
function displayWorkerWarning() {
  warning$2(!isLocalFileSystem, `Loading PDF.js worker may not work on protocols other than HTTP/HTTPS. ${allowFileAccessFromFilesTip}`);
}
function cancelRunningTask(me) {
  me && me.cancel && me.cancel();
}
function makePageCallback(me, ue) {
  return Object.defineProperty(me, "width", {
    get() {
      return this.view[2] * ue;
    },
    configurable: !0
  }), Object.defineProperty(me, "height", {
    get() {
      return this.view[3] * ue;
    },
    configurable: !0
  }), Object.defineProperty(me, "originalWidth", {
    get() {
      return this.view[2];
    },
    configurable: !0
  }), Object.defineProperty(me, "originalHeight", {
    get() {
      return this.view[3];
    },
    configurable: !0
  }), me;
}
function isCancelException(me) {
  return me.name === "RenderingCancelledException";
}
function loadFromFile(me) {
  return new Promise((ue, Qe) => {
    const Ue = new FileReader();
    Ue.onload = () => {
      if (!Ue.result)
        return Qe(new Error("Error while reading a file."));
      ue(Ue.result);
    }, Ue.onerror = (He) => {
      if (!He.target)
        return Qe(new Error("Error while reading a file."));
      const { error: Ge } = He.target;
      if (!Ge)
        return Qe(new Error("Error while reading a file."));
      switch (Ge.code) {
        case Ge.NOT_FOUND_ERR:
          return Qe(new Error("Error while reading a file: File not found."));
        case Ge.SECURITY_ERR:
          return Qe(new Error("Error while reading a file: Security error."));
        case Ge.ABORT_ERR:
          return Qe(new Error("Error while reading a file: Aborted."));
        default:
          return Qe(new Error("Error while reading a file."));
      }
    }, Ue.readAsArrayBuffer(me);
  });
}
function reducer(me, ue) {
  switch (ue.type) {
    case "RESOLVE":
      return { value: ue.value, error: void 0 };
    case "REJECT":
      return { value: !1, error: ue.error };
    case "RESET":
      return { value: void 0, error: void 0 };
    default:
      return me;
  }
}
function useResolver() {
  return useReducer(reducer, { value: void 0, error: void 0 });
}
var __awaiter = function(me, ue, Qe, Ue) {
  function He(Ge) {
    return Ge instanceof Qe ? Ge : new Qe(function(Xe) {
      Xe(Ge);
    });
  }
  return new (Qe || (Qe = Promise))(function(Ge, Xe) {
    function Ke(Ze) {
      try {
        Je(Ue.next(Ze));
      } catch (nt) {
        Xe(nt);
      }
    }
    function $e(Ze) {
      try {
        Je(Ue.throw(Ze));
      } catch (nt) {
        Xe(nt);
      }
    }
    function Je(Ze) {
      Ze.done ? Ge(Ze.value) : He(Ze.value).then(Ke, $e);
    }
    Je((Ue = Ue.apply(me, ue || [])).next());
  });
}, __rest$1 = function(me, ue) {
  var Qe = {};
  for (var Ue in me) Object.prototype.hasOwnProperty.call(me, Ue) && ue.indexOf(Ue) < 0 && (Qe[Ue] = me[Ue]);
  if (me != null && typeof Object.getOwnPropertySymbols == "function")
    for (var He = 0, Ue = Object.getOwnPropertySymbols(me); He < Ue.length; He++)
      ue.indexOf(Ue[He]) < 0 && Object.prototype.propertyIsEnumerable.call(me, Ue[He]) && (Qe[Ue[He]] = me[Ue[He]]);
  return Qe;
};
const { PDFDataRangeTransport } = pdfjs, defaultOnPassword = (me, ue) => {
  switch (ue) {
    case PasswordResponses.NEED_PASSWORD: {
      const Qe = prompt("Enter the password to open this PDF file.");
      me(Qe);
      break;
    }
    case PasswordResponses.INCORRECT_PASSWORD: {
      const Qe = prompt("Invalid password. Please try again.");
      me(Qe);
      break;
    }
  }
};
function isParameterObject(me) {
  return typeof me == "object" && me !== null && ("data" in me || "range" in me || "url" in me);
}
const Document$1 = forwardRef(function(ue, Qe) {
  var { children: Ue, className: He, error: Ge = "Failed to load PDF file.", externalLinkRel: Xe, externalLinkTarget: Ke, file: $e, inputRef: Je, imageResourcesPath: Ze, loading: nt = "Loading PDF…", noData: tt = "No PDF file specified.", onItemClick: et, onLoadError: rt, onLoadProgress: it, onLoadSuccess: ot, onPassword: at = defaultOnPassword, onSourceError: st, onSourceSuccess: ut, options: lt, renderMode: dt, rotate: At } = ue, pt = __rest$1(ue, ["children", "className", "error", "externalLinkRel", "externalLinkTarget", "file", "inputRef", "imageResourcesPath", "loading", "noData", "onItemClick", "onLoadError", "onLoadProgress", "onLoadSuccess", "onPassword", "onSourceError", "onSourceSuccess", "options", "renderMode", "rotate"]);
  const [gt, wt] = useResolver(), { value: Bt, error: Tt } = gt, [yt, Ct] = useResolver(), { value: ht, error: It } = yt, vt = useRef(new LinkService()), Et = useRef([]), bt = useRef(void 0), Rt = useRef(void 0);
  $e && $e !== bt.current && isParameterObject($e) && (warning$2(!dequal($e, bt.current), `File prop passed to <Document /> changed, but it's equal to previous one. This might result in unnecessary reloads. Consider memoizing the value passed to "file" prop.`), bt.current = $e), lt && lt !== Rt.current && (warning$2(!dequal(lt, Rt.current), `Options prop passed to <Document /> changed, but it's equal to previous one. This might result in unnecessary reloads. Consider memoizing the value passed to "options" prop.`), Rt.current = lt);
  const St = useRef({
    // Handling jumping to internal links target
    scrollPageIntoView: (Gt) => {
      const { dest: zt, pageNumber: $t, pageIndex: Ht = $t - 1 } = Gt;
      if (et) {
        et({ dest: zt, pageIndex: Ht, pageNumber: $t });
        return;
      }
      const hn = Et.current[Ht];
      if (hn) {
        hn.scrollIntoView();
        return;
      }
      warning$2(!1, `An internal link leading to page ${$t} was clicked, but neither <Document> was provided with onItemClick nor it was able to find the page within itself. Either provide onItemClick to <Document> and handle navigating by yourself or ensure that all pages are rendered within <Document>.`);
    }
  });
  useImperativeHandle(Qe, () => ({
    linkService: vt,
    pages: Et,
    viewer: St
  }), []);
  function kt() {
    ut && ut();
  }
  function jt() {
    Tt && (warning$2(!1, Tt.toString()), st && st(Tt));
  }
  function Pt() {
    wt({ type: "RESET" });
  }
  useEffect(Pt, [$e, wt]);
  const Qt = useCallback(() => __awaiter(this, void 0, void 0, function* () {
    if (!$e)
      return null;
    if (typeof $e == "string")
      return isDataURI($e) ? { data: dataURItoByteString($e) } : (displayCORSWarning(), { url: $e });
    if ($e instanceof PDFDataRangeTransport)
      return { range: $e };
    if (isArrayBuffer$1($e))
      return { data: $e };
    if (isBrowser && isBlob$1($e))
      return { data: yield loadFromFile($e) };
    if (invariant(typeof $e == "object", "Invalid parameter in file, need either Uint8Array, string or a parameter object"), invariant(isParameterObject($e), "Invalid parameter object: need either .data, .range or .url"), "url" in $e && typeof $e.url == "string") {
      if (isDataURI($e.url)) {
        const { url: Gt } = $e, zt = __rest$1($e, ["url"]), $t = dataURItoByteString(Gt);
        return Object.assign({ data: $t }, zt);
      }
      displayCORSWarning();
    }
    return $e;
  }), [$e]);
  useEffect(() => {
    const Gt = makeCancellablePromise(Qt());
    return Gt.promise.then((zt) => {
      wt({ type: "RESOLVE", value: zt });
    }).catch((zt) => {
      wt({ type: "REJECT", error: zt });
    }), () => {
      cancelRunningTask(Gt);
    };
  }, [Qt, wt]), useEffect(
    () => {
      if (!(typeof Bt > "u")) {
        if (Bt === !1) {
          jt();
          return;
        }
        kt();
      }
    },
    // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [Bt]
  );
  function qt() {
    ht && (ot && ot(ht), Et.current = new Array(ht.numPages), vt.current.setDocument(ht));
  }
  function _t() {
    It && (warning$2(!1, It.toString()), rt && rt(It));
  }
  function Yt() {
    Ct({ type: "RESET" });
  }
  useEffect(Yt, [Ct, Bt]);
  function Xt() {
    if (!Bt)
      return;
    const Gt = Object.assign(Object.assign({}, Bt), lt), zt = __webpack_exports__getDocument(Gt);
    it && (zt.onProgress = it), at && (zt.onPassword = at);
    const $t = zt;
    return $t.promise.then((Ht) => {
      Ct({ type: "RESOLVE", value: Ht });
    }).catch((Ht) => {
      $t.destroyed || Ct({ type: "REJECT", error: Ht });
    }), () => {
      $t.destroy();
    };
  }
  useEffect(
    Xt,
    // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [lt, Ct, Bt]
  ), useEffect(
    () => {
      if (!(typeof ht > "u")) {
        if (ht === !1) {
          _t();
          return;
        }
        qt();
      }
    },
    // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ht]
  );
  function Ut() {
    vt.current.setViewer(St.current), vt.current.setExternalLinkRel(Xe), vt.current.setExternalLinkTarget(Ke);
  }
  useEffect(Ut, [Xe, Ke]);
  function Lt(Gt, zt) {
    Et.current[Gt] = zt;
  }
  function Ot(Gt) {
    delete Et.current[Gt];
  }
  const ft = useMemo(() => ({
    imageResourcesPath: Ze,
    linkService: vt.current,
    onItemClick: et,
    pdf: ht,
    registerPage: Lt,
    renderMode: dt,
    rotate: At,
    unregisterPage: Ot
  }), [Ze, et, ht, dt, At]), Dt = useMemo(() => makeEventProps(pt, () => ht), [pt, ht]);
  function Mt() {
    return jsxRuntimeExports.jsx(DocumentContext.Provider, { value: ft, children: Ue });
  }
  function Ft() {
    return $e ? ht == null ? jsxRuntimeExports.jsx(Message$3, { type: "loading", children: typeof nt == "function" ? nt() : nt }) : ht === !1 ? jsxRuntimeExports.jsx(Message$3, { type: "error", children: typeof Ge == "function" ? Ge() : Ge }) : Mt() : jsxRuntimeExports.jsx(Message$3, { type: "no-data", children: typeof tt == "function" ? tt() : tt });
  }
  return jsxRuntimeExports.jsx("div", Object.assign({
    className: clsx("react-pdf__Document", He),
    // Assertion is needed for React 18 compatibility
    ref: Je,
    style: {
      "--scale-factor": "1"
    }
  }, Dt, { children: Ft() }));
});
function useDocumentContext() {
  return useContext(DocumentContext);
}
function mergeRefs() {
  for (var me = [], ue = 0; ue < arguments.length; ue++)
    me[ue] = arguments[ue];
  var Qe = me.filter(Boolean);
  if (Qe.length <= 1) {
    var Ue = Qe[0];
    return Ue || null;
  }
  return function(Ge) {
    Qe.forEach(function(Xe) {
      typeof Xe == "function" ? Xe(Ge) : Xe && (Xe.current = Ge);
    });
  };
}
const PageContext = createContext(null), PDF_ROLE_TO_HTML_ROLE = {
  // Document level structure types
  Document: null,
  // There's a "document" role, but it doesn't make sense here.
  DocumentFragment: null,
  // Grouping level structure types
  Part: "group",
  Sect: "group",
  // XXX: There's a "section" role, but it's abstract.
  Div: "group",
  Aside: "note",
  NonStruct: "none",
  // Block level structure types
  P: null,
  // H<n>,
  H: "heading",
  Title: null,
  FENote: "note",
  // Sub-block level structure type
  Sub: "group",
  // General inline level structure types
  Lbl: null,
  Span: null,
  Em: null,
  Strong: null,
  Link: "link",
  Annot: "note",
  Form: "form",
  // Ruby and Warichu structure types
  Ruby: null,
  RB: null,
  RT: null,
  RP: null,
  Warichu: null,
  WT: null,
  WP: null,
  // List standard structure types
  L: "list",
  LI: "listitem",
  LBody: null,
  // Table standard structure types
  Table: "table",
  TR: "row",
  TH: "columnheader",
  TD: "cell",
  THead: "columnheader",
  TBody: null,
  TFoot: null,
  // Standard structure type Caption
  Caption: null,
  // Standard structure type Figure
  Figure: "figure",
  // Standard structure type Formula
  Formula: null,
  // standard structure type Artifact
  Artifact: null
}, HEADING_PATTERN = /^H(\d+)$/;
function isPdfRole(me) {
  return me in PDF_ROLE_TO_HTML_ROLE;
}
function isStructTreeNode(me) {
  return "children" in me;
}
function isStructTreeNodeWithOnlyContentChild(me) {
  return isStructTreeNode(me) ? me.children.length === 1 && 0 in me.children && "id" in me.children[0] : !1;
}
function getRoleAttributes(me) {
  const ue = {};
  if (isStructTreeNode(me)) {
    const { role: Qe } = me, Ue = Qe.match(HEADING_PATTERN);
    if (Ue)
      ue.role = "heading", ue["aria-level"] = Number(Ue[1]);
    else if (isPdfRole(Qe)) {
      const He = PDF_ROLE_TO_HTML_ROLE[Qe];
      He && (ue.role = He);
    }
  }
  return ue;
}
function getBaseAttributes(me) {
  const ue = {};
  if (isStructTreeNode(me)) {
    if (me.alt !== void 0 && (ue["aria-label"] = me.alt), me.lang !== void 0 && (ue.lang = me.lang), isStructTreeNodeWithOnlyContentChild(me)) {
      const [Qe] = me.children;
      if (Qe) {
        const Ue = getBaseAttributes(Qe);
        return Object.assign(Object.assign({}, ue), Ue);
      }
    }
  } else
    "id" in me && (ue["aria-owns"] = me.id);
  return ue;
}
function getAttributes(me) {
  return me ? Object.assign(Object.assign({}, getRoleAttributes(me)), getBaseAttributes(me)) : null;
}
function StructTreeItem({ className: me, node: ue }) {
  const Qe = useMemo(() => getAttributes(ue), [ue]), Ue = useMemo(() => !isStructTreeNode(ue) || isStructTreeNodeWithOnlyContentChild(ue) ? null : ue.children.map((He, Ge) => (
    // eslint-disable-next-line react/no-array-index-key
    jsxRuntimeExports.jsx(StructTreeItem, { node: He }, Ge)
  )), [ue]);
  return jsxRuntimeExports.jsx("span", Object.assign({ className: me }, Qe, { children: Ue }));
}
function usePageContext() {
  return useContext(PageContext);
}
function StructTree() {
  const me = usePageContext();
  invariant(me, "Unable to find Page context.");
  const { onGetStructTreeError: ue, onGetStructTreeSuccess: Qe } = me, [Ue, He] = useResolver(), { value: Ge, error: Xe } = Ue, { customTextRenderer: Ke, page: $e } = me;
  function Je() {
    Ge && Qe && Qe(Ge);
  }
  function Ze() {
    Xe && (warning$2(!1, Xe.toString()), ue && ue(Xe));
  }
  function nt() {
    He({ type: "RESET" });
  }
  useEffect(nt, [He, $e]);
  function tt() {
    if (Ke || !$e)
      return;
    const et = makeCancellablePromise($e.getStructTree()), rt = et;
    return et.promise.then((it) => {
      He({ type: "RESOLVE", value: it });
    }).catch((it) => {
      He({ type: "REJECT", error: it });
    }), () => cancelRunningTask(rt);
  }
  return useEffect(tt, [Ke, $e, He]), useEffect(
    () => {
      if (Ge !== void 0) {
        if (Ge === !1) {
          Ze();
          return;
        }
        Je();
      }
    },
    // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [Ge]
  ), Ge ? jsxRuntimeExports.jsx(StructTreeItem, { className: "react-pdf__Page__structTree structTree", node: Ge }) : null;
}
const ANNOTATION_MODE = __webpack_exports__AnnotationMode;
function Canvas$1(me) {
  const ue = usePageContext();
  invariant(ue, "Unable to find Page context.");
  const Qe = Object.assign(Object.assign({}, ue), me), { _className: Ue, canvasBackground: He, devicePixelRatio: Ge = getDevicePixelRatio(), onRenderError: Xe, onRenderSuccess: Ke, page: $e, renderForms: Je, renderTextLayer: Ze, rotate: nt, scale: tt } = Qe, { canvasRef: et } = me;
  invariant($e, "Attempted to render page canvas, but no page was specified.");
  const rt = useRef(null);
  function it() {
    $e && Ke && Ke(makePageCallback($e, tt));
  }
  function ot(dt) {
    isCancelException(dt) || (warning$2(!1, dt.toString()), Xe && Xe(dt));
  }
  const at = useMemo(() => $e.getViewport({ scale: tt * Ge, rotation: nt }), [Ge, $e, nt, tt]), st = useMemo(() => $e.getViewport({ scale: tt, rotation: nt }), [$e, nt, tt]);
  function ut() {
    if (!$e)
      return;
    $e.cleanup();
    const { current: dt } = rt;
    if (!dt)
      return;
    dt.width = at.width, dt.height = at.height, dt.style.width = `${Math.floor(st.width)}px`, dt.style.height = `${Math.floor(st.height)}px`, dt.style.visibility = "hidden";
    const At = {
      annotationMode: Je ? ANNOTATION_MODE.ENABLE_FORMS : ANNOTATION_MODE.ENABLE,
      canvasContext: dt.getContext("2d", { alpha: !1 }),
      viewport: at
    };
    He && (At.background = He);
    const pt = $e.render(At), gt = pt;
    return pt.promise.then(() => {
      dt.style.visibility = "", it();
    }).catch(ot), () => cancelRunningTask(gt);
  }
  useEffect(
    ut,
    // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      He,
      rt,
      Ge,
      $e,
      Je,
      at,
      st
    ]
  );
  const lt = useCallback(() => {
    const { current: dt } = rt;
    dt && (dt.width = 0, dt.height = 0);
  }, [rt]);
  return useEffect(() => lt, [lt]), jsxRuntimeExports.jsx("canvas", { className: `${Ue}__canvas`, dir: "ltr", ref: mergeRefs(et, rt), style: {
    display: "block",
    userSelect: "none"
  }, children: Ze ? jsxRuntimeExports.jsx(StructTree, {}) : null });
}
function isTextItem(me) {
  return "str" in me;
}
function TextLayer() {
  const me = usePageContext();
  invariant(me, "Unable to find Page context.");
  const { customTextRenderer: ue, onGetTextError: Qe, onGetTextSuccess: Ue, onRenderTextLayerError: He, onRenderTextLayerSuccess: Ge, page: Xe, pageIndex: Ke, pageNumber: $e, rotate: Je, scale: Ze } = me;
  invariant(Xe, "Attempted to load page text content, but no page was specified.");
  const [nt, tt] = useResolver(), { value: et, error: rt } = nt, it = useRef(null), ot = useRef(void 0);
  warning$2(parseInt(window.getComputedStyle(document.body).getPropertyValue("--react-pdf-text-layer"), 10) === 1, "TextLayer styles not found. Read more: https://github.com/wojtekmaj/react-pdf#support-for-text-layer");
  function at() {
    et && Ue && Ue(et);
  }
  function st() {
    rt && (warning$2(!1, rt.toString()), Qe && Qe(rt));
  }
  function ut() {
    tt({ type: "RESET" });
  }
  useEffect(ut, [Xe, tt]);
  function lt() {
    if (!Xe)
      return;
    const Tt = makeCancellablePromise(Xe.getTextContent()), yt = Tt;
    return Tt.promise.then((Ct) => {
      tt({ type: "RESOLVE", value: Ct });
    }).catch((Ct) => {
      tt({ type: "REJECT", error: Ct });
    }), () => cancelRunningTask(yt);
  }
  useEffect(lt, [Xe, tt]), useEffect(
    () => {
      if (et !== void 0) {
        if (et === !1) {
          st();
          return;
        }
        at();
      }
    },
    // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [et]
  );
  const dt = useCallback(() => {
    Ge && Ge();
  }, [Ge]), At = useCallback((Tt) => {
    warning$2(!1, Tt.toString()), He && He(Tt);
  }, [He]);
  function pt() {
    const Tt = ot.current;
    Tt && Tt.classList.add("active");
  }
  function gt() {
    const Tt = ot.current;
    Tt && Tt.classList.remove("active");
  }
  const wt = useMemo(() => Xe.getViewport({ scale: Ze, rotation: Je }), [Xe, Je, Ze]);
  function Bt() {
    if (!Xe || !et)
      return;
    const { current: Tt } = it;
    if (!Tt)
      return;
    Tt.innerHTML = "";
    const yt = Xe.streamTextContent({ includeMarkedContent: !0 }), Ct = {
      container: Tt,
      textContentSource: yt,
      viewport: wt
    }, ht = new __webpack_exports__TextLayer(Ct), It = ht;
    return ht.render().then(() => {
      const vt = document.createElement("div");
      vt.className = "endOfContent", Tt.append(vt), ot.current = vt;
      const Et = Tt.querySelectorAll('[role="presentation"]');
      if (ue) {
        let bt = 0;
        et.items.forEach((Rt, St) => {
          if (!isTextItem(Rt))
            return;
          const kt = Et[bt];
          if (!kt)
            return;
          const jt = ue(Object.assign({
            pageIndex: Ke,
            pageNumber: $e,
            itemIndex: St
          }, Rt));
          kt.innerHTML = jt, bt += Rt.str && Rt.hasEOL ? 2 : 1;
        });
      }
      dt();
    }).catch(At), () => cancelRunningTask(It);
  }
  return useLayoutEffect(Bt, [
    ue,
    At,
    dt,
    Xe,
    Ke,
    $e,
    et,
    wt
  ]), // eslint-disable-next-line jsx-a11y/no-static-element-interactions
  jsxRuntimeExports.jsx("div", { className: clsx("react-pdf__Page__textContent", "textLayer"), onMouseUp: gt, onMouseDown: pt, ref: it });
}
function AnnotationLayer() {
  const me = useDocumentContext(), ue = usePageContext();
  invariant(ue, "Unable to find Page context.");
  const Qe = Object.assign(Object.assign({}, me), ue), { imageResourcesPath: Ue, linkService: He, onGetAnnotationsError: Ge, onGetAnnotationsSuccess: Xe, onRenderAnnotationLayerError: Ke, onRenderAnnotationLayerSuccess: $e, page: Je, pdf: Ze, renderForms: nt, rotate: tt, scale: et = 1 } = Qe;
  invariant(Ze, "Attempted to load page annotations, but no document was specified. Wrap <Page /> in a <Document /> or pass explicit `pdf` prop."), invariant(Je, "Attempted to load page annotations, but no page was specified."), invariant(He, "Attempted to load page annotations, but no linkService was specified.");
  const [rt, it] = useResolver(), { value: ot, error: at } = rt, st = useRef(null);
  warning$2(parseInt(window.getComputedStyle(document.body).getPropertyValue("--react-pdf-annotation-layer"), 10) === 1, "AnnotationLayer styles not found. Read more: https://github.com/wojtekmaj/react-pdf#support-for-annotations");
  function ut() {
    ot && Xe && Xe(ot);
  }
  function lt() {
    at && (warning$2(!1, at.toString()), Ge && Ge(at));
  }
  function dt() {
    it({ type: "RESET" });
  }
  useEffect(dt, [it, Je]);
  function At() {
    if (!Je)
      return;
    const Tt = makeCancellablePromise(Je.getAnnotations()), yt = Tt;
    return Tt.promise.then((Ct) => {
      it({ type: "RESOLVE", value: Ct });
    }).catch((Ct) => {
      it({ type: "REJECT", error: Ct });
    }), () => {
      cancelRunningTask(yt);
    };
  }
  useEffect(At, [it, Je, nt]), useEffect(
    () => {
      if (ot !== void 0) {
        if (ot === !1) {
          lt();
          return;
        }
        ut();
      }
    },
    // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ot]
  );
  function pt() {
    $e && $e();
  }
  function gt(Tt) {
    warning$2(!1, `${Tt}`), Ke && Ke(Tt);
  }
  const wt = useMemo(() => Je.getViewport({ scale: et, rotation: tt }), [Je, tt, et]);
  function Bt() {
    if (!Ze || !Je || !He || !ot)
      return;
    const { current: Tt } = st;
    if (!Tt)
      return;
    const yt = wt.clone({ dontFlip: !0 }), Ct = {
      accessibilityManager: null,
      // TODO: Implement this
      annotationCanvasMap: null,
      // TODO: Implement this
      annotationEditorUIManager: null,
      // TODO: Implement this
      div: Tt,
      l10n: null,
      // TODO: Implement this
      page: Je,
      viewport: yt
    }, ht = {
      annotations: ot,
      annotationStorage: Ze.annotationStorage,
      div: Tt,
      imageResourcesPath: Ue,
      linkService: He,
      page: Je,
      renderForms: nt,
      viewport: yt
    };
    Tt.innerHTML = "";
    try {
      new __webpack_exports__AnnotationLayer(Ct).render(ht), pt();
    } catch (It) {
      gt(It);
    }
    return () => {
    };
  }
  return useEffect(
    Bt,
    // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ot, Ue, He, Je, nt, wt]
  ), jsxRuntimeExports.jsx("div", { className: clsx("react-pdf__Page__annotations", "annotationLayer"), ref: st });
}
var __rest = function(me, ue) {
  var Qe = {};
  for (var Ue in me) Object.prototype.hasOwnProperty.call(me, Ue) && ue.indexOf(Ue) < 0 && (Qe[Ue] = me[Ue]);
  if (me != null && typeof Object.getOwnPropertySymbols == "function")
    for (var He = 0, Ue = Object.getOwnPropertySymbols(me); He < Ue.length; He++)
      ue.indexOf(Ue[He]) < 0 && Object.prototype.propertyIsEnumerable.call(me, Ue[He]) && (Qe[Ue[He]] = me[Ue[He]]);
  return Qe;
};
const defaultScale = 1;
function Page(me) {
  const ue = useDocumentContext(), Qe = Object.assign(Object.assign({}, ue), me), { _className: Ue = "react-pdf__Page", _enableRegisterUnregisterPage: He = !0, canvasBackground: Ge, canvasRef: Xe, children: Ke, className: $e, customRenderer: Je, customTextRenderer: Ze, devicePixelRatio: nt, error: tt = "Failed to load the page.", height: et, inputRef: rt, loading: it = "Loading page…", noData: ot = "No page specified.", onGetAnnotationsError: at, onGetAnnotationsSuccess: st, onGetStructTreeError: ut, onGetStructTreeSuccess: lt, onGetTextError: dt, onGetTextSuccess: At, onLoadError: pt, onLoadSuccess: gt, onRenderAnnotationLayerError: wt, onRenderAnnotationLayerSuccess: Bt, onRenderError: Tt, onRenderSuccess: yt, onRenderTextLayerError: Ct, onRenderTextLayerSuccess: ht, pageIndex: It, pageNumber: vt, pdf: Et, registerPage: bt, renderAnnotationLayer: Rt = !0, renderForms: St = !1, renderMode: kt = "canvas", renderTextLayer: jt = !0, rotate: Pt, scale: Qt = defaultScale, unregisterPage: qt, width: _t } = Qe, Yt = __rest(Qe, ["_className", "_enableRegisterUnregisterPage", "canvasBackground", "canvasRef", "children", "className", "customRenderer", "customTextRenderer", "devicePixelRatio", "error", "height", "inputRef", "loading", "noData", "onGetAnnotationsError", "onGetAnnotationsSuccess", "onGetStructTreeError", "onGetStructTreeSuccess", "onGetTextError", "onGetTextSuccess", "onLoadError", "onLoadSuccess", "onRenderAnnotationLayerError", "onRenderAnnotationLayerSuccess", "onRenderError", "onRenderSuccess", "onRenderTextLayerError", "onRenderTextLayerSuccess", "pageIndex", "pageNumber", "pdf", "registerPage", "renderAnnotationLayer", "renderForms", "renderMode", "renderTextLayer", "rotate", "scale", "unregisterPage", "width"]), [Xt, Ut] = useResolver(), { value: Lt, error: Ot } = Xt, ft = useRef(null);
  invariant(Et, "Attempted to load a page, but no document was specified. Wrap <Page /> in a <Document /> or pass explicit `pdf` prop.");
  const Dt = isProvided(vt) ? vt - 1 : It ?? null, Mt = vt ?? (isProvided(It) ? It + 1 : null), Ft = Pt ?? (Lt ? Lt.rotate : null), Gt = useMemo(() => {
    if (!Lt)
      return null;
    let Nn = 1;
    const Rn = Qt ?? defaultScale;
    if (_t || et) {
      const rn = Lt.getViewport({ scale: 1, rotation: Ft });
      _t ? Nn = _t / rn.width : et && (Nn = et / rn.height);
    }
    return Rn * Nn;
  }, [et, Lt, Ft, Qt, _t]);
  function zt() {
    return () => {
      isProvided(Dt) && He && qt && qt(Dt);
    };
  }
  useEffect(zt, [He, Et, Dt, qt]);
  function $t() {
    if (gt) {
      if (!Lt || !Gt)
        return;
      gt(makePageCallback(Lt, Gt));
    }
    if (He && bt) {
      if (!isProvided(Dt) || !ft.current)
        return;
      bt(Dt, ft.current);
    }
  }
  function Ht() {
    Ot && (warning$2(!1, Ot.toString()), pt && pt(Ot));
  }
  function hn() {
    Ut({ type: "RESET" });
  }
  useEffect(hn, [Ut, Et, Dt]);
  function un() {
    if (!Et || !Mt)
      return;
    const Nn = makeCancellablePromise(Et.getPage(Mt)), Rn = Nn;
    return Nn.promise.then((rn) => {
      Ut({ type: "RESOLVE", value: rn });
    }).catch((rn) => {
      Ut({ type: "REJECT", error: rn });
    }), () => cancelRunningTask(Rn);
  }
  useEffect(un, [Ut, Et, Dt, Mt, bt]), useEffect(
    () => {
      if (Lt !== void 0) {
        if (Lt === !1) {
          Ht();
          return;
        }
        $t();
      }
    },
    // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [Lt, Gt]
  );
  const An = useMemo(() => (
    // Technically there cannot be page without pageIndex, pageNumber, rotate and scale, but TypeScript doesn't know that
    Lt && isProvided(Dt) && Mt && isProvided(Ft) && isProvided(Gt) ? {
      _className: Ue,
      canvasBackground: Ge,
      customTextRenderer: Ze,
      devicePixelRatio: nt,
      onGetAnnotationsError: at,
      onGetAnnotationsSuccess: st,
      onGetStructTreeError: ut,
      onGetStructTreeSuccess: lt,
      onGetTextError: dt,
      onGetTextSuccess: At,
      onRenderAnnotationLayerError: wt,
      onRenderAnnotationLayerSuccess: Bt,
      onRenderError: Tt,
      onRenderSuccess: yt,
      onRenderTextLayerError: Ct,
      onRenderTextLayerSuccess: ht,
      page: Lt,
      pageIndex: Dt,
      pageNumber: Mt,
      renderForms: St,
      renderTextLayer: jt,
      rotate: Ft,
      scale: Gt
    } : null
  ), [
    Ue,
    Ge,
    Ze,
    nt,
    at,
    st,
    ut,
    lt,
    dt,
    At,
    wt,
    Bt,
    Tt,
    yt,
    Ct,
    ht,
    Lt,
    Dt,
    Mt,
    St,
    jt,
    Ft,
    Gt
  ]), mn = useMemo(() => makeEventProps(Yt, () => Lt && (Gt ? makePageCallback(Lt, Gt) : void 0)), [Yt, Lt, Gt]), En = `${Dt}@${Gt}/${Ft}`;
  function Jt() {
    switch (kt) {
      case "custom":
        return invariant(Je, 'renderMode was set to "custom", but no customRenderer was passed.'), jsxRuntimeExports.jsx(Je, {}, `${En}_custom`);
      case "none":
        return null;
      case "canvas":
      default:
        return jsxRuntimeExports.jsx(Canvas$1, { canvasRef: Xe }, `${En}_canvas`);
    }
  }
  function an() {
    return jt ? jsxRuntimeExports.jsx(TextLayer, {}, `${En}_text`) : null;
  }
  function cn() {
    return Rt ? jsxRuntimeExports.jsx(AnnotationLayer, {}, `${En}_annotations`) : null;
  }
  function dn() {
    return jsxRuntimeExports.jsxs(PageContext.Provider, { value: An, children: [Jt(), an(), cn(), Ke] });
  }
  function yn() {
    return Mt ? Et === null || Lt === void 0 || Lt === null ? jsxRuntimeExports.jsx(Message$3, { type: "loading", children: typeof it == "function" ? it() : it }) : Et === !1 || Lt === !1 ? jsxRuntimeExports.jsx(Message$3, { type: "error", children: typeof tt == "function" ? tt() : tt }) : dn() : jsxRuntimeExports.jsx(Message$3, { type: "no-data", children: typeof ot == "function" ? ot() : ot });
  }
  return jsxRuntimeExports.jsx("div", Object.assign({
    className: clsx(Ue, $e),
    "data-page-number": Mt,
    // Assertion is needed for React 18 compatibility
    ref: mergeRefs(rt, ft),
    style: {
      "--scale-factor": `${Gt}`,
      backgroundColor: Ge || "white",
      position: "relative",
      minWidth: "min-content",
      minHeight: "min-content"
    }
  }, mn, { children: yn() }));
}
displayWorkerWarning();
__webpack_exports__GlobalWorkerOptions.workerSrc = "pdf.worker.mjs";
const warning = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='29'%20height='24'%20viewBox='0%200%2029%2024'%3e%3cpath%20fill='%23FF5C6F'%20fill-rule='nonzero'%20d='M28.745%2021.377L16.022.837A1.788%201.788%200%200%200%2014.5%200c-.623%200-1.2.317-1.522.837L.255%2021.377a1.69%201.69%200%200%200-.025%201.744c.315.543.906.879%201.547.879h25.446c.641%200%201.232-.336%201.547-.88a1.69%201.69%200%200%200-.025-1.743zM14.509%207.105c.731%200%201.35.402%201.35%201.113%200%202.17-.263%205.29-.263%207.46%200%20.565-.637.802-1.087.802-.599%200-1.105-.237-1.105-.802%200-2.17-.262-5.29-.262-7.46%200-.711.6-1.113%201.367-1.113zm.02%2013.442c-.825%200-1.443-.656-1.443-1.404%200-.766.618-1.404%201.442-1.404.768%200%201.424.638%201.424%201.404%200%20.748-.656%201.404-1.424%201.404z'/%3e%3c/svg%3e";
__webpack_exports__GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${__webpack_exports__version}/pdf.worker.min.mjs`;
const CapturePreviewContainer = qe.div`
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  flex-direction: column;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding: 50px;
  z-index: 100;
`, CapturePreviewMessage = qe.div`
  display: flex;
  min-height: 25px;
  font-weight: bold;
  font-size: 19px;
  margin-bottom: 20px;
  min-width: 100px;
`, CapturePreviewMessageImage = qe.img`
  margin-right: 10px;
`, StyledDocument$1 = qe(Document$1)`
  border-radius: 14px;
  box-sizing: border-box;
  object-fit: contain;
  border: 8px solid #fff;
  max-width: 100%;
  max-height: 100%;
  margin: 0 auto;
  transition: 0.4s linear;
  transition-property: border, border-color;
  box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.22);
`, StyledPage$1 = qe(Page)`
  width: 100%;
  height: 100%;

  canvas {
    width: 100% !important;
    height: auto !important;
  }

  &.desktop {
    canvas {
      width: auto !important;
      height: 100% !important;
    }
  }
`, CapturePreviewImageContainer = qe.div`
  max-width: 100%;
  max-height: 100%;
  height: 100%;
  width: 100%;
  overflow: hidden;
  text-align: center;
  border-radius: 14px;
  flex: 1;
  padding: 7px;
  position: relative;
  margin-bottom: 20px;

  @media only screen and (max-height: 480px) {
    flex: unset;
  }

  &.error {
    img,
    ${StyledDocument$1} {
      border: 10px solid #ff5c6f;
    }
  }

  &.success {
    img,
    ${StyledDocument$1} {
      border: 10px solid #0aeda8;
    }
  }

  &.poa {
    display: flex;
    justify-content: center;
    height: auto;
    width: auto;
  }
`, CONTAINER_BORDER = 8, CapturePreviewImage = qe.img`
  border-radius: 14px;
  box-sizing: border-box;
  object-fit: contain;
  border: ${CONTAINER_BORDER}px solid #fff;
  max-width: 100%;
  max-height: 100%;
  margin: 0 auto;
  transition: 0.4s linear;
  transition-property: border, border-color;
  box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.22);
  backdrop-filter: blur(${(me) => me.shouldBlurImage ? 8 : 0}px);
  filter: blur(${(me) => me.shouldBlurImage ? 8 : 0}px);

  &.desktop {
    width: 687px;
    height: 440px;
  }
`, CapturePreviewUploadingContainer = qe.div`
  text-align: center;
  width: 100%;
`, AttemptsRemainingText = qe.p`
  color: #979797;
  padding-top: 15px;
`, CapturePreviewUploadingText = qe.p`
  margin: 10px 0;
  font-weight: bold;
`, CapturePreviewUploadingBarOutside = qe.div`
  width: 80%;
  height: 7px;
  background: #c6c6c6;
  margin: 0 auto;
  border-radius: 4px;
`, CapturePreviewUploadingProgress = qe.div`
  width: ${(me) => me.progress}%;
  height: 7px;
  border-radius: 4px;
  background: #3cb0f7;
  transition: 0.4s linear;
  transition-property: width, background-color;
`, CapturePreview = ({
  timesCaptureFailed: me = 0,
  numberOfTries: ue = 3,
  progress: Qe = 0,
  finishCapture: Ue,
  captureSuccessful: He,
  onClose: Ge,
  message: Xe = "",
  fileType: Ke = "",
  imageBase64: $e,
  isSelfie: Je,
  isPassport: Ze,
  isPoa: nt = !1,
  shouldBlurImage: tt = !1,
  shouldRotate: et = !1,
  ageAssurance: rt = !1,
  resumeAutocapture: it = () => {
  }
}) => {
  const { t: ot } = useTranslation(), [at, st] = useState(ot("notifications.couldntCapture")), ut = mobile.isDesktop(), lt = useRef(null), dt = useRef(null), [At, pt] = useState({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  });
  useAutoFocus(lt, !0), useEffect(() => {
    const wt = ot(Ue ? He ? "capturePreview.success" : Je ? "capturePreview.faceError" : Ze ? "capturePreview.passportError" : nt ? "capturePreview.poaError" : "capturePreview.idError" : rt ? "capturePreview.calculating" : "common.uploading");
    if (st(wt), Ue) {
      const Bt = setTimeout(() => {
        Ge(He);
      }, 1500);
      return () => clearTimeout(Bt);
    }
  }, [
    Ue,
    He,
    Je,
    Ze,
    Ge,
    ot,
    nt,
    rt
  ]), useEffect(() => {
    const wt = new ResizeObserver(() => {
      const { width: Bt, height: Tt, top: yt, left: Ct } = dt.current.getBoundingClientRect();
      pt({
        width: Bt - CONTAINER_BORDER * 2,
        height: Tt - CONTAINER_BORDER * 2,
        top: yt,
        left: Ct
      });
    });
    return wt.observe(dt.current), () => {
      wt.disconnect();
    };
  }, []);
  const gt = Ke === "application/pdf";
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    CapturePreviewContainer,
    {
      className: "IncodePreviewContainer",
      ref: lt,
      tabIndex: "-1",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          CapturePreviewMessage,
          {
            className: "IncodeCapturePreviewMessage",
            role: "region",
            "aria-live": "assertive",
            children: !He && Xe && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                CapturePreviewMessageImage,
                {
                  src: warning,
                  role: "alert",
                  "aria-live": "assertive",
                  className: "IncodeCapturePreviewMessageImage"
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: Xe })
            ] })
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          CapturePreviewImageContainer,
          {
            ref: dt,
            className: classNames("IncodeCapturePreviewImageContainer", {
              neutral: He === null,
              success: He === !0,
              error: He === !1,
              desktop: ut,
              poa: nt
            }),
            children: [
              gt ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocument$1, { file: $e, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                StyledPage$1,
                {
                  className: classNames({
                    desktop: ut
                  }),
                  pageNumber: 1
                }
              ) }) : null,
              !gt && $e && !et ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                CapturePreviewImage,
                {
                  src: $e,
                  alt: "ID capture preview",
                  className: classNames("IncodeCapturePreviewImage", {
                    desktop: ut
                  }),
                  shouldBlurImage: tt
                }
              ) : null,
              !gt && $e && et ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                "div",
                {
                  style: {
                    width: At.height,
                    height: At.width,
                    transform: `rotate(90deg) translate(${Math.abs(
                      (At.width - At.height) / 2
                    )}px, ${Math.abs(
                      (At.width - At.height) / 2
                    )}px)`
                  },
                  children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    CapturePreviewImage,
                    {
                      src: $e,
                      alt: "ID capture preview",
                      className: classNames("IncodeCapturePreviewImage", {
                        desktop: ut
                      })
                    }
                  )
                }
              ) : null
            ]
          }
        ),
        !Xe && /* @__PURE__ */ jsxRuntimeExports.jsxs(CapturePreviewUploadingContainer, { className: "IncodeCapturePreviewUploadingContainer", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            CapturePreviewUploadingText,
            {
              role: "region",
              "aria-live": !He && Xe ? "off" : "assertive",
              className: "IncodeCapturePreviewUploadingText",
              children: at
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(CapturePreviewUploadingBarOutside, { className: "IncodeCapturePreviewUploadingBarOutside", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            CapturePreviewUploadingProgress,
            {
              progress: Qe,
              className: "IncodeCapturePreviewUploadingBarInside"
            }
          ) })
        ] }),
        !He && Xe && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button$a,
            {
              onClick: () => {
                it();
              },
              children: me >= ue - 1 ? ot("common.continue") : ot("common.tryAgain")
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(AttemptsRemainingText, { class: "IncodeAttempsRemainingText", children: ot("common.attempsLeft", {
            attempts: ue - 1 - me
          }) })
        ] })
      ]
    }
  ) });
}, CaptureButton = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='76'%20height='76'%20viewBox='0%200%2076%2076'%3e%3cg%20fill='none'%20fill-rule='evenodd'%3e%3ccircle%20cx='38'%20cy='38'%20r='37'%20fill='%23000'%20opacity='.5'/%3e%3cpath%20fill='%23FFF'%20d='M38%2076C17.013%2076%200%2058.987%200%2038S17.013%200%2038%200s38%2017.013%2038%2038-17.013%2038-38%2038zm0-5c18.225%200%2033-14.775%2033-33S56.225%205%2038%205%205%2019.775%205%2038s14.775%2033%2033%2033z'/%3e%3ccircle%20cx='38'%20cy='38'%20r='25'%20fill='%23FFF'/%3e%3c/g%3e%3c/svg%3e", moveIn$2 = We`
  0% {
    bottom: -200px;
  }

  80% {
    bottom: 6%;
  }

  100% {
    bottom: 5%;
  }
`, FakeButton$2 = qe.div`
  position: absolute;
  text-align: center;
  left: 50%;
  transform: translateX(-50%);
  animation: ${moveIn$2} 1s ease-in forwards;

  &.hidden {
    display: none;
  }
`, toImage = (me) => `data:image/png;base64,${me}`;
function AdditionalId({
  onBoarding: me,
  onSuccess: ue,
  permission: Qe,
  setPermission: Ue,
  permissionMessage: He,
  permissionBackgroundColor: Ge,
  onLog: Xe,
  token: Ke,
  documentType: $e
}) {
  const Je = Ke ? Ke.token : me.state.token.token, [, Ze] = useState("white"), [nt, tt] = useState(0), [et, rt] = useState(!1), [it, ot] = useState(null), [at, st] = useState(null), [ut, lt] = useState(null), dt = useRef(null), At = throttle$1(async () => {
    const gt = dt.current.getCanvas(), Bt = gt.getResizedCanvas(
      dt.current.video.clientWidth,
      dt.current.video.clientHeight
    ).getBase64Image(), Tt = gt.getBase64Image(), { blob: yt } = gt.getBlobData();
    return rt(!0), lt(toImage(Bt)), Ze("green"), $e === "secondId" ? me.addFrontSecondId({
      token: Je,
      image: yt,
      onProgress: tt
    }).then(() => {
      tt(100), Ze("white"), ot(!0), st(!0), Xe(
        getLogObject("successCapture", {
          message: "Second ID captured successfully"
        })
      ), me.processSecondId({ token: Je });
    }).then(() => {
      ue("success");
    }) : me.addDocument({
      token: Je,
      type: $e,
      image: Tt,
      onProgress: tt
    }).then(() => {
      tt(100), Ze("white"), ot(!0), st(!0), Xe(
        getLogObject("successCapture", {
          message: "Document captured successfully"
        })
      );
    }).then(() => {
      ue("success");
    });
  }, 300), pt = () => {
    rt(!1), tt(0), st(!1), ot(!1), Ze("white");
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Webcam,
      {
        ref: dt,
        videoSource: "environment",
        permission: Qe,
        setPermission: Ue,
        permissionMessage: He,
        type: "additionalId",
        permissionBackgroundColor: Ge,
        onLog: Xe,
        token: Je,
        interviewId: Ke.interviewId,
        className: "IncodeAdditionalIDWebcam"
      }
    ),
    et && /* @__PURE__ */ jsxRuntimeExports.jsx(
      CapturePreview,
      {
        open: !0,
        progress: nt,
        finishCapture: at,
        captureSuccessful: it,
        onClose: pt,
        imageBase64: ut,
        isSelfie: !1,
        className: "IncodeAdditionalIDCapturePreview"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(FakeButton$2, { className: classNames({ hidden: et }), children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "img",
      {
        alt: "capture button",
        src: CaptureButton,
        className: "step__video-catch-event IncodeAdditionalIDFakeButton",
        onClick: () => At(),
        onKeyDown: () => At()
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("canvas", { id: "canvasFrame", hidden: !0 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Notification,
      {
        inline: !1,
        center: !0,
        className: "IncodeAdditionalIDNotification"
      }
    )
  ] });
}
const ButtonsContainer$4 = qe.div`
  display: flex;
  flex-direction: column;
`, StyledButton = qe(Button$a)`
  margin-bottom: 20px;

  @media only screen and (max-height: 600px) {
    margin-bottom: 10px;
    height: 60px;
  }
`, TutorialSHeader = qe.div`
  display: flex;
  flex-direction: column;
  & > section {
    display: flex;
    flex-direction: column;
    span {
      margin-bottom: 5px;
    }
  }
`, TutorialCreditCardBackHeader = () => {
  const { t: me } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: me("tutorial.creditCardBack") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: me("tutorial.creditCardBack2") })
  ] });
};
function TutorialCreditCardBack({
  onSuccess: me,
  token: ue,
  src: Qe = "https://sdk.incode.com/sdk/tutorials/card%20back.svg",
  ...Ue
}) {
  const { t: He } = useTranslation();
  useEffect(() => {
    addEvent({
      token: ue.token,
      code: "tutorialCreditCardBack",
      payload: { tutorialCreditCardBack: !0 }
    });
  }, [ue.token]);
  function Ge() {
    addEvent({
      token: ue == null ? void 0 : ue.token,
      code: "continue"
    }), me();
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Tutorial,
    {
      creditCard: !0,
      ...Ue,
      src: Qe,
      header: /* @__PURE__ */ jsxRuntimeExports.jsx(TutorialCreditCardBackHeader, {}),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonsContainer$4, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        StyledButton,
        {
          className: classNames("IncodeTutorialButton", "IncodeTutorialButtonSelfie"),
          onClick: Ge,
          children: He("common.continue")
        }
      ) })
    }
  );
}
const ChooseCameraContainer = qe.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  z-index: 99999;
  box-sizing: border-box;
  padding: 75px 25px;
  height: 100%;
  width: 100%;
  background-color: #f9f9f9;
`, CameraSelect = qe.select`
  border: 1px solid #cccccc;
  border-radius: 5px;
  padding: 8px;
  margin-bottom: 20px;
  margin-top: 20px;
`, PreviewVideo = qe.video`
  max-height: 60vh;
  transform: rotateY(180deg);
  border: 5px solid white;
  border-radius: 30px;
  width: 100%;
  height: auto;
`, ChooseCamera = ({ onCameraChosen: me, token: ue }) => {
  const [Qe, Ue] = useState([]), He = useRef(null), Ge = useRef(), [Xe, Ke] = useState(""), { t: $e } = useTranslation();
  useEffect(() => () => {
    var tt;
    (tt = Ge.current) == null || tt.getTracks().forEach((et) => {
      et.stop();
    });
  }, []);
  const Je = () => {
    me(Xe);
  }, Ze = async (tt) => {
    Ke(tt);
    const et = await navigator.mediaDevices.getUserMedia({
      video: { deviceId: { exact: tt } }
    });
    Ge.current = et, He.current.srcObject = et;
  };
  useEffect(() => {
    (async () => {
      try {
        const et = [];
        if (await navigator.mediaDevices.getUserMedia({ video: !0 }), (await navigator.mediaDevices.enumerateDevices()).forEach((it) => {
          it.kind === "videoinput" && et.push(it);
        }), et.length === 1)
          return me(et[0].deviceId);
        Ue(et), Ze(et[0].deviceId);
      } catch (et) {
        et.constructor.name === "DOMException" && (addEvent({
          code: "permissionDenied",
          payload: {
            message: "User denied to use camera."
          },
          token: ue
        }), et.type = "permissionDenied"), me("error");
      }
    })();
  }, []);
  const nt = async (tt) => {
    await Ze(tt.target.value);
  };
  return Qe.length === 0 ? null : /* @__PURE__ */ jsxRuntimeExports.jsxs(ChooseCameraContainer, { className: "IncodeChooseCameraContainer", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { className: "IncodeChooseCameraTitle", children: $e("choseCamera.confirmCameraToUse") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      PreviewVideo,
      {
        className: "IncodeChooseCameraPreviewVideo",
        autoPlay: !0,
        ref: He
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CameraSelect,
      {
        className: "IncodeChooseCameraSelector",
        onChange: nt,
        children: Qe.map((tt) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: tt.deviceId, children: tt.label }, tt.deviceId))
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button$a,
      {
        className: "IncodeChooseCameraButton",
        onClick: Je,
        children: $e("common.continue")
      }
    )
  ] });
}, glare = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20width='56px'%20height='70px'%20viewBox='0%200%2056%2070'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3ctitle%3eglare@1x%3c/title%3e%3cg%20id='Page-1'%20stroke='none'%20stroke-width='1'%20fill='none'%20fill-rule='evenodd'%3e%3cg%20id='Artboard'%20transform='translate(-206.000000,%20-142.000000)'%3e%3cg%20id='glare'%20transform='translate(206.000000,%20142.000000)'%3e%3crect%20id='Rectangle'%20fill='%2320263D'%20fill-rule='nonzero'%20transform='translate(24.500000,%2038.500000)%20rotate(-90.000000)%20translate(-24.500000,%20-38.500000)%20'%20x='-7'%20y='14'%20width='63'%20height='49'%20rx='8'%3e%3c/rect%3e%3cpath%20d='M25.064,30.015%20C20.074,30.015%2016.015,34.075%2016.015,39.065%20C16.015,44.055%2020.075,48.115%2025.064,48.115%20C30.053,48.115%2034.113,44.055%2034.113,39.065%20C34.113,34.075%2030.053,30.015%2025.064,30.015%20Z%20M25.064,27.355%20C24.089,27.355%2023.298,26.565%2023.298,25.59%20L23.298,22.766%20C23.298,21.79%2024.088,21%2025.064,21%20C26.039,21%2026.83,21.79%2026.83,22.766%20L26.83,25.59%20C26.83,26.565%2026.038,27.355%2025.064,27.355%20L25.064,27.355%20Z%20M25.064,50.772%20C24.089,50.772%2023.298,51.562%2023.298,52.538%20L23.298,55.362%20C23.298,56.338%2024.088,57.128%2025.064,57.128%20C26.039,57.128%2026.83,56.338%2026.83,55.362%20L26.83,52.538%20C26.83,51.562%2026.038,50.772%2025.064,50.772%20Z%20M33.342,30.785%20C32.654,30.095%2032.654,28.978%2033.342,28.288%20L35.34,26.29%20C36.029,25.602%2037.147,25.602%2037.837,26.29%20C38.527,26.98%2038.527,28.098%2037.837,28.787%20L35.839,30.785%20C35.15,31.475%2034.033,31.475%2033.342,30.785%20Z%20M15.785,47.344%20C15.095,46.654%2013.978,46.654%2013.288,47.344%20L11.29,49.341%20C10.602,50.03%2010.6,51.149%2011.29,51.838%20C11.98,52.526%2013.098,52.526%2013.787,51.838%20L15.785,49.839%20C16.475,49.15%2016.475,48.032%2015.785,47.344%20Z%20M36.772,39.064%20C36.772,38.089%2037.562,37.298%2038.538,37.298%20L41.362,37.298%20C42.338,37.298%2043.128,38.088%2043.128,39.064%20C43.128,40.039%2042.338,40.829%2041.362,40.829%20L38.538,40.829%20C37.562,40.829%2036.772,40.039%2036.772,39.064%20Z%20M12.355,39.064%20C12.355,38.089%2011.565,37.298%2010.59,37.298%20L7.766,37.298%20C6.79,37.298%206,38.088%206,39.064%20C6,40.039%206.79,40.829%207.766,40.829%20L10.59,40.829%20C11.565,40.829%2012.355,40.039%2012.355,39.064%20Z%20M32.342,47.344%20C33.032,46.655%2034.15,46.655%2034.839,47.344%20L36.837,49.342%20C37.527,50.03%2037.527,51.149%2036.837,51.838%20C36.147,52.526%2035.03,52.526%2034.34,51.838%20L32.342,49.84%20C31.652,49.15%2031.652,48.033%2032.342,47.344%20Z%20M15.785,30.785%20C16.475,30.095%2016.475,28.978%2015.785,28.288%20L13.787,26.291%20C13.097,25.601%2011.98,25.601%2011.29,26.291%20C10.6,26.98%2010.6,28.098%2011.29,28.787%20L13.288,30.785%20C13.978,31.475%2015.095,31.475%2015.785,30.785%20Z'%20id='Shape'%20fill='%23FFFFFF'%20fill-rule='nonzero'%3e%3c/path%3e%3cg%20id='Group'%20transform='translate(36.000000,%200.000000)'%3e%3ccircle%20id='Oval'%20fill='%23FF5C6F'%20fill-rule='nonzero'%20cx='9.979'%20cy='9.979'%20r='9.979'%3e%3c/circle%3e%3cg%20transform='translate(6.000000,%206.000000)'%20id='Path'%20stroke='%23FFFFFF'%20stroke-width='1.247'%3e%3cpath%20d='M4.913,4.134%20L7.556,1.491%20C7.628,1.418%207.668,1.321%207.669,1.218%20C7.669,1.114%207.629,1.018%207.556,0.944%20L7.324,0.713%20C7.251,0.64%207.154,0.6%207.051,0.6%20C6.947,0.6%206.851,0.64%206.777,0.713%20L4.134,3.356%20L1.491,0.713%20C1.42,0.64%201.321,0.6%201.218,0.6%20C1.115,0.6%201.018,0.64%200.945,0.713%20L0.713,0.944%20C0.563,1.095%200.563,1.341%200.713,1.491%20L3.356,4.134%20L0.713,6.777%20C0.64,6.85%200.6,6.947%200.6,7.051%20C0.6,7.154%200.64,7.251%200.713,7.324%20L0.945,7.556%20C1.017,7.629%201.115,7.669%201.218,7.669%20C1.322,7.669%201.418,7.629%201.491,7.556%20L4.134,4.913%20L6.777,7.556%20C6.85,7.629%206.947,7.669%207.051,7.669%20L7.051,7.669%20C7.154,7.669%207.251,7.629%207.324,7.556%20L7.556,7.324%20C7.628,7.251%207.668,7.154%207.668,7.051%20C7.668,6.947%207.628,6.851%207.556,6.777%20L4.913,4.134%20Z'%3e%3c/path%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e", lens = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20width='56px'%20height='70px'%20viewBox='0%200%2056%2070'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3ctitle%3elens@1x%3c/title%3e%3cg%20id='Page-1'%20stroke='none'%20stroke-width='1'%20fill='none'%20fill-rule='evenodd'%3e%3cg%20id='Artboard'%20transform='translate(-289.000000,%20-142.000000)'%3e%3cg%20id='lens'%20transform='translate(289.000000,%20142.000000)'%3e%3crect%20id='Rectangle'%20fill='%2320263D'%20fill-rule='nonzero'%20transform='translate(24.500000,%2038.500000)%20rotate(-90.000000)%20translate(-24.500000,%20-38.500000)%20'%20x='-7'%20y='14'%20width='63'%20height='49'%20rx='8'%3e%3c/rect%3e%3cg%20id='Group'%20transform='translate(9.000000,%2026.000000)'%20fill='%23FFFFFF'%3e%3cpath%20d='M28.233,3.96%20L24.163,3.96%20C23.649,3.96%2023.166,3.754%2022.802,3.38%20L20.456,0.967%20C19.85,0.344%2019.044,0%2018.186,0%20L12.613,0%20C11.756,0%2010.95,0.344%2010.344,0.967%20L7.998,3.38%20C7.634,3.754%207.151,3.96%206.637,3.96%20L2.567,3.96%20C1.15,3.96%200,5.144%200,6.6%20L0,23.76%20C0,25.216%201.151,26.4%202.567,26.4%20L28.233,26.4%20C29.649,26.4%2030.8,25.216%2030.8,23.76%20L30.8,6.6%20C30.8,5.144%2029.649,3.96%2028.233,3.96%20Z%20M15.4,24.2%20C10.547,24.2%206.6,20.253%206.6,15.4%20C6.6,10.547%2010.547,6.6%2015.4,6.6%20C20.253,6.6%2024.2,10.547%2024.2,15.4%20C24.2,20.253%2020.253,24.2%2015.4,24.2%20Z%20M26.4,7.7%20C27.006,7.7%2027.5,8.194%2027.5,8.8%20C27.5,9.406%2027.006,9.9%2026.4,9.9%20C25.794,9.9%2025.3,9.406%2025.3,8.8%20C25.3,8.194%2025.794,7.7%2026.4,7.7%20Z%20M6.05,1.1%20C6.354,1.1%206.6,1.346%206.6,1.65%20C6.6,1.954%206.354,2.2%206.05,2.2%20L2.75,2.2%20C2.446,2.2%202.2,1.954%202.2,1.65%20C2.2,1.346%202.446,1.1%202.75,1.1%20L6.05,1.1%20Z'%20id='Shape'%20fill-rule='nonzero'%3e%3c/path%3e%3ccircle%20id='Oval'%20cx='13.5'%20cy='13.5'%20r='3.5'%3e%3c/circle%3e%3ccircle%20id='Oval-Copy'%20cx='19.5'%20cy='15.5'%20r='1.5'%3e%3c/circle%3e%3ccircle%20id='Oval-Copy-2'%20cx='17'%20cy='19'%20r='2'%3e%3c/circle%3e%3c/g%3e%3cg%20id='Group'%20transform='translate(36.000000,%200.000000)'%3e%3ccircle%20id='Oval'%20fill='%23FF5C6F'%20fill-rule='nonzero'%20cx='9.979'%20cy='9.979'%20r='9.979'%3e%3c/circle%3e%3cg%20transform='translate(6.000000,%206.000000)'%20id='Path'%20stroke='%23FFFFFF'%20stroke-width='1.247'%3e%3cpath%20d='M4.913,4.134%20L7.556,1.491%20C7.628,1.418%207.668,1.321%207.669,1.218%20C7.669,1.114%207.629,1.018%207.556,0.944%20L7.324,0.713%20C7.251,0.64%207.154,0.6%207.051,0.6%20C6.947,0.6%206.851,0.64%206.777,0.713%20L4.134,3.356%20L1.491,0.713%20C1.42,0.64%201.321,0.6%201.218,0.6%20C1.115,0.6%201.018,0.64%200.945,0.713%20L0.713,0.944%20C0.563,1.095%200.563,1.341%200.713,1.491%20L3.356,4.134%20L0.713,6.777%20C0.64,6.85%200.6,6.947%200.6,7.051%20C0.6,7.154%200.64,7.251%200.713,7.324%20L0.945,7.556%20C1.017,7.629%201.115,7.669%201.218,7.669%20C1.322,7.669%201.418,7.629%201.491,7.556%20L4.134,4.913%20L6.777,7.556%20C6.85,7.629%206.947,7.669%207.051,7.669%20L7.051,7.669%20C7.154,7.669%207.251,7.629%207.324,7.556%20L7.556,7.324%20C7.628,7.251%207.668,7.154%207.668,7.051%20C7.668,6.947%207.628,6.851%207.556,6.777%20L4.913,4.134%20Z'%3e%3c/path%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e", outFrame = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20width='56px'%20height='77px'%20viewBox='0%200%2056%2077'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3ctitle%3eout%20frame@1x%3c/title%3e%3cg%20id='Page-1'%20stroke='none'%20stroke-width='1'%20fill='none'%20fill-rule='evenodd'%3e%3cg%20id='Artboard'%20transform='translate(-125.000000,%20-142.000000)'%3e%3cg%20id='out-frame'%20transform='translate(125.000000,%20142.000000)'%3e%3cg%20id='Group'%20transform='translate(0.000000,%207.000000)'%20fill-rule='nonzero'%3e%3cg%20id='bc6d9nhkxa-link'%20transform='translate(24.500000,%2031.500000)%20rotate(-90.000000)%20translate(-24.500000,%20-31.500000)%20translate(-7.000000,%207.000000)'%20fill='%2320263D'%3e%3crect%20id='bc6d9nhkxa'%20x='0'%20y='0'%20width='63'%20height='49'%20rx='8'%3e%3c/rect%3e%3c/g%3e%3cg%20id='Group'%20transform='translate(9.000000,%2015.000000)'%20fill='%23FFFFFF'%3e%3cpath%20d='M45.061706,13.5722694%20C46.298706,13.5722694%2047.301706,14.5752694%2047.301706,15.8122694%20L47.301706,39.3322694%20C47.301706,40.5692694%2046.298706,41.5722694%2045.061706,41.5722694%20L2.50170602,41.5722694%20C1.26470602,41.5722694%200.261706024,40.5692694%200.261706024,39.3322694%20L0.261706024,15.8122694%20C0.261706024,14.5752694%201.26470602,13.5722694%202.50170602,13.5722694%20L45.061706,13.5722694%20Z%20M18.181706,16.9322694%20L5.86170602,16.9322694%20C4.62470602,16.9322694%203.62170602,17.9352694%203.62170602,19.1722694%20L3.62170602,35.9722694%20C3.62170602,37.2092694%204.62470602,38.2122694%205.86170602,38.2122694%20L18.181706,38.2122694%20C19.418706,38.2122694%2020.421706,37.2092694%2020.421706,35.9722694%20L20.421706,19.1722694%20C20.421706,17.9352694%2019.418706,16.9322694%2018.181706,16.9322694%20Z%20M42.821706,35.9722694%20L24.901706,35.9722694%20C24.282706,35.9722694%2023.781706,36.4732694%2023.781706,37.0922694%20C23.781706,37.7112694%2024.282706,38.2122694%2024.901706,38.2122694%20L42.821706,38.2122694%20C43.440706,38.2122694%2043.941706,37.7112694%2043.941706,37.0922694%20C43.941706,36.4732694%2043.440706,35.9722694%2042.821706,35.9722694%20Z%20M42.821706,31.4922694%20L24.901706,31.4922694%20C24.282706,31.4922694%2023.781706,31.9932694%2023.781706,32.6122694%20C23.781706,33.2312694%2024.282706,33.7322694%2024.901706,33.7322694%20L42.821706,33.7322694%20C43.440706,33.7322694%2043.941706,33.2312694%2043.941706,32.6122694%20C43.941706,31.9932694%2043.440706,31.4922694%2042.821706,31.4922694%20Z%20M42.821706,27.0122694%20L24.901706,27.0122694%20C24.282706,27.0122694%2023.781706,27.5132694%2023.781706,28.1322694%20C23.781706,28.7512694%2024.282706,29.2522694%2024.901706,29.2522694%20L42.821706,29.2522694%20C43.440706,29.2522694%2043.941706,28.7512694%2043.941706,28.1322694%20C43.941706,27.5132694%2043.440706,27.0122694%2042.821706,27.0122694%20Z%20M33.861706,22.5322694%20L24.901706,22.5322694%20C24.282706,22.5322694%2023.781706,23.0332694%2023.781706,23.6522694%20C23.781706,24.2712694%2024.282706,24.7722694%2024.901706,24.7722694%20L33.861706,24.7722694%20C34.480706,24.7722694%2034.981706,24.2712694%2034.981706,23.6522694%20C34.981706,23.0332694%2034.480706,22.5322694%2033.861706,22.5322694%20Z%20M33.861706,18.0522694%20L24.901706,18.0522694%20C24.282706,18.0522694%2023.781706,18.5532694%2023.781706,19.1722694%20C23.781706,19.7912694%2024.282706,20.2922694%2024.901706,20.2922694%20L33.861706,20.2922694%20C34.480706,20.2922694%2034.981706,19.7912694%2034.981706,19.1722694%20C34.981706,18.5532694%2034.480706,18.0522694%2033.861706,18.0522694%20Z'%20id='Shape'%20transform='translate(23.781706,%2027.572269)%20rotate(63.000000)%20translate(-23.781706,%20-27.572269)%20'%3e%3c/path%3e%3cg%20transform='translate(9.000000,%209.000000)'%20id='Path'%3e%3cpath%20d='M13.434487,9.98015524%20C14.511487,9.98015524%2015.444487,9.59415524%2016.206487,8.83215524%20C16.968487,8.06915524%2017.354487,7.13715524%2017.354487,6.06015524%20C17.354487,4.98315524%2016.968487,4.05015524%2016.206487,3.28815524%20C15.443487,2.52615524%2014.511487,2.14015524%2013.434487,2.14015524%20C12.357487,2.14015524%2011.424487,2.52615524%2010.662487,3.28815524%20C9.90048698,4.05015524%209.51448698,4.98315524%209.51448698,6.06015524%20C9.51448698,7.13715524%209.90048698,8.07015524%2010.663487,8.83215524%20C11.425487,9.59415524%2012.357487,9.98015524%2013.434487,9.98015524%20Z'%20transform='translate(13.434487,%206.060155)%20rotate(63.000000)%20translate(-13.434487,%20-6.060155)%20'%3e%3c/path%3e%3cpath%20d='M12.5789958,10.0354408%20C12.5589958,9.73944075%2012.5189958,9.41744075%2012.4589958,9.07744075%20C12.3989958,8.73444075%2012.3219958,8.41044075%2012.2299958,8.11344075%20C12.1349958,7.80744075%2012.0049958,7.50544075%2011.8439958,7.21544075%20C11.6779958,6.91444075%2011.4819958,6.65244075%2011.2629958,6.43644075%20C11.0329958,6.21144075%2010.7529958,6.03044075%2010.4269958,5.89744075%20C10.1039958,5.76644075%209.74499583,5.69944075%209.36099583,5.69944075%20C9.21099583,5.69944075%209.06399583,5.76344075%208.78299583,5.95144075%20C8.60999583,6.06744075%208.40699583,6.20144075%208.18099583,6.35044075%20C7.98699583,6.47644075%207.72499583,6.59544075%207.40099583,6.70244075%20C7.08599583,6.80744075%206.76499583,6.86044075%206.44899583,6.86044075%20C6.13199583,6.86044075%205.81199583,6.80744075%205.49599583,6.70244075%20C5.17199583,6.59544075%204.90999583,6.47644075%204.71599583,6.35044075%20L4.11399583,5.95044075%20C3.83299583,5.76344075%203.68699583,5.69944075%203.53599583,5.69944075%20C3.15199583,5.69944075%202.79399583,5.76644075%202.46999583,5.89744075%20C2.14499583,6.02944075%201.86399583,6.21144075%201.63499583,6.43744075%20C1.41499583,6.65244075%201.21899583,6.91444075%201.05299583,7.21544075%20C0.892995826,7.50544075%200.762995826,7.80744075%200.667995826,8.11344075%20C0.574995826,8.41044075%200.497995826,8.73344075%200.437995826,9.07744075%20C0.377995826,9.41744075%200.337995826,9.73944075%200.317995826,10.0354408%20C0.297995826,10.3254408%200.288995826,10.6274408%200.288995826,10.9314408%20C0.288995826,11.7224408%200.533995826,12.3634408%201.01699583,12.8364408%20C1.49399583,13.3024408%202.12599583,13.5394408%202.89399583,13.5394408%20L10.0039958,13.5394408%20C10.7719958,13.5394408%2011.4039958,13.3034408%2011.8809958,12.8364408%20C12.3639958,12.3644408%2012.6089958,11.7234408%2012.6089958,10.9314408%20C12.6089958,10.6254408%2012.5989958,10.3244408%2012.5789958,10.0354408%20L12.5789958,10.0354408%20Z'%20transform='translate(6.448996,%209.619441)%20rotate(63.000000)%20translate(-6.448996,%20-9.619441)%20'%3e%3c/path%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cg%20id='Group'%20transform='translate(36.000000,%200.000000)'%3e%3ccircle%20id='Oval'%20fill='%23FF5C6F'%20fill-rule='nonzero'%20cx='9.979'%20cy='9.979'%20r='9.979'%3e%3c/circle%3e%3cg%20transform='translate(6.000000,%206.000000)'%20id='Path'%20stroke='%23FFFFFF'%20stroke-width='1.247'%3e%3cpath%20d='M4.913,4.134%20L7.556,1.491%20C7.628,1.418%207.668,1.321%207.669,1.218%20C7.669,1.114%207.629,1.018%207.556,0.944%20L7.324,0.713%20C7.251,0.64%207.154,0.6%207.051,0.6%20C6.947,0.6%206.851,0.64%206.777,0.713%20L4.134,3.356%20L1.491,0.713%20C1.42,0.64%201.321,0.6%201.218,0.6%20C1.115,0.6%201.018,0.64%200.945,0.713%20L0.713,0.944%20C0.563,1.095%200.563,1.341%200.713,1.491%20L3.356,4.134%20L0.713,6.777%20C0.64,6.85%200.6,6.947%200.6,7.051%20C0.6,7.154%200.64,7.251%200.713,7.324%20L0.945,7.556%20C1.017,7.629%201.115,7.669%201.218,7.669%20C1.322,7.669%201.418,7.629%201.491,7.556%20L4.134,4.913%20L6.777,7.556%20C6.85,7.629%206.947,7.669%207.051,7.669%20L7.051,7.669%20C7.154,7.669%207.251,7.629%207.324,7.556%20L7.556,7.324%20C7.628,7.251%207.668,7.154%207.668,7.051%20C7.668,6.947%207.628,6.851%207.556,6.777%20L4.913,4.134%20Z'%3e%3c/path%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e", ButtonContainer = qe.div`
  margin: 60px 0 30px 0;

  @media only screen and (max-height: 480px) {
    margin: 10px 0 20px 0;
  }
`, CommonIssuesContainer = qe.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: auto;
  background: #ffffff;
`, InstructionText = qe.p`
  flex: 1;
  text-align: left;
  margin: 0 0 0 21px;
`, Title$6 = qe.h1`
  font-size: 26px;
  line-height: 1.35;
  text-align: center;
  margin-bottom: 48px;

  @media only screen and (max-height: 480px) {
    margin-bottom: 10px;
  }
`, Instruction = qe.div`
  display: flex;
  align-items: center;
  margin-bottom: 18px;
`, customStyles$3 = {
  content: {
    top: "0px",
    left: "0px",
    right: "0px",
    bottom: "0px",
    display: "block"
  },
  overlay: { zIndex: 999996, backgroundColor: "#ffffff" }
};
function CommonIssuesModal({ onClose: me, ...ue }) {
  const { t: Qe } = useTranslation(), Ue = useRef(), [, He] = useState({});
  return useLayoutEffect(() => {
    He({});
  }, []), /* @__PURE__ */ jsxRuntimeExports.jsx(
    Modal,
    {
      className: "IncodeCommonIssuesModal",
      isOpen: !0,
      style: customStyles$3,
      contentLabel: "CommonIssuesModal",
      ariaHideApp: !0,
      ...ue,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        CommonIssuesContainer,
        {
          ref: Ue,
          className: "IncodeCommonIssuesModalContainer",
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "IncodeCommonIssuesModalInstructionsContainer", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(Instruction, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Title$6, { children: Qe("commonIssues.commonIssues") }) }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs(Instruction, { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: outFrame, alt: "out of frame" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(InstructionText, { children: Qe("commonIssues.idFar") })
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs(Instruction, { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: glare, alt: "sun meaning glare" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(InstructionText, { children: Qe("commonIssues.glare") })
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs(Instruction, { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: lens, alt: "Dirty lens" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(InstructionText, { children: Qe("commonIssues.cameraDirty") })
              ] })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonContainer, { className: "IncodeCommonIssuesModalButtonContainer", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              Button$a,
              {
                className: "IncodeCommonIssuesModalTryAgainContainer",
                onClick: me,
                children: Qe("commonIssues.tryAgain")
              }
            ) })
          ]
        }
      )
    }
  );
}
const idLetters = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MjgiIHZpZXdCb3g9IjAgMCA0MCA0MjgiPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBmb250LWZhbWlseT0iQ2lyY3VsYXJTdGQtQm9sZCwgQ2lyY3VsYXIgU3RkIiBmb250LXNpemU9IjE1IiBmb250LXdlaWdodD0iYm9sZCIgbGV0dGVyLXNwYWNpbmc9Ii4xIiBvcGFjaXR5PSIuMiI+CiAgICAgICAgPGcgZmlsbD0iIzAwMCI+CiAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgPHRleHQgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMwMSAtMTk4KSB0cmFuc2xhdGUoMzAxIDE5OC41KSByb3RhdGUoLTkwIDkuNSAyMTMuNSkiPgogICAgICAgICAgICAgICAgICAgIDx0c3BhbiB4PSItMjA0IiB5PSIyMTkiPlogWCAmbHQ7ICZsdDsgWCBaIFggWiBYIFogWCBaIFggWiBYICZsdDsgWiBYIFogWCBaIFggWiBYIFogJmx0OyAmbHQ7ICZsdDsgJmx0OyAmbHQ7ICZsdDsgJmx0OyAmbHQ7IDwvdHNwYW4+CiAgICAgICAgICAgICAgICA8L3RleHQ+CiAgICAgICAgICAgICAgICA8dGV4dCB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzAxIC0xOTgpIHRyYW5zbGF0ZSgzMDEgMTk4LjUpIHJvdGF0ZSgtOTAgMzAuNSAyMTUpIj4KICAgICAgICAgICAgICAgICAgICA8dHNwYW4geD0iLTE4MS41IiB5PSIyMjAuNSI+WiBYIFogWCBaIFggWiBYIFogWCBaIFggWiBYIFogWCBaIFggWiBYIFogWCAmbHQ7ICZsdDsgJmx0OyAmbHQ7ICZsdDsgJmx0OyAmbHQ7ICZsdDsgJmx0OyAmbHQ7ICZsdDs8L3RzcGFuPgogICAgICAgICAgICAgICAgPC90ZXh0PgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K", id = "data:image/png;base64,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", PassportMaskContainer = qe.div`
  display: flex;
  flex-direction: row;
  width: ${(me) => me.width}px;
  height: ${(me) => me.height}px;
  top: ${(me) => me.top}px;
  left: ${(me) => me.left}px;
  position: absolute;
`, Table = qe.table`
  width: 100%;
  height: 100%;
  border-radius: 5px;
  border-spacing: 0;
  box-shadow: 0 0 0 300px rgba(0, 0, 0, 0.75);

  &.mask-animate-stop {
    #first,
    #second {
      animation-name: none;
    }

    #first {
      border: 7.5px white solid;
    }

    #second {
      border-top: 7.5px solid white;
      border-right: 7.5px solid white;
      border-bottom: 7.5px solid white;
    }
  }

  &.mask-green {
    #first {
      border: 7.5px rgb(9, 237, 168) solid;
    }

    #second {
      border-top: 7.5px solid rgb(8, 230, 173);
      border-right: 7.5px solid rgb(8, 230, 173);
      border-bottom: 7.5px solid rgb(8, 230, 173);
    }
  }

  &.mask-blue {
    #first {
      border: 7.5px solid rgb(0, 135, 226);
    }

    #second {
      border-top: 7.5px solid rgb(0, 135, 226);
      border-right: 7.5px solid rgb(0, 135, 226);
      border-bottom: 7.5px solid rgb(0, 135, 226);
    }
  }

  &.mask-red {
    #first {
      border: 7.5px rgb(255, 99, 123) solid;
    }

    #second {
      border-top: 7.5px solid rgb(255, 99, 123);
      border-right: 7.5px solid rgb(255, 99, 123);
      border-bottom: 7.5px solid rgb(255, 99, 123);
    }
  }

  #first {
    width: 70%;
    border-radius: 5px 0 0 5px;
    animation-name: none;
    border: 7.5px transparent solid;
  }

  #second {
    width: 30%;
    border-radius: 0 5px 5px 0;
    animation-name: none;
    border-top: 7.5px transparent solid;
    border-right: 7.5px transparent solid;
    border-bottom: 7.5px transparent solid;
  }
`, Image$5 = qe.img`
  width: 80%;
  position: absolute;
  bottom: 15px;
  right: 15px;
`, ImageLetters = qe.img`
  height: 95%;
`;
function PassportMask(me) {
  const [{ width: ue, height: Qe, top: Ue, left: He }, Ge] = useState({});
  return useEffect(() => {
    Ge(getMaskPosition(!0));
  }, []), /* @__PURE__ */ jsxRuntimeExports.jsx(
    PassportMaskContainer,
    {
      className: "IncodePassportMaskContainer",
      width: ue,
      height: Qe,
      top: Ue,
      left: He,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Table,
        {
          cellSpacing: "0",
          className: `mask-${me.frame} mask-animate-stop`,
          children: [
            me.children,
            /* @__PURE__ */ jsxRuntimeExports.jsx("tbody", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("tr", { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("td", { id: "first", style: { position: "relative" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Image$5, { src: id }) }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "td",
                {
                  id: "second",
                  align: "center",
                  style: {
                    backgroundColor: "rgba(0, 0, 0, 0.2)",
                    backgroundOrigin: "padding-box"
                  },
                  children: /* @__PURE__ */ jsxRuntimeExports.jsx(ImageLetters, { src: idLetters })
                }
              )
            ] }) })
          ]
        }
      )
    }
  );
}
const idOverlayHorizontal = "data:image/svg+xml,%3csvg%20width='506'%20height='318'%20viewBox='0%200%20506%20318'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_3533_44032)'%3e%3crect%20y='318'%20width='318'%20height='506'%20rx='14'%20transform='rotate(-90%200%20318)'%20fill='%2320263D'%20fill-opacity='0.25'/%3e%3cg%20opacity='0.3'%3e%3cg%20clip-path='url(%23clip1_3533_44032)'%3e%3cpath%20d='M173.653%20273.497C173.708%20273.21%20171.68%20258.313%20171.661%20258.012C171.661%20258.012%20167.881%20248.404%20161.908%20247.427C155.933%20246.442%20148.258%20244.355%20145.049%20241.927C143.172%20240.498%20137.058%20238.021%20134.227%20236.99C132.905%20236.51%20130.643%20232.596%20129.866%20230.828C129.081%20229.06%20123.692%20225.485%20122.318%20225.287L122.103%20217.925L137.703%20213.065C137.703%20213.065%20141.722%20211.197%20142.113%20211.197C142.506%20211.197%20140.248%20208.236%20139.958%20207.441C139.664%20206.652%20138.193%20201.281%20138.193%20201.281C138.193%20201.281%20143.46%20207.732%20146.129%20208.94C146.129%20208.94%20140.885%20199.076%20139.324%20193.578C137.755%20188.079%20136.724%20179.49%20136.724%20178.706C136.724%20177.916%20133.491%20154.848%20131.726%20151.021C129.962%20147.187%20127.569%20141.989%20123.471%20139.436C119.376%20136.883%20113.304%20133.248%20104.579%20132.763C104.449%20132.759%20104.318%20132.759%20104.19%20132.745C104.06%20132.756%20103.928%20132.756%20103.795%20132.763C95.0781%20133.25%2089.0061%20136.885%2084.9094%20139.436C80.8183%20141.988%2078.423%20147.189%2076.657%20151.021C74.8939%20154.848%2071.6584%20177.916%2071.6584%20178.706C71.6584%20179.49%2070.7438%20188.426%2069.1759%20193.92C67.608%20199.421%2062.2526%20208.938%2062.2526%20208.938C64.9247%20207.732%2068.6157%20205.936%2068.6157%20205.936C68.6157%20205.936%2068.2908%20207.176%2067.993%20207.963C67.6965%20208.754%2065.8786%20211.197%2066.272%20211.197C66.6597%20211.197%2070.682%20213.065%2070.682%20213.065L86.2862%20217.925L86.0656%20225.287C84.6959%20225.485%2079.3067%20229.063%2078.5213%20230.828C77.7346%20232.596%2075.4783%20236.51%2074.1591%20236.99C71.3212%20238.019%2065.2141%20240.498%2063.3357%20241.927C60.1199%20244.356%2052.4632%20246.442%2046.4825%20247.427C40.5061%20248.403%2036.7297%20257.339%2036.7297%20257.339C36.7072%20257.643%2034.6828%20273.21%2034.7334%20273.497L173.653%20273.497Z'%20fill='white'/%3e%3c/g%3e%3crect%20x='39.7314'%20y='268.502'%20width='170.164'%20height='128.921'%20rx='12.3652'%20transform='rotate(-90%2039.7314%20268.502)'%20stroke='white'%20stroke-width='10'/%3e%3c/g%3e%3crect%20opacity='0.3'%20x='34.7305'%20y='58.8635'%20width='10'%20height='387.461'%20rx='5'%20transform='rotate(-90%2034.7305%2058.8635)'%20fill='white'/%3e%3cg%20opacity='0.3'%3e%3crect%20x='199.699'%20y='144.372'%20width='10'%20height='154.116'%20rx='5'%20transform='rotate(-90%20199.699%20144.372)'%20fill='white'/%3e%3crect%20x='199.699'%20y='234.372'%20width='10'%20height='124.812'%20rx='5'%20transform='rotate(-90%20199.699%20234.372)'%20fill='white'/%3e%3crect%20x='199.699'%20y='174.372'%20width='10'%20height='65.1194'%20rx='5'%20transform='rotate(-90%20199.699%20174.372)'%20fill='white'/%3e%3crect%20x='199.699'%20y='204.372'%20width='10'%20height='95.5085'%20rx='5'%20transform='rotate(-90%20199.699%20204.372)'%20fill='white'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_3533_44032'%3e%3crect%20y='318'%20width='318'%20height='506'%20rx='14'%20transform='rotate(-90%200%20318)'%20fill='white'/%3e%3c/clipPath%3e%3cclipPath%20id='clip1_3533_44032'%3e%3crect%20x='34.7314'%20y='273.502'%20width='180.164'%20height='138.921'%20rx='17.3652'%20transform='rotate(-90%2034.7314%20273.502)'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", idOverlayVertical = "data:image/svg+xml,%3csvg%20width='318'%20height='506'%20viewBox='0%200%20318%20506'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='318'%20y='506'%20width='318'%20height='506'%20rx='14'%20transform='rotate(-180%20318%20506)'%20fill='%2320263D'%20fill-opacity='0.25'/%3e%3cg%20opacity='0.3'%3e%3cg%20clip-path='url(%23clip0_3515_43908)'%3e%3cpath%20d='M273.498%20332.348C273.211%20332.293%20258.314%20334.32%20258.012%20334.34C258.012%20334.34%20248.405%20338.119%20247.428%20344.093C246.443%20350.068%20244.355%20357.743%20241.927%20360.952C240.499%20362.829%20238.021%20368.943%20236.991%20371.774C236.511%20373.096%20232.597%20375.358%20230.829%20376.135C229.061%20376.92%20225.486%20382.309%20225.287%20383.683L217.926%20383.898L213.066%20368.298C213.066%20368.298%20211.198%20364.279%20211.198%20363.888C211.198%20363.495%20208.237%20365.752%20207.441%20366.043C206.653%20366.337%20201.282%20367.808%20201.282%20367.808C201.282%20367.808%20207.733%20362.541%20208.94%20359.871C208.94%20359.871%20199.076%20365.116%20193.579%20366.677C188.079%20368.246%20179.491%20369.277%20178.707%20369.277C177.917%20369.277%20154.849%20372.51%20151.022%20374.274C147.188%20376.039%20141.99%20378.432%20139.437%20382.53C136.883%20386.625%20133.249%20392.697%20132.763%20401.421C132.759%20401.552%20132.759%20401.683%20132.745%20401.81C132.756%20401.941%20132.756%20402.073%20132.763%20402.205C133.25%20410.923%20136.886%20416.995%20139.437%20421.091C141.988%20425.182%20147.189%20427.578%20151.022%20429.344C154.849%20431.107%20177.917%20434.342%20178.707%20434.342C179.491%20434.342%20188.427%20435.257%20193.921%20436.825C199.421%20438.393%20208.939%20443.748%20208.939%20443.748C207.733%20441.076%20205.937%20437.385%20205.937%20437.385C205.937%20437.385%20207.177%20437.71%20207.964%20438.008C208.755%20438.304%20211.198%20440.122%20211.198%20439.729C211.198%20439.341%20213.066%20435.319%20213.066%20435.319L217.926%20419.715L225.287%20419.935C225.486%20421.305%20229.064%20426.694%20230.829%20427.479C232.597%20428.266%20236.511%20430.522%20236.991%20431.842C238.02%20434.68%20240.499%20440.787%20241.927%20442.665C244.357%20445.881%20246.443%20453.538%20247.428%20459.518C248.403%20465.495%20257.34%20469.271%20257.34%20469.271C257.644%20469.294%20273.211%20471.318%20273.498%20471.267L273.498%20332.348Z'%20fill='white'/%3e%3c/g%3e%3crect%20x='268.502'%20y='466.269'%20width='170.164'%20height='128.921'%20rx='12.3652'%20transform='rotate(-180%20268.502%20466.269)'%20stroke='white'%20stroke-width='10'/%3e%3c/g%3e%3crect%20opacity='0.3'%20x='58.8633'%20y='471.269'%20width='10'%20height='387.461'%20rx='5'%20transform='rotate(-180%2058.8633%20471.269)'%20fill='white'/%3e%3cg%20opacity='0.3'%3e%3crect%20x='144.372'%20y='306.3'%20width='10'%20height='154.116'%20rx='5'%20transform='rotate(-180%20144.372%20306.3)'%20fill='white'/%3e%3crect%20x='234.372'%20y='306.3'%20width='10'%20height='124.812'%20rx='5'%20transform='rotate(-180%20234.372%20306.3)'%20fill='white'/%3e%3crect%20x='174.372'%20y='306.3'%20width='10'%20height='65.1194'%20rx='5'%20transform='rotate(-180%20174.372%20306.3)'%20fill='white'/%3e%3crect%20x='204.372'%20y='306.3'%20width='10'%20height='95.5085'%20rx='5'%20transform='rotate(-180%20204.372%20306.3)'%20fill='white'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_3515_43908'%3e%3crect%20x='273.502'%20y='471.269'%20width='180.164'%20height='138.921'%20rx='17.3652'%20transform='rotate(-180%20273.502%20471.269)'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", pulseBorder = We`
0% {
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55), inset 0 0 0 5px transparent;
}

100% {
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55), inset 0 0 0 5px white;
}
`, MaskContainer = qe.canvas`
  position: fixed;
  border-radius: 15px;
  width: ${(me) => me.width}px;
  height: ${(me) => me.height}px;
  top: ${(me) => me.top}px;
  left: ${(me) => me.left}px;

  ${(me) => me.showIDOverlay && `background: url(${idOverlayVertical}) center center no-repeat;`}

  &.mask-white {
    backface-visibility: hidden;
    perspective: 1000;
    transform: translateZ(0);
    animation-name: none;
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55), inset 0 0 0 5px white;
  }

  &.mask-green {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(9, 237, 168);

    div {
      display: none;
    }
  }

  &.mask-blue {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(60, 176, 247);

    div {
      display: none;
    }
  }

  &.mask-red {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(255, 99, 123);

    div {
      display: none;
    }
  }

  &.mask-animate-stop {
    animation-name: none;
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55), inset 0 0 0 5px white;

    .sc-fznKkj {
      animation-name: none;
    }
  }
`, MaskContainerKiosk = qe.canvas`
  position: absolute;
  border-radius: 36px;
  width: ${"calc(100% - 20%)"};
  height: ${"calc(100% - 30%)"};
  top: 15%;
  left: 10%;

  ${(me) => me.showIDOverlay && `
    background: url(${idOverlayHorizontal}) center center no-repeat;
    background-size: cover;
  `}

  &.mask-white {
    backface-visibility: hidden;
    perspective: 1000;
    transform: translateZ(0);
    animation-name: none;
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55), inset 0 0 0 5px white;
  }

  &.mask-green {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(9, 237, 168);

    div {
      display: none;
    }
  }

  &.mask-blue {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(60, 176, 247);

    div {
      display: none;
    }
  }

  &.mask-red {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(255, 99, 123);

    div {
      display: none;
    }
  }

  &.mask-animate-stop {
    animation-name: none;
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55), inset 0 0 0 5px white;
  }
`, MaskContainerKioskVertical = qe.canvas`
  position: absolute;
  border-radius: 36px;
  width: ${(me) => me.width}px;
  height: ${(me) => me.height}px;
  top: ${(me) => me.top}px;
  left: ${(me) => me.left}px;

  ${(me) => me.showIDOverlay && `
    background: url(${idOverlayHorizontal}) center center no-repeat;
    background-size: cover;
  `}

  &.mask-white {
    backface-visibility: hidden;
    perspective: 1000;
    transform: translateZ(0);
    animation-name: none;
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55), inset 0 0 0 5px white;
  }

  &.mask-green {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(9, 237, 168);

    div {
      display: none;
    }
  }

  &.mask-blue {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(60, 176, 247);

    div {
      display: none;
    }
  }

  &.mask-red {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(255, 99, 123);

    div {
      display: none;
    }
  }

  &.mask-animate-stop {
    animation-name: none;
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55), inset 0 0 0 5px white;
  }
`, MaskContainerHorizontal = qe.canvas`
  position: fixed;
  border-radius: 15px;
  width: ${window.innerWidth - 2 * window.innerWidth / 20}px;
  height: ${window.innerHeight / 3}px;
  top: ${(me) => me.top ? `${me.top}px` : "15%"};
  left: ${window.innerWidth / 20}px;

  ${(me) => me.showIDOverlay && `
    background: url(${idOverlayHorizontal}) center center no-repeat;
    background-size: cover;
  `}

  &.mask-white {
    backface-visibility: hidden;
    perspective: 1000;
    transform: translateZ(0);
    animation-name: none;
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55), inset 0 0 0 5px white;
  }

  &.mask-green {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(9, 237, 168);

    div {
      display: none;
    }
  }

  &.mask-blue {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(60, 176, 247);

    div {
      display: none;
    }
  }

  &.mask-red {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(255, 99, 123);

    div {
      display: none;
    }
  }

  &.mask-animate-stop {
    animation-name: none;
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55), inset 0 0 0 5px white;
  }
`, MaskBarcode = qe.canvas`
  position: fixed;
  border-radius: 15px;
  width: ${window.innerWidth / 2}px;
  height: ${(me) => me.height - 50}px;
  top: 10%;
  left: 200px;
  transform: translate(-50%, 0);

  &.mask-white {
    backface-visibility: hidden;
    perspective: 1000;
    animation-name: none;
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55), inset 0 0 0 5px white;
  }

  &.mask-green {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(9, 237, 168);

    div {
      display: none;
    }
  }

  &.mask-blue {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(60, 176, 247);

    div {
      display: none;
    }
  }

  &.mask-red {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(255, 99, 123);

    div {
      display: none;
    }
  }

  &.mask-animate-stop {
    animation-name: none;
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55), inset 0 0 0 5px white;

    .sc-fznKkj {
      animation-name: none;
    }
  }
`, DesktopMask = qe.canvas`
  position: fixed;
  border-radius: 15px;
  height: 638px;
  width: 1016px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  &.mask-white {
    backface-visibility: hidden;
    perspective: 1000;
    animation-name: ${pulseBorder};
    animation-iteration-count: infinite;
    animation-timing-function: ease;
    animation-direction: alternate;
    animation-duration: 0.5s;
  }

  &.mask-green {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(9, 237, 168);

    div {
      display: none;
    }
  }

  &.mask-blue {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(60, 176, 247);

    div {
      display: none;
    }
  }

  &.mask-red {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55),
      inset 0 0 0 5px rgb(255, 99, 123);

    div {
      display: none;
    }
  }

  &.mask-animate-stop {
    animation-name: none;
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.55), inset 0 0 0 5px white;

    .sc-fznKkj {
      animation-name: none;
    }
  }
`;
function Mask({ type: me, showIDOverlay: ue, isKiosk: Qe = !1, ...Ue }) {
  const [{ width: He, height: Ge, top: Xe, left: Ke }, $e] = useState({});
  return useEffect(() => {
    $e(Qe ? getKioskMaskPosition() : getMaskPosition());
  }, [Qe]), Ue.show ? Qe ? me === "verticalKiosk" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    MaskContainerKioskVertical,
    {
      className: classNames("IncodeMaskContainerKiosk", {
        [`mask-${Ue.frame}`]: !0,
        "mask-animate-stop": !Ue.animate
      }),
      height: Ge,
      width: He,
      top: Xe,
      left: Ke,
      showIDOverlay: ue,
      children: Ue.children
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    MaskContainerKiosk,
    {
      top: Xe,
      className: classNames("IncodeMaskContainerKiosk", {
        [`mask-${Ue.frame}`]: !0,
        "mask-animate-stop": !Ue.animate
      }),
      showIDOverlay: ue,
      children: Ue.children
    }
  ) : ["horizontal"].includes(me) ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    MaskContainerHorizontal,
    {
      top: Ue.top,
      className: classNames("IncodeMaskContainerHorizontal", {
        [`mask-${Ue.frame}`]: !0,
        "mask-animate-stop": !Ue.animate
      }),
      showIDOverlay: ue,
      children: Ue.children
    }
  ) : me === "passport" ? /* @__PURE__ */ jsxRuntimeExports.jsx(PassportMask, { className: "IncodePassportMask", ...Ue }) : me === "desktop" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    DesktopMask,
    {
      className: classNames("IncodeDesktopMask", {
        [`mask-${Ue.frame}`]: !0,
        "mask-animate-stop": !Ue.animate
      })
    }
  ) : ["vertical", "id"].includes(me) ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    MaskContainer,
    {
      className: classNames("IncodeMaskContainer", {
        [`mask-${Ue.frame}`]: !0,
        "mask-animate-stop": !Ue.animate
      }),
      height: Ge,
      width: He,
      top: Xe,
      left: Ke,
      showIDOverlay: ue,
      children: Ue.children
    }
  ) : me === "barcode" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    MaskBarcode,
    {
      top: Ue.top,
      className: classNames("IncodeMaskBarcode", {
        [`mask-${Ue.frame}`]: !0,
        "mask-animate-stop": !Ue.animate
      }),
      children: Ue.children
    }
  ) : null : null;
}
__webpack_exports__GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${__webpack_exports__version}/pdf.worker.min.mjs`;
const Text$2 = qe.p`
  font-style: normal;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 21px;
  text-align: center;
  color: #20263d;
  padding: 0 30px;
`, Title$5 = qe.h1`
  font-style: normal;
  font-weight: bold;
  font-size: 1.5625rem;
  line-height: 35px;
  text-align: center;
  color: #20263d;
  margin: 0;
`, RetakeContainer = qe.div`
  display: flex;
  flex-direction: column;
  width: auto;
  height: 100%;
  background-color: #fff;
  padding: 50px 0px;
`, ImageContainer = qe.section`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  max-height: 100%;
  height: auto;
  overflow: hidden;
  text-align: center;
  flex: 1;
`, Image$4 = qe.img`
  border-radius: 15px;
  box-sizing: border-box;
  object-fit: contain;
  transition: 0.4s linear;
  transition-property: border, border-color;
  box-shadow: 0px 10px 8px 0px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  object-fit: contain;
  max-width: 80%;
  max-height: 100%;
  width: auto;
  margin: auto;
`, ButtonsContainer$3 = qe.section`
  height: 20%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
`, RetakeButton = qe.button`
  background-color: transparent;
  width: 150px;
  height: 60px;
  font-size: 1rem;
  font-weight: bolder;
  border: none;
  display: flex;
  flex-direction: row;
  max-width: 150px;
  align-items: center;
  justify-content: center;

  @media only screen and (max-width: 350px) {
    font-size: 12px;
  }
`, CustomButton$1 = qe(Button$a)`
  min-width: 175px;
  height: 60px;
  font-size: 1.188rem;
  text-transform: uppercase;

  @media only screen and (max-width: 350px) {
    font-size: 12px;
    min-width: 160px;
  }
`, RetakeParagraph = qe.p`
  text-align: center;
  text-transform: uppercase;
`, StyledDocument = qe(Document$1)`
  width: 80%;
  height: 100%;
`, StyledPage = qe(Page)`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;

  canvas {
    width: auto !important;
    height: 100% !important;
  }
`, customStyles$2 = {
  content: {
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    margin: "0",
    padding: "0",
    border: "none",
    background: "#fff",
    overflow: "auto"
  },
  overlay: {
    zIndex: 1e3,
    backgroundColor: "#fff"
  }
}, StyledBackImage = () => {
  const me = new URLSearchParams(window.location.search), Qe = me.get("darkMode") || me.get("darkTheme") ? "#FFF" : "#000";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "8",
      height: "12",
      viewBox: "0 0 8 12",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Back Image" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("g", { fill: "none", "fill-rule": "evenodd", children: /* @__PURE__ */ jsxRuntimeExports.jsx("g", { fill: Qe, "fill-rule": "nonzero", children: /* @__PURE__ */ jsxRuntimeExports.jsx("g", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            d: "M7.783 5.532L1.723.192C1.583.068 1.396 0 1.196 0S.81.068.67.192L.223.585c-.29.256-.29.672 0 .928l5.089 4.485-5.094 4.489c-.14.123-.218.288-.218.464 0 .176.077.34.218.464l.446.393c.14.124.327.192.527.192s.386-.068.526-.192l6.066-5.345c.14-.124.217-.29.217-.465 0-.177-.077-.342-.217-.466z",
            transform: "translate(-50 -660) matrix(-1 0 0 1 58 660)"
          }
        ) }) }) })
      ]
    }
  );
};
function Retake({
  fileType: me = "",
  imageBase64: ue,
  onClose: Qe,
  handleCapture: Ue,
  token: He,
  type: Ge
}) {
  const { t: Xe } = useTranslation(), Ke = cameraScreenNamesMapper[Ge], $e = eventModuleNames[Ke];
  useEffect(() => {
    addScreenEvent({
      module: $e,
      screen: eventScreenNames[`${Ke}CameraCapture`],
      token: He,
      shouldOpen: !1
    }), addScreenEvent({
      module: $e,
      screen: eventScreenNames[`${Ke}ReviewPhoto`],
      token: He,
      shouldOpen: !0
    });
  }, []);
  function Je() {
    addEvent({
      token: He,
      code: "retakeContinue"
    }), addScreenEvent({
      module: $e,
      screen: eventScreenNames[`${Ke}ReviewPhoto`],
      token: He,
      shouldOpen: !1
    }), Ue();
  }
  function Ze() {
    addEvent({
      token: He,
      code: "retakeTryAgain"
    }), addScreenEvent({
      module: $e,
      screen: eventScreenNames[`${Ke}ReviewPhoto`],
      token: He,
      shouldOpen: !1
    }), addScreenEvent({
      module: $e,
      screen: eventScreenNames[`${Ke}CameraCapture`],
      token: He,
      shouldOpen: !0
    }), Qe();
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Modal, { isOpen: !0, style: customStyles$2, contentLabel: "retake", ariaHideApp: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(RetakeContainer, { className: "IncodeRetakeContainer", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "aria-live": "assertive", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Title$5, { className: "IncodeRetakeTitle", children: Xe("retake.title") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { className: "IncodeRetakeSubtitle", children: Xe("retake.instructions") })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ImageContainer,
      {
        "aria-label": "capture preview",
        className: "IncodeRetakeImageContainer",
        children: me === "application/pdf" ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          StyledDocument,
          {
            file: ue,
            "aria-label": "copy of the document you've uploaded",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledPage, { pageNumber: 1 })
          }
        ) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Image$4,
          {
            className: "IncodeRetakeImage",
            src: ue,
            alt: "copy of the document you've uploaded"
          }
        ) })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      ButtonsContainer$3,
      {
        className: "IncodeRetakeButtonsContainer",
        "aria-label": "buttons container",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(RetakeButton, { className: "IncodeRetakeButton", onClick: Ze, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(StyledBackImage, {}),
            /* @__PURE__ */ jsxRuntimeExports.jsx(RetakeParagraph, { children: Xe("common.retake") })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            CustomButton$1,
            {
              role: "button",
              className: "IncodeRetakeContinueContainer",
              onClick: Je,
              children: Xe("common.continue")
            }
          )
        ]
      }
    )
  ] }) });
}
const DesktopCaptureButton = "data:image/svg+xml,%3csvg%20width='76'%20height='76'%20viewBox='0%200%2076%2076'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='icon%20/%20big%20/%20capture'%3e%3cpath%20id='Combined%20Shape'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M38%2076C58.9868%2076%2076%2058.9868%2076%2038C76%2017.0132%2058.9868%200%2038%200C17.0132%200%200%2017.0132%200%2038C0%2058.9868%2017.0132%2076%2038%2076ZM38%2071C56.2254%2071%2071%2056.2254%2071%2038C71%2019.7746%2056.2254%205%2038%205C19.7746%205%205%2019.7746%205%2038C5%2056.2254%2019.7746%2071%2038%2071Z'%20fill='%2320263D'/%3e%3ccircle%20id='Oval%20Copy%202'%20cx='38'%20cy='38'%20r='28'%20fill='%2320263D'/%3e%3c/g%3e%3c/svg%3e", questionsMaskIcon = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='23'%20height='23'%20viewBox='0%200%2023%2023'%3e%3cg%20fill='none'%20fill-rule='evenodd'%3e%3cg%20fill='%2321273B'%3e%3cg%3e%3cpath%20d='M56.5%207C62.851%207%2068%2012.149%2068%2018.5S62.851%2030%2056.5%2030%2045%2024.851%2045%2018.5%2050.149%207%2056.5%207zm-.261%2015.176c-.852%200-1.53.64-1.53%201.421S55.388%2025%2056.24%2025c.851%200%201.548-.622%201.548-1.403s-.697-1.42-1.548-1.42zM56.432%2012C53.568%2012%2052%2013.847%2052%2015.765c0%20.266.02.55.097.8l2.438.088c-.058-.16-.077-.355-.077-.568%200-.995.6-2.007%201.974-2.007%201.297%200%201.936.781%201.936%201.598%200%20.533-.252%201.013-.833%201.403l-.929.64c-1.103.763-1.529%201.633-1.529%202.575%200%20.266.04.497.078.728h2.09v-.107c0-.728.368-1.278%201.045-1.722l.794-.515c1.142-.746%201.916-1.74%201.916-3.144C61%2013.74%2059.432%2012%2056.432%2012z'%20transform='translate(-329%20-579)%20translate(284%20572)'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e", isSurface = isSurfaceTablet(), QuestionMarkImg = qe.img`
  margin-left: 5px;
`, NativeButton = qe.button`
  background-color: #ffffff;
  border-radius: 7px;
  bottom: 15px;
  color: #21273b;
  display: flex;
  font-size: 11px;
  font-weight: bold;
  height: 37px;
  padding: 5px 7px 6px 9px;
  position: fixed;
  right: 15px;
  z-index: 99999;
  line-height: normal;
  border: none;
`, moveIn$1 = We`
  0% {
    bottom: -200px;
  }

  80% {
    bottom: 6%;
  }

  100% {
    bottom: 5%;
  }
`, fadeIn = We`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`, FakeButtonContainer = qe.div`
  position: absolute;
  text-align: center;
  left: 50%;
  transform: translateX(-50%);
  animation: ${moveIn$1} 1s ease-in forwards;
`, FakeButtonMessage = qe.div`
  opacity: 0;
  animation: ${fadeIn} 1s ease-in 0.5s forwards;
  border: 2px solid transparent;
  padding: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  color: white;
  min-width: 200px;
  white-space: pre-wrap;
  margin-bottom: 20px;
  position: relative;
`, FakeButtonArrowDown = qe.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid black;
  bottom: -12px;
  width: 0;
  opacity: 0.5;
  height: 0;
`, backgroundImageStyle = Ae`
  background-repeat: no-repeat;
  background-size: contain;
`, FakeButton$1 = qe.button`
  width: 76px;
  height: 76px;
  margin: auto;
  border: none;
  cursor: pointer;
  background-color: transparent;
  background-size: cover;
  ${(me) => me.surface && Ae`
      width: 150px;
      height: 150px;
      ${backgroundImageStyle}
    `}
  ${(me) => me.desktop && backgroundImageStyle}
`, CaptureContainer = qe.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: #f9faff;

  &.kiosk {
    background-color: transparent;
    border-radius: 36px;
    overflow: hidden;
  }
`, WebcamContainer = qe.div`
  border: 8px solid #e9e9eb;
  border-radius: 36px;
  overflow: hidden;
  width: 687px;
  height: 440px;
  position: relative;

  &.kiosk {
    height: 500px;
    position: relative;
    border: none;
  }

  &.neutral {
    border: 8px solid #00b2fd;
  }

  &.error {
    border: 8px solid #ff5c6f;
  }

  &.success {
    border: 8px solid #0cd5a2;
  }

  &.surface {
    width: 1030.5px;
    height: 660px;
  }
`, TakenPicture = qe.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: blur(${(me) => me.shouldBlurImage ? 8 : 0}px);
`, CaptureKioskFeedback = qe.h1`
  position: absolute;
  bottom: 50px;
  font-size: 24px;
`, CaptureFeedback = qe.h2`
  margin-bottom: 25px;
`, CaptureFeedbackContainer = qe.div`
  position: absolute;
  bottom: 50px;
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  text-align: center;
  button {
  margin: auto;
  }
`, NotificationsTitle = qe.h1`
  background-color: #f9faff;
  position: absolute;
  top: 60px;
  margin: 0;
  left: 50%;
  transform: translate(-50%, -50%);

  &.surface {
    top: 25%;
  }

  &.kiosk {
    background: none;
  }
`, Opacity = qe.div`
  position: absolute;
  height: 100%;
  width: 100%;
  opacity: 0.3;
  background-color: #fff;
`, SLEEP_DURATION = 2e3, ZOOM_WAIT_DURATION = 500, SUCESS_SLEEP_DURATION = 300;
let manualCaptureTimeout, showFillRectangleNorificationTimeout;
function getIdType(me, ue) {
  return me === "back" ? "BackId" : ue ? "Passport" : "FrontId";
}
function CaptureId({
  getInstructionsNotification: me = emptyFunc,
  shouldTakeIdAgain: ue = emptyFunc,
  type: Qe,
  onError: Ue,
  onSuccess: He,
  numberOfTries: Ge,
  onLog: Xe,
  onlyFront: Ke,
  permission: $e,
  setPermission: Je,
  permissionMessage: Ze,
  permissionBackgroundColor: nt,
  token: tt,
  sendBase64: et,
  stream: rt,
  onlyCapture: it,
  timeout: ot = 18e3,
  showCustomCameraPermissionScreen: at,
  isRetry: st,
  isSecondId: ut,
  hideRetake: lt,
  isRecordingEnabled: dt = !1,
  onRestartOnboarding: At,
  showDoublePermissionsRequest: pt,
  isCreditCard: gt,
  isCreditCardBack: wt,
  onStreamReady: Bt,
  deviceId: Tt,
  showAutoCaptureIDOverlay: yt = !1,
  showManualCaptureIDOverlay: Ct = !1,
  defaultHorizontalMask: ht = !1,
  isFixedMask: It = !1,
  goNextCameraStep: vt,
  isKiosk: Et = !1,
  ageAssurance: bt = !1,
  publishAudio: Rt = !1,
  zoomLevel: St = 1
}) {
  const kt = tt == null ? void 0 : tt.token, [jt, Pt] = useState("white"), [Qt, qt] = useState(!1), _t = useRef(void 0), [Yt, Xt] = useState(0), [Ut, Lt] = useState(0), [Ot, ft] = useState(null), [Dt, Mt] = useState(!1), [Ft, Gt] = useState(""), [, zt] = useState(""), [$t, Ht] = useState(!1), [hn, un] = useState(!1), [An, mn] = useState(!1), [, En] = useState(!1), [Jt, an] = useState(0), [cn, dn] = useState(!1), [, yn] = useState(!1), [Nn, Rn] = useState(!1), [rn, ln] = useState(""), [pn, Sn] = useState(!1), [In, Bn] = useState(null), [Pn, Yn] = useState(!1), [or, mr] = useState(!1), lr = useRef(!1), [Mr, ai] = useSessionState(null), Un = cameraScreenNamesMapper[Qe], qn = eventModuleNames[Un], [hr, Vr] = useState({
    isOpen: !1,
    canvas: null
  }), Pr = useRef(void 0), [Er, xr] = useState(""), kr = useRef(null), Rr = useRef(!1), sr = useRef(!1), br = useRef(null), Gr = useRef(!0), [on, bn] = useState("vertical"), { t: vn } = useTranslation(), { showNotification: Ln, showPriorityNotification: Jn, closeNotification: nr } = useNotifications(), { startRecording: ir, stopRecording: Zn } = useMediaRecorder({
    token: kt,
    type: `${Qe}Id`
  });
  function Wr(Vn) {
    Bt == null || Bt(Vn), dt && ir(Vn);
  }
  const { notificationMessage: Or, notificationVariant: pr } = me(), yr = useRef(null), vi = !!isWebRtcSupported(), Kn = getIdType(Qe, Ke);
  useAutoFocus(yr);
  const Td = () => Et ? pn ? "horizontalKiosk" : "verticalKiosk" : mobile.any() ? pn ? "horizontal" : Ke ? "passport" : "vertical" : "desktop";
  useEffect(() => {
    bn(Td());
  }, []);
  const Ts = async (Vn, Cr) => {
    nr(), Pt("blue"), clearTimeout(manualCaptureTimeout), clearTimeout(showFillRectangleNorificationTimeout), sr.current = !1, Xe(
      getLogObject(`capturing${Kn}`, {
        message: "Hold still. Capturing..."
      })
    ), _t.current !== vn("notifications.takingPhoto") && (addEvent({
      token: tt == null ? void 0 : tt.token,
      module: "ID capture",
      code: "cameraFeedbackDisplayed",
      screen: `${Kn} Camera Capture`,
      payload: {
        feedback: "Hold still. Capturing..."
      }
    }), _t.current = vn("notifications.takingPhoto")), Jn(
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { textAlign: "center" }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: vn("notifications.dontMove") }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: vn("notifications.takingPhoto") })
      ] }),
      "dontMove"
    ), await sleep(SLEEP_DURATION), nr(), Ds(Vn, Cr), !it && (await sleep(SLEEP_DURATION), Wi());
  }, Wi = async () => {
    var ro, ml;
    if (mobile.isDesktop())
      return;
    const Vn = (ro = document.querySelector("video")) == null ? void 0 : ro.srcObject, Cr = Vn == null ? void 0 : Vn.getVideoTracks()[0];
    Pr.current = (ml = Cr == null ? void 0 : Cr.getSettings()) == null ? void 0 : ml.zoom;
    const $r = await zoomCameraToTheMax(
      document.querySelector("video").srcObject
    );
    if (mobile.iOS() && !$r) {
      await no(Cr);
      return;
    }
    await sleep(ZOOM_WAIT_DURATION);
    const yi = yr.current.getCanvas();
    if (!yi) {
      await no(Cr);
      return;
    }
    const zo = yi.getImageData(), oi = yi.getBase64Image();
    logFrame({
      base64Image: oi,
      token: tt == null ? void 0 : tt.token,
      source: sources[Qe]
    }), await MlWasmJSApi$1.allocateImageBuffers(zo.width, zo.height), (await MlWasmJSApi$1.runIdCapture(zo)).quad.size() > 0 && addDeviceStats(tt == null ? void 0 : tt.token, {
      virtualCameraDetected: !0
    }), await no(Cr);
  }, no = async (Vn) => {
    Pr.current && (await zoomCamera(Vn, Pr.current), await sleep(ZOOM_WAIT_DURATION), Pr.current = Vn.getSettings().zoom);
  }, zc = () => {
    Xe(
      getLogObject("IDNotDetected", {
        message: `${vn("notifications.couldntCapture")}`
      })
    ), Qt || Jn(Or, pr);
  }, cf = (Vn) => {
    const Cr = vn(Vn ? "notifications.glareDetectedChange" : "notifications.glareDetected");
    Cr === vn("notifications.glareDetectedChange") && _t.current !== Cr && (Xe(
      getLogObject("glareDetectedChanged", {
        message: vn("notifications.glareDetected")
      })
    ), addEvent({
      token: tt == null ? void 0 : tt.token,
      code: "cameraFeedbackDisplayed",
      module: "ID capture",
      screen: `${Kn} Camera Capture`,
      payload: {
        feedback: "Change light conditions"
      }
    }), _t.current = Cr), Xe(
      getLogObject("glareDetected", {
        message: vn("notifications.glareDetected")
      })
    ), Jn(
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { textAlign: "center" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: Cr }) }),
      "Focus"
    );
  }, Bs = (Vn) => {
    const Cr = vn(Vn ? "notifications.outOfFocusChange" : "notifications.outOfFocus");
    Cr === vn("notifications.outOfFocusChange") && _t.current !== Cr && (addEvent({
      token: tt == null ? void 0 : tt.token,
      code: "cameraFeedbackDisplayed",
      module: "ID capture",
      screen: `${Kn} Camera Capture`,
      payload: {
        feedback: "Focusing camera"
      }
    }), Xe(
      getLogObject("outOfFocus", {
        message: vn(Vn ? "notifications.outOfFocusChange" : "notifications.outOfFocus")
      })
    ), _t.current = Cr), Jn(
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { textAlign: "center" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: Cr }) }),
      "Focus"
    );
  }, uf = () => {
    lr.current || (lr.current = !0);
  }, Rs = () => {
    Jn(
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { textAlign: "center" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: vn("notifications.fitOverlay") }) }),
      ""
    ), Xe(
      getLogObject("fitOverlay", {
        message: vn("notifications.fitOverlay")
      })
    );
  };
  let Na = !1;
  const Xc = (Vn, Cr, $r, yi = "") => {
    Qt || Na || (yi !== Er && (Na = !0, setTimeout(() => {
      Na = !1;
    }, 1e3), xr(yi), yi !== "vertical" && bn(yi)), Yn(Vn), Sn(Cr), Bn($r));
  }, dl = () => {
    nr(), sr.current = !1, Gr.current = !1, qt(!0), Yn(!0), Sn(Et ?? !1), Xe(getLogObject("manualCaptureOn", {})), clearTimeout(showFillRectangleNorificationTimeout), addEvent({
      token: kt,
      code: `switchToManualCapture${Kn}`,
      payload: { [`manualCapture${Kn}`]: !0 }
    }), Xe(
      getLogObject("switchToManualCapture", {
        message: vn("Switched to manual capture")
      })
    );
  };
  let Os = !1;
  const fl = (Vn) => {
    Os || Vn !== on && (Os = !0, setTimeout(() => {
      Os = !1;
    }, 1e3), bn(Vn === "passport" ? Vn : Td));
  }, hl = (Vn) => {
  }, Kc = async () => {
    kr.current = new IdCapture(), await kr.current.initialize({
      onCapturing: Ts,
      onFarAway: Rs,
      onGlare: cf,
      onBlur: Bs,
      onIDNotDetected: zc,
      onMaskChange: Xc,
      onDetectionStarted: uf,
      onSwitchToManualCapture: dl,
      onIDTypeChange: fl,
      onIDSideChange: hl,
      idType: Kn,
      isFixedMask: It,
      isBlurCheckEnabled: !1,
      isGlareCheckEnabled: !1,
      pipelineProfile: detectionSetup.getProfile(DetectionType.IDCapture),
      autocaptureTimeout: ot
    });
  };
  useEffect(() => (document.body.style.position = "fixed", () => {
    document.body.style.position = "unset";
  }), []), useEffect(() => () => {
    Zn();
  }, []), useEffect(() => {
    Er && (addEvent({
      token: kt,
      code: "idOrientationChanged",
      module: "ID capture",
      payload: {
        orientation: Er
      }
    }), Xe(
      getLogObject("idOrientationChanged", {
        message: "ID orientation changed"
      })
    ));
  }, [Er]), useEffect(() => {
    addScreenEvent({
      module: qn,
      screen: eventScreenNames[`${Un}CameraCapture`],
      token: kt,
      shouldOpen: !0
    }), Xe(
      getLogObject("lookingForID", {
        message: vn(`Looking for ${Kn}`)
      })
    );
  }, []), useEffect(() => {
    if (!(!mobile.isDesktop() && !Et) && Dt) {
      const Vn = setTimeout(() => {
        Od(Ot);
      }, 1500);
      return () => clearInterval(Vn);
    }
  }, [Dt, ks, Ot]), useEffect(() => {
    Qt && _t.current !== vn("captureInstructions.step2") && (addEvent({
      token: tt == null ? void 0 : tt.token,
      code: "cameraFeedbackDisplayed",
      module: "ID capture",
      screen: `${Kn} Camera Capture`,
      payload: {
        feedback: "Press capture button"
      }
    }), Xe(
      getLogObject("cameraFeedbackDisplayed", {
        message: vn("Press capture button")
      })
    ), _t.current = vn("captureInstructions.step2"));
  }, [Qt]);
  const Ns = useCallback(async () => {
    if (!(!sr.current || Rr.current)) {
      Rr.current = !0, kr.current || await Kc();
      try {
        await MlWasmJSApi$1.handleDetectionCallAndUpdateState(
          detectionSetup.getProfile(DetectionType.IDCapture).pipelineType
        );
        const Vn = yr.current.getCanvas();
        if (!Vn)
          return;
        await kr.current.detect(Vn);
      } catch (Vn) {
        console.error(Vn);
      } finally {
        Rr.current = !1;
      }
    }
  }, [Kc]);
  useEffect(() => (onFrameEmitter.on("newFrame", Ns), () => {
    onFrameEmitter.off("newFrame", Ns);
  }), [Ns]);
  const qo = useCallback(() => {
    sr.current || (sr.current = !0, yr.current.video.play());
  }, []);
  useEffect(() => {
    cn && (dn(!1), Qt || qo());
  }, [qo, Qt, cn]), useEffect(() => (Rn(!0), () => {
    var Vn;
    Rn(!1), sr.current = !1, !rt && (Vn = yr.current) != null && Vn.mediaStreamTrack && yr.current.mediaStreamTrack.stop();
  }), [rt]), useEffect(() => {
    addEvent({
      token: kt,
      code: `camera${Kn}`,
      payload: { [`camera${Kn}`]: !0 }
    });
  }, [Kn, kt]);
  const pl = async (Vn) => {
    Ln(
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { textAlign: "center" }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: vn("notifications.couldntCapture") }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: vn("notifications.verifyLater") })
      ] }),
      "skip"
    ), await sleep(SLEEP_DURATION), Xe(
      getLogObject("noAttemps", {
        response: br.current,
        message: "No attempt left"
      })
    ), nr(), Vn && Vn();
  }, lf = async ({
    key: Vn,
    value: Cr
  }) => {
    try {
      await updateSession({
        token: kt,
        key: Vn,
        value: Cr
      }), yn(!1);
    } catch {
      yn(!1);
    }
  }, df = () => {
    if (yn(!1), nr(), an(Jt + 1), En(!1), Ge !== -1 && Jt + 1 >= Ge)
      return lf({
        key: "manualIdCheckNeeded",
        value: !0
      }), pl(
        () => Ue({ ...br.current, type: "skip" })
      );
    dn(!0);
  }, ff = () => {
    var Vn;
    return yn(!1), En(!1), dn(!1), nr(), Xe(
      getLogObject("successCapture", {
        response: br.current
      })
    ), (Vn = br.current) != null && Vn.showMandatoryConsent ? (vt(br.current), !0) : (He(br.current), !0);
  }, Bd = () => {
    nr(), Ht(!0);
  }, Rd = Xt, Ds = async (Vn, Cr) => {
    if (clearTimeout(manualCaptureTimeout), manualCaptureTimeout = void 0, !Vn)
      return;
    ks(), addEvent({
      token: kt,
      code: Qt ? `manualCapture${Kn}` : `capture${Kn}`,
      payload: { [`manualCapture${Kn}`]: !0 }
    });
    const $r = Vn.getBase64Image(), { blob: yi, url: zo } = Vn.getBlobData();
    if (Gt(zo), Bd(), await OnboardingAnalytics$1.analyzeFrame($r), MlWasmJSApi$1.resetAllPipelines(), it)
      return He({ imageBase64: $r, blob: yi, url: zo });
    if (bt && un(!0), Qt || addScreenEvent({
      module: qn,
      screen: eventScreenNames[`${Un}CameraCapture`],
      token: kt,
      shouldOpen: !1
    }), addScreenEvent({
      module: qn,
      screen: eventScreenNames[`${Un}UploadProgress`],
      token: kt,
      shouldOpen: !0
    }), gt || wt) {
      const { success: oi } = await gt ? await addCreditCardFront({
        token: kt,
        base64Image: $r
      }) : await addCreditCardBack({
        token: kt,
        base64Image: $r
      });
      addScreenEvent({
        module: qn,
        screen: eventScreenNames[`${Un}UploadProgress`],
        token: kt,
        shouldOpen: !1
      }), oi ? (addScreenEvent({
        module: qn,
        screen: eventScreenNames[`${Un}UploadSuccess`],
        token: kt,
        shouldOpen: !0
      }), ft(!0), await sleep(SLEEP_DURATION), addScreenEvent({
        module: qn,
        screen: eventScreenNames[`${Un}UploadSuccess`],
        token: kt,
        shouldOpen: !1
      }), Xe(
        getLogObject("captureSucessful", {
          message: vn(`Capture for ${Kn} was successful`)
        })
      ), Pt("white")) : (addScreenEvent({
        module: qn,
        screen: eventScreenNames[`${Un}AttemptFailed`],
        token: kt,
        shouldOpen: !0
      }), Xe(
        getLogObject("attemptFailed", {
          attempt: Jt + 1
        })
      ), ft(!1), ln("error"), await sleep(SLEEP_DURATION), addScreenEvent({
        module: qn,
        screen: eventScreenNames[`${Un}AttemptFailed`],
        token: kt,
        shouldOpen: !1
      }), addScreenEvent({
        module: qn,
        screen: eventScreenNames[`${Un}CameraCapture`],
        token: kt,
        shouldOpen: !0
      }), Pt("white")), Mt(!0), Xt(100);
    } else
      addEvent({
        token: tt == null ? void 0 : tt.token,
        code: "cameraFeedbackDisplayed",
        module: "ID capture",
        screen: `${Kn}image inspection`,
        payload: {
          feedback: "Inspecting..."
        }
      }), Xe(
        getLogObject("inspecting", {
          message: vn(`Inspecting ${Kn}...`)
        })
      ), addEvent({
        token: tt == null ? void 0 : tt.token,
        code: "captureAttemptFinished",
        module: `ID capture ${Kn}`,
        payload: {
          logs: OnboardingAnalytics$1.getPipelineLogs()
        }
      }), (Kn === "FrontId" || Kn === "Passport") && addDeviceStats(tt == null ? void 0 : tt.token, {
        frontIdStatsAnalysisStatus: OnboardingAnalytics$1.getAnalysisStatus(),
        backIdStatsAnalysisStatus: "",
        selfieStatsAnalysisStatus: "",
        motionStatus: OnboardingAnalytics$1.getMotionStatus()
      }), Kn === "BackId" && addDeviceStats(tt == null ? void 0 : tt.token, {
        frontIdStatsAnalysisStatus: "",
        backIdStatsAnalysisStatus: OnboardingAnalytics$1.getAnalysisStatus(),
        selfieStatsAnalysisStatus: "",
        motionStatus: OnboardingAnalytics$1.getMotionStatus()
      }), await sleep(ZOOM_WAIT_DURATION), await capture({
        token: kt,
        image: et ? $r : yi,
        type: Qe,
        onProgress: Rd,
        sendBase64: et,
        onlyFront: Ke,
        isRetry: st,
        isSecondId: ut,
        encrypted: !1,
        faceCoordinates: void 0,
        imageType: void 0,
        shouldSkipGlareBack: Mr == null ? void 0 : Mr.skipGlareBack,
        shouldSkipGlareFront: Mr == null ? void 0 : Mr.skipGlareFront,
        ...Cr && {
          glare: Cr.glare,
          sharpness: Cr.sharpness
        }
      }).then(async (oi) => {
        var Dd;
        const { skipGlareBack: Xo, skipGlareFront: ro } = oi;
        (Xo || ro) && ai({
          ...Mr,
          skipGlareBack: Xo,
          skipGlareFront: ro
        });
        const io = await getImages$1({
          token: kt,
          body: { images: ["croppedIDFace", ...bt ? [Kn === "BackId" ? "croppedBackID" : "croppedFrontID"] : []] },
          onDownloadProgress: ($c) => Lt($c)
        }).catch(() => ({
          croppedIDFace: "",
          croppedFrontID: "",
          croppedBackID: ""
        }));
        if (br.current = {
          ...oi,
          originalImage: $r,
          frontIdImage: $r,
          backIdImage: io.croppedBackID,
          ...io
        }, bt && (io.croppedFrontID || io.croppedBackID)) {
          const $c = (Dd = IncodeCanvas == null ? void 0 : IncodeCanvas.base64ToBlob(
            io.croppedFrontID ?? io.croppedBackID
          )) == null ? void 0 : Dd.url, Jc = document.createElement("img");
          Jc.src = $c, Jc.onload = () => {
            mn(Jc.width > Jc.height);
          }, Gt($c);
        }
        un(!1);
        const { status: Nd, message: Yc, errorKey: Af } = ue(
          oi
        );
        addScreenEvent({
          module: qn,
          screen: eventScreenNames[`${Un}UploadProgress`],
          token: kt,
          shouldOpen: !1
        }), Xe(
          getLogObject(`uploading${Kn}`, {
            message: vn(`Uploading ${Kn}`)
          })
        );
        const gf = (oi == null ? void 0 : oi.skipGlareFront) && Kn === "FrontId", mf = (oi == null ? void 0 : oi.skipGlareBack) && Kn === "BackId";
        Nd && !gf && !mf ? (addScreenEvent({
          module: qn,
          screen: eventScreenNames[`${Un}AttemptFailed`],
          token: kt,
          shouldOpen: !0
        }), Xe(
          getLogObject("attemptFailed", {
            response: br.current,
            message: Yc,
            reason: Af,
            attempt: Jt + 1
          })
        ), addEvent({
          token: tt == null ? void 0 : tt.token,
          code: "captureStatusDisplayed",
          module: "ID capture",
          screen: `${Kn} image inspection`,
          payload: {
            capture_status: "Scan failed",
            feedback: Yc
          }
        }), ft(!1), ln(Yc), addScreenEvent({
          module: qn,
          screen: eventScreenNames[`${Un}AttemptFailed`],
          token: kt,
          shouldOpen: !1
        }), addScreenEvent({
          module: qn,
          screen: eventScreenNames[`${Un}CameraCapture`],
          token: kt,
          shouldOpen: !0
        }), Pt("white")) : (addScreenEvent({
          module: qn,
          screen: eventScreenNames[`${Un}UploadSuccess`],
          token: kt,
          shouldOpen: !0
        }), addEvent({
          token: tt == null ? void 0 : tt.token,
          code: "captureStatusDisplayed",
          screen: `${Kn} image inspection`,
          module: "ID capture",
          payload: {
            capture_status: "Scan succeeded",
            feedback: "Success!"
          }
        }), Xe(
          getLogObject(`${Kn}UploadSuccessful`, {
            message: vn(`${Kn} capture was successful`)
          })
        ), zt(io.croppedFace), ft(!0), await sleep(SUCESS_SLEEP_DURATION), addScreenEvent({
          module: qn,
          screen: eventScreenNames[`${Un}UploadSuccess`],
          token: kt,
          shouldOpen: !1
        }), Pt("white")), !Nd && Mt(!0);
      }).catch(async (oi) => {
        const { message: Xo, errorKey: ro } = ue(
          oi.response.data
        );
        addScreenEvent({
          module: qn,
          screen: eventScreenNames[`${Un}AttemptFailed`],
          token: kt,
          shouldOpen: !0
        }), Xe(
          getLogObject("attemptFailed", {
            response: oi.response.data,
            message: Xo,
            reason: ro,
            attempt: Jt + 1
          })
        ), mn(!1), ln(Xo), ft(!1), Xt(100), addScreenEvent({
          module: qn,
          screen: eventScreenNames[`${Un}AttemptFailed`],
          token: kt,
          shouldOpen: !1
        }), addScreenEvent({
          module: qn,
          screen: eventScreenNames[`${Un}CameraCapture`],
          token: kt,
          shouldOpen: !0
        }), Pt("white");
      }).finally(() => {
      });
  }, hf = async () => {
    Xc(!0, ht, !1), sr.current = !1, Jn(Or, pr), Qt || (await sleep(SLEEP_DURATION), qo());
  }, Od = (Vn) => {
    Vn ? ff() : df(), ln(""), Ht(!1), un(!1), mn(!1), Xt(0), Mt(!1), ft(null), Pt("white");
  }, Al = async () => {
    var Vn, Cr;
    if (!Qt) {
      if (St && Et) {
        const $r = (Vn = document.querySelector("video")) == null ? void 0 : Vn.srcObject, yi = $r == null ? void 0 : $r.getVideoTracks()[0];
        yi && await zoomCamera(yi, St);
      }
      (Cr = yr.current) == null || Cr.setIsLoadingCamera(!1), hf();
    }
  };
  function Ps() {
    or ? (Qt || qo(), addEvent({
      token: kt,
      code: "tryAgainSelected",
      screen: "ID capture help",
      module: "ID capture"
    }), addScreenEvent({
      module: qn,
      screen: eventScreenNames[`${Un}Help`],
      token: kt,
      shouldOpen: !1
    }), addScreenEvent({
      module: qn,
      screen: eventScreenNames[`${Un}CameraCapture`],
      token: kt,
      shouldOpen: !0
    }), Xe(getLogObject("commonIssuesClosed", {}))) : (addEvent({
      token: kt,
      code: "needHelpSelected",
      screen: `${Kn} Camera Capture`,
      module: "ID capture"
    }), addScreenEvent({
      module: qn,
      screen: eventScreenNames[`${Un}CameraCapture`],
      token: kt,
      shouldOpen: !1
    }), addScreenEvent({
      module: qn,
      screen: eventScreenNames[`${Un}Help`],
      token: kt,
      shouldOpen: !0
    }), Xe(getLogObject("commonIssuesOpened", {})), sr.current = !1), mr(!or);
  }
  function gl() {
    if (Ge !== -1 && Jt >= Ge) return;
    const Vn = yr.current.getCanvas();
    Vn.updateBase64Image(), Vn.updateBlob(), lt ? Ds(Vn) : Vr({
      isOpen: !0,
      canvas: Vn
    });
  }
  function ks() {
    Vr({
      isOpen: !1,
      canvas: null
    });
  }
  if (!Nn)
    return null;
  if (Et)
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        NotificationsTitle,
        {
          className: classNames({
            surface: isSurface,
            kiosk: !0
          }),
          children: !$t && !hr.isOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Notification,
            {
              inline: !0,
              center: !0,
              noPortal: !0,
              isKiosk: Et
            }
          )
        }
      ),
      vi && /* @__PURE__ */ jsxRuntimeExports.jsxs(
        CaptureContainer,
        {
          className: classNames({
            kiosk: !0
          }),
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs(
              WebcamContainer,
              {
                className: classNames({
                  [$t ? Ot == null ? "neutral" : Ot ? "success" : "error" : ""]: !0,
                  surface: isSurface,
                  kiosk: !0
                }),
                children: [
                  $t ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
                    hn ? /* @__PURE__ */ jsxRuntimeExports.jsx(Opacity, {}) : null,
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      TakenPicture,
                      {
                        src: Ft,
                        shouldBlurImage: hn
                      }
                    )
                  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      Webcam,
                      {
                        ref: yr,
                        onPlay: Al,
                        videoSource: "environment",
                        permission: $e,
                        setPermission: Je,
                        permissionMessage: Ze,
                        permissionBackgroundColor: nt,
                        onLog: Xe,
                        stream: rt,
                        onError: Ue,
                        token: kt,
                        type: Kn,
                        interviewId: tt == null ? void 0 : tt.interviewId,
                        showCustomCameraPermissionScreen: at,
                        onStreamReady: dt ? ir : void 0,
                        isRecordingEnabled: dt,
                        onRestartOnboarding: At,
                        showDoublePermissionsRequest: pt,
                        deviceId: Tt,
                        className: "kiosk",
                        isKiosk: !0
                      }
                    ),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      Mask,
                      {
                        className: "IncodeCaptureIdMask",
                        show: Pn,
                        top: In,
                        frame: jt,
                        animate: !Qt,
                        type: on,
                        showIDOverlay: !Qt && yt || Qt && Ct || yt && Ct,
                        isKiosk: !0
                      }
                    )
                  ] }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "step__video-overlay" }),
                  Qt && hr.isOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(
                    Retake,
                    {
                      imageBase64: hr.canvas.getBase64Image(1, !0),
                      onClose: ks,
                      handleCapture: () => Ds(hr.canvas),
                      token: kt,
                      type: Qe
                    }
                  )
                ]
              }
            ),
            Qt && !$t && /* @__PURE__ */ jsxRuntimeExports.jsxs(FakeButtonContainer, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs(FakeButtonMessage, { children: [
                `${vn("captureInstructions.step1")} 
 ${vn(
                  "captureInstructions.step2"
                )}`,
                /* @__PURE__ */ jsxRuntimeExports.jsx(FakeButtonArrowDown, {})
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                FakeButton$1,
                {
                  surface: isSurface,
                  onClick: () => gl(),
                  "aria-label": vn("manualCapture.ariaLabel"),
                  children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "img",
                    {
                      src: isSurface ? DesktopCaptureButton : CaptureButton,
                      alt: vn("manualCapture.ariaLabel")
                    }
                  )
                }
              )
            ] }),
            $t && /* @__PURE__ */ jsxRuntimeExports.jsx(CaptureKioskFeedback, { children: rn || vn("desktopHome.uploading") })
          ]
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("canvas", { id: "canvasFrame" })
    ] });
  function pf() {
    return bt ? (Yt + Ut) / 200 * 100 : Yt;
  }
  return mobile.isDesktop() ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    or && /* @__PURE__ */ jsxRuntimeExports.jsx(CommonIssuesModal, { onClose: Ps }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      NotificationsTitle,
      {
        className: classNames({
          surface: isSurface
        }),
        children: !$t && !hr.isOpen ? /* @__PURE__ */ jsxRuntimeExports.jsx(Notification, { inline: !0, center: !0, noPortal: !0 }) : /* @__PURE__ */ jsxRuntimeExports.jsx(HiddenTitle, { children: "Capture Front ID" })
      }
    ),
    !$t && /* @__PURE__ */ jsxRuntimeExports.jsxs(NativeButton, { onClick: Ps, role: "button", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Trans, { t: vn, i18nKey: "commonIssues.needHelp", children: [
        "Need ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
        " Help"
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        QuestionMarkImg,
        {
          src: questionsMaskIcon,
          alt: "question mark",
          "aria-hidden": !0
        }
      )
    ] }),
    vi && /* @__PURE__ */ jsxRuntimeExports.jsxs(CaptureContainer, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        WebcamContainer,
        {
          className: classNames({
            [$t ? Ot == null ? "neutral" : Ot ? "success" : "error" : ""]: !0,
            surface: isSurface
          }),
          children: [
            $t ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
              hn ? /* @__PURE__ */ jsxRuntimeExports.jsx(Opacity, {}) : null,
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                TakenPicture,
                {
                  alt: vn("capturePreview.ariaLabel"),
                  src: Ft,
                  shouldBlurImage: hn
                }
              )
            ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              Webcam,
              {
                ref: yr,
                onPlay: Al,
                videoSource: "environment",
                permission: $e,
                setPermission: Je,
                permissionMessage: Ze,
                permissionBackgroundColor: nt,
                onLog: Xe,
                stream: rt,
                onError: Ue,
                token: kt,
                type: Kn,
                interviewId: tt == null ? void 0 : tt.interviewId,
                showCustomCameraPermissionScreen: at,
                onStreamReady: dt ? ir : void 0,
                isRecordingEnabled: dt,
                onRestartOnboarding: At,
                showDoublePermissionsRequest: pt,
                deviceId: Tt,
                publishAudio: Rt
              }
            ) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "step__video-overlay" }),
            Qt && hr.isOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(
              Retake,
              {
                imageBase64: hr.canvas.getBase64Image(1, !0),
                onClose: ks,
                handleCapture: () => Ds(hr.canvas),
                token: kt,
                type: Qe
              }
            )
          ]
        }
      ),
      Qt && !$t && /* @__PURE__ */ jsxRuntimeExports.jsxs(FakeButtonContainer, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(FakeButtonMessage, { children: [
          `${vn("captureInstructions.step1")} 
 ${vn(
            "captureInstructions.step2"
          )}`,
          /* @__PURE__ */ jsxRuntimeExports.jsx(FakeButtonArrowDown, {})
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          FakeButton$1,
          {
            desktop: !0,
            onClick: () => gl(),
            "aria-label": vn("manualCapture.ariaLabel"),
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              "img",
              {
                src: DesktopCaptureButton,
                alt: vn("manualCapture.ariaLabel")
              }
            )
          }
        )
      ] }),
      $t && /* @__PURE__ */ jsxRuntimeExports.jsxs(CaptureFeedbackContainer, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(CaptureFeedback, { children: rn || vn("desktopHome.uploading") }),
        rn && /* @__PURE__ */ jsxRuntimeExports.jsx(Button$a, { onClick: () => Mt(!0), children: Jt >= Ge - 1 ? vn("common.continue") : vn("common.tryAgain") })
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("canvas", { id: "canvasFrame" })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    !$t && /* @__PURE__ */ jsxRuntimeExports.jsxs(
      NativeButton,
      {
        className: "IncodeCaptureIdNativeButton",
        onClick: Ps,
        role: "button",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Trans, { t: vn, i18nKey: "commonIssues.needHelp", children: [
            "Need ",
            /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
            " Help"
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            QuestionMarkImg,
            {
              className: "IncodeCaptureIdQuestionMarkImg",
              src: questionsMaskIcon,
              alt: "question mark"
            }
          )
        ]
      }
    ),
    or && /* @__PURE__ */ jsxRuntimeExports.jsx(CommonIssuesModal, { onClose: Ps }),
    vi && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Webcam,
        {
          className: "IncodeCaptureIdWebcam",
          ref: yr,
          onPlay: Al,
          videoSource: "environment",
          permission: $e,
          setPermission: Je,
          permissionMessage: Ze,
          permissionBackgroundColor: nt,
          onLog: Xe,
          stream: rt,
          onError: Ue,
          token: kt,
          interviewId: tt == null ? void 0 : tt.interviewId,
          type: Kn,
          showCustomCameraPermissionScreen: at,
          onStreamReady: Wr,
          isRecordingEnabled: dt,
          onRestartOnboarding: At,
          showDoublePermissionsRequest: pt,
          publishAudio: Rt
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Mask,
        {
          className: "IncodeCaptureIdMask",
          show: Pn,
          top: In,
          frame: jt,
          animate: !Qt,
          type: on,
          showIDOverlay: !Qt && yt || Qt && Ct || yt && Ct
        }
      ),
      Qt && hr.isOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(
        Retake,
        {
          imageBase64: hr.canvas.getBase64Image(1, !0),
          onClose: ks,
          handleCapture: () => Ds(hr.canvas),
          token: kt,
          type: Qe
        }
      ),
      Qt && /* @__PURE__ */ jsxRuntimeExports.jsxs(
        FakeButtonContainer,
        {
          className: "IncodeCaptureIdFakeButton",
          role: "region",
          "aria-live": "assertive",
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs(FakeButtonMessage, { className: "IncodeCaptureIdFakeButtonMessage", children: [
              `${vn("captureInstructions.step1")} 
 ${vn(
                "captureInstructions.step2"
              )}`,
              /* @__PURE__ */ jsxRuntimeExports.jsx(FakeButtonArrowDown, { className: "IncodeCaptureIdFakeButtonArrowDown" })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              FakeButton$1,
              {
                className: "IncodeCaptureIdFakeButtonImage",
                onClick: () => gl(),
                "aria-label": vn("manualCapture.ariaLabel"),
                children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: CaptureButton, alt: vn("manualCapture.ariaLabel") })
              }
            )
          ]
        }
      ),
      $t && /* @__PURE__ */ jsxRuntimeExports.jsx(
        CapturePreview,
        {
          message: rn,
          progress: pf(),
          finishCapture: Dt,
          captureSuccessful: Ot,
          onClose: Od,
          imageBase64: Ft,
          isSelfie: !1,
          isPassport: Ke,
          shouldRotate: An,
          shouldBlurImage: hn,
          ageAssurance: bt,
          resumeAutocapture: () => Mt(!0),
          numberOfTries: Ge,
          timesCaptureFailed: Jt
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "step__video-overlay" }),
      !$t && !hr.isOpen && !Qt && /* @__PURE__ */ jsxRuntimeExports.jsx(Notification, { inline: !1, center: !0 })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("canvas", { id: "canvasFrame" })
  ] });
}
const CaptureIdWithChooseCamera = (me) => {
  var He;
  const [ue, Qe] = useDeviceId();
  function Ue(Ge) {
    Qe(Ge);
  }
  return mobile.any() || ue === "error" ? /* @__PURE__ */ jsxRuntimeExports.jsx(CaptureId, { ...me }) : ue ? /* @__PURE__ */ jsxRuntimeExports.jsx(CaptureId, { ...me, deviceId: ue }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    ChooseCamera,
    {
      onCameraChosen: Ue,
      token: (He = me.token) == null ? void 0 : He.token
    }
  );
}, CaptureID = preloadScript$4(CaptureIdWithChooseCamera);
function CaptureBackId(me) {
  const { t: ue } = useTranslation(), [Qe] = useSessionState(null), Ue = useRef(void 0), He = ({
    sharpness: Xe,
    glare: Ke,
    classification: $e,
    failReason: Je
  }) => {
    if (Je === "ID_TYPE_UNACCEPTABLE")
      return {
        status: !0,
        message: ue("notifications.idTypeUnacceptable")
      };
    if (Je === "WRONG_DOCUMENT_SIDE")
      return {
        status: !0,
        message: ue("notifications.wrongSide")
      };
    if (!$e)
      return {
        status: !0,
        message: ue("notifications.backClassificationFailed")
      };
    const Ze = mobile.isDesktop() ? -1 : 10, nt = 10;
    return Xe < Ze ? {
      status: !0,
      message: ue("notifications.lowSharpness")
    } : Ke < nt && !(Qe != null && Qe.skipGlareBack) ? {
      status: !0,
      message: ue("notifications.glareDetected")
    } : { status: !1, message: "" };
  }, Ge = (Xe) => {
    var $e;
    if (me.scanPdf417)
      return {
        notificationMessage: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { textAlign: "center" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: ue("notifications.showBack.pdf417") }) })
      };
    const Ke = ue(Xe ? "notifications.showBackLowEnd.one" : "notifications.showBack.one");
    return me.onLog && me.onLog(
      getLogObject("showBack", {
        message: Ke
      })
    ), Ue.current !== Ke && (addEvent({
      token: ($e = me == null ? void 0 : me.token) == null ? void 0 : $e.token,
      code: "cameraFeedbackDisplayed",
      payload: {
        feedback: "Fill frame with front id"
      },
      module: "ID capture",
      screen: "Back ID camera capture"
    }), Ue.current = Ke), {
      notificationMessage: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { textAlign: "center" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: Ke }) }),
      notificationVariant: "rotate"
    };
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CaptureID,
    {
      ...me,
      shouldTakeIdAgain: He,
      type: backType,
      getInstructionsNotification: Ge,
      isCreditCardBack: me.type === "creditCardBack"
    }
  );
}
function CaptureAndTutorial$3(me) {
  const { currentStep: ue, nextStep: Qe } = useSteps(), Ue = me.type === "creditCardBack" ? TutorialCreditCardBack : TutorialBack;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Steps, { currentStep: ue, children: [
    me.showTutorial && isWebRtcSupported() && /* @__PURE__ */ jsxRuntimeExports.jsx(
      Ue,
      {
        className: "IncodeCaptureBackIdTutorial",
        ...me,
        onSuccess: Qe,
        token: me.token
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(CaptureBackId, { ...me })
  ] });
}
const TutorialSelfieHeader = ({ ageAssurance: me }) => {
  const { t: ue } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(TutorialSHeader, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: ue(`tutorial.${me ? "ageAssurance" : "selfie1"}`) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("section", { children: me ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: ue("tutorial.ageAssurance2") }) : /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: `${ue("tutorial.selfie2")} ${ue("tutorial.selfie3")}` }) })
  ] });
};
function TutorialSelfie({
  onSuccess: me,
  token: ue = {},
  ageAssurance: Qe = !1,
  ...Ue
}) {
  const { t: He } = useTranslation(), Ge = () => options.darkMode ? "https://sdk.incode.com/sdk/tutorials/selfie-dark.mp4" : "https://sdk.incode.com/sdk/tutorials/selfie.gif";
  useEffect(() => {
    ue != null && ue.token && addEvent({
      token: ue.token,
      code: "tutorialSelfie",
      payload: { tutorialSelfie: !0 }
    });
  }, [ue == null ? void 0 : ue.token]);
  function Xe() {
    addEvent({
      token: ue == null ? void 0 : ue.token,
      code: "continue"
    }), me();
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Tutorial,
    {
      ...Ue,
      token: ue || {},
      selfie: !0,
      src: Ge(),
      header: /* @__PURE__ */ jsxRuntimeExports.jsx(TutorialSelfieHeader, { ageAssurance: Qe }),
      type: "selfie",
      ageAssurance: Qe,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonsContainer$4, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        StyledButton,
        {
          className: classNames("IncodeTutorialButton", "IncodeTutorialButtonSelfie"),
          onClick: Xe,
          children: He("common.continue")
        }
      ) })
    }
  );
}
const CaptureButtonContainer = qe(CaptureButtonContainer$2)`
  position: absolute;
`, SelfieContainer = qe.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 65%;
  background-color: #f9faff;
`, Container$3 = qe.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`, Selfie$1 = ({
  onBoarding: me,
  onError: ue,
  onSuccess: Qe,
  permission: Ue,
  setPermission: He,
  permissionMessage: Ge,
  permissionBackgroundColor: Xe,
  onLog: Ke,
  token: $e,
  timeout: Je,
  numberOfTries: Ze,
  stream: nt,
  onlyCapture: tt,
  showCustomCameraPermissionScreen: et,
  isSecondId: rt,
  isRecordingEnabled: it = !1,
  skipProcessFace: ot = !1,
  deviceId: at
}) => {
  var Ut;
  const st = $e ? $e.token : (Ut = me.state.token) == null ? void 0 : Ut.token, ut = useRef(null), lt = useRef(!1), [dt, At] = useState({}), { startRecording: pt, stopRecording: gt } = useMediaRecorder({
    token: st,
    type: "selfie"
  });
  useEffect(() => () => {
    gt == null || gt();
  }, [gt]);
  const wt = throttle$1(
    async (Lt, Ot) => {
      var Dt;
      const ft = Lt.getBase64Image();
      try {
        addScreenEvent({
          module: eventModuleNames.selfie,
          screen: eventScreenNames.faceCaptureCamera,
          token: st,
          shouldOpen: !0
        }), clearTimeout(qt.current), Et(""), me.addEvent({
          code: "selfieCapture",
          token: st
        }), await OnboardingAnalytics$1.analyzeFrame(ft), MlWasmJSApi$1.resetAllPipelines();
        const Mt = me.selfieType, Ft = await MlWasmJSApi$1.encryptImage(ft), { blob: Gt, url: zt } = Lt.getBlobData();
        if (tt)
          return Qe({ imageBase64: ft, blob: Gt, encryptedImage: Ft, url: zt });
        addScreenEvent({
          module: eventModuleNames.selfie,
          screen: eventScreenNames.faceCaptureCamera,
          token: st,
          shouldOpen: !1
        }), addScreenEvent({
          module: eventModuleNames.selfie,
          screen: eventScreenNames.faceCaptureUpload,
          token: st,
          shouldOpen: !0
        }), addEvent({
          token: st,
          code: "captureAttemptFinished",
          module: "selfieCapture",
          payload: {
            logs: OnboardingAnalytics$1.getPipelineLogs()
          }
        }), addDeviceStats(st, {
          inspectorOpened: null,
          frontIdStatsAnalysisStatus: "",
          backIdStatsAnalysisStatus: "",
          selfieStatsAnalysisStatus: OnboardingAnalytics$1.getAnalysisStatus(),
          motionStatus: OnboardingAnalytics$1.getMotionStatus()
        });
        const $t = await me.capture({
          token: st,
          image: Ft,
          type: Mt,
          encrypted: !0,
          faceCoordinates: Ot
        }), Ht = selfieChecks($t);
        if (Ht.hasErrors) {
          addScreenEvent({
            module: eventModuleNames.selfie,
            screen: eventScreenNames.faceCaptureUpload,
            token: st,
            shouldOpen: !1
          }), addScreenEvent({
            module: eventModuleNames.selfie,
            screen: eventScreenNames.faceCaptureError,
            token: st,
            shouldOpen: !0
          }), ht("error"), logSelfieChecks($t, Ht, Ke, Et, Bt), addScreenEvent({
            module: eventModuleNames.selfie,
            screen: eventScreenNames.faceCaptureError,
            token: st,
            shouldOpen: !1
          }), At({
            response: $t,
            livenessPassed: Ht.livenessPassed,
            imageBase64: ft
          }), !Qt && Rt();
          return;
        }
        Et(Bt("notifications.processing"));
        const { faceMatch: hn, existingUser: un, ...An } = await Ct();
        return addScreenEvent({
          module: eventModuleNames.selfie,
          screen: eventScreenNames.faceCaptureUpload,
          token: st,
          shouldOpen: !1
        }), addScreenEvent({
          module: eventModuleNames.selfie,
          screen: eventScreenNames.faceCaptureSuccess,
          token: st,
          shouldOpen: !0
        }), Ke(
          getLogObject("successCapture", {
            response: $t,
            message: "Selfie uploaded successfully"
          })
        ), Et(Bt("notifications.success")), await sleep(3500), addScreenEvent({
          module: eventModuleNames.selfie,
          screen: eventScreenNames.faceCaptureSuccess,
          token: st,
          shouldOpen: !1
        }), Qe({
          ...$t,
          ...An,
          faceMatch: hn,
          existingUser: un,
          liveness: Ht.livenessPassed,
          imageBase64: ft
        });
      } catch (Mt) {
        addScreenEvent({
          module: eventModuleNames.selfie,
          screen: eventScreenNames.faceCaptureUpload,
          token: st,
          shouldOpen: !1
        }), addScreenEvent({
          module: eventModuleNames.selfie,
          screen: eventScreenNames.faceCaptureError,
          token: st,
          shouldOpen: !0
        }), bt(
          Mt.response ? Mt.response.data : Bt("notifications.serverError")
        ), ht("error"), await sleep(3e3), addScreenEvent({
          module: eventModuleNames.selfie,
          screen: eventScreenNames.faceCaptureError,
          token: st,
          shouldOpen: !1
        }), At({
          response: (Dt = Mt == null ? void 0 : Mt.response) == null ? void 0 : Dt.data,
          livenessPassed: null,
          imageBase64: ft
        }), !Qt && Rt();
      }
    },
    300
  ), { t: Bt } = useTranslation(), Tt = (Lt, Ot, ft, Dt) => {
    me.updateSession({
      token: st,
      key: "manualSelfieCheckNeeded",
      value: !0
    });
    const Mt = getLogObject("skip", {
      existingUser: Lt,
      liveness: Ot,
      imageBase64: ft,
      faceMatch: Dt
    });
    Ke(Mt), ue(Mt);
  };
  async function yt({
    response: Lt,
    livenessPassed: Ot,
    imageBase64: ft
  }) {
    me.addEvent({
      code: "noAttempts",
      token: st
    }), Ke(
      getLogObject("noAttemps", {
        response: Lt,
        message: "No attempt left"
      })
    );
    const { faceMatch: Dt, existingUser: Mt } = await Ct();
    return Tt(Mt, Ot, ft, Dt);
  }
  async function Ct() {
    if (ot)
      return {
        faceMatch: !1
      };
    const Lt = await me.processFace({
      token: st
    });
    rt && await me.processFaceSecondId({
      token: st
    });
    const Ot = Lt.confidence === 1, ft = Lt.existingUser;
    return { faceMatch: Ot, existingUser: ft, ...Lt };
  }
  const {
    setMode: ht,
    resetLoading: It,
    notificationMessage: vt,
    setNotificationMessage: Et,
    handleError: bt,
    startAutoDetect: Rt,
    handleManualCapture: St,
    isSuccess: kt,
    isError: jt,
    isLoading: Pt,
    shouldShowManualCapture: Qt,
    selfieTimeoutRef: qt,
    hideCamera: _t
  } = useSelfie({
    timeout: Je,
    onLog: Ke,
    handleCapture: wt,
    handleNoAttempsLeft: yt,
    numberOfTries: Ze,
    webcam: ut,
    token: st,
    isDetecting: lt,
    onSwitchManualCapture: () => {
      Et(""), me.addEvent({
        code: "switchToManualCaptureSelfie",
        token: st
      });
    },
    onManualCaptureSelfie: () => {
      me.addEvent({
        code: "manualCaptureSelfie",
        token: st
      });
    }
  }), Yt = Pt ? Bt("notifications.uploading") : vt, Xt = Pt || jt || kt;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Container$3, { className: "IncodeCaptureDesktopSelfieContainer", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(SrOnlyHeading, { children: Bt("selfie.title") }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(SelfieContainer, { className: "IncodeCaptureDesktopSelfieSelfieContainer", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        FaceMask$1,
        {
          className: "IncodeCaptureDesktopSelfieFaceMask",
          isCapturing: kt,
          isLoading: Pt,
          error: jt,
          isUploading: Xt,
          desktop: !0,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            FaceFrame$1,
            {
              src: faceFrame$1,
              alt: "face frame",
              className: classNames("IncodeCaptureDesktopSelfieFaceFrame", {
                hidden: _t
              })
            }
          )
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Webcam,
        {
          className: "IncodeCaptureDesktopSelfieWebcam",
          ref: ut,
          onPlay: () => {
          },
          videoSource: "user",
          isSelfie: !0,
          type: "desktopSelfie",
          permission: Ue,
          setPermission: He,
          permissionMessage: Ge,
          permissionBackgroundColor: Xe,
          onLog: Ke,
          stream: nt,
          onError: ue,
          token: st,
          interviewId: $e == null ? void 0 : $e.interviewId,
          onStreamReady: it ? pt : void 0,
          showCustomCameraPermissionScreen: et,
          deviceId: at
        }
      ),
      Yt && /* @__PURE__ */ jsxRuntimeExports.jsx(
        Notification$1,
        {
          isLoading: Pt,
          isError: jt,
          className: "desktop IncodeCaptureDesktopSelfieNotification",
          children: Yt
        }
      ),
      jt && /* @__PURE__ */ jsxRuntimeExports.jsx(RetryButtonsContainer, { isDesktop: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button$a, { onClick: () => It(dt), children: Bt("common.tryAgain") }) }),
      Qt && /* @__PURE__ */ jsxRuntimeExports.jsx(
        CaptureButtonContainer,
        {
          className: "IncodeCaptureDesktopSelfieCaptureButtonContainer",
          initial: {
            scale: 0
          },
          animate: {
            scale: 1
          },
          children: /* @__PURE__ */ jsxRuntimeExports.jsx("button", { onClick: St, type: "button", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: CaptureButton, alt: "capture button" }) })
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("canvas", { id: "canvasFrame", hidden: !0 })
  ] });
};
function CaptureAndTutorial$2(me) {
  const [ue, Qe] = useDeviceId(), { currentStep: Ue, nextStep: He } = useSteps(), { showTutorial: Ge, token: Xe } = me;
  function Ke($e) {
    Qe($e);
  }
  return ue ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Steps, { currentStep: Ue, children: [
    Ge && /* @__PURE__ */ jsxRuntimeExports.jsx(
      TutorialSelfie,
      {
        className: "IncodeCaptureDesktopSelfieTutorial",
        ...me,
        onSuccess: He
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Selfie$1, { deviceId: ue, ...me })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(ChooseCamera, { onCameraChosen: Ke, token: Xe == null ? void 0 : Xe.token });
}
const CaptureDesktopSelfie = preloadScript$4(CaptureAndTutorial$2), moveIn = We`
  0% {
    bottom: -200px;
  }

  80% {
    bottom: 6%;
  }

  100% {
    bottom: 5%;
  }
`, FakeButton = qe.div`
  position: fixed;
  text-align: center;
  left: 50%;
  transform: translateX(-50%);
  animation: ${moveIn} 1s ease-in forwards;

  &.hidden {
    display: none;
  }
`;
function CameraPaperStatement({
  onBoarding: me,
  onSuccess: ue,
  permission: Qe,
  setPermission: Ue,
  permissionMessage: He,
  permissionBackgroundColor: Ge,
  onLog: Xe,
  token: Ke,
  onError: $e,
  numberOfTries: Je,
  timeout: Ze = 1e3,
  hideRetake: nt
}) {
  const tt = Ke ? Ke.token : me.state.token.token, { t: et } = useTranslation(), [rt, it] = useState(0), [ot, at] = useState(!1), [st, ut] = useState(null), [lt, dt] = useState(null), [At, pt] = useState(null), [gt, wt] = useState(!1), Bt = useRef(0), [Tt, yt] = useState(""), [Ct, ht] = useState(!1), It = useRef(), vt = useRef(), { showNotification: Et, closeNotification: bt } = useNotifications();
  useEffect(() => {
    addScreenEvent({
      module: eventModuleNames.document,
      screen: eventScreenNames.documentCameraCapture,
      token: tt,
      shouldOpen: !0
    });
  }, []), useEffect(() => {
    if (gt && !ot)
      return vt.current = setInterval(() => {
        Xe(getLogObject("noCaptureInTime", {}));
      }, Ze), () => clearInterval(vt.current);
  }, [Xe, Ze, gt, ot]), useEffect(() => {
    sleep(1e3).then(() => {
      const Yt = `${et("notifications.showUtilityBill.one")} 
 ${et(
        "notifications.showUtilityBill.two"
      )} 
 ${et("notifications.showUtilityBill.three")}`;
      return Et(
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { textAlign: "center" }, children: Yt }),
        "plug"
      ), sleep(2e3);
    }).then(() => wt(!0));
    const _t = It.current;
    return () => {
      var Yt;
      return (Yt = _t == null ? void 0 : _t.mediaStreamTrack) == null ? void 0 : Yt.stop();
    };
  }, []);
  const Rt = async () => {
    const _t = It.current.getCanvas(), Xt = _t.getResizedCanvas(
      It.current.video.clientWidth,
      It.current.video.clientHeight
    ).getBase64Image(), Ut = _t.getBase64Image(), { blob: Lt } = _t.getBlobData(), Ot = _t.getImageData();
    return { imageBase64: Xt, fullImage: Lt, imageData: Ot, fullImageBase64: Ut };
  }, St = async (_t = At) => (bt(), ht(!1), at(!0), addScreenEvent({
    module: eventModuleNames.document,
    screen: eventScreenNames.documentUploadProgress,
    token: tt,
    shouldOpen: !0
  }), me.addAddressStatement({
    token: tt,
    image: _t.fullImageBase64,
    onProgress: it
  }).then(async ({ success: Yt }) => {
    if (Yt)
      addScreenEvent({
        module: eventModuleNames.document,
        screen: eventScreenNames.documentUploadProgress,
        token: tt,
        shouldOpen: !1
      }), addScreenEvent({
        module: eventModuleNames.document,
        screen: eventScreenNames.documentUploadSuccess,
        token: tt,
        shouldOpen: !0
      }), it(100), ut(!0), dt(!0), await sleep(1500), addScreenEvent({
        module: eventModuleNames.document,
        screen: eventScreenNames.documentUploadSuccess,
        token: tt,
        shouldOpen: !1
      }), Xe(
        getLogObject("successCapture", {
          message: "Document captured successfully"
        })
      ), ue({ images: _t });
    else {
      const Xt = et("notifications.badProofOfAddress");
      addScreenEvent({
        module: eventModuleNames.document,
        screen: eventScreenNames.documentUploadProgress,
        token: tt,
        shouldOpen: !1
      }), addScreenEvent({
        module: eventModuleNames.document,
        screen: eventScreenNames.documentAttemptFailed,
        token: tt,
        shouldOpen: !0
      }), Bt.current += 1, Xe(
        getLogObject("attemptFailed", {
          response: { success: Yt },
          message: Xt,
          attempt: Bt.current
        })
      ), ut(!1), dt(!0), yt(Xt), await sleep(1500), addScreenEvent({
        module: eventModuleNames.document,
        screen: eventScreenNames.documentAttemptFailed,
        token: tt,
        shouldOpen: !1
      }), addScreenEvent({
        module: eventModuleNames.document,
        screen: eventScreenNames.documentCameraCapture,
        token: tt,
        shouldOpen: !0
      });
    }
  }).catch(async (Yt) => {
    const Xt = et("notifications.badProofOfAddress");
    addScreenEvent({
      module: eventModuleNames.document,
      screen: eventScreenNames.documentUploadProgress,
      token: tt,
      shouldOpen: !1
    }), addScreenEvent({
      module: eventModuleNames.document,
      screen: eventScreenNames.documentAttemptFailed,
      token: tt,
      shouldOpen: !0
    }), Bt.current += 1, Xe(
      getLogObject("attemptFailed", {
        response: { error: Yt },
        message: Yt.message,
        attempt: Bt.current
      })
    ), ut(!1), dt(!0), yt(Xt), await sleep(1500), addScreenEvent({
      module: eventModuleNames.document,
      screen: eventScreenNames.documentAttemptFailed,
      token: tt,
      shouldOpen: !1
    }), addScreenEvent({
      module: eventModuleNames.document,
      screen: eventScreenNames.documentCameraCapture,
      token: tt,
      shouldOpen: !0
    });
  }));
  function kt() {
    ht(!1), at(!1), it(0), dt(!1), ut(null), yt("");
  }
  function jt() {
    kt();
  }
  function Pt() {
    kt(), Je !== -1 && Bt.current >= Je && (Xe(
      getLogObject("noAttemps", {
        response: { success: !1 },
        message: "No attempt left"
      })
    ), $e("skip"));
  }
  const Qt = (_t) => {
    _t ? jt() : Pt();
  }, qt = async () => {
    bt(), clearTimeout(vt.current);
    const _t = await Rt();
    if (pt(_t), nt)
      return St(_t);
    ht(!0);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Webcam,
      {
        ref: It,
        className: "IncodeCaptureDocumentWebcam",
        videoSource: "environment",
        permission: Qe,
        setPermission: Ue,
        permissionMessage: He,
        permissionBackgroundColor: Ge,
        onLog: Xe,
        dataURLtoBlob: "image/jpeg",
        onError: $e,
        token: tt.token,
        interviewId: Ke.interviewId
      }
    ),
    !nt && Ct && At && /* @__PURE__ */ jsxRuntimeExports.jsx(
      Retake,
      {
        imageBase64: toImage$1(At.fullImageBase64),
        onClose: kt,
        handleCapture: St,
        token: tt,
        className: "IncodeCaptureDocumentRetake",
        type: "document"
      }
    ),
    ot && At && /* @__PURE__ */ jsxRuntimeExports.jsx(
      CapturePreview,
      {
        open: !0,
        progress: rt,
        message: Tt,
        finishCapture: lt,
        captureSuccessful: st,
        onClose: Qt,
        imageBase64: toImage$1(At.fullImageBase64),
        isSelfie: !1,
        isPoa: !0,
        className: "IncodeCaptureDocumentPreview",
        numberOfTries: Je,
        timesCaptureFailed: Bt.current
      }
    ),
    gt && /* @__PURE__ */ jsxRuntimeExports.jsx(
      FakeButton,
      {
        className: classNames("IncodeCaptureDocumentFakeButton", {
          hidden: ot || Ct
        }),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "img",
          {
            tabIndex: -1,
            alt: "capture button",
            src: CaptureButton,
            className: "step__video-catch-event",
            onClick: qt,
            onKeyUp: qt
          }
        )
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("canvas", { id: "canvasFrame", hidden: !0 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Notification,
      {
        className: "IncodeCaptureDocumentNotification",
        inline: !1,
        center: !0
      }
    )
  ] });
}
const TutorialCreditCardFrontHeader = () => {
  const { t: me } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: me("tutorial.creditCardFront") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: me("tutorial.creditCardFront2") })
  ] });
};
function TutorialCreditCardFront({
  onSuccess: me,
  token: ue,
  src: Qe = "https://sdk.incode.com/sdk/tutorials/card%20front.svg",
  ...Ue
}) {
  const { t: He } = useTranslation();
  useEffect(() => {
    addEvent({
      token: ue.token,
      code: "tutorialCreditCard",
      payload: { tutorialCreditCard: !0 }
    });
  }, [ue.token]);
  function Ge() {
    addEvent({
      token: ue == null ? void 0 : ue.token,
      code: "continue"
    }), me();
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Tutorial,
    {
      creditCard: !0,
      ...Ue,
      src: Qe,
      header: /* @__PURE__ */ jsxRuntimeExports.jsx(TutorialCreditCardFrontHeader, {}),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonsContainer$4, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        StyledButton,
        {
          className: classNames("IncodeTutorialButton", "IncodeTutorialButtonSelfie"),
          onClick: Ge,
          children: He("common.continue")
        }
      ) })
    }
  );
}
function isObject$3(me) {
  return me !== null && typeof me == "object" && "constructor" in me && me.constructor === Object;
}
function extend$3(me = {}, ue = {}) {
  Object.keys(ue).forEach((Qe) => {
    typeof me[Qe] > "u" ? me[Qe] = ue[Qe] : isObject$3(ue[Qe]) && isObject$3(me[Qe]) && Object.keys(ue[Qe]).length > 0 && extend$3(me[Qe], ue[Qe]);
  });
}
const ssrDocument = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function getDocument() {
  const me = typeof document < "u" ? document : {};
  return extend$3(me, ssrDocument), me;
}
const ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(me) {
    return typeof setTimeout > "u" ? (me(), null) : setTimeout(me, 0);
  },
  cancelAnimationFrame(me) {
    typeof setTimeout > "u" || clearTimeout(me);
  }
};
function getWindow() {
  const me = typeof window < "u" ? window : {};
  return extend$3(me, ssrWindow), me;
}
function deleteProps(me) {
  const ue = me;
  Object.keys(ue).forEach((Qe) => {
    try {
      ue[Qe] = null;
    } catch {
    }
    try {
      delete ue[Qe];
    } catch {
    }
  });
}
function nextTick(me, ue = 0) {
  return setTimeout(me, ue);
}
function now() {
  return Date.now();
}
function getComputedStyle$1(me) {
  const ue = getWindow();
  let Qe;
  return ue.getComputedStyle && (Qe = ue.getComputedStyle(me, null)), !Qe && me.currentStyle && (Qe = me.currentStyle), Qe || (Qe = me.style), Qe;
}
function getTranslate(me, ue = "x") {
  const Qe = getWindow();
  let Ue, He, Ge;
  const Xe = getComputedStyle$1(me);
  return Qe.WebKitCSSMatrix ? (He = Xe.transform || Xe.webkitTransform, He.split(",").length > 6 && (He = He.split(", ").map((Ke) => Ke.replace(",", ".")).join(", ")), Ge = new Qe.WebKitCSSMatrix(He === "none" ? "" : He)) : (Ge = Xe.MozTransform || Xe.OTransform || Xe.MsTransform || Xe.msTransform || Xe.transform || Xe.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), Ue = Ge.toString().split(",")), ue === "x" && (Qe.WebKitCSSMatrix ? He = Ge.m41 : Ue.length === 16 ? He = parseFloat(Ue[12]) : He = parseFloat(Ue[4])), ue === "y" && (Qe.WebKitCSSMatrix ? He = Ge.m42 : Ue.length === 16 ? He = parseFloat(Ue[13]) : He = parseFloat(Ue[5])), He || 0;
}
function isObject$2(me) {
  return typeof me == "object" && me !== null && me.constructor && Object.prototype.toString.call(me).slice(8, -1) === "Object";
}
function isNode(me) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? me instanceof HTMLElement : me && (me.nodeType === 1 || me.nodeType === 11);
}
function extend$2(...me) {
  const ue = Object(me[0]), Qe = ["__proto__", "constructor", "prototype"];
  for (let Ue = 1; Ue < me.length; Ue += 1) {
    const He = me[Ue];
    if (He != null && !isNode(He)) {
      const Ge = Object.keys(Object(He)).filter((Xe) => Qe.indexOf(Xe) < 0);
      for (let Xe = 0, Ke = Ge.length; Xe < Ke; Xe += 1) {
        const $e = Ge[Xe], Je = Object.getOwnPropertyDescriptor(He, $e);
        Je !== void 0 && Je.enumerable && (isObject$2(ue[$e]) && isObject$2(He[$e]) ? He[$e].__swiper__ ? ue[$e] = He[$e] : extend$2(ue[$e], He[$e]) : !isObject$2(ue[$e]) && isObject$2(He[$e]) ? (ue[$e] = {}, He[$e].__swiper__ ? ue[$e] = He[$e] : extend$2(ue[$e], He[$e])) : ue[$e] = He[$e]);
      }
    }
  }
  return ue;
}
function setCSSProperty(me, ue, Qe) {
  me.style.setProperty(ue, Qe);
}
function animateCSSModeScroll({
  swiper: me,
  targetPosition: ue,
  side: Qe
}) {
  const Ue = getWindow(), He = -me.translate;
  let Ge = null, Xe;
  const Ke = me.params.speed;
  me.wrapperEl.style.scrollSnapType = "none", Ue.cancelAnimationFrame(me.cssModeFrameID);
  const $e = ue > He ? "next" : "prev", Je = (nt, tt) => $e === "next" && nt >= tt || $e === "prev" && nt <= tt, Ze = () => {
    Xe = (/* @__PURE__ */ new Date()).getTime(), Ge === null && (Ge = Xe);
    const nt = Math.max(Math.min((Xe - Ge) / Ke, 1), 0), tt = 0.5 - Math.cos(nt * Math.PI) / 2;
    let et = He + tt * (ue - He);
    if (Je(et, ue) && (et = ue), me.wrapperEl.scrollTo({
      [Qe]: et
    }), Je(et, ue)) {
      me.wrapperEl.style.overflow = "hidden", me.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        me.wrapperEl.style.overflow = "", me.wrapperEl.scrollTo({
          [Qe]: et
        });
      }), Ue.cancelAnimationFrame(me.cssModeFrameID);
      return;
    }
    me.cssModeFrameID = Ue.requestAnimationFrame(Ze);
  };
  Ze();
}
function elementChildren(me, ue = "") {
  return [...me.children].filter((Qe) => Qe.matches(ue));
}
function createElement(me, ue = []) {
  const Qe = document.createElement(me);
  return Qe.classList.add(...Array.isArray(ue) ? ue : [ue]), Qe;
}
function elementPrevAll(me, ue) {
  const Qe = [];
  for (; me.previousElementSibling; ) {
    const Ue = me.previousElementSibling;
    ue ? Ue.matches(ue) && Qe.push(Ue) : Qe.push(Ue), me = Ue;
  }
  return Qe;
}
function elementNextAll(me, ue) {
  const Qe = [];
  for (; me.nextElementSibling; ) {
    const Ue = me.nextElementSibling;
    ue ? Ue.matches(ue) && Qe.push(Ue) : Qe.push(Ue), me = Ue;
  }
  return Qe;
}
function elementStyle(me, ue) {
  return getWindow().getComputedStyle(me, null).getPropertyValue(ue);
}
function elementIndex(me) {
  let ue = me, Qe;
  if (ue) {
    for (Qe = 0; (ue = ue.previousSibling) !== null; )
      ue.nodeType === 1 && (Qe += 1);
    return Qe;
  }
}
function elementParents(me, ue) {
  const Qe = [];
  let Ue = me.parentElement;
  for (; Ue; )
    ue ? Ue.matches(ue) && Qe.push(Ue) : Qe.push(Ue), Ue = Ue.parentElement;
  return Qe;
}
function elementOuterSize(me, ue, Qe) {
  const Ue = getWindow();
  return me[ue === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(Ue.getComputedStyle(me, null).getPropertyValue(ue === "width" ? "margin-right" : "margin-top")) + parseFloat(Ue.getComputedStyle(me, null).getPropertyValue(ue === "width" ? "margin-left" : "margin-bottom"));
}
let support;
function calcSupport() {
  const me = getWindow(), ue = getDocument();
  return {
    smoothScroll: ue.documentElement && ue.documentElement.style && "scrollBehavior" in ue.documentElement.style,
    touch: !!("ontouchstart" in me || me.DocumentTouch && ue instanceof me.DocumentTouch)
  };
}
function getSupport() {
  return support || (support = calcSupport()), support;
}
let deviceCached;
function calcDevice({
  userAgent: me
} = {}) {
  const ue = getSupport(), Qe = getWindow(), Ue = Qe.navigator.platform, He = me || Qe.navigator.userAgent, Ge = {
    ios: !1,
    android: !1
  }, Xe = Qe.screen.width, Ke = Qe.screen.height, $e = He.match(/(Android);?[\s\/]+([\d.]+)?/);
  let Je = He.match(/(iPad).*OS\s([\d_]+)/);
  const Ze = He.match(/(iPod)(.*OS\s([\d_]+))?/), nt = !Je && He.match(/(iPhone\sOS|iOS)\s([\d_]+)/), tt = Ue === "Win32";
  let et = Ue === "MacIntel";
  const rt = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !Je && et && ue.touch && rt.indexOf(`${Xe}x${Ke}`) >= 0 && (Je = He.match(/(Version)\/([\d.]+)/), Je || (Je = [0, 1, "13_0_0"]), et = !1), $e && !tt && (Ge.os = "android", Ge.android = !0), (Je || nt || Ze) && (Ge.os = "ios", Ge.ios = !0), Ge;
}
function getDevice(me = {}) {
  return deviceCached || (deviceCached = calcDevice(me)), deviceCached;
}
let browser;
function calcBrowser() {
  const me = getWindow();
  let ue = !1;
  function Qe() {
    const Ue = me.navigator.userAgent.toLowerCase();
    return Ue.indexOf("safari") >= 0 && Ue.indexOf("chrome") < 0 && Ue.indexOf("android") < 0;
  }
  if (Qe()) {
    const Ue = String(me.navigator.userAgent);
    if (Ue.includes("Version/")) {
      const [He, Ge] = Ue.split("Version/")[1].split(" ")[0].split(".").map((Xe) => Number(Xe));
      ue = He < 16 || He === 16 && Ge < 2;
    }
  }
  return {
    isSafari: ue || Qe(),
    needPerspectiveFix: ue,
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(me.navigator.userAgent)
  };
}
function getBrowser() {
  return browser || (browser = calcBrowser()), browser;
}
function Resize({
  swiper: me,
  on: ue,
  emit: Qe
}) {
  const Ue = getWindow();
  let He = null, Ge = null;
  const Xe = () => {
    !me || me.destroyed || !me.initialized || (Qe("beforeResize"), Qe("resize"));
  }, Ke = () => {
    !me || me.destroyed || !me.initialized || (He = new ResizeObserver((Ze) => {
      Ge = Ue.requestAnimationFrame(() => {
        const {
          width: nt,
          height: tt
        } = me;
        let et = nt, rt = tt;
        Ze.forEach(({
          contentBoxSize: it,
          contentRect: ot,
          target: at
        }) => {
          at && at !== me.el || (et = ot ? ot.width : (it[0] || it).inlineSize, rt = ot ? ot.height : (it[0] || it).blockSize);
        }), (et !== nt || rt !== tt) && Xe();
      });
    }), He.observe(me.el));
  }, $e = () => {
    Ge && Ue.cancelAnimationFrame(Ge), He && He.unobserve && me.el && (He.unobserve(me.el), He = null);
  }, Je = () => {
    !me || me.destroyed || !me.initialized || Qe("orientationchange");
  };
  ue("init", () => {
    if (me.params.resizeObserver && typeof Ue.ResizeObserver < "u") {
      Ke();
      return;
    }
    Ue.addEventListener("resize", Xe), Ue.addEventListener("orientationchange", Je);
  }), ue("destroy", () => {
    $e(), Ue.removeEventListener("resize", Xe), Ue.removeEventListener("orientationchange", Je);
  });
}
function Observer({
  swiper: me,
  extendParams: ue,
  on: Qe,
  emit: Ue
}) {
  const He = [], Ge = getWindow(), Xe = (Je, Ze = {}) => {
    const nt = Ge.MutationObserver || Ge.WebkitMutationObserver, tt = new nt((et) => {
      if (me.__preventObserver__) return;
      if (et.length === 1) {
        Ue("observerUpdate", et[0]);
        return;
      }
      const rt = function() {
        Ue("observerUpdate", et[0]);
      };
      Ge.requestAnimationFrame ? Ge.requestAnimationFrame(rt) : Ge.setTimeout(rt, 0);
    });
    tt.observe(Je, {
      attributes: typeof Ze.attributes > "u" ? !0 : Ze.attributes,
      childList: typeof Ze.childList > "u" ? !0 : Ze.childList,
      characterData: typeof Ze.characterData > "u" ? !0 : Ze.characterData
    }), He.push(tt);
  }, Ke = () => {
    if (me.params.observer) {
      if (me.params.observeParents) {
        const Je = elementParents(me.el);
        for (let Ze = 0; Ze < Je.length; Ze += 1)
          Xe(Je[Ze]);
      }
      Xe(me.el, {
        childList: me.params.observeSlideChildren
      }), Xe(me.wrapperEl, {
        attributes: !1
      });
    }
  }, $e = () => {
    He.forEach((Je) => {
      Je.disconnect();
    }), He.splice(0, He.length);
  };
  ue({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), Qe("init", Ke), Qe("destroy", $e);
}
const eventsEmitter = {
  on(me, ue, Qe) {
    const Ue = this;
    if (!Ue.eventsListeners || Ue.destroyed || typeof ue != "function") return Ue;
    const He = Qe ? "unshift" : "push";
    return me.split(" ").forEach((Ge) => {
      Ue.eventsListeners[Ge] || (Ue.eventsListeners[Ge] = []), Ue.eventsListeners[Ge][He](ue);
    }), Ue;
  },
  once(me, ue, Qe) {
    const Ue = this;
    if (!Ue.eventsListeners || Ue.destroyed || typeof ue != "function") return Ue;
    function He(...Ge) {
      Ue.off(me, He), He.__emitterProxy && delete He.__emitterProxy, ue.apply(Ue, Ge);
    }
    return He.__emitterProxy = ue, Ue.on(me, He, Qe);
  },
  onAny(me, ue) {
    const Qe = this;
    if (!Qe.eventsListeners || Qe.destroyed || typeof me != "function") return Qe;
    const Ue = ue ? "unshift" : "push";
    return Qe.eventsAnyListeners.indexOf(me) < 0 && Qe.eventsAnyListeners[Ue](me), Qe;
  },
  offAny(me) {
    const ue = this;
    if (!ue.eventsListeners || ue.destroyed || !ue.eventsAnyListeners) return ue;
    const Qe = ue.eventsAnyListeners.indexOf(me);
    return Qe >= 0 && ue.eventsAnyListeners.splice(Qe, 1), ue;
  },
  off(me, ue) {
    const Qe = this;
    return !Qe.eventsListeners || Qe.destroyed || !Qe.eventsListeners || me.split(" ").forEach((Ue) => {
      typeof ue > "u" ? Qe.eventsListeners[Ue] = [] : Qe.eventsListeners[Ue] && Qe.eventsListeners[Ue].forEach((He, Ge) => {
        (He === ue || He.__emitterProxy && He.__emitterProxy === ue) && Qe.eventsListeners[Ue].splice(Ge, 1);
      });
    }), Qe;
  },
  emit(...me) {
    const ue = this;
    if (!ue.eventsListeners || ue.destroyed || !ue.eventsListeners) return ue;
    let Qe, Ue, He;
    return typeof me[0] == "string" || Array.isArray(me[0]) ? (Qe = me[0], Ue = me.slice(1, me.length), He = ue) : (Qe = me[0].events, Ue = me[0].data, He = me[0].context || ue), Ue.unshift(He), (Array.isArray(Qe) ? Qe : Qe.split(" ")).forEach((Xe) => {
      ue.eventsAnyListeners && ue.eventsAnyListeners.length && ue.eventsAnyListeners.forEach((Ke) => {
        Ke.apply(He, [Xe, ...Ue]);
      }), ue.eventsListeners && ue.eventsListeners[Xe] && ue.eventsListeners[Xe].forEach((Ke) => {
        Ke.apply(He, Ue);
      });
    }), ue;
  }
};
function updateSize() {
  const me = this;
  let ue, Qe;
  const Ue = me.el;
  typeof me.params.width < "u" && me.params.width !== null ? ue = me.params.width : ue = Ue.clientWidth, typeof me.params.height < "u" && me.params.height !== null ? Qe = me.params.height : Qe = Ue.clientHeight, !(ue === 0 && me.isHorizontal() || Qe === 0 && me.isVertical()) && (ue = ue - parseInt(elementStyle(Ue, "padding-left") || 0, 10) - parseInt(elementStyle(Ue, "padding-right") || 0, 10), Qe = Qe - parseInt(elementStyle(Ue, "padding-top") || 0, 10) - parseInt(elementStyle(Ue, "padding-bottom") || 0, 10), Number.isNaN(ue) && (ue = 0), Number.isNaN(Qe) && (Qe = 0), Object.assign(me, {
    width: ue,
    height: Qe,
    size: me.isHorizontal() ? ue : Qe
  }));
}
function updateSlides() {
  const me = this;
  function ue(Tt) {
    return me.isHorizontal() ? Tt : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[Tt];
  }
  function Qe(Tt, yt) {
    return parseFloat(Tt.getPropertyValue(ue(yt)) || 0);
  }
  const Ue = me.params, {
    wrapperEl: He,
    slidesEl: Ge,
    size: Xe,
    rtlTranslate: Ke,
    wrongRTL: $e
  } = me, Je = me.virtual && Ue.virtual.enabled, Ze = Je ? me.virtual.slides.length : me.slides.length, nt = elementChildren(Ge, `.${me.params.slideClass}, swiper-slide`), tt = Je ? me.virtual.slides.length : nt.length;
  let et = [];
  const rt = [], it = [];
  let ot = Ue.slidesOffsetBefore;
  typeof ot == "function" && (ot = Ue.slidesOffsetBefore.call(me));
  let at = Ue.slidesOffsetAfter;
  typeof at == "function" && (at = Ue.slidesOffsetAfter.call(me));
  const st = me.snapGrid.length, ut = me.slidesGrid.length;
  let lt = Ue.spaceBetween, dt = -ot, At = 0, pt = 0;
  if (typeof Xe > "u")
    return;
  typeof lt == "string" && lt.indexOf("%") >= 0 ? lt = parseFloat(lt.replace("%", "")) / 100 * Xe : typeof lt == "string" && (lt = parseFloat(lt)), me.virtualSize = -lt, nt.forEach((Tt) => {
    Ke ? Tt.style.marginLeft = "" : Tt.style.marginRight = "", Tt.style.marginBottom = "", Tt.style.marginTop = "";
  }), Ue.centeredSlides && Ue.cssMode && (setCSSProperty(He, "--swiper-centered-offset-before", ""), setCSSProperty(He, "--swiper-centered-offset-after", ""));
  const gt = Ue.grid && Ue.grid.rows > 1 && me.grid;
  gt && me.grid.initSlides(tt);
  let wt;
  const Bt = Ue.slidesPerView === "auto" && Ue.breakpoints && Object.keys(Ue.breakpoints).filter((Tt) => typeof Ue.breakpoints[Tt].slidesPerView < "u").length > 0;
  for (let Tt = 0; Tt < tt; Tt += 1) {
    wt = 0;
    let yt;
    if (nt[Tt] && (yt = nt[Tt]), gt && me.grid.updateSlide(Tt, yt, tt, ue), !(nt[Tt] && elementStyle(yt, "display") === "none")) {
      if (Ue.slidesPerView === "auto") {
        Bt && (nt[Tt].style[ue("width")] = "");
        const Ct = getComputedStyle(yt), ht = yt.style.transform, It = yt.style.webkitTransform;
        if (ht && (yt.style.transform = "none"), It && (yt.style.webkitTransform = "none"), Ue.roundLengths)
          wt = me.isHorizontal() ? elementOuterSize(yt, "width") : elementOuterSize(yt, "height");
        else {
          const vt = Qe(Ct, "width"), Et = Qe(Ct, "padding-left"), bt = Qe(Ct, "padding-right"), Rt = Qe(Ct, "margin-left"), St = Qe(Ct, "margin-right"), kt = Ct.getPropertyValue("box-sizing");
          if (kt && kt === "border-box")
            wt = vt + Rt + St;
          else {
            const {
              clientWidth: jt,
              offsetWidth: Pt
            } = yt;
            wt = vt + Et + bt + Rt + St + (Pt - jt);
          }
        }
        ht && (yt.style.transform = ht), It && (yt.style.webkitTransform = It), Ue.roundLengths && (wt = Math.floor(wt));
      } else
        wt = (Xe - (Ue.slidesPerView - 1) * lt) / Ue.slidesPerView, Ue.roundLengths && (wt = Math.floor(wt)), nt[Tt] && (nt[Tt].style[ue("width")] = `${wt}px`);
      nt[Tt] && (nt[Tt].swiperSlideSize = wt), it.push(wt), Ue.centeredSlides ? (dt = dt + wt / 2 + At / 2 + lt, At === 0 && Tt !== 0 && (dt = dt - Xe / 2 - lt), Tt === 0 && (dt = dt - Xe / 2 - lt), Math.abs(dt) < 1 / 1e3 && (dt = 0), Ue.roundLengths && (dt = Math.floor(dt)), pt % Ue.slidesPerGroup === 0 && et.push(dt), rt.push(dt)) : (Ue.roundLengths && (dt = Math.floor(dt)), (pt - Math.min(me.params.slidesPerGroupSkip, pt)) % me.params.slidesPerGroup === 0 && et.push(dt), rt.push(dt), dt = dt + wt + lt), me.virtualSize += wt + lt, At = wt, pt += 1;
    }
  }
  if (me.virtualSize = Math.max(me.virtualSize, Xe) + at, Ke && $e && (Ue.effect === "slide" || Ue.effect === "coverflow") && (He.style.width = `${me.virtualSize + lt}px`), Ue.setWrapperSize && (He.style[ue("width")] = `${me.virtualSize + lt}px`), gt && me.grid.updateWrapperSize(wt, et, ue), !Ue.centeredSlides) {
    const Tt = [];
    for (let yt = 0; yt < et.length; yt += 1) {
      let Ct = et[yt];
      Ue.roundLengths && (Ct = Math.floor(Ct)), et[yt] <= me.virtualSize - Xe && Tt.push(Ct);
    }
    et = Tt, Math.floor(me.virtualSize - Xe) - Math.floor(et[et.length - 1]) > 1 && et.push(me.virtualSize - Xe);
  }
  if (Je && Ue.loop) {
    const Tt = it[0] + lt;
    if (Ue.slidesPerGroup > 1) {
      const yt = Math.ceil((me.virtual.slidesBefore + me.virtual.slidesAfter) / Ue.slidesPerGroup), Ct = Tt * Ue.slidesPerGroup;
      for (let ht = 0; ht < yt; ht += 1)
        et.push(et[et.length - 1] + Ct);
    }
    for (let yt = 0; yt < me.virtual.slidesBefore + me.virtual.slidesAfter; yt += 1)
      Ue.slidesPerGroup === 1 && et.push(et[et.length - 1] + Tt), rt.push(rt[rt.length - 1] + Tt), me.virtualSize += Tt;
  }
  if (et.length === 0 && (et = [0]), lt !== 0) {
    const Tt = me.isHorizontal() && Ke ? "marginLeft" : ue("marginRight");
    nt.filter((yt, Ct) => !Ue.cssMode || Ue.loop ? !0 : Ct !== nt.length - 1).forEach((yt) => {
      yt.style[Tt] = `${lt}px`;
    });
  }
  if (Ue.centeredSlides && Ue.centeredSlidesBounds) {
    let Tt = 0;
    it.forEach((Ct) => {
      Tt += Ct + (lt || 0);
    }), Tt -= lt;
    const yt = Tt - Xe;
    et = et.map((Ct) => Ct <= 0 ? -ot : Ct > yt ? yt + at : Ct);
  }
  if (Ue.centerInsufficientSlides) {
    let Tt = 0;
    if (it.forEach((yt) => {
      Tt += yt + (lt || 0);
    }), Tt -= lt, Tt < Xe) {
      const yt = (Xe - Tt) / 2;
      et.forEach((Ct, ht) => {
        et[ht] = Ct - yt;
      }), rt.forEach((Ct, ht) => {
        rt[ht] = Ct + yt;
      });
    }
  }
  if (Object.assign(me, {
    slides: nt,
    snapGrid: et,
    slidesGrid: rt,
    slidesSizesGrid: it
  }), Ue.centeredSlides && Ue.cssMode && !Ue.centeredSlidesBounds) {
    setCSSProperty(He, "--swiper-centered-offset-before", `${-et[0]}px`), setCSSProperty(He, "--swiper-centered-offset-after", `${me.size / 2 - it[it.length - 1] / 2}px`);
    const Tt = -me.snapGrid[0], yt = -me.slidesGrid[0];
    me.snapGrid = me.snapGrid.map((Ct) => Ct + Tt), me.slidesGrid = me.slidesGrid.map((Ct) => Ct + yt);
  }
  if (tt !== Ze && me.emit("slidesLengthChange"), et.length !== st && (me.params.watchOverflow && me.checkOverflow(), me.emit("snapGridLengthChange")), rt.length !== ut && me.emit("slidesGridLengthChange"), Ue.watchSlidesProgress && me.updateSlidesOffset(), !Je && !Ue.cssMode && (Ue.effect === "slide" || Ue.effect === "fade")) {
    const Tt = `${Ue.containerModifierClass}backface-hidden`, yt = me.el.classList.contains(Tt);
    tt <= Ue.maxBackfaceHiddenSlides ? yt || me.el.classList.add(Tt) : yt && me.el.classList.remove(Tt);
  }
}
function updateAutoHeight(me) {
  const ue = this, Qe = [], Ue = ue.virtual && ue.params.virtual.enabled;
  let He = 0, Ge;
  typeof me == "number" ? ue.setTransition(me) : me === !0 && ue.setTransition(ue.params.speed);
  const Xe = (Ke) => Ue ? ue.slides[ue.getSlideIndexByData(Ke)] : ue.slides[Ke];
  if (ue.params.slidesPerView !== "auto" && ue.params.slidesPerView > 1)
    if (ue.params.centeredSlides)
      (ue.visibleSlides || []).forEach((Ke) => {
        Qe.push(Ke);
      });
    else
      for (Ge = 0; Ge < Math.ceil(ue.params.slidesPerView); Ge += 1) {
        const Ke = ue.activeIndex + Ge;
        if (Ke > ue.slides.length && !Ue) break;
        Qe.push(Xe(Ke));
      }
  else
    Qe.push(Xe(ue.activeIndex));
  for (Ge = 0; Ge < Qe.length; Ge += 1)
    if (typeof Qe[Ge] < "u") {
      const Ke = Qe[Ge].offsetHeight;
      He = Ke > He ? Ke : He;
    }
  (He || He === 0) && (ue.wrapperEl.style.height = `${He}px`);
}
function updateSlidesOffset() {
  const me = this, ue = me.slides, Qe = me.isElement ? me.isHorizontal() ? me.wrapperEl.offsetLeft : me.wrapperEl.offsetTop : 0;
  for (let Ue = 0; Ue < ue.length; Ue += 1)
    ue[Ue].swiperSlideOffset = (me.isHorizontal() ? ue[Ue].offsetLeft : ue[Ue].offsetTop) - Qe - me.cssOverflowAdjustment();
}
function updateSlidesProgress(me = this && this.translate || 0) {
  const ue = this, Qe = ue.params, {
    slides: Ue,
    rtlTranslate: He,
    snapGrid: Ge
  } = ue;
  if (Ue.length === 0) return;
  typeof Ue[0].swiperSlideOffset > "u" && ue.updateSlidesOffset();
  let Xe = -me;
  He && (Xe = me), Ue.forEach(($e) => {
    $e.classList.remove(Qe.slideVisibleClass);
  }), ue.visibleSlidesIndexes = [], ue.visibleSlides = [];
  let Ke = Qe.spaceBetween;
  typeof Ke == "string" && Ke.indexOf("%") >= 0 ? Ke = parseFloat(Ke.replace("%", "")) / 100 * ue.size : typeof Ke == "string" && (Ke = parseFloat(Ke));
  for (let $e = 0; $e < Ue.length; $e += 1) {
    const Je = Ue[$e];
    let Ze = Je.swiperSlideOffset;
    Qe.cssMode && Qe.centeredSlides && (Ze -= Ue[0].swiperSlideOffset);
    const nt = (Xe + (Qe.centeredSlides ? ue.minTranslate() : 0) - Ze) / (Je.swiperSlideSize + Ke), tt = (Xe - Ge[0] + (Qe.centeredSlides ? ue.minTranslate() : 0) - Ze) / (Je.swiperSlideSize + Ke), et = -(Xe - Ze), rt = et + ue.slidesSizesGrid[$e];
    (et >= 0 && et < ue.size - 1 || rt > 1 && rt <= ue.size || et <= 0 && rt >= ue.size) && (ue.visibleSlides.push(Je), ue.visibleSlidesIndexes.push($e), Ue[$e].classList.add(Qe.slideVisibleClass)), Je.progress = He ? -nt : nt, Je.originalProgress = He ? -tt : tt;
  }
}
function updateProgress(me) {
  const ue = this;
  if (typeof me > "u") {
    const Ze = ue.rtlTranslate ? -1 : 1;
    me = ue && ue.translate && ue.translate * Ze || 0;
  }
  const Qe = ue.params, Ue = ue.maxTranslate() - ue.minTranslate();
  let {
    progress: He,
    isBeginning: Ge,
    isEnd: Xe,
    progressLoop: Ke
  } = ue;
  const $e = Ge, Je = Xe;
  if (Ue === 0)
    He = 0, Ge = !0, Xe = !0;
  else {
    He = (me - ue.minTranslate()) / Ue;
    const Ze = Math.abs(me - ue.minTranslate()) < 1, nt = Math.abs(me - ue.maxTranslate()) < 1;
    Ge = Ze || He <= 0, Xe = nt || He >= 1, Ze && (He = 0), nt && (He = 1);
  }
  if (Qe.loop) {
    const Ze = ue.getSlideIndexByData(0), nt = ue.getSlideIndexByData(ue.slides.length - 1), tt = ue.slidesGrid[Ze], et = ue.slidesGrid[nt], rt = ue.slidesGrid[ue.slidesGrid.length - 1], it = Math.abs(me);
    it >= tt ? Ke = (it - tt) / rt : Ke = (it + rt - et) / rt, Ke > 1 && (Ke -= 1);
  }
  Object.assign(ue, {
    progress: He,
    progressLoop: Ke,
    isBeginning: Ge,
    isEnd: Xe
  }), (Qe.watchSlidesProgress || Qe.centeredSlides && Qe.autoHeight) && ue.updateSlidesProgress(me), Ge && !$e && ue.emit("reachBeginning toEdge"), Xe && !Je && ue.emit("reachEnd toEdge"), ($e && !Ge || Je && !Xe) && ue.emit("fromEdge"), ue.emit("progress", He);
}
function updateSlidesClasses() {
  const me = this, {
    slides: ue,
    params: Qe,
    slidesEl: Ue,
    activeIndex: He
  } = me, Ge = me.virtual && Qe.virtual.enabled, Xe = ($e) => elementChildren(Ue, `.${Qe.slideClass}${$e}, swiper-slide${$e}`)[0];
  ue.forEach(($e) => {
    $e.classList.remove(Qe.slideActiveClass, Qe.slideNextClass, Qe.slidePrevClass);
  });
  let Ke;
  if (Ge)
    if (Qe.loop) {
      let $e = He - me.virtual.slidesBefore;
      $e < 0 && ($e = me.virtual.slides.length + $e), $e >= me.virtual.slides.length && ($e -= me.virtual.slides.length), Ke = Xe(`[data-swiper-slide-index="${$e}"]`);
    } else
      Ke = Xe(`[data-swiper-slide-index="${He}"]`);
  else
    Ke = ue[He];
  if (Ke) {
    Ke.classList.add(Qe.slideActiveClass);
    let $e = elementNextAll(Ke, `.${Qe.slideClass}, swiper-slide`)[0];
    Qe.loop && !$e && ($e = ue[0]), $e && $e.classList.add(Qe.slideNextClass);
    let Je = elementPrevAll(Ke, `.${Qe.slideClass}, swiper-slide`)[0];
    Qe.loop && !Je === 0 && (Je = ue[ue.length - 1]), Je && Je.classList.add(Qe.slidePrevClass);
  }
  me.emitSlidesClasses();
}
const processLazyPreloader = (me, ue) => {
  if (!me || me.destroyed || !me.params) return;
  const Qe = () => me.isElement ? "swiper-slide" : `.${me.params.slideClass}`, Ue = ue.closest(Qe());
  if (Ue) {
    const He = Ue.querySelector(`.${me.params.lazyPreloaderClass}`);
    He && He.remove();
  }
}, unlazy = (me, ue) => {
  if (!me.slides[ue]) return;
  const Qe = me.slides[ue].querySelector('[loading="lazy"]');
  Qe && Qe.removeAttribute("loading");
}, preload = (me) => {
  if (!me || me.destroyed || !me.params) return;
  let ue = me.params.lazyPreloadPrevNext;
  const Qe = me.slides.length;
  if (!Qe || !ue || ue < 0) return;
  ue = Math.min(ue, Qe);
  const Ue = me.params.slidesPerView === "auto" ? me.slidesPerViewDynamic() : Math.ceil(me.params.slidesPerView), He = me.activeIndex;
  if (me.params.grid && me.params.grid.rows > 1) {
    const Xe = He, Ke = [Xe - ue];
    Ke.push(...Array.from({
      length: ue
    }).map(($e, Je) => Xe + Ue + Je)), me.slides.forEach(($e, Je) => {
      Ke.includes($e.column) && unlazy(me, Je);
    });
    return;
  }
  const Ge = He + Ue - 1;
  if (me.params.rewind || me.params.loop)
    for (let Xe = He - ue; Xe <= Ge + ue; Xe += 1) {
      const Ke = (Xe % Qe + Qe) % Qe;
      (Ke < He || Ke > Ge) && unlazy(me, Ke);
    }
  else
    for (let Xe = Math.max(He - ue, 0); Xe <= Math.min(Ge + ue, Qe - 1); Xe += 1)
      Xe !== He && (Xe > Ge || Xe < He) && unlazy(me, Xe);
};
function getActiveIndexByTranslate(me) {
  const {
    slidesGrid: ue,
    params: Qe
  } = me, Ue = me.rtlTranslate ? me.translate : -me.translate;
  let He;
  for (let Ge = 0; Ge < ue.length; Ge += 1)
    typeof ue[Ge + 1] < "u" ? Ue >= ue[Ge] && Ue < ue[Ge + 1] - (ue[Ge + 1] - ue[Ge]) / 2 ? He = Ge : Ue >= ue[Ge] && Ue < ue[Ge + 1] && (He = Ge + 1) : Ue >= ue[Ge] && (He = Ge);
  return Qe.normalizeSlideIndex && (He < 0 || typeof He > "u") && (He = 0), He;
}
function updateActiveIndex(me) {
  const ue = this, Qe = ue.rtlTranslate ? ue.translate : -ue.translate, {
    snapGrid: Ue,
    params: He,
    activeIndex: Ge,
    realIndex: Xe,
    snapIndex: Ke
  } = ue;
  let $e = me, Je;
  const Ze = (tt) => {
    let et = tt - ue.virtual.slidesBefore;
    return et < 0 && (et = ue.virtual.slides.length + et), et >= ue.virtual.slides.length && (et -= ue.virtual.slides.length), et;
  };
  if (typeof $e > "u" && ($e = getActiveIndexByTranslate(ue)), Ue.indexOf(Qe) >= 0)
    Je = Ue.indexOf(Qe);
  else {
    const tt = Math.min(He.slidesPerGroupSkip, $e);
    Je = tt + Math.floor(($e - tt) / He.slidesPerGroup);
  }
  if (Je >= Ue.length && (Je = Ue.length - 1), $e === Ge) {
    Je !== Ke && (ue.snapIndex = Je, ue.emit("snapIndexChange")), ue.params.loop && ue.virtual && ue.params.virtual.enabled && (ue.realIndex = Ze($e));
    return;
  }
  let nt;
  ue.virtual && He.virtual.enabled && He.loop ? nt = Ze($e) : ue.slides[$e] ? nt = parseInt(ue.slides[$e].getAttribute("data-swiper-slide-index") || $e, 10) : nt = $e, Object.assign(ue, {
    previousSnapIndex: Ke,
    snapIndex: Je,
    previousRealIndex: Xe,
    realIndex: nt,
    previousIndex: Ge,
    activeIndex: $e
  }), ue.initialized && preload(ue), ue.emit("activeIndexChange"), ue.emit("snapIndexChange"), Xe !== nt && ue.emit("realIndexChange"), (ue.initialized || ue.params.runCallbacksOnInit) && ue.emit("slideChange");
}
function updateClickedSlide(me) {
  const ue = this, Qe = ue.params, Ue = me.closest(`.${Qe.slideClass}, swiper-slide`);
  let He = !1, Ge;
  if (Ue) {
    for (let Xe = 0; Xe < ue.slides.length; Xe += 1)
      if (ue.slides[Xe] === Ue) {
        He = !0, Ge = Xe;
        break;
      }
  }
  if (Ue && He)
    ue.clickedSlide = Ue, ue.virtual && ue.params.virtual.enabled ? ue.clickedIndex = parseInt(Ue.getAttribute("data-swiper-slide-index"), 10) : ue.clickedIndex = Ge;
  else {
    ue.clickedSlide = void 0, ue.clickedIndex = void 0;
    return;
  }
  Qe.slideToClickedSlide && ue.clickedIndex !== void 0 && ue.clickedIndex !== ue.activeIndex && ue.slideToClickedSlide();
}
const update$2 = {
  updateSize,
  updateSlides,
  updateAutoHeight,
  updateSlidesOffset,
  updateSlidesProgress,
  updateProgress,
  updateSlidesClasses,
  updateActiveIndex,
  updateClickedSlide
};
function getSwiperTranslate(me = this.isHorizontal() ? "x" : "y") {
  const ue = this, {
    params: Qe,
    rtlTranslate: Ue,
    translate: He,
    wrapperEl: Ge
  } = ue;
  if (Qe.virtualTranslate)
    return Ue ? -He : He;
  if (Qe.cssMode)
    return He;
  let Xe = getTranslate(Ge, me);
  return Xe += ue.cssOverflowAdjustment(), Ue && (Xe = -Xe), Xe || 0;
}
function setTranslate(me, ue) {
  const Qe = this, {
    rtlTranslate: Ue,
    params: He,
    wrapperEl: Ge,
    progress: Xe
  } = Qe;
  let Ke = 0, $e = 0;
  const Je = 0;
  Qe.isHorizontal() ? Ke = Ue ? -me : me : $e = me, He.roundLengths && (Ke = Math.floor(Ke), $e = Math.floor($e)), Qe.previousTranslate = Qe.translate, Qe.translate = Qe.isHorizontal() ? Ke : $e, He.cssMode ? Ge[Qe.isHorizontal() ? "scrollLeft" : "scrollTop"] = Qe.isHorizontal() ? -Ke : -$e : He.virtualTranslate || (Qe.isHorizontal() ? Ke -= Qe.cssOverflowAdjustment() : $e -= Qe.cssOverflowAdjustment(), Ge.style.transform = `translate3d(${Ke}px, ${$e}px, ${Je}px)`);
  let Ze;
  const nt = Qe.maxTranslate() - Qe.minTranslate();
  nt === 0 ? Ze = 0 : Ze = (me - Qe.minTranslate()) / nt, Ze !== Xe && Qe.updateProgress(me), Qe.emit("setTranslate", Qe.translate, ue);
}
function minTranslate() {
  return -this.snapGrid[0];
}
function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function translateTo(me = 0, ue = this.params.speed, Qe = !0, Ue = !0, He) {
  const Ge = this, {
    params: Xe,
    wrapperEl: Ke
  } = Ge;
  if (Ge.animating && Xe.preventInteractionOnTransition)
    return !1;
  const $e = Ge.minTranslate(), Je = Ge.maxTranslate();
  let Ze;
  if (Ue && me > $e ? Ze = $e : Ue && me < Je ? Ze = Je : Ze = me, Ge.updateProgress(Ze), Xe.cssMode) {
    const nt = Ge.isHorizontal();
    if (ue === 0)
      Ke[nt ? "scrollLeft" : "scrollTop"] = -Ze;
    else {
      if (!Ge.support.smoothScroll)
        return animateCSSModeScroll({
          swiper: Ge,
          targetPosition: -Ze,
          side: nt ? "left" : "top"
        }), !0;
      Ke.scrollTo({
        [nt ? "left" : "top"]: -Ze,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return ue === 0 ? (Ge.setTransition(0), Ge.setTranslate(Ze), Qe && (Ge.emit("beforeTransitionStart", ue, He), Ge.emit("transitionEnd"))) : (Ge.setTransition(ue), Ge.setTranslate(Ze), Qe && (Ge.emit("beforeTransitionStart", ue, He), Ge.emit("transitionStart")), Ge.animating || (Ge.animating = !0, Ge.onTranslateToWrapperTransitionEnd || (Ge.onTranslateToWrapperTransitionEnd = function(tt) {
    !Ge || Ge.destroyed || tt.target === this && (Ge.wrapperEl.removeEventListener("transitionend", Ge.onTranslateToWrapperTransitionEnd), Ge.onTranslateToWrapperTransitionEnd = null, delete Ge.onTranslateToWrapperTransitionEnd, Qe && Ge.emit("transitionEnd"));
  }), Ge.wrapperEl.addEventListener("transitionend", Ge.onTranslateToWrapperTransitionEnd))), !0;
}
const translate = {
  getTranslate: getSwiperTranslate,
  setTranslate,
  minTranslate,
  maxTranslate,
  translateTo
};
function setTransition(me, ue) {
  const Qe = this;
  Qe.params.cssMode || (Qe.wrapperEl.style.transitionDuration = `${me}ms`), Qe.emit("setTransition", me, ue);
}
function transitionEmit({
  swiper: me,
  runCallbacks: ue,
  direction: Qe,
  step: Ue
}) {
  const {
    activeIndex: He,
    previousIndex: Ge
  } = me;
  let Xe = Qe;
  if (Xe || (He > Ge ? Xe = "next" : He < Ge ? Xe = "prev" : Xe = "reset"), me.emit(`transition${Ue}`), ue && He !== Ge) {
    if (Xe === "reset") {
      me.emit(`slideResetTransition${Ue}`);
      return;
    }
    me.emit(`slideChangeTransition${Ue}`), Xe === "next" ? me.emit(`slideNextTransition${Ue}`) : me.emit(`slidePrevTransition${Ue}`);
  }
}
function transitionStart(me = !0, ue) {
  const Qe = this, {
    params: Ue
  } = Qe;
  Ue.cssMode || (Ue.autoHeight && Qe.updateAutoHeight(), transitionEmit({
    swiper: Qe,
    runCallbacks: me,
    direction: ue,
    step: "Start"
  }));
}
function transitionEnd(me = !0, ue) {
  const Qe = this, {
    params: Ue
  } = Qe;
  Qe.animating = !1, !Ue.cssMode && (Qe.setTransition(0), transitionEmit({
    swiper: Qe,
    runCallbacks: me,
    direction: ue,
    step: "End"
  }));
}
const transition = {
  setTransition,
  transitionStart,
  transitionEnd
};
function slideTo(me = 0, ue = this.params.speed, Qe = !0, Ue, He) {
  typeof me == "string" && (me = parseInt(me, 10));
  const Ge = this;
  let Xe = me;
  Xe < 0 && (Xe = 0);
  const {
    params: Ke,
    snapGrid: $e,
    slidesGrid: Je,
    previousIndex: Ze,
    activeIndex: nt,
    rtlTranslate: tt,
    wrapperEl: et,
    enabled: rt
  } = Ge;
  if (Ge.animating && Ke.preventInteractionOnTransition || !rt && !Ue && !He)
    return !1;
  const it = Math.min(Ge.params.slidesPerGroupSkip, Xe);
  let ot = it + Math.floor((Xe - it) / Ge.params.slidesPerGroup);
  ot >= $e.length && (ot = $e.length - 1);
  const at = -$e[ot];
  if (Ke.normalizeSlideIndex)
    for (let ut = 0; ut < Je.length; ut += 1) {
      const lt = -Math.floor(at * 100), dt = Math.floor(Je[ut] * 100), At = Math.floor(Je[ut + 1] * 100);
      typeof Je[ut + 1] < "u" ? lt >= dt && lt < At - (At - dt) / 2 ? Xe = ut : lt >= dt && lt < At && (Xe = ut + 1) : lt >= dt && (Xe = ut);
    }
  if (Ge.initialized && Xe !== nt && (!Ge.allowSlideNext && (tt ? at > Ge.translate && at > Ge.minTranslate() : at < Ge.translate && at < Ge.minTranslate()) || !Ge.allowSlidePrev && at > Ge.translate && at > Ge.maxTranslate() && (nt || 0) !== Xe))
    return !1;
  Xe !== (Ze || 0) && Qe && Ge.emit("beforeSlideChangeStart"), Ge.updateProgress(at);
  let st;
  if (Xe > nt ? st = "next" : Xe < nt ? st = "prev" : st = "reset", tt && -at === Ge.translate || !tt && at === Ge.translate)
    return Ge.updateActiveIndex(Xe), Ke.autoHeight && Ge.updateAutoHeight(), Ge.updateSlidesClasses(), Ke.effect !== "slide" && Ge.setTranslate(at), st !== "reset" && (Ge.transitionStart(Qe, st), Ge.transitionEnd(Qe, st)), !1;
  if (Ke.cssMode) {
    const ut = Ge.isHorizontal(), lt = tt ? at : -at;
    if (ue === 0) {
      const dt = Ge.virtual && Ge.params.virtual.enabled;
      dt && (Ge.wrapperEl.style.scrollSnapType = "none", Ge._immediateVirtual = !0), dt && !Ge._cssModeVirtualInitialSet && Ge.params.initialSlide > 0 ? (Ge._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
        et[ut ? "scrollLeft" : "scrollTop"] = lt;
      })) : et[ut ? "scrollLeft" : "scrollTop"] = lt, dt && requestAnimationFrame(() => {
        Ge.wrapperEl.style.scrollSnapType = "", Ge._immediateVirtual = !1;
      });
    } else {
      if (!Ge.support.smoothScroll)
        return animateCSSModeScroll({
          swiper: Ge,
          targetPosition: lt,
          side: ut ? "left" : "top"
        }), !0;
      et.scrollTo({
        [ut ? "left" : "top"]: lt,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return Ge.setTransition(ue), Ge.setTranslate(at), Ge.updateActiveIndex(Xe), Ge.updateSlidesClasses(), Ge.emit("beforeTransitionStart", ue, Ue), Ge.transitionStart(Qe, st), ue === 0 ? Ge.transitionEnd(Qe, st) : Ge.animating || (Ge.animating = !0, Ge.onSlideToWrapperTransitionEnd || (Ge.onSlideToWrapperTransitionEnd = function(lt) {
    !Ge || Ge.destroyed || lt.target === this && (Ge.wrapperEl.removeEventListener("transitionend", Ge.onSlideToWrapperTransitionEnd), Ge.onSlideToWrapperTransitionEnd = null, delete Ge.onSlideToWrapperTransitionEnd, Ge.transitionEnd(Qe, st));
  }), Ge.wrapperEl.addEventListener("transitionend", Ge.onSlideToWrapperTransitionEnd)), !0;
}
function slideToLoop(me = 0, ue = this.params.speed, Qe = !0, Ue) {
  typeof me == "string" && (me = parseInt(me, 10));
  const He = this;
  let Ge = me;
  return He.params.loop && (He.virtual && He.params.virtual.enabled ? Ge = Ge + He.virtual.slidesBefore : Ge = He.getSlideIndexByData(Ge)), He.slideTo(Ge, ue, Qe, Ue);
}
function slideNext(me = this.params.speed, ue = !0, Qe) {
  const Ue = this, {
    enabled: He,
    params: Ge,
    animating: Xe
  } = Ue;
  if (!He) return Ue;
  let Ke = Ge.slidesPerGroup;
  Ge.slidesPerView === "auto" && Ge.slidesPerGroup === 1 && Ge.slidesPerGroupAuto && (Ke = Math.max(Ue.slidesPerViewDynamic("current", !0), 1));
  const $e = Ue.activeIndex < Ge.slidesPerGroupSkip ? 1 : Ke, Je = Ue.virtual && Ge.virtual.enabled;
  if (Ge.loop) {
    if (Xe && !Je && Ge.loopPreventsSliding) return !1;
    Ue.loopFix({
      direction: "next"
    }), Ue._clientLeft = Ue.wrapperEl.clientLeft;
  }
  return Ge.rewind && Ue.isEnd ? Ue.slideTo(0, me, ue, Qe) : Ue.slideTo(Ue.activeIndex + $e, me, ue, Qe);
}
function slidePrev(me = this.params.speed, ue = !0, Qe) {
  const Ue = this, {
    params: He,
    snapGrid: Ge,
    slidesGrid: Xe,
    rtlTranslate: Ke,
    enabled: $e,
    animating: Je
  } = Ue;
  if (!$e) return Ue;
  const Ze = Ue.virtual && He.virtual.enabled;
  if (He.loop) {
    if (Je && !Ze && He.loopPreventsSliding) return !1;
    Ue.loopFix({
      direction: "prev"
    }), Ue._clientLeft = Ue.wrapperEl.clientLeft;
  }
  const nt = Ke ? Ue.translate : -Ue.translate;
  function tt(at) {
    return at < 0 ? -Math.floor(Math.abs(at)) : Math.floor(at);
  }
  const et = tt(nt), rt = Ge.map((at) => tt(at));
  let it = Ge[rt.indexOf(et) - 1];
  if (typeof it > "u" && He.cssMode) {
    let at;
    Ge.forEach((st, ut) => {
      et >= st && (at = ut);
    }), typeof at < "u" && (it = Ge[at > 0 ? at - 1 : at]);
  }
  let ot = 0;
  if (typeof it < "u" && (ot = Xe.indexOf(it), ot < 0 && (ot = Ue.activeIndex - 1), He.slidesPerView === "auto" && He.slidesPerGroup === 1 && He.slidesPerGroupAuto && (ot = ot - Ue.slidesPerViewDynamic("previous", !0) + 1, ot = Math.max(ot, 0))), He.rewind && Ue.isBeginning) {
    const at = Ue.params.virtual && Ue.params.virtual.enabled && Ue.virtual ? Ue.virtual.slides.length - 1 : Ue.slides.length - 1;
    return Ue.slideTo(at, me, ue, Qe);
  }
  return Ue.slideTo(ot, me, ue, Qe);
}
function slideReset(me = this.params.speed, ue = !0, Qe) {
  const Ue = this;
  return Ue.slideTo(Ue.activeIndex, me, ue, Qe);
}
function slideToClosest(me = this.params.speed, ue = !0, Qe, Ue = 0.5) {
  const He = this;
  let Ge = He.activeIndex;
  const Xe = Math.min(He.params.slidesPerGroupSkip, Ge), Ke = Xe + Math.floor((Ge - Xe) / He.params.slidesPerGroup), $e = He.rtlTranslate ? He.translate : -He.translate;
  if ($e >= He.snapGrid[Ke]) {
    const Je = He.snapGrid[Ke], Ze = He.snapGrid[Ke + 1];
    $e - Je > (Ze - Je) * Ue && (Ge += He.params.slidesPerGroup);
  } else {
    const Je = He.snapGrid[Ke - 1], Ze = He.snapGrid[Ke];
    $e - Je <= (Ze - Je) * Ue && (Ge -= He.params.slidesPerGroup);
  }
  return Ge = Math.max(Ge, 0), Ge = Math.min(Ge, He.slidesGrid.length - 1), He.slideTo(Ge, me, ue, Qe);
}
function slideToClickedSlide() {
  const me = this, {
    params: ue,
    slidesEl: Qe
  } = me, Ue = ue.slidesPerView === "auto" ? me.slidesPerViewDynamic() : ue.slidesPerView;
  let He = me.clickedIndex, Ge;
  const Xe = me.isElement ? "swiper-slide" : `.${ue.slideClass}`;
  if (ue.loop) {
    if (me.animating) return;
    Ge = parseInt(me.clickedSlide.getAttribute("data-swiper-slide-index"), 10), ue.centeredSlides ? He < me.loopedSlides - Ue / 2 || He > me.slides.length - me.loopedSlides + Ue / 2 ? (me.loopFix(), He = me.getSlideIndex(elementChildren(Qe, `${Xe}[data-swiper-slide-index="${Ge}"]`)[0]), nextTick(() => {
      me.slideTo(He);
    })) : me.slideTo(He) : He > me.slides.length - Ue ? (me.loopFix(), He = me.getSlideIndex(elementChildren(Qe, `${Xe}[data-swiper-slide-index="${Ge}"]`)[0]), nextTick(() => {
      me.slideTo(He);
    })) : me.slideTo(He);
  } else
    me.slideTo(He);
}
const slide = {
  slideTo,
  slideToLoop,
  slideNext,
  slidePrev,
  slideReset,
  slideToClosest,
  slideToClickedSlide
};
function loopCreate(me) {
  const ue = this, {
    params: Qe,
    slidesEl: Ue
  } = ue;
  if (!Qe.loop || ue.virtual && ue.params.virtual.enabled) return;
  elementChildren(Ue, `.${Qe.slideClass}, swiper-slide`).forEach((Ge, Xe) => {
    Ge.setAttribute("data-swiper-slide-index", Xe);
  }), ue.loopFix({
    slideRealIndex: me,
    direction: Qe.centeredSlides ? void 0 : "next"
  });
}
function loopFix({
  slideRealIndex: me,
  slideTo: ue = !0,
  direction: Qe,
  setTranslate: Ue,
  activeSlideIndex: He,
  byController: Ge,
  byMousewheel: Xe
} = {}) {
  const Ke = this;
  if (!Ke.params.loop) return;
  Ke.emit("beforeLoopFix");
  const {
    slides: $e,
    allowSlidePrev: Je,
    allowSlideNext: Ze,
    slidesEl: nt,
    params: tt
  } = Ke;
  if (Ke.allowSlidePrev = !0, Ke.allowSlideNext = !0, Ke.virtual && tt.virtual.enabled) {
    ue && (!tt.centeredSlides && Ke.snapIndex === 0 ? Ke.slideTo(Ke.virtual.slides.length, 0, !1, !0) : tt.centeredSlides && Ke.snapIndex < tt.slidesPerView ? Ke.slideTo(Ke.virtual.slides.length + Ke.snapIndex, 0, !1, !0) : Ke.snapIndex === Ke.snapGrid.length - 1 && Ke.slideTo(Ke.virtual.slidesBefore, 0, !1, !0)), Ke.allowSlidePrev = Je, Ke.allowSlideNext = Ze, Ke.emit("loopFix");
    return;
  }
  const et = tt.slidesPerView === "auto" ? Ke.slidesPerViewDynamic() : Math.ceil(parseFloat(tt.slidesPerView, 10));
  let rt = tt.loopedSlides || et;
  rt % tt.slidesPerGroup !== 0 && (rt += tt.slidesPerGroup - rt % tt.slidesPerGroup), Ke.loopedSlides = rt;
  const it = [], ot = [];
  let at = Ke.activeIndex;
  typeof He > "u" ? He = Ke.getSlideIndex(Ke.slides.filter((At) => At.classList.contains(tt.slideActiveClass))[0]) : at = He;
  const st = Qe === "next" || !Qe, ut = Qe === "prev" || !Qe;
  let lt = 0, dt = 0;
  if (He < rt) {
    lt = Math.max(rt - He, tt.slidesPerGroup);
    for (let At = 0; At < rt - He; At += 1) {
      const pt = At - Math.floor(At / $e.length) * $e.length;
      it.push($e.length - pt - 1);
    }
  } else if (He > Ke.slides.length - rt * 2) {
    dt = Math.max(He - (Ke.slides.length - rt * 2), tt.slidesPerGroup);
    for (let At = 0; At < dt; At += 1) {
      const pt = At - Math.floor(At / $e.length) * $e.length;
      ot.push(pt);
    }
  }
  if (ut && it.forEach((At) => {
    Ke.slides[At].swiperLoopMoveDOM = !0, nt.prepend(Ke.slides[At]), Ke.slides[At].swiperLoopMoveDOM = !1;
  }), st && ot.forEach((At) => {
    Ke.slides[At].swiperLoopMoveDOM = !0, nt.append(Ke.slides[At]), Ke.slides[At].swiperLoopMoveDOM = !1;
  }), Ke.recalcSlides(), tt.slidesPerView === "auto" && Ke.updateSlides(), tt.watchSlidesProgress && Ke.updateSlidesOffset(), ue) {
    if (it.length > 0 && ut)
      if (typeof me > "u") {
        const At = Ke.slidesGrid[at], gt = Ke.slidesGrid[at + lt] - At;
        Xe ? Ke.setTranslate(Ke.translate - gt) : (Ke.slideTo(at + lt, 0, !1, !0), Ue && (Ke.touches[Ke.isHorizontal() ? "startX" : "startY"] += gt));
      } else
        Ue && Ke.slideToLoop(me, 0, !1, !0);
    else if (ot.length > 0 && st)
      if (typeof me > "u") {
        const At = Ke.slidesGrid[at], gt = Ke.slidesGrid[at - dt] - At;
        Xe ? Ke.setTranslate(Ke.translate - gt) : (Ke.slideTo(at - dt, 0, !1, !0), Ue && (Ke.touches[Ke.isHorizontal() ? "startX" : "startY"] += gt));
      } else
        Ke.slideToLoop(me, 0, !1, !0);
  }
  if (Ke.allowSlidePrev = Je, Ke.allowSlideNext = Ze, Ke.controller && Ke.controller.control && !Ge) {
    const At = {
      slideRealIndex: me,
      slideTo: !1,
      direction: Qe,
      setTranslate: Ue,
      activeSlideIndex: He,
      byController: !0
    };
    Array.isArray(Ke.controller.control) ? Ke.controller.control.forEach((pt) => {
      !pt.destroyed && pt.params.loop && pt.loopFix(At);
    }) : Ke.controller.control instanceof Ke.constructor && Ke.controller.control.params.loop && Ke.controller.control.loopFix(At);
  }
  Ke.emit("loopFix");
}
function loopDestroy() {
  const me = this, {
    params: ue,
    slidesEl: Qe
  } = me;
  if (!ue.loop || me.virtual && me.params.virtual.enabled) return;
  me.recalcSlides();
  const Ue = [];
  me.slides.forEach((He) => {
    const Ge = typeof He.swiperSlideIndex > "u" ? He.getAttribute("data-swiper-slide-index") * 1 : He.swiperSlideIndex;
    Ue[Ge] = He;
  }), me.slides.forEach((He) => {
    He.removeAttribute("data-swiper-slide-index");
  }), Ue.forEach((He) => {
    Qe.append(He);
  }), me.recalcSlides(), me.slideTo(me.realIndex, 0);
}
const loop = {
  loopCreate,
  loopFix,
  loopDestroy
};
function setGrabCursor(me) {
  const ue = this;
  if (!ue.params.simulateTouch || ue.params.watchOverflow && ue.isLocked || ue.params.cssMode) return;
  const Qe = ue.params.touchEventsTarget === "container" ? ue.el : ue.wrapperEl;
  ue.isElement && (ue.__preventObserver__ = !0), Qe.style.cursor = "move", Qe.style.cursor = me ? "grabbing" : "grab", ue.isElement && requestAnimationFrame(() => {
    ue.__preventObserver__ = !1;
  });
}
function unsetGrabCursor() {
  const me = this;
  me.params.watchOverflow && me.isLocked || me.params.cssMode || (me.isElement && (me.__preventObserver__ = !0), me[me.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", me.isElement && requestAnimationFrame(() => {
    me.__preventObserver__ = !1;
  }));
}
const grabCursor = {
  setGrabCursor,
  unsetGrabCursor
};
function closestElement(me, ue = this) {
  function Qe(Ue) {
    if (!Ue || Ue === getDocument() || Ue === getWindow()) return null;
    Ue.assignedSlot && (Ue = Ue.assignedSlot);
    const He = Ue.closest(me);
    return !He && !Ue.getRootNode ? null : He || Qe(Ue.getRootNode().host);
  }
  return Qe(ue);
}
function onTouchStart(me) {
  const ue = this, Qe = getDocument(), Ue = getWindow(), He = ue.touchEventsData;
  He.evCache.push(me);
  const {
    params: Ge,
    touches: Xe,
    enabled: Ke
  } = ue;
  if (!Ke || !Ge.simulateTouch && me.pointerType === "mouse" || ue.animating && Ge.preventInteractionOnTransition)
    return;
  !ue.animating && Ge.cssMode && Ge.loop && ue.loopFix();
  let $e = me;
  $e.originalEvent && ($e = $e.originalEvent);
  let Je = $e.target;
  if (Ge.touchEventsTarget === "wrapper" && !ue.wrapperEl.contains(Je) || "which" in $e && $e.which === 3 || "button" in $e && $e.button > 0 || He.isTouched && He.isMoved) return;
  const Ze = !!Ge.noSwipingClass && Ge.noSwipingClass !== "", nt = me.composedPath ? me.composedPath() : me.path;
  Ze && $e.target && $e.target.shadowRoot && nt && (Je = nt[0]);
  const tt = Ge.noSwipingSelector ? Ge.noSwipingSelector : `.${Ge.noSwipingClass}`, et = !!($e.target && $e.target.shadowRoot);
  if (Ge.noSwiping && (et ? closestElement(tt, Je) : Je.closest(tt))) {
    ue.allowClick = !0;
    return;
  }
  if (Ge.swipeHandler && !Je.closest(Ge.swipeHandler))
    return;
  Xe.currentX = $e.pageX, Xe.currentY = $e.pageY;
  const rt = Xe.currentX, it = Xe.currentY, ot = Ge.edgeSwipeDetection || Ge.iOSEdgeSwipeDetection, at = Ge.edgeSwipeThreshold || Ge.iOSEdgeSwipeThreshold;
  if (ot && (rt <= at || rt >= Ue.innerWidth - at))
    if (ot === "prevent")
      me.preventDefault();
    else
      return;
  Object.assign(He, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), Xe.startX = rt, Xe.startY = it, He.touchStartTime = now(), ue.allowClick = !0, ue.updateSize(), ue.swipeDirection = void 0, Ge.threshold > 0 && (He.allowThresholdMove = !1);
  let st = !0;
  Je.matches(He.focusableElements) && (st = !1, Je.nodeName === "SELECT" && (He.isTouched = !1)), Qe.activeElement && Qe.activeElement.matches(He.focusableElements) && Qe.activeElement !== Je && Qe.activeElement.blur();
  const ut = st && ue.allowTouchMove && Ge.touchStartPreventDefault;
  (Ge.touchStartForcePreventDefault || ut) && !Je.isContentEditable && $e.preventDefault(), Ge.freeMode && Ge.freeMode.enabled && ue.freeMode && ue.animating && !Ge.cssMode && ue.freeMode.onTouchStart(), ue.emit("touchStart", $e);
}
function onTouchMove(me) {
  const ue = getDocument(), Qe = this, Ue = Qe.touchEventsData, {
    params: He,
    touches: Ge,
    rtlTranslate: Xe,
    enabled: Ke
  } = Qe;
  if (!Ke || !He.simulateTouch && me.pointerType === "mouse") return;
  let $e = me;
  if ($e.originalEvent && ($e = $e.originalEvent), !Ue.isTouched) {
    Ue.startMoving && Ue.isScrolling && Qe.emit("touchMoveOpposite", $e);
    return;
  }
  const Je = Ue.evCache.findIndex((At) => At.pointerId === $e.pointerId);
  Je >= 0 && (Ue.evCache[Je] = $e);
  const Ze = Ue.evCache.length > 1 ? Ue.evCache[0] : $e, nt = Ze.pageX, tt = Ze.pageY;
  if ($e.preventedByNestedSwiper) {
    Ge.startX = nt, Ge.startY = tt;
    return;
  }
  if (!Qe.allowTouchMove) {
    $e.target.matches(Ue.focusableElements) || (Qe.allowClick = !1), Ue.isTouched && (Object.assign(Ge, {
      startX: nt,
      startY: tt,
      prevX: Qe.touches.currentX,
      prevY: Qe.touches.currentY,
      currentX: nt,
      currentY: tt
    }), Ue.touchStartTime = now());
    return;
  }
  if (He.touchReleaseOnEdges && !He.loop) {
    if (Qe.isVertical()) {
      if (tt < Ge.startY && Qe.translate <= Qe.maxTranslate() || tt > Ge.startY && Qe.translate >= Qe.minTranslate()) {
        Ue.isTouched = !1, Ue.isMoved = !1;
        return;
      }
    } else if (nt < Ge.startX && Qe.translate <= Qe.maxTranslate() || nt > Ge.startX && Qe.translate >= Qe.minTranslate())
      return;
  }
  if (ue.activeElement && $e.target === ue.activeElement && $e.target.matches(Ue.focusableElements)) {
    Ue.isMoved = !0, Qe.allowClick = !1;
    return;
  }
  if (Ue.allowTouchCallbacks && Qe.emit("touchMove", $e), $e.targetTouches && $e.targetTouches.length > 1) return;
  Ge.currentX = nt, Ge.currentY = tt;
  const et = Ge.currentX - Ge.startX, rt = Ge.currentY - Ge.startY;
  if (Qe.params.threshold && Math.sqrt(et ** 2 + rt ** 2) < Qe.params.threshold) return;
  if (typeof Ue.isScrolling > "u") {
    let At;
    Qe.isHorizontal() && Ge.currentY === Ge.startY || Qe.isVertical() && Ge.currentX === Ge.startX ? Ue.isScrolling = !1 : et * et + rt * rt >= 25 && (At = Math.atan2(Math.abs(rt), Math.abs(et)) * 180 / Math.PI, Ue.isScrolling = Qe.isHorizontal() ? At > He.touchAngle : 90 - At > He.touchAngle);
  }
  if (Ue.isScrolling && Qe.emit("touchMoveOpposite", $e), typeof Ue.startMoving > "u" && (Ge.currentX !== Ge.startX || Ge.currentY !== Ge.startY) && (Ue.startMoving = !0), Ue.isScrolling || Qe.zoom && Qe.params.zoom && Qe.params.zoom.enabled && Ue.evCache.length > 1) {
    Ue.isTouched = !1;
    return;
  }
  if (!Ue.startMoving)
    return;
  Qe.allowClick = !1, !He.cssMode && $e.cancelable && $e.preventDefault(), He.touchMoveStopPropagation && !He.nested && $e.stopPropagation();
  let it = Qe.isHorizontal() ? et : rt, ot = Qe.isHorizontal() ? Ge.currentX - Ge.previousX : Ge.currentY - Ge.previousY;
  He.oneWayMovement && (it = Math.abs(it) * (Xe ? 1 : -1), ot = Math.abs(ot) * (Xe ? 1 : -1)), Ge.diff = it, it *= He.touchRatio, Xe && (it = -it, ot = -ot);
  const at = Qe.touchesDirection;
  Qe.swipeDirection = it > 0 ? "prev" : "next", Qe.touchesDirection = ot > 0 ? "prev" : "next";
  const st = Qe.params.loop && !He.cssMode;
  if (!Ue.isMoved) {
    if (st && Qe.loopFix({
      direction: Qe.swipeDirection
    }), Ue.startTranslate = Qe.getTranslate(), Qe.setTransition(0), Qe.animating) {
      const At = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0
      });
      Qe.wrapperEl.dispatchEvent(At);
    }
    Ue.allowMomentumBounce = !1, He.grabCursor && (Qe.allowSlideNext === !0 || Qe.allowSlidePrev === !0) && Qe.setGrabCursor(!0), Qe.emit("sliderFirstMove", $e);
  }
  let ut;
  Ue.isMoved && at !== Qe.touchesDirection && st && Math.abs(it) >= 1 && (Qe.loopFix({
    direction: Qe.swipeDirection,
    setTranslate: !0
  }), ut = !0), Qe.emit("sliderMove", $e), Ue.isMoved = !0, Ue.currentTranslate = it + Ue.startTranslate;
  let lt = !0, dt = He.resistanceRatio;
  if (He.touchReleaseOnEdges && (dt = 0), it > 0 ? (st && !ut && Ue.currentTranslate > (He.centeredSlides ? Qe.minTranslate() - Qe.size / 2 : Qe.minTranslate()) && Qe.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), Ue.currentTranslate > Qe.minTranslate() && (lt = !1, He.resistance && (Ue.currentTranslate = Qe.minTranslate() - 1 + (-Qe.minTranslate() + Ue.startTranslate + it) ** dt))) : it < 0 && (st && !ut && Ue.currentTranslate < (He.centeredSlides ? Qe.maxTranslate() + Qe.size / 2 : Qe.maxTranslate()) && Qe.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: Qe.slides.length - (He.slidesPerView === "auto" ? Qe.slidesPerViewDynamic() : Math.ceil(parseFloat(He.slidesPerView, 10)))
  }), Ue.currentTranslate < Qe.maxTranslate() && (lt = !1, He.resistance && (Ue.currentTranslate = Qe.maxTranslate() + 1 - (Qe.maxTranslate() - Ue.startTranslate - it) ** dt))), lt && ($e.preventedByNestedSwiper = !0), !Qe.allowSlideNext && Qe.swipeDirection === "next" && Ue.currentTranslate < Ue.startTranslate && (Ue.currentTranslate = Ue.startTranslate), !Qe.allowSlidePrev && Qe.swipeDirection === "prev" && Ue.currentTranslate > Ue.startTranslate && (Ue.currentTranslate = Ue.startTranslate), !Qe.allowSlidePrev && !Qe.allowSlideNext && (Ue.currentTranslate = Ue.startTranslate), He.threshold > 0)
    if (Math.abs(it) > He.threshold || Ue.allowThresholdMove) {
      if (!Ue.allowThresholdMove) {
        Ue.allowThresholdMove = !0, Ge.startX = Ge.currentX, Ge.startY = Ge.currentY, Ue.currentTranslate = Ue.startTranslate, Ge.diff = Qe.isHorizontal() ? Ge.currentX - Ge.startX : Ge.currentY - Ge.startY;
        return;
      }
    } else {
      Ue.currentTranslate = Ue.startTranslate;
      return;
    }
  !He.followFinger || He.cssMode || ((He.freeMode && He.freeMode.enabled && Qe.freeMode || He.watchSlidesProgress) && (Qe.updateActiveIndex(), Qe.updateSlidesClasses()), He.freeMode && He.freeMode.enabled && Qe.freeMode && Qe.freeMode.onTouchMove(), Qe.updateProgress(Ue.currentTranslate), Qe.setTranslate(Ue.currentTranslate));
}
function onTouchEnd(me) {
  const ue = this, Qe = ue.touchEventsData, Ue = Qe.evCache.findIndex((ut) => ut.pointerId === me.pointerId);
  if (Ue >= 0 && Qe.evCache.splice(Ue, 1), ["pointercancel", "pointerout", "pointerleave"].includes(me.type) && !(me.type === "pointercancel" && (ue.browser.isSafari || ue.browser.isWebView)))
    return;
  const {
    params: He,
    touches: Ge,
    rtlTranslate: Xe,
    slidesGrid: Ke,
    enabled: $e
  } = ue;
  if (!$e || !He.simulateTouch && me.pointerType === "mouse") return;
  let Je = me;
  if (Je.originalEvent && (Je = Je.originalEvent), Qe.allowTouchCallbacks && ue.emit("touchEnd", Je), Qe.allowTouchCallbacks = !1, !Qe.isTouched) {
    Qe.isMoved && He.grabCursor && ue.setGrabCursor(!1), Qe.isMoved = !1, Qe.startMoving = !1;
    return;
  }
  He.grabCursor && Qe.isMoved && Qe.isTouched && (ue.allowSlideNext === !0 || ue.allowSlidePrev === !0) && ue.setGrabCursor(!1);
  const Ze = now(), nt = Ze - Qe.touchStartTime;
  if (ue.allowClick) {
    const ut = Je.path || Je.composedPath && Je.composedPath();
    ue.updateClickedSlide(ut && ut[0] || Je.target), ue.emit("tap click", Je), nt < 300 && Ze - Qe.lastClickTime < 300 && ue.emit("doubleTap doubleClick", Je);
  }
  if (Qe.lastClickTime = now(), nextTick(() => {
    ue.destroyed || (ue.allowClick = !0);
  }), !Qe.isTouched || !Qe.isMoved || !ue.swipeDirection || Ge.diff === 0 || Qe.currentTranslate === Qe.startTranslate) {
    Qe.isTouched = !1, Qe.isMoved = !1, Qe.startMoving = !1;
    return;
  }
  Qe.isTouched = !1, Qe.isMoved = !1, Qe.startMoving = !1;
  let tt;
  if (He.followFinger ? tt = Xe ? ue.translate : -ue.translate : tt = -Qe.currentTranslate, He.cssMode)
    return;
  if (He.freeMode && He.freeMode.enabled) {
    ue.freeMode.onTouchEnd({
      currentPos: tt
    });
    return;
  }
  let et = 0, rt = ue.slidesSizesGrid[0];
  for (let ut = 0; ut < Ke.length; ut += ut < He.slidesPerGroupSkip ? 1 : He.slidesPerGroup) {
    const lt = ut < He.slidesPerGroupSkip - 1 ? 1 : He.slidesPerGroup;
    typeof Ke[ut + lt] < "u" ? tt >= Ke[ut] && tt < Ke[ut + lt] && (et = ut, rt = Ke[ut + lt] - Ke[ut]) : tt >= Ke[ut] && (et = ut, rt = Ke[Ke.length - 1] - Ke[Ke.length - 2]);
  }
  let it = null, ot = null;
  He.rewind && (ue.isBeginning ? ot = He.virtual && He.virtual.enabled && ue.virtual ? ue.virtual.slides.length - 1 : ue.slides.length - 1 : ue.isEnd && (it = 0));
  const at = (tt - Ke[et]) / rt, st = et < He.slidesPerGroupSkip - 1 ? 1 : He.slidesPerGroup;
  if (nt > He.longSwipesMs) {
    if (!He.longSwipes) {
      ue.slideTo(ue.activeIndex);
      return;
    }
    ue.swipeDirection === "next" && (at >= He.longSwipesRatio ? ue.slideTo(He.rewind && ue.isEnd ? it : et + st) : ue.slideTo(et)), ue.swipeDirection === "prev" && (at > 1 - He.longSwipesRatio ? ue.slideTo(et + st) : ot !== null && at < 0 && Math.abs(at) > He.longSwipesRatio ? ue.slideTo(ot) : ue.slideTo(et));
  } else {
    if (!He.shortSwipes) {
      ue.slideTo(ue.activeIndex);
      return;
    }
    ue.navigation && (Je.target === ue.navigation.nextEl || Je.target === ue.navigation.prevEl) ? Je.target === ue.navigation.nextEl ? ue.slideTo(et + st) : ue.slideTo(et) : (ue.swipeDirection === "next" && ue.slideTo(it !== null ? it : et + st), ue.swipeDirection === "prev" && ue.slideTo(ot !== null ? ot : et));
  }
}
function onResize() {
  const me = this, {
    params: ue,
    el: Qe
  } = me;
  if (Qe && Qe.offsetWidth === 0) return;
  ue.breakpoints && me.setBreakpoint();
  const {
    allowSlideNext: Ue,
    allowSlidePrev: He,
    snapGrid: Ge
  } = me, Xe = me.virtual && me.params.virtual.enabled;
  me.allowSlideNext = !0, me.allowSlidePrev = !0, me.updateSize(), me.updateSlides(), me.updateSlidesClasses();
  const Ke = Xe && ue.loop;
  (ue.slidesPerView === "auto" || ue.slidesPerView > 1) && me.isEnd && !me.isBeginning && !me.params.centeredSlides && !Ke ? me.slideTo(me.slides.length - 1, 0, !1, !0) : me.params.loop && !Xe ? me.slideToLoop(me.realIndex, 0, !1, !0) : me.slideTo(me.activeIndex, 0, !1, !0), me.autoplay && me.autoplay.running && me.autoplay.paused && (clearTimeout(me.autoplay.resizeTimeout), me.autoplay.resizeTimeout = setTimeout(() => {
    me.autoplay && me.autoplay.running && me.autoplay.paused && me.autoplay.resume();
  }, 500)), me.allowSlidePrev = He, me.allowSlideNext = Ue, me.params.watchOverflow && Ge !== me.snapGrid && me.checkOverflow();
}
function onClick(me) {
  const ue = this;
  ue.enabled && (ue.allowClick || (ue.params.preventClicks && me.preventDefault(), ue.params.preventClicksPropagation && ue.animating && (me.stopPropagation(), me.stopImmediatePropagation())));
}
function onScroll() {
  const me = this, {
    wrapperEl: ue,
    rtlTranslate: Qe,
    enabled: Ue
  } = me;
  if (!Ue) return;
  me.previousTranslate = me.translate, me.isHorizontal() ? me.translate = -ue.scrollLeft : me.translate = -ue.scrollTop, me.translate === 0 && (me.translate = 0), me.updateActiveIndex(), me.updateSlidesClasses();
  let He;
  const Ge = me.maxTranslate() - me.minTranslate();
  Ge === 0 ? He = 0 : He = (me.translate - me.minTranslate()) / Ge, He !== me.progress && me.updateProgress(Qe ? -me.translate : me.translate), me.emit("setTranslate", me.translate, !1);
}
function onLoad(me) {
  const ue = this;
  processLazyPreloader(ue, me.target), !(ue.params.cssMode || ue.params.slidesPerView !== "auto" && !ue.params.autoHeight) && ue.update();
}
let dummyEventAttached = !1;
function dummyEventListener() {
}
const events = (me, ue) => {
  const Qe = getDocument(), {
    params: Ue,
    el: He,
    wrapperEl: Ge,
    device: Xe
  } = me, Ke = !!Ue.nested, $e = ue === "on" ? "addEventListener" : "removeEventListener", Je = ue;
  He[$e]("pointerdown", me.onTouchStart, {
    passive: !1
  }), Qe[$e]("pointermove", me.onTouchMove, {
    passive: !1,
    capture: Ke
  }), Qe[$e]("pointerup", me.onTouchEnd, {
    passive: !0
  }), Qe[$e]("pointercancel", me.onTouchEnd, {
    passive: !0
  }), Qe[$e]("pointerout", me.onTouchEnd, {
    passive: !0
  }), Qe[$e]("pointerleave", me.onTouchEnd, {
    passive: !0
  }), (Ue.preventClicks || Ue.preventClicksPropagation) && He[$e]("click", me.onClick, !0), Ue.cssMode && Ge[$e]("scroll", me.onScroll), Ue.updateOnWindowResize ? me[Je](Xe.ios || Xe.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", onResize, !0) : me[Je]("observerUpdate", onResize, !0), He[$e]("load", me.onLoad, {
    capture: !0
  });
};
function attachEvents() {
  const me = this, ue = getDocument(), {
    params: Qe
  } = me;
  me.onTouchStart = onTouchStart.bind(me), me.onTouchMove = onTouchMove.bind(me), me.onTouchEnd = onTouchEnd.bind(me), Qe.cssMode && (me.onScroll = onScroll.bind(me)), me.onClick = onClick.bind(me), me.onLoad = onLoad.bind(me), dummyEventAttached || (ue.addEventListener("touchstart", dummyEventListener), dummyEventAttached = !0), events(me, "on");
}
function detachEvents() {
  events(this, "off");
}
const events$1 = {
  attachEvents,
  detachEvents
}, isGridEnabled = (me, ue) => me.grid && ue.grid && ue.grid.rows > 1;
function setBreakpoint() {
  const me = this, {
    realIndex: ue,
    initialized: Qe,
    params: Ue,
    el: He
  } = me, Ge = Ue.breakpoints;
  if (!Ge || Ge && Object.keys(Ge).length === 0) return;
  const Xe = me.getBreakpoint(Ge, me.params.breakpointsBase, me.el);
  if (!Xe || me.currentBreakpoint === Xe) return;
  const $e = (Xe in Ge ? Ge[Xe] : void 0) || me.originalParams, Je = isGridEnabled(me, Ue), Ze = isGridEnabled(me, $e), nt = Ue.enabled;
  Je && !Ze ? (He.classList.remove(`${Ue.containerModifierClass}grid`, `${Ue.containerModifierClass}grid-column`), me.emitContainerClasses()) : !Je && Ze && (He.classList.add(`${Ue.containerModifierClass}grid`), ($e.grid.fill && $e.grid.fill === "column" || !$e.grid.fill && Ue.grid.fill === "column") && He.classList.add(`${Ue.containerModifierClass}grid-column`), me.emitContainerClasses()), ["navigation", "pagination", "scrollbar"].forEach((it) => {
    if (typeof $e[it] > "u") return;
    const ot = Ue[it] && Ue[it].enabled, at = $e[it] && $e[it].enabled;
    ot && !at && me[it].disable(), !ot && at && me[it].enable();
  });
  const tt = $e.direction && $e.direction !== Ue.direction, et = Ue.loop && ($e.slidesPerView !== Ue.slidesPerView || tt);
  tt && Qe && me.changeDirection(), extend$2(me.params, $e);
  const rt = me.params.enabled;
  Object.assign(me, {
    allowTouchMove: me.params.allowTouchMove,
    allowSlideNext: me.params.allowSlideNext,
    allowSlidePrev: me.params.allowSlidePrev
  }), nt && !rt ? me.disable() : !nt && rt && me.enable(), me.currentBreakpoint = Xe, me.emit("_beforeBreakpoint", $e), et && Qe && (me.loopDestroy(), me.loopCreate(ue), me.updateSlides()), me.emit("breakpoint", $e);
}
function getBreakpoint(me, ue = "window", Qe) {
  if (!me || ue === "container" && !Qe) return;
  let Ue = !1;
  const He = getWindow(), Ge = ue === "window" ? He.innerHeight : Qe.clientHeight, Xe = Object.keys(me).map((Ke) => {
    if (typeof Ke == "string" && Ke.indexOf("@") === 0) {
      const $e = parseFloat(Ke.substr(1));
      return {
        value: Ge * $e,
        point: Ke
      };
    }
    return {
      value: Ke,
      point: Ke
    };
  });
  Xe.sort((Ke, $e) => parseInt(Ke.value, 10) - parseInt($e.value, 10));
  for (let Ke = 0; Ke < Xe.length; Ke += 1) {
    const {
      point: $e,
      value: Je
    } = Xe[Ke];
    ue === "window" ? He.matchMedia(`(min-width: ${Je}px)`).matches && (Ue = $e) : Je <= Qe.clientWidth && (Ue = $e);
  }
  return Ue || "max";
}
const breakpoints = {
  setBreakpoint,
  getBreakpoint
};
function prepareClasses(me, ue) {
  const Qe = [];
  return me.forEach((Ue) => {
    typeof Ue == "object" ? Object.keys(Ue).forEach((He) => {
      Ue[He] && Qe.push(ue + He);
    }) : typeof Ue == "string" && Qe.push(ue + Ue);
  }), Qe;
}
function addClasses() {
  const me = this, {
    classNames: ue,
    params: Qe,
    rtl: Ue,
    el: He,
    device: Ge
  } = me, Xe = prepareClasses(["initialized", Qe.direction, {
    "free-mode": me.params.freeMode && Qe.freeMode.enabled
  }, {
    autoheight: Qe.autoHeight
  }, {
    rtl: Ue
  }, {
    grid: Qe.grid && Qe.grid.rows > 1
  }, {
    "grid-column": Qe.grid && Qe.grid.rows > 1 && Qe.grid.fill === "column"
  }, {
    android: Ge.android
  }, {
    ios: Ge.ios
  }, {
    "css-mode": Qe.cssMode
  }, {
    centered: Qe.cssMode && Qe.centeredSlides
  }, {
    "watch-progress": Qe.watchSlidesProgress
  }], Qe.containerModifierClass);
  ue.push(...Xe), He.classList.add(...ue), me.emitContainerClasses();
}
function removeClasses() {
  const me = this, {
    el: ue,
    classNames: Qe
  } = me;
  ue.classList.remove(...Qe), me.emitContainerClasses();
}
const classes = {
  addClasses,
  removeClasses
};
function checkOverflow() {
  const me = this, {
    isLocked: ue,
    params: Qe
  } = me, {
    slidesOffsetBefore: Ue
  } = Qe;
  if (Ue) {
    const He = me.slides.length - 1, Ge = me.slidesGrid[He] + me.slidesSizesGrid[He] + Ue * 2;
    me.isLocked = me.size > Ge;
  } else
    me.isLocked = me.snapGrid.length === 1;
  Qe.allowSlideNext === !0 && (me.allowSlideNext = !me.isLocked), Qe.allowSlidePrev === !0 && (me.allowSlidePrev = !me.isLocked), ue && ue !== me.isLocked && (me.isEnd = !1), ue !== me.isLocked && me.emit(me.isLocked ? "lock" : "unlock");
}
const checkOverflow$1 = {
  checkOverflow
}, defaults$4 = {
  init: !0,
  direction: "horizontal",
  oneWayMovement: !1,
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 5,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // loop
  loop: !1,
  loopedSlides: null,
  loopPreventsSliding: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function moduleExtendParams(me, ue) {
  return function(Ue = {}) {
    const He = Object.keys(Ue)[0], Ge = Ue[He];
    if (typeof Ge != "object" || Ge === null) {
      extend$2(ue, Ue);
      return;
    }
    if (["navigation", "pagination", "scrollbar"].indexOf(He) >= 0 && me[He] === !0 && (me[He] = {
      auto: !0
    }), !(He in me && "enabled" in Ge)) {
      extend$2(ue, Ue);
      return;
    }
    me[He] === !0 && (me[He] = {
      enabled: !0
    }), typeof me[He] == "object" && !("enabled" in me[He]) && (me[He].enabled = !0), me[He] || (me[He] = {
      enabled: !1
    }), extend$2(ue, Ue);
  };
}
const prototypes = {
  eventsEmitter,
  update: update$2,
  translate,
  transition,
  slide,
  loop,
  grabCursor,
  events: events$1,
  breakpoints,
  checkOverflow: checkOverflow$1,
  classes
}, extendedDefaults = {};
let Swiper$1 = class po {
  constructor(...ue) {
    let Qe, Ue;
    ue.length === 1 && ue[0].constructor && Object.prototype.toString.call(ue[0]).slice(8, -1) === "Object" ? Ue = ue[0] : [Qe, Ue] = ue, Ue || (Ue = {}), Ue = extend$2({}, Ue), Qe && !Ue.el && (Ue.el = Qe);
    const He = getDocument();
    if (Ue.el && typeof Ue.el == "string" && He.querySelectorAll(Ue.el).length > 1) {
      const $e = [];
      return He.querySelectorAll(Ue.el).forEach((Je) => {
        const Ze = extend$2({}, Ue, {
          el: Je
        });
        $e.push(new po(Ze));
      }), $e;
    }
    const Ge = this;
    Ge.__swiper__ = !0, Ge.support = getSupport(), Ge.device = getDevice({
      userAgent: Ue.userAgent
    }), Ge.browser = getBrowser(), Ge.eventsListeners = {}, Ge.eventsAnyListeners = [], Ge.modules = [...Ge.__modules__], Ue.modules && Array.isArray(Ue.modules) && Ge.modules.push(...Ue.modules);
    const Xe = {};
    Ge.modules.forEach(($e) => {
      $e({
        params: Ue,
        swiper: Ge,
        extendParams: moduleExtendParams(Ue, Xe),
        on: Ge.on.bind(Ge),
        once: Ge.once.bind(Ge),
        off: Ge.off.bind(Ge),
        emit: Ge.emit.bind(Ge)
      });
    });
    const Ke = extend$2({}, defaults$4, Xe);
    return Ge.params = extend$2({}, Ke, extendedDefaults, Ue), Ge.originalParams = extend$2({}, Ge.params), Ge.passedParams = extend$2({}, Ue), Ge.params && Ge.params.on && Object.keys(Ge.params.on).forEach(($e) => {
      Ge.on($e, Ge.params.on[$e]);
    }), Ge.params && Ge.params.onAny && Ge.onAny(Ge.params.onAny), Object.assign(Ge, {
      enabled: Ge.params.enabled,
      el: Qe,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return Ge.params.direction === "horizontal";
      },
      isVertical() {
        return Ge.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: Ge.params.allowSlideNext,
      allowSlidePrev: Ge.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: Ge.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        evCache: []
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: Ge.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), Ge.emit("_swiper"), Ge.params.init && Ge.init(), Ge;
  }
  getSlideIndex(ue) {
    const {
      slidesEl: Qe,
      params: Ue
    } = this, He = elementChildren(Qe, `.${Ue.slideClass}, swiper-slide`), Ge = elementIndex(He[0]);
    return elementIndex(ue) - Ge;
  }
  getSlideIndexByData(ue) {
    return this.getSlideIndex(this.slides.filter((Qe) => Qe.getAttribute("data-swiper-slide-index") * 1 === ue)[0]);
  }
  recalcSlides() {
    const ue = this, {
      slidesEl: Qe,
      params: Ue
    } = ue;
    ue.slides = elementChildren(Qe, `.${Ue.slideClass}, swiper-slide`);
  }
  enable() {
    const ue = this;
    ue.enabled || (ue.enabled = !0, ue.params.grabCursor && ue.setGrabCursor(), ue.emit("enable"));
  }
  disable() {
    const ue = this;
    ue.enabled && (ue.enabled = !1, ue.params.grabCursor && ue.unsetGrabCursor(), ue.emit("disable"));
  }
  setProgress(ue, Qe) {
    const Ue = this;
    ue = Math.min(Math.max(ue, 0), 1);
    const He = Ue.minTranslate(), Xe = (Ue.maxTranslate() - He) * ue + He;
    Ue.translateTo(Xe, typeof Qe > "u" ? 0 : Qe), Ue.updateActiveIndex(), Ue.updateSlidesClasses();
  }
  emitContainerClasses() {
    const ue = this;
    if (!ue.params._emitClasses || !ue.el) return;
    const Qe = ue.el.className.split(" ").filter((Ue) => Ue.indexOf("swiper") === 0 || Ue.indexOf(ue.params.containerModifierClass) === 0);
    ue.emit("_containerClasses", Qe.join(" "));
  }
  getSlideClasses(ue) {
    const Qe = this;
    return Qe.destroyed ? "" : ue.className.split(" ").filter((Ue) => Ue.indexOf("swiper-slide") === 0 || Ue.indexOf(Qe.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const ue = this;
    if (!ue.params._emitClasses || !ue.el) return;
    const Qe = [];
    ue.slides.forEach((Ue) => {
      const He = ue.getSlideClasses(Ue);
      Qe.push({
        slideEl: Ue,
        classNames: He
      }), ue.emit("_slideClass", Ue, He);
    }), ue.emit("_slideClasses", Qe);
  }
  slidesPerViewDynamic(ue = "current", Qe = !1) {
    const Ue = this, {
      params: He,
      slides: Ge,
      slidesGrid: Xe,
      slidesSizesGrid: Ke,
      size: $e,
      activeIndex: Je
    } = Ue;
    let Ze = 1;
    if (He.centeredSlides) {
      let nt = Ge[Je] ? Ge[Je].swiperSlideSize : 0, tt;
      for (let et = Je + 1; et < Ge.length; et += 1)
        Ge[et] && !tt && (nt += Ge[et].swiperSlideSize, Ze += 1, nt > $e && (tt = !0));
      for (let et = Je - 1; et >= 0; et -= 1)
        Ge[et] && !tt && (nt += Ge[et].swiperSlideSize, Ze += 1, nt > $e && (tt = !0));
    } else if (ue === "current")
      for (let nt = Je + 1; nt < Ge.length; nt += 1)
        (Qe ? Xe[nt] + Ke[nt] - Xe[Je] < $e : Xe[nt] - Xe[Je] < $e) && (Ze += 1);
    else
      for (let nt = Je - 1; nt >= 0; nt -= 1)
        Xe[Je] - Xe[nt] < $e && (Ze += 1);
    return Ze;
  }
  update() {
    const ue = this;
    if (!ue || ue.destroyed) return;
    const {
      snapGrid: Qe,
      params: Ue
    } = ue;
    Ue.breakpoints && ue.setBreakpoint(), [...ue.el.querySelectorAll('[loading="lazy"]')].forEach((Xe) => {
      Xe.complete && processLazyPreloader(ue, Xe);
    }), ue.updateSize(), ue.updateSlides(), ue.updateProgress(), ue.updateSlidesClasses();
    function He() {
      const Xe = ue.rtlTranslate ? ue.translate * -1 : ue.translate, Ke = Math.min(Math.max(Xe, ue.maxTranslate()), ue.minTranslate());
      ue.setTranslate(Ke), ue.updateActiveIndex(), ue.updateSlidesClasses();
    }
    let Ge;
    if (Ue.freeMode && Ue.freeMode.enabled && !Ue.cssMode)
      He(), Ue.autoHeight && ue.updateAutoHeight();
    else {
      if ((Ue.slidesPerView === "auto" || Ue.slidesPerView > 1) && ue.isEnd && !Ue.centeredSlides) {
        const Xe = ue.virtual && Ue.virtual.enabled ? ue.virtual.slides : ue.slides;
        Ge = ue.slideTo(Xe.length - 1, 0, !1, !0);
      } else
        Ge = ue.slideTo(ue.activeIndex, 0, !1, !0);
      Ge || He();
    }
    Ue.watchOverflow && Qe !== ue.snapGrid && ue.checkOverflow(), ue.emit("update");
  }
  changeDirection(ue, Qe = !0) {
    const Ue = this, He = Ue.params.direction;
    return ue || (ue = He === "horizontal" ? "vertical" : "horizontal"), ue === He || ue !== "horizontal" && ue !== "vertical" || (Ue.el.classList.remove(`${Ue.params.containerModifierClass}${He}`), Ue.el.classList.add(`${Ue.params.containerModifierClass}${ue}`), Ue.emitContainerClasses(), Ue.params.direction = ue, Ue.slides.forEach((Ge) => {
      ue === "vertical" ? Ge.style.width = "" : Ge.style.height = "";
    }), Ue.emit("changeDirection"), Qe && Ue.update()), Ue;
  }
  changeLanguageDirection(ue) {
    const Qe = this;
    Qe.rtl && ue === "rtl" || !Qe.rtl && ue === "ltr" || (Qe.rtl = ue === "rtl", Qe.rtlTranslate = Qe.params.direction === "horizontal" && Qe.rtl, Qe.rtl ? (Qe.el.classList.add(`${Qe.params.containerModifierClass}rtl`), Qe.el.dir = "rtl") : (Qe.el.classList.remove(`${Qe.params.containerModifierClass}rtl`), Qe.el.dir = "ltr"), Qe.update());
  }
  mount(ue) {
    const Qe = this;
    if (Qe.mounted) return !0;
    let Ue = ue || Qe.params.el;
    if (typeof Ue == "string" && (Ue = document.querySelector(Ue)), !Ue)
      return !1;
    Ue.swiper = Qe, Ue.shadowEl && (Qe.isElement = !0);
    const He = () => `.${(Qe.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let Xe = Ue && Ue.shadowRoot && Ue.shadowRoot.querySelector ? Ue.shadowRoot.querySelector(He()) : elementChildren(Ue, He())[0];
    return !Xe && Qe.params.createElements && (Xe = createElement("div", Qe.params.wrapperClass), Ue.append(Xe), elementChildren(Ue, `.${Qe.params.slideClass}`).forEach((Ke) => {
      Xe.append(Ke);
    })), Object.assign(Qe, {
      el: Ue,
      wrapperEl: Xe,
      slidesEl: Qe.isElement ? Ue : Xe,
      mounted: !0,
      // RTL
      rtl: Ue.dir.toLowerCase() === "rtl" || elementStyle(Ue, "direction") === "rtl",
      rtlTranslate: Qe.params.direction === "horizontal" && (Ue.dir.toLowerCase() === "rtl" || elementStyle(Ue, "direction") === "rtl"),
      wrongRTL: elementStyle(Xe, "display") === "-webkit-box"
    }), !0;
  }
  init(ue) {
    const Qe = this;
    return Qe.initialized || Qe.mount(ue) === !1 || (Qe.emit("beforeInit"), Qe.params.breakpoints && Qe.setBreakpoint(), Qe.addClasses(), Qe.updateSize(), Qe.updateSlides(), Qe.params.watchOverflow && Qe.checkOverflow(), Qe.params.grabCursor && Qe.enabled && Qe.setGrabCursor(), Qe.params.loop && Qe.virtual && Qe.params.virtual.enabled ? Qe.slideTo(Qe.params.initialSlide + Qe.virtual.slidesBefore, 0, Qe.params.runCallbacksOnInit, !1, !0) : Qe.slideTo(Qe.params.initialSlide, 0, Qe.params.runCallbacksOnInit, !1, !0), Qe.params.loop && Qe.loopCreate(), Qe.attachEvents(), [...Qe.el.querySelectorAll('[loading="lazy"]')].forEach((He) => {
      He.complete ? processLazyPreloader(Qe, He) : He.addEventListener("load", (Ge) => {
        processLazyPreloader(Qe, Ge.target);
      });
    }), preload(Qe), Qe.initialized = !0, preload(Qe), Qe.emit("init"), Qe.emit("afterInit")), Qe;
  }
  destroy(ue = !0, Qe = !0) {
    const Ue = this, {
      params: He,
      el: Ge,
      wrapperEl: Xe,
      slides: Ke
    } = Ue;
    return typeof Ue.params > "u" || Ue.destroyed || (Ue.emit("beforeDestroy"), Ue.initialized = !1, Ue.detachEvents(), He.loop && Ue.loopDestroy(), Qe && (Ue.removeClasses(), Ge.removeAttribute("style"), Xe.removeAttribute("style"), Ke && Ke.length && Ke.forEach(($e) => {
      $e.classList.remove(He.slideVisibleClass, He.slideActiveClass, He.slideNextClass, He.slidePrevClass), $e.removeAttribute("style"), $e.removeAttribute("data-swiper-slide-index");
    })), Ue.emit("destroy"), Object.keys(Ue.eventsListeners).forEach(($e) => {
      Ue.off($e);
    }), ue !== !1 && (Ue.el.swiper = null, deleteProps(Ue)), Ue.destroyed = !0), null;
  }
  static extendDefaults(ue) {
    extend$2(extendedDefaults, ue);
  }
  static get extendedDefaults() {
    return extendedDefaults;
  }
  static get defaults() {
    return defaults$4;
  }
  static installModule(ue) {
    po.prototype.__modules__ || (po.prototype.__modules__ = []);
    const Qe = po.prototype.__modules__;
    typeof ue == "function" && Qe.indexOf(ue) < 0 && Qe.push(ue);
  }
  static use(ue) {
    return Array.isArray(ue) ? (ue.forEach((Qe) => po.installModule(Qe)), po) : (po.installModule(ue), po);
  }
};
Object.keys(prototypes).forEach((me) => {
  Object.keys(prototypes[me]).forEach((ue) => {
    Swiper$1.prototype[ue] = prototypes[me][ue];
  });
});
Swiper$1.use([Resize, Observer]);
function createElementIfNotDefined(me, ue, Qe, Ue) {
  return me.params.createElements && Object.keys(Ue).forEach((He) => {
    if (!Qe[He] && Qe.auto === !0) {
      let Ge = elementChildren(me.el, `.${Ue[He]}`)[0];
      Ge || (Ge = createElement("div", Ue[He]), Ge.className = Ue[He], me.el.append(Ge)), Qe[He] = Ge, ue[He] = Ge;
    }
  }), Qe;
}
function classesToSelector(me = "") {
  return `.${me.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, ".")}`;
}
function Pagination({
  swiper: me,
  extendParams: ue,
  on: Qe,
  emit: Ue
}) {
  const He = "swiper-pagination";
  ue({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (at) => at,
      formatFractionTotal: (at) => at,
      bulletClass: `${He}-bullet`,
      bulletActiveClass: `${He}-bullet-active`,
      modifierClass: `${He}-`,
      currentClass: `${He}-current`,
      totalClass: `${He}-total`,
      hiddenClass: `${He}-hidden`,
      progressbarFillClass: `${He}-progressbar-fill`,
      progressbarOppositeClass: `${He}-progressbar-opposite`,
      clickableClass: `${He}-clickable`,
      lockClass: `${He}-lock`,
      horizontalClass: `${He}-horizontal`,
      verticalClass: `${He}-vertical`,
      paginationDisabledClass: `${He}-disabled`
    }
  }), me.pagination = {
    el: null,
    bullets: []
  };
  let Ge, Xe = 0;
  const Ke = (at) => (Array.isArray(at) || (at = [at].filter((st) => !!st)), at);
  function $e() {
    return !me.params.pagination.el || !me.pagination.el || Array.isArray(me.pagination.el) && me.pagination.el.length === 0;
  }
  function Je(at, st) {
    const {
      bulletActiveClass: ut
    } = me.params.pagination;
    at && (at = at[`${st === "prev" ? "previous" : "next"}ElementSibling`], at && (at.classList.add(`${ut}-${st}`), at = at[`${st === "prev" ? "previous" : "next"}ElementSibling`], at && at.classList.add(`${ut}-${st}-${st}`)));
  }
  function Ze(at) {
    const st = at.target.closest(classesToSelector(me.params.pagination.bulletClass));
    if (!st)
      return;
    at.preventDefault();
    const ut = elementIndex(st) * me.params.slidesPerGroup;
    if (me.params.loop) {
      if (me.realIndex === ut) return;
      const lt = me.getSlideIndexByData(ut), dt = me.getSlideIndexByData(me.realIndex);
      lt > me.slides.length - me.loopedSlides && me.loopFix({
        direction: lt > dt ? "next" : "prev",
        activeSlideIndex: lt,
        slideTo: !1
      }), me.slideToLoop(ut);
    } else
      me.slideTo(ut);
  }
  function nt() {
    const at = me.rtl, st = me.params.pagination;
    if ($e()) return;
    let ut = me.pagination.el;
    ut = Ke(ut);
    let lt, dt;
    const At = me.virtual && me.params.virtual.enabled ? me.virtual.slides.length : me.slides.length, pt = me.params.loop ? Math.ceil(At / me.params.slidesPerGroup) : me.snapGrid.length;
    if (me.params.loop ? (dt = me.previousRealIndex || 0, lt = me.params.slidesPerGroup > 1 ? Math.floor(me.realIndex / me.params.slidesPerGroup) : me.realIndex) : typeof me.snapIndex < "u" ? (lt = me.snapIndex, dt = me.previousSnapIndex) : (dt = me.previousIndex || 0, lt = me.activeIndex || 0), st.type === "bullets" && me.pagination.bullets && me.pagination.bullets.length > 0) {
      const gt = me.pagination.bullets;
      let wt, Bt, Tt;
      if (st.dynamicBullets && (Ge = elementOuterSize(gt[0], me.isHorizontal() ? "width" : "height"), ut.forEach((yt) => {
        yt.style[me.isHorizontal() ? "width" : "height"] = `${Ge * (st.dynamicMainBullets + 4)}px`;
      }), st.dynamicMainBullets > 1 && dt !== void 0 && (Xe += lt - (dt || 0), Xe > st.dynamicMainBullets - 1 ? Xe = st.dynamicMainBullets - 1 : Xe < 0 && (Xe = 0)), wt = Math.max(lt - Xe, 0), Bt = wt + (Math.min(gt.length, st.dynamicMainBullets) - 1), Tt = (Bt + wt) / 2), gt.forEach((yt) => {
        const Ct = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((ht) => `${st.bulletActiveClass}${ht}`)].map((ht) => typeof ht == "string" && ht.includes(" ") ? ht.split(" ") : ht).flat();
        yt.classList.remove(...Ct);
      }), ut.length > 1)
        gt.forEach((yt) => {
          const Ct = elementIndex(yt);
          Ct === lt ? yt.classList.add(...st.bulletActiveClass.split(" ")) : me.isElement && yt.setAttribute("part", "bullet"), st.dynamicBullets && (Ct >= wt && Ct <= Bt && yt.classList.add(...`${st.bulletActiveClass}-main`.split(" ")), Ct === wt && Je(yt, "prev"), Ct === Bt && Je(yt, "next"));
        });
      else {
        const yt = gt[lt];
        if (yt && yt.classList.add(...st.bulletActiveClass.split(" ")), me.isElement && gt.forEach((Ct, ht) => {
          Ct.setAttribute("part", ht === lt ? "bullet-active" : "bullet");
        }), st.dynamicBullets) {
          const Ct = gt[wt], ht = gt[Bt];
          for (let It = wt; It <= Bt; It += 1)
            gt[It] && gt[It].classList.add(...`${st.bulletActiveClass}-main`.split(" "));
          Je(Ct, "prev"), Je(ht, "next");
        }
      }
      if (st.dynamicBullets) {
        const yt = Math.min(gt.length, st.dynamicMainBullets + 4), Ct = (Ge * yt - Ge) / 2 - Tt * Ge, ht = at ? "right" : "left";
        gt.forEach((It) => {
          It.style[me.isHorizontal() ? ht : "top"] = `${Ct}px`;
        });
      }
    }
    ut.forEach((gt, wt) => {
      if (st.type === "fraction" && (gt.querySelectorAll(classesToSelector(st.currentClass)).forEach((Bt) => {
        Bt.textContent = st.formatFractionCurrent(lt + 1);
      }), gt.querySelectorAll(classesToSelector(st.totalClass)).forEach((Bt) => {
        Bt.textContent = st.formatFractionTotal(pt);
      })), st.type === "progressbar") {
        let Bt;
        st.progressbarOpposite ? Bt = me.isHorizontal() ? "vertical" : "horizontal" : Bt = me.isHorizontal() ? "horizontal" : "vertical";
        const Tt = (lt + 1) / pt;
        let yt = 1, Ct = 1;
        Bt === "horizontal" ? yt = Tt : Ct = Tt, gt.querySelectorAll(classesToSelector(st.progressbarFillClass)).forEach((ht) => {
          ht.style.transform = `translate3d(0,0,0) scaleX(${yt}) scaleY(${Ct})`, ht.style.transitionDuration = `${me.params.speed}ms`;
        });
      }
      st.type === "custom" && st.renderCustom ? (gt.innerHTML = st.renderCustom(me, lt + 1, pt), wt === 0 && Ue("paginationRender", gt)) : (wt === 0 && Ue("paginationRender", gt), Ue("paginationUpdate", gt)), me.params.watchOverflow && me.enabled && gt.classList[me.isLocked ? "add" : "remove"](st.lockClass);
    });
  }
  function tt() {
    const at = me.params.pagination;
    if ($e()) return;
    const st = me.virtual && me.params.virtual.enabled ? me.virtual.slides.length : me.slides.length;
    let ut = me.pagination.el;
    ut = Ke(ut);
    let lt = "";
    if (at.type === "bullets") {
      let dt = me.params.loop ? Math.ceil(st / me.params.slidesPerGroup) : me.snapGrid.length;
      me.params.freeMode && me.params.freeMode.enabled && dt > st && (dt = st);
      for (let At = 0; At < dt; At += 1)
        at.renderBullet ? lt += at.renderBullet.call(me, At, at.bulletClass) : lt += `<${at.bulletElement} ${me.isElement ? 'part="bullet"' : ""} class="${at.bulletClass}"></${at.bulletElement}>`;
    }
    at.type === "fraction" && (at.renderFraction ? lt = at.renderFraction.call(me, at.currentClass, at.totalClass) : lt = `<span class="${at.currentClass}"></span> / <span class="${at.totalClass}"></span>`), at.type === "progressbar" && (at.renderProgressbar ? lt = at.renderProgressbar.call(me, at.progressbarFillClass) : lt = `<span class="${at.progressbarFillClass}"></span>`), me.pagination.bullets = [], ut.forEach((dt) => {
      at.type !== "custom" && (dt.innerHTML = lt || ""), at.type === "bullets" && me.pagination.bullets.push(...dt.querySelectorAll(classesToSelector(at.bulletClass)));
    }), at.type !== "custom" && Ue("paginationRender", ut[0]);
  }
  function et() {
    me.params.pagination = createElementIfNotDefined(me, me.originalParams.pagination, me.params.pagination, {
      el: "swiper-pagination"
    });
    const at = me.params.pagination;
    if (!at.el) return;
    let st;
    typeof at.el == "string" && me.isElement && (st = me.el.shadowRoot.querySelector(at.el)), !st && typeof at.el == "string" && (st = [...document.querySelectorAll(at.el)]), st || (st = at.el), !(!st || st.length === 0) && (me.params.uniqueNavElements && typeof at.el == "string" && Array.isArray(st) && st.length > 1 && (st = [...me.el.querySelectorAll(at.el)], st.length > 1 && (st = st.filter((ut) => elementParents(ut, ".swiper")[0] === me.el)[0])), Array.isArray(st) && st.length === 1 && (st = st[0]), Object.assign(me.pagination, {
      el: st
    }), st = Ke(st), st.forEach((ut) => {
      at.type === "bullets" && at.clickable && ut.classList.add(at.clickableClass), ut.classList.add(at.modifierClass + at.type), ut.classList.add(me.isHorizontal() ? at.horizontalClass : at.verticalClass), at.type === "bullets" && at.dynamicBullets && (ut.classList.add(`${at.modifierClass}${at.type}-dynamic`), Xe = 0, at.dynamicMainBullets < 1 && (at.dynamicMainBullets = 1)), at.type === "progressbar" && at.progressbarOpposite && ut.classList.add(at.progressbarOppositeClass), at.clickable && ut.addEventListener("click", Ze), me.enabled || ut.classList.add(at.lockClass);
    }));
  }
  function rt() {
    const at = me.params.pagination;
    if ($e()) return;
    let st = me.pagination.el;
    st && (st = Ke(st), st.forEach((ut) => {
      ut.classList.remove(at.hiddenClass), ut.classList.remove(at.modifierClass + at.type), ut.classList.remove(me.isHorizontal() ? at.horizontalClass : at.verticalClass), at.clickable && ut.removeEventListener("click", Ze);
    })), me.pagination.bullets && me.pagination.bullets.forEach((ut) => ut.classList.remove(...at.bulletActiveClass.split(" ")));
  }
  Qe("changeDirection", () => {
    if (!me.pagination || !me.pagination.el) return;
    const at = me.params.pagination;
    let {
      el: st
    } = me.pagination;
    st = Ke(st), st.forEach((ut) => {
      ut.classList.remove(at.horizontalClass, at.verticalClass), ut.classList.add(me.isHorizontal() ? at.horizontalClass : at.verticalClass);
    });
  }), Qe("init", () => {
    me.params.pagination.enabled === !1 ? ot() : (et(), tt(), nt());
  }), Qe("activeIndexChange", () => {
    typeof me.snapIndex > "u" && nt();
  }), Qe("snapIndexChange", () => {
    nt();
  }), Qe("snapGridLengthChange", () => {
    tt(), nt();
  }), Qe("destroy", () => {
    rt();
  }), Qe("enable disable", () => {
    let {
      el: at
    } = me.pagination;
    at && (at = Ke(at), at.forEach((st) => st.classList[me.enabled ? "remove" : "add"](me.params.pagination.lockClass)));
  }), Qe("lock unlock", () => {
    nt();
  }), Qe("click", (at, st) => {
    const ut = st.target;
    let {
      el: lt
    } = me.pagination;
    if (Array.isArray(lt) || (lt = [lt].filter((dt) => !!dt)), me.params.pagination.el && me.params.pagination.hideOnClick && lt && lt.length > 0 && !ut.classList.contains(me.params.pagination.bulletClass)) {
      if (me.navigation && (me.navigation.nextEl && ut === me.navigation.nextEl || me.navigation.prevEl && ut === me.navigation.prevEl)) return;
      const dt = lt[0].classList.contains(me.params.pagination.hiddenClass);
      Ue(dt === !0 ? "paginationShow" : "paginationHide"), lt.forEach((At) => At.classList.toggle(me.params.pagination.hiddenClass));
    }
  });
  const it = () => {
    me.el.classList.remove(me.params.pagination.paginationDisabledClass);
    let {
      el: at
    } = me.pagination;
    at && (at = Ke(at), at.forEach((st) => st.classList.remove(me.params.pagination.paginationDisabledClass))), et(), tt(), nt();
  }, ot = () => {
    me.el.classList.add(me.params.pagination.paginationDisabledClass);
    let {
      el: at
    } = me.pagination;
    at && (at = Ke(at), at.forEach((st) => st.classList.add(me.params.pagination.paginationDisabledClass))), rt();
  };
  Object.assign(me.pagination, {
    enable: it,
    disable: ot,
    render: tt,
    update: nt,
    init: et,
    destroy: rt
  });
}
function A11y({
  swiper: me,
  extendParams: ue,
  on: Qe
}) {
  ue({
    a11y: {
      enabled: !0,
      notificationClass: "swiper-notification",
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
      firstSlideMessage: "This is the first slide",
      lastSlideMessage: "This is the last slide",
      paginationBulletMessage: "Go to slide {{index}}",
      slideLabelMessage: "{{index}} / {{slidesLength}}",
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      itemRoleDescriptionMessage: null,
      slideRole: "group",
      id: null
    }
  }), me.a11y = {
    clicked: !1
  };
  let Ue = null;
  function He(Ct) {
    const ht = Ue;
    ht.length !== 0 && (ht.innerHTML = "", ht.innerHTML = Ct);
  }
  const Ge = (Ct) => (Array.isArray(Ct) || (Ct = [Ct].filter((ht) => !!ht)), Ct);
  function Xe(Ct = 16) {
    const ht = () => Math.round(16 * Math.random()).toString(16);
    return "x".repeat(Ct).replace(/x/g, ht);
  }
  function Ke(Ct) {
    Ct = Ge(Ct), Ct.forEach((ht) => {
      ht.setAttribute("tabIndex", "0");
    });
  }
  function $e(Ct) {
    Ct = Ge(Ct), Ct.forEach((ht) => {
      ht.setAttribute("tabIndex", "-1");
    });
  }
  function Je(Ct, ht) {
    Ct = Ge(Ct), Ct.forEach((It) => {
      It.setAttribute("role", ht);
    });
  }
  function Ze(Ct, ht) {
    Ct = Ge(Ct), Ct.forEach((It) => {
      It.setAttribute("aria-roledescription", ht);
    });
  }
  function nt(Ct, ht) {
    Ct = Ge(Ct), Ct.forEach((It) => {
      It.setAttribute("aria-controls", ht);
    });
  }
  function tt(Ct, ht) {
    Ct = Ge(Ct), Ct.forEach((It) => {
      It.setAttribute("aria-label", ht);
    });
  }
  function et(Ct, ht) {
    Ct = Ge(Ct), Ct.forEach((It) => {
      It.setAttribute("id", ht);
    });
  }
  function rt(Ct, ht) {
    Ct = Ge(Ct), Ct.forEach((It) => {
      It.setAttribute("aria-live", ht);
    });
  }
  function it(Ct) {
    Ct = Ge(Ct), Ct.forEach((ht) => {
      ht.setAttribute("aria-disabled", !0);
    });
  }
  function ot(Ct) {
    Ct = Ge(Ct), Ct.forEach((ht) => {
      ht.setAttribute("aria-disabled", !1);
    });
  }
  function at(Ct) {
    if (Ct.keyCode !== 13 && Ct.keyCode !== 32) return;
    const ht = me.params.a11y, It = Ct.target;
    me.pagination && me.pagination.el && (It === me.pagination.el || me.pagination.el.contains(Ct.target)) && !Ct.target.matches(classesToSelector(me.params.pagination.bulletClass)) || (me.navigation && me.navigation.nextEl && It === me.navigation.nextEl && (me.isEnd && !me.params.loop || me.slideNext(), me.isEnd ? He(ht.lastSlideMessage) : He(ht.nextSlideMessage)), me.navigation && me.navigation.prevEl && It === me.navigation.prevEl && (me.isBeginning && !me.params.loop || me.slidePrev(), me.isBeginning ? He(ht.firstSlideMessage) : He(ht.prevSlideMessage)), me.pagination && It.matches(classesToSelector(me.params.pagination.bulletClass)) && It.click());
  }
  function st() {
    if (me.params.loop || me.params.rewind || !me.navigation) return;
    const {
      nextEl: Ct,
      prevEl: ht
    } = me.navigation;
    ht && (me.isBeginning ? (it(ht), $e(ht)) : (ot(ht), Ke(ht))), Ct && (me.isEnd ? (it(Ct), $e(Ct)) : (ot(Ct), Ke(Ct)));
  }
  function ut() {
    return me.pagination && me.pagination.bullets && me.pagination.bullets.length;
  }
  function lt() {
    return ut() && me.params.pagination.clickable;
  }
  function dt() {
    const Ct = me.params.a11y;
    ut() && me.pagination.bullets.forEach((ht) => {
      me.params.pagination.clickable && (Ke(ht), me.params.pagination.renderBullet || (Je(ht, "button"), tt(ht, Ct.paginationBulletMessage.replace(/\{\{index\}\}/, elementIndex(ht) + 1)))), ht.matches(classesToSelector(me.params.pagination.bulletActiveClass)) ? ht.setAttribute("aria-current", "true") : ht.removeAttribute("aria-current");
    });
  }
  const At = (Ct, ht, It) => {
    Ke(Ct), Ct.tagName !== "BUTTON" && (Je(Ct, "button"), Ct.addEventListener("keydown", at)), tt(Ct, It), nt(Ct, ht);
  }, pt = () => {
    me.a11y.clicked = !0;
  }, gt = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        me.destroyed || (me.a11y.clicked = !1);
      });
    });
  }, wt = (Ct) => {
    if (me.a11y.clicked) return;
    const ht = Ct.target.closest(`.${me.params.slideClass}, swiper-slide`);
    if (!ht || !me.slides.includes(ht)) return;
    const It = me.slides.indexOf(ht) === me.activeIndex, vt = me.params.watchSlidesProgress && me.visibleSlides && me.visibleSlides.includes(ht);
    It || vt || Ct.sourceCapabilities && Ct.sourceCapabilities.firesTouchEvents || (me.isHorizontal() ? me.el.scrollLeft = 0 : me.el.scrollTop = 0, me.slideTo(me.slides.indexOf(ht), 0));
  }, Bt = () => {
    const Ct = me.params.a11y;
    Ct.itemRoleDescriptionMessage && Ze(me.slides, Ct.itemRoleDescriptionMessage), Ct.slideRole && Je(me.slides, Ct.slideRole);
    const ht = me.slides.length;
    Ct.slideLabelMessage && me.slides.forEach((It, vt) => {
      const Et = me.params.loop ? parseInt(It.getAttribute("data-swiper-slide-index"), 10) : vt, bt = Ct.slideLabelMessage.replace(/\{\{index\}\}/, Et + 1).replace(/\{\{slidesLength\}\}/, ht);
      tt(It, bt);
    });
  }, Tt = () => {
    const Ct = me.params.a11y;
    me.isElement ? me.el.shadowEl.append(Ue) : me.el.append(Ue);
    const ht = me.el;
    Ct.containerRoleDescriptionMessage && Ze(ht, Ct.containerRoleDescriptionMessage), Ct.containerMessage && tt(ht, Ct.containerMessage);
    const It = me.wrapperEl, vt = Ct.id || It.getAttribute("id") || `swiper-wrapper-${Xe(16)}`, Et = me.params.autoplay && me.params.autoplay.enabled ? "off" : "polite";
    et(It, vt), rt(It, Et), Bt();
    let {
      nextEl: bt,
      prevEl: Rt
    } = me.navigation ? me.navigation : {};
    bt = Ge(bt), Rt = Ge(Rt), bt && bt.forEach((St) => At(St, vt, Ct.nextSlideMessage)), Rt && Rt.forEach((St) => At(St, vt, Ct.prevSlideMessage)), lt() && (Array.isArray(me.pagination.el) ? me.pagination.el : [me.pagination.el]).forEach((kt) => {
      kt.addEventListener("keydown", at);
    }), me.el.addEventListener("focus", wt, !0), me.el.addEventListener("pointerdown", pt, !0), me.el.addEventListener("pointerup", gt, !0);
  };
  function yt() {
    Ue && Ue.remove();
    let {
      nextEl: Ct,
      prevEl: ht
    } = me.navigation ? me.navigation : {};
    Ct = Ge(Ct), ht = Ge(ht), Ct && Ct.forEach((It) => It.removeEventListener("keydown", at)), ht && ht.forEach((It) => It.removeEventListener("keydown", at)), lt() && (Array.isArray(me.pagination.el) ? me.pagination.el : [me.pagination.el]).forEach((vt) => {
      vt.removeEventListener("keydown", at);
    }), me.el.removeEventListener("focus", wt, !0), me.el.removeEventListener("pointerdown", pt, !0), me.el.removeEventListener("pointerup", gt, !0);
  }
  Qe("beforeInit", () => {
    Ue = createElement("span", me.params.a11y.notificationClass), Ue.setAttribute("aria-live", "assertive"), Ue.setAttribute("aria-atomic", "true");
  }), Qe("afterInit", () => {
    me.params.a11y.enabled && Tt();
  }), Qe("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
    me.params.a11y.enabled && Bt();
  }), Qe("fromEdge toEdge afterInit lock unlock", () => {
    me.params.a11y.enabled && st();
  }), Qe("paginationUpdate", () => {
    me.params.a11y.enabled && dt();
  }), Qe("destroy", () => {
    me.params.a11y.enabled && yt();
  });
}
function isObject$1(me) {
  return typeof me == "object" && me !== null && me.constructor && Object.prototype.toString.call(me).slice(8, -1) === "Object";
}
function extend$1(me, ue) {
  const Qe = ["__proto__", "constructor", "prototype"];
  Object.keys(ue).filter((Ue) => Qe.indexOf(Ue) < 0).forEach((Ue) => {
    typeof me[Ue] > "u" ? me[Ue] = ue[Ue] : isObject$1(ue[Ue]) && isObject$1(me[Ue]) && Object.keys(ue[Ue]).length > 0 ? ue[Ue].__swiper__ ? me[Ue] = ue[Ue] : extend$1(me[Ue], ue[Ue]) : me[Ue] = ue[Ue];
  });
}
function needsNavigation(me = {}) {
  return me.navigation && typeof me.navigation.nextEl > "u" && typeof me.navigation.prevEl > "u";
}
function needsPagination(me = {}) {
  return me.pagination && typeof me.pagination.el > "u";
}
function needsScrollbar(me = {}) {
  return me.scrollbar && typeof me.scrollbar.el > "u";
}
function uniqueClasses(me = "") {
  const ue = me.split(" ").map((Ue) => Ue.trim()).filter((Ue) => !!Ue), Qe = [];
  return ue.forEach((Ue) => {
    Qe.indexOf(Ue) < 0 && Qe.push(Ue);
  }), Qe.join(" ");
}
function wrapperClass(me = "") {
  return me ? me.includes("swiper-wrapper") ? me : `swiper-wrapper ${me}` : "swiper-wrapper";
}
const paramsList = [
  "eventsPrefix",
  "injectStyles",
  "injectStylesUrls",
  "modules",
  "init",
  "_direction",
  "oneWayMovement",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_loop",
  "loopedSlides",
  "loopPreventsSliding",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideActiveClass",
  "slideVisibleClass",
  "slideNextClass",
  "slidePrevClass",
  "wrapperClass",
  "lazyPreloaderClass",
  "lazyPreloadPrevNext",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom",
  "control"
];
function getParams(me = {}, ue = !0) {
  const Qe = {
    on: {}
  }, Ue = {}, He = {};
  extend$1(Qe, Swiper$1.defaults), extend$1(Qe, Swiper$1.extendedDefaults), Qe._emitClasses = !0, Qe.init = !1;
  const Ge = {}, Xe = paramsList.map(($e) => $e.replace(/_/, "")), Ke = Object.assign({}, me);
  return Object.keys(Ke).forEach(($e) => {
    typeof me[$e] > "u" || (Xe.indexOf($e) >= 0 ? isObject$1(me[$e]) ? (Qe[$e] = {}, He[$e] = {}, extend$1(Qe[$e], me[$e]), extend$1(He[$e], me[$e])) : (Qe[$e] = me[$e], He[$e] = me[$e]) : $e.search(/on[A-Z]/) === 0 && typeof me[$e] == "function" ? ue ? Ue[`${$e[2].toLowerCase()}${$e.substr(3)}`] = me[$e] : Qe.on[`${$e[2].toLowerCase()}${$e.substr(3)}`] = me[$e] : Ge[$e] = me[$e]);
  }), ["navigation", "pagination", "scrollbar"].forEach(($e) => {
    Qe[$e] === !0 && (Qe[$e] = {}), Qe[$e] === !1 && delete Qe[$e];
  }), {
    params: Qe,
    passedParams: He,
    rest: Ge,
    events: Ue
  };
}
function mountSwiper({
  el: me,
  nextEl: ue,
  prevEl: Qe,
  paginationEl: Ue,
  scrollbarEl: He,
  swiper: Ge
}, Xe) {
  needsNavigation(Xe) && ue && Qe && (Ge.params.navigation.nextEl = ue, Ge.originalParams.navigation.nextEl = ue, Ge.params.navigation.prevEl = Qe, Ge.originalParams.navigation.prevEl = Qe), needsPagination(Xe) && Ue && (Ge.params.pagination.el = Ue, Ge.originalParams.pagination.el = Ue), needsScrollbar(Xe) && He && (Ge.params.scrollbar.el = He, Ge.originalParams.scrollbar.el = He), Ge.init(me);
}
function getChangedParams(me, ue, Qe, Ue, He) {
  const Ge = [];
  if (!ue) return Ge;
  const Xe = ($e) => {
    Ge.indexOf($e) < 0 && Ge.push($e);
  };
  if (Qe && Ue) {
    const $e = Ue.map(He), Je = Qe.map(He);
    $e.join("") !== Je.join("") && Xe("children"), Ue.length !== Qe.length && Xe("children");
  }
  return paramsList.filter(($e) => $e[0] === "_").map(($e) => $e.replace(/_/, "")).forEach(($e) => {
    if ($e in me && $e in ue)
      if (isObject$1(me[$e]) && isObject$1(ue[$e])) {
        const Je = Object.keys(me[$e]), Ze = Object.keys(ue[$e]);
        Je.length !== Ze.length ? Xe($e) : (Je.forEach((nt) => {
          me[$e][nt] !== ue[$e][nt] && Xe($e);
        }), Ze.forEach((nt) => {
          me[$e][nt] !== ue[$e][nt] && Xe($e);
        }));
      } else me[$e] !== ue[$e] && Xe($e);
  }), Ge;
}
function isChildSwiperSlide(me) {
  return me.type && me.type.displayName && me.type.displayName.includes("SwiperSlide");
}
function processChildren(me) {
  const ue = [];
  return React__default.Children.toArray(me).forEach((Qe) => {
    isChildSwiperSlide(Qe) ? ue.push(Qe) : Qe.props && Qe.props.children && processChildren(Qe.props.children).forEach((Ue) => ue.push(Ue));
  }), ue;
}
function getChildren(me) {
  const ue = [], Qe = {
    "container-start": [],
    "container-end": [],
    "wrapper-start": [],
    "wrapper-end": []
  };
  return React__default.Children.toArray(me).forEach((Ue) => {
    if (isChildSwiperSlide(Ue))
      ue.push(Ue);
    else if (Ue.props && Ue.props.slot && Qe[Ue.props.slot])
      Qe[Ue.props.slot].push(Ue);
    else if (Ue.props && Ue.props.children) {
      const He = processChildren(Ue.props.children);
      He.length > 0 ? He.forEach((Ge) => ue.push(Ge)) : Qe["container-end"].push(Ue);
    } else
      Qe["container-end"].push(Ue);
  }), {
    slides: ue,
    slots: Qe
  };
}
function updateSwiper({
  swiper: me,
  slides: ue,
  passedParams: Qe,
  changedParams: Ue,
  nextEl: He,
  prevEl: Ge,
  scrollbarEl: Xe,
  paginationEl: Ke
}) {
  const $e = Ue.filter((gt) => gt !== "children" && gt !== "direction" && gt !== "wrapperClass"), {
    params: Je,
    pagination: Ze,
    navigation: nt,
    scrollbar: tt,
    virtual: et,
    thumbs: rt
  } = me;
  let it, ot, at, st, ut, lt, dt, At;
  Ue.includes("thumbs") && Qe.thumbs && Qe.thumbs.swiper && Je.thumbs && !Je.thumbs.swiper && (it = !0), Ue.includes("controller") && Qe.controller && Qe.controller.control && Je.controller && !Je.controller.control && (ot = !0), Ue.includes("pagination") && Qe.pagination && (Qe.pagination.el || Ke) && (Je.pagination || Je.pagination === !1) && Ze && !Ze.el && (at = !0), Ue.includes("scrollbar") && Qe.scrollbar && (Qe.scrollbar.el || Xe) && (Je.scrollbar || Je.scrollbar === !1) && tt && !tt.el && (st = !0), Ue.includes("navigation") && Qe.navigation && (Qe.navigation.prevEl || Ge) && (Qe.navigation.nextEl || He) && (Je.navigation || Je.navigation === !1) && nt && !nt.prevEl && !nt.nextEl && (ut = !0);
  const pt = (gt) => {
    me[gt] && (me[gt].destroy(), gt === "navigation" ? (me.isElement && (me[gt].prevEl.remove(), me[gt].nextEl.remove()), Je[gt].prevEl = void 0, Je[gt].nextEl = void 0, me[gt].prevEl = void 0, me[gt].nextEl = void 0) : (me.isElement && me[gt].el.remove(), Je[gt].el = void 0, me[gt].el = void 0));
  };
  Ue.includes("loop") && me.isElement && (Je.loop && !Qe.loop ? lt = !0 : !Je.loop && Qe.loop ? dt = !0 : At = !0), $e.forEach((gt) => {
    if (isObject$1(Je[gt]) && isObject$1(Qe[gt]))
      extend$1(Je[gt], Qe[gt]), (gt === "navigation" || gt === "pagination" || gt === "scrollbar") && "enabled" in Qe[gt] && !Qe[gt].enabled && pt(gt);
    else {
      const wt = Qe[gt];
      (wt === !0 || wt === !1) && (gt === "navigation" || gt === "pagination" || gt === "scrollbar") ? wt === !1 && pt(gt) : Je[gt] = Qe[gt];
    }
  }), $e.includes("controller") && !ot && me.controller && me.controller.control && Je.controller && Je.controller.control && (me.controller.control = Je.controller.control), Ue.includes("children") && ue && et && Je.virtual.enabled && (et.slides = ue, et.update(!0)), Ue.includes("children") && ue && Je.loop && (At = !0), it && rt.init() && rt.update(!0), ot && (me.controller.control = Je.controller.control), at && (me.isElement && (!Ke || typeof Ke == "string") && (Ke = document.createElement("div"), Ke.classList.add("swiper-pagination"), me.el.shadowEl.appendChild(Ke)), Ke && (Je.pagination.el = Ke), Ze.init(), Ze.render(), Ze.update()), st && (me.isElement && (!Xe || typeof Xe == "string") && (Xe = document.createElement("div"), Xe.classList.add("swiper-scrollbar"), me.el.shadowEl.appendChild(Xe)), Xe && (Je.scrollbar.el = Xe), tt.init(), tt.updateSize(), tt.setTranslate()), ut && (me.isElement && ((!He || typeof He == "string") && (He = document.createElement("div"), He.classList.add("swiper-button-next"), me.el.shadowEl.appendChild(He)), (!Ge || typeof Ge == "string") && (Ge = document.createElement("div"), Ge.classList.add("swiper-button-prev"), me.el.shadowEl.appendChild(Ge))), He && (Je.navigation.nextEl = He), Ge && (Je.navigation.prevEl = Ge), nt.init(), nt.update()), Ue.includes("allowSlideNext") && (me.allowSlideNext = Qe.allowSlideNext), Ue.includes("allowSlidePrev") && (me.allowSlidePrev = Qe.allowSlidePrev), Ue.includes("direction") && me.changeDirection(Qe.direction, !1), (lt || At) && me.loopDestroy(), (dt || At) && me.loopCreate(), me.update();
}
function renderVirtual(me, ue, Qe) {
  if (!Qe) return null;
  const Ue = (Ze) => {
    let nt = Ze;
    return Ze < 0 ? nt = ue.length + Ze : nt >= ue.length && (nt = nt - ue.length), nt;
  }, He = me.isHorizontal() ? {
    [me.rtlTranslate ? "right" : "left"]: `${Qe.offset}px`
  } : {
    top: `${Qe.offset}px`
  }, {
    from: Ge,
    to: Xe
  } = Qe, Ke = me.params.loop ? -ue.length : 0, $e = me.params.loop ? ue.length * 2 : ue.length, Je = [];
  for (let Ze = Ke; Ze < $e; Ze += 1)
    Ze >= Ge && Ze <= Xe && Je.push(ue[Ue(Ze)]);
  return Je.map((Ze, nt) => /* @__PURE__ */ React__default.cloneElement(Ze, {
    swiper: me,
    style: He,
    key: `slide-${nt}`
  }));
}
const updateOnVirtualData = (me) => {
  !me || me.destroyed || !me.params.virtual || me.params.virtual && !me.params.virtual.enabled || (me.updateSlides(), me.updateProgress(), me.updateSlidesClasses(), me.parallax && me.params.parallax && me.params.parallax.enabled && me.parallax.setTranslate());
};
function useIsomorphicLayoutEffect(me, ue) {
  return typeof window > "u" ? useEffect(me, ue) : useLayoutEffect(me, ue);
}
const SwiperSlideContext = /* @__PURE__ */ createContext(null), SwiperContext = /* @__PURE__ */ createContext(null);
function _extends$4() {
  return _extends$4 = Object.assign ? Object.assign.bind() : function(me) {
    for (var ue = 1; ue < arguments.length; ue++) {
      var Qe = arguments[ue];
      for (var Ue in Qe)
        Object.prototype.hasOwnProperty.call(Qe, Ue) && (me[Ue] = Qe[Ue]);
    }
    return me;
  }, _extends$4.apply(this, arguments);
}
const Swiper = /* @__PURE__ */ forwardRef(function(me, ue) {
  let {
    className: Qe,
    tag: Ue = "div",
    wrapperTag: He = "div",
    children: Ge,
    onSwiper: Xe,
    ...Ke
  } = me === void 0 ? {} : me, $e = !1;
  const [Je, Ze] = useState("swiper"), [nt, tt] = useState(null), [et, rt] = useState(!1), it = useRef(!1), ot = useRef(null), at = useRef(null), st = useRef(null), ut = useRef(null), lt = useRef(null), dt = useRef(null), At = useRef(null), pt = useRef(null), {
    params: gt,
    passedParams: wt,
    rest: Bt,
    events: Tt
  } = getParams(Ke), {
    slides: yt,
    slots: Ct
  } = getChildren(Ge), ht = () => {
    rt(!et);
  };
  Object.assign(gt.on, {
    _containerClasses(Rt, St) {
      Ze(St);
    }
  });
  const It = () => {
    Object.assign(gt.on, Tt), $e = !0;
    const Rt = {
      ...gt
    };
    if (delete Rt.wrapperClass, at.current = new Swiper$1(Rt), at.current.virtual && at.current.params.virtual.enabled) {
      at.current.virtual.slides = yt;
      const St = {
        cache: !1,
        slides: yt,
        renderExternal: tt,
        renderExternalUpdate: !1
      };
      extend$1(at.current.params.virtual, St), extend$1(at.current.originalParams.virtual, St);
    }
  };
  ot.current || It(), at.current && at.current.on("_beforeBreakpoint", ht);
  const vt = () => {
    $e || !Tt || !at.current || Object.keys(Tt).forEach((Rt) => {
      at.current.on(Rt, Tt[Rt]);
    });
  }, Et = () => {
    !Tt || !at.current || Object.keys(Tt).forEach((Rt) => {
      at.current.off(Rt, Tt[Rt]);
    });
  };
  useEffect(() => () => {
    at.current && at.current.off("_beforeBreakpoint", ht);
  }), useEffect(() => {
    !it.current && at.current && (at.current.emitSlidesClasses(), it.current = !0);
  }), useIsomorphicLayoutEffect(() => {
    if (ue && (ue.current = ot.current), !!ot.current)
      return at.current.destroyed && It(), mountSwiper({
        el: ot.current,
        nextEl: lt.current,
        prevEl: dt.current,
        paginationEl: At.current,
        scrollbarEl: pt.current,
        swiper: at.current
      }, gt), Xe && Xe(at.current), () => {
        at.current && !at.current.destroyed && at.current.destroy(!0, !1);
      };
  }, []), useIsomorphicLayoutEffect(() => {
    vt();
    const Rt = getChangedParams(wt, st.current, yt, ut.current, (St) => St.key);
    return st.current = wt, ut.current = yt, Rt.length && at.current && !at.current.destroyed && updateSwiper({
      swiper: at.current,
      slides: yt,
      passedParams: wt,
      changedParams: Rt,
      nextEl: lt.current,
      prevEl: dt.current,
      scrollbarEl: pt.current,
      paginationEl: At.current
    }), () => {
      Et();
    };
  }), useIsomorphicLayoutEffect(() => {
    updateOnVirtualData(at.current);
  }, [nt]);
  function bt() {
    return gt.virtual ? renderVirtual(at.current, yt, nt) : yt.map((Rt, St) => /* @__PURE__ */ React__default.cloneElement(Rt, {
      swiper: at.current,
      swiperSlideIndex: St
    }));
  }
  return /* @__PURE__ */ React__default.createElement(Ue, _extends$4({
    ref: ot,
    className: uniqueClasses(`${Je}${Qe ? ` ${Qe}` : ""}`)
  }, Bt), /* @__PURE__ */ React__default.createElement(SwiperContext.Provider, {
    value: at.current
  }, Ct["container-start"], /* @__PURE__ */ React__default.createElement(He, {
    className: wrapperClass(gt.wrapperClass)
  }, Ct["wrapper-start"], bt(), Ct["wrapper-end"]), needsNavigation(gt) && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", {
    ref: dt,
    className: "swiper-button-prev"
  }), /* @__PURE__ */ React__default.createElement("div", {
    ref: lt,
    className: "swiper-button-next"
  })), needsScrollbar(gt) && /* @__PURE__ */ React__default.createElement("div", {
    ref: pt,
    className: "swiper-scrollbar"
  }), needsPagination(gt) && /* @__PURE__ */ React__default.createElement("div", {
    ref: At,
    className: "swiper-pagination"
  }), Ct["container-end"]));
});
Swiper.displayName = "Swiper";
function _extends$3() {
  return _extends$3 = Object.assign ? Object.assign.bind() : function(me) {
    for (var ue = 1; ue < arguments.length; ue++) {
      var Qe = arguments[ue];
      for (var Ue in Qe)
        Object.prototype.hasOwnProperty.call(Qe, Ue) && (me[Ue] = Qe[Ue]);
    }
    return me;
  }, _extends$3.apply(this, arguments);
}
const SwiperSlide = /* @__PURE__ */ forwardRef(function(me, ue) {
  let {
    tag: Qe = "div",
    children: Ue,
    className: He = "",
    swiper: Ge,
    zoom: Xe,
    lazy: Ke,
    virtualIndex: $e,
    swiperSlideIndex: Je,
    ...Ze
  } = me === void 0 ? {} : me;
  const nt = useRef(null), [tt, et] = useState("swiper-slide"), [rt, it] = useState(!1);
  function ot(lt, dt, At) {
    dt === nt.current && et(At);
  }
  useIsomorphicLayoutEffect(() => {
    if (typeof Je < "u" && (nt.current.swiperSlideIndex = Je), ue && (ue.current = nt.current), !(!nt.current || !Ge)) {
      if (Ge.destroyed) {
        tt !== "swiper-slide" && et("swiper-slide");
        return;
      }
      return Ge.on("_slideClass", ot), () => {
        Ge && Ge.off("_slideClass", ot);
      };
    }
  }), useIsomorphicLayoutEffect(() => {
    Ge && nt.current && !Ge.destroyed && et(Ge.getSlideClasses(nt.current));
  }, [Ge]);
  const at = {
    isActive: tt.indexOf("swiper-slide-active") >= 0,
    isVisible: tt.indexOf("swiper-slide-visible") >= 0,
    isPrev: tt.indexOf("swiper-slide-prev") >= 0,
    isNext: tt.indexOf("swiper-slide-next") >= 0
  }, st = () => typeof Ue == "function" ? Ue(at) : Ue, ut = () => {
    it(!0);
  };
  return /* @__PURE__ */ React__default.createElement(Qe, _extends$3({
    ref: nt,
    className: uniqueClasses(`${tt}${He ? ` ${He}` : ""}`),
    "data-swiper-slide-index": $e,
    onLoad: ut
  }, Ze), Xe && /* @__PURE__ */ React__default.createElement(SwiperSlideContext.Provider, {
    value: at
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof Xe == "number" ? Xe : void 0
  }, st(), Ke && !rt && /* @__PURE__ */ React__default.createElement("div", {
    className: "swiper-lazy-preloader"
  }))), !Xe && /* @__PURE__ */ React__default.createElement(SwiperSlideContext.Provider, {
    value: at
  }, st(), Ke && !rt && /* @__PURE__ */ React__default.createElement("div", {
    className: "swiper-lazy-preloader"
  })));
});
SwiperSlide.displayName = "SwiperSlide";
const step1 = "data:image/svg+xml,%3csvg%20width='74'%20height='44'%20viewBox='0%200%2074%2044'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_8319_10898)'%3e%3cpath%20d='M0.227051%204.7727C0.227051%202.56356%202.01791%200.772705%204.22705%200.772705L70.147%200.772705C72.3562%200.772705%2074.147%202.56357%2074.147%204.77271V39.3327C74.147%2041.5419%2072.3562%2043.3327%2070.147%2043.3327L4.22706%2043.3327C2.01792%2043.3327%200.227051%2041.5418%200.227051%2039.3327L0.227051%204.7727Z'%20fill='white'/%3e%3cpath%20d='M0.727051%204.7727C0.727051%202.8397%202.29405%201.27271%204.22705%201.27271L70.147%201.27271C72.08%201.27271%2073.647%202.83971%2073.647%204.77271V39.3327C73.647%2041.2657%2072.08%2042.8327%2070.147%2042.8327L4.22706%2042.8327C2.29406%2042.8327%200.727051%2041.2657%200.727051%2039.3327L0.727051%204.7727Z'%20stroke='black'%20stroke-opacity='0.1'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M4.36742%2010.0223C4.36752%209.86768%204.49285%209.74243%204.64742%209.74243L69.8559%209.74243C70.0106%209.74243%2070.1359%209.86779%2070.1359%2010.0224V10.8544C70.1359%2011.009%2070.0105%2011.1344%2069.8559%2011.1344L4.64688%2011.1344C4.49217%2011.1344%204.36678%2011.0089%204.36688%2010.8542L4.36742%2010.0223Z'%20fill='%23E9E9EB'/%3e%3crect%20x='26.7661'%20y='17.0227'%20width='17.08'%20height='2.8'%20rx='0.28'%20fill='%23E9E9EB'/%3e%3crect%20x='26.7661'%20y='22.342'%20width='17.08'%20height='2.8'%20rx='0.28'%20fill='%23E9E9EB'/%3e%3crect%20x='26.7661'%20y='27.6624'%20width='23.8'%20height='2.8'%20rx='0.28'%20fill='%23E9E9EB'/%3e%3crect%20x='26.7661'%20y='32.9827'%20width='7.56'%20height='2.52'%20rx='0.28'%20fill='%23E9E9EB'/%3e%3crect%20x='4.3667'%20y='3.86255'%20width='31.36'%20height='3.08'%20rx='0.28'%20fill='%23D7D7D7'/%3e%3crect%20x='63.7876'%20y='3.70435'%20width='6.44'%20height='3.36'%20rx='0.28'%20fill='%23DBB107'/%3e%3cg%20clip-path='url(%23clip1_8319_10898)'%3e%3cg%20clip-path='url(%23clip2_8319_10898)'%3e%3crect%20x='4.30713'%20y='13.9685'%20width='19.5599'%20height='23.4718'%20rx='1.4'%20fill='%23C9C9C9'/%3e%3cpath%20d='M24.2206%2034.0174C25.1192%2035.6252%2025.6364%2039.3334%2025.6364%2039.3334H2.98291C2.98291%2039.3334%203.50035%2035.6248%204.39876%2034.0174C5.29716%2032.4099%2010.7724%2030.919%2010.7724%2030.919C11.2573%2031.7951%2012.6809%2032.5943%2014.138%2032.63C15.7193%2032.6688%2017.3401%2031.8695%2017.8443%2030.9185C17.8443%2030.9185%2023.322%2032.4095%2024.2206%2034.0174Z'%20fill='white'/%3e%3cpath%20d='M11.6467%2029.6414V29.6773C11.6368%2030.4351%2010.9989%2031.0049%209.73291%2031.3868C11.2584%2032.495%2012.7839%2033.3815%2014.3094%2033.3815C15.8349%2033.3815%2017.3604%2032.495%2018.8859%2031.3868C17.6285%2031.0045%2016.9905%2030.4338%2016.9721%2029.6747C16.9721%2029.3866%2016.9731%2026.5799%2016.9744%2026.2918C17.0653%2026.3046%2017.0576%2026.2965%2016.9744%2026.2734C16.9769%2025.3243%2016.981%2026.5667%2016.9866%2025.2697C16.9923%2023.9727%2011.5586%2022.8124%2011.6384%2026.3737C11.6395%2026.7368%2011.6416%2029.2302%2011.6467%2029.6414Z'%20fill='url(%23paint0_linear_8319_10898)'/%3e%3cpath%20d='M24.2206%2034.0174C25.1192%2035.6252%2025.6364%2039.3334%2025.6364%2039.3334H2.98291C2.98291%2039.3334%203.50035%2035.6248%204.39876%2034.0174C5.29716%2032.4099%2010.7724%2030.919%2010.7724%2030.919C10.7724%2031.8934%2012.6611%2033.2985%2014.138%2033.3236C16.1975%2033.3236%2017.8443%2031.8934%2017.8443%2030.9185C17.8443%2030.9185%2023.322%2032.4095%2024.2206%2034.0174Z'%20fill='%23007AFF'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M18.0534%2026.0701C17.321%2028.1537%2015.6774%2029.617%2014.3206%2029.617C12.8015%2029.617%2011.1821%2028.0835%2010.5166%2025.9209C10.468%2025.9369%2010.4115%2025.9491%2010.3463%2025.9574C9.97084%2026.0049%209.72284%2024.9825%209.63634%2024.6008C9.62277%2024.5409%209.60695%2024.4836%209.59135%2024.427C9.50748%2024.1231%209.43001%2023.8423%209.74386%2023.3188C9.89353%2023.0691%2010.0618%2023.0312%2010.211%2023.0849C10.2713%2020.4793%2010.7708%2017.947%2014.3206%2017.947C17.9246%2017.947%2018.3845%2020.5007%2018.4327%2023.1917C18.5347%2023.2095%2018.6385%2023.2834%2018.7338%2023.4457C19.0427%2023.9722%2018.9625%2024.2522%2018.8758%2024.5554C18.8597%2024.6118%2018.8433%2024.669%2018.8292%2024.7287C18.7391%2025.1095%2018.4814%2026.1296%2018.1064%2026.0785C18.0881%2026.076%2018.0704%2026.0732%2018.0534%2026.0701Z'%20fill='url(%23paint1_linear_8319_10898)'/%3e%3c/g%3e%3c/g%3e%3cg%20opacity='0.5'%20clip-path='url(%23clip3_8319_10898)'%3e%3cpath%20d='M65.1692%2034.8527V34.8672C65.1652%2035.1737%2064.9071%2035.4042%2064.395%2035.5587C65.0121%2036.007%2065.6292%2036.3656%2066.2463%2036.3656C66.8633%2036.3656%2067.4804%2036.007%2068.0975%2035.5587C67.5889%2035.4041%2067.3308%2035.1732%2067.3233%2034.8661C67.3233%2034.7496%2067.3237%2033.6143%2067.3243%2033.4977C67.3611%2033.5029%2067.3579%2033.4996%2067.3243%2033.4903C67.3253%2033.1064%2067.3269%2033.6089%2067.3292%2033.0843C67.3315%2032.5596%2065.1335%2032.0902%2065.1658%2033.5308C65.1662%2033.6777%2065.1671%2034.6863%2065.1692%2034.8527Z'%20fill='url(%23paint2_linear_8319_10898)'/%3e%3cpath%20d='M70.2564%2036.6232C70.6199%2037.2736%2070.8292%2038.7736%2070.8292%2038.7736H61.6655C61.6655%2038.7736%2061.8748%2037.2734%2062.2383%2036.6232C62.6017%2035.973%2064.8164%2035.3699%2064.8164%2035.3699C64.8164%2035.764%2065.5805%2036.3324%2066.1779%2036.3425C67.011%2036.3425%2067.6771%2035.764%2067.6771%2035.3696C67.6771%2035.3696%2069.8929%2035.9728%2070.2564%2036.6232Z'%20fill='%23C6C6C6'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M67.6813%2033.4161C67.3844%2034.2908%2066.7176%2034.9051%2066.1672%2034.9051C65.554%2034.9051%2064.9005%2034.2676%2064.6282%2033.3668C64.6038%2033.3802%2064.572%2033.3902%2064.5316%2033.3967C64.3821%2033.4206%2064.2696%2033.0151%2064.23%2032.8636C64.2238%2032.8399%2064.2167%2032.8171%2064.2097%2032.7947C64.1722%2032.6743%2064.1376%2032.5631%2064.2562%2032.3497C64.3318%2032.2137%2064.4256%2032.2284%2064.498%2032.2804C64.5053%2031.1457%2064.6147%2029.991%2066.1672%2030.0082C67.8446%2030.0082%2067.841%2031.1465%2067.8373%2032.313C67.8372%2032.3238%2067.8372%2032.3347%2067.8372%2032.3455C67.9174%2032.2842%2068.0295%2032.254%2068.1018%2032.4149C68.2019%2032.6376%2068.158%2032.7455%2068.1104%2032.8623C68.1016%2032.8841%2068.0926%2032.9061%2068.0844%2032.9292C68.0321%2033.0768%2067.8857%2033.4713%2067.7388%2033.4349C67.717%2033.4295%2067.6979%2033.4232%2067.6813%2033.4161Z'%20fill='url(%23paint3_linear_8319_10898)'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_8319_10898'%20x1='13.9035'%20y1='26.5902'%20x2='13.9035'%20y2='30.9977'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23B1B1B1'/%3e%3cstop%20offset='1'%20stop-color='white'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear_8319_10898'%20x1='10.71'%20y1='23.7275'%20x2='16.5256'%20y2='23.7495'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23E0E0E0'/%3e%3cstop%20offset='1'%20stop-color='white'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint2_linear_8319_10898'%20x1='66.0821'%20y1='33.6184'%20x2='66.0821'%20y2='35.4013'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23D6D4D4'/%3e%3cstop%20offset='1'%20stop-color='%23E4E4E4'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint3_linear_8319_10898'%20x1='64.4093'%20y1='33.0791'%20x2='66.3543'%20y2='33.0791'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23CECECE'/%3e%3cstop%20offset='1'%20stop-color='%23E7E7E7'/%3e%3c/linearGradient%3e%3cclipPath%20id='clip0_8319_10898'%3e%3crect%20x='0.227051'%20y='0.772461'%20width='73.7729'%20height='42.455'%20rx='4'%20fill='white'/%3e%3c/clipPath%3e%3cclipPath%20id='clip1_8319_10898'%3e%3crect%20x='4.3667'%20y='13.9426'%20width='19.32'%20height='23.52'%20rx='1.04397'%20fill='white'/%3e%3c/clipPath%3e%3cclipPath%20id='clip2_8319_10898'%3e%3crect%20width='24.9189'%20height='24.9189'%20fill='white'%20transform='translate(1.8501%2013.9429)'/%3e%3c/clipPath%3e%3cclipPath%20id='clip3_8319_10898'%3e%3crect%20width='10.08'%20height='10.08'%20fill='white'%20transform='translate(61.2065%2028.5022)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", step2 = "data:image/svg+xml,%3csvg%20width='73'%20height='42'%20viewBox='0%200%2073%2042'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cg%20clip-path='url(%23clip0_8319_10931)'%3e%3cg%20clip-path='url(%23clip1_8319_10931)'%3e%3cpath%20d='M-49.9917%20-40.2858C-49.9917%20-45.6521%20-45.6415%20-50.0023%20-40.2752%20-50.0023L117.375%20-50.0023C122.742%20-50.0023%20127.092%20-45.6521%20127.092%20-40.2858V42.2813C127.092%2047.6476%20122.742%2051.9979%20117.375%2051.9979L-40.2752%2051.9979C-45.6415%2051.9979%20-49.9917%2047.6476%20-49.9917%2042.2813L-49.9917%20-40.2858Z'%20fill='white'/%3e%3cpath%20d='M-48.7771%20-40.2858C-48.7771%20-44.9813%20-44.9707%20-48.7878%20-40.2752%20-48.7878L117.375%20-48.7878C122.071%20-48.7878%20125.877%20-44.9813%20125.877%20-40.2858V42.2813C125.877%2046.9768%20122.071%2050.7833%20117.375%2050.7833L-40.2752%2050.7833C-44.9707%2050.7833%20-48.7771%2046.9768%20-48.7771%2042.2813L-48.7771%20-40.2858Z'%20stroke='black'%20stroke-opacity='0.1'%20stroke-width='2.42913'/%3e%3crect%20opacity='0.25'%20x='-39.3672'%20y='-43.6262'%20width='112.625'%20height='81.4585'%20fill='url(%23pattern0_8319_10931)'/%3e%3cpath%20d='M15.5587%2020.4843H16.9621C17.2785%2020.4843%2017.5198%2020.5085%2017.6858%2020.5569C17.9089%2020.6227%2018.1%2020.7394%2018.2591%2020.9071C18.4182%2021.0749%2018.5392%2021.2807%2018.6222%2021.5245C18.7052%2021.7666%2018.7467%2022.0658%2018.7467%2022.422C18.7467%2022.735%2018.7078%2023.0048%2018.63%2023.2314C18.5349%2023.508%2018.3991%2023.732%2018.2228%2023.9032C18.0896%2024.0329%2017.9097%2024.1341%2017.6832%2024.2067C17.5137%2024.2603%2017.2872%2024.2871%2017.0036%2024.2871H15.5587V20.4843ZM16.3265%2021.1276V23.6464H16.8998C17.1143%2023.6464%2017.269%2023.6343%2017.3641%2023.6101C17.4887%2023.5789%2017.5915%2023.5262%2017.6728%2023.4518C17.7558%2023.3775%2017.8233%2023.2556%2017.8752%2023.0861C17.927%2022.9149%2017.953%2022.6823%2017.953%2022.3883C17.953%2022.0943%2017.927%2021.8686%2017.8752%2021.7113C17.8233%2021.5539%2017.7506%2021.4311%2017.6573%2021.3429C17.5639%2021.2547%2017.4454%2021.1951%2017.3019%2021.1639C17.1947%2021.1397%2016.9846%2021.1276%2016.6715%2021.1276H16.3265ZM19.2448%2022.4091C19.2448%2022.0217%2019.3027%2021.6966%2019.4186%2021.4337C19.5051%2021.24%2019.6226%2021.0662%2019.7714%2020.9123C19.9218%2020.7584%2020.0861%2020.6443%2020.2642%2020.5699C20.5011%2020.4696%2020.7744%2020.4195%2021.0839%2020.4195C21.6442%2020.4195%2022.0921%2020.5933%2022.4276%2020.9409C22.7648%2021.2884%2022.9335%2021.7718%2022.9335%2022.3909C22.9335%2023.0048%2022.7666%2023.4856%2022.4328%2023.8332C22.0991%2024.179%2021.6529%2024.352%2021.0943%2024.352C20.5288%2024.352%2020.0792%2024.1799%2019.7454%2023.8358C19.4117%2023.4899%2019.2448%2023.0143%2019.2448%2022.4091ZM20.036%2022.3831C20.036%2022.8137%2020.1354%2023.1406%2020.3343%2023.3636C20.5331%2023.585%2020.7856%2023.6957%2021.0917%2023.6957C21.3978%2023.6957%2021.6486%2023.5859%2021.844%2023.3662C22.0411%2023.1449%2022.1397%2022.8137%2022.1397%2022.3727C22.1397%2021.9369%2022.0437%2021.6118%2021.8518%2021.3974C21.6615%2021.183%2021.4082%2021.0757%2021.0917%2021.0757C20.7752%2021.0757%2020.5202%2021.1847%2020.3265%2021.4026C20.1328%2021.6187%2020.036%2021.9456%2020.036%2022.3831ZM23.5379%2020.4843H25.0579C25.3588%2020.4843%2025.5828%2020.4973%2025.7298%2020.5232C25.8785%2020.5474%2026.0108%2020.5993%2026.1267%2020.6789C26.2443%2020.7584%2026.342%2020.8648%2026.4198%2020.9979C26.4976%2021.1293%2026.5365%2021.2772%2026.5365%2021.4415C26.5365%2021.6196%2026.4881%2021.783%2026.3913%2021.9318C26.2961%2022.0805%2026.1664%2022.192%2026.0022%2022.2664C26.2339%2022.3338%2026.412%2022.4488%2026.5365%2022.6114C26.661%2022.7739%2026.7233%2022.965%2026.7233%2023.1847C26.7233%2023.3576%2026.6826%2023.5262%2026.6014%2023.6905C26.5218%2023.853%2026.412%2023.9836%2026.2719%2024.0822C26.1336%2024.179%2025.9624%2024.2387%2025.7583%2024.2612C25.6303%2024.275%2025.3217%2024.2837%2024.8323%2024.2871H23.5379V20.4843ZM24.3057%2021.1172V21.9966H24.8089C25.1081%2021.9966%2025.294%2021.9923%2025.3666%2021.9836C25.4981%2021.9681%2025.6009%2021.9231%2025.6753%2021.8488C25.7514%2021.7727%2025.7894%2021.6732%2025.7894%2021.5504C25.7894%2021.4328%2025.7566%2021.3377%2025.6909%2021.2651C25.6269%2021.1907%2025.5309%2021.1458%2025.4029%2021.1302C25.3268%2021.1216%2025.1081%2021.1172%2024.7467%2021.1172H24.3057ZM24.3057%2022.6295V23.6464H25.0164C25.2931%2023.6464%2025.4687%2023.6386%2025.543%2023.623C25.6572%2023.6023%2025.7497%2023.5521%2025.8206%2023.4726C25.8932%2023.3913%2025.9295%2023.2832%2025.9295%2023.1483C25.9295%2023.0342%2025.9019%2022.9374%2025.8465%2022.8578C25.7912%2022.7783%2025.7108%2022.7203%2025.6053%2022.684C25.5015%2022.6477%2025.275%2022.6295%2024.9256%2022.6295H24.3057ZM29.9243%2020.4687C30.2926%2020.4687%2030.5806%2020.6002%2030.7881%2020.863C31.0354%2021.1743%2031.159%2021.6905%2031.159%2022.4116C31.159%2023.1311%2031.0345%2023.6481%2030.7855%2023.9629C30.5797%2024.2223%2030.2926%2024.352%2029.9243%2024.352C29.5542%2024.352%2029.2559%2024.2102%2029.0293%2023.9265C28.8028%2023.6412%2028.6895%2023.1336%2028.6895%2022.4039C28.6895%2021.6879%2028.814%2021.1726%2029.0631%2020.8578C29.2689%2020.5984%2029.5559%2020.4687%2029.9243%2020.4687ZM29.9243%2021.0731C29.8361%2021.0731%2029.7574%2021.1017%2029.6882%2021.1587C29.6191%2021.2141%2029.5654%2021.3144%2029.5274%2021.4597C29.4772%2021.6481%2029.4522%2021.9655%2029.4522%2022.4116C29.4522%2022.8578%2029.4747%2023.1648%2029.5196%2023.3325C29.5646%2023.4985%2029.6208%2023.6092%2029.6882%2023.6645C29.7574%2023.7199%2029.8361%2023.7476%2029.9243%2023.7476C30.0125%2023.7476%2030.0912%2023.7199%2030.1603%2023.6645C30.2295%2023.6075%2030.2831%2023.5063%2030.3212%2023.3611C30.3713%2023.1743%2030.3964%2022.8578%2030.3964%2022.4116C30.3964%2021.9655%2030.3739%2021.6594%2030.3289%2021.4934C30.284%2021.3256%2030.2269%2021.2141%2030.1577%2021.1587C30.0903%2021.1017%2030.0125%2021.0731%2029.9243%2021.0731ZM32.2744%2022.2353C32.0859%2022.1557%2031.9485%2022.0468%2031.862%2021.9084C31.7773%2021.7683%2031.7349%2021.6153%2031.7349%2021.4493C31.7349%2021.1657%2031.8335%2020.9313%2032.0306%2020.7463C32.2295%2020.5613%2032.5114%2020.4687%2032.8762%2020.4687C33.2377%2020.4687%2033.5178%2020.5613%2033.7167%2020.7463C33.9173%2020.9313%2034.0176%2021.1657%2034.0176%2021.4493C34.0176%2021.6257%2033.9718%2021.783%2033.8801%2021.9214C33.7885%2022.058%2033.6596%2022.1626%2033.4936%2022.2353C33.7046%2022.32%2033.8646%2022.4436%2033.9735%2022.6062C34.0842%2022.7688%2034.1395%2022.9564%2034.1395%2023.1691C34.1395%2023.5202%2034.0271%2023.8055%2033.8023%2024.0251C33.5792%2024.2447%2033.2818%2024.3546%2032.91%2024.3546C32.5641%2024.3546%2032.2762%2024.2638%2032.0462%2024.0822C31.7747%2023.8677%2031.6389%2023.5738%2031.6389%2023.2002C31.6389%2022.9944%2031.6899%2022.8059%2031.792%2022.6347C31.894%2022.4618%2032.0548%2022.3286%2032.2744%2022.2353ZM32.4249%2021.5012C32.4249%2021.6464%2032.4655%2021.7597%2032.5468%2021.841C32.6298%2021.9222%2032.7396%2021.9629%2032.8762%2021.9629C33.0146%2021.9629%2033.1253%2021.9222%2033.2083%2021.841C33.2913%2021.758%2033.3328%2021.6438%2033.3328%2021.4986C33.3328%2021.3619%2033.2913%2021.253%2033.2083%2021.1717C33.127%2021.0887%2033.0189%2021.0472%2032.884%2021.0472C32.744%2021.0472%2032.6324%2021.0887%2032.5494%2021.1717C32.4664%2021.2547%2032.4249%2021.3645%2032.4249%2021.5012ZM32.3575%2023.1302C32.3575%2023.3308%2032.4085%2023.4873%2032.5105%2023.5997C32.6143%2023.7121%2032.7431%2023.7683%2032.897%2023.7683C33.0475%2023.7683%2033.172%2023.7147%2033.2705%2023.6075C33.3691%2023.4985%2033.4184%2023.342%2033.4184%2023.138C33.4184%2022.9598%2033.3682%2022.8172%2033.2679%2022.71C33.1676%2022.601%2033.0405%2022.5465%2032.8866%2022.5465C32.7085%2022.5465%2032.5753%2022.6079%2032.4872%2022.7307C32.4007%2022.8535%2032.3575%2022.9867%2032.3575%2023.1302ZM34.373%2024.352L35.3146%2020.4195H35.8619L34.9099%2024.352H34.373ZM36.0591%2023.278L36.7647%2023.1924C36.7871%2023.3723%2036.8477%2023.5098%2036.9462%2023.6049C37.0448%2023.7%2037.1641%2023.7476%2037.3042%2023.7476C37.4547%2023.7476%2037.5809%2023.6905%2037.6829%2023.5764C37.7867%2023.4622%2037.8386%2023.3083%2037.8386%2023.1146C37.8386%2022.9313%2037.7893%2022.786%2037.6907%2022.6788C37.5921%2022.5716%2037.472%2022.518%2037.3301%2022.518C37.2368%2022.518%2037.1252%2022.5362%2036.9955%2022.5725L37.0759%2021.9785C37.2731%2021.9836%2037.4235%2021.9413%2037.5273%2021.8513C37.631%2021.7597%2037.6829%2021.6386%2037.6829%2021.4882C37.6829%2021.3602%2037.6449%2021.2582%2037.5688%2021.1821C37.4927%2021.106%2037.3915%2021.068%2037.2653%2021.068C37.1408%2021.068%2037.0344%2021.1112%2036.9462%2021.1977C36.858%2021.2841%2036.8044%2021.4104%2036.7854%2021.5764L36.1136%2021.4622C36.1603%2021.2322%2036.2303%2021.0489%2036.3237%2020.9123C36.4188%2020.774%2036.5502%2020.6659%2036.718%2020.5881C36.8874%2020.5085%2037.0768%2020.4687%2037.286%2020.4687C37.644%2020.4687%2037.9311%2020.5829%2038.1473%2020.8112C38.3254%2020.9979%2038.4144%2021.2089%2038.4144%2021.4441C38.4144%2021.7778%2038.232%2022.0442%2037.8671%2022.243C38.085%2022.2897%2038.2588%2022.3944%2038.3885%2022.5569C38.5199%2022.7195%2038.5856%2022.9157%2038.5856%2023.1458C38.5856%2023.4795%2038.4637%2023.764%2038.2199%2023.9992C37.9761%2024.2344%2037.6726%2024.352%2037.3094%2024.352C36.9653%2024.352%2036.6799%2024.2534%2036.4534%2024.0562C36.2268%2023.8574%2036.0954%2023.598%2036.0591%2023.278ZM40.9073%2024.2871H40.1784V21.5401C39.912%2021.7891%2039.5982%2021.9733%2039.2367%2022.0926V21.4311C39.427%2021.3689%2039.6336%2021.2513%2039.8567%2021.0783C40.0798%2020.9037%2040.2328%2020.7005%2040.3158%2020.4687H40.9073V24.2871ZM41.7659%2024.352L42.7075%2020.4195H43.2548L42.3028%2024.352H41.7659ZM45.343%2024.2871H44.6141V21.5401C44.3478%2021.7891%2044.0339%2021.9733%2043.6725%2022.0926V21.4311C43.8627%2021.3689%2044.0694%2021.2513%2044.2924%2021.0783C44.5155%2020.9037%2044.6686%2020.7005%2044.7516%2020.4687H45.343V24.2871ZM46.4506%2023.4077L47.1562%2023.3299C47.1735%2023.4735%2047.2185%2023.5798%2047.2911%2023.649C47.3637%2023.7182%2047.4597%2023.7527%2047.579%2023.7527C47.7295%2023.7527%2047.8575%2023.6836%2047.9629%2023.5452C48.0684%2023.4069%2048.1359%2023.1198%2048.1653%2022.684C47.982%2022.8967%2047.7528%2023.0031%2047.4779%2023.0031C47.1787%2023.0031%2046.9202%2022.8881%2046.7023%2022.6581C46.4861%2022.4263%2046.378%2022.1254%2046.378%2021.7554C46.378%2021.3697%2046.4921%2021.0593%2046.7204%2020.8241C46.9504%2020.5872%2047.2427%2020.4687%2047.5972%2020.4687C47.9828%2020.4687%2048.2993%2020.6183%2048.5466%2020.9175C48.7939%2021.215%2048.9175%2021.7052%2048.9175%2022.3883C48.9175%2023.0835%2048.7887%2023.585%2048.531%2023.8928C48.2734%2024.2006%2047.9379%2024.3546%2047.5246%2024.3546C47.2271%2024.3546%2046.9867%2024.2759%2046.8034%2024.1185C46.6201%2023.9594%2046.5025%2023.7225%2046.4506%2023.4077ZM48.1004%2021.815C48.1004%2021.5798%2048.046%2021.3974%2047.937%2021.2677C47.8298%2021.138%2047.7053%2021.0731%2047.5635%2021.0731C47.4286%2021.0731%2047.3162%2021.1268%2047.2262%2021.234C47.1381%2021.3395%2047.094%2021.5133%2047.094%2021.7554C47.094%2022.0009%2047.1424%2022.1816%2047.2392%2022.2975C47.3361%2022.4116%2047.4571%2022.4687%2047.6024%2022.4687C47.7425%2022.4687%2047.86%2022.4134%2047.9552%2022.3027C48.052%2022.192%2048.1004%2022.0295%2048.1004%2021.815ZM50.0174%2022.2353C49.8289%2022.1557%2049.6914%2022.0468%2049.6049%2021.9084C49.5202%2021.7683%2049.4778%2021.6153%2049.4778%2021.4493C49.4778%2021.1657%2049.5764%2020.9313%2049.7736%2020.7463C49.9724%2020.5613%2050.2543%2020.4687%2050.6192%2020.4687C50.9806%2020.4687%2051.2608%2020.5613%2051.4597%2020.7463C51.6603%2020.9313%2051.7606%2021.1657%2051.7606%2021.4493C51.7606%2021.6257%2051.7147%2021.783%2051.6231%2021.9214C51.5314%2022.058%2051.4026%2022.1626%2051.2366%2022.2353C51.4475%2022.32%2051.6075%2022.4436%2051.7165%2022.6062C51.8271%2022.7688%2051.8825%2022.9564%2051.8825%2023.1691C51.8825%2023.5202%2051.7701%2023.8055%2051.5453%2024.0251C51.3222%2024.2447%2051.0247%2024.3546%2050.6529%2024.3546C50.3071%2024.3546%2050.0191%2024.2638%2049.7891%2024.0822C49.5176%2023.8677%2049.3819%2023.5738%2049.3819%2023.2002C49.3819%2022.9944%2049.4329%2022.8059%2049.5349%2022.6347C49.6369%2022.4618%2049.7978%2022.3286%2050.0174%2022.2353ZM50.1678%2021.5012C50.1678%2021.6464%2050.2085%2021.7597%2050.2898%2021.841C50.3728%2021.9222%2050.4826%2021.9629%2050.6192%2021.9629C50.7575%2021.9629%2050.8682%2021.9222%2050.9512%2021.841C51.0342%2021.758%2051.0757%2021.6438%2051.0757%2021.4986C51.0757%2021.3619%2051.0342%2021.253%2050.9512%2021.1717C50.8699%2021.0887%2050.7619%2021.0472%2050.627%2021.0472C50.4869%2021.0472%2050.3754%2021.0887%2050.2924%2021.1717C50.2093%2021.2547%2050.1678%2021.3645%2050.1678%2021.5012ZM50.1004%2023.1302C50.1004%2023.3308%2050.1514%2023.4873%2050.2534%2023.5997C50.3572%2023.7121%2050.486%2023.7683%2050.6399%2023.7683C50.7904%2023.7683%2050.9149%2023.7147%2051.0135%2023.6075C51.1121%2023.4985%2051.1613%2023.342%2051.1613%2023.138C51.1613%2022.9598%2051.1112%2022.8172%2051.0109%2022.71C50.9106%2022.601%2050.7835%2022.5465%2050.6296%2022.5465C50.4515%2022.5465%2050.3183%2022.6079%2050.2301%2022.7307C50.1436%2022.8535%2050.1004%2022.9867%2050.1004%2023.1302ZM52.3235%2023.278L53.029%2023.1924C53.0515%2023.3723%2053.112%2023.5098%2053.2106%2023.6049C53.3092%2023.7%2053.4285%2023.7476%2053.5686%2023.7476C53.719%2023.7476%2053.8453%2023.6905%2053.9473%2023.5764C54.0511%2023.4622%2054.1029%2023.3083%2054.1029%2023.1146C54.1029%2022.9313%2054.0537%2022.786%2053.9551%2022.6788C53.8565%2022.5716%2053.7363%2022.518%2053.5945%2022.518C53.5011%2022.518%2053.3896%2022.5362%2053.2599%2022.5725L53.3403%2021.9785C53.5374%2021.9836%2053.6879%2021.9413%2053.7917%2021.8513C53.8954%2021.7597%2053.9473%2021.6386%2053.9473%2021.4882C53.9473%2021.3602%2053.9093%2021.2582%2053.8332%2021.1821C53.7571%2021.106%2053.6559%2021.068%2053.5297%2021.068C53.4052%2021.068%2053.2988%2021.1112%2053.2106%2021.1977C53.1224%2021.2841%2053.0688%2021.4104%2053.0498%2021.5764L52.3779%2021.4622C52.4246%2021.2322%2052.4947%2021.0489%2052.588%2020.9123C52.6832%2020.774%2052.8146%2020.6659%2052.9823%2020.5881C53.1518%2020.5085%2053.3412%2020.4687%2053.5504%2020.4687C53.9084%2020.4687%2054.1955%2020.5829%2054.4116%2020.8112C54.5897%2020.9979%2054.6788%2021.2089%2054.6788%2021.4441C54.6788%2021.7778%2054.4964%2022.0442%2054.1315%2022.243C54.3494%2022.2897%2054.5232%2022.3944%2054.6529%2022.5569C54.7843%2022.7195%2054.85%2022.9157%2054.85%2023.1458C54.85%2023.4795%2054.7281%2023.764%2054.4843%2023.9992C54.2404%2024.2344%2053.9369%2024.352%2053.5738%2024.352C53.2296%2024.352%2052.9443%2024.2534%2052.7177%2024.0562C52.4912%2023.8574%2052.3598%2023.598%2052.3235%2023.278Z'%20fill='%23007AFF'/%3e%3cg%20clip-path='url(%23clip2_8319_10931)'%3e%3cg%20clip-path='url(%23clip3_8319_10931)'%3e%3crect%20x='-40.7822'%20y='-18.129'%20width='46.7501'%20height='56.6668'%20rx='3.54167'%20fill='%23D2D2D2'/%3e%3cpath%20d='M7.51522%2030.5187C9.67871%2034.4436%2010.9241%2043.4957%2010.9241%2043.4957H-43.6177C-43.6177%2043.4957%20-42.3719%2034.4426%20-40.2088%2030.5187C-38.0458%2026.5948%20-24.8634%2022.9554%20-24.8634%2022.9554C-23.6958%2025.0941%20-20.2684%2027.0449%20-16.76%2027.1321C-12.953%2027.2267%20-9.05053%2025.2755%20-7.83675%2022.954C-7.83675%2022.954%205.35173%2026.5938%207.51522%2030.5187Z'%20fill='white'/%3e%3cpath%20d='M7.51522%2030.5187C9.67871%2034.4436%2010.9241%2043.4957%2010.9241%2043.4957H-43.6177C-43.6177%2043.4957%20-42.3719%2034.4426%20-40.2088%2030.5187C-38.0458%2026.5948%20-24.8634%2022.9554%20-24.8634%2022.9554C-24.8634%2025.3339%20-20.3161%2028.764%20-16.76%2028.8251C-11.8017%2028.8251%20-7.83675%2025.3339%20-7.83675%2022.954C-7.83675%2022.954%205.35173%2026.5938%207.51522%2030.5187Z'%20fill='%23007AFF'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3crect%20x='0.600098'%20y='0.504761'%20width='71.9'%20height='40.9904'%20rx='3.5'%20stroke='black'%20stroke-opacity='0.1'/%3e%3cdefs%3e%3cpattern%20id='pattern0_8319_10931'%20patternContentUnits='objectBoundingBox'%20width='1'%20height='1'%3e%3cuse%20xlink:href='%23image0_8319_10931'%20transform='matrix(0.00598802%200%200%200.00827909%200%20-0.000885247)'/%3e%3c/pattern%3e%3cclipPath%20id='clip0_8319_10931'%3e%3crect%20x='0.100098'%20y='0.00476074'%20width='72.9'%20height='41.9904'%20rx='4'%20fill='white'/%3e%3c/clipPath%3e%3cclipPath%20id='clip1_8319_10931'%3e%3crect%20x='-49.9917'%20y='-50.0001'%20width='177.084'%20height='102'%20rx='4.25001'%20fill='white'/%3e%3c/clipPath%3e%3cclipPath%20id='clip2_8319_10931'%3e%3crect%20x='-40.0728'%20y='-18.129'%20width='46.0417'%20height='56.6668'%20rx='2.83334'%20fill='white'/%3e%3c/clipPath%3e%3cclipPath%20id='clip3_8319_10931'%3e%3crect%20width='60.2084'%20height='60.2084'%20fill='white'%20transform='translate(-46.4478%20-18.129)'/%3e%3c/clipPath%3e%3cimage%20id='image0_8319_10931'%20width='167'%20height='121'%20xlink:href='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKcAAAB5CAYAAABcIjGzAAAAAXNSR0IArs4c6QAABj9JREFUeF7tnVvIpVMYx/cwDoMxXJhxuFAyyiElpEhckQuh3Dgkp0JqruScEqK5IBNySo5Drsgp5XSDQhQuuDNFjEMZh2FmmGRqZv/smfXt17eed/es3t9c/b81az3rWf/n17v2/lrfeheM/KcDSR1YkDQv09KBkXAKQVoHhDNtaUxMOGUgrQPCmbY0JiacMpDWAeFMWxoTE04ZSOuAcKYtjYkJpwykdUA405bGxIRTBtI6IJxpS2NiwikDaR0QzrSlMTHhlIG0Dghn2tKYmHDKQFoHhDNtaUxMOGUgrQPCmbY0JiacMpDWAeFMWxoTE04ZSOuAcKYtjYkJpwykdUA405bGxIRTBtI6IJxpS2NiwikDaR0QzrSlMTHhlIG0Dghn2tKYmHDKQFoHhDNtaUxMOGUgrQPCmbY0JiacMpDWAeFMWxoTE04ZSOuAcKYtjYkJpwykdUA405bGxISzjoFTMHwN9NfQl0K/AH0o9CPQb0C/Cb0S+lzoO6BvgV4I/SD0ztCrob+A3gX6iMJcdc51GC2cHUyao4tw1vk352jhrDNXOOv8E84e/SOc3BbXYs510EuhL4N+Cvp26Pehl0BfC70P9PLCtv4K2j8rbNOno30Z9Ea39R4J6jG0cPZortt6nbnCWeef23qP/vFb7d6Y5xfoTdDs8xvaN0PvCb0BenFhq/2jw/o4lvnwI8GPhfiL0N5lrg7pdOvik7ObT6Vewlnnn0/OHv0Tzh7N9cnZo7mGrnNAOOv8c3SPDghnj+Yaus4B4azzz9E9OiCcPZpr6DoHhLPOP0f36IBw1pl7MIbTy5/RTs1ferP9VPR/B5rH2/5G+wHQP0D/Bb1foc+BaN+1sPyv6myJGS2cdT4KZ51/c44WzjpzhbPOP+Hs0T+Gfhs/PFOYk9vux+hzNfSV0AdBvwvNk/bfo52n39ej/aXCXPyosAp9np+RZ8I5I6OFM9hot/U4Q4UzzsstkYQzztASnI9hiougP4feHfo06Iehf4V+Dfo7aP4GgEfvzkKfT6B5bO8etL8aZ8v8Iwnn/L2bHCmccV765Az2UjiDDfXJGWyo4eIcEM44L40U7IBwBhtquDgHhDPOSyMFOyCcwYYaLs4B4Yzz0kjBDghnsKGGi3NAOOO8NFKwA8IZbKjh4hwQzjgvefyMly3wVDmPrl2Bqb+Bvhj6oUI7j7S9hz7HQ38IfRg0j+0dh/a7oM+HvgD6UeizJ6y7ED+fB3099G3Ql0M/Ab3twlzhFM6tDghnHAvpIvnkHJfEJ2cCPLl9H1LYpo9BOy+GPRLtR0EfDv049InQL0M/C81jcmegnXfC34h23kv/XGFbvxntvIv+6An/eTf9mYWtnBfm8vT/6+h/zVbttl5HuHCO/RPOOpbCRwuncIZDFRXwSQTiKXe+roV/q34n+t8A/S30rdAfQfMbLT8S8LcBvDf+A4zdC3rfQs7n7GhrHY1GV6H90zmM4zZ9P/qdBH0v9HXQvE//Prf1GDyFc+yjcMYwFRZFOIUzDCYDNeSA39YbKtbQUhXOoVW8ofUKZ0PFGlqqwjm0ije0XuFsqFhDS1U4h1bxhtYrnA0Va2ipCufQKt7QeoWzoWINLVXhHFrFG1qvcDZUrKGlKpxDq3hD6xXOhoo1tFSFc2gVb2i9wtlQsYaWqnAOreINrVc4GyrW0FIVzqFVvKH1CmdDxRpaqsI5tIo3tF7hjCvWYoTi29Y4A/9+/Hf8x1Jovj+d18tsQJ+N0HtA8/3sm9G+E/Qm6D+hF0GTC87L+LtNWMc1L8P/rZ2vxcI5X+e2HyecY0+EM46rkEjCKZwhIPURhC9g5cWo3NZ+wsT7Qy8vbPFvof2Ewhb8ANrXQPNam6fRzotneT0Mb3rjDXKl97+/OGHiCvx8E3TpxbRTa+C2PtWizh2Ec2yVcHbGZjYdhVM4Z0Nax1l4gxovstp2r/loNOLbhHlPO79Nn4z5FkIzDrd13izH+F9iLO9fX4329dC8YJbbOt/bfiz63w3NjxP/NnO+Vei3EvqSjr5u6ea2/n/c2r6vcI49Ec46lsJHC6dwhkOVLSAvfV2XLbl55NPl12pTw7qtT7VoJh2Ecwc2C+dM2Js6iXAK51RI7JDIAZ+ciYphKv914B8yIqlXZ3YxPAAAAABJRU5ErkJggg=='/%3e%3c/defs%3e%3c/svg%3e", step3 = "data:image/svg+xml,%3csvg%20width='73'%20height='42'%20viewBox='0%200%2073%2042'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cg%20clip-path='url(%23clip0_8319_10967)'%3e%3cpath%20d='M0.100098%204.00354C0.100098%201.79441%201.89096%200.00354004%204.1001%200.00354004L69.0001%200.00354004C71.2092%200.00354004%2073.0001%201.7944%2073.0001%204.00354V37.9939C73.0001%2040.2031%2071.2092%2041.9939%2069.0001%2041.9939L4.1001%2041.9939C1.89097%2041.9939%200.100098%2040.2031%200.100098%2037.9939L0.100098%204.00354Z'%20fill='white'/%3e%3cpath%20d='M0.600098%204.00354C0.600098%202.07055%202.1671%200.50354%204.1001%200.50354L69.0001%200.50354C70.9331%200.50354%2072.5001%202.07054%2072.5001%204.00354V37.9939C72.5001%2039.9269%2070.9331%2041.4939%2069.0001%2041.4939L4.1001%2041.4939C2.16711%2041.4939%200.600098%2039.9269%200.600098%2037.9939L0.600098%204.00354Z'%20stroke='black'%20stroke-opacity='0.1'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M4.18382%209.02844C4.18392%208.87551%204.30791%208.75159%204.46084%208.75159L68.9329%208.75159C69.0859%208.75159%2069.2099%208.87561%2069.2099%209.02861V9.93257C69.2099%2010.0856%2069.0859%2010.2096%2068.9329%2010.2096L4.46029%2010.2096C4.30723%2010.2096%204.18318%2010.0855%204.18327%209.9324L4.18382%209.02844Z'%20fill='%23E9E9EB'/%3e%3crect%20x='62.7935'%20y='2.91858'%20width='6.4152'%20height='3.2076'%20rx='0.2916'%20fill='%23DBB107'/%3e%3crect%20opacity='0.25'%20x='4.47412'%20y='2.62854'%20width='46.3644'%20height='33.534'%20fill='url(%23pattern0_8319_10967)'/%3e%3cpath%20d='M4.60424%204.78977L5.11067%204.74053C5.14115%204.91052%205.2027%205.03536%205.29531%205.11508C5.38909%205.19479%205.51511%205.23465%205.67337%205.23465C5.84101%205.23465%205.96703%205.19948%206.05143%205.12915C6.13701%205.05764%206.1798%204.9744%206.1798%204.87945C6.1798%204.81849%206.16163%204.76691%206.12528%204.72471C6.09012%204.68133%206.02799%204.64382%205.93889%204.61217C5.87793%204.59107%205.73902%204.55355%205.52214%204.49963C5.24314%204.43046%205.04737%204.34547%204.93483%204.24466C4.77657%204.10281%204.69744%203.9299%204.69744%203.72592C4.69744%203.59463%204.73437%203.47212%204.80822%203.35841C4.88325%203.24353%204.99051%203.15619%205.13001%203.0964C5.27069%203.03662%205.44008%203.00672%205.6382%203.00672C5.96175%203.00672%206.205%203.07765%206.36795%203.21949C6.53207%203.36134%206.61823%203.55066%206.62644%203.78747L6.10594%203.81033C6.08367%203.67786%206.0356%203.5829%205.96175%203.52546C5.88907%203.46685%205.77946%203.43754%205.63292%203.43754C5.4817%203.43754%205.3633%203.4686%205.27772%203.53074C5.22263%203.57059%205.19508%203.62393%205.19508%203.69075C5.19508%203.75171%205.22087%203.80388%205.27245%203.84725C5.3381%203.90235%205.49753%203.95979%205.75074%204.01958C6.00395%204.07937%206.19093%204.1415%206.31168%204.20597C6.4336%204.26928%206.52855%204.35661%206.59654%204.46798C6.66571%204.57817%206.70029%204.71474%206.70029%204.87769C6.70029%205.0254%206.65926%205.16373%206.5772%205.29268C6.49514%205.42163%206.37908%205.51776%206.22903%205.58106C6.07898%205.64319%205.892%205.67426%205.66809%205.67426C5.3422%205.67426%205.09192%205.59923%204.91724%205.44918C4.74257%205.29796%204.63824%205.07815%204.60424%204.78977ZM7.66568%205.62854V3.48678H6.90076V3.05069H8.94933V3.48678H8.18617V5.62854H7.66568ZM11.2916%205.62854H10.7254L10.5003%205.04298H9.46984L9.25707%205.62854H8.70492L9.70898%203.05069H10.2594L11.2916%205.62854ZM10.3332%204.60865L9.97802%203.65207L9.62985%204.60865H10.3332ZM11.8297%205.62854V3.48678H11.0647V3.05069H13.1133V3.48678H12.3502V5.62854H11.8297ZM13.3982%205.62854V3.05069H15.3096V3.48678H13.9187V4.05826H15.2129V4.4926H13.9187V5.19421H15.3588V5.62854H13.3982ZM16.7023%205.62854V3.05069H17.2087L18.2638%204.77219V3.05069H18.7473V5.62854H18.2251L17.1859%203.94748V5.62854H16.7023ZM21.5714%205.62854H21.0052L20.7801%205.04298H19.7497L19.5369%205.62854H18.9847L19.9888%203.05069H20.5392L21.5714%205.62854ZM20.613%204.60865L20.2578%203.65207L19.9097%204.60865H20.613ZM21.7894%205.62854V3.05069H22.5684L23.0362%204.80911L23.4986%203.05069H24.2794V5.62854H23.7958V3.59931L23.2841%205.62854H22.783L22.273%203.59931V5.62854H21.7894ZM24.7436%205.62854V3.05069H26.655V3.48678H25.2641V4.05826H26.5583V4.4926H25.2641V5.19421H26.7043V5.62854H24.7436Z'%20fill='%23A6A6A6'/%3e%3cpath%20d='M27.0853%2029.1392H27.663C27.7933%2029.1392%2027.8926%2029.1492%2027.9609%2029.1691C28.0528%2029.1962%2028.1314%2029.2442%2028.1969%2029.3133C28.2624%2029.3823%2028.3123%2029.467%2028.3464%2029.5674C28.3806%2029.6671%2028.3977%2029.7903%2028.3977%2029.9369C28.3977%2030.0658%2028.3817%2030.1768%2028.3497%2030.2701C28.3105%2030.384%2028.2546%2030.4762%2028.182%2030.5467C28.1272%2030.6001%2028.0531%2030.6417%2027.9599%2030.6716C27.8901%2030.6937%2027.7968%2030.7047%2027.6801%2030.7047H27.0853V29.1392ZM27.4014%2029.404V30.4409H27.6374C27.7257%2030.4409%2027.7894%2030.436%2027.8285%2030.426C27.8798%2030.4132%2027.9221%2030.3915%2027.9556%2030.3609C27.9898%2030.3302%2028.0175%2030.2801%2028.0389%2030.2103C28.0603%2030.1398%2028.0709%2030.0441%2028.0709%2029.923C28.0709%2029.802%2028.0603%2029.7091%2028.0389%2029.6443C28.0175%2029.5795%2027.9876%2029.529%2027.9492%2029.4927C27.9108%2029.4564%2027.862%2029.4318%2027.8029%2029.419C27.7588%2029.409%2027.6723%2029.404%2027.5434%2029.404H27.4014ZM28.6027%2029.9316C28.6027%2029.7721%2028.6266%2029.6383%2028.6743%2029.5301C28.7099%2029.4503%2028.7583%2029.3788%2028.8195%2029.3154C28.8815%2029.2521%2028.9491%2029.2051%2029.0224%2029.1745C29.1199%2029.1332%2029.2324%2029.1125%2029.3599%2029.1125C29.5905%2029.1125%2029.7749%2029.1841%2029.913%2029.3272C30.0518%2029.4703%2030.1212%2029.6692%2030.1212%2029.9241C30.1212%2030.1768%2030.0525%2030.3747%2029.9151%2030.5178C29.7777%2030.6602%2029.5941%2030.7314%2029.3641%2030.7314C29.1313%2030.7314%2028.9462%2030.6606%2028.8088%2030.5189C28.6714%2030.3765%2028.6027%2030.1807%2028.6027%2029.9316ZM28.9284%2029.9209C28.9284%2030.0982%2028.9694%2030.2327%2029.0512%2030.3245C29.1331%2030.4157%2029.2371%2030.4612%2029.3631%2030.4612C29.4891%2030.4612%2029.5923%2030.416%2029.6727%2030.3256C29.7539%2030.2345%2029.7945%2030.0982%2029.7945%2029.9166C29.7945%2029.7372%2029.755%2029.6034%2029.6759%2029.5151C29.5976%2029.4268%2029.4933%2029.3827%2029.3631%2029.3827C29.2328%2029.3827%2029.1278%2029.4275%2029.048%2029.5172C28.9683%2029.6062%2028.9284%2029.7408%2028.9284%2029.9209ZM30.3701%2029.1392H30.9958C31.1197%2029.1392%2031.2119%2029.1446%2031.2724%2029.1552C31.3336%2029.1652%2031.3881%2029.1866%2031.4358%2029.2193C31.4842%2029.2521%2031.5244%2029.2958%2031.5565%2029.3507C31.5885%2029.4048%2031.6045%2029.4656%2031.6045%2029.5333C31.6045%2029.6066%2031.5846%2029.6739%2031.5447%2029.7351C31.5056%2029.7963%2031.4522%2029.8422%2031.3845%2029.8728C31.4799%2029.9006%2031.5533%2029.9479%2031.6045%2030.0149C31.6558%2030.0818%2031.6814%2030.1605%2031.6814%2030.2509C31.6814%2030.3221%2031.6647%2030.3915%2031.6312%2030.4591C31.5985%2030.526%2031.5533%2030.5798%2031.4956%2030.6204C31.4386%2030.6602%2031.3682%2030.6848%2031.2842%2030.694C31.2315%2030.6997%2031.1044%2030.7033%2030.9029%2030.7047H30.3701V29.1392ZM30.6862%2029.3998V29.7618H30.8933C31.0165%2029.7618%2031.093%2029.76%2031.1229%2029.7564C31.177%2029.75%2031.2194%2029.7315%2031.25%2029.7009C31.2813%2029.6696%2031.297%2029.6287%2031.297%2029.5781C31.297%2029.5297%2031.2834%2029.4905%2031.2564%2029.4606C31.2301%2029.43%2031.1905%2029.4115%2031.1379%2029.4051C31.1065%2029.4016%2031.0165%2029.3998%2030.8677%2029.3998H30.6862ZM30.6862%2030.0223V30.4409H30.9787C31.0927%2030.4409%2031.1649%2030.4377%2031.1955%2030.4313C31.2425%2030.4228%2031.2806%2030.4021%2031.3098%2030.3694C31.3397%2030.3359%2031.3546%2030.2914%2031.3546%2030.2359C31.3546%2030.1889%2031.3432%2030.1491%2031.3205%2030.1163C31.2977%2030.0836%2031.2646%2030.0597%2031.2212%2030.0448C31.1784%2030.0298%2031.0852%2030.0223%2030.9414%2030.0223H30.6862ZM32.9992%2029.1328C33.1508%2029.1328%2033.2693%2029.1869%2033.3548%2029.2951C33.4566%2029.4233%2033.5075%2029.6358%2033.5075%2029.9326C33.5075%2030.2288%2033.4562%2030.4417%2033.3537%2030.5712C33.269%2030.678%2033.1508%2030.7314%2032.9992%2030.7314C32.8468%2030.7314%2032.724%2030.673%2032.6307%2030.5563C32.5375%2030.4388%2032.4909%2030.2299%2032.4909%2029.9294C32.4909%2029.6347%2032.5421%2029.4226%2032.6446%2029.293C32.7293%2029.1862%2032.8475%2029.1328%2032.9992%2029.1328ZM32.9992%2029.3816C32.9629%2029.3816%2032.9305%2029.3934%2032.902%2029.4169C32.8735%2029.4396%2032.8514%2029.4809%2032.8358%2029.5407C32.8151%2029.6183%2032.8048%2029.749%2032.8048%2029.9326C32.8048%2030.1163%2032.8141%2030.2427%2032.8326%2030.3117C32.8511%2030.3801%2032.8742%2030.4256%2032.902%2030.4484C32.9305%2030.4712%2032.9629%2030.4826%2032.9992%2030.4826C33.0355%2030.4826%2033.0679%2030.4712%2033.0963%2030.4484C33.1248%2030.4249%2033.1469%2030.3833%2033.1625%2030.3235C33.1832%2030.2466%2033.1935%2030.1163%2033.1935%2029.9326C33.1935%2029.749%2033.1843%2029.623%2033.1657%2029.5546C33.1472%2029.4856%2033.1237%2029.4396%2033.0953%2029.4169C33.0675%2029.3934%2033.0355%2029.3816%2032.9992%2029.3816ZM33.9667%2029.86C33.8891%2029.8273%2033.8325%2029.7824%2033.7969%2029.7255C33.762%2029.6678%2033.7445%2029.6048%2033.7445%2029.5365C33.7445%2029.4197%2033.7851%2029.3232%2033.8663%2029.2471C33.9481%2029.1709%2034.0642%2029.1328%2034.2144%2029.1328C34.3632%2029.1328%2034.4785%2029.1709%2034.5604%2029.2471C34.643%2029.3232%2034.6843%2029.4197%2034.6843%2029.5365C34.6843%2029.6091%2034.6654%2029.6739%2034.6277%2029.7308C34.5899%2029.7871%2034.5369%2029.8301%2034.4686%2029.86C34.5554%2029.8949%2034.6213%2029.9458%2034.6661%2030.0127C34.7117%2030.0797%2034.7345%2030.1569%2034.7345%2030.2445C34.7345%2030.389%2034.6882%2030.5064%2034.5956%2030.5969C34.5038%2030.6873%2034.3813%2030.7325%2034.2283%2030.7325C34.0859%2030.7325%2033.9674%2030.6951%2033.8727%2030.6204C33.7609%2030.5321%2033.705%2030.411%2033.705%2030.2573C33.705%2030.1726%2033.726%2030.095%2033.768%2030.0245C33.81%2029.9533%2033.8762%2029.8985%2033.9667%2029.86ZM34.0286%2029.5578C34.0286%2029.6176%2034.0453%2029.6642%2034.0788%2029.6977C34.113%2029.7312%2034.1582%2029.7479%2034.2144%2029.7479C34.2714%2029.7479%2034.3169%2029.7312%2034.3511%2029.6977C34.3853%2029.6635%2034.4023%2029.6166%2034.4023%2029.5568C34.4023%2029.5005%2034.3853%2029.4557%2034.3511%2029.4222C34.3176%2029.388%2034.2731%2029.3709%2034.2176%2029.3709C34.1599%2029.3709%2034.114%2029.388%2034.0798%2029.4222C34.0457%2029.4564%2034.0286%2029.5016%2034.0286%2029.5578ZM34.0008%2030.2284C34.0008%2030.311%2034.0218%2030.3755%2034.0638%2030.4217C34.1065%2030.468%2034.1596%2030.4911%2034.2229%2030.4911C34.2849%2030.4911%2034.3361%2030.4691%2034.3767%2030.4249C34.4173%2030.3801%2034.4376%2030.3157%2034.4376%2030.2316C34.4376%2030.1583%2034.4169%2030.0996%2034.3756%2030.0554C34.3344%2030.0106%2034.282%2029.9882%2034.2187%2029.9882C34.1453%2029.9882%2034.0905%2030.0134%2034.0542%2030.064C34.0186%2030.1145%2034.0008%2030.1694%2034.0008%2030.2284ZM34.8306%2030.7314L35.2182%2029.1125H35.4435L35.0516%2030.7314H34.8306ZM35.5247%2030.2893L35.8151%2030.2541C35.8244%2030.3281%2035.8493%2030.3847%2035.8899%2030.4239C35.9305%2030.463%2035.9796%2030.4826%2036.0373%2030.4826C36.0992%2030.4826%2036.1512%2030.4591%2036.1932%2030.4121C36.2359%2030.3651%2036.2572%2030.3018%2036.2572%2030.222C36.2572%2030.1466%2036.2369%2030.0868%2036.1964%2030.0426C36.1558%2029.9985%2036.1063%2029.9764%2036.0479%2029.9764C36.0095%2029.9764%2035.9636%2029.9839%2035.9102%2029.9988L35.9433%2029.7543C36.0244%2029.7564%2036.0864%2029.739%2036.1291%2029.702C36.1718%2029.6642%2036.1932%2029.6144%2036.1932%2029.5525C36.1932%2029.4998%2036.1775%2029.4578%2036.1462%2029.4265C36.1149%2029.3951%2036.0732%2029.3795%2036.0212%2029.3795C35.97%2029.3795%2035.9262%2029.3973%2035.8899%2029.4329C35.8536%2029.4685%2035.8315%2029.5204%2035.8237%2029.5888L35.5471%2029.5418C35.5663%2029.4471%2035.5952%2029.3717%2035.6336%2029.3154C35.6728%2029.2585%2035.7269%2029.214%2035.7959%2029.1819C35.8657%2029.1492%2035.9436%2029.1328%2036.0298%2029.1328C36.1771%2029.1328%2036.2953%2029.1798%2036.3843%2029.2738C36.4576%2029.3507%2036.4943%2029.4375%2036.4943%2029.5343C36.4943%2029.6717%2036.4192%2029.7814%2036.269%2029.8632C36.3587%2029.8825%2036.4302%2029.9255%2036.4836%2029.9924C36.5377%2030.0594%2036.5648%2030.1402%2036.5648%2030.2348C36.5648%2030.3722%2036.5146%2030.4894%2036.4142%2030.5862C36.3138%2030.683%2036.1889%2030.7314%2036.0394%2030.7314C35.8977%2030.7314%2035.7803%2030.6908%2035.687%2030.6097C35.5937%2030.5278%2035.5396%2030.421%2035.5247%2030.2893ZM37.5205%2030.7047H37.2205V29.5738C37.1108%2029.6764%2036.9816%2029.7522%2036.8328%2029.8013V29.529C36.9111%2029.5034%2036.9962%2029.4549%2037.088%2029.3838C37.1799%2029.3119%2037.2429%2029.2282%2037.2771%2029.1328H37.5205V30.7047ZM37.874%2030.7314L38.2616%2029.1125H38.4869L38.095%2030.7314H37.874ZM39.3466%2030.7047H39.0465V29.5738C38.9369%2029.6764%2038.8077%2029.7522%2038.6589%2029.8013V29.529C38.7372%2029.5034%2038.8223%2029.4549%2038.9141%2029.3838C39.0059%2029.3119%2039.0689%2029.2282%2039.1031%2029.1328H39.3466V30.7047ZM39.8026%2030.3427L40.093%2030.3107C40.1001%2030.3698%2040.1187%2030.4135%2040.1486%2030.442C40.1785%2030.4705%2040.218%2030.4847%2040.2671%2030.4847C40.329%2030.4847%2040.3817%2030.4563%2040.4251%2030.3993C40.4686%2030.3423%2040.4963%2030.2242%2040.5084%2030.0448C40.433%2030.1323%2040.3386%2030.1761%2040.2254%2030.1761C40.1023%2030.1761%2039.9959%2030.1288%2039.9062%2030.0341C39.8172%2029.9387%2039.7727%2029.8148%2039.7727%2029.6625C39.7727%2029.5037%2039.8197%2029.3759%2039.9136%2029.2791C40.0083%2029.1816%2040.1286%2029.1328%2040.2746%2029.1328C40.4333%2029.1328%2040.5636%2029.1944%2040.6654%2029.3175C40.7672%2029.44%2040.8181%2029.6418%2040.8181%2029.923C40.8181%2030.2092%2040.7651%2030.4157%2040.659%2030.5424C40.5529%2030.6691%2040.4148%2030.7325%2040.2447%2030.7325C40.1222%2030.7325%2040.0233%2030.7001%2039.9478%2030.6353C39.8723%2030.5698%2039.8239%2030.4723%2039.8026%2030.3427ZM40.4817%2029.687C40.4817%2029.5902%2040.4593%2029.5151%2040.4145%2029.4617C40.3703%2029.4083%2040.3191%2029.3816%2040.2607%2029.3816C40.2052%2029.3816%2040.1589%2029.4037%2040.1219%2029.4478C40.0856%2029.4913%2040.0674%2029.5628%2040.0674%2029.6625C40.0674%2029.7636%2040.0873%2029.838%2040.1272%2029.8857C40.1671%2029.9326%2040.2169%2029.9561%2040.2767%2029.9561C40.3344%2029.9561%2040.3828%2029.9334%2040.4219%2029.8878C40.4618%2029.8422%2040.4817%2029.7753%2040.4817%2029.687ZM41.2709%2029.86C41.1933%2029.8273%2041.1367%2029.7824%2041.1011%2029.7255C41.0662%2029.6678%2041.0488%2029.6048%2041.0488%2029.5365C41.0488%2029.4197%2041.0894%2029.3232%2041.1705%2029.2471C41.2524%2029.1709%2041.3684%2029.1328%2041.5186%2029.1328C41.6674%2029.1328%2041.7828%2029.1709%2041.8646%2029.2471C41.9472%2029.3232%2041.9885%2029.4197%2041.9885%2029.5365C41.9885%2029.6091%2041.9696%2029.6739%2041.9319%2029.7308C41.8942%2029.7871%2041.8411%2029.8301%2041.7728%2029.86C41.8596%2029.8949%2041.9255%2029.9458%2041.9703%2030.0127C42.0159%2030.0797%2042.0387%2030.1569%2042.0387%2030.2445C42.0387%2030.389%2041.9924%2030.5064%2041.8999%2030.5969C41.808%2030.6873%2041.6856%2030.7325%2041.5325%2030.7325C41.3901%2030.7325%2041.2716%2030.6951%2041.1769%2030.6204C41.0651%2030.5321%2041.0093%2030.411%2041.0093%2030.2573C41.0093%2030.1726%2041.0303%2030.095%2041.0723%2030.0245C41.1143%2029.9533%2041.1805%2029.8985%2041.2709%2029.86ZM41.3328%2029.5578C41.3328%2029.6176%2041.3496%2029.6642%2041.383%2029.6977C41.4172%2029.7312%2041.4624%2029.7479%2041.5186%2029.7479C41.5756%2029.7479%2041.6212%2029.7312%2041.6553%2029.6977C41.6895%2029.6635%2041.7066%2029.6166%2041.7066%2029.5568C41.7066%2029.5005%2041.6895%2029.4557%2041.6553%2029.4222C41.6219%2029.388%2041.5774%2029.3709%2041.5218%2029.3709C41.4642%2029.3709%2041.4183%2029.388%2041.3841%2029.4222C41.3499%2029.4564%2041.3328%2029.5016%2041.3328%2029.5578ZM41.3051%2030.2284C41.3051%2030.311%2041.3261%2030.3755%2041.3681%2030.4217C41.4108%2030.468%2041.4638%2030.4911%2041.5272%2030.4911C41.5891%2030.4911%2041.6404%2030.4691%2041.681%2030.4249C41.7215%2030.3801%2041.7418%2030.3157%2041.7418%2030.2316C41.7418%2030.1583%2041.7212%2030.0996%2041.6799%2030.0554C41.6386%2030.0106%2041.5863%2029.9882%2041.5229%2029.9882C41.4496%2029.9882%2041.3948%2030.0134%2041.3585%2030.064C41.3229%2030.1145%2041.3051%2030.1694%2041.3051%2030.2284ZM42.2202%2030.2893L42.5107%2030.2541C42.5199%2030.3281%2042.5449%2030.3847%2042.5854%2030.4239C42.626%2030.463%2042.6751%2030.4826%2042.7328%2030.4826C42.7947%2030.4826%2042.8467%2030.4591%2042.8887%2030.4121C42.9314%2030.3651%2042.9528%2030.3018%2042.9528%2030.222C42.9528%2030.1466%2042.9325%2030.0868%2042.8919%2030.0426C42.8513%2029.9985%2042.8019%2029.9764%2042.7435%2029.9764C42.705%2029.9764%2042.6591%2029.9839%2042.6057%2029.9988L42.6388%2029.7543C42.72%2029.7564%2042.7819%2029.739%2042.8246%2029.702C42.8674%2029.6642%2042.8887%2029.6144%2042.8887%2029.5525C42.8887%2029.4998%2042.8731%2029.4578%2042.8417%2029.4265C42.8104%2029.3951%2042.7688%2029.3795%2042.7168%2029.3795C42.6655%2029.3795%2042.6217%2029.3973%2042.5854%2029.4329C42.5491%2029.4685%2042.5271%2029.5204%2042.5192%2029.5888L42.2427%2029.5418C42.2619%2029.4471%2042.2907%2029.3717%2042.3291%2029.3154C42.3683%2029.2585%2042.4224%2029.214%2042.4915%2029.1819C42.5612%2029.1492%2042.6392%2029.1328%2042.7253%2029.1328C42.8727%2029.1328%2042.9909%2029.1798%2043.0799%2029.2738C43.1532%2029.3507%2043.1899%2029.4375%2043.1899%2029.5343C43.1899%2029.6717%2043.1147%2029.7814%2042.9645%2029.8632C43.0542%2029.8825%2043.1258%2029.9255%2043.1792%2029.9924C43.2333%2030.0594%2043.2603%2030.1402%2043.2603%2030.2348C43.2603%2030.3722%2043.2101%2030.4894%2043.1098%2030.5862C43.0094%2030.683%2042.8844%2030.7314%2042.7349%2030.7314C42.5933%2030.7314%2042.4758%2030.6908%2042.3825%2030.6097C42.2893%2030.5278%2042.2352%2030.421%2042.2202%2030.2893Z'%20fill='%23007AFF'/%3e%3cg%20clip-path='url(%23clip1_8319_10967)'%3e%3cg%20clip-path='url(%23clip2_8319_10967)'%3e%3crect%20x='3.89111'%20y='13.1241'%20width='19.2456'%20height='23.328'%20rx='1.458'%20fill='%23D2D2D2'/%3e%3cpath%20d='M23.774%2033.1515C24.6646%2034.7673%2025.1773%2038.4938%2025.1773%2038.4938H2.72412C2.72412%2038.4938%203.23699%2034.7669%204.12745%2033.1515C5.0179%2031.5362%2010.4447%2030.0379%2010.4447%2030.0379C10.9253%2030.9184%2012.3363%2031.7215%2013.7806%2031.7574C15.3479%2031.7963%2016.9544%2030.993%2017.4541%2030.0374C17.4541%2030.0374%2022.8834%2031.5358%2023.774%2033.1515Z'%20fill='white'/%3e%3cpath%20d='M11.3212%2028.6495V28.6851C11.3115%2029.4389%2010.6815%2030.0056%209.43115%2030.3854C10.9377%2031.4876%2012.4444%2032.3694%2013.951%2032.3694C15.4575%2032.3694%2016.9642%2031.4876%2018.4708%2030.3854C17.2289%2030.0052%2016.5989%2029.4376%2016.5807%2028.6825C16.5807%2028.396%2016.5816%2025.6045%2016.583%2025.3179C16.6728%2025.3306%2016.6651%2025.3225%2016.583%2025.2996C16.5854%2024.3556%2016.5894%2025.5913%2016.595%2024.3013C16.6006%2023.0113%2011.2343%2021.8572%2011.313%2025.3993C11.3141%2025.7605%2011.3162%2028.2405%2011.3212%2028.6495Z'%20fill='url(%23paint0_linear_8319_10967)'/%3e%3cpath%20d='M23.774%2033.1515C24.6646%2034.7673%2025.1773%2038.4938%2025.1773%2038.4938H2.72412C2.72412%2038.4938%203.23699%2034.7669%204.12745%2033.1515C5.0179%2031.5362%2010.4447%2030.0379%2010.4447%2030.0379C10.4447%2031.0171%2012.3167%2032.4292%2013.7806%2032.4543C15.8218%2032.4543%2017.4541%2031.0171%2017.4541%2030.0374C17.4541%2030.0374%2022.8834%2031.5358%2023.774%2033.1515Z'%20fill='%23007AFF'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M17.5277%2025.2645C16.8122%2027.3791%2015.1639%2028.8702%2013.8056%2028.8702C12.322%2028.8702%2010.742%2027.3833%2010.0641%2025.2733C9.68216%2025.2756%209.43571%2024.2888%209.34859%2023.9151C9.33461%2023.8551%209.31822%2023.7976%209.30207%2023.7409C9.21521%2023.4364%209.13499%2023.155%209.47015%2022.6267C9.55347%2022.4953%209.64178%2022.4217%209.72956%2022.3888C9.7844%2019.768%2010.2642%2017.2062%2013.8056%2017.2062C17.3499%2017.2062%2017.8275%2019.7169%2017.8817%2022.382C17.9702%2022.4152%2018.0589%2022.4898%2018.1419%2022.6235C18.4721%2023.1551%2018.3893%2023.4356%2018.2996%2023.7394L18.2996%2023.7394C18.2829%2023.7959%2018.266%2023.8532%2018.2514%2023.913C18.1612%2024.2845%2017.9071%2025.2628%2017.5277%2025.2645Z'%20fill='url(%23paint1_linear_8319_10967)'/%3e%3c/g%3e%3c/g%3e%3cg%20opacity='0.5'%20clip-path='url(%23clip3_8319_10967)'%3e%3cpath%20d='M64.4011%2033.7762V33.7906C64.3973%2034.0968%2064.1534%2034.3271%2063.6694%2034.4814C64.2526%2034.9292%2064.8358%2035.2874%2065.419%2035.2874C66.0022%2035.2874%2066.5854%2034.9292%2067.1686%2034.4814C66.6879%2034.3269%2066.444%2034.0963%2066.437%2033.7896C66.437%2033.6732%2066.4374%2032.5391%2066.4379%2032.4227C66.4726%2032.4279%2066.4697%2032.4246%2066.4379%2032.4153C66.4388%2032.0318%2066.4404%2032.5338%2066.4425%2032.0097C66.4447%2031.4857%2064.3674%2031.0168%2064.3979%2032.4558C64.3983%2032.6025%2064.3991%2033.61%2064.4011%2033.7762Z'%20fill='url(%23paint2_linear_8319_10967)'/%3e%3cpath%20d='M69.5191%2035.3017C69.8776%2035.9146%2070.084%2037.3281%2070.084%2037.3281H61.0444C61.0444%2037.3281%2061.2509%2035.9144%2061.6094%2035.3017C61.9679%2034.689%2064.1527%2034.1207%2064.1527%2034.1207C64.1527%2034.4921%2064.9064%2035.0277%2065.4957%2035.0373C66.3175%2035.0373%2066.9747%2034.4921%2066.9747%2034.1205C66.9747%2034.1205%2069.1605%2034.6888%2069.5191%2035.3017Z'%20fill='%23C6C6C6'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M67.0406%2032.2085C66.7509%2033.1524%2066.0183%2033.8267%2065.4179%2033.8267C64.7838%2033.8267%2064.1085%2033.1979%2063.8169%2032.3048C63.6457%2032.2712%2063.5307%2031.9204%2063.4883%2031.7821C63.481%2031.7584%2063.4726%2031.7358%2063.4643%2031.7136C63.4195%2031.5938%2063.3781%2031.4832%2063.5426%2031.2621C63.583%2031.2078%2063.6262%2031.1759%2063.6693%2031.1601C63.6775%2030.0146%2063.796%2028.8523%2065.4179%2028.8697C67.1407%2028.8697%2067.1709%2029.9771%2067.1677%2031.1331C67.2115%2031.1518%2067.2541%2031.1877%2067.2915%2031.2481C67.4366%2031.4821%2067.3859%2031.5888%2067.331%2031.7043L67.331%2031.7043C67.3208%2031.7258%2067.3105%2031.7476%2067.3012%2031.7706C67.2592%2031.8748%2067.1628%2032.1027%2067.0406%2032.2085Z'%20fill='url(%23paint3_linear_8319_10967)'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cpattern%20id='pattern0_8319_10967'%20patternContentUnits='objectBoundingBox'%20width='1'%20height='1'%3e%3cuse%20xlink:href='%23image0_8319_10967'%20transform='matrix(0.00598802%200%200%200.00827909%200%20-0.000885226)'/%3e%3c/pattern%3e%3clinearGradient%20id='paint0_linear_8319_10967'%20x1='13.5501'%20y1='25.6147'%20x2='13.5501'%20y2='29.9985'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23B1B1B1'/%3e%3cstop%20offset='1'%20stop-color='white'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear_8319_10967'%20x1='10.3827'%20y1='22.9837'%20x2='16.0242'%20y2='23.0044'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23E0E0E0'/%3e%3cstop%20offset='1'%20stop-color='white'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint2_linear_8319_10967'%20x1='65.2639'%20y1='32.5433'%20x2='65.2639'%20y2='34.3242'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23D6D4D4'/%3e%3cstop%20offset='1'%20stop-color='%23E4E4E4'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint3_linear_8319_10967'%20x1='63.6576'%20y1='31.9783'%20x2='65.5906'%20y2='31.9783'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23CECECE'/%3e%3cstop%20offset='1'%20stop-color='%23E7E7E7'/%3e%3c/linearGradient%3e%3cclipPath%20id='clip0_8319_10967'%3e%3crect%20x='0.100098'%20y='0.00476074'%20width='72.9'%20height='41.9904'%20rx='1.7496'%20fill='white'/%3e%3c/clipPath%3e%3cclipPath%20id='clip1_8319_10967'%3e%3crect%20x='4.18311'%20y='13.1246'%20width='18.954'%20height='23.328'%20rx='1.1664'%20fill='white'/%3e%3c/clipPath%3e%3cclipPath%20id='clip2_8319_10967'%3e%3crect%20width='24.786'%20height='24.786'%20fill='white'%20transform='translate(1.55908%2013.1244)'/%3e%3c/clipPath%3e%3cclipPath%20id='clip3_8319_10967'%3e%3crect%20width='9.9144'%20height='9.9144'%20fill='white'%20transform='translate(60.4614%2027.4137)'/%3e%3c/clipPath%3e%3cimage%20id='image0_8319_10967'%20width='167'%20height='121'%20xlink:href='data:image/png;base64,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'/%3e%3c/defs%3e%3c/svg%3e", TutorialFrontHeader = ({
  title: me,
  subtitle: ue
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "IncodeTutorialHeader IncodeTutorialHeaderFront", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { className: "IncodeText IncodeH1 IncodeTutorialHeaderTitle IncodeTutorialHeaderTitleFront", children: me }),
  ue ? /* @__PURE__ */ jsxRuntimeExports.jsx(TutorialSubtitle, { children: ue }) : null
] }), videoSources = {
  light: {
    position: "https://sdk.incode.com/sdk/tutorials/id-position.mp4",
    shadow: "https://sdk.incode.com/sdk/tutorials/id-shadow.mp4"
  },
  dark: {
    position: "https://sdk.incode.com/sdk/tutorials/front-dark.mp4",
    shadow: "https://sdk.incode.com/sdk/tutorials/front-shadow-dark.mp4"
  }
};
function TutorialFront$1({
  onSuccess: me,
  token: ue = { token: "" },
  ageAssurance: Qe
}) {
  const { t: Ue } = useTranslation();
  useScreenEvents({
    module: eventModuleNames.front,
    screen: eventScreenNames.frontTutorial,
    token: ue == null ? void 0 : ue.token
  });
  const [He, Ge] = useState(Ue("common.continue")), [Xe, Ke] = useState(
    () => Ue(`tutorial.front.${Qe ? "ageVerification" : "titleFrame"}`)
  ), [$e, Je] = useState(
    () => Qe ? Ue("tutorial.front.ageVerificationSubtitle") : null
  ), [Ze, nt] = useState(!0), [tt, et] = useState(null), rt = (ut) => {
    const lt = options.darkMode ? "dark" : "light";
    return videoSources[lt][ut];
  }, it = () => {
    Ge(Ue("common.continue")), Ke(Ue("tutorial.front.titleFrame")), Je(null), nt(!0);
  }, ot = () => {
    Ge(Ue("common.readyToScan")), Ke(Ue("tutorial.front.titleGlare")), Je(null), nt(!1);
  }, at = () => {
    switch (tt.slides[tt.activeIndex].id) {
      case "AGE_ASSURANCE":
        it(), tt.slideTo(1);
        break;
      case "FRAME_INSTRUCTIONS":
        ot(), tt.slideTo(Qe ? 2 : 1);
        break;
      case "GLARE_INSTRUCTIONS":
        st();
        break;
    }
  };
  useEffect(() => {
    ue && addEvent({
      token: ue == null ? void 0 : ue.token,
      code: "tutorialVideoStarted",
      payload: {
        tutorialFrontID: !0
      },
      module: "ID Capture",
      screen: "ID Preparation feedbacks"
    });
  }, []);
  function st() {
    addEvent({
      token: ue == null ? void 0 : ue.token,
      code: "ctaTapped",
      payload: {
        cta: "Continue"
      },
      module: "ID capture",
      screen: "ID Preparation feedbacks"
    }), me();
  }
  return mobile.isDesktop() ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    Tutorial,
    {
      token: ue,
      src: "https://sdk.incode.com/sdk/tutorials/tutorial-front-desktop.mp4",
      next: st,
      type: "Front",
      header: /* @__PURE__ */ jsxRuntimeExports.jsx(HiddenTitle, { "aria-hidden": "true", children: "Capture Front ID Tutorial" })
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(RootContainer, { cssSelector: "IncodeTutorialContainerFront", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(TutorialContainer$1, { role: "region", "aria-live": "assertive", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(TutorialHeader, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      TutorialFrontHeader,
      {
        title: Xe,
        subtitle: $e
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Swiper,
      {
        autoplay: !1,
        className: "IncodeSwiperComponent",
        onSwiper: et,
        pagination: !0,
        modules: [Pagination, A11y],
        children: [
          Qe ? /* @__PURE__ */ jsxRuntimeExports.jsx(
            SwiperSlide,
            {
              id: "AGE_ASSURANCE",
              style: { flexDirection: "column" },
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                VideoContainer,
                {
                  className: "IncodeTutorialAnimationContainer",
                  style: { alignItems: "flex-start" },
                  children: /* @__PURE__ */ jsxRuntimeExports.jsxs(AgeStepsWrapper, { children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsxs(AgeStepContainer, { children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsx(AgeStep, { children: "1" }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(AgeText, { children: Ue("tutorial.front.ageVerificationStep1") }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(
                        "img",
                        {
                          src: step1,
                          alt: Ue("tutorial.front.ageVerificationStep1")
                        }
                      )
                    ] }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(AgeStepDivder, {}),
                    /* @__PURE__ */ jsxRuntimeExports.jsxs(AgeStepContainer, { children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsx(AgeStep, { children: "2" }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(AgeText, { children: Ue("tutorial.front.ageVerificationStep2") }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(
                        "img",
                        {
                          src: step2,
                          alt: Ue("tutorial.front.ageVerificationStep2")
                        }
                      )
                    ] }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(AgeStepDivder, {}),
                    /* @__PURE__ */ jsxRuntimeExports.jsxs(AgeStepContainer, { children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsx(AgeStep, { children: "3" }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(AgeText, { children: Ue("tutorial.front.ageVerificationStep3") }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(
                        "img",
                        {
                          src: step3,
                          alt: Ue("tutorial.front.ageVerificationStep3")
                        }
                      )
                    ] })
                  ] })
                }
              )
            }
          ) : null,
          /* @__PURE__ */ jsxRuntimeExports.jsx(SwiperSlide, { id: "FRAME_INSTRUCTIONS", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VideoContainer, { className: "IncodeTutorialAnimationContainer", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "img",
              {
                src: "",
                "aria-hidden": !Ze,
                style: { opacity: "0", position: "absolute" },
                alt: Ue("tutorial.front.titleAriaFrame"),
                role: "img"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "video",
              {
                preload: "auto",
                className: "IncodeTutorialAnimation",
                playsInline: !0,
                src: rt("position"),
                muted: !0,
                autoPlay: !0,
                loop: !0
              }
            )
          ] }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(SwiperSlide, { id: "GLARE_INSTRUCTIONS", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VideoContainer, { className: "IncodeTutorialAnimationContainer", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "img",
              {
                src: "",
                "aria-hidden": "false",
                style: { opacity: "0", position: "absolute" },
                alt: Ue("tutorial.front.titleGlare"),
                role: "img"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "video",
              {
                preload: "auto",
                className: "IncodeTutorialAnimation",
                playsInline: !0,
                src: rt("shadow"),
                muted: !0,
                autoPlay: !0,
                loop: !0
              }
            )
          ] }) })
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      FrontTutorialAction,
      {
        className: classNames(
          "IncodeTutorialButtonContainer",
          "IncodeTutorialButtonContainerFront"
        ),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          StyledButton,
          {
            className: classNames("IncodeTutorialButton", "IncodeTutorialButtonFront"),
            onClick: at,
            children: He
          }
        )
      }
    )
  ] }) });
}
const TutorialPapperDLHeader = ({
  title: me,
  subtitle: ue
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "IncodeTutorialHeader IncodeTutorialHeaderFront", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { className: "IncodeText IncodeH1 IncodeTutorialHeaderTitle IncodeTutorialHeaderTitleFront", children: me }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("p", { style: { fontSize: "18px" }, children: ue })
] }), videoUrl = "https://sdk.incode.com/sdk/tutorials/paper-license-tutorial.mp4";
function TutorialFront({ onSuccess: me, token: ue }) {
  const { t: Qe } = useTranslation();
  useEffect(() => {
    ue != null && ue.token && addEvent({
      token: ue.token,
      code: "tutorialVideoStarted",
      payload: {
        tutorialFrontID: !0
      },
      module: "ID Capture",
      screen: "ID Preparation feedbacks"
    });
  }, []);
  function Ue() {
    addEvent({
      token: ue == null ? void 0 : ue.token,
      code: "ctaTapped",
      payload: {
        cta: "Continue"
      },
      module: "ID capture",
      screen: "ID Preparation feedbacks"
    }), me();
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(TutorialContainer$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(TutorialHeader, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      TutorialPapperDLHeader,
      {
        title: Qe("tutorial.paperDL.titleFrame"),
        subtitle: Qe("tutorial.paperDL.subtitle")
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VideoContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("video", { preload: "auto", playsInline: !0, src: videoUrl, muted: !0, autoPlay: !0, loop: !0 }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      FrontTutorialAction,
      {
        className: classNames(
          "IncodeTutorialButtonContainer",
          "IncodeTutorialButtonContainerFront"
        ),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          StyledButton,
          {
            className: classNames("IncodeTutorialButton", "IncodeTutorialButtonFront"),
            onClick: Ue,
            children: Qe("common.continue")
          }
        )
      }
    )
  ] });
}
const TutorialPassportHeader = () => {
  const { t: me } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: me("tutorial.passport1") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: me("tutorial.passport2") })
  ] });
};
function TutorialPassport({ onSuccess: me, token: ue, src: Qe, ...Ue }) {
  const He = options.darkMode ? "https://sdk.incode.com/sdk/tutorials/passport-dark.mp4" : "https://sdk.incode.com/sdk/tutorials/passport.gif";
  Qe = Qe || He;
  const { t: Ge } = useTranslation();
  useEffect(() => {
    addEvent({
      token: ue.token,
      code: "tutorialPassport",
      payload: { tutorialPassport: !0 }
    });
  }, [ue.token]);
  function Xe() {
    addEvent({
      token: ue == null ? void 0 : ue.token,
      code: "ctaTapped",
      payload: {
        cta: "Continue"
      },
      module: "ID capture",
      screen: "ID Preparation feedbacks"
    }), me();
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Tutorial,
    {
      ...Ue,
      token: ue,
      src: Qe,
      header: /* @__PURE__ */ jsxRuntimeExports.jsx(TutorialPassportHeader, {}),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonsContainer$4, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        StyledButton,
        {
          className: classNames("IncodeTutorialButton", "IncodeTutorialButtonSelfie"),
          onClick: Xe,
          children: Ge("common.continue")
        }
      ) })
    }
  );
}
function CaptureFrontId(me) {
  const { t: ue } = useTranslation(), Qe = useRef(void 0), [Ue] = useSessionState(null), He = ({
    sharpness: Xe,
    glare: Ke,
    classification: $e,
    failReason: Je
  }) => {
    if (Je === "ID_TYPE_UNACCEPTABLE")
      return Qe.current = ue("notifications.idTypeUnacceptable"), {
        status: !0,
        message: ue("notifications.idTypeUnacceptable")
      };
    if (Je === "WRONG_DOCUMENT_SIDE")
      return {
        status: !0,
        message: ue("notifications.wrongSideFront")
      };
    if (!$e)
      return {
        status: !0,
        message: me.type === "passport" ? ue("notifications.passportClassificationFailed") : ue("notifications.frontClassificationFailed")
      };
    const Ze = mobile.isDesktop() ? -1 : 10, nt = 10;
    return Xe < Ze ? {
      status: !0,
      message: ue("notifications.lowSharpness")
    } : Ke < nt && !(Ue != null && Ue.skipGlareFront) ? {
      status: !0,
      message: ue("notifications.glareDetected")
    } : { status: !1, message: "" };
  }, Ge = () => {
    var $e;
    const Xe = ($e = me.token) == null ? void 0 : $e.token;
    if (me.type === "passport")
      return {
        notificationMessage: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { textAlign: "center" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: ue("notifications.showPassport") }) }),
        notificationVariant: "front"
      };
    const Ke = ue("notifications.showFront.one");
    return me.onLog && me.onLog(
      getLogObject("showFront", {
        message: Ke
      })
    ), Qe.current !== Ke && (addEvent({
      token: Xe,
      code: "cameraFeedbackDisplayed",
      payload: {
        feedback: "Fill frame with front id"
      },
      module: "ID capture",
      screen: "Front ID Camera Capture"
    }), Qe.current = Ke), {
      notificationMessage: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { textAlign: "center" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: Ke }) }),
      notificationVariant: "front"
    };
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CaptureID,
    {
      ...me,
      shouldTakeIdAgain: He,
      type: frontType,
      onlyFront: me.type === "passport",
      getInstructionsNotification: Ge,
      isCreditCard: me.type === "creditCard"
    }
  );
}
function CaptureAndTutorial$1({ ...me }) {
  const [ue, Qe] = useState(!0);
  useEffect(() => {
    Qe(!1);
  }, []);
  const { currentStep: Ue, nextStep: He } = useSteps(), Ge = me.type === "passport" ? TutorialPassport : me.type === "creditCard" ? TutorialCreditCardFront : me.showPaperDLTutorial ? TutorialFront : TutorialFront$1;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Steps, { currentStep: Ue, children: [
    me.showTutorial && isWebRtcSupported() && /* @__PURE__ */ jsxRuntimeExports.jsx(
      Ge,
      {
        className: "IncodeCaptureFrontIdTutorial",
        ...me,
        onSuccess: He,
        disabledButton: ue
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(CaptureFrontId, { ...me })
  ] });
}
const FILE_SIZE_LIMIT = 10 * 1024 * 1024, NativeCameraContainer = qe.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`, LabelButton = qe.label`
  padding: 20px 40px;
  background-color: ${(me) => me.theme.main};
  min-width: 215px;
  border-radius: 31px;
  color: #fff;
  font-size: 1.188rem;
  font-weight: bold;
  border: none;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  margin: 15px 0;

  &:hover {
    background-color: ${(me) => me.theme.main};
  }

  &.button-hidden {
    display: none;
  }

  button {
    text-transform: uppercase;
    width: 100%;
    font-size: 1.188rem;
  }

  &:disabled {
    opacity: 0.5;
    box-shadow: 0 6px 10px 0 rgba(18, 21, 28, 0.4);
    background-color: #757575;
  }
`;
LabelButton.defaultProps = {
  theme
};
function NativeCamera({
  onBoarding: me,
  token: ue,
  onLog: Qe,
  onSuccess: Ue,
  numberOfTries: He,
  onError: Ge,
  documentType: Xe = "addressStatement",
  onlyAllowCapture: Ke = !1,
  sendBase64: $e
}) {
  const Je = ue ? ue.token : me.state.token.token, { t: Ze } = useTranslation(), [nt, tt] = useState(!1), [et, rt] = useState(0), [it, ot] = useState(""), [at, st] = useState(null), [ut, lt] = useState(null), [dt, At] = useState(!1), [pt, gt] = useState({}), wt = useRef(0), Bt = useRef();
  useEffect(() => {
    addScreenEvent({
      module: eventModuleNames.document,
      screen: eventScreenNames.documentCameraCapture,
      token: Je,
      shouldOpen: !0
    });
  }, []);
  const Tt = async (Rt) => {
    var kt;
    const St = await getScaledImageFromFile(Rt.target.files[0]);
    St && (((kt = St.fullImage) == null ? void 0 : kt.size) > FILE_SIZE_LIMIT ? ot(Ze("nativeCamera.maximumSize")) : (ot(""), Rt.target.value = null, gt(St), At(!0)));
  }, yt = () => {
    Ct(pt), At(!1);
  }, Ct = (Rt) => {
    tt(!0), addScreenEvent({
      module: eventModuleNames.document,
      screen: eventScreenNames.documentUploadProgress,
      token: Je,
      shouldOpen: !0
    });
    let St;
    return $e ? St = {
      token: Je,
      image: Rt.imageBase64.replace("data:image/png;base64,", ""),
      docType: Xe,
      onProgress: rt
    } : St = {
      token: Je,
      file: Rt.fullImage,
      docType: Xe,
      onProgress: rt
    }, me.addAddressStatement(St).then(async ({ success: kt }) => {
      if (kt)
        addScreenEvent({
          module: eventModuleNames.document,
          screen: eventScreenNames.documentUploadProgress,
          token: Je,
          shouldOpen: !1
        }), addScreenEvent({
          module: eventModuleNames.document,
          screen: eventScreenNames.documentUploadSuccess,
          token: Je,
          shouldOpen: !0
        }), rt(100), lt(!0), st(!0), Qe(
          getLogObject("successCapture", {
            message: "Document captured successfully"
          })
        ), lt(!0), await sleep(1500), addScreenEvent({
          module: eventModuleNames.document,
          screen: eventScreenNames.documentUploadSuccess,
          token: Je,
          shouldOpen: !1
        }), ht(Rt);
      else {
        addScreenEvent({
          module: eventModuleNames.document,
          screen: eventScreenNames.documentUploadProgress,
          token: Je,
          shouldOpen: !1
        }), addScreenEvent({
          module: eventModuleNames.document,
          screen: eventScreenNames.documentAttemptFailed,
          token: Je,
          shouldOpen: !0
        });
        const jt = Ze("notifications.badProofOfAddress");
        wt.current += 1, Qe(
          getLogObject("attemptFailed", {
            response: { success: kt },
            message: jt,
            attempt: wt.current
          })
        ), lt(!1), st(!0), ot(jt), await sleep(1500), addScreenEvent({
          module: eventModuleNames.document,
          screen: eventScreenNames.documentAttemptFailed,
          token: Je,
          shouldOpen: !1
        }), addScreenEvent({
          module: eventModuleNames.document,
          screen: eventScreenNames.documentCameraCapture,
          token: Je,
          shouldOpen: !0
        });
      }
    }).catch(async (kt) => {
      addScreenEvent({
        module: eventModuleNames.document,
        screen: eventScreenNames.documentUploadProgress,
        token: Je,
        shouldOpen: !1
      }), addScreenEvent({
        module: eventModuleNames.document,
        screen: eventScreenNames.documentAttemptFailed,
        token: Je,
        shouldOpen: !0
      });
      const jt = Ze("notifications.badProofOfAddress");
      wt.current += 1, Qe(
        getLogObject("attemptFailed", {
          response: { error: kt },
          message: kt.message,
          attempt: wt.current
        })
      ), lt(!1), st(!0), ot(jt), await sleep(1500), addScreenEvent({
        module: eventModuleNames.document,
        screen: eventScreenNames.documentAttemptFailed,
        token: Je,
        shouldOpen: !1
      }), addScreenEvent({
        module: eventModuleNames.document,
        screen: eventScreenNames.documentCameraCapture,
        token: Je,
        shouldOpen: !0
      });
    });
  }, ht = async (Rt) => Ue({ ...Rt });
  function It() {
    At(!1), tt(!1), rt(0), st(!1), lt(null), ot(""), gt({});
  }
  function vt() {
    He !== -1 && wt.current >= He ? (Qe(
      getLogObject("noAttemps", {
        response: { success: !1 },
        message: "No attempt left"
      })
    ), Ge("skip")) : It();
  }
  const Et = (Rt) => {
    Rt && It();
  }, bt = () => {
    var Rt;
    (Rt = Bt.current) == null || Rt.click();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    NativeCameraContainer,
    {
      className: "IncodeRootContainer IncodeNativeCameraContainer",
      "aria-live": "assertive",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(HiddenTitle, { children: Ze("common.uploadStatement") }),
        dt && /* @__PURE__ */ jsxRuntimeExports.jsx(
          Retake,
          {
            className: "IncodeNativeCameraRetake",
            fileType: pt.fullImage.type,
            imageBase64: pt.imageBase64,
            onClose: It,
            handleCapture: yt,
            token: Je,
            type: "document"
          }
        ),
        nt && /* @__PURE__ */ jsxRuntimeExports.jsx(
          CapturePreview,
          {
            className: "IncodeNativeCameraCapturePreview",
            open: !0,
            progress: et,
            message: it,
            finishCapture: at,
            captureSuccessful: ut,
            fileType: pt.fullImage.type,
            imageBase64: pt.imageBase64,
            isSelfie: !1,
            isPoa: !0,
            onClose: Et,
            numberOfTries: He < 1 ? 2 : He + 1,
            timesCaptureFailed: wt.current,
            resumeAutocapture: vt
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(LabelButton, { className: "IncodeNativeCameraLabelButton", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "input",
            {
              className: "IncodeNativeCameraInput",
              style: { display: "none" },
              type: "file",
              ref: Bt,
              accept: "application/pdf, image/*",
              onChange: Tt,
              capture: Ke ? "environment" : void 0
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              className: "IncodeNativeCameraButton",
              role: "button",
              onClick: bt,
              type: "button",
              children: Ze(
                `common.${me.isDesktop() ? "uploadStatement" : "takePhoto"}`
              )
            }
          )
        ] }),
        it ? /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: it }) : null
      ]
    }
  );
}
function Selfie(me) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CaptureSelfie$1, { ...me });
}
function CaptureAndTutorial({ ...me }) {
  const { currentStep: ue, nextStep: Qe } = useSteps();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Steps, { currentStep: ue, children: [
    me.showTutorial && isWebRtcSupported() && /* @__PURE__ */ jsxRuntimeExports.jsx(TutorialSelfie, { ...me, onSuccess: Qe }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Selfie, { ...me })
  ] });
}
function App(me) {
  var Ke;
  useModuleEvents({
    module: eventModuleNames[me.type],
    token: (Ke = me.token) == null ? void 0 : Ke.token
  });
  const { nextStep: ue, currentStep: Qe } = useSteps(0), [Ue, He] = useState(null), Ge = ($e) => {
    if ($e.type === "passport")
      return /* @__PURE__ */ jsxRuntimeExports.jsx(CaptureAndTutorial$1, { ...$e });
    if ($e.type === frontType)
      return /* @__PURE__ */ jsxRuntimeExports.jsx(CaptureAndTutorial$1, { ...$e });
    if ($e.type === backType)
      return /* @__PURE__ */ jsxRuntimeExports.jsx(CaptureAndTutorial$3, { ...$e });
    if ($e.type === selfieType)
      return mobile.any() || isSurfaceTablet() ? /* @__PURE__ */ jsxRuntimeExports.jsx(CaptureAndTutorial, { ...$e }) : /* @__PURE__ */ jsxRuntimeExports.jsx(CaptureDesktopSelfie, { ...$e });
    if ($e.type === "document") {
      const Je = $e.nativeCamera ? NativeCamera : CameraPaperStatement;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Je, { ...$e });
    }
    if ($e.type === "secondId")
      return /* @__PURE__ */ jsxRuntimeExports.jsx(AdditionalId, { ...$e });
    if ($e.type === "thirdId")
      return /* @__PURE__ */ jsxRuntimeExports.jsx(AdditionalId, { ...$e });
    if ($e.type === "creditCard")
      return /* @__PURE__ */ jsxRuntimeExports.jsx(CaptureAndTutorial$1, { ...$e });
    if ($e.type === "creditCardBack")
      return /* @__PURE__ */ jsxRuntimeExports.jsx(CaptureAndTutorial$3, { ...$e });
  }, Xe = ($e) => {
    He($e), ue();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(NotificationProvider, { initialValue: { isOpen: !1 }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Steps, { currentStep: Qe, children: [
    Ge({
      ...me,
      goNextCameraStep: Xe
    }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      BiometricConsent,
      {
        token: me.token,
        onSuccess: () => me.onSuccess(Ue),
        onCancel: () => me.onError({ message: "Consent not given" }),
        regulationType: Ue == null ? void 0 : Ue.regulationType
      }
    )
  ] }) });
}
function renderCamera(me, ue, {
  onSuccess: Qe = emptyFunc,
  onError: Ue = emptyFunc,
  numberOfTries: He = 3,
  onLog: Ge = emptyFunc,
  permissionMessage: Xe,
  permissionBackgroundColor: Ke,
  token: $e,
  timeout: Je = 4e4,
  sendBase64: Ze = !0,
  documentType: nt,
  showPreview: tt = !1,
  stream: et,
  nativeCamera: rt = !1,
  hideRetake: it = !1,
  showTutorial: ot = !1,
  showPaperDLTutorial: at = !1,
  onlyCapture: st = !1,
  scanPdf417: ut = !1,
  videoTutorialSrc: lt,
  showCustomCameraPermissionScreen: dt = !1,
  isSecondId: At = !1,
  fullScreen: pt = !0,
  assistedOnboarding: gt = !1,
  isRecordingEnabled: wt = !1,
  onRestartOnboarding: Bt = reload,
  showDoublePermissionsRequest: Tt = !1,
  onlyAllowCapture: yt = !1,
  disableFullScreen: Ct = !1,
  onStreamReady: ht = emptyFunc,
  showAutoCaptureIDOverlay: It = !1,
  showManualCaptureIDOverlay: vt = !1,
  skipProcessFace: Et = !1,
  defaultHorizontalMask: bt = !1,
  isFixedMask: Rt = !1,
  blurrinessStrictMode: St = !1,
  isKiosk: kt = !1,
  ageAssurance: jt = !1,
  publishAudio: Pt = !1,
  zoomLevel: Qt
}) {
  const qt = $e ?? state.token, _t = createRoot$1(ue), Yt = {
    onSuccess: handleUnmountRoot(Qe, _t, ue),
    onError: handleUnmountRoot(Ue, _t, ue),
    onBoarding: this,
    numberOfTries: He,
    onLog: Ge,
    permissionMessage: Xe,
    permissionBackgroundColor: Ke,
    type: me,
    token: qt,
    timeout: Je,
    sendBase64: Ze,
    documentType: nt,
    showPreview: tt,
    stream: et,
    nativeCamera: rt,
    hideRetake: it,
    showTutorial: ot,
    showPaperDLTutorial: at,
    onlyCapture: st,
    scanPdf417: ut,
    videoSrc: lt,
    showCustomCameraPermissionScreen: dt,
    isSecondId: At,
    fullScreen: pt,
    assistedOnboarding: gt,
    isRecordingEnabled: wt,
    onRestartOnboarding: Bt,
    showDoublePermissionsRequest: Tt,
    onlyAllowCapture: yt,
    disableFullScreen: Ct,
    onStreamReady: ht,
    showAutoCaptureIDOverlay: It,
    showManualCaptureIDOverlay: vt,
    skipProcessFace: Et,
    defaultHorizontalMask: bt,
    isFixedMask: Rt,
    blurrinessStrictMode: St,
    isKiosk: kt,
    ageAssurance: jt,
    publishAudio: Pt,
    zoomLevel: Qt
  };
  return customRender(
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      App$1,
      {
        disableFullScreen: Ct,
        isKiosk: kt,
        token: $e == null ? void 0 : $e.token,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(App, { ...Yt })
      }
    ),
    ue,
    _t
  ), { close: handleUnmountRoot(emptyFunc, _t, ue) };
}
function renderCapture(me, ue, Qe) {
  return renderCamera.call(this, me, ue, {
    ...Qe,
    onlyCapture: !0
  });
}
var media = {
  webm: "data:video/webm;base64,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",
  mp4: "data:video/mp4;base64,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"
};
const { webm, mp4 } = media, oldIOS = () => typeof navigator < "u" && parseFloat(
  ("" + (/CPU.*OS ([0-9_]{3,4})[0-9_]{0,1}|(CPU like).*AppleWebKit.*Mobile/i.exec(
    navigator.userAgent
  ) || [0, ""])[1]).replace("undefined", "3_2").replace("_", ".").replace("_", "")
) < 10 && !window.MSStream, nativeWakeLock = () => "wakeLock" in navigator;
class NoSleep {
  constructor() {
    if (this.enabled = !1, nativeWakeLock()) {
      this._wakeLock = null;
      const ue = () => {
        this._wakeLock !== null && document.visibilityState === "visible" && this.enable();
      };
      document.addEventListener("visibilitychange", ue), document.addEventListener("fullscreenchange", ue);
    } else oldIOS() ? this.noSleepTimer = null : (this.noSleepVideo = document.createElement("video"), this.noSleepVideo.setAttribute("title", "No Sleep"), this.noSleepVideo.setAttribute("playsinline", ""), this._addSourceToVideo(this.noSleepVideo, "webm", webm), this._addSourceToVideo(this.noSleepVideo, "mp4", mp4), this.noSleepVideo.addEventListener("loadedmetadata", () => {
      this.noSleepVideo.duration <= 1 ? this.noSleepVideo.setAttribute("loop", "") : this.noSleepVideo.addEventListener("timeupdate", () => {
        this.noSleepVideo.currentTime > 0.5 && (this.noSleepVideo.currentTime = Math.random());
      });
    }));
  }
  _addSourceToVideo(ue, Qe, Ue) {
    var He = document.createElement("source");
    He.src = Ue, He.type = `video/${Qe}`, ue.appendChild(He);
  }
  get isEnabled() {
    return this.enabled;
  }
  enable() {
    return nativeWakeLock() ? navigator.wakeLock.request("screen").then((ue) => {
      this._wakeLock = ue, this.enabled = !0, console.log("Wake Lock active."), this._wakeLock.addEventListener("release", () => {
        console.log("Wake Lock released.");
      });
    }).catch((ue) => {
      throw this.enabled = !1, console.error(`${ue.name}, ${ue.message}`), ue;
    }) : oldIOS() ? (this.disable(), console.warn(`
        NoSleep enabled for older iOS devices. This can interrupt
        active or long-running network requests from completing successfully.
        See https://github.com/richtr/NoSleep.js/issues/15 for more details.
      `), this.noSleepTimer = window.setInterval(() => {
      document.hidden || (window.location.href = window.location.href.split("#")[0], window.setTimeout(window.stop, 0));
    }, 15e3), this.enabled = !0, Promise.resolve()) : this.noSleepVideo.play().then((Qe) => (this.enabled = !0, Qe)).catch((Qe) => {
      throw this.enabled = !1, Qe;
    });
  }
  disable() {
    nativeWakeLock() ? (this._wakeLock && this._wakeLock.release(), this._wakeLock = null) : oldIOS() ? this.noSleepTimer && (console.warn(`
          NoSleep now disabled for older iOS devices.
        `), window.clearInterval(this.noSleepTimer), this.noSleepTimer = null) : this.noSleepVideo.pause(), this.enabled = !1;
  }
}
var src = NoSleep;
const NoSleep$1 = /* @__PURE__ */ getDefaultExportFromCjs(src);
var NetworkTest$1 = { exports: {} };
(function(me, ue) {
  (function(Qe, Ue) {
    me.exports = Ue();
  })(window, function() {
    return function(Qe) {
      var Ue = {};
      function He(Ge) {
        if (Ue[Ge]) return Ue[Ge].exports;
        var Xe = Ue[Ge] = { i: Ge, l: !1, exports: {} };
        return Qe[Ge].call(Xe.exports, Xe, Xe.exports, He), Xe.l = !0, Xe.exports;
      }
      return He.m = Qe, He.c = Ue, He.d = function(Ge, Xe, Ke) {
        He.o(Ge, Xe) || Object.defineProperty(Ge, Xe, { enumerable: !0, get: Ke });
      }, He.r = function(Ge) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(Ge, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(Ge, "__esModule", { value: !0 });
      }, He.t = function(Ge, Xe) {
        if (1 & Xe && (Ge = He(Ge)), 8 & Xe || 4 & Xe && typeof Ge == "object" && Ge && Ge.__esModule) return Ge;
        var Ke = /* @__PURE__ */ Object.create(null);
        if (He.r(Ke), Object.defineProperty(Ke, "default", { enumerable: !0, value: Ge }), 2 & Xe && typeof Ge != "string") for (var $e in Ge) He.d(Ke, $e, (function(Je) {
          return Ge[Je];
        }).bind(null, $e));
        return Ke;
      }, He.n = function(Ge) {
        var Xe = Ge && Ge.__esModule ? function() {
          return Ge.default;
        } : function() {
          return Ge;
        };
        return He.d(Xe, "a", Xe), Xe;
      }, He.o = function(Ge, Xe) {
        return Object.prototype.hasOwnProperty.call(Ge, Xe);
      }, He.p = "", He(He.s = 21);
    }([function(Qe, Ue, He) {
      var Ge = He(8), Xe = Object.prototype.toString;
      function Ke(et) {
        return Xe.call(et) === "[object Array]";
      }
      function $e(et) {
        return et === void 0;
      }
      function Je(et) {
        return et !== null && typeof et == "object";
      }
      function Ze(et) {
        if (Xe.call(et) !== "[object Object]") return !1;
        var rt = Object.getPrototypeOf(et);
        return rt === null || rt === Object.prototype;
      }
      function nt(et) {
        return Xe.call(et) === "[object Function]";
      }
      function tt(et, rt) {
        if (et != null) if (typeof et != "object" && (et = [et]), Ke(et)) for (var it = 0, ot = et.length; it < ot; it++) rt.call(null, et[it], it, et);
        else for (var at in et) Object.prototype.hasOwnProperty.call(et, at) && rt.call(null, et[at], at, et);
      }
      Qe.exports = { isArray: Ke, isArrayBuffer: function(et) {
        return Xe.call(et) === "[object ArrayBuffer]";
      }, isBuffer: function(et) {
        return et !== null && !$e(et) && et.constructor !== null && !$e(et.constructor) && typeof et.constructor.isBuffer == "function" && et.constructor.isBuffer(et);
      }, isFormData: function(et) {
        return typeof FormData < "u" && et instanceof FormData;
      }, isArrayBufferView: function(et) {
        return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(et) : et && et.buffer && et.buffer instanceof ArrayBuffer;
      }, isString: function(et) {
        return typeof et == "string";
      }, isNumber: function(et) {
        return typeof et == "number";
      }, isObject: Je, isPlainObject: Ze, isUndefined: $e, isDate: function(et) {
        return Xe.call(et) === "[object Date]";
      }, isFile: function(et) {
        return Xe.call(et) === "[object File]";
      }, isBlob: function(et) {
        return Xe.call(et) === "[object Blob]";
      }, isFunction: nt, isStream: function(et) {
        return Je(et) && nt(et.pipe);
      }, isURLSearchParams: function(et) {
        return typeof URLSearchParams < "u" && et instanceof URLSearchParams;
      }, isStandardBrowserEnv: function() {
        return (typeof navigator > "u" || navigator.product !== "ReactNative" && navigator.product !== "NativeScript" && navigator.product !== "NS") && typeof window < "u" && typeof document < "u";
      }, forEach: tt, merge: function et() {
        var rt = {};
        function it(st, ut) {
          Ze(rt[ut]) && Ze(st) ? rt[ut] = et(rt[ut], st) : Ze(st) ? rt[ut] = et({}, st) : Ke(st) ? rt[ut] = st.slice() : rt[ut] = st;
        }
        for (var ot = 0, at = arguments.length; ot < at; ot++) tt(arguments[ot], it);
        return rt;
      }, extend: function(et, rt, it) {
        return tt(rt, function(ot, at) {
          et[at] = it && typeof ot == "function" ? Ge(ot, it) : ot;
        }), et;
      }, trim: function(et) {
        return et.trim ? et.trim() : et.replace(/^\s+|\s+$/g, "");
      }, stripBOM: function(et) {
        return et.charCodeAt(0) === 65279 && (et = et.slice(1)), et;
      } };
    }, function(Qe, Ue, He) {
      Object.defineProperty(Ue, "__esModule", { value: !0 }), Ue.assoc = (Ge, Xe, Ke) => Object.assign({}, Ke, { [Ge]: Xe }), Ue.assocPath = (Ge, Xe, Ke) => {
        const $e = Ge.split("."), Je = $e[0];
        if (!$e.length) return Ke;
        if ($e.length === 1) return Ue.assoc(Je, Xe, Ke);
        const Ze = Ue.get(Je, Ke), nt = Ze && typeof Ze == "object" ? Ze : Object.assign({}, Ke, { [Je]: {} }), tt = Ue.assoc(Je, Ue.assocPath($e.slice(1).join("."), Xe, Ue.get(Je, nt)), Ke);
        return Object.assign({}, Ke, tt);
      }, Ue.get = (Ge, Xe) => {
        if (!Xe) return Xe;
        const [Ke, ...$e] = Ge.split("."), Je = Xe[Ke];
        return Je == null ? Je : $e.length ? Ue.get($e.join("."), Je) : Je;
      }, Ue.getOr = (Ge, Xe, Ke) => Ue.get(Xe, Ke) || Ge, Ue.pick = (Ge, Xe, Ke = !1) => Ge.reduce(($e, Je) => Xe[Je] !== void 0 || Ke ? Object.assign({}, $e, { [Je]: Xe[Je] }) : $e, {}), Ue.pickAll = (Ge, Xe) => Ue.pick(Ge, Xe, !0), Ue.last = (Ge) => Ge[Ge.length - 1], Ue.nth = (Ge, Xe) => Ge < 0 ? Xe[Xe.length + Ge] : Xe[Ge], Ue.head = (Ge) => Ue.nth(0, Ge);
    }, function(Qe, Ue, He) {
      Object.defineProperty(Ue, "__esModule", { value: !0 });
      const Ge = He(1);
      (function(Xe) {
        Xe.NETWORK_TEST_ERROR = "NetworkTestError", Xe.MISSING_OPENTOK_INSTANCE = "MissingOpenTokInstanceError", Xe.INCOMPLETE_SESSON_CREDENTIALS = "IncompleteSessionCredentialsError", Xe.MISSING_SESSON_CREDENTIALS = "MissingSessionCredentialsError", Xe.INVALID_ON_UPDATE_CALLBACK = "InvalidOnUpdateCallback", Xe.CONNECTIVITY_ERROR = "ConnectivityError", Xe.API_CONNECTIVITY_ERROR = "APIConnectivityError", Xe.CONNECT_TO_SESSION_ERROR = "ConnectToSessionError", Xe.CONNECT_TO_SESSION_TOKEN_ERROR = "ConnectToSessionTokenError", Xe.CONNECT_TO_SESSION_ID_ERROR = "ConnectToSessionSessionIdError", Xe.CONNECT_TO_SESSION_NETWORK_ERROR = "ConnectToSessionNetworkError", Xe.MEDIA_DEVICE_ERROR = "MediaDeviceError", Xe.FAILED_TO_OBTAIN_MEDIA_DEVICES = "FailedToObtainMediaDevices", Xe.NO_VIDEO_CAPTURE_DEVICES = "NoVideoCaptureDevicesError", Xe.NO_AUDIO_CAPTURE_DEVICES = "NoAudioCaptureDevicesError", Xe.PUBLISH_TO_SESSION_ERROR = "PublishToSessionError", Xe.INIT_PUBLISHER_ERROR = "InitPublisherError", Xe.FAILED_MESSAGING_SERVER_TEST = "FailedMessagingServerTestError", Xe.FAILED_TO_CREATE_LOCAL_PUBLISHER = "FailedToCreateLocalPublisher", Xe.PUBLISH_TO_SESSION_NOT_CONNECTED = "PublishToSessionNotConnectedError", Xe.PUBLISH_TO_SESSION_PERMISSION_OR_TIMEOUT_ERROR = "PublishToSessionPermissionOrTimeoutError", Xe.PUBLISH_TO_SESSION_NETWORK_ERROR = "PublishToSessionNetworkError", Xe.SUBSCRIBE_TO_SESSION_ERROR = "SubscribeToSessionError", Xe.LOGGING_SERVER_CONNECTION_ERROR = "LoggingServerConnectionError", Xe.QUALITY_TEST_ERROR = "QualityTestError", Xe.UNSUPPORTED_BROWSER = "UnsupportedBrowser", Xe.SUBSCRIBER_GET_STATS_ERROR = "SubscriberGetStatsError", Xe.MISSING_SUBSCRIBER_ERROR = "MissingSubscriberError";
      })(Ue.ErrorNames || (Ue.ErrorNames = {})), function(Xe) {
        Xe.JS_EXCEPTION = "JS_EXCEPTION", Xe.OT_AUTHENTICATION_ERROR = "OT_AUTHENTICATION_ERROR", Xe.OT_INVALID_HTTP_STATUS = "OT_INVALID_HTTP_STATUS", Xe.OT_CONNECT_FAILED = "OT_CONNECT_FAILED", Xe.OT_INVALID_SESSION_ID = "OT_INVALID_SESSION_ID", Xe.CONNECT_FAILED = "CONNECT_FAILED", Xe.CONNECT_REJECTED = "CONNECT_REJECTED", Xe.CONNECTION_TIMEOUT = "CONNECTION_TIMEOUT", Xe.NOT_CONNECTED = "NOT_CONNECTED", Xe.INVALID_PARAMETER = "INVALID_PARAMETER", Xe.P2P_CONNECTION_FAILED = "P2P_CONNECTION_FAILED", Xe.API_RESPONSE_FAILURE = "API_RESPONSE_FAILURE", Xe.TERMS_OF_SERVICE_FAILURE = "TERMS_OF_SERVICE_FAILURE", Xe.CONNECTION_LIMIT_EXCEEDED = "CONNECTION_LIMIT_EXCEEDED", Xe.UNABLE_TO_PUBLISH = "UNABLE_TO_PUBLISH", Xe.UNABLE_TO_SUBSCRIBE = "UNABLE_TO_SUBSCRIBE", Xe.UNSUPPORTED_VIDEO_CODEC = "UNSUPPORTED_VIDEO_CODEC", Xe.UNABLE_TO_FORCE_DISCONNECT = "UNABLE_TO_FORCE_DISCONNECT", Xe.UNABLE_TO_FORCE_UNPUBLISH = "UNABLE_TO_FORCE_UNPUBLISH", Xe.PUBLISHER_ICE_WORKFLOW_FAILED = "PUBLISHER_ICE_WORKFLOW_FAILED", Xe.SUBSCRIBER_ICE_WORKFLOW_FAILED = "SUBSCRIBER_ICE_WORKFLOW_FAILED", Xe.STREAM_LIMIT_EXCEEDED = "STREAM_LIMIT_EXCEEDED", Xe.UNEXPECTED_SERVER_RESPONSE = "UNEXPECTED_SERVER_RESPONSE", Xe.REPORT_ISSUE_ERROR = "REPORT_ISSUE_ERROR", Xe.ANVIL_BADLY_FORMED_RESPONSE = "ANVIL_BADLY_FORMED_RESPONSE", Xe.ANVIL_INVALID_HTTP_STATUS = "ANVIL_INVALID_HTTP_STATUS", Xe.ANVIL_XDOMAIN_OR_PARSING_ERROR = "ANVIL_XDOMAIN_OR_PARSING_ERROR", Xe.ANVIL_UNKNOWN_HTTP_ERROR = "ANVIL_UNKNOWN_HTTP_ERROR", Xe.ANVIL_UNEXPECTED_ERROR_CODE = "ANVIL_UNEXPECTED_ERROR_CODE", Xe.ANVIL_EMPTY_RESPONSE_BODY = "ANVIL_EMPTY_RESPONSE_BODY", Xe.ANVIL_CONNECT_FAILED = "ANVIL_CONNECT_FAILED";
      }(Ue.OTErrorType || (Ue.OTErrorType = {})), Ue.errorHasName = (Xe = null, Ke) => Ge.get("name", Xe) === Ke;
    }, function(Qe, Ue, He) {
      var Ge = He(17);
      function Xe() {
      }
      var Ke = null, $e = {};
      function Je(ot) {
        if (typeof this != "object") throw new TypeError("Promises must be constructed via new");
        if (typeof ot != "function") throw new TypeError("Promise constructor's argument is not a function");
        this._U = 0, this._V = 0, this._W = null, this._X = null, ot !== Xe && it(ot, this);
      }
      function Ze(ot, at) {
        for (; ot._V === 3; ) ot = ot._W;
        if (Je._Y && Je._Y(ot), ot._V === 0) return ot._U === 0 ? (ot._U = 1, void (ot._X = at)) : ot._U === 1 ? (ot._U = 2, void (ot._X = [ot._X, at])) : void ot._X.push(at);
        (function(st, ut) {
          Ge(function() {
            var lt = st._V === 1 ? ut.onFulfilled : ut.onRejected;
            if (lt !== null) {
              var dt = function(At, pt) {
                try {
                  return At(pt);
                } catch (gt) {
                  return Ke = gt, $e;
                }
              }(lt, st._W);
              dt === $e ? tt(ut.promise, Ke) : nt(ut.promise, dt);
            } else st._V === 1 ? nt(ut.promise, st._W) : tt(ut.promise, st._W);
          });
        })(ot, at);
      }
      function nt(ot, at) {
        if (at === ot) return tt(ot, new TypeError("A promise cannot be resolved with itself."));
        if (at && (typeof at == "object" || typeof at == "function")) {
          var st = function(ut) {
            try {
              return ut.then;
            } catch (lt) {
              return Ke = lt, $e;
            }
          }(at);
          if (st === $e) return tt(ot, Ke);
          if (st === ot.then && at instanceof Je) return ot._V = 3, ot._W = at, void et(ot);
          if (typeof st == "function") return void it(st.bind(at), ot);
        }
        ot._V = 1, ot._W = at, et(ot);
      }
      function tt(ot, at) {
        ot._V = 2, ot._W = at, Je._Z && Je._Z(ot, at), et(ot);
      }
      function et(ot) {
        if (ot._U === 1 && (Ze(ot, ot._X), ot._X = null), ot._U === 2) {
          for (var at = 0; at < ot._X.length; at++) Ze(ot, ot._X[at]);
          ot._X = null;
        }
      }
      function rt(ot, at, st) {
        this.onFulfilled = typeof ot == "function" ? ot : null, this.onRejected = typeof at == "function" ? at : null, this.promise = st;
      }
      function it(ot, at) {
        var st = !1, ut = function(lt, dt, At) {
          try {
            lt(dt, At);
          } catch (pt) {
            return Ke = pt, $e;
          }
        }(ot, function(lt) {
          st || (st = !0, nt(at, lt));
        }, function(lt) {
          st || (st = !0, tt(at, lt));
        });
        st || ut !== $e || (st = !0, tt(at, Ke));
      }
      Qe.exports = Je, Je._Y = null, Je._Z = null, Je._0 = Xe, Je.prototype.then = function(ot, at) {
        if (this.constructor !== Je) return function(ut, lt, dt) {
          return new ut.constructor(function(At, pt) {
            var gt = new Je(Xe);
            gt.then(At, pt), Ze(ut, new rt(lt, dt, gt));
          });
        }(this, ot, at);
        var st = new Je(Xe);
        return Ze(this, new rt(ot, at, st)), st;
      };
    }, function(Qe, Ue, He) {
      Object.defineProperty(Ue, "__esModule", { value: !0 }), Ue.default = { getStatsInterval: 1e3, getStatsVideoAndAudioTestDuration: 3e4, getStatsAudioOnlyDuration: 1e4, subscribeOptions: { testNetwork: !0, audioVolume: 0 }, minimumVideoAndAudioTestSampleSize: 5, steadyStateSampleWindow: 5e3, steadyStateAllowedDelta: 0.05, qualityThresholds: { video: [{ bps: 1e6, plr: 5e-3, recommendedSetting: "1280x720 @ 30FPS" }, { bps: 6e5, plr: 5e-3, recommendedSetting: "640x480 @ 30FPS" }, { bps: 3e5, plr: 5e-3, recommendedSetting: "320x240 @ 30FPS" }, { bps: 35e4, plr: 0.03, recommendedSetting: "1280x720 @ 30FPS" }, { bps: 25e4, plr: 0.03, recommendedSetting: "640x480 @ 30FPS" }, { bps: 15e4, plr: 0.03, recommendedSetting: "320x240 @ 30FPS" }], audio: [{ minMos: 2.4 }] }, strings: { bandwidthLow: "Bandwidth too low.", noCam: "No camera was found.", noMic: "No microphone was found." } };
    }, function(Qe, Ue, He) {
      (function(Ge) {
        var Xe = He(0), Ke = He(30), $e = He(10), Je = { "Content-Type": "application/x-www-form-urlencoded" };
        function Ze(et, rt) {
          !Xe.isUndefined(et) && Xe.isUndefined(et["Content-Type"]) && (et["Content-Type"] = rt);
        }
        var nt, tt = { transitional: { silentJSONParsing: !0, forcedJSONParsing: !0, clarifyTimeoutError: !1 }, adapter: ((typeof XMLHttpRequest < "u" || Ge !== void 0 && Object.prototype.toString.call(Ge) === "[object process]") && (nt = He(11)), nt), transformRequest: [function(et, rt) {
          return Ke(rt, "Accept"), Ke(rt, "Content-Type"), Xe.isFormData(et) || Xe.isArrayBuffer(et) || Xe.isBuffer(et) || Xe.isStream(et) || Xe.isFile(et) || Xe.isBlob(et) ? et : Xe.isArrayBufferView(et) ? et.buffer : Xe.isURLSearchParams(et) ? (Ze(rt, "application/x-www-form-urlencoded;charset=utf-8"), et.toString()) : Xe.isObject(et) || rt && rt["Content-Type"] === "application/json" ? (Ze(rt, "application/json"), JSON.stringify(et)) : et;
        }], transformResponse: [function(et) {
          var rt = this.transitional, it = rt && rt.silentJSONParsing, ot = rt && rt.forcedJSONParsing, at = !it && this.responseType === "json";
          if (at || ot && Xe.isString(et) && et.length) try {
            return JSON.parse(et);
          } catch (st) {
            if (at)
              throw st.name === "SyntaxError" ? $e(st, this, "E_JSON_PARSE") : st;
          }
          return et;
        }], timeout: 0, xsrfCookieName: "XSRF-TOKEN", xsrfHeaderName: "X-XSRF-TOKEN", maxContentLength: -1, maxBodyLength: -1, validateStatus: function(et) {
          return et >= 200 && et < 300;
        } };
        tt.headers = { common: { Accept: "application/json, text/plain, */*" } }, Xe.forEach(["delete", "get", "head"], function(et) {
          tt.headers[et] = {};
        }), Xe.forEach(["post", "put", "patch"], function(et) {
          tt.headers[et] = Xe.merge(Je);
        }), Qe.exports = tt;
      }).call(this, He(29));
    }, function(Qe, Ue, He) {
      Object.defineProperty(Ue, "__esModule", { value: !0 });
      const Ge = He(2);
      class Xe extends Error {
        constructor($e, Je) {
          super($e), this.name = Je || Ge.ErrorNames.NETWORK_TEST_ERROR, this.stack = new Error($e).stack;
        }
      }
      Ue.NetworkTestError = Xe, Ue.MissingOpenTokInstanceError = class extends Xe {
        constructor() {
          super("An instance of OT, the OpenTok.js client SDK, is required."), this.name = Ge.ErrorNames.MISSING_OPENTOK_INSTANCE;
        }
      }, Ue.IncompleteSessionCredentialsError = class extends Xe {
        constructor() {
          super("NetworkConnectivity requires an apiKey, sessionId, and token.", Ge.ErrorNames.INCOMPLETE_SESSON_CREDENTIALS);
        }
      }, Ue.MissingSessionCredentialsError = class extends Xe {
        constructor() {
          super("NetworkConnectivity requires OpenTok session credentials.", Ge.ErrorNames.MISSING_SESSON_CREDENTIALS);
        }
      }, Ue.InvalidOnUpdateCallback = class extends Xe {
        constructor() {
          super("The onUpdate callback must be a function that accepts a single parameter.", Ge.ErrorNames.INVALID_ON_UPDATE_CALLBACK);
        }
      };
    }, function(Qe, Ue, He) {
      Qe.exports = He(24);
    }, function(Qe, Ue, He) {
      Qe.exports = function(Ge, Xe) {
        return function() {
          for (var Ke = new Array(arguments.length), $e = 0; $e < Ke.length; $e++) Ke[$e] = arguments[$e];
          return Ge.apply(Xe, Ke);
        };
      };
    }, function(Qe, Ue, He) {
      var Ge = He(0);
      function Xe(Ke) {
        return encodeURIComponent(Ke).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
      }
      Qe.exports = function(Ke, $e, Je) {
        if (!$e) return Ke;
        var Ze;
        if (Je) Ze = Je($e);
        else if (Ge.isURLSearchParams($e)) Ze = $e.toString();
        else {
          var nt = [];
          Ge.forEach($e, function(et, rt) {
            et != null && (Ge.isArray(et) ? rt += "[]" : et = [et], Ge.forEach(et, function(it) {
              Ge.isDate(it) ? it = it.toISOString() : Ge.isObject(it) && (it = JSON.stringify(it)), nt.push(Xe(rt) + "=" + Xe(it));
            }));
          }), Ze = nt.join("&");
        }
        if (Ze) {
          var tt = Ke.indexOf("#");
          tt !== -1 && (Ke = Ke.slice(0, tt)), Ke += (Ke.indexOf("?") === -1 ? "?" : "&") + Ze;
        }
        return Ke;
      };
    }, function(Qe, Ue, He) {
      Qe.exports = function(Ge, Xe, Ke, $e, Je) {
        return Ge.config = Xe, Ke && (Ge.code = Ke), Ge.request = $e, Ge.response = Je, Ge.isAxiosError = !0, Ge.toJSON = function() {
          return { message: this.message, name: this.name, description: this.description, number: this.number, fileName: this.fileName, lineNumber: this.lineNumber, columnNumber: this.columnNumber, stack: this.stack, config: this.config, code: this.code };
        }, Ge;
      };
    }, function(Qe, Ue, He) {
      var Ge = He(0), Xe = He(31), Ke = He(32), $e = He(9), Je = He(33), Ze = He(36), nt = He(37), tt = He(12);
      Qe.exports = function(et) {
        return new Promise(function(rt, it) {
          var ot = et.data, at = et.headers, st = et.responseType;
          Ge.isFormData(ot) && delete at["Content-Type"];
          var ut = new XMLHttpRequest();
          if (et.auth) {
            var lt = et.auth.username || "", dt = et.auth.password ? unescape(encodeURIComponent(et.auth.password)) : "";
            at.Authorization = "Basic " + btoa(lt + ":" + dt);
          }
          var At = Je(et.baseURL, et.url);
          function pt() {
            if (ut) {
              var wt = "getAllResponseHeaders" in ut ? Ze(ut.getAllResponseHeaders()) : null, Bt = { data: st && st !== "text" && st !== "json" ? ut.response : ut.responseText, status: ut.status, statusText: ut.statusText, headers: wt, config: et, request: ut };
              Xe(rt, it, Bt), ut = null;
            }
          }
          if (ut.open(et.method.toUpperCase(), $e(At, et.params, et.paramsSerializer), !0), ut.timeout = et.timeout, "onloadend" in ut ? ut.onloadend = pt : ut.onreadystatechange = function() {
            ut && ut.readyState === 4 && (ut.status !== 0 || ut.responseURL && ut.responseURL.indexOf("file:") === 0) && setTimeout(pt);
          }, ut.onabort = function() {
            ut && (it(tt("Request aborted", et, "ECONNABORTED", ut)), ut = null);
          }, ut.onerror = function() {
            it(tt("Network Error", et, null, ut)), ut = null;
          }, ut.ontimeout = function() {
            var wt = "timeout of " + et.timeout + "ms exceeded";
            et.timeoutErrorMessage && (wt = et.timeoutErrorMessage), it(tt(wt, et, et.transitional && et.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", ut)), ut = null;
          }, Ge.isStandardBrowserEnv()) {
            var gt = (et.withCredentials || nt(At)) && et.xsrfCookieName ? Ke.read(et.xsrfCookieName) : void 0;
            gt && (at[et.xsrfHeaderName] = gt);
          }
          "setRequestHeader" in ut && Ge.forEach(at, function(wt, Bt) {
            ot === void 0 && Bt.toLowerCase() === "content-type" ? delete at[Bt] : ut.setRequestHeader(Bt, wt);
          }), Ge.isUndefined(et.withCredentials) || (ut.withCredentials = !!et.withCredentials), st && st !== "json" && (ut.responseType = et.responseType), typeof et.onDownloadProgress == "function" && ut.addEventListener("progress", et.onDownloadProgress), typeof et.onUploadProgress == "function" && ut.upload && ut.upload.addEventListener("progress", et.onUploadProgress), et.cancelToken && et.cancelToken.promise.then(function(wt) {
            ut && (ut.abort(), it(wt), ut = null);
          }), ot || (ot = null), ut.send(ot);
        });
      };
    }, function(Qe, Ue, He) {
      var Ge = He(10);
      Qe.exports = function(Xe, Ke, $e, Je, Ze) {
        var nt = new Error(Xe);
        return Ge(nt, Ke, $e, Je, Ze);
      };
    }, function(Qe, Ue, He) {
      Qe.exports = function(Ge) {
        return !(!Ge || !Ge.__CANCEL__);
      };
    }, function(Qe, Ue, He) {
      var Ge = He(0);
      Qe.exports = function(Xe, Ke) {
        Ke = Ke || {};
        var $e = {}, Je = ["url", "method", "data"], Ze = ["headers", "auth", "proxy", "params"], nt = ["baseURL", "transformRequest", "transformResponse", "paramsSerializer", "timeout", "timeoutMessage", "withCredentials", "adapter", "responseType", "xsrfCookieName", "xsrfHeaderName", "onUploadProgress", "onDownloadProgress", "decompress", "maxContentLength", "maxBodyLength", "maxRedirects", "transport", "httpAgent", "httpsAgent", "cancelToken", "socketPath", "responseEncoding"], tt = ["validateStatus"];
        function et(at, st) {
          return Ge.isPlainObject(at) && Ge.isPlainObject(st) ? Ge.merge(at, st) : Ge.isPlainObject(st) ? Ge.merge({}, st) : Ge.isArray(st) ? st.slice() : st;
        }
        function rt(at) {
          Ge.isUndefined(Ke[at]) ? Ge.isUndefined(Xe[at]) || ($e[at] = et(void 0, Xe[at])) : $e[at] = et(Xe[at], Ke[at]);
        }
        Ge.forEach(Je, function(at) {
          Ge.isUndefined(Ke[at]) || ($e[at] = et(void 0, Ke[at]));
        }), Ge.forEach(Ze, rt), Ge.forEach(nt, function(at) {
          Ge.isUndefined(Ke[at]) ? Ge.isUndefined(Xe[at]) || ($e[at] = et(void 0, Xe[at])) : $e[at] = et(void 0, Ke[at]);
        }), Ge.forEach(tt, function(at) {
          at in Ke ? $e[at] = et(Xe[at], Ke[at]) : at in Xe && ($e[at] = et(void 0, Xe[at]));
        });
        var it = Je.concat(Ze).concat(nt).concat(tt), ot = Object.keys(Xe).concat(Object.keys(Ke)).filter(function(at) {
          return it.indexOf(at) === -1;
        });
        return Ge.forEach(ot, rt), $e;
      };
    }, function(Qe, Ue, He) {
      function Ge(Xe) {
        this.message = Xe;
      }
      Ge.prototype.toString = function() {
        return "Cancel" + (this.message ? ": " + this.message : "");
      }, Ge.prototype.__CANCEL__ = !0, Qe.exports = Ge;
    }, function(Qe, Ue, He) {
      Qe.exports = He(43);
    }, function(Qe, Ue, He) {
      (function(Ge) {
        function Xe(at) {
          $e.length || Ke(), $e[$e.length] = at;
        }
        Qe.exports = Xe;
        var Ke, $e = [], Je = 0;
        function Ze() {
          for (; Je < $e.length; ) {
            var at = Je;
            if (Je += 1, $e[at].call(), Je > 1024) {
              for (var st = 0, ut = $e.length - Je; st < ut; st++) $e[st] = $e[st + Je];
              $e.length -= Je, Je = 0;
            }
          }
          $e.length = 0, Je = 0;
        }
        var nt, tt, et, rt = Ge !== void 0 ? Ge : self, it = rt.MutationObserver || rt.WebKitMutationObserver;
        function ot(at) {
          return function() {
            var st = setTimeout(lt, 0), ut = setInterval(lt, 50);
            function lt() {
              clearTimeout(st), clearInterval(ut), at();
            }
          };
        }
        typeof it == "function" ? (nt = 1, tt = new it(Ze), et = document.createTextNode(""), tt.observe(et, { characterData: !0 }), Ke = function() {
          nt = -nt, et.data = nt;
        }) : Ke = ot(Ze), Xe.requestFlush = Ke, Xe.makeRequestCallFromTimer = ot;
      }).call(this, He(44));
    }, function(Qe, Ue, He) {
      Object.defineProperty(Ue, "__esModule", { value: !0 });
      const Ge = He(4), Xe = He(1);
      Ue.default = function(Ke) {
        const $e = Xe.getOr(0, "timestamp", Xe.last(Ke)) - Ge.default.steadyStateSampleWindow;
        return Ke.filter((Je) => Je.timestamp >= $e);
      };
    }, function(Qe, Ue, He) {
      function Ge(Xe, Ke) {
        const $e = [];
        for (let Je = 1; Je < Ke.length; Je += 1) {
          const Ze = Ke[Je], nt = Ke[Je - 1];
          if (Ze[Xe] && nt[Xe]) {
            const tt = 8 * (Ze[Xe].bytesReceived ? Ze[Xe].bytesReceived - nt[Xe].bytesReceived : 0) / ((Ze.timestamp - nt.timestamp) / 1e3), et = Ze[Xe].packetsReceived, rt = Ze[Xe].packetsLost, it = rt + et;
            let ot = 0;
            it > 0 && rt > 0 && (ot = rt / it);
            const at = Xe === "video" ? { frameRate: Ze[Xe].frameRate } : {};
            $e.push(Object.assign({ averageBitrate: tt, packetLossRatio: ot }, at));
          }
        }
        return $e;
      }
      Object.defineProperty(Ue, "__esModule", { value: !0 }), Ue.default = function(Xe) {
        if (Xe.length < 2) throw new Error("Cannot calculate bitrate with less than two data points.");
        return { audio: Ge("audio", Xe), video: Ge("video", Xe) };
      };
    }, function(Qe, Ue, He) {
      Object.defineProperty(Ue, "__esModule", { value: !0 });
      class Ge {
        constructor(Ke) {
          this.stats = { audio: {}, video: {} }, this.bandwidth = { audio: 0, video: 0 }, this.hasAudioTrack = () => this.statsLog[0] && !!this.statsLog[0].audio, this.hasVideoTrack = () => this.statsLog[0] && !!this.statsLog[0].video, this.statsLog = [], this.audioScoresLog = [], this.videoScoresLog = [], this.audioOnlyFallback = !!Ke;
        }
        audioScore() {
          return this.audioScoresLog.reduce((Ke, $e) => Ke + $e, 0) / this.audioScoresLog.length;
        }
        videoScore() {
          return this.videoScoresLog.reduce((Ke, $e) => Ke + $e, 0) / this.videoScoresLog.length;
        }
        clearInterval() {
          this.intervalId && window.clearInterval(this.intervalId), this.intervalId = void 0;
        }
        pruneAudioScores() {
          const Ke = this.audioScoresLog;
          for (; Ke.length > Ge.maxLogLength; ) Ke.shift();
          this.audioScoresLog = Ke;
        }
        pruneVideoScores() {
          const Ke = this.videoScoresLog;
          for (; Ke.length > Ge.maxLogLength; ) Ke.shift();
          this.videoScoresLog = Ke;
        }
        pruneScores() {
          this.pruneAudioScores(), this.pruneVideoScores();
        }
        audioQualityScore() {
          return this.hasAudioTrack() ? this.audioScore() : 1;
        }
        videoQualityScore() {
          return this.hasVideoTrack() ? this.videoScore() : 1;
        }
      }
      Ge.maxLogLength = 1e3, Ge.scoreInterval = 1e3, Ue.default = Ge;
    }, function(Qe, Ue, He) {
      Object.defineProperty(Ue, "__esModule", { value: !0 });
      const Ge = He(22).version, Xe = He(23), Ke = He(53), $e = He(6), Je = He(61);
      Ue.default = class {
        constructor(nt, tt, et) {
          this.validateOT(nt), this.validateCredentials(tt);
          const rt = this.validateProxyUrl(et);
          this.otLogging = this.startLoggingEngine(tt.apiKey, tt.sessionId, rt), this.OT = nt, this.credentials = tt, this.options = et, this.setProxyUrl(rt);
        }
        validateOT(nt) {
          if (!nt || typeof nt != "object" || !nt.initSession) throw new $e.MissingOpenTokInstanceError();
        }
        validateCredentials(nt) {
          if (!nt) throw new $e.MissingSessionCredentialsError();
          if (!nt.apiKey || !nt.sessionId || !nt.token) throw new $e.IncompleteSessionCredentialsError();
        }
        validateProxyUrl(nt) {
          return nt && nt.proxyServerUrl ? nt.proxyServerUrl : "";
        }
        setProxyUrl(nt) {
          this.OT.setProxyUrl && typeof this.OT.setProxyUrl == "function" && nt && this.OT.setProxyUrl(nt);
        }
        startLoggingEngine(nt, tt, et) {
          return new Je({ sessionId: tt, partnerId: nt, source: window.location.href, clientVersion: "js-network-test-" + Ge, name: "opentok-network-test", componentId: "opentok-network-test" }, { proxyUrl: et });
        }
        testConnectivity() {
          return this.otLogging.logEvent({ action: "testConnectivity", variation: "Attempt" }), Xe.testConnectivity(this.OT, this.credentials, this.otLogging, this.options);
        }
        testQuality(nt) {
          if (this.otLogging.logEvent({ action: "testQuality", variation: "Attempt" }), nt && (typeof nt != "function" || nt.length !== 1)) throw this.otLogging.logEvent({ action: "testQuality", variation: "Failure" }), new $e.InvalidOnUpdateCallback();
          return Ke.testQuality(this.OT, this.credentials, this.otLogging, this.options, nt);
        }
        stop() {
          Ke.stopQualityTest();
        }
      };
      var Ze = He(2);
      Ue.ErrorNames = Ze.ErrorNames;
    }, function(Qe) {
      Qe.exports = JSON.parse('{"name":"opentok-network-test-js","version":"2.5.0","description":"Precall network test for applications using the OpenTok platform.","main":"dist/NetworkTest/index.js","types":"dist/NetworkTest/index.d.ts","scripts":{"build":"rm -rf dist && webpack --config webpack.config.js","test-setup":"node test/setup/setup.js","test-teardown":"rm test/credentials.json","karma":"karma start","test":"npm run test-setup && npm run karma && npm run test-teardown","example":"npm run build && cd sample && npm run build && python -m SimpleHTTPServer","tslint":"./node_modules/tslint/bin/tslint -p tsconfig.json"},"repository":{"type":"git","url":"git+https://github.com/opentok/opentok-network-test-js.git"},"keywords":["tokbox","opentok","network test","connectivity","webrtc"],"author":{"name":"TokBox","email":"contact@tokbox.com"},"license":"MIT","bugs":{"url":"https://github.com/opentok/network-connectivity-js/issues"},"homepage":"https://github.com/opentok/network-connectivity-js#readme","dependencies":{"axios":"^0.21.1","opentok-solutions-logging":"^1.1.1","promise":"^8.0.1"},"devDependencies":{"@opentok/client":"^2.18.0","@types/expect.js":"^0.3.29","@types/jasmine":"^2.8.8","@types/jasmine-matchers":"^0.2.30","@types/mocha":"^5.2.2","@types/node":"^10.3.2","@types/opentok":"^2.3.4","@types/promise":"^7.1.30","@types/webrtc":"0.0.22","dotenv":"^4.0.0","fs-extra":"^4.0.3","jasmine":"^2.99.0","jasmine-core":"^2.99.1","karma":"^5.1.1","karma-chrome-launcher":"^2.2.0","karma-cli":"^1.0.1","karma-firefox-launcher":"^1.1.0","karma-jasmine":"^1.1.2","karma-mocha-reporter":"^2.2.5","karma-safari-launcher":"^1.0.0","karma-safaritechpreview-launcher":"0.0.6","karma-sauce-launcher":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-webpack":"^2.0.13","opentok":"^2.9.1","terser-webpack-plugin":"^2.3.3","ts-loader":"^4.4.1","tslint":"^5.10.0","tslint-config-airbnb":"^5.9.2","typescript":"2.9.2","webpack":"^4.12.0","webpack-cli":"^3.0.4","webpack-node-externals":"^1.7.2"}}');
    }, function(Qe, Ue, He) {
      Object.defineProperty(Ue, "__esModule", { value: !0 });
      const Ge = He(7), Xe = He(16), Ke = He(51), $e = He(2), Je = He(52), Ze = He(1);
      function nt(ot) {
        return new Xe((at, st) => {
          ot.on("sessionDisconnected", () => {
            ot.off(), at();
          }), ot.disconnect();
        });
      }
      function tt(ot) {
        return new Xe((at, st) => {
          ot.on("destroyed", () => {
            at();
          }), ot || at(), ot.destroy();
        });
      }
      function et(ot, at) {
        return new Xe((st, ut) => {
          (function(lt) {
            return new Xe((dt, At) => {
              lt.getDevices((pt, gt = []) => {
                if (pt) At(new Ke.FailedToObtainMediaDevices());
                else {
                  const wt = gt.reduce((Bt, Tt) => {
                    const yt = Tt.kind === "audioInput" ? "audio" : "video";
                    return Object.assign({}, Bt, { [yt]: Object.assign({}, Bt[yt], { [Tt.deviceId]: Tt }) });
                  }, { audio: {}, video: {} });
                  Object.keys(wt.audio).length || Object.keys(wt.video).length ? dt(wt) : At(new Ke.FailedToObtainMediaDevices());
                }
              });
            });
          })(ot).then((lt) => {
            const dt = document.createElement("div");
            dt.style.position = "fixed", dt.style.bottom = "-1px", dt.style.width = "1px", dt.style.height = "1px", dt.style.opacity = "0.01", document.body.appendChild(dt);
            const At = { width: "100%", height: "100%", insertMode: "append", showControls: !1, scalableVideo: !1 };
            at && at.audioSource && (At.audioSource = at.audioSource), at && at.videoSource && (At.videoSource = at.videoSource), at && at.audioOnly && (At.videoSource = null), Object.keys(lt.audio).length || (At.audioSource = null), Object.keys(lt.video).length || (At.videoSource = null), at && at.scalableVideo && (At.scalableVideo = at.scalableVideo);
            const pt = ot.initPublisher(dt, At, (gt) => {
              gt ? ut(new Ke.FailedToCreateLocalPublisher()) : st({ publisher: pt });
            });
            pt.on("streamCreated", () => {
              dt.style.visibility = "hidden";
            });
          }).catch(ut);
        });
      }
      function rt({ session: ot, publisher: at }) {
        return new Xe((st, ut) => {
          const lt = { testNetwork: !0, audioVolume: 0 }, dt = (At) => {
            tt(at).then(() => nt(ot)).then(() => {
              ut(At);
            });
          };
          if (at.stream) {
            const At = document.createElement("div"), pt = ot.subscribe(at.stream, At, lt, (gt) => {
              gt ? dt(new Ke.SubscribeToSessionError()) : st(Object.assign({ session: ot }, { publisher: at }, { subscriber: pt }));
            });
          } else dt(new Ke.SubscribeToSessionError());
        });
      }
      function it(ot, at, st) {
        return new Xe((ut, lt) => {
          const dt = Ze.getOr("", "properties.loggingURL", ot) + "/logging/ClientEvent", At = at && at.proxyServerUrl && `${at.proxyServerUrl}/${dt.replace("https://", "")}` || dt, pt = () => lt(new Ke.LoggingServerConnectionError());
          Ge.default.post(At).then((gt) => gt.status === 200 ? ut(st) : pt()).catch(pt);
        });
      }
      Ue.testConnectivity = function(ot, at, st, ut) {
        return new Xe((lt, dt) => {
          (function(At, { apiKey: pt, sessionId: gt, token: wt }, Bt) {
            return new Xe((Tt, yt) => {
              let Ct = {};
              Bt && Bt.initSessionOptions && (Ct = Bt.initSessionOptions), Bt && Bt.proxyServerUrl && (At.hasOwnProperty("setProxyUrl") || (Ct.proxyUrl = Bt.proxyServerUrl));
              const ht = At.initSession(pt, gt, Ct);
              ht.connect(wt, (It) => {
                $e.errorHasName(It, $e.OTErrorType.OT_AUTHENTICATION_ERROR) ? yt(new Ke.ConnectToSessionTokenError()) : $e.errorHasName(It, $e.OTErrorType.OT_INVALID_SESSION_ID) ? yt(new Ke.ConnectToSessionSessionIdError()) : $e.errorHasName(It, $e.OTErrorType.OT_CONNECT_FAILED) ? yt(new Ke.ConnectToSessionNetworkError()) : $e.errorHasName(It, $e.OTErrorType.OT_INVALID_HTTP_STATUS) ? yt(new Ke.APIConnectivityError()) : It ? yt(new Ke.ConnectToSessionError()) : Tt(ht);
              });
            });
          })(ot, at, ut).then((At) => function(pt, gt, wt) {
            return new Xe((Bt, Tt) => {
              const yt = (Ct) => {
                nt(gt).then(() => {
                  Tt(Ct);
                });
              };
              et(pt, wt).then(({ publisher: Ct }) => {
                gt.publish(Ct, (ht) => {
                  ht ? $e.errorHasName(ht, $e.OTErrorType.NOT_CONNECTED) ? yt(new Ke.PublishToSessionNotConnectedError()) : $e.errorHasName(ht, $e.OTErrorType.UNABLE_TO_PUBLISH) ? yt(new Ke.PublishToSessionPermissionOrTimeoutError()) : ht && yt(new Ke.PublishToSessionError()) : Bt(Object.assign({ session: gt }, { publisher: Ct }));
                });
              }).catch((Ct) => {
                yt(Ct);
              });
            });
          }(ot, At, ut)).then(rt).then((At) => it(ot, ut, At)).then((At) => {
            const pt = { success: !0, failedTests: [] };
            return st.logEvent({ action: "testConnectivity", variation: "Success" }), (gt = At.session, wt = At.subscriber, new Xe((Bt, Tt) => {
              wt.on("destroyed", () => {
                Bt();
              }), wt || Bt(), gt.unsubscribe(wt);
            })).then(() => tt(At.publisher)).then(() => nt(At.session)).then(() => lt(pt));
            var gt, wt;
          }).catch((At) => {
            const pt = (...gt) => {
              const wt = Je.mapErrors(...gt), Bt = wt.find((yt) => yt.type === "messaging"), Tt = { failedTests: [...wt, ...Bt ? Je.mapErrors(new Ke.FailedMessagingServerTestError()) : []], success: !1 };
              st.logEvent({ action: "testConnectivity", variation: "Success" }), lt(Tt);
            };
            At.name === "LoggingServerConnectionError" ? pt(At) : it(ot, ut).then(() => pt(At)).catch((gt) => pt(At, gt));
          });
        });
      };
    }, function(Qe, Ue, He) {
      var Ge = He(0), Xe = He(8), Ke = He(25), $e = He(14);
      function Je(nt) {
        var tt = new Ke(nt), et = Xe(Ke.prototype.request, tt);
        return Ge.extend(et, Ke.prototype, tt), Ge.extend(et, tt), et;
      }
      var Ze = Je(He(5));
      Ze.Axios = Ke, Ze.create = function(nt) {
        return Je($e(Ze.defaults, nt));
      }, Ze.Cancel = He(15), Ze.CancelToken = He(40), Ze.isCancel = He(13), Ze.all = function(nt) {
        return Promise.all(nt);
      }, Ze.spread = He(41), Ze.isAxiosError = He(42), Qe.exports = Ze, Qe.exports.default = Ze;
    }, function(Qe, Ue, He) {
      var Ge = He(0), Xe = He(9), Ke = He(26), $e = He(27), Je = He(14), Ze = He(38), nt = Ze.validators;
      function tt(et) {
        this.defaults = et, this.interceptors = { request: new Ke(), response: new Ke() };
      }
      tt.prototype.request = function(et) {
        typeof et == "string" ? (et = arguments[1] || {}).url = arguments[0] : et = et || {}, (et = Je(this.defaults, et)).method ? et.method = et.method.toLowerCase() : this.defaults.method ? et.method = this.defaults.method.toLowerCase() : et.method = "get";
        var rt = et.transitional;
        rt !== void 0 && Ze.assertOptions(rt, { silentJSONParsing: nt.transitional(nt.boolean, "1.0.0"), forcedJSONParsing: nt.transitional(nt.boolean, "1.0.0"), clarifyTimeoutError: nt.transitional(nt.boolean, "1.0.0") }, !1);
        var it = [], ot = !0;
        this.interceptors.request.forEach(function(pt) {
          typeof pt.runWhen == "function" && pt.runWhen(et) === !1 || (ot = ot && pt.synchronous, it.unshift(pt.fulfilled, pt.rejected));
        });
        var at, st = [];
        if (this.interceptors.response.forEach(function(pt) {
          st.push(pt.fulfilled, pt.rejected);
        }), !ot) {
          var ut = [$e, void 0];
          for (Array.prototype.unshift.apply(ut, it), ut.concat(st), at = Promise.resolve(et); ut.length; ) at = at.then(ut.shift(), ut.shift());
          return at;
        }
        for (var lt = et; it.length; ) {
          var dt = it.shift(), At = it.shift();
          try {
            lt = dt(lt);
          } catch (pt) {
            At(pt);
            break;
          }
        }
        try {
          at = $e(lt);
        } catch (pt) {
          return Promise.reject(pt);
        }
        for (; st.length; ) at = at.then(st.shift(), st.shift());
        return at;
      }, tt.prototype.getUri = function(et) {
        return et = Je(this.defaults, et), Xe(et.url, et.params, et.paramsSerializer).replace(/^\?/, "");
      }, Ge.forEach(["delete", "get", "head", "options"], function(et) {
        tt.prototype[et] = function(rt, it) {
          return this.request(Je(it || {}, { method: et, url: rt, data: (it || {}).data }));
        };
      }), Ge.forEach(["post", "put", "patch"], function(et) {
        tt.prototype[et] = function(rt, it, ot) {
          return this.request(Je(ot || {}, { method: et, url: rt, data: it }));
        };
      }), Qe.exports = tt;
    }, function(Qe, Ue, He) {
      var Ge = He(0);
      function Xe() {
        this.handlers = [];
      }
      Xe.prototype.use = function(Ke, $e, Je) {
        return this.handlers.push({ fulfilled: Ke, rejected: $e, synchronous: !!Je && Je.synchronous, runWhen: Je ? Je.runWhen : null }), this.handlers.length - 1;
      }, Xe.prototype.eject = function(Ke) {
        this.handlers[Ke] && (this.handlers[Ke] = null);
      }, Xe.prototype.forEach = function(Ke) {
        Ge.forEach(this.handlers, function($e) {
          $e !== null && Ke($e);
        });
      }, Qe.exports = Xe;
    }, function(Qe, Ue, He) {
      var Ge = He(0), Xe = He(28), Ke = He(13), $e = He(5);
      function Je(Ze) {
        Ze.cancelToken && Ze.cancelToken.throwIfRequested();
      }
      Qe.exports = function(Ze) {
        return Je(Ze), Ze.headers = Ze.headers || {}, Ze.data = Xe.call(Ze, Ze.data, Ze.headers, Ze.transformRequest), Ze.headers = Ge.merge(Ze.headers.common || {}, Ze.headers[Ze.method] || {}, Ze.headers), Ge.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function(nt) {
          delete Ze.headers[nt];
        }), (Ze.adapter || $e.adapter)(Ze).then(function(nt) {
          return Je(Ze), nt.data = Xe.call(Ze, nt.data, nt.headers, Ze.transformResponse), nt;
        }, function(nt) {
          return Ke(nt) || (Je(Ze), nt && nt.response && (nt.response.data = Xe.call(Ze, nt.response.data, nt.response.headers, Ze.transformResponse))), Promise.reject(nt);
        });
      };
    }, function(Qe, Ue, He) {
      var Ge = He(0), Xe = He(5);
      Qe.exports = function(Ke, $e, Je) {
        var Ze = this || Xe;
        return Ge.forEach(Je, function(nt) {
          Ke = nt.call(Ze, Ke, $e);
        }), Ke;
      };
    }, function(Qe, Ue) {
      var He, Ge, Xe = Qe.exports = {};
      function Ke() {
        throw new Error("setTimeout has not been defined");
      }
      function $e() {
        throw new Error("clearTimeout has not been defined");
      }
      function Je(st) {
        if (He === setTimeout) return setTimeout(st, 0);
        if ((He === Ke || !He) && setTimeout) return He = setTimeout, setTimeout(st, 0);
        try {
          return He(st, 0);
        } catch {
          try {
            return He.call(null, st, 0);
          } catch {
            return He.call(this, st, 0);
          }
        }
      }
      (function() {
        try {
          He = typeof setTimeout == "function" ? setTimeout : Ke;
        } catch {
          He = Ke;
        }
        try {
          Ge = typeof clearTimeout == "function" ? clearTimeout : $e;
        } catch {
          Ge = $e;
        }
      })();
      var Ze, nt = [], tt = !1, et = -1;
      function rt() {
        tt && Ze && (tt = !1, Ze.length ? nt = Ze.concat(nt) : et = -1, nt.length && it());
      }
      function it() {
        if (!tt) {
          var st = Je(rt);
          tt = !0;
          for (var ut = nt.length; ut; ) {
            for (Ze = nt, nt = []; ++et < ut; ) Ze && Ze[et].run();
            et = -1, ut = nt.length;
          }
          Ze = null, tt = !1, function(lt) {
            if (Ge === clearTimeout) return clearTimeout(lt);
            if ((Ge === $e || !Ge) && clearTimeout) return Ge = clearTimeout, clearTimeout(lt);
            try {
              Ge(lt);
            } catch {
              try {
                return Ge.call(null, lt);
              } catch {
                return Ge.call(this, lt);
              }
            }
          }(st);
        }
      }
      function ot(st, ut) {
        this.fun = st, this.array = ut;
      }
      function at() {
      }
      Xe.nextTick = function(st) {
        var ut = new Array(arguments.length - 1);
        if (arguments.length > 1) for (var lt = 1; lt < arguments.length; lt++) ut[lt - 1] = arguments[lt];
        nt.push(new ot(st, ut)), nt.length !== 1 || tt || Je(it);
      }, ot.prototype.run = function() {
        this.fun.apply(null, this.array);
      }, Xe.title = "browser", Xe.browser = !0, Xe.env = {}, Xe.argv = [], Xe.version = "", Xe.versions = {}, Xe.on = at, Xe.addListener = at, Xe.once = at, Xe.off = at, Xe.removeListener = at, Xe.removeAllListeners = at, Xe.emit = at, Xe.prependListener = at, Xe.prependOnceListener = at, Xe.listeners = function(st) {
        return [];
      }, Xe.binding = function(st) {
        throw new Error("process.binding is not supported");
      }, Xe.cwd = function() {
        return "/";
      }, Xe.chdir = function(st) {
        throw new Error("process.chdir is not supported");
      }, Xe.umask = function() {
        return 0;
      };
    }, function(Qe, Ue, He) {
      var Ge = He(0);
      Qe.exports = function(Xe, Ke) {
        Ge.forEach(Xe, function($e, Je) {
          Je !== Ke && Je.toUpperCase() === Ke.toUpperCase() && (Xe[Ke] = $e, delete Xe[Je]);
        });
      };
    }, function(Qe, Ue, He) {
      var Ge = He(12);
      Qe.exports = function(Xe, Ke, $e) {
        var Je = $e.config.validateStatus;
        $e.status && Je && !Je($e.status) ? Ke(Ge("Request failed with status code " + $e.status, $e.config, null, $e.request, $e)) : Xe($e);
      };
    }, function(Qe, Ue, He) {
      var Ge = He(0);
      Qe.exports = Ge.isStandardBrowserEnv() ? { write: function(Xe, Ke, $e, Je, Ze, nt) {
        var tt = [];
        tt.push(Xe + "=" + encodeURIComponent(Ke)), Ge.isNumber($e) && tt.push("expires=" + new Date($e).toGMTString()), Ge.isString(Je) && tt.push("path=" + Je), Ge.isString(Ze) && tt.push("domain=" + Ze), nt === !0 && tt.push("secure"), document.cookie = tt.join("; ");
      }, read: function(Xe) {
        var Ke = document.cookie.match(new RegExp("(^|;\\s*)(" + Xe + ")=([^;]*)"));
        return Ke ? decodeURIComponent(Ke[3]) : null;
      }, remove: function(Xe) {
        this.write(Xe, "", Date.now() - 864e5);
      } } : { write: function() {
      }, read: function() {
        return null;
      }, remove: function() {
      } };
    }, function(Qe, Ue, He) {
      var Ge = He(34), Xe = He(35);
      Qe.exports = function(Ke, $e) {
        return Ke && !Ge($e) ? Xe(Ke, $e) : $e;
      };
    }, function(Qe, Ue, He) {
      Qe.exports = function(Ge) {
        return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(Ge);
      };
    }, function(Qe, Ue, He) {
      Qe.exports = function(Ge, Xe) {
        return Xe ? Ge.replace(/\/+$/, "") + "/" + Xe.replace(/^\/+/, "") : Ge;
      };
    }, function(Qe, Ue, He) {
      var Ge = He(0), Xe = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"];
      Qe.exports = function(Ke) {
        var $e, Je, Ze, nt = {};
        return Ke && Ge.forEach(Ke.split(`
`), function(tt) {
          if (Ze = tt.indexOf(":"), $e = Ge.trim(tt.substr(0, Ze)).toLowerCase(), Je = Ge.trim(tt.substr(Ze + 1)), $e) {
            if (nt[$e] && Xe.indexOf($e) >= 0) return;
            nt[$e] = $e === "set-cookie" ? (nt[$e] ? nt[$e] : []).concat([Je]) : nt[$e] ? nt[$e] + ", " + Je : Je;
          }
        }), nt;
      };
    }, function(Qe, Ue, He) {
      var Ge = He(0);
      Qe.exports = Ge.isStandardBrowserEnv() ? function() {
        var Xe, Ke = /(msie|trident)/i.test(navigator.userAgent), $e = document.createElement("a");
        function Je(Ze) {
          var nt = Ze;
          return Ke && ($e.setAttribute("href", nt), nt = $e.href), $e.setAttribute("href", nt), { href: $e.href, protocol: $e.protocol ? $e.protocol.replace(/:$/, "") : "", host: $e.host, search: $e.search ? $e.search.replace(/^\?/, "") : "", hash: $e.hash ? $e.hash.replace(/^#/, "") : "", hostname: $e.hostname, port: $e.port, pathname: $e.pathname.charAt(0) === "/" ? $e.pathname : "/" + $e.pathname };
        }
        return Xe = Je(window.location.href), function(Ze) {
          var nt = Ge.isString(Ze) ? Je(Ze) : Ze;
          return nt.protocol === Xe.protocol && nt.host === Xe.host;
        };
      }() : function() {
        return !0;
      };
    }, function(Qe, Ue, He) {
      var Ge = He(39), Xe = {};
      ["object", "boolean", "number", "function", "string", "symbol"].forEach(function(Ze, nt) {
        Xe[Ze] = function(tt) {
          return typeof tt === Ze || "a" + (nt < 1 ? "n " : " ") + Ze;
        };
      });
      var Ke = {}, $e = Ge.version.split(".");
      function Je(Ze, nt) {
        for (var tt = nt ? nt.split(".") : $e, et = Ze.split("."), rt = 0; rt < 3; rt++) {
          if (tt[rt] > et[rt]) return !0;
          if (tt[rt] < et[rt]) return !1;
        }
        return !1;
      }
      Xe.transitional = function(Ze, nt, tt) {
        var et = nt && Je(nt);
        function rt(it, ot) {
          return "[Axios v" + Ge.version + "] Transitional option '" + it + "'" + ot + (tt ? ". " + tt : "");
        }
        return function(it, ot, at) {
          if (Ze === !1) throw new Error(rt(ot, " has been removed in " + nt));
          return et && !Ke[ot] && (Ke[ot] = !0, console.warn(rt(ot, " has been deprecated since v" + nt + " and will be removed in the near future"))), !Ze || Ze(it, ot, at);
        };
      }, Qe.exports = { isOlderVersion: Je, assertOptions: function(Ze, nt, tt) {
        if (typeof Ze != "object") throw new TypeError("options must be an object");
        for (var et = Object.keys(Ze), rt = et.length; rt-- > 0; ) {
          var it = et[rt], ot = nt[it];
          if (ot) {
            var at = Ze[it], st = at === void 0 || ot(at, it, Ze);
            if (st !== !0) throw new TypeError("option " + it + " must be " + st);
          } else if (tt !== !0) throw Error("Unknown option " + it);
        }
      }, validators: Xe };
    }, function(Qe) {
      Qe.exports = JSON.parse('{"_args":[["axios@0.21.2","/Users/jswartz_1/src/opentok-network-test-js"]],"_from":"axios@0.21.2","_id":"axios@0.21.2","_inBundle":false,"_integrity":"sha512-87otirqUw3e8CzHTMO+/9kh/FSgXt/eVDvipijwDtEuwbkySWZ9SBm6VEubmJ/kLKEoLQV/POhxXFb66bfekfg==","_location":"/axios","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"axios@0.21.2","name":"axios","escapedName":"axios","rawSpec":"0.21.2","saveSpec":null,"fetchSpec":"0.21.2"},"_requiredBy":["/","/opentok-solutions-logging"],"_resolved":"https://registry.npmjs.org/axios/-/axios-0.21.2.tgz","_spec":"0.21.2","_where":"/Users/jswartz_1/src/opentok-network-test-js","author":{"name":"Matt Zabriskie"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"bugs":{"url":"https://github.com/axios/axios/issues"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}],"dependencies":{"follow-redirects":"^1.14.0"},"description":"Promise based HTTP client for the browser and node.js","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"homepage":"https://axios-http.com","jsdelivr":"dist/axios.min.js","keywords":["xhr","http","ajax","promise","node"],"license":"MIT","main":"index.js","name":"axios","repository":{"type":"git","url":"git+https://github.com/axios/axios.git"},"scripts":{"build":"NODE_ENV=production grunt build","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","examples":"node ./examples/server.js","fix":"eslint --fix lib/**/*.js","postversion":"git push && git push --tags","preversion":"npm test","start":"node ./sandbox/server.js","test":"grunt test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json"},"typings":"./index.d.ts","unpkg":"dist/axios.min.js","version":"0.21.2"}');
    }, function(Qe, Ue, He) {
      var Ge = He(15);
      function Xe(Ke) {
        if (typeof Ke != "function") throw new TypeError("executor must be a function.");
        var $e;
        this.promise = new Promise(function(Ze) {
          $e = Ze;
        });
        var Je = this;
        Ke(function(Ze) {
          Je.reason || (Je.reason = new Ge(Ze), $e(Je.reason));
        });
      }
      Xe.prototype.throwIfRequested = function() {
        if (this.reason) throw this.reason;
      }, Xe.source = function() {
        var Ke;
        return { token: new Xe(function($e) {
          Ke = $e;
        }), cancel: Ke };
      }, Qe.exports = Xe;
    }, function(Qe, Ue, He) {
      Qe.exports = function(Ge) {
        return function(Xe) {
          return Ge.apply(null, Xe);
        };
      };
    }, function(Qe, Ue, He) {
      Qe.exports = function(Ge) {
        return typeof Ge == "object" && Ge.isAxiosError === !0;
      };
    }, function(Qe, Ue, He) {
      Qe.exports = He(3), He(45), He(46), He(47), He(48), He(50);
    }, function(Qe, Ue) {
      var He;
      He = /* @__PURE__ */ function() {
        return this;
      }();
      try {
        He = He || new Function("return this")();
      } catch {
        typeof window == "object" && (He = window);
      }
      Qe.exports = He;
    }, function(Qe, Ue, He) {
      var Ge = He(3);
      Qe.exports = Ge, Ge.prototype.done = function(Xe, Ke) {
        var $e = arguments.length ? this.then.apply(this, arguments) : this;
        $e.then(null, function(Je) {
          setTimeout(function() {
            throw Je;
          }, 0);
        });
      };
    }, function(Qe, Ue, He) {
      var Ge = He(3);
      Qe.exports = Ge, Ge.prototype.finally = function(Xe) {
        return this.then(function(Ke) {
          return Ge.resolve(Xe()).then(function() {
            return Ke;
          });
        }, function(Ke) {
          return Ge.resolve(Xe()).then(function() {
            throw Ke;
          });
        });
      };
    }, function(Qe, Ue, He) {
      var Ge = He(3);
      Qe.exports = Ge;
      var Xe = tt(!0), Ke = tt(!1), $e = tt(null), Je = tt(void 0), Ze = tt(0), nt = tt("");
      function tt(rt) {
        var it = new Ge(Ge._0);
        return it._V = 1, it._W = rt, it;
      }
      Ge.resolve = function(rt) {
        if (rt instanceof Ge) return rt;
        if (rt === null) return $e;
        if (rt === void 0) return Je;
        if (rt === !0) return Xe;
        if (rt === !1) return Ke;
        if (rt === 0) return Ze;
        if (rt === "") return nt;
        if (typeof rt == "object" || typeof rt == "function") try {
          var it = rt.then;
          if (typeof it == "function") return new Ge(it.bind(rt));
        } catch (ot) {
          return new Ge(function(at, st) {
            st(ot);
          });
        }
        return tt(rt);
      };
      var et = function(rt) {
        return typeof Array.from == "function" ? (et = Array.from, Array.from(rt)) : (et = function(it) {
          return Array.prototype.slice.call(it);
        }, Array.prototype.slice.call(rt));
      };
      Ge.all = function(rt) {
        var it = et(rt);
        return new Ge(function(ot, at) {
          if (it.length === 0) return ot([]);
          var st = it.length;
          function ut(dt, At) {
            if (At && (typeof At == "object" || typeof At == "function")) {
              if (At instanceof Ge && At.then === Ge.prototype.then) {
                for (; At._V === 3; ) At = At._W;
                return At._V === 1 ? ut(dt, At._W) : (At._V === 2 && at(At._W), void At.then(function(gt) {
                  ut(dt, gt);
                }, at));
              }
              var pt = At.then;
              if (typeof pt == "function") return void new Ge(pt.bind(At)).then(function(gt) {
                ut(dt, gt);
              }, at);
            }
            it[dt] = At, --st == 0 && ot(it);
          }
          for (var lt = 0; lt < it.length; lt++) ut(lt, it[lt]);
        });
      }, Ge.reject = function(rt) {
        return new Ge(function(it, ot) {
          ot(rt);
        });
      }, Ge.race = function(rt) {
        return new Ge(function(it, ot) {
          et(rt).forEach(function(at) {
            Ge.resolve(at).then(it, ot);
          });
        });
      }, Ge.prototype.catch = function(rt) {
        return this.then(null, rt);
      };
    }, function(Qe, Ue, He) {
      var Ge = He(3), Xe = He(49);
      Qe.exports = Ge, Ge.denodeify = function($e, Je) {
        return typeof Je == "number" && Je !== 1 / 0 ? function(Ze, nt) {
          for (var tt = [], et = 0; et < nt; et++) tt.push("a" + et);
          var rt = ["return function (" + tt.join(",") + ") {", "var self = this;", "return new Promise(function (rs, rj) {", "var res = fn.call(", ["self"].concat(tt).concat([Ke]).join(","), ");", "if (res &&", '(typeof res === "object" || typeof res === "function") &&', 'typeof res.then === "function"', ") {rs(res);}", "});", "};"].join("");
          return Function(["Promise", "fn"], rt)(Ge, Ze);
        }($e, Je) : function(Ze) {
          for (var nt = Math.max(Ze.length - 1, 3), tt = [], et = 0; et < nt; et++) tt.push("a" + et);
          var rt = ["return function (" + tt.join(",") + ") {", "var self = this;", "var args;", "var argLength = arguments.length;", "if (arguments.length > " + nt + ") {", "args = new Array(arguments.length + 1);", "for (var i = 0; i < arguments.length; i++) {", "args[i] = arguments[i];", "}", "}", "return new Promise(function (rs, rj) {", "var cb = " + Ke + ";", "var res;", "switch (argLength) {", tt.concat(["extra"]).map(function(it, ot) {
            return "case " + ot + ":res = fn.call(" + ["self"].concat(tt.slice(0, ot)).concat("cb").join(",") + ");break;";
          }).join(""), "default:", "args[argLength] = cb;", "res = fn.apply(self, args);", "}", "if (res &&", '(typeof res === "object" || typeof res === "function") &&', 'typeof res.then === "function"', ") {rs(res);}", "});", "};"].join("");
          return Function(["Promise", "fn"], rt)(Ge, Ze);
        }($e);
      };
      var Ke = "function (err, res) {if (err) { rj(err); } else { rs(res); }}";
      Ge.nodeify = function($e) {
        return function() {
          var Je = Array.prototype.slice.call(arguments), Ze = typeof Je[Je.length - 1] == "function" ? Je.pop() : null, nt = this;
          try {
            return $e.apply(this, arguments).nodeify(Ze, nt);
          } catch (tt) {
            if (Ze == null) return new Ge(function(et, rt) {
              rt(tt);
            });
            Xe(function() {
              Ze.call(nt, tt);
            });
          }
        };
      }, Ge.prototype.nodeify = function($e, Je) {
        if (typeof $e != "function") return this;
        this.then(function(Ze) {
          Xe(function() {
            $e.call(Je, null, Ze);
          });
        }, function(Ze) {
          Xe(function() {
            $e.call(Je, Ze);
          });
        });
      };
    }, function(Qe, Ue, He) {
      var Ge = He(17), Xe = [], Ke = [], $e = Ge.makeRequestCallFromTimer(function() {
        if (Ke.length) throw Ke.shift();
      });
      function Je(nt) {
        var tt;
        (tt = Xe.length ? Xe.pop() : new Ze()).task = nt, Ge(tt);
      }
      function Ze() {
        this.task = null;
      }
      Qe.exports = Je, Ze.prototype.call = function() {
        try {
          this.task.call();
        } catch (nt) {
          Je.onerror ? Je.onerror(nt) : (Ke.push(nt), $e());
        } finally {
          this.task = null, Xe[Xe.length] = this;
        }
      };
    }, function(Qe, Ue, He) {
      var Ge = He(3);
      Qe.exports = Ge, Ge.enableSynchronous = function() {
        Ge.prototype.isPending = function() {
          return this.getState() == 0;
        }, Ge.prototype.isFulfilled = function() {
          return this.getState() == 1;
        }, Ge.prototype.isRejected = function() {
          return this.getState() == 2;
        }, Ge.prototype.getValue = function() {
          if (this._V === 3) return this._W.getValue();
          if (!this.isFulfilled()) throw new Error("Cannot get a value of an unfulfilled promise.");
          return this._W;
        }, Ge.prototype.getReason = function() {
          if (this._V === 3) return this._W.getReason();
          if (!this.isRejected()) throw new Error("Cannot get a rejection reason of a non-rejected promise.");
          return this._W;
        }, Ge.prototype.getState = function() {
          return this._V === 3 ? this._W.getState() : this._V === -1 || this._V === -2 ? 0 : this._V;
        };
      }, Ge.disableSynchronous = function() {
        Ge.prototype.isPending = void 0, Ge.prototype.isFulfilled = void 0, Ge.prototype.isRejected = void 0, Ge.prototype.getValue = void 0, Ge.prototype.getReason = void 0, Ge.prototype.getState = void 0;
      };
    }, function(Qe, Ue, He) {
      Object.defineProperty(Ue, "__esModule", { value: !0 });
      const Ge = He(6), Xe = He(2);
      class Ke extends Ge.NetworkTestError {
        constructor(tt, et) {
          super(tt, et || Xe.ErrorNames.CONNECTIVITY_ERROR);
        }
      }
      Ue.ConnectivityError = Ke, Ue.APIConnectivityError = class extends Ke {
        constructor() {
          super("Failed to connect to OpenTOK API Server", Xe.ErrorNames.API_CONNECTIVITY_ERROR);
        }
      };
      class $e extends Ke {
        constructor(tt, et) {
          super(tt || "Failed to connect to the session due to a network error.", et || Xe.ErrorNames.CONNECT_TO_SESSION_ERROR);
        }
      }
      Ue.ConnectToSessionError = $e, Ue.ConnectToSessionTokenError = class extends $e {
        constructor() {
          super("Failed to connect to the session due to an invalid token.", Xe.ErrorNames.CONNECT_TO_SESSION_TOKEN_ERROR);
        }
      }, Ue.ConnectToSessionSessionIdError = class extends $e {
        constructor() {
          super("Failed to connect to the session due to an invalid session ID.", Xe.ErrorNames.CONNECT_TO_SESSION_ID_ERROR);
        }
      }, Ue.ConnectToSessionNetworkError = class extends $e {
        constructor() {
          super("Failed to connect to the session due to a network error.", Xe.ErrorNames.CONNECT_TO_SESSION_NETWORK_ERROR);
        }
      };
      class Je extends Ke {
        constructor(tt, et) {
          super(tt || "OpenTok failed to find media devices for this browser.", et || Xe.ErrorNames.MEDIA_DEVICE_ERROR);
        }
      }
      Ue.MediaDeviceError = Je, Ue.FailedToObtainMediaDevices = class extends Je {
        constructor() {
          super("Failed to obtain media devices.", Xe.ErrorNames.FAILED_TO_OBTAIN_MEDIA_DEVICES);
        }
      }, Ue.NoVideoCaptureDevicesError = class extends Je {
        constructor() {
          super("This browser has no video capture devices", Xe.ErrorNames.NO_VIDEO_CAPTURE_DEVICES);
        }
      }, Ue.NoAudioCaptureDevicesError = class extends Je {
        constructor() {
          super("This browser has no audio capture devices.", Xe.ErrorNames.NO_AUDIO_CAPTURE_DEVICES);
        }
      };
      class Ze extends Ke {
        constructor(tt, et) {
          super(tt || "Encountered an unknown error while attempting to publish to a session.", et || Xe.ErrorNames.PUBLISH_TO_SESSION_ERROR);
        }
      }
      Ue.PublishToSessionError = Ze, Ue.FailedMessagingServerTestError = class extends Ze {
        constructor() {
          super("Failed to connect to media server due to messaging server connection failure", Xe.ErrorNames.FAILED_MESSAGING_SERVER_TEST);
        }
      }, Ue.FailedToCreateLocalPublisher = class extends Ze {
        constructor() {
          super("Failed to create a local publisher object.", Xe.ErrorNames.FAILED_TO_CREATE_LOCAL_PUBLISHER);
        }
      }, Ue.PublishToSessionNotConnectedError = class extends Ze {
        constructor() {
          super("Precall failed to publish to the session because it was not connected.", Xe.ErrorNames.PUBLISH_TO_SESSION_NOT_CONNECTED);
        }
      }, Ue.PublishToSessionPermissionOrTimeoutError = class extends Ze {
        constructor() {
          super("Precall failed to publish to the session due a permissions error or timeout.", Xe.ErrorNames.PUBLISH_TO_SESSION_PERMISSION_OR_TIMEOUT_ERROR);
        }
      }, Ue.PublishToSessionNetworkError = class extends Ze {
        constructor() {
          super("Precall failed to publish to the session due a network error.", Xe.ErrorNames.PUBLISH_TO_SESSION_NETWORK_ERROR);
        }
      }, Ue.SubscribeToSessionError = class extends Ke {
        constructor(nt) {
          super(nt || "Encountered an unknown error while attempting to subscribe to a session.", Xe.ErrorNames.SUBSCRIBE_TO_SESSION_ERROR);
        }
      }, Ue.LoggingServerConnectionError = class extends Ke {
        constructor() {
          super("Failed to connect to the OpenTok logging server.", Xe.ErrorNames.LOGGING_SERVER_CONNECTION_ERROR);
        }
      };
    }, function(Qe, Ue, He) {
      Object.defineProperty(Ue, "__esModule", { value: !0 });
      const Ge = He(2);
      var Xe;
      (function($e) {
        $e.Api = "api", $e.Messaging = "messaging", $e.OpentokJs = "OpenTok.js", $e.Media = "media", $e.Logging = "logging", $e.ConnectivityError = "OpenTok.js";
      })(Xe = Ue.FailureType || (Ue.FailureType = {}));
      const Ke = ($e) => ({ error: $e, type: (() => {
        switch ($e.name) {
          case Ge.ErrorNames.API_CONNECTIVITY_ERROR:
          case Ge.ErrorNames.CONNECT_TO_SESSION_NETWORK_ERROR:
            return Xe.Api;
          case Ge.ErrorNames.CONNECT_TO_SESSION_ERROR:
          case Ge.ErrorNames.CONNECT_TO_SESSION_TOKEN_ERROR:
          case Ge.ErrorNames.CONNECT_TO_SESSION_ID_ERROR:
            return Xe.Messaging;
          case Ge.ErrorNames.MEDIA_DEVICE_ERROR:
          case Ge.ErrorNames.FAILED_TO_OBTAIN_MEDIA_DEVICES:
          case Ge.ErrorNames.NO_VIDEO_CAPTURE_DEVICES:
          case Ge.ErrorNames.NO_AUDIO_CAPTURE_DEVICES:
          case Ge.ErrorNames.FAILED_TO_CREATE_LOCAL_PUBLISHER:
          case Ge.ErrorNames.PUBLISH_TO_SESSION_NOT_CONNECTED:
          case Ge.ErrorNames.PUBLISH_TO_SESSION_PERMISSION_OR_TIMEOUT_ERROR:
          case Ge.ErrorNames.PUBLISH_TO_SESSION_NETWORK_ERROR:
            return Xe.OpentokJs;
          case Ge.ErrorNames.PUBLISH_TO_SESSION_ERROR:
          case Ge.ErrorNames.SUBSCRIBE_TO_SESSION_ERROR:
          case Ge.ErrorNames.FAILED_MESSAGING_SERVER_TEST:
            return Xe.Media;
          case Ge.ErrorNames.LOGGING_SERVER_CONNECTION_ERROR:
            return Xe.Logging;
          default:
            return Xe.OpentokJs;
        }
      })() });
      Ue.mapErrors = (...$e) => $e.map(Ke);
    }, function(Qe, Ue, He) {
      Object.defineProperty(Ue, "__esModule", { value: !0 });
      const Ge = He(16), Xe = He(1), Ke = He(54), $e = He(2), Je = He(55), Ze = He(20), nt = He(4), tt = He(60);
      let et, rt, it, ot = !1, at = !1, st = !1;
      function ut(At, pt) {
        return (gt) => new Ge((wt, Bt) => {
          const Tt = document.createElement("div");
          Tt.style.position = "fixed", Tt.style.bottom = "-1px", Tt.style.width = "1px", Tt.style.height = "1px", Tt.style.opacity = "0", document.body.appendChild(Tt), function(yt) {
            return new Ge((Ct, ht) => {
              yt.getDevices((It, vt = []) => {
                if (It) ht(new Ke.FailedToObtainMediaDevices());
                else {
                  const Et = vt.reduce((bt, Rt) => {
                    const St = Rt.kind === "audioInput" ? "audio" : "video";
                    return Object.assign({}, bt, { [St]: Object.assign({}, bt[St], { [Rt.deviceId]: Rt }) });
                  }, { audio: {}, video: {} });
                  Object.keys(Et.audio).length ? Ct(Et) : ht(new Ke.NoAudioCaptureDevicesError());
                }
              });
            });
          }(At).then((yt) => {
            Object.keys(yt.video).length || (ot = !0);
            const Ct = { resolution: "1280x720", width: "100%", height: "100%", insertMode: "append", showControls: !1 };
            pt && pt.audioSource && (Ct.audioSource = pt.audioSource), pt && pt.videoSource && (Ct.videoSource = pt.videoSource), ot && (Ct.videoSource = null);
            const ht = At.initPublisher(Tt, Ct, (It) => {
              It ? Bt(new Ke.InitPublisherError(It.message)) : gt.publish(ht, (vt) => {
                if (vt) return $e.errorHasName(vt, $e.OTErrorType.NOT_CONNECTED) ? Bt(new Ke.PublishToSessionNotConnectedError()) : $e.errorHasName(vt, $e.OTErrorType.UNABLE_TO_PUBLISH) ? Bt(new Ke.PublishToSessionPermissionOrTimeoutError()) : Bt(new Ke.PublishToSessionError());
              });
            });
            ht.on("streamCreated", (It) => {
              const vt = gt.subscribe(It.stream, Tt, { testNetwork: !0, insertMode: "append" }, (Et) => Et ? Bt(new Ke.SubscribeToSessionError(Et.message)) : wt({ publisher: ht, subscriber: vt }));
            });
          }).catch(Bt);
        });
      }
      function lt(At, pt, gt, wt) {
        return new Ge((Bt, Tt) => {
          (function(yt, Ct) {
            return new Ge((ht, It) => {
              yt.connection ? ht(yt) : yt.connect(Ct, (vt) => {
                vt && ($e.errorHasName(vt, $e.OTErrorType.OT_AUTHENTICATION_ERROR) ? It(new Ke.ConnectToSessionTokenError()) : $e.errorHasName(vt, $e.OTErrorType.OT_INVALID_SESSION_ID) ? It(new Ke.ConnectToSessionSessionIdError()) : $e.errorHasName(vt, $e.OTErrorType.OT_CONNECT_FAILED) ? It(new Ke.ConnectToSessionNetworkError()) : It(new Ke.ConnectToSessionError())), ht(yt);
              });
            });
          })(pt, gt.token).then(ut(At, wt)).then(Bt).catch(Tt);
        });
      }
      function dt(At, pt, gt, wt, Bt, Tt) {
        let yt;
        return new Ge((Ct, ht) => {
          lt(At, pt, gt, wt).then(({ publisher: It, subscriber: vt }) => {
            if (vt) try {
              const Et = Object.assign({ state: new Ze.default(Tt) }, { subscriber: vt }, { credentials: gt }), bt = (kt, jt) => {
                var Pt;
                jt && Bt && Bt((Pt = jt, Object.assign({}, Pt, { phase: ot ? "audio-only" : "audio-video" })));
              }, Rt = () => {
                const kt = function(Pt) {
                  const Qt = ["bitrate", "packetLossRatio", "supported", "reason", "mos"];
                  return Pt.state.stats.audio.mos = Pt.state.audioQualityScore(), Pt.state.stats.video.mos = Pt.state.videoQualityScore(), Pt.state.stats.audio.mos >= nt.default.qualityThresholds.audio[0].minMos ? Pt.state.stats.audio.supported = !0 : (Pt.state.stats.audio.supported = !1, Pt.state.stats.audio.reason = nt.default.strings.bandwidthLow), { audio: Xe.pick(Qt, Pt.state.stats.audio), video: Xe.pick(Qt.concat(["frameRate", "recommendedResolution", "recommendedFrameRate"]), Pt.state.stats.video) };
                }(Et);
                if (ot || (jt = kt).audio.mos && jt.audio.mos >= nt.default.qualityThresholds.audio[0].minMos || st) pt.on("sessionDisconnected", () => {
                  Ct(kt), pt.off();
                }), function(Pt, Qt) {
                  return new Ge((qt, _t) => {
                    Qt.on("destroyed", () => {
                      qt();
                    }), Qt || qt(), Pt.unsubscribe(Qt);
                  });
                }(pt, vt).then(() => function(Pt) {
                  return new Ge((Qt, qt) => {
                    Pt.on("destroyed", () => {
                      Qt();
                    }), Pt || Qt(), Pt.destroy();
                  });
                }(It)).then(() => pt.disconnect());
                else {
                  ot = !0;
                  const Pt = kt.video;
                  dt(At, pt, gt, wt, Bt, !0).then((Qt) => {
                    Qt.video = Pt, Ct(Qt);
                  });
                }
                var jt;
              };
              rt = () => {
                Rt();
              };
              const St = (kt) => {
                clearTimeout(yt), Rt();
              };
              Je.default(Et.state, vt, It, bt, St), yt = window.setTimeout(Rt, et + 1), window.clearTimeout(it), it = window.setTimeout(() => {
                at = !0, st && rt && rt();
              }, 5e3);
            } catch {
              ht(new Ke.SubscriberGetStatsError());
            }
            else ht(new Ke.MissingSubscriberError());
          }).catch(ht);
        });
      }
      Ue.testQuality = function(At, pt, gt, wt, Bt) {
        return at = !1, st = !1, new Ge((Tt, yt) => {
          ot = !(!wt || !wt.audioOnly), et = ot ? nt.default.getStatsAudioOnlyDuration : nt.default.getStatsVideoAndAudioTestDuration, wt && wt.timeout && (et = Math.min(et, wt.timeout, 3e4));
          const Ct = (It) => {
            rt = void 0, gt.logEvent({ action: "testQuality", variation: "Success" }), Tt(It);
          }, ht = (It) => {
            rt = void 0, gt.logEvent({ action: "testQuality", variation: "Failure" }), yt(It);
          };
          new Ge((It, vt) => {
            const { supported: Et, browser: bt } = tt.default();
            return Et ? It() : vt(new Ke.UnsupportedBrowserError(bt));
          }).then(() => {
            let It = {};
            wt && wt.initSessionOptions && (It = wt.initSessionOptions), wt && wt.proxyServerUrl && (At.hasOwnProperty("setProxyUrl") || (It.proxyUrl = wt.proxyServerUrl));
            const vt = At.initSession(pt.apiKey, pt.sessionId, It);
            dt(At, vt, pt, wt, Bt).then(Ct).catch(ht);
          }).catch(ht);
        });
      }, Ue.stopQualityTest = function() {
        st = !0, at && rt && rt();
      };
    }, function(Qe, Ue, He) {
      Object.defineProperty(Ue, "__esModule", { value: !0 });
      const Ge = He(6), Xe = He(2);
      class Ke extends Ge.NetworkTestError {
        constructor(tt, et) {
          super(tt, et || Xe.ErrorNames.QUALITY_TEST_ERROR);
        }
      }
      Ue.QualityTestError = Ke, Ue.UnsupportedBrowserError = class extends Ke {
        constructor(nt) {
          super(`Your current browser (${nt}) does not support the audio-video quality test. Please run the test in a supported browser.`, Xe.ErrorNames.UNSUPPORTED_BROWSER);
        }
      };
      class $e extends Ke {
        constructor(tt, et) {
          super(tt || "Failed to connect to the session due to a network error.", et || Xe.ErrorNames.CONNECT_TO_SESSION_ERROR);
        }
      }
      Ue.ConnectToSessionError = $e, Ue.ConnectToSessionTokenError = class extends $e {
        constructor() {
          super("Failed to connect to the session due to an invalid token.", Xe.ErrorNames.CONNECT_TO_SESSION_TOKEN_ERROR);
        }
      }, Ue.ConnectToSessionSessionIdError = class extends $e {
        constructor() {
          super("Failed to connect to the session due to an invalid session ID.", Xe.ErrorNames.CONNECT_TO_SESSION_ID_ERROR);
        }
      }, Ue.ConnectToSessionNetworkError = class extends $e {
        constructor() {
          super("Failed to connect to the session due to a network error.", Xe.ErrorNames.CONNECT_TO_SESSION_NETWORK_ERROR);
        }
      }, Ue.MediaDeviceError = class extends Ke {
        constructor(nt, tt) {
          super(nt || "OpenTok failed to find media devices for this browser.", tt || Xe.ErrorNames.MEDIA_DEVICE_ERROR);
        }
      }, Ue.FailedToObtainMediaDevices = class extends Ke {
        constructor() {
          super("Failed to obtain media devices.", Xe.ErrorNames.FAILED_TO_OBTAIN_MEDIA_DEVICES);
        }
      }, Ue.NoVideoCaptureDevicesError = class extends Ke {
        constructor() {
          super("This browser has no video capture devices", Xe.ErrorNames.NO_VIDEO_CAPTURE_DEVICES);
        }
      }, Ue.NoAudioCaptureDevicesError = class extends Ke {
        constructor() {
          super("This browser has no audio capture devices.", Xe.ErrorNames.NO_AUDIO_CAPTURE_DEVICES);
        }
      };
      class Je extends Ke {
        constructor(tt, et) {
          super(tt || "Encountered an unknown error while attempting to publish to a session.", et || Xe.ErrorNames.PUBLISH_TO_SESSION_ERROR);
        }
      }
      Ue.PublishToSessionError = Je, Ue.InitPublisherError = class extends Je {
        constructor(nt) {
          super(nt || "Failed to initialize publisher.", Xe.ErrorNames.INIT_PUBLISHER_ERROR);
        }
      }, Ue.PublishToSessionNotConnectedError = class extends Je {
        constructor() {
          super("Precall failed to publish to the session because it was not connected.", Xe.ErrorNames.PUBLISH_TO_SESSION_NOT_CONNECTED);
        }
      }, Ue.PublishToSessionPermissionOrTimeoutError = class extends Je {
        constructor() {
          super("Precall failed to publish to the session due a permissions error or timeout.", Xe.ErrorNames.PUBLISH_TO_SESSION_PERMISSION_OR_TIMEOUT_ERROR);
        }
      };
      class Ze extends Ke {
        constructor(tt, et) {
          super(tt || "Encountered an unknown error while attempting to publish to a session.", et || Xe.ErrorNames.SUBSCRIBE_TO_SESSION_ERROR);
        }
      }
      Ue.SubscribeToSessionError = Ze, Ue.SubscriberGetStatsError = class extends Ze {
        constructor() {
          super("Failed to get network stats for a subscriber.", Xe.ErrorNames.SUBSCRIBER_GET_STATS_ERROR);
        }
      }, Ue.MissingSubscriberError = class extends Ze {
        constructor() {
          super("Call checkSubscribeToSession before calling checkSubscriberQuality.", Xe.ErrorNames.MISSING_SUBSCRIBER_ERROR);
        }
      };
    }, function(Qe, Ue, He) {
      var Ge = this && this.__awaiter || function(rt, it, ot, at) {
        return new (ot || (ot = Promise))(function(st, ut) {
          function lt(pt) {
            try {
              At(at.next(pt));
            } catch (gt) {
              ut(gt);
            }
          }
          function dt(pt) {
            try {
              At(at.throw(pt));
            } catch (gt) {
              ut(gt);
            }
          }
          function At(pt) {
            pt.done ? st(pt.value) : new ot(function(gt) {
              gt(pt.value);
            }).then(lt, dt);
          }
          At((at = at.apply(rt, it || [])).next());
        });
      };
      Object.defineProperty(Ue, "__esModule", { value: !0 });
      const Xe = He(56), Ke = He(57), $e = He(20), Je = He(1), Ze = He(59), nt = (rt) => Je.getOr(0, "packetsLost", rt), tt = (rt) => nt(rt) + ((it) => Je.getOr(0, "packetsReceived", it))(rt);
      function et(rt, it, ot) {
        const at = () => 1e3 * (() => {
          if (it) {
            const { rtcStatsReport: gt } = it[0];
            gt.forEach((wt) => {
              wt.type === "remote-inbound-rtp" && wt.kind === "audio" && (isNaN(wt.roundTripTime) || wt.roundTripTime);
            });
          }
          return 0;
        })() / 2 || 150, st = Je.last(ot), ut = Je.nth(-2, ot);
        if (!st || !ut || !rt.stream) return 1;
        const lt = (At = ut, tt(st[dt = "audio"]) - tt(At[dt]));
        var dt, At;
        if (lt === 0) return 1;
        let pt = (nt(st.audio) - nt(ut.audio)) / lt;
        return pt < 0 && (pt = 0), ((gt) => {
          const wt = at();
          return (Bt = (() => {
            const Tt = wt + 30;
            return 93.2 - (0.024 * Tt + 0.11 * (Tt - 177.3) * 1) - (0 + 19.8 * Math.log(1 + 29.7 * gt));
          })()) < 0 ? 1 : Bt > 100 ? 4.5 : 1 + 0.035 * Bt + Bt * (Bt - 60) * (100 - Bt) * 7e-6;
          var Bt;
        })(pt);
      }
      Ue.default = function(rt, it, ot, at, st) {
        return rt.intervalId = window.setInterval(() => {
          it.getStats((ut, lt) => Ge(this, void 0, void 0, function* () {
            if (!lt) return null;
            let dt = null;
            try {
              dt = yield Ze.default(ot);
            } catch {
            }
            if (lt.audio.bytesReceived < 0 || Je.getOr(1, "video.bytesReceived", lt) < 0) return rt.clearInterval(), st(rt);
            if (lt && rt.statsLog.push(lt), at && typeof at == "function" && at(ut, lt), rt.statsLog.length < 2) return null;
            rt.stats = Ke.default(rt);
            const At = function(gt, wt) {
              const Bt = Je.last(wt), Tt = Je.nth(-2, wt);
              if (!Bt || !Tt || !gt.stream) return 1;
              const yt = ((vt, Et, bt) => {
                const Rt = Et.timestamp - bt.timestamp;
                return Et[vt] && Et[vt].bytesReceived ? 8 * (Et[vt].bytesReceived - bt[vt].bytesReceived) / (Rt / 1e3) : 0;
              })("video", Bt, Tt), Ct = ((vt) => {
                const Et = 2.069924867 * Math.pow(Math.log10(vt), 0.6250223771);
                return Math.pow(10, Et);
              })(gt.stream.videoDimensions.width * gt.stream.videoDimensions.height);
              if (yt < 3e4) return 1;
              const ht = Math.min(yt, Ct);
              let It = Math.log(ht / 3e4) / Math.log(Ct / 3e4) * 4 + 1;
              return It = Math.min(It, 4.5), It;
            }(it, rt.statsLog);
            rt.videoScoresLog.push(At);
            const pt = et(it, dt, rt.statsLog);
            return rt.audioScoresLog.push(pt), rt.pruneScores(), Xe.default(rt.statsLog) ? (rt.clearInterval(), st(rt)) : null;
          }));
        }, $e.default.scoreInterval), it.on("destroyed", rt.clearInterval.bind(rt)), rt;
      };
    }, function(Qe, Ue, He) {
      Object.defineProperty(Ue, "__esModule", { value: !0 });
      const Ge = He(18), Xe = He(19), Ke = He(4);
      Ue.default = function($e) {
        const Je = Ge.default($e), Ze = Ke.default.steadyStateAllowedDelta;
        let nt = !0;
        if (Je.length < Ke.default.minimumVideoAndAudioTestSampleSize) return !1;
        const tt = Xe.default(Je);
        return ["video", "audio"].forEach((et) => {
          for (let rt = 1; rt < tt[et].length; rt += 1) {
            const it = tt[et][rt].averageBitrate, ot = tt[et][rt - 1].averageBitrate;
            it - ot > ot * Ze && (nt = !1);
          }
        }), nt;
      };
    }, function(Qe, Ue, He) {
      Object.defineProperty(Ue, "__esModule", { value: !0 });
      const Ge = He(18), Xe = He(19), Ke = He(58), $e = He(4), Je = He(1);
      function Ze(nt, tt) {
        let et = 0, rt = 0, it = 0;
        tt.forEach((at) => {
          et += at.averageBitrate, rt += at.packetLossRatio, nt === "video" && (it += Number(Je.getOr(0, "frameRate", at)));
        });
        const ot = { bitrate: et / tt.length, packetLossRatio: rt / tt.length };
        if (nt === "video") {
          const { supported: at, reason: st, recommendedResolution: ut, recommendedFrameRate: lt } = Ke.default(ot), dt = nt === "video" ? { recommendedResolution: ut, recommendedFrameRate: lt, frameRate: it / tt.length } : {};
          return Object.assign({}, ot, { supported: at, reason: st }, dt);
        }
        return Object.assign({}, ot);
      }
      Ue.default = function(nt) {
        const tt = Ge.default(nt.statsLog), et = Xe.default(tt);
        return { audio: nt.hasAudioTrack() ? Ze("audio", et.audio) : { supported: !1, reason: $e.default.strings.noMic }, video: nt.audioOnlyFallback ? { supported: !1, reason: $e.default.strings.bandwidthLow } : nt.hasVideoTrack() ? Ze("video", et.video) : { supported: !1, reason: $e.default.strings.noCam } };
      };
    }, function(Qe, Ue, He) {
      Object.defineProperty(Ue, "__esModule", { value: !0 });
      const Ge = He(4), Xe = He(1);
      Ue.default = function(Ke) {
        const $e = Ge.default.qualityThresholds.video, Je = Ke.bitrate, Ze = Ke.packetLossRatio;
        let nt, tt = !1, et = 30, rt = "";
        for (let ot = 0; ot < $e.length; ot += 1) {
          const at = $e[ot];
          if (Je >= at.bps && Ze <= at.plr) {
            tt = !0, nt = Xe.get("recommendedSetting", at), et = Number(nt.substring(nt.indexOf("@") + 1).replace("FPS", "")), rt = nt.substring(0, nt.indexOf("@") - 1);
            break;
          }
        }
        const it = { supported: tt, recommendedFrameRate: et, recommendedResolution: rt };
        return tt ? (it.recommendedFrameRate = et, it.recommendedResolution = rt) : it.reason = Ge.default.strings.bandwidthLow, it;
      };
    }, function(Qe, Ue, He) {
      Object.defineProperty(Ue, "__esModule", { value: !0 }), Ue.default = (Ge) => new Promise((Xe) => {
        if (typeof Ge.getRtcStatsReport != "function") return Xe(null);
        const Ke = Ge.getRtcStatsReport();
        Ke ? Ke.then(Xe).catch(() => Xe(null)) : Ge.getRtcStatsReport(($e, Je) => {
          Xe(Je);
        });
      });
    }, function(Qe, Ue, He) {
      Object.defineProperty(Ue, "__esModule", { value: !0 });
      const Ge = He(1);
      Ue.default = function() {
        const Xe = function() {
          const Ke = window && window.navigator;
          return typeof window < "u" && window.navigator ? Ge.get("mozGetUserMedia", Ke) ? "Firefox" : Ge.get("webkitGetUserMedia", Ke) ? window.hasOwnProperty("webkitRTCPeerConnection") ? Ke.userAgent.match(/Edg/) ? "Edge" : Ke.userAgent.match(/Opera|OPR\//) ? "Opera" : "Chrome" : Ke.userAgent.match(/Version\/(\d+).(\d+)/) ? "Safari" : "WebKit browser without WebRTC support" : Ke.mediaDevices && Ke.userAgent.match(/Edge\/(\d+).(\d+)$/) ? "non-Chromium Edge" : Ke.userAgent.indexOf("MSIE ") > 0 || Ke.userAgent.match(/Trident.*rv\:11\./) ? "Internet Explorer" : Ke.mediaDevices && Ke.userAgent.match(/AppleWebKit\/(\d+)\./) ? "Safari" : "unsupported browser" : "not a browser";
        }();
        return { browser: Xe, supported: ["Chrome", "Firefox", "Safari", "Edge", "Opera"].indexOf(Xe) > -1 };
      };
    }, function(Qe, Ue, He) {
      var Ge, Xe, Ke, $e = /* @__PURE__ */ function() {
        function Ze(nt, tt) {
          for (var et = 0; et < tt.length; et++) {
            var rt = tt[et];
            rt.enumerable = rt.enumerable || !1, rt.configurable = !0, "value" in rt && (rt.writable = !0), Object.defineProperty(nt, rt.key, rt);
          }
        }
        return function(nt, tt, et) {
          return tt && Ze(nt.prototype, tt), et && Ze(nt, et), nt;
        };
      }(), Je = Object.assign || function(Ze) {
        for (var nt = 1; nt < arguments.length; nt++) {
          var tt = arguments[nt];
          for (var et in tt) Object.prototype.hasOwnProperty.call(tt, et) && (Ze[et] = tt[et]);
        }
        return Ze;
      };
      Xe = [He(7)], (Ke = typeof (Ge = function(Ze) {
        var nt = !1, tt = void 0, et = function(it) {
          return function(ot) {
            if (nt) return null;
            for (var at = ot + "=", st = document.cookie.split(";"), ut = void 0, lt = 0; lt < st.length; lt++) {
              for (ut = st[lt]; ut.charAt(0) === " "; ) ut = ut.substring(1, ut.length);
              if (ut.indexOf(at) === 0) return ut.substring(at.length, ut.length);
            }
            return null;
          }(it) || function(ot, at, st) {
            if (nt) return at;
            var ut = "", lt = void 0;
            (lt = /* @__PURE__ */ new Date()).setTime(lt.getTime() + 24 * st * 60 * 60 * 1e3), ut = ["; expires=", lt.toGMTString()].join("");
            var dt = [ot, "=", at, ut, "; path=/"].join("");
            return document.cookie = dt, at;
          }(it, function() {
            for (var ot = [], at = "0123456789abcdef", st = 0; st < 36; st++) ot.push(at.substr(Math.floor(16 * Math.random()), 1));
            return ot[14] = "4", ot[19] = at.substr(3 & ot[19] | 8, 1), ot[8] = ot[13] = ot[18] = ot[23] = "-", ot.join("");
          }(), 7);
        }, rt = function(it) {
          var ot = function(st) {
            if (!st.clientVersion) throw console.log("Error. The clientVersion field cannot be null in the log entry"), new Error("The clientVersion field cannot be null in the log entry");
            if (!st.source) throw console.log("Error. The source field cannot be null in the log entry"), new Error("The source field cannot be null in the log entry");
            if (!st.componentId) throw console.log("Error. The componentId field cannot be null in the log entry"), new Error("The componentId field cannot be null in the log entry");
            if (!st.name) throw console.log("Error. The name field cannot be null in the log entry"), new Error("The guid field cannot be null in the log entry");
            var ut = st.logVersion || "2", lt = st.clientSystemTime || (/* @__PURE__ */ new Date()).getTime();
            return Je({}, st, { logVersion: ut, clientSystemTime: lt });
          }(it);
          if (nt) Ze.post(tt, ot);
          else {
            var at = new XMLHttpRequest();
            at.open("POST", tt, !0), at.setRequestHeader("Content-type", "application/json"), at.send(JSON.stringify(ot));
          }
        };
        return function() {
          function it(ot, at) {
            (function(ut, lt) {
              if (!(ut instanceof lt)) throw new TypeError("Cannot call a class as a function");
            })(this, it), this.analyticsData = ot, nt = at && at.server;
            var st = "hlg.tokbox.com/prod/logging/ClientEvent";
            tt = at && at.proxyUrl && at.proxyUrl + "/" + st || "https://" + st, this.analyticsData.guid = et(ot.name);
          }
          return $e(it, [{ key: "addSessionInfo", value: function(ot) {
            if (!ot.sessionId) throw console.log("Error. The sessionId field cannot be null in the log entry"), new Error("The sessionId field cannot be null in the log entry");
            if (this.analyticsData.sessionId = ot.sessionId, !ot.connectionId) throw console.log("Error. The connectionId field cannot be null in the log entry"), new Error("The connectionId field cannot be null in the log entry");
            if (this.analyticsData.connectionId = ot.connectionId, ot.partnerId === 0) throw console.log("Error. The partnerId field cannot be null in the log entry"), new Error("The partnerId field cannot be null in the log entry");
            this.analyticsData.partnerId = ot.partnerId;
          } }, { key: "logEvent", value: function(ot) {
            this.analyticsData = Je({}, this.analyticsData, ot, { clientSystemTime: (/* @__PURE__ */ new Date()).getTime() }), rt(this.analyticsData);
          } }]), it;
        }();
      }) == "function" ? Ge.apply(Ue, Xe) : Ge) === void 0 || (Qe.exports = Ke);
    }]);
  });
})(NetworkTest$1);
var NetworkTestExports = NetworkTest$1.exports;
const NetworkTest = /* @__PURE__ */ getDefaultExportFromCjs(NetworkTestExports);
if (typeof window < "u") {
  var passiveTestOptions = {
    get passive() {
    }
  };
  window.addEventListener("testPassive", null, passiveTestOptions), window.removeEventListener("testPassive", null, passiveTestOptions);
}
var isIosDevice = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1), locks = [], clearAllBodyScrollLocks = function() {
  isIosDevice && locks.forEach(function(ue) {
    ue.targetElement.ontouchstart = null, ue.targetElement.ontouchmove = null;
  }), locks = [];
}, enableBodyScroll = function(ue) {
  if (!ue) {
    console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
    return;
  }
  locks = locks.filter(function(Qe) {
    return Qe.targetElement !== ue;
  }), isIosDevice && (ue.ontouchstart = null, ue.ontouchmove = null);
}, localizedFormat$1 = { exports: {} };
(function(me, ue) {
  (function(Qe, Ue) {
    me.exports = Ue();
  })(commonjsGlobal, function() {
    var Qe = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
    return function(Ue, He, Ge) {
      var Xe = He.prototype, Ke = Xe.format;
      Ge.en.formats = Qe, Xe.format = function($e) {
        $e === void 0 && ($e = "YYYY-MM-DDTHH:mm:ssZ");
        var Je = this.$locale().formats, Ze = function(nt, tt) {
          return nt.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(et, rt, it) {
            var ot = it && it.toUpperCase();
            return rt || tt[it] || Qe[it] || tt[ot].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(at, st, ut) {
              return st || ut.slice(1);
            });
          });
        }($e, Je === void 0 ? {} : Je);
        return Ke.call(this, Ze);
      };
    };
  });
})(localizedFormat$1);
var localizedFormatExports = localizedFormat$1.exports;
const localizedFormat = /* @__PURE__ */ getDefaultExportFromCjs(localizedFormatExports), deleteIcon = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='14'%20height='14'%20viewBox='0%200%2014%2014'%3e%3cpath%20fill='%233F3E40'%20fill-rule='nonzero'%20d='M13.5%202.752L9.268%206.987l4.234%204.234a1.613%201.613%200%200%201-2.28%202.28L6.987%209.267%202.752%2013.5a1.607%201.607%200%200%201-1.14.472%201.613%201.613%200%200%201-1.14-2.753l4.234-4.233L.472%202.752a1.612%201.612%200%200%201%202.28-2.28l4.235%204.234L11.22.472a1.613%201.613%200%200%201%202.28%202.28z'/%3e%3c/svg%3e", readMessage = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%3e%3cg%20fill='none'%20fill-rule='evenodd'%3e%3cg%20fill-rule='nonzero'%3e%3cg%3e%3cg%20fill='%230CD5A2'%3e%3cpath%20d='M12%2024C5.384%2024%200%2018.617%200%2012%200%205.384%205.384%200%2012%200c6.617%200%2012%205.384%2012%2012%200%206.617-5.383%2012-12%2012z'%20transform='translate(-113%20-618)%20translate(113%20618)'/%3e%3c/g%3e%3cpath%20fill='%23FFF'%20d='M16.752%2015.75c-.327.333-.854.333-1.181%200l-3.594-3.681-3.594%203.681c-.351.308-.88.266-1.181-.093-.27-.321-.27-.796%200-1.117l4.188-4.29c.327-.333.855-.333%201.182%200l4.188%204.29c.323.338.32.878-.008%201.21z'%20transform='translate(-113%20-618)%20translate(113%20618)%20rotate(-180%2012%2013)'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e", interviewerIcon = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='43'%20height='43'%20viewBox='0%200%2043%2043'%3e%3cg%20fill='none'%20fill-rule='evenodd'%3e%3ccircle%20cx='21.5'%20cy='21.5'%20r='21.5'%20fill='%23595959'/%3e%3cg%20fill='%23FFF'%20fill-rule='nonzero'%3e%3cpath%20d='M22%208c-5.481%200-9.941%204.46-9.941%209.941v9.177a2.297%202.297%200%200%200%202.294%202.294%202.297%202.297%200%200%200%202.294-2.294V19.47a2.297%202.297%200%200%200-2.294-2.294c-.258%200-.501.052-.733.13.327-4.342%203.956-7.778%208.38-7.778%204.421%200%208.05%203.433%208.38%207.772a2.253%202.253%200%200%200-.733-.124%202.297%202.297%200%200%200-2.294%202.294v7.647a2.297%202.297%200%200%200%202.294%202.294c.27%200%20.524-.055.765-.141v.906a.766.766%200%200%201-.765.764h-5.494A2.29%202.29%200%200%200%2022%2029.411a2.297%202.297%200%200%200-2.294%202.295A2.297%202.297%200%200%200%2022%2034a2.29%202.29%200%200%200%202.153-1.53h5.494a2.297%202.297%200%200%200%202.294-2.293V17.94C31.941%2012.46%2027.481%208%2022%208zM33.47%2018.847v8.894A2.29%202.29%200%200%200%2035%2025.588V21a2.29%202.29%200%200%200-1.53-2.153zM9%2021v4.588a2.29%202.29%200%200%200%201.53%202.153v-8.894A2.29%202.29%200%200%200%209%2021z'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e", userIcon = "data:image/png;base64,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";
dayjs.extend(localizedFormat);
const NewMessage = qe.button`
  display: block;
  cursor: pointer;
  position: absolute;
  transform: translateX(-50%);
  left: 50%;
  bottom: 66px;
  min-width: 200px;
  white-space: nowrap;
  height: 60px;
  padding: 17px 19px 15px;
  border-radius: 10px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.25);
  border: solid 1px #cccccc;
  background-color: #ffffff;

  & img {
    margin-right: 5px;
    width: 20px;
    height: 20px;
  }
`, SENDER = "interviewer";
function ChatView({
  messages: me = [],
  onClose: ue = emptyFunc,
  onSendMessage: Qe = emptyFunc,
  setUnreadMessages: Ue
}) {
  const { t: He } = useTranslation(), [Ge, Xe] = useState(""), Ke = useRef(null), $e = useRef([]), [Je, Ze] = useState(0), [nt, tt] = useState(!1);
  useEventListener("scroll", it, Ke.current);
  const et = useCallback(() => {
    $e.current.forEach((st, ut) => {
      $e.current[ut].read = !0;
    }), Ze(0), rt();
  }, []);
  useEffect(() => (enableBodyScroll(document.getElementsByTagName("html")[0]), clearAllBodyScrollLocks()), []), useLayoutEffect(() => {
    function st() {
      if ($e.current.length === 0) {
        const lt = me.filter(
          (dt) => dt.author === SENDER && !$e.current.some(
            (At) => At.date === dt.date
          )
        );
        lt.length > 0 && ($e.current = [
          ...$e.current,
          ...lt
        ]);
      } else
        $e.current = me.filter(
          (lt) => lt.author === SENDER
        );
      const ut = $e.current.reduce(
        (lt, dt) => {
          let At = lt;
          return dt.read || (At += 1), At;
        },
        0
      );
      Ze(ut), (ut === 0 || nt || ut > 0 && ot(Ke.current.scrollTop)) && (et(), tt(!1));
    }
    st();
  }, [me, et, nt]), useEffect(() => (Ue(0), () => Ue(0)), [Ue]);
  const rt = () => {
    Ke.current.scrollTop = Ke.current.scrollHeight;
  };
  function it(st) {
    const {
      target: { scrollTop: ut }
    } = st;
    ot(ut) && et();
  }
  function ot(st) {
    return Ke.current.scrollHeight - Ke.current.clientHeight === st;
  }
  const at = (st) => {
    st.preventDefault(), Qe(Ge), Xe(""), tt(!0);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "chatScreenBack", onClick: ue, onKeyDown: ue }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "chatScreen", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "chat-header", children: /* @__PURE__ */ jsxRuntimeExports.jsx("button", { onClick: ue, className: "no-style", type: "button", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: deleteIcon, alt: "delete icon" }) }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "messages", ref: Ke, children: me.map((st) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "div",
        {
          className: classNames("message-container", {
            mine: st.author === "user",
            "from-other": st.author === "interviewer"
          }),
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "avatar", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              "img",
              {
                src: st.author === "interviewer" ? interviewerIcon : userIcon,
                alt: "avatar"
              }
            ) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "div",
              {
                className: classNames("message", {
                  mine: st.author === "user",
                  "from-other": st.author === "interviewer"
                }),
                style: {
                  color: st.author === "user" ? "white" : "black"
                },
                children: st.body
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "date", children: dayjs(st.date).format("MMM D LT") })
          ]
        },
        st.date + st.body
      )) }),
      Je > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(NewMessage, { onClick: et, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: readMessage, alt: "new message" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: `${Je} new message(s)` })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("form", { className: "message-form", onSubmit: at, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "input",
          {
            type: "text",
            className: "send-message-input",
            value: Ge,
            onChange: (st) => Xe(st.target.value),
            placeholder: He("support.writeMessage")
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("button", { disabled: !Ge, className: "no-style", type: "submit", children: He("common.send") })
      ] })
    ] })
  ] });
}
const chatIcon = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='64'%20height='64'%20viewBox='0%200%2064%2064'%3e%3cg%20fill='none'%20fill-rule='nonzero'%3e%3ccircle%20cx='32'%20cy='32'%20r='32'%20fill='%23FFF'/%3e%3cg%20fill='%2321273B'%3e%3cpath%20stroke='%2321273B'%20stroke-width='.2'%20d='M23.024%2048.86c-2.175%201.553-4.463%202.2-6.691%202.2-.554%200-1.06-.043-1.518-.114a1.881%201.881%200%200%201-1.57-1.577%201.868%201.868%200%200%201%201.027-1.97c1.23-.604%202.214-1.768%202.97-3.27-6.228-7.55-5.703-18.684%201.245-25.632A18.962%2018.962%200%200%201%2031.99%2012.9c5.103%200%209.893%201.986%2013.504%205.597%203.614%203.614%205.604%208.405%205.604%2013.503%200%205.102-1.985%209.892-5.596%2013.503a19.096%2019.096%200%200%201-13.52%205.597c-3.113%200-6.186-.76-8.958-2.24zm-6.396-.174c1.788-.06%203.624-.661%205.362-2.007a.263.263%200%200%201%20.088-.064%201.18%201.18%200%200%201%201.44-.184c6.564%203.857%2014.91%202.787%2020.3-2.604%206.526-6.525%206.523-17.131-.008-23.654-6.517-6.525-17.13-6.525-23.655%200-6.243%206.243-6.55%2016.305-.702%2022.913.162.187.262.421.286.651.063.25.043.513-.061.764-.742%201.69-1.744%203.152-3.05%204.185z'/%3e%3cpath%20d='M24%2031h3v3h-3zM30%2031h3v3h-3zM36%2031h3v3h-3z'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e";
function Chat({
  session: me,
  playAlert: ue,
  unreadMessages: Qe,
  setUnreadMessages: Ue,
  isChatViewOpen: He,
  setChatViewOpen: Ge,
  token: Xe
}) {
  const [Ke, $e] = useState([]);
  return useEffect(() => {
    me.on("signal:msg", (Je) => {
      const Ze = typeof Je.data == "string" ? JSON.parse(Je.data) : Je.data, nt = {
        date: Date.now(),
        body: Ze.message,
        author: Ze.author
      };
      $e((tt) => [...tt, nt]), Ze.author === "interviewer" && Ue((tt) => tt + 1);
    }), me.on("signal:wake-up", () => {
      ue();
    });
  }, [me]), /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "button",
      {
        className: "float-button no-style",
        type: "button",
        onClick: () => {
          Ge(!0), addScreenEvent({
            module: eventModuleNames.conference,
            screen: eventScreenNames.conferenceVideoChat,
            token: Xe,
            shouldOpen: !1
          }), addScreenEvent({
            module: eventModuleNames.conference,
            screen: eventScreenNames.conferenceMessageChat,
            token: Xe,
            shouldOpen: !0
          });
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "button-inside", children: [
          Qe > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "indicator", children: Qe }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: chatIcon, alt: "chat icon" })
        ] })
      }
    ),
    He && /* @__PURE__ */ jsxRuntimeExports.jsx(
      ChatView,
      {
        onClose: () => {
          Ge(!1), addScreenEvent({
            module: eventModuleNames.conference,
            screen: eventScreenNames.conferenceMessageChat,
            token: Xe,
            shouldOpen: !1
          }), addScreenEvent({
            module: eventModuleNames.conference,
            screen: eventScreenNames.conferenceVideoChat,
            token: Xe,
            shouldOpen: !0
          });
        },
        messages: Ke,
        setUnreadMessages: Ue,
        onSendMessage: (Je) => {
          me.signal({
            type: "msg",
            data: JSON.stringify({ message: Je, author: "user" })
          });
        }
      }
    )
  ] });
}
const ModalSubtitle = qe.h2`
  display: none;
`, CloseButton = qe.button`
  position: absolute;
  background-color: transparent;
  top: 15px;
  right: 25px;
`, AreYouSureModalContainer = qe(Modal)`
  position: absolute;
  top: 40px;
  left: 40px;
  right: 40px;
  bottom: 40px;
  border: 1px solid #ccc;
  background: #fff;
  overflow: auto;
  border-radius: 4px;
  -webkit-overflow-scrolling: touch;
  outline: none;
  padding: 20px;
`, getTitle = (me, ue) => {
  switch (me) {
    case "waiting-room":
      return {
        title: ue("support.aysConnectingModalTitle"),
        subtitle: ue("support.aysConnectingModalSubtitle")
      };
    case "user-turn":
      return {
        title: ue("support.aysExecutiveReadyModalTitle"),
        subtitle: ue("support.aysExecutiveModalSubtitle")
      };
    case "support":
      return {
        title: ue("support.aysSupportModalTitle"),
        subtitle: ue("support.aysSupportModalSubtitle")
      };
    default:
      return {
        title: ue("conference.areYouSure"),
        subtitle: ue("conference.areYouSureSubtitle")
      };
  }
}, customStyles$1 = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "95vw",
    padding: "50px 30px",
    borderRadius: 25,
    textAlign: "center"
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.67)",
    zIndex: 9999
  }
};
function AreYouSureModal({
  onDisconnect: me,
  closeModal: ue,
  isOpen: Qe,
  theme: Ue,
  origin: He
}) {
  const { t: Ge } = useTranslation(), { title: Xe, subtitle: Ke } = getTitle(He, Ge);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    AreYouSureModalContainer,
    {
      isOpen: Qe,
      style: {
        ...customStyles$1,
        content: {
          ...customStyles$1.content,
          ...Ue.modal
        },
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.67)",
          zIndex: 9999
        }
      },
      onRequestClose: ue,
      contentLabel: "Are You Sure Modal",
      shouldCloseOnOverlayClick: !1,
      className: "IncodeAreYouSureModal",
      overlayClassName: "IncodeAreYouSureModalOverlay",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          CloseButton,
          {
            className: "IncodeAreYouSureModalCloseIconButton",
            onClick: ue,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "IncodeAreYouSureModalCloseIconSpan" })
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ModalTitle, { className: "IncodeAreYouSureModalTitle", children: Xe }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ModalSubtitle, { className: "IncodeAreYouSureModalSubtitle", children: Ke }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "IncodeAreYouSureModalButtonsContainer", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            ModalButton,
            {
              onClick: ue,
              className: "IncodeAreYouSureModalContinueProcessButton",
              children: Ge("conference.continueProcess")
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            DisconnectButton,
            {
              className: "IncodeAreYouSureModalDisconnectButton",
              onClick: me,
              children: Ge("conference.disconnect")
            }
          )
        ] })
      ]
    }
  );
}
const smsIcon = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='45'%20height='54'%20viewBox='0%200%2045%2054'%3e%3cg%20fill='none'%20fill-rule='evenodd'%3e%3cpath%20fill='%2320263D'%20d='M27.718%200c3.369%200%206.11%202.731%206.11%206.088v7.966h3.567c3.995%200%207.245%203.239%207.245%207.219v5.901c0%203.98-3.25%207.22-7.245%207.22h-3.568v13.518c0%203.357-2.74%206.088-6.11%206.088H6.11C2.74%2054%200%2051.269%200%2047.912V6.088C0%202.73%202.741%200%206.11%200zM8.69%202.88H5.8c-1.61%200-2.92%201.307-2.92%202.913v41.694c0%201.606%201.31%202.913%202.92%202.913h21.52c1.61%200%202.92-1.307%202.92-2.913V34.01h-7.256l-5.088%202.562c-.301.176-.64.266-.979.266-.305%200-.612-.072-.895-.219-.644-.334-1.044-.99-1.044-1.715V20.931c0-3.968%203.237-7.196%207.215-7.196h8.047V5.793c0-1.606-1.31-2.913-2.92-2.913h-2.89v1.689c0%201.669-1.361%203.027-3.034%203.027h-9.671c-1.674%200-3.035-1.358-3.035-3.027V2.88zm11.33%2041.76c.873%200%201.58.645%201.58%201.44%200%20.795-.707%201.44-1.58%201.44h-6.2c-.873%200-1.58-.645-1.58-1.44%200-.795.707-1.44%201.58-1.44zM21.6%202.88h-9.36v1.44h9.36V2.88z'/%3e%3cpath%20fill='%233CB0F7'%20fill-rule='nonzero'%20d='M37.678%2017.28c2.25%200%204.082%201.792%204.082%203.995v5.815c0%202.203-1.831%203.994-4.082%203.994h-14.38c-.351%200-.69.09-.989.263L18.72%2033.12V21.275c0-2.203%201.831-3.995%204.082-3.995h14.876zm-.379%207.92h-6.918c-.873%200-1.581.645-1.581%201.44%200%20.795.708%201.44%201.581%201.44h6.918c.873%200%201.581-.645%201.581-1.44%200-.795-.708-1.44-1.581-1.44zm-.026-5.76H23.207c-.887%200-1.607.645-1.607%201.44%200%20.795.72%201.44%201.607%201.44h14.066c.887%200%201.607-.645%201.607-1.44%200-.795-.72-1.44-1.607-1.44z'/%3e%3c/g%3e%3c/svg%3e", SmsContainer = qe.div`
  display: flex;
  padding: 0px 15px;
`, SmsIconImg = qe.img`
  width: 45px;
`, SmsText = qe.p`
  font-size: 18px;
  font-weight: bold;
`, SMSMessageContainer = qe.div`
  padding: 0 20px;
`;
function SMSMesage({ onDisconnect: me }) {
  const { t: ue } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(SMSMessageContainer, { className: "IncodeSMSMessageContainer", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(SmsContainer, { className: "IncodeSMSContainer", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        SmsIconImg,
        {
          src: smsIcon,
          alt: "phone with sms",
          className: "IncodeSMSIconImg"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(SmsText, { className: "IncodeSmsText", children: ue("conference.smsMessage") })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      DisconnectButton,
      {
        className: "IncodeDisconnectButton IncodeDisconnectButtonQueue",
        onClick: me,
        children: ue("support.disconnectWaitingRoom")
      }
    )
  ] });
}
const spinnerAnimation = We`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`, SpinnerDiv = qe.div`
  position: absolute;
  animation: ${spinnerAnimation} 0.6s linear infinite;
`, StyledSpinnerImage = ({ className: me, color: ue = "#1C1F28" }) => /* @__PURE__ */ jsxRuntimeExports.jsx(SpinnerDiv, { className: me, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "286",
    height: "286",
    viewBox: "0 0 286 286",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Loading" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { id: "a", cx: "150", cy: "150", r: "131" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("mask", { id: "b", width: "286", height: "286", x: "-12", y: "-12", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fill: "#fff", d: "M7 7h286v286H7z" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("use", { xlinkHref: "#a" })
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "use",
        {
          fill: "none",
          "fill-rule": "evenodd",
          stroke: ue,
          "stroke-dasharray": "3,5",
          "stroke-width": "24",
          mask: "url(#b)",
          transform: "translate(-7 -7)",
          xlinkHref: "#a"
        }
      )
    ]
  }
) }), Footer = qe.div`
  text-align: center;
  width: 100%;
`, ConnectingParagraph = qe.p`
  padding: 10px;
`, BandwithContainer = qe.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
`, BandwithTitle = qe.h1`
  font-weight: normal;
`, BandwidthSubtitle = qe.h2`
  display: none;
`, BandwithParagraph = qe.p`
  opacity: 0.5;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #21273b;
`, ConnectingTitle = qe.h1`
  display: none;
`, ConnectingImage = qe.img`
  display: none;
`, BandwidthImage = qe.img`
  display: none;
`, LoadingCircle = qe.div`
  height: ${(me) => me.noPadding ? "calc(100% - 90px)" : "100%"};
  display: flex;
  padding-top: ${(me) => me.noPadding ? "0px" : "30px"};
  position: fixed;
  justify-content: space-evenly;
  flex-direction: column;
  top: ${(me) => me.noPadding ? "90px" : "0"};
  width: 100%;
`, SpinnerInner = qe.div`
  width: 250px;
  height: 250px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.1);
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
`;
function Connecting({
  index: me,
  bandwidth: ue,
  onDisconnect: Qe,
  onlyCircle: Ue = !1,
  incodeConnectingImageSrc: He,
  incodeBandwidthImageSrc: Ge
}) {
  const { t: Xe } = useTranslation(), Ke = new URLSearchParams(window.location.search), Je = Ke.get("darkMode") || Ke.get("darkTheme") ? "#FFF" : "#1C1F28";
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: ue ? /* @__PURE__ */ jsxRuntimeExports.jsxs(BandwithContainer, { className: "IncodeBandwithContainer", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(BandwithTitle, { className: "IncodeBandwithTitle", children: Xe("conference.networkTest") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      BandwidthImage,
      {
        alt: "checking bandwidth",
        className: "IncodeBandwidthImage",
        src: Ge
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(BandwidthSubtitle, { className: "IncodeBandwidthSubtitle", children: Xe("conference.networkTestSubtitle") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$5, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(BandwithParagraph, { className: "IncodeBandwithText", children: ue })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(
    LoadingCircle,
    {
      noPadding: Ue,
      className: "IncodeLoadingCircleContainer",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(ConnectingTitle, { className: "IncodeConnectingTitle", children: Xe("support.connectingTitle") }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          ConnectingImage,
          {
            className: "IncodeConnectingImage",
            alt: "connecting",
            src: He
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(SpinnerInner, { className: "IncodeLoadingCircleSpinnerInner", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            StyledSpinnerImage,
            {
              className: "IncodeLoadingCircleImg",
              color: Je
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(ConnectingParagraph, { className: "IncodeLoadingCircleConnectingText", children: Xe("support.bankRepresentativeSoon") }),
          me && me > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(ConnectingParagraph, { className: "IncodeLoadingCircleConnectingText", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Trans, { i18nKey: "support.queuePlace", children: [
            "Place in the queue is:",
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "IncodeConnectingSpan", children: { index: me } })
          ] }) }) : me && me === 0 ? `${Xe("support.queueNext")}` : ""
        ] }),
        !Ue && /* @__PURE__ */ jsxRuntimeExports.jsx(Footer, { className: "IncodeFooterSmsMessage", children: /* @__PURE__ */ jsxRuntimeExports.jsx(SMSMesage, { onDisconnect: Qe }) })
      ]
    }
  ) });
}
function ErrorMessage$1() {
  const { t: me } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "support", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "card-wrapper", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "circle error", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: me("common.error") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: me("support.noConnection") })
  ] }) }) });
}
const ExecutiveReadyContainer = qe.div`
  padding: 50px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
`, ExecutiveReadyTitle = qe.h1`
  display: none;
`, Message$2 = qe.p`
  font-size: 28px;
  color: #21273b;
  font-weight: bold;
`, ButtonsContainer$2 = qe.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
`, ExecutiveReadyImage = qe.img`
  display: none;
`;
function ExecutiveReady({
  onConnect: me,
  onDisconnect: ue,
  incodeExecutiveReadyImageSrc: Qe
}) {
  const { t: Ue } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ExecutiveReadyContainer, { className: "IncodeExecutiveReadyContainer", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ExecutiveReadyTitle, { className: "IncodeExecutiveReadyTitle", children: Ue("conference.executiveReadyTitle") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ExecutiveReadyImage,
      {
        className: "IncodeExecutiveReadyImage",
        alt: "executive ready",
        src: Qe
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Message$2, { className: "IncodeExecutiveReadyMessage", children: Ue("conference.executiveReady") }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonsContainer$2, { className: "IncodeExecutiveReadyButtonContainer", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button$a,
        {
          className: "IncodeExecutiveReadyConnectButton",
          onClick: me,
          children: Ue("common.connect")
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        DisconnectButton,
        {
          className: "IncodeExecutiveReadyDisconnectButton",
          onClick: ue,
          children: Ue("conference.disconnectExecutiveReady")
        }
      )
    ] })
  ] });
}
const LegalModalContainer = qe(Modal)`
  position: absolute;
  top: 40px;
  left: 40px;
  right: 40px;
  bottom: 40px;
  border: 1px solid #ccc;
  background: #fff;
  overflow: auto;
  border-radius: 4px;
  -webkit-overflow-scrolling: touch;
  outline: none;
  padding: 20px;
`;
function LegalModal({ handleDisconnect: me, onLog: ue, session: Qe, ...Ue }) {
  const { t: He } = useTranslation(), [Ge, Xe] = useState(!1), [Ke, $e] = useState(!1);
  function Je() {
    ue(
      getLogObject("clientAcceptedTerms", {
        status: "Client accepted terms"
      })
    ), Qe.signal({
      type: "terms",
      data: { bureauAccepted: Ge, termsAccepted: Ke }
    }), Ue.onRequestClose();
  }
  function Ze() {
    ue(
      getLogObject("clientRejectedTerms", {
        message: "Client rejected terms so conference can't be continued"
      })
    ), me();
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    LegalModalContainer,
    {
      style: {
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(255, 255, 255, 0.75)",
          zIndex: 1e3
        }
      },
      contentLabel: "Legal Modal",
      ...Ue,
      className: "IncodeLegalModal",
      overlayClassName: "IncodeLegalModalOverlay",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(ModalTitle, { className: "IncodeLegalModalTitle", children: He("conference.bureauTitle") }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Checkbox,
          {
            id: "bureau",
            text: He("conference.bureau"),
            handleChange: () => Xe(!Ge)
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ModalTitle, { className: "IncodeLegalModalTermsText", children: He("conference.termsTitle") }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Checkbox,
          {
            id: "terms",
            text: He("conference.terms"),
            handleChange: () => $e(!Ke)
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "IncodeLegalModalButtonsContainer", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            ModalButton,
            {
              onClick: Je,
              className: "IncodeLegalModalAcceptButton",
              disabled: !Ke,
              children: He("conference.accept")
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            DisconnectButton,
            {
              className: "IncodeLegalModalCancelButton",
              onClick: Ze,
              children: He("conference.cancel")
            }
          )
        ] })
      ]
    }
  );
}
const mic = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='14'%20height='21'%20viewBox='0%200%2014%2021'%3e%3cg%20fill='%23FFF'%20fill-rule='evenodd'%3e%3cpath%20d='M7.002%2014.51c1.069%200%201.984-.395%202.745-1.184.762-.789%201.142-1.738%201.142-2.846V4.03c0-1.108-.38-2.056-1.142-2.846C8.987.394%208.071%200%207.002%200c-1.07%200-1.985.395-2.746%201.184-.761.79-1.142%201.738-1.142%202.847v6.449c0%201.108.38%202.057%201.142%202.846.761.79%201.677%201.184%202.746%201.184z'/%3e%3cpath%20d='M13.769%208.3a.734.734%200%200%200-.547-.239c-.21%200-.393.08-.547.24a.79.79%200%200%200-.23.566v1.613c0%201.553-.533%202.882-1.598%203.986-1.065%201.105-2.347%201.657-3.845%201.657-1.499%200-2.78-.552-3.846-1.657-1.065-1.104-1.597-2.433-1.597-3.986V8.867a.789.789%200%200%200-.23-.566.734.734%200%200%200-.548-.24c-.21%200-.393.08-.546.24a.789.789%200%200%200-.231.566v1.613c0%201.856.597%203.47%201.792%204.843%201.194%201.373%202.67%202.16%204.428%202.361v1.663h-3.11c-.21%200-.393.08-.547.24a.789.789%200%200%200-.23.566.79.79%200%200%200%20.23.567c.154.16.336.24.547.24h7.775c.21%200%20.393-.08.547-.24a.789.789%200%200%200%20.231-.567.788.788%200%200%200-.231-.566.734.734%200%200%200-.547-.24H7.78v-1.663c1.758-.201%203.234-.988%204.429-2.361C13.402%2013.95%2014%2012.336%2014%2010.48V8.867a.789.789%200%200%200-.231-.566z'/%3e%3c/g%3e%3c/svg%3e", phone$1 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='25'%20height='10'%20viewBox='0%200%2025%2010'%3e%3cpath%20fill='%23FFF'%20fill-rule='nonzero'%20d='M2.175%209.007l4.154.005c.826%200%201.498-.697%201.497-1.554l-.002-2.093c.102-.03.209-.06.321-.09%201.027-.294%202.433-.695%204.337-.692%201.909.002%203.318.407%204.347.702l.314.09v1.403l.002.691c0%20.858.675%201.555%201.5%201.557l4.156.005c.825%200%201.497-.696%201.496-1.554l-.005-1.174h-.031c-.055-.447-.18-.9-.37-1.334a5.004%205.004%200%200%200-.65-1.078C21.238%201.34%2018.12.298%2012.48.29%204.684.283%201.84%203.715%201.72%203.865c-.26.33-.472.683-.647%201.082-.188.43-.312.882-.366%201.328l-.024.001L.673%207.45c.002.857.675%201.555%201.502%201.557z'/%3e%3c/svg%3e", TEST_TIMEOUT = 5e3, ModalTitle = qe.h1`
  font-size: 23px;
  font-weight: bold;
  text-align: center;
  color: #21273b;
`, ModalButton = qe(Button$a)`
  width: 100%;
  text-transform: none;
  margin-top: 30px;
`, waitingRoom = "waiting-room";
function Header$1({ onFinishSession: me, onMute: ue, audio: Qe, name: Ue }) {
  const { t: He } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("header", { className: "IncodeConferenceHeader", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "button",
      {
        className: classNames("mute", { muted: !Qe }),
        onClick: ue,
        type: "button",
        children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { alt: "microphone", src: mic })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "center", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: Ue }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("small", { children: He("support.connected") })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("button", { className: "hang", onClick: me, type: "button", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { alt: "phone", src: phone$1 }) })
  ] });
}
function CallFinished({ classes: me, onSuccess: ue }) {
  const { t: Qe } = useTranslation(), Ue = () => {
    ue();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "support", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "card-wrapper apply", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: Qe("support.thanks") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { children: Qe("support.finished") })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button$a,
      {
        variant: "contained",
        size: "large",
        className: me.button,
        onClick: Ue,
        children: Qe("support.restart")
      }
    )
  ] }) });
}
function Stream({ subscriberEventHandlers: me }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "subscriber IncodeSubscriberContainer", children: /* @__PURE__ */ jsxRuntimeExports.jsx(OTSubscriber$2, { eventHandlers: me }) });
}
function getSession(me, ue, Qe) {
  return createSession$4({
    apiKey: me.tokboxApiKey,
    sessionId: ue.sessionId,
    token: ue.interviewToken,
    ...Qe
  });
}
function addToQueue(me, ue, Qe) {
  return me.addToQueue({ token: ue.token, queueName: Qe }).then((Ue) => Math.ceil(Ue.waitingTimeInSeconds / 60));
}
const DisconnectButton = qe(SecondaryButton)`
  margin-top: 30px;
`;
function Conference({
  classes: me,
  token: ue,
  onBoarding: Qe,
  onSuccess: Ue,
  interviewerData: He,
  playAlert: Ge,
  onLog: Xe,
  queue: Ke,
  onError: $e,
  showLegalModal: Je,
  customImagesSrc: Ze
}) {
  const [nt] = useState({
    isComplete: !1,
    status: ""
  }), [tt, et] = useState(null), [rt, it] = useState(!1), [ot, at] = useState(!1), [st, ut] = useState(null), [lt, dt] = useState(null), [At, pt] = useState(!0), [gt, wt] = useState(!1), [Bt, Tt] = useState(0), [yt, Ct] = useState(null), [ht, It] = useState("waiting"), [vt, Et] = useState(!1), [bt, Rt] = useState(!1), [St, kt] = useState(0), [jt, Pt] = useState(!1), Qt = useRef(null), qt = useRef(null), _t = useRef(!1), Yt = useRef(null), Xt = useRef(null), Ut = useRef(null), { t: Lt } = useTranslation();
  useEffect(() => {
    addScreenEvent({
      module: eventModuleNames.conference,
      screen: eventScreenNames.conferenceWait,
      token: ue.token,
      shouldOpen: !0
    });
  }, []), useEffect(() => {
    rt && (Qe.addEvent({
      token: ue.token,
      code: "startVideoconference"
    }), Xe(
      getLogObject("conferenceConnected", {
        message: "Conference successfully connected"
      })
    ));
  }, [ue, Qe, rt, Xe]), useEffect(() => {
    async function Jt() {
      try {
        const cn = await window.OT.getUserMedia({
          audio: !0,
          video: !0
        });
        Ut.current = cn;
      } catch (cn) {
        return cn.originalName === "NotAllowedError" && Xe(
          getLogObject("permissionDenied", {
            message: "User denied to use camera."
          })
        ), $e("no-permissions", cn);
      }
      if (He) {
        at(!0), Ct(He), window.clearInterval(Yt.current), It("user-turn");
        return;
      }
      const an = await addToQueue(Qe, ue, Ke);
      Tt(an), wt(!0);
    }
    Jt();
  }, []), useEffect(() => {
    st === 1 && Qe.addEvent({
      token: ue.token,
      code: "userFirstInQueue"
    });
  }, [st, Qe, ue]), useEffect(() => {
    if (ot || !gt) return;
    function Jt() {
      Qe.getQueueIndex({ token: ue.token, queueName: Ke }).then(async (cn) => {
        if (cn.index === 0) {
          const dn = await Qe.getInterviewerName({
            token: ue.token
          });
          at(!0), Ct(dn), window.clearInterval(Yt.current), It("user-turn"), ut(0), Xe(
            getLogObject("executiveReady", {
              message: "Executive is ready to take videocall"
            })
          );
        } else
          ut(cn.index);
      });
    }
    const an = setInterval(() => {
      ot || Jt();
    }, 1e3);
    return () => clearInterval(an);
  }, [
    Ft,
    ot,
    gt,
    Qe,
    ue.token,
    Ke,
    $e,
    Xe
  ]), useEventListener(
    "message",
    ({ data: Jt }) => {
      var cn, dn;
      const an = (dn = (cn = Xt.current) == null ? void 0 : cn.state) == null ? void 0 : dn.session;
      if (an) {
        if (Jt === "OK") {
          hn("selfie", 100, an);
          return;
        }
        Jt === "NOK" && hn("selfie", 0, an);
      }
    },
    window
  ), useOffline(() => {
    $e(conferenceStatus.noConnection);
  });
  const Ot = useMemo(
    () => ({
      sessionConnected: ({ target: Jt }) => ($t({ success: !0 }, "connect", Jt), Qt.current = { session: Jt }, addScreenEvent({
        module: eventModuleNames.conference,
        screen: eventScreenNames.conferenceWait,
        token: ue.token,
        shouldOpen: !1
      }), addScreenEvent({
        module: eventModuleNames.conference,
        screen: eventScreenNames.conferenceVideoChat,
        token: ue.token,
        shouldOpen: !0
      }), it(!0)),
      sessionDisconnected: () => {
        addScreenEvent({
          module: eventModuleNames.conference,
          screen: jt ? eventScreenNames.conferenceMessageChat : eventScreenNames.conferenceVideoChat,
          token: ue.token,
          shouldOpen: !1
        }), it(!1);
      },
      "signal:close": (Jt) => {
        console.error(jt), addScreenEvent({
          module: eventModuleNames.conference,
          screen: jt ? eventScreenNames.conferenceMessageChat : eventScreenNames.conferenceVideoChat,
          token: ue.token,
          shouldOpen: !1
        });
        const an = JSON.parse(Jt.data);
        Xe(getLogObject("conferenceClosed", an));
      },
      "signal:showLegalModal": () => {
        Je && Rt(!0);
      },
      "signal:conferenceFinished": (Jt) => {
        Ut.current && killStream(Ut.current);
        const an = JSON.parse(Jt.data);
        return Xe(
          getLogObject("conferenceFinished", {
            message: "Conference successfully finished"
          })
        ), Ue(an.status);
      }
    }),
    [Xe, Ue, Je]
  );
  function ft(Jt) {
    Ue("rejected"), it(!1), et(`Failed to connect: ${Jt.message}`), Xe(
      getLogObject("conferenceFailed", {
        message: Jt.message
      })
    );
  }
  function Dt(Jt) {
    qt.current = getSession(
      Qe,
      {
        sessionId: Jt.sessionId,
        interviewToken: Jt.interviewToken
      },
      {
        onError: (an) => {
          Ue("rejectedSignal"), et(`Failed to connect singal session: ${an.message}`), Xe(
            getLogObject("conferenceSignalFailed", {
              message: an.message
            })
          );
        },
        onConnect: () => {
          _t.current = !0, Xe(getLogObject("signal-connect", { success: !0 }));
          const { session: an } = qt.current;
          an.signal(
            {
              type: "connectSignal"
            },
            (cn) => {
              console.log(cn ? `connectSignal error: ${cn.message}` : "connectSignal sent");
            }
          );
        },
        onDisconnect: () => {
          _t.current = !1;
        }
      }
    );
  }
  const Mt = (Jt, an) => new Promise((cn, dn) => {
    var yn, Nn, Rn;
    return (Rn = (Nn = (yn = qt.current) == null ? void 0 : yn.session) == null ? void 0 : Nn.signal) == null ? void 0 : Rn.call(
      Nn,
      {
        type: an,
        data: Jt
      },
      (rn) => {
        rn ? (console.log(`${an} signal error: ${rn.message}`), dn(rn)) : (console.log(`${an} signal sent`), cn());
      }
    );
  });
  async function Ft() {
    It("connecting"), dt(Lt("conference.checkingInternet")), Xe(
      getLogObject("clientClickedConnect", {
        message: "Client clicked connect after executive accepted videoconference"
      })
    );
    const { index: Jt } = await Qe.getQueueIndex({
      token: ue.token,
      queueName: Ke
    });
    if (Jt === -1) {
      $e(conferenceStatus.executiveDisconnected), Xe(getLogObject(conferenceStatus.executiveDisconnected, {})), An({
        type: conferenceStatus.executiveDisconnected,
        reason: "Executive finish the call"
      });
      return;
    }
    const an = {
      audioOnly: !1,
      timeout: TEST_TIMEOUT
    };
    Dt(yt);
    const cn = setInterval(dn, 100);
    async function dn() {
      console.log("attempting connectivity check", _t.current), _t.current && (console.log("connectivity check started"), Qe.getOpenTokTest({ token: ue.token }).then(async (yn) => {
        const Nn = {
          apiKey: Qe.tokboxApiKey,
          sessionId: yn.sessionId,
          token: yn.interviewToken
        }, Rn = new NetworkTest(window.OT, Nn, an);
        await Mt("", "testInit");
        const rn = await Rn.testConnectivity();
        if (rn.failedTests)
          for (const ln of rn.failedTests) {
            let pn = "", Sn;
            switch (ln.error.name) {
              case NetworkTestExports.ErrorNames.FAILED_TO_OBTAIN_MEDIA_DEVICES:
                Sn = conferenceStatus.noPermission, pn = "User didn't grant device permissions";
                break;
              case NetworkTestExports.ErrorNames.NO_AUDIO_CAPTURE_DEVICES:
              case NetworkTestExports.ErrorNames.NO_VIDEO_CAPTURE_DEVICES:
                Sn = conferenceStatus.noDevice, pn = "User has no device available to connect";
                break;
              default:
                Sn = conferenceStatus.genericError, pn = "Customer had an unexpected error when connecting";
                break;
            }
            return Xe(
              getLogObject("networkTest-failedTests", {
                reason: pn,
                error: Sn,
                results: rn
              })
            ), An({
              type: "networkTest-failedTests",
              reason: pn
            }), await Mt(pn, "connectivityError"), $e(Sn);
          }
        await Mt("", "checkingInternet"), dt(Lt("conference.checkingInternet")), Rn.testQuality().then((ln) => {
          Qe.getQueueIndex({
            token: ue.token,
            queueName: Ke
          }).then(async ({ index: pn }) => {
            if (pn === -1) {
              $e(conferenceStatus.executiveDisconnected), Xe(
                getLogObject(conferenceStatus.executiveDisconnected, {})
              ), An({
                type: conferenceStatus.executiveDisconnected,
                reason: "Executive finish the call"
              });
              return;
            }
            An({
              type: "video-mos",
              reason: ln.video.mos
            }), An({
              type: "audio-mos",
              reason: ln.audio.mos
            }), ln.audio.mos < 1.1 || ln.video.mos < 1.1 ? (dt(Lt("conference.internetNotStable")), await Mt(
              `audio ${ln.audio.mos} - video ${ln.video.mos}`,
              "internetNotStable"
            )) : (dt(Lt("conference.internetStable")), await Mt("", "internetStable")), await qt.current.disconnect(), Xe(
              getLogObject("conferenceConnecting", {
                message: "Conference started connecting status"
              })
            ), it(!0), It("connected"), Qe.connectToQueue({ token: ue.token, queue: Ke });
          }).catch(async (pn) => {
            $e("OpenTok quality test error", pn), await Mt("", "queueIndexErr");
          });
        }).catch(async (ln) => {
          let pn = "";
          switch (ln.name) {
            case NetworkTestExports.ErrorNames.UNSUPPORTED_BROWSER:
              $e(conferenceStatus.noBrowser), pn = conferenceStatus.noBrowser;
              break;
            case NetworkTestExports.ErrorNames.CONNECT_TO_SESSION_NETWORK_ERROR:
              $e(conferenceStatus.badInternet), pn = conferenceStatus.badInternet;
              break;
            case NetworkTestExports.ErrorNames.FAILED_TO_OBTAIN_MEDIA_DEVICES:
              $e(conferenceStatus.noPermission), pn = conferenceStatus.noPermission;
              break;
            case NetworkTestExports.ErrorNames.NO_AUDIO_CAPTURE_DEVICES:
            case NetworkTestExports.ErrorNames.NO_VIDEO_CAPTURE_DEVICES:
              $e(conferenceStatus.noDevice), pn = conferenceStatus.noDevice;
              break;
            case NetworkTestExports.ErrorNames.INIT_PUBLISHER_ERROR:
              await qt.current.disconnect(), it(!0), It("connected"), Qe.connectToQueue({ token: ue.token, queue: Ke });
              break;
            default:
              $e(conferenceStatus.genericError), pn = `${conferenceStatus.genericError}-${ln.name}`;
              break;
          }
          await Mt(pn, "qualityError");
        });
      }), clearInterval(cn));
    }
  }
  function Gt() {
    Et(!0);
  }
  function zt(Jt, an) {
    switch (Jt) {
      case waitingRoom:
        addScreenEvent({
          module: eventModuleNames.conference,
          screen: eventScreenNames.conferenceWait,
          token: ue.token,
          shouldOpen: !1
        }), Xe(
          getLogObject("clientDisconnected", {
            message: "Client clicked disconnect in waiting room"
          })
        );
        break;
      case "user-turn":
        addScreenEvent({
          module: eventModuleNames.conference,
          screen: eventScreenNames.conferenceVideoChat,
          token: ue.token,
          shouldOpen: !1
        }), Xe(
          getLogObject("clientClickedDisconnect", {
            message: "Client clicked disconnect after executive accepted videoconference"
          })
        );
        break;
      case "support":
        addScreenEvent({
          module: eventModuleNames.conference,
          screen: eventScreenNames.conferenceVideoChat,
          token: ue.token,
          shouldOpen: !1
        }), Xe(
          getLogObject("clientClickedDisconnectOnSupport", {
            message: "Client clicked disconnect while being in conference"
          })
        );
        break;
    }
    Jt === "support" ? Ht(an) : (Qe.removeFromQueue({ queueName: Ke, token: ue.token }), Ue(conferenceStatus.close));
  }
  const $t = (Jt, an, cn) => new Promise((dn, yn) => cn == null ? void 0 : cn.signal(
    {
      type: an,
      data: Jt
    },
    (Nn) => {
      Nn ? (console.log(`signal error: ${Nn.message}`), yn(Nn)) : (console.log("signal sent"), dn());
    }
  ));
  async function Ht(Jt) {
    await $t("Call is closed", "user-disconnected", Jt), Ue(conferenceStatus.close), Jt.disconnect(), Ut.current && killStream(Ut.current);
  }
  function hn(Jt, an, cn) {
    return $t({ score: an, image: Jt }, "externalScore", cn);
  }
  if (nt.isComplete)
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      CallFinished,
      {
        classes: me,
        status: nt.status,
        onSuccess: Ue
      }
    );
  if (tt)
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorMessage$1, {});
  const un = (Jt, an) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    AreYouSureModal,
    {
      closeModal: () => Et(!1),
      isOpen: vt,
      onDisconnect: () => zt(Jt, an),
      theme: Qe.theme,
      origin: Jt
    }
  );
  if (ht === "user-turn")
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      un("user-turn"),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        ExecutiveReady,
        {
          onConnect: Ft,
          onDisconnect: Gt,
          incodeExecutiveReadyImageSrc: Ze.incodeExecutiveReadyImageSrc
        }
      )
    ] });
  if (ht === "waiting" || ht === "connecting")
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      un(waitingRoom),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Connecting,
        {
          index: st,
          time: Bt,
          bandwidth: lt,
          onConnect: Ft,
          onDisconnect: Gt,
          incodeConnectingImageSrc: Ze.incodeConnectingImageSrc,
          incodeBandwidthImageSrc: Ze.incodeBandwidthImageSrc
        }
      )
    ] });
  function An(Jt) {
    let an;
    try {
      an = JSON.stringify(Jt);
    } catch {
      an = Jt.reason || "";
    }
    const cn = (ue == null ? void 0 : ue.interviewId) || (He == null ? void 0 : He.interviewId);
    cn && Qe.addConferenceEvent({
      token: ue.token,
      interviewId: cn,
      opentokSessionId: yt.sessionId,
      eventType: Jt.type,
      details: an,
      eventSource: "customer"
    });
  }
  const mn = {
    accessAllowed: An,
    accessDenied: An,
    accessDialogClosed: An,
    error: An,
    accessDialogOpened: An,
    // audioLevelUpdated: logToServer,
    destroyed: An,
    mediaStopped: An,
    streamCreated: An,
    streamDestroyed: An,
    videoDimensionsChanged: An,
    videoElementCreated: An
  }, En = {
    audioLevel: An,
    audioStatsUpdated: An,
    connected: An,
    error: An,
    streamDisconnected: An,
    streamReconnected: An,
    videoDisabled: An,
    videoDisableWarning: An,
    videoDisableWarningLifted: An,
    videoEnabled: An,
    videoStatsUpdated: An
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    OTSession$2,
    {
      apiKey: Qe.tokboxApiKey,
      sessionId: yt.sessionId,
      token: yt.interviewToken,
      eventHandlers: Ot,
      onError: ft,
      children: ({ session: Jt }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("section", { className: "support IncodeConferenceContainer", children: [
        un("support", Jt),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          LegalModal,
          {
            isOpen: bt,
            onLog: Xe,
            onRequestClose: () => Rt(!1),
            handleDisconnect: () => Ht(Jt),
            shouldCloseOnOverlayClick: !1,
            session: Jt
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: rt ? "publisher" : "connecting", children: [
          rt && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Header$1,
            {
              audio: At,
              onFinishSession: Gt,
              onMute: () => pt((an) => !an),
              name: yt.interviewerName
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            OTPublisher$2,
            {
              ref: Xt,
              properties: {
                publishAudio: At
              },
              eventHandlers: mn
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(OTStreams$2, { loading: /* @__PURE__ */ jsxRuntimeExports.jsx(Connecting, { onlyCircle: !0 }), children: /* @__PURE__ */ jsxRuntimeExports.jsx(Stream, { subscriberEventHandlers: En }) }),
          rt && ot ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            Chat,
            {
              session: Jt,
              playAlert: Ge,
              unreadMessages: St,
              setUnreadMessages: kt,
              token: ue.token,
              isChatViewOpen: jt,
              setChatViewOpen: Pt
            }
          ) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Connecting, { index: st, time: Bt })
        ] })
      ] })
    }
  );
}
const Conference$1 = preloadScript$3(Conference), serviceBell = "data:audio/mpeg;base64,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", fail = "data:image/svg+xml,%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='8'%20cy='8'%20r='8'%20fill='%23E81E35'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M11.1007%206.31501C11.4912%205.92449%2011.4912%205.29132%2011.1007%204.9008C10.7102%204.51028%2010.077%204.51028%209.68649%204.90081L8.00148%206.58582L6.31648%204.90081C5.92596%204.51028%205.2928%204.51028%204.90227%204.9008C4.51174%205.29132%204.51174%205.92449%204.90227%206.31501L6.58728%208.00004L4.90227%209.68506C4.51174%2010.0756%204.51174%2010.7087%204.90227%2011.0993C5.2928%2011.4898%205.92596%2011.4898%206.31648%2011.0993L8.00148%209.41425L9.68649%2011.0993C10.077%2011.4898%2010.7102%2011.4898%2011.1007%2011.0993C11.4912%2010.7087%2011.4912%2010.0756%2011.1007%209.68506L9.41569%208.00004L11.1007%206.31501Z'%20fill='white'/%3e%3c/svg%3e", loading = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M12%203V6'%20stroke='%2320263D'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M18.364%205.63599L16.2427%207.75731'%20stroke='%2320263D'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M21%2012H18'%20stroke='%2320263D'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20opacity='0.5'%20d='M18.364%2018.364L16.2427%2016.2427'%20stroke='%2320263D'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20opacity='0.5'%20d='M12%2021V18'%20stroke='%2320263D'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20opacity='0.33'%20d='M5.63623%2018.364L7.75755%2016.2427'%20stroke='%2320263D'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20opacity='0.33'%20d='M3%2012H6'%20stroke='%2320263D'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20opacity='0.12'%20d='M5.63623%205.63599L7.75755%207.75731'%20stroke='%2320263D'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", timerIcon = "data:image/svg+xml,%3csvg%20width='18'%20height='22'%20viewBox='0%200%2018%2022'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9%2021C13.4183%2021%2017%2017.4183%2017%2013C17%208.58172%2013.4183%205%209%205C4.58172%205%201%208.58172%201%2013C1%2017.4183%204.58172%2021%209%2021Z'%20stroke='%2320263D'%20stroke-width='2'%20stroke-miterlimit='10'/%3e%3cpath%20d='M9%2013L12%2010'%20stroke='%2320263D'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M7%201.5H11'%20stroke='%2320263D'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", timerIconRed = "data:image/svg+xml,%3csvg%20width='18'%20height='22'%20viewBox='0%200%2018%2022'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9%2021C13.4183%2021%2017%2017.4183%2017%2013C17%208.58172%2013.4183%205%209%205C4.58172%205%201%208.58172%201%2013C1%2017.4183%204.58172%2021%209%2021Z'%20stroke='%23E81E35'%20stroke-width='2'%20stroke-miterlimit='10'/%3e%3cpath%20d='M9%2013L12%2010'%20stroke='%23E81E35'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M7%201.5H11'%20stroke='%23E81E35'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", IncodeOTPTitle = qe.h1`
  display: none;
`, IncodeOTPSecondsParagraph = qe.p`
  display: none;
`, InfoLabel = qe.p`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  font-size: 1.06rem;
  font-weight: bold;
  text-align: center;
  color: ${(me) => me.timeout <= 5 && me.type === "timer" ? "#E81E35" : "#20263d"};
  margin: 0;
  span {
    font-size: 1rem;
    min-width: 125px;
  }
  > img {
    width: 24px;
    height: 24px;
    margin-right: 5px;
  }

  .spin-loader {
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
`, Button$3 = qe(Button$a)`
  color: #ffffff;
  background-color: #0093fd;
  margin-top: 60px;
  padding: 20px 32px;
  min-width: auto;
  :disabled {
    opacity: 1;
    color: #636670;
    background-color: #e9e9eb;
  }
`, ErrorContainer = qe.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;

  img {
    margin-right: 5px;
  }
`, ErrorLabel = qe.span`
  font-size: 1rem;
  color: #e81e35;
`, Text$1 = qe.p`
  color: #20263d;
  font-size: 2.43rem;
  font-weight: bold;
  margin: 0;
  letter-spacing: 15px;
  margin: 15px 0 15px;
  opacity: ${(me) => me.hideCode ? 0 : 1};
  &.loading {
    letter-spacing: unset;
  }
`, Label = qe.label`
  line-height: 35px;
  display: flex;
  font-size: 1.56rem;
  padding: 0 70px;
  color: #20263d;
`, Content = qe.div`
  width: 100%;
  height: 100%;
  background-color: #fff;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.5);
  text-align: center;
  padding-top: 50px;

  .character-inputs-container {
    margin-top: 22px;
  }
`, Container$2 = qe.main`
  height: 100%;
  background-color: #21273b;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #21273b;
`;
function OTP({
  isReady: me,
  interviewCode: ue,
  timer: Qe,
  onSubmit: Ue,
  error: He,
  onCodeChange: Ge,
  code: Xe,
  generatingCode: Ke = !1
}) {
  const { t: $e } = useTranslation(), Je = useRef();
  return useEffect(() => {
    (() => {
      if (!Je.current)
        return;
      Qe <= 10 && Qe >= 9 ? Je.current.setAttribute("aria-live", "polite") : Je.current.setAttribute("aria-live", "off");
    })();
  }, [Qe]), /* @__PURE__ */ jsxRuntimeExports.jsx(Container$2, { className: "IncodeOTP", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Content, { className: "IncodeOTPContent", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(IncodeOTPTitle, { className: "IncodeOTPTitle" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(IncodeOTPSecondsParagraph, { className: "IncodeOTPSecondsParagraph" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Label, { className: "IncodeOTPLabel", children: $e("otp.enterLabel") }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("form", { "aria-label": "OT challenge form", children: [
      me ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Text$1,
          {
            role: "region",
            "aria-live": "polite",
            hideCode: Ke,
            className: "IncodeOTPText",
            children: ue
          }
        ),
        Ke ? /* @__PURE__ */ jsxRuntimeExports.jsxs(InfoLabel, { type: "code", className: "IncodeOTPTimer timer", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "img",
            {
              alt: "",
              className: "spin-loader",
              src: loading,
              "aria-hidden": !0
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: $e("otp.generatingCode") })
        ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(
          InfoLabel,
          {
            ref: Je,
            role: "region",
            timeout: Qe,
            type: "timer",
            className: "IncodeOTPTimer timer",
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "img",
                {
                  alt: "",
                  src: Qe <= 5 ? timerIconRed : timerIcon,
                  "aria-hidden": !0
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: $e("otp.secondsLeft", { seconds: Qe }) })
            ]
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          IndividualCharacterInputBoxes,
          {
            amount: ue.length,
            onChange: Ge,
            autoFocus: !0,
            value: Xe,
            password: !1,
            isNumeric: !1
          }
        )
      ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { className: "IncodeOTPText loading", children: $e("common.loading") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { role: "region", "aria-live": "assertive", children: He && /* @__PURE__ */ jsxRuntimeExports.jsxs(ErrorContainer, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: fail, "aria-hidden": !0, alt: "" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          ErrorLabel,
          {
            role: "alert",
            "aria-live": "assertive",
            className: "IncodeOTPError",
            id: "OTPInput-0",
            children: [
              " ",
              $e("otp.error")
            ]
          }
        )
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button$3,
        {
          className: "IncodeOTPButton",
          type: "submit",
          disabled: Xe.length !== 6,
          onClick: (Ze) => {
            Ze.preventDefault(), Ue(Xe);
          },
          theme,
          children: $e("otp.submit")
        }
      )
    ] })
  ] }) });
}
const DEFAULT_TIMER_TIMEOUT = 3e4, isValidTimeout = (me) => !Number.isNaN(me) && typeof me == "number";
function SimpleOTP({
  token: { token: me },
  onBoarding: ue,
  numberOfTries: Qe,
  onError: Ue,
  onLog: He,
  onSuccess: Ge,
  otpTimeout: Xe = DEFAULT_TIMER_TIMEOUT
}) {
  const Ke = isValidTimeout(Xe) ? Math.max(Xe, 1e3) : DEFAULT_TIMER_TIMEOUT, [$e, Je] = useState(""), [Ze, nt] = useState(""), [tt, et] = useState(!1), [rt, it] = useState(0), [ot, at] = useState(!0), [st, ut] = useState(!1), [lt, dt] = useState(Math.round(Ke / 1e3));
  useScreenEvents({
    module: eventModuleNames.otp,
    screen: eventScreenNames.simpleOTP,
    token: me
  });
  const At = useCallback(
    async function() {
      ut(!0);
      const { interviewCode: Tt } = await ue.generateOTP({
        token: me
      });
      ut(!1), Je(Tt), at(!1), dt(Math.round(Ke / 1e3)), nt("");
    },
    [ue, me, Ke]
  );
  useEffect(() => {
    At();
  }, [At]), useInterval(() => {
    lt === 0 ? At() : dt(lt - 1);
  }, 1e3);
  async function pt() {
    const Bt = rt + 1;
    if (et(!0), it((Tt) => Tt + 1), He(
      getLogObject("otpAttemptFailed", {
        message: "Incorrect OTP"
      })
    ), Qe !== -1 && Bt >= Qe) {
      Ue("OTPError"), He(
        getLogObject("otpNoAttemptsLeft", {
          message: "No attempts left"
        })
      );
      return;
    }
    At();
  }
  function gt(Bt) {
    Bt !== Ze && (et(!1), nt(Bt));
  }
  async function wt(Bt) {
    try {
      const { success: Tt } = await ue.verifyOTP({
        token: me,
        code: Bt
      });
      Tt && (ue.addEvent({
        token: me,
        code: "otpSubmitted"
      }), He(
        getLogObject("otpPassed", {
          message: "Correct OTP"
        })
      ), Ge());
    } catch {
      pt();
    }
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    OTP,
    {
      generatingCode: st,
      isReady: !ot,
      interviewCode: $e,
      timer: lt,
      onSubmit: wt,
      error: tt,
      onCodeChange: gt,
      code: Ze
    }
  );
}
const desktopIcon = "data:image/svg+xml,%3csvg%20aria-hidden='true'%20focusable='false'%20data-prefix='fas'%20data-icon='desktop'%20class='svg-inline--fa%20fa-desktop%20fa-w-18'%20role='img'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20576%20512'%3e%3cpath%20fill='currentColor'%20d='M528%200H48C21.5%200%200%2021.5%200%2048v320c0%2026.5%2021.5%2048%2048%2048h192l-16%2048h-72c-13.3%200-24%2010.7-24%2024s10.7%2024%2024%2024h272c13.3%200%2024-10.7%2024-24s-10.7-24-24-24h-72l-16-48h192c26.5%200%2048-21.5%2048-48V48c0-26.5-21.5-48-48-48zm-16%20352H64V64h448v288z'%3e%3c/path%3e%3c/svg%3e", DesktopDetectedContainer = qe.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: white;
  text-align: center;
  z-index: 9999999;
  box-sizing: border-box;
  padding: 50px;
  font-weight: bolder;
  height: 100%;
  width: 100%;
`, Image$3 = qe.img`
  height: 90px;
  margin-bottom: 25px;
`, Text = qe.p`
  display: block;
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 0;
  margin-inline-end: 0;
  font-size: 22px;
`;
function DesktopDetected() {
  const { t: me } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(DesktopDetectedContainer, { className: "IncodeDesktopDetectedContainer", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Image$3,
      {
        className: "IncodeDesktopDetectedImage",
        src: desktopIcon,
        alt: "browser not supported"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { className: "IncodeDesktopDetectedText", children: me("common.onlyMobile") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { className: "IncodeDesktopDetectedText", children: me("common.goToMobile") })
  ] });
}
const noSleep = new NoSleep$1(), steps = ["otp", "conference"];
function ConferenceApp({
  showOTP: me,
  onBoarding: ue,
  token: Qe,
  onSuccess: Ue,
  numberOfTries: He,
  onError: Ge,
  onConnect: Xe,
  interviewerData: Ke,
  onLog: $e,
  queue: Je,
  showLegalModal: Ze,
  customImagesSrc: nt,
  otpTimeout: tt
}) {
  const [et, rt] = useState(
    steps.indexOf(me ? "otp" : "conference")
  );
  useModuleEvents({
    module: eventModuleNames.conference,
    token: Qe.token
  });
  const it = useRef(null);
  function ot(ut) {
    return rt(steps.indexOf(ut));
  }
  const at = () => {
    it.current.play();
  };
  useEffect(() => {
    noSleep.enable();
  }, []);
  function st(ut) {
    noSleep.enable(), ot("conference"), at(), it.current.pause();
  }
  return mobile.any() ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("audio", { src: serviceBell, ref: it }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Steps, { currentStep: et, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        SimpleOTP,
        {
          onBoarding: ue,
          token: Qe,
          onSuccess: st,
          numberOfTries: He,
          onError: Ge,
          onLog: $e,
          queue: Je,
          otpTimeout: tt
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Conference$1,
        {
          onBoarding: ue,
          token: Qe,
          onSuccess: Ue,
          onConnect: Xe,
          interviewerData: Ke,
          playAlert: at,
          onLog: $e,
          queue: Je,
          onError: Ge,
          showLegalModal: Ze,
          customImagesSrc: nt
        }
      )
    ] })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(DesktopDetected, {});
}
function renderConference(me, {
  token: ue,
  showOTP: Qe = !1,
  numberOfTries: Ue = 3,
  interviewerData: He,
  queue: Ge = "",
  showLegalModal: Xe = !1,
  customImagesSrc: Ke = {},
  otpTimeout: $e = 3e4
}, { onSuccess: Je, onError: Ze, onConnect: nt = emptyFunc, onLog: tt = emptyFunc }) {
  const et = createRoot$1(me), rt = {
    onSuccess: handleUnmountRoot(Je, et, me),
    onError: handleUnmountRoot(Ze, et, me)
  };
  return customRender(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      ConferenceApp,
      {
        onBoarding: this,
        token: ue,
        onSuccess: rt.onSuccess,
        showOTP: Qe,
        numberOfTries: Ue,
        onError: rt.onError,
        onConnect: nt,
        onLog: tt,
        interviewerData: He,
        queue: Ge,
        showLegalModal: Xe,
        customImagesSrc: Ke,
        otpTimeout: $e
      }
    ) }),
    me,
    et
  ), { close: handleUnmountRoot(emptyFunc, et, me) };
}
const idIcon = "data:image/svg+xml,%3csvg%20width='96'%20height='56'%20viewBox='0%200%2096%2056'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3crect%20x='1'%20width='94'%20height='56'%20rx='4'%20fill='%23FDF6E6'/%3e%3cpath%20opacity='0.319964'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M1.00128%2012H95V13H1L1.00128%2012Z'%20fill='%23979797'/%3e%3crect%20x='35'%20y='18'%20width='22'%20height='4'%20rx='0.4536'%20fill='%23D8D8D8'/%3e%3crect%20x='35'%20y='25'%20width='22'%20height='4'%20rx='0.4536'%20fill='%23D8D8D8'/%3e%3crect%20x='35'%20y='32'%20width='30'%20height='4'%20rx='0.4536'%20fill='%23D8D8D8'/%3e%3crect%20x='35'%20y='40'%20width='10'%20height='4'%20rx='0.4536'%20fill='%23D8D8D8'/%3e%3crect%20x='6'%20y='4'%20width='40'%20height='4'%20rx='0.4536'%20fill='%231A366D'/%3e%3crect%20x='83'%20y='3'%20width='7'%20height='6'%20rx='0.4536'%20fill='%23DBB107'/%3e%3cg%20opacity='0.5'%3e%3cmask%20id='mask0'%20style='mask-type:alpha'%20maskUnits='userSpaceOnUse'%20x='78'%20y='34'%20width='12'%20height='16'%3e%3crect%20x='78'%20y='34'%20width='12'%20height='15.2727'%20rx='2'%20fill='%2393D3E5'/%3e%3c/mask%3e%3cg%20mask='url(%23mask0)'%3e%3crect%20x='77.8203'%20y='35.8768'%20width='12.3709'%20height='13.8901'%20rx='2'%20fill='url(%23pattern0)'/%3e%3c/g%3e%3c/g%3e%3cg%20clip-path='url(%23clip0)'%3e%3crect%20x='6'%20y='18'%20width='24'%20height='30.5455'%20rx='0.774194'%20fill='%2393D3E5'/%3e%3cpath%20d='M7.89682%2042.6127C6.13166%2043.0152%205.61295%2043.5288%205.57424%2043.7352L5.14844%2048.8062H29.9226C29.9355%2047.4772%2029.9536%2044.6797%2029.9226%2044.1223C29.8917%2043.5649%2029.0323%2043.0385%2028.6065%2042.8449L22.0259%2041.2578L12.813%2041.4127C11.9097%2041.6449%209.66199%2042.2101%207.89682%2042.6127Z'%20fill='%23707487'/%3e%3cpath%20d='M13.5488%2043.503V38.3159H22.1037V41.2191C22.1037%2041.343%2019.3682%2043.4384%2017.923%2044.6255L13.5488%2043.503Z'%20fill='%23E6AE78'/%3e%3cpath%20d='M13.5869%2041.8385V38.1611L21.9482%2038.6256C21.4579%2039.2449%2020.0669%2040.6617%2018.4256%2041.374C16.7843%2042.0862%2014.5159%2041.9804%2013.5869%2041.8385Z'%20fill='%23D29B6E'/%3e%3cpath%20d='M12.0772%2035.9546V32.1224C12.1538%2031.503%2012.2609%2030.0708%2012.0772%2029.2966C11.8476%2028.3288%2013.1998%2027.9417%2014.9804%2027.2837C16.7611%2026.6256%2020.2062%2027.0127%2021.5998%2027.2837C22.7146%2027.5004%2023.2514%2030.445%2023.3804%2031.8901C24.3482%2031.3095%2024.774%2032.3159%2024.8127%2032.6643C24.8514%2033.0127%2024.4256%2033.9417%2024.3482%2034.8708C24.2862%2035.614%2023.9353%2035.774%2023.7675%2035.7611C23.7675%2037.6191%2022.5675%2038.4321%2021.9869%2038.7417C21.4062%2039.0514%2020.5159%2039.9417%2019.6256%2040.2127C18.7353%2040.4837%2016.8385%2040.5224%2016.0256%2040.2127C15.2127%2039.903%2015.1353%2039.4385%2013.5482%2038.4321C12.2785%2037.6269%2012.0385%2036.445%2012.0772%2035.9546Z'%20fill='%23F0C087'/%3e%3cpath%20d='M16.5342%2049.0104L16.8051%2045.8362L18.6245%2045.6427L18.8568%2049.0104H16.5342Z'%20fill='%235B5D6E'/%3e%3cpath%20d='M17.6182%2046.2234C16.5963%2046.2543%2016.4182%2045.4105%2016.457%2044.9847L16.5344%2044.675L18.1989%2044.7137C18.4054%2044.4427%2018.8338%2044.0634%2018.8957%2044.7137C18.9731%2045.5266%2018.8957%2046.1847%2017.6182%2046.2234Z'%20fill='%23515262'/%3e%3cpath%20d='M12.3873%2040.8321L11.8066%2041.7224C12.5034%2043.2708%2013.9279%2046.3985%2014.0518%2046.5224C14.2066%2046.6772%2014.7099%2046.7546%2015.0195%2046.2901C15.2673%2045.9185%2016.8002%2044.9998%2017.5357%2044.5869C16.2324%2043.4127%2013.5331%2040.9869%2013.1615%2040.6772C12.7899%2040.3675%2012.4905%2040.6514%2012.3873%2040.8321Z'%20fill='%235B5D6E'/%3e%3cpath%20d='M22.7221%2040.7769L23.3027%2041.6692C22.606%2043.2209%2021.1814%2046.3555%2021.0576%2046.4796C20.9027%2046.6348%2020.3995%2046.7124%2020.0898%2046.2469C19.8421%2045.8744%2018.3092%2044.9537%2017.5737%2044.5399C18.8769%2043.3632%2021.5763%2040.9321%2021.9479%2040.6217C22.3195%2040.3114%2022.6189%2040.5959%2022.7221%2040.7769Z'%20fill='%235B5D6E'/%3e%3cmask%20id='mask1'%20style='mask-type:alpha'%20maskUnits='userSpaceOnUse'%20x='12'%20y='26'%20width='13'%20height='15'%3e%3cpath%20d='M12.0772%2035.9546V32.1224C12.1538%2031.503%2012.2609%2030.0708%2012.0772%2029.2966C11.8476%2028.3288%2013.1998%2027.9417%2014.9804%2027.2837C16.7611%2026.6256%2020.2062%2027.0127%2021.5998%2027.2837C22.7146%2027.5004%2023.2514%2030.445%2023.3804%2031.8901C24.3482%2031.3095%2024.774%2032.3159%2024.8127%2032.6643C24.8514%2033.0127%2024.4256%2033.9417%2024.3482%2034.8708C24.2862%2035.614%2023.9353%2035.774%2023.7675%2035.7611C23.7675%2037.6191%2022.5675%2038.4321%2021.9869%2038.7417C21.4062%2039.0514%2020.5159%2039.9417%2019.6256%2040.2127C18.7353%2040.4837%2016.8385%2040.5224%2016.0256%2040.2127C15.2127%2039.903%2015.1353%2039.4385%2013.5482%2038.4321C12.2785%2037.6269%2012.0385%2036.445%2012.0772%2035.9546Z'%20fill='%23F0C087'/%3e%3c/mask%3e%3cg%20mask='url(%23mask1)'%3e%3cpath%20d='M17.6122%2028.7933C20.3373%2028.4837%2021.5605%2027.6062%2021.8315%2027.2062C20.3089%2027.1288%2016.7915%2026.9585%2014.9025%2026.8966C13.0135%2026.8346%2012.1541%2027.9546%2011.9605%2028.5224C11.8702%2031.2062%2011.7437%2037.0927%2011.9605%2039.1675C12.1773%2041.2424%2015.8186%2040.7804%2017.6122%2040.2901C14.3605%2038.0837%2015.0573%2034.6772%2015.1347%2032.4708C15.2122%2030.2643%2014.2057%2029.1804%2017.6122%2028.7933Z'%20fill='%23ECB880'/%3e%3c/g%3e%3cpath%20d='M10.9547%2031.8901C11.4812%2031.3017%2011.9999%2031.7997%2012.1934%2032.1223V34.9868C12.1547%2035.232%2011.9612%2035.7223%2011.4967%2035.7223C10.916%2035.7223%2010.6838%2034.0191%2010.6063%2033.5159C10.5289%2033.0126%2010.2967%2032.6255%2010.9547%2031.8901Z'%20fill='%23F0C087'/%3e%3cpath%20d='M23.6901%2024.5001C23.2537%2023.6274%2022.0537%2023.7728%2021.5083%2023.9546C20.5992%2024.6819%2019.0796%2026.4602%2020.8251%2026.8965C22.5705%2027.3329%2023.3412%2030.513%2023.3412%2031.9675C23.7775%2031.5311%2024.5529%2031.991%2024.7347%2032.3546C24.7347%2031.4819%2024.9628%2030.3182%2025.3265%2029.9546C25.3265%2027.2273%2024.2356%2025.591%2023.6901%2024.5001Z'%20fill='%23785550'/%3e%3cpath%20d='M10.0546%2029.9546C9.61821%2025.1546%2012.0546%2023.5909%2013.3273%2023.4091C15.6908%2024.6818%2020.3086%2027.3364%2019.8722%2027.7728C19.3268%2028.3182%2016.5995%2027.7728%2015.5086%2027.7728C12.8904%2027.7728%2012.2359%2030.6818%2012.2359%2032.1364C11.7995%2031.7%2011.3268%2031.9546%2011.145%2032.1364C11.145%2030.8273%2010.418%2030.1364%2010.0546%2029.9546Z'%20fill='%235A4146'/%3e%3cpath%20d='M20.9626%2022.3182C18.3444%2021.0091%2014.0535%2022.1364%2012.2353%2022.8637L12.7808%2023.4091C11.4717%2025.1546%2011.5081%2027.0455%2011.6899%2027.7728C14.9626%2025.591%2017.1444%2027.7728%2019.3263%2027.7728C21.0717%2027.7728%2022.2353%2027.0455%2022.599%2026.6819C23.1444%2025.7728%2023.5808%2023.6273%2020.9626%2022.3182Z'%20fill='%23694B4B'/%3e%3cpath%20d='M5.38086%2043.9288L5.80667%2043.503C6.50344%2044.0965%208.11376%2045.5004%208.98086%2046.3675C9.84796%2047.2346%209.80667%2048.432%209.67763%2048.9223H5.38086V43.9288Z'%20fill='%235B5D6E'/%3e%3cpath%20d='M30%2043.9288L29.5773%2043.503C28.8855%2044.0965%2027.2869%2045.5004%2026.426%2046.3675C25.5652%2047.2346%2025.6062%2048.432%2025.7343%2048.9223H30V43.9288Z'%20fill='%235B5D6E'/%3e%3c/g%3e%3cdefs%3e%3cpattern%20id='pattern0'%20patternContentUnits='objectBoundingBox'%20width='1'%20height='1'%3e%3cuse%20xlink:href='%23image0'%20transform='scale(0.00057971)'/%3e%3c/pattern%3e%3cclipPath%20id='clip0'%3e%3crect%20x='6'%20y='18'%20width='24'%20height='30.5455'%20rx='0.774194'%20fill='white'/%3e%3c/clipPath%3e%3cimage%20id='image0'%20width='1725'%20height='1945'%20xlink:href='data:image/png;base64,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'/%3e%3c/defs%3e%3c/svg%3e", passportIcon = "data:image/svg+xml,%3csvg%20width='80'%20height='88'%20viewBox='0%200%2080%2088'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20filter='url(%23filter0_d_21_10294)'%3e%3cpath%20d='M10%206C10%204.89543%2010.8954%204%2012%204H63.1562C66.47%204%2069.1562%206.68629%2069.1562%2010V78.7193C69.1562%2082.033%2066.47%2084.7193%2063.1562%2084.7193H12C10.8954%2084.7193%2010%2083.8238%2010%2082.7193V6Z'%20fill='%2375231E'/%3e%3cpath%20d='M11%206C11%205.44772%2011.4477%205%2012%205H63.1562C65.9177%205%2068.1562%207.23858%2068.1562%2010V78.7193C68.1562%2081.4807%2065.9177%2083.7193%2063.1562%2083.7193H12C11.4477%2083.7193%2011%2083.2715%2011%2082.7193V6Z'%20stroke='white'%20stroke-opacity='0.5'%20stroke-width='2'/%3e%3c/g%3e%3cpath%20d='M39.5961%2050.6034C46.105%2050.6034%2051.3816%2045.6528%2051.3816%2039.5458C51.3816%2033.4389%2046.105%2028.4883%2039.5961%2028.4883C33.0871%2028.4883%2027.8105%2033.4389%2027.8105%2039.5458C27.8105%2045.6528%2033.0871%2050.6034%2039.5961%2050.6034Z'%20stroke='white'%20stroke-width='1.55056'%20stroke-miterlimit='10'/%3e%3cpath%20d='M28.4824%2035.8594H50.703'%20stroke='white'%20stroke-width='1.55056'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M28.4824%2043.2305H50.703'%20stroke='white'%20stroke-width='1.55056'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M39.5981%2050.3033C42.3102%2050.3033%2044.5088%2045.4867%2044.5088%2039.5452C44.5088%2033.6037%2042.3102%2028.7871%2039.5981%2028.7871C36.8861%2028.7871%2034.6875%2033.6037%2034.6875%2039.5452C34.6875%2045.4867%2036.8861%2050.3033%2039.5981%2050.3033Z'%20stroke='white'%20stroke-width='1.55056'%20stroke-miterlimit='10'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M33.6953%2068.8945C33.6953%2068.6184%2033.9192%2068.3945%2034.1953%2068.3945H44.8333C45.1095%2068.3945%2045.3333%2068.6184%2045.3333%2068.8945V70.3888C45.3333%2070.665%2045.1095%2070.8888%2044.8333%2070.8888H42.4066C42.1735%2070.8888%2041.9769%2070.7245%2041.8822%2070.5114C41.5082%2069.6701%2040.5833%2069.0748%2039.5015%2069.0748C38.4197%2069.0748%2037.4948%2069.6701%2037.1209%2070.5114C37.0262%2070.7245%2036.8295%2070.8888%2036.5964%2070.8888H34.1953C33.9192%2070.8888%2033.6953%2070.665%2033.6953%2070.3888V68.8945ZM37.1209%2072.1732C37.0262%2071.9602%2036.8295%2071.7958%2036.5964%2071.7958H34.1953C33.9192%2071.7958%2033.6953%2072.0197%2033.6953%2072.2958V73.7901C33.6953%2074.0663%2033.9192%2074.2901%2034.1953%2074.2901H44.8333C45.1095%2074.2901%2045.3333%2074.0663%2045.3333%2073.7901V72.2958C45.3333%2072.0197%2045.1095%2071.7958%2044.8333%2071.7958H42.4066C42.1735%2071.7958%2041.9769%2071.9602%2041.8822%2072.1732C41.5082%2073.0145%2040.5833%2073.6099%2039.5015%2073.6099C38.4197%2073.6099%2037.4948%2073.0145%2037.1209%2072.1732Z'%20fill='%23FFCC00'/%3e%3cellipse%20cx='39.515'%20cy='71.3438'%20rx='1.63214'%20ry='1.47461'%20fill='%23FFCC00'/%3e%3crect%20x='19.9609'%20y='14.4297'%20width='39.2318'%20height='3.66906'%20rx='1.03371'%20fill='%23E9E9EB'/%3e%3crect%20x='27.8047'%20y='57.9648'%20width='23.5391'%20height='3.66906'%20rx='1.03371'%20fill='%23E9E9EB'/%3e%3cdefs%3e%3cfilter%20id='filter0_d_21_10294'%20x='0'%20y='-4'%20width='79.1562'%20height='100.719'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'%20result='hardAlpha'/%3e%3cfeOffset%20dy='2'/%3e%3cfeGaussianBlur%20stdDeviation='5'/%3e%3cfeColorMatrix%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200.1%200'/%3e%3cfeBlend%20mode='normal'%20in2='BackgroundImageFix'%20result='effect1_dropShadow_21_10294'/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='effect1_dropShadow_21_10294'%20result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e", Header = qe.div`
  padding: 10px 10px 32px 10px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`, H1 = qe.h1`
  font-size: 28px;
  text-transform: none;
  font-weight: bold;
  line-height: 1.25;
  padding: 0 15px;

  @media only screen and (max-height: 480px) {
    font-size: 20px;
  }
`, Button$2 = qe.button`
  align-items: center;
  background: #20263d;
  border-radius: 15px;

  display: flex;
  margin-bottom: 22px;
  max-width: 300px;
  min-height: 116px;
  padding: 12px 30px;
  color: #ffffff;
  text-align: left;
  width: 100%;
  font-size: 18px;

  p {
    color: #ffffff;
    font-size: 18px;
    font-weight: 500;
    line-height: 26px;
    margin: 0;
  }

  img {
    margin-right: 20px;
  }
`, ButtonsContainer$1 = qe.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 50px;

  @media only screen and (max-height: 480px) {
    margin-top: 30px;
  }
`, blockname = "document-selector", DocumentSelector = ({
  goNext: me,
  onSourceChange: ue
}) => {
  const { t: Qe } = useTranslation(), Ue = useParams(), { client: He } = Ue, Ge = He == null ? void 0 : He.includes("aeromexico");
  function Xe(Ke) {
    Ke === "passport" && ue(Ke), me();
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(RootContainer, { cssSelector: "IncodeDocumentSelectorContainer", children: /* @__PURE__ */ jsxRuntimeExports.jsx("section", { className: blockname, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Header, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(H1, { children: Qe("documentSelector.title") }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonsContainer$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Button$2, { onClick: Xe, className: "IncodeIdCardButton", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: idIcon, alt: "id icon" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Trans,
          {
            t: Qe,
            i18nKey: ["BR", "PT"].includes("MX") ? "documentSelector.brazilianId" : "documentSelector.id"
          }
        ) })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Button$2,
        {
          onClick: () => Xe("passport"),
          className: "IncodeBookletButton",
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: passportIcon, alt: "passport icon" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              Trans,
              {
                t: Qe,
                i18nKey: Ge ? "documentSelector.onlyPassport" : "documentSelector.passport",
                children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Passport" })
              }
            ) })
          ]
        }
      )
    ] })
  ] }) }) });
}, DocumentSelectorSteps = {
  DocumentSelector: 0,
  FrontID: 1,
  BackID: 2
};
function Front(me) {
  const { onSuccess: ue, onError: Qe, token: Ue, ...He } = me, Ge = useRef();
  return useEffect(() => {
    renderCamera(me.type, Ge.current, {
      onSuccess: ue,
      onError: Qe,
      numberOfTries: -1,
      showTutorial: !0,
      disableFullScreen: !1,
      token: Ue,
      ...He
    });
  }, []), /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: Ge });
}
function Back(me) {
  const { onSuccess: ue, onError: Qe, token: Ue, ...He } = me, Ge = useRef();
  return useEffect(() => {
    renderCamera("back", Ge.current, {
      onSuccess: ue,
      onError: Qe,
      numberOfTries: -1,
      showTutorial: !0,
      disableFullScreen: !1,
      token: Ue,
      ...He
    });
  }, []), /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: Ge });
}
const DocumentSelectorOrchestrator = (me) => {
  const { setStep: ue, currentStep: Qe } = useSteps(() => DocumentSelectorSteps.DocumentSelector), [Ue, He] = useState("front"), Ge = (Xe) => {
    He(Xe);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Steps, { currentStep: Qe, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      DocumentSelector,
      {
        ...me,
        goNext: () => ue(DocumentSelectorSteps.FrontID),
        onSourceChange: Ge
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Front,
      {
        ...me,
        onSuccess: () => ue(DocumentSelectorSteps.BackID),
        type: Ue
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Back, { ...me })
  ] });
};
function renderDocumentSelector(me, {
  onSuccess: ue = emptyFunc,
  onError: Qe = emptyFunc,
  numberOfTries: Ue = 3,
  onLog: He = emptyFunc,
  permissionMessage: Ge,
  permissionBackgroundColor: Xe,
  token: Ke,
  timeout: $e = 4e4,
  sendBase64: Je = !0,
  documentType: Ze,
  showPreview: nt = !1,
  stream: tt,
  nativeCamera: et = !1,
  hideRetake: rt = !1,
  showTutorial: it = !1,
  showPaperDLTutorial: ot = !1,
  onlyCapture: at = !1,
  scanPdf417: st = !1,
  videoTutorialSrc: ut,
  showCustomCameraPermissionScreen: lt = !1,
  isSecondId: dt = !1,
  fullScreen: At = !0,
  assistedOnboarding: pt = !1,
  isRecordingEnabled: gt = !1,
  onRestartOnboarding: wt = reload,
  showDoublePermissionsRequest: Bt = !1,
  onlyAllowCapture: Tt = !1,
  disableFullScreen: yt = !1,
  onStreamReady: Ct = emptyFunc,
  showAutoCaptureIDOverlay: ht = !1,
  showManualCaptureIDOverlay: It = !1,
  skipProcessFace: vt = !1,
  defaultHorizontalMask: Et = !1,
  isFixedMask: bt = !1,
  blurrinessStrictMode: Rt = !1
}) {
  const St = Ke ?? state.token, kt = createRoot$1(me), jt = {
    onSuccess: handleUnmountRoot(ue, kt, me),
    onError: handleUnmountRoot(Qe, kt, me),
    onBoarding: this,
    numberOfTries: Ue,
    onLog: He,
    permissionMessage: Ge,
    permissionBackgroundColor: Xe,
    token: St,
    timeout: $e,
    sendBase64: Je,
    documentType: Ze,
    showPreview: nt,
    stream: tt,
    nativeCamera: et,
    hideRetake: rt,
    showTutorial: it,
    showPaperDLTutorial: ot,
    onlyCapture: at,
    scanPdf417: st,
    videoSrc: ut,
    showCustomCameraPermissionScreen: lt,
    isSecondId: dt,
    fullScreen: At,
    assistedOnboarding: pt,
    isRecordingEnabled: gt,
    onRestartOnboarding: wt,
    showDoublePermissionsRequest: Bt,
    onlyAllowCapture: Tt,
    disableFullScreen: yt,
    onStreamReady: Ct,
    showAutoCaptureIDOverlay: ht,
    showManualCaptureIDOverlay: It,
    skipProcessFace: vt,
    defaultHorizontalMask: Et,
    isFixedMask: bt,
    blurrinessStrictMode: Rt
  };
  customRender(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(DocumentSelectorOrchestrator, { ...jt }) }),
    me,
    kt
  );
}
const Document = "data:image/png;base64,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", TutorialContainer = qe.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  overflow: auto;
`, Title$4 = qe.h1`
  font-size: 1.6em;
  text-align: center;
  margin-bottom: 1em;
`, Subtitle$2 = qe.p`
  width: 70%;
  font-size: 1em;
  text-align: center;
  margin-top: 0;
  margin-bottom: 40px;
`, Image$2 = qe.img`
  height: 250px;
  margin-bottom: 50px;
`, TutorialAction = qe.div`
  margin-bottom: calc(var(--vw) * 15);
  min-height: 82px;
  min-width: 50px;
`, Button$1 = qe.button`
  text-transform: uppercase;
  padding: 20px;
  background-color: #3db0f7;
  min-width: 215px;
  height: 62px;
  border-radius: 31px;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  margin-top: 20px;
  line-height: 1.5px;
  border: none;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);

  &.hover {
    background-color: #3db0f7;
  }

  &.button-hidden {
    display: none;
  }
`;
function TutorialDocument({ onSuccess: me }) {
  const { t: ue } = useTranslation(), Qe = useRef();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(TutorialContainer, { ref: Qe, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Title$4, { children: ue("documentCapture.tutorialTitle") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Subtitle$2, { children: ue("documentCapture.tutorialSubTitle") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Image$2, { src: Document }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(TutorialAction, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { onClick: me, children: ue("common.continue") }) })
  ] });
}
function renderTutorialDocument(me, { onSuccess: ue }) {
  const Qe = createRoot$1(me), Ue = {
    onSuccess: handleUnmountRoot(ue, Qe, me),
    onBoarding: this
  };
  customRender(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(TutorialDocument, { ...Ue }) }),
    me,
    Qe
  );
}
const Container$1 = qe.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`, InputContainer$1 = qe.div`
  display: flex;
  border-bottom: 1px solid #1c1f28;
  width: 80%;
`, Input$2 = qe.input`
  border-top: 30px;
  background-color: transparent;
  border: none;
  font-size: 2em;
  width: 100%;
  font-weight: bold;
`, Button = qe(Button$a)`
  margin-top: 30px;
  text-transform: uppercase;
`, ErrorMessage = qe.span`
  position: absolute;
  text-align: center;
  width: 100%;
  bottom: 140px;
  font-size: 1.3em;
`, EmailHeader = qe.h2`
  margin-top: 30px;
  text-align: center;
`;
function getErrorTranslationKey(me) {
  return me === "Bad Request" ? "authorization.emailInvalid" : "phone.genericError";
}
function Email({ onSuccess: me, token: ue }) {
  const { t: Qe } = useTranslation(), [Ue, He] = useState(!0), [Ge, Xe] = useState(null), [Ke, $e] = useState(!1), [Je, Ze] = useState("");
  useModuleEvents({
    module: eventModuleNames.email,
    token: ue.token
  }), useScreenEvents({
    module: eventModuleNames.email,
    screen: eventScreenNames.emailInput,
    token: ue.token
  });
  const nt = async () => {
    if (Ke) return;
    const et = Je.trim();
    try {
      $e(!0), await addEmail({ email: et, token: ue.token }), addEvent({
        code: "continue",
        screen: eventScreenNames.emailInput,
        module: eventModuleNames.email,
        token: ue.token
      }), Xe(null), me();
    } catch (rt) {
      Xe(Qe(getErrorTranslationKey(rt.error))), $e(!1);
    }
  };
  function tt({ target: { value: et } }) {
    Ze(et);
    const rt = et.trim();
    rt && regex$1.EMAIL_PATTERN.test(rt) ? He(!1) : He(!0);
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Container$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(EmailHeader, { children: Qe("enterEmail") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(InputContainer$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Input$2, { value: Je, type: "email", onChange: (et) => tt(et) }) }),
    Ge && /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorMessage, { children: Ge }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { disabled: Ue || Ke, onClick: nt, children: Qe("common.continue") })
  ] });
}
const EmailSteps = {
  Email: 0,
  OTP: 1
};
function EmailOrchestrator(me) {
  const { setStep: ue, currentStep: Qe } = useSteps(() => EmailSteps.Email);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Steps, { currentStep: Qe, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Email,
      {
        ...me,
        onSuccess: () => me.otpVerification ? ue(EmailSteps.OTP) : me.onSuccess()
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      SMSOTP,
      {
        ...me,
        numberOfTries: 3,
        goBack: () => ue(EmailSteps.Email),
        isEmail: !0
      }
    )
  ] });
}
function renderEmail(me, {
  onSuccess: ue,
  onError: Qe,
  session: Ue,
  optinEnabled: He,
  optinCompanyName: Ge,
  otpVerification: Xe,
  onLog: Ke = emptyFunc
}) {
  const $e = createRoot(me), Je = {
    onBoarding: this,
    onLog: Ke,
    token: Ue,
    onSuccess: handleUnmountRoot(ue, $e, me),
    onError: handleUnmountRoot(Qe, $e, me),
    optinEnabled: He,
    optinCompanyName: Ge,
    otpVerification: Xe
  };
  $e.render(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { token: Ue.token, children: /* @__PURE__ */ jsxRuntimeExports.jsx(EmailOrchestrator, { ...Je }) })
  );
}
function _extends$2() {
  return _extends$2 = Object.assign ? Object.assign.bind() : function(me) {
    for (var ue = 1; ue < arguments.length; ue++) {
      var Qe = arguments[ue];
      for (var Ue in Qe)
        Object.prototype.hasOwnProperty.call(Qe, Ue) && (me[Ue] = Qe[Ue]);
    }
    return me;
  }, _extends$2.apply(this, arguments);
}
function _inheritsLoose(me, ue) {
  me.prototype = Object.create(ue.prototype), me.prototype.constructor = me, _setPrototypeOf$1(me, ue);
}
function hasClass(me, ue) {
  return me.classList ? !!ue && me.classList.contains(ue) : (" " + (me.className.baseVal || me.className) + " ").indexOf(" " + ue + " ") !== -1;
}
function addClass(me, ue) {
  me.classList ? me.classList.add(ue) : hasClass(me, ue) || (typeof me.className == "string" ? me.className = me.className + " " + ue : me.setAttribute("class", (me.className && me.className.baseVal || "") + " " + ue));
}
function replaceClassName(me, ue) {
  return me.replace(new RegExp("(^|\\s)" + ue + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function removeClass$1(me, ue) {
  me.classList ? me.classList.remove(ue) : typeof me.className == "string" ? me.className = replaceClassName(me.className, ue) : me.setAttribute("class", replaceClassName(me.className && me.className.baseVal || "", ue));
}
const config = {
  disabled: !1
};
var timeoutsShape = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null, classNamesShape = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;
const TransitionGroupContext = React__default.createContext(null);
var forceReflow = function(ue) {
  return ue.scrollTop;
}, UNMOUNTED = "unmounted", EXITED = "exited", ENTERING = "entering", ENTERED = "entered", EXITING = "exiting", Transition = /* @__PURE__ */ function(me) {
  _inheritsLoose(ue, me);
  function ue(Ue, He) {
    var Ge;
    Ge = me.call(this, Ue, He) || this;
    var Xe = He, Ke = Xe && !Xe.isMounting ? Ue.enter : Ue.appear, $e;
    return Ge.appearStatus = null, Ue.in ? Ke ? ($e = EXITED, Ge.appearStatus = ENTERING) : $e = ENTERED : Ue.unmountOnExit || Ue.mountOnEnter ? $e = UNMOUNTED : $e = EXITED, Ge.state = {
      status: $e
    }, Ge.nextCallback = null, Ge;
  }
  ue.getDerivedStateFromProps = function(He, Ge) {
    var Xe = He.in;
    return Xe && Ge.status === UNMOUNTED ? {
      status: EXITED
    } : null;
  };
  var Qe = ue.prototype;
  return Qe.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, Qe.componentDidUpdate = function(He) {
    var Ge = null;
    if (He !== this.props) {
      var Xe = this.state.status;
      this.props.in ? Xe !== ENTERING && Xe !== ENTERED && (Ge = ENTERING) : (Xe === ENTERING || Xe === ENTERED) && (Ge = EXITING);
    }
    this.updateStatus(!1, Ge);
  }, Qe.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, Qe.getTimeouts = function() {
    var He = this.props.timeout, Ge, Xe, Ke;
    return Ge = Xe = Ke = He, He != null && typeof He != "number" && (Ge = He.exit, Xe = He.enter, Ke = He.appear !== void 0 ? He.appear : Xe), {
      exit: Ge,
      enter: Xe,
      appear: Ke
    };
  }, Qe.updateStatus = function(He, Ge) {
    if (He === void 0 && (He = !1), Ge !== null)
      if (this.cancelNextCallback(), Ge === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var Xe = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
          Xe && forceReflow(Xe);
        }
        this.performEnter(He);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === EXITED && this.setState({
      status: UNMOUNTED
    });
  }, Qe.performEnter = function(He) {
    var Ge = this, Xe = this.props.enter, Ke = this.context ? this.context.isMounting : He, $e = this.props.nodeRef ? [Ke] : [ReactDOM__default.findDOMNode(this), Ke], Je = $e[0], Ze = $e[1], nt = this.getTimeouts(), tt = Ke ? nt.appear : nt.enter;
    if (!He && !Xe || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function() {
        Ge.props.onEntered(Je);
      });
      return;
    }
    this.props.onEnter(Je, Ze), this.safeSetState({
      status: ENTERING
    }, function() {
      Ge.props.onEntering(Je, Ze), Ge.onTransitionEnd(tt, function() {
        Ge.safeSetState({
          status: ENTERED
        }, function() {
          Ge.props.onEntered(Je, Ze);
        });
      });
    });
  }, Qe.performExit = function() {
    var He = this, Ge = this.props.exit, Xe = this.getTimeouts(), Ke = this.props.nodeRef ? void 0 : ReactDOM__default.findDOMNode(this);
    if (!Ge || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function() {
        He.props.onExited(Ke);
      });
      return;
    }
    this.props.onExit(Ke), this.safeSetState({
      status: EXITING
    }, function() {
      He.props.onExiting(Ke), He.onTransitionEnd(Xe.exit, function() {
        He.safeSetState({
          status: EXITED
        }, function() {
          He.props.onExited(Ke);
        });
      });
    });
  }, Qe.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, Qe.safeSetState = function(He, Ge) {
    Ge = this.setNextCallback(Ge), this.setState(He, Ge);
  }, Qe.setNextCallback = function(He) {
    var Ge = this, Xe = !0;
    return this.nextCallback = function(Ke) {
      Xe && (Xe = !1, Ge.nextCallback = null, He(Ke));
    }, this.nextCallback.cancel = function() {
      Xe = !1;
    }, this.nextCallback;
  }, Qe.onTransitionEnd = function(He, Ge) {
    this.setNextCallback(Ge);
    var Xe = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this), Ke = He == null && !this.props.addEndListener;
    if (!Xe || Ke) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var $e = this.props.nodeRef ? [this.nextCallback] : [Xe, this.nextCallback], Je = $e[0], Ze = $e[1];
      this.props.addEndListener(Je, Ze);
    }
    He != null && setTimeout(this.nextCallback, He);
  }, Qe.render = function() {
    var He = this.state.status;
    if (He === UNMOUNTED)
      return null;
    var Ge = this.props, Xe = Ge.children;
    Ge.in, Ge.mountOnEnter, Ge.unmountOnExit, Ge.appear, Ge.enter, Ge.exit, Ge.timeout, Ge.addEndListener, Ge.onEnter, Ge.onEntering, Ge.onEntered, Ge.onExit, Ge.onExiting, Ge.onExited, Ge.nodeRef;
    var Ke = _objectWithoutPropertiesLoose(Ge, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof Xe == "function" ? Xe(He, Ke) : React__default.cloneElement(React__default.Children.only(Xe), Ke))
    );
  }, ue;
}(React__default.Component);
Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element > "u" ? PropTypes.any : function(me, ue, Qe, Ue, He, Ge) {
      var Xe = me[ue];
      return PropTypes.instanceOf(Xe && "ownerDocument" in Xe ? Xe.ownerDocument.defaultView.Element : Element)(me, ue, Qe, Ue, He, Ge);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(ue) {
    var Qe = timeoutsShape;
    ue.addEndListener || (Qe = Qe.isRequired);
    for (var Ue = arguments.length, He = new Array(Ue > 1 ? Ue - 1 : 0), Ge = 1; Ge < Ue; Ge++)
      He[Ge - 1] = arguments[Ge];
    return Qe.apply(void 0, [ue].concat(He));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};
function noop() {
}
Transition.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var _addClass = function(ue, Qe) {
  return ue && Qe && Qe.split(" ").forEach(function(Ue) {
    return addClass(ue, Ue);
  });
}, removeClass = function(ue, Qe) {
  return ue && Qe && Qe.split(" ").forEach(function(Ue) {
    return removeClass$1(ue, Ue);
  });
}, CSSTransition = /* @__PURE__ */ function(me) {
  _inheritsLoose(ue, me);
  function ue() {
    for (var Ue, He = arguments.length, Ge = new Array(He), Xe = 0; Xe < He; Xe++)
      Ge[Xe] = arguments[Xe];
    return Ue = me.call.apply(me, [this].concat(Ge)) || this, Ue.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    }, Ue.onEnter = function(Ke, $e) {
      var Je = Ue.resolveArguments(Ke, $e), Ze = Je[0], nt = Je[1];
      Ue.removeClasses(Ze, "exit"), Ue.addClass(Ze, nt ? "appear" : "enter", "base"), Ue.props.onEnter && Ue.props.onEnter(Ke, $e);
    }, Ue.onEntering = function(Ke, $e) {
      var Je = Ue.resolveArguments(Ke, $e), Ze = Je[0], nt = Je[1], tt = nt ? "appear" : "enter";
      Ue.addClass(Ze, tt, "active"), Ue.props.onEntering && Ue.props.onEntering(Ke, $e);
    }, Ue.onEntered = function(Ke, $e) {
      var Je = Ue.resolveArguments(Ke, $e), Ze = Je[0], nt = Je[1], tt = nt ? "appear" : "enter";
      Ue.removeClasses(Ze, tt), Ue.addClass(Ze, tt, "done"), Ue.props.onEntered && Ue.props.onEntered(Ke, $e);
    }, Ue.onExit = function(Ke) {
      var $e = Ue.resolveArguments(Ke), Je = $e[0];
      Ue.removeClasses(Je, "appear"), Ue.removeClasses(Je, "enter"), Ue.addClass(Je, "exit", "base"), Ue.props.onExit && Ue.props.onExit(Ke);
    }, Ue.onExiting = function(Ke) {
      var $e = Ue.resolveArguments(Ke), Je = $e[0];
      Ue.addClass(Je, "exit", "active"), Ue.props.onExiting && Ue.props.onExiting(Ke);
    }, Ue.onExited = function(Ke) {
      var $e = Ue.resolveArguments(Ke), Je = $e[0];
      Ue.removeClasses(Je, "exit"), Ue.addClass(Je, "exit", "done"), Ue.props.onExited && Ue.props.onExited(Ke);
    }, Ue.resolveArguments = function(Ke, $e) {
      return Ue.props.nodeRef ? [Ue.props.nodeRef.current, Ke] : [Ke, $e];
    }, Ue.getClassNames = function(Ke) {
      var $e = Ue.props.classNames, Je = typeof $e == "string", Ze = Je && $e ? $e + "-" : "", nt = Je ? "" + Ze + Ke : $e[Ke], tt = Je ? nt + "-active" : $e[Ke + "Active"], et = Je ? nt + "-done" : $e[Ke + "Done"];
      return {
        baseClassName: nt,
        activeClassName: tt,
        doneClassName: et
      };
    }, Ue;
  }
  var Qe = ue.prototype;
  return Qe.addClass = function(He, Ge, Xe) {
    var Ke = this.getClassNames(Ge)[Xe + "ClassName"], $e = this.getClassNames("enter"), Je = $e.doneClassName;
    Ge === "appear" && Xe === "done" && Je && (Ke += " " + Je), Xe === "active" && He && forceReflow(He), Ke && (this.appliedClasses[Ge][Xe] = Ke, _addClass(He, Ke));
  }, Qe.removeClasses = function(He, Ge) {
    var Xe = this.appliedClasses[Ge], Ke = Xe.base, $e = Xe.active, Je = Xe.done;
    this.appliedClasses[Ge] = {}, Ke && removeClass(He, Ke), $e && removeClass(He, $e), Je && removeClass(He, Je);
  }, Qe.render = function() {
    var He = this.props;
    He.classNames;
    var Ge = _objectWithoutPropertiesLoose(He, ["classNames"]);
    return /* @__PURE__ */ React__default.createElement(Transition, _extends$2({}, Ge, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  }, ue;
}(React__default.Component);
CSSTransition.defaultProps = {
  classNames: ""
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends$2({}, Transition.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var _leaveRenders, _enterRenders;
function areChildrenDifferent(me, ue) {
  return !(me === ue || React__default.isValidElement(me) && React__default.isValidElement(ue) && me.key != null && me.key === ue.key);
}
var modes = {
  out: "out-in",
  in: "in-out"
}, callHook = function(ue, Qe, Ue) {
  return function() {
    var He;
    ue.props[Qe] && (He = ue.props)[Qe].apply(He, arguments), Ue();
  };
}, leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function(me) {
  var ue = me.current, Qe = me.changeState;
  return React__default.cloneElement(ue, {
    in: !1,
    onExited: callHook(ue, "onExited", function() {
      Qe(ENTERING, null);
    })
  });
}, _leaveRenders[modes.in] = function(me) {
  var ue = me.current, Qe = me.changeState, Ue = me.children;
  return [ue, React__default.cloneElement(Ue, {
    in: !0,
    onEntered: callHook(Ue, "onEntered", function() {
      Qe(ENTERING);
    })
  })];
}, _leaveRenders), enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function(me) {
  var ue = me.children, Qe = me.changeState;
  return React__default.cloneElement(ue, {
    in: !0,
    onEntered: callHook(ue, "onEntered", function() {
      Qe(ENTERED, React__default.cloneElement(ue, {
        in: !0
      }));
    })
  });
}, _enterRenders[modes.in] = function(me) {
  var ue = me.current, Qe = me.children, Ue = me.changeState;
  return [React__default.cloneElement(ue, {
    in: !1,
    onExited: callHook(ue, "onExited", function() {
      Ue(ENTERED, React__default.cloneElement(Qe, {
        in: !0
      }));
    })
  }), React__default.cloneElement(Qe, {
    in: !0
  })];
}, _enterRenders), SwitchTransition = /* @__PURE__ */ function(me) {
  _inheritsLoose(ue, me);
  function ue() {
    for (var Ue, He = arguments.length, Ge = new Array(He), Xe = 0; Xe < He; Xe++)
      Ge[Xe] = arguments[Xe];
    return Ue = me.call.apply(me, [this].concat(Ge)) || this, Ue.state = {
      status: ENTERED,
      current: null
    }, Ue.appeared = !1, Ue.changeState = function(Ke, $e) {
      $e === void 0 && ($e = Ue.state.current), Ue.setState({
        status: Ke,
        current: $e
      });
    }, Ue;
  }
  var Qe = ue.prototype;
  return Qe.componentDidMount = function() {
    this.appeared = !0;
  }, ue.getDerivedStateFromProps = function(He, Ge) {
    return He.children == null ? {
      current: null
    } : Ge.status === ENTERING && He.mode === modes.in ? {
      status: ENTERING
    } : Ge.current && areChildrenDifferent(Ge.current, He.children) ? {
      status: EXITING
    } : {
      current: React__default.cloneElement(He.children, {
        in: !0
      })
    };
  }, Qe.render = function() {
    var He = this.props, Ge = He.children, Xe = He.mode, Ke = this.state, $e = Ke.status, Je = Ke.current, Ze = {
      children: Ge,
      current: Je,
      changeState: this.changeState,
      status: $e
    }, nt;
    switch ($e) {
      case ENTERING:
        nt = enterRenders[Xe](Ze);
        break;
      case EXITING:
        nt = leaveRenders[Xe](Ze);
        break;
      case ENTERED:
        nt = Je;
    }
    return /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
      value: {
        isMounting: !this.appeared
      }
    }, nt);
  }, ue;
}(React__default.Component);
SwitchTransition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Transition modes.
   * `out-in`: Current element transitions out first, then when complete, the new element transitions in.
   * `in-out`: New element transitions in first, then when complete, the current element transitions out.
   *
   * @type {'out-in'|'in-out'}
   */
  mode: PropTypes.oneOf([modes.in, modes.out]),
  /**
   * Any `Transition` or `CSSTransition` component.
   */
  children: PropTypes.oneOfType([PropTypes.element.isRequired])
} : {};
SwitchTransition.defaultProps = {
  mode: modes.out
};
const success = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='36'%20height='28'%20viewBox='0%200%2036%2028'%3e%3cpath%20fill='%230cd5a2'%20fill-rule='nonzero'%20d='M35.35%203.865L32.19.66c-.433-.44-.96-.66-1.579-.66-.62%200-1.146.22-1.58.66L13.796%2016.145%206.968%209.192c-.434-.44-.96-.66-1.58-.66-.619%200-1.145.22-1.579.66L.65%2012.397C.217%2012.837%200%2013.372%200%2014s.217%201.163.65%201.603l8.408%208.532%203.159%203.205c.433.44.96.66%201.58.66.618%200%201.145-.22%201.578-.66l3.16-3.205L35.35%207.07A2.2%202.2%200%200%200%2036%205.468c0-.628-.217-1.163-.65-1.603z'/%3e%3c/svg%3e", denied = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%3e%3cpath%20fill='%23F94C6A'%20fill-rule='nonzero'%20d='M23.326%2016l7.92-7.92A2.492%202.492%200%200%200%2032%206.25c0-.72-.252-1.33-.754-1.832L27.583.754A2.494%202.494%200%200%200%2025.75%200c-.718%200-1.329.251-1.832.754L16%208.674%208.08.753A2.493%202.493%200%200%200%206.25%200C5.53%200%204.92.251%204.417.754L.754%204.418A2.494%202.494%200%200%200%200%206.249c0%20.719.251%201.33.754%201.832L8.674%2016l-7.92%207.918A2.495%202.495%200%200%200%200%2025.751c0%20.718.251%201.329.754%201.832l3.664%203.663A2.493%202.493%200%200%200%206.249%2032c.719%200%201.33-.252%201.832-.754l7.92-7.92%207.919%207.92a2.492%202.492%200%200%200%201.832.754c.718%200%201.329-.252%201.831-.754l3.663-3.663A2.492%202.492%200%200%200%2032%2025.75c0-.718-.251-1.329-.754-1.832L23.326%2016z'/%3e%3c/svg%3e", user = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='26'%20height='24'%20viewBox='0%200%2026%2024'%3e%3cpath%20fill='%23FF637B'%20fill-rule='nonzero'%20stroke='%23FFF'%20d='M23.006%2017.768l-3.822-1.876a1.032%201.032%200%200%201-.584-.93v-1.327c.092-.11.188-.236.288-.374a8.932%208.932%200%200%200%201.181-2.278c.565-.254.931-.802.931-1.421V7.99a1.55%201.55%200%200%200-.4-1.03V4.87c.022-.216.11-1.503-.837-2.564C18.942%201.386%2017.608.92%2015.8.92c-1.808%200-3.142.467-3.963%201.387a3.38%203.38%200%200%200-.826%201.888c-.685-.349-1.493-.525-2.411-.525-4.156%200-4.398%203.479-4.4%203.536v1.799c-.26.277-.4.597-.4.915v1.357c0%20.424.193.819.524%201.086.33%201.222%201.142%202.145%201.458%202.47v1.077c0%20.31-.171.593-.468.752l-2.662%201.64A3.105%203.105%200%200%200%201%2021.035v1.491h24v-1.588a3.52%203.52%200%200%200-1.994-3.17zM6.6%2020.861v.88H1.8v-.706c0-.853.474-1.636%201.256-2.056l2.661-1.64c.533-.285.865-.833.865-1.43v-1.41l-.128-.118c-.01-.009-1.073-.995-1.387-2.339l-.036-.156-.137-.086a.622.622%200%200%201-.294-.524V9.919c0-.141.098-.31.268-.461L5%209.34V7.228c.006-.113.215-2.773%203.6-2.773.957%200%201.763.217%202.4.646v1.858a1.55%201.55%200%200%200-.4%201.031v1.572c0%20.12.014.237.04.35.011.046.033.088.048.132.022.066.04.134.07.196l.001.002c.103.208.252.393.44.541l.006.022c.024.09.05.179.077.267l.032.102.018.055.042.126c.024.069.05.14.079.217.012.032.026.061.039.093.032.082.065.162.1.24.008.02.015.04.024.058l.022.05.032.065c.039.084.077.166.117.244l.019.039c.025.05.05.095.076.143a8.52%208.52%200%200%200%20.355.604l.034.053c.097.148.18.267.25.36l.05.067.029.038v1.3c0%20.38-.212.73-.551.911l-1.059.567-.184-.016-.075.155-2.25%201.206A3.535%203.535%200%200%200%206.6%2020.861zm17.6.88H7.4v-.88c0-1.01.56-1.938%201.464-2.421l3.568-1.912a1.82%201.82%200%200%200%20.968-1.602v-1.578l-.078-.092-.015-.017c0-.002-.025-.031-.066-.083l-.007-.01a3.739%203.739%200%200%201-.075-.098l-.001-.002a7.132%207.132%200%200%201-.218-.314l-.005-.009c-.04-.06-.081-.125-.123-.195l-.01-.016a7.886%207.886%200%200%201-.434-.82l-.02-.045-.067-.154-.024-.059c-.02-.051-.042-.103-.064-.162a6.407%206.407%200%200%201-.116-.334l-.022-.07-.008-.024a6.06%206.06%200%200%201-.104-.381l-.036-.156-.137-.086a.78.78%200%200%201-.37-.66v-1.57a.77.77%200%200%201%20.268-.58l.132-.117V4.708l-.01-.008c-.014-.283.003-1.153.648-1.876.663-.743%201.794-1.12%203.362-1.12%201.562%200%202.69.374%203.354%201.112.78.864.65%201.97.65%201.98L19.8%207.294l.132.117a.768.768%200%200%201%20.268.58v1.57a.783.783%200%200%201-.569.747l-.199.06-.064.195a8.167%208.167%200%200%201-1.134%202.244%205.183%205.183%200%200%201-.334.424l-.1.111v1.62c0%20.696.393%201.321%201.026%201.632l3.822%201.877a2.738%202.738%200%200%201%201.552%202.467v.802z'/%3e%3c/svg%3e", facePlaceholder = "data:image/png;base64,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", matchFail = "data:image/svg+xml,%3csvg%20width='25'%20height='24'%20viewBox='0%200%2025%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='12.5'%20cy='12'%20r='12'%20fill='%23FF5C6F'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M16.7975%209.11921C17.188%208.72869%2017.188%208.09552%2016.7975%207.705C16.407%207.31448%2015.7738%207.31448%2015.3833%207.705L12.5022%2010.5861L9.62117%207.705C9.23065%207.31448%208.59748%207.31448%208.20696%207.705C7.81643%208.09552%207.81643%208.72869%208.20695%209.11921L11.088%2012.0003L8.20695%2014.8814C7.81643%2015.2719%207.81643%2015.9051%208.20696%2016.2956C8.59748%2016.6861%209.23065%2016.6861%209.62117%2016.2956L12.5022%2013.4145L15.3833%2016.2956C15.7738%2016.6861%2016.407%2016.6861%2016.7975%2016.2956C17.188%2015.9051%2017.188%2015.2719%2016.7975%2014.8814L13.9164%2012.0003L16.7975%209.11921Z'%20fill='white'/%3e%3c/svg%3e", matchSuccess = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='12'%20cy='12'%20r='12'%20fill='%230CD5A2'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M16.7399%209.32733C17.1114%209.73599%2017.0813%2010.3684%2016.6727%2010.7399L10.4671%2016.3814L7.29289%2013.2071C6.90237%2012.8166%206.90237%2012.1834%207.29289%2011.7929C7.68342%2011.4024%208.31658%2011.4024%208.70711%2011.7929L10.5329%2013.6187L15.3273%209.26007C15.736%208.88856%2016.3684%208.91868%2016.7399%209.32733Z'%20fill='white'/%3e%3c/svg%3e", MatchUserContainer = qe.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`, BodyContainer = qe.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`, Title$3 = qe.h1`
  text-align: center;

  &.fade-enter {
    opacity: 0;
  }

  &.fade-enter-active {
    opacity: 1;
    transition: opacity 300ms cubic-bezier(0.55, 0.085, 0.68, 0.53);
  }

  &.fade-exit {
    opacity: 1;
  }

  &.fade-exit-active {
    opacity: 0;
    transition: opacity 200ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  @media only screen and (max-height: 480px) {
    margin: 0;
  }
`, CirclesContainer = qe.div`
  height: 225px;
  width: 100%;
  position: relative;
  margin-bottom: 20px;

  @media only screen and (max-height: 480px) {
    margin-bottom: 0;
  }
`, appear = We`
  to {
    visibility: visible;
  }
`, MessageContainer$1 = qe.div`
  animation: ${appear} 0s 2s forwards;
  visibility: hidden;
  background-color: #21273b;
  padding: 20px;
  border-radius: 10px;
  color: white;
  min-width: 192px;
  vertical-align: middle;
  display: flex;
  align-items: center;
  position: relative;
  top: 20px;

  @media only screen and (max-height: 480px) {
    top: 40px;
  }
`, UserIcon = qe.img`
  margin-right: 10px;
`, Span = qe.span``, RedDot = qe.div`
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background-color: #ff637b;
  position: absolute;
  right: 10px;
  top: 10px;
`, ArrowDown = qe.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #21273b;
  bottom: -9px;
  width: 0;
  height: 0;
`, LivenessStripe = qe.div`
  height: 60px;
  width: 100%;
  font-weight: bold;
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(me) => me.liveness ? "rgba(14, 83, 65, 1)" : "rgba(74, 9, 17, 1)"};

  img {
    margin-right: 10px;
  }
`, disappear1 = We`
  0% {
    left: 36px;
    opacity: 1;
  }

  100% {
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
  }
`, disappear2 = We`
  0% {
    left: calc(100% - 36px);
    opacity: 1;
  }

  100% {
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
  }
`, LabelContainer = qe.div`
  font-size: 1rem;
  position: absolute;
  text-align: center;
  border-radius: 10px;
  background-color: #20263d;
  color: white;
  animation: ${(me) => me.coolId ? disappear1 : disappear2} 1.2s
    ease-in-out 0.8s forwards;
  opacity: 0;
  left: 50%;
  transform: translateX(-50%);

  p {
    font-size: 0.9rem;
    width: 100%;
    color: #fff;
    position: absolute;
    font-weight: bold;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin-top: -3px;
  }
`, Circle = qe.div`
  position: absolute;
  border-radius: 100%;
  overflow: hidden;
  width: 169px;
  height: 169px;
  border: 2.6px solid #fff;
  top: 50px;
  animation: ${(me) => me.coolId ? circle1 : circle2} 1.2s ease-in-out
    0.8s forwards;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
`, disappearSecondLabel = We`
  0% {
    top: calc(100% - 136px);
    opacity: 1;
  }

  100% {
    top: 24%;
    transform: translateY(0%);
    opacity: 0;
  }
`, LabelContainerSecondId = qe.div`
  border-radius: 10px;
  position: absolute;
  text-align: center;
  background-color: #20263d;
  color: white;
  animation: ${disappearSecondLabel} 1.2s ease-in-out 0.8s forwards;
  opacity: 0;
  left: 38%;
  transform: translateY(100%);

  p {
    font-size: 0.9rem;
    width: 100%;
    position: absolute;
    font-weight: bold;
    top: 27%;
    color: #ffffff;
    //transform: translate(150%, 150%);
    margin-top: -3px;
  }
`, circleSecondId = We`
 0% {
    bottom: 36px;
    opacity: 1;
  }

  100% {
    top: 60%;
    transform: translateY(-50%);
    opacity: 0.8;
    left: calc(50% - 84.5px);
  }
`, CircleSecond = qe.div`
  position: absolute;
  border-radius: 100%;
  overflow: hidden;
  width: 169px;
  height: 169px;
  border: 2.6px solid #fff;
  top: 50px;
  left: 50%;
  animation: ${circleSecondId} 1.2s ease-in-out 0.8s forwards;
  top: 100%;
  transform: translateX(-50%);
  opacity: 0;
`, circle1 = We`
  0% {
    left: 36px;
    opacity: 1;
  }

  100% {
    left: 50%;
    transform: translateX(-50%);
    opacity: 0.8;
  }
`, circle2 = We`
  0% {
    left: calc(100% - 36px);
    opacity: 1;
  }

  90% {
    opacity: 0.7;
  }

  100% {
    left: 50%;
    transform: translateX(-50%);
    opacity: 1;
  }
`, checkAnimation = We`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`, CircleThreeContainer = qe(Circle)`
  opacity: 0;
  background-color: rgba(0, 0, 0, 0.6);
  width: 169px;
  height: 169px;
  left: 50%;
  transform: translateX(-50%);
  animation: ${checkAnimation} 0.9s ease-out 2s forwards;

  &.matched {
    background-color: rgba(6, 134, 80, 0.6);
  }
`, CircleThreeImage = qe.img`
  &.check {
    width: 36px;
    height: 28px;
    margin: 68px auto 0 auto;
    display: block;
  }

  &.notCheck {
    width: 28px;
    height: 28px;
    margin: 68px auto 0 auto;
    display: block;
  }
`, continueButtonAnimation = We`
  0% {
    pointer-events: none
    opacity:0;
  }

  100% {
    pointer-events: auto;
    opacity:1;
  }
`, ContainerContinueButton = qe.div`
  min-height: 60px;
  width: 100%;
  text-align: center;

  button {
    opacity: 0;
    animation: ${continueButtonAnimation} 0.9s ease-out 2s forwards;
  }
`, BoxWithTooltip = qe.div`
  position: relative;
  background-color: #20263d;
  height: 40px;
  width: 100px;
  border-radius: 10px;

  :after,
  :before {
    top: 90%;
    left: 50%;
    border: solid transparent;
    content: '';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  :after {
    border-color: rgba(136, 183, 213, 0);
    border-top-color: #20263d;
    border-width: 15px;
    margin-left: -15px;
  }

  :before {
    border-width: 40px;
    margin-left: -40px;
  }
`, CircleOne = ({ croppedIdFace: me, isSecondId: ue }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs(LabelContainer, { coolId: !0, "aria-hidden": !0, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithTooltip, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: ue ? "First Id" : "ID" })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    Circle,
    {
      coolId: !0,
      style: {
        background: me ? `url(data:image/jpg;base64,${me}) left center no-repeat` : `url(${facePlaceholder}) left center no-repeat`,
        backgroundSize: "cover"
      }
    }
  )
] }), CircleTwo = ({ croppedFace: me, isSecondId: ue, faceMatch: Qe }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs(LabelContainer, { "aria-hidden": !0, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithTooltip, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: ue ? "Second Id" : "Selfie" })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    Circle,
    {
      role: "img",
      alt: Qe ? "matched" : "not matched",
      style: {
        background: me ? `url(data:image/jpg;base64,${me}) center center no-repeat` : `url(${facePlaceholder}) left center no-repeat`,
        backgroundSize: "cover"
      }
    }
  )
] }), CircleSecondId = ({ croppedFace: me }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs(LabelContainerSecondId, { "aria-hidden": !0, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithTooltip, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Selfie" })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    CircleSecond,
    {
      style: {
        background: me ? `url(data:image/jpg;base64,${me}) center center no-repeat` : `url(${facePlaceholder}) left center no-repeat`,
        backgroundSize: "cover"
      }
    }
  )
] }), CircleThree = ({ faceMatch: me }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  CircleThreeContainer,
  {
    className: classNames({
      circle: !0,
      matched: me
    }),
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      CircleThreeImage,
      {
        src: me ? success : denied,
        className: me ? "check" : "notCheck",
        alt: "",
        "aria-expanded": !0
      }
    )
  }
), Message$1 = () => {
  const { t: me } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(MessageContainer$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(UserIcon, { src: user, alt: "", "aria-hidden": !0 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Span, { children: me("matchUser.alreadyExists") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(RedDot, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowDown, {})
  ] });
}, FaceMatch = ({
  onSuccess: me,
  onBoarding: ue,
  token: Qe,
  existingUser: Ue,
  isSecondId: He
}) => {
  const { t: Ge } = useTranslation(), [Xe, Ke] = useState(null), [$e, Je] = useState(null), [Ze, nt] = useState(null), [tt, et] = useState(null), [rt, it] = useState(!0), [ot, at] = useState(null), [st, ut] = useState(Ge("matchUser.matching"));
  useModuleEvents({ module: eventModuleNames.faceMatch, token: Qe.token }), useScreenEvents({
    module: eventModuleNames.faceMatch,
    screen: eventScreenNames.faceMatch,
    token: Qe.token
  }), useEffect(() => {
    if (!rt) {
      const pt = setTimeout(() => {
        ut(
          Ge(tt ? "matchUser.matched" : "matchUser.facesNoMatch")
        );
      }, 2e3);
      return () => {
        clearTimeout(pt);
      };
    }
  }, [tt, rt, Ge]), useEffect(() => {
    const pt = [
      ue.getImages({
        token: Qe.token,
        body: { images: ["croppedFace", "croppedIDFace"] }
      }),
      ue.getScore({ token: Qe.token })
    ];
    He && pt.push(
      ue.getSecondIdImages({
        token: Qe.token,
        body: { images: ["croppedIDFace"] },
        secondId: !0
      })
    ), Promise.all(pt).then(([gt, wt, Bt]) => {
      var Tt, yt, Ct, ht;
      et(((yt = (Tt = wt == null ? void 0 : wt.faceRecognition) == null ? void 0 : Tt.overall) == null ? void 0 : yt.status) === "OK"), Ke(gt.croppedFace), Je(gt.croppedIDFace), at(((ht = (Ct = wt == null ? void 0 : wt.liveness) == null ? void 0 : Ct.overall) == null ? void 0 : ht.status) === "OK"), Bt && nt(Bt.croppedIDFace), it(!1);
    });
  }, [ue, Qe.token, He]);
  function lt() {
    ue.addEvent({
      token: Qe.token,
      code: "continue"
    }), me();
  }
  const dt = Ge(ot ? "matchUser.livenessSuccess" : "matchUser.livenessFailed"), At = "IncodeMatchUser";
  return rt ? /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$6, {}) : /* @__PURE__ */ jsxRuntimeExports.jsxs(MatchUserContainer, { className: `${At}Container`, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      BodyContainer,
      {
        className: `${At}BodyContainer`,
        "aria-live": "polite",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(SwitchTransition, { mode: "out-in", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            CSSTransition,
            {
              classNames: "fade",
              addEndListener: (pt, gt) => {
                pt.addEventListener("transitionend", gt, !1);
              },
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(Title$3, { className: `${At}Title`, children: st })
            },
            st
          ) }),
          Ue && /* @__PURE__ */ jsxRuntimeExports.jsx(Message$1, { className: `${At}Message` }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(CirclesContainer, { className: `${At}CirclesContainer`, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              CircleOne,
              {
                isSecondId: He,
                croppedIdFace: $e,
                className: `${At}IDFace`
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              CircleTwo,
              {
                isSecondId: He,
                croppedFace: He ? Ze : Xe,
                className: `${At}Face`,
                faceMatch: tt
              }
            ),
            He ? /* @__PURE__ */ jsxRuntimeExports.jsx(
              CircleSecondId,
              {
                croppedFace: Xe,
                className: `${At}IDSecondFace`
              }
            ) : null,
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              CircleThree,
              {
                faceMatch: tt,
                className: `${At}FaceMatch`
              }
            )
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            ContainerContinueButton,
            {
              className: `${At}ContainerContinueButton`,
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                Button$a,
                {
                  onClick: lt,
                  className: `${At}ContinueButton`,
                  children: Ge("matchUser.continue")
                }
              )
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      LivenessStripe,
      {
        liveness: ot,
        className: `${At}LivenessStripe`,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "img",
            {
              src: ot ? matchSuccess : matchFail,
              alt: "",
              className: `${At}LivenessImage`
            }
          ),
          dt
        ]
      }
    )
  ] });
};
function renderFaceMatch(me, { token: ue, onSuccess: Qe, liveness: Ue, existingUser: He, isSecondId: Ge }) {
  const Xe = createRoot$1(me), Ke = {
    onSuccess: handleUnmountRoot(Qe, Xe, me),
    token: ue,
    liveness: Ue,
    existingUser: He,
    onBoarding: this,
    isSecondId: Ge
  };
  customRender(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { token: ue.token, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FaceMatch, { ...Ke }) }),
    me,
    Xe
  );
}
const isWebRtcNotSupported$1 = !isWebRtcSupported();
function renderFrontTutorial(me, { onSuccess: ue, noWait: Qe, token: Ue = {}, videoSrc: He }) {
  isWebRtcNotSupported$1 && ue();
  const Ge = createRoot$1(me), Xe = {
    onSuccess: handleUnmountRoot(ue, Ge, me),
    onBoarding: this,
    noWait: Qe,
    token: Ue,
    videoSrc: He
  };
  customRender(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(TutorialFront$1, { ...Xe }) }),
    me,
    Ge
  );
}
function OTPApp(me) {
  return useModuleEvents({
    module: eventModuleNames.otp,
    token: me.token.token
  }), /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: me.useSMS ? /* @__PURE__ */ jsxRuntimeExports.jsx(SMSOTP, { ...me }) : /* @__PURE__ */ jsxRuntimeExports.jsx(SimpleOTP, { ...me }) });
}
function renderOTP(me, {
  token: ue,
  numberOfTries: Qe = 3,
  otpTimeout: Ue = 3e4,
  useSMS: He = !1,
  isIndianGovernmentValidation: Ge = !1
}, { onSuccess: Xe, onError: Ke, onLog: $e = emptyFunc }) {
  const Je = createRoot$1(me), Ze = {
    onSuccess: handleUnmountRoot(Xe, Je, me),
    onError: handleUnmountRoot(Ke, Je, me)
  };
  customRender(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { token: ue.token, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      OTPApp,
      {
        onBoarding: this,
        token: ue,
        onSuccess: Ze.onSuccess,
        numberOfTries: Qe,
        onError: Ze.onError,
        onLog: $e,
        otpTimeout: Ue,
        useSMS: He,
        isIndianGovernmentValidation: Ge
      }
    ) }),
    me,
    Je
  );
}
function renderPassportTutorial(me, { onSuccess: ue, token: Qe = {} }) {
  const Ue = createRoot$1(me), He = {
    onSuccess: handleUnmountRoot(ue, Ue, me),
    onBoarding: this,
    token: Qe
  };
  customRender(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(TutorialPassport, { ...He }) }),
    me,
    Ue
  );
}
var lib = {}, mode$1 = {
  MODE_NUMBER: 1,
  MODE_ALPHA_NUM: 2,
  MODE_8BIT_BYTE: 4,
  MODE_KANJI: 8
}, mode = mode$1;
function QR8bitByte(me) {
  this.mode = mode.MODE_8BIT_BYTE, this.data = me;
}
QR8bitByte.prototype = {
  getLength: function(me) {
    return this.data.length;
  },
  write: function(me) {
    for (var ue = 0; ue < this.data.length; ue++)
      me.put(this.data.charCodeAt(ue), 8);
  }
};
var _8BitByte = QR8bitByte, ErrorCorrectLevel = {
  L: 1,
  M: 0,
  Q: 3,
  H: 2
}, ECL = ErrorCorrectLevel;
function QRRSBlock(me, ue) {
  this.totalCount = me, this.dataCount = ue;
}
QRRSBlock.RS_BLOCK_TABLE = [
  // L
  // M
  // Q
  // H
  // 1
  [1, 26, 19],
  [1, 26, 16],
  [1, 26, 13],
  [1, 26, 9],
  // 2
  [1, 44, 34],
  [1, 44, 28],
  [1, 44, 22],
  [1, 44, 16],
  // 3
  [1, 70, 55],
  [1, 70, 44],
  [2, 35, 17],
  [2, 35, 13],
  // 4		
  [1, 100, 80],
  [2, 50, 32],
  [2, 50, 24],
  [4, 25, 9],
  // 5
  [1, 134, 108],
  [2, 67, 43],
  [2, 33, 15, 2, 34, 16],
  [2, 33, 11, 2, 34, 12],
  // 6
  [2, 86, 68],
  [4, 43, 27],
  [4, 43, 19],
  [4, 43, 15],
  // 7		
  [2, 98, 78],
  [4, 49, 31],
  [2, 32, 14, 4, 33, 15],
  [4, 39, 13, 1, 40, 14],
  // 8
  [2, 121, 97],
  [2, 60, 38, 2, 61, 39],
  [4, 40, 18, 2, 41, 19],
  [4, 40, 14, 2, 41, 15],
  // 9
  [2, 146, 116],
  [3, 58, 36, 2, 59, 37],
  [4, 36, 16, 4, 37, 17],
  [4, 36, 12, 4, 37, 13],
  // 10		
  [2, 86, 68, 2, 87, 69],
  [4, 69, 43, 1, 70, 44],
  [6, 43, 19, 2, 44, 20],
  [6, 43, 15, 2, 44, 16],
  // 11
  [4, 101, 81],
  [1, 80, 50, 4, 81, 51],
  [4, 50, 22, 4, 51, 23],
  [3, 36, 12, 8, 37, 13],
  // 12
  [2, 116, 92, 2, 117, 93],
  [6, 58, 36, 2, 59, 37],
  [4, 46, 20, 6, 47, 21],
  [7, 42, 14, 4, 43, 15],
  // 13
  [4, 133, 107],
  [8, 59, 37, 1, 60, 38],
  [8, 44, 20, 4, 45, 21],
  [12, 33, 11, 4, 34, 12],
  // 14
  [3, 145, 115, 1, 146, 116],
  [4, 64, 40, 5, 65, 41],
  [11, 36, 16, 5, 37, 17],
  [11, 36, 12, 5, 37, 13],
  // 15
  [5, 109, 87, 1, 110, 88],
  [5, 65, 41, 5, 66, 42],
  [5, 54, 24, 7, 55, 25],
  [11, 36, 12],
  // 16
  [5, 122, 98, 1, 123, 99],
  [7, 73, 45, 3, 74, 46],
  [15, 43, 19, 2, 44, 20],
  [3, 45, 15, 13, 46, 16],
  // 17
  [1, 135, 107, 5, 136, 108],
  [10, 74, 46, 1, 75, 47],
  [1, 50, 22, 15, 51, 23],
  [2, 42, 14, 17, 43, 15],
  // 18
  [5, 150, 120, 1, 151, 121],
  [9, 69, 43, 4, 70, 44],
  [17, 50, 22, 1, 51, 23],
  [2, 42, 14, 19, 43, 15],
  // 19
  [3, 141, 113, 4, 142, 114],
  [3, 70, 44, 11, 71, 45],
  [17, 47, 21, 4, 48, 22],
  [9, 39, 13, 16, 40, 14],
  // 20
  [3, 135, 107, 5, 136, 108],
  [3, 67, 41, 13, 68, 42],
  [15, 54, 24, 5, 55, 25],
  [15, 43, 15, 10, 44, 16],
  // 21
  [4, 144, 116, 4, 145, 117],
  [17, 68, 42],
  [17, 50, 22, 6, 51, 23],
  [19, 46, 16, 6, 47, 17],
  // 22
  [2, 139, 111, 7, 140, 112],
  [17, 74, 46],
  [7, 54, 24, 16, 55, 25],
  [34, 37, 13],
  // 23
  [4, 151, 121, 5, 152, 122],
  [4, 75, 47, 14, 76, 48],
  [11, 54, 24, 14, 55, 25],
  [16, 45, 15, 14, 46, 16],
  // 24
  [6, 147, 117, 4, 148, 118],
  [6, 73, 45, 14, 74, 46],
  [11, 54, 24, 16, 55, 25],
  [30, 46, 16, 2, 47, 17],
  // 25
  [8, 132, 106, 4, 133, 107],
  [8, 75, 47, 13, 76, 48],
  [7, 54, 24, 22, 55, 25],
  [22, 45, 15, 13, 46, 16],
  // 26
  [10, 142, 114, 2, 143, 115],
  [19, 74, 46, 4, 75, 47],
  [28, 50, 22, 6, 51, 23],
  [33, 46, 16, 4, 47, 17],
  // 27
  [8, 152, 122, 4, 153, 123],
  [22, 73, 45, 3, 74, 46],
  [8, 53, 23, 26, 54, 24],
  [12, 45, 15, 28, 46, 16],
  // 28
  [3, 147, 117, 10, 148, 118],
  [3, 73, 45, 23, 74, 46],
  [4, 54, 24, 31, 55, 25],
  [11, 45, 15, 31, 46, 16],
  // 29
  [7, 146, 116, 7, 147, 117],
  [21, 73, 45, 7, 74, 46],
  [1, 53, 23, 37, 54, 24],
  [19, 45, 15, 26, 46, 16],
  // 30
  [5, 145, 115, 10, 146, 116],
  [19, 75, 47, 10, 76, 48],
  [15, 54, 24, 25, 55, 25],
  [23, 45, 15, 25, 46, 16],
  // 31
  [13, 145, 115, 3, 146, 116],
  [2, 74, 46, 29, 75, 47],
  [42, 54, 24, 1, 55, 25],
  [23, 45, 15, 28, 46, 16],
  // 32
  [17, 145, 115],
  [10, 74, 46, 23, 75, 47],
  [10, 54, 24, 35, 55, 25],
  [19, 45, 15, 35, 46, 16],
  // 33
  [17, 145, 115, 1, 146, 116],
  [14, 74, 46, 21, 75, 47],
  [29, 54, 24, 19, 55, 25],
  [11, 45, 15, 46, 46, 16],
  // 34
  [13, 145, 115, 6, 146, 116],
  [14, 74, 46, 23, 75, 47],
  [44, 54, 24, 7, 55, 25],
  [59, 46, 16, 1, 47, 17],
  // 35
  [12, 151, 121, 7, 152, 122],
  [12, 75, 47, 26, 76, 48],
  [39, 54, 24, 14, 55, 25],
  [22, 45, 15, 41, 46, 16],
  // 36
  [6, 151, 121, 14, 152, 122],
  [6, 75, 47, 34, 76, 48],
  [46, 54, 24, 10, 55, 25],
  [2, 45, 15, 64, 46, 16],
  // 37
  [17, 152, 122, 4, 153, 123],
  [29, 74, 46, 14, 75, 47],
  [49, 54, 24, 10, 55, 25],
  [24, 45, 15, 46, 46, 16],
  // 38
  [4, 152, 122, 18, 153, 123],
  [13, 74, 46, 32, 75, 47],
  [48, 54, 24, 14, 55, 25],
  [42, 45, 15, 32, 46, 16],
  // 39
  [20, 147, 117, 4, 148, 118],
  [40, 75, 47, 7, 76, 48],
  [43, 54, 24, 22, 55, 25],
  [10, 45, 15, 67, 46, 16],
  // 40
  [19, 148, 118, 6, 149, 119],
  [18, 75, 47, 31, 76, 48],
  [34, 54, 24, 34, 55, 25],
  [20, 45, 15, 61, 46, 16]
];
QRRSBlock.getRSBlocks = function(me, ue) {
  var Qe = QRRSBlock.getRsBlockTable(me, ue);
  if (Qe == null)
    throw new Error("bad rs block @ typeNumber:" + me + "/errorCorrectLevel:" + ue);
  for (var Ue = Qe.length / 3, He = new Array(), Ge = 0; Ge < Ue; Ge++)
    for (var Xe = Qe[Ge * 3 + 0], Ke = Qe[Ge * 3 + 1], $e = Qe[Ge * 3 + 2], Je = 0; Je < Xe; Je++)
      He.push(new QRRSBlock(Ke, $e));
  return He;
};
QRRSBlock.getRsBlockTable = function(me, ue) {
  switch (ue) {
    case ECL.L:
      return QRRSBlock.RS_BLOCK_TABLE[(me - 1) * 4 + 0];
    case ECL.M:
      return QRRSBlock.RS_BLOCK_TABLE[(me - 1) * 4 + 1];
    case ECL.Q:
      return QRRSBlock.RS_BLOCK_TABLE[(me - 1) * 4 + 2];
    case ECL.H:
      return QRRSBlock.RS_BLOCK_TABLE[(me - 1) * 4 + 3];
    default:
      return;
  }
};
var RSBlock$1 = QRRSBlock;
function QRBitBuffer() {
  this.buffer = new Array(), this.length = 0;
}
QRBitBuffer.prototype = {
  get: function(me) {
    var ue = Math.floor(me / 8);
    return (this.buffer[ue] >>> 7 - me % 8 & 1) == 1;
  },
  put: function(me, ue) {
    for (var Qe = 0; Qe < ue; Qe++)
      this.putBit((me >>> ue - Qe - 1 & 1) == 1);
  },
  getLengthInBits: function() {
    return this.length;
  },
  putBit: function(me) {
    var ue = Math.floor(this.length / 8);
    this.buffer.length <= ue && this.buffer.push(0), me && (this.buffer[ue] |= 128 >>> this.length % 8), this.length++;
  }
};
var BitBuffer$1 = QRBitBuffer, QRMath = {
  glog: function(me) {
    if (me < 1)
      throw new Error("glog(" + me + ")");
    return QRMath.LOG_TABLE[me];
  },
  gexp: function(me) {
    for (; me < 0; )
      me += 255;
    for (; me >= 256; )
      me -= 255;
    return QRMath.EXP_TABLE[me];
  },
  EXP_TABLE: new Array(256),
  LOG_TABLE: new Array(256)
};
for (var i = 0; i < 8; i++)
  QRMath.EXP_TABLE[i] = 1 << i;
for (var i = 8; i < 256; i++)
  QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4] ^ QRMath.EXP_TABLE[i - 5] ^ QRMath.EXP_TABLE[i - 6] ^ QRMath.EXP_TABLE[i - 8];
for (var i = 0; i < 255; i++)
  QRMath.LOG_TABLE[QRMath.EXP_TABLE[i]] = i;
var math$2 = QRMath, math$1 = math$2;
function QRPolynomial(me, ue) {
  if (me.length == null)
    throw new Error(me.length + "/" + ue);
  for (var Qe = 0; Qe < me.length && me[Qe] == 0; )
    Qe++;
  this.num = new Array(me.length - Qe + ue);
  for (var Ue = 0; Ue < me.length - Qe; Ue++)
    this.num[Ue] = me[Ue + Qe];
}
QRPolynomial.prototype = {
  get: function(me) {
    return this.num[me];
  },
  getLength: function() {
    return this.num.length;
  },
  multiply: function(me) {
    for (var ue = new Array(this.getLength() + me.getLength() - 1), Qe = 0; Qe < this.getLength(); Qe++)
      for (var Ue = 0; Ue < me.getLength(); Ue++)
        ue[Qe + Ue] ^= math$1.gexp(math$1.glog(this.get(Qe)) + math$1.glog(me.get(Ue)));
    return new QRPolynomial(ue, 0);
  },
  mod: function(me) {
    if (this.getLength() - me.getLength() < 0)
      return this;
    for (var ue = math$1.glog(this.get(0)) - math$1.glog(me.get(0)), Qe = new Array(this.getLength()), Ue = 0; Ue < this.getLength(); Ue++)
      Qe[Ue] = this.get(Ue);
    for (var Ue = 0; Ue < me.getLength(); Ue++)
      Qe[Ue] ^= math$1.gexp(math$1.glog(me.get(Ue)) + ue);
    return new QRPolynomial(Qe, 0).mod(me);
  }
};
var Polynomial$2 = QRPolynomial, Mode = mode$1, Polynomial$1 = Polynomial$2, math = math$2, QRMaskPattern = {
  PATTERN000: 0,
  PATTERN001: 1,
  PATTERN010: 2,
  PATTERN011: 3,
  PATTERN100: 4,
  PATTERN101: 5,
  PATTERN110: 6,
  PATTERN111: 7
}, QRUtil = {
  PATTERN_POSITION_TABLE: [
    [],
    [6, 18],
    [6, 22],
    [6, 26],
    [6, 30],
    [6, 34],
    [6, 22, 38],
    [6, 24, 42],
    [6, 26, 46],
    [6, 28, 50],
    [6, 30, 54],
    [6, 32, 58],
    [6, 34, 62],
    [6, 26, 46, 66],
    [6, 26, 48, 70],
    [6, 26, 50, 74],
    [6, 30, 54, 78],
    [6, 30, 56, 82],
    [6, 30, 58, 86],
    [6, 34, 62, 90],
    [6, 28, 50, 72, 94],
    [6, 26, 50, 74, 98],
    [6, 30, 54, 78, 102],
    [6, 28, 54, 80, 106],
    [6, 32, 58, 84, 110],
    [6, 30, 58, 86, 114],
    [6, 34, 62, 90, 118],
    [6, 26, 50, 74, 98, 122],
    [6, 30, 54, 78, 102, 126],
    [6, 26, 52, 78, 104, 130],
    [6, 30, 56, 82, 108, 134],
    [6, 34, 60, 86, 112, 138],
    [6, 30, 58, 86, 114, 142],
    [6, 34, 62, 90, 118, 146],
    [6, 30, 54, 78, 102, 126, 150],
    [6, 24, 50, 76, 102, 128, 154],
    [6, 28, 54, 80, 106, 132, 158],
    [6, 32, 58, 84, 110, 136, 162],
    [6, 26, 54, 82, 110, 138, 166],
    [6, 30, 58, 86, 114, 142, 170]
  ],
  G15: 1335,
  G18: 7973,
  G15_MASK: 21522,
  getBCHTypeInfo: function(me) {
    for (var ue = me << 10; QRUtil.getBCHDigit(ue) - QRUtil.getBCHDigit(QRUtil.G15) >= 0; )
      ue ^= QRUtil.G15 << QRUtil.getBCHDigit(ue) - QRUtil.getBCHDigit(QRUtil.G15);
    return (me << 10 | ue) ^ QRUtil.G15_MASK;
  },
  getBCHTypeNumber: function(me) {
    for (var ue = me << 12; QRUtil.getBCHDigit(ue) - QRUtil.getBCHDigit(QRUtil.G18) >= 0; )
      ue ^= QRUtil.G18 << QRUtil.getBCHDigit(ue) - QRUtil.getBCHDigit(QRUtil.G18);
    return me << 12 | ue;
  },
  getBCHDigit: function(me) {
    for (var ue = 0; me != 0; )
      ue++, me >>>= 1;
    return ue;
  },
  getPatternPosition: function(me) {
    return QRUtil.PATTERN_POSITION_TABLE[me - 1];
  },
  getMask: function(me, ue, Qe) {
    switch (me) {
      case QRMaskPattern.PATTERN000:
        return (ue + Qe) % 2 == 0;
      case QRMaskPattern.PATTERN001:
        return ue % 2 == 0;
      case QRMaskPattern.PATTERN010:
        return Qe % 3 == 0;
      case QRMaskPattern.PATTERN011:
        return (ue + Qe) % 3 == 0;
      case QRMaskPattern.PATTERN100:
        return (Math.floor(ue / 2) + Math.floor(Qe / 3)) % 2 == 0;
      case QRMaskPattern.PATTERN101:
        return ue * Qe % 2 + ue * Qe % 3 == 0;
      case QRMaskPattern.PATTERN110:
        return (ue * Qe % 2 + ue * Qe % 3) % 2 == 0;
      case QRMaskPattern.PATTERN111:
        return (ue * Qe % 3 + (ue + Qe) % 2) % 2 == 0;
      default:
        throw new Error("bad maskPattern:" + me);
    }
  },
  getErrorCorrectPolynomial: function(me) {
    for (var ue = new Polynomial$1([1], 0), Qe = 0; Qe < me; Qe++)
      ue = ue.multiply(new Polynomial$1([1, math.gexp(Qe)], 0));
    return ue;
  },
  getLengthInBits: function(me, ue) {
    if (1 <= ue && ue < 10)
      switch (me) {
        case Mode.MODE_NUMBER:
          return 10;
        case Mode.MODE_ALPHA_NUM:
          return 9;
        case Mode.MODE_8BIT_BYTE:
          return 8;
        case Mode.MODE_KANJI:
          return 8;
        default:
          throw new Error("mode:" + me);
      }
    else if (ue < 27)
      switch (me) {
        case Mode.MODE_NUMBER:
          return 12;
        case Mode.MODE_ALPHA_NUM:
          return 11;
        case Mode.MODE_8BIT_BYTE:
          return 16;
        case Mode.MODE_KANJI:
          return 10;
        default:
          throw new Error("mode:" + me);
      }
    else if (ue < 41)
      switch (me) {
        case Mode.MODE_NUMBER:
          return 14;
        case Mode.MODE_ALPHA_NUM:
          return 13;
        case Mode.MODE_8BIT_BYTE:
          return 16;
        case Mode.MODE_KANJI:
          return 12;
        default:
          throw new Error("mode:" + me);
      }
    else
      throw new Error("type:" + ue);
  },
  getLostPoint: function(me) {
    for (var ue = me.getModuleCount(), Qe = 0, Ue = 0; Ue < ue; Ue++)
      for (var He = 0; He < ue; He++) {
        for (var Ge = 0, Xe = me.isDark(Ue, He), Ke = -1; Ke <= 1; Ke++)
          if (!(Ue + Ke < 0 || ue <= Ue + Ke))
            for (var $e = -1; $e <= 1; $e++)
              He + $e < 0 || ue <= He + $e || Ke == 0 && $e == 0 || Xe == me.isDark(Ue + Ke, He + $e) && Ge++;
        Ge > 5 && (Qe += 3 + Ge - 5);
      }
    for (var Ue = 0; Ue < ue - 1; Ue++)
      for (var He = 0; He < ue - 1; He++) {
        var Je = 0;
        me.isDark(Ue, He) && Je++, me.isDark(Ue + 1, He) && Je++, me.isDark(Ue, He + 1) && Je++, me.isDark(Ue + 1, He + 1) && Je++, (Je == 0 || Je == 4) && (Qe += 3);
      }
    for (var Ue = 0; Ue < ue; Ue++)
      for (var He = 0; He < ue - 6; He++)
        me.isDark(Ue, He) && !me.isDark(Ue, He + 1) && me.isDark(Ue, He + 2) && me.isDark(Ue, He + 3) && me.isDark(Ue, He + 4) && !me.isDark(Ue, He + 5) && me.isDark(Ue, He + 6) && (Qe += 40);
    for (var He = 0; He < ue; He++)
      for (var Ue = 0; Ue < ue - 6; Ue++)
        me.isDark(Ue, He) && !me.isDark(Ue + 1, He) && me.isDark(Ue + 2, He) && me.isDark(Ue + 3, He) && me.isDark(Ue + 4, He) && !me.isDark(Ue + 5, He) && me.isDark(Ue + 6, He) && (Qe += 40);
    for (var Ze = 0, He = 0; He < ue; He++)
      for (var Ue = 0; Ue < ue; Ue++)
        me.isDark(Ue, He) && Ze++;
    var nt = Math.abs(100 * Ze / ue / ue - 50) / 5;
    return Qe += nt * 10, Qe;
  }
}, util$1 = QRUtil, BitByte = _8BitByte, RSBlock = RSBlock$1, BitBuffer = BitBuffer$1, util = util$1, Polynomial = Polynomial$2;
function QRCode$1(me, ue) {
  this.typeNumber = me, this.errorCorrectLevel = ue, this.modules = null, this.moduleCount = 0, this.dataCache = null, this.dataList = [];
}
var proto = QRCode$1.prototype;
proto.addData = function(me) {
  var ue = new BitByte(me);
  this.dataList.push(ue), this.dataCache = null;
};
proto.isDark = function(me, ue) {
  if (me < 0 || this.moduleCount <= me || ue < 0 || this.moduleCount <= ue)
    throw new Error(me + "," + ue);
  return this.modules[me][ue];
};
proto.getModuleCount = function() {
  return this.moduleCount;
};
proto.make = function() {
  if (this.typeNumber < 1) {
    var me = 1;
    for (me = 1; me < 40; me++) {
      for (var ue = RSBlock.getRSBlocks(me, this.errorCorrectLevel), Qe = new BitBuffer(), Ue = 0, He = 0; He < ue.length; He++)
        Ue += ue[He].dataCount;
      for (var He = 0; He < this.dataList.length; He++) {
        var Ge = this.dataList[He];
        Qe.put(Ge.mode, 4), Qe.put(Ge.getLength(), util.getLengthInBits(Ge.mode, me)), Ge.write(Qe);
      }
      if (Qe.getLengthInBits() <= Ue * 8)
        break;
    }
    this.typeNumber = me;
  }
  this.makeImpl(!1, this.getBestMaskPattern());
};
proto.makeImpl = function(me, ue) {
  this.moduleCount = this.typeNumber * 4 + 17, this.modules = new Array(this.moduleCount);
  for (var Qe = 0; Qe < this.moduleCount; Qe++) {
    this.modules[Qe] = new Array(this.moduleCount);
    for (var Ue = 0; Ue < this.moduleCount; Ue++)
      this.modules[Qe][Ue] = null;
  }
  this.setupPositionProbePattern(0, 0), this.setupPositionProbePattern(this.moduleCount - 7, 0), this.setupPositionProbePattern(0, this.moduleCount - 7), this.setupPositionAdjustPattern(), this.setupTimingPattern(), this.setupTypeInfo(me, ue), this.typeNumber >= 7 && this.setupTypeNumber(me), this.dataCache == null && (this.dataCache = QRCode$1.createData(this.typeNumber, this.errorCorrectLevel, this.dataList)), this.mapData(this.dataCache, ue);
};
proto.setupPositionProbePattern = function(me, ue) {
  for (var Qe = -1; Qe <= 7; Qe++)
    if (!(me + Qe <= -1 || this.moduleCount <= me + Qe))
      for (var Ue = -1; Ue <= 7; Ue++)
        ue + Ue <= -1 || this.moduleCount <= ue + Ue || (0 <= Qe && Qe <= 6 && (Ue == 0 || Ue == 6) || 0 <= Ue && Ue <= 6 && (Qe == 0 || Qe == 6) || 2 <= Qe && Qe <= 4 && 2 <= Ue && Ue <= 4 ? this.modules[me + Qe][ue + Ue] = !0 : this.modules[me + Qe][ue + Ue] = !1);
};
proto.getBestMaskPattern = function() {
  for (var me = 0, ue = 0, Qe = 0; Qe < 8; Qe++) {
    this.makeImpl(!0, Qe);
    var Ue = util.getLostPoint(this);
    (Qe == 0 || me > Ue) && (me = Ue, ue = Qe);
  }
  return ue;
};
proto.createMovieClip = function(me, ue, Qe) {
  var Ue = me.createEmptyMovieClip(ue, Qe), He = 1;
  this.make();
  for (var Ge = 0; Ge < this.modules.length; Ge++)
    for (var Xe = Ge * He, Ke = 0; Ke < this.modules[Ge].length; Ke++) {
      var $e = Ke * He, Je = this.modules[Ge][Ke];
      Je && (Ue.beginFill(0, 100), Ue.moveTo($e, Xe), Ue.lineTo($e + He, Xe), Ue.lineTo($e + He, Xe + He), Ue.lineTo($e, Xe + He), Ue.endFill());
    }
  return Ue;
};
proto.setupTimingPattern = function() {
  for (var me = 8; me < this.moduleCount - 8; me++)
    this.modules[me][6] == null && (this.modules[me][6] = me % 2 == 0);
  for (var ue = 8; ue < this.moduleCount - 8; ue++)
    this.modules[6][ue] == null && (this.modules[6][ue] = ue % 2 == 0);
};
proto.setupPositionAdjustPattern = function() {
  for (var me = util.getPatternPosition(this.typeNumber), ue = 0; ue < me.length; ue++)
    for (var Qe = 0; Qe < me.length; Qe++) {
      var Ue = me[ue], He = me[Qe];
      if (this.modules[Ue][He] == null)
        for (var Ge = -2; Ge <= 2; Ge++)
          for (var Xe = -2; Xe <= 2; Xe++)
            Ge == -2 || Ge == 2 || Xe == -2 || Xe == 2 || Ge == 0 && Xe == 0 ? this.modules[Ue + Ge][He + Xe] = !0 : this.modules[Ue + Ge][He + Xe] = !1;
    }
};
proto.setupTypeNumber = function(me) {
  for (var ue = util.getBCHTypeNumber(this.typeNumber), Qe = 0; Qe < 18; Qe++) {
    var Ue = !me && (ue >> Qe & 1) == 1;
    this.modules[Math.floor(Qe / 3)][Qe % 3 + this.moduleCount - 8 - 3] = Ue;
  }
  for (var Qe = 0; Qe < 18; Qe++) {
    var Ue = !me && (ue >> Qe & 1) == 1;
    this.modules[Qe % 3 + this.moduleCount - 8 - 3][Math.floor(Qe / 3)] = Ue;
  }
};
proto.setupTypeInfo = function(me, ue) {
  for (var Qe = this.errorCorrectLevel << 3 | ue, Ue = util.getBCHTypeInfo(Qe), He = 0; He < 15; He++) {
    var Ge = !me && (Ue >> He & 1) == 1;
    He < 6 ? this.modules[He][8] = Ge : He < 8 ? this.modules[He + 1][8] = Ge : this.modules[this.moduleCount - 15 + He][8] = Ge;
  }
  for (var He = 0; He < 15; He++) {
    var Ge = !me && (Ue >> He & 1) == 1;
    He < 8 ? this.modules[8][this.moduleCount - He - 1] = Ge : He < 9 ? this.modules[8][15 - He - 1 + 1] = Ge : this.modules[8][15 - He - 1] = Ge;
  }
  this.modules[this.moduleCount - 8][8] = !me;
};
proto.mapData = function(me, ue) {
  for (var Qe = -1, Ue = this.moduleCount - 1, He = 7, Ge = 0, Xe = this.moduleCount - 1; Xe > 0; Xe -= 2)
    for (Xe == 6 && Xe--; ; ) {
      for (var Ke = 0; Ke < 2; Ke++)
        if (this.modules[Ue][Xe - Ke] == null) {
          var $e = !1;
          Ge < me.length && ($e = (me[Ge] >>> He & 1) == 1);
          var Je = util.getMask(ue, Ue, Xe - Ke);
          Je && ($e = !$e), this.modules[Ue][Xe - Ke] = $e, He--, He == -1 && (Ge++, He = 7);
        }
      if (Ue += Qe, Ue < 0 || this.moduleCount <= Ue) {
        Ue -= Qe, Qe = -Qe;
        break;
      }
    }
};
QRCode$1.PAD0 = 236;
QRCode$1.PAD1 = 17;
QRCode$1.createData = function(me, ue, Qe) {
  for (var Ue = RSBlock.getRSBlocks(me, ue), He = new BitBuffer(), Ge = 0; Ge < Qe.length; Ge++) {
    var Xe = Qe[Ge];
    He.put(Xe.mode, 4), He.put(Xe.getLength(), util.getLengthInBits(Xe.mode, me)), Xe.write(He);
  }
  for (var Ke = 0, Ge = 0; Ge < Ue.length; Ge++)
    Ke += Ue[Ge].dataCount;
  if (He.getLengthInBits() > Ke * 8)
    throw new Error("code length overflow. (" + He.getLengthInBits() + ">" + Ke * 8 + ")");
  for (He.getLengthInBits() + 4 <= Ke * 8 && He.put(0, 4); He.getLengthInBits() % 8 != 0; )
    He.putBit(!1);
  for (; !(He.getLengthInBits() >= Ke * 8 || (He.put(QRCode$1.PAD0, 8), He.getLengthInBits() >= Ke * 8)); )
    He.put(QRCode$1.PAD1, 8);
  return QRCode$1.createBytes(He, Ue);
};
QRCode$1.createBytes = function(me, ue) {
  for (var Qe = 0, Ue = 0, He = 0, Ge = new Array(ue.length), Xe = new Array(ue.length), Ke = 0; Ke < ue.length; Ke++) {
    var $e = ue[Ke].dataCount, Je = ue[Ke].totalCount - $e;
    Ue = Math.max(Ue, $e), He = Math.max(He, Je), Ge[Ke] = new Array($e);
    for (var Ze = 0; Ze < Ge[Ke].length; Ze++)
      Ge[Ke][Ze] = 255 & me.buffer[Ze + Qe];
    Qe += $e;
    var nt = util.getErrorCorrectPolynomial(Je), tt = new Polynomial(Ge[Ke], nt.getLength() - 1), et = tt.mod(nt);
    Xe[Ke] = new Array(nt.getLength() - 1);
    for (var Ze = 0; Ze < Xe[Ke].length; Ze++) {
      var rt = Ze + et.getLength() - Xe[Ke].length;
      Xe[Ke][Ze] = rt >= 0 ? et.get(rt) : 0;
    }
  }
  for (var it = 0, Ze = 0; Ze < ue.length; Ze++)
    it += ue[Ze].totalCount;
  for (var ot = new Array(it), at = 0, Ze = 0; Ze < Ue; Ze++)
    for (var Ke = 0; Ke < ue.length; Ke++)
      Ze < Ge[Ke].length && (ot[at++] = Ge[Ke][Ze]);
  for (var Ze = 0; Ze < He; Ze++)
    for (var Ke = 0; Ke < ue.length; Ke++)
      Ze < Xe[Ke].length && (ot[at++] = Xe[Ke][Ze]);
  return ot;
};
var QRCode_1 = QRCode$1, QRCodeSvg$1 = {};
Object.defineProperty(QRCodeSvg$1, "__esModule", {
  value: !0
});
var _extends$1 = Object.assign || function(me) {
  for (var ue = 1; ue < arguments.length; ue++) {
    var Qe = arguments[ue];
    for (var Ue in Qe)
      Object.prototype.hasOwnProperty.call(Qe, Ue) && (me[Ue] = Qe[Ue]);
  }
  return me;
}, _propTypes$1 = propTypesExports, _propTypes2$1 = _interopRequireDefault$1(_propTypes$1), _react$1 = React__default, _react2$1 = _interopRequireDefault$1(_react$1);
function _interopRequireDefault$1(me) {
  return me && me.__esModule ? me : { default: me };
}
function _objectWithoutProperties$1(me, ue) {
  var Qe = {};
  for (var Ue in me)
    ue.indexOf(Ue) >= 0 || Object.prototype.hasOwnProperty.call(me, Ue) && (Qe[Ue] = me[Ue]);
  return Qe;
}
var propTypes$1 = {
  bgColor: _propTypes2$1.default.oneOfType([_propTypes2$1.default.object, _propTypes2$1.default.string]).isRequired,
  bgD: _propTypes2$1.default.string.isRequired,
  fgColor: _propTypes2$1.default.oneOfType([_propTypes2$1.default.object, _propTypes2$1.default.string]).isRequired,
  fgD: _propTypes2$1.default.string.isRequired,
  size: _propTypes2$1.default.number.isRequired,
  title: _propTypes2$1.default.string,
  viewBoxSize: _propTypes2$1.default.number.isRequired,
  xmlns: _propTypes2$1.default.string
}, defaultProps$1 = {
  title: void 0,
  xmlns: "http://www.w3.org/2000/svg"
}, QRCodeSvg = (0, _react$1.forwardRef)(function(me, ue) {
  var Qe = me.bgColor, Ue = me.bgD, He = me.fgD, Ge = me.fgColor, Xe = me.size, Ke = me.title, $e = me.viewBoxSize, Je = _objectWithoutProperties$1(me, ["bgColor", "bgD", "fgD", "fgColor", "size", "title", "viewBoxSize"]);
  return _react2$1.default.createElement(
    "svg",
    _extends$1({}, Je, { height: Xe, ref: ue, viewBox: "0 0 " + $e + " " + $e, width: Xe }),
    Ke ? _react2$1.default.createElement(
      "title",
      null,
      Ke
    ) : null,
    _react2$1.default.createElement("path", { d: Ue, fill: Qe }),
    _react2$1.default.createElement("path", { d: He, fill: Ge })
  );
});
QRCodeSvg.displayName = "QRCodeSvg";
QRCodeSvg.propTypes = propTypes$1;
QRCodeSvg.defaultProps = defaultProps$1;
QRCodeSvg$1.default = QRCodeSvg;
Object.defineProperty(lib, "__esModule", {
  value: !0
});
lib.QRCode = void 0;
var _extends = Object.assign || function(me) {
  for (var ue = 1; ue < arguments.length; ue++) {
    var Qe = arguments[ue];
    for (var Ue in Qe)
      Object.prototype.hasOwnProperty.call(Qe, Ue) && (me[Ue] = Qe[Ue]);
  }
  return me;
}, _QRCode = QRCode_1, _QRCode2 = _interopRequireDefault(_QRCode), _ErrorCorrectLevel = ErrorCorrectLevel, _ErrorCorrectLevel2 = _interopRequireDefault(_ErrorCorrectLevel), _propTypes = propTypesExports, _propTypes2 = _interopRequireDefault(_propTypes), _react = React__default, _react2 = _interopRequireDefault(_react), _QRCodeSvg = QRCodeSvg$1, _QRCodeSvg2 = _interopRequireDefault(_QRCodeSvg);
function _interopRequireDefault(me) {
  return me && me.__esModule ? me : { default: me };
}
function _objectWithoutProperties(me, ue) {
  var Qe = {};
  for (var Ue in me)
    ue.indexOf(Ue) >= 0 || Object.prototype.hasOwnProperty.call(me, Ue) && (Qe[Ue] = me[Ue]);
  return Qe;
}
var propTypes = {
  bgColor: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  fgColor: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  level: _propTypes2.default.string,
  size: _propTypes2.default.number,
  value: _propTypes2.default.string.isRequired
}, defaultProps = {
  bgColor: "#FFFFFF",
  fgColor: "#000000",
  level: "L",
  size: 256
}, QRCode = (0, _react.forwardRef)(function(me, ue) {
  var Qe = me.bgColor, Ue = me.fgColor, He = me.level, Ge = me.size, Xe = me.value, Ke = _objectWithoutProperties(me, ["bgColor", "fgColor", "level", "size", "value"]), $e = new _QRCode2.default(-1, _ErrorCorrectLevel2.default[He]);
  $e.addData(Xe), $e.make();
  var Je = $e.modules;
  return _react2.default.createElement(_QRCodeSvg2.default, _extends({}, Ke, {
    bgColor: Qe,
    bgD: Je.map(function(Ze, nt) {
      return Ze.map(function(tt, et) {
        return tt ? "" : "M " + et + " " + nt + " l 1 0 0 1 -1 0 Z";
      }).join(" ");
    }).join(" "),
    fgColor: Ue,
    fgD: Je.map(function(Ze, nt) {
      return Ze.map(function(tt, et) {
        return tt ? "M " + et + " " + nt + " l 1 0 0 1 -1 0 Z" : "";
      }).join(" ");
    }).join(" "),
    ref: ue,
    size: Ge,
    viewBoxSize: Je.length
  }));
});
lib.QRCode = QRCode;
QRCode.displayName = "QRCode";
QRCode.propTypes = propTypes;
QRCode.defaultProps = defaultProps;
var _default = lib.default = QRCode;
const URL_ERROR = "Url is not valid", useQR = ({
  session: me,
  onSuccess: ue,
  url: Qe,
  allowReEnrollment: Ue = !1,
  expired: He = !1,
  externalId: Ge,
  canceled: Xe = !1,
  lang: Ke
}) => {
  const [$e, Je] = useState(""), [Ze, nt] = useState(!1), tt = useRef(null), et = useRef(!1);
  return useEffect(() => {
    getOnboardingStatus(me).then((rt) => {
      (rt == null ? void 0 : rt.onboardingStatus) === "ONBOARDING_FINISHED" && Ue && !He && nt(!0);
    });
  }, []), useEffect(() => {
    addEvent({
      token: me.token,
      code: "qrCodeShown"
    });
  }, [me]), tt.current = useInterval(
    () => {
      const rt = async () => {
        try {
          const { redirectionUrl: it = "" } = await getRedirectUrl(null, me);
          if (sleep(3e3), it) {
            window.location.replace(it);
            return;
          }
        } catch (it) {
          console.error(it, "finish");
        }
      };
      getOnboardingStatus(me).then((it) => {
        Ze ? (it == null ? void 0 : it.onboardingStatus) !== "ONBOARDING_FINISHED" && nt(!1) : (it == null ? void 0 : it.onboardingStatus) === "ONBOARDING_FINISHED" && !et.current && (tt.current && clearInterval(tt.current), et.current = !0, ue(it), rt());
      }).catch(emptyFunc);
    },
    Xe ? null : 5e3
  ), useEffect(() => {
    (async () => {
      try {
        const it = await createRedirectUrl({
          session: me
        }), ot = new URL(it);
        if (Qe) {
          const at = new URL(Qe), st = ot.searchParams.get("uuid");
          at.searchParams.append("uuid", st), at.searchParams.append("isRedirect", "true"), Ke && at.searchParams.append("lang", Ke), Ge && at.searchParams.append("externalId", Ge), Je(at.href);
        } else {
          const at = new URL(it);
          at.searchParams.append("isRedirect", "true"), Ke && at.searchParams.append("lang", Ke), Je(at.href);
        }
      } catch (it) {
        console.error(URL_ERROR, it);
      }
    })();
  }, [Qe]), {
    redirectUrl: $e
  };
};
function Qr({
  session: me,
  onSuccess: ue,
  url: Qe,
  primaryColor: Ue,
  secondaryColor: He,
  sizePx: Ge
}) {
  const { redirectUrl: Xe } = useQR({
    url: Qe,
    onSuccess: ue,
    session: me
  });
  if (Xe)
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      _default,
      {
        value: Xe,
        bgColor: Ue,
        fgColor: He,
        size: Ge,
        className: "IncodeRedirectQRCode"
      }
    );
}
function renderQr(me, {
  onSuccess: ue,
  session: Qe,
  url: Ue,
  primaryColor: He,
  secondaryColor: Ge,
  sizePx: Xe
}) {
  const Ke = createRoot$1(me), $e = {
    onSuccess: handleUnmountRoot(ue, Ke, me),
    onBoarding: this,
    session: Qe,
    url: Ue,
    primaryColor: He,
    secondaryColor: Ge,
    sizePx: Xe
  };
  customRender(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { token: Qe.token, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Qr, { ...$e }) }),
    me,
    Ke
  );
}
const sendRedirectSMS = ({ token: me, smsType: ue, params: Qe }) => api.post(
  "/omni/notify/send-sms",
  { smsType: ue, params: Qe },
  {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }
).then((Ue) => Ue.data).catch((Ue) => Promise.reject(Ue.response.data)), phone = "data:image/svg+xml,%3csvg%20width='154'%20height='320'%20viewBox='0%200%20154%20320'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1'%20y='1'%20width='151.927'%20height='317.921'%20rx='17.5841'%20fill='white'%20stroke='%2380868F'%20stroke-width='1.05505'/%3e%3crect%20x='58.676'%20y='16.474'%20width='37.6301'%20height='10.5505'%20rx='5.27524'%20fill='%23ECEFF2'/%3e%3crect%20x='60.4342'%20y='15.7706'%20width='33.0582'%20height='7.38534'%20rx='3.69267'%20fill='white'%20stroke='%2380868F'%20stroke-width='0.703366'/%3e%3crect%20x='64.6548'%20y='18.5842'%20width='24.6178'%20height='1.75841'%20rx='0.879207'%20fill='%23ECEFF2'/%3e%3ccircle%20cx='76.7877'%20cy='300.458'%20r='13.5398'%20fill='white'%20stroke='%2380868F'%20stroke-width='0.703366'/%3e%3ccircle%20cx='76.7875'%20cy='300.458'%20r='7.56118'%20fill='%23ECEFF2'/%3e%3crect%20x='11.5503'%20y='35.8166'%20width='136.453'%20height='242.309'%20rx='5.27524'%20fill='%23ECEFF2'/%3e%3crect%20x='5.57202'%20y='37.5751'%20width='140.673'%20height='245.475'%20rx='3.51683'%20fill='white'/%3e%3crect%20x='9.0885'%20y='38.9818'%20width='135.75'%20height='241.606'%20rx='4.92356'%20fill='%23ECEFF2'%20stroke='%2380868F'%20stroke-width='0.703366'/%3e%3c/svg%3e", asYouType = new AsYouType(), RedirectContainer = qe.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  flex-direction: row;
  position: relative;
  padding-bottom: 50px;

  @media screen and (max-width: 1280px) {
    flex-direction: column;
  }

  @media screen and (max-height: 687px) {
    justify-content: flex-start;
  }
`, Title$2 = qe.h1`
  @media screen and (min-width: 768px) {
    text-align: left;
    width: 500px;
    display: block;
  }
  @media screen and (min-width: 1280px) {
    text-align: center;
  }
  display: none;
  max-width: 500px;

  font-size: 1.5rem;
  padding: 0 15px;
  font-weight: bold;

  @media screen and (max-height: 687px) {
    font-size: 1.3rem;
  }
`, TitleMobile = qe.h1`
  display: none;
  max-width: 500px;
  text-align: center;
  font-size: 1.5rem;
  padding: 0 15px;
  font-weight: bold;
  @media screen and (max-width: 767px) {
    display: block;
  }
`, QrContainer = qe.div`
  background-color: #eceff2;
  padding: 30px;
  border-radius: 12px;
  @media screen and (max-width: 768px) {
    padding: 10px;
  }
`, List = qe.ul`
  list-style-type: disc;
  color: #bebebe;

  line-height: 1.2em;
  li {
    font-size: 1.125rem;
    margin-bottom: 15px;
  }
  display: none;
  @media screen and (min-width: 768px) {
    display: block;
    padding-left: 40px;

    &.mid-screen {
      display: block;
    }
    &.big-screen {
      display: none;
    }
  }

  @media screen and (min-width: 1281px) {
    &.mid-screen {
      display: none;
    }
    &.big-screen {
      display: block;
    }
  }

  @media screen and (max-height: 687px) {
    li {
      font-size: 1rem;
    }
  }
`, ListMobile = qe.ul`
  list-style-type: disc;
  color: #bebebe;
  width: 350px;
  li {
    font-size: 1.125rem;
  }
  line-height: 1.2em;
  display: none;
  margin-bottom: 10px;
  @media screen and (max-width: 767px) {
    display: block;
    padding-left: 33px;
  }
`, Item = qe.li`
  margin-bottom: 5px;
`, VerticalLine = qe.div`
  height: 1px;
  flex-direction: column;
  border: 1px solid #cccccc;
  flex: 1;

  @media screen and (max-height: 687px) {
    padding: 0 10px;
  }
`, QrItemContainer = qe.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media screen and (min-width: 768px) {
    flex-direction: row;
    width: 100%;
    justify-content: flex-start;
    padding: 0 25px;
  }
  @media screen and (width: 1280px) {
    padding: 0px 125px;
  }
  @media screen and (max-width: 767px) {
    padding: 0 25px;
  }
  @media screen and (min-width: 1281px) {
    flex-direction: column;
    justify-content: center;
  }
`, SeparatorContainer = qe.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 500px;
  height: 520px;
  @media screen and (max-width: 1281px) {
    width: 100%;
    max-width: 80%;
    flex-direction: row;
    padding: 0 10px;
    height: 100px;
  }

  @media screen and (max-height: 687px) {
    height: 20px;
  }
`, Paragraph = qe.p`
  margin: 32px 0;
  @media screen and (max-width: 1281px) {
    margin-left: 8px;
    margin-right: 8px;
  }
`, Input$1 = qe.input`
  width: 250px;
  height: 50px;
  border: 1px solid #b6b6b6;
  border-radius: 5px;
  font-size: 24px;
  color: #858996;
  margin-bottom: 20px;
  text-align: center;
  @media screen and (max-height: 687px) {
    font-size: 1.2rem;
    height: 35px;
  }
`, Image$1 = qe.img`
  height: 225px;
  @media screen and (max-width: 1280px) {
    width: 160px;
  }
  @media screen and (max-height: 687px) {
    height: 100px;
  }
`, Logo = qe.img`
  width: 120px;
  max-width: 150px;

  &:only-child {
    margin: 0 auto;
  }
`, SmsSentContainer = qe.div`
  height: auto;
  background-color: #0cd5a2;
  padding: 10px;
  white-space: pre-wrap;
  text-align: center;
`, SmsSentParagraph = qe.p`
  color: #ffffff;
  margin: 0;
  font-size: 0.8rem;
`, ResendParagraph = qe.p`
  color: #00b2fd;
  text-decoration: underline;
  font-size: 0.875rem;
  cursor: pointer;
`, SendVerificationMobile = qe.section`
  display: none;
  flex-direction: column;
  align-items: center;
  div img {
    width: 50px;
    height: 50px;
    margin-right: 10px;
  }
  @media screen and (max-width: 767px) {
    display: block;
  }
`, SendVerificationDesktop = qe.section`
  display: none;
  flex-direction: column;
  h1 {
    display: none;
  }
  @media screen and (min-width: 768px) {
    display: flex;
  }
  @media screen and (min-width: 1281px) {
    h1 {
      display: block;
    }
  }
`, MessageContainer = qe.div`
  align-items: center;
  display: flex;
  h2 {
    font-size: 1.5rem;
  }
`, SendSmSContainer = qe.section`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  input {
    margin-bottom: 0;
    margin-right: 10px;
  }

  @media screen and (min-width: 768px) {
    margin-top: 0;
    flex-direction: column;
    align-items: flex-start;
  }
  @media screen and (max-width: 767px) {
    h2 {
      display: none;
    }
  }

  @media screen and (min-width: 1281px) {
    h2 {
      display: none;
    }
  }
  @media screen and (max-height: 687px) {
    h2 {
      font-size: 1.3rem;
    }
  }
`, FooterDesktop = qe.footer`
  position: absolute;
  bottom: 0px;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid rgb(204, 204, 204);
  padding: 0 10px;
  height: 35px;

  p {
    color: #636670;
    margin: 0;
  }
  button {
    margin-left: 10px;
    color: #00b2fd;
  }
  @media screen and (max-width: 580px) {
    justify-content: center;
    button,
    p {
      display: none;
    }
  }
`, CustomButton = qe(Button$a)`
  width: 100%;
  min-width: unset;
  padding: 19px 32px;
  @media screen and (max-height: 687px) {
    padding: 12px 32px;
    font-size: 1rem;
  }
`, ContainerRecommendation = qe.section`
  @media screen and (min-width: 1281px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`, ContainerInputs = qe.section`
  display: flex;

  @media screen and (min-width: 768px) {
    display: flex;
    justify-content: flex-start;
    align-self: flex-start;
    padding-left: 40px;
    align-items: center;
  }

  @media screen and (min-width: 1281px) {
    flex-direction: column;
    gap: 10px;
    button {
      width: 250px;
    }
  }
`, convertMinutesToDHM = (me) => {
  const ue = {
    days: 0,
    hours: 0,
    minutes: 0
  };
  return me < 60 ? ue.minutes = me : me >= 60 && me <= 4320 ? (ue.hours = Math.floor(me / 60), ue.minutes = me % 60) : (ue.days = Math.floor(me / 1440), ue.hours = Math.floor(me % 1440 / 60), ue.minutes = me % 60), ue;
};
function Redirect({
  session: me,
  onSuccess: ue,
  url: Qe,
  showSms: Ue,
  assets: He,
  smsText: Ge,
  skipDesktopRedirect: Xe,
  allowSkipRedirect: Ke = !1,
  externalId: $e,
  expired: Je,
  allowReEnrollment: Ze
}) {
  const { t: nt } = useTranslation(), [tt, et] = useState(""), [rt, it] = useState(null), [ot, at] = useState(), [st, ut] = useState(Ue), [lt, dt] = useState(!0), [At, pt] = useState(!1), [gt, wt] = useState(), [Bt, Tt] = useState(!1), yt = useQuery(), Ct = yt.get("lang"), ht = convertMinutesToDHM(
    me.onboardingLinkExpirationMinutes ?? 15
  ), It = (Pt) => {
    const { hours: Qt, days: qt, minutes: _t } = Pt;
    let Yt = "";
    return qt > 0 && (Yt += ` ${qt} ${nt("redirect.expDays")}`, Qt > 0 && (Yt += _t > 0 ? "," : ` ${nt("redirect.and")}`), Qt === 0 && _t > 0 && (Yt += ` ${nt("redirect.and")}`)), Qt > 0 && (Yt += ` ${Qt} ${nt("redirect.expHours")}`, _t > 0 && (Yt += ` ${nt("redirect.and")}`)), _t > 0 && (Yt += ` ${_t} ${nt("redirect.expMinutes")}`), Yt;
  };
  useEffect(() => {
    const Pt = yt.get("hideSms");
    (() => {
      if (Pt == null) return;
      const qt = Pt.toLowerCase() === "true";
      ut(qt);
    })();
  }, [yt]);
  const { redirectUrl: vt } = useQR({
    url: Qe,
    onSuccess: ue,
    session: me,
    expired: Je,
    allowReEnrollment: Ze,
    externalId: $e,
    lang: Ct,
    canceled: Bt
  });
  useEffect(() => {
    getStartInfo(me).then((Pt) => {
      et(Pt.phonePrefix);
    });
  }, []), useEffect(() => {
    if (!He)
      return;
    const { logo: Pt } = He;
    if (!Pt) {
      wt(welcomeLogo);
      return;
    }
    wt(Pt);
  }, [He]);
  function Et({ target: { value: Pt } }) {
    const Qt = parsePhoneNumber(Pt), qt = asYouType.input(Pt);
    et(qt), asYouType.reset(), Qt != null && Qt.isValid() ? (at(Pt), dt(!1)) : dt(!0);
  }
  const bt = () => `${Ge} ${vt}`, Rt = async () => {
    it(!0), addEvent({
      token: me.token,
      code: "userClickedSendSms"
    }), await addPhone({
      phone: ot,
      token: me.token,
      ...Ge && { text: bt() }
    });
    const Pt = Ct ? [`lang=${Ct}`] : [];
    Ge || await sendRedirectSMS({
      smsType: "DESKTOP_ONBOARDING",
      token: me.token,
      params: Pt
    }), it(!1), pt(!0);
  }, St = () => {
    Tt(!0), Xe();
  }, [kt, jt] = useState(!1);
  return useLayoutEffect(() => {
    window.innerWidth <= 1281 && jt(!0);
  }, []), vt ? /* @__PURE__ */ jsxRuntimeExports.jsxs(RedirectContainer, { className: "IncodeRedirectContainer", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(QrItemContainer, { className: "IncodeRedirectQrItemContainer", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(TitleMobile, { className: "IncodeRedirectTitleMobile", children: nt("redirect.scanQrTitle") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ListMobile, { className: "IncodeRedirectListMobile", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Item, { className: "IncodeRedirectItem", children: nt("redirect.scanQrParagraph1") }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(QrContainer, { className: "IncodeRedirectQrContainer", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        _default,
        {
          value: vt,
          bgColor: "#eceff2",
          size: kt ? 100 : 150,
          className: "IncodeRedirectQRCode"
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(ContainerRecommendation, { className: "IncodeRedirectContainerRecommendation", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Title$2, { className: "IncodeRedirectTitle", children: nt("redirect.scanQrTitle") }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(List, { className: "IncodeRedirectList", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Item, { className: "IncodeRedirectParagraph1", children: nt("redirect.scanQrParagraph1") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Item, { className: "IncodeRedirectParagraph2", children: nt("redirect.scanQrParagraph2") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Item, { className: "IncodeRedirectParagraph3", children: nt("redirect.scanQrParagraph3") })
        ] })
      ] })
    ] }),
    st && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(SeparatorContainer, { className: "IncodeRedirectSeparatorContainer", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(VerticalLine, { className: "IncodeRedirectVerticalLine" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph, { children: nt("common.or") }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(VerticalLine, {})
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(QrItemContainer, { className: "IncodeRedirectQrItemContainer", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(SendVerificationMobile, { className: "IncodeRedirectSendVerificationMobileContainer", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(MessageContainer, { className: "IncodeRedirectSendVerificationMobileMessageContainer", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Image$1,
              {
                className: "IncodeRedirectSendVerificationMobileImage",
                src: phone,
                alt: "mobile device"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "IncodeRedirectSendVerificationMobileText", children: nt("redirect.sendLinkToMyPhone") })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(ListMobile, { className: "IncodeRedirectSendVerificationMobileList", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Item, { className: "IncodeRedirectSendVerificationMobileListItem", children: nt("redirect.linkParagraph") }) })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(SendVerificationDesktop, { className: "IncodeRedirectSendVerificationDesktopContainer", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Image$1,
            {
              className: "IncodeRedirectSendVerificationDesktopImage",
              src: phone,
              alt: "mobile device"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Title$2, { className: "IncodeRedirectSendVerificationDesktopText", children: nt("redirect.sendLink") })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(SendSmSContainer, { className: "IncodeRedirectSendSMSContainer", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "IncodeRedirectSendSMSText", children: nt("redirect.sendLink") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(List, { className: "mid-screen IncodeRedirectSendSMSList", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Item, { className: "IncodeRedirectSendSMSListItem", children: nt("redirect.linkParagraph") }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(ContainerInputs, { className: "IncodeRedirectContainerInputs", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Input$1,
              {
                autoComplete: "off",
                type: "tel",
                onChange: Et,
                value: tt,
                className: "IncodeRedirectInput"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(List, { className: "big-screen", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Item, { children: nt("redirect.linkParagraph") }) }),
            At ? /* @__PURE__ */ jsxRuntimeExports.jsx(SmsSentContainer, { className: "IncodeRedirectSmsSentContainer", children: /* @__PURE__ */ jsxRuntimeExports.jsx(SmsSentParagraph, { className: "IncodeRedirectSmsSentParagraph", children: `${nt("redirect.expLink")}${It(ht)}` }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
              CustomButton,
              {
                disabled: lt || rt,
                onClick: Rt,
                children: nt("common.send")
              }
            )
          ] })
        ] }),
        At && /* @__PURE__ */ jsxRuntimeExports.jsx(
          ResendParagraph,
          {
            onClick: () => {
              pt(!1), Rt();
            },
            className: "IncodeRedirectResendParagraph",
            children: nt("redirect.linkNotReceived")
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(FooterDesktop, { className: "IncodeRedirectFooterDesktop", children: [
      gt && /* @__PURE__ */ jsxRuntimeExports.jsx(Logo, { src: gt }),
      " ",
      Ke ? /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
        nt("redirect.dontHavePhone"),
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("button", { onClick: St, type: "button", children: nt("redirect.continueOnDesktop") })
      ] }) : null
    ] })
  ] }) : null;
}
function renderRedirectToMobile(me, {
  onSuccess: ue,
  session: Qe,
  flowId: Ue,
  logoSrc: He,
  url: Ge,
  showSms: Xe = !0,
  allowReEnrollment: Ke = !0,
  assets: $e,
  expired: Je,
  smsText: Ze,
  skipDesktopRedirect: nt,
  allowSkipRedirect: tt,
  externalId: et
}) {
  const rt = createRoot$1(me), it = {
    onSuccess: handleUnmountRoot(ue, rt, me),
    onBoarding: this,
    session: Qe,
    flowId: Ue,
    logoSrc: He,
    url: Ge,
    showSms: Xe,
    allowReEnrollment: Ke,
    assets: $e,
    expired: Je,
    smsText: Ze,
    skipDesktopRedirect: nt,
    allowSkipRedirect: tt,
    externalId: et
  };
  return customRender(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { token: Qe.token, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Redirect, { ...it }) }),
    me,
    rt
  ), { close: handleUnmountRoot(emptyFunc, rt, me) };
}
const isWebRtcNotSupported = !isWebRtcSupported();
function renderSelfieTutorial(me, { onSuccess: ue, noWait: Qe, token: Ue = {}, videoSrc: He, onError: Ge }) {
  isWebRtcNotSupported && ue();
  const Xe = createRoot$1(me), Ke = {
    onSuccess: handleUnmountRoot(ue, Xe, me),
    onError: handleUnmountRoot(Ge, Xe, me),
    onBoarding: this,
    noWait: Qe,
    token: Ue,
    videoSrc: He
  };
  customRender(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(TutorialSelfie, { ...Ke }) }),
    me,
    Xe
  );
}
const Container = qe.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  align-items: center;
  ${({ fullScreen: me, backgroundColor: ue }) => me && {
  width: "100vw",
  height: "100vh",
  zIndex: 1,
  background: ue || "#ffffff",
  position: "absolute",
  justifyContent: "center"
}}
`, Spinner = qe.div`
  border: 2px solid #000000;
  border-radius: 50%;
  border-top: 2px solid transparent;
  width: 40px;
  height: 40px;
  margin-bottom: 15px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`, Message = qe.div`
  font-weight: bold;
  color: #000000;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  h1 {
    font-size: 25px;
  }
  span {
    font-size: 14px;
  }
`, customStyles = {
  overlay: {
    zIndex: 5
  },
  content: {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    padding: 0,
    borderRadius: 0,
    border: "none",
    inset: 0,
    backgroundColor: "transparent",
    transform: "translateY(0)"
  }
};
function Loader({ message: me, ...ue }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Modal, { isOpen: !0, style: customStyles, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Container, { ...ue, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Message, { children: me })
  ] }) });
}
const Check = "data:image/svg+xml,%3csvg%20width='36'%20height='28'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M35.35%203.865%2032.19.66c-.433-.44-.96-.66-1.579-.66-.62%200-1.146.22-1.58.66L13.796%2016.145%206.968%209.192c-.434-.44-.96-.66-1.58-.66-.619%200-1.145.22-1.579.66L.65%2012.397C.217%2012.837%200%2013.371%200%2014c0%20.628.217%201.163.65%201.603l8.408%208.532%203.159%203.205c.433.44.96.66%201.58.66.618%200%201.145-.22%201.579-.66l3.158-3.205L35.35%207.07A2.2%202.2%200%200%200%2036%205.468c0-.628-.217-1.163-.65-1.603z'%20fill='%230CD5A2'/%3e%3c/svg%3e", SuccessMessageContainer = qe.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`, ContainerElements = qe.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  span {
    color: #0cd5a2;
    font-size: 25px;
    font-weight: bold;
  }
`;
function SuccessMessage() {
  const { t: me } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SuccessMessageContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ContainerElements, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: Check, alt: "Check mark" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: me("watchList.successMessage") })
  ] }) });
}
const WatchListContainer = qe.div`
  height: 100%;
  padding: 25px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
  overflow: auto;
  gap: 10px;
`, viewStates$1 = {
  LOADING: "LOADING",
  SUCCESS: "SUCCESS"
}, CustomWatchList = ({ token: me, onSuccess: ue }) => {
  const { t: Qe } = useTranslation(), [Ue, He] = useState(viewStates$1.LOADING);
  return useEffect(() => {
    (async () => {
      addScreenEvent({
        module: eventModuleNames.customWatchList,
        screen: eventScreenNames.customWatchListProgress,
        token: me.token,
        shouldOpen: !0
      });
      const Xe = await processWatchlist({
        token: me.token
      });
      addEvent({
        token: me.token,
        code: "processWatchlist",
        payload: Xe
      }), addScreenEvent({
        module: eventModuleNames.customWatchList,
        screen: eventScreenNames.customWatchListProgress,
        token: me.token,
        shouldOpen: !1
      }), He(viewStates$1.SUCCESS), addScreenEvent({
        module: eventModuleNames.customWatchList,
        screen: eventScreenNames.customWatchListSuccess,
        token: me.token,
        shouldOpen: !0
      }), sleep(3e3).then(() => {
        addScreenEvent({
          module: eventModuleNames.customWatchList,
          screen: eventScreenNames.customWatchListSuccess,
          token: me.token,
          shouldOpen: !1
        }), ue();
      });
    })();
  }, [me]), /* @__PURE__ */ jsxRuntimeExports.jsxs(WatchListContainer, { children: [
    Ue === viewStates$1.LOADING && /* @__PURE__ */ jsxRuntimeExports.jsx(
      Loader,
      {
        fullScreen: !0,
        message: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: Qe("watchList.uploading") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: Qe("watchList.thisMigthTake") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: Qe("watchList.browser") })
        ] })
      }
    ),
    Ue === viewStates$1.SUCCESS && /* @__PURE__ */ jsxRuntimeExports.jsx(SuccessMessage, {})
  ] });
}, viewStates = {
  LOADING: "LOADING",
  SUCCESS: "SUCCESS"
}, GlobalWatchList = ({ onSuccess: me, onBoarding: ue, token: Qe }) => {
  const { t: Ue } = useTranslation(), [He, Ge] = useState(viewStates.LOADING);
  return useEffect(() => {
    async function Xe() {
      try {
        await ue.processGlobalWatchlist({ token: Qe.token }), Ge(viewStates.SUCCESS);
      } catch (Ke) {
        console.error(Ke);
      }
      setTimeout(() => me(), 3e3);
    }
    Xe();
  }, [Qe, ue.processGlobalWatchlist]), /* @__PURE__ */ jsxRuntimeExports.jsx(WatchListContainer, { children: He === viewStates.SUCCESS ? /* @__PURE__ */ jsxRuntimeExports.jsx(SuccessMessage, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    Loader,
    {
      fullScreen: !0,
      message: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: Ue("watchList.processing") }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: Ue("watchList.thisMigthTake") }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: Ue("watchList.browser") })
      ] })
    }
  ) });
};
function renderWatchList(me, ue, { token: Qe, onSuccess: Ue }) {
  const He = createRoot$1(me), Ge = {
    onSuccess: handleUnmountRoot(Ue, He, me),
    onBoarding: this,
    token: Qe
  };
  customRender(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { token: Qe.token, children: ue === "custom" ? /* @__PURE__ */ jsxRuntimeExports.jsx(CustomWatchList, { ...Ge }) : /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalWatchList, { ...Ge }) }),
    me,
    He
  );
}
const ShowInstructions = ({
  goNext: me,
  token: ue,
  image: Qe
}) => {
  const { t: Ue } = useTranslation();
  useEffect(() => {
    ue != null && ue.token && addEvent({
      token: ue.token,
      code: "retryInstructions"
    });
  }, [ue]);
  function He() {
    addEvent({
      token: ue == null ? void 0 : ue.token,
      code: "retryInstructionContinue"
    }), me();
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      style: {
        padding: "0 30px 10px 30px",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        height: "100%",
        justifyContent: "space-around"
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { textAlign: "center" }, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "h1",
            {
              className: "IncodeText IncodeH1 IncodeTutorialHeaderTitle IncodeTutorialHeaderTitleInstructions",
              style: { fontSize: "28px" },
              children: Ue("retrySteps.showInstructions.title")
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { style: { fontSize: "14px" }, children: Ue("retrySteps.showInstructions.text") })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "img",
          {
            src: Qe,
            style: { width: "100%", borderRadius: "15px" },
            alt: "id blur"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button$a, { onClick: He, children: Ue("common.retake") }) })
      ]
    }
  );
}, attemptFinished = ({ token: me }) => api.post(
  "/omni/attempt-finished",
  {},
  {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }
).then((ue) => ue.data).catch((ue) => Promise.reject(ue.response.data)), ProcessId = ({ token: me, goNext: ue, callProcessFace: Qe }) => (useEffect(() => {
  const Ue = processId({
    token: me.token
  }).then(() => {
    if (Qe)
      return processFace({ token: me.token });
  }).catch(console.log), He = sleep(3e3);
  Promise.all([Ue, He]).then(() => {
    ue();
  });
}, [me.token, ue, Qe]), /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$6, {})), RetrySteps = ({
  token: me,
  onSuccess: ue,
  onBoarding: Qe,
  numberOfTries: Ue,
  onError: He,
  showPassport: Ge,
  showTutorials: Xe
}) => {
  const [Ke, $e] = useState(!0), [Je, Ze] = useState([]), [nt, tt] = useState(), { currentStep: et, setStep: rt, nextStep: it } = useSteps();
  useEffect(() => {
    if (!Je) return;
    async function st() {
      const lt = (await getImages$1({
        token: me == null ? void 0 : me.token,
        body: {
          images: ["croppedFrontID"]
        }
      })).croppedFrontID;
      tt(lt);
    }
    st();
  }, [Je]), useEffect(() => {
    if (!Ke) return;
    async function st() {
      var lt;
      await attemptFinished({ token: me.token }).catch(console.log);
      const { retryInfo: ut } = await getScore({ token: me.token });
      if (!(ut != null && ut.stepsToRetry) || ((lt = ut == null ? void 0 : ut.stepsToRetry) == null ? void 0 : lt.length) === 0) {
        ue();
        return;
      }
      rt(0), Ze(ut == null ? void 0 : ut.stepsToRetry), $e(!1);
    }
    st();
  }, [me.token, ue, rt, Ke]);
  const ot = useCallback(() => {
    $e(!0), Ze([]);
  }, []);
  if (Ke)
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$6, {});
  if (Je.length === 0)
    return null;
  const at = async (st) => {
    if (st.typeOfId === "Passport" && !Ge || Ge && (Je != null && Je.includes("backId"))) {
      rt(et + 2);
      return;
    }
    it();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(NotificationProvider, { initialValue: { isOpen: !1 }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Steps, { currentStep: et, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ShowInstructions,
      {
        goNext: it,
        token: me,
        image: `data:image/jpeg;base64,${nt}`
      }
    ),
    (Je == null ? void 0 : Je.includes("frontId")) && /* @__PURE__ */ jsxRuntimeExports.jsx(
      CaptureAndTutorial$1,
      {
        onSuccess: at,
        onError: He,
        onBoarding: Qe,
        numberOfTries: Ue,
        type: Ge ? "passport" : Qe.frontType,
        token: me,
        timeout: 4e4,
        sendBase64: !0,
        showPreview: !1,
        nativeCamera: !1,
        hideRetake: !1,
        showTutorial: Xe,
        onlyCapture: !1,
        scanPdf417: !1,
        showCustomCameraPermissionScreen: !1,
        onLog: emptyFunc,
        isRetry: !Ge && !(Je != null && Je.includes("backId"))
      }
    ),
    (Je == null ? void 0 : Je.includes("backId")) && /* @__PURE__ */ jsxRuntimeExports.jsx(
      CaptureAndTutorial$3,
      {
        onSuccess: it,
        onError: He,
        onBoarding: Qe,
        numberOfTries: Ue,
        type: Qe.backType,
        token: me,
        timeout: 4e4,
        sendBase64: !0,
        showPreview: !1,
        nativeCamera: !1,
        hideRetake: !1,
        showTutorial: Xe,
        onlyCapture: !1,
        scanPdf417: !1,
        showCustomCameraPermissionScreen: !1,
        onLog: emptyFunc,
        isRetry: !(Je != null && Je.includes("frontId"))
      }
    ),
    ((Je == null ? void 0 : Je.includes("backId")) || (Je == null ? void 0 : Je.includes("frontId"))) && /* @__PURE__ */ jsxRuntimeExports.jsx(
      ProcessId,
      {
        goNext: ot,
        token: me,
        callProcessFace: Je == null ? void 0 : Je.includes("frontId")
      }
    )
  ] }) });
};
function renderRetrySteps(me, { token: ue, numberOfTries: Qe, showPassport: Ue, showTutorials: He }, { onSuccess: Ge, onError: Xe }) {
  const Ke = createRoot$1(me), $e = {
    onSuccess: handleUnmountRoot(Ge, Ke, me),
    onError: handleUnmountRoot(Xe, Ke, me)
  };
  customRender(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { token: ue.token, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      RetrySteps,
      {
        onBoarding: this,
        token: ue,
        onSuccess: $e.onSuccess,
        numberOfTries: Qe,
        onError: $e.onError,
        showPassport: Ue,
        showTutorials: He
      }
    ) }),
    me,
    Ke
  );
}
const enableDeviceRiskModule = async (me, ue = !0) => {
  const Qe = await getCustomFields({ token: me });
  if (Qe.customFields === void 0)
    return null;
  const { customFields: Ue } = Qe, He = ue ? "api.sandbox.sardine.ai" : "api.sardine.ai", Ge = document.createElement("script");
  return Ge.type = "text/javascript", Ge.async = !0, Ge.src = `https://${He}/assets/loader.min.js`, await new Promise((Xe) => {
    Ge.onload = async () => {
      if (typeof Ue.SardineClientID != "string" || typeof Ue.SardineSessionKey != "string" || typeof Ue.SardineUserID != "string") {
        Xe(null);
        return;
      }
      Xe(
        createSardineContext({
          sardineClientId: Ue.SardineClientID,
          sardineSessionKey: Ue.SardineSessionKey,
          sardineUserId: Ue.SardineUserID,
          isSandbox: ue,
          token: me
        })
      );
    };
    const Ke = document.getElementsByTagName("script")[0];
    Ke.parentNode.insertBefore(Ge, Ke);
  });
}, createSardineContext = ({
  sardineClientId: me,
  sardineSessionKey: ue,
  sardineUserId: Qe,
  isSandbox: Ue,
  token: He
}) => {
  const Ge = self.crypto.randomUUID();
  return window._Sardine.createContext({
    clientId: me,
    sessionKey: Ge,
    flow: `Landing page ${location.pathname}`,
    environment: Ue ? "sandbox" : "production",
    parentElement: document.body,
    parentSessionKey: ue,
    userIdHash: Qe,
    // called when sardine generates/restores deviceID for given device.
    onDeviceResponse(Xe) {
      addEvent({
        code: "externalRiskSDKInitialized",
        payload: {
          sardineData: {
            deviceId: Xe.deviceId,
            uuid: Xe.uuid
          },
          uuid: Ge,
          sardineClientId: me,
          sardineSessionKey: ue,
          sardineUserId: Qe
        },
        token: He
      });
    }
  });
};
function sendEkyb({ body: me, token: ue }) {
  return api.post("/omni/externalVerification/ekyb", me, {
    headers: {
      "X-Incode-Hardware-Id": ue
    }
  }).then((Qe) => Qe.data);
}
function sendEmail({ status: me, token: ue }) {
  return api.post(
    "/omni/fanid/send-email",
    { status: me },
    {
      headers: {
        "X-Incode-Hardware-Id": ue
      }
    }
  ).then((Qe) => Qe.data).catch((Qe) => Promise.reject(Qe.response.data));
}
function getCurrentPosition() {
  return new Promise((me, ue) => {
    navigator.geolocation.getCurrentPosition(me, ue);
  });
}
async function sendGeolocation(me) {
  const ue = { location: "Unknown" };
  return getCurrentPosition().then(
    (Qe) => this.addGeolocation({
      token: me,
      longitude: Qe.coords.longitude,
      latitude: Qe.coords.latitude
    }).then((Ue) => Ue.location ? Ue : ue).catch(() => ue)
  );
}
function setSessionStatus({ token: me, action: ue }) {
  return api.post(
    `/omni/session/status/set?action=${ue}`,
    {},
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).then((Qe) => Qe.data);
}
var sha1$1 = { exports: {} };
/*
 * [js-sha1]{@link https://github.com/emn178/js-sha1}
 *
 * @version 0.6.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2017
 * @license MIT
 */
(function(module) {
  (function() {
    var root = typeof window == "object" ? window : {}, NODE_JS = !root.JS_SHA1_NO_NODE_JS && typeof process == "object" && process.versions && process.versions.node;
    NODE_JS && (root = commonjsGlobal);
    var COMMON_JS = !root.JS_SHA1_NO_COMMON_JS && !0 && module.exports, HEX_CHARS = "0123456789abcdef".split(""), EXTRA = [-2147483648, 8388608, 32768, 128], SHIFT = [24, 16, 8, 0], OUTPUT_TYPES = ["hex", "array", "digest", "arrayBuffer"], blocks = [], createOutputMethod = function(me) {
      return function(ue) {
        return new Sha1(!0).update(ue)[me]();
      };
    }, createMethod = function() {
      var me = createOutputMethod("hex");
      NODE_JS && (me = nodeWrap(me)), me.create = function() {
        return new Sha1();
      }, me.update = function(Ue) {
        return me.create().update(Ue);
      };
      for (var ue = 0; ue < OUTPUT_TYPES.length; ++ue) {
        var Qe = OUTPUT_TYPES[ue];
        me[Qe] = createOutputMethod(Qe);
      }
      return me;
    }, nodeWrap = function(method) {
      var crypto = eval("require('crypto')"), Buffer = eval("require('buffer').Buffer"), nodeMethod = function(me) {
        if (typeof me == "string")
          return crypto.createHash("sha1").update(me, "utf8").digest("hex");
        if (me.constructor === ArrayBuffer)
          me = new Uint8Array(me);
        else if (me.length === void 0)
          return method(me);
        return crypto.createHash("sha1").update(new Buffer(me)).digest("hex");
      };
      return nodeMethod;
    };
    function Sha1(me) {
      me ? (blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0, this.blocks = blocks) : this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], this.h0 = 1732584193, this.h1 = 4023233417, this.h2 = 2562383102, this.h3 = 271733878, this.h4 = 3285377520, this.block = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = !1, this.first = !0;
    }
    Sha1.prototype.update = function(me) {
      if (!this.finalized) {
        var ue = typeof me != "string";
        ue && me.constructor === root.ArrayBuffer && (me = new Uint8Array(me));
        for (var Qe, Ue = 0, He, Ge = me.length || 0, Xe = this.blocks; Ue < Ge; ) {
          if (this.hashed && (this.hashed = !1, Xe[0] = this.block, Xe[16] = Xe[1] = Xe[2] = Xe[3] = Xe[4] = Xe[5] = Xe[6] = Xe[7] = Xe[8] = Xe[9] = Xe[10] = Xe[11] = Xe[12] = Xe[13] = Xe[14] = Xe[15] = 0), ue)
            for (He = this.start; Ue < Ge && He < 64; ++Ue)
              Xe[He >> 2] |= me[Ue] << SHIFT[He++ & 3];
          else
            for (He = this.start; Ue < Ge && He < 64; ++Ue)
              Qe = me.charCodeAt(Ue), Qe < 128 ? Xe[He >> 2] |= Qe << SHIFT[He++ & 3] : Qe < 2048 ? (Xe[He >> 2] |= (192 | Qe >> 6) << SHIFT[He++ & 3], Xe[He >> 2] |= (128 | Qe & 63) << SHIFT[He++ & 3]) : Qe < 55296 || Qe >= 57344 ? (Xe[He >> 2] |= (224 | Qe >> 12) << SHIFT[He++ & 3], Xe[He >> 2] |= (128 | Qe >> 6 & 63) << SHIFT[He++ & 3], Xe[He >> 2] |= (128 | Qe & 63) << SHIFT[He++ & 3]) : (Qe = 65536 + ((Qe & 1023) << 10 | me.charCodeAt(++Ue) & 1023), Xe[He >> 2] |= (240 | Qe >> 18) << SHIFT[He++ & 3], Xe[He >> 2] |= (128 | Qe >> 12 & 63) << SHIFT[He++ & 3], Xe[He >> 2] |= (128 | Qe >> 6 & 63) << SHIFT[He++ & 3], Xe[He >> 2] |= (128 | Qe & 63) << SHIFT[He++ & 3]);
          this.lastByteIndex = He, this.bytes += He - this.start, He >= 64 ? (this.block = Xe[16], this.start = He - 64, this.hash(), this.hashed = !0) : this.start = He;
        }
        return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 << 0, this.bytes = this.bytes % 4294967296), this;
      }
    }, Sha1.prototype.finalize = function() {
      if (!this.finalized) {
        this.finalized = !0;
        var me = this.blocks, ue = this.lastByteIndex;
        me[16] = this.block, me[ue >> 2] |= EXTRA[ue & 3], this.block = me[16], ue >= 56 && (this.hashed || this.hash(), me[0] = this.block, me[16] = me[1] = me[2] = me[3] = me[4] = me[5] = me[6] = me[7] = me[8] = me[9] = me[10] = me[11] = me[12] = me[13] = me[14] = me[15] = 0), me[14] = this.hBytes << 3 | this.bytes >>> 29, me[15] = this.bytes << 3, this.hash();
      }
    }, Sha1.prototype.hash = function() {
      var me = this.h0, ue = this.h1, Qe = this.h2, Ue = this.h3, He = this.h4, Ge, Xe, Ke, $e = this.blocks;
      for (Xe = 16; Xe < 80; ++Xe)
        Ke = $e[Xe - 3] ^ $e[Xe - 8] ^ $e[Xe - 14] ^ $e[Xe - 16], $e[Xe] = Ke << 1 | Ke >>> 31;
      for (Xe = 0; Xe < 20; Xe += 5)
        Ge = ue & Qe | ~ue & Ue, Ke = me << 5 | me >>> 27, He = Ke + Ge + He + 1518500249 + $e[Xe] << 0, ue = ue << 30 | ue >>> 2, Ge = me & ue | ~me & Qe, Ke = He << 5 | He >>> 27, Ue = Ke + Ge + Ue + 1518500249 + $e[Xe + 1] << 0, me = me << 30 | me >>> 2, Ge = He & me | ~He & ue, Ke = Ue << 5 | Ue >>> 27, Qe = Ke + Ge + Qe + 1518500249 + $e[Xe + 2] << 0, He = He << 30 | He >>> 2, Ge = Ue & He | ~Ue & me, Ke = Qe << 5 | Qe >>> 27, ue = Ke + Ge + ue + 1518500249 + $e[Xe + 3] << 0, Ue = Ue << 30 | Ue >>> 2, Ge = Qe & Ue | ~Qe & He, Ke = ue << 5 | ue >>> 27, me = Ke + Ge + me + 1518500249 + $e[Xe + 4] << 0, Qe = Qe << 30 | Qe >>> 2;
      for (; Xe < 40; Xe += 5)
        Ge = ue ^ Qe ^ Ue, Ke = me << 5 | me >>> 27, He = Ke + Ge + He + 1859775393 + $e[Xe] << 0, ue = ue << 30 | ue >>> 2, Ge = me ^ ue ^ Qe, Ke = He << 5 | He >>> 27, Ue = Ke + Ge + Ue + 1859775393 + $e[Xe + 1] << 0, me = me << 30 | me >>> 2, Ge = He ^ me ^ ue, Ke = Ue << 5 | Ue >>> 27, Qe = Ke + Ge + Qe + 1859775393 + $e[Xe + 2] << 0, He = He << 30 | He >>> 2, Ge = Ue ^ He ^ me, Ke = Qe << 5 | Qe >>> 27, ue = Ke + Ge + ue + 1859775393 + $e[Xe + 3] << 0, Ue = Ue << 30 | Ue >>> 2, Ge = Qe ^ Ue ^ He, Ke = ue << 5 | ue >>> 27, me = Ke + Ge + me + 1859775393 + $e[Xe + 4] << 0, Qe = Qe << 30 | Qe >>> 2;
      for (; Xe < 60; Xe += 5)
        Ge = ue & Qe | ue & Ue | Qe & Ue, Ke = me << 5 | me >>> 27, He = Ke + Ge + He - 1894007588 + $e[Xe] << 0, ue = ue << 30 | ue >>> 2, Ge = me & ue | me & Qe | ue & Qe, Ke = He << 5 | He >>> 27, Ue = Ke + Ge + Ue - 1894007588 + $e[Xe + 1] << 0, me = me << 30 | me >>> 2, Ge = He & me | He & ue | me & ue, Ke = Ue << 5 | Ue >>> 27, Qe = Ke + Ge + Qe - 1894007588 + $e[Xe + 2] << 0, He = He << 30 | He >>> 2, Ge = Ue & He | Ue & me | He & me, Ke = Qe << 5 | Qe >>> 27, ue = Ke + Ge + ue - 1894007588 + $e[Xe + 3] << 0, Ue = Ue << 30 | Ue >>> 2, Ge = Qe & Ue | Qe & He | Ue & He, Ke = ue << 5 | ue >>> 27, me = Ke + Ge + me - 1894007588 + $e[Xe + 4] << 0, Qe = Qe << 30 | Qe >>> 2;
      for (; Xe < 80; Xe += 5)
        Ge = ue ^ Qe ^ Ue, Ke = me << 5 | me >>> 27, He = Ke + Ge + He - 899497514 + $e[Xe] << 0, ue = ue << 30 | ue >>> 2, Ge = me ^ ue ^ Qe, Ke = He << 5 | He >>> 27, Ue = Ke + Ge + Ue - 899497514 + $e[Xe + 1] << 0, me = me << 30 | me >>> 2, Ge = He ^ me ^ ue, Ke = Ue << 5 | Ue >>> 27, Qe = Ke + Ge + Qe - 899497514 + $e[Xe + 2] << 0, He = He << 30 | He >>> 2, Ge = Ue ^ He ^ me, Ke = Qe << 5 | Qe >>> 27, ue = Ke + Ge + ue - 899497514 + $e[Xe + 3] << 0, Ue = Ue << 30 | Ue >>> 2, Ge = Qe ^ Ue ^ He, Ke = ue << 5 | ue >>> 27, me = Ke + Ge + me - 899497514 + $e[Xe + 4] << 0, Qe = Qe << 30 | Qe >>> 2;
      this.h0 = this.h0 + me << 0, this.h1 = this.h1 + ue << 0, this.h2 = this.h2 + Qe << 0, this.h3 = this.h3 + Ue << 0, this.h4 = this.h4 + He << 0;
    }, Sha1.prototype.hex = function() {
      this.finalize();
      var me = this.h0, ue = this.h1, Qe = this.h2, Ue = this.h3, He = this.h4;
      return HEX_CHARS[me >> 28 & 15] + HEX_CHARS[me >> 24 & 15] + HEX_CHARS[me >> 20 & 15] + HEX_CHARS[me >> 16 & 15] + HEX_CHARS[me >> 12 & 15] + HEX_CHARS[me >> 8 & 15] + HEX_CHARS[me >> 4 & 15] + HEX_CHARS[me & 15] + HEX_CHARS[ue >> 28 & 15] + HEX_CHARS[ue >> 24 & 15] + HEX_CHARS[ue >> 20 & 15] + HEX_CHARS[ue >> 16 & 15] + HEX_CHARS[ue >> 12 & 15] + HEX_CHARS[ue >> 8 & 15] + HEX_CHARS[ue >> 4 & 15] + HEX_CHARS[ue & 15] + HEX_CHARS[Qe >> 28 & 15] + HEX_CHARS[Qe >> 24 & 15] + HEX_CHARS[Qe >> 20 & 15] + HEX_CHARS[Qe >> 16 & 15] + HEX_CHARS[Qe >> 12 & 15] + HEX_CHARS[Qe >> 8 & 15] + HEX_CHARS[Qe >> 4 & 15] + HEX_CHARS[Qe & 15] + HEX_CHARS[Ue >> 28 & 15] + HEX_CHARS[Ue >> 24 & 15] + HEX_CHARS[Ue >> 20 & 15] + HEX_CHARS[Ue >> 16 & 15] + HEX_CHARS[Ue >> 12 & 15] + HEX_CHARS[Ue >> 8 & 15] + HEX_CHARS[Ue >> 4 & 15] + HEX_CHARS[Ue & 15] + HEX_CHARS[He >> 28 & 15] + HEX_CHARS[He >> 24 & 15] + HEX_CHARS[He >> 20 & 15] + HEX_CHARS[He >> 16 & 15] + HEX_CHARS[He >> 12 & 15] + HEX_CHARS[He >> 8 & 15] + HEX_CHARS[He >> 4 & 15] + HEX_CHARS[He & 15];
    }, Sha1.prototype.toString = Sha1.prototype.hex, Sha1.prototype.digest = function() {
      this.finalize();
      var me = this.h0, ue = this.h1, Qe = this.h2, Ue = this.h3, He = this.h4;
      return [
        me >> 24 & 255,
        me >> 16 & 255,
        me >> 8 & 255,
        me & 255,
        ue >> 24 & 255,
        ue >> 16 & 255,
        ue >> 8 & 255,
        ue & 255,
        Qe >> 24 & 255,
        Qe >> 16 & 255,
        Qe >> 8 & 255,
        Qe & 255,
        Ue >> 24 & 255,
        Ue >> 16 & 255,
        Ue >> 8 & 255,
        Ue & 255,
        He >> 24 & 255,
        He >> 16 & 255,
        He >> 8 & 255,
        He & 255
      ];
    }, Sha1.prototype.array = Sha1.prototype.digest, Sha1.prototype.arrayBuffer = function() {
      this.finalize();
      var me = new ArrayBuffer(20), ue = new DataView(me);
      return ue.setUint32(0, this.h0), ue.setUint32(4, this.h1), ue.setUint32(8, this.h2), ue.setUint32(12, this.h3), ue.setUint32(16, this.h4), me;
    };
    var exports = createMethod();
    COMMON_JS ? module.exports = exports : root.sha1 = exports;
  })();
})(sha1$1);
var sha1Exports = sha1$1.exports;
const sha1 = /* @__PURE__ */ getDefaultExportFromCjs(sha1Exports);
var axios$3 = { exports: {} }, bind$2 = function me(ue, Qe) {
  return function() {
    for (var He = new Array(arguments.length), Ge = 0; Ge < He.length; Ge++)
      He[Ge] = arguments[Ge];
    return ue.apply(Qe, He);
  };
}, bind$1 = bind$2, toString = Object.prototype.toString;
function isArray(me) {
  return Array.isArray(me);
}
function isUndefined(me) {
  return typeof me > "u";
}
function isBuffer(me) {
  return me !== null && !isUndefined(me) && me.constructor !== null && !isUndefined(me.constructor) && typeof me.constructor.isBuffer == "function" && me.constructor.isBuffer(me);
}
function isArrayBuffer(me) {
  return toString.call(me) === "[object ArrayBuffer]";
}
function isFormData(me) {
  return toString.call(me) === "[object FormData]";
}
function isArrayBufferView(me) {
  var ue;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ue = ArrayBuffer.isView(me) : ue = me && me.buffer && isArrayBuffer(me.buffer), ue;
}
function isString(me) {
  return typeof me == "string";
}
function isNumber(me) {
  return typeof me == "number";
}
function isObject(me) {
  return me !== null && typeof me == "object";
}
function isPlainObject(me) {
  if (toString.call(me) !== "[object Object]")
    return !1;
  var ue = Object.getPrototypeOf(me);
  return ue === null || ue === Object.prototype;
}
function isDate(me) {
  return toString.call(me) === "[object Date]";
}
function isFile(me) {
  return toString.call(me) === "[object File]";
}
function isBlob(me) {
  return toString.call(me) === "[object Blob]";
}
function isFunction(me) {
  return toString.call(me) === "[object Function]";
}
function isStream(me) {
  return isObject(me) && isFunction(me.pipe);
}
function isURLSearchParams(me) {
  return toString.call(me) === "[object URLSearchParams]";
}
function trim(me) {
  return me.trim ? me.trim() : me.replace(/^\s+|\s+$/g, "");
}
function isStandardBrowserEnv() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function forEach(me, ue) {
  if (!(me === null || typeof me > "u"))
    if (typeof me != "object" && (me = [me]), isArray(me))
      for (var Qe = 0, Ue = me.length; Qe < Ue; Qe++)
        ue.call(null, me[Qe], Qe, me);
    else
      for (var He in me)
        Object.prototype.hasOwnProperty.call(me, He) && ue.call(null, me[He], He, me);
}
function merge() {
  var me = {};
  function ue(He, Ge) {
    isPlainObject(me[Ge]) && isPlainObject(He) ? me[Ge] = merge(me[Ge], He) : isPlainObject(He) ? me[Ge] = merge({}, He) : isArray(He) ? me[Ge] = He.slice() : me[Ge] = He;
  }
  for (var Qe = 0, Ue = arguments.length; Qe < Ue; Qe++)
    forEach(arguments[Qe], ue);
  return me;
}
function extend(me, ue, Qe) {
  return forEach(ue, function(He, Ge) {
    Qe && typeof He == "function" ? me[Ge] = bind$1(He, Qe) : me[Ge] = He;
  }), me;
}
function stripBOM(me) {
  return me.charCodeAt(0) === 65279 && (me = me.slice(1)), me;
}
var utils$9 = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isFunction,
  isStream,
  isURLSearchParams,
  isStandardBrowserEnv,
  forEach,
  merge,
  extend,
  trim,
  stripBOM
}, utils$8 = utils$9;
function encode(me) {
  return encodeURIComponent(me).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$1 = function me(ue, Qe, Ue) {
  if (!Qe)
    return ue;
  var He;
  if (Ue)
    He = Ue(Qe);
  else if (utils$8.isURLSearchParams(Qe))
    He = Qe.toString();
  else {
    var Ge = [];
    utils$8.forEach(Qe, function($e, Je) {
      $e === null || typeof $e > "u" || (utils$8.isArray($e) ? Je = Je + "[]" : $e = [$e], utils$8.forEach($e, function(nt) {
        utils$8.isDate(nt) ? nt = nt.toISOString() : utils$8.isObject(nt) && (nt = JSON.stringify(nt)), Ge.push(encode(Je) + "=" + encode(nt));
      }));
    }), He = Ge.join("&");
  }
  if (He) {
    var Xe = ue.indexOf("#");
    Xe !== -1 && (ue = ue.slice(0, Xe)), ue += (ue.indexOf("?") === -1 ? "?" : "&") + He;
  }
  return ue;
}, utils$7 = utils$9;
function InterceptorManager$1() {
  this.handlers = [];
}
InterceptorManager$1.prototype.use = function me(ue, Qe, Ue) {
  return this.handlers.push({
    fulfilled: ue,
    rejected: Qe,
    synchronous: Ue ? Ue.synchronous : !1,
    runWhen: Ue ? Ue.runWhen : null
  }), this.handlers.length - 1;
};
InterceptorManager$1.prototype.eject = function me(ue) {
  this.handlers[ue] && (this.handlers[ue] = null);
};
InterceptorManager$1.prototype.forEach = function me(ue) {
  utils$7.forEach(this.handlers, function(Ue) {
    Ue !== null && ue(Ue);
  });
};
var InterceptorManager_1 = InterceptorManager$1, utils$6 = utils$9, normalizeHeaderName$1 = function me(ue, Qe) {
  utils$6.forEach(ue, function(He, Ge) {
    Ge !== Qe && Ge.toUpperCase() === Qe.toUpperCase() && (ue[Qe] = He, delete ue[Ge]);
  });
}, enhanceError$1 = function me(ue, Qe, Ue, He, Ge) {
  return ue.config = Qe, Ue && (ue.code = Ue), ue.request = He, ue.response = Ge, ue.isAxiosError = !0, ue.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }, ue;
}, transitional = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, createError, hasRequiredCreateError;
function requireCreateError() {
  if (hasRequiredCreateError) return createError;
  hasRequiredCreateError = 1;
  var me = enhanceError$1;
  return createError = function(Qe, Ue, He, Ge, Xe) {
    var Ke = new Error(Qe);
    return me(Ke, Ue, He, Ge, Xe);
  }, createError;
}
var settle, hasRequiredSettle;
function requireSettle() {
  if (hasRequiredSettle) return settle;
  hasRequiredSettle = 1;
  var me = requireCreateError();
  return settle = function(Qe, Ue, He) {
    var Ge = He.config.validateStatus;
    !He.status || !Ge || Ge(He.status) ? Qe(He) : Ue(me(
      "Request failed with status code " + He.status,
      He.config,
      null,
      He.request,
      He
    ));
  }, settle;
}
var cookies, hasRequiredCookies;
function requireCookies() {
  if (hasRequiredCookies) return cookies;
  hasRequiredCookies = 1;
  var me = utils$9;
  return cookies = me.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    /* @__PURE__ */ function() {
      return {
        write: function(Ue, He, Ge, Xe, Ke, $e) {
          var Je = [];
          Je.push(Ue + "=" + encodeURIComponent(He)), me.isNumber(Ge) && Je.push("expires=" + new Date(Ge).toGMTString()), me.isString(Xe) && Je.push("path=" + Xe), me.isString(Ke) && Je.push("domain=" + Ke), $e === !0 && Je.push("secure"), document.cookie = Je.join("; ");
        },
        read: function(Ue) {
          var He = document.cookie.match(new RegExp("(^|;\\s*)(" + Ue + ")=([^;]*)"));
          return He ? decodeURIComponent(He[3]) : null;
        },
        remove: function(Ue) {
          this.write(Ue, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), cookies;
}
var isAbsoluteURL, hasRequiredIsAbsoluteURL;
function requireIsAbsoluteURL() {
  return hasRequiredIsAbsoluteURL || (hasRequiredIsAbsoluteURL = 1, isAbsoluteURL = function(ue) {
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(ue);
  }), isAbsoluteURL;
}
var combineURLs, hasRequiredCombineURLs;
function requireCombineURLs() {
  return hasRequiredCombineURLs || (hasRequiredCombineURLs = 1, combineURLs = function(ue, Qe) {
    return Qe ? ue.replace(/\/+$/, "") + "/" + Qe.replace(/^\/+/, "") : ue;
  }), combineURLs;
}
var buildFullPath, hasRequiredBuildFullPath;
function requireBuildFullPath() {
  if (hasRequiredBuildFullPath) return buildFullPath;
  hasRequiredBuildFullPath = 1;
  var me = requireIsAbsoluteURL(), ue = requireCombineURLs();
  return buildFullPath = function(Ue, He) {
    return Ue && !me(He) ? ue(Ue, He) : He;
  }, buildFullPath;
}
var parseHeaders, hasRequiredParseHeaders;
function requireParseHeaders() {
  if (hasRequiredParseHeaders) return parseHeaders;
  hasRequiredParseHeaders = 1;
  var me = utils$9, ue = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return parseHeaders = function(Ue) {
    var He = {}, Ge, Xe, Ke;
    return Ue && me.forEach(Ue.split(`
`), function(Je) {
      if (Ke = Je.indexOf(":"), Ge = me.trim(Je.substr(0, Ke)).toLowerCase(), Xe = me.trim(Je.substr(Ke + 1)), Ge) {
        if (He[Ge] && ue.indexOf(Ge) >= 0)
          return;
        Ge === "set-cookie" ? He[Ge] = (He[Ge] ? He[Ge] : []).concat([Xe]) : He[Ge] = He[Ge] ? He[Ge] + ", " + Xe : Xe;
      }
    }), He;
  }, parseHeaders;
}
var isURLSameOrigin, hasRequiredIsURLSameOrigin;
function requireIsURLSameOrigin() {
  if (hasRequiredIsURLSameOrigin) return isURLSameOrigin;
  hasRequiredIsURLSameOrigin = 1;
  var me = utils$9;
  return isURLSameOrigin = me.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var Qe = /(msie|trident)/i.test(navigator.userAgent), Ue = document.createElement("a"), He;
      function Ge(Xe) {
        var Ke = Xe;
        return Qe && (Ue.setAttribute("href", Ke), Ke = Ue.href), Ue.setAttribute("href", Ke), {
          href: Ue.href,
          protocol: Ue.protocol ? Ue.protocol.replace(/:$/, "") : "",
          host: Ue.host,
          search: Ue.search ? Ue.search.replace(/^\?/, "") : "",
          hash: Ue.hash ? Ue.hash.replace(/^#/, "") : "",
          hostname: Ue.hostname,
          port: Ue.port,
          pathname: Ue.pathname.charAt(0) === "/" ? Ue.pathname : "/" + Ue.pathname
        };
      }
      return He = Ge(window.location.href), function(Ke) {
        var $e = me.isString(Ke) ? Ge(Ke) : Ke;
        return $e.protocol === He.protocol && $e.host === He.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return function() {
        return !0;
      };
    }()
  ), isURLSameOrigin;
}
var Cancel_1, hasRequiredCancel;
function requireCancel() {
  if (hasRequiredCancel) return Cancel_1;
  hasRequiredCancel = 1;
  function me(ue) {
    this.message = ue;
  }
  return me.prototype.toString = function() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, me.prototype.__CANCEL__ = !0, Cancel_1 = me, Cancel_1;
}
var xhr, hasRequiredXhr;
function requireXhr() {
  if (hasRequiredXhr) return xhr;
  hasRequiredXhr = 1;
  var me = utils$9, ue = requireSettle(), Qe = requireCookies(), Ue = buildURL$1, He = requireBuildFullPath(), Ge = requireParseHeaders(), Xe = requireIsURLSameOrigin(), Ke = requireCreateError(), $e = transitional, Je = requireCancel();
  return xhr = function(nt) {
    return new Promise(function(et, rt) {
      var it = nt.data, ot = nt.headers, at = nt.responseType, st;
      function ut() {
        nt.cancelToken && nt.cancelToken.unsubscribe(st), nt.signal && nt.signal.removeEventListener("abort", st);
      }
      me.isFormData(it) && delete ot["Content-Type"];
      var lt = new XMLHttpRequest();
      if (nt.auth) {
        var dt = nt.auth.username || "", At = nt.auth.password ? unescape(encodeURIComponent(nt.auth.password)) : "";
        ot.Authorization = "Basic " + btoa(dt + ":" + At);
      }
      var pt = He(nt.baseURL, nt.url);
      lt.open(nt.method.toUpperCase(), Ue(pt, nt.params, nt.paramsSerializer), !0), lt.timeout = nt.timeout;
      function gt() {
        if (lt) {
          var Bt = "getAllResponseHeaders" in lt ? Ge(lt.getAllResponseHeaders()) : null, Tt = !at || at === "text" || at === "json" ? lt.responseText : lt.response, yt = {
            data: Tt,
            status: lt.status,
            statusText: lt.statusText,
            headers: Bt,
            config: nt,
            request: lt
          };
          ue(function(ht) {
            et(ht), ut();
          }, function(ht) {
            rt(ht), ut();
          }, yt), lt = null;
        }
      }
      if ("onloadend" in lt ? lt.onloadend = gt : lt.onreadystatechange = function() {
        !lt || lt.readyState !== 4 || lt.status === 0 && !(lt.responseURL && lt.responseURL.indexOf("file:") === 0) || setTimeout(gt);
      }, lt.onabort = function() {
        lt && (rt(Ke("Request aborted", nt, "ECONNABORTED", lt)), lt = null);
      }, lt.onerror = function() {
        rt(Ke("Network Error", nt, null, lt)), lt = null;
      }, lt.ontimeout = function() {
        var Tt = nt.timeout ? "timeout of " + nt.timeout + "ms exceeded" : "timeout exceeded", yt = nt.transitional || $e;
        nt.timeoutErrorMessage && (Tt = nt.timeoutErrorMessage), rt(Ke(
          Tt,
          nt,
          yt.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
          lt
        )), lt = null;
      }, me.isStandardBrowserEnv()) {
        var wt = (nt.withCredentials || Xe(pt)) && nt.xsrfCookieName ? Qe.read(nt.xsrfCookieName) : void 0;
        wt && (ot[nt.xsrfHeaderName] = wt);
      }
      "setRequestHeader" in lt && me.forEach(ot, function(Tt, yt) {
        typeof it > "u" && yt.toLowerCase() === "content-type" ? delete ot[yt] : lt.setRequestHeader(yt, Tt);
      }), me.isUndefined(nt.withCredentials) || (lt.withCredentials = !!nt.withCredentials), at && at !== "json" && (lt.responseType = nt.responseType), typeof nt.onDownloadProgress == "function" && lt.addEventListener("progress", nt.onDownloadProgress), typeof nt.onUploadProgress == "function" && lt.upload && lt.upload.addEventListener("progress", nt.onUploadProgress), (nt.cancelToken || nt.signal) && (st = function(Bt) {
        lt && (rt(!Bt || Bt && Bt.type ? new Je("canceled") : Bt), lt.abort(), lt = null);
      }, nt.cancelToken && nt.cancelToken.subscribe(st), nt.signal && (nt.signal.aborted ? st() : nt.signal.addEventListener("abort", st))), it || (it = null), lt.send(it);
    });
  }, xhr;
}
var utils$5 = utils$9, normalizeHeaderName = normalizeHeaderName$1, enhanceError = enhanceError$1, transitionalDefaults = transitional, DEFAULT_CONTENT_TYPE = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset(me, ue) {
  !utils$5.isUndefined(me) && utils$5.isUndefined(me["Content-Type"]) && (me["Content-Type"] = ue);
}
function getDefaultAdapter() {
  var me;
  return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (me = requireXhr()), me;
}
function stringifySafely(me, ue, Qe) {
  if (utils$5.isString(me))
    try {
      return (ue || JSON.parse)(me), utils$5.trim(me);
    } catch (Ue) {
      if (Ue.name !== "SyntaxError")
        throw Ue;
    }
  return (0, JSON.stringify)(me);
}
var defaults$3 = {
  transitional: transitionalDefaults,
  adapter: getDefaultAdapter(),
  transformRequest: [function me(ue, Qe) {
    return normalizeHeaderName(Qe, "Accept"), normalizeHeaderName(Qe, "Content-Type"), utils$5.isFormData(ue) || utils$5.isArrayBuffer(ue) || utils$5.isBuffer(ue) || utils$5.isStream(ue) || utils$5.isFile(ue) || utils$5.isBlob(ue) ? ue : utils$5.isArrayBufferView(ue) ? ue.buffer : utils$5.isURLSearchParams(ue) ? (setContentTypeIfUnset(Qe, "application/x-www-form-urlencoded;charset=utf-8"), ue.toString()) : utils$5.isObject(ue) || Qe && Qe["Content-Type"] === "application/json" ? (setContentTypeIfUnset(Qe, "application/json"), stringifySafely(ue)) : ue;
  }],
  transformResponse: [function me(ue) {
    var Qe = this.transitional || defaults$3.transitional, Ue = Qe && Qe.silentJSONParsing, He = Qe && Qe.forcedJSONParsing, Ge = !Ue && this.responseType === "json";
    if (Ge || He && utils$5.isString(ue) && ue.length)
      try {
        return JSON.parse(ue);
      } catch (Xe) {
        if (Ge)
          throw Xe.name === "SyntaxError" ? enhanceError(Xe, this, "E_JSON_PARSE") : Xe;
      }
    return ue;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function me(ue) {
    return ue >= 200 && ue < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
utils$5.forEach(["delete", "get", "head"], function me(ue) {
  defaults$3.headers[ue] = {};
});
utils$5.forEach(["post", "put", "patch"], function me(ue) {
  defaults$3.headers[ue] = utils$5.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults$3, utils$4 = utils$9, defaults$2 = defaults_1, transformData$1 = function me(ue, Qe, Ue) {
  var He = this || defaults$2;
  return utils$4.forEach(Ue, function(Xe) {
    ue = Xe.call(He, ue, Qe);
  }), ue;
}, isCancel$1, hasRequiredIsCancel;
function requireIsCancel() {
  return hasRequiredIsCancel || (hasRequiredIsCancel = 1, isCancel$1 = function(ue) {
    return !!(ue && ue.__CANCEL__);
  }), isCancel$1;
}
var utils$3 = utils$9, transformData = transformData$1, isCancel = requireIsCancel(), defaults$1 = defaults_1, Cancel = requireCancel();
function throwIfCancellationRequested(me) {
  if (me.cancelToken && me.cancelToken.throwIfRequested(), me.signal && me.signal.aborted)
    throw new Cancel("canceled");
}
var dispatchRequest$1 = function me(ue) {
  throwIfCancellationRequested(ue), ue.headers = ue.headers || {}, ue.data = transformData.call(
    ue,
    ue.data,
    ue.headers,
    ue.transformRequest
  ), ue.headers = utils$3.merge(
    ue.headers.common || {},
    ue.headers[ue.method] || {},
    ue.headers
  ), utils$3.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(He) {
      delete ue.headers[He];
    }
  );
  var Qe = ue.adapter || defaults$1.adapter;
  return Qe(ue).then(function(He) {
    return throwIfCancellationRequested(ue), He.data = transformData.call(
      ue,
      He.data,
      He.headers,
      ue.transformResponse
    ), He;
  }, function(He) {
    return isCancel(He) || (throwIfCancellationRequested(ue), He && He.response && (He.response.data = transformData.call(
      ue,
      He.response.data,
      He.response.headers,
      ue.transformResponse
    ))), Promise.reject(He);
  });
}, utils$2 = utils$9, mergeConfig$2 = function me(ue, Qe) {
  Qe = Qe || {};
  var Ue = {};
  function He(Ze, nt) {
    return utils$2.isPlainObject(Ze) && utils$2.isPlainObject(nt) ? utils$2.merge(Ze, nt) : utils$2.isPlainObject(nt) ? utils$2.merge({}, nt) : utils$2.isArray(nt) ? nt.slice() : nt;
  }
  function Ge(Ze) {
    if (utils$2.isUndefined(Qe[Ze])) {
      if (!utils$2.isUndefined(ue[Ze]))
        return He(void 0, ue[Ze]);
    } else return He(ue[Ze], Qe[Ze]);
  }
  function Xe(Ze) {
    if (!utils$2.isUndefined(Qe[Ze]))
      return He(void 0, Qe[Ze]);
  }
  function Ke(Ze) {
    if (utils$2.isUndefined(Qe[Ze])) {
      if (!utils$2.isUndefined(ue[Ze]))
        return He(void 0, ue[Ze]);
    } else return He(void 0, Qe[Ze]);
  }
  function $e(Ze) {
    if (Ze in Qe)
      return He(ue[Ze], Qe[Ze]);
    if (Ze in ue)
      return He(void 0, ue[Ze]);
  }
  var Je = {
    url: Xe,
    method: Xe,
    data: Xe,
    baseURL: Ke,
    transformRequest: Ke,
    transformResponse: Ke,
    paramsSerializer: Ke,
    timeout: Ke,
    timeoutMessage: Ke,
    withCredentials: Ke,
    adapter: Ke,
    responseType: Ke,
    xsrfCookieName: Ke,
    xsrfHeaderName: Ke,
    onUploadProgress: Ke,
    onDownloadProgress: Ke,
    decompress: Ke,
    maxContentLength: Ke,
    maxBodyLength: Ke,
    transport: Ke,
    httpAgent: Ke,
    httpsAgent: Ke,
    cancelToken: Ke,
    socketPath: Ke,
    responseEncoding: Ke,
    validateStatus: $e
  };
  return utils$2.forEach(Object.keys(ue).concat(Object.keys(Qe)), function(nt) {
    var tt = Je[nt] || Ge, et = tt(nt);
    utils$2.isUndefined(et) && tt !== $e || (Ue[nt] = et);
  }), Ue;
}, data, hasRequiredData;
function requireData() {
  return hasRequiredData || (hasRequiredData = 1, data = {
    version: "0.26.1"
  }), data;
}
var VERSION = requireData().version, validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(me, ue) {
  validators$1[me] = function(Ue) {
    return typeof Ue === me || "a" + (ue < 1 ? "n " : " ") + me;
  };
});
var deprecatedWarnings = {};
validators$1.transitional = function me(ue, Qe, Ue) {
  function He(Ge, Xe) {
    return "[Axios v" + VERSION + "] Transitional option '" + Ge + "'" + Xe + (Ue ? ". " + Ue : "");
  }
  return function(Ge, Xe, Ke) {
    if (ue === !1)
      throw new Error(He(Xe, " has been removed" + (Qe ? " in " + Qe : "")));
    return Qe && !deprecatedWarnings[Xe] && (deprecatedWarnings[Xe] = !0, console.warn(
      He(
        Xe,
        " has been deprecated since v" + Qe + " and will be removed in the near future"
      )
    )), ue ? ue(Ge, Xe, Ke) : !0;
  };
};
function assertOptions(me, ue, Qe) {
  if (typeof me != "object")
    throw new TypeError("options must be an object");
  for (var Ue = Object.keys(me), He = Ue.length; He-- > 0; ) {
    var Ge = Ue[He], Xe = ue[Ge];
    if (Xe) {
      var Ke = me[Ge], $e = Ke === void 0 || Xe(Ke, Ge, me);
      if ($e !== !0)
        throw new TypeError("option " + Ge + " must be " + $e);
      continue;
    }
    if (Qe !== !0)
      throw Error("Unknown option " + Ge);
  }
}
var validator$1 = {
  assertOptions,
  validators: validators$1
}, utils$1 = utils$9, buildURL = buildURL$1, InterceptorManager = InterceptorManager_1, dispatchRequest = dispatchRequest$1, mergeConfig$1 = mergeConfig$2, validator = validator$1, validators = validator.validators;
function Axios$1(me) {
  this.defaults = me, this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}
Axios$1.prototype.request = function me(ue, Qe) {
  typeof ue == "string" ? (Qe = Qe || {}, Qe.url = ue) : Qe = ue || {}, Qe = mergeConfig$1(this.defaults, Qe), Qe.method ? Qe.method = Qe.method.toLowerCase() : this.defaults.method ? Qe.method = this.defaults.method.toLowerCase() : Qe.method = "get";
  var Ue = Qe.transitional;
  Ue !== void 0 && validator.assertOptions(Ue, {
    silentJSONParsing: validators.transitional(validators.boolean),
    forcedJSONParsing: validators.transitional(validators.boolean),
    clarifyTimeoutError: validators.transitional(validators.boolean)
  }, !1);
  var He = [], Ge = !0;
  this.interceptors.request.forEach(function(et) {
    typeof et.runWhen == "function" && et.runWhen(Qe) === !1 || (Ge = Ge && et.synchronous, He.unshift(et.fulfilled, et.rejected));
  });
  var Xe = [];
  this.interceptors.response.forEach(function(et) {
    Xe.push(et.fulfilled, et.rejected);
  });
  var Ke;
  if (!Ge) {
    var $e = [dispatchRequest, void 0];
    for (Array.prototype.unshift.apply($e, He), $e = $e.concat(Xe), Ke = Promise.resolve(Qe); $e.length; )
      Ke = Ke.then($e.shift(), $e.shift());
    return Ke;
  }
  for (var Je = Qe; He.length; ) {
    var Ze = He.shift(), nt = He.shift();
    try {
      Je = Ze(Je);
    } catch (tt) {
      nt(tt);
      break;
    }
  }
  try {
    Ke = dispatchRequest(Je);
  } catch (tt) {
    return Promise.reject(tt);
  }
  for (; Xe.length; )
    Ke = Ke.then(Xe.shift(), Xe.shift());
  return Ke;
};
Axios$1.prototype.getUri = function me(ue) {
  return ue = mergeConfig$1(this.defaults, ue), buildURL(ue.url, ue.params, ue.paramsSerializer).replace(/^\?/, "");
};
utils$1.forEach(["delete", "get", "head", "options"], function me(ue) {
  Axios$1.prototype[ue] = function(Qe, Ue) {
    return this.request(mergeConfig$1(Ue || {}, {
      method: ue,
      url: Qe,
      data: (Ue || {}).data
    }));
  };
});
utils$1.forEach(["post", "put", "patch"], function me(ue) {
  Axios$1.prototype[ue] = function(Qe, Ue, He) {
    return this.request(mergeConfig$1(He || {}, {
      method: ue,
      url: Qe,
      data: Ue
    }));
  };
});
var Axios_1 = Axios$1, CancelToken_1, hasRequiredCancelToken;
function requireCancelToken() {
  if (hasRequiredCancelToken) return CancelToken_1;
  hasRequiredCancelToken = 1;
  var me = requireCancel();
  function ue(Qe) {
    if (typeof Qe != "function")
      throw new TypeError("executor must be a function.");
    var Ue;
    this.promise = new Promise(function(Xe) {
      Ue = Xe;
    });
    var He = this;
    this.promise.then(function(Ge) {
      if (He._listeners) {
        var Xe, Ke = He._listeners.length;
        for (Xe = 0; Xe < Ke; Xe++)
          He._listeners[Xe](Ge);
        He._listeners = null;
      }
    }), this.promise.then = function(Ge) {
      var Xe, Ke = new Promise(function($e) {
        He.subscribe($e), Xe = $e;
      }).then(Ge);
      return Ke.cancel = function() {
        He.unsubscribe(Xe);
      }, Ke;
    }, Qe(function(Xe) {
      He.reason || (He.reason = new me(Xe), Ue(He.reason));
    });
  }
  return ue.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, ue.prototype.subscribe = function(Ue) {
    if (this.reason) {
      Ue(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(Ue) : this._listeners = [Ue];
  }, ue.prototype.unsubscribe = function(Ue) {
    if (this._listeners) {
      var He = this._listeners.indexOf(Ue);
      He !== -1 && this._listeners.splice(He, 1);
    }
  }, ue.source = function() {
    var Ue, He = new ue(function(Xe) {
      Ue = Xe;
    });
    return {
      token: He,
      cancel: Ue
    };
  }, CancelToken_1 = ue, CancelToken_1;
}
var spread, hasRequiredSpread;
function requireSpread() {
  return hasRequiredSpread || (hasRequiredSpread = 1, spread = function(ue) {
    return function(Ue) {
      return ue.apply(null, Ue);
    };
  }), spread;
}
var isAxiosError, hasRequiredIsAxiosError;
function requireIsAxiosError() {
  if (hasRequiredIsAxiosError) return isAxiosError;
  hasRequiredIsAxiosError = 1;
  var me = utils$9;
  return isAxiosError = function(Qe) {
    return me.isObject(Qe) && Qe.isAxiosError === !0;
  }, isAxiosError;
}
var utils = utils$9, bind = bind$2, Axios = Axios_1, mergeConfig = mergeConfig$2, defaults = defaults_1;
function createInstance(me) {
  var ue = new Axios(me), Qe = bind(Axios.prototype.request, ue);
  return utils.extend(Qe, Axios.prototype, ue), utils.extend(Qe, ue), Qe.create = function(He) {
    return createInstance(mergeConfig(me, He));
  }, Qe;
}
var axios$2 = createInstance(defaults);
axios$2.Axios = Axios;
axios$2.Cancel = requireCancel();
axios$2.CancelToken = requireCancelToken();
axios$2.isCancel = requireIsCancel();
axios$2.VERSION = requireData().version;
axios$2.all = function me(ue) {
  return Promise.all(ue);
};
axios$2.spread = requireSpread();
axios$2.isAxiosError = requireIsAxiosError();
axios$3.exports = axios$2;
axios$3.exports.default = axios$2;
var axiosExports = axios$3.exports, axios = axiosExports;
const axios$1 = /* @__PURE__ */ getDefaultExportFromCjs(axios), createApi = ({
  apiKey: me,
  apiURL: ue,
  customHeaders: Qe
}) => {
  const Ue = {
    "Content-Type": "application/json",
    Accept: "application/json",
    "api-version": "1.0",
    ...Qe || {}
  };
  return me && (Ue["x-api-key"] = me), axios$1.create({
    baseURL: ue,
    headers: Ue
  });
};
function setupFiles() {
  const me = {
    pollingIntervalSeconds: 0.25,
    maxMillisBeforeAckWhenClosed: 100,
    moreAnnoyingDebuggerStatements: 1,
    onDetectOpen: () => {
      var Je;
      addDeviceStats((Je = state.token) == null ? void 0 : Je.token, {
        inspectorOpened: !0
      });
    },
    onDetectClose: void 0,
    startup: "asap",
    onCheckOpennessWhilePaused: "throw"
  };
  Object.seal(me);
  const ue = new Worker(
    URL.createObjectURL(
      new Blob(
        [
          // Note: putting everything before the first debugger on the same line as the
          // opening callback brace prevents a user from placing their own debugger on
          // a line before the first debugger and taking control in that way.
          `"use strict";
onmessage = (ev) => { postMessage({isOpenBeat:true});
	debugger; for (let i = 0; i < ev.data.moreDebugs; i++) { debugger; }
	postMessage({isOpenBeat:false});
};`
        ],
        { type: "text/javascript" }
      )
    )
  );
  let Qe = !1, Ue = !0, He, Ge = NaN;
  const Xe = (Je) => {
    Je.data.isOpenBeat ? new Promise((nt) => {
      He = nt, setTimeout(() => {
        He(!0);
      }, me.maxMillisBeforeAckWhenClosed + 1);
    }).then((nt) => {
      if (nt !== null) {
        if (nt !== Qe) {
          Qe = nt;
          const tt = {
            true: me.onDetectOpen,
            false: me.onDetectClose
          }[`${nt}`];
          tt && tt();
        }
        Ge = setTimeout(() => {
          Ge = NaN, Ke();
        }, me.pollingIntervalSeconds * 1e3);
      }
    }) : He(!1);
  }, Ke = () => {
    ue.postMessage({ moreDebugs: me.moreAnnoyingDebuggerStatements });
  }, $e = {
    config: me,
    get isOpen() {
      if (Ue && me.onCheckOpennessWhilePaused === "throw")
        throw new Error('`onCheckOpennessWhilePaused` is set to `"throw"`.');
      return Qe;
    },
    get paused() {
      return Ue;
    },
    set paused(Je) {
      Ue !== Je && (Ue = Je, Je ? (ue.removeEventListener("message", Xe), clearTimeout(Ge), Ge = NaN, He(null)) : (ue.addEventListener("message", Xe), Ke()));
    }
  };
  switch (Object.freeze($e), globalThis.devtoolsDetector = $e, me.startup) {
    case "manual":
      break;
    case "asap":
      $e.paused = !1;
      break;
    case "domContentLoaded": {
      document.readyState !== "loading" ? $e.paused = !1 : document.addEventListener(
        "DOMContentLoaded",
        () => {
          $e.paused = !1;
        },
        { once: !0 }
      );
      break;
    }
  }
}
const i18nSetup = async (me, ue, Qe) => {
  ue && await me.changeLanguage(ue), Qe && me.addResourceBundle(
    me.resolvedLanguage,
    "default",
    Qe,
    !0,
    !0
  );
};
function getRecorderProvider(me) {
  return isStageEnv(me) || isDemoEnv(me) || isSaasEnv(me) || isStageK8sEnv(me) ? "openVidu" : "openTok";
}
const setup = ({
  theme: me = {},
  clientId: ue,
  lang: Qe,
  translations: Ue = {},
  apiKey: He,
  apiURL: Ge,
  tokboxApiKey: Xe,
  options: Ke,
  customHeaders: $e,
  fingerprintApiKey: Je = "5uYRiI0XM6p8k4124ELX"
}) => {
  setTheme(me), setOptions({ ...Ke, recorderProvider: getRecorderProvider(Ge) });
  const Ze = async () => {
    i18nInstance.isInitialized ? await i18nSetup(i18nInstance, Qe, Ue) : await new Promise((tt) => {
      i18nInstance.on("initialized", async () => {
        await i18nSetup(i18nInstance, Qe, Ue), tt();
      });
    });
  };
  ue && (He = sha1(ue));
  const nt = createApi({ apiKey: He, apiURL: Ge, customHeaders: $e });
  return setApi(nt), setTokboxApiKey(Xe), setFingerprintApiKey(Je), detectionSetup.setupDetect(), Ke.unsafeMode || setupFiles(), Ze();
};
async function attachSignatureOnAnnotation({
  contractId: me,
  signatureType: ue,
  token: Qe,
  signedContractId: Ue,
  orientation: He = "ORIENTATION_NORMAL",
  signatureText: Ge = ""
}) {
  return api.post(
    "/omni/attach-signature-on-annotation",
    {
      contractId: me,
      signatureType: ue,
      signedContractId: Ue,
      orientation: He,
      replacementText: Ge
    },
    {
      headers: {
        "X-Incode-Hardware-Id": Qe
      }
    }
  ).then((Xe) => Xe.data).catch((Xe) => {
    var Ke;
    return Promise.reject((Ke = Xe == null ? void 0 : Xe.response) == null ? void 0 : Ke.data);
  });
}
async function getSignedContractsLinks({ token: me }) {
  return api.get("/omni/get/signed-contracts-links", {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }).then((ue) => ue.data).catch((ue) => {
    var Qe;
    return Promise.reject((Qe = ue == null ? void 0 : ue.response) == null ? void 0 : Qe.data);
  });
}
/*!
 * Signature Pad v4.1.7 | https://github.com/szimek/signature_pad
 * (c) 2023 Szymon Nowak | Released under the MIT license
 */
class Point {
  constructor(ue, Qe, Ue, He) {
    if (isNaN(ue) || isNaN(Qe))
      throw new Error(`Point is invalid: (${ue}, ${Qe})`);
    this.x = +ue, this.y = +Qe, this.pressure = Ue || 0, this.time = He || Date.now();
  }
  distanceTo(ue) {
    return Math.sqrt(Math.pow(this.x - ue.x, 2) + Math.pow(this.y - ue.y, 2));
  }
  equals(ue) {
    return this.x === ue.x && this.y === ue.y && this.pressure === ue.pressure && this.time === ue.time;
  }
  velocityFrom(ue) {
    return this.time !== ue.time ? this.distanceTo(ue) / (this.time - ue.time) : 0;
  }
}
class Bezier {
  static fromPoints(ue, Qe) {
    const Ue = this.calculateControlPoints(ue[0], ue[1], ue[2]).c2, He = this.calculateControlPoints(ue[1], ue[2], ue[3]).c1;
    return new Bezier(ue[1], Ue, He, ue[2], Qe.start, Qe.end);
  }
  static calculateControlPoints(ue, Qe, Ue) {
    const He = ue.x - Qe.x, Ge = ue.y - Qe.y, Xe = Qe.x - Ue.x, Ke = Qe.y - Ue.y, $e = { x: (ue.x + Qe.x) / 2, y: (ue.y + Qe.y) / 2 }, Je = { x: (Qe.x + Ue.x) / 2, y: (Qe.y + Ue.y) / 2 }, Ze = Math.sqrt(He * He + Ge * Ge), nt = Math.sqrt(Xe * Xe + Ke * Ke), tt = $e.x - Je.x, et = $e.y - Je.y, rt = nt / (Ze + nt), it = { x: Je.x + tt * rt, y: Je.y + et * rt }, ot = Qe.x - it.x, at = Qe.y - it.y;
    return {
      c1: new Point($e.x + ot, $e.y + at),
      c2: new Point(Je.x + ot, Je.y + at)
    };
  }
  constructor(ue, Qe, Ue, He, Ge, Xe) {
    this.startPoint = ue, this.control2 = Qe, this.control1 = Ue, this.endPoint = He, this.startWidth = Ge, this.endWidth = Xe;
  }
  length() {
    let Qe = 0, Ue, He;
    for (let Ge = 0; Ge <= 10; Ge += 1) {
      const Xe = Ge / 10, Ke = this.point(Xe, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x), $e = this.point(Xe, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
      if (Ge > 0) {
        const Je = Ke - Ue, Ze = $e - He;
        Qe += Math.sqrt(Je * Je + Ze * Ze);
      }
      Ue = Ke, He = $e;
    }
    return Qe;
  }
  point(ue, Qe, Ue, He, Ge) {
    return Qe * (1 - ue) * (1 - ue) * (1 - ue) + 3 * Ue * (1 - ue) * (1 - ue) * ue + 3 * He * (1 - ue) * ue * ue + Ge * ue * ue * ue;
  }
}
class SignatureEventTarget {
  constructor() {
    try {
      this._et = new EventTarget();
    } catch {
      this._et = document;
    }
  }
  addEventListener(ue, Qe, Ue) {
    this._et.addEventListener(ue, Qe, Ue);
  }
  dispatchEvent(ue) {
    return this._et.dispatchEvent(ue);
  }
  removeEventListener(ue, Qe, Ue) {
    this._et.removeEventListener(ue, Qe, Ue);
  }
}
function throttle(me, ue = 250) {
  let Qe = 0, Ue = null, He, Ge, Xe;
  const Ke = () => {
    Qe = Date.now(), Ue = null, He = me.apply(Ge, Xe), Ue || (Ge = null, Xe = []);
  };
  return function(...Je) {
    const Ze = Date.now(), nt = ue - (Ze - Qe);
    return Ge = this, Xe = Je, nt <= 0 || nt > ue ? (Ue && (clearTimeout(Ue), Ue = null), Qe = Ze, He = me.apply(Ge, Xe), Ue || (Ge = null, Xe = [])) : Ue || (Ue = window.setTimeout(Ke, nt)), He;
  };
}
class SignaturePad extends SignatureEventTarget {
  constructor(ue, Qe = {}) {
    super(), this.canvas = ue, this._drawingStroke = !1, this._isEmpty = !0, this._lastPoints = [], this._data = [], this._lastVelocity = 0, this._lastWidth = 0, this._handleMouseDown = (Ue) => {
      Ue.buttons === 1 && this._strokeBegin(Ue);
    }, this._handleMouseMove = (Ue) => {
      this._strokeMoveUpdate(Ue);
    }, this._handleMouseUp = (Ue) => {
      Ue.buttons === 1 && this._strokeEnd(Ue);
    }, this._handleTouchStart = (Ue) => {
      if (Ue.cancelable && Ue.preventDefault(), Ue.targetTouches.length === 1) {
        const He = Ue.changedTouches[0];
        this._strokeBegin(He);
      }
    }, this._handleTouchMove = (Ue) => {
      Ue.cancelable && Ue.preventDefault();
      const He = Ue.targetTouches[0];
      this._strokeMoveUpdate(He);
    }, this._handleTouchEnd = (Ue) => {
      if (Ue.target === this.canvas) {
        Ue.cancelable && Ue.preventDefault();
        const Ge = Ue.changedTouches[0];
        this._strokeEnd(Ge);
      }
    }, this._handlePointerStart = (Ue) => {
      Ue.preventDefault(), this._strokeBegin(Ue);
    }, this._handlePointerMove = (Ue) => {
      this._strokeMoveUpdate(Ue);
    }, this._handlePointerEnd = (Ue) => {
      this._drawingStroke && (Ue.preventDefault(), this._strokeEnd(Ue));
    }, this.velocityFilterWeight = Qe.velocityFilterWeight || 0.7, this.minWidth = Qe.minWidth || 0.5, this.maxWidth = Qe.maxWidth || 2.5, this.throttle = "throttle" in Qe ? Qe.throttle : 16, this.minDistance = "minDistance" in Qe ? Qe.minDistance : 5, this.dotSize = Qe.dotSize || 0, this.penColor = Qe.penColor || "black", this.backgroundColor = Qe.backgroundColor || "rgba(0,0,0,0)", this.compositeOperation = Qe.compositeOperation || "source-over", this._strokeMoveUpdate = this.throttle ? throttle(SignaturePad.prototype._strokeUpdate, this.throttle) : SignaturePad.prototype._strokeUpdate, this._ctx = ue.getContext("2d"), this.clear(), this.on();
  }
  clear() {
    const { _ctx: ue, canvas: Qe } = this;
    ue.fillStyle = this.backgroundColor, ue.clearRect(0, 0, Qe.width, Qe.height), ue.fillRect(0, 0, Qe.width, Qe.height), this._data = [], this._reset(this._getPointGroupOptions()), this._isEmpty = !0;
  }
  fromDataURL(ue, Qe = {}) {
    return new Promise((Ue, He) => {
      const Ge = new Image(), Xe = Qe.ratio || window.devicePixelRatio || 1, Ke = Qe.width || this.canvas.width / Xe, $e = Qe.height || this.canvas.height / Xe, Je = Qe.xOffset || 0, Ze = Qe.yOffset || 0;
      this._reset(this._getPointGroupOptions()), Ge.onload = () => {
        this._ctx.drawImage(Ge, Je, Ze, Ke, $e), Ue();
      }, Ge.onerror = (nt) => {
        He(nt);
      }, Ge.crossOrigin = "anonymous", Ge.src = ue, this._isEmpty = !1;
    });
  }
  toDataURL(ue = "image/png", Qe) {
    switch (ue) {
      case "image/svg+xml":
        return typeof Qe != "object" && (Qe = void 0), `data:image/svg+xml;base64,${btoa(this.toSVG(Qe))}`;
      default:
        return typeof Qe != "number" && (Qe = void 0), this.canvas.toDataURL(ue, Qe);
    }
  }
  on() {
    this.canvas.style.touchAction = "none", this.canvas.style.msTouchAction = "none", this.canvas.style.userSelect = "none";
    const ue = /Macintosh/.test(navigator.userAgent) && "ontouchstart" in document;
    window.PointerEvent && !ue ? this._handlePointerEvents() : (this._handleMouseEvents(), "ontouchstart" in window && this._handleTouchEvents());
  }
  off() {
    this.canvas.style.touchAction = "auto", this.canvas.style.msTouchAction = "auto", this.canvas.style.userSelect = "auto", this.canvas.removeEventListener("pointerdown", this._handlePointerStart), this.canvas.removeEventListener("pointermove", this._handlePointerMove), this.canvas.ownerDocument.removeEventListener("pointerup", this._handlePointerEnd), this.canvas.removeEventListener("mousedown", this._handleMouseDown), this.canvas.removeEventListener("mousemove", this._handleMouseMove), this.canvas.ownerDocument.removeEventListener("mouseup", this._handleMouseUp), this.canvas.removeEventListener("touchstart", this._handleTouchStart), this.canvas.removeEventListener("touchmove", this._handleTouchMove), this.canvas.removeEventListener("touchend", this._handleTouchEnd);
  }
  isEmpty() {
    return this._isEmpty;
  }
  fromData(ue, { clear: Qe = !0 } = {}) {
    Qe && this.clear(), this._fromData(ue, this._drawCurve.bind(this), this._drawDot.bind(this)), this._data = this._data.concat(ue);
  }
  toData() {
    return this._data;
  }
  _getPointGroupOptions(ue) {
    return {
      penColor: ue && "penColor" in ue ? ue.penColor : this.penColor,
      dotSize: ue && "dotSize" in ue ? ue.dotSize : this.dotSize,
      minWidth: ue && "minWidth" in ue ? ue.minWidth : this.minWidth,
      maxWidth: ue && "maxWidth" in ue ? ue.maxWidth : this.maxWidth,
      velocityFilterWeight: ue && "velocityFilterWeight" in ue ? ue.velocityFilterWeight : this.velocityFilterWeight,
      compositeOperation: ue && "compositeOperation" in ue ? ue.compositeOperation : this.compositeOperation
    };
  }
  _strokeBegin(ue) {
    if (!this.dispatchEvent(new CustomEvent("beginStroke", { detail: ue, cancelable: !0 })))
      return;
    this._drawingStroke = !0;
    const Ue = this._getPointGroupOptions(), He = Object.assign(Object.assign({}, Ue), { points: [] });
    this._data.push(He), this._reset(Ue), this._strokeUpdate(ue);
  }
  _strokeUpdate(ue) {
    if (!this._drawingStroke)
      return;
    if (this._data.length === 0) {
      this._strokeBegin(ue);
      return;
    }
    this.dispatchEvent(new CustomEvent("beforeUpdateStroke", { detail: ue }));
    const Qe = ue.clientX, Ue = ue.clientY, He = ue.pressure !== void 0 ? ue.pressure : ue.force !== void 0 ? ue.force : 0, Ge = this._createPoint(Qe, Ue, He), Xe = this._data[this._data.length - 1], Ke = Xe.points, $e = Ke.length > 0 && Ke[Ke.length - 1], Je = $e ? Ge.distanceTo($e) <= this.minDistance : !1, Ze = this._getPointGroupOptions(Xe);
    if (!$e || !($e && Je)) {
      const nt = this._addPoint(Ge, Ze);
      $e ? nt && this._drawCurve(nt, Ze) : this._drawDot(Ge, Ze), Ke.push({
        time: Ge.time,
        x: Ge.x,
        y: Ge.y,
        pressure: Ge.pressure
      });
    }
    this.dispatchEvent(new CustomEvent("afterUpdateStroke", { detail: ue }));
  }
  _strokeEnd(ue) {
    this._drawingStroke && (this._strokeUpdate(ue), this._drawingStroke = !1, this.dispatchEvent(new CustomEvent("endStroke", { detail: ue })));
  }
  _handlePointerEvents() {
    this._drawingStroke = !1, this.canvas.addEventListener("pointerdown", this._handlePointerStart), this.canvas.addEventListener("pointermove", this._handlePointerMove), this.canvas.ownerDocument.addEventListener("pointerup", this._handlePointerEnd);
  }
  _handleMouseEvents() {
    this._drawingStroke = !1, this.canvas.addEventListener("mousedown", this._handleMouseDown), this.canvas.addEventListener("mousemove", this._handleMouseMove), this.canvas.ownerDocument.addEventListener("mouseup", this._handleMouseUp);
  }
  _handleTouchEvents() {
    this.canvas.addEventListener("touchstart", this._handleTouchStart), this.canvas.addEventListener("touchmove", this._handleTouchMove), this.canvas.addEventListener("touchend", this._handleTouchEnd);
  }
  _reset(ue) {
    this._lastPoints = [], this._lastVelocity = 0, this._lastWidth = (ue.minWidth + ue.maxWidth) / 2, this._ctx.fillStyle = ue.penColor, this._ctx.globalCompositeOperation = ue.compositeOperation;
  }
  _createPoint(ue, Qe, Ue) {
    const He = this.canvas.getBoundingClientRect();
    return new Point(ue - He.left, Qe - He.top, Ue, (/* @__PURE__ */ new Date()).getTime());
  }
  _addPoint(ue, Qe) {
    const { _lastPoints: Ue } = this;
    if (Ue.push(ue), Ue.length > 2) {
      Ue.length === 3 && Ue.unshift(Ue[0]);
      const He = this._calculateCurveWidths(Ue[1], Ue[2], Qe), Ge = Bezier.fromPoints(Ue, He);
      return Ue.shift(), Ge;
    }
    return null;
  }
  _calculateCurveWidths(ue, Qe, Ue) {
    const He = Ue.velocityFilterWeight * Qe.velocityFrom(ue) + (1 - Ue.velocityFilterWeight) * this._lastVelocity, Ge = this._strokeWidth(He, Ue), Xe = {
      end: Ge,
      start: this._lastWidth
    };
    return this._lastVelocity = He, this._lastWidth = Ge, Xe;
  }
  _strokeWidth(ue, Qe) {
    return Math.max(Qe.maxWidth / (ue + 1), Qe.minWidth);
  }
  _drawCurveSegment(ue, Qe, Ue) {
    const He = this._ctx;
    He.moveTo(ue, Qe), He.arc(ue, Qe, Ue, 0, 2 * Math.PI, !1), this._isEmpty = !1;
  }
  _drawCurve(ue, Qe) {
    const Ue = this._ctx, He = ue.endWidth - ue.startWidth, Ge = Math.ceil(ue.length()) * 2;
    Ue.beginPath(), Ue.fillStyle = Qe.penColor;
    for (let Xe = 0; Xe < Ge; Xe += 1) {
      const Ke = Xe / Ge, $e = Ke * Ke, Je = $e * Ke, Ze = 1 - Ke, nt = Ze * Ze, tt = nt * Ze;
      let et = tt * ue.startPoint.x;
      et += 3 * nt * Ke * ue.control1.x, et += 3 * Ze * $e * ue.control2.x, et += Je * ue.endPoint.x;
      let rt = tt * ue.startPoint.y;
      rt += 3 * nt * Ke * ue.control1.y, rt += 3 * Ze * $e * ue.control2.y, rt += Je * ue.endPoint.y;
      const it = Math.min(ue.startWidth + Je * He, Qe.maxWidth);
      this._drawCurveSegment(et, rt, it);
    }
    Ue.closePath(), Ue.fill();
  }
  _drawDot(ue, Qe) {
    const Ue = this._ctx, He = Qe.dotSize > 0 ? Qe.dotSize : (Qe.minWidth + Qe.maxWidth) / 2;
    Ue.beginPath(), this._drawCurveSegment(ue.x, ue.y, He), Ue.closePath(), Ue.fillStyle = Qe.penColor, Ue.fill();
  }
  _fromData(ue, Qe, Ue) {
    for (const He of ue) {
      const { points: Ge } = He, Xe = this._getPointGroupOptions(He);
      if (Ge.length > 1)
        for (let Ke = 0; Ke < Ge.length; Ke += 1) {
          const $e = Ge[Ke], Je = new Point($e.x, $e.y, $e.pressure, $e.time);
          Ke === 0 && this._reset(Xe);
          const Ze = this._addPoint(Je, Xe);
          Ze && Qe(Ze, Xe);
        }
      else
        this._reset(Xe), Ue(Ge[0], Xe);
    }
  }
  toSVG({ includeBackgroundColor: ue = !1 } = {}) {
    const Qe = this._data, Ue = Math.max(window.devicePixelRatio || 1, 1), He = 0, Ge = 0, Xe = this.canvas.width / Ue, Ke = this.canvas.height / Ue, $e = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    if ($e.setAttribute("xmlns", "http://www.w3.org/2000/svg"), $e.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), $e.setAttribute("viewBox", `${He} ${Ge} ${Xe} ${Ke}`), $e.setAttribute("width", Xe.toString()), $e.setAttribute("height", Ke.toString()), ue && this.backgroundColor) {
      const Je = document.createElement("rect");
      Je.setAttribute("width", "100%"), Je.setAttribute("height", "100%"), Je.setAttribute("fill", this.backgroundColor), $e.appendChild(Je);
    }
    return this._fromData(Qe, (Je, { penColor: Ze }) => {
      const nt = document.createElement("path");
      if (!isNaN(Je.control1.x) && !isNaN(Je.control1.y) && !isNaN(Je.control2.x) && !isNaN(Je.control2.y)) {
        const tt = `M ${Je.startPoint.x.toFixed(3)},${Je.startPoint.y.toFixed(3)} C ${Je.control1.x.toFixed(3)},${Je.control1.y.toFixed(3)} ${Je.control2.x.toFixed(3)},${Je.control2.y.toFixed(3)} ${Je.endPoint.x.toFixed(3)},${Je.endPoint.y.toFixed(3)}`;
        nt.setAttribute("d", tt), nt.setAttribute("stroke-width", (Je.endWidth * 2.25).toFixed(3)), nt.setAttribute("stroke", Ze), nt.setAttribute("fill", "none"), nt.setAttribute("stroke-linecap", "round"), $e.appendChild(nt);
      }
    }, (Je, { penColor: Ze, dotSize: nt, minWidth: tt, maxWidth: et }) => {
      const rt = document.createElement("circle"), it = nt > 0 ? nt : (tt + et) / 2;
      rt.setAttribute("r", it.toString()), rt.setAttribute("cx", Je.x.toString()), rt.setAttribute("cy", Je.y.toString()), rt.setAttribute("fill", Ze), $e.appendChild(rt);
    }), $e.outerHTML;
  }
}
function debounce(me, ue, Qe) {
  let Ue;
  return (...He) => {
    const Ge = () => {
      Ue = null, me(...He);
    };
    clearTimeout(Ue), Ue = setTimeout(Ge, ue);
  };
}
function useSignaturePad(me, ue, Qe) {
  const Ue = useRef(), He = useRef(), Ge = useRef();
  useEffect(() => {
    He.current = me;
  }, [me]), useEffect(() => {
    Ge.current = ue;
  });
  const Xe = useCallback(() => {
    var nt;
    const Je = He.current(), Ze = Math.max(window.devicePixelRatio || 1, 1);
    Je.width = Je.offsetWidth * Ze, Je.height = Je.offsetHeight * Ze, Je.getContext("2d").scale(Ze, Ze), (nt = Ue.current) == null || nt.clear();
  }, []);
  useEventListener(
    "resize",
    debounce(() => {
      Xe();
    }, 700),
    window
  ), useEffect(() => {
    const Je = He.current();
    if (Je)
      return Ue.current = new SignaturePad(
        Je,
        Ge.current
      ), Object.keys(Ge.current.events).forEach(
        (Ze) => Ue.current.addEventListener(
          Ze,
          Ge.current.events[Ze]
        )
      ), setTimeout(() => {
        Xe();
      }, 700), () => {
        Object.keys(Ge.current.events).forEach(
          (Ze) => Ue.current.removeEventListener(
            Ze,
            Ge.current.events[Ze]
          )
        );
      };
  }, [Xe]);
  const Ke = (Je = me()) => {
    Ue.current.backgroundColor = "#ffffff";
    const Ze = Je.toDataURL(), nt = atob(Ze.split(",")[1]), tt = [];
    for (let et = 0; et < nt.length; et++)
      tt.push(nt.charCodeAt(et));
    return new Blob([new Uint8Array(tt)]);
  }, $e = () => {
    const Je = Ue.current, Ze = document.createElement("canvas"), nt = Ze.getContext("2d"), tt = me();
    Ze.width = tt.width, Ze.height = tt.height;
    const et = new SignaturePad(Ze);
    et.backgroundColor = "white";
    const rt = Je.toData();
    return rt.forEach((it) => {
      it.penColor = "black";
    }), nt.fillStyle = "#ffffff", nt.fillRect(0, 0, Ze.width, Ze.height), et.fromData(rt), Ze.toDataURL(), Ze;
  };
  useImperativeHandle(Qe, () => ({
    toDataURL() {
      return me().toDataURL();
    },
    getSignaturePad: () => Ue.current,
    getCanvas: me,
    clear: () => Ue.current.clear(),
    isEmpty: () => Ue.current.isEmpty(),
    off: () => Ue.current.off(),
    getBlob: Ke,
    getSignatureWithWhiteBackground: $e
  }));
}
function SignatureCanvas({ canvasProps: me, className: ue, ...Qe }, Ue) {
  const He = useRef();
  return useSignaturePad(() => He.current, Qe, Ue), /* @__PURE__ */ jsxRuntimeExports.jsx("canvas", { ...me, className: ue, ref: He });
}
const SignatureCanvas$1 = forwardRef(SignatureCanvas), ButtonsContainer = qe.div`
  display: flex;
  flex-direction: column;
`, CanvasContainer = qe.div`
  position: relative;
  width: 100%;
  flex: 1;
`, ClearButton = qe.button`
  padding: 20px;
  background-color: transparent;
  border: none;
`, Canvas = qe(SignatureCanvas$1)`
  width: 100%;
  border: 1.5px solid ${(me) => me.canvasBorderColor};
  border-radius: 18px;
  height: 100%;
`, SignatureContainer = qe.div`
  height: 100%;
  padding: 6% 6% 15% 6%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  background-color: rgb(255, 255, 255);
  padding: 90px 0;
  max-width: 90%;
  margin: auto;

  &.desktop {
    position: unset;
    padding: 130px 0px;
    background: transparent;
  }
`, Title$1 = qe.h1`
  text-align: center;
  margin-bottom: 0;
`, Subtitle$1 = qe.h2`
  text-align: center;
  margin-bottom: 15px;
`, TextInstructionsLabel = qe.label`
  font-size: 26px;
  opacity: 0.5;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  pointer-events: none;
`, InputContainer = qe.div`
  margin-top: 30px;
  min-width: 350px;
  display: flex;
  flex-direction: column;
`, InputLabel = qe.label`
  font-weight: 700;
  font-size: 16px;
  color: #636670;
  margin-bottom: 4px;
`, Input = qe.input`
  width: 100%;
  max-width: 332px;
  height: 60px;
  padding: 10px 15px;
  background: transparent;
  border: 2px solid #20263d;
  border-radius: 8px;
  font-weight: 500;
  font-size: 20px;
  color: #21273b;
`;
function Signature({
  onSuccess: me,
  onBoarding: ue,
  token: Qe,
  type: Ue,
  title: He,
  subtitle: Ge,
  initials: Xe,
  sendBase64: Ke,
  canvasBackgroundColor: $e = "#fff",
  canvasBorderColor: Je = "#20263d",
  penColor: Ze = "#20263D",
  onInputChange: nt,
  showSignatureInput: tt
}) {
  const { t: et } = useTranslation(), rt = useRef(null), [it, ot] = useState(!1), [at, st] = useState(!1), { isRotated: ut } = useOrientation();
  useModuleEvents({
    module: eventModuleNames.signature,
    token: Qe
  }), useScreenEvents({
    module: eventModuleNames.signature,
    screen: eventScreenNames.signatureInput,
    token: Qe
  }), useEffect(() => {
    ut && (rt.current.clear(), st(!1));
  });
  function lt() {
    if (rt.current.isEmpty())
      return;
    rt.current.off(), ue.addEvent({
      token: Qe,
      code: "continue"
    }), ot(!0);
    const At = Xe ? ue.addInitials : ue.addSignature, pt = rt.current.getSignatureWithWhiteBackground(), gt = Ke ? pt.toDataURL().replace("data:image/png;base64,", "") : rt.current.getBlob(pt);
    At({
      token: Qe,
      image: gt,
      type: Ue,
      sendBase64: Ke
    }).then(me).catch(() => ot(!1));
  }
  function dt() {
    rt.current.clear(), st(!1);
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    SignatureContainer,
    {
      className: classNames("IncodeSignatureContainer", {
        desktop: ue.isDesktop()
      }),
      children: [
        He && /* @__PURE__ */ jsxRuntimeExports.jsx(Title$1, { className: "IncodeSignatureTitle", children: He }),
        Ge && /* @__PURE__ */ jsxRuntimeExports.jsx(Subtitle$1, { className: "IncodeSignatureSubtitle", children: Ge }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(CanvasContainer, { className: "IncodeSignatureCanvas", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Canvas,
            {
              ref: rt,
              canvasBorderColor: Je,
              events: {
                beginStroke: () => st(!0)
              },
              backgroundColor: $e,
              canvasProps: {
                style: {
                  backgroundColor: $e
                }
              },
              className: "IncodeSignatureCanvas",
              penColor: Ze
            }
          ),
          !at && /* @__PURE__ */ jsxRuntimeExports.jsx(TextInstructionsLabel, { children: et(Xe ? "signature.placeholderInitials" : "signature.placeholder") })
        ] }),
        tt ? /* @__PURE__ */ jsxRuntimeExports.jsxs(InputContainer, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(InputLabel, { children: et("signature.inputLabel") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Input,
            {
              autoComplete: "off",
              onChange: (At) => nt(At.target.value)
            }
          )
        ] }) : null,
        /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonsContainer, { className: "IncodeSignatureButtonsContainer", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            ClearButton,
            {
              className: "IncodeSignatureClearButton",
              onClick: dt,
              disabled: !at,
              children: et("signature.clear")
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button$a,
            {
              onClick: lt,
              disabled: it || !at,
              theme,
              className: "IncodeSignatureDoneButton",
              children: et("signature.done")
            }
          )
        ] })
      ]
    }
  );
}
function renderSignature(me, {
  onSuccess: ue,
  token: Qe,
  type: Ue,
  title: He,
  subtitle: Ge,
  initials: Xe = !1,
  sendBase64: Ke = !0,
  showSignatureInput: $e = !1,
  canvasBackgroundColor: Je,
  canvasBorderColor: Ze,
  penColor: nt,
  onInputChange: tt
}) {
  const et = createRoot$1(me), rt = {
    onSuccess: handleUnmountRoot(ue, et, me),
    onInputChange: tt,
    onBoarding: this,
    token: Qe,
    type: Ue,
    title: He,
    subtitle: Ge,
    initials: Xe,
    sendBase64: Ke,
    canvasBackgroundColor: Je,
    canvasBorderColor: Ze,
    penColor: nt,
    showSignatureInput: $e
  };
  customRender(
    /* @__PURE__ */ jsxRuntimeExports.jsx(App$1, { token: Qe, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Signature, { ...rt }) }),
    me,
    et
  );
}
const getSubmitAnswerURL = () => "/omni/form-answer/submit";
function submitAnswer({
  token: me,
  answer: ue
}) {
  return api.post(getSubmitAnswerURL(), ue, {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }).then((Qe) => Qe.data);
}
function update$1({ token: me, updatedData: ue }) {
  return api.put("/omni/update", ue, {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }).catch((Qe) => Promise.reject(Qe.response.data));
}
function update({ token: me, updatedData: ue }) {
  return api.put("/omni/update-second-id", ue, {
    headers: {
      "X-Incode-Hardware-Id": me
    }
  }).catch((Qe) => console.log(Qe));
}
const verifyOTPUrl = "/omni/code/verify";
function verifyOTP({ code: me, token: ue }) {
  return api.post(
    verifyOTPUrl,
    {
      interviewCode: me
    },
    {
      headers: {
        "X-Incode-Hardware-Id": ue
      }
    }
  ).then((Qe) => Qe.data).catch((Qe) => Promise.reject(Qe.response.data));
}
function addWatchListResults({
  token: me,
  firstName: ue = null,
  surName: Qe = null,
  birthYear: Ue = null,
  countryCodes: He = []
}) {
  return api.post(
    "/omni/watchlist-result",
    {
      firstName: ue,
      surName: Qe,
      birthYear: Ue,
      countryCodes: He,
      subscribe: !0
    },
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).then((Ge) => Ge.data).catch((Ge) => Promise.reject(Ge.response.data));
}
function initWatchList({ token: me }) {
  return api.post(
    "/omni/init-watchlist",
    {},
    {
      headers: {
        "X-Incode-Hardware-Id": me
      }
    }
  ).then((ue) => ue.data).catch((ue) => Promise.reject(ue.response.data));
}
function create({
  apiKey: me,
  apiURL: ue,
  lang: Qe,
  encrypt: Ue = !1,
  translations: He = {},
  theme: Ge = {},
  clientId: Xe,
  tokboxApiKey: Ke = "46135862",
  darkMode: $e = !1,
  hostingApp: Je,
  unsafeMode: Ze = !1,
  customHeaders: nt,
  fingerprintApiKey: tt = "5uYRiI0XM6p8k4124ELX",
  redirectFromUnsupportedBrowsers: et = !1
}) {
  const rt = setup({
    theme: Ge,
    clientId: Xe,
    lang: Qe,
    translations: He,
    apiKey: me,
    apiURL: ue,
    tokboxApiKey: Ke,
    options: {
      darkMode: $e,
      hostingApp: Je,
      unsafeMode: Ze,
      redirectFromUnsupportedBrowsers: et
    },
    customHeaders: nt,
    fingerprintApiKey: tt
  });
  async function it() {
    await rt;
  }
  return {
    createSession: createSession$3,
    createNewSession,
    updateSession,
    publishKeys,
    capture,
    frontType,
    backType,
    selfieType,
    ocrData,
    getScore,
    addToQueue: addToQueue$1,
    getQueueIndex,
    addDocument,
    state,
    processId,
    processFace,
    getInterviewerName,
    getOpenTokTest,
    addAddressStatement,
    processAddressStatement,
    processWatchlist,
    processGovernmentValidation,
    addPhone,
    addPhoneInstantVerify,
    postFingerPrint: postFingerprint,
    getImages: getImages$1,
    getConnectionDetails,
    fetchModules,
    fetchModels,
    update: update$1,
    renderCamera,
    renderConference,
    renderManualIdUpload: manualIdUpload,
    renderFrontTutorial,
    renderBackTutorial,
    renderSelfieTutorial,
    renderPassportTutorial,
    renderDocumentTutorial: renderTutorialDocument,
    encrypt: Ue,
    sendFingerprint,
    getFingerPrint,
    verifyOTP,
    generateOTP,
    connectToQueue,
    addConferenceEvent,
    removeFromQueue,
    approve,
    addGeolocation,
    warmup: detectionSetup.warmup,
    renderSignature,
    renderAdvancedElectronicSignature,
    addSignature,
    getMedicalOcrData,
    renderVideoSelfie,
    renderOTP,
    addEvent,
    getRandomQuestions,
    sendGeolocation,
    fetchProcessingStatus,
    theme,
    tokboxApiKey: Ke,
    mock,
    setSessionStatus,
    renderCapture,
    addSpeech,
    fetchAssets,
    setTheme,
    sendOTPSMS,
    compareOTP,
    getFinishStatus,
    renderLogin,
    renderLoginIncodeID,
    renderLoginDesktop,
    identify,
    identifyInstantVerify,
    OneToOneIdentify: oneToOneIdentify,
    addCurp,
    addCurpv2,
    renderEnterCurp,
    addInitials,
    attachSignatureOnAnnotation,
    getSignedContractsLinks,
    renderRedirectToMobile,
    renderQr,
    getOnboardingStatus,
    addWatchListResults,
    initWatchList,
    addName,
    addEmail,
    addCustomFields,
    addBarcode,
    renderRetrySteps,
    isDesktop: mobile.isDesktop,
    addFrontSecondId,
    processSecondId,
    ocrDataSecondId,
    processFaceSecondId,
    getCustomFields,
    getImagesV2: getImages,
    renderFaceMatch,
    sendRedirectSMS,
    sendMfa,
    getInterviewData,
    lastNameMatch,
    lastNameMatchByCustomer,
    sendEmail,
    addCreditCardFront,
    addCreditCardBack,
    processCreditCard,
    i18n: i18nInstance,
    compareOCR,
    compareID,
    compareBackID,
    compareBackOCR,
    getStartInfo,
    addMLConsent,
    renderMlConsent,
    sendEkyb,
    addQrCodeText,
    renderQrScanner,
    addContract,
    processCrossDocumentData,
    processAntiFraud,
    darkMode: $e,
    getSecondIdImages,
    getSecondIdImagesV2,
    enableDeviceRiskModule,
    addBankInfo,
    getBelvoWidgetToken,
    getWatchlist,
    useModuleEvents,
    useScreenEvents,
    eventModuleNames,
    eventScreenNames,
    addScreenEvent,
    updateSecondId: update,
    createRedirectUrl,
    compareGovValidationOTP,
    compareInstantVerifyOTP,
    getAdvancedElectronicSignatureUnsignedDocs,
    processAdvancedElectronicSignatureDocs,
    renderUniversalIdentity,
    renderInstantVerify,
    getInstantVerifyMissingModules,
    renderWatchList,
    renderEmail,
    renderPhone,
    instantVerifyShareIdentity,
    renderForms,
    submitAnswer,
    getForms,
    generateAESDocumentUploadUrl,
    getModuleConfig,
    instantVerifyUpdate,
    renderDocumentSelector,
    renderBiometricConsent: renderBiometricConsent$1,
    processImss,
    renderUserConsent,
    processGlobalWatchlist,
    getRedirectUrl,
    renderCombinedConsent: renderBiometricConsent,
    setUxType,
    getOtpStatus,
    getLocationSuggestions,
    initialize: it
  };
}
const useScore = (me, ue) => {
  const [Qe, Ue] = useState(null), [He, Ge] = useState(!1);
  return useEffect(() => {
    if (!ue || !me) return;
    (async () => {
      Ge(!0);
      const Ke = await getScore({ token: ue });
      Ue(Ke), Ge(!1);
    })();
  }, [ue, me]), { score: Qe, isLoading: He };
}, approvedStatuses = {
  OK: "OK",
  WARN: "WARN",
  FAIL: "FAIL",
  UNKNOWN: "UNKNOWN",
  MANUAL: "MANUAL",
  MANUAL_OK: "MANUAL_OK",
  MANUAL_FAIL: "MANUAL_FAIL",
  MANUAL_PENDING: "MANUAL_PENDING"
}, RedirectedCallFinishedContainer = qe.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  flex-direction: column;
`, Title = qe.h1`
  width: 500px;
  text-align: center;
  margin-bottom: 50px;
`, Subtitle = qe.h2`
  width: 400;
  text-align: center;
  margin-bottom: 50px;
`, ImageWrapper = qe.div`
  display: inline-block;
  width: 48px;
  height: 48px;
  margin-bottom: 16px;
`, scoreStatus = {
  [approvedStatuses.OK]: "Ok",
  [approvedStatuses.FAIL]: "Fail",
  [approvedStatuses.UNKNOWN]: "Unknown"
}, getScoreStatus = (me) => {
  switch (me) {
    case approvedStatuses.OK:
    case approvedStatuses.MANUAL_OK:
      return scoreStatus.OK;
    case approvedStatuses.FAIL:
    case approvedStatuses.MANUAL_FAIL:
      return scoreStatus.FAIL;
    default:
      return scoreStatus.UNKNOWN;
  }
};
function RedirectedCallFinished({
  title: me,
  subtitle: ue,
  displayOnboardingResultOnDesktop: Qe,
  token: Ue
}) {
  const { score: He, isLoading: Ge } = useScore(
    Qe,
    Ue
  ), { t: Xe } = useTranslation(), Ke = getScoreStatus(He == null ? void 0 : He.overall.status);
  return Ge && Qe ? /* @__PURE__ */ jsxRuntimeExports.jsx(RedirectedCallFinishedContainer, { className: "IncodeRedirectCallFinishedContainer", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$5, {}) }) : Qe ? /* @__PURE__ */ jsxRuntimeExports.jsxs(RedirectedCallFinishedContainer, { className: "IncodeRedirectCallFinishedContainer", children: [
    Ke !== scoreStatus.UNKNOWN && /* @__PURE__ */ jsxRuntimeExports.jsx(ImageWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "img",
      {
        src: Ke === scoreStatus.OK ? success : denied,
        alt: "verification"
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Subtitle, { className: "IncodeRedirectCallFinishedSubtitle", children: Xe(`verificationComplete.title${Ke}`) })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(RedirectedCallFinishedContainer, { className: "IncodeRedirectCallFinishedContainer", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { className: "IncodeRedirectCallFinishedTitle", children: me }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Subtitle, { className: "IncodeRedirectCallFinishedSubtitle", children: ue })
  ] });
}
const getVerifyVerificationUrl = () => "omni/externalVerification/ekyc";
function verifyInformation(me, ue) {
  return api.post(getVerifyVerificationUrl(), me, {
    headers: {
      "X-Incode-Hardware-Id": ue
    }
  }).then((Qe) => Qe.data).catch((Qe) => Promise.reject(Qe.response.data));
}
const setupDetect = () => detectionSetup.setupDetect();
export {
  BrowserNotSupported,
  CaptureSelfie$1 as CaptureSelfie,
  Login,
  Redirect,
  RedirectedCallFinished,
  TutorialSelfie,
  Webcam,
  addConsent,
  addCustomFields,
  addDocument,
  addEvent,
  addName,
  addQr,
  api,
  approve,
  conferenceStatus,
  create,
  createNewSession,
  createRedirectUrl,
  createSession$3 as createSession,
  enableDeviceRiskModule,
  getPrivacyConsentData as getConsents,
  getCustomFields,
  getFeatureConfig,
  getFinishStatus,
  getImages$1 as getImages,
  getImages as getImagesV2,
  getInterviewData,
  getLocationSuggestions,
  getOnboardingStatus,
  getOtpStatus,
  getRedirectUrl,
  getScore,
  getSecondIdImages,
  getSecondIdImagesV2,
  getWatchlist,
  i18nInstance as i18n,
  mock,
  ocrData,
  processAntiFraud,
  processCrossDocumentData,
  processGovernmentValidation,
  processId,
  processImss,
  recorderRepository,
  renderCamera,
  renderOTP,
  renderQr,
  renderRedirectToMobile,
  renderUserConsent,
  sendEkyb,
  sendEmail,
  setup,
  setupDetect,
  theme,
  update$1 as update,
  verifyInformation
};
